(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2888],{

/***/ 12601:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "bZj": function() { return /* binding */ Alert; },
  "OLm": function() { return /* binding */ AlertDialogAction; },
  "iPF": function() { return /* binding */ AlertDialogBody; },
  "_Tf": function() { return /* binding */ AlertDialogContent; },
  "yTm": function() { return /* binding */ AlertDialogDescription; },
  "xoY": function() { return /* binding */ AlertDialogFooter; },
  "fYl": function() { return /* binding */ AlertDialogHeader; },
  "mOp": function() { return /* binding */ AlertDialogHeading; },
  "Iyn": function() { return /* binding */ AlertDialogRoot; },
  "eee": function() { return /* binding */ Anchor; },
  "Cts": function() { return /* binding */ Badge; },
  "aGc": function() { return /* binding */ Breadcrumb; },
  "zxk": function() { return /* binding */ Button; },
  "NlM": function() { return /* binding */ ButtonCta; },
  "Eik": function() { return /* binding */ ButtonIcon; },
  "xnB": function() { return /* binding */ ButtonUnderline; },
  "UWt": function() { return /* binding */ Callout; },
  "ip": function() { return /* binding */ CalloutBody; },
  "nuQ": function() { return /* binding */ CalloutIcon; },
  "PLo": function() { return /* binding */ CalloutRoot; },
  "Zbd": function() { return /* binding */ Card; },
  "lLF": function() { return /* binding */ CollapsibleChevron; },
  "FwI": function() { return /* binding */ CollapsibleContent; },
  "Kq5": function() { return /* binding */ CollapsibleRoot; },
  "wy4": function() { return /* binding */ CollapsibleTrigger; },
  "W20": function() { return /* binding */ Container; },
  "a7O": function() { return /* binding */ DialogBody; },
  "cZJ": function() { return /* binding */ DialogContent; },
  "BeV": function() { return /* binding */ DialogDescription; },
  "cNS": function() { return /* binding */ DialogFooter; },
  "fKu": function() { return /* binding */ DialogHeader; },
  "EtB": function() { return /* binding */ DialogHeading; },
  "GRm": function() { return /* binding */ DialogRoot; },
  "hgM": function() { return /* binding */ DialogTrigger; },
  "izJ": function() { return /* binding */ Divider; },
  "jpF": function() { return /* binding */ DotAnimation; },
  "yaL": function() { return /* binding */ ErrorText; },
  "zEy": function() { return /* binding */ FilterSelect; },
  "rjZ": function() { return /* binding */ Grid; },
  "X6q": function() { return /* binding */ Heading; },
  "JO$": function() { return /* binding */ Icon; },
  "o2J": function() { return /* binding */ InputCheckbox; },
  "kec": function() { return /* binding */ InputCombobox; },
  "ksW": function() { return /* binding */ InputDateSelect; },
  "CMk": function() { return /* binding */ InputPassword; },
  "rWV": function() { return /* binding */ InputRadio; },
  "JDu": function() { return /* binding */ InputSelect; },
  "QlS": function() { return /* binding */ InputSwitch; },
  "oHY": function() { return /* binding */ InputText; },
  "zg5": function() { return /* binding */ InputTextArea; },
  "SP3": function() { return /* binding */ InputWrapper; },
  "rUS": function() { return /* binding */ Link; },
  "NIR": function() { return /* binding */ LinkCta; },
  "xPt": function() { return /* binding */ LinkIcon; },
  "p67": function() { return /* binding */ LinkInvBlock; },
  "u66": function() { return /* binding */ LinkText; },
  "_u$": function() { return /* binding */ LinkUnderline; },
  "LE2": function() { return /* binding */ LiveRegion; },
  "baG": function() { return /* binding */ PopoverBody; },
  "yky": function() { return /* binding */ PopoverContent; },
  "PgP": function() { return /* binding */ PopoverRoot; },
  "xol": function() { return /* binding */ PopoverTrigger; },
  "N6d": function() { return /* binding */ QuiltCell; },
  "oK3": function() { return /* binding */ QuiltRoot; },
  "oWz": function() { return /* binding */ QuiltViewport; },
  "qgy": function() { return /* binding */ RibbonGradientBackground; },
  "mAy": function() { return /* binding */ RibbonItem; },
  "wq0": function() { return /* binding */ RibbonRoot; },
  "oWH": function() { return /* binding */ RibbonScroller; },
  "jzu": function() { return /* binding */ SearchContent; },
  "UIq": function() { return /* binding */ SearchForm; },
  "qdA": function() { return /* binding */ SearchListbox; },
  "VcP": function() { return /* binding */ SearchOption; },
  "dW3": function() { return /* binding */ SearchRoot; },
  "OaK": function() { return /* binding */ SearchTrigger; },
  "Z0O": function() { return /* binding */ Separator; },
  "t7v": function() { return /* binding */ Sidenav; },
  "zdj": function() { return /* binding */ SidenavLink; },
  "LZC": function() { return /* binding */ Spacer; },
  "Kqy": function() { return /* binding */ Stack; },
  "xvT": function() { return /* binding */ Text; },
  "qWt": function() { return /* binding */ TileActionList; },
  "hnB": function() { return /* binding */ TileBody; },
  "Y2I": function() { return /* binding */ TileContent; },
  "NhG": function() { return /* binding */ TileDescription; },
  "V_6": function() { return /* binding */ TileFloat; },
  "HTg": function() { return /* binding */ TileFooter; },
  "ZRD": function() { return /* binding */ TileHeading; },
  "uIU": function() { return /* binding */ TileMedia; },
  "OH2": function() { return /* binding */ TileRoot; },
  "ljp": function() { return /* binding */ ToastDescription; },
  "IhZ": function() { return /* binding */ ToastIcon; },
  "VWW": function() { return /* binding */ ToastProvider; },
  "_lt": function() { return /* binding */ ToastRoot; },
  "Miw": function() { return /* binding */ ToastTitle; },
  "_ih": function() { return /* binding */ ToastViewport; },
  "_vU": function() { return /* binding */ TooltipContent; },
  "pnl": function() { return /* binding */ TooltipProvider; },
  "wYI": function() { return /* binding */ TooltipRoot; },
  "aJU": function() { return /* binding */ TooltipTrigger; },
  "c3M": function() { return /* binding */ useInputDivStyle; },
  "ad4": function() { return /* binding */ useInputIconSlots; }
});

// UNUSED EXPORTS: AccordionChevron, AccordionContent, AccordionContext, AccordionItem, AccordionItemContext, AccordionRoot, AccordionTrigger, AlertDialogCancel, AlertDialogContext, AlertDialogProvider, AlertDialogTrigger, AspectRatio, AutoFocus, AvatarGraphic, AvatarIcon, AvatarImage, AvatarLabel, AvatarRoot, Balancer, BalancerProvider, Bleed, ButtonInvBlock, ButtonText, CalloutText, CarouselChevronButton, CarouselDots, CarouselPageOf, CarouselPeekButton, CarouselProgress, CarouselRoot, CarouselSlide, CarouselThumb, CarouselThumbList, CarouselViewport, Chip, Collab, CollapsibleContext, DISPLAY_SIZE_CONFIG, DialogContentInner, DialogContext, DialogProvider, Display, Elevated, ErrorIcon, Fieldset, FilterSelectInner, FilterToggle, Float, GridCell, HeroActionList, HeroCollab, HeroContent, HeroDescription, HeroFootnote, HeroHeading, HeroMedia, HeroMediaContainer, HeroRoot, ICON_SIZES, Image, InputLabel, Inset, MediaContainer, PAGE_OF_SIZES, PLACEHOLDER_VALUE, PopoverClose, PopoverHeader, ProgressStepper, QuiltScrollNext, QuiltScrollPrev, SelectChevron, SelectContext, SelectHiddenInput, SelectProvider, SelectRoot, SelectValue, SidenavContext, SupportText, SupportTextContainer, TabsContent, TabsList, TabsRoot, TabsTrigger, TileCollab, TileFootnote, ToastAction, ToastClose, ToastPrimitives, ToggleButton, ToggleButtonChip, ToggleButtonIcon, ToggleButtonImage, ToggleButtonSwitch, ToggleButtonText, ToggleButtonThumb, ToggleChevron, ToggleGroupItem, ToggleGroupItemChip, ToggleGroupItemIcon, ToggleGroupItemImage, ToggleGroupItemSwitch, ToggleGroupItemText, ToggleGroupItemThumb, ToggleGroupRoot, VideoPlayer, accordionItemStyle, accordionRootStyle, badgeStyle, collapsibleRootStyle, contentStyle, fadeOut, footerStyle, iconSizeStyle, useAccordionContext, useAccordionItemContext, useAlertDialogContext, useCollapsibleContext, useDialogContext, useImageLoadingStatus, useMinMaxLength, useSelectContext, useTextStyle

// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
var react_namespaceObject = /*#__PURE__*/__webpack_require__.t(react, 2);
// EXTERNAL MODULE: ../node_modules/twind/css/css.js
var css_css = __webpack_require__(49224);
// EXTERNAL MODULE: ../node_modules/twind/style/style.js
var style = __webpack_require__(79200);
// EXTERNAL MODULE: ../node_modules/@global-ecom/nitro-uds/dist/hooks/esm/index.js
var esm = __webpack_require__(68138);
// EXTERNAL MODULE: ../node_modules/twind/twind.js + 1 modules
var twind = __webpack_require__(34209);
// EXTERNAL MODULE: ../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(25773);
;// CONCATENATED MODULE: ../node_modules/@radix-ui/react-slot/node_modules/@radix-ui/react-compose-refs/dist/index.module.js



/**
 * Set a given ref to a given value
 * This utility takes care of different types of refs: callback refs and RefObject(s)
 */ function $6ed0406888f73fc4$var$setRef(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref !== null && ref !== undefined) ref.current = value;
}
/**
 * A utility to compose multiple refs together
 * Accepts callback refs and RefObject(s)
 */ function $6ed0406888f73fc4$export$43e446d32b3d21af(...refs) {
    return (node)=>refs.forEach((ref)=>$6ed0406888f73fc4$var$setRef(ref, node)
        )
    ;
}
/**
 * A custom hook that composes multiple refs
 * Accepts callback refs and RefObject(s)
 */ function $6ed0406888f73fc4$export$c7b2cbe3552a0d05(...refs) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return $3vqmr$useCallback($6ed0406888f73fc4$export$43e446d32b3d21af(...refs), refs);
}





//# sourceMappingURL=index.module.js.map

;// CONCATENATED MODULE: ../node_modules/@radix-ui/react-slot/dist/index.module.js







/* -------------------------------------------------------------------------------------------------
 * Slot
 * -----------------------------------------------------------------------------------------------*/ const $5e63c961fc1ce211$export$8c6ed5c666ac1360 = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { children: children , ...slotProps } = props;
    const childrenArray = react.Children.toArray(children);
    const slottable = childrenArray.find($5e63c961fc1ce211$var$isSlottable);
    if (slottable) {
        // the new element to render is the one passed as a child of `Slottable`
        const newElement = slottable.props.children;
        const newChildren = childrenArray.map((child)=>{
            if (child === slottable) {
                // because the new element will be the one rendered, we are only interested
                // in grabbing its children (`newElement.props.children`)
                if (react.Children.count(newElement) > 1) return react.Children.only(null);
                return /*#__PURE__*/ (0,react.isValidElement)(newElement) ? newElement.props.children : null;
            } else return child;
        });
        return /*#__PURE__*/ (0,react.createElement)($5e63c961fc1ce211$var$SlotClone, (0,esm_extends/* default */.Z)({}, slotProps, {
            ref: forwardedRef
        }), /*#__PURE__*/ (0,react.isValidElement)(newElement) ? /*#__PURE__*/ (0,react.cloneElement)(newElement, undefined, newChildren) : null);
    }
    return /*#__PURE__*/ (0,react.createElement)($5e63c961fc1ce211$var$SlotClone, (0,esm_extends/* default */.Z)({}, slotProps, {
        ref: forwardedRef
    }), children);
});
$5e63c961fc1ce211$export$8c6ed5c666ac1360.displayName = 'Slot';
/* -------------------------------------------------------------------------------------------------
 * SlotClone
 * -----------------------------------------------------------------------------------------------*/ const $5e63c961fc1ce211$var$SlotClone = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { children: children , ...slotProps } = props;
    if (/*#__PURE__*/ (0,react.isValidElement)(children)) return /*#__PURE__*/ (0,react.cloneElement)(children, {
        ...$5e63c961fc1ce211$var$mergeProps(slotProps, children.props),
        ref: $6ed0406888f73fc4$export$43e446d32b3d21af(forwardedRef, children.ref)
    });
    return react.Children.count(children) > 1 ? react.Children.only(null) : null;
});
$5e63c961fc1ce211$var$SlotClone.displayName = 'SlotClone';
/* -------------------------------------------------------------------------------------------------
 * Slottable
 * -----------------------------------------------------------------------------------------------*/ const $5e63c961fc1ce211$export$d9f1ccf0bdb05d45 = ({ children: children  })=>{
    return /*#__PURE__*/ (0,react.createElement)(react.Fragment, null, children);
};
/* ---------------------------------------------------------------------------------------------- */ function $5e63c961fc1ce211$var$isSlottable(child) {
    return /*#__PURE__*/ (0,react.isValidElement)(child) && child.type === $5e63c961fc1ce211$export$d9f1ccf0bdb05d45;
}
function $5e63c961fc1ce211$var$mergeProps(slotProps, childProps) {
    // all child props should override
    const overrideProps = {
        ...childProps
    };
    for(const propName in childProps){
        const slotPropValue = slotProps[propName];
        const childPropValue = childProps[propName];
        const isHandler = /^on[A-Z]/.test(propName);
        if (isHandler) {
            // if the handler exists on both, we compose them
            if (slotPropValue && childPropValue) overrideProps[propName] = (...args)=>{
                childPropValue(...args);
                slotPropValue(...args);
            };
            else if (slotPropValue) overrideProps[propName] = slotPropValue;
        } else if (propName === 'style') overrideProps[propName] = {
            ...slotPropValue,
            ...childPropValue
        };
        else if (propName === 'className') overrideProps[propName] = [
            slotPropValue,
            childPropValue
        ].filter(Boolean).join(' ');
    }
    return {
        ...slotProps,
        ...overrideProps
    };
}
const $5e63c961fc1ce211$export$be92b6f5f03c0fe9 = (/* unused pure expression or super */ null && ($5e63c961fc1ce211$export$8c6ed5c666ac1360));





//# sourceMappingURL=index.module.js.map

;// CONCATENATED MODULE: ../node_modules/@reach/utils/dist/reach-utils.mjs

/**
  * @reach/utils v0.18.0
  *
  * Copyright (c) 2018-2022, React Training LLC
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE.md file in the root directory of this source tree.
  *
  * @license MIT
  */


// src/can-use-dom.ts
function canUseDOM() {
  return !!(typeof window !== "undefined" && window.document && window.document.createElement);
}

// src/clone-valid-element.ts

function cloneValidElement(element, props, ...children) {
  return isValidElement(element) ? cloneElement(element, props, ...children) : element;
}

// src/compose-event-handlers.ts
function composeEventHandlers(theirHandler, ourHandler) {
  return (event) => {
    theirHandler && theirHandler(event);
    if (!event.defaultPrevented) {
      return ourHandler(event);
    }
  };
}

// src/compose-refs.ts


// src/type-check.ts
function isBoolean(value) {
  return typeof value === "boolean";
}
function isFunction(value) {
  return !!(value && {}.toString.call(value) == "[object Function]");
}
function reach_utils_isNumber(value) {
  return typeof value === "number" && !isNaN(value);
}
function isString(value) {
  return typeof value === "string";
}

// src/compose-refs.ts
function assignRef(ref, value) {
  if (ref == null)
    return;
  if (isFunction(ref)) {
    ref(value);
  } else {
    try {
      ref.current = value;
    } catch (error) {
      throw new Error(`Cannot assign value "${value}" to ref "${ref}"`);
    }
  }
}
function useComposedRefs(...refs) {
  return useCallback((node) => {
    for (let ref of refs) {
      assignRef(ref, node);
    }
  }, refs);
}

// src/owner-document.ts
function getOwnerDocument(element) {
  return canUseDOM() ? element ? element.ownerDocument : document : null;
}
function getOwnerWindow(element) {
  let ownerDocument = getOwnerDocument(element);
  return ownerDocument ? ownerDocument.defaultView || window : null;
}

// src/computed-styles.ts
function getComputedStyles(element) {
  let ownerWindow = getOwnerWindow(element);
  if (ownerWindow) {
    return ownerWindow.getComputedStyle(element, null);
  }
  return null;
}
function reach_utils_getComputedStyle(element, styleProp) {
  return getComputedStyles(element)?.getPropertyValue(styleProp) || null;
}

// src/context.tsx

function createNamedContext(name, defaultValue) {
  let Ctx = React.createContext(defaultValue);
  Ctx.displayName = name;
  return Ctx;
}
function createContext2(rootComponentName, defaultContext) {
  let Ctx = React.createContext(defaultContext);
  function Provider(props) {
    let { children, ...context } = props;
    let value = React.useMemo(() => context, Object.values(context));
    return /* @__PURE__ */ React.createElement(Ctx.Provider, {
      value
    }, children);
  }
  function useContext2(callerComponentName) {
    let context = React.useContext(Ctx);
    if (context) {
      return context;
    }
    if (defaultContext) {
      return defaultContext;
    }
    throw Error(`${callerComponentName} must be rendered inside of a ${rootComponentName} component.`);
  }
  Ctx.displayName = `${rootComponentName}Context`;
  Provider.displayName = `${rootComponentName}Provider`;
  return [Provider, useContext2];
}

// src/dev-utils.ts

function useControlledSwitchWarning(controlledValue, controlledPropName, componentName) {
  if (true) {
    let controlledRef = useRef(controlledValue != null);
    let nameCache = useRef({ componentName, controlledPropName });
    useEffect(() => {
      nameCache.current = { componentName, controlledPropName };
    }, [componentName, controlledPropName]);
    useEffect(() => {
      let { current: wasControlled } = controlledRef;
      let { componentName: componentName2, controlledPropName: controlledPropName2 } = nameCache.current;
      let isControlled = controlledValue != null;
      if (wasControlled !== isControlled) {
        console.error(`A component is changing an ${wasControlled ? "" : "un"}controlled \`${controlledPropName2}\` state of ${componentName2} to be ${wasControlled ? "un" : ""}controlled. This is likely caused by the value changing from undefined to a defined value, which should not happen. Decide between using a controlled or uncontrolled ${componentName2} element for the lifetime of the component.
      More info: https://fb.me/react-controlled-components`);
      }
    }, [controlledValue]);
  }
}

// src/get-document-dimensions.ts
function getDocumentDimensions(element) {
  let ownerDocument = getOwnerDocument(element);
  let ownerWindow = ownerDocument.defaultView || window;
  if (!ownerDocument) {
    return {
      width: 0,
      height: 0
    };
  }
  return {
    width: ownerDocument.documentElement.clientWidth ?? ownerWindow.innerWidth,
    height: ownerDocument.documentElement.clientHeight ?? ownerWindow.innerHeight
  };
}

// src/get-scroll-position.ts
function getScrollPosition(element) {
  let ownerWindow = getOwnerWindow(element);
  if (!ownerWindow) {
    return {
      scrollX: 0,
      scrollY: 0
    };
  }
  return {
    scrollX: ownerWindow.scrollX,
    scrollY: ownerWindow.scrollY
  };
}

// src/get-scrollbar-offset.ts
function getScrollbarOffset() {
  try {
    if (window.innerWidth > document.documentElement.clientWidth) {
      return window.innerWidth - document.documentElement.clientWidth;
    }
  } catch (err) {
  }
  return 0;
}

// src/is-right-click.ts
function isRightClick(nativeEvent) {
  return "which" in nativeEvent ? nativeEvent.which === 3 : "button" in nativeEvent ? nativeEvent.button === 2 : false;
}

// src/make-id.ts
function makeId(...args) {
  return args.filter((val) => val != null).join("--");
}

// src/noop.ts
function noop() {
}

// src/use-constant.ts

function useConstant(fn) {
  const ref = useRef2();
  if (!ref.current) {
    ref.current = { v: fn() };
  }
  return ref.current.v;
}

// src/use-controlled-state.ts

function useControlledState({
  controlledValue,
  defaultValue,
  calledFrom = "A component"
}) {
  let wasControlled = controlledValue !== void 0;
  let isControlledRef = useRef3(wasControlled);
  if (true) {
    if (!isControlledRef.current && wasControlled) {
      console.warn(`${calledFrom} is changing from controlled to uncontrolled. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`);
    }
    if (isControlledRef.current && !wasControlled) {
      console.warn(`${calledFrom} is changing from uncontrolled to controlled. Components should not switch from uncontrolled to controlled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`);
    }
  }
  let [valueState, setValue] = useState(isControlledRef.current ? controlledValue : defaultValue);
  let set = useCallback2((n) => {
    if (!isControlledRef.current) {
      setValue(n);
    }
  }, []);
  return [isControlledRef.current ? controlledValue : valueState, set];
}

// src/use-event-listener.ts

function useEventListener(eventName, listener, element = window) {
  const savedHandler = useRef4(listener);
  useEffect2(() => {
    savedHandler.current = listener;
  }, [listener]);
  useEffect2(() => {
    const isSupported = element && element.addEventListener;
    if (!isSupported) {
      if (true) {
        console.warn("Event listener not supported on the element provided");
      }
      return;
    }
    function eventListener(event) {
      savedHandler.current(event);
    }
    element.addEventListener(eventName, eventListener);
    return () => {
      element.removeEventListener(eventName, eventListener);
    };
  }, [eventName, element]);
}

// src/use-focus-change.ts

function useFocusChange(handleChange = console.log, when = "focus", ownerDocument = document) {
  let lastActiveElement = useRef5(ownerDocument.activeElement);
  useEffect3(() => {
    lastActiveElement.current = ownerDocument.activeElement;
    function onChange(event) {
      if (lastActiveElement.current !== ownerDocument.activeElement) {
        handleChange(ownerDocument.activeElement, lastActiveElement.current, event);
        lastActiveElement.current = ownerDocument.activeElement;
      }
    }
    ownerDocument.addEventListener(when, onChange, true);
    return () => {
      ownerDocument.removeEventListener(when, onChange);
    };
  }, [when, handleChange, ownerDocument]);
}

// src/use-force-update.ts

function useForceUpdate() {
  let [, dispatch] = useState2(/* @__PURE__ */ Object.create(null));
  return useCallback3(() => {
    dispatch(/* @__PURE__ */ Object.create(null));
  }, []);
}

// src/use-isomorphic-layout-effect.ts

var useIsomorphicLayoutEffect = canUseDOM() ? react.useLayoutEffect : react.useEffect;

// src/use-lazy-ref.ts

function useLazyRef(fn) {
  let isSet = useRef6(false);
  let ref = useRef6();
  if (!isSet.current) {
    isSet.current = true;
    ref.current = fn();
  }
  return ref;
}

// src/use-previous.ts

function usePrevious(value) {
  const ref = useRef7(null);
  useEffect5(() => {
    ref.current = value;
  }, [value]);
  return ref.current;
}

// src/use-stable-callback.ts

function createStableCallbackHook(useEffectHook, callback) {
  let callbackRef = useRef8(callback);
  useEffectHook(() => {
    callbackRef.current = callback;
  });
  return useCallback4((...args) => {
    callbackRef.current && callbackRef.current(...args);
  }, []);
}
function useStableCallback(callback) {
  return createStableCallbackHook(useEffect6, callback);
}
function useStableLayoutCallback(callback) {
  return createStableCallbackHook(useIsomorphicLayoutEffect, callback);
}

// src/use-stateful-ref-value.ts

function useStatefulRefValue(ref, initialState) {
  let [state, setState] = useState3(initialState);
  let callbackRef = useCallback5((refValue) => {
    ref.current = refValue;
    setState(refValue);
  }, []);
  return [state, callbackRef];
}

// src/use-update-effect.ts

function useUpdateEffect(effect, deps) {
  const mounted = useRef9(false);
  useEffect7(() => {
    if (mounted.current) {
      effect();
    } else {
      mounted.current = true;
    }
  }, deps);
}


;// CONCATENATED MODULE: ../node_modules/@reach/auto-id/dist/reach-auto-id.mjs

/**
  * @reach/auto-id v0.18.0
  *
  * Copyright (c) 2018-2022, React Training LLC
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE.md file in the root directory of this source tree.
  *
  * @license MIT
  */


// src/reach-auto-id.ts


var serverHandoffComplete = false;
var id = 0;
function genId() {
  return ++id;
}
var maybeReactUseId = react_namespaceObject["useId".toString()];
function reach_auto_id_useId(providedId) {
  if (maybeReactUseId !== void 0) {
    let generatedId = maybeReactUseId();
    return providedId ?? generatedId;
  }
  let initialId = providedId ?? (serverHandoffComplete ? genId() : null);
  let [id2, setId] = react.useState(initialId);
  useIsomorphicLayoutEffect(() => {
    if (id2 === null) {
      setId(genId());
    }
  }, []);
  react.useEffect(() => {
    if (serverHandoffComplete === false) {
      serverHandoffComplete = true;
    }
  }, []);
  return providedId ?? id2 ?? void 0;
}


// EXTERNAL MODULE: ../node_modules/twind/observe/observe.js
var observe = __webpack_require__(1281);
;// CONCATENATED MODULE: ../node_modules/twind/shim/shim.js
// src/shim/index.ts


if (typeof document !== "undefined" && typeof addEventListener == "function") {
  shim_onload = () => {
    const script = document.querySelector('script[type="twind-config"]');
    setup(script ? JSON.parse(script.innerHTML) : {});
  };
  if (document.readyState === "loading") {
    addEventListener("DOMContentLoaded", shim_onload);
  } else {
    timeoutRef = setTimeout(shim_onload);
  }
}
var shim_onload;
var timeoutRef;
var observer = (0,observe/* createObserver */.zo)();
var disconnect = () => {
  if (shim_onload) {
    removeEventListener("DOMContentLoaded", shim_onload);
    clearTimeout(timeoutRef);
  }
  observer.disconnect();
};
var setup = ({
  target = document.documentElement,
  ...config
} = {}) => {
  if (Object.keys(config).length) {
    (0,observe/* setup */.cY)(config);
  }
  disconnect();
  observer.observe(target);
  target.hidden = false;
};

//# sourceMappingURL=shim.js.map

// EXTERNAL MODULE: ../node_modules/@global-ecom/nitro-uds/dist/utils/esm/index.js
var utils_esm = __webpack_require__(21955);
;// CONCATENATED MODULE: ../node_modules/@radix-ui/react-collapsible/node_modules/@radix-ui/primitive/dist/index.module.js
function $e42e1063c40fb3ef$export$b9ecd428b558ff10(originalEventHandler, ourEventHandler, { checkForDefaultPrevented: checkForDefaultPrevented = true  } = {}) {
    return function handleEvent(event) {
        originalEventHandler === null || originalEventHandler === void 0 || originalEventHandler(event);
        if (checkForDefaultPrevented === false || !event.defaultPrevented) return ourEventHandler === null || ourEventHandler === void 0 ? void 0 : ourEventHandler(event);
    };
}





//# sourceMappingURL=index.module.js.map

;// CONCATENATED MODULE: ../node_modules/@radix-ui/react-collapsible/node_modules/@radix-ui/react-context/dist/index.module.js



function $c512c27ab02ef895$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
    const Context = /*#__PURE__*/ $3bkAK$createContext(defaultContext);
    function Provider(props) {
        const { children: children , ...context } = props; // Only re-memoize when prop values change
        // eslint-disable-next-line react-hooks/exhaustive-deps
        const value = $3bkAK$useMemo(()=>context
        , Object.values(context));
        return /*#__PURE__*/ $3bkAK$createElement(Context.Provider, {
            value: value
        }, children);
    }
    function useContext(consumerName) {
        const context = $3bkAK$useContext(Context);
        if (context) return context;
        if (defaultContext !== undefined) return defaultContext; // if a defaultContext wasn't specified, it's a required context.
        throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
    }
    Provider.displayName = rootComponentName + 'Provider';
    return [
        Provider,
        useContext
    ];
}
/* -------------------------------------------------------------------------------------------------
 * createContextScope
 * -----------------------------------------------------------------------------------------------*/ function $c512c27ab02ef895$export$50c7b4e9d9f19c1(scopeName, createContextScopeDeps = []) {
    let defaultContexts = [];
    /* -----------------------------------------------------------------------------------------------
   * createContext
   * ---------------------------------------------------------------------------------------------*/ function $c512c27ab02ef895$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
        const BaseContext = /*#__PURE__*/ (0,react.createContext)(defaultContext);
        const index = defaultContexts.length;
        defaultContexts = [
            ...defaultContexts,
            defaultContext
        ];
        function Provider(props) {
            const { scope: scope , children: children , ...context } = props;
            const Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index]) || BaseContext; // Only re-memoize when prop values change
            // eslint-disable-next-line react-hooks/exhaustive-deps
            const value = (0,react.useMemo)(()=>context
            , Object.values(context));
            return /*#__PURE__*/ (0,react.createElement)(Context.Provider, {
                value: value
            }, children);
        }
        function useContext(consumerName, scope) {
            const Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index]) || BaseContext;
            const context = (0,react.useContext)(Context);
            if (context) return context;
            if (defaultContext !== undefined) return defaultContext; // if a defaultContext wasn't specified, it's a required context.
            throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
        }
        Provider.displayName = rootComponentName + 'Provider';
        return [
            Provider,
            useContext
        ];
    }
    /* -----------------------------------------------------------------------------------------------
   * createScope
   * ---------------------------------------------------------------------------------------------*/ const createScope = ()=>{
        const scopeContexts = defaultContexts.map((defaultContext)=>{
            return /*#__PURE__*/ (0,react.createContext)(defaultContext);
        });
        return function useScope(scope) {
            const contexts = (scope === null || scope === void 0 ? void 0 : scope[scopeName]) || scopeContexts;
            return (0,react.useMemo)(()=>({
                    [`__scope${scopeName}`]: {
                        ...scope,
                        [scopeName]: contexts
                    }
                })
            , [
                scope,
                contexts
            ]);
        };
    };
    createScope.scopeName = scopeName;
    return [
        $c512c27ab02ef895$export$fd42f52fd3ae1109,
        $c512c27ab02ef895$var$composeContextScopes(createScope, ...createContextScopeDeps)
    ];
}
/* -------------------------------------------------------------------------------------------------
 * composeContextScopes
 * -----------------------------------------------------------------------------------------------*/ function $c512c27ab02ef895$var$composeContextScopes(...scopes) {
    const baseScope = scopes[0];
    if (scopes.length === 1) return baseScope;
    const createScope1 = ()=>{
        const scopeHooks = scopes.map((createScope)=>({
                useScope: createScope(),
                scopeName: createScope.scopeName
            })
        );
        return function useComposedScopes(overrideScopes) {
            const nextScopes1 = scopeHooks.reduce((nextScopes, { useScope: useScope , scopeName: scopeName  })=>{
                // We are calling a hook inside a callback which React warns against to avoid inconsistent
                // renders, however, scoping doesn't have render side effects so we ignore the rule.
                // eslint-disable-next-line react-hooks/rules-of-hooks
                const scopeProps = useScope(overrideScopes);
                const currentScope = scopeProps[`__scope${scopeName}`];
                return {
                    ...nextScopes,
                    ...currentScope
                };
            }, {});
            return (0,react.useMemo)(()=>({
                    [`__scope${baseScope.scopeName}`]: nextScopes1
                })
            , [
                nextScopes1
            ]);
        };
    };
    createScope1.scopeName = baseScope.scopeName;
    return createScope1;
}





//# sourceMappingURL=index.module.js.map

;// CONCATENATED MODULE: ../node_modules/@radix-ui/react-collapsible/node_modules/@radix-ui/react-use-callback-ref/dist/index.module.js



/**
 * A custom hook that converts a callback to a ref to avoid triggering re-renders when passed as a
 * prop or avoid re-executing effects when passed as a dependency
 */ function $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(callback) {
    const callbackRef = (0,react.useRef)(callback);
    (0,react.useEffect)(()=>{
        callbackRef.current = callback;
    }); // https://github.com/facebook/react/issues/19240
    return (0,react.useMemo)(()=>(...args)=>{
            var _callbackRef$current;
            return (_callbackRef$current = callbackRef.current) === null || _callbackRef$current === void 0 ? void 0 : _callbackRef$current.call(callbackRef, ...args);
        }
    , []);
}





//# sourceMappingURL=index.module.js.map

;// CONCATENATED MODULE: ../node_modules/@radix-ui/react-collapsible/node_modules/@radix-ui/react-use-controllable-state/dist/index.module.js





function $71cd76cc60e0454e$export$6f32135080cb4c3({ prop: prop , defaultProp: defaultProp , onChange: onChange = ()=>{}  }) {
    const [uncontrolledProp, setUncontrolledProp] = $71cd76cc60e0454e$var$useUncontrolledState({
        defaultProp: defaultProp,
        onChange: onChange
    });
    const isControlled = prop !== undefined;
    const value1 = isControlled ? prop : uncontrolledProp;
    const handleChange = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(onChange);
    const setValue = (0,react.useCallback)((nextValue)=>{
        if (isControlled) {
            const setter = nextValue;
            const value = typeof nextValue === 'function' ? setter(prop) : nextValue;
            if (value !== prop) handleChange(value);
        } else setUncontrolledProp(nextValue);
    }, [
        isControlled,
        prop,
        setUncontrolledProp,
        handleChange
    ]);
    return [
        value1,
        setValue
    ];
}
function $71cd76cc60e0454e$var$useUncontrolledState({ defaultProp: defaultProp , onChange: onChange  }) {
    const uncontrolledState = (0,react.useState)(defaultProp);
    const [value] = uncontrolledState;
    const prevValueRef = (0,react.useRef)(value);
    const handleChange = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(onChange);
    (0,react.useEffect)(()=>{
        if (prevValueRef.current !== value) {
            handleChange(value);
            prevValueRef.current = value;
        }
    }, [
        value,
        prevValueRef,
        handleChange
    ]);
    return uncontrolledState;
}





//# sourceMappingURL=index.module.js.map

;// CONCATENATED MODULE: ../node_modules/@radix-ui/react-collapsible/node_modules/@radix-ui/react-use-layout-effect/dist/index.module.js



/**
 * On the server, React emits a warning when calling `useLayoutEffect`.
 * This is because neither `useLayoutEffect` nor `useEffect` run on the server.
 * We use this safe version which suppresses the warning by replacing it with a noop on the server.
 *
 * See: https://reactjs.org/docs/hooks-reference.html#uselayouteffect
 */ const $9f79659886946c16$export$e5c5a5f917a5871c = Boolean(globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) ? react.useLayoutEffect : ()=>{};





//# sourceMappingURL=index.module.js.map

;// CONCATENATED MODULE: ../node_modules/@radix-ui/react-collapsible/node_modules/@radix-ui/react-compose-refs/dist/index.module.js



/**
 * Set a given ref to a given value
 * This utility takes care of different types of refs: callback refs and RefObject(s)
 */ function index_module_$6ed0406888f73fc4$var$setRef(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref !== null && ref !== undefined) ref.current = value;
}
/**
 * A utility to compose multiple refs together
 * Accepts callback refs and RefObject(s)
 */ function index_module_$6ed0406888f73fc4$export$43e446d32b3d21af(...refs) {
    return (node)=>refs.forEach((ref)=>index_module_$6ed0406888f73fc4$var$setRef(ref, node)
        )
    ;
}
/**
 * A custom hook that composes multiple refs
 * Accepts callback refs and RefObject(s)
 */ function index_module_$6ed0406888f73fc4$export$c7b2cbe3552a0d05(...refs) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return (0,react.useCallback)(index_module_$6ed0406888f73fc4$export$43e446d32b3d21af(...refs), refs);
}





//# sourceMappingURL=index.module.js.map

// EXTERNAL MODULE: ../node_modules/react-dom/index.js
var react_dom = __webpack_require__(31542);
;// CONCATENATED MODULE: ../node_modules/@radix-ui/react-collapsible/node_modules/@radix-ui/react-primitive/dist/index.module.js









const $8927f6f2acc4f386$var$NODES = [
    'a',
    'button',
    'div',
    'form',
    'h2',
    'h3',
    'img',
    'input',
    'label',
    'li',
    'nav',
    'ol',
    'p',
    'span',
    'svg',
    'ul'
]; // Temporary while we await merge of this fix:
// https://github.com/DefinitelyTyped/DefinitelyTyped/pull/55396
// prettier-ignore
/* -------------------------------------------------------------------------------------------------
 * Primitive
 * -----------------------------------------------------------------------------------------------*/ const $8927f6f2acc4f386$export$250ffa63cdc0d034 = $8927f6f2acc4f386$var$NODES.reduce((primitive, node)=>{
    const Node = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
        const { asChild: asChild , ...primitiveProps } = props;
        const Comp = asChild ? $5e63c961fc1ce211$export$8c6ed5c666ac1360 : node;
        (0,react.useEffect)(()=>{
            window[Symbol.for('radix-ui')] = true;
        }, []);
        return /*#__PURE__*/ (0,react.createElement)(Comp, (0,esm_extends/* default */.Z)({}, primitiveProps, {
            ref: forwardedRef
        }));
    });
    Node.displayName = `Primitive.${node}`;
    return {
        ...primitive,
        [node]: Node
    };
}, {});
/* -------------------------------------------------------------------------------------------------
 * Utils
 * -----------------------------------------------------------------------------------------------*/ /**
 * Flush custom event dispatch
 * https://github.com/radix-ui/primitives/pull/1378
 *
 * React batches *all* event handlers since version 18, this introduces certain considerations when using custom event types.
 *
 * Internally, React prioritises events in the following order:
 *  - discrete
 *  - continuous
 *  - default
 *
 * https://github.com/facebook/react/blob/a8a4742f1c54493df00da648a3f9d26e3db9c8b5/packages/react-dom/src/events/ReactDOMEventListener.js#L294-L350
 *
 * `discrete` is an  important distinction as updates within these events are applied immediately.
 * React however, is not able to infer the priority of custom event types due to how they are detected internally.
 * Because of this, it's possible for updates from custom events to be unexpectedly batched when
 * dispatched by another `discrete` event.
 *
 * In order to ensure that updates from custom events are applied predictably, we need to manually flush the batch.
 * This utility should be used when dispatching a custom event from within another `discrete` event, this utility
 * is not nessesary when dispatching known event types, or if dispatching a custom type inside a non-discrete event.
 * For example:
 *
 * dispatching a known click 👎
 * target.dispatchEvent(new Event(‘click’))
 *
 * dispatching a custom type within a non-discrete event 👎
 * onScroll={(event) => event.target.dispatchEvent(new CustomEvent(‘customType’))}
 *
 * dispatching a custom type within a `discrete` event 👍
 * onPointerDown={(event) => dispatchDiscreteCustomEvent(event.target, new CustomEvent(‘customType’))}
 *
 * Note: though React classifies `focus`, `focusin` and `focusout` events as `discrete`, it's  not recommended to use
 * this utility with them. This is because it's possible for those handlers to be called implicitly during render
 * e.g. when focus is within a component as it is unmounted, or when managing focus on mount.
 */ function $8927f6f2acc4f386$export$6d1a0317bde7de7f(target, event) {
    if (target) $4q5Fq$flushSync(()=>target.dispatchEvent(event)
    );
}
/* -----------------------------------------------------------------------------------------------*/ const $8927f6f2acc4f386$export$be92b6f5f03c0fe9 = (/* unused pure expression or super */ null && ($8927f6f2acc4f386$export$250ffa63cdc0d034));





//# sourceMappingURL=index.module.js.map

;// CONCATENATED MODULE: ../node_modules/@radix-ui/react-collapsible/node_modules/@radix-ui/react-presence/dist/index.module.js










function $fe963b355347cc68$export$3e6543de14f8614f(initialState, machine) {
    return (0,react.useReducer)((state, event)=>{
        const nextState = machine[state][event];
        return nextState !== null && nextState !== void 0 ? nextState : state;
    }, initialState);
}


const $921a889cee6df7e8$export$99c2b779aa4e8b8b = (props)=>{
    const { present: present , children: children  } = props;
    const presence = $921a889cee6df7e8$var$usePresence(present);
    const child = typeof children === 'function' ? children({
        present: presence.isPresent
    }) : react.Children.only(children);
    const ref = index_module_$6ed0406888f73fc4$export$c7b2cbe3552a0d05(presence.ref, child.ref);
    const forceMount = typeof children === 'function';
    return forceMount || presence.isPresent ? /*#__PURE__*/ (0,react.cloneElement)(child, {
        ref: ref
    }) : null;
};
$921a889cee6df7e8$export$99c2b779aa4e8b8b.displayName = 'Presence';
/* -------------------------------------------------------------------------------------------------
 * usePresence
 * -----------------------------------------------------------------------------------------------*/ function $921a889cee6df7e8$var$usePresence(present) {
    const [node1, setNode] = (0,react.useState)();
    const stylesRef = (0,react.useRef)({});
    const prevPresentRef = (0,react.useRef)(present);
    const prevAnimationNameRef = (0,react.useRef)('none');
    const initialState = present ? 'mounted' : 'unmounted';
    const [state, send] = $fe963b355347cc68$export$3e6543de14f8614f(initialState, {
        mounted: {
            UNMOUNT: 'unmounted',
            ANIMATION_OUT: 'unmountSuspended'
        },
        unmountSuspended: {
            MOUNT: 'mounted',
            ANIMATION_END: 'unmounted'
        },
        unmounted: {
            MOUNT: 'mounted'
        }
    });
    (0,react.useEffect)(()=>{
        const currentAnimationName = $921a889cee6df7e8$var$getAnimationName(stylesRef.current);
        prevAnimationNameRef.current = state === 'mounted' ? currentAnimationName : 'none';
    }, [
        state
    ]);
    $9f79659886946c16$export$e5c5a5f917a5871c(()=>{
        const styles = stylesRef.current;
        const wasPresent = prevPresentRef.current;
        const hasPresentChanged = wasPresent !== present;
        if (hasPresentChanged) {
            const prevAnimationName = prevAnimationNameRef.current;
            const currentAnimationName = $921a889cee6df7e8$var$getAnimationName(styles);
            if (present) send('MOUNT');
            else if (currentAnimationName === 'none' || (styles === null || styles === void 0 ? void 0 : styles.display) === 'none') // If there is no exit animation or the element is hidden, animations won't run
            // so we unmount instantly
            send('UNMOUNT');
            else {
                /**
         * When `present` changes to `false`, we check changes to animation-name to
         * determine whether an animation has started. We chose this approach (reading
         * computed styles) because there is no `animationrun` event and `animationstart`
         * fires after `animation-delay` has expired which would be too late.
         */ const isAnimating = prevAnimationName !== currentAnimationName;
                if (wasPresent && isAnimating) send('ANIMATION_OUT');
                else send('UNMOUNT');
            }
            prevPresentRef.current = present;
        }
    }, [
        present,
        send
    ]);
    $9f79659886946c16$export$e5c5a5f917a5871c(()=>{
        if (node1) {
            /**
       * Triggering an ANIMATION_OUT during an ANIMATION_IN will fire an `animationcancel`
       * event for ANIMATION_IN after we have entered `unmountSuspended` state. So, we
       * make sure we only trigger ANIMATION_END for the currently active animation.
       */ const handleAnimationEnd = (event)=>{
                const currentAnimationName = $921a889cee6df7e8$var$getAnimationName(stylesRef.current);
                const isCurrentAnimation = currentAnimationName.includes(event.animationName);
                if (event.target === node1 && isCurrentAnimation) // With React 18 concurrency this update is applied
                // a frame after the animation ends, creating a flash of visible content.
                // By manually flushing we ensure they sync within a frame, removing the flash.
                (0,react_dom.flushSync)(()=>send('ANIMATION_END')
                );
            };
            const handleAnimationStart = (event)=>{
                if (event.target === node1) // if animation occurred, store its name as the previous animation.
                prevAnimationNameRef.current = $921a889cee6df7e8$var$getAnimationName(stylesRef.current);
            };
            node1.addEventListener('animationstart', handleAnimationStart);
            node1.addEventListener('animationcancel', handleAnimationEnd);
            node1.addEventListener('animationend', handleAnimationEnd);
            return ()=>{
                node1.removeEventListener('animationstart', handleAnimationStart);
                node1.removeEventListener('animationcancel', handleAnimationEnd);
                node1.removeEventListener('animationend', handleAnimationEnd);
            };
        } else // Transition to the unmounted state if the node is removed prematurely.
        // We avoid doing so during cleanup as the node may change but still exist.
        send('ANIMATION_END');
    }, [
        node1,
        send
    ]);
    return {
        isPresent: [
            'mounted',
            'unmountSuspended'
        ].includes(state),
        ref: (0,react.useCallback)((node)=>{
            if (node) stylesRef.current = getComputedStyle(node);
            setNode(node);
        }, [])
    };
}
/* -----------------------------------------------------------------------------------------------*/ function $921a889cee6df7e8$var$getAnimationName(styles) {
    return (styles === null || styles === void 0 ? void 0 : styles.animationName) || 'none';
}





//# sourceMappingURL=index.module.js.map

;// CONCATENATED MODULE: ../node_modules/@radix-ui/react-collapsible/node_modules/@radix-ui/react-id/dist/index.module.js





const $1746a345f3d73bb7$var$useReactId = react_namespaceObject['useId'.toString()] || (()=>undefined
);
let $1746a345f3d73bb7$var$count = 0;
function $1746a345f3d73bb7$export$f680877a34711e37(deterministicId) {
    const [id, setId] = react.useState($1746a345f3d73bb7$var$useReactId()); // React versions older than 18 will have client-side ids only.
    $9f79659886946c16$export$e5c5a5f917a5871c(()=>{
        if (!deterministicId) setId((reactId)=>reactId !== null && reactId !== void 0 ? reactId : String($1746a345f3d73bb7$var$count++)
        );
    }, [
        deterministicId
    ]);
    return deterministicId || (id ? `radix-${id}` : '');
}





//# sourceMappingURL=index.module.js.map

;// CONCATENATED MODULE: ../node_modules/@radix-ui/react-collapsible/dist/index.module.js





















/* -------------------------------------------------------------------------------------------------
 * Collapsible
 * -----------------------------------------------------------------------------------------------*/ const $409067139f391064$var$COLLAPSIBLE_NAME = 'Collapsible';
const [$409067139f391064$var$createCollapsibleContext, $409067139f391064$export$952b32dcbe73087a] = $c512c27ab02ef895$export$50c7b4e9d9f19c1($409067139f391064$var$COLLAPSIBLE_NAME);
const [$409067139f391064$var$CollapsibleProvider, $409067139f391064$var$useCollapsibleContext] = $409067139f391064$var$createCollapsibleContext($409067139f391064$var$COLLAPSIBLE_NAME);
const $409067139f391064$export$6eb0f7ddcda6131f = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { __scopeCollapsible: __scopeCollapsible , open: openProp , defaultOpen: defaultOpen , disabled: disabled , onOpenChange: onOpenChange , ...collapsibleProps } = props;
    const [open = false, setOpen] = $71cd76cc60e0454e$export$6f32135080cb4c3({
        prop: openProp,
        defaultProp: defaultOpen,
        onChange: onOpenChange
    });
    return /*#__PURE__*/ (0,react.createElement)($409067139f391064$var$CollapsibleProvider, {
        scope: __scopeCollapsible,
        disabled: disabled,
        contentId: $1746a345f3d73bb7$export$f680877a34711e37(),
        open: open,
        onOpenToggle: (0,react.useCallback)(()=>setOpen((prevOpen)=>!prevOpen
            )
        , [
            setOpen
        ])
    }, /*#__PURE__*/ (0,react.createElement)($8927f6f2acc4f386$export$250ffa63cdc0d034.div, (0,esm_extends/* default */.Z)({
        "data-state": $409067139f391064$var$getState(open),
        "data-disabled": disabled ? '' : undefined
    }, collapsibleProps, {
        ref: forwardedRef
    })));
});
/*#__PURE__*/ Object.assign($409067139f391064$export$6eb0f7ddcda6131f, {
    displayName: $409067139f391064$var$COLLAPSIBLE_NAME
});
/* -------------------------------------------------------------------------------------------------
 * CollapsibleTrigger
 * -----------------------------------------------------------------------------------------------*/ const $409067139f391064$var$TRIGGER_NAME = 'CollapsibleTrigger';
const $409067139f391064$export$c135dce7b15bbbdc = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { __scopeCollapsible: __scopeCollapsible , ...triggerProps } = props;
    const context = $409067139f391064$var$useCollapsibleContext($409067139f391064$var$TRIGGER_NAME, __scopeCollapsible);
    return /*#__PURE__*/ (0,react.createElement)($8927f6f2acc4f386$export$250ffa63cdc0d034.button, (0,esm_extends/* default */.Z)({
        type: "button",
        "aria-controls": context.contentId,
        "aria-expanded": context.open || false,
        "data-state": $409067139f391064$var$getState(context.open),
        "data-disabled": context.disabled ? '' : undefined,
        disabled: context.disabled
    }, triggerProps, {
        ref: forwardedRef,
        onClick: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onClick, context.onOpenToggle)
    }));
});
/*#__PURE__*/ Object.assign($409067139f391064$export$c135dce7b15bbbdc, {
    displayName: $409067139f391064$var$TRIGGER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * CollapsibleContent
 * -----------------------------------------------------------------------------------------------*/ const $409067139f391064$var$CONTENT_NAME = 'CollapsibleContent';
const $409067139f391064$export$aadde00976f34151 = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { forceMount: forceMount , ...contentProps } = props;
    const context = $409067139f391064$var$useCollapsibleContext($409067139f391064$var$CONTENT_NAME, props.__scopeCollapsible);
    return /*#__PURE__*/ (0,react.createElement)($921a889cee6df7e8$export$99c2b779aa4e8b8b, {
        present: forceMount || context.open
    }, ({ present: present  })=>/*#__PURE__*/ (0,react.createElement)($409067139f391064$var$CollapsibleContentImpl, (0,esm_extends/* default */.Z)({}, contentProps, {
            ref: forwardedRef,
            present: present
        }))
    );
});
/*#__PURE__*/ Object.assign($409067139f391064$export$aadde00976f34151, {
    displayName: $409067139f391064$var$CONTENT_NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $409067139f391064$var$CollapsibleContentImpl = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { __scopeCollapsible: __scopeCollapsible , present: present , children: children , ...contentProps } = props;
    const context = $409067139f391064$var$useCollapsibleContext($409067139f391064$var$CONTENT_NAME, __scopeCollapsible);
    const [isPresent, setIsPresent] = (0,react.useState)(present);
    const ref = (0,react.useRef)(null);
    const composedRefs = index_module_$6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, ref);
    const heightRef = (0,react.useRef)(0);
    const height = heightRef.current;
    const widthRef = (0,react.useRef)(0);
    const width = widthRef.current; // when opening we want it to immediately open to retrieve dimensions
    // when closing we delay `present` to retrieve dimensions before closing
    const isOpen = context.open || isPresent;
    const isMountAnimationPreventedRef = (0,react.useRef)(isOpen);
    const originalStylesRef = (0,react.useRef)();
    (0,react.useEffect)(()=>{
        const rAF = requestAnimationFrame(()=>isMountAnimationPreventedRef.current = false
        );
        return ()=>cancelAnimationFrame(rAF)
        ;
    }, []);
    $9f79659886946c16$export$e5c5a5f917a5871c(()=>{
        const node = ref.current;
        if (node) {
            originalStylesRef.current = originalStylesRef.current || {
                transitionDuration: node.style.transitionDuration,
                animationName: node.style.animationName
            }; // block any animations/transitions so the element renders at its full dimensions
            node.style.transitionDuration = '0s';
            node.style.animationName = 'none'; // get width and height from full dimensions
            const rect = node.getBoundingClientRect();
            heightRef.current = rect.height;
            widthRef.current = rect.width; // kick off any animations/transitions that were originally set up if it isn't the initial mount
            if (!isMountAnimationPreventedRef.current) {
                node.style.transitionDuration = originalStylesRef.current.transitionDuration;
                node.style.animationName = originalStylesRef.current.animationName;
            }
            setIsPresent(present);
        }
    /**
     * depends on `context.open` because it will change to `false`
     * when a close is triggered but `present` will be `false` on
     * animation end (so when close finishes). This allows us to
     * retrieve the dimensions *before* closing.
     */ }, [
        context.open,
        present
    ]);
    return /*#__PURE__*/ (0,react.createElement)($8927f6f2acc4f386$export$250ffa63cdc0d034.div, (0,esm_extends/* default */.Z)({
        "data-state": $409067139f391064$var$getState(context.open),
        "data-disabled": context.disabled ? '' : undefined,
        id: context.contentId,
        hidden: !isOpen
    }, contentProps, {
        ref: composedRefs,
        style: {
            [`--radix-collapsible-content-height`]: height ? `${height}px` : undefined,
            [`--radix-collapsible-content-width`]: width ? `${width}px` : undefined,
            ...props.style
        }
    }), isOpen && children);
});
/* -----------------------------------------------------------------------------------------------*/ function $409067139f391064$var$getState(open) {
    return open ? 'open' : 'closed';
}
const $409067139f391064$export$be92b6f5f03c0fe9 = $409067139f391064$export$6eb0f7ddcda6131f;
const $409067139f391064$export$41fb9f06171c75f4 = $409067139f391064$export$c135dce7b15bbbdc;
const $409067139f391064$export$7c6e2c02157bb7d2 = $409067139f391064$export$aadde00976f34151;





//# sourceMappingURL=index.module.js.map

;// CONCATENATED MODULE: ../node_modules/@radix-ui/react-dialog/node_modules/@radix-ui/primitive/dist/index.module.js
function index_module_$e42e1063c40fb3ef$export$b9ecd428b558ff10(originalEventHandler, ourEventHandler, { checkForDefaultPrevented: checkForDefaultPrevented = true  } = {}) {
    return function handleEvent(event) {
        originalEventHandler === null || originalEventHandler === void 0 || originalEventHandler(event);
        if (checkForDefaultPrevented === false || !event.defaultPrevented) return ourEventHandler === null || ourEventHandler === void 0 ? void 0 : ourEventHandler(event);
    };
}





//# sourceMappingURL=index.module.js.map

;// CONCATENATED MODULE: ../node_modules/@radix-ui/react-dialog/node_modules/@radix-ui/react-compose-refs/dist/index.module.js



/**
 * Set a given ref to a given value
 * This utility takes care of different types of refs: callback refs and RefObject(s)
 */ function dist_index_module_$6ed0406888f73fc4$var$setRef(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref !== null && ref !== undefined) ref.current = value;
}
/**
 * A utility to compose multiple refs together
 * Accepts callback refs and RefObject(s)
 */ function dist_index_module_$6ed0406888f73fc4$export$43e446d32b3d21af(...refs) {
    return (node)=>refs.forEach((ref)=>dist_index_module_$6ed0406888f73fc4$var$setRef(ref, node)
        )
    ;
}
/**
 * A custom hook that composes multiple refs
 * Accepts callback refs and RefObject(s)
 */ function dist_index_module_$6ed0406888f73fc4$export$c7b2cbe3552a0d05(...refs) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return (0,react.useCallback)(dist_index_module_$6ed0406888f73fc4$export$43e446d32b3d21af(...refs), refs);
}





//# sourceMappingURL=index.module.js.map

;// CONCATENATED MODULE: ../node_modules/@radix-ui/react-dialog/node_modules/@radix-ui/react-context/dist/index.module.js



function index_module_$c512c27ab02ef895$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
    const Context = /*#__PURE__*/ (0,react.createContext)(defaultContext);
    function Provider(props) {
        const { children: children , ...context } = props; // Only re-memoize when prop values change
        // eslint-disable-next-line react-hooks/exhaustive-deps
        const value = (0,react.useMemo)(()=>context
        , Object.values(context));
        return /*#__PURE__*/ (0,react.createElement)(Context.Provider, {
            value: value
        }, children);
    }
    function useContext(consumerName) {
        const context = (0,react.useContext)(Context);
        if (context) return context;
        if (defaultContext !== undefined) return defaultContext; // if a defaultContext wasn't specified, it's a required context.
        throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
    }
    Provider.displayName = rootComponentName + 'Provider';
    return [
        Provider,
        useContext
    ];
}
/* -------------------------------------------------------------------------------------------------
 * createContextScope
 * -----------------------------------------------------------------------------------------------*/ function index_module_$c512c27ab02ef895$export$50c7b4e9d9f19c1(scopeName, createContextScopeDeps = []) {
    let defaultContexts = [];
    /* -----------------------------------------------------------------------------------------------
   * createContext
   * ---------------------------------------------------------------------------------------------*/ function $c512c27ab02ef895$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
        const BaseContext = /*#__PURE__*/ (0,react.createContext)(defaultContext);
        const index = defaultContexts.length;
        defaultContexts = [
            ...defaultContexts,
            defaultContext
        ];
        function Provider(props) {
            const { scope: scope , children: children , ...context } = props;
            const Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index]) || BaseContext; // Only re-memoize when prop values change
            // eslint-disable-next-line react-hooks/exhaustive-deps
            const value = (0,react.useMemo)(()=>context
            , Object.values(context));
            return /*#__PURE__*/ (0,react.createElement)(Context.Provider, {
                value: value
            }, children);
        }
        function useContext(consumerName, scope) {
            const Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index]) || BaseContext;
            const context = (0,react.useContext)(Context);
            if (context) return context;
            if (defaultContext !== undefined) return defaultContext; // if a defaultContext wasn't specified, it's a required context.
            throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
        }
        Provider.displayName = rootComponentName + 'Provider';
        return [
            Provider,
            useContext
        ];
    }
    /* -----------------------------------------------------------------------------------------------
   * createScope
   * ---------------------------------------------------------------------------------------------*/ const createScope = ()=>{
        const scopeContexts = defaultContexts.map((defaultContext)=>{
            return /*#__PURE__*/ (0,react.createContext)(defaultContext);
        });
        return function useScope(scope) {
            const contexts = (scope === null || scope === void 0 ? void 0 : scope[scopeName]) || scopeContexts;
            return (0,react.useMemo)(()=>({
                    [`__scope${scopeName}`]: {
                        ...scope,
                        [scopeName]: contexts
                    }
                })
            , [
                scope,
                contexts
            ]);
        };
    };
    createScope.scopeName = scopeName;
    return [
        $c512c27ab02ef895$export$fd42f52fd3ae1109,
        index_module_$c512c27ab02ef895$var$composeContextScopes(createScope, ...createContextScopeDeps)
    ];
}
/* -------------------------------------------------------------------------------------------------
 * composeContextScopes
 * -----------------------------------------------------------------------------------------------*/ function index_module_$c512c27ab02ef895$var$composeContextScopes(...scopes) {
    const baseScope = scopes[0];
    if (scopes.length === 1) return baseScope;
    const createScope1 = ()=>{
        const scopeHooks = scopes.map((createScope)=>({
                useScope: createScope(),
                scopeName: createScope.scopeName
            })
        );
        return function useComposedScopes(overrideScopes) {
            const nextScopes1 = scopeHooks.reduce((nextScopes, { useScope: useScope , scopeName: scopeName  })=>{
                // We are calling a hook inside a callback which React warns against to avoid inconsistent
                // renders, however, scoping doesn't have render side effects so we ignore the rule.
                // eslint-disable-next-line react-hooks/rules-of-hooks
                const scopeProps = useScope(overrideScopes);
                const currentScope = scopeProps[`__scope${scopeName}`];
                return {
                    ...nextScopes,
                    ...currentScope
                };
            }, {});
            return (0,react.useMemo)(()=>({
                    [`__scope${baseScope.scopeName}`]: nextScopes1
                })
            , [
                nextScopes1
            ]);
        };
    };
    createScope1.scopeName = baseScope.scopeName;
    return createScope1;
}





//# sourceMappingURL=index.module.js.map

;// CONCATENATED MODULE: ../node_modules/@radix-ui/react-dialog/node_modules/@radix-ui/react-use-layout-effect/dist/index.module.js



/**
 * On the server, React emits a warning when calling `useLayoutEffect`.
 * This is because neither `useLayoutEffect` nor `useEffect` run on the server.
 * We use this safe version which suppresses the warning by replacing it with a noop on the server.
 *
 * See: https://reactjs.org/docs/hooks-reference.html#uselayouteffect
 */ const index_module_$9f79659886946c16$export$e5c5a5f917a5871c = Boolean(globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) ? react.useLayoutEffect : ()=>{};





//# sourceMappingURL=index.module.js.map

;// CONCATENATED MODULE: ../node_modules/@radix-ui/react-dialog/node_modules/@radix-ui/react-id/dist/index.module.js





const index_module_$1746a345f3d73bb7$var$useReactId = react_namespaceObject['useId'.toString()] || (()=>undefined
);
let index_module_$1746a345f3d73bb7$var$count = 0;
function index_module_$1746a345f3d73bb7$export$f680877a34711e37(deterministicId) {
    const [id, setId] = react.useState(index_module_$1746a345f3d73bb7$var$useReactId()); // React versions older than 18 will have client-side ids only.
    index_module_$9f79659886946c16$export$e5c5a5f917a5871c(()=>{
        if (!deterministicId) setId((reactId)=>reactId !== null && reactId !== void 0 ? reactId : String(index_module_$1746a345f3d73bb7$var$count++)
        );
    }, [
        deterministicId
    ]);
    return deterministicId || (id ? `radix-${id}` : '');
}





//# sourceMappingURL=index.module.js.map

;// CONCATENATED MODULE: ../node_modules/@radix-ui/react-dialog/node_modules/@radix-ui/react-use-callback-ref/dist/index.module.js



/**
 * A custom hook that converts a callback to a ref to avoid triggering re-renders when passed as a
 * prop or avoid re-executing effects when passed as a dependency
 */ function index_module_$b1b2314f5f9a1d84$export$25bec8c6f54ee79a(callback) {
    const callbackRef = (0,react.useRef)(callback);
    (0,react.useEffect)(()=>{
        callbackRef.current = callback;
    }); // https://github.com/facebook/react/issues/19240
    return (0,react.useMemo)(()=>(...args)=>{
            var _callbackRef$current;
            return (_callbackRef$current = callbackRef.current) === null || _callbackRef$current === void 0 ? void 0 : _callbackRef$current.call(callbackRef, ...args);
        }
    , []);
}





//# sourceMappingURL=index.module.js.map

;// CONCATENATED MODULE: ../node_modules/@radix-ui/react-dialog/node_modules/@radix-ui/react-use-controllable-state/dist/index.module.js





function index_module_$71cd76cc60e0454e$export$6f32135080cb4c3({ prop: prop , defaultProp: defaultProp , onChange: onChange = ()=>{}  }) {
    const [uncontrolledProp, setUncontrolledProp] = index_module_$71cd76cc60e0454e$var$useUncontrolledState({
        defaultProp: defaultProp,
        onChange: onChange
    });
    const isControlled = prop !== undefined;
    const value1 = isControlled ? prop : uncontrolledProp;
    const handleChange = index_module_$b1b2314f5f9a1d84$export$25bec8c6f54ee79a(onChange);
    const setValue = (0,react.useCallback)((nextValue)=>{
        if (isControlled) {
            const setter = nextValue;
            const value = typeof nextValue === 'function' ? setter(prop) : nextValue;
            if (value !== prop) handleChange(value);
        } else setUncontrolledProp(nextValue);
    }, [
        isControlled,
        prop,
        setUncontrolledProp,
        handleChange
    ]);
    return [
        value1,
        setValue
    ];
}
function index_module_$71cd76cc60e0454e$var$useUncontrolledState({ defaultProp: defaultProp , onChange: onChange  }) {
    const uncontrolledState = (0,react.useState)(defaultProp);
    const [value] = uncontrolledState;
    const prevValueRef = (0,react.useRef)(value);
    const handleChange = index_module_$b1b2314f5f9a1d84$export$25bec8c6f54ee79a(onChange);
    (0,react.useEffect)(()=>{
        if (prevValueRef.current !== value) {
            handleChange(value);
            prevValueRef.current = value;
        }
    }, [
        value,
        prevValueRef,
        handleChange
    ]);
    return uncontrolledState;
}





//# sourceMappingURL=index.module.js.map

;// CONCATENATED MODULE: ../node_modules/@radix-ui/react-dismissable-layer/node_modules/@radix-ui/primitive/dist/index.module.js
function dist_index_module_$e42e1063c40fb3ef$export$b9ecd428b558ff10(originalEventHandler, ourEventHandler, { checkForDefaultPrevented: checkForDefaultPrevented = true  } = {}) {
    return function handleEvent(event) {
        originalEventHandler === null || originalEventHandler === void 0 || originalEventHandler(event);
        if (checkForDefaultPrevented === false || !event.defaultPrevented) return ourEventHandler === null || ourEventHandler === void 0 ? void 0 : ourEventHandler(event);
    };
}





//# sourceMappingURL=index.module.js.map

;// CONCATENATED MODULE: ../node_modules/@radix-ui/react-dismissable-layer/node_modules/@radix-ui/react-primitive/dist/index.module.js









const index_module_$8927f6f2acc4f386$var$NODES = [
    'a',
    'button',
    'div',
    'h2',
    'h3',
    'img',
    'label',
    'li',
    'nav',
    'ol',
    'p',
    'span',
    'svg',
    'ul'
]; // Temporary while we await merge of this fix:
// https://github.com/DefinitelyTyped/DefinitelyTyped/pull/55396
// prettier-ignore
/* -------------------------------------------------------------------------------------------------
 * Primitive
 * -----------------------------------------------------------------------------------------------*/ const index_module_$8927f6f2acc4f386$export$250ffa63cdc0d034 = index_module_$8927f6f2acc4f386$var$NODES.reduce((primitive, node)=>{
    const Node = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
        const { asChild: asChild , ...primitiveProps } = props;
        const Comp = asChild ? $5e63c961fc1ce211$export$8c6ed5c666ac1360 : node;
        (0,react.useEffect)(()=>{
            window[Symbol.for('radix-ui')] = true;
        }, []);
        return /*#__PURE__*/ (0,react.createElement)(Comp, (0,esm_extends/* default */.Z)({}, primitiveProps, {
            ref: forwardedRef
        }));
    });
    Node.displayName = `Primitive.${node}`;
    return {
        ...primitive,
        [node]: Node
    };
}, {});
/* -------------------------------------------------------------------------------------------------
 * Utils
 * -----------------------------------------------------------------------------------------------*/ /**
 * Flush custom event dispatch
 * https://github.com/radix-ui/primitives/pull/1378
 *
 * React batches *all* event handlers since version 18, this introduces certain considerations when using custom event types.
 *
 * Internally, React prioritises events in the following order:
 *  - discrete
 *  - continuous
 *  - default
 *
 * https://github.com/facebook/react/blob/a8a4742f1c54493df00da648a3f9d26e3db9c8b5/packages/react-dom/src/events/ReactDOMEventListener.js#L294-L350
 *
 * `discrete` is an  important distinction as updates within these events are applied immediately.
 * React however, is not able to infer the priority of custom event types due to how they are detected internally.
 * Because of this, it's possible for updates from custom events to be unexpectedly batched when
 * dispatched by another `discrete` event.
 *
 * In order to ensure that updates from custom events are applied predictably, we need to manually flush the batch.
 * This utility should be used when dispatching a custom event from within another `discrete` event, this utility
 * is not nessesary when dispatching known event types, or if dispatching a custom type inside a non-discrete event.
 * For example:
 *
 * dispatching a known click 👎
 * target.dispatchEvent(new Event(‘click’))
 *
 * dispatching a custom type within a non-discrete event 👎
 * onScroll={(event) => event.target.dispatchEvent(new CustomEvent(‘customType’))}
 *
 * dispatching a custom type within a `discrete` event 👍
 * onPointerDown={(event) => dispatchDiscreteCustomEvent(event.target, new CustomEvent(‘customType’))}
 *
 * Note: though React classifies `focus`, `focusin` and `focusout` events as `discrete`, it's  not recommended to use
 * this utility with them. This is because it's possible for those handlers to be called implicitly during render
 * e.g. when focus is within a component as it is unmounted, or when managing focus on mount.
 */ function index_module_$8927f6f2acc4f386$export$6d1a0317bde7de7f(target, event) {
    if (target) (0,react_dom.flushSync)(()=>target.dispatchEvent(event)
    );
}
/* -----------------------------------------------------------------------------------------------*/ const index_module_$8927f6f2acc4f386$export$be92b6f5f03c0fe9 = (/* unused pure expression or super */ null && (index_module_$8927f6f2acc4f386$export$250ffa63cdc0d034));





//# sourceMappingURL=index.module.js.map

;// CONCATENATED MODULE: ../node_modules/@radix-ui/react-dismissable-layer/node_modules/@radix-ui/react-compose-refs/dist/index.module.js



/**
 * Set a given ref to a given value
 * This utility takes care of different types of refs: callback refs and RefObject(s)
 */ function react_compose_refs_dist_index_module_$6ed0406888f73fc4$var$setRef(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref !== null && ref !== undefined) ref.current = value;
}
/**
 * A utility to compose multiple refs together
 * Accepts callback refs and RefObject(s)
 */ function react_compose_refs_dist_index_module_$6ed0406888f73fc4$export$43e446d32b3d21af(...refs) {
    return (node)=>refs.forEach((ref)=>react_compose_refs_dist_index_module_$6ed0406888f73fc4$var$setRef(ref, node)
        )
    ;
}
/**
 * A custom hook that composes multiple refs
 * Accepts callback refs and RefObject(s)
 */ function react_compose_refs_dist_index_module_$6ed0406888f73fc4$export$c7b2cbe3552a0d05(...refs) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return (0,react.useCallback)(react_compose_refs_dist_index_module_$6ed0406888f73fc4$export$43e446d32b3d21af(...refs), refs);
}





//# sourceMappingURL=index.module.js.map

;// CONCATENATED MODULE: ../node_modules/@radix-ui/react-dismissable-layer/node_modules/@radix-ui/react-use-callback-ref/dist/index.module.js



/**
 * A custom hook that converts a callback to a ref to avoid triggering re-renders when passed as a
 * prop or avoid re-executing effects when passed as a dependency
 */ function dist_index_module_$b1b2314f5f9a1d84$export$25bec8c6f54ee79a(callback) {
    const callbackRef = (0,react.useRef)(callback);
    (0,react.useEffect)(()=>{
        callbackRef.current = callback;
    }); // https://github.com/facebook/react/issues/19240
    return (0,react.useMemo)(()=>(...args)=>{
            var _callbackRef$current;
            return (_callbackRef$current = callbackRef.current) === null || _callbackRef$current === void 0 ? void 0 : _callbackRef$current.call(callbackRef, ...args);
        }
    , []);
}





//# sourceMappingURL=index.module.js.map

;// CONCATENATED MODULE: ../node_modules/@radix-ui/react-use-escape-keydown/node_modules/@radix-ui/react-use-callback-ref/dist/index.module.js



/**
 * A custom hook that converts a callback to a ref to avoid triggering re-renders when passed as a
 * prop or avoid re-executing effects when passed as a dependency
 */ function react_use_callback_ref_dist_index_module_$b1b2314f5f9a1d84$export$25bec8c6f54ee79a(callback) {
    const callbackRef = (0,react.useRef)(callback);
    (0,react.useEffect)(()=>{
        callbackRef.current = callback;
    }); // https://github.com/facebook/react/issues/19240
    return (0,react.useMemo)(()=>(...args)=>{
            var _callbackRef$current;
            return (_callbackRef$current = callbackRef.current) === null || _callbackRef$current === void 0 ? void 0 : _callbackRef$current.call(callbackRef, ...args);
        }
    , []);
}





//# sourceMappingURL=index.module.js.map

;// CONCATENATED MODULE: ../node_modules/@radix-ui/react-use-escape-keydown/dist/index.module.js





/**
 * Listens for when the escape key is down
 */ function $addc16e1bbe58fd0$export$3a72a57244d6e765(onEscapeKeyDownProp, ownerDocument = globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) {
    const onEscapeKeyDown = react_use_callback_ref_dist_index_module_$b1b2314f5f9a1d84$export$25bec8c6f54ee79a(onEscapeKeyDownProp);
    (0,react.useEffect)(()=>{
        const handleKeyDown = (event)=>{
            if (event.key === 'Escape') onEscapeKeyDown(event);
        };
        ownerDocument.addEventListener('keydown', handleKeyDown);
        return ()=>ownerDocument.removeEventListener('keydown', handleKeyDown)
        ;
    }, [
        onEscapeKeyDown,
        ownerDocument
    ]);
}





//# sourceMappingURL=index.module.js.map

;// CONCATENATED MODULE: ../node_modules/@radix-ui/react-dismissable-layer/dist/index.module.js















/* -------------------------------------------------------------------------------------------------
 * DismissableLayer
 * -----------------------------------------------------------------------------------------------*/ const $5cb92bef7577960e$var$DISMISSABLE_LAYER_NAME = 'DismissableLayer';
const $5cb92bef7577960e$var$CONTEXT_UPDATE = 'dismissableLayer.update';
const $5cb92bef7577960e$var$POINTER_DOWN_OUTSIDE = 'dismissableLayer.pointerDownOutside';
const $5cb92bef7577960e$var$FOCUS_OUTSIDE = 'dismissableLayer.focusOutside';
let $5cb92bef7577960e$var$originalBodyPointerEvents;
const $5cb92bef7577960e$var$DismissableLayerContext = /*#__PURE__*/ (0,react.createContext)({
    layers: new Set(),
    layersWithOutsidePointerEventsDisabled: new Set(),
    branches: new Set()
});
const $5cb92bef7577960e$export$177fb62ff3ec1f22 = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    var _node$ownerDocument;
    const { disableOutsidePointerEvents: disableOutsidePointerEvents = false , onEscapeKeyDown: onEscapeKeyDown , onPointerDownOutside: onPointerDownOutside , onFocusOutside: onFocusOutside , onInteractOutside: onInteractOutside , onDismiss: onDismiss , ...layerProps } = props;
    const context = (0,react.useContext)($5cb92bef7577960e$var$DismissableLayerContext);
    const [node1, setNode] = (0,react.useState)(null);
    const ownerDocument = (_node$ownerDocument = node1 === null || node1 === void 0 ? void 0 : node1.ownerDocument) !== null && _node$ownerDocument !== void 0 ? _node$ownerDocument : globalThis === null || globalThis === void 0 ? void 0 : globalThis.document;
    const [, force] = (0,react.useState)({});
    const composedRefs = react_compose_refs_dist_index_module_$6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, (node)=>setNode(node)
    );
    const layers = Array.from(context.layers);
    const [highestLayerWithOutsidePointerEventsDisabled] = [
        ...context.layersWithOutsidePointerEventsDisabled
    ].slice(-1); // prettier-ignore
    const highestLayerWithOutsidePointerEventsDisabledIndex = layers.indexOf(highestLayerWithOutsidePointerEventsDisabled); // prettier-ignore
    const index = node1 ? layers.indexOf(node1) : -1;
    const isBodyPointerEventsDisabled = context.layersWithOutsidePointerEventsDisabled.size > 0;
    const isPointerEventsEnabled = index >= highestLayerWithOutsidePointerEventsDisabledIndex;
    const pointerDownOutside = $5cb92bef7577960e$var$usePointerDownOutside((event)=>{
        const target = event.target;
        const isPointerDownOnBranch = [
            ...context.branches
        ].some((branch)=>branch.contains(target)
        );
        if (!isPointerEventsEnabled || isPointerDownOnBranch) return;
        onPointerDownOutside === null || onPointerDownOutside === void 0 || onPointerDownOutside(event);
        onInteractOutside === null || onInteractOutside === void 0 || onInteractOutside(event);
        if (!event.defaultPrevented) onDismiss === null || onDismiss === void 0 || onDismiss();
    }, ownerDocument);
    const focusOutside = $5cb92bef7577960e$var$useFocusOutside((event)=>{
        const target = event.target;
        const isFocusInBranch = [
            ...context.branches
        ].some((branch)=>branch.contains(target)
        );
        if (isFocusInBranch) return;
        onFocusOutside === null || onFocusOutside === void 0 || onFocusOutside(event);
        onInteractOutside === null || onInteractOutside === void 0 || onInteractOutside(event);
        if (!event.defaultPrevented) onDismiss === null || onDismiss === void 0 || onDismiss();
    }, ownerDocument);
    $addc16e1bbe58fd0$export$3a72a57244d6e765((event)=>{
        const isHighestLayer = index === context.layers.size - 1;
        if (!isHighestLayer) return;
        onEscapeKeyDown === null || onEscapeKeyDown === void 0 || onEscapeKeyDown(event);
        if (!event.defaultPrevented && onDismiss) {
            event.preventDefault();
            onDismiss();
        }
    }, ownerDocument);
    (0,react.useEffect)(()=>{
        if (!node1) return;
        if (disableOutsidePointerEvents) {
            if (context.layersWithOutsidePointerEventsDisabled.size === 0) {
                $5cb92bef7577960e$var$originalBodyPointerEvents = ownerDocument.body.style.pointerEvents;
                ownerDocument.body.style.pointerEvents = 'none';
            }
            context.layersWithOutsidePointerEventsDisabled.add(node1);
        }
        context.layers.add(node1);
        $5cb92bef7577960e$var$dispatchUpdate();
        return ()=>{
            if (disableOutsidePointerEvents && context.layersWithOutsidePointerEventsDisabled.size === 1) ownerDocument.body.style.pointerEvents = $5cb92bef7577960e$var$originalBodyPointerEvents;
        };
    }, [
        node1,
        ownerDocument,
        disableOutsidePointerEvents,
        context
    ]);
    /**
   * We purposefully prevent combining this effect with the `disableOutsidePointerEvents` effect
   * because a change to `disableOutsidePointerEvents` would remove this layer from the stack
   * and add it to the end again so the layering order wouldn't be _creation order_.
   * We only want them to be removed from context stacks when unmounted.
   */ (0,react.useEffect)(()=>{
        return ()=>{
            if (!node1) return;
            context.layers.delete(node1);
            context.layersWithOutsidePointerEventsDisabled.delete(node1);
            $5cb92bef7577960e$var$dispatchUpdate();
        };
    }, [
        node1,
        context
    ]);
    (0,react.useEffect)(()=>{
        const handleUpdate = ()=>force({})
        ;
        document.addEventListener($5cb92bef7577960e$var$CONTEXT_UPDATE, handleUpdate);
        return ()=>document.removeEventListener($5cb92bef7577960e$var$CONTEXT_UPDATE, handleUpdate)
        ;
    }, []);
    return /*#__PURE__*/ (0,react.createElement)(index_module_$8927f6f2acc4f386$export$250ffa63cdc0d034.div, (0,esm_extends/* default */.Z)({}, layerProps, {
        ref: composedRefs,
        style: {
            pointerEvents: isBodyPointerEventsDisabled ? isPointerEventsEnabled ? 'auto' : 'none' : undefined,
            ...props.style
        },
        onFocusCapture: dist_index_module_$e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onFocusCapture, focusOutside.onFocusCapture),
        onBlurCapture: dist_index_module_$e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onBlurCapture, focusOutside.onBlurCapture),
        onPointerDownCapture: dist_index_module_$e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onPointerDownCapture, pointerDownOutside.onPointerDownCapture)
    }));
});
/*#__PURE__*/ Object.assign($5cb92bef7577960e$export$177fb62ff3ec1f22, {
    displayName: $5cb92bef7577960e$var$DISMISSABLE_LAYER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DismissableLayerBranch
 * -----------------------------------------------------------------------------------------------*/ const $5cb92bef7577960e$var$BRANCH_NAME = 'DismissableLayerBranch';
const $5cb92bef7577960e$export$4d5eb2109db14228 = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const context = (0,react.useContext)($5cb92bef7577960e$var$DismissableLayerContext);
    const ref = (0,react.useRef)(null);
    const composedRefs = react_compose_refs_dist_index_module_$6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, ref);
    (0,react.useEffect)(()=>{
        const node = ref.current;
        if (node) {
            context.branches.add(node);
            return ()=>{
                context.branches.delete(node);
            };
        }
    }, [
        context.branches
    ]);
    return /*#__PURE__*/ (0,react.createElement)(index_module_$8927f6f2acc4f386$export$250ffa63cdc0d034.div, (0,esm_extends/* default */.Z)({}, props, {
        ref: composedRefs
    }));
});
/*#__PURE__*/ Object.assign($5cb92bef7577960e$export$4d5eb2109db14228, {
    displayName: $5cb92bef7577960e$var$BRANCH_NAME
});
/* -----------------------------------------------------------------------------------------------*/ /**
 * Listens for `pointerdown` outside a react subtree. We use `pointerdown` rather than `pointerup`
 * to mimic layer dismissing behaviour present in OS.
 * Returns props to pass to the node we want to check for outside events.
 */ function $5cb92bef7577960e$var$usePointerDownOutside(onPointerDownOutside, ownerDocument = globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) {
    const handlePointerDownOutside = dist_index_module_$b1b2314f5f9a1d84$export$25bec8c6f54ee79a(onPointerDownOutside);
    const isPointerInsideReactTreeRef = (0,react.useRef)(false);
    const handleClickRef = (0,react.useRef)(()=>{});
    (0,react.useEffect)(()=>{
        const handlePointerDown = (event)=>{
            if (event.target && !isPointerInsideReactTreeRef.current) {
                const eventDetail = {
                    originalEvent: event
                };
                function handleAndDispatchPointerDownOutsideEvent() {
                    $5cb92bef7577960e$var$handleAndDispatchCustomEvent($5cb92bef7577960e$var$POINTER_DOWN_OUTSIDE, handlePointerDownOutside, eventDetail, {
                        discrete: true
                    });
                }
                /**
         * On touch devices, we need to wait for a click event because browsers implement
         * a ~350ms delay between the time the user stops touching the display and when the
         * browser executres events. We need to ensure we don't reactivate pointer-events within
         * this timeframe otherwise the browser may execute events that should have been prevented.
         *
         * Additionally, this also lets us deal automatically with cancellations when a click event
         * isn't raised because the page was considered scrolled/drag-scrolled, long-pressed, etc.
         *
         * This is why we also continuously remove the previous listener, because we cannot be
         * certain that it was raised, and therefore cleaned-up.
         */ if (event.pointerType === 'touch') {
                    ownerDocument.removeEventListener('click', handleClickRef.current);
                    handleClickRef.current = handleAndDispatchPointerDownOutsideEvent;
                    ownerDocument.addEventListener('click', handleClickRef.current, {
                        once: true
                    });
                } else handleAndDispatchPointerDownOutsideEvent();
            }
            isPointerInsideReactTreeRef.current = false;
        };
        /**
     * if this hook executes in a component that mounts via a `pointerdown` event, the event
     * would bubble up to the document and trigger a `pointerDownOutside` event. We avoid
     * this by delaying the event listener registration on the document.
     * This is not React specific, but rather how the DOM works, ie:
     * ```
     * button.addEventListener('pointerdown', () => {
     *   console.log('I will log');
     *   document.addEventListener('pointerdown', () => {
     *     console.log('I will also log');
     *   })
     * });
     */ const timerId = window.setTimeout(()=>{
            ownerDocument.addEventListener('pointerdown', handlePointerDown);
        }, 0);
        return ()=>{
            window.clearTimeout(timerId);
            ownerDocument.removeEventListener('pointerdown', handlePointerDown);
            ownerDocument.removeEventListener('click', handleClickRef.current);
        };
    }, [
        ownerDocument,
        handlePointerDownOutside
    ]);
    return {
        // ensures we check React component tree (not just DOM tree)
        onPointerDownCapture: ()=>isPointerInsideReactTreeRef.current = true
    };
}
/**
 * Listens for when focus happens outside a react subtree.
 * Returns props to pass to the root (node) of the subtree we want to check.
 */ function $5cb92bef7577960e$var$useFocusOutside(onFocusOutside, ownerDocument = globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) {
    const handleFocusOutside = dist_index_module_$b1b2314f5f9a1d84$export$25bec8c6f54ee79a(onFocusOutside);
    const isFocusInsideReactTreeRef = (0,react.useRef)(false);
    (0,react.useEffect)(()=>{
        const handleFocus = (event)=>{
            if (event.target && !isFocusInsideReactTreeRef.current) {
                const eventDetail = {
                    originalEvent: event
                };
                $5cb92bef7577960e$var$handleAndDispatchCustomEvent($5cb92bef7577960e$var$FOCUS_OUTSIDE, handleFocusOutside, eventDetail, {
                    discrete: false
                });
            }
        };
        ownerDocument.addEventListener('focusin', handleFocus);
        return ()=>ownerDocument.removeEventListener('focusin', handleFocus)
        ;
    }, [
        ownerDocument,
        handleFocusOutside
    ]);
    return {
        onFocusCapture: ()=>isFocusInsideReactTreeRef.current = true
        ,
        onBlurCapture: ()=>isFocusInsideReactTreeRef.current = false
    };
}
function $5cb92bef7577960e$var$dispatchUpdate() {
    const event = new CustomEvent($5cb92bef7577960e$var$CONTEXT_UPDATE);
    document.dispatchEvent(event);
}
function $5cb92bef7577960e$var$handleAndDispatchCustomEvent(name, handler, detail, { discrete: discrete  }) {
    const target = detail.originalEvent.target;
    const event = new CustomEvent(name, {
        bubbles: false,
        cancelable: true,
        detail: detail
    });
    if (handler) target.addEventListener(name, handler, {
        once: true
    });
    if (discrete) index_module_$8927f6f2acc4f386$export$6d1a0317bde7de7f(target, event);
    else target.dispatchEvent(event);
}
const $5cb92bef7577960e$export$be92b6f5f03c0fe9 = $5cb92bef7577960e$export$177fb62ff3ec1f22;
const $5cb92bef7577960e$export$aecb2ddcb55c95be = $5cb92bef7577960e$export$4d5eb2109db14228;





//# sourceMappingURL=index.module.js.map

;// CONCATENATED MODULE: ../node_modules/@radix-ui/react-focus-scope/node_modules/@radix-ui/react-compose-refs/dist/index.module.js



/**
 * Set a given ref to a given value
 * This utility takes care of different types of refs: callback refs and RefObject(s)
 */ function _radix_ui_react_compose_refs_dist_index_module_$6ed0406888f73fc4$var$setRef(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref !== null && ref !== undefined) ref.current = value;
}
/**
 * A utility to compose multiple refs together
 * Accepts callback refs and RefObject(s)
 */ function _radix_ui_react_compose_refs_dist_index_module_$6ed0406888f73fc4$export$43e446d32b3d21af(...refs) {
    return (node)=>refs.forEach((ref)=>_radix_ui_react_compose_refs_dist_index_module_$6ed0406888f73fc4$var$setRef(ref, node)
        )
    ;
}
/**
 * A custom hook that composes multiple refs
 * Accepts callback refs and RefObject(s)
 */ function _radix_ui_react_compose_refs_dist_index_module_$6ed0406888f73fc4$export$c7b2cbe3552a0d05(...refs) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return (0,react.useCallback)(_radix_ui_react_compose_refs_dist_index_module_$6ed0406888f73fc4$export$43e446d32b3d21af(...refs), refs);
}





//# sourceMappingURL=index.module.js.map

;// CONCATENATED MODULE: ../node_modules/@radix-ui/react-focus-scope/node_modules/@radix-ui/react-primitive/dist/index.module.js









const dist_index_module_$8927f6f2acc4f386$var$NODES = [
    'a',
    'button',
    'div',
    'h2',
    'h3',
    'img',
    'label',
    'li',
    'nav',
    'ol',
    'p',
    'span',
    'svg',
    'ul'
]; // Temporary while we await merge of this fix:
// https://github.com/DefinitelyTyped/DefinitelyTyped/pull/55396
// prettier-ignore
/* -------------------------------------------------------------------------------------------------
 * Primitive
 * -----------------------------------------------------------------------------------------------*/ const dist_index_module_$8927f6f2acc4f386$export$250ffa63cdc0d034 = dist_index_module_$8927f6f2acc4f386$var$NODES.reduce((primitive, node)=>{
    const Node = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
        const { asChild: asChild , ...primitiveProps } = props;
        const Comp = asChild ? $5e63c961fc1ce211$export$8c6ed5c666ac1360 : node;
        (0,react.useEffect)(()=>{
            window[Symbol.for('radix-ui')] = true;
        }, []);
        return /*#__PURE__*/ (0,react.createElement)(Comp, (0,esm_extends/* default */.Z)({}, primitiveProps, {
            ref: forwardedRef
        }));
    });
    Node.displayName = `Primitive.${node}`;
    return {
        ...primitive,
        [node]: Node
    };
}, {});
/* -------------------------------------------------------------------------------------------------
 * Utils
 * -----------------------------------------------------------------------------------------------*/ /**
 * Flush custom event dispatch
 * https://github.com/radix-ui/primitives/pull/1378
 *
 * React batches *all* event handlers since version 18, this introduces certain considerations when using custom event types.
 *
 * Internally, React prioritises events in the following order:
 *  - discrete
 *  - continuous
 *  - default
 *
 * https://github.com/facebook/react/blob/a8a4742f1c54493df00da648a3f9d26e3db9c8b5/packages/react-dom/src/events/ReactDOMEventListener.js#L294-L350
 *
 * `discrete` is an  important distinction as updates within these events are applied immediately.
 * React however, is not able to infer the priority of custom event types due to how they are detected internally.
 * Because of this, it's possible for updates from custom events to be unexpectedly batched when
 * dispatched by another `discrete` event.
 *
 * In order to ensure that updates from custom events are applied predictably, we need to manually flush the batch.
 * This utility should be used when dispatching a custom event from within another `discrete` event, this utility
 * is not nessesary when dispatching known event types, or if dispatching a custom type inside a non-discrete event.
 * For example:
 *
 * dispatching a known click 👎
 * target.dispatchEvent(new Event(‘click’))
 *
 * dispatching a custom type within a non-discrete event 👎
 * onScroll={(event) => event.target.dispatchEvent(new CustomEvent(‘customType’))}
 *
 * dispatching a custom type within a `discrete` event 👍
 * onPointerDown={(event) => dispatchDiscreteCustomEvent(event.target, new CustomEvent(‘customType’))}
 *
 * Note: though React classifies `focus`, `focusin` and `focusout` events as `discrete`, it's  not recommended to use
 * this utility with them. This is because it's possible for those handlers to be called implicitly during render
 * e.g. when focus is within a component as it is unmounted, or when managing focus on mount.
 */ function dist_index_module_$8927f6f2acc4f386$export$6d1a0317bde7de7f(target, event) {
    if (target) $4q5Fq$flushSync(()=>target.dispatchEvent(event)
    );
}
/* -----------------------------------------------------------------------------------------------*/ const dist_index_module_$8927f6f2acc4f386$export$be92b6f5f03c0fe9 = (/* unused pure expression or super */ null && (dist_index_module_$8927f6f2acc4f386$export$250ffa63cdc0d034));





//# sourceMappingURL=index.module.js.map

;// CONCATENATED MODULE: ../node_modules/@radix-ui/react-focus-scope/node_modules/@radix-ui/react-use-callback-ref/dist/index.module.js



/**
 * A custom hook that converts a callback to a ref to avoid triggering re-renders when passed as a
 * prop or avoid re-executing effects when passed as a dependency
 */ function _radix_ui_react_use_callback_ref_dist_index_module_$b1b2314f5f9a1d84$export$25bec8c6f54ee79a(callback) {
    const callbackRef = (0,react.useRef)(callback);
    (0,react.useEffect)(()=>{
        callbackRef.current = callback;
    }); // https://github.com/facebook/react/issues/19240
    return (0,react.useMemo)(()=>(...args)=>{
            var _callbackRef$current;
            return (_callbackRef$current = callbackRef.current) === null || _callbackRef$current === void 0 ? void 0 : _callbackRef$current.call(callbackRef, ...args);
        }
    , []);
}





//# sourceMappingURL=index.module.js.map

;// CONCATENATED MODULE: ../node_modules/@radix-ui/react-focus-scope/dist/index.module.js











const $d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT = 'focusScope.autoFocusOnMount';
const $d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT = 'focusScope.autoFocusOnUnmount';
const $d3863c46a17e8a28$var$EVENT_OPTIONS = {
    bubbles: false,
    cancelable: true
};
/* -------------------------------------------------------------------------------------------------
 * FocusScope
 * -----------------------------------------------------------------------------------------------*/ const $d3863c46a17e8a28$var$FOCUS_SCOPE_NAME = 'FocusScope';
const $d3863c46a17e8a28$export$20e40289641fbbb6 = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { loop: loop = false , trapped: trapped = false , onMountAutoFocus: onMountAutoFocusProp , onUnmountAutoFocus: onUnmountAutoFocusProp , ...scopeProps } = props;
    const [container1, setContainer] = (0,react.useState)(null);
    const onMountAutoFocus = _radix_ui_react_use_callback_ref_dist_index_module_$b1b2314f5f9a1d84$export$25bec8c6f54ee79a(onMountAutoFocusProp);
    const onUnmountAutoFocus = _radix_ui_react_use_callback_ref_dist_index_module_$b1b2314f5f9a1d84$export$25bec8c6f54ee79a(onUnmountAutoFocusProp);
    const lastFocusedElementRef = (0,react.useRef)(null);
    const composedRefs = _radix_ui_react_compose_refs_dist_index_module_$6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, (node)=>setContainer(node)
    );
    const focusScope = (0,react.useRef)({
        paused: false,
        pause () {
            this.paused = true;
        },
        resume () {
            this.paused = false;
        }
    }).current; // Takes care of trapping focus if focus is moved outside programmatically for example
    (0,react.useEffect)(()=>{
        if (trapped) {
            function handleFocusIn(event) {
                if (focusScope.paused || !container1) return;
                const target = event.target;
                if (container1.contains(target)) lastFocusedElementRef.current = target;
                else $d3863c46a17e8a28$var$focus(lastFocusedElementRef.current, {
                    select: true
                });
            }
            function handleFocusOut(event) {
                if (focusScope.paused || !container1) return;
                if (!container1.contains(event.relatedTarget)) $d3863c46a17e8a28$var$focus(lastFocusedElementRef.current, {
                    select: true
                });
            }
            document.addEventListener('focusin', handleFocusIn);
            document.addEventListener('focusout', handleFocusOut);
            return ()=>{
                document.removeEventListener('focusin', handleFocusIn);
                document.removeEventListener('focusout', handleFocusOut);
            };
        }
    }, [
        trapped,
        container1,
        focusScope.paused
    ]);
    (0,react.useEffect)(()=>{
        if (container1) {
            $d3863c46a17e8a28$var$focusScopesStack.add(focusScope);
            const previouslyFocusedElement = document.activeElement;
            const hasFocusedCandidate = container1.contains(previouslyFocusedElement);
            if (!hasFocusedCandidate) {
                const mountEvent = new CustomEvent($d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT, $d3863c46a17e8a28$var$EVENT_OPTIONS);
                container1.addEventListener($d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT, onMountAutoFocus);
                container1.dispatchEvent(mountEvent);
                if (!mountEvent.defaultPrevented) {
                    $d3863c46a17e8a28$var$focusFirst($d3863c46a17e8a28$var$removeLinks($d3863c46a17e8a28$var$getTabbableCandidates(container1)), {
                        select: true
                    });
                    if (document.activeElement === previouslyFocusedElement) $d3863c46a17e8a28$var$focus(container1);
                }
            }
            return ()=>{
                container1.removeEventListener($d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT, onMountAutoFocus); // We hit a react bug (fixed in v17) with focusing in unmount.
                // We need to delay the focus a little to get around it for now.
                // See: https://github.com/facebook/react/issues/17894
                setTimeout(()=>{
                    const unmountEvent = new CustomEvent($d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT, $d3863c46a17e8a28$var$EVENT_OPTIONS);
                    container1.addEventListener($d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
                    container1.dispatchEvent(unmountEvent);
                    if (!unmountEvent.defaultPrevented) $d3863c46a17e8a28$var$focus(previouslyFocusedElement !== null && previouslyFocusedElement !== void 0 ? previouslyFocusedElement : document.body, {
                        select: true
                    });
                     // we need to remove the listener after we `dispatchEvent`
                    container1.removeEventListener($d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
                    $d3863c46a17e8a28$var$focusScopesStack.remove(focusScope);
                }, 0);
            };
        }
    }, [
        container1,
        onMountAutoFocus,
        onUnmountAutoFocus,
        focusScope
    ]); // Takes care of looping focus (when tabbing whilst at the edges)
    const handleKeyDown = (0,react.useCallback)((event)=>{
        if (!loop && !trapped) return;
        if (focusScope.paused) return;
        const isTabKey = event.key === 'Tab' && !event.altKey && !event.ctrlKey && !event.metaKey;
        const focusedElement = document.activeElement;
        if (isTabKey && focusedElement) {
            const container = event.currentTarget;
            const [first, last] = $d3863c46a17e8a28$var$getTabbableEdges(container);
            const hasTabbableElementsInside = first && last; // we can only wrap focus if we have tabbable edges
            if (!hasTabbableElementsInside) {
                if (focusedElement === container) event.preventDefault();
            } else {
                if (!event.shiftKey && focusedElement === last) {
                    event.preventDefault();
                    if (loop) $d3863c46a17e8a28$var$focus(first, {
                        select: true
                    });
                } else if (event.shiftKey && focusedElement === first) {
                    event.preventDefault();
                    if (loop) $d3863c46a17e8a28$var$focus(last, {
                        select: true
                    });
                }
            }
        }
    }, [
        loop,
        trapped,
        focusScope.paused
    ]);
    return /*#__PURE__*/ (0,react.createElement)(dist_index_module_$8927f6f2acc4f386$export$250ffa63cdc0d034.div, (0,esm_extends/* default */.Z)({
        tabIndex: -1
    }, scopeProps, {
        ref: composedRefs,
        onKeyDown: handleKeyDown
    }));
});
/*#__PURE__*/ Object.assign($d3863c46a17e8a28$export$20e40289641fbbb6, {
    displayName: $d3863c46a17e8a28$var$FOCUS_SCOPE_NAME
});
/* -------------------------------------------------------------------------------------------------
 * Utils
 * -----------------------------------------------------------------------------------------------*/ /**
 * Attempts focusing the first element in a list of candidates.
 * Stops when focus has actually moved.
 */ function $d3863c46a17e8a28$var$focusFirst(candidates, { select: select = false  } = {}) {
    const previouslyFocusedElement = document.activeElement;
    for (const candidate of candidates){
        $d3863c46a17e8a28$var$focus(candidate, {
            select: select
        });
        if (document.activeElement !== previouslyFocusedElement) return;
    }
}
/**
 * Returns the first and last tabbable elements inside a container.
 */ function $d3863c46a17e8a28$var$getTabbableEdges(container) {
    const candidates = $d3863c46a17e8a28$var$getTabbableCandidates(container);
    const first = $d3863c46a17e8a28$var$findVisible(candidates, container);
    const last = $d3863c46a17e8a28$var$findVisible(candidates.reverse(), container);
    return [
        first,
        last
    ];
}
/**
 * Returns a list of potential tabbable candidates.
 *
 * NOTE: This is only a close approximation. For example it doesn't take into account cases like when
 * elements are not visible. This cannot be worked out easily by just reading a property, but rather
 * necessitate runtime knowledge (computed styles, etc). We deal with these cases separately.
 *
 * See: https://developer.mozilla.org/en-US/docs/Web/API/TreeWalker
 * Credit: https://github.com/discord/focus-layers/blob/master/src/util/wrapFocus.tsx#L1
 */ function $d3863c46a17e8a28$var$getTabbableCandidates(container) {
    const nodes = [];
    const walker = document.createTreeWalker(container, NodeFilter.SHOW_ELEMENT, {
        acceptNode: (node)=>{
            const isHiddenInput = node.tagName === 'INPUT' && node.type === 'hidden';
            if (node.disabled || node.hidden || isHiddenInput) return NodeFilter.FILTER_SKIP; // `.tabIndex` is not the same as the `tabindex` attribute. It works on the
            // runtime's understanding of tabbability, so this automatically accounts
            // for any kind of element that could be tabbed to.
            return node.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
        }
    });
    while(walker.nextNode())nodes.push(walker.currentNode); // we do not take into account the order of nodes with positive `tabIndex` as it
    // hinders accessibility to have tab order different from visual order.
    return nodes;
}
/**
 * Returns the first visible element in a list.
 * NOTE: Only checks visibility up to the `container`.
 */ function $d3863c46a17e8a28$var$findVisible(elements, container) {
    for (const element of elements){
        // we stop checking if it's hidden at the `container` level (excluding)
        if (!$d3863c46a17e8a28$var$isHidden(element, {
            upTo: container
        })) return element;
    }
}
function $d3863c46a17e8a28$var$isHidden(node, { upTo: upTo  }) {
    if (getComputedStyle(node).visibility === 'hidden') return true;
    while(node){
        // we stop at `upTo` (excluding it)
        if (upTo !== undefined && node === upTo) return false;
        if (getComputedStyle(node).display === 'none') return true;
        node = node.parentElement;
    }
    return false;
}
function $d3863c46a17e8a28$var$isSelectableInput(element) {
    return element instanceof HTMLInputElement && 'select' in element;
}
function $d3863c46a17e8a28$var$focus(element, { select: select = false  } = {}) {
    // only focus if that element is focusable
    if (element && element.focus) {
        const previouslyFocusedElement = document.activeElement; // NOTE: we prevent scrolling on focus, to minimize jarring transitions for users
        element.focus({
            preventScroll: true
        }); // only select if its not the same element, it supports selection and we need to select
        if (element !== previouslyFocusedElement && $d3863c46a17e8a28$var$isSelectableInput(element) && select) element.select();
    }
}
/* -------------------------------------------------------------------------------------------------
 * FocusScope stack
 * -----------------------------------------------------------------------------------------------*/ const $d3863c46a17e8a28$var$focusScopesStack = $d3863c46a17e8a28$var$createFocusScopesStack();
function $d3863c46a17e8a28$var$createFocusScopesStack() {
    /** A stack of focus scopes, with the active one at the top */ let stack = [];
    return {
        add (focusScope) {
            // pause the currently active focus scope (at the top of the stack)
            const activeFocusScope = stack[0];
            if (focusScope !== activeFocusScope) activeFocusScope === null || activeFocusScope === void 0 || activeFocusScope.pause();
             // remove in case it already exists (because we'll re-add it at the top of the stack)
            stack = $d3863c46a17e8a28$var$arrayRemove(stack, focusScope);
            stack.unshift(focusScope);
        },
        remove (focusScope) {
            var _stack$;
            stack = $d3863c46a17e8a28$var$arrayRemove(stack, focusScope);
            (_stack$ = stack[0]) === null || _stack$ === void 0 || _stack$.resume();
        }
    };
}
function $d3863c46a17e8a28$var$arrayRemove(array, item) {
    const updatedArray = [
        ...array
    ];
    const index = updatedArray.indexOf(item);
    if (index !== -1) updatedArray.splice(index, 1);
    return updatedArray;
}
function $d3863c46a17e8a28$var$removeLinks(items) {
    return items.filter((item)=>item.tagName !== 'A'
    );
}
const $d3863c46a17e8a28$export$be92b6f5f03c0fe9 = (/* unused pure expression or super */ null && ($d3863c46a17e8a28$export$20e40289641fbbb6));





//# sourceMappingURL=index.module.js.map

;// CONCATENATED MODULE: ../node_modules/@radix-ui/react-portal/node_modules/@radix-ui/react-primitive/dist/index.module.js









const react_primitive_dist_index_module_$8927f6f2acc4f386$var$NODES = [
    'a',
    'button',
    'div',
    'h2',
    'h3',
    'img',
    'label',
    'li',
    'nav',
    'ol',
    'p',
    'span',
    'svg',
    'ul'
]; // Temporary while we await merge of this fix:
// https://github.com/DefinitelyTyped/DefinitelyTyped/pull/55396
// prettier-ignore
/* -------------------------------------------------------------------------------------------------
 * Primitive
 * -----------------------------------------------------------------------------------------------*/ const react_primitive_dist_index_module_$8927f6f2acc4f386$export$250ffa63cdc0d034 = react_primitive_dist_index_module_$8927f6f2acc4f386$var$NODES.reduce((primitive, node)=>{
    const Node = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
        const { asChild: asChild , ...primitiveProps } = props;
        const Comp = asChild ? $5e63c961fc1ce211$export$8c6ed5c666ac1360 : node;
        (0,react.useEffect)(()=>{
            window[Symbol.for('radix-ui')] = true;
        }, []);
        return /*#__PURE__*/ (0,react.createElement)(Comp, (0,esm_extends/* default */.Z)({}, primitiveProps, {
            ref: forwardedRef
        }));
    });
    Node.displayName = `Primitive.${node}`;
    return {
        ...primitive,
        [node]: Node
    };
}, {});
/* -------------------------------------------------------------------------------------------------
 * Utils
 * -----------------------------------------------------------------------------------------------*/ /**
 * Flush custom event dispatch
 * https://github.com/radix-ui/primitives/pull/1378
 *
 * React batches *all* event handlers since version 18, this introduces certain considerations when using custom event types.
 *
 * Internally, React prioritises events in the following order:
 *  - discrete
 *  - continuous
 *  - default
 *
 * https://github.com/facebook/react/blob/a8a4742f1c54493df00da648a3f9d26e3db9c8b5/packages/react-dom/src/events/ReactDOMEventListener.js#L294-L350
 *
 * `discrete` is an  important distinction as updates within these events are applied immediately.
 * React however, is not able to infer the priority of custom event types due to how they are detected internally.
 * Because of this, it's possible for updates from custom events to be unexpectedly batched when
 * dispatched by another `discrete` event.
 *
 * In order to ensure that updates from custom events are applied predictably, we need to manually flush the batch.
 * This utility should be used when dispatching a custom event from within another `discrete` event, this utility
 * is not nessesary when dispatching known event types, or if dispatching a custom type inside a non-discrete event.
 * For example:
 *
 * dispatching a known click 👎
 * target.dispatchEvent(new Event(‘click’))
 *
 * dispatching a custom type within a non-discrete event 👎
 * onScroll={(event) => event.target.dispatchEvent(new CustomEvent(‘customType’))}
 *
 * dispatching a custom type within a `discrete` event 👍
 * onPointerDown={(event) => dispatchDiscreteCustomEvent(event.target, new CustomEvent(‘customType’))}
 *
 * Note: though React classifies `focus`, `focusin` and `focusout` events as `discrete`, it's  not recommended to use
 * this utility with them. This is because it's possible for those handlers to be called implicitly during render
 * e.g. when focus is within a component as it is unmounted, or when managing focus on mount.
 */ function react_primitive_dist_index_module_$8927f6f2acc4f386$export$6d1a0317bde7de7f(target, event) {
    if (target) $4q5Fq$flushSync(()=>target.dispatchEvent(event)
    );
}
/* -----------------------------------------------------------------------------------------------*/ const react_primitive_dist_index_module_$8927f6f2acc4f386$export$be92b6f5f03c0fe9 = (/* unused pure expression or super */ null && (react_primitive_dist_index_module_$8927f6f2acc4f386$export$250ffa63cdc0d034));





//# sourceMappingURL=index.module.js.map

;// CONCATENATED MODULE: ../node_modules/@radix-ui/react-portal/dist/index.module.js









/* -------------------------------------------------------------------------------------------------
 * Portal
 * -----------------------------------------------------------------------------------------------*/ const $f1701beae083dbae$var$PORTAL_NAME = 'Portal';
const $f1701beae083dbae$export$602eac185826482c = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    var _globalThis$document;
    const { container: container = globalThis === null || globalThis === void 0 ? void 0 : (_globalThis$document = globalThis.document) === null || _globalThis$document === void 0 ? void 0 : _globalThis$document.body , ...portalProps } = props;
    return container ? /*#__PURE__*/ react_dom.createPortal(/*#__PURE__*/ (0,react.createElement)(react_primitive_dist_index_module_$8927f6f2acc4f386$export$250ffa63cdc0d034.div, (0,esm_extends/* default */.Z)({}, portalProps, {
        ref: forwardedRef
    })), container) : null;
});
/*#__PURE__*/ Object.assign($f1701beae083dbae$export$602eac185826482c, {
    displayName: $f1701beae083dbae$var$PORTAL_NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $f1701beae083dbae$export$be92b6f5f03c0fe9 = (/* unused pure expression or super */ null && ($f1701beae083dbae$export$602eac185826482c));





//# sourceMappingURL=index.module.js.map

;// CONCATENATED MODULE: ../node_modules/@radix-ui/react-dialog/node_modules/@radix-ui/react-presence/dist/index.module.js










function index_module_$fe963b355347cc68$export$3e6543de14f8614f(initialState, machine) {
    return (0,react.useReducer)((state, event)=>{
        const nextState = machine[state][event];
        return nextState !== null && nextState !== void 0 ? nextState : state;
    }, initialState);
}


const index_module_$921a889cee6df7e8$export$99c2b779aa4e8b8b = (props)=>{
    const { present: present , children: children  } = props;
    const presence = index_module_$921a889cee6df7e8$var$usePresence(present);
    const child = typeof children === 'function' ? children({
        present: presence.isPresent
    }) : react.Children.only(children);
    const ref = dist_index_module_$6ed0406888f73fc4$export$c7b2cbe3552a0d05(presence.ref, child.ref);
    const forceMount = typeof children === 'function';
    return forceMount || presence.isPresent ? /*#__PURE__*/ (0,react.cloneElement)(child, {
        ref: ref
    }) : null;
};
index_module_$921a889cee6df7e8$export$99c2b779aa4e8b8b.displayName = 'Presence';
/* -------------------------------------------------------------------------------------------------
 * usePresence
 * -----------------------------------------------------------------------------------------------*/ function index_module_$921a889cee6df7e8$var$usePresence(present) {
    const [node1, setNode] = (0,react.useState)();
    const stylesRef = (0,react.useRef)({});
    const prevPresentRef = (0,react.useRef)(present);
    const prevAnimationNameRef = (0,react.useRef)('none');
    const initialState = present ? 'mounted' : 'unmounted';
    const [state, send] = index_module_$fe963b355347cc68$export$3e6543de14f8614f(initialState, {
        mounted: {
            UNMOUNT: 'unmounted',
            ANIMATION_OUT: 'unmountSuspended'
        },
        unmountSuspended: {
            MOUNT: 'mounted',
            ANIMATION_END: 'unmounted'
        },
        unmounted: {
            MOUNT: 'mounted'
        }
    });
    (0,react.useEffect)(()=>{
        const currentAnimationName = index_module_$921a889cee6df7e8$var$getAnimationName(stylesRef.current);
        prevAnimationNameRef.current = state === 'mounted' ? currentAnimationName : 'none';
    }, [
        state
    ]);
    index_module_$9f79659886946c16$export$e5c5a5f917a5871c(()=>{
        const styles = stylesRef.current;
        const wasPresent = prevPresentRef.current;
        const hasPresentChanged = wasPresent !== present;
        if (hasPresentChanged) {
            const prevAnimationName = prevAnimationNameRef.current;
            const currentAnimationName = index_module_$921a889cee6df7e8$var$getAnimationName(styles);
            if (present) send('MOUNT');
            else if (currentAnimationName === 'none' || (styles === null || styles === void 0 ? void 0 : styles.display) === 'none') // If there is no exit animation or the element is hidden, animations won't run
            // so we unmount instantly
            send('UNMOUNT');
            else {
                /**
         * When `present` changes to `false`, we check changes to animation-name to
         * determine whether an animation has started. We chose this approach (reading
         * computed styles) because there is no `animationrun` event and `animationstart`
         * fires after `animation-delay` has expired which would be too late.
         */ const isAnimating = prevAnimationName !== currentAnimationName;
                if (wasPresent && isAnimating) send('ANIMATION_OUT');
                else send('UNMOUNT');
            }
            prevPresentRef.current = present;
        }
    }, [
        present,
        send
    ]);
    index_module_$9f79659886946c16$export$e5c5a5f917a5871c(()=>{
        if (node1) {
            /**
       * Triggering an ANIMATION_OUT during an ANIMATION_IN will fire an `animationcancel`
       * event for ANIMATION_IN after we have entered `unmountSuspended` state. So, we
       * make sure we only trigger ANIMATION_END for the currently active animation.
       */ const handleAnimationEnd = (event)=>{
                const currentAnimationName = index_module_$921a889cee6df7e8$var$getAnimationName(stylesRef.current);
                const isCurrentAnimation = currentAnimationName.includes(event.animationName);
                if (event.target === node1 && isCurrentAnimation) // With React 18 concurrency this update is applied
                // a frame after the animation ends, creating a flash of visible content.
                // By manually flushing we ensure they sync within a frame, removing the flash.
                (0,react_dom.flushSync)(()=>send('ANIMATION_END')
                );
            };
            const handleAnimationStart = (event)=>{
                if (event.target === node1) // if animation occurred, store its name as the previous animation.
                prevAnimationNameRef.current = index_module_$921a889cee6df7e8$var$getAnimationName(stylesRef.current);
            };
            node1.addEventListener('animationstart', handleAnimationStart);
            node1.addEventListener('animationcancel', handleAnimationEnd);
            node1.addEventListener('animationend', handleAnimationEnd);
            return ()=>{
                node1.removeEventListener('animationstart', handleAnimationStart);
                node1.removeEventListener('animationcancel', handleAnimationEnd);
                node1.removeEventListener('animationend', handleAnimationEnd);
            };
        } else // Transition to the unmounted state if the node is removed prematurely.
        // We avoid doing so during cleanup as the node may change but still exist.
        send('ANIMATION_END');
    }, [
        node1,
        send
    ]);
    return {
        isPresent: [
            'mounted',
            'unmountSuspended'
        ].includes(state),
        ref: (0,react.useCallback)((node)=>{
            if (node) stylesRef.current = getComputedStyle(node);
            setNode(node);
        }, [])
    };
}
/* -----------------------------------------------------------------------------------------------*/ function index_module_$921a889cee6df7e8$var$getAnimationName(styles) {
    return (styles === null || styles === void 0 ? void 0 : styles.animationName) || 'none';
}





//# sourceMappingURL=index.module.js.map

;// CONCATENATED MODULE: ../node_modules/@radix-ui/react-dialog/node_modules/@radix-ui/react-primitive/dist/index.module.js









const _radix_ui_react_primitive_dist_index_module_$8927f6f2acc4f386$var$NODES = [
    'a',
    'button',
    'div',
    'h2',
    'h3',
    'img',
    'label',
    'li',
    'nav',
    'ol',
    'p',
    'span',
    'svg',
    'ul'
]; // Temporary while we await merge of this fix:
// https://github.com/DefinitelyTyped/DefinitelyTyped/pull/55396
// prettier-ignore
/* -------------------------------------------------------------------------------------------------
 * Primitive
 * -----------------------------------------------------------------------------------------------*/ const _radix_ui_react_primitive_dist_index_module_$8927f6f2acc4f386$export$250ffa63cdc0d034 = _radix_ui_react_primitive_dist_index_module_$8927f6f2acc4f386$var$NODES.reduce((primitive, node)=>{
    const Node = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
        const { asChild: asChild , ...primitiveProps } = props;
        const Comp = asChild ? $5e63c961fc1ce211$export$8c6ed5c666ac1360 : node;
        (0,react.useEffect)(()=>{
            window[Symbol.for('radix-ui')] = true;
        }, []);
        return /*#__PURE__*/ (0,react.createElement)(Comp, (0,esm_extends/* default */.Z)({}, primitiveProps, {
            ref: forwardedRef
        }));
    });
    Node.displayName = `Primitive.${node}`;
    return {
        ...primitive,
        [node]: Node
    };
}, {});
/* -------------------------------------------------------------------------------------------------
 * Utils
 * -----------------------------------------------------------------------------------------------*/ /**
 * Flush custom event dispatch
 * https://github.com/radix-ui/primitives/pull/1378
 *
 * React batches *all* event handlers since version 18, this introduces certain considerations when using custom event types.
 *
 * Internally, React prioritises events in the following order:
 *  - discrete
 *  - continuous
 *  - default
 *
 * https://github.com/facebook/react/blob/a8a4742f1c54493df00da648a3f9d26e3db9c8b5/packages/react-dom/src/events/ReactDOMEventListener.js#L294-L350
 *
 * `discrete` is an  important distinction as updates within these events are applied immediately.
 * React however, is not able to infer the priority of custom event types due to how they are detected internally.
 * Because of this, it's possible for updates from custom events to be unexpectedly batched when
 * dispatched by another `discrete` event.
 *
 * In order to ensure that updates from custom events are applied predictably, we need to manually flush the batch.
 * This utility should be used when dispatching a custom event from within another `discrete` event, this utility
 * is not nessesary when dispatching known event types, or if dispatching a custom type inside a non-discrete event.
 * For example:
 *
 * dispatching a known click 👎
 * target.dispatchEvent(new Event(‘click’))
 *
 * dispatching a custom type within a non-discrete event 👎
 * onScroll={(event) => event.target.dispatchEvent(new CustomEvent(‘customType’))}
 *
 * dispatching a custom type within a `discrete` event 👍
 * onPointerDown={(event) => dispatchDiscreteCustomEvent(event.target, new CustomEvent(‘customType’))}
 *
 * Note: though React classifies `focus`, `focusin` and `focusout` events as `discrete`, it's  not recommended to use
 * this utility with them. This is because it's possible for those handlers to be called implicitly during render
 * e.g. when focus is within a component as it is unmounted, or when managing focus on mount.
 */ function _radix_ui_react_primitive_dist_index_module_$8927f6f2acc4f386$export$6d1a0317bde7de7f(target, event) {
    if (target) $4q5Fq$flushSync(()=>target.dispatchEvent(event)
    );
}
/* -----------------------------------------------------------------------------------------------*/ const _radix_ui_react_primitive_dist_index_module_$8927f6f2acc4f386$export$be92b6f5f03c0fe9 = (/* unused pure expression or super */ null && (_radix_ui_react_primitive_dist_index_module_$8927f6f2acc4f386$export$250ffa63cdc0d034));





//# sourceMappingURL=index.module.js.map

;// CONCATENATED MODULE: ../node_modules/@radix-ui/react-focus-guards/dist/index.module.js



/** Number of components which have requested interest to have focus guards */ let $3db38b7d1fb3fe6a$var$count = 0;
function $3db38b7d1fb3fe6a$export$ac5b58043b79449b(props) {
    $3db38b7d1fb3fe6a$export$b7ece24a22aeda8c();
    return props.children;
}
/**
 * Injects a pair of focus guards at the edges of the whole DOM tree
 * to ensure `focusin` & `focusout` events can be caught consistently.
 */ function $3db38b7d1fb3fe6a$export$b7ece24a22aeda8c() {
    (0,react.useEffect)(()=>{
        var _edgeGuards$, _edgeGuards$2;
        const edgeGuards = document.querySelectorAll('[data-radix-focus-guard]');
        document.body.insertAdjacentElement('afterbegin', (_edgeGuards$ = edgeGuards[0]) !== null && _edgeGuards$ !== void 0 ? _edgeGuards$ : $3db38b7d1fb3fe6a$var$createFocusGuard());
        document.body.insertAdjacentElement('beforeend', (_edgeGuards$2 = edgeGuards[1]) !== null && _edgeGuards$2 !== void 0 ? _edgeGuards$2 : $3db38b7d1fb3fe6a$var$createFocusGuard());
        $3db38b7d1fb3fe6a$var$count++;
        return ()=>{
            if ($3db38b7d1fb3fe6a$var$count === 1) document.querySelectorAll('[data-radix-focus-guard]').forEach((node)=>node.remove()
            );
            $3db38b7d1fb3fe6a$var$count--;
        };
    }, []);
}
function $3db38b7d1fb3fe6a$var$createFocusGuard() {
    const element = document.createElement('span');
    element.setAttribute('data-radix-focus-guard', '');
    element.tabIndex = 0;
    element.style.cssText = 'outline: none; opacity: 0; position: fixed; pointer-events: none';
    return element;
}
const $3db38b7d1fb3fe6a$export$be92b6f5f03c0fe9 = (/* unused pure expression or super */ null && ($3db38b7d1fb3fe6a$export$ac5b58043b79449b));





//# sourceMappingURL=index.module.js.map

// EXTERNAL MODULE: ../node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(59312);
;// CONCATENATED MODULE: ../node_modules/react-remove-scroll-bar/dist/es2015/constants.js
var zeroRightClassName = 'right-scroll-bar-position';
var fullWidthClassName = 'width-before-scroll-bar';
var noScrollbarsClassName = 'with-scroll-bars-hidden';
/**
 * Name of a CSS variable containing the amount of "hidden" scrollbar
 * ! might be undefined ! use will fallback!
 */
var removedBarSizeVariable = '--removed-body-scroll-bar-size';

;// CONCATENATED MODULE: ../node_modules/use-callback-ref/dist/es2015/assignRef.js
/**
 * Assigns a value for a given ref, no matter of the ref format
 * @param {RefObject} ref - a callback function or ref object
 * @param value - a new value
 *
 * @see https://github.com/theKashey/use-callback-ref#assignref
 * @example
 * const refObject = useRef();
 * const refFn = (ref) => {....}
 *
 * assignRef(refObject, "refValue");
 * assignRef(refFn, "refValue");
 */
function assignRef_assignRef(ref, value) {
    if (typeof ref === 'function') {
        ref(value);
    }
    else if (ref) {
        ref.current = value;
    }
    return ref;
}

;// CONCATENATED MODULE: ../node_modules/use-callback-ref/dist/es2015/useRef.js

/**
 * creates a MutableRef with ref change callback
 * @param initialValue - initial ref value
 * @param {Function} callback - a callback to run when value changes
 *
 * @example
 * const ref = useCallbackRef(0, (newValue, oldValue) => console.log(oldValue, '->', newValue);
 * ref.current = 1;
 * // prints 0 -> 1
 *
 * @see https://reactjs.org/docs/hooks-reference.html#useref
 * @see https://github.com/theKashey/use-callback-ref#usecallbackref---to-replace-reactuseref
 * @returns {MutableRefObject}
 */
function useCallbackRef(initialValue, callback) {
    var ref = (0,react.useState)(function () { return ({
        // value
        value: initialValue,
        // last callback
        callback: callback,
        // "memoized" public interface
        facade: {
            get current() {
                return ref.value;
            },
            set current(value) {
                var last = ref.value;
                if (last !== value) {
                    ref.value = value;
                    ref.callback(value, last);
                }
            },
        },
    }); })[0];
    // update callback
    ref.callback = callback;
    return ref.facade;
}

;// CONCATENATED MODULE: ../node_modules/use-callback-ref/dist/es2015/useMergeRef.js



var useMergeRef_useIsomorphicLayoutEffect = typeof window !== 'undefined' ? react.useLayoutEffect : react.useEffect;
var currentValues = new WeakMap();
/**
 * Merges two or more refs together providing a single interface to set their value
 * @param {RefObject|Ref} refs
 * @returns {MutableRefObject} - a new ref, which translates all changes to {refs}
 *
 * @see {@link mergeRefs} a version without buit-in memoization
 * @see https://github.com/theKashey/use-callback-ref#usemergerefs
 * @example
 * const Component = React.forwardRef((props, ref) => {
 *   const ownRef = useRef();
 *   const domRef = useMergeRefs([ref, ownRef]); // 👈 merge together
 *   return <div ref={domRef}>...</div>
 * }
 */
function useMergeRefs(refs, defaultValue) {
    var callbackRef = useCallbackRef(defaultValue || null, function (newValue) {
        return refs.forEach(function (ref) { return assignRef_assignRef(ref, newValue); });
    });
    // handle refs changes - added or removed
    useMergeRef_useIsomorphicLayoutEffect(function () {
        var oldValue = currentValues.get(callbackRef);
        if (oldValue) {
            var prevRefs_1 = new Set(oldValue);
            var nextRefs_1 = new Set(refs);
            var current_1 = callbackRef.current;
            prevRefs_1.forEach(function (ref) {
                if (!nextRefs_1.has(ref)) {
                    assignRef_assignRef(ref, null);
                }
            });
            nextRefs_1.forEach(function (ref) {
                if (!prevRefs_1.has(ref)) {
                    assignRef_assignRef(ref, current_1);
                }
            });
        }
        currentValues.set(callbackRef, refs);
    }, [refs]);
    return callbackRef;
}

;// CONCATENATED MODULE: ../node_modules/use-sidecar/dist/es2015/medium.js

function ItoI(a) {
    return a;
}
function innerCreateMedium(defaults, middleware) {
    if (middleware === void 0) { middleware = ItoI; }
    var buffer = [];
    var assigned = false;
    var medium = {
        read: function () {
            if (assigned) {
                throw new Error('Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.');
            }
            if (buffer.length) {
                return buffer[buffer.length - 1];
            }
            return defaults;
        },
        useMedium: function (data) {
            var item = middleware(data, assigned);
            buffer.push(item);
            return function () {
                buffer = buffer.filter(function (x) { return x !== item; });
            };
        },
        assignSyncMedium: function (cb) {
            assigned = true;
            while (buffer.length) {
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
            }
            buffer = {
                push: function (x) { return cb(x); },
                filter: function () { return buffer; },
            };
        },
        assignMedium: function (cb) {
            assigned = true;
            var pendingQueue = [];
            if (buffer.length) {
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
                pendingQueue = buffer;
            }
            var executeQueue = function () {
                var cbs = pendingQueue;
                pendingQueue = [];
                cbs.forEach(cb);
            };
            var cycle = function () { return Promise.resolve().then(executeQueue); };
            cycle();
            buffer = {
                push: function (x) {
                    pendingQueue.push(x);
                    cycle();
                },
                filter: function (filter) {
                    pendingQueue = pendingQueue.filter(filter);
                    return buffer;
                },
            };
        },
    };
    return medium;
}
function createMedium(defaults, middleware) {
    if (middleware === void 0) { middleware = ItoI; }
    return innerCreateMedium(defaults, middleware);
}
// eslint-disable-next-line @typescript-eslint/ban-types
function createSidecarMedium(options) {
    if (options === void 0) { options = {}; }
    var medium = innerCreateMedium(null);
    medium.options = (0,tslib_es6.__assign)({ async: true, ssr: false }, options);
    return medium;
}

;// CONCATENATED MODULE: ../node_modules/react-remove-scroll/dist/es2015/medium.js

var effectCar = createSidecarMedium();

;// CONCATENATED MODULE: ../node_modules/react-remove-scroll/dist/es2015/UI.js





var nothing = function () {
    return;
};
/**
 * Removes scrollbar from the page and contain the scroll within the Lock
 */
var RemoveScroll = react.forwardRef(function (props, parentRef) {
    var ref = react.useRef(null);
    var _a = react.useState({
        onScrollCapture: nothing,
        onWheelCapture: nothing,
        onTouchMoveCapture: nothing,
    }), callbacks = _a[0], setCallbacks = _a[1];
    var forwardProps = props.forwardProps, children = props.children, className = props.className, removeScrollBar = props.removeScrollBar, enabled = props.enabled, shards = props.shards, sideCar = props.sideCar, noIsolation = props.noIsolation, inert = props.inert, allowPinchZoom = props.allowPinchZoom, _b = props.as, Container = _b === void 0 ? 'div' : _b, rest = (0,tslib_es6.__rest)(props, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as"]);
    var SideCar = sideCar;
    var containerRef = useMergeRefs([ref, parentRef]);
    var containerProps = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, rest), callbacks);
    return (react.createElement(react.Fragment, null,
        enabled && (react.createElement(SideCar, { sideCar: effectCar, removeScrollBar: removeScrollBar, shards: shards, noIsolation: noIsolation, inert: inert, setCallbacks: setCallbacks, allowPinchZoom: !!allowPinchZoom, lockRef: ref })),
        forwardProps ? (react.cloneElement(react.Children.only(children), (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, containerProps), { ref: containerRef }))) : (react.createElement(Container, (0,tslib_es6.__assign)({}, containerProps, { className: className, ref: containerRef }), children))));
});
RemoveScroll.defaultProps = {
    enabled: true,
    removeScrollBar: true,
    inert: false,
};
RemoveScroll.classNames = {
    fullWidth: fullWidthClassName,
    zeroRight: zeroRightClassName,
};


;// CONCATENATED MODULE: ../node_modules/use-sidecar/dist/es2015/exports.js


var SideCar = function (_a) {
    var sideCar = _a.sideCar, rest = (0,tslib_es6.__rest)(_a, ["sideCar"]);
    if (!sideCar) {
        throw new Error('Sidecar: please provide `sideCar` property to import the right car');
    }
    var Target = sideCar.read();
    if (!Target) {
        throw new Error('Sidecar medium not found');
    }
    return react.createElement(Target, (0,tslib_es6.__assign)({}, rest));
};
SideCar.isSideCarExport = true;
function exportSidecar(medium, exported) {
    medium.useMedium(exported);
    return SideCar;
}

;// CONCATENATED MODULE: ../node_modules/get-nonce/dist/es2015/index.js
var currentNonce;
var setNonce = function (nonce) {
    currentNonce = nonce;
};
var getNonce = function () {
    if (currentNonce) {
        return currentNonce;
    }
    if (true) {
        return __webpack_require__.nc;
    }
    return undefined;
};

;// CONCATENATED MODULE: ../node_modules/react-style-singleton/dist/es2015/singleton.js

function makeStyleTag() {
    if (!document)
        return null;
    var tag = document.createElement('style');
    tag.type = 'text/css';
    var nonce = getNonce();
    if (nonce) {
        tag.setAttribute('nonce', nonce);
    }
    return tag;
}
function injectStyles(tag, css) {
    // @ts-ignore
    if (tag.styleSheet) {
        // @ts-ignore
        tag.styleSheet.cssText = css;
    }
    else {
        tag.appendChild(document.createTextNode(css));
    }
}
function insertStyleTag(tag) {
    var head = document.head || document.getElementsByTagName('head')[0];
    head.appendChild(tag);
}
var stylesheetSingleton = function () {
    var counter = 0;
    var stylesheet = null;
    return {
        add: function (style) {
            if (counter == 0) {
                if ((stylesheet = makeStyleTag())) {
                    injectStyles(stylesheet, style);
                    insertStyleTag(stylesheet);
                }
            }
            counter++;
        },
        remove: function () {
            counter--;
            if (!counter && stylesheet) {
                stylesheet.parentNode && stylesheet.parentNode.removeChild(stylesheet);
                stylesheet = null;
            }
        },
    };
};

;// CONCATENATED MODULE: ../node_modules/react-style-singleton/dist/es2015/hook.js


/**
 * creates a hook to control style singleton
 * @see {@link styleSingleton} for a safer component version
 * @example
 * ```tsx
 * const useStyle = styleHookSingleton();
 * ///
 * useStyle('body { overflow: hidden}');
 */
var styleHookSingleton = function () {
    var sheet = stylesheetSingleton();
    return function (styles, isDynamic) {
        react.useEffect(function () {
            sheet.add(styles);
            return function () {
                sheet.remove();
            };
        }, [styles && isDynamic]);
    };
};

;// CONCATENATED MODULE: ../node_modules/react-style-singleton/dist/es2015/component.js

/**
 * create a Component to add styles on demand
 * - styles are added when first instance is mounted
 * - styles are removed when the last instance is unmounted
 * - changing styles in runtime does nothing unless dynamic is set. But with multiple components that can lead to the undefined behavior
 */
var styleSingleton = function () {
    var useStyle = styleHookSingleton();
    var Sheet = function (_a) {
        var styles = _a.styles, dynamic = _a.dynamic;
        useStyle(styles, dynamic);
        return null;
    };
    return Sheet;
};

;// CONCATENATED MODULE: ../node_modules/react-style-singleton/dist/es2015/index.js




;// CONCATENATED MODULE: ../node_modules/react-remove-scroll-bar/dist/es2015/utils.js
var zeroGap = {
    left: 0,
    top: 0,
    right: 0,
    gap: 0,
};
var parse = function (x) { return parseInt(x || '', 10) || 0; };
var getOffset = function (gapMode) {
    var cs = window.getComputedStyle(document.body);
    var left = cs[gapMode === 'padding' ? 'paddingLeft' : 'marginLeft'];
    var top = cs[gapMode === 'padding' ? 'paddingTop' : 'marginTop'];
    var right = cs[gapMode === 'padding' ? 'paddingRight' : 'marginRight'];
    return [parse(left), parse(top), parse(right)];
};
var getGapWidth = function (gapMode) {
    if (gapMode === void 0) { gapMode = 'margin'; }
    if (typeof window === 'undefined') {
        return zeroGap;
    }
    var offsets = getOffset(gapMode);
    var documentWidth = document.documentElement.clientWidth;
    var windowWidth = window.innerWidth;
    return {
        left: offsets[0],
        top: offsets[1],
        right: offsets[2],
        gap: Math.max(0, windowWidth - documentWidth + offsets[2] - offsets[0]),
    };
};

;// CONCATENATED MODULE: ../node_modules/react-remove-scroll-bar/dist/es2015/component.js




var Style = styleSingleton();
var lockAttribute = 'data-scroll-locked';
// important tip - once we measure scrollBar width and remove them
// we could not repeat this operation
// thus we are using style-singleton - only the first "yet correct" style will be applied.
var getStyles = function (_a, allowRelative, gapMode, important) {
    var left = _a.left, top = _a.top, right = _a.right, gap = _a.gap;
    if (gapMode === void 0) { gapMode = 'margin'; }
    return "\n  .".concat(noScrollbarsClassName, " {\n   overflow: hidden ").concat(important, ";\n   padding-right: ").concat(gap, "px ").concat(important, ";\n  }\n  body[").concat(lockAttribute, "] {\n    overflow: hidden ").concat(important, ";\n    overscroll-behavior: contain;\n    ").concat([
        allowRelative && "position: relative ".concat(important, ";"),
        gapMode === 'margin' &&
            "\n    padding-left: ".concat(left, "px;\n    padding-top: ").concat(top, "px;\n    padding-right: ").concat(right, "px;\n    margin-left:0;\n    margin-top:0;\n    margin-right: ").concat(gap, "px ").concat(important, ";\n    "),
        gapMode === 'padding' && "padding-right: ".concat(gap, "px ").concat(important, ";"),
    ]
        .filter(Boolean)
        .join(''), "\n  }\n  \n  .").concat(zeroRightClassName, " {\n    right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat(fullWidthClassName, " {\n    margin-right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat(zeroRightClassName, " .").concat(zeroRightClassName, " {\n    right: 0 ").concat(important, ";\n  }\n  \n  .").concat(fullWidthClassName, " .").concat(fullWidthClassName, " {\n    margin-right: 0 ").concat(important, ";\n  }\n  \n  body[").concat(lockAttribute, "] {\n    ").concat(removedBarSizeVariable, ": ").concat(gap, "px;\n  }\n");
};
var getCurrentUseCounter = function () {
    var counter = parseInt(document.body.getAttribute(lockAttribute) || '0', 10);
    return isFinite(counter) ? counter : 0;
};
var useLockAttribute = function () {
    react.useEffect(function () {
        document.body.setAttribute(lockAttribute, (getCurrentUseCounter() + 1).toString());
        return function () {
            var newCounter = getCurrentUseCounter() - 1;
            if (newCounter <= 0) {
                document.body.removeAttribute(lockAttribute);
            }
            else {
                document.body.setAttribute(lockAttribute, newCounter.toString());
            }
        };
    }, []);
};
/**
 * Removes page scrollbar and blocks page scroll when mounted
 */
var RemoveScrollBar = function (_a) {
    var noRelative = _a.noRelative, noImportant = _a.noImportant, _b = _a.gapMode, gapMode = _b === void 0 ? 'margin' : _b;
    useLockAttribute();
    /*
     gap will be measured on every component mount
     however it will be used only by the "first" invocation
     due to singleton nature of <Style
     */
    var gap = react.useMemo(function () { return getGapWidth(gapMode); }, [gapMode]);
    return react.createElement(Style, { styles: getStyles(gap, !noRelative, gapMode, !noImportant ? '!important' : '') });
};

;// CONCATENATED MODULE: ../node_modules/react-remove-scroll-bar/dist/es2015/index.js





;// CONCATENATED MODULE: ../node_modules/react-remove-scroll/dist/es2015/aggresiveCapture.js
var passiveSupported = false;
if (typeof window !== 'undefined') {
    try {
        var options = Object.defineProperty({}, 'passive', {
            get: function () {
                passiveSupported = true;
                return true;
            },
        });
        // @ts-ignore
        window.addEventListener('test', options, options);
        // @ts-ignore
        window.removeEventListener('test', options, options);
    }
    catch (err) {
        passiveSupported = false;
    }
}
var nonPassive = passiveSupported ? { passive: false } : false;

;// CONCATENATED MODULE: ../node_modules/react-remove-scroll/dist/es2015/handleScroll.js
var alwaysContainsScroll = function (node) {
    // textarea will always _contain_ scroll inside self. It only can be hidden
    return node.tagName === 'TEXTAREA';
};
var elementCanBeScrolled = function (node, overflow) {
    var styles = window.getComputedStyle(node);
    return (
    // not-not-scrollable
    styles[overflow] !== 'hidden' &&
        // contains scroll inside self
        !(styles.overflowY === styles.overflowX && !alwaysContainsScroll(node) && styles[overflow] === 'visible'));
};
var elementCouldBeVScrolled = function (node) { return elementCanBeScrolled(node, 'overflowY'); };
var elementCouldBeHScrolled = function (node) { return elementCanBeScrolled(node, 'overflowX'); };
var locationCouldBeScrolled = function (axis, node) {
    var current = node;
    do {
        // Skip over shadow root
        if (typeof ShadowRoot !== 'undefined' && current instanceof ShadowRoot) {
            current = current.host;
        }
        var isScrollable = elementCouldBeScrolled(axis, current);
        if (isScrollable) {
            var _a = getScrollVariables(axis, current), s = _a[1], d = _a[2];
            if (s > d) {
                return true;
            }
        }
        current = current.parentNode;
    } while (current && current !== document.body);
    return false;
};
var getVScrollVariables = function (_a) {
    var scrollTop = _a.scrollTop, scrollHeight = _a.scrollHeight, clientHeight = _a.clientHeight;
    return [
        scrollTop,
        scrollHeight,
        clientHeight,
    ];
};
var getHScrollVariables = function (_a) {
    var scrollLeft = _a.scrollLeft, scrollWidth = _a.scrollWidth, clientWidth = _a.clientWidth;
    return [
        scrollLeft,
        scrollWidth,
        clientWidth,
    ];
};
var elementCouldBeScrolled = function (axis, node) {
    return axis === 'v' ? elementCouldBeVScrolled(node) : elementCouldBeHScrolled(node);
};
var getScrollVariables = function (axis, node) {
    return axis === 'v' ? getVScrollVariables(node) : getHScrollVariables(node);
};
var getDirectionFactor = function (axis, direction) {
    /**
     * If the element's direction is rtl (right-to-left), then scrollLeft is 0 when the scrollbar is at its rightmost position,
     * and then increasingly negative as you scroll towards the end of the content.
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollLeft
     */
    return axis === 'h' && direction === 'rtl' ? -1 : 1;
};
var handleScroll = function (axis, endTarget, event, sourceDelta, noOverscroll) {
    var directionFactor = getDirectionFactor(axis, window.getComputedStyle(endTarget).direction);
    var delta = directionFactor * sourceDelta;
    // find scrollable target
    var target = event.target;
    var targetInLock = endTarget.contains(target);
    var shouldCancelScroll = false;
    var isDeltaPositive = delta > 0;
    var availableScroll = 0;
    var availableScrollTop = 0;
    do {
        var _a = getScrollVariables(axis, target), position = _a[0], scroll_1 = _a[1], capacity = _a[2];
        var elementScroll = scroll_1 - capacity - directionFactor * position;
        if (position || elementScroll) {
            if (elementCouldBeScrolled(axis, target)) {
                availableScroll += elementScroll;
                availableScrollTop += position;
            }
        }
        target = target.parentNode;
    } while (
    // portaled content
    (!targetInLock && target !== document.body) ||
        // self content
        (targetInLock && (endTarget.contains(target) || endTarget === target)));
    if (isDeltaPositive && ((noOverscroll && availableScroll === 0) || (!noOverscroll && delta > availableScroll))) {
        shouldCancelScroll = true;
    }
    else if (!isDeltaPositive &&
        ((noOverscroll && availableScrollTop === 0) || (!noOverscroll && -delta > availableScrollTop))) {
        shouldCancelScroll = true;
    }
    return shouldCancelScroll;
};

;// CONCATENATED MODULE: ../node_modules/react-remove-scroll/dist/es2015/SideEffect.js






var getTouchXY = function (event) {
    return 'changedTouches' in event ? [event.changedTouches[0].clientX, event.changedTouches[0].clientY] : [0, 0];
};
var getDeltaXY = function (event) { return [event.deltaX, event.deltaY]; };
var extractRef = function (ref) {
    return ref && 'current' in ref ? ref.current : ref;
};
var deltaCompare = function (x, y) { return x[0] === y[0] && x[1] === y[1]; };
var generateStyle = function (id) { return "\n  .block-interactivity-".concat(id, " {pointer-events: none;}\n  .allow-interactivity-").concat(id, " {pointer-events: all;}\n"); };
var idCounter = 0;
var lockStack = [];
function RemoveScrollSideCar(props) {
    var shouldPreventQueue = react.useRef([]);
    var touchStartRef = react.useRef([0, 0]);
    var activeAxis = react.useRef();
    var id = react.useState(idCounter++)[0];
    var Style = react.useState(function () { return styleSingleton(); })[0];
    var lastProps = react.useRef(props);
    react.useEffect(function () {
        lastProps.current = props;
    }, [props]);
    react.useEffect(function () {
        if (props.inert) {
            document.body.classList.add("block-interactivity-".concat(id));
            var allow_1 = (0,tslib_es6.__spreadArray)([props.lockRef.current], (props.shards || []).map(extractRef), true).filter(Boolean);
            allow_1.forEach(function (el) { return el.classList.add("allow-interactivity-".concat(id)); });
            return function () {
                document.body.classList.remove("block-interactivity-".concat(id));
                allow_1.forEach(function (el) { return el.classList.remove("allow-interactivity-".concat(id)); });
            };
        }
        return;
    }, [props.inert, props.lockRef.current, props.shards]);
    var shouldCancelEvent = react.useCallback(function (event, parent) {
        if ('touches' in event && event.touches.length === 2) {
            return !lastProps.current.allowPinchZoom;
        }
        var touch = getTouchXY(event);
        var touchStart = touchStartRef.current;
        var deltaX = 'deltaX' in event ? event.deltaX : touchStart[0] - touch[0];
        var deltaY = 'deltaY' in event ? event.deltaY : touchStart[1] - touch[1];
        var currentAxis;
        var target = event.target;
        var moveDirection = Math.abs(deltaX) > Math.abs(deltaY) ? 'h' : 'v';
        // allow horizontal touch move on Range inputs. They will not cause any scroll
        if ('touches' in event && moveDirection === 'h' && target.type === 'range') {
            return false;
        }
        var canBeScrolledInMainDirection = locationCouldBeScrolled(moveDirection, target);
        if (!canBeScrolledInMainDirection) {
            return true;
        }
        if (canBeScrolledInMainDirection) {
            currentAxis = moveDirection;
        }
        else {
            currentAxis = moveDirection === 'v' ? 'h' : 'v';
            canBeScrolledInMainDirection = locationCouldBeScrolled(moveDirection, target);
            // other axis might be not scrollable
        }
        if (!canBeScrolledInMainDirection) {
            return false;
        }
        if (!activeAxis.current && 'changedTouches' in event && (deltaX || deltaY)) {
            activeAxis.current = currentAxis;
        }
        if (!currentAxis) {
            return true;
        }
        var cancelingAxis = activeAxis.current || currentAxis;
        return handleScroll(cancelingAxis, parent, event, cancelingAxis === 'h' ? deltaX : deltaY, true);
    }, []);
    var shouldPrevent = react.useCallback(function (_event) {
        var event = _event;
        if (!lockStack.length || lockStack[lockStack.length - 1] !== Style) {
            // not the last active
            return;
        }
        var delta = 'deltaY' in event ? getDeltaXY(event) : getTouchXY(event);
        var sourceEvent = shouldPreventQueue.current.filter(function (e) { return e.name === event.type && e.target === event.target && deltaCompare(e.delta, delta); })[0];
        // self event, and should be canceled
        if (sourceEvent && sourceEvent.should) {
            if (event.cancelable) {
                event.preventDefault();
            }
            return;
        }
        // outside or shard event
        if (!sourceEvent) {
            var shardNodes = (lastProps.current.shards || [])
                .map(extractRef)
                .filter(Boolean)
                .filter(function (node) { return node.contains(event.target); });
            var shouldStop = shardNodes.length > 0 ? shouldCancelEvent(event, shardNodes[0]) : !lastProps.current.noIsolation;
            if (shouldStop) {
                if (event.cancelable) {
                    event.preventDefault();
                }
            }
        }
    }, []);
    var shouldCancel = react.useCallback(function (name, delta, target, should) {
        var event = { name: name, delta: delta, target: target, should: should };
        shouldPreventQueue.current.push(event);
        setTimeout(function () {
            shouldPreventQueue.current = shouldPreventQueue.current.filter(function (e) { return e !== event; });
        }, 1);
    }, []);
    var scrollTouchStart = react.useCallback(function (event) {
        touchStartRef.current = getTouchXY(event);
        activeAxis.current = undefined;
    }, []);
    var scrollWheel = react.useCallback(function (event) {
        shouldCancel(event.type, getDeltaXY(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    var scrollTouchMove = react.useCallback(function (event) {
        shouldCancel(event.type, getTouchXY(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    react.useEffect(function () {
        lockStack.push(Style);
        props.setCallbacks({
            onScrollCapture: scrollWheel,
            onWheelCapture: scrollWheel,
            onTouchMoveCapture: scrollTouchMove,
        });
        document.addEventListener('wheel', shouldPrevent, nonPassive);
        document.addEventListener('touchmove', shouldPrevent, nonPassive);
        document.addEventListener('touchstart', scrollTouchStart, nonPassive);
        return function () {
            lockStack = lockStack.filter(function (inst) { return inst !== Style; });
            document.removeEventListener('wheel', shouldPrevent, nonPassive);
            document.removeEventListener('touchmove', shouldPrevent, nonPassive);
            document.removeEventListener('touchstart', scrollTouchStart, nonPassive);
        };
    }, []);
    var removeScrollBar = props.removeScrollBar, inert = props.inert;
    return (react.createElement(react.Fragment, null,
        inert ? react.createElement(Style, { styles: generateStyle(id) }) : null,
        removeScrollBar ? react.createElement(RemoveScrollBar, { gapMode: "margin" }) : null));
}

;// CONCATENATED MODULE: ../node_modules/react-remove-scroll/dist/es2015/sidecar.js



/* harmony default export */ var sidecar = (exportSidecar(effectCar, RemoveScrollSideCar));

;// CONCATENATED MODULE: ../node_modules/react-remove-scroll/dist/es2015/Combination.js




var ReactRemoveScroll = react.forwardRef(function (props, ref) { return (react.createElement(RemoveScroll, (0,tslib_es6.__assign)({}, props, { ref: ref, sideCar: sidecar }))); });
ReactRemoveScroll.classNames = RemoveScroll.classNames;
/* harmony default export */ var Combination = (ReactRemoveScroll);

;// CONCATENATED MODULE: ../node_modules/aria-hidden/dist/es2015/index.js
var getDefaultParent = function (originalTarget) {
    if (typeof document === 'undefined') {
        return null;
    }
    var sampleTarget = Array.isArray(originalTarget) ? originalTarget[0] : originalTarget;
    return sampleTarget.ownerDocument.body;
};
var counterMap = new WeakMap();
var uncontrolledNodes = new WeakMap();
var markerMap = {};
var lockCount = 0;
var unwrapHost = function (node) {
    return node && (node.host || unwrapHost(node.parentNode));
};
var correctTargets = function (parent, targets) {
    return targets
        .map(function (target) {
        if (parent.contains(target)) {
            return target;
        }
        var correctedTarget = unwrapHost(target);
        if (correctedTarget && parent.contains(correctedTarget)) {
            return correctedTarget;
        }
        console.error('aria-hidden', target, 'in not contained inside', parent, '. Doing nothing');
        return null;
    })
        .filter(function (x) { return Boolean(x); });
};
/**
 * Marks everything except given node(or nodes) as aria-hidden
 * @param {Element | Element[]} originalTarget - elements to keep on the page
 * @param [parentNode] - top element, defaults to document.body
 * @param {String} [markerName] - a special attribute to mark every node
 * @param {String} [controlAttribute] - html Attribute to control
 * @return {Undo} undo command
 */
var applyAttributeToOthers = function (originalTarget, parentNode, markerName, controlAttribute) {
    var targets = correctTargets(parentNode, Array.isArray(originalTarget) ? originalTarget : [originalTarget]);
    if (!markerMap[markerName]) {
        markerMap[markerName] = new WeakMap();
    }
    var markerCounter = markerMap[markerName];
    var hiddenNodes = [];
    var elementsToKeep = new Set();
    var elementsToStop = new Set(targets);
    var keep = function (el) {
        if (!el || elementsToKeep.has(el)) {
            return;
        }
        elementsToKeep.add(el);
        keep(el.parentNode);
    };
    targets.forEach(keep);
    var deep = function (parent) {
        if (!parent || elementsToStop.has(parent)) {
            return;
        }
        Array.prototype.forEach.call(parent.children, function (node) {
            if (elementsToKeep.has(node)) {
                deep(node);
            }
            else {
                try {
                    var attr = node.getAttribute(controlAttribute);
                    var alreadyHidden = attr !== null && attr !== 'false';
                    var counterValue = (counterMap.get(node) || 0) + 1;
                    var markerValue = (markerCounter.get(node) || 0) + 1;
                    counterMap.set(node, counterValue);
                    markerCounter.set(node, markerValue);
                    hiddenNodes.push(node);
                    if (counterValue === 1 && alreadyHidden) {
                        uncontrolledNodes.set(node, true);
                    }
                    if (markerValue === 1) {
                        node.setAttribute(markerName, 'true');
                    }
                    if (!alreadyHidden) {
                        node.setAttribute(controlAttribute, 'true');
                    }
                }
                catch (e) {
                    console.error('aria-hidden: cannot operate on ', node, e);
                }
            }
        });
    };
    deep(parentNode);
    elementsToKeep.clear();
    lockCount++;
    return function () {
        hiddenNodes.forEach(function (node) {
            var counterValue = counterMap.get(node) - 1;
            var markerValue = markerCounter.get(node) - 1;
            counterMap.set(node, counterValue);
            markerCounter.set(node, markerValue);
            if (!counterValue) {
                if (!uncontrolledNodes.has(node)) {
                    node.removeAttribute(controlAttribute);
                }
                uncontrolledNodes.delete(node);
            }
            if (!markerValue) {
                node.removeAttribute(markerName);
            }
        });
        lockCount--;
        if (!lockCount) {
            // clear
            counterMap = new WeakMap();
            counterMap = new WeakMap();
            uncontrolledNodes = new WeakMap();
            markerMap = {};
        }
    };
};
/**
 * Marks everything except given node(or nodes) as aria-hidden
 * @param {Element | Element[]} originalTarget - elements to keep on the page
 * @param [parentNode] - top element, defaults to document.body
 * @param {String} [markerName] - a special attribute to mark every node
 * @return {Undo} undo command
 */
var hideOthers = function (originalTarget, parentNode, markerName) {
    if (markerName === void 0) { markerName = 'data-aria-hidden'; }
    var targets = Array.from(Array.isArray(originalTarget) ? originalTarget : [originalTarget]);
    var activeParentNode = parentNode || getDefaultParent(originalTarget);
    if (!activeParentNode) {
        return function () { return null; };
    }
    // we should not hide ariaLive elements - https://github.com/theKashey/aria-hidden/issues/10
    targets.push.apply(targets, Array.from(activeParentNode.querySelectorAll('[aria-live]')));
    return applyAttributeToOthers(targets, activeParentNode, markerName, 'aria-hidden');
};
/**
 * Marks everything except given node(or nodes) as inert
 * @param {Element | Element[]} originalTarget - elements to keep on the page
 * @param [parentNode] - top element, defaults to document.body
 * @param {String} [markerName] - a special attribute to mark every node
 * @return {Undo} undo command
 */
var inertOthers = function (originalTarget, parentNode, markerName) {
    if (markerName === void 0) { markerName = 'data-inert-ed'; }
    var activeParentNode = parentNode || getDefaultParent(originalTarget);
    if (!activeParentNode) {
        return function () { return null; };
    }
    return applyAttributeToOthers(originalTarget, activeParentNode, markerName, 'inert');
};
/**
 * @returns if current browser supports inert
 */
var supportsInert = function () {
    return typeof HTMLElement !== 'undefined' && HTMLElement.prototype.hasOwnProperty('inert');
};
/**
 * Automatic function to "suppress" DOM elements - _hide_ or _inert_ in the best possible way
 * @param {Element | Element[]} originalTarget - elements to keep on the page
 * @param [parentNode] - top element, defaults to document.body
 * @param {String} [markerName] - a special attribute to mark every node
 * @return {Undo} undo command
 */
var suppressOthers = function (originalTarget, parentNode, markerName) {
    if (markerName === void 0) { markerName = 'data-suppressed'; }
    return (supportsInert() ? inertOthers : hideOthers)(originalTarget, parentNode, markerName);
};

;// CONCATENATED MODULE: ../node_modules/@radix-ui/react-dialog/dist/index.module.js

































/* -------------------------------------------------------------------------------------------------
 * Dialog
 * -----------------------------------------------------------------------------------------------*/ const $5d3850c4d0b4e6c7$var$DIALOG_NAME = 'Dialog';
const [$5d3850c4d0b4e6c7$var$createDialogContext, $5d3850c4d0b4e6c7$export$cc702773b8ea3e41] = index_module_$c512c27ab02ef895$export$50c7b4e9d9f19c1($5d3850c4d0b4e6c7$var$DIALOG_NAME);
const [$5d3850c4d0b4e6c7$var$DialogProvider, $5d3850c4d0b4e6c7$var$useDialogContext] = $5d3850c4d0b4e6c7$var$createDialogContext($5d3850c4d0b4e6c7$var$DIALOG_NAME);
const $5d3850c4d0b4e6c7$export$3ddf2d174ce01153 = (props)=>{
    const { __scopeDialog: __scopeDialog , children: children , open: openProp , defaultOpen: defaultOpen , onOpenChange: onOpenChange , modal: modal = true  } = props;
    const triggerRef = (0,react.useRef)(null);
    const contentRef = (0,react.useRef)(null);
    const [open = false, setOpen] = index_module_$71cd76cc60e0454e$export$6f32135080cb4c3({
        prop: openProp,
        defaultProp: defaultOpen,
        onChange: onOpenChange
    });
    return /*#__PURE__*/ (0,react.createElement)($5d3850c4d0b4e6c7$var$DialogProvider, {
        scope: __scopeDialog,
        triggerRef: triggerRef,
        contentRef: contentRef,
        contentId: index_module_$1746a345f3d73bb7$export$f680877a34711e37(),
        titleId: index_module_$1746a345f3d73bb7$export$f680877a34711e37(),
        descriptionId: index_module_$1746a345f3d73bb7$export$f680877a34711e37(),
        open: open,
        onOpenChange: setOpen,
        onOpenToggle: (0,react.useCallback)(()=>setOpen((prevOpen)=>!prevOpen
            )
        , [
            setOpen
        ]),
        modal: modal
    }, children);
};
/*#__PURE__*/ Object.assign($5d3850c4d0b4e6c7$export$3ddf2d174ce01153, {
    displayName: $5d3850c4d0b4e6c7$var$DIALOG_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DialogTrigger
 * -----------------------------------------------------------------------------------------------*/ const $5d3850c4d0b4e6c7$var$TRIGGER_NAME = 'DialogTrigger';
const $5d3850c4d0b4e6c7$export$2e1e1122cf0cba88 = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog , ...triggerProps } = props;
    const context = $5d3850c4d0b4e6c7$var$useDialogContext($5d3850c4d0b4e6c7$var$TRIGGER_NAME, __scopeDialog);
    const composedTriggerRef = dist_index_module_$6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, context.triggerRef);
    return /*#__PURE__*/ (0,react.createElement)(_radix_ui_react_primitive_dist_index_module_$8927f6f2acc4f386$export$250ffa63cdc0d034.button, (0,esm_extends/* default */.Z)({
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": context.open,
        "aria-controls": context.contentId,
        "data-state": $5d3850c4d0b4e6c7$var$getState(context.open)
    }, triggerProps, {
        ref: composedTriggerRef,
        onClick: index_module_$e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onClick, context.onOpenToggle)
    }));
});
/*#__PURE__*/ Object.assign($5d3850c4d0b4e6c7$export$2e1e1122cf0cba88, {
    displayName: $5d3850c4d0b4e6c7$var$TRIGGER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DialogPortal
 * -----------------------------------------------------------------------------------------------*/ const $5d3850c4d0b4e6c7$var$PORTAL_NAME = 'DialogPortal';
const [$5d3850c4d0b4e6c7$var$PortalProvider, $5d3850c4d0b4e6c7$var$usePortalContext] = $5d3850c4d0b4e6c7$var$createDialogContext($5d3850c4d0b4e6c7$var$PORTAL_NAME, {
    forceMount: undefined
});
const $5d3850c4d0b4e6c7$export$dad7c95542bacce0 = (props)=>{
    const { __scopeDialog: __scopeDialog , forceMount: forceMount , children: children , container: container  } = props;
    const context = $5d3850c4d0b4e6c7$var$useDialogContext($5d3850c4d0b4e6c7$var$PORTAL_NAME, __scopeDialog);
    return /*#__PURE__*/ (0,react.createElement)($5d3850c4d0b4e6c7$var$PortalProvider, {
        scope: __scopeDialog,
        forceMount: forceMount
    }, react.Children.map(children, (child)=>/*#__PURE__*/ (0,react.createElement)(index_module_$921a889cee6df7e8$export$99c2b779aa4e8b8b, {
            present: forceMount || context.open
        }, /*#__PURE__*/ (0,react.createElement)($f1701beae083dbae$export$602eac185826482c, {
            asChild: true,
            container: container
        }, child))
    ));
};
/*#__PURE__*/ Object.assign($5d3850c4d0b4e6c7$export$dad7c95542bacce0, {
    displayName: $5d3850c4d0b4e6c7$var$PORTAL_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DialogOverlay
 * -----------------------------------------------------------------------------------------------*/ const $5d3850c4d0b4e6c7$var$OVERLAY_NAME = 'DialogOverlay';
const $5d3850c4d0b4e6c7$export$bd1d06c79be19e17 = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const portalContext = $5d3850c4d0b4e6c7$var$usePortalContext($5d3850c4d0b4e6c7$var$OVERLAY_NAME, props.__scopeDialog);
    const { forceMount: forceMount = portalContext.forceMount , ...overlayProps } = props;
    const context = $5d3850c4d0b4e6c7$var$useDialogContext($5d3850c4d0b4e6c7$var$OVERLAY_NAME, props.__scopeDialog);
    return context.modal ? /*#__PURE__*/ (0,react.createElement)(index_module_$921a889cee6df7e8$export$99c2b779aa4e8b8b, {
        present: forceMount || context.open
    }, /*#__PURE__*/ (0,react.createElement)($5d3850c4d0b4e6c7$var$DialogOverlayImpl, (0,esm_extends/* default */.Z)({}, overlayProps, {
        ref: forwardedRef
    }))) : null;
});
/*#__PURE__*/ Object.assign($5d3850c4d0b4e6c7$export$bd1d06c79be19e17, {
    displayName: $5d3850c4d0b4e6c7$var$OVERLAY_NAME
});
const $5d3850c4d0b4e6c7$var$DialogOverlayImpl = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog , ...overlayProps } = props;
    const context = $5d3850c4d0b4e6c7$var$useDialogContext($5d3850c4d0b4e6c7$var$OVERLAY_NAME, __scopeDialog);
    return(/*#__PURE__*/ // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
    // ie. when `Overlay` and `Content` are siblings
    (0,react.createElement)(Combination, {
        as: $5e63c961fc1ce211$export$8c6ed5c666ac1360,
        allowPinchZoom: true,
        shards: [
            context.contentRef
        ]
    }, /*#__PURE__*/ (0,react.createElement)(_radix_ui_react_primitive_dist_index_module_$8927f6f2acc4f386$export$250ffa63cdc0d034.div, (0,esm_extends/* default */.Z)({
        "data-state": $5d3850c4d0b4e6c7$var$getState(context.open)
    }, overlayProps, {
        ref: forwardedRef // We re-enable pointer-events prevented by `Dialog.Content` to allow scrolling the overlay.
        ,
        style: {
            pointerEvents: 'auto',
            ...overlayProps.style
        }
    }))));
});
/* -------------------------------------------------------------------------------------------------
 * DialogContent
 * -----------------------------------------------------------------------------------------------*/ const $5d3850c4d0b4e6c7$var$CONTENT_NAME = 'DialogContent';
const $5d3850c4d0b4e6c7$export$b6d9565de1e068cf = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const portalContext = $5d3850c4d0b4e6c7$var$usePortalContext($5d3850c4d0b4e6c7$var$CONTENT_NAME, props.__scopeDialog);
    const { forceMount: forceMount = portalContext.forceMount , ...contentProps } = props;
    const context = $5d3850c4d0b4e6c7$var$useDialogContext($5d3850c4d0b4e6c7$var$CONTENT_NAME, props.__scopeDialog);
    return /*#__PURE__*/ (0,react.createElement)(index_module_$921a889cee6df7e8$export$99c2b779aa4e8b8b, {
        present: forceMount || context.open
    }, context.modal ? /*#__PURE__*/ (0,react.createElement)($5d3850c4d0b4e6c7$var$DialogContentModal, (0,esm_extends/* default */.Z)({}, contentProps, {
        ref: forwardedRef
    })) : /*#__PURE__*/ (0,react.createElement)($5d3850c4d0b4e6c7$var$DialogContentNonModal, (0,esm_extends/* default */.Z)({}, contentProps, {
        ref: forwardedRef
    })));
});
/*#__PURE__*/ Object.assign($5d3850c4d0b4e6c7$export$b6d9565de1e068cf, {
    displayName: $5d3850c4d0b4e6c7$var$CONTENT_NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $5d3850c4d0b4e6c7$var$DialogContentModal = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const context = $5d3850c4d0b4e6c7$var$useDialogContext($5d3850c4d0b4e6c7$var$CONTENT_NAME, props.__scopeDialog);
    const contentRef = (0,react.useRef)(null);
    const composedRefs = dist_index_module_$6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, context.contentRef, contentRef); // aria-hide everything except the content (better supported equivalent to setting aria-modal)
    (0,react.useEffect)(()=>{
        const content = contentRef.current;
        if (content) return hideOthers(content);
    }, []);
    return /*#__PURE__*/ (0,react.createElement)($5d3850c4d0b4e6c7$var$DialogContentImpl, (0,esm_extends/* default */.Z)({}, props, {
        ref: composedRefs // we make sure focus isn't trapped once `DialogContent` has been closed
        ,
        trapFocus: context.open,
        disableOutsidePointerEvents: true,
        onCloseAutoFocus: index_module_$e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onCloseAutoFocus, (event)=>{
            var _context$triggerRef$c;
            event.preventDefault();
            (_context$triggerRef$c = context.triggerRef.current) === null || _context$triggerRef$c === void 0 || _context$triggerRef$c.focus();
        }),
        onPointerDownOutside: index_module_$e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onPointerDownOutside, (event)=>{
            const originalEvent = event.detail.originalEvent;
            const ctrlLeftClick = originalEvent.button === 0 && originalEvent.ctrlKey === true;
            const isRightClick = originalEvent.button === 2 || ctrlLeftClick; // If the event is a right-click, we shouldn't close because
            // it is effectively as if we right-clicked the `Overlay`.
            if (isRightClick) event.preventDefault();
        }) // When focus is trapped, a `focusout` event may still happen.
        ,
        onFocusOutside: index_module_$e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onFocusOutside, (event)=>event.preventDefault()
        )
    }));
});
/* -----------------------------------------------------------------------------------------------*/ const $5d3850c4d0b4e6c7$var$DialogContentNonModal = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const context = $5d3850c4d0b4e6c7$var$useDialogContext($5d3850c4d0b4e6c7$var$CONTENT_NAME, props.__scopeDialog);
    const hasInteractedOutsideRef = (0,react.useRef)(false);
    return /*#__PURE__*/ (0,react.createElement)($5d3850c4d0b4e6c7$var$DialogContentImpl, (0,esm_extends/* default */.Z)({}, props, {
        ref: forwardedRef,
        trapFocus: false,
        disableOutsidePointerEvents: false,
        onCloseAutoFocus: (event)=>{
            var _props$onCloseAutoFoc;
            (_props$onCloseAutoFoc = props.onCloseAutoFocus) === null || _props$onCloseAutoFoc === void 0 || _props$onCloseAutoFoc.call(props, event);
            if (!event.defaultPrevented) {
                var _context$triggerRef$c2;
                if (!hasInteractedOutsideRef.current) (_context$triggerRef$c2 = context.triggerRef.current) === null || _context$triggerRef$c2 === void 0 || _context$triggerRef$c2.focus(); // Always prevent auto focus because we either focus manually or want user agent focus
                event.preventDefault();
            }
            hasInteractedOutsideRef.current = false;
        },
        onInteractOutside: (event)=>{
            var _props$onInteractOuts, _context$triggerRef$c3;
            (_props$onInteractOuts = props.onInteractOutside) === null || _props$onInteractOuts === void 0 || _props$onInteractOuts.call(props, event);
            if (!event.defaultPrevented) hasInteractedOutsideRef.current = true; // Prevent dismissing when clicking the trigger.
            // As the trigger is already setup to close, without doing so would
            // cause it to close and immediately open.
            //
            // We use `onInteractOutside` as some browsers also
            // focus on pointer down, creating the same issue.
            const target = event.target;
            const targetIsTrigger = (_context$triggerRef$c3 = context.triggerRef.current) === null || _context$triggerRef$c3 === void 0 ? void 0 : _context$triggerRef$c3.contains(target);
            if (targetIsTrigger) event.preventDefault();
        }
    }));
});
/* -----------------------------------------------------------------------------------------------*/ const $5d3850c4d0b4e6c7$var$DialogContentImpl = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog , trapFocus: trapFocus , onOpenAutoFocus: onOpenAutoFocus , onCloseAutoFocus: onCloseAutoFocus , ...contentProps } = props;
    const context = $5d3850c4d0b4e6c7$var$useDialogContext($5d3850c4d0b4e6c7$var$CONTENT_NAME, __scopeDialog);
    const contentRef = (0,react.useRef)(null);
    const composedRefs = dist_index_module_$6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, contentRef); // Make sure the whole tree has focus guards as our `Dialog` will be
    // the last element in the DOM (beacuse of the `Portal`)
    $3db38b7d1fb3fe6a$export$b7ece24a22aeda8c();
    return /*#__PURE__*/ (0,react.createElement)(react.Fragment, null, /*#__PURE__*/ (0,react.createElement)($d3863c46a17e8a28$export$20e40289641fbbb6, {
        asChild: true,
        loop: true,
        trapped: trapFocus,
        onMountAutoFocus: onOpenAutoFocus,
        onUnmountAutoFocus: onCloseAutoFocus
    }, /*#__PURE__*/ (0,react.createElement)($5cb92bef7577960e$export$177fb62ff3ec1f22, (0,esm_extends/* default */.Z)({
        role: "dialog",
        id: context.contentId,
        "aria-describedby": context.descriptionId,
        "aria-labelledby": context.titleId,
        "data-state": $5d3850c4d0b4e6c7$var$getState(context.open)
    }, contentProps, {
        ref: composedRefs,
        onDismiss: ()=>context.onOpenChange(false)
    }))), false);
});
/* -------------------------------------------------------------------------------------------------
 * DialogTitle
 * -----------------------------------------------------------------------------------------------*/ const $5d3850c4d0b4e6c7$var$TITLE_NAME = 'DialogTitle';
const $5d3850c4d0b4e6c7$export$16f7638e4a34b909 = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog , ...titleProps } = props;
    const context = $5d3850c4d0b4e6c7$var$useDialogContext($5d3850c4d0b4e6c7$var$TITLE_NAME, __scopeDialog);
    return /*#__PURE__*/ (0,react.createElement)(_radix_ui_react_primitive_dist_index_module_$8927f6f2acc4f386$export$250ffa63cdc0d034.h2, (0,esm_extends/* default */.Z)({
        id: context.titleId
    }, titleProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($5d3850c4d0b4e6c7$export$16f7638e4a34b909, {
    displayName: $5d3850c4d0b4e6c7$var$TITLE_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DialogDescription
 * -----------------------------------------------------------------------------------------------*/ const $5d3850c4d0b4e6c7$var$DESCRIPTION_NAME = 'DialogDescription';
const $5d3850c4d0b4e6c7$export$94e94c2ec2c954d5 = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog , ...descriptionProps } = props;
    const context = $5d3850c4d0b4e6c7$var$useDialogContext($5d3850c4d0b4e6c7$var$DESCRIPTION_NAME, __scopeDialog);
    return /*#__PURE__*/ (0,react.createElement)(_radix_ui_react_primitive_dist_index_module_$8927f6f2acc4f386$export$250ffa63cdc0d034.p, (0,esm_extends/* default */.Z)({
        id: context.descriptionId
    }, descriptionProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($5d3850c4d0b4e6c7$export$94e94c2ec2c954d5, {
    displayName: $5d3850c4d0b4e6c7$var$DESCRIPTION_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DialogClose
 * -----------------------------------------------------------------------------------------------*/ const $5d3850c4d0b4e6c7$var$CLOSE_NAME = 'DialogClose';
const $5d3850c4d0b4e6c7$export$fba2fb7cd781b7ac = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog , ...closeProps } = props;
    const context = $5d3850c4d0b4e6c7$var$useDialogContext($5d3850c4d0b4e6c7$var$CLOSE_NAME, __scopeDialog);
    return /*#__PURE__*/ (0,react.createElement)(_radix_ui_react_primitive_dist_index_module_$8927f6f2acc4f386$export$250ffa63cdc0d034.button, (0,esm_extends/* default */.Z)({
        type: "button"
    }, closeProps, {
        ref: forwardedRef,
        onClick: index_module_$e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onClick, ()=>context.onOpenChange(false)
        )
    }));
});
/*#__PURE__*/ Object.assign($5d3850c4d0b4e6c7$export$fba2fb7cd781b7ac, {
    displayName: $5d3850c4d0b4e6c7$var$CLOSE_NAME
});
/* -----------------------------------------------------------------------------------------------*/ function $5d3850c4d0b4e6c7$var$getState(open) {
    return open ? 'open' : 'closed';
}
const $5d3850c4d0b4e6c7$var$TITLE_WARNING_NAME = 'DialogTitleWarning';
const [$5d3850c4d0b4e6c7$export$69b62a49393917d6, $5d3850c4d0b4e6c7$var$useWarningContext] = index_module_$c512c27ab02ef895$export$fd42f52fd3ae1109($5d3850c4d0b4e6c7$var$TITLE_WARNING_NAME, {
    contentName: $5d3850c4d0b4e6c7$var$CONTENT_NAME,
    titleName: $5d3850c4d0b4e6c7$var$TITLE_NAME,
    docsSlug: 'dialog'
});
const $5d3850c4d0b4e6c7$var$TitleWarning = ({ titleId: titleId  })=>{
    const titleWarningContext = $5d3850c4d0b4e6c7$var$useWarningContext($5d3850c4d0b4e6c7$var$TITLE_WARNING_NAME);
    const MESSAGE = `\`${titleWarningContext.contentName}\` requires a \`${titleWarningContext.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${titleWarningContext.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${titleWarningContext.docsSlug}`;
    $67UHm$useEffect(()=>{
        if (titleId) {
            const hasTitle = document.getElementById(titleId);
            if (!hasTitle) throw new Error(MESSAGE);
        }
    }, [
        MESSAGE,
        titleId
    ]);
    return null;
};
const $5d3850c4d0b4e6c7$var$DESCRIPTION_WARNING_NAME = 'DialogDescriptionWarning';
const $5d3850c4d0b4e6c7$var$DescriptionWarning = ({ contentRef: contentRef , descriptionId: descriptionId  })=>{
    const descriptionWarningContext = $5d3850c4d0b4e6c7$var$useWarningContext($5d3850c4d0b4e6c7$var$DESCRIPTION_WARNING_NAME);
    const MESSAGE = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${descriptionWarningContext.contentName}}.`;
    $67UHm$useEffect(()=>{
        var _contentRef$current;
        const describedById = (_contentRef$current = contentRef.current) === null || _contentRef$current === void 0 ? void 0 : _contentRef$current.getAttribute('aria-describedby'); // if we have an id and the user hasn't set aria-describedby={undefined}
        if (descriptionId && describedById) {
            const hasDescription = document.getElementById(descriptionId);
            if (!hasDescription) console.warn(MESSAGE);
        }
    }, [
        MESSAGE,
        contentRef,
        descriptionId
    ]);
    return null;
};
const $5d3850c4d0b4e6c7$export$be92b6f5f03c0fe9 = $5d3850c4d0b4e6c7$export$3ddf2d174ce01153;
const $5d3850c4d0b4e6c7$export$41fb9f06171c75f4 = $5d3850c4d0b4e6c7$export$2e1e1122cf0cba88;
const $5d3850c4d0b4e6c7$export$602eac185826482c = $5d3850c4d0b4e6c7$export$dad7c95542bacce0;
const $5d3850c4d0b4e6c7$export$c6fdb837b070b4ff = $5d3850c4d0b4e6c7$export$bd1d06c79be19e17;
const $5d3850c4d0b4e6c7$export$7c6e2c02157bb7d2 = $5d3850c4d0b4e6c7$export$b6d9565de1e068cf;
const $5d3850c4d0b4e6c7$export$f99233281efd08a0 = $5d3850c4d0b4e6c7$export$16f7638e4a34b909;
const $5d3850c4d0b4e6c7$export$393edc798c47379d = $5d3850c4d0b4e6c7$export$94e94c2ec2c954d5;
const $5d3850c4d0b4e6c7$export$f39c2d165cd861fe = $5d3850c4d0b4e6c7$export$fba2fb7cd781b7ac;





//# sourceMappingURL=index.module.js.map

;// CONCATENATED MODULE: ../node_modules/@radix-ui/react-alert-dialog/node_modules/@radix-ui/react-context/dist/index.module.js



function dist_index_module_$c512c27ab02ef895$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
    const Context = /*#__PURE__*/ $3bkAK$createContext(defaultContext);
    function Provider(props) {
        const { children: children , ...context } = props; // Only re-memoize when prop values change
        // eslint-disable-next-line react-hooks/exhaustive-deps
        const value = $3bkAK$useMemo(()=>context
        , Object.values(context));
        return /*#__PURE__*/ $3bkAK$createElement(Context.Provider, {
            value: value
        }, children);
    }
    function useContext(consumerName) {
        const context = $3bkAK$useContext(Context);
        if (context) return context;
        if (defaultContext !== undefined) return defaultContext; // if a defaultContext wasn't specified, it's a required context.
        throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
    }
    Provider.displayName = rootComponentName + 'Provider';
    return [
        Provider,
        useContext
    ];
}
/* -------------------------------------------------------------------------------------------------
 * createContextScope
 * -----------------------------------------------------------------------------------------------*/ function dist_index_module_$c512c27ab02ef895$export$50c7b4e9d9f19c1(scopeName, createContextScopeDeps = []) {
    let defaultContexts = [];
    /* -----------------------------------------------------------------------------------------------
   * createContext
   * ---------------------------------------------------------------------------------------------*/ function $c512c27ab02ef895$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
        const BaseContext = /*#__PURE__*/ (0,react.createContext)(defaultContext);
        const index = defaultContexts.length;
        defaultContexts = [
            ...defaultContexts,
            defaultContext
        ];
        function Provider(props) {
            const { scope: scope , children: children , ...context } = props;
            const Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index]) || BaseContext; // Only re-memoize when prop values change
            // eslint-disable-next-line react-hooks/exhaustive-deps
            const value = (0,react.useMemo)(()=>context
            , Object.values(context));
            return /*#__PURE__*/ (0,react.createElement)(Context.Provider, {
                value: value
            }, children);
        }
        function useContext(consumerName, scope) {
            const Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index]) || BaseContext;
            const context = (0,react.useContext)(Context);
            if (context) return context;
            if (defaultContext !== undefined) return defaultContext; // if a defaultContext wasn't specified, it's a required context.
            throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
        }
        Provider.displayName = rootComponentName + 'Provider';
        return [
            Provider,
            useContext
        ];
    }
    /* -----------------------------------------------------------------------------------------------
   * createScope
   * ---------------------------------------------------------------------------------------------*/ const createScope = ()=>{
        const scopeContexts = defaultContexts.map((defaultContext)=>{
            return /*#__PURE__*/ (0,react.createContext)(defaultContext);
        });
        return function useScope(scope) {
            const contexts = (scope === null || scope === void 0 ? void 0 : scope[scopeName]) || scopeContexts;
            return (0,react.useMemo)(()=>({
                    [`__scope${scopeName}`]: {
                        ...scope,
                        [scopeName]: contexts
                    }
                })
            , [
                scope,
                contexts
            ]);
        };
    };
    createScope.scopeName = scopeName;
    return [
        $c512c27ab02ef895$export$fd42f52fd3ae1109,
        dist_index_module_$c512c27ab02ef895$var$composeContextScopes(createScope, ...createContextScopeDeps)
    ];
}
/* -------------------------------------------------------------------------------------------------
 * composeContextScopes
 * -----------------------------------------------------------------------------------------------*/ function dist_index_module_$c512c27ab02ef895$var$composeContextScopes(...scopes) {
    const baseScope = scopes[0];
    if (scopes.length === 1) return baseScope;
    const createScope1 = ()=>{
        const scopeHooks = scopes.map((createScope)=>({
                useScope: createScope(),
                scopeName: createScope.scopeName
            })
        );
        return function useComposedScopes(overrideScopes) {
            const nextScopes1 = scopeHooks.reduce((nextScopes, { useScope: useScope , scopeName: scopeName  })=>{
                // We are calling a hook inside a callback which React warns against to avoid inconsistent
                // renders, however, scoping doesn't have render side effects so we ignore the rule.
                // eslint-disable-next-line react-hooks/rules-of-hooks
                const scopeProps = useScope(overrideScopes);
                const currentScope = scopeProps[`__scope${scopeName}`];
                return {
                    ...nextScopes,
                    ...currentScope
                };
            }, {});
            return (0,react.useMemo)(()=>({
                    [`__scope${baseScope.scopeName}`]: nextScopes1
                })
            , [
                nextScopes1
            ]);
        };
    };
    createScope1.scopeName = baseScope.scopeName;
    return createScope1;
}





//# sourceMappingURL=index.module.js.map

;// CONCATENATED MODULE: ../node_modules/@radix-ui/react-alert-dialog/node_modules/@radix-ui/react-compose-refs/dist/index.module.js



/**
 * Set a given ref to a given value
 * This utility takes care of different types of refs: callback refs and RefObject(s)
 */ function node_modules_radix_ui_react_compose_refs_dist_index_module_$6ed0406888f73fc4$var$setRef(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref !== null && ref !== undefined) ref.current = value;
}
/**
 * A utility to compose multiple refs together
 * Accepts callback refs and RefObject(s)
 */ function node_modules_radix_ui_react_compose_refs_dist_index_module_$6ed0406888f73fc4$export$43e446d32b3d21af(...refs) {
    return (node)=>refs.forEach((ref)=>node_modules_radix_ui_react_compose_refs_dist_index_module_$6ed0406888f73fc4$var$setRef(ref, node)
        )
    ;
}
/**
 * A custom hook that composes multiple refs
 * Accepts callback refs and RefObject(s)
 */ function node_modules_radix_ui_react_compose_refs_dist_index_module_$6ed0406888f73fc4$export$c7b2cbe3552a0d05(...refs) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return (0,react.useCallback)(node_modules_radix_ui_react_compose_refs_dist_index_module_$6ed0406888f73fc4$export$43e446d32b3d21af(...refs), refs);
}





//# sourceMappingURL=index.module.js.map

;// CONCATENATED MODULE: ../node_modules/@radix-ui/react-alert-dialog/node_modules/@radix-ui/primitive/dist/index.module.js
function primitive_dist_index_module_$e42e1063c40fb3ef$export$b9ecd428b558ff10(originalEventHandler, ourEventHandler, { checkForDefaultPrevented: checkForDefaultPrevented = true  } = {}) {
    return function handleEvent(event) {
        originalEventHandler === null || originalEventHandler === void 0 || originalEventHandler(event);
        if (checkForDefaultPrevented === false || !event.defaultPrevented) return ourEventHandler === null || ourEventHandler === void 0 ? void 0 : ourEventHandler(event);
    };
}





//# sourceMappingURL=index.module.js.map

;// CONCATENATED MODULE: ../node_modules/@radix-ui/react-alert-dialog/dist/index.module.js
















/* -------------------------------------------------------------------------------------------------
 * AlertDialog
 * -----------------------------------------------------------------------------------------------*/ const $905f4ae918aab1aa$var$ROOT_NAME = 'AlertDialog';
const [$905f4ae918aab1aa$var$createAlertDialogContext, $905f4ae918aab1aa$export$b8891880751c2c5b] = dist_index_module_$c512c27ab02ef895$export$50c7b4e9d9f19c1($905f4ae918aab1aa$var$ROOT_NAME, [
    $5d3850c4d0b4e6c7$export$cc702773b8ea3e41
]);
const $905f4ae918aab1aa$var$useDialogScope = $5d3850c4d0b4e6c7$export$cc702773b8ea3e41();
const $905f4ae918aab1aa$export$de466dd8317b0b75 = (props)=>{
    const { __scopeAlertDialog: __scopeAlertDialog , ...alertDialogProps } = props;
    const dialogScope = $905f4ae918aab1aa$var$useDialogScope(__scopeAlertDialog);
    return /*#__PURE__*/ (0,react.createElement)($5d3850c4d0b4e6c7$export$be92b6f5f03c0fe9, (0,esm_extends/* default */.Z)({}, dialogScope, alertDialogProps, {
        modal: true
    }));
};
/*#__PURE__*/ Object.assign($905f4ae918aab1aa$export$de466dd8317b0b75, {
    displayName: $905f4ae918aab1aa$var$ROOT_NAME
});
/* -------------------------------------------------------------------------------------------------
 * AlertDialogTrigger
 * -----------------------------------------------------------------------------------------------*/ const $905f4ae918aab1aa$var$TRIGGER_NAME = 'AlertDialogTrigger';
const $905f4ae918aab1aa$export$6edd7a623ef0f40b = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { __scopeAlertDialog: __scopeAlertDialog , ...triggerProps } = props;
    const dialogScope = $905f4ae918aab1aa$var$useDialogScope(__scopeAlertDialog);
    return /*#__PURE__*/ (0,react.createElement)($5d3850c4d0b4e6c7$export$41fb9f06171c75f4, (0,esm_extends/* default */.Z)({}, dialogScope, triggerProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($905f4ae918aab1aa$export$6edd7a623ef0f40b, {
    displayName: $905f4ae918aab1aa$var$TRIGGER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * AlertDialogPortal
 * -----------------------------------------------------------------------------------------------*/ const $905f4ae918aab1aa$var$PORTAL_NAME = 'AlertDialogPortal';
const $905f4ae918aab1aa$export$660f2bfdb986706c = (props)=>{
    const { __scopeAlertDialog: __scopeAlertDialog , ...portalProps } = props;
    const dialogScope = $905f4ae918aab1aa$var$useDialogScope(__scopeAlertDialog);
    return /*#__PURE__*/ (0,react.createElement)($5d3850c4d0b4e6c7$export$602eac185826482c, (0,esm_extends/* default */.Z)({}, dialogScope, portalProps));
};
/*#__PURE__*/ Object.assign($905f4ae918aab1aa$export$660f2bfdb986706c, {
    displayName: $905f4ae918aab1aa$var$PORTAL_NAME
});
/* -------------------------------------------------------------------------------------------------
 * AlertDialogOverlay
 * -----------------------------------------------------------------------------------------------*/ const $905f4ae918aab1aa$var$OVERLAY_NAME = 'AlertDialogOverlay';
const $905f4ae918aab1aa$export$a707a4895ce23256 = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { __scopeAlertDialog: __scopeAlertDialog , ...overlayProps } = props;
    const dialogScope = $905f4ae918aab1aa$var$useDialogScope(__scopeAlertDialog);
    return /*#__PURE__*/ (0,react.createElement)($5d3850c4d0b4e6c7$export$c6fdb837b070b4ff, (0,esm_extends/* default */.Z)({}, dialogScope, overlayProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($905f4ae918aab1aa$export$a707a4895ce23256, {
    displayName: $905f4ae918aab1aa$var$OVERLAY_NAME
});
/* -------------------------------------------------------------------------------------------------
 * AlertDialogContent
 * -----------------------------------------------------------------------------------------------*/ const $905f4ae918aab1aa$var$CONTENT_NAME = 'AlertDialogContent';
const [$905f4ae918aab1aa$var$AlertDialogContentProvider, $905f4ae918aab1aa$var$useAlertDialogContentContext] = $905f4ae918aab1aa$var$createAlertDialogContext($905f4ae918aab1aa$var$CONTENT_NAME);
const $905f4ae918aab1aa$export$94e6af45f0af4efd = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { __scopeAlertDialog: __scopeAlertDialog , children: children , ...contentProps } = props;
    const dialogScope = $905f4ae918aab1aa$var$useDialogScope(__scopeAlertDialog);
    const contentRef = (0,react.useRef)(null);
    const composedRefs = node_modules_radix_ui_react_compose_refs_dist_index_module_$6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, contentRef);
    const cancelRef = (0,react.useRef)(null);
    return /*#__PURE__*/ (0,react.createElement)($5d3850c4d0b4e6c7$export$69b62a49393917d6, {
        contentName: $905f4ae918aab1aa$var$CONTENT_NAME,
        titleName: $905f4ae918aab1aa$var$TITLE_NAME,
        docsSlug: "alert-dialog"
    }, /*#__PURE__*/ (0,react.createElement)($905f4ae918aab1aa$var$AlertDialogContentProvider, {
        scope: __scopeAlertDialog,
        cancelRef: cancelRef
    }, /*#__PURE__*/ (0,react.createElement)($5d3850c4d0b4e6c7$export$7c6e2c02157bb7d2, (0,esm_extends/* default */.Z)({
        role: "alertdialog"
    }, dialogScope, contentProps, {
        ref: composedRefs,
        onOpenAutoFocus: primitive_dist_index_module_$e42e1063c40fb3ef$export$b9ecd428b558ff10(contentProps.onOpenAutoFocus, (event)=>{
            var _cancelRef$current;
            event.preventDefault();
            (_cancelRef$current = cancelRef.current) === null || _cancelRef$current === void 0 || _cancelRef$current.focus({
                preventScroll: true
            });
        }),
        onPointerDownOutside: (event)=>event.preventDefault()
        ,
        onInteractOutside: (event)=>event.preventDefault()
    }), /*#__PURE__*/ (0,react.createElement)($5e63c961fc1ce211$export$d9f1ccf0bdb05d45, null, children), false)));
});
/*#__PURE__*/ Object.assign($905f4ae918aab1aa$export$94e6af45f0af4efd, {
    displayName: $905f4ae918aab1aa$var$CONTENT_NAME
});
/* -------------------------------------------------------------------------------------------------
 * AlertDialogTitle
 * -----------------------------------------------------------------------------------------------*/ const $905f4ae918aab1aa$var$TITLE_NAME = 'AlertDialogTitle';
const $905f4ae918aab1aa$export$225e0da62d314b7 = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { __scopeAlertDialog: __scopeAlertDialog , ...titleProps } = props;
    const dialogScope = $905f4ae918aab1aa$var$useDialogScope(__scopeAlertDialog);
    return /*#__PURE__*/ (0,react.createElement)($5d3850c4d0b4e6c7$export$f99233281efd08a0, (0,esm_extends/* default */.Z)({}, dialogScope, titleProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($905f4ae918aab1aa$export$225e0da62d314b7, {
    displayName: $905f4ae918aab1aa$var$TITLE_NAME
});
/* -------------------------------------------------------------------------------------------------
 * AlertDialogDescription
 * -----------------------------------------------------------------------------------------------*/ const $905f4ae918aab1aa$var$DESCRIPTION_NAME = 'AlertDialogDescription';
const $905f4ae918aab1aa$export$a23b55cde55ad9a5 = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { __scopeAlertDialog: __scopeAlertDialog , ...descriptionProps } = props;
    const dialogScope = $905f4ae918aab1aa$var$useDialogScope(__scopeAlertDialog);
    return /*#__PURE__*/ (0,react.createElement)($5d3850c4d0b4e6c7$export$393edc798c47379d, (0,esm_extends/* default */.Z)({}, dialogScope, descriptionProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($905f4ae918aab1aa$export$a23b55cde55ad9a5, {
    displayName: $905f4ae918aab1aa$var$DESCRIPTION_NAME
});
/* -------------------------------------------------------------------------------------------------
 * AlertDialogAction
 * -----------------------------------------------------------------------------------------------*/ const $905f4ae918aab1aa$var$ACTION_NAME = 'AlertDialogAction';
const $905f4ae918aab1aa$export$b454f818c58ee85d = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { __scopeAlertDialog: __scopeAlertDialog , ...actionProps } = props;
    const dialogScope = $905f4ae918aab1aa$var$useDialogScope(__scopeAlertDialog);
    return /*#__PURE__*/ (0,react.createElement)($5d3850c4d0b4e6c7$export$f39c2d165cd861fe, (0,esm_extends/* default */.Z)({}, dialogScope, actionProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($905f4ae918aab1aa$export$b454f818c58ee85d, {
    displayName: $905f4ae918aab1aa$var$ACTION_NAME
});
/* -------------------------------------------------------------------------------------------------
 * AlertDialogCancel
 * -----------------------------------------------------------------------------------------------*/ const $905f4ae918aab1aa$var$CANCEL_NAME = 'AlertDialogCancel';
const $905f4ae918aab1aa$export$2f67a923571aaea0 = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { __scopeAlertDialog: __scopeAlertDialog , ...cancelProps } = props;
    const { cancelRef: cancelRef  } = $905f4ae918aab1aa$var$useAlertDialogContentContext($905f4ae918aab1aa$var$CANCEL_NAME, __scopeAlertDialog);
    const dialogScope = $905f4ae918aab1aa$var$useDialogScope(__scopeAlertDialog);
    const ref = node_modules_radix_ui_react_compose_refs_dist_index_module_$6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, cancelRef);
    return /*#__PURE__*/ (0,react.createElement)($5d3850c4d0b4e6c7$export$f39c2d165cd861fe, (0,esm_extends/* default */.Z)({}, dialogScope, cancelProps, {
        ref: ref
    }));
});
/*#__PURE__*/ Object.assign($905f4ae918aab1aa$export$2f67a923571aaea0, {
    displayName: $905f4ae918aab1aa$var$CANCEL_NAME
});
/* ---------------------------------------------------------------------------------------------- */ const $905f4ae918aab1aa$var$DescriptionWarning = ({ contentRef: contentRef  })=>{
    const MESSAGE = `\`${$905f4ae918aab1aa$var$CONTENT_NAME}\` requires a description for the component to be accessible for screen reader users.

You can add a description to the \`${$905f4ae918aab1aa$var$CONTENT_NAME}\` by passing a \`${$905f4ae918aab1aa$var$DESCRIPTION_NAME}\` component as a child, which also benefits sighted users by adding visible context to the dialog.

Alternatively, you can use your own component as a description by assigning it an \`id\` and passing the same value to the \`aria-describedby\` prop in \`${$905f4ae918aab1aa$var$CONTENT_NAME}\`. If the description is confusing or duplicative for sighted users, you can use the \`@radix-ui/react-visually-hidden\` primitive as a wrapper around your description component.

For more information, see https://radix-ui.com/primitives/docs/components/alert-dialog`;
    $4k4D0$useEffect(()=>{
        var _contentRef$current;
        const hasDescription = document.getElementById((_contentRef$current = contentRef.current) === null || _contentRef$current === void 0 ? void 0 : _contentRef$current.getAttribute('aria-describedby'));
        if (!hasDescription) console.warn(MESSAGE);
    }, [
        MESSAGE,
        contentRef
    ]);
    return null;
};
const $905f4ae918aab1aa$export$be92b6f5f03c0fe9 = $905f4ae918aab1aa$export$de466dd8317b0b75;
const $905f4ae918aab1aa$export$41fb9f06171c75f4 = (/* unused pure expression or super */ null && ($905f4ae918aab1aa$export$6edd7a623ef0f40b));
const $905f4ae918aab1aa$export$602eac185826482c = $905f4ae918aab1aa$export$660f2bfdb986706c;
const $905f4ae918aab1aa$export$c6fdb837b070b4ff = $905f4ae918aab1aa$export$a707a4895ce23256;
const $905f4ae918aab1aa$export$7c6e2c02157bb7d2 = $905f4ae918aab1aa$export$94e6af45f0af4efd;
const $905f4ae918aab1aa$export$e19cd5f9376f8cee = $905f4ae918aab1aa$export$b454f818c58ee85d;
const $905f4ae918aab1aa$export$848c9b7ead0df967 = (/* unused pure expression or super */ null && ($905f4ae918aab1aa$export$2f67a923571aaea0));
const $905f4ae918aab1aa$export$f99233281efd08a0 = $905f4ae918aab1aa$export$225e0da62d314b7;
const $905f4ae918aab1aa$export$393edc798c47379d = $905f4ae918aab1aa$export$a23b55cde55ad9a5;





//# sourceMappingURL=index.module.js.map

// EXTERNAL MODULE: ../node_modules/@radix-ui/primitive/dist/index.mjs
var dist = __webpack_require__(76949);
// EXTERNAL MODULE: ../node_modules/@radix-ui/react-compose-refs/dist/index.mjs
var react_compose_refs_dist = __webpack_require__(62921);
// EXTERNAL MODULE: ../node_modules/@radix-ui/react-context/dist/index.mjs
var react_context_dist = __webpack_require__(13958);
// EXTERNAL MODULE: ../node_modules/@radix-ui/react-primitive/dist/index.mjs + 1 modules
var react_primitive_dist = __webpack_require__(14181);
// EXTERNAL MODULE: ../node_modules/@radix-ui/react-use-callback-ref/dist/index.mjs
var react_use_callback_ref_dist = __webpack_require__(60938);
;// CONCATENATED MODULE: ../node_modules/@radix-ui/react-popover/node_modules/@radix-ui/react-use-escape-keydown/dist/index.mjs





/**
 * Listens for when the escape key is down
 */ function dist_$addc16e1bbe58fd0$export$3a72a57244d6e765(onEscapeKeyDownProp, ownerDocument = globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) {
    const onEscapeKeyDown = (0,react_use_callback_ref_dist/* useCallbackRef */.W)(onEscapeKeyDownProp);
    (0,react.useEffect)(()=>{
        const handleKeyDown = (event)=>{
            if (event.key === 'Escape') onEscapeKeyDown(event);
        };
        ownerDocument.addEventListener('keydown', handleKeyDown);
        return ()=>ownerDocument.removeEventListener('keydown', handleKeyDown)
        ;
    }, [
        onEscapeKeyDown,
        ownerDocument
    ]);
}





//# sourceMappingURL=index.mjs.map

;// CONCATENATED MODULE: ../node_modules/@radix-ui/react-popover/node_modules/@radix-ui/react-dismissable-layer/dist/index.mjs















/* -------------------------------------------------------------------------------------------------
 * DismissableLayer
 * -----------------------------------------------------------------------------------------------*/ const dist_$5cb92bef7577960e$var$DISMISSABLE_LAYER_NAME = 'DismissableLayer';
const dist_$5cb92bef7577960e$var$CONTEXT_UPDATE = 'dismissableLayer.update';
const dist_$5cb92bef7577960e$var$POINTER_DOWN_OUTSIDE = 'dismissableLayer.pointerDownOutside';
const dist_$5cb92bef7577960e$var$FOCUS_OUTSIDE = 'dismissableLayer.focusOutside';
let dist_$5cb92bef7577960e$var$originalBodyPointerEvents;
const dist_$5cb92bef7577960e$var$DismissableLayerContext = /*#__PURE__*/ (0,react.createContext)({
    layers: new Set(),
    layersWithOutsidePointerEventsDisabled: new Set(),
    branches: new Set()
});
const dist_$5cb92bef7577960e$export$177fb62ff3ec1f22 = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    var _node$ownerDocument;
    const { disableOutsidePointerEvents: disableOutsidePointerEvents = false , onEscapeKeyDown: onEscapeKeyDown , onPointerDownOutside: onPointerDownOutside , onFocusOutside: onFocusOutside , onInteractOutside: onInteractOutside , onDismiss: onDismiss , ...layerProps } = props;
    const context = (0,react.useContext)(dist_$5cb92bef7577960e$var$DismissableLayerContext);
    const [node1, setNode] = (0,react.useState)(null);
    const ownerDocument = (_node$ownerDocument = node1 === null || node1 === void 0 ? void 0 : node1.ownerDocument) !== null && _node$ownerDocument !== void 0 ? _node$ownerDocument : globalThis === null || globalThis === void 0 ? void 0 : globalThis.document;
    const [, force] = (0,react.useState)({});
    const composedRefs = (0,react_compose_refs_dist/* useComposedRefs */.e)(forwardedRef, (node)=>setNode(node)
    );
    const layers = Array.from(context.layers);
    const [highestLayerWithOutsidePointerEventsDisabled] = [
        ...context.layersWithOutsidePointerEventsDisabled
    ].slice(-1); // prettier-ignore
    const highestLayerWithOutsidePointerEventsDisabledIndex = layers.indexOf(highestLayerWithOutsidePointerEventsDisabled); // prettier-ignore
    const index = node1 ? layers.indexOf(node1) : -1;
    const isBodyPointerEventsDisabled = context.layersWithOutsidePointerEventsDisabled.size > 0;
    const isPointerEventsEnabled = index >= highestLayerWithOutsidePointerEventsDisabledIndex;
    const pointerDownOutside = dist_$5cb92bef7577960e$var$usePointerDownOutside((event)=>{
        const target = event.target;
        const isPointerDownOnBranch = [
            ...context.branches
        ].some((branch)=>branch.contains(target)
        );
        if (!isPointerEventsEnabled || isPointerDownOnBranch) return;
        onPointerDownOutside === null || onPointerDownOutside === void 0 || onPointerDownOutside(event);
        onInteractOutside === null || onInteractOutside === void 0 || onInteractOutside(event);
        if (!event.defaultPrevented) onDismiss === null || onDismiss === void 0 || onDismiss();
    }, ownerDocument);
    const focusOutside = dist_$5cb92bef7577960e$var$useFocusOutside((event)=>{
        const target = event.target;
        const isFocusInBranch = [
            ...context.branches
        ].some((branch)=>branch.contains(target)
        );
        if (isFocusInBranch) return;
        onFocusOutside === null || onFocusOutside === void 0 || onFocusOutside(event);
        onInteractOutside === null || onInteractOutside === void 0 || onInteractOutside(event);
        if (!event.defaultPrevented) onDismiss === null || onDismiss === void 0 || onDismiss();
    }, ownerDocument);
    dist_$addc16e1bbe58fd0$export$3a72a57244d6e765((event)=>{
        const isHighestLayer = index === context.layers.size - 1;
        if (!isHighestLayer) return;
        onEscapeKeyDown === null || onEscapeKeyDown === void 0 || onEscapeKeyDown(event);
        if (!event.defaultPrevented && onDismiss) {
            event.preventDefault();
            onDismiss();
        }
    }, ownerDocument);
    (0,react.useEffect)(()=>{
        if (!node1) return;
        if (disableOutsidePointerEvents) {
            if (context.layersWithOutsidePointerEventsDisabled.size === 0) {
                dist_$5cb92bef7577960e$var$originalBodyPointerEvents = ownerDocument.body.style.pointerEvents;
                ownerDocument.body.style.pointerEvents = 'none';
            }
            context.layersWithOutsidePointerEventsDisabled.add(node1);
        }
        context.layers.add(node1);
        dist_$5cb92bef7577960e$var$dispatchUpdate();
        return ()=>{
            if (disableOutsidePointerEvents && context.layersWithOutsidePointerEventsDisabled.size === 1) ownerDocument.body.style.pointerEvents = dist_$5cb92bef7577960e$var$originalBodyPointerEvents;
        };
    }, [
        node1,
        ownerDocument,
        disableOutsidePointerEvents,
        context
    ]);
    /**
   * We purposefully prevent combining this effect with the `disableOutsidePointerEvents` effect
   * because a change to `disableOutsidePointerEvents` would remove this layer from the stack
   * and add it to the end again so the layering order wouldn't be _creation order_.
   * We only want them to be removed from context stacks when unmounted.
   */ (0,react.useEffect)(()=>{
        return ()=>{
            if (!node1) return;
            context.layers.delete(node1);
            context.layersWithOutsidePointerEventsDisabled.delete(node1);
            dist_$5cb92bef7577960e$var$dispatchUpdate();
        };
    }, [
        node1,
        context
    ]);
    (0,react.useEffect)(()=>{
        const handleUpdate = ()=>force({})
        ;
        document.addEventListener(dist_$5cb92bef7577960e$var$CONTEXT_UPDATE, handleUpdate);
        return ()=>document.removeEventListener(dist_$5cb92bef7577960e$var$CONTEXT_UPDATE, handleUpdate)
        ;
    }, []);
    return /*#__PURE__*/ (0,react.createElement)(react_primitive_dist/* Primitive.div */.WV.div, (0,esm_extends/* default */.Z)({}, layerProps, {
        ref: composedRefs,
        style: {
            pointerEvents: isBodyPointerEventsDisabled ? isPointerEventsEnabled ? 'auto' : 'none' : undefined,
            ...props.style
        },
        onFocusCapture: (0,dist/* composeEventHandlers */.M)(props.onFocusCapture, focusOutside.onFocusCapture),
        onBlurCapture: (0,dist/* composeEventHandlers */.M)(props.onBlurCapture, focusOutside.onBlurCapture),
        onPointerDownCapture: (0,dist/* composeEventHandlers */.M)(props.onPointerDownCapture, pointerDownOutside.onPointerDownCapture)
    }));
});
/*#__PURE__*/ Object.assign(dist_$5cb92bef7577960e$export$177fb62ff3ec1f22, {
    displayName: dist_$5cb92bef7577960e$var$DISMISSABLE_LAYER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DismissableLayerBranch
 * -----------------------------------------------------------------------------------------------*/ const dist_$5cb92bef7577960e$var$BRANCH_NAME = 'DismissableLayerBranch';
const dist_$5cb92bef7577960e$export$4d5eb2109db14228 = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const context = (0,react.useContext)(dist_$5cb92bef7577960e$var$DismissableLayerContext);
    const ref = (0,react.useRef)(null);
    const composedRefs = (0,react_compose_refs_dist/* useComposedRefs */.e)(forwardedRef, ref);
    (0,react.useEffect)(()=>{
        const node = ref.current;
        if (node) {
            context.branches.add(node);
            return ()=>{
                context.branches.delete(node);
            };
        }
    }, [
        context.branches
    ]);
    return /*#__PURE__*/ (0,react.createElement)(react_primitive_dist/* Primitive.div */.WV.div, (0,esm_extends/* default */.Z)({}, props, {
        ref: composedRefs
    }));
});
/*#__PURE__*/ Object.assign(dist_$5cb92bef7577960e$export$4d5eb2109db14228, {
    displayName: dist_$5cb92bef7577960e$var$BRANCH_NAME
});
/* -----------------------------------------------------------------------------------------------*/ /**
 * Listens for `pointerdown` outside a react subtree. We use `pointerdown` rather than `pointerup`
 * to mimic layer dismissing behaviour present in OS.
 * Returns props to pass to the node we want to check for outside events.
 */ function dist_$5cb92bef7577960e$var$usePointerDownOutside(onPointerDownOutside, ownerDocument = globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) {
    const handlePointerDownOutside = (0,react_use_callback_ref_dist/* useCallbackRef */.W)(onPointerDownOutside);
    const isPointerInsideReactTreeRef = (0,react.useRef)(false);
    const handleClickRef = (0,react.useRef)(()=>{});
    (0,react.useEffect)(()=>{
        const handlePointerDown = (event)=>{
            if (event.target && !isPointerInsideReactTreeRef.current) {
                const eventDetail = {
                    originalEvent: event
                };
                function handleAndDispatchPointerDownOutsideEvent() {
                    dist_$5cb92bef7577960e$var$handleAndDispatchCustomEvent(dist_$5cb92bef7577960e$var$POINTER_DOWN_OUTSIDE, handlePointerDownOutside, eventDetail, {
                        discrete: true
                    });
                }
                /**
         * On touch devices, we need to wait for a click event because browsers implement
         * a ~350ms delay between the time the user stops touching the display and when the
         * browser executres events. We need to ensure we don't reactivate pointer-events within
         * this timeframe otherwise the browser may execute events that should have been prevented.
         *
         * Additionally, this also lets us deal automatically with cancellations when a click event
         * isn't raised because the page was considered scrolled/drag-scrolled, long-pressed, etc.
         *
         * This is why we also continuously remove the previous listener, because we cannot be
         * certain that it was raised, and therefore cleaned-up.
         */ if (event.pointerType === 'touch') {
                    ownerDocument.removeEventListener('click', handleClickRef.current);
                    handleClickRef.current = handleAndDispatchPointerDownOutsideEvent;
                    ownerDocument.addEventListener('click', handleClickRef.current, {
                        once: true
                    });
                } else handleAndDispatchPointerDownOutsideEvent();
            }
            isPointerInsideReactTreeRef.current = false;
        };
        /**
     * if this hook executes in a component that mounts via a `pointerdown` event, the event
     * would bubble up to the document and trigger a `pointerDownOutside` event. We avoid
     * this by delaying the event listener registration on the document.
     * This is not React specific, but rather how the DOM works, ie:
     * ```
     * button.addEventListener('pointerdown', () => {
     *   console.log('I will log');
     *   document.addEventListener('pointerdown', () => {
     *     console.log('I will also log');
     *   })
     * });
     */ const timerId = window.setTimeout(()=>{
            ownerDocument.addEventListener('pointerdown', handlePointerDown);
        }, 0);
        return ()=>{
            window.clearTimeout(timerId);
            ownerDocument.removeEventListener('pointerdown', handlePointerDown);
            ownerDocument.removeEventListener('click', handleClickRef.current);
        };
    }, [
        ownerDocument,
        handlePointerDownOutside
    ]);
    return {
        // ensures we check React component tree (not just DOM tree)
        onPointerDownCapture: ()=>isPointerInsideReactTreeRef.current = true
    };
}
/**
 * Listens for when focus happens outside a react subtree.
 * Returns props to pass to the root (node) of the subtree we want to check.
 */ function dist_$5cb92bef7577960e$var$useFocusOutside(onFocusOutside, ownerDocument = globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) {
    const handleFocusOutside = (0,react_use_callback_ref_dist/* useCallbackRef */.W)(onFocusOutside);
    const isFocusInsideReactTreeRef = (0,react.useRef)(false);
    (0,react.useEffect)(()=>{
        const handleFocus = (event)=>{
            if (event.target && !isFocusInsideReactTreeRef.current) {
                const eventDetail = {
                    originalEvent: event
                };
                dist_$5cb92bef7577960e$var$handleAndDispatchCustomEvent(dist_$5cb92bef7577960e$var$FOCUS_OUTSIDE, handleFocusOutside, eventDetail, {
                    discrete: false
                });
            }
        };
        ownerDocument.addEventListener('focusin', handleFocus);
        return ()=>ownerDocument.removeEventListener('focusin', handleFocus)
        ;
    }, [
        ownerDocument,
        handleFocusOutside
    ]);
    return {
        onFocusCapture: ()=>isFocusInsideReactTreeRef.current = true
        ,
        onBlurCapture: ()=>isFocusInsideReactTreeRef.current = false
    };
}
function dist_$5cb92bef7577960e$var$dispatchUpdate() {
    const event = new CustomEvent(dist_$5cb92bef7577960e$var$CONTEXT_UPDATE);
    document.dispatchEvent(event);
}
function dist_$5cb92bef7577960e$var$handleAndDispatchCustomEvent(name, handler, detail, { discrete: discrete  }) {
    const target = detail.originalEvent.target;
    const event = new CustomEvent(name, {
        bubbles: false,
        cancelable: true,
        detail: detail
    });
    if (handler) target.addEventListener(name, handler, {
        once: true
    });
    if (discrete) (0,react_primitive_dist/* dispatchDiscreteCustomEvent */.jH)(target, event);
    else target.dispatchEvent(event);
}
const dist_$5cb92bef7577960e$export$be92b6f5f03c0fe9 = (/* unused pure expression or super */ null && (dist_$5cb92bef7577960e$export$177fb62ff3ec1f22));
const dist_$5cb92bef7577960e$export$aecb2ddcb55c95be = (/* unused pure expression or super */ null && (dist_$5cb92bef7577960e$export$4d5eb2109db14228));





//# sourceMappingURL=index.mjs.map

;// CONCATENATED MODULE: ../node_modules/@radix-ui/react-popover/node_modules/@radix-ui/react-focus-guards/dist/index.mjs



/** Number of components which have requested interest to have focus guards */ let dist_$3db38b7d1fb3fe6a$var$count = 0;
function dist_$3db38b7d1fb3fe6a$export$ac5b58043b79449b(props) {
    dist_$3db38b7d1fb3fe6a$export$b7ece24a22aeda8c();
    return props.children;
}
/**
 * Injects a pair of focus guards at the edges of the whole DOM tree
 * to ensure `focusin` & `focusout` events can be caught consistently.
 */ function dist_$3db38b7d1fb3fe6a$export$b7ece24a22aeda8c() {
    (0,react.useEffect)(()=>{
        var _edgeGuards$, _edgeGuards$2;
        const edgeGuards = document.querySelectorAll('[data-radix-focus-guard]');
        document.body.insertAdjacentElement('afterbegin', (_edgeGuards$ = edgeGuards[0]) !== null && _edgeGuards$ !== void 0 ? _edgeGuards$ : dist_$3db38b7d1fb3fe6a$var$createFocusGuard());
        document.body.insertAdjacentElement('beforeend', (_edgeGuards$2 = edgeGuards[1]) !== null && _edgeGuards$2 !== void 0 ? _edgeGuards$2 : dist_$3db38b7d1fb3fe6a$var$createFocusGuard());
        dist_$3db38b7d1fb3fe6a$var$count++;
        return ()=>{
            if (dist_$3db38b7d1fb3fe6a$var$count === 1) document.querySelectorAll('[data-radix-focus-guard]').forEach((node)=>node.remove()
            );
            dist_$3db38b7d1fb3fe6a$var$count--;
        };
    }, []);
}
function dist_$3db38b7d1fb3fe6a$var$createFocusGuard() {
    const element = document.createElement('span');
    element.setAttribute('data-radix-focus-guard', '');
    element.tabIndex = 0;
    element.style.cssText = 'outline: none; opacity: 0; position: fixed; pointer-events: none';
    return element;
}
const dist_$3db38b7d1fb3fe6a$export$be92b6f5f03c0fe9 = (/* unused pure expression or super */ null && (dist_$3db38b7d1fb3fe6a$export$ac5b58043b79449b));





//# sourceMappingURL=index.mjs.map

;// CONCATENATED MODULE: ../node_modules/@radix-ui/react-popover/node_modules/@radix-ui/react-focus-scope/dist/index.mjs











const dist_$d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT = 'focusScope.autoFocusOnMount';
const dist_$d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT = 'focusScope.autoFocusOnUnmount';
const dist_$d3863c46a17e8a28$var$EVENT_OPTIONS = {
    bubbles: false,
    cancelable: true
};
/* -------------------------------------------------------------------------------------------------
 * FocusScope
 * -----------------------------------------------------------------------------------------------*/ const dist_$d3863c46a17e8a28$var$FOCUS_SCOPE_NAME = 'FocusScope';
const dist_$d3863c46a17e8a28$export$20e40289641fbbb6 = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { loop: loop = false , trapped: trapped = false , onMountAutoFocus: onMountAutoFocusProp , onUnmountAutoFocus: onUnmountAutoFocusProp , ...scopeProps } = props;
    const [container1, setContainer] = (0,react.useState)(null);
    const onMountAutoFocus = (0,react_use_callback_ref_dist/* useCallbackRef */.W)(onMountAutoFocusProp);
    const onUnmountAutoFocus = (0,react_use_callback_ref_dist/* useCallbackRef */.W)(onUnmountAutoFocusProp);
    const lastFocusedElementRef = (0,react.useRef)(null);
    const composedRefs = (0,react_compose_refs_dist/* useComposedRefs */.e)(forwardedRef, (node)=>setContainer(node)
    );
    const focusScope = (0,react.useRef)({
        paused: false,
        pause () {
            this.paused = true;
        },
        resume () {
            this.paused = false;
        }
    }).current; // Takes care of trapping focus if focus is moved outside programmatically for example
    (0,react.useEffect)(()=>{
        if (trapped) {
            function handleFocusIn(event) {
                if (focusScope.paused || !container1) return;
                const target = event.target;
                if (container1.contains(target)) lastFocusedElementRef.current = target;
                else dist_$d3863c46a17e8a28$var$focus(lastFocusedElementRef.current, {
                    select: true
                });
            }
            function handleFocusOut(event) {
                if (focusScope.paused || !container1) return;
                const relatedTarget = event.relatedTarget; // A `focusout` event with a `null` `relatedTarget` will happen in at least two cases:
                //
                // 1. When the user switches app/tabs/windows/the browser itself loses focus.
                // 2. In Google Chrome, when the focused element is removed from the DOM.
                //
                // We let the browser do its thing here because:
                //
                // 1. The browser already keeps a memory of what's focused for when the page gets refocused.
                // 2. In Google Chrome, if we try to focus the deleted focused element (as per below), it
                //    throws the CPU to 100%, so we avoid doing anything for this reason here too.
                if (relatedTarget === null) return; // If the focus has moved to an actual legitimate element (`relatedTarget !== null`)
                // that is outside the container, we move focus to the last valid focused element inside.
                if (!container1.contains(relatedTarget)) dist_$d3863c46a17e8a28$var$focus(lastFocusedElementRef.current, {
                    select: true
                });
            } // When the focused element gets removed from the DOM, browsers move focus
            // back to the document.body. In this case, we move focus to the container
            // to keep focus trapped correctly.
            function handleMutations(mutations) {
                const focusedElement = document.activeElement;
                for (const mutation of mutations){
                    if (mutation.removedNodes.length > 0) {
                        if (!(container1 !== null && container1 !== void 0 && container1.contains(focusedElement))) dist_$d3863c46a17e8a28$var$focus(container1);
                    }
                }
            }
            document.addEventListener('focusin', handleFocusIn);
            document.addEventListener('focusout', handleFocusOut);
            const mutationObserver = new MutationObserver(handleMutations);
            if (container1) mutationObserver.observe(container1, {
                childList: true,
                subtree: true
            });
            return ()=>{
                document.removeEventListener('focusin', handleFocusIn);
                document.removeEventListener('focusout', handleFocusOut);
                mutationObserver.disconnect();
            };
        }
    }, [
        trapped,
        container1,
        focusScope.paused
    ]);
    (0,react.useEffect)(()=>{
        if (container1) {
            dist_$d3863c46a17e8a28$var$focusScopesStack.add(focusScope);
            const previouslyFocusedElement = document.activeElement;
            const hasFocusedCandidate = container1.contains(previouslyFocusedElement);
            if (!hasFocusedCandidate) {
                const mountEvent = new CustomEvent(dist_$d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT, dist_$d3863c46a17e8a28$var$EVENT_OPTIONS);
                container1.addEventListener(dist_$d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT, onMountAutoFocus);
                container1.dispatchEvent(mountEvent);
                if (!mountEvent.defaultPrevented) {
                    dist_$d3863c46a17e8a28$var$focusFirst(dist_$d3863c46a17e8a28$var$removeLinks(dist_$d3863c46a17e8a28$var$getTabbableCandidates(container1)), {
                        select: true
                    });
                    if (document.activeElement === previouslyFocusedElement) dist_$d3863c46a17e8a28$var$focus(container1);
                }
            }
            return ()=>{
                container1.removeEventListener(dist_$d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT, onMountAutoFocus); // We hit a react bug (fixed in v17) with focusing in unmount.
                // We need to delay the focus a little to get around it for now.
                // See: https://github.com/facebook/react/issues/17894
                setTimeout(()=>{
                    const unmountEvent = new CustomEvent(dist_$d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT, dist_$d3863c46a17e8a28$var$EVENT_OPTIONS);
                    container1.addEventListener(dist_$d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
                    container1.dispatchEvent(unmountEvent);
                    if (!unmountEvent.defaultPrevented) dist_$d3863c46a17e8a28$var$focus(previouslyFocusedElement !== null && previouslyFocusedElement !== void 0 ? previouslyFocusedElement : document.body, {
                        select: true
                    });
                     // we need to remove the listener after we `dispatchEvent`
                    container1.removeEventListener(dist_$d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
                    dist_$d3863c46a17e8a28$var$focusScopesStack.remove(focusScope);
                }, 0);
            };
        }
    }, [
        container1,
        onMountAutoFocus,
        onUnmountAutoFocus,
        focusScope
    ]); // Takes care of looping focus (when tabbing whilst at the edges)
    const handleKeyDown = (0,react.useCallback)((event)=>{
        if (!loop && !trapped) return;
        if (focusScope.paused) return;
        const isTabKey = event.key === 'Tab' && !event.altKey && !event.ctrlKey && !event.metaKey;
        const focusedElement = document.activeElement;
        if (isTabKey && focusedElement) {
            const container = event.currentTarget;
            const [first, last] = dist_$d3863c46a17e8a28$var$getTabbableEdges(container);
            const hasTabbableElementsInside = first && last; // we can only wrap focus if we have tabbable edges
            if (!hasTabbableElementsInside) {
                if (focusedElement === container) event.preventDefault();
            } else {
                if (!event.shiftKey && focusedElement === last) {
                    event.preventDefault();
                    if (loop) dist_$d3863c46a17e8a28$var$focus(first, {
                        select: true
                    });
                } else if (event.shiftKey && focusedElement === first) {
                    event.preventDefault();
                    if (loop) dist_$d3863c46a17e8a28$var$focus(last, {
                        select: true
                    });
                }
            }
        }
    }, [
        loop,
        trapped,
        focusScope.paused
    ]);
    return /*#__PURE__*/ (0,react.createElement)(react_primitive_dist/* Primitive.div */.WV.div, (0,esm_extends/* default */.Z)({
        tabIndex: -1
    }, scopeProps, {
        ref: composedRefs,
        onKeyDown: handleKeyDown
    }));
});
/*#__PURE__*/ Object.assign(dist_$d3863c46a17e8a28$export$20e40289641fbbb6, {
    displayName: dist_$d3863c46a17e8a28$var$FOCUS_SCOPE_NAME
});
/* -------------------------------------------------------------------------------------------------
 * Utils
 * -----------------------------------------------------------------------------------------------*/ /**
 * Attempts focusing the first element in a list of candidates.
 * Stops when focus has actually moved.
 */ function dist_$d3863c46a17e8a28$var$focusFirst(candidates, { select: select = false  } = {}) {
    const previouslyFocusedElement = document.activeElement;
    for (const candidate of candidates){
        dist_$d3863c46a17e8a28$var$focus(candidate, {
            select: select
        });
        if (document.activeElement !== previouslyFocusedElement) return;
    }
}
/**
 * Returns the first and last tabbable elements inside a container.
 */ function dist_$d3863c46a17e8a28$var$getTabbableEdges(container) {
    const candidates = dist_$d3863c46a17e8a28$var$getTabbableCandidates(container);
    const first = dist_$d3863c46a17e8a28$var$findVisible(candidates, container);
    const last = dist_$d3863c46a17e8a28$var$findVisible(candidates.reverse(), container);
    return [
        first,
        last
    ];
}
/**
 * Returns a list of potential tabbable candidates.
 *
 * NOTE: This is only a close approximation. For example it doesn't take into account cases like when
 * elements are not visible. This cannot be worked out easily by just reading a property, but rather
 * necessitate runtime knowledge (computed styles, etc). We deal with these cases separately.
 *
 * See: https://developer.mozilla.org/en-US/docs/Web/API/TreeWalker
 * Credit: https://github.com/discord/focus-layers/blob/master/src/util/wrapFocus.tsx#L1
 */ function dist_$d3863c46a17e8a28$var$getTabbableCandidates(container) {
    const nodes = [];
    const walker = document.createTreeWalker(container, NodeFilter.SHOW_ELEMENT, {
        acceptNode: (node)=>{
            const isHiddenInput = node.tagName === 'INPUT' && node.type === 'hidden';
            if (node.disabled || node.hidden || isHiddenInput) return NodeFilter.FILTER_SKIP; // `.tabIndex` is not the same as the `tabindex` attribute. It works on the
            // runtime's understanding of tabbability, so this automatically accounts
            // for any kind of element that could be tabbed to.
            return node.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
        }
    });
    while(walker.nextNode())nodes.push(walker.currentNode); // we do not take into account the order of nodes with positive `tabIndex` as it
    // hinders accessibility to have tab order different from visual order.
    return nodes;
}
/**
 * Returns the first visible element in a list.
 * NOTE: Only checks visibility up to the `container`.
 */ function dist_$d3863c46a17e8a28$var$findVisible(elements, container) {
    for (const element of elements){
        // we stop checking if it's hidden at the `container` level (excluding)
        if (!dist_$d3863c46a17e8a28$var$isHidden(element, {
            upTo: container
        })) return element;
    }
}
function dist_$d3863c46a17e8a28$var$isHidden(node, { upTo: upTo  }) {
    if (getComputedStyle(node).visibility === 'hidden') return true;
    while(node){
        // we stop at `upTo` (excluding it)
        if (upTo !== undefined && node === upTo) return false;
        if (getComputedStyle(node).display === 'none') return true;
        node = node.parentElement;
    }
    return false;
}
function dist_$d3863c46a17e8a28$var$isSelectableInput(element) {
    return element instanceof HTMLInputElement && 'select' in element;
}
function dist_$d3863c46a17e8a28$var$focus(element, { select: select = false  } = {}) {
    // only focus if that element is focusable
    if (element && element.focus) {
        const previouslyFocusedElement = document.activeElement; // NOTE: we prevent scrolling on focus, to minimize jarring transitions for users
        element.focus({
            preventScroll: true
        }); // only select if its not the same element, it supports selection and we need to select
        if (element !== previouslyFocusedElement && dist_$d3863c46a17e8a28$var$isSelectableInput(element) && select) element.select();
    }
}
/* -------------------------------------------------------------------------------------------------
 * FocusScope stack
 * -----------------------------------------------------------------------------------------------*/ const dist_$d3863c46a17e8a28$var$focusScopesStack = dist_$d3863c46a17e8a28$var$createFocusScopesStack();
function dist_$d3863c46a17e8a28$var$createFocusScopesStack() {
    /** A stack of focus scopes, with the active one at the top */ let stack = [];
    return {
        add (focusScope) {
            // pause the currently active focus scope (at the top of the stack)
            const activeFocusScope = stack[0];
            if (focusScope !== activeFocusScope) activeFocusScope === null || activeFocusScope === void 0 || activeFocusScope.pause();
             // remove in case it already exists (because we'll re-add it at the top of the stack)
            stack = dist_$d3863c46a17e8a28$var$arrayRemove(stack, focusScope);
            stack.unshift(focusScope);
        },
        remove (focusScope) {
            var _stack$;
            stack = dist_$d3863c46a17e8a28$var$arrayRemove(stack, focusScope);
            (_stack$ = stack[0]) === null || _stack$ === void 0 || _stack$.resume();
        }
    };
}
function dist_$d3863c46a17e8a28$var$arrayRemove(array, item) {
    const updatedArray = [
        ...array
    ];
    const index = updatedArray.indexOf(item);
    if (index !== -1) updatedArray.splice(index, 1);
    return updatedArray;
}
function dist_$d3863c46a17e8a28$var$removeLinks(items) {
    return items.filter((item)=>item.tagName !== 'A'
    );
}
const dist_$d3863c46a17e8a28$export$be92b6f5f03c0fe9 = (/* unused pure expression or super */ null && (dist_$d3863c46a17e8a28$export$20e40289641fbbb6));





//# sourceMappingURL=index.mjs.map

// EXTERNAL MODULE: ../node_modules/@radix-ui/react-use-layout-effect/dist/index.mjs
var react_use_layout_effect_dist = __webpack_require__(39447);
;// CONCATENATED MODULE: ../node_modules/@radix-ui/react-id/dist/index.mjs





const dist_$1746a345f3d73bb7$var$useReactId = react_namespaceObject['useId'.toString()] || (()=>undefined
);
let dist_$1746a345f3d73bb7$var$count = 0;
function dist_$1746a345f3d73bb7$export$f680877a34711e37(deterministicId) {
    const [id, setId] = react.useState(dist_$1746a345f3d73bb7$var$useReactId()); // React versions older than 18 will have client-side ids only.
    (0,react_use_layout_effect_dist/* useLayoutEffect */.b)(()=>{
        if (!deterministicId) setId((reactId)=>reactId !== null && reactId !== void 0 ? reactId : String(dist_$1746a345f3d73bb7$var$count++)
        );
    }, [
        deterministicId
    ]);
    return deterministicId || (id ? `radix-${id}` : '');
}





//# sourceMappingURL=index.mjs.map

;// CONCATENATED MODULE: ../node_modules/@floating-ui/utils/dist/floating-ui.utils.mjs
/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */

const sides = ['top', 'right', 'bottom', 'left'];
const alignments = (/* unused pure expression or super */ null && (['start', 'end']));
const floating_ui_utils_placements = /*#__PURE__*/(/* unused pure expression or super */ null && (sides.reduce((acc, side) => acc.concat(side, side + "-" + alignments[0], side + "-" + alignments[1]), [])));
const floating_ui_utils_min = Math.min;
const floating_ui_utils_max = Math.max;
const round = Math.round;
const floor = Math.floor;
const createCoords = v => ({
  x: v,
  y: v
});
const oppositeSideMap = {
  left: 'right',
  right: 'left',
  bottom: 'top',
  top: 'bottom'
};
const oppositeAlignmentMap = {
  start: 'end',
  end: 'start'
};
function clamp(start, value, end) {
  return floating_ui_utils_max(start, floating_ui_utils_min(value, end));
}
function floating_ui_utils_evaluate(value, param) {
  return typeof value === 'function' ? value(param) : value;
}
function floating_ui_utils_getSide(placement) {
  return placement.split('-')[0];
}
function floating_ui_utils_getAlignment(placement) {
  return placement.split('-')[1];
}
function getOppositeAxis(axis) {
  return axis === 'x' ? 'y' : 'x';
}
function getAxisLength(axis) {
  return axis === 'y' ? 'height' : 'width';
}
function floating_ui_utils_getSideAxis(placement) {
  return ['top', 'bottom'].includes(floating_ui_utils_getSide(placement)) ? 'y' : 'x';
}
function getAlignmentAxis(placement) {
  return getOppositeAxis(floating_ui_utils_getSideAxis(placement));
}
function floating_ui_utils_getAlignmentSides(placement, rects, rtl) {
  if (rtl === void 0) {
    rtl = false;
  }
  const alignment = floating_ui_utils_getAlignment(placement);
  const alignmentAxis = getAlignmentAxis(placement);
  const length = getAxisLength(alignmentAxis);
  let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
  if (rects.reference[length] > rects.floating[length]) {
    mainAlignmentSide = getOppositePlacement(mainAlignmentSide);
  }
  return [mainAlignmentSide, getOppositePlacement(mainAlignmentSide)];
}
function getExpandedPlacements(placement) {
  const oppositePlacement = getOppositePlacement(placement);
  return [floating_ui_utils_getOppositeAlignmentPlacement(placement), oppositePlacement, floating_ui_utils_getOppositeAlignmentPlacement(oppositePlacement)];
}
function floating_ui_utils_getOppositeAlignmentPlacement(placement) {
  return placement.replace(/start|end/g, alignment => oppositeAlignmentMap[alignment]);
}
function getSideList(side, isStart, rtl) {
  const lr = ['left', 'right'];
  const rl = ['right', 'left'];
  const tb = ['top', 'bottom'];
  const bt = ['bottom', 'top'];
  switch (side) {
    case 'top':
    case 'bottom':
      if (rtl) return isStart ? rl : lr;
      return isStart ? lr : rl;
    case 'left':
    case 'right':
      return isStart ? tb : bt;
    default:
      return [];
  }
}
function getOppositeAxisPlacements(placement, flipAlignment, direction, rtl) {
  const alignment = floating_ui_utils_getAlignment(placement);
  let list = getSideList(floating_ui_utils_getSide(placement), direction === 'start', rtl);
  if (alignment) {
    list = list.map(side => side + "-" + alignment);
    if (flipAlignment) {
      list = list.concat(list.map(floating_ui_utils_getOppositeAlignmentPlacement));
    }
  }
  return list;
}
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, side => oppositeSideMap[side]);
}
function expandPaddingObject(padding) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...padding
  };
}
function floating_ui_utils_getPaddingObject(padding) {
  return typeof padding !== 'number' ? expandPaddingObject(padding) : {
    top: padding,
    right: padding,
    bottom: padding,
    left: padding
  };
}
function floating_ui_utils_rectToClientRect(rect) {
  const {
    x,
    y,
    width,
    height
  } = rect;
  return {
    width,
    height,
    top: y,
    left: x,
    right: x + width,
    bottom: y + height,
    x,
    y
  };
}



;// CONCATENATED MODULE: ../node_modules/@floating-ui/core/dist/floating-ui.core.mjs



function computeCoordsFromPlacement(_ref, placement, rtl) {
  let {
    reference,
    floating
  } = _ref;
  const sideAxis = floating_ui_utils_getSideAxis(placement);
  const alignmentAxis = getAlignmentAxis(placement);
  const alignLength = getAxisLength(alignmentAxis);
  const side = floating_ui_utils_getSide(placement);
  const isVertical = sideAxis === 'y';
  const commonX = reference.x + reference.width / 2 - floating.width / 2;
  const commonY = reference.y + reference.height / 2 - floating.height / 2;
  const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
  let coords;
  switch (side) {
    case 'top':
      coords = {
        x: commonX,
        y: reference.y - floating.height
      };
      break;
    case 'bottom':
      coords = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;
    case 'right':
      coords = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;
    case 'left':
      coords = {
        x: reference.x - floating.width,
        y: commonY
      };
      break;
    default:
      coords = {
        x: reference.x,
        y: reference.y
      };
  }
  switch (floating_ui_utils_getAlignment(placement)) {
    case 'start':
      coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
      break;
    case 'end':
      coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
      break;
  }
  return coords;
}

/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */
const computePosition = async (reference, floating, config) => {
  const {
    placement = 'bottom',
    strategy = 'absolute',
    middleware = [],
    platform
  } = config;
  const validMiddleware = middleware.filter(Boolean);
  const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
  let rects = await platform.getElementRects({
    reference,
    floating,
    strategy
  });
  let {
    x,
    y
  } = computeCoordsFromPlacement(rects, placement, rtl);
  let statefulPlacement = placement;
  let middlewareData = {};
  let resetCount = 0;
  for (let i = 0; i < validMiddleware.length; i++) {
    const {
      name,
      fn
    } = validMiddleware[i];
    const {
      x: nextX,
      y: nextY,
      data,
      reset
    } = await fn({
      x,
      y,
      initialPlacement: placement,
      placement: statefulPlacement,
      strategy,
      middlewareData,
      rects,
      platform,
      elements: {
        reference,
        floating
      }
    });
    x = nextX != null ? nextX : x;
    y = nextY != null ? nextY : y;
    middlewareData = {
      ...middlewareData,
      [name]: {
        ...middlewareData[name],
        ...data
      }
    };
    if (reset && resetCount <= 50) {
      resetCount++;
      if (typeof reset === 'object') {
        if (reset.placement) {
          statefulPlacement = reset.placement;
        }
        if (reset.rects) {
          rects = reset.rects === true ? await platform.getElementRects({
            reference,
            floating,
            strategy
          }) : reset.rects;
        }
        ({
          x,
          y
        } = computeCoordsFromPlacement(rects, statefulPlacement, rtl));
      }
      i = -1;
    }
  }
  return {
    x,
    y,
    placement: statefulPlacement,
    strategy,
    middlewareData
  };
};

/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */
async function detectOverflow(state, options) {
  var _await$platform$isEle;
  if (options === void 0) {
    options = {};
  }
  const {
    x,
    y,
    platform,
    rects,
    elements,
    strategy
  } = state;
  const {
    boundary = 'clippingAncestors',
    rootBoundary = 'viewport',
    elementContext = 'floating',
    altBoundary = false,
    padding = 0
  } = floating_ui_utils_evaluate(options, state);
  const paddingObject = floating_ui_utils_getPaddingObject(padding);
  const altContext = elementContext === 'floating' ? 'reference' : 'floating';
  const element = elements[altBoundary ? altContext : elementContext];
  const clippingClientRect = floating_ui_utils_rectToClientRect(await platform.getClippingRect({
    element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || (await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating))),
    boundary,
    rootBoundary,
    strategy
  }));
  const rect = elementContext === 'floating' ? {
    x,
    y,
    width: rects.floating.width,
    height: rects.floating.height
  } : rects.reference;
  const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
  const offsetScale = (await (platform.isElement == null ? void 0 : platform.isElement(offsetParent))) ? (await (platform.getScale == null ? void 0 : platform.getScale(offsetParent))) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  };
  const elementClientRect = floating_ui_utils_rectToClientRect(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements,
    rect,
    offsetParent,
    strategy
  }) : rect);
  return {
    top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
    bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
    left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
    right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
  };
}

/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */
const arrow = options => ({
  name: 'arrow',
  options,
  async fn(state) {
    const {
      x,
      y,
      placement,
      rects,
      platform,
      elements,
      middlewareData
    } = state;
    // Since `element` is required, we don't Partial<> the type.
    const {
      element,
      padding = 0
    } = floating_ui_utils_evaluate(options, state) || {};
    if (element == null) {
      return {};
    }
    const paddingObject = floating_ui_utils_getPaddingObject(padding);
    const coords = {
      x,
      y
    };
    const axis = getAlignmentAxis(placement);
    const length = getAxisLength(axis);
    const arrowDimensions = await platform.getDimensions(element);
    const isYAxis = axis === 'y';
    const minProp = isYAxis ? 'top' : 'left';
    const maxProp = isYAxis ? 'bottom' : 'right';
    const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
    const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
    const startDiff = coords[axis] - rects.reference[axis];
    const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
    let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;

    // DOM platform can return `window` as the `offsetParent`.
    if (!clientSize || !(await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent)))) {
      clientSize = elements.floating[clientProp] || rects.floating[length];
    }
    const centerToReference = endDiff / 2 - startDiff / 2;

    // If the padding is large enough that it causes the arrow to no longer be
    // centered, modify the padding so that it is centered.
    const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
    const minPadding = floating_ui_utils_min(paddingObject[minProp], largestPossiblePadding);
    const maxPadding = floating_ui_utils_min(paddingObject[maxProp], largestPossiblePadding);

    // Make sure the arrow doesn't overflow the floating element if the center
    // point is outside the floating element's bounds.
    const min$1 = minPadding;
    const max = clientSize - arrowDimensions[length] - maxPadding;
    const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
    const offset = clamp(min$1, center, max);

    // If the reference is small enough that the arrow's padding causes it to
    // to point to nothing for an aligned placement, adjust the offset of the
    // floating element itself. To ensure `shift()` continues to take action,
    // a single reset is performed when this is true.
    const shouldAddOffset = !middlewareData.arrow && floating_ui_utils_getAlignment(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
    const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
    return {
      [axis]: coords[axis] + alignmentOffset,
      data: {
        [axis]: offset,
        centerOffset: center - offset - alignmentOffset,
        ...(shouldAddOffset && {
          alignmentOffset
        })
      },
      reset: shouldAddOffset
    };
  }
});

function getPlacementList(alignment, autoAlignment, allowedPlacements) {
  const allowedPlacementsSortedByAlignment = alignment ? [...allowedPlacements.filter(placement => getAlignment(placement) === alignment), ...allowedPlacements.filter(placement => getAlignment(placement) !== alignment)] : allowedPlacements.filter(placement => getSide(placement) === placement);
  return allowedPlacementsSortedByAlignment.filter(placement => {
    if (alignment) {
      return getAlignment(placement) === alignment || (autoAlignment ? getOppositeAlignmentPlacement(placement) !== placement : false);
    }
    return true;
  });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */
const autoPlacement = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: 'autoPlacement',
    options,
    async fn(state) {
      var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
      const {
        rects,
        middlewareData,
        placement,
        platform,
        elements
      } = state;
      const {
        crossAxis = false,
        alignment,
        allowedPlacements = placements,
        autoAlignment = true,
        ...detectOverflowOptions
      } = evaluate(options, state);
      const placements$1 = alignment !== undefined || allowedPlacements === placements ? getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
      const overflow = await detectOverflow(state, detectOverflowOptions);
      const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
      const currentPlacement = placements$1[currentIndex];
      if (currentPlacement == null) {
        return {};
      }
      const alignmentSides = getAlignmentSides(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));

      // Make `computeCoords` start from the right place.
      if (placement !== currentPlacement) {
        return {
          reset: {
            placement: placements$1[0]
          }
        };
      }
      const currentOverflows = [overflow[getSide(currentPlacement)], overflow[alignmentSides[0]], overflow[alignmentSides[1]]];
      const allOverflows = [...(((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || []), {
        placement: currentPlacement,
        overflows: currentOverflows
      }];
      const nextPlacement = placements$1[currentIndex + 1];

      // There are more placements to check.
      if (nextPlacement) {
        return {
          data: {
            index: currentIndex + 1,
            overflows: allOverflows
          },
          reset: {
            placement: nextPlacement
          }
        };
      }
      const placementsSortedByMostSpace = allOverflows.map(d => {
        const alignment = getAlignment(d.placement);
        return [d.placement, alignment && crossAxis ?
        // Check along the mainAxis and main crossAxis side.
        d.overflows.slice(0, 2).reduce((acc, v) => acc + v, 0) :
        // Check only the mainAxis.
        d.overflows[0], d.overflows];
      }).sort((a, b) => a[1] - b[1]);
      const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter(d => d[2].slice(0,
      // Aligned placements should not check their opposite crossAxis
      // side.
      getAlignment(d[0]) ? 2 : 3).every(v => v <= 0));
      const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
      if (resetPlacement !== placement) {
        return {
          data: {
            index: currentIndex + 1,
            overflows: allOverflows
          },
          reset: {
            placement: resetPlacement
          }
        };
      }
      return {};
    }
  };
};

/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */
const flip = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: 'flip',
    options,
    async fn(state) {
      var _middlewareData$arrow, _middlewareData$flip;
      const {
        placement,
        middlewareData,
        rects,
        initialPlacement,
        platform,
        elements
      } = state;
      const {
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = true,
        fallbackPlacements: specifiedFallbackPlacements,
        fallbackStrategy = 'bestFit',
        fallbackAxisSideDirection = 'none',
        flipAlignment = true,
        ...detectOverflowOptions
      } = floating_ui_utils_evaluate(options, state);

      // If a reset by the arrow was caused due to an alignment offset being
      // added, we should skip any logic now since `flip()` has already done its
      // work.
      // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
      if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) {
        return {};
      }
      const side = floating_ui_utils_getSide(placement);
      const initialSideAxis = floating_ui_utils_getSideAxis(initialPlacement);
      const isBasePlacement = floating_ui_utils_getSide(initialPlacement) === initialPlacement;
      const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
      const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [getOppositePlacement(initialPlacement)] : getExpandedPlacements(initialPlacement));
      const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== 'none';
      if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) {
        fallbackPlacements.push(...getOppositeAxisPlacements(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
      }
      const placements = [initialPlacement, ...fallbackPlacements];
      const overflow = await detectOverflow(state, detectOverflowOptions);
      const overflows = [];
      let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
      if (checkMainAxis) {
        overflows.push(overflow[side]);
      }
      if (checkCrossAxis) {
        const sides = floating_ui_utils_getAlignmentSides(placement, rects, rtl);
        overflows.push(overflow[sides[0]], overflow[sides[1]]);
      }
      overflowsData = [...overflowsData, {
        placement,
        overflows
      }];

      // One or more sides is overflowing.
      if (!overflows.every(side => side <= 0)) {
        var _middlewareData$flip2, _overflowsData$filter;
        const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
        const nextPlacement = placements[nextIndex];
        if (nextPlacement) {
          // Try next placement and re-run the lifecycle.
          return {
            data: {
              index: nextIndex,
              overflows: overflowsData
            },
            reset: {
              placement: nextPlacement
            }
          };
        }

        // First, find the candidates that fit on the mainAxis side of overflow,
        // then find the placement that fits the best on the main crossAxis side.
        let resetPlacement = (_overflowsData$filter = overflowsData.filter(d => d.overflows[0] <= 0).sort((a, b) => a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;

        // Otherwise fallback.
        if (!resetPlacement) {
          switch (fallbackStrategy) {
            case 'bestFit':
              {
                var _overflowsData$filter2;
                const placement = (_overflowsData$filter2 = overflowsData.filter(d => {
                  if (hasFallbackAxisSideDirection) {
                    const currentSideAxis = floating_ui_utils_getSideAxis(d.placement);
                    return currentSideAxis === initialSideAxis ||
                    // Create a bias to the `y` side axis due to horizontal
                    // reading directions favoring greater width.
                    currentSideAxis === 'y';
                  }
                  return true;
                }).map(d => [d.placement, d.overflows.filter(overflow => overflow > 0).reduce((acc, overflow) => acc + overflow, 0)]).sort((a, b) => a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                if (placement) {
                  resetPlacement = placement;
                }
                break;
              }
            case 'initialPlacement':
              resetPlacement = initialPlacement;
              break;
          }
        }
        if (placement !== resetPlacement) {
          return {
            reset: {
              placement: resetPlacement
            }
          };
        }
      }
      return {};
    }
  };
};

function getSideOffsets(overflow, rect) {
  return {
    top: overflow.top - rect.height,
    right: overflow.right - rect.width,
    bottom: overflow.bottom - rect.height,
    left: overflow.left - rect.width
  };
}
function isAnySideFullyClipped(overflow) {
  return sides.some(side => overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */
const hide = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: 'hide',
    options,
    async fn(state) {
      const {
        rects
      } = state;
      const {
        strategy = 'referenceHidden',
        ...detectOverflowOptions
      } = floating_ui_utils_evaluate(options, state);
      switch (strategy) {
        case 'referenceHidden':
          {
            const overflow = await detectOverflow(state, {
              ...detectOverflowOptions,
              elementContext: 'reference'
            });
            const offsets = getSideOffsets(overflow, rects.reference);
            return {
              data: {
                referenceHiddenOffsets: offsets,
                referenceHidden: isAnySideFullyClipped(offsets)
              }
            };
          }
        case 'escaped':
          {
            const overflow = await detectOverflow(state, {
              ...detectOverflowOptions,
              altBoundary: true
            });
            const offsets = getSideOffsets(overflow, rects.floating);
            return {
              data: {
                escapedOffsets: offsets,
                escaped: isAnySideFullyClipped(offsets)
              }
            };
          }
        default:
          {
            return {};
          }
      }
    }
  };
};

function getBoundingRect(rects) {
  const minX = min(...rects.map(rect => rect.left));
  const minY = min(...rects.map(rect => rect.top));
  const maxX = max(...rects.map(rect => rect.right));
  const maxY = max(...rects.map(rect => rect.bottom));
  return {
    x: minX,
    y: minY,
    width: maxX - minX,
    height: maxY - minY
  };
}
function getRectsByLine(rects) {
  const sortedRects = rects.slice().sort((a, b) => a.y - b.y);
  const groups = [];
  let prevRect = null;
  for (let i = 0; i < sortedRects.length; i++) {
    const rect = sortedRects[i];
    if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) {
      groups.push([rect]);
    } else {
      groups[groups.length - 1].push(rect);
    }
    prevRect = rect;
  }
  return groups.map(rect => rectToClientRect(getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */
const inline = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: 'inline',
    options,
    async fn(state) {
      const {
        placement,
        elements,
        rects,
        platform,
        strategy
      } = state;
      // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
      // ClientRect's bounds, despite the event listener being triggered. A
      // padding of 2 seems to handle this issue.
      const {
        padding = 2,
        x,
        y
      } = evaluate(options, state);
      const nativeClientRects = Array.from((await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference))) || []);
      const clientRects = getRectsByLine(nativeClientRects);
      const fallback = rectToClientRect(getBoundingRect(nativeClientRects));
      const paddingObject = getPaddingObject(padding);
      function getBoundingClientRect() {
        // There are two rects and they are disjoined.
        if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) {
          // Find the first rect in which the point is fully inside.
          return clientRects.find(rect => x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
        }

        // There are 2 or more connected rects.
        if (clientRects.length >= 2) {
          if (getSideAxis(placement) === 'y') {
            const firstRect = clientRects[0];
            const lastRect = clientRects[clientRects.length - 1];
            const isTop = getSide(placement) === 'top';
            const top = firstRect.top;
            const bottom = lastRect.bottom;
            const left = isTop ? firstRect.left : lastRect.left;
            const right = isTop ? firstRect.right : lastRect.right;
            const width = right - left;
            const height = bottom - top;
            return {
              top,
              bottom,
              left,
              right,
              width,
              height,
              x: left,
              y: top
            };
          }
          const isLeftSide = getSide(placement) === 'left';
          const maxRight = max(...clientRects.map(rect => rect.right));
          const minLeft = min(...clientRects.map(rect => rect.left));
          const measureRects = clientRects.filter(rect => isLeftSide ? rect.left === minLeft : rect.right === maxRight);
          const top = measureRects[0].top;
          const bottom = measureRects[measureRects.length - 1].bottom;
          const left = minLeft;
          const right = maxRight;
          const width = right - left;
          const height = bottom - top;
          return {
            top,
            bottom,
            left,
            right,
            width,
            height,
            x: left,
            y: top
          };
        }
        return fallback;
      }
      const resetRects = await platform.getElementRects({
        reference: {
          getBoundingClientRect
        },
        floating: elements.floating,
        strategy
      });
      if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) {
        return {
          reset: {
            rects: resetRects
          }
        };
      }
      return {};
    }
  };
};

// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.

async function convertValueToCoords(state, options) {
  const {
    placement,
    platform,
    elements
  } = state;
  const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
  const side = floating_ui_utils_getSide(placement);
  const alignment = floating_ui_utils_getAlignment(placement);
  const isVertical = floating_ui_utils_getSideAxis(placement) === 'y';
  const mainAxisMulti = ['left', 'top'].includes(side) ? -1 : 1;
  const crossAxisMulti = rtl && isVertical ? -1 : 1;
  const rawValue = floating_ui_utils_evaluate(options, state);

  // eslint-disable-next-line prefer-const
  let {
    mainAxis,
    crossAxis,
    alignmentAxis
  } = typeof rawValue === 'number' ? {
    mainAxis: rawValue,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: rawValue.mainAxis || 0,
    crossAxis: rawValue.crossAxis || 0,
    alignmentAxis: rawValue.alignmentAxis
  };
  if (alignment && typeof alignmentAxis === 'number') {
    crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
  }
  return isVertical ? {
    x: crossAxis * crossAxisMulti,
    y: mainAxis * mainAxisMulti
  } : {
    x: mainAxis * mainAxisMulti,
    y: crossAxis * crossAxisMulti
  };
}

/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */
const offset = function (options) {
  if (options === void 0) {
    options = 0;
  }
  return {
    name: 'offset',
    options,
    async fn(state) {
      var _middlewareData$offse, _middlewareData$arrow;
      const {
        x,
        y,
        placement,
        middlewareData
      } = state;
      const diffCoords = await convertValueToCoords(state, options);

      // If the placement is the same and the arrow caused an alignment offset
      // then we don't need to change the positioning coordinates.
      if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) {
        return {};
      }
      return {
        x: x + diffCoords.x,
        y: y + diffCoords.y,
        data: {
          ...diffCoords,
          placement
        }
      };
    }
  };
};

/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */
const shift = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: 'shift',
    options,
    async fn(state) {
      const {
        x,
        y,
        placement
      } = state;
      const {
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = false,
        limiter = {
          fn: _ref => {
            let {
              x,
              y
            } = _ref;
            return {
              x,
              y
            };
          }
        },
        ...detectOverflowOptions
      } = floating_ui_utils_evaluate(options, state);
      const coords = {
        x,
        y
      };
      const overflow = await detectOverflow(state, detectOverflowOptions);
      const crossAxis = floating_ui_utils_getSideAxis(floating_ui_utils_getSide(placement));
      const mainAxis = getOppositeAxis(crossAxis);
      let mainAxisCoord = coords[mainAxis];
      let crossAxisCoord = coords[crossAxis];
      if (checkMainAxis) {
        const minSide = mainAxis === 'y' ? 'top' : 'left';
        const maxSide = mainAxis === 'y' ? 'bottom' : 'right';
        const min = mainAxisCoord + overflow[minSide];
        const max = mainAxisCoord - overflow[maxSide];
        mainAxisCoord = clamp(min, mainAxisCoord, max);
      }
      if (checkCrossAxis) {
        const minSide = crossAxis === 'y' ? 'top' : 'left';
        const maxSide = crossAxis === 'y' ? 'bottom' : 'right';
        const min = crossAxisCoord + overflow[minSide];
        const max = crossAxisCoord - overflow[maxSide];
        crossAxisCoord = clamp(min, crossAxisCoord, max);
      }
      const limitedCoords = limiter.fn({
        ...state,
        [mainAxis]: mainAxisCoord,
        [crossAxis]: crossAxisCoord
      });
      return {
        ...limitedCoords,
        data: {
          x: limitedCoords.x - x,
          y: limitedCoords.y - y,
          enabled: {
            [mainAxis]: checkMainAxis,
            [crossAxis]: checkCrossAxis
          }
        }
      };
    }
  };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */
const limitShift = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    options,
    fn(state) {
      const {
        x,
        y,
        placement,
        rects,
        middlewareData
      } = state;
      const {
        offset = 0,
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = true
      } = floating_ui_utils_evaluate(options, state);
      const coords = {
        x,
        y
      };
      const crossAxis = floating_ui_utils_getSideAxis(placement);
      const mainAxis = getOppositeAxis(crossAxis);
      let mainAxisCoord = coords[mainAxis];
      let crossAxisCoord = coords[crossAxis];
      const rawOffset = floating_ui_utils_evaluate(offset, state);
      const computedOffset = typeof rawOffset === 'number' ? {
        mainAxis: rawOffset,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...rawOffset
      };
      if (checkMainAxis) {
        const len = mainAxis === 'y' ? 'height' : 'width';
        const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
        const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
        if (mainAxisCoord < limitMin) {
          mainAxisCoord = limitMin;
        } else if (mainAxisCoord > limitMax) {
          mainAxisCoord = limitMax;
        }
      }
      if (checkCrossAxis) {
        var _middlewareData$offse, _middlewareData$offse2;
        const len = mainAxis === 'y' ? 'width' : 'height';
        const isOriginSide = ['top', 'left'].includes(floating_ui_utils_getSide(placement));
        const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
        const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
        if (crossAxisCoord < limitMin) {
          crossAxisCoord = limitMin;
        } else if (crossAxisCoord > limitMax) {
          crossAxisCoord = limitMax;
        }
      }
      return {
        [mainAxis]: mainAxisCoord,
        [crossAxis]: crossAxisCoord
      };
    }
  };
};

/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */
const size = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: 'size',
    options,
    async fn(state) {
      var _state$middlewareData, _state$middlewareData2;
      const {
        placement,
        rects,
        platform,
        elements
      } = state;
      const {
        apply = () => {},
        ...detectOverflowOptions
      } = floating_ui_utils_evaluate(options, state);
      const overflow = await detectOverflow(state, detectOverflowOptions);
      const side = floating_ui_utils_getSide(placement);
      const alignment = floating_ui_utils_getAlignment(placement);
      const isYAxis = floating_ui_utils_getSideAxis(placement) === 'y';
      const {
        width,
        height
      } = rects.floating;
      let heightSide;
      let widthSide;
      if (side === 'top' || side === 'bottom') {
        heightSide = side;
        widthSide = alignment === ((await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating))) ? 'start' : 'end') ? 'left' : 'right';
      } else {
        widthSide = side;
        heightSide = alignment === 'end' ? 'top' : 'bottom';
      }
      const maximumClippingHeight = height - overflow.top - overflow.bottom;
      const maximumClippingWidth = width - overflow.left - overflow.right;
      const overflowAvailableHeight = floating_ui_utils_min(height - overflow[heightSide], maximumClippingHeight);
      const overflowAvailableWidth = floating_ui_utils_min(width - overflow[widthSide], maximumClippingWidth);
      const noShift = !state.middlewareData.shift;
      let availableHeight = overflowAvailableHeight;
      let availableWidth = overflowAvailableWidth;
      if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) {
        availableWidth = maximumClippingWidth;
      }
      if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) {
        availableHeight = maximumClippingHeight;
      }
      if (noShift && !alignment) {
        const xMin = floating_ui_utils_max(overflow.left, 0);
        const xMax = floating_ui_utils_max(overflow.right, 0);
        const yMin = floating_ui_utils_max(overflow.top, 0);
        const yMax = floating_ui_utils_max(overflow.bottom, 0);
        if (isYAxis) {
          availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : floating_ui_utils_max(overflow.left, overflow.right));
        } else {
          availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : floating_ui_utils_max(overflow.top, overflow.bottom));
        }
      }
      await apply({
        ...state,
        availableWidth,
        availableHeight
      });
      const nextDimensions = await platform.getDimensions(elements.floating);
      if (width !== nextDimensions.width || height !== nextDimensions.height) {
        return {
          reset: {
            rects: true
          }
        };
      }
      return {};
    }
  };
};



;// CONCATENATED MODULE: ../node_modules/@floating-ui/utils/dist/floating-ui.utils.dom.mjs
function hasWindow() {
  return typeof window !== 'undefined';
}
function getNodeName(node) {
  if (isNode(node)) {
    return (node.nodeName || '').toLowerCase();
  }
  // Mocked nodes in testing environments may not be instances of Node. By
  // returning `#document` an infinite loop won't occur.
  // https://github.com/floating-ui/floating-ui/issues/2317
  return '#document';
}
function getWindow(node) {
  var _node$ownerDocument;
  return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function getDocumentElement(node) {
  var _ref;
  return (_ref = (isNode(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function isNode(value) {
  if (!hasWindow()) {
    return false;
  }
  return value instanceof Node || value instanceof getWindow(value).Node;
}
function isElement(value) {
  if (!hasWindow()) {
    return false;
  }
  return value instanceof Element || value instanceof getWindow(value).Element;
}
function isHTMLElement(value) {
  if (!hasWindow()) {
    return false;
  }
  return value instanceof HTMLElement || value instanceof getWindow(value).HTMLElement;
}
function isShadowRoot(value) {
  if (!hasWindow() || typeof ShadowRoot === 'undefined') {
    return false;
  }
  return value instanceof ShadowRoot || value instanceof getWindow(value).ShadowRoot;
}
function isOverflowElement(element) {
  const {
    overflow,
    overflowX,
    overflowY,
    display
  } = floating_ui_utils_dom_getComputedStyle(element);
  return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && !['inline', 'contents'].includes(display);
}
function isTableElement(element) {
  return ['table', 'td', 'th'].includes(getNodeName(element));
}
function isTopLayer(element) {
  return [':popover-open', ':modal'].some(selector => {
    try {
      return element.matches(selector);
    } catch (e) {
      return false;
    }
  });
}
function isContainingBlock(elementOrCss) {
  const webkit = isWebKit();
  const css = isElement(elementOrCss) ? floating_ui_utils_dom_getComputedStyle(elementOrCss) : elementOrCss;

  // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
  return css.transform !== 'none' || css.perspective !== 'none' || (css.containerType ? css.containerType !== 'normal' : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== 'none' : false) || !webkit && (css.filter ? css.filter !== 'none' : false) || ['transform', 'perspective', 'filter'].some(value => (css.willChange || '').includes(value)) || ['paint', 'layout', 'strict', 'content'].some(value => (css.contain || '').includes(value));
}
function getContainingBlock(element) {
  let currentNode = getParentNode(element);
  while (isHTMLElement(currentNode) && !isLastTraversableNode(currentNode)) {
    if (isContainingBlock(currentNode)) {
      return currentNode;
    } else if (isTopLayer(currentNode)) {
      return null;
    }
    currentNode = getParentNode(currentNode);
  }
  return null;
}
function isWebKit() {
  if (typeof CSS === 'undefined' || !CSS.supports) return false;
  return CSS.supports('-webkit-backdrop-filter', 'none');
}
function isLastTraversableNode(node) {
  return ['html', 'body', '#document'].includes(getNodeName(node));
}
function floating_ui_utils_dom_getComputedStyle(element) {
  return getWindow(element).getComputedStyle(element);
}
function getNodeScroll(element) {
  if (isElement(element)) {
    return {
      scrollLeft: element.scrollLeft,
      scrollTop: element.scrollTop
    };
  }
  return {
    scrollLeft: element.scrollX,
    scrollTop: element.scrollY
  };
}
function getParentNode(node) {
  if (getNodeName(node) === 'html') {
    return node;
  }
  const result =
  // Step into the shadow DOM of the parent of a slotted node.
  node.assignedSlot ||
  // DOM Element detected.
  node.parentNode ||
  // ShadowRoot detected.
  isShadowRoot(node) && node.host ||
  // Fallback.
  getDocumentElement(node);
  return isShadowRoot(result) ? result.host : result;
}
function getNearestOverflowAncestor(node) {
  const parentNode = getParentNode(node);
  if (isLastTraversableNode(parentNode)) {
    return node.ownerDocument ? node.ownerDocument.body : node.body;
  }
  if (isHTMLElement(parentNode) && isOverflowElement(parentNode)) {
    return parentNode;
  }
  return getNearestOverflowAncestor(parentNode);
}
function getOverflowAncestors(node, list, traverseIframes) {
  var _node$ownerDocument2;
  if (list === void 0) {
    list = [];
  }
  if (traverseIframes === void 0) {
    traverseIframes = true;
  }
  const scrollableAncestor = getNearestOverflowAncestor(node);
  const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
  const win = getWindow(scrollableAncestor);
  if (isBody) {
    const frameElement = getFrameElement(win);
    return list.concat(win, win.visualViewport || [], isOverflowElement(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? getOverflowAncestors(frameElement) : []);
  }
  return list.concat(scrollableAncestor, getOverflowAncestors(scrollableAncestor, [], traverseIframes));
}
function getFrameElement(win) {
  return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}



;// CONCATENATED MODULE: ../node_modules/@floating-ui/dom/dist/floating-ui.dom.mjs





function getCssDimensions(element) {
  const css = floating_ui_utils_dom_getComputedStyle(element);
  // In testing environments, the `width` and `height` properties are empty
  // strings for SVG elements, returning NaN. Fallback to `0` in this case.
  let width = parseFloat(css.width) || 0;
  let height = parseFloat(css.height) || 0;
  const hasOffset = isHTMLElement(element);
  const offsetWidth = hasOffset ? element.offsetWidth : width;
  const offsetHeight = hasOffset ? element.offsetHeight : height;
  const shouldFallback = round(width) !== offsetWidth || round(height) !== offsetHeight;
  if (shouldFallback) {
    width = offsetWidth;
    height = offsetHeight;
  }
  return {
    width,
    height,
    $: shouldFallback
  };
}

function unwrapElement(element) {
  return !isElement(element) ? element.contextElement : element;
}

function getScale(element) {
  const domElement = unwrapElement(element);
  if (!isHTMLElement(domElement)) {
    return createCoords(1);
  }
  const rect = domElement.getBoundingClientRect();
  const {
    width,
    height,
    $
  } = getCssDimensions(domElement);
  let x = ($ ? round(rect.width) : rect.width) / width;
  let y = ($ ? round(rect.height) : rect.height) / height;

  // 0, NaN, or Infinity should always fallback to 1.

  if (!x || !Number.isFinite(x)) {
    x = 1;
  }
  if (!y || !Number.isFinite(y)) {
    y = 1;
  }
  return {
    x,
    y
  };
}

const noOffsets = /*#__PURE__*/createCoords(0);
function getVisualOffsets(element) {
  const win = getWindow(element);
  if (!isWebKit() || !win.visualViewport) {
    return noOffsets;
  }
  return {
    x: win.visualViewport.offsetLeft,
    y: win.visualViewport.offsetTop
  };
}
function shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
  if (isFixed === void 0) {
    isFixed = false;
  }
  if (!floatingOffsetParent || isFixed && floatingOffsetParent !== getWindow(element)) {
    return false;
  }
  return isFixed;
}

function getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
  if (includeScale === void 0) {
    includeScale = false;
  }
  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }
  const clientRect = element.getBoundingClientRect();
  const domElement = unwrapElement(element);
  let scale = createCoords(1);
  if (includeScale) {
    if (offsetParent) {
      if (isElement(offsetParent)) {
        scale = getScale(offsetParent);
      }
    } else {
      scale = getScale(element);
    }
  }
  const visualOffsets = shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? getVisualOffsets(domElement) : createCoords(0);
  let x = (clientRect.left + visualOffsets.x) / scale.x;
  let y = (clientRect.top + visualOffsets.y) / scale.y;
  let width = clientRect.width / scale.x;
  let height = clientRect.height / scale.y;
  if (domElement) {
    const win = getWindow(domElement);
    const offsetWin = offsetParent && isElement(offsetParent) ? getWindow(offsetParent) : offsetParent;
    let currentWin = win;
    let currentIFrame = getFrameElement(currentWin);
    while (currentIFrame && offsetParent && offsetWin !== currentWin) {
      const iframeScale = getScale(currentIFrame);
      const iframeRect = currentIFrame.getBoundingClientRect();
      const css = floating_ui_utils_dom_getComputedStyle(currentIFrame);
      const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
      const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
      x *= iframeScale.x;
      y *= iframeScale.y;
      width *= iframeScale.x;
      height *= iframeScale.y;
      x += left;
      y += top;
      currentWin = getWindow(currentIFrame);
      currentIFrame = getFrameElement(currentWin);
    }
  }
  return floating_ui_utils_rectToClientRect({
    width,
    height,
    x,
    y
  });
}

function convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
  let {
    elements,
    rect,
    offsetParent,
    strategy
  } = _ref;
  const isFixed = strategy === 'fixed';
  const documentElement = getDocumentElement(offsetParent);
  const topLayer = elements ? isTopLayer(elements.floating) : false;
  if (offsetParent === documentElement || topLayer && isFixed) {
    return rect;
  }
  let scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  let scale = createCoords(1);
  const offsets = createCoords(0);
  const isOffsetParentAnElement = isHTMLElement(offsetParent);
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== 'body' || isOverflowElement(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isHTMLElement(offsetParent)) {
      const offsetRect = getBoundingClientRect(offsetParent);
      scale = getScale(offsetParent);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    }
  }
  return {
    width: rect.width * scale.x,
    height: rect.height * scale.y,
    x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x,
    y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y
  };
}

function getClientRects(element) {
  return Array.from(element.getClientRects());
}

// If <html> has a CSS width greater than the viewport, then this will be
// incorrect for RTL.
function getWindowScrollBarX(element, rect) {
  const leftScroll = getNodeScroll(element).scrollLeft;
  if (!rect) {
    return getBoundingClientRect(getDocumentElement(element)).left + leftScroll;
  }
  return rect.left + leftScroll;
}

// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function getDocumentRect(element) {
  const html = getDocumentElement(element);
  const scroll = getNodeScroll(element);
  const body = element.ownerDocument.body;
  const width = floating_ui_utils_max(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
  const height = floating_ui_utils_max(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
  let x = -scroll.scrollLeft + getWindowScrollBarX(element);
  const y = -scroll.scrollTop;
  if (floating_ui_utils_dom_getComputedStyle(body).direction === 'rtl') {
    x += floating_ui_utils_max(html.clientWidth, body.clientWidth) - width;
  }
  return {
    width,
    height,
    x,
    y
  };
}

function getViewportRect(element, strategy) {
  const win = getWindow(element);
  const html = getDocumentElement(element);
  const visualViewport = win.visualViewport;
  let width = html.clientWidth;
  let height = html.clientHeight;
  let x = 0;
  let y = 0;
  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    const visualViewportBased = isWebKit();
    if (!visualViewportBased || visualViewportBased && strategy === 'fixed') {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }
  return {
    width,
    height,
    x,
    y
  };
}

// Returns the inner client rect, subtracting scrollbars if present.
function getInnerBoundingClientRect(element, strategy) {
  const clientRect = getBoundingClientRect(element, true, strategy === 'fixed');
  const top = clientRect.top + element.clientTop;
  const left = clientRect.left + element.clientLeft;
  const scale = isHTMLElement(element) ? getScale(element) : createCoords(1);
  const width = element.clientWidth * scale.x;
  const height = element.clientHeight * scale.y;
  const x = left * scale.x;
  const y = top * scale.y;
  return {
    width,
    height,
    x,
    y
  };
}
function getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
  let rect;
  if (clippingAncestor === 'viewport') {
    rect = getViewportRect(element, strategy);
  } else if (clippingAncestor === 'document') {
    rect = getDocumentRect(getDocumentElement(element));
  } else if (isElement(clippingAncestor)) {
    rect = getInnerBoundingClientRect(clippingAncestor, strategy);
  } else {
    const visualOffsets = getVisualOffsets(element);
    rect = {
      ...clippingAncestor,
      x: clippingAncestor.x - visualOffsets.x,
      y: clippingAncestor.y - visualOffsets.y
    };
  }
  return floating_ui_utils_rectToClientRect(rect);
}
function hasFixedPositionAncestor(element, stopNode) {
  const parentNode = getParentNode(element);
  if (parentNode === stopNode || !isElement(parentNode) || isLastTraversableNode(parentNode)) {
    return false;
  }
  return floating_ui_utils_dom_getComputedStyle(parentNode).position === 'fixed' || hasFixedPositionAncestor(parentNode, stopNode);
}

// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function getClippingElementAncestors(element, cache) {
  const cachedResult = cache.get(element);
  if (cachedResult) {
    return cachedResult;
  }
  let result = getOverflowAncestors(element, [], false).filter(el => isElement(el) && getNodeName(el) !== 'body');
  let currentContainingBlockComputedStyle = null;
  const elementIsFixed = floating_ui_utils_dom_getComputedStyle(element).position === 'fixed';
  let currentNode = elementIsFixed ? getParentNode(element) : element;

  // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
  while (isElement(currentNode) && !isLastTraversableNode(currentNode)) {
    const computedStyle = floating_ui_utils_dom_getComputedStyle(currentNode);
    const currentNodeIsContaining = isContainingBlock(currentNode);
    if (!currentNodeIsContaining && computedStyle.position === 'fixed') {
      currentContainingBlockComputedStyle = null;
    }
    const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === 'static' && !!currentContainingBlockComputedStyle && ['absolute', 'fixed'].includes(currentContainingBlockComputedStyle.position) || isOverflowElement(currentNode) && !currentNodeIsContaining && hasFixedPositionAncestor(element, currentNode);
    if (shouldDropCurrentNode) {
      // Drop non-containing blocks.
      result = result.filter(ancestor => ancestor !== currentNode);
    } else {
      // Record last containing block for next iteration.
      currentContainingBlockComputedStyle = computedStyle;
    }
    currentNode = getParentNode(currentNode);
  }
  cache.set(element, result);
  return result;
}

// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function getClippingRect(_ref) {
  let {
    element,
    boundary,
    rootBoundary,
    strategy
  } = _ref;
  const elementClippingAncestors = boundary === 'clippingAncestors' ? isTopLayer(element) ? [] : getClippingElementAncestors(element, this._c) : [].concat(boundary);
  const clippingAncestors = [...elementClippingAncestors, rootBoundary];
  const firstClippingAncestor = clippingAncestors[0];
  const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor) => {
    const rect = getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
    accRect.top = floating_ui_utils_max(rect.top, accRect.top);
    accRect.right = floating_ui_utils_min(rect.right, accRect.right);
    accRect.bottom = floating_ui_utils_min(rect.bottom, accRect.bottom);
    accRect.left = floating_ui_utils_max(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
  return {
    width: clippingRect.right - clippingRect.left,
    height: clippingRect.bottom - clippingRect.top,
    x: clippingRect.left,
    y: clippingRect.top
  };
}

function getDimensions(element) {
  const {
    width,
    height
  } = getCssDimensions(element);
  return {
    width,
    height
  };
}

function getRectRelativeToOffsetParent(element, offsetParent, strategy) {
  const isOffsetParentAnElement = isHTMLElement(offsetParent);
  const documentElement = getDocumentElement(offsetParent);
  const isFixed = strategy === 'fixed';
  const rect = getBoundingClientRect(element, true, isFixed, offsetParent);
  let scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const offsets = createCoords(0);
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== 'body' || isOverflowElement(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isOffsetParentAnElement) {
      const offsetRect = getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    } else if (documentElement) {
      // If the <body> scrollbar appears on the left (e.g. RTL systems). Use
      // Firefox with layout.scrollbar.side = 3 in about:config to test this.
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }
  let htmlX = 0;
  let htmlY = 0;
  if (documentElement && !isOffsetParentAnElement && !isFixed) {
    const htmlRect = documentElement.getBoundingClientRect();
    htmlY = htmlRect.top + scroll.scrollTop;
    htmlX = htmlRect.left + scroll.scrollLeft -
    // RTL <body> scrollbar.
    getWindowScrollBarX(documentElement, htmlRect);
  }
  const x = rect.left + scroll.scrollLeft - offsets.x - htmlX;
  const y = rect.top + scroll.scrollTop - offsets.y - htmlY;
  return {
    x,
    y,
    width: rect.width,
    height: rect.height
  };
}

function isStaticPositioned(element) {
  return floating_ui_utils_dom_getComputedStyle(element).position === 'static';
}

function getTrueOffsetParent(element, polyfill) {
  if (!isHTMLElement(element) || floating_ui_utils_dom_getComputedStyle(element).position === 'fixed') {
    return null;
  }
  if (polyfill) {
    return polyfill(element);
  }
  let rawOffsetParent = element.offsetParent;

  // Firefox returns the <html> element as the offsetParent if it's non-static,
  // while Chrome and Safari return the <body> element. The <body> element must
  // be used to perform the correct calculations even if the <html> element is
  // non-static.
  if (getDocumentElement(element) === rawOffsetParent) {
    rawOffsetParent = rawOffsetParent.ownerDocument.body;
  }
  return rawOffsetParent;
}

// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function getOffsetParent(element, polyfill) {
  const win = getWindow(element);
  if (isTopLayer(element)) {
    return win;
  }
  if (!isHTMLElement(element)) {
    let svgOffsetParent = getParentNode(element);
    while (svgOffsetParent && !isLastTraversableNode(svgOffsetParent)) {
      if (isElement(svgOffsetParent) && !isStaticPositioned(svgOffsetParent)) {
        return svgOffsetParent;
      }
      svgOffsetParent = getParentNode(svgOffsetParent);
    }
    return win;
  }
  let offsetParent = getTrueOffsetParent(element, polyfill);
  while (offsetParent && isTableElement(offsetParent) && isStaticPositioned(offsetParent)) {
    offsetParent = getTrueOffsetParent(offsetParent, polyfill);
  }
  if (offsetParent && isLastTraversableNode(offsetParent) && isStaticPositioned(offsetParent) && !isContainingBlock(offsetParent)) {
    return win;
  }
  return offsetParent || getContainingBlock(element) || win;
}

const getElementRects = async function (data) {
  const getOffsetParentFn = this.getOffsetParent || getOffsetParent;
  const getDimensionsFn = this.getDimensions;
  const floatingDimensions = await getDimensionsFn(data.floating);
  return {
    reference: getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
    floating: {
      x: 0,
      y: 0,
      width: floatingDimensions.width,
      height: floatingDimensions.height
    }
  };
};

function isRTL(element) {
  return floating_ui_utils_dom_getComputedStyle(element).direction === 'rtl';
}

const platform = {
  convertOffsetParentRelativeRectToViewportRelativeRect,
  getDocumentElement: getDocumentElement,
  getClippingRect,
  getOffsetParent,
  getElementRects,
  getClientRects,
  getDimensions,
  getScale,
  isElement: isElement,
  isRTL
};

// https://samthor.au/2021/observing-dom/
function observeMove(element, onMove) {
  let io = null;
  let timeoutId;
  const root = getDocumentElement(element);
  function cleanup() {
    var _io;
    clearTimeout(timeoutId);
    (_io = io) == null || _io.disconnect();
    io = null;
  }
  function refresh(skip, threshold) {
    if (skip === void 0) {
      skip = false;
    }
    if (threshold === void 0) {
      threshold = 1;
    }
    cleanup();
    const {
      left,
      top,
      width,
      height
    } = element.getBoundingClientRect();
    if (!skip) {
      onMove();
    }
    if (!width || !height) {
      return;
    }
    const insetTop = floor(top);
    const insetRight = floor(root.clientWidth - (left + width));
    const insetBottom = floor(root.clientHeight - (top + height));
    const insetLeft = floor(left);
    const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
    const options = {
      rootMargin,
      threshold: floating_ui_utils_max(0, floating_ui_utils_min(1, threshold)) || 1
    };
    let isFirstUpdate = true;
    function handleObserve(entries) {
      const ratio = entries[0].intersectionRatio;
      if (ratio !== threshold) {
        if (!isFirstUpdate) {
          return refresh();
        }
        if (!ratio) {
          // If the reference is clipped, the ratio is 0. Throttle the refresh
          // to prevent an infinite loop of updates.
          timeoutId = setTimeout(() => {
            refresh(false, 1e-7);
          }, 1000);
        } else {
          refresh(false, ratio);
        }
      }
      isFirstUpdate = false;
    }

    // Older browsers don't support a `document` as the root and will throw an
    // error.
    try {
      io = new IntersectionObserver(handleObserve, {
        ...options,
        // Handle <iframe>s
        root: root.ownerDocument
      });
    } catch (e) {
      io = new IntersectionObserver(handleObserve, options);
    }
    io.observe(element);
  }
  refresh(true);
  return cleanup;
}

/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */
function autoUpdate(reference, floating, update, options) {
  if (options === void 0) {
    options = {};
  }
  const {
    ancestorScroll = true,
    ancestorResize = true,
    elementResize = typeof ResizeObserver === 'function',
    layoutShift = typeof IntersectionObserver === 'function',
    animationFrame = false
  } = options;
  const referenceEl = unwrapElement(reference);
  const ancestors = ancestorScroll || ancestorResize ? [...(referenceEl ? getOverflowAncestors(referenceEl) : []), ...getOverflowAncestors(floating)] : [];
  ancestors.forEach(ancestor => {
    ancestorScroll && ancestor.addEventListener('scroll', update, {
      passive: true
    });
    ancestorResize && ancestor.addEventListener('resize', update);
  });
  const cleanupIo = referenceEl && layoutShift ? observeMove(referenceEl, update) : null;
  let reobserveFrame = -1;
  let resizeObserver = null;
  if (elementResize) {
    resizeObserver = new ResizeObserver(_ref => {
      let [firstEntry] = _ref;
      if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
        // Prevent update loops when using the `size` middleware.
        // https://github.com/floating-ui/floating-ui/issues/1740
        resizeObserver.unobserve(floating);
        cancelAnimationFrame(reobserveFrame);
        reobserveFrame = requestAnimationFrame(() => {
          var _resizeObserver;
          (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
        });
      }
      update();
    });
    if (referenceEl && !animationFrame) {
      resizeObserver.observe(referenceEl);
    }
    resizeObserver.observe(floating);
  }
  let frameId;
  let prevRefRect = animationFrame ? getBoundingClientRect(reference) : null;
  if (animationFrame) {
    frameLoop();
  }
  function frameLoop() {
    const nextRefRect = getBoundingClientRect(reference);
    if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) {
      update();
    }
    prevRefRect = nextRefRect;
    frameId = requestAnimationFrame(frameLoop);
  }
  update();
  return () => {
    var _resizeObserver2;
    ancestors.forEach(ancestor => {
      ancestorScroll && ancestor.removeEventListener('scroll', update);
      ancestorResize && ancestor.removeEventListener('resize', update);
    });
    cleanupIo == null || cleanupIo();
    (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
    resizeObserver = null;
    if (animationFrame) {
      cancelAnimationFrame(frameId);
    }
  };
}

/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */
const floating_ui_dom_detectOverflow = (/* unused pure expression or super */ null && (detectOverflow$1));

/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */
const floating_ui_dom_offset = offset;

/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */
const floating_ui_dom_autoPlacement = (/* unused pure expression or super */ null && (autoPlacement$1));

/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */
const floating_ui_dom_shift = shift;

/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */
const floating_ui_dom_flip = flip;

/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */
const floating_ui_dom_size = size;

/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */
const floating_ui_dom_hide = hide;

/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */
const floating_ui_dom_arrow = arrow;

/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */
const floating_ui_dom_inline = (/* unused pure expression or super */ null && (inline$1));

/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */
const floating_ui_dom_limitShift = limitShift;

/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */
const floating_ui_dom_computePosition = (reference, floating, options) => {
  // This caches the expensive `getClippingElementAncestors` function so that
  // multiple lifecycle resets re-use the same result. It only lives for a
  // single call. If other functions become expensive, we can add them as well.
  const cache = new Map();
  const mergedOptions = {
    platform,
    ...options
  };
  const platformWithCache = {
    ...mergedOptions.platform,
    _c: cache
  };
  return computePosition(reference, floating, {
    ...mergedOptions,
    platform: platformWithCache
  });
};



;// CONCATENATED MODULE: ../node_modules/@floating-ui/react-dom/dist/floating-ui.react-dom.mjs






var index = typeof document !== 'undefined' ? react.useLayoutEffect : react.useEffect;

// Fork of `fast-deep-equal` that only does the comparisons we need and compares
// functions
function deepEqual(a, b) {
  if (a === b) {
    return true;
  }
  if (typeof a !== typeof b) {
    return false;
  }
  if (typeof a === 'function' && a.toString() === b.toString()) {
    return true;
  }
  let length;
  let i;
  let keys;
  if (a && b && typeof a === 'object') {
    if (Array.isArray(a)) {
      length = a.length;
      if (length !== b.length) return false;
      for (i = length; i-- !== 0;) {
        if (!deepEqual(a[i], b[i])) {
          return false;
        }
      }
      return true;
    }
    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) {
      return false;
    }
    for (i = length; i-- !== 0;) {
      if (!{}.hasOwnProperty.call(b, keys[i])) {
        return false;
      }
    }
    for (i = length; i-- !== 0;) {
      const key = keys[i];
      if (key === '_owner' && a.$$typeof) {
        continue;
      }
      if (!deepEqual(a[key], b[key])) {
        return false;
      }
    }
    return true;
  }
  return a !== a && b !== b;
}

function getDPR(element) {
  if (typeof window === 'undefined') {
    return 1;
  }
  const win = element.ownerDocument.defaultView || window;
  return win.devicePixelRatio || 1;
}

function roundByDPR(element, value) {
  const dpr = getDPR(element);
  return Math.round(value * dpr) / dpr;
}

function useLatestRef(value) {
  const ref = react.useRef(value);
  index(() => {
    ref.current = value;
  });
  return ref;
}

/**
 * Provides data to position a floating element.
 * @see https://floating-ui.com/docs/useFloating
 */
function useFloating(options) {
  if (options === void 0) {
    options = {};
  }
  const {
    placement = 'bottom',
    strategy = 'absolute',
    middleware = [],
    platform,
    elements: {
      reference: externalReference,
      floating: externalFloating
    } = {},
    transform = true,
    whileElementsMounted,
    open
  } = options;
  const [data, setData] = react.useState({
    x: 0,
    y: 0,
    strategy,
    placement,
    middlewareData: {},
    isPositioned: false
  });
  const [latestMiddleware, setLatestMiddleware] = react.useState(middleware);
  if (!deepEqual(latestMiddleware, middleware)) {
    setLatestMiddleware(middleware);
  }
  const [_reference, _setReference] = react.useState(null);
  const [_floating, _setFloating] = react.useState(null);
  const setReference = react.useCallback(node => {
    if (node !== referenceRef.current) {
      referenceRef.current = node;
      _setReference(node);
    }
  }, []);
  const setFloating = react.useCallback(node => {
    if (node !== floatingRef.current) {
      floatingRef.current = node;
      _setFloating(node);
    }
  }, []);
  const referenceEl = externalReference || _reference;
  const floatingEl = externalFloating || _floating;
  const referenceRef = react.useRef(null);
  const floatingRef = react.useRef(null);
  const dataRef = react.useRef(data);
  const hasWhileElementsMounted = whileElementsMounted != null;
  const whileElementsMountedRef = useLatestRef(whileElementsMounted);
  const platformRef = useLatestRef(platform);
  const openRef = useLatestRef(open);
  const update = react.useCallback(() => {
    if (!referenceRef.current || !floatingRef.current) {
      return;
    }
    const config = {
      placement,
      strategy,
      middleware: latestMiddleware
    };
    if (platformRef.current) {
      config.platform = platformRef.current;
    }
    floating_ui_dom_computePosition(referenceRef.current, floatingRef.current, config).then(data => {
      const fullData = {
        ...data,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: openRef.current !== false
      };
      if (isMountedRef.current && !deepEqual(dataRef.current, fullData)) {
        dataRef.current = fullData;
        react_dom.flushSync(() => {
          setData(fullData);
        });
      }
    });
  }, [latestMiddleware, placement, strategy, platformRef, openRef]);
  index(() => {
    if (open === false && dataRef.current.isPositioned) {
      dataRef.current.isPositioned = false;
      setData(data => ({
        ...data,
        isPositioned: false
      }));
    }
  }, [open]);
  const isMountedRef = react.useRef(false);
  index(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);
  index(() => {
    if (referenceEl) referenceRef.current = referenceEl;
    if (floatingEl) floatingRef.current = floatingEl;
    if (referenceEl && floatingEl) {
      if (whileElementsMountedRef.current) {
        return whileElementsMountedRef.current(referenceEl, floatingEl, update);
      }
      update();
    }
  }, [referenceEl, floatingEl, update, whileElementsMountedRef, hasWhileElementsMounted]);
  const refs = react.useMemo(() => ({
    reference: referenceRef,
    floating: floatingRef,
    setReference,
    setFloating
  }), [setReference, setFloating]);
  const elements = react.useMemo(() => ({
    reference: referenceEl,
    floating: floatingEl
  }), [referenceEl, floatingEl]);
  const floatingStyles = react.useMemo(() => {
    const initialStyles = {
      position: strategy,
      left: 0,
      top: 0
    };
    if (!elements.floating) {
      return initialStyles;
    }
    const x = roundByDPR(elements.floating, data.x);
    const y = roundByDPR(elements.floating, data.y);
    if (transform) {
      return {
        ...initialStyles,
        transform: "translate(" + x + "px, " + y + "px)",
        ...(getDPR(elements.floating) >= 1.5 && {
          willChange: 'transform'
        })
      };
    }
    return {
      position: strategy,
      left: x,
      top: y
    };
  }, [strategy, transform, elements.floating, data.x, data.y]);
  return react.useMemo(() => ({
    ...data,
    update,
    refs,
    elements,
    floatingStyles
  }), [data, update, refs, elements, floatingStyles]);
}

/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */
const arrow$1 = options => {
  function isRef(value) {
    return {}.hasOwnProperty.call(value, 'current');
  }
  return {
    name: 'arrow',
    options,
    fn(state) {
      const {
        element,
        padding
      } = typeof options === 'function' ? options(state) : options;
      if (element && isRef(element)) {
        if (element.current != null) {
          return floating_ui_dom_arrow({
            element: element.current,
            padding
          }).fn(state);
        }
        return {};
      }
      if (element) {
        return floating_ui_dom_arrow({
          element,
          padding
        }).fn(state);
      }
      return {};
    }
  };
};

/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */
const floating_ui_react_dom_offset = (options, deps) => ({
  ...floating_ui_dom_offset(options),
  options: [options, deps]
});

/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */
const floating_ui_react_dom_shift = (options, deps) => ({
  ...floating_ui_dom_shift(options),
  options: [options, deps]
});

/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */
const floating_ui_react_dom_limitShift = (options, deps) => ({
  ...floating_ui_dom_limitShift(options),
  options: [options, deps]
});

/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */
const floating_ui_react_dom_flip = (options, deps) => ({
  ...floating_ui_dom_flip(options),
  options: [options, deps]
});

/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */
const floating_ui_react_dom_size = (options, deps) => ({
  ...floating_ui_dom_size(options),
  options: [options, deps]
});

/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */
const floating_ui_react_dom_autoPlacement = (options, deps) => ({
  ...autoPlacement$1(options),
  options: [options, deps]
});

/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */
const floating_ui_react_dom_hide = (options, deps) => ({
  ...floating_ui_dom_hide(options),
  options: [options, deps]
});

/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */
const floating_ui_react_dom_inline = (options, deps) => ({
  ...inline$1(options),
  options: [options, deps]
});

/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */
const floating_ui_react_dom_arrow = (options, deps) => ({
  ...arrow$1(options),
  options: [options, deps]
});



;// CONCATENATED MODULE: ../node_modules/@radix-ui/react-arrow/dist/index.mjs







/* -------------------------------------------------------------------------------------------------
 * Arrow
 * -----------------------------------------------------------------------------------------------*/ const $7e8f5cd07187803e$var$NAME = 'Arrow';
const $7e8f5cd07187803e$export$21b07c8f274aebd5 = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { children: children , width: width = 10 , height: height = 5 , ...arrowProps } = props;
    return /*#__PURE__*/ (0,react.createElement)(react_primitive_dist/* Primitive.svg */.WV.svg, (0,esm_extends/* default */.Z)({}, arrowProps, {
        ref: forwardedRef,
        width: width,
        height: height,
        viewBox: "0 0 30 10",
        preserveAspectRatio: "none"
    }), props.asChild ? children : /*#__PURE__*/ (0,react.createElement)("polygon", {
        points: "0,0 30,0 15,10"
    }));
});
/*#__PURE__*/ Object.assign($7e8f5cd07187803e$export$21b07c8f274aebd5, {
    displayName: $7e8f5cd07187803e$var$NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $7e8f5cd07187803e$export$be92b6f5f03c0fe9 = $7e8f5cd07187803e$export$21b07c8f274aebd5;





//# sourceMappingURL=index.mjs.map

// EXTERNAL MODULE: ../node_modules/@radix-ui/react-use-size/dist/index.mjs
var react_use_size_dist = __webpack_require__(40261);
;// CONCATENATED MODULE: ../node_modules/@radix-ui/react-popper/dist/index.mjs





















const $cf1ac5d9fe0e8206$export$36f0086da09c4b9f = (/* unused pure expression or super */ null && ([
    'top',
    'right',
    'bottom',
    'left'
]));
const $cf1ac5d9fe0e8206$export$3671ffab7b302fc9 = (/* unused pure expression or super */ null && ([
    'start',
    'center',
    'end'
]));
/* -------------------------------------------------------------------------------------------------
 * Popper
 * -----------------------------------------------------------------------------------------------*/ const $cf1ac5d9fe0e8206$var$POPPER_NAME = 'Popper';
const [$cf1ac5d9fe0e8206$var$createPopperContext, $cf1ac5d9fe0e8206$export$722aac194ae923] = (0,react_context_dist/* createContextScope */.b)($cf1ac5d9fe0e8206$var$POPPER_NAME);
const [$cf1ac5d9fe0e8206$var$PopperProvider, $cf1ac5d9fe0e8206$var$usePopperContext] = $cf1ac5d9fe0e8206$var$createPopperContext($cf1ac5d9fe0e8206$var$POPPER_NAME);
const $cf1ac5d9fe0e8206$export$badac9ada3a0bdf9 = (props)=>{
    const { __scopePopper: __scopePopper , children: children  } = props;
    const [anchor, setAnchor] = (0,react.useState)(null);
    return /*#__PURE__*/ (0,react.createElement)($cf1ac5d9fe0e8206$var$PopperProvider, {
        scope: __scopePopper,
        anchor: anchor,
        onAnchorChange: setAnchor
    }, children);
};
/*#__PURE__*/ Object.assign($cf1ac5d9fe0e8206$export$badac9ada3a0bdf9, {
    displayName: $cf1ac5d9fe0e8206$var$POPPER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * PopperAnchor
 * -----------------------------------------------------------------------------------------------*/ const $cf1ac5d9fe0e8206$var$ANCHOR_NAME = 'PopperAnchor';
const $cf1ac5d9fe0e8206$export$ecd4e1ccab6ed6d = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { __scopePopper: __scopePopper , virtualRef: virtualRef , ...anchorProps } = props;
    const context = $cf1ac5d9fe0e8206$var$usePopperContext($cf1ac5d9fe0e8206$var$ANCHOR_NAME, __scopePopper);
    const ref = (0,react.useRef)(null);
    const composedRefs = (0,react_compose_refs_dist/* useComposedRefs */.e)(forwardedRef, ref);
    (0,react.useEffect)(()=>{
        // Consumer can anchor the popper to something that isn't
        // a DOM node e.g. pointer position, so we override the
        // `anchorRef` with their virtual ref in this case.
        context.onAnchorChange((virtualRef === null || virtualRef === void 0 ? void 0 : virtualRef.current) || ref.current);
    });
    return virtualRef ? null : /*#__PURE__*/ (0,react.createElement)(react_primitive_dist/* Primitive.div */.WV.div, (0,esm_extends/* default */.Z)({}, anchorProps, {
        ref: composedRefs
    }));
});
/*#__PURE__*/ Object.assign($cf1ac5d9fe0e8206$export$ecd4e1ccab6ed6d, {
    displayName: $cf1ac5d9fe0e8206$var$ANCHOR_NAME
});
/* -------------------------------------------------------------------------------------------------
 * PopperContent
 * -----------------------------------------------------------------------------------------------*/ const $cf1ac5d9fe0e8206$var$CONTENT_NAME = 'PopperContent';
const [$cf1ac5d9fe0e8206$var$PopperContentProvider, $cf1ac5d9fe0e8206$var$useContentContext] = $cf1ac5d9fe0e8206$var$createPopperContext($cf1ac5d9fe0e8206$var$CONTENT_NAME);
const $cf1ac5d9fe0e8206$export$bc4ae5855d3c4fc = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    var _arrowSize$width, _arrowSize$height, _middlewareData$arrow, _middlewareData$arrow2, _middlewareData$arrow3, _middlewareData$trans, _middlewareData$trans2, _middlewareData$hide;
    const { __scopePopper: __scopePopper , side: side = 'bottom' , sideOffset: sideOffset = 0 , align: align = 'center' , alignOffset: alignOffset = 0 , arrowPadding: arrowPadding = 0 , collisionBoundary: collisionBoundary = [] , collisionPadding: collisionPaddingProp = 0 , sticky: sticky = 'partial' , hideWhenDetached: hideWhenDetached = false , avoidCollisions: avoidCollisions = true , onPlaced: onPlaced , ...contentProps } = props;
    const context = $cf1ac5d9fe0e8206$var$usePopperContext($cf1ac5d9fe0e8206$var$CONTENT_NAME, __scopePopper);
    const [content, setContent] = (0,react.useState)(null);
    const composedRefs = (0,react_compose_refs_dist/* useComposedRefs */.e)(forwardedRef, (node)=>setContent(node)
    );
    const [arrow, setArrow] = (0,react.useState)(null);
    const arrowSize = (0,react_use_size_dist/* useSize */.t)(arrow);
    const arrowWidth = (_arrowSize$width = arrowSize === null || arrowSize === void 0 ? void 0 : arrowSize.width) !== null && _arrowSize$width !== void 0 ? _arrowSize$width : 0;
    const arrowHeight = (_arrowSize$height = arrowSize === null || arrowSize === void 0 ? void 0 : arrowSize.height) !== null && _arrowSize$height !== void 0 ? _arrowSize$height : 0;
    const desiredPlacement = side + (align !== 'center' ? '-' + align : '');
    const collisionPadding = typeof collisionPaddingProp === 'number' ? collisionPaddingProp : {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...collisionPaddingProp
    };
    const boundary = Array.isArray(collisionBoundary) ? collisionBoundary : [
        collisionBoundary
    ];
    const hasExplicitBoundaries = boundary.length > 0;
    const detectOverflowOptions = {
        padding: collisionPadding,
        boundary: boundary.filter($cf1ac5d9fe0e8206$var$isNotNull),
        // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
        altBoundary: hasExplicitBoundaries
    };
    const { refs: refs , floatingStyles: floatingStyles , placement: placement , isPositioned: isPositioned , middlewareData: middlewareData  } = useFloating({
        // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
        strategy: 'fixed',
        placement: desiredPlacement,
        whileElementsMounted: autoUpdate,
        elements: {
            reference: context.anchor
        },
        middleware: [
            floating_ui_react_dom_offset({
                mainAxis: sideOffset + arrowHeight,
                alignmentAxis: alignOffset
            }),
            avoidCollisions && floating_ui_react_dom_shift({
                mainAxis: true,
                crossAxis: false,
                limiter: sticky === 'partial' ? floating_ui_react_dom_limitShift() : undefined,
                ...detectOverflowOptions
            }),
            avoidCollisions && floating_ui_react_dom_flip({
                ...detectOverflowOptions
            }),
            floating_ui_react_dom_size({
                ...detectOverflowOptions,
                apply: ({ elements: elements , rects: rects , availableWidth: availableWidth , availableHeight: availableHeight  })=>{
                    const { width: anchorWidth , height: anchorHeight  } = rects.reference;
                    const contentStyle = elements.floating.style;
                    contentStyle.setProperty('--radix-popper-available-width', `${availableWidth}px`);
                    contentStyle.setProperty('--radix-popper-available-height', `${availableHeight}px`);
                    contentStyle.setProperty('--radix-popper-anchor-width', `${anchorWidth}px`);
                    contentStyle.setProperty('--radix-popper-anchor-height', `${anchorHeight}px`);
                }
            }),
            arrow && floating_ui_react_dom_arrow({
                element: arrow,
                padding: arrowPadding
            }),
            $cf1ac5d9fe0e8206$var$transformOrigin({
                arrowWidth: arrowWidth,
                arrowHeight: arrowHeight
            }),
            hideWhenDetached && floating_ui_react_dom_hide({
                strategy: 'referenceHidden'
            })
        ]
    });
    const [placedSide, placedAlign] = $cf1ac5d9fe0e8206$var$getSideAndAlignFromPlacement(placement);
    const handlePlaced = (0,react_use_callback_ref_dist/* useCallbackRef */.W)(onPlaced);
    (0,react_use_layout_effect_dist/* useLayoutEffect */.b)(()=>{
        if (isPositioned) handlePlaced === null || handlePlaced === void 0 || handlePlaced();
    }, [
        isPositioned,
        handlePlaced
    ]);
    const arrowX = (_middlewareData$arrow = middlewareData.arrow) === null || _middlewareData$arrow === void 0 ? void 0 : _middlewareData$arrow.x;
    const arrowY = (_middlewareData$arrow2 = middlewareData.arrow) === null || _middlewareData$arrow2 === void 0 ? void 0 : _middlewareData$arrow2.y;
    const cannotCenterArrow = ((_middlewareData$arrow3 = middlewareData.arrow) === null || _middlewareData$arrow3 === void 0 ? void 0 : _middlewareData$arrow3.centerOffset) !== 0;
    const [contentZIndex, setContentZIndex] = (0,react.useState)();
    (0,react_use_layout_effect_dist/* useLayoutEffect */.b)(()=>{
        if (content) setContentZIndex(window.getComputedStyle(content).zIndex);
    }, [
        content
    ]);
    return /*#__PURE__*/ (0,react.createElement)("div", {
        ref: refs.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
            ...floatingStyles,
            transform: isPositioned ? floatingStyles.transform : 'translate(0, -200%)',
            // keep off the page when measuring
            minWidth: 'max-content',
            zIndex: contentZIndex,
            ['--radix-popper-transform-origin']: [
                (_middlewareData$trans = middlewareData.transformOrigin) === null || _middlewareData$trans === void 0 ? void 0 : _middlewareData$trans.x,
                (_middlewareData$trans2 = middlewareData.transformOrigin) === null || _middlewareData$trans2 === void 0 ? void 0 : _middlewareData$trans2.y
            ].join(' ')
        } // Floating UI interally calculates logical alignment based the `dir` attribute on
        ,
        dir: props.dir
    }, /*#__PURE__*/ (0,react.createElement)($cf1ac5d9fe0e8206$var$PopperContentProvider, {
        scope: __scopePopper,
        placedSide: placedSide,
        onArrowChange: setArrow,
        arrowX: arrowX,
        arrowY: arrowY,
        shouldHideArrow: cannotCenterArrow
    }, /*#__PURE__*/ (0,react.createElement)(react_primitive_dist/* Primitive.div */.WV.div, (0,esm_extends/* default */.Z)({
        "data-side": placedSide,
        "data-align": placedAlign
    }, contentProps, {
        ref: composedRefs,
        style: {
            ...contentProps.style,
            // if the PopperContent hasn't been placed yet (not all measurements done)
            // we prevent animations so that users's animation don't kick in too early referring wrong sides
            animation: !isPositioned ? 'none' : undefined,
            // hide the content if using the hide middleware and should be hidden
            opacity: (_middlewareData$hide = middlewareData.hide) !== null && _middlewareData$hide !== void 0 && _middlewareData$hide.referenceHidden ? 0 : undefined
        }
    }))));
});
/*#__PURE__*/ Object.assign($cf1ac5d9fe0e8206$export$bc4ae5855d3c4fc, {
    displayName: $cf1ac5d9fe0e8206$var$CONTENT_NAME
});
/* -------------------------------------------------------------------------------------------------
 * PopperArrow
 * -----------------------------------------------------------------------------------------------*/ const $cf1ac5d9fe0e8206$var$ARROW_NAME = 'PopperArrow';
const $cf1ac5d9fe0e8206$var$OPPOSITE_SIDE = {
    top: 'bottom',
    right: 'left',
    bottom: 'top',
    left: 'right'
};
const $cf1ac5d9fe0e8206$export$79d62cd4e10a3fd0 = /*#__PURE__*/ (0,react.forwardRef)(function $cf1ac5d9fe0e8206$export$79d62cd4e10a3fd0(props, forwardedRef) {
    const { __scopePopper: __scopePopper , ...arrowProps } = props;
    const contentContext = $cf1ac5d9fe0e8206$var$useContentContext($cf1ac5d9fe0e8206$var$ARROW_NAME, __scopePopper);
    const baseSide = $cf1ac5d9fe0e8206$var$OPPOSITE_SIDE[contentContext.placedSide];
    return(/*#__PURE__*/ // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    (0,react.createElement)("span", {
        ref: contentContext.onArrowChange,
        style: {
            position: 'absolute',
            left: contentContext.arrowX,
            top: contentContext.arrowY,
            [baseSide]: 0,
            transformOrigin: {
                top: '',
                right: '0 0',
                bottom: 'center 0',
                left: '100% 0'
            }[contentContext.placedSide],
            transform: {
                top: 'translateY(100%)',
                right: 'translateY(50%) rotate(90deg) translateX(-50%)',
                bottom: `rotate(180deg)`,
                left: 'translateY(50%) rotate(-90deg) translateX(50%)'
            }[contentContext.placedSide],
            visibility: contentContext.shouldHideArrow ? 'hidden' : undefined
        }
    }, /*#__PURE__*/ (0,react.createElement)($7e8f5cd07187803e$export$be92b6f5f03c0fe9, (0,esm_extends/* default */.Z)({}, arrowProps, {
        ref: forwardedRef,
        style: {
            ...arrowProps.style,
            // ensures the element can be measured correctly (mostly for if SVG)
            display: 'block'
        }
    }))));
});
/*#__PURE__*/ Object.assign($cf1ac5d9fe0e8206$export$79d62cd4e10a3fd0, {
    displayName: $cf1ac5d9fe0e8206$var$ARROW_NAME
});
/* -----------------------------------------------------------------------------------------------*/ function $cf1ac5d9fe0e8206$var$isNotNull(value) {
    return value !== null;
}
const $cf1ac5d9fe0e8206$var$transformOrigin = (options)=>({
        name: 'transformOrigin',
        options: options,
        fn (data) {
            var _middlewareData$arrow4, _middlewareData$arrow5, _middlewareData$arrow6, _middlewareData$arrow7, _middlewareData$arrow8;
            const { placement: placement , rects: rects , middlewareData: middlewareData  } = data;
            const cannotCenterArrow = ((_middlewareData$arrow4 = middlewareData.arrow) === null || _middlewareData$arrow4 === void 0 ? void 0 : _middlewareData$arrow4.centerOffset) !== 0;
            const isArrowHidden = cannotCenterArrow;
            const arrowWidth = isArrowHidden ? 0 : options.arrowWidth;
            const arrowHeight = isArrowHidden ? 0 : options.arrowHeight;
            const [placedSide, placedAlign] = $cf1ac5d9fe0e8206$var$getSideAndAlignFromPlacement(placement);
            const noArrowAlign = {
                start: '0%',
                center: '50%',
                end: '100%'
            }[placedAlign];
            const arrowXCenter = ((_middlewareData$arrow5 = (_middlewareData$arrow6 = middlewareData.arrow) === null || _middlewareData$arrow6 === void 0 ? void 0 : _middlewareData$arrow6.x) !== null && _middlewareData$arrow5 !== void 0 ? _middlewareData$arrow5 : 0) + arrowWidth / 2;
            const arrowYCenter = ((_middlewareData$arrow7 = (_middlewareData$arrow8 = middlewareData.arrow) === null || _middlewareData$arrow8 === void 0 ? void 0 : _middlewareData$arrow8.y) !== null && _middlewareData$arrow7 !== void 0 ? _middlewareData$arrow7 : 0) + arrowHeight / 2;
            let x = '';
            let y = '';
            if (placedSide === 'bottom') {
                x = isArrowHidden ? noArrowAlign : `${arrowXCenter}px`;
                y = `${-arrowHeight}px`;
            } else if (placedSide === 'top') {
                x = isArrowHidden ? noArrowAlign : `${arrowXCenter}px`;
                y = `${rects.floating.height + arrowHeight}px`;
            } else if (placedSide === 'right') {
                x = `${-arrowHeight}px`;
                y = isArrowHidden ? noArrowAlign : `${arrowYCenter}px`;
            } else if (placedSide === 'left') {
                x = `${rects.floating.width + arrowHeight}px`;
                y = isArrowHidden ? noArrowAlign : `${arrowYCenter}px`;
            }
            return {
                data: {
                    x: x,
                    y: y
                }
            };
        }
    })
;
function $cf1ac5d9fe0e8206$var$getSideAndAlignFromPlacement(placement) {
    const [side, align = 'center'] = placement.split('-');
    return [
        side,
        align
    ];
}
const $cf1ac5d9fe0e8206$export$be92b6f5f03c0fe9 = $cf1ac5d9fe0e8206$export$badac9ada3a0bdf9;
const $cf1ac5d9fe0e8206$export$b688253958b8dfe7 = $cf1ac5d9fe0e8206$export$ecd4e1ccab6ed6d;
const $cf1ac5d9fe0e8206$export$7c6e2c02157bb7d2 = $cf1ac5d9fe0e8206$export$bc4ae5855d3c4fc;
const $cf1ac5d9fe0e8206$export$21b07c8f274aebd5 = $cf1ac5d9fe0e8206$export$79d62cd4e10a3fd0;





//# sourceMappingURL=index.mjs.map

;// CONCATENATED MODULE: ../node_modules/@radix-ui/react-popover/node_modules/@radix-ui/react-portal/dist/index.mjs









/* -------------------------------------------------------------------------------------------------
 * Portal
 * -----------------------------------------------------------------------------------------------*/ const dist_$f1701beae083dbae$var$PORTAL_NAME = 'Portal';
const dist_$f1701beae083dbae$export$602eac185826482c = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    var _globalThis$document;
    const { container: container = globalThis === null || globalThis === void 0 ? void 0 : (_globalThis$document = globalThis.document) === null || _globalThis$document === void 0 ? void 0 : _globalThis$document.body , ...portalProps } = props;
    return container ? /*#__PURE__*/ react_dom.createPortal(/*#__PURE__*/ (0,react.createElement)(react_primitive_dist/* Primitive.div */.WV.div, (0,esm_extends/* default */.Z)({}, portalProps, {
        ref: forwardedRef
    })), container) : null;
});
/*#__PURE__*/ Object.assign(dist_$f1701beae083dbae$export$602eac185826482c, {
    displayName: dist_$f1701beae083dbae$var$PORTAL_NAME
});
/* -----------------------------------------------------------------------------------------------*/ const dist_$f1701beae083dbae$export$be92b6f5f03c0fe9 = (/* unused pure expression or super */ null && (dist_$f1701beae083dbae$export$602eac185826482c));





//# sourceMappingURL=index.mjs.map

;// CONCATENATED MODULE: ../node_modules/@radix-ui/react-presence/dist/index.mjs










function dist_$fe963b355347cc68$export$3e6543de14f8614f(initialState, machine) {
    return (0,react.useReducer)((state, event)=>{
        const nextState = machine[state][event];
        return nextState !== null && nextState !== void 0 ? nextState : state;
    }, initialState);
}


const dist_$921a889cee6df7e8$export$99c2b779aa4e8b8b = (props)=>{
    const { present: present , children: children  } = props;
    const presence = dist_$921a889cee6df7e8$var$usePresence(present);
    const child = typeof children === 'function' ? children({
        present: presence.isPresent
    }) : react.Children.only(children);
    const ref = (0,react_compose_refs_dist/* useComposedRefs */.e)(presence.ref, child.ref);
    const forceMount = typeof children === 'function';
    return forceMount || presence.isPresent ? /*#__PURE__*/ (0,react.cloneElement)(child, {
        ref: ref
    }) : null;
};
dist_$921a889cee6df7e8$export$99c2b779aa4e8b8b.displayName = 'Presence';
/* -------------------------------------------------------------------------------------------------
 * usePresence
 * -----------------------------------------------------------------------------------------------*/ function dist_$921a889cee6df7e8$var$usePresence(present) {
    const [node1, setNode] = (0,react.useState)();
    const stylesRef = (0,react.useRef)({});
    const prevPresentRef = (0,react.useRef)(present);
    const prevAnimationNameRef = (0,react.useRef)('none');
    const initialState = present ? 'mounted' : 'unmounted';
    const [state, send] = dist_$fe963b355347cc68$export$3e6543de14f8614f(initialState, {
        mounted: {
            UNMOUNT: 'unmounted',
            ANIMATION_OUT: 'unmountSuspended'
        },
        unmountSuspended: {
            MOUNT: 'mounted',
            ANIMATION_END: 'unmounted'
        },
        unmounted: {
            MOUNT: 'mounted'
        }
    });
    (0,react.useEffect)(()=>{
        const currentAnimationName = dist_$921a889cee6df7e8$var$getAnimationName(stylesRef.current);
        prevAnimationNameRef.current = state === 'mounted' ? currentAnimationName : 'none';
    }, [
        state
    ]);
    (0,react_use_layout_effect_dist/* useLayoutEffect */.b)(()=>{
        const styles = stylesRef.current;
        const wasPresent = prevPresentRef.current;
        const hasPresentChanged = wasPresent !== present;
        if (hasPresentChanged) {
            const prevAnimationName = prevAnimationNameRef.current;
            const currentAnimationName = dist_$921a889cee6df7e8$var$getAnimationName(styles);
            if (present) send('MOUNT');
            else if (currentAnimationName === 'none' || (styles === null || styles === void 0 ? void 0 : styles.display) === 'none') // If there is no exit animation or the element is hidden, animations won't run
            // so we unmount instantly
            send('UNMOUNT');
            else {
                /**
         * When `present` changes to `false`, we check changes to animation-name to
         * determine whether an animation has started. We chose this approach (reading
         * computed styles) because there is no `animationrun` event and `animationstart`
         * fires after `animation-delay` has expired which would be too late.
         */ const isAnimating = prevAnimationName !== currentAnimationName;
                if (wasPresent && isAnimating) send('ANIMATION_OUT');
                else send('UNMOUNT');
            }
            prevPresentRef.current = present;
        }
    }, [
        present,
        send
    ]);
    (0,react_use_layout_effect_dist/* useLayoutEffect */.b)(()=>{
        if (node1) {
            /**
       * Triggering an ANIMATION_OUT during an ANIMATION_IN will fire an `animationcancel`
       * event for ANIMATION_IN after we have entered `unmountSuspended` state. So, we
       * make sure we only trigger ANIMATION_END for the currently active animation.
       */ const handleAnimationEnd = (event)=>{
                const currentAnimationName = dist_$921a889cee6df7e8$var$getAnimationName(stylesRef.current);
                const isCurrentAnimation = currentAnimationName.includes(event.animationName);
                if (event.target === node1 && isCurrentAnimation) // With React 18 concurrency this update is applied
                // a frame after the animation ends, creating a flash of visible content.
                // By manually flushing we ensure they sync within a frame, removing the flash.
                (0,react_dom.flushSync)(()=>send('ANIMATION_END')
                );
            };
            const handleAnimationStart = (event)=>{
                if (event.target === node1) // if animation occurred, store its name as the previous animation.
                prevAnimationNameRef.current = dist_$921a889cee6df7e8$var$getAnimationName(stylesRef.current);
            };
            node1.addEventListener('animationstart', handleAnimationStart);
            node1.addEventListener('animationcancel', handleAnimationEnd);
            node1.addEventListener('animationend', handleAnimationEnd);
            return ()=>{
                node1.removeEventListener('animationstart', handleAnimationStart);
                node1.removeEventListener('animationcancel', handleAnimationEnd);
                node1.removeEventListener('animationend', handleAnimationEnd);
            };
        } else // Transition to the unmounted state if the node is removed prematurely.
        // We avoid doing so during cleanup as the node may change but still exist.
        send('ANIMATION_END');
    }, [
        node1,
        send
    ]);
    return {
        isPresent: [
            'mounted',
            'unmountSuspended'
        ].includes(state),
        ref: (0,react.useCallback)((node)=>{
            if (node) stylesRef.current = getComputedStyle(node);
            setNode(node);
        }, [])
    };
}
/* -----------------------------------------------------------------------------------------------*/ function dist_$921a889cee6df7e8$var$getAnimationName(styles) {
    return (styles === null || styles === void 0 ? void 0 : styles.animationName) || 'none';
}





//# sourceMappingURL=index.mjs.map

;// CONCATENATED MODULE: ../node_modules/@radix-ui/react-popover/node_modules/@radix-ui/react-slot/dist/index.mjs







/* -------------------------------------------------------------------------------------------------
 * Slot
 * -----------------------------------------------------------------------------------------------*/ const dist_$5e63c961fc1ce211$export$8c6ed5c666ac1360 = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { children: children , ...slotProps } = props;
    const childrenArray = react.Children.toArray(children);
    const slottable = childrenArray.find(dist_$5e63c961fc1ce211$var$isSlottable);
    if (slottable) {
        // the new element to render is the one passed as a child of `Slottable`
        const newElement = slottable.props.children;
        const newChildren = childrenArray.map((child)=>{
            if (child === slottable) {
                // because the new element will be the one rendered, we are only interested
                // in grabbing its children (`newElement.props.children`)
                if (react.Children.count(newElement) > 1) return react.Children.only(null);
                return /*#__PURE__*/ (0,react.isValidElement)(newElement) ? newElement.props.children : null;
            } else return child;
        });
        return /*#__PURE__*/ (0,react.createElement)(dist_$5e63c961fc1ce211$var$SlotClone, (0,esm_extends/* default */.Z)({}, slotProps, {
            ref: forwardedRef
        }), /*#__PURE__*/ (0,react.isValidElement)(newElement) ? /*#__PURE__*/ (0,react.cloneElement)(newElement, undefined, newChildren) : null);
    }
    return /*#__PURE__*/ (0,react.createElement)(dist_$5e63c961fc1ce211$var$SlotClone, (0,esm_extends/* default */.Z)({}, slotProps, {
        ref: forwardedRef
    }), children);
});
dist_$5e63c961fc1ce211$export$8c6ed5c666ac1360.displayName = 'Slot';
/* -------------------------------------------------------------------------------------------------
 * SlotClone
 * -----------------------------------------------------------------------------------------------*/ const dist_$5e63c961fc1ce211$var$SlotClone = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { children: children , ...slotProps } = props;
    if (/*#__PURE__*/ (0,react.isValidElement)(children)) return /*#__PURE__*/ (0,react.cloneElement)(children, {
        ...dist_$5e63c961fc1ce211$var$mergeProps(slotProps, children.props),
        ref: forwardedRef ? (0,react_compose_refs_dist/* composeRefs */.F)(forwardedRef, children.ref) : children.ref
    });
    return react.Children.count(children) > 1 ? react.Children.only(null) : null;
});
dist_$5e63c961fc1ce211$var$SlotClone.displayName = 'SlotClone';
/* -------------------------------------------------------------------------------------------------
 * Slottable
 * -----------------------------------------------------------------------------------------------*/ const dist_$5e63c961fc1ce211$export$d9f1ccf0bdb05d45 = ({ children: children  })=>{
    return /*#__PURE__*/ (0,react.createElement)(react.Fragment, null, children);
};
/* ---------------------------------------------------------------------------------------------- */ function dist_$5e63c961fc1ce211$var$isSlottable(child) {
    return /*#__PURE__*/ (0,react.isValidElement)(child) && child.type === dist_$5e63c961fc1ce211$export$d9f1ccf0bdb05d45;
}
function dist_$5e63c961fc1ce211$var$mergeProps(slotProps, childProps) {
    // all child props should override
    const overrideProps = {
        ...childProps
    };
    for(const propName in childProps){
        const slotPropValue = slotProps[propName];
        const childPropValue = childProps[propName];
        const isHandler = /^on[A-Z]/.test(propName);
        if (isHandler) {
            // if the handler exists on both, we compose them
            if (slotPropValue && childPropValue) overrideProps[propName] = (...args)=>{
                childPropValue(...args);
                slotPropValue(...args);
            };
            else if (slotPropValue) overrideProps[propName] = slotPropValue;
        } else if (propName === 'style') overrideProps[propName] = {
            ...slotPropValue,
            ...childPropValue
        };
        else if (propName === 'className') overrideProps[propName] = [
            slotPropValue,
            childPropValue
        ].filter(Boolean).join(' ');
    }
    return {
        ...slotProps,
        ...overrideProps
    };
}
const dist_$5e63c961fc1ce211$export$be92b6f5f03c0fe9 = (/* unused pure expression or super */ null && (dist_$5e63c961fc1ce211$export$8c6ed5c666ac1360));





//# sourceMappingURL=index.mjs.map

// EXTERNAL MODULE: ../node_modules/@radix-ui/react-use-controllable-state/dist/index.mjs
var react_use_controllable_state_dist = __webpack_require__(37517);
;// CONCATENATED MODULE: ../node_modules/@radix-ui/react-popover/dist/index.mjs




































/* -------------------------------------------------------------------------------------------------
 * Popover
 * -----------------------------------------------------------------------------------------------*/ const $cb5cc270b50c6fcd$var$POPOVER_NAME = 'Popover';
const [$cb5cc270b50c6fcd$var$createPopoverContext, $cb5cc270b50c6fcd$export$c8393c9e73286932] = (0,react_context_dist/* createContextScope */.b)($cb5cc270b50c6fcd$var$POPOVER_NAME, [
    $cf1ac5d9fe0e8206$export$722aac194ae923
]);
const $cb5cc270b50c6fcd$var$usePopperScope = $cf1ac5d9fe0e8206$export$722aac194ae923();
const [$cb5cc270b50c6fcd$var$PopoverProvider, $cb5cc270b50c6fcd$var$usePopoverContext] = $cb5cc270b50c6fcd$var$createPopoverContext($cb5cc270b50c6fcd$var$POPOVER_NAME);
const $cb5cc270b50c6fcd$export$5b6b19405a83ff9d = (props)=>{
    const { __scopePopover: __scopePopover , children: children , open: openProp , defaultOpen: defaultOpen , onOpenChange: onOpenChange , modal: modal = false  } = props;
    const popperScope = $cb5cc270b50c6fcd$var$usePopperScope(__scopePopover);
    const triggerRef = (0,react.useRef)(null);
    const [hasCustomAnchor, setHasCustomAnchor] = (0,react.useState)(false);
    const [open = false, setOpen] = (0,react_use_controllable_state_dist/* useControllableState */.T)({
        prop: openProp,
        defaultProp: defaultOpen,
        onChange: onOpenChange
    });
    return /*#__PURE__*/ (0,react.createElement)($cf1ac5d9fe0e8206$export$be92b6f5f03c0fe9, popperScope, /*#__PURE__*/ (0,react.createElement)($cb5cc270b50c6fcd$var$PopoverProvider, {
        scope: __scopePopover,
        contentId: dist_$1746a345f3d73bb7$export$f680877a34711e37(),
        triggerRef: triggerRef,
        open: open,
        onOpenChange: setOpen,
        onOpenToggle: (0,react.useCallback)(()=>setOpen((prevOpen)=>!prevOpen
            )
        , [
            setOpen
        ]),
        hasCustomAnchor: hasCustomAnchor,
        onCustomAnchorAdd: (0,react.useCallback)(()=>setHasCustomAnchor(true)
        , []),
        onCustomAnchorRemove: (0,react.useCallback)(()=>setHasCustomAnchor(false)
        , []),
        modal: modal
    }, children));
};
/*#__PURE__*/ Object.assign($cb5cc270b50c6fcd$export$5b6b19405a83ff9d, {
    displayName: $cb5cc270b50c6fcd$var$POPOVER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * PopoverAnchor
 * -----------------------------------------------------------------------------------------------*/ const $cb5cc270b50c6fcd$var$ANCHOR_NAME = 'PopoverAnchor';
const $cb5cc270b50c6fcd$export$96e5381f42521a79 = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { __scopePopover: __scopePopover , ...anchorProps } = props;
    const context = $cb5cc270b50c6fcd$var$usePopoverContext($cb5cc270b50c6fcd$var$ANCHOR_NAME, __scopePopover);
    const popperScope = $cb5cc270b50c6fcd$var$usePopperScope(__scopePopover);
    const { onCustomAnchorAdd: onCustomAnchorAdd , onCustomAnchorRemove: onCustomAnchorRemove  } = context;
    (0,react.useEffect)(()=>{
        onCustomAnchorAdd();
        return ()=>onCustomAnchorRemove()
        ;
    }, [
        onCustomAnchorAdd,
        onCustomAnchorRemove
    ]);
    return /*#__PURE__*/ (0,react.createElement)($cf1ac5d9fe0e8206$export$b688253958b8dfe7, (0,esm_extends/* default */.Z)({}, popperScope, anchorProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($cb5cc270b50c6fcd$export$96e5381f42521a79, {
    displayName: $cb5cc270b50c6fcd$var$ANCHOR_NAME
});
/* -------------------------------------------------------------------------------------------------
 * PopoverTrigger
 * -----------------------------------------------------------------------------------------------*/ const $cb5cc270b50c6fcd$var$TRIGGER_NAME = 'PopoverTrigger';
const $cb5cc270b50c6fcd$export$7dacb05d26466c3 = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { __scopePopover: __scopePopover , ...triggerProps } = props;
    const context = $cb5cc270b50c6fcd$var$usePopoverContext($cb5cc270b50c6fcd$var$TRIGGER_NAME, __scopePopover);
    const popperScope = $cb5cc270b50c6fcd$var$usePopperScope(__scopePopover);
    const composedTriggerRef = (0,react_compose_refs_dist/* useComposedRefs */.e)(forwardedRef, context.triggerRef);
    const trigger = /*#__PURE__*/ (0,react.createElement)(react_primitive_dist/* Primitive.button */.WV.button, (0,esm_extends/* default */.Z)({
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": context.open,
        "aria-controls": context.contentId,
        "data-state": $cb5cc270b50c6fcd$var$getState(context.open)
    }, triggerProps, {
        ref: composedTriggerRef,
        onClick: (0,dist/* composeEventHandlers */.M)(props.onClick, context.onOpenToggle)
    }));
    return context.hasCustomAnchor ? trigger : /*#__PURE__*/ (0,react.createElement)($cf1ac5d9fe0e8206$export$b688253958b8dfe7, (0,esm_extends/* default */.Z)({
        asChild: true
    }, popperScope), trigger);
});
/*#__PURE__*/ Object.assign($cb5cc270b50c6fcd$export$7dacb05d26466c3, {
    displayName: $cb5cc270b50c6fcd$var$TRIGGER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * PopoverPortal
 * -----------------------------------------------------------------------------------------------*/ const $cb5cc270b50c6fcd$var$PORTAL_NAME = 'PopoverPortal';
const [$cb5cc270b50c6fcd$var$PortalProvider, $cb5cc270b50c6fcd$var$usePortalContext] = $cb5cc270b50c6fcd$var$createPopoverContext($cb5cc270b50c6fcd$var$PORTAL_NAME, {
    forceMount: undefined
});
const $cb5cc270b50c6fcd$export$dd679ffb4362d2d4 = (props)=>{
    const { __scopePopover: __scopePopover , forceMount: forceMount , children: children , container: container  } = props;
    const context = $cb5cc270b50c6fcd$var$usePopoverContext($cb5cc270b50c6fcd$var$PORTAL_NAME, __scopePopover);
    return /*#__PURE__*/ (0,react.createElement)($cb5cc270b50c6fcd$var$PortalProvider, {
        scope: __scopePopover,
        forceMount: forceMount
    }, /*#__PURE__*/ (0,react.createElement)(dist_$921a889cee6df7e8$export$99c2b779aa4e8b8b, {
        present: forceMount || context.open
    }, /*#__PURE__*/ (0,react.createElement)(dist_$f1701beae083dbae$export$602eac185826482c, {
        asChild: true,
        container: container
    }, children)));
};
/*#__PURE__*/ Object.assign($cb5cc270b50c6fcd$export$dd679ffb4362d2d4, {
    displayName: $cb5cc270b50c6fcd$var$PORTAL_NAME
});
/* -------------------------------------------------------------------------------------------------
 * PopoverContent
 * -----------------------------------------------------------------------------------------------*/ const $cb5cc270b50c6fcd$var$CONTENT_NAME = 'PopoverContent';
const $cb5cc270b50c6fcd$export$d7e1f420b25549ff = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const portalContext = $cb5cc270b50c6fcd$var$usePortalContext($cb5cc270b50c6fcd$var$CONTENT_NAME, props.__scopePopover);
    const { forceMount: forceMount = portalContext.forceMount , ...contentProps } = props;
    const context = $cb5cc270b50c6fcd$var$usePopoverContext($cb5cc270b50c6fcd$var$CONTENT_NAME, props.__scopePopover);
    return /*#__PURE__*/ (0,react.createElement)(dist_$921a889cee6df7e8$export$99c2b779aa4e8b8b, {
        present: forceMount || context.open
    }, context.modal ? /*#__PURE__*/ (0,react.createElement)($cb5cc270b50c6fcd$var$PopoverContentModal, (0,esm_extends/* default */.Z)({}, contentProps, {
        ref: forwardedRef
    })) : /*#__PURE__*/ (0,react.createElement)($cb5cc270b50c6fcd$var$PopoverContentNonModal, (0,esm_extends/* default */.Z)({}, contentProps, {
        ref: forwardedRef
    })));
});
/*#__PURE__*/ Object.assign($cb5cc270b50c6fcd$export$d7e1f420b25549ff, {
    displayName: $cb5cc270b50c6fcd$var$CONTENT_NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $cb5cc270b50c6fcd$var$PopoverContentModal = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const context = $cb5cc270b50c6fcd$var$usePopoverContext($cb5cc270b50c6fcd$var$CONTENT_NAME, props.__scopePopover);
    const contentRef = (0,react.useRef)(null);
    const composedRefs = (0,react_compose_refs_dist/* useComposedRefs */.e)(forwardedRef, contentRef);
    const isRightClickOutsideRef = (0,react.useRef)(false); // aria-hide everything except the content (better supported equivalent to setting aria-modal)
    (0,react.useEffect)(()=>{
        const content = contentRef.current;
        if (content) return hideOthers(content);
    }, []);
    return /*#__PURE__*/ (0,react.createElement)(Combination, {
        as: dist_$5e63c961fc1ce211$export$8c6ed5c666ac1360,
        allowPinchZoom: true
    }, /*#__PURE__*/ (0,react.createElement)($cb5cc270b50c6fcd$var$PopoverContentImpl, (0,esm_extends/* default */.Z)({}, props, {
        ref: composedRefs // we make sure we're not trapping once it's been closed
        ,
        trapFocus: context.open,
        disableOutsidePointerEvents: true,
        onCloseAutoFocus: (0,dist/* composeEventHandlers */.M)(props.onCloseAutoFocus, (event)=>{
            var _context$triggerRef$c;
            event.preventDefault();
            if (!isRightClickOutsideRef.current) (_context$triggerRef$c = context.triggerRef.current) === null || _context$triggerRef$c === void 0 || _context$triggerRef$c.focus();
        }),
        onPointerDownOutside: (0,dist/* composeEventHandlers */.M)(props.onPointerDownOutside, (event)=>{
            const originalEvent = event.detail.originalEvent;
            const ctrlLeftClick = originalEvent.button === 0 && originalEvent.ctrlKey === true;
            const isRightClick = originalEvent.button === 2 || ctrlLeftClick;
            isRightClickOutsideRef.current = isRightClick;
        }, {
            checkForDefaultPrevented: false
        }) // When focus is trapped, a `focusout` event may still happen.
        ,
        onFocusOutside: (0,dist/* composeEventHandlers */.M)(props.onFocusOutside, (event)=>event.preventDefault()
        , {
            checkForDefaultPrevented: false
        })
    })));
});
const $cb5cc270b50c6fcd$var$PopoverContentNonModal = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const context = $cb5cc270b50c6fcd$var$usePopoverContext($cb5cc270b50c6fcd$var$CONTENT_NAME, props.__scopePopover);
    const hasInteractedOutsideRef = (0,react.useRef)(false);
    const hasPointerDownOutsideRef = (0,react.useRef)(false);
    return /*#__PURE__*/ (0,react.createElement)($cb5cc270b50c6fcd$var$PopoverContentImpl, (0,esm_extends/* default */.Z)({}, props, {
        ref: forwardedRef,
        trapFocus: false,
        disableOutsidePointerEvents: false,
        onCloseAutoFocus: (event)=>{
            var _props$onCloseAutoFoc;
            (_props$onCloseAutoFoc = props.onCloseAutoFocus) === null || _props$onCloseAutoFoc === void 0 || _props$onCloseAutoFoc.call(props, event);
            if (!event.defaultPrevented) {
                var _context$triggerRef$c2;
                if (!hasInteractedOutsideRef.current) (_context$triggerRef$c2 = context.triggerRef.current) === null || _context$triggerRef$c2 === void 0 || _context$triggerRef$c2.focus(); // Always prevent auto focus because we either focus manually or want user agent focus
                event.preventDefault();
            }
            hasInteractedOutsideRef.current = false;
            hasPointerDownOutsideRef.current = false;
        },
        onInteractOutside: (event)=>{
            var _props$onInteractOuts, _context$triggerRef$c3;
            (_props$onInteractOuts = props.onInteractOutside) === null || _props$onInteractOuts === void 0 || _props$onInteractOuts.call(props, event);
            if (!event.defaultPrevented) {
                hasInteractedOutsideRef.current = true;
                if (event.detail.originalEvent.type === 'pointerdown') hasPointerDownOutsideRef.current = true;
            } // Prevent dismissing when clicking the trigger.
            // As the trigger is already setup to close, without doing so would
            // cause it to close and immediately open.
            const target = event.target;
            const targetIsTrigger = (_context$triggerRef$c3 = context.triggerRef.current) === null || _context$triggerRef$c3 === void 0 ? void 0 : _context$triggerRef$c3.contains(target);
            if (targetIsTrigger) event.preventDefault(); // On Safari if the trigger is inside a container with tabIndex={0}, when clicked
            // we will get the pointer down outside event on the trigger, but then a subsequent
            // focus outside event on the container, we ignore any focus outside event when we've
            // already had a pointer down outside event.
            if (event.detail.originalEvent.type === 'focusin' && hasPointerDownOutsideRef.current) event.preventDefault();
        }
    }));
});
/* -----------------------------------------------------------------------------------------------*/ const $cb5cc270b50c6fcd$var$PopoverContentImpl = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { __scopePopover: __scopePopover , trapFocus: trapFocus , onOpenAutoFocus: onOpenAutoFocus , onCloseAutoFocus: onCloseAutoFocus , disableOutsidePointerEvents: disableOutsidePointerEvents , onEscapeKeyDown: onEscapeKeyDown , onPointerDownOutside: onPointerDownOutside , onFocusOutside: onFocusOutside , onInteractOutside: onInteractOutside , ...contentProps } = props;
    const context = $cb5cc270b50c6fcd$var$usePopoverContext($cb5cc270b50c6fcd$var$CONTENT_NAME, __scopePopover);
    const popperScope = $cb5cc270b50c6fcd$var$usePopperScope(__scopePopover); // Make sure the whole tree has focus guards as our `Popover` may be
    // the last element in the DOM (beacuse of the `Portal`)
    dist_$3db38b7d1fb3fe6a$export$b7ece24a22aeda8c();
    return /*#__PURE__*/ (0,react.createElement)(dist_$d3863c46a17e8a28$export$20e40289641fbbb6, {
        asChild: true,
        loop: true,
        trapped: trapFocus,
        onMountAutoFocus: onOpenAutoFocus,
        onUnmountAutoFocus: onCloseAutoFocus
    }, /*#__PURE__*/ (0,react.createElement)(dist_$5cb92bef7577960e$export$177fb62ff3ec1f22, {
        asChild: true,
        disableOutsidePointerEvents: disableOutsidePointerEvents,
        onInteractOutside: onInteractOutside,
        onEscapeKeyDown: onEscapeKeyDown,
        onPointerDownOutside: onPointerDownOutside,
        onFocusOutside: onFocusOutside,
        onDismiss: ()=>context.onOpenChange(false)
    }, /*#__PURE__*/ (0,react.createElement)($cf1ac5d9fe0e8206$export$7c6e2c02157bb7d2, (0,esm_extends/* default */.Z)({
        "data-state": $cb5cc270b50c6fcd$var$getState(context.open),
        role: "dialog",
        id: context.contentId
    }, popperScope, contentProps, {
        ref: forwardedRef,
        style: {
            ...contentProps.style,
            '--radix-popover-content-transform-origin': 'var(--radix-popper-transform-origin)',
            '--radix-popover-content-available-width': 'var(--radix-popper-available-width)',
            '--radix-popover-content-available-height': 'var(--radix-popper-available-height)',
            '--radix-popover-trigger-width': 'var(--radix-popper-anchor-width)',
            '--radix-popover-trigger-height': 'var(--radix-popper-anchor-height)'
        }
    }))));
});
/* -------------------------------------------------------------------------------------------------
 * PopoverClose
 * -----------------------------------------------------------------------------------------------*/ const $cb5cc270b50c6fcd$var$CLOSE_NAME = 'PopoverClose';
const $cb5cc270b50c6fcd$export$d6ac43ebaa40d53e = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { __scopePopover: __scopePopover , ...closeProps } = props;
    const context = $cb5cc270b50c6fcd$var$usePopoverContext($cb5cc270b50c6fcd$var$CLOSE_NAME, __scopePopover);
    return /*#__PURE__*/ (0,react.createElement)(react_primitive_dist/* Primitive.button */.WV.button, (0,esm_extends/* default */.Z)({
        type: "button"
    }, closeProps, {
        ref: forwardedRef,
        onClick: (0,dist/* composeEventHandlers */.M)(props.onClick, ()=>context.onOpenChange(false)
        )
    }));
});
/*#__PURE__*/ Object.assign($cb5cc270b50c6fcd$export$d6ac43ebaa40d53e, {
    displayName: $cb5cc270b50c6fcd$var$CLOSE_NAME
});
/* -------------------------------------------------------------------------------------------------
 * PopoverArrow
 * -----------------------------------------------------------------------------------------------*/ const $cb5cc270b50c6fcd$var$ARROW_NAME = 'PopoverArrow';
const $cb5cc270b50c6fcd$export$3152841115e061b2 = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { __scopePopover: __scopePopover , ...arrowProps } = props;
    const popperScope = $cb5cc270b50c6fcd$var$usePopperScope(__scopePopover);
    return /*#__PURE__*/ (0,react.createElement)($cf1ac5d9fe0e8206$export$21b07c8f274aebd5, (0,esm_extends/* default */.Z)({}, popperScope, arrowProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($cb5cc270b50c6fcd$export$3152841115e061b2, {
    displayName: $cb5cc270b50c6fcd$var$ARROW_NAME
});
/* -----------------------------------------------------------------------------------------------*/ function $cb5cc270b50c6fcd$var$getState(open) {
    return open ? 'open' : 'closed';
}
const $cb5cc270b50c6fcd$export$be92b6f5f03c0fe9 = $cb5cc270b50c6fcd$export$5b6b19405a83ff9d;
const $cb5cc270b50c6fcd$export$b688253958b8dfe7 = (/* unused pure expression or super */ null && ($cb5cc270b50c6fcd$export$96e5381f42521a79));
const $cb5cc270b50c6fcd$export$41fb9f06171c75f4 = $cb5cc270b50c6fcd$export$7dacb05d26466c3;
const $cb5cc270b50c6fcd$export$602eac185826482c = $cb5cc270b50c6fcd$export$dd679ffb4362d2d4;
const $cb5cc270b50c6fcd$export$7c6e2c02157bb7d2 = $cb5cc270b50c6fcd$export$d7e1f420b25549ff;
const $cb5cc270b50c6fcd$export$f39c2d165cd861fe = $cb5cc270b50c6fcd$export$d6ac43ebaa40d53e;
const $cb5cc270b50c6fcd$export$21b07c8f274aebd5 = $cb5cc270b50c6fcd$export$3152841115e061b2;





//# sourceMappingURL=index.mjs.map

;// CONCATENATED MODULE: ../node_modules/@radix-ui/react-tooltip/node_modules/@radix-ui/react-use-escape-keydown/dist/index.mjs





/**
 * Listens for when the escape key is down
 */ function react_use_escape_keydown_dist_$addc16e1bbe58fd0$export$3a72a57244d6e765(onEscapeKeyDownProp, ownerDocument = globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) {
    const onEscapeKeyDown = (0,react_use_callback_ref_dist/* useCallbackRef */.W)(onEscapeKeyDownProp);
    (0,react.useEffect)(()=>{
        const handleKeyDown = (event)=>{
            if (event.key === 'Escape') onEscapeKeyDown(event);
        };
        ownerDocument.addEventListener('keydown', handleKeyDown);
        return ()=>ownerDocument.removeEventListener('keydown', handleKeyDown)
        ;
    }, [
        onEscapeKeyDown,
        ownerDocument
    ]);
}





//# sourceMappingURL=index.mjs.map

;// CONCATENATED MODULE: ../node_modules/@radix-ui/react-tooltip/node_modules/@radix-ui/react-dismissable-layer/dist/index.mjs















/* -------------------------------------------------------------------------------------------------
 * DismissableLayer
 * -----------------------------------------------------------------------------------------------*/ const react_dismissable_layer_dist_$5cb92bef7577960e$var$DISMISSABLE_LAYER_NAME = 'DismissableLayer';
const react_dismissable_layer_dist_$5cb92bef7577960e$var$CONTEXT_UPDATE = 'dismissableLayer.update';
const react_dismissable_layer_dist_$5cb92bef7577960e$var$POINTER_DOWN_OUTSIDE = 'dismissableLayer.pointerDownOutside';
const react_dismissable_layer_dist_$5cb92bef7577960e$var$FOCUS_OUTSIDE = 'dismissableLayer.focusOutside';
let react_dismissable_layer_dist_$5cb92bef7577960e$var$originalBodyPointerEvents;
const react_dismissable_layer_dist_$5cb92bef7577960e$var$DismissableLayerContext = /*#__PURE__*/ (0,react.createContext)({
    layers: new Set(),
    layersWithOutsidePointerEventsDisabled: new Set(),
    branches: new Set()
});
const react_dismissable_layer_dist_$5cb92bef7577960e$export$177fb62ff3ec1f22 = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    var _node$ownerDocument;
    const { disableOutsidePointerEvents: disableOutsidePointerEvents = false , onEscapeKeyDown: onEscapeKeyDown , onPointerDownOutside: onPointerDownOutside , onFocusOutside: onFocusOutside , onInteractOutside: onInteractOutside , onDismiss: onDismiss , ...layerProps } = props;
    const context = (0,react.useContext)(react_dismissable_layer_dist_$5cb92bef7577960e$var$DismissableLayerContext);
    const [node1, setNode] = (0,react.useState)(null);
    const ownerDocument = (_node$ownerDocument = node1 === null || node1 === void 0 ? void 0 : node1.ownerDocument) !== null && _node$ownerDocument !== void 0 ? _node$ownerDocument : globalThis === null || globalThis === void 0 ? void 0 : globalThis.document;
    const [, force] = (0,react.useState)({});
    const composedRefs = (0,react_compose_refs_dist/* useComposedRefs */.e)(forwardedRef, (node)=>setNode(node)
    );
    const layers = Array.from(context.layers);
    const [highestLayerWithOutsidePointerEventsDisabled] = [
        ...context.layersWithOutsidePointerEventsDisabled
    ].slice(-1); // prettier-ignore
    const highestLayerWithOutsidePointerEventsDisabledIndex = layers.indexOf(highestLayerWithOutsidePointerEventsDisabled); // prettier-ignore
    const index = node1 ? layers.indexOf(node1) : -1;
    const isBodyPointerEventsDisabled = context.layersWithOutsidePointerEventsDisabled.size > 0;
    const isPointerEventsEnabled = index >= highestLayerWithOutsidePointerEventsDisabledIndex;
    const pointerDownOutside = react_dismissable_layer_dist_$5cb92bef7577960e$var$usePointerDownOutside((event)=>{
        const target = event.target;
        const isPointerDownOnBranch = [
            ...context.branches
        ].some((branch)=>branch.contains(target)
        );
        if (!isPointerEventsEnabled || isPointerDownOnBranch) return;
        onPointerDownOutside === null || onPointerDownOutside === void 0 || onPointerDownOutside(event);
        onInteractOutside === null || onInteractOutside === void 0 || onInteractOutside(event);
        if (!event.defaultPrevented) onDismiss === null || onDismiss === void 0 || onDismiss();
    }, ownerDocument);
    const focusOutside = react_dismissable_layer_dist_$5cb92bef7577960e$var$useFocusOutside((event)=>{
        const target = event.target;
        const isFocusInBranch = [
            ...context.branches
        ].some((branch)=>branch.contains(target)
        );
        if (isFocusInBranch) return;
        onFocusOutside === null || onFocusOutside === void 0 || onFocusOutside(event);
        onInteractOutside === null || onInteractOutside === void 0 || onInteractOutside(event);
        if (!event.defaultPrevented) onDismiss === null || onDismiss === void 0 || onDismiss();
    }, ownerDocument);
    react_use_escape_keydown_dist_$addc16e1bbe58fd0$export$3a72a57244d6e765((event)=>{
        const isHighestLayer = index === context.layers.size - 1;
        if (!isHighestLayer) return;
        onEscapeKeyDown === null || onEscapeKeyDown === void 0 || onEscapeKeyDown(event);
        if (!event.defaultPrevented && onDismiss) {
            event.preventDefault();
            onDismiss();
        }
    }, ownerDocument);
    (0,react.useEffect)(()=>{
        if (!node1) return;
        if (disableOutsidePointerEvents) {
            if (context.layersWithOutsidePointerEventsDisabled.size === 0) {
                react_dismissable_layer_dist_$5cb92bef7577960e$var$originalBodyPointerEvents = ownerDocument.body.style.pointerEvents;
                ownerDocument.body.style.pointerEvents = 'none';
            }
            context.layersWithOutsidePointerEventsDisabled.add(node1);
        }
        context.layers.add(node1);
        react_dismissable_layer_dist_$5cb92bef7577960e$var$dispatchUpdate();
        return ()=>{
            if (disableOutsidePointerEvents && context.layersWithOutsidePointerEventsDisabled.size === 1) ownerDocument.body.style.pointerEvents = react_dismissable_layer_dist_$5cb92bef7577960e$var$originalBodyPointerEvents;
        };
    }, [
        node1,
        ownerDocument,
        disableOutsidePointerEvents,
        context
    ]);
    /**
   * We purposefully prevent combining this effect with the `disableOutsidePointerEvents` effect
   * because a change to `disableOutsidePointerEvents` would remove this layer from the stack
   * and add it to the end again so the layering order wouldn't be _creation order_.
   * We only want them to be removed from context stacks when unmounted.
   */ (0,react.useEffect)(()=>{
        return ()=>{
            if (!node1) return;
            context.layers.delete(node1);
            context.layersWithOutsidePointerEventsDisabled.delete(node1);
            react_dismissable_layer_dist_$5cb92bef7577960e$var$dispatchUpdate();
        };
    }, [
        node1,
        context
    ]);
    (0,react.useEffect)(()=>{
        const handleUpdate = ()=>force({})
        ;
        document.addEventListener(react_dismissable_layer_dist_$5cb92bef7577960e$var$CONTEXT_UPDATE, handleUpdate);
        return ()=>document.removeEventListener(react_dismissable_layer_dist_$5cb92bef7577960e$var$CONTEXT_UPDATE, handleUpdate)
        ;
    }, []);
    return /*#__PURE__*/ (0,react.createElement)(react_primitive_dist/* Primitive.div */.WV.div, (0,esm_extends/* default */.Z)({}, layerProps, {
        ref: composedRefs,
        style: {
            pointerEvents: isBodyPointerEventsDisabled ? isPointerEventsEnabled ? 'auto' : 'none' : undefined,
            ...props.style
        },
        onFocusCapture: (0,dist/* composeEventHandlers */.M)(props.onFocusCapture, focusOutside.onFocusCapture),
        onBlurCapture: (0,dist/* composeEventHandlers */.M)(props.onBlurCapture, focusOutside.onBlurCapture),
        onPointerDownCapture: (0,dist/* composeEventHandlers */.M)(props.onPointerDownCapture, pointerDownOutside.onPointerDownCapture)
    }));
});
/*#__PURE__*/ Object.assign(react_dismissable_layer_dist_$5cb92bef7577960e$export$177fb62ff3ec1f22, {
    displayName: react_dismissable_layer_dist_$5cb92bef7577960e$var$DISMISSABLE_LAYER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DismissableLayerBranch
 * -----------------------------------------------------------------------------------------------*/ const react_dismissable_layer_dist_$5cb92bef7577960e$var$BRANCH_NAME = 'DismissableLayerBranch';
const react_dismissable_layer_dist_$5cb92bef7577960e$export$4d5eb2109db14228 = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const context = (0,react.useContext)(react_dismissable_layer_dist_$5cb92bef7577960e$var$DismissableLayerContext);
    const ref = (0,react.useRef)(null);
    const composedRefs = (0,react_compose_refs_dist/* useComposedRefs */.e)(forwardedRef, ref);
    (0,react.useEffect)(()=>{
        const node = ref.current;
        if (node) {
            context.branches.add(node);
            return ()=>{
                context.branches.delete(node);
            };
        }
    }, [
        context.branches
    ]);
    return /*#__PURE__*/ (0,react.createElement)(react_primitive_dist/* Primitive.div */.WV.div, (0,esm_extends/* default */.Z)({}, props, {
        ref: composedRefs
    }));
});
/*#__PURE__*/ Object.assign(react_dismissable_layer_dist_$5cb92bef7577960e$export$4d5eb2109db14228, {
    displayName: react_dismissable_layer_dist_$5cb92bef7577960e$var$BRANCH_NAME
});
/* -----------------------------------------------------------------------------------------------*/ /**
 * Listens for `pointerdown` outside a react subtree. We use `pointerdown` rather than `pointerup`
 * to mimic layer dismissing behaviour present in OS.
 * Returns props to pass to the node we want to check for outside events.
 */ function react_dismissable_layer_dist_$5cb92bef7577960e$var$usePointerDownOutside(onPointerDownOutside, ownerDocument = globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) {
    const handlePointerDownOutside = (0,react_use_callback_ref_dist/* useCallbackRef */.W)(onPointerDownOutside);
    const isPointerInsideReactTreeRef = (0,react.useRef)(false);
    const handleClickRef = (0,react.useRef)(()=>{});
    (0,react.useEffect)(()=>{
        const handlePointerDown = (event)=>{
            if (event.target && !isPointerInsideReactTreeRef.current) {
                const eventDetail = {
                    originalEvent: event
                };
                function handleAndDispatchPointerDownOutsideEvent() {
                    react_dismissable_layer_dist_$5cb92bef7577960e$var$handleAndDispatchCustomEvent(react_dismissable_layer_dist_$5cb92bef7577960e$var$POINTER_DOWN_OUTSIDE, handlePointerDownOutside, eventDetail, {
                        discrete: true
                    });
                }
                /**
         * On touch devices, we need to wait for a click event because browsers implement
         * a ~350ms delay between the time the user stops touching the display and when the
         * browser executres events. We need to ensure we don't reactivate pointer-events within
         * this timeframe otherwise the browser may execute events that should have been prevented.
         *
         * Additionally, this also lets us deal automatically with cancellations when a click event
         * isn't raised because the page was considered scrolled/drag-scrolled, long-pressed, etc.
         *
         * This is why we also continuously remove the previous listener, because we cannot be
         * certain that it was raised, and therefore cleaned-up.
         */ if (event.pointerType === 'touch') {
                    ownerDocument.removeEventListener('click', handleClickRef.current);
                    handleClickRef.current = handleAndDispatchPointerDownOutsideEvent;
                    ownerDocument.addEventListener('click', handleClickRef.current, {
                        once: true
                    });
                } else handleAndDispatchPointerDownOutsideEvent();
            }
            isPointerInsideReactTreeRef.current = false;
        };
        /**
     * if this hook executes in a component that mounts via a `pointerdown` event, the event
     * would bubble up to the document and trigger a `pointerDownOutside` event. We avoid
     * this by delaying the event listener registration on the document.
     * This is not React specific, but rather how the DOM works, ie:
     * ```
     * button.addEventListener('pointerdown', () => {
     *   console.log('I will log');
     *   document.addEventListener('pointerdown', () => {
     *     console.log('I will also log');
     *   })
     * });
     */ const timerId = window.setTimeout(()=>{
            ownerDocument.addEventListener('pointerdown', handlePointerDown);
        }, 0);
        return ()=>{
            window.clearTimeout(timerId);
            ownerDocument.removeEventListener('pointerdown', handlePointerDown);
            ownerDocument.removeEventListener('click', handleClickRef.current);
        };
    }, [
        ownerDocument,
        handlePointerDownOutside
    ]);
    return {
        // ensures we check React component tree (not just DOM tree)
        onPointerDownCapture: ()=>isPointerInsideReactTreeRef.current = true
    };
}
/**
 * Listens for when focus happens outside a react subtree.
 * Returns props to pass to the root (node) of the subtree we want to check.
 */ function react_dismissable_layer_dist_$5cb92bef7577960e$var$useFocusOutside(onFocusOutside, ownerDocument = globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) {
    const handleFocusOutside = (0,react_use_callback_ref_dist/* useCallbackRef */.W)(onFocusOutside);
    const isFocusInsideReactTreeRef = (0,react.useRef)(false);
    (0,react.useEffect)(()=>{
        const handleFocus = (event)=>{
            if (event.target && !isFocusInsideReactTreeRef.current) {
                const eventDetail = {
                    originalEvent: event
                };
                react_dismissable_layer_dist_$5cb92bef7577960e$var$handleAndDispatchCustomEvent(react_dismissable_layer_dist_$5cb92bef7577960e$var$FOCUS_OUTSIDE, handleFocusOutside, eventDetail, {
                    discrete: false
                });
            }
        };
        ownerDocument.addEventListener('focusin', handleFocus);
        return ()=>ownerDocument.removeEventListener('focusin', handleFocus)
        ;
    }, [
        ownerDocument,
        handleFocusOutside
    ]);
    return {
        onFocusCapture: ()=>isFocusInsideReactTreeRef.current = true
        ,
        onBlurCapture: ()=>isFocusInsideReactTreeRef.current = false
    };
}
function react_dismissable_layer_dist_$5cb92bef7577960e$var$dispatchUpdate() {
    const event = new CustomEvent(react_dismissable_layer_dist_$5cb92bef7577960e$var$CONTEXT_UPDATE);
    document.dispatchEvent(event);
}
function react_dismissable_layer_dist_$5cb92bef7577960e$var$handleAndDispatchCustomEvent(name, handler, detail, { discrete: discrete  }) {
    const target = detail.originalEvent.target;
    const event = new CustomEvent(name, {
        bubbles: false,
        cancelable: true,
        detail: detail
    });
    if (handler) target.addEventListener(name, handler, {
        once: true
    });
    if (discrete) (0,react_primitive_dist/* dispatchDiscreteCustomEvent */.jH)(target, event);
    else target.dispatchEvent(event);
}
const react_dismissable_layer_dist_$5cb92bef7577960e$export$be92b6f5f03c0fe9 = (/* unused pure expression or super */ null && (react_dismissable_layer_dist_$5cb92bef7577960e$export$177fb62ff3ec1f22));
const react_dismissable_layer_dist_$5cb92bef7577960e$export$aecb2ddcb55c95be = (/* unused pure expression or super */ null && (react_dismissable_layer_dist_$5cb92bef7577960e$export$4d5eb2109db14228));





//# sourceMappingURL=index.mjs.map

;// CONCATENATED MODULE: ../node_modules/@radix-ui/react-tooltip/node_modules/@radix-ui/react-portal/dist/index.mjs









/* -------------------------------------------------------------------------------------------------
 * Portal
 * -----------------------------------------------------------------------------------------------*/ const react_portal_dist_$f1701beae083dbae$var$PORTAL_NAME = 'Portal';
const react_portal_dist_$f1701beae083dbae$export$602eac185826482c = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    var _globalThis$document;
    const { container: container = globalThis === null || globalThis === void 0 ? void 0 : (_globalThis$document = globalThis.document) === null || _globalThis$document === void 0 ? void 0 : _globalThis$document.body , ...portalProps } = props;
    return container ? /*#__PURE__*/ react_dom.createPortal(/*#__PURE__*/ (0,react.createElement)(react_primitive_dist/* Primitive.div */.WV.div, (0,esm_extends/* default */.Z)({}, portalProps, {
        ref: forwardedRef
    })), container) : null;
});
/*#__PURE__*/ Object.assign(react_portal_dist_$f1701beae083dbae$export$602eac185826482c, {
    displayName: react_portal_dist_$f1701beae083dbae$var$PORTAL_NAME
});
/* -----------------------------------------------------------------------------------------------*/ const react_portal_dist_$f1701beae083dbae$export$be92b6f5f03c0fe9 = (/* unused pure expression or super */ null && (react_portal_dist_$f1701beae083dbae$export$602eac185826482c));





//# sourceMappingURL=index.mjs.map

;// CONCATENATED MODULE: ../node_modules/@radix-ui/react-tooltip/node_modules/@radix-ui/react-slot/dist/index.mjs







/* -------------------------------------------------------------------------------------------------
 * Slot
 * -----------------------------------------------------------------------------------------------*/ const react_slot_dist_$5e63c961fc1ce211$export$8c6ed5c666ac1360 = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { children: children , ...slotProps } = props;
    const childrenArray = react.Children.toArray(children);
    const slottable = childrenArray.find(react_slot_dist_$5e63c961fc1ce211$var$isSlottable);
    if (slottable) {
        // the new element to render is the one passed as a child of `Slottable`
        const newElement = slottable.props.children;
        const newChildren = childrenArray.map((child)=>{
            if (child === slottable) {
                // because the new element will be the one rendered, we are only interested
                // in grabbing its children (`newElement.props.children`)
                if (react.Children.count(newElement) > 1) return react.Children.only(null);
                return /*#__PURE__*/ (0,react.isValidElement)(newElement) ? newElement.props.children : null;
            } else return child;
        });
        return /*#__PURE__*/ (0,react.createElement)(react_slot_dist_$5e63c961fc1ce211$var$SlotClone, (0,esm_extends/* default */.Z)({}, slotProps, {
            ref: forwardedRef
        }), /*#__PURE__*/ (0,react.isValidElement)(newElement) ? /*#__PURE__*/ (0,react.cloneElement)(newElement, undefined, newChildren) : null);
    }
    return /*#__PURE__*/ (0,react.createElement)(react_slot_dist_$5e63c961fc1ce211$var$SlotClone, (0,esm_extends/* default */.Z)({}, slotProps, {
        ref: forwardedRef
    }), children);
});
react_slot_dist_$5e63c961fc1ce211$export$8c6ed5c666ac1360.displayName = 'Slot';
/* -------------------------------------------------------------------------------------------------
 * SlotClone
 * -----------------------------------------------------------------------------------------------*/ const react_slot_dist_$5e63c961fc1ce211$var$SlotClone = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { children: children , ...slotProps } = props;
    if (/*#__PURE__*/ (0,react.isValidElement)(children)) return /*#__PURE__*/ (0,react.cloneElement)(children, {
        ...react_slot_dist_$5e63c961fc1ce211$var$mergeProps(slotProps, children.props),
        ref: forwardedRef ? (0,react_compose_refs_dist/* composeRefs */.F)(forwardedRef, children.ref) : children.ref
    });
    return react.Children.count(children) > 1 ? react.Children.only(null) : null;
});
react_slot_dist_$5e63c961fc1ce211$var$SlotClone.displayName = 'SlotClone';
/* -------------------------------------------------------------------------------------------------
 * Slottable
 * -----------------------------------------------------------------------------------------------*/ const react_slot_dist_$5e63c961fc1ce211$export$d9f1ccf0bdb05d45 = ({ children: children  })=>{
    return /*#__PURE__*/ (0,react.createElement)(react.Fragment, null, children);
};
/* ---------------------------------------------------------------------------------------------- */ function react_slot_dist_$5e63c961fc1ce211$var$isSlottable(child) {
    return /*#__PURE__*/ (0,react.isValidElement)(child) && child.type === react_slot_dist_$5e63c961fc1ce211$export$d9f1ccf0bdb05d45;
}
function react_slot_dist_$5e63c961fc1ce211$var$mergeProps(slotProps, childProps) {
    // all child props should override
    const overrideProps = {
        ...childProps
    };
    for(const propName in childProps){
        const slotPropValue = slotProps[propName];
        const childPropValue = childProps[propName];
        const isHandler = /^on[A-Z]/.test(propName);
        if (isHandler) {
            // if the handler exists on both, we compose them
            if (slotPropValue && childPropValue) overrideProps[propName] = (...args)=>{
                childPropValue(...args);
                slotPropValue(...args);
            };
            else if (slotPropValue) overrideProps[propName] = slotPropValue;
        } else if (propName === 'style') overrideProps[propName] = {
            ...slotPropValue,
            ...childPropValue
        };
        else if (propName === 'className') overrideProps[propName] = [
            slotPropValue,
            childPropValue
        ].filter(Boolean).join(' ');
    }
    return {
        ...slotProps,
        ...overrideProps
    };
}
const react_slot_dist_$5e63c961fc1ce211$export$be92b6f5f03c0fe9 = (/* unused pure expression or super */ null && (react_slot_dist_$5e63c961fc1ce211$export$8c6ed5c666ac1360));





//# sourceMappingURL=index.mjs.map

;// CONCATENATED MODULE: ../node_modules/@radix-ui/react-tooltip/node_modules/@radix-ui/react-visually-hidden/dist/index.mjs







/* -------------------------------------------------------------------------------------------------
 * VisuallyHidden
 * -----------------------------------------------------------------------------------------------*/ const $ea1ef594cf570d83$var$NAME = 'VisuallyHidden';
const $ea1ef594cf570d83$export$439d29a4e110a164 = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    return /*#__PURE__*/ (0,react.createElement)(react_primitive_dist/* Primitive.span */.WV.span, (0,esm_extends/* default */.Z)({}, props, {
        ref: forwardedRef,
        style: {
            // See: https://github.com/twbs/bootstrap/blob/master/scss/mixins/_screen-reader.scss
            position: 'absolute',
            border: 0,
            width: 1,
            height: 1,
            padding: 0,
            margin: -1,
            overflow: 'hidden',
            clip: 'rect(0, 0, 0, 0)',
            whiteSpace: 'nowrap',
            wordWrap: 'normal',
            ...props.style
        }
    }));
});
/*#__PURE__*/ Object.assign($ea1ef594cf570d83$export$439d29a4e110a164, {
    displayName: $ea1ef594cf570d83$var$NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $ea1ef594cf570d83$export$be92b6f5f03c0fe9 = $ea1ef594cf570d83$export$439d29a4e110a164;





//# sourceMappingURL=index.mjs.map

;// CONCATENATED MODULE: ../node_modules/@radix-ui/react-tooltip/dist/index.mjs






























const [$a093c7e1ec25a057$var$createTooltipContext, $a093c7e1ec25a057$export$1c540a2224f0d865] = (0,react_context_dist/* createContextScope */.b)('Tooltip', [
    $cf1ac5d9fe0e8206$export$722aac194ae923
]);
const $a093c7e1ec25a057$var$usePopperScope = $cf1ac5d9fe0e8206$export$722aac194ae923();
/* -------------------------------------------------------------------------------------------------
 * TooltipProvider
 * -----------------------------------------------------------------------------------------------*/ const $a093c7e1ec25a057$var$PROVIDER_NAME = 'TooltipProvider';
const $a093c7e1ec25a057$var$DEFAULT_DELAY_DURATION = 700;
const $a093c7e1ec25a057$var$TOOLTIP_OPEN = 'tooltip.open';
const [$a093c7e1ec25a057$var$TooltipProviderContextProvider, $a093c7e1ec25a057$var$useTooltipProviderContext] = $a093c7e1ec25a057$var$createTooltipContext($a093c7e1ec25a057$var$PROVIDER_NAME);
const $a093c7e1ec25a057$export$f78649fb9ca566b8 = (props)=>{
    const { __scopeTooltip: __scopeTooltip , delayDuration: delayDuration = $a093c7e1ec25a057$var$DEFAULT_DELAY_DURATION , skipDelayDuration: skipDelayDuration = 300 , disableHoverableContent: disableHoverableContent = false , children: children  } = props;
    const [isOpenDelayed, setIsOpenDelayed] = (0,react.useState)(true);
    const isPointerInTransitRef = (0,react.useRef)(false);
    const skipDelayTimerRef = (0,react.useRef)(0);
    (0,react.useEffect)(()=>{
        const skipDelayTimer = skipDelayTimerRef.current;
        return ()=>window.clearTimeout(skipDelayTimer)
        ;
    }, []);
    return /*#__PURE__*/ (0,react.createElement)($a093c7e1ec25a057$var$TooltipProviderContextProvider, {
        scope: __scopeTooltip,
        isOpenDelayed: isOpenDelayed,
        delayDuration: delayDuration,
        onOpen: (0,react.useCallback)(()=>{
            window.clearTimeout(skipDelayTimerRef.current);
            setIsOpenDelayed(false);
        }, []),
        onClose: (0,react.useCallback)(()=>{
            window.clearTimeout(skipDelayTimerRef.current);
            skipDelayTimerRef.current = window.setTimeout(()=>setIsOpenDelayed(true)
            , skipDelayDuration);
        }, [
            skipDelayDuration
        ]),
        isPointerInTransitRef: isPointerInTransitRef,
        onPointerInTransitChange: (0,react.useCallback)((inTransit)=>{
            isPointerInTransitRef.current = inTransit;
        }, []),
        disableHoverableContent: disableHoverableContent
    }, children);
};
/*#__PURE__*/ Object.assign($a093c7e1ec25a057$export$f78649fb9ca566b8, {
    displayName: $a093c7e1ec25a057$var$PROVIDER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * Tooltip
 * -----------------------------------------------------------------------------------------------*/ const $a093c7e1ec25a057$var$TOOLTIP_NAME = 'Tooltip';
const [$a093c7e1ec25a057$var$TooltipContextProvider, $a093c7e1ec25a057$var$useTooltipContext] = $a093c7e1ec25a057$var$createTooltipContext($a093c7e1ec25a057$var$TOOLTIP_NAME);
const $a093c7e1ec25a057$export$28c660c63b792dea = (props)=>{
    const { __scopeTooltip: __scopeTooltip , children: children , open: openProp , defaultOpen: defaultOpen = false , onOpenChange: onOpenChange , disableHoverableContent: disableHoverableContentProp , delayDuration: delayDurationProp  } = props;
    const providerContext = $a093c7e1ec25a057$var$useTooltipProviderContext($a093c7e1ec25a057$var$TOOLTIP_NAME, props.__scopeTooltip);
    const popperScope = $a093c7e1ec25a057$var$usePopperScope(__scopeTooltip);
    const [trigger, setTrigger] = (0,react.useState)(null);
    const contentId = dist_$1746a345f3d73bb7$export$f680877a34711e37();
    const openTimerRef = (0,react.useRef)(0);
    const disableHoverableContent = disableHoverableContentProp !== null && disableHoverableContentProp !== void 0 ? disableHoverableContentProp : providerContext.disableHoverableContent;
    const delayDuration = delayDurationProp !== null && delayDurationProp !== void 0 ? delayDurationProp : providerContext.delayDuration;
    const wasOpenDelayedRef = (0,react.useRef)(false);
    const [open1 = false, setOpen] = (0,react_use_controllable_state_dist/* useControllableState */.T)({
        prop: openProp,
        defaultProp: defaultOpen,
        onChange: (open)=>{
            if (open) {
                providerContext.onOpen(); // as `onChange` is called within a lifecycle method we
                // avoid dispatching via `dispatchDiscreteCustomEvent`.
                document.dispatchEvent(new CustomEvent($a093c7e1ec25a057$var$TOOLTIP_OPEN));
            } else providerContext.onClose();
            onOpenChange === null || onOpenChange === void 0 || onOpenChange(open);
        }
    });
    const stateAttribute = (0,react.useMemo)(()=>{
        return open1 ? wasOpenDelayedRef.current ? 'delayed-open' : 'instant-open' : 'closed';
    }, [
        open1
    ]);
    const handleOpen = (0,react.useCallback)(()=>{
        window.clearTimeout(openTimerRef.current);
        wasOpenDelayedRef.current = false;
        setOpen(true);
    }, [
        setOpen
    ]);
    const handleClose = (0,react.useCallback)(()=>{
        window.clearTimeout(openTimerRef.current);
        setOpen(false);
    }, [
        setOpen
    ]);
    const handleDelayedOpen = (0,react.useCallback)(()=>{
        window.clearTimeout(openTimerRef.current);
        openTimerRef.current = window.setTimeout(()=>{
            wasOpenDelayedRef.current = true;
            setOpen(true);
        }, delayDuration);
    }, [
        delayDuration,
        setOpen
    ]);
    (0,react.useEffect)(()=>{
        return ()=>window.clearTimeout(openTimerRef.current)
        ;
    }, []);
    return /*#__PURE__*/ (0,react.createElement)($cf1ac5d9fe0e8206$export$be92b6f5f03c0fe9, popperScope, /*#__PURE__*/ (0,react.createElement)($a093c7e1ec25a057$var$TooltipContextProvider, {
        scope: __scopeTooltip,
        contentId: contentId,
        open: open1,
        stateAttribute: stateAttribute,
        trigger: trigger,
        onTriggerChange: setTrigger,
        onTriggerEnter: (0,react.useCallback)(()=>{
            if (providerContext.isOpenDelayed) handleDelayedOpen();
            else handleOpen();
        }, [
            providerContext.isOpenDelayed,
            handleDelayedOpen,
            handleOpen
        ]),
        onTriggerLeave: (0,react.useCallback)(()=>{
            if (disableHoverableContent) handleClose();
            else // Clear the timer in case the pointer leaves the trigger before the tooltip is opened.
            window.clearTimeout(openTimerRef.current);
        }, [
            handleClose,
            disableHoverableContent
        ]),
        onOpen: handleOpen,
        onClose: handleClose,
        disableHoverableContent: disableHoverableContent
    }, children));
};
/*#__PURE__*/ Object.assign($a093c7e1ec25a057$export$28c660c63b792dea, {
    displayName: $a093c7e1ec25a057$var$TOOLTIP_NAME
});
/* -------------------------------------------------------------------------------------------------
 * TooltipTrigger
 * -----------------------------------------------------------------------------------------------*/ const $a093c7e1ec25a057$var$TRIGGER_NAME = 'TooltipTrigger';
const $a093c7e1ec25a057$export$8c610744efcf8a1d = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { __scopeTooltip: __scopeTooltip , ...triggerProps } = props;
    const context = $a093c7e1ec25a057$var$useTooltipContext($a093c7e1ec25a057$var$TRIGGER_NAME, __scopeTooltip);
    const providerContext = $a093c7e1ec25a057$var$useTooltipProviderContext($a093c7e1ec25a057$var$TRIGGER_NAME, __scopeTooltip);
    const popperScope = $a093c7e1ec25a057$var$usePopperScope(__scopeTooltip);
    const ref = (0,react.useRef)(null);
    const composedRefs = (0,react_compose_refs_dist/* useComposedRefs */.e)(forwardedRef, ref, context.onTriggerChange);
    const isPointerDownRef = (0,react.useRef)(false);
    const hasPointerMoveOpenedRef = (0,react.useRef)(false);
    const handlePointerUp = (0,react.useCallback)(()=>isPointerDownRef.current = false
    , []);
    (0,react.useEffect)(()=>{
        return ()=>document.removeEventListener('pointerup', handlePointerUp)
        ;
    }, [
        handlePointerUp
    ]);
    return /*#__PURE__*/ (0,react.createElement)($cf1ac5d9fe0e8206$export$b688253958b8dfe7, (0,esm_extends/* default */.Z)({
        asChild: true
    }, popperScope), /*#__PURE__*/ (0,react.createElement)(react_primitive_dist/* Primitive.button */.WV.button, (0,esm_extends/* default */.Z)({
        // We purposefully avoid adding `type=button` here because tooltip triggers are also
        // commonly anchors and the anchor `type` attribute signifies MIME type.
        "aria-describedby": context.open ? context.contentId : undefined,
        "data-state": context.stateAttribute
    }, triggerProps, {
        ref: composedRefs,
        onPointerMove: (0,dist/* composeEventHandlers */.M)(props.onPointerMove, (event)=>{
            if (event.pointerType === 'touch') return;
            if (!hasPointerMoveOpenedRef.current && !providerContext.isPointerInTransitRef.current) {
                context.onTriggerEnter();
                hasPointerMoveOpenedRef.current = true;
            }
        }),
        onPointerLeave: (0,dist/* composeEventHandlers */.M)(props.onPointerLeave, ()=>{
            context.onTriggerLeave();
            hasPointerMoveOpenedRef.current = false;
        }),
        onPointerDown: (0,dist/* composeEventHandlers */.M)(props.onPointerDown, ()=>{
            isPointerDownRef.current = true;
            document.addEventListener('pointerup', handlePointerUp, {
                once: true
            });
        }),
        onFocus: (0,dist/* composeEventHandlers */.M)(props.onFocus, ()=>{
            if (!isPointerDownRef.current) context.onOpen();
        }),
        onBlur: (0,dist/* composeEventHandlers */.M)(props.onBlur, context.onClose),
        onClick: (0,dist/* composeEventHandlers */.M)(props.onClick, context.onClose)
    })));
});
/*#__PURE__*/ Object.assign($a093c7e1ec25a057$export$8c610744efcf8a1d, {
    displayName: $a093c7e1ec25a057$var$TRIGGER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * TooltipPortal
 * -----------------------------------------------------------------------------------------------*/ const $a093c7e1ec25a057$var$PORTAL_NAME = 'TooltipPortal';
const [$a093c7e1ec25a057$var$PortalProvider, $a093c7e1ec25a057$var$usePortalContext] = $a093c7e1ec25a057$var$createTooltipContext($a093c7e1ec25a057$var$PORTAL_NAME, {
    forceMount: undefined
});
const $a093c7e1ec25a057$export$7b36b8f925ab7497 = (props)=>{
    const { __scopeTooltip: __scopeTooltip , forceMount: forceMount , children: children , container: container  } = props;
    const context = $a093c7e1ec25a057$var$useTooltipContext($a093c7e1ec25a057$var$PORTAL_NAME, __scopeTooltip);
    return /*#__PURE__*/ (0,react.createElement)($a093c7e1ec25a057$var$PortalProvider, {
        scope: __scopeTooltip,
        forceMount: forceMount
    }, /*#__PURE__*/ (0,react.createElement)(dist_$921a889cee6df7e8$export$99c2b779aa4e8b8b, {
        present: forceMount || context.open
    }, /*#__PURE__*/ (0,react.createElement)(react_portal_dist_$f1701beae083dbae$export$602eac185826482c, {
        asChild: true,
        container: container
    }, children)));
};
/*#__PURE__*/ Object.assign($a093c7e1ec25a057$export$7b36b8f925ab7497, {
    displayName: $a093c7e1ec25a057$var$PORTAL_NAME
});
/* -------------------------------------------------------------------------------------------------
 * TooltipContent
 * -----------------------------------------------------------------------------------------------*/ const $a093c7e1ec25a057$var$CONTENT_NAME = 'TooltipContent';
const $a093c7e1ec25a057$export$e9003e2be37ec060 = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const portalContext = $a093c7e1ec25a057$var$usePortalContext($a093c7e1ec25a057$var$CONTENT_NAME, props.__scopeTooltip);
    const { forceMount: forceMount = portalContext.forceMount , side: side = 'top' , ...contentProps } = props;
    const context = $a093c7e1ec25a057$var$useTooltipContext($a093c7e1ec25a057$var$CONTENT_NAME, props.__scopeTooltip);
    return /*#__PURE__*/ (0,react.createElement)(dist_$921a889cee6df7e8$export$99c2b779aa4e8b8b, {
        present: forceMount || context.open
    }, context.disableHoverableContent ? /*#__PURE__*/ (0,react.createElement)($a093c7e1ec25a057$var$TooltipContentImpl, (0,esm_extends/* default */.Z)({
        side: side
    }, contentProps, {
        ref: forwardedRef
    })) : /*#__PURE__*/ (0,react.createElement)($a093c7e1ec25a057$var$TooltipContentHoverable, (0,esm_extends/* default */.Z)({
        side: side
    }, contentProps, {
        ref: forwardedRef
    })));
});
const $a093c7e1ec25a057$var$TooltipContentHoverable = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const context = $a093c7e1ec25a057$var$useTooltipContext($a093c7e1ec25a057$var$CONTENT_NAME, props.__scopeTooltip);
    const providerContext = $a093c7e1ec25a057$var$useTooltipProviderContext($a093c7e1ec25a057$var$CONTENT_NAME, props.__scopeTooltip);
    const ref = (0,react.useRef)(null);
    const composedRefs = (0,react_compose_refs_dist/* useComposedRefs */.e)(forwardedRef, ref);
    const [pointerGraceArea, setPointerGraceArea] = (0,react.useState)(null);
    const { trigger: trigger , onClose: onClose  } = context;
    const content = ref.current;
    const { onPointerInTransitChange: onPointerInTransitChange  } = providerContext;
    const handleRemoveGraceArea = (0,react.useCallback)(()=>{
        setPointerGraceArea(null);
        onPointerInTransitChange(false);
    }, [
        onPointerInTransitChange
    ]);
    const handleCreateGraceArea = (0,react.useCallback)((event, hoverTarget)=>{
        const currentTarget = event.currentTarget;
        const exitPoint = {
            x: event.clientX,
            y: event.clientY
        };
        const exitSide = $a093c7e1ec25a057$var$getExitSideFromRect(exitPoint, currentTarget.getBoundingClientRect());
        const paddedExitPoints = $a093c7e1ec25a057$var$getPaddedExitPoints(exitPoint, exitSide);
        const hoverTargetPoints = $a093c7e1ec25a057$var$getPointsFromRect(hoverTarget.getBoundingClientRect());
        const graceArea = $a093c7e1ec25a057$var$getHull([
            ...paddedExitPoints,
            ...hoverTargetPoints
        ]);
        setPointerGraceArea(graceArea);
        onPointerInTransitChange(true);
    }, [
        onPointerInTransitChange
    ]);
    (0,react.useEffect)(()=>{
        return ()=>handleRemoveGraceArea()
        ;
    }, [
        handleRemoveGraceArea
    ]);
    (0,react.useEffect)(()=>{
        if (trigger && content) {
            const handleTriggerLeave = (event)=>handleCreateGraceArea(event, content)
            ;
            const handleContentLeave = (event)=>handleCreateGraceArea(event, trigger)
            ;
            trigger.addEventListener('pointerleave', handleTriggerLeave);
            content.addEventListener('pointerleave', handleContentLeave);
            return ()=>{
                trigger.removeEventListener('pointerleave', handleTriggerLeave);
                content.removeEventListener('pointerleave', handleContentLeave);
            };
        }
    }, [
        trigger,
        content,
        handleCreateGraceArea,
        handleRemoveGraceArea
    ]);
    (0,react.useEffect)(()=>{
        if (pointerGraceArea) {
            const handleTrackPointerGrace = (event)=>{
                const target = event.target;
                const pointerPosition = {
                    x: event.clientX,
                    y: event.clientY
                };
                const hasEnteredTarget = (trigger === null || trigger === void 0 ? void 0 : trigger.contains(target)) || (content === null || content === void 0 ? void 0 : content.contains(target));
                const isPointerOutsideGraceArea = !$a093c7e1ec25a057$var$isPointInPolygon(pointerPosition, pointerGraceArea);
                if (hasEnteredTarget) handleRemoveGraceArea();
                else if (isPointerOutsideGraceArea) {
                    handleRemoveGraceArea();
                    onClose();
                }
            };
            document.addEventListener('pointermove', handleTrackPointerGrace);
            return ()=>document.removeEventListener('pointermove', handleTrackPointerGrace)
            ;
        }
    }, [
        trigger,
        content,
        pointerGraceArea,
        onClose,
        handleRemoveGraceArea
    ]);
    return /*#__PURE__*/ (0,react.createElement)($a093c7e1ec25a057$var$TooltipContentImpl, (0,esm_extends/* default */.Z)({}, props, {
        ref: composedRefs
    }));
});
const [$a093c7e1ec25a057$var$VisuallyHiddenContentContextProvider, $a093c7e1ec25a057$var$useVisuallyHiddenContentContext] = $a093c7e1ec25a057$var$createTooltipContext($a093c7e1ec25a057$var$TOOLTIP_NAME, {
    isInside: false
});
const $a093c7e1ec25a057$var$TooltipContentImpl = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { __scopeTooltip: __scopeTooltip , children: children , 'aria-label': ariaLabel , onEscapeKeyDown: onEscapeKeyDown , onPointerDownOutside: onPointerDownOutside , ...contentProps } = props;
    const context = $a093c7e1ec25a057$var$useTooltipContext($a093c7e1ec25a057$var$CONTENT_NAME, __scopeTooltip);
    const popperScope = $a093c7e1ec25a057$var$usePopperScope(__scopeTooltip);
    const { onClose: onClose  } = context; // Close this tooltip if another one opens
    (0,react.useEffect)(()=>{
        document.addEventListener($a093c7e1ec25a057$var$TOOLTIP_OPEN, onClose);
        return ()=>document.removeEventListener($a093c7e1ec25a057$var$TOOLTIP_OPEN, onClose)
        ;
    }, [
        onClose
    ]); // Close the tooltip if the trigger is scrolled
    (0,react.useEffect)(()=>{
        if (context.trigger) {
            const handleScroll = (event)=>{
                const target = event.target;
                if (target !== null && target !== void 0 && target.contains(context.trigger)) onClose();
            };
            window.addEventListener('scroll', handleScroll, {
                capture: true
            });
            return ()=>window.removeEventListener('scroll', handleScroll, {
                    capture: true
                })
            ;
        }
    }, [
        context.trigger,
        onClose
    ]);
    return /*#__PURE__*/ (0,react.createElement)(react_dismissable_layer_dist_$5cb92bef7577960e$export$177fb62ff3ec1f22, {
        asChild: true,
        disableOutsidePointerEvents: false,
        onEscapeKeyDown: onEscapeKeyDown,
        onPointerDownOutside: onPointerDownOutside,
        onFocusOutside: (event)=>event.preventDefault()
        ,
        onDismiss: onClose
    }, /*#__PURE__*/ (0,react.createElement)($cf1ac5d9fe0e8206$export$7c6e2c02157bb7d2, (0,esm_extends/* default */.Z)({
        "data-state": context.stateAttribute
    }, popperScope, contentProps, {
        ref: forwardedRef,
        style: {
            ...contentProps.style,
            '--radix-tooltip-content-transform-origin': 'var(--radix-popper-transform-origin)',
            '--radix-tooltip-content-available-width': 'var(--radix-popper-available-width)',
            '--radix-tooltip-content-available-height': 'var(--radix-popper-available-height)',
            '--radix-tooltip-trigger-width': 'var(--radix-popper-anchor-width)',
            '--radix-tooltip-trigger-height': 'var(--radix-popper-anchor-height)'
        }
    }), /*#__PURE__*/ (0,react.createElement)(react_slot_dist_$5e63c961fc1ce211$export$d9f1ccf0bdb05d45, null, children), /*#__PURE__*/ (0,react.createElement)($a093c7e1ec25a057$var$VisuallyHiddenContentContextProvider, {
        scope: __scopeTooltip,
        isInside: true
    }, /*#__PURE__*/ (0,react.createElement)($ea1ef594cf570d83$export$be92b6f5f03c0fe9, {
        id: context.contentId,
        role: "tooltip"
    }, ariaLabel || children))));
});
/*#__PURE__*/ Object.assign($a093c7e1ec25a057$export$e9003e2be37ec060, {
    displayName: $a093c7e1ec25a057$var$CONTENT_NAME
});
/* -------------------------------------------------------------------------------------------------
 * TooltipArrow
 * -----------------------------------------------------------------------------------------------*/ const $a093c7e1ec25a057$var$ARROW_NAME = 'TooltipArrow';
const $a093c7e1ec25a057$export$c27ee0ad710f7559 = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { __scopeTooltip: __scopeTooltip , ...arrowProps } = props;
    const popperScope = $a093c7e1ec25a057$var$usePopperScope(__scopeTooltip);
    const visuallyHiddenContentContext = $a093c7e1ec25a057$var$useVisuallyHiddenContentContext($a093c7e1ec25a057$var$ARROW_NAME, __scopeTooltip); // if the arrow is inside the `VisuallyHidden`, we don't want to render it all to
    // prevent issues in positioning the arrow due to the duplicate
    return visuallyHiddenContentContext.isInside ? null : /*#__PURE__*/ (0,react.createElement)($cf1ac5d9fe0e8206$export$21b07c8f274aebd5, (0,esm_extends/* default */.Z)({}, popperScope, arrowProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($a093c7e1ec25a057$export$c27ee0ad710f7559, {
    displayName: $a093c7e1ec25a057$var$ARROW_NAME
});
/* -----------------------------------------------------------------------------------------------*/ function $a093c7e1ec25a057$var$getExitSideFromRect(point, rect) {
    const top = Math.abs(rect.top - point.y);
    const bottom = Math.abs(rect.bottom - point.y);
    const right = Math.abs(rect.right - point.x);
    const left = Math.abs(rect.left - point.x);
    switch(Math.min(top, bottom, right, left)){
        case left:
            return 'left';
        case right:
            return 'right';
        case top:
            return 'top';
        case bottom:
            return 'bottom';
        default:
            throw new Error('unreachable');
    }
}
function $a093c7e1ec25a057$var$getPaddedExitPoints(exitPoint, exitSide, padding = 5) {
    const paddedExitPoints = [];
    switch(exitSide){
        case 'top':
            paddedExitPoints.push({
                x: exitPoint.x - padding,
                y: exitPoint.y + padding
            }, {
                x: exitPoint.x + padding,
                y: exitPoint.y + padding
            });
            break;
        case 'bottom':
            paddedExitPoints.push({
                x: exitPoint.x - padding,
                y: exitPoint.y - padding
            }, {
                x: exitPoint.x + padding,
                y: exitPoint.y - padding
            });
            break;
        case 'left':
            paddedExitPoints.push({
                x: exitPoint.x + padding,
                y: exitPoint.y - padding
            }, {
                x: exitPoint.x + padding,
                y: exitPoint.y + padding
            });
            break;
        case 'right':
            paddedExitPoints.push({
                x: exitPoint.x - padding,
                y: exitPoint.y - padding
            }, {
                x: exitPoint.x - padding,
                y: exitPoint.y + padding
            });
            break;
    }
    return paddedExitPoints;
}
function $a093c7e1ec25a057$var$getPointsFromRect(rect) {
    const { top: top , right: right , bottom: bottom , left: left  } = rect;
    return [
        {
            x: left,
            y: top
        },
        {
            x: right,
            y: top
        },
        {
            x: right,
            y: bottom
        },
        {
            x: left,
            y: bottom
        }
    ];
} // Determine if a point is inside of a polygon.
// Based on https://github.com/substack/point-in-polygon
function $a093c7e1ec25a057$var$isPointInPolygon(point, polygon) {
    const { x: x , y: y  } = point;
    let inside = false;
    for(let i = 0, j = polygon.length - 1; i < polygon.length; j = i++){
        const xi = polygon[i].x;
        const yi = polygon[i].y;
        const xj = polygon[j].x;
        const yj = polygon[j].y; // prettier-ignore
        const intersect = yi > y !== yj > y && x < (xj - xi) * (y - yi) / (yj - yi) + xi;
        if (intersect) inside = !inside;
    }
    return inside;
} // Returns a new array of points representing the convex hull of the given set of points.
// https://www.nayuki.io/page/convex-hull-algorithm
function $a093c7e1ec25a057$var$getHull(points) {
    const newPoints = points.slice();
    newPoints.sort((a, b)=>{
        if (a.x < b.x) return -1;
        else if (a.x > b.x) return 1;
        else if (a.y < b.y) return -1;
        else if (a.y > b.y) return 1;
        else return 0;
    });
    return $a093c7e1ec25a057$var$getHullPresorted(newPoints);
} // Returns the convex hull, assuming that each points[i] <= points[i + 1]. Runs in O(n) time.
function $a093c7e1ec25a057$var$getHullPresorted(points) {
    if (points.length <= 1) return points.slice();
    const upperHull = [];
    for(let i = 0; i < points.length; i++){
        const p = points[i];
        while(upperHull.length >= 2){
            const q = upperHull[upperHull.length - 1];
            const r = upperHull[upperHull.length - 2];
            if ((q.x - r.x) * (p.y - r.y) >= (q.y - r.y) * (p.x - r.x)) upperHull.pop();
            else break;
        }
        upperHull.push(p);
    }
    upperHull.pop();
    const lowerHull = [];
    for(let i1 = points.length - 1; i1 >= 0; i1--){
        const p = points[i1];
        while(lowerHull.length >= 2){
            const q = lowerHull[lowerHull.length - 1];
            const r = lowerHull[lowerHull.length - 2];
            if ((q.x - r.x) * (p.y - r.y) >= (q.y - r.y) * (p.x - r.x)) lowerHull.pop();
            else break;
        }
        lowerHull.push(p);
    }
    lowerHull.pop();
    if (upperHull.length === 1 && lowerHull.length === 1 && upperHull[0].x === lowerHull[0].x && upperHull[0].y === lowerHull[0].y) return upperHull;
    else return upperHull.concat(lowerHull);
}
const $a093c7e1ec25a057$export$2881499e37b75b9a = $a093c7e1ec25a057$export$f78649fb9ca566b8;
const $a093c7e1ec25a057$export$be92b6f5f03c0fe9 = $a093c7e1ec25a057$export$28c660c63b792dea;
const $a093c7e1ec25a057$export$41fb9f06171c75f4 = $a093c7e1ec25a057$export$8c610744efcf8a1d;
const $a093c7e1ec25a057$export$602eac185826482c = $a093c7e1ec25a057$export$7b36b8f925ab7497;
const $a093c7e1ec25a057$export$7c6e2c02157bb7d2 = $a093c7e1ec25a057$export$e9003e2be37ec060;
const $a093c7e1ec25a057$export$21b07c8f274aebd5 = $a093c7e1ec25a057$export$c27ee0ad710f7559;





//# sourceMappingURL=index.mjs.map

;// CONCATENATED MODULE: ../node_modules/@radix-ui/react-toast/node_modules/@radix-ui/primitive/dist/index.module.js
function _radix_ui_primitive_dist_index_module_$e42e1063c40fb3ef$export$b9ecd428b558ff10(originalEventHandler, ourEventHandler, { checkForDefaultPrevented: checkForDefaultPrevented = true  } = {}) {
    return function handleEvent(event) {
        originalEventHandler === null || originalEventHandler === void 0 || originalEventHandler(event);
        if (checkForDefaultPrevented === false || !event.defaultPrevented) return ourEventHandler === null || ourEventHandler === void 0 ? void 0 : ourEventHandler(event);
    };
}





//# sourceMappingURL=index.module.js.map

;// CONCATENATED MODULE: ../node_modules/@radix-ui/react-toast/node_modules/@radix-ui/react-compose-refs/dist/index.module.js



/**
 * Set a given ref to a given value
 * This utility takes care of different types of refs: callback refs and RefObject(s)
 */ function react_toast_node_modules_radix_ui_react_compose_refs_dist_index_module_$6ed0406888f73fc4$var$setRef(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref !== null && ref !== undefined) ref.current = value;
}
/**
 * A utility to compose multiple refs together
 * Accepts callback refs and RefObject(s)
 */ function react_toast_node_modules_radix_ui_react_compose_refs_dist_index_module_$6ed0406888f73fc4$export$43e446d32b3d21af(...refs) {
    return (node)=>refs.forEach((ref)=>react_toast_node_modules_radix_ui_react_compose_refs_dist_index_module_$6ed0406888f73fc4$var$setRef(ref, node)
        )
    ;
}
/**
 * A custom hook that composes multiple refs
 * Accepts callback refs and RefObject(s)
 */ function react_toast_node_modules_radix_ui_react_compose_refs_dist_index_module_$6ed0406888f73fc4$export$c7b2cbe3552a0d05(...refs) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return (0,react.useCallback)(react_toast_node_modules_radix_ui_react_compose_refs_dist_index_module_$6ed0406888f73fc4$export$43e446d32b3d21af(...refs), refs);
}





//# sourceMappingURL=index.module.js.map

;// CONCATENATED MODULE: ../node_modules/@radix-ui/react-toast/node_modules/@radix-ui/react-context/dist/index.module.js



function react_context_dist_index_module_$c512c27ab02ef895$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
    const Context = /*#__PURE__*/ $3bkAK$createContext(defaultContext);
    function Provider(props) {
        const { children: children , ...context } = props; // Only re-memoize when prop values change
        // eslint-disable-next-line react-hooks/exhaustive-deps
        const value = $3bkAK$useMemo(()=>context
        , Object.values(context));
        return /*#__PURE__*/ $3bkAK$createElement(Context.Provider, {
            value: value
        }, children);
    }
    function useContext(consumerName) {
        const context = $3bkAK$useContext(Context);
        if (context) return context;
        if (defaultContext !== undefined) return defaultContext; // if a defaultContext wasn't specified, it's a required context.
        throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
    }
    Provider.displayName = rootComponentName + 'Provider';
    return [
        Provider,
        useContext
    ];
}
/* -------------------------------------------------------------------------------------------------
 * createContextScope
 * -----------------------------------------------------------------------------------------------*/ function react_context_dist_index_module_$c512c27ab02ef895$export$50c7b4e9d9f19c1(scopeName, createContextScopeDeps = []) {
    let defaultContexts = [];
    /* -----------------------------------------------------------------------------------------------
   * createContext
   * ---------------------------------------------------------------------------------------------*/ function $c512c27ab02ef895$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
        const BaseContext = /*#__PURE__*/ (0,react.createContext)(defaultContext);
        const index = defaultContexts.length;
        defaultContexts = [
            ...defaultContexts,
            defaultContext
        ];
        function Provider(props) {
            const { scope: scope , children: children , ...context } = props;
            const Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index]) || BaseContext; // Only re-memoize when prop values change
            // eslint-disable-next-line react-hooks/exhaustive-deps
            const value = (0,react.useMemo)(()=>context
            , Object.values(context));
            return /*#__PURE__*/ (0,react.createElement)(Context.Provider, {
                value: value
            }, children);
        }
        function useContext(consumerName, scope) {
            const Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index]) || BaseContext;
            const context = (0,react.useContext)(Context);
            if (context) return context;
            if (defaultContext !== undefined) return defaultContext; // if a defaultContext wasn't specified, it's a required context.
            throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
        }
        Provider.displayName = rootComponentName + 'Provider';
        return [
            Provider,
            useContext
        ];
    }
    /* -----------------------------------------------------------------------------------------------
   * createScope
   * ---------------------------------------------------------------------------------------------*/ const createScope = ()=>{
        const scopeContexts = defaultContexts.map((defaultContext)=>{
            return /*#__PURE__*/ (0,react.createContext)(defaultContext);
        });
        return function useScope(scope) {
            const contexts = (scope === null || scope === void 0 ? void 0 : scope[scopeName]) || scopeContexts;
            return (0,react.useMemo)(()=>({
                    [`__scope${scopeName}`]: {
                        ...scope,
                        [scopeName]: contexts
                    }
                })
            , [
                scope,
                contexts
            ]);
        };
    };
    createScope.scopeName = scopeName;
    return [
        $c512c27ab02ef895$export$fd42f52fd3ae1109,
        react_context_dist_index_module_$c512c27ab02ef895$var$composeContextScopes(createScope, ...createContextScopeDeps)
    ];
}
/* -------------------------------------------------------------------------------------------------
 * composeContextScopes
 * -----------------------------------------------------------------------------------------------*/ function react_context_dist_index_module_$c512c27ab02ef895$var$composeContextScopes(...scopes) {
    const baseScope = scopes[0];
    if (scopes.length === 1) return baseScope;
    const createScope1 = ()=>{
        const scopeHooks = scopes.map((createScope)=>({
                useScope: createScope(),
                scopeName: createScope.scopeName
            })
        );
        return function useComposedScopes(overrideScopes) {
            const nextScopes1 = scopeHooks.reduce((nextScopes, { useScope: useScope , scopeName: scopeName  })=>{
                // We are calling a hook inside a callback which React warns against to avoid inconsistent
                // renders, however, scoping doesn't have render side effects so we ignore the rule.
                // eslint-disable-next-line react-hooks/rules-of-hooks
                const scopeProps = useScope(overrideScopes);
                const currentScope = scopeProps[`__scope${scopeName}`];
                return {
                    ...nextScopes,
                    ...currentScope
                };
            }, {});
            return (0,react.useMemo)(()=>({
                    [`__scope${baseScope.scopeName}`]: nextScopes1
                })
            , [
                nextScopes1
            ]);
        };
    };
    createScope1.scopeName = baseScope.scopeName;
    return createScope1;
}





//# sourceMappingURL=index.module.js.map

;// CONCATENATED MODULE: ../node_modules/@radix-ui/react-toast/node_modules/@radix-ui/react-collection/dist/index.module.js









// We have resorted to returning slots directly rather than exposing primitives that can then
// be slotted like `<CollectionItem as={Slot}>…</CollectionItem>`.
// This is because we encountered issues with generic types that cannot be statically analysed
// due to creating them dynamically via createCollection.
function $e02a7d9cb1dc128c$export$c74125a8e3af6bb2(name) {
    /* -----------------------------------------------------------------------------------------------
   * CollectionProvider
   * ---------------------------------------------------------------------------------------------*/ const PROVIDER_NAME = name + 'CollectionProvider';
    const [createCollectionContext, createCollectionScope] = react_context_dist_index_module_$c512c27ab02ef895$export$50c7b4e9d9f19c1(PROVIDER_NAME);
    const [CollectionProviderImpl, useCollectionContext] = createCollectionContext(PROVIDER_NAME, {
        collectionRef: {
            current: null
        },
        itemMap: new Map()
    });
    const CollectionProvider = (props)=>{
        const { scope: scope , children: children  } = props;
        const ref = react.useRef(null);
        const itemMap = react.useRef(new Map()).current;
        return /*#__PURE__*/ react.createElement(CollectionProviderImpl, {
            scope: scope,
            itemMap: itemMap,
            collectionRef: ref
        }, children);
    };
    /*#__PURE__*/ Object.assign(CollectionProvider, {
        displayName: PROVIDER_NAME
    });
    /* -----------------------------------------------------------------------------------------------
   * CollectionSlot
   * ---------------------------------------------------------------------------------------------*/ const COLLECTION_SLOT_NAME = name + 'CollectionSlot';
    const CollectionSlot = /*#__PURE__*/ react.forwardRef((props, forwardedRef)=>{
        const { scope: scope , children: children  } = props;
        const context = useCollectionContext(COLLECTION_SLOT_NAME, scope);
        const composedRefs = react_toast_node_modules_radix_ui_react_compose_refs_dist_index_module_$6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, context.collectionRef);
        return /*#__PURE__*/ react.createElement($5e63c961fc1ce211$export$8c6ed5c666ac1360, {
            ref: composedRefs
        }, children);
    });
    /*#__PURE__*/ Object.assign(CollectionSlot, {
        displayName: COLLECTION_SLOT_NAME
    });
    /* -----------------------------------------------------------------------------------------------
   * CollectionItem
   * ---------------------------------------------------------------------------------------------*/ const ITEM_SLOT_NAME = name + 'CollectionItemSlot';
    const ITEM_DATA_ATTR = 'data-radix-collection-item';
    const CollectionItemSlot = /*#__PURE__*/ react.forwardRef((props, forwardedRef)=>{
        const { scope: scope , children: children , ...itemData } = props;
        const ref = react.useRef(null);
        const composedRefs = react_toast_node_modules_radix_ui_react_compose_refs_dist_index_module_$6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, ref);
        const context = useCollectionContext(ITEM_SLOT_NAME, scope);
        react.useEffect(()=>{
            context.itemMap.set(ref, {
                ref: ref,
                ...itemData
            });
            return ()=>void context.itemMap.delete(ref)
            ;
        });
        return /*#__PURE__*/ react.createElement($5e63c961fc1ce211$export$8c6ed5c666ac1360, {
            [ITEM_DATA_ATTR]: '',
            ref: composedRefs
        }, children);
    });
    /*#__PURE__*/ Object.assign(CollectionItemSlot, {
        displayName: ITEM_SLOT_NAME
    });
    /* -----------------------------------------------------------------------------------------------
   * useCollection
   * ---------------------------------------------------------------------------------------------*/ function useCollection(scope) {
        const context = useCollectionContext(name + 'CollectionConsumer', scope);
        const getItems = react.useCallback(()=>{
            const collectionNode = context.collectionRef.current;
            if (!collectionNode) return [];
            const orderedNodes = Array.from(collectionNode.querySelectorAll(`[${ITEM_DATA_ATTR}]`));
            const items = Array.from(context.itemMap.values());
            const orderedItems = items.sort((a, b)=>orderedNodes.indexOf(a.ref.current) - orderedNodes.indexOf(b.ref.current)
            );
            return orderedItems;
        }, [
            context.collectionRef,
            context.itemMap
        ]);
        return getItems;
    }
    return [
        {
            Provider: CollectionProvider,
            Slot: CollectionSlot,
            ItemSlot: CollectionItemSlot
        },
        useCollection,
        createCollectionScope
    ];
}





//# sourceMappingURL=index.module.js.map

;// CONCATENATED MODULE: ../node_modules/@radix-ui/react-toast/node_modules/@radix-ui/react-use-layout-effect/dist/index.module.js



/**
 * On the server, React emits a warning when calling `useLayoutEffect`.
 * This is because neither `useLayoutEffect` nor `useEffect` run on the server.
 * We use this safe version which suppresses the warning by replacing it with a noop on the server.
 *
 * See: https://reactjs.org/docs/hooks-reference.html#uselayouteffect
 */ const dist_index_module_$9f79659886946c16$export$e5c5a5f917a5871c = Boolean(globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) ? react.useLayoutEffect : ()=>{};





//# sourceMappingURL=index.module.js.map

;// CONCATENATED MODULE: ../node_modules/@radix-ui/react-toast/node_modules/@radix-ui/react-presence/dist/index.module.js










function dist_index_module_$fe963b355347cc68$export$3e6543de14f8614f(initialState, machine) {
    return (0,react.useReducer)((state, event)=>{
        const nextState = machine[state][event];
        return nextState !== null && nextState !== void 0 ? nextState : state;
    }, initialState);
}


const dist_index_module_$921a889cee6df7e8$export$99c2b779aa4e8b8b = (props)=>{
    const { present: present , children: children  } = props;
    const presence = dist_index_module_$921a889cee6df7e8$var$usePresence(present);
    const child = typeof children === 'function' ? children({
        present: presence.isPresent
    }) : react.Children.only(children);
    const ref = react_toast_node_modules_radix_ui_react_compose_refs_dist_index_module_$6ed0406888f73fc4$export$c7b2cbe3552a0d05(presence.ref, child.ref);
    const forceMount = typeof children === 'function';
    return forceMount || presence.isPresent ? /*#__PURE__*/ (0,react.cloneElement)(child, {
        ref: ref
    }) : null;
};
dist_index_module_$921a889cee6df7e8$export$99c2b779aa4e8b8b.displayName = 'Presence';
/* -------------------------------------------------------------------------------------------------
 * usePresence
 * -----------------------------------------------------------------------------------------------*/ function dist_index_module_$921a889cee6df7e8$var$usePresence(present) {
    const [node1, setNode] = (0,react.useState)();
    const stylesRef = (0,react.useRef)({});
    const prevPresentRef = (0,react.useRef)(present);
    const prevAnimationNameRef = (0,react.useRef)('none');
    const initialState = present ? 'mounted' : 'unmounted';
    const [state, send] = dist_index_module_$fe963b355347cc68$export$3e6543de14f8614f(initialState, {
        mounted: {
            UNMOUNT: 'unmounted',
            ANIMATION_OUT: 'unmountSuspended'
        },
        unmountSuspended: {
            MOUNT: 'mounted',
            ANIMATION_END: 'unmounted'
        },
        unmounted: {
            MOUNT: 'mounted'
        }
    });
    (0,react.useEffect)(()=>{
        const currentAnimationName = dist_index_module_$921a889cee6df7e8$var$getAnimationName(stylesRef.current);
        prevAnimationNameRef.current = state === 'mounted' ? currentAnimationName : 'none';
    }, [
        state
    ]);
    dist_index_module_$9f79659886946c16$export$e5c5a5f917a5871c(()=>{
        const styles = stylesRef.current;
        const wasPresent = prevPresentRef.current;
        const hasPresentChanged = wasPresent !== present;
        if (hasPresentChanged) {
            const prevAnimationName = prevAnimationNameRef.current;
            const currentAnimationName = dist_index_module_$921a889cee6df7e8$var$getAnimationName(styles);
            if (present) send('MOUNT');
            else if (currentAnimationName === 'none' || (styles === null || styles === void 0 ? void 0 : styles.display) === 'none') // If there is no exit animation or the element is hidden, animations won't run
            // so we unmount instantly
            send('UNMOUNT');
            else {
                /**
         * When `present` changes to `false`, we check changes to animation-name to
         * determine whether an animation has started. We chose this approach (reading
         * computed styles) because there is no `animationrun` event and `animationstart`
         * fires after `animation-delay` has expired which would be too late.
         */ const isAnimating = prevAnimationName !== currentAnimationName;
                if (wasPresent && isAnimating) send('ANIMATION_OUT');
                else send('UNMOUNT');
            }
            prevPresentRef.current = present;
        }
    }, [
        present,
        send
    ]);
    dist_index_module_$9f79659886946c16$export$e5c5a5f917a5871c(()=>{
        if (node1) {
            /**
       * Triggering an ANIMATION_OUT during an ANIMATION_IN will fire an `animationcancel`
       * event for ANIMATION_IN after we have entered `unmountSuspended` state. So, we
       * make sure we only trigger ANIMATION_END for the currently active animation.
       */ const handleAnimationEnd = (event)=>{
                const currentAnimationName = dist_index_module_$921a889cee6df7e8$var$getAnimationName(stylesRef.current);
                const isCurrentAnimation = currentAnimationName.includes(event.animationName);
                if (event.target === node1 && isCurrentAnimation) // With React 18 concurrency this update is applied
                // a frame after the animation ends, creating a flash of visible content.
                // By manually flushing we ensure they sync within a frame, removing the flash.
                (0,react_dom.flushSync)(()=>send('ANIMATION_END')
                );
            };
            const handleAnimationStart = (event)=>{
                if (event.target === node1) // if animation occurred, store its name as the previous animation.
                prevAnimationNameRef.current = dist_index_module_$921a889cee6df7e8$var$getAnimationName(stylesRef.current);
            };
            node1.addEventListener('animationstart', handleAnimationStart);
            node1.addEventListener('animationcancel', handleAnimationEnd);
            node1.addEventListener('animationend', handleAnimationEnd);
            return ()=>{
                node1.removeEventListener('animationstart', handleAnimationStart);
                node1.removeEventListener('animationcancel', handleAnimationEnd);
                node1.removeEventListener('animationend', handleAnimationEnd);
            };
        } else // Transition to the unmounted state if the node is removed prematurely.
        // We avoid doing so during cleanup as the node may change but still exist.
        send('ANIMATION_END');
    }, [
        node1,
        send
    ]);
    return {
        isPresent: [
            'mounted',
            'unmountSuspended'
        ].includes(state),
        ref: (0,react.useCallback)((node)=>{
            if (node) stylesRef.current = getComputedStyle(node);
            setNode(node);
        }, [])
    };
}
/* -----------------------------------------------------------------------------------------------*/ function dist_index_module_$921a889cee6df7e8$var$getAnimationName(styles) {
    return (styles === null || styles === void 0 ? void 0 : styles.animationName) || 'none';
}





//# sourceMappingURL=index.module.js.map

;// CONCATENATED MODULE: ../node_modules/@radix-ui/react-toast/node_modules/@radix-ui/react-primitive/dist/index.module.js









const node_modules_radix_ui_react_primitive_dist_index_module_$8927f6f2acc4f386$var$NODES = [
    'a',
    'button',
    'div',
    'h2',
    'h3',
    'img',
    'label',
    'li',
    'nav',
    'ol',
    'p',
    'span',
    'svg',
    'ul'
]; // Temporary while we await merge of this fix:
// https://github.com/DefinitelyTyped/DefinitelyTyped/pull/55396
// prettier-ignore
/* -------------------------------------------------------------------------------------------------
 * Primitive
 * -----------------------------------------------------------------------------------------------*/ const node_modules_radix_ui_react_primitive_dist_index_module_$8927f6f2acc4f386$export$250ffa63cdc0d034 = node_modules_radix_ui_react_primitive_dist_index_module_$8927f6f2acc4f386$var$NODES.reduce((primitive, node)=>{
    const Node = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
        const { asChild: asChild , ...primitiveProps } = props;
        const Comp = asChild ? $5e63c961fc1ce211$export$8c6ed5c666ac1360 : node;
        (0,react.useEffect)(()=>{
            window[Symbol.for('radix-ui')] = true;
        }, []);
        return /*#__PURE__*/ (0,react.createElement)(Comp, (0,esm_extends/* default */.Z)({}, primitiveProps, {
            ref: forwardedRef
        }));
    });
    Node.displayName = `Primitive.${node}`;
    return {
        ...primitive,
        [node]: Node
    };
}, {});
/* -------------------------------------------------------------------------------------------------
 * Utils
 * -----------------------------------------------------------------------------------------------*/ /**
 * Flush custom event dispatch
 * https://github.com/radix-ui/primitives/pull/1378
 *
 * React batches *all* event handlers since version 18, this introduces certain considerations when using custom event types.
 *
 * Internally, React prioritises events in the following order:
 *  - discrete
 *  - continuous
 *  - default
 *
 * https://github.com/facebook/react/blob/a8a4742f1c54493df00da648a3f9d26e3db9c8b5/packages/react-dom/src/events/ReactDOMEventListener.js#L294-L350
 *
 * `discrete` is an  important distinction as updates within these events are applied immediately.
 * React however, is not able to infer the priority of custom event types due to how they are detected internally.
 * Because of this, it's possible for updates from custom events to be unexpectedly batched when
 * dispatched by another `discrete` event.
 *
 * In order to ensure that updates from custom events are applied predictably, we need to manually flush the batch.
 * This utility should be used when dispatching a custom event from within another `discrete` event, this utility
 * is not nessesary when dispatching known event types, or if dispatching a custom type inside a non-discrete event.
 * For example:
 *
 * dispatching a known click 👎
 * target.dispatchEvent(new Event(‘click’))
 *
 * dispatching a custom type within a non-discrete event 👎
 * onScroll={(event) => event.target.dispatchEvent(new CustomEvent(‘customType’))}
 *
 * dispatching a custom type within a `discrete` event 👍
 * onPointerDown={(event) => dispatchDiscreteCustomEvent(event.target, new CustomEvent(‘customType’))}
 *
 * Note: though React classifies `focus`, `focusin` and `focusout` events as `discrete`, it's  not recommended to use
 * this utility with them. This is because it's possible for those handlers to be called implicitly during render
 * e.g. when focus is within a component as it is unmounted, or when managing focus on mount.
 */ function node_modules_radix_ui_react_primitive_dist_index_module_$8927f6f2acc4f386$export$6d1a0317bde7de7f(target, event) {
    if (target) (0,react_dom.flushSync)(()=>target.dispatchEvent(event)
    );
}
/* -----------------------------------------------------------------------------------------------*/ const node_modules_radix_ui_react_primitive_dist_index_module_$8927f6f2acc4f386$export$be92b6f5f03c0fe9 = (/* unused pure expression or super */ null && (node_modules_radix_ui_react_primitive_dist_index_module_$8927f6f2acc4f386$export$250ffa63cdc0d034));





//# sourceMappingURL=index.module.js.map

;// CONCATENATED MODULE: ../node_modules/@radix-ui/react-toast/node_modules/@radix-ui/react-use-callback-ref/dist/index.module.js



/**
 * A custom hook that converts a callback to a ref to avoid triggering re-renders when passed as a
 * prop or avoid re-executing effects when passed as a dependency
 */ function node_modules_radix_ui_react_use_callback_ref_dist_index_module_$b1b2314f5f9a1d84$export$25bec8c6f54ee79a(callback) {
    const callbackRef = (0,react.useRef)(callback);
    (0,react.useEffect)(()=>{
        callbackRef.current = callback;
    }); // https://github.com/facebook/react/issues/19240
    return (0,react.useMemo)(()=>(...args)=>{
            var _callbackRef$current;
            return (_callbackRef$current = callbackRef.current) === null || _callbackRef$current === void 0 ? void 0 : _callbackRef$current.call(callbackRef, ...args);
        }
    , []);
}





//# sourceMappingURL=index.module.js.map

;// CONCATENATED MODULE: ../node_modules/@radix-ui/react-toast/node_modules/@radix-ui/react-use-controllable-state/dist/index.module.js





function dist_index_module_$71cd76cc60e0454e$export$6f32135080cb4c3({ prop: prop , defaultProp: defaultProp , onChange: onChange = ()=>{}  }) {
    const [uncontrolledProp, setUncontrolledProp] = dist_index_module_$71cd76cc60e0454e$var$useUncontrolledState({
        defaultProp: defaultProp,
        onChange: onChange
    });
    const isControlled = prop !== undefined;
    const value1 = isControlled ? prop : uncontrolledProp;
    const handleChange = node_modules_radix_ui_react_use_callback_ref_dist_index_module_$b1b2314f5f9a1d84$export$25bec8c6f54ee79a(onChange);
    const setValue = (0,react.useCallback)((nextValue)=>{
        if (isControlled) {
            const setter = nextValue;
            const value = typeof nextValue === 'function' ? setter(prop) : nextValue;
            if (value !== prop) handleChange(value);
        } else setUncontrolledProp(nextValue);
    }, [
        isControlled,
        prop,
        setUncontrolledProp,
        handleChange
    ]);
    return [
        value1,
        setValue
    ];
}
function dist_index_module_$71cd76cc60e0454e$var$useUncontrolledState({ defaultProp: defaultProp , onChange: onChange  }) {
    const uncontrolledState = (0,react.useState)(defaultProp);
    const [value] = uncontrolledState;
    const prevValueRef = (0,react.useRef)(value);
    const handleChange = node_modules_radix_ui_react_use_callback_ref_dist_index_module_$b1b2314f5f9a1d84$export$25bec8c6f54ee79a(onChange);
    (0,react.useEffect)(()=>{
        if (prevValueRef.current !== value) {
            handleChange(value);
            prevValueRef.current = value;
        }
    }, [
        value,
        prevValueRef,
        handleChange
    ]);
    return uncontrolledState;
}





//# sourceMappingURL=index.module.js.map

;// CONCATENATED MODULE: ../node_modules/@radix-ui/react-visually-hidden/node_modules/@radix-ui/react-primitive/dist/index.module.js









const react_visually_hidden_node_modules_radix_ui_react_primitive_dist_index_module_$8927f6f2acc4f386$var$NODES = [
    'a',
    'button',
    'div',
    'h2',
    'h3',
    'img',
    'label',
    'li',
    'nav',
    'ol',
    'p',
    'span',
    'svg',
    'ul'
]; // Temporary while we await merge of this fix:
// https://github.com/DefinitelyTyped/DefinitelyTyped/pull/55396
// prettier-ignore
/* -------------------------------------------------------------------------------------------------
 * Primitive
 * -----------------------------------------------------------------------------------------------*/ const react_visually_hidden_node_modules_radix_ui_react_primitive_dist_index_module_$8927f6f2acc4f386$export$250ffa63cdc0d034 = react_visually_hidden_node_modules_radix_ui_react_primitive_dist_index_module_$8927f6f2acc4f386$var$NODES.reduce((primitive, node)=>{
    const Node = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
        const { asChild: asChild , ...primitiveProps } = props;
        const Comp = asChild ? $5e63c961fc1ce211$export$8c6ed5c666ac1360 : node;
        (0,react.useEffect)(()=>{
            window[Symbol.for('radix-ui')] = true;
        }, []);
        return /*#__PURE__*/ (0,react.createElement)(Comp, (0,esm_extends/* default */.Z)({}, primitiveProps, {
            ref: forwardedRef
        }));
    });
    Node.displayName = `Primitive.${node}`;
    return {
        ...primitive,
        [node]: Node
    };
}, {});
/* -------------------------------------------------------------------------------------------------
 * Utils
 * -----------------------------------------------------------------------------------------------*/ /**
 * Flush custom event dispatch
 * https://github.com/radix-ui/primitives/pull/1378
 *
 * React batches *all* event handlers since version 18, this introduces certain considerations when using custom event types.
 *
 * Internally, React prioritises events in the following order:
 *  - discrete
 *  - continuous
 *  - default
 *
 * https://github.com/facebook/react/blob/a8a4742f1c54493df00da648a3f9d26e3db9c8b5/packages/react-dom/src/events/ReactDOMEventListener.js#L294-L350
 *
 * `discrete` is an  important distinction as updates within these events are applied immediately.
 * React however, is not able to infer the priority of custom event types due to how they are detected internally.
 * Because of this, it's possible for updates from custom events to be unexpectedly batched when
 * dispatched by another `discrete` event.
 *
 * In order to ensure that updates from custom events are applied predictably, we need to manually flush the batch.
 * This utility should be used when dispatching a custom event from within another `discrete` event, this utility
 * is not nessesary when dispatching known event types, or if dispatching a custom type inside a non-discrete event.
 * For example:
 *
 * dispatching a known click 👎
 * target.dispatchEvent(new Event(‘click’))
 *
 * dispatching a custom type within a non-discrete event 👎
 * onScroll={(event) => event.target.dispatchEvent(new CustomEvent(‘customType’))}
 *
 * dispatching a custom type within a `discrete` event 👍
 * onPointerDown={(event) => dispatchDiscreteCustomEvent(event.target, new CustomEvent(‘customType’))}
 *
 * Note: though React classifies `focus`, `focusin` and `focusout` events as `discrete`, it's  not recommended to use
 * this utility with them. This is because it's possible for those handlers to be called implicitly during render
 * e.g. when focus is within a component as it is unmounted, or when managing focus on mount.
 */ function react_visually_hidden_node_modules_radix_ui_react_primitive_dist_index_module_$8927f6f2acc4f386$export$6d1a0317bde7de7f(target, event) {
    if (target) $4q5Fq$flushSync(()=>target.dispatchEvent(event)
    );
}
/* -----------------------------------------------------------------------------------------------*/ const react_visually_hidden_node_modules_radix_ui_react_primitive_dist_index_module_$8927f6f2acc4f386$export$be92b6f5f03c0fe9 = (/* unused pure expression or super */ null && (react_visually_hidden_node_modules_radix_ui_react_primitive_dist_index_module_$8927f6f2acc4f386$export$250ffa63cdc0d034));





//# sourceMappingURL=index.module.js.map

;// CONCATENATED MODULE: ../node_modules/@radix-ui/react-visually-hidden/dist/index.module.js







/* -------------------------------------------------------------------------------------------------
 * VisuallyHidden
 * -----------------------------------------------------------------------------------------------*/ const index_module_$ea1ef594cf570d83$var$NAME = 'VisuallyHidden';
const index_module_$ea1ef594cf570d83$export$439d29a4e110a164 = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    return /*#__PURE__*/ (0,react.createElement)(react_visually_hidden_node_modules_radix_ui_react_primitive_dist_index_module_$8927f6f2acc4f386$export$250ffa63cdc0d034.span, (0,esm_extends/* default */.Z)({}, props, {
        ref: forwardedRef,
        style: {
            // See: https://github.com/twbs/bootstrap/blob/master/scss/mixins/_screen-reader.scss
            position: 'absolute',
            border: 0,
            width: 1,
            height: 1,
            padding: 0,
            margin: -1,
            overflow: 'hidden',
            clip: 'rect(0, 0, 0, 0)',
            whiteSpace: 'nowrap',
            wordWrap: 'normal',
            ...props.style
        }
    }));
});
/*#__PURE__*/ Object.assign(index_module_$ea1ef594cf570d83$export$439d29a4e110a164, {
    displayName: index_module_$ea1ef594cf570d83$var$NAME
});
/* -----------------------------------------------------------------------------------------------*/ const index_module_$ea1ef594cf570d83$export$be92b6f5f03c0fe9 = (/* unused pure expression or super */ null && (index_module_$ea1ef594cf570d83$export$439d29a4e110a164));





//# sourceMappingURL=index.module.js.map

;// CONCATENATED MODULE: ../node_modules/@radix-ui/react-toast/dist/index.module.js































/* -------------------------------------------------------------------------------------------------
 * ToastProvider
 * -----------------------------------------------------------------------------------------------*/ const $054eb8030ebde76e$var$PROVIDER_NAME = 'ToastProvider';
const [$054eb8030ebde76e$var$Collection, $054eb8030ebde76e$var$useCollection, $054eb8030ebde76e$var$createCollectionScope] = $e02a7d9cb1dc128c$export$c74125a8e3af6bb2('Toast');
const [$054eb8030ebde76e$var$createToastContext, $054eb8030ebde76e$export$8a359da18fbc9073] = react_context_dist_index_module_$c512c27ab02ef895$export$50c7b4e9d9f19c1('Toast', [
    $054eb8030ebde76e$var$createCollectionScope
]);
const [$054eb8030ebde76e$var$ToastProviderProvider, $054eb8030ebde76e$var$useToastProviderContext] = $054eb8030ebde76e$var$createToastContext($054eb8030ebde76e$var$PROVIDER_NAME);
const $054eb8030ebde76e$export$f5d03d415824e0e = (props)=>{
    const { __scopeToast: __scopeToast , label: label = 'Notification' , duration: duration = 5000 , swipeDirection: swipeDirection = 'right' , swipeThreshold: swipeThreshold = 50 , children: children  } = props;
    const [viewport, setViewport] = (0,react.useState)(null);
    const [toastCount, setToastCount] = (0,react.useState)(0);
    const isFocusedToastEscapeKeyDownRef = (0,react.useRef)(false);
    const isClosePausedRef = (0,react.useRef)(false);
    return /*#__PURE__*/ (0,react.createElement)($054eb8030ebde76e$var$Collection.Provider, {
        scope: __scopeToast
    }, /*#__PURE__*/ (0,react.createElement)($054eb8030ebde76e$var$ToastProviderProvider, {
        scope: __scopeToast,
        label: label,
        duration: duration,
        swipeDirection: swipeDirection,
        swipeThreshold: swipeThreshold,
        toastCount: toastCount,
        viewport: viewport,
        onViewportChange: setViewport,
        onToastAdd: (0,react.useCallback)(()=>setToastCount((prevCount)=>prevCount + 1
            )
        , []),
        onToastRemove: (0,react.useCallback)(()=>setToastCount((prevCount)=>prevCount - 1
            )
        , []),
        isFocusedToastEscapeKeyDownRef: isFocusedToastEscapeKeyDownRef,
        isClosePausedRef: isClosePausedRef
    }, children));
};
$054eb8030ebde76e$export$f5d03d415824e0e.propTypes = {
    label (props) {
        if (props.label && typeof props.label === 'string' && !props.label.trim()) {
            const error = `Invalid prop \`label\` supplied to \`${$054eb8030ebde76e$var$PROVIDER_NAME}\`. Expected non-empty \`string\`.`;
            return new Error(error);
        }
        return null;
    }
};
/*#__PURE__*/ Object.assign($054eb8030ebde76e$export$f5d03d415824e0e, {
    displayName: $054eb8030ebde76e$var$PROVIDER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * ToastViewport
 * -----------------------------------------------------------------------------------------------*/ const $054eb8030ebde76e$var$VIEWPORT_NAME = 'ToastViewport';
const $054eb8030ebde76e$var$VIEWPORT_DEFAULT_HOTKEY = [
    'F8'
];
const $054eb8030ebde76e$var$VIEWPORT_PAUSE = 'toast.viewportPause';
const $054eb8030ebde76e$var$VIEWPORT_RESUME = 'toast.viewportResume';
const $054eb8030ebde76e$export$6192c2425ecfd989 = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { __scopeToast: __scopeToast , hotkey: hotkey = $054eb8030ebde76e$var$VIEWPORT_DEFAULT_HOTKEY , label: label = 'Notifications ({hotkey})' , ...viewportProps } = props;
    const context = $054eb8030ebde76e$var$useToastProviderContext($054eb8030ebde76e$var$VIEWPORT_NAME, __scopeToast);
    const getItems = $054eb8030ebde76e$var$useCollection(__scopeToast);
    const wrapperRef = (0,react.useRef)(null);
    const headFocusProxyRef = (0,react.useRef)(null);
    const tailFocusProxyRef = (0,react.useRef)(null);
    const ref = (0,react.useRef)(null);
    const composedRefs = react_toast_node_modules_radix_ui_react_compose_refs_dist_index_module_$6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, ref, context.onViewportChange);
    const hotkeyLabel = hotkey.join('+').replace(/Key/g, '').replace(/Digit/g, '');
    const hasToasts = context.toastCount > 0;
    (0,react.useEffect)(()=>{
        const handleKeyDown = (event)=>{
            var _ref$current;
            // we use `event.code` as it is consistent regardless of meta keys that were pressed.
            // for example, `event.key` for `Control+Alt+t` is `†` and `t !== †`
            const isHotkeyPressed = hotkey.every((key)=>event[key] || event.code === key
            );
            if (isHotkeyPressed) (_ref$current = ref.current) === null || _ref$current === void 0 || _ref$current.focus();
        };
        document.addEventListener('keydown', handleKeyDown);
        return ()=>document.removeEventListener('keydown', handleKeyDown)
        ;
    }, [
        hotkey
    ]);
    (0,react.useEffect)(()=>{
        const wrapper = wrapperRef.current;
        const viewport = ref.current;
        if (hasToasts && wrapper && viewport) {
            const handlePause = ()=>{
                if (!context.isClosePausedRef.current) {
                    const pauseEvent = new CustomEvent($054eb8030ebde76e$var$VIEWPORT_PAUSE);
                    viewport.dispatchEvent(pauseEvent);
                    context.isClosePausedRef.current = true;
                }
            };
            const handleResume = ()=>{
                if (context.isClosePausedRef.current) {
                    const resumeEvent = new CustomEvent($054eb8030ebde76e$var$VIEWPORT_RESUME);
                    viewport.dispatchEvent(resumeEvent);
                    context.isClosePausedRef.current = false;
                }
            };
            const handleFocusOutResume = (event)=>{
                const isFocusMovingOutside = !wrapper.contains(event.relatedTarget);
                if (isFocusMovingOutside) handleResume();
            };
            const handlePointerLeaveResume = ()=>{
                const isFocusInside = wrapper.contains(document.activeElement);
                if (!isFocusInside) handleResume();
            }; // Toasts are not in the viewport React tree so we need to bind DOM events
            wrapper.addEventListener('focusin', handlePause);
            wrapper.addEventListener('focusout', handleFocusOutResume);
            wrapper.addEventListener('pointermove', handlePause);
            wrapper.addEventListener('pointerleave', handlePointerLeaveResume);
            window.addEventListener('blur', handlePause);
            window.addEventListener('focus', handleResume);
            return ()=>{
                wrapper.removeEventListener('focusin', handlePause);
                wrapper.removeEventListener('focusout', handleFocusOutResume);
                wrapper.removeEventListener('pointermove', handlePause);
                wrapper.removeEventListener('pointerleave', handlePointerLeaveResume);
                window.removeEventListener('blur', handlePause);
                window.removeEventListener('focus', handleResume);
            };
        }
    }, [
        hasToasts,
        context.isClosePausedRef
    ]);
    const getSortedTabbableCandidates = (0,react.useCallback)(({ tabbingDirection: tabbingDirection  })=>{
        const toastItems = getItems();
        const tabbableCandidates = toastItems.map((toastItem)=>{
            const toastNode = toastItem.ref.current;
            const toastTabbableCandidates = [
                toastNode,
                ...$054eb8030ebde76e$var$getTabbableCandidates(toastNode)
            ];
            return tabbingDirection === 'forwards' ? toastTabbableCandidates : toastTabbableCandidates.reverse();
        });
        return (tabbingDirection === 'forwards' ? tabbableCandidates.reverse() : tabbableCandidates).flat();
    }, [
        getItems
    ]);
    (0,react.useEffect)(()=>{
        const viewport = ref.current; // We programmatically manage tabbing as we are unable to influence
        // the source order with portals, this allows us to reverse the
        // tab order so that it runs from most recent toast to least
        if (viewport) {
            const handleKeyDown = (event)=>{
                const isMetaKey = event.altKey || event.ctrlKey || event.metaKey;
                const isTabKey = event.key === 'Tab' && !isMetaKey;
                if (isTabKey) {
                    const focusedElement = document.activeElement;
                    const isTabbingBackwards = event.shiftKey;
                    const targetIsViewport = event.target === viewport; // If we're back tabbing after jumping to the viewport then we simply
                    // proxy focus out to the preceding document
                    if (targetIsViewport && isTabbingBackwards) {
                        var _headFocusProxyRef$cu;
                        (_headFocusProxyRef$cu = headFocusProxyRef.current) === null || _headFocusProxyRef$cu === void 0 || _headFocusProxyRef$cu.focus();
                        return;
                    }
                    const tabbingDirection = isTabbingBackwards ? 'backwards' : 'forwards';
                    const sortedCandidates = getSortedTabbableCandidates({
                        tabbingDirection: tabbingDirection
                    });
                    const index = sortedCandidates.findIndex((candidate)=>candidate === focusedElement
                    );
                    if ($054eb8030ebde76e$var$focusFirst(sortedCandidates.slice(index + 1))) event.preventDefault();
                    else {
                        var _headFocusProxyRef$cu2, _tailFocusProxyRef$cu;
                        // If we can't focus that means we're at the edges so we
                        // proxy to the corresponding exit point and let the browser handle
                        // tab/shift+tab keypress and implicitly pass focus to the next valid element in the document
                        isTabbingBackwards ? (_headFocusProxyRef$cu2 = headFocusProxyRef.current) === null || _headFocusProxyRef$cu2 === void 0 || _headFocusProxyRef$cu2.focus() : (_tailFocusProxyRef$cu = tailFocusProxyRef.current) === null || _tailFocusProxyRef$cu === void 0 || _tailFocusProxyRef$cu.focus();
                    }
                }
            }; // Toasts are not in the viewport React tree so we need to bind DOM events
            viewport.addEventListener('keydown', handleKeyDown);
            return ()=>viewport.removeEventListener('keydown', handleKeyDown)
            ;
        }
    }, [
        getItems,
        getSortedTabbableCandidates
    ]);
    return /*#__PURE__*/ (0,react.createElement)($5cb92bef7577960e$export$aecb2ddcb55c95be, {
        ref: wrapperRef,
        role: "region",
        "aria-label": label.replace('{hotkey}', hotkeyLabel) // Ensure virtual cursor from landmarks menus triggers focus/blur for pause/resume
        ,
        tabIndex: -1 // incase list has size when empty (e.g. padding), we remove pointer events so
        ,
        style: {
            pointerEvents: hasToasts ? undefined : 'none'
        }
    }, hasToasts && /*#__PURE__*/ (0,react.createElement)($054eb8030ebde76e$var$FocusProxy, {
        ref: headFocusProxyRef,
        onFocusFromOutsideViewport: ()=>{
            const tabbableCandidates = getSortedTabbableCandidates({
                tabbingDirection: 'forwards'
            });
            $054eb8030ebde76e$var$focusFirst(tabbableCandidates);
        }
    }), /*#__PURE__*/ (0,react.createElement)($054eb8030ebde76e$var$Collection.Slot, {
        scope: __scopeToast
    }, /*#__PURE__*/ (0,react.createElement)(node_modules_radix_ui_react_primitive_dist_index_module_$8927f6f2acc4f386$export$250ffa63cdc0d034.ol, (0,esm_extends/* default */.Z)({
        tabIndex: -1
    }, viewportProps, {
        ref: composedRefs
    }))), hasToasts && /*#__PURE__*/ (0,react.createElement)($054eb8030ebde76e$var$FocusProxy, {
        ref: tailFocusProxyRef,
        onFocusFromOutsideViewport: ()=>{
            const tabbableCandidates = getSortedTabbableCandidates({
                tabbingDirection: 'backwards'
            });
            $054eb8030ebde76e$var$focusFirst(tabbableCandidates);
        }
    }));
});
/*#__PURE__*/ Object.assign($054eb8030ebde76e$export$6192c2425ecfd989, {
    displayName: $054eb8030ebde76e$var$VIEWPORT_NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $054eb8030ebde76e$var$FOCUS_PROXY_NAME = 'ToastFocusProxy';
const $054eb8030ebde76e$var$FocusProxy = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { __scopeToast: __scopeToast , onFocusFromOutsideViewport: onFocusFromOutsideViewport , ...proxyProps } = props;
    const context = $054eb8030ebde76e$var$useToastProviderContext($054eb8030ebde76e$var$FOCUS_PROXY_NAME, __scopeToast);
    return /*#__PURE__*/ (0,react.createElement)(index_module_$ea1ef594cf570d83$export$439d29a4e110a164, (0,esm_extends/* default */.Z)({
        "aria-hidden": true,
        tabIndex: 0
    }, proxyProps, {
        ref: forwardedRef // Avoid page scrolling when focus is on the focus proxy
        ,
        style: {
            position: 'fixed'
        },
        onFocus: (event)=>{
            var _context$viewport;
            const prevFocusedElement = event.relatedTarget;
            const isFocusFromOutsideViewport = !((_context$viewport = context.viewport) !== null && _context$viewport !== void 0 && _context$viewport.contains(prevFocusedElement));
            if (isFocusFromOutsideViewport) onFocusFromOutsideViewport();
        }
    }));
});
/*#__PURE__*/ Object.assign($054eb8030ebde76e$var$FocusProxy, {
    displayName: $054eb8030ebde76e$var$FOCUS_PROXY_NAME
});
/* -------------------------------------------------------------------------------------------------
 * Toast
 * -----------------------------------------------------------------------------------------------*/ const $054eb8030ebde76e$var$TOAST_NAME = 'Toast';
const $054eb8030ebde76e$var$TOAST_SWIPE_START = 'toast.swipeStart';
const $054eb8030ebde76e$var$TOAST_SWIPE_MOVE = 'toast.swipeMove';
const $054eb8030ebde76e$var$TOAST_SWIPE_CANCEL = 'toast.swipeCancel';
const $054eb8030ebde76e$var$TOAST_SWIPE_END = 'toast.swipeEnd';
const $054eb8030ebde76e$export$8d8dc7d5f743331b = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { forceMount: forceMount , open: openProp , defaultOpen: defaultOpen , onOpenChange: onOpenChange , ...toastProps } = props;
    const [open = true, setOpen] = dist_index_module_$71cd76cc60e0454e$export$6f32135080cb4c3({
        prop: openProp,
        defaultProp: defaultOpen,
        onChange: onOpenChange
    });
    return /*#__PURE__*/ (0,react.createElement)(dist_index_module_$921a889cee6df7e8$export$99c2b779aa4e8b8b, {
        present: forceMount || open
    }, /*#__PURE__*/ (0,react.createElement)($054eb8030ebde76e$var$ToastImpl, (0,esm_extends/* default */.Z)({
        open: open
    }, toastProps, {
        ref: forwardedRef,
        onClose: ()=>setOpen(false)
        ,
        onPause: node_modules_radix_ui_react_use_callback_ref_dist_index_module_$b1b2314f5f9a1d84$export$25bec8c6f54ee79a(props.onPause),
        onResume: node_modules_radix_ui_react_use_callback_ref_dist_index_module_$b1b2314f5f9a1d84$export$25bec8c6f54ee79a(props.onResume),
        onSwipeStart: _radix_ui_primitive_dist_index_module_$e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onSwipeStart, (event)=>{
            event.currentTarget.setAttribute('data-swipe', 'start');
        }),
        onSwipeMove: _radix_ui_primitive_dist_index_module_$e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onSwipeMove, (event)=>{
            const { x: x , y: y  } = event.detail.delta;
            event.currentTarget.setAttribute('data-swipe', 'move');
            event.currentTarget.style.setProperty('--radix-toast-swipe-move-x', `${x}px`);
            event.currentTarget.style.setProperty('--radix-toast-swipe-move-y', `${y}px`);
        }),
        onSwipeCancel: _radix_ui_primitive_dist_index_module_$e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onSwipeCancel, (event)=>{
            event.currentTarget.setAttribute('data-swipe', 'cancel');
            event.currentTarget.style.removeProperty('--radix-toast-swipe-move-x');
            event.currentTarget.style.removeProperty('--radix-toast-swipe-move-y');
            event.currentTarget.style.removeProperty('--radix-toast-swipe-end-x');
            event.currentTarget.style.removeProperty('--radix-toast-swipe-end-y');
        }),
        onSwipeEnd: _radix_ui_primitive_dist_index_module_$e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onSwipeEnd, (event)=>{
            const { x: x , y: y  } = event.detail.delta;
            event.currentTarget.setAttribute('data-swipe', 'end');
            event.currentTarget.style.removeProperty('--radix-toast-swipe-move-x');
            event.currentTarget.style.removeProperty('--radix-toast-swipe-move-y');
            event.currentTarget.style.setProperty('--radix-toast-swipe-end-x', `${x}px`);
            event.currentTarget.style.setProperty('--radix-toast-swipe-end-y', `${y}px`);
            setOpen(false);
        })
    })));
});
/*#__PURE__*/ Object.assign($054eb8030ebde76e$export$8d8dc7d5f743331b, {
    displayName: $054eb8030ebde76e$var$TOAST_NAME
});
/* -----------------------------------------------------------------------------------------------*/ const [$054eb8030ebde76e$var$ToastInteractiveProvider, $054eb8030ebde76e$var$useToastInteractiveContext] = $054eb8030ebde76e$var$createToastContext($054eb8030ebde76e$var$TOAST_NAME, {
    onClose () {}
});
const $054eb8030ebde76e$var$ToastImpl = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { __scopeToast: __scopeToast , type: type = 'foreground' , duration: durationProp , open: open , onClose: onClose , onEscapeKeyDown: onEscapeKeyDown , onPause: onPause , onResume: onResume , onSwipeStart: onSwipeStart , onSwipeMove: onSwipeMove , onSwipeCancel: onSwipeCancel , onSwipeEnd: onSwipeEnd , ...toastProps } = props;
    const context = $054eb8030ebde76e$var$useToastProviderContext($054eb8030ebde76e$var$TOAST_NAME, __scopeToast);
    const [node1, setNode] = (0,react.useState)(null);
    const composedRefs = react_toast_node_modules_radix_ui_react_compose_refs_dist_index_module_$6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, (node)=>setNode(node)
    );
    const pointerStartRef = (0,react.useRef)(null);
    const swipeDeltaRef = (0,react.useRef)(null);
    const duration1 = durationProp || context.duration;
    const closeTimerStartTimeRef = (0,react.useRef)(0);
    const closeTimerRemainingTimeRef = (0,react.useRef)(duration1);
    const closeTimerRef = (0,react.useRef)(0);
    const { onToastAdd: onToastAdd , onToastRemove: onToastRemove  } = context;
    const handleClose = node_modules_radix_ui_react_use_callback_ref_dist_index_module_$b1b2314f5f9a1d84$export$25bec8c6f54ee79a(()=>{
        var _context$viewport2;
        // focus viewport if focus is within toast to read the remaining toast
        // count to SR users and ensure focus isn't lost
        const isFocusInToast = node1 === null || node1 === void 0 ? void 0 : node1.contains(document.activeElement);
        if (isFocusInToast) (_context$viewport2 = context.viewport) === null || _context$viewport2 === void 0 || _context$viewport2.focus();
        onClose();
    });
    const startTimer = (0,react.useCallback)((duration)=>{
        if (!duration || duration === Infinity) return;
        window.clearTimeout(closeTimerRef.current);
        closeTimerStartTimeRef.current = new Date().getTime();
        closeTimerRef.current = window.setTimeout(handleClose, duration);
    }, [
        handleClose
    ]);
    (0,react.useEffect)(()=>{
        const viewport = context.viewport;
        if (viewport) {
            const handleResume = ()=>{
                startTimer(closeTimerRemainingTimeRef.current);
                onResume === null || onResume === void 0 || onResume();
            };
            const handlePause = ()=>{
                const elapsedTime = new Date().getTime() - closeTimerStartTimeRef.current;
                closeTimerRemainingTimeRef.current = closeTimerRemainingTimeRef.current - elapsedTime;
                window.clearTimeout(closeTimerRef.current);
                onPause === null || onPause === void 0 || onPause();
            };
            viewport.addEventListener($054eb8030ebde76e$var$VIEWPORT_PAUSE, handlePause);
            viewport.addEventListener($054eb8030ebde76e$var$VIEWPORT_RESUME, handleResume);
            return ()=>{
                viewport.removeEventListener($054eb8030ebde76e$var$VIEWPORT_PAUSE, handlePause);
                viewport.removeEventListener($054eb8030ebde76e$var$VIEWPORT_RESUME, handleResume);
            };
        }
    }, [
        context.viewport,
        duration1,
        onPause,
        onResume,
        startTimer
    ]); // start timer when toast opens or duration changes.
    // we include `open` in deps because closed !== unmounted when animating
    // so it could reopen before being completely unmounted
    (0,react.useEffect)(()=>{
        if (open && !context.isClosePausedRef.current) startTimer(duration1);
    }, [
        open,
        duration1,
        context.isClosePausedRef,
        startTimer
    ]);
    (0,react.useEffect)(()=>{
        onToastAdd();
        return ()=>onToastRemove()
        ;
    }, [
        onToastAdd,
        onToastRemove
    ]);
    const announceTextContent = (0,react.useMemo)(()=>{
        return node1 ? $054eb8030ebde76e$var$getAnnounceTextContent(node1) : null;
    }, [
        node1
    ]);
    if (!context.viewport) return null;
    return /*#__PURE__*/ (0,react.createElement)(react.Fragment, null, announceTextContent && /*#__PURE__*/ (0,react.createElement)($054eb8030ebde76e$var$ToastAnnounce, {
        __scopeToast: __scopeToast // Toasts are always role=status to avoid stuttering issues with role=alert in SRs.
        ,
        role: "status",
        "aria-live": type === 'foreground' ? 'assertive' : 'polite',
        "aria-atomic": true
    }, announceTextContent), /*#__PURE__*/ (0,react.createElement)($054eb8030ebde76e$var$ToastInteractiveProvider, {
        scope: __scopeToast,
        onClose: handleClose
    }, /*#__PURE__*/ (0,react_dom.createPortal)(/*#__PURE__*/ (0,react.createElement)($054eb8030ebde76e$var$Collection.ItemSlot, {
        scope: __scopeToast
    }, /*#__PURE__*/ (0,react.createElement)($5cb92bef7577960e$export$be92b6f5f03c0fe9, {
        asChild: true,
        onEscapeKeyDown: _radix_ui_primitive_dist_index_module_$e42e1063c40fb3ef$export$b9ecd428b558ff10(onEscapeKeyDown, ()=>{
            if (!context.isFocusedToastEscapeKeyDownRef.current) handleClose();
            context.isFocusedToastEscapeKeyDownRef.current = false;
        })
    }, /*#__PURE__*/ (0,react.createElement)(node_modules_radix_ui_react_primitive_dist_index_module_$8927f6f2acc4f386$export$250ffa63cdc0d034.li, (0,esm_extends/* default */.Z)({
        // Ensure toasts are announced as status list or status when focused
        role: "status",
        "aria-live": "off",
        "aria-atomic": true,
        tabIndex: 0,
        "data-state": open ? 'open' : 'closed',
        "data-swipe-direction": context.swipeDirection
    }, toastProps, {
        ref: composedRefs,
        style: {
            userSelect: 'none',
            touchAction: 'none',
            ...props.style
        },
        onKeyDown: _radix_ui_primitive_dist_index_module_$e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onKeyDown, (event)=>{
            if (event.key !== 'Escape') return;
            onEscapeKeyDown === null || onEscapeKeyDown === void 0 || onEscapeKeyDown(event.nativeEvent);
            if (!event.nativeEvent.defaultPrevented) {
                context.isFocusedToastEscapeKeyDownRef.current = true;
                handleClose();
            }
        }),
        onPointerDown: _radix_ui_primitive_dist_index_module_$e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onPointerDown, (event)=>{
            if (event.button !== 0) return;
            pointerStartRef.current = {
                x: event.clientX,
                y: event.clientY
            };
        }),
        onPointerMove: _radix_ui_primitive_dist_index_module_$e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onPointerMove, (event)=>{
            if (!pointerStartRef.current) return;
            const x = event.clientX - pointerStartRef.current.x;
            const y = event.clientY - pointerStartRef.current.y;
            const hasSwipeMoveStarted = Boolean(swipeDeltaRef.current);
            const isHorizontalSwipe = [
                'left',
                'right'
            ].includes(context.swipeDirection);
            const clamp = [
                'left',
                'up'
            ].includes(context.swipeDirection) ? Math.min : Math.max;
            const clampedX = isHorizontalSwipe ? clamp(0, x) : 0;
            const clampedY = !isHorizontalSwipe ? clamp(0, y) : 0;
            const moveStartBuffer = event.pointerType === 'touch' ? 10 : 2;
            const delta = {
                x: clampedX,
                y: clampedY
            };
            const eventDetail = {
                originalEvent: event,
                delta: delta
            };
            if (hasSwipeMoveStarted) {
                swipeDeltaRef.current = delta;
                $054eb8030ebde76e$var$handleAndDispatchCustomEvent($054eb8030ebde76e$var$TOAST_SWIPE_MOVE, onSwipeMove, eventDetail, {
                    discrete: false
                });
            } else if ($054eb8030ebde76e$var$isDeltaInDirection(delta, context.swipeDirection, moveStartBuffer)) {
                swipeDeltaRef.current = delta;
                $054eb8030ebde76e$var$handleAndDispatchCustomEvent($054eb8030ebde76e$var$TOAST_SWIPE_START, onSwipeStart, eventDetail, {
                    discrete: false
                });
                event.target.setPointerCapture(event.pointerId);
            } else if (Math.abs(x) > moveStartBuffer || Math.abs(y) > moveStartBuffer) // User is swiping in wrong direction so we disable swipe gesture
            // for the current pointer down interaction
            pointerStartRef.current = null;
        }),
        onPointerUp: _radix_ui_primitive_dist_index_module_$e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onPointerUp, (event1)=>{
            const delta = swipeDeltaRef.current;
            const target = event1.target;
            if (target.hasPointerCapture(event1.pointerId)) target.releasePointerCapture(event1.pointerId);
            swipeDeltaRef.current = null;
            pointerStartRef.current = null;
            if (delta) {
                const toast = event1.currentTarget;
                const eventDetail = {
                    originalEvent: event1,
                    delta: delta
                };
                if ($054eb8030ebde76e$var$isDeltaInDirection(delta, context.swipeDirection, context.swipeThreshold)) $054eb8030ebde76e$var$handleAndDispatchCustomEvent($054eb8030ebde76e$var$TOAST_SWIPE_END, onSwipeEnd, eventDetail, {
                    discrete: true
                });
                else $054eb8030ebde76e$var$handleAndDispatchCustomEvent($054eb8030ebde76e$var$TOAST_SWIPE_CANCEL, onSwipeCancel, eventDetail, {
                    discrete: true
                });
                 // Prevent click event from triggering on items within the toast when
                // pointer up is part of a swipe gesture
                toast.addEventListener('click', (event)=>event.preventDefault()
                , {
                    once: true
                });
            }
        })
    })))), context.viewport)));
});
$054eb8030ebde76e$var$ToastImpl.propTypes = {
    type (props) {
        if (props.type && ![
            'foreground',
            'background'
        ].includes(props.type)) {
            const error = `Invalid prop \`type\` supplied to \`${$054eb8030ebde76e$var$TOAST_NAME}\`. Expected \`foreground | background\`.`;
            return new Error(error);
        }
        return null;
    }
};
/* -----------------------------------------------------------------------------------------------*/ const $054eb8030ebde76e$var$ToastAnnounce = (props)=>{
    const { __scopeToast: __scopeToast , children: children , ...announceProps } = props;
    const context = $054eb8030ebde76e$var$useToastProviderContext($054eb8030ebde76e$var$TOAST_NAME, __scopeToast);
    const [renderAnnounceText, setRenderAnnounceText] = (0,react.useState)(false);
    const [isAnnounced, setIsAnnounced] = (0,react.useState)(false); // render text content in the next frame to ensure toast is announced in NVDA
    $054eb8030ebde76e$var$useNextFrame(()=>setRenderAnnounceText(true)
    ); // cleanup after announcing
    (0,react.useEffect)(()=>{
        const timer = window.setTimeout(()=>setIsAnnounced(true)
        , 1000);
        return ()=>window.clearTimeout(timer)
        ;
    }, []);
    return isAnnounced ? null : /*#__PURE__*/ (0,react.createElement)($f1701beae083dbae$export$602eac185826482c, {
        asChild: true
    }, /*#__PURE__*/ (0,react.createElement)(index_module_$ea1ef594cf570d83$export$439d29a4e110a164, announceProps, renderAnnounceText && /*#__PURE__*/ (0,react.createElement)(react.Fragment, null, context.label, " ", children)));
};
/* -------------------------------------------------------------------------------------------------
 * ToastTitle
 * -----------------------------------------------------------------------------------------------*/ const $054eb8030ebde76e$var$TITLE_NAME = 'ToastTitle';
const $054eb8030ebde76e$export$16d42d7c29b95a4 = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { __scopeToast: __scopeToast , ...titleProps } = props;
    return /*#__PURE__*/ (0,react.createElement)(node_modules_radix_ui_react_primitive_dist_index_module_$8927f6f2acc4f386$export$250ffa63cdc0d034.div, (0,esm_extends/* default */.Z)({}, titleProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($054eb8030ebde76e$export$16d42d7c29b95a4, {
    displayName: $054eb8030ebde76e$var$TITLE_NAME
});
/* -------------------------------------------------------------------------------------------------
 * ToastDescription
 * -----------------------------------------------------------------------------------------------*/ const $054eb8030ebde76e$var$DESCRIPTION_NAME = 'ToastDescription';
const $054eb8030ebde76e$export$ecddd96c53621d9a = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { __scopeToast: __scopeToast , ...descriptionProps } = props;
    return /*#__PURE__*/ (0,react.createElement)(node_modules_radix_ui_react_primitive_dist_index_module_$8927f6f2acc4f386$export$250ffa63cdc0d034.div, (0,esm_extends/* default */.Z)({}, descriptionProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($054eb8030ebde76e$export$ecddd96c53621d9a, {
    displayName: $054eb8030ebde76e$var$DESCRIPTION_NAME
});
/* -------------------------------------------------------------------------------------------------
 * ToastAction
 * -----------------------------------------------------------------------------------------------*/ const $054eb8030ebde76e$var$ACTION_NAME = 'ToastAction';
const $054eb8030ebde76e$export$3019feecfda683d2 = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { altText: altText , ...actionProps } = props;
    if (!altText) return null;
    return /*#__PURE__*/ (0,react.createElement)($054eb8030ebde76e$var$ToastAnnounceExclude, {
        altText: altText,
        asChild: true
    }, /*#__PURE__*/ (0,react.createElement)($054eb8030ebde76e$export$811e70f61c205839, (0,esm_extends/* default */.Z)({}, actionProps, {
        ref: forwardedRef
    })));
});
$054eb8030ebde76e$export$3019feecfda683d2.propTypes = {
    altText (props) {
        if (!props.altText) return new Error(`Missing prop \`altText\` expected on \`${$054eb8030ebde76e$var$ACTION_NAME}\``);
        return null;
    }
};
/*#__PURE__*/ Object.assign($054eb8030ebde76e$export$3019feecfda683d2, {
    displayName: $054eb8030ebde76e$var$ACTION_NAME
});
/* -------------------------------------------------------------------------------------------------
 * ToastClose
 * -----------------------------------------------------------------------------------------------*/ const $054eb8030ebde76e$var$CLOSE_NAME = 'ToastClose';
const $054eb8030ebde76e$export$811e70f61c205839 = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { __scopeToast: __scopeToast , ...closeProps } = props;
    const interactiveContext = $054eb8030ebde76e$var$useToastInteractiveContext($054eb8030ebde76e$var$CLOSE_NAME, __scopeToast);
    return /*#__PURE__*/ (0,react.createElement)($054eb8030ebde76e$var$ToastAnnounceExclude, {
        asChild: true
    }, /*#__PURE__*/ (0,react.createElement)(node_modules_radix_ui_react_primitive_dist_index_module_$8927f6f2acc4f386$export$250ffa63cdc0d034.button, (0,esm_extends/* default */.Z)({
        type: "button"
    }, closeProps, {
        ref: forwardedRef,
        onClick: _radix_ui_primitive_dist_index_module_$e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onClick, interactiveContext.onClose)
    })));
});
/*#__PURE__*/ Object.assign($054eb8030ebde76e$export$811e70f61c205839, {
    displayName: $054eb8030ebde76e$var$CLOSE_NAME
});
/* ---------------------------------------------------------------------------------------------- */ const $054eb8030ebde76e$var$ToastAnnounceExclude = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { __scopeToast: __scopeToast , altText: altText , ...announceExcludeProps } = props;
    return /*#__PURE__*/ (0,react.createElement)(node_modules_radix_ui_react_primitive_dist_index_module_$8927f6f2acc4f386$export$250ffa63cdc0d034.div, (0,esm_extends/* default */.Z)({
        "data-radix-toast-announce-exclude": "",
        "data-radix-toast-announce-alt": altText || undefined
    }, announceExcludeProps, {
        ref: forwardedRef
    }));
});
function $054eb8030ebde76e$var$getAnnounceTextContent(container) {
    const textContent = [];
    const childNodes = Array.from(container.childNodes);
    childNodes.forEach((node)=>{
        if (node.nodeType === node.TEXT_NODE && node.textContent) textContent.push(node.textContent);
        if ($054eb8030ebde76e$var$isHTMLElement(node)) {
            const isHidden = node.ariaHidden || node.hidden || node.style.display === 'none';
            const isExcluded = node.dataset.radixToastAnnounceExclude === '';
            if (!isHidden) {
                if (isExcluded) {
                    const altText = node.dataset.radixToastAnnounceAlt;
                    if (altText) textContent.push(altText);
                } else textContent.push(...$054eb8030ebde76e$var$getAnnounceTextContent(node));
            }
        }
    }); // We return a collection of text rather than a single concatenated string.
    // This allows SR VO to naturally pause break between nodes while announcing.
    return textContent;
}
/* ---------------------------------------------------------------------------------------------- */ function $054eb8030ebde76e$var$handleAndDispatchCustomEvent(name, handler, detail, { discrete: discrete  }) {
    const currentTarget = detail.originalEvent.currentTarget;
    const event = new CustomEvent(name, {
        bubbles: true,
        cancelable: true,
        detail: detail
    });
    if (handler) currentTarget.addEventListener(name, handler, {
        once: true
    });
    if (discrete) node_modules_radix_ui_react_primitive_dist_index_module_$8927f6f2acc4f386$export$6d1a0317bde7de7f(currentTarget, event);
    else currentTarget.dispatchEvent(event);
}
const $054eb8030ebde76e$var$isDeltaInDirection = (delta, direction, threshold = 0)=>{
    const deltaX = Math.abs(delta.x);
    const deltaY = Math.abs(delta.y);
    const isDeltaX = deltaX > deltaY;
    if (direction === 'left' || direction === 'right') return isDeltaX && deltaX > threshold;
    else return !isDeltaX && deltaY > threshold;
};
function $054eb8030ebde76e$var$useNextFrame(callback = ()=>{}) {
    const fn = node_modules_radix_ui_react_use_callback_ref_dist_index_module_$b1b2314f5f9a1d84$export$25bec8c6f54ee79a(callback);
    dist_index_module_$9f79659886946c16$export$e5c5a5f917a5871c(()=>{
        let raf1 = 0;
        let raf2 = 0;
        raf1 = window.requestAnimationFrame(()=>raf2 = window.requestAnimationFrame(fn)
        );
        return ()=>{
            window.cancelAnimationFrame(raf1);
            window.cancelAnimationFrame(raf2);
        };
    }, [
        fn
    ]);
}
function $054eb8030ebde76e$var$isHTMLElement(node) {
    return node.nodeType === node.ELEMENT_NODE;
}
/**
 * Returns a list of potential tabbable candidates.
 *
 * NOTE: This is only a close approximation. For example it doesn't take into account cases like when
 * elements are not visible. This cannot be worked out easily by just reading a property, but rather
 * necessitate runtime knowledge (computed styles, etc). We deal with these cases separately.
 *
 * See: https://developer.mozilla.org/en-US/docs/Web/API/TreeWalker
 * Credit: https://github.com/discord/focus-layers/blob/master/src/util/wrapFocus.tsx#L1
 */ function $054eb8030ebde76e$var$getTabbableCandidates(container) {
    const nodes = [];
    const walker = document.createTreeWalker(container, NodeFilter.SHOW_ELEMENT, {
        acceptNode: (node)=>{
            const isHiddenInput = node.tagName === 'INPUT' && node.type === 'hidden';
            if (node.disabled || node.hidden || isHiddenInput) return NodeFilter.FILTER_SKIP; // `.tabIndex` is not the same as the `tabindex` attribute. It works on the
            // runtime's understanding of tabbability, so this automatically accounts
            // for any kind of element that could be tabbed to.
            return node.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
        }
    });
    while(walker.nextNode())nodes.push(walker.currentNode); // we do not take into account the order of nodes with positive `tabIndex` as it
    // hinders accessibility to have tab order different from visual order.
    return nodes;
}
function $054eb8030ebde76e$var$focusFirst(candidates) {
    const previouslyFocusedElement = document.activeElement;
    return candidates.some((candidate)=>{
        // if focus is already where we want to go, we don't want to keep going through the candidates
        if (candidate === previouslyFocusedElement) return true;
        candidate.focus();
        return document.activeElement !== previouslyFocusedElement;
    });
}
const $054eb8030ebde76e$export$2881499e37b75b9a = $054eb8030ebde76e$export$f5d03d415824e0e;
const $054eb8030ebde76e$export$d5c6c08dc2d3ca7 = $054eb8030ebde76e$export$6192c2425ecfd989;
const $054eb8030ebde76e$export$be92b6f5f03c0fe9 = $054eb8030ebde76e$export$8d8dc7d5f743331b;
const $054eb8030ebde76e$export$f99233281efd08a0 = (/* unused pure expression or super */ null && ($054eb8030ebde76e$export$16d42d7c29b95a4));
const $054eb8030ebde76e$export$393edc798c47379d = (/* unused pure expression or super */ null && ($054eb8030ebde76e$export$ecddd96c53621d9a));
const $054eb8030ebde76e$export$e19cd5f9376f8cee = (/* unused pure expression or super */ null && ($054eb8030ebde76e$export$3019feecfda683d2));
const $054eb8030ebde76e$export$f39c2d165cd861fe = (/* unused pure expression or super */ null && ($054eb8030ebde76e$export$811e70f61c205839));





//# sourceMappingURL=index.module.js.map

;// CONCATENATED MODULE: ../node_modules/@react-aria/live-announcer/dist/LiveAnnouncer.mjs
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /* Inspired by https://github.com/AlmeroSteyn/react-aria-live */ const $319e236875307eab$var$LIVEREGION_TIMEOUT_DELAY = 7000;
let $319e236875307eab$var$liveAnnouncer = null;
function $319e236875307eab$export$a9b970dcc4ae71a9(message, assertiveness = 'assertive', timeout = $319e236875307eab$var$LIVEREGION_TIMEOUT_DELAY) {
    if (!$319e236875307eab$var$liveAnnouncer) {
        $319e236875307eab$var$liveAnnouncer = new $319e236875307eab$var$LiveAnnouncer();
        // wait for the live announcer regions to be added to the dom, then announce
        // otherwise Safari won't announce the message if it's added too quickly
        // found most times less than 100ms were not consistent when announcing with Safari
        // IS_REACT_ACT_ENVIRONMENT is used by React 18. Previous versions checked for the `jest` global.
        // https://github.com/reactwg/react-18/discussions/102
        // if we're in a test environment, announce without waiting
        // @ts-ignore
        if (!(typeof IS_REACT_ACT_ENVIRONMENT === 'boolean' ? IS_REACT_ACT_ENVIRONMENT : typeof jest !== 'undefined')) setTimeout(()=>{
            if ($319e236875307eab$var$liveAnnouncer === null || $319e236875307eab$var$liveAnnouncer === void 0 ? void 0 : $319e236875307eab$var$liveAnnouncer.isAttached()) $319e236875307eab$var$liveAnnouncer === null || $319e236875307eab$var$liveAnnouncer === void 0 ? void 0 : $319e236875307eab$var$liveAnnouncer.announce(message, assertiveness, timeout);
        }, 100);
        else $319e236875307eab$var$liveAnnouncer.announce(message, assertiveness, timeout);
    } else $319e236875307eab$var$liveAnnouncer.announce(message, assertiveness, timeout);
}
function $319e236875307eab$export$d10ae4f68404609a(assertiveness) {
    if ($319e236875307eab$var$liveAnnouncer) $319e236875307eab$var$liveAnnouncer.clear(assertiveness);
}
function $319e236875307eab$export$d8686216b8b81b2f() {
    if ($319e236875307eab$var$liveAnnouncer) {
        $319e236875307eab$var$liveAnnouncer.destroy();
        $319e236875307eab$var$liveAnnouncer = null;
    }
}
// LiveAnnouncer is implemented using vanilla DOM, not React. That's because as of React 18
// ReactDOM.render is deprecated, and the replacement, ReactDOM.createRoot is moved into a
// subpath import `react-dom/client`. That makes it hard for us to support multiple React versions.
// As a global API, we can't use portals without introducing a breaking API change. LiveAnnouncer
// is simple enough to implement without React, so that's what we do here.
// See this discussion for more details: https://github.com/reactwg/react-18/discussions/125#discussioncomment-2382638
class $319e236875307eab$var$LiveAnnouncer {
    isAttached() {
        var _this_node;
        return (_this_node = this.node) === null || _this_node === void 0 ? void 0 : _this_node.isConnected;
    }
    createLog(ariaLive) {
        let node = document.createElement('div');
        node.setAttribute('role', 'log');
        node.setAttribute('aria-live', ariaLive);
        node.setAttribute('aria-relevant', 'additions');
        return node;
    }
    destroy() {
        if (!this.node) return;
        document.body.removeChild(this.node);
        this.node = null;
    }
    announce(message, assertiveness = 'assertive', timeout = $319e236875307eab$var$LIVEREGION_TIMEOUT_DELAY) {
        var _this_assertiveLog, _this_politeLog;
        if (!this.node) return;
        let node = document.createElement('div');
        if (typeof message === 'object') {
            // To read an aria-labelledby, the element must have an appropriate role, such as img.
            node.setAttribute('role', 'img');
            node.setAttribute('aria-labelledby', message['aria-labelledby']);
        } else node.textContent = message;
        if (assertiveness === 'assertive') (_this_assertiveLog = this.assertiveLog) === null || _this_assertiveLog === void 0 ? void 0 : _this_assertiveLog.appendChild(node);
        else (_this_politeLog = this.politeLog) === null || _this_politeLog === void 0 ? void 0 : _this_politeLog.appendChild(node);
        if (message !== '') setTimeout(()=>{
            node.remove();
        }, timeout);
    }
    clear(assertiveness) {
        if (!this.node) return;
        if ((!assertiveness || assertiveness === 'assertive') && this.assertiveLog) this.assertiveLog.innerHTML = '';
        if ((!assertiveness || assertiveness === 'polite') && this.politeLog) this.politeLog.innerHTML = '';
    }
    constructor(){
        this.node = null;
        this.assertiveLog = null;
        this.politeLog = null;
        if (typeof document !== 'undefined') {
            this.node = document.createElement('div');
            this.node.dataset.liveAnnouncer = 'true';
            // copied from VisuallyHidden
            Object.assign(this.node.style, {
                border: 0,
                clip: 'rect(0 0 0 0)',
                clipPath: 'inset(50%)',
                height: '1px',
                margin: '-1px',
                overflow: 'hidden',
                padding: 0,
                position: 'absolute',
                width: '1px',
                whiteSpace: 'nowrap'
            });
            this.assertiveLog = this.createLog('assertive');
            this.node.appendChild(this.assertiveLog);
            this.politeLog = this.createLog('polite');
            this.node.appendChild(this.politeLog);
            document.body.prepend(this.node);
        }
    }
}



//# sourceMappingURL=LiveAnnouncer.module.js.map

;// CONCATENATED MODULE: ../node_modules/@radix-ui/react-toggle/dist/index.mjs











/* -------------------------------------------------------------------------------------------------
 * Toggle
 * -----------------------------------------------------------------------------------------------*/ const $b3bbe2732c13b576$var$NAME = 'Toggle';
const $b3bbe2732c13b576$export$bea8ebba691c5813 = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { pressed: pressedProp , defaultPressed: defaultPressed = false , onPressedChange: onPressedChange , ...buttonProps } = props;
    const [pressed = false, setPressed] = (0,react_use_controllable_state_dist/* useControllableState */.T)({
        prop: pressedProp,
        onChange: onPressedChange,
        defaultProp: defaultPressed
    });
    return /*#__PURE__*/ (0,react.createElement)(react_primitive_dist/* Primitive.button */.WV.button, (0,esm_extends/* default */.Z)({
        type: "button",
        "aria-pressed": pressed,
        "data-state": pressed ? 'on' : 'off',
        "data-disabled": props.disabled ? '' : undefined
    }, buttonProps, {
        ref: forwardedRef,
        onClick: (0,dist/* composeEventHandlers */.M)(props.onClick, ()=>{
            if (!props.disabled) setPressed(!pressed);
        })
    }));
});
/*#__PURE__*/ Object.assign($b3bbe2732c13b576$export$bea8ebba691c5813, {
    displayName: $b3bbe2732c13b576$var$NAME
});
/* ---------------------------------------------------------------------------------------------- */ const $b3bbe2732c13b576$export$be92b6f5f03c0fe9 = (/* unused pure expression or super */ null && ($b3bbe2732c13b576$export$bea8ebba691c5813));





//# sourceMappingURL=index.mjs.map

// EXTERNAL MODULE: ../node_modules/@radix-ui/react-collection/dist/index.mjs + 1 modules
var react_collection_dist = __webpack_require__(84878);
// EXTERNAL MODULE: ../node_modules/@radix-ui/react-direction/dist/index.mjs
var react_direction_dist = __webpack_require__(73814);
;// CONCATENATED MODULE: ../node_modules/@radix-ui/react-roving-focus/dist/index.mjs























const $d7bdfb9eb0fdf311$var$ENTRY_FOCUS = 'rovingFocusGroup.onEntryFocus';
const $d7bdfb9eb0fdf311$var$EVENT_OPTIONS = {
    bubbles: false,
    cancelable: true
};
/* -------------------------------------------------------------------------------------------------
 * RovingFocusGroup
 * -----------------------------------------------------------------------------------------------*/ const $d7bdfb9eb0fdf311$var$GROUP_NAME = 'RovingFocusGroup';
const [$d7bdfb9eb0fdf311$var$Collection, $d7bdfb9eb0fdf311$var$useCollection, $d7bdfb9eb0fdf311$var$createCollectionScope] = (0,react_collection_dist/* createCollection */.B)($d7bdfb9eb0fdf311$var$GROUP_NAME);
const [$d7bdfb9eb0fdf311$var$createRovingFocusGroupContext, $d7bdfb9eb0fdf311$export$c7109489551a4f4] = (0,react_context_dist/* createContextScope */.b)($d7bdfb9eb0fdf311$var$GROUP_NAME, [
    $d7bdfb9eb0fdf311$var$createCollectionScope
]);
const [$d7bdfb9eb0fdf311$var$RovingFocusProvider, $d7bdfb9eb0fdf311$var$useRovingFocusContext] = $d7bdfb9eb0fdf311$var$createRovingFocusGroupContext($d7bdfb9eb0fdf311$var$GROUP_NAME);
const $d7bdfb9eb0fdf311$export$8699f7c8af148338 = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    return /*#__PURE__*/ (0,react.createElement)($d7bdfb9eb0fdf311$var$Collection.Provider, {
        scope: props.__scopeRovingFocusGroup
    }, /*#__PURE__*/ (0,react.createElement)($d7bdfb9eb0fdf311$var$Collection.Slot, {
        scope: props.__scopeRovingFocusGroup
    }, /*#__PURE__*/ (0,react.createElement)($d7bdfb9eb0fdf311$var$RovingFocusGroupImpl, (0,esm_extends/* default */.Z)({}, props, {
        ref: forwardedRef
    }))));
});
/*#__PURE__*/ Object.assign($d7bdfb9eb0fdf311$export$8699f7c8af148338, {
    displayName: $d7bdfb9eb0fdf311$var$GROUP_NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $d7bdfb9eb0fdf311$var$RovingFocusGroupImpl = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { __scopeRovingFocusGroup: __scopeRovingFocusGroup , orientation: orientation , loop: loop = false , dir: dir , currentTabStopId: currentTabStopIdProp , defaultCurrentTabStopId: defaultCurrentTabStopId , onCurrentTabStopIdChange: onCurrentTabStopIdChange , onEntryFocus: onEntryFocus , ...groupProps } = props;
    const ref = (0,react.useRef)(null);
    const composedRefs = (0,react_compose_refs_dist/* useComposedRefs */.e)(forwardedRef, ref);
    const direction = (0,react_direction_dist/* useDirection */.gm)(dir);
    const [currentTabStopId = null, setCurrentTabStopId] = (0,react_use_controllable_state_dist/* useControllableState */.T)({
        prop: currentTabStopIdProp,
        defaultProp: defaultCurrentTabStopId,
        onChange: onCurrentTabStopIdChange
    });
    const [isTabbingBackOut, setIsTabbingBackOut] = (0,react.useState)(false);
    const handleEntryFocus = (0,react_use_callback_ref_dist/* useCallbackRef */.W)(onEntryFocus);
    const getItems = $d7bdfb9eb0fdf311$var$useCollection(__scopeRovingFocusGroup);
    const isClickFocusRef = (0,react.useRef)(false);
    const [focusableItemsCount, setFocusableItemsCount] = (0,react.useState)(0);
    (0,react.useEffect)(()=>{
        const node = ref.current;
        if (node) {
            node.addEventListener($d7bdfb9eb0fdf311$var$ENTRY_FOCUS, handleEntryFocus);
            return ()=>node.removeEventListener($d7bdfb9eb0fdf311$var$ENTRY_FOCUS, handleEntryFocus)
            ;
        }
    }, [
        handleEntryFocus
    ]);
    return /*#__PURE__*/ (0,react.createElement)($d7bdfb9eb0fdf311$var$RovingFocusProvider, {
        scope: __scopeRovingFocusGroup,
        orientation: orientation,
        dir: direction,
        loop: loop,
        currentTabStopId: currentTabStopId,
        onItemFocus: (0,react.useCallback)((tabStopId)=>setCurrentTabStopId(tabStopId)
        , [
            setCurrentTabStopId
        ]),
        onItemShiftTab: (0,react.useCallback)(()=>setIsTabbingBackOut(true)
        , []),
        onFocusableItemAdd: (0,react.useCallback)(()=>setFocusableItemsCount((prevCount)=>prevCount + 1
            )
        , []),
        onFocusableItemRemove: (0,react.useCallback)(()=>setFocusableItemsCount((prevCount)=>prevCount - 1
            )
        , [])
    }, /*#__PURE__*/ (0,react.createElement)(react_primitive_dist/* Primitive.div */.WV.div, (0,esm_extends/* default */.Z)({
        tabIndex: isTabbingBackOut || focusableItemsCount === 0 ? -1 : 0,
        "data-orientation": orientation
    }, groupProps, {
        ref: composedRefs,
        style: {
            outline: 'none',
            ...props.style
        },
        onMouseDown: (0,dist/* composeEventHandlers */.M)(props.onMouseDown, ()=>{
            isClickFocusRef.current = true;
        }),
        onFocus: (0,dist/* composeEventHandlers */.M)(props.onFocus, (event)=>{
            // We normally wouldn't need this check, because we already check
            // that the focus is on the current target and not bubbling to it.
            // We do this because Safari doesn't focus buttons when clicked, and
            // instead, the wrapper will get focused and not through a bubbling event.
            const isKeyboardFocus = !isClickFocusRef.current;
            if (event.target === event.currentTarget && isKeyboardFocus && !isTabbingBackOut) {
                const entryFocusEvent = new CustomEvent($d7bdfb9eb0fdf311$var$ENTRY_FOCUS, $d7bdfb9eb0fdf311$var$EVENT_OPTIONS);
                event.currentTarget.dispatchEvent(entryFocusEvent);
                if (!entryFocusEvent.defaultPrevented) {
                    const items = getItems().filter((item)=>item.focusable
                    );
                    const activeItem = items.find((item)=>item.active
                    );
                    const currentItem = items.find((item)=>item.id === currentTabStopId
                    );
                    const candidateItems = [
                        activeItem,
                        currentItem,
                        ...items
                    ].filter(Boolean);
                    const candidateNodes = candidateItems.map((item)=>item.ref.current
                    );
                    $d7bdfb9eb0fdf311$var$focusFirst(candidateNodes);
                }
            }
            isClickFocusRef.current = false;
        }),
        onBlur: (0,dist/* composeEventHandlers */.M)(props.onBlur, ()=>setIsTabbingBackOut(false)
        )
    })));
});
/* -------------------------------------------------------------------------------------------------
 * RovingFocusGroupItem
 * -----------------------------------------------------------------------------------------------*/ const $d7bdfb9eb0fdf311$var$ITEM_NAME = 'RovingFocusGroupItem';
const $d7bdfb9eb0fdf311$export$ab9df7c53fe8454 = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { __scopeRovingFocusGroup: __scopeRovingFocusGroup , focusable: focusable = true , active: active = false , tabStopId: tabStopId , ...itemProps } = props;
    const autoId = dist_$1746a345f3d73bb7$export$f680877a34711e37();
    const id = tabStopId || autoId;
    const context = $d7bdfb9eb0fdf311$var$useRovingFocusContext($d7bdfb9eb0fdf311$var$ITEM_NAME, __scopeRovingFocusGroup);
    const isCurrentTabStop = context.currentTabStopId === id;
    const getItems = $d7bdfb9eb0fdf311$var$useCollection(__scopeRovingFocusGroup);
    const { onFocusableItemAdd: onFocusableItemAdd , onFocusableItemRemove: onFocusableItemRemove  } = context;
    (0,react.useEffect)(()=>{
        if (focusable) {
            onFocusableItemAdd();
            return ()=>onFocusableItemRemove()
            ;
        }
    }, [
        focusable,
        onFocusableItemAdd,
        onFocusableItemRemove
    ]);
    return /*#__PURE__*/ (0,react.createElement)($d7bdfb9eb0fdf311$var$Collection.ItemSlot, {
        scope: __scopeRovingFocusGroup,
        id: id,
        focusable: focusable,
        active: active
    }, /*#__PURE__*/ (0,react.createElement)(react_primitive_dist/* Primitive.span */.WV.span, (0,esm_extends/* default */.Z)({
        tabIndex: isCurrentTabStop ? 0 : -1,
        "data-orientation": context.orientation
    }, itemProps, {
        ref: forwardedRef,
        onMouseDown: (0,dist/* composeEventHandlers */.M)(props.onMouseDown, (event)=>{
            // We prevent focusing non-focusable items on `mousedown`.
            // Even though the item has tabIndex={-1}, that only means take it out of the tab order.
            if (!focusable) event.preventDefault(); // Safari doesn't focus a button when clicked so we run our logic on mousedown also
            else context.onItemFocus(id);
        }),
        onFocus: (0,dist/* composeEventHandlers */.M)(props.onFocus, ()=>context.onItemFocus(id)
        ),
        onKeyDown: (0,dist/* composeEventHandlers */.M)(props.onKeyDown, (event)=>{
            if (event.key === 'Tab' && event.shiftKey) {
                context.onItemShiftTab();
                return;
            }
            if (event.target !== event.currentTarget) return;
            const focusIntent = $d7bdfb9eb0fdf311$var$getFocusIntent(event, context.orientation, context.dir);
            if (focusIntent !== undefined) {
                event.preventDefault();
                const items = getItems().filter((item)=>item.focusable
                );
                let candidateNodes = items.map((item)=>item.ref.current
                );
                if (focusIntent === 'last') candidateNodes.reverse();
                else if (focusIntent === 'prev' || focusIntent === 'next') {
                    if (focusIntent === 'prev') candidateNodes.reverse();
                    const currentIndex = candidateNodes.indexOf(event.currentTarget);
                    candidateNodes = context.loop ? $d7bdfb9eb0fdf311$var$wrapArray(candidateNodes, currentIndex + 1) : candidateNodes.slice(currentIndex + 1);
                }
                /**
         * Imperative focus during keydown is risky so we prevent React's batching updates
         * to avoid potential bugs. See: https://github.com/facebook/react/issues/20332
         */ setTimeout(()=>$d7bdfb9eb0fdf311$var$focusFirst(candidateNodes)
                );
            }
        })
    })));
});
/*#__PURE__*/ Object.assign($d7bdfb9eb0fdf311$export$ab9df7c53fe8454, {
    displayName: $d7bdfb9eb0fdf311$var$ITEM_NAME
});
/* -----------------------------------------------------------------------------------------------*/ // prettier-ignore
const $d7bdfb9eb0fdf311$var$MAP_KEY_TO_FOCUS_INTENT = {
    ArrowLeft: 'prev',
    ArrowUp: 'prev',
    ArrowRight: 'next',
    ArrowDown: 'next',
    PageUp: 'first',
    Home: 'first',
    PageDown: 'last',
    End: 'last'
};
function $d7bdfb9eb0fdf311$var$getDirectionAwareKey(key, dir) {
    if (dir !== 'rtl') return key;
    return key === 'ArrowLeft' ? 'ArrowRight' : key === 'ArrowRight' ? 'ArrowLeft' : key;
}
function $d7bdfb9eb0fdf311$var$getFocusIntent(event, orientation, dir) {
    const key = $d7bdfb9eb0fdf311$var$getDirectionAwareKey(event.key, dir);
    if (orientation === 'vertical' && [
        'ArrowLeft',
        'ArrowRight'
    ].includes(key)) return undefined;
    if (orientation === 'horizontal' && [
        'ArrowUp',
        'ArrowDown'
    ].includes(key)) return undefined;
    return $d7bdfb9eb0fdf311$var$MAP_KEY_TO_FOCUS_INTENT[key];
}
function $d7bdfb9eb0fdf311$var$focusFirst(candidates) {
    const PREVIOUSLY_FOCUSED_ELEMENT = document.activeElement;
    for (const candidate of candidates){
        // if focus is already where we want to go, we don't want to keep going through the candidates
        if (candidate === PREVIOUSLY_FOCUSED_ELEMENT) return;
        candidate.focus();
        if (document.activeElement !== PREVIOUSLY_FOCUSED_ELEMENT) return;
    }
}
/**
 * Wraps an array around itself at a given start index
 * Example: `wrapArray(['a', 'b', 'c', 'd'], 2) === ['c', 'd', 'a', 'b']`
 */ function $d7bdfb9eb0fdf311$var$wrapArray(array, startIndex) {
    return array.map((_, index)=>array[(startIndex + index) % array.length]
    );
}
const $d7bdfb9eb0fdf311$export$be92b6f5f03c0fe9 = $d7bdfb9eb0fdf311$export$8699f7c8af148338;
const $d7bdfb9eb0fdf311$export$6d08773d2e66f8f2 = $d7bdfb9eb0fdf311$export$ab9df7c53fe8454;





//# sourceMappingURL=index.mjs.map

;// CONCATENATED MODULE: ../node_modules/@radix-ui/react-toggle-group/dist/index.mjs


















/* -------------------------------------------------------------------------------------------------
 * ToggleGroup
 * -----------------------------------------------------------------------------------------------*/ const $6c1fd9e6a8969628$var$TOGGLE_GROUP_NAME = 'ToggleGroup';
const [$6c1fd9e6a8969628$var$createToggleGroupContext, $6c1fd9e6a8969628$export$d1c7c4bcd9f26dd4] = (0,react_context_dist/* createContextScope */.b)($6c1fd9e6a8969628$var$TOGGLE_GROUP_NAME, [
    $d7bdfb9eb0fdf311$export$c7109489551a4f4
]);
const $6c1fd9e6a8969628$var$useRovingFocusGroupScope = $d7bdfb9eb0fdf311$export$c7109489551a4f4();
const $6c1fd9e6a8969628$export$af3ec21f6cfb5e30 = /*#__PURE__*/ react.forwardRef((props, forwardedRef)=>{
    const { type: type , ...toggleGroupProps } = props;
    if (type === 'single') {
        const singleProps = toggleGroupProps;
        return /*#__PURE__*/ react.createElement($6c1fd9e6a8969628$var$ToggleGroupImplSingle, (0,esm_extends/* default */.Z)({}, singleProps, {
            ref: forwardedRef
        }));
    }
    if (type === 'multiple') {
        const multipleProps = toggleGroupProps;
        return /*#__PURE__*/ react.createElement($6c1fd9e6a8969628$var$ToggleGroupImplMultiple, (0,esm_extends/* default */.Z)({}, multipleProps, {
            ref: forwardedRef
        }));
    }
    throw new Error(`Missing prop \`type\` expected on \`${$6c1fd9e6a8969628$var$TOGGLE_GROUP_NAME}\``);
});
/*#__PURE__*/ Object.assign($6c1fd9e6a8969628$export$af3ec21f6cfb5e30, {
    displayName: $6c1fd9e6a8969628$var$TOGGLE_GROUP_NAME
});
/* -----------------------------------------------------------------------------------------------*/ const [$6c1fd9e6a8969628$var$ToggleGroupValueProvider, $6c1fd9e6a8969628$var$useToggleGroupValueContext] = $6c1fd9e6a8969628$var$createToggleGroupContext($6c1fd9e6a8969628$var$TOGGLE_GROUP_NAME);
const $6c1fd9e6a8969628$var$ToggleGroupImplSingle = /*#__PURE__*/ react.forwardRef((props, forwardedRef)=>{
    const { value: valueProp , defaultValue: defaultValue , onValueChange: onValueChange = ()=>{} , ...toggleGroupSingleProps } = props;
    const [value, setValue] = (0,react_use_controllable_state_dist/* useControllableState */.T)({
        prop: valueProp,
        defaultProp: defaultValue,
        onChange: onValueChange
    });
    return /*#__PURE__*/ react.createElement($6c1fd9e6a8969628$var$ToggleGroupValueProvider, {
        scope: props.__scopeToggleGroup,
        type: "single",
        value: value ? [
            value
        ] : [],
        onItemActivate: setValue,
        onItemDeactivate: react.useCallback(()=>setValue('')
        , [
            setValue
        ])
    }, /*#__PURE__*/ react.createElement($6c1fd9e6a8969628$var$ToggleGroupImpl, (0,esm_extends/* default */.Z)({}, toggleGroupSingleProps, {
        ref: forwardedRef
    })));
});
const $6c1fd9e6a8969628$var$ToggleGroupImplMultiple = /*#__PURE__*/ react.forwardRef((props, forwardedRef)=>{
    const { value: valueProp , defaultValue: defaultValue , onValueChange: onValueChange = ()=>{} , ...toggleGroupMultipleProps } = props;
    const [value1 = [], setValue] = (0,react_use_controllable_state_dist/* useControllableState */.T)({
        prop: valueProp,
        defaultProp: defaultValue,
        onChange: onValueChange
    });
    const handleButtonActivate = react.useCallback((itemValue)=>setValue((prevValue = [])=>[
                ...prevValue,
                itemValue
            ]
        )
    , [
        setValue
    ]);
    const handleButtonDeactivate = react.useCallback((itemValue)=>setValue((prevValue = [])=>prevValue.filter((value)=>value !== itemValue
            )
        )
    , [
        setValue
    ]);
    return /*#__PURE__*/ react.createElement($6c1fd9e6a8969628$var$ToggleGroupValueProvider, {
        scope: props.__scopeToggleGroup,
        type: "multiple",
        value: value1,
        onItemActivate: handleButtonActivate,
        onItemDeactivate: handleButtonDeactivate
    }, /*#__PURE__*/ react.createElement($6c1fd9e6a8969628$var$ToggleGroupImpl, (0,esm_extends/* default */.Z)({}, toggleGroupMultipleProps, {
        ref: forwardedRef
    })));
});
/*#__PURE__*/ Object.assign($6c1fd9e6a8969628$export$af3ec21f6cfb5e30, {
    displayName: $6c1fd9e6a8969628$var$TOGGLE_GROUP_NAME
});
/* -----------------------------------------------------------------------------------------------*/ const [$6c1fd9e6a8969628$var$ToggleGroupContext, $6c1fd9e6a8969628$var$useToggleGroupContext] = $6c1fd9e6a8969628$var$createToggleGroupContext($6c1fd9e6a8969628$var$TOGGLE_GROUP_NAME);
const $6c1fd9e6a8969628$var$ToggleGroupImpl = /*#__PURE__*/ react.forwardRef((props, forwardedRef)=>{
    const { __scopeToggleGroup: __scopeToggleGroup , disabled: disabled = false , rovingFocus: rovingFocus = true , orientation: orientation , dir: dir , loop: loop = true , ...toggleGroupProps } = props;
    const rovingFocusGroupScope = $6c1fd9e6a8969628$var$useRovingFocusGroupScope(__scopeToggleGroup);
    const direction = (0,react_direction_dist/* useDirection */.gm)(dir);
    const commonProps = {
        role: 'group',
        dir: direction,
        ...toggleGroupProps
    };
    return /*#__PURE__*/ react.createElement($6c1fd9e6a8969628$var$ToggleGroupContext, {
        scope: __scopeToggleGroup,
        rovingFocus: rovingFocus,
        disabled: disabled
    }, rovingFocus ? /*#__PURE__*/ react.createElement($d7bdfb9eb0fdf311$export$be92b6f5f03c0fe9, (0,esm_extends/* default */.Z)({
        asChild: true
    }, rovingFocusGroupScope, {
        orientation: orientation,
        dir: direction,
        loop: loop
    }), /*#__PURE__*/ react.createElement(react_primitive_dist/* Primitive.div */.WV.div, (0,esm_extends/* default */.Z)({}, commonProps, {
        ref: forwardedRef
    }))) : /*#__PURE__*/ react.createElement(react_primitive_dist/* Primitive.div */.WV.div, (0,esm_extends/* default */.Z)({}, commonProps, {
        ref: forwardedRef
    })));
});
/* -------------------------------------------------------------------------------------------------
 * ToggleGroupItem
 * -----------------------------------------------------------------------------------------------*/ const $6c1fd9e6a8969628$var$ITEM_NAME = 'ToggleGroupItem';
const $6c1fd9e6a8969628$export$b453109e13abe10b = /*#__PURE__*/ react.forwardRef((props, forwardedRef)=>{
    const valueContext = $6c1fd9e6a8969628$var$useToggleGroupValueContext($6c1fd9e6a8969628$var$ITEM_NAME, props.__scopeToggleGroup);
    const context = $6c1fd9e6a8969628$var$useToggleGroupContext($6c1fd9e6a8969628$var$ITEM_NAME, props.__scopeToggleGroup);
    const rovingFocusGroupScope = $6c1fd9e6a8969628$var$useRovingFocusGroupScope(props.__scopeToggleGroup);
    const pressed = valueContext.value.includes(props.value);
    const disabled = context.disabled || props.disabled;
    const commonProps = {
        ...props,
        pressed: pressed,
        disabled: disabled
    };
    const ref = react.useRef(null);
    return context.rovingFocus ? /*#__PURE__*/ react.createElement($d7bdfb9eb0fdf311$export$6d08773d2e66f8f2, (0,esm_extends/* default */.Z)({
        asChild: true
    }, rovingFocusGroupScope, {
        focusable: !disabled,
        active: pressed,
        ref: ref
    }), /*#__PURE__*/ react.createElement($6c1fd9e6a8969628$var$ToggleGroupItemImpl, (0,esm_extends/* default */.Z)({}, commonProps, {
        ref: forwardedRef
    }))) : /*#__PURE__*/ react.createElement($6c1fd9e6a8969628$var$ToggleGroupItemImpl, (0,esm_extends/* default */.Z)({}, commonProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($6c1fd9e6a8969628$export$b453109e13abe10b, {
    displayName: $6c1fd9e6a8969628$var$ITEM_NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $6c1fd9e6a8969628$var$ToggleGroupItemImpl = /*#__PURE__*/ react.forwardRef((props, forwardedRef)=>{
    const { __scopeToggleGroup: __scopeToggleGroup , value: value , ...itemProps } = props;
    const valueContext = $6c1fd9e6a8969628$var$useToggleGroupValueContext($6c1fd9e6a8969628$var$ITEM_NAME, __scopeToggleGroup);
    const singleProps = {
        role: 'radio',
        'aria-checked': props.pressed,
        'aria-pressed': undefined
    };
    const typeProps = valueContext.type === 'single' ? singleProps : undefined;
    return /*#__PURE__*/ react.createElement($b3bbe2732c13b576$export$bea8ebba691c5813, (0,esm_extends/* default */.Z)({}, typeProps, itemProps, {
        ref: forwardedRef,
        onPressedChange: (pressed)=>{
            if (pressed) valueContext.onItemActivate(value);
            else valueContext.onItemDeactivate(value);
        }
    }));
});
/* -----------------------------------------------------------------------------------------------*/ const $6c1fd9e6a8969628$export$be92b6f5f03c0fe9 = (/* unused pure expression or super */ null && ($6c1fd9e6a8969628$export$af3ec21f6cfb5e30));
const $6c1fd9e6a8969628$export$6d08773d2e66f8f2 = (/* unused pure expression or super */ null && ($6c1fd9e6a8969628$export$b453109e13abe10b));





//# sourceMappingURL=index.mjs.map

;// CONCATENATED MODULE: ../node_modules/@global-ecom/nitro-uds/dist/elements/esm/index.js
























const sizeStyle = (0,style/* style */.oB)({
    variants: {
        size: {
            sm: 'text-xxs',
            base: 'text-xs',
            lg: 'text-base',
        },
    },
});
const dot = css_css/* css */.iv `
  position: relative;
  border-radius: 50%;
  background-color: currentColor;
  transform: scale(0);
  width: 1em;
  height: 1em;

  &:nth-child(1) {
    animation-delay: 0.15s;
  }
  &:nth-child(2) {
    animation-delay: 0.35s;
  }
  &:nth-child(3) {
    animation-delay: 0.55s;
  }
`;
const dotPlaying = css_css/* css */.iv `
  animation: dotPulse 1.3s infinite linear;
  @keyframes dotPulse {
    0% {
      transform: scale(0);
    }
    40% {
      transform: scale(1);
    }
    80%,
    100% {
      transform: scale(0);
    }
  }
`;
const DotAnimation = ({ className, on = true, size = 'base', compact = false, ...rest }) => {
    const [playing, setPlaying] = (0,react.useState)(false);
    const playingTimeoutRef = (0,react.useRef)();
    (0,react.useEffect)(() => {
        playingTimeoutRef.current && clearTimeout(playingTimeoutRef.current);
        playingTimeoutRef.current = setTimeout(() => {
            setPlaying(on);
        }, on ? 0 : 300);
        return () => {
            playingTimeoutRef.current && clearTimeout(playingTimeoutRef.current);
        };
    }, [on, setPlaying]);
    return playing ? (react.createElement("div", { "data-uds-child": "dot-animation", className: (0,css_css.tw)(className, sizeStyle({ size }), 'flex space-x-1.5 transition-opacity duration-300', on ? 'opacity-100' : 'opacity-0'), ...rest },
        react.createElement("div", { "data-uds-child": "dot", className: (0,css_css.tw)(dot, playing && dotPlaying) }),
        react.createElement("div", { "data-uds-child": "dot", className: (0,css_css.tw)(dot, playing && dotPlaying) }),
        compact === false ? (react.createElement("div", { "data-uds-child": "dot", className: (0,css_css.tw)(dot, playing && dotPlaying) })) : null)) : null;
};

const colorStyle = (0,style/* style */.oB)({
    variants: {
        /**
         * Semantic color options.
         *
         * @defaultValue base
         */
        color: {
            current: '',
            inherit: 'text-inherit',
            base: 'text-neutral-100',
            muted: 'text-neutral-60',
            brand: 'text-brand-60',
            success: 'text-success-60',
            info: 'text-info-60',
            error: 'text-error-60',
            warning: 'text-warning-70',
        },
        /**
         * Use `invert` mode when rendering on dark backgrounds.
         *
         * @defaultValue false
         */
        invert: {
            true: '',
            false: '',
        },
    },
    matches: [
        {
            invert: true,
            color: 'base',
            use: 'text-neutral-0',
        },
        {
            invert: true,
            color: 'muted',
            use: 'text-neutral-50',
        },
        {
            invert: true,
            color: 'brand',
            use: 'text-brand-30',
        },
        {
            invert: true,
            color: 'success',
            use: 'text-success-40',
        },
        {
            invert: true,
            color: 'info',
            use: 'text-info-40',
        },
        {
            invert: true,
            color: 'warning',
            use: 'text-warning-50',
        },
        {
            invert: true,
            color: 'error',
            use: 'text-error-40',
        },
    ],
    defaults: {
        color: 'current',
    },
});
const fontStyle = (0,style/* style */.oB)({
    variants: {
        /**
         * Font weight.
         *
         * @defaultValue 400
         */
        weight: {
            400: 'font-normal',
            normal: 'font-normal',
            700: 'font-bold',
            bold: 'font-bold',
        },
        condensed: {
            false: 'font-stretch-normal',
            true: 'font-stretch-condensed',
        },
        /**
         * Transform text case.
         *
         * @defaultValue none
         */
        transform: {
            none: '',
            uppercase: 'uppercase',
            lowercase: 'lowercase',
            capitalize: 'capitalize',
        },
        /**
         * Render the text as visually hidden for screen readers.
         *
         * - For visually hidden text, it is recommended to use
         * plain tailwind styling `<p className="sr-only"/>`.
         *
         * @defaultValue false
         */
        srOnly: {
            true: 'sr-only',
            false: 'not-sr-only	',
        },
    },
});

const ICONS_BIDI = ["arrow-left", "arrow-right", "chevron-left", "chevron-right"];

const ICON_SIZES = {
    inherit: 'text-[1.2em]',
    xxs: 'text-xxs',
    xs: 'text-xs',
    sm: 'text-sm',
    base: 'text-base',
    lg: 'text-lg',
    xl: 'text-xl',
    '2xl': 'text-2xl',
    '3xl': 'text-3xl',
    '4xl': 'text-4xl',
    '5xl': 'text-5xl',
    '6xl': 'text-6xl',
    '7xl': 'text-7xl',
    '8xl': 'text-8xl',
    '9xl': 'text-9xl',
    '10xl': 'text-10xl',
};
const iconSizeStyle = (0,style/* style */.oB)({
    variants: {
        /**
         * Set the size of the icon.
         * - Uses the text size scale
         * - If a size is not provided, the icon will inherit the width and height of it's container
         * - Set to `inherit` to inherit the font-size of parent text
         */
        size: ICON_SIZES,
    },
});
/**
 * `Icon` is a wrapper designed to be used around svg icons. It applies some necessary
 * accessibility attributes, and provides the option to render an accessible label.
 *
 * @example
 * ```
 * <Icon name="cart" size="base" label="Cart" />
 * ```
 */
const Icon = ({ name, children, className, label, dataTestId, size, aspectRatio = 1, bidi, color, invert, ...rest }) => {
    const { iconDirectory } = (0,esm/* useUdsContext */.vV)();
    const isBidi = ICONS_BIDI.includes(name);
    const sizeClassName = size
        ? (0,style.tw)(iconSizeStyle({ size }), `w-[1em] h-[${aspectRatio}em]`)
        : `w-full h-full`;
    const svgProps = {
        'aria-hidden': 'true',
        focusable: 'false',
        className: (0,style.tw)(sizeClassName, colorStyle({ color, invert }), (bidi || isBidi) && 'rtl:(transform -scale-x-100 origin-center)', className),
        'data-test-id': dataTestId,
        ...rest,
    };
    const href = `${iconDirectory}/${name}.svg#icon`;
    //.only to ensure only one child has been passed
    const child = children && react.Children.only(children);
    return (react.createElement(react.Fragment, null,
        name ? (react.createElement("svg", { "data-uds-child": "icon", ...svgProps },
            react.createElement("use", { href: href, 
                // xlinkHref attribute is needed for backwards compatability
                // https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/xlink:href
                xlinkHref: href }))) : child ? (react.cloneElement(child, svgProps)) : null,
        label && (react.createElement("span", { "data-test-id": dataTestId ? `${dataTestId}-label` : null, className: "sr-only", "data-uds-child": "icon-label" }, label))));
};

const ctaStyle = (0,style/* style */.oB)({
    base: 'pointer-events-all relative inline-flex whitespace-normal items-center justify-center h-10 min-w-max border-1 text-white bg-neutral-100 border-neutral-100 hover:(bg-neutral-80 border-neutral-80) focus-visible:(bg-neutral-80 border-neutral-80 ring-0 outline-none)',
    variants: {
        /**
         * Choose one of the core CTA styles.
         *
         * - primary: a solid rectangle
         * - secondary: outline rectangle
         * - ghost: transparent rectangle
         * - underline: deprecated - use `ButtonUnderline` or `ButtonText` instead
         *
         * @defaultValue primary
         *
         * @example
         * ```
         * <ButtonCta variant="primary" label="Shop Running" />
         * ```
         */
        variant: {
            primary: 'text-white bg-neutral-100 border-neutral-100 hover:(bg-neutral-80 border-neutral-80) focus-visible:(bg-neutral-80 border-neutral-80)',
            secondary: 'text-neutral-100 border-neutral-40 bg-transparent hover:(bg-transparent border-neutral-100) focus-visible:(bg-transparent border-neutral-100)',
            ghost: 'bg-neutral-100 border-transparent bg-opacity-0 text-neutral-100 hover:(border-transparent bg-opacity-20) focus-visible:(border-transparent bg-opacity-20)',
            underline: 'h-auto rounded-none border-0 bg-transparent border-transparent text-neutral-100 hover:(bg-transparent) focus-visible:(bg-transparent)',
        },
        /**
         * Use to render elements on dark backgrounds
         *
         * @defaultValue false
         *
         * @example
         * ```
         * <ButtonCta
         *   variant="primary"
         *   label="Shop Running"
         *   invert={true}
         * />
         * ```
         */
        invert: {
            true: 'bg-white border-white text-neutral-100 hover:(bg-neutral-20 border-neutral-20) focus-visible:(bg-neutral-20 border-neutral-20)',
            false: '',
        },
        /**
         * Set rounded corners
         *
         * @defaultValue false
         */
        round: {
            true: 'rounded-full',
            false: 'rounded-sm',
        },
        /**
         * Set to full width
         *
         * @defaultValue false
         */
        bleed: {
            true: 'w-full',
            false: '',
        },
        /**
         * Semantic color property. Currently only supports `brand`
         */
        color: {
            default: '',
            brand: 'bg-brand-60  border-brand-60 text-white hover:(border-neutral-80 bg-neutral-80) focus-visible:(border-neutral-80 bg-neutral-80)',
        },
        /**
         * Set the element size.
         *
         * @defaultValue base
         */
        size: {
            sm: 'h-8 px-3',
            base: 'h-10 px-4',
            lg: 'h-14 px-6',
        },
        /**
         * The mode of the button
         * - text: renders a text button
         * - icon: renders an icon button
         *
         * @defaultValue text
         *
         * @deprecated use `ButtonIcon` instead for icon buttons
         */
        mode: {
            icon: 'px-0 w-10 h-10 rounded-full',
            text: '',
        },
        dimmed: {
            true: 'cursor-not-allowed',
            false: 'cursor-pointer',
        },
        loading: {
            true: 'cursor-not-allowed',
            false: 'cursor-pointer',
        },
    },
    matches: [
        {
            mode: 'icon',
            size: 'sm',
            use: 'w-8 h-8',
        },
        {
            mode: 'icon',
            size: 'base',
            use: 'w-10 h-10',
        },
        {
            mode: 'icon',
            size: 'lg',
            use: 'w-14 h-14 px-0',
        },
        {
            variant: 'underline',
            use: 'px-0',
        },
        {
            variant: 'underline',
            mode: 'icon',
            size: 'sm',
            use: 'w-4 h-6',
        },
        {
            variant: 'underline',
            mode: 'icon',
            size: 'base',
            use: 'w-6 h-6',
        },
        {
            variant: 'underline',
            mode: 'icon',
            size: 'lg',
            use: 'w-8 h-6',
        },
        {
            variant: 'primary',
            dimmed: true,
            use: 'bg-neutral-30 border-neutral-30 text-neutral-80 hover:(bg-neutral-30 border-neutral-30) focus-visible:(bg-neutral-30 border-neutral-30)',
        },
        {
            variant: 'primary',
            dimmed: true,
            invert: true,
            use: 'bg-neutral-30 border-neutral-30 text-neutral-80 hover:(bg-neutral-30 border-neutral-30) focus-visible:(bg-neutral-30 border-neutral-30)',
        },
        {
            variant: 'secondary',
            invert: true,
            use: 'bg-transparent border-neutral-60 text-white hover:(border-white bg-transparent) focus-visible:(border-white bg-transparent)',
        },
        {
            variant: 'secondary',
            dimmed: true,
            use: 'bg-transparent text-neutral-60 border-current hover:(bg-transparent border-current) focus-visible:(bg-transparent border-current)',
        },
        {
            variant: 'secondary',
            dimmed: true,
            invert: true,
            use: 'bg-transparent text-neutral-50 border-current hover:(bg-transparent border-current) focus-visible:(bg-transparent border-current)',
        },
        {
            variant: 'ghost',
            invert: true,
            use: 'bg-neutral-0 bg-opacity-0 border-transparent text-neutral-10 hover:(border-transparent bg-opacity-20) focus-visible:(border-transparent bg-opacity-20)',
        },
        {
            variant: 'ghost',
            dimmed: true,
            invert: false,
            use: 'bg-neutral-0 bg-opacity-0 border-transparent text-neutral-60 hover:bg-transparent focus-visible:bg-transparent',
        },
        {
            variant: 'ghost',
            dimmed: true,
            invert: true,
            use: 'bg-neutral-0 bg-opacity-0 border-transparent text-neutral-50 hover:bg-transparent focus-visible:bg-transparent',
        },
        {
            color: 'brand',
            invert: true,
            use: 'bg-brand-60 border-brand-60 text-white hover:(border-neutral-80 bg-neutral-80) focus-visible:(border-neutral-80 bg-neutral-80)',
        },
        {
            color: 'brand',
            dimmed: true,
            use: 'bg-neutral-30 border-neutral-30 text-neutral-80 hover:(bg-neutral-30 border-neutral-30) focus-visible:(bg-neutral-30 border-neutral-30)',
        },
        {
            variant: 'underline',
            invert: true,
            use: 'bg-transparent border-none text-white hover:(bg-transparent border-transparent) focus-visible:(bg-transparent border-transparent)',
        },
        {
            variant: 'underline',
            dimmed: true,
            use: 'bg-transparent border-none text-neutral-50 hover:(bg-transparent border-transparent) focus-visible:(bg-transparent border-transparent)',
        },
    ],
    defaults: {
        variant: 'primary',
        size: 'base',
        color: 'default',
        round: false,
    },
});
const iconSizeMap$1 = {
    sm: 'base',
    base: '2xl',
    lg: '4xl',
};
const getIconSizeByActionSize$1 = (size) => {
    let iconSize;
    if (typeof size === 'string') {
        iconSize = iconSizeMap$1[size];
    }
    else {
        iconSize = Object.assign({});
        for (const [key, value] of Object.entries(size)) {
            iconSize[key] = iconSizeMap$1[value];
        }
    }
    return iconSize;
};
const useActionCta = ({ className, label, srOnlyLabel, variant = 'primary', invert = false, round = false, bleed = false, size = 'base', color = 'default', mode = 'text', dimmed = false, dimmedReason, icon, iconEnd, loading, }) => {
    const t = (0,esm/* useUdsTranslate */.oG)();
    const actionClassName = (0,style.tw)('group', ctaStyle({
        variant: variant,
        invert: invert,
        size: size,
        round: round,
        bleed: bleed,
        color: color,
        mode: mode,
        dimmed: dimmed,
        loading: loading,
    }), iconEnd ? 'flex-row-reverse' : 'flex-row', `after::(absolute hidden pointer-events-none -left-1 -top-1 -right-1 -bottom-1)`, `after::(border-2 ${invert ? 'border-outline-invert' : 'border-outline'} ${mode === 'icon' || round ? 'rounded-full' : 'rounded-sm'} )`, variant !== 'underline' && 'focus-visible:after::block', css_css/* css */.iv `
      &::after {
        content: '';
      }
    `, className);
    const labelSizeClass = (0,esm/* useResponsiveProp */.Uo)(size, size => {
        if (size === 'sm')
            return ['px-1.5', 'text-sm', 'tracking-wider'];
        if (size === 'base')
            return ['px-2', 'text-base'];
        if (size === 'lg')
            return ['px-3', 'text-lg'];
    });
    const labelMode = (0,esm/* useResponsiveProp */.Uo)(mode, mode => {
        return mode === 'icon' ? ['sr-only', 'px-0!'] : '';
    });
    const labelStyle = (0,style.tw)('relative font-bold uppercase', labelSizeClass, labelMode);
    const underLineLabelSize = (0,esm/* useResponsiveProp */.Uo)(size, size => {
        if (size === 'sm')
            return ['text-xs', 'tracking-wider', 'leading-4'];
        if (size === 'base')
            return ['text-sm', 'leading-5'];
        if (size === 'lg')
            return ['text-base', 'leading-6'];
    });
    const underLineLabelMode = (0,esm/* useResponsiveProp */.Uo)(mode, mode => {
        return mode === 'icon' ? ['sr-only'] : '';
    });
    const underLineLabelStyle = (0,style.tw)('relative font-bold uppercase px-0', underLineLabelSize, underLineLabelMode);
    const iconWrapperMode = (0,esm/* useResponsiveProp */.Uo)(mode, mode => {
        return mode === 'icon' ? ['mr-0', 'ml-0', 'rtl:ml-0', 'rtl:mr-0'] : '';
    });
    const iconWrapperStyle = (0,style.tw)('relative', iconWrapperMode, loading ? 'opacity-0' : 'opacity-100');
    const iconSize = variant === 'underline' ? 'base' : getIconSizeByActionSize$1(size);
    const actionChildren = [
        icon ? (react.createElement("div", { key: "icon", "data-uds-child": "icon", className: iconWrapperStyle },
            react.createElement(Icon, { name: icon, size: iconSize }))) : null,
        loading ? (react.createElement("div", { key: "loading", className: (0,style.tw)('absolute', 'text-current') },
            react.createElement(DotAnimation, { key: "loading", on: loading, size: size, compact: mode === 'icon' }))) : null,
        srOnlyLabel ? (react.createElement("span", { key: "sr-label", "data-uds-child": "sr-only-label", className: "sr-only" }, srOnlyLabel)) : null,
        react.createElement("div", { key: "label", "data-uds-child": "text-label", "aria-hidden": srOnlyLabel ? 'true' : 'false', className: variant === 'underline' ? underLineLabelStyle : labelStyle },
            react.createElement("div", { className: loading ? 'opacity-0' : 'opacity-100' }, label),
            variant === 'underline' ? (react.createElement("div", { key: "underline", className: (0,style.tw)('h-0.5 absolute -bottom-0.5 w-full z-0', !invert && 'bg-neutral-40', !dimmed &&
                    'group-hover:bg-neutral-100 group-focus-visible:bg-neutral-100', invert && 'bg-neutral-50', invert &&
                    !dimmed &&
                    'group-hover:bg-white group-focus-visible:bg-white', className) })) : null),
        loading ? (react.createElement("span", { key: "loading-sr-text", className: "sr-only" }, ` ${t('loading').toLowerCase()}`)) : null,
        dimmed && dimmedReason ? (react.createElement("span", { "data-uds-child": "dimmed-reason", key: "dimmed-reason", className: (0,style.tw)(`absolute bottom-full whitespace-nowrap flex-none mb-2 px-2 py-1 bg-neutral-100 rounded-sm text-white font-bold text-xs uppercase`, 'opacity-0 invisible group-hover:(opacity-100 visible) group-focus-visible:(opacity-100 visible)') }, dimmedReason)) : null,
    ];
    return {
        className: actionClassName,
        children: actionChildren,
        'aria-disabled': dimmed || undefined,
    };
};

/**
 * The `ButtonCta` component renders a `button` tag, and is used to
 * submit forms, or receive user input. For navigation it is recommended
 * to use the `LinkCta` component.
 *
 * @example
 * ```
 * <ButtonCta label="Shop Running" />
 * ```
 */
const ButtonCta = react.forwardRef(function ButtonCta(props, forwardedRef) {
    const { dataTestId, label, srOnlyLabel, variant, invert, size, color, mode, bleed, round, dimmed, dimmedReason, disabled, icon, iconEnd, loading, className, onClick, type = 'button', ...rest } = props;
    const actionCtaProps = useActionCta({
        className,
        label,
        srOnlyLabel,
        variant,
        invert,
        size,
        color,
        mode,
        round,
        bleed,
        dimmed: dimmed || disabled,
        dimmedReason,
        icon,
        iconEnd,
        loading,
    });
    const handleOnClick = (e) => {
        if (loading) {
            e.preventDefault();
            return;
        }
        if (onClick) {
            onClick(e);
        }
    };
    return (react.createElement("button", { ref: forwardedRef, "data-test-id": dataTestId, onClick: handleOnClick, disabled: disabled, type: type, ...actionCtaProps, ...rest }));
});
// Temporarily export both ButtonCta and Button whilst we migrate to ButtonCta
const Button = ButtonCta;

/**
 * LinkCta is a link that is styled as a rectangle call-to-action, identical to the `ButtonCta` element
 *
 * @example
 * ```
 * <LinkCta label="Shop Running" href="/running" />
 * ```
 */
const LinkCta = react.forwardRef(function LinkCta(props, forwardedRef) {
    const { label, srOnlyLabel, className, variant, invert, size, color, mode, round, bleed, dimmed, icon, iconEnd, loading, dataTestId, ...rest } = props;
    const actionCtaProps = useActionCta({
        label,
        srOnlyLabel,
        className,
        variant,
        invert,
        size,
        color,
        mode,
        round,
        bleed,
        dimmed,
        icon,
        iconEnd,
        loading,
    });
    const navigateProps = (0,esm/* useNavigate */.s0)(rest);
    return (react.createElement("a", { ref: forwardedRef, ...actionCtaProps, ...navigateProps, "data-test-id": dataTestId }));
});
// Temporarily export both LinkCta and Link whilst we migrate to LinkCta
const Link = LinkCta;

const iconStyle = (0,style/* style */.oB)({
    base: 'relative flex items-center justify-center border-1',
    variants: {
        /**
         * The visual variant of the button. Follows the same pattern as ButtonCta and LinkCta
         *
         * @defaultValue primary
         * @example
         * ```jsx
         * <ButtonIcon variant="secondary" />
         * ```
         */
        variant: {
            primary: 'text-white bg-neutral-100 border-neutral-100 group-hover:(bg-neutral-80 border-neutral-80) group-focus-visible:(bg-neutral-80 border-neutral-80)',
            secondary: 'text-neutral-100 border-neutral-40 bg-transparent group-hover:(bg-transparent border-neutral-100) group-focus-visible:(bg-transparent border-neutral-100)',
            ghost: 'bg-neutral-100 border-transparent bg-opacity-0 text-neutral-100 group-hover:(border-transparent bg-opacity-20) group-focus-visible:(border-transparent bg-opacity-20)',
        },
        /**
         * Use on dark backgrounds
         *
         * @defaultValue false
         * @example
         * ```jsx
         * <ButtonIcon invert />
         * ```
         */
        invert: {
            true: '',
            false: '',
        },
        /**
         * Position the icon on the end of the text orientation
         *
         * @defaultValue false
         *
         * @example
         *
         * ```jsx
         * <ButtonIcon iconEnd />
         * ```
         */
        iconEnd: {
            false: '',
            true: '',
        },
        /**
         * Set rounded corners
         *
         * @defaultValue false
         */
        round: {
            true: 'rounded-full',
            false: 'rounded-sm',
        },
        /**
         * Applies a transition to the icon and label
         * @defaultValue labek
         * @example
         * ```jsx
         * <ButtonIcon animate="icon" />
         * ```
         */
        animate: {
            label: '',
            icon: '',
        },
        /**
         * Float the label next to the icon, or visually hide tha label
         * @defaultValue icon
         * @example
         * ```jsx
         * <ButtonIcon mode="float" />
         * ```
         */
        mode: {
            icon: 'group-focus-visible:(transform translate-x-0) group-hover:(transform translate-x-0)',
            float: '',
        },
        dimmed: {
            true: '',
            false: '',
        },
        /**
         * Responsive size of the button
         * @defaultValue base
         * @example
         * ```jsx
         * <ButtonIcon size="sm" />
         * ```
         */
        size: {
            xs: 'w-6 h-6',
            sm: 'w-8 h-8',
            base: 'w-10 h-10',
            lg: 'w-14 h-14',
        },
    },
    matches: [
        {
            dimmed: true,
            invert: false,
            use: 'text-neutral-60',
        },
        {
            dimmed: true,
            invert: true,
            use: 'text-neutral-50',
        },
        {
            variant: 'primary',
            invert: true,
            use: 'bg-white border-white text-neutral-100 group-hover:(bg-neutral-20 border-neutral-20) group-focus-visible:(bg-neutral-20 border-neutral-20)',
        },
        {
            variant: 'primary',
            dimmed: true,
            use: 'bg-neutral-30 border-neutral-30 text-neutral-80 group-hover:(bg-neutral-30 border-neutral-30) group-focus-visible:(bg-neutral-30 border-neutral-30)',
        },
        {
            variant: 'primary',
            dimmed: true,
            invert: true,
            use: 'bg-neutral-30 border-neutral-30 text-neutral-80 group-hover:(bg-neutral-30 border-neutral-30) group-focus-visible:(bg-neutral-30 border-neutral-30)',
        },
        {
            variant: 'secondary',
            invert: true,
            use: 'bg-transparent border-neutral-60 text-white group-hover:(border-white bg-transparent) group-focus-visible:(border-white bg-transparent)',
        },
        {
            variant: 'secondary',
            dimmed: true,
            use: 'bg-transparent text-neutral-60 border-current group-hover:(bg-transparent border-current) group-focus-visible:(bg-transparent border-current)',
        },
        {
            variant: 'secondary',
            dimmed: true,
            invert: true,
            use: 'bg-transparent text-neutral-50 border-current group-hover:(bg-transparent border-current) group-focus-visible:(bg-transparent border-current)',
        },
        {
            variant: 'ghost',
            invert: true,
            use: 'bg-neutral-0 bg-opacity-0 border-transparent text-neutral-10 group-hover:(border-transparent bg-opacity-20) group-focus-visible:(border-transparent bg-opacity-20)',
        },
        {
            variant: 'ghost',
            dimmed: true,
            use: 'bg-neutral-0 bg-opacity-0 border-transparent text-neutral-60 group-hover:bg-transparent group-focus-visible:bg-transparent',
        },
        {
            variant: 'ghost',
            dimmed: true,
            invert: true,
            use: 'bg-neutral-0 bg-opacity-0 border-transparent text-neutral-50 group-hover:bg-transparent group-focus-visible:bg-transparent',
        },
        {
            iconEnd: true,
            animate: 'icon',
            dimmed: false,
            mode: 'float',
            use: 'group-focus-visible:(transform translate-x-1) group-hover:(transform translate-x-1) group-focus-visible:rtl:(transform -translate-x-1) group-hover:rtl:(transform -translate-x-1)',
        },
        {
            iconEnd: false,
            animate: 'icon',
            mode: 'float',
            dimmed: false,
            use: 'group-focus-visible:(transform -translate-x-1) group-hover:(transform -translate-x-1) group-focus-visible:rtl:(transform translate-x-1) group-hover:rtl:(transform translate-x-1)',
        },
    ],
    defaults: {
        variant: 'primary',
        iconEnd: 'false',
        animate: 'label',
        size: 'base',
        round: true,
    },
});
const labelStyle$1 = (0,style/* style */.oB)({
    base: '',
    variants: {
        size: {
            xs: 'text-sm mt-px',
            sm: 'text-base mt-px',
            base: 'text-base mt-0.5',
            lg: 'text-lg mt-1.5',
        },
        iconEnd: {
            false: '',
            true: '',
        },
        animate: {
            icon: 'group-focus-visible:(transform translate-x-0) group-hover:(transform translate-x-0)',
            label: '',
        },
        dimmed: {
            true: '',
            false: '',
        },
        invert: {
            true: '',
            false: '',
        },
        mode: {
            icon: 'sr-only',
            float: '',
        },
    },
    matches: [
        {
            dimmed: true,
            invert: false,
            use: 'text-neutral-60',
        },
        {
            dimmed: true,
            invert: true,
            use: 'text-neutral-50',
        },
        {
            iconEnd: true,
            animate: 'label',
            dimmed: false,
            mode: 'float',
            use: 'group-focus-visible:(transform -translate-x-1) group-hover:(transform -translate-x-1) group-focus-visible:rtl:(transform translate-x-1) group-hover:rtl:(transform translate-x-1)',
        },
        {
            iconEnd: false,
            animate: 'label',
            dimmed: false,
            mode: 'float',
            use: 'group-focus-visible:(transform translate-x-1) group-hover:(transform translate-x-1) group-focus-visible:rtl:(transform -translate-x-1) group-hover:rtl:(transform -translate-x-1)',
        },
    ],
    defaults: {
        size: 'base',
        iconEnd: 'false',
        animate: 'label',
    },
});
const groupStyle = (0,style/* style */.oB)({
    base: 'relative flex items-center focus-visible:(ring-0 outline-none)',
    variants: {
        invert: {
            true: 'text-neutral-0',
            false: 'text-neutral-100',
        },
        iconEnd: {
            false: 'flex-row',
            true: 'flex-row-reverse',
        },
        animate: {
            label: '',
            icon: '',
        },
        mode: {
            icon: '',
            float: '',
        },
        dimmed: {
            true: 'cursor-not-allowed',
            false: 'cursor-pointer',
        },
        size: {
            xs: 'gap-1.5',
            sm: 'gap-2',
            base: 'gap-2',
            lg: 'gap-2.5',
        },
    },
    matches: [{ mode: 'icon', use: 'gap-none' }],
    defaults: {
        iconEnd: 'false',
        animate: 'label',
        size: 'base',
    },
});
const iconSizeMap = {
    xs: 'base',
    sm: 'base',
    base: '2xl',
    lg: '4xl',
};
const getIconSizeByActionSize = (size) => {
    let iconSize;
    if (typeof size === 'string') {
        iconSize = iconSizeMap[size];
    }
    else {
        iconSize = Object.assign({});
        for (const [key, value] of Object.entries(size)) {
            iconSize[key] = iconSizeMap[value];
        }
    }
    return iconSize;
};
const useActionIcon = (props) => {
    const { className, label, variant = 'primary', invert = false, size = 'base', mode = 'icon', iconEnd = false, animate = 'label', round = true, dimmed = false, dimmedReason, icon, } = props;
    const buttonClassName = (0,style.tw)('group', groupStyle({ size, invert, mode, iconEnd, animate, dimmed }), className);
    const buttonChildren = [
        react.createElement("div", { key: "icon", "data-uds-child": "action-icon-icon", className: (0,style.tw)(iconStyle({
                variant,
                invert,
                size,
                mode,
                iconEnd,
                animate,
                round,
                dimmed,
            }), 'flex-none transition ease-out-expo duration-300', `after::(absolute hidden pointer-events-none -left-1 -top-1 -right-1 -bottom-1)`, `after::(border-2 ${invert ? 'border-outline-invert' : 'border-outline'} ${round ? 'rounded-full' : 'rounded-sm'} )`, 'group-focus-visible:after::block', css_css/* css */.iv `
          &::after {
            content: '';
          }
        `) },
            react.createElement(Icon, { name: icon, size: getIconSizeByActionSize(size) })),
        react.createElement("span", { key: "label", "data-uds-child": "action-icon-label", className: (0,style.tw)('font-bold leading-[1.15]', 'transition ease-out-expo duration-300', labelStyle$1({ size, mode, iconEnd, animate, dimmed, invert })) }, label),
        dimmed && dimmedReason ? (react.createElement("span", { "data-uds-child": "dimmed-reason", key: "dimmed-reason", className: (0,style.tw)(`absolute left-1/2 transform -translate-x-1/2 bottom-full whitespace-nowrap flex-none mb-2 px-2 py-1 bg-neutral-100 rounded-sm text-white font-bold text-xs uppercase`, 'opacity-0 invisible group-hover:(opacity-100 visible) group-focus-visible:(opacity-100 visible)') }, dimmedReason)) : null,
    ];
    return {
        className: buttonClassName,
        children: buttonChildren,
        'aria-disabled': dimmed || undefined,
    };
};

/**
 * The `ButtonIcon` component renders a rounded icon button, withan optional floating label model.
 *
 * The API is similar to the `Button` component, and will eventually replace the `<Button mode="icon"/>`
 *
 * Use this compoenent to submit forms, or receive user input. For navigation it is recommended
 * to use the `LinkIcon` component.
 *
 * @example
 * ```jsx
 * <ButtonIcon label="Shop Running" mode="float" icon="puma-logo" />
 * ```
 */
const ButtonIcon = react.forwardRef(function ButtonIcon(props, forwardedRef) {
    const { dataTestId, label, variant, invert, size, disabled, icon, mode, dimmed, dimmedReason, iconEnd, round, animate, className, type = 'button', ...rest } = props;
    const { children, ...ctaProps } = useActionIcon({
        className,
        label,
        variant,
        invert,
        size,
        mode,
        dimmed,
        dimmedReason,
        icon,
        iconEnd,
        round,
        animate,
    });
    return (react.createElement(react.Fragment, null,
        react.createElement("button", { ref: forwardedRef, "data-test-id": dataTestId, disabled: disabled, type: type, "data-uds-child": "button-icon", ...ctaProps, ...rest }, children)));
});

/**
 * The `LinkIcon` component renders a rounded icon anchor element, withan optional floating label model.
 *
 * The API is similar to the `Link` component, and will eventually replace the `<Link mode="icon"/>`
 *
 *
 * @example
 * ```jsx
 * <LinkIcon label="Shop Running" mode="float" icon="puma-logo" />
 * ```
 */
const LinkIcon = react.forwardRef(function LinkIcon(props, forwardedRef) {
    const { label, className, variant, invert, size, mode, dimmed, dimmedReason, icon, iconEnd, round, animate, dataTestId, ...rest } = props;
    const actionIconProps = useActionIcon({
        label,
        className,
        variant,
        invert,
        size,
        mode,
        dimmed,
        dimmedReason,
        icon,
        iconEnd,
        round,
        animate,
    });
    const navigateProps = (0,esm/* useNavigate */.s0)(rest);
    return (react.createElement("a", { ref: forwardedRef, ...actionIconProps, ...navigateProps, "data-uds-child": "link-icon", "data-test-id": dataTestId }));
});

const LinkInvBlock = ({ className, children, dataTestId, ...rest }) => {
    const navigateProps = (0,esm/* useNavigate */.s0)(rest);
    return (react.createElement("a", { className: (0,twind.tw)('absolute inset-0 z-1', className), ...navigateProps, "data-test-id": dataTestId, "data-uds-child": "link-inv-block" },
        react.createElement("span", { className: "sr-only" }, children)));
};

const ButtonInvBlock = ({ className, dataTestId, focusable = true, children, ...rest }) => {
    return (React.createElement("button", { ...rest, className: tw$2('absolute inset-0 z-1', className), "data-uds-child": "button-inv-block", "data-test-id": dataTestId, tabIndex: focusable ? 0 : -1, "aria-hidden": focusable ? 'false' : 'true' },
        React.createElement("span", { className: "sr-only" }, children)));
};

const SYMBOL_KEY = '__wrap_b';
const SYMBOL_OBSERVER_KEY = '__wrap_o';
const IS_SERVER = typeof window === 'undefined';
const esm_useIsomorphicLayoutEffect = IS_SERVER
    ? react.useEffect
    : react.useLayoutEffect;
const relayout = (id, ratio, wrapper) => {
    wrapper =
        wrapper || document.querySelector(`[data-br="${id}"]`);
    const container = wrapper.parentElement;
    const update = (width) => (wrapper.style.maxWidth = width + 'px');
    // Reset wrapper width
    wrapper.style.maxWidth = '';
    // Get the initial container size
    const width = container.clientWidth;
    const height = container.clientHeight;
    // Synchronously do binary search and calculate the layout
    let lower = width / 2 - 0.25;
    let upper = width + 0.5;
    let middle;
    if (width) {
        while (lower + 1 < upper) {
            middle = Math.round((lower + upper) / 2);
            update(middle);
            if (container.clientHeight === height) {
                upper = middle;
            }
            else {
                lower = middle;
            }
        }
        // Update the wrapper width
        update(upper * ratio + width * (1 - ratio));
    }
    // Create a new observer if we don't have one.
    // Note that we must inline the key here as we use `toString()` to serialize
    // the function.
    if (!wrapper['__wrap_o']) {
        (wrapper['__wrap_o'] = new ResizeObserver(() => {
            window.requestAnimationFrame(() => {
                self.__wrap_b(0, +wrapper.dataset.brr, wrapper);
            });
        })).observe(container);
    }
};
const RELAYOUT_STR = relayout.toString();
const createScriptElement = (injected, suffix = '') => (react.createElement("script", { suppressHydrationWarning: true, dangerouslySetInnerHTML: {
        // Calculate the balance initially for SSR
        __html: (injected ? '' : `self.${SYMBOL_KEY}=${RELAYOUT_STR};`) + suffix,
    } }));
/**
 * An optional provider to inject the global relayout function, so all children
 * Balancer components can share it.
 */
const BalancerContext = react.createContext(false);
const BalancerProvider = ({ children }) => {
    return (React.createElement(BalancerContext.Provider, { value: true },
        createScriptElement(false),
        children));
};
const Balancer = ({ ratio = 1, children, ...props }) => {
    const id = reach_auto_id_useId();
    const wrapperRef = react.useRef();
    const hasProvider = react.useContext(BalancerContext);
    // Re-balance on content change and on mount/hydration.
    esm_useIsomorphicLayoutEffect(() => {
        if (wrapperRef.current) {
            // Re-assign the function here as the component can be dynamically rendered, and script tag won't work in that case.
            (self[SYMBOL_KEY] = relayout)(0, ratio, wrapperRef.current);
        }
    }, [children, ratio]);
    // Remove the observer when unmounting.
    esm_useIsomorphicLayoutEffect(() => {
        return () => {
            if (!wrapperRef.current)
                return;
            const resizeObserver = wrapperRef.current[SYMBOL_OBSERVER_KEY];
            if (!resizeObserver)
                return;
            resizeObserver.disconnect();
            delete wrapperRef.current[SYMBOL_OBSERVER_KEY];
        };
    }, []);
    return (react.createElement(react.Fragment, null,
        react.createElement($5e63c961fc1ce211$export$8c6ed5c666ac1360, { ...props, "data-br": id, "data-brr": ratio, ref: wrapperRef, style: {
                display: 'inline-block',
                verticalAlign: 'top',
                textDecoration: 'inherit',
            }, suppressHydrationWarning: true }, children),
        createScriptElement(hasProvider, `self.${SYMBOL_KEY}("${id}",${ratio})`)));
};
// As Next.js adds `display: none` to `body` for development, we need to trigger
// a re-balance right after the style is removed, synchronously.
if (!IS_SERVER && "production" !== 'production') {}

const TEXT_SIZES = {
    inherit: 'text-inherit',
    xxs: 'text-xxs',
    xs: 'text-xs',
    sm: 'text-sm',
    base: 'text-base',
    lg: 'text-lg',
    xl: 'text-xl',
    '2xl': 'text-2xl',
};
const useTextStyle = ({ size }) => {
    return (0,esm/* useResponsiveProp */.Uo)(size, size => TEXT_SIZES[size]);
};
/**
 * Text only identifies a text size hierarchy, used for running text, and
 * other text styles.
 *
 * - By default renders a span. To render as a custom element, use the `asChild` prop
 *
 * @example
 * ```
 * <Text asChild>
 *   <p>New Collection</p>
 * </Text>
 * ```
 */
const Text = react.forwardRef(function Text(props, forwardedRef) {
    const { asChild, dataTestId, balance = false, size, prose, weight, condensed = false, srOnly, transform, className, children, color, invert, ...rest } = props;
    const Comp = balance
        ? Balancer
        : typeof children !== 'string' && asChild
            ? $5e63c961fc1ce211$export$8c6ed5c666ac1360
            : 'span';
    const sizeClassName = useTextStyle({ size });
    return (react.createElement(Comp, { ref: forwardedRef, className: (0,style.tw)(sizeClassName, prose && 'max-w-[65ch]', fontStyle({
            condensed,
            weight,
            transform,
            srOnly,
        }), colorStyle({
            color,
            invert,
        }), className), "data-test-id": dataTestId, "data-uds-child": "text", ...rest }, asChild ? children : balance ? react.createElement("span", null, children) : children));
});

const HEADING_SIZES = {
    xxxs: 'heading-xxxs',
    xxs: 'heading-xxs',
    xs: 'heading-xs',
    sm: 'heading-sm',
    base: 'heading-base',
    lg: 'heading-lg',
    xl: 'heading-xl',
    '2xl': 'heading-2xl',
    '3xl': 'heading-3xl',
    '4xl': 'heading-4xl',
    '5xl': 'heading-5xl',
    '6xl': 'heading-6xl',
};
/**
 * Heading is implements text size hierarchy, used for large and display text.
 *
 * - By default renders a span. To render as a custom element, use the `asChild` prop.
 *
 * @example
 * ```
 * <Heading
 *   color="success"
 *   size="xl"
 *   asChild
 * >
 *   <h2>New Collection</h2>
 * </Heading>
 * ```
 */
const Heading = react.forwardRef(function Heading(props, forwardedRef) {
    const { asChild, dataTestId, balance, size = 'base', weight = 700, condensed = false, transform, srOnly, className, children, color, invert, ...rest } = props;
    const Comp = balance
        ? Balancer
        : typeof children !== 'string' && asChild
            ? $5e63c961fc1ce211$export$8c6ed5c666ac1360
            : 'span';
    const sizeClassName = (0,esm/* useResponsiveProp */.Uo)(size, size => HEADING_SIZES[size]);
    return (react.createElement(Comp, { ref: forwardedRef, className: (0,style.tw)(sizeClassName, fontStyle({
            condensed,
            weight,
            transform,
            srOnly,
        }), colorStyle({
            color,
            invert,
        }), className), "data-test-id": dataTestId, "data-uds-child": "heading", ...rest }, asChild ? children : balance ? react.createElement("span", null, children) : children));
});

const DISPLAY_SIZE_CONFIG = {
    1: style/* css */.iv `
    --min: 48;
    --max: 96;
    --lh: 1;
    --ls: -0.02;

    @screen lg {
      --lh: 0.9;
    }
  `,
    2: style/* css */.iv `
    --min: 40;
    --max: 72;
    --lh: 1.1;
    --ls: -0.02;

    @screen md {
      --lh: 1;
    }
  `,
    3: style/* css */.iv `
    --min: 32;
    --max: 60;
    --lh: 1.13;
    --ls: -0.01;

    @screen md {
      --lh: 1;
    }
  `,
    4: style/* css */.iv `
    --min: 28;
    --max: 48;
    --lh: 1.14;
    --ls: -0.01;

    @screen md {
      --lh: 1;
    }
  `,
    5: style/* css */.iv `
    --min: 24;
    --max: 40;
    --lh: 1.17;
    --ls: 0;

    @screen md {
      --lh: 1.1;
    }
  `,
    6: style/* css */.iv `
    --min: 20;
    --max: 32;
    --lh: 1.2;
    --ls: 0;

    @screen md {
      --lh: 1.13;
    }
  `,
    7: style/* css */.iv `
    --min: 18;
    --max: 28;
    --lh: 1.3;
    --ls: 0;

    @screen md {
      --lh: 1.14;
    }
  `,
    8: style/* css */.iv `
    --min: 16;
    --max: 24;
    --lh: 1.5;
    --ls: 0;

    @screen md {
      --lh: 1.17;
    }
  `,
};
const DISPLAY_CALC = style/* css */.iv `
  --bp-min: 480;
  --bp-max: 1600;

  --preferred-scale: calc(
    (100 * (var(--max) - var(--min))) / (var(--bp-max) - var(--bp-min))
  );

  --preferred-base: calc(
    ((var(--bp-min) * var(--max)) - (var(--bp-max) * var(--min))) /
      (var(--bp-min) - var(--bp-max))
  );

  font-size: clamp(
    calc(var(--min) * 1px),
    calc((var(--preferred-scale) * 1vw) + (var(--preferred-base) * 1px)),
    calc(var(--max) * 1px)
  );

  line-height: calc(var(--lh) * 1em);
`;
// only apply letter spacing to condensed variant
const DISPLAY_LS = style/* css */.iv `
  letter-spacing: calc(var(--ls) * 1em);
`;
/**
 * Display
 *
 * - By default renders a span. To render as a custom element, use the `asChild` prop
 *
 * @example
 * ```
 * <Display level="1" asChild>
 *   <p>New Collection</p>
 * </Display>
 * ```
 */
const Display = react.forwardRef(function Display(props, forwardedRef) {
    const { asChild, dataTestId, balance = false, level = 3, condensed = false, weight = 'bold', transform = 'uppercase', srOnly, className, children, color, invert, ...rest } = props;
    const Comp = balance
        ? Balancer
        : typeof children !== 'string' && asChild
            ? $5e63c961fc1ce211$export$8c6ed5c666ac1360
            : 'span';
    return (react.createElement(Comp, { ref: forwardedRef, className: (0,style.tw)(DISPLAY_CALC, condensed ? DISPLAY_LS : '', DISPLAY_SIZE_CONFIG[level], fontStyle({
            weight,
            condensed,
            transform,
            srOnly,
        }), colorStyle({
            color,
            invert,
        }), className), "data-test-id": dataTestId, "data-uds-child": "display", ...rest }, asChild ? children : balance ? react.createElement("span", null, children) : children));
});

const actionTextStyle = (0,style/* style */.oB)({
    base: 'group relative inline flex-none rounded-sm appearance-none text-left focus-visible:outline-2',
    variants: {
        color: {
            current: '',
            base: '',
            muted: '',
            brand: '',
            success: '',
            info: '',
            error: '',
            warning: '',
        },
        invert: {
            true: 'hover:(bg-neutral-0 bg-opacity-[0.15])',
            false: 'hover:(bg-neutral-100 bg-opacity-10) ',
        },
    },
    matches: [
        {
            color: 'muted',
            invert: true,
            use: 'hover:(text-neutral-0)',
        },
        {
            color: 'muted',
            invert: false,
            use: 'hover:(text-neutral-100)',
        },
    ],
});
const useActionText = (props) => {
    const { label, srOnlyLabel, color, invert = false, size, condensed, transform, weight, className, external, } = props;
    const buttonChildren = [
        srOnlyLabel ? (react.createElement("span", { key: "sr-label", "data-uds-child": "sr-only-label", className: "sr-only" }, srOnlyLabel)) : null,
        react.createElement("span", { key: "label", "data-uds-child": "text-label", className: "font-inherit decoration-underline decoration-1 underline-offset-[0.18em]", "aria-hidden": srOnlyLabel ? 'true' : 'false' }, label),
        external ? (react.createElement(Icon, { size: "inherit", className: "mx-1 inline align-bottom mb-0.5", name: "external-link" })) : null,
    ];
    const textStyle = useTextStyle({ size });
    return {
        children: buttonChildren,
        className: (0,twind.tw)(colorStyle({ color, invert }), fontStyle({ condensed, transform, weight }), actionTextStyle({ color, invert }), textStyle, className),
    };
};

const ButtonText = react.forwardRef(function ButtonText(props, forwardedRef) {
    const { dataTestId, label, srOnlyLabel, invert, size, color, transform, weight, condensed, external, disabled, className, onClick, type = 'button', ...rest } = props;
    const { children, ...ctaProps } = useActionText({
        className,
        label,
        srOnlyLabel,
        invert,
        size,
        color,
        transform,
        weight,
        condensed,
        external,
    });
    const handleOnClick = (e) => {
        if (onClick) {
            onClick(e);
        }
    };
    return (react.createElement(react.Fragment, null,
        react.createElement("button", { ref: forwardedRef, "data-test-id": dataTestId, onClick: handleOnClick, disabled: disabled, type: type, ...ctaProps, ...rest }, children)));
});

/**
 * LinkText is a link that is styled as a rectangle call-to-action, identical to the `ButtonText` element
 *
 * @example
 * ```
 * <LinkText label="Shop Running" href="/running" />
 * ```
 */
const LinkText = react.forwardRef(function LinkText(props, forwardedRef) {
    const { label, srOnlyLabel, className, invert, size, color, transform, weight, condensed, external, dataTestId, ...rest } = props;
    const actionTextProps = useActionText({
        label,
        srOnlyLabel,
        className,
        invert,
        size,
        color,
        transform,
        weight,
        condensed,
        external,
    });
    const navigateProps = (0,esm/* useNavigate */.s0)(rest);
    return (react.createElement("a", { ref: forwardedRef, ...actionTextProps, ...navigateProps, "data-test-id": dataTestId }));
});

const labelStyle = css_css/* css */.iv `
  &::before {
    content: '';
    transition: transform 350ms cubic-bezier(0.76, 0, 0.24, 1) 150ms;
    @apply absolute left-0 bottom-0 right-0 h-[2px] bg-current transform scale-x-0 origin-left pointer-none;
  }

  :hover > &::before {
    @apply scale-x-100;
  }

  &::after {
    content: '';
    transition: transform 350ms cubic-bezier(0.76, 0, 0.24, 1);
    @apply absolute left-0 bottom-0 right-0 h-[2px] bg-current transform scale-x-100 origin-right pointer-none;
  }

  :hover > &::after {
    @apply scale-x-0;
  }
`;
const actionUnderlineStyle = (0,style/* style */.oB)({
    base: 'group relative flex whitespace-nowrap gap-2 items-center max-w-max rounded-sm text-left focus-visible:outline-2',
    variants: {
        size: {
            inherit: '',
            sm: 'text-sm',
            base: 'text-base',
            lg: 'text-lg',
        },
        invert: {
            true: '',
            false: '',
        },
    },
});
const useActionUnderline = (props) => {
    const { icon, iconEnd, label, srOnlyLabel, invert, size, transform, className, } = props;
    const buttonChildren = [
        icon ? (react.createElement(Icon, { key: "icon", size: "inherit", className: "flex-shrink-0 inline align-bottom", name: icon })) : null,
        srOnlyLabel ? (react.createElement("span", { key: "sr-label", "data-uds-child": "sr-only-label", className: "sr-only" }, srOnlyLabel)) : null,
        react.createElement("span", { key: "label", "data-uds-child": "text-label", className: (0,twind.tw)('relative overflow-hidden truncate font-bold min-w-0 flex-1', labelStyle), "aria-hidden": srOnlyLabel ? 'true' : 'false' }, label),
    ];
    return {
        children: buttonChildren,
        className: (0,twind.tw)(iconEnd ? 'flex-row-reverse' : 'flex-row', colorStyle({ color: 'base', invert }), fontStyle({ transform }), actionUnderlineStyle({ size, invert }), className),
    };
};

const ButtonUnderline = react.forwardRef(function ButtonUnderline(props, forwardedRef) {
    const { dataTestId, label, srOnlyLabel, invert, size, transform, disabled, icon, iconEnd, className, onClick, type = 'button', ...rest } = props;
    const { children, ...ctaProps } = useActionUnderline({
        className,
        label,
        srOnlyLabel,
        invert,
        size,
        transform,
        icon,
        iconEnd,
    });
    const handleOnClick = (e) => {
        if (onClick) {
            onClick(e);
        }
    };
    return (react.createElement(react.Fragment, null,
        react.createElement("button", { ref: forwardedRef, "data-test-id": dataTestId, onClick: handleOnClick, disabled: disabled, type: type, ...ctaProps, ...rest }, children)));
});

/**
 * LinkUnderline is a link that is styled as an underlined call-to-action
 *
 * @example
 * ```
 * <LinkUnderline label="Shop Running" href="/running" />
 * ```
 */
const LinkUnderline = react.forwardRef(function LinkUnderline(props, forwardedRef) {
    const { label, srOnlyLabel, className, invert, size, transform, icon, iconEnd, dataTestId, ...rest } = props;
    const linkCtaProps = useActionUnderline({
        label,
        srOnlyLabel,
        className,
        invert,
        size,
        transform,
        icon,
        iconEnd,
    });
    const navigateProps = (0,esm/* useNavigate */.s0)(rest);
    return (react.createElement("a", { ref: forwardedRef, ...linkCtaProps, ...navigateProps, "data-test-id": dataTestId }));
});

/**
 * A plain text link, that inherits font-size and color from the parent context
 */
const Anchor = react.forwardRef(function Anchor(props, forwardedRef) {
    const { className, dataTestId, ...rest } = props;
    const navigateProps = (0,esm/* useNavigate */.s0)(rest);
    return (react.createElement("a", { ref: forwardedRef, className: (0,style.tw)('font-bold text-inherit cursor-pointer focus:(ring-0 text-inherit)', 'hover:(bg-gradient-to-b) from-current to-current bg-no-repeat', style/* css */.iv `
            background-size: 100% 2px;
            background-position: 100% 100%;
          `, className), ...navigateProps, "data-test-id": dataTestId }));
});

const liItemBase = 'text-neutral-100 whitespace-nowrap flex items-center h-5 leading-5';
const liItemCurrent = 'flex-1 truncate font-normal leading-none px-2';
const Breadcrumb = ({ path, dataTestId, ...args }) => {
    const ulStyle = 'capitalize flex items-center font-medium w-full';
    const itemSmScreenHidden = 'mobile:hidden tablet:hidden';
    const listItems = path.map((step, index) => {
        const isLastItem = index === path.length - 1;
        const shouldHideOnSmall = index < path.length - 2 || isLastItem;
        const isLastLink = index === path.length - 2;
        if (isLastItem) {
            return (react.createElement(BreadcrumbListItem, { key: step.label, label: step.label, className: (0,twind.tw)(itemSmScreenHidden) }));
        }
        else {
            return (react.createElement(BreadcrumbLinkListItem, { key: step.label, step: step, hasBackArrow: isLastLink, className: (0,twind.tw)(shouldHideOnSmall && itemSmScreenHidden) }));
        }
    });
    return (react.createElement("nav", { "data-test-id": dataTestId ?? 'breadcrumb-nav', "data-uds-child": "breadcrumb", "aria-label": "Breadcrumb", className: "flex flex-row items-center ", ...args },
        react.createElement("ul", { className: ulStyle, "data-uds-child": "breadcrumb-list" }, listItems)));
};
//breadcrumb item components
const BreadcrumbListItem = ({ label, className, }) => (react.createElement("li", { "data-uds-child": "breadcrumb-list-item", className: (0,twind.tw)(liItemBase, liItemCurrent, className) }, label));
const BreadcrumbLinkListItem = ({ step, hasBackArrow, className, }) => {
    const liItemAnchor = 'group flex items-center font-bold border-1 border-white rounded-sm px-2 focus-visible:(border-neutral-100 ring) hover:text-neutral-80';
    const listItemSeparator = (0,twind.tw)('after::(hidden flex-none bg-neutral-50 w-1 h-1 transform translate-y-0.5 rounded-full mx-2) lg:after::(block)', css_css/* css */.iv `
      &::after {
        content: '';
      }
    `);
    const navigateProps = (0,esm/* useNavigate */.s0)({ href: step.url });
    return (react.createElement("li", { className: (0,twind.tw)(liItemBase, className, listItemSeparator), "data-uds-child": "breadcrumb-list-item" },
        react.createElement("a", { className: liItemAnchor, ...navigateProps, "data-uds-child": "breadcrumb-link" },
            hasBackArrow ? (react.createElement("div", { className: "block lg:hidden flex-none mt-0.5 mr-1 rtl:(mr-0 ml-0.5) transition-transform ease-out group-hover:(transform -translate-x-1 rtl:translate-x-1) group-focus-visible:(transform -translate-x-1 rtl:translate-x-1)" },
                react.createElement(Icon, { size: "sm", name: "chevron-left" }))) : null,
            step.label)));
};

const SidenavContext = (0,react.createContext)({});
/**
 * The `Sidenav` component is used to render a secondary navigation on the side of the main page.
 *
 * @example
 * ```
 * <Sidenav>
 *   <SidenavLink label="Overview" icon="info" href="/my-account" />
 *   <SidenavLink label="Account Settings" icon="filter" href="/my-account/settings" />
 * </Sidenav>
 * ```
 */
const Sidenav = ({ gap = true, dataTestId, className, children, asChild, ...rest }) => {
    const Comp = asChild ? $5e63c961fc1ce211$export$8c6ed5c666ac1360 : 'nav';
    return (react.createElement(SidenavContext.Provider, { value: { dataTestId } },
        react.createElement(Comp, { ...rest, "data-test-id": dataTestId, "data-uds-child": "sidebav", className: (0,style.tw)('flex flex-col', gap && 'gap-2', className) }, children)));
};
const linkStyle = (0,style/* style */.oB)({
    variants: {
        /**
         * Render a chevron at the end of the link
         */
        chevronEnd: {
            true: 'display-block',
            false: 'hidden',
        },
    },
});
/**
 * The `SidenavLink` component usually within the Sidenav component, but can be used independently
 *
 * @example
 * ```
 * <Sidenav>
 *   <SidenavLink label="Overview" icon="info" href="/my-account" />
 *   <SidenavLink label="Account Settings" icon="filter" href="/my-account/settings" />
 * </Sidenav>
 * ```
 *
 *  * @example
 * ```
 * <Stack asChild>
 *   <nav
 *     <SidenavLink label="Overview" icon="info" href="/my-account" />
 *     <SidenavLink label="Account Settings" icon="filter" href="/my-account/settings" />
 *   </nav>
 * </SideStacknav>
 * ```
 */
const SidenavLink = (props) => {
    const { dataTestId, selected, className, label, icon, chevronEnd = false, ...rest } = props;
    const navigateProps = (0,esm/* useNavigate */.s0)(rest);
    const { dataTestId: contextDataTestId } = react.useContext(SidenavContext);
    const appliedDataTestId = dataTestId || contextDataTestId;
    return (react.createElement("a", { ...navigateProps, "data-test-id": `${appliedDataTestId}-link-${rest.href}`, className: (0,style.tw)('relative py-4 pl-5 pr-4', 'flex justify-between gap-4', 'border-l-2 rtl:(border-r-2 border-l-0))', selected
            ? 'border-neutral-100 bg-neutral-0'
            : 'border-transparent bg-transparent ', 'z-1 hover:(bg-neutral-20 z-[2]) focus:(bg-neutral-20 z-[2])', className) },
        react.createElement("div", { className: "flex gap-4" },
            icon ? (react.createElement(Icon, { size: "3xl", name: icon, dataTestId: `${appliedDataTestId}-link-icon`, className: "flex-shrink-0 -ml-px rtl:(ml-auto -mr-px)" })) : null,
            react.createElement(Text, { size: "base", weight: "bold", className: "py-0.5" }, label)),
        react.createElement(Icon, { size: "3xl", name: "chevron-right", dataTestId: `${appliedDataTestId}-link-chevron`, className: (0,style.tw)(linkStyle({ chevronEnd })) })));
};

const UDS_GAP = {
    min: '[0.8vmax]',
    max: '[3.2vmax]',
    auto: '[1.6vmax]',
    none: '0',
    px: 'px',
    xxs: '1',
    xs: '2',
    sm: '4',
    base: '6',
    lg: '8',
    xl: '12',
    '2xl': '16',
    '3xl': '20',
    '4xl': '28',
    '5xl': '36',
};
const UDS_GAP_VALUES = {
    min: '1vmax',
    auto: '3.2vmax',
    max: '4.8vmax',
    none: '0px',
    px: '1px',
    xs: '0.5rem',
    sm: '1rem',
    base: '1.5rem',
    lg: '2rem',
    xl: '3.5rem',
    '2xl': '4rem',
    '3xl': '5rem',
    '4xl': '7rem',
    '5xl': '9rem',
};
const gapStyle = (0,style/* style */.oB)({
    variants: {
        /**
         * Gap, applies both horizontally and vertically. Alternatively use `gapX` and `gapY` to configure each space separately.
         */
        gap: {
            min: `gap-${UDS_GAP.min}`,
            auto: `gap-${UDS_GAP.auto}`,
            max: `gap-${UDS_GAP.max}`,
            none: `gap-${UDS_GAP.none}`,
            px: `gap-${UDS_GAP.px}`,
            xxs: `gap-${UDS_GAP.xxs}`,
            xs: `gap-${UDS_GAP.xs}`,
            sm: `gap-${UDS_GAP.sm}`,
            base: `gap-${UDS_GAP.base}`,
            lg: `gap-${UDS_GAP.lg}`,
            xl: `gap-${UDS_GAP.xl}`,
            '2xl': `gap-${UDS_GAP['2xl']}`,
            '3xl': `gap-${UDS_GAP['3xl']}`,
            '4xl': `gap-${UDS_GAP['4xl']}`,
            '5xl': `gap-${UDS_GAP['5xl']}`,
        },
        /**
         * Gap X, applies only horizontally. Alternatively use `gap` to configure gaps on both axis combined
         */
        gapX: {
            min: `gap-x-${UDS_GAP.min}`,
            auto: `gap-x-${UDS_GAP.auto}`,
            max: `gap-x-${UDS_GAP.max}`,
            none: `gap-x-${UDS_GAP.none}`,
            px: `gap-x-${UDS_GAP.px}`,
            xxs: `gap-x-${UDS_GAP.xxs}`,
            xs: `gap-x-${UDS_GAP.xs}`,
            sm: `gap-x-${UDS_GAP.sm}`,
            base: `gap-x-${UDS_GAP.base}`,
            lg: `gap-x-${UDS_GAP.lg}`,
            xl: `gap-x-${UDS_GAP.xl}`,
            '2xl': `gap-x-${UDS_GAP['2xl']}`,
            '3xl': `gap-x-${UDS_GAP['3xl']}`,
            '4xl': `gap-x-${UDS_GAP['4xl']}`,
            '5xl': `gap-x-${UDS_GAP['5xl']}`,
        },
        /**
         * Gap Y, applies only vertically. Alternatively use `gap` to configure gaps on both axis combined.
         */
        gapY: {
            min: `gap-y-${UDS_GAP.min}`,
            auto: `gap-y-${UDS_GAP.auto}`,
            max: `gap-y-${UDS_GAP.max}`,
            none: `gap-y-${UDS_GAP.none}`,
            px: `gap-y-${UDS_GAP.px}`,
            xxs: `gap-y-${UDS_GAP.xxs}`,
            xs: `gap-y-${UDS_GAP.xs}`,
            sm: `gap-y-${UDS_GAP.sm}`,
            base: `gap-y-${UDS_GAP.base}`,
            lg: `gap-y-${UDS_GAP.lg}`,
            xl: `gap-y-${UDS_GAP.xl}`,
            '2xl': `gap-y-${UDS_GAP['2xl']}`,
            '3xl': `gap-y-${UDS_GAP['3xl']}`,
            '4xl': `gap-y-${UDS_GAP['4xl']}`,
            '5xl': `gap-y-${UDS_GAP['5xl']}`,
        },
    },
});

const AccordionContext = (0,react.createContext)(null);
const useAccordionContext = () => {
    return useContext(AccordionContext);
};
const AccordionItemContext = (0,react.createContext)(null);
const useAccordionItemContext = () => {
    return useContext(AccordionItemContext);
};

const ACCORDION_VARIANTS = {
    invert: {
        false: 'text-neutral-100 border-neutral-20 bg-neutral-10',
        true: 'text-neutral-0 border-neutral-80 bg-neutral-90',
    },
    fill: {
        false: 'bg-opacity-0',
        true: 'bg-opacity-100',
    },
    outline: {
        false: 'border-0',
        true: 'border-1',
    },
};
const accordionRootStyle = (0,style/* style */.oB)({
    variants: ACCORDION_VARIANTS,
});
const AccordionRoot = ({ id: propsId, children, type, value, defaultValue, onValueChange, gap = 'none', transition = 'reveal', speed = 'base', fill = false, outline = false, invert = false, className, dataTestId, ...rest }) => {
    const id = useId(propsId);
    const [internalValue, setInternalValue] = React.useState(defaultValue);
    useEffect(() => {
        setInternalValue(value);
    }, [value]);
    const handleOpenChange = (value) => {
        setInternalValue(value);
        onValueChange?.(value);
    };
    const rootProps = type === 'single'
        ? {
            type: 'single',
            value: internalValue,
            defaultValue,
            onValueChange: handleOpenChange,
        }
        : {
            type: 'multiple',
            onValueChange: handleOpenChange,
            defaultValue,
            value: internalValue,
        };
    return (React.createElement(AccordionContext.Provider, { value: {
            id,
            invert,
            transition,
            speed,
            dataTestId,
            value: internalValue,
        } },
        React.createElement(RadixAccordion.Root, { ...rest, ...rootProps, id: id, "data-test-id": dataTestId, "data-uds-child": "accordion", className: tw('w-full flex flex-col', accordionRootStyle({ fill, invert, outline }), gapStyle({ gap }), className) }, children)));
};

const ACCORDION_ITEM_VARIANTS = {
    invert: {
        false: 'text-neutral-100 border-neutral-20 bg-neutral-10',
        true: 'text-neutral-0 border-neutral-80 bg-neutral-90',
    },
    fill: {
        false: 'bg-opacity-0',
        true: 'bg-opacity-100',
    },
    outline: {
        false: 'border-0',
        true: 'border-1',
    },
};
const accordionItemStyle = (0,style/* style */.oB)({
    variants: ACCORDION_ITEM_VARIANTS,
});
const AccordionItem = (props) => {
    const { value, children, invert, fill = false, outline = false, ...rest } = props;
    const { invert: rootInvert } = useAccordionContext();
    const { value: valueContext = [] } = useAccordionContext();
    const isItemOpen = valueContext === value || valueContext.includes(value);
    const appliedInvert = is.exists(invert) ? invert : rootInvert;
    return (React.createElement(AccordionItemContext.Provider, { value: { open: isItemOpen, invert: appliedInvert } },
        React.createElement(RadixAccordion.Item, { value: value, key: value, "data-uds-child": "accordion-item", className: tw$1(accordionItemStyle({ invert, fill, outline }), 'flex flex-col leading-[1]'), ...rest }, children)));
};

const animFadeIn$1 = (curve) => {
    return (0,css_css/* animation */.oQ)(curve, {
        from: {
            opacity: 0,
        },
        to: {
            opacity: 1,
        },
    });
};
const animFadeOut$1 = (curve) => {
    return (0,css_css/* animation */.oQ)(curve, {
        from: {
            opacity: 1,
        },
        to: {
            opacity: 0,
        },
    });
};
const animRevealIn = (curve, heightVar) => {
    return (0,css_css/* animation */.oQ)(curve, {
        from: {
            opacity: 0,
            height: '0px',
        },
        to: {
            opacity: 1,
            height: `var(${heightVar})`,
        },
    });
};
const animRevealOut = (curve, heightVar) => {
    return (0,css_css/* animation */.oQ)(curve, {
        from: {
            opacity: 1,
            height: `var(${heightVar})`,
        },
        to: {
            opacity: 0,
            height: '0px',
        },
    });
};
const animSlideIn = (curve, heightVar) => {
    return (0,css_css/* animation */.oQ)(curve, {
        from: {
            height: '0px',
        },
        to: {
            height: `var(${heightVar})`,
        },
    });
};
const animSlideOut = (curve, heightVar) => {
    return (0,css_css/* animation */.oQ)(curve, {
        from: {
            height: `var(${heightVar})`,
        },
        to: {
            height: '0px',
        },
    });
};
const getCollapsibleTransition = (param) => {
    return {
        in: getCollapsibleTransitionIn(param),
        out: getCollapsibleTransitionOut(param),
    };
};
const speedMap = {
    base: 0.6,
    fast: 0.3,
    slow: 1,
};
const getCurve = (speed) => {
    return `${speedMap[speed]}s cubic-bezier(0.16, 1, 0.3, 1) forwards`;
};
const getCollapsibleTransitionIn = (param) => {
    const curve = getCurve(param.speed);
    switch (param.type) {
        case 'fade':
            return animFadeIn$1(curve);
        case 'slide':
            return animSlideIn(curve, param.heightVar);
        case 'reveal':
            return animRevealIn(curve, param.heightVar);
        case 'none':
            return '';
    }
};
const getCollapsibleTransitionOut = (param) => {
    const curve = getCurve(param.speed);
    switch (param.type) {
        case 'fade':
            return animFadeOut$1(curve);
        case 'slide':
            return animSlideOut(curve, param.heightVar);
        case 'reveal':
            return animRevealOut(curve, param.heightVar);
        case 'none':
            return '';
    }
};

const insetStyle = (0,style/* style */.oB)({
    variants: {
        inset: {
            none: '',
            xxxs: '',
            xxs: '',
            xs: '',
            sm: '',
            base: '',
            md: '',
            lg: '',
            xl: '',
            '2xl': '',
            '3xl': '',
            '4xl': '',
            '5xl': '',
        },
        insetX: {
            none: 'px-0',
            xxxs: 'px-1',
            xxs: 'px-2',
            xs: 'px-3',
            sm: 'px-4',
            base: 'px-6',
            md: 'px-8',
            lg: 'px-12',
            xl: 'px-14',
            '2xl': 'px-16',
            '3xl': 'px-20',
            '4xl': 'px-28',
            '5xl': 'px-36',
        },
        insetY: {
            none: 'py-0',
            xxxs: 'py-1',
            xxs: 'py-2',
            xs: 'py-3',
            sm: 'py-4',
            base: 'py-6',
            md: 'py-8',
            lg: 'py-12',
            xl: 'py-14',
            '2xl': 'py-16',
            '3xl': 'py-20',
            '4xl': 'py-28',
            '5xl': 'py-36',
        },
        insetStart: {
            none: 'pl-0 rtl:pr-0',
            xxxs: 'pl-1 rtl:pr-1',
            xxs: 'pl-2 rtl:pr-2',
            xs: 'pl-3 rtl:pr-3',
            sm: 'pl-4 rtl:pr-4',
            base: 'pl-6 rtl:pr-6',
            md: 'pl-8 rtl:pr-8',
            lg: 'pl-12 rtl:pr-12',
            xl: 'pl-14 rtl:pr-14',
            '2xl': 'pl-16 rtl:pr-16',
            '3xl': 'pl-20 rtl:pr-20',
            '4xl': 'pl-28 rtl:pr-28',
            '5xl': 'pl-36 rtl:pr-36',
        },
        insetEnd: {
            none: 'pr-0 rtl:pl-0',
            xxxs: 'pr-1 rtl:pl-1',
            xxs: 'pr-2 rtl:pl-2',
            xs: 'pr-3 rtl:pl-3',
            sm: 'pr-4 rtl:pl-4',
            base: 'pr-6 rtl:pl-6',
            md: 'pr-8 rtl:pl-8',
            lg: 'pr-12 rtl:pl-12',
            xl: 'pr-14 rtl:pl-14',
            '2xl': 'pr-16 rtl:pl-16',
            '3xl': 'pr-20 rtl:pl-20',
            '4xl': 'pr-28 rtl:pl-28',
            '5xl': 'pr-36 rtl:pl-36',
        },
        insetTop: {
            none: 'pt-0',
            xxxs: 'pt-1',
            xxs: 'pt-2',
            xs: 'pt-3',
            sm: 'pt-4',
            base: 'pt-6',
            md: 'pt-8',
            lg: 'pt-12',
            xl: 'pt-14',
            '2xl': 'pt-16',
            '3xl': 'pt-20',
            '4xl': 'pt-28',
            '5xl': 'pt-36',
        },
        insetBottom: {
            none: 'pb-0',
            xxxs: 'pb-1',
            xxs: 'pb-2',
            xs: 'pb-3',
            sm: 'pb-4',
            base: 'pb-6',
            md: 'pb-8',
            lg: 'pb-12',
            xl: 'pb-14',
            '2xl': 'pb-16',
            '3xl': 'pb-20',
            '4xl': 'pb-28',
            '5xl': 'pb-36',
        },
    },
});
/**
 * The `Inset` component is a padded container for content.
 *
 * @example
 * ```jsx
 * <Inset inset="md"/>
 * <Inset inset={{_:'base,md:'2xl'}}/>
 * ```
 */
const Inset = react.forwardRef((props, forwadedRef) => {
    const { asChild, dataTestId, inset = 'none', insetX, insetY, insetTop, insetStart, insetBottom, insetEnd, className, ...rest } = props;
    const Comp = asChild ? $5e63c961fc1ce211$export$8c6ed5c666ac1360 : 'div';
    return (react.createElement(Comp, { ref: forwadedRef, "data-test-id": dataTestId, "data-uds-child": "inset", className: (0,style.tw)('w-full', insetStyle({
            insetX: insetX ?? inset,
            insetY: insetY ?? inset,
            insetStart: insetStart,
            insetEnd: insetEnd,
            insetTop: insetTop,
            insetBottom: insetBottom,
        }), className), ...rest }));
});
Inset.displayName = 'Inset';

const AccordionContent = ({ inset = 'none', insetX, insetY, insetTop, insetEnd, insetBottom, insetStart, className, children, ...props }) => {
    const { id, dataTestId, transition, speed } = useAccordionContext();
    const animation = getCollapsibleTransition({
        type: transition,
        speed: speed,
        heightVar: '--radix-accordion-content-height',
    });
    const animationCss = css$1 `
    &[data-state='open'] {
      ${animation.in}
    }

    &[data-state='closed'] {
      ${animation.out}
    }

    @media (prefers-reduced-motion) {
      &[data-state='open'] {
        animation: none;
      }

      &[data-state='closed'] {
        animation: none;
      }
    }
  `;
    return (React.createElement(RadixAccordion.Content, { ...props, "data-uds-child": "accordion-content", "data-test-id": dataTestId ? `${dataTestId}-content` : null, className: tw$2(className, 'overflow-hidden', animationCss) },
        React.createElement(Inset, { inset: inset, insetX: insetX, insetY: insetY, insetTop: insetTop, insetEnd: insetEnd, insetBottom: insetBottom, insetStart: insetStart }, children)));
};

const accordionTriggerStyle = (0,style/* style */.oB)({
    variants: {
        hover: {
            bg: '',
            underline: '',
            none: '',
        },
        invert: {
            false: '',
            true: '',
        },
    },
    matches: [
        {
            hover: 'bg',
            invert: 'true',
            use: 'hover:bg-neutral-80 focus-visible:bg-neutral-80',
        },
        {
            hover: 'bg',
            invert: 'false',
            use: 'hover:bg-neutral-20 focus-visible:bg-neutral-20',
        },
        {
            hover: 'underline',
            use: 'focus:outline-none hover:(decoration-underline decoration-1) focus-visible:(decoration-underline decoration-1)',
        },
    ],
});
const AccordionTrigger = ({ className, hover = 'bg', inset = 'none', insetX, insetY, insetTop, insetEnd, insetBottom, insetStart, asChild, ...rest }) => {
    const { dataTestId } = useAccordionContext();
    const { invert } = useAccordionItemContext();
    const wrapProps = asChild
        ? {}
        : {
            asChild: true,
            inset: inset,
            insetX: insetX,
            insetY: insetY,
            insetTop: insetTop,
            insetEnd: insetEnd,
            insetBottom: insetBottom,
            insetStart: insetStart,
        };
    const Wrap = asChild ? React.Fragment : Inset;
    return (React.createElement(Wrap, { ...wrapProps },
        React.createElement(RadixAccordion.Trigger, { ...rest, asChild: asChild, "data-uds-child": "accordion-trigger", "data-test-id": dataTestId ? `${dataTestId}-trigger` : null, className: tw$1(accordionTriggerStyle({ hover, invert }), 'w-full text-left rtl:text-right', 'transition-colors duration-[800ms] ease-out', 'hover:(transition-colors duration-300 ease-out)', className) })));
};

const ToggleChevron = ({ size = 'xl', open = false, className, ...rest }) => {
    return (react.createElement(Icon, { "data-uds-child": "toggle-chevron", ...rest, name: "chevron-down", "data-state": open ? 'open' : 'closed', size: size, className: (0,style.tw)('transition-transform transform', style/* css */.iv `
          &[data-state='open'] {
            transform: rotate(180deg);
          }
        `, className) }));
};

const AccordionChevron = (props) => {
    const { open } = useAccordionItemContext();
    return (React.createElement(ToggleChevron, { ...props, open: open, "data-uds-child": "accordion-chevron" }));
};

const CarouselContext = (0,react.createContext)(undefined);
const CarouselProvider = ({ children, value, }) => (React.createElement(CarouselContext.Provider, { value: value }, children));

/**
 * The `CarouselRoot` component is the root component for the carousel. It provides the context for the carousel.
 *
 * To render slides within the carousel, you will need to wrap them in a `CarouselViewport` component, which provides the scrolling functionality.
 *
 * The pattern also exposes other components to help with navigation, such as `CarouselChevronButton`. `CarouselDots`, `Caroueland `CarouselProgress`
 *
 * ```
 * import {
 *   CarouselRoot,
 *   CarouselViewport,
 *   CarouselChevronButton,
 *   CarouselDots,
 *   CarouselProgress,
 *   CarouselThumbList,
 *   CarouselThumb,
 *   CarouselHeading,
 *   CarouselPageOf
 * } from '@global-ecom/nitro-uds/elements';
 *```
 *
 * @example
 * ```tsx
 * <CarouselRoot
 *   align="center"
 *   columns={1}
 * >
 * <CarouselChevronButton
 *    direction="prev"
 *  />
 *   CarouselChevronButton
 *    direction="next"
 *  />
 *
 *  <CarouselHeading>Trending content</CarouselHeading>
 *
 *  <CarouselViewport>
 *    <CarouselSlide/>
 *    <CarouselSlide/>
 *    <CarouselSlide/>
 *  </CarouselViewport>
 *
 *  <CarouselPeekButton
 *    direction="prev"
 *  />
 *   CarouselPeekButton
 *    direction="next"
 *  />
 *
 *  <CarouselDots />
 *  <CarouselProgress />
 *  <CarouselPageOf />
 *
 *  <CarouselThumbList>
 *    <CarouselThumb>
 *      <img />
 *    </CarouselThumb>
 *    <CarouselThumb>
 *      <img />
 *    </CarouselThumb>
 *    <CarouselThumb>
 *      <img />
 *    </CarouselThumb>
 *  </CarouselThumbList>
 * </CarouselRoot>
 * ```
 */
const CarouselRoot = ({ id: propsId, columns = 1, peek = false, limit = 999, gap = 'auto', loop = true, snap = true, animate = true, dataTestId, className, children, onSlideChange, ...rest }) => {
    const id = useId(propsId);
    const { devicePreferences } = useUdsContext();
    const prefersReducedMotion = devicePreferences.prefersReducedMotion;
    const columnValue = useResponsiveValue(columns);
    const rootRef = useRef(null);
    const [emblaRef, api] = useEmblaCarousel({
        containScroll: 'keepSnaps',
        skipSnaps: snap,
        dragFree: !snap,
        align: peek === true ? 'center' : 'start',
        inViewThreshold: 0.5,
        duration: animate && prefersReducedMotion !== true ? 20 : 0,
        slidesToScroll: columnValue,
        loop: loop,
    }, []);
    const handleSlideSelect = useCallback(api => {
        onSlideChange && onSlideChange(api.selectedScrollSnap());
    }, []);
    useEffect(() => {
        if (api) {
            api.on('init', handleSlideSelect);
            api.on('select', handleSlideSelect);
        }
        return () => {
            if (api) {
                api.off('init', handleSlideSelect);
                api.off('select', handleSlideSelect);
            }
        };
    }, [api, handleSlideSelect]);
    const handleKeyDown = event => {
        /* istanbul ignore next */
        if (!api || !rootRef.current.contains(document.activeElement))
            return;
        if (event.key === 'ArrowRight') {
            api.scrollNext();
        }
        if (event.key === 'ArrowLeft') {
            api.scrollPrev();
        }
        if (event.key === 'Home') {
            api.scrollTo(0);
        }
        if (event.key === 'End') {
            api.scrollTo(api.scrollSnapList().length - 1);
        }
    };
    useEffect(() => {
        /* istanbul ignore next */
        if (!rootRef.current)
            return;
        rootRef.current.addEventListener('keydown', handleKeyDown);
        return () => {
            if (!rootRef.current)
                return;
            rootRef.current.removeEventListener('keydown', handleKeyDown);
        };
    }, [rootRef, handleKeyDown]);
    return (React.createElement("div", { id: id, ref: rootRef, className: tw$2('relative', className), "data-uds-child": "carousel", "data-test-id": dataTestId, ...rest },
        React.createElement(CarouselProvider, { value: {
                id,
                dataTestId,
                peek,
                slidesToScroll: columnValue,
                columns,
                limit,
                loop,
                gap,
                rootRef: rootRef,
                viewportRef: emblaRef,
                api: api,
            } }, children)));
};

const LiveRegion = ({ id, children, className, dataTestId, role = 'alert', type = 'polite', atomic = true, ...rest }) => {
    return (react.createElement("div", { id: id, "data-test-id": dataTestId, role: role, "aria-live": type, "aria-atomic": atomic, className: (0,twind.tw)('w-full', className, !children && 'hidden'), ...rest }, children));
};

const CAROUSEL_GAP = {
    min: `-ml-${UDS_GAP['min']} children:pl-${UDS_GAP['min']}`,
    auto: `-ml-${UDS_GAP['auto']} children:pl-${UDS_GAP['auto']}`,
    max: `-ml-${UDS_GAP['max']} children:pl-${UDS_GAP['max']}`,
    none: `-ml-${UDS_GAP['none']} children:pl-${UDS_GAP['none']}`,
    px: `-ml-${UDS_GAP['px']} children:pl-${UDS_GAP['px']}`,
    xxs: `-ml-${UDS_GAP['xxs']} children:pl-${UDS_GAP['xxs']}`,
    xs: `-ml-${UDS_GAP['xs']} children:pl-${UDS_GAP['xs']}`,
    sm: `-ml-${UDS_GAP['sm']} children:pl-${UDS_GAP['sm']}`,
    base: `-ml-${UDS_GAP['base']} children:pl-${UDS_GAP['base']}`,
    lg: `-ml-${UDS_GAP['lg']} children:pl-${UDS_GAP['lg']}`,
    xl: `-ml-${UDS_GAP['xl']} children:pl-${UDS_GAP['xl']}`,
    '2xl': `-ml-${UDS_GAP['2xl']} children:pl-${UDS_GAP['2xl']}`,
    '3xl': `-ml-${UDS_GAP['3xl']} children:pl-${UDS_GAP['3xl']}`,
    '4xl': `-ml-${UDS_GAP['4xl']} children:pl-${UDS_GAP['4xl']}`,
    '5xl': `-ml-${UDS_GAP['5xl']} children:pl-${UDS_GAP['5xl']}`,
};
const THUMB_SIZE$2 = {
    xs: 'h-6 w-6 p-px',
    sm: 'h-8 w-8 p-px',
    base: 'h-10 w-10 p-px',
    lg: 'h-12 w-12 p-px',
};
const THUMB_SIZE_RAW = {
    xs: 20,
    sm: 28,
    base: 36,
    lg: 44,
};
const THUMBS_GAP_RAW = {
    xs: 4,
    sm: 4,
    base: 6,
    lg: 8,
};
const THUMBS_GAP = {
    xs: '-ml-1 children:pl-1',
    sm: '-ml-1 children:pl-1',
    base: '-ml-1.5 children:pl-1.5',
    lg: '-ml-2 children:pl-2',
};

/**
 * useCarouselContext is used to access the CarouselContext. It's mounted internally by the CarouselRoot, and will not be used directly by consumers.
 *
 * @internal
 */
const useCarouselContext = () => {
    const context = (0,react.useContext)(CarouselContext);
    if (!context) {
        throw new Error('useCarouselContext must be used within a CarouselRoot');
    }
    return context;
};

/**
 * A utility hook, that returns the scroll progress of the parent carousel
 *
 * @example
 * ```tsx
 * useCarouselProgress(({ progressPercent, selectedIndex }) => {
 *  console.log(progressPercent, selectedIndex);
 * });
 * ```
 */
const useCarouselProgress = (onUpdate) => {
    const { api } = useCarouselContext();
    const progress = React.useRef(null);
    const onScroll = useCallback(() => {
        /* istanbul ignore next */
        if (!api)
            return;
        const progressPercent = Math.max(0.005, Math.min(1, api.scrollProgress()));
        progress.current = progressPercent;
        onUpdate({
            api,
            progressPercent,
            slidesInView: api.slidesInView(),
            selectedIndex: api.selectedScrollSnap(),
        });
    }, [api]);
    useEffect(() => {
        /* istanbul ignore next */
        if (!api)
            return;
        onScroll();
        api.on('reInit', onScroll);
        api.on('scroll', onScroll);
        api.on('select', onScroll);
        return () => {
            api.off('reInit', onScroll);
            api.off('scroll', onScroll);
            api.off('select', onScroll);
        };
    }, [api, onScroll]);
    return progress;
};

/**
 * A utility hook, that returns the scrolll positions, the current selected index and an array of indexes, representing the slides currently in view.
 *
 * @example
 * ```tsx
 * const { scrollSnapList, selectedIndex, slidesInView } = useCarouselSnaps();
 * ```
 */
const useCarouselSnaps = () => {
    const { api } = useCarouselContext();
    const [selectedIndex, setSelectedIndex] = useState(0);
    const [scrollSnapList, setSnaps] = useState([]);
    const [slidesInView, setSlidesInView] = useState([]);
    const onInit = useCallback(() => {
        /* istanbul ignore next */
        if (!api)
            return;
        setSnaps(api.scrollSnapList());
        setSlidesInView(api.slidesInView());
        setSelectedIndex(api.selectedScrollSnap());
    }, [api]);
    const onSelect = useCallback(() => {
        setSlidesInView(api.slidesInView());
        setSelectedIndex(api.selectedScrollSnap());
    }, [api]);
    const onSettle = useCallback(() => {
        setSlidesInView(api.slidesInView());
        setSelectedIndex(api.selectedScrollSnap());
    }, [api]);
    useEffect(() => {
        /* istanbul ignore next */
        if (!api)
            return;
        api.on('init', onInit);
        api.on('reInit', onInit);
        api.on('select', onSelect);
        api.on('settle', onSettle);
        onInit();
        return () => {
            api.off('init', onInit);
            api.off('reInit', onInit);
            api.off('select', onSelect);
            api.off('settle', onSettle);
        };
    }, [api, onInit]);
    return { scrollSnapList, selectedIndex, slidesInView };
};

/**
 * The viewport of the carousel. This is the container that holds the slides, and is responsible for scrolling.. It does not receive any props, and injerits all the configurations from the CarouselRoot.
 *
 * @example
 * ```tsx
 * <CarouselRoot>
 *  <CarouselViewport>
 *    <CarouselSlide/>
 *    <CarouselSlide/>
 *    <CarouselSlide/>
 *  </CarouselViewport>
 * </CarouselRoot>
 * ```
 */
const CarouselViewport = ({ children, ...rest }) => {
    const t = useUdsTranslate();
    const { id, dataTestId, viewportRef, peek, columns, limit, gap } = useCarouselContext();
    const { scrollSnapList, selectedIndex } = useCarouselSnaps();
    const containerRef = React.useRef(null);
    const columnsClassName = useResponsiveProp(columns, col => {
        if (peek === true) {
            col += 0.2 + (col > 1 ? col * 0.12 : 0.06);
        }
        return `auto-cols-[${100 / col}%]`;
    });
    const limitValue = useResponsiveValue(limit);
    useCarouselProgress(({ slidesInView }) => {
        const tileList = containerRef.current.querySelectorAll('[data-uds-child="carousel-slide"]');
        const tileTargets = Array.prototype.slice.call(tileList);
        tileTargets.forEach((target, index) => {
            const isInView = slidesInView.includes(index);
            target.setAttribute('inert', `${!isInView}`);
            // target.dataset.udsAttrItemActive = isInView ? 'true' : 'false';
            target.children[0].dataset.udsAttrInView = isInView
                ? 'true'
                : 'false';
        });
    });
    const gapClassName = useResponsiveProp(gap, value => {
        return CAROUSEL_GAP[value].split(' ');
    });
    const containerClassName = tw$2('grid grid-flow-col', 'children:grid', gapClassName, columnsClassName);
    return (React.createElement(React.Fragment, null,
        React.createElement(LiveRegion, { type: "polite", "data-uds-child": "carousel-announcer" },
            React.createElement("p", { className: "sr-only" }, t('pageXofY', {
                page: selectedIndex + 1,
                total: scrollSnapList.length,
            }))),
        React.createElement("div", { tabIndex: 0, role: "region", "data-uds-child": "carousel-viewport", ref: viewportRef, "data-test-id": dataTestId ? `${dataTestId}-viewport` : undefined, className: tw$2('transition-transform ease-out duration-300', 'focus:outline-none focus-visible:(ring ring-2 ring-offset-2) overflow-hidden'), ...rest },
            React.createElement("div", { "data-uds-child": "carousel-slides-track", className: tw$2(containerClassName), ref: containerRef, role: "none" }, React.Children.map(children, (child, index) => index < limitValue ? child : null)))));
};

const CarouselSlide = ({ children, ...rest }) => {
    return (React.createElement("div", { role: "none", "data-uds-child": "carousel-slide", ...rest }, children));
};

/**
 *
 * A utility hook, that returns a object containing the carousel navigation functions and state.
 *
 * @example
 * ```tsx
 * const { scrollTo, scrollNext, scrollPrev, canScrollNext, canScrollPrev } = useCarouselNav();
 * ```
 */
const useCarouselNav = () => {
    const { api } = useCarouselContext();
    const [canScrollNext, setScrollNext] = (0,react.useState)(false);
    const [canScrollPrev, setScrollPrev] = (0,react.useState)(false);
    const onSelect = () => {
        setScrollNext(api.canScrollNext());
        setScrollPrev(api.canScrollPrev());
    };
    const scrollNext = (0,react.useCallback)(() => api && api.scrollNext(), [api]);
    const scrollPrev = (0,react.useCallback)(() => api && api.scrollPrev(), [api]);
    const scrollTo = (0,react.useCallback)((index) => api && api.scrollTo(index), [api]);
    (0,react.useEffect)(() => {
        /* istanbul ignore next */
        if (!api)
            return;
        api.on('init', onSelect);
        api.on('reInit', onSelect);
        api.on('select', onSelect);
        onSelect();
        return () => {
            api.off('init', onSelect);
            api.off('reInit', onSelect);
            api.off('select', onSelect);
        };
    }, [api, onSelect]);
    return {
        scrollNext,
        scrollPrev,
        scrollTo,
        canScrollNext,
        canScrollPrev,
    };
};

/**
 * A component that renders an icon button that can be used to navigate the carousel to the next or previous page.
 *
 * The CarouselChevronButton is a convenience component that wraps the ButtonIcon component, and inherits some of its props.
 *
 * You can render this component, withiin the CarouselRoot, and position it however you like.
 *
 * Alternatively, you can use the useCarouselNav hook, which provides all the information you need to render your own custom component.
 *
 * @example
 * ```tsx
 * <CarouselRoot>
 *  <CarouselChevronButton direction="next" className="absolute"/>
 *  <CarouselChevronButton direction="prev"  className="absolute"/>
 *  <CarouselViewport>
 *    <CarouselSlide/>
 *    <CarouselSlide/>
 *   </CarouselViewport>
 * </CarouselRoot>
 * ```
 *
 * @example Button props
 * ```tsx
 * <CarouselChevronButton variant="primary" size="md">
 * <CarouselChevronButton variant="primary" invert>
 * <CarouselChevronButton variant="ghost" size="xs">
 * <CarouselChevronButton icon="arrow-right">
 * ```
 */
const CarouselChevronButton = (0,react.forwardRef)(function CarouselChevronButton(props, ref) {
    const { className, direction, variant, label, size, icon, invert } = props;
    const { dataTestId } = useCarouselContext();
    const t = (0,esm/* useUdsTranslate */.oG)();
    const { scrollNext, scrollPrev, canScrollPrev, canScrollNext } = useCarouselNav();
    const handleClick = e => {
        if (direction === 'prev') {
            scrollPrev();
        }
        if (direction === 'next') {
            scrollNext();
        }
    };
    const disabled = direction === 'prev' ? !canScrollPrev : !canScrollNext;
    const appliedIcon = icon || direction === 'prev' ? 'chevron-left' : 'chevron-right';
    const appliedLabel = label || direction === 'prev' ? t('scrollPrevious') : t('scrollNext');
    return (react.createElement(ButtonIcon, { ref: ref, icon: appliedIcon, label: appliedLabel, size: size, invert: invert, variant: variant, mode: "icon", onClick: handleClick, disabled: disabled, className: className, "data-uds-child": `carousel-chevron-button-${direction}`, 
        /* istanbul ignore next */
        dataTestId: dataTestId ? `${dataTestId}-chevron-button-${direction}` : undefined }));
});

/**
 * A variation of the CarouselChevronButton that is designed to be used with the peek feature.
 *
 * Is automatically resized to the size of the peek area, and based on the direction
 *
 */
const CarouselPeekButton = (0,react.forwardRef)(function CarouselChevronButton(props, ref) {
    const { variant, size = { _: 'xs', md: 'sm', xl: 'base' }, direction, label, invert, offsetY = 0, } = props;
    const { dataTestId, columns, gap } = useCarouselContext();
    const t = (0,esm/* useUdsTranslate */.oG)();
    const { scrollNext, scrollPrev, canScrollPrev, canScrollNext } = useCarouselNav();
    const handleClick = () => {
        if (direction === 'prev') {
            scrollPrev();
        }
        if (direction === 'next') {
            scrollNext();
        }
    };
    const widthClassName = (0,esm/* useResponsiveProp */.Uo)(columns, col => {
        let columnSize = col;
        columnSize += 0.2 + (col > 1 ? col * 0.12 : 0.06);
        return [`w-[${(100 - (100 / columnSize) * col) / 2}%]`];
    });
    const paddingClassName = (0,esm/* useResponsiveProp */.Uo)(gap, value => {
        return direction === 'prev'
            ? `pr-${UDS_GAP[value]}`
            : `pl-${UDS_GAP[value]}`;
    });
    const disabled = direction === 'prev' ? canScrollPrev === false : canScrollNext === false;
    const appliedLabel = label || direction === 'prev' ? t('scrollPrevious') : t('scrollNext');
    const buttonOffsetY = (0,esm/* useResponsiveValue */.Vt)(offsetY);
    const { children: buttonChildren, className: buttonClassName } = useActionIcon({
        label: appliedLabel,
        variant: variant,
        invert: invert,
        size: size,
        mode: 'icon',
        icon: direction === 'prev' ? 'chevron-left' : 'chevron-right',
    });
    return (react.createElement("div", { className: (0,twind.tw)(paddingClassName, widthClassName, 'min-w-12', 'absolute h-full top-0 z-10 flex text-white', direction === 'prev' ? 'left-0' : 'right-0') },
        react.createElement("button", { ref: ref, onClick: handleClick, "data-uds-child": `carousel-peek-button-${direction}`, disabled: disabled, "data-test-id": dataTestId ? `${dataTestId}-peek-button-${direction}` : undefined, className: (0,twind.tw)(buttonClassName, 'w-full flex-1', 'focus:outline-none') },
            react.createElement("div", { className: (0,twind.tw)('absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2', css_css/* css */.iv `
              top: calc(
                50% + ${buttonOffsetY}${(0,utils_esm/* isNumber */.hj)(buttonOffsetY) ? 'px' : ''}
              );
            `) }, buttonChildren))));
});

/**
 * A component that renders a a progress bar, that represents the current scroll position of the carousel.
 *
 * You can render this component, withiin the CarouselRoot, and position it however you like.
 *
 * Alternatively, you can use the useCarouselProgress hook, which provides all the information you need to render your own custom progress bar.
 *
 * @example
 * ```tsx
 * <CarouselRoot>
 *   <CarouselProgress className="absolute bottom-2" />
 *  <CarouselViewport>
 *    <CarouselSlide/>
 *    <CarouselSlide/>
 *   </CarouselViewport>
 * </CarouselRoot>
 * ```
 */
const CarouselProgress = ({ invert, className, }) => {
    const spreadRed = React.useRef(null);
    const { dataTestId } = useCarouselContext();
    useCarouselProgress(({ progressPercent }) => {
        spreadRed.current.style.transform = `scaleX(${progressPercent})`;
    });
    return (React.createElement("div", { "data-uds-child": "carousel-progress", "data-test-id": dataTestId ? `${dataTestId}-progress` : undefined, className: tw$2('relative h-1.5 rounded-full', invert ? 'bg-neutral-80' : 'bg-neutral-30', className) },
        React.createElement("div", { className: tw$2('origin-top-left h-1.5 w-full', invert ? 'bg-neutral-0' : 'bg-neutral-90'), ref: spreadRed })));
};

const PAGE_OF_SIZES = {
    xs: '',
    sm: '',
    base: '',
    lg: '',
    xl: '',
    '2xl': '',
};
const LINE_SIZES = {
    xs: 'h-px w-4 mx-1.5 mt-0.5',
    sm: 'h-px w-6 mx-1.5 mt-0.5',
    base: 'h-px w-6 mx-2 mt-0.5',
    lg: 'h-px w-8 mx-2 mt-0.5',
    xl: 'h-px w-8 mx-2 mt-0.5',
    '2xl': 'h-px w-8 mx-2 mt-0.5',
};
/**
 * A text component that renders the current page number and the total number of pages in the carousel.
 *
 * Its size can be customized using a small subset of the size scale, and it inherits the color, transform, and weight props from the Heading component.
 *
 * The text is hidden from screen readers, as the engine, internally announces the same content. to screen readers.
 *
 * @example
 * ```tsx
 * <CarouselRoot>
 *  <CarouselViewport>
 *    <CarouselSlide/>
 *    <CarouselSlide/>
 *   </CarouselViewport>
 *   <CarouselPageOf size="lg" weight="bold"/>
 * </CarouselRoot>
 * ```
 */
const CarouselPageOf = ({ className, color = 'base', weight = '400', size = 'base', ...rest }) => {
    const t = useUdsTranslate();
    const { dataTestId } = useCarouselContext();
    const { scrollSnapList, selectedIndex } = useCarouselSnaps();
    const lineClassName = useResponsiveProp(size, value => {
        return `${LINE_SIZES[value]}`;
    });
    return (React.createElement(Heading, { "data-uds-child": "carousel-page-of", 
        /* istanbul ignore next */
        dataTestId: dataTestId ? `${dataTestId}-page-of` : undefined, className: tw$2('tabular-nums	flex items-center', className), "aria-hidden": "true", size: size, color: color, weight: weight, ...rest, asChild: true, "aria-label": t('pageXofY', {
            page: selectedIndex + 1,
            total: scrollSnapList.length,
        }) },
        React.createElement("p", null,
            React.createElement("span", null, `${selectedIndex + 1}`.padStart(2, '0')),
            React.createElement("span", { role: "presentation", "aria-hidden": "true", className: tw$2('block flex-none bg-current', lineClassName) }),
            React.createElement("span", null, `${scrollSnapList.length}`.padStart(2, '0')))));
};

const stackStyle = (0,style/* style */.oB)({
    base: 'w-full flex',
    variants: {
        /**
         * Flex Direction.
         *
         * - column, stacks vertically,
         * - row stacks horizontally, with row wrap,
         * - inline is a flex row, that doesn wrap the children
         *
         * defaultValue column
         *
         * @example
         * ```
         * <Stack direction="column" />
         * ```
         */
        direction: {
            column: '',
            row: 'flex-wrap',
            inline: 'children:flex-auto',
        },
        /**
         * Reverse the order of the children
         * defaultValue false
         */
        reverse: {
            true: '',
            false: '',
        },
        /**
         * Flex items. Align items across the stack direction
         */
        items: {
            start: 'items-start',
            end: 'items-end',
            center: 'items-center',
            stretch: 'items-stretch',
            baseline: 'items-baseline',
        },
        /**
         * Flex justify. Align items along the stack direction
         *
         * - stretch applies flex-1 to it's children
         */
        justify: {
            start: 'justify-start',
            end: 'justify-end',
            center: 'justify-center',
            stretch: 'children:flex-1',
            between: 'justify-between',
        },
    },
    matches: [
        {
            direction: 'column',
            reverse: false,
            use: 'flex-col',
        },
        {
            direction: 'row',
            reverse: false,
            use: 'flex-row',
        },
        {
            direction: 'inline',
            reverse: false,
            use: 'flex-row',
        },
        {
            direction: 'column',
            reverse: true,
            use: 'flex-col-reverse',
        },
        {
            direction: 'row',
            reverse: true,
            use: 'flex-row-reverse ',
        },
        {
            direction: 'inline',
            reverse: true,
            use: 'flex-row-reverse ',
        },
    ],
});
/**
 * The Stack is a layout component wrapped around css flexbox. It is used as a way to
 * declaratively define a flex layout.
 *
 * @example
 * ```
 * <Stack
 *   direction="row"
 *   gap={{_: 'base', sm: 'xl'}}
 * >
 *  ...
 * </Stack>
 * ```
 *
 * Can be configured responsively
 *
 *  @example
 * ```
 * <Stack
 *   direction={{_: 'column', sm: 'row'}}
 *   gap={{_: 'base', sm: 'xl'}}
 * >
 *  ...
 * </Stack>
 * ```
 *
 * - By default renders a div. To render as a custom element, use the `asChild` prop
 *
 * @example
 * ```
 * <Stack
 *   asChild
 *   gap="xl"
 * >
 *  <section>...</section>
 * </Stack>
 * ```
 */
const Stack = react.forwardRef((props, forwardedRef) => {
    const { asChild, dataTestId, css: whatIsThis, // TODO find out why this is here
    gap = 'base', gapX, gapY, direction = 'column', reverse = false, items, justify, className, children, ...rest } = props;
    const Comp = asChild ? $5e63c961fc1ce211$export$8c6ed5c666ac1360 : 'div';
    return (react.createElement(Comp, { ref: forwardedRef, className: (0,style.tw)(gapStyle({ gap, gapX, gapY }), stackStyle({
            items,
            justify,
            direction,
            reverse,
        }), className), "data-uds-child": "stack", "data-test-id": dataTestId, ...rest }, children));
});
Stack.displayName = 'Stack';

/**
 * A component that renders a set of dot buttons, that represent the number of pages in the carousel, and scroll to the corresponding page when clicked.
 *
 * You can render this component, withiin the CarouselRoot, and position it however you like.
 *
 * Alternatively, you can use the useCarouselSnaps hook, which provides all the information you need to render your own custom pagination component.
 *
 * @example
 * ```tsx
 * <CarouselRoot>
 *   <CarouselDots invert/>
 *  <CarouselViewport>
 *    <CarouselSlide/>
 *    <CarouselSlide/>
 *   </CarouselViewport>
 * </CarouselRoot>
 * ```
 *
 * @example Responsive invert
 * ```tsx
 * <CarouselRoot invert={{_:false, md:true}}/>
 * ```
 */
const CarouselDots = ({ invert, className }) => {
    const { dataTestId } = useCarouselContext();
    const ref = useRef(null);
    const { scrollSnapList, selectedIndex } = useCarouselSnaps();
    const { scrollTo } = useCarouselNav();
    useEffect(() => {
        if (!ref.current.contains(document.activeElement))
            return;
        const nodelist = ref.current?.querySelectorAll('button');
        const targets = Array.prototype.slice.call(nodelist);
        targets.forEach((target, index) => {
            if (index === selectedIndex) {
                target.focus();
                target.tabIndex = 0;
                target.setAttribute('ariaHidden', 'true');
                target.setAttribute('ariaSelected', 'true');
            }
            else {
                target.tabIndex = -1;
                target.setAttribute('ariaHidden', 'false');
                target.setAttribute('ariaSelected', 'false');
            }
        });
    }, [selectedIndex]);
    const selectedDotClassName = useResponsiveProp(invert, value => {
        return value ? 'bg-neutral-0' : 'bg-neutral-100';
    });
    const dotClassName = useResponsiveProp(invert, value => {
        return value
            ? 'bg-neutral-60 group-hover:bg-neutral-40'
            : 'bg-neutral-40 group-hover:bg-neutral-60';
    });
    return (React.createElement(Stack, { ref: ref, direction: "row", justify: "center", gap: "xs", className: className, "data-uds-child": "carousel-dots", dataTestId: dataTestId ? `${dataTestId}-dots` : undefined, asChild: true },
        React.createElement("div", { role: "tablist" }, scrollSnapList.map((_, index) => (React.createElement("button", { key: index, role: "tab", "data-uds-child": "carousel-dot-button", onClick: () => scrollTo(index), tabIndex: selectedIndex === index ? 0 : -1, "aria-selected": selectedIndex === index ? 'true' : 'false', className: tw$2('group flex-none relative px-0.5 py-0.5 rounded-full', 'focus:outline-none focus-visible:(ring-2 ring-offset-0)', css `
                &:after {
                  position: absolute;
                  top: -6px;
                  left: -4px;
                  right: -4px;
                  bottom: -6px;
                  content: '';
                  display: block;
                  opacity: 1;
                  background-color: rgba(255, 25, 255, 0);
                }
              `) },
            React.createElement("div", { className: tw$2('flex-none h-2.5 w-2.5 rounded-full', 'transition-bg duration-400 ease-in', selectedIndex === index ? selectedDotClassName : dotClassName) }),
            React.createElement("span", { className: "sr-only" }, `Page ${index + 1}`)))))));
};

/**
 * A component that renders a list of thumb buttons, that represent the number of pages in the carousel, and scroll to the corresponding page when clicked.
 *
 * Provide as may items as the carousel slides, and they will be rendered as the thumbs.
 *
 * @example
 *
 * ```tsx
 * <CarouselRoot>
 *
 *  <CarouselThumbList>
 *    <CarouselThumb>
 *      <img />
 *    </CarouselThumb>
 *    <CarouselThumb>
 *      <img />
 *    </CarouselThumb>
 *    <CarouselThumb>
 *      <img />
 *    </CarouselThumb>
 *  </CarouselThumbList>
 *
 *  <CarouselViewport>
 *    <CarouselSlide/>
 *    <CarouselSlide/>
 *    <CarouselSlide/>
 *   </CarouselViewport>
 *
 * </CarouselRoot>
 * ```
 */
const CarouselThumbList = ({ children, size = 'base', scroll: scrollThumbs, invert, className, }) => {
    const t = useUdsTranslate();
    const trackRef = useRef(null);
    const { dataTestId, slidesToScroll, columns, limit, api, loop } = useCarouselContext();
    const { slidesInView, selectedIndex } = useCarouselSnaps();
    const { scrollTo } = useCarouselNav();
    const sizeValue = useResponsiveValue(size);
    const columnValue = useResponsiveValue(columns);
    const limitValue = useResponsiveValue(limit);
    const scrollThumbsValue = useResponsiveValue(scrollThumbs);
    const visibleThumbs = Math.max(slidesToScroll, scrollThumbsValue);
    const viewportWidth = visibleThumbs * THUMB_SIZE_RAW[sizeValue] +
        (visibleThumbs - 1) * THUMBS_GAP_RAW[sizeValue];
    const thumbsCarouselEnabled = isNumber(scrollThumbsValue) &&
        scrollThumbsValue &&
        scrollThumbsValue < React.Children.count(children);
    const [thumbsViewportRef, thumbApi] = useEmblaCarousel({
        active: thumbsCarouselEnabled,
        containScroll: 'keepSnaps',
        dragFree: true,
        slidesToScroll: slidesToScroll,
        align: 'center',
        loop: loop,
    }, []);
    const onSelect = useCallback(() => {
        /* istanbul ignore next */
        if (!api || !thumbApi)
            return;
        thumbApi.scrollTo(api.selectedScrollSnap());
    }, [api, thumbApi]);
    const gapClassName = useResponsiveProp(size, value => {
        return THUMBS_GAP[value];
    });
    const scrollThumbsNext = useCallback(() => {
        thumbApi.scrollNext();
    }, [thumbApi]);
    const scrollThumbsPrev = useCallback(() => {
        thumbApi.scrollPrev();
    }, [thumbApi]);
    useEffect(() => {
        if (!trackRef.current.contains(document.activeElement))
            return;
        const targetIndex = selectedIndex * columnValue;
        const nodelist = trackRef.current.querySelectorAll('[data-uds-child="carousel-thumb"]');
        const targets = Array.prototype.slice.call(nodelist);
        targets[targetIndex].focus();
    }, [selectedIndex]);
    const syncVisibleThumbs = (slidesInView) => {
        const nodelist = trackRef.current.querySelectorAll('[data-uds-child="carousel-thumb"]');
        const targets = Array.prototype.slice.call(nodelist);
        targets.forEach((target, index) => {
            const isInView = slidesInView.includes(index);
            target.tabIndex = isInView ? 0 : -1;
            target.setAttribute('ariaSelected', `${isInView}`);
        });
    };
    useCarouselProgress(({ slidesInView }) => {
        syncVisibleThumbs(slidesInView);
    });
    useEffect(() => {
        /* istanbul ignore next */
        if (!api || !thumbApi)
            return;
        onSelect();
        api.on('init', onSelect);
        api.on('reInit', onSelect);
        api.on('select', onSelect);
        return () => {
            /* istanbul ignore next */
            if (!api)
                return;
            api.off('init', onSelect);
            api.off('reInit', onSelect);
            api.off('select', onSelect);
        };
    }, [api, thumbApi, onSelect]);
    const thumbsLength = limitValue ?? React.Children.count(children);
    const arrowsSize = size === 'xs' || size === 'sm' ? 'xs' : 'sm';
    return (React.createElement("div", { className: tw$2(className, 'flex gap-3'), "data-uds-child": "carousel-thumbs" },
        thumbsCarouselEnabled ? (React.createElement(ButtonIcon, { icon: "chevron-left", label: t('scrollPrevious'), size: arrowsSize, variant: "ghost", mode: "icon", invert: invert, onClick: scrollThumbsPrev, "data-uds-child": "carousel-thumbs-chevron-prev" })) : null,
        React.createElement("div", { ref: thumbsViewportRef, className: tw$2('py-0.5 px-0.5', thumbsCarouselEnabled &&
                `flex-none overflow-hidden w-[${viewportWidth}px]`) },
            React.createElement("div", { role: "tablist", "data-uds-child": "carousel-thumbs-track", ref: trackRef, "data-test-id": dataTestId ? `${dataTestId}-thumbs` : undefined, className: tw$2('grid grid-flow-col', gapClassName, css `
              grid-template-columns: repeat(${thumbsLength}, max-content);
            `, className) }, React.Children.map(children, (child, index) => !limitValue || index < limitValue ? (React.createElement("div", { role: "none" }, React.cloneElement(child, {
                role: 'tab',
                size: size,
                invert: invert,
                'data-uds-child': 'carousel-thumb',
                'aria-label': `Slide ${index + 1}`,
                active: slidesInView.includes(index),
                onClick: () => {
                    scrollTo(Math.floor(index / columnValue));
                },
            }))) : null))),
        thumbsCarouselEnabled ? (React.createElement(ButtonIcon, { icon: "chevron-right", label: t('scrollNext'), size: arrowsSize, variant: "ghost", mode: "icon", invert: invert, onClick: scrollThumbsNext, "data-uds-child": "carousel-thumbs-chevron-next" })) : null));
};

/**
 * The AspectRatio component is used to wrap content in a fixed aspect ratio.
 *
 * Use the `overflow` property, to set the layout to a minimum-aspect-ratio, that grows depending on the length of its contents.
 *
 * @example
 * ```jsx
 * <AspectRatio ratio={16/9}/>
 * ```
 *
 */
const fixedRatios = {
    landscape: 0.42,
    wide: 0.66,
    square: 1,
    tall: 1.3333,
};
const AspectRatio = react.forwardRef((props, forwadedRef) => {
    const { asChild, ratio = 1, overflow, className, dataTestId, ...rest } = props;
    const Comp = asChild ? $5e63c961fc1ce211$export$8c6ed5c666ac1360 : 'div';
    const callback = (value) => {
        const ratio = fixedRatios[value] ?? value;
        return overflow
            ? `min-aspect-ratio-[${ratio}]`
            : ['overflow-hidden', `aspect-ratio-[${ratio}]`];
    };
    const ratioClassName = (0,esm/* useResponsiveProp */.Uo)(ratio, callback);
    return (react.createElement(Comp, { ref: forwadedRef, "data-test-id": dataTestId, "data-uds-child": "aspect-ratio", className: (0,twind.tw)(ratioClassName, className), ...rest }));
});
AspectRatio.displayName = 'AspectRatio';

/**
 *
 * A single thumbnail button for the CarouselThumbViewport component.
 *
 * @example
 *
 * ```tsx
 * <CarouselRoot>
 *   <CarouselViewport>
 *   </CarouselViewport>
 *   <CarouselThumbList>
 *    <CarouselThumb size="sm" ratio="wide"><img/></CarouselThumb>
 *  </CarouselThumbList ratio={1}>
 * </CarouselRoot>
 * ```
 */
const CarouselThumb = ({ size = 'base', ratio = 1, grayscale = true, invert, children, active, ...rest }) => {
    const buttonSize = useResponsiveProp(size, value => `w-${THUMB_SIZE$2[value]} h-${THUMB_SIZE$2[value]}`);
    const overlayBgColor = invert ? 'rgba(0,0,0,0.4)' : 'rgba(255,255,255,0.4)';
    return (React.createElement("button", { ...rest, tabIndex: active ? 0 : -1, "data-uds-child": "carousel-thumb", "aria-hidden": active ? 'false' : 'true', "aria-selected": active ? 'true' : 'false', className: tw$2(buttonSize, 'relative block', 'flex-none', 'focus:outline-none focus-visible:(ring-offset-1 ring-2)', 'transition-all duration-300', 'border-1 p-px', invert
            ? 'bg-neutral-90 border-neutral-60'
            : 'bg-neutral-10 border-neutral-40', css `
          &[aria-selected='true'] {
            @apply ${invert ? 'border-neutral-0' : 'border-neutral-100'};
          }
          &:hover,
          &:focus-visible {
            @apply ${invert ? 'border-neutral-30' : 'border-neutral-60'};
          }
        `, grayscale &&
            css `
            filter: grayscale(100%);
            &[aria-selected='true'] {
              filter: none;
            }

            &:hover,
            &:focus-visible {
              filter: none;
            }
          `, css `
          &:after {
            position: absolute;
            top: 1px;
            left: 1px;
            right: 1px;
            bottom: 1px;
            content: '';
            display: block;
            opacity: 1;
            background-color: ${overlayBgColor};
          }
          &[aria-selected='true'] {
            &:after {
              opacity: 0;
            }
          }
          &:hover,
          &:focus-visible {
            &:after {
              opacity: 0;
            }
          }
        `) },
        React.createElement(AspectRatio, { ratio: ratio },
            React.createElement("div", { className: tw$2('absolute inset-0 w-full h-full', css `
              & img,
              & video {
                object-fit: cover;
                object-position: center;
                position: absolute;
                inset: 0;
                width: 100%;
                height: 100%;
              }
            `) }, children))));
};

const CollapsibleContext = (0,react.createContext)(null);
const useCollapsibleContext = () => {
    return (0,react.useContext)(CollapsibleContext);
};

const COLLAPSIBLE_VARIANTS = {
    invert: {
        false: 'text-neutral-100 border-neutral-20 bg-neutral-10',
        true: 'text-neutral-0 border-neutral-80 bg-neutral-90',
    },
    fill: {
        false: 'bg-opacity-0',
        true: 'bg-opacity-100',
    },
    outline: {
        false: 'border-0',
        true: 'border-1',
    },
};
const collapsibleRootStyle = (0,style/* style */.oB)({
    variants: COLLAPSIBLE_VARIANTS,
});
const CollapsibleRoot = ({ fill = false, outline = false, invert = false, transition = 'reveal', speed = 'base', open, defaultOpen, onOpenChange, id: propsId, className, dataTestId, ...rest }) => {
    const id = reach_auto_id_useId(propsId);
    const [internalOpen, setInternalOpen] = react.useState(defaultOpen);
    const handleOpenChange = (open) => {
        setInternalOpen(open);
        onOpenChange?.(open);
    };
    return (react.createElement(CollapsibleContext.Provider, { value: {
            id,
            invert,
            transition,
            speed,
            dataTestId,
            open: internalOpen,
        } },
        react.createElement($409067139f391064$export$be92b6f5f03c0fe9, { ...rest, id: id, "data-test-id": dataTestId, "data-uds-child": "collapsible", open: open, defaultOpen: defaultOpen, onOpenChange: handleOpenChange, className: (0,css_css.tw)('w-full leading-[1]', collapsibleRootStyle({ fill, outline, invert }), className) })));
};

const CollapsibleTriggerStyle = (0,style/* style */.oB)({
    variants: {
        hover: {
            bg: '',
            underline: '',
            none: '',
        },
        invert: {
            false: '',
            true: '',
        },
    },
    matches: [
        {
            hover: 'bg',
            invert: 'true',
            use: 'hover:bg-neutral-80 focus-visible:bg-neutral-80',
        },
        {
            hover: 'bg',
            invert: 'false',
            use: 'hover:bg-neutral-20 focus-visible:bg-neutral-20',
        },
        {
            hover: 'underline',
            use: 'focus:outline-none hover:(decoration-underline decoration-1) focus-visible:(decoration-underline decoration-1)',
        },
    ],
});
const CollapsibleTrigger = react.forwardRef(({ className, hover = 'bg', inset = 'none', insetX, insetY, insetTop, insetEnd, insetBottom, insetStart, asChild, ...rest }, ref) => {
    const { invert, dataTestId } = useCollapsibleContext();
    const appliedHover = asChild ? 'none' : hover;
    const wrapProps = asChild
        ? {}
        : {
            asChild: true,
            inset: inset,
            insetX: insetX,
            insetY: insetY,
            insetTop: insetTop,
            insetEnd: insetEnd,
            insetBottom: insetBottom,
            insetStart: insetStart,
        };
    const Wrap = asChild ? react.Fragment : Inset;
    return (react.createElement(Wrap, { ...wrapProps },
        react.createElement($409067139f391064$export$41fb9f06171c75f4, { ...rest, ref: ref, asChild: asChild, "data-uds-child": "collapsible-trigger", "data-test-id": dataTestId ? `${dataTestId}-trigger` : null, "data-invert": invert, className: (0,style.tw)(CollapsibleTriggerStyle({ hover: appliedHover, invert }), !asChild && 'w-full text-left rtl:text-right', !asChild && 'transition-bg duration-[800ms] ease-out', !asChild &&
                'hover:(transition-bg duration-300 ease-out) focus:(transition-bg duration-300 ease-out)', className) })));
});
CollapsibleTrigger.displayName = 'CollapsibleTrigger';

const CollapsibleContent = (props) => {
    const { inset = 'none', insetX, insetY, insetTop, insetEnd, insetBottom, insetStart, className, children, ...rest } = props;
    const { transition, speed, dataTestId } = useCollapsibleContext();
    const animationCss = (0,react.useMemo)(() => {
        const animation = getCollapsibleTransition({
            type: transition,
            speed: speed,
            heightVar: '--radix-collapsible-content-height',
        });
        return style/* css */.iv `
      &[data-state='open'] {
        ${animation.in}
      }

      &[data-state='closed'] {
        ${animation.out}
      }

      @media (prefers-reduced-motion) {
        &[data-state='open'] {
          animation: none;
        }

        &[data-state='closed'] {
          animation: none;
        }
      }
    `;
    }, [transition, speed]);
    return (react.createElement($409067139f391064$export$7c6e2c02157bb7d2, { ...rest, "data-uds-child": "collapsible-content", "data-test-id": dataTestId ? `${dataTestId}-content` : null, className: (0,twind.tw)(className, 'overflow-hidden', animationCss) },
        react.createElement(Inset, { inset: inset, insetX: insetX, insetY: insetY, insetTop: insetTop, insetEnd: insetEnd, insetBottom: insetBottom, insetStart: insetStart }, children)));
};

const CollapsibleChevron = (props) => {
    const { open } = useCollapsibleContext();
    return (react.createElement(ToggleChevron, { ...props, open: open, "data-uds-child": "collapsible-chevron" }));
};

/**
 * Render and control a list of panels, and display one panel of content at a time
 *
 * @example
 * ```tsx
 * <TabsRoot defaultValue="1" activationMode={"automatic" | "manual"}>
 *  <TabsList bleed>
 *    <TabsTrigger size="lg" value="1">One</TabsTrigger>
 *    <TabsTrigger size="lg" value="2">Two</TabsTrigger>
 *   </TabsList>
 *   <TabsContent value="1">Content 1</TabsContent>
 *   <TabsContent value="2">Content 2</TabsContent>
 * </TabsRoot>
 * ```
 */
const TabsRoot = (props) => {
    const { dataTestId, activationMode = 'manual', children, ...rest } = props;
    return (React.createElement(RadixTabs.Root, { "data-uds-child": "tabs", "data-test-id": dataTestId, activationMode: activationMode, ...rest }, children));
};
/**
 * Render and control a list of panels, and display one panel of content at a time
 *
 * @example
 * ```tsx
 * <TabsRoot defaultValue="1">
 *  <TabsList>
 *    <TabsTrigger value="1">One</TabsTrigger>
 *    <TabsTrigger value="2">Two</TabsTrigger>
 *   </TabsList>
 *   <TabsContent value="1">Content 1</TabsContent>
 *   <TabsContent value="2">Content 2</TabsContent>
 * </TabsRoot>
 * ```
 */
const TabsList = (props) => {
    const { bleed, className, ...rest } = props;
    return (React.createElement(RadixTabs.List, { ...rest, "data-uds-child": "tabs-list", className: tw$2(bleed
            ? 'w-full flex children:(flex flex-1)'
            : 'w-auto flex children:(flex flex-none max-w-content)', className) }));
};
const SizeVariants = {
    sm: 'text-sm min-h-8 px-3',
    base: 'text-base min-h-10 px-4',
    lg: 'text-lg min-h-14 px-6',
};
/**
 * Render a button that controls a tap panel. The value prop is required
 *
 * @example
 * ```tsx
 * <TabsRoot defaultValue="1">
 *  <TabsList>
 *    <TabsTrigger value="1">One</TabsTrigger>
 *    <TabsTrigger value="2">Two</TabsTrigger>
 *   </TabsList>
 *   <TabsContent value="1">Content 1</TabsContent>
 *   <TabsContent value="2">Content 2</TabsContent>
 * </TabsRoot>
 * ```
 */
const TabsTrigger = (props) => {
    const { children, size = 'base', invert, className, ...rest } = props;
    const sizeClassName = useResponsiveProp(size, value => SizeVariants[value]);
    return (React.createElement(RadixTabs.TabsTrigger, { ...rest, "data-uds-child": "tabs-trigger", className: tw$2('relative whitespace-nowrap rounded-sm', 'flex items-center justify-center', 'focus:outline-none', 'focus-visible:(ring-2)', invert ? 'text-neutral-0' : 'text-neutral-100', sizeClassName, css `
          & > [data-uds-child='tabs-trigger-outline'] {
            display: none;
          }
          &:focus-visible > [data-uds-child='tabs-trigger-outline'] {
            display: block;
          }
        `, invert
            ? css `
              & > [data-uds-child='tabs-trigger-underline'] {
                @apply bg-neutral-70;
              }
              &[data-state='active'] {
                @apply font-bold;
                & > [data-uds-child='tabs-trigger-underline'] {
                  @apply bg-neutral-0;
                }
              }
            `
            : css `
              & > [data-uds-child='tabs-trigger-underline'] {
                @apply bg-neutral-30;
              }
              &[data-state='active'] {
                @apply font-bold;
                & > [data-uds-child='tabs-trigger-underline'] {
                  @apply bg-neutral-100;
                }
              }
            `, className) },
        children,
        React.createElement("div", { className: "block w-full h-0.5 absolute left-0 bottom-0", "data-uds-child": "tabs-trigger-underline" }),
        React.createElement("div", { className: tw$2('border-1 block absolute inset-0 rounded-sm', invert ? 'border-neutral-0' : 'border-neutral-100'), "data-uds-child": "tabs-trigger-outline" })));
};
/**
 * Render content panels that are controlled by TabsTrigger
 *
 * @example
 * ```tsx
 * <TabsRoot defaultValue="1">
 *  <TabsList>
 *    <TabsTrigger value="1">One</TabsTrigger>
 *    <TabsTrigger value="2">Two</TabsTrigger>
 *   </TabsList>
 *   <TabsContent value="1">Content 1</TabsContent>
 *   <TabsContent value="2">Content 2</TabsContent>
 * </TabsRoot>
 * ```
 */
const TabsContent = (props) => {
    const { className, ...rest } = props;
    return (React.createElement(RadixTabs.Content, { ...rest, "data-uds-child": "tabs-content", className: tw$2(className, css `
          &:focus-visible {
            outline-offset: 6px;
          }
        `) }));
};

/**
 * Shared input label component. Renders a `label` tag and is reused on all inputs.
 */
const InputLabel = ({ htmlFor, children, invert, required, optional, className, ...rest }) => {
    const t = (0,esm/* useUdsTranslate */.oG)();
    const style = (0,twind.tw)('flex font-bold text-xs uppercase', invert ? 'text-white' : 'text-neutral-100');
    return (react.createElement("label", { className: (0,twind.tw)(className, style), htmlFor: htmlFor, ...rest },
        children,
        required ? (react.createElement("div", { "data-uds-child": "asterisk-required", "aria-hidden": true, className: "text-error ml-1 rtl:mr-1" },
            ' ',
            "*")) : null,
        !required && optional ? (react.createElement("div", { "aria-hidden": true, "data-uds-child": "label-optional", className: (0,twind.tw)('ml-1 rtl:mr-1 font-normal normal-case', invert ? 'text-neutral-40' : 'text-neutral-60') },
            ' ',
            "(",
            t('optional'),
            ")")) : null));
};

const ErrorText = ({ children, invert, ...rest }) => {
    const className = (0,twind.tw)('text-sm', invert ? 'text-error-40' : 'text-error-60');
    return (react.createElement("p", { className: className, ...rest }, children));
};
const SupportTextContainer = ({ id, dataTestId, children, }) => (react.createElement("div", { id: id, "data-test-id": dataTestId }, children));
const SupportText = ({ invert, children, ...rest }) => {
    const style = (0,twind.tw)('text-sm', invert ? 'text-white' : 'text-neutral-100');
    return (react.createElement("p", { className: style, ...rest }, children));
};
const InputWrapper = ({ dataTestIdPrefix, childId, supportText, label, srOnlyLabel, srOnlyDescription, errorText, showLabel, minMaxText, invert, required, optional, children, className, ...rest }) => {
    const labelClass = showLabel === false ? 'sr-only' : '';
    return (react.createElement("div", { "data-test-id": dataTestIdPrefix ? `${dataTestIdPrefix}-wrapper` : null, ...rest, className: (0,twind.tw)('w-full', className) },
        react.createElement("div", { className: "flex justify-between" }, label && (react.createElement(InputLabel, { id: `${childId}-label`, htmlFor: childId, className: labelClass, invert: invert, required: required, optional: optional, "data-test-id": dataTestIdPrefix ? `${dataTestIdPrefix}-label` : null },
            react.createElement("span", { "data-label": "visible", "aria-hidden": srOnlyLabel ? 'true' : 'false' }, label),
            srOnlyLabel && (react.createElement("span", { "data-uds-child": "sr-only-label", className: "sr-only" },
                ' ',
                srOnlyLabel))))),
        children,
        react.createElement(LiveRegion, { id: errorText?.id, type: "polite" }, errorText?.text ? (react.createElement(ErrorText, { "data-uds-child": "error-text", "data-test-id": dataTestIdPrefix ? `${dataTestIdPrefix}-error` : undefined, invert: invert }, errorText?.text)) : null),
        supportText && !errorText?.text ? (react.createElement(SupportTextContainer, { id: supportText.id },
            react.createElement(SupportText, { "data-uds-child": "support-text", "data-test-id": dataTestIdPrefix ? `${dataTestIdPrefix}-support` : undefined, invert: invert }, supportText.text))) : null,
        srOnlyDescription ? (react.createElement("p", { className: "sr-only", "data-uds-child": "sr-only-description", id: `${childId}_sr-description`, "data-test-id": dataTestIdPrefix ? `${dataTestIdPrefix}-sr-description` : undefined }, srOnlyDescription)) : null,
        minMaxText?.id ? (react.createElement(LiveRegion, { id: minMaxText.id, type: "polite" },
            react.createElement("p", { className: "sr-only", "data-test-id": dataTestIdPrefix ? `${dataTestIdPrefix}-minmax` : undefined }, minMaxText.text))) : null));
};

const useInputDivStyle = ({ error, disabled, invert, hasSlot, descriptionText, showLabel, }) => {
    const wrapperStyle = (0,twind.tw)('w-full inline-flex items-center border-1 text-base rounded-sm relative', disabled && 'cursor-not-allowed', error && 'border-error border-2', error && invert && 'border-error-40', disabled
        ? invert
            ? 'text-neutral-30 bg-neutral-80 border-neutral-80 hover:border-neutral-80'
            : 'text-neutral-70 border-neutral-20 bg-neutral-20 hover:border-neutral-20'
        : invert
            ? 'text-white bg-neutral-100 border-neutral-50 focus-within:(border-white ring) hover:(border-white)'
            : 'text-neutral-100 bg-white border-neutral-80 focus-within:(border-neutral-100 ring) hover:(border-neutral-100)', descriptionText && 'mb-2', showLabel && 'mt-2');
    const inputStyle = (0,twind.tw)('w-full h-14 bg-transparent px-3 relative focus:outline-none', hasSlot && 'pr-12 rtl:pl-12', disabled && 'cursor-not-allowed', (0,style/* css */.iv)({
        '&::placeholder': {
            '@apply': 'text-neutral-60',
        },
        '&:-webkit-autofill, &:-webkit-autofill:hover, &:-webkit-autofill:focus': {
            '-webkit-text-fill-color': `${invert ? 'white' : 'black'} `,
            '-webkit-box-shadow': '0 0 0px 1000px transparent inset',
            transition: 'background-color 5000s ease-in-out 0s',
        },
    }));
    const prefixSuffixStyles = (0,twind.tw)('px-3 h-full flex items-center', disabled
        ? invert
            ? 'bg-neutral-80 border-neutral-70'
            : 'bg-neutral-20 border-neutral-30'
        : invert
            ? 'text-neutral-50 bg-neutral-100 border-neutral-50'
            : 'text-neutral-60 bg-white border-neutral-60');
    return { wrapperStyle, inputStyle, prefixSuffixStyles };
};

const useMinMaxLength = ({ minLength, maxLength, value, }) => {
    const [minMaxText, setMinMaxText] = (0,react.useState)();
    const [length, setLength] = (0,react.useState)();
    const t = (0,esm/* useUdsTranslate */.oG)();
    (0,react.useEffect)(() => {
        setLength(String(value)?.length);
    }, [value]);
    (0,react.useEffect)(() => {
        const generateSrOnlyText = () => {
            if (!length) {
                return;
            }
            if (maxLength !== undefined || minLength !== undefined) {
                if (minLength !== undefined && minLength - length > 0) {
                    return `${t('genericFieldMinLength', {
                        length: minLength,
                    })}`;
                }
                else if (maxLength !== undefined && maxLength - length >= 0) {
                    return `${t('charactersRemaining', {
                        num: maxLength - length,
                    })}`;
                }
            }
        };
        if (minLength || maxLength) {
            const text = generateSrOnlyText();
            setMinMaxText(text);
        }
    }, [length, minLength, maxLength]);
    return minMaxText;
};

const ErrorIcon = ({ disabled, invert, size = '2xl', ...props }) => {
    const iconStyle = (0,twind.tw)('flex-shrink-0', invert ? 'text-error-40' : 'text-error-60', disabled && 'text-neutral-60', invert && disabled && 'text-neutral-50');
    return (react.createElement(Icon, { name: "exclamation-filled", className: iconStyle, size: size, ...props }));
};

const inputIconDivStyle = (0,style/* style */.oB)({
    base: `absolute right-1.5 rtl:right-auto rtl:left-1.5 gap-2 grid grid-flow-col auto-cols-fr justify-items-center items-center pr-2 rtl:(pl-2 pr-0)`,
    variants: {
        right: {
            sm: 'right-1 rtl:right-auto rtl:left-1',
            base: 'right-1.5 rtl:right-auto rtl:left-1.5',
            lg: 'right-2 rtl:right-auto rtl:left-2',
        },
        position: {
            top: 'top-3',
        },
    },
});
const inputSlotReturnsValue = (inputSlot) => {
    if (!inputSlot) {
        return false;
    }
    return Boolean(inputSlot({}));
};
const useInputIconSlots = ({ invert, disabled, inputSlot, error, right = 'base', position, className, }) => {
    const shouldRenderInputSlot = inputSlotReturnsValue(inputSlot);
    const iconSpace = shouldRenderInputSlot && error
        ? 'w-16'
        : shouldRenderInputSlot
            ? 'w-9'
            : error
                ? 'w-9'
                : 'w-0';
    const divStyle = (0,twind.tw)(inputIconDivStyle({ right, position }), iconSpace, className);
    const slots = !error && !shouldRenderInputSlot ? null : (react.createElement("div", { className: divStyle },
        error && react.createElement(ErrorIcon, { invert: invert, disabled: disabled }),
        shouldRenderInputSlot && inputSlot ? (react.createElement("div", { "data-uds-child": "input-slot" }, inputSlot({ invert, disabled }))) : null));
    return {
        inputIconsSlot: slots,
        shouldRenderInputSlot: shouldRenderInputSlot,
    };
};

const Fieldset = react.forwardRef(function Fieldset(props, forwardRef) {
    const { id, invert, children, errorText, supportText, legend, className, showLegend = true, required, optional, dataTestId, ...rest } = props;
    const t = (0,esm/* useUdsTranslate */.oG)();
    const style = (0,twind.tw)('flex font-bold text-xs uppercase mb-2', invert ? 'text-white' : 'text-neutral-100', !showLegend && 'sr-only');
    return (react.createElement("fieldset", { "data-test-id": dataTestId, ref: forwardRef, className: className, "aria-describedby": `${id}_error ${id}_support`, ...rest },
        react.createElement("legend", { className: style, id: `${id}_legend` },
            legend,
            required && (react.createElement("div", { "aria-hidden": true, className: "text-error ml-1 rtl:mr-1" }, "*")),
            !required && optional ? (react.createElement("div", { "aria-hidden": true, className: (0,twind.tw)('ml-1 rtl:mr-1 font-normal normal-case', invert ? 'text-neutral-40' : 'text-neutral-60') },
                "(",
                t('optional'),
                ")")) : null),
        react.createElement(Stack, { gap: "xs" },
            children,
            supportText && !errorText ? (react.createElement(SupportTextContainer, { id: `${id}_support` },
                react.createElement(SupportText, { invert: invert, "data-test-id": dataTestId ? `${dataTestId}-support` : undefined }, supportText))) : null,
            react.createElement(LiveRegion, { id: `${id}_error`, type: "polite", atomic: true }, errorText && (react.createElement(ErrorText, { invert: invert, "data-test-id": dataTestId ? `${dataTestId}-error` : undefined }, errorText))))));
});

/**
 * Renders and `input` element, along with it's associated label, and support/error messages
 *
 * - Receives all the standard HTML `input` props
 *
 * @example
 * ```
 * <InputText
 *   required
 *   label="First Name"
 *   errorText="Field is required"
 * />
 * ```
 */
const InputText = react.forwardRef(function InputText(props, forwardRef) {
    const { id: propsId, dataTestId, name, disabled, children, error, errorText, showErrorIcon = true, supportText, className, label, srOnlyLabel, srOnlyDescription, prefix, suffix, invert, required, optional, type, autoComplete, minLength, maxLength, value, placeholder, onChange, inputSlot, defaultValue, showLabel = true, ...rest } = props;
    const id = reach_auto_id_useId(propsId);
    const shouldRenderErrorIcon = Boolean(showErrorIcon && (error || errorText));
    const inputRef = (0,react.useRef)(null);
    const ref = (0,esm/* useSharedRef */.lD)(forwardRef, inputRef);
    const slotClassName = suffix && 'mr-11 rtl:(ml-11)';
    const { inputIconsSlot, shouldRenderInputSlot } = useInputIconSlots({
        error: shouldRenderErrorIcon,
        inputSlot,
        invert,
        disabled,
        className: slotClassName,
    });
    const [uncontrolledValue, setUncontrolledValue] = (0,react.useState)(null);
    const descriptionIds = {
        error: `${id}_error`,
        support: `${id}_support`,
        minMax: `${id}_length`,
    };
    const minMaxText = useMinMaxLength({
        minLength,
        maxLength,
        value: value ?? uncontrolledValue,
    });
    const { wrapperStyle, inputStyle, prefixSuffixStyles } = useInputDivStyle({
        error: error || errorText ? true : false,
        disabled,
        invert,
        showLabel,
        hasSlot: shouldRenderInputSlot,
        descriptionText: Boolean(supportText || errorText),
    });
    const inputTextStyle = `pl-3 rtl:(pr-3)`;
    const inputWrapperProps = {
        childId: id,
        label,
        showLabel,
        srOnlyLabel,
        srOnlyDescription,
        supportText: {
            text: supportText,
            id: descriptionIds.support,
        },
        errorText: {
            text: errorText || undefined,
            id: descriptionIds.error,
        },
        minMaxText: {
            text: minMaxText,
            id: descriptionIds.minMax,
        },
        invert,
        required: required,
        optional: optional,
        dataTestIdPrefix: dataTestId,
        className,
    };
    const handleOnChange = (e) => {
        if (props.autoCapitalize && props.autoCapitalize !== 'off') {
            e.target.value = e.target.value.toUpperCase();
        }
        if (onChange) {
            onChange(e);
        }
        setUncontrolledValue(e.target.value);
    };
    const describedBySrOnly = srOnlyDescription ? `${id}_sr-description ` : '';
    return (react.createElement(react.Fragment, null,
        react.createElement(InputWrapper, { ...inputWrapperProps },
            react.createElement("div", { className: (0,style.tw)(wrapperStyle, 'h-14') },
                prefix && (react.createElement("div", { "data-uds-child": "prefix", "aria-hidden": "true", className: (0,style.tw)(prefixSuffixStyles, 'flex-none border-r-1 rtl:(border-r-0 border-l-1)') }, prefix)),
                react.createElement("input", { id: id, "data-test-id": dataTestId, ref: ref, type: type || 'text', name: name, disabled: disabled, required: required, className: (0,style.tw)(inputStyle, inputTextStyle), "aria-describedby": `${descriptionIds.error} ${descriptionIds.support} ${describedBySrOnly}${descriptionIds.minMax}`, "aria-invalid": error || errorText ? 'true' : 'false', autoComplete: autoComplete, minLength: minLength, maxLength: maxLength, placeholder: placeholder, onChange: handleOnChange, defaultValue: defaultValue, value: value, ...rest }),
                suffix && (react.createElement("div", { "aria-hidden": "true", "data-uds-child": "suffix", className: (0,style.tw)(prefixSuffixStyles, 'flex-none border-l-1 rtl:(border-l-0 border-r-1)') }, suffix)),
                inputIconsSlot))));
});

const InputPassword = react.forwardRef(function InputPassword(props, forwardRef) {
    const [showPassword, setShowPassword] = react.useState(false);
    const t = (0,esm/* useUdsTranslate */.oG)();
    return (react.createElement(InputText, { ref: forwardRef, ...props, type: showPassword ? 'text' : 'password', inputSlot: ({ invert, disabled }) => (react.createElement(ButtonCta, { "data-uds-child": "toggle-password", dataTestId: props.dataTestId ? `${props.dataTestId}-toggle-password` : undefined, label: showPassword ? t('hidePassword') : t('showPassword'), icon: showPassword ? 'eye-closed' : 'eye-open', mode: "icon", variant: "ghost", onClick: () => setShowPassword(!showPassword), role: "switch", "aria-pressed": showPassword, invert: invert, dimmed: disabled })) }));
});

/**
 * Renders and `input` element, along with it's associated label, and support/error messages
 *
 * - Receives all the standard HTML `input` props
 *
 * @example
 * ```
 * <InputTextArea
 *   required
 *   size="lg"
 *   label="First Name"
 *   errorText="Field is required"
 * />
 * ```
 */
const InputTextArea = react.forwardRef(function InputText(props, forwardRef) {
    const { id: propsId, dataTestId, name, disabled, children, error, errorText, showErrorIcon = true, supportText, className, label, srOnlyLabel, srOnlyDescription, showLabel = true, invert, required, optional, autoComplete, minLength, maxLength, value, placeholder, onChange, size = 'base', inputSlot, ...rest } = props;
    const id = reach_auto_id_useId(propsId);
    const shouldRenderErrorIcon = Boolean(showErrorIcon && (error || errorText));
    const inputRef = (0,react.useRef)(null);
    const ref = (0,esm/* useSharedRef */.lD)(forwardRef, inputRef);
    const { inputIconsSlot, shouldRenderInputSlot } = useInputIconSlots({
        error: shouldRenderErrorIcon,
        inputSlot,
        invert,
        disabled,
        position: 'top',
    });
    const [uncontrolledValue, setUncontrolledValue] = (0,react.useState)();
    const descriptionIds = {
        error: `${id}_error`,
        support: `${id}_support`,
        minMax: `${id}_length`,
    };
    const minMaxText = useMinMaxLength({
        minLength,
        maxLength,
        value: value ?? uncontrolledValue,
    });
    const { wrapperStyle, inputStyle } = useInputDivStyle({
        error: error || errorText ? true : false,
        disabled,
        invert,
        showLabel,
        descriptionText: Boolean(supportText || errorText),
    });
    const inputTextAreaStyle = (0,style.tw)('h-auto resize-none py-3', shouldRenderInputSlot && 'pr-8 rtl:(pl-8 pr-0)');
    const rowSize = size === 'sm' ? 2 : size === 'base' ? 4 : 6;
    const inputWrapperProps = {
        childId: id,
        label,
        srOnlyLabel,
        srOnlyDescription,
        showLabel,
        required: required,
        optional: optional,
        supportText: {
            text: supportText,
            id: descriptionIds.support,
        },
        errorText: {
            text: errorText || undefined,
            id: descriptionIds.error,
        },
        minMaxText: {
            text: minMaxText,
            id: descriptionIds.minMax,
        },
        invert,
        dataTestIdPrefix: dataTestId,
        className,
    };
    const describedBySrOnly = srOnlyDescription ? `${id}_sr-description ` : '';
    const handleOnChange = (e) => {
        if (onChange) {
            onChange(e);
        }
        setUncontrolledValue(e.target.value);
    };
    return (react.createElement(InputWrapper, { ...inputWrapperProps },
        react.createElement("div", { className: (0,style.tw)(wrapperStyle) },
            react.createElement("textarea", { id: id, name: name, ref: ref, disabled: disabled, "data-test-id": dataTestId, required: required, className: (0,style.tw)(inputStyle, inputTextAreaStyle), "aria-describedby": `${descriptionIds.error} ${descriptionIds.support} ${describedBySrOnly}${descriptionIds.minMax}`, "aria-invalid": error || errorText ? 'true' : 'false', autoComplete: autoComplete, minLength: minLength, maxLength: maxLength, placeholder: placeholder, value: value, rows: rowSize, onChange: handleOnChange, ...rest }),
            inputIconsSlot)));
});

/**
 * InputCheckbox renders a label, and within an input of `type=checkbox`.
 * The children of the component, are part of the label
 */
const InputCheckbox = react.forwardRef(function InputCheckbox(props, forwardRef) {
    const { id: propsId, disabled, children, invert, className, dataTestId, ...rest } = props;
    const id = reach_auto_id_useId(propsId);
    const inputRef = (0,react.useRef)(null);
    const ref = (0,esm/* useSharedRef */.lD)(forwardRef, inputRef);
    const styles = {
        checkboxWrapper: (0,style.tw)('relative flex group', disabled ? 'cursor-not-allowed' : 'cursor-pointer', className),
        checkButton: (0,style.tw)('relative block text-lg w-5 h-5 border-2 rounded-sm flex-none mt-0.5 mr-4 rtl:mr-0 rtl:ml-4', invert && !disabled && 'text-neutral-100', invert && disabled && 'text-neutral-50', !invert && disabled && 'text-neutral-60', !invert && !disabled && 'border-neutral-60 text-white', `group-hover:(${invert ? 'border-neutral-20' : 'border-neutral-80'})`),
        checkIndicator: (0,style.tw)('w-4 h-4 absolute left-1/2 top-1/2 -translate-y-1/2 -translate-x-1/2 w-full', (0,style/* css */.iv)({
            display: 'none',
        })),
        input: (0,style.tw)('opacity-0 absolute left-0 top-0 w-full h-full', disabled ? 'cursor-not-allowed' : 'cursor-pointer', (0,style/* css */.iv)({
            '&:focus + [data-uds-child="indicator"]': {
                '@apply': `ring-3 border-neutral-80 ${invert && 'ring-invert border-white'}`,
            },
            '&:checked + [data-uds-child="indicator"]': {
                '@apply': `${invert ? 'bg-white border-white' : 'bg-black border-neutral-100'}`,
                span: {
                    display: 'block',
                },
            },
            '&:disabled + [data-uds-child="indicator"]': {
                '@apply': `${invert
                    ? 'bg-neutral-80 border-neutral-50'
                    : 'bg-neutral-20 border-neutral-60'}`,
            },
        })),
        inputLabel: (0,style.tw)('text-base flex-1', disabled && `${invert ? 'text-neutral-50' : 'text-neutral-60'}`, invert && 'text-white'),
    };
    return (react.createElement("label", { htmlFor: id, className: styles.checkboxWrapper, "data-test-id": dataTestId },
        react.createElement("input", { className: styles.input, id: id, ref: ref, type: "checkbox", "data-uds-child": "checkbox", "data-test-id": dataTestId ? `${dataTestId}-checkbox` : undefined, disabled: disabled, ...rest }),
        react.createElement("div", { "data-uds-child": "indicator", "aria-hidden": true, className: styles.checkButton },
            react.createElement("span", { className: styles.checkIndicator },
                react.createElement(Icon, { name: "check" }))),
        children && (react.createElement("div", { "data-uds-child": "children", className: styles.inputLabel }, children))));
});

/**
 * InputRadio renders a label, and within an input of `type=radio`.
 * The children of the component, are part of the label
 */
const InputRadio = react.forwardRef(function InputRadio(props, forwardRef) {
    const { id: propsId, disabled, children, className, invert, dataTestId, ...rest } = props;
    const id = reach_auto_id_useId(propsId);
    const inputRef = (0,react.useRef)(null);
    const ref = (0,esm/* useSharedRef */.lD)(forwardRef, inputRef);
    const styles = {
        checkboxWrapper: (0,style.tw)('relative flex group', disabled ? 'cursor-not-allowed' : 'cursor-pointer', className),
        checkButton: (0,style.tw)('relative block text-lg w-5 h-5 rounded-full border-2 flex-none mt-0.5 mr-4 rtl:mr-0 rtl:ml-4', invert && !disabled && 'text-white', invert && disabled && 'text-neutral-50', !invert && disabled && 'text-neutral-60', !invert && !disabled && 'border-neutral-60 text-black', `group-hover:(${invert ? 'border-neutral-20' : 'border-neutral-80'})`),
        checkIndicator: (0,style.tw)('absolute left-1/2 top-1/2 -translate-y-1/2 -translate-x-1/2 w-full p-0.5 hidden'),
        input: (0,style.tw)('opacity-0 absolute left-0 top-0 w-full h-full', disabled ? 'cursor-not-allowed' : 'cursor-pointer', (0,style/* css */.iv)({
            '&:focus + [data-uds-child="indicator"]': {
                '@apply': `ring border-neutral-80 ${invert && 'ring-invert border-white'}`,
            },
            '&:checked + [data-uds-child="indicator"]': {
                '@apply': `${invert ? 'bg-black border-white' : 'bg-white border-neutral-100'}`,
                span: {
                    display: 'block',
                },
            },
            '&:disabled + [data-uds-child="indicator"]': {
                '@apply': `${invert
                    ? 'bg-neutral-80 border-neutral-50'
                    : 'bg-neutral-20 border-neutral-60'}`,
            },
        })),
        inputLabel: (0,style.tw)('text-base flex-1', disabled && `${invert ? 'text-neutral-50' : 'text-neutral-60'}`, invert && 'text-white'),
    };
    return (react.createElement("label", { "data-test-id": dataTestId, htmlFor: id, className: styles.checkboxWrapper },
        react.createElement("input", { id: id, className: styles.input, ref: ref, type: "radio", disabled: disabled, "data-uds-child": "radio", "data-test-id": dataTestId ? `${dataTestId}-radio` : undefined, ...rest }),
        react.createElement("div", { "aria-hidden": true, className: styles.checkButton, "data-uds-child": "indicator" },
            react.createElement("span", { className: styles.checkIndicator },
                react.createElement(IndicatorRadio, null))),
        children && (react.createElement("div", { "data-uds-child": "children", className: styles.inputLabel }, children))));
});
const IndicatorRadio = () => {
    return (react.createElement("svg", { viewBox: "0 0 24 24" },
        react.createElement("circle", { r: 10, cx: 12, cy: 12, fill: "currentColor" })));
};

const ListBoxItem = (props) => {
    return (react.createElement("li", { role: "option", id: `${props.name}-option-${props.id}`, value: props.value, "data-index": props.index, "aria-selected": props.selected, className: (0,twind.tw)('flex items-center w-full px-2 py-1', props.className) },
        react.createElement("span", { className: (0,twind.tw)('flex-1', props.selected && 'font-bold') }, props.value),
        props.selected ? react.createElement(Icon, { size: "2xl", name: "check" }) : null));
};
const ListBox = react.forwardRef(function ListBox(props, forwardRef) {
    return (react.createElement("ul", { ref: forwardRef, id: `listbox-${props.id}`, role: "listbox", tabIndex: -1, "aria-labelledby": `${props.id}-label`, className: (0,twind.tw)(props.hidden && 'hidden', props.className, 'border-1 overflow-auto w-full '), "aria-hidden": props.hidden }, props.options?.map((option, i) => (react.createElement(ListBoxItem, { key: option.value, index: i, id: option.id, value: option.value, name: props.id, selected: option.value === props.currentValue })))));
});
const getOptionElements = (node) => {
    if (!node)
        return [];
    const nodelist = node.querySelectorAll('li');
    const targets = Array.prototype.slice.call(nodelist);
    return targets;
};
function useCombobox(inputRef, params) {
    const { onOptionSelect, typeahead, filter } = params;
    const keypress = (0,react.useRef)('');
    const listboxRef = (0,react.useRef)(null);
    const keypressTimeout = (0,react.useRef)();
    const mouseMoveTimeout = (0,react.useRef)();
    const hideListboxTimeout = (0,react.useRef)();
    const [isActive, setActive] = (0,react.useState)(false);
    const [isExpanded, setExpanded] = (0,react.useState)(false);
    const [currentValue, setCurrentValue] = (0,react.useState)(null);
    const [activeDescendant, setActiveDescendant] = (0,react.useState)(-1);
    const [options, setOptions] = (0,react.useState)([]);
    const defaultFilter = (value) => {
        if (value && params.options) {
            const filteredOptions = params.options.filter(option => option.value
                .toString()
                .toLowerCase()
                .startsWith(value.toLowerCase().trim()));
            return setOptions(filteredOptions);
        }
        setOptions(params.options ?? []);
    };
    const filterOptions = (value) => {
        if (filter === true && params.options) {
            defaultFilter(value);
        }
        else if (typeof filter === 'function') {
            filter({
                value: value,
                setOptions: setOptions,
            });
        }
    };
    (0,react.useEffect)(() => {
        setOptions(params.options || []);
    }, [params.options]);
    const arrowRef = inputRef.current?.parentElement?.querySelector(`#action_${params.id}`);
    (0,react.useEffect)(() => {
        if (params.typeahead !== true) {
            inputRef.current?.removeAttribute('aria-autocomplete');
            inputRef.current?.setAttribute('readonly', 'true');
        }
        else {
            inputRef.current?.setAttribute('aria-autocomplete', 'list');
        }
        inputRef.current?.setAttribute('type', 'text');
        inputRef.current?.setAttribute('autocomplete', 'off');
        inputRef.current?.setAttribute('autocorrect', 'off');
        inputRef.current?.setAttribute('spellcheck', 'false');
        inputRef.current?.setAttribute('role', 'combobox');
        inputRef.current?.setAttribute('aria-haspopup', 'listbox');
    }, [params.id, params.typeahead]);
    (0,react.useEffect)(() => {
        if (isExpanded) {
            inputRef.current?.setAttribute('aria-controls', `listbox-${params.id}`);
        }
        else {
            inputRef.current?.removeAttribute('aria-controls');
        }
        inputRef.current?.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
    }, [isExpanded]);
    const listbox = (0,react.useMemo)(() => {
        return (react.createElement(ListBox, { hidden: !isExpanded, ref: listboxRef, id: params.id, className: params.classNameListbox, optionClassName: params.classNameListItem, currentValue: currentValue, options: options }));
    }, [listboxRef, currentValue, isExpanded, params.id, options]);
    const showListbox = () => {
        keypress.current = '';
        if (options.length > 0) {
            setCurrentValue(inputRef.current?.value);
            setExpanded(true);
        }
    };
    const hideListbox = () => {
        keypress.current = '';
        setExpanded(false);
        inputRef.current?.removeAttribute('aria-activedescendant');
        setActiveDescendant(-1);
        highlightOption(-1);
        listboxRef.current?.scrollTo({ top: 0 });
    };
    const setDefaultValue = (defaultValue) => {
        if (!inputRef.current)
            return;
        inputRef.current.value = defaultValue ? `${defaultValue}` : '';
        if (isActive) {
            const caretPos = defaultValue ? `${defaultValue}`.length : 0;
            inputRef.current.selectionStart = caretPos;
        }
        setCurrentValue(defaultValue);
    };
    const setSelectedOption = (selectedOptionIndex) => {
        if (!options)
            return;
        if (!inputRef.current)
            return;
        const selectedOption = options[selectedOptionIndex];
        /**
         * This valueSetter, and prototypeValueSetteris needed to fire `onKeyUp` event`
         * inputRef.current.value = selectedOption.label;
         *
         */
        const valueSetter = Object.getOwnPropertyDescriptor(inputRef.current, 'value')?.set;
        const prototype = Object.getPrototypeOf(inputRef.current);
        const prototypeValueSetter = Object.getOwnPropertyDescriptor(prototype, 'value')?.set;
        if (valueSetter && valueSetter !== prototypeValueSetter) {
            prototypeValueSetter?.call(inputRef.current, selectedOption.value);
        }
        else {
            valueSetter?.call(inputRef.current, selectedOption.value);
        }
        inputRef.current.dispatchEvent(new Event('input', { bubbles: true }));
        if (isActive) {
            const caretPos = `${selectedOption.value}`.length;
            inputRef.current.selectionStart = caretPos;
        }
        setCurrentValue(selectedOption.value);
        if (onOptionSelect)
            onOptionSelect(selectedOption);
        hideListboxTimeout.current = setTimeout(() => {
            hideListbox();
        }, 300);
    };
    const hoverClassName = (0,twind.tw)((0,twind/* apply */.nn)(params?.classNameListItemHover));
    const highlightOption = (optionIndex, scrollTo = false) => {
        if (!isActive || !options || !listboxRef.current)
            return;
        const optionElementsList = getOptionElements(listboxRef.current);
        if (activeDescendant >= 0) {
            const currentOptionElement = optionElementsList[activeDescendant];
            if (currentOptionElement) {
                currentOptionElement.classList.remove(hoverClassName);
                currentOptionElement.removeAttribute('data-highlight');
            }
        }
        if (optionIndex < 0)
            return;
        const activeOptionElement = optionElementsList[optionIndex];
        if (!activeOptionElement) {
            inputRef.current?.removeAttribute('aria-activedescendant');
            return;
        }
        activeOptionElement.classList.add(hoverClassName);
        activeOptionElement.setAttribute('data-highlight', 'true');
        const listboxScroll = listboxRef.current?.scrollTop;
        const listboxHeight = listboxRef.current?.getBoundingClientRect().height;
        const elementHeight = activeOptionElement.getBoundingClientRect().height;
        const elementTopPos = activeOptionElement.offsetTop;
        const elementBottomPos = elementTopPos + elementHeight;
        if (elementBottomPos > listboxScroll + listboxHeight)
            listboxRef.current?.scrollTo({
                top: elementBottomPos - listboxHeight,
            });
        if (elementTopPos < listboxScroll)
            listboxRef.current?.scrollTo({
                top: elementTopPos,
            });
        inputRef.current?.setAttribute('aria-activedescendant', `${activeOptionElement.getAttribute('id')}`);
        setActiveDescendant(optionIndex);
    };
    (0,esm/* useIsomorphicLayoutEffect */.LI)(() => {
        if (!params.defaultValue) {
            setDefaultValue('');
            return;
        }
        const selectedOptionIndex = options.findIndex(o => o.id === params.defaultValue || o.value === params.defaultValue);
        if (selectedOptionIndex >= 0) {
            setSelectedOption(selectedOptionIndex);
            return;
        }
        setDefaultValue(params.defaultValue);
    }, [params.defaultValue]);
    (0,react.useEffect)(() => {
        if (isActive && options && options.length > 0) {
            showListbox();
        }
        else {
            hideListbox();
        }
    }, [options]);
    (0,esm/* useIsomorphicLayoutEffect */.LI)(() => {
        const onFocus = (event) => {
            if (event.defaultPrevented) {
                return;
            }
            setCurrentValue(inputRef.current?.value);
            setActive(true);
        };
        const onBlur = (event) => {
            if (event.defaultPrevented) {
                return;
            }
            setActive(false);
            hideListbox();
        };
        const onArrowClick = (event) => {
            event.preventDefault();
            event.stopPropagation();
            setCurrentValue(inputRef.current?.value);
            inputRef.current?.focus();
            if (!isExpanded && options && options.length > 0) {
                showListbox();
            }
            else {
                hideListbox();
            }
        };
        const onClick = (event) => {
            if (event.defaultPrevented) {
                return;
            }
            setCurrentValue(inputRef.current?.value);
            if (params.typeahead === true)
                return;
            if (options && options.length > 0) {
                showListbox();
            }
            else {
                hideListbox();
            }
        };
        const onMouseMove = () => {
            clearTimeout(mouseMoveTimeout.current);
            mouseMoveTimeout.current = setTimeout(() => {
                mouseMoveTimeout.current = undefined;
            }, 500);
        };
        const onOptionHover = (event) => {
            if (!mouseMoveTimeout.current)
                return;
            event.preventDefault();
            event.stopPropagation();
            const hoverElement = event.currentTarget;
            const elementIndex = parseInt(`${hoverElement.dataset.index}`, 10);
            highlightOption(elementIndex);
        };
        const onOptionLeave = (event) => {
            event.preventDefault();
            event.stopPropagation();
            highlightOption(-1);
        };
        const onOptionClick = (event) => {
            event.preventDefault();
            event.stopPropagation();
            const selectedOptionElement = event.currentTarget;
            const selectedOptionIndex = parseInt(`${selectedOptionElement.dataset.index}`, 10);
            setSelectedOption(selectedOptionIndex);
            return false;
        };
        const onKeyUp = (event) => {
            if (!isActive || !options || !listboxRef.current)
                return;
            const target = event.target;
            let activeOption = activeDescendant;
            if ((typeahead && /^(Key|Digit)/.test(event.code)) ||
                event.key == 'Backspace' ||
                event.key === 'Delete') {
                filterOptions(target.value);
            }
            if (!isExpanded) {
                return;
            }
            /**
             * Listbox navigation
             */
            // TODO BACKSPACE
            if (!params.filter && /^(Key|Digit)/.test(event.code)) {
                clearTimeout(keypressTimeout.current);
                if (!typeahead) {
                    keypress.current = keypress.current + event.key;
                }
                else {
                    keypress.current = target?.value || '';
                }
                activeOption = options.findIndex(({ value }) => {
                    return `${value}`
                        .toLowerCase()
                        .startsWith(keypress.current.toLowerCase());
                });
                if (!typeahead) {
                    keypressTimeout.current = setTimeout(() => {
                        keypress.current = '';
                    }, 900);
                }
            }
            highlightOption(activeOption, true);
        };
        const onKeyDown = (event) => {
            if (!isActive || !options || !listboxRef.current)
                return;
            event.target;
            let activeOption = activeDescendant;
            const optionElementsList = getOptionElements(listboxRef.current);
            const totalOptions = optionElementsList.length;
            if (event.key === 'Escape') {
                hideListbox();
                return;
            }
            else if (!isExpanded && event.key === 'Tab') {
                return;
            }
            else if (!isExpanded && event.key === 'Enter') {
                event.preventDefault();
                event.stopPropagation();
                showListbox();
            }
            else if (!isExpanded &&
                (event.key === 'ArrowDown' || event.key === 'ArrowUp')) {
                event.preventDefault();
                event.stopPropagation();
                showListbox();
            }
            const blockKeys = ['ArrowDown', 'ArrowUp', 'PageDown', 'PageUp'];
            if (!isExpanded)
                return;
            if (blockKeys.includes(event.key)) {
                event.preventDefault();
                event.stopPropagation();
            }
            if (event.code === 'Tab') {
                if (activeOption >= 0) {
                    setSelectedOption(activeOption);
                    return;
                }
            }
            if (event.code === 'Space' || event.key === 'Enter') {
                if (activeOption >= 0) {
                    event.preventDefault();
                    event.stopPropagation();
                    setSelectedOption(activeOption);
                    return;
                }
            }
            if (event.key === 'ArrowDown') {
                event.preventDefault();
                event.stopPropagation();
                activeOption += 1;
                if (activeOption >= totalOptions) {
                    activeOption = 0;
                }
            }
            else if (event.key === 'ArrowUp') {
                event.preventDefault();
                event.stopPropagation();
                activeOption -= 1;
                if (activeOption < 0) {
                    activeOption = totalOptions - 1;
                }
            }
            else if (event.key === 'PageDown') {
                event.preventDefault();
                event.stopPropagation();
                activeOption += 10;
                if (activeOption >= totalOptions) {
                    activeOption = totalOptions - 1;
                }
            }
            else if (event.key === 'PageUp') {
                event.preventDefault();
                event.stopPropagation();
                activeOption -= 10;
                if (activeOption < 0) {
                    activeOption = 0;
                }
            }
            else if (event.key === 'Home') {
                event.preventDefault();
                event.stopPropagation();
                activeOption = 0;
            }
            else if (event.key === 'End') {
                event.preventDefault();
                event.stopPropagation();
                activeOption = totalOptions - 1;
            }
            highlightOption(activeOption, true);
        };
        const optionElementsList = listboxRef.current
            ? getOptionElements(listboxRef.current)
            : [];
        for (const item of optionElementsList) {
            item.addEventListener('mouseenter', onOptionHover);
            item.addEventListener('mouseleave', onOptionLeave);
            item.addEventListener('mousedown', onOptionClick);
        }
        arrowRef?.addEventListener('mousedown', onArrowClick);
        inputRef.current?.addEventListener('mousedown', onClick);
        inputRef.current?.addEventListener('keydown', onKeyDown);
        inputRef.current?.addEventListener('keyup', onKeyUp);
        inputRef.current?.addEventListener('focus', onFocus);
        inputRef.current?.addEventListener('blur', onBlur, true);
        document.addEventListener('mousemove', onMouseMove, true);
        return () => {
            clearTimeout(hideListboxTimeout.current);
            arrowRef?.removeEventListener('mousedown', onArrowClick);
            inputRef.current?.removeEventListener('mousedown', onClick);
            inputRef.current?.removeEventListener('keydown', onKeyDown);
            inputRef.current?.removeEventListener('keyup', onKeyUp);
            inputRef.current?.removeEventListener('focus', onFocus);
            inputRef.current?.removeEventListener('blur', onBlur, true);
            document.removeEventListener('mousemove', onMouseMove, true);
            for (const item of optionElementsList) {
                item.removeEventListener('mouseenter', onOptionHover);
                item.removeEventListener('mouseleave', onOptionLeave);
                item.removeEventListener('mousedown', onOptionClick);
            }
        };
    }, [options, activeDescendant, inputRef, isExpanded, isActive, typeahead]);
    return { listbox, isExpanded };
}

const defaultInputSplot = ({ expanded }) => (react.createElement(Icon, { name: expanded ? 'chevron-up' : 'chevron-down', className: "z-40", size: "2xl" }));
/**
 * The `InputCombobox` is a combination of a drop-down list or listbox and a single-line editable textbox,
 * allowing the user to either type a value directly or select a value from the list
 *
 * @example
 * ```
 *
 * <InputCombobox
 *   label="Combobox"
 *   typeahead={true}
 *   defaultValue="Tomato"
 *   options={[...]}
 * />
 *
 * ```
 */
const InputCombobox = react.forwardRef(function InputCombobox(props, forwardRef) {
    const inputRef = (0,react.useRef)(null);
    const { id: propsId, dataTestId, className, options, typeahead, filter, onOptionSelect, defaultValue, inputSlot, value, ...rest } = props;
    const id = reach_auto_id_useId(propsId);
    const { listbox, isExpanded } = useCombobox(inputRef, {
        id: id,
        filter: filter,
        options: options,
        typeahead: typeahead,
        defaultValue: defaultValue,
        onOptionSelect: onOptionSelect,
        classNameListbox: props.invert
            ? 'bg-neutral-100 border-neutral-50 max-h-64 rounded-sm'
            : 'bg-white border-neutral-60 max-h-64 rounded-sm',
        classNameListItem: props.invert ? 'text-white' : 'text-neutral-100',
        classNameListItemHover: props.invert
            ? 'bg-neutral-70 text-white'
            : 'bg-neutral-30 text-neutral-100',
    });
    const ref = (0,esm/* useSharedRef */.lD)(inputRef, forwardRef);
    const handleInputSlot = (props) => {
        return inputSlot
            ? inputSlot({ ...props, expanded: isExpanded })
            : defaultInputSplot({ ...props, expanded: isExpanded });
    };
    return (react.createElement("div", { className: (0,twind.tw)('relative', className) },
        react.createElement(InputText, { ...rest, id: id, ref: ref, type: "text", dataTestId: dataTestId, inputSlot: handleInputSlot }),
        react.createElement("div", { "data-test-id": `${dataTestId}-listbox`, className: "z-[999] absolute top-20 mt-1.5 w-full" }, listbox)));
});

const PLACEHOLDER_VALUE = '';

const SelectContext = (0,react.createContext)(undefined);
/**
 * The `SelectProvider` component provides the select props to all of its children via context.
 *
 * @example
 * ```
 * <SelectProvider value={selectProps}>
 *   <SelectRoot>
 *     <SelectValue />
 *     <SelectHiddenInput />
 *     <SelectChevron />
 *   </SelectRoot>
 * </SelectProvider>
 * ```
 */
const SelectProvider = ({ children, value: contextValue, }) => {
    const { placeholder, defaultValue, value, options } = contextValue;
    if (value && defaultValue) {
        console.error('Select cannot be used as a controlled and uncontrolled component at the same time. Provide either a value or a defaultValue prop, not both.');
    }
    const getDefaultValue = () => {
        // Controlled value takes precedence over default value
        if (value || defaultValue) {
            return String(value || defaultValue);
        }
        // If no value is provided but a placeholder is, we want to show that
        if (placeholder) {
            return PLACEHOLDER_VALUE;
        }
        // Otherwise, show the first option as that is the default behaviour of a native select
        return options[0].value;
    };
    // We control the value of the select with state as it allows us to show a placeholder when no value is selected
    const [internalValue, setInternalValue] = (0,react.useState)(getDefaultValue());
    const displayValue = internalValue === PLACEHOLDER_VALUE
        ? placeholder
        : options.find(option => option.value === internalValue)?.label;
    // Keep local state up-to-date with controlled value
    (0,react.useEffect)(() => {
        if (value && value !== internalValue) {
            setInternalValue(String(value));
        }
    }, [value]);
    return (react.createElement(SelectContext.Provider, { value: {
            ...contextValue,
            // Only use default value if the Select is being used in an uncontrolled manner
            defaultValue: value ? undefined : internalValue,
            value,
            displayValue,
            setValue: setInternalValue,
        } }, children));
};
/**
 * A hook to access the `SelectContext` values.
 */
const useSelectContext = () => {
    const context = (0,react.useContext)(SelectContext);
    if (!context) {
        throw new Error('useSelectContext must be used within a SelectProvider');
    }
    return context;
};

/**
 * The `SelectRoot` component is used to render the wrapping element of the select.
 *
 * @example
 * ```
 * <SelectRoot>
 *   <SelectValue />
 *   <SelectHiddenInput />
 *   <SelectChevron />
 * </SelectRoot>
 * ```
 */
const SelectRoot = ({ className, children, ...rest }) => {
    const { dataTestId } = useSelectContext();
    return (react.createElement("div", { className: (0,twind.tw)('relative inline-flex items-center gap-2', className), "data-test-id": dataTestId, ...rest }, children));
};

/**
 * The `SelectValue` component is used to render the placeholder text or selected value.
 *
 * @example
 * ```
 * <SelectValue />
 * ```
 */
const SelectValue = ({ className }) => {
    const { displayValue, dataTestId } = useSelectContext();
    return (react.createElement("span", { className: (0,twind.tw)('flex-1 whitespace-nowrap text-left rtl:text-right', className), "aria-hidden": "true", "data-test-id": dataTestId ? `${dataTestId}-value` : undefined }, displayValue));
};

/**
 * The `SelectHiddenInput` component is the actual select element.
 * The native select is hidden from view but is used to handle the rendering of options and selection.
 * A ref should be passed to this component to allow the parent component to access the select element.
 *
 * @example
 * ```
 * <SelectHiddenInput ref={ref} />
 * ```
 */
const SelectHiddenInput = react.forwardRef(function Select(_, ref) {
    const { id, name, dataTestId, placeholder, options, disabled, invert, required, error, className, defaultValue, value, displayValue, 'aria-describedby': ariaDescribedBy, showErrorIcon, setValue, onChange, ...rest } = useSelectContext();
    const handleOnChange = (e) => {
        const val = e.target.value;
        setValue(val);
        if (onChange)
            onChange(val);
    };
    const selectStyle = (0,twind.tw)('absolute w-full inset-0 opacity-0', // Hide the select so the span above shows the value - this lets the component be either controlled or uncontrolled depending on need.
    'text-neutral-100', // Necessary to ensure the select option text is legible on windows machines.
    disabled ? 'cursor-not-allowed' : 'cursor-pointer');
    return (react.createElement("select", { id: id, name: name, "data-test-id": dataTestId ? `${dataTestId}-input` : undefined, className: selectStyle, defaultValue: defaultValue, value: value, disabled: disabled, "aria-invalid": error ? 'true' : 'false', "aria-describedby": ariaDescribedBy, onChange: handleOnChange, required: required, ref: ref, ...rest },
        placeholder ? (react.createElement("option", { value: PLACEHOLDER_VALUE, disabled: true }, placeholder)) : null,
        options.map(option => (react.createElement("option", { key: option.value, value: option.value, disabled: option.disabled }, option.label)))));
});

/**
 * The `SelectChevron` component renders the chevron icon for a select.
 *
 * @example
 * ```
 * <SelectChevron />
 * ```
 */
const SelectChevron = ({ className = 'flex-shrink-0' }) => {
    const { dataTestId } = useSelectContext();
    return (react.createElement(ToggleChevron, { className: className, "data-test-id": dataTestId ? `${dataTestId}-chevron` : undefined }));
};

const InputSelectInner = react.forwardRef(function InputSelectInner({ label, showLabel, supportText, errorText }, ref) {
    const { error, disabled, invert, placeholder, displayValue, dataTestId } = useSelectContext();
    const { wrapperStyle } = useInputDivStyle({
        error,
        disabled,
        invert,
        descriptionText: Boolean(errorText || supportText),
        showLabel,
    });
    const isPlaceholder = displayValue === placeholder || displayValue === label;
    let valueColor = '';
    if (isPlaceholder && disabled) {
        valueColor = invert ? 'text-neutral-30' : 'text-neutral-70';
    }
    else if (isPlaceholder && !disabled) {
        valueColor = invert ? 'text-neutral-40' : 'text-neutral-60';
    }
    return (react.createElement(SelectRoot, { className: (0,twind.tw)(wrapperStyle, 'h-14 pl-3 pr-4') },
        react.createElement(SelectValue, { className: (0,twind.tw)('text-base truncate', valueColor) }),
        react.createElement(SelectHiddenInput, { ref: ref }),
        error && (react.createElement(ErrorIcon, { invert: invert, disabled: disabled, dataTestId: dataTestId ? `${dataTestId}-error-icon` : undefined })),
        react.createElement(SelectChevron, null)));
});
/**
 * The `InputSelect` renders a styled `select` tag and is used to create a drop-down list.
 * It is most often used in a form, to collect user input.
 *
 * @example
 * ```
 * <InputSelect
 *   label="Options"
 *   placeholder="Select an option"
 *   options={[ { value: "optionOne", label: "Option One" } ]}
 *   defaultValue="optionOne"
 * />
 *
 * ```
 */
const InputSelect = react.forwardRef(function InputSelect({ id: propsId, name, value, defaultValue, dataTestId, label, placeholder, options, disabled, invert, required, optional, className, error, errorText, supportText, showLabel = true, showErrorIcon = true, srOnlyLabel, srOnlyDescription, 'aria-describedby': ariaDescribedBy, onChange, onBlur, }, ref) {
    const id = reach_auto_id_useId(propsId);
    const descriptionIds = {
        error: `${id}_error`,
        support: `${id}_support`,
    };
    const inputWrapperProps = {
        label,
        childId: id,
        dataTestIdPrefix: dataTestId,
        supportText: supportText && descriptionIds?.support
            ? {
                text: supportText,
                id: descriptionIds.support,
            }
            : undefined,
        errorText: {
            text: errorText || undefined,
            id: descriptionIds.error,
        },
        required: required,
        optional: optional,
        invert,
        showLabel,
        className,
        srOnlyLabel,
        srOnlyDescription,
    };
    return (react.createElement(InputWrapper, { ...inputWrapperProps },
        react.createElement(SelectProvider, { value: {
                id,
                name,
                value,
                defaultValue,
                dataTestId,
                invert,
                options,
                placeholder,
                disabled,
                onChange,
                onBlur,
                required,
                showErrorIcon,
                'aria-describedby': ariaDescribedBy ||
                    `${descriptionIds.error}  ${descriptionIds.support}`,
                error: Boolean(error || errorText),
            } },
            react.createElement(InputSelectInner, { ref: ref, label: label, showLabel: showLabel, supportText: supportText, errorText: errorText }))));
});

const monthNames = [
    'january',
    'february',
    'march',
    'april',
    'may',
    'june',
    'july',
    'august',
    'september',
    'october',
    'november',
    'december',
];
const range = (length) => Array.from(Array(length).keys());
const initialDays = range(31).map((number) => {
    const value = `${number + 1}`;
    return { label: value, value };
});
const currentYear = new Date().getFullYear();
const yearList = range(100).reduce((result, current) => {
    const value = `${currentYear - current}`;
    return [...result, { label: value, value }];
}, []);
const createMonthsList = (months) => months.map((month, index) => ({ label: month, value: `${index + 1}` }));
const getCorrectDaysForMonth = (year, month) => {
    const monthLength = new Date(year, month, 0).getDate();
    const daysList = range(monthLength).map((number) => {
        const day = (number + 1).toString();
        return { label: day, value: day };
    });
    return daysList;
};
const useDateParts = () => {
    const t = (0,esm/* useUdsTranslate */.oG)();
    const [dayList, setDayList] = (0,react.useState)(initialDays);
    const [selectedMonth, setSelectedMonth] = (0,react.useState)();
    const [selectedYear, setSelectedYear] = (0,react.useState)();
    const months = monthNames.map(m => t(m));
    const monthList = createMonthsList(months);
    const handleYearChange = (year) => setSelectedYear(parseInt(year));
    const handleMonthChange = (month) => setSelectedMonth(parseInt(month));
    (0,react.useEffect)(() => {
        if (selectedMonth && selectedYear) {
            const days = getCorrectDaysForMonth(selectedYear, selectedMonth);
            setDayList(days);
        }
        else if (selectedMonth && !selectedYear) {
            const days = getCorrectDaysForMonth(new Date().getFullYear(), selectedMonth);
            setDayList(days);
        }
    }, [selectedMonth, selectedYear]);
    return { monthList, yearList, dayList, handleMonthChange, handleYearChange };
};

const defaultSelectNames = {
    year: 'year',
    month: 'month',
    day: 'day',
};
const containerStyle$1 = (0,style/* style */.oB)({
    base: 'grid',
    variants: {
        direction: {
            column: 'grid-cols-1 gap-4',
            row: 'grid-cols-3 gap-4',
        },
    },
});
const isFieldError = (error, errorText) => (field) => {
    return typeof error === 'boolean'
        ? error
        : error?.[field] ||
            (typeof errorText === 'string'
                ? typeof error === 'undefined'
                : Boolean(errorText?.[field]));
};
/**
 * The `InputDateSelect` renders a fieldset, with three inputs for year, month, day.
 *
 * The inputs are three `InputSelect` components
 *
 * @example
 * ```
 * <InputDateSelect
 *   errorText={{
 *     year: 'Year is required',
 *   }}
 * />
 * ```
 */
const InputDateSelect = react.forwardRef((props, forwardRef) => {
    const { id: propsId, direction = { initial: 'column', sm: 'row' }, disabled, invert, className, selectNames = defaultSelectNames, error, errorText, supportText, currentItems, required, optional, label, dataTestId, refs, } = props;
    const id = reach_auto_id_useId(propsId);
    const t = (0,esm/* useUdsTranslate */.oG)();
    const day = t('day');
    const month = t('month');
    const year = t('year');
    const { dayList, monthList, yearList, handleMonthChange, handleYearChange, } = useDateParts();
    const yearRef = refs?.year ? refs.year : forwardRef;
    const monthRef = refs?.month ? refs.month : forwardRef;
    const dayRef = refs?.day ? refs.day : forwardRef;
    const getFieldError = isFieldError(error, errorText);
    const isYearError = getFieldError('year');
    const yearErrorText = typeof errorText !== 'string' ? errorText?.year : undefined;
    const isMonthError = getFieldError('month');
    const monthErrorText = typeof errorText !== 'string' ? errorText?.month : undefined;
    const isDayError = getFieldError('day');
    const dayErrorText = typeof errorText !== 'string' ? errorText?.day : undefined;
    const fieldsetErrorText = typeof errorText === 'string' ? errorText : undefined;
    const fieldsetErrorId = `${id}_error`;
    return (react.createElement(Fieldset, { id: id, dataTestId: dataTestId, invert: invert, legend: label, errorText: fieldsetErrorText, supportText: supportText, className: (0,twind.tw)(className, 'w-full'), required: required, optional: optional, ref: forwardRef },
        react.createElement("div", { className: (0,twind.tw)(containerStyle$1({ direction })) },
            react.createElement(InputSelect, { name: selectNames.year, showLabel: false, options: yearList, placeholder: year, id: `${id}-${selectNames.year}`, label: year, defaultValue: currentItems?.year, ref: yearRef, disabled: disabled, onChange: handleYearChange, error: isYearError, errorText: yearErrorText, invert: invert, required: required, "aria-describedby": fieldsetErrorText && isYearError ? fieldsetErrorId : undefined, dataTestId: dataTestId ? `${dataTestId}-${selectNames.year}` : undefined }),
            react.createElement(InputSelect, { name: selectNames.month, showLabel: false, options: monthList, placeholder: month, id: `${id}-${selectNames.month}`, label: month, ref: monthRef, error: isMonthError, errorText: monthErrorText, defaultValue: currentItems?.month, disabled: disabled, onChange: handleMonthChange, invert: invert, required: required, "aria-describedby": fieldsetErrorText && isMonthError ? fieldsetErrorId : undefined, dataTestId: dataTestId ? `${dataTestId}-${selectNames.month}` : undefined }),
            react.createElement(InputSelect, { name: selectNames.day, showLabel: false, options: dayList, placeholder: day, id: `${id}-${selectNames.day}`, label: day, error: isDayError, errorText: dayErrorText, ref: dayRef, defaultValue: currentItems?.day, disabled: disabled, invert: invert, required: required, "aria-describedby": fieldsetErrorText && isDayError ? fieldsetErrorId : undefined, dataTestId: dataTestId ? `${dataTestId}-${selectNames.day}` : undefined }))));
});
InputDateSelect.displayName = 'InputDateSelect';

/**
 * InputCheckbox renders a label, and within an input of `type=checkbox`.
 * The children of the component, are part of the label
 */
const InputSwitch = react.forwardRef(function InputCheckbox(props, forwardRef) {
    const { id: propsId, disabled, children, invert, className, dataTestId, showLabel = true, reverse, ...rest } = props;
    const id = reach_auto_id_useId(propsId);
    const inputRef = (0,react.useRef)(null);
    const ref = (0,esm/* useSharedRef */.lD)(forwardRef, inputRef);
    const styles = {
        switchWrapper: (0,style.tw)('group relative flex gap-4', disabled ? 'cursor-not-allowed' : 'cursor-pointer', reverse && 'flex-row-reverse', className),
        switch: (0,style.tw)('pointer-events-none transition transition-all ease-out relative block text-lg w-12 h-6 border-2 rounded-full flex-none', !invert && !disabled && 'bg-neutral-20 text-white border-neutral-100', !invert && disabled && 'bg-neutral-20 border-neutral-60', invert && !disabled && 'bg-neutral-90 text-neutral-100 border-white', invert && disabled && 'bg-neutral-80 border-neutral-50'),
        swichThumb: (0,style.tw)('pointer-events-none transition transition-all ease-out absolute transform -translate-x-0.5 left-0 -top-0.5 rtl:(left-auto right-0 translate-x-0.5)', 'w-6 h-6 rounded-full bg-white border-2 border-neutral-100', !invert && !disabled && 'bg-white border-neutral-100', !invert && disabled && 'bg-neutral-20 border-neutral-60', invert && !disabled && 'bg-neutral-100 border-white', invert && disabled && 'bg-neutral-80 border-neutral-50'),
        checkIndicator: (0,style.tw)('absolute w-4 h-4 top-0.5 left-1.5 transition transition-all ease-out opacity-0 transform -translate-x-2 rtl:(left-auto right-1.5 transform translate-x-2) ', invert ? 'text-neutral-100' : 'text-white'),
        input: (0,style.tw)('opacity-0 absolute left-0 top-0 w-full h-full', disabled ? 'cursor-not-allowed' : 'cursor-pointer', (0,style/* css */.iv)({
            '&:focus ~ .switch, &:active ~ .switch': {
                '@apply': `ring-3 ${invert && 'ring-invert'}`,
            },
            '&:checked + .switch': {
                '@apply': `${invert ? 'bg-white' : 'bg-neutral-100'}`,
            },
            '&:checked + .switch > .thumb': {
                '@apply': `left-6 rtl:(left-auto right-6)`,
            },
            '&:checked + .switch > [data-indicator]': {
                '@apply': `translate-x-0 opacity-100`,
            },
        })),
        inputLabel: (0,style.tw)('text-base flex-1', disabled && `${invert ? 'text-neutral-50' : 'text-neutral-60'}`, invert && 'text-white', !showLabel && 'sr-only'),
    };
    return (react.createElement("label", { htmlFor: id, className: styles.switchWrapper, "data-test-id": dataTestId },
        react.createElement("input", { className: styles.input, id: id, ref: ref, type: "checkbox", disabled: disabled, ...rest }),
        react.createElement("div", { "data-uds-child": "switch", "aria-hidden": true, className: `${styles.switch} switch` },
            react.createElement("div", { "data-indicator": true, className: (0,style.tw)(styles.checkIndicator) },
                react.createElement(Icon, { name: "check" })),
            react.createElement("span", { className: (0,style.tw)(styles.swichThumb, 'thumb') })),
        children && (react.createElement("div", { "data-uds-child": "children", className: styles.inputLabel }, children))));
});

/**
 * The `SearchForm` component is used to render a form with a search input, clear button and submit button.
 *
 * @example
 * ```
 * const [value, setValue] = useState('');
 *
 * <SearchForm
 *   label="Search"
 *   placeholder="Search"
 *   value={value}
 *   onChange={setValue}
 *   onSubmit={handleSubmit}
 * />
 * ```
 */
const SearchForm = (0,react.forwardRef)(function SearchForm({ id: propsId, label, placeholder, name, dataTestId, value, invert, onChange, onSubmit, required = false, ...props }, forwardedRef) {
    const id = reach_auto_id_useId(propsId);
    const ref = (0,react.useRef)(null);
    const sharedRef = (0,esm/* useSharedRef */.lD)(forwardedRef, ref);
    const { dictionary } = (0,esm/* useUdsContext */.vV)();
    const isLargeDevice = (0,esm/* useMediaQuery */.ac)(`(min-width: ${twind.tw.theme('screens.lg')})`);
    const handleClear = () => {
        onChange('');
        // Refocus input after clearing
        ref.current?.focus();
    };
    const clearButtonProps = {
        type: 'reset',
        label: dictionary.clear,
        onClick: handleClear,
        dataTestId: dataTestId ? `${dataTestId}-clear` : undefined,
        'data-uds-child': 'search-form-clear',
        invert,
    };
    return (react.createElement("form", { className: "relative flex-1", role: "search", "data-test-id": dataTestId, onSubmit: onSubmit },
        react.createElement("label", { htmlFor: id, className: "sr-only" }, label),
        react.createElement("input", { type: "search", id: id, name: name, placeholder: placeholder || label, value: value, className: (0,twind.tw)('w-full h-14 rounded-sm border-1 focus-within:ring', invert
                ? 'bg-neutral-100 text-neutral-0 border-neutral-50 hover:border-neutral-0 focus-within:border-neutral-0'
                : 'bg-neutral-0 text-neutral-100 border-neutral-60 hover:border-neutral-100 focus-within:border-neutral-100', 
            // Padding to account for clear and submit buttons
            value
                ? 'pl-4 pr(28 lg:32) rtl:(pr-4 pl(28 lg:32))'
                : 'pl-4 pr-14 rtl:(pr-4 pl-14)'), autoComplete: "off", onChange: e => onChange(e.target.value), "data-uds-child": "search-form-input", "data-test-id": dataTestId ? `${dataTestId}-input` : undefined, ref: sharedRef, required: required, ...props }),
        react.createElement("div", { className: "absolute top-2 right-2 flex items-center gap-2 rtl:(right-auto left-2)" },
            value && (react.createElement(react.Fragment, null,
                isLargeDevice ? (react.createElement(ButtonUnderline, { ...clearButtonProps, className: "mr-2 rtl:mr-0 rtl:ml-2", transform: "uppercase", size: "sm" })) : (react.createElement(ButtonIcon, { ...clearButtonProps, icon: "close", variant: "ghost" })),
                react.createElement("div", { role: "separator", className: (0,twind.tw)('h-6 w-px', invert ? 'bg-neutral-60' : 'bg-neutral-30') }))),
            react.createElement(ButtonIcon, { type: "submit", label: dictionary.search, icon: "search", variant: "ghost", "data-uds-child": "search-form-submit", "data-test-id": dataTestId ? `${dataTestId}-submit` : undefined, invert: invert }))));
});

/**
 * Context for the Callout component.
 *
 * @internal Used internally by the CalloutRoot component.
 */
const CalloutContext = (0,react.createContext)(null);
/**
 * Internal hook for consuming the Callout context.
 *
 * @internal
 */
const useCalloutContext = () => {
    return (0,react.useContext)(CalloutContext);
};

const CalloutIcon = (props) => {
    const { icon, size = '2xl', dataTestId, className, ...rest } = props;
    const { variant, invert, dataTestId: contextDataTestId, } = useCalloutContext();
    return (react.createElement(Icon, { ...rest, name: icon, color: variant, invert: invert, className: className, size: size, "data-uds-child": "callout-icon", dataTestId: dataTestId
            ? dataTestId
            : contextDataTestId
                ? `${contextDataTestId}-icon`
                : undefined }));
};
const CalloutBody = (props) => {
    const { dataTestId: contextDataTestId } = useCalloutContext();
    return (react.createElement("div", { "data-uds-child": "callout-body", "data-test-id": props.dataTestId
            ? props.dataTestId
            : contextDataTestId
                ? `${contextDataTestId}-body`
                : undefined, ...props }));
};
const CalloutText = ({ weight = 'bold', dataTestId, ...props }) => {
    const { variant, invert, dataTestId: contextDataTestId, } = useCalloutContext();
    return (react.createElement(Text, { color: variant, invert: invert, weight: weight, "data-uds-child": "callout-text", "data-test-id": dataTestId
            ? dataTestId
            : contextDataTestId
                ? `${contextDataTestId}-text`
                : undefined, ...props }));
};

const CalloutCloseButton = (props) => {
    const { className } = props;
    const { onCloseClick, invert } = useCalloutContext();
    const t = (0,esm/* useUdsTranslate */.oG)();
    const handleClick = e => {
        onCloseClick?.(e);
    };
    return (react.createElement(ButtonIcon, { "data-uds-child": "callout-close", label: t('close'), icon: "close", size: "xs", variant: "ghost", invert: invert, onClick: handleClick, className: className }));
};

(0,css_css/* animation */.oQ)('0.3s cubic-bezier(0.16, 1, 0.3, 1) forwards', {
    '0%': {
        opacity: 0,
    },
    '100%': {
        opacity: 1,
    },
});
const fadeOut$2 = (0,css_css/* animation */.oQ)('0.3s cubic-bezier(0.5, 1, 0.89, 1) forwards', {
    '0%': {
        opacity: 1,
    },
    '100%': {
        opacity: 0,
    },
});
(0,css_css/* animation */.oQ)('0.5s cubic-bezier(0.16, 1, 0.3, 1) forwards', {
    '0%': {
        transform: 'translate3d(0, -60px, 0)',
    },
    '100%': {
        transform: 'translate3d(0, 0, 0)',
    },
});

const baseLayout$1 = css_css/* css */.iv `
  @apply grid;
  grid-auto-rows: max-content;

  & > [data-uds-child='callout-icon'] {
    grid-area: icon;
    @apply mt-px;
  }

  & > [data-uds-child='callout-body'] {
    grid-area: body;
    @apply justify-self-start self-start leading-normal;
  }

  & > [data-uds-child='callout-close'] {
    grid-area: close;
    @apply mt-0.5 justify-self-start self-start;
  }
`;
const baseLayoutIconStart = css_css/* css */.iv `
  grid-template-columns: max-content auto max-content;
  grid-template-areas:
    'icon body close'
    'icon body close';
  & > [data-uds-child='callout-icon'] {
    @apply -ml-1 mr-2 rtl:(ml-2 -mr-1);
  }
  & > [data-uds-child='callout-close'] {
    @apply -mr-1 ml-3 rtl:(mr-3 -ml-1);
  }
`;
const baseLayoutIconEnd = css_css/* css */.iv `
  grid-template-columns: auto max-content max-content;
  grid-template-areas:
    'body icon close'
    'body icon close';
  & > [data-uds-child='callout-icon'] {
    @apply -mr-1 ml-2 rtl:(mr-2 -ml-1);
  }
  & > [data-uds-child='callout-close'] {
    @apply -ml-1 mr-3 rtl:(ml-3 -mr-1);
  }
`;
const borderStyles = {
    base: 'border-neutral-20',
    muted: 'border-neutral-20',
    brand: 'border-brand-10',
    success: 'border-success-10',
    error: 'border-error-10',
    warning: 'border-warning-10',
    info: 'border-info-10',
};
const borderStylesInvert = {
    base: 'border-neutral-80',
    muted: 'border-neutral-80',
    brand: 'border-brand-70',
    success: 'border-success-80',
    error: 'border-error-80',
    warning: 'border-warning-80',
    info: 'border-info-80',
};
const fillStyles = {
    base: 'bg-neutral-10',
    muted: 'bg-neutral-5',
    brand: 'bg-brand-5',
    success: 'bg-success-5',
    error: 'bg-error-5',
    warning: 'bg-warning-5',
    info: 'bg-info-5',
};
const fillStylesInvert = {
    base: 'bg-neutral-90',
    muted: 'bg-neutral-100',
    brand: 'bg-brand-100',
    success: 'bg-success-100',
    error: 'bg-error-100',
    warning: 'bg-warning-100',
    info: 'bg-info-100',
};
/**

 */
const CalloutRoot = ({ variant = 'base', invert = false, outline = false, fill = false, inset = 'none', insetX, insetY, insetTop, insetEnd, insetBottom, insetStart, iconEnd = false, bleed = false, open = true, dismissible, onDismiss, asChild, dataTestId, className, children, ...rest }) => {
    const [isOpen, setIsOpen] = react.useState(open);
    const calloutMounted = (0,esm/* useDelayUnmount */.dN)(isOpen, 1000);
    const handleClose = (e) => {
        onDismiss && onDismiss(e);
        setIsOpen(false);
    };
    (0,react.useEffect)(() => {
        setIsOpen(open);
    }, [open]);
    return utils_esm.is.undefined(dismissible) || calloutMounted ? (react.createElement(CalloutContext.Provider, { value: {
            open: isOpen,
            invert,
            variant,
            outline,
            iconEnd,
            dataTestId,
            onCloseClick: handleClose,
        } },
        react.createElement(Inset, { "data-uds-child": "callout", asChild: asChild, inset: inset, insetX: insetX, insetY: insetY, insetTop: insetTop, insetEnd: insetEnd, insetBottom: insetBottom, insetStart: insetStart, dataTestId: dataTestId, className: (0,twind.tw)(bleed ? 'w-full' : 'w-auto max-w-max', className, baseLayout$1, !isOpen && fadeOut$2, iconEnd ? baseLayoutIconEnd : baseLayoutIconStart, outline && 'relative border-1 rounded-sm', outline && !invert && borderStyles[variant], outline && invert && borderStylesInvert[variant], outline && fill && !invert && fillStyles[variant], outline && fill && invert && fillStylesInvert[variant]), ...rest },
            children,
            dismissible && react.createElement(CalloutCloseButton, null)))) : null;
};

/**
 * Callout message component.
 *
 * @example
 * ```
 * <Callout
 *   content="This order qualifies for free shipping"
 *   variant="success"
 *   icon="truck"
 * />
 * ```
 */
const Callout = ({ content, invert, variant, icon, ...rest }) => (react.createElement(CalloutRoot, { variant: variant, invert: invert, inset: "none", ...rest },
    icon && react.createElement(CalloutIcon, { icon: icon }),
    react.createElement(CalloutBody, null,
        react.createElement(CalloutText, { asChild: true, color: variant, invert: invert },
            react.createElement("p", null, content)))));

const defaultAlertIcons = {
    success: 'check-filled',
    error: 'exclamation-filled',
    warning: 'warning-filled',
    info: 'info-filled',
};
/**
 * Alert message component. Renders a box with the alert contents
 *
 * - The Alert is usually wrapped in a `LiveRegion` component. By itself, the alert
 * is not of `role=alert` but just text content.
 *
 * @example
 * ```
 * <LiveRegion role="assertive">
 *   <Alert title="Please fix the form errors" />
 * </LiveRegion>
 * ```
 */
const Alert = ({ title, content, variant = 'base', invert, icon = true, dataTestId, className, ref, ...rest }) => {
    const defaultAlertIcon = defaultAlertIcons[variant];
    const alertContent = Array.isArray(content) ? (react.createElement("ul", { className: "list-inside", "data-test-id": dataTestId ? `${dataTestId}-content` : undefined, "data-uds-child": "alert-content" }, content &&
        content.map(c => (react.createElement(CalloutText, { key: c, weight: title ? 'normal' : 'bold', asChild: true },
            react.createElement("li", { className: "list-disc" }, c)))))) : (react.createElement(CalloutText, { weight: title ? 'normal' : 'bold', dataTestId: dataTestId ? `${dataTestId}-content` : undefined, "data-uds-child": "alert-content", asChild: true },
        react.createElement("p", null, content)));
    const useIcon = icon === true && defaultAlertIcon
        ? defaultAlertIcon
        : utils_esm.is.string(icon)
            ? icon
            : null;
    return (react.createElement(CalloutRoot, { ref: ref, variant: variant, invert: invert, iconEnd: true, outline: true, insetX: "xs", insetY: "xxs", dataTestId: dataTestId, className: (0,twind.tw)(className, 'w-full'), ...rest },
        useIcon ? (react.createElement(CalloutIcon, { icon: useIcon, "data-uds-child": "alert-icon", dataTestId: `${dataTestId}-icon` })) : null,
        react.createElement(CalloutBody, { "data-uds-child": "alert-body" },
            react.createElement(Stack, { gap: "px", justify: "start" },
                title ? (react.createElement(CalloutText, { "data-uds-child": "alert-title", dataTestId: dataTestId && `${dataTestId}-title`, asChild: true },
                    react.createElement("h4", null, title))) : null,
                content ? alertContent : null))));
};

const cardStyle = (0,style/* style */.oB)({
    base: 'relative',
    variants: {
        variant: {
            fill: '',
            base: '',
            frost: '',
            transparent: '',
        },
        invert: {
            true: 'text-neutral-0',
            false: 'text-neutral-100',
        },
        outline: {
            true: '',
            false: '',
        },
        elevate: {
            true: 'shadow-glow-base',
            false: '',
        },
    },
    matches: [
        {
            invert: false,
            variant: 'base',
            use: 'bg-neutral-0',
        },
        {
            invert: false,
            variant: 'fill',
            use: 'bg-neutral-10',
        },
        {
            invert: false,
            variant: 'frost',
            use: 'bg-white bg-opacity-20',
        },
        {
            invert: true,
            variant: 'base',
            use: 'bg-neutral-100',
        },
        {
            invert: true,
            variant: 'fill',
            use: 'bg-neutral-90',
        },
        {
            invert: true,
            variant: 'frost',
            use: 'bg-neutral-100 bg-opacity-30',
        },
        {
            variant: 'transparent',
            use: 'border-1 border-transparent bg-transparent',
        },
        {
            variant: 'frost',
            use: style/* css */.iv `
        backdrop-filter: blur(16px);
      `,
        },
        {
            invert: false,
            outline: true,
            use: 'border-1 border-neutral-20',
        },
        {
            invert: true,
            outline: true,
            use: 'border-1 border-neutral-80',
        },
        {
            outline: false,
            use: 'border-1 border-transparent',
        },
    ],
    defaults: {
        variant: 'base',
        invert: false,
    },
});
/**
 * The `Card` component is a container for content. Internally uses the `Inset` component and inherits all its props.
 *
 * @example
 * ```tsx
 * <Card variant="frost" inset="md">
 * ```
 */
const Card = react.forwardRef((props, forwadedRef) => {
    const { variant = 'fill', outline = false, invert = false, elevate = false, inset = 'base', className, ...rest } = props;
    return (react.createElement(Inset, { ref: forwadedRef, "data-uds-child": "card", className: (0,style.tw)(cardStyle({
            invert,
            outline,
            variant,
            elevate,
        }), className), inset: inset, ...rest }));
});
Card.displayName = 'Card';

const badgeStyle = (0,style/* style */.oB)({
    base: 'flex-shrink-0 inline-flex items-center justify-center gap-1 font-bold uppercase',
    variants: {
        /**
         * The color of the badge.
         * @defaultValue 'base'
         *
         * @example
         * ```tsx
         * <Badge color="error" />
         * ```
         */
        color: {
            base: '',
            muted: '',
            brand: '',
            success: '',
            info: '',
            error: '',
            warning: '',
            promotion: '',
        },
        /**
         * The size of the badge.
         * @defaultValue 'base'
         *
         * @example
         * ```tsx
         * <Badge size="sm" />
         * ```
         */
        size: {
            sm: 'text-xxs h-5 min-w-5',
            base: 'text-xs h-6 min-w-6',
        },
        /**
         * Set the badge to the round variant.
         * @defaultValue false
         *
         * @example
         * ```tsx
         * <Badge round />
         * ```
         */
        round: {
            true: 'rounded-full',
            false: 'rounded-sm ',
        },
        /**
         * Set the badge to the outlined variant.
         * @defaultValue false
         *
         * @example
         * ```tsx
         * <Badge outline />
         * ```
         */
        outline: {
            true: 'border border-1',
            false: '',
        },
        /**
         * Set the badge to the inverted variant.
         * @defaultValue false
         *
         * @example
         * ```tsx
         * <Badge invert />
         * ```
         */
        invert: {
            true: '',
            false: '',
        },
    },
    matches: [
        // Sizes
        {
            round: false,
            size: 'sm',
            use: 'px-3',
        },
        {
            round: false,
            size: 'base',
            use: 'px-4',
        },
        {
            round: true,
            size: 'sm',
            use: 'px-1.5',
        },
        {
            round: true,
            size: 'base',
            use: 'px-2',
        },
        // Solid colors
        {
            invert: false,
            outline: false,
            use: 'text-white',
        },
        {
            outline: false,
            color: 'base',
            invert: false,
            use: 'bg-neutral-100',
        },
        {
            outline: false,
            color: 'muted',
            invert: false,
            use: 'bg-neutral-60',
        },
        {
            outline: false,
            color: 'brand',
            invert: false,
            use: 'bg-brand-60',
        },
        {
            outline: false,
            color: 'success',
            invert: false,
            use: 'bg-success-60',
        },
        {
            outline: false,
            color: 'info',
            invert: false,
            use: 'bg-info-60',
        },
        {
            outline: false,
            color: 'error',
            invert: false,
            use: 'bg-error-60',
        },
        {
            outline: false,
            color: 'warning',
            invert: false,
            use: 'bg-warning-70',
        },
        {
            outline: false,
            color: 'promotion',
            invert: false,
            use: 'bg-promotion-100',
        },
        // Solid colors (inverted)
        {
            invert: true,
            outline: false,
            use: 'text-neutral-100',
        },
        {
            outline: false,
            color: 'base',
            invert: true,
            use: 'bg-white',
        },
        {
            outline: false,
            color: 'muted',
            invert: true,
            use: 'bg-neutral-50',
        },
        {
            outline: false,
            color: 'brand',
            invert: true,
            use: 'bg-brand-30',
        },
        {
            outline: false,
            color: 'success',
            invert: true,
            use: 'bg-success-40',
        },
        {
            outline: false,
            color: 'info',
            invert: true,
            use: 'bg-info-40',
        },
        {
            outline: false,
            color: 'error',
            invert: true,
            use: 'bg-error-40',
        },
        {
            outline: false,
            color: 'warning',
            invert: true,
            use: 'bg-warning-50',
        },
        {
            outline: false,
            color: 'promotion',
            invert: true,
            use: 'bg-promotion-10',
        },
        // Outline colors
        {
            outline: true,
            invert: false,
            use: 'bg-neutral-0',
        },
        {
            outline: true,
            invert: true,
            use: 'bg-neutral-100',
        },
        {
            outline: true,
            color: 'base',
            invert: false,
            use: 'text-neutral-100 border-neutral-20',
        },
        {
            outline: true,
            color: 'muted',
            invert: false,
            use: 'text-neutral-60 border-neutral-20',
        },
        {
            outline: true,
            color: 'brand',
            invert: false,
            use: 'text-brand-60 border-brand-20',
        },
        {
            outline: true,
            color: 'success',
            invert: false,
            use: 'text-success-60 border-success-20',
        },
        {
            outline: true,
            color: 'info',
            invert: false,
            use: 'text-info-60 border-info-20',
        },
        {
            outline: true,
            color: 'error',
            invert: false,
            use: 'text-error-60 border-error-20',
        },
        {
            outline: true,
            color: 'warning',
            invert: false,
            use: 'text-warning-70 border-warning-20',
        },
        {
            outline: true,
            color: 'promotion',
            invert: false,
            use: 'text-promotion-100 border-promotion-100',
        },
        // Outline colors (inverted)
        {
            outline: true,
            color: 'base',
            invert: true,
            use: 'text-white border-neutral-80',
        },
        {
            outline: true,
            color: 'muted',
            invert: true,
            use: 'text-neutral-50 border-neutral-80',
        },
        {
            outline: true,
            color: 'brand',
            invert: true,
            use: 'text-brand-30 border-brand-80',
        },
        {
            outline: true,
            color: 'success',
            invert: true,
            use: 'text-success-40 border-success-80',
        },
        {
            outline: true,
            color: 'info',
            invert: true,
            use: 'text-info-40 border-info-80',
        },
        {
            outline: true,
            color: 'error',
            invert: true,
            use: 'text-error-40 border-error-80',
        },
        {
            outline: true,
            color: 'warning',
            invert: true,
            use: 'text-warning-50 border-warning-80',
        },
        {
            outline: true,
            color: 'promotion',
            invert: true,
            use: 'text-promotion-10 border-promotion-10',
        },
    ],
});
/**
 * A badge component to highlight the status of an item or product.
 *
 * @example
 * ```
 * <Badge label="Coming Soon" color="success" icon="star-filled" />
 * ```
 */
const Badge = react.forwardRef(function Badge(props, forwardedRef) {
    const { dataTestId, color = 'base', size = 'base', icon, round = false, outline = false, invert = false, className, label, ...rest } = props;
    return (react.createElement("span", { ref: forwardedRef, className: (0,style.tw)('min-w-content', badgeStyle({
            color,
            outline,
            round,
            invert,
            size,
        }), className), "data-uds-child": "badge", "data-test-id": dataTestId, ...rest },
        icon && (react.createElement(Icon, { name: icon, size: "base", className: "flex-shrink-0 -ml-1 rtl:(-mr-1 ml-0))" })),
        label));
});

const ProgressStepperItemContext = (0,react.createContext)(undefined);
const ProgressStepperItemProvider = ({ children, value, }) => (React.createElement(ProgressStepperItemContext.Provider, { value: value }, children));
const useProgressStepperItemContext = () => {
    const context = useContext(ProgressStepperItemContext);
    if (!context) {
        throw new Error('useProgressStepperItemContext must be used within a ProgressStepperItemProvider');
    }
    return context;
};

/**
 * Step item bullet
 * @internal
 */
const ProgressStepperItemBullet = () => {
    const { isCurrent, layout, isFuture, isCompleted, number, isLast } = useProgressStepperItemContext();
    const style = useResponsiveProp(layout, value => {
        const bulletSize = 'w-8 h-8';
        const currentBullet = `bg-neutral-100 border-neutral-100 text-neutral-0 ${bulletSize}`;
        switch (value.compact) {
            case true:
                return [
                    isCurrent ? currentBullet : 'border-0 -indent-9999px w-2 h-2',
                    isCompleted && 'bg-neutral-100',
                    isFuture && 'bg-neutral-20',
                ];
            case false:
                return [
                    bulletSize,
                    isCurrent ? currentBullet : 'border-2 bg-neutral-0 indent-initial',
                    isFuture && 'text-neutral-60 border-neutral-20',
                    isCompleted && 'text-neutral-100 border-neutral-100',
                ];
        }
    });
    return (React.createElement("div", { className: "relative flex items-center justify-center w-8 h-8" },
        React.createElement("div", { className: "p-1 -m-1 bg-neutral-0 rounded-full" },
            React.createElement("div", { className: tw$2(`flex items-center justify-center rounded-full font-bold text-xs border-2 transition duration-300 ease-out-expo`, style), "aria-hidden": "true", "data-uds-child": "progress-stepper-item-bullet" }, isLast && isCurrent ? (React.createElement(Icon, { name: "check", size: "2xl" })) : (React.createElement(React.Fragment, null, number))))));
};

/**
 * Step item label
 *
 * @internal
 */
const ProgressStepperItemLabel = () => {
    const { isCurrent, layout, label } = useProgressStepperItemContext();
    const style = useResponsiveProp(layout, value => {
        const visibility = !isCurrent && value.compact ? `hidden` : `block`;
        switch (value.direction) {
            case `horizontal`:
                return ['text-xs', visibility];
            case 'vertical':
                return ['text-sm', visibility];
        }
    });
    return (React.createElement("span", { className: tw$2('font-bold uppercase whitespace-nowrap', !isCurrent && 'text-neutral-60', style), "data-uds-child": "progress-stepper-item-label" }, label));
};

/**
 * Item step count
 *
 * @internal
 */
const ProgressStepperItemStepCount = () => {
    const t = useUdsTranslate();
    const { isCurrent, layout, number, totalSteps } = useProgressStepperItemContext();
    const style = useResponsiveProp(layout, value => {
        return isCurrent && value.compact ? `block` : `hidden`;
    });
    return (React.createElement("span", { className: tw$2('font-bold text-xxs text-neutral-60 uppercase whitespace-nowrap', style), "data-uds-child": "progress-stepper-item-step-count" },
        ' ',
        t('stepCount', { step: number, total: totalSteps }),
        ' '));
};

/**
 * Step item text container
 *
 * @internal
 */
const ProgressStepperItemTextContainer = ({ children, }) => {
    const { layout, isFirst, isLast } = useProgressStepperItemContext();
    const style = useResponsiveProp(layout, value => {
        const out = [];
        switch (value.direction) {
            case `horizontal`:
                out.push('absolute top-10');
                isFirst && out.push('left-0 text-left');
                isLast && out.push('right-0 text-right');
                !isFirst &&
                    !isLast &&
                    out.push('left-1/2 -translate-x-1/2 text-center');
                break;
            case 'vertical':
                out.push('static translate-x-0 text-left');
                break;
        }
        return out;
    });
    return React.createElement("div", { className: tw$2('flex flex-col-reverse', style) }, children);
};

/**
 * Step item
 *
 * @internal
 */
const ProgressStepperItem = (props) => {
    const t = useUdsTranslate();
    const style = useResponsiveProp(props.layout, ({ direction, compact }) => {
        switch (direction) {
            case 'horizontal':
                return [
                    'flex gap-0 flex-col items-start',
                    // accounts for the absolutely positioned text container
                    compact ? 'pb-10' : 'pb-6',
                ];
            case 'vertical':
                return 'flex gap-3 flex-row items-center pb-0';
        }
    });
    return (React.createElement("li", { className: tw$2('relative z-[1]', style), "data-uds-child": "progress-stepper-item" },
        React.createElement(ProgressStepperItemProvider, { value: props },
            props.isCompleted && React.createElement("span", { className: "sr-only" },
                t('complete'),
                " "),
            props.isCurrent && React.createElement("span", { className: "sr-only" },
                t('current'),
                " "),
            React.createElement(ProgressStepperItemBullet, null),
            React.createElement(ProgressStepperItemTextContainer, null,
                React.createElement(ProgressStepperItemStepCount, null),
                React.createElement(ProgressStepperItemLabel, null)))));
};

const DEFAULT_VERTICAL_LAYOUT = {
    direction: 'vertical',
    compact: false,
    gap: 'base',
};
const DEFAULT_HORIZONTAL_LAYOUT = {
    direction: 'horizontal',
    compact: false,
    bleed: false,
    gap: 'base',
};
/** Formats the layout object into a responsive prop with default values */
const getLayout = (layout) => {
    const layoutObject = 'direction' in layout ? { _: layout } : layout;
    for (const breakpoint in layoutObject) {
        const { direction } = layoutObject[breakpoint];
        layoutObject[breakpoint] =
            direction === 'vertical'
                ? { ...DEFAULT_VERTICAL_LAYOUT, ...layoutObject[breakpoint] }
                : { ...DEFAULT_HORIZONTAL_LAYOUT, ...layoutObject[breakpoint] };
    }
    return layoutObject;
};
const HORIZONTAL_BAR_STYLES = 'left-4 top-4 right-4 bottom-auto h-[2px] w-auto';
const VERTICAL_BAR_STYLES = 'left-[15px] top-4 bottom-4 right-auto w-[2px] h-auto';
/**
 * Display the progress of a multi-step process.
 *
 * @example
 * ```
 * <ProgressStepper
 *   currentStep={0}
 *   steps={[
 *     "Ordered",
 *     "Processing",
 *     "Delivered",
 *   ]}
 *   layout={{
 *     direction: 'vertical', compact:false, gap:'base'
 *   }}
 * />
 * ```
 *
 * @example
 * ```
 * <ProgressStepper
 *  steps={[
 *    "Ordered",
 *    "Processing",
 *    "Packed",
 *    "Shipped",
 *    "Out for delivery",
 *    "Delivered",
 *  ]}
 *  currentStep={2}
 *  layout={{
 *    _: {
 *        direction: 'horizontal',
 *        gap: 'sm',
 *        compact: true
 *    },
 *    xl: {
 *        direction: 'horizontal',
 *        gap: 'lg',
 *        compact: false
 *    }
 *  }}
 * ```
 */
const ProgressStepper = ({ currentStep, steps, layout: layoutProp = DEFAULT_HORIZONTAL_LAYOUT, dataTestId, className, ...rest }) => {
    const layout = getLayout(layoutProp);
    const progressScale = Math.max((1 / (steps.length - 1)) * Math.min(currentStep + 0.5, steps.length - 1), 0);
    const style = useResponsiveProp(layout, ({ direction, gap, bleed }) => {
        switch (direction) {
            case 'horizontal':
                return [
                    `flex-row ${bleed ? 'w-full' : 'w-max'}`,
                    `${gap === 'sm' ? 'gap-8' : gap === 'lg' ? 'gap-24' : 'gap-16'}`,
                    `before:(${HORIZONTAL_BAR_STYLES})`,
                    `after:(${HORIZONTAL_BAR_STYLES} scale-x-[${progressScale}] scale-y-100)`,
                ];
            case 'vertical':
                return [
                    `flex-col w-auto ${bleed ? 'h-full' : 'h-max'}`,
                    `${gap === 'sm' ? 'gap-6' : gap === 'lg' ? 'gap-10' : 'gap-8'}`,
                    `before:(${VERTICAL_BAR_STYLES})`,
                    `after:(${VERTICAL_BAR_STYLES} scale-y-[${progressScale}] scale-x-100)`,
                ];
        }
    });
    return (React.createElement("ol", { className: tw$1('relative flex items-start justify-between min-w-max', `before:(content absolute bg-neutral-20)`, `after:(content absolute bg-neutral-100 origin-top-left transform transition-transform duration-300 ease-out-expo)`, style, className), "data-test-id": dataTestId, ...rest }, steps.map((item, i) => (React.createElement(ProgressStepperItem, { key: item, label: item, number: i + 1, totalSteps: steps.length, layout: layout, isFirst: i === 0, isLast: i === steps.length - 1, isCurrent: i === currentStep, isCompleted: i < currentStep, isFuture: i > currentStep })))));
};

const toPrecision = (number, precision = 2) => {
    const p = Math.pow(10, precision);
    const n = number * p * (1 + Number.EPSILON);
    return Math.round(n) / p;
};
const normalize = (value, minVal, maxVal, minTarget, maxTarget) => {
    return (minTarget + ((value - minVal) * (maxTarget - minTarget)) / (maxVal - minVal));
};

const GLOW_RGB = {
    base: [25, 25, 25],
    success: [32, 60, 0],
    error: [118, 25, 0],
    warning: [79, 56, 0],
    info: [0, 53, 118],
};
/**
 * Apply a subtle shaddow, and lift a surface off the background.
 *

 * @example
 * ```tsx
 * <Elevated asChild distance={0.4} angle={45}>
 *   <AvatarRoot/>
 * </Elevated>
 * ```
 */
const Elevated = (props) => {
    const { asChild, className, enabled = true, angle = 45, distance = 0.25, contrast = 0, color = 'base', invert, dataTestId, ...rest } = props;
    const Comp = asChild ? Slot : 'div';
    const elevationShadow = useMemo(() => {
        if (!enabled)
            return 'none';
        const opacityOffset = toPrecision(normalize(contrast, 0, 1, 0, 0.15), 2);
        const maxContrast = invert ? 0.65 : 0.25;
        const minContrast = invert ? 0.5 : 0.1;
        const opacity = toPrecision(normalize(distance, 0, 1, maxContrast + opacityOffset, minContrast + opacityOffset), 2);
        const minBlur = 5 + toPrecision(normalize(contrast, 0, 1, 0, -2), 2);
        const maxBlur = 18 + toPrecision(normalize(contrast, 0, 1, 0, -8));
        const blur = toPrecision(normalize(distance, 0, 1, minBlur, maxBlur));
        const spread = toPrecision(normalize(distance, 0, 1, -4, 0));
        const radians = (angle * Math.PI) / 180;
        const offset = 3;
        const minX = offset + Math.cos(radians);
        const maxX = offset + blur * Math.cos(radians);
        const minY = offset + Math.sin(radians);
        const maxY = offset + blur * Math.sin(radians);
        const offsetX = toPrecision(normalize(distance, 0, 1, minX, maxX));
        const offsetY = toPrecision(normalize(distance, 0, 1, minY, maxY));
        const rgba = color in GLOW_RGB
            ? `rgba(${GLOW_RGB[color].join(', ')}, ${opacity})`
            : color;
        return `${offsetX}px ${offsetY}px ${blur}px ${spread}px ${rgba}`;
    }, [enabled, invert, distance, contrast, angle, color]);
    return (React.createElement(Comp, { "data-test-id": dataTestId, "data-uds-child": "elevated", className: tw$2(className, css `
          box-shadow: ${elevationShadow};
        `), ...rest }));
};

const Bleed = props => {
    const { dataTestId, className, children, ...rest } = props;
    return (React.createElement("div", { className: tw$2('relative w-screen left-1/2 right-1/2 -ml-[50vw] -mr-[50vw] px-0 sm:px-0', className), "data-uds-child": "bleed", "data-test-id": dataTestId, ...rest },
        React.createElement("div", { className: "max-w-screen-4xl mx-auto" }, children)));
};

const containerStyle = (0,style/* style */.oB)({
    base: '',
    variants: {
        /**
         * Container Size (Responsive variant)
         *
         * @example
         *
         * ```
         * <Container  size={{_:md, md:'lg'}}>
         *   ...
         * </Container>
         * ```
         */
        size: {
            xs: 'max-w-screen-2xs',
            sm: 'max-w-[512px]',
            md: 'max-w-screen-md',
            lg: 'max-w-screen-lg',
            xl: 'max-w-[1312px]',
            base: 'max-w-screen-3xl',
            page: 'max-w-screen-3xl px-4 md:px-8 lg:px-10',
            bleed: 'max-w-screen-4xl',
        },
    },
});
/**
 * The `Container` is used to create a horizontally centered content container, and configure
 * its maximum width
 *
 * @example
 *
 * ```
 * <Container  size="md">
 *   ...
 * </Container>
 * ```
 */
const Container = react.forwardRef((props, forwadedRef) => {
    const { asChild, dataTestId, size = 'base', className, ...rest } = props;
    const Comp = asChild ? $5e63c961fc1ce211$export$8c6ed5c666ac1360 : 'div';
    return (react.createElement(Comp, { ref: forwadedRef, "data-test-id": dataTestId, "data-uds-child": "container", className: (0,style.tw)('w-full mx-auto', containerStyle({ size }), className), ...rest }));
});
Container.displayName = 'Container';

const separatorStyle = (0,style/* style */.oB)({
    variants: {
        /**
         * The visual and semantic orientation of the separator. Sets both the visual direction and the margin axis
         *
         * @defaultValue horizontal
         * @example
         * ```jsx
         * <Separator orientation="vertical" />
         * ```
         */
        orientation: {
            horizontal: 'w-full h-px',
            vertical: 'w-px h-auto self-stretch',
        },
        /**
         * Use on dark backgrounds
         */
        invert: {
            true: 'text-neutral-70 bg-neutral-80',
            false: 'text-neutral-30 bg-neutral-20',
        },
        variant: {
            transparent: style/* css */.iv `
        @apply bg-transparent;
        color: inherit;
      `,
            line: '',
            dashed: style/* css */.iv `
        background-color: transparent;
        background-image: linear-gradient(
          to right,
          currentColor 40%,
          rgba(255, 255, 255, 0) 0%
        );
        background-position: top;
        background-size: 12px 1px;
        background-repeat: repeat-x;
      `,
            dot: style/* css */.iv `
        position: relative;
        background-color: transparent;
        &:after {
          content: '';
          display: block;
          width: 4px;
          height: 4px;
          border-radius: 50%;
          background-color: currentColor;
          position: absolute;
          left: 50%;
          top: calc(50% + 3px);
          transform: translate(-50%, -50%);
        }
      `,
        },
        /**
         * Responsive margin before and after the separator
         *
         * @example
         * ```jsx
         * <Separator gap="none" />
         * ```
         *
         * @example
         * ```jsx
         * <Separator gap={{_:'sm', md:'base'}} />
         * ```
         */
        gap: {
            min: '',
            auto: '',
            max: '',
            none: '',
            px: '',
            xxs: '',
            xs: '',
            sm: '',
            base: '',
            md: '',
            lg: '',
            xl: '',
            '2xl': '',
            '3xl': '',
            '4xl': '',
            '5xl': '',
        },
        asChild: {
            true: 'h-auto',
            false: '',
        },
    },
    matches: [
        {
            orientation: 'horizontal',
            gap: 'min',
            use: `my-${UDS_GAP.min} mx-0`,
        },
        {
            orientation: 'horizontal',
            gap: 'auto',
            use: `my-${UDS_GAP.auto} mx-0`,
        },
        {
            orientation: 'horizontal',
            gap: 'max',
            use: `my-${UDS_GAP.max} mx-0`,
        },
        {
            orientation: 'horizontal',
            gap: 'none',
            use: `my-${UDS_GAP.none} mx-0`,
        },
        {
            orientation: 'horizontal',
            gap: 'px',
            use: `my-${UDS_GAP.px} mx-0`,
        },
        {
            orientation: 'horizontal',
            gap: 'xxs',
            use: `my-${UDS_GAP.xxs} mx-0`,
        },
        {
            orientation: 'horizontal',
            gap: 'xs',
            use: `my-${UDS_GAP.xs} mx-0`,
        },
        {
            orientation: 'horizontal',
            gap: 'sm',
            use: `my-${UDS_GAP.sm} mx-0`,
        },
        {
            orientation: 'horizontal',
            gap: 'base',
            use: `my-${UDS_GAP.base} mx-0`,
        },
        {
            orientation: 'horizontal',
            gap: 'lg',
            use: `my-${UDS_GAP.lg} mx-0`,
        },
        {
            orientation: 'horizontal',
            gap: 'xl',
            use: `my-${UDS_GAP.xl} mx-0`,
        },
        {
            orientation: 'horizontal',
            gap: '2xl',
            use: `my-${UDS_GAP['2xl']} mx-0`,
        },
        {
            orientation: 'horizontal',
            gap: '3xl',
            use: `my-${UDS_GAP['3xl']} mx-0`,
        },
        {
            orientation: 'horizontal',
            gap: '4xl',
            use: `my-${UDS_GAP['4xl']} mx-0`,
        },
        {
            orientation: 'horizontal',
            gap: '5xl',
            use: `my-${UDS_GAP['5xl']} mx-0`,
        },
        {
            orientation: 'vertical',
            gap: 'min',
            use: `mx-${UDS_GAP.min} my-0`,
        },
        {
            orientation: 'vertical',
            gap: 'auto',
            use: `mx-${UDS_GAP.auto} my-0`,
        },
        {
            orientation: 'vertical',
            gap: 'max',
            use: `mx-${UDS_GAP.max} my-0`,
        },
        {
            orientation: 'vertical',
            gap: 'none',
            use: `mx-${UDS_GAP.none} my-0`,
        },
        {
            orientation: 'vertical',
            gap: 'px',
            use: `mx-${UDS_GAP.px} my-0`,
        },
        {
            orientation: 'vertical',
            gap: 'xxs',
            use: `mx-${UDS_GAP.xxs} my-0`,
        },
        {
            orientation: 'vertical',
            gap: 'xs',
            use: `mx-${UDS_GAP.xs} my-0`,
        },
        {
            orientation: 'vertical',
            gap: 'sm',
            use: `mx-${UDS_GAP.sm} my-0`,
        },
        {
            orientation: 'vertical',
            gap: 'base',
            use: `mx-${UDS_GAP.base} my-0`,
        },
        {
            orientation: 'vertical',
            gap: 'lg',
            use: `mx-${UDS_GAP.lg} my-0`,
        },
        {
            orientation: 'vertical',
            gap: 'xl',
            use: `mx-${UDS_GAP.xl} my-0`,
        },
        {
            orientation: 'vertical',
            gap: '2xl',
            use: `mx-${UDS_GAP['2xl']} my-0`,
        },
        {
            orientation: 'vertical',
            gap: '3xl',
            use: `mx-${UDS_GAP['3xl']} my-0`,
        },
        {
            orientation: 'vertical',
            gap: '4xl',
            use: `mx-${UDS_GAP['4xl']} my-0`,
        },
        {
            orientation: 'vertical',
            gap: '5xl',
            use: `mx-${UDS_GAP['5xl']} my-0`,
        },
        {
            variant: 'transparent',
            orientation: 'horizontal',
            gap: 'min',
            use: `mt-${UDS_GAP.min} mb-0 mx-0`,
        },
        {
            variant: 'transparent',
            orientation: 'horizontal',
            gap: 'auto',
            use: `mt-${UDS_GAP.auto} mb-0 mx-0`,
        },
        {
            variant: 'transparent',
            orientation: 'horizontal',
            gap: 'max',
            use: `mt-${UDS_GAP.max} mb-0 mx-0`,
        },
        {
            variant: 'transparent',
            orientation: 'horizontal',
            gap: 'none',
            use: `mt-${UDS_GAP.none} mb-0 mx-0`,
        },
        {
            variant: 'transparent',
            orientation: 'horizontal',
            gap: 'px',
            use: `mt-${UDS_GAP.px} mb-0 mx-0`,
        },
        {
            variant: 'transparent',
            orientation: 'horizontal',
            gap: 'xxs',
            use: `mt-${UDS_GAP.xxs} mb-0 mx-0`,
        },
        {
            variant: 'transparent',
            orientation: 'horizontal',
            gap: 'xs',
            use: `mt-${UDS_GAP.xs} mb-0 mx-0`,
        },
        {
            variant: 'transparent',
            orientation: 'horizontal',
            gap: 'sm',
            use: `mt-${UDS_GAP.sm} mb-0 mx-0`,
        },
        {
            variant: 'transparent',
            orientation: 'horizontal',
            gap: 'base',
            use: `mt-${UDS_GAP.base} mb-0 mx-0`,
        },
        {
            variant: 'transparent',
            orientation: 'horizontal',
            gap: 'lg',
            use: `mt-${UDS_GAP.lg} mb-0 mx-0`,
        },
        {
            variant: 'transparent',
            orientation: 'horizontal',
            gap: 'xl',
            use: `mt-${UDS_GAP.xl} mb-0 mx-0`,
        },
        {
            variant: 'transparent',
            orientation: 'horizontal',
            gap: '2xl',
            use: `mt-${UDS_GAP['2xl']} mb-0 mx-0`,
        },
        {
            variant: 'transparent',
            orientation: 'horizontal',
            gap: '3xl',
            use: `mt-${UDS_GAP['3xl']} mb-0 mx-0`,
        },
        {
            variant: 'transparent',
            orientation: 'horizontal',
            gap: '4xl',
            use: `mt-${UDS_GAP['4xl']} mb-0 mx-0`,
        },
        {
            variant: 'transparent',
            orientation: 'horizontal',
            gap: '5xl',
            use: `mt-${UDS_GAP['5xl']} mb-0 mx-0`,
        },
        {
            variant: 'transparent',
            orientation: 'vertical',
            gap: 'min',
            use: `ml--${UDS_GAP.min} mr-0 rtl:(ml-0 mr--${UDS_GAP.min}) my-0`,
        },
        {
            variant: 'transparent',
            orientation: 'vertical',
            gap: 'auto',
            use: `ml--${UDS_GAP.auto} mr-0 rtl:(ml-0 mr--${UDS_GAP.auto}) my-0`,
        },
        {
            variant: 'transparent',
            orientation: 'vertical',
            gap: 'max',
            use: `ml--${UDS_GAP.max} mr-0 rtl:(ml-0 mr--${UDS_GAP.max}) my-0`,
        },
        {
            variant: 'transparent',
            orientation: 'vertical',
            gap: 'none',
            use: `ml-${UDS_GAP.none} mr-0 rtl:(ml-0 mr-${UDS_GAP.none}) my-0`,
        },
        {
            variant: 'transparent',
            orientation: 'vertical',
            gap: 'px',
            use: `ml-${UDS_GAP.px} mr-0 rtl:(ml-0 mr-${UDS_GAP.px}) my-0`,
        },
        {
            variant: 'transparent',
            orientation: 'vertical',
            gap: 'xxs',
            use: `ml-${UDS_GAP.xxs} mr-0 rtl:(ml-0 mr-${UDS_GAP.xxs}) my-0`,
        },
        {
            variant: 'transparent',
            orientation: 'vertical',
            gap: 'xs',
            use: `ml-${UDS_GAP.xs} mr-0 rtl:(ml-0 mr-${UDS_GAP.xs}) my-0`,
        },
        {
            variant: 'transparent',
            orientation: 'vertical',
            gap: 'sm',
            use: `ml-${UDS_GAP.sm} mr-0 rtl:(ml-0 mr-${UDS_GAP.sm}) my-0`,
        },
        {
            variant: 'transparent',
            orientation: 'vertical',
            gap: 'base',
            use: `ml-${UDS_GAP.base} mr-0 rtl:(ml-0 mr-${UDS_GAP.base}) my-0`,
        },
        {
            variant: 'transparent',
            orientation: 'vertical',
            gap: 'lg',
            use: `ml-${UDS_GAP.lg} mr-0 rtl:(ml-0 mr-${UDS_GAP.lg}) my-0`,
        },
        {
            variant: 'transparent',
            orientation: 'vertical',
            gap: 'xl',
            use: `ml-${UDS_GAP.xl} rtl:(ml-0 mr-${UDS_GAP.xl}) my-0`,
        },
        {
            variant: 'transparent',
            orientation: 'vertical',
            gap: '2xl',
            use: `ml-${UDS_GAP['2xl']} rtl:(ml-0 mr-${UDS_GAP['2xl']}) my-0`,
        },
        {
            variant: 'transparent',
            orientation: 'vertical',
            gap: '3xl',
            use: `ml-${UDS_GAP['3xl']} rtl:(ml-0 mr-${UDS_GAP['3xl']}) my-0`,
        },
        {
            variant: 'transparent',
            orientation: 'vertical',
            gap: '4xl',
            use: `ml-${UDS_GAP['4xl']} rtl:(ml-0 mr-${UDS_GAP['4xl']}) my-0`,
        },
        {
            variant: 'transparent',
            orientation: 'vertical',
            gap: '5xl',
            use: `ml-${UDS_GAP['5xl']} rtl:(ml-0 mr-${UDS_GAP['5xl']}) my-0`,
        },
        {
            orientation: 'vertical',
            variant: 'dashed',
            use: style/* css */.iv `
        background-color: transparent;
        background-image: linear-gradient(
          to bottom,
          currentColor 40%,
          rgba(255, 255, 255, 0) 0%
        );
        background-position: top;
        background-size: 1px 12px;
        background-repeat: repeat-y;
      `,
        },
        {
            asChild: true,
            use: 'h-auto w-auto bg-transparent',
        },
    ],
    defaults: {
        invert: false,
    },
});
/**
 * The `Separator` component is a visual, thematic and contextual content separator.
 *
 * It can be rendered as a line, dashed, or single dot
 *
 *
 * @example
 *
 * ```jsx
 * <Separator variant="dashed" orientation="horizontal"/>
 * ```
 *
 * @example
 * ```jsx
 * <Separator gap={{_:'sm', md:'base'}} />
 * ```
 */
const Separator = react.forwardRef((props, forwadedRef) => {
    const { variant = 'line', orientation = 'horizontal', role = 'separator', invert = false, gap = 'base', className, dataTestId, asChild, ...rest } = props;
    const Comp = asChild ? $5e63c961fc1ce211$export$8c6ed5c666ac1360 : 'div';
    return (react.createElement(Comp, { ref: forwadedRef, role: role, "data-uds-child": "separator", "aria-orientation": orientation, "data-test-id": dataTestId, className: (0,style.tw)(className, separatorStyle({
            gap: gap,
            variant: variant,
            orientation: orientation,
            invert,
            asChild,
        })), ...rest }));
});
Separator.displayName = 'Separator';

/**
 * The `Divider` is a component, that doesn't render an HTML element itself, but instead renders a separator between each child.
 *
 * By default, it renders a `Separator` component, but you can also pass a custom react node using the `separator` prop.
 *
 * @example
 * ```tsx
 * <Divider variant="dash">
 *    <div>...</div>
 *    <div>...</div>
 * </Divider>
 * ```
 *
 */
const Divider = props => {
    const { separator, gap = 'none', variant, orientation, invert, role, children, } = props;
    return react.Children.map(children, (child, index) => [
        child,
        index < react.Children.count(children) - 1 &&
            (0,react.cloneElement)(react.createElement(Separator, null), {
                gap: gap,
                orientation: orientation,
                invert: invert,
                role: role,
                variant: variant,
                asChild: separator ? true : false,
            }, separator),
    ]);
};

const floatStyle = (0,style/* style */.oB)({
    base: 'max-w-fit absolute z-[3] flex items-center justify-center',
    variants: {
        align: {
            top: 'top-0 bottom-auto',
            middle: 'top-1/2 transform -translate-y-1/2',
            bottom: '-bottom-0 top-auto',
        },
        justify: {
            start: 'left-0 right-auto text-left rtl:(right-0 left-auto text-right)',
            center: 'left-1/2 text-center transform -translate-x-1/2',
            end: 'right-0 left-auto text-right rtl:(left-0 right-auto text-left)',
        },
        invert: {
            true: 'text-white',
            false: 'text-neutral',
        },
        inset: {
            none: '',
            px: '',
            xs: '',
            sm: '',
            base: '',
            md: '',
            lg: '',
            xl: '',
            '2xl': '',
            '3xl': '',
            '4xl': '',
            '5xl': '',
        },
        insetX: {
            none: 'px-0',
            px: 'px-px',
            xs: 'px-2',
            sm: 'px-4',
            base: 'px-6',
            md: 'px-8',
            lg: 'px-12',
            xl: 'px-14',
            '2xl': 'px-16',
            '3xl': 'px-20',
            '4xl': 'px-28',
            '5xl': 'px-36',
        },
        insetY: {
            none: 'py-0',
            px: 'py-px',
            xs: 'py-2',
            sm: 'py-4',
            base: 'py-6',
            md: 'py-8',
            lg: 'py-12',
            xl: 'py-14',
            '2xl': 'py-16',
            '3xl': 'py-20',
            '4xl': 'py-28',
            '5xl': 'py-36',
        },
    },
    matches: [
        {
            align: 'middle',
            justify: 'center',
            use: 'text-center top-1/2 transform -translate-y-1/2 left-1/2 -translate-x-1/2',
        },
    ],
});
/**
 * Float is a floating content container, that can be positioned anywhere over another element.
 *
 * Use it to render badges, icons, buttons and other floating content.
 *
 * @example
 * ```jsx
 * <Float>
 *   <Badge icon="start" label="Exclusive"/>
 * </Float>
 * ```
 */
const Float = ({ children, align = 'top', justify = 'start', interactive = true, inset, insetX, insetY, invert, className, dataTestId, asChild, ...rest }) => {
    const Comp = asChild ? $5e63c961fc1ce211$export$8c6ed5c666ac1360 : 'div';
    return (react.createElement(Comp, { "data-uds-child": "float", "data-test-id": dataTestId, ...rest, className: (0,style.tw)(!interactive && 'pointer-events-none', floatStyle({
            invert,
            align,
            justify,
            inset,
            insetX: insetX ?? inset,
            insetY: insetY ?? inset,
        }), className) }, children));
};

const gridStyle$1 = (0,style/* style */.oB)({
    base: 'w-full grid',
    variants: {
        /**
         * Responsive align grid children along the Y axis
         */
        align: {
            start: 'items-start',
            center: 'items-center',
            auto: 'items-stretch',
            end: 'items-end',
        },
        /**
         * Responsive justify grid children along the X axis
         */
        justify: {
            start: 'justify-items-start',
            center: 'justify-items-center',
            auto: 'justify-items-auto',
            end: 'justify-items-end',
        },
        /**
         * Responsive Grid columns. By default, `columns=auto` is selected, and grid children will be distributed equally.
         *
         * defaultValue auto
         *
         * @example
         * Default use case, three equal columns
         * ```
         * <Grid asChild>
         *   <ul>
         *     <li>Et mollit voluptate ad do quis.</li>
         *     <li>Et mollit voluptate ad do quis.</li>
         *     <li>Et mollit voluptate ad do quis.</li>
         *   </ul>
         * </Grid>
         *
         * @example
         * Responsive Grid columns
         * <Grid columns={{_: "2", md: "6"}} />
         * ```
         */
        columns: {
            auto: 'grid-flow-col auto-cols-fr',
            '1': 'grid-cols-1',
            '2': 'grid-cols-2',
            '3': 'grid-cols-3',
            '4': 'grid-cols-4',
            '5': 'grid-cols-5',
            '6': 'grid-cols-6',
            '7': 'grid-cols-7',
            '8': 'grid-cols-8',
            '9': 'grid-cols-9',
            '10': 'grid-cols-10',
            '11': 'grid-cols-11',
            '12': 'grid-cols-12',
        },
    },
});
/**
 * The Grid is a simply layout component wrapped around css grid specification. It is used as a way to
 * declaratively define a grid system.
 *
 * @example auto flow
 * ```
 * <Grid>
 *   <li>Et mollit voluptate ad do quis.</li>
 *   <li>Et mollit voluptate ad do quis.</li>
 *   <li>Et mollit voluptate ad do quis.</li>
 * </Grid>
 * ```
 *
 * @example responsive columns
 * ```
 * <Grid columns={{_:1, md:3}}>
 *   <li>Et mollit voluptate ad do quis.</li>
 *   <li>Et mollit voluptate ad do quis.</li>
 *   <li>Et mollit voluptate ad do quis.</li>
 * </Grid>
 * ```
 *
* - By default renders a div. To render as a custom element, use the `asChild` prop

 */
const Grid = react.forwardRef((props, forwardedRef) => {
    const { asChild, dataTestId, css: whatIsThis, // TODO find out why this is here
    gap = 'base', gapX, gapY, columns = 'auto', align, justify, className, children, ...rest } = props;
    const Comp = asChild ? $5e63c961fc1ce211$export$8c6ed5c666ac1360 : 'div';
    return (react.createElement(Comp, { ref: forwardedRef, className: (0,style.tw)(gridStyle$1({
            columns,
            align,
            justify,
        }), gapStyle({ gap, gapX, gapY }), className), "data-test-id": dataTestId, ...rest }, children));
});
Grid.displayName = 'Grid';

const gridStyle = (0,style/* style */.oB)({
    variants: {
        /**
         * Align cell along both axes.
         *
         * @example
         * use `place=center` to center the grid cell.
         * ```
         * <GridCell place="center />
         * ```
         */
        place: {
            start: 'place-self-start',
            center: 'place-self-center',
            auto: 'place-self-auto',
            end: 'place-self-end',
        },
        /**
         * Align grid children along the Y axis
         */
        align: {
            start: 'self-start',
            center: 'self-center',
            auto: 'self-auto',
            end: 'self-end',
        },
        /**
         * Align grid children along the X axis
         */
        justify: {
            start: 'justify-self-start',
            center: 'justify-self-center',
            auto: 'justify-self-auto',
            end: 'justify-self-end',
        },
        /**
         * GridCell column span, configure a cell to span to a custom number of columns.
         *
         * @example
         *
         * ```jsx
         * <Grid>
         *  <GridCell colSpan="2}/>
         * </Grid>
         * ```
         *
         * @example responsive
         *
         * ```jsx
         * <GridCell colSpan={{ _:'auto', md: 2}}/>
         * ```
         */
        colSpan: {
            auto: 'col-span-auto',
            full: 'col-span-full',
            '1': 'col-span-1',
            '2': 'col-span-2',
            '3': 'col-span-3',
            '4': 'col-span-4',
            '5': 'col-span-5',
            '6': 'col-span-6',
            '7': 'col-span-7',
        },
        /**
         * GridCell column start, configure a cell to render at a particular column index
         *
         * @example
         *
         * ```jsx
         * <Grid>
         *  <GridCell colStart={2} />
         * </Grid>
         * ```
         *
         * @example responsive
         *
         * ```jsx
         * <GridCell colStart={{ _:'auto', md: 2}}/>
         * ```
         */
        colStart: {
            auto: 'col-start-auto',
            '1': 'col-start-1',
            '2': 'col-start-2',
            '3': 'col-start-3',
            '4': 'col-start-4',
            '5': 'col-start-5',
            '6': 'col-start-6',
            '7': 'col-start-7',
        },
        /**
         * GridCell row span, configure a cell to span to a custom number of rows.
         *
         * @example
         *
         * ```jsx
         * <Grid>
         *  <GridCell rowSpan={2} />
         * </Grid>
         * ```
         *
         * @example responsive
         *
         * ```jsx
         * <GridCell rowSpan={{ _:'auto', md: 2}}/>
         * ```
         */
        rowSpan: {
            auto: 'row-span-auto',
            full: 'row-span-full',
            '1': 'row-span-1',
            '2': 'row-span-2',
            '3': 'row-span-3',
            '4': 'row-span-4',
            '5': 'row-span-5',
            '6': 'row-span-6',
            '7': 'row-span-7',
        },
        /**
         * GridCell row start, configure a cell to start at a specific row index.
         *
         * @example
         *
         * ```jsx
         * <Grid>
         *  <GridCell rowStart={2} />
         * </Grid>
         * ```
         *
         * @example responsive
         *
         * ```jsx
         * <GridCell rowStart={{ _:'auto', md: 2}}/>
         * ```
         */
        rowStart: {
            auto: 'row-start-auto',
            '1': 'row-start-1',
            '2': 'row-start-2',
            '3': 'row-start-3',
            '4': 'row-start-4',
            '5': 'row-start-5',
            '6': 'row-start-6',
            '7': 'row-start-7',
        },
    },
});
/**
 * The `GridCell` is always found directly nested within a `Grid` component.
 *
 * @example
 * Usage in a 2:1 grid
 * ```
 * <Grid columns="3" >
 *   <GridCell colSpan="2"/>
 *   <GridCell colSpan="1"/>
 * </Grid>
 * ```
 */
const GridCell = react.forwardRef((props, forwardedRef) => {
    const { asChild, dataTestId, css: whatIsThis, // TODO find out why this is here
    justify, align, place, colSpan, colStart, rowSpan, rowStart, className, children, ...rest } = props;
    const Comp = asChild ? $5e63c961fc1ce211$export$8c6ed5c666ac1360 : 'div';
    return (react.createElement(Comp, { ref: forwardedRef, className: (0,style.tw)(gridStyle({
            justify,
            align,
            place,
            colSpan,
            colStart,
            rowSpan,
            rowStart,
        }), className), "data-uds-child": "grid-cell", "data-test-id": dataTestId, ...rest }, children));
});
GridCell.displayName = 'GridCell';

const spacerStyle = (0,style/* style */.oB)({
    variants: {
        /**
         * The visual orientation of the divider. Sets the margin axis
         *
         * @defaultValue horizontal
         * @example
         * ```jsx
         * <Spacer orientation="vertical" />
         * ```
         */
        orientation: {
            horizontal: 'w-full h-0',
            vertical: 'w-0',
        },
        /**
         * Responsive margin before and after the spacer
         *
         * @example
         * ```jsx
         * <Spacer gap="none" />
         * ```
         *
         * @example
         * ```jsx
         * <Spacer gap={{_:'sm', md:'base'}} />
         * ```
         */
        gap: {
            min: '',
            auto: '',
            max: '',
            none: '',
            px: '',
            xxs: '',
            xs: '',
            sm: '',
            base: '',
            md: '',
            lg: '',
            xl: '',
            '2xl': '',
            '3xl': '',
            '4xl': '',
            '5xl': '',
        },
    },
    matches: [
        {
            orientation: 'horizontal',
            gap: 'min',
            use: `mt-${UDS_GAP.min} mb-0 mx-0`,
        },
        {
            orientation: 'horizontal',
            gap: 'auto',
            use: `mt-${UDS_GAP.auto} mb-0 mx-0`,
        },
        {
            orientation: 'horizontal',
            gap: 'max',
            use: `mt-${UDS_GAP.max} mb-0 mx-0`,
        },
        {
            orientation: 'horizontal',
            gap: 'none',
            use: `mt-${UDS_GAP.none} mb-0 mx-0`,
        },
        {
            orientation: 'horizontal',
            gap: 'px',
            use: `mt-${UDS_GAP.px} mb-0 mx-0`,
        },
        {
            orientation: 'horizontal',
            gap: 'xxs',
            use: `mt-${UDS_GAP.xxs} mb-0 mx-0`,
        },
        {
            orientation: 'horizontal',
            gap: 'xs',
            use: `mt-${UDS_GAP.xs} mb-0 mx-0`,
        },
        {
            orientation: 'horizontal',
            gap: 'sm',
            use: `mt-${UDS_GAP.sm} mb-0 mx-0`,
        },
        {
            orientation: 'horizontal',
            gap: 'base',
            use: `mt-${UDS_GAP.base} mb-0 mx-0`,
        },
        {
            orientation: 'horizontal',
            gap: 'lg',
            use: `mt-${UDS_GAP.lg} mb-0 mx-0`,
        },
        {
            orientation: 'horizontal',
            gap: 'xl',
            use: `mt-${UDS_GAP.xl} mb-0 mx-0`,
        },
        {
            orientation: 'horizontal',
            gap: '2xl',
            use: `mt-${UDS_GAP['2xl']} mb-0 mx-0`,
        },
        {
            orientation: 'horizontal',
            gap: '3xl',
            use: `mt-${UDS_GAP['3xl']} mb-0 mx-0`,
        },
        {
            orientation: 'horizontal',
            gap: '4xl',
            use: `mt-${UDS_GAP['4xl']} mb-0 mx-0`,
        },
        {
            orientation: 'horizontal',
            gap: '5xl',
            use: `mt-${UDS_GAP['5xl']} mb-0 mx-0`,
        },
        {
            orientation: 'vertical',
            gap: 'min',
            use: `ml--${UDS_GAP.min} mr-0 rtl:(ml-0 mr--${UDS_GAP.min}) my-0`,
        },
        {
            orientation: 'vertical',
            gap: 'auto',
            use: `ml--${UDS_GAP.auto} mr-0 rtl:(ml-0 mr--${UDS_GAP.auto}) my-0`,
        },
        {
            orientation: 'vertical',
            gap: 'max',
            use: `ml--${UDS_GAP.max} mr-0 rtl:(ml-0 mr--${UDS_GAP.max}) my-0`,
        },
        {
            orientation: 'vertical',
            gap: 'none',
            use: `ml-${UDS_GAP.none} mr-0 rtl:(ml-0 mr-${UDS_GAP.none}) my-0`,
        },
        {
            orientation: 'vertical',
            gap: 'px',
            use: `ml-${UDS_GAP.px} mr-0 rtl:(ml-0 mr-${UDS_GAP.px}) my-0`,
        },
        {
            orientation: 'vertical',
            gap: 'xxs',
            use: `ml-${UDS_GAP.xxs} mr-0 rtl:(ml-0 mr-${UDS_GAP.xxs}) my-0`,
        },
        {
            orientation: 'vertical',
            gap: 'xs',
            use: `ml-${UDS_GAP.xs} mr-0 rtl:(ml-0 mr-${UDS_GAP.xs}) my-0`,
        },
        {
            orientation: 'vertical',
            gap: 'sm',
            use: `ml-${UDS_GAP.sm} mr-0 rtl:(ml-0 mr-${UDS_GAP.sm}) my-0`,
        },
        {
            orientation: 'vertical',
            gap: 'base',
            use: `ml-${UDS_GAP.base} mr-0 rtl:(ml-0 mr-${UDS_GAP.base}) my-0`,
        },
        {
            orientation: 'vertical',
            gap: 'lg',
            use: `ml-${UDS_GAP.lg} mr-0 rtl:(ml-0 mr-${UDS_GAP.lg}) my-0`,
        },
        {
            orientation: 'vertical',
            gap: 'xl',
            use: `ml-${UDS_GAP.xl} rtl:(ml-0 mr-${UDS_GAP.xl}) my-0`,
        },
        {
            orientation: 'vertical',
            gap: '2xl',
            use: `ml-${UDS_GAP['2xl']} rtl:(ml-0 mr-${UDS_GAP['2xl']}) my-0`,
        },
        {
            orientation: 'vertical',
            gap: '3xl',
            use: `ml-${UDS_GAP['3xl']} rtl:(ml-0 mr-${UDS_GAP['3xl']}) my-0`,
        },
        {
            orientation: 'vertical',
            gap: '4xl',
            use: `ml-${UDS_GAP['4xl']} rtl:(ml-0 mr-${UDS_GAP['4xl']}) my-0`,
        },
        {
            orientation: 'vertical',
            gap: '5xl',
            use: `ml-${UDS_GAP['5xl']} rtl:(ml-0 mr-${UDS_GAP['5xl']}) my-0`,
        },
    ],
});
/**
 * The `Spacer` component is vertical or hozitonal spacer between elements.
 *
 * @example
 * ```jsx
 * <Spacer gap="base"/>
 * ```
 *
 * @example
 * ```jsx
 * <Spacer gap={{_:'sm', md:'base'}} />
 * ```
 */
const Spacer = react.forwardRef((props, forwadedRef) => {
    const { orientation = 'horizontal', gap = 'base', className, dataTestId, ...rest } = props;
    return (react.createElement("div", { ref: forwadedRef, "data-uds-child": "spacer", "data-test-id": dataTestId, className: (0,style.tw)('flex-none', className, spacerStyle({
            gap: gap,
            orientation: orientation,
        })), ...rest }));
});
Spacer.displayName = 'Spacer';

const DialogContext = (0,react.createContext)(undefined);
const DialogProvider = ({ children, value, }) => react.createElement(DialogContext.Provider, { value: value }, children);
const useDialogContext = () => {
    const context = (0,react.useContext)(DialogContext);
    if (!context) {
        throw new Error('useDialogContext must be used within a DialogProvider');
    }
    return context;
};

/**
 * The `DialogRoot` component is the root component needed to render a dialog.
 * It wraps the trigger that opens the dialog and the dialog content itself.
 *
 * @example
 * ```
 * <DialogRoot>
 *   <DialogTrigger>Open Dialog</DialogTrigger>
 *   <DialogContent>
 *     <DialogHeader>
 *       <DialogHeading>Title</DialogHeading>
 *     </DialogHeader>
 *     <DialogBody>
 *       <DialogDescription>Description</DialogDescription>
 *     </DialogBody>
 *     <DialogFooter>
 *       <ButtonCta label="Submit" />
 *     </DialogFooter>
 *   </DialogContent>
 * </DialogRoot>
 * ```
 */
const DialogRoot = ({ children, modal = true, autoClose, autoFocus = 'content', invert = false, size = 'md', align = 'center', justify = 'center', drawer = false, dataTestId, open, onOpenChange, onEscapeKeyDown, ...rest }) => {
    const closeButtonRef = (0,react.useRef)();
    const contextProps = {
        modal,
        invert,
        size,
        justify,
        align,
        drawer,
        autoClose,
        autoFocus,
        dataTestId,
        closeButtonRef,
        onOpenChange,
        onEscapeKeyDown,
    };
    return (react.createElement($5d3850c4d0b4e6c7$export$be92b6f5f03c0fe9, { modal: modal, open: open, onOpenChange: onOpenChange, ...rest },
        react.createElement(DialogProvider, { value: contextProps }, children)));
};

const fadeIn$1 = (0,css_css/* animation */.oQ)('0.3s cubic-bezier(0.16, 1, 0.3, 1) forwards', {
    '0%': {
        opacity: 0,
    },
    '100%': {
        opacity: 1,
    },
});
(0,css_css/* animation */.oQ)('0.3s cubic-bezier(0.5, 1, 0.89, 1) forwards', {
    '0%': {
        opacity: 1,
    },
    '100%': {
        opacity: 0,
    },
});
const slideInBottom = (0,css_css/* animation */.oQ)('0.5s cubic-bezier(0.16, 1, 0.3, 1) forwards', {
    '0%': {
        transform: 'translate3d(0, 5%, 0)',
    },
    '100%': {
        transform: 'translate3d(0, 0, 0)',
    },
});
const slideInBottomCentered = (0,css_css/* animation */.oQ)('0.5s cubic-bezier(0.16, 1, 0.3, 1) forwards', {
    '0%': {
        transform: 'translate3d(-50%, -45%, 0)',
    },
    '100%': {
        transform: 'translate3d(-50%, -50%, 0)',
    },
});
const slideInBottomCenteredX = (0,css_css/* animation */.oQ)('0.5s cubic-bezier(0.16, 1, 0.3, 1) forwards', {
    '0%': {
        transform: 'translate3d(-50%, 5%, 0)',
    },
    '100%': {
        transform: 'translate3d(-50%, 0, 0)',
    },
});
const slideInBottomCenteredY = (0,css_css/* animation */.oQ)('0.5s cubic-bezier(0.16, 1, 0.3, 1) forwards', {
    '0%': {
        transform: 'translate3d(0, -45%, 0)',
    },
    '100%': {
        transform: 'translate3d(0, -50%, 0)',
    },
});
const slideInLeft = (0,css_css/* animation */.oQ)('0.6s cubic-bezier(0.16, 1, 0.3, 1) forwards', {
    '0%': {
        transform: 'translate3d(-20%, 0, 0)',
    },
    '100%': {
        transform: 'translate3d(0, 0, 0)',
    },
});
const slideInRight = (0,css_css/* animation */.oQ)('0.6s cubic-bezier(0.16, 1, 0.3, 1) forwards', {
    '0%': {
        transform: 'translate3d(20%, 0, 0)',
    },
    '100%': {
        transform: 'translate3d(0, 0, 0)',
    },
});

const maxAvailableHeight = `
  height: 100vh;
  /* Fixes height of dialog on iOS Safari */
  max-height: -webkit-fill-available;
`;
const overlayStyle = (0,style/* style */.oB)({
    base: style/* css */.iv `
    ${fadeIn$1}
    @apply fixed z-dialog inset-0 flex overflow-y-auto bg-black bg-opacity-50;
  `,
    variants: {
        size: {
            xs: '',
            sm: '',
            md: '',
            lg: '',
            xl: '',
            full: '',
        },
        drawer: {
            true: '',
            false: '',
        },
    },
    matches: [
        {
            drawer: false,
            size: 'xs',
            use: 'p-4 md:p-6',
        },
        {
            drawer: false,
            size: 'sm',
            use: 'p-4 md:p-6',
        },
        {
            drawer: false,
            size: 'md',
            use: 'p-4 md:p-6',
        },
        {
            drawer: false,
            size: 'lg',
            use: 'p-4 md:p-6',
        },
        {
            drawer: false,
            size: 'xl',
            use: 'p-4 md:p-6',
        },
        {
            drawer: false,
            size: 'full',
            use: 'p-0 md:p-0',
        },
        // Drawer
        {
            drawer: true,
            size: 'xs',
            use: 'p-0 md:p-0',
        },
        {
            drawer: true,
            size: 'sm',
            use: 'p-0 md:p-0',
        },
        {
            drawer: true,
            size: 'md',
            use: 'p-0 md:p-0',
        },
        {
            drawer: true,
            size: 'lg',
            use: 'p-0 md:p-0',
        },
        {
            drawer: true,
            size: 'xl',
            use: 'p-0 md:p-0',
        },
        {
            drawer: true,
            size: 'full',
            use: 'p-0 md:p-0',
        },
    ],
});
const contentStyle$2 = (0,style/* style */.oB)({
    base: 'relative flex flex-col w-full overflow-hidden focus-visible:(outline-none ring ring-1 ring-inset ring-offset-1)',
    variants: {
        size: {
            xs: 'max-w-screen-2xs max-h-auto h-auto rounded-md',
            sm: 'max-w-screen-xs max-h-auto h-auto rounded-md',
            md: 'max-w-screen-sm max-h-auto h-auto rounded-md',
            lg: 'max-w-screen-md max-h-auto h-auto rounded-md',
            xl: 'max-w-screen-lg max-h-auto h-auto rounded-md',
            full: style/* css */.iv `
        ${maxAvailableHeight}
        @apply rounded-none max-w-full;
      `,
        },
        modal: {
            true: 'relative w-full',
            // Minus the gutter width either side to prevent dialog from overflowing
            // on smaller screens - necessary as it is a fixed element.
            false: 'fixed w-[calc(100%-2rem)] lg:w-[calc(100%-3rem)] shadow-xl border-1',
        },
        drawer: {
            true: style/* css */.iv `
        ${maxAvailableHeight}
        @apply rounded-none;
      `,
            false: '',
        },
        invert: {
            true: 'bg-neutral-100 text-white border-neutral-80',
            false: 'bg-white text-neutral-100 border-neutral-20',
        },
        align: {
            start: '',
            center: '',
            end: '',
        },
        justify: {
            start: '',
            center: '',
            end: '',
        },
    },
    matches: [
        {
            invert: true,
            size: 'full',
            use: 'bg-neutral-100',
        },
        {
            invert: false,
            size: 'full',
            use: 'bg-white',
        },
        /**
         * Modal dialog
         * - Aligned using margin as it is in a fixed, flex container
         */
        {
            align: 'start',
            modal: true,
            use: 'mb-auto mt-0',
        },
        {
            align: 'center',
            modal: true,
            use: 'my-auto',
        },
        {
            align: 'end',
            modal: true,
            use: 'mt-auto mb-0',
        },
        {
            justify: 'start',
            modal: true,
            drawer: false,
            use: style/* css */.iv `
        ${slideInBottom}
        @apply mr-auto ml-0;
      `,
        },
        {
            justify: 'center',
            modal: true,
            drawer: false,
            use: style/* css */.iv `
        ${slideInBottom}
        @apply mx-auto;
      `,
        },
        {
            justify: 'end',
            modal: true,
            drawer: false,
            use: style/* css */.iv `
        ${slideInBottom}
        @apply ml-auto mr-0;
      `,
        },
        // drawer
        {
            modal: true,
            drawer: true,
            justify: 'start',
            use: style/* css */.iv `
        ${slideInLeft}
        @apply mr-auto ml-0;
      `,
        },
        {
            modal: true,
            drawer: true,
            justify: 'center',
            use: style/* css */.iv `
        ${slideInLeft}
        @apply mr-auto ml-0;
      `,
        },
        {
            modal: true,
            justify: 'end',
            drawer: true,
            use: style/* css */.iv `
        ${slideInRight}
        @apply ml-auto mr-0;
      `,
        },
        /**
         * Non-modal dialog
         * - Fixed positioning
         */
        {
            align: 'start',
            modal: false,
            drawer: false,
            use: style/* css */.iv `
        ${slideInBottom}
        @apply top-6 bottom-auto;
      `,
        },
        {
            align: 'center',
            modal: false,
            drawer: false,
            use: style/* css */.iv `
        ${slideInBottomCenteredY}
        @apply top-1/2 -translate-y-1/2 bottom-auto;
      `,
        },
        {
            align: 'end',
            modal: false,
            drawer: false,
            use: style/* css */.iv `
        ${slideInBottom}
        @apply bottom-6 top-auto;
      `,
        },
        {
            justify: 'start',
            modal: false,
            drawer: false,
            use: 'left-6 right-auto',
        },
        {
            justify: 'center',
            modal: false,
            drawer: false,
            use: style/* css */.iv `
        ${slideInBottomCenteredX}
        @apply left-1/2 -translate-x-1/2 right-auto;
      `,
        },
        {
            justify: 'end',
            modal: false,
            drawer: false,
            use: 'right-6 left-auto',
        },
        {
            align: 'center',
            justify: 'center',
            modal: false,
            drawer: false,
            use: style/* css */.iv `
        ${slideInBottomCentered}
        @apply top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 right-auto bottom-auto;
      `,
        },
        // drawer
        {
            modal: false,
            justify: 'start',
            drawer: true,
            use: style/* css */.iv `
        ${slideInLeft}
        @apply top-0 left-0 right-auto border-r border-t-0 border-b-0 border-l-0',
      `,
        },
        {
            modal: false,
            justify: 'center',
            drawer: true,
            use: style/* css */.iv `
        ${slideInLeft}
        @apply top-0 left-0 right-auto border-r border-l-0 border-t-0 border-b-0',
      `,
        },
        {
            modal: false,
            justify: 'end',
            drawer: true,
            use: style/* css */.iv `
        ${slideInRight}
        @apply top-0 right-0 left-auto border-l border-r-0 border-t-0 border-b-0',
      `,
        },
    ],
});

const DialogContentInner = (0,react.forwardRef)(function DialogContentInner({ children, className, asChild, ...rest }, forwardedRef) {
    const { size, align, justify, modal, invert, drawer, autoClose, dataTestId, autoFocus, closeButtonRef, onOpenChange, onEscapeKeyDown, } = useDialogContext();
    const contentRef = (0,react.useRef)();
    const sharedRef = (0,esm/* useSharedRef */.lD)(forwardedRef, contentRef);
    const handleAutoFocus = (e) => {
        if (autoFocus !== 'close') {
            e.preventDefault();
        }
        if (autoFocus === 'content') {
            contentRef.current.focus();
        }
    };
    // Auto close useEffect
    (0,react.useEffect)(() => {
        let timeout;
        if (autoClose && open) {
            timeout = setTimeout(() => {
                if (onOpenChange) {
                    // Controlled dialogs
                    // Call the onOpenChange callback to close the dialog
                    onOpenChange(false);
                }
                else {
                    // Uncontrolled dialogs
                    // Simulate a click event on the close button to close the dialog
                    closeButtonRef.current.click();
                }
            }, autoClose);
        }
        else {
            // Reset timeout if open={false}
            clearTimeout(timeout);
        }
        // Clean up timeout on unmount
        return () => {
            if (timeout) {
                clearTimeout(timeout);
            }
        };
    }, [autoClose, open, onOpenChange]);
    const currentSize = (0,esm/* useResponsiveValue */.Vt)(size);
    return (react.createElement($5d3850c4d0b4e6c7$export$7c6e2c02157bb7d2, { "data-test-id": dataTestId && `${dataTestId}-content`, "data-uds-child": "dialog-content", className: (0,style.tw)(contentStyle$2({ size, modal, invert, align, justify, drawer }), currentSize === 'full' && 'animate-none', className), onOpenAutoFocus: handleAutoFocus, onEscapeKeyDown: onEscapeKeyDown, asChild: asChild, ref: sharedRef, ...rest }, children));
});
/**
 * The `DialogContent` component is used to wrap the content of a dialog
 * It renders a close button and any children provided, including body and footer.
 *
 * @example
 * ```
 * <DialogContent>
 *   <DialogHeader>
 *     <DialogHeading>Dialog Heading</DialogHeading>
 *   </DialogHeader>
 *   <DialogBody>
 *     <DialogDescription>Dialog Description</DialogDescription>
 *   </DialogBody>
 *   <DialogFooter>
 *     <ButtonCta label="Submit" />
 *   </DialogFooter>
 * </DialogContent>
 * ```
 */
const DialogContent = (0,react.forwardRef)(function DialogContent({ children, ...rest }, forwardedRef) {
    const { size, drawer, modal, dataTestId } = useDialogContext();
    return (react.createElement($5d3850c4d0b4e6c7$export$602eac185826482c, null, modal ? (react.createElement($5d3850c4d0b4e6c7$export$c6fdb837b070b4ff, { className: (0,style.tw)(overlayStyle({ size, drawer })), "data-test-id": dataTestId && `${dataTestId}-overlay`, "data-uds-child": "dialog-overlay" },
        react.createElement(DialogContentInner, { ...rest, ref: forwardedRef }, children))) : (react.createElement(DialogContentInner, { ...rest, ref: forwardedRef }, children))));
});

/**
 * The `DialogTrigger` component should wrap the element opens the dialog.
 * It will render as the child element.
 *
 * @example
 * ```
 * <DialogTrigger>
 *   <ButtonCta label="Open Dialog" />
 * </DialogTrigger>
 * ```
 */
const DialogTrigger = ({ children }) => {
    const { dataTestId } = useDialogContext();
    return (react.createElement($5d3850c4d0b4e6c7$export$2e1e1122cf0cba88, { "data-test-id": dataTestId && `${dataTestId}-trigger`, asChild: true }, children));
};

/**
 * The `DialogHeader` component is used to render a header specifically for Dialogs.
 *
 * @example
 * ```
 * <DialogHeader>
 *   <DialogHeading>Title</DialogHeading>
 * </DialogHeader>
 * ```
 */
const DialogHeader = ({ children, className }) => {
    const { dataTestId, invert, closeButtonRef } = useDialogContext();
    const t = (0,esm/* useUdsTranslate */.oG)();
    return (react.createElement(Container, { asChild: true },
        react.createElement("header", { className: (0,twind.tw)('flex items-start pt-5 pb-4 px-6', className), "data-test-id": dataTestId && `${dataTestId}-header`, "data-uds-child": "dialog-header" },
            children,
            react.createElement($5d3850c4d0b4e6c7$export$f39c2d165cd861fe, { asChild: true },
                react.createElement(ButtonIcon, { className: "absolute flex-shrink-0 top-3.5 right-3 rtl:(left-3 mr-auto)", icon: "close", label: t('close'), variant: "ghost", invert: invert, ref: closeButtonRef, dataTestId: dataTestId && `${dataTestId}-close` })))));
};

/**
 * The `DialogBody` component is used to wrap the body content of a dialog, below the header.
 * It can contain a `DialogDescription` component, forms or any other content.
 *
 * @example
 * ```
 * <DialogBody>
 *   <DialogDescription>Dialog Description</DialogDescription>
 * </DialogBody>
 * ```
 */
const DialogBody = ({ children, className }) => {
    const { dataTestId } = useDialogContext();
    return (react.createElement(Container, { asChild: true },
        react.createElement("div", { "data-test-id": dataTestId && `${dataTestId}-body`, "data-uds-child": "dialog-body", className: (0,twind.tw)('flex-1 px-6', className) }, children)));
};

const footerStyle$2 = (0,style/* style */.oB)({
    base: 'flex gap-4 p-6 children:flex-grow-1',
    variants: {
        size: {
            xs: 'flex-col',
            sm: 'flex-row-reverse flex-wrap sm:max-w-max sm:ml-auto sm:rtl:(mr-auto ml-0)',
            md: 'flex-row-reverse flex-wrap sm:max-w-max sm:ml-auto sm:rtl:(mr-auto ml-0)',
            lg: 'flex-row-reverse flex-wrap sm:max-w-max sm:ml-auto sm:rtl:(mr-auto ml-0) ',
            xl: 'flex-row-reverse flex-wrap sm:max-w-max sm:ml-auto sm:rtl:(mr-auto ml-0)',
            full: 'flex-row-reverse flex-wrap sm:max-w-max sm:ml-auto sm:rtl:(mr-auto ml-0)',
        },
        bleed: {
            true: 'w-full sm:max-w-full',
            false: '',
        },
    },
});
/**
 * The `DialogFooter` component wraps the call to actions of a dialog.
 * It can contain `ButtonCta` and `LinkCta` components.
 *
 * @example
 * ```
 * <DialogFooter>
 *   <ButtonCta label="Cancel" />
 *   <LinkCta label="Go to Homepage" href="/" />
 * </DialogFooter>
 * ```
 */
const DialogFooter = ({ children, bleed, className, }) => {
    const { size, dataTestId } = useDialogContext();
    return (react.createElement(Container, null,
        react.createElement("div", { "data-test-id": dataTestId && `${dataTestId}-footer`, className: (0,twind.tw)(footerStyle$2({ size, bleed }), className) }, children)));
};

/**
 * The `DialogHeading` component is used to render a heading specifically for Dialogs.
 *
 * It's a wrapper around the Heading component with some different defaults.
 *
 * By default renders a h1. To render as a custom element, use the `asChild` prop.
 *
 * @example
 * ```
 * <DialogHeading>Title</DialogHeading>
 * ```
 */
const DialogHeading = react.forwardRef(function DialogHeading({ children, size = 'sm', asChild, ...props }, ref) {
    const { dataTestId, invert } = useDialogContext();
    return (react.createElement($5d3850c4d0b4e6c7$export$f99233281efd08a0, { "data-test-id": dataTestId && `${dataTestId}-heading`, asChild: true },
        react.createElement(Heading, { size: size, invert: invert, ref: ref, asChild: true, ...props }, asChild ? children : react.createElement("h1", null, children))));
});

/**
 * The `DialogDescription` component is used to render a description specifically for Dialogs.
 *
 * It's a wrapper around the Text component with some different defaults.
 *
 * By default renders a `p`. To render as a custom element, use the `asChild` prop.
 *
 * @example
 * ```
 * <DialogDescription>Description</DialogDescription>
 * ```
 */
const DialogDescription = react.forwardRef(function DialogDescription({ children, size = 'base', asChild, ...props }, ref) {
    const { dataTestId, invert } = useDialogContext();
    return (react.createElement($5d3850c4d0b4e6c7$export$393edc798c47379d, { "data-test-id": dataTestId && `${dataTestId}-description`, asChild: true },
        react.createElement(Text, { size: size, invert: invert, ref: ref, asChild: true, ...props }, asChild ? children : react.createElement("p", null, children))));
});

const AlertDialogContext = (0,react.createContext)(undefined);
const AlertDialogProvider = ({ children, value, }) => (react.createElement(AlertDialogContext.Provider, { value: value }, children));
const useAlertDialogContext = () => {
    const context = (0,react.useContext)(AlertDialogContext);
    if (!context) {
        throw new Error('useAlertDialogContext must be used within a AlertDialogProvider');
    }
    return context;
};

/**
 * The `AlertDialogAction` component should wrap each positive action in an alert dialog.
 * It will render as the child element.
 *
 * @example
 * ```
 * <AlertDialogAction>
 *   <ButtonCta label="Permanently Delete" />
 * </AlertDialogAction>
 * ```
 */
const AlertDialogAction = ({ children }) => {
    const { dataTestId } = useAlertDialogContext();
    return (react.createElement($905f4ae918aab1aa$export$e19cd5f9376f8cee, { "data-test-id": dataTestId && `${dataTestId}-action`, asChild: true }, children));
};

/**
 * The `AlertDialogBody` component is used to wrap the body content of a dialog, below the header and before the footer.
 * Should be used to provide additional context to the user.
 *
 * @example
 * ```
 * <AlertDialogBody>
 *   <Text>Description</Text>
 * </AlertDialogBody>
 * ```
 */
const AlertDialogBody = ({ children, className, asChild, }) => {
    const { dataTestId } = useAlertDialogContext();
    const Comp = asChild ? $5e63c961fc1ce211$export$8c6ed5c666ac1360 : 'div';
    return (react.createElement(Comp, { "data-test-id": dataTestId && `${dataTestId}-body`, "data-uds-child": "alert-dialog-body", className: (0,twind.tw)('px-6', className) }, children));
};

/**
 * The `AlertDialogCancel` component should wrap the cancel action in an alert dialog.
 * It will render as the child element.
 *
 * @example
 * ```
 * <AlertDialogCancel>
 *   <ButtonCta label="Cancel" />
 * </AlertDialogCancel>
 * ```
 */
const AlertDialogCancel = ({ children }) => {
    const { dataTestId } = useAlertDialogContext();
    return (React.createElement(RadixAlertDialog.Cancel, { "data-test-id": dataTestId && `${dataTestId}-cancel`, asChild: true }, children));
};

const contentStyle$1 = (0,style/* style */.oB)({
    base: 'flex flex-col w-full rounded-md overflow-hidden animate-slide-in-bottom relative m-auto focus-visible:(outline-none ring ring-1 ring-inset ring-offset-1)',
    variants: {
        size: {
            xs: 'max-w-screen-2xs',
            sm: 'max-w-screen-xs',
            md: 'max-w-screen-sm',
            lg: 'max-w-screen-md',
            xl: 'max-w-screen-lg',
        },
        invert: {
            true: 'bg-neutral-100 text-white border-neutral-80',
            false: 'bg-white text-neutral-100 border-neutral-20',
        },
    },
});
/**
 * The `AlertDialogContent` component is used to wrap the content of a dialog.
 *
 * @example
 * ```
 * <AlertDialogContent>
 *   <AlertDialogHeader>
 *     <AlertDialogHeading>Title</AlertDialogHeading>
 *   </AlertDialogHeader>
 *   <AlertDialogBody>
 *     <AlertDialogDescription>Description</AlertDialogDescription>
 *   </AlertDialogBody>
 *   <AlertDialogFooter>
 *     <AlertDialogAction>
 *        <ButtonCta label="Accept" />
 *      </AlertDialogAction>
 *     <AlertDialogCancel>
 *        <ButtonCta label="Cancel" />
 *      </AlertDialogCancel>
 *   </AlertDialogFooter>
 * </AlertDialogContent>
 * ```
 */
const AlertDialogContent = ({ children, className, asChild, ...rest }) => {
    const { autoFocus, size, invert, dataTestId, onEscapeKeyDown } = useAlertDialogContext();
    const contentRef = (0,react.useRef)(null);
    const handleAutoFocus = (e) => {
        if (autoFocus !== 'cancel') {
            e.preventDefault();
        }
        if (autoFocus === 'content') {
            contentRef.current.focus();
        }
    };
    return (react.createElement($905f4ae918aab1aa$export$602eac185826482c, null,
        react.createElement($905f4ae918aab1aa$export$c6fdb837b070b4ff, { "data-test-id": dataTestId && `${dataTestId}-overlay`, "data-uds-child": "alert-dialog-overlay", className: "fixed z-dialog inset-0 p-6 flex overflow-y-auto bg-black bg-opacity-50 animate-fade-in" },
            react.createElement($905f4ae918aab1aa$export$7c6e2c02157bb7d2, { "data-test-id": dataTestId && `${dataTestId}-content`, "data-uds-child": "alert-dialog-content", className: (0,style.tw)(contentStyle$1({ size, invert }), className), onOpenAutoFocus: handleAutoFocus, onEscapeKeyDown: onEscapeKeyDown, asChild: asChild, ref: contentRef, ...rest }, children))));
};

/**
 * The `AlertDialogDescription` component is used to render a description specifically for AlertDialogs.
 *
 * It's a wrapper around the Text component with some different defaults.
 *
 * By default renders a `p`. To render as a custom element, use the `asChild` prop.
 *
 * @example
 * ```
 * <AlertDialogDescription>Description</AlertDialogDescription>
 * ```
 */
const AlertDialogDescription = react.forwardRef(function AlertDialogDescription({ children, size = 'base', asChild, ...props }, ref) {
    const { dataTestId, invert } = useAlertDialogContext();
    return (react.createElement($905f4ae918aab1aa$export$393edc798c47379d, { "data-test-id": dataTestId && `${dataTestId}-description`, asChild: true },
        react.createElement(Text, { size: size, invert: invert, ref: ref, asChild: true, ...props }, asChild ? children : react.createElement("p", null, children))));
});

const footerStyle$1 = (0,style/* style */.oB)({
    base: 'flex gap-4 p-6 children:flex-grow-1',
    variants: {
        size: {
            xs: 'flex-col',
            sm: 'flex-row-reverse flex-wrap sm:max-w-max sm:ml-auto sm:rtl:(mr-auto ml-0)',
            md: 'flex-row-reverse flex-wrap sm:max-w-max sm:ml-auto sm:rtl:(mr-auto ml-0)',
            lg: 'flex-row-reverse flex-wrap sm:max-w-max sm:ml-auto sm:rtl:(mr-auto ml-0) ',
            xl: 'flex-row-reverse flex-wrap sm:max-w-max sm:ml-auto sm:rtl:(mr-auto ml-0)',
        },
    },
});
/**
 * The `AlertDialogFooter` component wraps the actions of an alert dialog.
 * It should contain a positive action (e.g. "Confirm") and a negative action (e.g. "Cancel").
 *
 * @example
 * ```
 * <AlertDialogFooter>
 *   <AlertDialogAction>
 *      <ButtonCta label="Confirm" />
 *    </AlertDialogAction>
 *   <AlertDialogCancel>
 *      <ButtonCta label="Cancel" />
 *    </AlertDialogCancel>
 * </AlertDialogFooter>
 * ```
 */
const AlertDialogFooter = ({ children, className, }) => {
    const { size, dataTestId } = useAlertDialogContext();
    return (react.createElement("footer", { "data-test-id": dataTestId && `${dataTestId}-footer`, "data-uds-child": "alert-dialog-footer", className: (0,twind.tw)(footerStyle$1({ size }), className) }, children));
};

/**
 * The `AlertDialogHeader` component is used to render a header specifically for AlertDialogs.
 *
 * @example
 * ```
 * <AlertDialogHeader>
 *   <AlertDialogHeading>Title</AlertDialogHeading>
 * </AlertDialogHeader>
 * ```
 */
const AlertDialogHeader = ({ children, className, }) => {
    const { dataTestId } = useAlertDialogContext();
    return (react.createElement("header", { className: (0,twind.tw)('flex flex-col gap-4 p-6', className), "data-test-id": dataTestId && `${dataTestId}-header`, "data-uds-child": "alert-dialog-header" }, children));
};

/**
 * The `AlertDialogHeading` component is used to render a heading specifically for AlertDialogs.
 *
 * It's a wrapper around the Heading component with some different defaults.
 *
 * By default renders a h1. To render as a custom element, use the `asChild` prop.
 *
 * @example
 * ```
 * <AlertDialogHeading>Title</AlertDialogHeading>
 * ```
 */
const AlertDialogHeading = react.forwardRef(function AlertDialogHeading({ children, size = 'sm', asChild, ...props }, ref) {
    const { dataTestId, invert } = useAlertDialogContext();
    return (react.createElement($905f4ae918aab1aa$export$f99233281efd08a0, { "data-test-id": dataTestId && `${dataTestId}-heading`, asChild: true },
        react.createElement(Heading, { size: size, invert: invert, ref: ref, asChild: true, ...props }, asChild ? children : react.createElement("h1", null, children))));
});

/**
 * The `AlertDialogRoot` component is the root component needed to render an alert dialog.
 * It wraps the trigger that opens the alert dialog and the alert dialog content itself.
 *
 * @example
 * ```
 * <AlertDialogRoot>
 *   <AlertDialogTrigger>Open Dialog</AlertDialogTrigger>
 *   <AlertDialogContent>
 *     <AlertDialogHeader>
 *       <AlertDialogHeading>Title</AlertDialogHeading>
 *     </AlertDialogHeader>
 *     <AlertDialogBody>
 *       <Text>Description</Text>
 *     </AlertDialogBody>
 *     <AlertDialogFooter>
 *       <AlertDialogAction>
 *          <ButtonCta label="Accept" />
 *        </AlertDialogAction>
 *       <AlertDialogCancel>
 *          <ButtonCta label="Cancel" />
 *        </AlertDialogCancel>
 *     </AlertDialogFooter>
 *   </AlertDialogContent>
 * </AlertDialogRoot>
 * ```
 */
const AlertDialogRoot = ({ children, invert = false, size = 'md', open, autoFocus = 'cancel', dataTestId, onOpenChange, onEscapeKeyDown, ...rest }) => {
    const contextProps = {
        invert,
        size,
        open,
        autoFocus,
        dataTestId,
        onOpenChange,
        onEscapeKeyDown,
    };
    return (react.createElement($905f4ae918aab1aa$export$be92b6f5f03c0fe9, { open: open, onOpenChange: onOpenChange, ...rest },
        react.createElement(AlertDialogProvider, { value: contextProps }, children)));
};

/**
 * The `AlertDialogTrigger` component should wrap the element opens the alert dialog.
 * It will render as the child element.
 *
 * @example
 * ```
 * <AlertDialogTrigger>
 *   <ButtonCta label="Remove Card" />
 * </AlertDialogTrigger>
 * ```
 */
const AlertDialogTrigger = ({ children }) => {
    const { dataTestId } = useAlertDialogContext();
    return (React.createElement(RadixAlertDialog.Trigger, { "data-test-id": dataTestId && `${dataTestId}-trigger`, asChild: true }, children));
};

const PopoverContext = (0,react.createContext)(undefined);
const PopoverProvider = ({ children, value, }) => (react.createElement(PopoverContext.Provider, { value: value }, children));
const usePopoverContext = () => {
    const context = (0,react.useContext)(PopoverContext);
    if (!context) {
        throw new Error('usePopoverContext must be used within a PopoverProvider');
    }
    return context;
};

/**
 * The `PopoverRoot` component is the root component needed to render a popover.
 * It wraps the trigger that opens the popover and the popover content itself.
 *
 * @example
 * ```
 * <PopoverRoot>
 *   <PopoverTrigger>Open Popover</PopoverTrigger>
 *   <PopoverContent>
 *     <PopoverBody>
 *        <PopoverHeading srOnly>...</PopoverHeading>
 *        ...
 *     </PopoverBody>
 *     <PopoverClose />
 *   </PopoverContent>
 * </PopoverRoot>
 * ```
 */
const PopoverRoot = ({ id, size = 'base', align = 'start', side = 'bottom', arrow = true, distance = 12, autoFocus, dataTestId, children, ...rest }) => {
    const popId = reach_auto_id_useId(id);
    return (react.createElement(PopoverProvider, { value: {
            id: popId,
            dataTestId,
            size,
            align,
            side,
            arrow,
            distance,
            autoFocus: autoFocus ?? 'auto',
            ...rest,
        } },
        react.createElement($cb5cc270b50c6fcd$export$be92b6f5f03c0fe9, { ...rest }, children)));
};

const POPOVER_SIZE_MAP = {
    xs: [
        css_css/* css */.iv `
      --popover-max-width: 12rem;
    `,
    ],
    sm: [
        css_css/* css */.iv `
      --popover-max-width: 15rem;
    `,
    ],
    base: [
        css_css/* css */.iv `
      --popover-max-width: 20rem;
    `,
    ],
    lg: [
        css_css/* css */.iv `
      --popover-max-width: 24rem;
    `,
    ],
    xl: [
        css_css/* css */.iv `
      --popover-max-width: 28rem;
    `,
    ],
};
const POPOVER_CLOSE_BUTTON_SIZE_MAP = {
    xs: ['top-2', 'right-1.5', 'rtl:(right-auto left-1.5)'],
    sm: ['top-3', 'right-2.5', 'rtl:(right-auto left-2.5)'],
    base: ['top-3', 'right-2.5', 'rtl:(right-auto left-2.5)'],
    lg: ['top-4', 'right-3.5', 'rtl:(right-auto left-3.5)'],
    xl: ['top-4', 'right-3.5', 'rtl:(right-auto left-3.5)'],
};
const POPOVER_HEADER_SIZE_MAP = {
    xs: 'p-3 pb-0',
    sm: 'p-4 pb-0',
    base: 'p-4 pb-0',
    lg: 'p-6 pb-0',
    xl: 'p-6 pb-0',
};
const POPOVER_BODY_SIZE_MAP = {
    xs: 'p-3',
    sm: 'p-4',
    base: 'p-4',
    lg: 'p-6',
    xl: 'p-6',
};

/**
 * The `PopoverContent` component is used to wrap the contents of a popover.
 *
 * @example
 * ```
 * <PopoverContent arrow>
 *   <PopoverClose />
 *   <PopoverBody>...</PopoverBody>
 * </PopoverContent>
 * ```
 */
const PopoverContent = ({ children, className, zIndex = 20, ...rest }) => {
    const popoverContent = (0,react.useRef)(null);
    const { id, size, invert, side, align, distance, offset, arrow, autoFocus } = usePopoverContext();
    const { dataTestId } = usePopoverContext();
    const colorStyle = (0,esm/* useResponsiveProp */.Uo)(invert, invert => invert
        ? 'bg-neutral-100 border-neutral-80 text-neutral-0'
        : 'bg-neutral-0 border-neutral-20 text-neutral-100');
    const sizeStyle = (0,esm/* useResponsiveProp */.Uo)(size, size => (0,twind.tw)(POPOVER_SIZE_MAP[size]));
    const handleAutoFocus = (e) => {
        if (!utils_esm.is.undefined(autoFocus) && autoFocus !== 'auto') {
            e.preventDefault();
        }
        if (popoverContent.current && autoFocus === 'content') {
            popoverContent.current.focus();
        }
        if (autoFocus === 'close') {
            popoverContent.current.querySelector('[data-uds-child="popover-close-button"]')?.focus();
        }
    };
    return (react.createElement($cb5cc270b50c6fcd$export$602eac185826482c, null,
        react.createElement($cb5cc270b50c6fcd$export$7c6e2c02157bb7d2, { ref: popoverContent, "data-uds-child": "popover-content", "data-test-id": dataTestId && `${dataTestId}-content`, side: side, align: align, sideOffset: arrow ? distance - 12 : distance, alignOffset: offset, "aria-labelledby": `popover-${id}-heading`, className: (0,twind.tw)('relative shadow-glow-base animate-slide-in-bottom rounded-sm', 'focus-visible:(outline-none ring ring-1)'), onOpenAutoFocus: handleAutoFocus, style: {
                zIndex: zIndex,
            }, ...rest },
            arrow && (react.createElement($cb5cc270b50c6fcd$export$21b07c8f274aebd5, { asChild: true },
                react.createElement("span", { className: (0,twind.tw)('w-3 h-3 rotate-45 -translate-y-1/2 border-b-1 border-r-1', colorStyle), "data-uds-child": "popover-arrow", "data-test-id": dataTestId && `${dataTestId}-arrow` }))),
            react.createElement("div", { className: (0,twind.tw)(css_css/* css */.iv `
            max-height: 50vh;
            overflow-y: auto;
          `) },
                react.createElement("div", { className: (0,twind.tw)('flex flex-col rounded-sm border-1', sizeStyle, css_css/* css */.iv `
                width: min(
                  var(--radix-popper-available-width),
                  var(--popover-max-width)
                );
              `, colorStyle, className) }, children)))));
};

/**
 * The `PopoverTrigger` component should wrap the element opens the popover.
 * It will render as the child element.
 *
 * @example
 * <PopoverTrigger>
 *   <ButtonCta label="Open Popover" />
 * </PopoverTrigger>
 */
const PopoverTrigger = ({ children, ...rest }) => {
    const { dataTestId } = usePopoverContext();
    return (react.createElement($cb5cc270b50c6fcd$export$41fb9f06171c75f4, { "data-uds-child": "popover-trigger", "data-test-id": dataTestId && `${dataTestId}-trigger`, ...rest, asChild: true }, children));
};

/**
 * The body content of a popover.
 *
 * @example
 * ```
 * <PopoverHeader>
 *   <Heading>Some content</Heading>
 *   <PopoverClose />
 * </PopoverHeader>
 * ```
 */
const PopoverHeader = ({ children, className }) => {
    const { size } = usePopoverContext();
    const headerSizeStyle = useResponsiveProp(size, size => POPOVER_HEADER_SIZE_MAP[size]);
    return (React.createElement("header", { className: tw$2('flex items-start gap-2', headerSizeStyle, css `
          > [data-uds-child='popover-close-button'] {
            @apply relative transform top-auto right-auto -translate-y-1 translate-x-1.5 rtl:(-translate-x-1.5);
          }
        `, className) }, children));
};

/**
 * The body content of a popover.
 *
 * @example
 * ```
 * <PopoverBody>
 *   <Heading>Some content</Heading>
 * </PopoverBody>
 * ```
 */
const PopoverBody = ({ children, className }) => {
    const { size, dataTestId } = usePopoverContext();
    const bodySizeStyle = (0,esm/* useResponsiveProp */.Uo)(size, size => POPOVER_BODY_SIZE_MAP[size]);
    return (react.createElement("div", { className: (0,twind.tw)('order-2 flex-1', bodySizeStyle, className), "data-uds-child": "popover-body", "data-test-id": dataTestId && `${dataTestId}-body` }, children));
};

const PopoverClose = (0,react.forwardRef)(function PopoverClose({ className }, ref) {
    const t = (0,esm/* useUdsTranslate */.oG)();
    const { size, dataTestId, invert } = usePopoverContext();
    const sizeStyle = (0,esm/* useResponsiveProp */.Uo)(size, size => POPOVER_CLOSE_BUTTON_SIZE_MAP[size]);
    return (react.createElement($cb5cc270b50c6fcd$export$f39c2d165cd861fe, { asChild: true },
        react.createElement(ButtonIcon, { ref: ref, className: (0,twind.tw)('absolute top-0 right-0 order-1 ml-auto', sizeStyle, className), mode: "icon", icon: "close", label: t('close'), size: "xs", variant: "ghost", invert: invert, "data-uds-child": "popover-close-button", "data-test-id": dataTestId && `${dataTestId}-close-button` })));
});

const TooltipInnerContext = (0,react.createContext)(undefined);
const TooltipInnerProvider = ({ children, value, }) => (react.createElement(TooltipInnerContext.Provider, { value: value }, children));
const useTooltipContext = () => {
    const context = (0,react.useContext)(TooltipInnerContext);
    if (!context) {
        throw new Error('useTooltipContext must be used within a TooltipProvider');
    }
    return context;
};

const animTooltipRight = (0,css_css/* animation */.oQ)('0.4s cubic-bezier(0.16, 1, 0.3, 1)', {
    '0%': {
        transform: 'translateX(8px)',
        opacity: 0,
    },
    '100%': {
        opacity: 100,
        transform: 'translateX(0)',
    },
});
const animTooltipLeft = (0,css_css/* animation */.oQ)('0.4s cubic-bezier(0.16, 1, 0.3, 1)', {
    '0%': {
        transform: 'translateX(-8px)',
        opacity: 0,
    },
    '100%': {
        opacity: 100,
        transform: 'translateX(0)',
    },
});
const animTooltipTop = (0,css_css/* animation */.oQ)('0.4s cubic-bezier(0.16, 1, 0.3, 1)', {
    '0%': {
        transform: 'translateY(-8px)',
        opacity: 0,
    },
    '100%': {
        opacity: 100,
        transform: 'translateY(0)',
    },
});
const animTooltipBottom = (0,css_css/* animation */.oQ)('0.4s cubic-bezier(0.16, 1, 0.3, 1)', {
    '0%': {
        transform: 'translateY(8px)',
        opacity: 0,
    },
    '100%': {
        opacity: 100,
        transform: 'translateY(0)',
    },
});

/**
 * The `TooltipContent` component is used to wrap the contents of a Tooltip.
 *
 * @example
 * ```
 * ```
 * <TooltipProvider delayDuration={300}>
 *   <TooltipRoot side="right" align="start">
 *     <TooltipTrigger>
 *       <button>Open Tooltip</button>
 *     </TooltipTrigger>
 *     <TooltipContent>
 *       Eiusmod non cillum fugiat qui eu culpa
 *     </TooltipContent>
 *   </TooltipRoot>
 * <TooltipProvider>
 * ```
 */
const TooltipContent = ({ children, className, zIndex = 20, ...rest }) => {
    const TooltipContent = (0,react.useRef)(null);
    const { dataTestId, invert, side, align, distance, offset } = useTooltipContext();
    const colorStyle = (0,esm/* useResponsiveProp */.Uo)(invert, invert => invert ? 'bg-neutral-10 text-neutral-100' : 'bg-neutral-90 text-neutral-0');
    return (react.createElement($a093c7e1ec25a057$export$602eac185826482c, null,
        react.createElement($a093c7e1ec25a057$export$7c6e2c02157bb7d2, { ref: TooltipContent, "data-uds-child": "tooltip-content", "data-test-id": dataTestId && `${dataTestId}-content`, side: side, align: align, sideOffset: distance + 4, alignOffset: offset, className: (0,twind.tw)('relative shadow-glow-base animate-slide-in-bottom rounded-sm', css_css/* css */.iv `
            --tooltip-max-width: 260px;
            max-width: min(
              var(--radix-tooltip-content-available-width),
              var(--tooltip-max-width)
            );
          `, css_css/* css */.iv `
            &[data-side='left'] {
              ${animTooltipLeft};
            }
            &[data-side='right'] {
              ${animTooltipRight};
            }
            &[data-side='top'] {
              ${animTooltipTop};
            }
            &[data-side='bottom'] {
              ${animTooltipBottom};
            }
          `), style: {
                zIndex: zIndex,
            }, ...rest },
            react.createElement($a093c7e1ec25a057$export$21b07c8f274aebd5, { asChild: true },
                react.createElement("div", { "data-test-id": dataTestId && `${dataTestId}-arrow`, className: (0,twind.tw)('w-2.5 h-2.5 rotate-45 -translate-y-1/2', colorStyle), "data-uds-child": "tooltip-arrow" })),
            react.createElement("div", { className: (0,twind.tw)('flex flex-col rounded-sm', 'px-3 py-2', 'text-sm', colorStyle, className) }, children))));
};

/**
 * The `TooltipRoot` component is the root component needed to render a Tooltip.
 * It wraps the trigger that opens the Tooltip and the Tooltip content itself.
 *
 * @example
 * ```
 * <TooltipProvider delayDuration={300}>
 *   <TooltipRoot side="right" align="start">
 *     <TooltipTrigger>
 *       <button>Open Tooltip</button>
 *     </TooltipTrigger>
 *     <TooltipContent>
 *       Eiusmod non cillum fugiat qui eu culpa
 *     </TooltipContent>
 *   </TooltipRoot>
 * <TooltipProvider>
 * ```
 */
const TooltipRoot = ({ align = 'start', side = 'bottom', distance = 0, dataTestId, children, ...rest }) => {
    return (react.createElement(TooltipInnerProvider, { value: {
            dataTestId,
            align,
            side,
            distance,
            ...rest,
        } },
        react.createElement($a093c7e1ec25a057$export$be92b6f5f03c0fe9, { ...rest }, children)));
};

/**
 * The `TooltipTrigger` component should wrap the element opens the Tooltip.
 * It will render as the child element.
 *
 * @example
 * <TooltipTrigger>
 *   <ButtonCta label="Open Tooltip" />
 * </TooltipTrigger>
 */
const TooltipTrigger = ({ children, ...rest }) => {
    const { dataTestId } = useTooltipContext();
    return (react.createElement($a093c7e1ec25a057$export$41fb9f06171c75f4, { "data-uds-child": "tooltip-trigger", "data-test-id": dataTestId && `${dataTestId}-trigger`, ...rest, asChild: true }, children));
};

const TooltipProvider = ({ children, delayDuration = 200, ...rest }) => {
    return (react.createElement($a093c7e1ec25a057$export$2881499e37b75b9a, { delayDuration: delayDuration, ...rest }, children));
};

const ToastPrimitives = {
    Toast: $054eb8030ebde76e$export$8d8dc7d5f743331b,
    Provider: $054eb8030ebde76e$export$f5d03d415824e0e,
    Viewport: $054eb8030ebde76e$export$6192c2425ecfd989,
    Description: $054eb8030ebde76e$export$ecddd96c53621d9a,
    Title: $054eb8030ebde76e$export$16d42d7c29b95a4,
    Close: $054eb8030ebde76e$export$811e70f61c205839,
    Action: $054eb8030ebde76e$export$3019feecfda683d2,
};

/**
 * Context for the Toast component.
 *
 * @internal Used internally by the ToastRoot component.
 */
const ToastContext = (0,react.createContext)(null);
/**
 * Internal hook for consuming the Toast context.
 *
 * @internal
 */
const useToastContext = () => {
    return (0,react.useContext)(ToastContext);
};

const defaultIcons = {
    success: 'check-filled',
    error: 'exclamation-filled',
    warning: 'warning-filled',
    info: 'info-filled',
    base: 'info-filled',
};
const ToastIcon = (props) => {
    const { icon, size = '2xl', dataTestId, className, ...rest } = props;
    const { variant, dataTestId: contextDataTestId } = useToastContext();
    return (react.createElement(Icon, { ...rest, name: icon ?? defaultIcons[variant], "data-test-id": dataTestId ?? `${contextDataTestId}-icon`, "data-uds-child": "toast-icon", className: className, size: size }));
};
const ToastTitle = ({ size = 'xxs', className, children, dataTestId, asChild, ...rest }) => {
    const { dataTestId: contextDataTestId } = useToastContext();
    const Comp = asChild ? react.Fragment : 'h4';
    return (react.createElement(ToastPrimitives.Title, { asChild: true },
        react.createElement(Heading, { ...rest, size: size, asChild: true, "data-uds-child": "toast-title", className: className, "data-test-id": dataTestId ?? `${contextDataTestId}-title`, "data-title": true },
            react.createElement(Comp, null, children))));
};
const ToastDescription = ({ size = 'base', className, children, dataTestId, asChild, ...rest }) => {
    const { dataTestId: contextDataTestId } = useToastContext();
    const Comp = asChild ? react.Fragment : 'p';
    return (react.createElement(ToastPrimitives.Description, { asChild: true },
        react.createElement(Text, { ...rest, asChild: true, size: size, "data-uds-child": "toast-description", "data-test-id": dataTestId ?? `${contextDataTestId}-description`, className: className, "data-description": true },
            react.createElement(Comp, null, children))));
};
const ToastAction = ({ altText, className, children, dataTestId, ...rest }) => {
    const { dataTestId: contextDataTestId } = useToastContext();
    return (React.createElement(ToastPrimitives.Action, { ...rest, asChild: true, altText: altText, "data-test-id": dataTestId ?? `${contextDataTestId}-action`, "data-uds-child": "toast-action", className: className }, children));
};
const ToastClose = ({ className, dataTestId, ...rest }) => {
    const { dictionary } = (0,esm/* useUdsContext */.vV)();
    const { invert, dataTestId: contextDataTestId } = useToastContext();
    return (react.createElement(ToastPrimitives.Close, { asChild: true },
        react.createElement(ButtonCta, { ...rest, className: (0,twind.tw)(className), mode: "icon", "data-uds-child": "toast-close", label: dictionary.close, icon: "close", size: "sm", variant: "ghost", "data-test-id": dataTestId ?? `${contextDataTestId}-close`, invert: invert })));
};

const sizeStyles = {
    sm: 'w-full w-64',
    base: 'w-full w-[26rem]',
    md: 'w-full w-[32rem]',
};
const variantStyles = {
    base: 'shadow-glow-base border border-neutral-40 bg-neutral-10 text-neutral',
    success: 'shadow-glow-success border border-success-20 bg-white text-success',
    error: 'shadow-glow-error border border-error-10 bg-white text-error',
    warning: 'shadow-glow-warning border border-warning-20 bg-white text-warning-70',
    info: 'shadow-glow-info border border-info-10 bg-white text-info',
};
const invertVariantStyles = {
    base: 'shadow-glow-base-invert border border-neutral-80 bg-neutral-100 text-neutral-0',
    success: 'shadow-glow-success-invert border border-success-90 bg-neutral-100 text-success-40',
    error: 'shadow-glow-error-invert border border-error-80 bg-neutral-100 text-error-40',
    warning: 'shadow-glow-warning-invert border border-warning-90 bg-neutral-100 text-warning-50',
    info: 'shadow-glow-info-invert border border-info-80 bg-neutral-100 text-info-40',
};
const baseLayout = css_css/* css */.iv `
  @apply grid;
  grid-auto-rows: max-content;
  grid-template-columns: max-content auto max-content;
  grid-template-areas:
    'icon title'
    'icon description'
    'icon action';

  & > [data-uds-child='toast-icon'] {
    grid-area: icon;
    @apply -ml-1 mr-2 rtl:(ml-2 -mr-1);
  }

  & > [data-uds-child='toast-title'] {
    grid-area: title;
    @apply justify-self-start self-start leading-normal;
  }

  & > [data-uds-child='toast-description'] {
    grid-area: description;
    @apply justify-self-start self-start;
  }

  & > [data-uds-child='toast-action'] {
    grid-area: action;
    @apply mt-2 justify-self-start self-start;
  }

  & > [data-uds-child='toast-close'] {
    @apply absolute right-2 top-2 mt-0 z-10 rtl:(-ml-1.5 mr-0 left-3 right-auto);
  }
`;
/**
 * A ToastRoot is a non-modal, unobtrusive window element used to display brief, auto-expiring windows of information to a user.
 *
 * A toast must appear within a ToastProvider, usually found at the root of the application. See the documentation for ToastProvider and ToastViewport.
 *
 *
 * @example
 * ```
 * <ToastRoot
 *   size="base"
 *   variant="base"
 *   invert={false}
 *   dismissible={true}
 *   onOpenChange={setOpen}
 * >
 *   <ToastIcon icon="info-filled" />
 *   <ToastTitle>Title</ToastTitle>
 *   <ToastDescription>Content</ToastDescription>
 *   <ToastAction altText="Action">
 *     <ButtonCta size="sm" label="Action" />
 *   </ToastAction>
 * </ToastRoot>
 * ```
 */
const ToastRoot = ({ size = 'base', variant = 'base', invert = false, assertive = false, dismissible = true, duration, className, dataTestId, children, ref, }) => {
    const toastStyle = (0,twind.tw)(sizeStyles[size], invert ? invertVariantStyles[variant] : variantStyles[variant]);
    return (react.createElement($054eb8030ebde76e$export$be92b6f5f03c0fe9, { "data-test-id": dataTestId, "data-uds-child": "toast", duration: duration, ref: ref, className: (0,twind.tw)(toastStyle, className, baseLayout, 'rounded-sm py-3 px-3', dismissible && 'pr-10 rtl:(pl-10 pr-3)'), type: assertive ? 'foreground' : 'background' },
        react.createElement(ToastContext.Provider, { value: { variant, invert, dataTestId, dismissible } },
            children,
            dismissible && react.createElement(ToastClose, null))));
};

/**
 * Top level provider, that's responsible for rendering the toast viewport, announcing the contents, and managing the toast state.
 *
 * Usually, you'll want to wrap your entire app with this provider, so that you can use the toast primitives anywhere in your app.
 *
 * You can have multiple ToastProviderInstances in your app, if you need to render context specific toasts.
 *
 * @example
 * ```jsx
 * <ToastProvider>
 *   <YourApp>
 *     <ToastRoot />
 *   </YourApp>
 * <ToastViewport position="bottom_end" animationIn="fade"/>
 * <ToastProvider>
 * ```
 */
const ToastProvider = (props) => {
    const { dataTestId, children, label = 'Notifications', duration = 5000, } = props;
    return (react.createElement($054eb8030ebde76e$export$2881499e37b75b9a, { label: label, duration: duration, "data-test-id": dataTestId }, children));
};

const animSlideInRight = (0,css_css/* animation */.oQ)('0.3s cubic-bezier(0.16, 1, 0.3, 1)', {
    '0%': {
        transform: 'translateX(20%)',
        opacity: 0,
    },
    '100%': {
        opacity: 100,
        transform: 'translateX(0)',
    },
});
const animSlideInLeft = (0,css_css/* animation */.oQ)('0.3s cubic-bezier(0.16, 1, 0.3, 1)', {
    '0%': {
        transform: 'translateX(-20%)',
        opacity: 0,
    },
    '100%': {
        opacity: 100,
        transform: 'translateX(0)',
    },
});
const animSlideOutRight = (0,css_css/* animation */.oQ)('0.3s cubic-bezier(0.55, 0, 1, 0.45)', {
    '0%': {
        transform: '0%',
        opacity: 100,
    },
    '100%': {
        opacity: 0,
        transform: 'translateX(20%)',
    },
});
const animSlideOutLeft = (0,css_css/* animation */.oQ)('0.3s cubic-bezier(0.55, 0, 1, 0.45)', {
    '0%': {
        transform: '0%',
        opacity: 100,
    },
    '100%': {
        opacity: 0,
        transform: 'translateX(-20%)',
    },
});
const animSlideInUp = (0,css_css/* animation */.oQ)('0.3s cubic-bezier(0.16, 1, 0.3, 1)', {
    '0%': {
        transform: 'translateY(50%)',
        opacity: 0,
    },
    '100%': {
        opacity: 100,
        transform: 'translateY(0)',
    },
});
const animSlideInDown = (0,css_css/* animation */.oQ)('0.3s cubic-bezier(0.16, 1, 0.3, 1)', {
    '0%': {
        transform: 'translateY(-50%)',
        opacity: 0,
    },
    '100%': {
        opacity: 100,
        transform: 'translateY(0)',
    },
});
const animSlideOutUp = (0,css_css/* animation */.oQ)('0.3s cubic-bezier(0.55, 0, 1, 0.45)', {
    '0%': {
        transform: '0%',
        opacity: 100,
    },
    '100%': {
        opacity: 0,
        transform: 'translateY(-50%)',
    },
});
const animSlideOutDown = (0,css_css/* animation */.oQ)('0.3s cubic-bezier(0.55, 0, 1, 0.45)', {
    '0%': {
        transform: '0%',
        opacity: 100,
    },
    '100%': {
        opacity: 0,
        transform: 'translateY(50%)',
    },
});
const animFadeIn = (0,css_css/* animation */.oQ)('0.4s cubic-bezier(0.16, 1, 0.3, 1)', {
    '0%': {
        opacity: 0,
    },
    '100%': {
        opacity: 100,
    },
});
const animFadeOut = (0,css_css/* animation */.oQ)('0.4s cubic-bezier(0.55, 0, 1, 0.45)', {
    '0%': {
        opacity: 100,
    },
    '100%': {
        opacity: 0,
    },
});

const positions = {
    top_end: 'fixed z-[99999] top-6 right-6 rtl:right-auto rtl:left-6',
    bottom_end: 'fixed z-[99999] bottom-6 right-6 rtl:right-auto rtl:left-6',
    top_start: 'fixed z-[99999] top-6 left-6 rtl:left-auto rtl:right-6',
    bottom_start: 'fixed z-[99999] bottom-6 left-6 rtl:left-auto rtl:right-6',
    top_middle: 'fixed z-[99999] top-6 left-1/2 -translate-x-1/2',
    bottom_middle: 'fixed z-[99999] bottom-6 left-1/2 -translate-x-1/2',
    middle_end: 'fixed z-[99999] top-1/2 -translate-y-1/2 right-6 rtl:right-auto rtl:left-6',
    middle_start: 'fixed z-[99999] top-1/2 -translate-y-1/2 left-6 rtl:left-auto rtl:right-6',
    inline: '',
};
const animationsIn = {
    left: css_css/* css */.iv `
    & > [data-state='open'] {
      ${animSlideInLeft}
    }
  `,
    right: css_css/* css */.iv `
    & > [data-state='open'] {
      ${animSlideInRight}
    }
  `,
    up: css_css/* css */.iv `
    & > [data-state='open'] {
      ${animSlideInUp}
    }
  `,
    down: css_css/* css */.iv `
    & > [data-state='open'] {
      ${animSlideInDown}
    }
  `,
    fade: css_css/* css */.iv `
    & > [data-state='open'] {
      ${animFadeIn}
    }
  `,
};
const animationsOut = {
    left: css_css/* css */.iv `
    & > [data-state='closed'] {
      ${animSlideOutLeft}
    }
  `,
    right: css_css/* css */.iv `
    & > [data-state='closed'] {
      ${animSlideOutRight}
    }
  `,
    up: css_css/* css */.iv `
    & > [data-state='closed'] {
      ${animSlideOutUp}
    }
  `,
    down: css_css/* css */.iv `
    & > [data-state='closed'] {
      ${animSlideOutDown}
    }
  `,
    fade: css_css/* css */.iv `
    & > [data-state='closed'] {
      ${animFadeOut}
    }
  `,
};
const toastStylesCommon = css_css/* css */.iv `
  & > li {
    transform: translate3d(0, 0, 0);
    backface-visibility: hidden;
    perspective: 1000;
  }
`;
const defaultAnimationIn = {
    top_start: 'left',
    top_end: 'right',
    top_middle: 'down',
    bottom_end: 'right',
    bottom_start: 'left',
    bottom_middle: 'up',
    middle_start: 'left',
    middle_end: 'right',
    inline: 'fade',
};
const defaultAnimationOut = {
    top_end: 'right',
    bottom_end: 'right',
    top_start: 'left',
    bottom_start: 'left',
    top_middle: 'up',
    bottom_middle: 'down',
    middle_start: 'left',
    middle_end: 'right',
    inline: 'fade',
};
/**
 * The ToastViewport is the html element, whithin which, the Toasts will be rendered. It is responsible for positioning the Toasts and animating them in and out.
 *
 * Toasts are not direct children of the Viewport, but are rendered in a portal, so they can be positioned anywhere in the dom. The viewport is determined by the parent ToastProvider instance.
 *
 *
 *
 * @example
 * ```
 * <ToastProvider>
 *   <YourApp>
 *     <ToastRoot />
 *   </YourApp>
 * // The Toasts will be rendered here
 * <ToastViewport position="bottom_end" animationIn="fade"/>
 * <ToastProvider>
 * ```
 */
const ToastViewport = (props) => {
    const { position = 'bottom_end', label = 'Notifications', animationIn, animationOut, offsetX = 0, offsetY = 0, hotkey = ['F8'], dataTestId, } = props;
    const animationInConfig = animationIn || defaultAnimationIn[position];
    const animationOutConfig = animationOut || defaultAnimationOut[position];
    const hotKeyString = `(${hotkey.join(' + ')})`;
    const viewportLabel = `${label} ${hotKeyString}`;
    const offsetPositionX = [
        'top_start',
        'bottom_start',
        'top_middle',
        'middle_start',
        'bottom_middle',
    ].includes(position)
        ? `ml-[${offsetX}px]`
        : `mr-[${offsetX}px]`;
    const offsetPositionY = [
        'top_start',
        'top_end',
        'top_middle',
        'middle_start',
        'middle_end',
    ].includes(position)
        ? `mt-[${offsetY}px]`
        : `mb-[${offsetY}px]`;
    return (react.createElement(react.Fragment, null,
        react.createElement($054eb8030ebde76e$export$d5c6c08dc2d3ca7, { label: viewportLabel, hotkey: hotkey, "data-test-id": dataTestId, "data-uds-child": "toast-viewport", "data-viewport": true, className: (0,style.tw)('outline:none flex flex-col gap-6 outline-none', positions[position], toastStylesCommon, animationsIn[animationInConfig], animationsOut[animationOutConfig], offsetPositionX, offsetPositionY) })));
};

const SearchContext = (0,react.createContext)(undefined);
/**
 * Provider for the search context, used to register search options and provide state and behaviour to the search pattern.
 *
 * @internal Mounted internally by the SearchRoot.
 */
const SearchProvider = ({ children, value, }) => react.createElement(SearchContext.Provider, { value: value }, children);
const useSearchContext = () => {
    const context = (0,react.useContext)(SearchContext);
    if (!context) {
        throw new Error('useSearchContext must be used within a SearchProvider');
    }
    return context;
};

/**
 * The `SearchRoot` component is the root component needed to render a search overlay.
 * It wraps and provides context to the trigger that opens the search overlay and the search overlay content.
 *
 * @example
 * ```
 * const [value, setValue] = useState('');
 * const [open, setOpen] = useState(false);
 *
 * <SearchRoot
 *   label="Search"
 *   placeholder="Type to search"
 *   value={value}
 *   open={open}
 *   onChange={setValue}
 *   onOpenChange={setOpen}
 *   onSubmit={handleSubmit}
 * >
 *   <SearchTrigger>
 *     <ButtonCta label="Search" />
 *   </SearchTrigger>
 *   <SearchContent>
 *     <SearchListbox>
 *       <ul>
 *         <li>
 *           <SearchOption>
 *             <a href="/option-1">Option 1</a>
 *           </SearchOption>
 *         </li>
 *         <li>
 *           <SearchOption>
 *             <a href="/option-2">Option 2</a>
 *           </SearchOption>
 *         </li>
 *         <li>
 *           <SearchOption>
 *             <a href="/option-3">Option 3</a>
 *           </SearchOption>
 *         </li>
 *       </ul>
 *     </SearchListbox>
 *   </SearchContent>
 * </SearchRoot>
 * ```
 */
const SearchRoot = ({ value, label, name, placeholder, children, dataTestId, open, loading, invert, onOpenChange, onEscapeKeyDown, onChange, onSubmit, }) => {
    const [options, setOptions] = (0,react.useState)([]);
    const [visuallyFocusedOption, setVisuallyFocusedOption] = (0,react.useState)(null);
    const t = (0,esm/* useUdsTranslate */.oG)();
    const listboxId = reach_auto_id_useId();
    const contentRef = (0,react.useRef)(null);
    const inputRef = (0,react.useRef)(null);
    const registeredTriggers = (0,react.useRef)([]);
    const activeTrigger = (0,react.useRef)(null);
    const onTriggerClick = (ref) => {
        activeTrigger.current = ref;
        onOpenChange(true);
    };
    const registerTrigger = (ref) => {
        const hasTrigger = registeredTriggers.current.some(t => t.current === ref.current);
        if (!hasTrigger) {
            registeredTriggers.current.push(ref);
        }
    };
    const unregisterTrigger = (ref) => {
        const triggerIndex = registeredTriggers.current.findIndex(t => t.current === ref.current);
        if (triggerIndex > -1) {
            registeredTriggers.current.splice(triggerIndex, 1);
        }
    };
    const registerOption = (id) => {
        setOptions(prev => [...prev, id]);
    };
    const unregisterOption = (id) => {
        setOptions(prev => prev.filter(optionId => optionId !== id));
    };
    const handleKeyDown = (e) => {
        switch (e.key) {
            case 'Escape':
                if (onEscapeKeyDown) {
                    onEscapeKeyDown(e);
                }
                else {
                    onOpenChange(false);
                }
                break;
            case 'Tab':
                // Ensure focus does not leave the search overlay
                const focusableElements = Array.from(contentRef.current.querySelectorAll('a:not([tabindex="-1"]), button:not([tabindex="-1"]), input')).filter(element => {
                    // Elements that have no offsetWidth, offsetHeight, or getClientRects()
                    // values are considered hidden
                    /* istanbul ignore next */
                    const isHidden = element.offsetWidth ||
                        element.offsetHeight ||
                        element.getClientRects().length;
                    return isHidden;
                });
                const firstElement = focusableElements[0];
                const lastElement = focusableElements[focusableElements.length - 1];
                if (!e.shiftKey && document.activeElement === lastElement) {
                    firstElement.focus();
                    e.preventDefault();
                }
                if (e.shiftKey && document.activeElement === firstElement) {
                    lastElement.focus();
                    e.preventDefault();
                }
                break;
        }
    };
    /**
     * Return focus to trigger on close
     */
    const isFirstRender = (0,react.useRef)(true);
    (0,react.useEffect)(() => {
        // Don't focus on initial render
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        if (!open) {
            activeTrigger.current?.current?.focus();
        }
    }, [open]);
    /**
     * Handle event listeners
     */
    (0,react.useEffect)(() => {
        if (open) {
            document.addEventListener('keydown', handleKeyDown);
        }
        else {
            document.removeEventListener('keydown', handleKeyDown);
        }
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [open, handleKeyDown]);
    /**
     * Announce search results to screen readers
     */
    const prevOptions = (0,react.useRef)(JSON.stringify(options));
    (0,react.useEffect)(() => {
        if (open &&
            value &&
            !loading &&
            prevOptions.current !== JSON.stringify(options)) {
            prevOptions.current = JSON.stringify(options);
            const announcement = options.length
                ? t('srNewSearchResults', { query: value, num: options.length })
                : t('srNoSearchResults', { query: value });
            $319e236875307eab$export$a9b970dcc4ae71a9(announcement, 'assertive');
        }
    }, [open, value, loading, options]);
    return (react.createElement(SearchProvider, { value: {
            value,
            label,
            placeholder,
            name,
            dataTestId,
            open,
            options,
            invert,
            visuallyFocusedOption,
            listboxId,
            contentRef,
            inputRef,
            onSubmit,
            onOpenChange,
            onChange,
            registerTrigger,
            unregisterTrigger,
            onTriggerClick,
            registerOption,
            unregisterOption,
            setVisuallyFocusedOption,
        } }, children));
};

/**
 * The `SearchFormInternal` component is used to render the input of the search overlay.
 *
 *
 * @internal This component is not meant to be used outside of the SearchContent component. A standalone version of this component is available as `SearchForm`.
 */
const SearchFormInternal = () => {
    const { label, placeholder, name, listboxId, dataTestId, open, value, options, invert, visuallyFocusedOption, inputRef, onChange, onSubmit, setVisuallyFocusedOption, } = useSearchContext();
    const handleChange = (value) => {
        onChange(value);
        setVisuallyFocusedOption(null);
    };
    const handleKeyDown = (e) => {
        const index = options.indexOf(visuallyFocusedOption);
        switch (e.key) {
            case 'ArrowDown':
                e.preventDefault();
                if (index < options.length - 1) {
                    setVisuallyFocusedOption(options[index + 1]);
                }
                else {
                    setVisuallyFocusedOption(options[0]);
                }
                break;
            case 'ArrowUp':
                e.preventDefault();
                if (index > 0) {
                    setVisuallyFocusedOption(options[index - 1]);
                }
                else {
                    setVisuallyFocusedOption(options[options.length - 1]);
                }
                break;
            case 'Enter':
                if (visuallyFocusedOption) {
                    e.preventDefault();
                    const element = document.getElementById(visuallyFocusedOption);
                    if (element)
                        element.click();
                }
                break;
            case 'Home':
                e.preventDefault();
                setVisuallyFocusedOption(options[0]);
                break;
            case 'End':
                e.preventDefault();
                setVisuallyFocusedOption(options[options.length - 1]);
                break;
            case 'Escape':
                // If there is a value or selected option, clear input and deselect option
                // Otherwise, the event will bubble up to the SearchRoot and close the search overlay
                if (value || visuallyFocusedOption) {
                    e.preventDefault();
                    e.stopPropagation();
                    setVisuallyFocusedOption(null);
                    onChange('');
                }
                break;
            case 'ArrowLeft':
            case 'ArrowRight':
                setVisuallyFocusedOption(null);
                break;
            case 'Delete':
            case 'Backspace':
                setVisuallyFocusedOption(null);
                break;
        }
    };
    return (react.createElement(SearchForm, { role: "combobox", name: name, label: label, placeholder: placeholder, value: value, invert: invert, "aria-controls": listboxId, "aria-expanded": open, "aria-autocomplete": "list", "aria-activedescendant": visuallyFocusedOption, onChange: handleChange, onKeyDown: handleKeyDown, onSubmit: onSubmit, onBlur: () => setVisuallyFocusedOption(null), dataTestId: dataTestId ? `${dataTestId}-form` : undefined, ref: inputRef, autoFocus: true }));
};

const fadeIn = (0,css_css/* animation */.oQ)('0.3s cubic-bezier(0.16, 1, 0.3, 1) forwards', {
    '0%': {
        opacity: 0,
    },
    '100%': {
        opacity: 1,
    },
});
const fadeOut$1 = (0,css_css/* animation */.oQ)('0.3s cubic-bezier(0.5, 1, 0.89, 1) forwards', {
    '0%': {
        opacity: 1,
    },
    '100%': {
        opacity: 0,
    },
});
const slideInTop = (0,css_css/* animation */.oQ)('0.5s cubic-bezier(0.16, 1, 0.3, 1) forwards', {
    '0%': {
        transform: 'translate3d(0, -60px, 0)',
    },
    '100%': {
        transform: 'translate3d(0, 0, 0)',
    },
});

/**
 * The `SearchContent` component is used to render the content of the search overlay e.g. the search result options.
 *
 * @example
 * <SearchContent>
 *   <SearchListbox>
 *     <ul>
 *       <li>
 *         <SearchOption>
 *           <a href="/option-1">Option 1</a>
 *         </SearchOption>
 *       </li>
 *       <li>
 *         <SearchOption>
 *           <a href="/option-2">Option 2</a>
 *         </SearchOption>
 *       </li>
 *       <li>
 *         <SearchOption>
 *           <a href="/option-3">Option 3</a>
 *         </SearchOption>
 *       </li>
 *     </ul>
 *   </SearchListbox>
 * </SearchContent>
 */
const SearchContent = ({ children, className, ...props }) => {
    const { dictionary } = (0,esm/* useUdsContext */.vV)();
    const { dataTestId, open, invert, contentRef, onOpenChange } = useSearchContext();
    const shouldMount = (0,esm/* useDelayUnmount */.dN)(open, 300);
    const isLargeDevice = (0,esm/* useMediaQuery */.ac)(`(min-width: ${twind.tw.theme('screens.lg')})`);
    if (!shouldMount)
        return null;
    return (react.createElement("div", { role: "dialog", "aria-label": dictionary.search, className: (0,twind.tw)('fixed inset-0 z-search', open ? fadeIn : fadeOut$1, className), "data-uds-child": "search-content", "data-test-id": dataTestId ? `${dataTestId}` : undefined, ref: contentRef, ...props },
        react.createElement("div", { "data-uds-child": "search-backdrop", className: "absolute inset-0 bg-black bg-opacity-50", onClick: () => onOpenChange(false), "aria-hidden": "true" }),
        react.createElement("div", { className: (0,twind.tw)('flex flex-col relative h-full lg:h-auto lg:max-h-full', css_css/* css */.iv `
            @screen lg {
              ${slideInTop}
            }
          `, invert ? 'bg-neutral-100' : 'bg-neutral-0'), style: {
                backfaceVisibility: 'hidden',
                perspective: 1000,
            } },
            react.createElement("div", { className: (0,twind.tw)('flex flex-shrink-0 sh items-center w-full h([104px] lg:[120px])', invert ? 'bg-neutral-90' : 'bg-neutral-10') },
                react.createElement(Container, { size: "page", className: "flex flex-row-reverse items-center lg:flex-row gap(2 lg:6)" },
                    react.createElement(SearchFormInternal, null),
                    react.createElement(ButtonIcon, { label: dictionary.close, icon: isLargeDevice ? 'close' : 'chevron-left', className: isLargeDevice ? '' : '-ml-3 rtl:ml-0 rtl:-mr-3', variant: "ghost", onClick: () => onOpenChange(false), "data-uds-child": "search-close-button", invert: invert }))),
            react.createElement(Container, { className: "py-8 overflow-auto", size: "page" }, children))));
};

/**
 * The `SearchTrigger` component should wrap the element that opens the search overlay.
 * It will render as the child element.
 *
 * @example
 * <SearchTrigger>
 *   <ButtonCta label="Search" icon="search" />
 * </SearchTrigger>
 */
const SearchTrigger = ({ className, children }) => {
    const { open, onTriggerClick, registerTrigger, unregisterTrigger } = useSearchContext();
    const ref = (0,react.useRef)(null);
    (0,react.useEffect)(() => {
        registerTrigger(ref);
        return () => {
            unregisterTrigger(ref);
        };
    }, [open]);
    const handleClick = () => {
        onTriggerClick(ref);
    };
    return (react.createElement($5e63c961fc1ce211$export$8c6ed5c666ac1360, { ref: ref, onClick: handleClick, className: className, "data-uds-child": "search-trigger" }, children));
};

/**
 * The `SearchListbox` component is used to render the listbox of the search overlay, wrapping the selectable options.
 *
 * @example
 * <SearchListbox>
 *   <ul>
 *     <li>
 *       <SearchOption>
 *         <a href="/option-1">Option 1</a>
 *       </SearchOption>
 *     </li>
 *     <li>
 *       <SearchOption>
 *         <a href="/option-2">Option 2</a>
 *       </SearchOption>
 *     </li>
 *     <li>
 *       <SearchOption>
 *         <a href="/option-3">Option 3</a>
 *       </SearchOption>
 *     </li>
 *   <ul>
 * </SearchListbox>
 */
const SearchListbox = ({ children, ...props }) => {
    const { listboxId, visuallyFocusedOption, dataTestId } = useSearchContext();
    return (react.createElement("div", { role: "listbox", "aria-activedescendant": visuallyFocusedOption, "data-test-id": dataTestId ? `${dataTestId}-listbox` : undefined, "data-uds-child": "search-listbox", id: listboxId, ...props }, children));
};

/**
 * Wrapper component for search result options, will register the anchor with the search context and attach keyboard navigation events, and any necessary behaviour.
 */
const SearchOption = ({ children, closeOnClick = true, }) => {
    const { dataTestId, visuallyFocusedOption, registerOption, unregisterOption, onOpenChange, } = useSearchContext();
    const id = reach_auto_id_useId();
    const isVisuallyFocused = id === visuallyFocusedOption;
    const handleClick = () => {
        if (closeOnClick)
            onOpenChange(false);
    };
    (0,react.useEffect)(() => {
        registerOption(id);
        return () => {
            unregisterOption(id);
        };
    }, []);
    return (react.createElement($5e63c961fc1ce211$export$8c6ed5c666ac1360, { tabIndex: 0, id: id, className: `focus-visible:ring-2 focus-visible:ring-neutral-50 focus-visible:border-[1px] focus-visible:border-neutral-50 focus:outline-none ${isVisuallyFocused
            ? 'ring-2 ring-neutral-50 border-[1px] border-neutral-50'
            : ''}`, "data-focused": isVisuallyFocused, "data-test-id": dataTestId ? `${dataTestId}-option` : undefined, role: "option", "data-uds-child": "search-option", "aria-selected": "false", onClick: handleClick }, children));
};

const fadeOut = (0,css_css/* animation */.oQ)('0.3s cubic-bezier(0.5, 1, 0.89, 1) forwards', {
    '0%': {
        opacity: 1,
    },
    '100%': {
        opacity: 0,
    },
});
const Chip = props => {
    const { label, dismissible = false, invert = false, round = false, className, onDismiss, dataTestId, ...rest } = props;
    const t = useUdsTranslate();
    const [isOpen, setIsOpen] = useState(true);
    const calloutMounted = useDelayUnmount(isOpen, 1000);
    const handleDismiss = e => {
        onDismiss && onDismiss(e);
        setIsOpen(false);
    };
    return is.undefined(dismissible) || calloutMounted ? (React.createElement("span", { ...rest, "data-uds-child": "chip", "data-test-id": dataTestId, className: tw$2('max-w-max relative', 'flex items-center flex-none', 'h-8 gap-1.5', round ? 'rounded-full px-px' : 'rounded-sm px-0', !isOpen && fadeOut, invert
            ? 'bg-neutral-80 text-neutral-0'
            : 'bg-neutral-20 text-neutral-100', 'text-sm font-bold tracking-wide leading-tight', 'focus-within:outline-none focus-within:ring-2', className) },
        React.createElement("span", { className: tw$2('mx-3', dismissible && 'pr-4') }, label),
        dismissible && (React.createElement("button", { onClick: handleDismiss, "data-uds-child": "chip-dismiss-button", "data-test-id": `${dataTestId}-dismiss-button`, className: tw$2('absolute inset-0', 'focus:outline-none') },
            React.createElement("span", { className: "sr-only" }, `${t('clear')} ${label}`),
            React.createElement("div", { className: tw$2('absolute mt-px top-1/2 -translate-y-1/2', round ? 'right-2' : 'right-1.5') },
                React.createElement(Icon, { name: "close", size: "lg" })))))) : null;
};

const TOGGLE_SIZE = {
    sm: 'h-8 text-xs',
    base: 'h-10 text-base',
    lg: 'h-14 text-xl',
};
const TOGGLE_PADDING = {
    sm: 'py-1 px-3',
    base: 'py-2 px-5',
    lg: 'py-3 px-7',
};
const ToggleTextBase = react.forwardRef(function ToggleTextBase(props, ref) {
    const { size = 'base', bleed, invert, disabled, className, label, children, dataTestId, ...rest } = props;
    const buttonSize = (0,esm/* useResponsiveProp */.Uo)(size, value => TOGGLE_SIZE[value]);
    const thumbStyle = (0,twind.tw)('block min-w-max relative border-1 rounded-[1px]', !disabled && invert && 'border-neutral-60 text-neutral-0', !disabled && !invert && 'border-neutral-20 text-neutral-100', !invert && disabled && 'border-neutral-20', invert && disabled && 'border-neutral-80', disabled && 'cursor-not-allowed', 'focus:outline-none focus-visible:outline-none', invert ? 'focus-visible:(ring-2 ring-invert)' : 'focus-visible:(ring-2)', bleed ? 'flex-1' : 'max-w-max flex-none', css_css/* css */.iv `
      &:hover,
      &:focus-visible {
        &:not([data-disabled]) {
          & [data-uds-child='toggle-text-overlay'] {
            @apply bg-opacity-100;
          }
        }
      }
      &[data-state='on'] {
        & [data-uds-child='toggle-text-outline'] {
          --tw-border-opacity: 1;
        }
        & [data-uds-child='toggle-text-overlay'] {
          @apply bg-opacity-0;
        }
      }
    `, css_css/* css */.iv `
      &[data-state='on'] {
        @apply border-opacity-0;
      }
    `);
    const contentPadding = (0,esm/* useResponsiveProp */.Uo)(size, value => TOGGLE_PADDING[value]);
    const contentStyle = (0,twind.tw)('relative z-[5] my-px flex items-center justify-center', '!leading-[1em]', bleed ? 'px-3' : contentPadding, disabled && !invert && 'text-neutral-60', disabled && invert && 'text-neutral-40');
    const outlineStyle = (0,twind.tw)('absolute -inset-px z-[10] rounded-[1px] transition-colors duration-100 transition-ease-out', 'border-2 border-opacity-0', invert ? 'border-neutral-0' : 'border-neutral-100 border-opacity-0');
    const overlayStyle = (0,twind.tw)('absolute inset-0 z-[0]', 'bg-opacity-0', !disabled && invert && 'bg-neutral-90', !disabled && !invert && 'bg-neutral-10', !invert && disabled && 'bg-neutral-20 bg-opacity-100', invert && disabled && 'bg-neutral-80 bg-opacity-100');
    return (react.createElement("button", { ...rest, ref: ref, disabled: disabled, "data-uds-child": "toggle-text", "data-test-id": dataTestId, className: (0,twind.tw)(thumbStyle, buttonSize, className) },
        react.createElement("div", { className: contentStyle, "data-uds-child": "toggle-text-label" }, label),
        react.createElement("div", { "data-uds-child": "toggle-text-overlay", className: overlayStyle }),
        react.createElement("div", { "data-uds-child": "toggle-text-outline", className: outlineStyle })));
});

const THUMB_SIZE$1 = {
    sm: 'w-8 h-8',
    base: 'w-10 h-10',
    lg: 'w-14 h-14',
};
const ICON_SIZE$2 = {
    sm: 'w-6 h-6',
    base: 'w-8 h-8',
    lg: 'w-10 h-10',
};
const ToggleIconBase = (0,react.forwardRef)(function ToggleIconBase(props, ref) {
    const { label, size = 'base', round, icon, iconOn, invert, disabled, className, children, dataTestId, ...rest } = props;
    const buttonSize = (0,esm/* useResponsiveProp */.Uo)(size, value => THUMB_SIZE$1[value]);
    const thumbStyle = (0,twind.tw)('flex items-center justify-center relative flex-none border-1 rounded-[1px]', round && 'rounded-full', disabled && 'cursor-not-allowed', !disabled && invert && 'border-neutral-60 text-neutral-0', !disabled && !invert && 'border-neutral-20 text-neutral-100', !invert && disabled && 'border-neutral-20', invert && disabled && 'border-neutral-80', 'focus:outline-none focus-visible:outline-none', invert ? 'focus-visible:(ring-2 ring-invert)' : 'focus-visible:(ring-2)', css_css/* css */.iv `
      &:hover,
      &:focus-visible {
        &:not([data-disabled]) {
          & [data-uds-child='toggle-icon-overlay'] {
            @apply bg-opacity-100;
          }
        }
      }
      &:not([data-disabled]) {
        & [data-uds-child='toggle-icon-content'] {
          opacity: 1;
          @apply ${invert ? 'text-neutral-70' : 'text-neutral-30'};
        }
      }

      &[data-state='on'] {
        & [data-uds-child='toggle-icon-content'] {
          opacity: 1;
          @apply ${invert ? 'text-neutral-0' : 'text-neutral-100'};
        }
        & [data-uds-child='toggle-icon-outline'] {
          --tw-border-opacity: 1;
        }
        & [data-uds-child='toggle-icon-overlay'] {
          @apply bg-opacity-0;
        }
      }
    `, css_css/* css */.iv `
      &[data-state='on'] {
        @apply border-opacity-0;
      }
    `, iconOn &&
        css_css/* css */.iv `
        & [data-uds-child='toggle-icon-svg-on'] {
          display: none;
        }
        &[data-state='on'] {
          & [data-uds-child='toggle-icon-svg'] {
            display: none;
          }
          & [data-uds-child='toggle-icon-svg-on'] {
            display: block;
          }
        }
      `);
    const iconSize = (0,esm/* useResponsiveProp */.Uo)(size, value => ICON_SIZE$2[value]);
    const iconStyle = (0,twind.tw)('relative z-[10]', disabled && invert && 'text-neutral-40', disabled && !invert && 'text-neutral-60', iconSize);
    const outlineStyle = (0,twind.tw)('border-2 border-opacity-0', 'absolute -inset-px z-[10] rounded-[1px] transition-colors duration-100 transition-ease-out', round && 'rounded-full', invert ? 'border-neutral-0' : 'border-neutral-100 border-opacity-0');
    const overlayStyle = (0,twind.tw)('absolute inset-0 z-[0]', 'bg-opacity-0', round && 'rounded-full', !disabled && invert && 'bg-neutral-90', !disabled && !invert && 'bg-neutral-10', !invert && disabled && 'bg-neutral-20 bg-opacity-100', invert && disabled && 'bg-neutral-80 bg-opacity-100');
    return (react.createElement("button", { ...rest, ref: ref, disabled: disabled, "data-uds-child": "toggle-icon", "data-test-id": dataTestId, className: (0,twind.tw)(thumbStyle, buttonSize, className) },
        react.createElement("span", { className: "sr-only" }, label),
        react.createElement("div", { className: "aspect-1-1" },
            react.createElement("div", { className: iconStyle, "data-uds-child": "toggle-icon-content" },
                react.createElement(Icon, { invert: invert, "data-uds-child": "toggle-icon-svg", name: icon }, children),
                iconOn && (react.createElement(Icon, { invert: invert, "data-uds-child": "toggle-icon-svg-on", name: iconOn }))),
            react.createElement("div", { "data-uds-child": "toggle-icon-overlay", className: overlayStyle }),
            react.createElement("div", { "data-uds-child": "toggle-icon-outline", className: outlineStyle }))));
});

const ICON_SIZE$1 = {
    sm: 'w-4 h-4',
    base: 'w-6 h-6',
    lg: 'w-7 h-7',
};
const CONTENT_STYLE = {
    sm: 'py-1 px-2 gap-1.5',
    base: 'py-2 px-3 gap-2',
    lg: 'py-3 px-4 gap-2.5',
};
const BUTTON_SIZE = {
    sm: 'h-8 min-w-6 text-xs',
    base: 'h-10 min-w-10 text-base',
    lg: 'h-14 min-w-14 text-xl',
};
const ToggleSwitchBase = (0,react.forwardRef)(function ToggleSwitchBase(props, ref) {
    const { size = 'base', icon = 'check-filled', iconEnd, invert, disabled, className, label, children, dataTestId, ...rest } = props;
    const buttonSize = (0,esm/* useResponsiveProp */.Uo)(size, value => BUTTON_SIZE[value]);
    const thumbStyle = (0,twind.tw)('block relative border-1 rounded-[1px]', 'flex justify-center items-center', !disabled && invert && 'border-neutral-60 text-neutral-0', !disabled && !invert && 'border-neutral-20 text-neutral-100', !invert && disabled && 'border-neutral-20', invert && disabled && 'border-neutral-80', disabled && 'cursor-not-allowed', 'focus:outline-none focus-visible:outline-none', invert ? 'focus-visible:(ring-2 ring-invert)' : 'focus-visible:(ring-2)', css_css/* css */.iv `
      &:hover,
      &:focus-visible {
        &:not([data-disabled]) {
          & [data-uds-child='toggle-switch-overlay'] {
            @apply bg-opacity-100;
          }
        }
      }

      &:not([data-disabled]) {
        & [data-uds-child='toggle-switch-icon'] {
          opacity: 1;
          @apply ${invert ? 'text-neutral-80' : 'text-neutral-20'};
        }
      }

      &[data-state='on'] {
        & [data-uds-child='toggle-switch-icon'] {
          opacity: 1;
          @apply ${invert ? 'text-neutral-0' : 'text-neutral-100'};
        }

        & [data-uds-child='toggle-switch-outline'] {
          --tw-border-opacity: 1;
        }
        & [data-uds-child='toggle-switch-overlay'] {
          @apply bg-opacity-0;
        }
      }
    `, css_css/* css */.iv `
      &[data-state='on'] {
        @apply border-opacity-0;
      }
    `);
    const iconSize = (0,esm/* useResponsiveProp */.Uo)(size, value => ICON_SIZE$1[value]);
    const iconStyle = (0,twind.tw)('transition-colors duration-250 transition-ease-out', disabled && invert && 'text-neutral-40', disabled && !invert && 'text-neutral-60', iconSize);
    const contentPadding = (0,esm/* useResponsiveProp */.Uo)(size, value => {
        return [CONTENT_STYLE[value]];
    });
    const contentStyle = (0,twind.tw)('relative z-[5] flex items-center justify-center', iconEnd ? 'flex-row-reverse' : 'flex-row', contentPadding);
    const labelStyle = (0,twind.tw)('!leading-[1em]', disabled && invert && 'text-neutral-40', disabled && !invert && 'text-neutral-60');
    const outlineStyle = (0,twind.tw)('absolute -inset-px z-[10] rounded-[1px] transition-colors duration-100 transition-ease-out', 'border-2 border-opacity-0', invert ? 'border-neutral-0' : 'border-neutral-100 border-opacity-0');
    const overlayStyle = (0,twind.tw)('absolute inset-0 z-[0]', 'bg-opacity-0', !disabled && invert && 'bg-neutral-90', !disabled && !invert && 'bg-neutral-10', !invert && disabled && 'bg-neutral-20 bg-opacity-100', invert && disabled && 'bg-neutral-80 bg-opacity-100');
    return (react.createElement("button", { ...rest, ref: ref, disabled: disabled, "data-uds-child": "toggle-switch", "data-test-id": dataTestId, className: (0,twind.tw)(thumbStyle, buttonSize, className) },
        react.createElement("div", { className: (0,twind.tw)(contentStyle) },
            react.createElement("div", { "data-uds-child": "toggle-switch-icon", className: iconStyle },
                react.createElement(Icon, { invert: invert, name: icon }, children)),
            react.createElement("div", { className: labelStyle, "data-uds-child": "toggle-switch-label" }, label)),
        react.createElement("div", { "data-uds-child": "toggle-switch-overlay", className: overlayStyle }),
        react.createElement("div", { "data-uds-child": "toggle-switch-outline", className: outlineStyle })));
});

const THUMB_SIZE = {
    auto: 'w-full',
    sm: 'w-8',
    base: 'w-10',
    lg: 'w-14',
};
const LABEL_SIZE$1 = {
    auto: 'text-sm mt-2',
    sm: 'text-xxs mt-1',
    base: 'text-xs mt-1.5',
    lg: 'text-sm mt-2',
};
const ToggleThumbBase = (0,react.forwardRef)(function ToggleThumbBase(props, ref) {
    const { label, showLabel = false, size = 'base', ratio = 1, round = false, invert, disabled, className, children, dataTestId, ...rest } = props;
    const buttonSize = (0,esm/* useResponsiveProp */.Uo)(size, value => THUMB_SIZE[value]);
    const labelSize = (0,esm/* useResponsiveProp */.Uo)(size, value => LABEL_SIZE$1[value]);
    const thumbStyle = (0,twind.tw)('group block relative flex-none rounded-[1px]', 'focus:outline-none focus-visible:outline-none', disabled && 'cursor-not-allowed', round && 'rounded-full', css_css/* css */.iv `
      &:hover,
      &:focus-visible {
        &:not([data-disabled]) {
          & [data-uds-child='toggle-thumb-overlay'] {
            @apply bg-opacity-20;
          }
        }
      }
      &[data-disabled] {
        & [data-uds-child='toggle-thumb-media'] {
          filter: grayscale(100%);
        }
      }
      &[data-state='on'] {
        & [data-uds-child='toggle-thumb-outline'] {
          --tw-border-opacity: 1;
        }
        & [data-uds-child='toggle-thumb-overlay'] {
          @apply bg-opacity-0;
        }
      }
    `, css_css/* css */.iv `
      &[data-state='on'] {
        & [data-uds-child='toggle-thumb-media'] {
          @apply border-opacity-0;
        }
      }
    `);
    const ratioStyle = (0,twind.tw)(round && 'rounded-full', invert
        ? 'group-focus-visible:(ring-2 ring-invert)'
        : 'group-focus-visible:(ring-2)');
    const contentStyle = (0,twind.tw)('absolute inset-0 border-1 z-0  rounded-[1px]', 'children:(object-cover object-center w-full h-full)', round && 'rounded-full overflow-hidden', invert ? 'border-neutral-80' : 'border-neutral-20');
    const outlineStyle = (0,twind.tw)('absolute inset-0 z-[10] rounded-[1px] transition-colors duration-100 transition-ease-out', 'border-2 border-opacity-0', round && 'rounded-full', invert ? 'border-neutral-0' : 'border-neutral-100 border-opacity-0');
    const overlayStyle = (0,twind.tw)('absolute inset-0 z-[1]', 'bg-neutral-20', 'bg-opacity-0', round && 'rounded-full', !invert && disabled && 'bg-opacity-80', invert && disabled && 'bg-neutral-80 bg-opacity-80');
    return (react.createElement("button", { ...rest, ref: ref, disabled: disabled, "data-uds-child": "toggle-thumb", "data-test-id": dataTestId, className: (0,twind.tw)(thumbStyle, buttonSize, className) },
        react.createElement(AspectRatio, { ratio: ratio, overflow: true, className: ratioStyle },
            react.createElement("div", { "data-uds-child": "toggle-thumb-media", className: contentStyle }, children),
            react.createElement("div", { "data-uds-child": "toggle-thumb-overlay", className: overlayStyle }),
            react.createElement("div", { "data-uds-child": "toggle-thumb-outline", className: outlineStyle })),
        react.createElement("span", { className: showLabel
                ? (0,twind.tw)('block leading-none text-center', labelSize)
                : 'sr-only' }, label)));
});

const CONTENT_SIZE = {
    sm: 'pl-3 pr-8 rtl:pl-8 rtl:pr-3 pb-2 pt-4',
    base: 'pl-4 pr-10 rtl:pl-10 rtl:pr-4 pb-3 pt-6',
    lg: 'pl-6 pr-12 rtl:pl-12 rtl:pr-6  pb-4 pt-7',
};
const LABEL_SIZE = {
    sm: 'text-xs',
    base: 'text-sm ',
    lg: 'text-base ',
};
const ICON_SIZE = {
    sm: 'xl',
    base: '2xl',
    lg: '3xl',
};
const ICON_OFFSET = {
    sm: '-mt-px',
    base: '-mt-0.5',
    lg: '-mt-0.5',
};
const ToggleImageBase = (0,react.forwardRef)(function ToggleImageBase(props, ref) {
    const { size = 'base', label, overlay = 'dark', ratio = 2 / 3, invert, disabled, className, children, dataTestId, ...rest } = props;
    const thumbStyle = (0,twind.tw)('w-full block relative rounded-[1px]', 'focus:outline-none focus-visible:outline-none', disabled && 'cursor-not-allowed', invert ? 'focus-visible:(ring-3 ring-invert)' : 'focus-visible:(ring-3)', css_css/* css */.iv `
      &:hover,
      &:focus-visible {
        &:not([data-disabled]) {
          & [data-uds-child='toggle-image-filter'] {
            backdrop-filter: blur(0px) opacity(100);
          }
        }
      }
      &[data-disabled] {
        & [data-uds-child='toggle-image-media'] {
          filter: grayscale(100%);
        }
      }

      & [data-uds-child='toggle-image-icon'] {
        opacity: 0;
      }

      &[data-state='on'] {
        & [data-uds-child='toggle-image-filter'] {
          backdrop-filter: blur(0px) opacity(100);
        }

        & [data-uds-child='toggle-image-overlay'] {
          opacity: 0;
        }
        & [data-uds-child='toggle-image-icon'] {
          opacity: 1;
        }
        &:hover,
        &:focus-visible {
          &:not([data-disabled]) {
            & [data-uds-child='toggle-image-overlay'] {
              opacity: 0;
            }
          }
        }
      }
    `);
    const filterStyle = (0,twind.tw)('pointer-events-none absolute inset-0 z-[1]', css_css/* css */.iv `
      transition: backdrop-filter 200ms ease-out;
      backdrop-filter: blur(4px) opacity(1);
    `, disabled && 'bg-opacity-0');
    const overlayStyle = (0,twind.tw)('pointer-events-none absolute inset-0 z-[1]', 'opacity-50', 'transition-opacity duration-200 transition-ease-out', overlay === 'dark' ? 'bg-neutral-100' : 'bg-neutral-10', invert && disabled && 'bg-neutral-100 opacity-50', !invert && disabled && 'bg-neutral-40 opacity-50');
    const mediaStyle = (0,twind.tw)('pointer-events-none absolute inset-0 z-0 rounded-[1px]', 'children:(object-cover object-center w-full h-full)');
    const contentSize = (0,esm/* useResponsiveProp */.Uo)(size, value => CONTENT_SIZE[value]);
    const contentStyle = (0,twind.tw)(contentSize, 'leading-[1] ', 'absolute z-[10] w-full bottom-0 left-0 text-left rtl:text-right', 'flex justify-between items-start gap-3', overlay === 'dark' ? 'text-neutral-0' : 'text-neutral-100', css_css/* css */.iv `
      & > span {
        position: relative;
        z-index: 10;
      }
      &:before {
        content: '';
        position: absolute;
        z-index: 0;
        top: 0;
        left: 0;
        width: 100%;
        height: calc(100% + 1px);
        --media-vignette-angle: 0deg;
        --grad-start: 0.6;
        --grad-end: 0;
        --grad-spread: 80%;
      }
    `, overlay === 'dark'
        ? css_css/* css */.iv `
          &:before {
            background: linear-gradient(
              var(--media-vignette-angle),
              rgba(25, 25, 25, var(--grad-start)) 0%,
              rgba(25, 25, 25, var(--grad-end)) var(--grad-spread)
            );
          }
        `
        : css_css/* css */.iv `
          &:before {
            background: linear-gradient(
              var(--media-vignette-angle),
              rgba(255, 255, 255, var(--grad-start)) 0%,
              rgba(255, 255, 255, var(--grad-end)) var(--grad-spread)
            );
          }
        `);
    const labelSize = (0,esm/* useResponsiveProp */.Uo)(size, value => LABEL_SIZE[value]);
    const labelStyle = (0,twind.tw)(labelSize, 'uppercase font-bold');
    const iconOffset = (0,esm/* useResponsiveProp */.Uo)(size, value => ICON_OFFSET[value]);
    const iconStyle = (0,twind.tw)('absolute left-full rtl:right-full rtl:left-auto top-0', 'transition-colors duration-300 transition-ease-out', iconOffset);
    const iconSize = (0,esm/* useResponsiveMap */._w)(size, ICON_SIZE);
    return (react.createElement("button", { ...rest, ref: ref, disabled: disabled, "data-uds-child": "toggle-image", "data-test-id": dataTestId, className: (0,twind.tw)(thumbStyle, className) },
        react.createElement(AspectRatio, { ratio: ratio, overflow: true },
            react.createElement("div", { "data-uds-child": "toggle-image-media", className: mediaStyle }, children),
            react.createElement("div", { "data-uds-child": "toggle-image-filter", className: filterStyle }),
            react.createElement("div", { "data-uds-child": "toggle-image-overlay", className: overlayStyle }),
            react.createElement("div", { "data-uds-child": "toggle-image-content", className: contentStyle },
                react.createElement("div", { className: "relative w-full" },
                    react.createElement("span", { className: labelStyle }, label),
                    react.createElement("span", { "data-aria-hidden": "true", "data-uds-child": "toggle-image-icon", className: iconStyle },
                        react.createElement(Icon, { size: iconSize, name: "check-filled" })))))));
});

const ToggleChipBase = react.forwardRef(function ToggleChipBase(props, ref) {
    const { round, invert, disabled, className, label, children, dataTestId, ...rest } = props;
    const thumbStyle = (0,twind.tw)('max-w-max relative', 'flex items-center flex-none', 'h-8', round ? 'rounded-full px-px' : 'rounded-sm px-0', !disabled && invert && 'bg-neutral-80', !disabled && !invert && 'bg-neutral-20', !invert && disabled && 'bg-neutral-20 bg-opacity-100', invert && disabled && 'bg-neutral-80 bg-opacity-100', !disabled && invert && 'border-neutral-60', !disabled && !invert && 'border-neutral-20', !invert && disabled && 'border-neutral-20', invert && disabled && 'border-neutral-80', disabled && 'cursor-not-allowed', 'focus:outline-none focus-visible:outline-none', invert ? 'focus-visible:(ring-2 ring-invert)' : 'focus-visible:(ring-2)', css_css/* css */.iv `
      &:hover,
      &:focus-visible {
        &:not([data-disabled]) {
          & [data-uds-child='toggle-chip-overlay'] {
            @apply bg-opacity-60;
          }
        }
      }
      &[data-state='on'] {
        & [data-uds-child='toggle-chip-outline'] {
          --tw-border-opacity: 1;
        }
        & [data-uds-child='toggle-chip-overlay'] {
          @apply bg-opacity-0;
        }
      }
    `, css_css/* css */.iv `
      &[data-state='on'] {
        @apply border-opacity-0;
      }
    `);
    const contentStyle = (0,twind.tw)('relative z-[5] my-px px-3', 'text-sm font-bold tracking-wide leading-tight', disabled && !invert && 'text-neutral-60', disabled && invert && 'text-neutral-40');
    const outlineStyle = (0,twind.tw)('absolute -inset-px z-[10] transition-colors duration-100 transition-ease-out', 'border-2 border-opacity-0', round ? 'rounded-full' : 'rounded-sm', invert ? 'border-neutral-0' : 'border-neutral-100 border-opacity-0');
    const overlayStyle = (0,twind.tw)('absolute inset-0 z-[0]', 'bg-opacity-0', round ? 'rounded-full' : 'rounded-sm', !invert ? 'bg-neutral-30' : 'bg-neutral-90');
    return (react.createElement("button", { ...rest, ref: ref, disabled: disabled, "data-uds-child": "toggle-chip", "data-test-id": dataTestId, className: (0,twind.tw)(thumbStyle, className) },
        react.createElement("div", { className: contentStyle, "data-uds-child": "toggle-chip-label" }, label),
        react.createElement("div", { "data-uds-child": "toggle-chip-overlay", className: overlayStyle }),
        react.createElement("div", { "data-uds-child": "toggle-chip-outline", className: outlineStyle })));
});

const ToggleButtonChip = (0,react.forwardRef)((props, ref) => {
    const { label, ...rest } = props;
    return (react.createElement($b3bbe2732c13b576$export$bea8ebba691c5813, { asChild: true, ...rest },
        react.createElement(ToggleChipBase, { ref: ref, label: label })));
});
ToggleButtonChip.displayName = 'ToggleButtonChip';

const ToggleButtonIcon = (0,react.forwardRef)((props, ref) => {
    const { label, icon, ...rest } = props;
    return (react.createElement($b3bbe2732c13b576$export$bea8ebba691c5813, { asChild: true, ...rest },
        react.createElement(ToggleIconBase, { ref: ref, icon: icon, label: label })));
});
ToggleButtonIcon.displayName = 'ToggleButtonIcon';

const ToggleButtonImage = (0,react.forwardRef)((props, ref) => {
    const { label, children, ...rest } = props;
    return (react.createElement($b3bbe2732c13b576$export$bea8ebba691c5813, { asChild: true, ...rest },
        react.createElement(ToggleImageBase, { ref: ref, label: label }, children)));
});
ToggleButtonImage.displayName = 'ToggleButtonImage';

const ToggleButtonSwitch = (0,react.forwardRef)((props, ref) => {
    const { label, ...rest } = props;
    return (react.createElement($b3bbe2732c13b576$export$bea8ebba691c5813, { asChild: true, ...rest },
        react.createElement(ToggleSwitchBase, { ref: ref, label: label })));
});
ToggleButtonSwitch.displayName = 'ToggleButtonSwitch';

const ToggleButtonText = (0,react.forwardRef)((props, ref) => {
    const { label, ...rest } = props;
    return (react.createElement($b3bbe2732c13b576$export$bea8ebba691c5813, { asChild: true, ...rest },
        react.createElement(ToggleTextBase, { ref: ref, label: label })));
});
ToggleButtonText.displayName = 'ToggleButtonText';

const ToggleButtonThumb = (0,react.forwardRef)((props, ref) => {
    const { label, children, ...rest } = props;
    return (react.createElement($b3bbe2732c13b576$export$bea8ebba691c5813, { asChild: true, ...rest },
        react.createElement(ToggleThumbBase, { ref: ref, label: label }, children)));
});
ToggleButtonThumb.displayName = 'ToggleButtonThumb';

const ToggleButton = {
    Icon: ToggleButtonIcon,
    Text: ToggleButtonText,
    Switch: ToggleButtonSwitch,
    Thumb: ToggleButtonThumb,
    Image: ToggleButtonImage,
    Chip: ToggleButtonChip,
};

const ToggleGroupRoot = (props) => {
    const { optional, type, value, defaultValue, onValueChange, className, ...rest } = props;
    const appliedOptional = optional ?? type === 'multiple';
    const [internalValue, setInternalValue] = useState(defaultValue || value);
    useEffect(() => {
        if (value)
            setInternalValue(value);
    }, [value]);
    const handleValueChange = (value) => {
        if (!appliedOptional && type === 'single' && !value)
            return;
        if (!appliedOptional && value.length === 0)
            return;
        setInternalValue(value);
        onValueChange?.(value);
    };
    return (React.createElement(ToggleGroup, { type: type, value: internalValue, onValueChange: handleValueChange, ...rest, className: className }));
};

const ToggleGroupItemChip = (0,react.forwardRef)((props, ref) => {
    const { label, ...rest } = props;
    return (react.createElement($6c1fd9e6a8969628$export$b453109e13abe10b, { asChild: true, ...rest },
        react.createElement(ToggleChipBase, { ref: ref, label: label })));
});
ToggleGroupItemChip.displayName = 'ToggleGroupItemChip';

const ToggleGroupItemIcon = (0,react.forwardRef)((props, ref) => {
    const { label, icon, ...rest } = props;
    return (react.createElement($6c1fd9e6a8969628$export$b453109e13abe10b, { asChild: true, ...rest },
        react.createElement(ToggleIconBase, { ref: ref, icon: icon, label: label })));
});
ToggleGroupItemIcon.displayName = 'ToggleGroupItemIcon';

const ToggleGroupItemImage = (0,react.forwardRef)((props, ref) => {
    const { label, children, ...rest } = props;
    return (react.createElement($6c1fd9e6a8969628$export$b453109e13abe10b, { asChild: true, ...rest },
        react.createElement(ToggleImageBase, { ref: ref, label: label }, children)));
});
ToggleGroupItemImage.displayName = 'ToggleGroupItemImage';

const ToggleGroupItemSwitch = (0,react.forwardRef)((props, ref) => {
    const { label, ...rest } = props;
    return (react.createElement($6c1fd9e6a8969628$export$b453109e13abe10b, { asChild: true, ...rest },
        react.createElement(ToggleSwitchBase, { ref: ref, label: label })));
});
ToggleGroupItemSwitch.displayName = 'ToggleGroupItemSwitch';

const ToggleGroupItemText = (0,react.forwardRef)((props, ref) => {
    const { label, ...rest } = props;
    return (react.createElement($6c1fd9e6a8969628$export$b453109e13abe10b, { asChild: true, ...rest },
        react.createElement(ToggleTextBase, { ref: ref, label: label })));
});
ToggleGroupItemText.displayName = 'ToggleGroupItemText';

const ToggleGroupItemThumb = (0,react.forwardRef)((props, ref) => {
    const { label, children, ...rest } = props;
    return (react.createElement($6c1fd9e6a8969628$export$b453109e13abe10b, { asChild: true, ...rest },
        react.createElement(ToggleThumbBase, { ref: ref, label: label }, children)));
});
ToggleGroupItemThumb.displayName = 'ToggleGroupItemThumb';

const ToggleGroupItem = {
    Text: ToggleGroupItemText,
    Icon: ToggleGroupItemIcon,
    Switch: ToggleGroupItemSwitch,
    Thumb: ToggleGroupItemThumb,
    Image: ToggleGroupItemImage,
    Chip: ToggleGroupItemChip,
};

const selectStyle = (0,style/* style */.oB)({
    base: 'h-10 px-3 border-1 rounded-sm text-sm',
    variants: {
        invert: {
            true: 'text-neutral-0',
            false: 'text-neutral-100',
        },
        disabled: {
            true: '',
            false: '',
        },
        filled: {
            true: '',
            false: '',
        },
    },
    matches: [
        // Default state
        {
            invert: false,
            disabled: false,
            filled: false,
            use: 'border-neutral-40 hover:border-neutral-100',
        },
        // Default state (inverted)
        {
            invert: true,
            disabled: false,
            filled: false,
            use: 'border-neutral-50 hover:border-neutral-0',
        },
        // Focused state
        {
            invert: false,
            disabled: false,
            use: 'focus-within:(border-neutral-100 ring-2)',
        },
        // Focused state (inverted)
        {
            invert: true,
            disabled: false,
            use: 'focus-within:(border-neutral-0 ring-2)',
        },
        // Filled state
        {
            invert: false,
            disabled: false,
            filled: true,
            use: 'border-neutral-100',
        },
        // Filled state (inverted)
        {
            invert: true,
            disabled: false,
            filled: true,
            use: 'border-neutral-0',
        },
        // Disabled state
        {
            disabled: true,
            invert: false,
            use: 'bg-neutral-20 border-neutral-20 text-neutral-70',
        },
        // Disabled state (inverted)
        {
            disabled: true,
            invert: true,
            use: 'bg-neutral-80 border-neutral-80 text-neutral-30',
        },
    ],
});
const FilterSelectInner = react.forwardRef(function FilterSelectInner({ label }, ref) {
    const { id, value, invert, disabled, className, dataTestId } = useSelectContext();
    return (react.createElement(SelectRoot, { className: (0,style.tw)(selectStyle({
            invert,
            disabled,
            filled: !!value && value !== PLACEHOLDER_VALUE,
        }), className) },
        react.createElement("label", { className: "sr-only", "data-test-id": dataTestId && `${dataTestId}-label`, htmlFor: id }, label),
        react.createElement(SelectValue, { className: "text-base font-bold" }),
        react.createElement(SelectHiddenInput, { ref: ref }),
        react.createElement(SelectChevron, { className: "mt-0.5" })));
});
/**
 * The `FilterSelect` renders a styled `select` tag and is used to create a drop-down list.
 *
 * - The component is implemented with backwards compatibility in mind, and is likely to change
 *
 * @example
 * ```
 * <FilterSelect
 *   label="Select an option"
 *   placeholder="Select an option"
 *   options={[ { value: "optionOne", label: "Option One" } ]}
 *   defaultValue="optionOne"
 * />
 * ```
 */
const FilterSelect = react.forwardRef(function FilterSelect({ label, id: propsId, invert = false, disabled = false, ...props }, ref) {
    const id = reach_auto_id_useId(propsId);
    return (react.createElement(SelectProvider, { value: {
            id,
            invert,
            disabled,
            ...props,
        } },
        react.createElement(FilterSelectInner, { label: label, ref: ref })));
});

const FilterToggle = react.forwardRef(function FilterToggle(props, ref) {
    const { dataTestId, highlighted, invert, defaultPressed, pressed, onPressedChange, children, ...rest } = props;
    const [internalPressed, setInternalPressed] = react.useState(defaultPressed);
    (0,react.useEffect)(() => {
        if (utils_esm.is.exists(pressed)) {
            setInternalPressed(pressed);
        }
    }, [pressed]);
    const handleClick = () => {
        setInternalPressed(!internalPressed);
        onPressedChange && onPressedChange(!internalPressed);
    };
    const baseColors = (0,twind.tw)(!internalPressed && !highlighted && 'border-neutral-30', internalPressed && 'border-neutral-100', highlighted && 'border-neutral-100', 'hover:border-neutral-100', 'focus:outline-none focus-visible:(border-neutral-100 ring-2)');
    const invertColors = (0,twind.tw)(!internalPressed && !highlighted && 'border-neutral-70', internalPressed && 'border-neutral-0', highlighted && 'border-neutral-0', 'hover:border-neutral-0', 'focus:outline-none focus-visible:(border-neutral-0 ring-invert ring-2)');
    return (react.createElement("button", { ref: ref, type: "button", "data-uds-child": "filter-toggle", "aria-pressed": internalPressed ? 'true' : 'false', "data-test-id": dataTestId, onClick: handleClick, className: (0,twind.tw)('relative h-10 px-3', 'flex gap-2 items-center', 'px-3 rounded-sm border-1', 'whitespace-nowrap text-base font-bold leading-none', invert ? invertColors : baseColors), ...rest },
        children,
        react.createElement(ToggleChevron, { open: internalPressed, size: "lg", className: "mt-0.5" })));
});

const Image = (0,react.forwardRef)((props, forwardedRef) => {
    const { src, onLoaded, onLoadingStatusChange, ...rest } = props;
    const imageLoadingStatus = useImageLoadingStatus(src);
    const handleLoadingStatusChange = (0,react_use_callback_ref_dist/* useCallbackRef */.W)((status) => {
        onLoadingStatusChange?.(status);
    });
    (0,esm/* useIsomorphicLayoutEffect */.LI)(() => {
        if (imageLoadingStatus !== 'idle') {
            handleLoadingStatusChange?.(imageLoadingStatus);
        }
        if (imageLoadingStatus === 'loaded') {
            onLoaded?.();
        }
    }, [imageLoadingStatus, handleLoadingStatusChange]);
    return imageLoadingStatus === 'loaded' ? (react.createElement("img", { "data-uds-child": "image", ...rest, ref: forwardedRef, src: src })) : null;
});
Image.displayName = 'Image';
const useImageLoadingStatus = (src) => {
    const image = (0,react.useRef)();
    const [loadingStatus, setLoadingStatus] = (0,react.useState)('idle');
    (0,react.useEffect)(() => {
        /* istanbul ignore next */
        if (utils_esm/* isServer */.sk)
            return;
        if (!src) {
            setLoadingStatus('error');
            return;
        }
        let isMounted = true;
        const updateStatus = (status) => () => {
            /* istanbul ignore next */
            if (!isMounted)
                return;
            setLoadingStatus(status);
        };
        setLoadingStatus('loading');
        image.current = new window.Image();
        image.current.onload = updateStatus('loaded');
        image.current.onerror = updateStatus('error');
        image.current.src = src;
        return () => {
            isMounted = false;
        };
    }, [src]);
    return loadingStatus;
};

const AVATAR_VARIANTS = {
    size: {
        sm: 'w-8 h-8 text-sm border-3',
        base: 'w-12 h-12 heading-sm border-4',
        lg: 'w-20 h-20 heading-base border-5',
    },
    invert: {
        true: 'bg-neutral-80 text-neutral-0 border-neutral-70',
        false: 'bg-neutral-10 text-neutral-100 border-neutral-0',
    },
};
const avatarStyle = (0,style/* style */.oB)({ variants: AVATAR_VARIANTS });
const AvatarContext = react.createContext(null);
const useAvatarContext = () => useContext(AvatarContext);
/**
 * Avatar compound pattern. Render a rounded image, graphic or icon with an optional label.
 *
 * @example
 * ```tsx
 * <AvatarRoot>
 *   <AvatarImage src="img.png" />
 *   <AvatarLabel>JD</AvatarLabel>
 * </AvatarRoot>
 * ```
 *
 *  * @example
 * ```tsx
 * <AvatarRoot aria-label="John Doe">
 *   <AvatarImage src="img.png" />
 * </AvatarRoot>
 * ```
 */
const AvatarRoot = (props) => {
    const { dataTestId, children, className, size = 'base', invert = false, delay = 600, asChild, ...rest } = props;
    const Comp = asChild ? Slot : 'span';
    const timeoutRef = useRef();
    const [imageLoaded, setImageLoaded] = React.useState(false);
    const onImageLoaded = React.useCallback(() => {
        timeoutRef.current = setTimeout(() => {
            setImageLoaded(true);
        }, delay);
        /* istanbul ignore next */
        return () => {
            /* istanbul ignore next */
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, []);
    return (React.createElement(AvatarContext.Provider, { value: { size, invert, onImageLoaded, imageLoaded } },
        React.createElement(Comp, { "data-test-id": dataTestId, "data-uds-attr-media-ready": imageLoaded ? 'true' : 'false', className: tw$2('relative inline-grid grid-cols-1 rounded-full overflow-hidden items-center justify-items-center align-middle', 'flex-none min-w-8 min-h-8', 'children:(col-start-1 row-start-1)', avatarStyle({ size, invert }), css `
            & > [data-uds-child='avatar-image'],
            & > [data-uds-child='avatar-graphic'] {
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              object-fit: cover;
              object-position: center;
              z-index: 0;
              opacity: 0;
            }

            & > [data-uds-child='avatar-image'],
            & > [data-uds-child='avatar-icon'],
            & > [data-uds-child='avatar-graphic'] {
              z-index: 0;
              opacity: 0;
            }

            & > [data-uds-child='avatar-label'] {
              z-index: 1;
              opacity: 1;
              margin-top: -0.075em;
            }

            &[data-uds-attr-media-ready='true'] {
              & > [data-uds-child='avatar-image'],
              & > [data-uds-child='avatar-icon'],
              & > [data-uds-child='avatar-graphic'] {
                opacity: 1;
              }
              & > [data-uds-child='avatar-label'] {
                opacity: 0;
              }
            }
          `, className), ...rest, "data-uds-child": "avatar" }, children)));
};
/**
 * Render an image inside the avatar.
 *
 * @example
 * ```tsx
 * <AvatarRoot>
 *   <AvatarImage src="img.png" />
 *   <AvatarLabel>JD</AvatarLabel>
 * </AvatarRoot>
 * ```
 */
const AvatarImage = (props) => {
    const { onImageLoaded } = useAvatarContext();
    return (React.createElement(Image, { "data-uds-child": "avatar-image", onLoaded: onImageLoaded, ...props }));
};
/**
 * Render an svg graphic inside the avatar
 *
 * @example
 * ```tsx
 * <AvatarRoot>
 *   <AvatarGraphic>
 *     <svg viewBox="0 0 24 24" fill="currentColor"/>
 *   </AvatarGraphic>
 *   <AvatarLabel>JD</AvatarLabel>
 * </AvatarRoot>
 * ```
 */
const AvatarGraphic = (props) => {
    const { className, ...rest } = props;
    const { onImageLoaded } = useAvatarContext();
    useEffect(() => {
        onImageLoaded();
    }, []);
    return (React.createElement("div", { "data-uds-child": "avatar-graphic", className: tw$2(className, 'children:(w-full aspect-ratio-1/1)'), ...rest }));
};
/**
 * Render a UDS icon inside the avatar. Extends the `Icon` component, and inherits all of its props.
 *
 * @example
 * ```tsx
 * <AvatarRoot>
 *   <AvatarIcon name="user"/>
 *   <AvatarLabel>JD</AvatarLabel>
 * </AvatarRoot>
 * ```
 */
const AvatarIcon = ({ size, ...rest }) => {
    const { onImageLoaded, size: contextSize } = useAvatarContext();
    useEffect(() => {
        onImageLoaded();
    }, []);
    const autoSize = useResponsiveMap(contextSize, {
        sm: 'lg',
        base: '2xl',
        lg: '4xl',
    });
    return (React.createElement(Icon, { name: "filter", size: size ?? autoSize, "data-uds-child": "avatar-icon", ...rest }));
};
/**
 * Render a text label within the avatar. If an icon, image or graphic is present, the label will be hidden, as soon as the asset is loaded.
 *
 * The Label inherits the following props from the Text component: transform, weight, condensed, color
 *
 * @example
 * ```tsx
 * <AvatarRoot>
 *   <AvatarLabel color="info">John Doe</AvatarLabel>
 * </AvatarRoot>
 * ```
 */
const AvatarLabel = (props) => {
    return (React.createElement(Text, { "data-uds-child": "avatar-label", transform: "uppercase", ...props }));
};

const vignetteStyle = (0,style/* style */.oB)({
    base: style/* css */.iv `
    pointer-events: none;
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    mix-blend-mode: multiply;
    background: linear-gradient(
      var(--media-vignette-angle),
      rgba(0, 0, 0, var(--grad-start)) 0%,
      rgba(0, 0, 0, var(--grad-end)) var(--grad-spread)
    );
  `,
    variants: {
        vignette: {
            cover: style/* css */.iv `
        display: block;
        --media-vignette-angle: 0deg;
        --grad-start: 0.3;
        --grad-end: 0.3;
        --grad-spread: 100%;
      `,
            bottom: style/* css */.iv `
        display: block;
        --media-vignette-angle: 0deg;
        --grad-start: 0.45;
        --grad-end: 0;
        --grad-spread: 60%;
      `,
            bottom_left: style/* css */.iv `
        display: block;
        --media-vignette-angle: 45deg;
        --grad-start: 0.45;
        --grad-end: 0;
        --grad-spread: 60%;
      `,
            left: style/* css */.iv `
        display: block;
        --media-vignette-angle: 90deg;
        --grad-start: 0.45;
        --grad-end: 0;
        --grad-spread: 60%;
      `,
            top_left: style/* css */.iv `
        display: block;
        --media-vignette-angle: 135deg;
        --grad-start: 0.45;
        --grad-end: 0;
        --grad-spread: 60%;
      `,
            top: style/* css */.iv `
        display: block;
        --media-vignette-angle: 180deg;
        --grad-start: 0.45;
        --grad-end: 0;
        --grad-spread: 60%;
      `,
            top_right: style/* css */.iv `
        display: block;
        --media-vignette-angle: 225deg;
        --grad-start: 0.45;
        --grad-end: 0;
        --grad-spread: 60%;
      `,
            right: style/* css */.iv `
        display: block;
        --media-vignette-angle: 270deg;
        --grad-start: 0.45;
        --grad-end: 0;
        --grad-spread: 60%;
      `,
            bottom_right: style/* css */.iv `
        display: block;
        --media-vignette-angle: 315deg;
        --grad-start: 0.45;
        --grad-end: 0;
        --grad-spread: 60%;
      `,
            true: style/* css */.iv `
        display: block;
        --media-vignette-angle: 0deg;
        --grad-start: 0.45;
        --grad-end: 0;
        --grad-spread: 60%;
      `,
            false: style/* css */.iv `
        display: none;
        -grad-start: 0;
        --grad-end: 0;
      `,
        },
    },
});
/**
 * A container for image and video content that maintains a fixed aspect ratio. Optionally applies a vignette to improve readability.
 *
 * @example
 * ```jsx
 * <MediaContainer>
 *   <img src="https://cdn.jpg" />
 * </MediaContainer>
 * ```
 */
const MediaContainer = react.forwardRef(function MediaContainer({ ratio = 1, vignette = false, className, children, dataTestId, ...rest }, ref) {
    return (react.createElement(AspectRatio, { ...rest, ref: ref, ratio: ratio, "data-test-id": dataTestId, "data-uds-child": "media-container", className: className },
        react.createElement("div", { className: (0,twind.tw)('absolute inset-0 w-full h-full', style/* css */.iv `
            & img,
            & video {
              object-fit: cover;
              object-position: center;
              position: absolute;
              inset: 0;
              width: 100%;
              height: 100%;
            }
          `, className) },
            children,
            vignette ? (react.createElement("div", { className: (0,twind.tw)(vignetteStyle({
                    vignette,
                })), "data-uds-child": "media-container-vignette" })) : null)));
});

const VideoPlayerBigPlayBtn = ({ disabled, playing, onClick, ...rest }) => {
    const mouseDeltaRef = useRef(0);
    const mouseDeltaTimeoutRef = useRef();
    const buttonRef = useRef(null);
    const fadeOutTimeoutRef = useRef();
    const fadeInThenOut = () => {
        buttonRef.current?.classList.remove('opacity-0');
        clearTimeout(fadeOutTimeoutRef.current);
        fadeOutTimeoutRef.current = setTimeout(fadeout, 2500);
    };
    useEffect(() => {
        clearTimeout(fadeOutTimeoutRef.current);
        if (!playing) {
            fadeOutTimeoutRef.current = setTimeout(fadein, 100);
        }
        else {
            fadeOutTimeoutRef.current = setTimeout(fadeout, 500);
        }
    }, [playing]);
    const fadein = () => {
        buttonRef.current?.classList.remove('opacity-0');
    };
    const fadeout = () => {
        buttonRef.current?.classList.add('opacity-0');
    };
    const handleMouseEnter = () => {
        if (!playing)
            return;
        fadeInThenOut();
    };
    const handleMouseMove = e => {
        if (!playing)
            return;
        clearTimeout(mouseDeltaTimeoutRef.current);
        const { movementX, movementY } = e;
        mouseDeltaRef.current += Math.abs(movementX) + Math.abs(movementY);
        mouseDeltaTimeoutRef.current = setTimeout(() => {
            mouseDeltaRef.current = 0;
        }, 400);
        if (mouseDeltaRef.current > 20) {
            fadeInThenOut();
        }
    };
    const handleMouseLeave = () => {
        if (!playing)
            return;
        clearTimeout(fadeOutTimeoutRef.current);
        fadeout();
    };
    useEffect(() => {
        return () => clearTimeout(fadeOutTimeoutRef.current);
    }, []);
    return (React.createElement("button", { "aria-label": "Play", onClick: onClick, ref: buttonRef, onMouseMove: handleMouseMove, onMouseOver: handleMouseEnter, onMouseOut: handleMouseLeave, onFocus: handleMouseEnter, onBlur: handleMouseLeave, className: tw('opacity-0', 'transition-opacity duration-700 absolute inset-0 flex items-center justify-center z-20', disabled && 'pointer-events-none opacity-0', 'focus:(outline-none) focus-visible:(ring-2)'), ...rest },
        React.createElement("div", { className: tw(playing && 'opacity-0', 'absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 w-1/4 min-w-12 max-w-24') },
            React.createElement(Icon, { name: 'play-filled', aspectRatio: 1, color: "base", invert: true })),
        React.createElement("div", { className: tw(!playing && 'opacity-0', 'absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 w-1/4 min-w-12 max-w-24') },
            React.createElement(Icon, { name: 'pause-filled', aspectRatio: 1, color: "base", invert: true }))));
};

/**
 * Video player with built in accessibility features. When set to `autoplay` the video won't load until the player intersects with the viewport
 *
 * @example
 * ```
 * <Video
 *   autoplay
 *   src="video.mp4"
 *   poster="/poster.png"
 *   aspectRatio={9/16}
 *   controls="none"
 * />
 * ```
 */
const VideoPlayer = (props) => {
    const { src, className, aspectRatio, autoPlay = false, autoPause = true, controls = 'plain', muted = false, loop, poster, lqip, onPlay, onPause, onLoad, onEnded, dataTestId, ...rest } = props;
    const player = useRef(null);
    const [ref, inView] = useIntersectionObserver({ threshold: 0.5 });
    const isTabVisible = useVisibilityChange();
    const isPlayerVisible = inView && isTabVisible;
    const [playing, setPlaying] = useState(false);
    const [source, setSource] = useState();
    const [started, setStarted] = useState(false);
    const [isMuted, setIsMuted] = useState(autoPlay || muted);
    const { devicePreferences } = useUdsContext();
    const prefersReducedData = devicePreferences.prefersReducedData;
    const prefersReducedMotion = devicePreferences.prefersReducedMotion;
    const hasPoster = is.exists(poster);
    const isAutoplayEnabled = autoPlay || (controls === 'none' && !hasPoster);
    const videoWrapClassName = aspectRatio
        ? `aspect-ratio-[${aspectRatio}]`
        : `absolute w-full h-full object-cover`;
    // a video can not autoplay if user prefers reduced data or reduced motion
    const canAutoPlay = isAutoplayEnabled && !prefersReducedData && !prefersReducedMotion;
    // inview autoplay/autopause
    const shouldAutoPlay = isPlayerVisible && canAutoPlay;
    const shouldStopPlaying = !isPlayerVisible && playing && autoPause;
    const [renderBigPlay, setRenderBigPlay] = useState(true);
    const bigPlayMounted = useDelayUnmount(renderBigPlay, 1000);
    const [renderPoster, setRenderPoster] = useState(false);
    const posterMounted = useDelayUnmount(renderPoster, 1000);
    const shouldUnmountBigPlay = controls === 'full'; // || (controls === 'none' && !hasPoster && !canAutoPlay);
    useEffect(() => {
        if (hasPoster && inView && !shouldAutoPlay && !playing) {
            setRenderPoster(true);
        }
    }, [inView, playing, hasPoster, shouldAutoPlay]);
    const hasBigPlayButton = (controls === 'none' && !hasPoster && !canAutoPlay) ||
        (controls === 'full' && !hasPoster) ||
        controls !== 'none';
    const videoUrl = src;
    const load = () => {
        setSource(videoUrl);
        player.current.src = videoUrl;
        player.current.load();
    };
    const play = () => {
        if (!source) {
            load();
        }
        setPlaying(true);
        const promise = player.current.play();
        if (promise) {
            promise.catch(e => console.log(e));
        }
    };
    const pause = () => {
        setPlaying(false);
        player.current.pause();
    };
    const handlePlay = e => {
        if (onPlay)
            onPlay(e);
        setStarted(true);
        setRenderPoster(false);
        if (shouldUnmountBigPlay) {
            setRenderBigPlay(false);
        }
    };
    const handleBigPlayClick = () => {
        playing ? pause() : play();
    };
    useEffect(() => {
        if (shouldStopPlaying) {
            pause();
        }
        else if (shouldAutoPlay) {
            play();
        }
        else if (!hasPoster && isPlayerVisible) {
            load();
        }
    }, [isPlayerVisible, hasPoster, shouldAutoPlay, shouldStopPlaying]);
    return (React.createElement("div", { ...rest, ref: ref, className: tw(className, videoWrapClassName, 'z-0 bg-cover bg-no-repeat bg-center'), style: { backgroundImage: lqip ? `url(${lqip})` : 'none' }, "data-test-id": dataTestId, "data-uds-child": "video-player-wrapper" },
        posterMounted ? (React.createElement("div", null,
            React.createElement("img", { src: poster, "data-uds-child": "video-player-poster", "data-test-id": dataTestId ? `${dataTestId}-poster` : undefined, className: tw('transition-opacity object-cover object-center w-full h-full absolute z-10', started ? 'pointer-events-none opacity-0' : 'opacity-100') }))) : null,
        hasBigPlayButton && bigPlayMounted ? (React.createElement(VideoPlayerBigPlayBtn, { onClick: handleBigPlayClick, playing: playing, disabled: !renderBigPlay, "data-uds-child": "video-player-big-play", "data-test-id": dataTestId ? `${dataTestId}-big-play` : undefined })) : null,
        React.createElement("video", { ref: player, autoPlay: false, controls: controls === 'full', muted: isMuted, loop: loop, playsInline: true, preload: "none", className: tw('w-full h-full object-cover object-center transition-opacity duration-500', source ? 'opacity-100' : 'opacity-0'), onPlay: handlePlay, onPause: onPause, onLoad: onLoad, onEnded: onEnded, "data-uds-child": "video-player-source", "data-test-id": dataTestId ? `${dataTestId}-source` : undefined })));
};

const collabStyle$1 = (0,style/* style */.oB)({
    base: 'flex items-center',
    variants: {
        size: {
            sm: 'text-sm gap-2',
            base: 'text-base gap-3',
            lg: 'text-lg gap-4',
            xl: 'text-xl gap-4',
        },
        invert: {
            true: 'text-white',
            false: 'text-neutral',
        },
    },
});
const imageStyle = (0,style/* style */.oB)({
    variants: {
        size: {
            sm: 'h-6',
            base: 'h-8',
            lg: 'h-10',
            xl: 'h-12',
        },
    },
});
const logoWrapper = (0,style/* style */.oB)({
    base: 'flex after:(w-px)',
    variants: {
        size: {
            sm: 'gap-2 after:(h-6 ml-1)',
            base: 'gap-3 after:(h-8 ml-1)',
            lg: 'gap-4 after:(h-10 ml-1)',
            xl: 'gap-4 after:(h-12 ml-1)',
        },
        showPumaLogo: {
            true: style/* css */.iv `
        &:after {
          content: ' ';
          display: block;
          background-color: currentColor;
        }
      `,
            false: 'hidden',
        },
    },
});
const pumaLogoStyle = (0,style/* style */.oB)({
    variants: {
        size: {
            sm: 'w-6 h-6',
            base: 'w-8 h-8',
            lg: 'w-10 h-10',
            xl: 'w-12 h-12',
        },
    },
});
const Collab = ({ size = 'base', collabLogo, showPumaLogo, dataTestId, children, invert = false, className, }) => {
    return (React.createElement("div", { className: tw$1(className, collabStyle$1({ size, invert })), "data-uds-child": "collab", "data-test-id": dataTestId },
        React.createElement("span", { className: tw$1('font-bold uppercase', collabLogo ? 'sr-only' : ''), "data-test-id": dataTestId && `${dataTestId}-copy` }, children),
        collabLogo ? (React.createElement(React.Fragment, null,
            showPumaLogo ? (React.createElement("div", { className: tw$1('flex', logoWrapper({ showPumaLogo, size })) },
                React.createElement("div", { className: tw$1(pumaLogoStyle({ size })) },
                    React.createElement(Icon, { aspectRatio: 1, name: "puma-logo", "data-test-id": dataTestId && `${dataTestId}-puma-logo` })))) : null,
            React.createElement("img", { src: collabLogo, alt: "", "data-test-id": dataTestId && `${dataTestId}-logo`, className: tw$1(imageStyle({ size })) }))) : null));
};

const HeroContext = (0,react.createContext)(undefined);
const HeroProvider = ({ children, value, }) => React.createElement(HeroContext.Provider, { value: value }, children);
const useHeroContext = () => {
    const context = useContext(HeroContext);
    if (!context) {
        throw new Error('useHeroContext must be used within a HeroProvider');
    }
    return context;
};

/**
 * HEADING SIZE MAPS
 */
const HEADING_SIZE_MAP_OVERLAY_1 = [
    { width: 0, size: 'heading-lg' },
    { width: 640, size: 'heading-xl' },
    { width: 1024, size: 'heading-2xl' },
    { width: 1280, size: 'heading-3xl' },
    { width: 1920, size: 'heading-4xl' },
];
const HEADING_SIZE_MAP_OVERLAY_2 = [
    { width: 0, size: 'heading-lg' },
    { width: 640, size: 'heading-xl' },
    { width: 1024, size: 'heading-2xl' },
    { width: 1280, size: 'heading-3xl' },
    { width: 1920, size: 'heading-3xl' },
];
const HEADING_SIZE_MAP_OVERLAY_3 = [
    { width: 0, size: 'heading-lg' },
    { width: 640, size: 'heading-xl' },
    { width: 1024, size: 'heading-2xl' },
    { width: 1280, size: 'heading-2xl' },
    { width: 1920, size: 'heading-3xl' },
];
const HEADING_SIZE_MAP_SPLIT_1 = [
    { width: 0, size: 'heading-lg' },
    { width: 640, size: 'heading-lg' },
    { width: 1024, size: 'heading-xl' },
    { width: 1280, size: 'heading-2xl' },
    { width: 1600, size: 'heading-3xl' },
    { width: 1920, size: 'heading-4xl' },
];
const HEADING_SIZE_MAP_SPLIT_2 = [
    { width: 0, size: 'heading-base' },
    { width: 640, size: 'heading-base' },
    { width: 1024, size: 'heading-lg' },
    { width: 1280, size: 'heading-xl' },
    { width: 1600, size: 'heading-2xl' },
    { width: 1920, size: 'heading-3xl' },
];
/**
 * DESCRIPTION SIZE MAPS
 */
const DESCRIPTION_SIZE_MAP_OVERLAY_1 = [
    { width: 0, size: 'mt-2 heading-sm' },
    { width: 1024, size: 'mt-3 heading-base' },
    { width: 1920, size: 'mt-4 heading-lg' },
];
const DESCRIPTION_SIZE_MAP_OVERLAY_2 = [
    { width: 0, size: 'mt-2 heading-sm' },
    { width: 1024, size: 'mt-3 heading-base' },
    { width: 1920, size: 'mt-4 heading-lg' },
];
const DESCRIPTION_SIZE_MAP_OVERLAY_3 = [
    { width: 0, size: 'mt-2 heading-sm' },
    { width: 1024, size: 'mt-3 heading-base' },
    { width: 1920, size: 'mt-4 heading-lg' },
];
const DESCRIPTION_SIZE_MAP_SPLIT_1 = [
    { width: 0, size: 'mt-2 heading-sm' },
    { width: 768, size: 'mt-3 heading-sm' },
    { width: 1280, size: 'mt-4 heading-base' },
    { width: 1920, size: 'mt-4 heading-lg' },
];
const DESCRIPTION_SIZE_MAP_SPLIT_2 = [
    { width: 0, size: 'mt-2 heading-sm' },
    { width: 1024, size: 'mt-3 heading-base' },
    { width: 1920, size: 'mt-4 heading-lg' },
];
/** Utility function */
const findSize = (data, width) => {
    let result;
    data.every(item => {
        if (item.width > width) {
            return false;
        }
        result = item.size;
        return true;
    });
    return result;
};
/**
 * Content Padding
 */
const SPLIT_CONTENT_PADDING_MAP = {
    '1920': {
        start: 'py-12 px-10',
        end: 'py-12 pl-12 pr-10',
    },
    '1440': {
        start: 'py-12 px-10',
        end: 'py-12 px-10',
    },
    '1280': {
        start: 'py-10 px-8',
        end: 'py-10 px-8',
    },
    '1024': {
        start: 'py-10 px-8',
        end: 'py-10 px-8',
    },
    '768': {
        start: 'py-8 px-6',
        end: 'py-8 px-6',
    },
    '640': {
        start: 'py-6 px-6',
        end: 'py-6 px-6',
    },
    '540': {
        start: 'py-6 px-6',
        end: 'py-6 px-6',
    },
    _: {
        start: 'py-4 px-4',
        end: 'py-4 px-4',
    },
};
const OVERLAY_CONTENT_PADDING_MAP = {
    '1920': 'py-12 px-10',
    '1440': 'py-12 px-10',
    '1280': 'py-10 px-10',
    '1024': 'py-10 px-10',
    '768': 'py-8 px-8',
    '640': 'py-8 px-4',
    '540': 'py-6 px-4',
    _: 'py-4 px-4',
};
/**
 * Layout
 */
const LAYOUT_MAP_OVERLAY = {
    '1280': {
        media: ['1 / span 12', 1],
        content_start: ['2 / span 5', 1],
        content_center: ['4 / span 6', 1],
        content_end: ['8 / span 5', 1],
    },
    '768': {
        media: ['1 / span 12', 1],
        content_start: ['2 / span 6', 1],
        content_center: ['4 / span 6', 1],
        content_end: ['6 / span 6', 1],
    },
    '640': {
        media: ['1 / span 12', 1],
        content_start: ['2 / span 6', 1],
        content_center: ['4 / span 6', 1],
        content_end: ['6 / span 6', 1],
    },
    _: {
        media: ['1 / span 12', 1],
        content_start: ['2 / span 10', 1],
        content_center: ['2 / span 10', 1],
        content_end: ['2 / span 10', 1],
    },
};
const LAYOUT_MAP_SPLIT = {
    '1280': {
        media_start: ['span 7', 1],
        media_end: ['6 / span 7', 1],
        content_start: ['2 / span 4', 1],
        content_end: ['8 / span 4', 1],
    },
    '768': {
        media_start: ['span 7', 1],
        media_end: ['6 / span 7', 1],
        content_start: ['2 / span 4', 1],
        content_end: ['8 / span 4', 1],
    },
    '640': {
        media_start: ['span 6', 1],
        media_end: ['7 / span 6', 1],
        content_start: ['span 6', 1],
        content_end: ['7 / span 6', 1],
    },
    _: {
        media_start: ['1 / span 12', 1],
        media_end: ['1 / span 12', 1],
        content_start: ['1 / span 12', 2],
        content_end: ['1 / span 12', 2],
    },
};

const useLayoutStyles = ({ layout, width, }) => {
    const getGridStyles = () => {
        const mapKey = width >= 1280
            ? '1280'
            : width >= 768
                ? '768'
                : width >= 640
                    ? '640'
                    : '_';
        if (layout === 'split') {
            const config = LAYOUT_MAP_SPLIT[mapKey];
            return css `
        &
          > [data-uds-child='hero-content']
          + [data-uds-child='hero-media-container'] {
          grid-column: ${config.media_end[0]};
          grid-row: ${config.media_end[1]};
        }
        & > [data-uds-child='hero-media-container'] {
          grid-column: ${config.media_start[0]};
          grid-row: ${config.media_start[1]};
        }

        &
          > [data-uds-child='hero-media-container']
          + [data-uds-child='hero-content'] {
          grid-column: ${config.content_end[0]};
          grid-row: ${config.content_end[1]};
        }
        & > [data-uds-child='hero-content'] {
          grid-column: ${config.content_start[0]};
          grid-row: ${config.content_start[1]};
        }
      `;
        }
        if (layout === 'overlay') {
            const config = LAYOUT_MAP_OVERLAY[mapKey];
            return css `
        & > [data-uds-child='hero-media-container'] {
          grid-column: ${config.media[0]};
          grid-row: ${config.media[1]};
        }
        & > [data-uds-child='hero-content'][data-uds-justify='start'] {
          grid-column: ${config.content_start[0]};
          grid-row: ${config.content_start[1]};
        }
        & > [data-uds-child='hero-content'][data-uds-justify='center'] {
          grid-column: ${config.content_center[0]};
          grid-row: ${config.content_center[1]};
        }
        & > [data-uds-child='hero-content'][data-uds-justify='end'] {
          grid-column: ${config.content_end[0]};
          grid-row: ${config.content_end[1]};
        }
      `;
        }
    };
    const getPaddingStyles = () => {
        const mapKey = width >= 1920
            ? '1920'
            : width >= 1440
                ? '1440'
                : width >= 1280
                    ? '1280'
                    : width >= 1024
                        ? '1024'
                        : width >= 768
                            ? '768'
                            : width >= 640
                                ? '640'
                                : width >= 540
                                    ? '540'
                                    : '_';
        if (layout === 'split') {
            const config = SPLIT_CONTENT_PADDING_MAP[mapKey];
            return css `
        & > [data-uds-child='hero-content'] {
          @apply ${config.start};
        }
        &
          > [data-uds-child='hero-media-container']
          + [data-uds-child='hero-content'] {
          @apply ${config.end};
        }
      `;
        }
        if (layout === 'overlay') {
            const config = OVERLAY_CONTENT_PADDING_MAP[mapKey];
            return css `
        & > [data-uds-child='hero-content'] {
          @apply ${config};
        }
      `;
        }
    };
    return [getGridStyles(), getPaddingStyles()];
};

const MAX_CONTENT_WIDTH = 'screens.3xl';
const heroStyles = (0,style/* style */.oB)({
    variants: {
        invert: {
            true: 'bg-neutral-100',
            false: 'bg-neutral-0',
        },
    },
});
/**
 * The HeroRoot component is the base component used to render a hero section.
 *
 * @example
 * ```
 * <HeroRoot
 *   layout="split"
 *   level={1}
 * >
 *   <HeroMediaContainer>
 *     <HeroMedia>
 *       <img src="image.jpg" />
 *     </HeroMedia>
 *   </HeroMediaContainer>
 *   <HeroContent>
 *     <HeroHeading>Hero Title</HeroHeading>
 *     <HeroDescription>Hero Description</HeroDescription>
 *   </HeroContent>
 * </HeroRoot>
 * ```
 *
 */
const HeroRoot = ({ layout = 'overlay', level: levelProp = 1, className, dataTestId, children, asChild, invert, ...rest }) => {
    const Comp = asChild ? Slot : 'article';
    const { ref, width } = useResizeObserver();
    const level = layout === 'split' && levelProp === 3 ? 2 : levelProp;
    const contextValue = { layout, level, width, invert, dataTestId };
    const layoutStyles = useLayoutStyles({ layout, width });
    return (React.createElement(HeroProvider, { value: contextValue },
        React.createElement(Comp, { className: tw('relative grid w-full', css `
            grid-template-columns:
              1fr
              repeat(10, min(10%, calc(${theme(MAX_CONTENT_WIDTH)} * 0.1)))
              1fr;
          `, heroStyles({ invert }), ...layoutStyles, className), "data-uds-child": "hero", "data-test-id": dataTestId, ref: ref, ...rest }, children)));
};

/**
 * The HeroMediaContainer component is used to wrap the HeroMedia component.
 * - It should be rendered directly inside the HeroRoot component, alongside the HeroContent component.
 *
 * @example
 * ```
 * <HeroMediaContainer>
 *   <HeroMedia>
 *     <img src="image.jpg" />
 *   </HeroMedia>
 * </HeroMediaContainer>
 * ```
 */
const HeroMediaContainer = ({ className, children, ...rest }) => {
    const { dataTestId } = useHeroContext();
    return (React.createElement("div", { className: tw$2('relative h-full', className), "data-test-id": dataTestId && `${dataTestId}-media-container`, "data-uds-child": "hero-media-container", ...rest }, children));
};

const useHeroRatio = () => {
    const { layout, level, width } = useHeroContext();
    if (layout === 'split') {
        if (width > 768) {
            return level === 1 ? 0.75 : 0.562;
        }
        else if (width > 640) {
            return 1;
        }
        else {
            return level === 1 ? 1 : 0.75;
        }
    }
    if (layout === 'overlay') {
        if (width > 1024) {
            return level === 1 ? 0.5 : level === 2 ? 0.428 : 0.25;
        }
        else if (width > 640) {
            return level === 1 ? 1 : level === 2 ? 0.75 : 0.333;
        }
        else {
            return level === 1 ? 1.5 : level === 2 ? 1.25 : 0.5;
        }
    }
};
/**
 * The HeroMedia component is used to render the media of a hero section.
 * - It should be rendered directly inside the HeroMediaContainer component.
 * - Insert an image or video element as a child.
 * - Overlay layouts includes a vignette effect to improve readability
 *   - Can be disabled by setting `vignette` to `false`.
 * - Internally uses the AspectRatio component.
 *
 * @example
 * ```
 * <HeroMedia vignette>
 *   <img src="image.jpg" />
 * </HeroMedia>
 * ```
 */
const HeroMedia = ({ vignette = true, className, ...rest }) => {
    const { layout, width, dataTestId } = useHeroContext();
    const ratio = useHeroRatio();
    const overlayVignette = width > 1024 ? 'left' : width > 640 ? 'bottom_left' : 'bottom';
    return (React.createElement(MediaContainer, { ...rest, dataTestId: dataTestId && `${dataTestId}-media`, ratio: ratio, vignette: layout === 'overlay' && vignette ? overlayVignette : false, className: tw$2('h-full', className), overflow: true }));
};

const outerStyles = (0,style/* style */.oB)({
    variants: {
        justify: {
            start: 'text-left rtl:text-right',
            center: 'text-center',
            end: 'text-right rtl:text-left',
        },
    },
});
const contentStyles = (0,style/* style */.oB)({
    variants: {
        justify: {
            start: 'items-start text-left rtl:text-right',
            center: 'items-center text-center',
            end: 'items-end text-right rtl:text-left',
        },
    },
});
/**
 * The HeroContent component is used to render the content of a hero section.
 *
 * - It should be rendered directly inside the HeroRoot component.
 * - For split layouts, it will be positioned on the opposite side of the HeroMediaContainer.
 *   - Place before or after the HeroMediaContainer component, depending on the desired layout.
 * - For overlay layouts, it will be positioned on top of the hero media.
 *
 * @example
 * ```
 * <HeroContent>
 *   <HeroHeading>Hero Title</HeroHeading>
 *   <HeroDescription>Hero Description</HeroDescription>
 * </HeroContent>
 * ```
 */
const HeroContent = ({ children, justify = 'start', className, ...rest }) => {
    const { layout, width, dataTestId } = useHeroContext();
    return (React.createElement("div", { "data-test-id": dataTestId && `${dataTestId}-content`, "data-uds-child": "hero-content", "data-uds-justify": justify, className: tw$1('relative max-w-screen-3xl', 'w-full flex', width < 1024 && layout === 'overlay' ? 'items-end' : 'items-center', outerStyles({ justify }), className), ...rest },
        React.createElement("div", { className: tw$1('flex flex-1 flex-col', contentStyles({ justify })) }, children)));
};

/**
 * HeroHeading is used to render a heading for the hero.
 * - It should be rendered directly inside the HeroContent component.
 *
 * @example
 * ```
 * <HeroHeading>Hero Heading</HeroHeading>
 * ```
 */
const HeroHeading = ({ className, children, color = 'base', transform = 'uppercase', ...rest }) => {
    const { dataTestId, width, layout, level, invert } = useHeroContext();
    const sizeClassName = useMemo(() => {
        switch (true) {
            case layout === 'overlay' && level === 1:
                return findSize(HEADING_SIZE_MAP_OVERLAY_1, width);
            case layout === 'overlay' && level === 2:
                return findSize(HEADING_SIZE_MAP_OVERLAY_2, width);
            case layout === 'overlay' && level === 3:
                return findSize(HEADING_SIZE_MAP_OVERLAY_3, width);
            case layout === 'split' && level === 1:
                return findSize(HEADING_SIZE_MAP_SPLIT_1, width);
            case layout === 'split' && level === 2:
                return findSize(HEADING_SIZE_MAP_SPLIT_2, width);
        }
    }, [width, layout, level]);
    return (React.createElement(Heading, { "data-test-id": dataTestId && `${dataTestId}-heading`, "data-uds-child": "hero-heading", transform: transform, className: tw$2(sizeClassName, className), invert: invert, color: color, ...rest }, children));
};

/**
 * HeroDescription is used to render a description for the hero.
 * - It should be rendered directly inside the HeroContent component.
 * - It should follow a HeroHeading component.
 *
 * @example
 * ```
 * <HeroDescription>Hero Description</HeroDescription>
 * ```
 */
const HeroDescription = ({ transform = 'uppercase', color = 'base', weight = '400', className, children, ...rest }) => {
    const { dataTestId, width, layout, level, invert } = useHeroContext();
    const sizeClassName = useMemo(() => {
        switch (true) {
            case layout === 'overlay' && level === 1:
                return findSize(DESCRIPTION_SIZE_MAP_OVERLAY_1, width);
            case layout === 'overlay' && level === 2:
                return findSize(DESCRIPTION_SIZE_MAP_OVERLAY_2, width);
            case layout === 'overlay' && level === 3:
                return findSize(DESCRIPTION_SIZE_MAP_OVERLAY_3, width);
            case layout === 'split' && level === 1:
                return findSize(DESCRIPTION_SIZE_MAP_SPLIT_1, width);
            case layout === 'split' && level === 2:
                return findSize(DESCRIPTION_SIZE_MAP_SPLIT_2, width);
        }
    }, [width, layout, level]);
    return (React.createElement(Heading, { "data-test-id": dataTestId && `${dataTestId}-description`, "data-uds-child": "hero-description", transform: transform, className: tw$2(sizeClassName, className), color: color, weight: weight, invert: invert, ...rest }, children));
};

/**
 * Use the HeroActionList component to display a list of actions in a Hero.
 * - The container, will apply the correct spacing and alignment based on the configuration of the parent HeroRoot.
 *
 * @example
 * ```
 * <HeroActionList>
 *   <LinkCta label="Shop Sports" href="/sports" />
 *   <LinkCta label="Shop Mens Shoes" href="/mens-shoes" />
 * </HeroActionList>
 * ```
 */
const HeroActionList = ({ className, children, ...rest }) => {
    const { dataTestId, invert } = useHeroContext();
    return (React.createElement("div", { ...rest, className: tw$2('flex flex-wrap max-w-max items-baseline gap-x-4 gap-y-2 mt-6 children:flex-1', className), "data-uds-child": "hero-actions", "data-test-id": dataTestId && `${dataTestId}-actions` }, React.Children.map(children, child => {
        return React.cloneElement(child, {
            invert: child.props?.invert ?? invert,
        });
    })));
};

/**
 * HeroFootnote is used to render a footnote for the hero.
 * - It should be rendered directly inside the HeroContent component.
 *
 * @example
 * ```
 * <HeroFootnote>Hero Footnote</HeroFootnote>
 * ```
 */
const HeroFootnote = ({ className, children, size = 'sm', color = 'base', ...rest }) => {
    const { dataTestId, invert } = useHeroContext();
    return (React.createElement(Text, { "data-test-id": dataTestId && `${dataTestId}-footnote`, "data-uds-child": "hero-footnote", className: tw$2('mt-4', className), size: size, color: color, invert: invert, asChild: true, ...rest }, children));
};

/**
 * HeroCollab is a component that is used to display a collaboration between PUMA and another brand.
 *
 * Uses the Float internally, and can be used directly as a child of the HeroMediaContainer or the HeroContent.
 *
 * It is positioned absolutely by default, but can be positioned relatively by setting the `inline` prop to `true`.
 *
 * @example
 * ```jsx
 * <HeroRoot>
 *   <HeroMediaContainer>
 *     <HeroCollab showPumaLogo>Brand</HeroCollab>
 *     <HeroMedia>
 *       ...
 *     </HeroMedia>
 *   </HeroMediaContainer>
 *   <HeroContent>
 *     ...
 *   </HeroContent>
 * </HeroRoot>
 * ```
 *
 * @example
 * ```
 * <HeroRoot>
 *   <HeroMediaContainer>
 *     ...
 *   </HeroMediaContainer>
 *   <HeroContent>
 *     <HeroCollab showPumaLogo inline>Brand</HeroCollab>
 *     <HeroHeading>Heading</HeroHeading>
 *     <HeroDescription>Description</HeroDescription>
 *   </HeroContent>
 * </HeroRoot>
 * ```
 */
const HeroCollab = ({ inline = false, align = 'top', justify = 'end', inset, insetX, insetY, showPumaLogo = true, size, invert, collabLogo, className, children, }) => {
    const { dataTestId, invert: contextInvert, width } = useHeroContext();
    return (React.createElement(Float, { align: align, justify: justify, invert: invert ?? contextInvert, inset: inset, insetY: insetY ?? inline
            ? 'none'
            : width > 1024
                ? 'base'
                : width > 640
                    ? 'sm'
                    : 'xs', insetX: insetX ?? inline
            ? 'none'
            : width > 1024
                ? 'md'
                : width > 640
                    ? 'base'
                    : 'sm', asChild: true },
        React.createElement(Collab, { showPumaLogo: showPumaLogo, collabLogo: collabLogo, dataTestId: dataTestId && `${dataTestId}-collab`, invert: invert ?? contextInvert, size: size || (width > 1280 ? 'xl' : 'base'), className: tw$1(inline &&
                'relative! top-auto bottom-auto left-auto right-auto transform-none text-left rtl:text-right', className) }, children)));
};

/**
 * QuiltRootContext is used to pass configuration to all Quilt components. It's mounted internally by the QuiltRoot, and will not be used directly by consumers.
 */
const QuiltRootContext = react.createContext(null);
const useQuiltContext = () => {
    const context = (0,react.useContext)(QuiltRootContext);
    if (!context) {
        throw new Error('useQuiltContext must be used within a QuiltRootContext');
    }
    return context;
};

/**
 * QuiltRoot is the root component for the Quilt layout system. It provides a responsive grid system for laying out content, and can be used to create a variety of layouts. It is designed to easily configure a layout that can switch betweeen a stack, row, mesh, scroll, or masonry layout, at different breakpoints.
 *
 * @example
 *
 * ```jsx
 * <QuiltRoot
 *   config={{
 *      _: { layout: "stack", gap: "xs" },
 *     md: { layout: "row", gap: "sm" },
 *     lg: { layout: "masonry", gap: "base" }
 *   }}
 * >
 *   <QuiltViewport>
 *     <Tile />
 *     <Tile />
 *     <Tile />
 *   </QuiltViewport>
 *   <QuiltScrollPrev>
 *     <button>Prev</button>
 *   </QuiltScrollPrev>
 *   <QuiltScrollNext>
 *     <button>Next</button>
 *   </QuiltScrollNext>
 * </QuiltRoot>
 * ```
 */
const QuiltRoot = (props) => {
    const { config = {}, className, dataTestId, children, asChild, ref: forwardRef, ...rest } = props;
    const Comp = asChild ? $5e63c961fc1ce211$export$8c6ed5c666ac1360 : 'section';
    const { ref, isOverflowing, hasPrev, hasNext, scrollToNext, scrollToPrev } = (0,esm/* useHorizontalScroll */.mZ)({
        infinite: false,
        items: react.Children.count(children),
    });
    const layoutConfig = 'layout' in config ? { _: config } : config;
    return (react.createElement(QuiltRootContext.Provider, { value: {
            dataTestId,
            config: layoutConfig,
            viewportRef: ref,
            isOverflowing,
            hasPrev,
            hasNext,
            scrollToNext,
            scrollToPrev,
        } },
        react.createElement(Comp, { ...rest, ref: forwardRef, "data-test-id": dataTestId, className: (0,twind.tw)('w-full relative', className) }, children)));
};

/**
 * A clone of the GridCell component for backwards compatibility. This component will be removed in a future release.
 */
const QuiltCell = GridCell;

const getMeshStyles = (props) => {
    const { columns, limit, gapX, gapY, mql } = props;
    return css_css/* css */.iv `
    @media ${mql} {
      display: grid;
      grid-template-columns: repeat(${columns}, minmax(0px, 1fr));
      column-gap: ${UDS_GAP_VALUES[gapX]};
      padding-bottom: 0;
      row-gap: ${UDS_GAP_VALUES[gapY]};
      & > :nth-child(n) {
        display: grid;
      }
      & > :nth-child(n + ${limit + 1}) {
        display: none;
      }
    }
  `;
};
const getScrollStyles = (props) => {
    const { length, columns, limit, mql, gapX, gapY } = props;
    const layoutColumns = length < limit ? length : limit;
    const visibleColumns = length < columns ? length : columns;
    const columnSize = visibleColumns === 1
        ? '100%'
        : `calc(
    ${100 / visibleColumns}% - ${(visibleColumns - 1) / visibleColumns} *
      ${UDS_GAP_VALUES[gapX]}
  )`;
    return css_css/* css */.iv `
    @media ${mql} {
      display: grid;
      column-gap: ${UDS_GAP_VALUES[gapX]};
      row-gap: ${UDS_GAP_VALUES[gapY]};
      padding-bottom: 0.625rem;
      overflow-x: auto;
      scroll-snap-type: x mandatory;
      grid-template-columns: repeat(${layoutColumns}, ${columnSize});

      & > :nth-child(n) {
        display: grid;
        scroll-snap-align: start;
      }
      & > :nth-child(n + ${limit + 1}) {
        display: none;
      }
    }
  `;
};
const cellDefaultProps = {
    colSpan: 1,
    rowSpan: 1,
    colStart: 'auto',
    rowStart: 'auto',
};
const tall = { colSpan: 1, rowSpan: 2, colStart: 'auto', rowStart: 'auto' };
const wide = { colSpan: 2, rowSpan: 1, colStart: 'auto', rowStart: 'auto' };
const masonryCellProps = {
    start: [
        tall,
        null,
        null,
        null,
        tall,
        null,
        tall,
        null,
        null,
        null,
        tall,
        null,
    ],
    end: [null, tall, null, tall, null, null, null, tall, null, tall, null, tall],
    top: [wide, null, null, wide, null, null, wide, null, null, wide, null, null],
    bottom: [
        null,
        null,
        wide,
        null,
        null,
        wide,
        null,
        null,
        wide,
        null,
        null,
        wide,
    ],
};
const getMasonryStyles = (props) => {
    const { gapX, gapY, limit, mql } = props;
    return css_css/* css */.iv `
    @media ${mql} {
      display: grid;
      grid-template-columns: repeat(2, minmax(0px, 1fr));
      column-gap: ${UDS_GAP_VALUES[gapX]};
      row-gap: ${UDS_GAP_VALUES[gapY]};
      padding-bottom: 0;
      & > :nth-child(n) {
        display: grid;
      }

      & > :nth-child(n + ${limit + 1}) {
        display: none;
      }
    }
  `;
};
const useQuiltStyles = (props) => {
    const childrenLength = react.Children.count(props.children);
    const quilt = (0,react.useMemo)(() => {
        const className = Object.keys(props.config).map((breakpoint) => {
            const breakPointConfig = props.config[breakpoint];
            const twScreen = css_css.tw.theme(`screens`)[breakpoint];
            const mql = typeof twScreen === 'string'
                ? `screen and (min-width: ${twScreen})`
                : twScreen.raw;
            const gapX = breakPointConfig.gapX ?? breakPointConfig.gap ?? 'auto';
            const gapY = breakPointConfig.gapY ?? breakPointConfig.gap ?? 'auto';
            if (breakPointConfig.layout === 'masonry') {
                return getMasonryStyles({
                    align: breakPointConfig.align || 'start',
                    limit: breakPointConfig.limit || childrenLength,
                    gapX: gapX,
                    gapY: gapY,
                    length: childrenLength,
                    breakpoint: breakpoint,
                    mql,
                });
            }
            if (breakPointConfig.layout === 'mesh') {
                return getMeshStyles({
                    columns: breakPointConfig.columns || 3,
                    limit: breakPointConfig.limit || 999,
                    gapX: gapX,
                    gapY: gapY,
                    length: childrenLength,
                    breakpoint,
                    mql,
                });
            }
            if (breakPointConfig.layout === 'row') {
                return getMeshStyles({
                    columns: breakPointConfig.columns || childrenLength,
                    limit: breakPointConfig.columns,
                    gapX: gapX,
                    gapY: gapY,
                    length: childrenLength,
                    breakpoint,
                    mql,
                });
            }
            if (breakPointConfig.layout === 'stack') {
                return getMeshStyles({
                    columns: 1,
                    limit: breakPointConfig.limit,
                    gapX: gapX,
                    gapY: gapY,
                    length: childrenLength,
                    breakpoint,
                    mql,
                });
            }
            if (breakPointConfig.layout === 'scroll') {
                return getScrollStyles({
                    columns: breakPointConfig.columns || 3,
                    limit: breakPointConfig.limit || childrenLength,
                    gapX: gapX,
                    gapY: gapY,
                    length: childrenLength,
                    breakpoint,
                    mql,
                });
            }
        });
        const cellProps = Array.from(new Array(childrenLength)).map((_, i) => {
            const el = {
                colSpan: {},
                rowSpan: {},
                colStart: {},
                rowStart: {},
            };
            Object.keys(props.config).forEach((breakpoint) => {
                const breakPointConfig = props.config[breakpoint];
                if (breakPointConfig.layout === 'masonry') {
                    const masonryLayout = masonryCellProps[breakPointConfig.align || 'start'];
                    el.colSpan[breakpoint] = (masonryLayout[i] || cellDefaultProps)['colSpan'];
                    el.rowSpan[breakpoint] = (masonryLayout[i] || cellDefaultProps)['rowSpan'];
                    el.colStart[breakpoint] = (masonryLayout[i] || cellDefaultProps)['colStart'];
                    el.rowStart[breakpoint] = (masonryLayout[i] || cellDefaultProps)['rowStart'];
                }
                else {
                    el.colSpan[breakpoint] = 1;
                    el.rowSpan[breakpoint] = 1;
                    el.colStart[breakpoint] = 'auto';
                    el.rowStart[breakpoint] = 'auto';
                }
            });
            return el;
        });
        return { className, cellProps };
    }, [JSON.stringify(props.config), childrenLength]);
    return quilt;
};
const ViewportInner = react.forwardRef(({ nodes, asChild, ...rest }, ref) => {
    return asChild ? (react.createElement(react.Fragment, null, (0,react.cloneElement)(nodes, { ...rest, ref }))) : (react.createElement(react.Fragment, { ...rest }));
});
ViewportInner.displayName = 'ViewportInner';
/**
 * QuiltViewport is the content container for all Quilt components
 *
 * It is responsible for setting up the grid layout and applying the correct styles to its children. Its configuration is inherited from the QuiltRoot component.
 *
 * @example
 *```jsx
 * <QuiltRoot>
 *   <QuiltViewport>
 *     <Tile />
 *     <Tile />
 *     <Tile />
 *   </QuiltViewport>
 * </QuiltRoot>
 * ```
 */
const QuiltViewport = (props) => {
    const { dataTestId, config, viewportRef } = useQuiltContext();
    const { asChild, children, className, ...rest } = props;
    const Comp = asChild ? $5e63c961fc1ce211$export$8c6ed5c666ac1360 : 'div';
    const quiltChildren = asChild
        ? children.props.children
        : children;
    const { className: containerClassName, cellProps } = useQuiltStyles({
        config: config,
        children: quiltChildren,
    });
    return (react.createElement(Comp, { ...rest, ref: viewportRef, className: (0,css_css.tw)(containerClassName, props.className), tabIndex: 0, "data-test-id": dataTestId ? `${dataTestId}-viewport` : null, "data-uds-child": "quilt-viewport" },
        react.createElement(ViewportInner, { asChild: asChild, nodes: props.children }, react.Children.map(quiltChildren, (child, index) => {
            const isQuiltCell = child.type.displayName === 'QuiltCell' ||
                child.type.displayName === 'GridCell';
            return isQuiltCell ? ((0,react.cloneElement)(child, {
                ...cellProps[index],
                ...child.props,
            })) : (react.createElement(QuiltCell, { ...cellProps[index] }, child));
        }))));
};

const getResponsiveStyle = (config) => {
    return Object.keys(config).reduce((res, breakpoint) => {
        const breakPointConfig = config[breakpoint];
        const breakpointLayout = breakPointConfig.layout;
        const [layoutType] = breakpointLayout.split('-');
        if (layoutType !== 'scroll') {
            res.push(`${breakpoint}:hidden`);
        }
        else {
            res.push(`${breakpoint}:block`);
        }
        return res;
    }, []);
};
/**
 * QuiltScrollPrev is a navigation higher-order-component that applies functionality to a child button, allowing it to scroll the viewport to the previous page of tiles.
 */
const QuiltScrollPrev = ({ className, children }) => {
    const { dataTestId, config, hasPrev, scrollToPrev } = useQuiltContext();
    return (React.createElement("div", { "data-test-id": dataTestId ? `${dataTestId}-prev-scroll-nav` : null, "data-uds-child": "quilt-scroll-prev", className: tw(getResponsiveStyle(config), hasPrev ? 'pointer-events-all' : 'pointer-events-none', className) }, Children.map(children, child => cloneElement(child, {
        onClick: scrollToPrev,
        'data-uds-enabled': hasPrev,
    }))));
};
/**
 * QuiltScrollNext is a navigation higher-order-component that applies functionality to a child button, allowing it to scroll the viewport to the next page of tiles.
 */
const QuiltScrollNext = ({ className, children }) => {
    const { dataTestId, config, hasNext, scrollToNext } = useQuiltContext();
    return (React.createElement("div", { "data-test-id": dataTestId ? `${dataTestId}-next-scroll-nav` : null, "data-uds-child": "quilt-scroll-next", className: tw(getResponsiveStyle(config), hasNext ? 'pointer-events-all' : 'pointer-events-none', className) }, Children.map(children, child => cloneElement(child, {
        onClick: scrollToNext,
        'data-uds-enabled': hasNext,
    }))));
};

/**
 * Share context between TileRoot and child elements
 *
 * @internal
 */
const TileRootContext = react.createContext(null);
const useTileContext = () => {
    const context = (0,react.useContext)(TileRootContext);
    if (!context) {
        throw new Error('useTileContext must be used within a TileRootContext');
    }
    return context;
};
/**
 * Share context between TileRoot and child elements
 *
 * @internal
 */
const TileContentContext = react.createContext(null);
const useContentContext = () => {
    const context = (0,react.useContext)(TileContentContext);
    return context || {};
};

const tileStyle = (0,style/* style */.oB)({
    variants: {
        layout: {
            overlay: css_css/* css */.iv `
        & [data-uds-child='tile-content'] {
          @apply row-start-1;
        }
      `,
            stack: css_css/* css */.iv `
        & [data-uds-child='tile-content'] {
          @apply row-start-2;
        }
      `,
        },
        fill: {
            content: css_css/* css */.iv `
        grid-template-rows: min-content auto;
      `,
            media: css_css/* css */.iv `
        grid-template-rows: auto min-content;
      `,
        },
        invert: {
            true: 'text-white',
            false: 'text-neutral',
        },
        size: {
            xxs: '',
            xs: '',
            sm: '',
            base: '',
            md: '',
            lg: '',
            xl: '',
            '2xl': '',
        },
    },
    matches: [
        {
            layout: 'overlay',
            fill: 'content',
            use: css_css/* css */.iv `
        grid-template-rows: auto min-content;
      `,
        },
    ],
});
/**
 * Tile Compound pattern. A Tile is a container that holds content related to a single subject. It can be used to display a product, a category post, a marketing campaign, or any other subject.
 *
 * @example
 * ```jsx
 * <TileRoot>
 *  <TileMedia />
 *  <TileContent />
 *    <TileBody>
 *      <TileHeading/>
 *      <TileDescription/>
 *    </TileBody>
 *    <TileFooter>
 *      <TileActionList>
 *        <Link label="Shop Running"/>
 *      </TileActionList>
 *    </TileFooter>
 *   <TileContent>
 * </TileRoot>
 * ```
 */
const TileRoot = ({ className, dataTestId, children, asChild, invert = false, fill = 'media', layout = 'overlay', size = 'auto', ref: forwardRef, ...rest }) => {
    const Comp = asChild ? $5e63c961fc1ce211$export$8c6ed5c666ac1360 : 'article';
    const { ref, width } = (0,esm/* useResizeObserver */.yU)();
    const sharedRef = (0,esm/* useSharedRef */.lD)(forwardRef, ref);
    const appliedSize = (size === 'auto'
        ? width > 768
            ? '2xl'
            : width > 599
                ? 'xl'
                : width > 504
                    ? 'lg'
                    : width > 390
                        ? 'md'
                        : width > 319
                            ? 'base'
                            : width > 255
                                ? 'sm'
                                : width > 199
                                    ? 'xs'
                                    : 'xxs'
        : size);
    return (react.createElement(TileRootContext.Provider, { value: { invert, width, layout, size: appliedSize, dataTestId } },
        react.createElement(Comp, { ...rest, ref: sharedRef, "data-test-id": dataTestId, className: (0,twind.tw)(className, tileStyle({ fill, layout, invert }), 'grid relative w-full', css_css/* css */.iv `
            & [data-uds-child='media-container'] {
              grid-row: 1;
              grid-column: 1;
            }

            & [data-uds-child='tile-content'] {
              grid-column: 1;
            }

            & [data-uds-child='link-inv-block'] {
              @apply z-[1];
            }

            & [data-uds-child='tile-footer'] {
              @apply z-[2];
            }

            & [data-uds-child='tile-actions'] {
              @apply z-[2];
            }
          `) }, children)));
};

/**
 * TileMedia is used to display an image or video in a tile, but also to determine the aspect ratio and overall shape of a Tile.
 *
 * Internally uses the AspectRatio and includes a vignette effect to improve readability.
 *
 * @example
 * ```jsx
 * <TileRoot>
 *  <TileMedia>
 *    <img src="https://cdn.jpg" />
 *  </TileMedia>
 *  <TileContent />
 *</TileRoot>
 * ```
 */
const TileMedia = react.forwardRef(function TileMedia(props, ref) {
    const { dataTestId } = useTileContext();
    return (react.createElement(MediaContainer, { dataTestId: dataTestId && `${dataTestId}-media`, ...props, ref: ref }));
});

const contentStyle = (0,style/* style */.oB)({
    variants: {
        position: {
            overlay: style/* css */.iv `
        grid-row-start: 1 !important;
      `,
            stack: style/* css */.iv `
        grid-row-start: 2 !important;
      `,
        },
        insetX: {
            true: '',
            false: '',
        },
        insetBottom: {
            true: '',
            false: '',
        },
        size: {
            xxs: 'px-2 pt-2',
            xs: 'px-4 pt-4',
            sm: 'px-4 pt-4',
            base: 'px-4 pt-4',
            md: 'px-4 pt-4',
            lg: 'px-6 pt-5',
            xl: 'px-6 pt-5',
            '2xl': 'px-8 pt-7',
        },
        invert: {
            true: 'text-white',
            false: 'text-neutral',
        },
    },
    matches: [
        {
            position: 'stack',
            insetBottom: undefined,
            use: 'pb-0',
        },
        {
            position: 'stack',
            insetX: undefined,
            use: 'px-0',
        },
        {
            size: 'xxs',
            position: 'overlay',
            use: 'px-2',
        },
        {
            size: 'xs',
            position: 'overlay',
            use: 'px-4',
        },
        {
            size: 'sm',
            position: 'overlay',
            use: 'px-4',
        },
        {
            size: 'base',
            position: 'overlay',
            use: 'px-4',
        },
        {
            size: 'md',
            position: 'overlay',
            use: 'px-4',
        },
        {
            size: 'lg',
            position: 'overlay',
            use: 'px-6',
        },
        {
            size: 'xl',
            position: 'overlay',
            use: 'px-6',
        },
        {
            size: '2xl',
            position: 'overlay',
            use: 'px-8',
        },
        {
            size: 'xxs',
            position: 'overlay',
            use: 'pb-2',
        },
        {
            size: 'xs',
            position: 'overlay',
            use: 'pb-4',
        },
        {
            size: 'sm',
            position: 'overlay',
            use: 'pb-4',
        },
        {
            size: 'base',
            position: 'overlay',
            use: 'pb-4',
        },
        {
            size: 'md',
            position: 'overlay',
            use: 'pb-4',
        },
        {
            size: 'lg',
            position: 'overlay',
            use: 'pb-5',
        },
        {
            size: 'xl',
            position: 'overlay',
            use: 'pb-5',
        },
        {
            size: '2xl',
            position: 'overlay',
            use: 'pb-7',
        },
        {
            size: 'xxs',
            insetX: true,
            use: 'px-2',
        },
        {
            size: 'xs',
            insetX: true,
            use: 'px-4',
        },
        {
            size: 'sm',
            insetX: true,
            use: 'px-4',
        },
        {
            size: 'base',
            insetX: true,
            use: 'px-4',
        },
        {
            size: 'md',
            insetX: true,
            use: 'px-4',
        },
        {
            size: 'lg',
            insetX: true,
            use: 'px-6',
        },
        {
            size: 'xl',
            insetX: true,
            use: 'px-6',
        },
        {
            size: '2xl',
            insetX: true,
            use: 'px-8',
        },
        {
            size: 'xxs',
            insetBottom: true,
            use: 'pb-2',
        },
        {
            size: 'xs',
            insetBottom: true,
            use: 'pb-4',
        },
        {
            size: 'sm',
            insetBottom: true,
            use: 'pb-4',
        },
        {
            size: 'base',
            insetBottom: true,
            use: 'pb-4',
        },
        {
            size: 'md',
            insetBottom: true,
            use: 'pb-4',
        },
        {
            size: 'lg',
            insetBottom: true,
            use: 'pb-5',
        },
        {
            size: 'xl',
            insetBottom: true,
            use: 'pb-5',
        },
        {
            size: '2xl',
            insetBottom: true,
            use: 'pb-7',
        },
        {
            insetX: false,
            use: 'px-0',
        },
        {
            insetBottom: false,
            use: 'pb-0',
        },
    ],
    defaults: {
        insetX: undefined,
        insetBottom: undefined,
    },
});
const innerContentStyle = (0,style/* style */.oB)({
    variants: {
        align: {
            top: 'justify-start',
            middle: 'justify-center',
            bottom: 'justify-end',
            'space-between': 'justify-between h-full!',
        },
        justify: {
            start: 'items-start text-left rtl:text-right',
            center: 'items-center text-center',
            end: 'items-end text-right rtl:text-left ',
        },
        size: {
            xxs: 'gap-3',
            xs: 'gap-4',
            sm: 'gap-4',
            base: 'gap-4',
            md: 'gap-5',
            lg: 'gap-7',
            xl: 'gap-7',
            '2xl': 'gap-8',
        },
    },
});
/**
 * @example
 * ```jsx
 * <TileRoot>
 *  <TileMedia />
 *  <TileContent />
 *    <TileBody>
 *    <TileFooter/>
 *   <TileContent>
 * </TileRoot>
 * ```
 */
const TileContent = ({ className, children, position, invert, justify = 'start', align = 'bottom', insetX = true, insetBottom, interactive = true, ...rest }) => {
    const { invert: invertContext, layout, width, size, dataTestId, } = useTileContext();
    const appliedInvert = invert ?? invertContext;
    return (react.createElement(TileContentContext.Provider, { value: {
            invert: appliedInvert,
            justify,
            align,
            insetX,
            position,
            width,
        } },
        react.createElement("div", { ...rest, "data-uds-child": "tile-content", "data-test-id": dataTestId && `${dataTestId}-content`, className: (0,twind.tw)(className, !interactive && 'pointer-events-none', 'relative z-1 flex w-full', contentStyle({
                position: position || layout,
                invert: appliedInvert,
                size,
                insetX,
                insetBottom,
            })) },
            react.createElement("div", { "data-uds-child": "tile-content-inner", className: (0,twind.tw)('relative flex flex-1 flex-col w-full', innerContentStyle({ justify, align, size })) }, children))));
};

const TILE_SIZE_TO_FLOAT_INSET = {
    none: 'none',
    xxs: 'xs',
    xs: 'sm',
    sm: 'sm',
    base: 'sm',
    md: 'sm',
    lg: 'base',
    xl: 'base',
    '2xl': 'md',
};
/**
 * TileFloat is a floating content container, that can be positioned anywhere on a Tile.
 *
 * Use it to render badges, icons, buttons and other floating content.
 *
 * @example
 * ```jsx
 * <TileRoot>
 *   <TileFloat>
 *     <Badge icon="start" label="Exclusive"/>
 *   </TileFloat>
 *   <TileMedia />
 *   <TileContent />
 * </TileRoot>
 * ```
 */
const TileFloat = ({ children, ...rest }) => {
    const { dataTestId, size } = useTileContext();
    const contentContext = useContentContext();
    const isInsideContent = !utils_esm.is.emptyObject(contentContext);
    const tileSize = (0,esm/* useResponsiveValue */.Vt)(size);
    return (react.createElement(Float, { dataTestId: dataTestId && `${dataTestId}-float`, inset: !isInsideContent && TILE_SIZE_TO_FLOAT_INSET[tileSize], ...rest }, children));
};

const bodyStyle = (0,style/* style */.oB)({
    base: 'w-full flex flex-col',
    variants: {
        size: {
            xxs: 'gap-none max-w-[95%]',
            xs: 'gap-1 max-w-[95%]',
            sm: 'gap-1 max-w-[95%]',
            base: 'gap-1 max-w-[90%]',
            md: 'gap-1 max-w-[90%]',
            lg: 'gap-2 max-w-[85%]',
            xl: 'gap-2 max-w-[85%]',
            '2xl': 'gap-2 max-w-[40rem]',
        },
        justify: {
            start: 'items-start text-left rtl:text-right',
            center: 'items-center text-center',
            end: 'items-end text-right rtl:text-left',
        },
    },
});
/**
 * The TileBody is a container for the main content of the Tile. Usually TileHeading, and TileDescription elements. It only applies vertical rhythm and content alignment, based on the configuration of the parent TileRoot.
 *
 * @example
 * ```jsx
 * <TileRoot>
 *  <TileMedia />
 *  <TileContent />
 *    <TileBody>
 *      <TileHeading/>
 *      <TileDescription/>
 *    </TileBody>
 *    <TileFooter>
 *      <TileActionList>
 *        <Link label="Shop Running"/>
 *      </TileActionList>
 *    </TileFooter>
 *  </TileRoot>
 * ```
 */
const TileBody = ({ className, children, ...rest }) => {
    const { dataTestId, size } = useTileContext();
    const { justify } = useContentContext();
    return (react.createElement("div", { ...rest, "data-uds-child": "tile-body", "data-test-id": dataTestId && `${dataTestId}-body`, className: (0,twind.tw)(className, bodyStyle({ size, justify })) }, children));
};

const footerStyle = (0,style/* style */.oB)({
    variants: {
        size: {
            xxs: 'gap-y-1',
            xs: 'gap-y-1',
            sm: 'gap-y-2',
            base: 'gap-y-2',
            md: 'gap-y-2',
            lg: 'gap-y-2',
            xl: 'gap-y-3',
            '2xl': 'gap-y-3',
        },
        justify: {
            start: 'items-start text-left rtl:text-right',
            center: 'items-center text-center',
            end: 'items-end text-right rtl:text-left',
        },
    },
});
/**
 * The footer of a Tile. It is used to display actions or other content. Often a footnote
 *
 * @example
 * ```jsx
 * <TileRoot>
 *  <TileMedia />
 *  <TileContent>
 *    <TileBody/>
 *    <TileFooter>
 *      <TileActionList>
 *        <Link label="Shop Running"/>
 *      </TileActionList>
 *    </TileFooter>
 *  <TileContent>
 * </TileRoot>
 * ```
 */
const TileFooter = ({ className, children, justify, ...rest }) => {
    const { size, dataTestId } = useTileContext();
    const { justify: contextJustify } = useContentContext();
    return (react.createElement("div", { ...rest, className: (0,twind.tw)('relative w-full flex flex-col', footerStyle({ size, justify: justify ?? contextJustify }), className), "data-uds-child": "tile-footer", "data-test-id": dataTestId && `${dataTestId}-footer` }, children));
};

/**
 * Use the TileActionList component to display a list of actions in a Tile. The container, will apply the correct spacing and alignment based on the configuration of the parent TileRoot.
 *
 * @example
 * ```jsx
 * <TileRoot>
 *  <TileMedia />
 *  <TileContent />
 *    <TileBody>
 *      <TileHeading/>
 *      <TileDescription/>
 *    </TileBody>
 *    <TileFooter>
 *      <TileActionList>
 *        <Link label="Shop Running"/>
 *      </TileActionList>
 *    </TileFooter>
 *  </TileRoot>
 * ```
 */
const TileActionList = ({ className, children, ...rest }) => {
    const { dataTestId } = useTileContext();
    const { invert } = useContentContext();
    return (react.createElement("div", { ...rest, className: (0,twind.tw)('flex items-baseline gap-x-4 gap-y-2', className), "data-uds-child": "tile-actions", "data-test-id": dataTestId && `${dataTestId}-actions` }, react.Children.map(children, child => {
        return react.cloneElement(child, {
            invert: child.props?.invert ?? invert,
        });
    })));
};

const tileHeadingSize = (0,style/* style */.oB)({
    variants: {
        size: {
            xxs: 'heading-xxs',
            xs: 'heading-sm',
            sm: 'heading-sm',
            base: 'heading-base',
            md: 'heading-lg',
            lg: 'heading-xl',
            xl: 'heading-2xl',
            '2xl': 'heading-3xl',
        },
    },
});
const tileCondensedSizeStyle = (0,style/* style */.oB)({
    variants: {
        size: {
            xxs: 'heading-sm',
            xs: 'heading-base',
            sm: 'heading-base',
            base: 'heading-lg',
            md: 'heading-xl',
            lg: 'heading-2xl',
            xl: 'heading-3xl',
            '2xl': 'heading-4xl',
        },
    },
});
/**
 * The TileHeading component is used to render a heading specifically inline Tiles.
 *
 * It's a wrapper around the Heading component, but implements a custom size scale, proportional to the TileRoot size.
 */
const TileHeading = react.forwardRef((props, forwardedRef) => {
    const { asChild, balance, size, weight = 700, condensed = false, transform = 'uppercase', srOnly, css, className, children, color, invert, ...rest } = props;
    const { dataTestId, size: contextSize } = useTileContext();
    const Comp = balance
        ? Balancer
        : typeof children !== 'string' && asChild
            ? $5e63c961fc1ce211$export$8c6ed5c666ac1360
            : 'h3';
    return (react.createElement(Comp, { ref: forwardedRef, className: (0,style.tw)(condensed
            ? tileCondensedSizeStyle({ size: size ?? contextSize })
            : tileHeadingSize({ size: size ?? contextSize }), fontStyle({
            condensed,
            weight,
            transform,
            srOnly,
        }), colorStyle({
            color,
            invert,
        }), className), "data-uds-child": "tile-heading", "data-test-id": dataTestId && `${dataTestId}-heading`, ...rest }, asChild ? children : balance ? react.createElement("span", null, children) : children));
});
TileHeading.displayName = 'TileHeading';

const descriptionSizeStyle = (0,style/* style */.oB)({
    variants: {
        size: {
            xxs: 'text-xs',
            xs: 'text-sm',
            sm: 'text-base',
            base: 'text-base',
            md: 'text-xl',
            lg: 'text-xl',
            xl: 'text-2xl ',
            '2xl': 'text-2xl ',
        },
    },
});
/**
 * The TileDescription component is used to render body copy specifically inline Tiles. Usually within the TileBody.
 *
 * It's a wrapper around the Text component, but implements a custom size scale, proportional to the TileRoot size.
 */
const TileDescription = ({ asChild, balance, weight = 400, condensed = false, transform, srOnly, className, children, color, invert, size, ...rest }) => {
    const { dataTestId, size: contextSize } = useTileContext();
    const BalancedWrapper = balance ? Balancer : asChild ? $5e63c961fc1ce211$export$8c6ed5c666ac1360 : react.Fragment;
    const elProps = {
        ...rest,
        className: (0,twind.tw)(descriptionSizeStyle({ size: size ?? contextSize }), fontStyle({
            condensed,
            weight,
            transform,
            srOnly,
        }), colorStyle({
            color,
            invert,
        }), className),
        'data-test-id': dataTestId && `${dataTestId}-description`,
        'data-uds-child': 'tile-description',
    };
    return asChild ? (react.createElement(BalancedWrapper, { ...elProps }, children)) : (react.createElement(BalancedWrapper, null,
        react.createElement("p", { ...elProps }, children)));
};

const footnoteSizeStyle = (0,style/* style */.oB)({
    variants: {
        size: {
            xxs: 'text-xxs',
            xs: 'text-xxs',
            sm: 'text-xs',
            base: 'text-sm',
            md: 'text-sm',
            lg: 'text-base',
            xl: 'text-base ',
            '2xl': 'text-base ',
        },
    },
});
/**
 * The TileFootnote component is used to render a footnote specifically inline Tiles. Usually within the TileFooter.
 *
 * It's a wrapper around the Text component, but implements a custom size scale, proportional to the TileRoot size.
 */
const TileFootnote = ({ asChild, balance, weight = 700, condensed = false, transform = 'uppercase', srOnly, className, children, color, invert, size, ...rest }) => {
    const { size: contextSize, dataTestId } = useTileContext();
    const Comp = asChild ? Slot : 'p';
    return (React.createElement(Comp, { ...rest, className: tw$2(footnoteSizeStyle({ size: size ?? contextSize }), fontStyle({
            condensed,
            weight,
            transform,
            srOnly,
        }), colorStyle({
            color,
            invert,
        }), className), "data-test-id": dataTestId && `${dataTestId}-footnote`, "data-uds-child": "tile-footnote" }, children));
};

const collabStyle = (0,style/* style */.oB)({
    variants: {
        inline: {
            true: 'relative',
            false: 'absolute z-20',
        },
    },
    matches: [
        {
            inline: true,
            use: 'relative! top-auto bottom-auto left-auto right-auto transform-none text-left rtl:text-right',
        },
    ],
});
const TILE_COLLAB_SIZE_MAP = {
    xxs: 'sm',
    xs: 'sm',
    sm: 'sm',
    base: 'base',
    md: 'base',
    lg: 'base',
    xl: 'xl',
    '2xl': 'xl',
};
/**
 * TileCollab is a component that is used to display a collaboration between PUMA and another brand.
 *
 * Uses the TileFloat internally, and can be used directly as a child of the TileRoot, or the TileContent.
 *
 * It is positioned absolutely by default, but can be positioned relatively by setting the inline prop to true.
 *
 * @example
 * ```jsx
 * <TileRoot>
 *   <TileCollab showPumaLogo>Vogue</TileCollab>
 *   <TileMedia />
 *   <TileContent />
 * </TileRoot>
 * ```
 */
const TileCollab = ({ children, invert, inline = false, align = 'top', justify = 'end', showPumaLogo = true, collabLogo, className, size, }) => {
    const { dataTestId, size: contextSize } = useTileContext();
    const { invert: contextInvert } = useContentContext();
    const responsiveSize = useResponsiveValue(size ?? contextSize);
    return (React.createElement(TileFloat, { align: align, justify: justify, invert: invert ?? contextInvert, asChild: true },
        React.createElement(Collab, { showPumaLogo: showPumaLogo, collabLogo: collabLogo, dataTestId: dataTestId && `${dataTestId}-collab`, size: TILE_COLLAB_SIZE_MAP[responsiveSize], invert: invert ?? contextInvert, className: tw$1(collabStyle({ inline }), className) }, children)));
};

const RibbonContext = (0,react.createContext)(undefined);
const RibbonProvider = ({ children, value, }) => react.createElement(RibbonContext.Provider, { value: value }, children);
const useRibbonContext = () => {
    const context = (0,react.useContext)(RibbonContext);
    if (!context) {
        throw new Error('useRibbonContext must be used within a RibbonProvider');
    }
    return context;
};

const SIZE_MAP = {
    sm: 'h-6',
    base: 'h-8',
    lg: 'h-10',
};
const GAP_MAP = {
    none: 0,
    xxs: 1,
    xs: 2,
    sm: 4,
    base: 6,
    lg: 8,
    xl: 12,
    '2xl': 16,
    '3xl': 20,
    '4xl': 28,
    '5xl': 36,
};
const SPEED_MAP = {
    slow: 4,
    base: 8,
    fast: 16,
};
const DEFAULT_GRADIENT = `linear-gradient(
  140deg,
  #de99f1 11.32%,
  #f6d2c8 16.18%,
  #f5e2c8 20.68%,
  #bde8d9 27.82%,
  #fffbf1 38.05%,
  #edc7c6 45.26%,
  #ecabc7 51.43%,
  #c7b2e5 61.12%,
  #e2ecf8 64.34%,
  #a9e8dd 72.25%,
  #eedfc5 79.63%,
  #e5b0c9 84.17%,
  #de99f1 88.59%
)`;

/**
 * The ribbon component is used to display a horizontal list of items, with
 * optional dividers between each item.
 *
 * @example
 *
 * ```
 * <Ribbon>
 *   <RibbonBackground />
 *   <RibbonScroller>
 *     <RibbonItem>Item 1</RibbonItem>
 *     <RibbonItem>Item 2</RibbonItem>
 *     <RibbonItem>Item 3</RibbonItem>
 *   </RibbonScroller>
 * </Ribbon>
 * ```
 */
const RibbonRoot = ({ size = 'base', gap = 'base', speed = 'base', divider, children, className, dataTestId, ...rest }) => {
    const gapAsRem = twind.tw.theme(`space`)[GAP_MAP[gap]];
    const { ref, width } = (0,esm/* useResizeObserver */.yU)();
    const style = (0,esm/* useResponsiveProp */.Uo)(size, value => SIZE_MAP[value]);
    return (react.createElement(RibbonProvider, { value: {
            divider: divider === false
                ? null
                : divider ?? (react.createElement(Icon, { name: "puma-logo", size: "2xl", dataTestId: dataTestId ? `${dataTestId}-divider` : undefined })),
            speed,
            size,
            width,
            dataTestId,
        } },
        react.createElement("div", { className: (0,twind.tw)(`relative flex items-center w-full gap-[var(--gap)] select-none overflow-hidden`, style, 
            // Gap is applied as a custom property to the ribbon, so that it can be
            // used by the ribbon scroller animation
            css_css/* css */.iv `
            --gap: ${gapAsRem};
          `, className), ref: ref, "data-test-id": dataTestId, "data-uds-child": "ribbon", ...rest }, children)));
};

const useRibbonSpeed = (speed, elementWidth) => {
    const { devicePreferences } = (0,esm/* useUdsContext */.vV)();
    const speedAsNumber = (0,utils_esm/* isNumber */.hj)(speed) ? speed : SPEED_MAP[speed];
    const appliedSpeed = devicePreferences?.prefersReducedMotion
        ? Math.min(speedAsNumber, SPEED_MAP.slow)
        : speedAsNumber;
    return (elementWidth / (appliedSpeed * 10)).toFixed(2);
};

const SCROLL_ANIMATION$1 = (0,css_css/* keyframes */.F4)({
    from: {
        transform: 'translateX(0)',
    },
    to: {
        transform: `translateX(50%)`,
    },
});
/**
 * Renders a ribbon gradient background which can be animated or static.
 *
 * @example
 * ```
 * <RibbonGradientBackground
 *   gradient="linear-gradient(90deg, #fff 0%, #ccc 50%, #fff 100%)"
 *   animate
 * />
 * ```
 */
const RibbonGradientBackground = ({ className, animate = true, gradient, speed, }) => {
    const { speed: ribbonSpeed, dataTestId } = useRibbonContext();
    const ref = (0,react.useRef)(null);
    const width = ref.current?.offsetWidth || 0;
    const animationSpeed = useRibbonSpeed(speed || ribbonSpeed, width);
    return (react.createElement("div", { ref: ref, className: (0,css_css.tw)(`absolute top-0 right-0 bottom-0 w-[200%] h-full overflow-hidden`, gradient
            ? css_css/* css */.iv `
              background: ${gradient}, ${gradient};
              background-size: 50% 100%;
              background-position: 0 0, 100%, 0;
            `
            : css_css/* css */.iv `
              background: linear-gradient(
                  0deg,
                  rgba(255, 255, 255, 1),
                  rgba(255, 255, 255, 1)
                ),
                ${DEFAULT_GRADIENT}, ${DEFAULT_GRADIENT};
              background-size: 100% 100%, 50% 100%, 50% 100%;
              background-blend-mode: soft-light, normal, normal;
              background-position: 0 0, 0 0, 100%, 0;
            `, css_css/* css */.iv `
          background-repeat: no-repeat;
        `, animate &&
            css_css/* css */.iv `
            animation: ${SCROLL_ANIMATION$1} ${animationSpeed}s linear infinite;
          `, className), "data-test-id": dataTestId ? `${dataTestId}-gradient-background` : undefined, "data-uds-child": "ribbon-gradient-background" }));
};

/**
 * A group of ribbon items
 *
 * @internal Used by the `RibbonScroller` component
 */
const RibbonItemGroup = (0,react.forwardRef)(function RibbonItemGroup({ children, isDuplicate, dataTestId }, ref) {
    return (react.createElement("div", { className: `flex flex-shrink-0 gap-[var(--gap)] items-center`, "aria-hidden": isDuplicate ? 'true' : undefined, "data-test-id": dataTestId, "data-uds-child": "ribbon-item-group", ref: ref }, children));
});

const SCROLL_ANIMATION = (0,css_css/* keyframes */.F4)({
    from: {
        transform: 'translateX(0)',
    },
    to: {
        transform: `translateX(calc((-100% - var(--gap)) / 2))`,
    },
});
/**
 * Renders ribbon items and scrolls them horizontally.
 *
 * @example
 * ```
 * <RibbonScroller>
 *   <RibbonItem>Item 1</RibbonItem>
 *   <RibbonItem>Item 2</RibbonItem>
 *   <RibbonItem>Item 3</RibbonItem>
 * </RibbonScroller>
 * ```
 */
const RibbonScroller = ({ children }) => {
    const id = reach_auto_id_useId();
    const { speed, divider, width, dataTestId } = useRibbonContext();
    const [duplicateItemGroupCount, setDuplicateItemGroupCount] = (0,react.useState)(0);
    const originalItemRef = (0,react.useRef)(null);
    const scrollerRef = (0,react.useRef)(null);
    const scrollerWidth = scrollerRef.current?.scrollWidth || 0;
    const animationSpeed = useRibbonSpeed(speed, scrollerWidth);
    // Insert divider between each child
    const items = react.Children.map(children, child => (react.createElement(react.Fragment, null,
        child,
        divider &&
            (0,react.cloneElement)(divider, {
                role: 'separator',
            }))));
    // Calculate how many duplicate item groups we need to fill the ribbon
    (0,react.useEffect)(() => {
        if (width && originalItemRef.current) {
            const itemGroupsPerViewport = Math.ceil(width / originalItemRef.current.offsetWidth);
            // We need 2 times as many items as we can fit in the viewport
            // minus 1 to account for the original item group
            setDuplicateItemGroupCount(itemGroupsPerViewport * 2 - 1);
        }
    }, [width]);
    return (react.createElement("div", { ref: scrollerRef, className: (0,css_css.tw)(`relative flex gap-[var(--gap)] flex-shrink-0 items-center min-w-[100%]`, css_css/* css */.iv `
          animation: ${SCROLL_ANIMATION} ${animationSpeed}s linear infinite;
        `), "data-test-id": dataTestId ? `${dataTestId}-scroller` : undefined, "data-uds-child": "ribbon-scroller" },
        react.createElement(RibbonItemGroup, { ref: originalItemRef, dataTestId: dataTestId ? `${dataTestId}-original-item-group` : undefined }, items),
        [...new Array(duplicateItemGroupCount)].map((_, i) => (react.createElement(RibbonItemGroup, { key: `${id}-${i}`, dataTestId: dataTestId ? `${dataTestId}-duplicate-item-group` : undefined, isDuplicate: true }, items)))));
};

const testSizes = {
    sm: 'text-xs',
    base: 'text-sm',
    lg: 'text-base',
};
/**
 * Renders a single item in a ribbon.
 *
 * @example
 * ```
 * <RibbonItem>Item text</RibbonItem>
 * ```
 */
const RibbonItem = ({ children, className, size, dataTestId, ...rest }) => {
    const { size: ribbonSize } = useRibbonContext();
    const style = (0,esm/* useResponsiveProp */.Uo)(size || ribbonSize, value => testSizes[value]);
    return (react.createElement("div", { className: (0,twind.tw)('relative flex-shrink-0 uppercase font-bold', style, className), "data-test-id": dataTestId, "data-uds-child": "ribbon-item", ...rest }, children));
};

/**
 * Wrap an element to automatically focus it when it is mounted.
 *
 * Warning: Use cautiously, to manage focus in popovers and dialogs or as a result of an action.
 *
 * @example
 * ```
 * <AutoFocus>
 *   <input />
 * </AutoFocus>
 * ```
 */
const AutoFocus = ({ children }) => {
    const ref = useRef(null);
    useEffect(() => {
        if (ref.current) {
            if (!(ref.current instanceof HTMLAnchorElement ||
                ref.current instanceof HTMLButtonElement ||
                ref.current instanceof HTMLInputElement ||
                ref.current instanceof HTMLSelectElement ||
                ref.current instanceof HTMLTextAreaElement)) {
                ref.current.tabIndex = -1;
            }
            ref.current.focus();
        }
    }, []);
    return React.createElement(Slot, { ref: ref }, children);
};


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 68138:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LI": function() { return /* binding */ useIsomorphicLayoutEffect; },
/* harmony export */   "Lq": function() { return /* binding */ UdsProvider; },
/* harmony export */   "Uo": function() { return /* binding */ useResponsiveProp; },
/* harmony export */   "Vt": function() { return /* binding */ useResponsiveValue; },
/* harmony export */   "_w": function() { return /* binding */ useResponsiveMap; },
/* harmony export */   "ac": function() { return /* binding */ useMediaQuery; },
/* harmony export */   "dN": function() { return /* binding */ useDelayUnmount; },
/* harmony export */   "lD": function() { return /* binding */ useSharedRef; },
/* harmony export */   "mZ": function() { return /* binding */ useHorizontalScroll; },
/* harmony export */   "oG": function() { return /* binding */ useUdsTranslate; },
/* harmony export */   "s0": function() { return /* binding */ useNavigate; },
/* harmony export */   "vV": function() { return /* binding */ useUdsContext; },
/* harmony export */   "yU": function() { return /* binding */ useResizeObserver; }
/* harmony export */ });
/* unused harmony exports UDS_BREAKPOINTS, UdsContext, initialDictionary, useIntersectionObserver, useVisibilityChange */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var _global_ecom_nitro_uds_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21955);
/* harmony import */ var deepmerge__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21857);
/* harmony import */ var deepmerge__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(deepmerge__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var twind__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34209);





const UDS_BREAKPOINTS = [
    '_',
    'mobile',
    '2xs',
    'xs',
    'sm',
    'tablet',
    'md',
    'desktop',
    'lg',
    'xl',
    '2xl',
    '3xl',
    '4xl',
];

const useResizeObserver = (elementRef) => {
    const isMounted = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
    const newRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    const ref = elementRef || newRef;
    const [state, setState] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({ width: 0, height: 0 });
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
        isMounted.current = true;
        return () => {
            isMounted.current = false;
        };
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
        /* istanbul ignore if  */
        if (!ref.current || _global_ecom_nitro_uds_utils__WEBPACK_IMPORTED_MODULE_1__/* .isServer */ .sk)
            return;
        if (isMounted.current) {
            setState({
                width: Math.round(ref.current.offsetWidth),
                height: Math.round(ref.current.offsetHeight),
            });
        }
        // @ts-ignore
        const ro = new window.ResizeObserver((0,_global_ecom_nitro_uds_utils__WEBPACK_IMPORTED_MODULE_1__/* .debounce */ .Ds)((entries) => {
            requestAnimationFrame(() => {
                /* istanbul ignore if  */
                if (!Array.isArray(entries) || !entries.length)
                    return;
                const { width, height } = entries[0].contentRect;
                /* istanbul ignore if  */
                if (isMounted.current)
                    setState({ width: Math.round(width), height: Math.round(height) });
            });
        }, 100));
        const element = ref.current;
        ro.observe(element);
        return () => ro.unobserve(element);
    }, [ref.current]);
    return { ref, ...state };
};

/* istanbul ignore  */
const useIsomorphicLayoutEffect = _global_ecom_nitro_uds_utils__WEBPACK_IMPORTED_MODULE_1__/* .isServer */ .sk
    ? /* istanbul ignore next */
        react__WEBPACK_IMPORTED_MODULE_0__.useEffect
    : react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect;

const useIntersectionObserver = (props = {}) => {
    const { threshold = 0.5, rootMargin, enabled = true, once = false } = props;
    const [inView, setInview] = useState(false);
    const ref = useRef(null);
    useEffect(() => {
        if (!enabled)
            return;
        let observer;
        if (ref.current && !isServer) {
            observer = new IntersectionObserver(([element]) => {
                setInview(element.isIntersecting);
                if (once && element.isIntersecting) {
                    observer.disconnect();
                }
            }, {
                threshold: threshold,
                rootMargin,
            });
            observer.observe(ref.current);
        }
        return () => {
            if (observer)
                observer.disconnect();
        };
    }, [enabled, ref]);
    return [ref, inView];
};

const useVisibilityChange = () => {
    const [isVisible, setIsVisible] = useState(true);
    const handleOnChange = () => {
        setIsVisible(document.visibilityState === 'visible');
    };
    useIsomorphicLayoutEffect(() => {
        document.addEventListener('visibilitychange', handleOnChange);
        return () => {
            document.removeEventListener('visibilitychange', handleOnChange);
        };
    }, []);
    return isVisible;
};

const useDelayUnmount = (isMounted, delayTime) => {
    const [shouldRender, setShouldRender] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
        let timeoutId;
        if (isMounted && !shouldRender) {
            setShouldRender(true);
        }
        else if (!isMounted && shouldRender) {
            timeoutId = setTimeout(() => setShouldRender(false), delayTime);
        }
        return () => clearTimeout(timeoutId);
    }, [isMounted, delayTime, shouldRender]);
    return shouldRender;
};

const useMediaQuery = (query) => {
    const mediaMatch = _global_ecom_nitro_uds_utils__WEBPACK_IMPORTED_MODULE_1__/* .isServer */ .sk
        ? /* istanbul ignore next */
            null
        : window.matchMedia(query);
    const [matches, setMatches] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(mediaMatch?.matches || false);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
        /* istanbul ignore if */
        if (_global_ecom_nitro_uds_utils__WEBPACK_IMPORTED_MODULE_1__/* .isServer */ .sk)
            return;
        const handler = e => setMatches(e.matches);
        mediaMatch.addEventListener('change', handler);
        return () => mediaMatch.removeEventListener('change', handler);
    });
    return matches;
};

/**
 * Hook to convert responsive prop to a responsive tailwind utility string
 * @example
 *
 * ```jsx
 * const padding:ResponsiveProp<string> = {_: 'md', md: 'lg'};
 *
 * const paddingClassName = useResponsiveProp(padding, (value) => `p-${value}`);
 *
 * const className = tw(paddingClassName);
 * ```
 *
 * @param prop - responsive prop
 * @param callback - callback to convert the prop value to a tailwind utility string
 * @returns string
 */
function useResponsiveProp(prop, callback) {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => {
        const propObject = _global_ecom_nitro_uds_utils__WEBPACK_IMPORTED_MODULE_1__.is.primitive(prop) ? { _: prop } : prop;
        return Object.keys(propObject).reduce((acc, key) => {
            const result = callback(propObject[key]);
            const prefix = key === '_' ? '' : `${key}:`;
            const out = Array.isArray(result)
                ? `${prefix}(${result.join(' ')})`
                : `${prefix}(${result})`;
            return `${acc} ${out.trim()}`;
        }, ``);
    }, [prop, callback]);
}

const initialDictionary = {
    next: 'Next',
    previous: 'Previous',
    scrollNext: 'Scroll Next',
    scrollPrevious: 'Scroll Previous',
    pageXofY: 'Page {page} of {total}',
    loading: 'Loading',
    optional: 'Optional',
    january: 'January',
    february: 'February',
    march: 'March',
    april: 'April',
    may: 'May',
    june: 'June',
    july: 'July',
    august: 'August',
    september: 'September',
    october: 'October',
    november: 'November',
    december: 'December',
    day: 'Day',
    month: 'Month',
    year: 'Year',
    close: 'Close',
    clear: 'Clear',
    search: 'Search',
    current: 'Current',
    complete: 'Complete',
    stepCount: 'Step {step} of {total}',
    showPassword: 'Show Password',
    hidePassword: 'Hide Password',
    charactersRemaining: '{num} characters remaining',
    genericFieldMinLength: 'This field must be at least {length} characters in length.',
    genericFieldMaxLength: 'This field cannot exceed {length} characters in length.',
    srNewSearchResults: 'New search results for query {query}. {num} items. Use your directional controls to navigate through the results.',
    srNoSearchResults: 'No search results found for your query {query}. Press the escape key to clear the search field.',
};
const replaceVariable = (translation, key, value) => {
    return translation.replace(new RegExp(`{${key}}`, 'g'), value);
};
const getDictionaryTranslation = (dictionary) => {
    const translate = (key, variables) => {
        let translation = dictionary[key] ?? '';
        if (variables) {
            Object.keys(variables).forEach(vKey => {
                if (translation.length) {
                    translation = replaceVariable(translation, vKey, variables[vKey]);
                }
            });
        }
        return translation;
    };
    return translate;
};
const initialContext = {
    iconDirectory: '',
    dictionary: initialDictionary,
    devicePreferences: {
        prefersReducedMotion: false,
        prefersReducedData: false,
    },
    screens: {},
};
/**
 * Typically, just the UdsProvider is needed.
 * Use this to provide overrides.
 */
const UdsContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(initialContext);
/**
 * This Provider is required by all UDS elements.
 * Be sure to add this to the root of your application.
 */
const UdsProvider = ({ value = {}, children, }) => {
    const mediaQueries = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => {
        return UDS_BREAKPOINTS.reduce((result, breakpoint) => {
            const twScreen = twind__WEBPACK_IMPORTED_MODULE_3__.tw.theme(`screens`)[breakpoint];
            const mql = typeof twScreen === 'string'
                ? `screen and (min-width: ${twScreen})`
                : twScreen.raw;
            result[breakpoint] = mql;
            return result;
        }, {});
    }, [twind__WEBPACK_IMPORTED_MODULE_3__.tw.theme(`screens`)]);
    const prefersReducedMotion = useMediaQuery('screen and (prefers-reduced-motion)');
    const prefersReducedData = useMediaQuery('screen and (prefers-reduced-data)');
    const getMqlMatches = () => {
        return UDS_BREAKPOINTS.reduce((matches, breakpoint) => {
            const mql = mediaQueries[breakpoint];
            if (breakpoint === '_')
                return matches;
            matches[breakpoint] = _global_ecom_nitro_uds_utils__WEBPACK_IMPORTED_MODULE_1__/* .isServer */ .sk ? false : window.matchMedia(mql).matches;
            return matches;
        }, { _: true });
    };
    const matches = getMqlMatches();
    const [mediaQueriesMatch, setMediaQueriesMatch] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(matches);
    const onResize = (0,_global_ecom_nitro_uds_utils__WEBPACK_IMPORTED_MODULE_1__/* .debounce */ .Ds)(() => {
        const matches = getMqlMatches();
        setMediaQueriesMatch(matches);
    }, 100);
    useIsomorphicLayoutEffect(() => {
        /* istanbul ignore next */
        if (_global_ecom_nitro_uds_utils__WEBPACK_IMPORTED_MODULE_1__/* .isServer */ .sk)
            return;
        window.addEventListener('resize', onResize);
        /* istanbul ignore next */
        return () => {
            window.removeEventListener('resize', onResize);
        };
    }, [mediaQueries]);
    const state = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => {
        return deepmerge__WEBPACK_IMPORTED_MODULE_2___default().all([
            initialContext,
            {
                screens: {
                    mql: mediaQueries || {},
                    mqlMatch: mediaQueriesMatch || {},
                    breakpoints: [...UDS_BREAKPOINTS],
                },
                devicePreferences: {
                    prefersReducedMotion,
                    prefersReducedData,
                },
            },
            value,
        ]);
    }, [
        value,
        prefersReducedMotion,
        prefersReducedData,
        mediaQueries,
        mediaQueriesMatch,
    ]);
    return react__WEBPACK_IMPORTED_MODULE_0__.createElement(UdsContext.Provider, { value: state }, children);
};
const useUdsContext = () => {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(UdsContext);
};
const useUdsTranslate = () => {
    const { dictionary } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(UdsContext);
    const t = getDictionaryTranslation(dictionary);
    return t;
};

function useResponsiveValue(value) {
    const propObject = (0,_global_ecom_nitro_uds_utils__WEBPACK_IMPORTED_MODULE_1__/* .isPrimitive */ .pt)(value) ? { _: value } : value;
    const { screens } = useUdsContext();
    let currentBreakpoint = '_';
    screens.breakpoints.forEach(breakpoint => {
        if (propObject[breakpoint] && screens.mqlMatch[breakpoint]) {
            currentBreakpoint = breakpoint;
        }
    });
    return propObject[currentBreakpoint];
}

function useResponsiveMap(prop, map) {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => {
        const propObject = _global_ecom_nitro_uds_utils__WEBPACK_IMPORTED_MODULE_1__.is.primitive(prop) ? { _: prop } : prop;
        return Object.keys(propObject).reduce((acc, key) => {
            acc[key] = map[propObject[key]];
            return acc;
        }, {});
    }, [prop, map]);
}

function useSharedRef(a, b) {
    const ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => {
        if (a === null && b === null) {
            return null;
        }
        return (value) => {
            if (typeof a === 'function') {
                a(value);
            }
            else if (a) {
                a.current = value;
            }
            if (typeof b === 'function') {
                b(value);
            }
            else if (b) {
                b.current = value;
            }
        };
    }, [a, b]);
    return ref;
}

const useHorizontalScroll = ({ infinite = true, items, } = {}) => {
    const { ref, width } = useResizeObserver();
    const [state, setState] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
        hasPrev: !!infinite,
        hasNext: !!infinite,
        isOverflowing: false,
    });
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
        const scroller = ref.current;
        const update = () => setState({
            hasPrev: infinite || scroller.scrollLeft != 0,
            hasNext: infinite ||
                scroller.scrollLeft + scroller.offsetWidth < scroller.scrollWidth,
            isOverflowing: scroller.scrollWidth > scroller.clientWidth,
        });
        if (scroller) {
            (0,_global_ecom_nitro_uds_utils__WEBPACK_IMPORTED_MODULE_1__/* .debounce */ .Ds)(update, 200)();
            scroller.addEventListener('scroll', (0,_global_ecom_nitro_uds_utils__WEBPACK_IMPORTED_MODULE_1__/* .debounce */ .Ds)(update, 200));
        }
    }, [ref, width, items]);
    const scrollToNext = () => {
        const scroller = ref.current;
        const scrollByAmount = scroller.offsetWidth;
        if (scroller.scrollLeft + scrollByAmount + 1 < scroller.scrollWidth) {
            scroller.scrollBy({
                left: scroller.offsetWidth,
                top: 0,
                behavior: 'smooth',
            });
        }
        else if (infinite)
            scroller.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
    };
    const scrollToPrev = () => {
        const scroller = ref.current;
        const scrollByAmount = scroller.offsetWidth;
        if (scroller.scrollLeft != 0) {
            scroller.scrollBy({
                left: -scrollByAmount,
                top: 0,
                behavior: 'smooth',
            });
        }
        else if (infinite)
            scroller.scrollTo({
                left: scroller.scrollWidth,
                top: 0,
                behavior: 'smooth',
            });
    };
    const scrollToIndex = (index) => {
        const scroller = ref.current;
        const scrollByAmount = scroller.offsetWidth;
        if (scroller.scrollLeft + scrollByAmount + 1 < scroller.scrollWidth) {
            scroller.scrollBy({
                left: scroller.offsetWidth * index,
                top: 0,
                behavior: 'auto',
            });
        }
        else if (infinite)
            scroller.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
    };
    return { ref, scrollToNext, scrollToPrev, scrollToIndex, ...state };
};

function useNavigate({ href, target, popup = false, popupWidth = 750, popupHeight = 780, focusable = true, onClick, ...rest }) {
    const { utils } = useUdsContext();
    const newTabProps = target === '_blank' ? { target: '_blank', rel: 'noopener noreferrer' } : {};
    const isAbsoluteUrl = href?.includes('://') ||
        href?.startsWith('mailto') ||
        href?.startsWith('tel');
    const localizedHref = utils?.localizeUrlPath && !isAbsoluteUrl
        ? utils.localizeUrlPath(href)
        : href;
    const handleClick = (e) => {
        if (onClick) {
            onClick(e);
        }
        if (popup) {
            e.preventDefault();
            return window.open(localizedHref, '', `
          scrollbars=yes,
          menubar=no,
          status=no,
          location=no,
          toolbar=no,
          width=${popupWidth},
          height=${popupHeight}},
          top=${(window.innerHeight - popupWidth) / 2},
          left=${(window.innerWidth - popupHeight) / 2}
          `
                .replace(/\\n/g, '')
                .trim());
        }
        const isModifiedEvent = e.metaKey || e.altKey || e.ctrlKey || e.shiftKey;
        if (utils?.navigate && // custom navigate function is available
            !e.defaultPrevented && // onClick prevented default
            e.button === 0 && // ignore everything but left clicks
            (!target || target === '_self') && // let browser handle "target=_blank" etc.
            !isModifiedEvent && // ignore clicks with modifier keys
            !isAbsoluteUrl // ignore absolute urls
        ) {
            e.preventDefault();
            utils.navigate(localizedHref);
        }
    };
    return {
        ...rest,
        ...newTabProps,
        href: localizedHref,
        tabIndex: focusable ? undefined : -1,
        'aria-hidden': focusable ? undefined : true,
        onClick: handleClick,
    };
}


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 21955:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ds": function() { return /* binding */ debounce; },
/* harmony export */   "hj": function() { return /* binding */ isNumber; },
/* harmony export */   "is": function() { return /* binding */ is; },
/* harmony export */   "pt": function() { return /* binding */ isPrimitive; },
/* harmony export */   "sk": function() { return /* binding */ isServer; }
/* harmony export */ });
/* unused harmony exports isArray, isBoolean, isEmptyObject, isExists, isFunction, isObject, isString, isTruthy, isUndefined, throttle */
function throttle(fn, timeout = 500) {
    let running;
    let result;
    return (...args) => {
        if (!running) {
            running = true;
            setTimeout(() => {
                running = false;
            }, timeout);
            result = fn(...args);
        }
        return result;
    };
}

function debounce(cb, ms) {
    let timeout;
    return function (...args) {
        if (timeout)
            clearTimeout(timeout);
        timeout = window.setTimeout(() => cb.apply(this, args), ms);
    };
}

const isServer = typeof window === 'undefined';
const isTruthy = (n) => n !== undefined && n !== null && n !== false;
const isExists = (n) => n !== undefined && n !== null;
const isUndefined = (n) => n === undefined;
const isArray = (n) => Array.isArray(n);
const isBoolean = (n) => typeof n === 'boolean';
const isNumber = (n) => typeof n === 'number' && !Number.isNaN(n);
const isFunction = (f) => typeof f === 'function';
const isString = (str) => Object.prototype.toString.call(str) === '[object String]';
const isPrimitive = (n) => isString(n) || isNumber(n) || isBoolean(n) || isUndefined(n);
const isObject = (n) => isExists(n) && !isArray(n) && typeof n === 'object';
const isEmptyObject = (n) => isExists(n) &&
    !isArray(n) &&
    Object.entries(n).length === 0 &&
    n.constructor === Object;
const is = {
    server: isServer,
    truthy: isTruthy,
    exists: isExists,
    undefined: isUndefined,
    boolean: isBoolean,
    array: isArray,
    number: isNumber,
    string: isString,
    primitive: isPrimitive,
    function: isFunction,
    object: isObject,
    emptyObject: isEmptyObject,
};


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 27894:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(69249)


/***/ }),

/***/ 2485:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var objectAssign = __webpack_require__(76493);

var buildMarksTree = __webpack_require__(45428);

var nestLists = __webpack_require__(3054);

var generateKeys = __webpack_require__(97901);

var mergeSerializers = __webpack_require__(12905); // Properties to extract from props and pass to serializers as options


var optionProps = ['projectId', 'dataset', 'imageOptions'];

var isDefined = function isDefined(val) {
  return typeof val !== 'undefined';
};

var defaults = {
  imageOptions: {}
};

function blocksToNodes(h, properties, defaultSerializers, serializeSpan) {
  var props = objectAssign({}, defaults, properties);
  var rawBlocks = Array.isArray(props.blocks) ? props.blocks : [props.blocks];
  var keyedBlocks = generateKeys(rawBlocks);
  var blocks = nestLists(keyedBlocks, props.listNestMode);
  var serializers = mergeSerializers(defaultSerializers, props.serializers || {});
  var options = optionProps.reduce(function (opts, key) {
    var value = props[key];

    if (isDefined(value)) {
      opts[key] = value;
    }

    return opts;
  }, {});

  function serializeNode(node, index, siblings, isInline) {
    if (isList(node)) {
      return serializeList(node);
    }

    if (isListItem(node)) {
      return serializeListItem(node, findListItemIndex(node, siblings));
    }

    if (isSpan(node)) {
      return serializeSpan(node, serializers, index, {
        serializeNode: serializeNode
      });
    }

    return serializeBlock(node, index, isInline);
  }

  function findListItemIndex(node, siblings) {
    var index = 0;

    for (var i = 0; i < siblings.length; i++) {
      if (siblings[i] === node) {
        return index;
      }

      if (!isListItem(siblings[i])) {
        continue;
      }

      index++;
    }

    return index;
  }

  function serializeBlock(block, index, isInline) {
    var tree = buildMarksTree(block);
    var children = tree.map(function (node, i, siblings) {
      return serializeNode(node, i, siblings, true);
    });
    var blockProps = {
      key: block._key || "block-".concat(index),
      node: block,
      isInline: isInline,
      serializers: serializers,
      options: options
    };
    return h(serializers.block, blockProps, children);
  }

  function serializeListItem(block, index) {
    var key = block._key;
    var tree = buildMarksTree(block);
    var children = tree.map(serializeNode);
    return h(serializers.listItem, {
      node: block,
      serializers: serializers,
      index: index,
      key: key,
      options: options
    }, children);
  }

  function serializeList(list) {
    var type = list.listItem;
    var level = list.level;
    var key = list._key;
    var children = list.children.map(serializeNode);
    return h(serializers.list, {
      key: key,
      level: level,
      type: type,
      options: options
    }, children);
  } // Default to false, so `undefined` will evaluate to the default here


  var renderContainerOnSingleChild = Boolean(props.renderContainerOnSingleChild);
  var nodes = blocks.map(serializeNode);

  if (renderContainerOnSingleChild || nodes.length > 1) {
    var containerProps = props.className ? {
      className: props.className
    } : {};
    return h(serializers.container, containerProps, nodes);
  }

  if (nodes[0]) {
    return nodes[0];
  }

  return typeof serializers.empty === 'function' ? h(serializers.empty) : serializers.empty;
}

function isList(block) {
  return block._type === 'list' && block.listItem;
}

function isListItem(block) {
  return block._type === 'block' && block.listItem;
}

function isSpan(block) {
  return typeof block === 'string' || block.marks || block._type === 'span';
}

module.exports = blocksToNodes;
//# sourceMappingURL=blocksToNodes.js.map

/***/ }),

/***/ 45428:
/***/ (function(module) {

"use strict";


var defaultMarks = ['strong', 'em', 'code', 'underline', 'strike-through'];

var buildMarksTree = function buildMarksTree(block) {
  var children = block.children,
      markDefs = block.markDefs;

  if (!children || !children.length) {
    return [];
  }

  var sortedMarks = children.map(sortMarksByOccurences);
  var rootNode = {
    _type: 'span',
    children: []
  };
  var nodeStack = [rootNode];
  children.forEach(function (span, i) {
    var marksNeeded = sortedMarks[i];

    if (!marksNeeded) {
      var lastNode = nodeStack[nodeStack.length - 1];
      lastNode.children.push(span);
      return;
    }

    var pos = 1; // Start at position one. Root is always plain and should never be removed. (?)

    if (nodeStack.length > 1) {
      for (pos; pos < nodeStack.length; pos++) {
        var mark = nodeStack[pos].markKey;
        var index = marksNeeded.indexOf(mark); // eslint-disable-next-line max-depth

        if (index === -1) {
          break;
        }

        marksNeeded.splice(index, 1);
      }
    } // Keep from beginning to first miss


    nodeStack = nodeStack.slice(0, pos); // Add needed nodes

    var currentNode = findLastParentNode(nodeStack);
    marksNeeded.forEach(function (mark) {
      var node = {
        _type: 'span',
        _key: span._key,
        children: [],
        mark: markDefs.find(function (def) {
          return def._key === mark;
        }) || mark,
        markKey: mark
      };
      currentNode.children.push(node);
      nodeStack.push(node);
      currentNode = node;
    }); // Split at newlines to make individual line chunks, but keep newline
    // characters as individual elements in the array. We use these characters
    // in the span serializer to trigger hard-break rendering

    if (isTextSpan(span)) {
      var lines = span.text.split('\n');

      for (var line = lines.length; line-- > 1;) {
        lines.splice(line, 0, '\n');
      }

      currentNode.children = currentNode.children.concat(lines);
    } else {
      currentNode.children = currentNode.children.concat(span);
    }
  });
  return rootNode.children;
}; // We want to sort all the marks of all the spans in the following order:
// 1. Marks that are shared amongst the most adjacent siblings
// 2. Non-default marks (links, custom metadata)
// 3. Built-in, plain marks (bold, emphasis, code etc)


function sortMarksByOccurences(span, i, spans) {
  if (!span.marks || span.marks.length === 0) {
    return span.marks || [];
  }

  var markOccurences = span.marks.reduce(function (occurences, mark) {
    occurences[mark] = occurences[mark] ? occurences[mark] + 1 : 1;

    for (var siblingIndex = i + 1; siblingIndex < spans.length; siblingIndex++) {
      var sibling = spans[siblingIndex];

      if (sibling.marks && Array.isArray(sibling.marks) && sibling.marks.indexOf(mark) !== -1) {
        occurences[mark]++;
      } else {
        break;
      }
    }

    return occurences;
  }, {});
  var sortByOccurence = sortMarks.bind(null, markOccurences); // Slicing because sort() mutates the input

  return span.marks.slice().sort(sortByOccurence);
}

function sortMarks(occurences, markA, markB) {
  var aOccurences = occurences[markA] || 0;
  var bOccurences = occurences[markB] || 0;

  if (aOccurences !== bOccurences) {
    return bOccurences - aOccurences;
  }

  var aDefaultPos = defaultMarks.indexOf(markA);
  var bDefaultPos = defaultMarks.indexOf(markB); // Sort default marks last

  if (aDefaultPos !== bDefaultPos) {
    return aDefaultPos - bDefaultPos;
  } // Sort other marks simply by key


  if (markA < markB) {
    return -1;
  } else if (markA > markB) {
    return 1;
  }

  return 0;
}

function isTextSpan(node) {
  return node._type === 'span' && typeof node.text === 'string' && (Array.isArray(node.marks) || typeof node.marks === 'undefined');
}

function findLastParentNode(nodes) {
  for (var i = nodes.length - 1; i >= 0; i--) {
    var node = nodes[i];

    if (node._type === 'span' && node.children) {
      return node;
    }
  }

  return undefined;
}

module.exports = buildMarksTree;
//# sourceMappingURL=buildMarksTree.js.map

/***/ }),

/***/ 97901:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var objectAssign = __webpack_require__(76493);

module.exports = function (blocks) {
  return blocks.map(function (block) {
    if (block._key) {
      return block;
    }

    return objectAssign({
      _key: getStaticKey(block)
    }, block);
  });
};

function getStaticKey(item) {
  return checksum(JSON.stringify(item)).toString(36).replace(/[^A-Za-z0-9]/g, '');
}
/* eslint-disable no-bitwise */


function checksum(str) {
  var hash = 0;
  var strlen = str.length;

  if (strlen === 0) {
    return hash;
  }

  for (var i = 0; i < strlen; i++) {
    hash = (hash << 5) - hash + str.charCodeAt(i);
    hash &= hash; // Convert to 32bit integer
  }

  return hash;
}
/* eslint-enable no-bitwise */
//# sourceMappingURL=generateKeys.js.map

/***/ }),

/***/ 7851:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var generateHelpUrl = __webpack_require__(49801);

var urlBuilder = __webpack_require__(63317);

var objectAssign = __webpack_require__(76493);

var enc = encodeURIComponent;
var materializeError = "You must either:\n  - Pass `projectId` and `dataset` to the block renderer\n  - Materialize images to include the `url` field.\n\nFor more information, see ".concat(generateHelpUrl('block-content-image-materializing'));

var getQueryString = function getQueryString(options) {
  var query = options.imageOptions;
  var keys = Object.keys(query);

  if (!keys.length) {
    return '';
  }

  var params = keys.map(function (key) {
    return "".concat(enc(key), "=").concat(enc(query[key]));
  });
  return "?".concat(params.join('&'));
};

var buildUrl = function buildUrl(props) {
  var node = props.node,
      options = props.options;
  var projectId = options.projectId,
      dataset = options.dataset;
  var asset = node.asset;

  if (!asset) {
    throw new Error('Image does not have required `asset` property');
  }

  if (asset.url) {
    return asset.url + getQueryString(options);
  }

  if (!projectId || !dataset) {
    throw new Error(materializeError);
  }

  var ref = asset._ref;

  if (!ref) {
    throw new Error('Invalid image reference in block, no `_ref` found on `asset`');
  }

  return urlBuilder(objectAssign({
    projectId: projectId,
    dataset: dataset
  }, options.imageOptions || {})).image(node).toString();
};

module.exports = buildUrl;
//# sourceMappingURL=getImageUrl.js.map

/***/ }),

/***/ 69249:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var getSerializers = __webpack_require__(92190);

var _blocksToNodes = __webpack_require__(2485);

var getImageUrl = __webpack_require__(7851);

var mergeSerializers = __webpack_require__(12905);

module.exports = {
  blocksToNodes: function blocksToNodes(renderNode, props, defaultSerializers, serializeSpan) {
    if (defaultSerializers) {
      return _blocksToNodes(renderNode, props, defaultSerializers, serializeSpan);
    } // Backwards-compatibility


    var serializers = getSerializers(renderNode);
    return _blocksToNodes(renderNode, props, serializers.defaultSerializers, serializers.serializeSpan);
  },
  getSerializers: getSerializers,
  getImageUrl: getImageUrl,
  mergeSerializers: mergeSerializers
};
//# sourceMappingURL=internals.js.map

/***/ }),

/***/ 12905:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var objectAssign = __webpack_require__(76493);

var isDefined = function isDefined(val) {
  return typeof val !== 'undefined';
}; // Recursively merge/replace default serializers with user-specified serializers


module.exports = function mergeSerializers(defaultSerializers, userSerializers) {
  return Object.keys(defaultSerializers).reduce(function (acc, key) {
    var type = _typeof(defaultSerializers[key]);

    if (type === 'function') {
      acc[key] = isDefined(userSerializers[key]) ? userSerializers[key] : defaultSerializers[key];
    } else if (type === 'object') {
      acc[key] = objectAssign({}, defaultSerializers[key], userSerializers[key]);
    } else {
      acc[key] = typeof userSerializers[key] === 'undefined' ? defaultSerializers[key] : userSerializers[key];
    }

    return acc;
  }, {});
};
//# sourceMappingURL=mergeSerializers.js.map

/***/ }),

/***/ 3054:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var objectAssign = __webpack_require__(76493);
/* eslint-disable max-depth, complexity */


function nestLists(blocks) {
  var mode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'html';
  var tree = [];
  var currentList;

  for (var i = 0; i < blocks.length; i++) {
    var block = blocks[i];

    if (!isListBlock(block)) {
      tree.push(block);
      currentList = null;
      continue;
    } // Start of a new list?


    if (!currentList) {
      currentList = listFromBlock(block);
      tree.push(currentList);
      continue;
    } // New list item within same list?


    if (blockMatchesList(block, currentList)) {
      currentList.children.push(block);
      continue;
    } // Different list props, are we going deeper?


    if (block.level > currentList.level) {
      var newList = listFromBlock(block);

      if (mode === 'html') {
        // Because HTML is kinda weird, nested lists needs to be nested within list items
        // So while you would think that we could populate the parent list with a new sub-list,
        // We actually have to target the last list element (child) of the parent.
        // However, at this point we need to be very careful - simply pushing to the list of children
        // will mutate the input, and we don't want to blindly clone the entire tree.
        // Clone the last child while adding our new list as the last child of it
        var lastListItem = lastChild(currentList);
        var newLastChild = objectAssign({}, lastListItem, {
          children: lastListItem.children.concat(newList)
        }); // Swap the last child

        currentList.children[currentList.children.length - 1] = newLastChild;
      } else {
        currentList.children.push(newList);
      } // Set the newly created, deeper list as the current


      currentList = newList;
      continue;
    } // Different list props, are we going back up the tree?


    if (block.level < currentList.level) {
      // Current list has ended, and we need to hook up with a parent of the same level and type
      var match = findListMatching(tree[tree.length - 1], block);

      if (match) {
        currentList = match;
        currentList.children.push(block);
        continue;
      } // Similar parent can't be found, assume new list


      currentList = listFromBlock(block);
      tree.push(currentList);
      continue;
    } // Different list props, different list style?


    if (block.listItem !== currentList.listItem) {
      var _match = findListMatching(tree[tree.length - 1], {
        level: block.level
      });

      if (_match && _match.listItem === block.listItem) {
        currentList = _match;
        currentList.children.push(block);
        continue;
      } else {
        currentList = listFromBlock(block);
        tree.push(currentList);
        continue;
      }
    } // eslint-disable-next-line no-console


    console.warn('Unknown state encountered for block', block);
    tree.push(block);
  }

  return tree;
}

function isListBlock(block) {
  return Boolean(block.listItem);
}

function blockMatchesList(block, list) {
  return block.level === list.level && block.listItem === list.listItem;
}

function listFromBlock(block) {
  return {
    _type: 'list',
    _key: "".concat(block._key, "-parent"),
    level: block.level,
    listItem: block.listItem,
    children: [block]
  };
}

function lastChild(block) {
  return block.children && block.children[block.children.length - 1];
}

function findListMatching(rootNode, matching) {
  var filterOnType = typeof matching.listItem === 'string';

  if (rootNode._type === 'list' && rootNode.level === matching.level && filterOnType && rootNode.listItem === matching.listItem) {
    return rootNode;
  }

  var node = lastChild(rootNode);

  if (!node) {
    return false;
  }

  return findListMatching(node, matching);
}

module.exports = nestLists;
//# sourceMappingURL=nestLists.js.map

/***/ }),

/***/ 92190:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var objectAssign = __webpack_require__(76493);

var getImageUrl = __webpack_require__(7851);

module.exports = function (h, serializerOpts) {
  var serializeOptions = serializerOpts || {
    useDashedStyles: false // Low-level block serializer

  };

  function BlockSerializer(props) {
    var node = props.node,
        serializers = props.serializers,
        options = props.options,
        isInline = props.isInline,
        children = props.children;
    var blockType = node._type;
    var serializer = serializers.types[blockType];

    if (!serializer) {
      throw new Error("Unknown block type \"".concat(blockType, "\", please specify a serializer for it in the `serializers.types` prop"));
    }

    return h(serializer, {
      node: node,
      options: options,
      isInline: isInline
    }, children);
  } // Low-level span serializer


  function SpanSerializer(props) {
    var _props$node = props.node,
        mark = _props$node.mark,
        children = _props$node.children;
    var isPlain = typeof mark === 'string';
    var markType = isPlain ? mark : mark._type;
    var serializer = props.serializers.marks[markType];

    if (!serializer) {
      // @todo Revert back to throwing errors?
      // eslint-disable-next-line no-console
      console.warn("Unknown mark type \"".concat(markType, "\", please specify a serializer for it in the `serializers.marks` prop"));
      return h(props.serializers.markFallback, null, children);
    }

    return h(serializer, props.node, children);
  } // Low-level list serializer


  function ListSerializer(props) {
    var tag = props.type === 'bullet' ? 'ul' : 'ol';
    return h(tag, null, props.children);
  } // Low-level list item serializer


  function ListItemSerializer(props) {
    var children = !props.node.style || props.node.style === 'normal' ? // Don't wrap plain text in paragraphs inside of a list item
    props.children : // But wrap any other style in whatever the block serializer says to use
    h(props.serializers.types.block, props, props.children);
    return h('li', null, children);
  } // Renderer of an actual block of type `block`. Confusing, we know.


  function BlockTypeSerializer(props) {
    var style = props.node.style || 'normal';

    if (/^h\d/.test(style)) {
      return h(style, null, props.children);
    }

    return style === 'blockquote' ? h('blockquote', null, props.children) : h('p', null, props.children);
  } // Serializers for things that can be directly attributed to a tag without any props
  // We use partial application to do this, passing the tag name as the first argument


  function RawMarkSerializer(tag, props) {
    return h(tag, null, props.children);
  }

  function UnderlineSerializer(props) {
    var style = serializeOptions.useDashedStyles ? {
      'text-decoration': 'underline'
    } : {
      textDecoration: 'underline'
    };
    return h('span', {
      style: style
    }, props.children);
  }

  function StrikeThroughSerializer(props) {
    return h('del', null, props.children);
  }

  function LinkSerializer(props) {
    return h('a', {
      href: props.mark.href
    }, props.children);
  }

  function ImageSerializer(props) {
    if (!props.node.asset) {
      return null;
    }

    var img = h('img', {
      src: getImageUrl(props)
    });
    return props.isInline ? img : h('figure', null, img);
  } // Serializer that recursively calls itself, producing a hyperscript tree of spans


  function serializeSpan(span, serializers, index, options) {
    if (span === '\n' && serializers.hardBreak) {
      return h(serializers.hardBreak, {
        key: "hb-".concat(index)
      });
    }

    if (typeof span === 'string') {
      return serializers.text ? h(serializers.text, {
        key: "text-".concat(index)
      }, span) : span;
    }

    var children;

    if (span.children) {
      children = {
        children: span.children.map(function (child, i) {
          return options.serializeNode(child, i, span.children, true);
        })
      };
    }

    var serializedNode = objectAssign({}, span, children);
    return h(serializers.span, {
      key: span._key || "span-".concat(index),
      node: serializedNode,
      serializers: serializers
    });
  }

  var HardBreakSerializer = function HardBreakSerializer() {
    return h('br');
  };

  var defaultMarkSerializers = {
    strong: RawMarkSerializer.bind(null, 'strong'),
    em: RawMarkSerializer.bind(null, 'em'),
    code: RawMarkSerializer.bind(null, 'code'),
    underline: UnderlineSerializer,
    'strike-through': StrikeThroughSerializer,
    link: LinkSerializer
  };
  var defaultSerializers = {
    // Common overrides
    types: {
      block: BlockTypeSerializer,
      image: ImageSerializer
    },
    marks: defaultMarkSerializers,
    // Less common overrides
    list: ListSerializer,
    listItem: ListItemSerializer,
    block: BlockSerializer,
    span: SpanSerializer,
    hardBreak: HardBreakSerializer,
    // Container element
    container: 'div',
    // When we can't resolve the mark properly, use this renderer as the container
    markFallback: 'span',
    // Allow overriding text renderer, but leave undefined to just use plain strings by default
    text: undefined,
    // Empty nodes (React uses null, hyperscript with empty strings)
    empty: ''
  };
  return {
    defaultSerializers: defaultSerializers,
    serializeSpan: serializeSpan
  };
};
//# sourceMappingURL=serializers.js.map

/***/ }),

/***/ 49801:
/***/ (function(module) {

var baseUrl = 'https://docs.sanity.io/help/'

module.exports = function generateHelpUrl(slug) {
  return baseUrl + slug
}


/***/ }),

/***/ 57178:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(27378);
var PropTypes = __webpack_require__(23615);
var internals = __webpack_require__(27894);

var _require = __webpack_require__(39015),
    serializers = _require.serializers,
    serializeSpan = _require.serializeSpan,
    renderProps = _require.renderProps;

var getImageUrl = internals.getImageUrl,
    blocksToNodes = internals.blocksToNodes,
    mergeSerializers = internals.mergeSerializers;

var renderNode = React.createElement;

var SanityBlockContent = function SanityBlockContent(props) {
  var customSerializers = mergeSerializers(SanityBlockContent.defaultSerializers, props.serializers);

  var blockProps = Object.assign({}, renderProps, props, {
    serializers: customSerializers,
    blocks: props.blocks || []
  });

  return blocksToNodes(renderNode, blockProps, serializers, serializeSpan);
};

// Expose default serializers to the user
SanityBlockContent.defaultSerializers = serializers;

// Expose logic for building image URLs from an image reference/node
SanityBlockContent.getImageUrl = getImageUrl;

SanityBlockContent.propTypes = {
  className: PropTypes.string,
  renderContainerOnSingleChild: PropTypes.bool,

  // When rendering images, we need project id and dataset, unless images are materialized
  projectId: PropTypes.string,
  dataset: PropTypes.string,
  imageOptions: PropTypes.object,

  serializers: PropTypes.shape({
    // Common overrides
    types: PropTypes.object,
    marks: PropTypes.object,

    // Less common overrides
    list: PropTypes.func,
    listItem: PropTypes.func,

    // Low-level serializers
    block: PropTypes.func,
    span: PropTypes.func
  }),

  blocks: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.shape({
    _type: PropTypes.string.isRequired
  })), PropTypes.shape({
    _type: PropTypes.string.isRequired
  })]).isRequired
};

SanityBlockContent.defaultProps = {
  renderContainerOnSingleChild: false,
  serializers: {},
  imageOptions: {}
};

module.exports = SanityBlockContent;
//# sourceMappingURL=BlockContent.js.map

/***/ }),

/***/ 39015:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(27378);

var _require = __webpack_require__(27894),
    getSerializers = _require.getSerializers;

var renderNode = React.createElement;

var _getSerializers = getSerializers(renderNode),
    defaultSerializers = _getSerializers.defaultSerializers,
    serializeSpan = _getSerializers.serializeSpan;

module.exports = {
  serializeSpan: serializeSpan,
  serializers: defaultSerializers,
  renderProps: { nestMarks: true }
};
//# sourceMappingURL=dom.js.map

/***/ }),

/***/ 63317:
/***/ (function(module) {

(function (global, factory) {
   true ? module.exports = factory() :
  0;
}(this, (function () {
  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }

  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }

  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;

    for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

    return arr2;
  }

  function _createForOfIteratorHelperLoose(o) {
    var i = 0;

    if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
      if (Array.isArray(o) || (o = _unsupportedIterableToArray(o))) return function () {
        if (i >= o.length) return {
          done: true
        };
        return {
          done: false,
          value: o[i++]
        };
      };
      throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }

    i = o[Symbol.iterator]();
    return i.next.bind(i);
  }

  var example = 'image-Tb9Ew8CXIwaY6R1kjMvI0uRR-2000x3000-jpg';
  function parseAssetId(ref) {
    var _ref$split = ref.split('-'),
        id = _ref$split[1],
        dimensionString = _ref$split[2],
        format = _ref$split[3];

    if (!id || !dimensionString || !format) {
      throw new Error("Malformed asset _ref '" + ref + "'. Expected an id like \"" + example + "\".");
    }

    var _dimensionString$spli = dimensionString.split('x'),
        imgWidthStr = _dimensionString$spli[0],
        imgHeightStr = _dimensionString$spli[1];

    var width = +imgWidthStr;
    var height = +imgHeightStr;
    var isValidAssetId = isFinite(width) && isFinite(height);

    if (!isValidAssetId) {
      throw new Error("Malformed asset _ref '" + ref + "'. Expected an id like \"" + example + "\".");
    }

    return {
      id: id,
      width: width,
      height: height,
      format: format
    };
  }

  var isRef = function isRef(src) {
    var source = src;
    return source ? typeof source._ref === 'string' : false;
  };

  var isAsset = function isAsset(src) {
    var source = src;
    return source ? typeof source._id === 'string' : false;
  };

  var isAssetStub = function isAssetStub(src) {
    var source = src;
    return source && source.asset ? typeof source.asset.url === 'string' : false;
  };

  function parseSource(source) {
    if (!source) {
      return null;
    }

    var image;

    if (typeof source === 'string' && isUrl(source)) {
      image = {
        asset: {
          _ref: urlToId(source)
        }
      };
    } else if (typeof source === 'string') {
      image = {
        asset: {
          _ref: source
        }
      };
    } else if (isRef(source)) {
      image = {
        asset: source
      };
    } else if (isAsset(source)) {
      image = {
        asset: {
          _ref: source._id || ''
        }
      };
    } else if (isAssetStub(source)) {
      image = {
        asset: {
          _ref: urlToId(source.asset.url)
        }
      };
    } else if (typeof source.asset === 'object') {
      image = source;
    } else {
      return null;
    }

    var img = source;

    if (img.crop) {
      image.crop = img.crop;
    }

    if (img.hotspot) {
      image.hotspot = img.hotspot;
    }

    return applyDefaults(image);
  }

  function isUrl(url) {
    return /^https?:\/\//.test("" + url);
  }

  function urlToId(url) {
    var parts = url.split('/').slice(-1);
    return ("image-" + parts[0]).replace(/\.([a-z]+)$/, '-$1');
  }

  function applyDefaults(image) {
    if (image.crop && image.hotspot) {
      return image;
    }

    var result = _extends({}, image);

    if (!result.crop) {
      result.crop = {
        left: 0,
        top: 0,
        bottom: 0,
        right: 0
      };
    }

    if (!result.hotspot) {
      result.hotspot = {
        x: 0.5,
        y: 0.5,
        height: 1.0,
        width: 1.0
      };
    }

    return result;
  }

  var SPEC_NAME_TO_URL_NAME_MAPPINGS = [['width', 'w'], ['height', 'h'], ['format', 'fm'], ['download', 'dl'], ['blur', 'blur'], ['sharpen', 'sharp'], ['invert', 'invert'], ['orientation', 'or'], ['minHeight', 'min-h'], ['maxHeight', 'max-h'], ['minWidth', 'min-w'], ['maxWidth', 'max-w'], ['quality', 'q'], ['fit', 'fit'], ['crop', 'crop'], ['saturation', 'sat'], ['auto', 'auto'], ['dpr', 'dpr'], ['pad', 'pad']];
  function urlForImage(options) {
    var spec = _extends({}, options || {});

    var source = spec.source;
    delete spec.source;
    var image = parseSource(source);

    if (!image) {
      return null;
    }

    var id = image.asset._ref || image.asset._id || '';
    var asset = parseAssetId(id);
    var cropLeft = Math.round(image.crop.left * asset.width);
    var cropTop = Math.round(image.crop.top * asset.height);
    var crop = {
      left: cropLeft,
      top: cropTop,
      width: Math.round(asset.width - image.crop.right * asset.width - cropLeft),
      height: Math.round(asset.height - image.crop.bottom * asset.height - cropTop)
    };
    var hotSpotVerticalRadius = image.hotspot.height * asset.height / 2;
    var hotSpotHorizontalRadius = image.hotspot.width * asset.width / 2;
    var hotSpotCenterX = image.hotspot.x * asset.width;
    var hotSpotCenterY = image.hotspot.y * asset.height;
    var hotspot = {
      left: hotSpotCenterX - hotSpotHorizontalRadius,
      top: hotSpotCenterY - hotSpotVerticalRadius,
      right: hotSpotCenterX + hotSpotHorizontalRadius,
      bottom: hotSpotCenterY + hotSpotVerticalRadius
    };

    if (!(spec.rect || spec.focalPoint || spec.ignoreImageParams || spec.crop)) {
      spec = _extends(_extends({}, spec), fit({
        crop: crop,
        hotspot: hotspot
      }, spec));
    }

    return specToImageUrl(_extends(_extends({}, spec), {}, {
      asset: asset
    }));
  }

  function specToImageUrl(spec) {
    var cdnUrl = spec.baseUrl || 'https://cdn.sanity.io';
    var filename = spec.asset.id + "-" + spec.asset.width + "x" + spec.asset.height + "." + spec.asset.format;
    var baseUrl = cdnUrl + "/images/" + spec.projectId + "/" + spec.dataset + "/" + filename;
    var params = [];

    if (spec.rect) {
      var _spec$rect = spec.rect,
          left = _spec$rect.left,
          top = _spec$rect.top,
          width = _spec$rect.width,
          height = _spec$rect.height;
      var isEffectiveCrop = left !== 0 || top !== 0 || height !== spec.asset.height || width !== spec.asset.width;

      if (isEffectiveCrop) {
        params.push("rect=" + left + "," + top + "," + width + "," + height);
      }
    }

    if (spec.bg) {
      params.push("bg=" + spec.bg);
    }

    if (spec.focalPoint) {
      params.push("fp-x=" + spec.focalPoint.x);
      params.push("fp-y=" + spec.focalPoint.y);
    }

    var flip = [spec.flipHorizontal && 'h', spec.flipVertical && 'v'].filter(Boolean).join('');

    if (flip) {
      params.push("flip=" + flip);
    }

    SPEC_NAME_TO_URL_NAME_MAPPINGS.forEach(function (mapping) {
      var specName = mapping[0],
          param = mapping[1];

      if (typeof spec[specName] !== 'undefined') {
        params.push(param + "=" + encodeURIComponent(spec[specName]));
      } else if (typeof spec[param] !== 'undefined') {
        params.push(param + "=" + encodeURIComponent(spec[param]));
      }
    });

    if (params.length === 0) {
      return baseUrl;
    }

    return baseUrl + "?" + params.join('&');
  }

  function fit(source, spec) {
    var cropRect;
    var imgWidth = spec.width;
    var imgHeight = spec.height;

    if (!(imgWidth && imgHeight)) {
      return {
        width: imgWidth,
        height: imgHeight,
        rect: source.crop
      };
    }

    var crop = source.crop;
    var hotspot = source.hotspot;
    var desiredAspectRatio = imgWidth / imgHeight;
    var cropAspectRatio = crop.width / crop.height;

    if (cropAspectRatio > desiredAspectRatio) {
      var height = crop.height;
      var width = height * desiredAspectRatio;
      var top = crop.top;
      var hotspotXCenter = (hotspot.right - hotspot.left) / 2 + hotspot.left;
      var left = hotspotXCenter - width / 2;

      if (left < crop.left) {
        left = crop.left;
      } else if (left + width > crop.left + crop.width) {
        left = crop.left + crop.width - width;
      }

      cropRect = {
        left: Math.round(left),
        top: Math.round(top),
        width: Math.round(width),
        height: Math.round(height)
      };
    } else {
      var _width = crop.width;

      var _height = _width / desiredAspectRatio;

      var _left = crop.left;
      var hotspotYCenter = (hotspot.bottom - hotspot.top) / 2 + hotspot.top;

      var _top = hotspotYCenter - _height / 2;

      if (_top < crop.top) {
        _top = crop.top;
      } else if (_top + _height > crop.top + crop.height) {
        _top = crop.top + crop.height - _height;
      }

      cropRect = {
        left: Math.max(0, Math.floor(_left)),
        top: Math.max(0, Math.floor(_top)),
        width: Math.round(_width),
        height: Math.round(_height)
      };
    }

    return {
      width: imgWidth,
      height: imgHeight,
      rect: cropRect
    };
  }

  var validFits = ['clip', 'crop', 'fill', 'fillmax', 'max', 'scale', 'min'];
  var validCrops = ['top', 'bottom', 'left', 'right', 'center', 'focalpoint', 'entropy'];
  var validAutoModes = ['format'];

  function isSanityClientLike(client) {
    return client ? typeof client.clientConfig === 'object' : false;
  }

  function rewriteSpecName(key) {
    var specs = SPEC_NAME_TO_URL_NAME_MAPPINGS;

    for (var _iterator = _createForOfIteratorHelperLoose(specs), _step; !(_step = _iterator()).done;) {
      var entry = _step.value;
      var specName = entry[0],
          param = entry[1];

      if (key === specName || key === param) {
        return specName;
      }
    }

    return key;
  }

  function urlBuilder(options) {
    var client = options;

    if (isSanityClientLike(client)) {
      var _client$clientConfig = client.clientConfig,
          apiUrl = _client$clientConfig.apiHost,
          projectId = _client$clientConfig.projectId,
          dataset = _client$clientConfig.dataset;
      var apiHost = apiUrl || 'https://api.sanity.io';
      return new ImageUrlBuilder(null, {
        baseUrl: apiHost.replace(/^https:\/\/api\./, 'https://cdn.'),
        projectId: projectId,
        dataset: dataset
      });
    }

    return new ImageUrlBuilder(null, options);
  }
  var ImageUrlBuilder = /*#__PURE__*/function () {
    function ImageUrlBuilder(parent, options) {
      this.options = parent ? _extends(_extends({}, parent.options || {}), options || {}) : _extends({}, options || {});
    }

    var _proto = ImageUrlBuilder.prototype;

    _proto.withOptions = function withOptions(options) {
      var baseUrl = options.baseUrl || this.options.baseUrl;
      var newOptions = {
        baseUrl: baseUrl
      };

      for (var key in options) {
        if (options.hasOwnProperty(key)) {
          var specKey = rewriteSpecName(key);
          newOptions[specKey] = options[key];
        }
      }

      return new ImageUrlBuilder(this, _extends({
        baseUrl: baseUrl
      }, newOptions));
    };

    _proto.image = function image(source) {
      return this.withOptions({
        source: source
      });
    };

    _proto.dataset = function dataset(_dataset) {
      return this.withOptions({
        dataset: _dataset
      });
    };

    _proto.projectId = function projectId(_projectId) {
      return this.withOptions({
        projectId: _projectId
      });
    };

    _proto.bg = function bg(_bg) {
      return this.withOptions({
        bg: _bg
      });
    };

    _proto.dpr = function dpr(_dpr) {
      return this.withOptions({
        dpr: _dpr
      });
    };

    _proto.width = function width(_width) {
      return this.withOptions({
        width: _width
      });
    };

    _proto.height = function height(_height) {
      return this.withOptions({
        height: _height
      });
    };

    _proto.focalPoint = function focalPoint(x, y) {
      return this.withOptions({
        focalPoint: {
          x: x,
          y: y
        }
      });
    };

    _proto.maxWidth = function maxWidth(_maxWidth) {
      return this.withOptions({
        maxWidth: _maxWidth
      });
    };

    _proto.minWidth = function minWidth(_minWidth) {
      return this.withOptions({
        minWidth: _minWidth
      });
    };

    _proto.maxHeight = function maxHeight(_maxHeight) {
      return this.withOptions({
        maxHeight: _maxHeight
      });
    };

    _proto.minHeight = function minHeight(_minHeight) {
      return this.withOptions({
        minHeight: _minHeight
      });
    };

    _proto.size = function size(width, height) {
      return this.withOptions({
        width: width,
        height: height
      });
    };

    _proto.blur = function blur(_blur) {
      return this.withOptions({
        blur: _blur
      });
    };

    _proto.sharpen = function sharpen(_sharpen) {
      return this.withOptions({
        sharpen: _sharpen
      });
    };

    _proto.rect = function rect(left, top, width, height) {
      return this.withOptions({
        rect: {
          left: left,
          top: top,
          width: width,
          height: height
        }
      });
    };

    _proto.format = function format(_format) {
      return this.withOptions({
        format: _format
      });
    };

    _proto.invert = function invert(_invert) {
      return this.withOptions({
        invert: _invert
      });
    };

    _proto.orientation = function orientation(_orientation) {
      return this.withOptions({
        orientation: _orientation
      });
    };

    _proto.quality = function quality(_quality) {
      return this.withOptions({
        quality: _quality
      });
    };

    _proto.forceDownload = function forceDownload(download) {
      return this.withOptions({
        download: download
      });
    };

    _proto.flipHorizontal = function flipHorizontal() {
      return this.withOptions({
        flipHorizontal: true
      });
    };

    _proto.flipVertical = function flipVertical() {
      return this.withOptions({
        flipVertical: true
      });
    };

    _proto.ignoreImageParams = function ignoreImageParams() {
      return this.withOptions({
        ignoreImageParams: true
      });
    };

    _proto.fit = function fit(value) {
      if (validFits.indexOf(value) === -1) {
        throw new Error("Invalid fit mode \"" + value + "\"");
      }

      return this.withOptions({
        fit: value
      });
    };

    _proto.crop = function crop(value) {
      if (validCrops.indexOf(value) === -1) {
        throw new Error("Invalid crop mode \"" + value + "\"");
      }

      return this.withOptions({
        crop: value
      });
    };

    _proto.saturation = function saturation(_saturation) {
      return this.withOptions({
        saturation: _saturation
      });
    };

    _proto.auto = function auto(value) {
      if (validAutoModes.indexOf(value) === -1) {
        throw new Error("Invalid auto mode \"" + value + "\"");
      }

      return this.withOptions({
        auto: value
      });
    };

    _proto.pad = function pad(_pad) {
      return this.withOptions({
        pad: _pad
      });
    };

    _proto.url = function url() {
      return urlForImage(this.options);
    };

    _proto.toString = function toString() {
      return this.url();
    };

    return ImageUrlBuilder;
  }();

  return urlBuilder;

})));
//# sourceMappingURL=image-url.umd.js.map


/***/ }),

/***/ 56921:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "R": function() { return /* binding */ BrowserClient; }
});

// EXTERNAL MODULE: ../node_modules/@sentry/utils/esm/dsn.js
var esm_dsn = __webpack_require__(73166);
// EXTERNAL MODULE: ../node_modules/@sentry/utils/esm/logger.js
var logger = __webpack_require__(86922);
// EXTERNAL MODULE: ../node_modules/@sentry/utils/esm/misc.js
var misc = __webpack_require__(67451);
// EXTERNAL MODULE: ../node_modules/@sentry/utils/esm/is.js
var is = __webpack_require__(66885);
// EXTERNAL MODULE: ../node_modules/@sentry/utils/esm/syncpromise.js
var syncpromise = __webpack_require__(48894);
// EXTERNAL MODULE: ../node_modules/@sentry/utils/esm/envelope.js
var envelope = __webpack_require__(73285);
// EXTERNAL MODULE: ../node_modules/@sentry/utils/esm/error.js
var error = __webpack_require__(44502);
// EXTERNAL MODULE: ../node_modules/@sentry/core/esm/api.js
var api = __webpack_require__(66485);
;// CONCATENATED MODULE: ../node_modules/@sentry/core/esm/envelope.js


/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/
function enhanceEventWithSdkInfo(event, sdkInfo) {
  if (!sdkInfo) {
    return event;
  }
  event.sdk = event.sdk || {};
  event.sdk.name = event.sdk.name || sdkInfo.name;
  event.sdk.version = event.sdk.version || sdkInfo.version;
  event.sdk.integrations = [...(event.sdk.integrations || []), ...(sdkInfo.integrations || [])];
  event.sdk.packages = [...(event.sdk.packages || []), ...(sdkInfo.packages || [])];
  return event;
}

/** Creates an envelope from a Session */
function createSessionEnvelope(
  session,
  dsn,
  metadata,
  tunnel,
) {
  const sdkInfo = (0,envelope/* getSdkMetadataForEnvelopeHeader */.HY)(metadata);
  const envelopeHeaders = {
    sent_at: new Date().toISOString(),
    ...(sdkInfo && { sdk: sdkInfo }),
    ...(!!tunnel && { dsn: (0,esm_dsn/* dsnToString */.RA)(dsn) }),
  };

  const envelopeItem =
    'aggregates' in session ? [{ type: 'sessions' }, session] : [{ type: 'session' }, session.toJSON()];

  return (0,envelope/* createEnvelope */.Jd)(envelopeHeaders, [envelopeItem]);
}

/**
 * Create an Envelope from an event.
 */
function createEventEnvelope(
  event,
  dsn,
  metadata,
  tunnel,
) {
  const sdkInfo = (0,envelope/* getSdkMetadataForEnvelopeHeader */.HY)(metadata);

  /*
    Note: Due to TS, event.type may be `replay_event`, theoretically.
    In practice, we never call `createEventEnvelope` with `replay_event` type,
    and we'd have to adjut a looot of types to make this work properly.
    We want to avoid casting this around, as that could lead to bugs (e.g. when we add another type)
    So the safe choice is to really guard against the replay_event type here.
  */
  const eventType = event.type && event.type !== 'replay_event' ? event.type : 'event';

  enhanceEventWithSdkInfo(event, metadata && metadata.sdk);

  const envelopeHeaders = (0,envelope/* createEventEnvelopeHeaders */.Cd)(event, sdkInfo, tunnel, dsn);

  // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
  // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
  // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
  // of this `delete`, lest we miss putting it back in the next time the property is in use.)
  delete event.sdkProcessingMetadata;

  const eventItem = [{ type: eventType }, event];
  return (0,envelope/* createEnvelope */.Jd)(envelopeHeaders, [eventItem]);
}


//# sourceMappingURL=envelope.js.map

// EXTERNAL MODULE: ../node_modules/@sentry/core/esm/integration.js
var esm_integration = __webpack_require__(99354);
// EXTERNAL MODULE: ../node_modules/@sentry/core/esm/session.js
var esm_session = __webpack_require__(89015);
// EXTERNAL MODULE: ../node_modules/@sentry/core/esm/utils/prepareEvent.js
var prepareEvent = __webpack_require__(53010);
;// CONCATENATED MODULE: ../node_modules/@sentry/core/esm/baseclient.js







const ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";

/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event, it is passed through
 * {@link BaseClient._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(options);
 *   }
 *
 *   // ...
 * }
 */
class BaseClient {
  /** Options passed to the SDK. */

  /** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. */

  /** Array of set up integrations. */
   __init() {this._integrations = {};}

  /** Indicates whether this client's integrations have been set up. */
   __init2() {this._integrationsInitialized = false;}

  /** Number of calls being processed */
   __init3() {this._numProcessing = 0;}

  /** Holds flushable  */
   __init4() {this._outcomes = {};}

  // eslint-disable-next-line @typescript-eslint/ban-types
   __init5() {this._hooks = {};}

  /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */
   constructor(options) {BaseClient.prototype.__init.call(this);BaseClient.prototype.__init2.call(this);BaseClient.prototype.__init3.call(this);BaseClient.prototype.__init4.call(this);BaseClient.prototype.__init5.call(this);
    this._options = options;

    if (options.dsn) {
      this._dsn = (0,esm_dsn/* makeDsn */.vK)(options.dsn);
    } else {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.warn */.kg.warn('No DSN provided, client will not do anything.');
    }

    if (this._dsn) {
      const url = (0,api/* getEnvelopeEndpointWithUrlEncodedAuth */.U)(this._dsn, options);
      this._transport = options.transport({
        recordDroppedEvent: this.recordDroppedEvent.bind(this),
        ...options.transportOptions,
        url,
      });
    }
  }

  /**
   * @inheritDoc
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
   captureException(exception, hint, scope) {
    // ensure we haven't captured this very object before
    if ((0,misc/* checkOrSetAlreadyCaught */.YO)(exception)) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log(ALREADY_SEEN_ERROR);
      return;
    }

    let eventId = hint && hint.event_id;

    this._process(
      this.eventFromException(exception, hint)
        .then(event => this._captureEvent(event, hint, scope))
        .then(result => {
          eventId = result;
        }),
    );

    return eventId;
  }

  /**
   * @inheritDoc
   */
   captureMessage(
    message,
    // eslint-disable-next-line deprecation/deprecation
    level,
    hint,
    scope,
  ) {
    let eventId = hint && hint.event_id;

    const promisedEvent = (0,is/* isPrimitive */.pt)(message)
      ? this.eventFromMessage(String(message), level, hint)
      : this.eventFromException(message, hint);

    this._process(
      promisedEvent
        .then(event => this._captureEvent(event, hint, scope))
        .then(result => {
          eventId = result;
        }),
    );

    return eventId;
  }

  /**
   * @inheritDoc
   */
   captureEvent(event, hint, scope) {
    // ensure we haven't captured this very object before
    if (hint && hint.originalException && (0,misc/* checkOrSetAlreadyCaught */.YO)(hint.originalException)) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log(ALREADY_SEEN_ERROR);
      return;
    }

    let eventId = hint && hint.event_id;

    this._process(
      this._captureEvent(event, hint, scope).then(result => {
        eventId = result;
      }),
    );

    return eventId;
  }

  /**
   * @inheritDoc
   */
   captureSession(session) {
    if (!this._isEnabled()) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.warn */.kg.warn('SDK not enabled, will not capture session.');
      return;
    }

    if (!(typeof session.release === 'string')) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.warn */.kg.warn('Discarded session because of missing or non-string release');
    } else {
      this.sendSession(session);
      // After sending, we set init false to indicate it's not the first occurrence
      (0,esm_session/* updateSession */.CT)(session, { init: false });
    }
  }

  /**
   * @inheritDoc
   */
   getDsn() {
    return this._dsn;
  }

  /**
   * @inheritDoc
   */
   getOptions() {
    return this._options;
  }

  /**
   * @see SdkMetadata in @sentry/types
   *
   * @return The metadata of the SDK
   */
   getSdkMetadata() {
    return this._options._metadata;
  }

  /**
   * @inheritDoc
   */
   getTransport() {
    return this._transport;
  }

  /**
   * @inheritDoc
   */
   flush(timeout) {
    const transport = this._transport;
    if (transport) {
      return this._isClientDoneProcessing(timeout).then(clientFinished => {
        return transport.flush(timeout).then(transportFlushed => clientFinished && transportFlushed);
      });
    } else {
      return (0,syncpromise/* resolvedSyncPromise */.WD)(true);
    }
  }

  /**
   * @inheritDoc
   */
   close(timeout) {
    return this.flush(timeout).then(result => {
      this.getOptions().enabled = false;
      return result;
    });
  }

  /**
   * Sets up the integrations
   */
   setupIntegrations() {
    if (this._isEnabled() && !this._integrationsInitialized) {
      this._integrations = (0,esm_integration/* setupIntegrations */.q4)(this._options.integrations);
      this._integrationsInitialized = true;
    }
  }

  /**
   * Gets an installed integration by its `id`.
   *
   * @returns The installed integration or `undefined` if no integration with that `id` was installed.
   */
   getIntegrationById(integrationId) {
    return this._integrations[integrationId];
  }

  /**
   * @inheritDoc
   */
   getIntegration(integration) {
    try {
      return (this._integrations[integration.id] ) || null;
    } catch (_oO) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.warn */.kg.warn(`Cannot retrieve integration ${integration.id} from the current Client`);
      return null;
    }
  }

  /**
   * @inheritDoc
   */
   addIntegration(integration) {
    (0,esm_integration/* setupIntegration */.m7)(integration, this._integrations);
  }

  /**
   * @inheritDoc
   */
   sendEvent(event, hint = {}) {
    if (this._dsn) {
      let env = createEventEnvelope(event, this._dsn, this._options._metadata, this._options.tunnel);

      for (const attachment of hint.attachments || []) {
        env = (0,envelope/* addItemToEnvelope */.BO)(
          env,
          (0,envelope/* createAttachmentEnvelopeItem */.zQ)(
            attachment,
            this._options.transportOptions && this._options.transportOptions.textEncoder,
          ),
        );
      }

      const promise = this._sendEnvelope(env);
      if (promise) {
        promise.then(sendResponse => this.emit('afterSendEvent', event, sendResponse), null);
      }
    }
  }

  /**
   * @inheritDoc
   */
   sendSession(session) {
    if (this._dsn) {
      const env = createSessionEnvelope(session, this._dsn, this._options._metadata, this._options.tunnel);
      void this._sendEnvelope(env);
    }
  }

  /**
   * @inheritDoc
   */
   recordDroppedEvent(reason, category, _event) {
    // Note: we use `event` in replay, where we overwrite this hook.

    if (this._options.sendClientReports) {
      // We want to track each category (error, transaction, session, replay_event) separately
      // but still keep the distinction between different type of outcomes.
      // We could use nested maps, but it's much easier to read and type this way.
      // A correct type for map-based implementation if we want to go that route
      // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
      // With typescript 4.1 we could even use template literal types
      const key = `${reason}:${category}`;
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log(`Adding outcome: "${key}"`);

      // The following works because undefined + 1 === NaN and NaN is falsy
      this._outcomes[key] = this._outcomes[key] + 1 || 1;
    }
  }

  // Keep on() & emit() signatures in sync with types' client.ts interface

  /** @inheritdoc */

  /** @inheritdoc */
   on(hook, callback) {
    if (!this._hooks[hook]) {
      this._hooks[hook] = [];
    }

    // @ts-ignore We assue the types are correct
    this._hooks[hook].push(callback);
  }

  /** @inheritdoc */

  /** @inheritdoc */
   emit(hook, ...rest) {
    if (this._hooks[hook]) {
      // @ts-ignore we cannot enforce the callback to match the hook
      this._hooks[hook].forEach(callback => callback(...rest));
    }
  }

  /** Updates existing session based on the provided event */
   _updateSessionFromEvent(session, event) {
    let crashed = false;
    let errored = false;
    const exceptions = event.exception && event.exception.values;

    if (exceptions) {
      errored = true;

      for (const ex of exceptions) {
        const mechanism = ex.mechanism;
        if (mechanism && mechanism.handled === false) {
          crashed = true;
          break;
        }
      }
    }

    // A session is updated and that session update is sent in only one of the two following scenarios:
    // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
    // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
    const sessionNonTerminal = session.status === 'ok';
    const shouldUpdateAndSend = (sessionNonTerminal && session.errors === 0) || (sessionNonTerminal && crashed);

    if (shouldUpdateAndSend) {
      (0,esm_session/* updateSession */.CT)(session, {
        ...(crashed && { status: 'crashed' }),
        errors: session.errors || Number(errored || crashed),
      });
      this.captureSession(session);
    }
  }

  /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */
   _isClientDoneProcessing(timeout) {
    return new syncpromise/* SyncPromise */.cW(resolve => {
      let ticked = 0;
      const tick = 1;

      const interval = setInterval(() => {
        if (this._numProcessing == 0) {
          clearInterval(interval);
          resolve(true);
        } else {
          ticked += tick;
          if (timeout && ticked >= timeout) {
            clearInterval(interval);
            resolve(false);
          }
        }
      }, tick);
    });
  }

  /** Determines whether this SDK is enabled and a valid Dsn is present. */
   _isEnabled() {
    return this.getOptions().enabled !== false && this._dsn !== undefined;
  }

  /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A new event with more information.
   */
   _prepareEvent(event, hint, scope) {
    const options = this.getOptions();
    const integrations = Object.keys(this._integrations);
    if (!hint.integrations && integrations.length > 0) {
      hint.integrations = integrations;
    }
    return (0,prepareEvent/* prepareEvent */.R)(options, event, hint, scope);
  }

  /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */
   _captureEvent(event, hint = {}, scope) {
    return this._processEvent(event, hint, scope).then(
      finalEvent => {
        return finalEvent.event_id;
      },
      reason => {
        if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
          // If something's gone wrong, log the error as a warning. If it's just us having used a `SentryError` for
          // control flow, log just the message (no stack) as a log-level log.
          const sentryError = reason ;
          if (sentryError.logLevel === 'log') {
            logger/* logger.log */.kg.log(sentryError.message);
          } else {
            logger/* logger.warn */.kg.warn(sentryError);
          }
        }
        return undefined;
      },
    );
  }

  /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */
   _processEvent(event, hint, scope) {
    const options = this.getOptions();
    const { sampleRate } = options;

    if (!this._isEnabled()) {
      return (0,syncpromise/* rejectedSyncPromise */.$2)(new error/* SentryError */.b('SDK not enabled, will not capture event.', 'log'));
    }

    const isTransaction = isTransactionEvent(event);
    const isError = isErrorEvent(event);
    const eventType = event.type || 'error';
    const beforeSendLabel = `before send for type \`${eventType}\``;

    // 1.0 === 100% events are sent
    // 0.0 === 0% events are sent
    // Sampling for transaction happens somewhere else
    if (isError && typeof sampleRate === 'number' && Math.random() > sampleRate) {
      this.recordDroppedEvent('sample_rate', 'error', event);
      return (0,syncpromise/* rejectedSyncPromise */.$2)(
        new error/* SentryError */.b(
          `Discarding event because it's not included in the random sample (sampling rate = ${sampleRate})`,
          'log',
        ),
      );
    }

    const dataCategory = eventType === 'replay_event' ? 'replay' : eventType;

    return this._prepareEvent(event, hint, scope)
      .then(prepared => {
        if (prepared === null) {
          this.recordDroppedEvent('event_processor', dataCategory, event);
          throw new error/* SentryError */.b('An event processor returned `null`, will not send event.', 'log');
        }

        const isInternalException = hint.data && (hint.data ).__sentry__ === true;
        if (isInternalException) {
          return prepared;
        }

        const result = processBeforeSend(options, prepared, hint);
        return _validateBeforeSendResult(result, beforeSendLabel);
      })
      .then(processedEvent => {
        if (processedEvent === null) {
          this.recordDroppedEvent('before_send', dataCategory, event);
          throw new error/* SentryError */.b(`${beforeSendLabel} returned \`null\`, will not send event.`, 'log');
        }

        const session = scope && scope.getSession();
        if (!isTransaction && session) {
          this._updateSessionFromEvent(session, processedEvent);
        }

        // None of the Sentry built event processor will update transaction name,
        // so if the transaction name has been changed by an event processor, we know
        // it has to come from custom event processor added by a user
        const transactionInfo = processedEvent.transaction_info;
        if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
          const source = 'custom';
          processedEvent.transaction_info = {
            ...transactionInfo,
            source,
          };
        }

        this.sendEvent(processedEvent, hint);
        return processedEvent;
      })
      .then(null, reason => {
        if (reason instanceof error/* SentryError */.b) {
          throw reason;
        }

        this.captureException(reason, {
          data: {
            __sentry__: true,
          },
          originalException: reason,
        });
        throw new error/* SentryError */.b(
          `Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: ${reason}`,
        );
      });
  }

  /**
   * Occupies the client with processing and event
   */
   _process(promise) {
    this._numProcessing++;
    void promise.then(
      value => {
        this._numProcessing--;
        return value;
      },
      reason => {
        this._numProcessing--;
        return reason;
      },
    );
  }

  /**
   * @inheritdoc
   */
   _sendEnvelope(envelope) {
    if (this._transport && this._dsn) {
      this.emit('beforeEnvelope', envelope);

      return this._transport.send(envelope).then(null, reason => {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.error */.kg.error('Error while sending event:', reason);
      });
    } else {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.error */.kg.error('Transport disabled');
    }
  }

  /**
   * Clears outcomes on this client and returns them.
   */
   _clearOutcomes() {
    const outcomes = this._outcomes;
    this._outcomes = {};
    return Object.keys(outcomes).map(key => {
      const [reason, category] = key.split(':') ;
      return {
        reason,
        category,
        quantity: outcomes[key],
      };
    });
  }

  /**
   * @inheritDoc
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types

}

/**
 * Verifies that return value of configured `beforeSend` or `beforeSendTransaction` is of expected type, and returns the value if so.
 */
function _validateBeforeSendResult(
  beforeSendResult,
  beforeSendLabel,
) {
  const invalidValueError = `${beforeSendLabel} must return \`null\` or a valid event.`;
  if ((0,is/* isThenable */.J8)(beforeSendResult)) {
    return beforeSendResult.then(
      event => {
        if (!(0,is/* isPlainObject */.PO)(event) && event !== null) {
          throw new error/* SentryError */.b(invalidValueError);
        }
        return event;
      },
      e => {
        throw new error/* SentryError */.b(`${beforeSendLabel} rejected with ${e}`);
      },
    );
  } else if (!(0,is/* isPlainObject */.PO)(beforeSendResult) && beforeSendResult !== null) {
    throw new error/* SentryError */.b(invalidValueError);
  }
  return beforeSendResult;
}

/**
 * Process the matching `beforeSendXXX` callback.
 */
function processBeforeSend(
  options,
  event,
  hint,
) {
  const { beforeSend, beforeSendTransaction } = options;

  if (isErrorEvent(event) && beforeSend) {
    return beforeSend(event, hint);
  }

  if (isTransactionEvent(event) && beforeSendTransaction) {
    return beforeSendTransaction(event, hint);
  }

  return event;
}

function isErrorEvent(event) {
  return event.type === undefined;
}

function isTransactionEvent(event) {
  return event.type === 'transaction';
}


//# sourceMappingURL=baseclient.js.map

// EXTERNAL MODULE: ../node_modules/@sentry/core/esm/version.js
var version = __webpack_require__(37486);
// EXTERNAL MODULE: ../node_modules/@sentry/utils/esm/env.js
var env = __webpack_require__(6905);
// EXTERNAL MODULE: ../node_modules/@sentry/utils/esm/time.js
var time = __webpack_require__(94180);
;// CONCATENATED MODULE: ../node_modules/@sentry/utils/esm/clientreport.js



/**
 * Creates client report envelope
 * @param discarded_events An array of discard events
 * @param dsn A DSN that can be set on the header. Optional.
 */
function createClientReportEnvelope(
  discarded_events,
  dsn,
  timestamp,
) {
  const clientReportItem = [
    { type: 'client_report' },
    {
      timestamp: timestamp || (0,time/* dateTimestampInSeconds */.yW)(),
      discarded_events,
    },
  ];
  return (0,envelope/* createEnvelope */.Jd)(dsn ? { dsn } : {}, [clientReportItem]);
}


//# sourceMappingURL=clientreport.js.map

// EXTERNAL MODULE: ../node_modules/@sentry/browser/esm/eventbuilder.js
var eventbuilder = __webpack_require__(24708);
// EXTERNAL MODULE: ../node_modules/@sentry/browser/esm/helpers.js
var helpers = __webpack_require__(51197);
// EXTERNAL MODULE: ../node_modules/@sentry/browser/esm/integrations/breadcrumbs.js + 1 modules
var breadcrumbs = __webpack_require__(77);
// EXTERNAL MODULE: ../node_modules/@sentry/browser/esm/userfeedback.js
var userfeedback = __webpack_require__(1367);
;// CONCATENATED MODULE: ../node_modules/@sentry/browser/esm/client.js







/**
 * Configuration options for the Sentry Browser SDK.
 * @see @sentry/types Options for more information.
 */

/**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */
class BrowserClient extends BaseClient {
  /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */
   constructor(options) {
    const sdkSource = helpers/* WINDOW.SENTRY_SDK_SOURCE */.m9.SENTRY_SDK_SOURCE || (0,env/* getSDKSource */.S)();

    options._metadata = options._metadata || {};
    options._metadata.sdk = options._metadata.sdk || {
      name: 'sentry.javascript.browser',
      packages: [
        {
          name: `${sdkSource}:@sentry/browser`,
          version: version/* SDK_VERSION */.J,
        },
      ],
      version: version/* SDK_VERSION */.J,
    };

    super(options);

    if (options.sendClientReports && helpers/* WINDOW.document */.m9.document) {
      helpers/* WINDOW.document.addEventListener */.m9.document.addEventListener('visibilitychange', () => {
        if (helpers/* WINDOW.document.visibilityState */.m9.document.visibilityState === 'hidden') {
          this._flushOutcomes();
        }
      });
    }
  }

  /**
   * @inheritDoc
   */
   eventFromException(exception, hint) {
    return (0,eventbuilder/* eventFromException */.dr)(this._options.stackParser, exception, hint, this._options.attachStacktrace);
  }

  /**
   * @inheritDoc
   */
   eventFromMessage(
    message,
    // eslint-disable-next-line deprecation/deprecation
    level = 'info',
    hint,
  ) {
    return (0,eventbuilder/* eventFromMessage */.aB)(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
  }

  /**
   * @inheritDoc
   */
   sendEvent(event, hint) {
    // We only want to add the sentry event breadcrumb when the user has the breadcrumb integration installed and
    // activated its `sentry` option.
    // We also do not want to use the `Breadcrumbs` class here directly, because we do not want it to be included in
    // bundles, if it is not used by the SDK.
    // This all sadly is a bit ugly, but we currently don't have a "pre-send" hook on the integrations so we do it this
    // way for now.
    const breadcrumbIntegration = this.getIntegrationById(breadcrumbs/* BREADCRUMB_INTEGRATION_ID */.p) ;
    // We check for definedness of `addSentryBreadcrumb` in case users provided their own integration with id
    // "Breadcrumbs" that does not have this function.
    if (breadcrumbIntegration && breadcrumbIntegration.addSentryBreadcrumb) {
      breadcrumbIntegration.addSentryBreadcrumb(event);
    }

    super.sendEvent(event, hint);
  }

  /**
   * Sends user feedback to Sentry.
   */
   captureUserFeedback(feedback) {
    if (!this._isEnabled()) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.warn */.kg.warn('SDK not enabled, will not capture user feedback.');
      return;
    }

    const envelope = (0,userfeedback/* createUserFeedbackEnvelope */.r)(feedback, {
      metadata: this.getSdkMetadata(),
      dsn: this.getDsn(),
      tunnel: this.getOptions().tunnel,
    });
    void this._sendEnvelope(envelope);
  }

  /**
   * @inheritDoc
   */
   _prepareEvent(event, hint, scope) {
    event.platform = event.platform || 'javascript';
    return super._prepareEvent(event, hint, scope);
  }

  /**
   * Sends client reports as an envelope.
   */
   _flushOutcomes() {
    const outcomes = this._clearOutcomes();

    if (outcomes.length === 0) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log('No outcomes to send');
      return;
    }

    if (!this._dsn) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log('No dsn provided, will not send outcomes');
      return;
    }

    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log('Sending outcomes:', outcomes);

    const envelope = createClientReportEnvelope(outcomes, this._options.tunnel && (0,esm_dsn/* dsnToString */.RA)(this._dsn));
    void this._sendEnvelope(envelope);
  }
}


//# sourceMappingURL=client.js.map


/***/ }),

/***/ 24708:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GJ": function() { return /* binding */ exceptionFromError; },
/* harmony export */   "ME": function() { return /* binding */ eventFromUnknownInput; },
/* harmony export */   "aB": function() { return /* binding */ eventFromMessage; },
/* harmony export */   "dr": function() { return /* binding */ eventFromException; }
/* harmony export */ });
/* unused harmony exports eventFromError, eventFromPlainObject, eventFromString, parseStackFrames */
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6878);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66885);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39109);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43527);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67451);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(48894);



/**
 * This function creates an exception from a JavaScript Error
 */
function exceptionFromError(stackParser, ex) {
  // Get the frames first since Opera can lose the stack if we touch anything else first
  const frames = parseStackFrames(stackParser, ex);

  const exception = {
    type: ex && ex.name,
    value: extractMessage(ex),
  };

  if (frames.length) {
    exception.stacktrace = { frames };
  }

  if (exception.type === undefined && exception.value === '') {
    exception.value = 'Unrecoverable error caught';
  }

  return exception;
}

/**
 * @hidden
 */
function eventFromPlainObject(
  stackParser,
  exception,
  syntheticException,
  isUnhandledRejection,
) {
  const hub = (0,_sentry_core__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)();
  const client = hub.getClient();
  const normalizeDepth = client && client.getOptions().normalizeDepth;

  const event = {
    exception: {
      values: [
        {
          type: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .isEvent */ .cO)(exception) ? exception.constructor.name : isUnhandledRejection ? 'UnhandledRejection' : 'Error',
          value: `Non-Error ${
            isUnhandledRejection ? 'promise rejection' : 'exception'
          } captured with keys: ${(0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .extractExceptionKeysForMessage */ .zf)(exception)}`,
        },
      ],
    },
    extra: {
      __serialized__: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .normalizeToSize */ .Qy)(exception, normalizeDepth),
    },
  };

  if (syntheticException) {
    const frames = parseStackFrames(stackParser, syntheticException);
    if (frames.length) {
      // event.exception.values[0] has been set above
      (event.exception ).values[0].stacktrace = { frames };
    }
  }

  return event;
}

/**
 * @hidden
 */
function eventFromError(stackParser, ex) {
  return {
    exception: {
      values: [exceptionFromError(stackParser, ex)],
    },
  };
}

/** Parses stack frames from an error */
function parseStackFrames(
  stackParser,
  ex,
) {
  // Access and store the stacktrace property before doing ANYTHING
  // else to it because Opera is not very good at providing it
  // reliably in other circumstances.
  const stacktrace = ex.stacktrace || ex.stack || '';

  const popSize = getPopSize(ex);

  try {
    return stackParser(stacktrace, popSize);
  } catch (e) {
    // no-empty
  }

  return [];
}

// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
const reactMinifiedRegexp = /Minified React error #\d+;/i;

function getPopSize(ex) {
  if (ex) {
    if (typeof ex.framesToPop === 'number') {
      return ex.framesToPop;
    }

    if (reactMinifiedRegexp.test(ex.message)) {
      return 1;
    }
  }

  return 0;
}

/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */
function extractMessage(ex) {
  const message = ex && ex.message;
  if (!message) {
    return 'No error message';
  }
  if (message.error && typeof message.error.message === 'string') {
    return message.error.message;
  }
  return message;
}

/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */
function eventFromException(
  stackParser,
  exception,
  hint,
  attachStacktrace,
) {
  const syntheticException = (hint && hint.syntheticException) || undefined;
  const event = eventFromUnknownInput(stackParser, exception, syntheticException, attachStacktrace);
  (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .addExceptionMechanism */ .EG)(event); // defaults to { type: 'generic', handled: true }
  event.level = 'error';
  if (hint && hint.event_id) {
    event.event_id = hint.event_id;
  }
  return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .resolvedSyncPromise */ .WD)(event);
}

/**
 * Builds and Event from a Message
 * @hidden
 */
function eventFromMessage(
  stackParser,
  message,
  // eslint-disable-next-line deprecation/deprecation
  level = 'info',
  hint,
  attachStacktrace,
) {
  const syntheticException = (hint && hint.syntheticException) || undefined;
  const event = eventFromString(stackParser, message, syntheticException, attachStacktrace);
  event.level = level;
  if (hint && hint.event_id) {
    event.event_id = hint.event_id;
  }
  return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .resolvedSyncPromise */ .WD)(event);
}

/**
 * @hidden
 */
function eventFromUnknownInput(
  stackParser,
  exception,
  syntheticException,
  attachStacktrace,
  isUnhandledRejection,
) {
  let event;

  if ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .isErrorEvent */ .VW)(exception ) && (exception ).error) {
    // If it is an ErrorEvent with `error` property, extract it to get actual Error
    const errorEvent = exception ;
    return eventFromError(stackParser, errorEvent.error );
  }

  // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
  // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
  // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
  //
  // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
  // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
  // https://webidl.spec.whatwg.org/#es-DOMException-specialness
  if ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .isDOMError */ .TX)(exception ) || (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .isDOMException */ .fm)(exception )) {
    const domException = exception ;

    if ('stack' in (exception )) {
      event = eventFromError(stackParser, exception );
    } else {
      const name = domException.name || ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .isDOMError */ .TX)(domException) ? 'DOMError' : 'DOMException');
      const message = domException.message ? `${name}: ${domException.message}` : name;
      event = eventFromString(stackParser, message, syntheticException, attachStacktrace);
      (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .addExceptionTypeValue */ .Db)(event, message);
    }
    if ('code' in domException) {
      event.tags = { ...event.tags, 'DOMException.code': `${domException.code}` };
    }

    return event;
  }
  if ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .isError */ .VZ)(exception)) {
    // we have a real Error object, do nothing
    return eventFromError(stackParser, exception);
  }
  if ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .isPlainObject */ .PO)(exception) || (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .isEvent */ .cO)(exception)) {
    // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
    // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
    // group on any key/value change.
    const objectException = exception ;
    event = eventFromPlainObject(stackParser, objectException, syntheticException, isUnhandledRejection);
    (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .addExceptionMechanism */ .EG)(event, {
      synthetic: true,
    });
    return event;
  }

  // If none of previous checks were valid, then it means that it's not:
  // - an instance of DOMError
  // - an instance of DOMException
  // - an instance of Event
  // - an instance of Error
  // - a valid ErrorEvent (one with an error property)
  // - a plain Object
  //
  // So bail out and capture it as a simple message:
  event = eventFromString(stackParser, exception , syntheticException, attachStacktrace);
  (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .addExceptionTypeValue */ .Db)(event, `${exception}`, undefined);
  (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .addExceptionMechanism */ .EG)(event, {
    synthetic: true,
  });

  return event;
}

/**
 * @hidden
 */
function eventFromString(
  stackParser,
  input,
  syntheticException,
  attachStacktrace,
) {
  const event = {
    message: input,
  };

  if (attachStacktrace && syntheticException) {
    const frames = parseStackFrames(stackParser, syntheticException);
    if (frames.length) {
      event.exception = {
        values: [{ value: input, stacktrace: { frames } }],
      };
    }
  }

  return event;
}


//# sourceMappingURL=eventbuilder.js.map


/***/ }),

/***/ 51197:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Wz": function() { return /* binding */ shouldIgnoreOnError; },
/* harmony export */   "m9": function() { return /* binding */ WINDOW; },
/* harmony export */   "re": function() { return /* binding */ wrap; }
/* harmony export */ });
/* unused harmony export ignoreNextOnError */
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(60074);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74211);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39109);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67451);



const WINDOW = _sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .GLOBAL_OBJ */ .n2 ;

let ignoreOnError = 0;

/**
 * @hidden
 */
function shouldIgnoreOnError() {
  return ignoreOnError > 0;
}

/**
 * @hidden
 */
function ignoreNextOnError() {
  // onerror should trigger before setTimeout
  ignoreOnError++;
  setTimeout(() => {
    ignoreOnError--;
  });
}

/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap. It is generally safe to pass an unbound function, because the returned wrapper always
 * has a correct `this` context.
 * @returns The wrapped function.
 * @hidden
 */
function wrap(
  fn,
  options

 = {},
  before,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
) {
  // for future readers what this does is wrap a function and then create
  // a bi-directional wrapping between them.
  //
  // example: wrapped = wrap(original);
  //  original.__sentry_wrapped__ -> wrapped
  //  wrapped.__sentry_original__ -> original

  if (typeof fn !== 'function') {
    return fn;
  }

  try {
    // if we're dealing with a function that was previously wrapped, return
    // the original wrapper.
    const wrapper = fn.__sentry_wrapped__;
    if (wrapper) {
      return wrapper;
    }

    // We don't wanna wrap it twice
    if ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .getOriginalFunction */ .HK)(fn)) {
      return fn;
    }
  } catch (e) {
    // Just accessing custom props in some Selenium environments
    // can cause a "Permission denied" exception (see raven-js#495).
    // Bail on wrapping and return the function as-is (defers to window.onerror).
    return fn;
  }

  /* eslint-disable prefer-rest-params */
  // It is important that `sentryWrapped` is not an arrow function to preserve the context of `this`
  const sentryWrapped = function () {
    const args = Array.prototype.slice.call(arguments);

    try {
      if (before && typeof before === 'function') {
        before.apply(this, arguments);
      }

      // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
      const wrappedArguments = args.map((arg) => wrap(arg, options));

      // Attempt to invoke user-land function
      // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
      //       means the sentry.javascript SDK caught an error invoking your application code. This
      //       is expected behavior and NOT indicative of a bug with sentry.javascript.
      return fn.apply(this, wrappedArguments);
    } catch (ex) {
      ignoreNextOnError();

      (0,_sentry_core__WEBPACK_IMPORTED_MODULE_2__/* .withScope */ .$e)((scope) => {
        scope.addEventProcessor((event) => {
          if (options.mechanism) {
            (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .addExceptionTypeValue */ .Db)(event, undefined, undefined);
            (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .addExceptionMechanism */ .EG)(event, options.mechanism);
          }

          event.extra = {
            ...event.extra,
            arguments: args,
          };

          return event;
        });

        (0,_sentry_core__WEBPACK_IMPORTED_MODULE_2__/* .captureException */ .Tb)(ex);
      });

      throw ex;
    }
  };
  /* eslint-enable prefer-rest-params */

  // Accessing some objects may throw
  // ref: https://github.com/getsentry/sentry-javascript/issues/1168
  try {
    for (const property in fn) {
      if (Object.prototype.hasOwnProperty.call(fn, property)) {
        sentryWrapped[property] = fn[property];
      }
    }
  } catch (_oO) {} // eslint-disable-line no-empty

  // Signal that this function has been wrapped/filled already
  // for both debugging and to prevent it to being wrapped/filled twice
  (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .markFunctionWrapped */ .$Q)(sentryWrapped, fn);

  (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .addNonEnumerableProperty */ .xp)(fn, '__sentry_wrapped__', sentryWrapped);

  // Restore original function name (not all browsers allow that)
  try {
    const descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, 'name') ;
    if (descriptor.configurable) {
      Object.defineProperty(sentryWrapped, 'name', {
        get() {
          return fn.name;
        },
      });
    }
    // eslint-disable-next-line no-empty
  } catch (_oO) {}

  return sentryWrapped;
}

/**
 * All properties the report dialog supports
 */


//# sourceMappingURL=helpers.js.map


/***/ }),

/***/ 77:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "p": function() { return /* binding */ BREADCRUMB_INTEGRATION_ID; },
  "O": function() { return /* binding */ Breadcrumbs; }
});

// EXTERNAL MODULE: ../node_modules/@sentry/core/esm/hub.js
var hub = __webpack_require__(6878);
// EXTERNAL MODULE: ../node_modules/@sentry/utils/esm/instrument.js + 1 modules
var instrument = __webpack_require__(15188);
// EXTERNAL MODULE: ../node_modules/@sentry/utils/esm/misc.js
var misc = __webpack_require__(67451);
// EXTERNAL MODULE: ../node_modules/@sentry/utils/esm/logger.js
var logger = __webpack_require__(86922);
// EXTERNAL MODULE: ../node_modules/@sentry/utils/esm/browser.js
var browser = __webpack_require__(61495);
;// CONCATENATED MODULE: ../node_modules/@sentry/utils/esm/severity.js
// Note: Ideally the `SeverityLevel` type would be derived from `validSeverityLevels`, but that would mean either
//
// a) moving `validSeverityLevels` to `@sentry/types`,
// b) moving the`SeverityLevel` type here, or
// c) importing `validSeverityLevels` from here into `@sentry/types`.
//
// Option A would make `@sentry/types` a runtime dependency of `@sentry/utils` (not good), and options B and C would
// create a circular dependency between `@sentry/types` and `@sentry/utils` (also not good). So a TODO accompanying the
// type, reminding anyone who changes it to change this list also, will have to do.

const validSeverityLevels = ['fatal', 'error', 'warning', 'log', 'info', 'debug'];

/**
 * Converts a string-based level into a member of the deprecated {@link Severity} enum.
 *
 * @deprecated `severityFromString` is deprecated. Please use `severityLevelFromString` instead.
 *
 * @param level String representation of Severity
 * @returns Severity
 */
function severityFromString(level) {
  return severityLevelFromString(level) ;
}

/**
 * Converts a string-based level into a `SeverityLevel`, normalizing it along the way.
 *
 * @param level String representation of desired `SeverityLevel`.
 * @returns The `SeverityLevel` corresponding to the given string, or 'log' if the string isn't a valid level.
 */
function severityLevelFromString(level) {
  return (level === 'warn' ? 'warning' : validSeverityLevels.includes(level) ? level : 'log') ;
}


//# sourceMappingURL=severity.js.map

// EXTERNAL MODULE: ../node_modules/@sentry/utils/esm/string.js
var string = __webpack_require__(65268);
// EXTERNAL MODULE: ../node_modules/@sentry/utils/esm/url.js
var url = __webpack_require__(94678);
// EXTERNAL MODULE: ../node_modules/@sentry/browser/esm/helpers.js
var helpers = __webpack_require__(51197);
;// CONCATENATED MODULE: ../node_modules/@sentry/browser/esm/integrations/breadcrumbs.js




/* eslint-disable @typescript-eslint/no-unsafe-member-access */

/** maxStringLength gets capped to prevent 100 breadcrumbs exceeding 1MB event payload size */
const MAX_ALLOWED_STRING_LENGTH = 1024;

const BREADCRUMB_INTEGRATION_ID = 'Breadcrumbs';

/**
 * Default Breadcrumbs instrumentations
 * TODO: Deprecated - with v6, this will be renamed to `Instrument`
 */
class Breadcrumbs  {
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = BREADCRUMB_INTEGRATION_ID;}

  /**
   * @inheritDoc
   */
   __init() {this.name = Breadcrumbs.id;}

  /**
   * Options of the breadcrumbs integration.
   */
  // This field is public, because we use it in the browser client to check if the `sentry` option is enabled.

  /**
   * @inheritDoc
   */
   constructor(options) {Breadcrumbs.prototype.__init.call(this);
    this.options = {
      console: true,
      dom: true,
      fetch: true,
      history: true,
      sentry: true,
      xhr: true,
      ...options,
    };
  }

  /**
   * Instrument browser built-ins w/ breadcrumb capturing
   *  - Console API
   *  - DOM API (click/typing)
   *  - XMLHttpRequest API
   *  - Fetch API
   *  - History API
   */
   setupOnce() {
    if (this.options.console) {
      (0,instrument/* addInstrumentationHandler */.oq)('console', _consoleBreadcrumb);
    }
    if (this.options.dom) {
      (0,instrument/* addInstrumentationHandler */.oq)('dom', _domBreadcrumb(this.options.dom));
    }
    if (this.options.xhr) {
      (0,instrument/* addInstrumentationHandler */.oq)('xhr', _xhrBreadcrumb);
    }
    if (this.options.fetch) {
      (0,instrument/* addInstrumentationHandler */.oq)('fetch', _fetchBreadcrumb);
    }
    if (this.options.history) {
      (0,instrument/* addInstrumentationHandler */.oq)('history', _historyBreadcrumb);
    }
  }

  /**
   * Adds a breadcrumb for Sentry events or transactions if this option is enabled.
   */
   addSentryBreadcrumb(event) {
    if (this.options.sentry) {
      (0,hub/* getCurrentHub */.Gd)().addBreadcrumb(
        {
          category: `sentry.${event.type === 'transaction' ? 'transaction' : 'event'}`,
          event_id: event.event_id,
          level: event.level,
          message: (0,misc/* getEventDescription */.jH)(event),
        },
        {
          event,
        },
      );
    }
  }
} Breadcrumbs.__initStatic();

/**
 * A HOC that creaes a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */
function _domBreadcrumb(dom) {
  function _innerDomBreadcrumb(handlerData) {
    let target;
    let keyAttrs = typeof dom === 'object' ? dom.serializeAttribute : undefined;

    let maxStringLength =
      typeof dom === 'object' && typeof dom.maxStringLength === 'number' ? dom.maxStringLength : undefined;
    if (maxStringLength && maxStringLength > MAX_ALLOWED_STRING_LENGTH) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        logger/* logger.warn */.kg.warn(
          `\`dom.maxStringLength\` cannot exceed ${MAX_ALLOWED_STRING_LENGTH}, but a value of ${maxStringLength} was configured. Sentry will use ${MAX_ALLOWED_STRING_LENGTH} instead.`,
        );
      maxStringLength = MAX_ALLOWED_STRING_LENGTH;
    }

    if (typeof keyAttrs === 'string') {
      keyAttrs = [keyAttrs];
    }

    // Accessing event.target can throw (see getsentry/raven-js#838, #768)
    try {
      const event = handlerData.event ;
      target = _isEvent(event)
        ? (0,browser/* htmlTreeAsString */.Rt)(event.target, { keyAttrs, maxStringLength })
        : (0,browser/* htmlTreeAsString */.Rt)(event, { keyAttrs, maxStringLength });
    } catch (e) {
      target = '<unknown>';
    }

    if (target.length === 0) {
      return;
    }

    (0,hub/* getCurrentHub */.Gd)().addBreadcrumb(
      {
        category: `ui.${handlerData.name}`,
        message: target,
      },
      {
        event: handlerData.event,
        name: handlerData.name,
        global: handlerData.global,
      },
    );
  }

  return _innerDomBreadcrumb;
}

/**
 * Creates breadcrumbs from console API calls
 */
function _consoleBreadcrumb(handlerData) {
  // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
  // console warnings. This happens when a Vue template is rendered with
  // an undeclared variable, which we try to stringify, ultimately causing
  // Vue to issue another warning which repeats indefinitely.
  // see: https://github.com/getsentry/sentry-javascript/pull/6010
  // see: https://github.com/getsentry/sentry-javascript/issues/5916
  for (let i = 0; i < handlerData.args.length; i++) {
    if (handlerData.args[i] === 'ref=Ref<') {
      handlerData.args[i + 1] = 'viewRef';
      break;
    }
  }
  const breadcrumb = {
    category: 'console',
    data: {
      arguments: handlerData.args,
      logger: 'console',
    },
    level: severityLevelFromString(handlerData.level),
    message: (0,string/* safeJoin */.nK)(handlerData.args, ' '),
  };

  if (handlerData.level === 'assert') {
    if (handlerData.args[0] === false) {
      breadcrumb.message = `Assertion failed: ${(0,string/* safeJoin */.nK)(handlerData.args.slice(1), ' ') || 'console.assert'}`;
      breadcrumb.data.arguments = handlerData.args.slice(1);
    } else {
      // Don't capture a breadcrumb for passed assertions
      return;
    }
  }

  (0,hub/* getCurrentHub */.Gd)().addBreadcrumb(breadcrumb, {
    input: handlerData.args,
    level: handlerData.level,
  });
}

/**
 * Creates breadcrumbs from XHR API calls
 */
function _xhrBreadcrumb(handlerData) {
  const { startTimestamp, endTimestamp } = handlerData;

  const sentryXhrData = handlerData.xhr[instrument/* SENTRY_XHR_DATA_KEY */.xU];

  // We only capture complete, non-sentry requests
  if (!startTimestamp || !endTimestamp || !sentryXhrData) {
    return;
  }

  const { method, url, status_code, body } = sentryXhrData;

  const data = {
    method,
    url,
    status_code,
  };

  const hint = {
    xhr: handlerData.xhr,
    input: body,
    startTimestamp,
    endTimestamp,
  };

  (0,hub/* getCurrentHub */.Gd)().addBreadcrumb(
    {
      category: 'xhr',
      data,
      type: 'http',
    },
    hint,
  );
}

/**
 * Creates breadcrumbs from fetch API calls
 */
function _fetchBreadcrumb(handlerData) {
  const { startTimestamp, endTimestamp } = handlerData;

  // We only capture complete fetch requests
  if (!endTimestamp) {
    return;
  }

  if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === 'POST') {
    // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
    return;
  }

  if (handlerData.error) {
    const data = handlerData.fetchData;
    const hint = {
      data: handlerData.error,
      input: handlerData.args,
      startTimestamp,
      endTimestamp,
    };

    (0,hub/* getCurrentHub */.Gd)().addBreadcrumb(
      {
        category: 'fetch',
        data,
        level: 'error',
        type: 'http',
      },
      hint,
    );
  } else {
    const data = {
      ...handlerData.fetchData,
      status_code: handlerData.response && handlerData.response.status,
    };
    const hint = {
      input: handlerData.args,
      response: handlerData.response,
      startTimestamp,
      endTimestamp,
    };
    (0,hub/* getCurrentHub */.Gd)().addBreadcrumb(
      {
        category: 'fetch',
        data,
        type: 'http',
      },
      hint,
    );
  }
}

/**
 * Creates breadcrumbs from history API calls
 */
function _historyBreadcrumb(handlerData) {
  let from = handlerData.from;
  let to = handlerData.to;
  const parsedLoc = (0,url/* parseUrl */.en)(helpers/* WINDOW.location.href */.m9.location.href);
  let parsedFrom = (0,url/* parseUrl */.en)(from);
  const parsedTo = (0,url/* parseUrl */.en)(to);

  // Initial pushState doesn't provide `from` information
  if (!parsedFrom.path) {
    parsedFrom = parsedLoc;
  }

  // Use only the path component of the URL if the URL matches the current
  // document (almost all the time when using pushState)
  if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) {
    to = parsedTo.relative;
  }
  if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) {
    from = parsedFrom.relative;
  }

  (0,hub/* getCurrentHub */.Gd)().addBreadcrumb({
    category: 'navigation',
    data: {
      from,
      to,
    },
  });
}

function _isEvent(event) {
  return event && !!(event ).target;
}


//# sourceMappingURL=breadcrumbs.js.map


/***/ }),

/***/ 12836:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ Dedupe; }
/* harmony export */ });
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(86922);


/** Deduplication filter */
class Dedupe  {constructor() { Dedupe.prototype.__init.call(this); }
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'Dedupe';}

  /**
   * @inheritDoc
   */
   __init() {this.name = Dedupe.id;}

  /**
   * @inheritDoc
   */

  /**
   * @inheritDoc
   */
   setupOnce(addGlobalEventProcessor, getCurrentHub) {
    const eventProcessor = currentEvent => {
      // We want to ignore any non-error type events, e.g. transactions or replays
      // These should never be deduped, and also not be compared against as _previousEvent.
      if (currentEvent.type) {
        return currentEvent;
      }

      const self = getCurrentHub().getIntegration(Dedupe);
      if (self) {
        // Juuust in case something goes wrong
        try {
          if (_shouldDropEvent(currentEvent, self._previousEvent)) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .logger.warn */ .kg.warn('Event dropped due to being a duplicate of previously captured event.');
            return null;
          }
        } catch (_oO) {
          return (self._previousEvent = currentEvent);
        }

        return (self._previousEvent = currentEvent);
      }
      return currentEvent;
    };

    eventProcessor.id = this.name;
    addGlobalEventProcessor(eventProcessor);
  }
} Dedupe.__initStatic();

/** JSDoc */
function _shouldDropEvent(currentEvent, previousEvent) {
  if (!previousEvent) {
    return false;
  }

  if (_isSameMessageEvent(currentEvent, previousEvent)) {
    return true;
  }

  if (_isSameExceptionEvent(currentEvent, previousEvent)) {
    return true;
  }

  return false;
}

/** JSDoc */
function _isSameMessageEvent(currentEvent, previousEvent) {
  const currentMessage = currentEvent.message;
  const previousMessage = previousEvent.message;

  // If neither event has a message property, they were both exceptions, so bail out
  if (!currentMessage && !previousMessage) {
    return false;
  }

  // If only one event has a stacktrace, but not the other one, they are not the same
  if ((currentMessage && !previousMessage) || (!currentMessage && previousMessage)) {
    return false;
  }

  if (currentMessage !== previousMessage) {
    return false;
  }

  if (!_isSameFingerprint(currentEvent, previousEvent)) {
    return false;
  }

  if (!_isSameStacktrace(currentEvent, previousEvent)) {
    return false;
  }

  return true;
}

/** JSDoc */
function _isSameExceptionEvent(currentEvent, previousEvent) {
  const previousException = _getExceptionFromEvent(previousEvent);
  const currentException = _getExceptionFromEvent(currentEvent);

  if (!previousException || !currentException) {
    return false;
  }

  if (previousException.type !== currentException.type || previousException.value !== currentException.value) {
    return false;
  }

  if (!_isSameFingerprint(currentEvent, previousEvent)) {
    return false;
  }

  if (!_isSameStacktrace(currentEvent, previousEvent)) {
    return false;
  }

  return true;
}

/** JSDoc */
function _isSameStacktrace(currentEvent, previousEvent) {
  let currentFrames = _getFramesFromEvent(currentEvent);
  let previousFrames = _getFramesFromEvent(previousEvent);

  // If neither event has a stacktrace, they are assumed to be the same
  if (!currentFrames && !previousFrames) {
    return true;
  }

  // If only one event has a stacktrace, but not the other one, they are not the same
  if ((currentFrames && !previousFrames) || (!currentFrames && previousFrames)) {
    return false;
  }

  currentFrames = currentFrames ;
  previousFrames = previousFrames ;

  // If number of frames differ, they are not the same
  if (previousFrames.length !== currentFrames.length) {
    return false;
  }

  // Otherwise, compare the two
  for (let i = 0; i < previousFrames.length; i++) {
    const frameA = previousFrames[i];
    const frameB = currentFrames[i];

    if (
      frameA.filename !== frameB.filename ||
      frameA.lineno !== frameB.lineno ||
      frameA.colno !== frameB.colno ||
      frameA.function !== frameB.function
    ) {
      return false;
    }
  }

  return true;
}

/** JSDoc */
function _isSameFingerprint(currentEvent, previousEvent) {
  let currentFingerprint = currentEvent.fingerprint;
  let previousFingerprint = previousEvent.fingerprint;

  // If neither event has a fingerprint, they are assumed to be the same
  if (!currentFingerprint && !previousFingerprint) {
    return true;
  }

  // If only one event has a fingerprint, but not the other one, they are not the same
  if ((currentFingerprint && !previousFingerprint) || (!currentFingerprint && previousFingerprint)) {
    return false;
  }

  currentFingerprint = currentFingerprint ;
  previousFingerprint = previousFingerprint ;

  // Otherwise, compare the two
  try {
    return !!(currentFingerprint.join('') === previousFingerprint.join(''));
  } catch (_oO) {
    return false;
  }
}

/** JSDoc */
function _getExceptionFromEvent(event) {
  return event.exception && event.exception.values && event.exception.values[0];
}

/** JSDoc */
function _getFramesFromEvent(event) {
  const exception = event.exception;

  if (exception) {
    try {
      // @ts-ignore Object could be undefined
      return exception.values[0].stacktrace.frames;
    } catch (_oO) {
      return undefined;
    }
  }
  return undefined;
}


//# sourceMappingURL=dedupe.js.map


/***/ }),

/***/ 35519:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ GlobalHandlers; }
/* harmony export */ });
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(6878);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(15188);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66885);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61495);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(86922);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67451);
/* harmony import */ var _eventbuilder_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24708);
/* harmony import */ var _helpers_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51197);





/* eslint-disable @typescript-eslint/no-unsafe-member-access */

/** Global handlers */
class GlobalHandlers  {
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'GlobalHandlers';}

  /**
   * @inheritDoc
   */
   __init() {this.name = GlobalHandlers.id;}

  /** JSDoc */

  /**
   * Stores references functions to installing handlers. Will set to undefined
   * after they have been run so that they are not used twice.
   */
   __init2() {this._installFunc = {
    onerror: _installGlobalOnErrorHandler,
    onunhandledrejection: _installGlobalOnUnhandledRejectionHandler,
  };}

  /** JSDoc */
   constructor(options) {GlobalHandlers.prototype.__init.call(this);GlobalHandlers.prototype.__init2.call(this);
    this._options = {
      onerror: true,
      onunhandledrejection: true,
      ...options,
    };
  }
  /**
   * @inheritDoc
   */
   setupOnce() {
    Error.stackTraceLimit = 50;
    const options = this._options;

    // We can disable guard-for-in as we construct the options object above + do checks against
    // `this._installFunc` for the property.
    // eslint-disable-next-line guard-for-in
    for (const key in options) {
      const installFunc = this._installFunc[key ];
      if (installFunc && options[key ]) {
        globalHandlerLog(key);
        installFunc();
        this._installFunc[key ] = undefined;
      }
    }
  }
} GlobalHandlers.__initStatic();

/** JSDoc */
function _installGlobalOnErrorHandler() {
  (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .addInstrumentationHandler */ .oq)(
    'error',
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (data) => {
      const [hub, stackParser, attachStacktrace] = getHubAndOptions();
      if (!hub.getIntegration(GlobalHandlers)) {
        return;
      }
      const { msg, url, line, column, error } = data;
      if ((0,_helpers_js__WEBPACK_IMPORTED_MODULE_1__/* .shouldIgnoreOnError */ .Wz)() || (error && error.__sentry_own_request__)) {
        return;
      }

      const event =
        error === undefined && (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .isString */ .HD)(msg)
          ? _eventFromIncompleteOnError(msg, url, line, column)
          : _enhanceEventWithInitialFrame(
              (0,_eventbuilder_js__WEBPACK_IMPORTED_MODULE_3__/* .eventFromUnknownInput */ .ME)(stackParser, error || msg, undefined, attachStacktrace, false),
              url,
              line,
              column,
            );

      event.level = 'error';

      addMechanismAndCapture(hub, error, event, 'onerror');
    },
  );
}

/** JSDoc */
function _installGlobalOnUnhandledRejectionHandler() {
  (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .addInstrumentationHandler */ .oq)(
    'unhandledrejection',
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (e) => {
      const [hub, stackParser, attachStacktrace] = getHubAndOptions();
      if (!hub.getIntegration(GlobalHandlers)) {
        return;
      }
      let error = e;

      // dig the object of the rejection out of known event types
      try {
        // PromiseRejectionEvents store the object of the rejection under 'reason'
        // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
        if ('reason' in e) {
          error = e.reason;
        }
        // something, somewhere, (likely a browser extension) effectively casts PromiseRejectionEvents
        // to CustomEvents, moving the `promise` and `reason` attributes of the PRE into
        // the CustomEvent's `detail` attribute, since they're not part of CustomEvent's spec
        // see https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent and
        // https://github.com/getsentry/sentry-javascript/issues/2380
        else if ('detail' in e && 'reason' in e.detail) {
          error = e.detail.reason;
        }
      } catch (_oO) {
        // no-empty
      }

      if ((0,_helpers_js__WEBPACK_IMPORTED_MODULE_1__/* .shouldIgnoreOnError */ .Wz)() || (error && error.__sentry_own_request__)) {
        return true;
      }

      const event = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .isPrimitive */ .pt)(error)
        ? _eventFromRejectionWithPrimitive(error)
        : (0,_eventbuilder_js__WEBPACK_IMPORTED_MODULE_3__/* .eventFromUnknownInput */ .ME)(stackParser, error, undefined, attachStacktrace, true);

      event.level = 'error';

      addMechanismAndCapture(hub, error, event, 'onunhandledrejection');
      return;
    },
  );
}

/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */
function _eventFromRejectionWithPrimitive(reason) {
  return {
    exception: {
      values: [
        {
          type: 'UnhandledRejection',
          // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
          value: `Non-Error promise rejection captured with value: ${String(reason)}`,
        },
      ],
    },
  };
}

/**
 * This function creates a stack from an old, error-less onerror handler.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _eventFromIncompleteOnError(msg, url, line, column) {
  const ERROR_TYPES_RE =
    /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;

  // If 'message' is ErrorEvent, get real message from inside
  let message = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .isErrorEvent */ .VW)(msg) ? msg.message : msg;
  let name = 'Error';

  const groups = message.match(ERROR_TYPES_RE);
  if (groups) {
    name = groups[1];
    message = groups[2];
  }

  const event = {
    exception: {
      values: [
        {
          type: name,
          value: message,
        },
      ],
    },
  };

  return _enhanceEventWithInitialFrame(event, url, line, column);
}

/** JSDoc */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _enhanceEventWithInitialFrame(event, url, line, column) {
  // event.exception
  const e = (event.exception = event.exception || {});
  // event.exception.values
  const ev = (e.values = e.values || []);
  // event.exception.values[0]
  const ev0 = (ev[0] = ev[0] || {});
  // event.exception.values[0].stacktrace
  const ev0s = (ev0.stacktrace = ev0.stacktrace || {});
  // event.exception.values[0].stacktrace.frames
  const ev0sf = (ev0s.frames = ev0s.frames || []);

  const colno = isNaN(parseInt(column, 10)) ? undefined : column;
  const lineno = isNaN(parseInt(line, 10)) ? undefined : line;
  const filename = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .isString */ .HD)(url) && url.length > 0 ? url : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .getLocationHref */ .l4)();

  // event.exception.values[0].stacktrace.frames
  if (ev0sf.length === 0) {
    ev0sf.push({
      colno,
      filename,
      function: '?',
      in_app: true,
      lineno,
    });
  }

  return event;
}

function globalHandlerLog(type) {
  (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .logger.log */ .kg.log(`Global Handler attached: ${type}`);
}

function addMechanismAndCapture(hub, error, event, type) {
  (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_6__/* .addExceptionMechanism */ .EG)(event, {
    handled: false,
    type,
  });
  hub.captureEvent(event, {
    originalException: error,
  });
}

function getHubAndOptions() {
  const hub = (0,_sentry_core__WEBPACK_IMPORTED_MODULE_7__/* .getCurrentHub */ .Gd)();
  const client = hub.getClient();
  const options = (client && client.getOptions()) || {
    stackParser: () => [],
    attachStacktrace: false,
  };
  return [hub, options.stackParser, options.attachStacktrace];
}


//# sourceMappingURL=globalhandlers.js.map


/***/ }),

/***/ 21680:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ HttpContext; }
/* harmony export */ });
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25516);
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6878);
/* harmony import */ var _helpers_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51197);



/** HttpContext integration collects information about HTTP request headers */
class HttpContext  {constructor() { HttpContext.prototype.__init.call(this); }
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'HttpContext';}

  /**
   * @inheritDoc
   */
   __init() {this.name = HttpContext.id;}

  /**
   * @inheritDoc
   */
   setupOnce() {
    (0,_sentry_core__WEBPACK_IMPORTED_MODULE_0__/* .addGlobalEventProcessor */ .c)((event) => {
      if ((0,_sentry_core__WEBPACK_IMPORTED_MODULE_1__/* .getCurrentHub */ .Gd)().getIntegration(HttpContext)) {
        // if none of the information we want exists, don't bother
        if (!_helpers_js__WEBPACK_IMPORTED_MODULE_2__/* .WINDOW.navigator */ .m9.navigator && !_helpers_js__WEBPACK_IMPORTED_MODULE_2__/* .WINDOW.location */ .m9.location && !_helpers_js__WEBPACK_IMPORTED_MODULE_2__/* .WINDOW.document */ .m9.document) {
          return event;
        }

        // grab as much info as exists and add it to the event
        const url = (event.request && event.request.url) || (_helpers_js__WEBPACK_IMPORTED_MODULE_2__/* .WINDOW.location */ .m9.location && _helpers_js__WEBPACK_IMPORTED_MODULE_2__/* .WINDOW.location.href */ .m9.location.href);
        const { referrer } = _helpers_js__WEBPACK_IMPORTED_MODULE_2__/* .WINDOW.document */ .m9.document || {};
        const { userAgent } = _helpers_js__WEBPACK_IMPORTED_MODULE_2__/* .WINDOW.navigator */ .m9.navigator || {};

        const headers = {
          ...(event.request && event.request.headers),
          ...(referrer && { Referer: referrer }),
          ...(userAgent && { 'User-Agent': userAgent }),
        };
        const request = { ...event.request, ...(url && { url }), headers };

        return { ...event, request };
      }
      return event;
    });
  }
} HttpContext.__initStatic();


//# sourceMappingURL=httpcontext.js.map


/***/ }),

/***/ 97373:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "iP": function() { return /* binding */ LinkedErrors; }
/* harmony export */ });
/* unused harmony exports _handler, _walkErrorTree */
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6878);
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25516);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66885);
/* harmony import */ var _eventbuilder_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24708);




const DEFAULT_KEY = 'cause';
const DEFAULT_LIMIT = 5;

/** Adds SDK info to an event. */
class LinkedErrors  {
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'LinkedErrors';}

  /**
   * @inheritDoc
   */
    __init() {this.name = LinkedErrors.id;}

  /**
   * @inheritDoc
   */

  /**
   * @inheritDoc
   */

  /**
   * @inheritDoc
   */
   constructor(options = {}) {LinkedErrors.prototype.__init.call(this);
    this._key = options.key || DEFAULT_KEY;
    this._limit = options.limit || DEFAULT_LIMIT;
  }

  /**
   * @inheritDoc
   */
   setupOnce() {
    const client = (0,_sentry_core__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().getClient();
    if (!client) {
      return;
    }
    (0,_sentry_core__WEBPACK_IMPORTED_MODULE_1__/* .addGlobalEventProcessor */ .c)((event, hint) => {
      const self = (0,_sentry_core__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().getIntegration(LinkedErrors);
      return self ? _handler(client.getOptions().stackParser, self._key, self._limit, event, hint) : event;
    });
  }
} LinkedErrors.__initStatic();

/**
 * @inheritDoc
 */
function _handler(
  parser,
  key,
  limit,
  event,
  hint,
) {
  if (!event.exception || !event.exception.values || !hint || !(0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .isInstanceOf */ .V9)(hint.originalException, Error)) {
    return event;
  }
  const linkedErrors = _walkErrorTree(parser, limit, hint.originalException , key);
  event.exception.values = [...linkedErrors, ...event.exception.values];
  return event;
}

/**
 * JSDOC
 */
function _walkErrorTree(
  parser,
  limit,
  error,
  key,
  stack = [],
) {
  if (!(0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .isInstanceOf */ .V9)(error[key], Error) || stack.length + 1 >= limit) {
    return stack;
  }
  const exception = (0,_eventbuilder_js__WEBPACK_IMPORTED_MODULE_3__/* .exceptionFromError */ .GJ)(parser, error[key]);
  return _walkErrorTree(parser, limit, error[key], key, [exception, ...stack]);
}


//# sourceMappingURL=linkederrors.js.map


/***/ }),

/***/ 34183:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ TryCatch; }
/* harmony export */ });
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39109);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55514);
/* harmony import */ var _helpers_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51197);



const DEFAULT_EVENT_TARGET = [
  'EventTarget',
  'Window',
  'Node',
  'ApplicationCache',
  'AudioTrackList',
  'ChannelMergerNode',
  'CryptoOperation',
  'EventSource',
  'FileReader',
  'HTMLUnknownElement',
  'IDBDatabase',
  'IDBRequest',
  'IDBTransaction',
  'KeyOperation',
  'MediaController',
  'MessagePort',
  'ModalWindow',
  'Notification',
  'SVGElementInstance',
  'Screen',
  'TextTrack',
  'TextTrackCue',
  'TextTrackList',
  'WebSocket',
  'WebSocketWorker',
  'Worker',
  'XMLHttpRequest',
  'XMLHttpRequestEventTarget',
  'XMLHttpRequestUpload',
];

/** Wrap timer functions and event targets to catch errors and provide better meta data */
class TryCatch  {
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'TryCatch';}

  /**
   * @inheritDoc
   */
   __init() {this.name = TryCatch.id;}

  /** JSDoc */

  /**
   * @inheritDoc
   */
   constructor(options) {TryCatch.prototype.__init.call(this);
    this._options = {
      XMLHttpRequest: true,
      eventTarget: true,
      requestAnimationFrame: true,
      setInterval: true,
      setTimeout: true,
      ...options,
    };
  }

  /**
   * Wrap timer functions and event targets to catch errors
   * and provide better metadata.
   */
   setupOnce() {
    if (this._options.setTimeout) {
      (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .fill */ .hl)(_helpers_js__WEBPACK_IMPORTED_MODULE_1__/* .WINDOW */ .m9, 'setTimeout', _wrapTimeFunction);
    }

    if (this._options.setInterval) {
      (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .fill */ .hl)(_helpers_js__WEBPACK_IMPORTED_MODULE_1__/* .WINDOW */ .m9, 'setInterval', _wrapTimeFunction);
    }

    if (this._options.requestAnimationFrame) {
      (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .fill */ .hl)(_helpers_js__WEBPACK_IMPORTED_MODULE_1__/* .WINDOW */ .m9, 'requestAnimationFrame', _wrapRAF);
    }

    if (this._options.XMLHttpRequest && "XMLHttpRequest" in _helpers_js__WEBPACK_IMPORTED_MODULE_1__/* .WINDOW */ .m9) {
      (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .fill */ .hl)(XMLHttpRequest.prototype, 'send', _wrapXHR);
    }

    const eventTargetOption = this._options.eventTarget;
    if (eventTargetOption) {
      const eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : DEFAULT_EVENT_TARGET;
      eventTarget.forEach(_wrapEventTarget);
    }
  }
} TryCatch.__initStatic();

/** JSDoc */
function _wrapTimeFunction(original) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return function ( ...args) {
    const originalCallback = args[0];
    args[0] = (0,_helpers_js__WEBPACK_IMPORTED_MODULE_1__/* .wrap */ .re)(originalCallback, {
      mechanism: {
        data: { function: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .getFunctionName */ .$P)(original) },
        handled: true,
        type: 'instrument',
      },
    });
    return original.apply(this, args);
  };
}

/** JSDoc */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _wrapRAF(original) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return function ( callback) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return original.apply(this, [
      (0,_helpers_js__WEBPACK_IMPORTED_MODULE_1__/* .wrap */ .re)(callback, {
        mechanism: {
          data: {
            function: 'requestAnimationFrame',
            handler: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .getFunctionName */ .$P)(original),
          },
          handled: true,
          type: 'instrument',
        },
      }),
    ]);
  };
}

/** JSDoc */
function _wrapXHR(originalSend) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return function ( ...args) {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const xhr = this;
    const xmlHttpRequestProps = ['onload', 'onerror', 'onprogress', 'onreadystatechange'];

    xmlHttpRequestProps.forEach(prop => {
      if (prop in xhr && typeof xhr[prop] === 'function') {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .fill */ .hl)(xhr, prop, function (original) {
          const wrapOptions = {
            mechanism: {
              data: {
                function: prop,
                handler: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .getFunctionName */ .$P)(original),
              },
              handled: true,
              type: 'instrument',
            },
          };

          // If Instrument integration has been called before TryCatch, get the name of original function
          const originalFunction = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .getOriginalFunction */ .HK)(original);
          if (originalFunction) {
            wrapOptions.mechanism.data.handler = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .getFunctionName */ .$P)(originalFunction);
          }

          // Otherwise wrap directly
          return (0,_helpers_js__WEBPACK_IMPORTED_MODULE_1__/* .wrap */ .re)(original, wrapOptions);
        });
      }
    });

    return originalSend.apply(this, args);
  };
}

/** JSDoc */
function _wrapEventTarget(target) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const globalObject = _helpers_js__WEBPACK_IMPORTED_MODULE_1__/* .WINDOW */ .m9 ;
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  const proto = globalObject[target] && globalObject[target].prototype;

  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
  if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) {
    return;
  }

  (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .fill */ .hl)(proto, 'addEventListener', function (original)

 {
    return function (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any

      eventName,
      fn,
      options,
    ) {
      try {
        if (typeof fn.handleEvent === 'function') {
          // ESlint disable explanation:
          //  First, it is generally safe to call `wrap` with an unbound function. Furthermore, using `.bind()` would
          //  introduce a bug here, because bind returns a new function that doesn't have our
          //  flags(like __sentry_original__) attached. `wrap` checks for those flags to avoid unnecessary wrapping.
          //  Without those flags, every call to addEventListener wraps the function again, causing a memory leak.
          // eslint-disable-next-line @typescript-eslint/unbound-method
          fn.handleEvent = (0,_helpers_js__WEBPACK_IMPORTED_MODULE_1__/* .wrap */ .re)(fn.handleEvent, {
            mechanism: {
              data: {
                function: 'handleEvent',
                handler: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .getFunctionName */ .$P)(fn),
                target,
              },
              handled: true,
              type: 'instrument',
            },
          });
        }
      } catch (err) {
        // can sometimes get 'Permission denied to access property "handle Event'
      }

      return original.apply(this, [
        eventName,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (0,_helpers_js__WEBPACK_IMPORTED_MODULE_1__/* .wrap */ .re)(fn , {
          mechanism: {
            data: {
              function: 'addEventListener',
              handler: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .getFunctionName */ .$P)(fn),
              target,
            },
            handled: true,
            type: 'instrument',
          },
        }),
        options,
      ]);
    };
  });

  (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .fill */ .hl)(
    proto,
    'removeEventListener',
    function (
      originalRemoveEventListener,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ) {
      return function (
        // eslint-disable-next-line @typescript-eslint/no-explicit-any

        eventName,
        fn,
        options,
      ) {
        /**
         * There are 2 possible scenarios here:
         *
         * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
         * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
         * as a pass-through, and call original `removeEventListener` with it.
         *
         * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
         * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
         * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
         * in order for us to make a distinction between wrapped/non-wrapped functions possible.
         * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
         *
         * When someone adds a handler prior to initialization, and then do it again, but after,
         * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
         * to get rid of the initial handler and it'd stick there forever.
         */
        const wrappedEventHandler = fn ;
        try {
          const originalEventHandler = wrappedEventHandler && wrappedEventHandler.__sentry_wrapped__;
          if (originalEventHandler) {
            originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
          }
        } catch (e) {
          // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
        }
        return originalRemoveEventListener.call(this, eventName, wrappedEventHandler, options);
      };
    },
  );
}


//# sourceMappingURL=trycatch.js.map


/***/ }),

/***/ 93968:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Jd": function() { return /* binding */ captureUserFeedback; },
  "xv": function() { return /* binding */ sdk_close; },
  "SS": function() { return /* binding */ defaultIntegrations; },
  "yl": function() { return /* binding */ flush; },
  "Eg": function() { return /* binding */ forceLoad; },
  "S1": function() { return /* binding */ init; },
  "eW": function() { return /* binding */ lastEventId; },
  "lA": function() { return /* binding */ onLoad; },
  "jp": function() { return /* binding */ showReportDialog; },
  "re": function() { return /* binding */ wrap; }
});

// EXTERNAL MODULE: ../node_modules/@sentry/core/esm/integrations/inboundfilters.js
var inboundfilters = __webpack_require__(37107);
// EXTERNAL MODULE: ../node_modules/@sentry/core/esm/integrations/functiontostring.js
var functiontostring = __webpack_require__(14979);
// EXTERNAL MODULE: ../node_modules/@sentry/core/esm/integration.js
var integration = __webpack_require__(99354);
// EXTERNAL MODULE: ../node_modules/@sentry/utils/esm/logger.js
var logger = __webpack_require__(86922);
// EXTERNAL MODULE: ../node_modules/@sentry/core/esm/hub.js
var esm_hub = __webpack_require__(6878);
;// CONCATENATED MODULE: ../node_modules/@sentry/core/esm/sdk.js



/** A class object that can instantiate Client objects. */

/**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instantiate.
 * @param options Options to pass to the client.
 */
function initAndBind(
  clientClass,
  options,
) {
  if (options.debug === true) {
    if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
      logger/* logger.enable */.kg.enable();
    } else {
      // use `console.warn` rather than `logger.warn` since by non-debug bundles have all `logger.x` statements stripped
      // eslint-disable-next-line no-console
      console.warn('[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.');
    }
  }
  const hub = (0,esm_hub/* getCurrentHub */.Gd)();
  const scope = hub.getScope();
  scope.update(options.initialScope);

  const client = new clientClass(options);
  hub.bindClient(client);
}


//# sourceMappingURL=sdk.js.map

// EXTERNAL MODULE: ../node_modules/@sentry/core/esm/api.js
var api = __webpack_require__(66485);
// EXTERNAL MODULE: ../node_modules/@sentry/utils/esm/stacktrace.js
var stacktrace = __webpack_require__(55514);
// EXTERNAL MODULE: ../node_modules/@sentry/utils/esm/supports.js
var supports = __webpack_require__(83589);
// EXTERNAL MODULE: ../node_modules/@sentry/utils/esm/syncpromise.js
var syncpromise = __webpack_require__(48894);
// EXTERNAL MODULE: ../node_modules/@sentry/utils/esm/instrument.js + 1 modules
var instrument = __webpack_require__(15188);
// EXTERNAL MODULE: ../node_modules/@sentry/browser/esm/client.js + 3 modules
var client = __webpack_require__(56921);
// EXTERNAL MODULE: ../node_modules/@sentry/browser/esm/helpers.js
var helpers = __webpack_require__(51197);
// EXTERNAL MODULE: ../node_modules/@sentry/browser/esm/integrations/globalhandlers.js
var globalhandlers = __webpack_require__(35519);
// EXTERNAL MODULE: ../node_modules/@sentry/browser/esm/integrations/trycatch.js
var trycatch = __webpack_require__(34183);
// EXTERNAL MODULE: ../node_modules/@sentry/browser/esm/integrations/breadcrumbs.js + 1 modules
var breadcrumbs = __webpack_require__(77);
// EXTERNAL MODULE: ../node_modules/@sentry/browser/esm/integrations/linkederrors.js
var linkederrors = __webpack_require__(97373);
// EXTERNAL MODULE: ../node_modules/@sentry/browser/esm/integrations/httpcontext.js
var httpcontext = __webpack_require__(21680);
// EXTERNAL MODULE: ../node_modules/@sentry/browser/esm/integrations/dedupe.js
var dedupe = __webpack_require__(12836);
// EXTERNAL MODULE: ../node_modules/@sentry/browser/esm/stack-parsers.js
var stack_parsers = __webpack_require__(97939);
// EXTERNAL MODULE: ../node_modules/@sentry/browser/esm/transports/fetch.js + 1 modules
var fetch = __webpack_require__(81804);
// EXTERNAL MODULE: ../node_modules/@sentry/browser/esm/transports/xhr.js
var xhr = __webpack_require__(20296);
;// CONCATENATED MODULE: ../node_modules/@sentry/browser/esm/sdk.js














const defaultIntegrations = [
  new inboundfilters/* InboundFilters */.QD(),
  new functiontostring/* FunctionToString */.c(),
  new trycatch/* TryCatch */.p(),
  new breadcrumbs/* Breadcrumbs */.O(),
  new globalhandlers/* GlobalHandlers */.d(),
  new linkederrors/* LinkedErrors */.iP(),
  new dedupe/* Dedupe */.I(),
  new httpcontext/* HttpContext */.q(),
];

/**
 * A magic string that build tooling can leverage in order to inject a release value into the SDK.
 */

/**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { configureScope } from '@sentry/browser';
 * configureScope((scope: Scope) => {
 *   scope.setExtra({ battery: 0.7 });
 *   scope.setTag({ user_mode: 'admin' });
 *   scope.setUser({ id: '4711' });
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */
function init(options = {}) {
  if (options.defaultIntegrations === undefined) {
    options.defaultIntegrations = defaultIntegrations;
  }
  if (options.release === undefined) {
    // This allows build tooling to find-and-replace __SENTRY_RELEASE__ to inject a release value
    if (typeof __SENTRY_RELEASE__ === 'string') {
      options.release = __SENTRY_RELEASE__;
    }

    // This supports the variable that sentry-webpack-plugin injects
    if (helpers/* WINDOW.SENTRY_RELEASE */.m9.SENTRY_RELEASE && helpers/* WINDOW.SENTRY_RELEASE.id */.m9.SENTRY_RELEASE.id) {
      options.release = helpers/* WINDOW.SENTRY_RELEASE.id */.m9.SENTRY_RELEASE.id;
    }
  }
  if (options.autoSessionTracking === undefined) {
    options.autoSessionTracking = true;
  }
  if (options.sendClientReports === undefined) {
    options.sendClientReports = true;
  }

  const clientOptions = {
    ...options,
    stackParser: (0,stacktrace/* stackParserFromStackParserOptions */.Sq)(options.stackParser || stack_parsers/* defaultStackParser */.Dt),
    integrations: (0,integration/* getIntegrationsToSetup */.m8)(options),
    transport: options.transport || ((0,supports/* supportsFetch */.Ak)() ? fetch/* makeFetchTransport */.f : xhr/* makeXHRTransport */.K),
  };

  initAndBind(client/* BrowserClient */.R, clientOptions);

  if (options.autoSessionTracking) {
    startSessionTracking();
  }
}

/**
 * Present the user with a report dialog.
 *
 * @param options Everything is optional, we try to fetch all info need from the global scope.
 */
function showReportDialog(options = {}, hub = (0,esm_hub/* getCurrentHub */.Gd)()) {
  // doesn't work without a document (React Native)
  if (!helpers/* WINDOW.document */.m9.document) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.error */.kg.error('Global document not defined in showReportDialog call');
    return;
  }

  const { client, scope } = hub.getStackTop();
  const dsn = options.dsn || (client && client.getDsn());
  if (!dsn) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.error */.kg.error('DSN not configured for showReportDialog call');
    return;
  }

  if (scope) {
    options.user = {
      ...scope.getUser(),
      ...options.user,
    };
  }

  if (!options.eventId) {
    options.eventId = hub.lastEventId();
  }

  const script = helpers/* WINDOW.document.createElement */.m9.document.createElement('script');
  script.async = true;
  script.src = (0,api/* getReportDialogEndpoint */.h)(dsn, options);

  if (options.onLoad) {
    script.onload = options.onLoad;
  }

  const injectionPoint = helpers/* WINDOW.document.head */.m9.document.head || helpers/* WINDOW.document.body */.m9.document.body;
  if (injectionPoint) {
    injectionPoint.appendChild(script);
  } else {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.error */.kg.error('Not injecting report dialog. No injection point found in HTML');
  }
}

/**
 * This is the getter for lastEventId.
 *
 * @returns The last event id of a captured event.
 */
function lastEventId() {
  return (0,esm_hub/* getCurrentHub */.Gd)().lastEventId();
}

/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */
function forceLoad() {
  // Noop
}

/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */
function onLoad(callback) {
  callback();
}

/**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */
function flush(timeout) {
  const client = (0,esm_hub/* getCurrentHub */.Gd)().getClient();
  if (client) {
    return client.flush(timeout);
  }
  (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.warn */.kg.warn('Cannot flush events. No client defined.');
  return (0,syncpromise/* resolvedSyncPromise */.WD)(false);
}

/**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */
function sdk_close(timeout) {
  const client = (0,esm_hub/* getCurrentHub */.Gd)().getClient();
  if (client) {
    return client.close(timeout);
  }
  (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.warn */.kg.warn('Cannot flush events and disable SDK. No client defined.');
  return (0,syncpromise/* resolvedSyncPromise */.WD)(false);
}

/**
 * Wrap code within a try/catch block so the SDK is able to capture errors.
 *
 * @param fn A function to wrap.
 *
 * @returns The result of wrapped function call.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function wrap(fn) {
  return (0,helpers/* wrap */.re)(fn)();
}

function startSessionOnHub(hub) {
  hub.startSession({ ignoreDuration: true });
  hub.captureSession();
}

/**
 * Enable automatic Session Tracking for the initial page load.
 */
function startSessionTracking() {
  if (typeof helpers/* WINDOW.document */.m9.document === 'undefined') {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      logger/* logger.warn */.kg.warn('Session tracking in non-browser environment with @sentry/browser is not supported.');
    return;
  }

  const hub = (0,esm_hub/* getCurrentHub */.Gd)();

  // The only way for this to be false is for there to be a version mismatch between @sentry/browser (>= 6.0.0) and
  // @sentry/hub (< 5.27.0). In the simple case, there won't ever be such a mismatch, because the two packages are
  // pinned at the same version in package.json, but there are edge cases where it's possible. See
  // https://github.com/getsentry/sentry-javascript/issues/3207 and
  // https://github.com/getsentry/sentry-javascript/issues/3234 and
  // https://github.com/getsentry/sentry-javascript/issues/3278.
  if (!hub.captureSession) {
    return;
  }

  // The session duration for browser sessions does not track a meaningful
  // concept that can be used as a metric.
  // Automatically captured sessions are akin to page views, and thus we
  // discard their duration.
  startSessionOnHub(hub);

  // We want to create a session for every navigation as well
  (0,instrument/* addInstrumentationHandler */.oq)('history', ({ from, to }) => {
    // Don't create an additional session for the initial route or if the location did not change
    if (!(from === undefined || from === to)) {
      startSessionOnHub((0,esm_hub/* getCurrentHub */.Gd)());
    }
  });
}

/**
 * Captures user feedback and sends it to Sentry.
 */
function captureUserFeedback(feedback) {
  const client = (0,esm_hub/* getCurrentHub */.Gd)().getClient();
  if (client) {
    client.captureUserFeedback(feedback);
  }
}


//# sourceMappingURL=sdk.js.map


/***/ }),

/***/ 97939:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$3": function() { return /* binding */ chromeStackLineParser; },
/* harmony export */   "$Q": function() { return /* binding */ geckoStackLineParser; },
/* harmony export */   "Dt": function() { return /* binding */ defaultStackParser; },
/* harmony export */   "HH": function() { return /* binding */ opera11StackLineParser; },
/* harmony export */   "NP": function() { return /* binding */ opera10StackLineParser; },
/* harmony export */   "R2": function() { return /* binding */ winjsStackLineParser; },
/* harmony export */   "d8": function() { return /* binding */ defaultStackLineParsers; }
/* harmony export */ });
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55514);


// global reference to slice
const UNKNOWN_FUNCTION = '?';

const OPERA10_PRIORITY = 10;
const OPERA11_PRIORITY = 20;
const CHROME_PRIORITY = 30;
const WINJS_PRIORITY = 40;
const GECKO_PRIORITY = 50;

function createFrame(filename, func, lineno, colno) {
  const frame = {
    filename,
    function: func,
    in_app: true, // All browser frames are considered in_app
  };

  if (lineno !== undefined) {
    frame.lineno = lineno;
  }

  if (colno !== undefined) {
    frame.colno = colno;
  }

  return frame;
}

// Chromium based browsers: Chrome, Brave, new Opera, new Edge
const chromeRegex =
  /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
const chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;

const chrome = line => {
  const parts = chromeRegex.exec(line);

  if (parts) {
    const isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line

    if (isEval) {
      const subMatch = chromeEvalRegex.exec(parts[2]);

      if (subMatch) {
        // throw out eval line/column and use top-most line/column number
        parts[2] = subMatch[1]; // url
        parts[3] = subMatch[2]; // line
        parts[4] = subMatch[3]; // column
      }
    }

    // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
    // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
    const [func, filename] = extractSafariExtensionDetails(parts[1] || UNKNOWN_FUNCTION, parts[2]);

    return createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
  }

  return;
};

const chromeStackLineParser = [CHROME_PRIORITY, chrome];

// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
const geckoREgex =
  /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
const geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;

const gecko = line => {
  const parts = geckoREgex.exec(line);

  if (parts) {
    const isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
    if (isEval) {
      const subMatch = geckoEvalRegex.exec(parts[3]);

      if (subMatch) {
        // throw out eval line/column and use top-most line number
        parts[1] = parts[1] || 'eval';
        parts[3] = subMatch[1];
        parts[4] = subMatch[2];
        parts[5] = ''; // no column when eval
      }
    }

    let filename = parts[3];
    let func = parts[1] || UNKNOWN_FUNCTION;
    [func, filename] = extractSafariExtensionDetails(func, filename);

    return createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
  }

  return;
};

const geckoStackLineParser = [GECKO_PRIORITY, gecko];

const winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i;

const winjs = line => {
  const parts = winjsRegex.exec(line);

  return parts
    ? createFrame(parts[2], parts[1] || UNKNOWN_FUNCTION, +parts[3], parts[4] ? +parts[4] : undefined)
    : undefined;
};

const winjsStackLineParser = [WINJS_PRIORITY, winjs];

const opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;

const opera10 = line => {
  const parts = opera10Regex.exec(line);
  return parts ? createFrame(parts[2], parts[3] || UNKNOWN_FUNCTION, +parts[1]) : undefined;
};

const opera10StackLineParser = [OPERA10_PRIORITY, opera10];

const opera11Regex =
  / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;

const opera11 = line => {
  const parts = opera11Regex.exec(line);
  return parts ? createFrame(parts[5], parts[3] || parts[4] || UNKNOWN_FUNCTION, +parts[1], +parts[2]) : undefined;
};

const opera11StackLineParser = [OPERA11_PRIORITY, opera11];

const defaultStackLineParsers = [chromeStackLineParser, geckoStackLineParser, winjsStackLineParser];

const defaultStackParser = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .createStackParser */ .pE)(...defaultStackLineParsers);

/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */
const extractSafariExtensionDetails = (func, filename) => {
  const isSafariExtension = func.indexOf('safari-extension') !== -1;
  const isSafariWebExtension = func.indexOf('safari-web-extension') !== -1;

  return isSafariExtension || isSafariWebExtension
    ? [
        func.indexOf('@') !== -1 ? func.split('@')[0] : UNKNOWN_FUNCTION,
        isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`,
      ]
    : [func, filename];
};


//# sourceMappingURL=stack-parsers.js.map


/***/ }),

/***/ 81804:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "f": function() { return /* binding */ makeFetchTransport; }
});

// EXTERNAL MODULE: ../node_modules/@sentry/core/esm/transports/base.js + 1 modules
var base = __webpack_require__(38862);
// EXTERNAL MODULE: ../node_modules/@sentry/utils/esm/syncpromise.js
var syncpromise = __webpack_require__(48894);
// EXTERNAL MODULE: ../node_modules/@sentry/utils/esm/supports.js
var supports = __webpack_require__(83589);
// EXTERNAL MODULE: ../node_modules/@sentry/utils/esm/logger.js
var logger = __webpack_require__(86922);
// EXTERNAL MODULE: ../node_modules/@sentry/browser/esm/helpers.js
var helpers = __webpack_require__(51197);
;// CONCATENATED MODULE: ../node_modules/@sentry/browser/esm/transports/utils.js



let cachedFetchImpl = undefined;

/**
 * A special usecase for incorrectly wrapped Fetch APIs in conjunction with ad-blockers.
 * Whenever someone wraps the Fetch API and returns the wrong promise chain,
 * this chain becomes orphaned and there is no possible way to capture it's rejections
 * other than allowing it bubble up to this very handler. eg.
 *
 * const f = window.fetch;
 * window.fetch = function () {
 *   const p = f.apply(this, arguments);
 *
 *   p.then(function() {
 *     console.log('hi.');
 *   });
 *
 *   return p;
 * }
 *
 * `p.then(function () { ... })` is producing a completely separate promise chain,
 * however, what's returned is `p` - the result of original `fetch` call.
 *
 * This mean, that whenever we use the Fetch API to send our own requests, _and_
 * some ad-blocker blocks it, this orphaned chain will _always_ reject,
 * effectively causing another event to be captured.
 * This makes a whole process become an infinite loop, which we need to somehow
 * deal with, and break it in one way or another.
 *
 * To deal with this issue, we are making sure that we _always_ use the real
 * browser Fetch API, instead of relying on what `window.fetch` exposes.
 * The only downside to this would be missing our own requests as breadcrumbs,
 * but because we are already not doing this, it should be just fine.
 *
 * Possible failed fetch error messages per-browser:
 *
 * Chrome:  Failed to fetch
 * Edge:    Failed to Fetch
 * Firefox: NetworkError when attempting to fetch resource
 * Safari:  resource blocked by content blocker
 */
function getNativeFetchImplementation() {
  if (cachedFetchImpl) {
    return cachedFetchImpl;
  }

  /* eslint-disable @typescript-eslint/unbound-method */

  // Fast path to avoid DOM I/O
  if ((0,supports/* isNativeFetch */.Du)(helpers/* WINDOW.fetch */.m9.fetch)) {
    return (cachedFetchImpl = helpers/* WINDOW.fetch.bind */.m9.fetch.bind(helpers/* WINDOW */.m9));
  }

  const document = helpers/* WINDOW.document */.m9.document;
  let fetchImpl = helpers/* WINDOW.fetch */.m9.fetch;
  // eslint-disable-next-line deprecation/deprecation
  if (document && typeof document.createElement === 'function') {
    try {
      const sandbox = document.createElement('iframe');
      sandbox.hidden = true;
      document.head.appendChild(sandbox);
      const contentWindow = sandbox.contentWindow;
      if (contentWindow && contentWindow.fetch) {
        fetchImpl = contentWindow.fetch;
      }
      document.head.removeChild(sandbox);
    } catch (e) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        logger/* logger.warn */.kg.warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', e);
    }
  }

  return (cachedFetchImpl = fetchImpl.bind(helpers/* WINDOW */.m9));
  /* eslint-enable @typescript-eslint/unbound-method */
}

/** Clears cached fetch impl */
function clearCachedFetchImplementation() {
  cachedFetchImpl = undefined;
}


//# sourceMappingURL=utils.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/browser/esm/transports/fetch.js




/**
 * Creates a Transport that uses the Fetch API to send events to Sentry.
 */
function makeFetchTransport(
  options,
  nativeFetch = getNativeFetchImplementation(),
) {
  let pendingBodySize = 0;
  let pendingCount = 0;

  function makeRequest(request) {
    const requestSize = request.body.length;
    pendingBodySize += requestSize;
    pendingCount++;

    const requestOptions = {
      body: request.body,
      method: 'POST',
      referrerPolicy: 'origin',
      headers: options.headers,
      // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
      // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
      // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
      // frequently sending events right before the user is switching pages (eg. whenfinishing navigation transactions).
      // Gotchas:
      // - `keepalive` isn't supported by Firefox
      // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
      //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
      //   We will therefore only activate the flag when we're below that limit.
      // There is also a limit of requests that can be open at the same time, so we also limit this to 15
      // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
      keepalive: pendingBodySize <= 60000 && pendingCount < 15,
      ...options.fetchOptions,
    };

    try {
      return nativeFetch(options.url, requestOptions).then(response => {
        pendingBodySize -= requestSize;
        pendingCount--;
        return {
          statusCode: response.status,
          headers: {
            'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
            'retry-after': response.headers.get('Retry-After'),
          },
        };
      });
    } catch (e) {
      clearCachedFetchImplementation();
      pendingBodySize -= requestSize;
      pendingCount--;
      return (0,syncpromise/* rejectedSyncPromise */.$2)(e);
    }
  }

  return (0,base/* createTransport */.q)(options, makeRequest);
}


//# sourceMappingURL=fetch.js.map


/***/ }),

/***/ 20296:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ makeXHRTransport; }
/* harmony export */ });
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(38862);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48894);



/**
 * The DONE ready state for XmlHttpRequest
 *
 * Defining it here as a constant b/c XMLHttpRequest.DONE is not always defined
 * (e.g. during testing, it is `undefined`)
 *
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/readyState}
 */
const XHR_READYSTATE_DONE = 4;

/**
 * Creates a Transport that uses the XMLHttpRequest API to send events to Sentry.
 */
function makeXHRTransport(options) {
  function makeRequest(request) {
    return new _sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .SyncPromise */ .cW((resolve, reject) => {
      const xhr = new XMLHttpRequest();

      xhr.onerror = reject;

      xhr.onreadystatechange = () => {
        if (xhr.readyState === XHR_READYSTATE_DONE) {
          resolve({
            statusCode: xhr.status,
            headers: {
              'x-sentry-rate-limits': xhr.getResponseHeader('X-Sentry-Rate-Limits'),
              'retry-after': xhr.getResponseHeader('Retry-After'),
            },
          });
        }
      };

      xhr.open('POST', options.url);

      for (const header in options.headers) {
        if (Object.prototype.hasOwnProperty.call(options.headers, header)) {
          xhr.setRequestHeader(header, options.headers[header]);
        }
      }

      xhr.send(request.body);
    });
  }

  return (0,_sentry_core__WEBPACK_IMPORTED_MODULE_1__/* .createTransport */ .q)(options, makeRequest);
}


//# sourceMappingURL=xhr.js.map


/***/ }),

/***/ 1367:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ createUserFeedbackEnvelope; }
/* harmony export */ });
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73166);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73285);


/**
 * Creates an envelope from a user feedback.
 */
function createUserFeedbackEnvelope(
  feedback,
  {
    metadata,
    tunnel,
    dsn,
  }

,
) {
  const headers = {
    event_id: feedback.event_id,
    sent_at: new Date().toISOString(),
    ...(metadata &&
      metadata.sdk && {
        sdk: {
          name: metadata.sdk.name,
          version: metadata.sdk.version,
        },
      }),
    ...(!!tunnel && !!dsn && { dsn: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .dsnToString */ .RA)(dsn) }),
  };
  const item = createUserFeedbackEnvelopeItem(feedback);

  return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .createEnvelope */ .Jd)(headers, [item]);
}

function createUserFeedbackEnvelopeItem(feedback) {
  const feedbackHeaders = {
    type: 'user_report',
  };
  return [feedbackHeaders, feedback];
}


//# sourceMappingURL=userfeedback.js.map


/***/ }),

/***/ 66485:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ getEnvelopeEndpointWithUrlEncodedAuth; },
/* harmony export */   "h": function() { return /* binding */ getReportDialogEndpoint; }
/* harmony export */ });
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39109);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73166);


const SENTRY_API_VERSION = '7';

/** Returns the prefix to construct Sentry ingestion API endpoints. */
function getBaseApiEndpoint(dsn) {
  const protocol = dsn.protocol ? `${dsn.protocol}:` : '';
  const port = dsn.port ? `:${dsn.port}` : '';
  return `${protocol}//${dsn.host}${port}${dsn.path ? `/${dsn.path}` : ''}/api/`;
}

/** Returns the ingest API endpoint for target. */
function _getIngestEndpoint(dsn) {
  return `${getBaseApiEndpoint(dsn)}${dsn.projectId}/envelope/`;
}

/** Returns a URL-encoded string with auth config suitable for a query string. */
function _encodedAuth(dsn, sdkInfo) {
  return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .urlEncode */ ._j)({
    // We send only the minimum set of required information. See
    // https://github.com/getsentry/sentry-javascript/issues/2572.
    sentry_key: dsn.publicKey,
    sentry_version: SENTRY_API_VERSION,
    ...(sdkInfo && { sentry_client: `${sdkInfo.name}/${sdkInfo.version}` }),
  });
}

/**
 * Returns the envelope endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */
function getEnvelopeEndpointWithUrlEncodedAuth(
  dsn,
  // TODO (v8): Remove `tunnelOrOptions` in favor of `options`, and use the substitute code below
  // options: ClientOptions = {} as ClientOptions,
  tunnelOrOptions = {} ,
) {
  // TODO (v8): Use this code instead
  // const { tunnel, _metadata = {} } = options;
  // return tunnel ? tunnel : `${_getIngestEndpoint(dsn)}?${_encodedAuth(dsn, _metadata.sdk)}`;

  const tunnel = typeof tunnelOrOptions === 'string' ? tunnelOrOptions : tunnelOrOptions.tunnel;
  const sdkInfo =
    typeof tunnelOrOptions === 'string' || !tunnelOrOptions._metadata ? undefined : tunnelOrOptions._metadata.sdk;

  return tunnel ? tunnel : `${_getIngestEndpoint(dsn)}?${_encodedAuth(dsn, sdkInfo)}`;
}

/** Returns the url to the report dialog endpoint. */
function getReportDialogEndpoint(
  dsnLike,
  dialogOptions

,
) {
  const dsn = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .makeDsn */ .vK)(dsnLike);
  if (!dsn) {
    return '';
  }

  const endpoint = `${getBaseApiEndpoint(dsn)}embed/error-page/`;

  let encodedOptions = `dsn=${(0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .dsnToString */ .RA)(dsn)}`;
  for (const key in dialogOptions) {
    if (key === 'dsn') {
      continue;
    }

    if (key === 'user') {
      const user = dialogOptions.user;
      if (!user) {
        continue;
      }
      if (user.name) {
        encodedOptions += `&name=${encodeURIComponent(user.name)}`;
      }
      if (user.email) {
        encodedOptions += `&email=${encodeURIComponent(user.email)}`;
      }
    } else {
      encodedOptions += `&${encodeURIComponent(key)}=${encodeURIComponent(dialogOptions[key] )}`;
    }
  }

  return `${endpoint}?${encodedOptions}`;
}


//# sourceMappingURL=api.js.map


/***/ }),

/***/ 99330:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ DEFAULT_ENVIRONMENT; }
/* harmony export */ });
const DEFAULT_ENVIRONMENT = 'production';


//# sourceMappingURL=constants.js.map


/***/ }),

/***/ 60074:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$e": function() { return /* binding */ withScope; },
/* harmony export */   "Tb": function() { return /* binding */ captureException; },
/* harmony export */   "YA": function() { return /* binding */ setTag; },
/* harmony export */   "Yr": function() { return /* binding */ startTransaction; },
/* harmony export */   "av": function() { return /* binding */ setUser; },
/* harmony export */   "e": function() { return /* binding */ configureScope; },
/* harmony export */   "eN": function() { return /* binding */ captureEvent; },
/* harmony export */   "mG": function() { return /* binding */ setTags; },
/* harmony export */   "n_": function() { return /* binding */ addBreadcrumb; },
/* harmony export */   "rJ": function() { return /* binding */ setExtras; },
/* harmony export */   "sU": function() { return /* binding */ setExtra; },
/* harmony export */   "uT": function() { return /* binding */ captureMessage; },
/* harmony export */   "v": function() { return /* binding */ setContext; }
/* harmony export */ });
/* unused harmony export captureCheckIn */
/* harmony import */ var _hub_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6878);



// Note: All functions in this file are typed with a return value of `ReturnType<Hub[HUB_FUNCTION]>`,
// where HUB_FUNCTION is some method on the Hub class.
//
// This is done to make sure the top level SDK methods stay in sync with the hub methods.
// Although every method here has an explicit return type, some of them (that map to void returns) do not
// contain `return` keywords. This is done to save on bundle size, as `return` is not minifiable.

/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception An exception-like object.
 * @param captureContext Additional scope data to apply to exception event.
 * @returns The generated eventId.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
function captureException(exception, captureContext) {
  return (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().captureException(exception, { captureContext });
}

/**
 * Captures a message event and sends it to Sentry.
 *
 * @param message The message to send to Sentry.
 * @param Severity Define the level of the message.
 * @returns The generated eventId.
 */
function captureMessage(
  message,
  // eslint-disable-next-line deprecation/deprecation
  captureContext,
) {
  // This is necessary to provide explicit scopes upgrade, without changing the original
  // arity of the `captureMessage(message, level)` method.
  const level = typeof captureContext === 'string' ? captureContext : undefined;
  const context = typeof captureContext !== 'string' ? { captureContext } : undefined;
  return (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().captureMessage(message, level, context);
}

/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param event The event to send to Sentry.
 * @returns The generated eventId.
 */
function captureEvent(event, hint) {
  return (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().captureEvent(event, hint);
}

/**
 * Callback to set context information onto the scope.
 * @param callback Callback function that receives Scope.
 */
function configureScope(callback) {
  (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().configureScope(callback);
}

/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 *
 * @param breadcrumb The breadcrumb to record.
 */
function addBreadcrumb(breadcrumb) {
  (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().addBreadcrumb(breadcrumb);
}

/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function setContext(name, context) {
  (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().setContext(name, context);
}

/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */
function setExtras(extras) {
  (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().setExtras(extras);
}

/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */
function setExtra(key, extra) {
  (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().setExtra(key, extra);
}

/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */
function setTags(tags) {
  (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().setTags(tags);
}

/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */
function setTag(key, value) {
  (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().setTag(key, value);
}

/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */
function setUser(user) {
  (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().setUser(user);
}

/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 *
 * This is essentially a convenience function for:
 *
 *     pushScope();
 *     callback();
 *     popScope();
 *
 * @param callback that will be enclosed into push/popScope.
 */
function withScope(callback) {
  (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().withScope(callback);
}

/**
 * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
 *
 * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
 * new child span within the transaction or any span, call the respective `.startChild()` method.
 *
 * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
 *
 * The transaction must be finished with a call to its `.finish()` method, at which point the transaction with all its
 * finished child spans will be sent to Sentry.
 *
 * NOTE: This function should only be used for *manual* instrumentation. Auto-instrumentation should call
 * `startTransaction` directly on the hub.
 *
 * @param context Properties of the new `Transaction`.
 * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
 * default values). See {@link Options.tracesSampler}.
 *
 * @returns The transaction which was just started
 */
function startTransaction(
  context,
  customSamplingContext,
) {
  return (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().startTransaction({ ...context }, customSamplingContext);
}

/**
 * Create a cron monitor check in and send it to Sentry.
 *
 * @param checkIn An object that describes a check in.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */
function captureCheckIn(checkIn, upsertMonitorConfig) {
  const client = getCurrentHub().getClient();
  if (!client) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.warn('Cannot capture check-in. No client defined.');
  } else if (!client.captureCheckIn) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.warn('Cannot capture check-in. Client does not support sending check-ins.');
  } else {
    return client.captureCheckIn(checkIn, upsertMonitorConfig);
  }

  return uuid4();
}


//# sourceMappingURL=exports.js.map


/***/ }),

/***/ 6878:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gd": function() { return /* binding */ getCurrentHub; },
/* harmony export */   "Xb": function() { return /* binding */ Hub; },
/* harmony export */   "cu": function() { return /* binding */ getMainCarrier; },
/* harmony export */   "pj": function() { return /* binding */ makeMain; },
/* harmony export */   "vi": function() { return /* binding */ getHubFromCarrier; }
/* harmony export */ });
/* unused harmony exports API_VERSION, ensureHubOnCarrier, runWithAsyncContext, setAsyncContextStrategy, setHubOnCarrier */
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67451);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94180);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86922);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(74211);
/* harmony import */ var _constants_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99330);
/* harmony import */ var _scope_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25516);
/* harmony import */ var _session_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(89015);





/**
 * API compatibility version of this hub.
 *
 * WARNING: This number should only be increased when the global interface
 * changes and new methods are introduced.
 *
 * @hidden
 */
const API_VERSION = 4;

/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */
const DEFAULT_BREADCRUMBS = 100;

/**
 * @inheritDoc
 */
class Hub  {
  /** Is a {@link Layer}[] containing the client and scope */

  /** Contains the last event id of a captured event.  */

  /**
   * Creates a new instance of the hub, will push one {@link Layer} into the
   * internal stack on creation.
   *
   * @param client bound to the hub.
   * @param scope bound to the hub.
   * @param version number, higher number means higher priority.
   */
   constructor(client, scope = new _scope_js__WEBPACK_IMPORTED_MODULE_0__/* .Scope */ .s(),   _version = API_VERSION) {this._version = _version;
    this._stack = [{ scope }];
    if (client) {
      this.bindClient(client);
    }
  }

  /**
   * @inheritDoc
   */
   isOlderThan(version) {
    return this._version < version;
  }

  /**
   * @inheritDoc
   */
   bindClient(client) {
    const top = this.getStackTop();
    top.client = client;
    if (client && client.setupIntegrations) {
      client.setupIntegrations();
    }
  }

  /**
   * @inheritDoc
   */
   pushScope() {
    // We want to clone the content of prev scope
    const scope = _scope_js__WEBPACK_IMPORTED_MODULE_0__/* .Scope.clone */ .s.clone(this.getScope());
    this.getStack().push({
      client: this.getClient(),
      scope,
    });
    return scope;
  }

  /**
   * @inheritDoc
   */
   popScope() {
    if (this.getStack().length <= 1) return false;
    return !!this.getStack().pop();
  }

  /**
   * @inheritDoc
   */
   withScope(callback) {
    const scope = this.pushScope();
    try {
      callback(scope);
    } finally {
      this.popScope();
    }
  }

  /**
   * @inheritDoc
   */
   getClient() {
    return this.getStackTop().client ;
  }

  /** Returns the scope of the top stack. */
   getScope() {
    return this.getStackTop().scope;
  }

  /** Returns the scope stack for domains or the process. */
   getStack() {
    return this._stack;
  }

  /** Returns the topmost scope layer in the order domain > local > process. */
   getStackTop() {
    return this._stack[this._stack.length - 1];
  }

  /**
   * @inheritDoc
   */
   captureException(exception, hint) {
    const eventId = (this._lastEventId = hint && hint.event_id ? hint.event_id : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)());
    const syntheticException = new Error('Sentry syntheticException');
    this._withClient((client, scope) => {
      client.captureException(
        exception,
        {
          originalException: exception,
          syntheticException,
          ...hint,
          event_id: eventId,
        },
        scope,
      );
    });
    return eventId;
  }

  /**
   * @inheritDoc
   */
   captureMessage(
    message,
    // eslint-disable-next-line deprecation/deprecation
    level,
    hint,
  ) {
    const eventId = (this._lastEventId = hint && hint.event_id ? hint.event_id : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)());
    const syntheticException = new Error(message);
    this._withClient((client, scope) => {
      client.captureMessage(
        message,
        level,
        {
          originalException: message,
          syntheticException,
          ...hint,
          event_id: eventId,
        },
        scope,
      );
    });
    return eventId;
  }

  /**
   * @inheritDoc
   */
   captureEvent(event, hint) {
    const eventId = hint && hint.event_id ? hint.event_id : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)();
    if (!event.type) {
      this._lastEventId = eventId;
    }

    this._withClient((client, scope) => {
      client.captureEvent(event, { ...hint, event_id: eventId }, scope);
    });
    return eventId;
  }

  /**
   * @inheritDoc
   */
   lastEventId() {
    return this._lastEventId;
  }

  /**
   * @inheritDoc
   */
   addBreadcrumb(breadcrumb, hint) {
    const { scope, client } = this.getStackTop();

    if (!client) return;

    const { beforeBreadcrumb = null, maxBreadcrumbs = DEFAULT_BREADCRUMBS } =
      (client.getOptions && client.getOptions()) || {};

    if (maxBreadcrumbs <= 0) return;

    const timestamp = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .dateTimestampInSeconds */ .yW)();
    const mergedBreadcrumb = { timestamp, ...breadcrumb };
    const finalBreadcrumb = beforeBreadcrumb
      ? ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .consoleSandbox */ .Cf)(() => beforeBreadcrumb(mergedBreadcrumb, hint)) )
      : mergedBreadcrumb;

    if (finalBreadcrumb === null) return;

    if (client.emit) {
      client.emit('beforeAddBreadcrumb', finalBreadcrumb, hint);
    }

    scope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
  }

  /**
   * @inheritDoc
   */
   setUser(user) {
    this.getScope().setUser(user);
  }

  /**
   * @inheritDoc
   */
   setTags(tags) {
    this.getScope().setTags(tags);
  }

  /**
   * @inheritDoc
   */
   setExtras(extras) {
    this.getScope().setExtras(extras);
  }

  /**
   * @inheritDoc
   */
   setTag(key, value) {
    this.getScope().setTag(key, value);
  }

  /**
   * @inheritDoc
   */
   setExtra(key, extra) {
    this.getScope().setExtra(key, extra);
  }

  /**
   * @inheritDoc
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
   setContext(name, context) {
    this.getScope().setContext(name, context);
  }

  /**
   * @inheritDoc
   */
   configureScope(callback) {
    const { scope, client } = this.getStackTop();
    if (client) {
      callback(scope);
    }
  }

  /**
   * @inheritDoc
   */
   run(callback) {
    const oldHub = makeMain(this);
    try {
      callback(this);
    } finally {
      makeMain(oldHub);
    }
  }

  /**
   * @inheritDoc
   */
   getIntegration(integration) {
    const client = this.getClient();
    if (!client) return null;
    try {
      return client.getIntegration(integration);
    } catch (_oO) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.warn */ .kg.warn(`Cannot retrieve integration ${integration.id} from the current Hub`);
      return null;
    }
  }

  /**
   * @inheritDoc
   */
   startTransaction(context, customSamplingContext) {
    const result = this._callExtensionMethod('startTransaction', context, customSamplingContext);

    if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && !result) {
      // eslint-disable-next-line no-console
      console.warn(`Tracing extension 'startTransaction' has not been added. Call 'addTracingExtensions' before calling 'init':
Sentry.addTracingExtensions();
Sentry.init({...});
`);
    }

    return result;
  }

  /**
   * @inheritDoc
   */
   traceHeaders() {
    return this._callExtensionMethod('traceHeaders');
  }

  /**
   * @inheritDoc
   */
   captureSession(endSession = false) {
    // both send the update and pull the session from the scope
    if (endSession) {
      return this.endSession();
    }

    // only send the update
    this._sendSessionUpdate();
  }

  /**
   * @inheritDoc
   */
   endSession() {
    const layer = this.getStackTop();
    const scope = layer.scope;
    const session = scope.getSession();
    if (session) {
      (0,_session_js__WEBPACK_IMPORTED_MODULE_4__/* .closeSession */ .RJ)(session);
    }
    this._sendSessionUpdate();

    // the session is over; take it off of the scope
    scope.setSession();
  }

  /**
   * @inheritDoc
   */
   startSession(context) {
    const { scope, client } = this.getStackTop();
    const { release, environment = _constants_js__WEBPACK_IMPORTED_MODULE_5__/* .DEFAULT_ENVIRONMENT */ .J } = (client && client.getOptions()) || {};

    // Will fetch userAgent if called from browser sdk
    const { userAgent } = _sentry_utils__WEBPACK_IMPORTED_MODULE_6__/* .GLOBAL_OBJ.navigator */ .n2.navigator || {};

    const session = (0,_session_js__WEBPACK_IMPORTED_MODULE_4__/* .makeSession */ .Hv)({
      release,
      environment,
      user: scope.getUser(),
      ...(userAgent && { userAgent }),
      ...context,
    });

    // End existing session if there's one
    const currentSession = scope.getSession && scope.getSession();
    if (currentSession && currentSession.status === 'ok') {
      (0,_session_js__WEBPACK_IMPORTED_MODULE_4__/* .updateSession */ .CT)(currentSession, { status: 'exited' });
    }
    this.endSession();

    // Afterwards we set the new session on the scope
    scope.setSession(session);

    return session;
  }

  /**
   * Returns if default PII should be sent to Sentry and propagated in ourgoing requests
   * when Tracing is used.
   */
   shouldSendDefaultPii() {
    const client = this.getClient();
    const options = client && client.getOptions();
    return Boolean(options && options.sendDefaultPii);
  }

  /**
   * Sends the current Session on the scope
   */
   _sendSessionUpdate() {
    const { scope, client } = this.getStackTop();

    const session = scope.getSession();
    if (session && client && client.captureSession) {
      client.captureSession(session);
    }
  }

  /**
   * Internal helper function to call a method on the top client if it exists.
   *
   * @param method The method to call on the client.
   * @param args Arguments to pass to the client function.
   */
   _withClient(callback) {
    const { scope, client } = this.getStackTop();
    if (client) {
      callback(client, scope);
    }
  }

  /**
   * Calls global extension method and binding current instance to the function call
   */
  // @ts-ignore Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
   _callExtensionMethod(method, ...args) {
    const carrier = getMainCarrier();
    const sentry = carrier.__SENTRY__;
    if (sentry && sentry.extensions && typeof sentry.extensions[method] === 'function') {
      return sentry.extensions[method].apply(this, args);
    }
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.warn */ .kg.warn(`Extension method ${method} couldn't be found, doing nothing.`);
  }
}

/**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/
function getMainCarrier() {
  _sentry_utils__WEBPACK_IMPORTED_MODULE_6__/* .GLOBAL_OBJ.__SENTRY__ */ .n2.__SENTRY__ = _sentry_utils__WEBPACK_IMPORTED_MODULE_6__/* .GLOBAL_OBJ.__SENTRY__ */ .n2.__SENTRY__ || {
    extensions: {},
    hub: undefined,
  };
  return _sentry_utils__WEBPACK_IMPORTED_MODULE_6__/* .GLOBAL_OBJ */ .n2;
}

/**
 * Replaces the current main hub with the passed one on the global object
 *
 * @returns The old replaced hub
 */
function makeMain(hub) {
  const registry = getMainCarrier();
  const oldHub = getHubFromCarrier(registry);
  setHubOnCarrier(registry, hub);
  return oldHub;
}

/**
 * Returns the default hub instance.
 *
 * If a hub is already registered in the global carrier but this module
 * contains a more recent version, it replaces the registered version.
 * Otherwise, the currently registered hub will be returned.
 */
function getCurrentHub() {
  // Get main carrier (global for every environment)
  const registry = getMainCarrier();

  if (registry.__SENTRY__ && registry.__SENTRY__.acs) {
    const hub = registry.__SENTRY__.acs.getCurrentHub();

    if (hub) {
      return hub;
    }
  }

  // Return hub that lives on a global object
  return getGlobalHub(registry);
}

function getGlobalHub(registry = getMainCarrier()) {
  // If there's no hub, or its an old API, assign a new one
  if (!hasHubOnCarrier(registry) || getHubFromCarrier(registry).isOlderThan(API_VERSION)) {
    setHubOnCarrier(registry, new Hub());
  }

  // Return hub that lives on a global object
  return getHubFromCarrier(registry);
}

/**
 * @private Private API with no semver guarantees!
 *
 * If the carrier does not contain a hub, a new hub is created with the global hub client and scope.
 */
function ensureHubOnCarrier(carrier, parent = getGlobalHub()) {
  // If there's no hub on current domain, or it's an old API, assign a new one
  if (!hasHubOnCarrier(carrier) || getHubFromCarrier(carrier).isOlderThan(API_VERSION)) {
    const globalHubTopStack = parent.getStackTop();
    setHubOnCarrier(carrier, new Hub(globalHubTopStack.client, Scope.clone(globalHubTopStack.scope)));
  }
}

/**
 * @private Private API with no semver guarantees!
 *
 * Sets the global async context strategy
 */
function setAsyncContextStrategy(strategy) {
  // Get main carrier (global for every environment)
  const registry = getMainCarrier();
  registry.__SENTRY__ = registry.__SENTRY__ || {};
  registry.__SENTRY__.acs = strategy;
}

/**
 * Runs the supplied callback in its own async context. Async Context strategies are defined per SDK.
 *
 * @param callback The callback to run in its own async context
 * @param options Options to pass to the async context strategy
 * @returns The result of the callback
 */
function runWithAsyncContext(callback, options = {}) {
  const registry = getMainCarrier();

  if (registry.__SENTRY__ && registry.__SENTRY__.acs) {
    return registry.__SENTRY__.acs.runWithAsyncContext(callback, options);
  }

  // if there was no strategy, fallback to just calling the callback
  return callback();
}

/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */
function hasHubOnCarrier(carrier) {
  return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
}

/**
 * This will create a new {@link Hub} and add to the passed object on
 * __SENTRY__.hub.
 * @param carrier object
 * @hidden
 */
function getHubFromCarrier(carrier) {
  return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_6__/* .getGlobalSingleton */ .YO)('hub', () => new Hub(), carrier);
}

/**
 * This will set passed {@link Hub} on the passed object's __SENTRY__.hub attribute
 * @param carrier object
 * @param hub Hub
 * @returns A boolean indicating success or failure
 */
function setHubOnCarrier(carrier, hub) {
  if (!carrier) return false;
  const __SENTRY__ = (carrier.__SENTRY__ = carrier.__SENTRY__ || {});
  __SENTRY__.hub = hub;
  return true;
}


//# sourceMappingURL=hub.js.map


/***/ }),

/***/ 99354:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m7": function() { return /* binding */ setupIntegration; },
/* harmony export */   "m8": function() { return /* binding */ getIntegrationsToSetup; },
/* harmony export */   "q4": function() { return /* binding */ setupIntegrations; }
/* harmony export */ });
/* unused harmony export installedIntegrations */
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67451);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86922);
/* harmony import */ var _hub_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6878);
/* harmony import */ var _scope_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25516);




const installedIntegrations = [];

/** Map of integrations assigned to a client */

/**
 * Remove duplicates from the given array, preferring the last instance of any duplicate. Not guaranteed to
 * preseve the order of integrations in the array.
 *
 * @private
 */
function filterDuplicates(integrations) {
  const integrationsByName = {};

  integrations.forEach(currentInstance => {
    const { name } = currentInstance;

    const existingInstance = integrationsByName[name];

    // We want integrations later in the array to overwrite earlier ones of the same type, except that we never want a
    // default instance to overwrite an existing user instance
    if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) {
      return;
    }

    integrationsByName[name] = currentInstance;
  });

  return Object.keys(integrationsByName).map(k => integrationsByName[k]);
}

/** Gets integrations to install */
function getIntegrationsToSetup(options) {
  const defaultIntegrations = options.defaultIntegrations || [];
  const userIntegrations = options.integrations;

  // We flag default instances, so that later we can tell them apart from any user-created instances of the same class
  defaultIntegrations.forEach(integration => {
    integration.isDefaultInstance = true;
  });

  let integrations;

  if (Array.isArray(userIntegrations)) {
    integrations = [...defaultIntegrations, ...userIntegrations];
  } else if (typeof userIntegrations === 'function') {
    integrations = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .arrayify */ .lE)(userIntegrations(defaultIntegrations));
  } else {
    integrations = defaultIntegrations;
  }

  const finalIntegrations = filterDuplicates(integrations);

  // The `Debug` integration prints copies of the `event` and `hint` which will be passed to `beforeSend` or
  // `beforeSendTransaction`. It therefore has to run after all other integrations, so that the changes of all event
  // processors will be reflected in the printed values. For lack of a more elegant way to guarantee that, we therefore
  // locate it and, assuming it exists, pop it out of its current spot and shove it onto the end of the array.
  const debugIndex = findIndex(finalIntegrations, integration => integration.name === 'Debug');
  if (debugIndex !== -1) {
    const [debugInstance] = finalIntegrations.splice(debugIndex, 1);
    finalIntegrations.push(debugInstance);
  }

  return finalIntegrations;
}

/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */
function setupIntegrations(integrations) {
  const integrationIndex = {};

  integrations.forEach(integration => {
    // guard against empty provided integrations
    if (integration) {
      setupIntegration(integration, integrationIndex);
    }
  });

  return integrationIndex;
}

/** Setup a single integration.  */
function setupIntegration(integration, integrationIndex) {
  integrationIndex[integration.name] = integration;

  if (installedIntegrations.indexOf(integration.name) === -1) {
    integration.setupOnce(_scope_js__WEBPACK_IMPORTED_MODULE_1__/* .addGlobalEventProcessor */ .c, _hub_js__WEBPACK_IMPORTED_MODULE_2__/* .getCurrentHub */ .Gd);
    installedIntegrations.push(integration.name);
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log(`Integration installed: ${integration.name}`);
  }
}

// Polyfill for Array.findIndex(), which is not supported in ES5
function findIndex(arr, callback) {
  for (let i = 0; i < arr.length; i++) {
    if (callback(arr[i]) === true) {
      return i;
    }
  }

  return -1;
}


//# sourceMappingURL=integration.js.map


/***/ }),

/***/ 14979:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ FunctionToString; }
/* harmony export */ });
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39109);


let originalFunctionToString;

/** Patch toString calls to return proper name for wrapped functions */
class FunctionToString  {constructor() { FunctionToString.prototype.__init.call(this); }
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'FunctionToString';}

  /**
   * @inheritDoc
   */
   __init() {this.name = FunctionToString.id;}

  /**
   * @inheritDoc
   */
   setupOnce() {
    // eslint-disable-next-line @typescript-eslint/unbound-method
    originalFunctionToString = Function.prototype.toString;

    // intrinsics (like Function.prototype) might be immutable in some environments
    // e.g. Node with --frozen-intrinsics, XS (an embedded JavaScript engine) or SES (a JavaScript proposal)
    try {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      Function.prototype.toString = function ( ...args) {
        const context = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .getOriginalFunction */ .HK)(this) || this;
        return originalFunctionToString.apply(context, args);
      };
    } catch (e) {
      // ignore errors here, just don't patch this
    }
  }
} FunctionToString.__initStatic();


//# sourceMappingURL=functiontostring.js.map


/***/ }),

/***/ 37107:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QD": function() { return /* binding */ InboundFilters; }
/* harmony export */ });
/* unused harmony exports _mergeOptions, _shouldDropEvent */
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(86922);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67451);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65268);


// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
const DEFAULT_IGNORE_ERRORS = [/^Script error\.?$/, /^Javascript error: Script error\.? on line 0$/];

const DEFAULT_IGNORE_TRANSACTIONS = [
  /^.*healthcheck.*$/,
  /^.*healthy.*$/,
  /^.*live.*$/,
  /^.*ready.*$/,
  /^.*heartbeat.*$/,
  /^.*\/health$/,
  /^.*\/healthz$/,
];

/** Options for the InboundFilters integration */

/** Inbound filters configurable by the user */
class InboundFilters  {
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'InboundFilters';}

  /**
   * @inheritDoc
   */
   __init() {this.name = InboundFilters.id;}

   constructor(  _options = {}) {this._options = _options;InboundFilters.prototype.__init.call(this);}

  /**
   * @inheritDoc
   */
   setupOnce(addGlobalEventProcessor, getCurrentHub) {
    const eventProcess = (event) => {
      const hub = getCurrentHub();
      if (hub) {
        const self = hub.getIntegration(InboundFilters);
        if (self) {
          const client = hub.getClient();
          const clientOptions = client ? client.getOptions() : {};
          const options = _mergeOptions(self._options, clientOptions);
          return _shouldDropEvent(event, options) ? null : event;
        }
      }
      return event;
    };

    eventProcess.id = this.name;
    addGlobalEventProcessor(eventProcess);
  }
} InboundFilters.__initStatic();

/** JSDoc */
function _mergeOptions(
  internalOptions = {},
  clientOptions = {},
) {
  return {
    allowUrls: [...(internalOptions.allowUrls || []), ...(clientOptions.allowUrls || [])],
    denyUrls: [...(internalOptions.denyUrls || []), ...(clientOptions.denyUrls || [])],
    ignoreErrors: [
      ...(internalOptions.ignoreErrors || []),
      ...(clientOptions.ignoreErrors || []),
      ...(internalOptions.disableErrorDefaults ? [] : DEFAULT_IGNORE_ERRORS),
    ],
    ignoreTransactions: [
      ...(internalOptions.ignoreTransactions || []),
      ...(clientOptions.ignoreTransactions || []),
      ...(internalOptions.disableTransactionDefaults ? [] : DEFAULT_IGNORE_TRANSACTIONS),
    ],
    ignoreInternal: internalOptions.ignoreInternal !== undefined ? internalOptions.ignoreInternal : true,
  };
}

/** JSDoc */
function _shouldDropEvent(event, options) {
  if (options.ignoreInternal && _isSentryError(event)) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      _sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .logger.warn */ .kg.warn(`Event dropped due to being internal Sentry Error.\nEvent: ${(0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .getEventDescription */ .jH)(event)}`);
    return true;
  }
  if (_isIgnoredError(event, options.ignoreErrors)) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      _sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .logger.warn */ .kg.warn(
        `Event dropped due to being matched by \`ignoreErrors\` option.\nEvent: ${(0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .getEventDescription */ .jH)(event)}`,
      );
    return true;
  }
  if (_isIgnoredTransaction(event, options.ignoreTransactions)) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      _sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .logger.warn */ .kg.warn(
        `Event dropped due to being matched by \`ignoreTransactions\` option.\nEvent: ${(0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .getEventDescription */ .jH)(event)}`,
      );
    return true;
  }
  if (_isDeniedUrl(event, options.denyUrls)) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      _sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .logger.warn */ .kg.warn(
        `Event dropped due to being matched by \`denyUrls\` option.\nEvent: ${(0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .getEventDescription */ .jH)(
          event,
        )}.\nUrl: ${_getEventFilterUrl(event)}`,
      );
    return true;
  }
  if (!_isAllowedUrl(event, options.allowUrls)) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      _sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .logger.warn */ .kg.warn(
        `Event dropped due to not being matched by \`allowUrls\` option.\nEvent: ${(0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .getEventDescription */ .jH)(
          event,
        )}.\nUrl: ${_getEventFilterUrl(event)}`,
      );
    return true;
  }
  return false;
}

function _isIgnoredError(event, ignoreErrors) {
  // If event.type, this is not an error
  if (event.type || !ignoreErrors || !ignoreErrors.length) {
    return false;
  }

  return _getPossibleEventMessages(event).some(message => (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .stringMatchesSomePattern */ .U0)(message, ignoreErrors));
}

function _isIgnoredTransaction(event, ignoreTransactions) {
  if (event.type !== 'transaction' || !ignoreTransactions || !ignoreTransactions.length) {
    return false;
  }

  const name = event.transaction;
  return name ? (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .stringMatchesSomePattern */ .U0)(name, ignoreTransactions) : false;
}

function _isDeniedUrl(event, denyUrls) {
  // TODO: Use Glob instead?
  if (!denyUrls || !denyUrls.length) {
    return false;
  }
  const url = _getEventFilterUrl(event);
  return !url ? false : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .stringMatchesSomePattern */ .U0)(url, denyUrls);
}

function _isAllowedUrl(event, allowUrls) {
  // TODO: Use Glob instead?
  if (!allowUrls || !allowUrls.length) {
    return true;
  }
  const url = _getEventFilterUrl(event);
  return !url ? true : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .stringMatchesSomePattern */ .U0)(url, allowUrls);
}

function _getPossibleEventMessages(event) {
  if (event.message) {
    return [event.message];
  }
  if (event.exception) {
    const { values } = event.exception;
    try {
      const { type = '', value = '' } = (values && values[values.length - 1]) || {};
      return [`${value}`, `${type}: ${value}`];
    } catch (oO) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .logger.error */ .kg.error(`Cannot extract message for event ${(0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .getEventDescription */ .jH)(event)}`);
      return [];
    }
  }
  return [];
}

function _isSentryError(event) {
  try {
    // @ts-ignore can't be a sentry error if undefined
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return event.exception.values[0].type === 'SentryError';
  } catch (e) {
    // ignore
  }
  return false;
}

function _getLastValidUrl(frames = []) {
  for (let i = frames.length - 1; i >= 0; i--) {
    const frame = frames[i];

    if (frame && frame.filename !== '<anonymous>' && frame.filename !== '[native code]') {
      return frame.filename || null;
    }
  }

  return null;
}

function _getEventFilterUrl(event) {
  try {
    let frames;
    try {
      // @ts-ignore we only care about frames if the whole thing here is defined
      frames = event.exception.values[0].stacktrace.frames;
    } catch (e) {
      // ignore
    }
    return frames ? _getLastValidUrl(frames) : null;
  } catch (oO) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .logger.error */ .kg.error(`Cannot extract url for event ${(0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .getEventDescription */ .jH)(event)}`);
    return null;
  }
}


//# sourceMappingURL=inboundfilters.js.map


/***/ }),

/***/ 25516:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ addGlobalEventProcessor; },
/* harmony export */   "s": function() { return /* binding */ Scope; }
/* harmony export */ });
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66885);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94180);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48894);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86922);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67451);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(74211);
/* harmony import */ var _session_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89015);



/**
 * Default value for maximum number of breadcrumbs added to an event.
 */
const DEFAULT_MAX_BREADCRUMBS = 100;

/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */
class Scope  {
  /** Flag if notifying is happening. */

  /** Callback for client to receive scope changes. */

  /** Callback list that will be called after {@link applyToEvent}. */

  /** Array of breadcrumbs. */

  /** User */

  /** Tags */

  /** Extra */

  /** Contexts */

  /** Attachments */

  /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */

  /** Fingerprint */

  /** Severity */
  // eslint-disable-next-line deprecation/deprecation

  /** Transaction Name */

  /** Span */

  /** Session */

  /** Request Mode Session Status */

  // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.

   constructor() {
    this._notifyingListeners = false;
    this._scopeListeners = [];
    this._eventProcessors = [];
    this._breadcrumbs = [];
    this._attachments = [];
    this._user = {};
    this._tags = {};
    this._extra = {};
    this._contexts = {};
    this._sdkProcessingMetadata = {};
  }

  /**
   * Inherit values from the parent scope.
   * @param scope to clone.
   */
   static clone(scope) {
    const newScope = new Scope();
    if (scope) {
      newScope._breadcrumbs = [...scope._breadcrumbs];
      newScope._tags = { ...scope._tags };
      newScope._extra = { ...scope._extra };
      newScope._contexts = { ...scope._contexts };
      newScope._user = scope._user;
      newScope._level = scope._level;
      newScope._span = scope._span;
      newScope._session = scope._session;
      newScope._transactionName = scope._transactionName;
      newScope._fingerprint = scope._fingerprint;
      newScope._eventProcessors = [...scope._eventProcessors];
      newScope._requestSession = scope._requestSession;
      newScope._attachments = [...scope._attachments];
      newScope._sdkProcessingMetadata = { ...scope._sdkProcessingMetadata };
    }
    return newScope;
  }

  /**
   * Add internal on change listener. Used for sub SDKs that need to store the scope.
   * @hidden
   */
   addScopeListener(callback) {
    this._scopeListeners.push(callback);
  }

  /**
   * @inheritDoc
   */
   addEventProcessor(callback) {
    this._eventProcessors.push(callback);
    return this;
  }

  /**
   * @inheritDoc
   */
   setUser(user) {
    this._user = user || {};
    if (this._session) {
      (0,_session_js__WEBPACK_IMPORTED_MODULE_0__/* .updateSession */ .CT)(this._session, { user });
    }
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   getUser() {
    return this._user;
  }

  /**
   * @inheritDoc
   */
   getRequestSession() {
    return this._requestSession;
  }

  /**
   * @inheritDoc
   */
   setRequestSession(requestSession) {
    this._requestSession = requestSession;
    return this;
  }

  /**
   * @inheritDoc
   */
   setTags(tags) {
    this._tags = {
      ...this._tags,
      ...tags,
    };
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setTag(key, value) {
    this._tags = { ...this._tags, [key]: value };
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setExtras(extras) {
    this._extra = {
      ...this._extra,
      ...extras,
    };
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setExtra(key, extra) {
    this._extra = { ...this._extra, [key]: extra };
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setFingerprint(fingerprint) {
    this._fingerprint = fingerprint;
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setLevel(
    // eslint-disable-next-line deprecation/deprecation
    level,
  ) {
    this._level = level;
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setTransactionName(name) {
    this._transactionName = name;
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setContext(key, context) {
    if (context === null) {
      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete this._contexts[key];
    } else {
      this._contexts[key] = context;
    }

    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setSpan(span) {
    this._span = span;
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   getSpan() {
    return this._span;
  }

  /**
   * @inheritDoc
   */
   getTransaction() {
    // Often, this span (if it exists at all) will be a transaction, but it's not guaranteed to be. Regardless, it will
    // have a pointer to the currently-active transaction.
    const span = this.getSpan();
    return span && span.transaction;
  }

  /**
   * @inheritDoc
   */
   setSession(session) {
    if (!session) {
      delete this._session;
    } else {
      this._session = session;
    }
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   getSession() {
    return this._session;
  }

  /**
   * @inheritDoc
   */
   update(captureContext) {
    if (!captureContext) {
      return this;
    }

    if (typeof captureContext === 'function') {
      const updatedScope = (captureContext )(this);
      return updatedScope instanceof Scope ? updatedScope : this;
    }

    if (captureContext instanceof Scope) {
      this._tags = { ...this._tags, ...captureContext._tags };
      this._extra = { ...this._extra, ...captureContext._extra };
      this._contexts = { ...this._contexts, ...captureContext._contexts };
      if (captureContext._user && Object.keys(captureContext._user).length) {
        this._user = captureContext._user;
      }
      if (captureContext._level) {
        this._level = captureContext._level;
      }
      if (captureContext._fingerprint) {
        this._fingerprint = captureContext._fingerprint;
      }
      if (captureContext._requestSession) {
        this._requestSession = captureContext._requestSession;
      }
    } else if ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .isPlainObject */ .PO)(captureContext)) {
      // eslint-disable-next-line no-param-reassign
      captureContext = captureContext ;
      this._tags = { ...this._tags, ...captureContext.tags };
      this._extra = { ...this._extra, ...captureContext.extra };
      this._contexts = { ...this._contexts, ...captureContext.contexts };
      if (captureContext.user) {
        this._user = captureContext.user;
      }
      if (captureContext.level) {
        this._level = captureContext.level;
      }
      if (captureContext.fingerprint) {
        this._fingerprint = captureContext.fingerprint;
      }
      if (captureContext.requestSession) {
        this._requestSession = captureContext.requestSession;
      }
    }

    return this;
  }

  /**
   * @inheritDoc
   */
   clear() {
    this._breadcrumbs = [];
    this._tags = {};
    this._extra = {};
    this._user = {};
    this._contexts = {};
    this._level = undefined;
    this._transactionName = undefined;
    this._fingerprint = undefined;
    this._requestSession = undefined;
    this._span = undefined;
    this._session = undefined;
    this._notifyScopeListeners();
    this._attachments = [];
    return this;
  }

  /**
   * @inheritDoc
   */
   addBreadcrumb(breadcrumb, maxBreadcrumbs) {
    const maxCrumbs = typeof maxBreadcrumbs === 'number' ? maxBreadcrumbs : DEFAULT_MAX_BREADCRUMBS;

    // No data has been changed, so don't notify scope listeners
    if (maxCrumbs <= 0) {
      return this;
    }

    const mergedBreadcrumb = {
      timestamp: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .dateTimestampInSeconds */ .yW)(),
      ...breadcrumb,
    };
    this._breadcrumbs = [...this._breadcrumbs, mergedBreadcrumb].slice(-maxCrumbs);
    this._notifyScopeListeners();

    return this;
  }

  /**
   * @inheritDoc
   */
   getLastBreadcrumb() {
    return this._breadcrumbs[this._breadcrumbs.length - 1];
  }

  /**
   * @inheritDoc
   */
   clearBreadcrumbs() {
    this._breadcrumbs = [];
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   addAttachment(attachment) {
    this._attachments.push(attachment);
    return this;
  }

  /**
   * @inheritDoc
   */
   getAttachments() {
    return this._attachments;
  }

  /**
   * @inheritDoc
   */
   clearAttachments() {
    this._attachments = [];
    return this;
  }

  /**
   * Applies data from the scope to the event and runs all event processors on it.
   *
   * @param event Event
   * @param hint Object containing additional information about the original exception, for use by the event processors.
   * @hidden
   */
   applyToEvent(event, hint = {}) {
    if (this._extra && Object.keys(this._extra).length) {
      event.extra = { ...this._extra, ...event.extra };
    }
    if (this._tags && Object.keys(this._tags).length) {
      event.tags = { ...this._tags, ...event.tags };
    }
    if (this._user && Object.keys(this._user).length) {
      event.user = { ...this._user, ...event.user };
    }
    if (this._contexts && Object.keys(this._contexts).length) {
      event.contexts = { ...this._contexts, ...event.contexts };
    }
    if (this._level) {
      event.level = this._level;
    }
    if (this._transactionName) {
      event.transaction = this._transactionName;
    }

    // We want to set the trace context for normal events only if there isn't already
    // a trace context on the event. There is a product feature in place where we link
    // errors with transaction and it relies on that.
    if (this._span) {
      event.contexts = { trace: this._span.getTraceContext(), ...event.contexts };
      const transaction = this._span.transaction;
      if (transaction) {
        event.sdkProcessingMetadata = {
          dynamicSamplingContext: transaction.getDynamicSamplingContext(),
          ...event.sdkProcessingMetadata,
        };
        const transactionName = transaction.name;
        if (transactionName) {
          event.tags = { transaction: transactionName, ...event.tags };
        }
      }
    }

    this._applyFingerprint(event);

    event.breadcrumbs = [...(event.breadcrumbs || []), ...this._breadcrumbs];
    event.breadcrumbs = event.breadcrumbs.length > 0 ? event.breadcrumbs : undefined;

    event.sdkProcessingMetadata = { ...event.sdkProcessingMetadata, ...this._sdkProcessingMetadata };

    return this._notifyEventProcessors([...getGlobalEventProcessors(), ...this._eventProcessors], event, hint);
  }

  /**
   * Add data which will be accessible during event processing but won't get sent to Sentry
   */
   setSDKProcessingMetadata(newData) {
    this._sdkProcessingMetadata = { ...this._sdkProcessingMetadata, ...newData };

    return this;
  }

  /**
   * This will be called after {@link applyToEvent} is finished.
   */
   _notifyEventProcessors(
    processors,
    event,
    hint,
    index = 0,
  ) {
    return new _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .SyncPromise */ .cW((resolve, reject) => {
      const processor = processors[index];
      if (event === null || typeof processor !== 'function') {
        resolve(event);
      } else {
        const result = processor({ ...event }, hint) ;

        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
          processor.id &&
          result === null &&
          _sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .logger.log */ .kg.log(`Event processor "${processor.id}" dropped event`);

        if ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .isThenable */ .J8)(result)) {
          void result
            .then(final => this._notifyEventProcessors(processors, final, hint, index + 1).then(resolve))
            .then(null, reject);
        } else {
          void this._notifyEventProcessors(processors, result, hint, index + 1)
            .then(resolve)
            .then(null, reject);
        }
      }
    });
  }

  /**
   * This will be called on every set call.
   */
   _notifyScopeListeners() {
    // We need this check for this._notifyingListeners to be able to work on scope during updates
    // If this check is not here we'll produce endless recursion when something is done with the scope
    // during the callback.
    if (!this._notifyingListeners) {
      this._notifyingListeners = true;
      this._scopeListeners.forEach(callback => {
        callback(this);
      });
      this._notifyingListeners = false;
    }
  }

  /**
   * Applies fingerprint from the scope to the event if there's one,
   * uses message if there's one instead or get rid of empty fingerprint
   */
   _applyFingerprint(event) {
    // Make sure it's an array first and we actually have something in place
    event.fingerprint = event.fingerprint ? (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .arrayify */ .lE)(event.fingerprint) : [];

    // If we have something on the scope, then merge it with event
    if (this._fingerprint) {
      event.fingerprint = event.fingerprint.concat(this._fingerprint);
    }

    // If we have no data at all, remove empty array default
    if (event.fingerprint && !event.fingerprint.length) {
      delete event.fingerprint;
    }
  }
}

/**
 * Returns the global event processors.
 */
function getGlobalEventProcessors() {
  return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_6__/* .getGlobalSingleton */ .YO)('globalEventProcessors', () => []);
}

/**
 * Add a EventProcessor to be kept globally.
 * @param callback EventProcessor to add
 */
function addGlobalEventProcessor(callback) {
  getGlobalEventProcessors().push(callback);
}


//# sourceMappingURL=scope.js.map


/***/ }),

/***/ 89015:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CT": function() { return /* binding */ updateSession; },
/* harmony export */   "Hv": function() { return /* binding */ makeSession; },
/* harmony export */   "RJ": function() { return /* binding */ closeSession; }
/* harmony export */ });
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94180);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67451);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39109);


/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */
function makeSession(context) {
  // Both timestamp and started are in seconds since the UNIX epoch.
  const startingTime = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .timestampInSeconds */ .ph)();

  const session = {
    sid: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)(),
    init: true,
    timestamp: startingTime,
    started: startingTime,
    duration: 0,
    status: 'ok',
    errors: 0,
    ignoreDuration: false,
    toJSON: () => sessionToJSON(session),
  };

  if (context) {
    updateSession(session, context);
  }

  return session;
}

/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see BaseClient.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */
// eslint-disable-next-line complexity
function updateSession(session, context = {}) {
  if (context.user) {
    if (!session.ipAddress && context.user.ip_address) {
      session.ipAddress = context.user.ip_address;
    }

    if (!session.did && !context.did) {
      session.did = context.user.id || context.user.email || context.user.username;
    }
  }

  session.timestamp = context.timestamp || (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .timestampInSeconds */ .ph)();

  if (context.ignoreDuration) {
    session.ignoreDuration = context.ignoreDuration;
  }
  if (context.sid) {
    // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)();
  }
  if (context.init !== undefined) {
    session.init = context.init;
  }
  if (!session.did && context.did) {
    session.did = `${context.did}`;
  }
  if (typeof context.started === 'number') {
    session.started = context.started;
  }
  if (session.ignoreDuration) {
    session.duration = undefined;
  } else if (typeof context.duration === 'number') {
    session.duration = context.duration;
  } else {
    const duration = session.timestamp - session.started;
    session.duration = duration >= 0 ? duration : 0;
  }
  if (context.release) {
    session.release = context.release;
  }
  if (context.environment) {
    session.environment = context.environment;
  }
  if (!session.ipAddress && context.ipAddress) {
    session.ipAddress = context.ipAddress;
  }
  if (!session.userAgent && context.userAgent) {
    session.userAgent = context.userAgent;
  }
  if (typeof context.errors === 'number') {
    session.errors = context.errors;
  }
  if (context.status) {
    session.status = context.status;
  }
}

/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */
function closeSession(session, status) {
  let context = {};
  if (status) {
    context = { status };
  } else if (session.status === 'ok') {
    context = { status: 'exited' };
  }

  updateSession(session, context);
}

/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */
function sessionToJSON(session) {
  return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .dropUndefinedKeys */ .Jr)({
    sid: `${session.sid}`,
    init: session.init,
    // Make sure that sec is converted to ms for date constructor
    started: new Date(session.started * 1000).toISOString(),
    timestamp: new Date(session.timestamp * 1000).toISOString(),
    status: session.status,
    errors: session.errors,
    did: typeof session.did === 'number' || typeof session.did === 'string' ? `${session.did}` : undefined,
    duration: session.duration,
    attrs: {
      release: session.release,
      environment: session.environment,
      ip_address: session.ipAddress,
      user_agent: session.userAgent,
    },
  });
}


//# sourceMappingURL=session.js.map


/***/ }),

/***/ 38862:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "q": function() { return /* binding */ createTransport; }
});

// UNUSED EXPORTS: DEFAULT_TRANSPORT_BUFFER_SIZE

// EXTERNAL MODULE: ../node_modules/@sentry/utils/esm/error.js
var esm_error = __webpack_require__(44502);
// EXTERNAL MODULE: ../node_modules/@sentry/utils/esm/syncpromise.js
var syncpromise = __webpack_require__(48894);
;// CONCATENATED MODULE: ../node_modules/@sentry/utils/esm/promisebuffer.js



/**
 * Creates an new PromiseBuffer object with the specified limit
 * @param limit max number of promises that can be stored in the buffer
 */
function makePromiseBuffer(limit) {
  const buffer = [];

  function isReady() {
    return limit === undefined || buffer.length < limit;
  }

  /**
   * Remove a promise from the queue.
   *
   * @param task Can be any PromiseLike<T>
   * @returns Removed promise.
   */
  function remove(task) {
    return buffer.splice(buffer.indexOf(task), 1)[0];
  }

  /**
   * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
   *
   * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
   *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
   *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
   *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
   *        limit check.
   * @returns The original promise.
   */
  function add(taskProducer) {
    if (!isReady()) {
      return (0,syncpromise/* rejectedSyncPromise */.$2)(new esm_error/* SentryError */.b('Not adding Promise because buffer limit was reached.'));
    }

    // start the task and add its promise to the queue
    const task = taskProducer();
    if (buffer.indexOf(task) === -1) {
      buffer.push(task);
    }
    void task
      .then(() => remove(task))
      // Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
      // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
      // have promises, so TS has to polyfill when down-compiling.)
      .then(null, () =>
        remove(task).then(null, () => {
          // We have to add another catch here because `remove()` starts a new promise chain.
        }),
      );
    return task;
  }

  /**
   * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
   * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
   * `false` otherwise
   */
  function drain(timeout) {
    return new syncpromise/* SyncPromise */.cW((resolve, reject) => {
      let counter = buffer.length;

      if (!counter) {
        return resolve(true);
      }

      // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
      const capturedSetTimeout = setTimeout(() => {
        if (timeout && timeout > 0) {
          resolve(false);
        }
      }, timeout);

      // if all promises resolve in time, cancel the timer and resolve to `true`
      buffer.forEach(item => {
        void (0,syncpromise/* resolvedSyncPromise */.WD)(item).then(() => {
          if (!--counter) {
            clearTimeout(capturedSetTimeout);
            resolve(true);
          }
        }, reject);
      });
    });
  }

  return {
    $: buffer,
    add,
    drain,
  };
}


//# sourceMappingURL=promisebuffer.js.map

// EXTERNAL MODULE: ../node_modules/@sentry/utils/esm/envelope.js
var esm_envelope = __webpack_require__(73285);
// EXTERNAL MODULE: ../node_modules/@sentry/utils/esm/ratelimit.js
var ratelimit = __webpack_require__(34006);
// EXTERNAL MODULE: ../node_modules/@sentry/utils/esm/logger.js
var logger = __webpack_require__(86922);
;// CONCATENATED MODULE: ../node_modules/@sentry/core/esm/transports/base.js


const DEFAULT_TRANSPORT_BUFFER_SIZE = 30;

/**
 * Creates an instance of a Sentry `Transport`
 *
 * @param options
 * @param makeRequest
 */
function createTransport(
  options,
  makeRequest,
  buffer = makePromiseBuffer(
    options.bufferSize || DEFAULT_TRANSPORT_BUFFER_SIZE,
  ),
) {
  let rateLimits = {};
  const flush = (timeout) => buffer.drain(timeout);

  function send(envelope) {
    const filteredEnvelopeItems = [];

    // Drop rate limited items from envelope
    (0,esm_envelope/* forEachEnvelopeItem */.gv)(envelope, (item, type) => {
      const envelopeItemDataCategory = (0,esm_envelope/* envelopeItemTypeToDataCategory */.mL)(type);
      if ((0,ratelimit/* isRateLimited */.Q)(rateLimits, envelopeItemDataCategory)) {
        const event = getEventForEnvelopeItem(item, type);
        options.recordDroppedEvent('ratelimit_backoff', envelopeItemDataCategory, event);
      } else {
        filteredEnvelopeItems.push(item);
      }
    });

    // Skip sending if envelope is empty after filtering out rate limited events
    if (filteredEnvelopeItems.length === 0) {
      return (0,syncpromise/* resolvedSyncPromise */.WD)();
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const filteredEnvelope = (0,esm_envelope/* createEnvelope */.Jd)(envelope[0], filteredEnvelopeItems );

    // Creates client report for each item in an envelope
    const recordEnvelopeLoss = (reason) => {
      (0,esm_envelope/* forEachEnvelopeItem */.gv)(filteredEnvelope, (item, type) => {
        const event = getEventForEnvelopeItem(item, type);
        options.recordDroppedEvent(reason, (0,esm_envelope/* envelopeItemTypeToDataCategory */.mL)(type), event);
      });
    };

    const requestTask = () =>
      makeRequest({ body: (0,esm_envelope/* serializeEnvelope */.V$)(filteredEnvelope, options.textEncoder) }).then(
        response => {
          // We don't want to throw on NOK responses, but we want to at least log them
          if (response.statusCode !== undefined && (response.statusCode < 200 || response.statusCode >= 300)) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.warn */.kg.warn(`Sentry responded with status code ${response.statusCode} to sent event.`);
          }

          rateLimits = (0,ratelimit/* updateRateLimits */.WG)(rateLimits, response);
          return response;
        },
        error => {
          recordEnvelopeLoss('network_error');
          throw error;
        },
      );

    return buffer.add(requestTask).then(
      result => result,
      error => {
        if (error instanceof esm_error/* SentryError */.b) {
          (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.error */.kg.error('Skipped sending event because buffer is full.');
          recordEnvelopeLoss('queue_overflow');
          return (0,syncpromise/* resolvedSyncPromise */.WD)();
        } else {
          throw error;
        }
      },
    );
  }

  // We use this to identifify if the transport is the base transport
  // TODO (v8): Remove this again as we'll no longer need it
  send.__sentry__baseTransport__ = true;

  return {
    send,
    flush,
  };
}

function getEventForEnvelopeItem(item, type) {
  if (type !== 'event' && type !== 'transaction') {
    return undefined;
  }

  return Array.isArray(item) ? (item )[1] : undefined;
}


//# sourceMappingURL=base.js.map


/***/ }),

/***/ 53010:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ prepareEvent; }
/* harmony export */ });
/* unused harmony exports applyDebugIds, applyDebugMeta */
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67451);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94180);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48894);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(65268);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(74211);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(43527);
/* harmony import */ var _constants_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99330);
/* harmony import */ var _scope_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25516);




/**
 * Adds common information to events.
 *
 * The information includes release and environment from `options`,
 * breadcrumbs and context (extra, tags and user) from the scope.
 *
 * Information that is already present in the event is never overwritten. For
 * nested objects, such as the context, keys are merged.
 *
 * Note: This also triggers callbacks for `addGlobalEventProcessor`, but not `beforeSend`.
 *
 * @param event The original event.
 * @param hint May contain additional information about the original exception.
 * @param scope A scope containing event metadata.
 * @returns A new event with more information.
 * @hidden
 */
function prepareEvent(
  options,
  event,
  hint,
  scope,
) {
  const { normalizeDepth = 3, normalizeMaxBreadth = 1000 } = options;
  const prepared = {
    ...event,
    event_id: event.event_id || hint.event_id || (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .uuid4 */ .DM)(),
    timestamp: event.timestamp || (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .dateTimestampInSeconds */ .yW)(),
  };
  const integrations = hint.integrations || options.integrations.map(i => i.name);

  applyClientOptions(prepared, options);
  applyIntegrationsMetadata(prepared, integrations);

  // Only put debug IDs onto frames for error events.
  if (event.type === undefined) {
    applyDebugIds(prepared, options.stackParser);
  }

  // If we have scope given to us, use it as the base for further modifications.
  // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
  let finalScope = scope;
  if (hint.captureContext) {
    finalScope = _scope_js__WEBPACK_IMPORTED_MODULE_2__/* .Scope.clone */ .s.clone(finalScope).update(hint.captureContext);
  }

  // We prepare the result here with a resolved Event.
  let result = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .resolvedSyncPromise */ .WD)(prepared);

  // This should be the last thing called, since we want that
  // {@link Hub.addEventProcessor} gets the finished prepared event.
  //
  // We need to check for the existence of `finalScope.getAttachments`
  // because `getAttachments` can be undefined if users are using an older version
  // of `@sentry/core` that does not have the `getAttachments` method.
  // See: https://github.com/getsentry/sentry-javascript/issues/5229
  if (finalScope) {
    // Collect attachments from the hint and scope
    if (finalScope.getAttachments) {
      const attachments = [...(hint.attachments || []), ...finalScope.getAttachments()];

      if (attachments.length) {
        hint.attachments = attachments;
      }
    }

    // In case we have a hub we reassign it.
    result = finalScope.applyToEvent(prepared, hint);
  }

  return result.then(evt => {
    if (evt) {
      // We apply the debug_meta field only after all event processors have ran, so that if any event processors modified
      // file names (e.g.the RewriteFrames integration) the filename -> debug ID relationship isn't destroyed.
      // This should not cause any PII issues, since we're only moving data that is already on the event and not adding
      // any new data
      applyDebugMeta(evt);
    }

    if (typeof normalizeDepth === 'number' && normalizeDepth > 0) {
      return normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
    }
    return evt;
  });
}

/**
 *  Enhances event using the client configuration.
 *  It takes care of all "static" values like environment, release and `dist`,
 *  as well as truncating overly long values.
 * @param event event instance to be enhanced
 */
function applyClientOptions(event, options) {
  const { environment, release, dist, maxValueLength = 250 } = options;

  if (!('environment' in event)) {
    event.environment = 'environment' in options ? environment : _constants_js__WEBPACK_IMPORTED_MODULE_4__/* .DEFAULT_ENVIRONMENT */ .J;
  }

  if (event.release === undefined && release !== undefined) {
    event.release = release;
  }

  if (event.dist === undefined && dist !== undefined) {
    event.dist = dist;
  }

  if (event.message) {
    event.message = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .truncate */ .$G)(event.message, maxValueLength);
  }

  const exception = event.exception && event.exception.values && event.exception.values[0];
  if (exception && exception.value) {
    exception.value = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .truncate */ .$G)(exception.value, maxValueLength);
  }

  const request = event.request;
  if (request && request.url) {
    request.url = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .truncate */ .$G)(request.url, maxValueLength);
  }
}

const debugIdStackParserCache = new WeakMap();

/**
 * Puts debug IDs into the stack frames of an error event.
 */
function applyDebugIds(event, stackParser) {
  const debugIdMap = _sentry_utils__WEBPACK_IMPORTED_MODULE_6__/* .GLOBAL_OBJ._sentryDebugIds */ .n2._sentryDebugIds;

  if (!debugIdMap) {
    return;
  }

  let debugIdStackFramesCache;
  const cachedDebugIdStackFrameCache = debugIdStackParserCache.get(stackParser);
  if (cachedDebugIdStackFrameCache) {
    debugIdStackFramesCache = cachedDebugIdStackFrameCache;
  } else {
    debugIdStackFramesCache = new Map();
    debugIdStackParserCache.set(stackParser, debugIdStackFramesCache);
  }

  // Build a map of filename -> debug_id
  const filenameDebugIdMap = Object.keys(debugIdMap).reduce((acc, debugIdStackTrace) => {
    let parsedStack;
    const cachedParsedStack = debugIdStackFramesCache.get(debugIdStackTrace);
    if (cachedParsedStack) {
      parsedStack = cachedParsedStack;
    } else {
      parsedStack = stackParser(debugIdStackTrace);
      debugIdStackFramesCache.set(debugIdStackTrace, parsedStack);
    }

    for (let i = parsedStack.length - 1; i >= 0; i--) {
      const stackFrame = parsedStack[i];
      if (stackFrame.filename) {
        acc[stackFrame.filename] = debugIdMap[debugIdStackTrace];
        break;
      }
    }
    return acc;
  }, {});

  try {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    event.exception.values.forEach(exception => {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      exception.stacktrace.frames.forEach(frame => {
        if (frame.filename) {
          frame.debug_id = filenameDebugIdMap[frame.filename];
        }
      });
    });
  } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
  }
}

/**
 * Moves debug IDs from the stack frames of an error event into the debug_meta field.
 */
function applyDebugMeta(event) {
  // Extract debug IDs and filenames from the stack frames on the event.
  const filenameDebugIdMap = {};
  try {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    event.exception.values.forEach(exception => {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      exception.stacktrace.frames.forEach(frame => {
        if (frame.debug_id) {
          if (frame.abs_path) {
            filenameDebugIdMap[frame.abs_path] = frame.debug_id;
          } else if (frame.filename) {
            filenameDebugIdMap[frame.filename] = frame.debug_id;
          }
          delete frame.debug_id;
        }
      });
    });
  } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
  }

  if (Object.keys(filenameDebugIdMap).length === 0) {
    return;
  }

  // Fill debug_meta information
  event.debug_meta = event.debug_meta || {};
  event.debug_meta.images = event.debug_meta.images || [];
  const images = event.debug_meta.images;
  Object.keys(filenameDebugIdMap).forEach(filename => {
    images.push({
      type: 'sourcemap',
      code_file: filename,
      debug_id: filenameDebugIdMap[filename],
    });
  });
}

/**
 * This function adds all used integrations to the SDK info in the event.
 * @param event The event that will be filled with all integrations.
 */
function applyIntegrationsMetadata(event, integrationNames) {
  if (integrationNames.length > 0) {
    event.sdk = event.sdk || {};
    event.sdk.integrations = [...(event.sdk.integrations || []), ...integrationNames];
  }
}

/**
 * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
 * Normalized keys:
 * - `breadcrumbs.data`
 * - `user`
 * - `contexts`
 * - `extra`
 * @param event Event
 * @returns Normalized event
 */
function normalizeEvent(event, depth, maxBreadth) {
  if (!event) {
    return null;
  }

  const normalized = {
    ...event,
    ...(event.breadcrumbs && {
      breadcrumbs: event.breadcrumbs.map(b => ({
        ...b,
        ...(b.data && {
          data: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_7__/* .normalize */ .Fv)(b.data, depth, maxBreadth),
        }),
      })),
    }),
    ...(event.user && {
      user: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_7__/* .normalize */ .Fv)(event.user, depth, maxBreadth),
    }),
    ...(event.contexts && {
      contexts: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_7__/* .normalize */ .Fv)(event.contexts, depth, maxBreadth),
    }),
    ...(event.extra && {
      extra: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_7__/* .normalize */ .Fv)(event.extra, depth, maxBreadth),
    }),
  };

  // event.contexts.trace stores information about a Transaction. Similarly,
  // event.spans[] stores information about child Spans. Given that a
  // Transaction is conceptually a Span, normalization should apply to both
  // Transactions and Spans consistently.
  // For now the decision is to skip normalization of Transactions and Spans,
  // so this block overwrites the normalized event to add back the original
  // Transaction information prior to normalization.
  if (event.contexts && event.contexts.trace && normalized.contexts) {
    normalized.contexts.trace = event.contexts.trace;

    // event.contexts.trace.data may contain circular/dangerous data so we need to normalize it
    if (event.contexts.trace.data) {
      normalized.contexts.trace.data = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_7__/* .normalize */ .Fv)(event.contexts.trace.data, depth, maxBreadth);
    }
  }

  // event.spans[].data may contain circular/dangerous data so we need to normalize it
  if (event.spans) {
    normalized.spans = event.spans.map(span => {
      // We cannot use the spread operator here because `toJSON` on `span` is non-enumerable
      if (span.data) {
        span.data = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_7__/* .normalize */ .Fv)(span.data, depth, maxBreadth);
      }
      return span;
    });
  }

  return normalized;
}


//# sourceMappingURL=prepareEvent.js.map


/***/ }),

/***/ 37486:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ SDK_VERSION; }
/* harmony export */ });
const SDK_VERSION = '7.56.0';


//# sourceMappingURL=version.js.map


/***/ }),

/***/ 6464:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Oo": function() { return /* reexport */ breadcrumbs/* Breadcrumbs */.O; },
  "RE": function() { return /* reexport */ client/* BrowserClient */.R; },
  "_p": function() { return /* reexport */ BrowserProfilingIntegration; },
  "gE": function() { return /* reexport */ BrowserTracing; },
  "Iq": function() { return /* reexport */ dedupe/* Dedupe */.I; },
  "SV": function() { return /* reexport */ ErrorBoundary; },
  "cq": function() { return /* reexport */ functiontostring/* FunctionToString */.c; },
  "dJ": function() { return /* reexport */ globalhandlers/* GlobalHandlers */.d; },
  "qT": function() { return /* reexport */ httpcontext/* HttpContext */.q; },
  "Xb": function() { return /* reexport */ esm_hub/* Hub */.Xb; },
  "QD": function() { return /* reexport */ inboundfilters/* InboundFilters */.QD; },
  "jK": function() { return /* reexport */ INTEGRATIONS; },
  "iP": function() { return /* reexport */ linkederrors/* LinkedErrors */.iP; },
  "Q1": function() { return /* reexport */ Profiler; },
  "UH": function() { return /* reexport */ Replay; },
  "Jn": function() { return /* reexport */ version/* SDK_VERSION */.J; },
  "sX": function() { return /* reexport */ esm_scope/* Scope */.s; },
  "pT": function() { return /* reexport */ trycatch/* TryCatch */.p; },
  "m9": function() { return /* reexport */ helpers/* WINDOW */.m9; },
  "n_": function() { return /* reexport */ esm_exports/* addBreadcrumb */.n_; },
  "cc": function() { return /* reexport */ esm_scope/* addGlobalEventProcessor */.c; },
  "Ts": function() { return /* reexport */ addTracingExtensions; },
  "eN": function() { return /* reexport */ esm_exports/* captureEvent */.eN; },
  "Tb": function() { return /* reexport */ esm_exports/* captureException */.Tb; },
  "uT": function() { return /* reexport */ esm_exports/* captureMessage */.uT; },
  "ud": function() { return /* reexport */ captureUnderscoreErrorException; },
  "Jd": function() { return /* reexport */ sdk/* captureUserFeedback */.Jd; },
  "$3": function() { return /* reexport */ stack_parsers/* chromeStackLineParser */.$3; },
  "xv": function() { return /* reexport */ sdk/* close */.xv; },
  "e": function() { return /* reexport */ esm_exports/* configureScope */.e; },
  "wS": function() { return /* reexport */ createReduxEnhancer; },
  "qv": function() { return /* reexport */ base/* createTransport */.q; },
  "rQ": function() { return /* reexport */ userfeedback/* createUserFeedbackEnvelope */.r; },
  "SS": function() { return /* reexport */ sdk/* defaultIntegrations */.SS; },
  "k3": function() { return /* reexport */ defaultRequestInstrumentationOptions; },
  "d8": function() { return /* reexport */ stack_parsers/* defaultStackLineParsers */.d8; },
  "Dt": function() { return /* reexport */ stack_parsers/* defaultStackParser */.Dt; },
  "dr": function() { return /* reexport */ eventbuilder/* eventFromException */.dr; },
  "aB": function() { return /* reexport */ eventbuilder/* eventFromMessage */.aB; },
  "qG": function() { return /* reexport */ extractTraceparentData; },
  "yl": function() { return /* reexport */ sdk/* flush */.yl; },
  "Eg": function() { return /* reexport */ sdk/* forceLoad */.Eg; },
  "$Q": function() { return /* reexport */ stack_parsers/* geckoStackLineParser */.$Q; },
  "x1": function() { return /* reexport */ getActiveTransaction; },
  "Gd": function() { return /* reexport */ esm_hub/* getCurrentHub */.Gd; },
  "vi": function() { return /* reexport */ esm_hub/* getHubFromCarrier */.vi; },
  "S1": function() { return /* binding */ client_init; },
  "L7": function() { return /* reexport */ instrumentOutgoingRequests; },
  "eW": function() { return /* reexport */ sdk/* lastEventId */.eW; },
  "O1": function() { return /* reexport */ makeBrowserOfflineTransport; },
  "fD": function() { return /* reexport */ fetch/* makeFetchTransport */.f; },
  "pj": function() { return /* reexport */ esm_hub/* makeMain */.pj; },
  "Wq": function() { return /* reexport */ makeMultiplexedTransport; },
  "KC": function() { return /* reexport */ xhr/* makeXHRTransport */.K; },
  "q$": function() { return /* reexport */ nextRouterInstrumentation; },
  "lA": function() { return /* reexport */ sdk/* onLoad */.lA; },
  "Uv": function() { return /* reexport */ onProfilingStartRouteTransaction; },
  "NP": function() { return /* reexport */ stack_parsers/* opera10StackLineParser */.NP; },
  "HH": function() { return /* reexport */ stack_parsers/* opera11StackLineParser */.HH; },
  "XQ": function() { return /* reexport */ reactRouterV3Instrumentation; },
  "qr": function() { return /* reexport */ reactRouterV4Instrumentation; },
  "qp": function() { return /* reexport */ reactRouterV5Instrumentation; },
  "KO": function() { return /* reexport */ reactRouterV6Instrumentation; },
  "v": function() { return /* reexport */ esm_exports/* setContext */.v; },
  "sU": function() { return /* reexport */ esm_exports/* setExtra */.sU; },
  "rJ": function() { return /* reexport */ esm_exports/* setExtras */.rJ; },
  "YA": function() { return /* reexport */ esm_exports/* setTag */.YA; },
  "mG": function() { return /* reexport */ esm_exports/* setTags */.mG; },
  "av": function() { return /* reexport */ esm_exports/* setUser */.av; },
  "jp": function() { return /* reexport */ sdk/* showReportDialog */.jp; },
  "Zd": function() { return /* reexport */ spanStatusfromHttpCode; },
  "Yr": function() { return /* reexport */ esm_exports/* startTransaction */.Yr; },
  "g4": function() { return /* reexport */ trace; },
  "ED": function() { return /* reexport */ useProfiler; },
  "R2": function() { return /* reexport */ stack_parsers/* winjsStackLineParser */.R2; },
  "Pf": function() { return /* reexport */ withErrorBoundary; },
  "zH": function() { return /* reexport */ withProfiler; },
  "$e": function() { return /* reexport */ esm_exports/* withScope */.$e; },
  "wO": function() { return /* binding */ withSentryConfig; },
  "sT": function() { return /* reexport */ withSentryGetServerSideProps; },
  "SF": function() { return /* reexport */ withSentryGetStaticProps; },
  "H0": function() { return /* reexport */ withSentryReactRouterV6Routing; },
  "gy": function() { return /* reexport */ withSentryRouting; },
  "Im": function() { return /* reexport */ withSentryServerSideAppGetInitialProps; },
  "W9": function() { return /* reexport */ withSentryServerSideDocumentGetInitialProps; },
  "vw": function() { return /* reexport */ withSentryServerSideErrorGetInitialProps; },
  "EC": function() { return /* reexport */ withSentryServerSideGetInitialProps; },
  "re": function() { return /* reexport */ sdk/* wrap */.re; },
  "$l": function() { return /* reexport */ wrapAppGetInitialPropsWithSentry; },
  "vG": function() { return /* reexport */ wrapCreateBrowserRouter; },
  "B4": function() { return /* reexport */ wrapDocumentGetInitialPropsWithSentry; },
  "rO": function() { return /* reexport */ wrapErrorGetInitialPropsWithSentry; },
  "O5": function() { return /* reexport */ wrapGetInitialPropsWithSentry; },
  "rC": function() { return /* reexport */ wrapGetServerSidePropsWithSentry; },
  "ug": function() { return /* reexport */ wrapGetStaticPropsWithSentry; },
  "M1": function() { return /* reexport */ wrapUseRoutes; }
});

// NAMESPACE OBJECT: ../node_modules/@sentry/core/esm/integrations/index.js
var integrations_namespaceObject = {};
__webpack_require__.r(integrations_namespaceObject);
__webpack_require__.d(integrations_namespaceObject, {
  "FunctionToString": function() { return functiontostring/* FunctionToString */.c; },
  "InboundFilters": function() { return inboundfilters/* InboundFilters */.QD; }
});

// NAMESPACE OBJECT: ../node_modules/@sentry/browser/esm/integrations/index.js
var esm_integrations_namespaceObject = {};
__webpack_require__.r(esm_integrations_namespaceObject);
__webpack_require__.d(esm_integrations_namespaceObject, {
  "Breadcrumbs": function() { return breadcrumbs/* Breadcrumbs */.O; },
  "Dedupe": function() { return dedupe/* Dedupe */.I; },
  "GlobalHandlers": function() { return globalhandlers/* GlobalHandlers */.d; },
  "HttpContext": function() { return httpcontext/* HttpContext */.q; },
  "LinkedErrors": function() { return linkederrors/* LinkedErrors */.iP; },
  "TryCatch": function() { return trycatch/* TryCatch */.p; }
});

;// CONCATENATED MODULE: ../node_modules/@sentry/utils/esm/buildPolyfills/_optionalChain.js
/**
 * Polyfill for the optional chain operator, `?.`, given previous conversion of the expression into an array of values,
 * descriptors, and functions.
 *
 * Adapted from Sucrase (https://github.com/alangpierce/sucrase)
 * See https://github.com/alangpierce/sucrase/blob/265887868966917f3b924ce38dfad01fbab1329f/src/transformers/OptionalChainingNullishTransformer.ts#L15
 *
 * @param ops Array result of expression conversion
 * @returns The value of the expression
 */
function _optionalChain(ops) {
  let lastAccessLHS = undefined;
  let value = ops[0];
  let i = 1;
  while (i < ops.length) {
    const op = ops[i] ;
    const fn = ops[i + 1] ;
    i += 2;
    // by checking for loose equality to `null`, we catch both `null` and `undefined`
    if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) {
      // really we're meaning to return `undefined` as an actual value here, but it saves bytes not to write it
      return;
    }
    if (op === 'access' || op === 'optionalAccess') {
      lastAccessLHS = value;
      value = fn(value);
    } else if (op === 'call' || op === 'optionalCall') {
      value = fn((...args) => (value ).call(lastAccessLHS, ...args));
      lastAccessLHS = undefined;
    }
  }
  return value;
}

// Sucrase version
// function _optionalChain(ops) {
//   let lastAccessLHS = undefined;
//   let value = ops[0];
//   let i = 1;
//   while (i < ops.length) {
//     const op = ops[i];
//     const fn = ops[i + 1];
//     i += 2;
//     if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) {
//       return undefined;
//     }
//     if (op === 'access' || op === 'optionalAccess') {
//       lastAccessLHS = value;
//       value = fn(value);
//     } else if (op === 'call' || op === 'optionalCall') {
//       value = fn((...args) => value.call(lastAccessLHS, ...args));
//       lastAccessLHS = undefined;
//     }
//   }
//   return value;
// }


//# sourceMappingURL=_optionalChain.js.map

// EXTERNAL MODULE: ../node_modules/@sentry/core/esm/hub.js
var esm_hub = __webpack_require__(6878);
;// CONCATENATED MODULE: ../node_modules/@sentry/core/esm/utils/hasTracingEnabled.js


// Treeshakable guard to remove all code related to tracing

/**
 * Determines if tracing is currently enabled.
 *
 * Tracing is enabled when at least one of `tracesSampleRate` and `tracesSampler` is defined in the SDK config.
 */
function hasTracingEnabled(
  maybeOptions,
) {
  if (typeof __SENTRY_TRACING__ === 'boolean' && !__SENTRY_TRACING__) {
    return false;
  }

  const client = (0,esm_hub/* getCurrentHub */.Gd)().getClient();
  const options = maybeOptions || (client && client.getOptions());
  return !!options && (options.enableTracing || 'tracesSampleRate' in options || 'tracesSampler' in options);
}


//# sourceMappingURL=hasTracingEnabled.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/utils/esm/path.js
// Slightly modified (no IE8 support, ES6) and transcribed to TypeScript
// https://github.com/calvinmetcalf/rollup-plugin-node-builtins/blob/63ab8aacd013767445ca299e468d9a60a95328d7/src/es6/path.js
//
// Copyright Joyent, Inc.and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

/** JSDoc */
function normalizeArray(parts, allowAboveRoot) {
  // if the path tries to go above the root, `up` ends up > 0
  let up = 0;
  for (let i = parts.length - 1; i >= 0; i--) {
    const last = parts[i];
    if (last === '.') {
      parts.splice(i, 1);
    } else if (last === '..') {
      parts.splice(i, 1);
      up++;
    } else if (up) {
      parts.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (allowAboveRoot) {
    for (; up--; up) {
      parts.unshift('..');
    }
  }

  return parts;
}

// Split a filename into [root, dir, basename, ext], unix version
// 'root' is just a slash, or nothing.
const splitPathRe = /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^/]+?|)(\.[^./]*|))(?:[/]*)$/;
/** JSDoc */
function splitPath(filename) {
  const parts = splitPathRe.exec(filename);
  return parts ? parts.slice(1) : [];
}

// path.resolve([from ...], to)
// posix version
/** JSDoc */
function resolve(...args) {
  let resolvedPath = '';
  let resolvedAbsolute = false;

  for (let i = args.length - 1; i >= -1 && !resolvedAbsolute; i--) {
    const path = i >= 0 ? args[i] : '/';

    // Skip empty entries
    if (!path) {
      continue;
    }

    resolvedPath = `${path}/${resolvedPath}`;
    resolvedAbsolute = path.charAt(0) === '/';
  }

  // At this point the path should be resolved to a full absolute path, but
  // handle relative paths to be safe (might happen when process.cwd() fails)

  // Normalize the path
  resolvedPath = normalizeArray(
    resolvedPath.split('/').filter(p => !!p),
    !resolvedAbsolute,
  ).join('/');

  return (resolvedAbsolute ? '/' : '') + resolvedPath || '.';
}

/** JSDoc */
function trim(arr) {
  let start = 0;
  for (; start < arr.length; start++) {
    if (arr[start] !== '') {
      break;
    }
  }

  let end = arr.length - 1;
  for (; end >= 0; end--) {
    if (arr[end] !== '') {
      break;
    }
  }

  if (start > end) {
    return [];
  }
  return arr.slice(start, end - start + 1);
}

// path.relative(from, to)
// posix version
/** JSDoc */
function relative(from, to) {
  /* eslint-disable no-param-reassign */
  from = resolve(from).slice(1);
  to = resolve(to).slice(1);
  /* eslint-enable no-param-reassign */

  const fromParts = trim(from.split('/'));
  const toParts = trim(to.split('/'));

  const length = Math.min(fromParts.length, toParts.length);
  let samePartsLength = length;
  for (let i = 0; i < length; i++) {
    if (fromParts[i] !== toParts[i]) {
      samePartsLength = i;
      break;
    }
  }

  let outputParts = [];
  for (let i = samePartsLength; i < fromParts.length; i++) {
    outputParts.push('..');
  }

  outputParts = outputParts.concat(toParts.slice(samePartsLength));

  return outputParts.join('/');
}

// path.normalize(path)
// posix version
/** JSDoc */
function normalizePath(path) {
  const isPathAbsolute = isAbsolute(path);
  const trailingSlash = path.slice(-1) === '/';

  // Normalize the path
  let normalizedPath = normalizeArray(
    path.split('/').filter(p => !!p),
    !isPathAbsolute,
  ).join('/');

  if (!normalizedPath && !isPathAbsolute) {
    normalizedPath = '.';
  }
  if (normalizedPath && trailingSlash) {
    normalizedPath += '/';
  }

  return (isPathAbsolute ? '/' : '') + normalizedPath;
}

// posix version
/** JSDoc */
function isAbsolute(path) {
  return path.charAt(0) === '/';
}

// posix version
/** JSDoc */
function join(...args) {
  return normalizePath(args.join('/'));
}

/** JSDoc */
function dirname(path) {
  const result = splitPath(path);
  const root = result[0];
  let dir = result[1];

  if (!root && !dir) {
    // No dirname whatsoever
    return '.';
  }

  if (dir) {
    // It has a dirname, strip trailing slash
    dir = dir.slice(0, dir.length - 1);
  }

  return root + dir;
}

/** JSDoc */
function basename(path, ext) {
  let f = splitPath(path)[2];
  if (ext && f.slice(ext.length * -1) === ext) {
    f = f.slice(0, f.length - ext.length);
  }
  return f;
}


//# sourceMappingURL=path.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/integrations/esm/rewriteframes.js


/** Rewrite event frames paths */
class RewriteFrames  {
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'RewriteFrames';}

  /**
   * @inheritDoc
   */
   __init() {this.name = RewriteFrames.id;}

  /**
   * @inheritDoc
   */

  /**
   * @inheritDoc
   */
    __init2() {this._prefix = 'app:///';}

  /**
   * @inheritDoc
   */
   constructor(options = {}) {RewriteFrames.prototype.__init.call(this);RewriteFrames.prototype.__init2.call(this);RewriteFrames.prototype.__init3.call(this);
    if (options.root) {
      this._root = options.root;
    }
    if (options.prefix) {
      this._prefix = options.prefix;
    }
    if (options.iteratee) {
      this._iteratee = options.iteratee;
    }
  }

  /**
   * @inheritDoc
   */
   setupOnce(addGlobalEventProcessor, getCurrentHub) {
    addGlobalEventProcessor(event => {
      const self = getCurrentHub().getIntegration(RewriteFrames);
      if (self) {
        return self.process(event);
      }
      return event;
    });
  }

  /** JSDoc */
   process(originalEvent) {
    let processedEvent = originalEvent;

    if (originalEvent.exception && Array.isArray(originalEvent.exception.values)) {
      processedEvent = this._processExceptionsEvent(processedEvent);
    }

    return processedEvent;
  }

  /**
   * @inheritDoc
   */
    __init3() {this._iteratee = (frame) => {
    if (!frame.filename) {
      return frame;
    }
    // Determine if this is a Windows frame by checking for a Windows-style prefix such as `C:\`
    const isWindowsFrame =
      /^[a-zA-Z]:\\/.test(frame.filename) ||
      // or the presence of a backslash without a forward slash (which are not allowed on Windows)
      (frame.filename.includes('\\') && !frame.filename.includes('/'));
    // Check if the frame filename begins with `/`
    const startsWithSlash = /^\//.test(frame.filename);
    if (isWindowsFrame || startsWithSlash) {
      const filename = isWindowsFrame
        ? frame.filename
            .replace(/^[a-zA-Z]:/, '') // remove Windows-style prefix
            .replace(/\\/g, '/') // replace all `\\` instances with `/`
        : frame.filename;
      const base = this._root ? relative(this._root, filename) : basename(filename);
      frame.filename = `${this._prefix}${base}`;
    }
    return frame;
  };}

  /** JSDoc */
   _processExceptionsEvent(event) {
    try {
      return {
        ...event,
        exception: {
          ...event.exception,
          // The check for this is performed inside `process` call itself, safe to skip here
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          values: event.exception.values.map(value => ({
            ...value,
            ...(value.stacktrace && { stacktrace: this._processStacktrace(value.stacktrace) }),
          })),
        },
      };
    } catch (_oO) {
      return event;
    }
  }

  /** JSDoc */
   _processStacktrace(stacktrace) {
    return {
      ...stacktrace,
      frames: stacktrace && stacktrace.frames && stacktrace.frames.map(f => this._iteratee(f)),
    };
  }
} RewriteFrames.__initStatic();


//# sourceMappingURL=rewriteframes.js.map

// EXTERNAL MODULE: ../node_modules/@sentry/core/esm/version.js
var version = __webpack_require__(37486);
// EXTERNAL MODULE: ../node_modules/@sentry/browser/esm/sdk.js + 1 modules
var sdk = __webpack_require__(93968);
;// CONCATENATED MODULE: ../node_modules/@sentry/react/esm/sdk.js


/**
 * Inits the React SDK
 */
function init(options) {
  options._metadata = options._metadata || {};
  options._metadata.sdk = options._metadata.sdk || {
    name: 'sentry.javascript.react',
    packages: [
      {
        name: 'npm:@sentry/react',
        version: version/* SDK_VERSION */.J,
      },
    ],
    version: version/* SDK_VERSION */.J,
  };
  (0,sdk/* init */.S1)(options);
}


//# sourceMappingURL=sdk.js.map

// EXTERNAL MODULE: ../node_modules/@sentry/core/esm/exports.js
var esm_exports = __webpack_require__(60074);
// EXTERNAL MODULE: ../node_modules/@sentry/utils/esm/time.js
var esm_time = __webpack_require__(94180);
// EXTERNAL MODULE: ../node_modules/@sentry/utils/esm/logger.js
var logger = __webpack_require__(86922);
// EXTERNAL MODULE: ../node_modules/@sentry/utils/esm/misc.js
var misc = __webpack_require__(67451);
// EXTERNAL MODULE: ../node_modules/@sentry/utils/esm/object.js
var object = __webpack_require__(39109);
;// CONCATENATED MODULE: ../node_modules/@sentry/core/esm/tracing/span.js


/**
 * Keeps track of finished spans for a given transaction
 * @internal
 * @hideconstructor
 * @hidden
 */
class SpanRecorder {
   __init() {this.spans = [];}

   constructor(maxlen = 1000) {SpanRecorder.prototype.__init.call(this);
    this._maxlen = maxlen;
  }

  /**
   * This is just so that we don't run out of memory while recording a lot
   * of spans. At some point we just stop and flush out the start of the
   * trace tree (i.e.the first n spans with the smallest
   * start_timestamp).
   */
   add(span) {
    if (this.spans.length > this._maxlen) {
      span.spanRecorder = undefined;
    } else {
      this.spans.push(span);
    }
  }
}

/**
 * Span contains all data about a span
 */
class Span  {
  /**
   * @inheritDoc
   */
   __init2() {this.traceId = (0,misc/* uuid4 */.DM)();}

  /**
   * @inheritDoc
   */
   __init3() {this.spanId = (0,misc/* uuid4 */.DM)().substring(16);}

  /**
   * @inheritDoc
   */

  /**
   * Internal keeper of the status
   */

  /**
   * @inheritDoc
   */

  /**
   * Timestamp in seconds when the span was created.
   */
   __init4() {this.startTimestamp = (0,esm_time/* timestampInSeconds */.ph)();}

  /**
   * Timestamp in seconds when the span ended.
   */

  /**
   * @inheritDoc
   */

  /**
   * @inheritDoc
   */

  /**
   * @inheritDoc
   */
   __init5() {this.tags = {};}

  /**
   * @inheritDoc
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
   __init6() {this.data = {};}

  /**
   * List of spans that were finalized
   */

  /**
   * @inheritDoc
   */

  /**
   * The instrumenter that created this span.
   */
   __init7() {this.instrumenter = 'sentry';}

  /**
   * You should never call the constructor manually, always use `Sentry.startTransaction()`
   * or call `startChild()` on an existing span.
   * @internal
   * @hideconstructor
   * @hidden
   */
   constructor(spanContext) {Span.prototype.__init2.call(this);Span.prototype.__init3.call(this);Span.prototype.__init4.call(this);Span.prototype.__init5.call(this);Span.prototype.__init6.call(this);Span.prototype.__init7.call(this);
    if (!spanContext) {
      return this;
    }
    if (spanContext.traceId) {
      this.traceId = spanContext.traceId;
    }
    if (spanContext.spanId) {
      this.spanId = spanContext.spanId;
    }
    if (spanContext.parentSpanId) {
      this.parentSpanId = spanContext.parentSpanId;
    }
    // We want to include booleans as well here
    if ('sampled' in spanContext) {
      this.sampled = spanContext.sampled;
    }
    if (spanContext.op) {
      this.op = spanContext.op;
    }
    if (spanContext.description) {
      this.description = spanContext.description;
    }
    if (spanContext.data) {
      this.data = spanContext.data;
    }
    if (spanContext.tags) {
      this.tags = spanContext.tags;
    }
    if (spanContext.status) {
      this.status = spanContext.status;
    }
    if (spanContext.startTimestamp) {
      this.startTimestamp = spanContext.startTimestamp;
    }
    if (spanContext.endTimestamp) {
      this.endTimestamp = spanContext.endTimestamp;
    }
    if (spanContext.instrumenter) {
      this.instrumenter = spanContext.instrumenter;
    }
  }

  /**
   * @inheritDoc
   */
   startChild(
    spanContext,
  ) {
    const childSpan = new Span({
      ...spanContext,
      parentSpanId: this.spanId,
      sampled: this.sampled,
      traceId: this.traceId,
    });

    childSpan.spanRecorder = this.spanRecorder;
    if (childSpan.spanRecorder) {
      childSpan.spanRecorder.add(childSpan);
    }

    childSpan.transaction = this.transaction;

    if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && childSpan.transaction) {
      const opStr = (spanContext && spanContext.op) || '< unknown op >';
      const nameStr = childSpan.transaction.name || '< unknown name >';
      const idStr = childSpan.transaction.spanId;

      const logMessage = `[Tracing] Starting '${opStr}' span on transaction '${nameStr}' (${idStr}).`;
      childSpan.transaction.metadata.spanMetadata[childSpan.spanId] = { logMessage };
      logger/* logger.log */.kg.log(logMessage);
    }

    return childSpan;
  }

  /**
   * @inheritDoc
   */
   setTag(key, value) {
    this.tags = { ...this.tags, [key]: value };
    return this;
  }

  /**
   * @inheritDoc
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
   setData(key, value) {
    this.data = { ...this.data, [key]: value };
    return this;
  }

  /**
   * @inheritDoc
   */
   setStatus(value) {
    this.status = value;
    return this;
  }

  /**
   * @inheritDoc
   */
   setHttpStatus(httpStatus) {
    this.setTag('http.status_code', String(httpStatus));
    const spanStatus = spanStatusfromHttpCode(httpStatus);
    if (spanStatus !== 'unknown_error') {
      this.setStatus(spanStatus);
    }
    return this;
  }

  /**
   * @inheritDoc
   */
   isSuccess() {
    return this.status === 'ok';
  }

  /**
   * @inheritDoc
   */
   finish(endTimestamp) {
    if (
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      // Don't call this for transactions
      this.transaction &&
      this.transaction.spanId !== this.spanId
    ) {
      const { logMessage } = this.transaction.metadata.spanMetadata[this.spanId];
      if (logMessage) {
        logger/* logger.log */.kg.log((logMessage ).replace('Starting', 'Finishing'));
      }
    }

    this.endTimestamp = typeof endTimestamp === 'number' ? endTimestamp : (0,esm_time/* timestampInSeconds */.ph)();
  }

  /**
   * @inheritDoc
   */
   toTraceparent() {
    let sampledString = '';
    if (this.sampled !== undefined) {
      sampledString = this.sampled ? '-1' : '-0';
    }
    return `${this.traceId}-${this.spanId}${sampledString}`;
  }

  /**
   * @inheritDoc
   */
   toContext() {
    return (0,object/* dropUndefinedKeys */.Jr)({
      data: this.data,
      description: this.description,
      endTimestamp: this.endTimestamp,
      op: this.op,
      parentSpanId: this.parentSpanId,
      sampled: this.sampled,
      spanId: this.spanId,
      startTimestamp: this.startTimestamp,
      status: this.status,
      tags: this.tags,
      traceId: this.traceId,
    });
  }

  /**
   * @inheritDoc
   */
   updateWithContext(spanContext) {
    this.data = spanContext.data || {};
    this.description = spanContext.description;
    this.endTimestamp = spanContext.endTimestamp;
    this.op = spanContext.op;
    this.parentSpanId = spanContext.parentSpanId;
    this.sampled = spanContext.sampled;
    this.spanId = spanContext.spanId || this.spanId;
    this.startTimestamp = spanContext.startTimestamp || this.startTimestamp;
    this.status = spanContext.status;
    this.tags = spanContext.tags || {};
    this.traceId = spanContext.traceId || this.traceId;

    return this;
  }

  /**
   * @inheritDoc
   */
   getTraceContext() {
    return (0,object/* dropUndefinedKeys */.Jr)({
      data: Object.keys(this.data).length > 0 ? this.data : undefined,
      description: this.description,
      op: this.op,
      parent_span_id: this.parentSpanId,
      span_id: this.spanId,
      status: this.status,
      tags: Object.keys(this.tags).length > 0 ? this.tags : undefined,
      trace_id: this.traceId,
    });
  }

  /**
   * @inheritDoc
   */
   toJSON()

 {
    return (0,object/* dropUndefinedKeys */.Jr)({
      data: Object.keys(this.data).length > 0 ? this.data : undefined,
      description: this.description,
      op: this.op,
      parent_span_id: this.parentSpanId,
      span_id: this.spanId,
      start_timestamp: this.startTimestamp,
      status: this.status,
      tags: Object.keys(this.tags).length > 0 ? this.tags : undefined,
      timestamp: this.endTimestamp,
      trace_id: this.traceId,
    });
  }
}

/**
 * Converts a HTTP status code into a {@link SpanStatusType}.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */
function spanStatusfromHttpCode(httpStatus) {
  if (httpStatus < 400 && httpStatus >= 100) {
    return 'ok';
  }

  if (httpStatus >= 400 && httpStatus < 500) {
    switch (httpStatus) {
      case 401:
        return 'unauthenticated';
      case 403:
        return 'permission_denied';
      case 404:
        return 'not_found';
      case 409:
        return 'already_exists';
      case 413:
        return 'failed_precondition';
      case 429:
        return 'resource_exhausted';
      default:
        return 'invalid_argument';
    }
  }

  if (httpStatus >= 500 && httpStatus < 600) {
    switch (httpStatus) {
      case 501:
        return 'unimplemented';
      case 503:
        return 'unavailable';
      case 504:
        return 'deadline_exceeded';
      default:
        return 'internal_error';
    }
  }

  return 'unknown_error';
}


//# sourceMappingURL=span.js.map

// EXTERNAL MODULE: ../node_modules/@sentry/core/esm/constants.js
var constants = __webpack_require__(99330);
;// CONCATENATED MODULE: ../node_modules/@sentry/core/esm/tracing/transaction.js





/** JSDoc */
class Transaction extends Span  {

  /**
   * The reference to the current hub.
   */

   __init() {this._measurements = {};}

   __init2() {this._contexts = {};}

   __init3() {this._frozenDynamicSamplingContext = undefined;}

  /**
   * This constructor should never be called manually. Those instrumenting tracing should use
   * `Sentry.startTransaction()`, and internal methods should use `hub.startTransaction()`.
   * @internal
   * @hideconstructor
   * @hidden
   */
   constructor(transactionContext, hub) {
    super(transactionContext);Transaction.prototype.__init.call(this);Transaction.prototype.__init2.call(this);Transaction.prototype.__init3.call(this);
    this._hub = hub || (0,esm_hub/* getCurrentHub */.Gd)();

    this._name = transactionContext.name || '';

    this.metadata = {
      source: 'custom',
      ...transactionContext.metadata,
      spanMetadata: {},
    };

    this._trimEnd = transactionContext.trimEnd;

    // this is because transactions are also spans, and spans have a transaction pointer
    this.transaction = this;

    // If Dynamic Sampling Context is provided during the creation of the transaction, we freeze it as it usually means
    // there is incoming Dynamic Sampling Context. (Either through an incoming request, a baggage meta-tag, or other means)
    const incomingDynamicSamplingContext = this.metadata.dynamicSamplingContext;
    if (incomingDynamicSamplingContext) {
      // We shallow copy this in case anything writes to the original reference of the passed in `dynamicSamplingContext`
      this._frozenDynamicSamplingContext = { ...incomingDynamicSamplingContext };
    }
  }

  /** Getter for `name` property */
   get name() {
    return this._name;
  }

  /** Setter for `name` property, which also sets `source` as custom */
   set name(newName) {
    this.setName(newName);
  }

  /**
   * JSDoc
   */
   setName(name, source = 'custom') {
    this._name = name;
    this.metadata.source = source;
  }

  /**
   * Attaches SpanRecorder to the span itself
   * @param maxlen maximum number of spans that can be recorded
   */
   initSpanRecorder(maxlen = 1000) {
    if (!this.spanRecorder) {
      this.spanRecorder = new SpanRecorder(maxlen);
    }
    this.spanRecorder.add(this);
  }

  /**
   * @inheritDoc
   */
   setContext(key, context) {
    if (context === null) {
      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete this._contexts[key];
    } else {
      this._contexts[key] = context;
    }
  }

  /**
   * @inheritDoc
   */
   setMeasurement(name, value, unit = '') {
    this._measurements[name] = { value, unit };
  }

  /**
   * @inheritDoc
   */
   setMetadata(newMetadata) {
    this.metadata = { ...this.metadata, ...newMetadata };
  }

  /**
   * @inheritDoc
   */
   finish(endTimestamp) {
    // This transaction is already finished, so we should not flush it again.
    if (this.endTimestamp !== undefined) {
      return undefined;
    }

    if (!this.name) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.warn */.kg.warn('Transaction has no name, falling back to `<unlabeled transaction>`.');
      this.name = '<unlabeled transaction>';
    }

    // just sets the end timestamp
    super.finish(endTimestamp);

    const client = this._hub.getClient();
    if (client && client.emit) {
      client.emit('finishTransaction', this);
    }

    if (this.sampled !== true) {
      // At this point if `sampled !== true` we want to discard the transaction.
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log('[Tracing] Discarding transaction because its trace was not chosen to be sampled.');

      if (client) {
        client.recordDroppedEvent('sample_rate', 'transaction');
      }

      return undefined;
    }

    const finishedSpans = this.spanRecorder ? this.spanRecorder.spans.filter(s => s !== this && s.endTimestamp) : [];

    if (this._trimEnd && finishedSpans.length > 0) {
      this.endTimestamp = finishedSpans.reduce((prev, current) => {
        if (prev.endTimestamp && current.endTimestamp) {
          return prev.endTimestamp > current.endTimestamp ? prev : current;
        }
        return prev;
      }).endTimestamp;
    }

    const metadata = this.metadata;

    const transaction = {
      contexts: {
        ...this._contexts,
        // We don't want to override trace context
        trace: this.getTraceContext(),
      },
      spans: finishedSpans,
      start_timestamp: this.startTimestamp,
      tags: this.tags,
      timestamp: this.endTimestamp,
      transaction: this.name,
      type: 'transaction',
      sdkProcessingMetadata: {
        ...metadata,
        dynamicSamplingContext: this.getDynamicSamplingContext(),
      },
      ...(metadata.source && {
        transaction_info: {
          source: metadata.source,
        },
      }),
    };

    const hasMeasurements = Object.keys(this._measurements).length > 0;

    if (hasMeasurements) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        logger/* logger.log */.kg.log(
          '[Measurements] Adding measurements to transaction',
          JSON.stringify(this._measurements, undefined, 2),
        );
      transaction.measurements = this._measurements;
    }

    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log(`[Tracing] Finishing ${this.op} transaction: ${this.name}.`);

    return this._hub.captureEvent(transaction);
  }

  /**
   * @inheritDoc
   */
   toContext() {
    const spanContext = super.toContext();

    return (0,object/* dropUndefinedKeys */.Jr)({
      ...spanContext,
      name: this.name,
      trimEnd: this._trimEnd,
    });
  }

  /**
   * @inheritDoc
   */
   updateWithContext(transactionContext) {
    super.updateWithContext(transactionContext);

    this.name = transactionContext.name || '';

    this._trimEnd = transactionContext.trimEnd;

    return this;
  }

  /**
   * @inheritdoc
   *
   * @experimental
   */
   getDynamicSamplingContext() {
    if (this._frozenDynamicSamplingContext) {
      return this._frozenDynamicSamplingContext;
    }

    const hub = this._hub || (0,esm_hub/* getCurrentHub */.Gd)();
    const client = hub && hub.getClient();

    if (!client) return {};

    const { environment, release } = client.getOptions() || {};
    const { publicKey: public_key } = client.getDsn() || {};

    const maybeSampleRate = this.metadata.sampleRate;
    const sample_rate = maybeSampleRate !== undefined ? maybeSampleRate.toString() : undefined;

    const { segment: user_segment } = hub.getScope().getUser() || {};

    const source = this.metadata.source;

    // We don't want to have a transaction name in the DSC if the source is "url" because URLs might contain PII
    const transaction = source && source !== 'url' ? this.name : undefined;

    const dsc = (0,object/* dropUndefinedKeys */.Jr)({
      environment: environment || constants/* DEFAULT_ENVIRONMENT */.J,
      release,
      transaction,
      user_segment,
      public_key,
      trace_id: this.traceId,
      sample_rate,
    });

    // Uncomment if we want to make DSC immutable
    // this._frozenDynamicSamplingContext = dsc;

    client.emit && client.emit('createDsc', dsc);

    return dsc;
  }

  /**
   * Override the current hub with a new one.
   * Used if you want another hub to finish the transaction.
   *
   * @internal
   */
   setHub(hub) {
    this._hub = hub;
  }
}


//# sourceMappingURL=transaction.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/core/esm/tracing/idletransaction.js




const TRACING_DEFAULTS = {
  idleTimeout: 1000,
  finalTimeout: 30000,
  heartbeatInterval: 5000,
};

const FINISH_REASON_TAG = 'finishReason';

const IDLE_TRANSACTION_FINISH_REASONS = [
  'heartbeatFailed',
  'idleTimeout',
  'documentHidden',
  'finalTimeout',
  'externalFinish',
  'cancelled',
];

/**
 * @inheritDoc
 */
class IdleTransactionSpanRecorder extends SpanRecorder {
   constructor(
      _pushActivity,
      _popActivity,
     transactionSpanId,
    maxlen,
  ) {
    super(maxlen);this._pushActivity = _pushActivity;this._popActivity = _popActivity;this.transactionSpanId = transactionSpanId;  }

  /**
   * @inheritDoc
   */
   add(span) {
    // We should make sure we do not push and pop activities for
    // the transaction that this span recorder belongs to.
    if (span.spanId !== this.transactionSpanId) {
      // We patch span.finish() to pop an activity after setting an endTimestamp.
      span.finish = (endTimestamp) => {
        span.endTimestamp = typeof endTimestamp === 'number' ? endTimestamp : (0,esm_time/* timestampInSeconds */.ph)();
        this._popActivity(span.spanId);
      };

      // We should only push new activities if the span does not have an end timestamp.
      if (span.endTimestamp === undefined) {
        this._pushActivity(span.spanId);
      }
    }

    super.add(span);
  }
}

/**
 * An IdleTransaction is a transaction that automatically finishes. It does this by tracking child spans as activities.
 * You can have multiple IdleTransactions active, but if the `onScope` option is specified, the idle transaction will
 * put itself on the scope on creation.
 */
class IdleTransaction extends Transaction {
  // Activities store a list of active spans
   __init() {this.activities = {};}

  // Track state of activities in previous heartbeat

  // Amount of times heartbeat has counted. Will cause transaction to finish after 3 beats.
   __init2() {this._heartbeatCounter = 0;}

  // We should not use heartbeat if we finished a transaction
   __init3() {this._finished = false;}

  // Idle timeout was canceled and we should finish the transaction with the last span end.
   __init4() {this._idleTimeoutCanceledPermanently = false;}

    __init5() {this._beforeFinishCallbacks = [];}

  /**
   * Timer that tracks Transaction idleTimeout
   */

   __init6() {this._finishReason = IDLE_TRANSACTION_FINISH_REASONS[4];}

   constructor(
    transactionContext,
      _idleHub,
    /**
     * The time to wait in ms until the idle transaction will be finished. This timer is started each time
     * there are no active spans on this transaction.
     */
      _idleTimeout = TRACING_DEFAULTS.idleTimeout,
    /**
     * The final value in ms that a transaction cannot exceed
     */
      _finalTimeout = TRACING_DEFAULTS.finalTimeout,
      _heartbeatInterval = TRACING_DEFAULTS.heartbeatInterval,
    // Whether or not the transaction should put itself on the scope when it starts and pop itself off when it ends
      _onScope = false,
  ) {
    super(transactionContext, _idleHub);this._idleHub = _idleHub;this._idleTimeout = _idleTimeout;this._finalTimeout = _finalTimeout;this._heartbeatInterval = _heartbeatInterval;this._onScope = _onScope;IdleTransaction.prototype.__init.call(this);IdleTransaction.prototype.__init2.call(this);IdleTransaction.prototype.__init3.call(this);IdleTransaction.prototype.__init4.call(this);IdleTransaction.prototype.__init5.call(this);IdleTransaction.prototype.__init6.call(this);
    if (_onScope) {
      // We set the transaction here on the scope so error events pick up the trace
      // context and attach it to the error.
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log(`Setting idle transaction on scope. Span ID: ${this.spanId}`);
      _idleHub.configureScope(scope => scope.setSpan(this));
    }

    this._restartIdleTimeout();
    setTimeout(() => {
      if (!this._finished) {
        this.setStatus('deadline_exceeded');
        this._finishReason = IDLE_TRANSACTION_FINISH_REASONS[3];
        this.finish();
      }
    }, this._finalTimeout);
  }

  /** {@inheritDoc} */
   finish(endTimestamp = (0,esm_time/* timestampInSeconds */.ph)()) {
    this._finished = true;
    this.activities = {};

    if (this.op === 'ui.action.click') {
      this.setTag(FINISH_REASON_TAG, this._finishReason);
    }

    if (this.spanRecorder) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        logger/* logger.log */.kg.log('[Tracing] finishing IdleTransaction', new Date(endTimestamp * 1000).toISOString(), this.op);

      for (const callback of this._beforeFinishCallbacks) {
        callback(this, endTimestamp);
      }

      this.spanRecorder.spans = this.spanRecorder.spans.filter((span) => {
        // If we are dealing with the transaction itself, we just return it
        if (span.spanId === this.spanId) {
          return true;
        }

        // We cancel all pending spans with status "cancelled" to indicate the idle transaction was finished early
        if (!span.endTimestamp) {
          span.endTimestamp = endTimestamp;
          span.setStatus('cancelled');
          (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
            logger/* logger.log */.kg.log('[Tracing] cancelling span since transaction ended early', JSON.stringify(span, undefined, 2));
        }

        const keepSpan = span.startTimestamp < endTimestamp;
        if (!keepSpan) {
          (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
            logger/* logger.log */.kg.log(
              '[Tracing] discarding Span since it happened after Transaction was finished',
              JSON.stringify(span, undefined, 2),
            );
        }
        return keepSpan;
      });

      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log('[Tracing] flushing IdleTransaction');
    } else {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log('[Tracing] No active IdleTransaction');
    }

    // if `this._onScope` is `true`, the transaction put itself on the scope when it started
    if (this._onScope) {
      const scope = this._idleHub.getScope();
      if (scope.getTransaction() === this) {
        scope.setSpan(undefined);
      }
    }

    return super.finish(endTimestamp);
  }

  /**
   * Register a callback function that gets excecuted before the transaction finishes.
   * Useful for cleanup or if you want to add any additional spans based on current context.
   *
   * This is exposed because users have no other way of running something before an idle transaction
   * finishes.
   */
   registerBeforeFinishCallback(callback) {
    this._beforeFinishCallbacks.push(callback);
  }

  /**
   * @inheritDoc
   */
   initSpanRecorder(maxlen) {
    if (!this.spanRecorder) {
      const pushActivity = (id) => {
        if (this._finished) {
          return;
        }
        this._pushActivity(id);
      };
      const popActivity = (id) => {
        if (this._finished) {
          return;
        }
        this._popActivity(id);
      };

      this.spanRecorder = new IdleTransactionSpanRecorder(pushActivity, popActivity, this.spanId, maxlen);

      // Start heartbeat so that transactions do not run forever.
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log('Starting heartbeat');
      this._pingHeartbeat();
    }
    this.spanRecorder.add(this);
  }

  /**
   * Cancels the existing idle timeout, if there is one.
   * @param restartOnChildSpanChange Default is `true`.
   *                                 If set to false the transaction will end
   *                                 with the last child span.
   */
   cancelIdleTimeout(
    endTimestamp,
    {
      restartOnChildSpanChange,
    }

 = {
      restartOnChildSpanChange: true,
    },
  ) {
    this._idleTimeoutCanceledPermanently = restartOnChildSpanChange === false;
    if (this._idleTimeoutID) {
      clearTimeout(this._idleTimeoutID);
      this._idleTimeoutID = undefined;

      if (Object.keys(this.activities).length === 0 && this._idleTimeoutCanceledPermanently) {
        this._finishReason = IDLE_TRANSACTION_FINISH_REASONS[5];
        this.finish(endTimestamp);
      }
    }
  }

  /**
   * Temporary method used to externally set the transaction's `finishReason`
   *
   * ** WARNING**
   * This is for the purpose of experimentation only and will be removed in the near future, do not use!
   *
   * @internal
   *
   */
   setFinishReason(reason) {
    this._finishReason = reason;
  }

  /**
   * Restarts idle timeout, if there is no running idle timeout it will start one.
   */
   _restartIdleTimeout(endTimestamp) {
    this.cancelIdleTimeout();
    this._idleTimeoutID = setTimeout(() => {
      if (!this._finished && Object.keys(this.activities).length === 0) {
        this._finishReason = IDLE_TRANSACTION_FINISH_REASONS[1];
        this.finish(endTimestamp);
      }
    }, this._idleTimeout);
  }

  /**
   * Start tracking a specific activity.
   * @param spanId The span id that represents the activity
   */
   _pushActivity(spanId) {
    this.cancelIdleTimeout(undefined, { restartOnChildSpanChange: !this._idleTimeoutCanceledPermanently });
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log(`[Tracing] pushActivity: ${spanId}`);
    this.activities[spanId] = true;
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log('[Tracing] new activities count', Object.keys(this.activities).length);
  }

  /**
   * Remove an activity from usage
   * @param spanId The span id that represents the activity
   */
   _popActivity(spanId) {
    if (this.activities[spanId]) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log(`[Tracing] popActivity ${spanId}`);
      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete this.activities[spanId];
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log('[Tracing] new activities count', Object.keys(this.activities).length);
    }

    if (Object.keys(this.activities).length === 0) {
      const endTimestamp = (0,esm_time/* timestampInSeconds */.ph)();
      if (this._idleTimeoutCanceledPermanently) {
        this._finishReason = IDLE_TRANSACTION_FINISH_REASONS[5];
        this.finish(endTimestamp);
      } else {
        // We need to add the timeout here to have the real endtimestamp of the transaction
        // Remember timestampInSeconds is in seconds, timeout is in ms
        this._restartIdleTimeout(endTimestamp + this._idleTimeout / 1000);
      }
    }
  }

  /**
   * Checks when entries of this.activities are not changing for 3 beats.
   * If this occurs we finish the transaction.
   */
   _beat() {
    // We should not be running heartbeat if the idle transaction is finished.
    if (this._finished) {
      return;
    }

    const heartbeatString = Object.keys(this.activities).join('');

    if (heartbeatString === this._prevHeartbeatString) {
      this._heartbeatCounter++;
    } else {
      this._heartbeatCounter = 1;
    }

    this._prevHeartbeatString = heartbeatString;

    if (this._heartbeatCounter >= 3) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log('[Tracing] Transaction finished because of no change for 3 heart beats');
      this.setStatus('deadline_exceeded');
      this._finishReason = IDLE_TRANSACTION_FINISH_REASONS[0];
      this.finish();
    } else {
      this._pingHeartbeat();
    }
  }

  /**
   * Pings the heartbeat
   */
   _pingHeartbeat() {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log(`pinging Heartbeat -> current counter: ${this._heartbeatCounter}`);
    setTimeout(() => {
      this._beat();
    }, this._heartbeatInterval);
  }
}


//# sourceMappingURL=idletransaction.js.map

// EXTERNAL MODULE: ../node_modules/@sentry/utils/esm/is.js
var is = __webpack_require__(66885);
// EXTERNAL MODULE: ../node_modules/@sentry/utils/esm/instrument.js + 1 modules
var instrument = __webpack_require__(15188);
;// CONCATENATED MODULE: ../node_modules/@sentry/core/esm/tracing/utils.js



/** Grabs active transaction off scope, if any */
function getActiveTransaction(maybeHub) {
  const hub = maybeHub || (0,esm_hub/* getCurrentHub */.Gd)();
  const scope = hub.getScope();
  return scope.getTransaction() ;
}


//# sourceMappingURL=utils.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/core/esm/tracing/errors.js



let errorsInstrumented = false;

/**
 * Configures global error listeners
 */
function registerErrorInstrumentation() {
  if (errorsInstrumented) {
    return;
  }

  errorsInstrumented = true;
  (0,instrument/* addInstrumentationHandler */.oq)('error', errorCallback);
  (0,instrument/* addInstrumentationHandler */.oq)('unhandledrejection', errorCallback);
}

/**
 * If an error or unhandled promise occurs, we mark the active transaction as failed
 */
function errorCallback() {
  const activeTransaction = getActiveTransaction();
  if (activeTransaction) {
    const status = 'internal_error';
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log(`[Tracing] Transaction: ${status} -> Global error occured`);
    activeTransaction.setStatus(status);
  }
}

// The function name will be lost when bundling but we need to be able to identify this listener later to maintain the
// node.js default exit behaviour
errorCallback.tag = 'sentry_tracingErrorCallback';


//# sourceMappingURL=errors.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/core/esm/tracing/hubextensions.js







/** Returns all trace headers that are currently on the top scope. */
function traceHeaders() {
  const scope = this.getScope();
  const span = scope.getSpan();

  return span
    ? {
        'sentry-trace': span.toTraceparent(),
      }
    : {};
}

/**
 * Makes a sampling decision for the given transaction and stores it on the transaction.
 *
 * Called every time a transaction is created. Only transactions which emerge with a `sampled` value of `true` will be
 * sent to Sentry.
 *
 * @param transaction: The transaction needing a sampling decision
 * @param options: The current client's options, so we can access `tracesSampleRate` and/or `tracesSampler`
 * @param samplingContext: Default and user-provided data which may be used to help make the decision
 *
 * @returns The given transaction with its `sampled` value set
 */
function sample(
  transaction,
  options,
  samplingContext,
) {
  // nothing to do if tracing is not enabled
  if (!hasTracingEnabled(options)) {
    transaction.sampled = false;
    return transaction;
  }

  // if the user has forced a sampling decision by passing a `sampled` value in their transaction context, go with that
  if (transaction.sampled !== undefined) {
    transaction.setMetadata({
      sampleRate: Number(transaction.sampled),
    });
    return transaction;
  }

  // we would have bailed already if neither `tracesSampler` nor `tracesSampleRate` nor `enableTracing` were defined, so one of these should
  // work; prefer the hook if so
  let sampleRate;
  if (typeof options.tracesSampler === 'function') {
    sampleRate = options.tracesSampler(samplingContext);
    transaction.setMetadata({
      sampleRate: Number(sampleRate),
    });
  } else if (samplingContext.parentSampled !== undefined) {
    sampleRate = samplingContext.parentSampled;
  } else if (typeof options.tracesSampleRate !== 'undefined') {
    sampleRate = options.tracesSampleRate;
    transaction.setMetadata({
      sampleRate: Number(sampleRate),
    });
  } else {
    // When `enableTracing === true`, we use a sample rate of 100%
    sampleRate = 1;
    transaction.setMetadata({
      sampleRate,
    });
  }

  // Since this is coming from the user (or from a function provided by the user), who knows what we might get. (The
  // only valid values are booleans or numbers between 0 and 1.)
  if (!isValidSampleRate(sampleRate)) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.warn */.kg.warn('[Tracing] Discarding transaction because of invalid sample rate.');
    transaction.sampled = false;
    return transaction;
  }

  // if the function returned 0 (or false), or if `tracesSampleRate` is 0, it's a sign the transaction should be dropped
  if (!sampleRate) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      logger/* logger.log */.kg.log(
        `[Tracing] Discarding transaction because ${
          typeof options.tracesSampler === 'function'
            ? 'tracesSampler returned 0 or false'
            : 'a negative sampling decision was inherited or tracesSampleRate is set to 0'
        }`,
      );
    transaction.sampled = false;
    return transaction;
  }

  // Now we roll the dice. Math.random is inclusive of 0, but not of 1, so strict < is safe here. In case sampleRate is
  // a boolean, the < comparison will cause it to be automatically cast to 1 if it's true and 0 if it's false.
  transaction.sampled = Math.random() < (sampleRate );

  // if we're not going to keep it, we're done
  if (!transaction.sampled) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      logger/* logger.log */.kg.log(
        `[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ${Number(
          sampleRate,
        )})`,
      );
    return transaction;
  }

  (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log(`[Tracing] starting ${transaction.op} transaction - ${transaction.name}`);
  return transaction;
}

/**
 * Checks the given sample rate to make sure it is valid type and value (a boolean, or a number between 0 and 1).
 */
function isValidSampleRate(rate) {
  // we need to check NaN explicitly because it's of type 'number' and therefore wouldn't get caught by this typecheck
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  if ((0,is/* isNaN */.i2)(rate) || !(typeof rate === 'number' || typeof rate === 'boolean')) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      logger/* logger.warn */.kg.warn(
        `[Tracing] Given sample rate is invalid. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(
          rate,
        )} of type ${JSON.stringify(typeof rate)}.`,
      );
    return false;
  }

  // in case sampleRate is a boolean, it will get automatically cast to 1 if it's true and 0 if it's false
  if (rate < 0 || rate > 1) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      logger/* logger.warn */.kg.warn(`[Tracing] Given sample rate is invalid. Sample rate must be between 0 and 1. Got ${rate}.`);
    return false;
  }
  return true;
}

/**
 * Creates a new transaction and adds a sampling decision if it doesn't yet have one.
 *
 * The Hub.startTransaction method delegates to this method to do its work, passing the Hub instance in as `this`, as if
 * it had been called on the hub directly. Exists as a separate function so that it can be injected into the class as an
 * "extension method."
 *
 * @param this: The Hub starting the transaction
 * @param transactionContext: Data used to configure the transaction
 * @param CustomSamplingContext: Optional data to be provided to the `tracesSampler` function (if any)
 *
 * @returns The new transaction
 *
 * @see {@link Hub.startTransaction}
 */
function _startTransaction(

  transactionContext,
  customSamplingContext,
) {
  const client = this.getClient();
  const options = (client && client.getOptions()) || {};

  const configInstrumenter = options.instrumenter || 'sentry';
  const transactionInstrumenter = transactionContext.instrumenter || 'sentry';

  if (configInstrumenter !== transactionInstrumenter) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      logger/* logger.error */.kg.error(
        `A transaction was started with instrumenter=\`${transactionInstrumenter}\`, but the SDK is configured with the \`${configInstrumenter}\` instrumenter.
The transaction will not be sampled. Please use the ${configInstrumenter} instrumentation to start transactions.`,
      );

    transactionContext.sampled = false;
  }

  let transaction = new Transaction(transactionContext, this);
  transaction = sample(transaction, options, {
    parentSampled: transactionContext.parentSampled,
    transactionContext,
    ...customSamplingContext,
  });
  if (transaction.sampled) {
    transaction.initSpanRecorder(options._experiments && (options._experiments.maxSpans ));
  }
  if (client && client.emit) {
    client.emit('startTransaction', transaction);
  }
  return transaction;
}

/**
 * Create new idle transaction.
 */
function startIdleTransaction(
  hub,
  transactionContext,
  idleTimeout,
  finalTimeout,
  onScope,
  customSamplingContext,
  heartbeatInterval,
) {
  const client = hub.getClient();
  const options = (client && client.getOptions()) || {};

  let transaction = new IdleTransaction(transactionContext, hub, idleTimeout, finalTimeout, heartbeatInterval, onScope);
  transaction = sample(transaction, options, {
    parentSampled: transactionContext.parentSampled,
    transactionContext,
    ...customSamplingContext,
  });
  if (transaction.sampled) {
    transaction.initSpanRecorder(options._experiments && (options._experiments.maxSpans ));
  }
  if (client && client.emit) {
    client.emit('startTransaction', transaction);
  }
  return transaction;
}

/**
 * Adds tracing extensions to the global hub.
 */
function addTracingExtensions() {
  const carrier = (0,esm_hub/* getMainCarrier */.cu)();
  if (!carrier.__SENTRY__) {
    return;
  }
  carrier.__SENTRY__.extensions = carrier.__SENTRY__.extensions || {};
  if (!carrier.__SENTRY__.extensions.startTransaction) {
    carrier.__SENTRY__.extensions.startTransaction = _startTransaction;
  }
  if (!carrier.__SENTRY__.extensions.traceHeaders) {
    carrier.__SENTRY__.extensions.traceHeaders = traceHeaders;
  }

  registerErrorInstrumentation();
}


//# sourceMappingURL=hubextensions.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/utils/esm/tracing.js
const TRACEPARENT_REGEXP = new RegExp(
  '^[ \\t]*' + // whitespace
    '([0-9a-f]{32})?' + // trace_id
    '-?([0-9a-f]{16})?' + // span_id
    '-?([01])?' + // sampled
    '[ \\t]*$', // whitespace
);

/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */
function extractTraceparentData(traceparent) {
  const matches = traceparent.match(TRACEPARENT_REGEXP);

  if (!traceparent || !matches) {
    // empty string or no matches is invalid traceparent data
    return undefined;
  }

  let parentSampled;
  if (matches[3] === '1') {
    parentSampled = true;
  } else if (matches[3] === '0') {
    parentSampled = false;
  }

  return {
    traceId: matches[1],
    parentSampled,
    parentSpanId: matches[2],
  };
}


//# sourceMappingURL=tracing.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/utils/esm/baggage.js



const BAGGAGE_HEADER_NAME = 'baggage';

const SENTRY_BAGGAGE_KEY_PREFIX = 'sentry-';

const SENTRY_BAGGAGE_KEY_PREFIX_REGEX = /^sentry-/;

/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */
const MAX_BAGGAGE_STRING_LENGTH = 8192;

/**
 * Takes a baggage header and turns it into Dynamic Sampling Context, by extracting all the "sentry-" prefixed values
 * from it.
 *
 * @param baggageHeader A very bread definition of a baggage header as it might appear in various frameworks.
 * @returns The Dynamic Sampling Context that was found on `baggageHeader`, if there was any, `undefined` otherwise.
 */
function baggageHeaderToDynamicSamplingContext(
  // Very liberal definition of what any incoming header might look like
  baggageHeader,
) {
  if (!(0,is/* isString */.HD)(baggageHeader) && !Array.isArray(baggageHeader)) {
    return undefined;
  }

  // Intermediary object to store baggage key value pairs of incoming baggage headers on.
  // It is later used to read Sentry-DSC-values from.
  let baggageObject = {};

  if (Array.isArray(baggageHeader)) {
    // Combine all baggage headers into one object containing the baggage values so we can later read the Sentry-DSC-values from it
    baggageObject = baggageHeader.reduce((acc, curr) => {
      const currBaggageObject = baggageHeaderToObject(curr);
      return {
        ...acc,
        ...currBaggageObject,
      };
    }, {});
  } else {
    // Return undefined if baggage header is an empty string (technically an empty baggage header is not spec conform but
    // this is how we choose to handle it)
    if (!baggageHeader) {
      return undefined;
    }

    baggageObject = baggageHeaderToObject(baggageHeader);
  }

  // Read all "sentry-" prefixed values out of the baggage object and put it onto a dynamic sampling context object.
  const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value]) => {
    if (key.match(SENTRY_BAGGAGE_KEY_PREFIX_REGEX)) {
      const nonPrefixedKey = key.slice(SENTRY_BAGGAGE_KEY_PREFIX.length);
      acc[nonPrefixedKey] = value;
    }
    return acc;
  }, {});

  // Only return a dynamic sampling context object if there are keys in it.
  // A keyless object means there were no sentry values on the header, which means that there is no DSC.
  if (Object.keys(dynamicSamplingContext).length > 0) {
    return dynamicSamplingContext ;
  } else {
    return undefined;
  }
}

/**
 * Turns a Dynamic Sampling Object into a baggage header by prefixing all the keys on the object with "sentry-".
 *
 * @param dynamicSamplingContext The Dynamic Sampling Context to turn into a header. For convenience and compatibility
 * with the `getDynamicSamplingContext` method on the Transaction class ,this argument can also be `undefined`. If it is
 * `undefined` the function will return `undefined`.
 * @returns a baggage header, created from `dynamicSamplingContext`, or `undefined` either if `dynamicSamplingContext`
 * was `undefined`, or if `dynamicSamplingContext` didn't contain any values.
 */
function dynamicSamplingContextToSentryBaggageHeader(
  // this also takes undefined for convenience and bundle size in other places
  dynamicSamplingContext,
) {
  // Prefix all DSC keys with "sentry-" and put them into a new object
  const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce(
    (acc, [dscKey, dscValue]) => {
      if (dscValue) {
        acc[`${SENTRY_BAGGAGE_KEY_PREFIX}${dscKey}`] = dscValue;
      }
      return acc;
    },
    {},
  );

  return objectToBaggageHeader(sentryPrefixedDSC);
}

/**
 * Will parse a baggage header, which is a simple key-value map, into a flat object.
 *
 * @param baggageHeader The baggage header to parse.
 * @returns a flat object containing all the key-value pairs from `baggageHeader`.
 */
function baggageHeaderToObject(baggageHeader) {
  return baggageHeader
    .split(',')
    .map(baggageEntry => baggageEntry.split('=').map(keyOrValue => decodeURIComponent(keyOrValue.trim())))
    .reduce((acc, [key, value]) => {
      acc[key] = value;
      return acc;
    }, {});
}

/**
 * Turns a flat object (key-value pairs) into a baggage header, which is also just key-value pairs.
 *
 * @param object The object to turn into a baggage header.
 * @returns a baggage header string, or `undefined` if the object didn't have any values, since an empty baggage header
 * is not spec compliant.
 */
function objectToBaggageHeader(object) {
  if (Object.keys(object).length === 0) {
    // An empty baggage header is not spec compliant: We return undefined.
    return undefined;
  }

  return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex) => {
    const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
    const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
    if (newBaggageHeader.length > MAX_BAGGAGE_STRING_LENGTH) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        logger/* logger.warn */.kg.warn(
          `Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`,
        );
      return baggageHeader;
    } else {
      return newBaggageHeader;
    }
  }, '');
}


//# sourceMappingURL=baggage.js.map

// EXTERNAL MODULE: ../node_modules/@sentry/utils/esm/browser.js
var browser = __webpack_require__(61495);
// EXTERNAL MODULE: ../node_modules/@sentry/utils/esm/worldwide.js
var worldwide = __webpack_require__(74211);
;// CONCATENATED MODULE: ../node_modules/@sentry-internal/tracing/esm/browser/types.js


const WINDOW = worldwide/* GLOBAL_OBJ */.n2 ;


//# sourceMappingURL=types.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry-internal/tracing/esm/browser/backgroundtab.js




/**
 * Add a listener that cancels and finishes a transaction when the global
 * document is hidden.
 */
function registerBackgroundTabDetection() {
  if (WINDOW && WINDOW.document) {
    WINDOW.document.addEventListener('visibilitychange', () => {
      const activeTransaction = getActiveTransaction() ;
      if (WINDOW.document.hidden && activeTransaction) {
        const statusType = 'cancelled';

        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
          logger/* logger.log */.kg.log(
            `[Tracing] Transaction: ${statusType} -> since tab moved to the background, op: ${activeTransaction.op}`,
          );
        // We should not set status if it is already set, this prevent important statuses like
        // error or data loss from being overwritten on transaction.
        if (!activeTransaction.status) {
          activeTransaction.setStatus(statusType);
        }
        activeTransaction.setTag('visibilitychange', 'document.hidden');
        activeTransaction.finish();
      }
    });
  } else {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      logger/* logger.warn */.kg.warn('[Tracing] Could not set up background tab detection due to lack of global document');
  }
}


//# sourceMappingURL=backgroundtab.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry-internal/tracing/esm/browser/web-vitals/lib/bindReporter.js
const bindReporter = (
  callback,
  metric,
  reportAllChanges,
) => {
  let prevValue;
  let delta;
  return (forceReport) => {
    if (metric.value >= 0) {
      if (forceReport || reportAllChanges) {
        delta = metric.value - (prevValue || 0);

        // Report the metric if there's a non-zero delta or if no previous
        // value exists (which can happen in the case of the document becoming
        // hidden when the metric value is 0).
        // See: https://github.com/GoogleChrome/web-vitals/issues/14
        if (delta || prevValue === undefined) {
          prevValue = metric.value;
          metric.delta = delta;
          callback(metric);
        }
      }
    }
  };
};


//# sourceMappingURL=bindReporter.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry-internal/tracing/esm/browser/web-vitals/lib/generateUniqueID.js
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Performantly generate a unique, 30-char string by combining a version
 * number, the current timestamp with a 13-digit number integer.
 * @return {string}
 */
const generateUniqueID = () => {
  return `v3-${Date.now()}-${Math.floor(Math.random() * (9e12 - 1)) + 1e12}`;
};


//# sourceMappingURL=generateUniqueID.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry-internal/tracing/esm/browser/web-vitals/lib/getNavigationEntry.js


/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

const getNavigationEntryFromPerformanceTiming = () => {
  // eslint-disable-next-line deprecation/deprecation
  const timing = WINDOW.performance.timing;
  // eslint-disable-next-line deprecation/deprecation
  const type = WINDOW.performance.navigation.type;

  const navigationEntry = {
    entryType: 'navigation',
    startTime: 0,
    type: type == 2 ? 'back_forward' : type === 1 ? 'reload' : 'navigate',
  };

  for (const key in timing) {
    if (key !== 'navigationStart' && key !== 'toJSON') {
      navigationEntry[key] = Math.max((timing[key ] ) - timing.navigationStart, 0);
    }
  }
  return navigationEntry ;
};

const getNavigationEntry = () => {
  if (WINDOW.__WEB_VITALS_POLYFILL__) {
    return (
      WINDOW.performance &&
      ((performance.getEntriesByType && performance.getEntriesByType('navigation')[0]) ||
        getNavigationEntryFromPerformanceTiming())
    );
  } else {
    return WINDOW.performance && performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
  }
};


//# sourceMappingURL=getNavigationEntry.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry-internal/tracing/esm/browser/web-vitals/lib/getActivationStart.js


/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

const getActivationStart = () => {
  const navEntry = getNavigationEntry();
  return (navEntry && navEntry.activationStart) || 0;
};


//# sourceMappingURL=getActivationStart.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry-internal/tracing/esm/browser/web-vitals/lib/initMetric.js





/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

const initMetric = (name, value) => {
  const navEntry = getNavigationEntry();
  let navigationType = 'navigate';

  if (navEntry) {
    if (WINDOW.document.prerendering || getActivationStart() > 0) {
      navigationType = 'prerender';
    } else {
      navigationType = navEntry.type.replace(/_/g, '-') ;
    }
  }

  return {
    name,
    value: typeof value === 'undefined' ? -1 : value,
    rating: 'good', // Will be updated if the value changes.
    delta: 0,
    entries: [],
    id: generateUniqueID(),
    navigationType,
  };
};


//# sourceMappingURL=initMetric.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry-internal/tracing/esm/browser/web-vitals/lib/observe.js
/**
 * Takes a performance entry type and a callback function, and creates a
 * `PerformanceObserver` instance that will observe the specified entry type
 * with buffering enabled and call the callback _for each entry_.
 *
 * This function also feature-detects entry support and wraps the logic in a
 * try/catch to avoid errors in unsupporting browsers.
 */
const observe = (
  type,
  callback,
  opts,
) => {
  try {
    if (PerformanceObserver.supportedEntryTypes.includes(type)) {
      const po = new PerformanceObserver(list => {
        callback(list.getEntries() );
      });
      po.observe(
        Object.assign(
          {
            type,
            buffered: true,
          },
          opts || {},
        ) ,
      );
      return po;
    }
  } catch (e) {
    // Do nothing.
  }
  return;
};


//# sourceMappingURL=observe.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry-internal/tracing/esm/browser/web-vitals/lib/onHidden.js


/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

const onHidden = (cb, once) => {
  const onHiddenOrPageHide = (event) => {
    if (event.type === 'pagehide' || WINDOW.document.visibilityState === 'hidden') {
      cb(event);
      if (once) {
        removeEventListener('visibilitychange', onHiddenOrPageHide, true);
        removeEventListener('pagehide', onHiddenOrPageHide, true);
      }
    }
  };
  addEventListener('visibilitychange', onHiddenOrPageHide, true);
  // Some browsers have buggy implementations of visibilitychange,
  // so we use pagehide in addition, just to be safe.
  addEventListener('pagehide', onHiddenOrPageHide, true);
};


//# sourceMappingURL=onHidden.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry-internal/tracing/esm/browser/web-vitals/getCLS.js





/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Calculates the [CLS](https://web.dev/cls/) value for the current page and
 * calls the `callback` function once the value is ready to be reported, along
 * with all `layout-shift` performance entries that were used in the metric
 * value calculation. The reported value is a `double` (corresponding to a
 * [layout shift score](https://web.dev/cls/#layout-shift-score)).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** CLS should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */
const onCLS = (onReport) => {
  const metric = initMetric('CLS', 0);
  let report;

  let sessionValue = 0;
  let sessionEntries = [];

  // const handleEntries = (entries: Metric['entries']) => {
  const handleEntries = (entries) => {
    entries.forEach(entry => {
      // Only count layout shifts without recent user input.
      if (!entry.hadRecentInput) {
        const firstSessionEntry = sessionEntries[0];
        const lastSessionEntry = sessionEntries[sessionEntries.length - 1];

        // If the entry occurred less than 1 second after the previous entry and
        // less than 5 seconds after the first entry in the session, include the
        // entry in the current session. Otherwise, start a new session.
        if (
          sessionValue &&
          sessionEntries.length !== 0 &&
          entry.startTime - lastSessionEntry.startTime < 1000 &&
          entry.startTime - firstSessionEntry.startTime < 5000
        ) {
          sessionValue += entry.value;
          sessionEntries.push(entry);
        } else {
          sessionValue = entry.value;
          sessionEntries = [entry];
        }

        // If the current session value is larger than the current CLS value,
        // update CLS and the entries contributing to it.
        if (sessionValue > metric.value) {
          metric.value = sessionValue;
          metric.entries = sessionEntries;
          if (report) {
            report();
          }
        }
      }
    });
  };

  const po = observe('layout-shift', handleEntries);
  if (po) {
    report = bindReporter(onReport, metric);

    const stopListening = () => {
      handleEntries(po.takeRecords() );
      report(true);
    };

    onHidden(stopListening);

    return stopListening;
  }

  return;
};


//# sourceMappingURL=getCLS.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry-internal/tracing/esm/browser/web-vitals/lib/getVisibilityWatcher.js



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

let firstHiddenTime = -1;

const initHiddenTime = () => {
  // If the document is hidden and not prerendering, assume it was always
  // hidden and the page was loaded in the background.
  return WINDOW.document.visibilityState === 'hidden' && !WINDOW.document.prerendering ? 0 : Infinity;
};

const trackChanges = () => {
  // Update the time if/when the document becomes hidden.
  onHidden(({ timeStamp }) => {
    firstHiddenTime = timeStamp;
  }, true);
};

const getVisibilityWatcher = (

) => {
  if (firstHiddenTime < 0) {
    // If the document is hidden when this code runs, assume it was hidden
    // since navigation start. This isn't a perfect heuristic, but it's the
    // best we can do until an API is available to support querying past
    // visibilityState.
    firstHiddenTime = initHiddenTime();
    trackChanges();
  }
  return {
    get firstHiddenTime() {
      return firstHiddenTime;
    },
  };
};


//# sourceMappingURL=getVisibilityWatcher.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry-internal/tracing/esm/browser/web-vitals/getFID.js






/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Calculates the [FID](https://web.dev/fid/) value for the current page and
 * calls the `callback` function once the value is ready, along with the
 * relevant `first-input` performance entry used to determine the value. The
 * reported value is a `DOMHighResTimeStamp`.
 *
 * _**Important:** since FID is only reported after the user interacts with the
 * page, it's possible that it will not be reported for some page loads._
 */
const onFID = (onReport) => {
  const visibilityWatcher = getVisibilityWatcher();
  const metric = initMetric('FID');
  // eslint-disable-next-line prefer-const
  let report;

  const handleEntry = (entry) => {
    // Only report if the page wasn't hidden prior to the first input.
    if (entry.startTime < visibilityWatcher.firstHiddenTime) {
      metric.value = entry.processingStart - entry.startTime;
      metric.entries.push(entry);
      report(true);
    }
  };

  const handleEntries = (entries) => {
    (entries ).forEach(handleEntry);
  };

  const po = observe('first-input', handleEntries);
  report = bindReporter(onReport, metric);

  if (po) {
    onHidden(() => {
      handleEntries(po.takeRecords() );
      po.disconnect();
    }, true);
  }
};


//# sourceMappingURL=getFID.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry-internal/tracing/esm/browser/web-vitals/getLCP.js







/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

const reportedMetricIDs = {};

/**
 * Calculates the [LCP](https://web.dev/lcp/) value for the current page and
 * calls the `callback` function once the value is ready (along with the
 * relevant `largest-contentful-paint` performance entry used to determine the
 * value). The reported value is a `DOMHighResTimeStamp`.
 */
const onLCP = (onReport) => {
  const visibilityWatcher = getVisibilityWatcher();
  const metric = initMetric('LCP');
  let report;

  const handleEntries = (entries) => {
    const lastEntry = entries[entries.length - 1] ;
    if (lastEntry) {
      // The startTime attribute returns the value of the renderTime if it is
      // not 0, and the value of the loadTime otherwise. The activationStart
      // reference is used because LCP should be relative to page activation
      // rather than navigation start if the page was prerendered.
      const value = Math.max(lastEntry.startTime - getActivationStart(), 0);

      // Only report if the page wasn't hidden prior to LCP.
      if (value < visibilityWatcher.firstHiddenTime) {
        metric.value = value;
        metric.entries = [lastEntry];
        report();
      }
    }
  };

  const po = observe('largest-contentful-paint', handleEntries);

  if (po) {
    report = bindReporter(onReport, metric);

    const stopListening = () => {
      if (!reportedMetricIDs[metric.id]) {
        handleEntries(po.takeRecords() );
        po.disconnect();
        reportedMetricIDs[metric.id] = true;
        report(true);
      }
    };

    // Stop listening after input. Note: while scrolling is an input that
    // stop LCP observation, it's unreliable since it can be programmatically
    // generated. See: https://github.com/GoogleChrome/web-vitals/issues/75
    ['keydown', 'click'].forEach(type => {
      addEventListener(type, stopListening, { once: true, capture: true });
    });

    onHidden(stopListening, true);

    return stopListening;
  }

  return;
};


//# sourceMappingURL=getLCP.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry-internal/tracing/esm/browser/metrics/utils.js
/**
 * Checks if a given value is a valid measurement value.
 */
function isMeasurementValue(value) {
  return typeof value === 'number' && isFinite(value);
}

/**
 * Helper function to start child on transactions. This function will make sure that the transaction will
 * use the start timestamp of the created child span if it is earlier than the transactions actual
 * start timestamp.
 */
function _startChild(transaction, { startTimestamp, ...ctx }) {
  if (startTimestamp && transaction.startTimestamp > startTimestamp) {
    transaction.startTimestamp = startTimestamp;
  }

  return transaction.startChild({
    startTimestamp,
    ...ctx,
  });
}


//# sourceMappingURL=utils.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry-internal/tracing/esm/browser/metrics/index.js










/**
 * Converts from milliseconds to seconds
 * @param time time in ms
 */
function msToSec(time) {
  return time / 1000;
}

function getBrowserPerformanceAPI() {
  return WINDOW && WINDOW.addEventListener && WINDOW.performance;
}

let _performanceCursor = 0;

let _measurements = {};
let _lcpEntry;
let _clsEntry;

/**
 * Start tracking web vitals
 *
 * @returns A function that forces web vitals collection
 */
function startTrackingWebVitals() {
  const performance = getBrowserPerformanceAPI();
  if (performance && esm_time/* browserPerformanceTimeOrigin */.Z1) {
    if (performance.mark) {
      WINDOW.performance.mark('sentry-tracing-init');
    }
    _trackFID();
    const clsCallback = _trackCLS();
    const lcpCallback = _trackLCP();

    return () => {
      if (clsCallback) {
        clsCallback();
      }
      if (lcpCallback) {
        lcpCallback();
      }
    };
  }

  return () => undefined;
}

/**
 * Start tracking long tasks.
 */
function startTrackingLongTasks() {
  const entryHandler = (entries) => {
    for (const entry of entries) {
      const transaction = getActiveTransaction() ;
      if (!transaction) {
        return;
      }
      const startTime = msToSec((esm_time/* browserPerformanceTimeOrigin */.Z1 ) + entry.startTime);
      const duration = msToSec(entry.duration);

      transaction.startChild({
        description: 'Main UI thread blocked',
        op: 'ui.long-task',
        startTimestamp: startTime,
        endTimestamp: startTime + duration,
      });
    }
  };

  observe('longtask', entryHandler);
}

/**
 * Start tracking interaction events.
 */
function startTrackingInteractions() {
  const entryHandler = (entries) => {
    for (const entry of entries) {
      const transaction = getActiveTransaction() ;
      if (!transaction) {
        return;
      }

      if (entry.name === 'click') {
        const startTime = msToSec((esm_time/* browserPerformanceTimeOrigin */.Z1 ) + entry.startTime);
        const duration = msToSec(entry.duration);

        transaction.startChild({
          description: (0,browser/* htmlTreeAsString */.Rt)(entry.target),
          op: `ui.interaction.${entry.name}`,
          startTimestamp: startTime,
          endTimestamp: startTime + duration,
        });
      }
    }
  };

  observe('event', entryHandler, { durationThreshold: 0 });
}

/** Starts tracking the Cumulative Layout Shift on the current page. */
function _trackCLS() {
  // See:
  // https://web.dev/evolving-cls/
  // https://web.dev/cls-web-tooling/
  return onCLS(metric => {
    const entry = metric.entries.pop();
    if (!entry) {
      return;
    }

    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log('[Measurements] Adding CLS');
    _measurements['cls'] = { value: metric.value, unit: '' };
    _clsEntry = entry ;
  });
}

/** Starts tracking the Largest Contentful Paint on the current page. */
function _trackLCP() {
  return onLCP(metric => {
    const entry = metric.entries.pop();
    if (!entry) {
      return;
    }

    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log('[Measurements] Adding LCP');
    _measurements['lcp'] = { value: metric.value, unit: 'millisecond' };
    _lcpEntry = entry ;
  });
}

/** Starts tracking the First Input Delay on the current page. */
function _trackFID() {
  onFID(metric => {
    const entry = metric.entries.pop();
    if (!entry) {
      return;
    }

    const timeOrigin = msToSec(esm_time/* browserPerformanceTimeOrigin */.Z1 );
    const startTime = msToSec(entry.startTime);
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log('[Measurements] Adding FID');
    _measurements['fid'] = { value: metric.value, unit: 'millisecond' };
    _measurements['mark.fid'] = { value: timeOrigin + startTime, unit: 'second' };
  });
}

/** Add performance related spans to a transaction */
function addPerformanceEntries(transaction) {
  const performance = getBrowserPerformanceAPI();
  if (!performance || !WINDOW.performance.getEntries || !esm_time/* browserPerformanceTimeOrigin */.Z1) {
    // Gatekeeper if performance API not available
    return;
  }

  (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log('[Tracing] Adding & adjusting spans using Performance API');
  const timeOrigin = msToSec(esm_time/* browserPerformanceTimeOrigin */.Z1);

  const performanceEntries = performance.getEntries();

  let responseStartTimestamp;
  let requestStartTimestamp;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  performanceEntries.slice(_performanceCursor).forEach((entry) => {
    const startTime = msToSec(entry.startTime);
    const duration = msToSec(entry.duration);

    if (transaction.op === 'navigation' && timeOrigin + startTime < transaction.startTimestamp) {
      return;
    }

    switch (entry.entryType) {
      case 'navigation': {
        _addNavigationSpans(transaction, entry, timeOrigin);
        responseStartTimestamp = timeOrigin + msToSec(entry.responseStart);
        requestStartTimestamp = timeOrigin + msToSec(entry.requestStart);
        break;
      }
      case 'mark':
      case 'paint':
      case 'measure': {
        _addMeasureSpans(transaction, entry, startTime, duration, timeOrigin);

        // capture web vitals
        const firstHidden = getVisibilityWatcher();
        // Only report if the page wasn't hidden prior to the web vital.
        const shouldRecord = entry.startTime < firstHidden.firstHiddenTime;

        if (entry.name === 'first-paint' && shouldRecord) {
          (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log('[Measurements] Adding FP');
          _measurements['fp'] = { value: entry.startTime, unit: 'millisecond' };
        }
        if (entry.name === 'first-contentful-paint' && shouldRecord) {
          (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log('[Measurements] Adding FCP');
          _measurements['fcp'] = { value: entry.startTime, unit: 'millisecond' };
        }
        break;
      }
      case 'resource': {
        const resourceName = (entry.name ).replace(WINDOW.location.origin, '');
        _addResourceSpans(transaction, entry, resourceName, startTime, duration, timeOrigin);
        break;
      }
      // Ignore other entry types.
    }
  });

  _performanceCursor = Math.max(performanceEntries.length - 1, 0);

  _trackNavigator(transaction);

  // Measurements are only available for pageload transactions
  if (transaction.op === 'pageload') {
    // Generate TTFB (Time to First Byte), which measured as the time between the beginning of the transaction and the
    // start of the response in milliseconds
    if (typeof responseStartTimestamp === 'number') {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log('[Measurements] Adding TTFB');
      _measurements['ttfb'] = {
        value: (responseStartTimestamp - transaction.startTimestamp) * 1000,
        unit: 'millisecond',
      };

      if (typeof requestStartTimestamp === 'number' && requestStartTimestamp <= responseStartTimestamp) {
        // Capture the time spent making the request and receiving the first byte of the response.
        // This is the time between the start of the request and the start of the response in milliseconds.
        _measurements['ttfb.requestTime'] = {
          value: (responseStartTimestamp - requestStartTimestamp) * 1000,
          unit: 'millisecond',
        };
      }
    }

    ['fcp', 'fp', 'lcp'].forEach(name => {
      if (!_measurements[name] || timeOrigin >= transaction.startTimestamp) {
        return;
      }
      // The web vitals, fcp, fp, lcp, and ttfb, all measure relative to timeOrigin.
      // Unfortunately, timeOrigin is not captured within the transaction span data, so these web vitals will need
      // to be adjusted to be relative to transaction.startTimestamp.
      const oldValue = _measurements[name].value;
      const measurementTimestamp = timeOrigin + msToSec(oldValue);

      // normalizedValue should be in milliseconds
      const normalizedValue = Math.abs((measurementTimestamp - transaction.startTimestamp) * 1000);
      const delta = normalizedValue - oldValue;

      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        logger/* logger.log */.kg.log(`[Measurements] Normalized ${name} from ${oldValue} to ${normalizedValue} (${delta})`);
      _measurements[name].value = normalizedValue;
    });

    const fidMark = _measurements['mark.fid'];
    if (fidMark && _measurements['fid']) {
      // create span for FID
      _startChild(transaction, {
        description: 'first input delay',
        endTimestamp: fidMark.value + msToSec(_measurements['fid'].value),
        op: 'ui.action',
        startTimestamp: fidMark.value,
      });

      // Delete mark.fid as we don't want it to be part of final payload
      delete _measurements['mark.fid'];
    }

    // If FCP is not recorded we should not record the cls value
    // according to the new definition of CLS.
    if (!('fcp' in _measurements)) {
      delete _measurements.cls;
    }

    Object.keys(_measurements).forEach(measurementName => {
      transaction.setMeasurement(
        measurementName,
        _measurements[measurementName].value,
        _measurements[measurementName].unit,
      );
    });

    _tagMetricInfo(transaction);
  }

  _lcpEntry = undefined;
  _clsEntry = undefined;
  _measurements = {};
}

/** Create measure related spans */
function _addMeasureSpans(
  transaction,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  entry,
  startTime,
  duration,
  timeOrigin,
) {
  const measureStartTimestamp = timeOrigin + startTime;
  const measureEndTimestamp = measureStartTimestamp + duration;

  _startChild(transaction, {
    description: entry.name ,
    endTimestamp: measureEndTimestamp,
    op: entry.entryType ,
    startTimestamp: measureStartTimestamp,
  });

  return measureStartTimestamp;
}

/** Instrument navigation entries */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _addNavigationSpans(transaction, entry, timeOrigin) {
  ['unloadEvent', 'redirect', 'domContentLoadedEvent', 'loadEvent', 'connect'].forEach(event => {
    _addPerformanceNavigationTiming(transaction, entry, event, timeOrigin);
  });
  _addPerformanceNavigationTiming(transaction, entry, 'secureConnection', timeOrigin, 'TLS/SSL', 'connectEnd');
  _addPerformanceNavigationTiming(transaction, entry, 'fetch', timeOrigin, 'cache', 'domainLookupStart');
  _addPerformanceNavigationTiming(transaction, entry, 'domainLookup', timeOrigin, 'DNS');
  _addRequest(transaction, entry, timeOrigin);
}

/** Create performance navigation related spans */
function _addPerformanceNavigationTiming(
  transaction,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  entry,
  event,
  timeOrigin,
  description,
  eventEnd,
) {
  const end = eventEnd ? (entry[eventEnd] ) : (entry[`${event}End`] );
  const start = entry[`${event}Start`] ;
  if (!start || !end) {
    return;
  }
  _startChild(transaction, {
    op: 'browser',
    description: description || event,
    startTimestamp: timeOrigin + msToSec(start),
    endTimestamp: timeOrigin + msToSec(end),
  });
}

/** Create request and response related spans */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _addRequest(transaction, entry, timeOrigin) {
  _startChild(transaction, {
    op: 'browser',
    description: 'request',
    startTimestamp: timeOrigin + msToSec(entry.requestStart ),
    endTimestamp: timeOrigin + msToSec(entry.responseEnd ),
  });

  _startChild(transaction, {
    op: 'browser',
    description: 'response',
    startTimestamp: timeOrigin + msToSec(entry.responseStart ),
    endTimestamp: timeOrigin + msToSec(entry.responseEnd ),
  });
}

/** Create resource-related spans */
function _addResourceSpans(
  transaction,
  entry,
  resourceName,
  startTime,
  duration,
  timeOrigin,
) {
  // we already instrument based on fetch and xhr, so we don't need to
  // duplicate spans here.
  if (entry.initiatorType === 'xmlhttprequest' || entry.initiatorType === 'fetch') {
    return;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const data = {};
  if ('transferSize' in entry) {
    data['http.response_transfer_size'] = entry.transferSize;
  }
  if ('encodedBodySize' in entry) {
    data['http.response_content_length'] = entry.encodedBodySize;
  }
  if ('decodedBodySize' in entry) {
    data['http.decoded_response_content_length'] = entry.decodedBodySize;
  }
  if ('renderBlockingStatus' in entry) {
    data['resource.render_blocking_status'] = entry.renderBlockingStatus;
  }

  const startTimestamp = timeOrigin + startTime;
  const endTimestamp = startTimestamp + duration;

  _startChild(transaction, {
    description: resourceName,
    endTimestamp,
    op: entry.initiatorType ? `resource.${entry.initiatorType}` : 'resource.other',
    startTimestamp,
    data,
  });
}

/**
 * Capture the information of the user agent.
 */
function _trackNavigator(transaction) {
  const navigator = WINDOW.navigator ;
  if (!navigator) {
    return;
  }

  // track network connectivity
  const connection = navigator.connection;
  if (connection) {
    if (connection.effectiveType) {
      transaction.setTag('effectiveConnectionType', connection.effectiveType);
    }

    if (connection.type) {
      transaction.setTag('connectionType', connection.type);
    }

    if (isMeasurementValue(connection.rtt)) {
      _measurements['connection.rtt'] = { value: connection.rtt, unit: 'millisecond' };
    }
  }

  if (isMeasurementValue(navigator.deviceMemory)) {
    transaction.setTag('deviceMemory', `${navigator.deviceMemory} GB`);
  }

  if (isMeasurementValue(navigator.hardwareConcurrency)) {
    transaction.setTag('hardwareConcurrency', String(navigator.hardwareConcurrency));
  }
}

/** Add LCP / CLS data to transaction to allow debugging */
function _tagMetricInfo(transaction) {
  if (_lcpEntry) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log('[Measurements] Adding LCP Data');

    // Capture Properties of the LCP element that contributes to the LCP.

    if (_lcpEntry.element) {
      transaction.setTag('lcp.element', (0,browser/* htmlTreeAsString */.Rt)(_lcpEntry.element));
    }

    if (_lcpEntry.id) {
      transaction.setTag('lcp.id', _lcpEntry.id);
    }

    if (_lcpEntry.url) {
      // Trim URL to the first 200 characters.
      transaction.setTag('lcp.url', _lcpEntry.url.trim().slice(0, 200));
    }

    transaction.setTag('lcp.size', _lcpEntry.size);
  }

  // See: https://developer.mozilla.org/en-US/docs/Web/API/LayoutShift
  if (_clsEntry && _clsEntry.sources) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log('[Measurements] Adding CLS Data');
    _clsEntry.sources.forEach((source, index) =>
      transaction.setTag(`cls.source.${index + 1}`, (0,browser/* htmlTreeAsString */.Rt)(source.node)),
    );
  }
}


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ../node_modules/@sentry/utils/esm/string.js
var string = __webpack_require__(65268);
;// CONCATENATED MODULE: ../node_modules/@sentry-internal/tracing/esm/browser/request.js



/* eslint-disable max-lines */

const DEFAULT_TRACE_PROPAGATION_TARGETS = ['localhost', /^\/(?!\/)/];

/** Options for Request Instrumentation */

const defaultRequestInstrumentationOptions = {
  traceFetch: true,
  traceXHR: true,
  // TODO (v8): Remove this property
  tracingOrigins: DEFAULT_TRACE_PROPAGATION_TARGETS,
  tracePropagationTargets: DEFAULT_TRACE_PROPAGATION_TARGETS,
};

/** Registers span creators for xhr and fetch requests  */
function instrumentOutgoingRequests(_options) {
  // eslint-disable-next-line deprecation/deprecation
  const { traceFetch, traceXHR, tracePropagationTargets, tracingOrigins, shouldCreateSpanForRequest } = {
    traceFetch: defaultRequestInstrumentationOptions.traceFetch,
    traceXHR: defaultRequestInstrumentationOptions.traceXHR,
    ..._options,
  };

  const shouldCreateSpan =
    typeof shouldCreateSpanForRequest === 'function' ? shouldCreateSpanForRequest : (_) => true;

  // TODO(v8) Remove tracingOrigins here
  // The only reason we're passing it in here is because this instrumentOutgoingRequests function is publicly exported
  // and we don't want to break the API. We can remove it in v8.
  const shouldAttachHeadersWithTargets = (url) =>
    shouldAttachHeaders(url, tracePropagationTargets || tracingOrigins);

  const spans = {};

  if (traceFetch) {
    (0,instrument/* addInstrumentationHandler */.oq)('fetch', (handlerData) => {
      fetchCallback(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
    });
  }

  if (traceXHR) {
    (0,instrument/* addInstrumentationHandler */.oq)('xhr', (handlerData) => {
      xhrCallback(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
    });
  }
}

/**
 * A function that determines whether to attach tracing headers to a request.
 * This was extracted from `instrumentOutgoingRequests` to make it easier to test shouldAttachHeaders.
 * We only export this fuction for testing purposes.
 */
function shouldAttachHeaders(url, tracePropagationTargets) {
  return (0,string/* stringMatchesSomePattern */.U0)(url, tracePropagationTargets || DEFAULT_TRACE_PROPAGATION_TARGETS);
}

/**
 * Create and track fetch request spans
 */
function fetchCallback(
  handlerData,
  shouldCreateSpan,
  shouldAttachHeaders,
  spans,
) {
  if (!hasTracingEnabled() || !(handlerData.fetchData && shouldCreateSpan(handlerData.fetchData.url))) {
    return;
  }

  if (handlerData.endTimestamp) {
    const spanId = handlerData.fetchData.__span;
    if (!spanId) return;

    const span = spans[spanId];
    if (span) {
      if (handlerData.response) {
        // TODO (kmclb) remove this once types PR goes through
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        span.setHttpStatus(handlerData.response.status);

        const contentLength =
          // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
          handlerData.response && handlerData.response.headers && handlerData.response.headers.get('content-length');

        const contentLengthNum = parseInt(contentLength);
        if (contentLengthNum > 0) {
          span.setData('http.response_content_length', contentLengthNum);
        }
      } else if (handlerData.error) {
        span.setStatus('internal_error');
      }
      span.finish();

      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete spans[spanId];
    }
    return;
  }

  const currentScope = (0,esm_hub/* getCurrentHub */.Gd)().getScope();
  const currentSpan = currentScope && currentScope.getSpan();
  const activeTransaction = currentSpan && currentSpan.transaction;

  if (currentSpan && activeTransaction) {
    const { method, url } = handlerData.fetchData;
    const span = currentSpan.startChild({
      data: {
        url,
        type: 'fetch',
        'http.method': method,
      },
      description: `${method} ${url}`,
      op: 'http.client',
    });

    handlerData.fetchData.__span = span.spanId;
    spans[span.spanId] = span;

    const request = handlerData.args[0];

    // In case the user hasn't set the second argument of a fetch call we default it to `{}`.
    handlerData.args[1] = handlerData.args[1] || {};

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const options = handlerData.args[1];

    if (shouldAttachHeaders(handlerData.fetchData.url)) {
      options.headers = addTracingHeadersToFetchRequest(
        request,
        activeTransaction.getDynamicSamplingContext(),
        span,
        options,
      );
    }
  }
}

/**
 * Adds sentry-trace and baggage headers to the various forms of fetch headers
 */
function addTracingHeadersToFetchRequest(
  request, // unknown is actually type Request but we can't export DOM types from this package,
  dynamicSamplingContext,
  span,
  options

,
) {
  const sentryBaggageHeader = dynamicSamplingContextToSentryBaggageHeader(dynamicSamplingContext);
  const sentryTraceHeader = span.toTraceparent();

  const headers =
    typeof Request !== 'undefined' && (0,is/* isInstanceOf */.V9)(request, Request) ? (request ).headers : options.headers;

  if (!headers) {
    return { 'sentry-trace': sentryTraceHeader, baggage: sentryBaggageHeader };
  } else if (typeof Headers !== 'undefined' && (0,is/* isInstanceOf */.V9)(headers, Headers)) {
    const newHeaders = new Headers(headers );

    newHeaders.append('sentry-trace', sentryTraceHeader);

    if (sentryBaggageHeader) {
      // If the same header is appended multiple times the browser will merge the values into a single request header.
      // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
      newHeaders.append(BAGGAGE_HEADER_NAME, sentryBaggageHeader);
    }

    return newHeaders ;
  } else if (Array.isArray(headers)) {
    const newHeaders = [...headers, ['sentry-trace', sentryTraceHeader]];

    if (sentryBaggageHeader) {
      // If there are multiple entries with the same key, the browser will merge the values into a single request header.
      // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
      newHeaders.push([BAGGAGE_HEADER_NAME, sentryBaggageHeader]);
    }

    return newHeaders ;
  } else {
    const existingBaggageHeader = 'baggage' in headers ? headers.baggage : undefined;
    const newBaggageHeaders = [];

    if (Array.isArray(existingBaggageHeader)) {
      newBaggageHeaders.push(...existingBaggageHeader);
    } else if (existingBaggageHeader) {
      newBaggageHeaders.push(existingBaggageHeader);
    }

    if (sentryBaggageHeader) {
      newBaggageHeaders.push(sentryBaggageHeader);
    }

    return {
      ...(headers ),
      'sentry-trace': sentryTraceHeader,
      baggage: newBaggageHeaders.length > 0 ? newBaggageHeaders.join(',') : undefined,
    };
  }
}

/**
 * Create and track xhr request spans
 */
function xhrCallback(
  handlerData,
  shouldCreateSpan,
  shouldAttachHeaders,
  spans,
) {
  const xhr = handlerData.xhr;
  const sentryXhrData = xhr && xhr[instrument/* SENTRY_XHR_DATA_KEY */.xU];

  if (
    !hasTracingEnabled() ||
    (xhr && xhr.__sentry_own_request__) ||
    !(xhr && sentryXhrData && shouldCreateSpan(sentryXhrData.url))
  ) {
    return;
  }

  // check first if the request has finished and is tracked by an existing span which should now end
  if (handlerData.endTimestamp) {
    const spanId = xhr.__sentry_xhr_span_id__;
    if (!spanId) return;

    const span = spans[spanId];
    if (span) {
      span.setHttpStatus(sentryXhrData.status_code);
      span.finish();

      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete spans[spanId];
    }
    return;
  }

  const currentScope = (0,esm_hub/* getCurrentHub */.Gd)().getScope();
  const currentSpan = currentScope && currentScope.getSpan();
  const activeTransaction = currentSpan && currentSpan.transaction;

  if (currentSpan && activeTransaction) {
    const span = currentSpan.startChild({
      data: {
        ...sentryXhrData.data,
        type: 'xhr',
        'http.method': sentryXhrData.method,
        url: sentryXhrData.url,
      },
      description: `${sentryXhrData.method} ${sentryXhrData.url}`,
      op: 'http.client',
    });

    xhr.__sentry_xhr_span_id__ = span.spanId;
    spans[xhr.__sentry_xhr_span_id__] = span;

    if (xhr.setRequestHeader && shouldAttachHeaders(sentryXhrData.url)) {
      try {
        xhr.setRequestHeader('sentry-trace', span.toTraceparent());

        const dynamicSamplingContext = activeTransaction.getDynamicSamplingContext();
        const sentryBaggageHeader = dynamicSamplingContextToSentryBaggageHeader(dynamicSamplingContext);

        if (sentryBaggageHeader) {
          // From MDN: "If this method is called several times with the same header, the values are merged into one single request header."
          // We can therefore simply set a baggage header without checking what was there before
          // https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/setRequestHeader
          xhr.setRequestHeader(BAGGAGE_HEADER_NAME, sentryBaggageHeader);
        }
      } catch (_) {
        // Error: InvalidStateError: Failed to execute 'setRequestHeader' on 'XMLHttpRequest': The object's state must be OPENED.
      }
    }
  }
}


//# sourceMappingURL=request.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry-internal/tracing/esm/browser/router.js



/**
 * Default function implementing pageload and navigation transactions
 */
function instrumentRoutingWithDefaults(
  customStartTransaction,
  startTransactionOnPageLoad = true,
  startTransactionOnLocationChange = true,
) {
  if (!WINDOW || !WINDOW.location) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.warn */.kg.warn('Could not initialize routing instrumentation due to invalid location');
    return;
  }

  let startingUrl = WINDOW.location.href;

  let activeTransaction;
  if (startTransactionOnPageLoad) {
    activeTransaction = customStartTransaction({
      name: WINDOW.location.pathname,
      // pageload should always start at timeOrigin (and needs to be in s, not ms)
      startTimestamp: esm_time/* browserPerformanceTimeOrigin */.Z1 ? esm_time/* browserPerformanceTimeOrigin */.Z1 / 1000 : undefined,
      op: 'pageload',
      metadata: { source: 'url' },
    });
  }

  if (startTransactionOnLocationChange) {
    (0,instrument/* addInstrumentationHandler */.oq)('history', ({ to, from }) => {
      /**
       * This early return is there to account for some cases where a navigation transaction starts right after
       * long-running pageload. We make sure that if `from` is undefined and a valid `startingURL` exists, we don't
       * create an uneccessary navigation transaction.
       *
       * This was hard to duplicate, but this behavior stopped as soon as this fix was applied. This issue might also
       * only be caused in certain development environments where the usage of a hot module reloader is causing
       * errors.
       */
      if (from === undefined && startingUrl && startingUrl.indexOf(to) !== -1) {
        startingUrl = undefined;
        return;
      }

      if (from !== to) {
        startingUrl = undefined;
        if (activeTransaction) {
          (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log(`[Tracing] Finishing current transaction with op: ${activeTransaction.op}`);
          // If there's an open transaction on the scope, we need to finish it before creating an new one.
          activeTransaction.finish();
        }
        activeTransaction = customStartTransaction({
          name: WINDOW.location.pathname,
          op: 'navigation',
          metadata: { source: 'url' },
        });
      }
    });
  }
}


//# sourceMappingURL=router.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry-internal/tracing/esm/browser/browsertracing.js








const BROWSER_TRACING_INTEGRATION_ID = 'BrowserTracing';

/** Options for Browser Tracing integration */

const DEFAULT_BROWSER_TRACING_OPTIONS = {
  ...TRACING_DEFAULTS,
  markBackgroundTransactions: true,
  routingInstrumentation: instrumentRoutingWithDefaults,
  startTransactionOnLocationChange: true,
  startTransactionOnPageLoad: true,
  enableLongTask: true,
  _experiments: {},
  ...defaultRequestInstrumentationOptions,
};

/**
 * The Browser Tracing integration automatically instruments browser pageload/navigation
 * actions as transactions, and captures requests, metrics and errors as spans.
 *
 * The integration can be configured with a variety of options, and can be extended to use
 * any routing library. This integration uses {@see IdleTransaction} to create transactions.
 */
class BrowserTracing  {
  // This class currently doesn't have a static `id` field like the other integration classes, because it prevented
  // @sentry/tracing from being treeshaken. Tree shakers do not like static fields, because they behave like side effects.
  // TODO: Come up with a better plan, than using static fields on integration classes, and use that plan on all
  // integrations.

  /** Browser Tracing integration options */

  /**
   * @inheritDoc
   */
   __init() {this.name = BROWSER_TRACING_INTEGRATION_ID;}

   constructor(_options) {BrowserTracing.prototype.__init.call(this);
    addTracingExtensions();

    this.options = {
      ...DEFAULT_BROWSER_TRACING_OPTIONS,
      ..._options,
    };

    // Special case: enableLongTask can be set in _experiments
    // TODO (v8): Remove this in v8
    if (this.options._experiments.enableLongTask !== undefined) {
      this.options.enableLongTask = this.options._experiments.enableLongTask;
    }

    // TODO (v8): remove this block after tracingOrigins is removed
    // Set tracePropagationTargets to tracingOrigins if specified by the user
    // In case both are specified, tracePropagationTargets takes precedence
    // eslint-disable-next-line deprecation/deprecation
    if (_options && !_options.tracePropagationTargets && _options.tracingOrigins) {
      // eslint-disable-next-line deprecation/deprecation
      this.options.tracePropagationTargets = _options.tracingOrigins;
    }

    this._collectWebVitals = startTrackingWebVitals();
    if (this.options.enableLongTask) {
      startTrackingLongTasks();
    }
    if (this.options._experiments.enableInteractions) {
      startTrackingInteractions();
    }
  }

  /**
   * @inheritDoc
   */
   setupOnce(_, getCurrentHub) {
    this._getCurrentHub = getCurrentHub;

    const {
      routingInstrumentation: instrumentRouting,
      startTransactionOnLocationChange,
      startTransactionOnPageLoad,
      markBackgroundTransactions,
      traceFetch,
      traceXHR,
      tracePropagationTargets,
      shouldCreateSpanForRequest,
      _experiments,
    } = this.options;

    instrumentRouting(
      (context) => {
        const transaction = this._createRouteTransaction(context);

        this.options._experiments.onStartRouteTransaction &&
          this.options._experiments.onStartRouteTransaction(transaction, context, getCurrentHub);

        return transaction;
      },
      startTransactionOnPageLoad,
      startTransactionOnLocationChange,
    );

    if (markBackgroundTransactions) {
      registerBackgroundTabDetection();
    }

    if (_experiments.enableInteractions) {
      this._registerInteractionListener();
    }

    instrumentOutgoingRequests({
      traceFetch,
      traceXHR,
      tracePropagationTargets,
      shouldCreateSpanForRequest,
    });
  }

  /** Create routing idle transaction. */
   _createRouteTransaction(context) {
    if (!this._getCurrentHub) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        logger/* logger.warn */.kg.warn(`[Tracing] Did not create ${context.op} transaction because _getCurrentHub is invalid.`);
      return undefined;
    }

    const { beforeNavigate, idleTimeout, finalTimeout, heartbeatInterval } = this.options;

    const isPageloadTransaction = context.op === 'pageload';

    const sentryTraceMetaTagValue = isPageloadTransaction ? getMetaContent('sentry-trace') : null;
    const baggageMetaTagValue = isPageloadTransaction ? getMetaContent('baggage') : null;

    const traceParentData = sentryTraceMetaTagValue ? extractTraceparentData(sentryTraceMetaTagValue) : undefined;
    const dynamicSamplingContext = baggageMetaTagValue
      ? baggageHeaderToDynamicSamplingContext(baggageMetaTagValue)
      : undefined;

    const expandedContext = {
      ...context,
      ...traceParentData,
      metadata: {
        ...context.metadata,
        dynamicSamplingContext: traceParentData && !dynamicSamplingContext ? {} : dynamicSamplingContext,
      },
      trimEnd: true,
    };

    const modifiedContext = typeof beforeNavigate === 'function' ? beforeNavigate(expandedContext) : expandedContext;

    // For backwards compatibility reasons, beforeNavigate can return undefined to "drop" the transaction (prevent it
    // from being sent to Sentry).
    const finalContext = modifiedContext === undefined ? { ...expandedContext, sampled: false } : modifiedContext;

    // If `beforeNavigate` set a custom name, record that fact
    finalContext.metadata =
      finalContext.name !== expandedContext.name
        ? { ...finalContext.metadata, source: 'custom' }
        : finalContext.metadata;

    this._latestRouteName = finalContext.name;
    this._latestRouteSource = finalContext.metadata && finalContext.metadata.source;

    if (finalContext.sampled === false) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        logger/* logger.log */.kg.log(`[Tracing] Will not send ${finalContext.op} transaction because of beforeNavigate.`);
    }

    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log(`[Tracing] Starting ${finalContext.op} transaction on scope`);

    const hub = this._getCurrentHub();
    const { location } = WINDOW;

    const idleTransaction = startIdleTransaction(
      hub,
      finalContext,
      idleTimeout,
      finalTimeout,
      true,
      { location }, // for use in the tracesSampler
      heartbeatInterval,
    );
    idleTransaction.registerBeforeFinishCallback(transaction => {
      this._collectWebVitals();
      addPerformanceEntries(transaction);
    });

    return idleTransaction ;
  }

  /** Start listener for interaction transactions */
   _registerInteractionListener() {
    let inflightInteractionTransaction;
    const registerInteractionTransaction = () => {
      const { idleTimeout, finalTimeout, heartbeatInterval } = this.options;
      const op = 'ui.action.click';

      const currentTransaction = getActiveTransaction();
      if (currentTransaction && currentTransaction.op && ['navigation', 'pageload'].includes(currentTransaction.op)) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
          logger/* logger.warn */.kg.warn(
            `[Tracing] Did not create ${op} transaction because a pageload or navigation transaction is in progress.`,
          );
        return undefined;
      }

      if (inflightInteractionTransaction) {
        inflightInteractionTransaction.setFinishReason('interactionInterrupted');
        inflightInteractionTransaction.finish();
        inflightInteractionTransaction = undefined;
      }

      if (!this._getCurrentHub) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.warn */.kg.warn(`[Tracing] Did not create ${op} transaction because _getCurrentHub is invalid.`);
        return undefined;
      }

      if (!this._latestRouteName) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
          logger/* logger.warn */.kg.warn(`[Tracing] Did not create ${op} transaction because _latestRouteName is missing.`);
        return undefined;
      }

      const hub = this._getCurrentHub();
      const { location } = WINDOW;

      const context = {
        name: this._latestRouteName,
        op,
        trimEnd: true,
        metadata: {
          source: this._latestRouteSource || 'url',
        },
      };

      inflightInteractionTransaction = startIdleTransaction(
        hub,
        context,
        idleTimeout,
        finalTimeout,
        true,
        { location }, // for use in the tracesSampler
        heartbeatInterval,
      );
    };

    ['click'].forEach(type => {
      addEventListener(type, registerInteractionTransaction, { once: false, capture: true });
    });
  }
}

/** Returns the value of a meta tag */
function getMetaContent(metaName) {
  // Can't specify generic to `getDomElement` because tracing can be used
  // in a variety of environments, have to disable `no-unsafe-member-access`
  // as a result.
  const metaTag = (0,browser/* getDomElement */.qT)(`meta[name=${metaName}]`);
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  return metaTag ? metaTag.getAttribute('content') : null;
}


//# sourceMappingURL=browsertracing.js.map

// EXTERNAL MODULE: ../node_modules/@sentry/core/esm/integrations/functiontostring.js
var functiontostring = __webpack_require__(14979);
// EXTERNAL MODULE: ../node_modules/@sentry/core/esm/integrations/inboundfilters.js
var inboundfilters = __webpack_require__(37107);
;// CONCATENATED MODULE: ../node_modules/@sentry/core/esm/integrations/index.js


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ../node_modules/@sentry/core/esm/scope.js
var esm_scope = __webpack_require__(25516);
// EXTERNAL MODULE: ../node_modules/@sentry/core/esm/transports/base.js + 1 modules
var base = __webpack_require__(38862);
// EXTERNAL MODULE: ../node_modules/@sentry/utils/esm/envelope.js
var envelope = __webpack_require__(73285);
// EXTERNAL MODULE: ../node_modules/@sentry/utils/esm/dsn.js
var esm_dsn = __webpack_require__(73166);
// EXTERNAL MODULE: ../node_modules/@sentry/core/esm/api.js
var api = __webpack_require__(66485);
;// CONCATENATED MODULE: ../node_modules/@sentry/core/esm/transports/multiplexed.js



function eventFromEnvelope(env, types) {
  let event;

  (0,envelope/* forEachEnvelopeItem */.gv)(env, (item, type) => {
    if (types.includes(type)) {
      event = Array.isArray(item) ? (item )[1] : undefined;
    }
    // bail out if we found an event
    return !!event;
  });

  return event;
}

/**
 * Creates a transport that can send events to different DSNs depending on the envelope contents.
 */
function makeMultiplexedTransport(
  createTransport,
  matcher,
) {
  return options => {
    const fallbackTransport = createTransport(options);
    const otherTransports = {};

    function getTransport(dsn) {
      if (!otherTransports[dsn]) {
        const validatedDsn = (0,esm_dsn/* dsnFromString */.U4)(dsn);
        if (!validatedDsn) {
          return undefined;
        }
        const url = (0,api/* getEnvelopeEndpointWithUrlEncodedAuth */.U)(validatedDsn);
        otherTransports[dsn] = createTransport({ ...options, url });
      }

      return otherTransports[dsn];
    }

    async function send(envelope) {
      function getEvent(types) {
        const eventTypes = types && types.length ? types : ['event'];
        return eventFromEnvelope(envelope, eventTypes);
      }

      const transports = matcher({ envelope, getEvent })
        .map(dsn => getTransport(dsn))
        .filter((t) => !!t);

      // If we have no transports to send to, use the fallback transport
      if (transports.length === 0) {
        transports.push(fallbackTransport);
      }

      const results = await Promise.all(transports.map(transport => transport.send(envelope)));

      return results[0];
    }

    async function flush(timeout) {
      const allTransports = [...Object.keys(otherTransports).map(dsn => otherTransports[dsn]), fallbackTransport];
      const results = await Promise.all(allTransports.map(transport => transport.flush(timeout)));
      return results.every(r => r);
    }

    return {
      send,
      flush,
    };
  };
}


//# sourceMappingURL=multiplexed.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/core/esm/tracing/trace.js



/**
 * Wraps a function with a transaction/span and finishes the span after the function is done.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`, this function
 * will not generate spans, and the `span` returned from the callback may be undefined.
 *
 * This function is meant to be used internally and may break at any time. Use at your own risk.
 *
 * @internal
 * @private
 */
function trace(
  context,
  callback,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onError = () => {},
) {
  const ctx = { ...context };
  // If a name is set and a description is not, set the description to the name.
  if (ctx.name !== undefined && ctx.description === undefined) {
    ctx.description = ctx.name;
  }

  const hub = (0,esm_hub/* getCurrentHub */.Gd)();
  const scope = hub.getScope();

  const parentSpan = scope.getSpan();
  const activeSpan = parentSpan ? parentSpan.startChild(ctx) : hub.startTransaction(ctx);
  scope.setSpan(activeSpan);

  function finishAndSetSpan() {
    activeSpan && activeSpan.finish();
    hub.getScope().setSpan(parentSpan);
  }

  let maybePromiseResult;
  try {
    maybePromiseResult = callback(activeSpan);
  } catch (e) {
    activeSpan && activeSpan.setStatus('internal_error');
    onError(e);
    finishAndSetSpan();
    throw e;
  }

  if ((0,is/* isThenable */.J8)(maybePromiseResult)) {
    Promise.resolve(maybePromiseResult).then(
      () => {
        finishAndSetSpan();
      },
      e => {
        activeSpan && activeSpan.setStatus('internal_error');
        onError(e);
        finishAndSetSpan();
      },
    );
  } else {
    finishAndSetSpan();
  }

  return maybePromiseResult;
}


//# sourceMappingURL=trace.js.map

// EXTERNAL MODULE: ../node_modules/@sentry/browser/esm/helpers.js
var helpers = __webpack_require__(51197);
// EXTERNAL MODULE: ../node_modules/@sentry/browser/esm/client.js + 3 modules
var client = __webpack_require__(56921);
// EXTERNAL MODULE: ../node_modules/@sentry/browser/esm/transports/fetch.js + 1 modules
var fetch = __webpack_require__(81804);
// EXTERNAL MODULE: ../node_modules/@sentry/browser/esm/transports/xhr.js
var xhr = __webpack_require__(20296);
// EXTERNAL MODULE: ../node_modules/@sentry/browser/esm/stack-parsers.js
var stack_parsers = __webpack_require__(97939);
// EXTERNAL MODULE: ../node_modules/@sentry/browser/esm/eventbuilder.js
var eventbuilder = __webpack_require__(24708);
// EXTERNAL MODULE: ../node_modules/@sentry/browser/esm/userfeedback.js
var userfeedback = __webpack_require__(1367);
// EXTERNAL MODULE: ../node_modules/@sentry/browser/esm/integrations/globalhandlers.js
var globalhandlers = __webpack_require__(35519);
// EXTERNAL MODULE: ../node_modules/@sentry/browser/esm/integrations/trycatch.js
var trycatch = __webpack_require__(34183);
// EXTERNAL MODULE: ../node_modules/@sentry/browser/esm/integrations/breadcrumbs.js + 1 modules
var breadcrumbs = __webpack_require__(77);
// EXTERNAL MODULE: ../node_modules/@sentry/browser/esm/integrations/linkederrors.js
var linkederrors = __webpack_require__(97373);
// EXTERNAL MODULE: ../node_modules/@sentry/browser/esm/integrations/httpcontext.js
var httpcontext = __webpack_require__(21680);
// EXTERNAL MODULE: ../node_modules/@sentry/browser/esm/integrations/dedupe.js
var dedupe = __webpack_require__(12836);
;// CONCATENATED MODULE: ../node_modules/@sentry/browser/esm/integrations/index.js






//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ../node_modules/@sentry/core/esm/utils/prepareEvent.js
var prepareEvent = __webpack_require__(53010);
// EXTERNAL MODULE: ../node_modules/@sentry/utils/esm/normalize.js + 1 modules
var normalize = __webpack_require__(43527);
// EXTERNAL MODULE: ../node_modules/@sentry/utils/esm/node.js
var node = __webpack_require__(5728);
;// CONCATENATED MODULE: ../node_modules/@sentry/replay/esm/index.js
/* provided dependency */ var process = __webpack_require__(27061);



// exporting a separate copy of `WINDOW` rather than exporting the one from `@sentry/browser`
// prevents the browser package from being bundled in the CDN bundle, and avoids a
// circular dependency between the browser and replay packages should `@sentry/browser` import
// from `@sentry/replay` in the future
const esm_WINDOW = worldwide/* GLOBAL_OBJ */.n2 ;

const REPLAY_SESSION_KEY = 'sentryReplaySession';
const REPLAY_EVENT_NAME = 'replay_event';
const UNABLE_TO_SEND_REPLAY = 'Unable to send Replay';

// The idle limit for a session after which recording is paused.
const SESSION_IDLE_PAUSE_DURATION = 300000; // 5 minutes in ms

// The idle limit for a session after which the session expires.
const SESSION_IDLE_EXPIRE_DURATION = 900000; // 15 minutes in ms

// The maximum length of a session
const MAX_SESSION_LIFE = 3600000; // 60 minutes in ms

/** Default flush delays */
const DEFAULT_FLUSH_MIN_DELAY = 5000;
// XXX: Temp fix for our debounce logic where `maxWait` would never occur if it
// was the same as `wait`
const DEFAULT_FLUSH_MAX_DELAY = 5500;

/* How long to wait for error checkouts */
const BUFFER_CHECKOUT_TIME = 60000;

const RETRY_BASE_INTERVAL = 5000;
const RETRY_MAX_COUNT = 3;

/* The max (uncompressed) size in bytes of a network body. Any body larger than this will be truncated. */
const NETWORK_BODY_MAX_SIZE = 150000;

/* The max size of a single console arg that is captured. Any arg larger than this will be truncated. */
const CONSOLE_ARG_MAX_SIZE = 5000;

/* Min. time to wait before we consider something a slow click. */
const SLOW_CLICK_THRESHOLD = 3000;
/* For scroll actions after a click, we only look for a very short time period to detect programmatic scrolling. */
const SLOW_CLICK_SCROLL_TIMEOUT = 300;
/* Clicks in this time period are considered e.g. double/triple clicks. */
const MULTI_CLICK_TIMEOUT = 1000;

/** When encountering a total segment size exceeding this size, stop the replay (as we cannot properly ingest it). */
const REPLAY_MAX_EVENT_BUFFER_SIZE = 20000000; // ~20MB

var NodeType$1;
(function (NodeType) {
    NodeType[NodeType["Document"] = 0] = "Document";
    NodeType[NodeType["DocumentType"] = 1] = "DocumentType";
    NodeType[NodeType["Element"] = 2] = "Element";
    NodeType[NodeType["Text"] = 3] = "Text";
    NodeType[NodeType["CDATA"] = 4] = "CDATA";
    NodeType[NodeType["Comment"] = 5] = "Comment";
})(NodeType$1 || (NodeType$1 = {}));

function isElement(n) {
    return n.nodeType === n.ELEMENT_NODE;
}
function isShadowRoot(n) {
    const host = n === null || n === void 0 ? void 0 : n.host;
    return Boolean(host && host.shadowRoot && host.shadowRoot === n);
}
function isInputTypeMasked({ maskInputOptions, tagName, type, }) {
    if (tagName.toLowerCase() === 'option') {
        tagName = 'select';
    }
    const actualType = typeof type === 'string' ? type.toLowerCase() : undefined;
    return (maskInputOptions[tagName.toLowerCase()] ||
        (actualType && maskInputOptions[actualType]) ||
        actualType === 'password' ||
        (tagName === 'input' && !type && maskInputOptions['text']));
}
function hasInputMaskOptions({ tagName, type, maskInputOptions, maskInputSelector, }) {
    return (maskInputSelector || isInputTypeMasked({ maskInputOptions, tagName, type }));
}
function maskInputValue({ input, maskInputSelector, unmaskInputSelector, maskInputOptions, tagName, type, value, maskInputFn, }) {
    let text = value || '';
    if (unmaskInputSelector && input.matches(unmaskInputSelector)) {
        return text;
    }
    if (input.hasAttribute('data-rr-is-password')) {
        type = 'password';
    }
    if (isInputTypeMasked({ maskInputOptions, tagName, type }) ||
        (maskInputSelector && input.matches(maskInputSelector))) {
        if (maskInputFn) {
            text = maskInputFn(text);
        }
        else {
            text = '*'.repeat(text.length);
        }
    }
    return text;
}
const ORIGINAL_ATTRIBUTE_NAME = '__rrweb_original__';
function is2DCanvasBlank(canvas) {
    const ctx = canvas.getContext('2d');
    if (!ctx)
        return true;
    const chunkSize = 50;
    for (let x = 0; x < canvas.width; x += chunkSize) {
        for (let y = 0; y < canvas.height; y += chunkSize) {
            const getImageData = ctx.getImageData;
            const originalGetImageData = ORIGINAL_ATTRIBUTE_NAME in getImageData
                ? getImageData[ORIGINAL_ATTRIBUTE_NAME]
                : getImageData;
            const pixelBuffer = new Uint32Array(originalGetImageData.call(ctx, x, y, Math.min(chunkSize, canvas.width - x), Math.min(chunkSize, canvas.height - y)).data.buffer);
            if (pixelBuffer.some((pixel) => pixel !== 0))
                return false;
        }
    }
    return true;
}
function getInputType(element) {
    const type = element.type;
    return element.hasAttribute('data-rr-is-password')
        ? 'password'
        : type
            ? type.toLowerCase()
            : null;
}
function getInputValue(el, tagName, type) {
    typeof type === 'string' ? type.toLowerCase() : '';
    if (tagName === 'INPUT' && (type === 'radio' || type === 'checkbox')) {
        return el.getAttribute('value') || '';
    }
    return el.value;
}

let _id = 1;
const tagNameRegex = new RegExp('[^a-z0-9-_:]');
const IGNORED_NODE = -2;
function defaultMaskFn(str) {
    return str ? str.replace(/[\S]/g, '*') : '';
}
function genId() {
    return _id++;
}
function getValidTagName(element) {
    if (element instanceof HTMLFormElement) {
        return 'form';
    }
    const processedTagName = element.tagName.toLowerCase().trim();
    if (tagNameRegex.test(processedTagName)) {
        return 'div';
    }
    return processedTagName;
}
function getCssRulesString(s) {
    try {
        const rules = s.rules || s.cssRules;
        return rules ? Array.from(rules).map(getCssRuleString).join('') : null;
    }
    catch (error) {
        return null;
    }
}
function getCssRuleString(rule) {
    let cssStringified = rule.cssText;
    if (isCSSImportRule(rule)) {
        try {
            cssStringified = getCssRulesString(rule.styleSheet) || cssStringified;
        }
        catch (_a) {
        }
    }
    return validateStringifiedCssRule(cssStringified);
}
function validateStringifiedCssRule(cssStringified) {
    if (cssStringified.indexOf(':') > -1) {
        const regex = /(\[(?:[\w-]+)[^\\])(:(?:[\w-]+)\])/gm;
        return cssStringified.replace(regex, '$1\\$2');
    }
    return cssStringified;
}
function isCSSImportRule(rule) {
    return 'styleSheet' in rule;
}
function stringifyStyleSheet(sheet) {
    return sheet.cssRules
        ? Array.from(sheet.cssRules)
            .map((rule) => rule.cssText ? validateStringifiedCssRule(rule.cssText) : '')
            .join('')
        : '';
}
function extractOrigin(url) {
    let origin = '';
    if (url.indexOf('//') > -1) {
        origin = url.split('/').slice(0, 3).join('/');
    }
    else {
        origin = url.split('/')[0];
    }
    origin = origin.split('?')[0];
    return origin;
}
let canvasService;
let canvasCtx;
const URL_IN_CSS_REF = /url\((?:(')([^']*)'|(")(.*?)"|([^)]*))\)/gm;
const RELATIVE_PATH = /^(?!www\.|(?:http|ftp)s?:\/\/|[A-Za-z]:\\|\/\/|#).*/;
const DATA_URI = /^(data:)([^,]*),(.*)/i;
function absoluteToStylesheet(cssText, href) {
    return (cssText || '').replace(URL_IN_CSS_REF, (origin, quote1, path1, quote2, path2, path3) => {
        const filePath = path1 || path2 || path3;
        const maybeQuote = quote1 || quote2 || '';
        if (!filePath) {
            return origin;
        }
        if (!RELATIVE_PATH.test(filePath)) {
            return `url(${maybeQuote}${filePath}${maybeQuote})`;
        }
        if (DATA_URI.test(filePath)) {
            return `url(${maybeQuote}${filePath}${maybeQuote})`;
        }
        if (filePath[0] === '/') {
            return `url(${maybeQuote}${extractOrigin(href) + filePath}${maybeQuote})`;
        }
        const stack = href.split('/');
        const parts = filePath.split('/');
        stack.pop();
        for (const part of parts) {
            if (part === '.') {
                continue;
            }
            else if (part === '..') {
                stack.pop();
            }
            else {
                stack.push(part);
            }
        }
        return `url(${maybeQuote}${stack.join('/')}${maybeQuote})`;
    });
}
const SRCSET_NOT_SPACES = /^[^ \t\n\r\u000c]+/;
const SRCSET_COMMAS_OR_SPACES = /^[, \t\n\r\u000c]+/;
function getAbsoluteSrcsetString(doc, attributeValue) {
    if (attributeValue.trim() === '') {
        return attributeValue;
    }
    let pos = 0;
    function collectCharacters(regEx) {
        let chars;
        let match = regEx.exec(attributeValue.substring(pos));
        if (match) {
            chars = match[0];
            pos += chars.length;
            return chars;
        }
        return '';
    }
    let output = [];
    while (true) {
        collectCharacters(SRCSET_COMMAS_OR_SPACES);
        if (pos >= attributeValue.length) {
            break;
        }
        let url = collectCharacters(SRCSET_NOT_SPACES);
        if (url.slice(-1) === ',') {
            url = absoluteToDoc(doc, url.substring(0, url.length - 1));
            output.push(url);
        }
        else {
            let descriptorsStr = '';
            url = absoluteToDoc(doc, url);
            let inParens = false;
            while (true) {
                let c = attributeValue.charAt(pos);
                if (c === '') {
                    output.push((url + descriptorsStr).trim());
                    break;
                }
                else if (!inParens) {
                    if (c === ',') {
                        pos += 1;
                        output.push((url + descriptorsStr).trim());
                        break;
                    }
                    else if (c === '(') {
                        inParens = true;
                    }
                }
                else {
                    if (c === ')') {
                        inParens = false;
                    }
                }
                descriptorsStr += c;
                pos += 1;
            }
        }
    }
    return output.join(', ');
}
function absoluteToDoc(doc, attributeValue) {
    if (!attributeValue || attributeValue.trim() === '') {
        return attributeValue;
    }
    const a = doc.createElement('a');
    a.href = attributeValue;
    return a.href;
}
function isSVGElement(el) {
    return Boolean(el.tagName === 'svg' || el.ownerSVGElement);
}
function getHref() {
    const a = document.createElement('a');
    a.href = '';
    return a.href;
}
function transformAttribute(doc, element, _tagName, _name, value, maskAllText, unmaskTextSelector, maskTextFn) {
    if (!value) {
        return value;
    }
    const name = _name.toLowerCase();
    const tagName = _tagName.toLowerCase();
    if (name === 'src' || name === 'href') {
        return absoluteToDoc(doc, value);
    }
    else if (name === 'xlink:href' && value[0] !== '#') {
        return absoluteToDoc(doc, value);
    }
    else if (name === 'background' &&
        (tagName === 'table' || tagName === 'td' || tagName === 'th')) {
        return absoluteToDoc(doc, value);
    }
    else if (name === 'srcset') {
        return getAbsoluteSrcsetString(doc, value);
    }
    else if (name === 'style') {
        return absoluteToStylesheet(value, getHref());
    }
    else if (tagName === 'object' && name === 'data') {
        return absoluteToDoc(doc, value);
    }
    else if (maskAllText &&
        _shouldMaskAttribute(element, name, tagName, unmaskTextSelector)) {
        return maskTextFn ? maskTextFn(value) : defaultMaskFn(value);
    }
    return value;
}
function _shouldMaskAttribute(element, attribute, tagName, unmaskTextSelector) {
    if (unmaskTextSelector && element.matches(unmaskTextSelector)) {
        return false;
    }
    return (['placeholder', 'title', 'aria-label'].indexOf(attribute) > -1 ||
        (tagName === 'input' &&
            attribute === 'value' &&
            element.hasAttribute('type') &&
            ['submit', 'button'].indexOf(element.getAttribute('type').toLowerCase()) > -1));
}
function _isBlockedElement(element, blockClass, blockSelector, unblockSelector) {
    if (unblockSelector && element.matches(unblockSelector)) {
        return false;
    }
    if (typeof blockClass === 'string') {
        if (element.classList.contains(blockClass)) {
            return true;
        }
    }
    else {
        for (let eIndex = 0; eIndex < element.classList.length; eIndex++) {
            const className = element.classList[eIndex];
            if (blockClass.test(className)) {
                return true;
            }
        }
    }
    if (blockSelector) {
        return element.matches(blockSelector);
    }
    return false;
}
function needMaskingText(node, maskTextClass, maskTextSelector, unmaskTextSelector, maskAllText) {
    if (!node) {
        return false;
    }
    if (node.nodeType !== node.ELEMENT_NODE) {
        return needMaskingText(node.parentNode, maskTextClass, maskTextSelector, unmaskTextSelector, maskAllText);
    }
    if (unmaskTextSelector) {
        if (node.matches(unmaskTextSelector) ||
            node.closest(unmaskTextSelector)) {
            return false;
        }
    }
    if (maskAllText) {
        return true;
    }
    if (typeof maskTextClass === 'string') {
        if (node.classList.contains(maskTextClass)) {
            return true;
        }
    }
    else {
        for (let eIndex = 0; eIndex < node.classList.length; eIndex++) {
            const className = node.classList[eIndex];
            if (maskTextClass.test(className)) {
                return true;
            }
        }
    }
    if (maskTextSelector) {
        if (node.matches(maskTextSelector)) {
            return true;
        }
    }
    return needMaskingText(node.parentNode, maskTextClass, maskTextSelector, unmaskTextSelector, maskAllText);
}
function onceIframeLoaded(iframeEl, listener, iframeLoadTimeout) {
    const win = iframeEl.contentWindow;
    if (!win) {
        return;
    }
    let fired = false;
    let readyState;
    try {
        readyState = win.document.readyState;
    }
    catch (error) {
        return;
    }
    if (readyState !== 'complete') {
        const timer = setTimeout(() => {
            if (!fired) {
                listener();
                fired = true;
            }
        }, iframeLoadTimeout);
        iframeEl.addEventListener('load', () => {
            clearTimeout(timer);
            fired = true;
            listener();
        });
        return;
    }
    const blankUrl = 'about:blank';
    if (win.location.href !== blankUrl ||
        iframeEl.src === blankUrl ||
        iframeEl.src === '') {
        setTimeout(listener, 0);
        return;
    }
    iframeEl.addEventListener('load', listener);
}
function serializeNode(n, options) {
    var _a;
    const { doc, blockClass, blockSelector, unblockSelector, maskTextClass, maskTextSelector, unmaskTextSelector, inlineStylesheet, maskInputSelector, unmaskInputSelector, maskAllText, maskInputOptions = {}, maskTextFn, maskInputFn, dataURLOptions = {}, inlineImages, recordCanvas, keepIframeSrcFn, } = options;
    let rootId;
    if (doc.__sn) {
        const docId = doc.__sn.id;
        rootId = docId === 1 ? undefined : docId;
    }
    switch (n.nodeType) {
        case n.DOCUMENT_NODE:
            if (n.compatMode !== 'CSS1Compat') {
                return {
                    type: NodeType$1.Document,
                    childNodes: [],
                    compatMode: n.compatMode,
                    rootId,
                };
            }
            else {
                return {
                    type: NodeType$1.Document,
                    childNodes: [],
                    rootId,
                };
            }
        case n.DOCUMENT_TYPE_NODE:
            return {
                type: NodeType$1.DocumentType,
                name: n.name,
                publicId: n.publicId,
                systemId: n.systemId,
                rootId,
            };
        case n.ELEMENT_NODE:
            const needBlock = _isBlockedElement(n, blockClass, blockSelector, unblockSelector);
            const tagName = getValidTagName(n);
            let attributes = {};
            for (const { name, value } of Array.from(n.attributes)) {
                if (!skipAttribute(tagName, name)) {
                    attributes[name] = transformAttribute(doc, n, tagName, name, value, maskAllText, unmaskTextSelector, maskTextFn);
                }
            }
            if (tagName === 'link' && inlineStylesheet) {
                const stylesheet = Array.from(doc.styleSheets).find((s) => {
                    return s.href === n.href;
                });
                let cssText = null;
                if (stylesheet) {
                    cssText = getCssRulesString(stylesheet);
                }
                if (cssText) {
                    delete attributes.rel;
                    delete attributes.href;
                    attributes._cssText = absoluteToStylesheet(cssText, stylesheet.href);
                }
            }
            if (tagName === 'style' &&
                n.sheet &&
                !(n.innerText ||
                    n.textContent ||
                    '').trim().length) {
                const cssText = getCssRulesString(n.sheet);
                if (cssText) {
                    attributes._cssText = absoluteToStylesheet(cssText, getHref());
                }
            }
            if (tagName === 'input' ||
                tagName === 'textarea' ||
                tagName === 'select' ||
                tagName === 'option') {
                const el = n;
                const type = getInputType(el);
                const value = getInputValue(el, tagName.toUpperCase(), type);
                const checked = n.checked;
                if (type !== 'submit' &&
                    type !== 'button' &&
                    value) {
                    attributes.value = maskInputValue({
                        input: el,
                        type,
                        tagName,
                        value,
                        maskInputSelector,
                        unmaskInputSelector,
                        maskInputOptions,
                        maskInputFn,
                    });
                }
                if (checked) {
                    attributes.checked = checked;
                }
            }
            if (tagName === 'option') {
                if (n.selected && !maskInputOptions['select']) {
                    attributes.selected = true;
                }
                else {
                    delete attributes.selected;
                }
            }
            if (tagName === 'canvas' && recordCanvas) {
                if (n.__context === '2d') {
                    if (!is2DCanvasBlank(n)) {
                        attributes.rr_dataURL = n.toDataURL(dataURLOptions.type, dataURLOptions.quality);
                    }
                }
                else if (!('__context' in n)) {
                    const canvasDataURL = n.toDataURL(dataURLOptions.type, dataURLOptions.quality);
                    const blankCanvas = document.createElement('canvas');
                    blankCanvas.width = n.width;
                    blankCanvas.height = n.height;
                    const blankCanvasDataURL = blankCanvas.toDataURL(dataURLOptions.type, dataURLOptions.quality);
                    if (canvasDataURL !== blankCanvasDataURL) {
                        attributes.rr_dataURL = canvasDataURL;
                    }
                }
            }
            if (tagName === 'img' && inlineImages) {
                if (!canvasService) {
                    canvasService = doc.createElement('canvas');
                    canvasCtx = canvasService.getContext('2d');
                }
                const image = n;
                const oldValue = image.crossOrigin;
                image.crossOrigin = 'anonymous';
                const recordInlineImage = () => {
                    try {
                        canvasService.width = image.naturalWidth;
                        canvasService.height = image.naturalHeight;
                        canvasCtx.drawImage(image, 0, 0);
                        attributes.rr_dataURL = canvasService.toDataURL(dataURLOptions.type, dataURLOptions.quality);
                    }
                    catch (err) {
                        console.warn(`Cannot inline img src=${image.currentSrc}! Error: ${err}`);
                    }
                    oldValue
                        ? (attributes.crossOrigin = oldValue)
                        : delete attributes.crossOrigin;
                };
                if (image.complete && image.naturalWidth !== 0)
                    recordInlineImage();
                else
                    image.onload = recordInlineImage;
            }
            if (tagName === 'audio' || tagName === 'video') {
                attributes.rr_mediaState = n.paused
                    ? 'paused'
                    : 'played';
                attributes.rr_mediaCurrentTime = n.currentTime;
            }
            if (n.scrollLeft) {
                attributes.rr_scrollLeft = n.scrollLeft;
            }
            if (n.scrollTop) {
                attributes.rr_scrollTop = n.scrollTop;
            }
            if (needBlock) {
                const { width, height } = n.getBoundingClientRect();
                attributes = {
                    class: attributes.class,
                    rr_width: `${width}px`,
                    rr_height: `${height}px`,
                };
            }
            if (tagName === 'iframe' && !keepIframeSrcFn(attributes.src)) {
                if (!n.contentDocument) {
                    attributes.rr_src = attributes.src;
                }
                delete attributes.src;
            }
            return {
                type: NodeType$1.Element,
                tagName,
                attributes,
                childNodes: [],
                isSVG: isSVGElement(n) || undefined,
                needBlock,
                rootId,
            };
        case n.TEXT_NODE:
            const parentTagName = n.parentNode && n.parentNode.tagName;
            let textContent = n.textContent;
            const isStyle = parentTagName === 'STYLE' ? true : undefined;
            const isScript = parentTagName === 'SCRIPT' ? true : undefined;
            if (isStyle && textContent) {
                try {
                    if (n.nextSibling || n.previousSibling) {
                    }
                    else if ((_a = n.parentNode.sheet) === null || _a === void 0 ? void 0 : _a.cssRules) {
                        textContent = stringifyStyleSheet(n.parentNode.sheet);
                    }
                }
                catch (err) {
                    console.warn(`Cannot get CSS styles from text's parentNode. Error: ${err}`, n);
                }
                textContent = absoluteToStylesheet(textContent, getHref());
            }
            if (isScript) {
                textContent = 'SCRIPT_PLACEHOLDER';
            }
            if (parentTagName === 'TEXTAREA' && textContent) {
                textContent = '';
            }
            else if (parentTagName === 'OPTION' && textContent) {
                const option = n.parentNode;
                textContent = maskInputValue({
                    input: option,
                    type: null,
                    tagName: parentTagName,
                    value: textContent,
                    maskInputSelector,
                    unmaskInputSelector,
                    maskInputOptions,
                    maskInputFn,
                });
            }
            else if (!isStyle &&
                !isScript &&
                needMaskingText(n, maskTextClass, maskTextSelector, unmaskTextSelector, maskAllText) &&
                textContent) {
                textContent = maskTextFn
                    ? maskTextFn(textContent)
                    : defaultMaskFn(textContent);
            }
            return {
                type: NodeType$1.Text,
                textContent: textContent || '',
                isStyle,
                rootId,
            };
        case n.CDATA_SECTION_NODE:
            return {
                type: NodeType$1.CDATA,
                textContent: '',
                rootId,
            };
        case n.COMMENT_NODE:
            return {
                type: NodeType$1.Comment,
                textContent: n.textContent || '',
                rootId,
            };
        default:
            return false;
    }
}
function lowerIfExists(maybeAttr) {
    if (maybeAttr === undefined || maybeAttr === null) {
        return '';
    }
    else {
        return maybeAttr.toLowerCase();
    }
}
function slimDOMExcluded(sn, slimDOMOptions) {
    if (slimDOMOptions.comment && sn.type === NodeType$1.Comment) {
        return true;
    }
    else if (sn.type === NodeType$1.Element) {
        if (slimDOMOptions.script &&
            (sn.tagName === 'script' ||
                (sn.tagName === 'link' &&
                    (sn.attributes.rel === 'preload' ||
                        sn.attributes.rel === 'modulepreload') &&
                    sn.attributes.as === 'script') ||
                (sn.tagName === 'link' &&
                    sn.attributes.rel === 'prefetch' &&
                    typeof sn.attributes.href === 'string' &&
                    sn.attributes.href.endsWith('.js')))) {
            return true;
        }
        else if (slimDOMOptions.headFavicon &&
            ((sn.tagName === 'link' && sn.attributes.rel === 'shortcut icon') ||
                (sn.tagName === 'meta' &&
                    (lowerIfExists(sn.attributes.name).match(/^msapplication-tile(image|color)$/) ||
                        lowerIfExists(sn.attributes.name) === 'application-name' ||
                        lowerIfExists(sn.attributes.rel) === 'icon' ||
                        lowerIfExists(sn.attributes.rel) === 'apple-touch-icon' ||
                        lowerIfExists(sn.attributes.rel) === 'shortcut icon')))) {
            return true;
        }
        else if (sn.tagName === 'meta') {
            if (slimDOMOptions.headMetaDescKeywords &&
                lowerIfExists(sn.attributes.name).match(/^description|keywords$/)) {
                return true;
            }
            else if (slimDOMOptions.headMetaSocial &&
                (lowerIfExists(sn.attributes.property).match(/^(og|twitter|fb):/) ||
                    lowerIfExists(sn.attributes.name).match(/^(og|twitter):/) ||
                    lowerIfExists(sn.attributes.name) === 'pinterest')) {
                return true;
            }
            else if (slimDOMOptions.headMetaRobots &&
                (lowerIfExists(sn.attributes.name) === 'robots' ||
                    lowerIfExists(sn.attributes.name) === 'googlebot' ||
                    lowerIfExists(sn.attributes.name) === 'bingbot')) {
                return true;
            }
            else if (slimDOMOptions.headMetaHttpEquiv &&
                sn.attributes['http-equiv'] !== undefined) {
                return true;
            }
            else if (slimDOMOptions.headMetaAuthorship &&
                (lowerIfExists(sn.attributes.name) === 'author' ||
                    lowerIfExists(sn.attributes.name) === 'generator' ||
                    lowerIfExists(sn.attributes.name) === 'framework' ||
                    lowerIfExists(sn.attributes.name) === 'publisher' ||
                    lowerIfExists(sn.attributes.name) === 'progid' ||
                    lowerIfExists(sn.attributes.property).match(/^article:/) ||
                    lowerIfExists(sn.attributes.property).match(/^product:/))) {
                return true;
            }
            else if (slimDOMOptions.headMetaVerification &&
                (lowerIfExists(sn.attributes.name) === 'google-site-verification' ||
                    lowerIfExists(sn.attributes.name) === 'yandex-verification' ||
                    lowerIfExists(sn.attributes.name) === 'csrf-token' ||
                    lowerIfExists(sn.attributes.name) === 'p:domain_verify' ||
                    lowerIfExists(sn.attributes.name) === 'verify-v1' ||
                    lowerIfExists(sn.attributes.name) === 'verification' ||
                    lowerIfExists(sn.attributes.name) === 'shopify-checkout-api-token')) {
                return true;
            }
        }
    }
    return false;
}
function serializeNodeWithId(n, options) {
    const { doc, map, blockClass, blockSelector, unblockSelector, maskTextClass, maskTextSelector, unmaskTextSelector, skipChild = false, inlineStylesheet = true, maskInputSelector, unmaskInputSelector, maskAllText, maskInputOptions = {}, maskTextFn, maskInputFn, slimDOMOptions, dataURLOptions = {}, inlineImages = false, recordCanvas = false, onSerialize, onIframeLoad, iframeLoadTimeout = 5000, keepIframeSrcFn = () => false, } = options;
    let { preserveWhiteSpace = true } = options;
    const _serializedNode = serializeNode(n, {
        doc,
        blockClass,
        blockSelector,
        unblockSelector,
        maskTextClass,
        maskTextSelector,
        unmaskTextSelector,
        inlineStylesheet,
        maskInputSelector,
        unmaskInputSelector,
        maskAllText,
        maskInputOptions,
        maskTextFn,
        maskInputFn,
        dataURLOptions,
        inlineImages,
        recordCanvas,
        keepIframeSrcFn,
    });
    if (!_serializedNode) {
        console.warn(n, 'not serialized');
        return null;
    }
    let id;
    if ('__sn' in n) {
        id = n.__sn.id;
    }
    else if (slimDOMExcluded(_serializedNode, slimDOMOptions) ||
        (!preserveWhiteSpace &&
            _serializedNode.type === NodeType$1.Text &&
            !_serializedNode.isStyle &&
            !_serializedNode.textContent.replace(/^\s+|\s+$/gm, '').length)) {
        id = IGNORED_NODE;
    }
    else {
        id = genId();
    }
    const serializedNode = Object.assign(_serializedNode, { id });
    n.__sn = serializedNode;
    if (id === IGNORED_NODE) {
        return null;
    }
    map[id] = n;
    if (onSerialize) {
        onSerialize(n);
    }
    let recordChild = !skipChild;
    if (serializedNode.type === NodeType$1.Element) {
        recordChild = recordChild && !serializedNode.needBlock;
        delete serializedNode.needBlock;
        if (n.shadowRoot)
            serializedNode.isShadowHost = true;
    }
    if ((serializedNode.type === NodeType$1.Document ||
        serializedNode.type === NodeType$1.Element) &&
        recordChild) {
        if (slimDOMOptions.headWhitespace &&
            _serializedNode.type === NodeType$1.Element &&
            _serializedNode.tagName === 'head') {
            preserveWhiteSpace = false;
        }
        const bypassOptions = {
            doc,
            map,
            blockClass,
            blockSelector,
            unblockSelector,
            maskTextClass,
            maskTextSelector,
            unmaskTextSelector,
            skipChild,
            inlineStylesheet,
            maskInputSelector,
            unmaskInputSelector,
            maskAllText,
            maskInputOptions,
            maskTextFn,
            maskInputFn,
            slimDOMOptions,
            dataURLOptions,
            inlineImages,
            recordCanvas,
            preserveWhiteSpace,
            onSerialize,
            onIframeLoad,
            iframeLoadTimeout,
            keepIframeSrcFn,
        };
        for (const childN of Array.from(n.childNodes)) {
            const serializedChildNode = serializeNodeWithId(childN, bypassOptions);
            if (serializedChildNode) {
                serializedNode.childNodes.push(serializedChildNode);
            }
        }
        if (isElement(n) && n.shadowRoot) {
            for (const childN of Array.from(n.shadowRoot.childNodes)) {
                const serializedChildNode = serializeNodeWithId(childN, bypassOptions);
                if (serializedChildNode) {
                    serializedChildNode.isShadow = true;
                    serializedNode.childNodes.push(serializedChildNode);
                }
            }
        }
    }
    if (n.parentNode && isShadowRoot(n.parentNode)) {
        serializedNode.isShadow = true;
    }
    if (serializedNode.type === NodeType$1.Element &&
        serializedNode.tagName === 'iframe') {
        onceIframeLoaded(n, () => {
            const iframeDoc = n.contentDocument;
            if (iframeDoc && onIframeLoad) {
                const serializedIframeNode = serializeNodeWithId(iframeDoc, {
                    doc: iframeDoc,
                    map,
                    blockClass,
                    blockSelector,
                    unblockSelector,
                    maskTextClass,
                    maskTextSelector,
                    unmaskTextSelector,
                    skipChild: false,
                    inlineStylesheet,
                    maskInputSelector,
                    unmaskInputSelector,
                    maskAllText,
                    maskInputOptions,
                    maskTextFn,
                    maskInputFn,
                    slimDOMOptions,
                    dataURLOptions,
                    inlineImages,
                    recordCanvas,
                    preserveWhiteSpace,
                    onSerialize,
                    onIframeLoad,
                    iframeLoadTimeout,
                    keepIframeSrcFn,
                });
                if (serializedIframeNode) {
                    onIframeLoad(n, serializedIframeNode);
                }
            }
        }, iframeLoadTimeout);
    }
    return serializedNode;
}
function snapshot(n, options) {
    const { blockClass = 'rr-block', blockSelector = null, unblockSelector = null, maskTextClass = 'rr-mask', maskTextSelector = null, unmaskTextSelector = null, inlineStylesheet = true, inlineImages = false, recordCanvas = false, maskInputSelector = null, unmaskInputSelector = null, maskAllText = false, maskAllInputs = false, maskTextFn, maskInputFn, slimDOM = false, dataURLOptions, preserveWhiteSpace, onSerialize, onIframeLoad, iframeLoadTimeout, keepIframeSrcFn = () => false, } = options || {};
    const idNodeMap = {};
    const maskInputOptions = maskAllInputs === true
        ? {
            color: true,
            date: true,
            'datetime-local': true,
            email: true,
            month: true,
            number: true,
            range: true,
            search: true,
            tel: true,
            text: true,
            time: true,
            url: true,
            week: true,
            textarea: true,
            select: true,
        }
        : maskAllInputs === false
            ? {}
            : maskAllInputs;
    const slimDOMOptions = slimDOM === true || slimDOM === 'all'
        ?
            {
                script: true,
                comment: true,
                headFavicon: true,
                headWhitespace: true,
                headMetaDescKeywords: slimDOM === 'all',
                headMetaSocial: true,
                headMetaRobots: true,
                headMetaHttpEquiv: true,
                headMetaAuthorship: true,
                headMetaVerification: true,
            }
        : slimDOM === false
            ? {}
            : slimDOM;
    return [
        serializeNodeWithId(n, {
            doc: n,
            map: idNodeMap,
            blockClass,
            blockSelector,
            unblockSelector,
            maskTextClass,
            maskTextSelector,
            unmaskTextSelector,
            skipChild: false,
            inlineStylesheet,
            maskInputSelector,
            unmaskInputSelector,
            maskAllText,
            maskInputOptions,
            maskTextFn,
            maskInputFn,
            slimDOMOptions,
            dataURLOptions,
            inlineImages,
            recordCanvas,
            preserveWhiteSpace,
            onSerialize,
            onIframeLoad,
            iframeLoadTimeout,
            keepIframeSrcFn,
        }),
        idNodeMap,
    ];
}
function skipAttribute(tagName, attributeName, value) {
    return ((tagName === 'video' || tagName === 'audio') && attributeName === 'autoplay');
}

var EventType;
(function (EventType) {
    EventType[EventType["DomContentLoaded"] = 0] = "DomContentLoaded";
    EventType[EventType["Load"] = 1] = "Load";
    EventType[EventType["FullSnapshot"] = 2] = "FullSnapshot";
    EventType[EventType["IncrementalSnapshot"] = 3] = "IncrementalSnapshot";
    EventType[EventType["Meta"] = 4] = "Meta";
    EventType[EventType["Custom"] = 5] = "Custom";
    EventType[EventType["Plugin"] = 6] = "Plugin";
})(EventType || (EventType = {}));
var IncrementalSource;
(function (IncrementalSource) {
    IncrementalSource[IncrementalSource["Mutation"] = 0] = "Mutation";
    IncrementalSource[IncrementalSource["MouseMove"] = 1] = "MouseMove";
    IncrementalSource[IncrementalSource["MouseInteraction"] = 2] = "MouseInteraction";
    IncrementalSource[IncrementalSource["Scroll"] = 3] = "Scroll";
    IncrementalSource[IncrementalSource["ViewportResize"] = 4] = "ViewportResize";
    IncrementalSource[IncrementalSource["Input"] = 5] = "Input";
    IncrementalSource[IncrementalSource["TouchMove"] = 6] = "TouchMove";
    IncrementalSource[IncrementalSource["MediaInteraction"] = 7] = "MediaInteraction";
    IncrementalSource[IncrementalSource["StyleSheetRule"] = 8] = "StyleSheetRule";
    IncrementalSource[IncrementalSource["CanvasMutation"] = 9] = "CanvasMutation";
    IncrementalSource[IncrementalSource["Font"] = 10] = "Font";
    IncrementalSource[IncrementalSource["Log"] = 11] = "Log";
    IncrementalSource[IncrementalSource["Drag"] = 12] = "Drag";
    IncrementalSource[IncrementalSource["StyleDeclaration"] = 13] = "StyleDeclaration";
})(IncrementalSource || (IncrementalSource = {}));
var MouseInteractions;
(function (MouseInteractions) {
    MouseInteractions[MouseInteractions["MouseUp"] = 0] = "MouseUp";
    MouseInteractions[MouseInteractions["MouseDown"] = 1] = "MouseDown";
    MouseInteractions[MouseInteractions["Click"] = 2] = "Click";
    MouseInteractions[MouseInteractions["ContextMenu"] = 3] = "ContextMenu";
    MouseInteractions[MouseInteractions["DblClick"] = 4] = "DblClick";
    MouseInteractions[MouseInteractions["Focus"] = 5] = "Focus";
    MouseInteractions[MouseInteractions["Blur"] = 6] = "Blur";
    MouseInteractions[MouseInteractions["TouchStart"] = 7] = "TouchStart";
    MouseInteractions[MouseInteractions["TouchMove_Departed"] = 8] = "TouchMove_Departed";
    MouseInteractions[MouseInteractions["TouchEnd"] = 9] = "TouchEnd";
    MouseInteractions[MouseInteractions["TouchCancel"] = 10] = "TouchCancel";
})(MouseInteractions || (MouseInteractions = {}));
var CanvasContext;
(function (CanvasContext) {
    CanvasContext[CanvasContext["2D"] = 0] = "2D";
    CanvasContext[CanvasContext["WebGL"] = 1] = "WebGL";
    CanvasContext[CanvasContext["WebGL2"] = 2] = "WebGL2";
})(CanvasContext || (CanvasContext = {}));
var MediaInteractions;
(function (MediaInteractions) {
    MediaInteractions[MediaInteractions["Play"] = 0] = "Play";
    MediaInteractions[MediaInteractions["Pause"] = 1] = "Pause";
    MediaInteractions[MediaInteractions["Seeked"] = 2] = "Seeked";
    MediaInteractions[MediaInteractions["VolumeChange"] = 3] = "VolumeChange";
})(MediaInteractions || (MediaInteractions = {}));
var ReplayerEvents;
(function (ReplayerEvents) {
    ReplayerEvents["Start"] = "start";
    ReplayerEvents["Pause"] = "pause";
    ReplayerEvents["Resume"] = "resume";
    ReplayerEvents["Resize"] = "resize";
    ReplayerEvents["Finish"] = "finish";
    ReplayerEvents["FullsnapshotRebuilded"] = "fullsnapshot-rebuilded";
    ReplayerEvents["LoadStylesheetStart"] = "load-stylesheet-start";
    ReplayerEvents["LoadStylesheetEnd"] = "load-stylesheet-end";
    ReplayerEvents["SkipStart"] = "skip-start";
    ReplayerEvents["SkipEnd"] = "skip-end";
    ReplayerEvents["MouseInteraction"] = "mouse-interaction";
    ReplayerEvents["EventCast"] = "event-cast";
    ReplayerEvents["CustomEvent"] = "custom-event";
    ReplayerEvents["Flush"] = "flush";
    ReplayerEvents["StateChange"] = "state-change";
    ReplayerEvents["PlayBack"] = "play-back";
})(ReplayerEvents || (ReplayerEvents = {}));

function on(type, fn, target = document) {
    const options = { capture: true, passive: true };
    target.addEventListener(type, fn, options);
    return () => target.removeEventListener(type, fn, options);
}
function createMirror() {
    return {
        map: {},
        getId(n) {
            if (!n || !n.__sn) {
                return -1;
            }
            return n.__sn.id;
        },
        getNode(id) {
            return this.map[id] || null;
        },
        removeNodeFromMap(n) {
            const id = n.__sn && n.__sn.id;
            delete this.map[id];
            if (n.childNodes) {
                n.childNodes.forEach((child) => this.removeNodeFromMap(child));
            }
        },
        has(id) {
            return this.map.hasOwnProperty(id);
        },
        reset() {
            this.map = {};
        },
    };
}
const DEPARTED_MIRROR_ACCESS_WARNING = 'Please stop import mirror directly. Instead of that,' +
    '\r\n' +
    'now you can use replayer.getMirror() to access the mirror instance of a replayer,' +
    '\r\n' +
    'or you can use record.mirror to access the mirror instance during recording.';
let _mirror = {
    map: {},
    getId() {
        console.error(DEPARTED_MIRROR_ACCESS_WARNING);
        return -1;
    },
    getNode() {
        console.error(DEPARTED_MIRROR_ACCESS_WARNING);
        return null;
    },
    removeNodeFromMap() {
        console.error(DEPARTED_MIRROR_ACCESS_WARNING);
    },
    has() {
        console.error(DEPARTED_MIRROR_ACCESS_WARNING);
        return false;
    },
    reset() {
        console.error(DEPARTED_MIRROR_ACCESS_WARNING);
    },
};
if (typeof window !== 'undefined' && window.Proxy && window.Reflect) {
    _mirror = new Proxy(_mirror, {
        get(target, prop, receiver) {
            if (prop === 'map') {
                console.error(DEPARTED_MIRROR_ACCESS_WARNING);
            }
            return Reflect.get(target, prop, receiver);
        },
    });
}
function throttle$1(func, wait, options = {}) {
    let timeout = null;
    let previous = 0;
    return function (arg) {
        let now = Date.now();
        if (!previous && options.leading === false) {
            previous = now;
        }
        let remaining = wait - (now - previous);
        let context = this;
        let args = arguments;
        if (remaining <= 0 || remaining > wait) {
            if (timeout) {
                clearTimeout(timeout);
                timeout = null;
            }
            previous = now;
            func.apply(context, args);
        }
        else if (!timeout && options.trailing !== false) {
            timeout = setTimeout(() => {
                previous = options.leading === false ? 0 : Date.now();
                timeout = null;
                func.apply(context, args);
            }, remaining);
        }
    };
}
function hookSetter(target, key, d, isRevoked, win = window) {
    const original = win.Object.getOwnPropertyDescriptor(target, key);
    win.Object.defineProperty(target, key, isRevoked
        ? d
        : {
            set(value) {
                setTimeout(() => {
                    d.set.call(this, value);
                }, 0);
                if (original && original.set) {
                    original.set.call(this, value);
                }
            },
        });
    return () => hookSetter(target, key, original || {}, true);
}
function patch(source, name, replacement) {
    try {
        if (!(name in source)) {
            return () => { };
        }
        const original = source[name];
        const wrapped = replacement(original);
        if (typeof wrapped === 'function') {
            wrapped.prototype = wrapped.prototype || {};
            Object.defineProperties(wrapped, {
                __rrweb_original__: {
                    enumerable: false,
                    value: original,
                },
            });
        }
        source[name] = wrapped;
        return () => {
            source[name] = original;
        };
    }
    catch (_a) {
        return () => { };
    }
}
function getWindowHeight() {
    return (window.innerHeight ||
        (document.documentElement && document.documentElement.clientHeight) ||
        (document.body && document.body.clientHeight));
}
function getWindowWidth() {
    return (window.innerWidth ||
        (document.documentElement && document.documentElement.clientWidth) ||
        (document.body && document.body.clientWidth));
}
function isBlocked(node, blockClass, blockSelector, unblockSelector) {
    if (!node) {
        return false;
    }
    if (node.nodeType === node.ELEMENT_NODE) {
        let needBlock = false;
        const needUnblock = unblockSelector && node.matches(unblockSelector);
        if (typeof blockClass === 'string') {
            if (node.closest !== undefined) {
                needBlock =
                    !needUnblock &&
                        node.closest('.' + blockClass) !== null;
            }
            else {
                needBlock =
                    !needUnblock && node.classList.contains(blockClass);
            }
        }
        else {
            !needUnblock &&
                node.classList.forEach((className) => {
                    if (blockClass.test(className)) {
                        needBlock = true;
                    }
                });
        }
        if (!needBlock && blockSelector) {
            needBlock = node.matches(blockSelector);
        }
        return ((!needUnblock && needBlock) ||
            isBlocked(node.parentNode, blockClass, blockSelector, unblockSelector));
    }
    if (node.nodeType === node.TEXT_NODE) {
        return isBlocked(node.parentNode, blockClass, blockSelector, unblockSelector);
    }
    return isBlocked(node.parentNode, blockClass, blockSelector, unblockSelector);
}
function isIgnored(n) {
    if ('__sn' in n) {
        return n.__sn.id === IGNORED_NODE;
    }
    return false;
}
function isAncestorRemoved(target, mirror) {
    if (isShadowRoot(target)) {
        return false;
    }
    const id = mirror.getId(target);
    if (!mirror.has(id)) {
        return true;
    }
    if (target.parentNode &&
        target.parentNode.nodeType === target.DOCUMENT_NODE) {
        return false;
    }
    if (!target.parentNode) {
        return true;
    }
    return isAncestorRemoved(target.parentNode, mirror);
}
function isTouchEvent(event) {
    return Boolean(event.changedTouches);
}
function polyfill(win = window) {
    if ('NodeList' in win && !win.NodeList.prototype.forEach) {
        win.NodeList.prototype.forEach = Array.prototype
            .forEach;
    }
    if ('DOMTokenList' in win && !win.DOMTokenList.prototype.forEach) {
        win.DOMTokenList.prototype.forEach = Array.prototype
            .forEach;
    }
    if (!Node.prototype.contains) {
        Node.prototype.contains = function contains(node) {
            if (!(0 in arguments)) {
                throw new TypeError('1 argument is required');
            }
            do {
                if (this === node) {
                    return true;
                }
            } while ((node = node && node.parentNode));
            return false;
        };
    }
}
function isIframeINode(node) {
    if ('__sn' in node) {
        return (node.__sn.type === NodeType$1.Element && node.__sn.tagName === 'iframe');
    }
    return false;
}
function hasShadowRoot(n) {
    return Boolean(n === null || n === void 0 ? void 0 : n.shadowRoot);
}

function isNodeInLinkedList(n) {
    return '__ln' in n;
}
class DoubleLinkedList {
    constructor() {
        this.length = 0;
        this.head = null;
    }
    get(position) {
        if (position >= this.length) {
            throw new Error('Position outside of list range');
        }
        let current = this.head;
        for (let index = 0; index < position; index++) {
            current = (current === null || current === void 0 ? void 0 : current.next) || null;
        }
        return current;
    }
    addNode(n) {
        const node = {
            value: n,
            previous: null,
            next: null,
        };
        n.__ln = node;
        if (n.previousSibling && isNodeInLinkedList(n.previousSibling)) {
            const current = n.previousSibling.__ln.next;
            node.next = current;
            node.previous = n.previousSibling.__ln;
            n.previousSibling.__ln.next = node;
            if (current) {
                current.previous = node;
            }
        }
        else if (n.nextSibling &&
            isNodeInLinkedList(n.nextSibling) &&
            n.nextSibling.__ln.previous) {
            const current = n.nextSibling.__ln.previous;
            node.previous = current;
            node.next = n.nextSibling.__ln;
            n.nextSibling.__ln.previous = node;
            if (current) {
                current.next = node;
            }
        }
        else {
            if (this.head) {
                this.head.previous = node;
            }
            node.next = this.head;
            this.head = node;
        }
        this.length++;
    }
    removeNode(n) {
        const current = n.__ln;
        if (!this.head) {
            return;
        }
        if (!current.previous) {
            this.head = current.next;
            if (this.head) {
                this.head.previous = null;
            }
        }
        else {
            current.previous.next = current.next;
            if (current.next) {
                current.next.previous = current.previous;
            }
        }
        if (n.__ln) {
            delete n.__ln;
        }
        this.length--;
    }
}
const moveKey = (id, parentId) => `${id}@${parentId}`;
function isINode(n) {
    return '__sn' in n;
}
class MutationBuffer {
    constructor() {
        this.frozen = false;
        this.locked = false;
        this.texts = [];
        this.attributes = [];
        this.removes = [];
        this.mapRemoves = [];
        this.movedMap = {};
        this.addedSet = new Set();
        this.movedSet = new Set();
        this.droppedSet = new Set();
        this.processMutations = (mutations) => {
            mutations.forEach(this.processMutation);
            this.emit();
        };
        this.emit = () => {
            if (this.frozen || this.locked) {
                return;
            }
            const adds = [];
            const addList = new DoubleLinkedList();
            const getNextId = (n) => {
                let ns = n;
                let nextId = IGNORED_NODE;
                while (nextId === IGNORED_NODE) {
                    ns = ns && ns.nextSibling;
                    nextId = ns && this.mirror.getId(ns);
                }
                return nextId;
            };
            const pushAdd = (n) => {
                var _a, _b, _c, _d, _e;
                const shadowHost = n.getRootNode
                    ? (_a = n.getRootNode()) === null || _a === void 0 ? void 0 : _a.host
                    : null;
                let rootShadowHost = shadowHost;
                while ((_c = (_b = rootShadowHost === null || rootShadowHost === void 0 ? void 0 : rootShadowHost.getRootNode) === null || _b === void 0 ? void 0 : _b.call(rootShadowHost)) === null || _c === void 0 ? void 0 : _c.host)
                    rootShadowHost =
                        ((_e = (_d = rootShadowHost === null || rootShadowHost === void 0 ? void 0 : rootShadowHost.getRootNode) === null || _d === void 0 ? void 0 : _d.call(rootShadowHost)) === null || _e === void 0 ? void 0 : _e.host) ||
                            null;
                const notInDoc = !this.doc.contains(n) &&
                    (!rootShadowHost || !this.doc.contains(rootShadowHost));
                if (!n.parentNode || notInDoc) {
                    return;
                }
                const parentId = isShadowRoot(n.parentNode)
                    ? this.mirror.getId(shadowHost)
                    : this.mirror.getId(n.parentNode);
                const nextId = getNextId(n);
                if (parentId === -1 || nextId === -1) {
                    return addList.addNode(n);
                }
                let sn = serializeNodeWithId(n, {
                    doc: this.doc,
                    map: this.mirror.map,
                    blockClass: this.blockClass,
                    blockSelector: this.blockSelector,
                    unblockSelector: this.unblockSelector,
                    maskTextClass: this.maskTextClass,
                    maskTextSelector: this.maskTextSelector,
                    unmaskTextSelector: this.unmaskTextSelector,
                    maskInputSelector: this.maskInputSelector,
                    unmaskInputSelector: this.unmaskInputSelector,
                    skipChild: true,
                    inlineStylesheet: this.inlineStylesheet,
                    maskAllText: this.maskAllText,
                    maskInputOptions: this.maskInputOptions,
                    maskTextFn: this.maskTextFn,
                    maskInputFn: this.maskInputFn,
                    slimDOMOptions: this.slimDOMOptions,
                    recordCanvas: this.recordCanvas,
                    inlineImages: this.inlineImages,
                    onSerialize: (currentN) => {
                        if (isIframeINode(currentN)) {
                            this.iframeManager.addIframe(currentN);
                        }
                        if (hasShadowRoot(n)) {
                            this.shadowDomManager.addShadowRoot(n.shadowRoot, document);
                        }
                    },
                    onIframeLoad: (iframe, childSn) => {
                        this.iframeManager.attachIframe(iframe, childSn);
                        this.shadowDomManager.observeAttachShadow(iframe);
                    },
                });
                if (sn) {
                    adds.push({
                        parentId,
                        nextId,
                        node: sn,
                    });
                }
            };
            while (this.mapRemoves.length) {
                this.mirror.removeNodeFromMap(this.mapRemoves.shift());
            }
            for (const n of this.movedSet) {
                if (isParentRemoved(this.removes, n, this.mirror) &&
                    !this.movedSet.has(n.parentNode)) {
                    continue;
                }
                pushAdd(n);
            }
            for (const n of this.addedSet) {
                if (!isAncestorInSet(this.droppedSet, n) &&
                    !isParentRemoved(this.removes, n, this.mirror)) {
                    pushAdd(n);
                }
                else if (isAncestorInSet(this.movedSet, n)) {
                    pushAdd(n);
                }
                else {
                    this.droppedSet.add(n);
                }
            }
            let candidate = null;
            while (addList.length) {
                let node = null;
                if (candidate) {
                    const parentId = this.mirror.getId(candidate.value.parentNode);
                    const nextId = getNextId(candidate.value);
                    if (parentId !== -1 && nextId !== -1) {
                        node = candidate;
                    }
                }
                if (!node) {
                    for (let index = addList.length - 1; index >= 0; index--) {
                        const _node = addList.get(index);
                        if (_node) {
                            const parentId = this.mirror.getId(_node.value.parentNode);
                            const nextId = getNextId(_node.value);
                            if (parentId !== -1 && nextId !== -1) {
                                node = _node;
                                break;
                            }
                        }
                    }
                }
                if (!node) {
                    while (addList.head) {
                        addList.removeNode(addList.head.value);
                    }
                    break;
                }
                candidate = node.previous;
                addList.removeNode(node.value);
                pushAdd(node.value);
            }
            const payload = {
                texts: this.texts
                    .map((text) => ({
                    id: this.mirror.getId(text.node),
                    value: text.value,
                }))
                    .filter((text) => this.mirror.has(text.id)),
                attributes: this.attributes
                    .map((attribute) => ({
                    id: this.mirror.getId(attribute.node),
                    attributes: attribute.attributes,
                }))
                    .filter((attribute) => this.mirror.has(attribute.id)),
                removes: this.removes,
                adds,
            };
            if (!payload.texts.length &&
                !payload.attributes.length &&
                !payload.removes.length &&
                !payload.adds.length) {
                return;
            }
            this.texts = [];
            this.attributes = [];
            this.removes = [];
            this.addedSet = new Set();
            this.movedSet = new Set();
            this.droppedSet = new Set();
            this.movedMap = {};
            this.mutationCb(payload);
        };
        this.processMutation = (m) => {
            if (isIgnored(m.target)) {
                return;
            }
            switch (m.type) {
                case 'characterData': {
                    const value = m.target.textContent;
                    if (!isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector) && value !== m.oldValue) {
                        this.texts.push({
                            value: needMaskingText(m.target, this.maskTextClass, this.maskTextSelector, this.unmaskTextSelector, this.maskAllText) && value
                                ? this.maskTextFn
                                    ? this.maskTextFn(value)
                                    : value.replace(/[\S]/g, '*')
                                : value,
                            node: m.target,
                        });
                    }
                    break;
                }
                case 'attributes': {
                    const target = m.target;
                    let value = target.getAttribute(m.attributeName);
                    if (m.attributeName === 'value') {
                        value = maskInputValue({
                            input: target,
                            maskInputSelector: this.maskInputSelector,
                            unmaskInputSelector: this.unmaskInputSelector,
                            maskInputOptions: this.maskInputOptions,
                            tagName: target.tagName,
                            type: target.getAttribute('type'),
                            value,
                            maskInputFn: this.maskInputFn,
                        });
                    }
                    if (isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector) || value === m.oldValue) {
                        return;
                    }
                    let item = this.attributes.find((a) => a.node === m.target);
                    if (!item) {
                        item = {
                            node: m.target,
                            attributes: {},
                        };
                        this.attributes.push(item);
                    }
                    if (m.attributeName === 'type' &&
                        target.tagName === 'INPUT' &&
                        (m.oldValue || '').toLowerCase() === 'password') {
                        target.setAttribute('data-rr-is-password', 'true');
                    }
                    if (m.attributeName === 'style') {
                        const old = this.doc.createElement('span');
                        if (m.oldValue) {
                            old.setAttribute('style', m.oldValue);
                        }
                        if (item.attributes.style === undefined ||
                            item.attributes.style === null) {
                            item.attributes.style = {};
                        }
                        try {
                            const styleObj = item.attributes.style;
                            for (const pname of Array.from(target.style)) {
                                const newValue = target.style.getPropertyValue(pname);
                                const newPriority = target.style.getPropertyPriority(pname);
                                if (newValue !== old.style.getPropertyValue(pname) ||
                                    newPriority !== old.style.getPropertyPriority(pname)) {
                                    if (newPriority === '') {
                                        styleObj[pname] = newValue;
                                    }
                                    else {
                                        styleObj[pname] = [newValue, newPriority];
                                    }
                                }
                            }
                            for (const pname of Array.from(old.style)) {
                                if (target.style.getPropertyValue(pname) === '') {
                                    styleObj[pname] = false;
                                }
                            }
                        }
                        catch (error) {
                            console.warn('[rrweb] Error when parsing update to style attribute:', error);
                        }
                    }
                    else {
                        const element = m.target;
                        item.attributes[m.attributeName] = transformAttribute(this.doc, element, element.tagName, m.attributeName, value, this.maskAllText, this.unmaskTextSelector, this.maskTextFn);
                    }
                    break;
                }
                case 'childList': {
                    m.addedNodes.forEach((n) => this.genAdds(n, m.target));
                    m.removedNodes.forEach((n) => {
                        const nodeId = this.mirror.getId(n);
                        const parentId = isShadowRoot(m.target)
                            ? this.mirror.getId(m.target.host)
                            : this.mirror.getId(m.target);
                        if (isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector) || isIgnored(n)) {
                            return;
                        }
                        if (this.addedSet.has(n)) {
                            deepDelete(this.addedSet, n);
                            this.droppedSet.add(n);
                        }
                        else if (this.addedSet.has(m.target) && nodeId === -1) ;
                        else if (isAncestorRemoved(m.target, this.mirror)) ;
                        else if (this.movedSet.has(n) &&
                            this.movedMap[moveKey(nodeId, parentId)]) {
                            deepDelete(this.movedSet, n);
                        }
                        else {
                            this.removes.push({
                                parentId,
                                id: nodeId,
                                isShadow: isShadowRoot(m.target) ? true : undefined,
                            });
                        }
                        this.mapRemoves.push(n);
                    });
                    break;
                }
            }
        };
        this.genAdds = (n, target) => {
            if (target && isBlocked(target, this.blockClass, this.blockSelector, this.unblockSelector)) {
                return;
            }
            if (isINode(n)) {
                if (isIgnored(n)) {
                    return;
                }
                this.movedSet.add(n);
                let targetId = null;
                if (target && isINode(target)) {
                    targetId = target.__sn.id;
                }
                if (targetId) {
                    this.movedMap[moveKey(n.__sn.id, targetId)] = true;
                }
            }
            else {
                this.addedSet.add(n);
                this.droppedSet.delete(n);
            }
            if (!isBlocked(n, this.blockClass, this.blockSelector, this.unblockSelector))
                n.childNodes.forEach((childN) => this.genAdds(childN));
        };
    }
    init(options) {
        [
            'mutationCb',
            'blockClass',
            'blockSelector',
            'unblockSelector',
            'maskTextClass',
            'maskTextSelector',
            'unmaskTextSelector',
            'maskInputSelector',
            'unmaskInputSelector',
            'inlineStylesheet',
            'maskAllText',
            'maskInputOptions',
            'maskTextFn',
            'maskInputFn',
            'recordCanvas',
            'inlineImages',
            'slimDOMOptions',
            'doc',
            'mirror',
            'iframeManager',
            'shadowDomManager',
            'canvasManager',
        ].forEach((key) => {
            this[key] = options[key];
        });
    }
    freeze() {
        this.frozen = true;
        this.canvasManager.freeze();
    }
    unfreeze() {
        this.frozen = false;
        this.canvasManager.unfreeze();
        this.emit();
    }
    isFrozen() {
        return this.frozen;
    }
    lock() {
        this.locked = true;
        this.canvasManager.lock();
    }
    unlock() {
        this.locked = false;
        this.canvasManager.unlock();
        this.emit();
    }
    reset() {
        this.shadowDomManager.reset();
        this.canvasManager.reset();
    }
}
function deepDelete(addsSet, n) {
    addsSet.delete(n);
    n.childNodes.forEach((childN) => deepDelete(addsSet, childN));
}
function isParentRemoved(removes, n, mirror) {
    const { parentNode } = n;
    if (!parentNode) {
        return false;
    }
    const parentId = mirror.getId(parentNode);
    if (removes.some((r) => r.id === parentId)) {
        return true;
    }
    return isParentRemoved(removes, parentNode, mirror);
}
function isAncestorInSet(set, n) {
    const { parentNode } = n;
    if (!parentNode) {
        return false;
    }
    if (set.has(parentNode)) {
        return true;
    }
    return isAncestorInSet(set, parentNode);
}

const callbackWrapper = (cb) => {
    const rrwebWrapped = (...rest) => {
        try {
            return cb(...rest);
        }
        catch (error) {
            try {
                error.__rrweb__ = true;
            }
            catch (_a) {
            }
            throw error;
        }
    };
    return rrwebWrapped;
};

const mutationBuffers = [];
function getEventTarget(event) {
    try {
        if ('composedPath' in event) {
            const path = event.composedPath();
            if (path.length) {
                return path[0];
            }
        }
        else if ('path' in event && event.path.length) {
            return event.path[0];
        }
    }
    catch (_a) { }
    return event && event.target;
}
function initMutationObserver(options, rootEl) {
    var _a, _b;
    const mutationBuffer = new MutationBuffer();
    mutationBuffers.push(mutationBuffer);
    mutationBuffer.init(options);
    let mutationObserverCtor = window.MutationObserver ||
        window.__rrMutationObserver;
    const angularZoneSymbol = (_b = (_a = window === null || window === void 0 ? void 0 : window.Zone) === null || _a === void 0 ? void 0 : _a.__symbol__) === null || _b === void 0 ? void 0 : _b.call(_a, 'MutationObserver');
    if (angularZoneSymbol &&
        window[angularZoneSymbol]) {
        mutationObserverCtor = window[angularZoneSymbol];
    }
    const observer = new mutationObserverCtor(callbackWrapper((mutations) => {
        if (options.onMutation && options.onMutation(mutations) === false) {
            return;
        }
        mutationBuffer.processMutations(mutations);
    }));
    observer.observe(rootEl, {
        attributes: true,
        attributeOldValue: true,
        characterData: true,
        characterDataOldValue: true,
        childList: true,
        subtree: true,
    });
    return observer;
}
function initMoveObserver({ mousemoveCb, sampling, doc, mirror, }) {
    if (sampling.mousemove === false) {
        return () => { };
    }
    const threshold = typeof sampling.mousemove === 'number' ? sampling.mousemove : 50;
    const callbackThreshold = typeof sampling.mousemoveCallback === 'number'
        ? sampling.mousemoveCallback
        : 500;
    let positions = [];
    let timeBaseline;
    const wrappedCb = throttle$1((source) => {
        const totalOffset = Date.now() - timeBaseline;
        callbackWrapper(mousemoveCb)(positions.map((p) => {
            p.timeOffset -= totalOffset;
            return p;
        }), source);
        positions = [];
        timeBaseline = null;
    }, callbackThreshold);
    const updatePosition = throttle$1((evt) => {
        const target = getEventTarget(evt);
        const { clientX, clientY } = isTouchEvent(evt)
            ? evt.changedTouches[0]
            : evt;
        if (!timeBaseline) {
            timeBaseline = Date.now();
        }
        positions.push({
            x: clientX,
            y: clientY,
            id: mirror.getId(target),
            timeOffset: Date.now() - timeBaseline,
        });
        wrappedCb(typeof DragEvent !== 'undefined' && evt instanceof DragEvent
            ? IncrementalSource.Drag
            : evt instanceof MouseEvent
                ? IncrementalSource.MouseMove
                : IncrementalSource.TouchMove);
    }, threshold, {
        trailing: false,
    });
    const handlers = [
        on('mousemove', callbackWrapper(updatePosition), doc),
        on('touchmove', callbackWrapper(updatePosition), doc),
        on('drag', callbackWrapper(updatePosition), doc),
    ];
    return callbackWrapper(() => {
        handlers.forEach((h) => h());
    });
}
function initMouseInteractionObserver({ mouseInteractionCb, doc, mirror, blockClass, blockSelector, unblockSelector, sampling, }) {
    if (sampling.mouseInteraction === false) {
        return () => { };
    }
    const disableMap = sampling.mouseInteraction === true ||
        sampling.mouseInteraction === undefined
        ? {}
        : sampling.mouseInteraction;
    const handlers = [];
    const getHandler = (eventKey) => {
        return (event) => {
            const target = getEventTarget(event);
            if (isBlocked(target, blockClass, blockSelector, unblockSelector)) {
                return;
            }
            const e = isTouchEvent(event) ? event.changedTouches[0] : event;
            if (!e) {
                return;
            }
            const id = mirror.getId(target);
            const { clientX, clientY } = e;
            callbackWrapper(mouseInteractionCb)({
                type: MouseInteractions[eventKey],
                id,
                x: clientX,
                y: clientY,
            });
        };
    };
    Object.keys(MouseInteractions)
        .filter((key) => Number.isNaN(Number(key)) &&
        !key.endsWith('_Departed') &&
        disableMap[key] !== false)
        .forEach((eventKey) => {
        const eventName = eventKey.toLowerCase();
        const handler = callbackWrapper(getHandler(eventKey));
        handlers.push(on(eventName, handler, doc));
    });
    return callbackWrapper(() => {
        handlers.forEach((h) => h());
    });
}
function initScrollObserver({ scrollCb, doc, mirror, blockClass, blockSelector, unblockSelector, sampling, }) {
    const updatePosition = throttle$1((evt) => {
        const target = getEventTarget(evt);
        if (!target ||
            isBlocked(target, blockClass, blockSelector, unblockSelector)) {
            return;
        }
        const id = mirror.getId(target);
        if (target === doc) {
            const scrollEl = (doc.scrollingElement || doc.documentElement);
            callbackWrapper(scrollCb)({
                id,
                x: scrollEl.scrollLeft,
                y: scrollEl.scrollTop,
            });
        }
        else {
            callbackWrapper(scrollCb)({
                id,
                x: target.scrollLeft,
                y: target.scrollTop,
            });
        }
    }, sampling.scroll || 100);
    return on('scroll', callbackWrapper(updatePosition), doc);
}
function initViewportResizeObserver({ viewportResizeCb, }) {
    let lastH = -1;
    let lastW = -1;
    const updateDimension = throttle$1(() => {
        const height = getWindowHeight();
        const width = getWindowWidth();
        if (lastH !== height || lastW !== width) {
            callbackWrapper(viewportResizeCb)({
                width: Number(width),
                height: Number(height),
            });
            lastH = height;
            lastW = width;
        }
    }, 200);
    return on('resize', callbackWrapper(updateDimension), window);
}
function wrapEventWithUserTriggeredFlag(v, enable) {
    const value = Object.assign({}, v);
    if (!enable)
        delete value.userTriggered;
    return value;
}
const INPUT_TAGS = ['INPUT', 'TEXTAREA', 'SELECT'];
const lastInputValueMap = new WeakMap();
function initInputObserver({ inputCb, doc, mirror, blockClass, blockSelector, unblockSelector, ignoreClass, ignoreSelector, maskInputSelector, unmaskInputSelector, maskInputOptions, maskInputFn, sampling, userTriggeredOnInput, }) {
    function eventHandler(event) {
        let target = getEventTarget(event);
        const tagName = target && target.tagName;
        const userTriggered = event.isTrusted;
        if (tagName === 'OPTION')
            target = target.parentElement;
        if (!target ||
            !tagName ||
            INPUT_TAGS.indexOf(tagName) < 0 ||
            isBlocked(target, blockClass, blockSelector, unblockSelector)) {
            return;
        }
        const el = target;
        const type = getInputType(el);
        if (el.classList.contains(ignoreClass) ||
            (ignoreSelector && el.matches(ignoreSelector))) {
            return;
        }
        let text = getInputValue(el, tagName, type);
        let isChecked = false;
        if (type === 'radio' || type === 'checkbox') {
            isChecked = target.checked;
        }
        if (hasInputMaskOptions({
            maskInputOptions,
            maskInputSelector,
            tagName,
            type,
        })) {
            text = maskInputValue({
                input: el,
                maskInputOptions,
                maskInputSelector,
                unmaskInputSelector,
                tagName,
                type,
                value: text,
                maskInputFn,
            });
        }
        cbWithDedup(target, callbackWrapper(wrapEventWithUserTriggeredFlag)({ text, isChecked, userTriggered }, userTriggeredOnInput));
        const name = target.name;
        if (type === 'radio' && name && isChecked) {
            doc
                .querySelectorAll(`input[type="radio"][name="${name}"]`)
                .forEach((el) => {
                if (el !== target) {
                    const text = maskInputValue({
                        input: el,
                        maskInputOptions,
                        maskInputSelector,
                        unmaskInputSelector,
                        tagName,
                        type,
                        value: getInputValue(el, tagName, type),
                        maskInputFn,
                    });
                    cbWithDedup(el, callbackWrapper(wrapEventWithUserTriggeredFlag)({
                        text,
                        isChecked: !isChecked,
                        userTriggered: false,
                    }, userTriggeredOnInput));
                }
            });
        }
    }
    function cbWithDedup(target, v) {
        const lastInputValue = lastInputValueMap.get(target);
        if (!lastInputValue ||
            lastInputValue.text !== v.text ||
            lastInputValue.isChecked !== v.isChecked) {
            lastInputValueMap.set(target, v);
            const id = mirror.getId(target);
            inputCb(Object.assign(Object.assign({}, v), { id }));
        }
    }
    const events = sampling.input === 'last' ? ['change'] : ['input', 'change'];
    const handlers = events.map((eventName) => on(eventName, callbackWrapper(eventHandler), doc));
    const propertyDescriptor = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value');
    const hookProperties = [
        [HTMLInputElement.prototype, 'value'],
        [HTMLInputElement.prototype, 'checked'],
        [HTMLSelectElement.prototype, 'value'],
        [HTMLTextAreaElement.prototype, 'value'],
        [HTMLSelectElement.prototype, 'selectedIndex'],
        [HTMLOptionElement.prototype, 'selected'],
    ];
    if (propertyDescriptor && propertyDescriptor.set) {
        handlers.push(...hookProperties.map((p) => hookSetter(p[0], p[1], {
            set() {
                callbackWrapper(eventHandler)({ target: this });
            },
        })));
    }
    return callbackWrapper(() => {
        handlers.forEach((h) => h());
    });
}
function getNestedCSSRulePositions(rule) {
    const positions = [];
    function recurse(childRule, pos) {
        if ((hasNestedCSSRule('CSSGroupingRule') &&
            childRule.parentRule instanceof CSSGroupingRule) ||
            (hasNestedCSSRule('CSSMediaRule') &&
                childRule.parentRule instanceof CSSMediaRule) ||
            (hasNestedCSSRule('CSSSupportsRule') &&
                childRule.parentRule instanceof CSSSupportsRule) ||
            (hasNestedCSSRule('CSSConditionRule') &&
                childRule.parentRule instanceof CSSConditionRule)) {
            const rules = Array.from(childRule.parentRule.cssRules);
            const index = rules.indexOf(childRule);
            pos.unshift(index);
        }
        else {
            const rules = Array.from(childRule.parentStyleSheet.cssRules);
            const index = rules.indexOf(childRule);
            pos.unshift(index);
        }
        return pos;
    }
    return recurse(rule, positions);
}
function initStyleSheetObserver({ styleSheetRuleCb, mirror }, { win }) {
    if (!win.CSSStyleSheet || !win.CSSStyleSheet.prototype) {
        return () => { };
    }
    const insertRule = win.CSSStyleSheet.prototype.insertRule;
    win.CSSStyleSheet.prototype.insertRule = new Proxy(insertRule, {
        apply: callbackWrapper((target, thisArg, argumentsList) => {
            const [rule, index] = argumentsList;
            const id = mirror.getId(thisArg.ownerNode);
            if (id !== -1) {
                styleSheetRuleCb({
                    id,
                    adds: [{ rule, index }],
                });
            }
            return target.apply(thisArg, argumentsList);
        }),
    });
    const deleteRule = win.CSSStyleSheet.prototype.deleteRule;
    win.CSSStyleSheet.prototype.deleteRule = new Proxy(deleteRule, {
        apply: callbackWrapper((target, thisArg, argumentsList) => {
            const [index] = argumentsList;
            const id = mirror.getId(thisArg.ownerNode);
            if (id !== -1) {
                styleSheetRuleCb({
                    id,
                    removes: [{ index }],
                });
            }
            return target.apply(thisArg, argumentsList);
        }),
    });
    const supportedNestedCSSRuleTypes = {};
    if (canMonkeyPatchNestedCSSRule('CSSGroupingRule')) {
        supportedNestedCSSRuleTypes.CSSGroupingRule = win.CSSGroupingRule;
    }
    else {
        if (canMonkeyPatchNestedCSSRule('CSSMediaRule')) {
            supportedNestedCSSRuleTypes.CSSMediaRule = win.CSSMediaRule;
        }
        if (canMonkeyPatchNestedCSSRule('CSSConditionRule')) {
            supportedNestedCSSRuleTypes.CSSConditionRule = win.CSSConditionRule;
        }
        if (canMonkeyPatchNestedCSSRule('CSSSupportsRule')) {
            supportedNestedCSSRuleTypes.CSSSupportsRule = win.CSSSupportsRule;
        }
    }
    const unmodifiedFunctions = {};
    Object.entries(supportedNestedCSSRuleTypes).forEach(([typeKey, type]) => {
        unmodifiedFunctions[typeKey] = {
            insertRule: type.prototype.insertRule,
            deleteRule: type.prototype.deleteRule,
        };
        type.prototype.insertRule = new Proxy(unmodifiedFunctions[typeKey].insertRule, {
            apply: callbackWrapper((target, thisArg, argumentsList) => {
                const [rule, index] = argumentsList;
                const id = mirror.getId(thisArg.parentStyleSheet.ownerNode);
                if (id !== -1) {
                    styleSheetRuleCb({
                        id,
                        adds: [
                            {
                                rule,
                                index: [
                                    ...getNestedCSSRulePositions(thisArg),
                                    index || 0,
                                ],
                            },
                        ],
                    });
                }
                return target.apply(thisArg, argumentsList);
            }),
        });
        type.prototype.deleteRule = new Proxy(unmodifiedFunctions[typeKey].deleteRule, {
            apply: callbackWrapper((target, thisArg, argumentsList) => {
                const [index] = argumentsList;
                const id = mirror.getId(thisArg.parentStyleSheet.ownerNode);
                if (id !== -1) {
                    styleSheetRuleCb({
                        id,
                        removes: [
                            { index: [...getNestedCSSRulePositions(thisArg), index] },
                        ],
                    });
                }
                return target.apply(thisArg, argumentsList);
            }),
        });
    });
    return callbackWrapper(() => {
        win.CSSStyleSheet.prototype.insertRule = insertRule;
        win.CSSStyleSheet.prototype.deleteRule = deleteRule;
        Object.entries(supportedNestedCSSRuleTypes).forEach(([typeKey, type]) => {
            type.prototype.insertRule = unmodifiedFunctions[typeKey].insertRule;
            type.prototype.deleteRule = unmodifiedFunctions[typeKey].deleteRule;
        });
    });
}
function initStyleDeclarationObserver({ styleDeclarationCb, mirror }, { win }) {
    const setProperty = win.CSSStyleDeclaration.prototype.setProperty;
    win.CSSStyleDeclaration.prototype.setProperty = new Proxy(setProperty, {
        apply: callbackWrapper((target, thisArg, argumentsList) => {
            var _a, _b;
            const [property, value, priority] = argumentsList;
            const id = mirror.getId((_b = (_a = thisArg.parentRule) === null || _a === void 0 ? void 0 : _a.parentStyleSheet) === null || _b === void 0 ? void 0 : _b.ownerNode);
            if (id !== -1) {
                styleDeclarationCb({
                    id,
                    set: {
                        property,
                        value,
                        priority,
                    },
                    index: getNestedCSSRulePositions(thisArg.parentRule),
                });
            }
            return target.apply(thisArg, argumentsList);
        }),
    });
    const removeProperty = win.CSSStyleDeclaration.prototype.removeProperty;
    win.CSSStyleDeclaration.prototype.removeProperty = new Proxy(removeProperty, {
        apply: callbackWrapper((target, thisArg, argumentsList) => {
            var _a, _b;
            const [property] = argumentsList;
            const id = mirror.getId((_b = (_a = thisArg.parentRule) === null || _a === void 0 ? void 0 : _a.parentStyleSheet) === null || _b === void 0 ? void 0 : _b.ownerNode);
            if (id !== -1) {
                styleDeclarationCb({
                    id,
                    remove: {
                        property,
                    },
                    index: getNestedCSSRulePositions(thisArg.parentRule),
                });
            }
            return target.apply(thisArg, argumentsList);
        }),
    });
    return callbackWrapper(() => {
        win.CSSStyleDeclaration.prototype.setProperty = setProperty;
        win.CSSStyleDeclaration.prototype.removeProperty = removeProperty;
    });
}
function initMediaInteractionObserver({ mediaInteractionCb, blockClass, blockSelector, unblockSelector, mirror, sampling, }) {
    const handler = (type) => throttle$1(callbackWrapper((event) => {
        const target = getEventTarget(event);
        if (!target ||
            isBlocked(target, blockClass, blockSelector, unblockSelector)) {
            return;
        }
        const { currentTime, volume, muted } = target;
        mediaInteractionCb({
            type,
            id: mirror.getId(target),
            currentTime,
            volume,
            muted,
        });
    }), sampling.media || 500);
    const handlers = [
        on('play', handler(0)),
        on('pause', handler(1)),
        on('seeked', handler(2)),
        on('volumechange', handler(3)),
    ];
    return callbackWrapper(() => {
        handlers.forEach((h) => h());
    });
}
function initFontObserver({ fontCb, doc }) {
    const win = doc.defaultView;
    if (!win) {
        return () => { };
    }
    const handlers = [];
    const fontMap = new WeakMap();
    const originalFontFace = win.FontFace;
    win.FontFace = function FontFace(family, source, descriptors) {
        const fontFace = new originalFontFace(family, source, descriptors);
        fontMap.set(fontFace, {
            family,
            buffer: typeof source !== 'string',
            descriptors,
            fontSource: typeof source === 'string'
                ? source
                :
                    JSON.stringify(Array.from(new Uint8Array(source))),
        });
        return fontFace;
    };
    const restoreHandler = patch(doc.fonts, 'add', function (original) {
        return function (fontFace) {
            setTimeout(() => {
                const p = fontMap.get(fontFace);
                if (p) {
                    fontCb(p);
                    fontMap.delete(fontFace);
                }
            }, 0);
            return original.apply(this, [fontFace]);
        };
    });
    handlers.push(() => {
        win.FontFace = originalFontFace;
    });
    handlers.push(restoreHandler);
    return callbackWrapper(() => {
        handlers.forEach((h) => h());
    });
}
function mergeHooks(o, hooks) {
    const { mutationCb, mousemoveCb, mouseInteractionCb, scrollCb, viewportResizeCb, inputCb, mediaInteractionCb, styleSheetRuleCb, styleDeclarationCb, canvasMutationCb, fontCb, } = o;
    o.mutationCb = (...p) => {
        if (hooks.mutation) {
            hooks.mutation(...p);
        }
        mutationCb(...p);
    };
    o.mousemoveCb = (...p) => {
        if (hooks.mousemove) {
            hooks.mousemove(...p);
        }
        mousemoveCb(...p);
    };
    o.mouseInteractionCb = (...p) => {
        if (hooks.mouseInteraction) {
            hooks.mouseInteraction(...p);
        }
        mouseInteractionCb(...p);
    };
    o.scrollCb = (...p) => {
        if (hooks.scroll) {
            hooks.scroll(...p);
        }
        scrollCb(...p);
    };
    o.viewportResizeCb = (...p) => {
        if (hooks.viewportResize) {
            hooks.viewportResize(...p);
        }
        viewportResizeCb(...p);
    };
    o.inputCb = (...p) => {
        if (hooks.input) {
            hooks.input(...p);
        }
        inputCb(...p);
    };
    o.mediaInteractionCb = (...p) => {
        if (hooks.mediaInteaction) {
            hooks.mediaInteaction(...p);
        }
        mediaInteractionCb(...p);
    };
    o.styleSheetRuleCb = (...p) => {
        if (hooks.styleSheetRule) {
            hooks.styleSheetRule(...p);
        }
        styleSheetRuleCb(...p);
    };
    o.styleDeclarationCb = (...p) => {
        if (hooks.styleDeclaration) {
            hooks.styleDeclaration(...p);
        }
        styleDeclarationCb(...p);
    };
    o.canvasMutationCb = (...p) => {
        if (hooks.canvasMutation) {
            hooks.canvasMutation(...p);
        }
        canvasMutationCb(...p);
    };
    o.fontCb = (...p) => {
        if (hooks.font) {
            hooks.font(...p);
        }
        fontCb(...p);
    };
}
function initObservers(o, hooks = {}) {
    const currentWindow = o.doc.defaultView;
    if (!currentWindow) {
        return () => { };
    }
    mergeHooks(o, hooks);
    const mutationObserver = initMutationObserver(o, o.doc);
    const mousemoveHandler = initMoveObserver(o);
    const mouseInteractionHandler = initMouseInteractionObserver(o);
    const scrollHandler = initScrollObserver(o);
    const viewportResizeHandler = initViewportResizeObserver(o);
    const inputHandler = initInputObserver(o);
    const mediaInteractionHandler = initMediaInteractionObserver(o);
    const styleSheetObserver = initStyleSheetObserver(o, { win: currentWindow });
    const styleDeclarationObserver = initStyleDeclarationObserver(o, {
        win: currentWindow,
    });
    const fontObserver = o.collectFonts ? initFontObserver(o) : () => { };
    const pluginHandlers = [];
    for (const plugin of o.plugins) {
        pluginHandlers.push(plugin.observer(plugin.callback, currentWindow, plugin.options));
    }
    return callbackWrapper(() => {
        mutationBuffers.forEach((b) => b.reset());
        mutationObserver.disconnect();
        mousemoveHandler();
        mouseInteractionHandler();
        scrollHandler();
        viewportResizeHandler();
        inputHandler();
        mediaInteractionHandler();
        try {
            styleSheetObserver();
            styleDeclarationObserver();
        }
        catch (e) {
        }
        fontObserver();
        pluginHandlers.forEach((h) => h());
    });
}
function hasNestedCSSRule(prop) {
    return typeof window[prop] !== 'undefined';
}
function canMonkeyPatchNestedCSSRule(prop) {
    return Boolean(typeof window[prop] !== 'undefined' &&
        window[prop].prototype &&
        'insertRule' in window[prop].prototype &&
        'deleteRule' in window[prop].prototype);
}

class IframeManager {
    constructor(options) {
        this.iframes = new WeakMap();
        this.mutationCb = options.mutationCb;
    }
    addIframe(iframeEl) {
        this.iframes.set(iframeEl, true);
    }
    addLoadListener(cb) {
        this.loadListener = cb;
    }
    attachIframe(iframeEl, childSn) {
        var _a;
        this.mutationCb({
            adds: [
                {
                    parentId: iframeEl.__sn.id,
                    nextId: null,
                    node: childSn,
                },
            ],
            removes: [],
            texts: [],
            attributes: [],
            isAttachIframe: true,
        });
        (_a = this.loadListener) === null || _a === void 0 ? void 0 : _a.call(this, iframeEl);
    }
}

class ShadowDomManager {
    constructor(options) {
        this.restorePatches = [];
        this.mutationCb = options.mutationCb;
        this.scrollCb = options.scrollCb;
        this.bypassOptions = options.bypassOptions;
        this.mirror = options.mirror;
        const manager = this;
        this.restorePatches.push(patch(HTMLElement.prototype, 'attachShadow', function (original) {
            return function () {
                const shadowRoot = original.apply(this, arguments);
                if (this.shadowRoot)
                    manager.addShadowRoot(this.shadowRoot, this.ownerDocument);
                return shadowRoot;
            };
        }));
    }
    addShadowRoot(shadowRoot, doc) {
        initMutationObserver(Object.assign(Object.assign({}, this.bypassOptions), { doc, mutationCb: this.mutationCb, mirror: this.mirror, shadowDomManager: this }), shadowRoot);
        initScrollObserver(Object.assign(Object.assign({}, this.bypassOptions), { scrollCb: this.scrollCb, doc: shadowRoot, mirror: this.mirror }));
    }
    observeAttachShadow(iframeElement) {
        if (iframeElement.contentWindow) {
            const manager = this;
            this.restorePatches.push(patch(iframeElement.contentWindow.HTMLElement.prototype, 'attachShadow', function (original) {
                return function () {
                    const shadowRoot = original.apply(this, arguments);
                    if (this.shadowRoot)
                        manager.addShadowRoot(this.shadowRoot, iframeElement.contentDocument);
                    return shadowRoot;
                };
            }));
        }
    }
    reset() {
        this.restorePatches.forEach((restorePatch) => restorePatch());
    }
}

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function initCanvas2DMutationObserver(cb, win, blockClass, unblockSelector, blockSelector, mirror) {
    const handlers = [];
    const props2D = Object.getOwnPropertyNames(win.CanvasRenderingContext2D.prototype);
    for (const prop of props2D) {
        try {
            if (typeof win.CanvasRenderingContext2D.prototype[prop] !== 'function') {
                continue;
            }
            const restoreHandler = patch(win.CanvasRenderingContext2D.prototype, prop, function (original) {
                return function (...args) {
                    if (!isBlocked(this.canvas, blockClass, blockSelector, unblockSelector)) {
                        setTimeout(() => {
                            const recordArgs = [...args];
                            if (prop === 'drawImage') {
                                if (recordArgs[0] &&
                                    recordArgs[0] instanceof HTMLCanvasElement) {
                                    const canvas = recordArgs[0];
                                    const ctx = canvas.getContext('2d');
                                    let imgd = ctx === null || ctx === void 0 ? void 0 : ctx.getImageData(0, 0, canvas.width, canvas.height);
                                    let pix = imgd === null || imgd === void 0 ? void 0 : imgd.data;
                                    recordArgs[0] = JSON.stringify(pix);
                                }
                            }
                            cb(this.canvas, {
                                type: CanvasContext['2D'],
                                property: prop,
                                args: recordArgs,
                            });
                        }, 0);
                    }
                    return original.apply(this, args);
                };
            });
            handlers.push(restoreHandler);
        }
        catch (_a) {
            const hookHandler = hookSetter(win.CanvasRenderingContext2D.prototype, prop, {
                set(v) {
                    cb(this.canvas, {
                        type: CanvasContext['2D'],
                        property: prop,
                        args: [v],
                        setter: true,
                    });
                },
            });
            handlers.push(hookHandler);
        }
    }
    return () => {
        handlers.forEach((h) => h());
    };
}

function initCanvasContextObserver(win, blockClass, blockSelector, unblockSelector) {
    const handlers = [];
    try {
        const restoreHandler = patch(win.HTMLCanvasElement.prototype, 'getContext', function (original) {
            return function (contextType, ...args) {
                if (!isBlocked(this, blockClass, blockSelector, unblockSelector)) {
                    if (!('__context' in this))
                        this.__context = contextType;
                }
                return original.apply(this, [contextType, ...args]);
            };
        });
        handlers.push(restoreHandler);
    }
    catch (_a) {
        console.error('failed to patch HTMLCanvasElement.prototype.getContext');
    }
    return () => {
        handlers.forEach((h) => h());
    };
}

/*
 * base64-arraybuffer 1.0.2 <https://github.com/niklasvh/base64-arraybuffer>
 * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
 * Released under MIT License
 */
var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
// Use a lookup table to find the index.
var lookup = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
for (var i = 0; i < chars.length; i++) {
    lookup[chars.charCodeAt(i)] = i;
}
var encode = function (arraybuffer) {
    var bytes = new Uint8Array(arraybuffer), i, len = bytes.length, base64 = '';
    for (i = 0; i < len; i += 3) {
        base64 += chars[bytes[i] >> 2];
        base64 += chars[((bytes[i] & 3) << 4) | (bytes[i + 1] >> 4)];
        base64 += chars[((bytes[i + 1] & 15) << 2) | (bytes[i + 2] >> 6)];
        base64 += chars[bytes[i + 2] & 63];
    }
    if (len % 3 === 2) {
        base64 = base64.substring(0, base64.length - 1) + '=';
    }
    else if (len % 3 === 1) {
        base64 = base64.substring(0, base64.length - 2) + '==';
    }
    return base64;
};

const webGLVarMap = new Map();
function variableListFor(ctx, ctor) {
    let contextMap = webGLVarMap.get(ctx);
    if (!contextMap) {
        contextMap = new Map();
        webGLVarMap.set(ctx, contextMap);
    }
    if (!contextMap.has(ctor)) {
        contextMap.set(ctor, []);
    }
    return contextMap.get(ctor);
}
const saveWebGLVar = (value, win, ctx) => {
    if (!value ||
        !(isInstanceOfWebGLObject(value, win) || typeof value === 'object'))
        return;
    const name = value.constructor.name;
    const list = variableListFor(ctx, name);
    let index = list.indexOf(value);
    if (index === -1) {
        index = list.length;
        list.push(value);
    }
    return index;
};
function serializeArg(value, win, ctx) {
    if (value instanceof Array) {
        return value.map((arg) => serializeArg(arg, win, ctx));
    }
    else if (value === null) {
        return value;
    }
    else if (value instanceof Float32Array ||
        value instanceof Float64Array ||
        value instanceof Int32Array ||
        value instanceof Uint32Array ||
        value instanceof Uint8Array ||
        value instanceof Uint16Array ||
        value instanceof Int16Array ||
        value instanceof Int8Array ||
        value instanceof Uint8ClampedArray) {
        const name = value.constructor.name;
        return {
            rr_type: name,
            args: [Object.values(value)],
        };
    }
    else if (value instanceof ArrayBuffer) {
        const name = value.constructor.name;
        const base64 = encode(value);
        return {
            rr_type: name,
            base64,
        };
    }
    else if (value instanceof DataView) {
        const name = value.constructor.name;
        return {
            rr_type: name,
            args: [
                serializeArg(value.buffer, win, ctx),
                value.byteOffset,
                value.byteLength,
            ],
        };
    }
    else if (value instanceof HTMLImageElement) {
        const name = value.constructor.name;
        const { src } = value;
        return {
            rr_type: name,
            src,
        };
    }
    else if (value instanceof ImageData) {
        const name = value.constructor.name;
        return {
            rr_type: name,
            args: [serializeArg(value.data, win, ctx), value.width, value.height],
        };
    }
    else if (isInstanceOfWebGLObject(value, win) || typeof value === 'object') {
        const name = value.constructor.name;
        const index = saveWebGLVar(value, win, ctx);
        return {
            rr_type: name,
            index: index,
        };
    }
    return value;
}
const serializeArgs = (args, win, ctx) => {
    return [...args].map((arg) => serializeArg(arg, win, ctx));
};
const isInstanceOfWebGLObject = (value, win) => {
    const webGLConstructorNames = [
        'WebGLActiveInfo',
        'WebGLBuffer',
        'WebGLFramebuffer',
        'WebGLProgram',
        'WebGLRenderbuffer',
        'WebGLShader',
        'WebGLShaderPrecisionFormat',
        'WebGLTexture',
        'WebGLUniformLocation',
        'WebGLVertexArrayObject',
        'WebGLVertexArrayObjectOES',
    ];
    const supportedWebGLConstructorNames = webGLConstructorNames.filter((name) => typeof win[name] === 'function');
    return Boolean(supportedWebGLConstructorNames.find((name) => value instanceof win[name]));
};

function patchGLPrototype(prototype, type, cb, blockClass, unblockSelector, blockSelector, mirror, win) {
    const handlers = [];
    const props = Object.getOwnPropertyNames(prototype);
    for (const prop of props) {
        try {
            if (typeof prototype[prop] !== 'function') {
                continue;
            }
            const restoreHandler = patch(prototype, prop, function (original) {
                return function (...args) {
                    const result = original.apply(this, args);
                    saveWebGLVar(result, win, prototype);
                    if (!isBlocked(this.canvas, blockClass, blockSelector, unblockSelector)) {
                        const id = mirror.getId(this.canvas);
                        const recordArgs = serializeArgs([...args], win, prototype);
                        const mutation = {
                            type,
                            property: prop,
                            args: recordArgs,
                        };
                        cb(this.canvas, mutation);
                    }
                    return result;
                };
            });
            handlers.push(restoreHandler);
        }
        catch (_a) {
            const hookHandler = hookSetter(prototype, prop, {
                set(v) {
                    cb(this.canvas, {
                        type,
                        property: prop,
                        args: [v],
                        setter: true,
                    });
                },
            });
            handlers.push(hookHandler);
        }
    }
    return handlers;
}
function initCanvasWebGLMutationObserver(cb, win, blockClass, blockSelector, unblockSelector, mirror) {
    const handlers = [];
    handlers.push(...patchGLPrototype(win.WebGLRenderingContext.prototype, CanvasContext.WebGL, cb, blockClass, blockSelector, unblockSelector, mirror, win));
    if (typeof win.WebGL2RenderingContext !== 'undefined') {
        handlers.push(...patchGLPrototype(win.WebGL2RenderingContext.prototype, CanvasContext.WebGL2, cb, blockClass, blockSelector, unblockSelector, mirror, win));
    }
    return () => {
        handlers.forEach((h) => h());
    };
}

class CanvasManager {
    reset() {
        this.pendingCanvasMutations.clear();
        this.resetObservers && this.resetObservers();
    }
    freeze() {
        this.frozen = true;
    }
    unfreeze() {
        this.frozen = false;
    }
    lock() {
        this.locked = true;
    }
    unlock() {
        this.locked = false;
    }
    constructor(options) {
        this.pendingCanvasMutations = new Map();
        this.rafStamps = { latestId: 0, invokeId: null };
        this.frozen = false;
        this.locked = false;
        this.processMutation = function (target, mutation) {
            const newFrame = this.rafStamps.invokeId &&
                this.rafStamps.latestId !== this.rafStamps.invokeId;
            if (newFrame || !this.rafStamps.invokeId)
                this.rafStamps.invokeId = this.rafStamps.latestId;
            if (!this.pendingCanvasMutations.has(target)) {
                this.pendingCanvasMutations.set(target, []);
            }
            this.pendingCanvasMutations.get(target).push(mutation);
        };
        this.mutationCb = options.mutationCb;
        this.mirror = options.mirror;
        if (options.recordCanvas === true)
            this.initCanvasMutationObserver(options.win, options.blockClass, options.blockSelector, options.unblockSelector);
    }
    initCanvasMutationObserver(win, blockClass, unblockSelector, blockSelector) {
        this.startRAFTimestamping();
        this.startPendingCanvasMutationFlusher();
        const canvasContextReset = initCanvasContextObserver(win, blockClass, blockSelector, unblockSelector);
        const canvas2DReset = initCanvas2DMutationObserver(this.processMutation.bind(this), win, blockClass, blockSelector, unblockSelector, this.mirror);
        const canvasWebGL1and2Reset = initCanvasWebGLMutationObserver(this.processMutation.bind(this), win, blockClass, blockSelector, unblockSelector, this.mirror);
        this.resetObservers = () => {
            canvasContextReset();
            canvas2DReset();
            canvasWebGL1and2Reset();
        };
    }
    startPendingCanvasMutationFlusher() {
        requestAnimationFrame(() => this.flushPendingCanvasMutations());
    }
    startRAFTimestamping() {
        const setLatestRAFTimestamp = (timestamp) => {
            this.rafStamps.latestId = timestamp;
            requestAnimationFrame(setLatestRAFTimestamp);
        };
        requestAnimationFrame(setLatestRAFTimestamp);
    }
    flushPendingCanvasMutations() {
        this.pendingCanvasMutations.forEach((values, canvas) => {
            const id = this.mirror.getId(canvas);
            this.flushPendingCanvasMutationFor(canvas, id);
        });
        requestAnimationFrame(() => this.flushPendingCanvasMutations());
    }
    flushPendingCanvasMutationFor(canvas, id) {
        if (this.frozen || this.locked) {
            return;
        }
        const valuesWithType = this.pendingCanvasMutations.get(canvas);
        if (!valuesWithType || id === -1)
            return;
        const values = valuesWithType.map((value) => {
            const rest = __rest(value, ["type"]);
            return rest;
        });
        const { type } = valuesWithType[0];
        this.mutationCb({ id, type, commands: values });
        this.pendingCanvasMutations.delete(canvas);
    }
}

function wrapEvent(e) {
    return Object.assign(Object.assign({}, e), { timestamp: Date.now() });
}
let wrappedEmit;
let takeFullSnapshot;
const mirror = createMirror();
function record(options = {}) {
    const { emit, checkoutEveryNms, checkoutEveryNth, blockClass = 'rr-block', blockSelector = null, unblockSelector = null, ignoreClass = 'rr-ignore', ignoreSelector = null, maskTextClass = 'rr-mask', maskTextSelector = null, maskInputSelector = null, unmaskTextSelector = null, unmaskInputSelector = null, inlineStylesheet = true, maskAllText = false, maskAllInputs, maskInputOptions: _maskInputOptions, slimDOMOptions: _slimDOMOptions, maskInputFn, maskTextFn, hooks, packFn, sampling = {}, mousemoveWait, recordCanvas = false, userTriggeredOnInput = false, collectFonts = false, inlineImages = false, plugins, keepIframeSrcFn = () => false, onMutation, } = options;
    if (!emit) {
        throw new Error('emit function is required');
    }
    if (mousemoveWait !== undefined && sampling.mousemove === undefined) {
        sampling.mousemove = mousemoveWait;
    }
    const maskInputOptions = maskAllInputs === true
        ? {
            color: true,
            date: true,
            'datetime-local': true,
            email: true,
            month: true,
            number: true,
            range: true,
            search: true,
            tel: true,
            text: true,
            time: true,
            url: true,
            week: true,
            textarea: true,
            select: true,
            radio: true,
            checkbox: true,
        }
        : _maskInputOptions !== undefined
            ? _maskInputOptions
            : {};
    const slimDOMOptions = _slimDOMOptions === true || _slimDOMOptions === 'all'
        ? {
            script: true,
            comment: true,
            headFavicon: true,
            headWhitespace: true,
            headMetaSocial: true,
            headMetaRobots: true,
            headMetaHttpEquiv: true,
            headMetaVerification: true,
            headMetaAuthorship: _slimDOMOptions === 'all',
            headMetaDescKeywords: _slimDOMOptions === 'all',
        }
        : _slimDOMOptions
            ? _slimDOMOptions
            : {};
    polyfill();
    let lastFullSnapshotEvent;
    let incrementalSnapshotCount = 0;
    const eventProcessor = (e) => {
        for (const plugin of plugins || []) {
            if (plugin.eventProcessor) {
                e = plugin.eventProcessor(e);
            }
        }
        if (packFn) {
            e = packFn(e);
        }
        return e;
    };
    wrappedEmit = (e, isCheckout) => {
        var _a;
        if (((_a = mutationBuffers[0]) === null || _a === void 0 ? void 0 : _a.isFrozen()) &&
            e.type !== EventType.FullSnapshot &&
            !(e.type === EventType.IncrementalSnapshot &&
                e.data.source === IncrementalSource.Mutation)) {
            mutationBuffers.forEach((buf) => buf.unfreeze());
        }
        emit(eventProcessor(e), isCheckout);
        if (e.type === EventType.FullSnapshot) {
            lastFullSnapshotEvent = e;
            incrementalSnapshotCount = 0;
        }
        else if (e.type === EventType.IncrementalSnapshot) {
            if (e.data.source === IncrementalSource.Mutation &&
                e.data.isAttachIframe) {
                return;
            }
            incrementalSnapshotCount++;
            const exceedCount = checkoutEveryNth && incrementalSnapshotCount >= checkoutEveryNth;
            const exceedTime = checkoutEveryNms &&
                e.timestamp - lastFullSnapshotEvent.timestamp > checkoutEveryNms;
            if (exceedCount || exceedTime) {
                takeFullSnapshot(true);
            }
        }
    };
    const wrappedMutationEmit = (m) => {
        wrappedEmit(wrapEvent({
            type: EventType.IncrementalSnapshot,
            data: Object.assign({ source: IncrementalSource.Mutation }, m),
        }));
    };
    const wrappedScrollEmit = (p) => wrappedEmit(wrapEvent({
        type: EventType.IncrementalSnapshot,
        data: Object.assign({ source: IncrementalSource.Scroll }, p),
    }));
    const wrappedCanvasMutationEmit = (p) => wrappedEmit(wrapEvent({
        type: EventType.IncrementalSnapshot,
        data: Object.assign({ source: IncrementalSource.CanvasMutation }, p),
    }));
    const iframeManager = new IframeManager({
        mutationCb: wrappedMutationEmit,
    });
    const canvasManager = new CanvasManager({
        recordCanvas,
        mutationCb: wrappedCanvasMutationEmit,
        win: window,
        blockClass,
        blockSelector,
        unblockSelector,
        mirror,
    });
    const shadowDomManager = new ShadowDomManager({
        mutationCb: wrappedMutationEmit,
        scrollCb: wrappedScrollEmit,
        bypassOptions: {
            onMutation,
            blockClass,
            blockSelector,
            unblockSelector,
            maskTextClass,
            maskTextSelector,
            unmaskTextSelector,
            maskInputSelector,
            unmaskInputSelector,
            inlineStylesheet,
            maskAllText,
            maskInputOptions,
            maskTextFn,
            maskInputFn,
            recordCanvas,
            inlineImages,
            sampling,
            slimDOMOptions,
            iframeManager,
            canvasManager,
        },
        mirror,
    });
    takeFullSnapshot = (isCheckout = false) => {
        var _a, _b, _c, _d;
        wrappedEmit(wrapEvent({
            type: EventType.Meta,
            data: {
                href: window.location.href,
                width: getWindowWidth(),
                height: getWindowHeight(),
            },
        }), isCheckout);
        mutationBuffers.forEach((buf) => buf.lock());
        const [node, idNodeMap] = snapshot(document, {
            blockClass,
            blockSelector,
            unblockSelector,
            maskTextClass,
            maskTextSelector,
            unmaskTextSelector,
            maskInputSelector,
            unmaskInputSelector,
            inlineStylesheet,
            maskAllText,
            maskAllInputs: maskInputOptions,
            maskTextFn,
            slimDOM: slimDOMOptions,
            recordCanvas,
            inlineImages,
            onSerialize: (n) => {
                if (isIframeINode(n)) {
                    iframeManager.addIframe(n);
                }
                if (hasShadowRoot(n)) {
                    shadowDomManager.addShadowRoot(n.shadowRoot, document);
                }
            },
            onIframeLoad: (iframe, childSn) => {
                iframeManager.attachIframe(iframe, childSn);
                shadowDomManager.observeAttachShadow(iframe);
            },
            keepIframeSrcFn,
        });
        if (!node) {
            return console.warn('Failed to snapshot the document');
        }
        mirror.map = idNodeMap;
        wrappedEmit(wrapEvent({
            type: EventType.FullSnapshot,
            data: {
                node,
                initialOffset: {
                    left: window.pageXOffset !== undefined
                        ? window.pageXOffset
                        : (document === null || document === void 0 ? void 0 : document.documentElement.scrollLeft) ||
                            ((_b = (_a = document === null || document === void 0 ? void 0 : document.body) === null || _a === void 0 ? void 0 : _a.parentElement) === null || _b === void 0 ? void 0 : _b.scrollLeft) ||
                            (document === null || document === void 0 ? void 0 : document.body.scrollLeft) ||
                            0,
                    top: window.pageYOffset !== undefined
                        ? window.pageYOffset
                        : (document === null || document === void 0 ? void 0 : document.documentElement.scrollTop) ||
                            ((_d = (_c = document === null || document === void 0 ? void 0 : document.body) === null || _c === void 0 ? void 0 : _c.parentElement) === null || _d === void 0 ? void 0 : _d.scrollTop) ||
                            (document === null || document === void 0 ? void 0 : document.body.scrollTop) ||
                            0,
                },
            },
        }));
        mutationBuffers.forEach((buf) => buf.unlock());
    };
    try {
        const handlers = [];
        handlers.push(on('DOMContentLoaded', () => {
            wrappedEmit(wrapEvent({
                type: EventType.DomContentLoaded,
                data: {},
            }));
        }));
        const observe = (doc) => {
            var _a;
            return callbackWrapper(initObservers)({
                onMutation,
                mutationCb: wrappedMutationEmit,
                mousemoveCb: (positions, source) => wrappedEmit(wrapEvent({
                    type: EventType.IncrementalSnapshot,
                    data: {
                        source,
                        positions,
                    },
                })),
                mouseInteractionCb: (d) => wrappedEmit(wrapEvent({
                    type: EventType.IncrementalSnapshot,
                    data: Object.assign({ source: IncrementalSource.MouseInteraction }, d),
                })),
                scrollCb: wrappedScrollEmit,
                viewportResizeCb: (d) => wrappedEmit(wrapEvent({
                    type: EventType.IncrementalSnapshot,
                    data: Object.assign({ source: IncrementalSource.ViewportResize }, d),
                })),
                inputCb: (v) => wrappedEmit(wrapEvent({
                    type: EventType.IncrementalSnapshot,
                    data: Object.assign({ source: IncrementalSource.Input }, v),
                })),
                mediaInteractionCb: (p) => wrappedEmit(wrapEvent({
                    type: EventType.IncrementalSnapshot,
                    data: Object.assign({ source: IncrementalSource.MediaInteraction }, p),
                })),
                styleSheetRuleCb: (r) => wrappedEmit(wrapEvent({
                    type: EventType.IncrementalSnapshot,
                    data: Object.assign({ source: IncrementalSource.StyleSheetRule }, r),
                })),
                styleDeclarationCb: (r) => wrappedEmit(wrapEvent({
                    type: EventType.IncrementalSnapshot,
                    data: Object.assign({ source: IncrementalSource.StyleDeclaration }, r),
                })),
                canvasMutationCb: wrappedCanvasMutationEmit,
                fontCb: (p) => wrappedEmit(wrapEvent({
                    type: EventType.IncrementalSnapshot,
                    data: Object.assign({ source: IncrementalSource.Font }, p),
                })),
                blockClass,
                ignoreClass,
                ignoreSelector,
                maskTextClass,
                maskTextSelector,
                unmaskTextSelector,
                maskInputSelector,
                unmaskInputSelector,
                maskInputOptions,
                inlineStylesheet,
                sampling,
                recordCanvas,
                inlineImages,
                userTriggeredOnInput,
                collectFonts,
                doc,
                maskAllText,
                maskInputFn,
                maskTextFn,
                blockSelector,
                unblockSelector,
                slimDOMOptions,
                mirror,
                iframeManager,
                shadowDomManager,
                canvasManager,
                plugins: ((_a = plugins === null || plugins === void 0 ? void 0 : plugins.filter((p) => p.observer)) === null || _a === void 0 ? void 0 : _a.map((p) => ({
                    observer: p.observer,
                    options: p.options,
                    callback: (payload) => wrappedEmit(wrapEvent({
                        type: EventType.Plugin,
                        data: {
                            plugin: p.name,
                            payload,
                        },
                    })),
                }))) || [],
            }, hooks);
        };
        iframeManager.addLoadListener((iframeEl) => {
            try {
                handlers.push(observe(iframeEl.contentDocument));
            }
            catch (error) {
                console.warn(error);
            }
        });
        const init = () => {
            takeFullSnapshot();
            handlers.push(observe(document));
        };
        if (document.readyState === 'interactive' ||
            document.readyState === 'complete') {
            init();
        }
        else {
            handlers.push(on('load', () => {
                wrappedEmit(wrapEvent({
                    type: EventType.Load,
                    data: {},
                }));
                init();
            }, window));
        }
        return () => {
            handlers.forEach((h) => h());
        };
    }
    catch (error) {
        console.warn(error);
    }
}
record.addCustomEvent = (tag, payload) => {
    if (!wrappedEmit) {
        throw new Error('please add custom event after start recording');
    }
    wrappedEmit(wrapEvent({
        type: EventType.Custom,
        data: {
            tag,
            payload,
        },
    }));
};
record.freezePage = () => {
    mutationBuffers.forEach((buf) => buf.freeze());
};
record.takeFullSnapshot = (isCheckout) => {
    if (!takeFullSnapshot) {
        throw new Error('please take full snapshot after start recording');
    }
    takeFullSnapshot(isCheckout);
};
record.mirror = mirror;

/**
 * Add a breadcrumb event to replay.
 */
function addBreadcrumbEvent(replay, breadcrumb) {
  if (breadcrumb.category === 'sentry.transaction') {
    return;
  }

  if (['ui.click', 'ui.input'].includes(breadcrumb.category )) {
    replay.triggerUserActivity();
  } else {
    replay.checkAndHandleExpiredSession();
  }

  replay.addUpdate(() => {
    void replay.throttledAddEvent({
      type: EventType.Custom,
      // TODO: We were converting from ms to seconds for breadcrumbs, spans,
      // but maybe we should just keep them as milliseconds
      timestamp: (breadcrumb.timestamp || 0) * 1000,
      data: {
        tag: 'breadcrumb',
        // normalize to max. 10 depth and 1_000 properties per object
        payload: (0,normalize/* normalize */.Fv)(breadcrumb, 10, 1000),
      },
    });

    // Do not flush after console log messages
    return breadcrumb.category === 'console';
  });
}

const INTERACTIVE_SELECTOR = 'button,a';

/**
 * For clicks, we check if the target is inside of a button or link
 * If so, we use this as the target instead
 * This is useful because if you click on the image in <button><img></button>,
 * The target will be the image, not the button, which we don't want here
 */
function getClickTargetNode(event) {
  const target = getTargetNode(event);

  if (!target || !(target instanceof Element)) {
    return target;
  }

  const closestInteractive = target.closest(INTERACTIVE_SELECTOR);
  return closestInteractive || target;
}

/** Get the event target node. */
function getTargetNode(event) {
  if (isEventWithTarget(event)) {
    return event.target ;
  }

  return event;
}

function isEventWithTarget(event) {
  return typeof event === 'object' && !!event && 'target' in event;
}

let handlers;

/**
 * Register a handler to be called when `window.open()` is called.
 * Returns a cleanup function.
 */
function onWindowOpen(cb) {
  // Ensure to only register this once
  if (!handlers) {
    handlers = [];
    monkeyPatchWindowOpen();
  }

  handlers.push(cb);

  return () => {
    const pos = handlers ? handlers.indexOf(cb) : -1;
    if (pos > -1) {
      (handlers ).splice(pos, 1);
    }
  };
}

function monkeyPatchWindowOpen() {
  (0,object/* fill */.hl)(esm_WINDOW, 'open', function (originalWindowOpen) {
    return function (...args) {
      if (handlers) {
        try {
          handlers.forEach(handler => handler());
        } catch (e) {
          // ignore errors in here
        }
      }

      return originalWindowOpen.apply(esm_WINDOW, args);
    };
  });
}

/** Handle a click. */
function handleClick(clickDetector, clickBreadcrumb, node) {
  clickDetector.handleClick(clickBreadcrumb, node);
}

/** A click detector class that can be used to detect slow or rage clicks on elements. */
class ClickDetector  {
  // protected for testing
   __init() {this._lastMutation = 0;}
   __init2() {this._lastScroll = 0;}

   __init3() {this._clicks = [];}

   constructor(
    replay,
    slowClickConfig,
    // Just for easier testing
    _addBreadcrumbEvent = addBreadcrumbEvent,
  ) {ClickDetector.prototype.__init.call(this);ClickDetector.prototype.__init2.call(this);ClickDetector.prototype.__init3.call(this);
    // We want everything in s, but options are in ms
    this._timeout = slowClickConfig.timeout / 1000;
    this._multiClickTimeout = slowClickConfig.multiClickTimeout / 1000;
    this._threshold = slowClickConfig.threshold / 1000;
    this._scollTimeout = slowClickConfig.scrollTimeout / 1000;
    this._replay = replay;
    this._ignoreSelector = slowClickConfig.ignoreSelector;
    this._addBreadcrumbEvent = _addBreadcrumbEvent;
  }

  /** Register click detection handlers on mutation or scroll. */
   addListeners() {
    const mutationHandler = () => {
      this._lastMutation = nowInSeconds();
    };

    const scrollHandler = () => {
      this._lastScroll = nowInSeconds();
    };

    const cleanupWindowOpen = onWindowOpen(() => {
      // Treat window.open as mutation
      this._lastMutation = nowInSeconds();
    });

    const clickHandler = (event) => {
      if (!event.target) {
        return;
      }

      const node = getClickTargetNode(event);
      if (node) {
        this._handleMultiClick(node );
      }
    };

    const obs = new MutationObserver(mutationHandler);

    obs.observe(esm_WINDOW.document.documentElement, {
      attributes: true,
      characterData: true,
      childList: true,
      subtree: true,
    });

    esm_WINDOW.addEventListener('scroll', scrollHandler, { passive: true });
    esm_WINDOW.addEventListener('click', clickHandler, { passive: true });

    this._teardown = () => {
      esm_WINDOW.removeEventListener('scroll', scrollHandler);
      esm_WINDOW.removeEventListener('click', clickHandler);
      cleanupWindowOpen();

      obs.disconnect();
      this._clicks = [];
      this._lastMutation = 0;
      this._lastScroll = 0;
    };
  }

  /** Clean up listeners. */
   removeListeners() {
    if (this._teardown) {
      this._teardown();
    }

    if (this._checkClickTimeout) {
      clearTimeout(this._checkClickTimeout);
    }
  }

  /** Handle a click */
   handleClick(breadcrumb, node) {
    if (ignoreElement(node, this._ignoreSelector) || !isClickBreadcrumb(breadcrumb)) {
      return;
    }

    const click = this._getClick(node);

    if (click) {
      // this means a click on the same element was captured in the last 1s, so we consider this a multi click
      return;
    }

    const newClick = {
      timestamp: breadcrumb.timestamp,
      clickBreadcrumb: breadcrumb,
      // Set this to 0 so we know it originates from the click breadcrumb
      clickCount: 0,
      node,
    };
    this._clicks.push(newClick);

    // If this is the first new click, set a timeout to check for multi clicks
    if (this._clicks.length === 1) {
      this._scheduleCheckClicks();
    }
  }

  /** Count multiple clicks on elements. */
   _handleMultiClick(node) {
    const click = this._getClick(node);

    if (!click) {
      return;
    }

    click.clickCount++;
  }

  /** Try to get an existing click on the given element. */
   _getClick(node) {
    const now = nowInSeconds();

    // Find any click on the same element in the last second
    // If one exists, we consider this click as a double/triple/etc click
    return this._clicks.find(click => click.node === node && now - click.timestamp < this._multiClickTimeout);
  }

  /** Check the clicks that happened. */
   _checkClicks() {
    const timedOutClicks = [];

    const now = nowInSeconds();

    this._clicks.forEach(click => {
      if (!click.mutationAfter && this._lastMutation) {
        click.mutationAfter = click.timestamp <= this._lastMutation ? this._lastMutation - click.timestamp : undefined;
      }
      if (!click.scrollAfter && this._lastScroll) {
        click.scrollAfter = click.timestamp <= this._lastScroll ? this._lastScroll - click.timestamp : undefined;
      }

      // If an action happens after the multi click threshold, we can skip waiting and handle the click right away
      const actionTime = click.scrollAfter || click.mutationAfter || 0;
      if (actionTime && actionTime >= this._multiClickTimeout) {
        timedOutClicks.push(click);
        return;
      }

      if (click.timestamp + this._timeout <= now) {
        timedOutClicks.push(click);
      }
    });

    // Remove "old" clicks
    for (const click of timedOutClicks) {
      this._generateBreadcrumbs(click);

      const pos = this._clicks.indexOf(click);
      if (pos !== -1) {
        this._clicks.splice(pos, 1);
      }
    }

    // Trigger new check, unless no clicks left
    if (this._clicks.length) {
      this._scheduleCheckClicks();
    }
  }

  /** Generate matching breadcrumb(s) for the click. */
   _generateBreadcrumbs(click) {
    const replay = this._replay;
    const hadScroll = click.scrollAfter && click.scrollAfter <= this._scollTimeout;
    const hadMutation = click.mutationAfter && click.mutationAfter <= this._threshold;

    const isSlowClick = !hadScroll && !hadMutation;
    const { clickCount, clickBreadcrumb } = click;

    // Slow click
    if (isSlowClick) {
      // If `mutationAfter` is set, it means a mutation happened after the threshold, but before the timeout
      // If not, it means we just timed out without scroll & mutation
      const timeAfterClickMs = Math.min(click.mutationAfter || this._timeout, this._timeout) * 1000;
      const endReason = timeAfterClickMs < this._timeout * 1000 ? 'mutation' : 'timeout';

      const breadcrumb = {
        type: 'default',
        message: clickBreadcrumb.message,
        timestamp: clickBreadcrumb.timestamp,
        category: 'ui.slowClickDetected',
        data: {
          ...clickBreadcrumb.data,
          url: esm_WINDOW.location.href,
          route: replay.getCurrentRoute(),
          timeAfterClickMs,
          endReason,
          // If clickCount === 0, it means multiClick was not correctly captured here
          // - we still want to send 1 in this case
          clickCount: clickCount || 1,
        },
      };

      this._addBreadcrumbEvent(replay, breadcrumb);
      return;
    }

    // Multi click
    if (clickCount > 1) {
      const breadcrumb = {
        type: 'default',
        message: clickBreadcrumb.message,
        timestamp: clickBreadcrumb.timestamp,
        category: 'ui.multiClick',
        data: {
          ...clickBreadcrumb.data,
          url: esm_WINDOW.location.href,
          route: replay.getCurrentRoute(),
          clickCount,
          metric: true,
        },
      };

      this._addBreadcrumbEvent(replay, breadcrumb);
    }
  }

  /** Schedule to check current clicks. */
   _scheduleCheckClicks() {
    this._checkClickTimeout = setTimeout(() => this._checkClicks(), 1000);
  }
}

const SLOW_CLICK_TAGS = ['A', 'BUTTON', 'INPUT'];

/** exported for tests only */
function ignoreElement(node, ignoreSelector) {
  if (!SLOW_CLICK_TAGS.includes(node.tagName)) {
    return true;
  }

  // If <input> tag, we only want to consider input[type='submit'] & input[type='button']
  if (node.tagName === 'INPUT' && !['submit', 'button'].includes(node.getAttribute('type') || '')) {
    return true;
  }

  // If <a> tag, detect special variants that may not lead to an action
  // If target !== _self, we may open the link somewhere else, which would lead to no action
  // Also, when downloading a file, we may not leave the page, but still not trigger an action
  if (
    node.tagName === 'A' &&
    (node.hasAttribute('download') || (node.hasAttribute('target') && node.getAttribute('target') !== '_self'))
  ) {
    return true;
  }

  if (ignoreSelector && node.matches(ignoreSelector)) {
    return true;
  }

  return false;
}

function isClickBreadcrumb(breadcrumb) {
  return !!(breadcrumb.data && typeof breadcrumb.data.nodeId === 'number' && breadcrumb.timestamp);
}

// This is good enough for us, and is easier to test/mock than `timestampInSeconds`
function nowInSeconds() {
  return Date.now() / 1000;
}

/**
 * Create a breadcrumb for a replay.
 */
function createBreadcrumb(
  breadcrumb,
) {
  return {
    timestamp: Date.now() / 1000,
    type: 'default',
    ...breadcrumb,
  };
}

var NodeType;
(function (NodeType) {
    NodeType[NodeType["Document"] = 0] = "Document";
    NodeType[NodeType["DocumentType"] = 1] = "DocumentType";
    NodeType[NodeType["Element"] = 2] = "Element";
    NodeType[NodeType["Text"] = 3] = "Text";
    NodeType[NodeType["CDATA"] = 4] = "CDATA";
    NodeType[NodeType["Comment"] = 5] = "Comment";
})(NodeType || (NodeType = {}));

// Note that these are the serialized attributes and not attributes directly on
// the DOM Node. Attributes we are interested in:
const ATTRIBUTES_TO_RECORD = new Set([
  'id',
  'class',
  'aria-label',
  'role',
  'name',
  'alt',
  'title',
  'data-test-id',
  'data-testid',
  'disabled',
  'aria-disabled',
]);

/**
 * Inclusion list of attributes that we want to record from the DOM element
 */
function getAttributesToRecord(attributes) {
  const obj = {};
  for (const key in attributes) {
    if (ATTRIBUTES_TO_RECORD.has(key)) {
      let normalizedKey = key;

      if (key === 'data-testid' || key === 'data-test-id') {
        normalizedKey = 'testId';
      }

      obj[normalizedKey] = attributes[key];
    }
  }

  return obj;
}

const handleDomListener = (
  replay,
) => {
  return (handlerData) => {
    if (!replay.isEnabled()) {
      return;
    }

    const result = handleDom(handlerData);

    if (!result) {
      return;
    }

    const isClick = handlerData.name === 'click';
    const event = isClick && (handlerData.event );
    // Ignore clicks if ctrl/alt/meta keys are held down as they alter behavior of clicks (e.g. open in new tab)
    if (isClick && replay.clickDetector && event && !event.altKey && !event.metaKey && !event.ctrlKey) {
      handleClick(
        replay.clickDetector,
        result ,
        getClickTargetNode(handlerData.event) ,
      );
    }

    addBreadcrumbEvent(replay, result);
  };
};

/** Get the base DOM breadcrumb. */
function getBaseDomBreadcrumb(target, message) {
  // `__sn` property is the serialized node created by rrweb
  const serializedNode = target && isRrwebNode(target) && target.__sn.type === NodeType.Element ? target.__sn : null;

  return {
    message,
    data: serializedNode
      ? {
          nodeId: serializedNode.id,
          node: {
            id: serializedNode.id,
            tagName: serializedNode.tagName,
            textContent: target
              ? Array.from(target.childNodes)
                  .map(
                    (node) => '__sn' in node && node.__sn.type === NodeType.Text && node.__sn.textContent,
                  )
                  .filter(Boolean) // filter out empty values
                  .map(text => (text ).trim())
                  .join('')
              : '',
            attributes: getAttributesToRecord(serializedNode.attributes),
          },
        }
      : {},
  };
}

/**
 * An event handler to react to DOM events.
 * Exported for tests.
 */
function handleDom(handlerData) {
  const { target, message } = getDomTarget(handlerData);

  return createBreadcrumb({
    category: `ui.${handlerData.name}`,
    ...getBaseDomBreadcrumb(target, message),
  });
}

function getDomTarget(handlerData) {
  const isClick = handlerData.name === 'click';

  let message;
  let target = null;

  // Accessing event.target can throw (see getsentry/raven-js#838, #768)
  try {
    target = isClick ? getClickTargetNode(handlerData.event) : getTargetNode(handlerData.event);
    message = (0,browser/* htmlTreeAsString */.Rt)(target, { maxStringLength: 200 }) || '<unknown>';
  } catch (e) {
    message = '<unknown>';
  }

  return { target, message };
}

function isRrwebNode(node) {
  return '__sn' in node;
}

/** Handle keyboard events & create breadcrumbs. */
function handleKeyboardEvent(replay, event) {
  if (!replay.isEnabled()) {
    return;
  }

  // Update user activity, but do not restart recording as it can create
  // noisy/low-value replays (e.g. user comes back from idle, hits alt-tab, new
  // session with a single "keydown" breadcrumb is created)
  replay.updateUserActivity();

  const breadcrumb = getKeyboardBreadcrumb(event);

  if (!breadcrumb) {
    return;
  }

  addBreadcrumbEvent(replay, breadcrumb);
}

/** exported only for tests */
function getKeyboardBreadcrumb(event) {
  const { metaKey, shiftKey, ctrlKey, altKey, key, target } = event;

  // never capture for input fields
  if (!target || isInputElement(target ) || !key) {
    return null;
  }

  // Note: We do not consider shift here, as that means "uppercase"
  const hasModifierKey = metaKey || ctrlKey || altKey;
  const isCharacterKey = key.length === 1; // other keys like Escape, Tab, etc have a longer length

  // Do not capture breadcrumb if only a word key is pressed
  // This could leak e.g. user input
  if (!hasModifierKey && isCharacterKey) {
    return null;
  }

  const message = (0,browser/* htmlTreeAsString */.Rt)(target, { maxStringLength: 200 }) || '<unknown>';
  const baseBreadcrumb = getBaseDomBreadcrumb(target , message);

  return createBreadcrumb({
    category: 'ui.keyDown',
    message,
    data: {
      ...baseBreadcrumb.data,
      metaKey,
      shiftKey,
      ctrlKey,
      altKey,
      key,
    },
  });
}

function isInputElement(target) {
  return target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable;
}

const NAVIGATION_ENTRY_KEYS = [
  'name',
  'type',
  'startTime',
  'transferSize',
  'duration',
];

function isNavigationEntryEqual(a) {
  return function (b) {
    return NAVIGATION_ENTRY_KEYS.every(key => a[key] === b[key]);
  };
}

/**
 * There are some difficulties diagnosing why there are duplicate navigation
 * entries. We've witnessed several intermittent results:
 * - duplicate entries have duration = 0
 * - duplicate entries are the same object reference
 * - none of the above
 *
 * Compare the values of several keys to determine if the entries are duplicates or not.
 */
// TODO (high-prio): Figure out wth is returned here
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function dedupePerformanceEntries(
  currentList,
  newList,
) {
  // Partition `currentList` into 3 different lists based on entryType
  const [existingNavigationEntries, existingLcpEntries, existingEntries] = currentList.reduce(
    (acc, entry) => {
      if (entry.entryType === 'navigation') {
        acc[0].push(entry );
      } else if (entry.entryType === 'largest-contentful-paint') {
        acc[1].push(entry );
      } else {
        acc[2].push(entry);
      }
      return acc;
    },
    [[], [], []],
  );

  const newEntries = [];
  const newNavigationEntries = [];
  let newLcpEntry = existingLcpEntries.length
    ? existingLcpEntries[existingLcpEntries.length - 1] // Take the last element as list is sorted
    : undefined;

  newList.forEach(entry => {
    if (entry.entryType === 'largest-contentful-paint') {
      // We want the latest LCP event only
      if (!newLcpEntry || newLcpEntry.startTime < entry.startTime) {
        newLcpEntry = entry;
      }
      return;
    }

    if (entry.entryType === 'navigation') {
      const navigationEntry = entry ;

      // Check if the navigation entry is contained in currentList or newList
      if (
        // Ignore any navigation entries with duration 0, as they are likely duplicates
        entry.duration > 0 &&
        // Ensure new entry does not already exist in existing entries
        !existingNavigationEntries.find(isNavigationEntryEqual(navigationEntry)) &&
        // Ensure new entry does not already exist in new list of navigation entries
        !newNavigationEntries.find(isNavigationEntryEqual(navigationEntry))
      ) {
        newNavigationEntries.push(navigationEntry);
      }

      // Otherwise this navigation entry is considered a duplicate and is thrown away
      return;
    }

    newEntries.push(entry);
  });

  // Re-combine and sort by startTime
  return [
    ...(newLcpEntry ? [newLcpEntry] : []),
    ...existingNavigationEntries,
    ...existingEntries,
    ...newEntries,
    ...newNavigationEntries,
  ].sort((a, b) => a.startTime - b.startTime);
}

/**
 * Sets up a PerformanceObserver to listen to all performance entry types.
 */
function setupPerformanceObserver(replay) {
  const performanceObserverHandler = (list) => {
    // For whatever reason the observer was returning duplicate navigation
    // entries (the other entry types were not duplicated).
    const newPerformanceEntries = dedupePerformanceEntries(
      replay.performanceEvents,
      list.getEntries() ,
    );
    replay.performanceEvents = newPerformanceEntries;
  };

  const performanceObserver = new PerformanceObserver(performanceObserverHandler);

  [
    'element',
    'event',
    'first-input',
    'largest-contentful-paint',
    'layout-shift',
    'longtask',
    'navigation',
    'paint',
    'resource',
  ].forEach(type => {
    try {
      performanceObserver.observe({
        type,
        buffered: true,
      });
    } catch (e) {
      // This can throw if an entry type is not supported in the browser.
      // Ignore these errors.
    }
  });

  return performanceObserver;
}

const r = `/*! pako 2.1.0 https://github.com/nodeca/pako @license (MIT AND Zlib) */
function t(t){let e=t.length;for(;--e>=0;)t[e]=0}const e=new Uint8Array([0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0]),a=new Uint8Array([0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13]),i=new Uint8Array([0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7]),n=new Uint8Array([16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15]),s=new Array(576);t(s);const r=new Array(60);t(r);const o=new Array(512);t(o);const l=new Array(256);t(l);const h=new Array(29);t(h);const d=new Array(30);function _(t,e,a,i,n){this.static_tree=t,this.extra_bits=e,this.extra_base=a,this.elems=i,this.max_length=n,this.has_stree=t&&t.length}let f,c,u;function w(t,e){this.dyn_tree=t,this.max_code=0,this.stat_desc=e}t(d);const m=t=>t<256?o[t]:o[256+(t>>>7)],b=(t,e)=>{t.pending_buf[t.pending++]=255&e,t.pending_buf[t.pending++]=e>>>8&255},g=(t,e,a)=>{t.bi_valid>16-a?(t.bi_buf|=e<<t.bi_valid&65535,b(t,t.bi_buf),t.bi_buf=e>>16-t.bi_valid,t.bi_valid+=a-16):(t.bi_buf|=e<<t.bi_valid&65535,t.bi_valid+=a)},p=(t,e,a)=>{g(t,a[2*e],a[2*e+1])},k=(t,e)=>{let a=0;do{a|=1&t,t>>>=1,a<<=1}while(--e>0);return a>>>1},v=(t,e,a)=>{const i=new Array(16);let n,s,r=0;for(n=1;n<=15;n++)r=r+a[n-1]<<1,i[n]=r;for(s=0;s<=e;s++){let e=t[2*s+1];0!==e&&(t[2*s]=k(i[e]++,e))}},y=t=>{let e;for(e=0;e<286;e++)t.dyn_ltree[2*e]=0;for(e=0;e<30;e++)t.dyn_dtree[2*e]=0;for(e=0;e<19;e++)t.bl_tree[2*e]=0;t.dyn_ltree[512]=1,t.opt_len=t.static_len=0,t.sym_next=t.matches=0},x=t=>{t.bi_valid>8?b(t,t.bi_buf):t.bi_valid>0&&(t.pending_buf[t.pending++]=t.bi_buf),t.bi_buf=0,t.bi_valid=0},z=(t,e,a,i)=>{const n=2*e,s=2*a;return t[n]<t[s]||t[n]===t[s]&&i[e]<=i[a]},A=(t,e,a)=>{const i=t.heap[a];let n=a<<1;for(;n<=t.heap_len&&(n<t.heap_len&&z(e,t.heap[n+1],t.heap[n],t.depth)&&n++,!z(e,i,t.heap[n],t.depth));)t.heap[a]=t.heap[n],a=n,n<<=1;t.heap[a]=i},E=(t,i,n)=>{let s,r,o,_,f=0;if(0!==t.sym_next)do{s=255&t.pending_buf[t.sym_buf+f++],s+=(255&t.pending_buf[t.sym_buf+f++])<<8,r=t.pending_buf[t.sym_buf+f++],0===s?p(t,r,i):(o=l[r],p(t,o+256+1,i),_=e[o],0!==_&&(r-=h[o],g(t,r,_)),s--,o=m(s),p(t,o,n),_=a[o],0!==_&&(s-=d[o],g(t,s,_)))}while(f<t.sym_next);p(t,256,i)},R=(t,e)=>{const a=e.dyn_tree,i=e.stat_desc.static_tree,n=e.stat_desc.has_stree,s=e.stat_desc.elems;let r,o,l,h=-1;for(t.heap_len=0,t.heap_max=573,r=0;r<s;r++)0!==a[2*r]?(t.heap[++t.heap_len]=h=r,t.depth[r]=0):a[2*r+1]=0;for(;t.heap_len<2;)l=t.heap[++t.heap_len]=h<2?++h:0,a[2*l]=1,t.depth[l]=0,t.opt_len--,n&&(t.static_len-=i[2*l+1]);for(e.max_code=h,r=t.heap_len>>1;r>=1;r--)A(t,a,r);l=s;do{r=t.heap[1],t.heap[1]=t.heap[t.heap_len--],A(t,a,1),o=t.heap[1],t.heap[--t.heap_max]=r,t.heap[--t.heap_max]=o,a[2*l]=a[2*r]+a[2*o],t.depth[l]=(t.depth[r]>=t.depth[o]?t.depth[r]:t.depth[o])+1,a[2*r+1]=a[2*o+1]=l,t.heap[1]=l++,A(t,a,1)}while(t.heap_len>=2);t.heap[--t.heap_max]=t.heap[1],((t,e)=>{const a=e.dyn_tree,i=e.max_code,n=e.stat_desc.static_tree,s=e.stat_desc.has_stree,r=e.stat_desc.extra_bits,o=e.stat_desc.extra_base,l=e.stat_desc.max_length;let h,d,_,f,c,u,w=0;for(f=0;f<=15;f++)t.bl_count[f]=0;for(a[2*t.heap[t.heap_max]+1]=0,h=t.heap_max+1;h<573;h++)d=t.heap[h],f=a[2*a[2*d+1]+1]+1,f>l&&(f=l,w++),a[2*d+1]=f,d>i||(t.bl_count[f]++,c=0,d>=o&&(c=r[d-o]),u=a[2*d],t.opt_len+=u*(f+c),s&&(t.static_len+=u*(n[2*d+1]+c)));if(0!==w){do{for(f=l-1;0===t.bl_count[f];)f--;t.bl_count[f]--,t.bl_count[f+1]+=2,t.bl_count[l]--,w-=2}while(w>0);for(f=l;0!==f;f--)for(d=t.bl_count[f];0!==d;)_=t.heap[--h],_>i||(a[2*_+1]!==f&&(t.opt_len+=(f-a[2*_+1])*a[2*_],a[2*_+1]=f),d--)}})(t,e),v(a,h,t.bl_count)},Z=(t,e,a)=>{let i,n,s=-1,r=e[1],o=0,l=7,h=4;for(0===r&&(l=138,h=3),e[2*(a+1)+1]=65535,i=0;i<=a;i++)n=r,r=e[2*(i+1)+1],++o<l&&n===r||(o<h?t.bl_tree[2*n]+=o:0!==n?(n!==s&&t.bl_tree[2*n]++,t.bl_tree[32]++):o<=10?t.bl_tree[34]++:t.bl_tree[36]++,o=0,s=n,0===r?(l=138,h=3):n===r?(l=6,h=3):(l=7,h=4))},U=(t,e,a)=>{let i,n,s=-1,r=e[1],o=0,l=7,h=4;for(0===r&&(l=138,h=3),i=0;i<=a;i++)if(n=r,r=e[2*(i+1)+1],!(++o<l&&n===r)){if(o<h)do{p(t,n,t.bl_tree)}while(0!=--o);else 0!==n?(n!==s&&(p(t,n,t.bl_tree),o--),p(t,16,t.bl_tree),g(t,o-3,2)):o<=10?(p(t,17,t.bl_tree),g(t,o-3,3)):(p(t,18,t.bl_tree),g(t,o-11,7));o=0,s=n,0===r?(l=138,h=3):n===r?(l=6,h=3):(l=7,h=4)}};let S=!1;const D=(t,e,a,i)=>{g(t,0+(i?1:0),3),x(t),b(t,a),b(t,~a),a&&t.pending_buf.set(t.window.subarray(e,e+a),t.pending),t.pending+=a};var T=(t,e,a,i)=>{let o,l,h=0;t.level>0?(2===t.strm.data_type&&(t.strm.data_type=(t=>{let e,a=4093624447;for(e=0;e<=31;e++,a>>>=1)if(1&a&&0!==t.dyn_ltree[2*e])return 0;if(0!==t.dyn_ltree[18]||0!==t.dyn_ltree[20]||0!==t.dyn_ltree[26])return 1;for(e=32;e<256;e++)if(0!==t.dyn_ltree[2*e])return 1;return 0})(t)),R(t,t.l_desc),R(t,t.d_desc),h=(t=>{let e;for(Z(t,t.dyn_ltree,t.l_desc.max_code),Z(t,t.dyn_dtree,t.d_desc.max_code),R(t,t.bl_desc),e=18;e>=3&&0===t.bl_tree[2*n[e]+1];e--);return t.opt_len+=3*(e+1)+5+5+4,e})(t),o=t.opt_len+3+7>>>3,l=t.static_len+3+7>>>3,l<=o&&(o=l)):o=l=a+5,a+4<=o&&-1!==e?D(t,e,a,i):4===t.strategy||l===o?(g(t,2+(i?1:0),3),E(t,s,r)):(g(t,4+(i?1:0),3),((t,e,a,i)=>{let s;for(g(t,e-257,5),g(t,a-1,5),g(t,i-4,4),s=0;s<i;s++)g(t,t.bl_tree[2*n[s]+1],3);U(t,t.dyn_ltree,e-1),U(t,t.dyn_dtree,a-1)})(t,t.l_desc.max_code+1,t.d_desc.max_code+1,h+1),E(t,t.dyn_ltree,t.dyn_dtree)),y(t),i&&x(t)},O={_tr_init:t=>{S||((()=>{let t,n,w,m,b;const g=new Array(16);for(w=0,m=0;m<28;m++)for(h[m]=w,t=0;t<1<<e[m];t++)l[w++]=m;for(l[w-1]=m,b=0,m=0;m<16;m++)for(d[m]=b,t=0;t<1<<a[m];t++)o[b++]=m;for(b>>=7;m<30;m++)for(d[m]=b<<7,t=0;t<1<<a[m]-7;t++)o[256+b++]=m;for(n=0;n<=15;n++)g[n]=0;for(t=0;t<=143;)s[2*t+1]=8,t++,g[8]++;for(;t<=255;)s[2*t+1]=9,t++,g[9]++;for(;t<=279;)s[2*t+1]=7,t++,g[7]++;for(;t<=287;)s[2*t+1]=8,t++,g[8]++;for(v(s,287,g),t=0;t<30;t++)r[2*t+1]=5,r[2*t]=k(t,5);f=new _(s,e,257,286,15),c=new _(r,a,0,30,15),u=new _(new Array(0),i,0,19,7)})(),S=!0),t.l_desc=new w(t.dyn_ltree,f),t.d_desc=new w(t.dyn_dtree,c),t.bl_desc=new w(t.bl_tree,u),t.bi_buf=0,t.bi_valid=0,y(t)},_tr_stored_block:D,_tr_flush_block:T,_tr_tally:(t,e,a)=>(t.pending_buf[t.sym_buf+t.sym_next++]=e,t.pending_buf[t.sym_buf+t.sym_next++]=e>>8,t.pending_buf[t.sym_buf+t.sym_next++]=a,0===e?t.dyn_ltree[2*a]++:(t.matches++,e--,t.dyn_ltree[2*(l[a]+256+1)]++,t.dyn_dtree[2*m(e)]++),t.sym_next===t.sym_end),_tr_align:t=>{g(t,2,3),p(t,256,s),(t=>{16===t.bi_valid?(b(t,t.bi_buf),t.bi_buf=0,t.bi_valid=0):t.bi_valid>=8&&(t.pending_buf[t.pending++]=255&t.bi_buf,t.bi_buf>>=8,t.bi_valid-=8)})(t)}};var F=(t,e,a,i)=>{let n=65535&t|0,s=t>>>16&65535|0,r=0;for(;0!==a;){r=a>2e3?2e3:a,a-=r;do{n=n+e[i++]|0,s=s+n|0}while(--r);n%=65521,s%=65521}return n|s<<16|0};const L=new Uint32Array((()=>{let t,e=[];for(var a=0;a<256;a++){t=a;for(var i=0;i<8;i++)t=1&t?3988292384^t>>>1:t>>>1;e[a]=t}return e})());var N=(t,e,a,i)=>{const n=L,s=i+a;t^=-1;for(let a=i;a<s;a++)t=t>>>8^n[255&(t^e[a])];return-1^t},I={2:"need dictionary",1:"stream end",0:"","-1":"file error","-2":"stream error","-3":"data error","-4":"insufficient memory","-5":"buffer error","-6":"incompatible version"},B={Z_NO_FLUSH:0,Z_PARTIAL_FLUSH:1,Z_SYNC_FLUSH:2,Z_FULL_FLUSH:3,Z_FINISH:4,Z_BLOCK:5,Z_TREES:6,Z_OK:0,Z_STREAM_END:1,Z_NEED_DICT:2,Z_ERRNO:-1,Z_STREAM_ERROR:-2,Z_DATA_ERROR:-3,Z_MEM_ERROR:-4,Z_BUF_ERROR:-5,Z_NO_COMPRESSION:0,Z_BEST_SPEED:1,Z_BEST_COMPRESSION:9,Z_DEFAULT_COMPRESSION:-1,Z_FILTERED:1,Z_HUFFMAN_ONLY:2,Z_RLE:3,Z_FIXED:4,Z_DEFAULT_STRATEGY:0,Z_BINARY:0,Z_TEXT:1,Z_UNKNOWN:2,Z_DEFLATED:8};const{_tr_init:C,_tr_stored_block:H,_tr_flush_block:M,_tr_tally:j,_tr_align:K}=O,{Z_NO_FLUSH:P,Z_PARTIAL_FLUSH:Y,Z_FULL_FLUSH:G,Z_FINISH:X,Z_BLOCK:W,Z_OK:q,Z_STREAM_END:J,Z_STREAM_ERROR:Q,Z_DATA_ERROR:V,Z_BUF_ERROR:$,Z_DEFAULT_COMPRESSION:tt,Z_FILTERED:et,Z_HUFFMAN_ONLY:at,Z_RLE:it,Z_FIXED:nt,Z_DEFAULT_STRATEGY:st,Z_UNKNOWN:rt,Z_DEFLATED:ot}=B,lt=(t,e)=>(t.msg=I[e],e),ht=t=>2*t-(t>4?9:0),dt=t=>{let e=t.length;for(;--e>=0;)t[e]=0},_t=t=>{let e,a,i,n=t.w_size;e=t.hash_size,i=e;do{a=t.head[--i],t.head[i]=a>=n?a-n:0}while(--e);e=n,i=e;do{a=t.prev[--i],t.prev[i]=a>=n?a-n:0}while(--e)};let ft=(t,e,a)=>(e<<t.hash_shift^a)&t.hash_mask;const ct=t=>{const e=t.state;let a=e.pending;a>t.avail_out&&(a=t.avail_out),0!==a&&(t.output.set(e.pending_buf.subarray(e.pending_out,e.pending_out+a),t.next_out),t.next_out+=a,e.pending_out+=a,t.total_out+=a,t.avail_out-=a,e.pending-=a,0===e.pending&&(e.pending_out=0))},ut=(t,e)=>{M(t,t.block_start>=0?t.block_start:-1,t.strstart-t.block_start,e),t.block_start=t.strstart,ct(t.strm)},wt=(t,e)=>{t.pending_buf[t.pending++]=e},mt=(t,e)=>{t.pending_buf[t.pending++]=e>>>8&255,t.pending_buf[t.pending++]=255&e},bt=(t,e,a,i)=>{let n=t.avail_in;return n>i&&(n=i),0===n?0:(t.avail_in-=n,e.set(t.input.subarray(t.next_in,t.next_in+n),a),1===t.state.wrap?t.adler=F(t.adler,e,n,a):2===t.state.wrap&&(t.adler=N(t.adler,e,n,a)),t.next_in+=n,t.total_in+=n,n)},gt=(t,e)=>{let a,i,n=t.max_chain_length,s=t.strstart,r=t.prev_length,o=t.nice_match;const l=t.strstart>t.w_size-262?t.strstart-(t.w_size-262):0,h=t.window,d=t.w_mask,_=t.prev,f=t.strstart+258;let c=h[s+r-1],u=h[s+r];t.prev_length>=t.good_match&&(n>>=2),o>t.lookahead&&(o=t.lookahead);do{if(a=e,h[a+r]===u&&h[a+r-1]===c&&h[a]===h[s]&&h[++a]===h[s+1]){s+=2,a++;do{}while(h[++s]===h[++a]&&h[++s]===h[++a]&&h[++s]===h[++a]&&h[++s]===h[++a]&&h[++s]===h[++a]&&h[++s]===h[++a]&&h[++s]===h[++a]&&h[++s]===h[++a]&&s<f);if(i=258-(f-s),s=f-258,i>r){if(t.match_start=e,r=i,i>=o)break;c=h[s+r-1],u=h[s+r]}}}while((e=_[e&d])>l&&0!=--n);return r<=t.lookahead?r:t.lookahead},pt=t=>{const e=t.w_size;let a,i,n;do{if(i=t.window_size-t.lookahead-t.strstart,t.strstart>=e+(e-262)&&(t.window.set(t.window.subarray(e,e+e-i),0),t.match_start-=e,t.strstart-=e,t.block_start-=e,t.insert>t.strstart&&(t.insert=t.strstart),_t(t),i+=e),0===t.strm.avail_in)break;if(a=bt(t.strm,t.window,t.strstart+t.lookahead,i),t.lookahead+=a,t.lookahead+t.insert>=3)for(n=t.strstart-t.insert,t.ins_h=t.window[n],t.ins_h=ft(t,t.ins_h,t.window[n+1]);t.insert&&(t.ins_h=ft(t,t.ins_h,t.window[n+3-1]),t.prev[n&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=n,n++,t.insert--,!(t.lookahead+t.insert<3)););}while(t.lookahead<262&&0!==t.strm.avail_in)},kt=(t,e)=>{let a,i,n,s=t.pending_buf_size-5>t.w_size?t.w_size:t.pending_buf_size-5,r=0,o=t.strm.avail_in;do{if(a=65535,n=t.bi_valid+42>>3,t.strm.avail_out<n)break;if(n=t.strm.avail_out-n,i=t.strstart-t.block_start,a>i+t.strm.avail_in&&(a=i+t.strm.avail_in),a>n&&(a=n),a<s&&(0===a&&e!==X||e===P||a!==i+t.strm.avail_in))break;r=e===X&&a===i+t.strm.avail_in?1:0,H(t,0,0,r),t.pending_buf[t.pending-4]=a,t.pending_buf[t.pending-3]=a>>8,t.pending_buf[t.pending-2]=~a,t.pending_buf[t.pending-1]=~a>>8,ct(t.strm),i&&(i>a&&(i=a),t.strm.output.set(t.window.subarray(t.block_start,t.block_start+i),t.strm.next_out),t.strm.next_out+=i,t.strm.avail_out-=i,t.strm.total_out+=i,t.block_start+=i,a-=i),a&&(bt(t.strm,t.strm.output,t.strm.next_out,a),t.strm.next_out+=a,t.strm.avail_out-=a,t.strm.total_out+=a)}while(0===r);return o-=t.strm.avail_in,o&&(o>=t.w_size?(t.matches=2,t.window.set(t.strm.input.subarray(t.strm.next_in-t.w_size,t.strm.next_in),0),t.strstart=t.w_size,t.insert=t.strstart):(t.window_size-t.strstart<=o&&(t.strstart-=t.w_size,t.window.set(t.window.subarray(t.w_size,t.w_size+t.strstart),0),t.matches<2&&t.matches++,t.insert>t.strstart&&(t.insert=t.strstart)),t.window.set(t.strm.input.subarray(t.strm.next_in-o,t.strm.next_in),t.strstart),t.strstart+=o,t.insert+=o>t.w_size-t.insert?t.w_size-t.insert:o),t.block_start=t.strstart),t.high_water<t.strstart&&(t.high_water=t.strstart),r?4:e!==P&&e!==X&&0===t.strm.avail_in&&t.strstart===t.block_start?2:(n=t.window_size-t.strstart,t.strm.avail_in>n&&t.block_start>=t.w_size&&(t.block_start-=t.w_size,t.strstart-=t.w_size,t.window.set(t.window.subarray(t.w_size,t.w_size+t.strstart),0),t.matches<2&&t.matches++,n+=t.w_size,t.insert>t.strstart&&(t.insert=t.strstart)),n>t.strm.avail_in&&(n=t.strm.avail_in),n&&(bt(t.strm,t.window,t.strstart,n),t.strstart+=n,t.insert+=n>t.w_size-t.insert?t.w_size-t.insert:n),t.high_water<t.strstart&&(t.high_water=t.strstart),n=t.bi_valid+42>>3,n=t.pending_buf_size-n>65535?65535:t.pending_buf_size-n,s=n>t.w_size?t.w_size:n,i=t.strstart-t.block_start,(i>=s||(i||e===X)&&e!==P&&0===t.strm.avail_in&&i<=n)&&(a=i>n?n:i,r=e===X&&0===t.strm.avail_in&&a===i?1:0,H(t,t.block_start,a,r),t.block_start+=a,ct(t.strm)),r?3:1)},vt=(t,e)=>{let a,i;for(;;){if(t.lookahead<262){if(pt(t),t.lookahead<262&&e===P)return 1;if(0===t.lookahead)break}if(a=0,t.lookahead>=3&&(t.ins_h=ft(t,t.ins_h,t.window[t.strstart+3-1]),a=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart),0!==a&&t.strstart-a<=t.w_size-262&&(t.match_length=gt(t,a)),t.match_length>=3)if(i=j(t,t.strstart-t.match_start,t.match_length-3),t.lookahead-=t.match_length,t.match_length<=t.max_lazy_match&&t.lookahead>=3){t.match_length--;do{t.strstart++,t.ins_h=ft(t,t.ins_h,t.window[t.strstart+3-1]),a=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart}while(0!=--t.match_length);t.strstart++}else t.strstart+=t.match_length,t.match_length=0,t.ins_h=t.window[t.strstart],t.ins_h=ft(t,t.ins_h,t.window[t.strstart+1]);else i=j(t,0,t.window[t.strstart]),t.lookahead--,t.strstart++;if(i&&(ut(t,!1),0===t.strm.avail_out))return 1}return t.insert=t.strstart<2?t.strstart:2,e===X?(ut(t,!0),0===t.strm.avail_out?3:4):t.sym_next&&(ut(t,!1),0===t.strm.avail_out)?1:2},yt=(t,e)=>{let a,i,n;for(;;){if(t.lookahead<262){if(pt(t),t.lookahead<262&&e===P)return 1;if(0===t.lookahead)break}if(a=0,t.lookahead>=3&&(t.ins_h=ft(t,t.ins_h,t.window[t.strstart+3-1]),a=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart),t.prev_length=t.match_length,t.prev_match=t.match_start,t.match_length=2,0!==a&&t.prev_length<t.max_lazy_match&&t.strstart-a<=t.w_size-262&&(t.match_length=gt(t,a),t.match_length<=5&&(t.strategy===et||3===t.match_length&&t.strstart-t.match_start>4096)&&(t.match_length=2)),t.prev_length>=3&&t.match_length<=t.prev_length){n=t.strstart+t.lookahead-3,i=j(t,t.strstart-1-t.prev_match,t.prev_length-3),t.lookahead-=t.prev_length-1,t.prev_length-=2;do{++t.strstart<=n&&(t.ins_h=ft(t,t.ins_h,t.window[t.strstart+3-1]),a=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart)}while(0!=--t.prev_length);if(t.match_available=0,t.match_length=2,t.strstart++,i&&(ut(t,!1),0===t.strm.avail_out))return 1}else if(t.match_available){if(i=j(t,0,t.window[t.strstart-1]),i&&ut(t,!1),t.strstart++,t.lookahead--,0===t.strm.avail_out)return 1}else t.match_available=1,t.strstart++,t.lookahead--}return t.match_available&&(i=j(t,0,t.window[t.strstart-1]),t.match_available=0),t.insert=t.strstart<2?t.strstart:2,e===X?(ut(t,!0),0===t.strm.avail_out?3:4):t.sym_next&&(ut(t,!1),0===t.strm.avail_out)?1:2};function xt(t,e,a,i,n){this.good_length=t,this.max_lazy=e,this.nice_length=a,this.max_chain=i,this.func=n}const zt=[new xt(0,0,0,0,kt),new xt(4,4,8,4,vt),new xt(4,5,16,8,vt),new xt(4,6,32,32,vt),new xt(4,4,16,16,yt),new xt(8,16,32,32,yt),new xt(8,16,128,128,yt),new xt(8,32,128,256,yt),new xt(32,128,258,1024,yt),new xt(32,258,258,4096,yt)];function At(){this.strm=null,this.status=0,this.pending_buf=null,this.pending_buf_size=0,this.pending_out=0,this.pending=0,this.wrap=0,this.gzhead=null,this.gzindex=0,this.method=ot,this.last_flush=-1,this.w_size=0,this.w_bits=0,this.w_mask=0,this.window=null,this.window_size=0,this.prev=null,this.head=null,this.ins_h=0,this.hash_size=0,this.hash_bits=0,this.hash_mask=0,this.hash_shift=0,this.block_start=0,this.match_length=0,this.prev_match=0,this.match_available=0,this.strstart=0,this.match_start=0,this.lookahead=0,this.prev_length=0,this.max_chain_length=0,this.max_lazy_match=0,this.level=0,this.strategy=0,this.good_match=0,this.nice_match=0,this.dyn_ltree=new Uint16Array(1146),this.dyn_dtree=new Uint16Array(122),this.bl_tree=new Uint16Array(78),dt(this.dyn_ltree),dt(this.dyn_dtree),dt(this.bl_tree),this.l_desc=null,this.d_desc=null,this.bl_desc=null,this.bl_count=new Uint16Array(16),this.heap=new Uint16Array(573),dt(this.heap),this.heap_len=0,this.heap_max=0,this.depth=new Uint16Array(573),dt(this.depth),this.sym_buf=0,this.lit_bufsize=0,this.sym_next=0,this.sym_end=0,this.opt_len=0,this.static_len=0,this.matches=0,this.insert=0,this.bi_buf=0,this.bi_valid=0}const Et=t=>{if(!t)return 1;const e=t.state;return!e||e.strm!==t||42!==e.status&&57!==e.status&&69!==e.status&&73!==e.status&&91!==e.status&&103!==e.status&&113!==e.status&&666!==e.status?1:0},Rt=t=>{if(Et(t))return lt(t,Q);t.total_in=t.total_out=0,t.data_type=rt;const e=t.state;return e.pending=0,e.pending_out=0,e.wrap<0&&(e.wrap=-e.wrap),e.status=2===e.wrap?57:e.wrap?42:113,t.adler=2===e.wrap?0:1,e.last_flush=-2,C(e),q},Zt=t=>{const e=Rt(t);var a;return e===q&&((a=t.state).window_size=2*a.w_size,dt(a.head),a.max_lazy_match=zt[a.level].max_lazy,a.good_match=zt[a.level].good_length,a.nice_match=zt[a.level].nice_length,a.max_chain_length=zt[a.level].max_chain,a.strstart=0,a.block_start=0,a.lookahead=0,a.insert=0,a.match_length=a.prev_length=2,a.match_available=0,a.ins_h=0),e},Ut=(t,e,a,i,n,s)=>{if(!t)return Q;let r=1;if(e===tt&&(e=6),i<0?(r=0,i=-i):i>15&&(r=2,i-=16),n<1||n>9||a!==ot||i<8||i>15||e<0||e>9||s<0||s>nt||8===i&&1!==r)return lt(t,Q);8===i&&(i=9);const o=new At;return t.state=o,o.strm=t,o.status=42,o.wrap=r,o.gzhead=null,o.w_bits=i,o.w_size=1<<o.w_bits,o.w_mask=o.w_size-1,o.hash_bits=n+7,o.hash_size=1<<o.hash_bits,o.hash_mask=o.hash_size-1,o.hash_shift=~~((o.hash_bits+3-1)/3),o.window=new Uint8Array(2*o.w_size),o.head=new Uint16Array(o.hash_size),o.prev=new Uint16Array(o.w_size),o.lit_bufsize=1<<n+6,o.pending_buf_size=4*o.lit_bufsize,o.pending_buf=new Uint8Array(o.pending_buf_size),o.sym_buf=o.lit_bufsize,o.sym_end=3*(o.lit_bufsize-1),o.level=e,o.strategy=s,o.method=a,Zt(t)};var St={deflateInit:(t,e)=>Ut(t,e,ot,15,8,st),deflateInit2:Ut,deflateReset:Zt,deflateResetKeep:Rt,deflateSetHeader:(t,e)=>Et(t)||2!==t.state.wrap?Q:(t.state.gzhead=e,q),deflate:(t,e)=>{if(Et(t)||e>W||e<0)return t?lt(t,Q):Q;const a=t.state;if(!t.output||0!==t.avail_in&&!t.input||666===a.status&&e!==X)return lt(t,0===t.avail_out?$:Q);const i=a.last_flush;if(a.last_flush=e,0!==a.pending){if(ct(t),0===t.avail_out)return a.last_flush=-1,q}else if(0===t.avail_in&&ht(e)<=ht(i)&&e!==X)return lt(t,$);if(666===a.status&&0!==t.avail_in)return lt(t,$);if(42===a.status&&0===a.wrap&&(a.status=113),42===a.status){let e=ot+(a.w_bits-8<<4)<<8,i=-1;if(i=a.strategy>=at||a.level<2?0:a.level<6?1:6===a.level?2:3,e|=i<<6,0!==a.strstart&&(e|=32),e+=31-e%31,mt(a,e),0!==a.strstart&&(mt(a,t.adler>>>16),mt(a,65535&t.adler)),t.adler=1,a.status=113,ct(t),0!==a.pending)return a.last_flush=-1,q}if(57===a.status)if(t.adler=0,wt(a,31),wt(a,139),wt(a,8),a.gzhead)wt(a,(a.gzhead.text?1:0)+(a.gzhead.hcrc?2:0)+(a.gzhead.extra?4:0)+(a.gzhead.name?8:0)+(a.gzhead.comment?16:0)),wt(a,255&a.gzhead.time),wt(a,a.gzhead.time>>8&255),wt(a,a.gzhead.time>>16&255),wt(a,a.gzhead.time>>24&255),wt(a,9===a.level?2:a.strategy>=at||a.level<2?4:0),wt(a,255&a.gzhead.os),a.gzhead.extra&&a.gzhead.extra.length&&(wt(a,255&a.gzhead.extra.length),wt(a,a.gzhead.extra.length>>8&255)),a.gzhead.hcrc&&(t.adler=N(t.adler,a.pending_buf,a.pending,0)),a.gzindex=0,a.status=69;else if(wt(a,0),wt(a,0),wt(a,0),wt(a,0),wt(a,0),wt(a,9===a.level?2:a.strategy>=at||a.level<2?4:0),wt(a,3),a.status=113,ct(t),0!==a.pending)return a.last_flush=-1,q;if(69===a.status){if(a.gzhead.extra){let e=a.pending,i=(65535&a.gzhead.extra.length)-a.gzindex;for(;a.pending+i>a.pending_buf_size;){let n=a.pending_buf_size-a.pending;if(a.pending_buf.set(a.gzhead.extra.subarray(a.gzindex,a.gzindex+n),a.pending),a.pending=a.pending_buf_size,a.gzhead.hcrc&&a.pending>e&&(t.adler=N(t.adler,a.pending_buf,a.pending-e,e)),a.gzindex+=n,ct(t),0!==a.pending)return a.last_flush=-1,q;e=0,i-=n}let n=new Uint8Array(a.gzhead.extra);a.pending_buf.set(n.subarray(a.gzindex,a.gzindex+i),a.pending),a.pending+=i,a.gzhead.hcrc&&a.pending>e&&(t.adler=N(t.adler,a.pending_buf,a.pending-e,e)),a.gzindex=0}a.status=73}if(73===a.status){if(a.gzhead.name){let e,i=a.pending;do{if(a.pending===a.pending_buf_size){if(a.gzhead.hcrc&&a.pending>i&&(t.adler=N(t.adler,a.pending_buf,a.pending-i,i)),ct(t),0!==a.pending)return a.last_flush=-1,q;i=0}e=a.gzindex<a.gzhead.name.length?255&a.gzhead.name.charCodeAt(a.gzindex++):0,wt(a,e)}while(0!==e);a.gzhead.hcrc&&a.pending>i&&(t.adler=N(t.adler,a.pending_buf,a.pending-i,i)),a.gzindex=0}a.status=91}if(91===a.status){if(a.gzhead.comment){let e,i=a.pending;do{if(a.pending===a.pending_buf_size){if(a.gzhead.hcrc&&a.pending>i&&(t.adler=N(t.adler,a.pending_buf,a.pending-i,i)),ct(t),0!==a.pending)return a.last_flush=-1,q;i=0}e=a.gzindex<a.gzhead.comment.length?255&a.gzhead.comment.charCodeAt(a.gzindex++):0,wt(a,e)}while(0!==e);a.gzhead.hcrc&&a.pending>i&&(t.adler=N(t.adler,a.pending_buf,a.pending-i,i))}a.status=103}if(103===a.status){if(a.gzhead.hcrc){if(a.pending+2>a.pending_buf_size&&(ct(t),0!==a.pending))return a.last_flush=-1,q;wt(a,255&t.adler),wt(a,t.adler>>8&255),t.adler=0}if(a.status=113,ct(t),0!==a.pending)return a.last_flush=-1,q}if(0!==t.avail_in||0!==a.lookahead||e!==P&&666!==a.status){let i=0===a.level?kt(a,e):a.strategy===at?((t,e)=>{let a;for(;;){if(0===t.lookahead&&(pt(t),0===t.lookahead)){if(e===P)return 1;break}if(t.match_length=0,a=j(t,0,t.window[t.strstart]),t.lookahead--,t.strstart++,a&&(ut(t,!1),0===t.strm.avail_out))return 1}return t.insert=0,e===X?(ut(t,!0),0===t.strm.avail_out?3:4):t.sym_next&&(ut(t,!1),0===t.strm.avail_out)?1:2})(a,e):a.strategy===it?((t,e)=>{let a,i,n,s;const r=t.window;for(;;){if(t.lookahead<=258){if(pt(t),t.lookahead<=258&&e===P)return 1;if(0===t.lookahead)break}if(t.match_length=0,t.lookahead>=3&&t.strstart>0&&(n=t.strstart-1,i=r[n],i===r[++n]&&i===r[++n]&&i===r[++n])){s=t.strstart+258;do{}while(i===r[++n]&&i===r[++n]&&i===r[++n]&&i===r[++n]&&i===r[++n]&&i===r[++n]&&i===r[++n]&&i===r[++n]&&n<s);t.match_length=258-(s-n),t.match_length>t.lookahead&&(t.match_length=t.lookahead)}if(t.match_length>=3?(a=j(t,1,t.match_length-3),t.lookahead-=t.match_length,t.strstart+=t.match_length,t.match_length=0):(a=j(t,0,t.window[t.strstart]),t.lookahead--,t.strstart++),a&&(ut(t,!1),0===t.strm.avail_out))return 1}return t.insert=0,e===X?(ut(t,!0),0===t.strm.avail_out?3:4):t.sym_next&&(ut(t,!1),0===t.strm.avail_out)?1:2})(a,e):zt[a.level].func(a,e);if(3!==i&&4!==i||(a.status=666),1===i||3===i)return 0===t.avail_out&&(a.last_flush=-1),q;if(2===i&&(e===Y?K(a):e!==W&&(H(a,0,0,!1),e===G&&(dt(a.head),0===a.lookahead&&(a.strstart=0,a.block_start=0,a.insert=0))),ct(t),0===t.avail_out))return a.last_flush=-1,q}return e!==X?q:a.wrap<=0?J:(2===a.wrap?(wt(a,255&t.adler),wt(a,t.adler>>8&255),wt(a,t.adler>>16&255),wt(a,t.adler>>24&255),wt(a,255&t.total_in),wt(a,t.total_in>>8&255),wt(a,t.total_in>>16&255),wt(a,t.total_in>>24&255)):(mt(a,t.adler>>>16),mt(a,65535&t.adler)),ct(t),a.wrap>0&&(a.wrap=-a.wrap),0!==a.pending?q:J)},deflateEnd:t=>{if(Et(t))return Q;const e=t.state.status;return t.state=null,113===e?lt(t,V):q},deflateSetDictionary:(t,e)=>{let a=e.length;if(Et(t))return Q;const i=t.state,n=i.wrap;if(2===n||1===n&&42!==i.status||i.lookahead)return Q;if(1===n&&(t.adler=F(t.adler,e,a,0)),i.wrap=0,a>=i.w_size){0===n&&(dt(i.head),i.strstart=0,i.block_start=0,i.insert=0);let t=new Uint8Array(i.w_size);t.set(e.subarray(a-i.w_size,a),0),e=t,a=i.w_size}const s=t.avail_in,r=t.next_in,o=t.input;for(t.avail_in=a,t.next_in=0,t.input=e,pt(i);i.lookahead>=3;){let t=i.strstart,e=i.lookahead-2;do{i.ins_h=ft(i,i.ins_h,i.window[t+3-1]),i.prev[t&i.w_mask]=i.head[i.ins_h],i.head[i.ins_h]=t,t++}while(--e);i.strstart=t,i.lookahead=2,pt(i)}return i.strstart+=i.lookahead,i.block_start=i.strstart,i.insert=i.lookahead,i.lookahead=0,i.match_length=i.prev_length=2,i.match_available=0,t.next_in=r,t.input=o,t.avail_in=s,i.wrap=n,q},deflateInfo:"pako deflate (from Nodeca project)"};const Dt=(t,e)=>Object.prototype.hasOwnProperty.call(t,e);var Tt=function(t){const e=Array.prototype.slice.call(arguments,1);for(;e.length;){const a=e.shift();if(a){if("object"!=typeof a)throw new TypeError(a+"must be non-object");for(const e in a)Dt(a,e)&&(t[e]=a[e])}}return t},Ot=t=>{let e=0;for(let a=0,i=t.length;a<i;a++)e+=t[a].length;const a=new Uint8Array(e);for(let e=0,i=0,n=t.length;e<n;e++){let n=t[e];a.set(n,i),i+=n.length}return a};let Ft=!0;try{String.fromCharCode.apply(null,new Uint8Array(1))}catch(t){Ft=!1}const Lt=new Uint8Array(256);for(let t=0;t<256;t++)Lt[t]=t>=252?6:t>=248?5:t>=240?4:t>=224?3:t>=192?2:1;Lt[254]=Lt[254]=1;var Nt=t=>{if("function"==typeof TextEncoder&&TextEncoder.prototype.encode)return(new TextEncoder).encode(t);let e,a,i,n,s,r=t.length,o=0;for(n=0;n<r;n++)a=t.charCodeAt(n),55296==(64512&a)&&n+1<r&&(i=t.charCodeAt(n+1),56320==(64512&i)&&(a=65536+(a-55296<<10)+(i-56320),n++)),o+=a<128?1:a<2048?2:a<65536?3:4;for(e=new Uint8Array(o),s=0,n=0;s<o;n++)a=t.charCodeAt(n),55296==(64512&a)&&n+1<r&&(i=t.charCodeAt(n+1),56320==(64512&i)&&(a=65536+(a-55296<<10)+(i-56320),n++)),a<128?e[s++]=a:a<2048?(e[s++]=192|a>>>6,e[s++]=128|63&a):a<65536?(e[s++]=224|a>>>12,e[s++]=128|a>>>6&63,e[s++]=128|63&a):(e[s++]=240|a>>>18,e[s++]=128|a>>>12&63,e[s++]=128|a>>>6&63,e[s++]=128|63&a);return e},It=(t,e)=>{const a=e||t.length;if("function"==typeof TextDecoder&&TextDecoder.prototype.decode)return(new TextDecoder).decode(t.subarray(0,e));let i,n;const s=new Array(2*a);for(n=0,i=0;i<a;){let e=t[i++];if(e<128){s[n++]=e;continue}let r=Lt[e];if(r>4)s[n++]=65533,i+=r-1;else{for(e&=2===r?31:3===r?15:7;r>1&&i<a;)e=e<<6|63&t[i++],r--;r>1?s[n++]=65533:e<65536?s[n++]=e:(e-=65536,s[n++]=55296|e>>10&1023,s[n++]=56320|1023&e)}}return((t,e)=>{if(e<65534&&t.subarray&&Ft)return String.fromCharCode.apply(null,t.length===e?t:t.subarray(0,e));let a="";for(let i=0;i<e;i++)a+=String.fromCharCode(t[i]);return a})(s,n)},Bt=(t,e)=>{(e=e||t.length)>t.length&&(e=t.length);let a=e-1;for(;a>=0&&128==(192&t[a]);)a--;return a<0||0===a?e:a+Lt[t[a]]>e?a:e};var Ct=function(){this.input=null,this.next_in=0,this.avail_in=0,this.total_in=0,this.output=null,this.next_out=0,this.avail_out=0,this.total_out=0,this.msg="",this.state=null,this.data_type=2,this.adler=0};const Ht=Object.prototype.toString,{Z_NO_FLUSH:Mt,Z_SYNC_FLUSH:jt,Z_FULL_FLUSH:Kt,Z_FINISH:Pt,Z_OK:Yt,Z_STREAM_END:Gt,Z_DEFAULT_COMPRESSION:Xt,Z_DEFAULT_STRATEGY:Wt,Z_DEFLATED:qt}=B;function Jt(t){this.options=Tt({level:Xt,method:qt,chunkSize:16384,windowBits:15,memLevel:8,strategy:Wt},t||{});let e=this.options;e.raw&&e.windowBits>0?e.windowBits=-e.windowBits:e.gzip&&e.windowBits>0&&e.windowBits<16&&(e.windowBits+=16),this.err=0,this.msg="",this.ended=!1,this.chunks=[],this.strm=new Ct,this.strm.avail_out=0;let a=St.deflateInit2(this.strm,e.level,e.method,e.windowBits,e.memLevel,e.strategy);if(a!==Yt)throw new Error(I[a]);if(e.header&&St.deflateSetHeader(this.strm,e.header),e.dictionary){let t;if(t="string"==typeof e.dictionary?Nt(e.dictionary):"[object ArrayBuffer]"===Ht.call(e.dictionary)?new Uint8Array(e.dictionary):e.dictionary,a=St.deflateSetDictionary(this.strm,t),a!==Yt)throw new Error(I[a]);this._dict_set=!0}}function Qt(t,e){const a=new Jt(e);if(a.push(t,!0),a.err)throw a.msg||I[a.err];return a.result}Jt.prototype.push=function(t,e){const a=this.strm,i=this.options.chunkSize;let n,s;if(this.ended)return!1;for(s=e===~~e?e:!0===e?Pt:Mt,"string"==typeof t?a.input=Nt(t):"[object ArrayBuffer]"===Ht.call(t)?a.input=new Uint8Array(t):a.input=t,a.next_in=0,a.avail_in=a.input.length;;)if(0===a.avail_out&&(a.output=new Uint8Array(i),a.next_out=0,a.avail_out=i),(s===jt||s===Kt)&&a.avail_out<=6)this.onData(a.output.subarray(0,a.next_out)),a.avail_out=0;else{if(n=St.deflate(a,s),n===Gt)return a.next_out>0&&this.onData(a.output.subarray(0,a.next_out)),n=St.deflateEnd(this.strm),this.onEnd(n),this.ended=!0,n===Yt;if(0!==a.avail_out){if(s>0&&a.next_out>0)this.onData(a.output.subarray(0,a.next_out)),a.avail_out=0;else if(0===a.avail_in)break}else this.onData(a.output)}return!0},Jt.prototype.onData=function(t){this.chunks.push(t)},Jt.prototype.onEnd=function(t){t===Yt&&(this.result=Ot(this.chunks)),this.chunks=[],this.err=t,this.msg=this.strm.msg};var Vt={Deflate:Jt,deflate:Qt,deflateRaw:function(t,e){return(e=e||{}).raw=!0,Qt(t,e)},gzip:function(t,e){return(e=e||{}).gzip=!0,Qt(t,e)},constants:B};var $t=function(t,e){let a,i,n,s,r,o,l,h,d,_,f,c,u,w,m,b,g,p,k,v,y,x,z,A;const E=t.state;a=t.next_in,z=t.input,i=a+(t.avail_in-5),n=t.next_out,A=t.output,s=n-(e-t.avail_out),r=n+(t.avail_out-257),o=E.dmax,l=E.wsize,h=E.whave,d=E.wnext,_=E.window,f=E.hold,c=E.bits,u=E.lencode,w=E.distcode,m=(1<<E.lenbits)-1,b=(1<<E.distbits)-1;t:do{c<15&&(f+=z[a++]<<c,c+=8,f+=z[a++]<<c,c+=8),g=u[f&m];e:for(;;){if(p=g>>>24,f>>>=p,c-=p,p=g>>>16&255,0===p)A[n++]=65535&g;else{if(!(16&p)){if(0==(64&p)){g=u[(65535&g)+(f&(1<<p)-1)];continue e}if(32&p){E.mode=16191;break t}t.msg="invalid literal/length code",E.mode=16209;break t}k=65535&g,p&=15,p&&(c<p&&(f+=z[a++]<<c,c+=8),k+=f&(1<<p)-1,f>>>=p,c-=p),c<15&&(f+=z[a++]<<c,c+=8,f+=z[a++]<<c,c+=8),g=w[f&b];a:for(;;){if(p=g>>>24,f>>>=p,c-=p,p=g>>>16&255,!(16&p)){if(0==(64&p)){g=w[(65535&g)+(f&(1<<p)-1)];continue a}t.msg="invalid distance code",E.mode=16209;break t}if(v=65535&g,p&=15,c<p&&(f+=z[a++]<<c,c+=8,c<p&&(f+=z[a++]<<c,c+=8)),v+=f&(1<<p)-1,v>o){t.msg="invalid distance too far back",E.mode=16209;break t}if(f>>>=p,c-=p,p=n-s,v>p){if(p=v-p,p>h&&E.sane){t.msg="invalid distance too far back",E.mode=16209;break t}if(y=0,x=_,0===d){if(y+=l-p,p<k){k-=p;do{A[n++]=_[y++]}while(--p);y=n-v,x=A}}else if(d<p){if(y+=l+d-p,p-=d,p<k){k-=p;do{A[n++]=_[y++]}while(--p);if(y=0,d<k){p=d,k-=p;do{A[n++]=_[y++]}while(--p);y=n-v,x=A}}}else if(y+=d-p,p<k){k-=p;do{A[n++]=_[y++]}while(--p);y=n-v,x=A}for(;k>2;)A[n++]=x[y++],A[n++]=x[y++],A[n++]=x[y++],k-=3;k&&(A[n++]=x[y++],k>1&&(A[n++]=x[y++]))}else{y=n-v;do{A[n++]=A[y++],A[n++]=A[y++],A[n++]=A[y++],k-=3}while(k>2);k&&(A[n++]=A[y++],k>1&&(A[n++]=A[y++]))}break}}break}}while(a<i&&n<r);k=c>>3,a-=k,c-=k<<3,f&=(1<<c)-1,t.next_in=a,t.next_out=n,t.avail_in=a<i?i-a+5:5-(a-i),t.avail_out=n<r?r-n+257:257-(n-r),E.hold=f,E.bits=c};const te=new Uint16Array([3,4,5,6,7,8,9,10,11,13,15,17,19,23,27,31,35,43,51,59,67,83,99,115,131,163,195,227,258,0,0]),ee=new Uint8Array([16,16,16,16,16,16,16,16,17,17,17,17,18,18,18,18,19,19,19,19,20,20,20,20,21,21,21,21,16,72,78]),ae=new Uint16Array([1,2,3,4,5,7,9,13,17,25,33,49,65,97,129,193,257,385,513,769,1025,1537,2049,3073,4097,6145,8193,12289,16385,24577,0,0]),ie=new Uint8Array([16,16,16,16,17,17,18,18,19,19,20,20,21,21,22,22,23,23,24,24,25,25,26,26,27,27,28,28,29,29,64,64]);var ne=(t,e,a,i,n,s,r,o)=>{const l=o.bits;let h,d,_,f,c,u,w=0,m=0,b=0,g=0,p=0,k=0,v=0,y=0,x=0,z=0,A=null;const E=new Uint16Array(16),R=new Uint16Array(16);let Z,U,S,D=null;for(w=0;w<=15;w++)E[w]=0;for(m=0;m<i;m++)E[e[a+m]]++;for(p=l,g=15;g>=1&&0===E[g];g--);if(p>g&&(p=g),0===g)return n[s++]=20971520,n[s++]=20971520,o.bits=1,0;for(b=1;b<g&&0===E[b];b++);for(p<b&&(p=b),y=1,w=1;w<=15;w++)if(y<<=1,y-=E[w],y<0)return-1;if(y>0&&(0===t||1!==g))return-1;for(R[1]=0,w=1;w<15;w++)R[w+1]=R[w]+E[w];for(m=0;m<i;m++)0!==e[a+m]&&(r[R[e[a+m]]++]=m);if(0===t?(A=D=r,u=20):1===t?(A=te,D=ee,u=257):(A=ae,D=ie,u=0),z=0,m=0,w=b,c=s,k=p,v=0,_=-1,x=1<<p,f=x-1,1===t&&x>852||2===t&&x>592)return 1;for(;;){Z=w-v,r[m]+1<u?(U=0,S=r[m]):r[m]>=u?(U=D[r[m]-u],S=A[r[m]-u]):(U=96,S=0),h=1<<w-v,d=1<<k,b=d;do{d-=h,n[c+(z>>v)+d]=Z<<24|U<<16|S|0}while(0!==d);for(h=1<<w-1;z&h;)h>>=1;if(0!==h?(z&=h-1,z+=h):z=0,m++,0==--E[w]){if(w===g)break;w=e[a+r[m]]}if(w>p&&(z&f)!==_){for(0===v&&(v=p),c+=b,k=w-v,y=1<<k;k+v<g&&(y-=E[k+v],!(y<=0));)k++,y<<=1;if(x+=1<<k,1===t&&x>852||2===t&&x>592)return 1;_=z&f,n[_]=p<<24|k<<16|c-s|0}}return 0!==z&&(n[c+z]=w-v<<24|64<<16|0),o.bits=p,0};const{Z_FINISH:se,Z_BLOCK:re,Z_TREES:oe,Z_OK:le,Z_STREAM_END:he,Z_NEED_DICT:de,Z_STREAM_ERROR:_e,Z_DATA_ERROR:fe,Z_MEM_ERROR:ce,Z_BUF_ERROR:ue,Z_DEFLATED:we}=B,me=16209,be=t=>(t>>>24&255)+(t>>>8&65280)+((65280&t)<<8)+((255&t)<<24);function ge(){this.strm=null,this.mode=0,this.last=!1,this.wrap=0,this.havedict=!1,this.flags=0,this.dmax=0,this.check=0,this.total=0,this.head=null,this.wbits=0,this.wsize=0,this.whave=0,this.wnext=0,this.window=null,this.hold=0,this.bits=0,this.length=0,this.offset=0,this.extra=0,this.lencode=null,this.distcode=null,this.lenbits=0,this.distbits=0,this.ncode=0,this.nlen=0,this.ndist=0,this.have=0,this.next=null,this.lens=new Uint16Array(320),this.work=new Uint16Array(288),this.lendyn=null,this.distdyn=null,this.sane=0,this.back=0,this.was=0}const pe=t=>{if(!t)return 1;const e=t.state;return!e||e.strm!==t||e.mode<16180||e.mode>16211?1:0},ke=t=>{if(pe(t))return _e;const e=t.state;return t.total_in=t.total_out=e.total=0,t.msg="",e.wrap&&(t.adler=1&e.wrap),e.mode=16180,e.last=0,e.havedict=0,e.flags=-1,e.dmax=32768,e.head=null,e.hold=0,e.bits=0,e.lencode=e.lendyn=new Int32Array(852),e.distcode=e.distdyn=new Int32Array(592),e.sane=1,e.back=-1,le},ve=t=>{if(pe(t))return _e;const e=t.state;return e.wsize=0,e.whave=0,e.wnext=0,ke(t)},ye=(t,e)=>{let a;if(pe(t))return _e;const i=t.state;return e<0?(a=0,e=-e):(a=5+(e>>4),e<48&&(e&=15)),e&&(e<8||e>15)?_e:(null!==i.window&&i.wbits!==e&&(i.window=null),i.wrap=a,i.wbits=e,ve(t))},xe=(t,e)=>{if(!t)return _e;const a=new ge;t.state=a,a.strm=t,a.window=null,a.mode=16180;const i=ye(t,e);return i!==le&&(t.state=null),i};let ze,Ae,Ee=!0;const Re=t=>{if(Ee){ze=new Int32Array(512),Ae=new Int32Array(32);let e=0;for(;e<144;)t.lens[e++]=8;for(;e<256;)t.lens[e++]=9;for(;e<280;)t.lens[e++]=7;for(;e<288;)t.lens[e++]=8;for(ne(1,t.lens,0,288,ze,0,t.work,{bits:9}),e=0;e<32;)t.lens[e++]=5;ne(2,t.lens,0,32,Ae,0,t.work,{bits:5}),Ee=!1}t.lencode=ze,t.lenbits=9,t.distcode=Ae,t.distbits=5},Ze=(t,e,a,i)=>{let n;const s=t.state;return null===s.window&&(s.wsize=1<<s.wbits,s.wnext=0,s.whave=0,s.window=new Uint8Array(s.wsize)),i>=s.wsize?(s.window.set(e.subarray(a-s.wsize,a),0),s.wnext=0,s.whave=s.wsize):(n=s.wsize-s.wnext,n>i&&(n=i),s.window.set(e.subarray(a-i,a-i+n),s.wnext),(i-=n)?(s.window.set(e.subarray(a-i,a),0),s.wnext=i,s.whave=s.wsize):(s.wnext+=n,s.wnext===s.wsize&&(s.wnext=0),s.whave<s.wsize&&(s.whave+=n))),0};var Ue={inflateReset:ve,inflateReset2:ye,inflateResetKeep:ke,inflateInit:t=>xe(t,15),inflateInit2:xe,inflate:(t,e)=>{let a,i,n,s,r,o,l,h,d,_,f,c,u,w,m,b,g,p,k,v,y,x,z=0;const A=new Uint8Array(4);let E,R;const Z=new Uint8Array([16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15]);if(pe(t)||!t.output||!t.input&&0!==t.avail_in)return _e;a=t.state,16191===a.mode&&(a.mode=16192),r=t.next_out,n=t.output,l=t.avail_out,s=t.next_in,i=t.input,o=t.avail_in,h=a.hold,d=a.bits,_=o,f=l,x=le;t:for(;;)switch(a.mode){case 16180:if(0===a.wrap){a.mode=16192;break}for(;d<16;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}if(2&a.wrap&&35615===h){0===a.wbits&&(a.wbits=15),a.check=0,A[0]=255&h,A[1]=h>>>8&255,a.check=N(a.check,A,2,0),h=0,d=0,a.mode=16181;break}if(a.head&&(a.head.done=!1),!(1&a.wrap)||(((255&h)<<8)+(h>>8))%31){t.msg="incorrect header check",a.mode=me;break}if((15&h)!==we){t.msg="unknown compression method",a.mode=me;break}if(h>>>=4,d-=4,y=8+(15&h),0===a.wbits&&(a.wbits=y),y>15||y>a.wbits){t.msg="invalid window size",a.mode=me;break}a.dmax=1<<a.wbits,a.flags=0,t.adler=a.check=1,a.mode=512&h?16189:16191,h=0,d=0;break;case 16181:for(;d<16;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}if(a.flags=h,(255&a.flags)!==we){t.msg="unknown compression method",a.mode=me;break}if(57344&a.flags){t.msg="unknown header flags set",a.mode=me;break}a.head&&(a.head.text=h>>8&1),512&a.flags&&4&a.wrap&&(A[0]=255&h,A[1]=h>>>8&255,a.check=N(a.check,A,2,0)),h=0,d=0,a.mode=16182;case 16182:for(;d<32;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}a.head&&(a.head.time=h),512&a.flags&&4&a.wrap&&(A[0]=255&h,A[1]=h>>>8&255,A[2]=h>>>16&255,A[3]=h>>>24&255,a.check=N(a.check,A,4,0)),h=0,d=0,a.mode=16183;case 16183:for(;d<16;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}a.head&&(a.head.xflags=255&h,a.head.os=h>>8),512&a.flags&&4&a.wrap&&(A[0]=255&h,A[1]=h>>>8&255,a.check=N(a.check,A,2,0)),h=0,d=0,a.mode=16184;case 16184:if(1024&a.flags){for(;d<16;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}a.length=h,a.head&&(a.head.extra_len=h),512&a.flags&&4&a.wrap&&(A[0]=255&h,A[1]=h>>>8&255,a.check=N(a.check,A,2,0)),h=0,d=0}else a.head&&(a.head.extra=null);a.mode=16185;case 16185:if(1024&a.flags&&(c=a.length,c>o&&(c=o),c&&(a.head&&(y=a.head.extra_len-a.length,a.head.extra||(a.head.extra=new Uint8Array(a.head.extra_len)),a.head.extra.set(i.subarray(s,s+c),y)),512&a.flags&&4&a.wrap&&(a.check=N(a.check,i,c,s)),o-=c,s+=c,a.length-=c),a.length))break t;a.length=0,a.mode=16186;case 16186:if(2048&a.flags){if(0===o)break t;c=0;do{y=i[s+c++],a.head&&y&&a.length<65536&&(a.head.name+=String.fromCharCode(y))}while(y&&c<o);if(512&a.flags&&4&a.wrap&&(a.check=N(a.check,i,c,s)),o-=c,s+=c,y)break t}else a.head&&(a.head.name=null);a.length=0,a.mode=16187;case 16187:if(4096&a.flags){if(0===o)break t;c=0;do{y=i[s+c++],a.head&&y&&a.length<65536&&(a.head.comment+=String.fromCharCode(y))}while(y&&c<o);if(512&a.flags&&4&a.wrap&&(a.check=N(a.check,i,c,s)),o-=c,s+=c,y)break t}else a.head&&(a.head.comment=null);a.mode=16188;case 16188:if(512&a.flags){for(;d<16;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}if(4&a.wrap&&h!==(65535&a.check)){t.msg="header crc mismatch",a.mode=me;break}h=0,d=0}a.head&&(a.head.hcrc=a.flags>>9&1,a.head.done=!0),t.adler=a.check=0,a.mode=16191;break;case 16189:for(;d<32;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}t.adler=a.check=be(h),h=0,d=0,a.mode=16190;case 16190:if(0===a.havedict)return t.next_out=r,t.avail_out=l,t.next_in=s,t.avail_in=o,a.hold=h,a.bits=d,de;t.adler=a.check=1,a.mode=16191;case 16191:if(e===re||e===oe)break t;case 16192:if(a.last){h>>>=7&d,d-=7&d,a.mode=16206;break}for(;d<3;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}switch(a.last=1&h,h>>>=1,d-=1,3&h){case 0:a.mode=16193;break;case 1:if(Re(a),a.mode=16199,e===oe){h>>>=2,d-=2;break t}break;case 2:a.mode=16196;break;case 3:t.msg="invalid block type",a.mode=me}h>>>=2,d-=2;break;case 16193:for(h>>>=7&d,d-=7&d;d<32;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}if((65535&h)!=(h>>>16^65535)){t.msg="invalid stored block lengths",a.mode=me;break}if(a.length=65535&h,h=0,d=0,a.mode=16194,e===oe)break t;case 16194:a.mode=16195;case 16195:if(c=a.length,c){if(c>o&&(c=o),c>l&&(c=l),0===c)break t;n.set(i.subarray(s,s+c),r),o-=c,s+=c,l-=c,r+=c,a.length-=c;break}a.mode=16191;break;case 16196:for(;d<14;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}if(a.nlen=257+(31&h),h>>>=5,d-=5,a.ndist=1+(31&h),h>>>=5,d-=5,a.ncode=4+(15&h),h>>>=4,d-=4,a.nlen>286||a.ndist>30){t.msg="too many length or distance symbols",a.mode=me;break}a.have=0,a.mode=16197;case 16197:for(;a.have<a.ncode;){for(;d<3;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}a.lens[Z[a.have++]]=7&h,h>>>=3,d-=3}for(;a.have<19;)a.lens[Z[a.have++]]=0;if(a.lencode=a.lendyn,a.lenbits=7,E={bits:a.lenbits},x=ne(0,a.lens,0,19,a.lencode,0,a.work,E),a.lenbits=E.bits,x){t.msg="invalid code lengths set",a.mode=me;break}a.have=0,a.mode=16198;case 16198:for(;a.have<a.nlen+a.ndist;){for(;z=a.lencode[h&(1<<a.lenbits)-1],m=z>>>24,b=z>>>16&255,g=65535&z,!(m<=d);){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}if(g<16)h>>>=m,d-=m,a.lens[a.have++]=g;else{if(16===g){for(R=m+2;d<R;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}if(h>>>=m,d-=m,0===a.have){t.msg="invalid bit length repeat",a.mode=me;break}y=a.lens[a.have-1],c=3+(3&h),h>>>=2,d-=2}else if(17===g){for(R=m+3;d<R;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}h>>>=m,d-=m,y=0,c=3+(7&h),h>>>=3,d-=3}else{for(R=m+7;d<R;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}h>>>=m,d-=m,y=0,c=11+(127&h),h>>>=7,d-=7}if(a.have+c>a.nlen+a.ndist){t.msg="invalid bit length repeat",a.mode=me;break}for(;c--;)a.lens[a.have++]=y}}if(a.mode===me)break;if(0===a.lens[256]){t.msg="invalid code -- missing end-of-block",a.mode=me;break}if(a.lenbits=9,E={bits:a.lenbits},x=ne(1,a.lens,0,a.nlen,a.lencode,0,a.work,E),a.lenbits=E.bits,x){t.msg="invalid literal/lengths set",a.mode=me;break}if(a.distbits=6,a.distcode=a.distdyn,E={bits:a.distbits},x=ne(2,a.lens,a.nlen,a.ndist,a.distcode,0,a.work,E),a.distbits=E.bits,x){t.msg="invalid distances set",a.mode=me;break}if(a.mode=16199,e===oe)break t;case 16199:a.mode=16200;case 16200:if(o>=6&&l>=258){t.next_out=r,t.avail_out=l,t.next_in=s,t.avail_in=o,a.hold=h,a.bits=d,$t(t,f),r=t.next_out,n=t.output,l=t.avail_out,s=t.next_in,i=t.input,o=t.avail_in,h=a.hold,d=a.bits,16191===a.mode&&(a.back=-1);break}for(a.back=0;z=a.lencode[h&(1<<a.lenbits)-1],m=z>>>24,b=z>>>16&255,g=65535&z,!(m<=d);){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}if(b&&0==(240&b)){for(p=m,k=b,v=g;z=a.lencode[v+((h&(1<<p+k)-1)>>p)],m=z>>>24,b=z>>>16&255,g=65535&z,!(p+m<=d);){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}h>>>=p,d-=p,a.back+=p}if(h>>>=m,d-=m,a.back+=m,a.length=g,0===b){a.mode=16205;break}if(32&b){a.back=-1,a.mode=16191;break}if(64&b){t.msg="invalid literal/length code",a.mode=me;break}a.extra=15&b,a.mode=16201;case 16201:if(a.extra){for(R=a.extra;d<R;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}a.length+=h&(1<<a.extra)-1,h>>>=a.extra,d-=a.extra,a.back+=a.extra}a.was=a.length,a.mode=16202;case 16202:for(;z=a.distcode[h&(1<<a.distbits)-1],m=z>>>24,b=z>>>16&255,g=65535&z,!(m<=d);){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}if(0==(240&b)){for(p=m,k=b,v=g;z=a.distcode[v+((h&(1<<p+k)-1)>>p)],m=z>>>24,b=z>>>16&255,g=65535&z,!(p+m<=d);){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}h>>>=p,d-=p,a.back+=p}if(h>>>=m,d-=m,a.back+=m,64&b){t.msg="invalid distance code",a.mode=me;break}a.offset=g,a.extra=15&b,a.mode=16203;case 16203:if(a.extra){for(R=a.extra;d<R;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}a.offset+=h&(1<<a.extra)-1,h>>>=a.extra,d-=a.extra,a.back+=a.extra}if(a.offset>a.dmax){t.msg="invalid distance too far back",a.mode=me;break}a.mode=16204;case 16204:if(0===l)break t;if(c=f-l,a.offset>c){if(c=a.offset-c,c>a.whave&&a.sane){t.msg="invalid distance too far back",a.mode=me;break}c>a.wnext?(c-=a.wnext,u=a.wsize-c):u=a.wnext-c,c>a.length&&(c=a.length),w=a.window}else w=n,u=r-a.offset,c=a.length;c>l&&(c=l),l-=c,a.length-=c;do{n[r++]=w[u++]}while(--c);0===a.length&&(a.mode=16200);break;case 16205:if(0===l)break t;n[r++]=a.length,l--,a.mode=16200;break;case 16206:if(a.wrap){for(;d<32;){if(0===o)break t;o--,h|=i[s++]<<d,d+=8}if(f-=l,t.total_out+=f,a.total+=f,4&a.wrap&&f&&(t.adler=a.check=a.flags?N(a.check,n,f,r-f):F(a.check,n,f,r-f)),f=l,4&a.wrap&&(a.flags?h:be(h))!==a.check){t.msg="incorrect data check",a.mode=me;break}h=0,d=0}a.mode=16207;case 16207:if(a.wrap&&a.flags){for(;d<32;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}if(4&a.wrap&&h!==(4294967295&a.total)){t.msg="incorrect length check",a.mode=me;break}h=0,d=0}a.mode=16208;case 16208:x=he;break t;case me:x=fe;break t;case 16210:return ce;default:return _e}return t.next_out=r,t.avail_out=l,t.next_in=s,t.avail_in=o,a.hold=h,a.bits=d,(a.wsize||f!==t.avail_out&&a.mode<me&&(a.mode<16206||e!==se))&&Ze(t,t.output,t.next_out,f-t.avail_out),_-=t.avail_in,f-=t.avail_out,t.total_in+=_,t.total_out+=f,a.total+=f,4&a.wrap&&f&&(t.adler=a.check=a.flags?N(a.check,n,f,t.next_out-f):F(a.check,n,f,t.next_out-f)),t.data_type=a.bits+(a.last?64:0)+(16191===a.mode?128:0)+(16199===a.mode||16194===a.mode?256:0),(0===_&&0===f||e===se)&&x===le&&(x=ue),x},inflateEnd:t=>{if(pe(t))return _e;let e=t.state;return e.window&&(e.window=null),t.state=null,le},inflateGetHeader:(t,e)=>{if(pe(t))return _e;const a=t.state;return 0==(2&a.wrap)?_e:(a.head=e,e.done=!1,le)},inflateSetDictionary:(t,e)=>{const a=e.length;let i,n,s;return pe(t)?_e:(i=t.state,0!==i.wrap&&16190!==i.mode?_e:16190===i.mode&&(n=1,n=F(n,e,a,0),n!==i.check)?fe:(s=Ze(t,e,a,a),s?(i.mode=16210,ce):(i.havedict=1,le)))},inflateInfo:"pako inflate (from Nodeca project)"};var Se=function(){this.text=0,this.time=0,this.xflags=0,this.os=0,this.extra=null,this.extra_len=0,this.name="",this.comment="",this.hcrc=0,this.done=!1};const De=Object.prototype.toString,{Z_NO_FLUSH:Te,Z_FINISH:Oe,Z_OK:Fe,Z_STREAM_END:Le,Z_NEED_DICT:Ne,Z_STREAM_ERROR:Ie,Z_DATA_ERROR:Be,Z_MEM_ERROR:Ce}=B;function He(t){this.options=Tt({chunkSize:65536,windowBits:15,to:""},t||{});const e=this.options;e.raw&&e.windowBits>=0&&e.windowBits<16&&(e.windowBits=-e.windowBits,0===e.windowBits&&(e.windowBits=-15)),!(e.windowBits>=0&&e.windowBits<16)||t&&t.windowBits||(e.windowBits+=32),e.windowBits>15&&e.windowBits<48&&0==(15&e.windowBits)&&(e.windowBits|=15),this.err=0,this.msg="",this.ended=!1,this.chunks=[],this.strm=new Ct,this.strm.avail_out=0;let a=Ue.inflateInit2(this.strm,e.windowBits);if(a!==Fe)throw new Error(I[a]);if(this.header=new Se,Ue.inflateGetHeader(this.strm,this.header),e.dictionary&&("string"==typeof e.dictionary?e.dictionary=Nt(e.dictionary):"[object ArrayBuffer]"===De.call(e.dictionary)&&(e.dictionary=new Uint8Array(e.dictionary)),e.raw&&(a=Ue.inflateSetDictionary(this.strm,e.dictionary),a!==Fe)))throw new Error(I[a])}He.prototype.push=function(t,e){const a=this.strm,i=this.options.chunkSize,n=this.options.dictionary;let s,r,o;if(this.ended)return!1;for(r=e===~~e?e:!0===e?Oe:Te,"[object ArrayBuffer]"===De.call(t)?a.input=new Uint8Array(t):a.input=t,a.next_in=0,a.avail_in=a.input.length;;){for(0===a.avail_out&&(a.output=new Uint8Array(i),a.next_out=0,a.avail_out=i),s=Ue.inflate(a,r),s===Ne&&n&&(s=Ue.inflateSetDictionary(a,n),s===Fe?s=Ue.inflate(a,r):s===Be&&(s=Ne));a.avail_in>0&&s===Le&&a.state.wrap>0&&0!==t[a.next_in];)Ue.inflateReset(a),s=Ue.inflate(a,r);switch(s){case Ie:case Be:case Ne:case Ce:return this.onEnd(s),this.ended=!0,!1}if(o=a.avail_out,a.next_out&&(0===a.avail_out||s===Le))if("string"===this.options.to){let t=Bt(a.output,a.next_out),e=a.next_out-t,n=It(a.output,t);a.next_out=e,a.avail_out=i-e,e&&a.output.set(a.output.subarray(t,t+e),0),this.onData(n)}else this.onData(a.output.length===a.next_out?a.output:a.output.subarray(0,a.next_out));if(s!==Fe||0!==o){if(s===Le)return s=Ue.inflateEnd(this.strm),this.onEnd(s),this.ended=!0,!0;if(0===a.avail_in)break}}return!0},He.prototype.onData=function(t){this.chunks.push(t)},He.prototype.onEnd=function(t){t===Fe&&("string"===this.options.to?this.result=this.chunks.join(""):this.result=Ot(this.chunks)),this.chunks=[],this.err=t,this.msg=this.strm.msg};const{Deflate:Me,deflate:je,deflateRaw:Ke,gzip:Pe}=Vt;var Ye=Me,Ge=je,Xe=B;const We=new class{constructor(){this._init()}clear(){this._init()}addEvent(t){if(!t)throw new Error("Adding invalid event");const e=this._hasEvents?",":"";this.deflate.push(e+t,Xe.Z_SYNC_FLUSH),this._hasEvents=!0}finish(){if(this.deflate.push("]",Xe.Z_FINISH),this.deflate.err)throw this.deflate.err;const t=this.deflate.result;return this._init(),t}_init(){this._hasEvents=!1,this.deflate=new Ye,this.deflate.push("[",Xe.Z_NO_FLUSH)}},qe={clear:()=>{We.clear()},addEvent:t=>We.addEvent(t),finish:()=>We.finish(),compress:t=>function(t){return Ge(t)}(t)};addEventListener("message",(function(t){const e=t.data.method,a=t.data.id,i=t.data.arg;if(e in qe&&"function"==typeof qe[e])try{const t=qe[e](i);postMessage({id:a,method:e,success:!0,response:t})}catch(t){postMessage({id:a,method:e,success:!1,response:t.message}),console.error(t)}})),postMessage({id:void 0,method:"init",success:!0,response:void 0});`;

function e(){const e=new Blob([r]);return URL.createObjectURL(e)}

/**
 * Converts a timestamp to ms, if it was in s, or keeps it as ms.
 */
function timestampToMs(timestamp) {
  const isMs = timestamp > 9999999999;
  return isMs ? timestamp : timestamp * 1000;
}

/**
 * A basic event buffer that does not do any compression.
 * Used as fallback if the compression worker cannot be loaded or is disabled.
 */
class EventBufferArray  {
  /** All the events that are buffered to be sent. */

   __init() {this._totalSize = 0;}

   constructor() {EventBufferArray.prototype.__init.call(this);
    this.events = [];
  }

  /** @inheritdoc */
   get hasEvents() {
    return this.events.length > 0;
  }

  /** @inheritdoc */
   get type() {
    return 'sync';
  }

  /** @inheritdoc */
   destroy() {
    this.events = [];
  }

  /** @inheritdoc */
   async addEvent(event) {
    const eventSize = JSON.stringify(event).length;
    this._totalSize += eventSize;
    if (this._totalSize > REPLAY_MAX_EVENT_BUFFER_SIZE) {
      throw new EventBufferSizeExceededError();
    }

    this.events.push(event);
  }

  /** @inheritdoc */
   finish() {
    return new Promise(resolve => {
      // Make a copy of the events array reference and immediately clear the
      // events member so that we do not lose new events while uploading
      // attachment.
      const eventsRet = this.events;
      this.clear();
      resolve(JSON.stringify(eventsRet));
    });
  }

  /** @inheritdoc */
   clear() {
    this.events = [];
    this._totalSize = 0;
  }

  /** @inheritdoc */
   getEarliestTimestamp() {
    const timestamp = this.events.map(event => event.timestamp).sort()[0];

    if (!timestamp) {
      return null;
    }

    return timestampToMs(timestamp);
  }
}

/**
 * Event buffer that uses a web worker to compress events.
 * Exported only for testing.
 */
class WorkerHandler {

   constructor(worker) {
    this._worker = worker;
    this._id = 0;
  }

  /**
   * Ensure the worker is ready (or not).
   * This will either resolve when the worker is ready, or reject if an error occured.
   */
   ensureReady() {
    // Ensure we only check once
    if (this._ensureReadyPromise) {
      return this._ensureReadyPromise;
    }

    this._ensureReadyPromise = new Promise((resolve, reject) => {
      this._worker.addEventListener(
        'message',
        ({ data }) => {
          if ((data ).success) {
            resolve();
          } else {
            reject();
          }
        },
        { once: true },
      );

      this._worker.addEventListener(
        'error',
        error => {
          reject(error);
        },
        { once: true },
      );
    });

    return this._ensureReadyPromise;
  }

  /**
   * Destroy the worker.
   */
   destroy() {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log('[Replay] Destroying compression worker');
    this._worker.terminate();
  }

  /**
   * Post message to worker and wait for response before resolving promise.
   */
   postMessage(method, arg) {
    const id = this._getAndIncrementId();

    return new Promise((resolve, reject) => {
      const listener = ({ data }) => {
        const response = data ;
        if (response.method !== method) {
          return;
        }

        // There can be multiple listeners for a single method, the id ensures
        // that the response matches the caller.
        if (response.id !== id) {
          return;
        }

        // At this point, we'll always want to remove listener regardless of result status
        this._worker.removeEventListener('message', listener);

        if (!response.success) {
          // TODO: Do some error handling, not sure what
          (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.error */.kg.error('[Replay]', response.response);

          reject(new Error('Error in compression worker'));
          return;
        }

        resolve(response.response );
      };

      // Note: we can't use `once` option because it's possible it needs to
      // listen to multiple messages
      this._worker.addEventListener('message', listener);
      this._worker.postMessage({ id, method, arg });
    });
  }

  /** Get the current ID and increment it for the next call. */
   _getAndIncrementId() {
    return this._id++;
  }
}

/**
 * Event buffer that uses a web worker to compress events.
 * Exported only for testing.
 */
class EventBufferCompressionWorker  {

   __init() {this._totalSize = 0;}

   constructor(worker) {EventBufferCompressionWorker.prototype.__init.call(this);
    this._worker = new WorkerHandler(worker);
    this._earliestTimestamp = null;
  }

  /** @inheritdoc */
   get hasEvents() {
    return !!this._earliestTimestamp;
  }

  /** @inheritdoc */
   get type() {
    return 'worker';
  }

  /**
   * Ensure the worker is ready (or not).
   * This will either resolve when the worker is ready, or reject if an error occured.
   */
   ensureReady() {
    return this._worker.ensureReady();
  }

  /**
   * Destroy the event buffer.
   */
   destroy() {
    this._worker.destroy();
  }

  /**
   * Add an event to the event buffer.
   *
   * Returns true if event was successfuly received and processed by worker.
   */
   addEvent(event) {
    const timestamp = timestampToMs(event.timestamp);
    if (!this._earliestTimestamp || timestamp < this._earliestTimestamp) {
      this._earliestTimestamp = timestamp;
    }

    const data = JSON.stringify(event);
    this._totalSize += data.length;

    if (this._totalSize > REPLAY_MAX_EVENT_BUFFER_SIZE) {
      return Promise.reject(new EventBufferSizeExceededError());
    }

    return this._sendEventToWorker(data);
  }

  /**
   * Finish the event buffer and return the compressed data.
   */
   finish() {
    return this._finishRequest();
  }

  /** @inheritdoc */
   clear() {
    this._earliestTimestamp = null;
    this._totalSize = 0;
    // We do not wait on this, as we assume the order of messages is consistent for the worker
    void this._worker.postMessage('clear');
  }

  /** @inheritdoc */
   getEarliestTimestamp() {
    return this._earliestTimestamp;
  }

  /**
   * Send the event to the worker.
   */
   _sendEventToWorker(data) {
    return this._worker.postMessage('addEvent', data);
  }

  /**
   * Finish the request and return the compressed data from the worker.
   */
   async _finishRequest() {
    const response = await this._worker.postMessage('finish');

    this._earliestTimestamp = null;
    this._totalSize = 0;

    return response;
  }
}

/**
 * This proxy will try to use the compression worker, and fall back to use the simple buffer if an error occurs there.
 * This can happen e.g. if the worker cannot be loaded.
 * Exported only for testing.
 */
class EventBufferProxy  {

   constructor(worker) {
    this._fallback = new EventBufferArray();
    this._compression = new EventBufferCompressionWorker(worker);
    this._used = this._fallback;

    this._ensureWorkerIsLoadedPromise = this._ensureWorkerIsLoaded();
  }

  /** @inheritdoc */
   get type() {
    return this._used.type;
  }

  /** @inheritDoc */
   get hasEvents() {
    return this._used.hasEvents;
  }

  /** @inheritDoc */
   destroy() {
    this._fallback.destroy();
    this._compression.destroy();
  }

  /** @inheritdoc */
   clear() {
    return this._used.clear();
  }

  /** @inheritdoc */
   getEarliestTimestamp() {
    return this._used.getEarliestTimestamp();
  }

  /**
   * Add an event to the event buffer.
   *
   * Returns true if event was successfully added.
   */
   addEvent(event) {
    return this._used.addEvent(event);
  }

  /** @inheritDoc */
   async finish() {
    // Ensure the worker is loaded, so the sent event is compressed
    await this.ensureWorkerIsLoaded();

    return this._used.finish();
  }

  /** Ensure the worker has loaded. */
   ensureWorkerIsLoaded() {
    return this._ensureWorkerIsLoadedPromise;
  }

  /** Actually check if the worker has been loaded. */
   async _ensureWorkerIsLoaded() {
    try {
      await this._compression.ensureReady();
    } catch (error) {
      // If the worker fails to load, we fall back to the simple buffer.
      // Nothing more to do from our side here
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log('[Replay] Failed to load the compression worker, falling back to simple buffer');
      return;
    }

    // Now we need to switch over the array buffer to the compression worker
    await this._switchToCompressionWorker();
  }

  /** Switch the used buffer to the compression worker. */
   async _switchToCompressionWorker() {
    const { events } = this._fallback;

    const addEventPromises = [];
    for (const event of events) {
      addEventPromises.push(this._compression.addEvent(event));
    }

    // We switch over to the new buffer immediately - any further events will be added
    // after the previously buffered ones
    this._used = this._compression;

    // Wait for original events to be re-added before resolving
    try {
      await Promise.all(addEventPromises);
    } catch (error) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.warn */.kg.warn('[Replay] Failed to add events when switching buffers.', error);
    }
  }
}

/**
 * Create an event buffer for replays.
 */
function createEventBuffer({ useCompression }) {
  // eslint-disable-next-line no-restricted-globals
  if (useCompression && window.Worker) {
    try {
      const workerUrl = e();

      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log('[Replay] Using compression worker');
      const worker = new Worker(workerUrl);
      return new EventBufferProxy(worker);
    } catch (error) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log('[Replay] Failed to create compression worker');
      // Fall back to use simple event buffer array
    }
  }

  (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log('[Replay] Using simple buffer');
  return new EventBufferArray();
}

/** This error indicates that the event buffer size exceeded the limit.. */
class EventBufferSizeExceededError extends Error {
   constructor() {
    super(`Event buffer exceeded maximum size of ${REPLAY_MAX_EVENT_BUFFER_SIZE}.`);
  }
}

/**
 * Removes the session from Session Storage and unsets session in replay instance
 */
function clearSession(replay) {
  deleteSession();
  replay.session = undefined;
}

/**
 * Deletes a session from storage
 */
function deleteSession() {
  const hasSessionStorage = 'sessionStorage' in esm_WINDOW;

  if (!hasSessionStorage) {
    return;
  }

  try {
    esm_WINDOW.sessionStorage.removeItem(REPLAY_SESSION_KEY);
  } catch (e) {
    // Ignore potential SecurityError exceptions
  }
}

/**
 * Given an initial timestamp and an expiry duration, checks to see if current
 * time should be considered as expired.
 */
function isExpired(
  initialTime,
  expiry,
  targetTime = +new Date(),
) {
  // Always expired if < 0
  if (initialTime === null || expiry === undefined || expiry < 0) {
    return true;
  }

  // Never expires if == 0
  if (expiry === 0) {
    return false;
  }

  return initialTime + expiry <= targetTime;
}

/**
 * Checks to see if session is expired
 */
function isSessionExpired(session, timeouts, targetTime = +new Date()) {
  return (
    // First, check that maximum session length has not been exceeded
    isExpired(session.started, timeouts.maxSessionLife, targetTime) ||
    // check that the idle timeout has not been exceeded (i.e. user has
    // performed an action within the last `sessionIdleExpire` ms)
    isExpired(session.lastActivity, timeouts.sessionIdleExpire, targetTime)
  );
}

/**
 * Given a sample rate, returns true if replay should be sampled.
 *
 * 1.0 = 100% sampling
 * 0.0 = 0% sampling
 */
function isSampled(sampleRate) {
  if (sampleRate === undefined) {
    return false;
  }

  // Math.random() returns a number in range of 0 to 1 (inclusive of 0, but not 1)
  return Math.random() < sampleRate;
}

/**
 * Save a session to session storage.
 */
function saveSession(session) {
  const hasSessionStorage = 'sessionStorage' in esm_WINDOW;
  if (!hasSessionStorage) {
    return;
  }

  try {
    esm_WINDOW.sessionStorage.setItem(REPLAY_SESSION_KEY, JSON.stringify(session));
  } catch (e) {
    // Ignore potential SecurityError exceptions
  }
}

/**
 * Get a session with defaults & applied sampling.
 */
function makeSession(session) {
  const now = Date.now();
  const id = session.id || (0,misc/* uuid4 */.DM)();
  // Note that this means we cannot set a started/lastActivity of `0`, but this should not be relevant outside of tests.
  const started = session.started || now;
  const lastActivity = session.lastActivity || now;
  const segmentId = session.segmentId || 0;
  const sampled = session.sampled;

  return {
    id,
    started,
    lastActivity,
    segmentId,
    sampled,
    shouldRefresh: true,
  };
}

/**
 * Get the sampled status for a session based on sample rates & current sampled status.
 */
function getSessionSampleType(sessionSampleRate, allowBuffering) {
  return isSampled(sessionSampleRate) ? 'session' : allowBuffering ? 'buffer' : false;
}

/**
 * Create a new session, which in its current implementation is a Sentry event
 * that all replays will be saved to as attachments. Currently, we only expect
 * one of these Sentry events per "replay session".
 */
function createSession({ sessionSampleRate, allowBuffering, stickySession = false }) {
  const sampled = getSessionSampleType(sessionSampleRate, allowBuffering);
  const session = makeSession({
    sampled,
  });

  (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log(`[Replay] Creating new session: ${session.id}`);

  if (stickySession) {
    saveSession(session);
  }

  return session;
}

/**
 * Fetches a session from storage
 */
function fetchSession() {
  const hasSessionStorage = 'sessionStorage' in esm_WINDOW;

  if (!hasSessionStorage) {
    return null;
  }

  try {
    // This can throw if cookies are disabled
    const sessionStringFromStorage = esm_WINDOW.sessionStorage.getItem(REPLAY_SESSION_KEY);

    if (!sessionStringFromStorage) {
      return null;
    }

    const sessionObj = JSON.parse(sessionStringFromStorage) ;

    return makeSession(sessionObj);
  } catch (e) {
    return null;
  }
}

/**
 * Get or create a session
 */
function getSession({
  timeouts,
  currentSession,
  stickySession,
  sessionSampleRate,
  allowBuffering,
}) {
  // If session exists and is passed, use it instead of always hitting session storage
  const session = currentSession || (stickySession && fetchSession());

  if (session) {
    // If there is a session, check if it is valid (e.g. "last activity" time
    // should be within the "session idle time", and "session started" time is
    // within "max session time").
    const isExpired = isSessionExpired(session, timeouts);

    if (!isExpired || (allowBuffering && session.shouldRefresh)) {
      return { type: 'saved', session };
    } else if (!session.shouldRefresh) {
      // This is the case if we have an error session that is completed
      // (=triggered an error). Session will continue as session-based replay,
      // and when this session is expired, it will not be renewed until user
      // reloads.
      const discardedSession = makeSession({ sampled: false });
      return { type: 'new', session: discardedSession };
    } else {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log('[Replay] Session has expired');
    }
    // Otherwise continue to create a new session
  }

  const newSession = createSession({
    stickySession,
    sessionSampleRate,
    allowBuffering,
  });

  return { type: 'new', session: newSession };
}

function isCustomEvent(event) {
  return event.type === EventType.Custom;
}

/**
 * Add an event to the event buffer.
 * `isCheckout` is true if this is either the very first event, or an event triggered by `checkoutEveryNms`.
 */
async function addEvent(
  replay,
  event,
  isCheckout,
) {
  if (!replay.eventBuffer) {
    // This implies that `_isEnabled` is false
    return null;
  }

  if (replay.isPaused()) {
    // Do not add to event buffer when recording is paused
    return null;
  }

  const timestampInMs = timestampToMs(event.timestamp);

  // Throw out events that happen more than 5 minutes ago. This can happen if
  // page has been left open and idle for a long period of time and user
  // comes back to trigger a new session. The performance entries rely on
  // `performance.timeOrigin`, which is when the page first opened.
  if (timestampInMs + replay.timeouts.sessionIdlePause < Date.now()) {
    return null;
  }

  try {
    if (isCheckout) {
      replay.eventBuffer.clear();
    }

    const replayOptions = replay.getOptions();

    const eventAfterPossibleCallback =
      typeof replayOptions.beforeAddRecordingEvent === 'function' && isCustomEvent(event)
        ? replayOptions.beforeAddRecordingEvent(event)
        : event;

    if (!eventAfterPossibleCallback) {
      return;
    }

    return await replay.eventBuffer.addEvent(eventAfterPossibleCallback);
  } catch (error) {
    const reason = error && error instanceof EventBufferSizeExceededError ? 'addEventSizeExceeded' : 'addEvent';

    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.error */.kg.error(error);
    await replay.stop(reason);

    const client = (0,esm_hub/* getCurrentHub */.Gd)().getClient();

    if (client) {
      client.recordDroppedEvent('internal_sdk_error', 'replay');
    }
  }
}

/** If the event is an error event */
function isErrorEvent(event) {
  return !event.type;
}

/** If the event is a transaction event */
function isTransactionEvent(event) {
  return event.type === 'transaction';
}

/** If the event is an replay event */
function isReplayEvent(event) {
  return event.type === 'replay_event';
}

/**
 * Returns a listener to be added to `client.on('afterSendErrorEvent, listener)`.
 */
function handleAfterSendEvent(replay) {
  // Custom transports may still be returning `Promise<void>`, which means we cannot expect the status code to be available there
  // TODO (v8): remove this check as it will no longer be necessary
  const enforceStatusCode = isBaseTransportSend();

  return (event, sendResponse) => {
    if (!isErrorEvent(event) && !isTransactionEvent(event)) {
      return;
    }

    const statusCode = sendResponse && sendResponse.statusCode;

    // We only want to do stuff on successful error sending, otherwise you get error replays without errors attached
    // If not using the base transport, we allow `undefined` response (as a custom transport may not implement this correctly yet)
    // If we do use the base transport, we skip if we encountered an non-OK status code
    if (enforceStatusCode && (!statusCode || statusCode < 200 || statusCode >= 300)) {
      return;
    }

    // Collect traceIds in _context regardless of `recordingMode`
    // In error mode, _context gets cleared on every checkout
    if (isTransactionEvent(event) && event.contexts && event.contexts.trace && event.contexts.trace.trace_id) {
      replay.getContext().traceIds.add(event.contexts.trace.trace_id );
      return;
    }

    // Everything below is just for error events
    if (!isErrorEvent(event)) {
      return;
    }

    // Add error to list of errorIds of replay. This is ok to do even if not
    // sampled because context will get reset at next checkout.
    // XXX: There is also a race condition where it's possible to capture an
    // error to Sentry before Replay SDK has loaded, but response returns after
    // it was loaded, and this gets called.
    if (event.event_id) {
      replay.getContext().errorIds.add(event.event_id);
    }

    // If error event is tagged with replay id it means it was sampled (when in buffer mode)
    // Need to be very careful that this does not cause an infinite loop
    if (replay.recordingMode === 'buffer' && event.tags && event.tags.replayId) {
      setTimeout(() => {
        // Capture current event buffer as new replay
        void replay.sendBufferedReplayOrFlush();
      });
    }
  };
}

function isBaseTransportSend() {
  const client = (0,esm_hub/* getCurrentHub */.Gd)().getClient();
  if (!client) {
    return false;
  }

  const transport = client.getTransport();
  if (!transport) {
    return false;
  }

  return (
    (transport.send ).__sentry__baseTransport__ || false
  );
}

/**
 * Returns true if we think the given event is an error originating inside of rrweb.
 */
function isRrwebError(event, hint) {
  if (event.type || !event.exception || !event.exception.values || !event.exception.values.length) {
    return false;
  }

  // @ts-ignore this may be set by rrweb when it finds errors
  if (hint.originalException && hint.originalException.__rrweb__) {
    return true;
  }

  // Check if any exception originates from rrweb
  return event.exception.values.some(exception => {
    if (!exception.stacktrace || !exception.stacktrace.frames || !exception.stacktrace.frames.length) {
      return false;
    }

    return exception.stacktrace.frames.some(frame => frame.filename && frame.filename.includes('/rrweb/src/'));
  });
}

/**
 * Determine if event should be sampled (only applies in buffer mode).
 * When an event is captured by `hanldleGlobalEvent`, when in buffer mode
 * we determine if we want to sample the error or not.
 */
function shouldSampleForBufferEvent(replay, event) {
  if (replay.recordingMode !== 'buffer') {
    return false;
  }

  // ignore this error because otherwise we could loop indefinitely with
  // trying to capture replay and failing
  if (event.message === UNABLE_TO_SEND_REPLAY) {
    return false;
  }

  // Require the event to be an error event & to have an exception
  if (!event.exception || event.type) {
    return false;
  }

  return isSampled(replay.getOptions().errorSampleRate);
}

/**
 * Returns a listener to be added to `addGlobalEventProcessor(listener)`.
 */
function handleGlobalEventListener(
  replay,
  includeAfterSendEventHandling = false,
) {
  const afterSendHandler = includeAfterSendEventHandling ? handleAfterSendEvent(replay) : undefined;

  return (event, hint) => {
    if (isReplayEvent(event)) {
      // Replays have separate set of breadcrumbs, do not include breadcrumbs
      // from core SDK
      delete event.breadcrumbs;
      return event;
    }

    // We only want to handle errors & transactions, nothing else
    if (!isErrorEvent(event) && !isTransactionEvent(event)) {
      return event;
    }

    // Unless `captureExceptions` is enabled, we want to ignore errors coming from rrweb
    // As there can be a bunch of stuff going wrong in internals there, that we don't want to bubble up to users
    if (isRrwebError(event, hint) && !replay.getOptions()._experiments.captureExceptions) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log('[Replay] Ignoring error from rrweb internals', event);
      return null;
    }

    // When in buffer mode, we decide to sample here.
    // Later, in `handleAfterSendEvent`, if the replayId is set, we know that we sampled
    // And convert the buffer session to a full session
    const isErrorEventSampled = shouldSampleForBufferEvent(replay, event);

    // Tag errors if it has been sampled in buffer mode, or if it is session mode
    // Only tag transactions if in session mode
    const shouldTagReplayId = isErrorEventSampled || replay.recordingMode === 'session';

    if (shouldTagReplayId) {
      event.tags = { ...event.tags, replayId: replay.getSessionId() };
    }

    // In cases where a custom client is used that does not support the new hooks (yet),
    // we manually call this hook method here
    if (afterSendHandler) {
      // Pretend the error had a 200 response so we always capture it
      afterSendHandler(event, { statusCode: 200 });
    }

    return event;
  };
}

/**
 * Create a "span" for each performance entry.
 */
function createPerformanceSpans(
  replay,
  entries,
) {
  return entries.map(({ type, start, end, name, data }) => {
    const response = replay.throttledAddEvent({
      type: EventType.Custom,
      timestamp: start,
      data: {
        tag: 'performanceSpan',
        payload: {
          op: type,
          description: name,
          startTimestamp: start,
          endTimestamp: end,
          data,
        },
      },
    });

    // If response is a string, it means its either THROTTLED or SKIPPED
    return typeof response === 'string' ? Promise.resolve(null) : response;
  });
}

function handleHistory(handlerData) {
  const { from, to } = handlerData;

  const now = Date.now() / 1000;

  return {
    type: 'navigation.push',
    start: now,
    end: now,
    name: to,
    data: {
      previous: from,
    },
  };
}

/**
 * Returns a listener to be added to `addInstrumentationHandler('history', listener)`.
 */
function handleHistorySpanListener(replay) {
  return (handlerData) => {
    if (!replay.isEnabled()) {
      return;
    }

    const result = handleHistory(handlerData);

    if (result === null) {
      return;
    }

    // Need to collect visited URLs
    replay.getContext().urls.push(result.name);
    replay.triggerUserActivity();

    replay.addUpdate(() => {
      createPerformanceSpans(replay, [result]);
      // Returning false to flush
      return false;
    });
  };
}

/**
 * Check whether a given request URL should be filtered out. This is so we
 * don't log Sentry ingest requests.
 */
function shouldFilterRequest(replay, url) {
  // If we enabled the `traceInternals` experiment, we want to trace everything
  if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && replay.getOptions()._experiments.traceInternals) {
    return false;
  }

  return _isSentryRequest(url);
}

/**
 * Checks wether a given URL belongs to the configured Sentry DSN.
 */
function _isSentryRequest(url) {
  const client = (0,esm_hub/* getCurrentHub */.Gd)().getClient();
  const dsn = client && client.getDsn();
  return dsn ? url.includes(dsn.host) : false;
}

/** Add a performance entry breadcrumb */
function addNetworkBreadcrumb(
  replay,
  result,
) {
  if (!replay.isEnabled()) {
    return;
  }

  if (result === null) {
    return;
  }

  if (shouldFilterRequest(replay, result.name)) {
    return;
  }

  replay.addUpdate(() => {
    createPerformanceSpans(replay, [result]);
    // Returning true will cause `addUpdate` to not flush
    // We do not want network requests to cause a flush. This will prevent
    // recurring/polling requests from keeping the replay session alive.
    return true;
  });
}

/** only exported for tests */
function handleFetch(handlerData) {
  const { startTimestamp, endTimestamp, fetchData, response } = handlerData;

  if (!endTimestamp) {
    return null;
  }

  // This is only used as a fallback, so we know the body sizes are never set here
  const { method, url } = fetchData;

  return {
    type: 'resource.fetch',
    start: startTimestamp / 1000,
    end: endTimestamp / 1000,
    name: url,
    data: {
      method,
      statusCode: response && (response ).status,
    },
  };
}

/**
 * Returns a listener to be added to `addInstrumentationHandler('fetch', listener)`.
 */
function handleFetchSpanListener(replay) {
  return (handlerData) => {
    if (!replay.isEnabled()) {
      return;
    }

    const result = handleFetch(handlerData);

    addNetworkBreadcrumb(replay, result);
  };
}

/** only exported for tests */
function handleXhr(handlerData) {
  const { startTimestamp, endTimestamp, xhr } = handlerData;

  const sentryXhrData = xhr[instrument/* SENTRY_XHR_DATA_KEY */.xU];

  if (!startTimestamp || !endTimestamp || !sentryXhrData) {
    return null;
  }

  // This is only used as a fallback, so we know the body sizes are never set here
  const { method, url, status_code: statusCode } = sentryXhrData;

  if (url === undefined) {
    return null;
  }

  return {
    type: 'resource.xhr',
    name: url,
    start: startTimestamp / 1000,
    end: endTimestamp / 1000,
    data: {
      method,
      statusCode,
    },
  };
}

/**
 * Returns a listener to be added to `addInstrumentationHandler('xhr', listener)`.
 */
function handleXhrSpanListener(replay) {
  return (handlerData) => {
    if (!replay.isEnabled()) {
      return;
    }

    const result = handleXhr(handlerData);

    addNetworkBreadcrumb(replay, result);
  };
}

const OBJ = 10;
const OBJ_KEY = 11;
const OBJ_KEY_STR = 12;
const OBJ_VAL = 13;
const OBJ_VAL_STR = 14;
const OBJ_VAL_COMPLETED = 15;

const ARR = 20;
const ARR_VAL = 21;
const ARR_VAL_STR = 22;
const ARR_VAL_COMPLETED = 23;

const ALLOWED_PRIMITIVES = ['true', 'false', 'null'];

/**
 * Complete an incomplete JSON string.
 * This will ensure that the last element always has a `"~~"` to indicate it was truncated.
 * For example, `[1,2,` will be completed to `[1,2,"~~"]`
 * and `{"aa":"b` will be completed to `{"aa":"b~~"}`
 */
function completeJson(incompleteJson, stack) {
  if (!stack.length) {
    return incompleteJson;
  }

  let json = incompleteJson;

  // Most checks are only needed for the last step in the stack
  const lastPos = stack.length - 1;
  const lastStep = stack[lastPos];

  json = _fixLastStep(json, lastStep);

  // Complete remaining steps - just add closing brackets
  for (let i = lastPos; i >= 0; i--) {
    const step = stack[i];

    switch (step) {
      case OBJ:
        json = `${json}}`;
        break;
      case ARR:
        json = `${json}]`;
        break;
    }
  }

  return json;
}

function _fixLastStep(json, lastStep) {
  switch (lastStep) {
    // Object cases
    case OBJ:
      return `${json}"~~":"~~"`;
    case OBJ_KEY:
      return `${json}:"~~"`;
    case OBJ_KEY_STR:
      return `${json}~~":"~~"`;
    case OBJ_VAL:
      return _maybeFixIncompleteObjValue(json);
    case OBJ_VAL_STR:
      return `${json}~~"`;
    case OBJ_VAL_COMPLETED:
      return `${json},"~~":"~~"`;

    // Array cases
    case ARR:
      return `${json}"~~"`;
    case ARR_VAL:
      return _maybeFixIncompleteArrValue(json);
    case ARR_VAL_STR:
      return `${json}~~"`;
    case ARR_VAL_COMPLETED:
      return `${json},"~~"`;
  }

  return json;
}

function _maybeFixIncompleteArrValue(json) {
  const pos = _findLastArrayDelimiter(json);

  if (pos > -1) {
    const part = json.slice(pos + 1);

    if (ALLOWED_PRIMITIVES.includes(part.trim())) {
      return `${json},"~~"`;
    }

    // Everything else is replaced with `"~~"`
    return `${json.slice(0, pos + 1)}"~~"`;
  }

  // fallback, this shouldn't happen, to be save
  return json;
}

function _findLastArrayDelimiter(json) {
  for (let i = json.length - 1; i >= 0; i--) {
    const char = json[i];

    if (char === ',' || char === '[') {
      return i;
    }
  }

  return -1;
}

function _maybeFixIncompleteObjValue(json) {
  const startPos = json.lastIndexOf(':');

  const part = json.slice(startPos + 1);

  if (ALLOWED_PRIMITIVES.includes(part.trim())) {
    return `${json},"~~":"~~"`;
  }

  // Everything else is replaced with `"~~"`
  // This also means we do not have incomplete numbers, e.g `[1` is replaced with `["~~"]`
  return `${json.slice(0, startPos + 1)}"~~"`;
}

/**
 * Evaluate an (incomplete) JSON string.
 */
function evaluateJson(json) {
  const stack = [];

  for (let pos = 0; pos < json.length; pos++) {
    _evaluateJsonPos(stack, json, pos);
  }

  return stack;
}

function _evaluateJsonPos(stack, json, pos) {
  const curStep = stack[stack.length - 1];

  const char = json[pos];

  const whitespaceRegex = /\s/;

  if (whitespaceRegex.test(char)) {
    return;
  }

  if (char === '"' && !_isEscaped(json, pos)) {
    _handleQuote(stack, curStep);
    return;
  }

  switch (char) {
    case '{':
      _handleObj(stack, curStep);
      break;
    case '[':
      _handleArr(stack, curStep);
      break;
    case ':':
      _handleColon(stack, curStep);
      break;
    case ',':
      _handleComma(stack, curStep);
      break;
    case '}':
      _handleObjClose(stack, curStep);
      break;
    case ']':
      _handleArrClose(stack, curStep);
      break;
  }
}

function _handleQuote(stack, curStep) {
  // End of obj value
  if (curStep === OBJ_VAL_STR) {
    stack.pop();
    stack.push(OBJ_VAL_COMPLETED);
    return;
  }

  // End of arr value
  if (curStep === ARR_VAL_STR) {
    stack.pop();
    stack.push(ARR_VAL_COMPLETED);
    return;
  }

  // Start of obj value
  if (curStep === OBJ_VAL) {
    stack.push(OBJ_VAL_STR);
    return;
  }

  // Start of arr value
  if (curStep === ARR_VAL) {
    stack.push(ARR_VAL_STR);
    return;
  }

  // Start of obj key
  if (curStep === OBJ) {
    stack.push(OBJ_KEY_STR);
    return;
  }

  // End of obj key
  if (curStep === OBJ_KEY_STR) {
    stack.pop();
    stack.push(OBJ_KEY);
    return;
  }
}

function _handleObj(stack, curStep) {
  // Initial object
  if (!curStep) {
    stack.push(OBJ);
    return;
  }

  // New object as obj value
  if (curStep === OBJ_VAL) {
    stack.push(OBJ);
    return;
  }

  // New object as array element
  if (curStep === ARR_VAL) {
    stack.push(OBJ);
  }

  // New object as first array element
  if (curStep === ARR) {
    stack.push(OBJ);
    return;
  }
}

function _handleArr(stack, curStep) {
  // Initial array
  if (!curStep) {
    stack.push(ARR);
    stack.push(ARR_VAL);
    return;
  }

  // New array as obj value
  if (curStep === OBJ_VAL) {
    stack.push(ARR);
    stack.push(ARR_VAL);
    return;
  }

  // New array as array element
  if (curStep === ARR_VAL) {
    stack.push(ARR);
    stack.push(ARR_VAL);
  }

  // New array as first array element
  if (curStep === ARR) {
    stack.push(ARR);
    stack.push(ARR_VAL);
    return;
  }
}

function _handleColon(stack, curStep) {
  if (curStep === OBJ_KEY) {
    stack.pop();
    stack.push(OBJ_VAL);
  }
}

function _handleComma(stack, curStep) {
  // Comma after obj value
  if (curStep === OBJ_VAL) {
    stack.pop();
    return;
  }
  if (curStep === OBJ_VAL_COMPLETED) {
    // Pop OBJ_VAL_COMPLETED & OBJ_VAL
    stack.pop();
    stack.pop();
    return;
  }

  // Comma after arr value
  if (curStep === ARR_VAL) {
    // do nothing - basically we'd pop ARR_VAL but add it right back
    return;
  }

  if (curStep === ARR_VAL_COMPLETED) {
    // Pop ARR_VAL_COMPLETED
    stack.pop();

    // basically we'd pop ARR_VAL but add it right back
    return;
  }
}

function _handleObjClose(stack, curStep) {
  // Empty object {}
  if (curStep === OBJ) {
    stack.pop();
  }

  // Object with element
  if (curStep === OBJ_VAL) {
    // Pop OBJ_VAL, OBJ
    stack.pop();
    stack.pop();
  }

  // Obj with element
  if (curStep === OBJ_VAL_COMPLETED) {
    // Pop OBJ_VAL_COMPLETED, OBJ_VAL, OBJ
    stack.pop();
    stack.pop();
    stack.pop();
  }

  // if was obj value, complete it
  if (stack[stack.length - 1] === OBJ_VAL) {
    stack.push(OBJ_VAL_COMPLETED);
  }

  // if was arr value, complete it
  if (stack[stack.length - 1] === ARR_VAL) {
    stack.push(ARR_VAL_COMPLETED);
  }
}

function _handleArrClose(stack, curStep) {
  // Empty array []
  if (curStep === ARR) {
    stack.pop();
  }

  // Array with element
  if (curStep === ARR_VAL) {
    // Pop ARR_VAL, ARR
    stack.pop();
    stack.pop();
  }

  // Array with element
  if (curStep === ARR_VAL_COMPLETED) {
    // Pop ARR_VAL_COMPLETED, ARR_VAL, ARR
    stack.pop();
    stack.pop();
    stack.pop();
  }

  // if was obj value, complete it
  if (stack[stack.length - 1] === OBJ_VAL) {
    stack.push(OBJ_VAL_COMPLETED);
  }

  // if was arr value, complete it
  if (stack[stack.length - 1] === ARR_VAL) {
    stack.push(ARR_VAL_COMPLETED);
  }
}

function _isEscaped(str, pos) {
  const previousChar = str[pos - 1];

  return previousChar === '\\' && !_isEscaped(str, pos - 1);
}

/* eslint-disable max-lines */

/**
 * Takes an incomplete JSON string, and returns a hopefully valid JSON string.
 * Note that this _can_ fail, so you should check the return value is valid JSON.
 */
function fixJson(incompleteJson) {
  const stack = evaluateJson(incompleteJson);

  return completeJson(incompleteJson, stack);
}

/** Get the size of a body. */
function getBodySize(
  body,
  textEncoder,
) {
  if (!body) {
    return undefined;
  }

  try {
    if (typeof body === 'string') {
      return textEncoder.encode(body).length;
    }

    if (body instanceof URLSearchParams) {
      return textEncoder.encode(body.toString()).length;
    }

    if (body instanceof FormData) {
      const formDataStr = _serializeFormData(body);
      return textEncoder.encode(formDataStr).length;
    }

    if (body instanceof Blob) {
      return body.size;
    }

    if (body instanceof ArrayBuffer) {
      return body.byteLength;
    }

    // Currently unhandled types: ArrayBufferView, ReadableStream
  } catch (e) {
    // just return undefined
  }

  return undefined;
}

/** Convert a Content-Length header to number/undefined.  */
function parseContentLengthHeader(header) {
  if (!header) {
    return undefined;
  }

  const size = parseInt(header, 10);
  return isNaN(size) ? undefined : size;
}

/** Get the string representation of a body. */
function getBodyString(body) {
  if (typeof body === 'string') {
    return body;
  }

  if (body instanceof URLSearchParams) {
    return body.toString();
  }

  if (body instanceof FormData) {
    return _serializeFormData(body);
  }

  return undefined;
}

/** Convert ReplayNetworkRequestData to a PerformanceEntry. */
function makeNetworkReplayBreadcrumb(
  type,
  data,
) {
  if (!data) {
    return null;
  }

  const { startTimestamp, endTimestamp, url, method, statusCode, request, response } = data;

  const result = {
    type,
    start: startTimestamp / 1000,
    end: endTimestamp / 1000,
    name: url,
    data: (0,object/* dropUndefinedKeys */.Jr)({
      method,
      statusCode,
      request,
      response,
    }),
  };

  return result;
}

/** Build the request or response part of a replay network breadcrumb that was skipped. */
function buildSkippedNetworkRequestOrResponse(bodySize) {
  return {
    headers: {},
    size: bodySize,
    _meta: {
      warnings: ['URL_SKIPPED'],
    },
  };
}

/** Build the request or response part of a replay network breadcrumb. */
function buildNetworkRequestOrResponse(
  headers,
  bodySize,
  body,
) {
  if (!bodySize && Object.keys(headers).length === 0) {
    return undefined;
  }

  if (!bodySize) {
    return {
      headers,
    };
  }

  if (!body) {
    return {
      headers,
      size: bodySize,
    };
  }

  const info = {
    headers,
    size: bodySize,
  };

  const { body: normalizedBody, warnings } = normalizeNetworkBody(body);
  info.body = normalizedBody;
  if (warnings.length > 0) {
    info._meta = {
      warnings,
    };
  }

  return info;
}

/** Filter a set of headers */
function getAllowedHeaders(headers, allowedHeaders) {
  return Object.keys(headers).reduce((filteredHeaders, key) => {
    const normalizedKey = key.toLowerCase();
    // Avoid putting empty strings into the headers
    if (allowedHeaders.includes(normalizedKey) && headers[key]) {
      filteredHeaders[normalizedKey] = headers[key];
    }
    return filteredHeaders;
  }, {});
}

function _serializeFormData(formData) {
  // This is a bit simplified, but gives us a decent estimate
  // This converts e.g. { name: 'Anne Smith', age: 13 } to 'name=Anne+Smith&age=13'
  // @ts-ignore passing FormData to URLSearchParams actually works
  return new URLSearchParams(formData).toString();
}

function normalizeNetworkBody(body)

 {
  if (!body || typeof body !== 'string') {
    return {
      body,
      warnings: [],
    };
  }

  const exceedsSizeLimit = body.length > NETWORK_BODY_MAX_SIZE;

  if (_strIsProbablyJson(body)) {
    try {
      const json = exceedsSizeLimit ? fixJson(body.slice(0, NETWORK_BODY_MAX_SIZE)) : body;
      const normalizedBody = JSON.parse(json);
      return {
        body: normalizedBody,
        warnings: exceedsSizeLimit ? ['JSON_TRUNCATED'] : [],
      };
    } catch (e3) {
      return {
        body: exceedsSizeLimit ? `${body.slice(0, NETWORK_BODY_MAX_SIZE)}…` : body,
        warnings: exceedsSizeLimit ? ['INVALID_JSON', 'TEXT_TRUNCATED'] : ['INVALID_JSON'],
      };
    }
  }

  return {
    body: exceedsSizeLimit ? `${body.slice(0, NETWORK_BODY_MAX_SIZE)}…` : body,
    warnings: exceedsSizeLimit ? ['TEXT_TRUNCATED'] : [],
  };
}

function _strIsProbablyJson(str) {
  const first = str[0];
  const last = str[str.length - 1];

  // Simple check: If this does not start & end with {} or [], it's not JSON
  return (first === '[' && last === ']') || (first === '{' && last === '}');
}

/** Match an URL against a list of strings/Regex. */
function urlMatches(url, urls) {
  const fullUrl = getFullUrl(url);

  return (0,string/* stringMatchesSomePattern */.U0)(fullUrl, urls);
}

/** exported for tests */
function getFullUrl(url, baseURI = esm_WINDOW.document.baseURI) {
  // Short circuit for common cases:
  if (url.startsWith('http://') || url.startsWith('https://') || url.startsWith(esm_WINDOW.location.origin)) {
    return url;
  }
  const fixedUrl = new URL(url, baseURI);

  // If these do not match, we are not dealing with a relative URL, so just return it
  if (fixedUrl.origin !== new URL(baseURI).origin) {
    return url;
  }

  const fullUrl = fixedUrl.href;

  // Remove trailing slashes, if they don't match the original URL
  if (!url.endsWith('/') && fullUrl.endsWith('/')) {
    return fullUrl.slice(0, -1);
  }

  return fullUrl;
}

/**
 * Capture a fetch breadcrumb to a replay.
 * This adds additional data (where approriate).
 */
async function captureFetchBreadcrumbToReplay(
  breadcrumb,
  hint,
  options

,
) {
  try {
    const data = await _prepareFetchData(breadcrumb, hint, options);

    // Create a replay performance entry from this breadcrumb
    const result = makeNetworkReplayBreadcrumb('resource.fetch', data);
    addNetworkBreadcrumb(options.replay, result);
  } catch (error) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.error */.kg.error('[Replay] Failed to capture fetch breadcrumb', error);
  }
}

/**
 * Enrich a breadcrumb with additional data.
 * This has to be sync & mutate the given breadcrumb,
 * as the breadcrumb is afterwards consumed by other handlers.
 */
function enrichFetchBreadcrumb(
  breadcrumb,
  hint,
  options,
) {
  const { input, response } = hint;

  const body = _getFetchRequestArgBody(input);
  const reqSize = getBodySize(body, options.textEncoder);

  const resSize = response ? parseContentLengthHeader(response.headers.get('content-length')) : undefined;

  if (reqSize !== undefined) {
    breadcrumb.data.request_body_size = reqSize;
  }
  if (resSize !== undefined) {
    breadcrumb.data.response_body_size = resSize;
  }
}

async function _prepareFetchData(
  breadcrumb,
  hint,
  options

,
) {
  const { startTimestamp, endTimestamp } = hint;

  const {
    url,
    method,
    status_code: statusCode = 0,
    request_body_size: requestBodySize,
    response_body_size: responseBodySize,
  } = breadcrumb.data;

  const captureDetails = urlMatches(url, options.networkDetailAllowUrls);

  const request = captureDetails
    ? _getRequestInfo(options, hint.input, requestBodySize)
    : buildSkippedNetworkRequestOrResponse(requestBodySize);
  const response = await _getResponseInfo(captureDetails, options, hint.response, responseBodySize);

  return {
    startTimestamp,
    endTimestamp,
    url,
    method,
    statusCode,
    request,
    response,
  };
}

function _getRequestInfo(
  { networkCaptureBodies, networkRequestHeaders },
  input,
  requestBodySize,
) {
  const headers = getRequestHeaders(input, networkRequestHeaders);

  if (!networkCaptureBodies) {
    return buildNetworkRequestOrResponse(headers, requestBodySize, undefined);
  }

  // We only want to transmit string or string-like bodies
  const requestBody = _getFetchRequestArgBody(input);
  const bodyStr = getBodyString(requestBody);
  return buildNetworkRequestOrResponse(headers, requestBodySize, bodyStr);
}

async function _getResponseInfo(
  captureDetails,
  {
    networkCaptureBodies,
    textEncoder,
    networkResponseHeaders,
  }

,
  response,
  responseBodySize,
) {
  if (!captureDetails && responseBodySize !== undefined) {
    return buildSkippedNetworkRequestOrResponse(responseBodySize);
  }

  const headers = getAllHeaders(response.headers, networkResponseHeaders);

  if (!networkCaptureBodies && responseBodySize !== undefined) {
    return buildNetworkRequestOrResponse(headers, responseBodySize, undefined);
  }

  // Only clone the response if we need to
  try {
    // We have to clone this, as the body can only be read once
    const res = response.clone();
    const bodyText = await _parseFetchBody(res);

    const size =
      bodyText && bodyText.length && responseBodySize === undefined
        ? getBodySize(bodyText, textEncoder)
        : responseBodySize;

    if (!captureDetails) {
      return buildSkippedNetworkRequestOrResponse(size);
    }

    if (networkCaptureBodies) {
      return buildNetworkRequestOrResponse(headers, size, bodyText);
    }

    return buildNetworkRequestOrResponse(headers, size, undefined);
  } catch (e) {
    // fallback
    return buildNetworkRequestOrResponse(headers, responseBodySize, undefined);
  }
}

async function _parseFetchBody(response) {
  try {
    return await response.text();
  } catch (e2) {
    return undefined;
  }
}

function _getFetchRequestArgBody(fetchArgs = []) {
  // We only support getting the body from the fetch options
  if (fetchArgs.length !== 2 || typeof fetchArgs[1] !== 'object') {
    return undefined;
  }

  return (fetchArgs[1] ).body;
}

function getAllHeaders(headers, allowedHeaders) {
  const allHeaders = {};

  allowedHeaders.forEach(header => {
    if (headers.get(header)) {
      allHeaders[header] = headers.get(header) ;
    }
  });

  return allHeaders;
}

function getRequestHeaders(fetchArgs, allowedHeaders) {
  if (fetchArgs.length === 1 && typeof fetchArgs[0] !== 'string') {
    return getHeadersFromOptions(fetchArgs[0] , allowedHeaders);
  }

  if (fetchArgs.length === 2) {
    return getHeadersFromOptions(fetchArgs[1] , allowedHeaders);
  }

  return {};
}

function getHeadersFromOptions(
  input,
  allowedHeaders,
) {
  if (!input) {
    return {};
  }

  const headers = input.headers;

  if (!headers) {
    return {};
  }

  if (headers instanceof Headers) {
    return getAllHeaders(headers, allowedHeaders);
  }

  // We do not support this, as it is not really documented (anymore?)
  if (Array.isArray(headers)) {
    return {};
  }

  return getAllowedHeaders(headers, allowedHeaders);
}

/**
 * Capture an XHR breadcrumb to a replay.
 * This adds additional data (where approriate).
 */
async function captureXhrBreadcrumbToReplay(
  breadcrumb,
  hint,
  options,
) {
  try {
    const data = _prepareXhrData(breadcrumb, hint, options);

    // Create a replay performance entry from this breadcrumb
    const result = makeNetworkReplayBreadcrumb('resource.xhr', data);
    addNetworkBreadcrumb(options.replay, result);
  } catch (error) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.error */.kg.error('[Replay] Failed to capture fetch breadcrumb', error);
  }
}

/**
 * Enrich a breadcrumb with additional data.
 * This has to be sync & mutate the given breadcrumb,
 * as the breadcrumb is afterwards consumed by other handlers.
 */
function enrichXhrBreadcrumb(
  breadcrumb,
  hint,
  options,
) {
  const { xhr, input } = hint;

  const reqSize = getBodySize(input, options.textEncoder);
  const resSize = xhr.getResponseHeader('content-length')
    ? parseContentLengthHeader(xhr.getResponseHeader('content-length'))
    : getBodySize(xhr.response, options.textEncoder);

  if (reqSize !== undefined) {
    breadcrumb.data.request_body_size = reqSize;
  }
  if (resSize !== undefined) {
    breadcrumb.data.response_body_size = resSize;
  }
}

function _prepareXhrData(
  breadcrumb,
  hint,
  options,
) {
  const { startTimestamp, endTimestamp, input, xhr } = hint;

  const {
    url,
    method,
    status_code: statusCode = 0,
    request_body_size: requestBodySize,
    response_body_size: responseBodySize,
  } = breadcrumb.data;

  if (!url) {
    return null;
  }

  if (!urlMatches(url, options.networkDetailAllowUrls)) {
    const request = buildSkippedNetworkRequestOrResponse(requestBodySize);
    const response = buildSkippedNetworkRequestOrResponse(responseBodySize);
    return {
      startTimestamp,
      endTimestamp,
      url,
      method,
      statusCode,
      request,
      response,
    };
  }

  const xhrInfo = xhr[instrument/* SENTRY_XHR_DATA_KEY */.xU];
  const networkRequestHeaders = xhrInfo
    ? getAllowedHeaders(xhrInfo.request_headers, options.networkRequestHeaders)
    : {};
  const networkResponseHeaders = getAllowedHeaders(getResponseHeaders(xhr), options.networkResponseHeaders);

  const request = buildNetworkRequestOrResponse(
    networkRequestHeaders,
    requestBodySize,
    options.networkCaptureBodies ? getBodyString(input) : undefined,
  );
  const response = buildNetworkRequestOrResponse(
    networkResponseHeaders,
    responseBodySize,
    options.networkCaptureBodies ? hint.xhr.responseText : undefined,
  );

  return {
    startTimestamp,
    endTimestamp,
    url,
    method,
    statusCode,
    request,
    response,
  };
}

function getResponseHeaders(xhr) {
  const headers = xhr.getAllResponseHeaders();

  if (!headers) {
    return {};
  }

  return headers.split('\r\n').reduce((acc, line) => {
    const [key, value] = line.split(': ');
    acc[key.toLowerCase()] = value;
    return acc;
  }, {});
}

/**
 * This method does two things:
 * - It enriches the regular XHR/fetch breadcrumbs with request/response size data
 * - It captures the XHR/fetch breadcrumbs to the replay
 *   (enriching it with further data that is _not_ added to the regular breadcrumbs)
 */
function handleNetworkBreadcrumbs(replay) {
  const client = (0,esm_hub/* getCurrentHub */.Gd)().getClient();

  try {
    const textEncoder = new TextEncoder();

    const { networkDetailAllowUrls, networkCaptureBodies, networkRequestHeaders, networkResponseHeaders } =
      replay.getOptions();

    const options = {
      replay,
      textEncoder,
      networkDetailAllowUrls,
      networkCaptureBodies,
      networkRequestHeaders,
      networkResponseHeaders,
    };

    if (client && client.on) {
      client.on('beforeAddBreadcrumb', (breadcrumb, hint) => beforeAddNetworkBreadcrumb(options, breadcrumb, hint));
    } else {
      // Fallback behavior
      (0,instrument/* addInstrumentationHandler */.oq)('fetch', handleFetchSpanListener(replay));
      (0,instrument/* addInstrumentationHandler */.oq)('xhr', handleXhrSpanListener(replay));
    }
  } catch (e2) {
    // Do nothing
  }
}

/** just exported for tests */
function beforeAddNetworkBreadcrumb(
  options,
  breadcrumb,
  hint,
) {
  if (!breadcrumb.data) {
    return;
  }

  try {
    if (_isXhrBreadcrumb(breadcrumb) && _isXhrHint(hint)) {
      // This has to be sync, as we need to ensure the breadcrumb is enriched in the same tick
      // Because the hook runs synchronously, and the breadcrumb is afterwards passed on
      // So any async mutations to it will not be reflected in the final breadcrumb
      enrichXhrBreadcrumb(breadcrumb, hint, options);

      void captureXhrBreadcrumbToReplay(breadcrumb, hint, options);
    }

    if (_isFetchBreadcrumb(breadcrumb) && _isFetchHint(hint)) {
      // This has to be sync, as we need to ensure the breadcrumb is enriched in the same tick
      // Because the hook runs synchronously, and the breadcrumb is afterwards passed on
      // So any async mutations to it will not be reflected in the final breadcrumb
      enrichFetchBreadcrumb(breadcrumb, hint, options);

      void captureFetchBreadcrumbToReplay(breadcrumb, hint, options);
    }
  } catch (e) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.warn */.kg.warn('Error when enriching network breadcrumb');
  }
}

function _isXhrBreadcrumb(breadcrumb) {
  return breadcrumb.category === 'xhr';
}

function _isFetchBreadcrumb(breadcrumb) {
  return breadcrumb.category === 'fetch';
}

function _isXhrHint(hint) {
  return hint && hint.xhr;
}

function _isFetchHint(hint) {
  return hint && hint.response;
}

let _LAST_BREADCRUMB = null;

function isBreadcrumbWithCategory(breadcrumb) {
  return !!breadcrumb.category;
}

const handleScopeListener =
  (replay) =>
  (scope) => {
    if (!replay.isEnabled()) {
      return;
    }

    const result = handleScope(scope);

    if (!result) {
      return;
    }

    addBreadcrumbEvent(replay, result);
  };

/**
 * An event handler to handle scope changes.
 */
function handleScope(scope) {
  // TODO (v8): Remove this guard. This was put in place because we introduced
  // Scope.getLastBreadcrumb mid-v7 which caused incompatibilities with older SDKs.
  // For now, we'll just return null if the method doesn't exist but we should eventually
  // get rid of this guard.
  const newBreadcrumb = scope.getLastBreadcrumb && scope.getLastBreadcrumb();

  // Listener can be called when breadcrumbs have not changed, so we store the
  // reference to the last crumb and only return a crumb if it has changed
  if (_LAST_BREADCRUMB === newBreadcrumb || !newBreadcrumb) {
    return null;
  }

  _LAST_BREADCRUMB = newBreadcrumb;

  if (
    !isBreadcrumbWithCategory(newBreadcrumb) ||
    ['fetch', 'xhr', 'sentry.event', 'sentry.transaction'].includes(newBreadcrumb.category) ||
    newBreadcrumb.category.startsWith('ui.')
  ) {
    return null;
  }

  if (newBreadcrumb.category === 'console') {
    return normalizeConsoleBreadcrumb(newBreadcrumb);
  }

  return createBreadcrumb(newBreadcrumb);
}

/** exported for tests only */
function normalizeConsoleBreadcrumb(
  breadcrumb,
) {
  const args = breadcrumb.data && breadcrumb.data.arguments;

  if (!Array.isArray(args) || args.length === 0) {
    return createBreadcrumb(breadcrumb);
  }

  let isTruncated = false;

  // Avoid giant args captures
  const normalizedArgs = args.map(arg => {
    if (!arg) {
      return arg;
    }
    if (typeof arg === 'string') {
      if (arg.length > CONSOLE_ARG_MAX_SIZE) {
        isTruncated = true;
        return `${arg.slice(0, CONSOLE_ARG_MAX_SIZE)}…`;
      }

      return arg;
    }
    if (typeof arg === 'object') {
      try {
        const normalizedArg = (0,normalize/* normalize */.Fv)(arg, 7);
        const stringified = JSON.stringify(normalizedArg);
        if (stringified.length > CONSOLE_ARG_MAX_SIZE) {
          const fixedJson = fixJson(stringified.slice(0, CONSOLE_ARG_MAX_SIZE));
          const json = JSON.parse(fixedJson);
          // We only set this after JSON.parse() was successfull, so we know we didn't run into `catch`
          isTruncated = true;
          return json;
        }
        return normalizedArg;
      } catch (e) {
        // fall back to default
      }
    }

    return arg;
  });

  return createBreadcrumb({
    ...breadcrumb,
    data: {
      ...breadcrumb.data,
      arguments: normalizedArgs,
      ...(isTruncated ? { _meta: { warnings: ['CONSOLE_ARG_TRUNCATED'] } } : {}),
    },
  });
}

/**
 * Add global listeners that cannot be removed.
 */
function addGlobalListeners(replay) {
  // Listeners from core SDK //
  const scope = (0,esm_hub/* getCurrentHub */.Gd)().getScope();
  const client = (0,esm_hub/* getCurrentHub */.Gd)().getClient();

  if (scope) {
    scope.addScopeListener(handleScopeListener(replay));
  }
  (0,instrument/* addInstrumentationHandler */.oq)('dom', handleDomListener(replay));
  (0,instrument/* addInstrumentationHandler */.oq)('history', handleHistorySpanListener(replay));
  handleNetworkBreadcrumbs(replay);

  // Tag all (non replay) events that get sent to Sentry with the current
  // replay ID so that we can reference them later in the UI
  (0,esm_scope/* addGlobalEventProcessor */.c)(handleGlobalEventListener(replay, !hasHooks(client)));

  // If a custom client has no hooks yet, we continue to use the "old" implementation
  if (hasHooks(client)) {
    client.on('afterSendEvent', handleAfterSendEvent(replay));
    client.on('createDsc', (dsc) => {
      const replayId = replay.getSessionId();
      // We do not want to set the DSC when in buffer mode, as that means the replay has not been sent (yet)
      if (replayId && replay.isEnabled() && replay.recordingMode === 'session') {
        dsc.replay_id = replayId;
      }
    });

    client.on('startTransaction', transaction => {
      replay.lastTransaction = transaction;
    });

    // We may be missing the initial startTransaction due to timing issues,
    // so we capture it on finish again.
    client.on('finishTransaction', transaction => {
      replay.lastTransaction = transaction;
    });
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function hasHooks(client) {
  return !!(client && client.on);
}

/**
 * Create a "span" for the total amount of memory being used by JS objects
 * (including v8 internal objects).
 */
async function addMemoryEntry(replay) {
  // window.performance.memory is a non-standard API and doesn't work on all browsers, so we try-catch this
  try {
    return Promise.all(
      createPerformanceSpans(replay, [
        // @ts-ignore memory doesn't exist on type Performance as the API is non-standard (we check that it exists above)
        createMemoryEntry(esm_WINDOW.performance.memory),
      ]),
    );
  } catch (error) {
    // Do nothing
    return [];
  }
}

function createMemoryEntry(memoryEntry) {
  const { jsHeapSizeLimit, totalJSHeapSize, usedJSHeapSize } = memoryEntry;
  // we don't want to use `getAbsoluteTime` because it adds the event time to the
  // time origin, so we get the current timestamp instead
  const time = Date.now() / 1000;
  return {
    type: 'memory',
    name: 'memory',
    start: time,
    end: time,
    data: {
      memory: {
        jsHeapSizeLimit,
        totalJSHeapSize,
        usedJSHeapSize,
      },
    },
  };
}

// Map entryType -> function to normalize data for event
// @ts-ignore TODO: entry type does not fit the create* functions entry type
const ENTRY_TYPES

 = {
  // @ts-ignore TODO: entry type does not fit the create* functions entry type
  resource: createResourceEntry,
  paint: createPaintEntry,
  // @ts-ignore TODO: entry type does not fit the create* functions entry type
  navigation: createNavigationEntry,
  // @ts-ignore TODO: entry type does not fit the create* functions entry type
  ['largest-contentful-paint']: createLargestContentfulPaint,
};

/**
 * Create replay performance entries from the browser performance entries.
 */
function createPerformanceEntries(
  entries,
) {
  return entries.map(createPerformanceEntry).filter(Boolean) ;
}

function createPerformanceEntry(entry) {
  if (ENTRY_TYPES[entry.entryType] === undefined) {
    return null;
  }

  return ENTRY_TYPES[entry.entryType](entry);
}

function getAbsoluteTime(time) {
  // browserPerformanceTimeOrigin can be undefined if `performance` or
  // `performance.now` doesn't exist, but this is already checked by this integration
  return ((esm_time/* browserPerformanceTimeOrigin */.Z1 || esm_WINDOW.performance.timeOrigin) + time) / 1000;
}

function createPaintEntry(entry) {
  const { duration, entryType, name, startTime } = entry;

  const start = getAbsoluteTime(startTime);
  return {
    type: entryType,
    name,
    start,
    end: start + duration,
    data: undefined,
  };
}

function createNavigationEntry(entry) {
  const {
    entryType,
    name,
    decodedBodySize,
    duration,
    domComplete,
    encodedBodySize,
    domContentLoadedEventStart,
    domContentLoadedEventEnd,
    domInteractive,
    loadEventStart,
    loadEventEnd,
    redirectCount,
    startTime,
    transferSize,
    type,
  } = entry;

  // Ignore entries with no duration, they do not seem to be useful and cause dupes
  if (duration === 0) {
    return null;
  }

  return {
    type: `${entryType}.${type}`,
    start: getAbsoluteTime(startTime),
    end: getAbsoluteTime(domComplete),
    name,
    data: {
      size: transferSize,
      decodedBodySize,
      encodedBodySize,
      duration,
      domInteractive,
      domContentLoadedEventStart,
      domContentLoadedEventEnd,
      loadEventStart,
      loadEventEnd,
      domComplete,
      redirectCount,
    },
  };
}

function createResourceEntry(
  entry,
) {
  const {
    entryType,
    initiatorType,
    name,
    responseEnd,
    startTime,
    decodedBodySize,
    encodedBodySize,
    responseStatus,
    transferSize,
  } = entry;

  // Core SDK handles these
  if (['fetch', 'xmlhttprequest'].includes(initiatorType)) {
    return null;
  }

  return {
    type: `${entryType}.${initiatorType}`,
    start: getAbsoluteTime(startTime),
    end: getAbsoluteTime(responseEnd),
    name,
    data: {
      size: transferSize,
      statusCode: responseStatus,
      decodedBodySize,
      encodedBodySize,
    },
  };
}

function createLargestContentfulPaint(
  entry,
) {
  const { entryType, startTime, size } = entry;

  let startTimeOrNavigationActivation = 0;

  if (esm_WINDOW.performance) {
    const navEntry = esm_WINDOW.performance.getEntriesByType('navigation')[0]

;

    // See https://github.com/GoogleChrome/web-vitals/blob/9f11c4c6578fb4c5ee6fa4e32b9d1d756475f135/src/lib/getActivationStart.ts#L21
    startTimeOrNavigationActivation = (navEntry && navEntry.activationStart) || 0;
  }

  // value is in ms
  const value = Math.max(startTime - startTimeOrNavigationActivation, 0);
  // LCP doesn't have a "duration", it just happens at a single point in time.
  // But the UI expects both, so use end (in seconds) for both timestamps.
  const end = getAbsoluteTime(startTimeOrNavigationActivation) + value / 1000;

  return {
    type: entryType,
    name: entryType,
    start: end,
    end,
    data: {
      value, // LCP "duration" in ms
      size,
      // Not sure why this errors, Node should be correct (Argument of type 'Node' is not assignable to parameter of type 'INode')
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      nodeId: record.mirror.getId(entry.element ),
    },
  };
}

/**
 * Heavily simplified debounce function based on lodash.debounce.
 *
 * This function takes a callback function (@param fun) and delays its invocation
 * by @param wait milliseconds. Optionally, a maxWait can be specified in @param options,
 * which ensures that the callback is invoked at least once after the specified max. wait time.
 *
 * @param func the function whose invocation is to be debounced
 * @param wait the minimum time until the function is invoked after it was called once
 * @param options the options object, which can contain the `maxWait` property
 *
 * @returns the debounced version of the function, which needs to be called at least once to start the
 *          debouncing process. Subsequent calls will reset the debouncing timer and, in case @paramfunc
 *          was already invoked in the meantime, return @param func's return value.
 *          The debounced function has two additional properties:
 *          - `flush`: Invokes the debounced function immediately and returns its return value
 *          - `cancel`: Cancels the debouncing process and resets the debouncing timer
 */
function debounce(func, wait, options) {
  let callbackReturnValue;

  let timerId;
  let maxTimerId;

  const maxWait = options && options.maxWait ? Math.max(options.maxWait, wait) : 0;

  function invokeFunc() {
    cancelTimers();
    callbackReturnValue = func();
    return callbackReturnValue;
  }

  function cancelTimers() {
    timerId !== undefined && clearTimeout(timerId);
    maxTimerId !== undefined && clearTimeout(maxTimerId);
    timerId = maxTimerId = undefined;
  }

  function flush() {
    if (timerId !== undefined || maxTimerId !== undefined) {
      return invokeFunc();
    }
    return callbackReturnValue;
  }

  function debounced() {
    if (timerId) {
      clearTimeout(timerId);
    }
    timerId = setTimeout(invokeFunc, wait);

    if (maxWait && maxTimerId === undefined) {
      maxTimerId = setTimeout(invokeFunc, maxWait);
    }

    return callbackReturnValue;
  }

  debounced.cancel = cancelTimers;
  debounced.flush = flush;
  return debounced;
}

/**
 * Handler for recording events.
 *
 * Adds to event buffer, and has varying flushing behaviors if the event was a checkout.
 */
function getHandleRecordingEmit(replay) {
  let hadFirstEvent = false;

  return (event, _isCheckout) => {
    // If this is false, it means session is expired, create and a new session and wait for checkout
    if (!replay.checkAndHandleExpiredSession()) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.warn */.kg.warn('[Replay] Received replay event after session expired.');

      return;
    }

    // `_isCheckout` is only set when the checkout is due to `checkoutEveryNms`
    // We also want to treat the first event as a checkout, so we handle this specifically here
    const isCheckout = _isCheckout || !hadFirstEvent;
    hadFirstEvent = true;

    // The handler returns `true` if we do not want to trigger debounced flush, `false` if we want to debounce flush.
    replay.addUpdate(() => {
      // The session is always started immediately on pageload/init, but for
      // error-only replays, it should reflect the most recent checkout
      // when an error occurs. Clear any state that happens before this current
      // checkout. This needs to happen before `addEvent()` which updates state
      // dependent on this reset.
      if (replay.recordingMode === 'buffer' && isCheckout) {
        replay.setInitialState();
      }

      // We need to clear existing events on a checkout, otherwise they are
      // incremental event updates and should be appended
      void addEvent(replay, event, isCheckout);

      // Different behavior for full snapshots (type=2), ignore other event types
      // See https://github.com/rrweb-io/rrweb/blob/d8f9290ca496712aa1e7d472549480c4e7876594/packages/rrweb/src/types.ts#L16
      if (!isCheckout) {
        return false;
      }

      // Additionally, create a meta event that will capture certain SDK settings.
      // In order to handle buffer mode, this needs to either be done when we
      // receive checkout events or at flush time.
      //
      // `isCheckout` is always true, but want to be explicit that it should
      // only be added for checkouts
      void addSettingsEvent(replay, isCheckout);

      // If there is a previousSessionId after a full snapshot occurs, then
      // the replay session was started due to session expiration. The new session
      // is started before triggering a new checkout and contains the id
      // of the previous session. Do not immediately flush in this case
      // to avoid capturing only the checkout and instead the replay will
      // be captured if they perform any follow-up actions.
      if (replay.session && replay.session.previousSessionId) {
        return true;
      }

      // When in buffer mode, make sure we adjust the session started date to the current earliest event of the buffer
      // this should usually be the timestamp of the checkout event, but to be safe...
      if (replay.recordingMode === 'buffer' && replay.session && replay.eventBuffer) {
        const earliestEvent = replay.eventBuffer.getEarliestTimestamp();
        if (earliestEvent) {
          replay.session.started = earliestEvent;

          if (replay.getOptions().stickySession) {
            saveSession(replay.session);
          }
        }
      }

      const options = replay.getOptions();

      // TODO: We want this as an experiment so that we can test
      // internally and create metrics before making this the default
      if (options._experiments.delayFlushOnCheckout) {
        // If the full snapshot is due to an initial load, we will not have
        // a previous session ID. In this case, we want to buffer events
        // for a set amount of time before flushing. This can help avoid
        // capturing replays of users that immediately close the window.
        // TODO: We should check `recordingMode` here and do nothing if it's
        // buffer, instead of checking inside of timeout, this will make our
        // tests a bit cleaner as we will need to wait on the delay in order to
        // do nothing.
        setTimeout(() => replay.conditionalFlush(), options._experiments.delayFlushOnCheckout);

        // Cancel any previously debounced flushes to ensure there are no [near]
        // simultaneous flushes happening. The latter request should be
        // insignificant in this case, so wait for additional user interaction to
        // trigger a new flush.
        //
        // This can happen because there's no guarantee that a recording event
        // happens first. e.g. a mouse click can happen and trigger a debounced
        // flush before the checkout.
        replay.cancelFlush();

        return true;
      }

      // Flush immediately so that we do not miss the first segment, otherwise
      // it can prevent loading on the UI. This will cause an increase in short
      // replays (e.g. opening and closing a tab quickly), but these can be
      // filtered on the UI.
      if (replay.recordingMode === 'session') {
        // We want to ensure the worker is ready, as otherwise we'd always send the first event uncompressed
        void replay.flushImmediate();
      }

      return true;
    });
  };
}

/**
 * Exported for tests
 */
function createOptionsEvent(replay) {
  const options = replay.getOptions();
  return {
    type: EventType.Custom,
    timestamp: Date.now(),
    data: {
      tag: 'options',
      payload: {
        sessionSampleRate: options.sessionSampleRate,
        errorSampleRate: options.errorSampleRate,
        useCompressionOption: options.useCompression,
        blockAllMedia: options.blockAllMedia,
        maskAllText: options.maskAllText,
        maskAllInputs: options.maskAllInputs,
        useCompression: replay.eventBuffer ? replay.eventBuffer.type === 'worker' : false,
        networkDetailHasUrls: options.networkDetailAllowUrls.length > 0,
        networkCaptureBodies: options.networkCaptureBodies,
        networkRequestHasHeaders: options.networkRequestHeaders.length > 0,
        networkResponseHasHeaders: options.networkResponseHeaders.length > 0,
      },
    },
  };
}

/**
 * Add a "meta" event that contains a simplified view on current configuration
 * options. This should only be included on the first segment of a recording.
 */
function addSettingsEvent(replay, isCheckout) {
  // Only need to add this event when sending the first segment
  if (!isCheckout || !replay.session || replay.session.segmentId !== 0) {
    return Promise.resolve(null);
  }

  return addEvent(replay, createOptionsEvent(replay), false);
}

/**
 * Create a replay envelope ready to be sent.
 * This includes both the replay event, as well as the recording data.
 */
function createReplayEnvelope(
  replayEvent,
  recordingData,
  dsn,
  tunnel,
) {
  return (0,envelope/* createEnvelope */.Jd)(
    (0,envelope/* createEventEnvelopeHeaders */.Cd)(replayEvent, (0,envelope/* getSdkMetadataForEnvelopeHeader */.HY)(replayEvent), tunnel, dsn),
    [
      [{ type: 'replay_event' }, replayEvent],
      [
        {
          type: 'replay_recording',
          // If string then we need to encode to UTF8, otherwise will have
          // wrong size. TextEncoder has similar browser support to
          // MutationObserver, although it does not accept IE11.
          length:
            typeof recordingData === 'string' ? new TextEncoder().encode(recordingData).length : recordingData.length,
        },
        recordingData,
      ],
    ],
  );
}

/**
 * Prepare the recording data ready to be sent.
 */
function prepareRecordingData({
  recordingData,
  headers,
}

) {
  let payloadWithSequence;

  // XXX: newline is needed to separate sequence id from events
  const replayHeaders = `${JSON.stringify(headers)}
`;

  if (typeof recordingData === 'string') {
    payloadWithSequence = `${replayHeaders}${recordingData}`;
  } else {
    const enc = new TextEncoder();
    // XXX: newline is needed to separate sequence id from events
    const sequence = enc.encode(replayHeaders);
    // Merge the two Uint8Arrays
    payloadWithSequence = new Uint8Array(sequence.length + recordingData.length);
    payloadWithSequence.set(sequence);
    payloadWithSequence.set(recordingData, sequence.length);
  }

  return payloadWithSequence;
}

/**
 * Prepare a replay event & enrich it with the SDK metadata.
 */
async function prepareReplayEvent({
  client,
  scope,
  replayId: event_id,
  event,
}

) {
  const integrations =
    typeof client._integrations === 'object' && client._integrations !== null && !Array.isArray(client._integrations)
      ? Object.keys(client._integrations)
      : undefined;
  const preparedEvent = (await (0,prepareEvent/* prepareEvent */.R)(
    client.getOptions(),
    event,
    { event_id, integrations },
    scope,
  )) ;

  // If e.g. a global event processor returned null
  if (!preparedEvent) {
    return null;
  }

  // This normally happens in browser client "_prepareEvent"
  // but since we do not use this private method from the client, but rather the plain import
  // we need to do this manually.
  preparedEvent.platform = preparedEvent.platform || 'javascript';

  // extract the SDK name because `client._prepareEvent` doesn't add it to the event
  const metadata = client.getSdkMetadata && client.getSdkMetadata();
  const { name, version } = (metadata && metadata.sdk) || {};

  preparedEvent.sdk = {
    ...preparedEvent.sdk,
    name: name || 'sentry.javascript.unknown',
    version: version || '0.0.0',
  };

  return preparedEvent;
}

/**
 * Send replay attachment using `fetch()`
 */
async function sendReplayRequest({
  recordingData,
  replayId,
  segmentId: segment_id,
  eventContext,
  timestamp,
  session,
}) {
  const preparedRecordingData = prepareRecordingData({
    recordingData,
    headers: {
      segment_id,
    },
  });

  const { urls, errorIds, traceIds, initialTimestamp } = eventContext;

  const hub = (0,esm_hub/* getCurrentHub */.Gd)();
  const client = hub.getClient();
  const scope = hub.getScope();
  const transport = client && client.getTransport();
  const dsn = client && client.getDsn();

  if (!client || !scope || !transport || !dsn || !session.sampled) {
    return;
  }

  const baseEvent = {
    type: REPLAY_EVENT_NAME,
    replay_start_timestamp: initialTimestamp / 1000,
    timestamp: timestamp / 1000,
    error_ids: errorIds,
    trace_ids: traceIds,
    urls,
    replay_id: replayId,
    segment_id,
    replay_type: session.sampled,
  };

  const replayEvent = await prepareReplayEvent({ scope, client, replayId, event: baseEvent });

  if (!replayEvent) {
    // Taken from baseclient's `_processEvent` method, where this is handled for errors/transactions
    client.recordDroppedEvent('event_processor', 'replay', baseEvent);
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log('An event processor returned `null`, will not send event.');
    return;
  }

  /*
  For reference, the fully built event looks something like this:
  {
      "type": "replay_event",
      "timestamp": 1670837008.634,
      "error_ids": [
          "errorId"
      ],
      "trace_ids": [
          "traceId"
      ],
      "urls": [
          "https://example.com"
      ],
      "replay_id": "eventId",
      "segment_id": 3,
      "replay_type": "error",
      "platform": "javascript",
      "event_id": "eventId",
      "environment": "production",
      "sdk": {
          "integrations": [
              "BrowserTracing",
              "Replay"
          ],
          "name": "sentry.javascript.browser",
          "version": "7.25.0"
      },
      "sdkProcessingMetadata": {},
      "contexts": {
      },
  }
  */

  const envelope = createReplayEnvelope(replayEvent, preparedRecordingData, dsn, client.getOptions().tunnel);

  let response;

  try {
    response = await transport.send(envelope);
  } catch (err) {
    const error = new Error(UNABLE_TO_SEND_REPLAY);

    try {
      // In case browsers don't allow this property to be writable
      // @ts-ignore This needs lib es2022 and newer
      error.cause = err;
    } catch (e) {
      // nothing to do
    }
    throw error;
  }

  // TODO (v8): we can remove this guard once transport.send's type signature doesn't include void anymore
  if (!response) {
    return response;
  }

  // If the status code is invalid, we want to immediately stop & not retry
  if (typeof response.statusCode === 'number' && (response.statusCode < 200 || response.statusCode >= 300)) {
    throw new TransportStatusCodeError(response.statusCode);
  }

  return response;
}

/**
 * This error indicates that the transport returned an invalid status code.
 */
class TransportStatusCodeError extends Error {
   constructor(statusCode) {
    super(`Transport returned status code ${statusCode}`);
  }
}

/**
 * Finalize and send the current replay event to Sentry
 */
async function sendReplay(
  replayData,
  retryConfig = {
    count: 0,
    interval: RETRY_BASE_INTERVAL,
  },
) {
  const { recordingData, options } = replayData;

  // short circuit if there's no events to upload (this shouldn't happen as _runFlush makes this check)
  if (!recordingData.length) {
    return;
  }

  try {
    await sendReplayRequest(replayData);
    return true;
  } catch (err) {
    if (err instanceof TransportStatusCodeError) {
      throw err;
    }

    // Capture error for every failed replay
    (0,esm_exports/* setContext */.v)('Replays', {
      _retryCount: retryConfig.count,
    });

    if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && options._experiments && options._experiments.captureExceptions) {
      (0,esm_exports/* captureException */.Tb)(err);
    }

    // If an error happened here, it's likely that uploading the attachment
    // failed, we'll can retry with the same events payload
    if (retryConfig.count >= RETRY_MAX_COUNT) {
      const error = new Error(`${UNABLE_TO_SEND_REPLAY} - max retries exceeded`);

      try {
        // In case browsers don't allow this property to be writable
        // @ts-ignore This needs lib es2022 and newer
        error.cause = err;
      } catch (e) {
        // nothing to do
      }

      throw error;
    }

    // will retry in intervals of 5, 10, 30
    retryConfig.interval *= ++retryConfig.count;

    return await new Promise((resolve, reject) => {
      setTimeout(async () => {
        try {
          await sendReplay(replayData, retryConfig);
          resolve(true);
        } catch (err) {
          reject(err);
        }
      }, retryConfig.interval);
    });
  }
}

const THROTTLED = '__THROTTLED';
const SKIPPED = '__SKIPPED';

/**
 * Create a throttled function off a given function.
 * When calling the throttled function, it will call the original function only
 * if it hasn't been called more than `maxCount` times in the last `durationSeconds`.
 *
 * Returns `THROTTLED` if throttled for the first time, after that `SKIPPED`,
 * or else the return value of the original function.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function throttle(
  fn,
  maxCount,
  durationSeconds,
) {
  const counter = new Map();

  const _cleanup = (now) => {
    const threshold = now - durationSeconds;
    counter.forEach((_value, key) => {
      if (key < threshold) {
        counter.delete(key);
      }
    });
  };

  const _getTotalCount = () => {
    return [...counter.values()].reduce((a, b) => a + b, 0);
  };

  let isThrottled = false;

  return (...rest) => {
    // Date in second-precision, which we use as basis for the throttling
    const now = Math.floor(Date.now() / 1000);

    // First, make sure to delete any old entries
    _cleanup(now);

    // If already over limit, do nothing
    if (_getTotalCount() >= maxCount) {
      const wasThrottled = isThrottled;
      isThrottled = true;
      return wasThrottled ? SKIPPED : THROTTLED;
    }

    isThrottled = false;
    const count = counter.get(now) || 0;
    counter.set(now, count + 1);

    return fn(...rest);
  };
}

/* eslint-disable max-lines */ // TODO: We might want to split this file up

/**
 * The main replay container class, which holds all the state and methods for recording and sending replays.
 */
class ReplayContainer  {
   __init() {this.eventBuffer = null;}

  /**
   * List of PerformanceEntry from PerformanceObserver
   */
   __init2() {this.performanceEvents = [];}

  /**
   * Recording can happen in one of three modes:
   *   - session: Record the whole session, sending it continuously
   *   - buffer: Always keep the last 60s of recording, requires:
   *     - having replaysOnErrorSampleRate > 0 to capture replay when an error occurs
   *     - or calling `flush()` to send the replay
   */
   __init3() {this.recordingMode = 'session';}

  /**
   * The current or last active transcation.
   * This is only available when performance is enabled.
   */

  /**
   * These are here so we can overwrite them in tests etc.
   * @hidden
   */
    __init4() {this.timeouts = {
    sessionIdlePause: SESSION_IDLE_PAUSE_DURATION,
    sessionIdleExpire: SESSION_IDLE_EXPIRE_DURATION,
    maxSessionLife: MAX_SESSION_LIFE,
  }; }

  /**
   * Options to pass to `rrweb.record()`
   */

   __init5() {this._performanceObserver = null;}

   __init6() {this._flushLock = null;}

  /**
   * Timestamp of the last user activity. This lives across sessions.
   */
   __init7() {this._lastActivity = Date.now();}

  /**
   * Is the integration currently active?
   */
   __init8() {this._isEnabled = false;}

  /**
   * Paused is a state where:
   * - DOM Recording is not listening at all
   * - Nothing will be added to event buffer (e.g. core SDK events)
   */
   __init9() {this._isPaused = false;}

  /**
   * Have we attached listeners to the core SDK?
   * Note we have to track this as there is no way to remove instrumentation handlers.
   */
   __init10() {this._hasInitializedCoreListeners = false;}

  /**
   * Function to stop recording
   */
   __init11() {this._stopRecording = null;}

   __init12() {this._context = {
    errorIds: new Set(),
    traceIds: new Set(),
    urls: [],
    initialTimestamp: Date.now(),
    initialUrl: '',
  };}

   constructor({
    options,
    recordingOptions,
  }

) {ReplayContainer.prototype.__init.call(this);ReplayContainer.prototype.__init2.call(this);ReplayContainer.prototype.__init3.call(this);ReplayContainer.prototype.__init4.call(this);ReplayContainer.prototype.__init5.call(this);ReplayContainer.prototype.__init6.call(this);ReplayContainer.prototype.__init7.call(this);ReplayContainer.prototype.__init8.call(this);ReplayContainer.prototype.__init9.call(this);ReplayContainer.prototype.__init10.call(this);ReplayContainer.prototype.__init11.call(this);ReplayContainer.prototype.__init12.call(this);ReplayContainer.prototype.__init13.call(this);ReplayContainer.prototype.__init14.call(this);ReplayContainer.prototype.__init15.call(this);ReplayContainer.prototype.__init16.call(this);ReplayContainer.prototype.__init17.call(this);ReplayContainer.prototype.__init18.call(this);
    this._recordingOptions = recordingOptions;
    this._options = options;

    this._debouncedFlush = debounce(() => this._flush(), this._options.flushMinDelay, {
      maxWait: this._options.flushMaxDelay,
    });

    this._throttledAddEvent = throttle(
      (event, isCheckout) => addEvent(this, event, isCheckout),
      // Max 300 events...
      300,
      // ... per 5s
      5,
    );

    const { slowClickTimeout, slowClickIgnoreSelectors } = this.getOptions();

    const slowClickConfig = slowClickTimeout
      ? {
          threshold: Math.min(SLOW_CLICK_THRESHOLD, slowClickTimeout),
          timeout: slowClickTimeout,
          scrollTimeout: SLOW_CLICK_SCROLL_TIMEOUT,
          ignoreSelector: slowClickIgnoreSelectors ? slowClickIgnoreSelectors.join(',') : '',
          multiClickTimeout: MULTI_CLICK_TIMEOUT,
        }
      : undefined;

    if (slowClickConfig) {
      this.clickDetector = new ClickDetector(this, slowClickConfig);
    }
  }

  /** Get the event context. */
   getContext() {
    return this._context;
  }

  /** If recording is currently enabled. */
   isEnabled() {
    return this._isEnabled;
  }

  /** If recording is currently paused. */
   isPaused() {
    return this._isPaused;
  }

  /** Get the replay integration options. */
   getOptions() {
    return this._options;
  }

  /**
   * Initializes the plugin based on sampling configuration. Should not be
   * called outside of constructor.
   */
   initializeSampling() {
    const { errorSampleRate, sessionSampleRate } = this._options;

    // If neither sample rate is > 0, then do nothing - user will need to call one of
    // `start()` or `startBuffering` themselves.
    if (errorSampleRate <= 0 && sessionSampleRate <= 0) {
      return;
    }

    // Otherwise if there is _any_ sample rate set, try to load an existing
    // session, or create a new one.
    const isSessionSampled = this._loadAndCheckSession();

    if (!isSessionSampled) {
      // This should only occur if `errorSampleRate` is 0 and was unsampled for
      // session-based replay. In this case there is nothing to do.
      return;
    }

    if (!this.session) {
      // This should not happen, something wrong has occurred
      this._handleException(new Error('Unable to initialize and create session'));
      return;
    }

    if (this.session.sampled && this.session.sampled !== 'session') {
      // If not sampled as session-based, then recording mode will be `buffer`
      // Note that we don't explicitly check if `sampled === 'buffer'` because we
      // could have sessions from Session storage that are still `error` from
      // prior SDK version.
      this.recordingMode = 'buffer';
    }

    this._initializeRecording();
  }

  /**
   * Start a replay regardless of sampling rate. Calling this will always
   * create a new session. Will throw an error if replay is already in progress.
   *
   * Creates or loads a session, attaches listeners to varying events (DOM,
   * _performanceObserver, Recording, Sentry SDK, etc)
   */
   start() {
    if (this._isEnabled && this.recordingMode === 'session') {
      throw new Error('Replay recording is already in progress');
    }

    if (this._isEnabled && this.recordingMode === 'buffer') {
      throw new Error('Replay buffering is in progress, call `flush()` to save the replay');
    }

    const previousSessionId = this.session && this.session.id;

    const { session } = getSession({
      timeouts: this.timeouts,
      stickySession: Boolean(this._options.stickySession),
      currentSession: this.session,
      // This is intentional: create a new session-based replay when calling `start()`
      sessionSampleRate: 1,
      allowBuffering: false,
    });

    session.previousSessionId = previousSessionId;
    this.session = session;

    this._initializeRecording();
  }

  /**
   * Start replay buffering. Buffers until `flush()` is called or, if
   * `replaysOnErrorSampleRate` > 0, an error occurs.
   */
   startBuffering() {
    if (this._isEnabled) {
      throw new Error('Replay recording is already in progress');
    }

    const previousSessionId = this.session && this.session.id;

    const { session } = getSession({
      timeouts: this.timeouts,
      stickySession: Boolean(this._options.stickySession),
      currentSession: this.session,
      sessionSampleRate: 0,
      allowBuffering: true,
    });

    session.previousSessionId = previousSessionId;
    this.session = session;

    this.recordingMode = 'buffer';
    this._initializeRecording();
  }

  /**
   * Start recording.
   *
   * Note that this will cause a new DOM checkout
   */
   startRecording() {
    try {
      this._stopRecording = record({
        ...this._recordingOptions,
        // When running in error sampling mode, we need to overwrite `checkoutEveryNms`
        // Without this, it would record forever, until an error happens, which we don't want
        // instead, we'll always keep the last 60 seconds of replay before an error happened
        ...(this.recordingMode === 'buffer' && { checkoutEveryNms: BUFFER_CHECKOUT_TIME }),
        emit: getHandleRecordingEmit(this),
        onMutation: this._onMutationHandler,
      });
    } catch (err) {
      this._handleException(err);
    }
  }

  /**
   * Stops the recording, if it was running.
   *
   * Returns true if it was previously stopped, or is now stopped,
   * otherwise false.
   */
   stopRecording() {
    try {
      if (this._stopRecording) {
        this._stopRecording();
        this._stopRecording = undefined;
      }

      return true;
    } catch (err) {
      this._handleException(err);
      return false;
    }
  }

  /**
   * Currently, this needs to be manually called (e.g. for tests). Sentry SDK
   * does not support a teardown
   */
   async stop(reason) {
    if (!this._isEnabled) {
      return;
    }

    try {
      if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
        const msg = `[Replay] Stopping Replay${reason ? ` triggered by ${reason}` : ''}`;

        // When `traceInternals` is enabled, we want to log this to the console
        // Else, use the regular debug output
        // eslint-disable-next-line
        const log = this.getOptions()._experiments.traceInternals ? console.warn : logger/* logger.log */.kg.log;
        log(msg);
      }

      // We can't move `_isEnabled` after awaiting a flush, otherwise we can
      // enter into an infinite loop when `stop()` is called while flushing.
      this._isEnabled = false;
      this._removeListeners();
      this.stopRecording();

      this._debouncedFlush.cancel();
      // See comment above re: `_isEnabled`, we "force" a flush, ignoring the
      // `_isEnabled` state of the plugin since it was disabled above.
      if (this.recordingMode === 'session') {
        await this._flush({ force: true });
      }

      // After flush, destroy event buffer
      this.eventBuffer && this.eventBuffer.destroy();
      this.eventBuffer = null;

      // Clear session from session storage, note this means if a new session
      // is started after, it will not have `previousSessionId`
      clearSession(this);
    } catch (err) {
      this._handleException(err);
    }
  }

  /**
   * Pause some replay functionality. See comments for `_isPaused`.
   * This differs from stop as this only stops DOM recording, it is
   * not as thorough of a shutdown as `stop()`.
   */
   pause() {
    this._isPaused = true;
    this.stopRecording();
  }

  /**
   * Resumes recording, see notes for `pause().
   *
   * Note that calling `startRecording()` here will cause a
   * new DOM checkout.`
   */
   resume() {
    if (!this._loadAndCheckSession()) {
      return;
    }

    this._isPaused = false;
    this.startRecording();
  }

  /**
   * If not in "session" recording mode, flush event buffer which will create a new replay.
   * Unless `continueRecording` is false, the replay will continue to record and
   * behave as a "session"-based replay.
   *
   * Otherwise, queue up a flush.
   */
   async sendBufferedReplayOrFlush({ continueRecording = true } = {}) {
    if (this.recordingMode === 'session') {
      return this.flushImmediate();
    }

    const activityTime = Date.now();

    // Allow flush to complete before resuming as a session recording, otherwise
    // the checkout from `startRecording` may be included in the payload.
    // Prefer to keep the error replay as a separate (and smaller) segment
    // than the session replay.
    await this.flushImmediate();

    const hasStoppedRecording = this.stopRecording();

    if (!continueRecording || !hasStoppedRecording) {
      return;
    }

    // Re-start recording, but in "session" recording mode

    // Reset all "capture on error" configuration before
    // starting a new recording
    this.recordingMode = 'session';

    // Once this session ends, we do not want to refresh it
    if (this.session) {
      this.session.shouldRefresh = false;

      // It's possible that the session lifespan is > max session lifespan
      // because we have been buffering beyond max session lifespan (we ignore
      // expiration given that `shouldRefresh` is true). Since we flip
      // `shouldRefresh`, the session could be considered expired due to
      // lifespan, which is not what we want. Update session start date to be
      // the current timestamp, so that session is not considered to be
      // expired. This means that max replay duration can be MAX_SESSION_LIFE +
      // (length of buffer), which we are ok with.
      this._updateUserActivity(activityTime);
      this._updateSessionActivity(activityTime);
      this.session.started = activityTime;
      this._maybeSaveSession();
    }

    this.startRecording();
  }

  /**
   * We want to batch uploads of replay events. Save events only if
   * `<flushMinDelay>` milliseconds have elapsed since the last event
   * *OR* if `<flushMaxDelay>` milliseconds have elapsed.
   *
   * Accepts a callback to perform side-effects and returns true to stop batch
   * processing and hand back control to caller.
   */
   addUpdate(cb) {
    // We need to always run `cb` (e.g. in the case of `this.recordingMode == 'buffer'`)
    const cbResult = cb();

    // If this option is turned on then we will only want to call `flush`
    // explicitly
    if (this.recordingMode === 'buffer') {
      return;
    }

    // If callback is true, we do not want to continue with flushing -- the
    // caller will need to handle it.
    if (cbResult === true) {
      return;
    }

    // addUpdate is called quite frequently - use _debouncedFlush so that it
    // respects the flush delays and does not flush immediately
    this._debouncedFlush();
  }

  /**
   * Updates the user activity timestamp and resumes recording. This should be
   * called in an event handler for a user action that we consider as the user
   * being "active" (e.g. a mouse click).
   */
   triggerUserActivity() {
    this._updateUserActivity();

    // This case means that recording was once stopped due to inactivity.
    // Ensure that recording is resumed.
    if (!this._stopRecording) {
      // Create a new session, otherwise when the user action is flushed, it
      // will get rejected due to an expired session.
      if (!this._loadAndCheckSession()) {
        return;
      }

      // Note: This will cause a new DOM checkout
      this.resume();
      return;
    }

    // Otherwise... recording was never suspended, continue as normalish
    this.checkAndHandleExpiredSession();

    this._updateSessionActivity();
  }

  /**
   * Updates the user activity timestamp *without* resuming
   * recording. Some user events (e.g. keydown) can be create
   * low-value replays that only contain the keypress as a
   * breadcrumb. Instead this would require other events to
   * create a new replay after a session has expired.
   */
   updateUserActivity() {
    this._updateUserActivity();
    this._updateSessionActivity();
  }

  /**
   * Only flush if `this.recordingMode === 'session'`
   */
   conditionalFlush() {
    if (this.recordingMode === 'buffer') {
      return Promise.resolve();
    }

    return this.flushImmediate();
  }

  /**
   * Always flush via `_debouncedFlush` so that we do not have flushes triggered
   * from calling both `flush` and `_debouncedFlush`. Otherwise, there could be
   * cases of mulitple flushes happening closely together.
   */
   flushImmediate() {
    this._debouncedFlush();
    // `.flush` is provided by the debounced function, analogously to lodash.debounce
    return this._debouncedFlush.flush() ;
  }

  /**
   * Cancels queued up flushes.
   */
   cancelFlush() {
    this._debouncedFlush.cancel();
  }

  /** Get the current sesion (=replay) ID */
   getSessionId() {
    return this.session && this.session.id;
  }

  /**
   * Checks if recording should be stopped due to user inactivity. Otherwise
   * check if session is expired and create a new session if so. Triggers a new
   * full snapshot on new session.
   *
   * Returns true if session is not expired, false otherwise.
   * @hidden
   */
   checkAndHandleExpiredSession() {
    const oldSessionId = this.getSessionId();

    // Prevent starting a new session if the last user activity is older than
    // SESSION_IDLE_PAUSE_DURATION. Otherwise non-user activity can trigger a new
    // session+recording. This creates noisy replays that do not have much
    // content in them.
    if (
      this._lastActivity &&
      isExpired(this._lastActivity, this.timeouts.sessionIdlePause) &&
      this.session &&
      this.session.sampled === 'session'
    ) {
      // Pause recording only for session-based replays. Otherwise, resuming
      // will create a new replay and will conflict with users who only choose
      // to record error-based replays only. (e.g. the resumed replay will not
      // contain a reference to an error)
      this.pause();
      return;
    }

    // --- There is recent user activity --- //
    // This will create a new session if expired, based on expiry length
    if (!this._loadAndCheckSession()) {
      return;
    }

    // Session was expired if session ids do not match
    const expired = oldSessionId !== this.getSessionId();

    if (!expired) {
      return true;
    }

    // Session is expired, trigger a full snapshot (which will create a new session)
    this._triggerFullSnapshot();

    return false;
  }

  /**
   * Capture some initial state that can change throughout the lifespan of the
   * replay. This is required because otherwise they would be captured at the
   * first flush.
   */
   setInitialState() {
    const urlPath = `${esm_WINDOW.location.pathname}${esm_WINDOW.location.hash}${esm_WINDOW.location.search}`;
    const url = `${esm_WINDOW.location.origin}${urlPath}`;

    this.performanceEvents = [];

    // Reset _context as well
    this._clearContext();

    this._context.initialUrl = url;
    this._context.initialTimestamp = Date.now();
    this._context.urls.push(url);
  }

  /**
   * Add a breadcrumb event, that may be throttled.
   * If it was throttled, we add a custom breadcrumb to indicate that.
   */
   throttledAddEvent(
    event,
    isCheckout,
  ) {
    const res = this._throttledAddEvent(event, isCheckout);

    // If this is THROTTLED, it means we have throttled the event for the first time
    // In this case, we want to add a breadcrumb indicating that something was skipped
    if (res === THROTTLED) {
      const breadcrumb = createBreadcrumb({
        category: 'replay.throttled',
      });

      this.addUpdate(() => {
        void addEvent(this, {
          type: EventType.Custom,
          timestamp: breadcrumb.timestamp || 0,
          data: {
            tag: 'breadcrumb',
            payload: breadcrumb,
            metric: true,
          },
        });
      });
    }

    return res;
  }

  /**
   * This will get the parametrized route name of the current page.
   * This is only available if performance is enabled, and if an instrumented router is used.
   */
   getCurrentRoute() {
    const lastTransaction = this.lastTransaction || (0,esm_hub/* getCurrentHub */.Gd)().getScope().getTransaction();
    if (!lastTransaction || !['route', 'custom'].includes(lastTransaction.metadata.source)) {
      return undefined;
    }

    return lastTransaction.name;
  }

  /**
   * Initialize and start all listeners to varying events (DOM,
   * Performance Observer, Recording, Sentry SDK, etc)
   */
   _initializeRecording() {
    this.setInitialState();

    // this method is generally called on page load or manually - in both cases
    // we should treat it as an activity
    this._updateSessionActivity();

    this.eventBuffer = createEventBuffer({
      useCompression: this._options.useCompression,
    });

    this._removeListeners();
    this._addListeners();

    // Need to set as enabled before we start recording, as `record()` can trigger a flush with a new checkout
    this._isEnabled = true;

    this.startRecording();
  }

  /** A wrapper to conditionally capture exceptions. */
   _handleException(error) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.error */.kg.error('[Replay]', error);

    if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && this._options._experiments && this._options._experiments.captureExceptions) {
      (0,esm_exports/* captureException */.Tb)(error);
    }
  }

  /**
   * Loads (or refreshes) the current session.
   * Returns false if session is not recorded.
   */
   _loadAndCheckSession() {
    const { type, session } = getSession({
      timeouts: this.timeouts,
      stickySession: Boolean(this._options.stickySession),
      currentSession: this.session,
      sessionSampleRate: this._options.sessionSampleRate,
      allowBuffering: this._options.errorSampleRate > 0 || this.recordingMode === 'buffer',
    });

    // If session was newly created (i.e. was not loaded from storage), then
    // enable flag to create the root replay
    if (type === 'new') {
      this.setInitialState();
    }

    const currentSessionId = this.getSessionId();
    if (session.id !== currentSessionId) {
      session.previousSessionId = currentSessionId;
    }

    this.session = session;

    if (!this.session.sampled) {
      void this.stop('session unsampled');
      return false;
    }

    return true;
  }

  /**
   * Adds listeners to record events for the replay
   */
   _addListeners() {
    try {
      esm_WINDOW.document.addEventListener('visibilitychange', this._handleVisibilityChange);
      esm_WINDOW.addEventListener('blur', this._handleWindowBlur);
      esm_WINDOW.addEventListener('focus', this._handleWindowFocus);
      esm_WINDOW.addEventListener('keydown', this._handleKeyboardEvent);

      if (this.clickDetector) {
        this.clickDetector.addListeners();
      }

      // There is no way to remove these listeners, so ensure they are only added once
      if (!this._hasInitializedCoreListeners) {
        addGlobalListeners(this);

        this._hasInitializedCoreListeners = true;
      }
    } catch (err) {
      this._handleException(err);
    }

    // PerformanceObserver //
    if (!('PerformanceObserver' in esm_WINDOW)) {
      return;
    }

    this._performanceObserver = setupPerformanceObserver(this);
  }

  /**
   * Cleans up listeners that were created in `_addListeners`
   */
   _removeListeners() {
    try {
      esm_WINDOW.document.removeEventListener('visibilitychange', this._handleVisibilityChange);

      esm_WINDOW.removeEventListener('blur', this._handleWindowBlur);
      esm_WINDOW.removeEventListener('focus', this._handleWindowFocus);
      esm_WINDOW.removeEventListener('keydown', this._handleKeyboardEvent);

      if (this.clickDetector) {
        this.clickDetector.removeListeners();
      }

      if (this._performanceObserver) {
        this._performanceObserver.disconnect();
        this._performanceObserver = null;
      }
    } catch (err) {
      this._handleException(err);
    }
  }

  /**
   * Handle when visibility of the page content changes. Opening a new tab will
   * cause the state to change to hidden because of content of current page will
   * be hidden. Likewise, moving a different window to cover the contents of the
   * page will also trigger a change to a hidden state.
   */
   __init13() {this._handleVisibilityChange = () => {
    if (esm_WINDOW.document.visibilityState === 'visible') {
      this._doChangeToForegroundTasks();
    } else {
      this._doChangeToBackgroundTasks();
    }
  };}

  /**
   * Handle when page is blurred
   */
   __init14() {this._handleWindowBlur = () => {
    const breadcrumb = createBreadcrumb({
      category: 'ui.blur',
    });

    // Do not count blur as a user action -- it's part of the process of them
    // leaving the page
    this._doChangeToBackgroundTasks(breadcrumb);
  };}

  /**
   * Handle when page is focused
   */
   __init15() {this._handleWindowFocus = () => {
    const breadcrumb = createBreadcrumb({
      category: 'ui.focus',
    });

    // Do not count focus as a user action -- instead wait until they focus and
    // interactive with page
    this._doChangeToForegroundTasks(breadcrumb);
  };}

  /** Ensure page remains active when a key is pressed. */
   __init16() {this._handleKeyboardEvent = (event) => {
    handleKeyboardEvent(this, event);
  };}

  /**
   * Tasks to run when we consider a page to be hidden (via blurring and/or visibility)
   */
   _doChangeToBackgroundTasks(breadcrumb) {
    if (!this.session) {
      return;
    }

    const expired = isSessionExpired(this.session, this.timeouts);

    if (breadcrumb && !expired) {
      this._createCustomBreadcrumb(breadcrumb);
    }

    // Send replay when the page/tab becomes hidden. There is no reason to send
    // replay if it becomes visible, since no actions we care about were done
    // while it was hidden
    void this.conditionalFlush();
  }

  /**
   * Tasks to run when we consider a page to be visible (via focus and/or visibility)
   */
   _doChangeToForegroundTasks(breadcrumb) {
    if (!this.session) {
      return;
    }

    const isSessionActive = this.checkAndHandleExpiredSession();

    if (!isSessionActive) {
      // If the user has come back to the page within SESSION_IDLE_PAUSE_DURATION
      // ms, we will re-use the existing session, otherwise create a new
      // session
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log('[Replay] Document has become active, but session has expired');
      return;
    }

    if (breadcrumb) {
      this._createCustomBreadcrumb(breadcrumb);
    }
  }

  /**
   * Trigger rrweb to take a full snapshot which will cause this plugin to
   * create a new Replay event.
   */
   _triggerFullSnapshot(checkout = true) {
    try {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log('[Replay] Taking full rrweb snapshot');
      record.takeFullSnapshot(checkout);
    } catch (err) {
      this._handleException(err);
    }
  }

  /**
   * Update user activity (across session lifespans)
   */
   _updateUserActivity(_lastActivity = Date.now()) {
    this._lastActivity = _lastActivity;
  }

  /**
   * Updates the session's last activity timestamp
   */
   _updateSessionActivity(_lastActivity = Date.now()) {
    if (this.session) {
      this.session.lastActivity = _lastActivity;
      this._maybeSaveSession();
    }
  }

  /**
   * Helper to create (and buffer) a replay breadcrumb from a core SDK breadcrumb
   */
   _createCustomBreadcrumb(breadcrumb) {
    this.addUpdate(() => {
      void this.throttledAddEvent({
        type: EventType.Custom,
        timestamp: breadcrumb.timestamp || 0,
        data: {
          tag: 'breadcrumb',
          payload: breadcrumb,
        },
      });
    });
  }

  /**
   * Observed performance events are added to `this.performanceEvents`. These
   * are included in the replay event before it is finished and sent to Sentry.
   */
   _addPerformanceEntries() {
    // Copy and reset entries before processing
    const entries = [...this.performanceEvents];
    this.performanceEvents = [];

    return Promise.all(createPerformanceSpans(this, createPerformanceEntries(entries)));
  }

  /**
   * Clear _context
   */
   _clearContext() {
    // XXX: `initialTimestamp` and `initialUrl` do not get cleared
    this._context.errorIds.clear();
    this._context.traceIds.clear();
    this._context.urls = [];
  }

  /** Update the initial timestamp based on the buffer content. */
   _updateInitialTimestampFromEventBuffer() {
    const { session, eventBuffer } = this;
    if (!session || !eventBuffer) {
      return;
    }

    // we only ever update this on the initial segment
    if (session.segmentId) {
      return;
    }

    const earliestEvent = eventBuffer.getEarliestTimestamp();
    if (earliestEvent && earliestEvent < this._context.initialTimestamp) {
      this._context.initialTimestamp = earliestEvent;
    }
  }

  /**
   * Return and clear _context
   */
   _popEventContext() {
    const _context = {
      initialTimestamp: this._context.initialTimestamp,
      initialUrl: this._context.initialUrl,
      errorIds: Array.from(this._context.errorIds),
      traceIds: Array.from(this._context.traceIds),
      urls: this._context.urls,
    };

    this._clearContext();

    return _context;
  }

  /**
   * Flushes replay event buffer to Sentry.
   *
   * Performance events are only added right before flushing - this is
   * due to the buffered performance observer events.
   *
   * Should never be called directly, only by `flush`
   */
   async _runFlush() {
    if (!this.session || !this.eventBuffer) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.error */.kg.error('[Replay] No session or eventBuffer found to flush.');
      return;
    }

    await this._addPerformanceEntries();

    // Check eventBuffer again, as it could have been stopped in the meanwhile
    if (!this.eventBuffer || !this.eventBuffer.hasEvents) {
      return;
    }

    // Only attach memory event if eventBuffer is not empty
    await addMemoryEntry(this);

    // Check eventBuffer again, as it could have been stopped in the meanwhile
    if (!this.eventBuffer) {
      return;
    }

    try {
      // This uses the data from the eventBuffer, so we need to call this before `finish()
      this._updateInitialTimestampFromEventBuffer();

      // Note this empties the event buffer regardless of outcome of sending replay
      const recordingData = await this.eventBuffer.finish();

      // NOTE: Copy values from instance members, as it's possible they could
      // change before the flush finishes.
      const replayId = this.session.id;
      const eventContext = this._popEventContext();
      // Always increment segmentId regardless of outcome of sending replay
      const segmentId = this.session.segmentId++;
      this._maybeSaveSession();

      await sendReplay({
        replayId,
        recordingData,
        segmentId,
        eventContext,
        session: this.session,
        options: this.getOptions(),
        timestamp: Date.now(),
      });
    } catch (err) {
      this._handleException(err);

      // This means we retried 3 times and all of them failed,
      // or we ran into a problem we don't want to retry, like rate limiting.
      // In this case, we want to completely stop the replay - otherwise, we may get inconsistent segments
      void this.stop('sendReplay');

      const client = (0,esm_hub/* getCurrentHub */.Gd)().getClient();

      if (client) {
        client.recordDroppedEvent('send_error', 'replay');
      }
    }
  }

  /**
   * Flush recording data to Sentry. Creates a lock so that only a single flush
   * can be active at a time. Do not call this directly.
   */
   __init17() {this._flush = async ({
    force = false,
  }

 = {}) => {
    if (!this._isEnabled && !force) {
      // This can happen if e.g. the replay was stopped because of exceeding the retry limit
      return;
    }

    if (!this.checkAndHandleExpiredSession()) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.error */.kg.error('[Replay] Attempting to finish replay event after session expired.');
      return;
    }

    if (!this.session) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.error */.kg.error('[Replay] No session found to flush.');
      return;
    }

    // A flush is about to happen, cancel any queued flushes
    this._debouncedFlush.cancel();

    // this._flushLock acts as a lock so that future calls to `_flush()`
    // will be blocked until this promise resolves
    if (!this._flushLock) {
      this._flushLock = this._runFlush();
      await this._flushLock;
      this._flushLock = null;
      return;
    }

    // Wait for previous flush to finish, then call the debounced `_flush()`.
    // It's possible there are other flush requests queued and waiting for it
    // to resolve. We want to reduce all outstanding requests (as well as any
    // new flush requests that occur within a second of the locked flush
    // completing) into a single flush.

    try {
      await this._flushLock;
    } catch (err) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.error */.kg.error(err);
    } finally {
      this._debouncedFlush();
    }
  };}

  /** Save the session, if it is sticky */
   _maybeSaveSession() {
    if (this.session && this._options.stickySession) {
      saveSession(this.session);
    }
  }

  /** Handler for rrweb.record.onMutation */
   __init18() {this._onMutationHandler = (mutations) => {
    const count = mutations.length;

    const mutationLimit = this._options.mutationLimit;
    const mutationBreadcrumbLimit = this._options.mutationBreadcrumbLimit;
    const overMutationLimit = mutationLimit && count > mutationLimit;

    // Create a breadcrumb if a lot of mutations happen at the same time
    // We can show this in the UI as an information with potential performance improvements
    if (count > mutationBreadcrumbLimit || overMutationLimit) {
      const breadcrumb = createBreadcrumb({
        category: 'replay.mutations',
        data: {
          count,
          limit: overMutationLimit,
        },
      });
      this._createCustomBreadcrumb(breadcrumb);
    }

    // Stop replay if over the mutation limit
    if (overMutationLimit) {
      void this.stop('mutationLimit');
      return false;
    }

    // `true` means we use the regular mutation handling by rrweb
    return true;
  };}
}

function getOption(
  selectors,
  defaultSelectors,
  deprecatedClassOption,
  deprecatedSelectorOption,
) {
  const deprecatedSelectors = typeof deprecatedSelectorOption === 'string' ? deprecatedSelectorOption.split(',') : [];

  const allSelectors = [
    ...selectors,
    // @deprecated
    ...deprecatedSelectors,

    // sentry defaults
    ...defaultSelectors,
  ];

  // @deprecated
  if (typeof deprecatedClassOption !== 'undefined') {
    // NOTE: No support for RegExp
    if (typeof deprecatedClassOption === 'string') {
      allSelectors.push(`.${deprecatedClassOption}`);
    }

    // eslint-disable-next-line no-console
    console.warn(
      '[Replay] You are using a deprecated configuration item for privacy. Read the documentation on how to use the new privacy configuration.',
    );
  }

  return allSelectors.join(',');
}

/**
 * Returns privacy related configuration for use in rrweb
 */
function getPrivacyOptions({
  mask,
  unmask,
  block,
  unblock,
  ignore,

  // eslint-disable-next-line deprecation/deprecation
  blockClass,
  // eslint-disable-next-line deprecation/deprecation
  blockSelector,
  // eslint-disable-next-line deprecation/deprecation
  maskTextClass,
  // eslint-disable-next-line deprecation/deprecation
  maskTextSelector,
  // eslint-disable-next-line deprecation/deprecation
  ignoreClass,
}) {
  const defaultBlockedElements = ['base[href="/"]'];

  const maskSelector = getOption(mask, ['.sentry-mask', '[data-sentry-mask]'], maskTextClass, maskTextSelector);
  const unmaskSelector = getOption(unmask, ['.sentry-unmask', '[data-sentry-unmask]']);

  const options = {
    // We are making the decision to make text and input selectors the same
    maskTextSelector: maskSelector,
    unmaskTextSelector: unmaskSelector,
    maskInputSelector: maskSelector,
    unmaskInputSelector: unmaskSelector,

    blockSelector: getOption(
      block,
      ['.sentry-block', '[data-sentry-block]', ...defaultBlockedElements],
      blockClass,
      blockSelector,
    ),
    unblockSelector: getOption(unblock, ['.sentry-unblock', '[data-sentry-unblock]']),
    ignoreSelector: getOption(ignore, ['.sentry-ignore', '[data-sentry-ignore]', 'input[type="file"]'], ignoreClass),
  };

  if (blockClass instanceof RegExp) {
    options.blockClass = blockClass;
  }

  if (maskTextClass instanceof RegExp) {
    options.maskTextClass = maskTextClass;
  }

  return options;
}

/**
 * Returns true if we are in the browser.
 */
function isBrowser() {
  // eslint-disable-next-line no-restricted-globals
  return typeof window !== 'undefined' && (!(0,node/* isNodeEnv */.KV)() || isElectronNodeRenderer());
}

// Electron renderers with nodeIntegration enabled are detected as Node.js so we specifically test for them
function isElectronNodeRenderer() {
  return typeof process !== 'undefined' && (process ).type === 'renderer';
}

const MEDIA_SELECTORS =
  'img,image,svg,video,object,picture,embed,map,audio,link[rel="icon"],link[rel="apple-touch-icon"]';

const DEFAULT_NETWORK_HEADERS = ['content-length', 'content-type', 'accept'];

let _initialized = false;

/**
 * The main replay integration class, to be passed to `init({  integrations: [] })`.
 */
class Replay  {
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'Replay';}

  /**
   * @inheritDoc
   */
   __init() {this.name = Replay.id;}

  /**
   * Options to pass to `rrweb.record()`
   */

  /**
   * Initial options passed to the replay integration, merged with default values.
   * Note: `sessionSampleRate` and `errorSampleRate` are not required here, as they
   * can only be finally set when setupOnce() is called.
   *
   * @private
   */

   constructor({
    flushMinDelay = DEFAULT_FLUSH_MIN_DELAY,
    flushMaxDelay = DEFAULT_FLUSH_MAX_DELAY,
    stickySession = true,
    useCompression = true,
    _experiments = {},
    sessionSampleRate,
    errorSampleRate,
    maskAllText = true,
    maskAllInputs = true,
    blockAllMedia = true,

    mutationBreadcrumbLimit = 750,
    mutationLimit = 10000,

    slowClickTimeout = 7000,
    slowClickIgnoreSelectors = [],

    networkDetailAllowUrls = [],
    networkCaptureBodies = true,
    networkRequestHeaders = [],
    networkResponseHeaders = [],

    mask = [],
    unmask = [],
    block = [],
    unblock = [],
    ignore = [],
    maskFn,

    beforeAddRecordingEvent,

    // eslint-disable-next-line deprecation/deprecation
    blockClass,
    // eslint-disable-next-line deprecation/deprecation
    blockSelector,
    // eslint-disable-next-line deprecation/deprecation
    maskInputOptions,
    // eslint-disable-next-line deprecation/deprecation
    maskTextClass,
    // eslint-disable-next-line deprecation/deprecation
    maskTextSelector,
    // eslint-disable-next-line deprecation/deprecation
    ignoreClass,
  } = {}) {Replay.prototype.__init.call(this);
    this._recordingOptions = {
      maskAllInputs,
      maskAllText,
      maskInputOptions: { ...(maskInputOptions || {}), password: true },
      maskTextFn: maskFn,
      maskInputFn: maskFn,

      ...getPrivacyOptions({
        mask,
        unmask,
        block,
        unblock,
        ignore,
        blockClass,
        blockSelector,
        maskTextClass,
        maskTextSelector,
        ignoreClass,
      }),

      // Our defaults
      slimDOMOptions: 'all',
      inlineStylesheet: true,
      // Disable inline images as it will increase segment/replay size
      inlineImages: false,
      // collect fonts, but be aware that `sentry.io` needs to be an allowed
      // origin for playback
      collectFonts: true,
    };

    this._initialOptions = {
      flushMinDelay,
      flushMaxDelay,
      stickySession,
      sessionSampleRate,
      errorSampleRate,
      useCompression,
      blockAllMedia,
      maskAllInputs,
      maskAllText,
      mutationBreadcrumbLimit,
      mutationLimit,
      slowClickTimeout,
      slowClickIgnoreSelectors,
      networkDetailAllowUrls,
      networkCaptureBodies,
      networkRequestHeaders: _getMergedNetworkHeaders(networkRequestHeaders),
      networkResponseHeaders: _getMergedNetworkHeaders(networkResponseHeaders),
      beforeAddRecordingEvent,

      _experiments,
    };

    if (typeof sessionSampleRate === 'number') {
      // eslint-disable-next-line
      console.warn(
        `[Replay] You are passing \`sessionSampleRate\` to the Replay integration.
This option is deprecated and will be removed soon.
Instead, configure \`replaysSessionSampleRate\` directly in the SDK init options, e.g.:
Sentry.init({ replaysSessionSampleRate: ${sessionSampleRate} })`,
      );

      this._initialOptions.sessionSampleRate = sessionSampleRate;
    }

    if (typeof errorSampleRate === 'number') {
      // eslint-disable-next-line
      console.warn(
        `[Replay] You are passing \`errorSampleRate\` to the Replay integration.
This option is deprecated and will be removed soon.
Instead, configure \`replaysOnErrorSampleRate\` directly in the SDK init options, e.g.:
Sentry.init({ replaysOnErrorSampleRate: ${errorSampleRate} })`,
      );

      this._initialOptions.errorSampleRate = errorSampleRate;
    }

    if (this._initialOptions.blockAllMedia) {
      // `blockAllMedia` is a more user friendly option to configure blocking
      // embedded media elements
      this._recordingOptions.blockSelector = !this._recordingOptions.blockSelector
        ? MEDIA_SELECTORS
        : `${this._recordingOptions.blockSelector},${MEDIA_SELECTORS}`;
    }

    if (this._isInitialized && isBrowser()) {
      throw new Error('Multiple Sentry Session Replay instances are not supported');
    }

    this._isInitialized = true;
  }

  /** If replay has already been initialized */
   get _isInitialized() {
    return _initialized;
  }

  /** Update _isInitialized */
   set _isInitialized(value) {
    _initialized = value;
  }

  /**
   * Setup and initialize replay container
   */
   setupOnce() {
    if (!isBrowser()) {
      return;
    }

    this._setup();

    // Once upon a time, we tried to create a transaction in `setupOnce` and it would
    // potentially create a transaction before some native SDK integrations have run
    // and applied their own global event processor. An example is:
    // https://github.com/getsentry/sentry-javascript/blob/b47ceafbdac7f8b99093ce6023726ad4687edc48/packages/browser/src/integrations/useragent.ts
    //
    // So we call `this._initialize()` in next event loop as a workaround to wait for other
    // global event processors to finish. This is no longer needed, but keeping it
    // here to avoid any future issues.
    setTimeout(() => this._initialize());
  }

  /**
   * Start a replay regardless of sampling rate. Calling this will always
   * create a new session. Will throw an error if replay is already in progress.
   *
   * Creates or loads a session, attaches listeners to varying events (DOM,
   * PerformanceObserver, Recording, Sentry SDK, etc)
   */
   start() {
    if (!this._replay) {
      return;
    }

    this._replay.start();
  }

  /**
   * Start replay buffering. Buffers until `flush()` is called or, if
   * `replaysOnErrorSampleRate` > 0, until an error occurs.
   */
   startBuffering() {
    if (!this._replay) {
      return;
    }

    this._replay.startBuffering();
  }

  /**
   * Currently, this needs to be manually called (e.g. for tests). Sentry SDK
   * does not support a teardown
   */
   stop() {
    if (!this._replay) {
      return Promise.resolve();
    }

    return this._replay.stop();
  }

  /**
   * If not in "session" recording mode, flush event buffer which will create a new replay.
   * Unless `continueRecording` is false, the replay will continue to record and
   * behave as a "session"-based replay.
   *
   * Otherwise, queue up a flush.
   */
   flush(options) {
    if (!this._replay || !this._replay.isEnabled()) {
      return Promise.resolve();
    }

    return this._replay.sendBufferedReplayOrFlush(options);
  }

  /**
   * Get the current session ID.
   */
   getReplayId() {
    if (!this._replay || !this._replay.isEnabled()) {
      return;
    }

    return this._replay.getSessionId();
  }
  /**
   * Initializes replay.
   */
   _initialize() {
    if (!this._replay) {
      return;
    }

    this._replay.initializeSampling();
  }

  /** Setup the integration. */
   _setup() {
    // Client is not available in constructor, so we need to wait until setupOnce
    const finalOptions = loadReplayOptionsFromClient(this._initialOptions);

    this._replay = new ReplayContainer({
      options: finalOptions,
      recordingOptions: this._recordingOptions,
    });
  }
} Replay.__initStatic();

/** Parse Replay-related options from SDK options */
function loadReplayOptionsFromClient(initialOptions) {
  const client = (0,esm_hub/* getCurrentHub */.Gd)().getClient();
  const opt = client && (client.getOptions() );

  const finalOptions = { sessionSampleRate: 0, errorSampleRate: 0, ...(0,object/* dropUndefinedKeys */.Jr)(initialOptions) };

  if (!opt) {
    // eslint-disable-next-line no-console
    console.warn('SDK client is not available.');
    return finalOptions;
  }

  if (
    initialOptions.sessionSampleRate == null && // TODO remove once deprecated rates are removed
    initialOptions.errorSampleRate == null && // TODO remove once deprecated rates are removed
    opt.replaysSessionSampleRate == null &&
    opt.replaysOnErrorSampleRate == null
  ) {
    // eslint-disable-next-line no-console
    console.warn(
      'Replay is disabled because neither `replaysSessionSampleRate` nor `replaysOnErrorSampleRate` are set.',
    );
  }

  if (typeof opt.replaysSessionSampleRate === 'number') {
    finalOptions.sessionSampleRate = opt.replaysSessionSampleRate;
  }

  if (typeof opt.replaysOnErrorSampleRate === 'number') {
    finalOptions.errorSampleRate = opt.replaysOnErrorSampleRate;
  }

  return finalOptions;
}

function _getMergedNetworkHeaders(headers) {
  return [...DEFAULT_NETWORK_HEADERS, ...headers.map(header => header.toLowerCase())];
}


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ../node_modules/@sentry/utils/esm/ratelimit.js
var ratelimit = __webpack_require__(34006);
;// CONCATENATED MODULE: ../node_modules/@sentry/core/esm/transports/offline.js


const MIN_DELAY = 100; // 100 ms
const START_DELAY = 5000; // 5 seconds
const MAX_DELAY = 3.6e6; // 1 hour

function log(msg, error) {
  (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.info */.kg.info(`[Offline]: ${msg}`, error);
}

/**
 * Wraps a transport and stores and retries events when they fail to send.
 *
 * @param createTransport The transport to wrap.
 */
function makeOfflineTransport(
  createTransport,
) {
  return options => {
    const transport = createTransport(options);
    const store = options.createStore ? options.createStore(options) : undefined;

    let retryDelay = START_DELAY;
    let flushTimer;

    function shouldQueue(env, error, retryDelay) {
      // We don't queue Session Replay envelopes because they are:
      // - Ordered and Replay relies on the response status to know when they're successfully sent.
      // - Likely to fill the queue quickly and block other events from being sent.
      // We also want to drop client reports because they can be generated when we retry sending events while offline.
      if ((0,envelope/* envelopeContainsItemType */.R)(env, ['replay_event', 'replay_recording', 'client_report'])) {
        return false;
      }

      if (options.shouldStore) {
        return options.shouldStore(env, error, retryDelay);
      }

      return true;
    }

    function flushIn(delay) {
      if (!store) {
        return;
      }

      if (flushTimer) {
        clearTimeout(flushTimer );
      }

      flushTimer = setTimeout(async () => {
        flushTimer = undefined;

        const found = await store.pop();
        if (found) {
          log('Attempting to send previously queued event');
          void send(found).catch(e => {
            log('Failed to retry sending', e);
          });
        }
      }, delay) ;

      // We need to unref the timer in node.js, otherwise the node process never exit.
      if (typeof flushTimer !== 'number' && flushTimer.unref) {
        flushTimer.unref();
      }
    }

    function flushWithBackOff() {
      if (flushTimer) {
        return;
      }

      flushIn(retryDelay);

      retryDelay = Math.min(retryDelay * 2, MAX_DELAY);
    }

    async function send(envelope) {
      try {
        const result = await transport.send(envelope);

        let delay = MIN_DELAY;

        if (result) {
          // If there's a retry-after header, use that as the next delay.
          if (result.headers && result.headers['retry-after']) {
            delay = (0,ratelimit/* parseRetryAfterHeader */.JY)(result.headers['retry-after']);
          } // If we have a server error, return now so we don't flush the queue.
          else if ((result.statusCode || 0) >= 400) {
            return result;
          }
        }

        flushIn(delay);
        retryDelay = START_DELAY;
        return result;
      } catch (e) {
        if (store && (await shouldQueue(envelope, e, retryDelay))) {
          await store.insert(envelope);
          flushWithBackOff();
          log('Error sending. Event queued', e);
          return {};
        } else {
          throw e;
        }
      }
    }

    if (options.flushAtStartup) {
      flushWithBackOff();
    }

    return {
      send,
      flush: t => transport.flush(t),
    };
  };
}


//# sourceMappingURL=offline.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/browser/esm/transports/offline.js



// 'Store', 'promisifyRequest' and 'createStore' were originally copied from the 'idb-keyval' package before being
// modified and simplified: https://github.com/jakearchibald/idb-keyval
//
// At commit: 0420a704fd6cbb4225429c536b1f61112d012fca
// Original licence:

// Copyright 2016, Jake Archibald
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//   http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

function promisifyRequest(request) {
  return new Promise((resolve, reject) => {
    // @ts-ignore - file size hacks
    request.oncomplete = request.onsuccess = () => resolve(request.result);
    // @ts-ignore - file size hacks
    request.onabort = request.onerror = () => reject(request.error);
  });
}

/** Create or open an IndexedDb store */
function createStore(dbName, storeName) {
  const request = indexedDB.open(dbName);
  request.onupgradeneeded = () => request.result.createObjectStore(storeName);
  const dbp = promisifyRequest(request);

  return callback => dbp.then(db => callback(db.transaction(storeName, 'readwrite').objectStore(storeName)));
}

function keys(store) {
  return promisifyRequest(store.getAllKeys() );
}

/** Insert into the store */
function insert(store, value, maxQueueSize) {
  return store(store => {
    return keys(store).then(keys => {
      if (keys.length >= maxQueueSize) {
        return;
      }

      // We insert with an incremented key so that the entries are popped in order
      store.put(value, Math.max(...keys, 0) + 1);
      return promisifyRequest(store.transaction);
    });
  });
}

/** Pop the oldest value from the store */
function pop(store) {
  return store(store => {
    return keys(store).then(keys => {
      if (keys.length === 0) {
        return undefined;
      }

      return promisifyRequest(store.get(keys[0])).then(value => {
        store.delete(keys[0]);
        return promisifyRequest(store.transaction).then(() => value);
      });
    });
  });
}

function createIndexedDbStore(options) {
  let store;

  // Lazily create the store only when it's needed
  function getStore() {
    if (store == undefined) {
      store = createStore(options.dbName || 'sentry-offline', options.storeName || 'queue');
    }

    return store;
  }

  return {
    insert: async (env) => {
      try {
        const serialized = await (0,envelope/* serializeEnvelope */.V$)(env, options.textEncoder);
        await insert(getStore(), serialized, options.maxQueueSize || 30);
      } catch (_) {
        //
      }
    },
    pop: async () => {
      try {
        const deserialized = await pop(getStore());
        if (deserialized) {
          return (0,envelope/* parseEnvelope */.f4)(
            deserialized,
            options.textEncoder || new TextEncoder(),
            options.textDecoder || new TextDecoder(),
          );
        }
      } catch (_) {
        //
      }

      return undefined;
    },
  };
}

function makeIndexedDbOfflineTransport(
  createTransport,
) {
  return options => createTransport({ ...options, createStore: createIndexedDbStore });
}

/**
 * Creates a transport that uses IndexedDb to store events when offline.
 */
function makeBrowserOfflineTransport(
  createTransport,
) {
  return makeIndexedDbOfflineTransport(makeOfflineTransport(createTransport));
}


//# sourceMappingURL=offline.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/browser/esm/profiling/cache.js
/**
 * Creates a cache that evicts keys in fifo order
 * @param size {Number}
 */
function makeProfilingCache(
  size,
)

 {
  // Maintain a fifo queue of keys, we cannot rely on Object.keys as the browser may not support it.
  let evictionOrder = [];
  let cache = {};

  return {
    add(key, value) {
      while (evictionOrder.length >= size) {
        // shift is O(n) but this is small size and only happens if we are
        // exceeding the cache size so it should be fine.
        const evictCandidate = evictionOrder.shift();

        if (evictCandidate !== undefined) {
          // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
          delete cache[evictCandidate];
        }
      }

      // in case we have a collision, delete the old key.
      if (cache[key]) {
        this.delete(key);
      }

      evictionOrder.push(key);
      cache[key] = value;
    },
    clear() {
      cache = {};
      evictionOrder = [];
    },
    get(key) {
      return cache[key];
    },
    size() {
      return evictionOrder.length;
    },
    // Delete cache key and return true if it existed, false otherwise.
    delete(key) {
      if (!cache[key]) {
        return false;
      }

      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete cache[key];

      for (let i = 0; i < evictionOrder.length; i++) {
        if (evictionOrder[i] === key) {
          evictionOrder.splice(i, 1);
          break;
        }
      }

      return true;
    },
  };
}

const PROFILING_EVENT_CACHE = makeProfilingCache(20);


//# sourceMappingURL=cache.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/browser/esm/profiling/utils.js




const MS_TO_NS = 1e6;
// Use 0 as main thread id which is identical to threadId in node:worker_threads
// where main logs 0 and workers seem to log in increments of 1
const THREAD_ID_STRING = String(0);
const THREAD_NAME = 'main';

// Machine properties (eval only once)
let OS_PLATFORM = ''; // macos
let OS_PLATFORM_VERSION = ''; // 13.2
let OS_ARCH = ''; // arm64
let OS_BROWSER = (helpers/* WINDOW.navigator */.m9.navigator && helpers/* WINDOW.navigator.userAgent */.m9.navigator.userAgent) || '';
let OS_MODEL = '';
const OS_LOCALE =
  (helpers/* WINDOW.navigator */.m9.navigator && helpers/* WINDOW.navigator.language */.m9.navigator.language) ||
  (helpers/* WINDOW.navigator */.m9.navigator && helpers/* WINDOW.navigator.languages */.m9.navigator.languages && helpers/* WINDOW.navigator.languages.0 */.m9.navigator.languages[0]) ||
  '';

function isUserAgentData(data) {
  return typeof data === 'object' && data !== null && 'getHighEntropyValues' in data;
}

// @ts-ignore userAgentData is not part of the navigator interface yet
const userAgentData = helpers/* WINDOW.navigator */.m9.navigator && helpers/* WINDOW.navigator.userAgentData */.m9.navigator.userAgentData;

if (isUserAgentData(userAgentData)) {
  userAgentData
    .getHighEntropyValues(['architecture', 'model', 'platform', 'platformVersion', 'fullVersionList'])
    .then((ua) => {
      OS_PLATFORM = ua.platform || '';
      OS_ARCH = ua.architecture || '';
      OS_MODEL = ua.model || '';
      OS_PLATFORM_VERSION = ua.platformVersion || '';

      if (ua.fullVersionList && ua.fullVersionList.length > 0) {
        const firstUa = ua.fullVersionList[ua.fullVersionList.length - 1];
        OS_BROWSER = `${firstUa.brand} ${firstUa.version}`;
      }
    })
    .catch(e => void e);
}

function isRawThreadCpuProfile(profile) {
  return !('thread_metadata' in profile);
}

// Enriches the profile with threadId of the current thread.
// This is done in node as we seem to not be able to get the info from C native code.
/**
 *
 */
function enrichWithThreadInformation(profile) {
  if (!isRawThreadCpuProfile(profile)) {
    return profile;
  }

  return convertJSSelfProfileToSampledFormat(profile);
}

// Profile is marked as optional because it is deleted from the metadata
// by the integration before the event is processed by other integrations.

/** Extract sdk info from from the API metadata */
function getSdkMetadataForEnvelopeHeader(metadata) {
  if (!metadata || !metadata.sdk) {
    return undefined;
  }

  return { name: metadata.sdk.name, version: metadata.sdk.version } ;
}

/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/
function enhanceEventWithSdkInfo(event, sdkInfo) {
  if (!sdkInfo) {
    return event;
  }
  event.sdk = event.sdk || {};
  event.sdk.name = event.sdk.name || sdkInfo.name || 'unknown sdk';
  event.sdk.version = event.sdk.version || sdkInfo.version || 'unknown sdk version';
  event.sdk.integrations = [...(event.sdk.integrations || []), ...(sdkInfo.integrations || [])];
  event.sdk.packages = [...(event.sdk.packages || []), ...(sdkInfo.packages || [])];
  return event;
}

function createEventEnvelopeHeaders(
  event,
  sdkInfo,
  tunnel,
  dsn,
) {
  const dynamicSamplingContext = event.sdkProcessingMetadata && event.sdkProcessingMetadata['dynamicSamplingContext'];

  return {
    event_id: event.event_id ,
    sent_at: new Date().toISOString(),
    ...(sdkInfo && { sdk: sdkInfo }),
    ...(!!tunnel && { dsn: (0,esm_dsn/* dsnToString */.RA)(dsn) }),
    ...(event.type === 'transaction' &&
      dynamicSamplingContext && {
        trace: (0,object/* dropUndefinedKeys */.Jr)({ ...dynamicSamplingContext }) ,
      }),
  };
}

function getTraceId(event) {
  const traceId = event && event.contexts && event.contexts['trace'] && event.contexts['trace']['trace_id'];
  // Log a warning if the profile has an invalid traceId (should be uuidv4).
  // All profiles and transactions are rejected if this is the case and we want to
  // warn users that this is happening if they enable debug flag
  if (typeof traceId === 'string' && traceId.length !== 32) {
    if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
      logger/* logger.log */.kg.log(`[Profiling] Invalid traceId: ${traceId} on profiled event`);
    }
  }
  if (typeof traceId !== 'string') {
    return '';
  }

  return traceId;
}
/**
 * Creates a profiling event envelope from a Sentry event. If profile does not pass
 * validation, returns null.
 * @param event
 * @param dsn
 * @param metadata
 * @param tunnel
 * @returns {EventEnvelope | null}
 */

/**
 * Creates a profiling event envelope from a Sentry event.
 */
function createProfilingEventEnvelope(
  event,
  dsn,
  metadata,
  tunnel,
) {
  if (event.type !== 'transaction') {
    // createProfilingEventEnvelope should only be called for transactions,
    // we type guard this behavior with isProfiledTransactionEvent.
    throw new TypeError('Profiling events may only be attached to transactions, this should never occur.');
  }

  const rawProfile = event.sdkProcessingMetadata['profile'];

  if (rawProfile === undefined || rawProfile === null) {
    throw new TypeError(
      `Cannot construct profiling event envelope without a valid profile. Got ${rawProfile} instead.`,
    );
  }

  if (!rawProfile.profile_id) {
    throw new TypeError('Profile is missing profile_id');
  }

  if (rawProfile.samples.length <= 1) {
    if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
      // Log a warning if the profile has less than 2 samples so users can know why
      // they are not seeing any profiling data and we cant avoid the back and forth
      // of asking them to provide us with a dump of the profile data.
      logger/* logger.log */.kg.log('[Profiling] Discarding profile because it contains less than 2 samples');
    }
    return null;
  }

  const traceId = getTraceId(event);
  const sdkInfo = getSdkMetadataForEnvelopeHeader(metadata);
  enhanceEventWithSdkInfo(event, metadata && metadata.sdk);
  const envelopeHeaders = createEventEnvelopeHeaders(event, sdkInfo, tunnel, dsn);
  const enrichedThreadProfile = enrichWithThreadInformation(rawProfile);
  const transactionStartMs = typeof event.start_timestamp === 'number' ? event.start_timestamp * 1000 : Date.now();
  const transactionEndMs = typeof event.timestamp === 'number' ? event.timestamp * 1000 : Date.now();

  const profile = {
    event_id: rawProfile.profile_id,
    timestamp: new Date(transactionStartMs).toISOString(),
    platform: 'javascript',
    version: '1',
    release: event.release || '',
    environment: event.environment || constants/* DEFAULT_ENVIRONMENT */.J,
    runtime: {
      name: 'javascript',
      version: helpers/* WINDOW.navigator.userAgent */.m9.navigator.userAgent,
    },
    os: {
      name: OS_PLATFORM,
      version: OS_PLATFORM_VERSION,
      build_number: OS_BROWSER,
    },
    device: {
      locale: OS_LOCALE,
      model: OS_MODEL,
      manufacturer: OS_BROWSER,
      architecture: OS_ARCH,
      is_emulator: false,
    },
    profile: enrichedThreadProfile,
    transactions: [
      {
        name: event.transaction || '',
        id: event.event_id || (0,misc/* uuid4 */.DM)(),
        trace_id: traceId,
        active_thread_id: THREAD_ID_STRING,
        relative_start_ns: '0',
        relative_end_ns: ((transactionEndMs - transactionStartMs) * 1e6).toFixed(0),
      },
    ],
  };

  const envelopeItem = [
    {
      type: 'profile',
    },
    // @ts-ignore this is missing in typedef
    profile,
  ];

  return (0,envelope/* createEnvelope */.Jd)(envelopeHeaders, [envelopeItem]);
}

/**
 * Converts a JSSelfProfile to a our sampled format.
 * Does not currently perform stack indexing.
 */
function convertJSSelfProfileToSampledFormat(input) {
  let EMPTY_STACK_ID = undefined;
  let STACK_ID = 0;

  // Initialize the profile that we will fill with data
  const profile = {
    samples: [],
    stacks: [],
    frames: [],
    thread_metadata: {
      [THREAD_ID_STRING]: { name: THREAD_NAME },
    },
  };

  if (!input.samples.length) {
    return profile;
  }

  // We assert samples.length > 0 above and timestamp should always be present
  const start = input.samples[0].timestamp;

  for (let i = 0; i < input.samples.length; i++) {
    const jsSample = input.samples[i];

    // If sample has no stack, add an empty sample
    if (jsSample.stackId === undefined) {
      if (EMPTY_STACK_ID === undefined) {
        EMPTY_STACK_ID = STACK_ID;
        profile.stacks[EMPTY_STACK_ID] = [];
        STACK_ID++;
      }

      profile['samples'][i] = {
        // convert ms timestamp to ns
        elapsed_since_start_ns: ((jsSample.timestamp - start) * MS_TO_NS).toFixed(0),
        stack_id: EMPTY_STACK_ID,
        thread_id: THREAD_ID_STRING,
      };
      continue;
    }

    let stackTop = input.stacks[jsSample.stackId];

    // Functions in top->down order (root is last)
    // We follow the stackTop.parentId trail and collect each visited frameId
    const stack = [];

    while (stackTop) {
      stack.push(stackTop.frameId);

      const frame = input.frames[stackTop.frameId];

      // If our frame has not been indexed yet, index it
      if (profile.frames[stackTop.frameId] === undefined) {
        profile.frames[stackTop.frameId] = {
          function: frame.name,
          file: frame.resourceId ? input.resources[frame.resourceId] : undefined,
          line: frame.line,
          column: frame.column,
        };
      }

      stackTop = stackTop.parentId === undefined ? undefined : input.stacks[stackTop.parentId];
    }

    const sample = {
      // convert ms timestamp to ns
      elapsed_since_start_ns: ((jsSample.timestamp - start) * MS_TO_NS).toFixed(0),
      stack_id: STACK_ID,
      thread_id: THREAD_ID_STRING,
    };

    profile['stacks'][STACK_ID] = stack;
    profile['samples'][i] = sample;
    STACK_ID++;
  }

  return profile;
}


//# sourceMappingURL=utils.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/browser/esm/profiling/sendProfile.js





/**
 * Performs lookup in the event cache and sends the profile to Sentry.
 * If the profiled transaction event is found, we use the profiled transaction event and profile
 * to construct a profile type envelope and send it to Sentry.
 */
function sendProfile(profileId, profile) {
  const event = PROFILING_EVENT_CACHE.get(profileId);

  if (!event) {
    // We could not find a corresponding transaction event for this profile.
    // Opt to do nothing for now, but in the future we should implement a simple retry mechanism.
    if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
      logger/* logger.log */.kg.log("[Profiling] Couldn't find a transaction event for this profile, dropping it.");
    }
    return;
  }

  event.sdkProcessingMetadata = event.sdkProcessingMetadata || {};
  if (event.sdkProcessingMetadata && !event.sdkProcessingMetadata['profile']) {
    event.sdkProcessingMetadata['profile'] = profile;
  }

  // Client, Dsn and Transport are all required to be able to send the profiling event to Sentry.
  // If either of them is not available, we remove the profile from the transaction event.
  // and forward it to the next event processor.
  const hub = (0,esm_hub/* getCurrentHub */.Gd)();
  const client = hub.getClient();

  if (!client) {
    if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
      logger/* logger.log */.kg.log(
        '[Profiling] getClient did not return a Client, removing profile from event and forwarding to next event processors.',
      );
    }
    return;
  }

  const dsn = client.getDsn();
  if (!dsn) {
    if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
      logger/* logger.log */.kg.log(
        '[Profiling] getDsn did not return a Dsn, removing profile from event and forwarding to next event processors.',
      );
    }
    return;
  }

  const transport = client.getTransport();
  if (!transport) {
    if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
      logger/* logger.log */.kg.log(
        '[Profiling] getTransport did not return a Transport, removing profile from event and forwarding to next event processors.',
      );
    }
    return;
  }

  // If all required components are available, we construct a profiling event envelope and send it to Sentry.
  if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
    logger/* logger.log */.kg.log('[Profiling] Preparing envelope and sending a profiling event');
  }
  const envelope = createProfilingEventEnvelope(event , dsn);

  // Evict event from the cache - we want to prevent the LRU cache from prioritizing already sent events over new ones.
  PROFILING_EVENT_CACHE["delete"](profileId);

  if (!envelope) {
    if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
      logger/* logger.log */.kg.log('[Profiling] Failed to construct envelope');
    }
    return;
  }

  if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
    logger/* logger.log */.kg.log('[Profiling] Envelope constructed, sending it');
  }

  // Wrap in try/catch because send will throw in case of a network error.
  transport.send(envelope).then(null, reason => {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log('[Profiling] Error while sending event:', reason);
  });
}


//# sourceMappingURL=sendProfile.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/browser/esm/profiling/hubextensions.js





// Max profile duration.
const MAX_PROFILE_DURATION_MS = 30000;
// Keep a flag value to avoid re-initializing the profiler constructor. If it fails
// once, it will always fail and this allows us to early return.
let PROFILING_CONSTRUCTOR_FAILED = false;

// While we experiment, per transaction sampling interval will be more flexible to work with.

/**
 * Check if profiler constructor is available.
 * @param maybeProfiler
 */
function isJSProfilerSupported(maybeProfiler) {
  return typeof maybeProfiler === 'function';
}

/**
 * Safety wrapper for startTransaction for the unlikely case that transaction starts before tracing is imported -
 * if that happens we want to avoid throwing an error from profiling code.
 * see https://github.com/getsentry/sentry-javascript/issues/4731.
 *
 * @experimental
 */
function onProfilingStartRouteTransaction(transaction) {
  if (!transaction) {
    if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
      logger/* logger.log */.kg.log('[Profiling] Transaction is undefined, skipping profiling');
    }
    return transaction;
  }

  return wrapTransactionWithProfiling(transaction);
}

/**
 * Wraps startTransaction and stopTransaction with profiling related logic.
 * startProfiling is called after the call to startTransaction in order to avoid our own code from
 * being profiled. Because of that same reason, stopProfiling is called before the call to stopTransaction.
 */
function wrapTransactionWithProfiling(transaction) {
  // Feature support check first
  const JSProfilerConstructor = helpers/* WINDOW.Profiler */.m9.Profiler;

  if (!isJSProfilerSupported(JSProfilerConstructor)) {
    if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
      logger/* logger.log */.kg.log(
        '[Profiling] Profiling is not supported by this browser, Profiler interface missing on window object.',
      );
    }
    return transaction;
  }

  // profilesSampleRate is multiplied with tracesSampleRate to get the final sampling rate.
  if (!transaction.sampled) {
    if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
      logger/* logger.log */.kg.log('[Profiling] Transaction is not sampled, skipping profiling');
    }
    return transaction;
  }

  // If constructor failed once, it will always fail, so we can early return.
  if (PROFILING_CONSTRUCTOR_FAILED) {
    if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
      logger/* logger.log */.kg.log('[Profiling] Profiling has been disabled for the duration of the current user session.');
    }
    return transaction;
  }

  const client = (0,esm_hub/* getCurrentHub */.Gd)().getClient();
  const options = client && client.getOptions();

  // @ts-ignore not part of the browser options yet
  const profilesSampleRate = (options && options.profilesSampleRate) || 0;
  if (profilesSampleRate === undefined) {
    if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
      logger/* logger.log */.kg.log('[Profiling] Profiling disabled, enable it by setting `profilesSampleRate` option to SDK init call.');
    }
    return transaction;
  }

  // Check if we should sample this profile
  if (Math.random() > profilesSampleRate) {
    if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
      logger/* logger.log */.kg.log('[Profiling] Skip profiling transaction due to sampling.');
    }
    return transaction;
  }

  // From initial testing, it seems that the minimum value for sampleInterval is 10ms.
  const samplingIntervalMS = 10;
  // Start the profiler
  const maxSamples = Math.floor(MAX_PROFILE_DURATION_MS / samplingIntervalMS);
  let profiler;

  // Attempt to initialize the profiler constructor, if it fails, we disable profiling for the current user session.
  // This is likely due to a missing 'Document-Policy': 'js-profiling' header. We do not want to throw an error if this happens
  // as we risk breaking the user's application, so just disable profiling and log an error.
  try {
    profiler = new JSProfilerConstructor({ sampleInterval: samplingIntervalMS, maxBufferSize: maxSamples });
  } catch (e) {
    if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
      logger/* logger.log */.kg.log(
        "[Profiling] Failed to initialize the Profiling constructor, this is likely due to a missing 'Document-Policy': 'js-profiling' header.",
      );
      logger/* logger.log */.kg.log('[Profiling] Disabling profiling for current user session.');
    }
    PROFILING_CONSTRUCTOR_FAILED = true;
  }

  // We failed to construct the profiler, fallback to original transaction - there is no need to log
  // anything as we already did that in the try/catch block.
  if (!profiler) {
    return transaction;
  }

  if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
    logger/* logger.log */.kg.log(`[Profiling] started profiling transaction: ${transaction.name || transaction.description}`);
  }

  // We create "unique" transaction names to avoid concurrent transactions with same names
  // from being ignored by the profiler. From here on, only this transaction name should be used when
  // calling the profiler methods. Note: we log the original name to the user to avoid confusion.
  const profileId = (0,misc/* uuid4 */.DM)();

  // A couple of important things to note here:
  // `CpuProfilerBindings.stopProfiling` will be scheduled to run in 30seconds in order to exceed max profile duration.
  // Whichever of the two (transaction.finish/timeout) is first to run, the profiling will be stopped and the gathered profile
  // will be processed when the original transaction is finished. Since onProfileHandler can be invoked multiple times in the
  // event of an error or user mistake (calling transaction.finish multiple times), it is important that the behavior of onProfileHandler
  // is idempotent as we do not want any timings or profiles to be overriden by the last call to onProfileHandler.
  // After the original finish method is called, the event will be reported through the integration and delegated to transport.
  let processedProfile = null;

  /**
   * Idempotent handler for profile stop
   */
  function onProfileHandler() {
    // Check if the profile exists and return it the behavior has to be idempotent as users may call transaction.finish multiple times.
    if (!transaction) {
      return;
    }
    // Satisfy the type checker, but profiler will always be defined here.
    if (!profiler) {
      return;
    }
    if (processedProfile) {
      if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
        logger/* logger.log */.kg.log(
          '[Profiling] profile for:',
          transaction.name || transaction.description,
          'already exists, returning early',
        );
      }
      return;
    }

    profiler
      .stop()
      .then((p) => {
        if (maxDurationTimeoutID) {
          helpers/* WINDOW.clearTimeout */.m9.clearTimeout(maxDurationTimeoutID);
          maxDurationTimeoutID = undefined;
        }

        if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
          logger/* logger.log */.kg.log(`[Profiling] stopped profiling of transaction: ${transaction.name || transaction.description}`);
        }

        // In case of an overlapping transaction, stopProfiling may return null and silently ignore the overlapping profile.
        if (!p) {
          if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
            logger/* logger.log */.kg.log(
              `[Profiling] profiler returned null profile for: ${transaction.name || transaction.description}`,
              'this may indicate an overlapping transaction or a call to stopProfiling with a profile title that was never started',
            );
          }
          return;
        }

        // If a profile has less than 2 samples, it is not useful and should be discarded.
        if (p.samples.length < 2) {
          return;
        }

        processedProfile = { ...p, profile_id: profileId };
        sendProfile(profileId, processedProfile);
      })
      .catch(error => {
        if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
          logger/* logger.log */.kg.log('[Profiling] error while stopping profiler:', error);
        }
        return null;
      });
  }

  // Enqueue a timeout to prevent profiles from running over max duration.
  let maxDurationTimeoutID = helpers/* WINDOW.setTimeout */.m9.setTimeout(() => {
    if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
      logger/* logger.log */.kg.log(
        '[Profiling] max profile duration elapsed, stopping profiling for:',
        transaction.name || transaction.description,
      );
    }
    void onProfileHandler();
  }, MAX_PROFILE_DURATION_MS);

  // We need to reference the original finish call to avoid creating an infinite loop
  const originalFinish = transaction.finish.bind(transaction);

  /**
   * Wraps startTransaction and stopTransaction with profiling related logic.
   * startProfiling is called after the call to startTransaction in order to avoid our own code from
   * being profiled. Because of that same reason, stopProfiling is called before the call to stopTransaction.
   */
  function profilingWrappedTransactionFinish() {
    if (!transaction) {
      return originalFinish();
    }
    // onProfileHandler should always return the same profile even if this is called multiple times.
    // Always call onProfileHandler to ensure stopProfiling is called and the timeout is cleared.
    onProfileHandler();

    // Set profile context
    transaction.setContext('profile', { profile_id: profileId });

    return originalFinish();
  }

  transaction.finish = profilingWrappedTransactionFinish;
  return transaction;
}

/**
 * Wraps startTransaction with profiling logic. This is done automatically by the profiling integration.
 */
function __PRIVATE__wrapStartTransactionWithProfiling(startTransaction) {
  return function wrappedStartTransaction(

    transactionContext,
    customSamplingContext,
  ) {
    const transaction = startTransaction.call(this, transactionContext, customSamplingContext);
    if (transaction === undefined) {
      if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
        logger/* logger.log */.kg.log('[Profiling] Transaction is undefined, skipping profiling');
      }
      return transaction;
    }

    return wrapTransactionWithProfiling(transaction);
  };
}

/**
 * Patches startTransaction and stopTransaction with profiling logic.
 */
function addProfilingExtensionMethods() {
  const carrier = (0,esm_hub/* getMainCarrier */.cu)();
  if (!carrier.__SENTRY__) {
    if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
      logger/* logger.log */.kg.log("[Profiling] Can't find main carrier, profiling won't work.");
    }
    return;
  }
  carrier.__SENTRY__.extensions = carrier.__SENTRY__.extensions || {};

  if (!carrier.__SENTRY__.extensions['startTransaction']) {
    if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
      logger/* logger.log */.kg.log(
        '[Profiling] startTransaction does not exists, profiling will not work. Make sure you import @sentry/tracing package before @sentry/profiling-node as import order matters.',
      );
    }
    return;
  }

  if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
    logger/* logger.log */.kg.log('[Profiling] startTransaction exists, patching it with profiling functionality...');
  }

  carrier.__SENTRY__.extensions['startTransaction'] = __PRIVATE__wrapStartTransactionWithProfiling(
    // This is already patched by sentry/tracing, we are going to re-patch it...
    carrier.__SENTRY__.extensions['startTransaction'] ,
  );
}


//# sourceMappingURL=hubextensions.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/browser/esm/profiling/integration.js




/**
 * Browser profiling integration. Stores any event that has contexts["profile"]["profile_id"]
 * This exists because we do not want to await async profiler.stop calls as transaction.finish is called
 * in a synchronous context. Instead, we handle sending the profile async from the promise callback and
 * rely on being able to pull the event from the cache when we need to construct the envelope. This makes the
 * integration less reliable as we might be dropping profiles when the cache is full.
 *
 * @experimental
 */
class BrowserProfilingIntegration  {constructor() { BrowserProfilingIntegration.prototype.__init.call(this); }
    __init() {this.name = 'BrowserProfilingIntegration';}

  /**
   * @inheritDoc
   */
   setupOnce(addGlobalEventProcessor) {
    // Patching the hub to add the extension methods.
    // Warning: we have an implicit dependency on import order and we will fail patching if the constructor of
    // BrowserProfilingIntegration is called before @sentry/tracing is imported. This is because we need to patch
    // the methods of @sentry/tracing which are patched as a side effect of importing @sentry/tracing.
    addProfilingExtensionMethods();

    // Add our event processor
    addGlobalEventProcessor(this.handleGlobalEvent.bind(this));
  }

  /**
   * @inheritDoc
   */
   handleGlobalEvent(event) {
    const profileId = event.contexts && event.contexts['profile'] && event.contexts['profile']['profile_id'];

    if (profileId && typeof profileId === 'string') {
      if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
        logger/* logger.log */.kg.log('[Profiling] Profiling event found, caching it.');
      }
      PROFILING_EVENT_CACHE.add(profileId, event);
    }

    return event;
  }
}


//# sourceMappingURL=integration.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/browser/esm/index.js
























let windowIntegrations = {};

// This block is needed to add compatibility with the integrations packages when used with a CDN
if (helpers/* WINDOW.Sentry */.m9.Sentry && helpers/* WINDOW.Sentry.Integrations */.m9.Sentry.Integrations) {
  windowIntegrations = helpers/* WINDOW.Sentry.Integrations */.m9.Sentry.Integrations;
}

const INTEGRATIONS = {
  ...windowIntegrations,
  ...integrations_namespaceObject,
  ...esm_integrations_namespaceObject,
};


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ../node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(55839);
var hoist_non_react_statics_cjs_default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics_cjs);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
;// CONCATENATED MODULE: ../node_modules/@sentry/react/esm/constants.js
const REACT_RENDER_OP = 'ui.react.render';

const REACT_UPDATE_OP = 'ui.react.update';

const REACT_MOUNT_OP = 'ui.react.mount';


//# sourceMappingURL=constants.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/react/esm/profiler.js






const _jsxFileName = "/home/runner/work/sentry-javascript/sentry-javascript/packages/react/src/profiler.tsx";

const UNKNOWN_COMPONENT = 'unknown';

/**
 * The Profiler component leverages Sentry's Tracing integration to generate
 * spans based on component lifecycles.
 */
class Profiler extends react.Component {
  /**
   * The span of the mount activity
   * Made protected for the React Native SDK to access
   */
   __init() {this._mountSpan = undefined;}
  /**
   * The span that represents the duration of time between shouldComponentUpdate and componentDidUpdate
   */
   __init2() {this._updateSpan = undefined;}

  // eslint-disable-next-line @typescript-eslint/member-ordering
   static __initStatic() {this.defaultProps = {
    disabled: false,
    includeRender: true,
    includeUpdates: true,
  };}

   constructor(props) {
    super(props);Profiler.prototype.__init.call(this);Profiler.prototype.__init2.call(this);    const { name, disabled = false } = this.props;

    if (disabled) {
      return;
    }

    const activeTransaction = profiler_getActiveTransaction();
    if (activeTransaction) {
      this._mountSpan = activeTransaction.startChild({
        description: `<${name}>`,
        op: REACT_MOUNT_OP,
      });
    }
  }

  // If a component mounted, we can finish the mount activity.
   componentDidMount() {
    if (this._mountSpan) {
      this._mountSpan.finish();
    }
  }

   shouldComponentUpdate({ updateProps, includeUpdates = true }) {
    // Only generate an update span if includeUpdates is true, if there is a valid mountSpan,
    // and if the updateProps have changed. It is ok to not do a deep equality check here as it is expensive.
    // We are just trying to give baseline clues for further investigation.
    if (includeUpdates && this._mountSpan && updateProps !== this.props.updateProps) {
      // See what props haved changed between the previous props, and the current props. This is
      // set as data on the span. We just store the prop keys as the values could be potenially very large.
      const changedProps = Object.keys(updateProps).filter(k => updateProps[k] !== this.props.updateProps[k]);
      if (changedProps.length > 0) {
        const now = (0,esm_time/* timestampInSeconds */.ph)();
        this._updateSpan = this._mountSpan.startChild({
          data: {
            changedProps,
          },
          description: `<${this.props.name}>`,
          op: REACT_UPDATE_OP,
          startTimestamp: now,
        });
      }
    }

    return true;
  }

   componentDidUpdate() {
    if (this._updateSpan) {
      this._updateSpan.finish();
      this._updateSpan = undefined;
    }
  }

  // If a component is unmounted, we can say it is no longer on the screen.
  // This means we can finish the span representing the component render.
   componentWillUnmount() {
    const { name, includeRender = true } = this.props;

    if (this._mountSpan && includeRender) {
      // If we were able to obtain the spanId of the mount activity, we should set the
      // next activity as a child to the component mount activity.
      this._mountSpan.startChild({
        description: `<${name}>`,
        endTimestamp: (0,esm_time/* timestampInSeconds */.ph)(),
        op: REACT_RENDER_OP,
        startTimestamp: this._mountSpan.endTimestamp,
      });
    }
  }

   render() {
    return this.props.children;
  }
} Profiler.__initStatic();

/**
 * withProfiler is a higher order component that wraps a
 * component in a {@link Profiler} component. It is recommended that
 * the higher order component be used over the regular {@link Profiler} component.
 *
 * @param WrappedComponent component that is wrapped by Profiler
 * @param options the {@link ProfilerProps} you can pass into the Profiler
 */
function withProfiler(
  WrappedComponent,
  // We do not want to have `updateProps` given in options, it is instead filled through the HOC.
  options,
) {
  const componentDisplayName =
    (options && options.name) || WrappedComponent.displayName || WrappedComponent.name || UNKNOWN_COMPONENT;

  const Wrapped = (props) => (
    react.createElement(Profiler, { ...options, name: componentDisplayName, updateProps: props, __self: this, __source: {fileName: _jsxFileName, lineNumber: 146}}
      , react.createElement(WrappedComponent, { ...props, __self: this, __source: {fileName: _jsxFileName, lineNumber: 147}} )
    )
  );

  Wrapped.displayName = `profiler(${componentDisplayName})`;

  // Copy over static methods from Wrapped component to Profiler HOC
  // See: https://reactjs.org/docs/higher-order-components.html#static-methods-must-be-copied-over
  hoist_non_react_statics_cjs_default()(Wrapped, WrappedComponent);
  return Wrapped;
}

/**
 *
 * `useProfiler` is a React hook that profiles a React component.
 *
 * Requires React 16.8 or above.
 * @param name displayName of component being profiled
 */
function useProfiler(
  name,
  options = {
    disabled: false,
    hasRenderSpan: true,
  },
) {
  const [mountSpan] = react.useState(() => {
    if (options && options.disabled) {
      return undefined;
    }

    const activeTransaction = profiler_getActiveTransaction();
    if (activeTransaction) {
      return activeTransaction.startChild({
        description: `<${name}>`,
        op: REACT_MOUNT_OP,
      });
    }

    return undefined;
  });

  react.useEffect(() => {
    if (mountSpan) {
      mountSpan.finish();
    }

    return () => {
      if (mountSpan && options.hasRenderSpan) {
        mountSpan.startChild({
          description: `<${name}>`,
          endTimestamp: (0,esm_time/* timestampInSeconds */.ph)(),
          op: REACT_RENDER_OP,
          startTimestamp: mountSpan.endTimestamp,
        });
      }
    };
    // We only want this to run once.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}

/** Grabs active transaction off scope */
function profiler_getActiveTransaction(hub = (0,esm_hub/* getCurrentHub */.Gd)()) {
  if (hub) {
    const scope = hub.getScope();
    if (scope) {
      return scope.getTransaction() ;
    }
  }

  return undefined;
}


//# sourceMappingURL=profiler.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/react/esm/errorboundary.js





const errorboundary_jsxFileName = "/home/runner/work/sentry-javascript/sentry-javascript/packages/react/src/errorboundary.tsx";

function isAtLeastReact17(version) {
  const major = version.match(/^([^.]+)/);
  return major !== null && parseInt(major[0]) >= 17;
}

const errorboundary_UNKNOWN_COMPONENT = 'unknown';

const INITIAL_STATE = {
  componentStack: null,
  error: null,
  eventId: null,
};

function setCause(error, cause) {
  const seenErrors = new WeakMap();

  function recurse(error, cause) {
    // If we've already seen the error, there is a recursive loop somewhere in the error's
    // cause chain. Let's just bail out then to prevent a stack overflow.
    if (seenErrors.has(error)) {
      return;
    }
    if (error.cause) {
      seenErrors.set(error, true);
      return recurse(error.cause, cause);
    }
    error.cause = cause;
  }

  recurse(error, cause);
}

/**
 * A ErrorBoundary component that logs errors to Sentry. Requires React >= 16.
 * NOTE: If you are a Sentry user, and you are seeing this stack frame, it means the
 * Sentry React SDK ErrorBoundary caught an error invoking your application code. This
 * is expected behavior and NOT indicative of a bug with the Sentry React SDK.
 */
class ErrorBoundary extends react.Component {
   __init() {this.state = INITIAL_STATE;}

    __init2() {this._openFallbackReportDialog = true;}

   constructor(props) {
    super(props);ErrorBoundary.prototype.__init.call(this);ErrorBoundary.prototype.__init2.call(this);ErrorBoundary.prototype.__init3.call(this);
    const client = (0,esm_hub/* getCurrentHub */.Gd)().getClient();
    if (client && client.on && props.showDialog) {
      this._openFallbackReportDialog = false;
      client.on('afterSendEvent', event => {
        if (!event.type && event.event_id === this._lastEventId) {
          (0,sdk/* showReportDialog */.jp)({ ...props.dialogOptions, eventId: this._lastEventId });
        }
      });
    }
  }

   componentDidCatch(error, { componentStack }) {
    const { beforeCapture, onError, showDialog, dialogOptions } = this.props;
    (0,esm_exports/* withScope */.$e)(scope => {
      // If on React version >= 17, create stack trace from componentStack param and links
      // to to the original error using `error.cause` otherwise relies on error param for stacktrace.
      // Linking errors requires the `LinkedErrors` integration be enabled.
      // See: https://reactjs.org/blog/2020/08/10/react-v17-rc.html#native-component-stacks
      //
      // Although `componentDidCatch` is typed to accept an `Error` object, it can also be invoked
      // with non-error objects. This is why we need to check if the error is an error-like object.
      // See: https://github.com/getsentry/sentry-javascript/issues/6167
      if (isAtLeastReact17(react.version) && (0,is/* isError */.VZ)(error)) {
        const errorBoundaryError = new Error(error.message);
        errorBoundaryError.name = `React ErrorBoundary ${errorBoundaryError.name}`;
        errorBoundaryError.stack = componentStack;

        // Using the `LinkedErrors` integration to link the errors together.
        setCause(error, errorBoundaryError);
      }

      if (beforeCapture) {
        beforeCapture(scope, error, componentStack);
      }
      const eventId = (0,esm_exports/* captureException */.Tb)(error, { contexts: { react: { componentStack } } });
      if (onError) {
        onError(error, componentStack, eventId);
      }
      if (showDialog) {
        this._lastEventId = eventId;
        if (this._openFallbackReportDialog) {
          (0,sdk/* showReportDialog */.jp)({ ...dialogOptions, eventId });
        }
      }

      // componentDidCatch is used over getDerivedStateFromError
      // so that componentStack is accessible through state.
      this.setState({ error, componentStack, eventId });
    });
  }

   componentDidMount() {
    const { onMount } = this.props;
    if (onMount) {
      onMount();
    }
  }

   componentWillUnmount() {
    const { error, componentStack, eventId } = this.state;
    const { onUnmount } = this.props;
    if (onUnmount) {
      onUnmount(error, componentStack, eventId);
    }
  }

   __init3() {this.resetErrorBoundary = () => {
    const { onReset } = this.props;
    const { error, componentStack, eventId } = this.state;
    if (onReset) {
      onReset(error, componentStack, eventId);
    }
    this.setState(INITIAL_STATE);
  };}

   render() {
    const { fallback, children } = this.props;
    const state = this.state;

    if (state.error) {
      let element = undefined;
      if (typeof fallback === 'function') {
        element = fallback({
          error: state.error,
          componentStack: state.componentStack,
          resetError: this.resetErrorBoundary,
          eventId: state.eventId,
        });
      } else {
        element = fallback;
      }

      if (react.isValidElement(element)) {
        return element;
      }

      if (fallback) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.warn */.kg.warn('fallback did not produce a valid ReactElement');
      }

      // Fail gracefully if no fallback provided or is not valid
      return null;
    }

    if (typeof children === 'function') {
      return (children )();
    }
    return children;
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function withErrorBoundary(
  WrappedComponent,
  errorBoundaryOptions,
) {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  const componentDisplayName = WrappedComponent.displayName || WrappedComponent.name || errorboundary_UNKNOWN_COMPONENT;

  const Wrapped = (props) => (
    react.createElement(ErrorBoundary, { ...errorBoundaryOptions, __self: this, __source: {fileName: errorboundary_jsxFileName, lineNumber: 224}}
      , react.createElement(WrappedComponent, { ...props, __self: this, __source: {fileName: errorboundary_jsxFileName, lineNumber: 225}} )
    )
  );

  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  Wrapped.displayName = `errorBoundary(${componentDisplayName})`;

  // Copy over static methods from Wrapped component to Profiler HOC
  // See: https://reactjs.org/docs/higher-order-components.html#static-methods-must-be-copied-over
  hoist_non_react_statics_cjs_default()(Wrapped, WrappedComponent);
  return Wrapped;
}


//# sourceMappingURL=errorboundary.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/react/esm/redux.js



/* eslint-disable @typescript-eslint/no-explicit-any */

const ACTION_BREADCRUMB_CATEGORY = 'redux.action';
const ACTION_BREADCRUMB_TYPE = 'info';

const defaultOptions = {
  actionTransformer: action => action,
  stateTransformer: state => state || null,
};

/**
 * Creates an enhancer that would be passed to Redux's createStore to log actions and the latest state to Sentry.
 *
 * @param enhancerOptions Options to pass to the enhancer
 */
function createReduxEnhancer(enhancerOptions) {
  // Note: We return an any type as to not have type conflicts.
  const options = {
    ...defaultOptions,
    ...enhancerOptions,
  };

  return (next) =>
    (reducer, initialState) => {
      const sentryReducer = (state, action) => {
        const newState = reducer(state, action);

        (0,esm_exports/* configureScope */.e)(scope => {
          /* Action breadcrumbs */
          const transformedAction = options.actionTransformer(action);
          if (typeof transformedAction !== 'undefined' && transformedAction !== null) {
            scope.addBreadcrumb({
              category: ACTION_BREADCRUMB_CATEGORY,
              data: transformedAction,
              type: ACTION_BREADCRUMB_TYPE,
            });
          }

          /* Set latest state to scope */
          const transformedState = options.stateTransformer(newState);
          if (typeof transformedState !== 'undefined' && transformedState !== null) {
            const client = (0,esm_hub/* getCurrentHub */.Gd)().getClient();
            const options = client && client.getOptions();
            const normalizationDepth = (options && options.normalizeDepth) || 3; // default state normalization depth to 3

            // Set the normalization depth of the redux state to the configured `normalizeDepth` option or a sane number as a fallback
            const newStateContext = { state: { type: 'redux', value: transformedState } };
            (0,object/* addNonEnumerableProperty */.xp)(
              newStateContext,
              '__sentry_override_normalization_depth__',
              3 + // 3 layers for `state.value.transformedState`
                normalizationDepth, // rest for the actual state
            );

            scope.setContext('state', newStateContext);
          } else {
            scope.setContext('state', null);
          }

          /* Allow user to configure scope with latest state */
          const { configureScopeWithState } = options;
          if (typeof configureScopeWithState === 'function') {
            configureScopeWithState(scope, newState);
          }
        });

        return newState;
      };

      return next(sentryReducer, initialState);
    };
}


//# sourceMappingURL=redux.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/react/esm/reactrouterv3.js


// Many of the types below had to be mocked out to prevent typescript issues
// these types are required for correct functionality.

/**
 * Creates routing instrumentation for React Router v3
 * Works for React Router >= 3.2.0 and < 4.0.0
 *
 * @param history object from the `history` library
 * @param routes a list of all routes, should be
 * @param match `Router.match` utility
 */
function reactRouterV3Instrumentation(
  history,
  routes,
  match,
) {
  return (
    startTransaction,
    startTransactionOnPageLoad = true,
    startTransactionOnLocationChange = true,
  ) => {
    let activeTransaction;
    let prevName;

    // Have to use window.location because history.location might not be defined.
    if (startTransactionOnPageLoad && helpers/* WINDOW */.m9 && helpers/* WINDOW.location */.m9.location) {
      normalizeTransactionName(
        routes,
        helpers/* WINDOW.location */.m9.location ,
        match,
        (localName, source = 'url') => {
          prevName = localName;
          activeTransaction = startTransaction({
            name: prevName,
            op: 'pageload',
            tags: {
              'routing.instrumentation': 'react-router-v3',
            },
            metadata: {
              source,
            },
          });
        },
      );
    }

    if (startTransactionOnLocationChange && history.listen) {
      history.listen(location => {
        if (location.action === 'PUSH' || location.action === 'POP') {
          if (activeTransaction) {
            activeTransaction.finish();
          }
          const tags = {
            'routing.instrumentation': 'react-router-v3',
          };
          if (prevName) {
            tags.from = prevName;
          }
          normalizeTransactionName(routes, location, match, (localName, source = 'url') => {
            prevName = localName;
            activeTransaction = startTransaction({
              name: prevName,
              op: 'navigation',
              tags,
              metadata: {
                source,
              },
            });
          });
        }
      });
    }
  };
}

/**
 * Normalize transaction names using `Router.match`
 */
function normalizeTransactionName(
  appRoutes,
  location,
  match,
  callback,
) {
  let name = location.pathname;
  match(
    {
      location,
      routes: appRoutes,
    },
    (error, _redirectLocation, renderProps) => {
      if (error || !renderProps) {
        return callback(name);
      }

      const routePath = getRouteStringFromRoutes(renderProps.routes || []);
      if (routePath.length === 0 || routePath === '/*') {
        return callback(name);
      }

      name = routePath;
      return callback(name, 'route');
    },
  );
}

/**
 * Generate route name from array of routes
 */
function getRouteStringFromRoutes(routes) {
  if (!Array.isArray(routes) || routes.length === 0) {
    return '';
  }

  const routesWithPaths = routes.filter((route) => !!route.path);

  let index = -1;
  for (let x = routesWithPaths.length - 1; x >= 0; x--) {
    const route = routesWithPaths[x];
    if (route.path && route.path.startsWith('/')) {
      index = x;
      break;
    }
  }

  return routesWithPaths
    .slice(index)
    .filter(({ path }) => !!path)
    .map(({ path }) => path)
    .join('');
}


//# sourceMappingURL=reactrouterv3.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/react/esm/reactrouter.js




const reactrouter_jsxFileName = "/home/runner/work/sentry-javascript/sentry-javascript/packages/react/src/reactrouter.tsx";
// We need to disable eslint no-explict-any because any is required for the
// react-router typings.
/* eslint-disable @typescript-eslint/no-explicit-any */

/* eslint-enable @typescript-eslint/no-explicit-any */

let activeTransaction;

function reactRouterV4Instrumentation(
  history,
  routes,
  matchPath,
) {
  return createReactRouterInstrumentation(history, 'react-router-v4', routes, matchPath);
}

function reactRouterV5Instrumentation(
  history,
  routes,
  matchPath,
) {
  return createReactRouterInstrumentation(history, 'react-router-v5', routes, matchPath);
}

function createReactRouterInstrumentation(
  history,
  name,
  allRoutes = [],
  matchPath,
) {
  function getInitPathName() {
    if (history && history.location) {
      return history.location.pathname;
    }

    if (helpers/* WINDOW */.m9 && helpers/* WINDOW.location */.m9.location) {
      return helpers/* WINDOW.location.pathname */.m9.location.pathname;
    }

    return undefined;
  }

  /**
   * Normalizes a transaction name. Returns the new name as well as the
   * source of the transaction.
   *
   * @param pathname The initial pathname we normalize
   */
  function normalizeTransactionName(pathname) {
    if (allRoutes.length === 0 || !matchPath) {
      return [pathname, 'url'];
    }

    const branches = matchRoutes(allRoutes, pathname, matchPath);
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for (let x = 0; x < branches.length; x++) {
      if (branches[x].match.isExact) {
        return [branches[x].match.path, 'route'];
      }
    }

    return [pathname, 'url'];
  }

  const tags = {
    'routing.instrumentation': name,
  };

  return (customStartTransaction, startTransactionOnPageLoad = true, startTransactionOnLocationChange = true) => {
    const initPathName = getInitPathName();
    if (startTransactionOnPageLoad && initPathName) {
      const [name, source] = normalizeTransactionName(initPathName);
      activeTransaction = customStartTransaction({
        name,
        op: 'pageload',
        tags,
        metadata: {
          source,
        },
      });
    }

    if (startTransactionOnLocationChange && history.listen) {
      history.listen((location, action) => {
        if (action && (action === 'PUSH' || action === 'POP')) {
          if (activeTransaction) {
            activeTransaction.finish();
          }

          const [name, source] = normalizeTransactionName(location.pathname);
          activeTransaction = customStartTransaction({
            name,
            op: 'navigation',
            tags,
            metadata: {
              source,
            },
          });
        }
      });
    }
  };
}

/**
 * Matches a set of routes to a pathname
 * Based on implementation from
 */
function matchRoutes(
  routes,
  pathname,
  matchPath,
  branch = [],
) {
  routes.some(route => {
    const match = route.path
      ? matchPath(pathname, route)
      : branch.length
      ? branch[branch.length - 1].match // use parent match
      : computeRootMatch(pathname); // use default "root" match

    if (match) {
      branch.push({ route, match });

      if (route.routes) {
        matchRoutes(route.routes, pathname, matchPath, branch);
      }
    }

    return !!match;
  });

  return branch;
}

function computeRootMatch(pathname) {
  return { path: '/', url: '/', params: {}, isExact: pathname === '/' };
}

/* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access */
function withSentryRouting(Route) {
  const componentDisplayName = (Route ).displayName || (Route ).name;

  const WrappedRoute = (props) => {
    if (activeTransaction && props && props.computedMatch && props.computedMatch.isExact) {
      activeTransaction.setName(props.computedMatch.path, 'route');
    }

    // @ts-ignore Setting more specific React Component typing for `R` generic above
    // will break advanced type inference done by react router params:
    // https://github.com/DefinitelyTyped/DefinitelyTyped/blob/13dc4235c069e25fe7ee16e11f529d909f9f3ff8/types/react-router/index.d.ts#L154-L164
    return react.createElement(Route, { ...props, __self: this, __source: {fileName: reactrouter_jsxFileName, lineNumber: 174}} );
  };

  WrappedRoute.displayName = `sentryRoute(${componentDisplayName})`;
  hoist_non_react_statics_cjs_default()(WrappedRoute, Route);
  // @ts-ignore Setting more specific React Component typing for `R` generic above
  // will break advanced type inference done by react router params:
  // https://github.com/DefinitelyTyped/DefinitelyTyped/blob/13dc4235c069e25fe7ee16e11f529d909f9f3ff8/types/react-router/index.d.ts#L154-L164
  return WrappedRoute;
}
/* eslint-enable @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access */


//# sourceMappingURL=reactrouter.js.map

// EXTERNAL MODULE: ../node_modules/@sentry/utils/esm/url.js
var url = __webpack_require__(94678);
;// CONCATENATED MODULE: ../node_modules/@sentry/react/esm/reactrouterv6.js





const reactrouterv6_jsxFileName = "/home/runner/work/sentry-javascript/sentry-javascript/packages/react/src/reactrouterv6.tsx";// Inspired from Donnie McNeal's solution:

let reactrouterv6_activeTransaction;

let _useEffect;
let _useLocation;
let _useNavigationType;
let _createRoutesFromChildren;
let _matchRoutes;
let _customStartTransaction;
let _startTransactionOnLocationChange;

const SENTRY_TAGS = {
  'routing.instrumentation': 'react-router-v6',
};

function reactRouterV6Instrumentation(
  useEffect,
  useLocation,
  useNavigationType,
  createRoutesFromChildren,
  matchRoutes,
) {
  return (
    customStartTransaction,
    startTransactionOnPageLoad = true,
    startTransactionOnLocationChange = true,
  ) => {
    const initPathName = helpers/* WINDOW */.m9 && helpers/* WINDOW.location */.m9.location && helpers/* WINDOW.location.pathname */.m9.location.pathname;
    if (startTransactionOnPageLoad && initPathName) {
      reactrouterv6_activeTransaction = customStartTransaction({
        name: initPathName,
        op: 'pageload',
        tags: SENTRY_TAGS,
        metadata: {
          source: 'url',
        },
      });
    }

    _useEffect = useEffect;
    _useLocation = useLocation;
    _useNavigationType = useNavigationType;
    _matchRoutes = matchRoutes;
    _createRoutesFromChildren = createRoutesFromChildren;

    _customStartTransaction = customStartTransaction;
    _startTransactionOnLocationChange = startTransactionOnLocationChange;
  };
}

function getNormalizedName(
  routes,
  location,
  branches,
) {
  if (!routes || routes.length === 0) {
    return [location.pathname, 'url'];
  }

  let pathBuilder = '';
  if (branches) {
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for (let x = 0; x < branches.length; x++) {
      const branch = branches[x];
      const route = branch.route;
      if (route) {
        // Early return if index route
        if (route.index) {
          return [branch.pathname, 'route'];
        }

        const path = route.path;
        if (path) {
          const newPath = path[0] === '/' || pathBuilder[pathBuilder.length - 1] === '/' ? path : `/${path}`;
          pathBuilder += newPath;
          if (branch.pathname === location.pathname) {
            if (
              // If the route defined on the element is something like
              // <Route path="/stores/:storeId/products/:productId" element={<div>Product</div>} />
              // We should check against the branch.pathname for the number of / seperators
              (0,url/* getNumberOfUrlSegments */.$A)(pathBuilder) !== (0,url/* getNumberOfUrlSegments */.$A)(branch.pathname) &&
              // We should not count wildcard operators in the url segments calculation
              pathBuilder.slice(-2) !== '/*'
            ) {
              return [newPath, 'route'];
            }
            return [pathBuilder, 'route'];
          }
        }
      }
    }
  }

  return [location.pathname, 'url'];
}

function updatePageloadTransaction(location, routes, matches) {
  const branches = Array.isArray(matches) ? matches : (_matchRoutes(routes, location) );

  if (reactrouterv6_activeTransaction && branches) {
    reactrouterv6_activeTransaction.setName(...getNormalizedName(routes, location, branches));
  }
}

function handleNavigation(
  location,
  routes,
  navigationType,
  matches,
) {
  const branches = Array.isArray(matches) ? matches : _matchRoutes(routes, location);

  if (_startTransactionOnLocationChange && (navigationType === 'PUSH' || navigationType === 'POP') && branches) {
    if (reactrouterv6_activeTransaction) {
      reactrouterv6_activeTransaction.finish();
    }

    const [name, source] = getNormalizedName(routes, location, branches);
    reactrouterv6_activeTransaction = _customStartTransaction({
      name,
      op: 'navigation',
      tags: SENTRY_TAGS,
      metadata: {
        source,
      },
    });
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function withSentryReactRouterV6Routing(Routes) {
  if (
    !_useEffect ||
    !_useLocation ||
    !_useNavigationType ||
    !_createRoutesFromChildren ||
    !_matchRoutes ||
    !_customStartTransaction
  ) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      logger/* logger.warn */.kg.warn(`reactRouterV6Instrumentation was unable to wrap Routes because of one or more missing parameters.
      useEffect: ${_useEffect}. useLocation: ${_useLocation}. useNavigationType: ${_useNavigationType}.
      createRoutesFromChildren: ${_createRoutesFromChildren}. matchRoutes: ${_matchRoutes}. customStartTransaction: ${_customStartTransaction}.`);

    return Routes;
  }

  let isMountRenderPass = true;

  const SentryRoutes = (props) => {
    const location = _useLocation();
    const navigationType = _useNavigationType();

    _useEffect(
      () => {
        const routes = _createRoutesFromChildren(props.children) ;

        if (isMountRenderPass) {
          updatePageloadTransaction(location, routes);
          isMountRenderPass = false;
        } else {
          handleNavigation(location, routes, navigationType);
        }
      },
      // `props.children` is purpusely not included in the dependency array, because we do not want to re-run this effect
      // when the children change. We only want to start transactions when the location or navigation type change.
      [location, navigationType],
    );

    // @ts-ignore Setting more specific React Component typing for `R` generic above
    // will break advanced type inference done by react router params
    return react.createElement(Routes, { ...props, __self: this, __source: {fileName: reactrouterv6_jsxFileName, lineNumber: 197}} );
  };

  hoist_non_react_statics_cjs_default()(SentryRoutes, Routes);

  // @ts-ignore Setting more specific React Component typing for `R` generic above
  // will break advanced type inference done by react router params
  return SentryRoutes;
}

function wrapUseRoutes(origUseRoutes) {
  if (!_useEffect || !_useLocation || !_useNavigationType || !_matchRoutes || !_customStartTransaction) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      logger/* logger.warn */.kg.warn(
        'reactRouterV6Instrumentation was unable to wrap `useRoutes` because of one or more missing parameters.',
      );

    return origUseRoutes;
  }

  let isMountRenderPass = true;

  // eslint-disable-next-line react/display-name
  return (routes, locationArg) => {
    const SentryRoutes = () => {
      const Routes = origUseRoutes(routes, locationArg);

      const location = _useLocation();
      const navigationType = _useNavigationType();

      // A value with stable identity to either pick `locationArg` if available or `location` if not
      const stableLocationParam =
        typeof locationArg === 'string' || (locationArg && locationArg.pathname)
          ? (locationArg )
          : location;

      _useEffect(() => {
        const normalizedLocation =
          typeof stableLocationParam === 'string' ? { pathname: stableLocationParam } : stableLocationParam;

        if (isMountRenderPass) {
          updatePageloadTransaction(normalizedLocation, routes);
          isMountRenderPass = false;
        } else {
          handleNavigation(normalizedLocation, routes, navigationType);
        }
      }, [navigationType, stableLocationParam]);

      return Routes;
    };

    return react.createElement(SentryRoutes, {__self: this, __source: {fileName: reactrouterv6_jsxFileName, lineNumber: 248}} );
  };
}

function wrapCreateBrowserRouter

(createRouterFunction) {
  // `opts` for createBrowserHistory and createMemoryHistory are different, but also not relevant for us at the moment.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return function (routes, opts) {
    const router = createRouterFunction(routes, opts);

    // The initial load ends when `createBrowserRouter` is called.
    // This is the earliest convenient time to update the transaction name.
    // Callbacks to `router.subscribe` are not called for the initial load.
    if (router.state.historyAction === 'POP' && reactrouterv6_activeTransaction) {
      updatePageloadTransaction(router.state.location, routes);
    }

    router.subscribe((state) => {
      const location = state.location;

      if (
        _startTransactionOnLocationChange &&
        (state.historyAction === 'PUSH' || state.historyAction === 'POP') &&
        reactrouterv6_activeTransaction
      ) {
        handleNavigation(location, routes, state.historyAction);
      }
    });

    return router;
  };
}


//# sourceMappingURL=reactrouterv6.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/react/esm/index.js








//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/utils/esm/userIntegrations.js
/**
 * Recursively traverses an object to update an existing nested key.
 * Note: The provided key path must include existing properties,
 * the function will not create objects while traversing.
 *
 * @param obj An object to update
 * @param value The value to update the nested key with
 * @param keyPath The path to the key to update ex. fizz.buzz.foo
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function setNestedKey(obj, keyPath, value) {
  // Ex. foo.bar.zoop will extract foo and bar.zoop
  const match = keyPath.match(/([a-z_]+)\.(.*)/i);
  // The match will be null when there's no more recursing to do, i.e., when we've reached the right level of the object
  if (match === null) {
    obj[keyPath] = value;
  } else {
    // `match[1]` is the initial segment of the path, and `match[2]` is the remainder of the path
    const innerObj = obj[match[1]];
    setNestedKey(innerObj, match[2], value);
  }
}

/**
 * Enforces inclusion of a given integration with specified options in an integration array originally determined by the
 * user, by either including the given default instance or by patching an existing user instance with the given options.
 *
 * Ideally this would happen when integrations are set up, but there isn't currently a mechanism there for merging
 * options from a default integration instance with those from a user-provided instance of the same integration, only
 * for allowing the user to override a default instance entirely. (TODO: Fix that.)
 *
 * @param defaultIntegrationInstance An instance of the integration with the correct options already set
 * @param userIntegrations Integrations defined by the user.
 * @param forcedOptions Options with which to patch an existing user-derived instance on the integration.
 * @returns A final integrations array.
 */
function addOrUpdateIntegration(
  defaultIntegrationInstance,
  userIntegrations,
  forcedOptions = {},
) {
  return (
    Array.isArray(userIntegrations)
      ? addOrUpdateIntegrationInArray(defaultIntegrationInstance, userIntegrations, forcedOptions)
      : addOrUpdateIntegrationInFunction(
          defaultIntegrationInstance,
          // Somehow TS can't figure out that not being an array makes this necessarily a function
          userIntegrations ,
          forcedOptions,
        )
  ) ;
}

function addOrUpdateIntegrationInArray(
  defaultIntegrationInstance,
  userIntegrations,
  forcedOptions,
) {
  const userInstance = userIntegrations.find(integration => integration.name === defaultIntegrationInstance.name);

  if (userInstance) {
    for (const [keyPath, value] of Object.entries(forcedOptions)) {
      setNestedKey(userInstance, keyPath, value);
    }

    return userIntegrations;
  }

  return [...userIntegrations, defaultIntegrationInstance];
}

function addOrUpdateIntegrationInFunction(
  defaultIntegrationInstance,
  userIntegrationsFunc,
  forcedOptions,
) {
  const wrapper = defaultIntegrations => {
    const userFinalIntegrations = userIntegrationsFunc(defaultIntegrations);

    // There are instances where we want the user to be able to prevent an integration from appearing at all, which they
    // would do by providing a function which filters out the integration in question. If that's happened in one of
    // those cases, don't add our default back in.
    if (defaultIntegrationInstance.allowExclusionByUser) {
      const userFinalInstance = userFinalIntegrations.find(
        integration => integration.name === defaultIntegrationInstance.name,
      );
      if (!userFinalInstance) {
        return userFinalIntegrations;
      }
    }

    return addOrUpdateIntegrationInArray(defaultIntegrationInstance, userFinalIntegrations, forcedOptions);
  };

  return wrapper;
}


//# sourceMappingURL=userIntegrations.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/nextjs/esm/common/getVercelEnv.js
/* provided dependency */ var getVercelEnv_process = __webpack_require__(27061);
/**
 * Returns an environment setting value determined by Vercel's `VERCEL_ENV` environment variable.
 *
 * @param isClient Flag to indicate whether to use the `NEXT_PUBLIC_` prefixed version of the environment variable.
 */
function getVercelEnv(isClient) {
  const vercelEnvVar = isClient ? getVercelEnv_process.env.NEXT_PUBLIC_VERCEL_ENV : getVercelEnv_process.env.VERCEL_ENV;
  return vercelEnvVar ? `vercel-${vercelEnvVar}` : undefined;
}


//# sourceMappingURL=getVercelEnv.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/nextjs/esm/common/metadata.js


const PACKAGE_NAME_PREFIX = 'npm:@sentry/';

/**
 * A builder for the SDK metadata in the options for the SDK initialization.
 * @param options sdk options object that gets mutated
 * @param names list of package names
 */
function buildMetadata(options, names) {
  options._metadata = options._metadata || {};
  options._metadata.sdk =
    options._metadata.sdk ||
    ({
      name: 'sentry.javascript.nextjs',
      packages: names.map(name => ({
        name: `${PACKAGE_NAME_PREFIX}${name}`,
        version: version/* SDK_VERSION */.J,
      })),
      version: version/* SDK_VERSION */.J,
    } );
}


//# sourceMappingURL=metadata.js.map

// EXTERNAL MODULE: ../node_modules/next/router.js
var router = __webpack_require__(86677);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
;// CONCATENATED MODULE: ../node_modules/@sentry/nextjs/esm/client/performance.js





const globalObject = helpers/* WINDOW */.m9

;

/**
 * Every Next.js page (static and dynamic ones) comes with a script tag with the id "__NEXT_DATA__". This script tag
 * contains a JSON object with data that was either generated at build time for static pages (`getStaticProps`), or at
 * runtime with data fetchers like `getServerSideProps.`.
 *
 * We can use this information to:
 * - Always get the parameterized route we're in when loading a page.
 * - Send trace information (trace-id, baggage) from the server to the client.
 *
 * This function extracts this information.
 */
function extractNextDataTagInformation() {
  let nextData;
  // Let's be on the safe side and actually check first if there is really a __NEXT_DATA__ script tag on the page.
  // Theoretically this should always be the case though.
  const nextDataTag = globalObject.document.getElementById('__NEXT_DATA__');
  if (nextDataTag && nextDataTag.innerHTML) {
    try {
      nextData = JSON.parse(nextDataTag.innerHTML);
    } catch (e) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.warn */.kg.warn('Could not extract __NEXT_DATA__');
    }
  }

  if (!nextData) {
    return {};
  }

  const nextDataTagInfo = {};

  const { page, query, props } = nextData;

  // `nextData.page` always contains the parameterized route - except for when an error occurs in a data fetching
  // function, then it is "/_error", but that isn't a problem since users know which route threw by looking at the
  // parent transaction
  // TODO: Actually this is a problem (even though it is not that big), because the DSC and the transaction payload will contain
  // a different transaction name. Maybe we can fix this. Idea: Also send transaction name via pageProps when available.
  nextDataTagInfo.route = page;
  nextDataTagInfo.params = query;

  if (props && props.pageProps) {
    if (props.pageProps._sentryBaggage) {
      nextDataTagInfo.baggage = props.pageProps._sentryBaggage;
    }

    if (props.pageProps._sentryTraceData) {
      nextDataTagInfo.traceParentData = extractTraceparentData(props.pageProps._sentryTraceData);
    }
  }

  return nextDataTagInfo;
}

const DEFAULT_TAGS = {
  'routing.instrumentation': 'next-router',
} ;

// We keep track of the active transaction so we can finish it when we start a navigation transaction.
let performance_activeTransaction = undefined;

// We keep track of the previous location name so we can set the `from` field on navigation transactions.
// This is either a route or a pathname.
let prevLocationName = undefined;

const performance_client = (0,esm_hub/* getCurrentHub */.Gd)().getClient();

/**
 * Creates routing instrumention for Next Router. Only supported for
 * client side routing. Works for Next >= 10.
 *
 * Leverages the SingletonRouter from the `next/router` to
 * generate pageload/navigation transactions and parameterize
 * transaction names.
 */
function nextRouterInstrumentation(
  startTransactionCb,
  startTransactionOnPageLoad = true,
  startTransactionOnLocationChange = true,
) {
  const { route, traceParentData, baggage, params } = extractNextDataTagInformation();
  prevLocationName = route || globalObject.location.pathname;

  if (startTransactionOnPageLoad) {
    const source = route ? 'route' : 'url';
    const dynamicSamplingContext = baggageHeaderToDynamicSamplingContext(baggage);

    performance_activeTransaction = startTransactionCb({
      name: prevLocationName,
      op: 'pageload',
      tags: DEFAULT_TAGS,
      ...(params && performance_client && performance_client.getOptions().sendDefaultPii && { data: params }),
      ...traceParentData,
      metadata: {
        source,
        dynamicSamplingContext: traceParentData && !dynamicSamplingContext ? {} : dynamicSamplingContext,
      },
    });
  }

  if (startTransactionOnLocationChange) {
    router_default().events.on('routeChangeStart', (navigationTarget) => {
      const strippedNavigationTarget = (0,url/* stripUrlQueryAndFragment */.rt)(navigationTarget);
      const matchedRoute = getNextRouteFromPathname(strippedNavigationTarget);

      let transactionName;
      let transactionSource;

      if (matchedRoute) {
        transactionName = matchedRoute;
        transactionSource = 'route';
      } else {
        transactionName = strippedNavigationTarget;
        transactionSource = 'url';
      }

      const tags = {
        ...DEFAULT_TAGS,
        from: prevLocationName,
      };

      prevLocationName = transactionName;

      if (performance_activeTransaction) {
        performance_activeTransaction.finish();
      }

      const navigationTransaction = startTransactionCb({
        name: transactionName,
        op: 'navigation',
        tags,
        metadata: { source: transactionSource },
      });

      if (navigationTransaction) {
        // In addition to the navigation transaction we're also starting a span to mark Next.js's `routeChangeStart`
        // and `routeChangeComplete` events.
        // We don't want to finish the navigation transaction on `routeChangeComplete`, since users might want to attach
        // spans to that transaction even after `routeChangeComplete` is fired (eg. HTTP requests in some useEffect
        // hooks). Instead, we'll simply let the navigation transaction finish itself (it's an `IdleTransaction`).
        const nextRouteChangeSpan = navigationTransaction.startChild({
          op: 'ui.nextjs.route-change',
          description: 'Next.js Route Change',
        });

        const finishRouteChangeSpan = () => {
          nextRouteChangeSpan.finish();
          router_default().events.off('routeChangeComplete', finishRouteChangeSpan);
        };

        router_default().events.on('routeChangeComplete', finishRouteChangeSpan);
      }
    });
  }
}

function getNextRouteFromPathname(pathname) {
  const pageRoutes = (globalObject.__BUILD_MANIFEST || {}).sortedPages;

  // Page route should in 99.999% of the cases be defined by now but just to be sure we make a check here
  if (!pageRoutes) {
    return;
  }

  return pageRoutes.find(route => {
    const routeRegExp = convertNextRouteToRegExp(route);
    return pathname.match(routeRegExp);
  });
}

/**
 * Converts a Next.js style route to a regular expression that matches on pathnames (no query params or URL fragments).
 *
 * In general this involves replacing any instances of square brackets in a route with a wildcard:
 * e.g. "/users/[id]/info" becomes /\/users\/([^/]+?)\/info/
 *
 * Some additional edgecases need to be considered:
 * - All routes have an optional slash at the end, meaning users can navigate to "/users/[id]/info" or
 *   "/users/[id]/info/" - both will be resolved to "/users/[id]/info".
 * - Non-optional "catchall"s at the end of a route must be considered when matching (e.g. "/users/[...params]").
 * - Optional "catchall"s at the end of a route must be considered when matching (e.g. "/users/[[...params]]").
 *
 * @param route A Next.js style route as it is found in `global.__BUILD_MANIFEST.sortedPages`
 */
function convertNextRouteToRegExp(route) {
  // We can assume a route is at least "/".
  const routeParts = route.split('/');

  let optionalCatchallWildcardRegex = '';
  if (routeParts[routeParts.length - 1].match(/^\[\[\.\.\..+\]\]$/)) {
    // If last route part has pattern "[[...xyz]]" we pop the latest route part to get rid of the required trailing
    // slash that would come before it if we didn't pop it.
    routeParts.pop();
    optionalCatchallWildcardRegex = '(?:/(.+?))?';
  }

  const rejoinedRouteParts = routeParts
    .map(
      routePart =>
        routePart
          .replace(/^\[\.\.\..+\]$/, '(.+?)') // Replace catch all wildcard with regex wildcard
          .replace(/^\[.*\]$/, '([^/]+?)'), // Replace route wildcards with lazy regex wildcards
    )
    .join('/');

  return new RegExp(
    `^${rejoinedRouteParts}${optionalCatchallWildcardRegex}(?:/)?$`, // optional slash at the end
  );
}


//# sourceMappingURL=performance.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/nextjs/esm/client/tunnelRoute.js


const globalWithInjectedValues = __webpack_require__.g

;

/**
 * Applies the `tunnel` option to the Next.js SDK options based on `withSentryConfig`'s `tunnelRoute` option.
 */
function applyTunnelRouteOption(options) {
  const tunnelRouteOption = globalWithInjectedValues.__sentryRewritesTunnelPath__;
  if (tunnelRouteOption && options.dsn) {
    const dsnComponents = (0,esm_dsn/* dsnFromString */.U4)(options.dsn);
    if (!dsnComponents) {
      return;
    }
    const sentrySaasDsnMatch = dsnComponents.host.match(/^o(\d+)\.ingest\.sentry\.io$/);
    if (sentrySaasDsnMatch) {
      const orgId = sentrySaasDsnMatch[1];
      const tunnelPath = `${tunnelRouteOption}?o=${orgId}&p=${dsnComponents.projectId}`;
      options.tunnel = tunnelPath;
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.info */.kg.info(`Tunneling events to "${tunnelPath}"`);
    } else {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.warn */.kg.warn('Provided DSN is not a Sentry SaaS DSN. Will not tunnel events.');
    }
  }
}


//# sourceMappingURL=tunnelRoute.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/nextjs/esm/common/_error.js



/** Platform-agnostic version of `flush` */
function flush(timeout) {
  const client = (0,esm_hub/* getCurrentHub */.Gd)().getClient();
  return client ? client.flush(timeout) : Promise.resolve(false);
}

/**
 * Capture the exception passed by nextjs to the `_error` page, adding context data as appropriate.
 *
 * @param contextOrProps The data passed to either `getInitialProps` or `render` by nextjs
 */
async function captureUnderscoreErrorException(contextOrProps) {
  const { req, res, err } = contextOrProps;

  // 404s (and other 400-y friends) can trigger `_error`, but we don't want to send them to Sentry
  const statusCode = (res && res.statusCode) || contextOrProps.statusCode;
  if (statusCode && statusCode < 500) {
    return Promise.resolve();
  }

  // In previous versions of the suggested `_error.js` page in which this function is meant to be used, there was a
  // workaround for https://github.com/vercel/next.js/issues/8592 which involved an extra call to this function, in the
  // custom error component's `render` method, just in case it hadn't been called by `getInitialProps`. Now that that
  // issue has been fixed, the second call is unnecessary, but since it lives in user code rather than our code, users
  // have to be the ones to get rid of it, and guaraneteedly, not all of them will. So, rather than capture the error
  // twice, we just bail if we sense we're in that now-extraneous second call. (We can tell which function we're in
  // because Nextjs passes `pathname` to `getInitialProps` but not to `render`.)
  if (!contextOrProps.pathname) {
    return Promise.resolve();
  }

  (0,esm_exports/* withScope */.$e)(scope => {
    scope.addEventProcessor(event => {
      (0,misc/* addExceptionMechanism */.EG)(event, {
        type: 'instrument',
        handled: true,
        data: {
          function: '_error.getInitialProps',
        },
      });
      return event;
    });

    if (req) {
      scope.setSDKProcessingMetadata({ request: req });
    }

    // If third-party libraries (or users themselves) throw something falsy, we want to capture it as a message (which
    // is what passing a string to `captureException` will wind up doing)
    (0,esm_exports/* captureException */.Tb)(err || `_error.js called with falsy error (${err})`);
  });

  // In case this is being run as part of a serverless function (as is the case with the server half of nextjs apps
  // deployed to vercel), make sure the error gets sent to Sentry before the lambda exits.
  await flush(2000);
}


//# sourceMappingURL=_error.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/nextjs/esm/client/wrapGetInitialPropsWithSentry.js
/**
 * A passthrough function in case this function is used on the clientside. We need to make the returned function async
 * so we are consistent with the serverside implementation.
 */
function wrapGetInitialPropsWithSentry(origGetInitialProps) {
  return new Proxy(origGetInitialProps, {
    apply: async (wrappingTarget, thisArg, args) => {
      return await wrappingTarget.apply(thisArg, args);
    },
  });
}

/**
 * @deprecated Use `wrapGetInitialPropsWithSentry` instead.
 */
const withSentryServerSideGetInitialProps = wrapGetInitialPropsWithSentry;


//# sourceMappingURL=wrapGetInitialPropsWithSentry.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/nextjs/esm/client/wrapAppGetInitialPropsWithSentry.js
/**
 * A passthrough function in case this function is used on the clientside. We need to make the returned function async
 * so we are consistent with the serverside implementation.
 */
function wrapAppGetInitialPropsWithSentry(origAppGetInitialProps) {
  return new Proxy(origAppGetInitialProps, {
    apply: async (wrappingTarget, thisArg, args) => {
      return await wrappingTarget.apply(thisArg, args);
    },
  });
}

/**
 * @deprecated Use `wrapAppGetInitialPropsWithSentry` instead.
 */
const withSentryServerSideAppGetInitialProps = wrapAppGetInitialPropsWithSentry;


//# sourceMappingURL=wrapAppGetInitialPropsWithSentry.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/nextjs/esm/client/wrapDocumentGetInitialPropsWithSentry.js
/**
 * A passthrough function in case this function is used on the clientside. We need to make the returned function async
 * so we are consistent with the serverside implementation.
 */
function wrapDocumentGetInitialPropsWithSentry(
  origDocumentGetInitialProps,
) {
  return new Proxy(origDocumentGetInitialProps, {
    apply: async (wrappingTarget, thisArg, args) => {
      return await wrappingTarget.apply(thisArg, args);
    },
  });
}

/**
 * @deprecated Use `wrapDocumentGetInitialPropsWithSentry` instead.
 */
const withSentryServerSideDocumentGetInitialProps = wrapDocumentGetInitialPropsWithSentry;


//# sourceMappingURL=wrapDocumentGetInitialPropsWithSentry.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/nextjs/esm/client/wrapErrorGetInitialPropsWithSentry.js
/**
 * A passthrough function in case this function is used on the clientside. We need to make the returned function async
 * so we are consistent with the serverside implementation.
 */
function wrapErrorGetInitialPropsWithSentry(
  origErrorGetInitialProps,
) {
  return new Proxy(origErrorGetInitialProps, {
    apply: async (wrappingTarget, thisArg, args) => {
      return await wrappingTarget.apply(thisArg, args);
    },
  });
}

/**
 * @deprecated Use `wrapErrorGetInitialPropsWithSentry` instead.
 */
const withSentryServerSideErrorGetInitialProps = wrapErrorGetInitialPropsWithSentry;


//# sourceMappingURL=wrapErrorGetInitialPropsWithSentry.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/nextjs/esm/client/wrapGetServerSidePropsWithSentry.js
/**
 * A passthrough function in case this function is used on the clientside. We need to make the returned function async
 * so we are consistent with the serverside implementation.
 */
function wrapGetServerSidePropsWithSentry(origGetServerSideProps) {
  return new Proxy(origGetServerSideProps, {
    apply: async (wrappingTarget, thisArg, args) => {
      return await wrappingTarget.apply(thisArg, args);
    },
  });
}

/**
 * @deprecated Use `withSentryGetServerSideProps` instead.
 */
const withSentryGetServerSideProps = wrapGetServerSidePropsWithSentry;


//# sourceMappingURL=wrapGetServerSidePropsWithSentry.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/nextjs/esm/client/wrapGetStaticPropsWithSentry.js
/**
 * A passthrough function in case this function is used on the clientside. We need to make the returned function async
 * so we are consistent with the serverside implementation.
 */
function wrapGetStaticPropsWithSentry(origGetStaticProps) {
  return new Proxy(origGetStaticProps, {
    apply: async (wrappingTarget, thisArg, args) => {
      return await wrappingTarget.apply(thisArg, args);
    },
  });
}

/**
 * @deprecated Use `wrapGetStaticPropsWithSentry` instead.
 */
const withSentryGetStaticProps = wrapGetStaticPropsWithSentry;


//# sourceMappingURL=wrapGetStaticPropsWithSentry.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/nextjs/esm/client/index.js





















// Treeshakable guard to remove all code related to tracing

const client_globalWithInjectedValues = __webpack_require__.g

;

/** Inits the Sentry NextJS SDK on the browser with the React SDK. */
function client_init(options) {
  applyTunnelRouteOption(options);
  buildMetadata(options, ['nextjs', 'react']);

  options.environment = options.environment || getVercelEnv(true) || "production";

  addClientIntegrations(options);

  init(options);

  (0,esm_exports/* configureScope */.e)(scope => {
    scope.setTag('runtime', 'browser');
    const filterTransactions = event =>
      event.type === 'transaction' && event.transaction === '/404' ? null : event;
    filterTransactions.id = 'NextClient404Filter';
    scope.addEventProcessor(filterTransactions);

    if (false) {}
  });
}

function addClientIntegrations(options) {
  let integrations = options.integrations || [];

  // This value is injected at build time, based on the output directory specified in the build config. Though a default
  // is set there, we set it here as well, just in case something has gone wrong with the injection.
  const assetPrefixPath = client_globalWithInjectedValues.__rewriteFramesAssetPrefixPath__ || '';

  const defaultRewriteFramesIntegration = new RewriteFrames({
    // Turn `<origin>/<path>/_next/static/...` into `app:///_next/static/...`
    iteratee: frame => {
      try {
        const { origin } = new URL(frame.filename );
        frame.filename = _optionalChain([frame, 'access', _ => _.filename, 'optionalAccess', _2 => _2.replace, 'call', _3 => _3(origin, 'app://'), 'access', _4 => _4.replace, 'call', _5 => _5(assetPrefixPath, '')]);
      } catch (err) {
        // Filename wasn't a properly formed URL, so there's nothing we can do
      }

      // We need to URI-decode the filename because Next.js has wildcard routes like "/users/[id].js" which show up as "/users/%5id%5.js" in Error stacktraces.
      // The corresponding sources that Next.js generates have proper brackets so we also need proper brackets in the frame so that source map resolving works.
      if (frame.filename && frame.filename.startsWith('app:///_next')) {
        frame.filename = decodeURI(frame.filename);
      }

      if (
        frame.filename &&
        frame.filename.match(
          /^app:\/\/\/_next\/static\/chunks\/(main-|main-app-|polyfills-|webpack-|framework-|framework\.)[0-9a-f]+\.js$/,
        )
      ) {
        // We don't care about these frames. It's Next.js internal code.
        frame.in_app = false;
      }

      return frame;
    },
  });
  integrations = addOrUpdateIntegration(defaultRewriteFramesIntegration, integrations);

  // This evaluates to true unless __SENTRY_TRACING__ is text-replaced with "false", in which case everything inside
  // will get treeshaken away
  if (typeof __SENTRY_TRACING__ === 'undefined' || __SENTRY_TRACING__) {
    if (hasTracingEnabled(options)) {
      const defaultBrowserTracingIntegration = new BrowserTracing({
        // eslint-disable-next-line deprecation/deprecation
        tracingOrigins: [...defaultRequestInstrumentationOptions.tracingOrigins, /^(api\/)/],
        routingInstrumentation: nextRouterInstrumentation,
      });

      integrations = addOrUpdateIntegration(defaultBrowserTracingIntegration, integrations, {
        'options.routingInstrumentation': nextRouterInstrumentation,
      });
    }
  }

  options.integrations = integrations;
}

/**
 * Just a passthrough in case this is imported from the client.
 */
function withSentryConfig(exportedUserNextConfig) {
  return exportedUserNextConfig;
}


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 61495:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Rt": function() { return /* binding */ htmlTreeAsString; },
/* harmony export */   "l4": function() { return /* binding */ getLocationHref; },
/* harmony export */   "qT": function() { return /* binding */ getDomElement; }
/* harmony export */ });
/* harmony import */ var _is_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66885);
/* harmony import */ var _worldwide_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74211);



// eslint-disable-next-line deprecation/deprecation
const WINDOW = (0,_worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .Rf)();

const DEFAULT_MAX_STRING_LENGTH = 80;

/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */
function htmlTreeAsString(
  elem,
  options = {},
) {

  // try/catch both:
  // - accessing event.target (see getsentry/raven-js#838, #768)
  // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
  // - can throw an exception in some circumstances.
  try {
    let currentElem = elem ;
    const MAX_TRAVERSE_HEIGHT = 5;
    const out = [];
    let height = 0;
    let len = 0;
    const separator = ' > ';
    const sepLength = separator.length;
    let nextStr;
    const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
    const maxStringLength = (!Array.isArray(options) && options.maxStringLength) || DEFAULT_MAX_STRING_LENGTH;

    while (currentElem && height++ < MAX_TRAVERSE_HEIGHT) {
      nextStr = _htmlElementAsString(currentElem, keyAttrs);
      // bail out if
      // - nextStr is the 'html' element
      // - the length of the string that would be created exceeds maxStringLength
      //   (ignore this limit if we are on the first iteration)
      if (nextStr === 'html' || (height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength)) {
        break;
      }

      out.push(nextStr);

      len += nextStr.length;
      currentElem = currentElem.parentNode;
    }

    return out.reverse().join(separator);
  } catch (_oO) {
    return '<unknown>';
  }
}

/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */
function _htmlElementAsString(el, keyAttrs) {
  const elem = el

;

  const out = [];
  let className;
  let classes;
  let key;
  let attr;
  let i;

  if (!elem || !elem.tagName) {
    return '';
  }

  out.push(elem.tagName.toLowerCase());

  // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
  const keyAttrPairs =
    keyAttrs && keyAttrs.length
      ? keyAttrs.filter(keyAttr => elem.getAttribute(keyAttr)).map(keyAttr => [keyAttr, elem.getAttribute(keyAttr)])
      : null;

  if (keyAttrPairs && keyAttrPairs.length) {
    keyAttrPairs.forEach(keyAttrPair => {
      out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
  } else {
    if (elem.id) {
      out.push(`#${elem.id}`);
    }

    // eslint-disable-next-line prefer-const
    className = elem.className;
    if (className && (0,_is_js__WEBPACK_IMPORTED_MODULE_1__/* .isString */ .HD)(className)) {
      classes = className.split(/\s+/);
      for (i = 0; i < classes.length; i++) {
        out.push(`.${classes[i]}`);
      }
    }
  }
  const allowedAttrs = ['aria-label', 'type', 'name', 'title', 'alt'];
  for (i = 0; i < allowedAttrs.length; i++) {
    key = allowedAttrs[i];
    attr = elem.getAttribute(key);
    if (attr) {
      out.push(`[${key}="${attr}"]`);
    }
  }
  return out.join('');
}

/**
 * A safe form of location.href
 */
function getLocationHref() {
  try {
    return WINDOW.document.location.href;
  } catch (oO) {
    return '';
  }
}

/**
 * Gets a DOM element by using document.querySelector.
 *
 * This wrapper will first check for the existance of the function before
 * actually calling it so that we don't have to take care of this check,
 * every time we want to access the DOM.
 *
 * Reason: DOM/querySelector is not available in all environments.
 *
 * We have to cast to any because utils can be consumed by a variety of environments,
 * and we don't want to break TS users. If you know what element will be selected by
 * `document.querySelector`, specify it as part of the generic call. For example,
 * `const element = getDomElement<Element>('selector');`
 *
 * @param selector the selector string passed on to document.querySelector
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function getDomElement(selector) {
  if (WINDOW.document && WINDOW.document.querySelector) {
    return WINDOW.document.querySelector(selector) ;
  }
  return null;
}


//# sourceMappingURL=browser.js.map


/***/ }),

/***/ 73166:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "RA": function() { return /* binding */ dsnToString; },
/* harmony export */   "U4": function() { return /* binding */ dsnFromString; },
/* harmony export */   "vK": function() { return /* binding */ makeDsn; }
/* harmony export */ });
/* harmony import */ var _logger_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(86922);


/** Regular expression used to parse a Dsn. */
const DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;

function isValidProtocol(protocol) {
  return protocol === 'http' || protocol === 'https';
}

/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */
function dsnToString(dsn, withPassword = false) {
  const { host, path, pass, port, projectId, protocol, publicKey } = dsn;
  return (
    `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ''}` +
    `@${host}${port ? `:${port}` : ''}/${path ? `${path}/` : path}${projectId}`
  );
}

/**
 * Parses a Dsn from a given string.
 *
 * @param str A Dsn as string
 * @returns Dsn as DsnComponents or undefined if @param str is not a valid DSN string
 */
function dsnFromString(str) {
  const match = DSN_REGEX.exec(str);

  if (!match) {
    // This should be logged to the console
    // eslint-disable-next-line no-console
    console.error(`Invalid Sentry Dsn: ${str}`);
    return undefined;
  }

  const [protocol, publicKey, pass = '', host, port = '', lastPath] = match.slice(1);
  let path = '';
  let projectId = lastPath;

  const split = projectId.split('/');
  if (split.length > 1) {
    path = split.slice(0, -1).join('/');
    projectId = split.pop() ;
  }

  if (projectId) {
    const projectMatch = projectId.match(/^\d+/);
    if (projectMatch) {
      projectId = projectMatch[0];
    }
  }

  return dsnFromComponents({ host, pass, path, projectId, port, protocol: protocol , publicKey });
}

function dsnFromComponents(components) {
  return {
    protocol: components.protocol,
    publicKey: components.publicKey || '',
    pass: components.pass || '',
    host: components.host,
    port: components.port || '',
    path: components.path || '',
    projectId: components.projectId,
  };
}

function validateDsn(dsn) {
  if (!(typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
    return true;
  }

  const { port, projectId, protocol } = dsn;

  const requiredComponents = ['protocol', 'publicKey', 'host', 'projectId'];
  const hasMissingRequiredComponent = requiredComponents.find(component => {
    if (!dsn[component]) {
      _logger_js__WEBPACK_IMPORTED_MODULE_0__/* .logger.error */ .kg.error(`Invalid Sentry Dsn: ${component} missing`);
      return true;
    }
    return false;
  });

  if (hasMissingRequiredComponent) {
    return false;
  }

  if (!projectId.match(/^\d+$/)) {
    _logger_js__WEBPACK_IMPORTED_MODULE_0__/* .logger.error */ .kg.error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
    return false;
  }

  if (!isValidProtocol(protocol)) {
    _logger_js__WEBPACK_IMPORTED_MODULE_0__/* .logger.error */ .kg.error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
    return false;
  }

  if (port && isNaN(parseInt(port, 10))) {
    _logger_js__WEBPACK_IMPORTED_MODULE_0__/* .logger.error */ .kg.error(`Invalid Sentry Dsn: Invalid port ${port}`);
    return false;
  }

  return true;
}

/**
 * Creates a valid Sentry Dsn object, identifying a Sentry instance and project.
 * @returns a valid DsnComponents object or `undefined` if @param from is an invalid DSN source
 */
function makeDsn(from) {
  const components = typeof from === 'string' ? dsnFromString(from) : dsnFromComponents(from);
  if (!components || !validateDsn(components)) {
    return undefined;
  }
  return components;
}


//# sourceMappingURL=dsn.js.map


/***/ }),

/***/ 6905:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ getSDKSource; },
/* harmony export */   "n": function() { return /* binding */ isBrowserBundle; }
/* harmony export */ });
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These flags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */

/**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */
function isBrowserBundle() {
  return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
}

/**
 * Get source of SDK.
 */
function getSDKSource() {
  // @ts-ignore "npm" is injected by rollup during build process
  return "npm";
}


//# sourceMappingURL=env.js.map


/***/ }),

/***/ 73285:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BO": function() { return /* binding */ addItemToEnvelope; },
/* harmony export */   "Cd": function() { return /* binding */ createEventEnvelopeHeaders; },
/* harmony export */   "HY": function() { return /* binding */ getSdkMetadataForEnvelopeHeader; },
/* harmony export */   "Jd": function() { return /* binding */ createEnvelope; },
/* harmony export */   "R": function() { return /* binding */ envelopeContainsItemType; },
/* harmony export */   "V$": function() { return /* binding */ serializeEnvelope; },
/* harmony export */   "f4": function() { return /* binding */ parseEnvelope; },
/* harmony export */   "gv": function() { return /* binding */ forEachEnvelopeItem; },
/* harmony export */   "mL": function() { return /* binding */ envelopeItemTypeToDataCategory; },
/* harmony export */   "zQ": function() { return /* binding */ createAttachmentEnvelopeItem; }
/* harmony export */ });
/* harmony import */ var _dsn_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73166);
/* harmony import */ var _normalize_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43527);
/* harmony import */ var _object_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39109);




/**
 * Creates an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */
function createEnvelope(headers, items = []) {
  return [headers, items] ;
}

/**
 * Add an item to an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */
function addItemToEnvelope(envelope, newItem) {
  const [headers, items] = envelope;
  return [headers, [...items, newItem]] ;
}

/**
 * Convenience function to loop through the items and item types of an envelope.
 * (This function was mostly created because working with envelope types is painful at the moment)
 *
 * If the callback returns true, the rest of the items will be skipped.
 */
function forEachEnvelopeItem(
  envelope,
  callback,
) {
  const envelopeItems = envelope[1];

  for (const envelopeItem of envelopeItems) {
    const envelopeItemType = envelopeItem[0].type;
    const result = callback(envelopeItem, envelopeItemType);

    if (result) {
      return true;
    }
  }

  return false;
}

/**
 * Returns true if the envelope contains any of the given envelope item types
 */
function envelopeContainsItemType(envelope, types) {
  return forEachEnvelopeItem(envelope, (_, type) => types.includes(type));
}

/**
 * Encode a string to UTF8.
 */
function encodeUTF8(input, textEncoder) {
  const utf8 = textEncoder || new TextEncoder();
  return utf8.encode(input);
}

/**
 * Serializes an envelope.
 */
function serializeEnvelope(envelope, textEncoder) {
  const [envHeaders, items] = envelope;

  // Initially we construct our envelope as a string and only convert to binary chunks if we encounter binary data
  let parts = JSON.stringify(envHeaders);

  function append(next) {
    if (typeof parts === 'string') {
      parts = typeof next === 'string' ? parts + next : [encodeUTF8(parts, textEncoder), next];
    } else {
      parts.push(typeof next === 'string' ? encodeUTF8(next, textEncoder) : next);
    }
  }

  for (const item of items) {
    const [itemHeaders, payload] = item;

    append(`\n${JSON.stringify(itemHeaders)}\n`);

    if (typeof payload === 'string' || payload instanceof Uint8Array) {
      append(payload);
    } else {
      let stringifiedPayload;
      try {
        stringifiedPayload = JSON.stringify(payload);
      } catch (e) {
        // In case, despite all our efforts to keep `payload` circular-dependency-free, `JSON.strinify()` still
        // fails, we try again after normalizing it again with infinite normalization depth. This of course has a
        // performance impact but in this case a performance hit is better than throwing.
        stringifiedPayload = JSON.stringify((0,_normalize_js__WEBPACK_IMPORTED_MODULE_0__/* .normalize */ .Fv)(payload));
      }
      append(stringifiedPayload);
    }
  }

  return typeof parts === 'string' ? parts : concatBuffers(parts);
}

function concatBuffers(buffers) {
  const totalLength = buffers.reduce((acc, buf) => acc + buf.length, 0);

  const merged = new Uint8Array(totalLength);
  let offset = 0;
  for (const buffer of buffers) {
    merged.set(buffer, offset);
    offset += buffer.length;
  }

  return merged;
}

/**
 * Parses an envelope
 */
function parseEnvelope(
  env,
  textEncoder,
  textDecoder,
) {
  let buffer = typeof env === 'string' ? textEncoder.encode(env) : env;

  function readBinary(length) {
    const bin = buffer.subarray(0, length);
    // Replace the buffer with the remaining data excluding trailing newline
    buffer = buffer.subarray(length + 1);
    return bin;
  }

  function readJson() {
    let i = buffer.indexOf(0xa);
    // If we couldn't find a newline, we must have found the end of the buffer
    if (i < 0) {
      i = buffer.length;
    }

    return JSON.parse(textDecoder.decode(readBinary(i))) ;
  }

  const envelopeHeader = readJson();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const items = [];

  while (buffer.length) {
    const itemHeader = readJson();
    const binaryLength = typeof itemHeader.length === 'number' ? itemHeader.length : undefined;

    items.push([itemHeader, binaryLength ? readBinary(binaryLength) : readJson()]);
  }

  return [envelopeHeader, items];
}

/**
 * Creates attachment envelope items
 */
function createAttachmentEnvelopeItem(
  attachment,
  textEncoder,
) {
  const buffer = typeof attachment.data === 'string' ? encodeUTF8(attachment.data, textEncoder) : attachment.data;

  return [
    (0,_object_js__WEBPACK_IMPORTED_MODULE_1__/* .dropUndefinedKeys */ .Jr)({
      type: 'attachment',
      length: buffer.length,
      filename: attachment.filename,
      content_type: attachment.contentType,
      attachment_type: attachment.attachmentType,
    }),
    buffer,
  ];
}

const ITEM_TYPE_TO_DATA_CATEGORY_MAP = {
  session: 'session',
  sessions: 'session',
  attachment: 'attachment',
  transaction: 'transaction',
  event: 'error',
  client_report: 'internal',
  user_report: 'default',
  profile: 'profile',
  replay_event: 'replay',
  replay_recording: 'replay',
  check_in: 'monitor',
};

/**
 * Maps the type of an envelope item to a data category.
 */
function envelopeItemTypeToDataCategory(type) {
  return ITEM_TYPE_TO_DATA_CATEGORY_MAP[type];
}

/** Extracts the minimal SDK info from from the metadata or an events */
function getSdkMetadataForEnvelopeHeader(metadataOrEvent) {
  if (!metadataOrEvent || !metadataOrEvent.sdk) {
    return;
  }
  const { name, version } = metadataOrEvent.sdk;
  return { name, version };
}

/**
 * Creates event envelope headers, based on event, sdk info and tunnel
 * Note: This function was extracted from the core package to make it available in Replay
 */
function createEventEnvelopeHeaders(
  event,
  sdkInfo,
  tunnel,
  dsn,
) {
  const dynamicSamplingContext = event.sdkProcessingMetadata && event.sdkProcessingMetadata.dynamicSamplingContext;
  return {
    event_id: event.event_id ,
    sent_at: new Date().toISOString(),
    ...(sdkInfo && { sdk: sdkInfo }),
    ...(!!tunnel && { dsn: (0,_dsn_js__WEBPACK_IMPORTED_MODULE_2__/* .dsnToString */ .RA)(dsn) }),
    ...(dynamicSamplingContext && {
      trace: (0,_object_js__WEBPACK_IMPORTED_MODULE_1__/* .dropUndefinedKeys */ .Jr)({ ...dynamicSamplingContext }),
    }),
  };
}


//# sourceMappingURL=envelope.js.map


/***/ }),

/***/ 44502:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ SentryError; }
/* harmony export */ });
/** An error emitted by Sentry SDKs and related utilities. */
class SentryError extends Error {
  /** Display name of this error instance. */

   constructor( message, logLevel = 'warn') {
    super(message);this.message = message;
    this.name = new.target.prototype.constructor.name;
    // This sets the prototype to be `Error`, not `SentryError`. It's unclear why we do this, but commenting this line
    // out causes various (seemingly totally unrelated) playwright tests consistently time out. FYI, this makes
    // instances of `SentryError` fail `obj instanceof SentryError` checks.
    Object.setPrototypeOf(this, new.target.prototype);
    this.logLevel = logLevel;
  }
}


//# sourceMappingURL=error.js.map


/***/ }),

/***/ 15188:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "xU": function() { return /* binding */ SENTRY_XHR_DATA_KEY; },
  "oq": function() { return /* binding */ addInstrumentationHandler; }
});

// UNUSED EXPORTS: parseFetchArgs

// EXTERNAL MODULE: ../node_modules/@sentry/utils/esm/is.js
var is = __webpack_require__(66885);
// EXTERNAL MODULE: ../node_modules/@sentry/utils/esm/logger.js
var logger = __webpack_require__(86922);
// EXTERNAL MODULE: ../node_modules/@sentry/utils/esm/object.js
var object = __webpack_require__(39109);
// EXTERNAL MODULE: ../node_modules/@sentry/utils/esm/stacktrace.js
var stacktrace = __webpack_require__(55514);
// EXTERNAL MODULE: ../node_modules/@sentry/utils/esm/supports.js
var supports = __webpack_require__(83589);
// EXTERNAL MODULE: ../node_modules/@sentry/utils/esm/worldwide.js
var worldwide = __webpack_require__(74211);
;// CONCATENATED MODULE: ../node_modules/@sentry/utils/esm/vendor/supportsHistory.js


// Based on https://github.com/angular/angular.js/pull/13945/files

// eslint-disable-next-line deprecation/deprecation
const WINDOW = (0,worldwide/* getGlobalObject */.Rf)();

/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */
function supportsHistory() {
  // NOTE: in Chrome App environment, touching history.pushState, *even inside
  //       a try/catch block*, will cause Chrome to output an error to console.error
  // borrowed from: https://github.com/angular/angular.js/pull/13945/files
  /* eslint-disable @typescript-eslint/no-unsafe-member-access */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const chrome = (WINDOW ).chrome;
  const isChromePackagedApp = chrome && chrome.app && chrome.app.runtime;
  /* eslint-enable @typescript-eslint/no-unsafe-member-access */
  const hasHistoryApi = 'history' in WINDOW && !!WINDOW.history.pushState && !!WINDOW.history.replaceState;

  return !isChromePackagedApp && hasHistoryApi;
}


//# sourceMappingURL=supportsHistory.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/utils/esm/instrument.js








// eslint-disable-next-line deprecation/deprecation
const instrument_WINDOW = (0,worldwide/* getGlobalObject */.Rf)();

const SENTRY_XHR_DATA_KEY = '__sentry_xhr_v2__';

/**
 * Instrument native APIs to call handlers that can be used to create breadcrumbs, APM spans etc.
 *  - Console API
 *  - Fetch API
 *  - XHR API
 *  - History API
 *  - DOM API (click/typing)
 *  - Error API
 *  - UnhandledRejection API
 */

const handlers = {};
const instrumented = {};

/** Instruments given API */
function instrument(type) {
  if (instrumented[type]) {
    return;
  }

  instrumented[type] = true;

  switch (type) {
    case 'console':
      instrumentConsole();
      break;
    case 'dom':
      instrumentDOM();
      break;
    case 'xhr':
      instrumentXHR();
      break;
    case 'fetch':
      instrumentFetch();
      break;
    case 'history':
      instrumentHistory();
      break;
    case 'error':
      instrumentError();
      break;
    case 'unhandledrejection':
      instrumentUnhandledRejection();
      break;
    default:
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.warn */.kg.warn('unknown instrumentation type:', type);
      return;
  }
}

/**
 * Add handler that will be called when given type of instrumentation triggers.
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */
function addInstrumentationHandler(type, callback) {
  handlers[type] = handlers[type] || [];
  (handlers[type] ).push(callback);
  instrument(type);
}

/** JSDoc */
function triggerHandlers(type, data) {
  if (!type || !handlers[type]) {
    return;
  }

  for (const handler of handlers[type] || []) {
    try {
      handler(data);
    } catch (e) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        logger/* logger.error */.kg.error(
          `Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0,stacktrace/* getFunctionName */.$P)(handler)}\nError:`,
          e,
        );
    }
  }
}

/** JSDoc */
function instrumentConsole() {
  if (!('console' in instrument_WINDOW)) {
    return;
  }

  logger/* CONSOLE_LEVELS.forEach */.RU.forEach(function (level) {
    if (!(level in instrument_WINDOW.console)) {
      return;
    }

    (0,object/* fill */.hl)(instrument_WINDOW.console, level, function (originalConsoleMethod) {
      return function (...args) {
        triggerHandlers('console', { args, level });

        // this fails for some browsers. :(
        if (originalConsoleMethod) {
          originalConsoleMethod.apply(instrument_WINDOW.console, args);
        }
      };
    });
  });
}

/** JSDoc */
function instrumentFetch() {
  if (!(0,supports/* supportsNativeFetch */.t$)()) {
    return;
  }

  (0,object/* fill */.hl)(instrument_WINDOW, 'fetch', function (originalFetch) {
    return function (...args) {
      const { method, url } = parseFetchArgs(args);

      const handlerData = {
        args,
        fetchData: {
          method,
          url,
        },
        startTimestamp: Date.now(),
      };

      triggerHandlers('fetch', {
        ...handlerData,
      });

      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      return originalFetch.apply(instrument_WINDOW, args).then(
        (response) => {
          triggerHandlers('fetch', {
            ...handlerData,
            endTimestamp: Date.now(),
            response,
          });
          return response;
        },
        (error) => {
          triggerHandlers('fetch', {
            ...handlerData,
            endTimestamp: Date.now(),
            error,
          });
          // NOTE: If you are a Sentry user, and you are seeing this stack frame,
          //       it means the sentry.javascript SDK caught an error invoking your application code.
          //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
          throw error;
        },
      );
    };
  });
}

function hasProp(obj, prop) {
  return !!obj && typeof obj === 'object' && !!(obj )[prop];
}

function getUrlFromResource(resource) {
  if (typeof resource === 'string') {
    return resource;
  }

  if (!resource) {
    return '';
  }

  if (hasProp(resource, 'url')) {
    return resource.url;
  }

  if (resource.toString) {
    return resource.toString();
  }

  return '';
}

/**
 * Parses the fetch arguments to find the used Http method and the url of the request
 */
function parseFetchArgs(fetchArgs) {
  if (fetchArgs.length === 0) {
    return { method: 'GET', url: '' };
  }

  if (fetchArgs.length === 2) {
    const [url, options] = fetchArgs ;

    return {
      url: getUrlFromResource(url),
      method: hasProp(options, 'method') ? String(options.method).toUpperCase() : 'GET',
    };
  }

  const arg = fetchArgs[0];
  return {
    url: getUrlFromResource(arg ),
    method: hasProp(arg, 'method') ? String(arg.method).toUpperCase() : 'GET',
  };
}

/** JSDoc */
function instrumentXHR() {
  if (!('XMLHttpRequest' in instrument_WINDOW)) {
    return;
  }

  const xhrproto = XMLHttpRequest.prototype;

  (0,object/* fill */.hl)(xhrproto, 'open', function (originalOpen) {
    return function ( ...args) {
      const url = args[1];
      const xhrInfo = (this[SENTRY_XHR_DATA_KEY] = {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        method: (0,is/* isString */.HD)(args[0]) ? args[0].toUpperCase() : args[0],
        url: args[1],
        request_headers: {},
      });

      // if Sentry key appears in URL, don't capture it as a request
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      if ((0,is/* isString */.HD)(url) && xhrInfo.method === 'POST' && url.match(/sentry_key/)) {
        this.__sentry_own_request__ = true;
      }

      const onreadystatechangeHandler = () => {
        // For whatever reason, this is not the same instance here as from the outer method
        const xhrInfo = this[SENTRY_XHR_DATA_KEY];

        if (!xhrInfo) {
          return;
        }

        if (this.readyState === 4) {
          try {
            // touching statusCode in some platforms throws
            // an exception
            xhrInfo.status_code = this.status;
          } catch (e) {
            /* do nothing */
          }

          triggerHandlers('xhr', {
            args: args ,
            endTimestamp: Date.now(),
            startTimestamp: Date.now(),
            xhr: this,
          } );
        }
      };

      if ('onreadystatechange' in this && typeof this.onreadystatechange === 'function') {
        (0,object/* fill */.hl)(this, 'onreadystatechange', function (original) {
          return function ( ...readyStateArgs) {
            onreadystatechangeHandler();
            return original.apply(this, readyStateArgs);
          };
        });
      } else {
        this.addEventListener('readystatechange', onreadystatechangeHandler);
      }

      // Intercepting `setRequestHeader` to access the request headers of XHR instance.
      // This will only work for user/library defined headers, not for the default/browser-assigned headers.
      // Request cookies are also unavailable for XHR, as `Cookie` header can't be defined by `setRequestHeader`.
      (0,object/* fill */.hl)(this, 'setRequestHeader', function (original) {
        return function ( ...setRequestHeaderArgs) {
          const [header, value] = setRequestHeaderArgs ;

          const xhrInfo = this[SENTRY_XHR_DATA_KEY];

          if (xhrInfo) {
            xhrInfo.request_headers[header.toLowerCase()] = value;
          }

          return original.apply(this, setRequestHeaderArgs);
        };
      });

      return originalOpen.apply(this, args);
    };
  });

  (0,object/* fill */.hl)(xhrproto, 'send', function (originalSend) {
    return function ( ...args) {
      const sentryXhrData = this[SENTRY_XHR_DATA_KEY];
      if (sentryXhrData && args[0] !== undefined) {
        sentryXhrData.body = args[0];
      }

      triggerHandlers('xhr', {
        args,
        startTimestamp: Date.now(),
        xhr: this,
      });

      return originalSend.apply(this, args);
    };
  });
}

let lastHref;

/** JSDoc */
function instrumentHistory() {
  if (!supportsHistory()) {
    return;
  }

  const oldOnPopState = instrument_WINDOW.onpopstate;
  instrument_WINDOW.onpopstate = function ( ...args) {
    const to = instrument_WINDOW.location.href;
    // keep track of the current URL state, as we always receive only the updated state
    const from = lastHref;
    lastHref = to;
    triggerHandlers('history', {
      from,
      to,
    });
    if (oldOnPopState) {
      // Apparently this can throw in Firefox when incorrectly implemented plugin is installed.
      // https://github.com/getsentry/sentry-javascript/issues/3344
      // https://github.com/bugsnag/bugsnag-js/issues/469
      try {
        return oldOnPopState.apply(this, args);
      } catch (_oO) {
        // no-empty
      }
    }
  };

  /** @hidden */
  function historyReplacementFunction(originalHistoryFunction) {
    return function ( ...args) {
      const url = args.length > 2 ? args[2] : undefined;
      if (url) {
        // coerce to string (this is what pushState does)
        const from = lastHref;
        const to = String(url);
        // keep track of the current URL state, as we always receive only the updated state
        lastHref = to;
        triggerHandlers('history', {
          from,
          to,
        });
      }
      return originalHistoryFunction.apply(this, args);
    };
  }

  (0,object/* fill */.hl)(instrument_WINDOW.history, 'pushState', historyReplacementFunction);
  (0,object/* fill */.hl)(instrument_WINDOW.history, 'replaceState', historyReplacementFunction);
}

const debounceDuration = 1000;
let debounceTimerID;
let lastCapturedEvent;

/**
 * Decide whether the current event should finish the debounce of previously captured one.
 * @param previous previously captured event
 * @param current event to be captured
 */
function shouldShortcircuitPreviousDebounce(previous, current) {
  // If there was no previous event, it should always be swapped for the new one.
  if (!previous) {
    return true;
  }

  // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
  if (previous.type !== current.type) {
    return true;
  }

  try {
    // If both events have the same type, it's still possible that actions were performed on different targets.
    // e.g. 2 clicks on different buttons.
    if (previous.target !== current.target) {
      return true;
    }
  } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
  }

  // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
  // to which an event listener was attached), we treat them as the same action, as we want to capture
  // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
  return false;
}

/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */
function shouldSkipDOMEvent(event) {
  // We are only interested in filtering `keypress` events for now.
  if (event.type !== 'keypress') {
    return false;
  }

  try {
    const target = event.target ;

    if (!target || !target.tagName) {
      return true;
    }

    // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
    // e.g.tabbing through elements, hotkeys, etc.
    if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) {
      return false;
    }
  } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
  }

  return true;
}

/**
 * Wraps addEventListener to capture UI breadcrumbs
 * @param handler function that will be triggered
 * @param globalListener indicates whether event was captured by the global event listener
 * @returns wrapped breadcrumb events handler
 * @hidden
 */
function makeDOMEventHandler(handler, globalListener = false) {
  return (event) => {
    // It's possible this handler might trigger multiple times for the same
    // event (e.g. event propagation through node ancestors).
    // Ignore if we've already captured that event.
    if (!event || lastCapturedEvent === event) {
      return;
    }

    // We always want to skip _some_ events.
    if (shouldSkipDOMEvent(event)) {
      return;
    }

    const name = event.type === 'keypress' ? 'input' : event.type;

    // If there is no debounce timer, it means that we can safely capture the new event and store it for future comparisons.
    if (debounceTimerID === undefined) {
      handler({
        event: event,
        name,
        global: globalListener,
      });
      lastCapturedEvent = event;
    }
    // If there is a debounce awaiting, see if the new event is different enough to treat it as a unique one.
    // If that's the case, emit the previous event and store locally the newly-captured DOM event.
    else if (shouldShortcircuitPreviousDebounce(lastCapturedEvent, event)) {
      handler({
        event: event,
        name,
        global: globalListener,
      });
      lastCapturedEvent = event;
    }

    // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
    clearTimeout(debounceTimerID);
    debounceTimerID = instrument_WINDOW.setTimeout(() => {
      debounceTimerID = undefined;
    }, debounceDuration);
  };
}

/** JSDoc */
function instrumentDOM() {
  if (!('document' in instrument_WINDOW)) {
    return;
  }

  // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
  // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
  // we instrument `addEventListener` so that we don't end up attaching this handler twice.
  const triggerDOMHandler = triggerHandlers.bind(null, 'dom');
  const globalDOMEventHandler = makeDOMEventHandler(triggerDOMHandler, true);
  instrument_WINDOW.document.addEventListener('click', globalDOMEventHandler, false);
  instrument_WINDOW.document.addEventListener('keypress', globalDOMEventHandler, false);

  // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
  // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
  // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
  // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
  // guaranteed to fire at least once.)
  ['EventTarget', 'Node'].forEach((target) => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    const proto = (instrument_WINDOW )[target] && (instrument_WINDOW )[target].prototype;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
    if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) {
      return;
    }

    (0,object/* fill */.hl)(proto, 'addEventListener', function (originalAddEventListener) {
      return function (

        type,
        listener,
        options,
      ) {
        if (type === 'click' || type == 'keypress') {
          try {
            const el = this ;
            const handlers = (el.__sentry_instrumentation_handlers__ = el.__sentry_instrumentation_handlers__ || {});
            const handlerForType = (handlers[type] = handlers[type] || { refCount: 0 });

            if (!handlerForType.handler) {
              const handler = makeDOMEventHandler(triggerDOMHandler);
              handlerForType.handler = handler;
              originalAddEventListener.call(this, type, handler, options);
            }

            handlerForType.refCount++;
          } catch (e) {
            // Accessing dom properties is always fragile.
            // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
          }
        }

        return originalAddEventListener.call(this, type, listener, options);
      };
    });

    (0,object/* fill */.hl)(
      proto,
      'removeEventListener',
      function (originalRemoveEventListener) {
        return function (

          type,
          listener,
          options,
        ) {
          if (type === 'click' || type == 'keypress') {
            try {
              const el = this ;
              const handlers = el.__sentry_instrumentation_handlers__ || {};
              const handlerForType = handlers[type];

              if (handlerForType) {
                handlerForType.refCount--;
                // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                if (handlerForType.refCount <= 0) {
                  originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                  handlerForType.handler = undefined;
                  delete handlers[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                }

                // If there are no longer any custom handlers of any type on this element, cleanup everything.
                if (Object.keys(handlers).length === 0) {
                  delete el.__sentry_instrumentation_handlers__;
                }
              }
            } catch (e) {
              // Accessing dom properties is always fragile.
              // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
            }
          }

          return originalRemoveEventListener.call(this, type, listener, options);
        };
      },
    );
  });
}

let _oldOnErrorHandler = null;
/** JSDoc */
function instrumentError() {
  _oldOnErrorHandler = instrument_WINDOW.onerror;

  instrument_WINDOW.onerror = function (msg, url, line, column, error) {
    triggerHandlers('error', {
      column,
      error,
      line,
      msg,
      url,
    });

    if (_oldOnErrorHandler && !_oldOnErrorHandler.__SENTRY_LOADER__) {
      // eslint-disable-next-line prefer-rest-params
      return _oldOnErrorHandler.apply(this, arguments);
    }

    return false;
  };

  instrument_WINDOW.onerror.__SENTRY_INSTRUMENTED__ = true;
}

let _oldOnUnhandledRejectionHandler = null;
/** JSDoc */
function instrumentUnhandledRejection() {
  _oldOnUnhandledRejectionHandler = instrument_WINDOW.onunhandledrejection;

  instrument_WINDOW.onunhandledrejection = function (e) {
    triggerHandlers('unhandledrejection', e);

    if (_oldOnUnhandledRejectionHandler && !_oldOnUnhandledRejectionHandler.__SENTRY_LOADER__) {
      // eslint-disable-next-line prefer-rest-params
      return _oldOnUnhandledRejectionHandler.apply(this, arguments);
    }

    return true;
  };

  instrument_WINDOW.onunhandledrejection.__SENTRY_INSTRUMENTED__ = true;
}


//# sourceMappingURL=instrument.js.map


/***/ }),

/***/ 66885:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cy": function() { return /* binding */ isSyntheticEvent; },
/* harmony export */   "HD": function() { return /* binding */ isString; },
/* harmony export */   "J8": function() { return /* binding */ isThenable; },
/* harmony export */   "Kj": function() { return /* binding */ isRegExp; },
/* harmony export */   "PO": function() { return /* binding */ isPlainObject; },
/* harmony export */   "TX": function() { return /* binding */ isDOMError; },
/* harmony export */   "V9": function() { return /* binding */ isInstanceOf; },
/* harmony export */   "VW": function() { return /* binding */ isErrorEvent; },
/* harmony export */   "VZ": function() { return /* binding */ isError; },
/* harmony export */   "cO": function() { return /* binding */ isEvent; },
/* harmony export */   "fm": function() { return /* binding */ isDOMException; },
/* harmony export */   "i2": function() { return /* binding */ isNaN; },
/* harmony export */   "kK": function() { return /* binding */ isElement; },
/* harmony export */   "pt": function() { return /* binding */ isPrimitive; }
/* harmony export */ });
// eslint-disable-next-line @typescript-eslint/unbound-method
const objectToString = Object.prototype.toString;

/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isError(wat) {
  switch (objectToString.call(wat)) {
    case '[object Error]':
    case '[object Exception]':
    case '[object DOMException]':
      return true;
    default:
      return isInstanceOf(wat, Error);
  }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */
function isBuiltin(wat, className) {
  return objectToString.call(wat) === `[object ${className}]`;
}

/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isErrorEvent(wat) {
  return isBuiltin(wat, 'ErrorEvent');
}

/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isDOMError(wat) {
  return isBuiltin(wat, 'DOMError');
}

/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isDOMException(wat) {
  return isBuiltin(wat, 'DOMException');
}

/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isString(wat) {
  return isBuiltin(wat, 'String');
}

/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isPrimitive(wat) {
  return wat === null || (typeof wat !== 'object' && typeof wat !== 'function');
}

/**
 * Checks whether given value's type is an object literal
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isPlainObject(wat) {
  return isBuiltin(wat, 'Object');
}

/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isEvent(wat) {
  return typeof Event !== 'undefined' && isInstanceOf(wat, Event);
}

/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isElement(wat) {
  return typeof Element !== 'undefined' && isInstanceOf(wat, Element);
}

/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isRegExp(wat) {
  return isBuiltin(wat, 'RegExp');
}

/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */
function isThenable(wat) {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  return Boolean(wat && wat.then && typeof wat.then === 'function');
}

/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isSyntheticEvent(wat) {
  return isPlainObject(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}

/**
 * Checks whether given value is NaN
 * {@link isNaN}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isNaN(wat) {
  return typeof wat === 'number' && wat !== wat;
}

/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */
function isInstanceOf(wat, base) {
  try {
    return wat instanceof base;
  } catch (_e) {
    return false;
  }
}


//# sourceMappingURL=is.js.map


/***/ }),

/***/ 86922:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cf": function() { return /* binding */ consoleSandbox; },
/* harmony export */   "RU": function() { return /* binding */ CONSOLE_LEVELS; },
/* harmony export */   "kg": function() { return /* binding */ logger; }
/* harmony export */ });
/* harmony import */ var _worldwide_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74211);


/** Prefix for logging strings */
const PREFIX = 'Sentry Logger ';

const CONSOLE_LEVELS = ['debug', 'info', 'warn', 'error', 'log', 'assert', 'trace'] ;

/**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */
function consoleSandbox(callback) {
  if (!("console" in _worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .GLOBAL_OBJ */ .n2)) {
    return callback();
  }

  const originalConsole = _worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .GLOBAL_OBJ.console */ .n2.console ;
  const wrappedLevels = {};

  // Restore all wrapped console methods
  CONSOLE_LEVELS.forEach(level => {
    // TODO(v7): Remove this check as it's only needed for Node 6
    const originalWrappedFunc =
      originalConsole[level] && (originalConsole[level] ).__sentry_original__;
    if (level in originalConsole && originalWrappedFunc) {
      wrappedLevels[level] = originalConsole[level] ;
      originalConsole[level] = originalWrappedFunc ;
    }
  });

  try {
    return callback();
  } finally {
    // Revert restoration to wrapped state
    Object.keys(wrappedLevels).forEach(level => {
      originalConsole[level] = wrappedLevels[level ];
    });
  }
}

function makeLogger() {
  let enabled = false;
  const logger = {
    enable: () => {
      enabled = true;
    },
    disable: () => {
      enabled = false;
    },
  };

  if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
    CONSOLE_LEVELS.forEach(name => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      logger[name] = (...args) => {
        if (enabled) {
          consoleSandbox(() => {
            _worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .GLOBAL_OBJ.console */ .n2.console[name](`${PREFIX}[${name}]:`, ...args);
          });
        }
      };
    });
  } else {
    CONSOLE_LEVELS.forEach(name => {
      logger[name] = () => undefined;
    });
  }

  return logger ;
}

// Ensure we only have a single logger instance, even if multiple versions of @sentry/utils are being used
let logger;
if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
  logger = (0,_worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalSingleton */ .YO)('logger', makeLogger);
} else {
  logger = makeLogger();
}


//# sourceMappingURL=logger.js.map


/***/ }),

/***/ 67451:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DM": function() { return /* binding */ uuid4; },
/* harmony export */   "Db": function() { return /* binding */ addExceptionTypeValue; },
/* harmony export */   "EG": function() { return /* binding */ addExceptionMechanism; },
/* harmony export */   "YO": function() { return /* binding */ checkOrSetAlreadyCaught; },
/* harmony export */   "jH": function() { return /* binding */ getEventDescription; },
/* harmony export */   "lE": function() { return /* binding */ arrayify; }
/* harmony export */ });
/* unused harmony exports addContextToFrame, parseSemver */
/* harmony import */ var _object_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39109);
/* harmony import */ var _worldwide_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74211);




/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */
function uuid4() {
  const gbl = _worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .GLOBAL_OBJ */ .n2 ;
  const crypto = gbl.crypto || gbl.msCrypto;

  if (crypto && crypto.randomUUID) {
    return crypto.randomUUID().replace(/-/g, '');
  }

  const getRandomByte =
    crypto && crypto.getRandomValues ? () => crypto.getRandomValues(new Uint8Array(1))[0] : () => Math.random() * 16;

  // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
  // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
  return (([1e7] ) + 1e3 + 4e3 + 8e3 + 1e11).replace(/[018]/g, c =>
    // eslint-disable-next-line no-bitwise
    ((c ) ^ ((getRandomByte() & 15) >> ((c ) / 4))).toString(16),
  );
}

function getFirstException(event) {
  return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}

/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */
function getEventDescription(event) {
  const { message, event_id: eventId } = event;
  if (message) {
    return message;
  }

  const firstException = getFirstException(event);
  if (firstException) {
    if (firstException.type && firstException.value) {
      return `${firstException.type}: ${firstException.value}`;
    }
    return firstException.type || firstException.value || eventId || '<unknown>';
  }
  return eventId || '<unknown>';
}

/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */
function addExceptionTypeValue(event, value, type) {
  const exception = (event.exception = event.exception || {});
  const values = (exception.values = exception.values || []);
  const firstException = (values[0] = values[0] || {});
  if (!firstException.value) {
    firstException.value = value || '';
  }
  if (!firstException.type) {
    firstException.type = type || 'Error';
  }
}

/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */
function addExceptionMechanism(event, newMechanism) {
  const firstException = getFirstException(event);
  if (!firstException) {
    return;
  }

  const defaultMechanism = { type: 'generic', handled: true };
  const currentMechanism = firstException.mechanism;
  firstException.mechanism = { ...defaultMechanism, ...currentMechanism, ...newMechanism };

  if (newMechanism && 'data' in newMechanism) {
    const mergedData = { ...(currentMechanism && currentMechanism.data), ...newMechanism.data };
    firstException.mechanism.data = mergedData;
  }
}

// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
const SEMVER_REGEXP =
  /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;

/**
 * Represents Semantic Versioning object
 */

/**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */
function parseSemver(input) {
  const match = input.match(SEMVER_REGEXP) || [];
  const major = parseInt(match[1], 10);
  const minor = parseInt(match[2], 10);
  const patch = parseInt(match[3], 10);
  return {
    buildmetadata: match[5],
    major: isNaN(major) ? undefined : major,
    minor: isNaN(minor) ? undefined : minor,
    patch: isNaN(patch) ? undefined : patch,
    prerelease: match[4],
  };
}

/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */
function addContextToFrame(lines, frame, linesOfContext = 5) {
  // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
  if (frame.lineno === undefined) {
    return;
  }

  const maxLines = lines.length;
  const sourceLine = Math.max(Math.min(maxLines, frame.lineno - 1), 0);

  frame.pre_context = lines
    .slice(Math.max(0, sourceLine - linesOfContext), sourceLine)
    .map((line) => snipLine(line, 0));

  frame.context_line = snipLine(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);

  frame.post_context = lines
    .slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext)
    .map((line) => snipLine(line, 0));
}

/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */
function checkOrSetAlreadyCaught(exception) {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  if (exception && (exception ).__sentry_captured__) {
    return true;
  }

  try {
    // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
    // `ExtraErrorData` integration
    (0,_object_js__WEBPACK_IMPORTED_MODULE_1__/* .addNonEnumerableProperty */ .xp)(exception , '__sentry_captured__', true);
  } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
  }

  return false;
}

/**
 * Checks whether the given input is already an array, and if it isn't, wraps it in one.
 *
 * @param maybeArray Input to turn into an array, if necessary
 * @returns The input, if already an array, or an array with the input as the only element, if not
 */
function arrayify(maybeArray) {
  return Array.isArray(maybeArray) ? maybeArray : [maybeArray];
}


//# sourceMappingURL=misc.js.map


/***/ }),

/***/ 5728:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "KV": function() { return /* binding */ isNodeEnv; },
/* harmony export */   "l$": function() { return /* binding */ dynamicRequire; }
/* harmony export */ });
/* unused harmony export loadModule */
/* harmony import */ var _env_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6905);
/* module decorator */ module = __webpack_require__.hmd(module);
/* provided dependency */ var process = __webpack_require__(27061);


/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */

/**
 * Checks whether we're in the Node.js or Browser environment
 *
 * @returns Answer to given question
 */
function isNodeEnv() {
  // explicitly check for browser bundles as those can be optimized statically
  // by terser/rollup.
  return (
    !(0,_env_js__WEBPACK_IMPORTED_MODULE_0__/* .isBrowserBundle */ .n)() &&
    Object.prototype.toString.call(typeof process !== 'undefined' ? process : 0) === '[object process]'
  );
}

/**
 * Requires a module which is protected against bundler minification.
 *
 * @param request The module path to resolve
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
function dynamicRequire(mod, request) {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  return mod.require(request);
}

/**
 * Helper for dynamically loading module that should work with linked dependencies.
 * The problem is that we _should_ be using `require(require.resolve(moduleName, { paths: [cwd()] }))`
 * However it's _not possible_ to do that with Webpack, as it has to know all the dependencies during
 * build time. `require.resolve` is also not available in any other way, so we cannot create,
 * a fake helper like we do with `dynamicRequire`.
 *
 * We always prefer to use local package, thus the value is not returned early from each `try/catch` block.
 * That is to mimic the behavior of `require.resolve` exactly.
 *
 * @param moduleName module name to require
 * @returns possibly required module
 */
function loadModule(moduleName) {
  let mod;

  try {
    mod = dynamicRequire(module, moduleName);
  } catch (e) {
    // no-empty
  }

  try {
    const { cwd } = dynamicRequire(module, 'process');
    mod = dynamicRequire(module, `${cwd()}/node_modules/${moduleName}`) ;
  } catch (e) {
    // no-empty
  }

  return mod;
}


//# sourceMappingURL=node.js.map


/***/ }),

/***/ 43527:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Fv": function() { return /* binding */ normalize; },
  "Qy": function() { return /* binding */ normalizeToSize; }
});

// UNUSED EXPORTS: walk

// EXTERNAL MODULE: ../node_modules/@sentry/utils/esm/is.js
var is = __webpack_require__(66885);
;// CONCATENATED MODULE: ../node_modules/@sentry/utils/esm/memo.js
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */

/**
 * Helper to decycle json objects
 */
function memoBuilder() {
  const hasWeakSet = typeof WeakSet === 'function';
  const inner = hasWeakSet ? new WeakSet() : [];
  function memoize(obj) {
    if (hasWeakSet) {
      if (inner.has(obj)) {
        return true;
      }
      inner.add(obj);
      return false;
    }
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for (let i = 0; i < inner.length; i++) {
      const value = inner[i];
      if (value === obj) {
        return true;
      }
    }
    inner.push(obj);
    return false;
  }

  function unmemoize(obj) {
    if (hasWeakSet) {
      inner.delete(obj);
    } else {
      for (let i = 0; i < inner.length; i++) {
        if (inner[i] === obj) {
          inner.splice(i, 1);
          break;
        }
      }
    }
  }
  return [memoize, unmemoize];
}


//# sourceMappingURL=memo.js.map

// EXTERNAL MODULE: ../node_modules/@sentry/utils/esm/object.js
var object = __webpack_require__(39109);
// EXTERNAL MODULE: ../node_modules/@sentry/utils/esm/stacktrace.js
var stacktrace = __webpack_require__(55514);
;// CONCATENATED MODULE: ../node_modules/@sentry/utils/esm/normalize.js





/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normallized output.
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function normalize(input, depth = 100, maxProperties = +Infinity) {
  try {
    // since we're at the outermost level, we don't provide a key
    return visit('', input, depth, maxProperties);
  } catch (err) {
    return { ERROR: `**non-serializable** (${err})` };
  }
}

/** JSDoc */
function normalizeToSize(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  object,
  // Default Node.js REPL depth
  depth = 3,
  // 100kB, as 200kB is max payload size, so half sounds reasonable
  maxSize = 100 * 1024,
) {
  const normalized = normalize(object, depth);

  if (jsonSize(normalized) > maxSize) {
    return normalizeToSize(object, depth - 1, maxSize);
  }

  return normalized ;
}

/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */
function visit(
  key,
  value,
  depth = +Infinity,
  maxProperties = +Infinity,
  memo = memoBuilder(),
) {
  const [memoize, unmemoize] = memo;

  // Get the simple cases out of the way first
  if (
    value == null || // this matches null and undefined -> eqeq not eqeqeq
    (['number', 'boolean', 'string'].includes(typeof value) && !(0,is/* isNaN */.i2)(value))
  ) {
    return value ;
  }

  const stringified = stringifyValue(key, value);

  // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
  // Everything else will have already been serialized, so if we don't see that pattern, we're done.
  if (!stringified.startsWith('[object ')) {
    return stringified;
  }

  // From here on, we can assert that `value` is either an object or an array.

  // Do not normalize objects that we know have already been normalized. As a general rule, the
  // "__sentry_skip_normalization__" property should only be used sparingly and only should only be set on objects that
  // have already been normalized.
  if ((value )['__sentry_skip_normalization__']) {
    return value ;
  }

  // We can set `__sentry_override_normalization_depth__` on an object to ensure that from there
  // We keep a certain amount of depth.
  // This should be used sparingly, e.g. we use it for the redux integration to ensure we get a certain amount of state.
  const remainingDepth =
    typeof (value )['__sentry_override_normalization_depth__'] === 'number'
      ? ((value )['__sentry_override_normalization_depth__'] )
      : depth;

  // We're also done if we've reached the max depth
  if (remainingDepth === 0) {
    // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace('object ', '');
  }

  // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
  if (memoize(value)) {
    return '[Circular ~]';
  }

  // If the value has a `toJSON` method, we call it to extract more information
  const valueWithToJSON = value ;
  if (valueWithToJSON && typeof valueWithToJSON.toJSON === 'function') {
    try {
      const jsonValue = valueWithToJSON.toJSON();
      // We need to normalize the return value of `.toJSON()` in case it has circular references
      return visit('', jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch (err) {
      // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
  }

  // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
  // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
  // property/entry, and keep track of the number of items we add to it.
  const normalized = (Array.isArray(value) ? [] : {}) ;
  let numAdded = 0;

  // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
  // properties are non-enumerable and otherwise would get missed.
  const visitable = (0,object/* convertToPlainObject */.Sh)(value );

  for (const visitKey in visitable) {
    // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
    if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) {
      continue;
    }

    if (numAdded >= maxProperties) {
      normalized[visitKey] = '[MaxProperties ~]';
      break;
    }

    // Recursively visit all the child nodes
    const visitValue = visitable[visitKey];
    normalized[visitKey] = visit(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);

    numAdded++;
  }

  // Once we've visited all the branches, remove the parent from memo storage
  unmemoize(value);

  // Return accumulated values
  return normalized;
}

/* eslint-disable complexity */
/**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */
function stringifyValue(
  key,
  // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
  // our internal use, it'll do
  value,
) {
  try {
    if (key === 'domain' && value && typeof value === 'object' && (value )._events) {
      return '[Domain]';
    }

    if (key === 'domainEmitter') {
      return '[DomainEmitter]';
    }

    // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
    // which won't throw if they are not present.

    if (typeof __webpack_require__.g !== 'undefined' && value === __webpack_require__.g) {
      return '[Global]';
    }

    // eslint-disable-next-line no-restricted-globals
    if (typeof window !== 'undefined' && value === window) {
      return '[Window]';
    }

    // eslint-disable-next-line no-restricted-globals
    if (typeof document !== 'undefined' && value === document) {
      return '[Document]';
    }

    // React's SyntheticEvent thingy
    if ((0,is/* isSyntheticEvent */.Cy)(value)) {
      return '[SyntheticEvent]';
    }

    if (typeof value === 'number' && value !== value) {
      return '[NaN]';
    }

    if (typeof value === 'function') {
      return `[Function: ${(0,stacktrace/* getFunctionName */.$P)(value)}]`;
    }

    if (typeof value === 'symbol') {
      return `[${String(value)}]`;
    }

    // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
    if (typeof value === 'bigint') {
      return `[BigInt: ${String(value)}]`;
    }

    // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
    // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
    // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
    // we can make sure that only plain objects come out that way.
    const objName = getConstructorName(value);

    // Handle HTML Elements
    if (/^HTML(\w*)Element$/.test(objName)) {
      return `[HTMLElement: ${objName}]`;
    }

    return `[object ${objName}]`;
  } catch (err) {
    return `**non-serializable** (${err})`;
  }
}
/* eslint-enable complexity */

function getConstructorName(value) {
  const prototype = Object.getPrototypeOf(value);

  return prototype ? prototype.constructor.name : 'null prototype';
}

/** Calculates bytes size of input string */
function utf8Length(value) {
  // eslint-disable-next-line no-bitwise
  return ~-encodeURI(value).split(/%..|./).length;
}

/** Calculates bytes size of input object */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function jsonSize(value) {
  return utf8Length(JSON.stringify(value));
}


//# sourceMappingURL=normalize.js.map


/***/ }),

/***/ 39109:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$Q": function() { return /* binding */ markFunctionWrapped; },
/* harmony export */   "HK": function() { return /* binding */ getOriginalFunction; },
/* harmony export */   "Jr": function() { return /* binding */ dropUndefinedKeys; },
/* harmony export */   "Sh": function() { return /* binding */ convertToPlainObject; },
/* harmony export */   "_j": function() { return /* binding */ urlEncode; },
/* harmony export */   "hl": function() { return /* binding */ fill; },
/* harmony export */   "xp": function() { return /* binding */ addNonEnumerableProperty; },
/* harmony export */   "zf": function() { return /* binding */ extractExceptionKeysForMessage; }
/* harmony export */ });
/* unused harmony export objectify */
/* harmony import */ var _browser_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61495);
/* harmony import */ var _is_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66885);
/* harmony import */ var _string_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65268);




/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */
function fill(source, name, replacementFactory) {
  if (!(name in source)) {
    return;
  }

  const original = source[name] ;
  const wrapped = replacementFactory(original) ;

  // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
  // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
  if (typeof wrapped === 'function') {
    try {
      markFunctionWrapped(wrapped, original);
    } catch (_Oo) {
      // This can throw if multiple fill happens on a global object like XMLHttpRequest
      // Fixes https://github.com/getsentry/sentry-javascript/issues/2043
    }
  }

  source[name] = wrapped;
}

/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */
function addNonEnumerableProperty(obj, name, value) {
  Object.defineProperty(obj, name, {
    // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
    value: value,
    writable: true,
    configurable: true,
  });
}

/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */
function markFunctionWrapped(wrapped, original) {
  const proto = original.prototype || {};
  wrapped.prototype = original.prototype = proto;
  addNonEnumerableProperty(wrapped, '__sentry_original__', original);
}

/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */
function getOriginalFunction(func) {
  return func.__sentry_original__;
}

/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 */
function urlEncode(object) {
  return Object.keys(object)
    .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(object[key])}`)
    .join('&');
}

/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argurment itself, when value is neither an Event nor
 *  an Error.
 */
function convertToPlainObject(value)

 {
  if ((0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isError */ .VZ)(value)) {
    return {
      message: value.message,
      name: value.name,
      stack: value.stack,
      ...getOwnProperties(value),
    };
  } else if ((0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isEvent */ .cO)(value)) {
    const newObj

 = {
      type: value.type,
      target: serializeEventTarget(value.target),
      currentTarget: serializeEventTarget(value.currentTarget),
      ...getOwnProperties(value),
    };

    if (typeof CustomEvent !== 'undefined' && (0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isInstanceOf */ .V9)(value, CustomEvent)) {
      newObj.detail = value.detail;
    }

    return newObj;
  } else {
    return value;
  }
}

/** Creates a string representation of the target of an `Event` object */
function serializeEventTarget(target) {
  try {
    return (0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isElement */ .kK)(target) ? (0,_browser_js__WEBPACK_IMPORTED_MODULE_1__/* .htmlTreeAsString */ .Rt)(target) : Object.prototype.toString.call(target);
  } catch (_oO) {
    return '<unknown>';
  }
}

/** Filters out all but an object's own properties */
function getOwnProperties(obj) {
  if (typeof obj === 'object' && obj !== null) {
    const extractedProps = {};
    for (const property in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, property)) {
        extractedProps[property] = (obj )[property];
      }
    }
    return extractedProps;
  } else {
    return {};
  }
}

/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */
function extractExceptionKeysForMessage(exception, maxLength = 40) {
  const keys = Object.keys(convertToPlainObject(exception));
  keys.sort();

  if (!keys.length) {
    return '[object has no keys]';
  }

  if (keys[0].length >= maxLength) {
    return (0,_string_js__WEBPACK_IMPORTED_MODULE_2__/* .truncate */ .$G)(keys[0], maxLength);
  }

  for (let includedKeys = keys.length; includedKeys > 0; includedKeys--) {
    const serialized = keys.slice(0, includedKeys).join(', ');
    if (serialized.length > maxLength) {
      continue;
    }
    if (includedKeys === keys.length) {
      return serialized;
    }
    return (0,_string_js__WEBPACK_IMPORTED_MODULE_2__/* .truncate */ .$G)(serialized, maxLength);
  }

  return '';
}

/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 */
function dropUndefinedKeys(inputValue) {
  // This map keeps track of what already visited nodes map to.
  // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
  // references as the input object.
  const memoizationMap = new Map();

  // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
  return _dropUndefinedKeys(inputValue, memoizationMap);
}

function _dropUndefinedKeys(inputValue, memoizationMap) {
  if ((0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isPlainObject */ .PO)(inputValue)) {
    // If this node has already been visited due to a circular reference, return the object it was mapped to in the new object
    const memoVal = memoizationMap.get(inputValue);
    if (memoVal !== undefined) {
      return memoVal ;
    }

    const returnValue = {};
    // Store the mapping of this value in case we visit it again, in case of circular data
    memoizationMap.set(inputValue, returnValue);

    for (const key of Object.keys(inputValue)) {
      if (typeof inputValue[key] !== 'undefined') {
        returnValue[key] = _dropUndefinedKeys(inputValue[key], memoizationMap);
      }
    }

    return returnValue ;
  }

  if (Array.isArray(inputValue)) {
    // If this node has already been visited due to a circular reference, return the array it was mapped to in the new object
    const memoVal = memoizationMap.get(inputValue);
    if (memoVal !== undefined) {
      return memoVal ;
    }

    const returnValue = [];
    // Store the mapping of this value in case we visit it again, in case of circular data
    memoizationMap.set(inputValue, returnValue);

    inputValue.forEach((item) => {
      returnValue.push(_dropUndefinedKeys(item, memoizationMap));
    });

    return returnValue ;
  }

  return inputValue;
}

/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */
function objectify(wat) {
  let objectified;
  switch (true) {
    case wat === undefined || wat === null:
      objectified = new String(wat);
      break;

    // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
    // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
    // an object in order to wrap it.
    case typeof wat === 'symbol' || typeof wat === 'bigint':
      objectified = Object(wat);
      break;

    // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
    case isPrimitive(wat):
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      objectified = new (wat ).constructor(wat);
      break;

    // by process of elimination, at this point we know that `wat` must already be an object
    default:
      objectified = wat;
      break;
  }
  return objectified;
}


//# sourceMappingURL=object.js.map


/***/ }),

/***/ 34006:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "JY": function() { return /* binding */ parseRetryAfterHeader; },
/* harmony export */   "Q": function() { return /* binding */ isRateLimited; },
/* harmony export */   "WG": function() { return /* binding */ updateRateLimits; }
/* harmony export */ });
/* unused harmony exports DEFAULT_RETRY_AFTER, disabledUntil */
// Intentionally keeping the key broad, as we don't know for sure what rate limit headers get returned from backend

const DEFAULT_RETRY_AFTER = 60 * 1000; // 60 seconds

/**
 * Extracts Retry-After value from the request header or returns default value
 * @param header string representation of 'Retry-After' header
 * @param now current unix timestamp
 *
 */
function parseRetryAfterHeader(header, now = Date.now()) {
  const headerDelay = parseInt(`${header}`, 10);
  if (!isNaN(headerDelay)) {
    return headerDelay * 1000;
  }

  const headerDate = Date.parse(`${header}`);
  if (!isNaN(headerDate)) {
    return headerDate - now;
  }

  return DEFAULT_RETRY_AFTER;
}

/**
 * Gets the time that the given category is disabled until for rate limiting.
 * In case no category-specific limit is set but a general rate limit across all categories is active,
 * that time is returned.
 *
 * @return the time in ms that the category is disabled until or 0 if there's no active rate limit.
 */
function disabledUntil(limits, category) {
  return limits[category] || limits.all || 0;
}

/**
 * Checks if a category is rate limited
 */
function isRateLimited(limits, category, now = Date.now()) {
  return disabledUntil(limits, category) > now;
}

/**
 * Update ratelimits from incoming headers.
 *
 * @return the updated RateLimits object.
 */
function updateRateLimits(
  limits,
  { statusCode, headers },
  now = Date.now(),
) {
  const updatedRateLimits = {
    ...limits,
  };

  // "The name is case-insensitive."
  // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
  const rateLimitHeader = headers && headers['x-sentry-rate-limits'];
  const retryAfterHeader = headers && headers['retry-after'];

  if (rateLimitHeader) {
    /**
     * rate limit headers are of the form
     *     <header>,<header>,..
     * where each <header> is of the form
     *     <retry_after>: <categories>: <scope>: <reason_code>
     * where
     *     <retry_after> is a delay in seconds
     *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
     *         <category>;<category>;...
     *     <scope> is what's being limited (org, project, or key) - ignored by SDK
     *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
     */
    for (const limit of rateLimitHeader.trim().split(',')) {
      const [retryAfter, categories] = limit.split(':', 2);
      const headerDelay = parseInt(retryAfter, 10);
      const delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
      if (!categories) {
        updatedRateLimits.all = now + delay;
      } else {
        for (const category of categories.split(';')) {
          updatedRateLimits[category] = now + delay;
        }
      }
    }
  } else if (retryAfterHeader) {
    updatedRateLimits.all = now + parseRetryAfterHeader(retryAfterHeader, now);
  } else if (statusCode === 429) {
    updatedRateLimits.all = now + 60 * 1000;
  }

  return updatedRateLimits;
}


//# sourceMappingURL=ratelimit.js.map


/***/ }),

/***/ 55514:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$P": function() { return /* binding */ getFunctionName; },
/* harmony export */   "Sq": function() { return /* binding */ stackParserFromStackParserOptions; },
/* harmony export */   "pE": function() { return /* binding */ createStackParser; }
/* harmony export */ });
/* unused harmony exports nodeStackLineParser, stripSentryFramesAndReverse */


const STACKTRACE_FRAME_LIMIT = 50;
// Used to sanitize webpack (error: *) wrapped stack errors
const WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;

/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */
function createStackParser(...parsers) {
  const sortedParsers = parsers.sort((a, b) => a[0] - b[0]).map(p => p[1]);

  return (stack, skipFirst = 0) => {
    const frames = [];
    const lines = stack.split('\n');

    for (let i = skipFirst; i < lines.length; i++) {
      const line = lines[i];
      // Ignore lines over 1kb as they are unlikely to be stack frames.
      // Many of the regular expressions use backtracking which results in run time that increases exponentially with
      // input size. Huge strings can result in hangs/Denial of Service:
      // https://github.com/getsentry/sentry-javascript/issues/2286
      if (line.length > 1024) {
        continue;
      }

      // https://github.com/getsentry/sentry-javascript/issues/5459
      // Remove webpack (error: *) wrappers
      const cleanedLine = WEBPACK_ERROR_REGEXP.test(line) ? line.replace(WEBPACK_ERROR_REGEXP, '$1') : line;

      // https://github.com/getsentry/sentry-javascript/issues/7813
      // Skip Error: lines
      if (cleanedLine.match(/\S*Error: /)) {
        continue;
      }

      for (const parser of sortedParsers) {
        const frame = parser(cleanedLine);

        if (frame) {
          frames.push(frame);
          break;
        }
      }

      if (frames.length >= STACKTRACE_FRAME_LIMIT) {
        break;
      }
    }

    return stripSentryFramesAndReverse(frames);
  };
}

/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */
function stackParserFromStackParserOptions(stackParser) {
  if (Array.isArray(stackParser)) {
    return createStackParser(...stackParser);
  }
  return stackParser;
}

/**
 * Removes Sentry frames from the top and bottom of the stack if present and enforces a limit of max number of frames.
 * Assumes stack input is ordered from top to bottom and returns the reverse representation so call site of the
 * function that caused the crash is the last frame in the array.
 * @hidden
 */
function stripSentryFramesAndReverse(stack) {
  if (!stack.length) {
    return [];
  }

  const localStack = stack.slice(0, STACKTRACE_FRAME_LIMIT);

  const lastFrameFunction = localStack[localStack.length - 1].function;
  // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
  if (lastFrameFunction && /sentryWrapped/.test(lastFrameFunction)) {
    localStack.pop();
  }

  // Reversing in the middle of the procedure allows us to just pop the values off the stack
  localStack.reverse();

  const firstFrameFunction = localStack[localStack.length - 1].function;
  // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
  if (firstFrameFunction && /captureMessage|captureException/.test(firstFrameFunction)) {
    localStack.pop();
  }

  return localStack.map(frame => ({
    ...frame,
    filename: frame.filename || localStack[localStack.length - 1].filename,
    function: frame.function || '?',
  }));
}

const defaultFunctionName = '<anonymous>';

/**
 * Safely extract function name from itself
 */
function getFunctionName(fn) {
  try {
    if (!fn || typeof fn !== 'function') {
      return defaultFunctionName;
    }
    return fn.name || defaultFunctionName;
  } catch (e) {
    // Just accessing custom props in some Selenium environments
    // can cause a "Permission denied" exception (see raven-js#495).
    return defaultFunctionName;
  }
}

/**
 * Node.js stack line parser
 *
 * This is in @sentry/utils so it can be used from the Electron SDK in the browser for when `nodeIntegration == true`.
 * This allows it to be used without referencing or importing any node specific code which causes bundlers to complain
 */
function nodeStackLineParser(getModule) {
  return [90, node(getModule)];
}


//# sourceMappingURL=stacktrace.js.map


/***/ }),

/***/ 65268:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$G": function() { return /* binding */ truncate; },
/* harmony export */   "U0": function() { return /* binding */ stringMatchesSomePattern; },
/* harmony export */   "nK": function() { return /* binding */ safeJoin; }
/* harmony export */ });
/* unused harmony exports isMatchingPattern, snipLine */
/* harmony import */ var _is_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66885);


/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */
function truncate(str, max = 0) {
  if (typeof str !== 'string' || max === 0) {
    return str;
  }
  return str.length <= max ? str : `${str.slice(0, max)}...`;
}

/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */
function snipLine(line, colno) {
  let newLine = line;
  const lineLength = newLine.length;
  if (lineLength <= 150) {
    return newLine;
  }
  if (colno > lineLength) {
    // eslint-disable-next-line no-param-reassign
    colno = lineLength;
  }

  let start = Math.max(colno - 60, 0);
  if (start < 5) {
    start = 0;
  }

  let end = Math.min(start + 140, lineLength);
  if (end > lineLength - 5) {
    end = lineLength;
  }
  if (end === lineLength) {
    start = Math.max(end - 140, 0);
  }

  newLine = newLine.slice(start, end);
  if (start > 0) {
    newLine = `'{snip} ${newLine}`;
  }
  if (end < lineLength) {
    newLine += ' {snip}';
  }

  return newLine;
}

/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function safeJoin(input, delimiter) {
  if (!Array.isArray(input)) {
    return '';
  }

  const output = [];
  // eslint-disable-next-line @typescript-eslint/prefer-for-of
  for (let i = 0; i < input.length; i++) {
    const value = input[i];
    try {
      output.push(String(value));
    } catch (e) {
      output.push('[value cannot be serialized]');
    }
  }

  return output.join(delimiter);
}

/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */
function isMatchingPattern(
  value,
  pattern,
  requireExactStringMatch = false,
) {
  if (!(0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isString */ .HD)(value)) {
    return false;
  }

  if ((0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isRegExp */ .Kj)(pattern)) {
    return pattern.test(value);
  }
  if ((0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isString */ .HD)(pattern)) {
    return requireExactStringMatch ? value === pattern : value.includes(pattern);
  }

  return false;
}

/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */
function stringMatchesSomePattern(
  testString,
  patterns = [],
  requireExactStringMatch = false,
) {
  return patterns.some(pattern => isMatchingPattern(testString, pattern, requireExactStringMatch));
}


//# sourceMappingURL=string.js.map


/***/ }),

/***/ 83589:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ak": function() { return /* binding */ supportsFetch; },
/* harmony export */   "Du": function() { return /* binding */ isNativeFetch; },
/* harmony export */   "t$": function() { return /* binding */ supportsNativeFetch; }
/* harmony export */ });
/* unused harmony exports supportsDOMError, supportsDOMException, supportsErrorEvent, supportsReferrerPolicy, supportsReportingObserver */
/* harmony import */ var _logger_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86922);
/* harmony import */ var _worldwide_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74211);



// eslint-disable-next-line deprecation/deprecation
const WINDOW = (0,_worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .Rf)();

/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */
function supportsErrorEvent() {
  try {
    new ErrorEvent('');
    return true;
  } catch (e) {
    return false;
  }
}

/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */
function supportsDOMError() {
  try {
    // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
    // 1 argument required, but only 0 present.
    // @ts-ignore It really needs 1 argument, not 0.
    new DOMError('');
    return true;
  } catch (e) {
    return false;
  }
}

/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */
function supportsDOMException() {
  try {
    new DOMException('');
    return true;
  } catch (e) {
    return false;
  }
}

/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */
function supportsFetch() {
  if (!('fetch' in WINDOW)) {
    return false;
  }

  try {
    new Headers();
    new Request('http://www.example.com');
    new Response();
    return true;
  } catch (e) {
    return false;
  }
}
/**
 * isNativeFetch checks if the given function is a native implementation of fetch()
 */
// eslint-disable-next-line @typescript-eslint/ban-types
function isNativeFetch(func) {
  return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}

/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */
function supportsNativeFetch() {
  if (!supportsFetch()) {
    return false;
  }

  // Fast path to avoid DOM I/O
  // eslint-disable-next-line @typescript-eslint/unbound-method
  if (isNativeFetch(WINDOW.fetch)) {
    return true;
  }

  // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
  // so create a "pure" iframe to see if that has native fetch
  let result = false;
  const doc = WINDOW.document;
  // eslint-disable-next-line deprecation/deprecation
  if (doc && typeof (doc.createElement ) === 'function') {
    try {
      const sandbox = doc.createElement('iframe');
      sandbox.hidden = true;
      doc.head.appendChild(sandbox);
      if (sandbox.contentWindow && sandbox.contentWindow.fetch) {
        // eslint-disable-next-line @typescript-eslint/unbound-method
        result = isNativeFetch(sandbox.contentWindow.fetch);
      }
      doc.head.removeChild(sandbox);
    } catch (err) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        _logger_js__WEBPACK_IMPORTED_MODULE_1__/* .logger.warn */ .kg.warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
    }
  }

  return result;
}

/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */
function supportsReportingObserver() {
  return 'ReportingObserver' in WINDOW;
}

/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */
function supportsReferrerPolicy() {
  // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
  // (see https://caniuse.com/#feat=referrer-policy),
  // it doesn't. And it throws an exception instead of ignoring this parameter...
  // REF: https://github.com/getsentry/raven-js/issues/1233

  if (!supportsFetch()) {
    return false;
  }

  try {
    new Request('_', {
      referrerPolicy: 'origin' ,
    });
    return true;
  } catch (e) {
    return false;
  }
}


//# sourceMappingURL=supports.js.map


/***/ }),

/***/ 48894:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$2": function() { return /* binding */ rejectedSyncPromise; },
/* harmony export */   "WD": function() { return /* binding */ resolvedSyncPromise; },
/* harmony export */   "cW": function() { return /* binding */ SyncPromise; }
/* harmony export */ });
/* harmony import */ var _is_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66885);


/* eslint-disable @typescript-eslint/explicit-function-return-type */

/** SyncPromise internal states */
var States; (function (States) {
  /** Pending */
  const PENDING = 0; States[States["PENDING"] = PENDING] = "PENDING";
  /** Resolved / OK */
  const RESOLVED = 1; States[States["RESOLVED"] = RESOLVED] = "RESOLVED";
  /** Rejected / Error */
  const REJECTED = 2; States[States["REJECTED"] = REJECTED] = "REJECTED";
})(States || (States = {}));

// Overloads so we can call resolvedSyncPromise without arguments and generic argument

/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */
function resolvedSyncPromise(value) {
  return new SyncPromise(resolve => {
    resolve(value);
  });
}

/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */
function rejectedSyncPromise(reason) {
  return new SyncPromise((_, reject) => {
    reject(reason);
  });
}

/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */
class SyncPromise {
   __init() {this._state = States.PENDING;}
   __init2() {this._handlers = [];}

   constructor(
    executor,
  ) {SyncPromise.prototype.__init.call(this);SyncPromise.prototype.__init2.call(this);SyncPromise.prototype.__init3.call(this);SyncPromise.prototype.__init4.call(this);SyncPromise.prototype.__init5.call(this);SyncPromise.prototype.__init6.call(this);
    try {
      executor(this._resolve, this._reject);
    } catch (e) {
      this._reject(e);
    }
  }

  /** JSDoc */
   then(
    onfulfilled,
    onrejected,
  ) {
    return new SyncPromise((resolve, reject) => {
      this._handlers.push([
        false,
        result => {
          if (!onfulfilled) {
            // TODO: ¯\_(ツ)_/¯
            // TODO: FIXME
            resolve(result );
          } else {
            try {
              resolve(onfulfilled(result));
            } catch (e) {
              reject(e);
            }
          }
        },
        reason => {
          if (!onrejected) {
            reject(reason);
          } else {
            try {
              resolve(onrejected(reason));
            } catch (e) {
              reject(e);
            }
          }
        },
      ]);
      this._executeHandlers();
    });
  }

  /** JSDoc */
   catch(
    onrejected,
  ) {
    return this.then(val => val, onrejected);
  }

  /** JSDoc */
   finally(onfinally) {
    return new SyncPromise((resolve, reject) => {
      let val;
      let isRejected;

      return this.then(
        value => {
          isRejected = false;
          val = value;
          if (onfinally) {
            onfinally();
          }
        },
        reason => {
          isRejected = true;
          val = reason;
          if (onfinally) {
            onfinally();
          }
        },
      ).then(() => {
        if (isRejected) {
          reject(val);
          return;
        }

        resolve(val );
      });
    });
  }

  /** JSDoc */
    __init3() {this._resolve = (value) => {
    this._setResult(States.RESOLVED, value);
  };}

  /** JSDoc */
    __init4() {this._reject = (reason) => {
    this._setResult(States.REJECTED, reason);
  };}

  /** JSDoc */
    __init5() {this._setResult = (state, value) => {
    if (this._state !== States.PENDING) {
      return;
    }

    if ((0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isThenable */ .J8)(value)) {
      void (value ).then(this._resolve, this._reject);
      return;
    }

    this._state = state;
    this._value = value;

    this._executeHandlers();
  };}

  /** JSDoc */
    __init6() {this._executeHandlers = () => {
    if (this._state === States.PENDING) {
      return;
    }

    const cachedHandlers = this._handlers.slice();
    this._handlers = [];

    cachedHandlers.forEach(handler => {
      if (handler[0]) {
        return;
      }

      if (this._state === States.RESOLVED) {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        handler[1](this._value );
      }

      if (this._state === States.REJECTED) {
        handler[2](this._value);
      }

      handler[0] = true;
    });
  };}
}


//# sourceMappingURL=syncpromise.js.map


/***/ }),

/***/ 94180:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z1": function() { return /* binding */ browserPerformanceTimeOrigin; },
/* harmony export */   "ph": function() { return /* binding */ timestampInSeconds; },
/* harmony export */   "yW": function() { return /* binding */ dateTimestampInSeconds; }
/* harmony export */ });
/* unused harmony exports _browserPerformanceTimeOriginMode, timestampWithMs, usingPerformanceAPI */
/* harmony import */ var _node_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5728);
/* harmony import */ var _worldwide_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74211);
/* module decorator */ module = __webpack_require__.hmd(module);



// eslint-disable-next-line deprecation/deprecation
const WINDOW = (0,_worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .Rf)();

/**
 * An object that can return the current timestamp in seconds since the UNIX epoch.
 */

/**
 * A TimestampSource implementation for environments that do not support the Performance Web API natively.
 *
 * Note that this TimestampSource does not use a monotonic clock. A call to `nowSeconds` may return a timestamp earlier
 * than a previously returned value. We do not try to emulate a monotonic behavior in order to facilitate debugging. It
 * is more obvious to explain "why does my span have negative duration" than "why my spans have zero duration".
 */
const dateTimestampSource = {
  nowSeconds: () => Date.now() / 1000,
};

/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */

/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */
function getBrowserPerformance() {
  const { performance } = WINDOW;
  if (!performance || !performance.now) {
    return undefined;
  }

  // Replace performance.timeOrigin with our own timeOrigin based on Date.now().
  //
  // This is a partial workaround for browsers reporting performance.timeOrigin such that performance.timeOrigin +
  // performance.now() gives a date arbitrarily in the past.
  //
  // Additionally, computing timeOrigin in this way fills the gap for browsers where performance.timeOrigin is
  // undefined.
  //
  // The assumption that performance.timeOrigin + performance.now() ~= Date.now() is flawed, but we depend on it to
  // interact with data coming out of performance entries.
  //
  // Note that despite recommendations against it in the spec, browsers implement the Performance API with a clock that
  // might stop when the computer is asleep (and perhaps under other circumstances). Such behavior causes
  // performance.timeOrigin + performance.now() to have an arbitrary skew over Date.now(). In laptop computers, we have
  // observed skews that can be as long as days, weeks or months.
  //
  // See https://github.com/getsentry/sentry-javascript/issues/2590.
  //
  // BUG: despite our best intentions, this workaround has its limitations. It mostly addresses timings of pageload
  // transactions, but ignores the skew built up over time that can aversely affect timestamps of navigation
  // transactions of long-lived web pages.
  const timeOrigin = Date.now() - performance.now();

  return {
    now: () => performance.now(),
    timeOrigin,
  };
}

/**
 * Returns the native Performance API implementation from Node.js. Returns undefined in old Node.js versions that don't
 * implement the API.
 */
function getNodePerformance() {
  try {
    const perfHooks = (0,_node_js__WEBPACK_IMPORTED_MODULE_1__/* .dynamicRequire */ .l$)(module, 'perf_hooks') ;
    return perfHooks.performance;
  } catch (_) {
    return undefined;
  }
}

/**
 * The Performance API implementation for the current platform, if available.
 */
const platformPerformance = (0,_node_js__WEBPACK_IMPORTED_MODULE_1__/* .isNodeEnv */ .KV)() ? getNodePerformance() : getBrowserPerformance();

const timestampSource =
  platformPerformance === undefined
    ? dateTimestampSource
    : {
        nowSeconds: () => (platformPerformance.timeOrigin + platformPerformance.now()) / 1000,
      };

/**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 */
const dateTimestampInSeconds = dateTimestampSource.nowSeconds.bind(dateTimestampSource);

/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * See `usingPerformanceAPI` to test whether the Performance API is used.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */
const timestampInSeconds = timestampSource.nowSeconds.bind(timestampSource);

/**
 * Re-exported with an old name for backwards-compatibility.
 * TODO (v8): Remove this
 *
 * @deprecated Use `timestampInSeconds` instead.
 */
const timestampWithMs = (/* unused pure expression or super */ null && (timestampInSeconds));

/**
 * A boolean that is true when timestampInSeconds uses the Performance API to produce monotonic timestamps.
 */
const usingPerformanceAPI = platformPerformance !== undefined;

/**
 * Internal helper to store what is the source of browserPerformanceTimeOrigin below. For debugging only.
 */
let _browserPerformanceTimeOriginMode;

/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */
const browserPerformanceTimeOrigin = (() => {
  // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
  // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
  // data as reliable if they are within a reasonable threshold of the current time.

  const { performance } = WINDOW;
  if (!performance || !performance.now) {
    _browserPerformanceTimeOriginMode = 'none';
    return undefined;
  }

  const threshold = 3600 * 1000;
  const performanceNow = performance.now();
  const dateNow = Date.now();

  // if timeOrigin isn't available set delta to threshold so it isn't used
  const timeOriginDelta = performance.timeOrigin
    ? Math.abs(performance.timeOrigin + performanceNow - dateNow)
    : threshold;
  const timeOriginIsReliable = timeOriginDelta < threshold;

  // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
  // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
  // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
  // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
  // Date API.
  // eslint-disable-next-line deprecation/deprecation
  const navigationStart = performance.timing && performance.timing.navigationStart;
  const hasNavigationStart = typeof navigationStart === 'number';
  // if navigationStart isn't available set delta to threshold so it isn't used
  const navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
  const navigationStartIsReliable = navigationStartDelta < threshold;

  if (timeOriginIsReliable || navigationStartIsReliable) {
    // Use the more reliable time origin
    if (timeOriginDelta <= navigationStartDelta) {
      _browserPerformanceTimeOriginMode = 'timeOrigin';
      return performance.timeOrigin;
    } else {
      _browserPerformanceTimeOriginMode = 'navigationStart';
      return navigationStart;
    }
  }

  // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
  _browserPerformanceTimeOriginMode = 'dateNow';
  return dateNow;
})();


//# sourceMappingURL=time.js.map


/***/ }),

/***/ 94678:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$A": function() { return /* binding */ getNumberOfUrlSegments; },
/* harmony export */   "en": function() { return /* binding */ parseUrl; },
/* harmony export */   "rt": function() { return /* binding */ stripUrlQueryAndFragment; }
/* harmony export */ });
/* unused harmony export getSanitizedUrlString */
/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */
function parseUrl(url) {
  if (!url) {
    return {};
  }

  const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);

  if (!match) {
    return {};
  }

  // coerce to undefined values to empty string so we don't get 'undefined'
  const query = match[6] || '';
  const fragment = match[8] || '';
  return {
    host: match[4],
    path: match[5],
    protocol: match[2],
    search: query,
    hash: fragment,
    relative: match[5] + query + fragment, // everything minus origin
  };
}

/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */
function stripUrlQueryAndFragment(urlPath) {
  // eslint-disable-next-line no-useless-escape
  return urlPath.split(/[\?#]/, 1)[0];
}

/**
 * Returns number of URL segments of a passed string URL.
 */
function getNumberOfUrlSegments(url) {
  // split at '/' or at '\/' to split regex urls correctly
  return url.split(/\\?\//).filter(s => s.length > 0 && s !== ',').length;
}

/**
 * Takes a URL object and returns a sanitized string which is safe to use as span description
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */
function getSanitizedUrlString(url) {
  const { protocol, host, path } = url;

  const filteredHost =
    (host &&
      host
        // Always filter out authority
        .replace(/^.*@/, '[filtered]:[filtered]@')
        // Don't show standard :80 (http) and :443 (https) ports to reduce the noise
        .replace(':80', '')
        .replace(':443', '')) ||
    '';

  return `${protocol ? `${protocol}://` : ''}${filteredHost}${path}`;
}


//# sourceMappingURL=url.js.map


/***/ }),

/***/ 74211:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Rf": function() { return /* binding */ getGlobalObject; },
/* harmony export */   "YO": function() { return /* binding */ getGlobalSingleton; },
/* harmony export */   "n2": function() { return /* binding */ GLOBAL_OBJ; }
/* harmony export */ });
/** Internal global with common properties and Sentry extensions  */

// The code below for 'isGlobalObj' and 'GLOBAL_OBJ' was copied from core-js before modification
// https://github.com/zloirock/core-js/blob/1b944df55282cdc99c90db5f49eb0b6eda2cc0a3/packages/core-js/internals/global.js
// core-js has the following licence:
//
// Copyright (c) 2014-2022 Denis Pushkarev
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

/** Returns 'obj' if it's the global object, otherwise returns undefined */
function isGlobalObj(obj) {
  return obj && obj.Math == Math ? obj : undefined;
}

/** Get's the global object for the current JavaScript runtime */
const GLOBAL_OBJ =
  (typeof globalThis == 'object' && isGlobalObj(globalThis)) ||
  // eslint-disable-next-line no-restricted-globals
  (typeof window == 'object' && isGlobalObj(window)) ||
  (typeof self == 'object' && isGlobalObj(self)) ||
  (typeof __webpack_require__.g == 'object' && isGlobalObj(__webpack_require__.g)) ||
  (function () {
    return this;
  })() ||
  {};

/**
 * @deprecated Use GLOBAL_OBJ instead or WINDOW from @sentry/browser. This will be removed in v8
 */
function getGlobalObject() {
  return GLOBAL_OBJ ;
}

/**
 * Returns a global singleton contained in the global `__SENTRY__` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */
function getGlobalSingleton(name, creator, obj) {
  const gbl = (obj || GLOBAL_OBJ) ;
  const __SENTRY__ = (gbl.__SENTRY__ = gbl.__SENTRY__ || {});
  const singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
  return singleton;
}


//# sourceMappingURL=worldwide.js.map


/***/ }),

/***/ 9686:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


// there's 3 implementations written in increasing order of efficiency

// 1 - no Set type is defined
function uniqNoSet(arr) {
	var ret = [];

	for (var i = 0; i < arr.length; i++) {
		if (ret.indexOf(arr[i]) === -1) {
			ret.push(arr[i]);
		}
	}

	return ret;
}

// 2 - a simple Set type is defined
function uniqSet(arr) {
	var seen = new Set();
	return arr.filter(function (el) {
		if (!seen.has(el)) {
			seen.add(el);
			return true;
		}
	});
}

// 3 - a standard Set type is defined and it has a forEach method
function uniqSetWithForEach(arr) {
	var ret = [];

	(new Set(arr)).forEach(function (el) {
		ret.push(el);
	});

	return ret;
}

// V8 currently has a broken implementation
// https://github.com/joyent/node/issues/8449
function doesForEachActuallyWork() {
	var ret = false;

	(new Set([true])).forEach(function (el) {
		ret = el;
	});

	return ret === true;
}

if ('Set' in __webpack_require__.g) {
	if (typeof Set.prototype.forEach === 'function' && doesForEachActuallyWork()) {
		module.exports = uniqSetWithForEach;
	} else {
		module.exports = uniqSet;
	}
} else {
	module.exports = uniqNoSet;
}


/***/ }),

/***/ 24782:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),

/***/ 30816:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(24782)
var ieee754 = __webpack_require__(78898)
var customInspectSymbol =
  (typeof Symbol === 'function' && typeof Symbol['for'] === 'function') // eslint-disable-line dot-notation
    ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
    : null

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

var K_MAX_LENGTH = 0x7fffffff
exports.kMaxLength = K_MAX_LENGTH

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */
Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport()

if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' &&
    typeof console.error === 'function') {
  console.error(
    'This browser lacks typed array (Uint8Array) support which is required by ' +
    '`buffer` v5.x. Use `buffer` v4.x if you require old browser support.'
  )
}

function typedArraySupport () {
  // Can typed array instances can be augmented?
  try {
    var arr = new Uint8Array(1)
    var proto = { foo: function () { return 42 } }
    Object.setPrototypeOf(proto, Uint8Array.prototype)
    Object.setPrototypeOf(arr, proto)
    return arr.foo() === 42
  } catch (e) {
    return false
  }
}

Object.defineProperty(Buffer.prototype, 'parent', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined
    return this.buffer
  }
})

Object.defineProperty(Buffer.prototype, 'offset', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined
    return this.byteOffset
  }
})

function createBuffer (length) {
  if (length > K_MAX_LENGTH) {
    throw new RangeError('The value "' + length + '" is invalid for option "size"')
  }
  // Return an augmented `Uint8Array` instance
  var buf = new Uint8Array(length)
  Object.setPrototypeOf(buf, Buffer.prototype)
  return buf
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new TypeError(
        'The "string" argument must be of type string. Received type number'
      )
    }
    return allocUnsafe(arg)
  }
  return from(arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

function from (value, encodingOrOffset, length) {
  if (typeof value === 'string') {
    return fromString(value, encodingOrOffset)
  }

  if (ArrayBuffer.isView(value)) {
    return fromArrayView(value)
  }

  if (value == null) {
    throw new TypeError(
      'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
      'or Array-like Object. Received type ' + (typeof value)
    )
  }

  if (isInstance(value, ArrayBuffer) ||
      (value && isInstance(value.buffer, ArrayBuffer))) {
    return fromArrayBuffer(value, encodingOrOffset, length)
  }

  if (typeof SharedArrayBuffer !== 'undefined' &&
      (isInstance(value, SharedArrayBuffer) ||
      (value && isInstance(value.buffer, SharedArrayBuffer)))) {
    return fromArrayBuffer(value, encodingOrOffset, length)
  }

  if (typeof value === 'number') {
    throw new TypeError(
      'The "value" argument must not be of type number. Received type number'
    )
  }

  var valueOf = value.valueOf && value.valueOf()
  if (valueOf != null && valueOf !== value) {
    return Buffer.from(valueOf, encodingOrOffset, length)
  }

  var b = fromObject(value)
  if (b) return b

  if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null &&
      typeof value[Symbol.toPrimitive] === 'function') {
    return Buffer.from(
      value[Symbol.toPrimitive]('string'), encodingOrOffset, length
    )
  }

  throw new TypeError(
    'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
    'or Array-like Object. Received type ' + (typeof value)
  )
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(value, encodingOrOffset, length)
}

// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf(Buffer.prototype, Uint8Array.prototype)
Object.setPrototypeOf(Buffer, Uint8Array)

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be of type number')
  } else if (size < 0) {
    throw new RangeError('The value "' + size + '" is invalid for option "size"')
  }
}

function alloc (size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(size).fill(fill, encoding)
      : createBuffer(size).fill(fill)
  }
  return createBuffer(size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(size, fill, encoding)
}

function allocUnsafe (size) {
  assertSize(size)
  return createBuffer(size < 0 ? 0 : checked(size) | 0)
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(size)
}

function fromString (string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('Unknown encoding: ' + encoding)
  }

  var length = byteLength(string, encoding) | 0
  var buf = createBuffer(length)

  var actual = buf.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual)
  }

  return buf
}

function fromArrayLike (array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  var buf = createBuffer(length)
  for (var i = 0; i < length; i += 1) {
    buf[i] = array[i] & 255
  }
  return buf
}

function fromArrayView (arrayView) {
  if (isInstance(arrayView, Uint8Array)) {
    var copy = new Uint8Array(arrayView)
    return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength)
  }
  return fromArrayLike(arrayView)
}

function fromArrayBuffer (array, byteOffset, length) {
  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('"offset" is outside of buffer bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('"length" is outside of buffer bounds')
  }

  var buf
  if (byteOffset === undefined && length === undefined) {
    buf = new Uint8Array(array)
  } else if (length === undefined) {
    buf = new Uint8Array(array, byteOffset)
  } else {
    buf = new Uint8Array(array, byteOffset, length)
  }

  // Return an augmented `Uint8Array` instance
  Object.setPrototypeOf(buf, Buffer.prototype)

  return buf
}

function fromObject (obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    var buf = createBuffer(len)

    if (buf.length === 0) {
      return buf
    }

    obj.copy(buf, 0, 0, len)
    return buf
  }

  if (obj.length !== undefined) {
    if (typeof obj.length !== 'number' || numberIsNaN(obj.length)) {
      return createBuffer(0)
    }
    return fromArrayLike(obj)
  }

  if (obj.type === 'Buffer' && Array.isArray(obj.data)) {
    return fromArrayLike(obj.data)
  }
}

function checked (length) {
  // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= K_MAX_LENGTH) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + K_MAX_LENGTH.toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return b != null && b._isBuffer === true &&
    b !== Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
}

Buffer.compare = function compare (a, b) {
  if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength)
  if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength)
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError(
      'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
    )
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!Array.isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (isInstance(buf, Uint8Array)) {
      if (pos + buf.length > buffer.length) {
        Buffer.from(buf).copy(buffer, pos)
      } else {
        Uint8Array.prototype.set.call(
          buffer,
          buf,
          pos
        )
      }
    } else if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    } else {
      buf.copy(buffer, pos)
    }
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    throw new TypeError(
      'The "string" argument must be one of type string, Buffer, or ArrayBuffer. ' +
      'Received type ' + typeof string
    )
  }

  var len = string.length
  var mustMatch = (arguments.length > 2 && arguments[2] === true)
  if (!mustMatch && len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) {
          return mustMatch ? -1 : utf8ToBytes(string).length // assume utf8
        }
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.toLocaleString = Buffer.prototype.toString

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim()
  if (this.length > max) str += ' ... '
  return '<Buffer ' + str + '>'
}
if (customInspectSymbol) {
  Buffer.prototype[customInspectSymbol] = Buffer.prototype.inspect
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (isInstance(target, Uint8Array)) {
    target = Buffer.from(target, target.offset, target.byteLength)
  }
  if (!Buffer.isBuffer(target)) {
    throw new TypeError(
      'The "target" argument must be one of type Buffer or Uint8Array. ' +
      'Received type ' + (typeof target)
    )
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset // Coerce to Number.
  if (numberIsNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [val], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  var strLen = string.length

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (numberIsNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset >>> 0
    if (isFinite(length)) {
      length = length >>> 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
      case 'latin1':
      case 'binary':
        return asciiWrite(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF)
      ? 4
      : (firstByte > 0xDF)
          ? 3
          : (firstByte > 0xBF)
              ? 2
              : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += hexSliceLookupTable[buf[i]]
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
  for (var i = 0; i < bytes.length - 1; i += 2) {
    res += String.fromCharCode(bytes[i] + (bytes[i + 1] * 256))
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf = this.subarray(start, end)
  // Return an augmented `Uint8Array` instance
  Object.setPrototypeOf(newBuf, Buffer.prototype)

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUintLE =
Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUintBE =
Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUint8 =
Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUint16LE =
Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUint16BE =
Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUint32LE =
Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUint32BE =
Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUintLE =
Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUintBE =
Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUint8 =
Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeUint16LE =
Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  return offset + 2
}

Buffer.prototype.writeUint16BE =
Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  this[offset] = (value >>> 8)
  this[offset + 1] = (value & 0xff)
  return offset + 2
}

Buffer.prototype.writeUint32LE =
Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  this[offset + 3] = (value >>> 24)
  this[offset + 2] = (value >>> 16)
  this[offset + 1] = (value >>> 8)
  this[offset] = (value & 0xff)
  return offset + 4
}

Buffer.prototype.writeUint32BE =
Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  this[offset] = (value >>> 24)
  this[offset + 1] = (value >>> 16)
  this[offset + 2] = (value >>> 8)
  this[offset + 3] = (value & 0xff)
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    var limit = Math.pow(2, (8 * byteLength) - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    var limit = Math.pow(2, (8 * byteLength) - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  this[offset] = (value >>> 8)
  this[offset + 1] = (value & 0xff)
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  this[offset + 2] = (value >>> 16)
  this[offset + 3] = (value >>> 24)
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  this[offset] = (value >>> 24)
  this[offset + 1] = (value >>> 16)
  this[offset + 2] = (value >>> 8)
  this[offset + 3] = (value & 0xff)
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer')
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('Index out of range')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start

  if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') {
    // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end)
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, end),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if ((encoding === 'utf8' && code < 128) ||
          encoding === 'latin1') {
        // Fast path: If `val` fits into a single byte, use that numeric value.
        val = code
      }
    }
  } else if (typeof val === 'number') {
    val = val & 255
  } else if (typeof val === 'boolean') {
    val = Number(val)
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : Buffer.from(val, encoding)
    var len = bytes.length
    if (len === 0) {
      throw new TypeError('The value "' + val +
        '" is invalid for argument "value"')
    }
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node takes equal signs as end of the Base64 encoding
  str = str.split('=')[0]
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = str.trim().replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function isInstance (obj, type) {
  return obj instanceof type ||
    (obj != null && obj.constructor != null && obj.constructor.name != null &&
      obj.constructor.name === type.name)
}
function numberIsNaN (obj) {
  // For IE11 support
  return obj !== obj // eslint-disable-line no-self-compare
}

// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var hexSliceLookupTable = (function () {
  var alphabet = '0123456789abcdef'
  var table = new Array(256)
  for (var i = 0; i < 16; ++i) {
    var i16 = i * 16
    for (var j = 0; j < 16; ++j) {
      table[i16 + j] = alphabet[i] + alphabet[j]
    }
  }
  return table
})()


/***/ }),

/***/ 12737:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(3162);

var callBind = __webpack_require__(34573);

var $indexOf = callBind(GetIntrinsic('String.prototype.indexOf'));

module.exports = function callBoundIntrinsic(name, allowMissing) {
	var intrinsic = GetIntrinsic(name, !!allowMissing);
	if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
		return callBind(intrinsic);
	}
	return intrinsic;
};


/***/ }),

/***/ 34573:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(20132);
var GetIntrinsic = __webpack_require__(3162);

var $apply = GetIntrinsic('%Function.prototype.apply%');
var $call = GetIntrinsic('%Function.prototype.call%');
var $reflectApply = GetIntrinsic('%Reflect.apply%', true) || bind.call($call, $apply);

var $gOPD = GetIntrinsic('%Object.getOwnPropertyDescriptor%', true);
var $defineProperty = GetIntrinsic('%Object.defineProperty%', true);
var $max = GetIntrinsic('%Math.max%');

if ($defineProperty) {
	try {
		$defineProperty({}, 'a', { value: 1 });
	} catch (e) {
		// IE 8 has a broken defineProperty
		$defineProperty = null;
	}
}

module.exports = function callBind(originalFunction) {
	var func = $reflectApply(bind, $call, arguments);
	if ($gOPD && $defineProperty) {
		var desc = $gOPD(func, 'length');
		if (desc.configurable) {
			// original length, plus the receiver, minus any additional arguments (after the receiver)
			$defineProperty(
				func,
				'length',
				{ value: 1 + $max(0, originalFunction.length - (arguments.length - 1)) }
			);
		}
	}
	return func;
};

var applyBind = function applyBind() {
	return $reflectApply(bind, $apply, arguments);
};

if ($defineProperty) {
	$defineProperty(module.exports, 'apply', { value: applyBind });
} else {
	module.exports.apply = applyBind;
}


/***/ }),

/***/ 3162:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var undefined;

var $SyntaxError = SyntaxError;
var $Function = Function;
var $TypeError = TypeError;

// eslint-disable-next-line consistent-return
var getEvalledConstructor = function (expressionSyntax) {
	try {
		return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
	} catch (e) {}
};

var $gOPD = Object.getOwnPropertyDescriptor;
if ($gOPD) {
	try {
		$gOPD({}, '');
	} catch (e) {
		$gOPD = null; // this is IE 8, which has a broken gOPD
	}
}

var throwTypeError = function () {
	throw new $TypeError();
};
var ThrowTypeError = $gOPD
	? (function () {
		try {
			// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
			arguments.callee; // IE 8 does not throw here
			return throwTypeError;
		} catch (calleeThrows) {
			try {
				// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
				return $gOPD(arguments, 'callee').get;
			} catch (gOPDthrows) {
				return throwTypeError;
			}
		}
	}())
	: throwTypeError;

var hasSymbols = __webpack_require__(40679)();

var getProto = Object.getPrototypeOf || function (x) { return x.__proto__; }; // eslint-disable-line no-proto

var needsEval = {};

var TypedArray = typeof Uint8Array === 'undefined' ? undefined : getProto(Uint8Array);

var INTRINSICS = {
	'%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
	'%Array%': Array,
	'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
	'%ArrayIteratorPrototype%': hasSymbols ? getProto([][Symbol.iterator]()) : undefined,
	'%AsyncFromSyncIteratorPrototype%': undefined,
	'%AsyncFunction%': needsEval,
	'%AsyncGenerator%': needsEval,
	'%AsyncGeneratorFunction%': needsEval,
	'%AsyncIteratorPrototype%': needsEval,
	'%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
	'%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
	'%Boolean%': Boolean,
	'%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
	'%Date%': Date,
	'%decodeURI%': decodeURI,
	'%decodeURIComponent%': decodeURIComponent,
	'%encodeURI%': encodeURI,
	'%encodeURIComponent%': encodeURIComponent,
	'%Error%': Error,
	'%eval%': eval, // eslint-disable-line no-eval
	'%EvalError%': EvalError,
	'%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
	'%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
	'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
	'%Function%': $Function,
	'%GeneratorFunction%': needsEval,
	'%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
	'%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
	'%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
	'%isFinite%': isFinite,
	'%isNaN%': isNaN,
	'%IteratorPrototype%': hasSymbols ? getProto(getProto([][Symbol.iterator]())) : undefined,
	'%JSON%': typeof JSON === 'object' ? JSON : undefined,
	'%Map%': typeof Map === 'undefined' ? undefined : Map,
	'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols ? undefined : getProto(new Map()[Symbol.iterator]()),
	'%Math%': Math,
	'%Number%': Number,
	'%Object%': Object,
	'%parseFloat%': parseFloat,
	'%parseInt%': parseInt,
	'%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
	'%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
	'%RangeError%': RangeError,
	'%ReferenceError%': ReferenceError,
	'%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
	'%RegExp%': RegExp,
	'%Set%': typeof Set === 'undefined' ? undefined : Set,
	'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols ? undefined : getProto(new Set()[Symbol.iterator]()),
	'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
	'%String%': String,
	'%StringIteratorPrototype%': hasSymbols ? getProto(''[Symbol.iterator]()) : undefined,
	'%Symbol%': hasSymbols ? Symbol : undefined,
	'%SyntaxError%': $SyntaxError,
	'%ThrowTypeError%': ThrowTypeError,
	'%TypedArray%': TypedArray,
	'%TypeError%': $TypeError,
	'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
	'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
	'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
	'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
	'%URIError%': URIError,
	'%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
	'%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
	'%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet
};

var doEval = function doEval(name) {
	var value;
	if (name === '%AsyncFunction%') {
		value = getEvalledConstructor('async function () {}');
	} else if (name === '%GeneratorFunction%') {
		value = getEvalledConstructor('function* () {}');
	} else if (name === '%AsyncGeneratorFunction%') {
		value = getEvalledConstructor('async function* () {}');
	} else if (name === '%AsyncGenerator%') {
		var fn = doEval('%AsyncGeneratorFunction%');
		if (fn) {
			value = fn.prototype;
		}
	} else if (name === '%AsyncIteratorPrototype%') {
		var gen = doEval('%AsyncGenerator%');
		if (gen) {
			value = getProto(gen.prototype);
		}
	}

	INTRINSICS[name] = value;

	return value;
};

var LEGACY_ALIASES = {
	'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
	'%ArrayPrototype%': ['Array', 'prototype'],
	'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
	'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
	'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
	'%ArrayProto_values%': ['Array', 'prototype', 'values'],
	'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
	'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
	'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
	'%BooleanPrototype%': ['Boolean', 'prototype'],
	'%DataViewPrototype%': ['DataView', 'prototype'],
	'%DatePrototype%': ['Date', 'prototype'],
	'%ErrorPrototype%': ['Error', 'prototype'],
	'%EvalErrorPrototype%': ['EvalError', 'prototype'],
	'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
	'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
	'%FunctionPrototype%': ['Function', 'prototype'],
	'%Generator%': ['GeneratorFunction', 'prototype'],
	'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
	'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
	'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
	'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
	'%JSONParse%': ['JSON', 'parse'],
	'%JSONStringify%': ['JSON', 'stringify'],
	'%MapPrototype%': ['Map', 'prototype'],
	'%NumberPrototype%': ['Number', 'prototype'],
	'%ObjectPrototype%': ['Object', 'prototype'],
	'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
	'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
	'%PromisePrototype%': ['Promise', 'prototype'],
	'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
	'%Promise_all%': ['Promise', 'all'],
	'%Promise_reject%': ['Promise', 'reject'],
	'%Promise_resolve%': ['Promise', 'resolve'],
	'%RangeErrorPrototype%': ['RangeError', 'prototype'],
	'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
	'%RegExpPrototype%': ['RegExp', 'prototype'],
	'%SetPrototype%': ['Set', 'prototype'],
	'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
	'%StringPrototype%': ['String', 'prototype'],
	'%SymbolPrototype%': ['Symbol', 'prototype'],
	'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
	'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
	'%TypeErrorPrototype%': ['TypeError', 'prototype'],
	'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
	'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
	'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
	'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
	'%URIErrorPrototype%': ['URIError', 'prototype'],
	'%WeakMapPrototype%': ['WeakMap', 'prototype'],
	'%WeakSetPrototype%': ['WeakSet', 'prototype']
};

var bind = __webpack_require__(20132);
var hasOwn = __webpack_require__(77492);
var $concat = bind.call(Function.call, Array.prototype.concat);
var $spliceApply = bind.call(Function.apply, Array.prototype.splice);
var $replace = bind.call(Function.call, String.prototype.replace);
var $strSlice = bind.call(Function.call, String.prototype.slice);
var $exec = bind.call(Function.call, RegExp.prototype.exec);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath = function stringToPath(string) {
	var first = $strSlice(string, 0, 1);
	var last = $strSlice(string, -1);
	if (first === '%' && last !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
	} else if (last === '%' && first !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
	}
	var result = [];
	$replace(string, rePropName, function (match, number, quote, subString) {
		result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
	});
	return result;
};
/* end adaptation */

var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
	var intrinsicName = name;
	var alias;
	if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
		alias = LEGACY_ALIASES[intrinsicName];
		intrinsicName = '%' + alias[0] + '%';
	}

	if (hasOwn(INTRINSICS, intrinsicName)) {
		var value = INTRINSICS[intrinsicName];
		if (value === needsEval) {
			value = doEval(intrinsicName);
		}
		if (typeof value === 'undefined' && !allowMissing) {
			throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
		}

		return {
			alias: alias,
			name: intrinsicName,
			value: value
		};
	}

	throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
};

module.exports = function GetIntrinsic(name, allowMissing) {
	if (typeof name !== 'string' || name.length === 0) {
		throw new $TypeError('intrinsic name must be a non-empty string');
	}
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new $TypeError('"allowMissing" argument must be a boolean');
	}

	if ($exec(/^%?[^%]*%?$/g, name) === null) {
		throw new $SyntaxError('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
	}
	var parts = stringToPath(name);
	var intrinsicBaseName = parts.length > 0 ? parts[0] : '';

	var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
	var intrinsicRealName = intrinsic.name;
	var value = intrinsic.value;
	var skipFurtherCaching = false;

	var alias = intrinsic.alias;
	if (alias) {
		intrinsicBaseName = alias[0];
		$spliceApply(parts, $concat([0, 1], alias));
	}

	for (var i = 1, isOwn = true; i < parts.length; i += 1) {
		var part = parts[i];
		var first = $strSlice(part, 0, 1);
		var last = $strSlice(part, -1);
		if (
			(
				(first === '"' || first === "'" || first === '`')
				|| (last === '"' || last === "'" || last === '`')
			)
			&& first !== last
		) {
			throw new $SyntaxError('property names with quotes must have matching quotes');
		}
		if (part === 'constructor' || !isOwn) {
			skipFurtherCaching = true;
		}

		intrinsicBaseName += '.' + part;
		intrinsicRealName = '%' + intrinsicBaseName + '%';

		if (hasOwn(INTRINSICS, intrinsicRealName)) {
			value = INTRINSICS[intrinsicRealName];
		} else if (value != null) {
			if (!(part in value)) {
				if (!allowMissing) {
					throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
				}
				return void undefined;
			}
			if ($gOPD && (i + 1) >= parts.length) {
				var desc = $gOPD(value, part);
				isOwn = !!desc;

				// By convention, when a data property is converted to an accessor
				// property to emulate a data property that does not suffer from
				// the override mistake, that accessor's getter is marked with
				// an `originalValue` property. Here, when we detect this, we
				// uphold the illusion by pretending to see that original data
				// property, i.e., returning the value rather than the getter
				// itself.
				if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
					value = desc.get;
				} else {
					value = value[part];
				}
			} else {
				isOwn = hasOwn(value, part);
				value = value[part];
			}

			if (isOwn && !skipFurtherCaching) {
				INTRINSICS[intrinsicRealName] = value;
			}
		}
	}
	return value;
};


/***/ }),

/***/ 13512:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Clamp.js 0.7.0
 *
 * Copyright 2011-2013, Joseph Schmitt http://joe.sh
 * Released under the WTFPL license
 * http://sam.zoy.org/wtfpl/
 */

(function(root, factory) {
  if (true) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}
}(this, function() {
  /**
   * Clamps a text node.
   * @param {HTMLElement} element. Element containing the text node to clamp.
   * @param {Object} options. Options to pass to the clamper.
   */
  function clamp(element, options) {
    options = options || {};

    var self = this,
      win = window,
      opt = {
        clamp: options.clamp || 2,
        useNativeClamp: typeof(options.useNativeClamp) != 'undefined' ? options.useNativeClamp : true,
        splitOnChars: options.splitOnChars || ['.', '-', '–', '—', ' '], //Split on sentences (periods), hypens, en-dashes, em-dashes, and words (spaces).
        animate: options.animate || false,
        truncationChar: options.truncationChar || '…',
        truncationHTML: options.truncationHTML
      },

      sty = element.style,
      originalText = element.innerHTML,

      supportsNativeClamp = typeof(element.style.webkitLineClamp) != 'undefined',
      clampValue = opt.clamp,
      isCSSValue = clampValue.indexOf && (clampValue.indexOf('px') > -1 || clampValue.indexOf('em') > -1),
      truncationHTMLContainer;

    if (opt.truncationHTML) {
      truncationHTMLContainer = document.createElement('span');
      truncationHTMLContainer.innerHTML = opt.truncationHTML;
    }


    // UTILITY FUNCTIONS __________________________________________________________

    /**
     * Return the current style for an element.
     * @param {HTMLElement} elem The element to compute.
     * @param {string} prop The style property.
     * @returns {number}
     */
    function computeStyle(elem, prop) {
      if (!win.getComputedStyle) {
        win.getComputedStyle = function(el, pseudo) {
          this.el = el;
          this.getPropertyValue = function(prop) {
            var re = /(\-([a-z]){1})/g;
            if (prop == 'float') prop = 'styleFloat';
            if (re.test(prop)) {
              prop = prop.replace(re, function() {
                return arguments[2].toUpperCase();
              });
            }
            return el.currentStyle && el.currentStyle[prop] ? el.currentStyle[prop] : null;
          };
          return this;
        };
      }

      return win.getComputedStyle(elem, null).getPropertyValue(prop);
    }

    /**
     * Returns the maximum number of lines of text that should be rendered based
     * on the current height of the element and the line-height of the text.
     */
    function getMaxLines(height) {
      var availHeight = height || element.clientHeight,
        lineHeight = getLineHeight(element);

      return Math.max(Math.floor(availHeight / lineHeight), 0);
    }

    /**
     * Returns the maximum height a given element should have based on the line-
     * height of the text and the given clamp value.
     */
    function getMaxHeight(clmp) {
      var lineHeight = getLineHeight(element);
      return lineHeight * clmp;
    }

    /**
     * Returns the line-height of an element as an integer.
     */
    function getLineHeight(elem) {
      var lh = computeStyle(elem, 'line-height');
      if (lh == 'normal') {
        // Normal line heights vary from browser to browser. The spec recommends
        // a value between 1.0 and 1.2 of the font size. Using 1.1 to split the diff.
        lh = parseInt(computeStyle(elem, 'font-size')) * 1.2;
      }
      return parseInt(lh);
    }


    // MEAT AND POTATOES (MMMM, POTATOES...) ______________________________________
    var splitOnChars = opt.splitOnChars.slice(0),
      splitChar = splitOnChars[0],
      chunks,
      lastChunk;

    /**
     * Gets an element's last child. That may be another node or a node's contents.
     */
    function getLastChild(elem) {
      //Current element has children, need to go deeper and get last child as a text node
      if (elem.lastChild.children && elem.lastChild.children.length > 0) {
        return getLastChild(Array.prototype.slice.call(elem.children).pop());
      }
      //This is the absolute last child, a text node, but something's wrong with it. Remove it and keep trying
      else if (!elem.lastChild || !elem.lastChild.nodeValue || elem.lastChild.nodeValue === '' || elem.lastChild.nodeValue == opt.truncationChar) {
        elem.lastChild.parentNode.removeChild(elem.lastChild);
        return getLastChild(element);
      }
      //This is the last child we want, return it
      else {
        return elem.lastChild;
      }
    }

    /**
     * Removes one character at a time from the text until its width or
     * height is beneath the passed-in max param.
     */
    function truncate(target, maxHeight) {
      if (!maxHeight) {
        return;
      }

      /**
       * Resets global variables.
       */
      function reset() {
        splitOnChars = opt.splitOnChars.slice(0);
        splitChar = splitOnChars[0];
        chunks = null;
        lastChunk = null;
      }

      var nodeValue = target.nodeValue.replace(opt.truncationChar, '');

      //Grab the next chunks
      if (!chunks) {
        //If there are more characters to try, grab the next one
        if (splitOnChars.length > 0) {
          splitChar = splitOnChars.shift();
        }
        //No characters to chunk by. Go character-by-character
        else {
          splitChar = '';
        }

        chunks = nodeValue.split(splitChar);
      }

      //If there are chunks left to remove, remove the last one and see if
      // the nodeValue fits.
      if (chunks.length > 1) {
        // console.log('chunks', chunks);
        lastChunk = chunks.pop();
        // console.log('lastChunk', lastChunk);
        applyEllipsis(target, chunks.join(splitChar));
      }
      //No more chunks can be removed using this character
      else {
        chunks = null;
      }

      //Insert the custom HTML before the truncation character
      if (truncationHTMLContainer) {
        target.nodeValue = target.nodeValue.replace(opt.truncationChar, '');
        element.innerHTML = target.nodeValue + ' ' + truncationHTMLContainer.innerHTML + opt.truncationChar;
      }

      //Search produced valid chunks
      if (chunks) {
        //It fits
        if (element.clientHeight <= maxHeight) {
          //There's still more characters to try splitting on, not quite done yet
          if (splitOnChars.length >= 0 && splitChar !== '') {
            applyEllipsis(target, chunks.join(splitChar) + splitChar + lastChunk);
            chunks = null;
          }
          //Finished!
          else {
            return element.innerHTML;
          }
        }
      }
      //No valid chunks produced
      else {
        //No valid chunks even when splitting by letter, time to move
        //on to the next node
        if (splitChar === '') {
          applyEllipsis(target, '');
          target = getLastChild(element);

          reset();
        }
      }

      //If you get here it means still too big, let's keep truncating
      if (opt.animate) {
        setTimeout(function() {
          truncate(target, maxHeight);
        }, opt.animate === true ? 10 : opt.animate);
      } else {
        return truncate(target, maxHeight);
      }
    }

    function applyEllipsis(elem, str) {
      elem.nodeValue = str + opt.truncationChar;
    }


    // CONSTRUCTOR ________________________________________________________________

    if (clampValue == 'auto') {
      clampValue = getMaxLines();
    } else if (isCSSValue) {
      clampValue = getMaxLines(parseInt(clampValue));
    }

    var clampedText;
    if (supportsNativeClamp && opt.useNativeClamp) {
      sty.overflow = 'hidden';
      sty.textOverflow = 'ellipsis';
      sty.webkitBoxOrient = 'vertical';
      sty.display = '-webkit-box';
      sty.webkitLineClamp = clampValue;

      if (isCSSValue) {
        sty.height = opt.clamp + 'px';
      }
    } else {
      var height = getMaxHeight(clampValue);
      if (height <= element.clientHeight) {
        clampedText = truncate(getLastChild(element), height);
      }
    }

    return {
      'original': originalText,
      'clamped': clampedText
    };
  }

  return clamp;
}));


/***/ }),

/***/ 34882:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
/*!
 * cookie
 * Copyright(c) 2012-2014 Roman Shtylman
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */



/**
 * Module exports.
 * @public
 */

exports.parse = parse;
exports.serialize = serialize;

/**
 * Module variables.
 * @private
 */

var decode = decodeURIComponent;
var encode = encodeURIComponent;

/**
 * RegExp to match field-content in RFC 7230 sec 3.2
 *
 * field-content = field-vchar [ 1*( SP / HTAB ) field-vchar ]
 * field-vchar   = VCHAR / obs-text
 * obs-text      = %x80-FF
 */

var fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;

/**
 * Parse a cookie header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 *
 * @param {string} str
 * @param {object} [options]
 * @return {object}
 * @public
 */

function parse(str, options) {
  if (typeof str !== 'string') {
    throw new TypeError('argument str must be a string');
  }

  var obj = {}
  var opt = options || {};
  var pairs = str.split(';')
  var dec = opt.decode || decode;

  for (var i = 0; i < pairs.length; i++) {
    var pair = pairs[i];
    var index = pair.indexOf('=')

    // skip things that don't look like key=value
    if (index < 0) {
      continue;
    }

    var key = pair.substring(0, index).trim()

    // only assign once
    if (undefined == obj[key]) {
      var val = pair.substring(index + 1, pair.length).trim()

      // quoted values
      if (val[0] === '"') {
        val = val.slice(1, -1)
      }

      obj[key] = tryDecode(val, dec);
    }
  }

  return obj;
}

/**
 * Serialize data into a cookie header.
 *
 * Serialize the a name value pair into a cookie string suitable for
 * http headers. An optional options object specified cookie parameters.
 *
 * serialize('foo', 'bar', { httpOnly: true })
 *   => "foo=bar; httpOnly"
 *
 * @param {string} name
 * @param {string} val
 * @param {object} [options]
 * @return {string}
 * @public
 */

function serialize(name, val, options) {
  var opt = options || {};
  var enc = opt.encode || encode;

  if (typeof enc !== 'function') {
    throw new TypeError('option encode is invalid');
  }

  if (!fieldContentRegExp.test(name)) {
    throw new TypeError('argument name is invalid');
  }

  var value = enc(val);

  if (value && !fieldContentRegExp.test(value)) {
    throw new TypeError('argument val is invalid');
  }

  var str = name + '=' + value;

  if (null != opt.maxAge) {
    var maxAge = opt.maxAge - 0;

    if (isNaN(maxAge) || !isFinite(maxAge)) {
      throw new TypeError('option maxAge is invalid')
    }

    str += '; Max-Age=' + Math.floor(maxAge);
  }

  if (opt.domain) {
    if (!fieldContentRegExp.test(opt.domain)) {
      throw new TypeError('option domain is invalid');
    }

    str += '; Domain=' + opt.domain;
  }

  if (opt.path) {
    if (!fieldContentRegExp.test(opt.path)) {
      throw new TypeError('option path is invalid');
    }

    str += '; Path=' + opt.path;
  }

  if (opt.expires) {
    if (typeof opt.expires.toUTCString !== 'function') {
      throw new TypeError('option expires is invalid');
    }

    str += '; Expires=' + opt.expires.toUTCString();
  }

  if (opt.httpOnly) {
    str += '; HttpOnly';
  }

  if (opt.secure) {
    str += '; Secure';
  }

  if (opt.sameSite) {
    var sameSite = typeof opt.sameSite === 'string'
      ? opt.sameSite.toLowerCase() : opt.sameSite;

    switch (sameSite) {
      case true:
        str += '; SameSite=Strict';
        break;
      case 'lax':
        str += '; SameSite=Lax';
        break;
      case 'strict':
        str += '; SameSite=Strict';
        break;
      case 'none':
        str += '; SameSite=None';
        break;
      default:
        throw new TypeError('option sameSite is invalid');
    }
  }

  return str;
}

/**
 * Try decoding a string using a decoding function.
 *
 * @param {string} str
 * @param {function} decode
 * @private
 */

function tryDecode(str, decode) {
  try {
    return decode(str);
  } catch (e) {
    return str;
  }
}


/***/ }),

/***/ 21857:
/***/ (function(module) {

"use strict";


var isMergeableObject = function isMergeableObject(value) {
	return isNonNullObject(value)
		&& !isSpecial(value)
};

function isNonNullObject(value) {
	return !!value && typeof value === 'object'
}

function isSpecial(value) {
	var stringValue = Object.prototype.toString.call(value);

	return stringValue === '[object RegExp]'
		|| stringValue === '[object Date]'
		|| isReactElement(value)
}

// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;

function isReactElement(value) {
	return value.$$typeof === REACT_ELEMENT_TYPE
}

function emptyTarget(val) {
	return Array.isArray(val) ? [] : {}
}

function cloneUnlessOtherwiseSpecified(value, options) {
	return (options.clone !== false && options.isMergeableObject(value))
		? deepmerge(emptyTarget(value), value, options)
		: value
}

function defaultArrayMerge(target, source, options) {
	return target.concat(source).map(function(element) {
		return cloneUnlessOtherwiseSpecified(element, options)
	})
}

function getMergeFunction(key, options) {
	if (!options.customMerge) {
		return deepmerge
	}
	var customMerge = options.customMerge(key);
	return typeof customMerge === 'function' ? customMerge : deepmerge
}

function getEnumerableOwnPropertySymbols(target) {
	return Object.getOwnPropertySymbols
		? Object.getOwnPropertySymbols(target).filter(function(symbol) {
			return target.propertyIsEnumerable(symbol)
		})
		: []
}

function getKeys(target) {
	return Object.keys(target).concat(getEnumerableOwnPropertySymbols(target))
}

function propertyIsOnObject(object, property) {
	try {
		return property in object
	} catch(_) {
		return false
	}
}

// Protects from prototype poisoning and unexpected merging up the prototype chain.
function propertyIsUnsafe(target, key) {
	return propertyIsOnObject(target, key) // Properties are safe to merge if they don't exist in the target yet,
		&& !(Object.hasOwnProperty.call(target, key) // unsafe if they exist up the prototype chain,
			&& Object.propertyIsEnumerable.call(target, key)) // and also unsafe if they're nonenumerable.
}

function mergeObject(target, source, options) {
	var destination = {};
	if (options.isMergeableObject(target)) {
		getKeys(target).forEach(function(key) {
			destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
		});
	}
	getKeys(source).forEach(function(key) {
		if (propertyIsUnsafe(target, key)) {
			return
		}

		if (propertyIsOnObject(target, key) && options.isMergeableObject(source[key])) {
			destination[key] = getMergeFunction(key, options)(target[key], source[key], options);
		} else {
			destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
		}
	});
	return destination
}

function deepmerge(target, source, options) {
	options = options || {};
	options.arrayMerge = options.arrayMerge || defaultArrayMerge;
	options.isMergeableObject = options.isMergeableObject || isMergeableObject;
	// cloneUnlessOtherwiseSpecified is added to `options` so that custom arrayMerge()
	// implementations can use it. The caller may not replace it.
	options.cloneUnlessOtherwiseSpecified = cloneUnlessOtherwiseSpecified;

	var sourceIsArray = Array.isArray(source);
	var targetIsArray = Array.isArray(target);
	var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;

	if (!sourceAndTargetTypesMatch) {
		return cloneUnlessOtherwiseSpecified(source, options)
	} else if (sourceIsArray) {
		return options.arrayMerge(target, source, options)
	} else {
		return mergeObject(target, source, options)
	}
}

deepmerge.all = function deepmergeAll(array, options) {
	if (!Array.isArray(array)) {
		throw new Error('first argument should be an array')
	}

	return array.reduce(function(prev, next) {
		return deepmerge(prev, next, options)
	}, {})
};

var deepmerge_1 = deepmerge;

module.exports = deepmerge_1;


/***/ }),

/***/ 58242:
/***/ (function(module) {

"use strict";


module.exports = function () {
  // https://mths.be/emoji
  return /\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62(?:\uDB40\uDC77\uDB40\uDC6C\uDB40\uDC73|\uDB40\uDC73\uDB40\uDC63\uDB40\uDC74|\uDB40\uDC65\uDB40\uDC6E\uDB40\uDC67)\uDB40\uDC7F|(?:\uD83E\uDDD1\uD83C\uDFFF\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69]))(?:\uD83C[\uDFFB-\uDFFE])|(?:\uD83E\uDDD1\uD83C\uDFFE\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69]))(?:\uD83C[\uDFFB-\uDFFD\uDFFF])|(?:\uD83E\uDDD1\uD83C\uDFFD\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69]))(?:\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])|(?:\uD83E\uDDD1\uD83C\uDFFC\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69]))(?:\uD83C[\uDFFB\uDFFD-\uDFFF])|(?:\uD83E\uDDD1\uD83C\uDFFB\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFB\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69]))(?:\uD83C[\uDFFC-\uDFFF])|\uD83D\uDC68(?:\uD83C\uDFFB(?:\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFF])|\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFF]))|\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFC-\uDFFF])|[\u2695\u2696\u2708]\uFE0F|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD]))?|(?:\uD83C[\uDFFC-\uDFFF])\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFF])|\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFF]))|\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83D\uDC68|(?:\uD83D[\uDC68\uDC69])\u200D(?:\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67]))|\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFF\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFE])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFE\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFD\uDFFF])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFD\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFC\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB\uDFFD-\uDFFF])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|(?:\uD83C\uDFFF\u200D[\u2695\u2696\u2708]|\uD83C\uDFFE\u200D[\u2695\u2696\u2708]|\uD83C\uDFFD\u200D[\u2695\u2696\u2708]|\uD83C\uDFFC\u200D[\u2695\u2696\u2708]|\u200D[\u2695\u2696\u2708])\uFE0F|\u200D(?:(?:\uD83D[\uDC68\uDC69])\u200D(?:\uD83D[\uDC66\uDC67])|\uD83D[\uDC66\uDC67])|\uD83C\uDFFF|\uD83C\uDFFE|\uD83C\uDFFD|\uD83C\uDFFC)?|(?:\uD83D\uDC69(?:\uD83C\uDFFB\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D(?:\uD83D[\uDC68\uDC69])|\uD83D[\uDC68\uDC69])|(?:\uD83C[\uDFFC-\uDFFF])\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D(?:\uD83D[\uDC68\uDC69])|\uD83D[\uDC68\uDC69]))|\uD83E\uDDD1(?:\uD83C[\uDFFB-\uDFFF])\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1)(?:\uD83C[\uDFFB-\uDFFF])|\uD83D\uDC69\u200D\uD83D\uDC69\u200D(?:\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67]))|\uD83D\uDC69(?:\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D(?:\uD83D[\uDC68\uDC69])|\uD83D[\uDC68\uDC69])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFF\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFE\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFD\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFC\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFB\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD]))|\uD83E\uDDD1(?:\u200D(?:\uD83E\uDD1D\u200D\uD83E\uDDD1|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFF\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFE\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFD\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFC\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFB\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD]))|\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC69\u200D\uD83D\uDC69\u200D(?:\uD83D[\uDC66\uDC67])|\uD83D\uDC69\u200D\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|(?:\uD83D\uDC41\uFE0F\u200D\uD83D\uDDE8|\uD83E\uDDD1(?:\uD83C\uDFFF\u200D[\u2695\u2696\u2708]|\uD83C\uDFFE\u200D[\u2695\u2696\u2708]|\uD83C\uDFFD\u200D[\u2695\u2696\u2708]|\uD83C\uDFFC\u200D[\u2695\u2696\u2708]|\uD83C\uDFFB\u200D[\u2695\u2696\u2708]|\u200D[\u2695\u2696\u2708])|\uD83D\uDC69(?:\uD83C\uDFFF\u200D[\u2695\u2696\u2708]|\uD83C\uDFFE\u200D[\u2695\u2696\u2708]|\uD83C\uDFFD\u200D[\u2695\u2696\u2708]|\uD83C\uDFFC\u200D[\u2695\u2696\u2708]|\uD83C\uDFFB\u200D[\u2695\u2696\u2708]|\u200D[\u2695\u2696\u2708])|\uD83D\uDE36\u200D\uD83C\uDF2B|\uD83C\uDFF3\uFE0F\u200D\u26A7|\uD83D\uDC3B\u200D\u2744|(?:(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC70\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD35\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD4\uDDD6-\uDDDD])(?:\uD83C[\uDFFB-\uDFFF])|\uD83D\uDC6F|\uD83E[\uDD3C\uDDDE\uDDDF])\u200D[\u2640\u2642]|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:\uFE0F|\uD83C[\uDFFB-\uDFFF])\u200D[\u2640\u2642]|\uD83C\uDFF4\u200D\u2620|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC70\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD35\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD4\uDDD6-\uDDDD])\u200D[\u2640\u2642]|[\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u2328\u23CF\u23ED-\u23EF\u23F1\u23F2\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB\u25FC\u2600-\u2604\u260E\u2611\u2618\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u265F\u2660\u2663\u2665\u2666\u2668\u267B\u267E\u2692\u2694-\u2697\u2699\u269B\u269C\u26A0\u26A7\u26B0\u26B1\u26C8\u26CF\u26D1\u26D3\u26E9\u26F0\u26F1\u26F4\u26F7\u26F8\u2702\u2708\u2709\u270F\u2712\u2714\u2716\u271D\u2721\u2733\u2734\u2744\u2747\u2763\u27A1\u2934\u2935\u2B05-\u2B07\u3030\u303D\u3297\u3299]|\uD83C[\uDD70\uDD71\uDD7E\uDD7F\uDE02\uDE37\uDF21\uDF24-\uDF2C\uDF36\uDF7D\uDF96\uDF97\uDF99-\uDF9B\uDF9E\uDF9F\uDFCD\uDFCE\uDFD4-\uDFDF\uDFF5\uDFF7]|\uD83D[\uDC3F\uDCFD\uDD49\uDD4A\uDD6F\uDD70\uDD73\uDD76-\uDD79\uDD87\uDD8A-\uDD8D\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA\uDECB\uDECD-\uDECF\uDEE0-\uDEE5\uDEE9\uDEF0\uDEF3])\uFE0F|\uD83C\uDFF3\uFE0F\u200D\uD83C\uDF08|\uD83D\uDC69\u200D\uD83D\uDC67|\uD83D\uDC69\u200D\uD83D\uDC66|\uD83D\uDE35\u200D\uD83D\uDCAB|\uD83D\uDE2E\u200D\uD83D\uDCA8|\uD83D\uDC15\u200D\uD83E\uDDBA|\uD83E\uDDD1(?:\uD83C\uDFFF|\uD83C\uDFFE|\uD83C\uDFFD|\uD83C\uDFFC|\uD83C\uDFFB)?|\uD83D\uDC69(?:\uD83C\uDFFF|\uD83C\uDFFE|\uD83C\uDFFD|\uD83C\uDFFC|\uD83C\uDFFB)?|\uD83C\uDDFD\uD83C\uDDF0|\uD83C\uDDF6\uD83C\uDDE6|\uD83C\uDDF4\uD83C\uDDF2|\uD83D\uDC08\u200D\u2B1B|\u2764\uFE0F\u200D(?:\uD83D\uDD25|\uD83E\uDE79)|\uD83D\uDC41\uFE0F|\uD83C\uDFF3\uFE0F|\uD83C\uDDFF(?:\uD83C[\uDDE6\uDDF2\uDDFC])|\uD83C\uDDFE(?:\uD83C[\uDDEA\uDDF9])|\uD83C\uDDFC(?:\uD83C[\uDDEB\uDDF8])|\uD83C\uDDFB(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDEE\uDDF3\uDDFA])|\uD83C\uDDFA(?:\uD83C[\uDDE6\uDDEC\uDDF2\uDDF3\uDDF8\uDDFE\uDDFF])|\uD83C\uDDF9(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDED\uDDEF-\uDDF4\uDDF7\uDDF9\uDDFB\uDDFC\uDDFF])|\uD83C\uDDF8(?:\uD83C[\uDDE6-\uDDEA\uDDEC-\uDDF4\uDDF7-\uDDF9\uDDFB\uDDFD-\uDDFF])|\uD83C\uDDF7(?:\uD83C[\uDDEA\uDDF4\uDDF8\uDDFA\uDDFC])|\uD83C\uDDF5(?:\uD83C[\uDDE6\uDDEA-\uDDED\uDDF0-\uDDF3\uDDF7-\uDDF9\uDDFC\uDDFE])|\uD83C\uDDF3(?:\uD83C[\uDDE6\uDDE8\uDDEA-\uDDEC\uDDEE\uDDF1\uDDF4\uDDF5\uDDF7\uDDFA\uDDFF])|\uD83C\uDDF2(?:\uD83C[\uDDE6\uDDE8-\uDDED\uDDF0-\uDDFF])|\uD83C\uDDF1(?:\uD83C[\uDDE6-\uDDE8\uDDEE\uDDF0\uDDF7-\uDDFB\uDDFE])|\uD83C\uDDF0(?:\uD83C[\uDDEA\uDDEC-\uDDEE\uDDF2\uDDF3\uDDF5\uDDF7\uDDFC\uDDFE\uDDFF])|\uD83C\uDDEF(?:\uD83C[\uDDEA\uDDF2\uDDF4\uDDF5])|\uD83C\uDDEE(?:\uD83C[\uDDE8-\uDDEA\uDDF1-\uDDF4\uDDF6-\uDDF9])|\uD83C\uDDED(?:\uD83C[\uDDF0\uDDF2\uDDF3\uDDF7\uDDF9\uDDFA])|\uD83C\uDDEC(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEE\uDDF1-\uDDF3\uDDF5-\uDDFA\uDDFC\uDDFE])|\uD83C\uDDEB(?:\uD83C[\uDDEE-\uDDF0\uDDF2\uDDF4\uDDF7])|\uD83C\uDDEA(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDED\uDDF7-\uDDFA])|\uD83C\uDDE9(?:\uD83C[\uDDEA\uDDEC\uDDEF\uDDF0\uDDF2\uDDF4\uDDFF])|\uD83C\uDDE8(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDEE\uDDF0-\uDDF5\uDDF7\uDDFA-\uDDFF])|\uD83C\uDDE7(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEF\uDDF1-\uDDF4\uDDF6-\uDDF9\uDDFB\uDDFC\uDDFE\uDDFF])|\uD83C\uDDE6(?:\uD83C[\uDDE8-\uDDEC\uDDEE\uDDF1\uDDF2\uDDF4\uDDF6-\uDDFA\uDDFC\uDDFD\uDDFF])|[#\*0-9]\uFE0F\u20E3|\u2764\uFE0F|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC70\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD35\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD4\uDDD6-\uDDDD])(?:\uD83C[\uDFFB-\uDFFF])|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:\uFE0F|\uD83C[\uDFFB-\uDFFF])|\uD83C\uDFF4|(?:[\u270A\u270B]|\uD83C[\uDF85\uDFC2\uDFC7]|\uD83D[\uDC42\uDC43\uDC46-\uDC50\uDC66\uDC67\uDC6B-\uDC6D\uDC72\uDC74-\uDC76\uDC78\uDC7C\uDC83\uDC85\uDC8F\uDC91\uDCAA\uDD7A\uDD95\uDD96\uDE4C\uDE4F\uDEC0\uDECC]|\uD83E[\uDD0C\uDD0F\uDD18-\uDD1C\uDD1E\uDD1F\uDD30-\uDD34\uDD36\uDD77\uDDB5\uDDB6\uDDBB\uDDD2\uDDD3\uDDD5])(?:\uD83C[\uDFFB-\uDFFF])|(?:[\u261D\u270C\u270D]|\uD83D[\uDD74\uDD90])(?:\uFE0F|\uD83C[\uDFFB-\uDFFF])|[\u270A\u270B]|\uD83C[\uDF85\uDFC2\uDFC7]|\uD83D[\uDC08\uDC15\uDC3B\uDC42\uDC43\uDC46-\uDC50\uDC66\uDC67\uDC6B-\uDC6D\uDC72\uDC74-\uDC76\uDC78\uDC7C\uDC83\uDC85\uDC8F\uDC91\uDCAA\uDD7A\uDD95\uDD96\uDE2E\uDE35\uDE36\uDE4C\uDE4F\uDEC0\uDECC]|\uD83E[\uDD0C\uDD0F\uDD18-\uDD1C\uDD1E\uDD1F\uDD30-\uDD34\uDD36\uDD77\uDDB5\uDDB6\uDDBB\uDDD2\uDDD3\uDDD5]|\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC70\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD35\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD4\uDDD6-\uDDDD]|\uD83D\uDC6F|\uD83E[\uDD3C\uDDDE\uDDDF]|[\u231A\u231B\u23E9-\u23EC\u23F0\u23F3\u25FD\u25FE\u2614\u2615\u2648-\u2653\u267F\u2693\u26A1\u26AA\u26AB\u26BD\u26BE\u26C4\u26C5\u26CE\u26D4\u26EA\u26F2\u26F3\u26F5\u26FA\u26FD\u2705\u2728\u274C\u274E\u2753-\u2755\u2757\u2795-\u2797\u27B0\u27BF\u2B1B\u2B1C\u2B50\u2B55]|\uD83C[\uDC04\uDCCF\uDD8E\uDD91-\uDD9A\uDE01\uDE1A\uDE2F\uDE32-\uDE36\uDE38-\uDE3A\uDE50\uDE51\uDF00-\uDF20\uDF2D-\uDF35\uDF37-\uDF7C\uDF7E-\uDF84\uDF86-\uDF93\uDFA0-\uDFC1\uDFC5\uDFC6\uDFC8\uDFC9\uDFCF-\uDFD3\uDFE0-\uDFF0\uDFF8-\uDFFF]|\uD83D[\uDC00-\uDC07\uDC09-\uDC14\uDC16-\uDC3A\uDC3C-\uDC3E\uDC40\uDC44\uDC45\uDC51-\uDC65\uDC6A\uDC79-\uDC7B\uDC7D-\uDC80\uDC84\uDC88-\uDC8E\uDC90\uDC92-\uDCA9\uDCAB-\uDCFC\uDCFF-\uDD3D\uDD4B-\uDD4E\uDD50-\uDD67\uDDA4\uDDFB-\uDE2D\uDE2F-\uDE34\uDE37-\uDE44\uDE48-\uDE4A\uDE80-\uDEA2\uDEA4-\uDEB3\uDEB7-\uDEBF\uDEC1-\uDEC5\uDED0-\uDED2\uDED5-\uDED7\uDEEB\uDEEC\uDEF4-\uDEFC\uDFE0-\uDFEB]|\uD83E[\uDD0D\uDD0E\uDD10-\uDD17\uDD1D\uDD20-\uDD25\uDD27-\uDD2F\uDD3A\uDD3F-\uDD45\uDD47-\uDD76\uDD78\uDD7A-\uDDB4\uDDB7\uDDBA\uDDBC-\uDDCB\uDDD0\uDDE0-\uDDFF\uDE70-\uDE74\uDE78-\uDE7A\uDE80-\uDE86\uDE90-\uDEA8\uDEB0-\uDEB6\uDEC0-\uDEC2\uDED0-\uDED6]|(?:[\u231A\u231B\u23E9-\u23EC\u23F0\u23F3\u25FD\u25FE\u2614\u2615\u2648-\u2653\u267F\u2693\u26A1\u26AA\u26AB\u26BD\u26BE\u26C4\u26C5\u26CE\u26D4\u26EA\u26F2\u26F3\u26F5\u26FA\u26FD\u2705\u270A\u270B\u2728\u274C\u274E\u2753-\u2755\u2757\u2795-\u2797\u27B0\u27BF\u2B1B\u2B1C\u2B50\u2B55]|\uD83C[\uDC04\uDCCF\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE1A\uDE2F\uDE32-\uDE36\uDE38-\uDE3A\uDE50\uDE51\uDF00-\uDF20\uDF2D-\uDF35\uDF37-\uDF7C\uDF7E-\uDF93\uDFA0-\uDFCA\uDFCF-\uDFD3\uDFE0-\uDFF0\uDFF4\uDFF8-\uDFFF]|\uD83D[\uDC00-\uDC3E\uDC40\uDC42-\uDCFC\uDCFF-\uDD3D\uDD4B-\uDD4E\uDD50-\uDD67\uDD7A\uDD95\uDD96\uDDA4\uDDFB-\uDE4F\uDE80-\uDEC5\uDECC\uDED0-\uDED2\uDED5-\uDED7\uDEEB\uDEEC\uDEF4-\uDEFC\uDFE0-\uDFEB]|\uD83E[\uDD0C-\uDD3A\uDD3C-\uDD45\uDD47-\uDD78\uDD7A-\uDDCB\uDDCD-\uDDFF\uDE70-\uDE74\uDE78-\uDE7A\uDE80-\uDE86\uDE90-\uDEA8\uDEB0-\uDEB6\uDEC0-\uDEC2\uDED0-\uDED6])|(?:[#\*0-9\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2604\u260E\u2611\u2614\u2615\u2618\u261D\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u2648-\u2653\u265F\u2660\u2663\u2665\u2666\u2668\u267B\u267E\u267F\u2692-\u2697\u2699\u269B\u269C\u26A0\u26A1\u26A7\u26AA\u26AB\u26B0\u26B1\u26BD\u26BE\u26C4\u26C5\u26C8\u26CE\u26CF\u26D1\u26D3\u26D4\u26E9\u26EA\u26F0-\u26F5\u26F7-\u26FA\u26FD\u2702\u2705\u2708-\u270D\u270F\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763\u2764\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC04\uDCCF\uDD70\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE02\uDE1A\uDE2F\uDE32-\uDE3A\uDE50\uDE51\uDF00-\uDF21\uDF24-\uDF93\uDF96\uDF97\uDF99-\uDF9B\uDF9E-\uDFF0\uDFF3-\uDFF5\uDFF7-\uDFFF]|\uD83D[\uDC00-\uDCFD\uDCFF-\uDD3D\uDD49-\uDD4E\uDD50-\uDD67\uDD6F\uDD70\uDD73-\uDD7A\uDD87\uDD8A-\uDD8D\uDD90\uDD95\uDD96\uDDA4\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA-\uDE4F\uDE80-\uDEC5\uDECB-\uDED2\uDED5-\uDED7\uDEE0-\uDEE5\uDEE9\uDEEB\uDEEC\uDEF0\uDEF3-\uDEFC\uDFE0-\uDFEB]|\uD83E[\uDD0C-\uDD3A\uDD3C-\uDD45\uDD47-\uDD78\uDD7A-\uDDCB\uDDCD-\uDDFF\uDE70-\uDE74\uDE78-\uDE7A\uDE80-\uDE86\uDE90-\uDEA8\uDEB0-\uDEB6\uDEC0-\uDEC2\uDED0-\uDED6])\uFE0F|(?:[\u261D\u26F9\u270A-\u270D]|\uD83C[\uDF85\uDFC2-\uDFC4\uDFC7\uDFCA-\uDFCC]|\uD83D[\uDC42\uDC43\uDC46-\uDC50\uDC66-\uDC78\uDC7C\uDC81-\uDC83\uDC85-\uDC87\uDC8F\uDC91\uDCAA\uDD74\uDD75\uDD7A\uDD90\uDD95\uDD96\uDE45-\uDE47\uDE4B-\uDE4F\uDEA3\uDEB4-\uDEB6\uDEC0\uDECC]|\uD83E[\uDD0C\uDD0F\uDD18-\uDD1F\uDD26\uDD30-\uDD39\uDD3C-\uDD3E\uDD77\uDDB5\uDDB6\uDDB8\uDDB9\uDDBB\uDDCD-\uDDCF\uDDD1-\uDDDD])/g;
};


/***/ }),

/***/ 50343:
/***/ (function(module) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var R = typeof Reflect === 'object' ? Reflect : null
var ReflectApply = R && typeof R.apply === 'function'
  ? R.apply
  : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
  }

var ReflectOwnKeys
if (R && typeof R.ownKeys === 'function') {
  ReflectOwnKeys = R.ownKeys
} else if (Object.getOwnPropertySymbols) {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target)
      .concat(Object.getOwnPropertySymbols(target));
  };
} else {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
  };
}

function ProcessEmitWarning(warning) {
  if (console && console.warn) console.warn(warning);
}

var NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
  return value !== value;
}

function EventEmitter() {
  EventEmitter.init.call(this);
}
module.exports = EventEmitter;
module.exports.once = once;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._eventsCount = 0;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var defaultMaxListeners = 10;

function checkListener(listener) {
  if (typeof listener !== 'function') {
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
  }
}

Object.defineProperty(EventEmitter, 'defaultMaxListeners', {
  enumerable: true,
  get: function() {
    return defaultMaxListeners;
  },
  set: function(arg) {
    if (typeof arg !== 'number' || arg < 0 || NumberIsNaN(arg)) {
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
    }
    defaultMaxListeners = arg;
  }
});

EventEmitter.init = function() {

  if (this._events === undefined ||
      this._events === Object.getPrototypeOf(this)._events) {
    this._events = Object.create(null);
    this._eventsCount = 0;
  }

  this._maxListeners = this._maxListeners || undefined;
};

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
  if (typeof n !== 'number' || n < 0 || NumberIsNaN(n)) {
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
  }
  this._maxListeners = n;
  return this;
};

function _getMaxListeners(that) {
  if (that._maxListeners === undefined)
    return EventEmitter.defaultMaxListeners;
  return that._maxListeners;
}

EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
  return _getMaxListeners(this);
};

EventEmitter.prototype.emit = function emit(type) {
  var args = [];
  for (var i = 1; i < arguments.length; i++) args.push(arguments[i]);
  var doError = (type === 'error');

  var events = this._events;
  if (events !== undefined)
    doError = (doError && events.error === undefined);
  else if (!doError)
    return false;

  // If there is no 'error' event listener then throw.
  if (doError) {
    var er;
    if (args.length > 0)
      er = args[0];
    if (er instanceof Error) {
      // Note: The comments on the `throw` lines are intentional, they show
      // up in Node's output if this results in an unhandled exception.
      throw er; // Unhandled 'error' event
    }
    // At least give some kind of context to the user
    var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
    err.context = er;
    throw err; // Unhandled 'error' event
  }

  var handler = events[type];

  if (handler === undefined)
    return false;

  if (typeof handler === 'function') {
    ReflectApply(handler, this, args);
  } else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      ReflectApply(listeners[i], this, args);
  }

  return true;
};

function _addListener(target, type, listener, prepend) {
  var m;
  var events;
  var existing;

  checkListener(listener);

  events = target._events;
  if (events === undefined) {
    events = target._events = Object.create(null);
    target._eventsCount = 0;
  } else {
    // To avoid recursion in the case that type === "newListener"! Before
    // adding it to the listeners, first emit "newListener".
    if (events.newListener !== undefined) {
      target.emit('newListener', type,
                  listener.listener ? listener.listener : listener);

      // Re-assign `events` because a newListener handler could have caused the
      // this._events to be assigned to a new object
      events = target._events;
    }
    existing = events[type];
  }

  if (existing === undefined) {
    // Optimize the case of one listener. Don't need the extra array object.
    existing = events[type] = listener;
    ++target._eventsCount;
  } else {
    if (typeof existing === 'function') {
      // Adding the second element, need to change to array.
      existing = events[type] =
        prepend ? [listener, existing] : [existing, listener];
      // If we've already got an array, just append.
    } else if (prepend) {
      existing.unshift(listener);
    } else {
      existing.push(listener);
    }

    // Check for listener leak
    m = _getMaxListeners(target);
    if (m > 0 && existing.length > m && !existing.warned) {
      existing.warned = true;
      // No error code for this since it is a Warning
      // eslint-disable-next-line no-restricted-syntax
      var w = new Error('Possible EventEmitter memory leak detected. ' +
                          existing.length + ' ' + String(type) + ' listeners ' +
                          'added. Use emitter.setMaxListeners() to ' +
                          'increase limit');
      w.name = 'MaxListenersExceededWarning';
      w.emitter = target;
      w.type = type;
      w.count = existing.length;
      ProcessEmitWarning(w);
    }
  }

  return target;
}

EventEmitter.prototype.addListener = function addListener(type, listener) {
  return _addListener(this, type, listener, false);
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.prependListener =
    function prependListener(type, listener) {
      return _addListener(this, type, listener, true);
    };

function onceWrapper() {
  if (!this.fired) {
    this.target.removeListener(this.type, this.wrapFn);
    this.fired = true;
    if (arguments.length === 0)
      return this.listener.call(this.target);
    return this.listener.apply(this.target, arguments);
  }
}

function _onceWrap(target, type, listener) {
  var state = { fired: false, wrapFn: undefined, target: target, type: type, listener: listener };
  var wrapped = onceWrapper.bind(state);
  wrapped.listener = listener;
  state.wrapFn = wrapped;
  return wrapped;
}

EventEmitter.prototype.once = function once(type, listener) {
  checkListener(listener);
  this.on(type, _onceWrap(this, type, listener));
  return this;
};

EventEmitter.prototype.prependOnceListener =
    function prependOnceListener(type, listener) {
      checkListener(listener);
      this.prependListener(type, _onceWrap(this, type, listener));
      return this;
    };

// Emits a 'removeListener' event if and only if the listener was removed.
EventEmitter.prototype.removeListener =
    function removeListener(type, listener) {
      var list, events, position, i, originalListener;

      checkListener(listener);

      events = this._events;
      if (events === undefined)
        return this;

      list = events[type];
      if (list === undefined)
        return this;

      if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0)
          this._events = Object.create(null);
        else {
          delete events[type];
          if (events.removeListener)
            this.emit('removeListener', type, list.listener || listener);
        }
      } else if (typeof list !== 'function') {
        position = -1;

        for (i = list.length - 1; i >= 0; i--) {
          if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
          }
        }

        if (position < 0)
          return this;

        if (position === 0)
          list.shift();
        else {
          spliceOne(list, position);
        }

        if (list.length === 1)
          events[type] = list[0];

        if (events.removeListener !== undefined)
          this.emit('removeListener', type, originalListener || listener);
      }

      return this;
    };

EventEmitter.prototype.off = EventEmitter.prototype.removeListener;

EventEmitter.prototype.removeAllListeners =
    function removeAllListeners(type) {
      var listeners, events, i;

      events = this._events;
      if (events === undefined)
        return this;

      // not listening for removeListener, no need to emit
      if (events.removeListener === undefined) {
        if (arguments.length === 0) {
          this._events = Object.create(null);
          this._eventsCount = 0;
        } else if (events[type] !== undefined) {
          if (--this._eventsCount === 0)
            this._events = Object.create(null);
          else
            delete events[type];
        }
        return this;
      }

      // emit removeListener for all listeners on all events
      if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for (i = 0; i < keys.length; ++i) {
          key = keys[i];
          if (key === 'removeListener') continue;
          this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
      }

      listeners = events[type];

      if (typeof listeners === 'function') {
        this.removeListener(type, listeners);
      } else if (listeners !== undefined) {
        // LIFO order
        for (i = listeners.length - 1; i >= 0; i--) {
          this.removeListener(type, listeners[i]);
        }
      }

      return this;
    };

function _listeners(target, type, unwrap) {
  var events = target._events;

  if (events === undefined)
    return [];

  var evlistener = events[type];
  if (evlistener === undefined)
    return [];

  if (typeof evlistener === 'function')
    return unwrap ? [evlistener.listener || evlistener] : [evlistener];

  return unwrap ?
    unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
}

EventEmitter.prototype.listeners = function listeners(type) {
  return _listeners(this, type, true);
};

EventEmitter.prototype.rawListeners = function rawListeners(type) {
  return _listeners(this, type, false);
};

EventEmitter.listenerCount = function(emitter, type) {
  if (typeof emitter.listenerCount === 'function') {
    return emitter.listenerCount(type);
  } else {
    return listenerCount.call(emitter, type);
  }
};

EventEmitter.prototype.listenerCount = listenerCount;
function listenerCount(type) {
  var events = this._events;

  if (events !== undefined) {
    var evlistener = events[type];

    if (typeof evlistener === 'function') {
      return 1;
    } else if (evlistener !== undefined) {
      return evlistener.length;
    }
  }

  return 0;
}

EventEmitter.prototype.eventNames = function eventNames() {
  return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
};

function arrayClone(arr, n) {
  var copy = new Array(n);
  for (var i = 0; i < n; ++i)
    copy[i] = arr[i];
  return copy;
}

function spliceOne(list, index) {
  for (; index + 1 < list.length; index++)
    list[index] = list[index + 1];
  list.pop();
}

function unwrapListeners(arr) {
  var ret = new Array(arr.length);
  for (var i = 0; i < ret.length; ++i) {
    ret[i] = arr[i].listener || arr[i];
  }
  return ret;
}

function once(emitter, name) {
  return new Promise(function (resolve, reject) {
    function errorListener(err) {
      emitter.removeListener(name, resolver);
      reject(err);
    }

    function resolver() {
      if (typeof emitter.removeListener === 'function') {
        emitter.removeListener('error', errorListener);
      }
      resolve([].slice.call(arguments));
    };

    eventTargetAgnosticAddListener(emitter, name, resolver, { once: true });
    if (name !== 'error') {
      addErrorHandlerIfEventEmitter(emitter, errorListener, { once: true });
    }
  });
}

function addErrorHandlerIfEventEmitter(emitter, handler, flags) {
  if (typeof emitter.on === 'function') {
    eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
  }
}

function eventTargetAgnosticAddListener(emitter, name, listener, flags) {
  if (typeof emitter.on === 'function') {
    if (flags.once) {
      emitter.once(name, listener);
    } else {
      emitter.on(name, listener);
    }
  } else if (typeof emitter.addEventListener === 'function') {
    // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
      // IE does not have builtin `{ once: true }` support so we
      // have to do it manually.
      if (flags.once) {
        emitter.removeEventListener(name, wrapListener);
      }
      listener(arg);
    });
  } else {
    throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
  }
}


/***/ }),

/***/ 11470:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var options_1 = __webpack_require__(75961);
var delay_factory_1 = __webpack_require__(65316);
function backOff(request, options) {
    if (options === void 0) { options = {}; }
    return __awaiter(this, void 0, void 0, function () {
        var sanitizedOptions, backOff;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    sanitizedOptions = options_1.getSanitizedOptions(options);
                    backOff = new BackOff(request, sanitizedOptions);
                    return [4 /*yield*/, backOff.execute()];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
exports.backOff = backOff;
var BackOff = /** @class */ (function () {
    function BackOff(request, options) {
        this.request = request;
        this.options = options;
        this.attemptNumber = 0;
    }
    BackOff.prototype.execute = function () {
        return __awaiter(this, void 0, void 0, function () {
            var e_1, shouldRetry;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!this.attemptLimitReached) return [3 /*break*/, 7];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 6]);
                        return [4 /*yield*/, this.applyDelay()];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.request()];
                    case 3: return [2 /*return*/, _a.sent()];
                    case 4:
                        e_1 = _a.sent();
                        this.attemptNumber++;
                        return [4 /*yield*/, this.options.retry(e_1, this.attemptNumber)];
                    case 5:
                        shouldRetry = _a.sent();
                        if (!shouldRetry || this.attemptLimitReached) {
                            throw e_1;
                        }
                        return [3 /*break*/, 6];
                    case 6: return [3 /*break*/, 0];
                    case 7: throw new Error("Something went wrong.");
                }
            });
        });
    };
    Object.defineProperty(BackOff.prototype, "attemptLimitReached", {
        get: function () {
            return this.attemptNumber >= this.options.numOfAttempts;
        },
        enumerable: true,
        configurable: true
    });
    BackOff.prototype.applyDelay = function () {
        return __awaiter(this, void 0, void 0, function () {
            var delay;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        delay = delay_factory_1.DelayFactory(this.options, this.attemptNumber);
                        return [4 /*yield*/, delay.apply()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    return BackOff;
}());
//# sourceMappingURL=backoff.js.map

/***/ }),

/***/ 63745:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", ({ value: true }));
var delay_base_1 = __webpack_require__(39231);
var AlwaysDelay = /** @class */ (function (_super) {
    __extends(AlwaysDelay, _super);
    function AlwaysDelay() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return AlwaysDelay;
}(delay_base_1.Delay));
exports.AlwaysDelay = AlwaysDelay;
//# sourceMappingURL=always.delay.js.map

/***/ }),

/***/ 39231:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var jitter_factory_1 = __webpack_require__(60055);
var Delay = /** @class */ (function () {
    function Delay(options) {
        this.options = options;
        this.attempt = 0;
    }
    Delay.prototype.apply = function () {
        var _this = this;
        return new Promise(function (resolve) { return setTimeout(resolve, _this.jitteredDelay); });
    };
    Delay.prototype.setAttemptNumber = function (attempt) {
        this.attempt = attempt;
    };
    Object.defineProperty(Delay.prototype, "jitteredDelay", {
        get: function () {
            var jitter = jitter_factory_1.JitterFactory(this.options);
            return jitter(this.delay);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Delay.prototype, "delay", {
        get: function () {
            var constant = this.options.startingDelay;
            var base = this.options.timeMultiple;
            var power = this.numOfDelayedAttempts;
            var delay = constant * Math.pow(base, power);
            return Math.min(delay, this.options.maxDelay);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Delay.prototype, "numOfDelayedAttempts", {
        get: function () {
            return this.attempt;
        },
        enumerable: true,
        configurable: true
    });
    return Delay;
}());
exports.Delay = Delay;
//# sourceMappingURL=delay.base.js.map

/***/ }),

/***/ 65316:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var skip_first_delay_1 = __webpack_require__(36955);
var always_delay_1 = __webpack_require__(63745);
function DelayFactory(options, attempt) {
    var delay = initDelayClass(options);
    delay.setAttemptNumber(attempt);
    return delay;
}
exports.DelayFactory = DelayFactory;
function initDelayClass(options) {
    if (!options.delayFirstAttempt) {
        return new skip_first_delay_1.SkipFirstDelay(options);
    }
    return new always_delay_1.AlwaysDelay(options);
}
//# sourceMappingURL=delay.factory.js.map

/***/ }),

/***/ 36955:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var delay_base_1 = __webpack_require__(39231);
var SkipFirstDelay = /** @class */ (function (_super) {
    __extends(SkipFirstDelay, _super);
    function SkipFirstDelay() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SkipFirstDelay.prototype.apply = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.isFirstAttempt ? true : _super.prototype.apply.call(this)];
            });
        });
    };
    Object.defineProperty(SkipFirstDelay.prototype, "isFirstAttempt", {
        get: function () {
            return this.attempt === 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SkipFirstDelay.prototype, "numOfDelayedAttempts", {
        get: function () {
            return this.attempt - 1;
        },
        enumerable: true,
        configurable: true
    });
    return SkipFirstDelay;
}(delay_base_1.Delay));
exports.SkipFirstDelay = SkipFirstDelay;
//# sourceMappingURL=skip-first.delay.js.map

/***/ }),

/***/ 4640:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
function fullJitter(delay) {
    var jitteredDelay = Math.random() * delay;
    return Math.round(jitteredDelay);
}
exports.fullJitter = fullJitter;
//# sourceMappingURL=full.jitter.js.map

/***/ }),

/***/ 60055:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var full_jitter_1 = __webpack_require__(4640);
var no_jitter_1 = __webpack_require__(2337);
function JitterFactory(options) {
    switch (options.jitter) {
        case "full":
            return full_jitter_1.fullJitter;
        case "none":
        default:
            return no_jitter_1.noJitter;
    }
}
exports.JitterFactory = JitterFactory;
//# sourceMappingURL=jitter.factory.js.map

/***/ }),

/***/ 2337:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
function noJitter(delay) {
    return delay;
}
exports.noJitter = noJitter;
//# sourceMappingURL=no.jitter.js.map

/***/ }),

/***/ 75961:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var defaultOptions = {
    delayFirstAttempt: false,
    jitter: "none",
    maxDelay: Infinity,
    numOfAttempts: 10,
    retry: function () { return true; },
    startingDelay: 100,
    timeMultiple: 2
};
function getSanitizedOptions(options) {
    var sanitized = __assign(__assign({}, defaultOptions), options);
    if (sanitized.numOfAttempts < 1) {
        sanitized.numOfAttempts = 1;
    }
    return sanitized;
}
exports.getSanitizedOptions = getSanitizedOptions;
//# sourceMappingURL=options.js.map

/***/ }),

/***/ 55278:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isCallable = __webpack_require__(72922);

var toStr = Object.prototype.toString;
var hasOwnProperty = Object.prototype.hasOwnProperty;

var forEachArray = function forEachArray(array, iterator, receiver) {
    for (var i = 0, len = array.length; i < len; i++) {
        if (hasOwnProperty.call(array, i)) {
            if (receiver == null) {
                iterator(array[i], i, array);
            } else {
                iterator.call(receiver, array[i], i, array);
            }
        }
    }
};

var forEachString = function forEachString(string, iterator, receiver) {
    for (var i = 0, len = string.length; i < len; i++) {
        // no such thing as a sparse string.
        if (receiver == null) {
            iterator(string.charAt(i), i, string);
        } else {
            iterator.call(receiver, string.charAt(i), i, string);
        }
    }
};

var forEachObject = function forEachObject(object, iterator, receiver) {
    for (var k in object) {
        if (hasOwnProperty.call(object, k)) {
            if (receiver == null) {
                iterator(object[k], k, object);
            } else {
                iterator.call(receiver, object[k], k, object);
            }
        }
    }
};

var forEach = function forEach(list, iterator, thisArg) {
    if (!isCallable(iterator)) {
        throw new TypeError('iterator must be a function');
    }

    var receiver;
    if (arguments.length >= 3) {
        receiver = thisArg;
    }

    if (toStr.call(list) === '[object Array]') {
        forEachArray(list, iterator, receiver);
    } else if (typeof list === 'string') {
        forEachString(list, iterator, receiver);
    } else {
        forEachObject(list, iterator, receiver);
    }
};

module.exports = forEach;


/***/ }),

/***/ 68458:
/***/ (function(module) {

"use strict";


/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var slice = Array.prototype.slice;
var toStr = Object.prototype.toString;
var funcType = '[object Function]';

module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr.call(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slice.call(arguments, 1);

    var bound;
    var binder = function () {
        if (this instanceof bound) {
            var result = target.apply(
                this,
                args.concat(slice.call(arguments))
            );
            if (Object(result) === result) {
                return result;
            }
            return this;
        } else {
            return target.apply(
                that,
                args.concat(slice.call(arguments))
            );
        }
    };

    var boundLength = Math.max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs.push('$' + i);
    }

    bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};


/***/ }),

/***/ 20132:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(68458);

module.exports = Function.prototype.bind || implementation;


/***/ }),

/***/ 40679:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var origSymbol = typeof Symbol !== 'undefined' && Symbol;
var hasSymbolSham = __webpack_require__(8186);

module.exports = function hasNativeSymbols() {
	if (typeof origSymbol !== 'function') { return false; }
	if (typeof Symbol !== 'function') { return false; }
	if (typeof origSymbol('foo') !== 'symbol') { return false; }
	if (typeof Symbol('bar') !== 'symbol') { return false; }

	return hasSymbolSham();
};


/***/ }),

/***/ 8186:
/***/ (function(module) {

"use strict";


/* eslint complexity: [2, 18], max-statements: [2, 33] */
module.exports = function hasSymbols() {
	if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
	if (typeof Symbol.iterator === 'symbol') { return true; }

	var obj = {};
	var sym = Symbol('test');
	var symObj = Object(sym);
	if (typeof sym === 'string') { return false; }

	if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
	if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }

	// temp disabled per https://github.com/ljharb/object.assign/issues/17
	// if (sym instanceof Symbol) { return false; }
	// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
	// if (!(symObj instanceof Symbol)) { return false; }

	// if (typeof Symbol.prototype.toString !== 'function') { return false; }
	// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

	var symVal = 42;
	obj[sym] = symVal;
	for (sym in obj) { return false; } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
	if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }

	if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }

	var syms = Object.getOwnPropertySymbols(obj);
	if (syms.length !== 1 || syms[0] !== sym) { return false; }

	if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }

	if (typeof Object.getOwnPropertyDescriptor === 'function') {
		var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
		if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
	}

	return true;
};


/***/ }),

/***/ 10698:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var hasSymbols = __webpack_require__(8186);

module.exports = function hasToStringTagShams() {
	return hasSymbols() && !!Symbol.toStringTag;
};


/***/ }),

/***/ 77492:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(20132);

module.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);


/***/ }),

/***/ 55839:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(12097);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),

/***/ 14173:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),

/***/ 12097:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(14173);
} else {}


/***/ }),

/***/ 78898:
/***/ (function(__unused_webpack_module, exports) {

/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),

/***/ 70087:
/***/ (function(module) {

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor
      ctor.prototype = Object.create(superCtor.prototype, {
        constructor: {
          value: ctor,
          enumerable: false,
          writable: true,
          configurable: true
        }
      })
    }
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor
      var TempCtor = function () {}
      TempCtor.prototype = superCtor.prototype
      ctor.prototype = new TempCtor()
      ctor.prototype.constructor = ctor
    }
  }
}


/***/ }),

/***/ 47740:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var hasToStringTag = __webpack_require__(10698)();
var callBound = __webpack_require__(12737);

var $toString = callBound('Object.prototype.toString');

var isStandardArguments = function isArguments(value) {
	if (hasToStringTag && value && typeof value === 'object' && Symbol.toStringTag in value) {
		return false;
	}
	return $toString(value) === '[object Arguments]';
};

var isLegacyArguments = function isArguments(value) {
	if (isStandardArguments(value)) {
		return true;
	}
	return value !== null &&
		typeof value === 'object' &&
		typeof value.length === 'number' &&
		value.length >= 0 &&
		$toString(value) !== '[object Array]' &&
		$toString(value.callee) === '[object Function]';
};

var supportsStandardArguments = (function () {
	return isStandardArguments(arguments);
}());

isStandardArguments.isLegacyArguments = isLegacyArguments; // for tests

module.exports = supportsStandardArguments ? isStandardArguments : isLegacyArguments;


/***/ }),

/***/ 72922:
/***/ (function(module) {

"use strict";


var fnToStr = Function.prototype.toString;
var reflectApply = typeof Reflect === 'object' && Reflect !== null && Reflect.apply;
var badArrayLike;
var isCallableMarker;
if (typeof reflectApply === 'function' && typeof Object.defineProperty === 'function') {
	try {
		badArrayLike = Object.defineProperty({}, 'length', {
			get: function () {
				throw isCallableMarker;
			}
		});
		isCallableMarker = {};
		// eslint-disable-next-line no-throw-literal
		reflectApply(function () { throw 42; }, null, badArrayLike);
	} catch (_) {
		if (_ !== isCallableMarker) {
			reflectApply = null;
		}
	}
} else {
	reflectApply = null;
}

var constructorRegex = /^\s*class\b/;
var isES6ClassFn = function isES6ClassFunction(value) {
	try {
		var fnStr = fnToStr.call(value);
		return constructorRegex.test(fnStr);
	} catch (e) {
		return false; // not a function
	}
};

var tryFunctionObject = function tryFunctionToStr(value) {
	try {
		if (isES6ClassFn(value)) { return false; }
		fnToStr.call(value);
		return true;
	} catch (e) {
		return false;
	}
};
var toStr = Object.prototype.toString;
var fnClass = '[object Function]';
var genClass = '[object GeneratorFunction]';
var hasToStringTag = typeof Symbol === 'function' && !!Symbol.toStringTag; // better: use `has-tostringtag`
/* globals document: false */
var documentDotAll = typeof document === 'object' && typeof document.all === 'undefined' && document.all !== undefined ? document.all : {};

module.exports = reflectApply
	? function isCallable(value) {
		if (value === documentDotAll) { return true; }
		if (!value) { return false; }
		if (typeof value !== 'function' && typeof value !== 'object') { return false; }
		if (typeof value === 'function' && !value.prototype) { return true; }
		try {
			reflectApply(value, null, badArrayLike);
		} catch (e) {
			if (e !== isCallableMarker) { return false; }
		}
		return !isES6ClassFn(value);
	}
	: function isCallable(value) {
		if (value === documentDotAll) { return true; }
		if (!value) { return false; }
		if (typeof value !== 'function' && typeof value !== 'object') { return false; }
		if (typeof value === 'function' && !value.prototype) { return true; }
		if (hasToStringTag) { return tryFunctionObject(value); }
		if (isES6ClassFn(value)) { return false; }
		var strClass = toStr.call(value);
		return strClass === fnClass || strClass === genClass;
	};


/***/ }),

/***/ 18265:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var toStr = Object.prototype.toString;
var fnToStr = Function.prototype.toString;
var isFnRegex = /^\s*(?:function)?\*/;
var hasToStringTag = __webpack_require__(10698)();
var getProto = Object.getPrototypeOf;
var getGeneratorFunc = function () { // eslint-disable-line consistent-return
	if (!hasToStringTag) {
		return false;
	}
	try {
		return Function('return function*() {}')();
	} catch (e) {
	}
};
var GeneratorFunction;

module.exports = function isGeneratorFunction(fn) {
	if (typeof fn !== 'function') {
		return false;
	}
	if (isFnRegex.test(fnToStr.call(fn))) {
		return true;
	}
	if (!hasToStringTag) {
		var str = toStr.call(fn);
		return str === '[object GeneratorFunction]';
	}
	if (!getProto) {
		return false;
	}
	if (typeof GeneratorFunction === 'undefined') {
		var generatorFunc = getGeneratorFunc();
		GeneratorFunction = generatorFunc ? getProto(generatorFunc) : false;
	}
	return getProto(fn) === GeneratorFunction;
};


/***/ }),

/***/ 76844:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* export default binding */ __WEBPACK_DEFAULT_EXPORT__; }
/* harmony export */ });
/* harmony default export */ function __WEBPACK_DEFAULT_EXPORT__(n){return{all:n=n||new Map,on:function(t,e){var i=n.get(t);i&&i.push(e)||n.set(t,[e])},off:function(t,e){var i=n.get(t);i&&i.splice(i.indexOf(e)>>>0,1)},emit:function(t,e){(n.get(t)||[]).slice().map(function(n){n(e)}),(n.get("*")||[]).slice().map(function(n){n(t,e)})}}}
//# sourceMappingURL=mitt.es.js.map


/***/ }),

/***/ 31388:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(63239)


/***/ }),

/***/ 36321:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_app",
      function () {
        return __webpack_require__(96529);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 90729:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _sentry_nextjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6464);
/* provided dependency */ var process = __webpack_require__(27061);
var _sentryCollisionFreeGlobalObject =  false ? 0 : window;
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {
    "id": "ee64fa18388a20d6b60fb833a576307ea0e58f8b"
};
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";
// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

var SENTRY_DSN = "https://1c92b0a3e49b41d396274c40f70c6095@o1059325.ingest.sentry.io/6047793" || 0;
var ALLOWED_DOMAINS = [
    /.+\.puma.com/i,
    /.+\.cybercat.cloud/i
];
_sentry_nextjs__WEBPACK_IMPORTED_MODULE_0__/* .init */ .S1({
    dsn: SENTRY_DSN,
    environment: "production",
    release: "puma-web@".concat(process.env.VERSION),
    allowUrls: ALLOWED_DOMAINS,
    tracePropagationTargets: ALLOWED_DOMAINS,
    ignoreErrors: [
        // TODO(ResizeObserver): Track down if this is a real error
        // - Might be Cypress related https://github.com/quasarframework/quasar/issues/2233
        // - This fix: https://forum.sentry.io/t/resizeobserver-loop-limit-exceeded/8402
        "ResizeObserver loop limit exceeded",
        "ResizeObserver loop completed with undelivered notifications",
        "The user aborted a request", 
    ],
    sampleRate: 0.1,
    tracesSampleRate: 0.1
});


/***/ }),

/***/ 41528:
/***/ (function(module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.getDomainLocale = getDomainLocale;
var basePath = (/* unused pure expression or super */ null && ( false || ""));
function getDomainLocale(path, locale, locales, domainLocales) {
    if (false) { var finalLocale, proto, domain, target, detectDomainLocale, normalizeLocalePath; } else {
        return false;
    }
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=get-domain-locale.js.map


/***/ }),

/***/ 11453:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _slicedToArray = (__webpack_require__(69854)/* ["default"] */ .Z);
var _typeOf = (__webpack_require__(92271)["default"]);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _interop_require_default = (__webpack_require__(42619)/* ["default"] */ .Z);
var _object_without_properties_loose = (__webpack_require__(90518)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(27378));
var _router = __webpack_require__(30194);
var _addLocale = __webpack_require__(24087);
var _routerContext = __webpack_require__(49756);
var _appRouterContext = __webpack_require__(82627);
var _useIntersection = __webpack_require__(41842);
var _getDomainLocale = __webpack_require__(41528);
var _addBasePath = __webpack_require__(91470);
// @ts-ignore useTransition exist
var hasUseTransition = typeof _react.default.useTransition !== "undefined";
var prefetched = {};
function prefetch(router, href, as, options) {
    if ( false || !router) return;
    if (!(0, _router).isLocalURL(href)) return;
    // Prefetch the JSON page if asked (only in the client)
    // We need to handle a prefetch error here since we may be
    // loading with priority which can reject but we don't
    // want to force navigation since this is only a prefetch
    Promise.resolve(router.prefetch(href, as, options)).catch(function(err) {
        if (false) {}
    });
    var curLocale = options && typeof options.locale !== "undefined" ? options.locale : router && router.locale;
    // Join on an invalid URI character
    prefetched[href + "%" + as + (curLocale ? "%" + curLocale : "")] = true;
}
function isModifiedEvent(event) {
    var target = event.currentTarget.target;
    return target && target !== "_self" || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.nativeEvent && event.nativeEvent.which === 2;
}
function linkClicked(e, router, href, as, replace, shallow, scroll, locale, startTransition, prefetchEnabled) {
    var nodeName = e.currentTarget.nodeName;
    // anchors inside an svg have a lowercase nodeName
    var isAnchorNodeName = nodeName.toUpperCase() === "A";
    if (isAnchorNodeName && (isModifiedEvent(e) || !(0, _router).isLocalURL(href))) {
        // ignore click for browser’s default behavior
        return;
    }
    e.preventDefault();
    var navigate = function() {
        // If the router is an NextRouter instance it will have `beforePopState`
        if ("beforePopState" in router) {
            router[replace ? "replace" : "push"](href, as, {
                shallow: shallow,
                locale: locale,
                scroll: scroll
            });
        } else {
            // If `beforePopState` doesn't exist on the router it's the AppRouter.
            var method = replace ? "replace" : "push";
            router[method](href, {
                forceOptimisticNavigation: !prefetchEnabled
            });
        }
    };
    if (startTransition) {
        startTransition(navigate);
    } else {
        navigate();
    }
}
var Link = /*#__PURE__*/ _react.default.forwardRef(function LinkComponent(props, forwardedRef) {
    if (false) { var hasWarned, optionalProps, optionalPropsGuard, requiredProps, requiredPropsGuard, createPropError; }
    var children;
    var hrefProp = props.href, asProp = props.as, childrenProp = props.children, prefetchProp = props.prefetch, passHref = props.passHref, replace = props.replace, shallow = props.shallow, scroll = props.scroll, locale = props.locale, onClick = props.onClick, onMouseEnter = props.onMouseEnter, onTouchStart = props.onTouchStart, _legacyBehavior = props.legacyBehavior, legacyBehavior = _legacyBehavior === void 0 ? Boolean(false) !== true : _legacyBehavior, restProps = _object_without_properties_loose(props, [
        "href",
        "as",
        "children",
        "prefetch",
        "passHref",
        "replace",
        "shallow",
        "scroll",
        "locale",
        "onClick",
        "onMouseEnter",
        "onTouchStart",
        "legacyBehavior"
    ]);
    children = childrenProp;
    if (legacyBehavior && (typeof children === "string" || typeof children === "number")) {
        children = /*#__PURE__*/ _react.default.createElement("a", null, children);
    }
    var p = prefetchProp !== false;
    var ref = _slicedToArray(hasUseTransition ? // @ts-ignore useTransition exists
    // eslint-disable-next-line react-hooks/rules-of-hooks
    _react.default.useTransition() : [], 2), /* isPending */ startTransition = ref[1];
    var router = _react.default.useContext(_routerContext.RouterContext);
    // TODO-APP: type error. Remove `as any`
    var appRouter = _react.default.useContext(_appRouterContext.AppRouterContext);
    if (appRouter) {
        router = appRouter;
    }
    var ref1 = _react.default.useMemo(function() {
        var ref = _slicedToArray((0, _router).resolveHref(router, hrefProp, true), 2), resolvedHref = ref[0], resolvedAs = ref[1];
        return {
            href: resolvedHref,
            as: asProp ? (0, _router).resolveHref(router, asProp) : resolvedAs || resolvedHref
        };
    }, [
        router,
        hrefProp,
        asProp
    ]), href = ref1.href, as = ref1.as;
    var previousHref = _react.default.useRef(href);
    var previousAs = _react.default.useRef(as);
    // This will return the first child, if multiple are provided it will throw an error
    var child;
    if (legacyBehavior) {
        if (false) {} else {
            child = _react.default.Children.only(children);
        }
    }
    var childRef = legacyBehavior ? child && typeof child === "object" && child.ref : forwardedRef;
    var ref2 = _slicedToArray((0, _useIntersection).useIntersection({
        rootMargin: "200px"
    }), 3), setIntersectionRef = ref2[0], isVisible = ref2[1], resetVisible = ref2[2];
    var setRef = _react.default.useCallback(function(el) {
        // Before the link getting observed, check if visible state need to be reset
        if (previousAs.current !== as || previousHref.current !== href) {
            resetVisible();
            previousAs.current = as;
            previousHref.current = href;
        }
        setIntersectionRef(el);
        if (childRef) {
            if (typeof childRef === "function") childRef(el);
            else if (typeof childRef === "object") {
                childRef.current = el;
            }
        }
    }, [
        as,
        childRef,
        href,
        resetVisible,
        setIntersectionRef
    ]);
    _react.default.useEffect(function() {
        var shouldPrefetch = isVisible && p && (0, _router).isLocalURL(href);
        var curLocale = typeof locale !== "undefined" ? locale : router && router.locale;
        var isPrefetched = prefetched[href + "%" + as + (curLocale ? "%" + curLocale : "")];
        if (shouldPrefetch && !isPrefetched) {
            prefetch(router, href, as, {
                locale: curLocale
            });
        }
    }, [
        as,
        href,
        isVisible,
        locale,
        p,
        router
    ]);
    var childProps = {
        ref: setRef,
        onClick: function(e) {
            if (false) {}
            if (!legacyBehavior && typeof onClick === "function") {
                onClick(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onClick === "function") {
                child.props.onClick(e);
            }
            if (!e.defaultPrevented) {
                linkClicked(e, router, href, as, replace, shallow, scroll, locale, appRouter ? startTransition : undefined, p);
            }
        },
        onMouseEnter: function(e) {
            if (!legacyBehavior && typeof onMouseEnter === "function") {
                onMouseEnter(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onMouseEnter === "function") {
                child.props.onMouseEnter(e);
            }
            // Check for not prefetch disabled in page using appRouter
            if (!(!p && appRouter)) {
                if ((0, _router).isLocalURL(href)) {
                    prefetch(router, href, as, {
                        priority: true
                    });
                }
            }
        },
        onTouchStart: function(e) {
            if (!legacyBehavior && typeof onTouchStart === "function") {
                onTouchStart(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onTouchStart === "function") {
                child.props.onTouchStart(e);
            }
            // Check for not prefetch disabled in page using appRouter
            if (!(!p && appRouter)) {
                if ((0, _router).isLocalURL(href)) {
                    prefetch(router, href, as, {
                        priority: true
                    });
                }
            }
        }
    };
    // If child is an <a> tag and doesn't have a href attribute, or if the 'passHref' property is
    // defined, we specify the current 'href', so that repetition is not needed by the user
    if (!legacyBehavior || passHref || child.type === "a" && !("href" in child.props)) {
        var curLocale = typeof locale !== "undefined" ? locale : router && router.locale;
        // we only render domain locales if we are currently on a domain locale
        // so that locale links are still visitable in development/preview envs
        var localeDomain = router && router.isLocaleDomain && (0, _getDomainLocale).getDomainLocale(as, curLocale, router.locales, router.domainLocales);
        childProps.href = localeDomain || (0, _addBasePath).addBasePath((0, _addLocale).addLocale(as, curLocale, router && router.defaultLocale));
    }
    return legacyBehavior ? /*#__PURE__*/ _react.default.cloneElement(child, childProps) : /*#__PURE__*/ _react.default.createElement("a", Object.assign({}, restProps, childProps), children);
});
var _default = Link;
exports["default"] = _default;
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=link.js.map


/***/ }),

/***/ 41842:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _slicedToArray = (__webpack_require__(69854)/* ["default"] */ .Z);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.useIntersection = useIntersection;
var _react = __webpack_require__(27378);
var _requestIdleCallback = __webpack_require__(72878);
var hasIntersectionObserver = typeof IntersectionObserver === "function";
var observers = new Map();
var idList = [];
function createObserver(options) {
    var id = {
        root: options.root || null,
        margin: options.rootMargin || ""
    };
    var existing = idList.find(function(obj) {
        return obj.root === id.root && obj.margin === id.margin;
    });
    var instance;
    if (existing) {
        instance = observers.get(existing);
        if (instance) {
            return instance;
        }
    }
    var elements = new Map();
    var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
            var callback = elements.get(entry.target);
            var isVisible = entry.isIntersecting || entry.intersectionRatio > 0;
            if (callback && isVisible) {
                callback(isVisible);
            }
        });
    }, options);
    instance = {
        id: id,
        observer: observer,
        elements: elements
    };
    idList.push(id);
    observers.set(id, instance);
    return instance;
}
function observe(element, callback, options) {
    var ref = createObserver(options), id = ref.id, observer = ref.observer, elements = ref.elements;
    elements.set(element, callback);
    observer.observe(element);
    return function unobserve() {
        elements.delete(element);
        observer.unobserve(element);
        // Destroy observer when there's nothing left to watch:
        if (elements.size === 0) {
            observer.disconnect();
            observers.delete(id);
            var index = idList.findIndex(function(obj) {
                return obj.root === id.root && obj.margin === id.margin;
            });
            if (index > -1) {
                idList.splice(index, 1);
            }
        }
    };
}
function useIntersection(param) {
    var rootRef = param.rootRef, rootMargin = param.rootMargin, disabled = param.disabled;
    var isDisabled = disabled || !hasIntersectionObserver;
    var ref = _slicedToArray((0, _react).useState(false), 2), visible = ref[0], setVisible = ref[1];
    var ref1 = _slicedToArray((0, _react).useState(null), 2), element = ref1[0], setElement = ref1[1];
    (0, _react).useEffect(function() {
        if (hasIntersectionObserver) {
            if (isDisabled || visible) return;
            if (element && element.tagName) {
                var unobserve = observe(element, function(isVisible) {
                    return isVisible && setVisible(isVisible);
                }, {
                    root: rootRef == null ? void 0 : rootRef.current,
                    rootMargin: rootMargin
                });
                return unobserve;
            }
        } else {
            if (!visible) {
                var idleCallback = (0, _requestIdleCallback).requestIdleCallback(function() {
                    return setVisible(true);
                });
                return function() {
                    return (0, _requestIdleCallback).cancelIdleCallback(idleCallback);
                };
            }
        }
    }, [
        element,
        isDisabled,
        rootMargin,
        rootRef,
        visible
    ]);
    var resetVisible = (0, _react).useCallback(function() {
        setVisible(false);
    }, []);
    return [
        setElement,
        visible,
        resetVisible
    ];
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=use-intersection.js.map


/***/ }),

/***/ 82627:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.GlobalLayoutRouterContext = exports.LayoutRouterContext = exports.AppRouterContext = void 0;
var _interop_require_default = (__webpack_require__(42619)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(27378));
var AppRouterContext = _react.default.createContext(null);
exports.AppRouterContext = AppRouterContext;
var LayoutRouterContext = _react.default.createContext(null);
exports.LayoutRouterContext = LayoutRouterContext;
var GlobalLayoutRouterContext = _react.default.createContext(null);
exports.GlobalLayoutRouterContext = GlobalLayoutRouterContext;
if (false) {} //# sourceMappingURL=app-router-context.js.map


/***/ }),

/***/ 29906:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _instanceof = (__webpack_require__(13210)/* ["default"] */ .Z);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = dynamic;
exports.noSSR = noSSR;
var _extends = (__webpack_require__(76516)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(42619)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(27378));
var _loadable = _interop_require_default(__webpack_require__(62456));
function dynamic(dynamicOptions, options) {
    var loadableFn = _loadable.default;
    var loadableOptions = {
        // A loading component is not required, so we default it
        loading: function(param) {
            var error = param.error, isLoading = param.isLoading, pastDelay = param.pastDelay;
            if (!pastDelay) return null;
            if (false) {}
            return null;
        }
    };
    // Support for direct import(), eg: dynamic(import('../hello-world'))
    // Note that this is only kept for the edge case where someone is passing in a promise as first argument
    // The react-loadable babel plugin will turn dynamic(import('../hello-world')) into dynamic(() => import('../hello-world'))
    // To make sure we don't execute the import without rendering first
    if (_instanceof(dynamicOptions, Promise)) {
        loadableOptions.loader = function() {
            return dynamicOptions;
        };
    // Support for having import as a function, eg: dynamic(() => import('../hello-world'))
    } else if (typeof dynamicOptions === "function") {
        loadableOptions.loader = dynamicOptions;
    // Support for having first argument being options, eg: dynamic({loader: import('../hello-world')})
    } else if (typeof dynamicOptions === "object") {
        loadableOptions = _extends({}, loadableOptions, dynamicOptions);
    }
    // Support for passing options, eg: dynamic(import('../hello-world'), {loading: () => <p>Loading something</p>})
    loadableOptions = _extends({}, loadableOptions, options);
    // Error if Fizz rendering is not enabled and `suspense` option is set to true
    if ( true && loadableOptions.suspense) {
        throw new Error("Invalid suspense option usage in next/dynamic. Read more: https://nextjs.org/docs/messages/invalid-dynamic-suspense");
    }
    if (false) {}
    // coming from build/babel/plugins/react-loadable-plugin.js
    if (loadableOptions.loadableGenerated) {
        loadableOptions = _extends({}, loadableOptions, loadableOptions.loadableGenerated);
        delete loadableOptions.loadableGenerated;
    }
    // support for disabling server side rendering, eg: dynamic(import('../hello-world'), {ssr: false}).
    // skip `ssr` for suspense mode and opt-in React.lazy directly
    if (typeof loadableOptions.ssr === "boolean" && !loadableOptions.suspense) {
        if (!loadableOptions.ssr) {
            delete loadableOptions.ssr;
            return noSSR(loadableFn, loadableOptions);
        }
        delete loadableOptions.ssr;
    }
    return loadableFn(loadableOptions);
}
var isServerSide = "object" === "undefined";
function noSSR(LoadableInitializer, loadableOptions) {
    // Removing webpack and modules means react-loadable won't try preloading
    delete loadableOptions.webpack;
    delete loadableOptions.modules;
    // This check is necessary to prevent react-loadable from initializing on the server
    if (!isServerSide) {
        return LoadableInitializer(loadableOptions);
    }
    var Loading = loadableOptions.loading;
    // This will only be rendered on the server side
    return function() {
        return /*#__PURE__*/ _react.default.createElement(Loading, {
            error: null,
            isLoading: true,
            pastDelay: false,
            timedOut: false
        });
    };
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=dynamic.js.map


/***/ }),

/***/ 37815:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.LoadableContext = void 0;
var _interop_require_default = (__webpack_require__(42619)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(27378));
var LoadableContext = _react.default.createContext(null);
exports.LoadableContext = LoadableContext;
if (false) {} //# sourceMappingURL=loadable-context.js.map


/***/ }),

/***/ 62456:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _classCallCheck = (__webpack_require__(30093)/* ["default"] */ .Z);
var _createClass = (__webpack_require__(27758)/* ["default"] */ .Z);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _extends = (__webpack_require__(76516)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(42619)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(27378));
var _loadableContext = __webpack_require__(37815);
var useSyncExternalStore = ( false ? 0 : __webpack_require__(70644)).useSyncExternalStore;
var ALL_INITIALIZERS = [];
var READY_INITIALIZERS = [];
var initialized = false;
function load(loader) {
    var promise = loader();
    var state = {
        loading: true,
        loaded: null,
        error: null
    };
    state.promise = promise.then(function(loaded) {
        state.loading = false;
        state.loaded = loaded;
        return loaded;
    }).catch(function(err) {
        state.loading = false;
        state.error = err;
        throw err;
    });
    return state;
}
function resolve(obj) {
    return obj && obj.__esModule ? obj.default : obj;
}
function createLoadableComponent(loadFn, options) {
    var init = function init() {
        if (!subscription) {
            var sub = new LoadableSubscription(loadFn, opts);
            subscription = {
                getCurrentValue: sub.getCurrentValue.bind(sub),
                subscribe: sub.subscribe.bind(sub),
                retry: sub.retry.bind(sub),
                promise: sub.promise.bind(sub)
            };
        }
        return subscription.promise();
    };
    var useLoadableModule = function useLoadableModule() {
        init();
        var context = _react.default.useContext(_loadableContext.LoadableContext);
        if (context && Array.isArray(opts.modules)) {
            opts.modules.forEach(function(moduleName) {
                context(moduleName);
            });
        }
    };
    var LoadableImpl = function LoadableImpl(props, ref) {
        useLoadableModule();
        var state = useSyncExternalStore(subscription.subscribe, subscription.getCurrentValue, subscription.getCurrentValue);
        _react.default.useImperativeHandle(ref, function() {
            return {
                retry: subscription.retry
            };
        }, []);
        return _react.default.useMemo(function() {
            if (state.loading || state.error) {
                return _react.default.createElement(opts.loading, {
                    isLoading: state.loading,
                    pastDelay: state.pastDelay,
                    timedOut: state.timedOut,
                    error: state.error,
                    retry: subscription.retry
                });
            } else if (state.loaded) {
                return _react.default.createElement(resolve(state.loaded), props);
            } else {
                return null;
            }
        }, [
            props,
            state
        ]);
    };
    var LazyImpl = function LazyImpl(props, ref) {
        useLoadableModule();
        return _react.default.createElement(opts.lazy, _extends({}, props, {
            ref: ref
        }));
    };
    var opts = Object.assign({
        loader: null,
        loading: null,
        delay: 200,
        timeout: null,
        webpack: null,
        modules: null,
        suspense: false
    }, options);
    if (opts.suspense) {
        opts.lazy = _react.default.lazy(opts.loader);
    }
    /** @type LoadableSubscription */ var subscription = null;
    // Server only
    if (false) {}
    // Client only
    if (!initialized && "object" !== "undefined") {
        // require.resolveWeak check is needed for environments that don't have it available like Jest
        var moduleIds = opts.webpack && "function" === "function" ? opts.webpack() : opts.modules;
        if (moduleIds) {
            READY_INITIALIZERS.push(function(ids) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = moduleIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var moduleId = _step.value;
                        if (ids.indexOf(moduleId) !== -1) {
                            return init();
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            });
        }
    }
    var LoadableComponent = opts.suspense ? LazyImpl : LoadableImpl;
    LoadableComponent.preload = function() {
        return init();
    };
    LoadableComponent.displayName = "LoadableComponent";
    return _react.default.forwardRef(LoadableComponent);
}
var LoadableSubscription = /*#__PURE__*/ function() {
    function LoadableSubscription(loadFn, opts) {
        _classCallCheck(this, LoadableSubscription);
        this._loadFn = loadFn;
        this._opts = opts;
        this._callbacks = new Set();
        this._delay = null;
        this._timeout = null;
        this.retry();
    }
    _createClass(LoadableSubscription, [
        {
            key: "promise",
            value: function promise() {
                return this._res.promise;
            }
        },
        {
            key: "retry",
            value: function retry() {
                var _this = this;
                this._clearTimeouts();
                this._res = this._loadFn(this._opts.loader);
                this._state = {
                    pastDelay: false,
                    timedOut: false
                };
                var ref = this, res = ref._res, opts = ref._opts;
                if (res.loading) {
                    if (typeof opts.delay === "number") {
                        if (opts.delay === 0) {
                            this._state.pastDelay = true;
                        } else {
                            this._delay = setTimeout(function() {
                                _this._update({
                                    pastDelay: true
                                });
                            }, opts.delay);
                        }
                    }
                    if (typeof opts.timeout === "number") {
                        this._timeout = setTimeout(function() {
                            _this._update({
                                timedOut: true
                            });
                        }, opts.timeout);
                    }
                }
                this._res.promise.then(function() {
                    _this._update({});
                    _this._clearTimeouts();
                }).catch(function(_err) {
                    _this._update({});
                    _this._clearTimeouts();
                });
                this._update({});
            }
        },
        {
            key: "_update",
            value: function _update(partial) {
                this._state = _extends({}, this._state, {
                    error: this._res.error,
                    loaded: this._res.loaded,
                    loading: this._res.loading
                }, partial);
                this._callbacks.forEach(function(callback) {
                    return callback();
                });
            }
        },
        {
            key: "_clearTimeouts",
            value: function _clearTimeouts() {
                clearTimeout(this._delay);
                clearTimeout(this._timeout);
            }
        },
        {
            key: "getCurrentValue",
            value: function getCurrentValue() {
                return this._state;
            }
        },
        {
            key: "subscribe",
            value: function subscribe(callback) {
                var _this = this;
                this._callbacks.add(callback);
                return function() {
                    _this._callbacks.delete(callback);
                };
            }
        }
    ]);
    return LoadableSubscription;
}();
function Loadable(opts) {
    return createLoadableComponent(load, opts);
}
function flushInitializers(initializers, ids) {
    var promises = [];
    while(initializers.length){
        var init = initializers.pop();
        promises.push(init(ids));
    }
    return Promise.all(promises).then(function() {
        if (initializers.length) {
            return flushInitializers(initializers, ids);
        }
    });
}
Loadable.preloadAll = function() {
    return new Promise(function(resolveInitializers, reject) {
        flushInitializers(ALL_INITIALIZERS).then(resolveInitializers, reject);
    });
};
Loadable.preloadReady = function() {
    var ids = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return new Promise(function(resolvePreload) {
        var res = function() {
            initialized = true;
            return resolvePreload();
        };
        // We always will resolve, errors should be handled within loading UIs.
        flushInitializers(READY_INITIALIZERS, ids).then(res, res);
    });
};
if (true) {
    window.__NEXT_PRELOADREADY = Loadable.preloadReady;
}
var _default = Loadable;
exports["default"] = _default; //# sourceMappingURL=loadable.js.map


/***/ }),

/***/ 37678:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$Bw": function() { return /* binding */ useLoginWithOtpMutation; },
/* harmony export */   "$It": function() { return /* binding */ useUpdateBillingAddressMutation; },
/* harmony export */   "$_1": function() { return /* binding */ useRegisterAmazonPaymentMutation; },
/* harmony export */   "$m7": function() { return /* binding */ AdyenPaymentMethodSubType; },
/* harmony export */   "$yP": function() { return /* binding */ useGetPayPayContentQuery; },
/* harmony export */   "AbE": function() { return /* binding */ useStartAmazonPaymentMutation; },
/* harmony export */   "C1o": function() { return /* binding */ useSearchRecommendedProductsQuery; },
/* harmony export */   "CMH": function() { return /* binding */ useCartQuery; },
/* harmony export */   "CSX": function() { return /* binding */ useConfirmPayPayMutation; },
/* harmony export */   "E1h": function() { return /* binding */ useRemoveGiftCardMutation; },
/* harmony export */   "E6_": function() { return /* binding */ useConfirmAfterPayMutation; },
/* harmony export */   "ER5": function() { return /* binding */ useAddStoreCreditsMutation; },
/* harmony export */   "Ey5": function() { return /* binding */ useSaveNotificationPreferencesMutation; },
/* harmony export */   "F0p": function() { return /* binding */ useUpdatePhoneMutation; },
/* harmony export */   "FA3": function() { return /* binding */ useProductQuery; },
/* harmony export */   "G5l": function() { return /* binding */ useTrendingSearchTermsQuery; },
/* harmony export */   "HKA": function() { return /* binding */ useCancelOrderMutation; },
/* harmony export */   "HiT": function() { return /* binding */ usePayWithPayTmMutation; },
/* harmony export */   "HuP": function() { return /* binding */ AdyenResultCodeEnum; },
/* harmony export */   "I_9": function() { return /* binding */ useOutfitsQuery; },
/* harmony export */   "I_O": function() { return /* binding */ useSiblingVariantsQuery; },
/* harmony export */   "Iav": function() { return /* binding */ useUpdateShippingAddressMutation; },
/* harmony export */   "J0N": function() { return /* binding */ usePayWithGiftCardMutation; },
/* harmony export */   "Joh": function() { return /* binding */ useRemoveGiftCardFromCartMutation; },
/* harmony export */   "L0X": function() { return /* binding */ GenericTextSize; },
/* harmony export */   "LA1": function() { return /* binding */ useAddGiftCardMutation; },
/* harmony export */   "LrK": function() { return /* binding */ useCreateContactMutation; },
/* harmony export */   "MA5": function() { return /* binding */ useRecommendationsWithDetailsQuery; },
/* harmony export */   "MVZ": function() { return /* binding */ useAddPaymentPromotionMutation; },
/* harmony export */   "MdU": function() { return /* binding */ useStartAdyenPaymentMutation; },
/* harmony export */   "Mmk": function() { return /* binding */ useCheckAmbassadorCardBalanceQuery; },
/* harmony export */   "NsB": function() { return /* binding */ useKlarnaMutation; },
/* harmony export */   "O70": function() { return /* binding */ usePayWithApplePayMutation; },
/* harmony export */   "OKS": function() { return /* binding */ useTrackProductViewMutation; },
/* harmony export */   "OOj": function() { return /* binding */ usePayWithPayPayInCartMutation; },
/* harmony export */   "OTz": function() { return /* binding */ useOrderQuery; },
/* harmony export */   "Oa7": function() { return /* binding */ useVerifyUserAffiliationsMutation; },
/* harmony export */   "P92": function() { return /* binding */ ProductScoreDocument; },
/* harmony export */   "PQi": function() { return /* binding */ useStartRazorPayMutation; },
/* harmony export */   "PjV": function() { return /* binding */ useProductScoreQuery; },
/* harmony export */   "Q$F": function() { return /* binding */ useCancelGooglePayMutation; },
/* harmony export */   "QMl": function() { return /* binding */ OrderStatusCode; },
/* harmony export */   "QW$": function() { return /* binding */ usePixleeConfigQuery; },
/* harmony export */   "Qnv": function() { return /* binding */ useConfirmRazorPayMutation; },
/* harmony export */   "RJP": function() { return /* binding */ useAddCouponToCartMutation; },
/* harmony export */   "RvP": function() { return /* binding */ useGetAmazonPayCustomerInfoQuery; },
/* harmony export */   "SEy": function() { return /* binding */ useUpdateItemInCartMutation; },
/* harmony export */   "SZc": function() { return /* binding */ useProductReviewsQuery; },
/* harmony export */   "ShS": function() { return /* binding */ useManageOrderLevelNotificationMutation; },
/* harmony export */   "SpN": function() { return /* binding */ AuthorityToLeaveOptions; },
/* harmony export */   "TGI": function() { return /* binding */ useUpdateProfileMutation; },
/* harmony export */   "Te6": function() { return /* binding */ useCompleteAmazonPaymentMutation; },
/* harmony export */   "Tgi": function() { return /* binding */ useSaveAmbassadorCardMutation; },
/* harmony export */   "UEB": function() { return /* binding */ useMeQuery; },
/* harmony export */   "UMO": function() { return /* binding */ PixleeConfigDocument; },
/* harmony export */   "UPZ": function() { return /* binding */ usePlaceOrderMutation; },
/* harmony export */   "VIF": function() { return /* binding */ useCheckGiftCardBalanceQuery; },
/* harmony export */   "VeD": function() { return /* binding */ usePayWithAfterPayMutation; },
/* harmony export */   "XB0": function() { return /* binding */ useAddItemsToCartMutation; },
/* harmony export */   "XjH": function() { return /* binding */ usePayWithCreditCardMutation; },
/* harmony export */   "Xue": function() { return /* binding */ useProductSizeChartQuery; },
/* harmony export */   "Y9C": function() { return /* binding */ useRemoveStoreCreditsMutation; },
/* harmony export */   "YB2": function() { return /* binding */ useTrackOrderConfirmationMutation; },
/* harmony export */   "Ymk": function() { return /* binding */ useRemoveCouponFromCartMutation; },
/* harmony export */   "Z$c": function() { return /* binding */ useCategoryByIdQuery; },
/* harmony export */   "Zcv": function() { return /* binding */ useSuggestionsQuery; },
/* harmony export */   "_0_": function() { return /* binding */ useAddAmbassadorCardToCartMutation; },
/* harmony export */   "_IF": function() { return /* binding */ useVerifyLoginWithOtpMutation; },
/* harmony export */   "_Q8": function() { return /* binding */ AdyenPaymentMethod; },
/* harmony export */   "_W0": function() { return /* binding */ useConfirmKlarnaPaymentMutation; },
/* harmony export */   "_xu": function() { return /* binding */ usePayWithPayPalMutation; },
/* harmony export */   "_y": function() { return /* binding */ PdpDocument; },
/* harmony export */   "_y5": function() { return /* binding */ useLogoutMutation; },
/* harmony export */   "a3O": function() { return /* binding */ useUpdatePasswordMutation; },
/* harmony export */   "b6C": function() { return /* binding */ useTrackLiveChatStartMutation; },
/* harmony export */   "bTF": function() { return /* binding */ FrontendConfigurationDocument; },
/* harmony export */   "bxv": function() { return /* binding */ useConfirmUpdatePhoneMutation; },
/* harmony export */   "c_8": function() { return /* binding */ useStartAmazonProcessOrderPaymentMutation; },
/* harmony export */   "ctD": function() { return /* binding */ useDeleteAddressMutation; },
/* harmony export */   "dAP": function() { return /* binding */ useRemoveAmbassadorCardFromCartMutation; },
/* harmony export */   "dCy": function() { return /* binding */ useSignAmazonPayloadMutation; },
/* harmony export */   "dVZ": function() { return /* binding */ usePincodeQuery; },
/* harmony export */   "eTX": function() { return /* binding */ usePayWithCashOnDeliveryMutation; },
/* harmony export */   "eXo": function() { return /* binding */ useOpluxFraudDetectionMutation; },
/* harmony export */   "ejx": function() { return /* binding */ useUpdateShipmentMethodMutation; },
/* harmony export */   "gCD": function() { return /* binding */ useCategorySizeChartQuery; },
/* harmony export */   "gL8": function() { return /* binding */ useResetPasswordMutation; },
/* harmony export */   "gPj": function() { return /* binding */ useValidateApplePayMerchantMutation; },
/* harmony export */   "gRK": function() { return /* binding */ useCancelApplePayMutation; },
/* harmony export */   "gcU": function() { return /* binding */ useConfirmApplePayMutation; },
/* harmony export */   "ggB": function() { return /* binding */ useInventoryQuery; },
/* harmony export */   "iN4": function() { return /* binding */ useAmazonPayPaymentDescriptorQuery; },
/* harmony export */   "igd": function() { return /* binding */ useUpdatePayPalMutation; },
/* harmony export */   "jNL": function() { return /* binding */ useTrackRecommendationClickMutation; },
/* harmony export */   "kii": function() { return /* binding */ useVariantsQuery; },
/* harmony export */   "ksR": function() { return /* binding */ useGiftCardQuery; },
/* harmony export */   "l42": function() { return /* binding */ useRegisterMutation; },
/* harmony export */   "l6q": function() { return /* binding */ useLazyPdpQuery; },
/* harmony export */   "lCm": function() { return /* binding */ useUserGeneratedContentQuery; },
/* harmony export */   "lNJ": function() { return /* binding */ GraphQlError; },
/* harmony export */   "liW": function() { return /* binding */ useStartKlarnaPaymentMutation; },
/* harmony export */   "m45": function() { return /* binding */ useCreateShopperContextMutation; },
/* harmony export */   "mEk": function() { return /* binding */ useSaveCreditCardMutation; },
/* harmony export */   "mFF": function() { return /* binding */ useResendOtpMutation; },
/* harmony export */   "nfz": function() { return /* binding */ usePayWithWalletMutation; },
/* harmony export */   "p98": function() { return /* binding */ useConfirmPayPalMutation; },
/* harmony export */   "pFA": function() { return /* binding */ usePayWithCreditCardInCartMutation; },
/* harmony export */   "pJ3": function() { return /* binding */ useLoginWithEmailAndPasswordMutation; },
/* harmony export */   "pVf": function() { return /* binding */ UserGeneratedContentDocument; },
/* harmony export */   "r3o": function() { return /* binding */ usePayWithGooglePayMutation; },
/* harmony export */   "rYM": function() { return /* binding */ useLoginWithPhoneMutation; },
/* harmony export */   "rxY": function() { return /* binding */ LinkVariant; },
/* harmony export */   "s1e": function() { return /* binding */ useRemoveItemFromCartMutation; },
/* harmony export */   "sHt": function() { return /* binding */ useAddAddressMutation; },
/* harmony export */   "sQc": function() { return /* binding */ useTrackLanguageChangeMutation; },
/* harmony export */   "sjO": function() { return /* binding */ useOrderHistoryMeQuery; },
/* harmony export */   "t8l": function() { return /* binding */ useStartCreditCardPaymentMutation; },
/* harmony export */   "tKb": function() { return /* binding */ usePayWithCashOnDeliveryInCartMutation; },
/* harmony export */   "teY": function() { return /* binding */ useCompleteResetPasswordMutation; },
/* harmony export */   "tfQ": function() { return /* binding */ useProfilingConsentMutation; },
/* harmony export */   "u1K": function() { return /* binding */ usePayWithPayPayMutation; },
/* harmony export */   "uEr": function() { return /* binding */ useCompleteAdyenPaymentMutation; },
/* harmony export */   "vEG": function() { return /* binding */ useGmoConfirmCreditCardMutation; },
/* harmony export */   "vTc": function() { return /* binding */ useUpdateAmbassadorCardsMutation; },
/* harmony export */   "vkA": function() { return /* binding */ useAfterPayConfigQuery; },
/* harmony export */   "wcd": function() { return /* binding */ useLookQuery; },
/* harmony export */   "wkv": function() { return /* binding */ useConfirmCashOnDeliveryMutation; },
/* harmony export */   "wvD": function() { return /* binding */ useUpdateContactMutation; },
/* harmony export */   "xv8": function() { return /* binding */ useDeleteCreditCardMutation; },
/* harmony export */   "xyt": function() { return /* binding */ useWishListTotalsQuery; },
/* harmony export */   "y5I": function() { return /* binding */ useAllCustomerGroupsQuery; },
/* harmony export */   "ygm": function() { return /* binding */ useTrackAppLinkClickMutation; },
/* harmony export */   "z06": function() { return /* binding */ usePayWithAmbassadorCardMutation; },
/* harmony export */   "zMd": function() { return /* binding */ usePdpQuery; },
/* harmony export */   "zc0": function() { return /* binding */ useDeleteAmbassadorCardMutation; }
/* harmony export */ });
/* unused harmony exports ConfirmUpdatePhoneCode, HorizontalAlignment, KlarnaPaymentMethod, KlarnaPaymentMethodSubType, KlarnaResultCodeEnum, LayoutDirection, ProductPromotionsPageType, ProductSearchExpansion, SupportPageContentAvailableOn, SupportedPaymentMethod, Taxation, TextAlignment, ThreeDsMethod, UpdatePhoneCode, Upgrade, UserEvent, VerifyLoginWithOtpCode, VerticalAlignment, TokenPayloadFragmentDoc, AddressFieldsFragmentDoc, AmbassadorCardFieldsFragmentDoc, AuthPayloadFragmentDoc, ProductCartSimpleItemFieldsFragmentDoc, ProductAnalyticsDimensionsFieldsFragmentDoc, ProductCartItemAnalyticsDimensionsFieldsFragmentDoc, ProductCartItemFieldsFragmentDoc, GiftWithPurchaseFieldsFragmentDoc, AmbassadorCardPaymentFieldsFragmentDoc, CartPaymentInstrumentsFieldsFragmentDoc, CustomerFieldsFragmentDoc, CartCostsFieldsFragmentDoc, CartPromoFieldsFragmentDoc, BillingAddressFieldsFragmentDoc, ShipmentFieldsFragmentDoc, ShipmentMethodInfoFieldsFragmentDoc, AvailablePaymentMethodsFieldsFragmentDoc, CartFieldsFragmentDoc, CategoryFragmentDoc, PortableTextFieldsFragmentDoc, CtaFieldsFragmentDoc, ColorInputFieldsFragmentDoc, BackgroundOverlayFieldsFragmentDoc, SanityImageFieldsFragmentDoc, SignUpFormFieldsFragmentDoc, SavedCreditCardFragmentDoc, OrderPaymentInstrumentFieldsFragmentDoc, OrderAddressFragmentDoc, OrderConfirmationFieldsFragmentDoc, NestedOrderDetailsFieldsFragmentDoc, PdpMandatoryVariantFieldsFragmentDoc, PdpMandatoryExtraVariantFieldsFragmentDoc, SizesFragmentDoc, MandatoryVariantFieldsFragmentDoc, MandatoryMasterFieldsFragmentDoc, PaginatedOutputNodesFragmentFragmentDoc, PaginatedOutputMetadataFragmentFragmentDoc, ReviewFieldsFragmentDoc, ReviewSummaryFieldsFragmentDoc, OrderPreviewFieldsFragmentDoc, StandardOrderDetailsFieldsFragmentDoc, StoreCreditFieldsFragmentDoc, TermsAndConditionsFieldsFragmentDoc, UserFieldsFragmentDoc, SanityVideoFieldsFragmentDoc, WishListFieldsFragmentDoc, RecommendationFieldsFragmentDoc, ProductFragmentDoc, GuestLogonDocument, useGuestLogonMutation, RefreshLogonDocument, useRefreshLogonMutation, UpdatePasswordDocument, UpdatePhoneDocument, ConfirmUpdatePhoneDocument, ResetPasswordDocument, CompleteResetPasswordDocument, CreateShopperContextDocument, VerifyUserAffiliationsDocument, AddAddressDocument, UpdateAddressDocument, useUpdateAddressMutation, DeleteAddressDocument, SaveAmbassadorCardDocument, DeleteAmbassadorCardDocument, UpdateAmbassadorCardsDocument, AddItemsToCartDocument, UpdateItemInCartDocument, RemoveItemFromCartDocument, AddGiftCardToCartDocument, useAddGiftCardToCartMutation, RemoveGiftCardFromCartDocument, AddGiftCardDocument, RemoveGiftCardDocument, UpdateShippingAddressDocument, UpdateShipmentMethodDocument, UpdateBillingAddressDocument, RemoveCouponFromCartDocument, AddCouponToCartDocument, AddPaymentPromotionDocument, AddAmbassadorCardToCartDocument, RemoveAmbassadorCardFromCartDocument, AddStoreCreditsDocument, RemoveStoreCreditsDocument, UpdateContactDocument, ProfilingConsentDocument, KlarnaDocument, ConfirmKlarnaDocument, useConfirmKlarnaMutation, CancelKlarnaDocument, useCancelKlarnaMutation, StartKlarnaPaymentDocument, ConfirmKlarnaPaymentDocument, LoginWithEmailAndPasswordDocument, VerifyLoginWithOtpDocument, LoginWithOtpDocument, LoginWithPhoneDocument, ResendOtpDocument, LogoutDocument, ManageCustomerLevelNotificationDocument, useManageCustomerLevelNotificationMutation, SaveNotificationPreferencesDocument, ManageOrderLevelNotificationDocument, CreateContactDocument, OpluxFraudDetectionDocument, StartAdyenPaymentDocument, CompleteAdyenPaymentDocument, PayWithAfterPayDocument, ConfirmAfterPayDocument, AmazonPayPaymentDescriptorDocument, SignAmazonPayloadDocument, StartAmazonPaymentDocument, StartAmazonProcessOrderPaymentDocument, CompleteAmazonPaymentDocument, RegisterAmazonPaymentDocument, PayWithAmbassadorCardDocument, PayWithApplePayDocument, ValidateApplePayMerchantDocument, ConfirmApplePayDocument, CancelApplePayDocument, CancelOrderDocument, PayWithCashOnDeliveryDocument, PayWithCashOnDeliveryInCartDocument, ConfirmCashOnDeliveryDocument, PayWithCreditCardDocument, PayWithCreditCardInCartDocument, ConfirmCreditCardDocument, useConfirmCreditCardMutation, SaveCreditCardDocument, DeleteCreditCardDocument, StartCreditCardPaymentDocument, GmoConfirmCreditCardDocument, PlaceOrderDocument, PayWithGiftCardDocument, PayWithGooglePayDocument, CancelGooglePayDocument, PayWithPayPalDocument, ConfirmPayPalDocument, UpdatePayPalDocument, PayWithPayPayDocument, ConfirmPayPayDocument, PayWithPayPayInCartDocument, PayWithPayTmDocument, ConfirmPayTmDocument, useConfirmPayTmMutation, StartRazorPayDocument, ConfirmRazorPayDocument, PayWithWalletDocument, ConfirmWalletDocument, useConfirmWalletMutation, UpdateProfileDocument, RegisterDocument, CreateReviewDocument, useCreateReviewMutation, TrackAppLinkClickDocument, TrackLanguageChangeDocument, TrackLiveChatStartDocument, TrackOrderConfirmationDocument, TrackRecommendationClickDocument, TrackProductViewDocument, AddItemToWishListDocument, useAddItemToWishListMutation, UpdateItemInWishListDocument, useUpdateItemInWishListMutation, RemoveItemFromWishListDocument, useRemoveItemFromWishListMutation, AddressDocument, useAddressQuery, AfterPayConfigDocument, AllCustomerGroupsDocument, CheckAmbassadorCardBalanceDocument, CartDocument, SimpleCartDocument, useSimpleCartQuery, CategoryByIdDocument, CategorySizeChartDocument, MainFooterMinimalDocument, useMainFooterMinimalQuery, MainFooterDocument, useMainFooterQuery, useFrontendConfigurationQuery, CheckGiftCardBalanceDocument, GiftCardDocument, GlossaryPageDocument, useGlossaryPageQuery, InventoryDocument, WishListTotalsDocument, MeDocument, NotificationPreferencesDocument, useNotificationPreferencesQuery, OrderDocument, OrderDetailsDocument, useOrderDetailsQuery, OrderHistoryMeDocument, SearchOrderByPhoneDocument, useSearchOrderByPhoneQuery, SearchOrderByEmailPostcodeDocument, useSearchOrderByEmailPostcodeQuery, SearchOrderByEmailDocument, useSearchOrderByEmailQuery, SearchOrderByEmailPhoneDocument, useSearchOrderByEmailPhoneQuery, OutfitsDocument, GetAmazonPayCustomerInfoDocument, GetPayPayContentDocument, PincodeDocument, CategoryPlpDocument, useCategoryPlpQuery, VariantsDocument, SiblingVariantsDocument, VariantDocument, useVariantQuery, ProductDocument, LazyPdpDocument, ProductSizeChartDocument, RecommendationsWithDetailsDocument, ProductReviewsDocument, TrendingSearchTermsDocument, SearchRecommendedProductsDocument, ProductSearchDocument, useProductSearchQuery, LookDocument, SuggestionsDocument, TermsAndConditionsConfigsDocument, useTermsAndConditionsConfigsQuery, UrlRedirectDocument, useUrlRedirectQuery, WishListDocument, useWishListQuery, getSdk */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85034);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19989);
/* harmony import */ var urql__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70463);
/* harmony import */ var urql__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25380);
/* harmony import */ var _graphql__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37678);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment tokenPayload on TokenPayload {\n  __typename\n  accessToken\n  refreshToken\n  customerId\n  uniqueShopperId\n  customerContext {\n    __typename\n    hashKey\n    customerGroups\n  }\n  user {\n    customerNo\n    email\n  }\n}\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment addressFields on Address {\n  id\n  title\n  firstName\n  lastName\n  firstNamePronunciation\n  lastNamePronunciation\n  address1\n  address2\n  stateCode\n  city\n  countryCode\n  phone\n  preferred\n  postalCode\n  streetNumber\n  salutation\n  companyName\n}\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment ambassadorCardFields on SavedAmbassadorCard {\n  id\n  maskedNumber\n  name\n  preferred\n}\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment authPayload on AuthPayload {\n  __typename\n  accessToken\n  refreshToken\n  customerId\n  customerContext {\n    __typename\n    hashKey\n    customerGroups\n  }\n  user {\n    customerNo\n    email\n  }\n}\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment productCartSimpleItemFields on CartItem {\n  ... on GiftCardCartItem {\n    id\n    imageUrl\n    amount\n    recipientEmail\n    recipientName\n    senderName\n    __typename\n  }\n  ... on ProductCartItem {\n    __typename\n    id\n    inCartPrice\n    bonusItemId\n    restricted\n    quantity\n    purchasedPrice {\n      price\n      promotionPrice\n    }\n    adjustments {\n      promotionId\n      itemText\n      price\n      couponCode\n      promotion {\n        id\n        calloutMessage\n        name\n      }\n      __typename\n    }\n    product {\n      masterId\n      id\n      isAppExclusive\n      appOnlyDateTimeFrom\n      appOnlyDateTimeTo\n      promotionExclusion\n      name\n      header\n      subHeader\n      price\n      brand\n      salePrice\n      productPrice {\n        price\n        salePrice\n        promotionPrice\n        isSalePriceElapsed\n        tax\n        taxRate\n        bestPrice\n      }\n      imageUrl\n      inventory\n      maxOrderableQuantity\n      primaryCategoryId\n      styleNumber\n      ean\n      upc\n      colorValue\n      colorName\n      displayOutOfStock {\n        soldout\n        backsoon\n        presale\n        validTo\n      }\n      size {\n        label\n        value\n      }\n      offline\n      orderable\n      assortmentAvailability\n    }\n    customizationName\n    customizationNumber\n    customizationCost\n    quantityInCart\n    stockMessage\n    stockMessageCode\n    hasStock\n    adjustQuantityMessage\n    personalizationSurcharge\n    personalizationImageURL\n    personalizationLargeImageURL\n    personalizationName\n    personalizationNumber\n    personalizationPrice\n    personalizationRecipeID\n    popularityCount\n    estimatedDeliveryDate {\n      id\n      carrierCode\n      eddBegin\n      eddEnd\n      errorResponse {\n        code\n        message\n      }\n      serviceCode\n      timeZoneName\n    }\n  }\n}\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment productAnalyticsDimensionsFields on VariantProduct {\n  colorDescription\n  sportName\n  technology\n  gender\n  ageGroup\n  lineName\n  businessUnit\n  businessSegment\n  businessSubSegment\n  division\n  articleGroup\n  articleType\n  franchise\n  collectionMark\n}\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment productCartItemAnalyticsDimensionsFields on CartItem {\n  ... on ProductCartItem {\n    product {\n      ...productAnalyticsDimensionsFields\n    }\n    taxRate\n  }\n}\n    ",
        ""
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment productCartItemFields on CartItem {\n  ... on GiftCardCartItem {\n    id\n    imageUrl\n    amount\n    recipientEmail\n    recipientName\n    senderName\n    __typename\n  }\n  ... on ProductCartItem {\n    __typename\n    id\n    inCartPrice\n    bonusItemId\n    restricted\n    quantity\n    purchasedPrice {\n      price\n      promotionPrice\n    }\n    adjustments {\n      promotionId\n      itemText\n      price\n      couponCode\n      promotion {\n        id\n        calloutMessage\n        name\n      }\n      __typename\n    }\n    product {\n      masterId\n      id\n      isAppExclusive\n      appOnlyDateTimeFrom\n      appOnlyDateTimeTo\n      promotionExclusion\n      name\n      header\n      subHeader\n      price\n      brand\n      salePrice\n      productPrice {\n        price\n        salePrice\n        promotionPrice\n        isSalePriceElapsed\n        tax\n        taxRate\n        bestPrice\n      }\n      imageUrl\n      inventory\n      maxOrderableQuantity\n      primaryCategoryId\n      styleNumber\n      ean\n      upc\n      colorValue\n      colorName\n      displayOutOfStock {\n        soldout\n        backsoon\n        presale\n        validTo\n      }\n      size {\n        label\n        value\n      }\n      offline\n      orderable\n      assortmentAvailability\n    }\n    customizationName\n    customizationNumber\n    customizationCost\n    quantityInCart\n    stockMessage\n    stockMessageCode\n    hasStock\n    adjustQuantityMessage\n    personalizationSurcharge\n    personalizationImageURL\n    personalizationLargeImageURL\n    personalizationName\n    personalizationNumber\n    personalizationPrice\n    personalizationRecipeID\n    popularityCount\n    estimatedDeliveryDate {\n      id\n      carrierCode\n      eddBegin\n      eddEnd\n      errorResponse {\n        code\n        message\n      }\n      serviceCode\n      timeZoneName\n    }\n  }\n}\n    "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment giftWithPurchaseFields on GiftWithPurchasePromo {\n  id\n  allowedQuantity\n  promotionId\n  calloutMessage\n  gwpTitle\n  details\n  fullfilled\n  availableProducts {\n    ... on VariantProduct {\n      __typename\n      masterId\n      id\n      name\n      price\n      images {\n        href\n        alt\n      }\n      inventory\n      primaryCategoryId\n      styleNumber\n      colorValue\n      colorName\n      size {\n        label\n        value\n      }\n    }\n    ... on ProductWithExclusion {\n      __typename\n      excludedColors\n      product {\n        id\n        name\n        variations {\n          id\n          colorValue\n          colorName\n          salePrice\n          price\n          productPrice {\n            price\n            salePrice\n            promotionPrice\n            bestPrice\n          }\n          preview\n          displayOutOfStock {\n            displayValue\n            soldout\n          }\n          orderable\n          sizeGroups {\n            label\n            description\n            sizes {\n              id\n              label\n              value\n              productId\n              orderable\n              maxOrderableQuantity\n            }\n          }\n          images {\n            href\n            alt\n          }\n        }\n      }\n    }\n  }\n}\n    "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment ambassadorCardPaymentFields on PaymentInstrument {\n  ... on AmbassadorCard {\n    __typename\n    id\n    maskedNumber\n    amount\n    authorizationStatus\n    type\n  }\n}\n    "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment cartPaymentInstrumentsFields on PaymentInstrument {\n  ... on AfterPay {\n    __typename\n    id\n    type\n  }\n  ... on AmazonPay {\n    __typename\n    id\n    type\n  }\n  ... on ApplePay {\n    __typename\n    id\n    authorizationStatus\n    type\n  }\n  ... on CashOnDelivery {\n    __typename\n    id\n    type\n  }\n  ... on CreditCard {\n    __typename\n    id\n    maskedNumber\n    expirationMonth\n    expirationYear\n    holder\n    type\n  }\n  ... on GiftCard {\n    __typename\n    id\n    maskedNumber\n    amount\n    type\n  }\n  ... on OnlineBanking {\n    __typename\n    id\n    type\n  }\n  ... on PayPal {\n    __typename\n    id\n    type\n  }\n  ... on PayPay {\n    __typename\n    id\n    type\n  }\n  ... on PayTm {\n    __typename\n    id\n    type\n  }\n  ... on Razorpay {\n    __typename\n    id\n    type\n  }\n  ... on Scheme {\n    __typename\n    id\n    type\n  }\n  ... on StoreCreditInstrument {\n    __typename\n    id\n    type\n    amount\n  }\n  ... on UPI {\n    __typename\n    id\n    type\n  }\n  ... on Wallet {\n    __typename\n    id\n    type\n  }\n  ...ambassadorCardPaymentFields\n}\n    ",
        ""
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment customerFields on Cart {\n  customer {\n    id\n    email\n    customerNo\n  }\n}\n    "
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment cartCostsFields on Cart {\n  subTotal\n  shippingCosts\n  estimatedShippingCosts\n  taxTotal\n  taxation\n  estimatedTotal\n  amountRemaining\n  customizationAdjustment {\n    price\n  }\n}\n    "
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment cartPromoFields on Cart {\n  couponItems {\n    code\n    couponItemId\n    statusCode\n    valid\n    discountAmount\n    calloutMessage\n    couponFamily\n    couponType\n  }\n  orderAdjustments {\n    promotionId\n    itemText\n    price\n    couponCode\n  }\n  shippingAdjustments {\n    promotionId\n    itemText\n    price\n    couponCode\n  }\n  productAdjustments {\n    promotionId\n    itemText\n    price\n    couponCode\n  }\n}\n    "
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment billingAddressFields on Cart {\n  billingAddress {\n    firstName\n    lastName\n    address1\n    address2\n    postalCode\n    city\n    countryCode\n    stateCode\n    phone\n    id\n    firstNamePronunciation\n    lastNamePronunciation\n    streetNumber\n    salutation\n    companyName\n  }\n}\n    "
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment shipmentFields on Shipment {\n  id\n  shipmentMethod {\n    id\n    name\n    price\n  }\n  address {\n    id\n    firstName\n    lastName\n    address1\n    address2\n    postalCode\n    city\n    countryCode\n    stateCode\n    phone\n    firstNamePronunciation\n    lastNamePronunciation\n    streetNumber\n    salutation\n    companyName\n  }\n  deliveryDate\n  deliveryTimeCode\n  deliveryTimeDisplayText\n  authorityToLeave {\n    leaveAt\n    deliveryInstructions\n  }\n}\n    "
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment shipmentMethodInfoFields on ShipmentMethodInfo {\n  defaultShipmentMethodId\n  availableShipmentMethods {\n    id\n    name\n    price\n    estimatedShippingDate {\n      min\n      max\n    }\n  }\n}\n    "
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment availablePaymentMethodsFields on PaymentMethod {\n  id\n  cards {\n    id\n    cardType\n    name\n  }\n  bank {\n    id\n    name\n  }\n  wallet {\n    id\n    name\n  }\n  description\n  name\n  paymentProcessorId\n  c_additionalFee\n}\n    "
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment cartFields on Cart {\n  id\n  productCount\n  amountRemainingForFreeShipping\n  basketInStockStatus\n  hasFreeShipping\n  hasOfflineProducts\n  preOrderDeliveryDate\n  shippingSurcharge {\n    amount\n    label\n    tooltip\n  }\n  products {\n    ...productCartItemFields\n  }\n  giftWithPurchases {\n    ...giftWithPurchaseFields\n  }\n  paymentInstruments {\n    ...cartPaymentInstrumentsFields\n  }\n  ...customerFields\n  ...cartCostsFields\n  ...cartPromoFields\n  ...billingAddressFields\n  shipment {\n    ...shipmentFields\n  }\n  shipmentMethodInfo {\n    ...shipmentMethodInfoFields\n  }\n  longTermPreOrder {\n    hasLongTermPreOrderItem\n    longTermPreOrderItemPaymentMethods\n  }\n  availablePaymentMethods {\n    ...availablePaymentMethodsFields\n  }\n}\n    ",
        "\n",
        "\n",
        "\n",
        "\n",
        "\n",
        "\n",
        "\n",
        "\n",
        "\n",
        ""
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment category on Category {\n  id\n  name\n  title\n  url\n  visible\n}\n    "
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment portableTextFields on PortableText {\n  _type\n  _key\n  children {\n    _type\n    _key\n    text\n    marks\n  }\n  markDefs {\n    _type\n    _key\n    _ref\n    href\n    link\n    newtab\n  }\n  style\n  level\n  listItem\n}\n    "
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment ctaFields on CTA {\n  __typename\n  _type\n  id\n  link\n  title\n  variant\n  outlined\n  newtab\n  popup\n  query\n}\n    "
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment colorInputFields on ColorInput {\n  __typename\n  hex\n  alpha\n  rgb {\n    r\n    g\n    b\n    a\n  }\n}\n    "
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment backgroundOverlayFields on BackgroundOverlay {\n  __typename\n  id\n  overlayColorInput {\n    ...colorInputFields\n  }\n  overlayType\n  direction\n}\n    ",
        ""
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment sanityImageFields on SanityImage {\n  alt\n  asset {\n    _id\n    url\n    metadata {\n      lqip\n      dimensions {\n        width\n        height\n      }\n    }\n    extension\n  }\n  overlay {\n    ...backgroundOverlayFields\n  }\n}\n    ",
        ""
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment signUpFormFields on SignUpForm {\n  id\n  __typename\n  analyticsIdentifier\n  launchButtonLabel\n  launchLinkText\n  cartPageLaunchButtonLabel\n  header\n  copy\n  footnote\n  contactSource\n  disclaimer {\n    ...portableTextFields\n  }\n  disclaimerText\n  portableDisclaimerText {\n    ...portableTextFields\n  }\n  submitButtonText\n  customText\n  submitButtonTextColor\n  submitButtonColor\n  fields\n  textColor\n  backgroundColor\n  successHeader\n  successHeaderTextColor\n  successCopy\n  successCopyTextColor\n  successFootnote\n  successFootnoteTextColor\n  inverted\n  ctas {\n    ...ctaFields\n  }\n  successImage {\n    ...sanityImageFields\n  }\n  mobileBackgroundImage {\n    ...sanityImageFields\n  }\n  formBackgroundImage: backgroundImage {\n    ...sanityImageFields\n  }\n}\n    ",
        "\n",
        "\n",
        ""
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment savedCreditCard on SavedCreditCard {\n  UUID\n  defaultFlag\n  creditHolderName\n  creditCardSeq\n  creditCardType\n  creditCardNumber\n  maskedCreditCardNumber\n  creditCardExpirationMonth\n  creditCardExpirationYear\n}\n    "
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment orderPaymentInstrumentFields on BaseOrder {\n  paymentInstruments {\n    ... on Adyen {\n      id\n      __typename\n      amount\n      type\n    }\n    ... on AdyenKlarna {\n      id\n      __typename\n      amount\n      type\n    }\n    ... on AdyenKlarnaAccount {\n      id\n      __typename\n      amount\n      type\n    }\n    ... on AmazonPay {\n      __typename\n      id\n      type\n    }\n    ... on AmbassadorCard {\n      id\n      __typename\n      authorizationStatus\n      maskedNumber\n      amount\n      type\n    }\n    ... on Scheme {\n      id\n      amount\n      authorizationStatus\n      type\n      __typename\n    }\n    ... on CreditCard {\n      id\n      amount\n      maskedNumber\n      cardType\n      authorizationStatus\n      type\n      __typename\n    }\n    ... on AfterPay {\n      id\n      authorizationStatus\n      type\n      __typename\n    }\n    ... on PayPay {\n      id\n      authorizationStatus\n      type\n      __typename\n    }\n    ... on ApplePay {\n      id\n      authorizationStatus\n      type\n      __typename\n    }\n    ... on PayPal {\n      id\n      authorizationStatus\n      type\n      __typename\n    }\n    ... on GiftCard {\n      id\n      __typename\n      maskedNumber\n      authorizationStatus\n      amount\n      type\n    }\n    ... on CashOnDelivery {\n      id\n      amount\n      type\n      __typename\n    }\n    ... on UPI {\n      id\n      amount\n      authorizationStatus\n      type\n      __typename\n    }\n    ... on Wallet {\n      id\n      amount\n      authorizationStatus\n      type\n      __typename\n    }\n    ... on OnlineBanking {\n      id\n      amount\n      authorizationStatus\n      type\n      __typename\n    }\n    ... on PayTm {\n      id\n      authorizationStatus\n      amount\n      type\n      __typename\n    }\n    ... on StoreCreditInstrument {\n      id\n      amount\n      type\n      __typename\n    }\n    ... on ZipPay {\n      id\n      type\n      __typename\n    }\n    ... on WechatPay {\n      id\n      type\n      __typename\n    }\n    ... on Alipay {\n      id\n      type\n      __typename\n    }\n    ... on KlarnaPayments {\n      id\n      type\n      amount\n      __typename\n    }\n    ... on Razorpay {\n      id\n      amount\n      type\n      __typename\n    }\n    ... on AmazonPay {\n      id\n      amount\n      type\n      __typename\n    }\n  }\n}\n    "
    ]);
    _templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment orderAddress on OrderAddress {\n  id\n  salutation\n  firstName\n  lastName\n  firstNamePronunciation\n  lastNamePronunciation\n  companyName\n  address1\n  address2\n  streetNumber\n  postalCode\n  city\n  countryCode\n  stateCode\n  phone\n}\n    "
    ]);
    _templateObject28 = function _templateObject28() {
        return data;
    };
    return data;
}
function _templateObject29() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment orderConfirmationFields on BaseOrder {\n  billingAddress {\n    ...orderAddress\n  }\n  shipment {\n    id\n    shipmentMethod {\n      id\n      name\n      price\n    }\n    address {\n      ...orderAddress\n    }\n    deliveryDate\n    deliveryTimeDisplayText\n  }\n  customer {\n    email\n    id\n  }\n}\n    ",
        ""
    ]);
    _templateObject29 = function _templateObject29() {
        return data;
    };
    return data;
}
function _templateObject30() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment nestedOrderDetailsFields on NestedOrder {\n  __typename\n  orderNo\n  status\n  taxTotal\n  subTotal\n  createdAt\n  currency\n  orderStatus {\n    code\n    label\n  }\n  isReturnable\n  ...orderPaymentInstrumentFields\n  ...orderConfirmationFields\n  suborders {\n    __typename\n    orderNo\n    awbNo\n    courierPartner\n    status\n    statuses {\n      status\n      label\n      order\n    }\n    returnBy\n    isReturnable\n    returnUrl\n    products {\n      ... on ProductCartItem {\n        __typename\n        id\n        status\n        inCartPrice\n        bonusItemId\n        restricted\n        quantity\n        purchasedPrice {\n          price\n          promotionPrice\n        }\n        product {\n          masterId\n          id\n          name\n          price\n          salePrice\n          productPrice {\n            price\n            salePrice\n            promotionPrice\n            bestPrice\n          }\n          images {\n            href\n            alt\n          }\n          inventory\n          primaryCategoryId\n          styleNumber\n          colorValue\n          colorName\n          size {\n            label\n            value\n          }\n          offline\n          orderable\n        }\n        productReturn {\n          id\n          returnOrderCode\n          forwardAwb\n          returnAwb\n          transporter\n          channelReturnOrderTime\n          type\n          status\n          statuses {\n            status\n            label\n            order\n          }\n          price\n          quantity\n        }\n      }\n    }\n  }\n}\n    ",
        "\n",
        ""
    ]);
    _templateObject30 = function _templateObject30() {
        return data;
    };
    return data;
}
function _templateObject31() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment pdpMandatoryVariantFields on Variant {\n  id\n  masterId\n  variantId\n  name\n  header\n  subHeader\n  price\n  colorValue\n  colorName\n  ean\n  preview\n  images {\n    alt\n    href\n    verticalImageHref\n  }\n}\n    "
    ]);
    _templateObject31 = function _templateObject31() {
        return data;
    };
    return data;
}
function _templateObject32() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment pdpMandatoryExtraVariantFields on Variant {\n  id\n  sizeGroups {\n    label\n    description\n    sizes {\n      id\n      label\n      value\n      productId\n      orderable\n      maxOrderableQuantity\n    }\n  }\n}\n    "
    ]);
    _templateObject32 = function _templateObject32() {
        return data;
    };
    return data;
}
function _templateObject33() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment sizes on Product {\n  productMeasurements {\n    metric\n    imperial\n  }\n}\n    "
    ]);
    _templateObject33 = function _templateObject33() {
        return data;
    };
    return data;
}
function _templateObject34() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment mandatoryVariantFields on Variant {\n  id\n  masterId\n  variantId\n  name\n  header\n  subHeader\n  price\n  colorValue\n  colorName\n  ean\n  sizeGroups {\n    label\n    description\n    sizes {\n      id\n      label\n      value\n      productId\n      orderable\n      maxOrderableQuantity\n    }\n  }\n  preview\n  images {\n    alt\n    href\n    verticalImageHref\n  }\n}\n    "
    ]);
    _templateObject34 = function _templateObject34() {
        return data;
    };
    return data;
}
function _templateObject35() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment mandatoryMasterFields on Product {\n  name\n  id\n  header\n  subHeader\n  orderableColorCount\n  displayOutOfStock {\n    soldout\n    soldoutWithRecommender\n    comingsoon\n    backsoon\n    presale\n    displayValue\n  }\n  colors {\n    name\n    value\n    image {\n      href\n      verticalImageHref\n      alt\n    }\n  }\n  image {\n    href\n    verticalImageHref\n    alt\n  }\n  showExploreCollectionCTA\n}\n    "
    ]);
    _templateObject35 = function _templateObject35() {
        return data;
    };
    return data;
}
function _templateObject36() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment PaginatedOutputNodesFragment on PaginatedOutput {\n  nodes {\n    __typename\n    id\n    color\n    masterId\n    variantProduct {\n      ...mandatoryVariantFields\n      badges {\n        id\n        label\n      }\n      percentageDiscountBadge\n      salePrice\n      productPrice {\n        price\n        salePrice\n        promotionPrice\n        isSalePriceElapsed\n        tax\n        taxRate\n        bestPrice\n      }\n      displayOutOfStock {\n        soldout\n        comingsoon\n        backsoon\n        presale\n        displayValue\n      }\n      orderable\n      promotions(page: ProductListingPage) {\n        id\n        calloutMessage\n      }\n      isAppExclusive\n      appOnlyDateTimeFrom\n      appOnlyDateTimeTo\n    }\n    masterProduct {\n      ...mandatoryMasterFields\n      brand\n      promotions(page: ProductListingPage) {\n        id\n        calloutMessage\n      }\n      amountOfReviews\n      averageRating\n      disableRatings\n      disableReviews\n      score {\n        rating\n        amount\n      }\n    }\n  }\n}\n    ",
        "\n",
        ""
    ]);
    _templateObject36 = function _templateObject36() {
        return data;
    };
    return data;
}
function _templateObject37() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment PaginatedOutputMetadataFragment on PaginatedOutput {\n  sortingOptions {\n    id\n    label\n  }\n  selectedSort\n  filteringOptions {\n    id\n    label\n    values {\n      value\n      label\n      hitCount\n    }\n  }\n  totalCount\n}\n    "
    ]);
    _templateObject37 = function _templateObject37() {
        return data;
    };
    return data;
}
function _templateObject38() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment ReviewFields on Review {\n  id\n  rating\n  title\n  text\n  nickname\n  location\n  pros\n  cons\n  date\n  helpfulVotes\n  isRecommended\n  secondaryRatings {\n    id\n    label\n    rating\n  }\n  aspects {\n    width\n    size\n    comfort\n  }\n}\n    "
    ]);
    _templateObject38 = function _templateObject38() {
        return data;
    };
    return data;
}
function _templateObject39() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment ReviewSummaryFields on ReviewSummary {\n  recommendedCount\n  totalCount\n  recommendedPercentage\n  aspects {\n    width\n    size\n    comfort\n  }\n}\n    "
    ]);
    _templateObject39 = function _templateObject39() {
        return data;
    };
    return data;
}
function _templateObject40() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment orderPreviewFields on StandardOrder {\n  orderNo\n  createdAt\n  currency\n  orderStatus {\n    code\n    label\n  }\n  estimatedTotal\n  isReturnable\n  shipment {\n    address {\n      id\n      firstName\n      lastName\n      postalCode\n      salutation\n    }\n  }\n  refundInformation\n  products {\n    ... on ProductCartItem {\n      __typename\n      id\n      quantity\n      inCartPrice\n      purchasedPrice {\n        price\n        promotionPrice\n      }\n      product {\n        id\n        name\n        header\n        subHeader\n        colorValue\n        colorName\n        masterId\n        images {\n          href\n          alt\n        }\n        styleNumber\n        offline\n        orderable\n      }\n      personalizationImageURL\n    }\n    ... on GiftCardCartItem {\n      id\n      imageUrl\n      amount\n      recipientEmail\n      recipientName\n      senderName\n      __typename\n    }\n  }\n  customer {\n    email\n    id\n  }\n}\n    "
    ]);
    _templateObject40 = function _templateObject40() {
        return data;
    };
    return data;
}
function _templateObject41() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment standardOrderDetailsFields on StandardOrder {\n  __typename\n  orderNo\n  orderToken\n  status\n  orderStatus {\n    code\n    label\n  }\n  refundInformation\n  trackingNumber\n  isReturnable\n  statuses {\n    status\n    label\n    order\n  }\n  taxTotal\n  taxation\n  createdAt\n  currency\n  oms {\n    trackingLink\n  }\n  subTotal\n  shippingCosts\n  estimatedTotal\n  gmoRedirectUrl\n  gmoChallengeUrl\n  gmoFlow\n  gmoAccessID\n  gmoAccessPass\n  promoDiscountValue\n  shippingSurcharge {\n    amount\n    label\n    tooltip\n  }\n  orderAdjustments {\n    promotionId\n    itemText\n    price\n    couponCode\n  }\n  shippingAdjustments {\n    promotionId\n    itemText\n    price\n    couponCode\n  }\n  couponItems {\n    code\n    couponItemId\n    statusCode\n    valid\n  }\n  products {\n    ...productCartItemFields\n  }\n  ...orderPaymentInstrumentFields\n  ...orderConfirmationFields\n}\n    ",
        "\n",
        "\n",
        ""
    ]);
    _templateObject41 = function _templateObject41() {
        return data;
    };
    return data;
}
function _templateObject42() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment storeCreditFields on StoreCredit {\n  amount\n}\n    "
    ]);
    _templateObject42 = function _templateObject42() {
        return data;
    };
    return data;
}
function _templateObject43() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment termsAndConditionsFields on TermsAndConditions {\n  id\n  __typename\n  content {\n    ...portableTextFields\n  }\n}\n    ",
        ""
    ]);
    _templateObject43 = function _templateObject43() {
        return data;
    };
    return data;
}
function _templateObject44() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment userFields on User {\n  id\n  customerNo\n  creationDate\n  birthday\n  firstName\n  lastName\n  firstNamePronunciation\n  lastNamePronunciation\n  email\n  phoneNumber\n  gender\n  birthday\n  smsContactNumber\n}\n    "
    ]);
    _templateObject44 = function _templateObject44() {
        return data;
    };
    return data;
}
function _templateObject45() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment sanityVideoFields on SanityVideo {\n  autoplay\n  loop\n  mute\n  source\n}\n    "
    ]);
    _templateObject45 = function _templateObject45() {
        return data;
    };
    return data;
}
function _templateObject46() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment wishListFields on WishList {\n  id\n  items {\n    __typename\n    id\n    quantity\n    creationDate\n    product {\n      id\n      name\n      header\n      subHeader\n      masterId\n      orderable\n      inventory\n      displayOutOfStock {\n        displayValue\n        presale\n        validTo\n      }\n      price\n      salePrice\n      productPrice {\n        price\n        salePrice\n        promotionPrice\n        isSalePriceElapsed\n        tax\n        taxRate\n        bestPrice\n      }\n      images {\n        href\n        alt\n      }\n      styleNumber\n      colorValue\n      colorName\n      size {\n        label\n        value\n      }\n      offline\n      isAppExclusive\n      appOnlyDateTimeFrom\n      appOnlyDateTimeTo\n    }\n  }\n}\n    "
    ]);
    _templateObject46 = function _templateObject46() {
        return data;
    };
    return data;
}
function _templateObject47() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment recommendationFields on ProductSearchHit {\n  __typename\n  id\n  masterId\n  color\n  variantProduct {\n    ...mandatoryVariantFields\n    badges {\n      id\n      label\n    }\n    percentageDiscountBadge\n    salePrice\n    productPrice {\n      price\n      salePrice\n      promotionPrice\n    }\n    displayOutOfStock {\n      soldout\n      comingsoon\n      backsoon\n      presale\n      displayValue\n    }\n    orderable\n    promotions(page: ProductListingPage) {\n      id\n      calloutMessage\n    }\n    isAppExclusive\n    appOnlyDateTimeFrom\n    appOnlyDateTimeTo\n  }\n  masterProduct {\n    ...mandatoryMasterFields\n    brand\n    promotions(page: ProductListingPage) {\n      id\n      calloutMessage\n    }\n    score {\n      rating\n      amount\n    }\n  }\n}\n    ",
        "\n",
        ""
    ]);
    _templateObject47 = function _templateObject47() {
        return data;
    };
    return data;
}
function _templateObject48() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment product on ProductSuggestion {\n  id\n  styleId\n  name\n  price\n  salePrice\n  orderable\n  image {\n    href\n    alt\n  }\n}\n    "
    ]);
    _templateObject48 = function _templateObject48() {
        return data;
    };
    return data;
}
function _templateObject49() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation GuestLogon {\n  guestLogon {\n    ...tokenPayload\n  }\n}\n    ",
        ""
    ]);
    _templateObject49 = function _templateObject49() {
        return data;
    };
    return data;
}
function _templateObject50() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation RefreshLogon($input: RefreshLogonInput!) {\n  refreshLogon(input: $input) {\n    ...tokenPayload\n  }\n}\n    ",
        ""
    ]);
    _templateObject50 = function _templateObject50() {
        return data;
    };
    return data;
}
function _templateObject51() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation UpdatePassword($currentPassword: String!, $newPassword: String!) {\n  updatePassword(\n    input: {currentPassword: $currentPassword, newPassword: $newPassword}\n  )\n}\n    "
    ]);
    _templateObject51 = function _templateObject51() {
        return data;
    };
    return data;
}
function _templateObject52() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation UpdatePhone($input: UpdatePhoneInput!) {\n  updatePhone(input: $input) {\n    code\n    message\n    pinId\n  }\n}\n    "
    ]);
    _templateObject52 = function _templateObject52() {
        return data;
    };
    return data;
}
function _templateObject53() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation ConfirmUpdatePhone($input: ConfirmUpdatePhoneInput!) {\n  confirmUpdatePhone(input: $input) {\n    code\n    message\n    user {\n      id\n      phoneNumber\n    }\n  }\n}\n    "
    ]);
    _templateObject53 = function _templateObject53() {
        return data;
    };
    return data;
}
function _templateObject54() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation ResetPassword($email: String!) {\n  resetPassword(email: $email)\n}\n    "
    ]);
    _templateObject54 = function _templateObject54() {
        return data;
    };
    return data;
}
function _templateObject55() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation CompleteResetPassword($password: String!, $token: String!) {\n  completeResetPassword(password: $password, token: $token)\n}\n    "
    ]);
    _templateObject55 = function _templateObject55() {
        return data;
    };
    return data;
}
function _templateObject56() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation CreateShopperContext($input: CreateShopperContextInput!) {\n  createShopperContext(input: $input) {\n    sourceCode\n  }\n}\n    "
    ]);
    _templateObject56 = function _templateObject56() {
        return data;
    };
    return data;
}
function _templateObject57() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation VerifyUserAffiliations($input: VerifyUserAffiliationsInput!) {\n  verifyUserAffiliations(input: $input) {\n    verified\n    affiliations\n  }\n}\n    "
    ]);
    _templateObject57 = function _templateObject57() {
        return data;
    };
    return data;
}
function _templateObject58() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation AddAddress($title: String!, $firstName: String!, $lastName: String!, $firstNamePronunciation: String, $lastNamePronunciation: String, $address1: String!, $address2: String, $city: String!, $postalCode: String!, $stateCode: String, $countryCode: String!, $phone: String, $preferred: Boolean!, $streetNumber: String, $salutation: String, $companyName: String) {\n  addAddress(\n    input: {title: $title, firstName: $firstName, lastName: $lastName, firstNamePronunciation: $firstNamePronunciation, lastNamePronunciation: $lastNamePronunciation, address1: $address1, city: $city, address2: $address2, postalCode: $postalCode, stateCode: $stateCode, countryCode: $countryCode, phone: $phone, preferred: $preferred, streetNumber: $streetNumber, salutation: $salutation, companyName: $companyName}\n  ) {\n    ...addressFields\n  }\n}\n    ",
        ""
    ]);
    _templateObject58 = function _templateObject58() {
        return data;
    };
    return data;
}
function _templateObject59() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation UpdateAddress($id: ID!, $title: String!, $firstName: String!, $lastName: String!, $firstNamePronunciation: String, $lastNamePronunciation: String, $address1: String!, $address2: String, $city: String!, $postalCode: String!, $stateCode: String, $countryCode: String!, $phone: String, $preferred: Boolean!, $streetNumber: String, $salutation: String, $companyName: String) {\n  updateAddress(\n    input: {id: $id, title: $title, firstName: $firstName, lastName: $lastName, firstNamePronunciation: $firstNamePronunciation, lastNamePronunciation: $lastNamePronunciation, address1: $address1, city: $city, address2: $address2, postalCode: $postalCode, stateCode: $stateCode, countryCode: $countryCode, phone: $phone, preferred: $preferred, streetNumber: $streetNumber, salutation: $salutation, companyName: $companyName}\n  ) {\n    ...addressFields\n  }\n}\n    ",
        ""
    ]);
    _templateObject59 = function _templateObject59() {
        return data;
    };
    return data;
}
function _templateObject60() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation DeleteAddress($id: ID!) {\n  deleteAddress(id: $id)\n}\n    "
    ]);
    _templateObject60 = function _templateObject60() {
        return data;
    };
    return data;
}
function _templateObject61() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation SaveAmbassadorCard($input: SaveAmbassadorCardInput!) {\n  saveAmbassadorCard(input: $input) {\n    id\n    ambassadorCards {\n      ...ambassadorCardFields\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject61 = function _templateObject61() {
        return data;
    };
    return data;
}
function _templateObject62() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation DeleteAmbassadorCard($input: DeleteAmbassadorCardInput!) {\n  deleteAmbassadorCard(input: $input) {\n    id\n    ambassadorCards {\n      ...ambassadorCardFields\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject62 = function _templateObject62() {
        return data;
    };
    return data;
}
function _templateObject63() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation UpdateAmbassadorCards($input: UpdateAmbassadorCardInput!) {\n  updateAmbassadorCards(input: $input) {\n    id\n    ambassadorCards {\n      ...ambassadorCardFields\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject63 = function _templateObject63() {
        return data;
    };
    return data;
}
function _templateObject64() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation AddItemsToCart($input: AddItemsToCartInput!) {\n  addItemsToCart(input: $input) {\n    ...cartFields\n  }\n}\n    ",
        ""
    ]);
    _templateObject64 = function _templateObject64() {
        return data;
    };
    return data;
}
function _templateObject65() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation UpdateItemInCart($input: UpdateItemInCartInput!) {\n  updateItemInCart(input: $input) {\n    ...cartFields\n  }\n}\n    ",
        ""
    ]);
    _templateObject65 = function _templateObject65() {
        return data;
    };
    return data;
}
function _templateObject66() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation RemoveItemFromCart($input: RemoveItemFromCartInput!) {\n  removeItemFromCart(input: $input) {\n    ...cartFields\n  }\n}\n    ",
        ""
    ]);
    _templateObject66 = function _templateObject66() {
        return data;
    };
    return data;
}
function _templateObject67() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation AddGiftCardToCart($input: AddGiftCardToCartInput!) {\n  addGiftCardToCart(input: $input) {\n    ...cartFields\n  }\n}\n    ",
        ""
    ]);
    _templateObject67 = function _templateObject67() {
        return data;
    };
    return data;
}
function _templateObject68() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation RemoveGiftCardFromCart($input: RemoveGiftCardFromCartInput!) {\n  removeGiftCardFromCart(input: $input) {\n    ...cartFields\n  }\n}\n    ",
        ""
    ]);
    _templateObject68 = function _templateObject68() {
        return data;
    };
    return data;
}
function _templateObject69() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation AddGiftCard($input: AddGiftCardInput!) {\n  addGiftCard(input: $input) {\n    ...cartFields\n  }\n}\n    ",
        ""
    ]);
    _templateObject69 = function _templateObject69() {
        return data;
    };
    return data;
}
function _templateObject70() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation RemoveGiftCard($input: RemoveGiftCardInput!) {\n  removeGiftCard(input: $input) {\n    ...cartFields\n  }\n}\n    ",
        ""
    ]);
    _templateObject70 = function _templateObject70() {
        return data;
    };
    return data;
}
function _templateObject71() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation UpdateShippingAddress($input: UpdateShippingAddressInput!) {\n  updateShippingAddress(input: $input) {\n    ...cartFields\n  }\n}\n    ",
        ""
    ]);
    _templateObject71 = function _templateObject71() {
        return data;
    };
    return data;
}
function _templateObject72() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation UpdateShipmentMethod($input: UpdateShipmentMethodInput!) {\n  updateShipmentMethod(input: $input) {\n    ...cartFields\n  }\n}\n    ",
        ""
    ]);
    _templateObject72 = function _templateObject72() {
        return data;
    };
    return data;
}
function _templateObject73() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation UpdateBillingAddress($input: UpdateBillingAddressInput!) {\n  updateBillingAddress(input: $input) {\n    ...cartFields\n  }\n}\n    ",
        ""
    ]);
    _templateObject73 = function _templateObject73() {
        return data;
    };
    return data;
}
function _templateObject74() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation RemoveCouponFromCart($input: RemoveCouponFromCartInput!) {\n  removeCouponFromCart(input: $input) {\n    ...cartFields\n  }\n}\n    ",
        ""
    ]);
    _templateObject74 = function _templateObject74() {
        return data;
    };
    return data;
}
function _templateObject75() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation AddCouponToCart($input: AddCouponToCartInput!) {\n  addCouponToCart(input: $input) {\n    ...cartFields\n  }\n}\n    ",
        ""
    ]);
    _templateObject75 = function _templateObject75() {
        return data;
    };
    return data;
}
function _templateObject76() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation AddPaymentPromotion($input: AddPaymentPromotionInput!) {\n  addPaymentPromotion(input: $input) {\n    ...cartFields\n  }\n}\n    ",
        ""
    ]);
    _templateObject76 = function _templateObject76() {
        return data;
    };
    return data;
}
function _templateObject77() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation AddAmbassadorCardToCart($input: AddAmbassadorCardToCartInput!) {\n  addAmbassadorCardToCart(input: $input) {\n    ...cartFields\n  }\n}\n    ",
        ""
    ]);
    _templateObject77 = function _templateObject77() {
        return data;
    };
    return data;
}
function _templateObject78() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation RemoveAmbassadorCardFromCart($input: RemoveAmbassadorCardFromCartInput!) {\n  removeAmbassadorCardFromCart(input: $input) {\n    ...cartFields\n  }\n}\n    ",
        ""
    ]);
    _templateObject78 = function _templateObject78() {
        return data;
    };
    return data;
}
function _templateObject79() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation AddStoreCredits($input: AddStoreCreditsInput!) {\n  addStoreCredits(input: $input) {\n    cart {\n      ...cartFields\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject79 = function _templateObject79() {
        return data;
    };
    return data;
}
function _templateObject80() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation RemoveStoreCredits($input: RemoveStoreCreditsInput!) {\n  removeStoreCredits(input: $input) {\n    cart {\n      ...cartFields\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject80 = function _templateObject80() {
        return data;
    };
    return data;
}
function _templateObject81() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation UpdateContact($input: CreateContactInput!) {\n  updateContact(input: $input) {\n    email\n    gender\n    dob {\n      day\n      month\n      year\n    }\n    firstName\n    lastName\n    firstNamePronunciation\n    lastNamePronunciation\n    emailPreference\n    shoppingPreference\n  }\n}\n    "
    ]);
    _templateObject81 = function _templateObject81() {
        return data;
    };
    return data;
}
function _templateObject82() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation ProfilingConsent($input: ProfilingConsentInput) {\n  profilingConsent(input: $input) {\n    externalRef\n    citizenId\n    token\n  }\n}\n    "
    ]);
    _templateObject82 = function _templateObject82() {
        return data;
    };
    return data;
}
function _templateObject83() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation Klarna($input: KlarnaInput!) {\n  klarna(input: $input) {\n    action\n    url\n    orderNo\n  }\n}\n    "
    ]);
    _templateObject83 = function _templateObject83() {
        return data;
    };
    return data;
}
function _templateObject84() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation ConfirmKlarna($input: ConfirmKlarnaInput!) {\n  confirmKlarna(input: $input) {\n    orderNo\n    status\n  }\n}\n    "
    ]);
    _templateObject84 = function _templateObject84() {
        return data;
    };
    return data;
}
function _templateObject85() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation CancelKlarna($input: CancelKlarnaInput!) {\n  cancelKlarna(input: $input) {\n    orderNo\n    status\n  }\n}\n    "
    ]);
    _templateObject85 = function _templateObject85() {
        return data;
    };
    return data;
}
function _templateObject86() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation startKlarnaPayment($input: StartKlarnaPaymentInput!) {\n  startKlarnaPayment(input: $input) {\n    clientToken\n    orderNo\n    paymentMethodCategories {\n      identifier\n    }\n    sessionId\n  }\n}\n    "
    ]);
    _templateObject86 = function _templateObject86() {
        return data;
    };
    return data;
}
function _templateObject87() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation confirmKlarnaPayment($input: ConfirmKlarnaPaymentInput!) {\n  confirmKlarnaPayment(input: $input) {\n    orderNo\n    orderStatus {\n      code\n      label\n    }\n    status\n  }\n}\n    "
    ]);
    _templateObject87 = function _templateObject87() {
        return data;
    };
    return data;
}
function _templateObject88() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation LoginWithEmailAndPassword($email: String!, $password: String!, $uniqueShopperId: String) {\n  login(\n    input: {email: $email, password: $password, uniqueShopperId: $uniqueShopperId}\n  ) {\n    ...authPayload\n  }\n}\n    ",
        ""
    ]);
    _templateObject88 = function _templateObject88() {
        return data;
    };
    return data;
}
function _templateObject89() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation VerifyLoginWithOTP($phoneNo: String!, $pinId: String!, $pin: String!, $recaptchaToken: String, $uniqueShopperId: String) {\n  verifyLoginWithOTP(\n    input: {phoneNo: $phoneNo, pinId: $pinId, pin: $pin, recaptchaToken: $recaptchaToken, uniqueShopperId: $uniqueShopperId}\n  ) {\n    authPayload {\n      ...authPayload\n    }\n    code\n    message\n    otpVerifyToken\n  }\n}\n    ",
        ""
    ]);
    _templateObject89 = function _templateObject89() {
        return data;
    };
    return data;
}
function _templateObject90() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation LoginWithOTP($recaptchaToken: String, $phoneNo: String!) {\n  loginWithOTP(input: {recaptchaToken: $recaptchaToken, phoneNo: $phoneNo})\n}\n    "
    ]);
    _templateObject90 = function _templateObject90() {
        return data;
    };
    return data;
}
function _templateObject91() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation LoginWithPhone($phoneNo: String!, $password: String!, $uniqueShopperId: String) {\n  loginWithPhone(\n    input: {phoneNo: $phoneNo, password: $password, uniqueShopperId: $uniqueShopperId}\n  ) {\n    ...authPayload\n  }\n}\n    ",
        ""
    ]);
    _templateObject91 = function _templateObject91() {
        return data;
    };
    return data;
}
function _templateObject92() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation ResendOTP($pinId: String!, $recaptchaToken: String) {\n  resendOTP(input: {pinId: $pinId, recaptchaToken: $recaptchaToken})\n}\n    "
    ]);
    _templateObject92 = function _templateObject92() {
        return data;
    };
    return data;
}
function _templateObject93() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation Logout {\n  logout\n}\n    "
    ]);
    _templateObject93 = function _templateObject93() {
        return data;
    };
    return data;
}
function _templateObject94() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation ManageCustomerLevelNotification($input: ManageCustomerLevelNotificationInput!) {\n  manageCustomerLevelNotification(input: $input)\n}\n    "
    ]);
    _templateObject94 = function _templateObject94() {
        return data;
    };
    return data;
}
function _templateObject95() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation SaveNotificationPreferences($input: NotificationsPreferenceInput!) {\n  saveNotificationPreferences(input: $input) {\n    phoneNumber\n    marketingSmsOptIn\n    customerSmsOptIn\n  }\n}\n    "
    ]);
    _templateObject95 = function _templateObject95() {
        return data;
    };
    return data;
}
function _templateObject96() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation ManageOrderLevelNotification($input: ManageOrderLevelNotificationInput!) {\n  manageOrderLevelNotification(input: $input)\n}\n    "
    ]);
    _templateObject96 = function _templateObject96() {
        return data;
    };
    return data;
}
function _templateObject97() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation CreateContact($input: CreateContactInput!) {\n  createContact(input: $input) {\n    email\n    gender\n    dob {\n      day\n      month\n      year\n    }\n    emailPreference\n    shoppingPreference\n  }\n}\n    "
    ]);
    _templateObject97 = function _templateObject97() {
        return data;
    };
    return data;
}
function _templateObject98() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation OpluxFraudDetection($basketId: String!, $opluxFraudDetection: String!, $paymentMethodId: String, $fraudbuster: String, $opluxEventId: String, $opluxScreeningResult: String) {\n  opluxFraudDetection(\n    basketId: $basketId\n    opluxFraudDetection: $opluxFraudDetection\n    paymentMethodId: $paymentMethodId\n    fraudbuster: $fraudbuster\n    opluxEventId: $opluxEventId\n    opluxScreeningResult: $opluxScreeningResult\n  ) {\n    isOpluxNG\n    opluxEventId\n    opluxScreeningResult\n  }\n}\n    "
    ]);
    _templateObject98 = function _templateObject98() {
        return data;
    };
    return data;
}
function _templateObject99() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation StartAdyenPayment($input: StartAdyenPaymentInput!) {\n  startAdyenPayment(input: $input) {\n    orderNo\n    simulatorUrl\n    resultCode\n    action {\n      ... on CheckoutRedirectAction {\n        data\n        method\n        type\n        url\n        paymentMethodType\n      }\n      ... on CheckoutSDKAction {\n        paymentMethodType\n        paymentData\n        type\n        sdkData {\n          token\n        }\n      }\n      ... on CheckoutAwaitAction {\n        paymentMethodType\n        type\n        url\n        paymentData\n      }\n    }\n  }\n}\n    "
    ]);
    _templateObject99 = function _templateObject99() {
        return data;
    };
    return data;
}
function _templateObject100() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation CompleteAdyenPayment($input: CompleteAdyenPaymentInput!) {\n  completeAdyenPayment(input: $input) {\n    order {\n      orderNo\n    }\n    resultCode\n  }\n}\n    "
    ]);
    _templateObject100 = function _templateObject100() {
        return data;
    };
    return data;
}
function _templateObject101() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation PayWithAfterPay($input: AfterPayInput!) {\n  afterPay(input: $input) {\n    url\n    orderNo\n  }\n}\n    "
    ]);
    _templateObject101 = function _templateObject101() {
        return data;
    };
    return data;
}
function _templateObject102() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation ConfirmAfterPay($input: ConfirmAfterPayInput!) {\n  confirmAfterPay(input: $input) {\n    orderNo\n    status\n    ...orderPaymentInstrumentFields\n    ...orderConfirmationFields\n  }\n}\n    ",
        "\n",
        ""
    ]);
    _templateObject102 = function _templateObject102() {
        return data;
    };
    return data;
}
function _templateObject103() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    query AmazonPayPaymentDescriptor($input: AmazonPayPaymentDescriptorInput!) {\n  amazonPayPaymentDescriptor(input: $input) {\n    paymentOption\n  }\n}\n    "
    ]);
    _templateObject103 = function _templateObject103() {
        return data;
    };
    return data;
}
function _templateObject104() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation SignAmazonPayload($input: SignAmazonPayloadInput!) {\n  signAmazonPayload(input: $input) {\n    signedPayload\n  }\n}\n    "
    ]);
    _templateObject104 = function _templateObject104() {
        return data;
    };
    return data;
}
function _templateObject105() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation StartAmazonPayment($input: StartAmazonPaymentInput!) {\n  startAmazonPayment(input: $input) {\n    url\n    order {\n      orderNo\n    }\n  }\n}\n    "
    ]);
    _templateObject105 = function _templateObject105() {
        return data;
    };
    return data;
}
function _templateObject106() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation StartAmazonProcessOrderPayment($input: StartAmazonProcessOrderPaymentInput!) {\n  startAmazonProcessOrderPayment(input: $input) {\n    order {\n      orderNo\n    }\n  }\n}\n    "
    ]);
    _templateObject106 = function _templateObject106() {
        return data;
    };
    return data;
}
function _templateObject107() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation CompleteAmazonPayment($input: CompleteAmazonPaymentInput!) {\n  completeAmazonPayment(input: $input) {\n    order {\n      orderNo\n    }\n  }\n}\n    "
    ]);
    _templateObject107 = function _templateObject107() {
        return data;
    };
    return data;
}
function _templateObject108() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation RegisterAmazonPayment($input: RegisterAmazonPaymentInput!) {\n  registerAmazonPayment(input: $input) {\n    shouldPromptForLogin\n    cart {\n      ...cartFields\n      shipment {\n        ...shipmentFields\n      }\n      shipmentMethodInfo {\n        ...shipmentMethodInfoFields\n      }\n      availablePaymentMethods {\n        ...availablePaymentMethodsFields\n      }\n    }\n  }\n}\n    ",
        "\n",
        "\n",
        "\n",
        ""
    ]);
    _templateObject108 = function _templateObject108() {
        return data;
    };
    return data;
}
function _templateObject109() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation PayWithAmbassadorCard($input: AmbassadorCardInput!) {\n  ambassadorCard(input: $input) {\n    orderNo\n    ...orderConfirmationFields\n    ...orderPaymentInstrumentFields\n  }\n}\n    ",
        "\n",
        ""
    ]);
    _templateObject109 = function _templateObject109() {
        return data;
    };
    return data;
}
function _templateObject110() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation PayWithApplePay($input: ApplePayInput!) {\n  applePay(input: $input) {\n    epochTimestamp\n    expiresAt\n    merchantSessionIdentifier\n    nonce\n    merchantIdentifier\n    domainName\n    displayName\n    signature\n    operationalAnalyticsIdentifier\n    retries\n  }\n}\n    "
    ]);
    _templateObject110 = function _templateObject110() {
        return data;
    };
    return data;
}
function _templateObject111() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation ValidateApplePayMerchant($input: ValidateApplePayMerchantInput!) {\n  validateApplePayMerchant(input: $input)\n}\n    "
    ]);
    _templateObject111 = function _templateObject111() {
        return data;
    };
    return data;
}
function _templateObject112() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation ConfirmApplePay($input: ConfirmApplePayInput!) {\n  confirmApplePay(input: $input) {\n    orderNo\n    status\n    ...orderPaymentInstrumentFields\n    ...orderConfirmationFields\n  }\n}\n    ",
        "\n",
        ""
    ]);
    _templateObject112 = function _templateObject112() {
        return data;
    };
    return data;
}
function _templateObject113() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation CancelApplePay($basketId: String!) {\n  cancelApplePay(basketId: $basketId) {\n    id\n  }\n}\n    "
    ]);
    _templateObject113 = function _templateObject113() {
        return data;
    };
    return data;
}
function _templateObject114() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation CancelOrder($input: CancelOrderInput!) {\n  cancelOrder(input: $input) {\n    order {\n      orderNo\n    }\n    cart {\n      ...cartFields\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject114 = function _templateObject114() {
        return data;
    };
    return data;
}
function _templateObject115() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation PayWithCashOnDelivery($input: CashOnDeliveryInput!) {\n  cashOnDelivery(input: $input) {\n    orderNo\n    ...orderConfirmationFields\n    orderAdjustments {\n      promotionId\n      itemText\n      price\n      couponCode\n    }\n    pinId\n    estimatedTotal\n    taxTotal\n    products {\n      ...productCartItemFields\n    }\n  }\n}\n    ",
        "\n",
        ""
    ]);
    _templateObject115 = function _templateObject115() {
        return data;
    };
    return data;
}
function _templateObject116() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation PayWithCashOnDeliveryInCart($input: AddCashOnDeliveryToCartInput!) {\n  addCashOnDeliveryPaymentMethodToCart(input: $input) {\n    ... on Cart {\n      id\n      estimatedTotal\n      amountRemaining\n      orderAdjustments {\n        promotionId\n        itemText\n        price\n        couponCode\n      }\n      shippingAdjustments {\n        promotionId\n        itemText\n        price\n        couponCode\n      }\n      paymentInstruments {\n        ... on CreditCard {\n          id\n          amount\n          __typename\n        }\n      }\n    }\n  }\n}\n    "
    ]);
    _templateObject116 = function _templateObject116() {
        return data;
    };
    return data;
}
function _templateObject117() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation ConfirmCashOnDelivery($input: ConfirmCashOnDeliveryInput!) {\n  confirmCashOnDelivery(input: $input) {\n    orderNo\n    pin\n    pinId\n    ...orderConfirmationFields\n  }\n}\n    ",
        ""
    ]);
    _templateObject117 = function _templateObject117() {
        return data;
    };
    return data;
}
function _templateObject118() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation PayWithCreditCard($input: CreditCardInput!) {\n  creditCard(input: $input) {\n    ... on ThreeDSResponse {\n      url\n      method\n      data\n      orderNo\n    }\n    ... on StandardOrder {\n      orderNo\n      status\n      ...orderConfirmationFields\n      subTotal\n      orderAdjustments {\n        promotionId\n        itemText\n        price\n        couponCode\n      }\n      shippingAdjustments {\n        promotionId\n        itemText\n        price\n        couponCode\n      }\n      couponItems {\n        code\n        couponItemId\n        statusCode\n        valid\n      }\n      orderNo\n      taxTotal\n      estimatedTotal\n      status\n      products {\n        ...productCartItemFields\n      }\n      ...orderPaymentInstrumentFields\n    }\n  }\n}\n    ",
        "\n",
        "\n",
        ""
    ]);
    _templateObject118 = function _templateObject118() {
        return data;
    };
    return data;
}
function _templateObject119() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation PayWithCreditCardInCart($input: AddCreditCardToCartInput!) {\n  addCreditCardPaymentMethodToCart(input: $input) {\n    ... on Cart {\n      id\n      orderAdjustments {\n        promotionId\n        itemText\n        price\n        couponCode\n      }\n      shippingAdjustments {\n        promotionId\n        itemText\n        price\n        couponCode\n      }\n      estimatedTotal\n      paymentInstruments {\n        ... on CreditCard {\n          id\n          amount\n          maskedNumber\n          cardType\n          authorizationStatus\n          __typename\n        }\n      }\n    }\n  }\n}\n    "
    ]);
    _templateObject119 = function _templateObject119() {
        return data;
    };
    return data;
}
function _templateObject120() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation ConfirmCreditCard($input: ConfirmCreditCardInput!) {\n  confirmCreditCard(input: $input) {\n    orderNo\n    status\n    ...orderPaymentInstrumentFields\n    ...orderConfirmationFields\n  }\n}\n    ",
        "\n",
        ""
    ]);
    _templateObject120 = function _templateObject120() {
        return data;
    };
    return data;
}
function _templateObject121() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation SaveCreditCard($cardType: String!, $expirationMonth: Int!, $expirationYear: Int!, $number: String!, $holder: String, $gmoSpecificSaveData: GMOSaveData, $defaultCard: Boolean) {\n  saveCreditCard(\n    input: {cardType: $cardType, expirationMonth: $expirationMonth, expirationYear: $expirationYear, number: $number, holder: $holder, gmoSpecificSaveData: $gmoSpecificSaveData, defaultCard: $defaultCard}\n  ) {\n    savedCards {\n      ...savedCreditCard\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject121 = function _templateObject121() {
        return data;
    };
    return data;
}
function _templateObject122() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation DeleteCreditCard($cardId: String!) {\n  deleteCreditCard(input: {cardId: $cardId}) {\n    savedCards {\n      ...savedCreditCard\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject122 = function _templateObject122() {
        return data;
    };
    return data;
}
function _templateObject123() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation StartCreditCardPayment($input: StartCreditCardPaymentInput!) {\n  startCreditCardPayment(input: $input) {\n    ...standardOrderDetailsFields\n  }\n}\n    ",
        ""
    ]);
    _templateObject123 = function _templateObject123() {
        return data;
    };
    return data;
}
function _templateObject124() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation GmoConfirmCreditCard($input: GmoConfirmCreditCardInput!) {\n  gmoConfirmCreditCard(input: $input) {\n    ...standardOrderDetailsFields\n  }\n}\n    ",
        ""
    ]);
    _templateObject124 = function _templateObject124() {
        return data;
    };
    return data;
}
function _templateObject125() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation PlaceOrder($input: PlaceOrderInput!) {\n  placeOrder(input: $input) {\n    order {\n      orderNo\n      status\n      subTotal\n      orderAdjustments {\n        promotionId\n        itemText\n        price\n        couponCode\n      }\n      shippingAdjustments {\n        promotionId\n        itemText\n        price\n        couponCode\n      }\n      orderNo\n      taxTotal\n      estimatedTotal\n      status\n      products {\n        ...productCartItemFields\n      }\n      ...orderConfirmationFields\n      ...orderPaymentInstrumentFields\n    }\n  }\n}\n    ",
        "\n",
        "\n",
        ""
    ]);
    _templateObject125 = function _templateObject125() {
        return data;
    };
    return data;
}
function _templateObject126() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation PayWithGiftCard($input: GiftCardInput!) {\n  giftCard(input: $input) {\n    orderNo\n    status\n    subTotal\n    orderAdjustments {\n      promotionId\n      itemText\n      price\n      couponCode\n    }\n    shippingAdjustments {\n      promotionId\n      itemText\n      price\n      couponCode\n    }\n    orderNo\n    taxTotal\n    estimatedTotal\n    status\n    products {\n      ...productCartItemFields\n    }\n    ...orderConfirmationFields\n    ...orderPaymentInstrumentFields\n  }\n}\n    ",
        "\n",
        "\n",
        ""
    ]);
    _templateObject126 = function _templateObject126() {
        return data;
    };
    return data;
}
function _templateObject127() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation PayWithGooglePay($input: GooglePayInput!) {\n  googlePay(input: $input) {\n    orderNo\n    status\n    ...orderPaymentInstrumentFields\n    ...orderConfirmationFields\n  }\n}\n    ",
        "\n",
        ""
    ]);
    _templateObject127 = function _templateObject127() {
        return data;
    };
    return data;
}
function _templateObject128() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation CancelGooglePay($input: CancelGooglePayInput!) {\n  cancelGooglePay(input: $input) {\n    id\n  }\n}\n    "
    ]);
    _templateObject128 = function _templateObject128() {
        return data;
    };
    return data;
}
function _templateObject129() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation PayWithPayPal($input: PayPalInput!) {\n  payPal(input: $input) {\n    token\n    url\n    action\n    orderNo\n  }\n}\n    "
    ]);
    _templateObject129 = function _templateObject129() {
        return data;
    };
    return data;
}
function _templateObject130() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation ConfirmPayPal($input: ConfirmPayPalInput!) {\n  confirmPayPal(input: $input) {\n    orderNo\n    status\n    ...orderPaymentInstrumentFields\n    ...orderConfirmationFields\n  }\n}\n    ",
        "\n",
        ""
    ]);
    _templateObject130 = function _templateObject130() {
        return data;
    };
    return data;
}
function _templateObject131() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation UpdatePayPal($input: ConfirmPayPalInput!) {\n  updatePayPal(input: $input) {\n    subTotal\n    shippingCosts\n    shippingSurcharge {\n      amount\n      label\n      tooltip\n    }\n    orderAdjustments {\n      promotionId\n      itemText\n      price\n      couponCode\n    }\n    shippingAdjustments {\n      promotionId\n      itemText\n      price\n      couponCode\n    }\n    orderNo\n    taxTotal\n    taxation\n    estimatedTotal\n    status\n    orderStatus {\n      code\n      label\n    }\n    createdAt\n    products {\n      ...productCartItemFields\n    }\n    ...orderPaymentInstrumentFields\n    ...orderConfirmationFields\n  }\n}\n    ",
        "\n",
        "\n",
        ""
    ]);
    _templateObject131 = function _templateObject131() {
        return data;
    };
    return data;
}
function _templateObject132() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation PayWithPayPay($input: PayPayInput!) {\n  payPay(input: $input) {\n    url\n    orderNo\n  }\n}\n    "
    ]);
    _templateObject132 = function _templateObject132() {
        return data;
    };
    return data;
}
function _templateObject133() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation ConfirmPayPay($input: ConfirmPayPayInput!) {\n  confirmPayPay(input: $input) {\n    orderNo\n    status\n    ...orderPaymentInstrumentFields\n    ...orderConfirmationFields\n  }\n}\n    ",
        "\n",
        ""
    ]);
    _templateObject133 = function _templateObject133() {
        return data;
    };
    return data;
}
function _templateObject134() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation PayWithPayPayInCart($input: AddPayPayToCartInput!) {\n  addPayPayPaymentMethodToCart(input: $input) {\n    ... on Cart {\n      id\n      estimatedTotal\n      amountRemaining\n      orderAdjustments {\n        promotionId\n        itemText\n        price\n        couponCode\n      }\n      shippingAdjustments {\n        promotionId\n        itemText\n        price\n        couponCode\n      }\n      paymentInstruments {\n        ... on CreditCard {\n          id\n          amount\n          __typename\n        }\n      }\n    }\n  }\n}\n    "
    ]);
    _templateObject134 = function _templateObject134() {
        return data;
    };
    return data;
}
function _templateObject135() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation PayWithPayTm($basketId: String!) {\n  payTm(basketId: $basketId) {\n    orderNo\n    url\n  }\n}\n    "
    ]);
    _templateObject135 = function _templateObject135() {
        return data;
    };
    return data;
}
function _templateObject136() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation ConfirmPayTm($orderNo: String!) {\n  confirmPayTm(orderNo: $orderNo) {\n    orderNo\n    ...orderConfirmationFields\n  }\n}\n    ",
        ""
    ]);
    _templateObject136 = function _templateObject136() {
        return data;
    };
    return data;
}
function _templateObject137() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation StartRazorPay($input: StartRazorPayInput!) {\n  startRazorPay(input: $input) {\n    razorPayOrderId\n    order {\n      orderNo\n    }\n  }\n}\n    "
    ]);
    _templateObject137 = function _templateObject137() {
        return data;
    };
    return data;
}
function _templateObject138() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation ConfirmRazorPay($input: ConfirmRazorPayInput!) {\n  confirmRazorPay(input: $input) {\n    order {\n      orderNo\n    }\n  }\n}\n    "
    ]);
    _templateObject138 = function _templateObject138() {
        return data;
    };
    return data;
}
function _templateObject139() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation PayWithWallet($input: WalletInput!) {\n  wallet(input: $input) {\n    url\n    orderNo\n  }\n}\n    "
    ]);
    _templateObject139 = function _templateObject139() {
        return data;
    };
    return data;
}
function _templateObject140() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation ConfirmWallet($orderNo: String!) {\n  confirmWallet(orderNo: $orderNo) {\n    orderNo\n    ...orderConfirmationFields\n  }\n}\n    ",
        ""
    ]);
    _templateObject140 = function _templateObject140() {
        return data;
    };
    return data;
}
function _templateObject141() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation UpdateProfile($firstName: String!, $lastName: String!, $firstNamePronunciation: String, $lastNamePronunciation: String, $phoneNumber: String, $birthday: String, $gender: String) {\n  updateProfile(\n    input: {firstName: $firstName, lastName: $lastName, firstNamePronunciation: $firstNamePronunciation, lastNamePronunciation: $lastNamePronunciation, phoneNumber: $phoneNumber, birthday: $birthday, gender: $gender}\n  ) {\n    ...userFields\n  }\n}\n    ",
        ""
    ]);
    _templateObject141 = function _templateObject141() {
        return data;
    };
    return data;
}
function _templateObject142() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation Register($firstName: String!, $lastName: String!, $firstNamePronunciation: String, $lastNamePronunciation: String, $birthday: String, $email: String!, $password: String!, $inflowCode: String, $orderNo: String, $phoneNo: String, $otpVerifyToken: String) {\n  register(\n    input: {firstName: $firstName, lastName: $lastName, firstNamePronunciation: $firstNamePronunciation, lastNamePronunciation: $lastNamePronunciation, birthday: $birthday, email: $email, password: $password, inflowCode: $inflowCode, orderNo: $orderNo, phoneNumber: $phoneNo, otpVerifyToken: $otpVerifyToken}\n  ) {\n    ...authPayload\n  }\n}\n    ",
        ""
    ]);
    _templateObject142 = function _templateObject142() {
        return data;
    };
    return data;
}
function _templateObject143() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation CreateReview($input: ReviewInput!) {\n  createReview(input: $input) {\n    id\n    nickname\n    email\n    isRecommended\n    date\n    location\n    rating\n    title\n    text\n    pros\n    cons\n    prosInputted\n    consInputted\n    aspects {\n      width\n      comfort\n      size\n    }\n    helpfulVotes\n    preview\n    terms\n    notification\n  }\n}\n    "
    ]);
    _templateObject143 = function _templateObject143() {
        return data;
    };
    return data;
}
function _templateObject144() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation TrackAppLinkClick($link: String!) {\n  trackUserEvent(input: {event: ON_APP_LINK_CLICK, payload: {link: $link}})\n}\n    "
    ]);
    _templateObject144 = function _templateObject144() {
        return data;
    };
    return data;
}
function _templateObject145() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation TrackLanguageChange($language: String!) {\n  trackUserEvent(\n    input: {event: ON_LANGUAGE_CHANGE, payload: {language: $language}}\n  )\n}\n    "
    ]);
    _templateObject145 = function _templateObject145() {
        return data;
    };
    return data;
}
function _templateObject146() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation TrackLiveChatStart($email: String, $firstName: String, $lastName: String) {\n  trackUserEvent(\n    input: {event: ON_LIVE_CHAT_START, payload: {email: $email, firstName: $firstName, lastName: $lastName}}\n  )\n}\n    "
    ]);
    _templateObject146 = function _templateObject146() {
        return data;
    };
    return data;
}
function _templateObject147() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation TrackOrderConfirmation($cartProducts: [UserEventTrackingCartProduct!]!, $email: String, $orderNo: String!) {\n  trackUserEvent(\n    input: {event: ON_ORDER_CONFIRMATION, payload: {cartProducts: $cartProducts, email: $email, orderNo: $orderNo}}\n  )\n}\n    "
    ]);
    _templateObject147 = function _templateObject147() {
        return data;
    };
    return data;
}
function _templateObject148() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation TrackRecommendationClick($masterId: String!, $swatch: String!, $recommenderId: String!, $recommenderName: String!) {\n  trackUserEvent(\n    input: {event: ON_RECOMMENDATION_CLICK, payload: {masterId: $masterId, swatch: $swatch, recommenderId: $recommenderId, recommenderName: $recommenderName}}\n  )\n}\n    "
    ]);
    _templateObject148 = function _templateObject148() {
        return data;
    };
    return data;
}
function _templateObject149() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation TrackProductView($masterId: String!) {\n  trackUserEvent(input: {event: ON_PRODUCT_VIEW, payload: {masterId: $masterId}})\n}\n    "
    ]);
    _templateObject149 = function _templateObject149() {
        return data;
    };
    return data;
}
function _templateObject150() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation AddItemToWishList($input: AddItemToWishListInput!) {\n  addItemToWishList(input: $input) {\n    ...wishListFields\n  }\n}\n    ",
        ""
    ]);
    _templateObject150 = function _templateObject150() {
        return data;
    };
    return data;
}
function _templateObject151() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation UpdateItemInWishList($input: UpdateItemInWishListInput!) {\n  updateItemInWishList(input: $input) {\n    ...wishListFields\n  }\n}\n    ",
        ""
    ]);
    _templateObject151 = function _templateObject151() {
        return data;
    };
    return data;
}
function _templateObject152() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation RemoveItemFromWishList($input: RemoveItemFromWishListInput!) {\n  removeItemFromWishList(input: $input)\n}\n    "
    ]);
    _templateObject152 = function _templateObject152() {
        return data;
    };
    return data;
}
function _templateObject153() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    query Address($id: ID!) {\n  address(id: $id) {\n    ...addressFields\n  }\n}\n    ",
        ""
    ]);
    _templateObject153 = function _templateObject153() {
        return data;
    };
    return data;
}
function _templateObject154() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    query AfterPayConfig {\n  afterPayConfig {\n    min\n    max\n  }\n}\n    "
    ]);
    _templateObject154 = function _templateObject154() {
        return data;
    };
    return data;
}
function _templateObject155() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    query AllCustomerGroups {\n  allCustomerGroups\n}\n    "
    ]);
    _templateObject155 = function _templateObject155() {
        return data;
    };
    return data;
}
function _templateObject156() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    query CheckAmbassadorCardBalance($paymentInstrumentId: String, $cardNumber: String, $pin: String!) {\n  checkAmbassadorBalance(\n    paymentInstrumentId: $paymentInstrumentId\n    cardNumber: $cardNumber\n    pin: $pin\n  )\n}\n    "
    ]);
    _templateObject156 = function _templateObject156() {
        return data;
    };
    return data;
}
function _templateObject157() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    query Cart {\n  activeCart {\n    ...cartFields\n    availablePaymentMethods {\n      ...availablePaymentMethodsFields\n    }\n    isMixedCartAllowed\n  }\n}\n    ",
        "\n",
        ""
    ]);
    _templateObject157 = function _templateObject157() {
        return data;
    };
    return data;
}
function _templateObject158() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    query SimpleCart {\n  activeCart {\n    id\n    productCount\n    isMixedCartAllowed\n    basketInStockStatus\n    estimatedTotal\n    subTotal\n    products {\n      ...productCartItemFields\n    }\n    customer {\n      email\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject158 = function _templateObject158() {
        return data;
    };
    return data;
}
function _templateObject159() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    query CategoryById($id: String!) {\n  categoryById(id: $id) {\n    ...category\n    parentCategory {\n      ...category\n      parentCategory {\n        ...category\n        parentCategory {\n          ...category\n          parentCategory {\n            ...category\n          }\n        }\n      }\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject159 = function _templateObject159() {
        return data;
    };
    return data;
}
function _templateObject160() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    query CategorySizeChart($id: String!) {\n  categoryById(id: $id) {\n    id\n    sizeCharts {\n      id\n      name\n      body\n    }\n  }\n}\n    "
    ]);
    _templateObject160 = function _templateObject160() {
        return data;
    };
    return data;
}
function _templateObject161() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    query MainFooterMinimal($isDraft: String) {\n  mainFooter(isDraft: $isDraft) {\n    id\n    minimalLinks {\n      ...ctaFields\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject161 = function _templateObject161() {
        return data;
    };
    return data;
}
function _templateObject162() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    query MainFooter($isDraft: String) {\n  mainFooter(isDraft: $isDraft) {\n    id\n    supportLinks {\n      ...ctaFields\n    }\n    aboutLinks {\n      ...ctaFields\n    }\n    legalLinks {\n      ...ctaFields\n    }\n    signUpForm {\n      ...signUpFormFields\n    }\n    signUpForms {\n      ...signUpFormFields\n    }\n  }\n}\n    ",
        "\n",
        ""
    ]);
    _templateObject162 = function _templateObject162() {
        return data;
    };
    return data;
}
function _templateObject163() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    query FrontendConfiguration {\n  frontendConfiguration {\n    featureFlags {\n      afterPayEnabled\n      applePayEnabled\n      googlePayEnabled\n      giftCardEnabled\n      amazonPayEnabled\n      payPayEnabled\n      googleAddressLookupEnabled\n      klarnaEnabled\n      googleReversePostalCodeLookup\n      myCustomizerEnabled\n      nestedOrdersEnabled\n      payPalEnabled\n      pincodeServiceabilityEnabled\n      ratingsAndReviewsEnabled\n      addressResumeInCheckoutEnabled\n      simplifiedAddressResumeInCheckoutEnabled\n      useSavedCardsEnabled\n      myAccountOrderDetailsContactInfoEnabled\n      myAccountOrderDetailsBillingInfoEnabled\n      additionalPriceTextForSaleEnabled\n      returnOrderEnabled\n      myAccountEditPasswordShowAdditionalCancelButtonEnabled\n      myAccountEditPasswordUseLabelInsteadOfPlaceholderEnabled\n      myAccountDashboardMembershipSectionEnabled\n      createAccountInCheckoutEnabled\n      showUserRegistrationOnCheckoutEnabled\n      saveAddressCheckboxEnabled\n      cartSummaryPromoCodeExpandedOnMobile\n      myAccountLeaveResetPasswordConfirmPopupOpenEnabled\n      showSaleBadgeOnProductImageEnabled\n      desiredDeliveryDateEnabled\n      autoShowNewsletterPopupEnabled\n      showProductKeywordsEnabled\n      scShowCartAbandonmentModalEnabled\n      miniCartSeparateViewAndCheckoutButtons\n      otpLoginEnabled\n      registerOTPVerificationEnabled\n      phoneInProfileEnabled\n      myAccountShowAdditionalFieldsInEditEnabled\n      priceWithDataEnabled\n      showOnlyOrderableSizesEnabled\n      myAccountHideNotificationSettingsInDashboard\n      myAccountHideNewsletterSettingsInDashboard\n      collapsableOrderDetailsIsCollapsedOnLoad\n      simplifiedGoogleShoppingPdpEnabled\n      showDynamicTaxMessage\n      hideYourSavings\n      paymentPromotionEnabled\n      showDiscountAmountAndTextEnabled\n      promoCodeAccordionIsExpandedByDefault\n      opluxEnabled\n      outfitsEnabled\n      storeCreditsEnabled\n    }\n    environment {\n      webInMaintenanceMode\n      abTestingScript\n      adyenClientKey\n      adyenEnv\n      adyenPayPalIntent\n      adyenPayPalMerchantId\n      adyenStatusUrl\n      afterpaySDKSource\n      bazaarVoiceReviewFormScriptUrl\n      bazaarVoiceReviewFormScriptUrl\n      bloomreachAccountId\n      bloomreachSEOAccountId\n      branchKey\n      configureIdApiKey\n      configureIdScriptUrl\n      fitAnalyticsOrderConfirmationUrl\n      fitAnalyticsPdpUrl\n      googleApiKey\n      googleOptimizeContainerId\n      googleTagManagerId\n      freshChatToken\n      freshChatHost\n      idMeClientId\n      klarnaDataClientId\n      klarnaScriptUrl\n      myCustomizerDomain\n      myCustomizerShopId\n      pixleeApiKey\n      radialFingerprint\n      radialStoreId\n      returnUrl\n      sanityDataset\n      sanitySiteId\n      sanityProjectId\n      storeRocketId\n      styliticsUsername\n      forterSiteId\n      gmoShopId\n      gmoSource\n      emarsysSignupURL\n      emplifiTurnToSite\n      dataGuardTemplateId\n      payPayReloadCount\n      payPayRetryWaitingTime\n      amazonPayMerchantId\n      amazonPayClientId\n      amazonPayScope\n      amazonPayMode\n      amazonPayButtonSize\n      amazonPayButtonColor\n      amazonPayPublicKeyId\n      amazonPayStoreId\n      oneTrustApiKey\n      googlePayEnvironment\n      googlePayPaymentGateway\n      googlePayPaymentGatewayMerchantId\n      googlePayMerchantId\n      googlePayMerchantName\n      sanitySiteId\n      razorPaySdkKey\n      yottaaScriptUrl\n    }\n    siteConfig {\n      freeShippingThreshold\n      maxDaysForReturn\n      scheduledFreeShippingThresholds {\n        availableFrom\n        availableTo\n        threshold\n      }\n      deliveryDateDays {\n        endDeliveryDateDay\n        startDeliveryDateDay\n      }\n    }\n  }\n}\n    "
    ]);
    _templateObject163 = function _templateObject163() {
        return data;
    };
    return data;
}
function _templateObject164() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    query CheckGiftCardBalance($cardNumber: String!, $pin: String!, $countryCode: String) {\n  checkGiftCardBalance(\n    cardNumber: $cardNumber\n    pin: $pin\n    countryCode: $countryCode\n  )\n}\n    "
    ]);
    _templateObject164 = function _templateObject164() {
        return data;
    };
    return data;
}
function _templateObject165() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    query GiftCard {\n  giftCard {\n    id\n    name\n    valueOptions\n    defaultValue\n    image\n  }\n}\n    "
    ]);
    _templateObject165 = function _templateObject165() {
        return data;
    };
    return data;
}
function _templateObject166() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    query GlossaryPage($slug: String!) {\n  glossaryPage(slug: $slug) {\n    categories {\n      label\n      value\n    }\n    headerBackgroundImage {\n      ...sanityImageFields\n    }\n    headerIntroduction\n    id\n    puid\n    seo {\n      pageDescription\n      pageTitle\n    }\n    terms {\n      categories\n      definition\n      id\n      puid\n      image {\n        ...sanityImageFields\n      }\n      mediaType\n      term\n      video {\n        ...sanityVideoFields\n      }\n    }\n    title\n    url\n  }\n}\n    ",
        "\n",
        ""
    ]);
    _templateObject166 = function _templateObject166() {
        return data;
    };
    return data;
}
function _templateObject167() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    query Inventory($id: ID!) {\n  inventory(id: $id) {\n    id\n    quantity\n    limitedAvailability\n  }\n}\n    "
    ]);
    _templateObject167 = function _templateObject167() {
        return data;
    };
    return data;
}
function _templateObject168() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    query WishListTotals {\n  wishList {\n    id\n    items {\n      id\n      quantity\n    }\n  }\n}\n    "
    ]);
    _templateObject168 = function _templateObject168() {
        return data;
    };
    return data;
}
function _templateObject169() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    query Me($includeAddresses: Boolean = false, $includeOrders: Boolean = false, $includeAmbassadorCards: Boolean = false, $includeSavedCards: Boolean = false, $includeGroups: Boolean = false, $includeNewsletter: Boolean = false, $includeStoreCredit: Boolean = false) {\n  me {\n    ...userFields\n    newsletterSubscription @include(if: $includeNewsletter) {\n      firstName\n      lastName\n      firstNamePronunciation\n      lastNamePronunciation\n      email\n      gender\n      memberId\n      dob {\n        day\n        month\n        year\n      }\n      emailPreference\n      shoppingPreference\n      iframeURL\n      isConfirmed\n    }\n    addresses @include(if: $includeAddresses) {\n      ...addressFields\n    }\n    orders(limit: 5) @include(if: $includeOrders) {\n      nodes {\n        ...orderPreviewFields\n      }\n    }\n    ambassadorCards @include(if: $includeAmbassadorCards) {\n      ...ambassadorCardFields\n    }\n    savedCards @include(if: $includeSavedCards) {\n      ...savedCreditCard\n    }\n    storeCredit @include(if: $includeStoreCredit) {\n      ...storeCreditFields\n    }\n    groups @include(if: $includeGroups)\n  }\n}\n    ",
        "\n",
        "\n",
        "\n",
        "\n",
        "\n",
        ""
    ]);
    _templateObject169 = function _templateObject169() {
        return data;
    };
    return data;
}
function _templateObject170() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    query NotificationPreferences {\n  notificationsPreferences {\n    phoneNumber\n    marketingSmsOptIn\n    customerSmsOptIn\n  }\n}\n    "
    ]);
    _templateObject170 = function _templateObject170() {
        return data;
    };
    return data;
}
function _templateObject171() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    query Order($orderNo: String!, $includeProductAnalyticsDetails: Boolean = false) {\n  order(orderNo: $orderNo) {\n    ... on StandardOrder {\n      subTotal\n      shippingCosts\n      shippingSurcharge {\n        amount\n        label\n        tooltip\n      }\n      orderAdjustments {\n        promotionId\n        itemText\n        price\n        couponCode\n      }\n      shippingAdjustments {\n        promotionId\n        itemText\n        price\n        couponCode\n      }\n      couponItems {\n        code\n        couponItemId\n        statusCode\n        valid\n      }\n      orderNo\n      taxTotal\n      taxation\n      estimatedTotal\n      promoDiscountValue\n      revenue @include(if: $includeProductAnalyticsDetails)\n      orderStatus {\n        code\n        label\n      }\n      __typename\n      refundInformation\n      createdAt\n      products {\n        ...productCartItemFields\n        ...productCartItemAnalyticsDimensionsFields @include(if: $includeProductAnalyticsDetails)\n      }\n      ...orderPaymentInstrumentFields\n      ...orderConfirmationFields\n      payPayAsyncResultNoticed\n    }\n  }\n}\n    ",
        "\n",
        "\n",
        "\n",
        ""
    ]);
    _templateObject171 = function _templateObject171() {
        return data;
    };
    return data;
}
function _templateObject172() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    query OrderDetails($orderNo: String!) {\n  order(orderNo: $orderNo) {\n    ...standardOrderDetailsFields\n    ...nestedOrderDetailsFields\n  }\n}\n    ",
        "\n",
        ""
    ]);
    _templateObject172 = function _templateObject172() {
        return data;
    };
    return data;
}
function _templateObject173() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    query OrderHistoryMe($from: String, $until: String, $offset: Int, $limit: Int) {\n  me {\n    ...userFields\n    addresses {\n      ...addressFields\n    }\n    orders(from: $from, until: $until, offset: $offset, limit: $limit) {\n      nodes {\n        ...orderPreviewFields\n      }\n      pageInfo {\n        offset\n        nextOffset\n        totalCount\n      }\n    }\n  }\n}\n    ",
        "\n",
        "\n",
        ""
    ]);
    _templateObject173 = function _templateObject173() {
        return data;
    };
    return data;
}
function _templateObject174() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    query SearchOrderByPhone($orderNo: String!, $phone: String!) {\n  searchOrderByPhone(orderNo: $orderNo, phone: $phone) {\n    ...standardOrderDetailsFields\n    ...nestedOrderDetailsFields\n  }\n}\n    ",
        "\n",
        ""
    ]);
    _templateObject174 = function _templateObject174() {
        return data;
    };
    return data;
}
function _templateObject175() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    query SearchOrderByEmailPostcode($orderNo: String!, $email: String!, $postcode: String!) {\n  searchOrderByEmailPostcode(\n    orderNo: $orderNo\n    email: $email\n    postcode: $postcode\n  ) {\n    ...standardOrderDetailsFields\n    ...nestedOrderDetailsFields\n  }\n}\n    ",
        "\n",
        ""
    ]);
    _templateObject175 = function _templateObject175() {
        return data;
    };
    return data;
}
function _templateObject176() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    query SearchOrderByEmail($orderNo: String!, $email: String!) {\n  searchOrderByEmail(orderNo: $orderNo, email: $email) {\n    ...standardOrderDetailsFields\n    ...nestedOrderDetailsFields\n  }\n}\n    ",
        "\n",
        ""
    ]);
    _templateObject176 = function _templateObject176() {
        return data;
    };
    return data;
}
function _templateObject177() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    query SearchOrderByEmailPhone($orderNo: String!, $phone: String!, $email: String!) {\n  searchOrderByEmailPhone(orderNo: $orderNo, phone: $phone, email: $email) {\n    ...standardOrderDetailsFields\n    ...nestedOrderDetailsFields\n  }\n}\n    ",
        "\n",
        ""
    ]);
    _templateObject177 = function _templateObject177() {
        return data;
    };
    return data;
}
function _templateObject178() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    query Outfits($tags: String!) {\n  outfits(tags: $tags) {\n    id\n    image {\n      href\n      coverImageHref\n      alt\n    }\n    products {\n      ...product\n      coords {\n        x\n        y\n        z\n        height\n        width\n      }\n      replacements {\n        ...product\n      }\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject178 = function _templateObject178() {
        return data;
    };
    return data;
}
function _templateObject179() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    query getAmazonPayCustomerInfo($amazonPayToken: String!) {\n  getAmazonPayCustomerInfo(amazonPayToken: $amazonPayToken) {\n    userEmail\n    registeredWithAmazon\n  }\n}\n    "
    ]);
    _templateObject179 = function _templateObject179() {
        return data;
    };
    return data;
}
function _templateObject180() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    query getPayPayContent($assetId: String!) {\n  getPayPayContent(assetId: $assetId) {\n    id\n    name\n    body\n  }\n}\n    "
    ]);
    _templateObject180 = function _templateObject180() {
        return data;
    };
    return data;
}
function _templateObject181() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    query Pincode($pincode: String!) {\n  pincode(pincode: $pincode) {\n    expectedDate\n    city\n    stateCode\n  }\n}\n    "
    ]);
    _templateObject181 = function _templateObject181() {
        return data;
    };
    return data;
}
function _templateObject182() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    query PixleeConfig {\n  pixleeConfig {\n    id\n    enable\n    enablePDPGallery\n    socialMediaIcon\n    numberPicturesGallery\n  }\n}\n    "
    ]);
    _templateObject182 = function _templateObject182() {
        return data;
    };
    return data;
}
function _templateObject183() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    query UserGeneratedContent($productId: ID!) {\n  userGeneratedContentForWeb(productId: $productId) {\n    source\n    pixleeCdnPhotos {\n      squareMediumUrl\n    }\n    altText\n  }\n}\n    "
    ]);
    _templateObject183 = function _templateObject183() {
        return data;
    };
    return data;
}
function _templateObject184() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    query CategoryPLP($url: String!, $isDraft: String, $sort: String, $filters: [FilterInputOption!]!, $expansions: [ProductSearchExpansion!], $includeCategoryMetadata: Boolean = true, $offset: Int!, $limit: Int!, $preview: PreviewInput) {\n  categoryByUrl(url: $url, preview: $preview) {\n    id\n    name\n    url\n    disableRatings\n    ...category @include(if: $includeCategoryMetadata)\n    description @include(if: $includeCategoryMetadata)\n    products(\n      input: {sort: $sort, filters: $filters, limit: $limit, offset: $offset, expansions: $expansions, includeCategoryMetadata: $includeCategoryMetadata, isDraft: $isDraft}\n    ) {\n      ...PaginatedOutputNodesFragment\n      ...PaginatedOutputMetadataFragment @include(if: $includeCategoryMetadata)\n    }\n    seo @include(if: $includeCategoryMetadata) {\n      pageTitle\n      pageDescription\n    }\n    parentCategory {\n      ...category\n      parentCategory {\n        ...category\n        parentCategory {\n          ...category\n          parentCategory {\n            ...category\n          }\n        }\n      }\n    }\n  }\n}\n    ",
        "\n",
        "\n",
        ""
    ]);
    _templateObject184 = function _templateObject184() {
        return data;
    };
    return data;
}
function _templateObject185() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    query Variants($input: VariantsInput!, $includeComparisonFields: Boolean = false) {\n  variants(input: $input) {\n    __typename\n    id\n    masterId\n    productPrice {\n      price\n      salePrice\n      promotionPrice\n      isSalePriceElapsed\n      tax\n      taxRate\n      bestPrice\n    }\n    ean\n    percentageDiscountBadge\n    name\n    variantId\n    header\n    subHeader\n    orderable\n    colorValue\n    colorName\n    displayOutOfStock {\n      displayValue\n    }\n    images {\n      href\n      alt\n    }\n    technology @include(if: $includeComparisonFields)\n    runTerrain @include(if: $includeComparisonFields)\n    weight @include(if: $includeComparisonFields)\n    heelToToeDrop @include(if: $includeComparisonFields)\n    fastener @include(if: $includeComparisonFields)\n    pronation @include(if: $includeComparisonFields)\n    refinementCushioningLevel @include(if: $includeComparisonFields)\n    runnerType @include(if: $includeComparisonFields)\n    mainMaterial @include(if: $includeComparisonFields)\n    cupType @include(if: $includeComparisonFields)\n    trouserRise @include(if: $includeComparisonFields)\n    pocketType @include(if: $includeComparisonFields)\n    apparelLength @include(if: $includeComparisonFields)\n    characteristics @include(if: $includeComparisonFields)\n    supportLevelBra @include(if: $includeComparisonFields)\n    studs @include(if: $includeComparisonFields)\n    playerLevel @include(if: $includeComparisonFields)\n    fit @include(if: $includeComparisonFields)\n  }\n}\n    "
    ]);
    _templateObject185 = function _templateObject185() {
        return data;
    };
    return data;
}
function _templateObject186() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    query SiblingVariants($input: SiblingVariantsInput!) {\n  siblingVariants(input: $input) {\n    ...mandatoryVariantFields\n    badges {\n      id\n      label\n    }\n    percentageDiscountBadge\n    salePrice\n    productPrice {\n      price\n      salePrice\n      promotionPrice\n      isSalePriceElapsed\n      tax\n      taxRate\n      bestPrice\n    }\n    displayOutOfStock {\n      soldout\n      soldoutWithRecommender\n      comingsoon\n      backsoon\n      presale\n      displayValue\n    }\n    orderable\n    promotions(page: ProductListingPage) {\n      id\n      calloutMessage\n    }\n    isAppExclusive\n    appOnlyDateTimeFrom\n    appOnlyDateTimeTo\n  }\n}\n    ",
        ""
    ]);
    _templateObject186 = function _templateObject186() {
        return data;
    };
    return data;
}
function _templateObject187() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    query Variant($id: ID!) {\n  variant(id: $id) {\n    id\n    masterId\n    name\n    colorValue\n    styleNumber\n    size {\n      value\n    }\n  }\n}\n    "
    ]);
    _templateObject187 = function _templateObject187() {
        return data;
    };
    return data;
}
function _templateObject188() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    query Product($id: ID!) {\n  product(id: $id) {\n    id\n    name\n    header\n    subHeader\n    orderable\n    displayOutOfStock {\n      displayValue\n    }\n    variations {\n      id\n      name\n      colorValue\n      colorName\n      preview\n      price\n      salePrice\n      productPrice {\n        price\n        salePrice\n        promotionPrice\n      }\n      orderable\n      sizeGroups {\n        label\n        description\n        sizes {\n          id\n          label\n          value\n          productId\n          orderable\n          maxOrderableQuantity\n        }\n      }\n      displayOutOfStock {\n        soldout\n        soldoutWithRecommender\n        comingsoon\n        backsoon\n        presale\n        displayValue\n        validTo\n      }\n      images {\n        href\n        alt\n      }\n    }\n  }\n}\n    "
    ]);
    _templateObject188 = function _templateObject188() {
        return data;
    };
    return data;
}
function _templateObject189() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    query PDP($id: ID!, $viewAt: String) {\n  product(id: $id) {\n    ...mandatoryMasterFields\n    productNameTranslated\n    description\n    primaryCategoryId\n    productDivision\n    brand\n    disableRatings\n    disableReviews\n    amountOfReviews\n    averageRating\n    sizeChartId\n    promotions(page: ProductDetailsPage) {\n      id\n      calloutMessage\n    }\n    configureID {\n      enabled\n      productID\n    }\n    productVideos\n    verticalProductVideos\n    promotionExclusion\n    exploreMoreCTALabel\n    showExploreCollectionCTA\n    exploreMoreCTATargetCategoryID\n    brand\n    orderable\n    fitOptions {\n      label\n      masterProduct {\n        id\n        name\n        variations {\n          id\n          colorValue\n          orderable\n        }\n      }\n    }\n    variations {\n      ...pdpMandatoryVariantFields\n      isFinalSale\n      returnRuleID\n      promotionExclusion\n      specialMessage(viewAt: $viewAt)\n      ean\n      validUntil\n      isAppExclusive\n      badges {\n        id\n        label\n      }\n      percentageDiscountBadge\n      salePrice\n      productPrice {\n        price\n        salePrice\n        promotionPrice\n        isSalePriceElapsed\n        tax\n        taxRate\n        bestPrice\n      }\n      styleNumber\n      materialComposition\n      displayOutOfStock {\n        soldout\n        soldoutWithRecommender\n        comingsoon\n        backsoon\n        presale\n        displayValue\n        validTo\n      }\n      orderable\n      modelMeasurementText\n      manufacturerInfo {\n        manufacturerAddress {\n          label\n          content\n        }\n        countryOfOrigin {\n          label\n          content\n        }\n      }\n      myCustomizer {\n        enabled\n        iframeID\n        startPoint\n      }\n      configureID {\n        enabled\n        productID\n      }\n      taxDisplayMsg\n      promotions(page: ProductDetailsPage) {\n        id\n        calloutMessage\n      }\n      appOnlyDateTimeFrom\n      appOnlyDateTimeTo\n    }\n  }\n}\n    ",
        "\n",
        ""
    ]);
    _templateObject189 = function _templateObject189() {
        return data;
    };
    return data;
}
function _templateObject190() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    query LazyPDP($id: ID!) {\n  product(id: $id) {\n    id\n    ...sizes\n    variations {\n      ...pdpMandatoryExtraVariantFields\n      description\n      productStory {\n        longDescription\n        materialComposition\n        careInstructions\n        manufacturerInfo {\n          manufacturerAddress {\n            label\n            content\n          }\n          countryOfOrigin {\n            label\n            content\n          }\n        }\n        productKeywords\n      }\n    }\n  }\n}\n    ",
        "\n",
        ""
    ]);
    _templateObject190 = function _templateObject190() {
        return data;
    };
    return data;
}
function _templateObject191() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    query ProductSizeChart($id: [ID!]!) {\n  sizeCharts(ids: $id) {\n    id\n    name\n    body\n  }\n}\n    "
    ]);
    _templateObject191 = function _templateObject191() {
        return data;
    };
    return data;
}
function _templateObject192() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n    query ProductScore($id: ID!, $offset: Int = 0, $limit: Int = 5, $sort: String = "newest", $search: String = "", $includeReviews: Boolean! = true) {\n  productScore(id: $id) {\n    id\n    amount\n    rating\n    reviews(offset: $offset, limit: $limit, sort: $sort, search: $search) @include(if: $includeReviews) {\n      nodes {\n        id\n        rating\n        title\n        text\n        nickname\n        date\n      }\n    }\n  }\n}\n    '
    ]);
    _templateObject192 = function _templateObject192() {
        return data;
    };
    return data;
}
function _templateObject193() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    query RecommendationsWithDetails($pageType: String!, $ids: [ID!]) {\n  recommendationsWithDetails(pageType: $pageType, ids: $ids) {\n    recommenderId\n    recommenderName\n    recommendations {\n      ...recommendationFields\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject193 = function _templateObject193() {
        return data;
    };
    return data;
}
function _templateObject194() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    query ProductReviews($id: ID!, $offset: Int, $limit: Int, $sort: String, $search: String) {\n  productScore(id: $id) {\n    id\n    amount\n    rating\n    reviews(offset: $offset, limit: $limit, sort: $sort, search: $search) {\n      nodes {\n        ...ReviewFields\n      }\n      pageInfo {\n        totalCount\n      }\n    }\n    summary {\n      ...ReviewSummaryFields\n    }\n  }\n}\n    ",
        "\n",
        ""
    ]);
    _templateObject194 = function _templateObject194() {
        return data;
    };
    return data;
}
function _templateObject195() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    query TrendingSearchTerms {\n  trendingSearchTerms {\n    searchTerm\n    rank\n  }\n}\n    "
    ]);
    _templateObject195 = function _templateObject195() {
        return data;
    };
    return data;
}
function _templateObject196() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    query SearchRecommendedProducts {\n  searchFlyoutRecommendedProducts {\n    __typename\n    id\n    variantProduct {\n      id\n      masterId\n      colorValue\n      name\n      header\n      subHeader\n      productPrice {\n        price\n        salePrice\n      }\n      images {\n        alt\n        href\n      }\n    }\n  }\n}\n    "
    ]);
    _templateObject196 = function _templateObject196() {
        return data;
    };
    return data;
}
function _templateObject197() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    query ProductSearch($q: String, $sort: String, $filters: [FilterInputOption!]!, $expansions: [ProductSearchExpansion!], $includeSearchMetadata: Boolean = true, $offset: Int!, $limit: Int!) {\n  search(\n    input: {q: $q, sort: $sort, filters: $filters, limit: $limit, offset: $offset, expansions: $expansions, includeSearchMetadata: $includeSearchMetadata}\n  ) {\n    __typename\n    ...PaginatedOutputNodesFragment\n    ...PaginatedOutputMetadataFragment @include(if: $includeSearchMetadata)\n  }\n}\n    ",
        "\n",
        ""
    ]);
    _templateObject197 = function _templateObject197() {
        return data;
    };
    return data;
}
function _templateObject198() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    query Look($id: ID!) {\n  look(id: $id) {\n    id\n    products {\n      ...product\n      coords {\n        x\n        y\n        z\n        height\n        width\n      }\n      replacements {\n        ...product\n      }\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject198 = function _templateObject198() {
        return data;
    };
    return data;
}
function _templateObject199() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    query Suggestions($searchTerm: String!, $preview: PreviewInput) {\n  suggestions(searchTerm: $searchTerm, preview: $preview) {\n    suggestedProductsSummaries {\n      id\n      masterId\n      colorValue\n      name\n      header\n      subHeader\n      images {\n        href\n        alt\n      }\n      price\n      salePrice\n      isSalePriceElapsed\n    }\n    suggestedTerms {\n      suggestion\n      original\n    }\n    suggestedPhrases {\n      suggestion\n    }\n    suggestedRedirect\n  }\n}\n    "
    ]);
    _templateObject199 = function _templateObject199() {
        return data;
    };
    return data;
}
function _templateObject200() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    query TermsAndConditionsConfigs($isDraft: String) {\n  termsAndConditionsConfigs(isDraft: $isDraft) {\n    id\n    tacOnCartPage {\n      ...termsAndConditionsFields\n    }\n    tacOnItemAddedPopup {\n      ...termsAndConditionsFields\n    }\n    tacOnCheckoutSignInArea {\n      ...termsAndConditionsFields\n    }\n    tacOnCheckoutConfirmation {\n      ...termsAndConditionsFields\n    }\n    tacOnCheckoutAddress {\n      ...termsAndConditionsFields\n    }\n    tacOnCreateAccount {\n      ...termsAndConditionsFields\n    }\n    tacOnCheckoutPayment {\n      ...termsAndConditionsFields\n    }\n    showAbove\n  }\n}\n    ",
        ""
    ]);
    _templateObject200 = function _templateObject200() {
        return data;
    };
    return data;
}
function _templateObject201() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    query UrlRedirect($path: String!) {\n  urlRedirectV2(path: $path) {\n    availableFrom\n    availableTo\n    redirectType\n    url\n  }\n}\n    "
    ]);
    _templateObject201 = function _templateObject201() {
        return data;
    };
    return data;
}
function _templateObject202() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    query WishList {\n  wishList {\n    ...wishListFields\n  }\n}\n    ",
        ""
    ]);
    _templateObject202 = function _templateObject202() {
        return data;
    };
    return data;
}



var AdyenPaymentMethod = {
    Afterpay: "AFTERPAY",
    Alipay: "ALIPAY",
    ApplePay: "APPLE_PAY",
    BilldeskOnline: "BILLDESK_ONLINE",
    BilldeskUpi: "BILLDESK_UPI",
    BilldeskWallet: "BILLDESK_WALLET",
    GooglePay: "GOOGLE_PAY",
    Klarna: "KLARNA",
    KlarnaAccount: "KLARNA_ACCOUNT",
    OnlinebankingIn: "ONLINEBANKING_IN",
    Paypal: "PAYPAL",
    PayTm: "PAY_TM",
    Scheme: "SCHEME",
    UpiCollect: "UPI_COLLECT",
    WechatPay: "WECHAT_PAY",
    ZipPay: "ZIP_PAY"
};
var AdyenPaymentMethodSubType = {
    Redirect: "REDIRECT",
    Sdk: "SDK"
};
var AdyenResultCodeEnum = {
    AuthenticationFinished: "AuthenticationFinished",
    Authorised: "Authorised",
    Cancelled: "Cancelled",
    ChallengeShopper: "ChallengeShopper",
    Error: "Error",
    IdentifyShopper: "IdentifyShopper",
    Pending: "Pending",
    PresentToShopper: "PresentToShopper",
    Received: "Received",
    RedirectShopper: "RedirectShopper",
    Refused: "Refused",
    Success: "Success"
};
var AuthorityToLeaveOptions = {
    LeaveAtFrontDoor: "LEAVE_AT_FRONT_DOOR",
    LeaveAtOther: "LEAVE_AT_OTHER",
    LeaveAtReception: "LEAVE_AT_RECEPTION",
    LeaveInSafePlace: "LEAVE_IN_SAFE_PLACE",
    TakeToPostOffice: "TAKE_TO_POST_OFFICE"
};
var ConfirmUpdatePhoneCode = {
    CustomerNotFound: "CUSTOMER_NOT_FOUND",
    EncryptedPasswordEmpty: "ENCRYPTED_PASSWORD_EMPTY",
    MoreThanOneCustomer: "MORE_THAN_ONE_CUSTOMER",
    NoMorePinAttempts: "NO_MORE_PIN_ATTEMPTS",
    Ok: "OK"
};
var GenericTextSize = {
    Large: "large",
    Medium: "medium",
    Small: "small"
};
var GraphQlError = {
    AddressIdAlreadyInUse: "ADDRESS_ID_ALREADY_IN_USE",
    AfterpayMax: "AFTERPAY_MAX",
    AfterpayMin: "AFTERPAY_MIN",
    BadUserInput: "BAD_USER_INPUT",
    CheetahResponseError: "CHEETAH_RESPONSE_ERROR",
    ConflictingPaymentMethods: "CONFLICTING_PAYMENT_METHODS",
    CountryError: "COUNTRY_ERROR",
    CurrentPasswordNotValid: "CURRENT_PASSWORD_NOT_VALID",
    DefaultError: "DEFAULT_ERROR",
    InsufficientFunds: "INSUFFICIENT_FUNDS",
    InternalServerError: "INTERNAL_SERVER_ERROR",
    InvalidCreditCard: "INVALID_CREDIT_CARD",
    InvalidGiftCard: "INVALID_GIFT_CARD",
    InvalidOrder: "INVALID_ORDER",
    LoginAlreadyExists: "LOGIN_ALREADY_EXISTS",
    LongTermPaymentError: "LONG_TERM_PAYMENT_ERROR",
    NotFound: "NOT_FOUND",
    NoGiftcards: "NO_GIFTCARDS",
    NumberExists: "NUMBER_EXISTS",
    OpluxNg: "OPLUX_NG",
    OtpDefaultError: "OTP_DEFAULT_ERROR",
    OtpLoginDisabled: "OTP_LOGIN_DISABLED",
    RejectedCreditCard: "REJECTED_CREDIT_CARD",
    TtlExpired: "TTL_EXPIRED",
    UnableToOrder: "UNABLE_TO_ORDER",
    UnexpectedApiResponse: "UNEXPECTED_API_RESPONSE",
    WrongPin: "WRONG_PIN"
};
var HorizontalAlignment = {
    Center: "center",
    Left: "left",
    Right: "right"
};
var KlarnaPaymentMethod = {
    Klarna: "KLARNA",
    KlarnaAccount: "KLARNA_ACCOUNT"
};
var KlarnaPaymentMethodSubType = {
    Redirect: "REDIRECT",
    Sdk: "SDK"
};
var KlarnaResultCodeEnum = {
    CheckoutIncomplete: "CHECKOUT_INCOMPLETE"
};
var LayoutDirection = {
    Left: "left",
    Right: "right"
};
var LinkVariant = {
    Black: "black",
    Primary: "primary",
    Secondary: "secondary",
    White: "white"
};
var OrderStatusCode = {
    BeingProcessed: "BEING_PROCESSED",
    Cancelled: "CANCELLED",
    Completed: "COMPLETED",
    CompletelyReturned: "COMPLETELY_RETURNED",
    Created: "CREATED",
    Delivered: "DELIVERED",
    Failed: "FAILED",
    New: "NEW",
    Open: "OPEN",
    OutForDelivery: "OUT_FOR_DELIVERY",
    Packed: "PACKED",
    PartiallyCancelled: "PARTIALLY_CANCELLED",
    PartiallyDelivered: "PARTIALLY_DELIVERED",
    PartiallyReturned: "PARTIALLY_RETURNED",
    PartiallyShipped: "PARTIALLY_SHIPPED",
    Replaced: "REPLACED",
    Returned: "RETURNED",
    Shipped: "SHIPPED"
};
var ProductPromotionsPageType = {
    ProductDetailsPage: "ProductDetailsPage",
    ProductListingPage: "ProductListingPage"
};
var ProductSearchExpansion = {
    AllColors: "ALL_COLORS",
    AllVariantExtendedData: "ALL_VARIANT_EXTENDED_DATA",
    AllVariantImages: "ALL_VARIANT_IMAGES",
    Availability: "AVAILABILITY",
    MasterProductExtendedData: "MASTER_PRODUCT_EXTENDED_DATA",
    Price: "PRICE",
    QuickColors: "QUICK_COLORS",
    VariantExtendedData: "VARIANT_EXTENDED_DATA",
    VariantImages: "VARIANT_IMAGES",
    VariationModel: "VARIATION_MODEL"
};
var SupportPageContentAvailableOn = {
    MobileApp: "mobileApp",
    Web: "web"
};
var SupportedPaymentMethod = {
    Adyen: "ADYEN",
    AdyenComponent: "ADYEN_COMPONENT",
    AdyenPaypal: "ADYEN_PAYPAL",
    Afterpay: "AFTERPAY",
    AfterpayTouch: "AFTERPAY_TOUCH",
    Alipay: "ALIPAY",
    AmazonPay: "AMAZON_PAY",
    AmazonPayV2: "AMAZON_PAY_V2",
    AmbassadorCard: "AMBASSADOR_CARD",
    ApplePay: "APPLE_PAY",
    Cod: "COD",
    CreditCard: "CREDIT_CARD",
    CreditCardConfirm: "CREDIT_CARD_CONFIRM",
    GiftCard: "GIFT_CARD",
    GooglePay: "GOOGLE_PAY",
    Klarna: "KLARNA",
    KlarnaAccount: "KLARNA_ACCOUNT",
    KlarnaPayments: "KLARNA_PAYMENTS",
    OnlineBanking: "ONLINE_BANKING",
    OnlineBankingIn: "ONLINE_BANKING_IN",
    Paypal: "PAYPAL",
    Paytm: "PAYTM",
    PayPay: "PAY_PAY",
    Razorpay: "RAZORPAY",
    Scheme: "SCHEME",
    StoreCredit: "STORE_CREDIT",
    Upi: "UPI",
    UpiCollect: "UPI_COLLECT",
    Wallet: "WALLET",
    WechatPay: "WECHAT_PAY",
    ZipPay: "ZIP_PAY"
};
var Taxation = {
    Gross: "gross",
    Net: "net"
};
var TextAlignment = {
    Center: "center",
    Left: "left",
    Right: "right"
};
var ThreeDsMethod = {
    Get: "GET",
    Post: "POST"
};
var UpdatePhoneCode = {
    Ok: "OK",
    PhoneAlreadyInUse: "PHONE_ALREADY_IN_USE",
    VerificationRequired: "VERIFICATION_REQUIRED"
};
var Upgrade = {
    Mandatory: "MANDATORY",
    Suggested: "SUGGESTED"
};
var UserEvent = {
    OnAppLinkClick: "ON_APP_LINK_CLICK",
    OnLanguageChange: "ON_LANGUAGE_CHANGE",
    OnLiveChatStart: "ON_LIVE_CHAT_START",
    OnOrderConfirmation: "ON_ORDER_CONFIRMATION",
    OnProductView: "ON_PRODUCT_VIEW",
    OnRecommendationClick: "ON_RECOMMENDATION_CLICK"
};
var VerifyLoginWithOtpCode = {
    CustomerNotFound: "CUSTOMER_NOT_FOUND",
    EncryptedPasswordEmpty: "ENCRYPTED_PASSWORD_EMPTY",
    MoreThanOneCustomer: "MORE_THAN_ONE_CUSTOMER",
    NoMorePinAttempts: "NO_MORE_PIN_ATTEMPTS",
    Ok: "OK"
};
var VerticalAlignment = {
    Bottom: "bottom",
    Middle: "middle",
    Top: "top"
};
var TokenPayloadFragmentDoc = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject());
var AddressFieldsFragmentDoc = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject1());
var AmbassadorCardFieldsFragmentDoc = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject2());
var AuthPayloadFragmentDoc = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject3());
var ProductCartSimpleItemFieldsFragmentDoc = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject4());
var ProductAnalyticsDimensionsFieldsFragmentDoc = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject5());
var ProductCartItemAnalyticsDimensionsFieldsFragmentDoc = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject6(), ProductAnalyticsDimensionsFieldsFragmentDoc);
var ProductCartItemFieldsFragmentDoc = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject7());
var GiftWithPurchaseFieldsFragmentDoc = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject8());
var AmbassadorCardPaymentFieldsFragmentDoc = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject9());
var CartPaymentInstrumentsFieldsFragmentDoc = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject10(), AmbassadorCardPaymentFieldsFragmentDoc);
var CustomerFieldsFragmentDoc = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject11());
var CartCostsFieldsFragmentDoc = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject12());
var CartPromoFieldsFragmentDoc = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject13());
var BillingAddressFieldsFragmentDoc = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject14());
var ShipmentFieldsFragmentDoc = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject15());
var ShipmentMethodInfoFieldsFragmentDoc = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject16());
var AvailablePaymentMethodsFieldsFragmentDoc = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject17());
var CartFieldsFragmentDoc = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject18(), ProductCartItemFieldsFragmentDoc, GiftWithPurchaseFieldsFragmentDoc, CartPaymentInstrumentsFieldsFragmentDoc, CustomerFieldsFragmentDoc, CartCostsFieldsFragmentDoc, CartPromoFieldsFragmentDoc, BillingAddressFieldsFragmentDoc, ShipmentFieldsFragmentDoc, ShipmentMethodInfoFieldsFragmentDoc, AvailablePaymentMethodsFieldsFragmentDoc);
var CategoryFragmentDoc = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject19());
var PortableTextFieldsFragmentDoc = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject20());
var CtaFieldsFragmentDoc = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject21());
var ColorInputFieldsFragmentDoc = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject22());
var BackgroundOverlayFieldsFragmentDoc = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject23(), ColorInputFieldsFragmentDoc);
var SanityImageFieldsFragmentDoc = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject24(), BackgroundOverlayFieldsFragmentDoc);
var SignUpFormFieldsFragmentDoc = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject25(), PortableTextFieldsFragmentDoc, CtaFieldsFragmentDoc, SanityImageFieldsFragmentDoc);
var SavedCreditCardFragmentDoc = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject26());
var OrderPaymentInstrumentFieldsFragmentDoc = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject27());
var OrderAddressFragmentDoc = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject28());
var OrderConfirmationFieldsFragmentDoc = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject29(), OrderAddressFragmentDoc);
var NestedOrderDetailsFieldsFragmentDoc = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject30(), OrderPaymentInstrumentFieldsFragmentDoc, OrderConfirmationFieldsFragmentDoc);
var PdpMandatoryVariantFieldsFragmentDoc = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject31());
var PdpMandatoryExtraVariantFieldsFragmentDoc = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject32());
var SizesFragmentDoc = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject33());
var MandatoryVariantFieldsFragmentDoc = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject34());
var MandatoryMasterFieldsFragmentDoc = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject35());
var PaginatedOutputNodesFragmentFragmentDoc = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject36(), MandatoryVariantFieldsFragmentDoc, MandatoryMasterFieldsFragmentDoc);
var PaginatedOutputMetadataFragmentFragmentDoc = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject37());
var ReviewFieldsFragmentDoc = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject38());
var ReviewSummaryFieldsFragmentDoc = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject39());
var OrderPreviewFieldsFragmentDoc = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject40());
var StandardOrderDetailsFieldsFragmentDoc = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject41(), ProductCartItemFieldsFragmentDoc, OrderPaymentInstrumentFieldsFragmentDoc, OrderConfirmationFieldsFragmentDoc);
var StoreCreditFieldsFragmentDoc = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject42());
var TermsAndConditionsFieldsFragmentDoc = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject43(), PortableTextFieldsFragmentDoc);
var UserFieldsFragmentDoc = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject44());
var SanityVideoFieldsFragmentDoc = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject45());
var WishListFieldsFragmentDoc = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject46());
var RecommendationFieldsFragmentDoc = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject47(), MandatoryVariantFieldsFragmentDoc, MandatoryMasterFieldsFragmentDoc);
var ProductFragmentDoc = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject48());
var GuestLogonDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject49(), TokenPayloadFragmentDoc);
function useGuestLogonMutation() {
    return Urql.useMutation(GuestLogonDocument);
}
var RefreshLogonDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject50(), TokenPayloadFragmentDoc);
function useRefreshLogonMutation() {
    return Urql.useMutation(RefreshLogonDocument);
}
var UpdatePasswordDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject51());
function useUpdatePasswordMutation() {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .Db(UpdatePasswordDocument);
}
var UpdatePhoneDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject52());
function useUpdatePhoneMutation() {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .Db(UpdatePhoneDocument);
}
var ConfirmUpdatePhoneDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject53());
function useConfirmUpdatePhoneMutation() {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .Db(ConfirmUpdatePhoneDocument);
}
var ResetPasswordDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject54());
function useResetPasswordMutation() {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .Db(ResetPasswordDocument);
}
var CompleteResetPasswordDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject55());
function useCompleteResetPasswordMutation() {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .Db(CompleteResetPasswordDocument);
}
var CreateShopperContextDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject56());
function useCreateShopperContextMutation() {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .Db(CreateShopperContextDocument);
}
var VerifyUserAffiliationsDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject57());
function useVerifyUserAffiliationsMutation() {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .Db(VerifyUserAffiliationsDocument);
}
var AddAddressDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject58(), AddressFieldsFragmentDoc);
function useAddAddressMutation() {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .Db(AddAddressDocument);
}
var UpdateAddressDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject59(), AddressFieldsFragmentDoc);
function useUpdateAddressMutation() {
    return Urql.useMutation(UpdateAddressDocument);
}
var DeleteAddressDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject60());
function useDeleteAddressMutation() {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .Db(DeleteAddressDocument);
}
var SaveAmbassadorCardDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject61(), AmbassadorCardFieldsFragmentDoc);
function useSaveAmbassadorCardMutation() {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .Db(SaveAmbassadorCardDocument);
}
var DeleteAmbassadorCardDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject62(), AmbassadorCardFieldsFragmentDoc);
function useDeleteAmbassadorCardMutation() {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .Db(DeleteAmbassadorCardDocument);
}
var UpdateAmbassadorCardsDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject63(), AmbassadorCardFieldsFragmentDoc);
function useUpdateAmbassadorCardsMutation() {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .Db(UpdateAmbassadorCardsDocument);
}
var AddItemsToCartDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject64(), CartFieldsFragmentDoc);
function useAddItemsToCartMutation() {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .Db(AddItemsToCartDocument);
}
var UpdateItemInCartDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject65(), CartFieldsFragmentDoc);
function useUpdateItemInCartMutation() {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .Db(UpdateItemInCartDocument);
}
var RemoveItemFromCartDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject66(), CartFieldsFragmentDoc);
function useRemoveItemFromCartMutation() {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .Db(RemoveItemFromCartDocument);
}
var AddGiftCardToCartDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject67(), CartFieldsFragmentDoc);
function useAddGiftCardToCartMutation() {
    return Urql.useMutation(AddGiftCardToCartDocument);
}
var RemoveGiftCardFromCartDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject68(), CartFieldsFragmentDoc);
function useRemoveGiftCardFromCartMutation() {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .Db(RemoveGiftCardFromCartDocument);
}
var AddGiftCardDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject69(), CartFieldsFragmentDoc);
function useAddGiftCardMutation() {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .Db(AddGiftCardDocument);
}
var RemoveGiftCardDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject70(), CartFieldsFragmentDoc);
function useRemoveGiftCardMutation() {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .Db(RemoveGiftCardDocument);
}
var UpdateShippingAddressDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject71(), CartFieldsFragmentDoc);
function useUpdateShippingAddressMutation() {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .Db(UpdateShippingAddressDocument);
}
var UpdateShipmentMethodDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject72(), CartFieldsFragmentDoc);
function useUpdateShipmentMethodMutation() {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .Db(UpdateShipmentMethodDocument);
}
var UpdateBillingAddressDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject73(), CartFieldsFragmentDoc);
function useUpdateBillingAddressMutation() {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .Db(UpdateBillingAddressDocument);
}
var RemoveCouponFromCartDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject74(), CartFieldsFragmentDoc);
function useRemoveCouponFromCartMutation() {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .Db(RemoveCouponFromCartDocument);
}
var AddCouponToCartDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject75(), CartFieldsFragmentDoc);
function useAddCouponToCartMutation() {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .Db(AddCouponToCartDocument);
}
var AddPaymentPromotionDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject76(), CartFieldsFragmentDoc);
function useAddPaymentPromotionMutation() {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .Db(AddPaymentPromotionDocument);
}
var AddAmbassadorCardToCartDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject77(), CartFieldsFragmentDoc);
function useAddAmbassadorCardToCartMutation() {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .Db(AddAmbassadorCardToCartDocument);
}
var RemoveAmbassadorCardFromCartDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject78(), CartFieldsFragmentDoc);
function useRemoveAmbassadorCardFromCartMutation() {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .Db(RemoveAmbassadorCardFromCartDocument);
}
var AddStoreCreditsDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject79(), CartFieldsFragmentDoc);
function useAddStoreCreditsMutation() {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .Db(AddStoreCreditsDocument);
}
var RemoveStoreCreditsDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject80(), CartFieldsFragmentDoc);
function useRemoveStoreCreditsMutation() {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .Db(RemoveStoreCreditsDocument);
}
var UpdateContactDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject81());
function useUpdateContactMutation() {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .Db(UpdateContactDocument);
}
var ProfilingConsentDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject82());
function useProfilingConsentMutation() {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .Db(ProfilingConsentDocument);
}
var KlarnaDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject83());
function useKlarnaMutation() {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .Db(KlarnaDocument);
}
var ConfirmKlarnaDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject84());
function useConfirmKlarnaMutation() {
    return Urql.useMutation(ConfirmKlarnaDocument);
}
var CancelKlarnaDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject85());
function useCancelKlarnaMutation() {
    return Urql.useMutation(CancelKlarnaDocument);
}
var StartKlarnaPaymentDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject86());
function useStartKlarnaPaymentMutation() {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .Db(StartKlarnaPaymentDocument);
}
var ConfirmKlarnaPaymentDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject87());
function useConfirmKlarnaPaymentMutation() {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .Db(ConfirmKlarnaPaymentDocument);
}
var LoginWithEmailAndPasswordDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject88(), AuthPayloadFragmentDoc);
function useLoginWithEmailAndPasswordMutation() {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .Db(LoginWithEmailAndPasswordDocument);
}
var VerifyLoginWithOtpDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject89(), AuthPayloadFragmentDoc);
function useVerifyLoginWithOtpMutation() {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .Db(VerifyLoginWithOtpDocument);
}
var LoginWithOtpDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject90());
function useLoginWithOtpMutation() {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .Db(LoginWithOtpDocument);
}
var LoginWithPhoneDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject91(), AuthPayloadFragmentDoc);
function useLoginWithPhoneMutation() {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .Db(LoginWithPhoneDocument);
}
var ResendOtpDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject92());
function useResendOtpMutation() {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .Db(ResendOtpDocument);
}
var LogoutDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject93());
function useLogoutMutation() {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .Db(LogoutDocument);
}
var ManageCustomerLevelNotificationDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject94());
function useManageCustomerLevelNotificationMutation() {
    return Urql.useMutation(ManageCustomerLevelNotificationDocument);
}
var SaveNotificationPreferencesDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject95());
function useSaveNotificationPreferencesMutation() {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .Db(SaveNotificationPreferencesDocument);
}
var ManageOrderLevelNotificationDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject96());
function useManageOrderLevelNotificationMutation() {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .Db(ManageOrderLevelNotificationDocument);
}
var CreateContactDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject97());
function useCreateContactMutation() {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .Db(CreateContactDocument);
}
var OpluxFraudDetectionDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject98());
function useOpluxFraudDetectionMutation() {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .Db(OpluxFraudDetectionDocument);
}
var StartAdyenPaymentDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject99());
function useStartAdyenPaymentMutation() {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .Db(StartAdyenPaymentDocument);
}
var CompleteAdyenPaymentDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject100());
function useCompleteAdyenPaymentMutation() {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .Db(CompleteAdyenPaymentDocument);
}
var PayWithAfterPayDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject101());
function usePayWithAfterPayMutation() {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .Db(PayWithAfterPayDocument);
}
var ConfirmAfterPayDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject102(), OrderPaymentInstrumentFieldsFragmentDoc, OrderConfirmationFieldsFragmentDoc);
function useConfirmAfterPayMutation() {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .Db(ConfirmAfterPayDocument);
}
var AmazonPayPaymentDescriptorDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject103());
function useAmazonPayPaymentDescriptorQuery(options) {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useQuery */ .aM((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        query: AmazonPayPaymentDescriptorDocument
    }, options));
}
var SignAmazonPayloadDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject104());
function useSignAmazonPayloadMutation() {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .Db(SignAmazonPayloadDocument);
}
var StartAmazonPaymentDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject105());
function useStartAmazonPaymentMutation() {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .Db(StartAmazonPaymentDocument);
}
var StartAmazonProcessOrderPaymentDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject106());
function useStartAmazonProcessOrderPaymentMutation() {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .Db(StartAmazonProcessOrderPaymentDocument);
}
var CompleteAmazonPaymentDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject107());
function useCompleteAmazonPaymentMutation() {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .Db(CompleteAmazonPaymentDocument);
}
var RegisterAmazonPaymentDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject108(), CartFieldsFragmentDoc, ShipmentFieldsFragmentDoc, ShipmentMethodInfoFieldsFragmentDoc, AvailablePaymentMethodsFieldsFragmentDoc);
function useRegisterAmazonPaymentMutation() {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .Db(RegisterAmazonPaymentDocument);
}
var PayWithAmbassadorCardDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject109(), OrderConfirmationFieldsFragmentDoc, OrderPaymentInstrumentFieldsFragmentDoc);
function usePayWithAmbassadorCardMutation() {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .Db(PayWithAmbassadorCardDocument);
}
var PayWithApplePayDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject110());
function usePayWithApplePayMutation() {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .Db(PayWithApplePayDocument);
}
var ValidateApplePayMerchantDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject111());
function useValidateApplePayMerchantMutation() {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .Db(ValidateApplePayMerchantDocument);
}
var ConfirmApplePayDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject112(), OrderPaymentInstrumentFieldsFragmentDoc, OrderConfirmationFieldsFragmentDoc);
function useConfirmApplePayMutation() {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .Db(ConfirmApplePayDocument);
}
var CancelApplePayDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject113());
function useCancelApplePayMutation() {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .Db(CancelApplePayDocument);
}
var CancelOrderDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject114(), CartFieldsFragmentDoc);
function useCancelOrderMutation() {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .Db(CancelOrderDocument);
}
var PayWithCashOnDeliveryDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject115(), OrderConfirmationFieldsFragmentDoc, ProductCartItemFieldsFragmentDoc);
function usePayWithCashOnDeliveryMutation() {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .Db(PayWithCashOnDeliveryDocument);
}
var PayWithCashOnDeliveryInCartDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject116());
function usePayWithCashOnDeliveryInCartMutation() {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .Db(PayWithCashOnDeliveryInCartDocument);
}
var ConfirmCashOnDeliveryDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject117(), OrderConfirmationFieldsFragmentDoc);
function useConfirmCashOnDeliveryMutation() {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .Db(ConfirmCashOnDeliveryDocument);
}
var PayWithCreditCardDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject118(), OrderConfirmationFieldsFragmentDoc, ProductCartItemFieldsFragmentDoc, OrderPaymentInstrumentFieldsFragmentDoc);
function usePayWithCreditCardMutation() {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .Db(PayWithCreditCardDocument);
}
var PayWithCreditCardInCartDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject119());
function usePayWithCreditCardInCartMutation() {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .Db(PayWithCreditCardInCartDocument);
}
var ConfirmCreditCardDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject120(), OrderPaymentInstrumentFieldsFragmentDoc, OrderConfirmationFieldsFragmentDoc);
function useConfirmCreditCardMutation() {
    return Urql.useMutation(ConfirmCreditCardDocument);
}
var SaveCreditCardDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject121(), SavedCreditCardFragmentDoc);
function useSaveCreditCardMutation() {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .Db(SaveCreditCardDocument);
}
var DeleteCreditCardDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject122(), SavedCreditCardFragmentDoc);
function useDeleteCreditCardMutation() {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .Db(DeleteCreditCardDocument);
}
var StartCreditCardPaymentDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject123(), StandardOrderDetailsFieldsFragmentDoc);
function useStartCreditCardPaymentMutation() {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .Db(StartCreditCardPaymentDocument);
}
var GmoConfirmCreditCardDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject124(), StandardOrderDetailsFieldsFragmentDoc);
function useGmoConfirmCreditCardMutation() {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .Db(GmoConfirmCreditCardDocument);
}
var PlaceOrderDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject125(), ProductCartItemFieldsFragmentDoc, OrderConfirmationFieldsFragmentDoc, OrderPaymentInstrumentFieldsFragmentDoc);
function usePlaceOrderMutation() {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .Db(PlaceOrderDocument);
}
var PayWithGiftCardDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject126(), ProductCartItemFieldsFragmentDoc, OrderConfirmationFieldsFragmentDoc, OrderPaymentInstrumentFieldsFragmentDoc);
function usePayWithGiftCardMutation() {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .Db(PayWithGiftCardDocument);
}
var PayWithGooglePayDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject127(), OrderPaymentInstrumentFieldsFragmentDoc, OrderConfirmationFieldsFragmentDoc);
function usePayWithGooglePayMutation() {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .Db(PayWithGooglePayDocument);
}
var CancelGooglePayDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject128());
function useCancelGooglePayMutation() {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .Db(CancelGooglePayDocument);
}
var PayWithPayPalDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject129());
function usePayWithPayPalMutation() {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .Db(PayWithPayPalDocument);
}
var ConfirmPayPalDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject130(), OrderPaymentInstrumentFieldsFragmentDoc, OrderConfirmationFieldsFragmentDoc);
function useConfirmPayPalMutation() {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .Db(ConfirmPayPalDocument);
}
var UpdatePayPalDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject131(), ProductCartItemFieldsFragmentDoc, OrderPaymentInstrumentFieldsFragmentDoc, OrderConfirmationFieldsFragmentDoc);
function useUpdatePayPalMutation() {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .Db(UpdatePayPalDocument);
}
var PayWithPayPayDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject132());
function usePayWithPayPayMutation() {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .Db(PayWithPayPayDocument);
}
var ConfirmPayPayDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject133(), OrderPaymentInstrumentFieldsFragmentDoc, OrderConfirmationFieldsFragmentDoc);
function useConfirmPayPayMutation() {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .Db(ConfirmPayPayDocument);
}
var PayWithPayPayInCartDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject134());
function usePayWithPayPayInCartMutation() {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .Db(PayWithPayPayInCartDocument);
}
var PayWithPayTmDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject135());
function usePayWithPayTmMutation() {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .Db(PayWithPayTmDocument);
}
var ConfirmPayTmDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject136(), OrderConfirmationFieldsFragmentDoc);
function useConfirmPayTmMutation() {
    return Urql.useMutation(ConfirmPayTmDocument);
}
var StartRazorPayDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject137());
function useStartRazorPayMutation() {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .Db(StartRazorPayDocument);
}
var ConfirmRazorPayDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject138());
function useConfirmRazorPayMutation() {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .Db(ConfirmRazorPayDocument);
}
var PayWithWalletDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject139());
function usePayWithWalletMutation() {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .Db(PayWithWalletDocument);
}
var ConfirmWalletDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject140(), OrderConfirmationFieldsFragmentDoc);
function useConfirmWalletMutation() {
    return Urql.useMutation(ConfirmWalletDocument);
}
var UpdateProfileDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject141(), UserFieldsFragmentDoc);
function useUpdateProfileMutation() {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .Db(UpdateProfileDocument);
}
var RegisterDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject142(), AuthPayloadFragmentDoc);
function useRegisterMutation() {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .Db(RegisterDocument);
}
var CreateReviewDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject143());
function useCreateReviewMutation() {
    return Urql.useMutation(CreateReviewDocument);
}
var TrackAppLinkClickDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject144());
function useTrackAppLinkClickMutation() {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .Db(TrackAppLinkClickDocument);
}
var TrackLanguageChangeDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject145());
function useTrackLanguageChangeMutation() {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .Db(TrackLanguageChangeDocument);
}
var TrackLiveChatStartDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject146());
function useTrackLiveChatStartMutation() {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .Db(TrackLiveChatStartDocument);
}
var TrackOrderConfirmationDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject147());
function useTrackOrderConfirmationMutation() {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .Db(TrackOrderConfirmationDocument);
}
var TrackRecommendationClickDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject148());
function useTrackRecommendationClickMutation() {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .Db(TrackRecommendationClickDocument);
}
var TrackProductViewDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject149());
function useTrackProductViewMutation() {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .Db(TrackProductViewDocument);
}
var AddItemToWishListDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject150(), WishListFieldsFragmentDoc);
function useAddItemToWishListMutation() {
    return Urql.useMutation(AddItemToWishListDocument);
}
var UpdateItemInWishListDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject151(), WishListFieldsFragmentDoc);
function useUpdateItemInWishListMutation() {
    return Urql.useMutation(UpdateItemInWishListDocument);
}
var RemoveItemFromWishListDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject152());
function useRemoveItemFromWishListMutation() {
    return Urql.useMutation(RemoveItemFromWishListDocument);
}
var AddressDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject153(), AddressFieldsFragmentDoc);
function useAddressQuery(options) {
    return Urql.useQuery(_object_spread({
        query: AddressDocument
    }, options));
}
var AfterPayConfigDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject154());
function useAfterPayConfigQuery(options) {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useQuery */ .aM((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        query: AfterPayConfigDocument
    }, options));
}
var AllCustomerGroupsDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject155());
function useAllCustomerGroupsQuery(options) {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useQuery */ .aM((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        query: AllCustomerGroupsDocument
    }, options));
}
var CheckAmbassadorCardBalanceDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject156());
function useCheckAmbassadorCardBalanceQuery(options) {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useQuery */ .aM((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        query: CheckAmbassadorCardBalanceDocument
    }, options));
}
var CartDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject157(), CartFieldsFragmentDoc, AvailablePaymentMethodsFieldsFragmentDoc);
function useCartQuery(options) {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useQuery */ .aM((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        query: CartDocument
    }, options));
}
var SimpleCartDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject158(), ProductCartItemFieldsFragmentDoc);
function useSimpleCartQuery(options) {
    return Urql.useQuery(_object_spread({
        query: SimpleCartDocument
    }, options));
}
var CategoryByIdDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject159(), CategoryFragmentDoc);
function useCategoryByIdQuery(options) {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useQuery */ .aM((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        query: CategoryByIdDocument
    }, options));
}
var CategorySizeChartDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject160());
function useCategorySizeChartQuery(options) {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useQuery */ .aM((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        query: CategorySizeChartDocument
    }, options));
}
var MainFooterMinimalDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject161(), CtaFieldsFragmentDoc);
function useMainFooterMinimalQuery(options) {
    return Urql.useQuery(_object_spread({
        query: MainFooterMinimalDocument
    }, options));
}
var MainFooterDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject162(), CtaFieldsFragmentDoc, SignUpFormFieldsFragmentDoc);
function useMainFooterQuery(options) {
    return Urql.useQuery(_object_spread({
        query: MainFooterDocument
    }, options));
}
var FrontendConfigurationDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject163());
function useFrontendConfigurationQuery(options) {
    return Urql.useQuery(_object_spread({
        query: FrontendConfigurationDocument
    }, options));
}
var CheckGiftCardBalanceDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject164());
function useCheckGiftCardBalanceQuery(options) {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useQuery */ .aM((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        query: CheckGiftCardBalanceDocument
    }, options));
}
var GiftCardDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject165());
function useGiftCardQuery(options) {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useQuery */ .aM((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        query: GiftCardDocument
    }, options));
}
var GlossaryPageDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject166(), SanityImageFieldsFragmentDoc, SanityVideoFieldsFragmentDoc);
function useGlossaryPageQuery(options) {
    return Urql.useQuery(_object_spread({
        query: GlossaryPageDocument
    }, options));
}
var InventoryDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject167());
function useInventoryQuery(options) {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useQuery */ .aM((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        query: InventoryDocument
    }, options));
}
var WishListTotalsDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject168());
function useWishListTotalsQuery(options) {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useQuery */ .aM((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        query: WishListTotalsDocument
    }, options));
}
var MeDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject169(), UserFieldsFragmentDoc, AddressFieldsFragmentDoc, OrderPreviewFieldsFragmentDoc, AmbassadorCardFieldsFragmentDoc, SavedCreditCardFragmentDoc, StoreCreditFieldsFragmentDoc);
function useMeQuery(options) {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useQuery */ .aM((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        query: MeDocument
    }, options));
}
var NotificationPreferencesDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject170());
function useNotificationPreferencesQuery(options) {
    return Urql.useQuery(_object_spread({
        query: NotificationPreferencesDocument
    }, options));
}
var OrderDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject171(), ProductCartItemFieldsFragmentDoc, ProductCartItemAnalyticsDimensionsFieldsFragmentDoc, OrderPaymentInstrumentFieldsFragmentDoc, OrderConfirmationFieldsFragmentDoc);
function useOrderQuery(options) {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useQuery */ .aM((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        query: OrderDocument
    }, options));
}
var OrderDetailsDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject172(), StandardOrderDetailsFieldsFragmentDoc, NestedOrderDetailsFieldsFragmentDoc);
function useOrderDetailsQuery(options) {
    return Urql.useQuery(_object_spread({
        query: OrderDetailsDocument
    }, options));
}
var OrderHistoryMeDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject173(), UserFieldsFragmentDoc, AddressFieldsFragmentDoc, OrderPreviewFieldsFragmentDoc);
function useOrderHistoryMeQuery(options) {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useQuery */ .aM((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        query: OrderHistoryMeDocument
    }, options));
}
var SearchOrderByPhoneDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject174(), StandardOrderDetailsFieldsFragmentDoc, NestedOrderDetailsFieldsFragmentDoc);
function useSearchOrderByPhoneQuery(options) {
    return Urql.useQuery(_object_spread({
        query: SearchOrderByPhoneDocument
    }, options));
}
var SearchOrderByEmailPostcodeDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject175(), StandardOrderDetailsFieldsFragmentDoc, NestedOrderDetailsFieldsFragmentDoc);
function useSearchOrderByEmailPostcodeQuery(options) {
    return Urql.useQuery(_object_spread({
        query: SearchOrderByEmailPostcodeDocument
    }, options));
}
var SearchOrderByEmailDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject176(), StandardOrderDetailsFieldsFragmentDoc, NestedOrderDetailsFieldsFragmentDoc);
function useSearchOrderByEmailQuery(options) {
    return Urql.useQuery(_object_spread({
        query: SearchOrderByEmailDocument
    }, options));
}
var SearchOrderByEmailPhoneDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject177(), StandardOrderDetailsFieldsFragmentDoc, NestedOrderDetailsFieldsFragmentDoc);
function useSearchOrderByEmailPhoneQuery(options) {
    return Urql.useQuery(_object_spread({
        query: SearchOrderByEmailPhoneDocument
    }, options));
}
var OutfitsDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject178(), ProductFragmentDoc);
function useOutfitsQuery(options) {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useQuery */ .aM((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        query: OutfitsDocument
    }, options));
}
var GetAmazonPayCustomerInfoDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject179());
function useGetAmazonPayCustomerInfoQuery(options) {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useQuery */ .aM((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        query: GetAmazonPayCustomerInfoDocument
    }, options));
}
var GetPayPayContentDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject180());
function useGetPayPayContentQuery(options) {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useQuery */ .aM((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        query: GetPayPayContentDocument
    }, options));
}
var PincodeDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject181());
function usePincodeQuery(options) {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useQuery */ .aM((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        query: PincodeDocument
    }, options));
}
var PixleeConfigDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject182());
function usePixleeConfigQuery(options) {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useQuery */ .aM((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        query: PixleeConfigDocument
    }, options));
}
var UserGeneratedContentDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject183());
function useUserGeneratedContentQuery(options) {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useQuery */ .aM((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        query: UserGeneratedContentDocument
    }, options));
}
var CategoryPlpDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject184(), CategoryFragmentDoc, PaginatedOutputNodesFragmentFragmentDoc, PaginatedOutputMetadataFragmentFragmentDoc);
function useCategoryPlpQuery(options) {
    return Urql.useQuery(_object_spread({
        query: CategoryPlpDocument
    }, options));
}
var VariantsDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject185());
function useVariantsQuery(options) {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useQuery */ .aM((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        query: VariantsDocument
    }, options));
}
var SiblingVariantsDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject186(), MandatoryVariantFieldsFragmentDoc);
function useSiblingVariantsQuery(options) {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useQuery */ .aM((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        query: SiblingVariantsDocument
    }, options));
}
var VariantDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject187());
function useVariantQuery(options) {
    return Urql.useQuery(_object_spread({
        query: VariantDocument
    }, options));
}
var ProductDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject188());
function useProductQuery(options) {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useQuery */ .aM((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        query: ProductDocument
    }, options));
}
var PdpDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject189(), MandatoryMasterFieldsFragmentDoc, PdpMandatoryVariantFieldsFragmentDoc);
function usePdpQuery(options) {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useQuery */ .aM((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        query: PdpDocument
    }, options));
}
var LazyPdpDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject190(), SizesFragmentDoc, PdpMandatoryExtraVariantFieldsFragmentDoc);
function useLazyPdpQuery(options) {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useQuery */ .aM((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        query: LazyPdpDocument
    }, options));
}
var ProductSizeChartDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject191());
function useProductSizeChartQuery(options) {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useQuery */ .aM((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        query: ProductSizeChartDocument
    }, options));
}
var ProductScoreDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject192());
function useProductScoreQuery(options) {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useQuery */ .aM((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        query: ProductScoreDocument
    }, options));
}
var RecommendationsWithDetailsDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject193(), RecommendationFieldsFragmentDoc);
function useRecommendationsWithDetailsQuery(options) {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useQuery */ .aM((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        query: RecommendationsWithDetailsDocument
    }, options));
}
var ProductReviewsDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject194(), ReviewFieldsFragmentDoc, ReviewSummaryFieldsFragmentDoc);
function useProductReviewsQuery(options) {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useQuery */ .aM((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        query: ProductReviewsDocument
    }, options));
}
var TrendingSearchTermsDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject195());
function useTrendingSearchTermsQuery(options) {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useQuery */ .aM((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        query: TrendingSearchTermsDocument
    }, options));
}
var SearchRecommendedProductsDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject196());
function useSearchRecommendedProductsQuery(options) {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useQuery */ .aM((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        query: SearchRecommendedProductsDocument
    }, options));
}
var ProductSearchDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject197(), PaginatedOutputNodesFragmentFragmentDoc, PaginatedOutputMetadataFragmentFragmentDoc);
function useProductSearchQuery(options) {
    return Urql.useQuery(_object_spread({
        query: ProductSearchDocument
    }, options));
}
var LookDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject198(), ProductFragmentDoc);
function useLookQuery(options) {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useQuery */ .aM((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        query: LookDocument
    }, options));
}
var SuggestionsDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject199());
function useSuggestionsQuery(options) {
    return urql__WEBPACK_IMPORTED_MODULE_3__/* .useQuery */ .aM((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        query: SuggestionsDocument
    }, options));
}
var TermsAndConditionsConfigsDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject200(), TermsAndConditionsFieldsFragmentDoc);
function useTermsAndConditionsConfigsQuery(options) {
    return Urql.useQuery(_object_spread({
        query: TermsAndConditionsConfigsDocument
    }, options));
}
var UrlRedirectDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject201());
function useUrlRedirectQuery(options) {
    return Urql.useQuery(_object_spread({
        query: UrlRedirectDocument
    }, options));
}
var WishListDocument = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject202(), WishListFieldsFragmentDoc);
function useWishListQuery(options) {
    return Urql.useQuery(_object_spread({
        query: WishListDocument
    }, options));
}
function getSdk(requester) {
    return {
        GuestLogon: function GuestLogon(variables, options) {
            return requester(Operations.GuestLogonDocument, variables, options);
        },
        RefreshLogon: function RefreshLogon(variables, options) {
            return requester(Operations.RefreshLogonDocument, variables, options);
        },
        UpdatePassword: function UpdatePassword(variables, options) {
            return requester(Operations.UpdatePasswordDocument, variables, options);
        },
        UpdatePhone: function UpdatePhone(variables, options) {
            return requester(Operations.UpdatePhoneDocument, variables, options);
        },
        ConfirmUpdatePhone: function ConfirmUpdatePhone(variables, options) {
            return requester(Operations.ConfirmUpdatePhoneDocument, variables, options);
        },
        ResetPassword: function ResetPassword(variables, options) {
            return requester(Operations.ResetPasswordDocument, variables, options);
        },
        CompleteResetPassword: function CompleteResetPassword(variables, options) {
            return requester(Operations.CompleteResetPasswordDocument, variables, options);
        },
        CreateShopperContext: function CreateShopperContext(variables, options) {
            return requester(Operations.CreateShopperContextDocument, variables, options);
        },
        VerifyUserAffiliations: function VerifyUserAffiliations(variables, options) {
            return requester(Operations.VerifyUserAffiliationsDocument, variables, options);
        },
        AddAddress: function AddAddress(variables, options) {
            return requester(Operations.AddAddressDocument, variables, options);
        },
        UpdateAddress: function UpdateAddress(variables, options) {
            return requester(Operations.UpdateAddressDocument, variables, options);
        },
        DeleteAddress: function DeleteAddress(variables, options) {
            return requester(Operations.DeleteAddressDocument, variables, options);
        },
        SaveAmbassadorCard: function SaveAmbassadorCard(variables, options) {
            return requester(Operations.SaveAmbassadorCardDocument, variables, options);
        },
        DeleteAmbassadorCard: function DeleteAmbassadorCard(variables, options) {
            return requester(Operations.DeleteAmbassadorCardDocument, variables, options);
        },
        UpdateAmbassadorCards: function UpdateAmbassadorCards(variables, options) {
            return requester(Operations.UpdateAmbassadorCardsDocument, variables, options);
        },
        AddItemsToCart: function AddItemsToCart(variables, options) {
            return requester(Operations.AddItemsToCartDocument, variables, options);
        },
        UpdateItemInCart: function UpdateItemInCart(variables, options) {
            return requester(Operations.UpdateItemInCartDocument, variables, options);
        },
        RemoveItemFromCart: function RemoveItemFromCart(variables, options) {
            return requester(Operations.RemoveItemFromCartDocument, variables, options);
        },
        AddGiftCardToCart: function AddGiftCardToCart(variables, options) {
            return requester(Operations.AddGiftCardToCartDocument, variables, options);
        },
        RemoveGiftCardFromCart: function RemoveGiftCardFromCart(variables, options) {
            return requester(Operations.RemoveGiftCardFromCartDocument, variables, options);
        },
        AddGiftCard: function AddGiftCard(variables, options) {
            return requester(Operations.AddGiftCardDocument, variables, options);
        },
        RemoveGiftCard: function RemoveGiftCard(variables, options) {
            return requester(Operations.RemoveGiftCardDocument, variables, options);
        },
        UpdateShippingAddress: function UpdateShippingAddress(variables, options) {
            return requester(Operations.UpdateShippingAddressDocument, variables, options);
        },
        UpdateShipmentMethod: function UpdateShipmentMethod(variables, options) {
            return requester(Operations.UpdateShipmentMethodDocument, variables, options);
        },
        UpdateBillingAddress: function UpdateBillingAddress(variables, options) {
            return requester(Operations.UpdateBillingAddressDocument, variables, options);
        },
        RemoveCouponFromCart: function RemoveCouponFromCart(variables, options) {
            return requester(Operations.RemoveCouponFromCartDocument, variables, options);
        },
        AddCouponToCart: function AddCouponToCart(variables, options) {
            return requester(Operations.AddCouponToCartDocument, variables, options);
        },
        AddPaymentPromotion: function AddPaymentPromotion(variables, options) {
            return requester(Operations.AddPaymentPromotionDocument, variables, options);
        },
        AddAmbassadorCardToCart: function AddAmbassadorCardToCart(variables, options) {
            return requester(Operations.AddAmbassadorCardToCartDocument, variables, options);
        },
        RemoveAmbassadorCardFromCart: function RemoveAmbassadorCardFromCart(variables, options) {
            return requester(Operations.RemoveAmbassadorCardFromCartDocument, variables, options);
        },
        AddStoreCredits: function AddStoreCredits(variables, options) {
            return requester(Operations.AddStoreCreditsDocument, variables, options);
        },
        RemoveStoreCredits: function RemoveStoreCredits(variables, options) {
            return requester(Operations.RemoveStoreCreditsDocument, variables, options);
        },
        UpdateContact: function UpdateContact(variables, options) {
            return requester(Operations.UpdateContactDocument, variables, options);
        },
        ProfilingConsent: function ProfilingConsent(variables, options) {
            return requester(Operations.ProfilingConsentDocument, variables, options);
        },
        Klarna: function Klarna(variables, options) {
            return requester(Operations.KlarnaDocument, variables, options);
        },
        ConfirmKlarna: function ConfirmKlarna(variables, options) {
            return requester(Operations.ConfirmKlarnaDocument, variables, options);
        },
        CancelKlarna: function CancelKlarna(variables, options) {
            return requester(Operations.CancelKlarnaDocument, variables, options);
        },
        startKlarnaPayment: function startKlarnaPayment(variables, options) {
            return requester(Operations.StartKlarnaPaymentDocument, variables, options);
        },
        confirmKlarnaPayment: function confirmKlarnaPayment(variables, options) {
            return requester(Operations.ConfirmKlarnaPaymentDocument, variables, options);
        },
        LoginWithEmailAndPassword: function LoginWithEmailAndPassword(variables, options) {
            return requester(Operations.LoginWithEmailAndPasswordDocument, variables, options);
        },
        VerifyLoginWithOTP: function VerifyLoginWithOTP(variables, options) {
            return requester(Operations.VerifyLoginWithOtpDocument, variables, options);
        },
        LoginWithOTP: function LoginWithOTP(variables, options) {
            return requester(Operations.LoginWithOtpDocument, variables, options);
        },
        LoginWithPhone: function LoginWithPhone(variables, options) {
            return requester(Operations.LoginWithPhoneDocument, variables, options);
        },
        ResendOTP: function ResendOTP(variables, options) {
            return requester(Operations.ResendOtpDocument, variables, options);
        },
        Logout: function Logout(variables, options) {
            return requester(Operations.LogoutDocument, variables, options);
        },
        ManageCustomerLevelNotification: function ManageCustomerLevelNotification(variables, options) {
            return requester(Operations.ManageCustomerLevelNotificationDocument, variables, options);
        },
        SaveNotificationPreferences: function SaveNotificationPreferences(variables, options) {
            return requester(Operations.SaveNotificationPreferencesDocument, variables, options);
        },
        ManageOrderLevelNotification: function ManageOrderLevelNotification(variables, options) {
            return requester(Operations.ManageOrderLevelNotificationDocument, variables, options);
        },
        CreateContact: function CreateContact(variables, options) {
            return requester(Operations.CreateContactDocument, variables, options);
        },
        OpluxFraudDetection: function OpluxFraudDetection(variables, options) {
            return requester(Operations.OpluxFraudDetectionDocument, variables, options);
        },
        StartAdyenPayment: function StartAdyenPayment(variables, options) {
            return requester(Operations.StartAdyenPaymentDocument, variables, options);
        },
        CompleteAdyenPayment: function CompleteAdyenPayment(variables, options) {
            return requester(Operations.CompleteAdyenPaymentDocument, variables, options);
        },
        PayWithAfterPay: function PayWithAfterPay(variables, options) {
            return requester(Operations.PayWithAfterPayDocument, variables, options);
        },
        ConfirmAfterPay: function ConfirmAfterPay(variables, options) {
            return requester(Operations.ConfirmAfterPayDocument, variables, options);
        },
        AmazonPayPaymentDescriptor: function AmazonPayPaymentDescriptor(variables, options) {
            return requester(Operations.AmazonPayPaymentDescriptorDocument, variables, options);
        },
        SignAmazonPayload: function SignAmazonPayload(variables, options) {
            return requester(Operations.SignAmazonPayloadDocument, variables, options);
        },
        StartAmazonPayment: function StartAmazonPayment(variables, options) {
            return requester(Operations.StartAmazonPaymentDocument, variables, options);
        },
        StartAmazonProcessOrderPayment: function StartAmazonProcessOrderPayment(variables, options) {
            return requester(Operations.StartAmazonProcessOrderPaymentDocument, variables, options);
        },
        CompleteAmazonPayment: function CompleteAmazonPayment(variables, options) {
            return requester(Operations.CompleteAmazonPaymentDocument, variables, options);
        },
        RegisterAmazonPayment: function RegisterAmazonPayment(variables, options) {
            return requester(Operations.RegisterAmazonPaymentDocument, variables, options);
        },
        PayWithAmbassadorCard: function PayWithAmbassadorCard(variables, options) {
            return requester(Operations.PayWithAmbassadorCardDocument, variables, options);
        },
        PayWithApplePay: function PayWithApplePay(variables, options) {
            return requester(Operations.PayWithApplePayDocument, variables, options);
        },
        ValidateApplePayMerchant: function ValidateApplePayMerchant(variables, options) {
            return requester(Operations.ValidateApplePayMerchantDocument, variables, options);
        },
        ConfirmApplePay: function ConfirmApplePay(variables, options) {
            return requester(Operations.ConfirmApplePayDocument, variables, options);
        },
        CancelApplePay: function CancelApplePay(variables, options) {
            return requester(Operations.CancelApplePayDocument, variables, options);
        },
        CancelOrder: function CancelOrder(variables, options) {
            return requester(Operations.CancelOrderDocument, variables, options);
        },
        PayWithCashOnDelivery: function PayWithCashOnDelivery(variables, options) {
            return requester(Operations.PayWithCashOnDeliveryDocument, variables, options);
        },
        PayWithCashOnDeliveryInCart: function PayWithCashOnDeliveryInCart(variables, options) {
            return requester(Operations.PayWithCashOnDeliveryInCartDocument, variables, options);
        },
        ConfirmCashOnDelivery: function ConfirmCashOnDelivery(variables, options) {
            return requester(Operations.ConfirmCashOnDeliveryDocument, variables, options);
        },
        PayWithCreditCard: function PayWithCreditCard(variables, options) {
            return requester(Operations.PayWithCreditCardDocument, variables, options);
        },
        PayWithCreditCardInCart: function PayWithCreditCardInCart(variables, options) {
            return requester(Operations.PayWithCreditCardInCartDocument, variables, options);
        },
        ConfirmCreditCard: function ConfirmCreditCard(variables, options) {
            return requester(Operations.ConfirmCreditCardDocument, variables, options);
        },
        SaveCreditCard: function SaveCreditCard(variables, options) {
            return requester(Operations.SaveCreditCardDocument, variables, options);
        },
        DeleteCreditCard: function DeleteCreditCard(variables, options) {
            return requester(Operations.DeleteCreditCardDocument, variables, options);
        },
        StartCreditCardPayment: function StartCreditCardPayment(variables, options) {
            return requester(Operations.StartCreditCardPaymentDocument, variables, options);
        },
        GmoConfirmCreditCard: function GmoConfirmCreditCard(variables, options) {
            return requester(Operations.GmoConfirmCreditCardDocument, variables, options);
        },
        PlaceOrder: function PlaceOrder(variables, options) {
            return requester(Operations.PlaceOrderDocument, variables, options);
        },
        PayWithGiftCard: function PayWithGiftCard(variables, options) {
            return requester(Operations.PayWithGiftCardDocument, variables, options);
        },
        PayWithGooglePay: function PayWithGooglePay(variables, options) {
            return requester(Operations.PayWithGooglePayDocument, variables, options);
        },
        CancelGooglePay: function CancelGooglePay(variables, options) {
            return requester(Operations.CancelGooglePayDocument, variables, options);
        },
        PayWithPayPal: function PayWithPayPal(variables, options) {
            return requester(Operations.PayWithPayPalDocument, variables, options);
        },
        ConfirmPayPal: function ConfirmPayPal(variables, options) {
            return requester(Operations.ConfirmPayPalDocument, variables, options);
        },
        UpdatePayPal: function UpdatePayPal(variables, options) {
            return requester(Operations.UpdatePayPalDocument, variables, options);
        },
        PayWithPayPay: function PayWithPayPay(variables, options) {
            return requester(Operations.PayWithPayPayDocument, variables, options);
        },
        ConfirmPayPay: function ConfirmPayPay(variables, options) {
            return requester(Operations.ConfirmPayPayDocument, variables, options);
        },
        PayWithPayPayInCart: function PayWithPayPayInCart(variables, options) {
            return requester(Operations.PayWithPayPayInCartDocument, variables, options);
        },
        PayWithPayTm: function PayWithPayTm(variables, options) {
            return requester(Operations.PayWithPayTmDocument, variables, options);
        },
        ConfirmPayTm: function ConfirmPayTm(variables, options) {
            return requester(Operations.ConfirmPayTmDocument, variables, options);
        },
        StartRazorPay: function StartRazorPay(variables, options) {
            return requester(Operations.StartRazorPayDocument, variables, options);
        },
        ConfirmRazorPay: function ConfirmRazorPay(variables, options) {
            return requester(Operations.ConfirmRazorPayDocument, variables, options);
        },
        PayWithWallet: function PayWithWallet(variables, options) {
            return requester(Operations.PayWithWalletDocument, variables, options);
        },
        ConfirmWallet: function ConfirmWallet(variables, options) {
            return requester(Operations.ConfirmWalletDocument, variables, options);
        },
        UpdateProfile: function UpdateProfile(variables, options) {
            return requester(Operations.UpdateProfileDocument, variables, options);
        },
        Register: function Register(variables, options) {
            return requester(Operations.RegisterDocument, variables, options);
        },
        CreateReview: function CreateReview(variables, options) {
            return requester(Operations.CreateReviewDocument, variables, options);
        },
        TrackAppLinkClick: function TrackAppLinkClick(variables, options) {
            return requester(Operations.TrackAppLinkClickDocument, variables, options);
        },
        TrackLanguageChange: function TrackLanguageChange(variables, options) {
            return requester(Operations.TrackLanguageChangeDocument, variables, options);
        },
        TrackLiveChatStart: function TrackLiveChatStart(variables, options) {
            return requester(Operations.TrackLiveChatStartDocument, variables, options);
        },
        TrackOrderConfirmation: function TrackOrderConfirmation(variables, options) {
            return requester(Operations.TrackOrderConfirmationDocument, variables, options);
        },
        TrackRecommendationClick: function TrackRecommendationClick(variables, options) {
            return requester(Operations.TrackRecommendationClickDocument, variables, options);
        },
        TrackProductView: function TrackProductView(variables, options) {
            return requester(Operations.TrackProductViewDocument, variables, options);
        },
        AddItemToWishList: function AddItemToWishList(variables, options) {
            return requester(Operations.AddItemToWishListDocument, variables, options);
        },
        UpdateItemInWishList: function UpdateItemInWishList(variables, options) {
            return requester(Operations.UpdateItemInWishListDocument, variables, options);
        },
        RemoveItemFromWishList: function RemoveItemFromWishList(variables, options) {
            return requester(Operations.RemoveItemFromWishListDocument, variables, options);
        },
        Address: function Address(variables, options) {
            return requester(Operations.AddressDocument, variables, options);
        },
        AfterPayConfig: function AfterPayConfig(variables, options) {
            return requester(Operations.AfterPayConfigDocument, variables, options);
        },
        AllCustomerGroups: function AllCustomerGroups(variables, options) {
            return requester(Operations.AllCustomerGroupsDocument, variables, options);
        },
        CheckAmbassadorCardBalance: function CheckAmbassadorCardBalance(variables, options) {
            return requester(Operations.CheckAmbassadorCardBalanceDocument, variables, options);
        },
        Cart: function Cart(variables, options) {
            return requester(Operations.CartDocument, variables, options);
        },
        SimpleCart: function SimpleCart(variables, options) {
            return requester(Operations.SimpleCartDocument, variables, options);
        },
        CategoryById: function CategoryById(variables, options) {
            return requester(Operations.CategoryByIdDocument, variables, options);
        },
        CategorySizeChart: function CategorySizeChart(variables, options) {
            return requester(Operations.CategorySizeChartDocument, variables, options);
        },
        MainFooterMinimal: function MainFooterMinimal(variables, options) {
            return requester(Operations.MainFooterMinimalDocument, variables, options);
        },
        MainFooter: function MainFooter(variables, options) {
            return requester(Operations.MainFooterDocument, variables, options);
        },
        FrontendConfiguration: function FrontendConfiguration(variables, options) {
            return requester(Operations.FrontendConfigurationDocument, variables, options);
        },
        CheckGiftCardBalance: function CheckGiftCardBalance(variables, options) {
            return requester(Operations.CheckGiftCardBalanceDocument, variables, options);
        },
        GiftCard: function GiftCard(variables, options) {
            return requester(Operations.GiftCardDocument, variables, options);
        },
        GlossaryPage: function GlossaryPage(variables, options) {
            return requester(Operations.GlossaryPageDocument, variables, options);
        },
        Inventory: function Inventory(variables, options) {
            return requester(Operations.InventoryDocument, variables, options);
        },
        WishListTotals: function WishListTotals(variables, options) {
            return requester(Operations.WishListTotalsDocument, variables, options);
        },
        Me: function Me(variables, options) {
            return requester(Operations.MeDocument, variables, options);
        },
        NotificationPreferences: function NotificationPreferences(variables, options) {
            return requester(Operations.NotificationPreferencesDocument, variables, options);
        },
        Order: function Order(variables, options) {
            return requester(Operations.OrderDocument, variables, options);
        },
        OrderDetails: function OrderDetails(variables, options) {
            return requester(Operations.OrderDetailsDocument, variables, options);
        },
        OrderHistoryMe: function OrderHistoryMe(variables, options) {
            return requester(Operations.OrderHistoryMeDocument, variables, options);
        },
        SearchOrderByPhone: function SearchOrderByPhone(variables, options) {
            return requester(Operations.SearchOrderByPhoneDocument, variables, options);
        },
        SearchOrderByEmailPostcode: function SearchOrderByEmailPostcode(variables, options) {
            return requester(Operations.SearchOrderByEmailPostcodeDocument, variables, options);
        },
        SearchOrderByEmail: function SearchOrderByEmail(variables, options) {
            return requester(Operations.SearchOrderByEmailDocument, variables, options);
        },
        SearchOrderByEmailPhone: function SearchOrderByEmailPhone(variables, options) {
            return requester(Operations.SearchOrderByEmailPhoneDocument, variables, options);
        },
        Outfits: function Outfits(variables, options) {
            return requester(Operations.OutfitsDocument, variables, options);
        },
        getAmazonPayCustomerInfo: function getAmazonPayCustomerInfo(variables, options) {
            return requester(Operations.GetAmazonPayCustomerInfoDocument, variables, options);
        },
        getPayPayContent: function getPayPayContent(variables, options) {
            return requester(Operations.GetPayPayContentDocument, variables, options);
        },
        Pincode: function Pincode(variables, options) {
            return requester(Operations.PincodeDocument, variables, options);
        },
        PixleeConfig: function PixleeConfig(variables, options) {
            return requester(Operations.PixleeConfigDocument, variables, options);
        },
        UserGeneratedContent: function UserGeneratedContent(variables, options) {
            return requester(Operations.UserGeneratedContentDocument, variables, options);
        },
        CategoryPLP: function CategoryPLP(variables, options) {
            return requester(Operations.CategoryPlpDocument, variables, options);
        },
        Variants: function Variants(variables, options) {
            return requester(Operations.VariantsDocument, variables, options);
        },
        SiblingVariants: function SiblingVariants(variables, options) {
            return requester(Operations.SiblingVariantsDocument, variables, options);
        },
        Variant: function Variant(variables, options) {
            return requester(Operations.VariantDocument, variables, options);
        },
        Product: function Product(variables, options) {
            return requester(Operations.ProductDocument, variables, options);
        },
        PDP: function PDP(variables, options) {
            return requester(Operations.PdpDocument, variables, options);
        },
        LazyPDP: function LazyPDP(variables, options) {
            return requester(Operations.LazyPdpDocument, variables, options);
        },
        ProductSizeChart: function ProductSizeChart(variables, options) {
            return requester(Operations.ProductSizeChartDocument, variables, options);
        },
        ProductScore: function ProductScore(variables, options) {
            return requester(Operations.ProductScoreDocument, variables, options);
        },
        RecommendationsWithDetails: function RecommendationsWithDetails(variables, options) {
            return requester(Operations.RecommendationsWithDetailsDocument, variables, options);
        },
        ProductReviews: function ProductReviews(variables, options) {
            return requester(Operations.ProductReviewsDocument, variables, options);
        },
        TrendingSearchTerms: function TrendingSearchTerms(variables, options) {
            return requester(Operations.TrendingSearchTermsDocument, variables, options);
        },
        SearchRecommendedProducts: function SearchRecommendedProducts(variables, options) {
            return requester(Operations.SearchRecommendedProductsDocument, variables, options);
        },
        ProductSearch: function ProductSearch(variables, options) {
            return requester(Operations.ProductSearchDocument, variables, options);
        },
        Look: function Look(variables, options) {
            return requester(Operations.LookDocument, variables, options);
        },
        Suggestions: function Suggestions(variables, options) {
            return requester(Operations.SuggestionsDocument, variables, options);
        },
        TermsAndConditionsConfigs: function TermsAndConditionsConfigs(variables, options) {
            return requester(Operations.TermsAndConditionsConfigsDocument, variables, options);
        },
        UrlRedirect: function UrlRedirect(variables, options) {
            return requester(Operations.UrlRedirectDocument, variables, options);
        },
        WishList: function WishList(variables, options) {
            return requester(Operations.WishListDocument, variables, options);
        }
    };
}


/***/ }),

/***/ 42956:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ authStateFromPayload; }
/* harmony export */ });
/* harmony import */ var _token__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4780);

function authStateFromPayload(payload) {
    var ref, ref1, ref2;
    var decodedToken = (0,_token__WEBPACK_IMPORTED_MODULE_0__/* .decodeToken */ .TD)(payload.accessToken);
    var isGuest = (decodedToken === null || decodedToken === void 0 ? void 0 : (ref = decodedToken.isb) === null || ref === void 0 ? void 0 : ref.includes("::upn:Guest::")) || false;
    var uniqueShopperId = payload.__typename === "TokenPayload" && payload.uniqueShopperId;
    return {
        accessToken: payload.accessToken,
        guest: isGuest,
        refreshToken: payload.refreshToken,
        customerId: payload.customerId,
        uniqueShopperId: uniqueShopperId || "",
        customerContext: {
            hashKey: ((ref1 = payload.customerContext) === null || ref1 === void 0 ? void 0 : ref1.hashKey) || undefined,
            customerGroups: ((ref2 = payload.customerContext) === null || ref2 === void 0 ? void 0 : ref2.customerGroups) || []
        },
        user: payload.user || undefined
    };
}


/***/ }),

/***/ 62900:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cj": function() { return /* binding */ destroyStoredAuthData; },
/* harmony export */   "KH": function() { return /* binding */ destroyStoredAgentAuthData; },
/* harmony export */   "_J": function() { return /* binding */ storeAuthData; },
/* harmony export */   "ir": function() { return /* binding */ getStoredAuthData; },
/* harmony export */   "jH": function() { return /* binding */ getStoredAgentAuthData; }
/* harmony export */ });
/* unused harmony exports AGENT_COOKIE_NAME, AUTH_COOKIE_NAME, storeAgentAuthData */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85034);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70169);
/* harmony import */ var nookies__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(15798);
/* harmony import */ var nookies__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(nookies__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var utils_locale__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79302);
/* harmony import */ var utils_clientLogger__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50222);
/* harmony import */ var _authState__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42956);







var AGENT_COOKIE_NAME = "cybercat-agent";
var AUTH_COOKIE_NAME =  false ? 0 : "cybercat-auth";
var IS_DEPLOYED = [
    "development",
    "qa",
    "production"
].includes("production");
var maxAge = 90 * 24 * 60 * 60; // 90 days
var defaultCookieOptions = {
    maxAge: maxAge,
    expires: new Date(Date.now() + maxAge * 1000),
    path: "/",
    secure: IS_DEPLOYED,
    httpOnly: false,
    sameSite: "strict"
};
function getCookieCountryPath(country) {
    return "/".concat(((0,utils_locale__WEBPACK_IMPORTED_MODULE_1__/* .getMappedCountryCode */ .p5)(country) || country).toLowerCase());
}
/**
 * Destroy the cookies used for authentication
 */ function destroyStoredAuthData(country, ctx) {
    try {
        (0,nookies__WEBPACK_IMPORTED_MODULE_0__.destroyCookie)(ctx, AUTH_COOKIE_NAME, {
            path: getCookieCountryPath(country)
        });
    } catch (err) {
        utils_clientLogger__WEBPACK_IMPORTED_MODULE_2__/* .clientLogger.error */ .u.error({
            err: err
        }, "authExchange: failed to destroy auth cookie");
    }
}
/**
 * Destroy the cookies used for agent impersonation
 */ function destroyStoredAgentAuthData(country, ctx) {
    try {
        (0,nookies__WEBPACK_IMPORTED_MODULE_0__.destroyCookie)(ctx, AGENT_COOKIE_NAME, {
            path: getCookieCountryPath(country)
        });
    } catch (err) {
        utils_clientLogger__WEBPACK_IMPORTED_MODULE_2__/* .clientLogger.error */ .u.error({
            err: err
        }, "authExchange: failed to destroy agent auth cookie");
    }
}
/**
 * Get the agent impersonation information
 * @param ctx NextJS page or API context, express context, null or undefined.
 * @returns The impersonation agent identification
 */ function getStoredAgentAuthData(ctx) {
    var cookies = (0,nookies__WEBPACK_IMPORTED_MODULE_0__.parseCookies)(ctx);
    var agentAuthStateCookie = cookies[AGENT_COOKIE_NAME];
    if (agentAuthStateCookie) {
        return JSON.parse(agentAuthStateCookie);
    }
    return null;
}
/**
 * Get the currently authenticated users information if exists.
 * If the browser is not authenticated, returns a guest identifier
 * @param ctx NextJS page or API context, express context, null or undefined.
 * @returns The user information
 */ function getStoredAuthData(ctx) {
    var cookies = (0,nookies__WEBPACK_IMPORTED_MODULE_0__.parseCookies)(ctx);
    var authStateCookie = cookies[AUTH_COOKIE_NAME];
    if (authStateCookie) {
        return JSON.parse(authStateCookie);
    }
    return {
        guest: true
    };
}
/**
 * Store the agent impersonation data
 * @param ctx NextJS page or API context, express context, null or undefined.
 * @param agent The agent information
 */ function storeAgentAuthData(param, ctx) {
    var agent = param.agent, country = param.country;
    try {
        var maxAge = defaultCookieOptions.maxAge, withoutMaxAge = _object_without_properties(defaultCookieOptions, [
            "maxAge"
        ]);
        var options = _object_spread_props(_object_spread({}, withoutMaxAge), {
            path: getCookieCountryPath(country),
            // since the request to this API endpoint comes from a different
            // domain, the default of sameSite=Strict would prevent the cookies
            // we create from being forwarded on to the redirect, so we have
            // to remove this restriction for agent logins
            sameSite: IS_DEPLOYED ? "none" : "lax"
        });
        setCookie(ctx, AGENT_COOKIE_NAME, JSON.stringify(agent), options);
    } catch (err) {
        clientLogger.error({
            err: err
        }, "authExchange: failed to set agent auth cookie");
    }
}
/**
 * Store the users authentication data
 * @param ctx NextJS page or API context, express context, null or undefined.
 * @param payload The token payload from the auth API response
 */ function storeAuthData(param, ctx) {
    var payload = param.payload, country = param.country;
    try {
        var authState = (0,_authState__WEBPACK_IMPORTED_MODULE_3__/* .authStateFromPayload */ .Y)(payload);
        var options = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, defaultCookieOptions), {
            path: getCookieCountryPath(country)
        });
        (0,nookies__WEBPACK_IMPORTED_MODULE_0__.setCookie)(ctx, AUTH_COOKIE_NAME, JSON.stringify(authState), options);
        return authState;
    } catch (err) {
        utils_clientLogger__WEBPACK_IMPORTED_MODULE_2__/* .clientLogger.error */ .u.error({
            err: err
        }, "authExchange: failed to set auth cookie");
        return {
            guest: true
        };
    }
}


/***/ }),

/***/ 4780:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "TD": function() { return /* binding */ decodeToken; },
  "kh": function() { return /* binding */ getGuestToken; },
  "pw": function() { return /* binding */ isTokenExpired; },
  "Oc": function() { return /* binding */ refreshAuthToken; }
});

// UNUSED EXPORTS: GUEST_LOGON_MUTATION, REFRESH_LOGON_MUTATION

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(23842);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(19989);
// EXTERNAL MODULE: ../node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(59312);
// EXTERNAL MODULE: ../node_modules/exponential-backoff/dist/backoff.js
var backoff = __webpack_require__(11470);
;// CONCATENATED MODULE: ../node_modules/js-base64/base64.mjs
/* provided dependency */ var Buffer = __webpack_require__(30816)["Buffer"];
/**
 *  base64.ts
 *
 *  Licensed under the BSD 3-Clause License.
 *    http://opensource.org/licenses/BSD-3-Clause
 *
 *  References:
 *    http://en.wikipedia.org/wiki/Base64
 *
 * @author Dan Kogai (https://github.com/dankogai)
 */
const version = '3.7.2';
/**
 * @deprecated use lowercase `version`.
 */
const VERSION = version;
const _hasatob = typeof atob === 'function';
const _hasbtoa = typeof btoa === 'function';
const _hasBuffer = typeof Buffer === 'function';
const _TD = typeof TextDecoder === 'function' ? new TextDecoder() : undefined;
const _TE = typeof TextEncoder === 'function' ? new TextEncoder() : undefined;
const b64ch = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
const b64chs = Array.prototype.slice.call(b64ch);
const b64tab = ((a) => {
    let tab = {};
    a.forEach((c, i) => tab[c] = i);
    return tab;
})(b64chs);
const b64re = /^(?:[A-Za-z\d+\/]{4})*?(?:[A-Za-z\d+\/]{2}(?:==)?|[A-Za-z\d+\/]{3}=?)?$/;
const _fromCC = String.fromCharCode.bind(String);
const _U8Afrom = typeof Uint8Array.from === 'function'
    ? Uint8Array.from.bind(Uint8Array)
    : (it, fn = (x) => x) => new Uint8Array(Array.prototype.slice.call(it, 0).map(fn));
const _mkUriSafe = (src) => src
    .replace(/=/g, '').replace(/[+\/]/g, (m0) => m0 == '+' ? '-' : '_');
const _tidyB64 = (s) => s.replace(/[^A-Za-z0-9\+\/]/g, '');
/**
 * polyfill version of `btoa`
 */
const btoaPolyfill = (bin) => {
    // console.log('polyfilled');
    let u32, c0, c1, c2, asc = '';
    const pad = bin.length % 3;
    for (let i = 0; i < bin.length;) {
        if ((c0 = bin.charCodeAt(i++)) > 255 ||
            (c1 = bin.charCodeAt(i++)) > 255 ||
            (c2 = bin.charCodeAt(i++)) > 255)
            throw new TypeError('invalid character found');
        u32 = (c0 << 16) | (c1 << 8) | c2;
        asc += b64chs[u32 >> 18 & 63]
            + b64chs[u32 >> 12 & 63]
            + b64chs[u32 >> 6 & 63]
            + b64chs[u32 & 63];
    }
    return pad ? asc.slice(0, pad - 3) + "===".substring(pad) : asc;
};
/**
 * does what `window.btoa` of web browsers do.
 * @param {String} bin binary string
 * @returns {string} Base64-encoded string
 */
const _btoa = _hasbtoa ? (bin) => btoa(bin)
    : _hasBuffer ? (bin) => Buffer.from(bin, 'binary').toString('base64')
        : btoaPolyfill;
const _fromUint8Array = _hasBuffer
    ? (u8a) => Buffer.from(u8a).toString('base64')
    : (u8a) => {
        // cf. https://stackoverflow.com/questions/12710001/how-to-convert-uint8-array-to-base64-encoded-string/12713326#12713326
        const maxargs = 0x1000;
        let strs = [];
        for (let i = 0, l = u8a.length; i < l; i += maxargs) {
            strs.push(_fromCC.apply(null, u8a.subarray(i, i + maxargs)));
        }
        return _btoa(strs.join(''));
    };
/**
 * converts a Uint8Array to a Base64 string.
 * @param {boolean} [urlsafe] URL-and-filename-safe a la RFC4648 §5
 * @returns {string} Base64 string
 */
const fromUint8Array = (u8a, urlsafe = false) => urlsafe ? _mkUriSafe(_fromUint8Array(u8a)) : _fromUint8Array(u8a);
// This trick is found broken https://github.com/dankogai/js-base64/issues/130
// const utob = (src: string) => unescape(encodeURIComponent(src));
// reverting good old fationed regexp
const cb_utob = (c) => {
    if (c.length < 2) {
        var cc = c.charCodeAt(0);
        return cc < 0x80 ? c
            : cc < 0x800 ? (_fromCC(0xc0 | (cc >>> 6))
                + _fromCC(0x80 | (cc & 0x3f)))
                : (_fromCC(0xe0 | ((cc >>> 12) & 0x0f))
                    + _fromCC(0x80 | ((cc >>> 6) & 0x3f))
                    + _fromCC(0x80 | (cc & 0x3f)));
    }
    else {
        var cc = 0x10000
            + (c.charCodeAt(0) - 0xD800) * 0x400
            + (c.charCodeAt(1) - 0xDC00);
        return (_fromCC(0xf0 | ((cc >>> 18) & 0x07))
            + _fromCC(0x80 | ((cc >>> 12) & 0x3f))
            + _fromCC(0x80 | ((cc >>> 6) & 0x3f))
            + _fromCC(0x80 | (cc & 0x3f)));
    }
};
const re_utob = /[\uD800-\uDBFF][\uDC00-\uDFFFF]|[^\x00-\x7F]/g;
/**
 * @deprecated should have been internal use only.
 * @param {string} src UTF-8 string
 * @returns {string} UTF-16 string
 */
const utob = (u) => u.replace(re_utob, cb_utob);
//
const _encode = _hasBuffer
    ? (s) => Buffer.from(s, 'utf8').toString('base64')
    : _TE
        ? (s) => _fromUint8Array(_TE.encode(s))
        : (s) => _btoa(utob(s));
/**
 * converts a UTF-8-encoded string to a Base64 string.
 * @param {boolean} [urlsafe] if `true` make the result URL-safe
 * @returns {string} Base64 string
 */
const encode = (src, urlsafe = false) => urlsafe
    ? _mkUriSafe(_encode(src))
    : _encode(src);
/**
 * converts a UTF-8-encoded string to URL-safe Base64 RFC4648 §5.
 * @returns {string} Base64 string
 */
const base64_encodeURI = (src) => encode(src, true);
// This trick is found broken https://github.com/dankogai/js-base64/issues/130
// const btou = (src: string) => decodeURIComponent(escape(src));
// reverting good old fationed regexp
const re_btou = /[\xC0-\xDF][\x80-\xBF]|[\xE0-\xEF][\x80-\xBF]{2}|[\xF0-\xF7][\x80-\xBF]{3}/g;
const cb_btou = (cccc) => {
    switch (cccc.length) {
        case 4:
            var cp = ((0x07 & cccc.charCodeAt(0)) << 18)
                | ((0x3f & cccc.charCodeAt(1)) << 12)
                | ((0x3f & cccc.charCodeAt(2)) << 6)
                | (0x3f & cccc.charCodeAt(3)), offset = cp - 0x10000;
            return (_fromCC((offset >>> 10) + 0xD800)
                + _fromCC((offset & 0x3FF) + 0xDC00));
        case 3:
            return _fromCC(((0x0f & cccc.charCodeAt(0)) << 12)
                | ((0x3f & cccc.charCodeAt(1)) << 6)
                | (0x3f & cccc.charCodeAt(2)));
        default:
            return _fromCC(((0x1f & cccc.charCodeAt(0)) << 6)
                | (0x3f & cccc.charCodeAt(1)));
    }
};
/**
 * @deprecated should have been internal use only.
 * @param {string} src UTF-16 string
 * @returns {string} UTF-8 string
 */
const btou = (b) => b.replace(re_btou, cb_btou);
/**
 * polyfill version of `atob`
 */
const atobPolyfill = (asc) => {
    // console.log('polyfilled');
    asc = asc.replace(/\s+/g, '');
    if (!b64re.test(asc))
        throw new TypeError('malformed base64.');
    asc += '=='.slice(2 - (asc.length & 3));
    let u24, bin = '', r1, r2;
    for (let i = 0; i < asc.length;) {
        u24 = b64tab[asc.charAt(i++)] << 18
            | b64tab[asc.charAt(i++)] << 12
            | (r1 = b64tab[asc.charAt(i++)]) << 6
            | (r2 = b64tab[asc.charAt(i++)]);
        bin += r1 === 64 ? _fromCC(u24 >> 16 & 255)
            : r2 === 64 ? _fromCC(u24 >> 16 & 255, u24 >> 8 & 255)
                : _fromCC(u24 >> 16 & 255, u24 >> 8 & 255, u24 & 255);
    }
    return bin;
};
/**
 * does what `window.atob` of web browsers do.
 * @param {String} asc Base64-encoded string
 * @returns {string} binary string
 */
const _atob = _hasatob ? (asc) => atob(_tidyB64(asc))
    : _hasBuffer ? (asc) => Buffer.from(asc, 'base64').toString('binary')
        : atobPolyfill;
//
const _toUint8Array = _hasBuffer
    ? (a) => _U8Afrom(Buffer.from(a, 'base64'))
    : (a) => _U8Afrom(_atob(a), c => c.charCodeAt(0));
/**
 * converts a Base64 string to a Uint8Array.
 */
const toUint8Array = (a) => _toUint8Array(_unURI(a));
//
const _decode = _hasBuffer
    ? (a) => Buffer.from(a, 'base64').toString('utf8')
    : _TD
        ? (a) => _TD.decode(_toUint8Array(a))
        : (a) => btou(_atob(a));
const _unURI = (a) => _tidyB64(a.replace(/[-_]/g, (m0) => m0 == '-' ? '+' : '/'));
/**
 * converts a Base64 string to a UTF-8 string.
 * @param {String} src Base64 string.  Both normal and URL-safe are supported
 * @returns {string} UTF-8 string
 */
const decode = (src) => _decode(_unURI(src));
/**
 * check if a value is a valid Base64 string
 * @param {String} src a value to check
  */
const isValid = (src) => {
    if (typeof src !== 'string')
        return false;
    const s = src.replace(/\s+/g, '').replace(/={0,2}$/, '');
    return !/[^\s0-9a-zA-Z\+/]/.test(s) || !/[^\s0-9a-zA-Z\-_]/.test(s);
};
//
const _noEnum = (v) => {
    return {
        value: v, enumerable: false, writable: true, configurable: true
    };
};
/**
 * extend String.prototype with relevant methods
 */
const extendString = function () {
    const _add = (name, body) => Object.defineProperty(String.prototype, name, _noEnum(body));
    _add('fromBase64', function () { return decode(this); });
    _add('toBase64', function (urlsafe) { return encode(this, urlsafe); });
    _add('toBase64URI', function () { return encode(this, true); });
    _add('toBase64URL', function () { return encode(this, true); });
    _add('toUint8Array', function () { return toUint8Array(this); });
};
/**
 * extend Uint8Array.prototype with relevant methods
 */
const extendUint8Array = function () {
    const _add = (name, body) => Object.defineProperty(Uint8Array.prototype, name, _noEnum(body));
    _add('toBase64', function (urlsafe) { return fromUint8Array(this, urlsafe); });
    _add('toBase64URI', function () { return fromUint8Array(this, true); });
    _add('toBase64URL', function () { return fromUint8Array(this, true); });
};
/**
 * extend Builtin prototypes with relevant methods
 */
const extendBuiltins = () => {
    extendString();
    extendUint8Array();
};
const gBase64 = {
    version: version,
    VERSION: VERSION,
    atob: _atob,
    atobPolyfill: atobPolyfill,
    btoa: _btoa,
    btoaPolyfill: btoaPolyfill,
    fromBase64: decode,
    toBase64: encode,
    encode: encode,
    encodeURI: base64_encodeURI,
    encodeURL: base64_encodeURI,
    utob: utob,
    btou: btou,
    decode: decode,
    isValid: isValid,
    fromUint8Array: fromUint8Array,
    toUint8Array: toUint8Array,
    extendString: extendString,
    extendUint8Array: extendUint8Array,
    extendBuiltins: extendBuiltins,
};
// makecjs:CUT //




















// and finally,


// EXTERNAL MODULE: ../node_modules/@urql/core/dist/urql-core.mjs
var urql_core = __webpack_require__(70463);
// EXTERNAL MODULE: ./utils/constants.ts
var constants = __webpack_require__(79758);
// EXTERNAL MODULE: ./utils/clientLogger.ts
var clientLogger = __webpack_require__(50222);
;// CONCATENATED MODULE: ./gql/exchanges/auth/token.ts
/* provided dependency */ var token_Buffer = __webpack_require__(30816)["Buffer"];



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment tokenPayload on TokenPayload {\n    __typename\n    accessToken\n    refreshToken\n    customerId\n    uniqueShopperId\n    customerContext {\n      __typename\n      hashKey\n      customerGroups\n    }\n    user {\n      customerNo\n      email\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation GuestLogon {\n    guestLogon {\n      ...tokenPayload\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation RefreshLogon($input: RefreshLogonInput!) {\n    refreshLogon(input: $input) {\n      ...tokenPayload\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}





// renew token if expires in less than X minute(s)
var EXPIRY_THRESHOLD = 1000 * 60 * 5;
var TOKEN_PAYLOAD_FRAGMENT = (0,urql_core/* gql */.Ps)(_templateObject());
var GUEST_LOGON_MUTATION = (0,urql_core/* gql */.Ps)(_templateObject1(), TOKEN_PAYLOAD_FRAGMENT);
var REFRESH_LOGON_MUTATION = (0,urql_core/* gql */.Ps)(_templateObject2(), TOKEN_PAYLOAD_FRAGMENT);
function getGuestToken(_) {
    return _getGuestToken.apply(this, arguments);
}
function _getGuestToken() {
    _getGuestToken = (0,_async_to_generator/* default */.Z)(function(param) {
        var mutate, getToken, result, _tmp, err, _tmp1;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    mutate = param.mutate;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    getToken = function() {
                        var _ref = (0,_async_to_generator/* default */.Z)(function() {
                            var ref, guestLogonResult, _tmp, Sentry, data, _tmp1;
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _tmp = {};
                                        return [
                                            4,
                                            mutate(GUEST_LOGON_MUTATION, _tmp)
                                        ];
                                    case 1:
                                        guestLogonResult = _state.sent();
                                        return [
                                            4,
                                            __webpack_require__.e(/* import() */ 5151).then(__webpack_require__.bind(__webpack_require__, 35151))
                                        ];
                                    case 2:
                                        Sentry = _state.sent().default;
                                        data = guestLogonResult === null || guestLogonResult === void 0 ? void 0 : (ref = guestLogonResult.data) === null || ref === void 0 ? void 0 : ref.guestLogon;
                                        _tmp1 = {};
                                        if (!data) {
                                            Sentry === null || Sentry === void 0 ? void 0 : Sentry.addBreadcrumb((_tmp1.message = "Guest logon returned no data", _tmp1));
                                            if (guestLogonResult.error) {
                                                throw guestLogonResult.error;
                                            }
                                            throw new Error("Guest logon returned no data");
                                        }
                                        return [
                                            2,
                                            data
                                        ];
                                }
                            });
                        });
                        return function getToken() {
                            return _ref.apply(this, arguments);
                        };
                    }();
                    _tmp = {};
                    return [
                        4,
                        (0,backoff.backOff)(getToken, (_tmp.jitter = "full", _tmp.numOfAttempts = 3, _tmp.retry = function() {
                            var _ref = (0,_async_to_generator/* default */.Z)(function(e, attemptNumber) {
                                var Sentry, _tmp;
                                return (0,tslib_es6.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            return [
                                                4,
                                                __webpack_require__.e(/* import() */ 5151).then(__webpack_require__.bind(__webpack_require__, 35151))
                                            ];
                                        case 1:
                                            Sentry = _state.sent().default;
                                            _tmp = {};
                                            Sentry === null || Sentry === void 0 ? void 0 : Sentry.addBreadcrumb((_tmp.message = "authExchange: ".concat(constants/* isServer */.sk ? "server" : "client", " guest logon failed attempt #").concat(attemptNumber), _tmp.data = {
                                                e: e
                                            }, _tmp));
                                            // will retry until max attempts is reached
                                            return [
                                                2,
                                                true
                                            ];
                                    }
                                });
                            });
                            return function(e, attemptNumber) {
                                return _ref.apply(this, arguments);
                            };
                        }(), _tmp))
                    ];
                case 2:
                    result = _state.sent();
                    return [
                        2,
                        result
                    ];
                case 3:
                    err = _state.sent();
                    _tmp1 = {};
                    clientLogger/* clientLogger.error */.u.error((_tmp1.err = err, _tmp1), "authExchange: ".concat(constants/* isServer */.sk ? "server" : "client", " guest logon failed"));
                    throw err;
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return _getGuestToken.apply(this, arguments);
}
function decodeToken(token) {
    if (!token) return null;
    try {
        if (constants/* isServer */.sk) {
            var buff = token_Buffer.from(token.split(".")[1], "base64");
            return JSON.parse(buff.toString("ascii"));
        } else {
            return JSON.parse(decode(token.split(".")[1]));
        }
    } catch (err) {
        clientLogger/* clientLogger.error */.u.error({
            err: err
        }, "authExchange: failed to decode token");
        return null;
    }
}
function isTokenExpired(token) {
    var decodedToken = decodeToken(token);
    return !(decodedToken === null || decodedToken === void 0 ? void 0 : decodedToken.exp) || Date.now() + EXPIRY_THRESHOLD > decodedToken.exp * 1000;
}
function refreshAuthToken(_) {
    return _refreshAuthToken.apply(this, arguments);
}
function _refreshAuthToken() {
    _refreshAuthToken = (0,_async_to_generator/* default */.Z)(function(param) {
        var refreshToken, mutate, _tmp, ref, refreshLogonResult, _tmp1, Sentry, data, _tmp2, err, _tmp3;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    refreshToken = param.refreshToken, mutate = param.mutate;
                    _tmp = {};
                    if (!refreshToken) {
                        clientLogger/* clientLogger.warn */.u.warn(_tmp, "authExchange: refresh called without token");
                        return [
                            2,
                            null
                        ];
                    }
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    _tmp1 = {};
                    return [
                        4,
                        mutate(REFRESH_LOGON_MUTATION, (_tmp1.input = {
                            refreshToken: refreshToken
                        }, _tmp1))
                    ];
                case 2:
                    refreshLogonResult = _state.sent();
                    return [
                        4,
                        __webpack_require__.e(/* import() */ 5151).then(__webpack_require__.bind(__webpack_require__, 35151))
                    ];
                case 3:
                    Sentry = _state.sent().default;
                    data = refreshLogonResult === null || refreshLogonResult === void 0 ? void 0 : (ref = refreshLogonResult.data) === null || ref === void 0 ? void 0 : ref.refreshLogon;
                    _tmp2 = {};
                    if (!data) {
                        Sentry.addBreadcrumb((_tmp2.message = "Refresh logon returned no data", _tmp2));
                        if (refreshLogonResult.error) {
                            throw refreshLogonResult.error;
                        }
                        throw new Error("Refresh logon returned no data");
                    }
                    return [
                        2,
                        data
                    ];
                case 4:
                    err = _state.sent();
                    _tmp3 = {};
                    clientLogger/* clientLogger.error */.u.error((_tmp3.err = err, _tmp3), "authExchange: refresh logon failed");
                    // intentionally return null
                    return [
                        2,
                        null
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return _refreshAuthToken.apply(this, arguments);
}


/***/ }),

/***/ 12352:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ ADDRESS_FRAGMENT; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19989);
/* harmony import */ var urql__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70463);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment addressFields on Address {\n    id\n    title\n    firstName\n    lastName\n    firstNamePronunciation\n    lastNamePronunciation\n    address1\n    address2\n    stateCode\n    city\n    countryCode\n    phone\n    preferred\n    postalCode\n    streetNumber\n    salutation\n    companyName\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var ADDRESS_FRAGMENT = (0,urql__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject());


/***/ }),

/***/ 38012:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ SAVED_AMBASSADOR_CARD_FRAGMENT; },
/* harmony export */   "e": function() { return /* binding */ AMBASSADOR_CARD_PAYMENT_FRAGMENT; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19989);
/* harmony import */ var urql__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70463);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment ambassadorCardFields on SavedAmbassadorCard {\n    id\n    maskedNumber\n    name\n    preferred\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment ambassadorCardPaymentFields on PaymentInstrument {\n    ... on AmbassadorCard {\n      __typename\n      id\n      maskedNumber\n      amount\n      authorizationStatus\n      type\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}

var SAVED_AMBASSADOR_CARD_FRAGMENT = (0,urql__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject());
var AMBASSADOR_CARD_PAYMENT_FRAGMENT = (0,urql__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject1());


/***/ }),

/***/ 84047:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ ORDER_CONFIRMATION_FRAGMENT; },
/* harmony export */   "w": function() { return /* binding */ PAYMENT_INSTRUMENT_FRAGMENT; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19989);
/* harmony import */ var urql__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70463);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment orderPaymentInstrumentFields on BaseOrder {\n    paymentInstruments {\n      ... on Adyen {\n        id\n        __typename\n        amount\n        type\n      }\n      ... on AdyenKlarna {\n        id\n        __typename\n        amount\n        type\n      }\n      ... on AdyenKlarnaAccount {\n        id\n        __typename\n        amount\n        type\n      }\n      ... on AmazonPay {\n        __typename\n        id\n        type\n      }\n      ... on AmbassadorCard {\n        id\n        __typename\n        authorizationStatus\n        maskedNumber\n        amount\n        type\n      }\n      ... on Scheme {\n        id\n        amount\n        authorizationStatus\n        type\n        __typename\n      }\n      ... on CreditCard {\n        id\n        amount\n        maskedNumber\n        cardType\n        authorizationStatus\n        type\n        __typename\n      }\n      ... on AfterPay {\n        id\n        authorizationStatus\n        type\n        __typename\n      }\n\n      ... on PayPay {\n        id\n        authorizationStatus\n        type\n        __typename\n      }\n      ... on ApplePay {\n        id\n        authorizationStatus\n        type\n        __typename\n      }\n      ... on PayPal {\n        id\n        authorizationStatus\n        type\n        __typename\n      }\n      ... on GiftCard {\n        id\n        __typename\n        maskedNumber\n        authorizationStatus\n        amount\n        type\n      }\n      ... on CashOnDelivery {\n        id\n        amount\n        type\n        __typename\n      }\n      ... on UPI {\n        id\n        amount\n        authorizationStatus\n        type\n        __typename\n      }\n      ... on Wallet {\n        id\n        amount\n        authorizationStatus\n        type\n        __typename\n      }\n      ... on OnlineBanking {\n        id\n        amount\n        authorizationStatus\n        type\n        __typename\n      }\n      ... on PayTm {\n        id\n        authorizationStatus\n        amount\n        type\n        __typename\n      }\n      ... on StoreCreditInstrument {\n        id\n        amount\n        type\n        __typename\n      }\n      ... on ZipPay {\n        id\n        type\n        __typename\n      }\n      ... on WechatPay {\n        id\n        type\n        __typename\n      }\n      ... on Alipay {\n        id\n        type\n        __typename\n      }\n      ... on KlarnaPayments {\n        id\n        type\n        amount\n        __typename\n      }\n      ... on Razorpay {\n        id\n        amount\n        type\n        __typename\n      }\n      ... on AmazonPay {\n        id\n        amount\n        type\n        __typename\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment orderAddress on OrderAddress {\n    id\n    salutation\n    firstName\n    lastName\n    firstNamePronunciation\n    lastNamePronunciation\n    companyName\n    address1\n    address2\n    streetNumber\n    postalCode\n    city\n    countryCode\n    stateCode\n    phone\n  }\n  fragment orderConfirmationFields on BaseOrder {\n    billingAddress {\n      ...orderAddress\n    }\n    shipment {\n      id\n      shipmentMethod {\n        id\n        name\n        price\n      }\n      address {\n        ...orderAddress\n      }\n      deliveryDate\n      deliveryTimeDisplayText\n    }\n    customer {\n      email\n      id\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}

var PAYMENT_INSTRUMENT_FRAGMENT = (0,urql__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject());
var ORDER_CONFIRMATION_FRAGMENT = (0,urql__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject1());


/***/ }),

/***/ 32317:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$F": function() { return /* binding */ CART_PRODUCT_ITEM_FRAGMENT; },
/* harmony export */   "B$": function() { return /* binding */ PRODUCT_CART_ITEM_ANALYTICS_DIMENSIONS_FIELDS; },
/* harmony export */   "Gd": function() { return /* binding */ CART_FRAGMENT; },
/* harmony export */   "o6": function() { return /* binding */ CART_AVAILABLE_PAYMENT_METHODS_FRAGMENT; }
/* harmony export */ });
/* unused harmony exports CART_SHIPMENT_METHOD_FRAGMENT, CART_CUSTOMER_FRAGMENT, CART_SHIPMENT_FRAGMENT, CART_BILLING_ADDRESS_FRAGMENT, CART_COSTS_FRAGMENT, CART_PROMO_FRAGMENT, CART_PAYMENT_INSTRUMENTS, CART_GIFT_WITH_PURCHASE_ITEMS_FRAGMENT, CART_SIMPLE_PRODUCT_ITEM_FRAGMENT */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19989);
/* harmony import */ var urql__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70463);
/* harmony import */ var gql_fragments_ambassadorCards__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(38012);
/* harmony import */ var _product__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19404);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment shipmentMethodInfoFields on ShipmentMethodInfo {\n    defaultShipmentMethodId\n    availableShipmentMethods {\n      id\n      name\n      price\n      estimatedShippingDate {\n        min\n        max\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment customerFields on Cart {\n    customer {\n      id\n      email\n      customerNo\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment shipmentFields on Shipment {\n    id\n    shipmentMethod {\n      id\n      name\n      price\n    }\n    address {\n      id\n      firstName\n      lastName\n      address1\n      address2\n      postalCode\n      city\n      countryCode\n      stateCode\n      phone\n      firstNamePronunciation\n      lastNamePronunciation\n      streetNumber\n      salutation\n      companyName\n    }\n    deliveryDate\n    deliveryTimeCode\n    deliveryTimeDisplayText\n    authorityToLeave {\n      leaveAt\n      deliveryInstructions\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment billingAddressFields on Cart {\n    billingAddress {\n      firstName\n      lastName\n      address1\n      address2\n      postalCode\n      city\n      countryCode\n      stateCode\n      phone\n      id\n      firstNamePronunciation\n      lastNamePronunciation\n      streetNumber\n      salutation\n      companyName\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment cartCostsFields on Cart {\n    subTotal\n    shippingCosts\n    estimatedShippingCosts\n    taxTotal\n    taxation\n    estimatedTotal\n    amountRemaining\n    customizationAdjustment {\n      price\n    }\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment cartPromoFields on Cart {\n    couponItems {\n      code\n      couponItemId\n      statusCode\n      valid\n      discountAmount\n      calloutMessage\n      couponFamily\n      couponType\n    }\n    orderAdjustments {\n      promotionId\n      itemText\n      price\n      couponCode\n    }\n    shippingAdjustments {\n      promotionId\n      itemText\n      price\n      couponCode\n    }\n    productAdjustments {\n      promotionId\n      itemText\n      price\n      couponCode\n    }\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment cartPaymentInstrumentsFields on PaymentInstrument {\n    ... on AfterPay {\n      __typename\n      id\n      type\n    }\n    ... on AmazonPay {\n      __typename\n      id\n      type\n    }\n    ... on ApplePay {\n      __typename\n      id\n      authorizationStatus\n      type\n    }\n    ... on CashOnDelivery {\n      __typename\n      id\n      type\n    }\n    ... on CreditCard {\n      __typename\n      id\n      maskedNumber\n      expirationMonth\n      expirationYear\n      holder\n      type\n    }\n    ... on GiftCard {\n      __typename\n      id\n      maskedNumber\n      amount\n      type\n    }\n    ... on OnlineBanking {\n      __typename\n      id\n      type\n    }\n    ... on PayPal {\n      __typename\n      id\n      type\n    }\n    ... on PayPay {\n      __typename\n      id\n      type\n    }\n    ... on PayTm {\n      __typename\n      id\n      type\n    }\n    ... on Razorpay {\n      __typename\n      id\n      type\n    }\n    ... on Scheme {\n      __typename\n      id\n      type\n    }\n    ... on StoreCreditInstrument {\n      __typename\n      id\n      type\n      amount\n    }\n    ... on UPI {\n      __typename\n      id\n      type\n    }\n    ... on Wallet {\n      __typename\n      id\n      type\n    }\n    ...ambassadorCardPaymentFields\n  }\n\n  ",
        "\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment giftWithPurchaseFields on GiftWithPurchasePromo {\n    id\n    allowedQuantity\n    promotionId\n    calloutMessage\n    gwpTitle\n    details\n    fullfilled\n    availableProducts {\n      ... on VariantProduct {\n        __typename\n        masterId\n        id\n        name\n        price\n        images {\n          href\n          alt\n        }\n        inventory\n        primaryCategoryId\n        styleNumber\n        colorValue\n        colorName\n        size {\n          label\n          value\n        }\n      }\n      ... on ProductWithExclusion {\n        __typename\n        excludedColors\n        product {\n          id\n          name\n          variations {\n            id\n            colorValue\n            colorName\n            salePrice\n            price\n            productPrice {\n              price\n              salePrice\n              promotionPrice\n              bestPrice\n            }\n            preview\n            displayOutOfStock {\n              displayValue\n              soldout\n            }\n            orderable\n            sizeGroups {\n              label\n              description\n              sizes {\n                id\n                label\n                value\n                productId\n                orderable\n                maxOrderableQuantity\n              }\n            }\n            images {\n              href\n              alt\n            }\n          }\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment productCartItemFields on CartItem {\n    ... on GiftCardCartItem {\n      id\n      imageUrl\n      amount\n      recipientEmail\n      recipientName\n      senderName\n      __typename\n    }\n    ... on ProductCartItem {\n      __typename\n      id\n      inCartPrice\n      bonusItemId\n      restricted\n      quantity\n      purchasedPrice {\n        price\n        promotionPrice\n      }\n      adjustments {\n        promotionId\n        itemText\n        price\n        couponCode\n        promotion {\n          id\n          calloutMessage\n          name\n        }\n        __typename\n      }\n      product {\n        masterId\n        id\n        isAppExclusive\n        appOnlyDateTimeFrom\n        appOnlyDateTimeTo\n        promotionExclusion\n        name\n        header\n        subHeader\n        price\n        brand\n        salePrice\n        productPrice {\n          price\n          salePrice\n          promotionPrice\n          isSalePriceElapsed\n          tax\n          taxRate\n          bestPrice\n        }\n        imageUrl\n        inventory\n        maxOrderableQuantity\n        primaryCategoryId\n        styleNumber\n        ean\n        upc\n        colorValue\n        colorName\n        displayOutOfStock {\n          soldout\n          backsoon\n          presale\n          validTo\n        }\n        size {\n          label\n          value\n        }\n        offline\n        orderable\n        assortmentAvailability\n      }\n      customizationName\n      customizationNumber\n      customizationCost\n      quantityInCart\n      stockMessage\n      stockMessageCode\n      hasStock\n      adjustQuantityMessage\n      personalizationSurcharge\n      personalizationImageURL\n      personalizationLargeImageURL\n      personalizationName\n      personalizationNumber\n      personalizationPrice\n      personalizationRecipeID\n      popularityCount\n      estimatedDeliveryDate {\n        id\n        carrierCode\n        eddBegin\n        eddEnd\n        errorResponse {\n          code\n          message\n        }\n        serviceCode\n        timeZoneName\n      }\n    }\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment productCartSimpleItemFields on CartItem {\n    ... on GiftCardCartItem {\n      id\n      imageUrl\n      amount\n      recipientEmail\n      recipientName\n      senderName\n      __typename\n    }\n    ... on ProductCartItem {\n      __typename\n      id\n      inCartPrice\n      bonusItemId\n      restricted\n      quantity\n      purchasedPrice {\n        price\n        promotionPrice\n      }\n      adjustments {\n        promotionId\n        itemText\n        price\n        couponCode\n        promotion {\n          id\n          calloutMessage\n          name\n        }\n        __typename\n      }\n      product {\n        masterId\n        id\n        isAppExclusive\n        appOnlyDateTimeFrom\n        appOnlyDateTimeTo\n        promotionExclusion\n        name\n        header\n        subHeader\n        price\n        brand\n        salePrice\n        productPrice {\n          price\n          salePrice\n          promotionPrice\n          isSalePriceElapsed\n          tax\n          taxRate\n          bestPrice\n        }\n        imageUrl\n        inventory\n        maxOrderableQuantity\n        primaryCategoryId\n        styleNumber\n        ean\n        upc\n        colorValue\n        colorName\n        displayOutOfStock {\n          soldout\n          backsoon\n          presale\n          validTo\n        }\n        size {\n          label\n          value\n        }\n        offline\n        orderable\n        assortmentAvailability\n      }\n      customizationName\n      customizationNumber\n      customizationCost\n      quantityInCart\n      stockMessage\n      stockMessageCode\n      hasStock\n      adjustQuantityMessage\n      personalizationSurcharge\n      personalizationImageURL\n      personalizationLargeImageURL\n      personalizationName\n      personalizationNumber\n      personalizationPrice\n      personalizationRecipeID\n      popularityCount\n      estimatedDeliveryDate {\n        id\n        carrierCode\n        eddBegin\n        eddEnd\n        errorResponse {\n          code\n          message\n        }\n        serviceCode\n        timeZoneName\n      }\n    }\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment productCartItemAnalyticsDimensionsFields on CartItem {\n    ... on ProductCartItem {\n      product {\n        ...productAnalyticsDimensionsFields\n      }\n      taxRate\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment availablePaymentMethodsFields on PaymentMethod {\n    id\n    cards {\n      id\n      cardType\n      name\n    }\n    bank {\n      id\n      name\n    }\n    wallet {\n      id\n      name\n    }\n    description\n    name\n    paymentProcessorId\n    c_additionalFee\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment cartFields on Cart {\n    id\n    productCount\n    amountRemainingForFreeShipping\n    basketInStockStatus\n    hasFreeShipping\n    hasOfflineProducts\n    preOrderDeliveryDate\n    shippingSurcharge {\n      amount\n      label\n      tooltip\n    }\n    products {\n      ...productCartItemFields\n    }\n    giftWithPurchases {\n      ...giftWithPurchaseFields\n    }\n    paymentInstruments {\n      ...cartPaymentInstrumentsFields\n    }\n    ...customerFields\n    ...cartCostsFields\n    ...cartPromoFields\n    ...billingAddressFields\n    shipment {\n      ...shipmentFields\n    }\n    shipmentMethodInfo {\n      ...shipmentMethodInfoFields\n    }\n    longTermPreOrder {\n      hasLongTermPreOrderItem\n      longTermPreOrderItemPaymentMethods\n    }\n    availablePaymentMethods {\n      ...availablePaymentMethodsFields\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}



var CART_SHIPMENT_METHOD_FRAGMENT = (0,urql__WEBPACK_IMPORTED_MODULE_3__/* .gql */ .Ps)(_templateObject());
var CART_CUSTOMER_FRAGMENT = (0,urql__WEBPACK_IMPORTED_MODULE_3__/* .gql */ .Ps)(_templateObject1());
var CART_SHIPMENT_FRAGMENT = (0,urql__WEBPACK_IMPORTED_MODULE_3__/* .gql */ .Ps)(_templateObject2());
var CART_BILLING_ADDRESS_FRAGMENT = (0,urql__WEBPACK_IMPORTED_MODULE_3__/* .gql */ .Ps)(_templateObject3());
var CART_COSTS_FRAGMENT = (0,urql__WEBPACK_IMPORTED_MODULE_3__/* .gql */ .Ps)(_templateObject4());
var CART_PROMO_FRAGMENT = (0,urql__WEBPACK_IMPORTED_MODULE_3__/* .gql */ .Ps)(_templateObject5());
var CART_PAYMENT_INSTRUMENTS = (0,urql__WEBPACK_IMPORTED_MODULE_3__/* .gql */ .Ps)(_templateObject6(), gql_fragments_ambassadorCards__WEBPACK_IMPORTED_MODULE_1__/* .AMBASSADOR_CARD_PAYMENT_FRAGMENT */ .e);
var CART_GIFT_WITH_PURCHASE_ITEMS_FRAGMENT = (0,urql__WEBPACK_IMPORTED_MODULE_3__/* .gql */ .Ps)(_templateObject7());
var CART_PRODUCT_ITEM_FRAGMENT = (0,urql__WEBPACK_IMPORTED_MODULE_3__/* .gql */ .Ps)(_templateObject8());
var CART_SIMPLE_PRODUCT_ITEM_FRAGMENT = (0,urql__WEBPACK_IMPORTED_MODULE_3__/* .gql */ .Ps)(_templateObject9());
var PRODUCT_CART_ITEM_ANALYTICS_DIMENSIONS_FIELDS = (0,urql__WEBPACK_IMPORTED_MODULE_3__/* .gql */ .Ps)(_templateObject10(), _product__WEBPACK_IMPORTED_MODULE_2__/* .PRODUCT_ANALYTICS_DIMENSIONS_FRAGMENT */ .Xs);
var CART_AVAILABLE_PAYMENT_METHODS_FRAGMENT = (0,urql__WEBPACK_IMPORTED_MODULE_3__/* .gql */ .Ps)(_templateObject11());
var CART_FRAGMENT = (0,urql__WEBPACK_IMPORTED_MODULE_3__/* .gql */ .Ps)(_templateObject12(), CART_CUSTOMER_FRAGMENT, CART_BILLING_ADDRESS_FRAGMENT, CART_COSTS_FRAGMENT, CART_PRODUCT_ITEM_FRAGMENT, CART_PROMO_FRAGMENT, CART_PAYMENT_INSTRUMENTS, CART_GIFT_WITH_PURCHASE_ITEMS_FRAGMENT, CART_SHIPMENT_FRAGMENT, CART_SHIPMENT_METHOD_FRAGMENT, CART_AVAILABLE_PAYMENT_METHODS_FRAGMENT);


/***/ }),

/***/ 19404:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EN": function() { return /* binding */ MANDATORY_VARIANT_FIELDS; },
/* harmony export */   "MI": function() { return /* binding */ PDP_MANDATORY_EXTRA_VARIANT_FIELDS; },
/* harmony export */   "Xs": function() { return /* binding */ PRODUCT_ANALYTICS_DIMENSIONS_FRAGMENT; },
/* harmony export */   "YP": function() { return /* binding */ MANDATORY_MASTER_FIELDS; },
/* harmony export */   "gm": function() { return /* binding */ SIZES_FRAGMENT; },
/* harmony export */   "uQ": function() { return /* binding */ PDP_MANDATORY_VARIANT_FIELDS; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19989);
/* harmony import */ var urql__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70463);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment mandatoryVariantFields on Variant {\n    id\n    masterId\n    variantId\n    name\n    header\n    subHeader\n    price\n    colorValue\n    colorName\n    ean\n    sizeGroups {\n      label\n      description\n      sizes {\n        id\n        label\n        value\n        productId\n        orderable\n        maxOrderableQuantity\n      }\n    }\n    preview\n    images {\n      alt\n      href\n      verticalImageHref\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment pdpMandatoryVariantFields on Variant {\n    id\n    masterId\n    variantId\n    name\n    header\n    subHeader\n    price\n    colorValue\n    colorName\n    ean\n    preview\n    images {\n      alt\n      href\n      verticalImageHref\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment pdpMandatoryExtraVariantFields on Variant {\n    id\n    sizeGroups {\n      label\n      description\n      sizes {\n        id\n        label\n        value\n        productId\n        orderable\n        maxOrderableQuantity\n      }\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment mandatoryMasterFields on Product {\n    name\n    id\n    header\n    subHeader\n    orderableColorCount\n    displayOutOfStock {\n      soldout\n      soldoutWithRecommender\n      comingsoon\n      backsoon\n      presale\n      displayValue\n    }\n    colors {\n      name\n      value\n      image {\n        href\n        verticalImageHref\n        alt\n      }\n    }\n    image {\n      href\n      verticalImageHref\n      alt\n    }\n    showExploreCollectionCTA\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment sizes on Product {\n    productMeasurements {\n      metric\n      imperial\n    }\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment productAnalyticsDimensionsFields on VariantProduct {\n    colorDescription\n    sportName\n    technology\n    gender\n    ageGroup\n    lineName\n    businessUnit\n    businessSegment\n    businessSubSegment\n    division\n    articleGroup\n    articleType\n    franchise\n    collectionMark\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}

// This fragment has all the non-optional fields. This must be shared between PLP product nodes and pdp queries
// so the cahce will not treat the entry as a miss.
var MANDATORY_VARIANT_FIELDS = (0,urql__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject());
var PDP_MANDATORY_VARIANT_FIELDS = (0,urql__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject1());
var PDP_MANDATORY_EXTRA_VARIANT_FIELDS = (0,urql__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject2());
// This fragment has all the non-optional fields. This must be shared between PLP product nodes and pdp queries
// so the cahce will not treat the entry as a miss.
var MANDATORY_MASTER_FIELDS = (0,urql__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject3());
var SIZES_FRAGMENT = (0,urql__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject4());
var PRODUCT_ANALYTICS_DIMENSIONS_FRAGMENT = (0,urql__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject5());


/***/ }),

/***/ 912:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ STANDARD_ORDER_DETAILS_FRAGMENT; },
/* harmony export */   "z": function() { return /* binding */ ORDER_PREVIEW_FRAGMENT; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19989);
/* harmony import */ var urql__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70463);
/* harmony import */ var gql_fragments_cart__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32317);
/* harmony import */ var gql_fragments_baseOrder__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(84047);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment orderPreviewFields on StandardOrder {\n    orderNo\n    createdAt\n    currency\n    orderStatus {\n      code\n      label\n    }\n    estimatedTotal\n    isReturnable\n    shipment {\n      address {\n        id\n        firstName\n        lastName\n        postalCode\n        salutation\n      }\n    }\n    refundInformation\n    products {\n      ... on ProductCartItem {\n        __typename\n        id\n        quantity\n        inCartPrice\n        purchasedPrice {\n          price\n          promotionPrice\n        }\n        product {\n          id\n          name\n          header\n          subHeader\n          colorValue\n          colorName\n          masterId\n          images {\n            href\n            alt\n          }\n          styleNumber\n          offline\n          orderable\n        }\n        personalizationImageURL\n      }\n      ... on GiftCardCartItem {\n        id\n        imageUrl\n        amount\n        recipientEmail\n        recipientName\n        senderName\n        __typename\n      }\n    }\n    customer {\n      email\n      id\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment standardOrderDetailsFields on StandardOrder {\n    __typename\n    orderNo\n    orderToken\n    status\n    orderStatus {\n      code\n      label\n    }\n    refundInformation\n    trackingNumber\n    isReturnable\n    statuses {\n      status\n      label\n      order\n    }\n    taxTotal\n    taxation\n    createdAt\n    currency\n    oms {\n      trackingLink\n    }\n    subTotal\n    shippingCosts\n    estimatedTotal\n    gmoRedirectUrl\n    gmoChallengeUrl\n    gmoFlow\n    gmoAccessID\n    gmoAccessPass\n    promoDiscountValue\n    shippingSurcharge {\n      amount\n      label\n      tooltip\n    }\n    orderAdjustments {\n      promotionId\n      itemText\n      price\n      couponCode\n    }\n    shippingAdjustments {\n      promotionId\n      itemText\n      price\n      couponCode\n    }\n    couponItems {\n      code\n      couponItemId\n      statusCode\n      valid\n    }\n    products {\n      ...productCartItemFields\n    }\n    ...orderPaymentInstrumentFields\n    ...orderConfirmationFields\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var ORDER_PREVIEW_FRAGMENT = (0,urql__WEBPACK_IMPORTED_MODULE_3__/* .gql */ .Ps)(_templateObject());
var STANDARD_ORDER_DETAILS_FRAGMENT = (0,urql__WEBPACK_IMPORTED_MODULE_3__/* .gql */ .Ps)(_templateObject1(), gql_fragments_cart__WEBPACK_IMPORTED_MODULE_1__/* .CART_PRODUCT_ITEM_FRAGMENT */ .$F, gql_fragments_baseOrder__WEBPACK_IMPORTED_MODULE_2__/* .ORDER_CONFIRMATION_FRAGMENT */ .c, gql_fragments_baseOrder__WEBPACK_IMPORTED_MODULE_2__/* .PAYMENT_INSTRUMENT_FRAGMENT */ .w);


/***/ }),

/***/ 87560:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ USER_FRAGMENT; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19989);
/* harmony import */ var urql__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70463);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment userFields on User {\n    id\n    customerNo\n    creationDate\n    birthday\n    firstName\n    lastName\n    firstNamePronunciation\n    lastNamePronunciation\n    email\n    phoneNumber\n    gender\n    birthday\n    smsContactNumber\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var USER_FRAGMENT = (0,urql__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject());


/***/ }),

/***/ 46350:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ WISHLIST_FRAGMENT; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19989);
/* harmony import */ var urql__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70463);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment wishListFields on WishList {\n    id\n    items {\n      __typename\n      id\n      quantity\n      creationDate\n      product {\n        id\n        name\n        header\n        subHeader\n        masterId\n        orderable\n        inventory\n        displayOutOfStock {\n          displayValue\n          presale\n          validTo\n        }\n        price\n        salePrice\n        productPrice {\n          price\n          salePrice\n          promotionPrice\n          isSalePriceElapsed\n          tax\n          taxRate\n          bestPrice\n        }\n        images {\n          href\n          alt\n        }\n        styleNumber\n        colorValue\n        colorName\n        size {\n          label\n          value\n        }\n        offline\n        isAppExclusive\n        appOnlyDateTimeFrom\n        appOnlyDateTimeTo\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var WISHLIST_FRAGMENT = (0,urql__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject());


/***/ }),

/***/ 66072:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ SIMPLE_CART_QUERY; },
/* harmony export */   "P": function() { return /* binding */ CART_QUERY; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19989);
/* harmony import */ var urql__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70463);
/* harmony import */ var gql_fragments_cart__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32317);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query Cart {\n    activeCart {\n      ...cartFields\n      availablePaymentMethods {\n        ...availablePaymentMethodsFields\n      }\n      isMixedCartAllowed\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query SimpleCart {\n    activeCart {\n      id\n      productCount\n      isMixedCartAllowed\n      basketInStockStatus\n      estimatedTotal\n      subTotal\n      products {\n        ...productCartItemFields\n      }\n      customer {\n        email\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var CART_QUERY = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject(), gql_fragments_cart__WEBPACK_IMPORTED_MODULE_1__/* .CART_FRAGMENT */ .Gd, gql_fragments_cart__WEBPACK_IMPORTED_MODULE_1__/* .CART_AVAILABLE_PAYMENT_METHODS_FRAGMENT */ .o6);
var SIMPLE_CART_QUERY = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject1(), gql_fragments_cart__WEBPACK_IMPORTED_MODULE_1__/* .CART_PRODUCT_ITEM_FRAGMENT */ .$F);


/***/ }),

/***/ 15350:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "g0": function() { return /* binding */ ORDER_DETAILS_QUERY; },
  "wc": function() { return /* binding */ ORDER_QUERY; },
  "rV": function() { return /* binding */ SEARCH_ORDER_BY_EMAIL_PHONE_QUERY; },
  "wn": function() { return /* binding */ SEARCH_ORDER_BY_EMAIL_POSTCODE_QUERY; },
  "B9": function() { return /* binding */ SEARCH_ORDER_BY_EMAIL_QUERY; },
  "Os": function() { return /* binding */ SEARCH_ORDER_BY_PHONE_QUERY; }
});

// UNUSED EXPORTS: ORDER_HISTORY_ME_QUERY

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(19989);
// EXTERNAL MODULE: ../node_modules/@urql/core/dist/urql-core.mjs
var urql_core = __webpack_require__(70463);
// EXTERNAL MODULE: ./gql/fragments/baseOrder.ts
var baseOrder = __webpack_require__(84047);
;// CONCATENATED MODULE: ./gql/fragments/nestedOrder.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment nestedOrderDetailsFields on NestedOrder {\n    __typename\n    orderNo\n    status\n    taxTotal\n    subTotal\n    createdAt\n    currency\n    orderStatus {\n      code\n      label\n    }\n    isReturnable\n    ...orderPaymentInstrumentFields\n    ...orderConfirmationFields\n    suborders {\n      __typename\n      orderNo\n      awbNo\n      courierPartner\n      status\n      statuses {\n        status\n        label\n        order\n      }\n      returnBy\n      isReturnable\n      returnUrl\n      products {\n        ... on ProductCartItem {\n          __typename\n          id\n          status\n          inCartPrice\n          bonusItemId\n          restricted\n          quantity\n          purchasedPrice {\n            price\n            promotionPrice\n          }\n          product {\n            masterId\n            id\n            name\n            price\n            salePrice\n            productPrice {\n              price\n              salePrice\n              promotionPrice\n              bestPrice\n            }\n            images {\n              href\n              alt\n            }\n            inventory\n            primaryCategoryId\n            styleNumber\n            colorValue\n            colorName\n            size {\n              label\n              value\n            }\n            offline\n            orderable\n          }\n          productReturn {\n            id\n            returnOrderCode\n            forwardAwb\n            returnAwb\n            transporter\n            channelReturnOrderTime\n            type\n            status\n            statuses {\n              status\n              label\n              order\n            }\n            price\n            quantity\n          }\n        }\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var NESTED_ORDER_DETAILS_FRAGMENT = (0,urql_core/* gql */.Ps)(_templateObject(), baseOrder/* ORDER_CONFIRMATION_FRAGMENT */.c, baseOrder/* PAYMENT_INSTRUMENT_FRAGMENT */.w);

// EXTERNAL MODULE: ./gql/fragments/standardOrder.ts
var standardOrder = __webpack_require__(912);
// EXTERNAL MODULE: ./gql/fragments/address.ts
var address = __webpack_require__(12352);
// EXTERNAL MODULE: ./gql/fragments/user.ts
var user = __webpack_require__(87560);
// EXTERNAL MODULE: ./gql/fragments/cart.ts
var cart = __webpack_require__(32317);
;// CONCATENATED MODULE: ./gql/queries/order.ts

function order_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query Order(\n    $orderNo: String!\n    $includeProductAnalyticsDetails: Boolean = false\n  ) {\n    order(orderNo: $orderNo) {\n      ... on StandardOrder {\n        subTotal\n        shippingCosts\n        shippingSurcharge {\n          amount\n          label\n          tooltip\n        }\n        orderAdjustments {\n          promotionId\n          itemText\n          price\n          couponCode\n        }\n        shippingAdjustments {\n          promotionId\n          itemText\n          price\n          couponCode\n        }\n        couponItems {\n          code\n          couponItemId\n          statusCode\n          valid\n        }\n        orderNo\n        taxTotal\n        taxation\n        estimatedTotal\n        promoDiscountValue\n        revenue @include(if: $includeProductAnalyticsDetails)\n        orderStatus {\n          code\n          label\n        }\n        __typename\n        refundInformation\n        createdAt\n        products {\n          ...productCartItemFields\n          ...productCartItemAnalyticsDimensionsFields\n            @include(if: $includeProductAnalyticsDetails)\n        }\n        ...orderPaymentInstrumentFields\n        ...orderConfirmationFields\n        payPayAsyncResultNoticed\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    order_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query OrderDetails($orderNo: String!) {\n    order(orderNo: $orderNo) {\n      ...standardOrderDetailsFields\n      ...nestedOrderDetailsFields\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query OrderHistoryMe(\n    $from: String\n    $until: String\n    $offset: Int\n    $limit: Int\n  ) {\n    me {\n      ...userFields\n      addresses {\n        ...addressFields\n      }\n      orders(from: $from, until: $until, offset: $offset, limit: $limit) {\n        nodes {\n          ...orderPreviewFields\n        }\n        pageInfo {\n          offset\n          nextOffset\n          totalCount\n        }\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query SearchOrderByPhone($orderNo: String!, $phone: String!) {\n    searchOrderByPhone(orderNo: $orderNo, phone: $phone) {\n      ...standardOrderDetailsFields\n      ...nestedOrderDetailsFields\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query SearchOrderByEmailPostcode(\n    $orderNo: String!\n    $email: String!\n    $postcode: String!\n  ) {\n    searchOrderByEmailPostcode(\n      orderNo: $orderNo\n      email: $email\n      postcode: $postcode\n    ) {\n      ...standardOrderDetailsFields\n      ...nestedOrderDetailsFields\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query SearchOrderByEmail($orderNo: String!, $email: String!) {\n    searchOrderByEmail(orderNo: $orderNo, email: $email) {\n      ...standardOrderDetailsFields\n      ...nestedOrderDetailsFields\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query SearchOrderByEmailPhone(\n    $orderNo: String!\n    $phone: String!\n    $email: String!\n  ) {\n    searchOrderByEmailPhone(orderNo: $orderNo, phone: $phone, email: $email) {\n      ...standardOrderDetailsFields\n      ...nestedOrderDetailsFields\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}







var ORDER_QUERY = (0,urql_core/* gql */.Ps)(order_templateObject(), baseOrder/* ORDER_CONFIRMATION_FRAGMENT */.c, baseOrder/* PAYMENT_INSTRUMENT_FRAGMENT */.w, cart/* CART_PRODUCT_ITEM_FRAGMENT */.$F, cart/* PRODUCT_CART_ITEM_ANALYTICS_DIMENSIONS_FIELDS */.B$);
var ORDER_DETAILS_QUERY = (0,urql_core/* gql */.Ps)(_templateObject1(), standardOrder/* STANDARD_ORDER_DETAILS_FRAGMENT */.K, NESTED_ORDER_DETAILS_FRAGMENT);
var ORDER_HISTORY_ME_QUERY = (0,urql_core/* gql */.Ps)(_templateObject2(), user/* USER_FRAGMENT */.P, address/* ADDRESS_FRAGMENT */.U, standardOrder/* ORDER_PREVIEW_FRAGMENT */.z);
var SEARCH_ORDER_BY_PHONE_QUERY = (0,urql_core/* gql */.Ps)(_templateObject3(), standardOrder/* STANDARD_ORDER_DETAILS_FRAGMENT */.K, NESTED_ORDER_DETAILS_FRAGMENT);
var SEARCH_ORDER_BY_EMAIL_POSTCODE_QUERY = (0,urql_core/* gql */.Ps)(_templateObject4(), standardOrder/* STANDARD_ORDER_DETAILS_FRAGMENT */.K, NESTED_ORDER_DETAILS_FRAGMENT);
var SEARCH_ORDER_BY_EMAIL_QUERY = (0,urql_core/* gql */.Ps)(_templateObject5(), standardOrder/* STANDARD_ORDER_DETAILS_FRAGMENT */.K, NESTED_ORDER_DETAILS_FRAGMENT);
var SEARCH_ORDER_BY_EMAIL_PHONE_QUERY = (0,urql_core/* gql */.Ps)(_templateObject6(), standardOrder/* STANDARD_ORDER_DETAILS_FRAGMENT */.K, NESTED_ORDER_DETAILS_FRAGMENT);


/***/ }),

/***/ 85288:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ WISHLIST_QUERY; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19989);
/* harmony import */ var urql__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70463);
/* harmony import */ var gql_fragments_wishList__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(46350);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query WishList {\n    wishList {\n      ...wishListFields\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var WISHLIST_QUERY = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject(), gql_fragments_wishList__WEBPACK_IMPORTED_MODULE_1__/* .WISHLIST_FRAGMENT */ .j);


/***/ }),

/***/ 18273:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Jo": function() { return /* binding */ componentsGroqQuery; },
/* harmony export */   "e6": function() { return /* binding */ SlotsGroqQuery; },
/* harmony export */   "hL": function() { return /* binding */ subComponentsGroqQuery; }
/* harmony export */ });
/* harmony import */ var _documents__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96723);

var componentsGroqQuery = "\n  ".concat((0,_documents__WEBPACK_IMPORTED_MODULE_0__/* .AdditionalContentSectionDocument */ .Xk)('_type == "AdditionalContentSection" =>'), ",\n  ").concat((0,_documents__WEBPACK_IMPORTED_MODULE_0__/* .AutomatedProductComparisonDocument */ .Oh)('_type == "AutomatedProductComparison" =>'), ",\n  ").concat((0,_documents__WEBPACK_IMPORTED_MODULE_0__/* .BodyContentDocument */ .NF)('_type == "BodyContent" =>'), ",\n  ").concat((0,_documents__WEBPACK_IMPORTED_MODULE_0__/* .BodyHeaderDocument */ .j$)('_type == "BodyHeader" =>'), ",\n  ").concat((0,_documents__WEBPACK_IMPORTED_MODULE_0__/* .CardsAndTilesDocument */ .YL)('_type == "LaunchCalendar" =>'), ",\n  ").concat((0,_documents__WEBPACK_IMPORTED_MODULE_0__/* .FeatureHeroDocument */ .gF)('_type == "FeatureHero" =>'), ",\n  ").concat((0,_documents__WEBPACK_IMPORTED_MODULE_0__/* .FeaturesGridDocument */ .Jp)('_type == "FeaturesGrid" =>'), ",\n  ").concat((0,_documents__WEBPACK_IMPORTED_MODULE_0__/* .FullBleedHeroDocument */ .Sx)('_type == "FullBleedHero" =>'), ",\n  ").concat((0,_documents__WEBPACK_IMPORTED_MODULE_0__/* .IframeDocument */ .SQ)('_type == "Iframe" =>'), ",\n  ").concat((0,_documents__WEBPACK_IMPORTED_MODULE_0__/* .InfoBannerDocument */ .kN)('_type == "InfoBanner" =>'), ",\n  ").concat((0,_documents__WEBPACK_IMPORTED_MODULE_0__/* .PixleeSimpleWidgetDocument */ .AS)('_type == "PixleeSimpleWidget" =>'), ",\n  ").concat((0,_documents__WEBPACK_IMPORTED_MODULE_0__/* .ProductCarouselDocument */ .en)('_type == "ProductCarousel" =>'), ",\n  ").concat((0,_documents__WEBPACK_IMPORTED_MODULE_0__/* .ProductComparisonDocument */ .lA)('_type == "ProductComparison" =>'), ",\n  ").concat((0,_documents__WEBPACK_IMPORTED_MODULE_0__/* .ProductGroupFeaturesDocument */ .zR)('_type == "ProductGroupFeatures" =>'), ",\n  ").concat((0,_documents__WEBPACK_IMPORTED_MODULE_0__/* .ProductRecommenderDocument */ .Qy)('_type == "ProductRecommender" =>'), ",\n  ").concat((0,_documents__WEBPACK_IMPORTED_MODULE_0__/* .QuiltDocument */ .ae)('_type == "Quilt" =>'), ",\n  ").concat((0,_documents__WEBPACK_IMPORTED_MODULE_0__/* .QuoteCalloutDocument */ .CX)('_type == "QuoteCallout" =>'), ",\n  ").concat((0,_documents__WEBPACK_IMPORTED_MODULE_0__/* .SideBySideDocument */ .TU)('_type == "SideBySide" =>'), ",\n  ").concat((0,_documents__WEBPACK_IMPORTED_MODULE_0__/* .SignUpFormDocument */ .z1)('_type == "SignUpForm" =>'), ",\n  ").concat((0,_documents__WEBPACK_IMPORTED_MODULE_0__/* .SplitHeroDocument */ .sK)('_type == "SplitHero" =>'), ",\n  ").concat((0,_documents__WEBPACK_IMPORTED_MODULE_0__/* .StyliticsCarouselDocument */ .VY)('_type == "StyliticsCarousel" =>'), ",\n  ").concat((0,_documents__WEBPACK_IMPORTED_MODULE_0__/* .TrendingInlineDocument */ .E7)('_type == "TrendingInline" =>'), ",\n  ").concat((0,_documents__WEBPACK_IMPORTED_MODULE_0__/* .VideoHeroDocument */ .iM)('_type == "VideoHero" =>'), ",\n  ").concat((0,_documents__WEBPACK_IMPORTED_MODULE_0__/* .YouTubeVideoCarouselDocument */ .Is)('_type == "YouTubeVideoCarousel" =>'), ",\n  ").concat((0,_documents__WEBPACK_IMPORTED_MODULE_0__/* .HowToWearItDocument */ .qR)('_type == "HowToWearIt" =>'), ",\n  ").concat((0,_documents__WEBPACK_IMPORTED_MODULE_0__/* .FAQModuleDocument */ .so)('_type == "FaqModule" =>'), ",\n  ").concat((0,_documents__WEBPACK_IMPORTED_MODULE_0__/* .WebCarouselDocument */ .FI)('_type == "WebCarousel" =>'), "\n");
var subComponentsGroqQuery = " \n  ".concat((0,_documents__WEBPACK_IMPORTED_MODULE_0__/* .CountdownClockDocument */ .nM)('_type == "CountdownClock" =>'), ",\n  ").concat((0,_documents__WEBPACK_IMPORTED_MODULE_0__/* .FeaturesGridRowDocument */ .jo)('_type == "FeaturesGridRow" =>'), ",\n  ").concat((0,_documents__WEBPACK_IMPORTED_MODULE_0__/* .PromoTileDocument */ .db)('_type == "PromoTile" =>'), ",\n  ").concat((0,_documents__WEBPACK_IMPORTED_MODULE_0__/* .TrendingTileDocument */ .gz)('_type == "TrendingTile" =>'), ",\n");
var SlotsGroqQuery = function() {
    return '{\n    "id": _key,\n    _type,\n    "availableFrom": coalesce(component->availableFrom, availableFrom),\n    "availableTo": coalesce(component->availableTo, availableTo),\n    targetDevices,\n    campaign[] -> {\n      _id,\n      _type,\n      availableFrom,\n      availableTo,\n      customerGroups,\n      puid,\n      sourceCode,\n    },\n    component -> {\n      '.concat(componentsGroqQuery, "\n    }\n  }\n");
};


/***/ }),

/***/ 82472:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ CampaignDocument; }
/* harmony export */ });
var CampaignDocument = function(field) {
    return "\n  ".concat(field, " {\n    _id,\n    _type,\n    availableFrom,\n    availableTo,\n    customerGroups,\n    puid,\n    sourceCode\n  }\n");
};


/***/ }),

/***/ 76155:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ CategoryDocument; },
/* harmony export */   "Y": function() { return /* binding */ CategoryByUrl; }
/* harmony export */ });
/* harmony import */ var groq_shared_LocaleString__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1809);
/* harmony import */ var groq_shared_LocaleSeo__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16138);
/* harmony import */ var groq_shared_LocaleUrl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(63950);
/* harmony import */ var groq_objects_SanityImageObject__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14075);




var CategoryByUrl = '\n  [country == $country]\n  [_type == "category"]\n  ['.concat((0,groq_shared_LocaleUrl__WEBPACK_IMPORTED_MODULE_0__/* .QueryByLocaleUrl */ .KM)(), "]\n");
var CategoryDocument = function(field) {
    return "\n  ".concat(field, " {\n    _id,\n    _type,\n    country,\n    id,\n    url,\n    ").concat((0,groq_shared_LocaleString__WEBPACK_IMPORTED_MODULE_1__/* .LocaleString */ .E)("urls"), ",\n    ").concat((0,groq_shared_LocaleString__WEBPACK_IMPORTED_MODULE_1__/* .LocaleString */ .E)("name"), ",\n    ").concat((0,groq_shared_LocaleString__WEBPACK_IMPORTED_MODULE_1__/* .LocaleString */ .E)("title"), ",\n    ").concat((0,groq_shared_LocaleString__WEBPACK_IMPORTED_MODULE_1__/* .LocaleString */ .E)("description"), ",\n    ").concat((0,groq_objects_SanityImageObject__WEBPACK_IMPORTED_MODULE_2__/* .SanityImageObject */ .i)("image"), ",\n    visible,\n    online,\n    onlineFrom,\n    onlineTo,\n    hasItemsInStock,\n    showEvenIfEmpty,\n    sizeChartId,\n    ").concat((0,groq_shared_LocaleSeo__WEBPACK_IMPORTED_MODULE_3__/* .LocaleSeo */ .U)("seo"), ",\n  }\n");
};


/***/ }),

/***/ 11241:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ CountdownClockDocument; }
/* harmony export */ });
var CountdownClockDocument = function(field) {
    return "\n  ".concat(field, ' {\n    "id": _id,\n    _id,\n    _type,\n    availableFrom,\n    availableTo,\n    countdownEnd,\n  }\n');
};


/***/ }),

/***/ 73050:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ FAQModuleDocument; },
/* harmony export */   "z": function() { return /* binding */ FAQ_ITEM_PORTABLE_TEXT_FIELD; }
/* harmony export */ });
/* harmony import */ var groq_shared_LocaleString__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1809);
/* harmony import */ var groq_shared_LocalePortableText__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(57831);


var FAQ_ITEM_PORTABLE_TEXT_FIELD = "answer";
var FAQModuleDocument = function(field) {
    return "\n  ".concat(field, ' {\n    "id": _id,\n    _id,\n    _type,\n    ').concat((0,groq_shared_LocaleString__WEBPACK_IMPORTED_MODULE_1__/* .LocaleString */ .E)("localeTitle"), ",\n    faqs[]-> {\n      _id,\n      ").concat((0,groq_shared_LocaleString__WEBPACK_IMPORTED_MODULE_1__/* .LocaleString */ .E)("question"), ",\n      ").concat((0,groq_shared_LocalePortableText__WEBPACK_IMPORTED_MODULE_0__/* .LocalePortableText */ .O)(FAQ_ITEM_PORTABLE_TEXT_FIELD), ",\n      tags[] -> {\n        value,\n        ").concat((0,groq_shared_LocaleString__WEBPACK_IMPORTED_MODULE_1__/* .LocaleString */ .E)("label"), ",\n      }\n    }\n  \n  }\n");
};


/***/ }),

/***/ 94735:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ GlobalPromoBannerDocument; }
/* harmony export */ });
/* harmony import */ var groq_objects_CallToActionObject__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28008);
/* harmony import */ var groq_shared_LocaleString__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1809);
/* harmony import */ var groq_shared_LocalePortableText__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57831);
/* harmony import */ var _CampaignDocument__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82472);
/* harmony import */ var _CountdownClockDocument__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11241);





var GlobalPromoBannerDocument = '\n  *[_id == lower($country) + "-GlobalPromoBanner"][0] {\n      "id": _id,\n      _id,\n      _type,\n      duration,\n      '.concat((0,groq_shared_LocalePortableText__WEBPACK_IMPORTED_MODULE_1__/* .LocalePortableText */ .O)("disclaimer"), ',\n      messages[] {\n        "id": _key,\n        _key,\n        "_type": "Message",\n        ').concat((0,groq_shared_LocaleString__WEBPACK_IMPORTED_MODULE_2__/* .LocaleString */ .E)("text"), ",\n        ").concat((0,groq_objects_CallToActionObject__WEBPACK_IMPORTED_MODULE_0__/* .CallToActionObject */ .U)("ctas[]"), ",\n        ").concat((0,_CampaignDocument__WEBPACK_IMPORTED_MODULE_3__/* .CampaignDocument */ .l)("campaign[]->"), ",\n        information {\n          ").concat((0,groq_shared_LocaleString__WEBPACK_IMPORTED_MODULE_2__/* .LocaleString */ .E)("title"), ",\n          ").concat((0,groq_shared_LocalePortableText__WEBPACK_IMPORTED_MODULE_1__/* .LocalePortableText */ .O)("localeDetails"), ",\n          details,\n        },\n        ").concat((0,_CountdownClockDocument__WEBPACK_IMPORTED_MODULE_4__/* .CountdownClockDocument */ .n)("countdownClock->"), ",\n        availableFrom,\n        availableTo,\n      }\n    }\n  ");


/***/ }),

/***/ 82528:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ InfoBannerDocument; }
/* harmony export */ });
/* harmony import */ var groq_objects_CallToActionObject__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28008);
/* harmony import */ var groq_objects_SanityImageObject__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14075);
/* harmony import */ var groq_shared_LocaleString__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1809);
/* harmony import */ var groq_shared_LocalePortableText__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57831);
/* harmony import */ var _CountdownClockDocument__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11241);





var InfoBannerDocument = function(field) {
    return "\n  ".concat(field, ' {\n    "id": _id,\n    _id,\n    _type,\n    puid,\n    ').concat((0,groq_shared_LocaleString__WEBPACK_IMPORTED_MODULE_2__/* .LocaleString */ .E)("header"), ",\n    ").concat((0,groq_shared_LocaleString__WEBPACK_IMPORTED_MODULE_2__/* .LocaleString */ .E)("copy"), ",\n    ").concat((0,groq_shared_LocaleString__WEBPACK_IMPORTED_MODULE_2__/* .LocaleString */ .E)("footnote"), ',\n    "optionalBackgroundImage": ').concat((0,groq_objects_SanityImageObject__WEBPACK_IMPORTED_MODULE_3__/* .SanityImageObject */ .i)("backgroundImage", "desktop", "mobileBackgroundImage"), ",\n    ").concat((0,groq_objects_SanityImageObject__WEBPACK_IMPORTED_MODULE_3__/* .SanityImageObject */ .i)("mobileBackgroundImage", "mobile"), ",\n    backgroundColor,\n    textColor,\n    ").concat((0,groq_shared_LocalePortableText__WEBPACK_IMPORTED_MODULE_1__/* .LocalePortableText */ .O)("disclaimer"), ",\n    ").concat((0,groq_objects_CallToActionObject__WEBPACK_IMPORTED_MODULE_0__/* .CallToActionObject */ .U)("ctas[]"), ",\n    ").concat((0,_CountdownClockDocument__WEBPACK_IMPORTED_MODULE_4__/* .CountdownClockDocument */ .n)("countdownClock->"), ",\n    showCountdownBeneathSubheading,\n  }\n");
};


/***/ }),

/***/ 3985:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ PromoTileDocument; }
/* harmony export */ });
/* harmony import */ var groq_objects_CallToActionObject__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28008);
/* harmony import */ var groq_objects_SanityImageObject__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14075);
/* harmony import */ var groq_objects_SanityVideoObject__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(65102);
/* harmony import */ var groq_shared_LocalePortableText__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57831);
/* harmony import */ var groq_shared_LocaleString__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1809);





var PromoTileDocument = function(field) {
    return "\n  ".concat(field, ' {\n    "id": _id,\n    _id,\n    _type,\n    ').concat((0,groq_shared_LocaleString__WEBPACK_IMPORTED_MODULE_2__/* .LocaleString */ .E)("header"), ",\n    ").concat((0,groq_shared_LocaleString__WEBPACK_IMPORTED_MODULE_2__/* .LocaleString */ .E)("copy"), ",\n    textColor,\n    backgroundColor,\n    verticalAlignment,\n    contentBelow,\n    ").concat((0,groq_shared_LocalePortableText__WEBPACK_IMPORTED_MODULE_1__/* .LocalePortableText */ .O)("disclaimer"), ",\n    ").concat((0,groq_objects_SanityVideoObject__WEBPACK_IMPORTED_MODULE_3__/* .SanityVideoObject */ .o)("video"), ",\n    ").concat((0,groq_objects_SanityImageObject__WEBPACK_IMPORTED_MODULE_4__/* .SanityImageObject */ .i)("backgroundImage", "desktop", "mobileBackgroundImage"), ",\n    ").concat((0,groq_objects_SanityImageObject__WEBPACK_IMPORTED_MODULE_4__/* .SanityImageObject */ .i)("mobileBackgroundImage", "mobile"), ",\n    ").concat((0,groq_objects_CallToActionObject__WEBPACK_IMPORTED_MODULE_0__/* .CallToActionObject */ .U)("cta"), ",\n    availableFrom,\n    availableTo,\n    puid,\n  }\n");
};


/***/ }),

/***/ 63642:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ SecondGlobalBannerDocument; }
/* harmony export */ });
/* harmony import */ var groq_shared_LocaleUrl__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63950);
/* harmony import */ var _CampaignDocument__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82472);
/* harmony import */ var _InfoBannerDocument__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82528);



var SecondGlobalBannerDocument = '\n  *[_id == lower($country) + "-SecondGlobalBanner"][0] {\n    banners[] {\n      _key,\n      "_type": "infoBannerWithCategoryExclusion",\n      '.concat((0,_InfoBannerDocument__WEBPACK_IMPORTED_MODULE_0__/* .InfoBannerDocument */ .k)("banner->"), ",\n      availableFrom,\n      availableTo,\n      ").concat((0,_CampaignDocument__WEBPACK_IMPORTED_MODULE_1__/* .CampaignDocument */ .l)("campaign[] ->"), ",\n      coreLinkExclusions,\n      exclusions[] -> {\n        id,\n        ").concat(groq_shared_LocaleUrl__WEBPACK_IMPORTED_MODULE_2__/* .LocaleUrl */ .wS, "\n      },\n      displayOnlyOn,\n      productsExclusions,\n      isSticky,\n      targetDevices,\n    }\n  }\n");


/***/ }),

/***/ 55835:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ SignUpFormDocument; }
/* harmony export */ });
/* harmony import */ var groq_objects_CallToActionObject__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28008);
/* harmony import */ var groq_objects_SanityImageObject__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14075);
/* harmony import */ var groq_shared_LocalePortableText__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57831);
/* harmony import */ var groq_shared_LocaleString__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1809);




var SignUpFormDocument = function(field) {
    return "\n  ".concat(field, " {\n    _id,\n    _type,\n    analyticsIdentifier,\n    ").concat((0,groq_shared_LocaleString__WEBPACK_IMPORTED_MODULE_2__/* .LocaleString */ .E)("launchButtonLabel"), ",\n    ").concat((0,groq_shared_LocaleString__WEBPACK_IMPORTED_MODULE_2__/* .LocaleString */ .E)("launchLinkText"), ",\n    ").concat((0,groq_shared_LocaleString__WEBPACK_IMPORTED_MODULE_2__/* .LocaleString */ .E)("cartPageLaunchButtonLabel"), ",\n    ").concat((0,groq_shared_LocaleString__WEBPACK_IMPORTED_MODULE_2__/* .LocaleString */ .E)("header"), ",\n    ").concat((0,groq_shared_LocaleString__WEBPACK_IMPORTED_MODULE_2__/* .LocaleString */ .E)("copy"), ",\n    ").concat((0,groq_shared_LocaleString__WEBPACK_IMPORTED_MODULE_2__/* .LocaleString */ .E)("footnote"), ",\n    contactSource,\n    ").concat((0,groq_shared_LocalePortableText__WEBPACK_IMPORTED_MODULE_1__/* .LocalePortableText */ .O)("disclaimer"), ",\n    ").concat((0,groq_shared_LocaleString__WEBPACK_IMPORTED_MODULE_2__/* .LocaleString */ .E)("disclaimerText"), ",\n    ").concat((0,groq_shared_LocalePortableText__WEBPACK_IMPORTED_MODULE_1__/* .LocalePortableText */ .O)("portableDisclaimerText"), ",\n    ").concat((0,groq_shared_LocaleString__WEBPACK_IMPORTED_MODULE_2__/* .LocaleString */ .E)("submitButtonText"), ",\n    ").concat((0,groq_shared_LocaleString__WEBPACK_IMPORTED_MODULE_2__/* .LocaleString */ .E)("customText"), ",\n    fields,\n    ").concat((0,groq_shared_LocaleString__WEBPACK_IMPORTED_MODULE_2__/* .LocaleString */ .E)("successHeader"), ",\n    ").concat((0,groq_shared_LocaleString__WEBPACK_IMPORTED_MODULE_2__/* .LocaleString */ .E)("successCopy"), ",\n    ").concat((0,groq_shared_LocaleString__WEBPACK_IMPORTED_MODULE_2__/* .LocaleString */ .E)("successFootnote"), ",\n    inverted,\n    ").concat((0,groq_objects_CallToActionObject__WEBPACK_IMPORTED_MODULE_0__/* .CallToActionObject */ .U)("ctas[]"), ",\n    ").concat((0,groq_objects_SanityImageObject__WEBPACK_IMPORTED_MODULE_3__/* .SanityImageObject */ .i)("successImage"), ",\n    ").concat((0,groq_objects_SanityImageObject__WEBPACK_IMPORTED_MODULE_3__/* .SanityImageObject */ .i)("mobileBackgroundImage", "mobile"), ",\n    ").concat((0,groq_shared_LocalePortableText__WEBPACK_IMPORTED_MODULE_1__/* .LocalePortableText */ .O)("disclaimer"), ',\n    "formBackgroundImage": ').concat((0,groq_objects_SanityImageObject__WEBPACK_IMPORTED_MODULE_3__/* .SanityImageObject */ .i)("backgroundImage", "desktop", "mobileBackgroundImage"), ",\n    backgroundColor,\n  }\n");
};


/***/ }),

/***/ 96159:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ SanityVideoAssetDocument; }
/* harmony export */ });
/* harmony import */ var groq_objects_CloudinaryOptimizationObject__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90345);

var SanityVideoAssetDocument = function(field) {
    return "\n  ".concat(field, " {\n    _id,\n    url,\n    path,\n    ").concat((0,groq_objects_CloudinaryOptimizationObject__WEBPACK_IMPORTED_MODULE_0__/* .CloudinaryVideoOptimizationObject */ .A)("cloudinary"), "\n  }\n");
};


/***/ }),

/***/ 96723:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Xk": function() { return /* reexport */ AdditionalContentSectionDocument; },
  "Oh": function() { return /* reexport */ AutomatedProductComparisonDocument; },
  "NF": function() { return /* reexport */ BodyContentDocument; },
  "j$": function() { return /* reexport */ BodyHeaderDocument; },
  "YL": function() { return /* reexport */ CardsAndTilesDocument; },
  "nM": function() { return /* reexport */ CountdownClockDocument/* CountdownClockDocument */.n; },
  "so": function() { return /* reexport */ FAQModuleDocument/* FAQModuleDocument */.s; },
  "gF": function() { return /* reexport */ FeatureHeroDocument; },
  "Jp": function() { return /* reexport */ FeaturesGridDocument; },
  "jo": function() { return /* reexport */ FeaturesGridRowDocument; },
  "Sx": function() { return /* reexport */ FullBleedHeroDocument; },
  "qR": function() { return /* reexport */ HowToWearItDocument; },
  "SQ": function() { return /* reexport */ IframeDocument; },
  "kN": function() { return /* reexport */ InfoBannerDocument/* InfoBannerDocument */.k; },
  "AS": function() { return /* reexport */ PixleeSimpleWidgetDocument; },
  "en": function() { return /* reexport */ ProductCarouselDocument; },
  "lA": function() { return /* reexport */ ProductComparisonDocument; },
  "zR": function() { return /* reexport */ ProductGroupFeaturesDocument; },
  "Qy": function() { return /* reexport */ ProductRecommenderDocument; },
  "db": function() { return /* reexport */ PromoTileDocument/* PromoTileDocument */.d; },
  "ae": function() { return /* reexport */ QuiltDocument; },
  "CX": function() { return /* reexport */ QuoteCalloutDocument; },
  "TU": function() { return /* reexport */ SideBySideDocument; },
  "z1": function() { return /* reexport */ SignUpFormDocument/* SignUpFormDocument */.z; },
  "sK": function() { return /* reexport */ SplitHeroDocument; },
  "VY": function() { return /* reexport */ StyliticsCarouselDocument; },
  "E7": function() { return /* reexport */ TrendingInlineDocument; },
  "gz": function() { return /* reexport */ TrendingTileDocument; },
  "iM": function() { return /* reexport */ VideoHeroDocument; },
  "FI": function() { return /* reexport */ WebCarouselDocument; },
  "Is": function() { return /* reexport */ YouTubeVideoCarouselDocument; }
});

// EXTERNAL MODULE: ./groq/documents/InfoBannerDocument.ts
var InfoBannerDocument = __webpack_require__(82528);
// EXTERNAL MODULE: ./groq/objects/SanityImageObject.ts + 1 modules
var SanityImageObject = __webpack_require__(14075);
// EXTERNAL MODULE: ./groq/shared/LocaleString.ts
var LocaleString = __webpack_require__(1809);
// EXTERNAL MODULE: ./groq/objects/CallToActionObject.ts
var CallToActionObject = __webpack_require__(28008);
// EXTERNAL MODULE: ./groq/shared/LocalePortableText.ts
var LocalePortableText = __webpack_require__(57831);
// EXTERNAL MODULE: ./groq/objects/LinkObject.ts
var LinkObject = __webpack_require__(47258);
// EXTERNAL MODULE: ./groq/documents/CountdownClockDocument.ts
var CountdownClockDocument = __webpack_require__(11241);
;// CONCATENATED MODULE: ./groq/documents/BodyContentDocument.ts






var BodyContentDocument = function(field) {
    return "\n  ".concat(field, " {\n    _id,\n    _type,\n    horizontalAlignment,\n    ").concat((0,LocaleString/* LocaleString */.E)("header"), ",\n    ").concat((0,LocaleString/* LocaleString */.E)("copy"), ",\n    ").concat((0,LocalePortableText/* LocalePortableText */.O)("pageContent"), ",\n    ").concat((0,LocalePortableText/* LocalePortableText */.O)("disclaimer"), ",\n    ").concat((0,SanityImageObject/* SanityImageObject */.i)("logo"), ",\n    ").concat((0,CallToActionObject/* CallToActionObject */.U)("ctas[]"), ",\n    ").concat((0,LinkObject/* LinkObject */.M)("link"), ",\n    ").concat((0,CountdownClockDocument/* CountdownClockDocument */.n)("countdownClock->"), ",\n    linkType,\n    availableFrom,\n    availableTo,\n    puid\n  }\n");
};

;// CONCATENATED MODULE: ./groq/documents/BodyHeaderDocument.ts


var BodyHeaderDocument = function(field) {
    return "\n  ".concat(field, " {\n    _id,\n    _type,\n    ").concat((0,LocaleString/* LocaleString */.E)("header"), ",\n    horizontalAlignment,\n    size,\n    ").concat((0,LinkObject/* LinkObject */.M)("link"), ",\n\n  }\n");
};

;// CONCATENATED MODULE: ./groq/documents/CardsAndTilesDocument.ts




// Schema: https://github.com/Global-eCom/sanity-studio-cms/blob/main/studio/schemas/documents/LaunchCalendar.ts
var CalendarContentField = function(field) {
    return "\n  ".concat(field, " {\n    _key,\n    _id,\n    _type,\n    image {\n      ").concat((0,SanityImageObject/* SanityImageObject */.i)("portrait"), ",\n      ").concat((0,SanityImageObject/* SanityImageObject */.i)("square"), ",\n      ").concat((0,SanityImageObject/* SanityImageObject */.i)("landscape"), ',\n    },\n    icon {\n      _type == "udsIcon" => {\n        ').concat((0,SanityImageObject/* SanityImageObject */.i)("img"), ",\n        ").concat((0,LocaleString/* LocaleString */.E)("alt"), "\n      }\n    },\n    text {\n      ").concat((0,LocaleString/* LocaleString */.E)("header"), ",\n      ").concat((0,LocaleString/* LocaleString */.E)("copy"), ",\n      ").concat((0,LocaleString/* LocaleString */.E)("footnote"), ",\n      align,\n      color,\n    },\n    ").concat((0,LinkObject/* LinkObject */.M)("link"), ',\n    "ctas": coalesce(\n      ').concat((0,CallToActionObject/* CallToActionObject */.U)("ctas2[]"), ",\n      ctas[] {\n        ...").concat((0,LinkObject/* LinkObject */.M)("link"), ",\n        ").concat((0,LocaleString/* LocaleString */.E)("title"), ',\n        "id": _key,\n        _key,\n        _type,\n        outlined,\n        variant,\n        width,\n      },\n    ),\n    alignment {\n      vertical,\n      horizontal,\n    },\n    style {\n      background,\n      border,\n      rounded,\n      shadow,\n    },\n    aspectRatio\n  }\n');
};
var CardsAndTilesDocument = function(field) {
    return "\n  ".concat(field, " {\n    _id,\n    _type,\n    calendarContent[] {\n      ").concat(CalendarContentField('_type == "Tile" =>'), ",\n      ").concat(CalendarContentField('_type == "Card" =>'), "\n    }\n  }\n");
};

;// CONCATENATED MODULE: ./groq/documents/SplitHeroDocument.ts






var SplitHeroDocument = function(field) {
    return "\n  ".concat(field, ' {\n    "id": _id,\n    _id,\n    _type,\n    ').concat((0,SanityImageObject/* SanityImageObject */.i)("logo"), ",\n    ").concat((0,SanityImageObject/* SanityImageObject */.i)("backgroundImage", "desktop", "mobileBackgroundImage"), ",\n    ").concat((0,SanityImageObject/* SanityImageObject */.i)("mobileBackgroundImage", "mobile"), ",\n    ").concat((0,LocaleString/* LocaleString */.E)("header"), ",\n    ").concat((0,LocaleString/* LocaleString */.E)("copy"), ",\n    ").concat((0,LocaleString/* LocaleString */.E)("footnote"), ",\n    ").concat((0,CallToActionObject/* CallToActionObject */.U)("ctas[]"), ",\n    ").concat((0,LinkObject/* LinkObject */.M)("link"), ",\n    linkType,\n    ").concat((0,CountdownClockDocument/* CountdownClockDocument */.n)("countdownClock->"), ",\n    ").concat((0,LocalePortableText/* LocalePortableText */.O)("disclaimer"), ",\n    layout,\n    horizontalAlignment,\n    backgroundColor,\n    textColor,\n    puid,\n    availableFrom,\n    availableTo\n  }\n");
};

;// CONCATENATED MODULE: ./groq/documents/QuoteCalloutDocument.ts



var QuoteCalloutDocument = function(field) {
    return "\n  ".concat(field, ' {\n    "id": _id,\n    _id,\n    _type,\n    ').concat((0,LocaleString/* LocaleString */.E)("header"), ",\n    ").concat((0,LocaleString/* LocaleString */.E)("copy"), ",\n    headerColor,\n    copyColor,\n    ").concat((0,LocaleString/* LocaleString */.E)("quote"), ",\n    ").concat((0,CallToActionObject/* CallToActionObject */.U)("ctas[]"), ",\n    ").concat((0,LocalePortableText/* LocalePortableText */.O)("disclaimer"), ",\n  }\n");
};

;// CONCATENATED MODULE: ./groq/documents/IframeDocument.ts
// Schema: https://github.com/Global-eCom/sanity-studio-cms/blob/main/studio/schemas/documents/Iframe.ts
var IframeDocument = function(field) {
    return "\n  ".concat(field, ' {\n    "id": _id,\n    _id,\n    _type,\n    src,\n    fullScreen,\n    height,\n  }\n');
};

;// CONCATENATED MODULE: ./groq/documents/FullBleedHeroDocument.ts






var FullBleedHeroDocument = function(field) {
    return "\n  ".concat(field, ' {\n    "id": _id,\n    _id,\n    _type,\n    ').concat((0,SanityImageObject/* SanityImageObject */.i)("backgroundImage", "desktop", "mobileBackgroundImage"), ",\n    ").concat((0,SanityImageObject/* SanityImageObject */.i)("mobileBackgroundImage", "mobile"), ",\n    ").concat((0,SanityImageObject/* SanityImageObject */.i)("logo", "desktop", "logoMobile"), ",\n    ").concat((0,SanityImageObject/* SanityImageObject */.i)("logoMobile", "mobile"), ",\n    ").concat((0,LocaleString/* LocaleString */.E)("header"), ",\n    ").concat((0,LocaleString/* LocaleString */.E)("copy"), ",\n    ").concat((0,LocaleString/* LocaleString */.E)("footnote"), ",\n    ").concat((0,CallToActionObject/* CallToActionObject */.U)("ctas[]"), ",\n    ").concat((0,LinkObject/* LinkObject */.M)("link"), ",\n    ").concat((0,LocalePortableText/* LocalePortableText */.O)("disclaimer"), ",\n    linkType,\n    logoPosition,\n    textAlignment,\n    horizontalAlignment,\n    verticalAlignment,\n    textColor,\n    backgroundColor,\n    overlayContent,\n    minAspectRatio,\n    puid,\n    ").concat((0,CountdownClockDocument/* CountdownClockDocument */.n)("countdownClock->"), ",\n    backgroundOverlay { ... },\n    mobileBackgroundOverlay { ... },\n    availableFrom,\n    availableTo,\n  }\n");
};

;// CONCATENATED MODULE: ./groq/documents/ProductCarouselDocument.ts

var ProductCarouselDocument = function(field) {
    return "\n  ".concat(field, " {\n    _id,\n    _type,\n    ").concat((0,LocaleString/* LocaleString */.E)("header"), ",\n    ").concat((0,LocaleString/* LocaleString */.E)("subHeader"), ",\n    ").concat((0,LocaleString/* LocaleString */.E)("copy"), ",\n    puid,\n    products,\n    availableFrom,\n    availableTo\n  }\n");
};

// EXTERNAL MODULE: ./groq/objects/SanityVideoObject.ts
var SanityVideoObject = __webpack_require__(65102);
// EXTERNAL MODULE: ./groq/documents/VideoAssetDocument.ts
var VideoAssetDocument = __webpack_require__(96159);
;// CONCATENATED MODULE: ./groq/documents/VideoHeroDocument.ts




var VideoHeroDocument = function(field) {
    return "\n  ".concat(field, ' {\n    "id": _id,\n    _id,\n    _type,\n    "backgroundVideo": ').concat((0,VideoAssetDocument/* SanityVideoAssetDocument */.U)("backgroundVideo.asset->"), ",\n    ").concat((0,SanityVideoObject/* SanityVideoObject */.o)("backgroundVideoObject"), ',\n    "mobileBackgroundVideo": ').concat((0,VideoAssetDocument/* SanityVideoAssetDocument */.U)("mobileBackgroundVideo.asset->"), ",\n    ").concat((0,SanityVideoObject/* SanityVideoObject */.o)("mobileBackgroundVideoObject"), ",\n    ").concat((0,LocaleString/* LocaleString */.E)("header"), ",\n    ").concat((0,LocaleString/* LocaleString */.E)("copy"), ",\n    ").concat((0,LocaleString/* LocaleString */.E)("footnote"), ",\n    ").concat((0,CallToActionObject/* CallToActionObject */.U)("ctas[]"), ",\n    textColor,\n    horizontalAlignment,\n    verticalAlignment,\n    overlayContent,\n    autoplay,\n    controls,\n    loop,\n    mute,\n    minAspectRatio,\n    availableFrom,\n    availableTo\n  }\n");
};

;// CONCATENATED MODULE: ./groq/documents/FeatureHeroDocument.ts




var FeatureHeroDocument = function(field) {
    return "\n  ".concat(field, " {\n    _id,\n    _type,\n    ").concat((0,LocaleString/* LocaleString */.E)("header"), ",\n    ").concat((0,LocaleString/* LocaleString */.E)("copy"), ",\n    ").concat((0,LocaleString/* LocaleString */.E)("footnote"), ",\n    backgroundColor,\n    textColor,\n    ").concat((0,CallToActionObject/* CallToActionObject */.U)("ctas[]"), ",\n    ").concat((0,SanityImageObject/* SanityImageObject */.i)("logo"), ',\n    "optionalPrimaryImage": ').concat((0,SanityImageObject/* SanityImageObject */.i)("primaryImage"), ",\n    ").concat((0,SanityVideoObject/* SanityVideoObject */.o)("primaryVideo"), ',\n    "optionalSecondaryImage": ').concat((0,SanityImageObject/* SanityImageObject */.i)("secondaryImage"), ",\n    ").concat((0,SanityVideoObject/* SanityVideoObject */.o)("secondaryVideo"), ",\n    availableFrom,\n    availableTo\n  }\n");
};

;// CONCATENATED MODULE: ./groq/documents/ProductComparisonDocument.ts
var ProductComparisonDocument = function(field) {
    return "\n  ".concat(field, ' {\n    "id": _id,\n    _id,\n    _type,\n    header,\n    comparisonFields,\n    products,\n  }\n');
};

;// CONCATENATED MODULE: ./groq/documents/ProductRecommenderDocument.ts


var ProductRecommenderDocument = function(field) {
    return "\n  ".concat(field, ' {\n    _id,\n    _type,\n    "__typename": _type,\n    puid,\n    ').concat((0,LocaleString/* LocaleString */.E)("header"), ",\n    ").concat((0,LocaleString/* LocaleString */.E)("copy"), ",\n    type,\n    showAsGrid,\n    ").concat((0,CallToActionObject/* CallToActionObject */.U)("cta[]"), ",\n  }\n");
};

;// CONCATENATED MODULE: ./groq/documents/ProductGroupFeaturesDocument.ts



var ProductGroupFeaturesDocument = function(field) {
    return "\n  ".concat(field, ' {\n    "id": _id,\n     _id,\n    _type,\n    productFeatures[] {\n      "id": _key,\n      _key,\n      ').concat((0,LocaleString/* LocaleString */.E)("header"), ",\n      ").concat((0,LocaleString/* LocaleString */.E)("copy"), ",\n      horizontalAlignment,\n      ").concat((0,SanityImageObject/* SanityImageObject */.i)("image"), ",\n      ").concat((0,SanityVideoObject/* SanityVideoObject */.o)("video"), ",\n    }\n  }\n");
};

;// CONCATENATED MODULE: ./groq/documents/TrendingTileDocument.ts






var TrendingTileDocument = function(field) {
    return "\n  ".concat(field, ' {\n    "id": _id,\n    _id,\n    _type,\n    "__typename": _type,\n    puid,\n    availableFrom,\n    availableTo,\n    ').concat((0,LocaleString/* LocaleString */.E)("header"), ",\n    linkType,\n    ").concat((0,LinkObject/* LinkObject */.M)("link"), ",\n    ").concat((0,LocaleString/* LocaleString */.E)("copy"), ",\n    textColor,\n    overlay,\n    backgroundType,\n    einsteinRecommender,\n    einsteinRecommenderAltText,\n    ").concat((0,SanityImageObject/* SanityImageObject */.i)("backgroundImage"), ",\n    ").concat((0,CallToActionObject/* CallToActionObject */.U)("ctas[]"), ",\n    ").concat((0,CountdownClockDocument/* CountdownClockDocument */.n)("countdownClock->"), ",\n    ").concat((0,LocalePortableText/* LocalePortableText */.O)("disclaimer"), ",\n    backgroundOverlay { ... },\n  }\n");
};

;// CONCATENATED MODULE: ./groq/documents/TrendingInlineDocument.ts

var TrendingInlineDocument = function(field) {
    return "\n  ".concat(field, ' {\n    _id,\n    _type,\n    availableFrom,\n    availableTo,\n    "requiredTiles": ').concat(TrendingTileDocument("tiles[]->"), "\n  }\n");
};

;// CONCATENATED MODULE: ./groq/documents/YouTubeVideoCarouselDocument.ts
var YouTubeVideoCarouselDocument = function(field) {
    return "\n  ".concat(field, ' {\n    "id": _id,\n    _id,\n    _type,\n    playlistId,\n    videoIds,\n    autoplay,\n    showThumbnails,\n  }\n');
};

// EXTERNAL MODULE: ./groq/documents/SignUpFormDocument.ts
var SignUpFormDocument = __webpack_require__(55835);
;// CONCATENATED MODULE: ./groq/documents/SideBySideDocument.ts


var SideBySideDocument = function(field) {
    return "\n  ".concat(field, ' {\n    "id": _id,\n    _id,\n    _type,\n    "requiredTiles": componentTiles[] -> {\n      ').concat(TrendingTileDocument('_type == "TrendingTile" =>'), ",\n      ").concat(ProductRecommenderDocument('_type == "ProductRecommender" =>'), ",\n    }\n  }\n");
};

// EXTERNAL MODULE: ./groq/objects/TileWithPosition.ts
var TileWithPosition = __webpack_require__(4287);
;// CONCATENATED MODULE: ./groq/documents/StyliticsCarouselDocument.ts


var StyliticsCarouselDocument = function(field) {
    return "\n  ".concat(field, " {\n    _id,\n    _type,\n    country,\n    puid,\n    ").concat((0,LocaleString/* LocaleString */.E)("header"), ",\n    numberOfTiles,\n    tags,\n    tileLayout,\n    ").concat((0,TileWithPosition/* TileWithPositionObject */.k)("tiles[]"), "\n  }\n");
};

;// CONCATENATED MODULE: ./groq/documents/FeaturesGridDocument.ts




var FeaturesGridRowDocument = function(field) {
    return "\n  ".concat(field, ' {\n    "id": _id,\n    _id,\n    _type,\n    ').concat((0,SanityImageObject/* SanityImageObject */.i)("primaryImage", "desktop", "mobilePrimaryImage"), ",\n    ").concat((0,SanityImageObject/* SanityImageObject */.i)("mobilePrimaryImage", "mobile"), ",\n    ").concat((0,LocaleString/* LocaleString */.E)("header"), ",\n    ").concat((0,LocaleString/* LocaleString */.E)("copy"), ",\n    ").concat((0,CallToActionObject/* CallToActionObject */.U)("ctas[]"), ",\n    ").concat((0,SanityImageObject/* SanityImageObject */.i)("secondaryImage"), ",\n    layout,\n  }\n");
};
var FeaturesGridDocument = function(field) {
    return "\n  ".concat(field, " {\n    _id,\n    _type,\n    ").concat((0,LinkObject/* LinkObject */.M)("link"), ",\n    featureRows[]{\n      _key,\n      ").concat(FeaturesGridRowDocument("...@->"), "\n    }\n  }\n");
};

;// CONCATENATED MODULE: ./groq/documents/AdditionalContentSectionDocument.ts

var AdditionalContentSectionDocument = function(field) {
    return "\n  ".concat(field, " {\n    _id,\n    _type,\n    text,\n    ").concat((0,LocalePortableText/* LocalePortableText */.O)("localeText"), "\n  }\n");
};

;// CONCATENATED MODULE: ./groq/documents/PixleeSimpleWidgetDocument.ts
// Schema: https://github.com/Global-eCom/sanity-studio-cms/blob/main/studio/schemas/documents/PixleeSimpleWidget.ts
var PixleeSimpleWidgetDocument = function(field) {
    return "\n  ".concat(field, " {\n    _id,\n    _type,\n    widgetId,\n  }\n");
};

;// CONCATENATED MODULE: ./groq/documents/AutomatedProductComparisonDocument.ts
var AutomatedProductComparisonDocument = function(field) {
    return "\n  ".concat(field, " {\n    _id,\n    _type,\n    header,\n    comparisonFields,\n    products,\n  }\n");
};

// EXTERNAL MODULE: ./groq/documents/Category.ts
var Category = __webpack_require__(76155);
// EXTERNAL MODULE: ./groq/documents/PromoTileDocument.ts
var PromoTileDocument = __webpack_require__(3985);
;// CONCATENATED MODULE: ./groq/documents/QuiltDocument.ts


var QuiltDocument = function(field) {
    return "".concat(field, " {\n    _id,\n    _type,\n    tileLayout,\n    tileMediaRatio,\n    mobile,\n    tablet,\n    desktop,\n    inverted,\n    contentJustify,\n    items[] -> {\n      ").concat((0,PromoTileDocument/* PromoTileDocument */.d)('_type == "PromoTile" =>'), ",\n      ").concat((0,Category/* CategoryDocument */.O)('_type == "category" =>'), ",\n    },\n  }");
};

;// CONCATENATED MODULE: ./groq/documents/HowToWearItDocument.ts
var HowToWearItDocument = function(field) {
    return "\n  ".concat(field, ' {\n    "id": _id,\n    _id,\n    _type,\n    country,\n    puid, \n    description,\n  }\n');
};

// EXTERNAL MODULE: ./groq/documents/FAQModuleDocument.ts
var FAQModuleDocument = __webpack_require__(73050);
;// CONCATENATED MODULE: ./groq/documents/WebCarouselDocument.ts

var WebCarouselDocument = function(field) {
    return "\n  ".concat(field, ' {\n    "id": _id,\n    _id,\n    _type,\n    "content": content[]{\n      ...@ -> {\n        ').concat(FullBleedHeroDocument('_type == "FullBleedHero" =>'), ",\n      }\n    },\n  }\n");
};

;// CONCATENATED MODULE: ./groq/documents/index.ts

































/***/ }),

/***/ 28008:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ CallToActionObject; }
/* harmony export */ });
/* harmony import */ var groq_shared_LocaleString__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1809);
/* harmony import */ var groq_objects_LinkObject__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47258);


// Schema: https://github.com/Global-eCom/sanity-studio-cms/blob/main/studio/schemas/objects/cta.ts
var LinkVariant = {
    Black: "black",
    Primary: "primary",
    Secondary: "secondary",
    White: "white"
};
var CallToActionObject = function(field) {
    return "\n  ".concat(field, " {\n    ...,\n    ").concat((0,groq_shared_LocaleString__WEBPACK_IMPORTED_MODULE_0__/* .LocaleString */ .E)("title"), ',\n    "category": route -> urls,\n    "article": "articles/" + article -> puid.current,\n    "marketing": marketing -> url.current,\n    "support": support -> url.current,\n    "newtab": coalesce(linkConfig.newtab, newtab),\n    "popup": coalesce(linkConfig.popup, popup),\n    "query": coalesce(linkConfig.query, query),\n    "action": coalesce(linkConfig.action, action),\n    "absolute": link,\n    ').concat((0,groq_objects_LinkObject__WEBPACK_IMPORTED_MODULE_1__/* .LinkObject */ .M)("linkConfig"), ",\n  }\n");
};


/***/ }),

/***/ 90345:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ CloudinaryVideoOptimizationObject; },
/* harmony export */   "H": function() { return /* binding */ CloudinaryImageOptimizationObject; }
/* harmony export */ });
var CloudinaryOptimizationObject = function(field, platform) {
    return "\n  ".concat(field, " {\n      status,\n      ").concat(platform ? 'transformations[platform == "'.concat(platform, '"]') : "transformations", "\n  }\n");
};
var CloudinaryImageOptimizationObject = function(field, platform) {
    return CloudinaryOptimizationObject(field, platform);
};
var CloudinaryVideoOptimizationObject = function(field) {
    return CloudinaryOptimizationObject(field);
};


/***/ }),

/***/ 47258:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ LinkObject; }
/* harmony export */ });
var LinkObject = function(field) {
    return "\n  ".concat(field, ' {\n      ...,\n      "category": category -> urls,\n      "article": "articles/" + article -> puid.current,\n      "marketing": marketing -> url.current,\n      "support": support -> url.current,\n  }\n');
};


/***/ }),

/***/ 14075:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "i": function() { return /* binding */ SanityImageObject; }
});

// EXTERNAL MODULE: ./groq/objects/CloudinaryOptimizationObject.ts
var CloudinaryOptimizationObject = __webpack_require__(90345);
;// CONCATENATED MODULE: ./groq/documents/ImageAssetDocument.ts

var ImageAssetDocument = function(field, platform) {
    return "\n  ".concat(field, " {\n    _id,\n    url,\n    path,\n    metadata {\n      lqip,\n      dimensions {\n        width,\n        height,\n      }\n    },\n    extension,\n    ").concat((0,CloudinaryOptimizationObject/* CloudinaryImageOptimizationObject */.H)("cloudinary", platform), "\n  }\n");
};

// EXTERNAL MODULE: ./groq/shared/LocaleString.ts
var LocaleString = __webpack_require__(1809);
;// CONCATENATED MODULE: ./groq/objects/SanityImageObject.ts


var _SanityImageObject = function(field) {
    var platform = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "all";
    return "\n  ".concat(field, " {\n    ").concat((0,LocaleString/* LocaleString */.E)("alt"), ",\n    ").concat(ImageAssetDocument("asset->", platform), ",\n    overlay\n  }\n");
};
var SanityImageObject = function(field) {
    var platform = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "all", mobileField = arguments.length > 2 ? arguments[2] : void 0;
    if (platform === "desktop" && mobileField) {
        return "\n      ".concat(field, " {\n        defined(^.").concat(mobileField, ".asset) => ").concat(_SanityImageObject("", "desktop"), ",\n        !defined(^.").concat(mobileField, ".asset) => ").concat(_SanityImageObject("", "all"), "\n      }\n    ");
    } else {
        return _SanityImageObject(field, platform);
    }
};


/***/ }),

/***/ 65102:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ SanityVideoObject; }
/* harmony export */ });
/* harmony import */ var groq_documents_VideoAssetDocument__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96159);
// Schema: https://github.com/Global-eCom/sanity-studio-cms/blob/main/studio/schemas/objects/video.ts

var SanityVideoObject = function(field) {
    return "\n  ".concat(field, ' {\n    "source": ').concat((0,groq_documents_VideoAssetDocument__WEBPACK_IMPORTED_MODULE_0__/* .SanityVideoAssetDocument */ .U)("source.asset->"), ",\n    autoplay,\n    loop,\n    mute,\n  }\n");
};


/***/ }),

/***/ 4287:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ TileWithPositionObject; }
/* harmony export */ });
/* harmony import */ var groq_documents_PromoTileDocument__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3985);

var TileWithPositionObject = function(field) {
    return "\n  ".concat(field, " {\n    _key,\n    _type,\n    position,\n    availableFrom,\n    availableTo,\n    ").concat((0,groq_documents_PromoTileDocument__WEBPACK_IMPORTED_MODULE_0__/* .PromoTileDocument */ .d)("tile->"), "\n  }\n");
};


/***/ }),

/***/ 37333:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ CategoryPageQuery; },
/* harmony export */   "y": function() { return /* binding */ CategoryPageByUrl; }
/* harmony export */ });
/* harmony import */ var groq_ContentSlots__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(18273);
/* harmony import */ var groq_shared_LocaleSeo__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16138);
/* harmony import */ var groq_shared_LocaleUrl__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63950);



var CategoryPageByUrl = '\n  [country == $country]\n  [_type == "CategoryPage"]\n  ['.concat((0,groq_shared_LocaleUrl__WEBPACK_IMPORTED_MODULE_1__/* .QueryByLocaleUrl */ .KM)("category->"), "]\n");
var CategoryPageQuery = "\n  *".concat(CategoryPageByUrl, "[0] {\n    _id,\n    _type,\n    online,\n    onlineFrom,\n    onlineTo,\n    ...(category -> {\n      id,\n      title,\n      ").concat((0,groq_shared_LocaleSeo__WEBPACK_IMPORTED_MODULE_2__/* .LocaleSeo */ .U)("seo"), ',\n    }),\n    "categoryPageSEO": {"noIndex": seo.noIndex},\n    content[] ').concat((0,groq_ContentSlots__WEBPACK_IMPORTED_MODULE_0__/* .SlotsGroqQuery */ .e6)(), ",\n    headersContent,\n  }\n");


/***/ }),

/***/ 89759:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ MarketingPageQuery; },
/* harmony export */   "a": function() { return /* binding */ MarketingPageByUrl; }
/* harmony export */ });
/* harmony import */ var groq_ContentSlots__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(18273);
/* harmony import */ var groq_shared_LocaleSeo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16138);


var MarketingPageByUrl = '\n  [country == $country]\n  [_type == "MarketingPage"]\n  [url.current == $url]\n';
var MarketingPageQuery = "\n  *".concat(MarketingPageByUrl, '[0] {\n    _id,\n    _type,\n    "online": true,\n    "onlineFrom": null,\n    "onlineTo": null,\n    ').concat((0,groq_shared_LocaleSeo__WEBPACK_IMPORTED_MODULE_1__/* .LocaleSeo */ .U)("seo"), ",\n    content[] ").concat((0,groq_ContentSlots__WEBPACK_IMPORTED_MODULE_0__/* .SlotsGroqQuery */ .e6)(), ",\n    headersContent,\n  }\n");


/***/ }),

/***/ 55723:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MH": function() { return /* binding */ StickyAddToCart_PDPTemplateQuery; },
/* harmony export */   "Ro": function() { return /* binding */ ProductDetails_PDPTemplateQuery; }
/* harmony export */ });
/* unused harmony export BelowProductStory_PDPTemplateQuery */
/* harmony import */ var groq_ContentSlots__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(18273);
/* harmony import */ var groq_documents__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96723);
/* harmony import */ var groq_shared_LocalePortableText__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57831);



var ProductDetails_PDPTemplateQuery = '\n*[_id == lower($country) + "-ProductDetailsPageTemplate"][0] {\n  _id,\n  _type,\n  aboveProductStory[] '.concat((0,groq_ContentSlots__WEBPACK_IMPORTED_MODULE_0__/* .SlotsGroqQuery */ .e6)(), ",\n  belowProductStory[] ").concat((0,groq_ContentSlots__WEBPACK_IMPORTED_MODULE_0__/* .SlotsGroqQuery */ .e6)(), ",\n  belowProductGoogleShopping[] ").concat((0,groq_ContentSlots__WEBPACK_IMPORTED_MODULE_0__/* .SlotsGroqQuery */ .e6)(), ",\n  soldOutRecommender[] -> {\n    ").concat((0,groq_documents__WEBPACK_IMPORTED_MODULE_1__/* .ProductRecommenderDocument */ .Qy)('_type == "ProductRecommender" =>'), ",\n    ").concat((0,groq_documents__WEBPACK_IMPORTED_MODULE_1__/* .ProductCarouselDocument */ .en)('_type == "ProductCarousel" =>'), ",\n  },\n  ").concat((0,groq_shared_LocalePortableText__WEBPACK_IMPORTED_MODULE_2__/* .LocalePortableText */ .O)("pdpCallout"), ",\n  stickyAddToCart,\n}\n");
var BelowProductStory_PDPTemplateQuery = '\n  *[_id == lower($country) + "-ProductDetailsPageTemplate"][0] {\n    _id,\n    _type,\n    belowProductStory[] '.concat((0,groq_ContentSlots__WEBPACK_IMPORTED_MODULE_0__/* .SlotsGroqQuery */ .e6)(), ",\n  }\n");
var StickyAddToCart_PDPTemplateQuery = '\n  *[_id == lower($country) + "-ProductDetailsPageTemplate"][0] {\n    _id,\n    _type,\n    stickyAddToCart,\n  }\n';


/***/ }),

/***/ 83070:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ MainFooterQuery; }
/* harmony export */ });
/* harmony import */ var groq_objects_CallToActionObject__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28008);
/* harmony import */ var groq_documents_SignUpFormDocument__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55835);


var MainFooterQuery = '*[_type == "MainFooter" && country == $country][0] {\n    _id,\n    _type,\n    '.concat((0,groq_objects_CallToActionObject__WEBPACK_IMPORTED_MODULE_0__/* .CallToActionObject */ .U)("supportLinks[]"), ",\n    ").concat((0,groq_objects_CallToActionObject__WEBPACK_IMPORTED_MODULE_0__/* .CallToActionObject */ .U)("aboutLinks[]"), ",\n    ").concat((0,groq_objects_CallToActionObject__WEBPACK_IMPORTED_MODULE_0__/* .CallToActionObject */ .U)("legalLinks[]"), ",\n    ").concat((0,groq_objects_CallToActionObject__WEBPACK_IMPORTED_MODULE_0__/* .CallToActionObject */ .U)("featuredLinks[]"), ",\n    ").concat((0,groq_documents_SignUpFormDocument__WEBPACK_IMPORTED_MODULE_1__/* .SignUpFormDocument */ .z)("signUpForm ->"), ",\n    ").concat((0,groq_documents_SignUpFormDocument__WEBPACK_IMPORTED_MODULE_1__/* .SignUpFormDocument */ .z)("signUpForms[] ->"), ",\n    signUpFormsData[]{\n      displayOnMobile,\n      ").concat((0,groq_documents_SignUpFormDocument__WEBPACK_IMPORTED_MODULE_1__/* .SignUpFormDocument */ .z)("signUpForm ->"), ",\n    },\n  }");


/***/ }),

/***/ 99550:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ PageTypeQuery; }
/* harmony export */ });
/* harmony import */ var groq_documents_Category__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(76155);
/* harmony import */ var groq_pages_CategoryPage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37333);
/* harmony import */ var groq_pages_MarketingPage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89759);



var PageTypeFields = "{\n  _id,\n  _type,\n  online,\n  onlineFrom,\n  onlineTo,\n}";
var PageTypeQuery = '{\n  "MarketingPage": *'.concat(groq_pages_MarketingPage__WEBPACK_IMPORTED_MODULE_2__/* .MarketingPageByUrl */ .a, "[0] ").concat(PageTypeFields, ',\n  "CategoryPage": *').concat(groq_pages_CategoryPage__WEBPACK_IMPORTED_MODULE_1__/* .CategoryPageByUrl */ .y, "[0] ").concat(PageTypeFields, ',\n  "category": *').concat(groq_documents_Category__WEBPACK_IMPORTED_MODULE_0__/* .CategoryByUrl */ .Y, "[0] ").concat(PageTypeFields, ",\n}");


/***/ }),

/***/ 57831:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ LocalePortableText; }
/* harmony export */ });
/* harmony import */ var groq_documents_FAQModuleDocument__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73050);
/* harmony import */ var groq_objects_CallToActionObject__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28008);
/* harmony import */ var groq_objects_SanityImageObject__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14075);



var LocalePortableText = function(field) {
    return '\n  "'.concat(field, '": coalesce(\n    ').concat(field, "[$locale],\n    ").concat(field, ".en_US,\n    ").concat(field, ".en_GB,\n    ").concat(field, ",\n  )[] {\n    ...,\n    markDefs[]{\n      _key,\n      _type,\n      id,\n      \"href\": coalesce(\n        @.href,\n        ''\n      ),\n      defined(_ref) => @-> {\n        \"href\": coalesce(\n          @.urls[$locale],\n          @.urls[$language],\n          @.url.current,\n          @.url,\n          ''\n        )\n      }\n    },\n    ").concat((0,groq_objects_CallToActionObject__WEBPACK_IMPORTED_MODULE_1__/* .CallToActionObject */ .U)("_type == 'cta' =>"), ",\n    ").concat((0,groq_objects_SanityImageObject__WEBPACK_IMPORTED_MODULE_2__/* .SanityImageObject */ .i)("_type == 'image' =>"), ",\n    ").concat(field === groq_documents_FAQModuleDocument__WEBPACK_IMPORTED_MODULE_0__/* .FAQ_ITEM_PORTABLE_TEXT_FIELD */ .z ? "" : (0,groq_documents_FAQModuleDocument__WEBPACK_IMPORTED_MODULE_0__/* .FAQModuleDocument */ .s)("_type == 'FaqModule' => @-> "), "\n  }\n");
};


/***/ }),

/***/ 16138:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "U": function() { return /* binding */ LocaleSeo; }
});

// UNUSED EXPORTS: LocaleSeoJSON

;// CONCATENATED MODULE: ./groq/shared/LocaleText.ts
// Schema: https://github.com/Global-eCom/sanity-studio-cms/blob/main/studio/schemas/objects/localeString.tsx
var LocaleText = function(field) {
    return '\n  "'.concat(field, '": coalesce(\n    ').concat(field, "[$locale],\n    ").concat(field, "[$language],\n    ").concat(field, ".en_GB,\n    ").concat(field, ".en_US,\n    ").concat(field, ".en,\n    ''\n  )\n");
};
var LocaleTextJSON = function(text) {
    return {
        _type: "localeString",
        en_US: text
    };
};

// EXTERNAL MODULE: ./groq/shared/LocaleString.ts
var LocaleString = __webpack_require__(1809);
;// CONCATENATED MODULE: ./groq/shared/LocaleSeo.ts
// Schema: https://github.com/Global-eCom/sanity-studio-cms/blob/main/studio/schemas/objects/seo.ts



var LocaleSeo = function(field) {
    return "\n  ".concat(field, " {\n    ").concat(LocaleText("pageDescriptions"), ",\n    ").concat((0,LocaleString/* LocaleString */.E)("pageTitles"), ",\n    ").concat(LocaleText("openGraphDescription"), ",\n    ").concat((0,LocaleString/* LocaleString */.E)("openGraphTitle"), ",\n    ").concat(LocaleText("twitterDescription"), ",\n    ").concat((0,LocaleString/* LocaleString */.E)("twitterTitle"), ",\n    \"twitterImageUrl\": twitterImageUrl.asset->url,\n    \"openGraphVideoUrl\": openGraphVideoUrl.source.asset->url,\n    \"openGraphImageUrl\": openGraphImageUrl.asset->url,\n    openGraphType,\n    noIndex,\n    'pageDescription': coalesce(\n      pageDescriptions[$locale],\n      pageDescriptions[$language],\n      pageDescription,\n      ''\n    ),\n    'pageTitle': coalesce(\n      pageTitles[$locale],\n      pageTitles[$language],\n      pageTitle,\n      ''\n    ),\n  }\n");
};
var LocaleSeoJSON = function(args) {
    return _object_spread({
        pageDescription: "",
        pageTitle: ""
    }, args);
};


/***/ }),

/***/ 1809:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ LocaleString; }
/* harmony export */ });
/* unused harmony export LocaleStringJSON */
// Schema: https://github.com/Global-eCom/sanity-studio-cms/blob/main/studio/schemas/objects/localeString.tsx
var LocaleString = function(field) {
    return '\n  "'.concat(field, '": coalesce(\n    ').concat(field, "[$locale],\n    ").concat(field, "[$language],\n    ").concat(field, ".en_GB,\n    ").concat(field, ".en_US,\n    ").concat(field, ".en,\n    ''\n  )\n");
};
var LocaleStringJSON = function(text) {
    return {
        _type: "localeString",
        en_US: text
    };
};


/***/ }),

/***/ 63950:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "KM": function() { return /* binding */ QueryByLocaleUrl; },
/* harmony export */   "mR": function() { return /* binding */ LocaleReferenceUrl; },
/* harmony export */   "wS": function() { return /* binding */ LocaleUrl; }
/* harmony export */ });
/* unused harmony export DereferenceUrl */
var LocaleUrl = "\n  \"url\": coalesce(\n    urls[$locale],\n    urls[$language],\n    urls.en_GB,\n    urls.en_US,\n    urls.en,\n    url,\n    ''\n  )\n";
var DereferenceUrl = function(referenceDocumentName) {
    return "\n  coalesce(\n    ".concat(referenceDocumentName, " -> urls[$locale],\n    ").concat(referenceDocumentName, " -> urls[$language],\n    ").concat(referenceDocumentName, " -> urls.en_GB,\n    ").concat(referenceDocumentName, " -> urls.en_US,\n    ").concat(referenceDocumentName, " -> urls.en,\n    ").concat(referenceDocumentName, " -> url\n  )\n");
};
var LocaleReferenceUrl = function(field) {
    return '\n  "'.concat(field, '": coalesce(\n    ').concat(DereferenceUrl("category"), ",\n    ").concat(DereferenceUrl("route"), ",\n    \"articles/\" + article -> puid.current,\n    marketing -> url.current,\n    support -> url.current,\n    product,\n    core,\n    absolute,\n    link,\n    ''\n  )\n");
};
var QueryByLocaleUrl = function() {
    var deref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return "\n  $url == ".concat(deref, "urls[$locale] ||\n  $url == ").concat(deref, "urls.en_GB ||\n  $url == ").concat(deref, "urls.en_US ||\n  $url == ").concat(deref, "url\n");
};


/***/ }),

/***/ 88035:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ MainNavItemLink; }
/* harmony export */ });
/* harmony import */ var groq_objects_SanityImageObject__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14075);
/* harmony import */ var _LocaleString__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1809);
/* harmony import */ var _LocaleUrl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(63950);



var MainNavItemLink = function(field) {
    return "\n  ".concat(field, " {\n    category -> {\n      ").concat(_LocaleUrl__WEBPACK_IMPORTED_MODULE_0__/* .LocaleUrl */ .wS, ",\n      hasItemsInStock,\n      online,\n      onlineFrom,\n      onlineTo,\n      showEvenEmpty,\n      ").concat((0,_LocaleString__WEBPACK_IMPORTED_MODULE_1__/* .LocaleString */ .E)("title"), ",\n      ").concat((0,groq_objects_SanityImageObject__WEBPACK_IMPORTED_MODULE_2__/* .SanityImageObject */ .i)("image"), ",\n    },\n    ").concat((0,_LocaleUrl__WEBPACK_IMPORTED_MODULE_0__/* .LocaleReferenceUrl */ .mR)("href"), ",\n    query,\n    newtab,\n  }\n");
};


/***/ }),

/***/ 78842:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BH": function() { return /* binding */ getFirstFocusTarget; },
/* harmony export */   "Iy": function() { return /* binding */ isRelatedNode; },
/* harmony export */   "Zv": function() { return /* binding */ getFocusTargets; },
/* harmony export */   "kv": function() { return /* binding */ getNextFocusTarget; }
/* harmony export */ });
// Source: https://github.com/KittyGiraudel/focusable-selectors/blob/efa886e/index.js
// MIT License, Copyright (c) 2021 Kitty Giraudel
var focusableSelector = [
    "a[href]",
    // 'area[href]',
    'input:not([type="hidden"]):not([type="radio"]):not([disabled])',
    'input[type="radio"]:not([disabled])',
    "select:not([disabled])",
    "textarea:not([disabled])",
    "button:not([disabled])",
    // 'iframe',
    "audio[controls]",
    "video[controls]",
    "[contenteditable]",
    "[tabindex]", 
].join(",");
var isUntabbable = function(element) {
    return !element.matches || !!element.matches('[tabindex^="-"], [aria-modal]');
};
var getFocusTargets = function(node) {
    var nodelist = node.querySelectorAll(focusableSelector);
    var targets = Array.prototype.slice.call(nodelist);
    return targets.filter(function(target) {
        // Filter out elements that have been marked as untabbable
        var parent = target;
        while(parent && parent !== node){
            if (isUntabbable(parent)) return false;
            parent = parent.parentElement;
        }
        // Filter by visible elements, exclude visually hidden ones
        return target.offsetWidth || target.offsetHeight || target.getClientRects().length;
    });
};
var getNextFocusTarget = function(node, reverse) {
    var root = document.querySelector("main") || document.body;
    var parent = node;
    while(parent && parent !== root){
        var sibling = parent;
        while(sibling){
            sibling = sibling[reverse ? "previousSibling" : "nextSibling"];
            if (!sibling || isUntabbable(sibling)) continue;
            var focusTargets = getFocusTargets(sibling);
            if (focusTargets.length) {
                return focusTargets[reverse ? focusTargets.length - 1 : 0];
            }
        }
        parent = parent.parentElement;
    }
    return null;
};
var getFirstFocusTarget = function(node) {
    return node.querySelector("[autofocus]") || node.querySelector(focusableSelector) || null;
};
var isRelatedNode = function(owner, node) {
    return !!(node && owner && (owner === node || owner.contains(node) || node.contains(owner)));
};


/***/ }),

/***/ 71129:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "yn": function() { return /* reexport */ useBodyScrollLock; },
  "sH": function() { return /* reexport */ useDialogDismiss; },
  "P5": function() { return /* reexport */ useFocusTrap; },
  "ii": function() { return /* reexport */ useListboxFocus; }
});

// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
;// CONCATENATED MODULE: ./hooks/a11y/useDialogDismiss.ts

function useDialogDismiss(props) {
    var ref = props.ref, external = props.external, handler = props.handler;
    (0,react.useEffect)(function() {
        var onKeydown = function(event) {
            if (event.isComposing || event.defaultPrevented || event.code !== "Escape") {
                return;
            }
            event.preventDefault();
            handler(event);
        };
        var onClick = function(event) {
            var ref1;
            if ((external === null || external === void 0 ? void 0 : external.current) === event.target || (external === null || external === void 0 ? void 0 : (ref1 = external.current) === null || ref1 === void 0 ? void 0 : ref1.contains(event.target)) || !ref.current || ref.current.contains(event.target)) {
                return;
            }
            event.stopPropagation();
            handler(event);
        };
        document.addEventListener("keydown", onKeydown);
        document.addEventListener("mousedown", onClick);
        document.addEventListener("touchstart", onClick);
        return function() {
            document.removeEventListener("keydown", onKeydown);
            document.removeEventListener("mousedown", onClick);
            document.removeEventListener("touchstart", onClick);
        };
    }, [
        ref,
        external,
        handler
    ]);
}

// EXTERNAL MODULE: ../node_modules/@global-ecom/nitro-uds/dist/hooks/esm/index.js
var esm = __webpack_require__(68138);
// EXTERNAL MODULE: ./hooks/useWindowSize.ts
var useWindowSize = __webpack_require__(45746);
// EXTERNAL MODULE: ./hooks/useIsServer.ts
var useIsServer = __webpack_require__(64724);
;// CONCATENATED MODULE: ./hooks/a11y/useBodyScrollLock.ts



var scrollLockCounter = 0;
function useBodyScrollLock(isActive) {
    var ref = (0,useWindowSize/* useWindowSize */.i)(), width = ref.width, height = ref.height;
    var isServer = (0,useIsServer/* useIsServer */.w)();
    var scrolbarWidth = isServer ? 0 : window.innerWidth - document.body.offsetWidth;
    (0,esm/* useIsomorphicLayoutEffect */.LI)(function() {
        if (!isActive) return;
        var scrollY = window.scrollY;
        if (scrollLockCounter++ === 0) {
            document.body.style.position = "fixed";
            document.body.style.top = "-".concat(scrollY, "px");
            document.body.style.width = "calc(100vw - ".concat(scrolbarWidth, "px)");
        }
        return function() {
            if (--scrollLockCounter === 0) {
                document.body.style.position = "";
                document.body.style.top = "";
                document.body.style.width = "100%";
                window.scrollTo(0, scrollY);
            }
        };
    }, [
        isActive,
        width,
        height
    ]);
}

// EXTERNAL MODULE: ./hooks/a11y/focus.ts
var a11y_focus = __webpack_require__(78842);
// EXTERNAL MODULE: ./hooks/a11y/useFocusVisible.ts
var useFocusVisible = __webpack_require__(2235);
;// CONCATENATED MODULE: ./hooks/a11y/useFocusTrap.ts




/** Activates a focus trap on the element targeted with the `React.RefObject`. This will trap focus within the container and prevent it from leaving it until it's closed. */ function useFocusTrap(props) {
    var ref = props.ref, isActive = props.isActive, isFocused = props.isFocused;
    var restoreFocusTo = (0,react.useRef)(null);
    (0,esm/* useIsomorphicLayoutEffect */.LI)(function() {
        var container = ref.current;
        if (!container) {
            return;
        } else {
            container.setAttribute("tabindex", "-1");
        }
        if (!isActive) {
            container.setAttribute("aria-hidden", "true");
        } else {
            container.setAttribute("aria-hidden", "false");
            if (!container.hasAttribute("aria-modal")) {
                container.setAttribute("aria-modal", "false");
            }
        }
        return function() {
            // Mark container as hidden, to indicate to screen readers that it's inactive
            container.setAttribute("aria-hidden", "true");
        };
    }, [
        ref.current,
        isActive
    ]);
    (0,esm/* useIsomorphicLayoutEffect */.LI)(function() {
        if (!isActive) return;
        restoreFocusTo.current = document.activeElement;
        // Focus the first focusable element in the container
        if (ref.current) {
            var focusTarget = (0,a11y_focus/* getFirstFocusTarget */.BH)(ref.current);
            if (focusTarget && focusTarget !== document.activeElement) {
                focusTarget.focus();
            }
        }
        var onBlur = function(event) {
            var container = ref.current;
            if (!container) return;
            // If focus has left the container then move it back to the first focus target
            if ((0,a11y_focus/* isRelatedNode */.Iy)(container, event.target) && (!event.relatedTarget || !(0,a11y_focus/* isRelatedNode */.Iy)(container, event.relatedTarget))) {
                var focusTarget = (0,a11y_focus/* getFirstFocusTarget */.BH)(container);
                if (focusTarget) focusTarget.focus();
            }
        };
        var onKeydown = function(event) {
            var container = ref.current;
            if (!container) return;
            if (!event.defaultPrevented && container && event.code === "Tab") {
                var focusTargets = (0,a11y_focus/* getFocusTargets */.Zv)(container);
                var focusedIndex = focusTargets.indexOf(document.activeElement);
                // Cycle focus when the focus is about to leave the container
                if (!focusTargets.length) {
                    return;
                } else if (event.shiftKey && focusedIndex === 0) {
                    event.preventDefault();
                    focusTargets[focusTargets.length - 1].focus();
                } else if (!event.shiftKey && focusedIndex === focusTargets.length - 1 || !event.shiftKey && !(0,useFocusVisible/* isFocusVisible */.E)() && focusedIndex === 0) {
                    event.preventDefault();
                    (0,useFocusVisible/* addFocusVisible */.Jo)();
                    focusTargets[0].focus();
                }
            }
        };
        if (!isFocused) {
            document.body.addEventListener("focusout", onBlur);
        }
        document.addEventListener("keydown", onKeydown);
        return function() {
            document.body.removeEventListener("focusout", onBlur);
            document.removeEventListener("keydown", onKeydown);
            // Restore focus to the previously focused element
            if (restoreFocusTo.current) restoreFocusTo.current.focus();
        };
    }, [
        ref,
        isActive
    ]);
}

;// CONCATENATED MODULE: ./hooks/a11y/useListboxFocus.ts



/** Activates listbox navigation on the element targeted with the `React.RefObject`. This will allow WAI-ARIA-compliant navigation with arrow keys in a secondary list. By default this list isn't auto focused or tabbable unlike a modal (Compared to `useFocusTrap`) */ function useListboxFocus(ref) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var ownerRef = options.ownerRef;
    var isActive = options.isActive !== false;
    var allowFocus = !!options.allowFocus;
    var returnFocus = !!options.returnFocus;
    var autoFocus = !!options.autoFocus;
    var _$ref = (0,react.useState)(false), active = _$ref[0], setActive = _$ref[1];
    (0,esm/* useIsomorphicLayoutEffect */.LI)(function() {
        var container = ref.current;
        if (!container) {
            return;
        } else if (!allowFocus) {
            container.setAttribute("tabindex", "-1");
        }
        if (!isActive) {
            container.setAttribute("aria-hidden", "true");
            if (active && returnFocus) {
                var _$ref;
                ownerRef === null || ownerRef === void 0 ? void 0 : (_$ref = ownerRef.current) === null || _$ref === void 0 ? void 0 : _$ref.focus();
            }
            setActive(false);
        } else {
            container.setAttribute("aria-hidden", "false");
            setActive(true);
        }
    }, [
        ref.current,
        active,
        setActive,
        allowFocus,
        isActive
    ]);
    (0,esm/* useIsomorphicLayoutEffect */.LI)(function() {
        if (!isActive) return;
        // Focus the first focusable element in the container
        if (autoFocus && ref.current) {
            var focusTarget = (0,a11y_focus/* getFirstFocusTarget */.BH)(ref.current);
            if (focusTarget) focusTarget.focus();
        }
        var willEnterFocus = false;
        var isFocusingForward = true;
        var onClick = function(event) {
            if (ref.current && (0,a11y_focus/* getFocusTargets */.Zv)(ref.current).indexOf(event.target) > -1) {
                willEnterFocus = true;
            }
        };
        var onFocusIn = function(event) {
            var container = ref.current;
            if (/* Focus shouldn't be prevented when it was explicitly moved */ !container || willEnterFocus || allowFocus || ownerRef && event.target === ownerRef.current) {
                willEnterFocus = false;
                return;
            }
            // Prevent focus from automatically entering the listbox
            if ((0,a11y_focus/* isRelatedNode */.Iy)(container, event.target) && !(0,a11y_focus/* isRelatedNode */.Iy)(container, event.relatedTarget)) {
                var parent = ownerRef && ownerRef.current || container;
                var previousTarget = (0,a11y_focus/* getNextFocusTarget */.kv)(parent, true);
                var nextTarget = (0,a11y_focus/* getNextFocusTarget */.kv)(parent, false);
                var target = isFocusingForward && nextTarget || previousTarget !== event.relatedTarget && previousTarget || nextTarget !== event.relatedTarget && nextTarget || null;
                if (target) {
                    event.preventDefault();
                    target.focus();
                }
            }
        };
        var onKeydown = function(event) {
            var container = ref.current;
            if (event.defaultPrevented || !container) {
                return;
            }
            var activeElement = document.activeElement;
            var isInputActive = activeElement && activeElement.tagName === "INPUT";
            var focusTargets = (0,a11y_focus/* getFocusTargets */.Zv)(container);
            if (event.code === "Tab" && !allowFocus) {
                isFocusingForward = !event.shiftKey;
                if (container.contains(activeElement)) {
                    var parent = ownerRef && ownerRef.current || container;
                    var target = (0,a11y_focus/* getNextFocusTarget */.kv)(parent, event.shiftKey);
                    if (target) {
                        event.preventDefault();
                        target.focus();
                    }
                }
            } else if (!focusTargets.length) {
                return;
            } else if (!autoFocus && (!ownerRef || !(0,a11y_focus/* isRelatedNode */.Iy)(activeElement, ownerRef.current)) && !(0,a11y_focus/* isRelatedNode */.Iy)(activeElement, container)) {
                return;
            } else if (!isInputActive && event.code === "ArrowRight" || event.code === "ArrowDown") {
                event.preventDefault();
                var focusedIndex = focusTargets.indexOf(activeElement);
                var nextFocusIndex = focusedIndex < focusTargets.length - 1 && focusedIndex >= 0 ? focusedIndex + 1 : 0;
                willEnterFocus = true;
                focusTargets[nextFocusIndex].focus();
            } else if (!isInputActive && event.code === "ArrowLeft" || event.code === "ArrowUp") {
                event.preventDefault();
                var focusedIndex1 = focusTargets.indexOf(activeElement);
                var nextFocusIndex1 = focusedIndex1 > 0 ? focusedIndex1 - 1 : focusTargets.length - 1;
                willEnterFocus = true;
                focusTargets[nextFocusIndex1].focus();
            } else if (ownerRef && ownerRef.current && ownerRef.current.tagName === "INPUT" && activeElement !== ownerRef.current && /^(Key|Digit)/.test(event.code)) {
                ownerRef.current.focus();
            }
        };
        if (ref.current) {
            ref.current.addEventListener("mousedown", onClick, true);
        }
        document.body.addEventListener("focusin", onFocusIn);
        document.addEventListener("keydown", onKeydown);
        return function() {
            if (ref.current) {
                ref.current.removeEventListener("mousedown", onClick);
            }
            document.body.removeEventListener("focusin", onFocusIn);
            document.removeEventListener("keydown", onKeydown);
        };
    }, [
        ref,
        isActive,
        allowFocus,
        autoFocus
    ]);
}

;// CONCATENATED MODULE: ./hooks/a11y/index.ts






/***/ }),

/***/ 2235:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ isFocusVisible; },
/* harmony export */   "Jo": function() { return /* binding */ addFocusVisible; },
/* harmony export */   "_Y": function() { return /* binding */ useFocusVisible; }
/* harmony export */ });
/* unused harmony export removeFocusVisible */
/* harmony import */ var _global_ecom_nitro_uds_hooks__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68138);
/* harmony import */ var hooks_useDeviceInteraction__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16643);
/* harmony import */ var _useIsServer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64724);



var focusClassName = "focus-visible";
function addFocusVisible(container) {
    var ref;
    (ref = container || document.querySelector("body")) === null || ref === void 0 ? void 0 : ref.classList.add(focusClassName);
}
function removeFocusVisible(container) {
    var ref;
    (ref = container || document.querySelector("body")) === null || ref === void 0 ? void 0 : ref.classList.remove(focusClassName);
}
function isFocusVisible(container) {
    var ref;
    return (ref = container || document.querySelector("body")) === null || ref === void 0 ? void 0 : ref.classList.contains(focusClassName);
}
function useFocusVisible(ref) {
    var isServer = (0,_useIsServer__WEBPACK_IMPORTED_MODULE_2__/* .useIsServer */ .w)();
    var container = ref ? ref.current : !isServer && document.body;
    var isKeyboardActive = (0,hooks_useDeviceInteraction__WEBPACK_IMPORTED_MODULE_1__/* .useDeviceInteraction */ .u)().isKeyboardActive;
    (0,_global_ecom_nitro_uds_hooks__WEBPACK_IMPORTED_MODULE_0__/* .useIsomorphicLayoutEffect */ .LI)(function() {
        if (!container) return;
        var onFocus = function() {
            if (isKeyboardActive) {
                addFocusVisible(container);
            } else {
                removeFocusVisible(container);
            }
        };
        container.addEventListener("focusin", onFocus, true);
        return function() {
            container.addEventListener("focusin", onFocus, true);
        };
    }, [
        container,
        isKeyboardActive
    ]);
}


/***/ }),

/***/ 35855:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "gX": function() { return /* binding */ ModalContentType; },
/* harmony export */   "ie": function() { return /* binding */ useAccountSettings; },
/* harmony export */   "nE": function() { return /* binding */ AccountSettingsProvider; }
/* harmony export */ });
/* unused harmony export AccountSettingsContext */
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5341);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27378);
/* harmony import */ var utils_analytics__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83168);




var ModalContentType;
(function(ModalContentType) {
    ModalContentType["PersonalDetails"] = "personal details";
    ModalContentType["EmailAndPassword"] = "email & password";
    ModalContentType["EmailNotifications"] = "email notifications";
    ModalContentType["SmsDeliveryNotifications"] = "sms delivery notifications";
})(ModalContentType || (ModalContentType = {}));
var AccountSettingsContext = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createContext({
    contentType: undefined,
    openModal: function() {
        return null;
    },
    closeModal: function() {
        return null;
    },
    isModalVisible: false,
    setIsModalVisible: function() {
        return null;
    },
    userProfile: undefined,
    setUserProfile: function() {
        return null;
    },
    notificationPreferences: undefined,
    setNotificationPreferences: function() {
        return null;
    },
    newsletterPreferences: undefined,
    setNewsletterPreferences: function() {
        return null;
    }
});
var AccountSettingsProvider = function(props) {
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_1__.useState(), 2), contentType = ref[0], setContentType = ref[1];
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_1__.useState(false), 2), isModalVisible = ref1[0], setIsModalVisible = ref1[1];
    var ref2 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_1__.useState(), 2), userProfile = ref2[0], setUserProfile = ref2[1];
    var ref3 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_1__.useState(), 2), notificationPreferences = ref3[0], setNotificationPreferences = ref3[1];
    var ref4 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_1__.useState(), 2), newsletterPreferences = ref4[0], setNewsletterPreferences = ref4[1];
    var openModal = react__WEBPACK_IMPORTED_MODULE_1__.useCallback(function(contentType) {
        setContentType(contentType);
        setIsModalVisible(true);
        (0,utils_analytics__WEBPACK_IMPORTED_MODULE_2__/* .myAccountUserSettingsEvent */ .yV)({
            userAction: "edit",
            section: contentType
        });
    }, []);
    var closeModal = react__WEBPACK_IMPORTED_MODULE_1__.useCallback(function() {
        setIsModalVisible(false);
    }, []);
    var providerValue = react__WEBPACK_IMPORTED_MODULE_1__.useMemo(function() {
        return {
            contentType: contentType,
            openModal: openModal,
            closeModal: closeModal,
            isModalVisible: isModalVisible,
            setIsModalVisible: setIsModalVisible,
            userProfile: userProfile,
            setUserProfile: setUserProfile,
            notificationPreferences: notificationPreferences,
            setNotificationPreferences: setNotificationPreferences,
            newsletterPreferences: newsletterPreferences,
            setNewsletterPreferences: setNewsletterPreferences
        };
    }, [
        contentType,
        openModal,
        closeModal,
        isModalVisible,
        setIsModalVisible,
        userProfile,
        setUserProfile,
        notificationPreferences,
        setNotificationPreferences,
        newsletterPreferences,
        setNewsletterPreferences, 
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AccountSettingsContext.Provider, {
        value: providerValue,
        children: props.children
    });
};
var useAccountSettings = function() {
    return react__WEBPACK_IMPORTED_MODULE_1__.useContext(AccountSettingsContext);
};


/***/ }),

/***/ 72507:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ho": function() { return /* binding */ AuthProvider; },
/* harmony export */   "aC": function() { return /* binding */ useAuth; }
/* harmony export */ });
/* unused harmony export AuthContext */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(23842);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(85034);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(70169);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5341);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(59312);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27378);
/* harmony import */ var gql_exchanges_auth_cookie__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62900);
/* harmony import */ var _generated_graphql__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(37678);
/* harmony import */ var _useFeature__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(53625);










var AuthContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({});
var AuthProvider = function(param) {
    var country = param.country, language = param.language, auth = param.auth, setAuth = param.setAuth, children = param.children;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_generated_graphql__WEBPACK_IMPORTED_MODULE_3__/* .useLogoutMutation */ ._y5)(), 2), logout = ref[1];
    var popoverLoginEnabled = (0,_useFeature__WEBPACK_IMPORTED_MODULE_4__/* .useFeature */ .S)("POPOVER_LOGIN_ENABLED");
    var clearOpluxDetectionPreferences = function() {
        window.localStorage.removeItem("skip-oplux-detection");
    };
    // On logout we delete all cookies then redirect the user to the homepage
    var handleLogout = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(redirection) {
            var _tmp, baseHref;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _tmp = {};
                        return [
                            4,
                            logout(_tmp)
                        ];
                    case 1:
                        _state.sent();
                        (0,gql_exchanges_auth_cookie__WEBPACK_IMPORTED_MODULE_2__/* .destroyStoredAuthData */ .Cj)(country);
                        clearOpluxDetectionPreferences();
                        if (popoverLoginEnabled && !window.location.pathname.includes("/account")) {
                            window.location.reload();
                            window.scrollTo(0, 0);
                        } else {
                            baseHref = "/".concat(country, "/").concat(language);
                            window.location.href = !redirection ? baseHref : baseHref + redirection;
                        }
                        window.localStorage.removeItem("otpToken");
                        return [
                            2
                        ];
                }
            });
        // We only want to define this function on initial render
        // when both country and language will be defined
        // eslint-disable-next-line react-hooks/exhaustive-deps
        });
        return function(redirection) {
            return _ref.apply(this, arguments);
        };
    }(), []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AuthContext.Provider, {
        value: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, auth), {
            setAuth: setAuth,
            logout: handleLogout
        }),
        children: children
    });
};
var useAuth = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(AuthContext);
};


/***/ }),

/***/ 6781:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ useAvailableNavItemFilter; }
/* harmony export */ });
/* harmony import */ var utils_isContentOnline__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89996);

var useAvailableNavItemFilter = function(result, preview) {
    if (!result) return [];
    return JSON.parse(JSON.stringify(result), function(key, value) {
        return key === "children" || key === "navChildren" ? value === null || value === void 0 ? void 0 : value.filter(function(child) {
            var isItemAvailable = (0,utils_isContentOnline__WEBPACK_IMPORTED_MODULE_0__/* .isContentOnline */ .e)({
                onlineFrom: child === null || child === void 0 ? void 0 : child.availableFrom,
                onlineTo: child === null || child === void 0 ? void 0 : child.availableTo
            }, preview);
            if (!isItemAvailable) return false;
            // NOTE: taken from the current graphql resolver still used by the app
            // https://github.com/cyber-cats/puma-gql/blob/main/src/graphql/content/MainNav.ts#L182
            if (child.link.category) {
                var category = child.link.category;
                if (child.image) {
                    category.image = child.image;
                }
                var hasStock = category.hasItemsInStock;
                var showEmpty = category.showEvenEmpty;
                var isOnline = category.online && (!category.onlineFrom || +new Date(category.onlineFrom) < +new Date()) && (!category.onlineTo || +new Date(category.onlineTo) > +new Date());
                return isOnline && (hasStock || showEmpty);
            }
            return true;
        }) : value;
    });
};


/***/ }),

/***/ 75073:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85034);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70169);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var _global_ecom_nitro_uds_hooks__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68138);
/* harmony import */ var _useIsServer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64724);





var useAvailableSpace = function(parentRef, data) {
    var isServer = (0,_useIsServer__WEBPACK_IMPORTED_MODULE_2__/* .useIsServer */ .w)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(function() {
        return {
            calculated: false,
            items: data.map(function(dataObject) {
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, dataObject), {
                    hidden: false
                });
            })
        };
    }), state = ref[0], setState = ref[1];
    (0,_global_ecom_nitro_uds_hooks__WEBPACK_IMPORTED_MODULE_1__/* .useIsomorphicLayoutEffect */ .LI)(function() {
        if (isServer || !parentRef.current) return;
        var ro = new window.ResizeObserver(function(entries) {
            var ref;
            var width = entries[0].contentRect.width;
            var visible = 0;
            if (parentRef === null || parentRef === void 0 ? void 0 : (ref = parentRef.current) === null || ref === void 0 ? void 0 : ref.children) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Array.from(parentRef.current.children)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var child = _step.value;
                        if (width > child.offsetWidth) visible++;
                        var style = window.getComputedStyle(child);
                        width = width - (child.offsetWidth + parseFloat(style.marginLeft) + parseFloat(style.marginRight));
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var items = data.map(function(dataObject, i) {
                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, dataObject), {
                        hidden: i >= visible
                    });
                });
                setState({
                    calculated: true,
                    items: items
                });
            }
        });
        var element = parentRef.current;
        ro.observe(element);
        return function() {
            return ro.unobserve(element);
        };
    }, [
        JSON.stringify(data),
        parentRef.current
    ]);
    return state;
};
/* harmony default export */ __webpack_exports__["Z"] = (useAvailableSpace);


/***/ }),

/***/ 99778:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ BrowsingHistoryProvider; },
/* harmony export */   "k": function() { return /* binding */ useBrowsingHistory; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3204);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27378);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86677);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_analytics__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(83168);





var BrowsingHistoryContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({
    pathHistory: [],
    prevPath: ""
});
var useBrowsingHistory = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(BrowsingHistoryContext);
};
var useBrowsingHistoryProvider = function() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([
        router.asPath
    ]), pathHistory = ref[0], setPathHistory = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var handleRouteChange = function(url) {
            var ref;
            setPathHistory(function(prev) {
                return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(prev).concat([
                    url
                ]);
            });
            var prevPath = (ref = pathHistory[pathHistory.length - 1]) === null || ref === void 0 ? void 0 : ref.split("?")[0];
            var path = url.split("?")[0];
            if (prevPath !== path) {
                (0,_utils_analytics__WEBPACK_IMPORTED_MODULE_3__/* .activateOptimize */ .Du)();
            }
        };
        router.events.on("routeChangeComplete", handleRouteChange);
        return function() {
            return router.events.off("routeChangeComplete", handleRouteChange);
        };
    }, [
        pathHistory,
        router.events
    ]);
    var browsingHistory = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return {
            pathHistory: pathHistory,
            prevPath: pathHistory[pathHistory.length - 2]
        };
    }, [
        pathHistory
    ]);
    return browsingHistory;
};
var BrowsingHistoryProvider = function(param) {
    var children = param.children;
    var browsingHistory = useBrowsingHistoryProvider();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BrowsingHistoryContext.Provider, {
        value: browsingHistory,
        children: children
    });
};


/***/ }),

/***/ 69771:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ useCart; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(23842);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(17599);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(85034);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(70169);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(31373);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(5341);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(3204);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(59312);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var _generated_graphql__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37678);
/* harmony import */ var hooks_useIsServer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64724);
/* harmony import */ var utils_analytics__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(83168);
/* harmony import */ var types_analyticTypes__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(90099);
/* harmony import */ var utils_bloomreach__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(61060);
/* harmony import */ var utils_ga4Items__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(54093);
/* harmony import */ var store__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(57023);
/* harmony import */ var _useMiniCart__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(38859);
/* harmony import */ var _useSiteConfig__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(20368);
/* harmony import */ var _useEmarsysWebExtend__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(78108);
/* harmony import */ var _useGA4Events__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(89113);
/* harmony import */ var _usePageEventsContext__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(43308);
/* harmony import */ var _useFeature__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(53625);






















var useCart = function() {
    var cartQueryOptions = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var ref;
    var isServer = (0,hooks_useIsServer__WEBPACK_IMPORTED_MODULE_2__/* .useIsServer */ .w)();
    var currency = (0,_useSiteConfig__WEBPACK_IMPORTED_MODULE_8__/* .useSiteConfig */ .N)().currency;
    var openMiniCart = (0,_useMiniCart__WEBPACK_IMPORTED_MODULE_7__/* .useMiniCart */ .lm)().openMiniCart;
    var trackCartUpdate = (0,_useEmarsysWebExtend__WEBPACK_IMPORTED_MODULE_9__/* .useEmarsysWebExtend */ ._)().trackCartUpdate;
    var pageviewEventHasFired = (0,_usePageEventsContext__WEBPACK_IMPORTED_MODULE_11__/* .usePageEventsContext */ .qN)().pageviewEventHasFired;
    var setTempState = (0,store__WEBPACK_IMPORTED_MODULE_6__/* .useTempStateStore */ .nx)().setTempState;
    var ref1 = (0,_useGA4Events__WEBPACK_IMPORTED_MODULE_10__/* .useGA4Events */ .tL)(), imageType = ref1.imageType, imageNumber = ref1.imageNumber;
    var triggerCartTotalEvent = (0,_useFeature__WEBPACK_IMPORTED_MODULE_12__/* .useFeature */ .S)("TRIGGER_CART_TOTAL_EVENT");
    var _pause;
    var ref2 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)((0,_generated_graphql__WEBPACK_IMPORTED_MODULE_1__/* .useCartQuery */ .CMH)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({}, cartQueryOptions), {
        // we always want to avoid invoking this query on the server, even when
        // overriding pause conditions are included
        pause: isServer || ((_pause = cartQueryOptions.pause) !== null && _pause !== void 0 ? _pause : false)
    })), 2), cartResult = ref2[0], refetch = ref2[1];
    var cart = (ref = cartResult.data) === null || ref === void 0 ? void 0 : ref.activeCart;
    var cartId = (cart === null || cart === void 0 ? void 0 : cart.id) || "";
    var ref3 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)((0,_generated_graphql__WEBPACK_IMPORTED_MODULE_1__/* .useAddItemsToCartMutation */ .XB0)(), 2), addItemsToCart = ref3[1];
    var addToCart = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function(items, additionalGAProductData) {
            var showMiniCart, currentUrl, ref, itemsArray, productReferrer, _tmp, itemsToAdd, _tmp1, res, _tmp2, ref1, addedProducts;
            var _arguments = arguments;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        showMiniCart = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : true, currentUrl = _arguments.length > 3 && _arguments[3] !== void 0 ? _arguments[3] : "/";
                        itemsArray = Array.isArray(items) ? items : [
                            items
                        ];
                        // we save temporally the id of the product added to cart to later use in the miniCart logic
                        setTempState("IdOfLastProductAddedToCart", itemsArray[0].productId);
                        _tmp = {};
                        productReferrer = (additionalGAProductData === null || additionalGAProductData === void 0 ? void 0 : additionalGAProductData[types_analyticTypes__WEBPACK_IMPORTED_MODULE_4__/* .Dimensions.d100 */ .Db.d100]) ? additionalGAProductData : (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(_tmp, types_analyticTypes__WEBPACK_IMPORTED_MODULE_4__/* .Dimensions.d100 */ .Db.d100, "");
                        _tmp1 = {};
                        itemsToAdd = itemsArray.reduce(function(acc, _param) {
                            var swatch = _param.swatch, size = _param.size, productId = _param.productId, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)(_param, [
                                "swatch",
                                "size",
                                "productId"
                            ]);
                            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({}, acc), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)({}, productId, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({
                                productId: productId
                            }, rest)));
                        }, _tmp1);
                        _tmp2 = {};
                        return [
                            4,
                            addItemsToCart((_tmp2.input = {
                                items: Object.values(itemsToAdd),
                                basketId: cartId
                            }, _tmp2))
                        ];
                    case 1:
                        res = _state.sent();
                        if ((ref = res.data) === null || ref === void 0 ? void 0 : ref.addItemsToCart) {
                            ;
                            if (triggerCartTotalEvent) (0,utils_analytics__WEBPACK_IMPORTED_MODULE_3__/* .sessionCartTotalEvent */ .kF)((ref1 = res.data) === null || ref1 === void 0 ? void 0 : ref1.addItemsToCart.subTotal);
                            addedProducts = res.data.addItemsToCart.products.reduce(function(acc, item) {
                                if (item.__typename === "ProductCartItem" && itemsToAdd[item.product.id]) {
                                    return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)(acc).concat([
                                        (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({}, item), {
                                            addedQuantity: itemsToAdd[item.product.id].quantity
                                        }), 
                                    ]);
                                }
                                return acc;
                            }, []);
                            if (addedProducts) {
                                if (showMiniCart) openMiniCart(addedProducts);
                                trackCartUpdate();
                                addedProducts.forEach(function(addedProduct) {
                                    (0,utils_analytics__WEBPACK_IMPORTED_MODULE_3__/* .event */ .B)(utils_analytics__WEBPACK_IMPORTED_MODULE_3__/* .AnalyticsEvents.ADD_TO_CART */ ._q.ADD_TO_CART, {
                                        ecommerce: {
                                            currencyCode: currency.code,
                                            add: {
                                                products: [
                                                    (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({}, (0,utils_analytics__WEBPACK_IMPORTED_MODULE_3__/* .transformVariantProductToAnalyticsProduct */ .Tp)(addedProduct.product, true)), {
                                                        price: addedProduct.inCartPrice,
                                                        quantity: addedProduct.addedQuantity,
                                                        variant: addedProduct.product.id,
                                                        brand: addedProduct.product.brand || "PUMA",
                                                        category: addedProduct.product.primaryCategoryId
                                                    }), productReferrer), 
                                                ]
                                            }
                                        }
                                    });
                                    if (pageviewEventHasFired) {
                                        var ref;
                                        var ga4Item = (0,utils_ga4Items__WEBPACK_IMPORTED_MODULE_21__/* .getGa4Item */ .Vr)((ref = addedProduct.product) === null || ref === void 0 ? void 0 : ref.styleNumber);
                                        if (ga4Item) {
                                            var ref1;
                                            var modifiedGa4Item = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({}, ga4Item), {
                                                cart: "1"
                                            });
                                            (0,utils_ga4Items__WEBPACK_IMPORTED_MODULE_21__/* .setGa4ItemInMap */ .HH)((ref1 = addedProduct.product) === null || ref1 === void 0 ? void 0 : ref1.styleNumber, modifiedGa4Item, true);
                                        }
                                        var value = Math.round(addedProduct.inCartPrice * addedProduct.addedQuantity * 100) / 100;
                                        var analyticsItem = (0,utils_analytics__WEBPACK_IMPORTED_MODULE_3__/* .transformListProductToAnalyticsItem */ .pD)({
                                            product: addedProduct.product,
                                            currency: currency.code,
                                            quantity: addedProduct.addedQuantity,
                                            categories: {
                                                item_category: addedProduct.product.primaryCategoryId
                                            },
                                            size: addedProduct.product.size.label,
                                            itemListId: ga4Item === null || ga4Item === void 0 ? void 0 : ga4Item.lid,
                                            itemListName: ga4Item === null || ga4Item === void 0 ? void 0 : ga4Item.lname,
                                            index: ga4Item === null || ga4Item === void 0 ? void 0 : ga4Item.idx,
                                            creativeName: ga4Item === null || ga4Item === void 0 ? void 0 : ga4Item.cname,
                                            creativeSlot: ga4Item === null || ga4Item === void 0 ? void 0 : ga4Item.cslot,
                                            promotionId: ga4Item === null || ga4Item === void 0 ? void 0 : ga4Item.pid,
                                            promotionName: ga4Item === null || ga4Item === void 0 ? void 0 : ga4Item.pname
                                        });
                                        var isPdpPage = (0,utils_analytics__WEBPACK_IMPORTED_MODULE_3__/* .getPageType */ .C2)(currentUrl) === "pdp";
                                        (0,utils_analytics__WEBPACK_IMPORTED_MODULE_3__/* .event */ .B)(utils_analytics__WEBPACK_IMPORTED_MODULE_3__/* .AnalyticsEvents.GA4EC_AddItemToCart */ ._q.GA4EC_AddItemToCart, {
                                            event_name: utils_analytics__WEBPACK_IMPORTED_MODULE_3__/* .AnalyticsEvents.ADD_ITEM_LIST_TO_CART */ ._q.ADD_ITEM_LIST_TO_CART,
                                            ecommerce: {
                                                item_list_id: ga4Item === null || ga4Item === void 0 ? void 0 : ga4Item.lid,
                                                item_list_name: ga4Item === null || ga4Item === void 0 ? void 0 : ga4Item.lname,
                                                currency: currency.code,
                                                value: value,
                                                item_id_ep: isPdpPage ? "".concat(addedProduct.product.masterId, "_").concat(addedProduct.product.colorValue) : undefined,
                                                item_name_ep: isPdpPage ? addedProduct.product.name : undefined,
                                                image_type: imageType,
                                                image_number: imageNumber,
                                                is_gift: String(Boolean(addedProduct.bonusItemId)),
                                                items: [
                                                    analyticsItem
                                                ]
                                            }
                                        });
                                    }
                                });
                                addedProducts.forEach(function(item) {
                                    (0,utils_bloomreach__WEBPACK_IMPORTED_MODULE_5__/* .trackAddToCartInBloomreach */ ._E)({
                                        productId: "".concat(item.product.masterId, "_").concat(item.product.colorValue),
                                        sku: item.product.ean || "",
                                        currency: currency.code
                                    });
                                });
                            }
                        }
                        return [
                            2,
                            res
                        ];
                }
            });
        });
        return function(items, additionalGAProductData) {
            return _ref.apply(this, arguments);
        };
    }(), [
        setTempState,
        addItemsToCart,
        cartId,
        triggerCartTotalEvent,
        openMiniCart,
        trackCartUpdate,
        currency.code,
        pageviewEventHasFired,
        imageType,
        imageNumber, 
    ]);
    var ref4 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)((0,_generated_graphql__WEBPACK_IMPORTED_MODULE_1__/* .useUpdateItemInCartMutation */ .SEy)(), 2), updateItemInCart = ref4[1];
    var updateInCart = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function(variables) {
            var ref, ref1, resp, _tmp;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _tmp = {};
                        return [
                            4,
                            updateItemInCart((_tmp.input = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({
                                basketId: cartId
                            }, variables), _tmp))
                        ];
                    case 1:
                        resp = _state.sent();
                        trackCartUpdate();
                        if (((ref = resp.data) === null || ref === void 0 ? void 0 : ref.updateItemInCart) && triggerCartTotalEvent) (0,utils_analytics__WEBPACK_IMPORTED_MODULE_3__/* .sessionCartTotalEvent */ .kF)((ref1 = resp.data) === null || ref1 === void 0 ? void 0 : ref1.updateItemInCart.subTotal);
                        return [
                            2,
                            resp
                        ];
                }
            });
        });
        return function(variables) {
            return _ref.apply(this, arguments);
        };
    }(), [
        cartId,
        trackCartUpdate,
        updateItemInCart,
        triggerCartTotalEvent
    ]);
    var ref5 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)((0,_generated_graphql__WEBPACK_IMPORTED_MODULE_1__/* .useRemoveItemFromCartMutation */ .s1e)(), 2), removeItemFromCart = ref5[1];
    var removeFromCart = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function(variables) {
            var ref, resp, _tmp, ref1;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _tmp = {};
                        return [
                            4,
                            removeItemFromCart((_tmp.input = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({
                                basketId: cartId
                            }, variables), _tmp))
                        ];
                    case 1:
                        resp = _state.sent();
                        trackCartUpdate();
                        if (((ref = resp.data) === null || ref === void 0 ? void 0 : ref.removeItemFromCart) && triggerCartTotalEvent) {
                            ;
                            (0,utils_analytics__WEBPACK_IMPORTED_MODULE_3__/* .sessionCartTotalEvent */ .kF)((ref1 = resp.data) === null || ref1 === void 0 ? void 0 : ref1.removeItemFromCart.subTotal);
                        }
                        return [
                            2,
                            resp
                        ];
                }
            });
        });
        return function(variables) {
            return _ref.apply(this, arguments);
        };
    }(), [
        cartId,
        removeItemFromCart,
        trackCartUpdate,
        triggerCartTotalEvent
    ]);
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        return {
            cart: cart,
            cartResult: cartResult,
            refetch: refetch,
            addToCart: addToCart,
            updateInCart: updateInCart,
            removeFromCart: removeFromCart
        };
    }, [
        cart,
        cartResult,
        refetch,
        addToCart,
        updateInCart,
        removeFromCart
    ]);
};


/***/ }),

/***/ 54973:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LF": function() { return /* binding */ CheckoutFormProvider; },
/* harmony export */   "rG": function() { return /* binding */ useCheckoutFormData; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(17599);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85034);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70169);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27378);





var CheckoutFormContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)(null);
var CheckoutFormProvider = function(param) {
    var children = param.children;
    // Initialize with empty state
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({}), data = ref[0], setData = ref[1];
    var setPersistedFormField = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(fieldName, value) {
        setData(function(prevData) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, prevData), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, fieldName, value));
        });
    }, []);
    var clearPersistedFormField = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(fieldName) {
        setData(function(prevData) {
            var newData = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, prevData);
            delete newData[fieldName];
            return newData;
        });
    }, []);
    var clearAddressFormFields = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(addressType) {
        setData(function(prevData) {
            var newData = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, prevData);
            Object.keys(newData).forEach(function(key) {
                if (key.startsWith(addressType)) {
                    delete newData[key];
                }
            });
            return newData;
        });
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CheckoutFormContext.Provider, {
        value: {
            data: data,
            setPersistedFormField: setPersistedFormField,
            clearPersistedFormField: clearPersistedFormField,
            clearAddressFormFields: clearAddressFormFields
        },
        children: children
    });
};
/**
 * Enhanced hook that provides form persistence utilities for checkout forms
 * using React Context API with optional form integration
 *
 * @param addressForm - Optional React Hook Form methods for form integration
 * @returns Form persistence utilities
 */ var useCheckoutFormData = function(addressForm) {
    var context = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(CheckoutFormContext);
    if (!context) {
        throw new Error("useCheckoutFormData must be used within a CheckoutFormProvider");
    }
    var data = context.data, setPersistedFormField = context.setPersistedFormField, clearPersistedFormField = context.clearPersistedFormField, clearAddressFormFields = context.clearAddressFormFields;
    /**
   * Retrieves a form field value from context state
   *
   * @param fieldName - The full name of the field (e.g., 'shippingAddress.firstName')
   * @returns The stored value or empty string/false if not found
   */ var getPersistedFormField = function(fieldName) {
        if (typeof data[fieldName] === "boolean") {
            return data[fieldName] || false;
        }
        return data[fieldName] || "";
    };
    /**
   * Enhanced version of setPersistedFormField that also updates form state if addressForm is provided
   */ var enhancedSetPersistedFormField = function(fieldName, value) {
        // Call the original context method
        setPersistedFormField(fieldName, value);
        // Also update form state if addressForm is provided
        if (addressForm) {
            addressForm.setValue(fieldName, value);
        }
    };
    /**
   * Enhanced version of clearPersistedFormField that also updates form state if addressForm is provided
   */ var enhancedClearPersistedFormField = function(fieldName) {
        // Call the original context method
        clearPersistedFormField(fieldName);
        // Also clear from form state if addressForm is provided
        if (addressForm) {
            addressForm.setValue(fieldName, "");
            addressForm.clearErrors(fieldName);
        }
    };
    /**
   * Enhanced version of clearAddressFormFields that also updates form state if addressForm is provided
   */ var enhancedClearAddressFormFields = function(addressType) {
        try {
            // Call the original context method
            clearAddressFormFields(addressType);
            // Also clear from form state if addressForm is provided
            if (addressForm) {
                var formValues = addressForm.getValues();
                Object.keys(formValues[addressType] || {}).forEach(function(field) {
                    var fieldName = "".concat(addressType, ".").concat(field);
                    addressForm.setValue(fieldName, "");
                    addressForm.clearErrors(fieldName);
                });
            }
        } catch (error) {
        // Silent error handling
        }
    };
    return {
        data: data,
        setPersistedFormField: enhancedSetPersistedFormField,
        clearPersistedFormField: enhancedClearPersistedFormField,
        clearAddressFormFields: enhancedClearAddressFormFields,
        getPersistedFormField: getPersistedFormField
    };
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (useCheckoutFormData)));


/***/ }),

/***/ 34457:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "o6": function() { return /* binding */ CookieSettingsProvider; },
  "Ci": function() { return /* binding */ cookieOptions; },
  "eK": function() { return /* binding */ useCookieSettings; }
});

// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(24246);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ../node_modules/react-hook-form/dist/index.esm.js
var index_esm = __webpack_require__(93451);
// EXTERNAL MODULE: ../node_modules/nookies/dist/index.js
var dist = __webpack_require__(15798);
// EXTERNAL MODULE: ./utils/constants.ts
var constants = __webpack_require__(79758);
;// CONCATENATED MODULE: ./utils/cookie.ts


var OPTANON_CONSENT_KEY = "OptanonConsent";
var OPTANON_ALERT_BOX_CLOSED = "OptanonAlertBoxClosed";
var getHasSeenCookieBannerOT = function() {
    return !!(0,dist.parseCookies)()[OPTANON_ALERT_BOX_CLOSED];
};
var getHasSeenCookieBanner = function() {
    return !!(0,dist.parseCookies)()[OPTANON_CONSENT_KEY];
};
var parseConsentCookie = function() {
    var defaultValue = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
        userExperience: true,
        marketing: true
    };
    var cookie = (0,dist.parseCookies)()[OPTANON_CONSENT_KEY];
    if (!cookie) return defaultValue;
    return cookie.split(",").reduce(function(acc, curr) {
        if (curr.startsWith("C0002")) {
            acc.userExperience = curr.endsWith("1");
        }
        if (curr.startsWith("C0004")) {
            acc.marketing = curr.endsWith("1");
        }
        if (curr.startsWith("C0005")) {
            acc.marketing = curr.endsWith("1");
        }
        return acc;
    }, defaultValue);
};
var setConsentCookie = function(userExperience, marketing, maxAgeCookiesExpires) {
    (0,dist.setCookie)(null, OPTANON_CONSENT_KEY, "groups=C0001:1,C0002:".concat(userExperience ? 1 : 0, ",C0003:1,C0004:").concat(marketing ? 1 : 0, ",C0005:").concat(marketing ? 1 : 0), {
        path: "/",
        maxAge: maxAgeCookiesExpires !== null && maxAgeCookiesExpires !== void 0 ? maxAgeCookiesExpires : constants/* MaxAgeExpiration.DAILY */.ho.DAILY
    });
};

// EXTERNAL MODULE: ./hooks/useSiteConfig.ts
var useSiteConfig = __webpack_require__(20368);
// EXTERNAL MODULE: ./hooks/useFeature.ts
var useFeature = __webpack_require__(53625);
// EXTERNAL MODULE: ./hooks/usePreferences.tsx
var usePreferences = __webpack_require__(89915);
;// CONCATENATED MODULE: ./hooks/useCookieSettings.tsx









var useCookieSettings_OPTANON_CONSENT_KEY = "OptanonConsent";
var cookieOptions = [
    {
        title: "yourPrivacy",
        label: "privacy",
        toggle: false
    },
    {
        title: "functional",
        label: "func",
        toggle: false
    },
    {
        title: "userExperienceAnalytics",
        label: "userExperience",
        toggle: true
    },
    {
        title: "marketingSocialMedia",
        label: "marketing",
        toggle: true
    }, 
];
var CookieSettingsContext = /*#__PURE__*/ (0,react.createContext)({});
var CookieSettingsProvider = function(param) {
    var children = param.children;
    var ref = (0,useSiteConfig/* useSiteConfig */.N)(), countryCode = ref.countryCode, maxAgeCookiesExpires = ref.maxAgeCookiesExpires, showCookieBanner = ref.staticFeatures.showCookieBanner;
    var preferences = (0,usePreferences/* usePreferences */.Gn)().preferences;
    var showCookieConsentLayer = (0,useFeature/* useFeature */.S)("SHOW_COOKIE_CONSENT_LAYER");
    var ref1 = (0,react.useState)(getHasSeenCookieBanner()), hasAcceptedCookies = ref1[0], setHasAcceptedCookies = ref1[1];
    var optanonCookie = (0,dist.parseCookies)()[useCookieSettings_OPTANON_CONSENT_KEY];
    (0,react.useEffect)(function() {
        // If the client supports GCP and it's enabled then opt-out without showing the banner
        if (!constants/* isServer */.sk && navigator.globalPrivacyControl && !optanonCookie) {
            setConsentCookie(false, false, maxAgeCookiesExpires);
        }
    }, [
        optanonCookie,
        maxAgeCookiesExpires
    ]);
    var ref2 = (0,react.useState)(false), showCookieSettings = ref2[0], setShowCookieSettings = ref2[1];
    var ref3 = (0,react.useState)(!getHasSeenCookieBannerOT()), showingCookieBannerOT = ref3[0], setShowingCookieBannerOT = ref3[1];
    (0,react.useEffect)(function() {
        if (countryCode === "ca" && hasAcceptedCookies) {
            window.__rmcp2 = [
                1,
                2,
                3,
                4,
                5,
                6,
                7,
                8,
                9,
                10
            ];
        }
    }, [
        hasAcceptedCookies,
        countryCode
    ]);
    var form = (0,index_esm/* useForm */.cI)({
        defaultValues: parseConsentCookie(),
        shouldUnregister: false,
        mode: "onChange"
    });
    var acceptCookies = (0,react.useCallback)(function() {
        var ref = form.getValues(), userExperience = ref.userExperience, marketing = ref.marketing;
        setShowCookieSettings(false);
        setHasAcceptedCookies(true);
        setConsentCookie(userExperience, marketing, maxAgeCookiesExpires);
        window.dispatchEvent(new Event(constants/* COOKIE_BANNER_ACKNOWLEDGED_EVENT_NAME */.p5));
    }, [
        form,
        maxAgeCookiesExpires
    ]);
    var value = {
        form: form,
        acceptCookies: acceptCookies,
        showCookieBanner: !!showCookieBanner && !showCookieSettings && showCookieConsentLayer && preferences["prefers-region"] && !hasAcceptedCookies && !constants/* isServer */.sk && !navigator.globalPrivacyControl,
        showCookieSettings: showCookieSettings,
        setShowCookieSettings: setShowCookieSettings,
        showingCookieBannerOT: showingCookieBannerOT,
        setShowingCookieBannerOT: setShowingCookieBannerOT
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CookieSettingsContext.Provider, {
        value: value,
        children: children
    });
};
var useCookieSettings = function() {
    var context = (0,react.useContext)(CookieSettingsContext);
    if (!context || Object.keys(context).length === 0) {
        throw new Error("useCookieSettings must be used within a CookieSettingsProvider");
    }
    return context;
};


/***/ }),

/***/ 16643:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ DeviceInteractionProvider; },
/* harmony export */   "u": function() { return /* binding */ useDeviceInteraction; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27378);
/* harmony import */ var _global_ecom_nitro_uds_hooks__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68138);
/* harmony import */ var utils_isTouchScreenDevice__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41332);




var DeviceInteractionContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({});
var DeviceInteractionProvider = function(param) {
    var children = param.children;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), keyboardActive = ref[0], setKeyboardActive = ref[1];
    (0,_global_ecom_nitro_uds_hooks__WEBPACK_IMPORTED_MODULE_2__/* .useIsomorphicLayoutEffect */ .LI)(function() {
        var onNonKeyboardInteraction = function(event) {
            if (event.defaultPrevented || !keyboardActive) return;
            setKeyboardActive(false);
        };
        var onKeyboardInteraction = function() {
            if ((0,utils_isTouchScreenDevice__WEBPACK_IMPORTED_MODULE_3__/* .isTouchScreenDevice */ .S)() || keyboardActive) return;
            setKeyboardActive(true);
        };
        document.addEventListener("keydown", onKeyboardInteraction, true);
        document.addEventListener("mousedown", onNonKeyboardInteraction);
        document.addEventListener("mouseup", onNonKeyboardInteraction);
        document.addEventListener("pointerdown", onNonKeyboardInteraction);
        document.addEventListener("pointerup", onNonKeyboardInteraction);
        document.addEventListener("touchstart", onNonKeyboardInteraction);
        document.addEventListener("touchend", onNonKeyboardInteraction);
        return function() {
            document.removeEventListener("keydown", onKeyboardInteraction, true);
            document.removeEventListener("mousedown", onNonKeyboardInteraction);
            document.removeEventListener("mouseup", onNonKeyboardInteraction);
            document.removeEventListener("pointerdown", onNonKeyboardInteraction);
            document.removeEventListener("pointerup", onNonKeyboardInteraction);
            document.removeEventListener("touchstart", onNonKeyboardInteraction);
            document.removeEventListener("touchend", onNonKeyboardInteraction);
        };
    }, [
        keyboardActive,
        setKeyboardActive
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DeviceInteractionContext.Provider, {
        value: {
            isKeyboardActive: keyboardActive
        },
        children: children
    });
};
var useDeviceInteraction = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(DeviceInteractionContext);
};


/***/ }),

/***/ 47607:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ useEmailNotification; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(23842);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(85034);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5341);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(59312);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86677);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _generated_graphql__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37678);
/* harmony import */ var hooks_useSiteConfig__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20368);
/* harmony import */ var utils_querystring__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(78474);









var CONTACT_SOURCE_CHECKOUT = "Checkout";
var CONTACT_SOURCE_SIGN_UP = "Account Sign Up";
var useEmailNotification = function() {
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_generated_graphql__WEBPACK_IMPORTED_MODULE_2__/* .useCreateContactMutation */ .LrK)(), 2), createContact = ref[1];
    var newsletter = (0,hooks_useSiteConfig__WEBPACK_IMPORTED_MODULE_3__/* .useSiteConfig */ .N)().newsletter;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        if (newsletter) {
            return [
                newsletter.contactSources.checkOut,
                newsletter.contactSources.signUp, 
            ];
        }
        return [
            CONTACT_SOURCE_CHECKOUT,
            CONTACT_SOURCE_SIGN_UP
        ];
    }, [
        newsletter
    ]), checkOut = ref1[0], signUp = ref1[1];
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var createCheckoutContact = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(order) {
            var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, _tmp;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(((ref = order.customer) === null || ref === void 0 ? void 0 : ref.id) && ((ref1 = order.customer) === null || ref1 === void 0 ? void 0 : ref1.email))) return [
                            3,
                            2
                        ];
                        _tmp = {};
                        return [
                            4,
                            createContact((_tmp.input = {
                                contact: {
                                    contactSource: checkOut,
                                    firstName: (ref2 = order.billingAddress) === null || ref2 === void 0 ? void 0 : ref2.firstName,
                                    lastName: (ref3 = order.billingAddress) === null || ref3 === void 0 ? void 0 : ref3.lastName,
                                    firstNamePronunciation: (ref4 = order.billingAddress) === null || ref4 === void 0 ? void 0 : ref4.firstNamePronunciation,
                                    lastNamePronunciation: (ref5 = order.billingAddress) === null || ref5 === void 0 ? void 0 : ref5.lastNamePronunciation,
                                    email: (ref6 = order.customer) === null || ref6 === void 0 ? void 0 : ref6.email,
                                    emailPreference: router.query[utils_querystring__WEBPACK_IMPORTED_MODULE_4__/* .NewsletterQueryParams.EmailList */ .v.EmailList] === "true" ? "optIn" : "optOut",
                                    address: (ref7 = order.billingAddress) === null || ref7 === void 0 ? void 0 : ref7.address1,
                                    phoneNumber: (ref8 = order.billingAddress) === null || ref8 === void 0 ? void 0 : ref8.phone,
                                    postalCode: (ref9 = order.billingAddress) === null || ref9 === void 0 ? void 0 : ref9.postalCode,
                                    city: (ref10 = order.billingAddress) === null || ref10 === void 0 ? void 0 : ref10.city
                                }
                            }, _tmp))
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        });
        return function(order) {
            return _ref.apply(this, arguments);
        };
    }(), [
        createContact,
        checkOut,
        router.query
    ]);
    var createSignupContact = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(data) {
            var _tmp;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _tmp = {};
                        return [
                            4,
                            createContact((_tmp.input = {
                                contact: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
                                    contactSource: signUp,
                                    emailPreference: "optIn"
                                }, data)
                            }, _tmp))
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(), [
        createContact,
        signUp
    ]);
    return {
        createCheckoutContact: createCheckoutContact,
        createSignupContact: createSignupContact
    };
};


/***/ }),

/***/ 78108:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "S": function() { return /* binding */ EmarsysWebExtendProvider; },
  "_": function() { return /* binding */ useEmarsysWebExtend; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(5341);
// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(24246);
// EXTERNAL MODULE: ../node_modules/next/router.js
var next_router = __webpack_require__(86677);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(24364);
;// CONCATENATED MODULE: ./utils/emarsysScarab.ts

/**
 * EmarsysScarab is a class that provides a stateful wrapper around the ScarabQueue
 * API from the scarab-v2.js script.
 *
 * Methods should be idempotent to avoid duplicate tracking calls to Emarsys.
 *
 * For more information, see the following resources:
 * Jira Ticket: https://pumaglobal.atlassian.net/browse/PNA-5360
 * Emarsys Web Extend documentation: https://dev.emarsys.com/docs/web-extend/321befdc63bc6-web-extend-api-introduction
 *
 */ var EmarsysScarab = /*#__PURE__*/ function() {
    "use strict";
    function EmarsysScarab() {
        var config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
            testMode: false,
            disabled: false
        };
        (0,_class_call_check/* default */.Z)(this, EmarsysScarab);
        this.config = config;
        this.isSubmitted = false;
        this.cart = null;
        this.user = null;
        this.tracking = null;
        this.queue = [];
    }
    var _proto = EmarsysScarab.prototype;
    /**
   * Submits the current tracking commands if all required data is present.
   * @returns This instance of EmarsysScarab
   */ _proto.safeSubmit = function safeSubmit() {
        var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _allowResubmit = ref.allowResubmit, allowResubmit = _allowResubmit === void 0 ? false : _allowResubmit;
        if (this.isSubmitted && !allowResubmit) {
            return this;
        }
        if (this.config.disabled) {
            return this;
        }
        if (!this.cart || !this.user || !this.tracking) {
            return this;
        }
        if (this.config.testMode) {
            this.queue.push([
                "testMode"
            ]);
        }
        return this.go();
    };
    /**
   * Tracks a Product Detail Page view.
   * @param productId - The ID of the product being viewed
   * @returns This instance of EmarsysScarab
   */ _proto.trackPdp = function trackPdp(productId) {
        if (this.isSubmitted || this.tracking) {
            return this;
        }
        this.setView(productId);
        return this;
    };
    /**
   * Tracks a category (PLP) view.
   * @param categoryId - An array of hierarchical category IDs
   * @returns This instance of EmarsysScarab
   */ _proto.trackCategory = function trackCategory(categoryId) {
        if (this.isSubmitted || this.tracking) {
            return this;
        }
        this.setCategory(categoryId);
        return this;
    };
    /**
   * Tracks a completed store purchase.
   * @param orderId - The ID of the order being tracked
   * @param items - An array of items representing the products in the order
   * @returns This instance of EmarsysScarab
   */ _proto.trackPurchase = function trackPurchase(orderId, items) {
        if (this.isSubmitted || this.tracking) {
            return this;
        }
        this.setPurchase({
            orderId: orderId,
            items: items
        });
        return this;
    };
    /**
   * Skips adding any specific tracking command to the queue.
   * @returns This instance of EmarsysScarab
   */ _proto.skipTracking = function skipTracking() {
        this.tracking = "none";
        return this;
    };
    /**
   * Clears all queued tracking data and resets tracking status flags.
   * @returns This instance of EmarsysScarab
   */ _proto.clear = function clear() {
        this.queue = [];
        this.isSubmitted = false;
        this.tracking = null;
        this.cart = null;
        this.user = null;
        return this;
    };
    /**
   * Sets the user ID for tracking.
   * @param id - The ID of the user to track
   * @returns This instance of EmarsysScarab
   */ _proto.setUser = function setUser(id) {
        var ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _update = ref.update, update = _update === void 0 ? false : _update;
        if (this.user && !update) {
            return this;
        }
        this.user = id;
        return this;
    };
    /**
   * Sets the cart items for tracking.
   * @param items - An array of items representing the products in the cart
   * @returns This instance of EmarsysScarab
   */ _proto.setCart = function setCart(items) {
        var ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _overwrite = ref.overwrite, overwrite = _overwrite === void 0 ? false : _overwrite;
        if (this.cart && !overwrite) {
            return this;
        }
        this.cart = items;
        return this;
    };
    _proto.setPurchase = function setPurchase(order) {
        this.tracking = [
            "purchase",
            order
        ];
        return this;
    };
    _proto.setView = function setView(productId) {
        this.tracking = [
            "view",
            productId
        ];
        return this;
    };
    _proto.setCategory = function setCategory(category) {
        this.tracking = [
            "category",
            category.join(" > ")
        ];
        return this;
    };
    _proto.go = function go() {
        this.isSubmitted = true;
        this.flushToWindow();
        return this;
    };
    _proto.flushToWindow = function flushToWindow() {
        var dataFlush = [];
        this.queue.push([
            "cart",
            this.cart
        ]);
        if (this.user !== "none") {
            this.queue.push([
                "setEmail",
                this.user
            ]);
        }
        if (this.tracking !== "none") {
            this.queue.push(this.tracking);
        }
        this.queue.push([
            "go"
        ]);
        while(this.queue.length){
            var item = this.queue.shift();
            if (!item) {
                break;
            }
            dataFlush.push(item);
            window.ScarabQueue.push(item);
        }
    };
    return EmarsysScarab;
}();

// EXTERNAL MODULE: ./hooks/useAuth.tsx
var useAuth = __webpack_require__(72507);
// EXTERNAL MODULE: ./hooks/useSimpleCart.tsx
var useSimpleCart = __webpack_require__(85914);
// EXTERNAL MODULE: ./hooks/useOrder.ts
var useOrder = __webpack_require__(64108);
;// CONCATENATED MODULE: ./hooks/useRouteChangeStart.tsx


var useRouteChangeStart = function(callback) {
    var router = (0,next_router.useRouter)();
    (0,react.useEffect)(function() {
        router.events.on("routeChangeStart", callback);
        return function() {
            router.events.off("routeChangeStart", callback);
        };
    }, [
        router.events,
        callback
    ]);
};

// EXTERNAL MODULE: ./hooks/useSiteConfig.ts
var useSiteConfig = __webpack_require__(20368);
;// CONCATENATED MODULE: ./hooks/useEmarsysWebExtend.tsx










var EmarsysWebExtendContext = /*#__PURE__*/ (0,react.createContext)({});
var transformCartItems = function(cartItems) {
    var items = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = cartItems[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var cartItem = _step.value;
            if (cartItem.__typename === "ProductCartItem") {
                items.push({
                    item: cartItem.product.styleNumber,
                    quantity: cartItem.quantity,
                    price: cartItem.inCartPrice * cartItem.quantity
                });
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return items;
};
var EmarsysWebExtendProvider = function(param) {
    var children = param.children;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var auth = (0,useAuth/* useAuth */.aC)();
    var router = (0,next_router.useRouter)();
    var ref7 = (0,useSimpleCart/* useSimpleCart */.r)(), cart = ref7.cart, cartResult = ref7.cartResult;
    var ref8 = (0,_sliced_to_array/* default */.Z)((0,useOrder/* useOrder */.A)((ref = router.query) === null || ref === void 0 ? void 0 : ref.orderNo), 1), order = ref8[0];
    var ref9 = (0,useSiteConfig/* useSiteConfig */.N)(), emarsysMerchantId = ref9.emarsysMerchantId, _env = ref9.env, stage = _env.STAGE;
    var ref10 = (0,react.useState)(false), shouldUpdateCart = ref10[0], setShouldUpdateCart = ref10[1];
    var scarab = (0,react.useRef)(new EmarsysScarab({
        disabled: !emarsysMerchantId,
        testMode: stage !== "production"
    }));
    var clearOnPageChange = (0,react.useCallback)(function(targetRoute) {
        var pathname = targetRoute.split("?")[0];
        var currentPath = router.asPath.split("?")[0];
        if (pathname !== currentPath) {
            scarab.current.clear();
        }
    }, [
        router.asPath
    ]);
    // Clear the tracker state when the page changes
    // to reset the double-submit protection
    useRouteChangeStart(clearOnPageChange);
    (0,react.useEffect)(function() {
        var ref, ref1;
        if ((ref = auth.user) === null || ref === void 0 ? void 0 : ref.email) {
            scarab.current.setUser(auth.user.email).safeSubmit();
            return;
        }
        if (!((ref1 = router.query) === null || ref1 === void 0 ? void 0 : ref1.orderNo)) {
            var ref2;
            var email = (cart === null || cart === void 0 ? void 0 : (ref2 = cart.customer) === null || ref2 === void 0 ? void 0 : ref2.email) || "none";
            scarab.current.setUser(email).safeSubmit();
            return;
        }
        if (!order.fetching && !order.stale) {
            var ref3, ref4, ref5, ref6;
            var email1 = ((ref3 = order.data) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.order) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.customer) === null || ref5 === void 0 ? void 0 : ref5.email) || (cart === null || cart === void 0 ? void 0 : (ref6 = cart.customer) === null || ref6 === void 0 ? void 0 : ref6.email) || "none";
            scarab.current.setUser(email1).safeSubmit();
            return;
        }
    }, [
        router.asPath,
        (ref1 = auth.user) === null || ref1 === void 0 ? void 0 : ref1.email,
        cart === null || cart === void 0 ? void 0 : (ref2 = cart.customer) === null || ref2 === void 0 ? void 0 : ref2.email,
        (ref3 = order.data) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.order) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.customer) === null || ref5 === void 0 ? void 0 : ref5.email,
        order.fetching,
        order.stale,
        (ref6 = router.query) === null || ref6 === void 0 ? void 0 : ref6.orderNo, 
    ]);
    (0,react.useEffect)(function() {
        if (!cartResult.fetching && !cartResult.stale) {
            var cartItems = transformCartItems((cart === null || cart === void 0 ? void 0 : cart.products) || []);
            scarab.current.setCart(cartItems, {
                overwrite: shouldUpdateCart
            }).safeSubmit({
                allowResubmit: shouldUpdateCart
            });
            if (shouldUpdateCart) {
                setShouldUpdateCart(false);
            }
        }
    }, [
        router.asPath,
        cartResult.fetching,
        cartResult.stale,
        cart === null || cart === void 0 ? void 0 : cart.products,
        shouldUpdateCart, 
    ]);
    var emarsys = (0,react.useMemo)(function() {
        return {
            omitTrackingCommand: function() {
                scarab.current.skipTracking().safeSubmit();
            },
            trackPdp: function(productId) {
                scarab.current.trackPdp(productId).safeSubmit();
            },
            trackCategory: function(categoryId) {
                scarab.current.trackCategory(categoryId).safeSubmit();
            },
            trackPurchase: function(orderId, products) {
                var purchase = transformCartItems(products);
                scarab.current.setCart([], {
                    overwrite: true
                });
                if (purchase.length === 0) {
                    scarab.current.skipTracking().safeSubmit();
                } else {
                    scarab.current.trackPurchase(orderId, purchase).safeSubmit();
                }
            },
            trackCartUpdate: function() {
                setShouldUpdateCart(true);
            }
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(EmarsysWebExtendContext.Provider, {
        value: emarsys,
        children: children
    });
};
var useEmarsysWebExtend = function() {
    var ctx = (0,react.useContext)(EmarsysWebExtendContext);
    if (false) {}
    return ctx;
};


/***/ }),

/***/ 53625:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ useFeature; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17599);
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79758);
/* harmony import */ var _useSiteConfig__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20368);



var useFeature = function(flagName) {
    var ref = (0,_useSiteConfig__WEBPACK_IMPORTED_MODULE_1__/* .useSiteConfig */ .N)(), features = ref.features, staticFeatures = ref.staticFeatures;
    var _obj;
    var flags = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .PaymentMethod.PAYPAL */ .XL.PAYPAL, features.payPalEnabled), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .PaymentMethod.APPLE_PAY */ .XL.APPLE_PAY, features.applePayEnabled), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .PaymentMethod.GOOGLE_PAY */ .XL.GOOGLE_PAY, features.googlePayEnabled), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .PaymentMethod.AFTERPAY */ .XL.AFTERPAY, features.afterPayEnabled), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .PaymentMethod.GIFT_CARD */ .XL.GIFT_CARD, features.giftCardEnabled), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .PaymentMethod.STORE_CREDIT */ .XL.STORE_CREDIT, features.storeCreditsEnabled), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .PaymentMethod.AMAZON_PAY */ .XL.AMAZON_PAY, features.amazonPayEnabled), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .PaymentMethod.PAY_PAY */ .XL.PAY_PAY, features.payPayEnabled), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "KLARNA_ENABLED", features.klarnaEnabled), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "GOOGLE_ADDRESS_LOOKUP", features.googleAddressLookupEnabled), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "GOOGLE_REVERSE_POSTAL_CODE_LOOKUP", features.googleReversePostalCodeLookup), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "RATINGS_AND_REVIEWS", features.ratingsAndReviewsEnabled), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "MY_CUSTOMIZER", features.myCustomizerEnabled), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "PINCODE_SERVICEABILITY", features.pincodeServiceabilityEnabled), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "REVIEW_ORDER_ON_CHECKOUT", staticFeatures.reviewOrderOnCheckout), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "NESTED_ORDERS", features.nestedOrdersEnabled), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "ADDRESS_RESUME_IN_CHECKOUT", features.addressResumeInCheckoutEnabled), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "SIMPLIFIED_ADDRESS_RESUME_IN_CHECKOUT", features.simplifiedAddressResumeInCheckoutEnabled), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "USE_SAVED_CARDS", features.useSavedCardsEnabled), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "MY_ACCOUNT_ORDER_DETAILS_CONTACT_INFO", features.myAccountOrderDetailsContactInfoEnabled), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "MY_ACCOUNT_ORDER_DETAILS_BILLING_INFO", features.myAccountOrderDetailsBillingInfoEnabled), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "ADDITIONAL_PRICE_TEXT_FOR_SALE", features.additionalPriceTextForSaleEnabled), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "RETURN_ORDER", features.returnOrderEnabled), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "MY_ACCOUNT_EDIT_PASSWORD_SHOW_ADDITIONAL_CANCEL_BUTTON", features.myAccountEditPasswordShowAdditionalCancelButtonEnabled), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "MY_ACCOUNT_EDIT_PASSWORD_USE_LABEL_INSTEAD_OF_PLACEHOLDER", features.myAccountEditPasswordUseLabelInsteadOfPlaceholderEnabled), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "ACCOUNT_DASHBOARD_SHOW_MEMBERSHIP_SECTION", features.myAccountDashboardMembershipSectionEnabled), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "CREATE_ACCOUNT_IN_CHECKOUT", features.createAccountInCheckoutEnabled), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "SHOW_USER_REGISTRATION_ON_CHECKOUT_CONFIRMATION", features.showUserRegistrationOnCheckoutEnabled), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "SAVE_ADDRESS_CHECKBOX_ENABLED", features.saveAddressCheckboxEnabled), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "CART_SUMMARY_PROMO_CODE_EXPANDED_ON_MOBILE", features.cartSummaryPromoCodeExpandedOnMobile), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "MY_ACCOUNT_LEAVE_RESET_PASSWORD_CONFIRM_POPUP_OPEN", features.myAccountLeaveResetPasswordConfirmPopupOpenEnabled), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "SHOW_SALES_BADGE_ON_PRODUCT_IMAGE", staticFeatures.showSaleBadgeOnProductImageEnabled), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "DESIRED_DELIVERY_DATE", features.desiredDeliveryDateEnabled), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "OTP_LOGIN", features.otpLoginEnabled && staticFeatures.otpLoginEnabled), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "REGISTER_OTP_VERIFICATION_ENABLED", features.registerOTPVerificationEnabled), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "PHONE_IN_PROFILE", features.phoneInProfileEnabled), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "AUTO_SHOW_NEWSLETTER_POPUP", features.autoShowNewsletterPopupEnabled), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "SHOW_PRODUCT_KEYWORDS", features.showProductKeywordsEnabled), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "SC_SHOW_CART_ABANDONMENT_MODAL", features.scShowCartAbandonmentModalEnabled), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "MINICART_SEPARATE_VIEW_AND_CHECKOUT_BUTTONS", features.miniCartSeparateViewAndCheckoutButtons), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "SHOW_ADDITIONAL_FIELDS_IN_ACCOUNT_EDIT", features.myAccountShowAdditionalFieldsInEditEnabled), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "PRICES_EXTENDED", features.priceWithDataEnabled), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "SHOW_ONLY_ORDERABLE_SIZES", features.showOnlyOrderableSizesEnabled), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "MY_ACCOUNT_HIDE_NOTIFICATION_SETTINGS_IN_DASHBOARD", features.myAccountHideNotificationSettingsInDashboard), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "PROMO_CODE_ACCORDION_EXPANDED_BY_DEFAULT", features.promoCodeAccordionIsExpandedByDefault), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "CHECKOUT_ACCORDION_COLLAPSED_BY_DEFAULT", features.collapsableOrderDetailsIsCollapsedOnLoad), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "SHOW_SIMPLIFIED_PDP_FOR_GOOGLE_SHOPPING", features.simplifiedGoogleShoppingPdpEnabled), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "HIDE_YOUR_SAVINGS", features.hideYourSavings), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "MY_ACCOUNT_DASHBOARD_ADD_ADDRESS_BUTTON", staticFeatures.showAddAddressButtonInAccountDashboard), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "PRODUCT_FILTER_COLLAPSIBLE", staticFeatures.productFilterCollapsible), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "MY_ACCOUNT_ORDER_HISTORY_ORDER_TITLE_TRANSLATION", staticFeatures.showTitleTranslationInAccountOrderHistory), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "CAN_REMOVE_WISHLIST_ITEMS_FROM_PDP", staticFeatures.canRemoveWishlistItemsFromPDP), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "CAN_SHOW_PHONEICON_IN_CHECKOUT", staticFeatures.showPhoneInCheckout), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "SHOW_PRODUCT_STORY_KEYWORD_TITLE", staticFeatures.showProductStoryKeywordTitle), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "SHOW_DYNAMIC_TAX_MESSAGE", features.showDynamicTaxMessage), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "SHOW_DISCOUNT_AMOUNT_AND_TEXT_ENABLED", features.showDiscountAmountAndTextEnabled), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "PAYMENT_PROMOTION", features.paymentPromotionEnabled), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "SHOW_NEWSLETTER_SIGNUP_ON_ORDER_CONFIRMATION", staticFeatures.showNewsletterSignupOnOrderConfirmation), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "USE_STOCK_MESSAGE_FROM_RESPONSE", staticFeatures.useStockMessageFromResponse), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "PDP_ENABLE_STOCK_MESSAGE", staticFeatures.enableStockStatusInPDP), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "PDP_SHOW_DETAILED_STOCK_MESSAGES", staticFeatures.pdpShowStockMessageBySFCCLogic), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "SHOW_SHIPPING_DISCOUNT_IN_CHECKOUT", staticFeatures.showShippingDiscountInCheckout), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "SHOW_METRIC_AS_DEFAULT", staticFeatures.showMetricAsDefault), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "MY_ACCOUNT_REDIRECT_AFTER_PROFILE_UPDATE", staticFeatures.redirectToAccountDashboardAfterProfileUpdate), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "CHECKOUT_HIDE_SHIPPING_AND_RETURNS_MESSAGE", staticFeatures.checkoutHideShippingAndReturnsMessage), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "PDP_DISABLE_RETURNS", staticFeatures.pdpDisableReturns), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "MY_ACCOUNT_HIDE_NEWSLETTER_SETTINGS_IN_DASHBOARD", features.myAccountHideNewsletterSettingsInDashboard), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "SHOW_COOKIE_CONSENT_LAYER", staticFeatures.showCookieConsentLayer), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "SHOW_ORDER_TRACKING_NUMBER_IN_ORDER_DETAILS", staticFeatures.showOrderTrackingNumberInOrderDetails), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "SHOW_BREADCRUMBS_ON_ORDER_DETAILS", staticFeatures.showBreadcrumbsOnOrderDetails), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "PARCEL_LAB_TRACKING_ENABLED", staticFeatures.parcelLabTrackingEnabled), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "SHOW_PRICE_DIFFERENCE", staticFeatures.showPriceDifference), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "CHECKOUT_SHOW_SAVE_CARD_CHECKBOX", staticFeatures.checkoutShowSaveCardCheckbox), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "USE_SFCC_DIVIDER_FOR_SEO_DESCRIPTION", staticFeatures.useSFCCDividerForSEODescription), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "SHOW_ORDER_SUMMARY_AT_ORDER_HISTORY", staticFeatures.showOrderSummaryAtOrderHistory), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "SHOW_REFUND_INFORMATION_AT_ORDER", staticFeatures.showRefundInformationAtOrder), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "PERSONALIZATION_ENABLED", staticFeatures.personalizationEnabled), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "HIDE_SOLD_OUT_COLORS_IN_STYLES_SELECTION", staticFeatures.hideSoldOutColorsInStylesSelection), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "HIDE_CALLOUT_MESSAGE", staticFeatures.hideCalloutMessage), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "HIDE_EAN_COLOR_CODE", staticFeatures.hideEanColorCode), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "OPLUX_ENABLED", features.opluxEnabled), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "SHOW_ALL_PRICES_AT_ONCE", staticFeatures.showAllPricesAtOnce), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "DISPLAY_PROMO_DISCOUNT_BREAKDOWN", staticFeatures.displayPromoDiscountBreakdown), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "EDIT_PASS_RESULT_ERROR_DISABLED", staticFeatures.editPasswordResultErrorDisabled), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "HIDE_TERMS_AND_CONDITIONS_ON_LOGIN", staticFeatures.hideTermsOnLoginForm), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "DISPLAY_PROMO_APPLIED_PROMOTION", staticFeatures.displayPromoAppliedPromotion), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "SHOW_ONE_FINAL_PRICE_ON_PURCHASED_PRODUCT", staticFeatures.showOneFinalPriceOnPurchasedProduct), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "SET_AUTO_CAPITALIZE_OFF", staticFeatures.setAutoCapitalizeOff), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "HIDE_MY_ACCOUNT_SUBTITLE", staticFeatures.hideMyAccountSubtitle), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "SHOW_WISHLIST_ICON_BADGE_ON_DROPDOWN_MENU", staticFeatures.showWishlistIconBadgeOnDropdownMenu), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "HIDE_PAYMENT_INFORMATION_ON_ACCOUNT_PAGE", staticFeatures.hidePaymentInformationOnAccountPage), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "ALLOW_EDIT_INCORRECT_SAVED_ADDRESS_CHECKOUT", staticFeatures.allowEditIncorrectSavedAddressCheckout), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "STORE_CREDITS_ENABLED", features.storeCreditsEnabled), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "OUTFITS_ENABLED", features.outfitsEnabled), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "HIDE_BULLETS_LISTS_PDP", staticFeatures.hideBulletsListsPdp), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "SHOW_KLARNA_DISCLAIMER_MESSAGE", staticFeatures.showKlarnaDisclaimerMessage), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "SHOW_SEARCH_FORM_ON_ERROR", staticFeatures.showSearchFormOnError), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "SHOW_PRODUCT_RECOMMENDER_ON_ERROR", staticFeatures.showProductRecommenderOnError), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "SHOW_SEARCH_TIPS_ON_ERROR", staticFeatures.showSearchTipsOnError), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "AUTHORITY_TO_LEAVE_ENABLED", staticFeatures.authorityToLeaveEnabled), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "USE_ACCOUNT_NOTIFICATION_FORM_V2", staticFeatures.useAccountNotificationFormV2), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "MY_ACCOUNT_HIDE_EMAIL_NOTIFICATIONS", staticFeatures.hideEmailNotifications), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "QUICK_ADDRESS_FINDER", staticFeatures.quickAddressFinder), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "SHOW_PROMO_EXCLUSION_MSG_ABOVE_PRODUCT_DETAILS", staticFeatures.showPromoExclusionMsgAboveProductDetails), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "SHOW_PROMO_EXCLUSION_MSG_IN_BASE_SIZE", staticFeatures.showPromoExclusionMsgInBaseSize), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "USE_DEFAULT_JAPAN_CHART", staticFeatures.useDefaultJapanChart), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "POPOVER_LOGIN_ENABLED", staticFeatures.popoverLoginEnabled), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "POPOVER_LOGIN_ENABLED_JP", staticFeatures.popoverLoginEnabledJP), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "REMOVE_RETURN_IFRAME", staticFeatures.removeReturnIframe), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "SHOW_GIFT_WITH_PURCHASE_MODAL_IN_MOBILE", staticFeatures.showGiftWithPurchaseModalInMobile), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "GIFT_WITH_PURCHASE_NEW_DESIGN", staticFeatures.giftWithPurchaseNewDesign), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "SEARCH_LOCAL_IMAGES_ON_PRODUCT_COMPARISON", staticFeatures.searchLocalImagesOnProductComparison), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "SEARCH_LOCAL_IMAGES_ON_DROP_CALENDAR", staticFeatures.searchLocalImagesOnDropCalendar), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "STYLE_BAZAAR_VOICE_MODAL", staticFeatures.styleBazaarVoiceModal), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "SHOW_FREE_SHIPPING_PROGRESS_BAR", staticFeatures.showFreeShippingProgressBar), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "USE_VARIANT_PROMOTION_EXCLUSION", staticFeatures.useVariantPromotionExclusion), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "SHOW_PROMO_EXCLUSION_MSG_IN_GRAY", staticFeatures.showPromoExclusionMsgInGray), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "SHOW_PINTEREST_FOOTER_ICON", staticFeatures.showPinterestFooterIcon), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "SHOW_PUMA_CARD", staticFeatures.showPumaCard), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "RETURNS_PAGE_DISABLED", staticFeatures.returnsPageDisabled), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "HIDE_WEIGHT_IN_PRODUCT_MEASUREMENTS", staticFeatures.hideWeightInProductMeasurements), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "AMBASSADOR_CARDS_ENABLED", staticFeatures.ambassadorCardsEnabled), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "ADD_ADDRESS_RESULT_ERROR_DISABLED", staticFeatures.addAddressResultErrorDisabled), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "TRIGGER_CART_TOTAL_EVENT", staticFeatures.triggerCartTotalEvent), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "ENABLE_ITEM_LINKS_IN_CART_SUMMARY", staticFeatures.enableItemLinksInCartSummary), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "USE_MASTER_IDS_IN_CART_RECOMMENDERS", staticFeatures.useMasterIdsInCartRecommenders), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "IS_GMO_ENABLED", staticFeatures.isGmoEnabled), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "IS_SALESFLOOR_ENABLED", staticFeatures.isSalesfloorEnabled), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "EU_CUSTOM_PRICE_FORMATING", staticFeatures.euCustomPriceFormat), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "IS_30_DAYS_BEST_PRICE", staticFeatures.is30DaysBestPrice), _obj);
    return !!flags[flagName];
};


/***/ }),

/***/ 56543:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G$": function() { return /* binding */ AuthFormContextProvider; },
/* harmony export */   "qW": function() { return /* binding */ useFormData; }
/* harmony export */ });
/* unused harmony export AuthFormContext */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85034);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27378);



var AuthFormContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({});
var AuthFormContextProvider = function(param) {
    var children = param.children;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({}), data = ref[0], setData = ref[1];
    var setValues = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(values) {
        setData(function(prevData) {
            return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, prevData, values);
        });
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AuthFormContext.Provider, {
        value: {
            data: data,
            setValues: setValues
        },
        children: children
    });
};
var useFormData = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(AuthFormContext);
};


/***/ }),

/***/ 42876:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "v": function() { return /* binding */ ForterProvider; },
  "c": function() { return /* binding */ useForter; }
});

// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(24246);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ../node_modules/next/script.js
var script = __webpack_require__(43218);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
// EXTERNAL MODULE: ./hooks/useSiteConfig.ts
var useSiteConfig = __webpack_require__(20368);
// EXTERNAL MODULE: ./utils/forter.ts
var forter = __webpack_require__(63179);
;// CONCATENATED MODULE: ./ui/elements/ForterScript.tsx




var ForterScript = function() {
    var env = (0,useSiteConfig/* useSiteConfig */.N)().env;
    if (!env.forterSiteId) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
        id: env.forterSiteId,
        strategy: "afterInteractive",
        dangerouslySetInnerHTML: {
            __html: "\n          (function () {\n            document.addEventListener('ftr:tokenReady', e => localStorage.setItem('".concat(forter/* FORTER_TOKEN_STORAGE_KEY */.Kn, "', e.detail));\n            document.addEventListener('ftr:customerWebIdReady',  e => localStorage.setItem('").concat(forter/* FORTER_WEBID_STORAGE_KEY */.Ek, "', e.detail));\n            const merchantConfig = { csp: true };\n            const siteId = '").concat(env.forterSiteId, '\';\n            function t(t,n){for(var e=t.split(""),r=0;r<e.length;++r)e[r]=String.fromCharCode(e[r].charCodeAt(0)+n);return e.join("")}function n(n){return t(n,-S).replace(/%SN%/g,siteId)}function e(){var t="no"+"op"+"fn",n="g"+"a",e="n"+"ame";return window[n]&&window[n][e]===t}function r(){return!(!navigator.brave||"function"!=typeof navigator.brave.isBrave)}function o(){return document.currentScript&&document.currentScript.src}function i(t){try{B.ex=t,e()&&-1===B.ex.indexOf(R.uB)&&(B.ex+=R.uB),r()&&-1===B.ex.indexOf(R.uBr)&&(B.ex+=R.uBr),o()&&-1===B.ex.indexOf(R.nIL)&&(B.ex+=R.nIL),window.ftr__snp_cwc||(B.ex+=R.s),F(B)}catch(t){}}function c(t,n){function e(o){try{o.blockedURI===t&&(n(),document.removeEventListener(r,e))}catch(t){document.removeEventListener(r,e)}}var r="securitypolicyviolation";document.addEventListener(r,e),setTimeout(function(){document.removeEventListener(r,e)},2*60*1e3)}function a(t,n,e,r){var o=!1;t="https://"+t,c(t,function(){r(!0),o=!0});var i=document.createElement("script");i.onerror=function(){if(!o)try{r(!1),o=!0}catch(t){}},i.onload=e,i.type="text/javascript",i.id="ftr__script",i.async=!0,i.src=t;var a=document.getElementsByTagName("script")[0];a.parentNode.insertBefore(i,a)}function u(t,n,e,r){var o=!1,i=new XMLHttpRequest;if(c("https:"+t,function(){e(new Error("CSP Violation"),!0),o=!0}),"withCredentials"in i)i.open("GET",t,!0);else{if("undefined"==typeof XDomainRequest)return;i=new XDomainRequest,i.open("GET",t)}Object.keys(r).forEach(function(t){i.setRequestHeader(t,r[t])}),i.onload=function(){"function"==typeof n&&n(i)},i.onerror=function(t){if("function"==typeof e&&!o)try{e(t,!1),o=!0}catch(t){}},i.onprogress=function(){},i.ontimeout=function(){"function"==typeof e&&e("tim"+"eo"+"ut",!1)},setTimeout(function(){i.send()},0)}function d(t,siteId,n){function e(t){var n=t.toString(16);return n.length%2?"0"+n:n}function r(t){if(t<=0)return"";for(var n="0123456789abcdef",e="",r=0;r<t;r++)e+=n[Math.floor(Math.random()*n.length)];return e}function o(t){for(var n="",r=0;r<t.length;r++)n+=e(t.charCodeAt(r));return n}function i(t){for(var n=t.split(""),e=0;e<n.length;++e)n[e]=String.fromCharCode(255^n[e].charCodeAt(0));return n.join("")}n=n?"1":"0";var c=[];return c.push(t),c.push(siteId),c.push(n),function(t){var n=40,e="";return t.length<n/2&&(e=","+r(n/2-t.length-1)),o(i(t+e))}(c.join(","))}function f(){function t(){C&&(Q(R.dUAL),setTimeout(s,E,R.dUAL))}function n(t,n){i(n?R.uAS+R.uF+R.cP:R.uAS+R.uF)}window.ftr__fdad(t,n)}function s(t){try{var n=t===R.uDF?q:C;if(!n)return;a(n,void 0,function(){try{X(),i(t+R.uS)}catch(t){}},function(n){try{X(),B.td=1*new Date-B.ts,i(n?t+R.uF+R.cP:t+R.uF),t===R.uDF&&f()}catch(t){i(R.eUoe)}})}catch(n){i(t+R.eTlu)}}var h="22g6otrwjeq6qsu1forxgiurqw1qhw2vwdwxv",v="fort",w="erTo",l="ken";window.ftr__config={m:merchantConfig,s:"15",si:siteId};var m=!1,p=v+w+l,g=10,_={write:function(t,n,e,r){void 0===r&&(r=!0);var o,i;if(e?(o=new Date,o.setTime(o.getTime()+24*e*60*60*1e3),i="; expires="+o.toGMTString()):i="",!r)return void(document.cookie=escape(t)+"="+escape(n)+i+"; path=/");for(var c=1,a=document.domain.split("."),u=g,d=!0;d&&a.length>=c&&u>0;){var f=a.slice(-c).join(".");document.cookie=escape(t)+"="+escape(n)+i+"; path=/; domain="+f;var s=_.read(t);null!=s&&s==n||(f="."+f,document.cookie=escape(t)+"="+escape(n)+i+"; path=/; domain="+f),d=-1===document.cookie.indexOf(t+"="+n),c++,u--}},read:function(t){var n=null;try{for(var e=escape(t)+"=",r=document.cookie.split(";"),o=32,i=0;i<r.length;i++){for(var c=r[i];c.charCodeAt(0)===o;)c=c.substring(1,c.length);0===c.indexOf(e)&&(n=unescape(c.substring(e.length,c.length)))}}finally{return n}}},y=window.ftr__config.s;y+="ck";var T=function(t){if(document.head){var n=function(){var n=document.createElement("link");return n.setAttribute("rel","pre"+"con"+"nect"),n.setAttribute("cros"+"sori"+"gin","anonymous"),n.onload=function(){document.head.removeChild(n)},n.onerror=function(t){document.head.removeChild(n)},n.setAttribute("href",t),document.head.appendChild(n),n}();setTimeout(function(){document.head.removeChild(n)},3e3)}},S=3,x=n(h||"22g6otrwjeq6qsu1forxgiurqw1qhw2vwdwxv"),A=t("[0Uhtxhvw0LG",-S),L=t("[0Fruuhodwlrq0LG",-S),k=t("Li0Qrqh0Pdwfk",-S),C,U="fgq71iruwhu1frp",q=n("(VQ(1"+U+"2vq2(VQ(2vfulsw1mv"),D=n("(VQ(1"+U+"2vqV2(VQ(2vfulsw1mv"),E=10;window.ftr__startScriptLoad=1*new Date;var b=function(t){var n="ft"+"r:tok"+"enR"+"eady";window.ftr__tt&&clearTimeout(window.ftr__tt),window.ftr__tt=setTimeout(function(){try{delete window.ftr__tt,t+="_tt";var e=document.createEvent("Event");e.initEvent(n,!1,!1),e.detail=t,document.dispatchEvent(e)}catch(t){}},1e3)},F=function(t){var n=function(t){return t||""},e=n(t.id)+"_"+n(t.ts)+"_"+n(t.td)+"_"+n(t.ex)+"_"+n(y);_.write(p,e,400,!0),b(e),window.ftr__gt=e},I=function(){var t=_.read(p)||"",n=t.split("_"),e=function(t){return n[t]||void 0};return{id:e(0),ts:e(1),td:e(2),ex:e(3),vr:e(4)}},V=function(){for(var t={},n="fgu",e=[],r=0;r<256;r++)e[r]=(r<16?"0":"")+r.toString(16);var o=function(t,n,r,o,i){var c=i?"-":"";return e[255&t]+e[t>>8&255]+e[t>>16&255]+e[t>>24&255]+c+e[255&n]+e[n>>8&255]+c+e[n>>16&15|64]+e[n>>24&255]+c+e[63&r|128]+e[r>>8&255]+c+e[r>>16&255]+e[r>>24&255]+e[255&o]+e[o>>8&255]+e[o>>16&255]+e[o>>24&255]},i=function(){if(window.Uint32Array&&window.crypto&&window.crypto.getRandomValues){var t=new window.Uint32Array(4);return window.crypto.getRandomValues(t),{d0:t[0],d1:t[1],d2:t[2],d3:t[3]}}return{d0:4294967296*Math.random()>>>0,d1:4294967296*Math.random()>>>0,d2:4294967296*Math.random()>>>0,d3:4294967296*Math.random()>>>0}},c=function(){var t="",n=function(t,n){for(var e="",r=t;r>0;--r)e+=n.charAt(1e3*Math.random()%n.length);return e};return t+=n(2,"0123456789"),t+=n(1,"123456789"),t+=n(8,"0123456789")};return t.safeGenerateNoDash=function(){try{var t=i();return o(t.d0,t.d1,t.d2,t.d3,!1)}catch(t){try{return n+c()}catch(t){}}},t.isValidNumericalToken=function(t){return t&&t.toString().length<=11&&t.length>=9&&parseInt(t,10).toString().length<=11&&parseInt(t,10).toString().length>=9},t.isValidUUIDToken=function(t){return t&&32===t.toString().length&&/^[a-z0-9]+$/.test(t)},t.isValidFGUToken=function(t){return 0==t.indexOf(n)&&t.length>=12},t}(),R={uDF:"UDF",dUAL:"dUAL",uAS:"UAS",mLd:"1",eTlu:"2",eUoe:"3",uS:"4",uF:"9",tmos:["T5","T10","T15","T30","T60"],tmosSecs:[5,10,15,30,60],bIR:"43",uB:"u",uBr:"b",cP:"c",nIL:"i",s:"s"};try{var B=I();try{B.id&&(V.isValidNumericalToken(B.id)||V.isValidUUIDToken(B.id)||V.isValidFGUToken(B.id))?window.ftr__ncd=!1:(B.id=V.safeGenerateNoDash(),window.ftr__ncd=!0),B.ts=window.ftr__startScriptLoad,F(B),window.ftr__snp_cwc=!!_.read(p),window.ftr__snp_cwc||(q=D);for(var G="for"+"ter"+".co"+"m",M="ht"+"tps://c"+"dn9."+G,O="ht"+"tps://"+B.id+"-"+siteId+".cd"+"n."+G,j="http"+"s://cd"+"n3."+G,N=[M,O,j],H=0;H<N.length;H++)T(N[H]);var P=new Array(R.tmosSecs.length),Q=function(t){for(var n=0;n<R.tmosSecs.length;n++)P[n]=setTimeout(i,1e3*R.tmosSecs[n],t+R.tmos[n])},X=function(){for(var t=0;t<R.tmosSecs.length;t++)clearTimeout(P[t])};window.ftr__fdad=function(n,e){if(!m){m=!0;var r={};r[k]=d(window.ftr__config.s,siteId,window.ftr__config.m.csp),u(x,function(e){try{var r=e.getAllResponseHeaders().toLowerCase();if(r.indexOf(L.toLowerCase())>=0){var o=e.getResponseHeader(L);window.ftr__altd2=t(atob(o),-S-1)}if(r.indexOf(A.toLowerCase())<0)return;var i=e.getResponseHeader(A),c=t(atob(i),-S-1);if(c){var a=c.split(":");if(a&&2===a.length){for(var u=a[0],d=a[1],f="",s=0,h=0;s<20;++s)f+=s%3>0&&h<12?siteId.charAt(h++):B.id.charAt(s);var v=d.split(",");if(v.length>1){var w=v[0],l=v[1];C=u+"/"+w+"."+f+"."+l}}}n()}catch(t){}},function(t,n){e&&e(t,n)},r)}},Q(R.uDF),setTimeout(s,E,R.uDF)}catch(t){i(R.mLd)}}catch(t){};\n          })();\n        ')
        }
    });
};
/* harmony default export */ var elements_ForterScript = (ForterScript);

;// CONCATENATED MODULE: ./hooks/useForter.tsx




var ForterContext = /*#__PURE__*/ (0,react.createContext)({
    isWaitingForForter: false,
    shouldRenderForter: true,
    onRenderForter: function() {
        return null;
    }
});
var ForterProvider = function(param) {
    var children = param.children;
    var ref = (0,useSiteConfig/* useSiteConfig */.N)(), env = ref.env, delayForterLoad = ref.staticFeatures.delayForterLoad;
    var forterEnabled = !!env.forterSiteId;
    var ref1 = (0,react.useState)(!delayForterLoad && forterEnabled), shouldRenderForter = ref1[0], setShouldRenderForter = ref1[1];
    var ref2 = (0,react.useState)(forterEnabled), isWaitingForForter = ref2[0], setIsWaitingForForter = ref2[1];
    var providerValue = (0,react.useMemo)(function() {
        return {
            shouldRenderForter: shouldRenderForter,
            isWaitingForForter: isWaitingForForter,
            onRenderForter: function() {
                return forterEnabled ? setShouldRenderForter(true) : null;
            }
        };
    }, [
        isWaitingForForter,
        shouldRenderForter,
        forterEnabled
    ]);
    (0,react.useEffect)(function() {
        if (!forterEnabled) return;
        var handler = function() {
            return setIsWaitingForForter(false);
        };
        document.addEventListener("ftr:tokenReady", handler);
        return function() {
            return document.removeEventListener("ftr:tokenReady", handler);
        };
    }, [
        forterEnabled
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ForterContext.Provider, {
        value: providerValue,
        children: [
            shouldRenderForter ? /*#__PURE__*/ (0,jsx_runtime.jsx)(elements_ForterScript, {}) : null,
            children
        ]
    });
};
var useForter = function() {
    return (0,react.useContext)(ForterContext);
};


/***/ }),

/***/ 89113:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F9": function() { return /* binding */ getProductFromLinkUrl; },
/* harmony export */   "OM": function() { return /* binding */ GA4Provider; },
/* harmony export */   "tL": function() { return /* binding */ useGA4Events; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5341);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27378);
/* harmony import */ var utils_analytics__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83168);
/* harmony import */ var utils_ga4Items__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(54093);
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79758);
/* harmony import */ var _useSiteConfig__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(20368);
/* harmony import */ var _usePageEventsContext__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(43308);








var initialState = {
    setProduct: function() {
        return null;
    },
    fireSelectItemEvent: function() {
        return null;
    },
    fireClickProductImage: function() {
        return null;
    },
    fireEventGA4ForImageOpened: function() {
        return null;
    }
};
/*
 This context is used to share common information between
 different components in order to trigger GA4 events
*/ var GA4Context = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)(initialState);
var getImageTypeAndNumber = function() {
    if (utils_constants__WEBPACK_IMPORTED_MODULE_3__/* .isServer */ .sk) return undefined;
    var image_type = localStorage.getItem("image_type");
    var image_number = localStorage.getItem("image_number");
    return {
        imageType: image_type === null ? undefined : image_type,
        imageNumber: image_number === null ? undefined : image_number !== "unavailable" ? (0,utils_analytics__WEBPACK_IMPORTED_MODULE_2__/* .addPrefixToAnalyticProp */ .lL)(image_number) : undefined
    };
};
var getProductFromLinkUrl = function(linkUrl) {
    var ref;
    var pageType = (0,utils_analytics__WEBPACK_IMPORTED_MODULE_2__/* .getPageType */ .C2)(linkUrl);
    if (pageType != "pdp") return undefined;
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(linkUrl.split("?"), 2), route = ref1[0], params = ref1[1];
    var routeArr = route.split("/");
    var masterProductId = routeArr[routeArr.length - 1];
    var colorValue = (ref = params.match(/swatch=(.*?)(&|$)/i)) === null || ref === void 0 ? void 0 : ref[1];
    if (masterProductId && colorValue) return {
        id: "".concat(masterProductId, "_").concat(colorValue),
        colorValue: colorValue
    };
    return undefined;
};
var GA4Provider = function(param) {
    var children = param.children;
    var currency = (0,_useSiteConfig__WEBPACK_IMPORTED_MODULE_4__/* .useSiteConfig */ .N)().currency;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(), product = ref[0], setProduct = ref[1];
    var pageviewEventHasFired = (0,_usePageEventsContext__WEBPACK_IMPORTED_MODULE_5__/* .usePageEventsContext */ .qN)().pageviewEventHasFired;
    var providerValue = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        var imageData = getImageTypeAndNumber();
        var fireSelectItemEvent = function(itemId) {
            if (!product) return;
            var _colorValue;
            var id = itemId || "".concat(product.masterId, "_").concat((_colorValue = product.colorValue) !== null && _colorValue !== void 0 ? _colorValue : product === null || product === void 0 ? void 0 : product.color);
            var ga4Item = (0,utils_ga4Items__WEBPACK_IMPORTED_MODULE_7__/* .getGa4Item */ .Vr)(id);
            var item = (0,utils_analytics__WEBPACK_IMPORTED_MODULE_2__/* .transformListProductToAnalyticsItem */ .pD)({
                product: product,
                currency: currency.code,
                quantity: 1,
                categories: {
                    item_category: product.primaryCategoryId
                },
                itemListId: ga4Item === null || ga4Item === void 0 ? void 0 : ga4Item.lid,
                itemListName: ga4Item === null || ga4Item === void 0 ? void 0 : ga4Item.lname,
                index: ga4Item === null || ga4Item === void 0 ? void 0 : ga4Item.idx,
                creativeName: ga4Item === null || ga4Item === void 0 ? void 0 : ga4Item.cname,
                creativeSlot: ga4Item === null || ga4Item === void 0 ? void 0 : ga4Item.cslot,
                promotionId: ga4Item === null || ga4Item === void 0 ? void 0 : ga4Item.pid,
                promotionName: ga4Item === null || ga4Item === void 0 ? void 0 : ga4Item.pname,
                itemId: itemId
            });
            (0,utils_analytics__WEBPACK_IMPORTED_MODULE_2__/* .event */ .B)(utils_analytics__WEBPACK_IMPORTED_MODULE_2__/* .AnalyticsEvents.GA4EC_ItemListClick */ ._q.GA4EC_ItemListClick, {
                event_name: utils_analytics__WEBPACK_IMPORTED_MODULE_2__/* .AnalyticsEvents.SELECT_ITEM */ ._q.SELECT_ITEM,
                ecommerce: {
                    item_list_id: ga4Item === null || ga4Item === void 0 ? void 0 : ga4Item.lid,
                    item_list_name: ga4Item === null || ga4Item === void 0 ? void 0 : ga4Item.lname,
                    item_id_ep: id || product.productId,
                    item_name_ep: (product === null || product === void 0 ? void 0 : product.name) || product.productName,
                    image_type: imageData === null || imageData === void 0 ? void 0 : imageData.imageType,
                    image_number: imageData === null || imageData === void 0 ? void 0 : imageData.imageNumber,
                    items: [
                        item
                    ]
                }
            });
            setProduct(undefined);
        };
        var fireClickProductImage = function(source) {
            var ref = (0,utils_analytics__WEBPACK_IMPORTED_MODULE_2__/* .transformImageUrlToImageInteractionAnalyticsEvent */ .bA)(source), imageType = ref.imageType, imageNumber = ref.imageNumber;
            window.localStorage.setItem("image_type", imageType);
            window.localStorage.setItem("image_number", imageNumber);
        };
        var fireEventGA4ForImageOpened = function(param) {
            var itemListId = param.itemListId, itemListName = param.itemListName;
            if (pageviewEventHasFired) {
                (0,utils_analytics__WEBPACK_IMPORTED_MODULE_2__/* .event */ .B)(utils_analytics__WEBPACK_IMPORTED_MODULE_2__/* .AnalyticsEvents.GA4_CustomEvent */ ._q.GA4_CustomEvent, {
                    event_name: utils_analytics__WEBPACK_IMPORTED_MODULE_2__/* .AnalyticsEvents.GA4_IMAGE_OPENED */ ._q.GA4_IMAGE_OPENED,
                    event_params: {
                        item_id_ep: itemListId,
                        item_name_ep: itemListName
                    }
                });
            }
        };
        return {
            product: product,
            imageType: imageData === null || imageData === void 0 ? void 0 : imageData.imageType,
            imageNumber: imageData === null || imageData === void 0 ? void 0 : imageData.imageNumber,
            setProduct: setProduct,
            fireSelectItemEvent: fireSelectItemEvent,
            fireClickProductImage: fireClickProductImage,
            fireEventGA4ForImageOpened: fireEventGA4ForImageOpened
        };
    }, [
        product,
        currency.code,
        pageviewEventHasFired,
        setProduct
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(GA4Context.Provider, {
        value: providerValue,
        children: children
    });
};
var useGA4Events = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(GA4Context);
};


/***/ }),

/***/ 24466:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "l": function() { return /* binding */ GooglePayProvider; },
  "G": function() { return /* binding */ useGooglePay; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(23842);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(85034);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(70169);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(5341);
// EXTERNAL MODULE: ../node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(59312);
// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(24246);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ../node_modules/next/router.js
var next_router = __webpack_require__(86677);
// EXTERNAL MODULE: ../node_modules/next/script.js
var script = __webpack_require__(43218);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
// EXTERNAL MODULE: ./__generated__/graphql.ts
var graphql = __webpack_require__(37678);
// EXTERNAL MODULE: ./hooks/useCart.ts
var useCart = __webpack_require__(69771);
// EXTERNAL MODULE: ./hooks/useFeature.ts
var useFeature = __webpack_require__(53625);
// EXTERNAL MODULE: ./hooks/useRadial.tsx + 1 modules
var useRadial = __webpack_require__(42849);
// EXTERNAL MODULE: ./hooks/useSiteConfig.ts
var useSiteConfig = __webpack_require__(20368);
// EXTERNAL MODULE: ./hooks/useTranslations.tsx
var useTranslations = __webpack_require__(77480);
// EXTERNAL MODULE: ./utils/constants.ts
var constants = __webpack_require__(79758);
// EXTERNAL MODULE: ./utils/isNumber.ts
var isNumber = __webpack_require__(95442);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_array_with_holes.mjs
var _array_with_holes = __webpack_require__(19695);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(82126);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_non_iterable_rest.mjs
var _non_iterable_rest = __webpack_require__(30539);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(12164);
;// CONCATENATED MODULE: ../node_modules/@swc/helpers/src/_to_array.mjs





function _toArray(arr) {
  return (0,_array_with_holes/* default */.Z)(arr) || (0,_iterable_to_array/* default */.Z)(arr) || (0,_unsupported_iterable_to_array/* default */.Z)(arr, i) || (0,_non_iterable_rest/* default */.Z)();
}

;// CONCATENATED MODULE: ./utils/splitName.ts

var splitName = function(fullName) {
    var ref = _toArray(fullName.split(" ")), firstName = ref[0], otherNames = ref.slice(1);
    return {
        firstName: otherNames.length ? firstName : "",
        lastName: otherNames.length ? otherNames.join(" ") : fullName
    };
};

// EXTERNAL MODULE: ./utils/forter.ts
var forter = __webpack_require__(63179);
;// CONCATENATED MODULE: ./hooks/useGooglePay.tsx



















var GooglePayContext = /*#__PURE__*/ (0,react.createContext)({});
var SUPPORTED_PAYMENT_GATEWAYS = [
    "adyen",
    "radialpayments"
];
var BASE_REQUEST = {
    apiVersion: 2,
    apiVersionMinor: 0
};
var ALLOWED_CARD_AUTH_METHODS = [
    "PAN_ONLY",
    "CRYPTOGRAM_3DS", 
];
var ALLOWED_CARD_NETWORKS = [
    "AMEX",
    "DISCOVER",
    "MASTERCARD",
    "VISA", 
];
var PAYMENT_DATA_REQUEST_UPDATE_NOOP = {};
var GooglePayProvider = function(param) {
    var children = param.children;
    var router = (0,next_router.useRouter)();
    var t = (0,useTranslations/* useTranslate */.qM)();
    var isGooglePayEnabled = (0,useFeature/* useFeature */.S)(constants/* PaymentMethod.GOOGLE_PAY */.XL.GOOGLE_PAY);
    var ref = (0,useSiteConfig/* useSiteConfig */.N)(), countryCode = ref.countryCode, env = ref.env, currency = ref.currency, language = ref.language, localizeUrlPath = ref.localizeUrlPath;
    var _googlePayPaymentGateway;
    var paymentGateway = (_googlePayPaymentGateway = env.googlePayPaymentGateway) !== null && _googlePayPaymentGateway !== void 0 ? _googlePayPaymentGateway : "";
    var isSupportedPaymentGateway = SUPPORTED_PAYMENT_GATEWAYS.includes(paymentGateway);
    var ref1 = (0,react.useState)(false), shouldInitialize = ref1[0], setShouldInitialize = ref1[1];
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,graphql/* usePayWithGooglePayMutation */.r3o)(), 2), googlePay = ref2[1];
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,graphql/* useCancelGooglePayMutation */.Q$F)(), 2), cancelGooglePay = ref3[1];
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,graphql/* useStartAdyenPaymentMutation */.MdU)(), 2), startAdyenPayment = ref4[1];
    var ref5 = (0,useRadial/* useRadial */.KS)(), radialFingerPrint = ref5.radialFingerPrint, radialFrontendContext = ref5.radialFrontendContext;
    var ref6 = (0,_sliced_to_array/* default */.Z)((0,graphql/* useUpdateShipmentMethodMutation */.ejx)(), 2), updateShipmentMethod = ref6[1];
    var ref7 = (0,_sliced_to_array/* default */.Z)((0,graphql/* useUpdateShippingAddressMutation */.Iav)(), 2), updateShippingAddress = ref7[1];
    var ref8 = (0,_sliced_to_array/* default */.Z)((0,graphql/* useUpdateBillingAddressMutation */.$It)(), 2), updateBillingAddress = ref8[1];
    var ref9 = (0,useCart/* useCart */.j)({
        pause: !shouldInitialize
    }), _activeCart = ref9.cart;
    var activeCartRef = (0,react.useRef)();
    (0,react.useEffect)(function() {
        // ActiveCart reference for callback methods to prevent stale closures
        if (_activeCart) {
            activeCartRef.current = _activeCart;
        }
    }, [
        _activeCart
    ]);
    var cancelGooglePayCallback = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(basketId) {
            var _tmp;
            return (0,tslib_es6.__generator)(this, function(_state) {
                _tmp = {};
                return [
                    2,
                    cancelGooglePay((_tmp.input = {
                        basketId: basketId
                    }, _tmp))
                ];
            });
        });
        return function cancelGooglePayCallback(basketId) {
            return _ref.apply(this, arguments);
        };
    }();
    var ref10, ref11, ref12, _price, _price1, ref13;
    var getTransactionInfo = function(cart) {
        var ref, ref1, ref2;
        return {
            countryCode: countryCode.toUpperCase(),
            currencyCode: currency.code,
            displayItems: [
                {
                    label: t("subtotal"),
                    price: "".concat(((ref10 = cart === null || cart === void 0 ? void 0 : cart.subTotal) !== null && ref10 !== void 0 ? ref10 : 0).toFixed(2)),
                    type: "SUBTOTAL"
                },
                {
                    label: t("estimatedSalesTax"),
                    price: "".concat(((ref11 = cart === null || cart === void 0 ? void 0 : cart.taxTotal) !== null && ref11 !== void 0 ? ref11 : 0).toFixed(2)),
                    type: "TAX"
                },
                {
                    label: t("shippingCosts"),
                    price: "".concat(((ref12 = cart === null || cart === void 0 ? void 0 : (ref = cart.shipment) === null || ref === void 0 ? void 0 : (ref1 = ref.shipmentMethod) === null || ref1 === void 0 ? void 0 : ref1.price) !== null && ref12 !== void 0 ? ref12 : 0).toFixed(2)),
                    type: "LINE_ITEM"
                },
                {
                    label: t("orderDiscount"),
                    price: "".concat((cart === null || cart === void 0 ? void 0 : cart.orderAdjustments).reduce(function(sum, item) {
                        return sum + ((_price = item.price) !== null && _price !== void 0 ? _price : 0);
                    }, 0).toFixed(2)),
                    type: "DISCOUNT"
                },
                {
                    label: t("shippingDiscount"),
                    price: "".concat((cart === null || cart === void 0 ? void 0 : cart.shippingAdjustments).reduce(function(sum, item) {
                        return sum + ((_price1 = item.price) !== null && _price1 !== void 0 ? _price1 : 0);
                    }, 0).toFixed(2)),
                    type: "DISCOUNT"
                }, 
            ],
            totalPriceStatus: "FINAL",
            totalPrice: (ref13 = cart === null || cart === void 0 ? void 0 : (ref2 = cart.estimatedTotal) === null || ref2 === void 0 ? void 0 : ref2.toFixed(2)) !== null && ref13 !== void 0 ? ref13 : "0.00",
            totalPriceLabel: t("total")
        };
    };
    var handleShippingOptionUpdate = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(cart, shippingMethodId) {
            var ref, ref1, updateShipmentOperationResult, _tmp, _tmp1, _tmp2;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _tmp = {};
                        return [
                            4,
                            updateShipmentMethod((_tmp.input = {
                                shippingMethodId: shippingMethodId,
                                basketId: (ref1 = cart === null || cart === void 0 ? void 0 : cart.id) !== null && ref1 !== void 0 ? ref1 : ""
                            }, _tmp))
                        ];
                    case 1:
                        updateShipmentOperationResult = _state.sent();
                        _tmp1 = {};
                        if (!((ref = updateShipmentOperationResult.data) === null || ref === void 0 ? void 0 : ref.updateShipmentMethod) || updateShipmentOperationResult.error) {
                            return [
                                2,
                                (_tmp1.error = {
                                    reason: "SHIPPING_OPTION_INVALID",
                                    intent: "SHIPPING_OPTION",
                                    message: "Shipping option is invalid."
                                }, _tmp1)
                            ];
                        }
                        _tmp2 = {};
                        return [
                            2,
                            (_tmp2.newTransactionInfo = getTransactionInfo(updateShipmentOperationResult.data.updateShipmentMethod), _tmp2)
                        ];
                }
            });
        });
        return function handleShippingOptionUpdate(cart, shippingMethodId) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleIntermediateShippingAddressUpdate = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(cart, intermediateShippingAddress) {
            var ref, locality, countryCode, postalCode, administrativeArea, ref1, updateShippingAddressOperationResult, _tmp, _tmp1, _tmp2;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        locality = intermediateShippingAddress.locality, countryCode = intermediateShippingAddress.countryCode, postalCode = intermediateShippingAddress.postalCode, administrativeArea = intermediateShippingAddress.administrativeArea;
                        _tmp = {};
                        return [
                            4,
                            updateShippingAddress((_tmp.input = {
                                address1: "Temporary",
                                basketId: (ref1 = cart === null || cart === void 0 ? void 0 : cart.id) !== null && ref1 !== void 0 ? ref1 : "",
                                city: locality,
                                countryCode: countryCode,
                                firstName: "Temporary",
                                lastName: "Temporary",
                                postalCode: postalCode,
                                stateCode: administrativeArea,
                                useAsBilling: false
                            }, _tmp))
                        ];
                    case 1:
                        updateShippingAddressOperationResult = _state.sent();
                        _tmp1 = {};
                        if (!((ref = updateShippingAddressOperationResult.data) === null || ref === void 0 ? void 0 : ref.updateShippingAddress) || updateShippingAddressOperationResult.error) {
                            return [
                                2,
                                (_tmp1.error = {
                                    reason: "SHIPPING_ADDRESS_INVALID",
                                    intent: "SHIPPING_ADDRESS",
                                    message: "Shipping address is invalid."
                                }, _tmp1)
                            ];
                        }
                        _tmp2 = {};
                        return [
                            2,
                            (_tmp2.newTransactionInfo = getTransactionInfo(updateShippingAddressOperationResult.data.updateShippingAddress), _tmp2)
                        ];
                }
            });
        });
        return function handleIntermediateShippingAddressUpdate(cart, intermediateShippingAddress) {
            return _ref.apply(this, arguments);
        };
    }();
    var onPaymentDataChanged = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(intermediatePaymentData) {
            var activeCart, ref;
            return (0,tslib_es6.__generator)(this, function(_state) {
                activeCart = activeCartRef.current;
                if (!activeCart) return [
                    2,
                    PAYMENT_DATA_REQUEST_UPDATE_NOOP
                ];
                switch(intermediatePaymentData.callbackTrigger){
                    case "INITIALIZE":
                    case "SHIPPING_ADDRESS":
                        {
                            if (!intermediatePaymentData.shippingAddress) {
                                return [
                                    2,
                                    PAYMENT_DATA_REQUEST_UPDATE_NOOP
                                ];
                            }
                            return [
                                2,
                                handleIntermediateShippingAddressUpdate(activeCart, intermediatePaymentData.shippingAddress)
                            ];
                        }
                    case "SHIPPING_OPTION":
                        {
                            ;
                            if (!((ref = intermediatePaymentData.shippingOptionData) === null || ref === void 0 ? void 0 : ref.id)) {
                                return [
                                    2,
                                    PAYMENT_DATA_REQUEST_UPDATE_NOOP
                                ];
                            }
                            return [
                                2,
                                handleShippingOptionUpdate(activeCart, intermediatePaymentData.shippingOptionData.id)
                            ];
                        }
                    default:
                        return [
                            2,
                            PAYMENT_DATA_REQUEST_UPDATE_NOOP
                        ];
                }
                return [
                    2
                ];
            });
        });
        return function onPaymentDataChanged(intermediatePaymentData) {
            return _ref.apply(this, arguments);
        };
    }();
    var onPaymentAuthorized = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(paymentData) {
            var ref, activeCart, _tmp, email, _tmp1, shippingAddress, billingAddress, phone, _tmp2, shippingAddressInvalidResult, _tmp3, ref1, ref2, firstName, lastName, updateShippingAddressOperationResult, _tmp4, billingAddressInvalidResult, _tmp5, ref3, ref4, firstName1, lastName1, updateBillingAddressOperationResult, _tmp6, paymentAuthorizationInvalidResult, _tmp7, basketId, token, orderNo, ref5, startAdyenPaymentOperationResult, _tmp8, _orderNo, ref6, parsedToken, googlePayOperationResult, _tmp9, _tmp10, _tmp11;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        activeCart = activeCartRef.current;
                        _tmp = {};
                        if (!activeCart) {
                            return [
                                2,
                                (_tmp.transactionState = "ERROR", _tmp.error = {
                                    reason: "OTHER_ERROR",
                                    intent: "PAYMENT_AUTHORIZATION",
                                    message: "Cart is required for payment authorization."
                                }, _tmp)
                            ];
                        }
                        email = paymentData.email;
                        _tmp1 = {};
                        if (!email) {
                            return [
                                2,
                                (_tmp1.transactionState = "ERROR", _tmp1.error = {
                                    reason: "PAYMENT_DATA_INVALID",
                                    intent: "PAYMENT_AUTHORIZATION",
                                    message: "Email is required for payment authorization."
                                }, _tmp1)
                            ];
                        }
                        shippingAddress = paymentData.shippingAddress;
                        billingAddress = (ref = paymentData.paymentMethodData.info) === null || ref === void 0 ? void 0 : ref.billingAddress;
                        phone = (shippingAddress === null || shippingAddress === void 0 ? void 0 : shippingAddress.phoneNumber) || (billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.phoneNumber);
                        _tmp2 = {};
                        if (!phone) {
                            return [
                                2,
                                (_tmp2.transactionState = "ERROR", _tmp2.error = {
                                    reason: "PAYMENT_DATA_INVALID",
                                    intent: "PAYMENT_AUTHORIZATION",
                                    message: "Phone number is required for payment authorization."
                                }, _tmp2)
                            ];
                        }
                        _tmp3 = {};
                        shippingAddressInvalidResult = (_tmp3.transactionState = "ERROR", _tmp3.error = {
                            reason: "SHIPPING_ADDRESS_INVALID",
                            intent: "PAYMENT_AUTHORIZATION",
                            message: "Shipping address is invalid."
                        }, _tmp3);
                        if (!(shippingAddress && shippingAddress.address1 && shippingAddress.name)) return [
                            3,
                            4
                        ];
                        ref2 = splitName(shippingAddress.name), firstName = ref2.firstName, lastName = ref2.lastName;
                        _tmp4 = {};
                        return [
                            4,
                            updateShippingAddress((_tmp4.input = {
                                address1: shippingAddress.address1,
                                address2: shippingAddress.address2,
                                basketId: activeCart.id,
                                city: shippingAddress.locality,
                                countryCode: shippingAddress.countryCode,
                                firstName: firstName,
                                lastName: lastName,
                                phone: phone,
                                postalCode: shippingAddress.postalCode,
                                stateCode: shippingAddress.administrativeArea,
                                email: email,
                                useAsBilling: false
                            }, _tmp4))
                        ];
                    case 1:
                        updateShippingAddressOperationResult = _state.sent();
                        if (!(!((ref1 = updateShippingAddressOperationResult.data) === null || ref1 === void 0 ? void 0 : ref1.updateShippingAddress) || updateShippingAddressOperationResult.error)) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            cancelGooglePayCallback(activeCart.id)
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2,
                            shippingAddressInvalidResult
                        ];
                    case 3:
                        return [
                            3,
                            5
                        ];
                    case 4:
                        return [
                            2,
                            shippingAddressInvalidResult
                        ];
                    case 5:
                        _tmp5 = {};
                        billingAddressInvalidResult = (_tmp5.transactionState = "ERROR", _tmp5.error = {
                            reason: "PAYMENT_DATA_INVALID",
                            intent: "PAYMENT_AUTHORIZATION",
                            message: "Billing address is invalid."
                        }, _tmp5);
                        if (!(billingAddress && billingAddress.address1 && billingAddress.name)) return [
                            3,
                            9
                        ];
                        ref4 = splitName(billingAddress.name), firstName1 = ref4.firstName, lastName1 = ref4.lastName;
                        _tmp6 = {};
                        return [
                            4,
                            updateBillingAddress((_tmp6.input = {
                                address1: billingAddress.address1,
                                address2: billingAddress.address2,
                                basketId: activeCart.id,
                                city: billingAddress.locality,
                                countryCode: billingAddress.countryCode,
                                firstName: firstName1,
                                lastName: lastName1,
                                phone: phone,
                                postalCode: billingAddress.postalCode,
                                stateCode: billingAddress.administrativeArea
                            }, _tmp6))
                        ];
                    case 6:
                        updateBillingAddressOperationResult = _state.sent();
                        if (!(!((ref3 = updateBillingAddressOperationResult.data) === null || ref3 === void 0 ? void 0 : ref3.updateBillingAddress) || updateBillingAddressOperationResult.error)) return [
                            3,
                            8
                        ];
                        return [
                            4,
                            cancelGooglePayCallback(activeCart.id)
                        ];
                    case 7:
                        _state.sent();
                        return [
                            2,
                            billingAddressInvalidResult
                        ];
                    case 8:
                        return [
                            3,
                            10
                        ];
                    case 9:
                        return [
                            2,
                            billingAddressInvalidResult
                        ];
                    case 10:
                        _tmp7 = {};
                        paymentAuthorizationInvalidResult = (_tmp7.transactionState = "ERROR", _tmp7.error = {
                            reason: "OTHER_ERROR",
                            message: "Payment could not be authorized.",
                            intent: "PAYMENT_AUTHORIZATION"
                        }, _tmp7);
                        basketId = activeCart.id;
                        token = paymentData.paymentMethodData.tokenizationData.token;
                        orderNo = "";
                        switch(paymentGateway){
                            case "adyen":
                                return [
                                    3,
                                    11
                                ];
                            case "radialpayments":
                                return [
                                    3,
                                    13
                                ];
                        }
                        return [
                            3,
                            15
                        ];
                    case 11:
                        _tmp8 = {};
                        return [
                            4,
                            startAdyenPayment((_tmp8.input = {
                                basketId: basketId,
                                adyenPaymentData: {
                                    paymentMethodType: graphql/* AdyenPaymentMethod.GooglePay */._Q8.GooglePay,
                                    googlePay: {
                                        googlePayToken: token
                                    }
                                }
                            }, _tmp8))
                        ];
                    case 12:
                        startAdyenPaymentOperationResult = _state.sent();
                        if (!((ref5 = startAdyenPaymentOperationResult.data) === null || ref5 === void 0 ? void 0 : ref5.startAdyenPayment) || startAdyenPaymentOperationResult.error) {
                            return [
                                2,
                                paymentAuthorizationInvalidResult
                            ];
                        }
                        orderNo = (_orderNo = startAdyenPaymentOperationResult.data.startAdyenPayment.orderNo) !== null && _orderNo !== void 0 ? _orderNo : "";
                        return [
                            3,
                            16
                        ];
                    case 13:
                        parsedToken = JSON.parse(token);
                        _tmp9 = {};
                        return [
                            4,
                            googlePay((_tmp9.input = {
                                basketId: basketId,
                                paymentData: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, parsedToken), {
                                    intermediateSigningKey: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, parsedToken.intermediateSigningKey), {
                                        signedKey: JSON.parse(parsedToken.intermediateSigningKey.signedKey)
                                    }),
                                    signedMessage: JSON.parse(parsedToken.signedMessage)
                                }),
                                radialFingerPrint: radialFingerPrint,
                                radialFrontendContext: radialFrontendContext,
                                forterToken: (0,forter/* getForterToken */.Ze)()
                            }, _tmp9))
                        ];
                    case 14:
                        googlePayOperationResult = _state.sent();
                        if (!((ref6 = googlePayOperationResult.data) === null || ref6 === void 0 ? void 0 : ref6.googlePay) || googlePayOperationResult.error) {
                            return [
                                2,
                                paymentAuthorizationInvalidResult
                            ];
                        }
                        orderNo = googlePayOperationResult.data.googlePay.orderNo;
                        return [
                            3,
                            16
                        ];
                    case 15:
                        return [
                            2,
                            paymentAuthorizationInvalidResult
                        ];
                    case 16:
                        window.sessionStorage.setItem("payment-method", "Google Pay");
                        _tmp10 = {};
                        router.push((_tmp10.pathname = localizeUrlPath("/checkout/confirmation"), _tmp10.query = {
                            orderNo: orderNo
                        }, _tmp10));
                        _tmp11 = {};
                        return [
                            2,
                            (_tmp11.transactionState = "SUCCESS", _tmp11)
                        ];
                }
            });
        });
        return function onPaymentAuthorized(paymentData) {
            return _ref.apply(this, arguments);
        };
    }();
    var ref14 = (0,react.useState)(false), scriptDidLoad = ref14[0], setScriptDidLoad = ref14[1];
    var ref15 = (0,react.useState)(), paymentsClient = ref15[0], setPaymentsClient = ref15[1];
    var ref16 = (0,react.useState)(false), isReadyToPay = ref16[0], setIsReadyToPay = ref16[1];
    (0,react.useEffect)(function() {
        // initialize paymentsClient instance
        if (constants/* isServer */.sk || !shouldInitialize || !scriptDidLoad || paymentsClient) {
            return;
        }
        var newPaymentsClient = new window.google.payments.api.PaymentsClient({
            environment: env.googlePayEnvironment,
            paymentDataCallbacks: {
                onPaymentDataChanged: onPaymentDataChanged,
                onPaymentAuthorized: onPaymentAuthorized
            }
        });
        setPaymentsClient(newPaymentsClient);
    }, [
        shouldInitialize,
        scriptDidLoad,
        paymentsClient
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    (0,react.useEffect)(function() {
        // set isReadyToPay
        if (!paymentsClient) return;
        var getIsReadyToPay = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var result, _tmp, _tmp1;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _tmp = {};
                            _tmp1 = {};
                            return [
                                4,
                                paymentsClient.isReadyToPay((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)(_tmp, BASE_REQUEST), (_tmp1.allowedPaymentMethods = [
                                    {
                                        type: "CARD",
                                        parameters: {
                                            allowedAuthMethods: ALLOWED_CARD_AUTH_METHODS,
                                            allowedCardNetworks: ALLOWED_CARD_NETWORKS
                                        }
                                    }, 
                                ], _tmp1)))
                            ];
                        case 1:
                            result = _state.sent().result;
                            setIsReadyToPay(result);
                            return [
                                2
                            ];
                    }
                });
            });
            return function getIsReadyToPay() {
                return _ref.apply(this, arguments);
            };
        }();
        getIsReadyToPay();
    }, [
        paymentsClient
    ]);
    var injectButtonStyles = function(buttonType) {
        if (!paymentsClient || !isReadyToPay) return;
        paymentsClient.createButton({
            buttonColor: "black",
            buttonType: buttonType,
            buttonLocale: language,
            onClick: function() {
                return undefined;
            }
        });
    };
    var formatShippingMethodPrice = function(price) {
        // google pay uses 'CA$' not 'CAD $' for canada
        var isCanada = countryCode.toUpperCase() === constants/* SUPPORTED_COUNTRY.CA */.bM.CA;
        return "".concat(isCanada ? "CA$" : currency.symbol).concat(price.toFixed(2));
    };
    var handleGooglePay = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var activeCart, cartHasProducts, ref, ref1, ref2, ref3, _googlePayMerchantId, _googlePayMerchantName, _googlePayPaymentGatewayMerchantId, _name, ref4, ref5, ref6, _tmp, _tmp1, e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        activeCart = activeCartRef.current;
                        if (!paymentsClient || !isReadyToPay || !activeCart) return [
                            2
                        ];
                        cartHasProducts = activeCart.products.some(function(product) {
                            return product.__typename !== "GiftCardCartItem";
                        });
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            5
                        ]);
                        _tmp = {};
                        _tmp1 = {};
                        return [
                            4,
                            paymentsClient.loadPaymentData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)(_tmp, BASE_REQUEST), (_tmp1.transactionInfo = getTransactionInfo(activeCart), _tmp1.merchantInfo = {
                                merchantId: (_googlePayMerchantId = env.googlePayMerchantId) !== null && _googlePayMerchantId !== void 0 ? _googlePayMerchantId : "",
                                merchantName: (_googlePayMerchantName = env.googlePayMerchantName) !== null && _googlePayMerchantName !== void 0 ? _googlePayMerchantName : ""
                            }, _tmp1.allowedPaymentMethods = [
                                {
                                    type: "CARD",
                                    tokenizationSpecification: {
                                        type: "PAYMENT_GATEWAY",
                                        parameters: {
                                            gateway: paymentGateway,
                                            gatewayMerchantId: (_googlePayPaymentGatewayMerchantId = env.googlePayPaymentGatewayMerchantId) !== null && _googlePayPaymentGatewayMerchantId !== void 0 ? _googlePayPaymentGatewayMerchantId : ""
                                        }
                                    },
                                    parameters: {
                                        allowedAuthMethods: ALLOWED_CARD_AUTH_METHODS,
                                        allowedCardNetworks: ALLOWED_CARD_NETWORKS,
                                        billingAddressRequired: true,
                                        billingAddressParameters: {
                                            format: "FULL"
                                        }
                                    }
                                }, 
                            ], _tmp1.emailRequired = true, _tmp1.shippingAddressRequired = true, _tmp1.shippingAddressParameters = {
                                allowedCountryCodes: [
                                    countryCode.toUpperCase()
                                ],
                                phoneNumberRequired: true
                            }, _tmp1.shippingOptionRequired = true, _tmp1.shippingOptionParameters = {
                                shippingOptions: (ref4 = (ref = activeCart.shipmentMethodInfo) === null || ref === void 0 ? void 0 : ref.availableShipmentMethods.filter(function(m) {
                                    return cartHasProducts ? true : m.id === "Email";
                                }).map(function(m) {
                                    return {
                                        id: m.id,
                                        label: (_name = m.name) !== null && _name !== void 0 ? _name : "",
                                        description: (0,isNumber/* isNumber */.h)(m.price) ? formatShippingMethodPrice(m.price) : undefined
                                    };
                                })) !== null && ref4 !== void 0 ? ref4 : [],
                                defaultSelectedOptionId: (ref6 = (ref5 = (ref1 = activeCart.shipment) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.shipmentMethod) === null || ref2 === void 0 ? void 0 : ref2.id) !== null && ref5 !== void 0 ? ref5 : (ref3 = activeCart.shipmentMethodInfo) === null || ref3 === void 0 ? void 0 : ref3.defaultShipmentMethodId) !== null && ref6 !== void 0 ? ref6 : undefined
                            }, _tmp1.callbackIntents = [
                                "SHIPPING_ADDRESS",
                                "SHIPPING_OPTION",
                                "PAYMENT_AUTHORIZATION", 
                            ], _tmp1)))
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            5
                        ];
                    case 3:
                        e = _state.sent();
                        return [
                            4,
                            cancelGooglePayCallback(activeCart.id)
                        ];
                    case 4:
                        _state.sent();
                        return [
                            3,
                            5
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleGooglePay() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            shouldInitialize && /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                async: true,
                src: "https://pay.google.com/gp/p/js/pay.js",
                onLoad: function() {
                    return setScriptDidLoad(true);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GooglePayContext.Provider, {
                value: {
                    enableGooglePay: function() {
                        // called when <GooglePayButton /> renders
                        if (!isGooglePayEnabled || !isSupportedPaymentGateway) return;
                        setShouldInitialize(true);
                    },
                    isGooglePayEnabled: isReadyToPay,
                    injectButtonStyles: injectButtonStyles,
                    handleGooglePay: handleGooglePay
                },
                children: children
            })
        ]
    });
};
var useGooglePay = function() {
    return (0,react.useContext)(GooglePayContext);
};


/***/ }),

/***/ 48548:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "g3": function() { return /* binding */ GoogleServicesProvider; },
  "o0": function() { return /* binding */ useGoogleServices; }
});

// UNUSED EXPORTS: GoogleServicesContext

// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(24246);
// EXTERNAL MODULE: ../node_modules/next/script.js
var script = __webpack_require__(43218);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(3204);
;// CONCATENATED MODULE: ./utils/throttle.ts

var throttle = function(fn) {
    var ms = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 500;
    var lock = false;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        if (!lock) {
            lock = true;
            setTimeout(function() {
                return lock = false;
            }, ms);
            return fn.apply(void 0, (0,_to_consumable_array/* default */.Z)(args));
        }
        return undefined;
    };
};

// EXTERNAL MODULE: ./hooks/useSiteConfig.ts
var useSiteConfig = __webpack_require__(20368);
;// CONCATENATED MODULE: ./hooks/useGoogleServices.tsx





var errorMessage = "Not inside <GoogleServicesProvider />.";
var isOkStatus = function(status) {
    return [
        window.google.maps.places.PlacesServiceStatus.OK,
        window.google.maps.places.PlacesServiceStatus.ZERO_RESULTS,
        window.google.maps.GeocoderStatus.OK,
        window.google.maps.GeocoderStatus.ZERO_RESULTS, 
    ].includes(status);
};
var GoogleServicesContext = /*#__PURE__*/ (0,react.createContext)({
    autoComplete: function() {
        return Promise.reject(new Error(errorMessage));
    },
    getPlaceDetails: function() {
        return Promise.reject(new Error(errorMessage));
    },
    geocode: function() {
        return Promise.reject(new Error(errorMessage));
    }
});
var GoogleServicesProvider = function(param) {
    var children = param.children;
    var env = (0,useSiteConfig/* useSiteConfig */.N)().env;
    var autoCompleteService = (0,react.useRef)();
    var placesService = (0,react.useRef)();
    var geocodeService = (0,react.useRef)();
    (0,react.useEffect)(function() {
        var ref, ref1, ref2;
        var initializeServices = function() {
            autoCompleteService.current = new window.google.maps.places.AutocompleteService();
            placesService.current = new window.google.maps.places.PlacesService(document.createElement("div"));
            geocodeService.current = new window.google.maps.Geocoder();
        };
        if ((ref = window.google) === null || ref === void 0 ? void 0 : (ref1 = ref.maps) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.places) === null || ref2 === void 0 ? void 0 : ref2.AutocompleteService) {
            initializeServices();
        } else {
            window.onGoogleMapsLoad = function() {
                initializeServices();
                delete window.onGoogleMapsLoad;
            };
        }
    }, []);
    var autoComplete = function(term, countryRestrictions) {
        if (!autoCompleteService.current) {
            return Promise.reject(new Error("Google Service not available."));
        }
        return new Promise(function(resolve, reject) {
            return autoCompleteService.current.getPlacePredictions({
                input: term,
                componentRestrictions: {
                    country: countryRestrictions || []
                }
            }, function(result, status) {
                if (isOkStatus(status)) {
                    resolve(result || []);
                } else {
                    reject(new Error("Google Service not available: ".concat(status)));
                }
            });
        });
    };
    var getPlaceDetails = throttle(function(id) {
        if (!placesService.current) {
            return Promise.reject(new Error("Google Service not available."));
        }
        return new Promise(function(resolve, reject) {
            return placesService.current.getDetails({
                placeId: id
            }, function(place, status) {
                if (isOkStatus(status)) {
                    resolve(place);
                } else {
                    reject(new Error("Google Service not available: ".concat(status)));
                }
            });
        });
    });
    var geocode = function(postalCode, country) {
        if (!geocodeService.current) {
            return Promise.reject(new Error("Google Service not available."));
        }
        return new Promise(function(resolve, reject) {
            return geocodeService.current.geocode({
                componentRestrictions: {
                    postalCode: postalCode,
                    country: country
                }
            }, function(result, status) {
                if (isOkStatus(status) && result) {
                    resolve(result[0]);
                } else {
                    reject(new Error("Google Service not available: ".concat(status)));
                }
            });
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(GoogleServicesContext.Provider, {
        value: {
            autoComplete: autoComplete,
            getPlaceDetails: getPlaceDetails,
            geocode: geocode
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                async: true,
                src: "https://maps.googleapis.com/maps/api/js?key=".concat(env.googleApiKey, "&callback=onGoogleMapsLoad&libraries=places")
            }),
            children
        ]
    });
};
var useGoogleServices = function() {
    return (0,react.useContext)(GoogleServicesContext);
};


/***/ }),

/***/ 95967:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Mo": function() { return /* binding */ useGroqQuery; },
/* harmony export */   "i8": function() { return /* binding */ groqPreviewInput; },
/* harmony export */   "lK": function() { return /* binding */ CONTENT_QUERY; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5341);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19989);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86677);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27378);
/* harmony import */ var urql__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70463);
/* harmony import */ var urql__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(25380);
/* harmony import */ var utils_isInitialClientRender__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64191);
/* harmony import */ var _useAuth__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(72507);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query Content_",
        "($input: ContentInput!) {\n    content(input: $input)\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var CONTENT_QUERY = function(operationName) {
    return (0,urql__WEBPACK_IMPORTED_MODULE_5__/* .gql */ .Ps)(_templateObject(), operationName);
};
var groqPreviewInput = function(routerQuery) {
    var ref;
    return {
        viewAt: routerQuery.viewAt,
        customerGroups: (ref = routerQuery.customerGroups) === null || ref === void 0 ? void 0 : ref.split(","),
        global: routerQuery.global === "true"
    };
};
var useGroqQuery = function(props) {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var auth = (0,_useAuth__WEBPACK_IMPORTED_MODULE_4__/* .useAuth */ .aC)();
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,urql__WEBPACK_IMPORTED_MODULE_7__/* .useQuery */ .aM)({
        query: CONTENT_QUERY(props.operationName),
        variables: {
            input: {
                query: props.query.replace(/[\n]+/g, "").replace(/\s\s+/g, ""),
                params: props.variables,
                src: router.query.src,
                draft: router.query.draft,
                preview: groqPreviewInput(router.query)
            }
        },
        pause: props.pause
    }), 2), result = ref[0], refetch = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        // Refetch this query on the client within the context of a customer
        // if this is the first render after SSR (which is always a guest)
        if ((0,utils_isInitialClientRender__WEBPACK_IMPORTED_MODULE_3__/* .isInitialClientRender */ .R)(router) && !auth.guest) {
            // Has to be within a timeout until we upgrade URQL to version ^3.0.0
            refetch({
                requestPolicy: "network-only"
            });
        }
    // We _really_ only want to run this on the first render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return [
        result,
        refetch
    ];
};


/***/ }),

/***/ 99592:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ useHeading; },
/* harmony export */   "u": function() { return /* binding */ HeadingProvider; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27378);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86677);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);



var HeadingContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({
    headingRef: {
        current: null
    },
    isPLPref: {
        current: false
    }
});
var useHeading = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(HeadingContext);
};
var HeadingProvider = function(param) {
    var children = param.children;
    var headingRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var isPLPref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(false);
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        return function() {
            headingRef.current = null;
        };
    }, [
        router.asPath
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(HeadingContext.Provider, {
        value: {
            headingRef: headingRef,
            isPLPref: isPLPref
        },
        children: children
    });
};


/***/ }),

/***/ 69340:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ useIntersectionObserver; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5341);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var _useIsServer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64724);



var useIntersectionObserver = function(container, callback, enabled, options, onIntersectionLoss) {
    var isServer = (0,_useIsServer__WEBPACK_IMPORTED_MODULE_1__/* .useIsServer */ .w)();
    var callbackRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(callback);
    var onIntersectionLossRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(onIntersectionLoss);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        callbackRef.current = callback;
        onIntersectionLossRef.current = onIntersectionLoss;
    }, [
        callback,
        onIntersectionLoss
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var observer;
        if (container.current && !isServer) {
            observer = new IntersectionObserver(function(param) {
                var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(param, 1), element = _param[0];
                if (element.isIntersecting && enabled) {
                    callbackRef.current(element.target, observer);
                }
            }, options);
            observer.observe(container.current);
        }
        return function() {
            onIntersectionLossRef.current && onIntersectionLossRef.current();
            if (observer) observer.disconnect();
        };
    }, [
        container,
        options,
        enabled,
        isServer
    ]);
};


/***/ }),

/***/ 32239:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ useIsCrawler; },
/* harmony export */   "j": function() { return /* binding */ CrawlerProvider; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27378);


var CrawlerContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)(undefined);
var useIsCrawler = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(CrawlerContext);
};
var CrawlerProvider = function(param) {
    var isCrawler = param.isCrawler, children = param.children;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(isCrawler), isCrawlerState = ref[0];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CrawlerContext.Provider, {
        value: isCrawlerState,
        children: children
    });
};


/***/ }),

/***/ 64724:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ useIsServer; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79758);


var useIsServer = function() {
    // A ref is used as it will not trigger a rerender,
    // so the value will always be consistent
    var isServerRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(_utils_constants__WEBPACK_IMPORTED_MODULE_1__/* .isServer */ .sk);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        // Updates on the client after hydration
        isServerRef.current = false;
    }, []);
    return isServerRef.current;
};


/***/ }),

/***/ 13022:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ useLinkResolver; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var utils_urls__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90901);
/* harmony import */ var _useSiteConfig__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20368);



var dereferenceUrlObj = function(localeKey, language, obj) {
    return (obj === null || obj === void 0 ? void 0 : obj[localeKey]) || (obj === null || obj === void 0 ? void 0 : obj[language]) || (obj === null || obj === void 0 ? void 0 : obj.en_GB) || (obj === null || obj === void 0 ? void 0 : obj.en_US) || (obj === null || obj === void 0 ? void 0 : obj.en);
};
var _getLink = function(parent, localeKey, language) {
    return !!parent ? dereferenceUrlObj(localeKey, language, parent === null || parent === void 0 ? void 0 : parent.category) || (parent === null || parent === void 0 ? void 0 : parent.article) || (parent === null || parent === void 0 ? void 0 : parent.marketing) || (parent === null || parent === void 0 ? void 0 : parent.support) || (parent === null || parent === void 0 ? void 0 : parent.product) || (parent === null || parent === void 0 ? void 0 : parent.core) || (parent === null || parent === void 0 ? void 0 : parent.absolute) || "" : "";
};
var useLinkResolver = function() {
    var ref = (0,_useSiteConfig__WEBPACK_IMPORTED_MODULE_2__/* .useSiteConfig */ .N)(), locale = ref.locale, language = ref.language, localizeUrlPath = ref.localizeUrlPath;
    var getLink = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(obj) {
        var localeKey = locale.replace("-", "_");
        return obj ? "linkConfig" in obj && _getLink(obj === null || obj === void 0 ? void 0 : obj.linkConfig, localeKey, language) || _getLink(obj, localeKey, language) : "";
    }, [
        language,
        locale
    ]);
    var getLocalizedLink = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(obj, localizedAbsolute) {
        var link = obj && "href" in obj ? obj.href : getLink(obj);
        if (!link) {
            return "/";
        }
        if ((0,utils_urls__WEBPACK_IMPORTED_MODULE_1__/* .isAbsoluteUrl */ .sD)(link)) return link;
        return "".concat(localizeUrlPath(link, localizedAbsolute)).concat((obj === null || obj === void 0 ? void 0 : obj.query) || "");
    }, [
        getLink,
        localizeUrlPath
    ]);
    return {
        getLink: getLink,
        getLocalizedLink: getLocalizedLink
    };
};


/***/ }),

/***/ 57998:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "b": function() { return /* binding */ useLiveChat; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(85034);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(70169);
// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(24246);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ./hooks/useSiteConfig.ts
var useSiteConfig = __webpack_require__(20368);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(23842);
// EXTERNAL MODULE: ../node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(59312);
// EXTERNAL MODULE: ./utils/constants.ts
var constants = __webpack_require__(79758);
// EXTERNAL MODULE: ./utils/dateCalculations.ts
var dateCalculations = __webpack_require__(35525);
// EXTERNAL MODULE: ./hooks/useTranslations.tsx
var useTranslations = __webpack_require__(77480);
;// CONCATENATED MODULE: ./hooks/useLiveChat/useFreshChat.tsx







var addPreChat = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(t, token, host, mainScript) {
        var scriptTags, preChat;
        return (0,tslib_es6.__generator)(this, function(_state) {
            if (constants/* isServer */.sk || !token || !host || !mainScript) return [
                2,
                null
            ];
            scriptTags = Array.from(document.getElementsByTagName("script"));
            if (scriptTags.some(function(scriptTag) {
                return scriptTag.id === "preFreshChat";
            })) return [
                2
            ];
            preChat = document.createElement("script");
            preChat.src = "/assets/preFreshChat.js";
            preChat.defer = true;
            preChat.async = false;
            preChat.id = "preFreshChat";
            window.fcSettings = {
                token: token,
                host: host,
                config: {
                    cssNames: {
                        widget: "custom_fc_frame",
                        expanded: "custom_fc_expanded"
                    },
                    headerProperty: {
                        hideChatButton: true
                    }
                },
                onInit: function() {
                    var ref;
                    (ref = window.fcPreChatform) === null || ref === void 0 ? void 0 : ref.fcWidgetInit({
                        mainbgColor: "#000000",
                        maintxColor: "#ffffff",
                        heading: t("freshChatHeading"),
                        textBanner: t("freshChatTextBanner"),
                        InfoPageLabel: t("freshChatInfoPageLabel"),
                        InfoPageID: "PRIVACY_POLICY",
                        SubmitLabel: t("startChat"),
                        fields: {
                            field1: {
                                type: "name",
                                label: "Name",
                                fieldId: "name",
                                required: "yes",
                                error: t("validName")
                            },
                            field2: {
                                type: "email",
                                label: "Email",
                                fieldId: "email",
                                required: "yes",
                                error: t("validEmail")
                            }
                        },
                        InfoPageURI: "/de/en/privacy-policy/PRIVACY_POLICY.html"
                    });
                }
            };
            preChat.onload = function() {
                var freshChatScript = document.createElement("script");
                freshChatScript.src = mainScript;
                freshChatScript.defer = true;
                freshChatScript.async = false;
                document.body.appendChild(freshChatScript);
            };
            document.body.appendChild(preChat);
            return [
                2
            ];
        });
    });
    return function addPreChat(t, token, host, mainScript) {
        return _ref.apply(this, arguments);
    };
}();
var useFreshChat = function() {
    var t = (0,useTranslations/* useTranslate */.qM)();
    var ref = (0,useSiteConfig/* useSiteConfig */.N)(), liveChat = ref.liveChat, _env = ref.env, freshChatHost = _env.freshChatHost, freshChatToken = _env.freshChatToken;
    var isAvailableForRegion = Boolean(freshChatHost && freshChatToken);
    var liveChatIsOpen = (0,dateCalculations/* isOpenNow */.H1)(liveChat === null || liveChat === void 0 ? void 0 : liveChat.openingHours);
    var openLiveChatWindow = react.useCallback(function() {
        var ref, ref1;
        if (!isAvailableForRegion) return;
        (ref = window.fcWidget) === null || ref === void 0 ? void 0 : (ref1 = ref.open) === null || ref1 === void 0 ? void 0 : ref1.call(ref);
    }, [
        isAvailableForRegion
    ]);
    react.useEffect(function() {
        addPreChat(t, freshChatToken, freshChatHost, liveChat === null || liveChat === void 0 ? void 0 : liveChat.script);
    }, [
        freshChatHost,
        freshChatToken,
        liveChat === null || liveChat === void 0 ? void 0 : liveChat.script,
        t
    ]);
    return {
        openLiveChatWindow: openLiveChatWindow,
        liveChatEnabled: isAvailableForRegion && liveChatIsOpen
    };
};

// EXTERNAL MODULE: ../node_modules/next/script.js
var script = __webpack_require__(43218);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
;// CONCATENATED MODULE: ./hooks/useLiveChat/useRadialChat.tsx




var LiveChatToggleWrapper = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "livechat-online",
        style: {
            display: "none"
        },
        children: children
    });
};
var useRadialLiveChat = function() {
    var ref = (0,useSiteConfig/* useSiteConfig */.N)(), liveChat = ref.liveChat, localizeUrlPath = ref.localizeUrlPath;
    var ref1;
    var liveChatScript = (ref1 = liveChat === null || liveChat === void 0 ? void 0 : liveChat.script) !== null && ref1 !== void 0 ? ref1 : "";
    var ref2;
    var liveChatCode = (ref2 = liveChat === null || liveChat === void 0 ? void 0 : liveChat.code) !== null && ref2 !== void 0 ? ref2 : "";
    var liveChatEnabled = !!liveChatScript && !!liveChatCode;
    var LiveChatScript = function(param) {
        var defer = param.defer;
        if (!liveChatEnabled) return null;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                    type: "text/javascript",
                    src: "https://ajax.googleapis.com/ajax/libs/jquery/1.11.3/jquery.min.js"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                    type: "text/javascript",
                    src: "/assets/chat.js"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                    type: "text/javascript",
                    src: liveChatScript
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                    type: "text/javascript",
                    src: "/assets/live-chat.js",
                    defer: defer
                })
            ]
        });
    };
    var openLiveChatWindow = function() {
        // calculate screen position in order to open live chat window in center of browser
        var browserW = window.outerWidth;
        var browserH = window.outerHeight;
        var browserX = window.screenLeft;
        var browserY = window.screenTop;
        var chatW = 500;
        var chatH = 700;
        var chatX = browserX + browserW / 2 - chatW / 2;
        var chatY = browserY + browserH / 2 - chatH / 2;
        window.open(localizeUrlPath("/live-chat"), "chat-window", "menubar=0,resizable=1,width=".concat(chatW, ",height=").concat(chatH, ",left=").concat(chatX, ",top=").concat(chatY));
    };
    return {
        liveChatCode: liveChatCode,
        liveChatEnabled: liveChatEnabled,
        LiveChatScript: LiveChatScript,
        LiveChatToggleWrapper: LiveChatToggleWrapper,
        openLiveChatWindow: openLiveChatWindow,
        renderInMainNav: !!(liveChat === null || liveChat === void 0 ? void 0 : liveChat.renderInMainNav)
    };
};

;// CONCATENATED MODULE: ./hooks/useLiveChat/useAdaChat.tsx




var useAdaChat_LiveChatToggleWrapper = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "livechat-online",
        children: children
    });
};
var useAdaLiveChat = function() {
    var liveChat = (0,useSiteConfig/* useSiteConfig */.N)().liveChat;
    var ref;
    var liveChatScript = (ref = liveChat === null || liveChat === void 0 ? void 0 : liveChat.script) !== null && ref !== void 0 ? ref : "";
    var ref1;
    var liveChatCode = (ref1 = liveChat === null || liveChat === void 0 ? void 0 : liveChat.code) !== null && ref1 !== void 0 ? ref1 : "";
    var liveChatEnabled = !!liveChatScript && !!liveChatCode;
    var LiveChatScript = function(param) {
        var defer = param.defer;
        if (!liveChatEnabled) return null;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                id: "__ada",
                type: "text/javascript",
                "data-handle": liveChatCode,
                src: liveChatScript,
                defer: defer
            })
        });
    };
    var openLiveChatWindow = react.useCallback(function() {
        window.adaEmbed.toggle();
    }, []);
    return {
        liveChatCode: liveChatCode,
        liveChatEnabled: liveChatEnabled,
        LiveChatScript: LiveChatScript,
        LiveChatToggleWrapper: useAdaChat_LiveChatToggleWrapper,
        openLiveChatWindow: openLiveChatWindow,
        renderInMainNav: !!(liveChat === null || liveChat === void 0 ? void 0 : liveChat.renderInMainNav)
    };
};

;// CONCATENATED MODULE: ./hooks/useLiveChat/index.tsx








var useLiveChat = function() {
    var liveChat = (0,useSiteConfig/* useSiteConfig */.N)().liveChat;
    var provider = liveChat === null || liveChat === void 0 ? void 0 : liveChat.provider;
    var radialBag = useRadialLiveChat();
    var freshChatBag = useFreshChat();
    var adaChatBag = useAdaLiveChat();
    return react.useMemo(function() {
        switch(provider){
            case "ada":
                return adaChatBag;
            case "freshChat":
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    renderInMainNav: !!(liveChat === null || liveChat === void 0 ? void 0 : liveChat.renderInMainNav)
                }, freshChatBag), {
                    LiveChatScript: function() {
                        return null;
                    },
                    liveChatCode: "",
                    LiveChatToggleWrapper: function(param) {
                        var children = param.children;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: children
                        });
                    }
                });
            case "radial":
                return radialBag;
            default:
                return {
                    renderInMainNav: false,
                    liveChatEnabled: false,
                    openLiveChatWindow: function() {
                        return null;
                    },
                    LiveChatScript: function() {
                        return null;
                    },
                    liveChatCode: "",
                    LiveChatToggleWrapper: function(param) {
                        var children = param.children;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: children
                        });
                    }
                };
        }
    }, [
        provider,
        adaChatBag,
        liveChat === null || liveChat === void 0 ? void 0 : liveChat.renderInMainNav,
        freshChatBag,
        radialBag, 
    ]);
};


/***/ }),

/***/ 60248:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "TH": function() { return /* binding */ useLocation; },
/* harmony export */   "ri": function() { return /* binding */ LocationContextProvider; }
/* harmony export */ });
/* unused harmony export LocationContext */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(85034);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70169);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5341);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27378);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65218);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var ui_components_Modal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51377);
/* harmony import */ var hooks_useSiteConfig__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(20368);








var LocationSelector = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return __webpack_require__.e(/* import() */ 9850).then(__webpack_require__.bind(__webpack_require__, 89850));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(89850)
            ];
        }
    },
    ssr: true
});
var LocationContext = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createContext({});
var useLocation = function() {
    return react__WEBPACK_IMPORTED_MODULE_1__.useContext(LocationContext);
};
var LocationContextProvider = function(param) {
    var children = param.children;
    var ref = (0,hooks_useSiteConfig__WEBPACK_IMPORTED_MODULE_4__/* .useSiteConfig */ .N)(), countryCode = ref.countryCode, countryName = ref.countryName;
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_1__.useState({}), 2), location = ref1[0], setLocation = ref1[1];
    var localeUrlsRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), localeUrlsState = ref2[0], setLocaleUrlsState = ref2[1];
    react__WEBPACK_IMPORTED_MODULE_1__.useEffect(function() {
        fetch("/api/getUserLocation").then(function(res) {
            return res.json();
        }).then(function(data) {
            var ref;
            var ref1;
            // in local development, the location data is stored in the "data" property,
            // but in deployed environments, fastly defers to a different endpoint
            // which returns location data in the "data.location" property
            //
            // the following just checks both places for the value
            var userCountry = (ref1 = (ref = data.location) === null || ref === void 0 ? void 0 : ref.userCountry) !== null && ref1 !== void 0 ? ref1 : data.userCountry;
            setLocation({
                userCountry: userCountry,
                siteCountry: {
                    id: countryCode,
                    name: countryName
                }
            });
        });
    }, [
        countryCode,
        countryName
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(LocationContext.Provider, {
        value: {
            location: location,
            setLocation: setLocation,
            localeUrlsRef: localeUrlsRef,
            localeUrlsState: localeUrlsState,
            setLocaleUrlsState: setLocaleUrlsState
        },
        children: [
            children,
            (location === null || location === void 0 ? void 0 : location.selecting) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ui_components_Modal__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                variant: "dark",
                onClickOutside: function() {
                    return setLocation((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, location), {
                        selecting: false
                    }));
                },
                className: "max-w-md w-full min-h-screen",
                dataTestId: "location-selector",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LocationSelector, {})
            }) : // Created to render LocationSelector in the DOM for SEO purposes
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LocationSelector, {
                isHidden: true
            })
        ]
    });
};


/***/ }),

/***/ 4402:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ useLoginAndRegister; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(23842);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(85034);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(70169);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(5341);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(59312);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86677);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _generated_graphql__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37678);
/* harmony import */ var gql_exchanges_auth_cookie__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62900);
/* harmony import */ var utils_analytics__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(83168);
/* harmony import */ var utils_authEventEmitter__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(54225);
/* harmony import */ var hooks_usePageEventsContext__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(43308);
/* harmony import */ var _useAuth__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(72507);













var useLoginAndRegister = function() {
    var auth = (0,_useAuth__WEBPACK_IMPORTED_MODULE_7__/* .useAuth */ .aC)();
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_generated_graphql__WEBPACK_IMPORTED_MODULE_2__/* .useRegisterMutation */ .l42)(), 2), registerResult = ref[0], registerHandler = ref[1];
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_generated_graphql__WEBPACK_IMPORTED_MODULE_2__/* .useLoginWithPhoneMutation */ .rYM)(), 2), loginWithPhoneAndPasswordResult = ref1[0], loginWithPhoneAndPasswordHandler = ref1[1];
    var ref2 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_generated_graphql__WEBPACK_IMPORTED_MODULE_2__/* .useLoginWithEmailAndPasswordMutation */ .pJ3)(), 2), loginWithEmailAndPasswordResult = ref2[0], loginWithEmailAndPasswordHandler = ref2[1];
    var ref3 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_generated_graphql__WEBPACK_IMPORTED_MODULE_2__/* .useVerifyLoginWithOtpMutation */ ._IF)(), 2), verifyLoginWithOTPResult = ref3[0], verifyLoginWithOTPHandler = ref3[1];
    var loginWithOTP = (0,_generated_graphql__WEBPACK_IMPORTED_MODULE_2__/* .useLoginWithOtpMutation */ .$Bw)();
    var resendOTP = (0,_generated_graphql__WEBPACK_IMPORTED_MODULE_2__/* .useResendOtpMutation */ .mFF)();
    var pageviewEventHasFired = (0,hooks_usePageEventsContext__WEBPACK_IMPORTED_MODULE_6__/* .usePageEventsContext */ .qN)().pageviewEventHasFired;
    var handleAuthSideEffects = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(function(param) {
        var payload = param.payload, email = param.email;
        (0,gql_exchanges_auth_cookie__WEBPACK_IMPORTED_MODULE_3__/* .storeAuthData */ ._J)({
            payload: payload,
            country: (next_router__WEBPACK_IMPORTED_MODULE_1___default().query.country)
        });
        utils_authEventEmitter__WEBPACK_IMPORTED_MODULE_5__/* .authEventEmitter.emit */ .c.emit("token-changed");
        (0,utils_analytics__WEBPACK_IMPORTED_MODULE_4__/* .event */ .B)(utils_analytics__WEBPACK_IMPORTED_MODULE_4__/* .AnalyticsEvents.ACCOUNT */ ._q.ACCOUNT, {
            domevent: "account login",
            domlabel: email
        });
    }, []);
    var registerCallback = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(function(args) {
            var ref, operationResult, email, _tmp, _tmp1, _tmp2;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            registerHandler(args)
                        ];
                    case 1:
                        operationResult = _state.sent();
                        _tmp = {};
                        _tmp1 = {};
                        _tmp2 = {};
                        if ((ref = operationResult.data) === null || ref === void 0 ? void 0 : ref.register) {
                            email = args === null || args === void 0 ? void 0 : args.email;
                            handleAuthSideEffects((_tmp.payload = operationResult.data.register, _tmp.email = email, _tmp));
                            (0,utils_analytics__WEBPACK_IMPORTED_MODULE_4__/* .event */ .B)(utils_analytics__WEBPACK_IMPORTED_MODULE_4__/* .AnalyticsEvents.ACCOUNT */ ._q.ACCOUNT, (_tmp1.domevent = "account created", _tmp1.domlabel = email, _tmp1));
                        } else {
                            if (pageviewEventHasFired) (0,utils_analytics__WEBPACK_IMPORTED_MODULE_4__/* .event */ .B)(utils_analytics__WEBPACK_IMPORTED_MODULE_4__/* .AnalyticsEvents.GA4_CustomEvent */ ._q.GA4_CustomEvent, (_tmp2.event_name = utils_analytics__WEBPACK_IMPORTED_MODULE_4__/* .AnalyticsEvents.SIGN_UP_FORM_ERROR */ ._q.SIGN_UP_FORM_ERROR, _tmp2.event_params = {
                                method: (0,utils_analytics__WEBPACK_IMPORTED_MODULE_4__/* .getPageType */ .C2)((next_router__WEBPACK_IMPORTED_MODULE_1___default().asPath))
                            }, _tmp2));
                        }
                        return [
                            2,
                            operationResult
                        ];
                }
            });
        });
        return function(args) {
            return _ref.apply(this, arguments);
        };
    }(), [
        registerHandler,
        handleAuthSideEffects,
        pageviewEventHasFired
    ]);
    var loginWithPhoneAndPasswordCallback = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(function(args) {
            var ref, operationResult, _tmp, _tmp1, _tmp2;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _tmp = {};
                        _tmp1 = {};
                        return [
                            4,
                            loginWithPhoneAndPasswordHandler((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_tmp, args), (_tmp1.uniqueShopperId = auth.uniqueShopperId, _tmp1)))
                        ];
                    case 1:
                        operationResult = _state.sent();
                        _tmp2 = {};
                        if ((ref = operationResult.data) === null || ref === void 0 ? void 0 : ref.loginWithPhone) {
                            handleAuthSideEffects((_tmp2.payload = operationResult.data.loginWithPhone, _tmp2));
                        }
                        return [
                            2,
                            operationResult
                        ];
                }
            });
        });
        return function(args) {
            return _ref.apply(this, arguments);
        };
    }(), [
        loginWithPhoneAndPasswordHandler,
        handleAuthSideEffects,
        auth
    ]);
    var loginWithEmailAndPasswordCallback = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(function(args) {
            var ref, operationResult, _tmp, _tmp1, _tmp2;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _tmp = {};
                        _tmp1 = {};
                        return [
                            4,
                            loginWithEmailAndPasswordHandler((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_tmp, args), (_tmp1.uniqueShopperId = auth.uniqueShopperId, _tmp1)))
                        ];
                    case 1:
                        operationResult = _state.sent();
                        _tmp2 = {};
                        if ((ref = operationResult.data) === null || ref === void 0 ? void 0 : ref.login) {
                            handleAuthSideEffects((_tmp2.payload = operationResult.data.login, _tmp2.email = args === null || args === void 0 ? void 0 : args.email, _tmp2));
                        }
                        return [
                            2,
                            operationResult
                        ];
                }
            });
        });
        return function(args) {
            return _ref.apply(this, arguments);
        };
    }(), [
        loginWithEmailAndPasswordHandler,
        handleAuthSideEffects,
        auth
    ]);
    var verifyLoginWithOTPCallback = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(function(args) {
            var ref, ref1, operationResult, _tmp, _tmp1, _tmp2, _otpVerifyToken;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _tmp = {};
                        _tmp1 = {};
                        return [
                            4,
                            verifyLoginWithOTPHandler((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_tmp, args), (_tmp1.uniqueShopperId = auth.uniqueShopperId, _tmp1)))
                        ];
                    case 1:
                        operationResult = _state.sent();
                        _tmp2 = {};
                        if ((ref = operationResult.data) === null || ref === void 0 ? void 0 : ref.verifyLoginWithOTP.authPayload) {
                            handleAuthSideEffects((_tmp2.payload = operationResult.data.verifyLoginWithOTP.authPayload, _tmp2));
                        }
                        window.localStorage.setItem("otpToken", (_otpVerifyToken = (ref1 = operationResult.data) === null || ref1 === void 0 ? void 0 : ref1.verifyLoginWithOTP.otpVerifyToken) !== null && _otpVerifyToken !== void 0 ? _otpVerifyToken : "");
                        return [
                            2,
                            operationResult
                        ];
                }
            });
        });
        return function(args) {
            return _ref.apply(this, arguments);
        };
    }(), [
        verifyLoginWithOTPHandler,
        handleAuthSideEffects,
        auth
    ]);
    var loginAndRegisterPayload = react__WEBPACK_IMPORTED_MODULE_0__.useMemo(function() {
        return {
            register: [
                registerResult,
                registerCallback
            ],
            loginWithEmailAndPassword: [
                loginWithEmailAndPasswordResult,
                loginWithEmailAndPasswordCallback, 
            ],
            loginWithPhoneAndPassword: [
                loginWithPhoneAndPasswordResult,
                loginWithPhoneAndPasswordCallback, 
            ],
            verifyLoginWithOTP: [
                verifyLoginWithOTPResult,
                verifyLoginWithOTPCallback, 
            ],
            loginWithOTP: loginWithOTP,
            resendOTP: resendOTP
        };
    }, [
        registerResult,
        registerCallback,
        loginWithEmailAndPasswordCallback,
        loginWithEmailAndPasswordResult,
        loginWithPhoneAndPasswordCallback,
        loginWithPhoneAndPasswordResult,
        verifyLoginWithOTPResult,
        verifyLoginWithOTPCallback,
        loginWithOTP,
        resendOTP, 
    ]);
    return loginAndRegisterPayload;
};


/***/ }),

/***/ 14425:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "s3": function() { return /* binding */ MainNavProvider; },
  "QH": function() { return /* binding */ useMainNavContext; }
});

// UNUSED EXPORTS: MainNavContext

// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(24246);
// EXTERNAL MODULE: ../node_modules/next/router.js
var next_router = __webpack_require__(86677);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ./utils/locale.ts + 1 modules
var utils_locale = __webpack_require__(79302);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(17599);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(3204);
// EXTERNAL MODULE: ./utils/analytics/index.ts + 6 modules
var analytics = __webpack_require__(83168);
;// CONCATENATED MODULE: ./hooks/useMainNavAnalytics.ts




var useMainNavAnalytics = function() {
    var switchFn = function switchFn(testCase, funnels) {
        if (!testCase) return;
        var callback = funnels[testCase];
        callback ? callback() : funnels.default();
    };
    var ref = (0,react.useState)([]), userClicks = ref[0], setUserClicks = ref[1];
    var buildParentCategory = function(category) {
        return [
            category,
            category
        ];
    }; // [Women, Women] or [Men, Men], etc
    var buildQuickLinkCategory = function(category) {
        return [
            "QuickLink",
            category
        ];
    }; // [QuickLink,Login] or [QuickLink, My Account], etc
    var buildChildrenCategory = function(categories) {
        return [
            "Shop", 
        ].concat((0,_to_consumable_array/* default */.Z)(categories));
    }; // [Shop,Men,Shoes,Basketball]
    var formatClickPath = function(categories) {
        return categories.join(":");
    }; // Women:Women, QuickLink:Login, Kid:Girls:Shoes:Classics etc.
    var resetUserClicks = function() {
        return setUserClicks([]);
    };
    var fireEvent = function(categories, linkClicked) {
        (0,analytics/* event */.B)(analytics/* AnalyticsEvents.HEADER_LINK_CLICKED */._q.HEADER_LINK_CLICKED, {
            parentNavigation: formatClickPath(categories),
            linkClicked: linkClicked
        });
        (0,analytics/* navigationEvent */.f)({
            event_name: analytics/* AnalyticsEvents.NAVIGATION_CLICK */._q.NAVIGATION_CLICK,
            user_action: "header",
            nav_path: formatClickPath(categories).toLowerCase()
        });
        resetUserClicks();
    };
    var appendCategory = function(param) {
        var category = param.category, _link = param.link, link = _link === void 0 ? "" : _link, _kind = param.kind, kind = _kind === void 0 ? null : _kind;
        setUserClicks(function(prev) {
            return (0,_to_consumable_array/* default */.Z)(prev).concat([
                category
            ]);
        });
        return new Promise(function(resolve) {
            var _obj;
            switchFn(kind, (_obj = {
                parent: function() {
                    return fireEvent(buildParentCategory(category), link);
                }
            }, (0,_define_property/* default */.Z)(_obj, "quick-link", function() {
                return fireEvent(buildQuickLinkCategory(category), link);
            }), (0,_define_property/* default */.Z)(_obj, "default", function() {
                return fireEvent(buildChildrenCategory((0,_to_consumable_array/* default */.Z)(userClicks).concat([
                    category
                ])), link);
            }), _obj));
            resolve();
        });
    };
    var removePreviousClick = function() {
        return setUserClicks(function(prev) {
            prev.pop();
            return (0,_to_consumable_array/* default */.Z)(prev);
        });
    };
    return {
        appendCategory: appendCategory,
        removePreviousClick: removePreviousClick
    };
};

// EXTERNAL MODULE: ./hooks/useGroqQuery.ts
var useGroqQuery = __webpack_require__(95967);
// EXTERNAL MODULE: ./hooks/useAvailableNavItemFilter.ts
var useAvailableNavItemFilter = __webpack_require__(6781);
// EXTERNAL MODULE: ./hooks/useSiteConfig.ts
var useSiteConfig = __webpack_require__(20368);
;// CONCATENATED MODULE: ./hooks/useMainNav.tsx








var MainNavContext = /*#__PURE__*/ (0,react.createContext)({});
var MainNavProvider = function(param) {
    var children = param.children, navLinks = param.navLinks, mobileNavLinks = param.mobileNavLinks;
    var router = (0,next_router.useRouter)();
    var locale = (0,useSiteConfig/* useSiteConfig */.N)().locale;
    var ref = (0,react.useState)(false), mobileMenuOpen = ref[0], setMobileMenuOpen = ref[1];
    var ref1 = (0,react.useState)(false), isRegisterOpen = ref1[0], setRegisterOpen = ref1[1];
    var ref2 = (0,react.useState)(false), isLoginOpen = ref2[0], setLoginOpen = ref2[1];
    var ref3 = (0,react.useState)(false), isForgotPasswordFormOpen = ref3[0], setForgotPasswordFormOpen = ref3[1];
    var ref4 = (0,react.useState)(false), showSubMenu = ref4[0], setShowSubMenu = ref4[1];
    var ref5 = (0,react.useState)(""), selectedCategory = ref5[0], setSelectedCategory = ref5[1];
    var ref6 = (0,react.useState)(""), clickedCategory = ref6[0], setClickedCategory = ref6[1];
    var ref7 = (0,react.useState)(""), previousPdp = ref7[0], setPreviousPdp = ref7[1];
    var ref8 = (0,react.useState)(false), isSearchFormOpen = ref8[0], setIsSearchFormOpen = ref8[1];
    var navAnalytics = useMainNavAnalytics();
    var subMenuItems = (0,useAvailableNavItemFilter/* useAvailableNavItemFilter */.C)(navLinks, (0,useGroqQuery/* groqPreviewInput */.i8)(router.query));
    (0,react.useEffect)(function() {
        // close sub menu and clear category on page change
        setShowSubMenu(false);
        setSelectedCategory("");
    // we only want to re-run this if the path changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        router.asPath.split("?")[0]
    ]);
    var handleCategoryClick = function(categoryId) {
        setPreviousPdp("");
        setClickedCategory(categoryId);
    };
    // Remove highlight if mobileMenuOpen
    (0,react.useEffect)(function() {
        if (mobileMenuOpen) setClickedCategory("");
    }, [
        mobileMenuOpen
    ]);
    // Remove highlight if user uses the back/forward button
    (0,react.useEffect)(function() {
        router.beforePopState(function() {
            setClickedCategory("");
            return true;
        });
        return function() {
            router.beforePopState(function() {
                return true;
            });
        };
    }, [
        router
    ]);
    var mainLinks = (0,react.useMemo)(function() {
        var ref;
        return (navLinks === null || navLinks === void 0 ? void 0 : (ref = navLinks.children) === null || ref === void 0 ? void 0 : ref.map(function(value) {
            return value === null || value === void 0 ? void 0 : value.link.href;
        })) || [];
    }, [
        navLinks
    ]);
    (0,react.useEffect)(function() {
        var ref;
        var isCategoryPage = !!((ref = router.query) === null || ref === void 0 ? void 0 : ref.category);
        var isPdp = router.asPath.includes("pd");
        var isHomePage = router.pathname === "/[country]/[language]" && !isCategoryPage;
        var url = (0,utils_locale/* removeLocalePrefix */.g5)(router.asPath, locale);
        if (!isCategoryPage && !isPdp && (!mainLinks.includes(url) || isHomePage)) {
            setPreviousPdp("");
            setClickedCategory("");
            return;
        }
        if (isPdp) {
            if (!previousPdp || router.query.id === previousPdp) {
                setPreviousPdp(router.query.id);
            } else {
                // Remove highlight if user navigates inside PDP to another product
                setPreviousPdp("");
                setClickedCategory("");
            }
        } else {
            setPreviousPdp("");
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        router.query,
        router.asPath
    ]);
    (0,react.useEffect)(function() {
        if (mobileMenuOpen) {
            document.body.classList.add("overflow-y-hidden");
        } else {
            document.body.classList.remove("overflow-y-hidden");
        }
    }, [
        mobileMenuOpen
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MainNavContext.Provider, {
        value: {
            mobileMenuOpen: mobileMenuOpen,
            navAnalytics: navAnalytics,
            selectedCategory: selectedCategory,
            clickedCategory: clickedCategory,
            setMobileMenuOpen: setMobileMenuOpen,
            setSelectedCategory: setSelectedCategory,
            handleCategoryClick: handleCategoryClick,
            setShowSubMenu: setShowSubMenu,
            showSubMenu: showSubMenu,
            subMenuItems: subMenuItems,
            navLinks: navLinks,
            mobileNavLinks: mobileNavLinks,
            setRegisterOpen: setRegisterOpen,
            isRegisterOpen: isRegisterOpen,
            setLoginOpen: setLoginOpen,
            isLoginOpen: isLoginOpen,
            isForgotPasswordFormOpen: isForgotPasswordFormOpen,
            setForgotPasswordFormOpen: setForgotPasswordFormOpen,
            isSearchFormOpen: isSearchFormOpen,
            setIsSearchFormOpen: setIsSearchFormOpen
        },
        children: children
    });
};
var useMainNavContext = function() {
    return (0,react.useContext)(MainNavContext);
};


/***/ }),

/***/ 38859:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "lm": function() { return /* binding */ useMiniCart; },
/* harmony export */   "qP": function() { return /* binding */ MiniCartProvider; }
/* harmony export */ });
/* unused harmony export MiniCartContext */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27378);


var MiniCartContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({
    products: undefined,
    openMiniCart: function() {
        return null;
    },
    closeMiniCart: function() {
        return null;
    },
    isMiniCartVisible: false,
    mixedCartNotAllowed: false,
    tryingToOpenMiniCartFromGWP: false,
    setMixedCartNotAllowed: function() {
        return null;
    }
});
var MiniCartProvider = function(props) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(), products = ref[0], setProducts = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isMiniCartVisible = ref1[0], setIsMiniCartVisible = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), mixedCartNotAllowed = ref2[0], setMixedCartNotAllowed = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), tryingToOpenMiniCartFromGWP = ref3[0], setTryingToOpenMiniCartFromGWP = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), triggeringElement = ref4[0], setTriggeringElement = ref4[1];
    var openMiniCart = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(products, _tryingToOpenMiniCartFromGWP, _triggeringElement) {
        setTriggeringElement(_triggeringElement || null);
        var productsArray = Array.isArray(products) ? products : [
            products
        ];
        setTryingToOpenMiniCartFromGWP(!!_tryingToOpenMiniCartFromGWP);
        if (productsArray.length) {
            setProducts(productsArray);
            setIsMiniCartVisible(true);
        }
    }, []);
    var closeMiniCart = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        // Return focus to the triggering element when closing
        if (triggeringElement && "focus" in triggeringElement) {
            triggeringElement.focus();
        }
        setProducts(undefined);
        setIsMiniCartVisible(false);
        setTriggeringElement(null);
    }, [
        triggeringElement
    ]);
    var providerValue = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return {
            products: products,
            openMiniCart: openMiniCart,
            closeMiniCart: closeMiniCart,
            isMiniCartVisible: isMiniCartVisible,
            mixedCartNotAllowed: mixedCartNotAllowed,
            setMixedCartNotAllowed: setMixedCartNotAllowed,
            tryingToOpenMiniCartFromGWP: tryingToOpenMiniCartFromGWP,
            triggeringElement: triggeringElement
        };
    }, [
        products,
        openMiniCart,
        closeMiniCart,
        isMiniCartVisible,
        mixedCartNotAllowed,
        setMixedCartNotAllowed,
        tryingToOpenMiniCartFromGWP,
        triggeringElement, 
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MiniCartContext.Provider, {
        value: providerValue,
        children: props.children
    });
};
var useMiniCart = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(MiniCartContext);
};


/***/ }),

/***/ 6364:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ useMounted; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);

var useMounted = function() {
    var isMounted = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        isMounted.current = true;
        return function() {
            isMounted.current = false;
        };
    }, []);
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        return isMounted.current;
    }, []);
};


/***/ }),

/***/ 64739:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ useNewsletterSignup; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(85034);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(70169);
/* harmony import */ var nookies__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(15798);
/* harmony import */ var nookies__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(nookies__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27378);
/* harmony import */ var types_analyticTypes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90099);
/* harmony import */ var utils_analytics__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(83168);
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(79758);
/* harmony import */ var _useAuth__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(72507);
/* harmony import */ var _usePreferences__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(89915);
/* harmony import */ var _useSiteConfig__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(20368);










var useNewsletterSignup = function(signUpForm) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isFormVisible = ref[0], setIsFormVisible = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true), isButtonVisible = ref1[0], setIsButtonVisible = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(), signUpLocation = ref2[0], setSignUpLocation = ref2[1];
    var ref3 = (0,_useAuth__WEBPACK_IMPORTED_MODULE_5__/* .useAuth */ .aC)(), isGuest = ref3.guest;
    var ref4 = (0,_usePreferences__WEBPACK_IMPORTED_MODULE_6__/* .usePreferences */ .Gn)(), preferences = ref4.preferences, setPreferences = ref4.setPreferences;
    var ref5 = (0,_useSiteConfig__WEBPACK_IMPORTED_MODULE_7__/* .useSiteConfig */ .N)(), env = ref5.env, newsletter = ref5.newsletter, country = ref5.country;
    var emarsysSignupURL = env.emarsysSignupURL;
    var STICKY_BUTTON_CLOSED = "stickyButtonClosed";
    var UK_SITE = country === utils_constants__WEBPACK_IMPORTED_MODULE_4__/* .SUPPORTED_COUNTRY.GB */ .bM.GB;
    var hasClosedStickyButtonUk = !!(0,nookies__WEBPACK_IMPORTED_MODULE_0__.parseCookies)()[STICKY_BUTTON_CLOSED];
    var hasSeenCookieBanner = !!(0,nookies__WEBPACK_IMPORTED_MODULE_0__.parseCookies)()["OptanonConsent"];
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(hasSeenCookieBanner), cookiesAccepted = ref6[0], setCookiesAccepted = ref6[1];
    var hasSpecifiedPreferedRegion = preferences["prefers-region"];
    var contactSource = (signUpForm === null || signUpForm === void 0 ? void 0 : signUpForm.contactSource.toLowerCase()) || (newsletter === null || newsletter === void 0 ? void 0 : newsletter.contactSources.footer);
    var isEmarsysEnabled = !!signUpForm || !!emarsysSignupURL;
    var identifier = signUpForm === null || signUpForm === void 0 ? void 0 : signUpForm.analyticsIdentifier;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var handler = function() {
            setCookiesAccepted(true);
        };
        if (!hasSeenCookieBanner) {
            // if the cookie banner is showing, wait for it to be dismissed before
            // shoing the newsletter signup button
            window.addEventListener(utils_constants__WEBPACK_IMPORTED_MODULE_4__/* .COOKIE_BANNER_ACKNOWLEDGED_EVENT_NAME */ .p5, handler);
        }
        return function() {
            return window.removeEventListener(utils_constants__WEBPACK_IMPORTED_MODULE_4__/* .COOKIE_BANNER_ACKNOWLEDGED_EVENT_NAME */ .p5, handler);
        };
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    var shouldShowButton = contactSource && isGuest && cookiesAccepted && hasSpecifiedPreferedRegion && isEmarsysEnabled && (UK_SITE ? !hasClosedStickyButtonUk : true);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (shouldShowButton) {
            setIsButtonVisible(true);
        } else {
            setIsButtonVisible(false);
        }
    }, [
        shouldShowButton
    ]);
    var show = function(location) {
        var hideButton = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
        setSignUpLocation(location);
        setIsFormVisible(true);
        setIsButtonVisible(!hideButton);
        (0,utils_analytics__WEBPACK_IMPORTED_MODULE_3__/* .signUpFormAnalyticsEvent */ .Sh)({
            identifier: identifier,
            action: types_analyticTypes__WEBPACK_IMPORTED_MODULE_2__/* .SignUpActions.Opened */ .ew.Opened,
            location: location
        });
    };
    var setContactSourceSeen = function() {
        var seen = new Set(preferences.seen);
        if (contactSource) {
            seen.add(contactSource);
            setPreferences(function(curr) {
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, curr), {
                    seen: Array.from(seen)
                });
            });
        }
    };
    var handleClose = function() {
        var markAsSeen = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
        if (markAsSeen) {
            setContactSourceSeen();
        } else {
            (0,utils_analytics__WEBPACK_IMPORTED_MODULE_3__/* .signUpFormAnalyticsEvent */ .Sh)({
                identifier: identifier,
                action: types_analyticTypes__WEBPACK_IMPORTED_MODULE_2__/* .SignUpActions.Closed */ .ew.Closed,
                location: signUpLocation
            });
        }
        if (UK_SITE) {
            (0,nookies__WEBPACK_IMPORTED_MODULE_0__.setCookie)(null, STICKY_BUTTON_CLOSED, "true", {
                maxAge: utils_constants__WEBPACK_IMPORTED_MODULE_4__/* .MaxAgeExpiration.WEEKLY */ .ho.WEEKLY
            });
        }
        setIsFormVisible(false);
        if (isGuest && !markAsSeen) {
            setIsButtonVisible(true);
        } else {
            setIsButtonVisible(false);
        }
        setSignUpLocation(undefined);
    };
    return {
        isButtonVisible: isButtonVisible,
        isFormVisible: isFormVisible,
        show: show,
        handleClose: handleClose,
        isEmarsysEnabled: isEmarsysEnabled,
        emarsysSignupURL: emarsysSignupURL !== null && emarsysSignupURL !== void 0 ? emarsysSignupURL : null,
        signUpLocation: signUpLocation,
        analyticsIdentifier: identifier
    };
};


/***/ }),

/***/ 97491:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ useOnRouterChangeStart; }
/* harmony export */ });
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(86677);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27378);


var useOnRouterChangeStart = function(cb) {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(router.asPath.split("?")[0]), previousPath = ref[0], setPreviousPath = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var onRouterChangeStart = function(url) {
            var path = url.split("?")[0];
            if (path !== previousPath) {
                setPreviousPath(path);
                cb();
            }
        };
        router.events.on("routeChangeStart", onRouterChangeStart);
        return function() {
            return router.events.off("routeChangeStart", onRouterChangeStart);
        };
    }, [
        previousPath,
        router.events,
        cb
    ]);
};


/***/ }),

/***/ 64108:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ useOrder; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5341);
/* harmony import */ var urql__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25380);
/* harmony import */ var gql_queries_order__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(15350);
/* harmony import */ var _useAuth__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72507);




var useOrder = function(orderNo) {
    var includeProductAnalyticsDetails = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var auth = (0,_useAuth__WEBPACK_IMPORTED_MODULE_1__/* .useAuth */ .aC)();
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,urql__WEBPACK_IMPORTED_MODULE_3__/* .useQuery */ .aM)({
        query: gql_queries_order__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_QUERY */ .wc,
        variables: {
            orderNo: orderNo,
            includeProductAnalyticsDetails: includeProductAnalyticsDetails
        },
        pause: !(auth.customerId && orderNo)
    }), 1), order = ref[0];
    return [
        order
    ];
};


/***/ }),

/***/ 43308:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Uu": function() { return /* binding */ PageEventsProvider; },
/* harmony export */   "qN": function() { return /* binding */ usePageEventsContext; }
/* harmony export */ });
/* unused harmony export PageEventsContext */
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3204);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27378);
/* harmony import */ var _useOnRouterChangeStart__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97491);




var PageEventsContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({});
var PageEventsProvider = function(param) {
    var children = param.children;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), pageviewEventHasFired = ref[0], setPageviewEventHasFired = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), cartEventFired = ref1[0], setCartEventFired = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), firedEvents = ref2[0], setFiredEvents = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), pixleeProductDiscovery = ref3[0], setPixleeProductDiscovery = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), userConsent = ref4[0], setUserConsent = ref4[1];
    (0,_useOnRouterChangeStart__WEBPACK_IMPORTED_MODULE_2__/* .useOnRouterChangeStart */ .k)((0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        // only reset the page view if we actually change page; i.e.,
        // disregard any querystring changes
        setPageviewEventHasFired(false);
        setFiredEvents([]);
    }, [
        setPageviewEventHasFired,
        setFiredEvents
    ]));
    var setEventFired = function(eventName) {
        return setFiredEvents(function(curr) {
            return Array.from(new Set((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(curr).concat([
                eventName
            ])));
        });
    };
    var setEventNotFired = function(eventName) {
        setFiredEvents(function(curr) {
            return curr.filter(function(x) {
                return typeof eventName === "string" ? x !== eventName : !eventName.test(x);
            });
        });
    };
    var eventHasFired = function(eventName) {
        return firedEvents.some(function(x) {
            return x === eventName;
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PageEventsContext.Provider, {
        value: {
            setPageviewEventHasFired: setPageviewEventHasFired,
            pageviewEventHasFired: pageviewEventHasFired,
            setEventFired: setEventFired,
            setEventNotFired: setEventNotFired,
            eventHasFired: eventHasFired,
            pixleeProductDiscovery: pixleeProductDiscovery,
            setPixleeProductDiscovery: setPixleeProductDiscovery,
            setUserConsent: setUserConsent,
            userConsent: userConsent,
            setCartEventFired: setCartEventFired,
            cartEventFired: cartEventFired
        },
        children: children
    });
};
var usePageEventsContext = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(PageEventsContext);
};


/***/ }),

/***/ 89915:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CE": function() { return /* binding */ PreferencesProvider; },
/* harmony export */   "Gn": function() { return /* binding */ usePreferences; }
/* harmony export */ });
/* unused harmony exports getInitialPreferences, PreferencesContext */
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5341);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27378);
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(79758);




var preferencesAndDefaults = {
    "prefers-region": false,
    "last-viewed-product": undefined,
    "last-ga4-item": undefined,
    "last-login-email": undefined,
    seen: []
};
var getInitialPreferences = function() {
    // get the user preferences from local storage
    // only loads preferences predefined in the preferencesAndDefaults type above
    var initial = Object.entries(preferencesAndDefaults).reduce(function(value, param) {
        var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(param, 2), k = _param[0], v = _param[1];
        var serialized = !utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .isServer */ .sk && (window === null || window === void 0 ? void 0 : window.localStorage.getItem(k));
        var propValue = serialized && JSON.parse(serialized) || v;
        value[k] = propValue;
        return value;
    }, {});
    // ensure last viewed products have the required keys
    var lastViewedProduct = initial["last-viewed-product"];
    if (lastViewedProduct && ![
        "id",
        "name",
        "swatch"
    ].every(function(key) {
        return key in lastViewedProduct;
    })) {
        initial["last-viewed-product"] = undefined;
    }
    // ensure last ga4 product has the required keys
    var lastGa4Item = initial["last-ga4-item"];
    if (lastGa4Item && ![
        "id",
        "name",
        "swatch"
    ].every(function(key) {
        return key in lastGa4Item;
    })) {
        initial["last-ga4-item"] = undefined;
    }
    return initial;
};
var PreferencesContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({});
var usePreferences = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(PreferencesContext);
};
var PreferencesProvider = function(param) {
    var children = param.children;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(function() {
        return getInitialPreferences();
    }), preferences = ref[0], setPreferences = ref[1];
    // cleanup storage entries set to undefined
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        Object.entries(preferences).forEach(function(param) {
            var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(param, 2), k = _param[0], v = _param[1];
            if (v === undefined) window.localStorage.removeItem(k);
            else window.localStorage.setItem(k, JSON.stringify(v));
        });
    }, [
        preferences
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PreferencesContext.Provider, {
        value: {
            preferences: preferences,
            setPreferences: setPreferences
        },
        children: children
    });
};


/***/ }),

/***/ 23658:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "o": function() { return /* binding */ usePriceFormatter; }
});

// EXTERNAL MODULE: ./hooks/useSiteConfig.ts
var useSiteConfig = __webpack_require__(20368);
// EXTERNAL MODULE: ./utils/constants.ts
var constants = __webpack_require__(79758);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(85034);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(70169);
;// CONCATENATED MODULE: ./utils/getIntlNumberFormatter.ts


var getIntlNumberFormatter = function(locale, options) {
    try {
        return new Intl.NumberFormat(locale, options);
    } catch (e) {
        if ("constructor" in e && e.constructor === RangeError) {
            return new Intl.NumberFormat(locale, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, options), {
                // Overwrite currencyDisplay if it is not supported
                currencyDisplay: "symbol"
            }));
        } else {
            throw e;
        }
    }
};

;// CONCATENATED MODULE: ./hooks/usePriceFormatter.ts



var usePriceFormatter = function(options) {
    var ref = (0,useSiteConfig/* useSiteConfig */.N)(), locale = ref.locale, currency = ref.currency, countryCode = ref.countryCode;
    var signDisplay = (options === null || options === void 0 ? void 0 : options.showSign) ? "always" : "auto";
    if (countryCode.toUpperCase() === constants/* SUPPORTED_COUNTRY.CA */.bM.CA) {
        return function() {
            var amount = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
            return Math.sign(amount) === -1 ? "".concat(currency.symbol.split(" ").join(" -")).concat(Math.abs(amount).toFixed(currency.decimalsToDisplay)) : "".concat(currency.symbol).concat(amount.toFixed(currency.decimalsToDisplay));
        };
    }
    return function() {
        var amount = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
        var formatterOptions = {
            style: "currency",
            currency: currency.code,
            currencyDisplay: "narrowSymbol",
            signDisplay: signDisplay,
            // Display the configured number of decimals, unless `amount` requires them
            minimumFractionDigits: Number.isInteger(amount) ? currency.decimalsToDisplay : 2
        };
        var formatter = getIntlNumberFormatter(locale, formatterOptions);
        var supCountriesArr = Object.values(constants/* SUPPORTED_COUNTRY */.bM);
        if (supCountriesArr.includes(countryCode.toUpperCase()) && currency.code.toUpperCase() === "EUR") {
            var parts = formatter.formatToParts(amount);
            return "".concat(parts.filter(function(part) {
                return part.type !== "currency";
            }).map(function(part) {
                return part.value;
            }).join(""), " ").concat(currency.symbol);
        }
        return formatter.format(amount);
    };
};


/***/ }),

/***/ 17695:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "zH": function() { return /* binding */ ProductHistoryProvider; },
  "Xd": function() { return /* binding */ useProductHistory; }
});

// UNUSED EXPORTS: PRODUCT_HISTORY_LOCAL_STORAGE_KEY

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(5341);
// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(24246);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ./utils/constants.ts
var constants = __webpack_require__(79758);
// EXTERNAL MODULE: ./utils/object.ts
var object = __webpack_require__(7676);
;// CONCATENATED MODULE: ./utils/productHistory.ts



var PRODUCT_HISTORY_MAX_LENGTH = 8;
var SUPPORTED_COUNTRIES = Object.values(constants/* SUPPORTED_COUNTRY */.bM);
var validateCountry = function(country) {
    // @ts-expect-error
    return SUPPORTED_COUNTRIES.includes(country.toUpperCase());
};
/**
 * Makes sure that the param passed to a function will have the structure that
 * can be processed as a product history entry (i.e. it has type `ProductHistory`).
 */ var validateProductHistory = function(productHistory) {
    var validatedProductHistory = {};
    try {
        if (!(0,object/* isPlainObject */.PO)(productHistory)) {
            throw new Error("productHistory cannot be parsed to a plain object.");
        }
        Object.entries(productHistory).forEach(function(param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), country = _param[0], items = _param[1];
            if (!validateCountry(country) || !Array.isArray(items)) return;
            var validItemsForCountry = items.filter(function(item) {
                return typeof item === "object" && !!(item === null || item === void 0 ? void 0 : item.id) && !!(item === null || item === void 0 ? void 0 : item.color) && typeof item.id === "string" && typeof item.color === "string";
            });
            if (validItemsForCountry.length > 0) {
                validatedProductHistory[country] = validItemsForCountry;
            }
        });
    } finally{
        return validatedProductHistory;
    }
};
/**
 * Takes an `item`, `country` and `productHistory`.
 *
 * Adds the item to the top of the product history (i.e. `productHistory[0]`).
 *
 * If the product history contains more than 8 items, then it will remove the last
 * one.
 *
 * If the product history already contains the item, then the item will be removed
 * (regardless of its previous position) and moved to the top.
 */ var pushItemForCountryToProductHistory = function(item, country, productHistory) {
    country = country.toUpperCase();
    if (!validateCountry(country)) return {};
    var validatedProductHistory = validateProductHistory(productHistory);
    var _country;
    var productHistoryForCountry = (_country = validatedProductHistory[country]) !== null && _country !== void 0 ? _country : [];
    // First, get rid of all all potential entries with the same master id.
    // It does not matter if the color is the same or not. We will replace it anyway
    // and move the new item to the top of the array.
    var newProductHistoryForCountry = productHistoryForCountry.filter(function(x) {
        return x.id !== item.id;
    });
    // If the size has reached the limit, then discard the oldest elements.
    if (newProductHistoryForCountry.length >= PRODUCT_HISTORY_MAX_LENGTH) {
        newProductHistoryForCountry = newProductHistoryForCountry.slice(0, 7);
    }
    newProductHistoryForCountry.unshift(item);
    validatedProductHistory[country] = newProductHistoryForCountry;
    return validatedProductHistory;
};
/**
 * Returns an array of `styleNumber`s for a `country` from the `productHistory`.
 */ var getRecentlyViewedProductsForCountry = function(country, productHistory) {
    var ref;
    if (!validateCountry(country)) return [];
    var ref1;
    return (ref1 = (ref = validateProductHistory(productHistory)[country]) === null || ref === void 0 ? void 0 : ref.map(function(item) {
        return "".concat(item.id, "_").concat(item.color);
    })) !== null && ref1 !== void 0 ? ref1 : [];
};

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(15963);
// EXTERNAL MODULE: ./hooks/useIsServer.ts
var useIsServer = __webpack_require__(64724);
;// CONCATENATED MODULE: ./hooks/useLocalStorage.ts



function useLocalStorage(key, initialValue) {
    var isServer = (0,useIsServer/* useIsServer */.w)();
    var ref = (0,react.useState)(function() {
        if (isServer) return initialValue;
        var value = window.localStorage.getItem(key);
        try {
            return value ? JSON.parse(value) : initialValue;
        } catch (e) {
            return initialValue;
        }
    }), storedValue = ref[0], setStoredValue = ref[1];
    var setValue = (0,react.useCallback)(function(setter) {
        var nextValue = (0,_instanceof/* default */.Z)(setter, Function) ? setter(storedValue) : setter;
        setStoredValue(nextValue);
        window.localStorage.setItem(key, JSON.stringify(nextValue));
    }, [
        key,
        storedValue
    ]);
    return [
        storedValue,
        setValue
    ];
}

// EXTERNAL MODULE: ./hooks/useSiteConfig.ts
var useSiteConfig = __webpack_require__(20368);
;// CONCATENATED MODULE: ./hooks/useProductHistory.tsx






var PRODUCT_HISTORY_LOCAL_STORAGE_KEY =  false ? 0 : "product-history";
var ProductHistoryContext = /*#__PURE__*/ (0,react.createContext)(null);
var ProductHistoryProvider = function(props) {
    var country = (0,useSiteConfig/* useSiteConfig */.N)().country;
    var ref = (0,_sliced_to_array/* default */.Z)(useLocalStorage(PRODUCT_HISTORY_LOCAL_STORAGE_KEY, {}), 2), productHistoryInLocalStorage = ref[0], setProductHistoryInLocalStorage = ref[1];
    var pushItemToProductHistory = (0,react.useCallback)(function(item) {
        var newProductHistory = pushItemForCountryToProductHistory(item, country, productHistoryInLocalStorage);
        setProductHistoryInLocalStorage(newProductHistory);
    }, [
        productHistoryInLocalStorage,
        setProductHistoryInLocalStorage,
        country
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductHistoryContext.Provider, {
        value: {
            get recentlyViewedProducts () {
                return getRecentlyViewedProductsForCountry(country, productHistoryInLocalStorage);
            },
            pushItemToProductHistory: pushItemToProductHistory
        },
        children: props.children
    });
};
var useProductHistory = function() {
    return (0,react.useContext)(ProductHistoryContext);
};


/***/ }),

/***/ 36858:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ usePromotionSelect; }
/* harmony export */ });
/* harmony import */ var utils_analytics__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83168);
/* harmony import */ var utils_ga4Items__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(54093);
/* harmony import */ var _useSiteConfig__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20368);
/* harmony import */ var _usePageEventsContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(43308);
/* harmony import */ var _usePreferences__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(89915);





var usePromotionSelect = function() {
    var currency = (0,_useSiteConfig__WEBPACK_IMPORTED_MODULE_1__/* .useSiteConfig */ .N)().currency;
    var pageviewEventHasFired = (0,_usePageEventsContext__WEBPACK_IMPORTED_MODULE_2__/* .usePageEventsContext */ .qN)().pageviewEventHasFired;
    var preferences = (0,_usePreferences__WEBPACK_IMPORTED_MODULE_3__/* .usePreferences */ .Gn)().preferences;
    var promotionSelectEvent = function(param) {
        var creative_name = param.creative_name, creative_slot = param.creative_slot, promotion_id = param.promotion_id, promotion_name = param.promotion_name, link_url = param.link_url, link_page_type = param.link_page_type, cta_click = param.cta_click, product = param.product, fireEventFromPdp = param.fireEventFromPdp, setPromotion = param.setPromotion;
        if (!pageviewEventHasFired) return;
        var item_name_ep;
        var item_id_ep;
        if (fireEventFromPdp) {
            var lastGa4Item = preferences["last-ga4-item"];
            if (lastGa4Item) {
                item_name_ep = lastGa4Item.name;
                item_id_ep = "".concat(lastGa4Item.id, "_").concat(lastGa4Item.swatch);
            }
        }
        var creativeName = creative_name || undefined;
        var promotionId = promotion_id || undefined;
        var promotionName = promotion_name || undefined;
        var analyticsItem;
        if (product) {
            (0,utils_ga4Items__WEBPACK_IMPORTED_MODULE_4__/* .setGa4ItemInMap */ .HH)(product.id, {
                cname: creativeName,
                cslot: creative_slot,
                pid: promotionId,
                pname: promotionName
            });
            analyticsItem = (0,utils_analytics__WEBPACK_IMPORTED_MODULE_0__/* .transformListProductToAnalyticsItem */ .pD)({
                product: product,
                currency: currency.code,
                quantity: 1,
                categories: {
                    item_category: product.primaryCategoryId
                },
                creativeName: creativeName,
                creativeSlot: creative_slot,
                promotionId: promotionId,
                promotionName: promotionName
            });
        } else if (setPromotion) {
            var promotion = {
                creativeSlot: creative_slot,
                creativeName: creativeName,
                promotionId: promotionId,
                promotionName: promotionName
            };
            window.sessionStorage.setItem("last-clicked-promotion", JSON.stringify(promotion));
        }
        (0,utils_analytics__WEBPACK_IMPORTED_MODULE_0__/* .event */ .B)(utils_analytics__WEBPACK_IMPORTED_MODULE_0__/* .AnalyticsEvents.GA4EC_PromotionSelect */ ._q.GA4EC_PromotionSelect, {
            event_name: utils_analytics__WEBPACK_IMPORTED_MODULE_0__/* .AnalyticsEvents.SELECT_PROMOTION */ ._q.SELECT_PROMOTION,
            ecommerce: {
                creative_name: creativeName,
                creative_slot: creative_slot,
                promotion_id: promotionId,
                promotion_name: promotionName,
                item_id_ep: item_id_ep,
                item_name_ep: item_name_ep,
                link_url: link_url,
                link_page_type: link_page_type,
                cta_click: cta_click ? cta_click.toLowerCase() : undefined,
                items: analyticsItem ? [
                    analyticsItem
                ] : []
            }
        });
    };
    return {
        promotionSelectEvent: promotionSelectEvent
    };
};


/***/ }),

/***/ 32736:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ usePromotionView; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(85034);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(70169);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86677);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var utils_analytics__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83168);
/* harmony import */ var _useIntersectionObserver__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69340);
/* harmony import */ var _usePageEventsContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(43308);
/* harmony import */ var _usePreferences__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(89915);
/* harmony import */ var _useGA4Events__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(89113);
/* harmony import */ var _useSiteConfig__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(20368);










var componentPosition = 0;
var componentPositionGa4 = 0;
var usePromotionView = function(ref, data, ga4Only, gaOnly) {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var preferences = (0,_usePreferences__WEBPACK_IMPORTED_MODULE_5__/* .usePreferences */ .Gn)().preferences;
    var pageviewEventHasFired = (0,_usePageEventsContext__WEBPACK_IMPORTED_MODULE_4__/* .usePageEventsContext */ .qN)().pageviewEventHasFired;
    var currency = (0,_useSiteConfig__WEBPACK_IMPORTED_MODULE_7__/* .useSiteConfig */ .N)().currency;
    var _$ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), gaViewEventFired = _$ref[0], setGaViewEventFired = _$ref[1];
    var _$ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), ga4ViewEventFired = _$ref1[0], setGa4ViewEventFired = _$ref1[1];
    var _$ref2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(function() {
        var thisPos = componentPosition;
        if (ga4Only) return thisPos;
        componentPosition += 1;
        return thisPos;
    }), pos = _$ref2[0];
    var _$ref3 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(function() {
        var thisPos = componentPositionGa4;
        if (gaOnly) return thisPos;
        componentPositionGa4 += 1;
        return thisPos;
    }), posGa4 = _$ref3[0];
    var onRouteChangeDone = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        componentPosition = 0;
        componentPositionGa4 = 0;
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        router.events.on("routeChangeComplete", onRouteChangeDone);
        return function() {
            router.events.off("routeChangeComplete", onRouteChangeDone);
        };
    }, [
        onRouteChangeDone,
        router.events
    ]);
    (0,_useIntersectionObserver__WEBPACK_IMPORTED_MODULE_3__/* .useIntersectionObserver */ .S)(ref, function() {
        if (!ga4Only && !gaViewEventFired && pageviewEventHasFired) {
            var promotionData = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, data), {
                position: pos.toString()
            });
            if (promotionData.items) delete promotionData.items;
            if (promotionData.creative_name) delete promotionData.creative_name;
            if (promotionData.promotion_id) delete promotionData.promotion_id;
            (0,utils_analytics__WEBPACK_IMPORTED_MODULE_2__/* .event */ .B)(utils_analytics__WEBPACK_IMPORTED_MODULE_2__/* .AnalyticsEvents.PROMOTION_VIEW */ ._q.PROMOTION_VIEW, {
                ecommerce: {
                    promoView: {
                        promotions: [
                            promotionData
                        ]
                    }
                }
            });
            setGaViewEventFired(true);
        }
        if (gaOnly || ga4ViewEventFired || !pageviewEventHasFired) return;
        var item_name_ep;
        var item_id_ep;
        var isPdpPage = router.asPath.includes("/pd/");
        if (isPdpPage) {
            var lastGa4Item = preferences["last-ga4-item"];
            if (lastGa4Item) {
                item_name_ep = lastGa4Item.name;
                item_id_ep = "".concat(lastGa4Item.id, "_").concat(lastGa4Item.swatch);
            }
        }
        var creative_name = data.creative_name || data.creative || undefined;
        var promotion_id = data.promotion_id || data.id || undefined;
        var promotion_name = data.name || undefined;
        var creative_slot = posGa4.toString();
        var _cta_links;
        var products = ((_cta_links = data.cta_links) !== null && _cta_links !== void 0 ? _cta_links : []).map(function(link) {
            return (0,_useGA4Events__WEBPACK_IMPORTED_MODULE_6__/* .getProductFromLinkUrl */ .F9)(link);
        }).filter(function(p) {
            return p;
        });
        var analyticsItems = products.map(function(product) {
            return (0,utils_analytics__WEBPACK_IMPORTED_MODULE_2__/* .transformListProductToAnalyticsItem */ .pD)({
                product: product,
                currency: currency.code,
                quantity: 1,
                categories: {
                    item_category: undefined
                },
                creativeName: creative_name,
                creativeSlot: creative_slot,
                promotionId: promotion_id,
                promotionName: promotion_name
            });
        });
        (0,utils_analytics__WEBPACK_IMPORTED_MODULE_2__/* .event */ .B)(utils_analytics__WEBPACK_IMPORTED_MODULE_2__/* .AnalyticsEvents.GA4EC_PromotionView */ ._q.GA4EC_PromotionView, {
            event_name: utils_analytics__WEBPACK_IMPORTED_MODULE_2__/* .AnalyticsEvents.VIEW_PROMOTION */ ._q.VIEW_PROMOTION,
            ecommerce: {
                creative_name: creative_name,
                creative_slot: creative_slot,
                promotion_id: promotion_id,
                promotion_name: promotion_name,
                item_name_ep: item_name_ep,
                item_id_ep: item_id_ep,
                items: analyticsItems
            }
        });
        setGa4ViewEventFired(true);
    }, true, {
        threshold: 0.5
    });
    return {
        promotionTrackerPosition: pos.toString(),
        ga4PromotionTrackerPosition: posGa4.toString()
    };
};


/***/ }),

/***/ 42849:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "M3": function() { return /* binding */ RADIAL_FINGERPRINT_INPUT_ID; },
  "UA": function() { return /* binding */ RadialProvider; },
  "KS": function() { return /* binding */ useRadial; }
});

// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(24246);
// EXTERNAL MODULE: ../node_modules/next/script.js
var script = __webpack_require__(43218);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ./hooks/useSiteConfig.ts
var useSiteConfig = __webpack_require__(20368);
;// CONCATENATED MODULE: ./hooks/useMutationObserver.ts

var defaultInit = {
    attributes: true,
    characterData: true,
    childList: true,
    subtree: true
};
var useMutationObserver = function(ref, callback) {
    var init = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : defaultInit;
    (0,react.useEffect)(function() {
        if (ref.current) {
            var observer = new MutationObserver(callback);
            observer.observe(ref.current, init);
            return function() {
                return observer.disconnect();
            };
        }
    }, [
        callback,
        init
    ]); // eslint-disable-line react-hooks/exhaustive-deps
};

// EXTERNAL MODULE: ./hooks/useIsServer.ts
var useIsServer = __webpack_require__(64724);
;// CONCATENATED MODULE: ./hooks/useRadial.tsx






var RADIAL_FINGERPRINT_INPUT_ID = "RDFUID";
var RadialContext = /*#__PURE__*/ (0,react.createContext)({});
var RadialProvider = function(param) {
    var children = param.children;
    var isServer = (0,useIsServer/* useIsServer */.w)();
    var ref = (0,useSiteConfig/* useSiteConfig */.N)(), env = ref.env, locale = ref.locale;
    /*
   *  radial fingerprint
   */ var ref1 = (0,react.useState)(function() {
        if (isServer) return null;
        return window.sessionStorage.getItem(RADIAL_FINGERPRINT_INPUT_ID) || null;
    }), radialFingerPrint = ref1[0], setRadialFingerPrint = ref1[1];
    var hiddenInputRef = (0,react.useRef)(null);
    useMutationObserver(hiddenInputRef, function(mutationList) {
        return mutationList.forEach(function(mutation) {
            if (mutation.attributeName !== "value") return;
            var _target = mutation.target, id = _target.id, value = _target.value;
            if (id === RADIAL_FINGERPRINT_INPUT_ID) {
                var ref;
                setRadialFingerPrint(value);
                window.sessionStorage.setItem(RADIAL_FINGERPRINT_INPUT_ID, value);
                (ref = hiddenInputRef.current) === null || ref === void 0 ? void 0 : ref.remove();
            }
        });
    });
    /*
   *  radial frontend context
   */ var radialFrontendContext = isServer ? null : {
        HostName: window.location.hostname,
        UserAgent: window.navigator.userAgent,
        Language: locale
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(RadialContext.Provider, {
        value: {
            radialFingerPrint: radialFingerPrint,
            radialFrontendContext: radialFrontendContext
        },
        children: [
            env.radialFingerprint && env.radialStoreId && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                        src: "".concat(env.radialFingerprint, "?clientIdentifier=").concat(env.radialStoreId),
                        strategy: "lazyOnload"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        ref: hiddenInputRef,
                        type: "hidden",
                        id: RADIAL_FINGERPRINT_INPUT_ID,
                        "data-test-id": RADIAL_FINGERPRINT_INPUT_ID,
                        hidden: true
                    })
                ]
            }),
            children
        ]
    });
};
var useRadial = function() {
    return (0,react.useContext)(RadialContext);
};


/***/ }),

/***/ 13765:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ useResizeObserver; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85034);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var utils_debounce__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40572);
/* harmony import */ var hooks_useIsServer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64724);




var useResizeObserver = function(elementRef) {
    var isServer = (0,hooks_useIsServer__WEBPACK_IMPORTED_MODULE_2__/* .useIsServer */ .w)();
    var isMounted = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
    var newRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    var ref = elementRef || newRef;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
        width: 0,
        height: 0
    }), state = ref1[0], setState = ref1[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        isMounted.current = true;
        return function() {
            isMounted.current = false;
        };
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (!ref.current || isServer) return;
        if (isMounted.current) {
            setState({
                width: Math.round(ref.current.offsetWidth),
                height: Math.round(ref.current.offsetHeight)
            });
        }
        var ro = new window.ResizeObserver((0,utils_debounce__WEBPACK_IMPORTED_MODULE_1__/* .debounce */ .D)(function(entries) {
            requestAnimationFrame(function() {
                if (!Array.isArray(entries) || !entries.length) return;
                var _contentRect = entries[0].contentRect, width = _contentRect.width, height = _contentRect.height;
                if (isMounted.current) setState({
                    width: Math.round(width),
                    height: Math.round(height)
                });
            });
        }, 100));
        var element = ref.current;
        ro.observe(element);
        return function() {
            return ro.unobserve(element);
        };
    }, [
        ref.current
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        ref: ref
    }, state);
};


/***/ }),

/***/ 85914:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ useSimpleCart; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5341);
/* harmony import */ var urql__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25380);
/* harmony import */ var gql_queries_cart__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66072);
/* harmony import */ var _useIsServer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64724);




var useSimpleCart = function() {
    var cartQueryOptions = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var ref;
    var isServer = (0,_useIsServer__WEBPACK_IMPORTED_MODULE_1__/* .useIsServer */ .w)();
    var _pause;
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,urql__WEBPACK_IMPORTED_MODULE_3__/* .useQuery */ .aM)({
        query: gql_queries_cart__WEBPACK_IMPORTED_MODULE_0__/* .SIMPLE_CART_QUERY */ .$,
        pause: isServer || ((_pause = cartQueryOptions.pause) !== null && _pause !== void 0 ? _pause : false)
    }), 2), simpleCart = ref1[0], refetch = ref1[1];
    return {
        cart: (ref = simpleCart.data) === null || ref === void 0 ? void 0 : ref.activeCart,
        cartResult: simpleCart,
        refetch: refetch
    };
};


/***/ }),

/***/ 20368:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ SiteConfigContext; },
/* harmony export */   "N": function() { return /* binding */ useSiteConfig; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);

var SiteConfigContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({});
var useSiteConfig = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(SiteConfigContext);
};


/***/ }),

/***/ 8261:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ useSticky; },
/* harmony export */   "Y": function() { return /* binding */ StickyStackContextProvider; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3204);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27378);
/* harmony import */ var twind__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34209);
/* harmony import */ var _useResizeObserver__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13765);





var StickyStackContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({
    stack: [],
    combinedHeightByOrdinal: {
        0: 0
    },
    /* eslint-disable @typescript-eslint/no-empty-function */ addToStack: function() {},
    removeFromStack: function() {}
});
var useSticky = function(ordinal, elementRef) {
    var ref;
    var context = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(StickyStackContext);
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0), nextTop = ref1[0], setNextTop = ref1[1];
    var ref2 = (0,_useResizeObserver__WEBPACK_IMPORTED_MODULE_2__/* .useResizeObserver */ .y)(elementRef), ref3 = ref2.ref, width = ref2.width, height = ref2.height;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (ordinal !== null) {
            context.addToStack(ref3, ordinal);
            return function() {
                return context.removeFromStack(ref3);
            };
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var currIdx = context.stack.findIndex(function(x) {
            return x.ref === ref3;
        });
        var height = 0;
        for(var i = 0; i < currIdx; i += 1){
            var ref, ref1;
            height += (((ref1 = (ref = context.stack[i]) === null || ref === void 0 ? void 0 : ref.ref.current) === null || ref1 === void 0 ? void 0 : ref1.offsetHeight) || 0) - 1;
        }
        setNextTop(height);
    }, [
        context.stack,
        ref3,
        (ref = ref3.current) === null || ref === void 0 ? void 0 : ref.offsetHeight,
        width,
        height
    ]);
    return {
        stickyRef: ref3,
        stickyTop: nextTop,
        stickyWidth: width,
        stickyHeight: height,
        stickyCss: (0,twind__WEBPACK_IMPORTED_MODULE_3__.tw)("sticky top-[".concat(nextTop, "px]")),
        combinedHeightByOrdinal: context.combinedHeightByOrdinal
    };
};
var StickyStackContextProvider = function(param) {
    var children = param.children;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), stack = ref[0], setStack = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        0: 0
    }), combinedHeightByOrdinal = ref1[0], setCombinedHeightByOrdinal = ref1[1];
    var addToStack = function(ref, ordinal) {
        // Items with null ordinals are not added.  However 'undefined' ordinal will
        // be reassigned to whichever order it renders in the DOM.
        var canAdd = ordinal !== null && (ordinal === undefined || typeof ordinal === "number");
        if (canAdd) {
            setStack(function(curr) {
                var newStack = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(curr);
                newStack.push({
                    ref: ref,
                    ordinal: ordinal !== null && ordinal !== void 0 ? ordinal : newStack.length
                });
                newStack.sort(function(a, b) {
                    return a.ordinal - b.ordinal;
                });
                return newStack;
            });
        }
    };
    var removeFromStack = function(ref) {
        return setStack(function(curr) {
            return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(curr).filter(function(x) {
                return x.ref !== ref;
            });
        });
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var combinedHeightByOrdinal = stack.reduce(function(acc, element) {
            var prevOrdinal = element.ordinal - 1;
            if (element === null || element === void 0 ? void 0 : element.ref.current) {
                var ref;
                var elementOffsetHeight = ((ref = element.ref.current) === null || ref === void 0 ? void 0 : ref.offsetHeight) || 0;
                acc[element.ordinal] = prevOrdinal in acc ? acc[prevOrdinal] + elementOffsetHeight : elementOffsetHeight;
            } else {
                var prevOrdinal1 = element.ordinal - 1;
                acc[element.ordinal] = prevOrdinal1 in acc ? acc[prevOrdinal1] : 0;
            }
            return acc;
        }, {});
        setCombinedHeightByOrdinal(combinedHeightByOrdinal);
    }, [
        stack
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StickyStackContext.Provider, {
        value: {
            stack: stack,
            combinedHeightByOrdinal: combinedHeightByOrdinal,
            addToStack: addToStack,
            removeFromStack: removeFromStack
        },
        children: children
    });
};


/***/ }),

/***/ 77313:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cg": function() { return /* binding */ useStickyButton; },
/* harmony export */   "Gs": function() { return /* binding */ StickyButtonProvider; },
/* harmony export */   "Yl": function() { return /* binding */ useStickyButtonIntersection; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(15963);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(5341);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27378);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86677);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var hooks_useIsServer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64724);
/* harmony import */ var groq_pages_ProductDetailsPageTemplate__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(55723);
/* harmony import */ var utils_analytics__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(83168);
/* harmony import */ var _useSiteConfig__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(20368);
/* harmony import */ var _useCookieSettings__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(34457);
/* harmony import */ var _useMainNav__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(14425);
/* harmony import */ var _useGroqQuery__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(95967);












var StickyButtonContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({
    showStickyButton: false,
    showSizesModal: false,
    isIntersected: false,
    buttonRef: null,
    /* eslint-disable @typescript-eslint/no-empty-function */ setButtonRef: function() {},
    setShowStickyButton: function() {},
    setShowSizesModal: function() {},
    setIsIntersected: function() {}
});
var useStickyButtonIntersection = function(ref, options) {
    var isServer = (0,hooks_useIsServer__WEBPACK_IMPORTED_MODULE_3__/* .useIsServer */ .w)();
    var _$ref = useStickyButton(), setIsIntersected = _$ref.setIsIntersected, setButtonRef = _$ref.setButtonRef;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (ref.current && !isServer) {
            var observer = new IntersectionObserver(function(entries) {
                entries.forEach(function(entry) {
                    setIsIntersected(entry.isIntersecting);
                    if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(ref.current, HTMLButtonElement)) {
                        setButtonRef(ref.current);
                    }
                });
            }, options !== null && options !== void 0 ? options : {
                threshold: 0
            });
            if (ref.current) {
                observer.observe(ref.current);
            }
            return function() {
                observer.disconnect();
            };
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        ref
    ]);
};
var StickyButtonProvider = function(param) {
    var children = param.children;
    var ref, ref1;
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), showStickyButton = ref2[0], setShowStickyButton = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), showSizesModal = ref3[0], setShowSizesModal = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isIntersected = ref4[0], setIsIntersected = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), buttonRef = ref5[0], setButtonRef = ref5[1];
    var cookieConsent = (0,_useSiteConfig__WEBPACK_IMPORTED_MODULE_6__/* .useSiteConfig */ .N)().cookieConsent;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var ref6 = (0,_useCookieSettings__WEBPACK_IMPORTED_MODULE_7__/* .useCookieSettings */ .eK)(), showCookieBanner = ref6.showCookieBanner, showCookieSettings = ref6.showCookieSettings, showingCookieBannerOT = ref6.showingCookieBannerOT;
    var mobileMenuOpen = (0,_useMainNav__WEBPACK_IMPORTED_MODULE_8__/* .useMainNavContext */ .QH)().mobileMenuOpen;
    var isProductPage = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return (0,utils_analytics__WEBPACK_IMPORTED_MODULE_5__/* .getPageType */ .C2)(router.pathname) === "pdp";
    }, [
        router.pathname
    ]);
    var ref7 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_useGroqQuery__WEBPACK_IMPORTED_MODULE_9__/* .useGroqQuery */ .Mo)({
        operationName: "StickyAddToCart_PDPTemplate",
        query: groq_pages_ProductDetailsPageTemplate__WEBPACK_IMPORTED_MODULE_4__/* .StickyAddToCart_PDPTemplateQuery */ .MH,
        pause: !isProductPage
    }), 1), stickyAddToCartPDPTemplateContent = ref7[0];
    var stickyBehavior = (stickyAddToCartPDPTemplateContent === null || stickyAddToCartPDPTemplateContent === void 0 ? void 0 : (ref = stickyAddToCartPDPTemplateContent.data) === null || ref === void 0 ? void 0 : (ref1 = ref.content) === null || ref1 === void 0 ? void 0 : ref1.stickyAddToCart) || "always";
    var handleScroll = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        if (!buttonRef) return;
        var addToCartButtonRef = buttonRef.getBoundingClientRect().top + window.scrollY;
        var position = window.scrollY || document.documentElement.scrollTop;
        var shouldShowStickyButton = !isIntersected && position >= addToCartButtonRef;
        setShowStickyButton(shouldShowStickyButton);
    }, [
        buttonRef,
        isIntersected
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var shouldHandleScroll = showingCookieBannerOT && (cookieConsent === null || cookieConsent === void 0 ? void 0 : cookieConsent.provider) === "OneTrust" || showCookieBanner || showCookieSettings || mobileMenuOpen || !isProductPage || stickyBehavior;
        if (shouldHandleScroll) {
            switch(stickyBehavior){
                case "always":
                    setShowStickyButton(!isIntersected);
                    break;
                case "afterScroll":
                    window.addEventListener("scroll", handleScroll);
                    break;
                case "disabled":
                    setShowStickyButton(false);
                    break;
            }
        }
        return function() {
            window.removeEventListener("scroll", handleScroll);
        };
    }, [
        buttonRef,
        cookieConsent === null || cookieConsent === void 0 ? void 0 : cookieConsent.provider,
        handleScroll,
        isIntersected,
        isProductPage,
        mobileMenuOpen,
        showCookieBanner,
        showCookieSettings,
        showingCookieBannerOT,
        stickyBehavior, 
    ]);
    var contextValue = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return {
            showStickyButton: showStickyButton,
            showSizesModal: showSizesModal,
            buttonRef: buttonRef,
            setButtonRef: setButtonRef,
            setShowSizesModal: setShowSizesModal,
            setShowStickyButton: setShowStickyButton,
            setIsIntersected: setIsIntersected,
            isIntersected: isIntersected
        };
    }, [
        showStickyButton,
        showSizesModal,
        isIntersected,
        buttonRef
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StickyButtonContext.Provider, {
        value: contextValue,
        children: children
    });
};
var useStickyButton = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(StickyButtonContext);
};


/***/ }),

/***/ 14476:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ ToastProvider; },
/* harmony export */   "p": function() { return /* binding */ useToast; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85034);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70169);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3204);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27378);
/* harmony import */ var _global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12601);
/* harmony import */ var utils_media__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(39772);







var genRandomId = function() {
    return Math.random().toString(32).substring(2);
};
var Toast = function(param) {
    var value = param.value, onClose = param.onClose;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_2__/* .ToastRoot */ ._lt, {
        open: value.isOpen,
        onOpenChange: function(isOpen) {
            return !isOpen && onClose(value.id);
        },
        duration: value.duration,
        variant: value.variant,
        className: (0,utils_media__WEBPACK_IMPORTED_MODULE_3__/* .getIsMobile */ .W)() ? "!w-full min-w-max" : "",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_2__/* .ToastTitle */ .Miw, {
                children: value.title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_2__/* .ToastIcon */ .IhZ, {
                icon: value.icon
            }),
            value.description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_2__/* .ToastDescription */ .ljp, {
                children: value.description
            })
        ]
    });
};
var OpenToastContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)(function() {
    return null;
});
var ToastProvider = function(param) {
    var children = param.children;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), toasts = ref[0], setToasts = ref[1];
    var openToast = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(params) {
        var id = genRandomId();
        setToasts(function(prev) {
            return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(prev).concat([
                (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    id: id,
                    isOpen: true
                }, params)
            ]);
        });
    }, []);
    var closeToast = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(id) {
        setToasts(function(prev) {
            return prev.map(function(value) {
                return value.id === id ? (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, value), {
                    isOpen: false
                }) : value;
            });
        });
        setTimeout(function() {
            setToasts(function(prev) {
                return prev.filter(function(value) {
                    return value.id !== id;
                });
            });
        }, 200);
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(OpenToastContext.Provider, {
        value: openToast,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_2__/* .ToastProvider */ .VWW, {
            duration: 5000,
            children: [
                children,
                toasts.map(function(value) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Toast, {
                        value: value,
                        onClose: closeToast
                    }, value.id);
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_2__/* .ToastViewport */ ._ih, {
                    position: (0,utils_media__WEBPACK_IMPORTED_MODULE_3__/* .getIsMobile */ .W)() ? "bottom_middle" : "bottom_end"
                })
            ]
        })
    });
};
function useToast() {
    return (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(OpenToastContext);
}


/***/ }),

/***/ 19318:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ useTranslationFieldOrDefault; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var hooks_useTranslations__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77480);
/* harmony import */ var utils_capitalize__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59308);



var useTranslationFieldOrDefault = function() {
    var t = (0,hooks_useTranslations__WEBPACK_IMPORTED_MODULE_1__/* .useTranslate */ .qM)();
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(field, base, variables) {
        var customTranslationKey = "".concat(base).concat((0,utils_capitalize__WEBPACK_IMPORTED_MODULE_2__/* .capitalize */ .k)(field));
        var customTranslation = t(customTranslationKey, variables);
        return customTranslation ? customTranslation : t(base);
    }, [
        t
    ]);
};


/***/ }),

/***/ 77480:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Te": function() { return /* binding */ getInitialTranslations; },
/* harmony export */   "qM": function() { return /* binding */ useTranslate; },
/* harmony export */   "yJ": function() { return /* binding */ TranslationsContext; }
/* harmony export */ });
/* unused harmony export get */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27378);


var get = function(source, key) {
    var path = key.split(".");
    var index = 0;
    while(source && path.length > index){
        source = source[path[index++]];
    }
    return source;
};
var getInitialTranslations = function(i18n) {
    return function t(key, variables, options) {
        var translation = get(i18n, key);
        //translations seems to fail sometimes or not return properly, this may be the race condition that breaks the add to cart.
        if (variables && translation) {
            Object.keys(variables).forEach(function(key) {
                translation = translation.replace(new RegExp("{".concat(key, "}"), "g"), variables[key]);
            });
        }
        if (options === null || options === void 0 ? void 0 : options.supportHTMLTags) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                dangerouslySetInnerHTML: {
                    __html: translation
                }
            });
        }
        return translation;
    };
};
var TranslationsContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({
    t: function() {
        return "";
    }
});
var useTranslate = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(TranslationsContext).t;
};


/***/ }),

/***/ 70750:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "v": function() { return /* binding */ usePincodeValidation; },
  "V": function() { return /* binding */ useValidation; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(23842);
// EXTERNAL MODULE: ../node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(59312);
// EXTERNAL MODULE: ../node_modules/emoji-regex/index.js
var emoji_regex = __webpack_require__(58242);
var emoji_regex_default = /*#__PURE__*/__webpack_require__.n(emoji_regex);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ../node_modules/urql/dist/urql.es.js
var urql_es = __webpack_require__(25380);
// EXTERNAL MODULE: ./sites/jp/fields.ts
var fields = __webpack_require__(3661);
// EXTERNAL MODULE: ./utils/constants.ts
var constants = __webpack_require__(79758);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(19989);
// EXTERNAL MODULE: ../node_modules/@urql/core/dist/urql-core.mjs
var urql_core = __webpack_require__(70463);
;// CONCATENATED MODULE: ./gql/queries/pincode.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query Pincode($pincode: String!) {\n    pincode(pincode: $pincode) {\n      expectedDate\n      city\n      stateCode\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var PINCODE_QUERY = (0,urql_core/* gql */.Ps)(_templateObject());

// EXTERNAL MODULE: ./hooks/useFeature.ts
var useFeature = __webpack_require__(53625);
// EXTERNAL MODULE: ./hooks/useSiteConfig.ts
var useSiteConfig = __webpack_require__(20368);
// EXTERNAL MODULE: ./hooks/useTranslations.tsx
var useTranslations = __webpack_require__(77480);
;// CONCATENATED MODULE: ./hooks/useValidation.ts











var UNSAFE_INPUT_REGEX = /[<>{}]|^\s+$/;
var PASSWORD_UNSAFE_INPUT_REGEX = /[<>]|^\s+$/;
var ADDRESS_UNSAFE_INPUT_REGEX = /[<>{}%]|^\s+$/;
var NUMBERS_ONLY_REGEX = /^[0-9]*$/;
var ALPHANUMERIC_ONLY_REGEX = /^[a-zA-Z0-9 ]+$/;
var US_DATE_FORMAT_REGEX = /^((?:0[1-9])|(?:1[0-2]))\/((?:0[1-9])|(?:[1-2][0-9])|(?:3[0-1]))\/(\d{4})$/;
var GB_DATE_FORMAT_REGEX = /^((?:0[1-9])|(?:[1-2][0-9])|(?:3[0-1]))\/((?:0[1-9])|(?:1[0-2]))\/(\d{4})$/;
// Does not contain only spaces. Contains A..Za-z single space between words.
var ENGLISH_LETTERS_ONLY_REGEX = /^[A-Za-z]+(\s[A-Za-z]+)*$/;
// Does not contain only spaces. Only latin characters including the one with accent on top and German special.
var LATIN_ONLY_REGEX = /^(?!\s+$)[\u0000-~\u0080-ž’”]+$/;
var usePincodeValidation = function() {
    var ref = (0,react.useState)(false), fetching = ref[0], setFetching = ref[1];
    var ref1 = (0,react.useState)(), data = ref1[0], setData = ref1[1];
    // We use "useClient" because useQuery's refetch function returns void.
    // in other words, it fires up our intent to refetch the data, but we dont have any indication when the data arrives.
    // For async validation we need that information to indicate if the network request is finished.
    // validate: async () => await refetch() // when refetch finishes we know our validation result came back, but this cannot be done with void.
    var client = (0,urql_es/* useClient */.m8)();
    var isPincodeEnabled = (0,useFeature/* useFeature */.S)("PINCODE_SERVICEABILITY");
    var callback = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(value) {
            var res, _tmp, _tmp1;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!value || !isPincodeEnabled) return [
                            2
                        ];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            ,
                            3,
                            4
                        ]);
                        setFetching(true);
                        _tmp = {};
                        _tmp1 = {};
                        return [
                            4,
                            client.query(PINCODE_QUERY, (_tmp.pincode = value, _tmp), (_tmp1.requestPolicy = "network-only", _tmp1)).toPromise()
                        ];
                    case 2:
                        res = _state.sent();
                        setData(res.data);
                        return [
                            2,
                            res
                        ];
                    case 3:
                        setFetching(false);
                        return [
                            7
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function(value) {
            return _ref.apply(this, arguments);
        };
    }(), [
        isPincodeEnabled,
        client
    ]);
    return (0,react.useMemo)(function() {
        return [
            {
                fetching: fetching,
                data: data
            },
            callback
        ];
    }, [
        callback,
        fetching,
        data
    ]);
};
var useValidation = function() {
    var ref;
    var t = (0,useTranslations/* useTranslate */.qM)();
    var ref1 = (0,useSiteConfig/* useSiteConfig */.N)(), validation = ref1.validation, countryCode = ref1.countryCode;
    var safeInput = (0,react.useCallback)(function(input) {
        if (UNSAFE_INPUT_REGEX.test(input)) return t("invalidCharacters");
    }, [
        t
    ]);
    var noEmoji = (0,react.useCallback)(function(input) {
        if (emoji_regex_default()().test(input)) return t("invalidCharacters");
    }, [
        t
    ]);
    var addressLine1 = (0,react.useCallback)(function(input) {
        if (ADDRESS_UNSAFE_INPUT_REGEX.test(input)) return t("invalidCharacters");
        if (!new RegExp(validation.address.line1).test(input)) return t("invalidAddress");
    }, [
        t,
        validation.address.line1
    ]);
    var addressLine2 = (0,react.useCallback)(function(input) {
        if (ADDRESS_UNSAFE_INPUT_REGEX.test(input)) return t("invalidCharacters");
        if (!validation.address.line2) return;
        if (!new RegExp(validation.address.line2).test(input)) return t("invalidAddress");
    }, [
        t,
        validation.address.line2
    ]);
    var addressTitle = (0,react.useCallback)(function(input) {
        if (ADDRESS_UNSAFE_INPUT_REGEX.test(input)) return t("invalidCharacters");
        var noEmojiError = noEmoji(input);
        if (noEmojiError) return noEmojiError;
        if (!validation.address.title) return;
        if (!new RegExp(validation.address.title).test(input)) {
            return t("invalidCharacters");
        }
    }, [
        noEmoji,
        t,
        validation.address.title
    ]);
    var email = (0,react.useCallback)(function(input) {
        if (validation.email && !new RegExp(validation.email).test(input)) return t("invalidEmail");
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        t
    ]);
    var name = (0,react.useCallback)(function(input) {
        var ref;
        var safeInputError = safeInput(input);
        if (safeInputError) return safeInputError;
        var noEmojiError = noEmoji(input);
        if (noEmojiError) return noEmojiError;
        if (!((ref = validation.name) === null || ref === void 0 ? void 0 : ref.regex)) return;
        if (!new RegExp(validation.name.regex).test(input)) {
            return t("invalidCharacters");
        }
    }, [
        noEmoji,
        safeInput,
        t,
        validation.name.regex
    ]);
    var companyName = (0,react.useCallback)(function(input) {
        var ref;
        var safeInputError = safeInput(input);
        if (safeInputError) return safeInputError;
        var noEmojiError = noEmoji(input);
        if (noEmojiError) return noEmojiError;
        if (!((ref = validation.name) === null || ref === void 0 ? void 0 : ref.regex)) return;
        if (!new RegExp(validation.name.regex).test(input)) {
            return t("invalidCharacters");
        }
    }, [
        noEmoji,
        safeInput,
        t,
        validation.name.regex
    ]);
    var englishLettersOnly = (0,react.useCallback)(function(input) {
        if (input && !new RegExp(ENGLISH_LETTERS_ONLY_REGEX).test(input)) {
            return t("invalidCharacters");
        }
    }, [
        t
    ]);
    var latinLettersOnly = (0,react.useCallback)(function(input) {
        if (input && !new RegExp(LATIN_ONLY_REGEX).test(input)) {
            return t("invalidNonLatinCharacters") || t("invalidCharacters");
        }
    }, [
        t
    ]);
    var phoneNumber = (0,react.useCallback)(function(input) {
        if (!new RegExp(validation.phone.regex).test(input)) return t("enterValidPhoneNumber");
    }, [
        t,
        validation.phone.regex
    ]);
    var alphanumericOnly = (0,react.useCallback)(function(text) {
        if (!ALPHANUMERIC_ONLY_REGEX.test(text)) return t("inputAlphanumericCharactersWarning") || t("invalidCharacters");
    }, [
        t
    ]);
    var postalCode = (0,react.useCallback)(function(inputPostalCode, inputCountryCode) {
        if (typeof inputCountryCode === "object") return;
        var finalCountryCode = inputCountryCode || countryCode;
        if (!new RegExp(validation.postalCode[finalCountryCode.toUpperCase()]).test(inputPostalCode)) {
            if (inputCountryCode && inputCountryCode in constants/* SUPPORTED_COUNTRY */.bM) {
                var countryKey = inputCountryCode.toLowerCase();
                return t("invalidPostalCode_".concat(countryKey)) || t("invalidPostalCode");
            }
            return t("invalidPostalCode_".concat(countryCode)) || t("invalidPostalCode");
        }
    }, [
        countryCode,
        t,
        validation.postalCode
    ]);
    var dateOfBirth = (0,react.useCallback)(function(input) {
        // TODO: Ideally this would be based on site config to support non-US date formats,
        // but the only place it is currently used (SignUpForm) requires this format.
        switch(countryCode){
            case "gb":
                if (!GB_DATE_FORMAT_REGEX.test(input)) {
                    return t("newsletterPopoverDobInvalid");
                }
                break;
            default:
                if (!US_DATE_FORMAT_REGEX.test(input)) {
                    return t("newsletterPopoverDobInvalid");
                }
                break;
        }
    }, [
        t,
        countryCode
    ]);
    var password = (0,react.useCallback)(function(input) {
        var _passwordUnsafeInputCheck;
        // Apply special password unsafe input check if configured (default: false)
        var usePasswordUnsafeCheck = (_passwordUnsafeInputCheck = validation.passwordUnsafeInputCheck) !== null && _passwordUnsafeInputCheck !== void 0 ? _passwordUnsafeInputCheck : false;
        if (usePasswordUnsafeCheck) {
            if (PASSWORD_UNSAFE_INPUT_REGEX.test(input)) {
                return t("invalidCharacters");
            }
        } else {
            // Otherwise apply the standard safe input check
            var safeInputError = safeInput(input);
            if (safeInputError) return safeInputError;
        }
        if (validation.password && !new RegExp(validation.password).test(input)) return t("passwordWarning");
    }, [
        safeInput,
        t,
        validation
    ]);
    var confirmPassword = (0,react.useCallback)(function(input, otherPasswordInput) {
        if (typeof otherPasswordInput === "object") return;
        var passwordError = password(input);
        if (passwordError) return passwordError;
        if (input !== otherPasswordInput) return t("passwordsDontMatch");
    }, [
        password,
        t
    ]);
    var numbersOnly = (0,react.useCallback)(function(text, number) {
        if (!NUMBERS_ONLY_REGEX.test(text)) switch(number){
            case "4":
                return t("cvvNumberOnlyAmbassador", {
                    count: number
                });
            case "19":
                return t("numberCardAmbassador", {
                    count: number
                });
            default:
                return "Input may only contain numbers.";
        }
    }, [
        t
    ]);
    var orderNumberValidation = (0,react.useCallback)(function(input) {
        var safeInputError = safeInput(input);
        if (safeInputError) return safeInputError;
        var noEmojiError = noEmoji(input);
        if (noEmojiError) return noEmojiError;
        if (!validation.orderNo) return;
        if (!new RegExp(validation.orderNo).test(input)) {
            return t("orderNoValidationError");
        }
    }, [
        noEmoji,
        safeInput,
        t,
        validation.orderNo
    ]);
    var holderName = (0,react.useCallback)(function(input) {
        var ref;
        if (!((ref = validation.holderName) === null || ref === void 0 ? void 0 : ref.regex)) return;
        if (!new RegExp(validation.holderName.regex).test(input)) return t("invalidCharacters");
    }, [
        t,
        (ref = validation.holderName) === null || ref === void 0 ? void 0 : ref.regex
    ]);
    var holderNameExcludeCharacters = (0,react.useCallback)(function(input) {
        var notAllowedCharacters = "[" + fields/* HOLDER_NAME_NOT_ALLOWED_CHARACTERS */.F + "]+";
        if (input && new RegExp(notAllowedCharacters).test(input)) {
            return t("requiredFieldHolderNameAccount");
        }
    }, [
        t
    ]);
    var dynamicValidation = (0,react.useCallback)(function(input, form, v) {
        var matches = v.validation.match(RegExp("(?<condition>requiredIf)\\.\\[(?<subject>.+)\\]\\.(?<op>is)\\.(?<value>.+)"));
        if (matches) {
            var ref, ref1, ref2, ref3;
            var condition = (ref = matches.groups) === null || ref === void 0 ? void 0 : ref.condition;
            var subject = (ref1 = matches.groups) === null || ref1 === void 0 ? void 0 : ref1.subject;
            var op = (ref2 = matches.groups) === null || ref2 === void 0 ? void 0 : ref2.op;
            var value = (ref3 = matches.groups) === null || ref3 === void 0 ? void 0 : ref3.value;
            // Modify this block as needed to support more dynamic validation
            if (subject && op && value) {
                var targetValue = form.getValues(subject);
                if (condition === "requiredIf" && op === "is") {
                    if (typeof targetValue === "string" && (targetValue === null || targetValue === void 0 ? void 0 : targetValue.toLowerCase()) === value.toLowerCase()) {
                        if (!input) {
                            return v.error ? t(v.error) : t("requiredField");
                        }
                    }
                }
            }
        }
    }, [
        t
    ]);
    return [
        {
            addressLine1: addressLine1,
            addressLine2: addressLine2,
            addressTitle: addressTitle,
            alphanumericOnly: alphanumericOnly,
            confirmPassword: confirmPassword,
            dateOfBirth: dateOfBirth,
            email: email,
            englishLettersOnly: englishLettersOnly,
            holderName: holderName,
            holderNameExcludeCharacters: holderNameExcludeCharacters,
            latinLettersOnly: latinLettersOnly,
            name: name,
            noEmoji: noEmoji,
            numbersOnly: numbersOnly,
            orderNumberValidation: orderNumberValidation,
            password: password,
            phoneNumber: phoneNumber,
            postalCode: postalCode,
            safeInput: safeInput,
            companyName: companyName
        },
        dynamicValidation, 
    ];
};


/***/ }),

/***/ 45746:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ useWindowSize; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var _global_ecom_nitro_uds_hooks__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68138);
// source -> https://github.com/uidotdev/usehooks/blob/dfa6623fcc2dcad3b466def4e0495b3f38af962b/index.js#L1344
// docs -> https://usehooks.com/usewindowsize


function useWindowSize() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
        width: null,
        height: null
    }), size = ref[0], setSize = ref[1];
    (0,_global_ecom_nitro_uds_hooks__WEBPACK_IMPORTED_MODULE_1__/* .useIsomorphicLayoutEffect */ .LI)(function() {
        var handleResize = function() {
            setSize({
                width: window.innerWidth,
                height: window.innerHeight
            });
        };
        handleResize();
        window.addEventListener("resize", handleResize);
        return function() {
            window.removeEventListener("resize", handleResize);
        };
    }, []);
    return size;
} // usage: `const { width, height } = useWindowSize();`


/***/ }),

/***/ 96529:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _app; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(23842);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(85034);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(70169);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(5341);
// EXTERNAL MODULE: ../node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(59312);
// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(24246);
// EXTERNAL MODULE: ../node_modules/@global-ecom/nitro-uds/dist/fonts/index.css
var fonts = __webpack_require__(1859);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ../node_modules/next/app.js
var app = __webpack_require__(31388);
// EXTERNAL MODULE: ../node_modules/next/head.js
var head = __webpack_require__(88038);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ../node_modules/next/dynamic.js
var dynamic = __webpack_require__(65218);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ../node_modules/next/script.js
var script = __webpack_require__(43218);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
// EXTERNAL MODULE: ../node_modules/next/router.js
var next_router = __webpack_require__(86677);
var router_default = /*#__PURE__*/__webpack_require__.n(next_router);
// EXTERNAL MODULE: ../node_modules/twind/observe/observe.js
var observe = __webpack_require__(1281);
;// CONCATENATED MODULE: ../node_modules/@twind/next/shim/app/app.js
// shim/app.ts


function withTwindApp(configOrBase, BaseApp) {
  if (typeof configOrBase == "function") {
    BaseApp = configOrBase;
    configOrBase = {};
  }
  if (typeof document !== "undefined") {
    (0,observe/* setup */.cY)(configOrBase);
    (0,observe/* observe */.N7)(document.documentElement);
  }
  return BaseApp || app["default"];
}

//# sourceMappingURL=app.js.map

// EXTERNAL MODULE: ../node_modules/@global-ecom/nitro-uds/dist/elements/esm/index.js + 103 modules
var esm = __webpack_require__(12601);
// EXTERNAL MODULE: ./hooks/useIsCrawler.tsx
var useIsCrawler = __webpack_require__(32239);
// EXTERNAL MODULE: ./hooks/useHeading.tsx
var useHeading = __webpack_require__(99592);
// EXTERNAL MODULE: ./hooks/useCheckoutFormData.tsx
var useCheckoutFormData = __webpack_require__(54973);
;// CONCATENATED MODULE: ./config/featureFlags.json
var featureFlags_namespaceObject = JSON.parse('{"PullRequestEnvironment":{"en-AU":{"QA_TEST_FLAG":true,"CROWNPEAK_ENABLED":false},"en-CA":{"QA_TEST_FLAG":true,"CROWNPEAK_ENABLED":false},"en-GB":{"QA_TEST_FLAG":true,"CROWNPEAK_ENABLED":false},"en-IN":{"QA_TEST_FLAG":true,"CROWNPEAK_ENABLED":false},"en-US":{"QA_TEST_FLAG":true,"CROWNPEAK_ENABLED":false},"es-US":{"QA_TEST_FLAG":true,"CROWNPEAK_ENABLED":false},"fr-CA":{"QA_TEST_FLAG":true,"CROWNPEAK_ENABLED":false},"ja-JP":{"QA_TEST_FLAG":true,"CROWNPEAK_ENABLED":false},"en-BG":{"QA_TEST_FLAG":true,"CROWNPEAK_ENABLED":false},"en-LT":{"QA_TEST_FLAG":true,"CROWNPEAK_ENABLED":false}},"pre-development":{"en-AU":{"QA_TEST_FLAG":true,"CROWNPEAK_ENABLED":false},"en-CA":{"QA_TEST_FLAG":true,"CROWNPEAK_ENABLED":false},"en-GB":{"QA_TEST_FLAG":true,"CROWNPEAK_ENABLED":false},"en-IN":{"QA_TEST_FLAG":true,"CROWNPEAK_ENABLED":false},"en-US":{"QA_TEST_FLAG":true,"CROWNPEAK_ENABLED":false},"es-US":{"QA_TEST_FLAG":true,"CROWNPEAK_ENABLED":false},"fr-CA":{"QA_TEST_FLAG":true,"CROWNPEAK_ENABLED":false},"ja-JP":{"QA_TEST_FLAG":true,"CROWNPEAK_ENABLED":false},"en-BG":{"QA_TEST_FLAG":true,"CROWNPEAK_ENABLED":false},"en-LT":{"QA_TEST_FLAG":true,"CROWNPEAK_ENABLED":false}},"development":{"en-AU":{"QA_TEST_FLAG":true,"CROWNPEAK_ENABLED":false},"en-CA":{"QA_TEST_FLAG":true,"CROWNPEAK_ENABLED":false},"en-GB":{"QA_TEST_FLAG":true,"CROWNPEAK_ENABLED":false},"en-IN":{"QA_TEST_FLAG":true,"CROWNPEAK_ENABLED":false},"en-US":{"QA_TEST_FLAG":true,"CROWNPEAK_ENABLED":false},"es-US":{"QA_TEST_FLAG":true,"CROWNPEAK_ENABLED":false},"fr-CA":{"QA_TEST_FLAG":true,"CROWNPEAK_ENABLED":false},"ja-JP":{"QA_TEST_FLAG":true,"CROWNPEAK_ENABLED":false},"en-BG":{"QA_TEST_FLAG":true,"CROWNPEAK_ENABLED":false},"en-LT":{"QA_TEST_FLAG":true,"CROWNPEAK_ENABLED":false}},"qa":{"en-AU":{"QA_TEST_FLAG":true,"CROWNPEAK_ENABLED":false},"en-CA":{"QA_TEST_FLAG":true,"CROWNPEAK_ENABLED":false},"en-GB":{"QA_TEST_FLAG":true,"CROWNPEAK_ENABLED":false},"en-IN":{"QA_TEST_FLAG":true,"CROWNPEAK_ENABLED":false},"en-US":{"QA_TEST_FLAG":true,"CROWNPEAK_ENABLED":false},"es-US":{"QA_TEST_FLAG":true,"CROWNPEAK_ENABLED":false},"fr-CA":{"QA_TEST_FLAG":true,"CROWNPEAK_ENABLED":false},"ja-JP":{"QA_TEST_FLAG":true,"CROWNPEAK_ENABLED":false},"en-BG":{"QA_TEST_FLAG":true,"CROWNPEAK_ENABLED":false},"en-LT":{"QA_TEST_FLAG":true,"CROWNPEAK_ENABLED":false}},"performance":{"en-AU":{"QA_TEST_FLAG":false,"CROWNPEAK_ENABLED":false},"en-CA":{"QA_TEST_FLAG":false,"CROWNPEAK_ENABLED":false},"en-GB":{"QA_TEST_FLAG":false,"CROWNPEAK_ENABLED":false},"en-IN":{"QA_TEST_FLAG":false,"CROWNPEAK_ENABLED":false},"en-US":{"QA_TEST_FLAG":false,"CROWNPEAK_ENABLED":false},"es-US":{"QA_TEST_FLAG":false,"CROWNPEAK_ENABLED":false},"fr-CA":{"QA_TEST_FLAG":false,"CROWNPEAK_ENABLED":false},"ja-JP":{"QA_TEST_FLAG":false,"CROWNPEAK_ENABLED":false},"en-BG":{"QA_TEST_FLAG":false,"CROWNPEAK_ENABLED":false},"en-LT":{"QA_TEST_FLAG":false,"CROWNPEAK_ENABLED":false}},"pre-production":{"en-AU":{"QA_TEST_FLAG":false,"CROWNPEAK_ENABLED":false},"en-CA":{"QA_TEST_FLAG":false,"CROWNPEAK_ENABLED":false},"en-GB":{"QA_TEST_FLAG":false,"CROWNPEAK_ENABLED":false},"en-IN":{"QA_TEST_FLAG":false,"CROWNPEAK_ENABLED":false},"en-US":{"QA_TEST_FLAG":false,"CROWNPEAK_ENABLED":false},"es-US":{"QA_TEST_FLAG":false,"CROWNPEAK_ENABLED":false},"fr-CA":{"QA_TEST_FLAG":false,"CROWNPEAK_ENABLED":false},"ja-JP":{"QA_TEST_FLAG":false,"CROWNPEAK_ENABLED":false},"en-BG":{"QA_TEST_FLAG":false,"CROWNPEAK_ENABLED":false},"en-LT":{"QA_TEST_FLAG":false,"CROWNPEAK_ENABLED":false}},"production":{"en-AU":{"QA_TEST_FLAG":false,"CROWNPEAK_ENABLED":false},"en-CA":{"QA_TEST_FLAG":false,"CROWNPEAK_ENABLED":false},"en-GB":{"QA_TEST_FLAG":false,"CROWNPEAK_ENABLED":false},"en-IN":{"QA_TEST_FLAG":false,"CROWNPEAK_ENABLED":false},"en-US":{"QA_TEST_FLAG":false,"CROWNPEAK_ENABLED":false},"es-US":{"QA_TEST_FLAG":false,"CROWNPEAK_ENABLED":false},"fr-CA":{"QA_TEST_FLAG":false,"CROWNPEAK_ENABLED":false},"ja-JP":{"QA_TEST_FLAG":false,"CROWNPEAK_ENABLED":false},"en-BG":{"QA_TEST_FLAG":false,"CROWNPEAK_ENABLED":false},"en-LT":{"QA_TEST_FLAG":false,"CROWNPEAK_ENABLED":false}}}');
// EXTERNAL MODULE: ./hooks/useGroqQuery.ts
var useGroqQuery = __webpack_require__(95967);
// EXTERNAL MODULE: ./utils/analytics/index.ts + 6 modules
var analytics = __webpack_require__(83168);
// EXTERNAL MODULE: ./hooks/useBrowsingHistory.tsx
var useBrowsingHistory = __webpack_require__(99778);
// EXTERNAL MODULE: ./ui/elements/InjectedScript.tsx
var InjectedScript = __webpack_require__(19735);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(31373);
// EXTERNAL MODULE: ./utils/media.ts
var media = __webpack_require__(39772);
;// CONCATENATED MODULE: ./ui/elements/Toast.tsx






var Toast = function(props) {
    var description = props.description, icon = props.icon, title = props.title, restProps = (0,_object_without_properties/* default */.Z)(props, [
        "description",
        "icon",
        "title"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* ToastRoot */._lt, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, restProps), {
        size: (0,media/* getIsMobile */.W)() ? "sm" : "base",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* ToastIcon */.IhZ, {
                icon: icon
            }),
            title && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* ToastTitle */.Miw, {
                children: title
            }),
            description && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* ToastDescription */.ljp, {
                children: description
            })
        ]
    }));
};

// EXTERNAL MODULE: ./hooks/useSticky.tsx
var useSticky = __webpack_require__(8261);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(3204);
// EXTERNAL MODULE: ./utils/constants.ts
var constants = __webpack_require__(79758);
// EXTERNAL MODULE: ../node_modules/nookies/dist/index.js
var dist = __webpack_require__(15798);
;// CONCATENATED MODULE: ./utils/updateScripts/deleteLegacyCookies.ts

var AUTH_COOKIE_NAMES_TO_DESTROY = [
    "country",
    "guest",
    "auth-token",
    "refresh-token",
    "customerId",
    "customerEmail",
    "impersonation",
    "uniqueShopperId", 
];
var deleteLegacyCookies = {
    name: "deleteLegacyCookies",
    test: function test() {
        // only run this if there are auth cookies present
        var cookies = (0,dist.parseCookies)();
        return !!cookies["auth-token"];
    },
    run: function run(log) {
        // remove any existing auth cookies to from the root path scope
        var authCookieNames = AUTH_COOKIE_NAMES_TO_DESTROY;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = authCookieNames[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var name = _step.value;
                log("Removing ".concat(name, " from root scope"));
                (0,dist.destroyCookie)(null, name, {
                    path: "/"
                });
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        // need to force a reload to regenerate cookies in correct scope
        return true;
    }
};

;// CONCATENATED MODULE: ./utils/updateScripts/deleteLegacyRegionalAuthCookies.ts


var deleteLegacyRegionalAuthCookies_AUTH_COOKIE_NAMES_TO_DESTROY = [
    "country",
    "guest",
    "auth-token",
    "refresh-token",
    "customerId",
    "customerEmail",
    "impersonation",
    "uniqueShopperId", 
];
var deleteLegacyRegionalAuthCookies = {
    name: "deleteLegacyRegionalAuthCookies",
    test: function test() {
        // only run this if there are auth cookies present
        var cookies = (0,dist.parseCookies)();
        return !!cookies["auth-token"];
    },
    run: function run(log) {
        // remove any existing auth cookies to from the country path scope
        var authCookieNames = deleteLegacyRegionalAuthCookies_AUTH_COOKIE_NAMES_TO_DESTROY;
        var country = (router_default()).query.country;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = authCookieNames[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var name = _step.value;
                log("Removing ".concat(name, ' from "/').concat(country, '" scope'));
                (0,dist.destroyCookie)(null, name, {
                    path: "/".concat(country)
                });
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        // need to force a reload to regenerate cookies in correct scope
        return true;
    }
};

;// CONCATENATED MODULE: ./utils/updateScripts/index.ts




// This file exists as a framework for running single-use code to repair bad data or to prepare for changes
// to the application which require legacy data to be altered in some way. This code will handle the one-time
// execution of these repair scripts.
//
// Updates are to be added to the `updates` array below, and each update will be an object with two methods:
// test(): boolean - checks whether it is safe to run the update (in case it had previously run and is not idempodent)
// run(): boolean - performs the update, and returns true if it requires the page to be reloaded
var updates = [
    deleteLegacyCookies,
    deleteLegacyRegionalAuthCookies
];
var runUpdates = function() {
    var _loop = function(i) {
        var update = updates[i];
        var log = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            var // eslint-disable-next-line no-console
            _console;
            (_console = console).log.apply(_console, [
                "[UPDATE ".concat(i, ": ").concat(update.name, "]")
            ].concat((0,_to_consumable_array/* default */.Z)(args)));
        };
        if (update.test(log)) {
            shouldReload = shouldReload || update.run(log);
        }
    };
    if (constants/* isServer */.sk) return;
    var lastUpdateNumber = Number(window.localStorage.getItem("update"));
    if (Number.isNaN(lastUpdateNumber)) lastUpdateNumber = 0;
    var shouldReload = false;
    for(var i = lastUpdateNumber; i < updates.length; i += 1)_loop(i);
    window.localStorage.setItem("update", updates.length.toString());
    return shouldReload;
};

// EXTERNAL MODULE: ./hooks/useTranslations.tsx
var useTranslations = __webpack_require__(77480);
// EXTERNAL MODULE: ./hooks/useLocation.tsx
var useLocation = __webpack_require__(60248);
// EXTERNAL MODULE: ./hooks/usePreferences.tsx
var usePreferences = __webpack_require__(89915);
// EXTERNAL MODULE: ./hooks/useSiteConfig.ts
var useSiteConfig = __webpack_require__(20368);
// EXTERNAL MODULE: ./utils/authEventEmitter.ts
var authEventEmitter = __webpack_require__(54225);
// EXTERNAL MODULE: ./hooks/useAuth.tsx
var useAuth = __webpack_require__(72507);
// EXTERNAL MODULE: ./__generated__/graphql.ts
var graphql = __webpack_require__(37678);
// EXTERNAL MODULE: ../node_modules/twind/twind.js + 1 modules
var twind = __webpack_require__(34209);
// EXTERNAL MODULE: ./gql/exchanges/auth/cookie.ts
var cookie = __webpack_require__(62900);
// EXTERNAL MODULE: ./ui/elements/Button.tsx + 1 modules
var Button = __webpack_require__(70868);
// EXTERNAL MODULE: ./utils/forter.ts
var forter = __webpack_require__(63179);
;// CONCATENATED MODULE: ./ui/components/ImpersonationBanner.tsx









var nonImpersonation = {
    impersonating: false
};
var getImpersonationData = function() {
    var agent = (0,cookie/* getStoredAgentAuthData */.jH)();
    if (agent) {
        try {
            var user = (0,cookie/* getStoredAuthData */.ir)().user;
            var ref;
            return {
                impersonating: true,
                agentDisplayName: agent.displayName,
                customerEmail: (user === null || user === void 0 ? void 0 : user.email) || undefined,
                customerWebId: (ref = (0,forter/* retrieveCustomerWebId */.at)()) !== null && ref !== void 0 ? ref : undefined
            };
        } catch (e) {
            return nonImpersonation;
        }
    }
    return nonImpersonation;
};
var ForterWebId = function() {
    var ref = (0,react.useState)(forter/* retrieveCustomerWebId */.at), webIdToDisplay = ref[0], setWebIdToDisplay = ref[1];
    var requestCustomerWebId = function() {
        var value = prompt("Enter customer web ID");
        if (value === null) return;
        var valueWithoutSpaces = value.replace(/\s/g, "");
        var isValid = (0,forter/* validateForterWebId */.JK)(valueWithoutSpaces);
        if (!isValid) {
            alert("Invalid Web ID, please confirm the number and try again.");
        }
        var customerWebId = isValid ? valueWithoutSpaces : null;
        setWebIdToDisplay(customerWebId);
        (0,forter/* storeCustomerWebId */.os)(customerWebId);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            webIdToDisplay && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: "font-bold",
                    children: [
                        "Customer Web ID: ",
                        (0,forter/* formatForterWebId */.Gl)(webIdToDisplay)
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                variant: "inline",
                onClick: requestCustomerWebId,
                children: webIdToDisplay ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: "Change"
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "font-bold",
                    children: "Set customer Web ID"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: "|"
            })
        ]
    });
};
var ImpersonationBanner = function() {
    var ref = (0,useSticky/* useSticky */.A)(0), stickyRef = ref.stickyRef, stickyCss = ref.stickyCss;
    var ref1 = (0,react.useState)(nonImpersonation), data = ref1[0], setData = ref1[1];
    var ref2 = (0,useSiteConfig/* useSiteConfig */.N)(), country = ref2.country, env = ref2.env;
    (0,react.useEffect)(function() {
        if (!constants/* isServer */.sk) {
            var data = getImpersonationData();
            setData(data);
        }
    }, []);
    if (!data.impersonating) return null;
    var forterEnabled = !!env.forterSiteId;
    var handleCloseSession = function() {
        (0,cookie/* destroyStoredAuthData */.Cj)(country);
        (0,cookie/* destroyStoredAgentAuthData */.KH)(country);
        (0,forter/* storeCustomerWebId */.os)(null);
        window.close();
    };
    var Message = function() {
        return data.customerEmail ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
            children: [
                "You are ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: (0,twind.tw)("font-bold"),
                    children: data.agentDisplayName
                }),
                " ",
                "logged in on behalf of",
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: (0,twind.tw)("font-bold"),
                    children: data.customerEmail
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
            children: [
                "You are ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: (0,twind.tw)("font-bold"),
                    children: data.agentDisplayName
                }),
                " ",
                "logged in on behalf of a",
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: (0,twind.tw)("font-bold"),
                    children: "guest customer"
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ref: stickyRef,
        className: (0,twind.tw)("z-50", stickyCss),
        "data-test-id": "impersonation-banner",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("aside", {
            className: (0,twind.tw)("flex justify-between items-center text-swatch-white bg-red-700 p-3 gap-3"),
            "data-test-id": "impersonation-title",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex-1",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Message, {})
                }),
                forterEnabled && /*#__PURE__*/ (0,jsx_runtime.jsx)(ForterWebId, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                    variant: "inline",
                    onClick: handleCloseSession,
                    children: "Close session"
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./utils/serializeBlockContent.tsx
var serializeBlockContent = __webpack_require__(88313);
// EXTERNAL MODULE: ./ui/components/Modal.tsx
var Modal = __webpack_require__(51377);
// EXTERNAL MODULE: ./ui/elements/Link.tsx
var Link = __webpack_require__(68302);
// EXTERNAL MODULE: ./ui/components/CloseButton.tsx
var CloseButton = __webpack_require__(6485);
// EXTERNAL MODULE: ./groq/documents/GlobalPromoBannerDocument.ts
var GlobalPromoBannerDocument = __webpack_require__(94735);
// EXTERNAL MODULE: ./hooks/usePromotionView.ts
var usePromotionView = __webpack_require__(32736);
// EXTERNAL MODULE: ./hooks/useWindowSize.ts
var useWindowSize = __webpack_require__(45746);
;// CONCATENATED MODULE: ./hooks/useDeviceOrientation.ts


function useDeviceOrientation() {
    var ref = (0,react.useState)("portrait"), deviceOrientation = ref[0], setDeviceOrientation = ref[1];
    var ref1 = (0,useWindowSize/* useWindowSize */.i)(), width = ref1.width, height = ref1.height;
    (0,react.useEffect)(function() {
        if (width !== null && height !== null) {
            if (width > height) {
                setDeviceOrientation("landscape");
            } else {
                setDeviceOrientation("portrait");
            }
        }
    }, [
        width,
        height
    ]);
    return deviceOrientation;
} // usage: `const deviceOrientation = useDeviceOrientation();`

// EXTERNAL MODULE: ./utils/locale.ts + 1 modules
var utils_locale = __webpack_require__(79302);
// EXTERNAL MODULE: ./hooks/useLinkResolver.ts
var useLinkResolver = __webpack_require__(13022);
// EXTERNAL MODULE: ./ui/content/CountdownClock.tsx + 1 modules
var CountdownClock = __webpack_require__(3099);
// EXTERNAL MODULE: ./ui/content/ClampedInfoMessageText.tsx + 1 modules
var ClampedInfoMessageText = __webpack_require__(83949);
;// CONCATENATED MODULE: ./ui/content/GlobalPromoBanner.tsx






















function useGlobalPromoBannerQuery() {
    return (0,useGroqQuery/* useGroqQuery */.Mo)({
        query: GlobalPromoBannerDocument/* GlobalPromoBannerDocument */.$,
        operationName: "GlobalPromoBanner"
    });
}
var GlobalPromoBanner = /*#__PURE__*/ react.forwardRef(function(_, forwardedRef) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10;
    var router = (0,next_router.useRouter)();
    var ref11 = (0,react.useState)(false), isReadingDetails = ref11[0], setReadingDetails = ref11[1];
    var ref12 = (0,react.useState)(false), showInfoMessage = ref12[0], setShowInfoMessage = ref12[1];
    var excluded = router.asPath.includes("/checkout");
    var ref13 = (0,_sliced_to_array/* default */.Z)(useGlobalPromoBannerQuery(), 1), result = ref13[0];
    var messages = ((ref = result.data) === null || ref === void 0 ? void 0 : (ref1 = ref.content) === null || ref1 === void 0 ? void 0 : ref1.messages) || [];
    var duration = ((ref2 = result.data) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.content) === null || ref3 === void 0 ? void 0 : ref3.duration) ? ((ref4 = result.data) === null || ref4 === void 0 ? void 0 : ref4.content.duration) * 1000 : 30000;
    var isMounted = (0,react.useRef)(false);
    var isDesktop = (0,media/* getIsDesktop */.w)();
    var locale = (0,useSiteConfig/* useSiteConfig */.N)().locale;
    var getLink = (0,useLinkResolver/* useLinkResolver */.u)().getLink;
    var localeUrl = (0,utils_locale/* getUrlFromLocale */.bH)(locale);
    var readMoreLink = "".concat(localeUrl, "/puma/sale-terms-and-conditions");
    var ref14 = (0,react.useRef)(null);
    var ref15 = (0,react.useState)(0), showingIndex = ref15[0], setShowingIndex = ref15[1];
    var currentMessage = messages[showingIndex];
    var promotion_id = "";
    var creative_name = ((ref5 = result.data) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.content) === null || ref6 === void 0 ? void 0 : ref6._type) || "GlobalPromoBanner";
    var gaTrackData = {
        id: promotion_id,
        name: "",
        creative: creative_name
    };
    var ga4PromotionTrackerPosition = (0,usePromotionView/* usePromotionView */.Y)(ref14, gaTrackData, true).ga4PromotionTrackerPosition;
    var ga4Data = {
        creative_name: creative_name,
        creative_slot: ga4PromotionTrackerPosition,
        promotion_id: promotion_id,
        fireEventFromPdp: router.asPath.includes("/pd/")
    };
    var deviceOrientation = useDeviceOrientation();
    // close the disclaimer when the device orientation changes.
    (0,react.useEffect)(function() {
        setShowInfoMessage(false);
    }, [
        deviceOrientation
    ]);
    (0,react.useEffect)(function() {
        isMounted.current = true;
        return function() {
            isMounted.current = false;
        };
    }, []);
    (0,react.useEffect)(function() {
        if (isReadingDetails) return;
        var timer;
        if (messages.length > 1) {
            timer = setInterval(function() {
                if (ref14.current) {
                    ref14.current.style.opacity = "0";
                    setTimeout(function() {
                        if (isMounted.current) setShowingIndex(function(index) {
                            return (index + 1) % messages.length;
                        });
                        if (ref14.current) ref14.current.style.opacity = "1";
                    }, 300);
                }
            }, duration);
        }
        return function() {
            if (timer) clearInterval(timer);
        };
    }, [
        isReadingDetails,
        duration,
        messages.length,
        isMounted
    ]);
    var ref16;
    var infoDetails = (ref16 = currentMessage === null || currentMessage === void 0 ? void 0 : (ref7 = currentMessage.information) === null || ref7 === void 0 ? void 0 : ref7.localeDetails) !== null && ref16 !== void 0 ? ref16 : currentMessage === null || currentMessage === void 0 ? void 0 : (ref8 = currentMessage.information) === null || ref8 === void 0 ? void 0 : ref8.details;
    var infoMessage = infoDetails === null || infoDetails === void 0 ? void 0 : infoDetails.map(function(detail) {
        var ref;
        return detail === null || detail === void 0 ? void 0 : (ref = detail.children) === null || ref === void 0 ? void 0 : ref.map(function(el) {
            return el.text;
        }).join("");
    }).join("");
    var isMobile = (0,media/* getIsMobile */.W)();
    var tooltipMaxWidth = isMobile ? "460px" : "375px";
    var tooltipStyles = {
        "--tooltip-max-width": tooltipMaxWidth,
        height: "10px",
        zIndex: "50"
    };
    if (excluded || !currentMessage) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("aside", {
        ref: forwardedRef,
        "aria-label": "Promo Banner",
        "data-test-id": "promo-banner",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
            className: "flex h-11 bg-puma-white font-display text-black items-center justify-center mobile:text-xs text-sm",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    ref: ref14,
                    className: (0,twind.tw)([
                        "transition-opacity duration-300",
                        "inline-flex flex-row", 
                    ]),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-wrap text-center leading-none font-bold justify-center items-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: currentMessage.text
                            }),
                            currentMessage.countdownClock && /*#__PURE__*/ (0,jsx_runtime.jsx)(CountdownClock/* CountdownClock */.h, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, currentMessage.countdownClock), {
                                config: {
                                    timeUnitClassName: "text-sm desktop:text-base",
                                    containerClassName: "space-x-[2px] ml-3 inline-flex"
                                }
                            })),
                            currentMessage === null || currentMessage === void 0 ? void 0 : (ref9 = currentMessage.ctas) === null || ref9 === void 0 ? void 0 : ref9.map(function(cta) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                                            href: getLink(cta),
                                            variant: "black",
                                            size: "sm",
                                            underlined: true,
                                            className: "inline whitespace-nowrap uppercase mobile:text-xs ml-3",
                                            newtab: !!cta.newtab,
                                            popup: !!cta.popup,
                                            query: cta.query,
                                            ga4Data: ga4Data,
                                            children: cta.title
                                        }),
                                        infoMessage && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "flex px-2 mt-[3px] items-center",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* TooltipRoot */.wYI, {
                                                dataTestId: "info-icon",
                                                invert: true,
                                                side: "bottom",
                                                align: "center",
                                                open: showInfoMessage,
                                                onOpenChange: setShowInfoMessage,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* TooltipTrigger */.aJU, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            onClick: function(e) {
                                                                if (!isDesktop) {
                                                                    setShowInfoMessage(!showInfoMessage);
                                                                }
                                                                e.preventDefault();
                                                                e.stopPropagation();
                                                            },
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Icon */.JO$, {
                                                                name: "info-outline",
                                                                size: "sm"
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* TooltipContent */._vU, {
                                                        style: tooltipStyles,
                                                        className: "!bg-puma-gray-20 !text-puma-black",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ClampedInfoMessageText/* ClampedInfoMessageText */.w, {
                                                            infoMessage: infoMessage,
                                                            setShowInfoMessage: setShowInfoMessage,
                                                            readMoreLink: readMoreLink
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }, cta._key);
                            }),
                            ((ref10 = currentMessage.information) === null || ref10 === void 0 ? void 0 : ref10.title) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                children: [
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                                        id: "moreInfoLink",
                                        href: "#",
                                        variant: "black",
                                        size: "sm",
                                        underlined: true,
                                        className: "inline whitespace-nowrap uppercase mobile:text-xs ml-3",
                                        "aria-label": currentMessage.information.title,
                                        onClick: function() {
                                            return setReadingDetails(true);
                                        },
                                        children: currentMessage.information.title
                                    })
                                ]
                            })
                        ]
                    })
                }, currentMessage.id),
                isReadingDetails && infoDetails && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
                    variant: "dark",
                    className: "w-full max-w-xl relative p-5 xs:p-8",
                    onClickOutside: function() {
                        setReadingDetails(false);
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseButton/* default */.Z, {
                            className: "float-right p-1 ml-5 xs:ml-8",
                            onClick: function() {
                                return setReadingDetails(false);
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(serializeBlockContent/* Prose */.Mr, {
                            content: infoDetails
                        })
                    ]
                })
            ]
        })
    });
});
GlobalPromoBanner.displayName = "GlobalPromoBanner";

// EXTERNAL MODULE: ../node_modules/twind/css/css.js
var css = __webpack_require__(49224);
// EXTERNAL MODULE: ./groq/queries/PageType.ts
var PageType = __webpack_require__(99550);
// EXTERNAL MODULE: ./groq/documents/SecondGlobalBannerDocument.ts
var SecondGlobalBannerDocument = __webpack_require__(63642);
;// CONCATENATED MODULE: ./utils/omit.ts
var omit = function(obj, key) {
    return Object.keys(obj).filter(function(k) {
        return k !== key;
    }).reduce(function(result, k) {
        result[k] = obj[k];
        return result;
    }, {});
};

// EXTERNAL MODULE: ./utils/getUrlByCategory.ts
var getUrlByCategory = __webpack_require__(21867);
// EXTERNAL MODULE: ./ui/content/InfoBanner.tsx
var InfoBanner = __webpack_require__(86491);
;// CONCATENATED MODULE: ./ui/content/SecondGlobalBanner.tsx

















function useSecondGlobalBannerQuery() {
    return (0,useGroqQuery/* useGroqQuery */.Mo)({
        query: SecondGlobalBannerDocument/* SecondGlobalBannerDocument */.B,
        operationName: "SecondGlobalBanner"
    });
}
function usePageTypeQuery(url) {
    return (0,useGroqQuery/* useGroqQuery */.Mo)({
        query: PageType/* PageTypeQuery */.i,
        operationName: "PageType",
        variables: {
            url: url
        },
        pause: !url
    });
}
var CATEGORY_PAGE_TYPES = {
    MarketingPage: "other",
    CategoryPage: "clp",
    category: "plp"
};
var AsideSecondGlobalBanner = function(props) {
    var ref;
    var ref1 = (0,useSticky/* useSticky */.A)(((ref = props.banner) === null || ref === void 0 ? void 0 : ref.isSticky) ? 2 : null), stickyRef = ref1.stickyRef, stickyCss = ref1.stickyCss;
    var _banner = props.banner, infoBanner = _banner.banner, rest = (0,_object_without_properties/* default */.Z)(_banner, [
        "banner"
    ]);
    var gaTrackData = {
        id: "",
        name: "",
        creative: "SecondGlobalBanner"
    };
    (0,usePromotionView/* usePromotionView */.Y)(stickyRef, gaTrackData, true);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("aside", {
        "aria-label": "Second Promo Banner",
        "data-test-id": "secondary-global-banner",
        className: (0,css.tw)(props.banner.isSticky && (0,css/* apply */.nn)("relative z-20", stickyCss)),
        ref: stickyRef,
        children: infoBanner && /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoBanner/* InfoBanner */.X, (0,_object_spread/* default */.Z)({
            priority: true
        }, infoBanner, rest))
    });
};
var SecondGlobalBanner = function() {
    var ref, ref1, ref2, ref3;
    var router = (0,next_router.useRouter)();
    var locale = (0,useSiteConfig/* useSiteConfig */.N)().locale;
    var category = router.query.category;
    var pagePath = (0,utils_locale/* removeLocalePrefix */.g5)(router.asPath.split("?")[0], locale);
    var url = (0,getUrlByCategory/* getUrlByCategory */.M)(category);
    var ref4 = (0,_sliced_to_array/* default */.Z)(usePageTypeQuery(url), 1), pageTypeResult = ref4[0];
    var ref5 = (0,_sliced_to_array/* default */.Z)(useSecondGlobalBannerQuery(), 1), result = ref5[0];
    var pageTypes = ((ref = pageTypeResult.data) === null || ref === void 0 ? void 0 : ref.content) || {};
    var ref6 = (0,_sliced_to_array/* default */.Z)(Object.entries(CATEGORY_PAGE_TYPES).filter(function(param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 1), type = _param[0];
        return pageTypes[type] && pageTypes[type]._id;
    }).map(function(param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 1), key = _param[0];
        return key;
    }), 1), categoryPage = ref6[0];
    var urlForExcludedCategories = (0,getUrlByCategory/* getUrlByCategory */.M)(category, pagePath || "/");
    var banners = result === null || result === void 0 ? void 0 : (ref1 = result.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.content) === null || ref2 === void 0 ? void 0 : ref2.banners;
    var banner = banners === null || banners === void 0 ? void 0 : banners.sort(function(a, b) {
        var ref, ref1, ref2, ref3;
        // prioritize banners associated with source codes
        var aFirstSrc = (ref = a.campaign) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.sourceCode;
        var bFirstSrc = (ref2 = b.campaign) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[0]) === null || ref3 === void 0 ? void 0 : ref3.sourceCode;
        if (!aFirstSrc && bFirstSrc) return 1;
        if (aFirstSrc && !bFirstSrc) return -1;
        return 0;
    }).find(function(banner) {
        var isNotExcludedCoreLink = (banner.coreLinkExclusions || []).every(function(excludedCoreLink) {
            return !pagePath.startsWith(excludedCoreLink);
        });
        var isNotExcludedCategory = (banner.exclusions || []).every(function(excludedCategory) {
            return (excludedCategory === null || excludedCategory === void 0 ? void 0 : excludedCategory.url) !== urlForExcludedCategories;
        });
        var pagesEntries = Object.entries(omit(banner.displayOnlyOn || {}, "_type"));
        var allPageTypes = pagesEntries.map(function(param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 1), key = _param[0];
            return key;
        });
        var excludedPageTypes = pagesEntries.filter(function(param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), _ = _param[0], display = _param[1];
            return !display;
        }).map(function(param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 1), key = _param[0];
            return key;
        });
        var noPagesSelected = allPageTypes.length === excludedPageTypes.length;
        var pageType = (0,analytics/* getPageType */.C2)(router.asPath) || "";
        if (pageType === "plp") {
            pageType = CATEGORY_PAGE_TYPES[categoryPage];
        }
        var isNotExcludedPageType = noPagesSelected || !excludedPageTypes.includes(pageType);
        var isAccountPage = pageType === "account";
        var isNotExcludedProduct = true;
        if (pageType === "pdp") {
            var sku = "".concat(router.query.id, "_").concat(router.query.swatch);
            isNotExcludedProduct = (banner.productsExclusions || []).every(function(param) {
                var masterId = param.masterId, color = param.color;
                return "".concat(masterId, "_").concat(color) !== sku;
            });
        }
        return isNotExcludedCoreLink && isNotExcludedCategory && isNotExcludedPageType && isNotExcludedProduct && !isAccountPage;
    });
    if (!banner) return null;
    var responsiveClasses = (ref3 = banner.targetDevices) === null || ref3 === void 0 ? void 0 : ref3.map(function(device) {
        return "".concat(device, ":block");
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,css.tw)("hidden empty:hidden", responsiveClasses),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AsideSecondGlobalBanner, {
            banner: banner
        })
    });
};

// EXTERNAL MODULE: ./hooks/useIsServer.ts
var useIsServer = __webpack_require__(64724);
// EXTERNAL MODULE: ./hooks/useResizeObserver.ts
var useResizeObserver = __webpack_require__(13765);
// EXTERNAL MODULE: ./hooks/useLiveChat/index.tsx + 3 modules
var useLiveChat = __webpack_require__(57998);
// EXTERNAL MODULE: ./hooks/useMainNav.tsx + 1 modules
var useMainNav = __webpack_require__(14425);
// EXTERNAL MODULE: ./hooks/useProductHistory.tsx + 2 modules
var useProductHistory = __webpack_require__(17695);
// EXTERNAL MODULE: ./utils/debounce.ts
var debounce = __webpack_require__(40572);
;// CONCATENATED MODULE: ./ui/components/Search/types.ts
var SearchViewScenario;
(function(SearchViewScenario) {
    SearchViewScenario["NewUser"] = "search-scenario-new-user";
    SearchViewScenario["ReturningUser"] = "search-scenario-returning-user";
    SearchViewScenario["SearchResults"] = "search-scenario-search-results";
})(SearchViewScenario || (SearchViewScenario = {}));

;// CONCATENATED MODULE: ./utils/search.ts

var SEARCH_DEBOUNCE_MS = 500;
var RETURNING_USER_THRESHOLD_VIEWED_PRODUCT_COUNT = 4;
var getSearchViewScenario = function(recentlyViewedProducts, hasSearchTerm) {
    if (recentlyViewedProducts.length >= RETURNING_USER_THRESHOLD_VIEWED_PRODUCT_COUNT) {
        return SearchViewScenario.ReturningUser;
    } else {
        return hasSearchTerm ? SearchViewScenario.SearchResults : SearchViewScenario.NewUser;
    }
};

// EXTERNAL MODULE: ./utils/bloomreach.ts
var bloomreach = __webpack_require__(61060);
// EXTERNAL MODULE: ./hooks/a11y/index.ts + 4 modules
var a11y = __webpack_require__(71129);
;// CONCATENATED MODULE: ./ui/components/Search/NoResultsMessage.tsx



var NoResultsMessage = function() {
    var t = (0,useTranslations/* useTranslate */.qM)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        "data-test-id": "search-no-results-message",
        className: "flex gap-2 items-center pb-6 mb-6 border-b-1",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Icon */.JO$, {
                name: "exclamation-outline",
                size: "2xl"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Text */.xvT, {
                weight: "bold",
                children: t("searchNoResultsMessage")
            })
        ]
    });
};
/* harmony default export */ var Search_NoResultsMessage = (NoResultsMessage);

// EXTERNAL MODULE: ./ui/components/LoadingSpinner.tsx
var LoadingSpinner = __webpack_require__(91622);
;// CONCATENATED MODULE: ./ui/components/Search/SearchLoadingIndicator.tsx


var SearchLoadingIndicator = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingSpinner/* LoadingSpinner */.T, {
        dataTestId: "search-flyout-loading",
        className: "text-neutral"
    });
};
/* harmony default export */ var Search_SearchLoadingIndicator = (SearchLoadingIndicator);

// EXTERNAL MODULE: ./utils/buildProductUrl.ts
var buildProductUrl = __webpack_require__(69377);
// EXTERNAL MODULE: ./ui/components/ProductPrice/ProductPrice.tsx + 2 modules
var ProductPrice = __webpack_require__(42413);
;// CONCATENATED MODULE: ./ui/components/Search/SearchProductListItem.tsx




var SearchProductListItem = function(param) {
    var product = param.product;
    var ref, ref1;
    var ref2 = (0,useSiteConfig/* useSiteConfig */.N)(), showHeaderSubHeaderProductDetail = ref2.staticFeatures.showHeaderSubHeaderProductDetail;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex gap-4 items-center group",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: (ref = product.image) === null || ref === void 0 ? void 0 : ref.href,
                alt: (ref1 = product.image) === null || ref1 === void 0 ? void 0 : ref1.alt,
                className: "flex-none w-[100px] h-[100px]"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col gap-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col w-full",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Text */.xvT, {
                                dataTestId: "search-product-name",
                                weight: "bold",
                                className: "block group-hover:text-underline",
                                children: showHeaderSubHeaderProductDetail ? product.header : product.name
                            }),
                            showHeaderSubHeaderProductDetail && product.subHeader && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Text */.xvT, {
                                dataTestId: "search-product-subheader",
                                className: "w-full text-base font-normal text-puma-gray-60 line-clamp-2",
                                children: product.subHeader
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex gap-2 flex-wrap",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPrice/* ProductPrice */.jF, {
                            price: {
                                amount: product.price,
                                salePrice: product.salePrice,
                                isSalePriceElapsed: product.isSalePriceElapsed,
                                bestPrice: product.bestPrice
                            },
                            compact: true
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./ui/components/Search/SearchOptionList.tsx



var SearchOptionList = function(param) {
    var id = param.id, dataTestId = param.dataTestId, heading = param.heading, children = param.children, _className = param.className, className = _className === void 0 ? "flex flex-col" : _className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        "data-test-id": dataTestId,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Heading */.X6q, {
                id: "".concat(dataTestId, "-heading"),
                dataTestId: "".concat(dataTestId, "-heading"),
                transform: "uppercase",
                size: "sm",
                asChild: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    children: heading
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                "aria-labelledby": "".concat(id, "-heading"),
                className: (0,twind.tw)("w-full mt-6 gap-4", className),
                children: children
            })
        ]
    });
};

;// CONCATENATED MODULE: ./ui/components/Search/SearchProductList.tsx





var SearchProductList = function(param) {
    var heading = param.heading, products = param.products, onClick = param.onClick;
    // show maximum of 8 product suggestions
    var productsToRender = products.slice(0, 8);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchOptionList, {
        id: "search-product-list",
        dataTestId: "search-product-list",
        heading: heading,
        className: "flex flex-col sm:grid sm:grid-cols-2",
        children: productsToRender.map(function(product) {
            var pdpUrl = (0,buildProductUrl/* buildProductUrl */.B)(product.masterId, product.name, {
                color: product.colorValue
            });
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* SearchOption */.VcP, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Anchor */.eee, {
                        dataTestId: "search-product-list-item",
                        href: pdpUrl,
                        onClick: function() {
                            return onClick === null || onClick === void 0 ? void 0 : onClick(product);
                        },
                        className: "block hover:bg-none",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchProductListItem, {
                            product: product
                        })
                    })
                })
            }, pdpUrl);
        })
    });
};

// EXTERNAL MODULE: ./utils/extractProductVariants.ts
var extractProductVariants = __webpack_require__(71926);
;// CONCATENATED MODULE: ./ui/components/Search/Views/RecommendedProducts.tsx








var RecommendedProducts = function(param) {
    var setIsLoading = param.setIsLoading, setSessionStorageData = param.setSessionStorageData;
    var ref;
    var t = (0,useTranslations/* useTranslate */.qM)();
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,graphql/* useSearchRecommendedProductsQuery */.C1o)(), 1), searchFlyoutRecommendedProductsResult = ref1[0];
    (0,react.useEffect)(function() {
        setIsLoading(searchFlyoutRecommendedProductsResult.fetching);
    }, [
        searchFlyoutRecommendedProductsResult.fetching,
        setIsLoading
    ]);
    var trackProductClick = function(product) {
        if (setSessionStorageData) {
            setSessionStorageData(t("recommendedProducts"), product.name);
            (0,analytics/* searchAnalyticsEvent */.dr)("0", true);
        }
        (0,analytics/* event */.B)(analytics/* AnalyticsEvents.SEARCH_RECOMMENDED_PRODUCT_CLICK */._q.SEARCH_RECOMMENDED_PRODUCT_CLICK, {
            suggested_product: product.name
        });
    };
    var searchFlyoutRecommendedProducts = (ref = searchFlyoutRecommendedProductsResult.data) === null || ref === void 0 ? void 0 : ref.searchFlyoutRecommendedProducts;
    if (!searchFlyoutRecommendedProducts) return null;
    var variants = (0,extractProductVariants/* extractProductVariants */.b)(searchFlyoutRecommendedProducts);
    var ref2, ref3;
    var products = variants.map(function(x) {
        var ref, ref1, ref4;
        return {
            masterId: x.masterId,
            colorValue: x.colorValue,
            name: x.name,
            header: x.header,
            subHeader: x.subHeader,
            price: (ref2 = (ref = x.productPrice) === null || ref === void 0 ? void 0 : ref.price) !== null && ref2 !== void 0 ? ref2 : 0,
            salePrice: (ref3 = x === null || x === void 0 ? void 0 : (ref1 = x.productPrice) === null || ref1 === void 0 ? void 0 : ref1.salePrice) !== null && ref3 !== void 0 ? ref3 : 0,
            image: x.images[0],
            isSalePriceElapsed: (ref4 = x.productPrice) === null || ref4 === void 0 ? void 0 : ref4.isSalePriceElapsed
        };
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchProductList, {
        heading: t("recommendedProducts"),
        products: products,
        onClick: trackProductClick
    });
};
/* harmony default export */ var Views_RecommendedProducts = (RecommendedProducts);

;// CONCATENATED MODULE: ./ui/components/Search/Views/SuggestedProducts.tsx









var SuggestedProducts = function(param) {
    var suggestionsResult = param.suggestionsResult, setIsLoading = param.setIsLoading, searchTerm = param.searchTerm, setSessionStorageData = param.setSessionStorageData;
    var ref;
    var t = (0,useTranslations/* useTranslate */.qM)();
    var countryCode = (0,useSiteConfig/* useSiteConfig */.N)().countryCode;
    var location = (0,useLocation/* useLocation */.TH)().location;
    (0,react.useEffect)(function() {
        var ref;
        setIsLoading((ref = suggestionsResult === null || suggestionsResult === void 0 ? void 0 : suggestionsResult.fetching) !== null && ref !== void 0 ? ref : false);
    }, [
        setIsLoading,
        suggestionsResult === null || suggestionsResult === void 0 ? void 0 : suggestionsResult.fetching
    ]);
    var trackProductClick = function(product) {
        var ref;
        if (setSessionStorageData) {
            setSessionStorageData(t("suggestedProducts"), product.name);
            (0,analytics/* searchAnalyticsEvent */.dr)("0", true);
        }
        (0,analytics/* event */.B)(analytics/* AnalyticsEvents.SEARCH_SUGGESTED_PRODUCT_CLICK */._q.SEARCH_SUGGESTED_PRODUCT_CLICK, {
            related_product: product.name
        });
        (0,bloomreach/* trackSuggestEventInBloomreach */.Nh)({
            query: searchTerm,
            suggestion: product.name,
            siteCountryCode: countryCode,
            visitorCountryCode: location === null || location === void 0 ? void 0 : (ref = location.userCountry) === null || ref === void 0 ? void 0 : ref.id
        });
    };
    var suggestions = suggestionsResult === null || suggestionsResult === void 0 ? void 0 : (ref = suggestionsResult.data) === null || ref === void 0 ? void 0 : ref.suggestions;
    if (!suggestions) return null;
    var _suggestedProductsSummaries;
    var suggestedProducts = (_suggestedProductsSummaries = suggestions.suggestedProductsSummaries) !== null && _suggestedProductsSummaries !== void 0 ? _suggestedProductsSummaries : [];
    var products = suggestedProducts.map(function(x) {
        return {
            masterId: x.masterId,
            colorValue: x.colorValue,
            image: x.images[0],
            name: x.name,
            price: x.price,
            salePrice: x.salePrice,
            isSalePriceElapsed: x.isSalePriceElapsed,
            header: x.header,
            subHeader: x.subHeader
        };
    });
    return products.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchProductList, {
        heading: t("suggestedProducts"),
        products: products,
        onClick: trackProductClick
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Views_RecommendedProducts, {
        setIsLoading: setIsLoading
    });
};
/* harmony default export */ var Views_SuggestedProducts = (SuggestedProducts);

// EXTERNAL MODULE: ./utils/capitalize.ts
var capitalize = __webpack_require__(59308);
;// CONCATENATED MODULE: ./ui/components/Search/SearchTermList.tsx





var SearchTermList = function(param) {
    var heading = param.heading, terms = param.terms, onClick = param.onClick;
    // show maximum of 6 search term suggestions
    var termsToRender = terms.filter(function(x) {
        return x.length > 0;
    }).slice(0, 6);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchOptionList, {
        id: "search-term-list",
        dataTestId: "search-term-list",
        heading: heading,
        children: termsToRender.map(function(str, idx) {
            var term = (0,capitalize/* capitalize */.k)(str);
            var searchUrl = "/search?q=".concat(term);
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                className: (0,twind.tw)(idx <= 3 ? "block" : "hidden sm:block"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* SearchOption */.VcP, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Anchor */.eee, {
                        dataTestId: "search-term-list-item",
                        href: searchUrl,
                        onClick: function() {
                            return onClick === null || onClick === void 0 ? void 0 : onClick(term);
                        },
                        className: "text-neutral-60 hover:text-neutral-100 [data-focused=true]:text-neutral-100 hover:bg-none",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Text */.xvT, {
                            weight: "bold",
                            children: term
                        })
                    })
                })
            }, term);
        })
    });
};

;// CONCATENATED MODULE: ./ui/components/Search/Views/TrendingSearchTerms.tsx







var TrendingSearchTerms = function(param) {
    var setIsLoading = param.setIsLoading, setSessionStorageData = param.setSessionStorageData;
    var ref;
    var t = (0,useTranslations/* useTranslate */.qM)();
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,graphql/* useTrendingSearchTermsQuery */.G5l)(), 1), trendingSearchTermsResult = ref1[0];
    (0,react.useEffect)(function() {
        setIsLoading(trendingSearchTermsResult.fetching);
    }, [
        trendingSearchTermsResult.fetching,
        setIsLoading
    ]);
    var trackTrendingSearchTermClick = function(term) {
        if (setSessionStorageData) {
            setSessionStorageData(t("trendingSearchTerms"), term);
        }
        (0,analytics/* event */.B)(analytics/* AnalyticsEvents.SEARCH_TRENDING_SEARCH_TERM_CLICK */._q.SEARCH_TRENDING_SEARCH_TERM_CLICK, {
            trending_search_term: term
        });
    };
    var trendingSearchTerms = (ref = trendingSearchTermsResult.data) === null || ref === void 0 ? void 0 : ref.trendingSearchTerms;
    var terms = (trendingSearchTerms !== null && trendingSearchTerms !== void 0 ? trendingSearchTerms : []).sort(function(a, b) {
        return a.rank - b.rank;
    }).map(function(item) {
        return item.searchTerm;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchTermList, {
        heading: t("trendingSearchTerms"),
        terms: terms,
        onClick: trackTrendingSearchTermClick
    });
};
/* harmony default export */ var Views_TrendingSearchTerms = (TrendingSearchTerms);

;// CONCATENATED MODULE: ./ui/components/Search/Views/SuggestedSearchTerms.tsx









var SuggestedSearchTerms = function(param) {
    var searchTerm = param.searchTerm, suggestionsResult = param.suggestionsResult, setIsLoading = param.setIsLoading, setSessionStorageData = param.setSessionStorageData;
    var ref, ref1, ref2;
    var t = (0,useTranslations/* useTranslate */.qM)();
    var countryCode = (0,useSiteConfig/* useSiteConfig */.N)().countryCode;
    var location = (0,useLocation/* useLocation */.TH)().location;
    (0,react.useEffect)(function() {
        var ref;
        setIsLoading((ref = suggestionsResult === null || suggestionsResult === void 0 ? void 0 : suggestionsResult.fetching) !== null && ref !== void 0 ? ref : false);
    }, [
        setIsLoading,
        suggestionsResult === null || suggestionsResult === void 0 ? void 0 : suggestionsResult.fetching
    ]);
    var trackSuggestedSearchTermClick = function(suggestedTerm) {
        var ref;
        if (!searchTerm || !suggestedTerm) return;
        if (setSessionStorageData) setSessionStorageData(t("suggestedSearchTerms"), suggestedTerm);
        // GA tracking
        (0,analytics/* event */.B)(analytics/* AnalyticsEvents.SEARCH_SUGGESTED_SEARCH_TERM_CLICK */._q.SEARCH_SUGGESTED_SEARCH_TERM_CLICK, {
            suggested_term: suggestedTerm
        });
        // bloomreach tracking
        (0,bloomreach/* trackSuggestEventInBloomreach */.Nh)({
            query: searchTerm,
            suggestion: suggestedTerm,
            siteCountryCode: countryCode,
            visitorCountryCode: location === null || location === void 0 ? void 0 : (ref = location.userCountry) === null || ref === void 0 ? void 0 : ref.id
        });
    };
    var suggestions = suggestionsResult === null || suggestionsResult === void 0 ? void 0 : (ref = suggestionsResult.data) === null || ref === void 0 ? void 0 : ref.suggestions;
    if (!suggestions) return null;
    var ref3;
    var terms = (ref3 = (ref1 = suggestions.suggestedTerms) === null || ref1 === void 0 ? void 0 : ref1.map(function(x) {
        return x.suggestion;
    }).slice(0, 8)) !== null && ref3 !== void 0 ? ref3 : [];
    var ref4;
    var phrases = (ref4 = (ref2 = suggestions.suggestedPhrases) === null || ref2 === void 0 ? void 0 : ref2.map(function(x) {
        return x.suggestion;
    }).slice(0, 8)) !== null && ref4 !== void 0 ? ref4 : [];
    var termsToDisplay = terms.length > 0 ? terms : phrases;
    return termsToDisplay.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchTermList, {
        heading: t("suggestedSearchTerms"),
        terms: termsToDisplay,
        onClick: trackSuggestedSearchTermClick
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Views_TrendingSearchTerms, {
        setIsLoading: setIsLoading,
        setSessionStorageData: setSessionStorageData
    });
};
/* harmony default export */ var Views_SuggestedSearchTerms = (SuggestedSearchTerms);

;// CONCATENATED MODULE: ./ui/components/Search/Views/RecentlyViewedProducts.tsx







var RecentlyViewedProducts = function(param) {
    var recentlyViewedProducts = param.recentlyViewedProducts, setIsLoading = param.setIsLoading, setSessionStorageData = param.setSessionStorageData;
    var ref;
    var t = (0,useTranslations/* useTranslate */.qM)();
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,graphql/* useVariantsQuery */.kii)({
        variables: {
            input: {
                styleNumberIds: recentlyViewedProducts
            }
        }
    }), 1), variantsResult = ref1[0];
    (0,react.useEffect)(function() {
        setIsLoading(variantsResult.fetching);
    }, [
        variantsResult.fetching,
        setIsLoading
    ]);
    var trackProductClick = function(product) {
        if (setSessionStorageData) {
            setSessionStorageData(t("recentlyViewed"), product.name);
            (0,analytics/* searchAnalyticsEvent */.dr)("0", true);
        }
        (0,analytics/* event */.B)(analytics/* AnalyticsEvents.SEARCH_RECENTLY_VIEWED_PRODUCT_CLICK */._q.SEARCH_RECENTLY_VIEWED_PRODUCT_CLICK, {
            recently_viewed_product: product.name
        });
    };
    var variants = (ref = variantsResult.data) === null || ref === void 0 ? void 0 : ref.variants;
    if (!variants) return null;
    var products = variants.map(function(product) {
        var ref, ref1, ref2;
        var ref3, ref4;
        return {
            masterId: product.masterId,
            colorValue: product.colorValue,
            name: product.name,
            header: product.header,
            subHeader: product.subHeader,
            price: (ref3 = (ref = product.productPrice) === null || ref === void 0 ? void 0 : ref.price) !== null && ref3 !== void 0 ? ref3 : 0,
            salePrice: (ref4 = (ref1 = product.productPrice) === null || ref1 === void 0 ? void 0 : ref1.salePrice) !== null && ref4 !== void 0 ? ref4 : 0,
            image: product.images[0],
            isSalePriceElapsed: (ref2 = product.productPrice) === null || ref2 === void 0 ? void 0 : ref2.isSalePriceElapsed
        };
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchProductList, {
        heading: t("recentlyViewed"),
        products: products,
        onClick: trackProductClick
    });
};
/* harmony default export */ var Views_RecentlyViewedProducts = (RecentlyViewedProducts);

;// CONCATENATED MODULE: ./ui/components/Search/SearchForm.tsx
























var SearchForm = function(param) {
    var darkMode = param.darkMode;
    var ref, ref1, ref2, ref3, ref4;
    var t = (0,useTranslations/* useTranslate */.qM)();
    var router = (0,next_router.useRouter)();
    var ref5 = (0,useSiteConfig/* useSiteConfig */.N)(), localizeUrlPath = ref5.localizeUrlPath, charactersNeededToSubmitSearch = ref5.charactersNeededToSubmitSearch, searchSymbolsMinValue = ref5.searchSymbolsMinValue, countryCode = ref5.countryCode;
    var ref6 = (0,useMainNav/* useMainNavContext */.QH)(), setIsSearchFormOpen = ref6.setIsSearchFormOpen, isSearchFormOpen = ref6.isSearchFormOpen;
    var location = (0,useLocation/* useLocation */.TH)().location;
    var ref7 = (0,react.useState)(""), searchTerm = ref7[0], setSearchTerm = ref7[1];
    var ref8 = (0,react.useState)(""), debouncedSearchTerm = ref8[0], setDebouncedSearchTerm = ref8[1];
    var ref9 = (0,react.useState)(false), hasSubmittedSearch = ref9[0], setHasSubmittedSearch = ref9[1];
    var ref10 = (0,react.useState)(true), loading1 = ref10[0], setLoading1 = ref10[1];
    var ref11 = (0,react.useState)(true), loading2 = ref11[0], setLoading2 = ref11[1];
    (0,a11y/* useBodyScrollLock */.yn)(isSearchFormOpen);
    var getComponentsForScenario = function(scenario) {
        switch(scenario){
            case SearchViewScenario.NewUser:
                return [
                    Views_TrendingSearchTerms,
                    Views_RecommendedProducts
                ];
            case SearchViewScenario.SearchResults:
                if (searchTerm) {
                    return [
                        Views_SuggestedSearchTerms,
                        Views_SuggestedProducts
                    ];
                }
                return [
                    Views_TrendingSearchTerms,
                    Views_RecommendedProducts
                ];
            case SearchViewScenario.ReturningUser:
                if (searchTerm) {
                    return [
                        Views_SuggestedSearchTerms,
                        Views_SuggestedProducts
                    ];
                }
                return [
                    Views_TrendingSearchTerms,
                    Views_RecentlyViewedProducts
                ];
        }
    };
    var handleSearchFlyoutOpenChange = function(newOpenState) {
        if (!isSearchFormOpen && newOpenState) {
            (0,analytics/* event */.B)(analytics/* AnalyticsEvents.SEARCH_MODAL_IMPRESSION */._q.SEARCH_MODAL_IMPRESSION);
            (0,analytics/* event */.B)(analytics/* AnalyticsEvents.GA4_CustomEvent */._q.GA4_CustomEvent, {
                event_name: analytics/* AnalyticsEvents.SEARCH_OPEN */._q.SEARCH_OPEN,
                event_params: {
                    search_type: analytics/* SearchType.regular */.Sc.regular
                }
            });
        }
        setIsSearchFormOpen(newOpenState);
    };
    var debounceSearchTerm = (0,debounce/* debounce */.D)(setDebouncedSearchTerm, SEARCH_DEBOUNCE_MS);
    var handleChange = function(value) {
        // `setSearchTerm` updates the value for the controlled search input component,
        // whereas the `debounceSearchTerm` will debounce actually invoking the search
        setSearchTerm(value);
        debounceSearchTerm(value);
    };
    var recentlyViewedProducts = (0,useProductHistory/* useProductHistory */.Xd)().recentlyViewedProducts;
    // a search term is considered valid if it contains the minimum number of characters
    // required for the region
    var hasValidSearchTerm = debouncedSearchTerm.length >= searchSymbolsMinValue;
    var searchViewScenario = (0,react.useMemo)(function() {
        return getSearchViewScenario(recentlyViewedProducts, hasValidSearchTerm);
    }, [
        recentlyViewedProducts,
        hasValidSearchTerm
    ]);
    var ref12 = (0,_sliced_to_array/* default */.Z)((0,graphql/* useSuggestionsQuery */.Zcv)({
        variables: {
            searchTerm: debouncedSearchTerm
        },
        pause: !hasValidSearchTerm
    }), 1), suggestionsResult = ref12[0];
    var setSessionStorageData = (0,react.useCallback)(function(suggestedSectionClick, suggestedElement, redirect) {
        window.sessionStorage.setItem("search_type", analytics/* SearchType.regular */.Sc.regular);
        window.sessionStorage.setItem("suggested_section_click", suggestedSectionClick);
        if (searchTerm !== "") window.sessionStorage.setItem("search_term", searchTerm);
        if (suggestedElement) window.sessionStorage.setItem("suggested_element_click", suggestedElement);
        window.sessionStorage.setItem("user_action", redirect ? "redirect" : "noredirect");
    }, [
        searchTerm
    ]);
    (0,react.useEffect)(function() {
        if (hasSubmittedSearch && !suggestionsResult.fetching && searchTerm === debouncedSearchTerm) {
            if (searchTerm && searchTerm.length >= charactersNeededToSubmitSearch) {
                var ref, ref1, ref2;
                (0,bloomreach/* trackSearchEventInBloomreach */.Xq)({
                    query: searchTerm,
                    siteCountryCode: countryCode,
                    visitorCountryCode: location === null || location === void 0 ? void 0 : (ref = location.userCountry) === null || ref === void 0 ? void 0 : ref.id
                });
                var redirect = (ref1 = suggestionsResult.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.suggestions) === null || ref2 === void 0 ? void 0 : ref2.suggestedRedirect;
                if (redirect) {
                    setSessionStorageData("enter/search button", undefined, true);
                    if (redirect.startsWith("https")) window.location.href = redirect;
                    else router.replace(localizeUrlPath(redirect));
                } else {
                    setSessionStorageData("enter/search button");
                    router.push(localizeUrlPath("/search?q=".concat(encodeURIComponent(searchTerm))));
                }
                setIsSearchFormOpen(false);
                setHasSubmittedSearch(false);
            }
        }
    }, [
        hasSubmittedSearch,
        suggestionsResult,
        searchTerm,
        debouncedSearchTerm,
        charactersNeededToSubmitSearch,
        countryCode,
        location === null || location === void 0 ? void 0 : (ref = location.userCountry) === null || ref === void 0 ? void 0 : ref.id,
        router,
        localizeUrlPath,
        setSessionStorageData,
        setIsSearchFormOpen, 
    ]);
    (0,react.useEffect)(function() {
        if (!router.pathname.includes("/[country]/[language]/search")) {
            setSearchTerm("");
        }
    }, [
        router.pathname
    ]);
    var ref13 = (0,_sliced_to_array/* default */.Z)(getComponentsForScenario(searchViewScenario), 2), TermListComponent = ref13[0], ProductListComponent = ref13[1];
    // if either of the search views are loading data or we have submitted the search query
    // then show the loading indicator
    var loading = loading1 || loading2 || hasSubmittedSearch;
    var hasNoResults = hasValidSearchTerm && !loading && !((ref1 = suggestionsResult.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.suggestions) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.suggestedProductsSummaries) === null || ref3 === void 0 ? void 0 : ref3.length);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* SearchRoot */.dW3, {
        dataTestId: "search-flyout",
        name: t("search"),
        label: t("search"),
        placeholder: (ref4 = t("searchPuma")) === null || ref4 === void 0 ? void 0 : ref4.toUpperCase(),
        open: isSearchFormOpen,
        onOpenChange: handleSearchFlyoutOpenChange,
        value: searchTerm,
        onChange: handleChange,
        onSubmit: function(e) {
            e.preventDefault();
            if (searchTerm && searchTerm.length >= charactersNeededToSubmitSearch) {
                setHasSubmittedSearch(true);
            }
        },
        loading: loading,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* SearchTrigger */.OaK, {
                className: "hidden xl:flex",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Button */.zxk, {
                    "data-test-id": "search-button-nav",
                    mode: "text",
                    label: t("search"),
                    icon: "search",
                    className: "mx-3",
                    invert: darkMode,
                    variant: "secondary"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* SearchTrigger */.OaK, {
                className: "xl:hidden",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Button */.zxk, {
                    "data-test-id": "search-icon-nav",
                    mode: "icon",
                    label: t("search"),
                    icon: "search",
                    invert: darkMode,
                    variant: "ghost"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* SearchContent */.jzu, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* SearchListbox */.qdA, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "relative text-neutral min-h-[500px]",
                        "data-test-id": searchViewScenario,
                        children: [
                            hasNoResults && /*#__PURE__*/ (0,jsx_runtime.jsx)(Search_NoResultsMessage, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col lg:flex-row gap-8",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "lg:flex-[1]",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TermListComponent, {
                                            recentlyViewedProducts: recentlyViewedProducts,
                                            searchTerm: debouncedSearchTerm,
                                            suggestionsResult: suggestionsResult,
                                            setIsLoading: setLoading1,
                                            setSessionStorageData: setSessionStorageData
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "lg:flex-[2]",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductListComponent, {
                                            recentlyViewedProducts: recentlyViewedProducts,
                                            searchTerm: debouncedSearchTerm,
                                            suggestionsResult: suggestionsResult,
                                            setIsLoading: setLoading2,
                                            setSessionStorageData: setSessionStorageData
                                        })
                                    })
                                ]
                            }),
                            loading && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "absolute flex items-center top-0 left-0 w-full h-full min-h-[500px] bg-white",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Search_SearchLoadingIndicator, {})
                            })
                        ]
                    })
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./hooks/useAvailableNavItemFilter.ts
var useAvailableNavItemFilter = __webpack_require__(6781);
// EXTERNAL MODULE: ./ui/forms/AuthenticateForm.tsx + 2 modules
var AuthenticateForm = __webpack_require__(8165);
// EXTERNAL MODULE: ./hooks/useFeature.ts
var useFeature = __webpack_require__(53625);
// EXTERNAL MODULE: ./ui/forms/OTPForm.tsx + 4 modules
var OTPForm = __webpack_require__(83688);
// EXTERNAL MODULE: ./hooks/useDeviceInteraction.tsx
var useDeviceInteraction = __webpack_require__(16643);
;// CONCATENATED MODULE: ./ui/components/hoverIntent.tsx





var HoverIntent = function(_param) {
    var _enterWait = _param.enterWait, enterWait = _enterWait === void 0 ? 200 : _enterWait, _leaveWait = _param.leaveWait, leaveWait = _leaveWait === void 0 ? 200 : _leaveWait, enterCallback = _param.enterCallback, leaveCallback = _param.leaveCallback, tmp = _param.component, ComponentProp = tmp === void 0 ? "div" : tmp, children = _param.children, otherProps // apply any remaining props to the specified root component
     = (0,_object_without_properties/* default */.Z)(_param, [
        "enterWait",
        "leaveWait",
        "enterCallback",
        "leaveCallback",
        "component",
        "children"
    ]);
    var isEnterEnvoked = (0,react.useRef)(false);
    var enterTimer = (0,react.useRef)();
    var leaveTimer = (0,react.useRef)();
    var cancelEnterTimer = (0,react.useCallback)(function() {
        clearTimeout(enterTimer.current);
    }, [
        enterTimer
    ]);
    var cancelLeaveTimer = (0,react.useCallback)(function() {
        clearTimeout(leaveTimer.current);
    }, [
        leaveTimer
    ]);
    var handleMouseEnter = (0,react.useCallback)(function() {
        cancelLeaveTimer();
        enterTimer.current = window.setTimeout(function() {
            enterCallback();
            isEnterEnvoked.current = true;
        }, enterWait);
    }, [
        cancelLeaveTimer,
        enterCallback,
        enterWait,
        ComponentProp
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    var handelMouseLeave = (0,react.useCallback)(function() {
        cancelEnterTimer();
        leaveTimer.current = window.setTimeout(function() {
            if (isEnterEnvoked.current) {
                leaveCallback();
                isEnterEnvoked.current = false;
            }
        }, leaveWait);
    }, [
        cancelEnterTimer,
        leaveCallback,
        leaveWait,
        ComponentProp
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    (0,react.useEffect)(function() {
        return function() {
            cancelEnterTimer();
            cancelLeaveTimer();
        };
    }, [
        cancelEnterTimer,
        cancelLeaveTimer
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ComponentProp, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handelMouseLeave
    }, otherProps), {
        children: children
    }));
};

// EXTERNAL MODULE: ./hooks/useAvailableSpace.ts
var useAvailableSpace = __webpack_require__(75073);
// EXTERNAL MODULE: ./utils/urls.ts
var urls = __webpack_require__(90901);
;// CONCATENATED MODULE: ./ui/components/MainNav/NavCategoryNavChildren.tsx







var NavCategoryNavChildren = function(props) {
    var query = (0,next_router.useRouter)().query;
    var navMenuColors = {
        black: "text-puma-black-300 hover:text-puma-gold",
        red: "text-puma-red hover:text-puma-gold",
        gold: "text-puma-gold hover:text-puma-gold-light"
    };
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
        className: "w-1/5 min-w-48 flex flex-col pr-8 space-y-1",
        role: "menu",
        "aria-label": props.title,
        children: props.navChildren.map(function(child) {
            var ref1, ref2;
            /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                role: "none",
                className: "whitespace-normal",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                    "data-link-name": child.label,
                    "data-link-location": "top-nav-level-2-side",
                    "data-test-id": "top-nav-level-2-side",
                    role: "menuitem",
                    href: (ref = (ref1 = child.link) === null || ref1 === void 0 ? void 0 : ref1.href) !== null && ref !== void 0 ? ref : "/",
                    query: (ref2 = child.link) === null || ref2 === void 0 ? void 0 : ref2.query,
                    absoluteForCrawlers: true,
                    className: (0,css.tw)((0,urls/* isUrlSegment */.xy)(child.link, query === null || query === void 0 ? void 0 : query.category) ? "text-puma-gold" : navMenuColors[child.navColor || "black"], "font-bold text-lg leading-6 whitespace-normal"),
                    onClick: function() {
                        (0,analytics/* categoryHeaderNavigationEvent */.z2)(child);
                        (0,analytics/* headerNavigationClickEvent */.Z8)(child);
                    },
                    children: child.label
                })
            }, child.id);
        })
    });
};

;// CONCATENATED MODULE: ./ui/components/MainNav/NavCategorySubCategoriesInline.tsx







var arrayToColumns = function(input, itemsPerColumn) {
    return input.reduce(function(columns, item, index) {
        var columnIndex = Math.floor(index / itemsPerColumn);
        if (!columns[columnIndex]) {
            columns[columnIndex] = []; // start a new chunk
        }
        columns[columnIndex].push(item);
        return columns;
    }, []);
};
var NavCategorySubCategoriesInline = function(param) {
    var categories = param.categories, title = param.title;
    var query = (0,next_router.useRouter)().query;
    var categoryColumns = (0,react.useMemo)(function() {
        return arrayToColumns(categories, 4);
    }, [
        categories
    ]);
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
        className: (0,css.tw)([
            "ml-2 p-2 w-full flex flex-row flex-wrap"
        ]),
        role: "menu",
        "aria-label": title,
        children: categoryColumns.map(function(column, i) {
            /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                className: "w-1/5 min-w-48 flex-shrink-0 pr-8 pb-6",
                role: "none",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    role: "menu",
                    children: column.map(function(category) {
                        var ref1, ref2;
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                            role: "none",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                                "data-link-location": "top-nav-level-3",
                                "data-test-id": "top-nav-level-3",
                                "data-link-name": category.label,
                                role: "menuitem",
                                href: (ref = (ref1 = category.link) === null || ref1 === void 0 ? void 0 : ref1.href) !== null && ref !== void 0 ? ref : "/",
                                query: (ref2 = category.link) === null || ref2 === void 0 ? void 0 : ref2.query,
                                absoluteForCrawlers: true,
                                className: (0,css.tw)((0,urls/* isUrlSegment */.xy)(category.link, query === null || query === void 0 ? void 0 : query.category) ? "text-puma-black" : "text-puma-black-300 hover:text-puma-black", "text-base leading-6"),
                                onClick: function() {
                                    (0,analytics/* categoryHeaderNavigationEvent */.z2)(category);
                                    (0,analytics/* headerNavigationClickEvent */.Z8)(category);
                                },
                                children: category.label
                            })
                        }, category.id);
                    })
                })
            }, i);
        })
    });
};

;// CONCATENATED MODULE: ./ui/components/MainNav/NavCategorySubCategoriesColumns.tsx








var DEFAULT_COLUMN_COUNT = 5;
var REM_FOR_COLUMN = 48;
var NavCategorySubCategoriesColumns = function(param) {
    var categories = param.categories;
    var query = (0,next_router.useRouter)().query;
    var navCategoryMaxColumnCount = (0,useSiteConfig/* useSiteConfig */.N)().navCategoryMaxColumnCount;
    var countColumn = typeof navCategoryMaxColumnCount === "number" && categories.length >= navCategoryMaxColumnCount ? navCategoryMaxColumnCount : DEFAULT_COLUMN_COUNT;
    var ref, ref1, ref2;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: categories.map(function(category) {
            var ref3, ref4;
            /*#__PURE__*/ return (0,jsx_runtime.jsxs)("ul", {
                className: "w-1/".concat(countColumn, " min-w-").concat(REM_FOR_COLUMN / countColumn, " flex-shrink-0 pr-5"),
                role: "menu",
                "aria-label": category.label,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: "border-b-2 mb-2 border-puma-black pb-2",
                        role: "none",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                            role: "menuitem",
                            "data-link-name": category.label,
                            "data-link-location": "top-nav-level-2-top",
                            "data-test-id": "top-nav-level-2-top",
                            href: (ref = (ref3 = category.link) === null || ref3 === void 0 ? void 0 : ref3.href) !== null && ref !== void 0 ? ref : "/",
                            query: (ref4 = category.link) === null || ref4 === void 0 ? void 0 : ref4.query,
                            absoluteForCrawlers: true,
                            className: (0,css.tw)((0,urls/* isUrlSegment */.xy)(category.link, query === null || query === void 0 ? void 0 : query.category) ? "text-puma-gold" : "text-puma-black hover:text-puma-gold", "pb-0.5 text-lg font-bold"),
                            onClick: function() {
                                (0,analytics/* categoryHeaderNavigationEvent */.z2)(category);
                                (0,analytics/* headerNavigationClickEvent */.Z8)(category);
                            },
                            children: category.label
                        })
                    }),
                    category.children && category.children.map(function(subcategory) {
                        var ref, ref3, ref4;
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(react.Fragment, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                role: "none",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                                        role: "menuitem",
                                        "data-link-name": subcategory.label,
                                        "data-link-location": "top-nav-level-3",
                                        "data-test-id": "top-nav-level-3",
                                        href: (ref1 = (ref = subcategory.link) === null || ref === void 0 ? void 0 : ref.href) !== null && ref1 !== void 0 ? ref1 : "/",
                                        query: (ref3 = subcategory.link) === null || ref3 === void 0 ? void 0 : ref3.query,
                                        absoluteForCrawlers: true,
                                        className: (0,css.tw)("text-base py-1 leading-6", (0,urls/* isUrlSegment */.xy)(subcategory.link, query === null || query === void 0 ? void 0 : query.category) ? "text-puma-black" : "text-puma-black-300 hover:text-puma-black", (category === null || category === void 0 ? void 0 : (ref4 = category.children) === null || ref4 === void 0 ? void 0 : ref4.find(function(child) {
                                            return child.children && child.children.length > 0;
                                        })) && "block font-bold"),
                                        onClick: function() {
                                            (0,analytics/* categoryHeaderNavigationEvent */.z2)(subcategory);
                                            (0,analytics/* headerNavigationClickEvent */.Z8)(subcategory);
                                        },
                                        children: subcategory.label
                                    }),
                                    subcategory.children && subcategory.children.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                        className: "pt-1 pb-2",
                                        role: "menu",
                                        children: subcategory.children.map(function(subsubcategory) {
                                            var ref, ref1;
                                            /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                                                role: "none",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                                                    role: "menuitem",
                                                    "data-link-name": subsubcategory.label,
                                                    "data-link-location": "top-nav-level-4",
                                                    "data-test-id": "top-nav-level-4",
                                                    href: (ref2 = (ref = subsubcategory.link) === null || ref === void 0 ? void 0 : ref.href) !== null && ref2 !== void 0 ? ref2 : "/",
                                                    query: (ref1 = subsubcategory.link) === null || ref1 === void 0 ? void 0 : ref1.query,
                                                    absoluteForCrawlers: true,
                                                    className: (0,css.tw)("text-base px-6 py-1 leading-6", (0,urls/* isUrlSegment */.xy)(subsubcategory.link, query === null || query === void 0 ? void 0 : query.category) ? "text-puma-black" : "text-puma-black-300 hover:text-puma-black"),
                                                    onClick: function() {
                                                        (0,analytics/* categoryHeaderNavigationEvent */.z2)(subsubcategory);
                                                        (0,analytics/* headerNavigationClickEvent */.Z8)(subsubcategory);
                                                    },
                                                    children: subsubcategory.label
                                                })
                                            }, subsubcategory.id);
                                        })
                                    })
                                ]
                            })
                        }, subcategory.id);
                    })
                ]
            }, category.id);
        })
    });
};

// EXTERNAL MODULE: ./ui/components/MainNav/MainNavSkeleton.tsx
var MainNavSkeleton = __webpack_require__(72805);
;// CONCATENATED MODULE: ./ui/components/MainNav/NavCategorySubMenu.tsx









var extractCategoriesWithSubCategories = function(category) {
    return ((category === null || category === void 0 ? void 0 : category.children) || []).filter(function(subCategory) {
        return subCategory.children && subCategory.children.length > 0;
    });
};
var extractCategoriesWithoutSubCategories = function(category) {
    return ((category === null || category === void 0 ? void 0 : category.children) || []).filter(function(subCategory) {
        return !subCategory.children || subCategory.children.length === 0;
    });
};
var NavCategorySubMenu = function(props) {
    var ref, ref1, ref2, ref3;
    var ariaSelected = props.ariaSelected, category = props.category, ownerRef = props.ownerRef, subMenuItems = props.subMenuItems;
    var categoryRef = (0,react.useRef)(null);
    var ref4 = (0,useMainNav/* useMainNavContext */.QH)(), selectedCategory = ref4.selectedCategory, showSubMenu = ref4.showSubMenu, handleCategoryClick = ref4.handleCategoryClick;
    var isMatchingCategory = selectedCategory === category.id;
    var subNavItems = (subMenuItems === null || subMenuItems === void 0 ? void 0 : (ref = subMenuItems.children) === null || ref === void 0 ? void 0 : ref.filter(function(item) {
        return item.id === category.id;
    })) || [];
    (0,a11y/* useListboxFocus */.ii)(categoryRef, {
        isActive: true,
        ownerRef: ownerRef
    });
    var categoriesWithSubCategories = extractCategoriesWithSubCategories(subNavItems[0]);
    var categoriesWithoutSubCategories = extractCategoriesWithoutSubCategories(subNavItems[0]);
    var cats = categoriesWithSubCategories.length === 0 ? categoriesWithoutSubCategories : categoriesWithSubCategories;
    var keyboardNavigableMenuStyles = "scale-y-100 opacity-100";
    var mouseNavigableMenuStyles = "transition-[transform,opacity] duration-0 ".concat(showSubMenu && isMatchingCategory ? "scale-y-100 z-10" : "scale-y-0 z-0");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,css.tw)("scale-y-100 opacity-100 absolute left-0 bottom-0 origin-top translate-y-full bg-white flex w-full text-puma-black-400 overflow-x-auto shadow-xl py-10 xl:py-12", ariaSelected ? keyboardNavigableMenuStyles : mouseNavigableMenuStyles),
        role: "menu",
        onClick: function() {
            return handleCategoryClick(category.id);
        },
        "data-test-id": "secondary-nav-menu",
        ref: categoryRef,
        children: [
            !(subMenuItems === null || subMenuItems === void 0 ? void 0 : subMenuItems.children) && /*#__PURE__*/ (0,jsx_runtime.jsx)(MainNavSkeleton/* MainNavSkeleton */.B, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex w-full max-w-screen-3xl mx-auto px-10",
                children: [
                    subNavItems && ((ref1 = subNavItems[0]) === null || ref1 === void 0 ? void 0 : ref1.navChildren) && /*#__PURE__*/ (0,jsx_runtime.jsx)(NavCategoryNavChildren, {
                        navChildren: (ref2 = subNavItems[0]) === null || ref2 === void 0 ? void 0 : ref2.navChildren,
                        title: (ref3 = subNavItems[0]) === null || ref3 === void 0 ? void 0 : ref3.label
                    }),
                    categoriesWithSubCategories.length === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(NavCategorySubCategoriesInline, {
                        categories: cats,
                        title: category.label
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(NavCategorySubCategoriesColumns, {
                        categories: cats
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./ui/components/MainNav/NavMenuBar.tsx










var NavMenuBar = function(props) {
    var categories = props.categories;
    var navListRef = (0,react.useRef)(null);
    var ref = (0,useAvailableSpace/* default */.Z)(navListRef, categories), calculated = ref.calculated, items = ref.items;
    var hiddenItems = items.filter(function(i) {
        return i.hidden;
    });
    var shouldHideAllItems = hiddenItems.length > 0;
    var menuItems = (0,react.useRef)(categories.map(function() {
        return /*#__PURE__*/ (0,react.createRef)();
    }));
    var isKeyboardActive = (0,useDeviceInteraction/* useDeviceInteraction */.u)().isKeyboardActive;
    var ref1 = (0,useMainNav/* useMainNavContext */.QH)(), setShowSubMenu = ref1.setShowSubMenu, selectedCategory = ref1.selectedCategory, clickedCategory = ref1.clickedCategory, setSelectedCategory = ref1.setSelectedCategory, handleCategoryClick = ref1.handleCategoryClick, subMenuItems = ref1.subMenuItems;
    var handleKeydown = (0,react.useCallback)(function(event, categoryId) {
        if (event.key === "ArrowDown") {
            setSelectedCategory(categoryId);
        }
    }, [
        setSelectedCategory
    ]);
    (0,react.useEffect)(function() {
        var handleKeyPress = function(event) {
            // Close menu on escape
            if (event.key === "Escape" && selectedCategory) {
                var ref;
                setShowSubMenu(false);
                setSelectedCategory("");
                // Return focus to the parent menu item
                var currentIndex = categories.findIndex(function(cat) {
                    return cat.id === selectedCategory;
                });
                if (currentIndex >= 0 && ((ref = menuItems.current[currentIndex]) === null || ref === void 0 ? void 0 : ref.current)) {
                    var ref1;
                    (ref1 = menuItems.current[currentIndex].current) === null || ref1 === void 0 ? void 0 : ref1.focus();
                }
            }
            // Close menu on Tab key
            if (event.key === "Tab" && selectedCategory) {
                setShowSubMenu(false);
                setSelectedCategory("");
            }
        };
        document.addEventListener("keydown", handleKeyPress);
        return function() {
            document.removeEventListener("keydown", handleKeyPress);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        selectedCategory,
        categories
    ]);
    (0,react.useEffect)(function() {
        if (calculated) props.setLinksHidden(shouldHideAllItems);
    }, [
        calculated,
        shouldHideAllItems
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
        className: "flex self-stretch flex-1 items-stretch overflow-x-hidden ml-5 hover:nav-fade-non-selected",
        role: "menubar",
        ref: navListRef,
        children: categories.map(function(category, idx) {
            var ref, ref1;
            var ariaSelected = isKeyboardActive && category.id === selectedCategory;
            var ref2;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                "data-test-id": "main-nav-category-item",
                role: "none",
                className: (0,css.tw)("group whitespace-nowrap flex", shouldHideAllItems && "invisible"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HoverIntent, {
                    className: "flex self-stretch hover:nav-fade-non-selected",
                    enterCallback: function() {
                        var ref;
                        if (category.children && ((ref = category.children) === null || ref === void 0 ? void 0 : ref.length) > 0 || category.navChildren && category.navChildren.length > 0) {
                            setShowSubMenu(true);
                            setSelectedCategory(category.id);
                        }
                    },
                    leaveCallback: function() {
                        setShowSubMenu(false);
                        setSelectedCategory("");
                    },
                    "data-test-id": "hoverable-nav-item",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex-1 flex relative",
                            role: "menuitem",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                                "data-link-name": category.label,
                                "data-link-location": "top-nav-level-1",
                                onKeyDown: function(event) {
                                    return handleKeydown(event, category.id);
                                },
                                "aria-haspopup": true,
                                "aria-expanded": ariaSelected,
                                href: (ref2 = (ref = category.link) === null || ref === void 0 ? void 0 : ref.href) !== null && ref2 !== void 0 ? ref2 : "/",
                                query: (ref1 = category.link) === null || ref1 === void 0 ? void 0 : ref1.query,
                                variant: "white",
                                ref: menuItems.current[idx],
                                absoluteForCrawlers: true,
                                className: (0,css.tw)("transition-opacity flex items-center self-stretch px-4 font-bold"),
                                onClick: function() {
                                    (0,analytics/* categoryHeaderNavigationEvent */.z2)(category);
                                    (0,analytics/* headerNavigationClickEvent */.Z8)(category);
                                    handleCategoryClick(category.id);
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (0,css.tw)("text-base block mt-1 pb-1 whitespace-nowrap nav-underline", ariaSelected || clickedCategory === category.id ? "nav-underline-selected" : "nav-underline-selected(group-hover:& group-focus:&)"),
                                    children: category.label
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NavCategorySubMenu, {
                            category: category,
                            ariaSelected: ariaSelected,
                            ownerRef: menuItems.current[idx],
                            subMenuItems: subMenuItems
                        })
                    ]
                })
            }, category.id);
        })
    });
};

// EXTERNAL MODULE: ./hooks/useSimpleCart.tsx
var useSimpleCart = __webpack_require__(85914);
// EXTERNAL MODULE: ./ui/components/MainNav/ItemCountBadge.tsx
var ItemCountBadge = __webpack_require__(3629);
;// CONCATENATED MODULE: ./ui/components/MainNav/CartLink.tsx








var CartLink = function(props) {
    var t = (0,useTranslations/* useTranslate */.qM)();
    var localizeUrlPath = (0,useSiteConfig/* useSiteConfig */.N)().localizeUrlPath;
    var isCrawler = (0,useIsCrawler/* useIsCrawler */.i)();
    var cart = (0,useSimpleCart/* useSimpleCart */.r)().cart;
    var count = (cart === null || cart === void 0 ? void 0 : cart.productCount) || 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Link */.rUS, {
                href: isCrawler ? localizeUrlPath("/cart", true) : "/cart",
                className: "relative",
                id: "nav-cart-link",
                dataTestId: "nav-cart-link",
                onClick: props.onClick,
                label: "".concat(t("shoppingCart"), " ").concat(count),
                icon: "cart",
                mode: "icon",
                variant: "ghost",
                invert: props.darkMode
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemCountBadge/* ItemCountBadge */.K, {
                float: true,
                count: count,
                dataTestId: "nav-cart-tally-badge"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./ui/components/MainNav/PhoneNavLink.tsx






var PhoneNavLink = function(props) {
    var t = (0,useTranslations/* useTranslate */.qM)();
    var showPhoneInCheckout = (0,useFeature/* useFeature */.S)("CAN_SHOW_PHONEICON_IN_CHECKOUT");
    var ref = (0,useSiteConfig/* useSiteConfig */.N)(), phoneAnchorNumberInCheckout = ref.phoneAnchorNumberInCheckout, phoneTextNumberInCheckout = ref.phoneTextNumberInCheckout;
    var ref1 = (0,react.useState)(false), showNumber = ref1[0], toggleShowNumber = ref1[1];
    if (!showPhoneInCheckout || !phoneAnchorNumberInCheckout || !phoneTextNumberInCheckout) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Link */.rUS, {
                href: phoneAnchorNumberInCheckout,
                label: t("phone"),
                className: "md:hidden",
                mode: "icon",
                icon: "phone",
                variant: "ghost",
                invert: props.darkMode
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Button */.zxk, {
                className: "hidden md:flex",
                dataTestId: "main-nav-phone-button",
                onClick: function() {
                    return toggleShowNumber(!showNumber);
                },
                label: showNumber ? phoneTextNumberInCheckout : t("phone"),
                icon: showNumber ? undefined : "phone",
                mode: showNumber ? "text" : "icon",
                variant: "ghost",
                invert: props.darkMode
            })
        ]
    });
};

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(19989);
;// CONCATENATED MODULE: ./ui/components/MainNav/WishlistLink.tsx


function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    animation: dotPulse 600ms ease-in-out;\n    @keyframes dotPulse {\n      0% {\n        transform: scale(1);\n      }\n      50% {\n        transform: scale(1.25);\n      }\n      100% {\n        transform: scale(1);\n      }\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}











var WishlistLink = function(props) {
    var ref;
    var t = (0,useTranslations/* useTranslate */.qM)();
    var auth = (0,useAuth/* useAuth */.aC)();
    var localizeUrlPath = (0,useSiteConfig/* useSiteConfig */.N)().localizeUrlPath;
    var isCrawler = (0,useIsCrawler/* useIsCrawler */.i)();
    var isServer = (0,useIsServer/* useIsServer */.w)();
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,graphql/* useWishListTotalsQuery */.xyt)({
        pause: !!auth.guest || isServer
    }), 1), wishlist = ref1[0];
    var count = ((ref = wishlist.data) === null || ref === void 0 ? void 0 : ref.wishList.items.length) || 0;
    var ref2 = (0,react.useState)(false), animate = ref2[0], setAnimate = ref2[1];
    var handleWishlistButton = function() {
        setAnimate(true);
        setTimeout(function() {
            setAnimate(false);
        }, 500);
    };
    (0,react.useEffect)(function() {
        window.addEventListener("PRODUCT_WISHLIST_BUTTON_CLICKED", handleWishlistButton);
        return function() {
            window.removeEventListener("PRODUCT_WISHLIST_BUTTON_CLICKED", handleWishlistButton);
        };
    }, []);
    var dotPulse = (0,css/* css */.iv)(_templateObject());
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Link */.rUS, {
                href: isCrawler ? localizeUrlPath("/wishlist", true) : "/wishlist",
                id: "nav-wishlist-link",
                label: "".concat(t("wishlist"), " ").concat(count),
                onClick: props.onClick,
                icon: "heart",
                mode: "icon",
                variant: "ghost",
                invert: props.darkMode
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemCountBadge/* ItemCountBadge */.K, {
                float: true,
                count: count,
                dataTestId: "nav-wishlist-tally-badge",
                className: (0,css.tw)(animate && dotPulse)
            })
        ]
    });
};

// EXTERNAL MODULE: ./ui/components/MainNav/PopoverForm.tsx
var PopoverForm = __webpack_require__(234);
;// CONCATENATED MODULE: ./ui/components/MainNav/MainNav.tsx


























var QuickLinks = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1957).then(__webpack_require__.bind(__webpack_require__, 91957));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(91957)
            ];
        }
    },
    ssr: false
});
var MobileMenuScreen = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 3750).then(__webpack_require__.bind(__webpack_require__, 83750));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(83750)
            ];
        }
    },
    ssr: false
});
var handleClickHome = function() {
    var parentNavigation = "Home";
    (0,analytics/* headerNavigationEvent */.n4)({
        parentNavigation: parentNavigation
    });
    (0,analytics/* navigationEvent */.f)({
        event_name: analytics/* AnalyticsEvents.NAVIGATION_CLICK */._q.NAVIGATION_CLICK,
        user_action: "header",
        nav_path: parentNavigation.toLocaleLowerCase()
    });
};
var HomeButton = function(param) {
    var shouldCenterIcon = param.shouldCenterIcon;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
        className: shouldCenterIcon ? "absolute left-1/2 -translate-x-1/2" : "block",
        "data-link-name": "puma-logo",
        "data-link-location": "top-nav",
        "data-test-id": "main-nav-home-link",
        href: "/",
        absoluteForCrawlers: true,
        onClick: function() {
            return handleClickHome();
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Icon */.JO$, {
            name: "puma-logo",
            size: shouldCenterIcon ? "5xl" : "4xl",
            label: "PUMA.com"
        })
    });
};
var MainNav = function(props) {
    var isServer = (0,useIsServer/* useIsServer */.w)();
    var t = (0,useTranslations/* useTranslate */.qM)();
    var router = (0,next_router.useRouter)();
    var localizeUrlPath = (0,useSiteConfig/* useSiteConfig */.N)().localizeUrlPath;
    var ref = (0,react.useState)(undefined), linksHidden = ref[0], setLinksHidden = ref[1];
    var hideNavChildren = !props.minimal && linksHidden === undefined;
    var ref1 = (0,useResizeObserver/* useResizeObserver */.y)(), width = ref1.width, height = ref1.height;
    var ref2 = (0,useSticky/* useSticky */.A)(1), stickyRef = ref2.stickyRef, stickyCss = ref2.stickyCss, combinedHeightByOrdinal = ref2.combinedHeightByOrdinal;
    var ref3 = (0,useMainNav/* useMainNavContext */.QH)(), mobileMenuOpen = ref3.mobileMenuOpen, setMobileMenuOpen = ref3.setMobileMenuOpen, navLinks = ref3.navLinks, isRegisterOpen = ref3.isRegisterOpen, setRegisterOpen = ref3.setRegisterOpen, isLoginOpen = ref3.isLoginOpen, setLoginOpen = ref3.setLoginOpen, setForgotPasswordFormOpen = ref3.setForgotPasswordFormOpen, isForgotPasswordFormOpen = ref3.isForgotPasswordFormOpen, setIsSearchFormOpen = ref3.setIsSearchFormOpen;
    var ref4 = (0,useLiveChat/* useLiveChat */.b)(), openLiveChatWindow = ref4.openLiveChatWindow, liveChatEnabled = ref4.liveChatEnabled, renderInMainNav = ref4.renderInMainNav;
    var ref5 = (0,react.useState)(false), accountMenuOpen = ref5[0], setAccountMenuOpen = ref5[1];
    var ref6 = (0,react.useState)(true), darkMode = ref6[0], setDarkMode = ref6[1];
    var isOTPAuthEnabled = (0,useFeature/* useFeature */.S)("OTP_LOGIN");
    var popoverLoginEnabledJP = (0,useFeature/* useFeature */.S)("POPOVER_LOGIN_ENABLED_JP");
    var availableNavItems = (0,useAvailableNavItemFilter/* useAvailableNavItemFilter */.C)(navLinks, (0,useGroqQuery/* groqPreviewInput */.i8)(router.query));
    var categories = (availableNavItems === null || availableNavItems === void 0 ? void 0 : availableNavItems.children) || [];
    var userMenuQuicklinks = (navLinks === null || navLinks === void 0 ? void 0 : navLinks.userMenuQuicklinks) || [];
    var setMainNavState = function(param) {
        var _mobileMenuOpen = param.mobileMenuOpen, mobileMenuOpen = _mobileMenuOpen === void 0 ? false : _mobileMenuOpen, _darkMode = param.darkMode, darkMode = _darkMode === void 0 ? true : _darkMode, _loginOpen = param.loginOpen, loginOpen = _loginOpen === void 0 ? false : _loginOpen, _registerOpen = param.registerOpen, registerOpen = _registerOpen === void 0 ? false : _registerOpen, _accountMenuOpen = param.accountMenuOpen, accountMenuOpen = _accountMenuOpen === void 0 ? false : _accountMenuOpen, _forgotPasswordFormOpen = param.forgotPasswordFormOpen, forgotPasswordFormOpen = _forgotPasswordFormOpen === void 0 ? false : _forgotPasswordFormOpen, _searchFormOpen = param.searchFormOpen, searchFormOpen = _searchFormOpen === void 0 ? false : _searchFormOpen;
        setMobileMenuOpen(mobileMenuOpen);
        setDarkMode(darkMode);
        setLoginOpen(loginOpen);
        setRegisterOpen(registerOpen);
        setAccountMenuOpen(accountMenuOpen);
        setForgotPasswordFormOpen(forgotPasswordFormOpen);
        setIsSearchFormOpen(searchFormOpen);
    };
    (0,react.useEffect)(function() {
        setMainNavState({});
    }, [
        width,
        router
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        id: "nav-bar-sticky",
        className: (0,css.tw)("relative z-20", stickyCss),
        ref: stickyRef,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("nav", {
            "aria-label": t("mainNavLabel"),
            className: (0,css.tw)(props.minimal && "mobile:px-4 tablet:px-6 desktop:px-8", darkMode ? "bg-puma-black-100 text-white" : "bg-white text-puma-black", hideNavChildren && "children:invisible"),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (0,css.tw)("h-16 lg:h-20 flex items-center justify-between mx-auto overflow-y-visible relative", !darkMode && "border-b", props.minimal ? "max-w-screen-xl" : "max-w-screen-3xl mobile:px-4 tablet:px-6 desktop:px-8"),
                    "data-test-id": "main-nav-bar",
                    children: [
                        linksHidden && !props.minimal && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            onClick: function() {
                                setMainNavState({
                                    mobileMenuOpen: !mobileMenuOpen,
                                    darkMode: mobileMenuOpen
                                });
                                !mobileMenuOpen && (0,analytics/* mobileMenuOpenEvent */.W0)();
                            },
                            "aria-label": "button icon to open menu",
                            "data-test-id": "account-button",
                            "data-link-name": "close",
                            "data-link-location": "mobile-nav",
                            className: "flex items-center",
                            type: "button",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Icon */.JO$, {
                                "data-test-id": "main-nav-menu-icon",
                                name: mobileMenuOpen ? "close" : "menu",
                                size: "2xl"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-8 h-8",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeButton, {
                                shouldCenterIcon: linksHidden && !props.minimal
                            })
                        }),
                        !props.minimal && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(NavMenuBar, {
                                    categories: categories,
                                    setLinksHidden: setLinksHidden
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (0,css.tw)("flex items-center justify-end gap-2 w-72", !hideNavChildren && "ml-5"),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: linksHidden ? "absolute left-14 lg:left-16" : "block",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchForm, {
                                                darkMode: darkMode
                                            })
                                        }),
                                        liveChatEnabled && renderInMainNav && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Button */.zxk, {
                                            dataTestId: "chat-button",
                                            icon: "chat",
                                            onClick: function() {
                                                return openLiveChatWindow();
                                            },
                                            mode: "icon",
                                            label: ""
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: linksHidden ? "hidden" : "block",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WishlistLink, {
                                                darkMode: darkMode,
                                                onClick: function() {
                                                    (0,analytics/* iconHeaderNavigationEvent */._J)("Wishlist");
                                                    (0,analytics/* iconHeaderNavigationClickEvent */.Hb)("Wishlist");
                                                }
                                            })
                                        }),
                                        linksHidden && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Button */.zxk, {
                                            id: "account-button",
                                            label: t("myAccount"),
                                            icon: "person",
                                            variant: "ghost",
                                            mode: "icon",
                                            invert: darkMode,
                                            onClick: function() {
                                                router.push(localizeUrlPath("/account"));
                                                (0,analytics/* iconHeaderNavigationClickEvent */.Hb)("My Account");
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CartLink, {
                                            darkMode: darkMode,
                                            onClick: function() {
                                                (0,analytics/* iconHeaderNavigationEvent */._J)("Cart");
                                                (0,analytics/* iconHeaderNavigationClickEvent */.Hb)("Cart");
                                            }
                                        }),
                                        !linksHidden && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "relative",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* PopoverRoot */.PgP, {
                                                dataTestId: "quicklinks-popout",
                                                open: accountMenuOpen || isLoginOpen || isRegisterOpen,
                                                onOpenChange: function(open) {
                                                    return setMainNavState({
                                                        accountMenuOpen: open
                                                    });
                                                },
                                                autoFocus: "content",
                                                side: "bottom",
                                                align: "end",
                                                size: popoverLoginEnabledJP ? "lg" : "base",
                                                offset: -20,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* PopoverTrigger */.xol, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Button */.zxk, {
                                                            id: "account-button",
                                                            label: t("myAccount"),
                                                            icon: "person",
                                                            variant: "ghost",
                                                            mode: "icon",
                                                            invert: darkMode,
                                                            onClick: function() {
                                                                return (0,analytics/* iconHeaderNavigationClickEvent */.Hb)("My Account");
                                                            }
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* PopoverContent */.yky, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* PopoverBody */.baG, {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PopoverForm/* PopoverForm */.z, {
                                                                    action: isOTPAuthEnabled ? OTPForm/* OTPAuthStage.login */.h.login : AuthenticateForm/* AuthAction.login */.g.login,
                                                                    isOpen: isLoginOpen,
                                                                    buttonText: isOTPAuthEnabled ? t("loginOrRegisterHeader") : t("login"),
                                                                    onClose: function() {
                                                                        return setMainNavState({});
                                                                    },
                                                                    handleClick: function() {
                                                                        return setMainNavState({
                                                                            accountMenuOpen: true
                                                                        });
                                                                    }
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PopoverForm/* PopoverForm */.z, {
                                                                    action: isOTPAuthEnabled ? OTPForm/* OTPAuthStage.register */.h.register : AuthenticateForm/* AuthAction.register */.g.register,
                                                                    isOpen: isRegisterOpen,
                                                                    buttonText: t("joinUs"),
                                                                    onClose: function() {
                                                                        return setMainNavState({});
                                                                    },
                                                                    handleClick: function() {
                                                                        return setMainNavState({
                                                                            accountMenuOpen: true
                                                                        });
                                                                    }
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PopoverForm/* PopoverForm */.z, {
                                                                    action: isOTPAuthEnabled && !isLoginOpen ? OTPForm/* OTPAuthStage.reset_password */.h.reset_password : AuthenticateForm/* AuthAction.reset_password */.g.reset_password,
                                                                    isOpen: isForgotPasswordFormOpen,
                                                                    buttonText: isOTPAuthEnabled ? t("loginOrRegisterHeader") : t("login"),
                                                                    onClose: function() {
                                                                        return setMainNavState({});
                                                                    },
                                                                    handleClick: function() {
                                                                        return setMainNavState({
                                                                            loginOpen: true
                                                                        });
                                                                    }
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(QuickLinks, {
                                                                    userMenuQuicklinks: userMenuQuicklinks,
                                                                    hideMobileMenu: function() {
                                                                        return setMainNavState({
                                                                            mobileMenuOpen: false,
                                                                            accountMenuOpen: !accountMenuOpen,
                                                                            darkMode: true
                                                                        });
                                                                    },
                                                                    setLoginOpen: function() {
                                                                        return setMainNavState({
                                                                            loginOpen: true
                                                                        });
                                                                    },
                                                                    setRegisterOpen: function() {
                                                                        return setMainNavState({
                                                                            registerOpen: true
                                                                        });
                                                                    },
                                                                    onClose: function() {
                                                                        return setMainNavState({});
                                                                    }
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        props.minimal && !router.asPath.includes("showQuickRegister") && /*#__PURE__*/ (0,jsx_runtime.jsx)(PhoneNavLink, {
                            darkMode: darkMode
                        })
                    ]
                }),
                mobileMenuOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "relative flex-col flex bg-white overflow-x-hidden ".concat(isRegisterOpen || isForgotPasswordFormOpen ? "overflow-y-scroll" : "overflow-y-hidden"),
                    style: {
                        height: isServer ? "100vh" : "".concat(window.innerHeight - height - props.mobileNavOffsetPx - // Get the height of the top two (max) sticky banners
                        // ignoring the height of product filters since they
                        // are rendered below the mobile nav
                        (combinedHeightByOrdinal[1] || 0), "px")
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileMenuScreen, {
                        userMenuQuicklinks: userMenuQuicklinks,
                        isOpen: mobileMenuOpen,
                        hideMobileMenu: function() {
                            return setMainNavState({
                                mobileMenuOpen: false,
                                accountMenuOpen: !accountMenuOpen,
                                darkMode: true
                            });
                        }
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./ui/components/MainNav/index.tsx


;// CONCATENATED MODULE: ./ui/components/Header.tsx








var getBannerHeightInView = function(elem) {
    if (!elem) {
        return 0;
    }
    var bounds = elem.getBoundingClientRect();
    if (!bounds) {
        return elem.offsetHeight;
    }
    return bounds.bottom < 0 ? 0 : Math.min(bounds.bottom, bounds.height);
};
var Header = function() {
    var router = (0,next_router.useRouter)();
    // Used to provide height information to MainNav
    var globalPromoBannerRef = react.useRef(null);
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(getBannerHeightInView(globalPromoBannerRef.current)), 2), mobileNavOffset = ref[0], setMobileNavOffset = ref[1];
    var handleScroll = react.useCallback(function() {
        var amountInViewPx = getBannerHeightInView(globalPromoBannerRef.current);
        if (mobileNavOffset !== amountInViewPx) {
            setMobileNavOffset(amountInViewPx);
        }
    }, [
        mobileNavOffset
    ]);
    react.useEffect(function() {
        window.addEventListener("scroll", handleScroll, {
            passive: true
        });
        return function() {
            return window.removeEventListener("scroll", handleScroll);
        };
    }, [
        handleScroll
    ]);
    var pageType = (0,analytics/* getPageType */.C2)(router.asPath);
    var shouldHideSecondGlobalBanner = pageType === "cart" || pageType === "checkout" || pageType === "payment" || pageType === "order confirmation";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalPromoBanner, {
                ref: globalPromoBannerRef
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MainNav, {
                minimal: router.asPath.includes("/checkout") || router.asPath.includes("showQuickRegister"),
                mobileNavOffsetPx: mobileNavOffset
            }),
            !shouldHideSecondGlobalBanner && /*#__PURE__*/ (0,jsx_runtime.jsx)(SecondGlobalBanner, {})
        ]
    });
};

// EXTERNAL MODULE: ../node_modules/react-hook-form/dist/index.esm.js
var index_esm = __webpack_require__(93451);
// EXTERNAL MODULE: ./utils/merge.ts
var merge = __webpack_require__(57000);
// EXTERNAL MODULE: ./hooks/useNewsletterSignup.ts
var useNewsletterSignup = __webpack_require__(64739);
// EXTERNAL MODULE: ./types/analyticTypes.ts
var analyticTypes = __webpack_require__(90099);
;// CONCATENATED MODULE: ./ui/elements/ForterWebId.tsx




var ForterWebId_ForterWebId = function() {
    var env = (0,useSiteConfig/* useSiteConfig */.N)().env;
    var ref = (0,react.useState)(null), webIdToDisplay = ref[0], setWebIdToDisplay = ref[1];
    var handleWebIdChange = function(e) {
        setWebIdToDisplay(e.detail);
    };
    (0,react.useEffect)(function() {
        if (!env.forterSiteId) return;
        setWebIdToDisplay((0,forter/* retrieveWebId */.Zn)());
        document.addEventListener("ftr:customerWebIdReady", handleWebIdChange);
        return function() {
            document.removeEventListener("ftr:customerWebIdReady", handleWebIdChange);
        };
    }, [
        env.forterSiteId
    ]);
    if (!env.forterSiteId || !webIdToDisplay) return null;
    // formats the number to be in 3-digit groups (e.g., 000 000 000)
    var formattedWebId = (0,forter/* formatForterWebId */.Gl)(webIdToDisplay);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        "data-test-id": "forter-web-id",
        children: [
            "Web ID: ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "whitespace-nowrap",
                children: formattedWebId
            })
        ]
    });
};
/* harmony default export */ var elements_ForterWebId = (ForterWebId_ForterWebId);

// EXTERNAL MODULE: ./hooks/useStickyButton.tsx
var useStickyButton = __webpack_require__(77313);
// EXTERNAL MODULE: ./groq/queries/MainFooterQuery.ts
var MainFooterQuery = __webpack_require__(83070);
// EXTERNAL MODULE: ./ui/components/AcceptedPaymentMethods.tsx
var AcceptedPaymentMethods = __webpack_require__(77797);
;// CONCATENATED MODULE: ./ui/components/AppLinks/shared.ts
var linkClassNames = [
    "border-1 border-puma-silver rounded-lg",
    "hover:border-white hover:rounded-lg",
    "focus:border-white focus:ring-2 focus:ring-gray-50 focus:rounded-lg", 
];

;// CONCATENATED MODULE: ./ui/components/AppLinks/PumaAppLink.tsx






var PumaAppLink = function(param) {
    var onClick = param.onClick;
    var pumaAppDownloadUrl = (0,useSiteConfig/* useSiteConfig */.N)().pumaAppDownloadUrl;
    var t = (0,useTranslations/* useTranslate */.qM)();
    if (!pumaAppDownloadUrl) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
        rel: "noopener noreferrer",
        href: pumaAppDownloadUrl,
        target: "_blank",
        "data-test-id": "puma-app-footer-link",
        className: (0,twind.tw)(linkClassNames),
        onClick: onClick,
        title: t("pumaAppTitle"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Icon */.JO$, {
            name: "puma-app",
            size: "7xl",
            invert: true,
            color: "base",
            className: "p-3"
        })
    });
};

;// CONCATENATED MODULE: ./ui/components/AppLinks/PumaTracLink.tsx





var PumaTracLink = function(param) {
    var onClick = param.onClick;
    var t = (0,useTranslations/* useTranslate */.qM)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
        rel: "noopener noreferrer",
        href: "http://pumatr.ac/app",
        target: "_blank",
        "data-test-id": "puma-trac-footer-link",
        className: (0,twind.tw)(linkClassNames),
        onClick: onClick,
        title: t("tracAppTitle"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Icon */.JO$, {
            name: "puma-trac",
            size: "7xl",
            color: "base",
            invert: true,
            className: "p-3"
        })
    });
};

;// CONCATENATED MODULE: ./ui/components/AppLinks/index.ts



// EXTERNAL MODULE: ./ui/components/FooterLinks.tsx
var FooterLinks = __webpack_require__(34976);
// EXTERNAL MODULE: ./hooks/useMounted.ts
var useMounted = __webpack_require__(6364);
;// CONCATENATED MODULE: ./ui/components/NewsletterSignUpButton.tsx






var NewsletterSignUpButton = function(param) {
    var analyticsIdentifier = param.analyticsIdentifier, label = param.label, location = param.location, onClick = param.onClick, onDismiss = param.onDismiss;
    var buttonRef = (0,react.useRef)(null);
    var isMounted = (0,useMounted/* useMounted */.s)();
    (0,react.useEffect)(function() {
        if (isMounted()) {
            (0,analytics/* signUpFormAnalyticsEvent */.Sh)({
                identifier: analyticsIdentifier,
                action: analyticTypes/* SignUpActions.Impression */.ew.Impression,
                location: location
            });
        }
    }, [
        analyticsIdentifier,
        location,
        isMounted
    ]);
    var handleClick = (0,react.useCallback)(function(e) {
        var clickTarget = e.target;
        if (buttonRef.current) {
            var buttonSvg = buttonRef.current.querySelector("svg");
            var clickTargetClosestSvg = clickTarget.closest("svg");
            // we don't currently have a way to handle clicking on the icon vs. the
            // rest of the button, so we can determine that the icon was clicked
            // if the reference icon and click target icon have the same parent
            var wasCloseIconClick = buttonSvg && clickTargetClosestSvg && buttonSvg.parentElement === clickTargetClosestSvg.parentElement;
            if (wasCloseIconClick) {
                onDismiss === null || onDismiss === void 0 ? void 0 : onDismiss();
            } else {
                onClick === null || onClick === void 0 ? void 0 : onClick();
            }
        }
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "relative signup-button-appear -left-full bg-clip-border inline-block lg:mb-0 md:mb-0 transition-all duration-[1500ms]",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "signup-button-outer",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "signup-button-inner",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Button */.zxk, {
                    ref: buttonRef,
                    variant: "primary",
                    className: "pointer-events-all",
                    "data-test-id": "newsletter-sign-up-form-button",
                    label: label,
                    icon: "close",
                    iconEnd: true,
                    invert: true,
                    onClick: handleClick
                })
            })
        })
    });
};

;// CONCATENATED MODULE: ./ui/components/MainFooter.tsx





function MainFooter_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n            --radix-collapsible-content-height: auto !important;\n          "
    ]);
    MainFooter_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



























var NewsletterSignup = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(2042), __webpack_require__.e(9925)]).then(__webpack_require__.bind(__webpack_require__, 59925)).then(function(mod) {
        return mod.NewsletterSignup;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(59925)
            ];
        }
    },
    ssr: false
});
var NewsletterSignupIFrame = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1829).then(__webpack_require__.bind(__webpack_require__, 51829));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(51829)
            ];
        }
    },
    ssr: false
});
var CookieSettings = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4448).then(__webpack_require__.bind(__webpack_require__, 54448));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(54448)
            ];
        }
    },
    ssr: false
});
var STICKY_BUTTON_LABEL_UK = "NEW HERE? TAKE 15% OFF*";
var withDefaultHeader = function(signUpFormDataObject) {
    var ref;
    if (!signUpFormDataObject) {
        return {};
    }
    return (0,merge/* merge */.T)(signUpFormDataObject, {
        signUpForm: {
            header: (signUpFormDataObject === null || signUpFormDataObject === void 0 ? void 0 : (ref = signUpFormDataObject.signUpForm) === null || ref === void 0 ? void 0 : ref.header) || STICKY_BUTTON_LABEL_UK
        }
    });
};
var MainFooter = function() {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16;
    var router = (0,next_router.useRouter)();
    var t = (0,useTranslations/* useTranslate */.qM)();
    var ref17 = (0,useSiteConfig/* useSiteConfig */.N)(), country = ref17.country, countryCode = ref17.countryCode, countryName = ref17.countryName, language = ref17.language, _staticFeatures = ref17.staticFeatures, hideNewsletterSignupButtonOnMobile = _staticFeatures.hideNewsletterSignupButtonOnMobile, showPaymentPartnersInFooter = _staticFeatures.showPaymentPartnersInFooter, host = ref17.host;
    var ref18 = (0,react.useState)(), selectedMobileFooterSection = ref18[0], setSelectedMobileFooterSection = ref18[1];
    var ref19 = (0,_sliced_to_array/* default */.Z)((0,graphql/* useTrackAppLinkClickMutation */.ygm)(), 2), trackAppLinkClick = ref19[1];
    var ref20 = (0,useLocation/* useLocation */.TH)(), location = ref20.location, setLocation = ref20.setLocation;
    var stickyButtonRef = (0,react.useRef)(null);
    var isMobile = (0,media/* getIsMobile */.W)();
    var mappedCountryCode = country ? (0,utils_locale/* getMappedCountryCode */.p5)(country) || country.toLowerCase() : "";
    var sitemapUrl = "https://".concat(host, "/").concat(mappedCountryCode, "/").concat(language, "/sitemap");
    (0,useStickyButton/* useStickyButtonIntersection */.Yl)(stickyButtonRef, {
        threshold: 1
    });
    var onOpenFooterSection = (0,react.useCallback)(function(heading) {
        return setSelectedMobileFooterSection(function(cur) {
            return cur !== heading ? heading : undefined;
        });
    }, []);
    var form = (0,index_esm/* useForm */.cI)({
        mode: "onSubmit",
        defaultValues: {
            emailAddress: ""
        }
    });
    var ref21 = (0,_sliced_to_array/* default */.Z)((0,useGroqQuery/* useGroqQuery */.Mo)({
        operationName: "MainFooter",
        query: MainFooterQuery/* MainFooterQuery */.Q
    }), 1), mainFooterData = ref21[0];
    var ref22;
    var ref23 = (ref22 = (ref = mainFooterData.data) === null || ref === void 0 ? void 0 : ref.content) !== null && ref22 !== void 0 ? ref22 : {}, legalLinks = ref23.legalLinks, supportLinks = ref23.supportLinks, aboutLinks = ref23.aboutLinks, signUpForm = ref23.signUpForm, signUpForms = ref23.signUpForms, signUpFormsData = ref23.signUpFormsData;
    if (supportLinks && !supportLinks.some(function(link) {
        return link._key === "sitemap-link";
    })) {
        supportLinks.push({
            _type: "Cta",
            _key: "sitemap-link",
            absolute: sitemapUrl,
            title: "Sitemap"
        });
    }
    var singleSignUpForm = (0,useNewsletterSignup/* useNewsletterSignup */.H)(signUpForm);
    var ref24, ref25, ref26, ref27;
    var newsLetterSignUpFormsMap = new Map([
        [
            (signUpForm === null || signUpForm === void 0 ? void 0 : signUpForm._id) || "emarsys-signup-form",
            singleSignUpForm
        ],
        [
            (ref24 = signUpFormsData === null || signUpFormsData === void 0 ? void 0 : (ref1 = signUpFormsData[0]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.signUpForm) === null || ref2 === void 0 ? void 0 : ref2._id) !== null && ref24 !== void 0 ? ref24 : signUpForms === null || signUpForms === void 0 ? void 0 : (ref3 = signUpForms[0]) === null || ref3 === void 0 ? void 0 : ref3._id,
            (0,useNewsletterSignup/* useNewsletterSignup */.H)((ref25 = signUpFormsData === null || signUpFormsData === void 0 ? void 0 : (ref4 = signUpFormsData[0]) === null || ref4 === void 0 ? void 0 : ref4.signUpForm) !== null && ref25 !== void 0 ? ref25 : signUpForms === null || signUpForms === void 0 ? void 0 : signUpForms[0]), 
        ],
        [
            (ref26 = signUpFormsData === null || signUpFormsData === void 0 ? void 0 : (ref5 = signUpFormsData[1]) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.signUpForm) === null || ref6 === void 0 ? void 0 : ref6._id) !== null && ref26 !== void 0 ? ref26 : signUpForms === null || signUpForms === void 0 ? void 0 : (ref7 = signUpForms[1]) === null || ref7 === void 0 ? void 0 : ref7._id,
            (0,useNewsletterSignup/* useNewsletterSignup */.H)((ref27 = signUpFormsData === null || signUpFormsData === void 0 ? void 0 : (ref8 = signUpFormsData[1]) === null || ref8 === void 0 ? void 0 : ref8.signUpForm) !== null && ref27 !== void 0 ? ref27 : signUpForms === null || signUpForms === void 0 ? void 0 : signUpForms[1]), 
        ], 
    ].filter(function(param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 1), k = _param[0];
        return !!k;
    }));
    var onShowNewsLetterSignup = function(formId) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            args[_key - 1] = arguments[_key];
        }
        var _form;
        var form = newsLetterSignUpFormsMap.get(formId);
        if (form) (_form = form).show.apply(_form, (0,_to_consumable_array/* default */.Z)(args));
    };
    var onHandleCloseNewsLetterSignup = function(formId) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            args[_key - 1] = arguments[_key];
        }
        var _form;
        var form = newsLetterSignUpFormsMap.get(formId);
        if (form) (_form = form).handleClose.apply(_form, (0,_to_consumable_array/* default */.Z)(args));
    };
    // array of newsletter signup forms to show
    var emarsysEnabledNewsLetterSignupForms = [];
    var signUpFormsItems = (signUpFormsData === null || signUpFormsData === void 0 ? void 0 : signUpFormsData.length) ? signUpFormsData : signUpForms;
    // signUpForm is deprecated
    // use signUpForm as fallback only if there are no signUpForms
    if (signUpFormsItems === null || signUpFormsItems === void 0 ? void 0 : signUpFormsItems.length) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = signUpFormsItems[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var formItem = _step.value;
                var formData = "_id" in formItem ? formItem : formItem.signUpForm;
                var _displayOnMobile;
                var displayOnMobile = "_id" in formItem ? true : (_displayOnMobile = formItem.displayOnMobile) !== null && _displayOnMobile !== void 0 ? _displayOnMobile : true;
                if (formData) {
                    var newsLetterSignUpForm = newsLetterSignUpFormsMap.get(formData._id);
                    if (newsLetterSignUpForm === null || newsLetterSignUpForm === void 0 ? void 0 : newsLetterSignUpForm.isEmarsysEnabled) {
                        emarsysEnabledNewsLetterSignupForms.push({
                            displayOnMobile: displayOnMobile,
                            signUpForm: formData
                        });
                    }
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    } else if (signUpForm && singleSignUpForm.isEmarsysEnabled) {
        emarsysEnabledNewsLetterSignupForms.push({
            signUpForm: signUpForm,
            displayOnMobile: true
        });
    } else if (singleSignUpForm.isEmarsysEnabled) {
        emarsysEnabledNewsLetterSignupForms.push({
            signUpForm: (0,_object_spread/* default */.Z)({
                _id: "emarsys-signup-form"
            }, singleSignUpForm),
            displayOnMobile: true
        });
    }
    var ref28 = (0,react.useState)(withDefaultHeader(emarsysEnabledNewsLetterSignupForms[0])), selectedFormDataObject = ref28[0], setSelectedFormDataObject = ref28[1];
    var handleClickForm = function(formDataObject) {
        setSelectedFormDataObject(withDefaultHeader(formDataObject));
    };
    var isCart = router.asPath.includes("/cart");
    var displaySignUpButton = (selectedFormDataObject === null || selectedFormDataObject === void 0 ? void 0 : (ref9 = selectedFormDataObject.signUpForm) === null || ref9 === void 0 ? void 0 : ref9.header) && ((ref11 = newsLetterSignUpFormsMap.get(selectedFormDataObject === null || selectedFormDataObject === void 0 ? void 0 : (ref10 = selectedFormDataObject.signUpForm) === null || ref10 === void 0 ? void 0 : ref10._id)) === null || ref11 === void 0 ? void 0 : ref11.isButtonVisible) && !isCart;
    var includeNewsletterComponents = !router.asPath.includes("/help/financial-incentives") && (selectedFormDataObject === null || selectedFormDataObject === void 0 ? void 0 : selectedFormDataObject.signUpForm) && ((ref12 = newsLetterSignUpFormsMap.get(selectedFormDataObject.signUpForm._id)) === null || ref12 === void 0 ? void 0 : ref12.isFormVisible);
    var _successHeader;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            displaySignUpButton && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "sticky overflow-hidden bottom-0 px-4 py-4 lg:px-8 lg:py-8 block z-20 pointer-events-none ".concat(hideNewsletterSignupButtonOnMobile || !selectedFormDataObject.displayOnMobile ? "mobile:hidden" : ""),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsletterSignUpButton, {
                    label: ((ref13 = selectedFormDataObject.signUpForm) === null || ref13 === void 0 ? void 0 : ref13.launchButtonLabel) || ((ref14 = selectedFormDataObject.signUpForm) === null || ref14 === void 0 ? void 0 : ref14.header) || "",
                    location: "StickySignUpButton",
                    onClick: function() {
                        var ref;
                        return onShowNewsLetterSignup((ref = selectedFormDataObject === null || selectedFormDataObject === void 0 ? void 0 : selectedFormDataObject.signUpForm) === null || ref === void 0 ? void 0 : ref._id, "SiteFooter");
                    },
                    onDismiss: function() {
                        var ref;
                        onHandleCloseNewsLetterSignup((ref = selectedFormDataObject === null || selectedFormDataObject === void 0 ? void 0 : selectedFormDataObject.signUpForm) === null || ref === void 0 ? void 0 : ref._id, true);
                        (0,analytics/* emailSignUpEvent */.QZ)(analyticTypes/* EmailSignUpActions.ButtonDismissed */.VF.ButtonDismissed, "StickySignUpButton");
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: stickyButtonRef
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("footer", {
                role: "contentinfo",
                className: "font-display relative bg-puma-black-100 text-puma-black-400",
                "aria-label": "Main Footer",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Container */.W20, {
                    size: "page",
                    asChild: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("nav", {
                        className: "py-8 lg:py-10 text-neutral-20 space-y-6",
                        "aria-label": "Footer Nav",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Container */.W20, {
                                size: "xl",
                                "data-test-id": "footer-top",
                                "data-footer-position": "top",
                                className: "flex flex-col lg:flex-row justify-between gap-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "lg:flex-[2]",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterSection, {
                                            dataTestId: "footer-support-section",
                                            heading: t("support"),
                                            current: selectedMobileFooterSection,
                                            onOpen: onOpenFooterSection,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                role: "menu",
                                                className: "grid grid-cols-2 gap-x-6 gap-y-1",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterLinks/* FooterLinks */.q, {
                                                        links: supportLinks,
                                                        parentNavigationName: "Support"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CookieSettings, {})
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "lg:flex-[1]",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterSection, {
                                            dataTestId: "footer-about-section",
                                            heading: t("about"),
                                            current: selectedMobileFooterSection,
                                            onOpen: onOpenFooterSection,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                role: "menu",
                                                className: "grid grid-cols-1 gap-x-6 gap-y-1",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterLinks/* FooterLinks */.q, {
                                                    links: aboutLinks,
                                                    parentNavigationName: "About"
                                                })
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "lg:flex-[1] flex flex-col gap-2 lg:gap-6",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                (emarsysEnabledNewsLetterSignupForms.length || showPaymentPartnersInFooter) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(FooterSection, {
                                                    dataTestId: "footer-stay-up-to-date-section",
                                                    heading: t("newsletterSignUp"),
                                                    current: selectedMobileFooterSection,
                                                    onOpen: onOpenFooterSection,
                                                    children: [
                                                        emarsysEnabledNewsLetterSignupForms.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                            role: "menu",
                                                            className: "grid grid-cols-1 gap-x-6 gap-y-1",
                                                            children: emarsysEnabledNewsLetterSignupForms.filter(function(formItem) {
                                                                return !isMobile || formItem.displayOnMobile;
                                                            }).map(function(formItem) {
                                                                return formItem.signUpForm && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                    role: "none",
                                                                    className: "flex",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        "data-test-id": "signup-link-".concat(formItem.signUpForm._id),
                                                                        role: "menuitem",
                                                                        className: "hover:text-white",
                                                                        href: "#",
                                                                        onClick: function(e) {
                                                                            e.preventDefault();
                                                                            onShowNewsLetterSignup(formItem.signUpForm._id, "SiteFooter");
                                                                            handleClickForm(formItem);
                                                                            (0,analytics/* footerNavigationEvent */.ZG)({
                                                                                parentNavigation: "Email Signup"
                                                                            });
                                                                            (0,analytics/* footerNavigationClickEvent */.i7)("stay up to date: sign up for email");
                                                                        },
                                                                        children: formItem.signUpForm.launchLinkText || t("newsletterSignUpCTA")
                                                                    })
                                                                }, formItem.signUpForm._id);
                                                            })
                                                        }),
                                                        showPaymentPartnersInFooter && /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialMediaFooterLinks, {
                                                            className: "mt-6"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterSection, {
                                                    dataTestId: "footer-explore-section",
                                                    heading: t("appSectionLabel"),
                                                    current: selectedMobileFooterSection,
                                                    onOpen: onOpenFooterSection,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "flex flex-row mt-4 gap-9",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PumaAppLink, {
                                                                onClick: function() {
                                                                    (0,analytics/* footerNavigationEvent */.ZG)({
                                                                        parentNavigation: "PUMAApp"
                                                                    });
                                                                    (0,analytics/* footerNavigationClickEvent */.i7)("explore:pumaapp");
                                                                    trackAppLinkClick({
                                                                        link: "footerNavigationClickEvent"
                                                                    });
                                                                }
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PumaTracLink, {
                                                                onClick: function() {
                                                                    (0,analytics/* footerNavigationEvent */.ZG)({
                                                                        parentNavigation: "PUMATrac"
                                                                    });
                                                                    (0,analytics/* footerNavigationClickEvent */.i7)("explore:pumatrac");
                                                                    trackAppLinkClick({
                                                                        link: "PUMATrac"
                                                                    });
                                                                }
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                "data-test-id": "footer-bottom",
                                "data-footer-position": "bottom",
                                className: (0,twind.tw)([
                                    "grid gap-x-3 gap-y-6",
                                    "grid-rows[auto_1px_auto_auto] grid-cols-1 items-start",
                                    "xs:grid-rows-[auto_1px_auto] xs:grid-cols-2",
                                    "lg:grid-rows-[1px_auto] lg:grid-cols-3 lg:items-center", 
                                ]),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (0,twind.tw)([
                                            "row-start-1",
                                            "xs:row-start-1 xs:col-start-1 xs:col-span-2",
                                            "lg:row-start-2 lg:col-start-2 lg:col-span-1 lg:justify-self-center", 
                                        ]),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Button */.zxk, {
                                            "data-test-id": "select-location",
                                            label: countryName,
                                            icon: "flag-".concat(countryCode),
                                            variant: "secondary",
                                            size: {
                                                _: "base",
                                                lg: "lg"
                                            },
                                            invert: true,
                                            className: "w-full lg:w-auto lg:mx-auto",
                                            onClick: function() {
                                                setLocation((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, location), {
                                                    selecting: true
                                                }));
                                                (0,analytics/* footerNavigationEvent */.ZG)({
                                                    parentNavigation: "Language"
                                                });
                                                (0,analytics/* footerNavigationClickEvent */.i7)("Language");
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                                        className: (0,twind.tw)("border-0 border-t-1 border-puma-black-400", [
                                            "row-start-2",
                                            "xs:row-start-2 xs:col-span-2",
                                            "lg:row-start-1 lg:col-start-1 lg:col-span-3", 
                                        ])
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (0,twind.tw)([
                                            "row-start-3",
                                            "xs:row-start-3",
                                            "lg:row-start-2 lg:col-start-1 lg:col-span-1", 
                                        ]),
                                        children: showPaymentPartnersInFooter ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AcceptedPaymentMethods/* AcceptedPaymentMethods */.e, {
                                            dataTestId: "accepted-payment-methods",
                                            className: "flex gap-2 flex-wrap"
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialMediaFooterLinks, {})
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (0,twind.tw)([
                                            "row-start-4",
                                            "xs:row-start-3",
                                            "lg:row-start-2 lg:col-start-3 lg:col-span-1", 
                                        ]),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex flex-col text-xs text-right text-neutral-40 uppercase",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CopyrightAndLegalLinks, {
                                                    legalLinks: legalLinks
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(elements_ForterWebId, {})
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            includeNewsletterComponents && ((selectedFormDataObject === null || selectedFormDataObject === void 0 ? void 0 : (ref15 = selectedFormDataObject.signUpForm) === null || ref15 === void 0 ? void 0 : ref15.emarsysSignupURL) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsletterSignupIFrame, {
                email: form.getValues()["emailAddress"],
                emarsysSignupURL: selectedFormDataObject.signUpForm.emarsysSignupURL,
                country: country,
                language: language,
                onClose: function() {
                    return onHandleCloseNewsLetterSignup((signUpForm === null || signUpForm === void 0 ? void 0 : signUpForm._id) || "emarsys-signup-form", true);
                },
                signUpLocation: "SiteFooter"
            }) : !!selectedFormDataObject.signUpForm && /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsletterSignup, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, selectedFormDataObject.signUpForm), {
                id: selectedFormDataObject.signUpForm._id,
                successHeader: (_successHeader = selectedFormDataObject === null || selectedFormDataObject === void 0 ? void 0 : selectedFormDataObject.signUpForm.successHeader) !== null && _successHeader !== void 0 ? _successHeader : "",
                onClose: function() {
                    return onHandleCloseNewsLetterSignup(selectedFormDataObject.signUpForm._id, false);
                },
                onSubmit: function() {
                    return onHandleCloseNewsLetterSignup(selectedFormDataObject.signUpForm._id, true);
                },
                signUpLocation: (ref16 = newsLetterSignUpFormsMap.get(selectedFormDataObject.signUpForm._id)) === null || ref16 === void 0 ? void 0 : ref16.signUpLocation
            })))
        ]
    });
};
var FooterSection = function(param) {
    var dataTestId = param.dataTestId, heading = param.heading, current = param.current, onOpen = param.onOpen, children = param.children;
    var isOpen = current === heading;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Stack */.Kqy, {
                gap: "xxs",
                "data-footer-type": "full",
                "data-test-id": dataTestId,
                className: (0,twind.tw)("mobile:hidden tablet:hidden desktop:flex"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Heading */.X6q, {
                        size: "xs",
                        transform: "uppercase",
                        color: "base",
                        invert: true,
                        asChild: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: heading
                        })
                    }),
                    children
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* CollapsibleRoot */.Kq5, {
                invert: true,
                open: isOpen,
                onOpenChange: function() {
                    return onOpen(heading);
                },
                dataTestId: dataTestId,
                "data-footer-type": "collapsible",
                className: "desktop:hidden",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* CollapsibleTrigger */.wy4, {
                            insetY: "xxs",
                            insetX: "xxxs",
                            className: "flex flex-row justify-between items-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Heading */.X6q, {
                                    size: "xs",
                                    transform: "uppercase",
                                    children: heading
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* CollapsibleChevron */.lLF, {})
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* CollapsibleContent */.FwI, {
                        insetY: "xxs",
                        insetX: "xxxs",
                        className: (0,twind.tw)((0,css/* css */.iv)(MainFooter_templateObject())),
                        children: children
                    })
                ]
            })
        ]
    });
};
var CopyrightAndLegalLinks = function(param) {
    var _legalLinks = param.legalLinks, legalLinks = _legalLinks === void 0 ? [] : _legalLinks;
    var t = (0,useTranslations/* useTranslate */.qM)();
    var currentYear = new Date().getFullYear();
    var getLink = (0,useLinkResolver/* useLinkResolver */.u)().getLink;
    var links = legalLinks ? (0,_to_consumable_array/* default */.Z)(legalLinks) : [];
    if (links.length === 0) {
        links.push({
            _type: "Cta",
            _key: "imprint-legal-data-link",
            support: "/help/imprint",
            title: t("imprintAndLegalData")
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                "data-test-id": "copyright-notice",
                children: t("allRightsReserved", {
                    year: currentYear
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                "data-test-id": "footer-legal-section",
                role: "menu",
                children: links.map(function(link) {
                    var newtabProps = link.newtab ? {
                        target: "_blank",
                        rel: "noopener noreferrer"
                    } : {};
                    var __key, _title;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        role: "none",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* LinkText */.u66, (0,_object_spread/* default */.Z)({
                            dataTestId: (__key = link._key) !== null && __key !== void 0 ? __key : undefined,
                            href: getLink(link),
                            label: (_title = link.title) !== null && _title !== void 0 ? _title : "",
                            role: "menuitem",
                            className: "underline-offset-0",
                            onClick: function() {
                                if (link.title) {
                                    (0,analytics/* footerNavigationEvent */.ZG)({
                                        parentNavigation: "Legal:".concat(link.title),
                                        linkClicked: link.title
                                    });
                                }
                                (0,analytics/* footerNavigationClickEvent */.i7)("Legal:".concat(link.title));
                            }
                        }, newtabProps))
                    }, link._key);
                })
            })
        ]
    });
};
var SocialMediaFooterLinks = function(param) {
    var className = param.className;
    var ref = (0,useSiteConfig/* useSiteConfig */.N)(), socialMediaLinks = ref.socialMediaLinks, showPinterestFooterIcon = ref.staticFeatures.showPinterestFooterIcon;
    var t = (0,useTranslations/* useTranslate */.qM)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        "data-test-id": "social-media-footer-links",
        className: className,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
            className: "flex justify-between xs:justify-start xs:gap-6",
            role: "menu",
            "aria-label": t("moreInspiration"),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialMediaLink, {
                    id: "social-youtube",
                    name: "YouTube",
                    url: (socialMediaLinks === null || socialMediaLinks === void 0 ? void 0 : socialMediaLinks.youtube) || "https://www.youtube.com/puma"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialMediaLink, {
                    id: "social-x",
                    name: "Twitter",
                    url: (socialMediaLinks === null || socialMediaLinks === void 0 ? void 0 : socialMediaLinks.twitter) || "https://x.com/PUMA"
                }),
                showPinterestFooterIcon && /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialMediaLink, {
                    id: "social-pinterest",
                    name: "Pinterest",
                    url: (socialMediaLinks === null || socialMediaLinks === void 0 ? void 0 : socialMediaLinks.pinterest) || "https://www.pinterest.com/puma/"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialMediaLink, {
                    id: "social-instagram",
                    name: "Instagram",
                    url: (socialMediaLinks === null || socialMediaLinks === void 0 ? void 0 : socialMediaLinks.instagram) || "https://instagram.com/puma/"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialMediaLink, {
                    id: "social-facebook",
                    name: "Facebook",
                    url: (socialMediaLinks === null || socialMediaLinks === void 0 ? void 0 : socialMediaLinks.facebook) || "https://www.facebook.com/PUMA/"
                })
            ]
        })
    });
};
var SocialMediaLink = function(param) {
    var id = param.id, name = param.name, url = param.url;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
        role: "none",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* LinkIcon */.xPt, {
            role: "menuitem",
            href: url,
            rel: "noopener noreferrer",
            target: "_blank",
            dataTestId: "".concat(id, "-social-link"),
            variant: "primary",
            label: name,
            icon: id,
            onClick: function() {
                (0,analytics/* footerNavigationEvent */.ZG)({
                    parentNavigation: "Social:".concat(name),
                    linkClicked: name
                });
            }
        })
    });
};

// EXTERNAL MODULE: ./hooks/useGooglePay.tsx + 2 modules
var useGooglePay = __webpack_require__(24466);
// EXTERNAL MODULE: ./hooks/usePageEventsContext.tsx
var usePageEventsContext = __webpack_require__(43308);
// EXTERNAL MODULE: ../node_modules/@global-ecom/nitro-uds/dist/hooks/esm/index.js
var hooks_esm = __webpack_require__(68138);
;// CONCATENATED MODULE: ./ui/components/UdsProviderWrapper.tsx





var UdsProviderWrapper = function(param) {
    var children = param.children;
    var localizeUrlPath = (0,useSiteConfig/* useSiteConfig */.N)().localizeUrlPath;
    var t = (0,useTranslations/* useTranslate */.qM)();
    var router = (0,next_router.useRouter)();
    var dictionary = {
        loading: t("loading"),
        optional: t("optional"),
        january: t("january"),
        february: t("february"),
        march: t("march"),
        april: t("april"),
        may: t("may"),
        june: t("june"),
        july: t("july"),
        august: t("august"),
        september: t("september"),
        october: t("october"),
        november: t("november"),
        december: t("december"),
        day: t("day"),
        month: t("month"),
        year: t("year"),
        showPassword: t("showPassword"),
        hidePassword: t("hidePassword"),
        charactersRemaining: t("charactersRemaining"),
        genericFieldMinLength: t("genericFieldMinLength"),
        genericFieldMaxLength: t("genericFieldMaxLength"),
        close: t("close"),
        clear: t("clear"),
        search: t("search"),
        srNewSearchResults: t("newSearchResults"),
        srNoSearchResults: t("noSearchResults")
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(hooks_esm/* UdsProvider */.Lq, {
        value: {
            dictionary: dictionary,
            iconDirectory: "/_next/static/assets/icons",
            utils: {
                localizeUrlPath: localizeUrlPath,
                navigate: router.push
            }
        },
        children: children
    });
};

// EXTERNAL MODULE: ./groq/shared/LocaleString.ts
var LocaleString = __webpack_require__(1809);
// EXTERNAL MODULE: ./groq/objects/SanityImageObject.ts + 1 modules
var SanityImageObject = __webpack_require__(14075);
// EXTERNAL MODULE: ./groq/shared/MainNavItemLink.ts
var MainNavItemLink = __webpack_require__(88035);
;// CONCATENATED MODULE: ./groq/shared/MainNavItem.ts



var MainNavItem = function(field) {
    var depth = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return "\n  ".concat(field, ' {\n    "id": _key,\n    _type,\n    ').concat((0,LocaleString/* LocaleString */.E)("label"), ",\n    ").concat((0,SanityImageObject/* SanityImageObject */.i)("image"), ",\n    ").concat((0,MainNavItemLink/* MainNavItemLink */.r)("link"), ',\n    navColor,\n    availableFrom,\n    availableTo,\n    "childrenCount": count(children),\n    ').concat(depth > 0 ? MainNavItem("children[]", depth - 1) : "", "\n  }\n");
};
var MainNavItemChildren = function() {
    var depth = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    return '\n  children[!defined(availableOn)\n    || availableOn == "all"\n    || availableOn == "web"\n    || availableOn == null] {\n    "id": _key,\n    _type,\n    '.concat((0,LocaleString/* LocaleString */.E)("label"), ",\n    ").concat((0,SanityImageObject/* SanityImageObject */.i)("image"), ",\n    ").concat((0,MainNavItemLink/* MainNavItemLink */.r)("link"), ',\n    navColor,\n    availableFrom,\n    availableTo,\n    availableOn,\n    "childrenCount": count(children),\n    ').concat(depth > 0 ? MainNavItemChildren(depth - 1) : "", "\n  }\n");
};

// EXTERNAL MODULE: ./groq/objects/CallToActionObject.ts
var CallToActionObject = __webpack_require__(28008);
;// CONCATENATED MODULE: ./groq/queries/MainNavQuery.ts




var children = 'children[] {\n    "id": _key,\n    _type,\n    '.concat((0,LocaleString/* LocaleString */.E)("label"), ",\n    ").concat((0,MainNavItemLink/* MainNavItemLink */.r)("link"), ",\n    ").concat(MainNavItem("navChildren[]"), ",\n    ").concat(MainNavItemChildren(4), ",\n    availableOn\n  }");
var mainNav = '*[_type == "MainNav" && country == $country][0] {\n  _id,\n  '.concat((0,CallToActionObject/* CallToActionObject */.U)("userMenuQuicklinks[]"), ",\n    ").concat(children, '[!defined(availableOn)\n    || availableOn == "all"\n    || availableOn == "web"\n    || availableOn == null]\n}');
var mainNavMobileOnly = '*[_type == "MainNav" && country == $country][0] {\n  _id,\n  '.concat(children, '[availableOn == "mobileApp"]\n}');
var MainNavQuery = '{\n    "mainNav": '.concat(mainNav, ',\n    "mobileOnly": ').concat(mainNavMobileOnly, "\n}");

;// CONCATENATED MODULE: ./hooks/useCancelOrder.ts








var sessionStorageEntries = Object.values(constants/* PAYMENT_METHOD_SESSION_STORAGE_ENTRY */.X9);
/**
 * When a user starts checkout, they can initialize a payment method.
 * If they navigate away from checkout, this hook will cancel those pending payments.
 */ var useCancelCustomerOrder = function(customerId) {
    var ref = (0,_sliced_to_array/* default */.Z)((0,graphql/* useCancelOrderMutation */.HKA)(), 2), cancelOrder = ref[1];
    var router = (0,next_router.useRouter)();
    (0,react.useEffect)(function() {
        var isConfirmationPage = router.asPath.includes("checkout/confirmation");
        var isPaypalPage = router.asPath.includes("checkout/paypal");
        var isValidationPage = router.asPath.includes("validation");
        var isPayPayPage = router.asPath.includes("paypay");
        if (isConfirmationPage || isValidationPage || isPaypalPage || isPayPayPage) {
            return;
        }
        var retreivedEntriesFromSessionStorage = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            // Get all the sessionStorageEntries, and save the order number if we find any.
            for(var _iterator = sessionStorageEntries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var sessionStorageEntryName = _step.value;
                var orderNo = window.sessionStorage.getItem(sessionStorageEntryName);
                if (orderNo) {
                    retreivedEntriesFromSessionStorage.push({
                        sessionStorageEntryName: sessionStorageEntryName,
                        orderNo: orderNo
                    });
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        (0,_async_to_generator/* default */.Z)(function() {
            var promises, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _ref, sessionStorageEntry, _query, orderNo, token, query, _tmp, _tmp1;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        promises = [];
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        _tmp = {};
                        _tmp1 = {};
                        try {
                            for(_iterator = retreivedEntriesFromSessionStorage[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                _ref = _step.value;
                                sessionStorageEntry = _ref;
                                _query = router.query, orderNo = _query.orderNo, token = _query.token, query = (0,_object_without_properties/* default */.Z)(_query, [
                                    "orderNo",
                                    "token"
                                ]);
                                // Remove query and token from the router params.
                                router.replace((_tmp.pathname = router.pathname, _tmp.query = query, _tmp));
                                // Remove the session storage entries.
                                window.sessionStorage.removeItem(sessionStorageEntry.sessionStorageEntryName);
                                // CancelOrder in GQL.
                                promises.push(cancelOrder((_tmp1.input = {
                                    orderNo: sessionStorageEntry.orderNo
                                }, _tmp1)));
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        return [
                            4,
                            Promise.all(promises)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        })();
    // We only want to re-run this if the path or customerId changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        customerId,
        router.asPath.split("?")[0]
    ]);
};

// EXTERNAL MODULE: ./hooks/useMiniCart.tsx
var useMiniCart = __webpack_require__(38859);
// EXTERNAL MODULE: ../node_modules/wonka/dist/wonka.mjs
var wonka = __webpack_require__(51044);
// EXTERNAL MODULE: ../node_modules/@urql/core/dist/urql-core.mjs
var urql_core = __webpack_require__(70463);
// EXTERNAL MODULE: ../node_modules/@urql/core/dist/urql-core-chunk.mjs
var urql_core_chunk = __webpack_require__(88423);
;// CONCATENATED MODULE: ../node_modules/@urql/exchange-auth/dist/urql-exchange-auth.mjs




var addAuthAttemptToOperation = (t, r) => (0,urql_core/* makeOperation */.vx)(t.kind, t, {
  ...t.context,
  authAttempt: r
});

function authExchange(f) {
  return ({client: d, forward: c}) => {
    var p = new WeakSet;
    var s = (0,wonka/* makeSubject */.nN)();
    var l = new Map;
    function flushQueue(t) {
      if (t) {
        v = t;
      }
      A = void 0;
      var r = l;
      l = new Map;
      r.forEach(s.next);
    }
    var A;
    var v = null;
    return t => {
      A = Promise.resolve().then((() => f({
        mutate(t, u, a) {
          var h = d.createRequestOperation("mutation", (0,urql_core_chunk.h)(t, u), a);
          return (0,wonka/* toPromise */.Vi)((0,wonka/* take */.qn)(1)((0,wonka/* filter */.hX)((t => t.operation.key === h.key))((0,wonka/* onStart */.Hr)((() => {
            var t = addAuthToOperation(h);
            p.add(t);
            s.next(t);
          }))(w))));
        },
        appendHeaders(t, r) {
          var e = "function" == typeof t.context.fetchOptions ? t.context.fetchOptions() : t.context.fetchOptions || {};
          return (0,urql_core/* makeOperation */.vx)(t.kind, t, {
            ...t.context,
            fetchOptions: {
              ...e,
              headers: {
                ...e.headers,
                ...r
              }
            }
          });
        }
      }))).then(flushQueue);
      function refreshAuth(t) {
        l.set(t.key, addAuthAttemptToOperation(t, !0));
        if (v && !A) {
          A = v.refreshAuth().finally(flushQueue);
        }
      }
      function addAuthToOperation(t) {
        return v ? v.addAuthToOperation(t) : t;
      }
      var x = (0,wonka/* filter */.hX)((t => "teardown" === t.kind))(t);
      var k = (0,wonka/* filter */.hX)((t => "teardown" !== t.kind))(t);
      var m = (0,wonka/* filter */.hX)(Boolean)((0,wonka/* map */.UI)((t => {
        if (t.context.authAttempt) {
          return addAuthToOperation(t);
        } else if (p.has(t)) {
          return t;
        } else if (A) {
          if (!l.has(t.key)) {
            l.set(t.key, addAuthAttemptToOperation(t, !1));
          }
          return null;
        } else if (function willAuthError(t) {
          return !t.context.authAttempt && v && v.willAuthError && v.willAuthError(t);
        }(t)) {
          refreshAuth(t);
          return null;
        }
        return addAuthToOperation(addAuthAttemptToOperation(t, !1));
      }))((0,wonka/* merge */.TS)([ s.source, k ])));
      var w = c((0,wonka/* merge */.TS)([ m, x ]));
      return (0,wonka/* filter */.hX)((t => {
        if (t.error && function didAuthError(t) {
          return v && v.didAuthError && v.didAuthError(t.error, t.operation);
        }(t) && !t.operation.context.authAttempt) {
          refreshAuth(t.operation);
          return !1;
        }
        return !0;
      }))(w);
    };
  };
}


//# sourceMappingURL=urql-exchange-auth.mjs.map

// EXTERNAL MODULE: ./utils/clientLogger.ts
var clientLogger = __webpack_require__(50222);
;// CONCATENATED MODULE: ./gql/exchanges/auth/headers.ts
/**
 * Get the request headers for all GQL requests
 * @param operationName The optional operation name
 */ function getRequestHeaders(operationName, authState) {
    var ref;
    var headers = {
        "puma-request-source": "web",
        "x-operation-name": operationName || "unknown"
    };
    // add the authorization headers
    if (authState === null || authState === void 0 ? void 0 : authState.accessToken) {
        headers["authorization"] = "Bearer ".concat(authState.accessToken);
        headers["refresh-token"] = authState.refreshToken;
        headers["customer-id"] = authState.customerId;
    }
    // add the customer-group received from the API
    if (authState === null || authState === void 0 ? void 0 : (ref = authState.customerContext) === null || ref === void 0 ? void 0 : ref.hashKey) {
        headers["customer-group"] = authState.customerContext.hashKey;
    }
    return headers;
}

// EXTERNAL MODULE: ./gql/exchanges/auth/token.ts + 1 modules
var auth_token = __webpack_require__(4780);
;// CONCATENATED MODULE: ./gql/exchanges/auth/utils.ts
/**
 * Returns the name of the graphql operation the client
 * assigned to the query
 * @param operation The graphql operation
 * @returns The name of the operation
 */ var getOperationName = function(operation) {
    var ref;
    return (ref = operation.query.definitions.find(function(definition) {
        return definition.kind === "OperationDefinition";
    }).name) === null || ref === void 0 ? void 0 : ref.value;
};
/**
 * Returns true if the API response contains an
 * Authentication Error
 */ var hasGraphQLAuthError = function(error) {
    return error.graphQLErrors.some(function(e) {
        var ref, ref1;
        return ((ref = e.extensions) === null || ref === void 0 ? void 0 : ref.code) === "UNAUTHENTICATED" || ((ref1 = e.extensions) === null || ref1 === void 0 ? void 0 : ref1.code) === "FORBIDDEN";
    });
};

;// CONCATENATED MODULE: ./gql/exchanges/auth/clientAuthExchange.ts










var createClientAuthExchange = function() {
    return authExchange(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(utils) {
            var country, _tmp;
            return (0,tslib_es6.__generator)(this, function(_state) {
                country = (router_default()).query.country;
                _tmp = {};
                return [
                    2,
                    (_tmp.addAuthToOperation = function addAuthToOperation(operation) {
                        var authState = (0,cookie/* getStoredAuthData */.ir)();
                        var operationName = getOperationName(operation) || "";
                        // capture debugging info
                        var isAuth = [
                            "GuestLogon",
                            "RefreshLogon"
                        ].includes(operationName);
                        if (!isAuth) {
                            if (!(authState === null || authState === void 0 ? void 0 : authState.accessToken)) {
                                clientLogger/* clientLogger.warn */.u.warn({
                                    operationName: operationName
                                }, "authExchange: [client] send operation without a token");
                            } else if ((0,auth_token/* isTokenExpired */.pw)(authState.accessToken)) {
                                clientLogger/* clientLogger.warn */.u.warn({
                                    operationName: operationName
                                }, "authExchange: [client] send operation with expired token");
                            }
                        }
                        var headers = getRequestHeaders(operationName, authState);
                        return utils.appendHeaders(operation, headers);
                    }, _tmp.willAuthError = function willAuthError() {
                        var authState = (0,cookie/* getStoredAuthData */.ir)();
                        if (!authState.accessToken) {
                            return true;
                        }
                        return (0,auth_token/* isTokenExpired */.pw)(authState.accessToken);
                    }, _tmp.didAuthError = hasGraphQLAuthError, _tmp.refreshAuth = function refreshAuth() {
                        return (0,_async_to_generator/* default */.Z)(function() {
                            var authState, result, _tmp, _tmp1, result1, _tmp2, _tmp3, err, _tmp4;
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        authState = (0,cookie/* getStoredAuthData */.ir)();
                                        _state.label = 1;
                                    case 1:
                                        _state.trys.push([
                                            1,
                                            5,
                                            ,
                                            6
                                        ]);
                                        if (!authState.refreshToken) return [
                                            3,
                                            3
                                        ];
                                        _tmp = {};
                                        return [
                                            4,
                                            (0,auth_token/* refreshAuthToken */.Oc)((_tmp.refreshToken = authState.refreshToken, _tmp.mutate = utils.mutate, _tmp))
                                        ];
                                    case 2:
                                        result = _state.sent();
                                        _tmp1 = {};
                                        if (result) {
                                            // successful refresh, update all stored tokens
                                            (0,cookie/* storeAuthData */._J)((_tmp1.payload = result, _tmp1.country = country, _tmp1));
                                            return [
                                                2
                                            ];
                                        }
                                        // we have an invalid refresh token, so destroy
                                        // all the current stored auth data so we can rebuild
                                        (0,cookie/* destroyStoredAuthData */.Cj)(country);
                                        _state.label = 3;
                                    case 3:
                                        _tmp2 = {};
                                        return [
                                            4,
                                            (0,auth_token/* getGuestToken */.kh)((_tmp2.mutate = utils.mutate, _tmp2))
                                        ];
                                    case 4:
                                        result1 = _state.sent();
                                        _tmp3 = {};
                                        (0,cookie/* storeAuthData */._J)((_tmp3.payload = result1, _tmp3.country = country, _tmp3));
                                        authEventEmitter/* authEventEmitter.emit */.c.emit("token-changed");
                                        return [
                                            3,
                                            6
                                        ];
                                    case 5:
                                        err = _state.sent();
                                        _tmp4 = {};
                                        clientLogger/* clientLogger.error */.u.error((_tmp4.err = err, _tmp4), "authExchange: [client] failed to refreshAuth");
                                        (0,cookie/* destroyStoredAuthData */.Cj)(country);
                                        authEventEmitter/* authEventEmitter.emit */.c.emit("token-changed");
                                        return [
                                            3,
                                            6
                                        ];
                                    case 6:
                                        return [
                                            2
                                        ];
                                }
                            });
                        })();
                    }, _tmp)
                ];
            });
        });
        return function(utils) {
            return _ref.apply(this, arguments);
        };
    }());
};

;// CONCATENATED MODULE: ./gql/mutations/account.ts

function account_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation UpdatePassword($currentPassword: String!, $newPassword: String!) {\n    updatePassword(\n      input: { currentPassword: $currentPassword, newPassword: $newPassword }\n    )\n  }\n"
    ]);
    account_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation UpdatePhone($input: UpdatePhoneInput!) {\n    updatePhone(input: $input) {\n      code\n      message\n      pinId\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation ConfirmUpdatePhone($input: ConfirmUpdatePhoneInput!) {\n    confirmUpdatePhone(input: $input) {\n      code\n      message\n      user {\n        id\n        phoneNumber\n      }\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation ResetPassword($email: String!) {\n    resetPassword(email: $email)\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation CompleteResetPassword($password: String!, $token: String!) {\n    completeResetPassword(password: $password, token: $token)\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation CreateShopperContext($input: CreateShopperContextInput!) {\n    createShopperContext(input: $input) {\n      sourceCode\n    }\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation VerifyUserAffiliations($input: VerifyUserAffiliationsInput!) {\n    verifyUserAffiliations(input: $input) {\n      verified\n      affiliations\n    }\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}

var UPDATE_PASSWORD_MUTATION = (0,urql_core/* gql */.Ps)(account_templateObject());
var UPDATE_PHONE_MUTATION = (0,urql_core/* gql */.Ps)(_templateObject1());
var CONFIRM_UPDATE_PHONE = (0,urql_core/* gql */.Ps)(_templateObject2());
var RESET_PASSWORD_MUTATION = (0,urql_core/* gql */.Ps)(_templateObject3());
var COMPLETE_RESET_PASSWORD_MUTATION = (0,urql_core/* gql */.Ps)(_templateObject4());
var CREATE_SHOPPER_CONTEXT_MUTATION = (0,urql_core/* gql */.Ps)(_templateObject5());
var VERIFY_USER_AFFILIATIONS = (0,urql_core/* gql */.Ps)(_templateObject6());

// EXTERNAL MODULE: ./gql/exchanges/auth/authState.ts
var auth_authState = __webpack_require__(42956);
;// CONCATENATED MODULE: ./gql/exchanges/auth/ssrAuthExchange.ts










var tokenCache = {};
var createSSRAuthExchange = function(ctx) {
    return authExchange(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(utils) {
            var ref, locale, ref1, srcCode, tokenCacheKey, _tmp;
            return (0,tslib_es6.__generator)(this, function(_state) {
                locale = (0,utils_locale/* getLocaleFromRequest */.Sr)(ctx.req);
                srcCode = (ref1 = (ref = ctx.req.query) === null || ref === void 0 ? void 0 : ref.src) !== null && ref1 !== void 0 ? ref1 : "";
                tokenCacheKey = srcCode ? "".concat(locale, "_").concat(srcCode) : locale;
                _tmp = {};
                return [
                    2,
                    (_tmp.addAuthToOperation = function addAuthToOperation(operation) {
                        var authState = tokenCache[tokenCacheKey];
                        var operationName = getOperationName(operation);
                        // setup request headers
                        var headers = getRequestHeaders(operationName, authState);
                        return utils.appendHeaders(operation, headers);
                    }, _tmp.willAuthError = function willAuthError() {
                        var authState = tokenCache[tokenCacheKey];
                        if (!(authState === null || authState === void 0 ? void 0 : authState.accessToken)) {
                            return true;
                        }
                        return (0,auth_token/* isTokenExpired */.pw)(authState.accessToken);
                    }, _tmp.didAuthError = hasGraphQLAuthError, _tmp.refreshAuth = function refreshAuth() {
                        return (0,_async_to_generator/* default */.Z)(function() {
                            var token, _tmp, authState, _tmp1, err, _tmp2;
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _state.trys.push([
                                            0,
                                            4,
                                            ,
                                            5
                                        ]);
                                        _tmp = {};
                                        return [
                                            4,
                                            (0,auth_token/* getGuestToken */.kh)((_tmp.mutate = utils.mutate, _tmp))
                                        ];
                                    case 1:
                                        token = _state.sent();
                                        authState = (0,auth_authState/* authStateFromPayload */.Y)(token);
                                        tokenCache[tokenCacheKey] = authState;
                                        if (!srcCode) return [
                                            3,
                                            3
                                        ];
                                        _tmp1 = {};
                                        return [
                                            4,
                                            utils.mutate(CREATE_SHOPPER_CONTEXT_MUTATION, (_tmp1.input = {
                                                sourceCode: srcCode
                                            }, _tmp1))
                                        ];
                                    case 2:
                                        _state.sent();
                                        _state.label = 3;
                                    case 3:
                                        return [
                                            3,
                                            5
                                        ];
                                    case 4:
                                        err = _state.sent();
                                        _tmp2 = {};
                                        clientLogger/* clientLogger.error */.u.error((_tmp2.err = err, _tmp2), "authExchange: [ssr] failed to refreshAuth");
                                        return [
                                            3,
                                            5
                                        ];
                                    case 5:
                                        return [
                                            2
                                        ];
                                }
                            });
                        })();
                    }, _tmp)
                ];
            });
        });
        return function(utils) {
            return _ref.apply(this, arguments);
        };
    }());
};

;// CONCATENATED MODULE: ./gql/exchanges/auth/index.ts





// EXTERNAL MODULE: ../node_modules/urql/dist/urql.es.js
var urql_es = __webpack_require__(25380);
;// CONCATENATED MODULE: ../node_modules/react-ssr-prepass/dist/react-ssr-prepass.es.js


function _extends() {
  _extends = Object.assign || function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var n in t) {
        if (Object.prototype.hasOwnProperty.call(t, n)) {
          e[n] = t[n];
        }
      }
    }
    return e;
  };
  return _extends.apply(this, arguments);
}

var n = 60103;

var u = 60106;

var o = 60107;

var react_ssr_prepass_es_a = 60108;

var react_ssr_prepass_es_i = 60114;

var react_ssr_prepass_es_c = 60109;

var l = 60110;

var f = 60111;

var react_ssr_prepass_es_s = 60112;

var react_ssr_prepass_es_v = 60113;

var react_ssr_prepass_es_p = 60115;

var d = 60116;

if ("function" == typeof Symbol && Symbol.for) {
  var m = Symbol.for;
  n = m("react.element");
  u = m("react.portal");
  o = m("react.fragment");
  react_ssr_prepass_es_a = m("react.strict_mode");
  react_ssr_prepass_es_i = m("react.profiler");
  react_ssr_prepass_es_c = m("react.provider");
  l = m("react.context");
  f = Symbol.for("react.concurrent_mode");
  react_ssr_prepass_es_s = m("react.forward_ref");
  react_ssr_prepass_es_v = m("react.suspense");
  react_ssr_prepass_es_p = m("react.memo");
  d = m("react.lazy");
}

var h = n;

var y = u;

var _ = o;

var S = react_ssr_prepass_es_a;

var x = react_ssr_prepass_es_i;

var b = react_ssr_prepass_es_c;

var M = l;

var g = f;

var k = react_ssr_prepass_es_s;

var w = react_ssr_prepass_es_v;

var F = react_ssr_prepass_es_p;

var I = d;

var q = react.Children.toArray;

var isAbstractElement = function(e) {
  return null !== e && "object" == typeof e;
};

var getChildrenArray = function(e) {
  return q(e).filter(isAbstractElement);
};

var computeProps = function(e, r) {
  return "object" == typeof r ? _extends({}, r, e) : e;
};

var E = new Map;

var C = {};

var D = void 0;

var P = void 0;

var getCurrentContextMap = function() {
  return _extends({}, C);
};

var getCurrentContextStore = function() {
  return new Map(E);
};

var flushPrevContextMap = function() {
  var e = D;
  D = void 0;
  return e;
};

var flushPrevContextStore = function() {
  var e = P;
  P = void 0;
  return e;
};

var restoreContextMap = function(e) {
  if (void 0 !== e) {
    _extends(C, e);
  }
};

var restoreContextStore = function(e) {
  if (void 0 !== e) {
    E.set(e[0], e[1]);
  }
};

var setCurrentContextMap = function(e) {
  D = void 0;
  C = e;
};

var setCurrentContextStore = function(e) {
  P = void 0;
  E = e;
};

var readContextValue = function(e) {
  var r = E.get(e);
  if (void 0 !== r) {
    return r;
  }
  return e._currentValue;
};

var R = {};

var maskContext = function(e) {
  var r = e.contextType;
  var t = e.contextTypes;
  if (r) {
    return readContextValue(r);
  } else if (!t) {
    return R;
  }
  var n = {};
  for (var u in t) {
    n[u] = C[u];
  }
  return n;
};

var z = null;

var getCurrentErrorFrame = function() {
  return z;
};

var setCurrentErrorFrame = function(e) {
  z = e || null;
};

var O = {
  current: {
    uniqueID: 0
  }
};

var W = "function" == typeof Object.is ? Object.is : function is(e, r) {
  return e === r && (0 !== e || 1 / e == 1 / r) || e != e && r != r;
};

var j = null;

var setCurrentIdentity = function(e) {
  j = e;
};

var getCurrentIdentity = function() {
  if (null === j) {
    throw new Error("[react-ssr-prepass] Hooks can only be called inside the body of a function component. (https://fb.me/react-invalid-hook-call)");
  }
  return j;
};

var H = null;

var T = null;

var U = !1;

var $ = null;

var A = 0;

var setFirstHook = function(e) {
  H = e;
};

function createWorkInProgressHook() {
  if (null === T) {
    if (null === H) {
      return H = T = {
        memoizedState: null,
        queue: null,
        next: null
      };
    } else {
      return T = H;
    }
  } else if (null === T.next) {
    return T = T.next = {
      memoizedState: null,
      queue: null,
      next: null
    };
  } else {
    return T = T.next;
  }
}

function basicStateReducer(e, r) {
  return "function" == typeof r ? r(e) : r;
}

function useReducer(e, r, t) {
  var n = getCurrentIdentity();
  if (null === (T = createWorkInProgressHook()).queue) {
    var u;
    if (e === basicStateReducer) {
      u = "function" == typeof r ? r() : r;
    } else {
      u = void 0 !== t ? t(r) : r;
    }
    T.memoizedState = u;
  }
  var o = T.queue || (T.queue = {
    last: null,
    dispatch: null
  });
  var a = o.dispatch || (o.dispatch = dispatchAction.bind(null, n, o));
  if (null !== $) {
    var i = $.get(o);
    if (void 0 !== i) {
      $.delete(o);
      var c = T.memoizedState;
      var l = i;
      do {
        c = e(c, l.action);
        l = l.next;
      } while (null !== l);
      T.memoizedState = c;
    }
  }
  return [ T.memoizedState, a ];
}

function useMemo(e, r) {
  getCurrentIdentity();
  var t = void 0 === r ? null : r;
  var n = (T = createWorkInProgressHook()).memoizedState;
  if (null !== n && null !== t) {
    if (function areHookInputsEqual(e, r) {
      if (null === r) {
        return !1;
      }
      for (var t = 0; t < r.length && t < e.length; t++) {
        if (!W(e[t], r[t])) {
          return !1;
        }
      }
      return !0;
    }(t, n[1])) {
      return n[0];
    }
  }
  var u = e();
  T.memoizedState = [ u, t ];
  return u;
}

function useOpaqueIdentifier() {
  getCurrentIdentity();
  if (!(T = createWorkInProgressHook()).memoizedState) {
    T.memoizedState = "R:" + (O.current.uniqueID++).toString(36);
  }
  return T.memoizedState;
}

function dispatchAction(e, r, t) {
  if (e === j) {
    U = !0;
    var n = {
      action: t,
      next: null
    };
    if (null === $) {
      $ = new Map;
    }
    var u = $.get(r);
    if (void 0 === u) {
      $.set(r, n);
    } else {
      var o = u;
      while (null !== o.next) {
        o = o.next;
      }
      o.next = n;
    }
  }
}

function noop() {}

function _ref$2(e) {
  e();
}

var N = {
  readContext: function readContext(e, r) {
    return readContextValue(e);
  },
  useSyncExternalStore: function useSyncExternalStore(e, r, t) {
    return r();
  },
  useContext: function useContext(e, r) {
    getCurrentIdentity();
    return readContextValue(e);
  },
  useMemo: useMemo,
  useReducer: useReducer,
  useRef: function useRef(e) {
    getCurrentIdentity();
    var r = (T = createWorkInProgressHook()).memoizedState;
    if (null === r) {
      var t = {
        current: e
      };
      T.memoizedState = t;
      return t;
    } else {
      return r;
    }
  },
  useState: function useState(e) {
    return useReducer(basicStateReducer, e);
  },
  useCallback: function useCallback(e, r) {
    return useMemo((function() {
      return e;
    }), r);
  },
  useMutableSource: function useMutableSource(e, r, t) {
    getCurrentIdentity();
    return r(e._source);
  },
  useTransition: function useTransition() {
    return [ _ref$2, !1 ];
  },
  useDeferredValue: function useDeferredValue(e) {
    return e;
  },
  useOpaqueIdentifier: useOpaqueIdentifier,
  useId: useOpaqueIdentifier,
  unstable_useId: useOpaqueIdentifier,
  unstable_useOpaqueIdentifier: useOpaqueIdentifier,
  useLayoutEffect: noop,
  useImperativeHandle: noop,
  useEffect: noop,
  useDebugValue: noop
};

var resolve = function(e) {
  var r = e._payload || e;
  if (0 === r._status) {
    return r._result;
  } else if (1 === r._status) {
    return Promise.resolve(r._result);
  } else if (2 === r._status) {
    return Promise.reject(r._result);
  }
  r._status = 0;
  return r._result = (r._ctor || r._result)().then((function(e) {
    r._result = e;
    if ("function" == typeof e) {
      r._status = 1;
    } else if (null !== e && "object" == typeof e && "function" == typeof e.default) {
      r._result = e.default;
      r._status = 1;
    } else {
      r._status = 2;
    }
  })).catch((function(e) {
    r._status = 2;
    r._result = e;
    return Promise.reject(e);
  }));
};

var render$3 = function(e, r, n) {
  var u = e._payload || e;
  if (1 === u._status) {
    return (0,react.createElement)(u._result, r);
  }
  return null;
};

var makeFrame$1 = function(e, r, t) {
  return {
    contextMap: getCurrentContextMap(),
    contextStore: getCurrentContextStore(),
    id: getCurrentIdentity(),
    hook: H,
    kind: "frame.hooks",
    errorFrame: getCurrentErrorFrame(),
    thenable: t,
    props: r,
    type: e
  };
};

var render$2 = function(e, r, t) {
  try {
    return function renderWithHooks(e, r, t) {
      T = null;
      var n = e(r, t);
      while (A < 25 && U) {
        U = !1;
        A += 1;
        T = null;
        n = e(r, t);
      }
      A = 0;
      $ = null;
      T = null;
      return n;
    }(e, computeProps(r, e.defaultProps), maskContext(e));
  } catch (n) {
    if ("function" != typeof n.then) {
      throw n;
    }
    t.push(makeFrame$1(e, r, n));
    return null;
  }
};

function _ref$1() {
  return !1;
}

function _ref2() {
  return null;
}

var createInstance = function(e, r) {
  var t = {
    _thrown: 0,
    queue: n = [],
    isMounted: _ref$1,
    enqueueForceUpdate: _ref2,
    enqueueReplaceState: function(e, r) {
      if (e._isMounted) {
        n.length = 0;
        n.push(r);
      }
    },
    enqueueSetState: function(e, r) {
      if (e._isMounted) {
        n.push(r);
      }
    }
  };
  var n;
  var u = computeProps(r, e.defaultProps);
  var o = maskContext(e);
  var a = new e(u, o, t);
  a.props = u;
  a.context = o;
  a.updater = t;
  a._isMounted = !0;
  if (void 0 === a.state) {
    a.state = null;
  }
  if ("function" == typeof a.componentDidCatch || "function" == typeof e.getDerivedStateFromError) {
    var i = makeFrame(e, a, null);
    i.errorFrame = i;
    setCurrentErrorFrame(i);
  }
  if ("function" == typeof e.getDerivedStateFromProps) {
    var c = (0, e.getDerivedStateFromProps)(a.props, a.state);
    if (null != c) {
      a.state = _extends({}, a.state, c);
    }
  } else if ("function" == typeof a.componentWillMount) {
    a.componentWillMount();
  } else if ("function" == typeof a.UNSAFE_componentWillMount) {
    a.UNSAFE_componentWillMount();
  }
  return a;
};

var makeFrame = function(e, r, t) {
  return {
    contextMap: getCurrentContextMap(),
    contextStore: getCurrentContextStore(),
    errorFrame: getCurrentErrorFrame(),
    thenable: t,
    kind: "frame.class",
    error: null,
    instance: r,
    type: e
  };
};

var render$1 = function(e, r, t) {
  !function(e) {
    var r = e.updater.queue;
    if (r.length > 0) {
      var t = _extends({}, e.state);
      for (var n = 0, u = r.length; n < u; n++) {
        var o = r[n];
        var a = "function" == typeof o ? o.call(e, t, e.props, e.context) : o;
        if (null !== a) {
          _extends(t, a);
        }
      }
      e.state = t;
      r.length = 0;
    }
  }(r);
  var n = null;
  try {
    n = r.render();
  } catch (n) {
    if ("function" != typeof n.then) {
      throw n;
    }
    t.push(makeFrame(e, r, n));
    return null;
  }
  if (void 0 !== e.childContextTypes && "function" == typeof r.getChildContext) {
    var u = r.getChildContext();
    if (null !== u && "object" == typeof u) {
      !function(e) {
        D = {};
        for (var r in e) {
          D[r] = C[r];
          C[r] = e[r];
        }
      }(u);
    }
  }
  if ("function" != typeof r.getDerivedStateFromProps && ("function" == typeof r.componentWillMount || "function" == typeof r.UNSAFE_componentWillMount) && "function" == typeof r.componentWillUnmount) {
    try {
      r.componentWillUnmount();
    } catch (e) {}
  }
  r._isMounted = !1;
  return n;
};

var L = react.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentDispatcher;

var V = "function" == typeof setImmediate;

var render = function(e, r, t, n, u) {
  return (o = e).prototype && o.prototype.isReactComponent ? function(e, r, t, n, u) {
    setCurrentIdentity(null);
    var o = createInstance(e, r);
    var a = n(u, o);
    if (a) {
      t.push(makeFrame(e, o, a));
      return null;
    }
    return render$1(e, o, t);
  }(e, r, t, n, u) : function(e, r, t, n, u) {
    setFirstHook(null);
    setCurrentIdentity({});
    var o = n(u);
    if (o) {
      t.push(makeFrame$1(e, r, o));
      return null;
    }
    return render$2(e, r, t);
  }(e, r, t, n, u);
  var o;
};

var visitElement = function(e, r, n) {
  switch (function(e) {
    switch (e.$$typeof) {
     case y:
      return y;

     case h:
      switch (e.type) {
       case g:
        return g;

       case _:
        return _;

       case x:
        return x;

       case S:
        return S;

       case w:
        return w;

       default:
        switch (e.type && e.type.$$typeof) {
         case I:
          return I;

         case F:
          return F;

         case M:
          return M;

         case b:
          return b;

         case k:
          return k;

         default:
          return h;
        }
      }

     default:
      return;
    }
  }(e)) {
   case w:
   case S:
   case g:
   case x:
   case _:
    return getChildrenArray(e.props.children);

   case b:
    var u = e.props;
    var o = u.children;
    !function(e, r) {
      P = [ e, E.get(e) ];
      E.set(e, r);
    }(e.type._context, u.value);
    return getChildrenArray(o);

   case M:
    var a = e.props.children;
    if ("function" == typeof a) {
      var i = e.type;
      var c = readContextValue("object" == typeof i._context ? i._context : i);
      return getChildrenArray(a(c));
    } else {
      return [];
    }

   case I:
    var l = function(e, r, t) {
      if ((e._payload || e)._status <= 0) {
        t.push({
          kind: "frame.lazy",
          contextMap: getCurrentContextMap(),
          contextStore: getCurrentContextStore(),
          errorFrame: getCurrentErrorFrame(),
          thenable: resolve(e),
          props: r,
          type: e
        });
        return null;
      }
      return render$3(e, r);
    }(e.type, e.props, r);
    return getChildrenArray(l);

   case F:
    var f = (0,react.createElement)(e.type.type, e.props);
    return getChildrenArray(f);

   case k:
    var s = e.type;
    var v = s.render;
    var p = computeProps(e.props, s.defaultProps);
    var d = (0,react.createElement)(v, p);
    return getChildrenArray(d);

   case h:
    if ("string" == typeof e.type) {
      return getChildrenArray(e.props.children);
    } else {
      var m = render(e.type, e.props, r, n, e);
      return getChildrenArray(m);
    }

   default:
    return [];
  }
};

var visitLoop = function(e, r, t, n, u, o) {
  var a = L.current;
  var i = Date.now();
  try {
    L.current = N;
    while (e.length > 0) {
      var c = e[e.length - 1].shift();
      if (void 0 !== c) {
        var l = visitElement(c, u, o);
        e.push(l);
        r.push(flushPrevContextMap());
        t.push(flushPrevContextStore());
        n.push(getCurrentErrorFrame());
      } else {
        e.pop();
        restoreContextMap(r.pop());
        restoreContextStore(t.pop());
        setCurrentErrorFrame(n.pop());
      }
      if (V && Date.now() - i > 5) {
        return !0;
      }
    }
    return !1;
  } catch (e) {
    var f = getCurrentErrorFrame();
    if (!f) {
      throw e;
    }
    f.error = e;
    u.unshift(f);
    return !1;
  } finally {
    L.current = a;
  }
};

var makeYieldFrame = function(e, r, t, n) {
  return {
    contextMap: getCurrentContextMap(),
    contextStore: getCurrentContextStore(),
    errorFrame: getCurrentErrorFrame(),
    thenable: null,
    kind: "frame.yield",
    traversalChildren: e,
    traversalMap: r,
    traversalStore: t,
    traversalErrorFrame: n
  };
};

var visit = function(e, r, t) {
  var n = [ e ];
  var u = [ flushPrevContextMap() ];
  var o = [ flushPrevContextStore() ];
  var a = [ getCurrentErrorFrame() ];
  if (visitLoop(n, u, o, a, r, t)) {
    r.unshift(makeYieldFrame(n, u, o, a));
  }
};

var update = function(e, r, t) {
  if ("frame.yield" === e.kind) {
    setCurrentIdentity(null);
    setCurrentContextMap(e.contextMap);
    setCurrentContextStore(e.contextStore);
    setCurrentErrorFrame(e.errorFrame);
    if (visitLoop(e.traversalChildren, e.traversalMap, e.traversalStore, e.traversalErrorFrame, r, t)) {
      r.unshift(makeYieldFrame(e.traversalChildren, e.traversalMap, e.traversalStore, e.traversalErrorFrame));
    }
  } else {
    var n = L.current;
    var u = null;
    L.current = N;
    try {
      if ("frame.class" === e.kind) {
        u = function(e, r) {
          setCurrentIdentity(null);
          setCurrentContextMap(r.contextMap);
          setCurrentContextStore(r.contextStore);
          setCurrentErrorFrame(r.errorFrame);
          if (r.error) {
            if (++r.instance.updater._thrown >= 25) {
              return null;
            }
            r.instance._isMounted = !0;
            if ("function" == typeof r.instance.componentDidCatch) {
              r.instance.componentDidCatch(r.error);
            }
            if ("function" == typeof r.type.getDerivedStateFromError) {
              r.instance.updater.enqueueSetState(r.instance, r.type.getDerivedStateFromError(r.error));
            }
          }
          return render$1(r.type, r.instance, e);
        }(r, e);
      } else if ("frame.hooks" === e.kind) {
        u = function(e, r) {
          setFirstHook(r.hook);
          setCurrentIdentity(r.id);
          setCurrentContextMap(r.contextMap);
          setCurrentContextStore(r.contextStore);
          setCurrentErrorFrame(r.errorFrame);
          return render$2(r.type, r.props, e);
        }(r, e);
      } else if ("frame.lazy" === e.kind) {
        u = function(e, r) {
          setCurrentIdentity(null);
          setCurrentContextMap(r.contextMap);
          setCurrentContextStore(r.contextStore);
          setCurrentErrorFrame(r.errorFrame);
          return render$3(r.type, r.props);
        }(0, e);
      }
    } catch (e) {
      var o = getCurrentErrorFrame();
      if (!o) {
        throw e;
      }
      o.error = e;
      r.unshift(o);
      u = null;
    } finally {
      L.current = n;
    }
    visit(getChildrenArray(u), r, t);
  }
};

function _ref(e, r) {
  setImmediate(e);
}

var flushFrames = function(e, r, t) {
  var n = e.shift();
  if (!n) {
    return Promise.resolve();
  }
  if (V && "frame.yield" === n.kind) {
    n.thenable = new Promise(_ref);
  }
  return Promise.resolve(n.thenable).then((function() {
    !function(e) {
      O.current = e;
    }(t);
    update(n, e, r);
    return flushFrames(e, r, t);
  }), (function(t) {
    if (!n.errorFrame) {
      throw t;
    }
    n.errorFrame.error = t;
    update(n.errorFrame, e, r);
  }));
};

var defaultVisitor = function() {
  return;
};

var renderPrepass = function(e, r) {
  if (!r) {
    r = defaultVisitor;
  }
  var t = [];
  var n = O.current = {
    uniqueID: 0
  };
  setCurrentContextMap({});
  setCurrentContextStore(new Map);
  setCurrentErrorFrame(null);
  try {
    visit(getChildrenArray(e), t, r);
  } catch (e) {
    return Promise.reject(e);
  }
  return flushFrames(t, r, n);
};


//# sourceMappingURL=react-ssr-prepass.es.js.map

;// CONCATENATED MODULE: ../node_modules/next-urql/dist/next-urql.es.js








var next_urql_es_p = null;

function resetClient() {
  next_urql_es_p = null;
}

function initUrqlClient(e, t) {
  var r = "undefined" == typeof window;
  if (r || !next_urql_es_p) {
    (next_urql_es_p = (0,urql_core/* createClient */.eI)({
      ...e,
      suspense: t && (r || e.suspense)
    })).toJSON = () => null;
  }
  return next_urql_es_p;
}

var next_urql_es_f;

function withUrqlClient(u, p) {
  if (!p) {
    p = {};
  }
  return v => {
    var d = Boolean((v.getInitialProps || p.ssr) && !p.neverSuspend);
    var WithUrql = ({pageProps: s, urqlClient: q, urqlState: C, ...g}) => {
      var [w, c] = (0,react.useReducer)((e => e + 1), 0);
      var m = s && s.urqlState || C;
      var h = (0,react.useMemo)((() => {
        if (q && !w) {
          return q;
        }
        if (!next_urql_es_f || "undefined" == typeof window) {
          next_urql_es_f = (0,urql_core/* ssrExchange */.$Y)({
            initialState: m,
            isClient: !0,
            staleWhileRevalidate: "undefined" != typeof window ? p.staleWhileRevalidate : void 0
          });
        } else if (!w) {
          next_urql_es_f.restoreData(m);
        }
        var e = u(next_urql_es_f);
        if (!e.exchanges) {
          e.exchanges = [ urql_core/* cacheExchange */.HG, next_urql_es_f, urql_core/* fetchExchange */.Ek ];
        }
        return initUrqlClient(e, d);
      }), [ q, m, w ]);
      var y = (0,react.useCallback)((() => {
        resetClient();
        next_urql_es_f = (0,urql_core/* ssrExchange */.$Y)({
          initialState: void 0
        });
        c();
      }), []);
      return (0,react.createElement)(urql_es/* Provider */.zt, {
        value: h
      }, (0,react.createElement)(v, {
        ...g,
        pageProps: s,
        urqlClient: h,
        resetUrqlClient: y
      }));
    };
    WithUrql.displayName = `withUrqlClient(${v.displayName || v.name || "Component"})`;
    if (v.getLayout) {
      WithUrql.getLayout = v.getLayout;
    }
    if (v.getInitialProps || p.ssr) {
      WithUrql.getInitialProps = async t => {
        var r = t.AppTree;
        var i = !!t.Component;
        var o = i ? t.ctx : t;
        var f = (0,urql_core/* ssrExchange */.$Y)({
          initialState: void 0
        });
        var d = u(f, o);
        if (!d.exchanges) {
          d.exchanges = [ urql_core/* cacheExchange */.HG, f, urql_core/* fetchExchange */.Ek ];
        }
        var q = initUrqlClient(d, !p.neverSuspend);
        if (q) {
          o.urqlClient = q;
        }
        var C = {};
        if (v.getInitialProps) {
          C = await v.getInitialProps(t);
          if (o.res && (o.res.writableEnded || o.res.finished)) {
            return {
              ...C,
              urqlClient: q
            };
          }
        }
        if ("undefined" != typeof window) {
          return {
            ...C,
            urqlClient: q
          };
        }
        var g = {
          ...C,
          urqlClient: q
        };
        var w = i ? {
          pageProps: {},
          ...g
        } : {
          pageProps: g
        };
        if (!p.neverSuspend) {
          await renderPrepass((0,react.createElement)(r, w));
        }
        return {
          ...C,
          urqlState: f ? f.extractData() : void 0,
          urqlClient: q
        };
      };
    }
    return WithUrql;
  };
}


//# sourceMappingURL=next-urql.es.js.map

// EXTERNAL MODULE: ../node_modules/@0no-co/graphql.web/dist/graphql.web.mjs
var graphql_web = __webpack_require__(7846);
;// CONCATENATED MODULE: ../node_modules/@urql/exchange-graphcache/dist/urql-exchange-graphcache.mjs






var getName = e => e.name.value;

var getFragmentTypeName = e => e.typeCondition.name.value;

var getFieldAlias = e => e.alias ? e.alias.value : e.name.value;

var urql_exchange_graphcache_y = [];

var getSelectionSet = e => e.selectionSet ? e.selectionSet.selections : urql_exchange_graphcache_y;

var getTypeCondition = e => e.typeCondition ? e.typeCondition.name.value : null;

var isFieldNode = e => e.kind === graphql_web/* Kind.FIELD */.hY.FIELD;

var isInlineFragment = e => e.kind === graphql_web/* Kind.INLINE_FRAGMENT */.hY.INLINE_FRAGMENT;

var getFieldArguments = (e, r) => {
  var t = null;
  if (e.arguments) {
    for (var i = 0, a = e.arguments.length; i < a; i++) {
      var n = e.arguments[i];
      var o = (0,graphql_web/* valueFromASTUntyped */.Mq)(n.value, r);
      if (null != o) {
        if (!t) {
          t = {};
        }
        t[getName(n)] = o;
      }
    }
  }
  return t;
};

var filterVariables = (e, r) => {
  if (!r || !e.variableDefinitions) {
    return;
  }
  var t = {};
  for (var i = 0, a = e.variableDefinitions.length; i < a; i++) {
    var n = getName(e.variableDefinitions[i].variable);
    t[n] = r[n];
  }
  return t;
};

var normalizeVariables = (e, r) => {
  var t = {};
  if (!r) {
    return t;
  }
  if (e.variableDefinitions) {
    for (var i = 0, a = e.variableDefinitions.length; i < a; i++) {
      var n = e.variableDefinitions[i];
      var o = getName(n.variable);
      t[o] = void 0 === r[o] && n.defaultValue ? (0,graphql_web/* valueFromASTUntyped */.Mq)(n.defaultValue, r) : r[o];
    }
  }
  for (var s in r) {
    if (!(s in t)) {
      t[s] = r[s];
    }
  }
  return t;
};

var urql_exchange_graphcache_h = "\nhttps://bit.ly/2XbVrpR#";

var urql_exchange_graphcache_m = new Set;

var urql_exchange_graphcache_g = (/* unused pure expression or super */ null && ([]));

var popDebugNode = () => urql_exchange_graphcache_g.pop();

var pushDebugNode = (e, r) => {
  var t = "";
  if (r.kind === p.INLINE_FRAGMENT) {
    t = e ? `Inline Fragment on "${e}"` : "Inline Fragment";
  } else if (r.kind === p.OPERATION_DEFINITION) {
    t = `${r.name ? `"${r.name.value}"` : "Unnamed"} ${r.operation}`;
  } else if (r.kind === p.FRAGMENT_DEFINITION) {
    t = `"${r.name.value}" Fragment`;
  }
  if (t) {
    urql_exchange_graphcache_g.push(t);
  }
};

var getDebugOutput = () => urql_exchange_graphcache_g.length ? "\n(Caused At: " + urql_exchange_graphcache_g.join(", ") + ")" : "";

function invariant(e, r, t) {
  if (!e) {
    var i = r || "Minfied Error #" + t + "\n";
    if (false) {}
    var a = new Error(i + urql_exchange_graphcache_h + t);
    a.name = "Graphcache Error";
    throw a;
  }
}

function warn(e, r) {
  if (!urql_exchange_graphcache_m.has(e)) {
    console.warn(e + getDebugOutput() + urql_exchange_graphcache_h + r);
    urql_exchange_graphcache_m.add(e);
  }
}

var getMainOperation = e => {
  for (var r = 0; r < e.definitions.length; r++) {
    if (e.definitions[r].kind === graphql_web/* Kind.OPERATION_DEFINITION */.hY.OPERATION_DEFINITION) {
      return e.definitions[r];
    }
  }
  invariant(!1,  false ? 0 : "", 1);
};

var getFragments = e => {
  var r = {};
  for (var t = 0; t < e.definitions.length; t++) {
    var i = e.definitions[t];
    if (i.kind === graphql_web/* Kind.FRAGMENT_DEFINITION */.hY.FRAGMENT_DEFINITION) {
      r[getName(i)] = i;
    }
  }
  return r;
};

var shouldInclude = (e, r) => {
  for (var t = 0; e.directives && t < e.directives.length; t++) {
    var i = e.directives[t];
    var a = getName(i);
    if (("include" === a || "skip" === a) && i.arguments && i.arguments[0] && "if" === getName(i.arguments[0])) {
      var n = (0,graphql_web/* valueFromASTUntyped */.Mq)(i.arguments[0].value, r);
      return "include" === a ? !!n : !n;
    }
  }
  return !0;
};

var isDeferred = (e, r) => {
  for (var t = 0; e.directives && t < e.directives.length; t++) {
    var i = e.directives[t];
    if ("defer" === getName(i)) {
      for (var a = 0; i.arguments && a < i.arguments.length; a++) {
        var n = i.arguments[t];
        if ("if" === getName(n)) {
          return !!(0,graphql_web/* valueFromASTUntyped */.Mq)(n.value, r);
        }
      }
      return !0;
    }
  }
  return !1;
};

var urql_exchange_graphcache_ = "__";

var isFieldNullable = (e, r, t) => {
  var i = getField(e, r, t);
  return !!i && "NON_NULL" !== i.type.kind;
};

var isListNullable = (e, r, t) => {
  var i = getField(e, r, t);
  if (!i) {
    return !1;
  }
  var a = "NON_NULL" === i.type.kind ? i.type.ofType : i.type;
  return "LIST" === a.kind && "NON_NULL" !== a.ofType.kind;
};

var isFieldAvailableOnType = (e, r, t) => 0 === t.indexOf(urql_exchange_graphcache_) || 0 === r.indexOf(urql_exchange_graphcache_) || !!getField(e, r, t);

var isInterfaceOfType = (e, r, t) => {
  if (!t) {
    return !1;
  }
  var i = getTypeCondition(r);
  if (!i || t === i) {
    return !0;
  } else if (e.types.has(i) && "OBJECT" === e.types.get(i).kind) {
    return i === t;
  }
  !function expectAbstractType(e, r) {
    invariant(e.types.has(r) && ("INTERFACE" === e.types.get(r).kind || "UNION" === e.types.get(r).kind),  false ? 0 : "", 5);
  }(e, i);
  expectObjectType(e, t);
  return e.isSubType(i, t);
};

var getField = (e, r, t) => {
  if (0 === t.indexOf(urql_exchange_graphcache_) || 0 === r.indexOf(urql_exchange_graphcache_)) {
    return;
  }
  expectObjectType(e, r);
  var i = e.types.get(r).fields()[t];
  if (false) {}
  return i;
};

function expectObjectType(e, r) {
  invariant(e.types.has(r) && "OBJECT" === e.types.get(r).kind,  false ? 0 : "", 3);
}

function warnAboutResolver(e) {
   false && 0;
}

var keyOfField = (r, t) => t ? `${r}(${(0,urql_core_chunk.i)(t)})` : r;

var joinKeys = (e, r) => `${e}.${r}`;

var fieldInfoOfKey = e => {
  var r = e.indexOf("(");
  if (r > -1) {
    return {
      fieldKey: e,
      fieldName: e.slice(0, r),
      arguments: JSON.parse(e.slice(r + 1, -1))
    };
  } else {
    return {
      fieldKey: e,
      fieldName: e,
      arguments: null
    };
  }
};

var deserializeKeyInfo = e => {
  var r = e.indexOf(".");
  return {
    entityKey: e.slice(0, r).replace(/%2e/g, "."),
    fieldKey: e.slice(r + 1)
  };
};

var makeDict = () => Object.create(null);

var urql_exchange_graphcache_N = null;

var urql_exchange_graphcache_E = null;

var urql_exchange_graphcache_O = null;

var urql_exchange_graphcache_k = null;

var urql_exchange_graphcache_w = null;

var urql_exchange_graphcache_b = null;

var urql_exchange_graphcache_D = !1;

var makeData = e => {
  var r;
  if (e) {
    if (urql_exchange_graphcache_N.has(e)) {
      return e;
    }
    r = urql_exchange_graphcache_E.get(e) || {
      ...e
    };
    urql_exchange_graphcache_E.set(e, r);
  } else {
    r = {};
  }
  urql_exchange_graphcache_N.add(r);
  return r;
};

var ownsData = e => !!e && urql_exchange_graphcache_N.has(e);

var initDataState = (e, r, t, i) => {
  urql_exchange_graphcache_N = new WeakSet;
  urql_exchange_graphcache_E = new WeakMap;
  urql_exchange_graphcache_O = e;
  urql_exchange_graphcache_k = r;
  urql_exchange_graphcache_w = new Set;
  urql_exchange_graphcache_D = !!i;
  if (false) {}
  if (!t) {
    urql_exchange_graphcache_b = null;
  } else if ("read" === urql_exchange_graphcache_O) {
    urql_exchange_graphcache_b = t;
  } else if (i || r.optimisticOrder.length > 1) {
    if (!i && !r.commutativeKeys.has(t)) {
      reserveLayer(r, t);
    } else if (i) {
      if (-1 !== r.optimisticOrder.indexOf(t) && !r.commutativeKeys.has(t)) {
        r.optimisticOrder.splice(r.optimisticOrder.indexOf(t), 1);
      }
      r.commutativeKeys.delete(t);
    }
    urql_exchange_graphcache_b = t;
    createLayer(r, t);
  } else {
    urql_exchange_graphcache_b = null;
    deleteLayer(r, t);
  }
};

var clearDataState = () => {
  if (false) {}
  var e = urql_exchange_graphcache_k;
  var r = urql_exchange_graphcache_b;
  urql_exchange_graphcache_D = !1;
  urql_exchange_graphcache_b = null;
  if (r && e.optimisticOrder.indexOf(r) > -1) {
    var t = e.optimisticOrder.length;
    while (--t >= 0 && e.dirtyKeys.has(e.optimisticOrder[t]) && e.commutativeKeys.has(e.optimisticOrder[t])) {
      squashLayer(e.optimisticOrder[t]);
    }
  }
  urql_exchange_graphcache_N = null;
  urql_exchange_graphcache_E = null;
  urql_exchange_graphcache_O = null;
  urql_exchange_graphcache_k = null;
  urql_exchange_graphcache_w = null;
  if (false) {}
  if (true) {
    if (!e.defer && (e.storage || !e.optimisticOrder.length)) {
      e.defer = !0;
      setTimeout((() => {
        initDataState("read", e, null);
        gc();
        persistData();
        clearDataState();
        e.defer = !1;
      }));
    }
  }
};

var noopDataState = (e, r, t) => {
  if (r && !t) {
    e.deferredKeys.delete(r);
  }
  initDataState("write", e, r, t);
  clearDataState();
};

var getCurrentOperation = () => {
  invariant(null !== urql_exchange_graphcache_O,  false ? 0 : "", 2);
  return urql_exchange_graphcache_O;
};

var getCurrentDependencies = () => {
  invariant(null !== urql_exchange_graphcache_w,  false ? 0 : "", 2);
  return urql_exchange_graphcache_w;
};

var setNode = (e, r, t, i) => {
  if (false) {}
  var a = urql_exchange_graphcache_b ? e.optimistic.get(urql_exchange_graphcache_b) : e.base;
  var n = a.get(r);
  if (void 0 === n) {
    a.set(r, n = makeDict());
  }
  if (void 0 === i && !urql_exchange_graphcache_b) {
    delete n[t];
  } else {
    n[t] = i;
  }
};

var getNode = (e, r, t) => {
  var i;
  var a = !urql_exchange_graphcache_D && "read" === urql_exchange_graphcache_O && urql_exchange_graphcache_b && urql_exchange_graphcache_k.commutativeKeys.has(urql_exchange_graphcache_b);
  for (var n = 0, o = urql_exchange_graphcache_k.optimisticOrder.length; n < o; n++) {
    var s = urql_exchange_graphcache_k.optimisticOrder[n];
    var v = e.optimistic.get(s);
    a = a && s !== urql_exchange_graphcache_b;
    if (v && (!a || !urql_exchange_graphcache_k.commutativeKeys.has(s)) && (!urql_exchange_graphcache_D || "write" === urql_exchange_graphcache_O || urql_exchange_graphcache_k.commutativeKeys.has(s)) && void 0 !== (i = v.get(r)) && t in i) {
      return i[t];
    }
  }
  return void 0 !== (i = e.base.get(r)) ? i[t] : void 0;
};

var updateRCForLink = (e, r) => {
  if (Array.isArray(e)) {
    for (var t = 0, i = e.length; t < i; t++) {
      updateRCForLink(e[t], r);
    }
  } else if ("string" == typeof e) {
    ((e, r) => {
      var t = urql_exchange_graphcache_k.refCount.get(e) || 0;
      var i = t + r > 0 ? t + r : 0;
      urql_exchange_graphcache_k.refCount.set(e, i);
      if (!i) {
        urql_exchange_graphcache_k.gc.add(e);
      } else if (!t && i) {
        urql_exchange_graphcache_k.gc.delete(e);
      }
    })(e, r);
  }
};

var extractNodeFields = (e, r, t) => {
  if (void 0 !== t) {
    for (var i in t) {
      if (!r.has(i)) {
        e.push(fieldInfoOfKey(i));
        r.add(i);
      }
    }
  }
};

var extractNodeMapFields = (e, r, t, i) => {
  extractNodeFields(e, r, i.base.get(t));
  for (var a = 0, n = urql_exchange_graphcache_k.optimisticOrder.length; a < n; a++) {
    var o = i.optimistic.get(urql_exchange_graphcache_k.optimisticOrder[a]);
    if (void 0 !== o) {
      extractNodeFields(e, r, o.get(t));
    }
  }
};

var gc = () => {
  if (urql_exchange_graphcache_k.optimisticOrder.length) {
    return;
  }
  for (var e of urql_exchange_graphcache_k.gc.keys()) {
    urql_exchange_graphcache_k.gc.delete(e);
    if ((urql_exchange_graphcache_k.refCount.get(e) || 0) > 0) {
      continue;
    }
    urql_exchange_graphcache_k.refCount.delete(e);
    urql_exchange_graphcache_k.records.base.delete(e);
    var r = urql_exchange_graphcache_k.links.base.get(e);
    if (r) {
      urql_exchange_graphcache_k.links.base.delete(e);
      for (var t in r) {
        updateRCForLink(r[t], -1);
      }
    }
  }
};

var updateDependencies = (e, r) => {
  if ("__typename" !== r) {
    if (e !== urql_exchange_graphcache_k.queryRootKey) {
      urql_exchange_graphcache_w.add(e);
    } else if (void 0 !== r) {
      urql_exchange_graphcache_w.add(joinKeys(e, r));
    }
  }
};

var updatePersist = (e, r) => {
  if (!urql_exchange_graphcache_D && urql_exchange_graphcache_k.storage) {
    urql_exchange_graphcache_k.persist.add(((e, r) => `${e.replace(/\./g, "%2e")}.${r}`)(e, r));
  }
};

var readRecord = (e, r) => {
  updateDependencies(e, r);
  return getNode(urql_exchange_graphcache_k.records, e, r);
};

var readLink = (e, r) => {
  updateDependencies(e, r);
  return getNode(urql_exchange_graphcache_k.links, e, r);
};

var writeRecord = (e, r, t) => {
  updateDependencies(e, r);
  updatePersist(e, r);
  setNode(urql_exchange_graphcache_k.records, e, r, t);
};

var writeLink = (e, r, t) => {
  var i = urql_exchange_graphcache_b ? urql_exchange_graphcache_k.links.optimistic.get(urql_exchange_graphcache_b) : urql_exchange_graphcache_k.links.base;
  if (!urql_exchange_graphcache_b) {
    var a = i && i.get(e);
    updateRCForLink(a && a[r], -1);
    updateRCForLink(t, 1);
  }
  updateDependencies(e, r);
  updatePersist(e, r);
  setNode(urql_exchange_graphcache_k.links, e, r, t);
};

var reserveLayer = (e, r, t) => {
  var i = e.optimisticOrder.indexOf(r);
  if (i > -1) {
    e.optimisticOrder.splice(i, 1);
  }
  if (t) {
    e.deferredKeys.add(r);
    for (i = i > -1 ? i : 0; i < e.optimisticOrder.length && !e.deferredKeys.has(e.optimisticOrder[i]) && (!e.dirtyKeys.has(e.optimisticOrder[i]) || !e.commutativeKeys.has(e.optimisticOrder[i])); i++) {}
  } else {
    e.deferredKeys.delete(r);
    if (i > -1 && !e.commutativeKeys.has(r)) {
      clearLayer(e, r);
    }
    i = 0;
  }
  e.optimisticOrder.splice(i, 0, r);
  e.commutativeKeys.add(r);
};

var createLayer = (e, r) => {
  if (-1 === e.optimisticOrder.indexOf(r)) {
    e.optimisticOrder.unshift(r);
  }
  if (!e.dirtyKeys.has(r)) {
    e.dirtyKeys.add(r);
    e.links.optimistic.set(r, new Map);
    e.records.optimistic.set(r, new Map);
  }
};

var clearLayer = (e, r) => {
  if (e.dirtyKeys.has(r)) {
    e.dirtyKeys.delete(r);
    e.records.optimistic.delete(r);
    e.links.optimistic.delete(r);
    e.deferredKeys.delete(r);
  }
};

var deleteLayer = (e, r) => {
  var t = e.optimisticOrder.indexOf(r);
  if (t > -1) {
    e.optimisticOrder.splice(t, 1);
    e.commutativeKeys.delete(r);
  }
  clearLayer(e, r);
};

var squashLayer = e => {
  var r = urql_exchange_graphcache_w;
  urql_exchange_graphcache_w = new Set;
  urql_exchange_graphcache_O = "write";
  var t = urql_exchange_graphcache_k.links.optimistic.get(e);
  if (t) {
    for (var i of t.entries()) {
      var a = i[0];
      var n = i[1];
      for (var o in n) {
        writeLink(a, o, n[o]);
      }
    }
  }
  var s = urql_exchange_graphcache_k.records.optimistic.get(e);
  if (s) {
    for (var v of s.entries()) {
      var l = v[0];
      var u = v[1];
      for (var d in u) {
        writeRecord(l, d, u[d]);
      }
    }
  }
  urql_exchange_graphcache_w = r;
  deleteLayer(urql_exchange_graphcache_k, e);
};

var inspectFields = e => {
  var {links: r, records: t} = urql_exchange_graphcache_k;
  var i = [];
  var a = new Set;
  updateDependencies(e);
  extractNodeMapFields(i, a, e, r);
  extractNodeMapFields(i, a, e, t);
  return i;
};

var persistData = () => {
  if (urql_exchange_graphcache_k.storage) {
    urql_exchange_graphcache_D = !0;
    urql_exchange_graphcache_O = "read";
    var r = makeDict();
    for (var t of urql_exchange_graphcache_k.persist.keys()) {
      var {entityKey: i, fieldKey: a} = deserializeKeyInfo(t);
      var n = void 0;
      if (void 0 !== (n = readLink(i, a))) {
        r[t] = `:${(0,urql_core_chunk.i)(n)}`;
      } else if (void 0 !== (n = readRecord(i, a))) {
        r[t] = (0,urql_core_chunk.i)(n);
      } else {
        r[t] = void 0;
      }
    }
    urql_exchange_graphcache_D = !1;
    urql_exchange_graphcache_k.storage.writeData(r);
    urql_exchange_graphcache_k.persist.clear();
  }
};

var urql_exchange_graphcache_V = {
  current: null
};

var urql_exchange_graphcache_q = {
  current: !1
};

var getFieldError = e => e.__internal.path.length > 0 && e.__internal.errorMap ? e.__internal.errorMap[e.__internal.path.join(".")] : void 0;

var makeContext = (e, r, t, i, a, n, o) => {
  var s = {
    store: e,
    variables: r,
    fragments: t,
    parent: {
      __typename: i
    },
    parentTypeName: i,
    parentKey: a,
    parentFieldKey: "",
    fieldName: "",
    error: void 0,
    partial: !1,
    optimistic: !!n,
    __internal: {
      path: [],
      errorMap: void 0
    }
  };
  if (o && o.graphQLErrors) {
    for (var v = 0; v < o.graphQLErrors.length; v++) {
      var l = o.graphQLErrors[v];
      if (l.path && l.path.length) {
        if (!s.__internal.errorMap) {
          s.__internal.errorMap = Object.create(null);
        }
        s.__internal.errorMap[l.path.join(".")] = l;
      }
    }
  }
  return s;
};

var updateContext = (e, r, t, i, a, n) => {
  urql_exchange_graphcache_V.current = e;
  e.parent = r;
  e.parentTypeName = t;
  e.parentKey = i;
  e.parentFieldKey = a;
  e.fieldName = n;
  e.error = getFieldError(e);
};

var isFragmentHeuristicallyMatching = (e, r, t, i) => {
  if (!r) {
    return !1;
  }
  var a = getTypeCondition(e);
  if (!a || r === a) {
    return !0;
  }
   false && 0;
  return "write" === urql_exchange_graphcache_O || !getSelectionSet(e).some((e => {
    if (!isFieldNode(e)) {
      return !1;
    }
    var r = keyOfField(getName(e), getFieldArguments(e, i));
    return !((e, r) => void 0 !== readRecord(e, r) || void 0 !== readLink(e, r))(t, r);
  }));
};

var makeSelectionIterator = (e, r, t, i) => {
  var a = !1;
  var n;
  var o = 0;
  return function next() {
    if (!urql_exchange_graphcache_q.current && a) {
      urql_exchange_graphcache_q.current = a;
    }
    if (n) {
      var s = n();
      if (null != s) {
        return s;
      }
      n = void 0;
      a = !1;
      if (false) {}
    }
    while (o < t.length) {
      var v = t[o++];
      if (!shouldInclude(v, i.variables)) {
        continue;
      } else if (!isFieldNode(v)) {
        var l = !isInlineFragment(v) ? i.fragments[getName(v)] : v;
        if (void 0 !== l) {
          if (i.store.schema ? isInterfaceOfType(i.store.schema, l, e) : isFragmentHeuristicallyMatching(l, e, r, i.variables)) {
            if (false) {}
            a = !!isDeferred(v, i.variables);
            if (!urql_exchange_graphcache_q.current && a) {
              urql_exchange_graphcache_q.current = a;
            }
            return (n = makeSelectionIterator(e, r, getSelectionSet(l), i))();
          }
        }
      } else {
        return v;
      }
    }
  };
};

var ensureData = e => null == e ? null : e;

var ensureLink = (e, r) => {
  if (null == r) {
    return r;
  } else if (Array.isArray(r)) {
    var t = new Array(r.length);
    for (var i = 0, a = t.length; i < a; i++) {
      t[i] = ensureLink(e, r[i]);
    }
    return t;
  }
  var n = e.keyOfEntity(r);
  if (false) {}
  return n;
};

var write = (e, r, t, i, a) => {
  initDataState("write", e.data, a || null);
  var n = startWrite(e, r, t, i);
  clearDataState();
  return n;
};

var startWrite = (e, r, t, i, a) => {
  var n = getMainOperation(r.query);
  var o = {
    data: t,
    dependencies: getCurrentDependencies()
  };
  var s = e.rootFields[n.operation];
  var v = makeContext(e, normalizeVariables(n, r.variables), getFragments(r.query), s, s, !!a, i);
  if (false) {}
  writeSelection(v, s, getSelectionSet(n), t);
  if (false) {}
  return o;
};

var writeSelection = (e, r, t, i) => {
  var a = e.store.rootNames[r] || "query";
  var n = !!e.store.rootNames[r];
  var o = n ? r : i.__typename;
  if (!o) {
     false && 0;
    return;
  } else if (!n && r) {
    writeRecord(r, "__typename", o);
  }
  var s = e.store.updates[o];
  var v = makeSelectionIterator(o, r || o, t, e);
  var l;
  while (l = v()) {
    var u = getName(l);
    var d = getFieldArguments(l, e.variables);
    var c = keyOfField(u, d);
    var p = getFieldAlias(l);
    var f = i[e.optimistic ? u : p];
    if (false) {}
    if ("__typename" === u || void 0 === f && (urql_exchange_graphcache_q.current || e.optimistic && "query" === a)) {
      continue;
    }
    e.__internal.path.push(p);
    var y = void 0;
    if (e.optimistic && "mutation" === a) {
      if (!(y = e.store.optimisticMutations[u])) {
        continue;
      }
    } else if (e.optimistic && "function" == typeof f) {
      y = f;
    }
    if (y) {
      updateContext(e, i, o, o, c, u);
      f = ensureData(y(d || {}, e.store, e));
    }
    if (l.selectionSet) {
      if (r && "query" === a) {
        var h = joinKeys(r, c);
        var m = writeField(e, getSelectionSet(l), ensureData(f), h);
        writeLink(r || o, c, m);
      } else {
        writeField(e, getSelectionSet(l), ensureData(f));
      }
    } else if (r && "query" === a) {
      writeRecord(r || o, c, null !== f || !getFieldError(e) ? f : void 0);
    }
    var g = s && s[u];
    if (g) {
      updateContext(e, i, o, o, joinKeys(o, c), u);
      i[u] = f;
      g(i, d || {}, e.store, e);
    }
    e.__internal.path.pop();
  }
};

var urql_exchange_graphcache_x = /^__|PageInfo|(Connection|Edge)$/;

var writeField = (e, r, t, i) => {
  if (Array.isArray(t)) {
    var a = new Array(t.length);
    for (var n = 0, o = t.length; n < o; n++) {
      e.__internal.path.push(n);
      var s = i ? joinKeys(i, `${n}`) : void 0;
      var v = writeField(e, r, t[n], s);
      a[n] = v;
      e.__internal.path.pop();
    }
    return a;
  } else if (null === t) {
    return getFieldError(e) ? void 0 : null;
  }
  var l = e.store.keyOfEntity(t);
  var u = t.__typename;
  if (false) {}
  var d = l || i;
  writeSelection(e, d, r, t);
  return d || null;
};

class Store {
  constructor(e) {
    Store.prototype.__init.call(this);
    Store.prototype.__init2.call(this);
    if (!e) {
      e = {};
    }
    this.resolvers = e.resolvers || {};
    this.optimisticMutations = e.optimistic || {};
    this.keys = e.keys || {};
    var r = "Query";
    var t = "Mutation";
    var i = "Subscription";
    if (e.schema) {
      var a = (({__schema: e}) => {
        var r = new Map;
        var buildNameMap = e => {
          var r;
          return () => {
            if (!r) {
              r = {};
              for (var t = 0; t < e.length; t++) {
                r[e[t].name] = e[t];
              }
            }
            return r;
          };
        };
        var buildType = e => {
          switch (e.kind) {
           case "OBJECT":
           case "INTERFACE":
            return {
              name: e.name,
              kind: e.kind,
              interfaces: buildNameMap(e.interfaces || []),
              fields: buildNameMap(e.fields.map((e => ({
                name: e.name,
                type: e.type,
                args: buildNameMap(e.args)
              }))))
            };

           case "UNION":
            return {
              name: e.name,
              kind: e.kind,
              types: buildNameMap(e.possibleTypes || [])
            };
          }
        };
        var t = {
          query: e.queryType ? e.queryType.name : null,
          mutation: e.mutationType ? e.mutationType.name : null,
          subscription: e.subscriptionType ? e.subscriptionType.name : null,
          types: void 0,
          isSubType(e, t) {
            var i = r.get(e);
            var a = r.get(t);
            if (!i || !a) {
              return !1;
            } else if ("UNION" === i.kind) {
              return !!i.types()[t];
            } else if ("OBJECT" !== i.kind && "OBJECT" === a.kind) {
              return !!a.interfaces()[e];
            } else {
              return e === t;
            }
          }
        };
        if (e.types) {
          t.types = r;
          for (var i = 0; i < e.types.length; i++) {
            var a = e.types[i];
            if (a && a.name) {
              var n = buildType(a);
              if (n) {
                r.set(a.name, n);
              }
            }
          }
        }
        return t;
      })(e.schema);
      r = a.query || r;
      t = a.mutation || t;
      i = a.subscription || i;
      if (a.types) {
        this.schema = a;
      }
    }
    this.updates = e.updates || {};
    this.rootFields = {
      query: r,
      mutation: t,
      subscription: i
    };
    this.rootNames = {
      [r]: "query",
      [t]: "mutation",
      [i]: "subscription"
    };
    this.data = (n = r, {
      defer: !1,
      gc: new Set,
      persist: new Set,
      queryRootKey: n,
      refCount: new Map,
      links: {
        optimistic: new Map,
        base: new Map
      },
      records: {
        optimistic: new Map,
        base: new Map
      },
      deferredKeys: new Set,
      commutativeKeys: new Set,
      dirtyKeys: new Set,
      optimisticOrder: [],
      storage: null
    });
    var n;
    if (this.schema && "production" !== "production") {}
  }
  __init() {
    this.keyOfField = keyOfField;
  }
  keyOfEntity(e) {
    if (urql_exchange_graphcache_V.current && e === urql_exchange_graphcache_V.current.parent) {
      return urql_exchange_graphcache_V.current.parentKey;
    }
    if (null == e || "string" == typeof e) {
      return e || null;
    }
    if (!e.__typename) {
      return null;
    }
    if (this.rootNames[e.__typename]) {
      return e.__typename;
    }
    var r;
    if (this.keys[e.__typename]) {
      r = this.keys[e.__typename](e);
    } else if (null != e.id) {
      r = `${e.id}`;
    } else if (null != e._id) {
      r = `${e._id}`;
    }
    return r ? `${e.__typename}:${r}` : null;
  }
  resolve(e, r, t) {
    var i = keyOfField(r, t);
    var a = this.keyOfEntity(e);
    if (!a) {
      return null;
    }
    var n = readRecord(a, i);
    if (void 0 !== n) {
      return n;
    }
    return readLink(a, i) || null;
  }
  __init2() {
    this.resolveFieldByKey = this.resolve;
  }
  invalidate(e, r, t) {
    var i = this.keyOfEntity(e);
    invariant(i,  false ? 0 : "", 19);
    ((e, r, t) => {
      var i = r ? [ {
        fieldKey: keyOfField(r, t)
      } ] : inspectFields(e);
      for (var a = 0, n = i.length; a < n; a++) {
        var {fieldKey: o} = i[a];
        if (void 0 !== readLink(e, o)) {
          writeLink(e, o, void 0);
        } else {
          writeRecord(e, o, void 0);
        }
      }
    })(i, r, t);
  }
  inspectFields(e) {
    var r = this.keyOfEntity(e);
    return r ? inspectFields(r) : [];
  }
  updateQuery(e, i) {
    var a = (0,urql_core_chunk.h)(e.query, e.variables);
    a.query = (0,urql_core/* formatDocument */.nZ)(a.query);
    var n = i(this.readQuery(a));
    if (null !== n) {
      startWrite(this, a, n);
    }
  }
  readQuery(e) {
    var i = (0,urql_core_chunk.h)(e.query, e.variables);
    i.query = (0,urql_core/* formatDocument */.nZ)(i.query);
    return read(this, i).data;
  }
  readFragment(e, r, i, a) {
    return readFragment(this, (0,urql_core/* formatDocument */.nZ)(e), r, i, a);
  }
  writeFragment(e, r, i, a) {
    ((e, r, t, i, a) => {
      var n = getFragments(r);
      var o;
      if (a) {
        if (!(o = n[a])) {
           false && 0;
          return null;
        }
      } else if (!(o = n[Object.keys(n)[0]])) {
         false && 0;
        return null;
      }
      var s = getFragmentTypeName(o);
      var v = {
        __typename: s,
        ...t
      };
      var l = e.keyOfEntity(v);
      if (!l) {
        return  false ? 0 : void 0;
      }
      if (false) {}
      var u = makeContext(e, i || {}, n, s, l, void 0);
      writeSelection(u, l, getSelectionSet(o), v);
      if (false) {}
    })(this, (0,urql_core/* formatDocument */.nZ)(e), r, i, a);
  }
  link(e, r, t, i) {
    var a = void 0 !== i ? t : null;
    var n = void 0 !== i ? i : t;
    var o = ensureLink(this, e);
    if ("string" == typeof o) {
      writeLink(o, keyOfField(r, a), ensureLink(this, n));
    }
  }
}

var query = (e, r, t, i, a) => {
  initDataState("read", e.data, a);
  var n = read(e, r, t, i);
  clearDataState();
  return n;
};

var read = (e, r, t, i) => {
  var a = getMainOperation(r.query);
  var n = e.rootFields[a.operation];
  var o = getSelectionSet(a);
  var s = makeContext(e, normalizeVariables(a, r.variables), getFragments(r.query), n, n, !1, i);
  if (false) {}
  if (!t) {
    t = makeData();
  }
  var v = n !== s.store.rootFields.query ? readRoot(s, n, o, t) : readSelection(s, n, o, t);
  if (false) {}
  return {
    dependencies: getCurrentDependencies(),
    partial: s.partial || !v,
    data: v || null
  };
};

var readRoot = (e, r, t, i) => {
  if ("string" != typeof (e.store.rootNames[r] ? r : i.__typename)) {
    return i;
  }
  var a = makeSelectionIterator(r, r, t, e);
  var n;
  var o = !1;
  var s = makeData(i);
  while (n = a()) {
    var v = getFieldAlias(n);
    var l = i[v];
    e.__internal.path.push(v);
    var u = void 0;
    if (n.selectionSet && null !== l) {
      u = readRootField(e, getSelectionSet(n), ensureData(l));
    } else {
      u = l;
    }
    o = o || u !== l;
    if (void 0 !== u) {
      s[v] = u;
    }
    e.__internal.path.pop();
  }
  return o ? s : i;
};

var readRootField = (e, r, t) => {
  if (Array.isArray(t)) {
    var i = new Array(t.length);
    var a = !1;
    for (var n = 0, o = t.length; n < o; n++) {
      e.__internal.path.push(n);
      i[n] = readRootField(e, r, t[n]);
      a = a || i[n] !== t[n];
      e.__internal.path.pop();
    }
    return a ? i : t;
  } else if (null === t) {
    return null;
  }
  var s = e.store.keyOfEntity(t);
  if (null !== s) {
    return readSelection(e, s, r, t) || null;
  } else {
    return readRoot(e, t.__typename, r, t);
  }
};

var readFragment = (e, r, t, i, a) => {
  var n = getFragments(r);
  var o;
  if (a) {
    if (!(o = n[a])) {
       false && 0;
      return null;
    }
  } else {
    if (!(o = n[Object.keys(n)[0]])) {
       false && 0;
      return null;
    }
  }
  var s = getFragmentTypeName(o);
  if ("string" != typeof t && !t.__typename) {
    t.__typename = s;
  }
  var v = e.keyOfEntity(t);
  if (!v) {
     false && 0;
    return null;
  }
  if (false) {}
  var l = makeContext(e, i || {}, n, s, v);
  var u = readSelection(l, v, getSelectionSet(o), makeData()) || null;
  if (false) {}
  return u;
};

var readSelection = (e, r, t, i, a) => {
  var {store: n} = e;
  var o = r === n.rootFields.query;
  var s = a && n.keyOfEntity(a) || r;
  if (false) {}
  var v = !o ? readRecord(s, "__typename") || a && a.__typename : r;
  if ("string" != typeof v) {
    return;
  } else if (a && v !== a.__typename) {
     false && 0;
    return;
  }
  var l = n.resolvers[v];
  var u = makeSelectionIterator(v, s, t, e);
  var d = !1;
  var c = !1;
  var p = v !== i.__typename;
  var f;
  var y = makeData(i);
  while (void 0 !== (f = u())) {
    var h = getName(f);
    var m = getFieldArguments(f, e.variables);
    var g = getFieldAlias(f);
    var _ = keyOfField(h, m);
    var N = joinKeys(s, _);
    var E = readRecord(s, _);
    var O = a ? a[h] : void 0;
    if (false) {}
    e.__internal.path.push(g);
    var k = void 0;
    if ("__typename" === h) {
      k = v;
    } else if (void 0 !== O && void 0 === f.selectionSet) {
      k = O;
    } else if ("read" === getCurrentOperation() && l && l[h]) {
      updateContext(e, y, v, s, N, h);
      if (void 0 !== E) {
        y[g] = E;
      }
      k = l[h](y, m || {}, n, e);
      if (f.selectionSet) {
        k = resolveResolverResult(e, v, h, N, getSelectionSet(f), void 0 !== y[g] ? y[g] : i[g], k, ownsData(i));
      }
      if (n.schema && null === k && !isFieldNullable(n.schema, v, h)) {
        return;
      }
    } else if (!f.selectionSet) {
      k = E;
    } else if (void 0 !== O) {
      k = resolveResolverResult(e, v, h, N, getSelectionSet(f), void 0 !== y[g] ? y[g] : i[g], O, ownsData(i));
    } else {
      var w = readLink(s, _);
      if (void 0 !== w) {
        k = resolveLink(e, w, v, h, getSelectionSet(f), void 0 !== y[g] ? y[g] : i[g], ownsData(i));
      } else if ("object" == typeof E && null !== E) {
        k = E;
      }
    }
    if (void 0 === k && urql_exchange_graphcache_q.current) {
      d = !0;
    } else if (void 0 === k && (n.schema && isFieldNullable(n.schema, v, h) || getFieldError(e))) {
      c = !0;
      k = null;
    } else if (void 0 === k) {
      e.__internal.path.pop();
      return;
    } else {
      d = d || "__typename" !== h;
    }
    e.__internal.path.pop();
    p = p || k !== i[g];
    if (void 0 !== k) {
      y[g] = k;
    }
  }
  e.partial = e.partial || c;
  return o && c && !d ? void 0 : p ? y : i;
};

var resolveResolverResult = (e, r, t, i, a, n, o, s) => {
  if (Array.isArray(o)) {
    var {store: v} = e;
    var l = v.schema ? isListNullable(v.schema, r, t) : !1;
    var u = new Array(o.length);
    var d = !Array.isArray(n) || o.length !== n.length;
    for (var c = 0, p = o.length; c < p; c++) {
      e.__internal.path.push(c);
      var f = resolveResolverResult(e, r, t, joinKeys(i, `${c}`), a, null != n ? n[c] : void 0, o[c], s);
      e.__internal.path.pop();
      if (void 0 === f && !l) {
        return;
      } else {
        e.partial = e.partial || void 0 === f && l;
        u[c] = null != f ? f : null;
        d = d || u[c] !== n[c];
      }
    }
    return d ? u : n;
  } else if (null == o) {
    return o;
  } else if (s && null === n) {
    return null;
  } else if (isDataOrKey(o)) {
    var y = n || makeData();
    return "string" == typeof o ? readSelection(e, o, a, y) : readSelection(e, i, a, y, o);
  } else {
     false && 0;
    return;
  }
};

var resolveLink = (e, r, t, i, a, n, o) => {
  if (Array.isArray(r)) {
    var {store: s} = e;
    var v = s.schema ? isListNullable(s.schema, t, i) : !1;
    var l = new Array(r.length);
    var u = !Array.isArray(n) || l.length !== n.length;
    for (var d = 0, c = r.length; d < c; d++) {
      e.__internal.path.push(d);
      var p = resolveLink(e, r[d], t, i, a, null != n ? n[d] : void 0, o);
      e.__internal.path.pop();
      if (void 0 === p && !v) {
        return;
      } else {
        e.partial = e.partial || void 0 === p && v;
        l[d] = p || null;
        u = u || l[d] !== n[d];
      }
    }
    return u ? l : n;
  } else if (null === r || null === n && o) {
    return null;
  }
  return readSelection(e, r, a, n || makeData());
};

var isDataOrKey = e => "string" == typeof e || "object" == typeof e && "string" == typeof e.__typename;

var addMetadata = (e, r) => i(e.kind, e, {
  ...e.context,
  meta: {
    ...e.context.meta,
    ...r
  }
});

var toRequestPolicy = (e, r) => (0,urql_core/* makeOperation */.vx)(e.kind, e, {
  ...e.context,
  requestPolicy: r
});

var cacheExchange = e => ({forward: r, client: a, dispatchDebug: c}) => {
  var p = new Store(e);
  if (e && e.storage) {
    e.storage.readData().then((r => {
      ((e, r, t) => {
        initDataState("write", e, null);
        for (var i in t) {
          var a = t[i];
          if (void 0 !== a) {
            var {entityKey: n, fieldKey: o} = deserializeKeyInfo(i);
            if (":" === a[0]) {
              if (void 0 === readLink(n, o)) {
                writeLink(n, o, JSON.parse(a.slice(1)));
              }
            } else if (void 0 === readRecord(n, o)) {
              writeRecord(n, o, JSON.parse(a));
            }
          }
        }
        clearDataState();
        e.storage = r;
      })(p.data, e.storage, r);
    }));
  }
  var f = new Map;
  var y = [];
  var h = new Map;
  var m = new Map;
  var g = new Set;
  var _ = new Set;
  var N = new Map;
  var E = new Set;
  var O = new Set;
  var isBlockedByOptimisticUpdate = e => {
    for (var r of e.values()) {
      if (g.has(r)) {
        return !0;
      }
    }
    return !1;
  };
  var collectPendingOperations = (e, r) => {
    if (r) {
      for (var t of r.values()) {
        var i = N.get(t);
        if (i) {
          for (var a of i.values()) {
            e.add(a);
          }
        }
      }
    }
  };
  var executePendingOperations = (e, r) => {
    for (var t of r.values()) {
      if (t !== e.key) {
        var i = h.get(t);
        if (i) {
          if ("query" === e.kind) {
            O.add(t);
          }
          h.delete(t);
          var n = "cache-first";
          if (_.has(t)) {
            _.delete(t);
            n = "cache-and-network";
          }
          a.reexecuteOperation(toRequestPolicy(i, n));
        }
      }
    }
    var o = E;
    if ("query" === e.kind) {
      (E = O).add(e.key);
    }
    (O = o).clear();
  };
  var prepareForwardedOperation = e => {
    if ("query" === e.kind) {
      reserveLayer(p.data, e.key);
    } else if ("teardown" === e.kind) {
      h.delete(e.key);
      m.delete(e.key);
      E.delete(e.key);
      noopDataState(p.data, e.key);
    } else if ("mutation" === e.kind && "network-only" !== e.context.requestPolicy) {
      var {dependencies: r} = ((e, r, t) => {
        if (false) {}
        initDataState("write", e.data, t, !0);
        var i = startWrite(e, r, {}, void 0, !0);
        clearDataState();
        return i;
      })(p, e, e.key);
      if (r.size) {
        for (var a of r.values()) {
          g.add(a);
        }
        f.set(e.key, r);
        var n = new Set;
        collectPendingOperations(n, r);
        executePendingOperations(e, n);
      }
    }
    return (0,urql_core/* makeOperation */.vx)(e.kind, {
      key: e.key,
      query: (0,urql_core/* formatDocument */.nZ)(e.query),
      variables: e.variables ? filterVariables(getMainOperation(e.query), e.variables) : e.variables
    }, {
      ...e.context,
      originalVariables: e.variables
    });
  };
  var updateDependencies = (e, r) => {
    for (var t of r.values()) {
      var i = N.get(t);
      if (!i) {
        N.set(t, i = new Set);
      }
      i.add(e.key);
    }
  };
  var operationResultFromCache = e => {
    var r = query(p, e, m.get(e.key));
    var t = r.data ? !r.partial ? "hit" : "partial" : "miss";
    m.set(e.key, r.data);
    h.set(e.key, e);
    updateDependencies(e, r.dependencies);
    return {
      outcome: t,
      operation: e,
      data: r.data,
      dependencies: r.dependencies
    };
  };
  var updateCacheWithResult = (e, r) => {
    var t = h.get(e.operation.key);
    var a = t ? (0,urql_core/* makeOperation */.vx)(t.kind, t, e.operation.context) : e.operation;
    if ("mutation" === a.kind) {
      if (e.operation.context.originalVariables) {
        a.variables = e.operation.context.originalVariables;
        delete e.operation.context.originalVariables;
      }
      var n = f.get(a.key);
      collectPendingOperations(r, n);
      f.delete(a.key);
    }
    if ("subscription" === a.kind || e.hasNext) {
      reserveLayer(p.data, a.key, !0);
    }
    var o;
    var s = e.data;
    if (s) {
      var v = write(p, a, s, e.error, a.key).dependencies;
      collectPendingOperations(r, v);
      var l = query(p, a, "query" === a.kind ? m.get(a.key) || s : s, e.error, a.key);
      s = l.data;
      if ("query" === a.kind) {
        collectPendingOperations(r, o = l.dependencies);
        m.set(a.key, s);
      }
    } else {
      noopDataState(p.data, a.key);
    }
    if (o) {
      h.set(a.key, a);
      updateDependencies(e.operation, o);
    }
    return {
      operation: a,
      data: s,
      error: e.error,
      extensions: e.extensions,
      hasNext: e.hasNext,
      stale: e.stale
    };
  };
  return e => {
    var t = (0,wonka/* share */.BN)((0,wonka/* map */.UI)(operationResultFromCache)((0,wonka/* filter */.hX)((e => "query" === e.kind && "network-only" !== e.context.requestPolicy))(e)));
    var i = (0,wonka/* filter */.hX)((e => "query" !== e.kind || "network-only" === e.context.requestPolicy))(e);
    var h = (0,wonka/* map */.UI)((e => {
       false && 0;
      return  false ? 0 : e.operation;
    }))((0,wonka/* filter */.hX)((e => "miss" === e.outcome && "cache-only" !== e.operation.context.requestPolicy && !isBlockedByOptimisticUpdate(e.dependencies) && !E.has(e.operation.key)))(t));
    var m = (0,wonka/* map */.UI)((e => {
      var {requestPolicy: r} = e.operation.context;
      var t = "partial" === e.outcome && "cache-only" !== r;
      var i = "cache-and-network" === r || "cache-first" === r && t && !E.has(e.operation.key);
      var n = {
        operation:  false ? 0 : e.operation,
        data: e.data,
        error: e.error,
        extensions: e.extensions,
        stale: i || t,
        hasNext: !1
      };
      if (!i) {} else if (!isBlockedByOptimisticUpdate(e.dependencies)) {
        a.reexecuteOperation(toRequestPolicy(e.operation, "network-only"));
      } else if ("cache-and-network" === r) {
        _.add(e.operation.key);
      }
       false && 0;
      return n;
    }))((0,wonka/* filter */.hX)((e => "miss" !== e.outcome || "cache-only" === e.operation.context.requestPolicy))(t));
    var N = r((0,wonka/* map */.UI)(prepareForwardedOperation)((0,wonka/* merge */.TS)([ i, h ])));
    var O = (0,wonka/* map */.UI)((e => {
      var r = new Set;
      var t = updateCacheWithResult(e, r);
      executePendingOperations(e.operation, r);
      return t;
    }))((0,wonka/* filter */.hX)((e => !f.has(e.operation.key)))(N));
    var k = (0,wonka/* mergeMap */.zg)((e => {
      if (y.push(e) < f.size) {
        return wonka/* empty */.cS;
      }
      for (var r = 0; r < y.length; r++) {
        reserveLayer(p.data, y[r].operation.key);
      }
      g.clear();
      var t = [];
      var i = new Set;
      var a;
      while (a = y.shift()) {
        t.push(updateCacheWithResult(a, i));
      }
      executePendingOperations(e.operation, i);
      return (0,wonka/* fromArray */.nI)(t);
    }))((0,wonka/* filter */.hX)((e => f.has(e.operation.key)))(N));
    return (0,wonka/* merge */.TS)([ O, k, m ]);
  };
};

var offlineExchange = e => t => {
  var {storage: n} = e;
  var o = e.isOfflineError || (e => e && e.networkError && !e.response && ("undefined" != typeof navigator && !1 === navigator.onLine || /request failed|failed to fetch|network\s?error/i.test(e.networkError.message)));
  if (n && n.onOnline && n.readMetadata && n.writeMetadata) {
    var {forward: l, client: u, dispatchDebug: d} = t;
    var {source: p, next: f} = c();
    var y = e.optimistic || {};
    var h = [];
    var updateMetadata = () => {
      var e = [];
      for (var r = 0; r < h.length; r++) {
        var t = h[r];
        if ("mutation" === t.kind) {
          e.push({
            query: a(t.query),
            variables: t.variables,
            extensions: t.extensions
          });
        }
      }
      n.writeMetadata(e);
    };
    var m = !1;
    var flushQueue = () => {
      if (!m) {
        m = !0;
        for (var e = 0; e < h.length; e++) {
          var r = h[e];
          if ("mutation" === r.kind) {
            f(i("teardown", r));
          }
        }
        for (var t = 0; t < h.length; t++) {
          u.reexecuteOperation(h[t]);
        }
        h.length = 0;
        m = !1;
        updateMetadata();
      }
    };
    n.readMetadata().then((e => {
      if (e) {
        for (var t = 0; t < e.length; t++) {
          h.push(u.createRequestOperation("mutation", r(e[t].query, e[t].variables), e[t].extensions));
        }
        flushQueue();
      }
    })).finally((() => n.onOnline(flushQueue)));
    var g = cacheExchange({
      ...e,
      storage: {
        ...n,
        readData: () => n.readData().finally(flushQueue)
      }
    })({
      client: u,
      dispatchDebug: d,
      forward: e => s((e => {
        if ("mutation" === e.operation.kind && o(e.error, e) && ((e, r) => {
          var t = r.variables || {};
          var i = getFragments(r.query);
          var a = [ ...getSelectionSet(getMainOperation(r.query)) ];
          var n;
          while (n = a.pop()) {
            if (!shouldInclude(n, t)) {
              continue;
            } else if (!isFieldNode(n)) {
              var o = !isInlineFragment(n) ? i[getName(n)] : n;
              if (o) {
                a.push(...getSelectionSet(o));
              }
            } else if (e[getName(n)]) {
              return !0;
            }
          }
          return !1;
        })(y, e.operation)) {
          h.push(e.operation);
          updateMetadata();
          return !1;
        }
        return !0;
      }))(l(e))
    });
    return e => {
      var r = v([ p, e ]);
      return s((e => {
        if ("query" === e.operation.kind && o(e.error, e)) {
          f(toRequestPolicy(e.operation, "cache-only"));
          h.push(e.operation);
          return !1;
        }
        return !0;
      }))(g(r));
    };
  }
  return cacheExchange(e)(t);
};


//# sourceMappingURL=urql-exchange-graphcache.mjs.map

// EXTERNAL MODULE: ./gql/queries/cart.ts
var queries_cart = __webpack_require__(66072);
// EXTERNAL MODULE: ./gql/fragments/address.ts
var address = __webpack_require__(12352);
// EXTERNAL MODULE: ./gql/fragments/ambassadorCards.ts
var ambassadorCards = __webpack_require__(38012);
;// CONCATENATED MODULE: ./gql/fragments/creditCards.ts

function creditCards_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment savedCreditCard on SavedCreditCard {\n    UUID\n    defaultFlag\n    creditHolderName\n    creditCardSeq\n    creditCardType\n    creditCardNumber\n    maskedCreditCardNumber\n    creditCardExpirationMonth\n    creditCardExpirationYear\n  }\n"
    ]);
    creditCards_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var SAVED_CARD_FRAGMENT = (0,urql_core/* gql */.Ps)(creditCards_templateObject());

// EXTERNAL MODULE: ./gql/fragments/standardOrder.ts
var standardOrder = __webpack_require__(912);
// EXTERNAL MODULE: ./gql/fragments/user.ts
var user = __webpack_require__(87560);
;// CONCATENATED MODULE: ./gql/fragments/storeCredit.ts

function storeCredit_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment storeCreditFields on StoreCredit {\n    amount\n  }\n"
    ]);
    storeCredit_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var STORE_CREDIT_FRAGMENT = (0,urql_core/* gql */.Ps)(storeCredit_templateObject());

;// CONCATENATED MODULE: ./gql/queries/me.ts

function me_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query Me(\n    $includeAddresses: Boolean = false\n    $includeOrders: Boolean = false\n    $includeAmbassadorCards: Boolean = false\n    $includeSavedCards: Boolean = false\n    $includeGroups: Boolean = false\n    $includeNewsletter: Boolean = false\n    $includeStoreCredit: Boolean = false\n  ) {\n    me {\n      ...userFields\n      newsletterSubscription @include(if: $includeNewsletter) {\n        firstName\n        lastName\n        firstNamePronunciation\n        lastNamePronunciation\n        email\n        gender\n        memberId\n        dob {\n          day\n          month\n          year\n        }\n        emailPreference\n        shoppingPreference\n        iframeURL\n        isConfirmed\n      }\n      addresses @include(if: $includeAddresses) {\n        ...addressFields\n      }\n      orders(limit: 5) @include(if: $includeOrders) {\n        nodes {\n          ...orderPreviewFields\n        }\n      }\n      ambassadorCards @include(if: $includeAmbassadorCards) {\n        ...ambassadorCardFields\n      }\n      savedCards @include(if: $includeSavedCards) {\n        ...savedCreditCard\n      }\n      storeCredit @include(if: $includeStoreCredit) {\n        ...storeCreditFields\n      }\n      groups @include(if: $includeGroups)\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    me_templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var ME_QUERY = (0,urql_core/* gql */.Ps)(me_templateObject(), user/* USER_FRAGMENT */.P, address/* ADDRESS_FRAGMENT */.U, standardOrder/* ORDER_PREVIEW_FRAGMENT */.z, ambassadorCards/* SAVED_AMBASSADOR_CARD_FRAGMENT */.c, SAVED_CARD_FRAGMENT, STORE_CREDIT_FRAGMENT);

// EXTERNAL MODULE: ./gql/queries/wishList.ts
var wishList = __webpack_require__(85288);
;// CONCATENATED MODULE: ./graphql.urql.schema.json
var graphql_urql_schema_namespaceObject = JSON.parse('{"__schema":{"queryType":{"name":"Query"},"mutationType":{"name":"Mutation"},"subscriptionType":null,"types":[{"kind":"OBJECT","name":"AccessTokenResponse","fields":[{"name":"applicationId","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"citizenId","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"createdAt","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"expiryDate","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"externalRef","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"token","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"AddStoreCreditsPayload","fields":[{"name":"cart","type":{"kind":"OBJECT","name":"Cart","ofType":null},"args":[]}],"interfaces":[]},{"kind":"UNION","name":"AdditionalContentListTextImage","possibleTypes":[{"kind":"OBJECT","name":"PortableTextWithList"},{"kind":"OBJECT","name":"SanityImage"}]},{"kind":"OBJECT","name":"AdditionalContentSection","fields":[{"name":"_id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"text","type":{"kind":"LIST","ofType":{"kind":"UNION","name":"AdditionalContentListTextImage","ofType":null}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"Address","fields":[{"name":"address1","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"address2","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"address3","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"city","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"companyName","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"countryCode","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"firstName","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"firstNamePronunciation","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"lastName","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"lastNamePronunciation","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"phone","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"postalCode","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"preferred","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"salutation","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"stateCode","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"streetNumber","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"title","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"Adjustment","fields":[{"name":"couponCode","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"itemText","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"price","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"promotion","type":{"kind":"OBJECT","name":"ProductPromotion","ofType":null},"args":[]},{"name":"promotionId","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"Adyen","fields":[{"name":"amount","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"type","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]}],"interfaces":[]},{"kind":"UNION","name":"AdyenAction","possibleTypes":[{"kind":"OBJECT","name":"CheckoutAwaitAction"},{"kind":"OBJECT","name":"CheckoutRedirectAction"},{"kind":"OBJECT","name":"CheckoutSDKAction"}]},{"kind":"OBJECT","name":"AdyenKlarna","fields":[{"name":"amount","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"type","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"AdyenKlarnaAccount","fields":[{"name":"amount","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"type","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"AdyenPayPal","fields":[{"name":"amount","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"type","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"AdyenPaymentDetailsPayload","fields":[{"name":"analytics","type":{"kind":"OBJECT","name":"OrderAnalytics","ofType":null},"args":[]},{"name":"order","type":{"kind":"OBJECT","name":"StandardOrder","ofType":null},"args":[]},{"name":"resultCode","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"AfterPay","fields":[{"name":"authorizationStatus","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"type","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"AfterPayConfig","fields":[{"name":"max","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"min","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"AfterPayPayload","fields":[{"name":"orderNo","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"url","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"Alignment","fields":[{"name":"horizontal","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"vertical","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"Alipay","fields":[{"name":"amount","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"type","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"AmazonPay","fields":[{"name":"amount","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"authorizationStatus","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"type","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"AmazonPayAddress","fields":[{"name":"address1","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"city","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"email","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"firstName","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"lastName","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"meiName","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"phone","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"postalCode","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"sayName","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"stateCode","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"AmazonPayCustomerInfoPayload","fields":[{"name":"registeredWithAmazon","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"userEmail","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"AmazonPayPaymentDescriptorPayload","fields":[{"name":"paymentOption","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"AmbassadorCard","fields":[{"name":"amount","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"authorizationStatus","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"maskedNumber","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"type","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"AppComponentWithFilters","fields":[{"name":"availableFrom","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"availableTo","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"component","type":{"kind":"UNION","name":"AppSlot","ofType":null},"args":[]},{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"online","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"AppContent","fields":[{"name":"appContent","type":{"kind":"LIST","ofType":{"kind":"UNION","name":"MobileAppHomePageContent","ofType":null}},"args":[]},{"name":"appContent2","type":{"kind":"LIST","ofType":{"kind":"OBJECT","name":"AppComponentWithFilters","ofType":null}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"AppDropItem","fields":[{"name":"availableFrom","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"availableTo","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"buttonLabel","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"copy","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"date","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"header","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"image","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"SanityImage","ofType":null}},"args":[]},{"name":"link","type":{"kind":"OBJECT","name":"MobileAppLink","ofType":null},"args":[]},{"name":"videoUrl","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"UNION","name":"AppSlot","possibleTypes":[{"kind":"OBJECT","name":"FaqModule"},{"kind":"OBJECT","name":"Iframe"},{"kind":"OBJECT","name":"LinkListing"},{"kind":"OBJECT","name":"MobileAppCarousel"},{"kind":"OBJECT","name":"MobileAppProductRecommendations"},{"kind":"OBJECT","name":"MobileAppProductTileCustom"},{"kind":"OBJECT","name":"MobileAppProductTileStandard"},{"kind":"OBJECT","name":"MobileAppQuoteCallout"},{"kind":"OBJECT","name":"MobileAppTeaserTile"},{"kind":"OBJECT","name":"ProductCarousel"},{"kind":"OBJECT","name":"ProductRecommender"},{"kind":"OBJECT","name":"ProductTile"},{"kind":"OBJECT","name":"SignUpForm"},{"kind":"OBJECT","name":"SpinTheWheel"},{"kind":"OBJECT","name":"VideoHero"}]},{"kind":"OBJECT","name":"AppVersion","fields":[{"name":"android","type":{"kind":"OBJECT","name":"Version","ofType":null},"args":[]},{"name":"ios","type":{"kind":"OBJECT","name":"Version","ofType":null},"args":[]},{"name":"upgrade","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"ApplePay","fields":[{"name":"authorizationStatus","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"type","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"ApplePayValidationResponse","fields":[{"name":"displayName","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"domainName","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"epochTimestamp","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"expiresAt","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"merchantIdentifier","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"merchantSessionIdentifier","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"nonce","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"operationalAnalyticsIdentifier","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"retries","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"signature","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"AuthPayload","fields":[{"name":"accessToken","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"customerContext","type":{"kind":"OBJECT","name":"CustomerContext","ofType":null},"args":[]},{"name":"customerEmail","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"customerGroup","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"customerId","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"refreshToken","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"shoppingCartId","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"user","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"User","ofType":null}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"AuthorityToLeave","fields":[{"name":"deliveryInstructions","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"leaveAt","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"BackgroundOverlay","fields":[{"name":"direction","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"id","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"overlayColorInput","type":{"kind":"OBJECT","name":"ColorInput","ofType":null},"args":[]},{"name":"overlayType","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"Badge","fields":[{"name":"color","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"label","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"BannerIdentifier","fields":[{"name":"_type","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"current","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"INTERFACE","name":"BaseOrder","fields":[{"name":"billingAddress","type":{"kind":"OBJECT","name":"OrderAddress","ofType":null},"args":[]},{"name":"createdAt","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"currency","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"customer","type":{"kind":"OBJECT","name":"CustomerInfo","ofType":null},"args":[]},{"name":"estimatedShippingCosts","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"estimatedTotal","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"orderAdjustments","type":{"kind":"NON_NULL","ofType":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"Adjustment","ofType":null}}}},"args":[]},{"name":"orderNo","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"orderStatus","type":{"kind":"OBJECT","name":"OrderStatus","ofType":null},"args":[]},{"name":"paymentInstruments","type":{"kind":"NON_NULL","ofType":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"UNION","name":"PaymentInstrument","ofType":null}}}},"args":[]},{"name":"shipment","type":{"kind":"OBJECT","name":"Shipment","ofType":null},"args":[]},{"name":"shippingAdjustments","type":{"kind":"NON_NULL","ofType":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"Adjustment","ofType":null}}}},"args":[]},{"name":"shippingCosts","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"shippingSurcharge","type":{"kind":"OBJECT","name":"ShippingSurcharge","ofType":null},"args":[]},{"name":"status","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"subTotal","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"taxTotal","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"taxation","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[],"possibleTypes":[{"kind":"OBJECT","name":"NestedOrder"},{"kind":"OBJECT","name":"StandardOrder"}]},{"kind":"OBJECT","name":"BodyContent","fields":[{"name":"_id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"availableFrom","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"availableTo","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"copy","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"countdownClock","type":{"kind":"OBJECT","name":"CountdownClock","ofType":null},"args":[]},{"name":"ctas","type":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"CTA","ofType":null}}},"args":[]},{"name":"footer","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"header","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"horizontalAlignment","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"logo","type":{"kind":"OBJECT","name":"SanityImage","ofType":null},"args":[]},{"name":"puid","type":{"kind":"OBJECT","name":"BannerIdentifier","ofType":null},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"BodyHeader","fields":[{"name":"_id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"header","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"horizontalAlignment","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"size","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"UNION","name":"BonusItemProduct","possibleTypes":[{"kind":"OBJECT","name":"ProductWithExclusion"},{"kind":"OBJECT","name":"VariantProduct"}]},{"kind":"OBJECT","name":"CTA","fields":[{"name":"_type","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"action","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"id","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"link","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"linkConfig","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"linkType","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"newtab","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"outlined","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"popup","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"query","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"signUpForm","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"title","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"variant","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"width","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"CallToAction","fields":[{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"link","type":{"kind":"OBJECT","name":"Link","ofType":null},"args":[]},{"name":"outlined","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"title","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"variant","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"width","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"Campaign","fields":[{"name":"availableFrom","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"availableTo","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"customerGroups","type":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}},"args":[]},{"name":"puid","type":{"kind":"OBJECT","name":"BannerIdentifier","ofType":null},"args":[]},{"name":"sourceCode","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"CancelOrderPayload","fields":[{"name":"cart","type":{"kind":"OBJECT","name":"Cart","ofType":null},"args":[]},{"name":"order","type":{"kind":"OBJECT","name":"StandardOrder","ofType":null},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"Card","fields":[{"name":"badge","type":{"kind":"OBJECT","name":"Badge","ofType":null},"args":[]},{"name":"ctas","type":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"CallToAction","ofType":null}}},"args":[]},{"name":"ctas2","type":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"CTA","ofType":null}}},"args":[]},{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"image","type":{"kind":"OBJECT","name":"Image","ofType":null},"args":[]},{"name":"link","type":{"kind":"OBJECT","name":"Link","ofType":null},"args":[]},{"name":"style","type":{"kind":"OBJECT","name":"Style","ofType":null},"args":[]},{"name":"text","type":{"kind":"OBJECT","name":"Text","ofType":null},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"Cart","fields":[{"name":"amountRemaining","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"amountRemainingForFreeShipping","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"availablePaymentMethods","type":{"kind":"NON_NULL","ofType":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"PaymentMethod","ofType":null}}}},"args":[]},{"name":"basketInStockStatus","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"billingAddress","type":{"kind":"OBJECT","name":"OrderAddress","ofType":null},"args":[]},{"name":"couponItems","type":{"kind":"NON_NULL","ofType":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"CouponItem","ofType":null}}}},"args":[]},{"name":"customer","type":{"kind":"OBJECT","name":"CustomerInfo","ofType":null},"args":[]},{"name":"customizationAdjustment","type":{"kind":"OBJECT","name":"Adjustment","ofType":null},"args":[]},{"name":"defaultFreeShippingThreshold","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"estimatedShippingCosts","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"estimatedTotal","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"freeShippingThreshold","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"giftWithPurchases","type":{"kind":"NON_NULL","ofType":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"GiftWithPurchasePromo","ofType":null}}}},"args":[]},{"name":"hasFreeShipping","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"hasOfflineProducts","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"isMixedCartAllowed","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"longTermPreOrder","type":{"kind":"OBJECT","name":"LongTermPreOrder","ofType":null},"args":[]},{"name":"orderAdjustments","type":{"kind":"NON_NULL","ofType":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"Adjustment","ofType":null}}}},"args":[]},{"name":"paymentInstruments","type":{"kind":"NON_NULL","ofType":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"UNION","name":"PaymentInstrument","ofType":null}}}},"args":[]},{"name":"preOrderDeliveryDate","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"productAdjustments","type":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"Adjustment","ofType":null}}},"args":[]},{"name":"productCount","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"products","type":{"kind":"NON_NULL","ofType":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"UNION","name":"CartItem","ofType":null}}}},"args":[]},{"name":"shipment","type":{"kind":"OBJECT","name":"Shipment","ofType":null},"args":[]},{"name":"shipmentMethodInfo","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"ShipmentMethodInfo","ofType":null}},"args":[]},{"name":"shippingAdjustments","type":{"kind":"NON_NULL","ofType":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"Adjustment","ofType":null}}}},"args":[]},{"name":"shippingCosts","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"shippingSurcharge","type":{"kind":"OBJECT","name":"ShippingSurcharge","ofType":null},"args":[]},{"name":"subTotal","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"taxTotal","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"taxation","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"temporaryOrderNo","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"UNION","name":"CartItem","possibleTypes":[{"kind":"OBJECT","name":"GiftCardCartItem"},{"kind":"OBJECT","name":"ProductCartItem"}]},{"kind":"OBJECT","name":"CartPage","fields":[{"name":"aboveCartContent","type":{"kind":"LIST","ofType":{"kind":"OBJECT","name":"componentWithFilters","ofType":null}},"args":[{"name":"preview","type":{"kind":"SCALAR","name":"Any"}},{"name":"src","type":{"kind":"SCALAR","name":"Any"}}]},{"name":"belowCartContent","type":{"kind":"LIST","ofType":{"kind":"OBJECT","name":"componentWithFilters","ofType":null}},"args":[{"name":"preview","type":{"kind":"SCALAR","name":"Any"}},{"name":"src","type":{"kind":"SCALAR","name":"Any"}}]},{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"CashOnDelivery","fields":[{"name":"amount","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"type","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"CashOnDeliveryResult","fields":[{"name":"orderNo","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"pinId","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"Category","fields":[{"name":"appContent","type":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"UNION","name":"MobileAppHomePageContent","ofType":null}}},"args":[]},{"name":"categories","type":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"Category","ofType":null}}},"args":[]},{"name":"content","type":{"kind":"UNION","name":"CategoryContent","ofType":null},"args":[{"name":"isDraft","type":{"kind":"SCALAR","name":"Any"}}]},{"name":"description","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"disableRatings","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"image","type":{"kind":"OBJECT","name":"SanityImage","ofType":null},"args":[]},{"name":"name","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"navChildren","type":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"Category","ofType":null}}},"args":[]},{"name":"parentCategory","type":{"kind":"OBJECT","name":"Category","ofType":null},"args":[]},{"name":"products","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"PaginatedOutput","ofType":null}},"args":[{"name":"input","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"seo","type":{"kind":"OBJECT","name":"SEO","ofType":null},"args":[]},{"name":"sizeChartId","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"sizeCharts","type":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"SizeChart","ofType":null}}},"args":[]},{"name":"title","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"url","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"visible","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"UNION","name":"CategoryContent","possibleTypes":[{"kind":"OBJECT","name":"CategoryPage"},{"kind":"OBJECT","name":"ProductListingPage"}]},{"kind":"OBJECT","name":"CategoryExclusion","fields":[{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"url","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"CategoryPage","fields":[{"name":"appSlots","type":{"kind":"NON_NULL","ofType":{"kind":"LIST","ofType":{"kind":"OBJECT","name":"AppComponentWithFilters","ofType":null}}},"args":[{"name":"preview","type":{"kind":"SCALAR","name":"Any"}},{"name":"src","type":{"kind":"SCALAR","name":"Any"}}]},{"name":"category","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"Category","ofType":null}},"args":[]},{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"slots","type":{"kind":"NON_NULL","ofType":{"kind":"LIST","ofType":{"kind":"OBJECT","name":"componentWithFilters","ofType":null}}},"args":[{"name":"preview","type":{"kind":"SCALAR","name":"Any"}},{"name":"src","type":{"kind":"SCALAR","name":"Any"}}]},{"name":"title","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]}],"interfaces":[{"kind":"INTERFACE","name":"Page"}]},{"kind":"OBJECT","name":"CheckNumberAndSendSmsResult","fields":[{"name":"pinId","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"CheckoutAwaitAction","fields":[{"name":"paymentData","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"paymentMethodType","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"type","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"url","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"CheckoutRedirectAction","fields":[{"name":"data","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"method","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"paymentMethodType","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"type","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"url","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"CheckoutSDKAction","fields":[{"name":"paymentData","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"paymentMethodType","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"sdkData","type":{"kind":"OBJECT","name":"SDKData","ofType":null},"args":[]},{"name":"type","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"Children","fields":[{"name":"_key","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"_type","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"marks","type":{"kind":"LIST","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"text","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"Chip","fields":[{"name":"filterId","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"filterLabel","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"label","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"value","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"CitizenRefLookupResponse","fields":[{"name":"citizenId","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"externalRef","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"locale","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"CloudinaryConfig","fields":[{"name":"status","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"transformations","type":{"kind":"LIST","ofType":{"kind":"OBJECT","name":"CloudinaryTransformation","ofType":null}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"CloudinaryTransformation","fields":[{"name":"height","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"media","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"platform","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"url","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"width","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"ColorInput","fields":[{"name":"alpha","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"hex","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"rgb","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"Rgba","ofType":null}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"ComparisonField","fields":[{"name":"name","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"value","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"ComparisonProduct","fields":[{"name":"comparisonFields","type":{"kind":"NON_NULL","ofType":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"ComparisonField","ofType":null}}}},"args":[]},{"name":"product","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"VariantProduct","ofType":null}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"CompleteAmazonPaymentPayload","fields":[{"name":"order","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"StandardOrder","ofType":null}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"ConfigureIDSettings","fields":[{"name":"enabled","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"productID","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"ConfirmKlarnaPaymentPayload","fields":[{"name":"authorizedPaymentMethod","type":{"kind":"OBJECT","name":"KlarnaAuthorizedPaymentMethod","ofType":null},"args":[]},{"name":"fraudStatus","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"orderId","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"redirectUrl","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"ConfirmRazorPayPayload","fields":[{"name":"order","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"StandardOrder","ofType":null}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"ConfirmUpdatePhonePayload","fields":[{"name":"code","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"message","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"user","type":{"kind":"OBJECT","name":"User","ofType":null},"args":[]}],"interfaces":[]},{"kind":"UNION","name":"ContentRecommender","possibleTypes":[{"kind":"OBJECT","name":"MobileAppProductRecommendations"},{"kind":"OBJECT","name":"SignUpForm"}]},{"kind":"OBJECT","name":"Coordinates","fields":[{"name":"height","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"width","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"x","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"y","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"z","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"CountdownClock","fields":[{"name":"availableFrom","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"availableTo","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"countdownEnd","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"CouponItem","fields":[{"name":"calloutMessage","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"code","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"couponFamily","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"couponItemId","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"couponType","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"discountAmount","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"statusCode","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"valid","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"CreditCard","fields":[{"name":"amount","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"authorizationStatus","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"cardType","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"expirationMonth","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"expirationYear","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"holder","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"maskedNumber","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"type","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"CreditCardConfirm","fields":[{"name":"amount","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"authorizationStatus","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"cardType","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"maskedNumber","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"type","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]}],"interfaces":[]},{"kind":"UNION","name":"CreditCardResult","possibleTypes":[{"kind":"OBJECT","name":"StandardOrder"},{"kind":"OBJECT","name":"ThreeDSResponse"}]},{"kind":"OBJECT","name":"Currency","fields":[{"name":"code","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"decimalsToDisplay","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"symbol","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"CustomerContext","fields":[{"name":"customerGroups","type":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}},"args":[]},{"name":"hashKey","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"CustomerInfo","fields":[{"name":"customerNo","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"email","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"id","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"CustomerSupport","fields":[{"name":"chatHours","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"email","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"phone","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"phoneHours","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"title","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"DOB","fields":[{"name":"day","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"month","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"year","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"DeliveryDateDays","fields":[{"name":"endDeliveryDateDay","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"startDeliveryDateDay","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"DisplayOutOfStock","fields":[{"name":"backsoon","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"comingsoon","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"displayValue","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"presale","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"soldout","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"soldoutWithRecommender","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"validFrom","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"validTo","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"DropCalendarPage","fields":[{"name":"aboveContent","type":{"kind":"LIST","ofType":{"kind":"UNION","name":"ContentRecommender","ofType":null}},"args":[]},{"name":"aboveContentRecommenders","type":{"kind":"LIST","ofType":{"kind":"OBJECT","name":"MobileAppProductRecommendations","ofType":null}},"args":[]},{"name":"belowContent","type":{"kind":"LIST","ofType":{"kind":"UNION","name":"ContentRecommender","ofType":null}},"args":[]},{"name":"belowContentRecommenders","type":{"kind":"LIST","ofType":{"kind":"OBJECT","name":"MobileAppProductRecommendations","ofType":null}},"args":[]},{"name":"products","type":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"DropCalendarProduct","ofType":null}}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"DropCalendarProduct","fields":[{"name":"appOnlyDateTimeFrom","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"appOnlyDateTimeTo","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"color","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"copy","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"ctaCopy","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"enableCountdown","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"header","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"image","type":{"kind":"OBJECT","name":"SanityImage","ofType":null},"args":[]},{"name":"imageUrl","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"isAppExclusive","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"isProductLinkDisabled","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"launchDate","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"link","type":{"kind":"OBJECT","name":"MobileAppLink","ofType":null},"args":[]},{"name":"masterId","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"subHeader","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"EinsteinProduct","fields":[{"name":"altId","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"altIdType","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"sku","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"Environment","fields":[{"name":"abTestingScript","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"adyenClientKey","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"adyenEnv","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"adyenMerchantAccount","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"adyenPayPalIntent","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"adyenPayPalMerchantId","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"adyenPublicKey","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"adyenStatusUrl","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"afterpaySDKSource","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"amazonPayButtonColor","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"amazonPayButtonSize","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"amazonPayClientId","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"amazonPayMerchantId","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"amazonPayMode","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"amazonPayPublicKeyId","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"amazonPayScope","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"amazonPayStoreId","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"appleMerchantIdentifier","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"appleMerchantName","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"bazaarVoiceReviewFormScriptUrl","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"bloomreachAccountId","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"bloomreachSEOAccountId","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"branchKey","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"checkoutAppInMaintenance","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"configureIdApiKey","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"configureIdScriptUrl","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"dataGuardTemplateId","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"dynamicYieldDynamicUrl","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"dynamicYieldStaticUrl","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"emarsysSignupURL","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"emplifiTurnToSite","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"fitAnalyticsOrderConfirmationUrl","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"fitAnalyticsPdpUrl","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"forterSiteId","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"freshChatHost","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"freshChatToken","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"gmoShopId","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"gmoSource","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"googleApiKey","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"googleOptimizeContainerId","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"googlePayEnvironment","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"googlePayMerchantId","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"googlePayMerchantName","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"googlePayPaymentGateway","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"googlePayPaymentGatewayMerchantId","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"googleTagManagerId","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"idMeClientId","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"klarnaDataClientId","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"klarnaScriptUrl","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"myCustomizerDomain","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"myCustomizerShopId","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"oneTrustApiKey","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"otpVerificationTokenSecret","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"payPayReloadCount","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"payPayRetryWaitingTime","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"pixleeApiKey","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"radialFingerprint","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"radialStoreId","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"razorPaySdkKey","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"recaptchaSiteKey","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"returnUrl","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"sanityDataset","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"sanityProjectId","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"sanitySiteId","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"storeRocketId","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"styliticsUsername","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"webInMaintenanceMode","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"yottaaScriptUrl","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"Error404","fields":[{"name":"appContent","type":{"kind":"LIST","ofType":{"kind":"UNION","name":"MobileApp404PageContent","ofType":null}},"args":[]},{"name":"appContent2","type":{"kind":"LIST","ofType":{"kind":"OBJECT","name":"AppComponentWithFilters","ofType":null}},"args":[]},{"name":"content","type":{"kind":"LIST","ofType":{"kind":"OBJECT","name":"componentWithFilters","ofType":null}},"args":[]},{"name":"customerSupportLinks","type":{"kind":"OBJECT","name":"CustomerSupport","ofType":null},"args":[]},{"name":"heading","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"seo","type":{"kind":"OBJECT","name":"SEO","ofType":null},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"EstimatedDeliveryDate","fields":[{"name":"carrierCode","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"eddBegin","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"eddEnd","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"errorResponse","type":{"kind":"OBJECT","name":"EstimatedDeliveryDateErrorResponse","ofType":null},"args":[]},{"name":"id","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"postalCode","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"productId","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"serviceCode","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"timeZoneName","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"EstimatedDeliveryDateErrorResponse","fields":[{"name":"code","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"message","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"EstimatedShippingDate","fields":[{"name":"carrierCode","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"cutoff","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"max","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"min","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"serviceCode","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"timezone","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"FaqItem","fields":[{"name":"answer","type":{"kind":"LIST","ofType":{"kind":"OBJECT","name":"PortableText","ofType":null}},"args":[]},{"name":"question","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"FaqModule","fields":[{"name":"_id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"faqs","type":{"kind":"NON_NULL","ofType":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"FaqItem","ofType":null}}}},"args":[]},{"name":"puid","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"title","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"FeatureFlags","fields":[{"name":"additionalPriceTextForSaleEnabled","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"addressResumeInCheckoutEnabled","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"afterPayEnabled","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"allowGuestAccessToOrderDetails","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"amazonPayEnabled","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"appAmazonPayEnabled","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"appApplePayEnabled","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"appGooglePayEnabled","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"appKlarnaEnabled","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"appPayPalEnabled","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"appPayPayEnabled","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"appPaymentPromotionEnabled","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"appUseSavedCardsEnabled","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"applePayEnabled","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"autoShowNewsletterPopupEnabled","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"cartSummaryPromoCodeExpandedOnMobile","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"checkoutOrderDetailsIsExpandedOnLoad","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"collapsableCheckoutOrderDetailsFullEnabled","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"collapsableCheckoutOrderDetailsOnlyProductsEnabled","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"collapsableOrderDetailsIsCollapsedOnLoad","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"createAccountInCheckoutEnabled","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"desiredDeliveryDateEnabled","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"giftCardEnabled","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"googleAddressLookupEnabled","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"googlePayEnabled","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"googleReversePostalCodeLookup","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"hideYourSavings","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"klarnaEnabled","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"miniCartSeparateViewAndCheckoutButtons","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"myAccountDashboardMembershipSectionEnabled","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"myAccountEditPasswordShowAdditionalCancelButtonEnabled","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"myAccountEditPasswordUseLabelInsteadOfPlaceholderEnabled","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"myAccountHideNewsletterSettingsInDashboard","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"myAccountHideNotificationSettingsInDashboard","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"myAccountLeaveResetPasswordConfirmPopupOpenEnabled","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"myAccountOrderDetailsBillingInfoEnabled","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"myAccountOrderDetailsContactInfoEnabled","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"myAccountShowAdditionalFieldsInEditEnabled","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"myCustomizerEnabled","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"nestedOrdersEnabled","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"opluxEnabled","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"otpLoginEnabled","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"outfitsEnabled","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"payPalEnabled","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"payPayEnabled","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"paymentPromotionEnabled","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"phoneInProfileEnabled","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"pincodeServiceabilityEnabled","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"priceWithDataEnabled","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"promoCodeAccordionIsExpandedByDefault","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"ratingsAndReviewsEnabled","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"registerOTPVerificationEnabled","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"returnOrderEnabled","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"saveAddressCheckboxEnabled","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"scShowCartAbandonmentModalEnabled","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"showDiscountAmountAndTextEnabled","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"showDynamicTaxMessage","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"showOnlyOrderableSizesEnabled","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"showProductKeywordsEnabled","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"showSaleBadgeOnProductImageEnabled","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"showUserRegistrationOnCheckoutEnabled","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"simplifiedAddressResumeInCheckoutEnabled","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"simplifiedGoogleShoppingPdpEnabled","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"storeCreditsEnabled","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"toggleCheckoutOrderDetailsFullEnabled","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"toggleCheckoutOrderDetailsOnlyProductsEnabled","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"useSavedCardsEnabled","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"webAmazonPayEnabled","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"webApplePayEnabled","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"webGooglePayEnabled","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"webKlarnaEnabled","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"webPayPalEnabled","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"webPayPayEnabled","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"webPaymentPromotionEnabled","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"webUseSavedCardsEnabled","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"FeatureGridRow","fields":[{"name":"copy","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"ctas","type":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"CTA","ofType":null}}},"args":[]},{"name":"header","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"layout","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"mobilePrimaryImage","type":{"kind":"OBJECT","name":"SanityImage","ofType":null},"args":[]},{"name":"primaryImage","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"SanityImage","ofType":null}},"args":[]},{"name":"secondaryImage","type":{"kind":"OBJECT","name":"SanityImage","ofType":null},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"FeatureHero","fields":[{"name":"_id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"availableFrom","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"availableTo","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"backgroundColor","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"copy","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"ctas","type":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"CTA","ofType":null}}},"args":[]},{"name":"footnote","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"header","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"logo","type":{"kind":"OBJECT","name":"SanityImage","ofType":null},"args":[]},{"name":"primaryImage","type":{"kind":"OBJECT","name":"SanityImage","ofType":null},"args":[]},{"name":"primaryVideo","type":{"kind":"OBJECT","name":"SanityVideo","ofType":null},"args":[]},{"name":"secondaryImage","type":{"kind":"OBJECT","name":"SanityImage","ofType":null},"args":[]},{"name":"secondaryVideo","type":{"kind":"OBJECT","name":"SanityVideo","ofType":null},"args":[]},{"name":"textColor","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"FeaturesGrid","fields":[{"name":"_id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"featureRows","type":{"kind":"NON_NULL","ofType":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"FeatureGridRow","ofType":null}}}},"args":[]},{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"FilterOption","fields":[{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"label","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"max","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"min","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"values","type":{"kind":"NON_NULL","ofType":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"FilterOptionValue","ofType":null}}}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"FilterOptionValue","fields":[{"name":"hitCount","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"label","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"value","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"FitOptions","fields":[{"name":"label","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"masterProduct","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"Product","ofType":null}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"FrontendConfiguration","fields":[{"name":"environment","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"Environment","ofType":null}},"args":[]},{"name":"featureFlags","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"FeatureFlags","ofType":null}},"args":[]},{"name":"siteConfig","type":{"kind":"OBJECT","name":"SiteConfig","ofType":null},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"FullBleedHero","fields":[{"name":"_id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"availableFrom","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"availableTo","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"backgroundColor","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"backgroundImage","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"SanityImage","ofType":null}},"args":[]},{"name":"backgroundOverlay","type":{"kind":"OBJECT","name":"BackgroundOverlay","ofType":null},"args":[]},{"name":"copy","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"countdownClock","type":{"kind":"OBJECT","name":"CountdownClock","ofType":null},"args":[]},{"name":"ctas","type":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"CTA","ofType":null}}},"args":[]},{"name":"footnote","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"header","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"horizontalAlignment","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"logo","type":{"kind":"OBJECT","name":"SanityImage","ofType":null},"args":[]},{"name":"logoMobile","type":{"kind":"OBJECT","name":"SanityImage","ofType":null},"args":[]},{"name":"logoPosition","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"minAspectRatio","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"mobileBackgroundImage","type":{"kind":"OBJECT","name":"SanityImage","ofType":null},"args":[]},{"name":"mobileBackgroundOverlay","type":{"kind":"OBJECT","name":"BackgroundOverlay","ofType":null},"args":[]},{"name":"overlayContent","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"puid","type":{"kind":"OBJECT","name":"BannerIdentifier","ofType":null},"args":[]},{"name":"showDayFieldInCountdownClock","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"textAlignment","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"textColor","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"verticalAlignment","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"GiftCard","fields":[{"name":"amount","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"authorizationStatus","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"maskedNumber","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"type","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"GiftCardCartItem","fields":[{"name":"amount","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"imageUrl","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"message","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"recipientEmail","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"recipientName","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"senderName","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"GiftCardProduct","fields":[{"name":"defaultValue","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"image","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"name","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"valueOptions","type":{"kind":"NON_NULL","ofType":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"GiftWithPurchasePromo","fields":[{"name":"allowedQuantity","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"availableProducts","type":{"kind":"NON_NULL","ofType":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"UNION","name":"BonusItemProduct","ofType":null}}}},"args":[]},{"name":"calloutMessage","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"details","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"fullfilled","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"gwpTitle","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"promotionId","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"GlobalPromoBanner","fields":[{"name":"duration","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"messages","type":{"kind":"NON_NULL","ofType":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"Message","ofType":null}}}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"GlossaryCategory","fields":[{"name":"label","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"value","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"GlossaryPage","fields":[{"name":"categories","type":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"GlossaryCategory","ofType":null}}},"args":[]},{"name":"headerBackgroundImage","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"SanityImage","ofType":null}},"args":[]},{"name":"headerIntroduction","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"puid","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"seo","type":{"kind":"OBJECT","name":"SEO","ofType":null},"args":[]},{"name":"terms","type":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"GlossaryTermFlattened","ofType":null}}},"args":[]},{"name":"title","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"url","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]}],"interfaces":[{"kind":"INTERFACE","name":"Page"}]},{"kind":"OBJECT","name":"GlossaryTermFlattened","fields":[{"name":"categories","type":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}},"args":[]},{"name":"definition","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"image","type":{"kind":"OBJECT","name":"SanityImage","ofType":null},"args":[]},{"name":"mediaType","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"puid","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"term","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"video","type":{"kind":"OBJECT","name":"SanityVideo","ofType":null},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"GmoTokenInput","fields":[{"name":"cardno","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"expire","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"holdername","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"securitycode","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"GooglePay","fields":[{"name":"amount","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"authorizationStatus","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"type","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]}],"interfaces":[]},{"kind":"UNION","name":"HighlightContent","possibleTypes":[{"kind":"OBJECT","name":"MobileAppProductTileCustom"},{"kind":"OBJECT","name":"MobileAppProductTileStandard"},{"kind":"OBJECT","name":"MobileAppTeaserTile"}]},{"kind":"OBJECT","name":"HotspotHero","fields":[{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"HowToWearIt","fields":[{"name":"_id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"Iframe","fields":[{"name":"_id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"fullScreen","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"height","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"heightPercentage","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"identifier","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"src","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"Image","fields":[{"name":"landscape","type":{"kind":"OBJECT","name":"SanityImage","ofType":null},"args":[]},{"name":"portrait","type":{"kind":"OBJECT","name":"SanityImage","ofType":null},"args":[]},{"name":"square","type":{"kind":"OBJECT","name":"SanityImage","ofType":null},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"Info","fields":[{"name":"content","type":{"kind":"LIST","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"label","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"InfoBanner","fields":[{"name":"_id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"backgroundColor","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"backgroundImage","type":{"kind":"OBJECT","name":"SanityImage","ofType":null},"args":[]},{"name":"backgroundOverlay","type":{"kind":"OBJECT","name":"BackgroundOverlay","ofType":null},"args":[]},{"name":"copy","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"countdownClock","type":{"kind":"OBJECT","name":"CountdownClock","ofType":null},"args":[]},{"name":"ctas","type":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"CTA","ofType":null}}},"args":[]},{"name":"footnote","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"header","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"mobileBackgroundImage","type":{"kind":"OBJECT","name":"SanityImage","ofType":null},"args":[]},{"name":"mobileBackgroundOverlay","type":{"kind":"OBJECT","name":"BackgroundOverlay","ofType":null},"args":[]},{"name":"puid","type":{"kind":"OBJECT","name":"BannerIdentifier","ofType":null},"args":[]},{"name":"showCountdownBeneathSubheading","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"textColor","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"Information","fields":[{"name":"details","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"title","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"Interest","fields":[{"name":"availableFrom","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"availableTo","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"category","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"content","type":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"UNION","name":"HighlightContent","ofType":null}}},"args":[]},{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"image","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"SanityImage","ofType":null}},"args":[]},{"name":"name","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"Inventory","fields":[{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"limitedAvailability","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"quantity","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"Issuer","fields":[{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"name","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]}],"interfaces":[]},{"kind":"UNION","name":"KlarnaAction","possibleTypes":[{"kind":"OBJECT","name":"CheckoutAwaitAction"},{"kind":"OBJECT","name":"CheckoutRedirectAction"},{"kind":"OBJECT","name":"CheckoutSDKAction"}]},{"kind":"OBJECT","name":"KlarnaAssetsUrl","fields":[{"name":"descriptive","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"standard","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"KlarnaAuthorizedPaymentMethod","fields":[{"name":"numberOfDays","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"numberOfInstallments","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"type","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"KlarnaCreateOrderResponse","fields":[{"name":"authorized_payment_method","type":{"kind":"OBJECT","name":"KlarnaAuthorizedPaymentMethod","ofType":null},"args":[]},{"name":"fraud_status","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"order_id","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"KlarnaCreateSessionPayload","fields":[{"name":"clientToken","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"paymentMethodCategories","type":{"kind":"LIST","ofType":{"kind":"OBJECT","name":"KlarnaPaymentMethodCategories","ofType":null}},"args":[]},{"name":"sessionId","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"KlarnaCreateSessionResponse","fields":[{"name":"client_token","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"payment_method_categories","type":{"kind":"LIST","ofType":{"kind":"OBJECT","name":"KlarnaPaymentMethodCategoriesResponse","ofType":null}},"args":[]},{"name":"session_id","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"KlarnaPaymentMethodCategories","fields":[{"name":"assetUrl","type":{"kind":"OBJECT","name":"KlarnaAssetsUrl","ofType":null},"args":[]},{"name":"identifier","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"name","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"KlarnaPaymentMethodCategoriesResponse","fields":[{"name":"asset_urls","type":{"kind":"OBJECT","name":"KlarnaAssetsUrl","ofType":null},"args":[]},{"name":"identifier","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"name","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"KlarnaPayments","fields":[{"name":"amount","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"type","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"KlarnaResult","fields":[{"name":"action","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"orderNo","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"url","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"LaunchCalendar","fields":[{"name":"_id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"calendarContent","type":{"kind":"NON_NULL","ofType":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"UNION","name":"Media","ofType":null}}}},"args":[]},{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"Link","fields":[{"name":"href","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"newtab","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"query","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"LinkListing","fields":[{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"links","type":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"CTA","ofType":null}}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"LongTermPreOrder","fields":[{"name":"hasLongTermPreOrderItem","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"longTermPreOrderItemPaymentMethods","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"MainFooter","fields":[{"name":"aboutLinks","type":{"kind":"NON_NULL","ofType":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"CTA","ofType":null}}}},"args":[]},{"name":"featuredLinks","type":{"kind":"NON_NULL","ofType":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"CTA","ofType":null}}}},"args":[]},{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"legalLinks","type":{"kind":"NON_NULL","ofType":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"CTA","ofType":null}}}},"args":[]},{"name":"minimalLinks","type":{"kind":"NON_NULL","ofType":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"CTA","ofType":null}}}},"args":[]},{"name":"signUpForm","type":{"kind":"OBJECT","name":"SignUpForm","ofType":null},"args":[]},{"name":"signUpForms","type":{"kind":"LIST","ofType":{"kind":"OBJECT","name":"SignUpForm","ofType":null}},"args":[]},{"name":"supportLinks","type":{"kind":"NON_NULL","ofType":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"CTA","ofType":null}}}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"MainNav","fields":[{"name":"children","type":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"MainNavItem","ofType":null}}},"args":[]},{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"userMenuQuicklinks","type":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"CTA","ofType":null}}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"MainNavCategory","fields":[{"name":"description","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"image","type":{"kind":"OBJECT","name":"SanityImage","ofType":null},"args":[]},{"name":"title","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"MainNavItem","fields":[{"name":"children","type":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"MainNavItem","ofType":null}}},"args":[]},{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"image","type":{"kind":"OBJECT","name":"SanityImage","ofType":null},"args":[]},{"name":"label","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"link","type":{"kind":"OBJECT","name":"MainNavLink","ofType":null},"args":[]},{"name":"navChildren","type":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"MainNavItem","ofType":null}}},"args":[]},{"name":"navColor","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"MainNavLink","fields":[{"name":"category","type":{"kind":"OBJECT","name":"MainNavCategory","ofType":null},"args":[]},{"name":"href","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"newtab","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"query","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"ManufacturerInfo","fields":[{"name":"countryOfOrigin","type":{"kind":"OBJECT","name":"Info","ofType":null},"args":[]},{"name":"manufacturerAddress","type":{"kind":"OBJECT","name":"Info","ofType":null},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"MarkDefs","fields":[{"name":"_key","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"_ref","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"_type","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"href","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"link","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"newtab","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"MarketingPage","fields":[{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"seo","type":{"kind":"OBJECT","name":"SEO","ofType":null},"args":[]},{"name":"slots","type":{"kind":"NON_NULL","ofType":{"kind":"LIST","ofType":{"kind":"OBJECT","name":"componentWithFilters","ofType":null}}},"args":[{"name":"preview","type":{"kind":"SCALAR","name":"Any"}},{"name":"src","type":{"kind":"SCALAR","name":"Any"}}]},{"name":"title","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]}],"interfaces":[{"kind":"INTERFACE","name":"Page"}]},{"kind":"UNION","name":"Media","possibleTypes":[{"kind":"OBJECT","name":"Card"},{"kind":"OBJECT","name":"Tile"}]},{"kind":"OBJECT","name":"Message","fields":[{"name":"availableFrom","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"availableTo","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"campaign","type":{"kind":"LIST","ofType":{"kind":"OBJECT","name":"Campaign","ofType":null}},"args":[]},{"name":"countdownClock","type":{"kind":"OBJECT","name":"CountdownClock","ofType":null},"args":[]},{"name":"ctas","type":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"CTA","ofType":null}}},"args":[]},{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"information","type":{"kind":"OBJECT","name":"Information","ofType":null},"args":[]},{"name":"text","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]}],"interfaces":[]},{"kind":"UNION","name":"MobileApp404PageContent","possibleTypes":[{"kind":"OBJECT","name":"MobileAppProductRecommendations"},{"kind":"OBJECT","name":"MobileAppTeaserTile"}]},{"kind":"OBJECT","name":"MobileAppCTA","fields":[{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"link","type":{"kind":"OBJECT","name":"MobileAppLink","ofType":null},"args":[]},{"name":"title","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"MobileAppCarousel","fields":[{"name":"_id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"availableFrom","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"availableTo","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"content","type":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"UNION","name":"MobileAppCarouselContent","ofType":null}}},"args":[]},{"name":"identifier","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]}],"interfaces":[]},{"kind":"UNION","name":"MobileAppCarouselContent","possibleTypes":[{"kind":"OBJECT","name":"MobileAppProductTileCustom"},{"kind":"OBJECT","name":"MobileAppProductTileStandard"},{"kind":"OBJECT","name":"MobileAppTeaserTile"},{"kind":"OBJECT","name":"ProductTile"},{"kind":"OBJECT","name":"SanityImage"}]},{"kind":"OBJECT","name":"MobileAppCartNotice","fields":[{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"notices","type":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"MobileAppCategoryLink","fields":[{"name":"name","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"url","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"UNION","name":"MobileAppHomePageContent","possibleTypes":[{"kind":"OBJECT","name":"MobileAppCarousel"},{"kind":"OBJECT","name":"MobileAppProductRecommendations"},{"kind":"OBJECT","name":"MobileAppProductTileCustom"},{"kind":"OBJECT","name":"MobileAppProductTileStandard"},{"kind":"OBJECT","name":"MobileAppQuoteCallout"},{"kind":"OBJECT","name":"MobileAppTeaserTile"},{"kind":"OBJECT","name":"ProductCarousel"},{"kind":"OBJECT","name":"ProductTile"},{"kind":"OBJECT","name":"SignUpForm"},{"kind":"OBJECT","name":"VideoHero"}]},{"kind":"OBJECT","name":"MobileAppInboxItem","fields":[{"name":"countdownClock","type":{"kind":"OBJECT","name":"CountdownClock","ofType":null},"args":[]},{"name":"date","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"image","type":{"kind":"OBJECT","name":"SanityImage","ofType":null},"args":[]},{"name":"link","type":{"kind":"OBJECT","name":"MobileAppLink","ofType":null},"args":[]},{"name":"messageCategory","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"title","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"MobileAppLink","fields":[{"name":"absolute","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"category","type":{"kind":"OBJECT","name":"MobileAppCategoryLink","ofType":null},"args":[]},{"name":"marketing","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"product","type":{"kind":"OBJECT","name":"MobileAppProductLink","ofType":null},"args":[]},{"name":"pumatracLink","type":{"kind":"OBJECT","name":"PumatracLink","ofType":null},"args":[]},{"name":"signUpForm","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"support","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"MobileAppNotificationBanner","fields":[{"name":"availableFrom","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"availableTo","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"badge","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"badgeColor","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"link","type":{"kind":"OBJECT","name":"MobileAppLink","ofType":null},"args":[]},{"name":"title","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"MobileAppProductLink","fields":[{"name":"color","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"masterId","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"MobileAppProductRecommendations","fields":[{"name":"_id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"header","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"identifier","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"promotionId","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"recommendations","type":{"kind":"NON_NULL","ofType":{"kind":"LIST","ofType":{"kind":"OBJECT","name":"ProductSearchHit","ofType":null}}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"MobileAppProductTileCustom","fields":[{"name":"_id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"availableFrom","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"availableTo","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"buttonColor","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"buttonLabel","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"copy","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"countdownClock","type":{"kind":"OBJECT","name":"CountdownClock","ofType":null},"args":[]},{"name":"header","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"identifier","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"link","type":{"kind":"OBJECT","name":"MobileAppLink","ofType":null},"args":[]},{"name":"product","type":{"kind":"OBJECT","name":"Variant","ofType":null},"args":[]},{"name":"showPrice","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"MobileAppProductTileStandard","fields":[{"name":"_id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"availableFrom","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"availableTo","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"countdownClock","type":{"kind":"OBJECT","name":"CountdownClock","ofType":null},"args":[]},{"name":"product","type":{"kind":"OBJECT","name":"Variant","ofType":null},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"MobileAppQuoteCallout","fields":[{"name":"alignment","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"backgroundColor","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"backgroundImage","type":{"kind":"OBJECT","name":"SanityImage","ofType":null},"args":[]},{"name":"backgroundOverlay","type":{"kind":"OBJECT","name":"BackgroundOverlay","ofType":null},"args":[]},{"name":"buttonColor","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"buttonLabel","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"copy","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"countdownClock","type":{"kind":"OBJECT","name":"CountdownClock","ofType":null},"args":[]},{"name":"ctas","type":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"MobileAppCTA","ofType":null}}},"args":[]},{"name":"ctas2","type":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"CTA","ofType":null}}},"args":[]},{"name":"header","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"identifier","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"link","type":{"kind":"OBJECT","name":"MobileAppLink","ofType":null},"args":[]},{"name":"source","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"MobileAppRecommendedWorkout","fields":[{"name":"_id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"badge","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"buttonColor","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"buttonLabel","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"copy","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"header","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"image","type":{"kind":"OBJECT","name":"SanityImage","ofType":null},"args":[]},{"name":"link","type":{"kind":"OBJECT","name":"MobileAppLink","ofType":null},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"MobileAppStory","fields":[{"name":"availableFrom","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"availableTo","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"identifier","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"storyContent","type":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"MobileAppStoryContent","ofType":null}}},"args":[]},{"name":"thumbnail","type":{"kind":"OBJECT","name":"SanityImage","ofType":null},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"MobileAppStoryContent","fields":[{"name":"buttonLabel","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"displayLength","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"id","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"image","type":{"kind":"OBJECT","name":"SanityImage","ofType":null},"args":[]},{"name":"link","type":{"kind":"OBJECT","name":"MobileAppLink","ofType":null},"args":[]},{"name":"title","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"video","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"videoPosterImage","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"videoV2","type":{"kind":"OBJECT","name":"Video","ofType":null},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"MobileAppTeaserTile","fields":[{"name":"_id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"availableFrom","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"availableTo","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"badge","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"buttonColor","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"buttonLabel","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"copy","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"ctas","type":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"MobileAppCTA","ofType":null}}},"args":[]},{"name":"ctas2","type":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"CTA","ofType":null}}},"args":[]},{"name":"header","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"identifier","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"image","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"SanityImage","ofType":null}},"args":[]},{"name":"link","type":{"kind":"OBJECT","name":"MobileAppLink","ofType":null},"args":[]},{"name":"textColor","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"Mutation","fields":[{"name":"addAddress","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"Address","ofType":null}},"args":[{"name":"input","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"addAmazonPayPaymentMethodToCart","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"Cart","ofType":null}},"args":[{"name":"input","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"addAmbassadorCardToCart","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"Cart","ofType":null}},"args":[{"name":"input","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"addCashOnDeliveryPaymentMethodToCart","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"Cart","ofType":null}},"args":[{"name":"input","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"addCouponToCart","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"Cart","ofType":null}},"args":[{"name":"input","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"addCreditCardPaymentMethodToCart","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"Cart","ofType":null}},"args":[{"name":"input","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"addGiftCard","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"Cart","ofType":null}},"args":[{"name":"input","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"addGiftCardToCart","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"Cart","ofType":null}},"args":[{"name":"input","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"addItemToCart","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"Cart","ofType":null}},"args":[{"name":"input","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"addItemToWishList","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"WishList","ofType":null}},"args":[{"name":"input","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"addItemsToCart","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"Cart","ofType":null}},"args":[{"name":"input","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"addItemsToWishList","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"WishList","ofType":null}},"args":[{"name":"input","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"addPayPayPaymentMethodToCart","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"Cart","ofType":null}},"args":[{"name":"input","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"addPaymentPromotion","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"Cart","ofType":null}},"args":[{"name":"input","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"addStoreCredits","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"AddStoreCreditsPayload","ofType":null}},"args":[{"name":"input","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"afterPay","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"AfterPayPayload","ofType":null}},"args":[{"name":"input","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"amazonPay","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"StandardOrder","ofType":null}},"args":[{"name":"input","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"ambassadorCard","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"StandardOrder","ofType":null}},"args":[{"name":"input","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"applePay","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"ApplePayValidationResponse","ofType":null}},"args":[{"name":"input","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"cancelAfterPay","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"StandardOrder","ofType":null}},"args":[{"name":"orderNo","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"cancelAmazonPay","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"StandardOrder","ofType":null}},"args":[{"name":"orderNo","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"cancelApplePay","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"Cart","ofType":null}},"args":[{"name":"basketId","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"cancelCashOnDelivery","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"StandardOrder","ofType":null}},"args":[{"name":"orderNo","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"cancelCreditCard","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"StandardOrder","ofType":null}},"args":[{"name":"orderNo","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"cancelGooglePay","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"Cart","ofType":null}},"args":[{"name":"input","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"cancelKlarna","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"StandardOrder","ofType":null}},"args":[{"name":"input","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"cancelOnlineBanking","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"StandardOrder","ofType":null}},"args":[{"name":"orderNo","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"cancelOrder","type":{"kind":"OBJECT","name":"CancelOrderPayload","ofType":null},"args":[{"name":"input","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"cancelPayPal","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"StandardOrder","ofType":null}},"args":[{"name":"orderNo","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"cancelPayPay","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"StandardOrder","ofType":null}},"args":[{"name":"orderNo","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"cancelPayTm","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"StandardOrder","ofType":null}},"args":[{"name":"orderNo","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"cancelUpi","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"StandardOrder","ofType":null}},"args":[{"name":"orderNo","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"cancelWallet","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"StandardOrder","ofType":null}},"args":[{"name":"orderNo","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"cashOnDelivery","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"StandardOrder","ofType":null}},"args":[{"name":"input","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"checkNumberAndSendSms","type":{"kind":"OBJECT","name":"CheckNumberAndSendSmsResult","ofType":null},"args":[{"name":"input","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"completeAdyenPayment","type":{"kind":"OBJECT","name":"AdyenPaymentDetailsPayload","ofType":null},"args":[{"name":"input","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"completeAmazonPayment","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"CompleteAmazonPaymentPayload","ofType":null}},"args":[{"name":"input","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"completeResetPassword","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[{"name":"password","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}},{"name":"token","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"confirmAfterPay","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"StandardOrder","ofType":null}},"args":[{"name":"input","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"confirmAmazonPay","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"StandardOrder","ofType":null}},"args":[{"name":"input","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"confirmApplePay","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"StandardOrder","ofType":null}},"args":[{"name":"input","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"confirmCashOnDelivery","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"StandardOrder","ofType":null}},"args":[{"name":"input","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"confirmCreditCard","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"StandardOrder","ofType":null}},"args":[{"name":"input","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"confirmKlarna","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"StandardOrder","ofType":null}},"args":[{"name":"input","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"confirmKlarnaPayment","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"StandardOrder","ofType":null}},"args":[{"name":"input","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"confirmLoginWithEmailOTP","type":{"kind":"OBJECT","name":"AuthPayload","ofType":null},"args":[{"name":"input","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"confirmLoginWithOTP","type":{"kind":"OBJECT","name":"AuthPayload","ofType":null},"args":[{"name":"input","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"confirmOnlineBanking","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"StandardOrder","ofType":null}},"args":[{"name":"input","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"confirmPayPal","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"StandardOrder","ofType":null}},"args":[{"name":"input","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"confirmPayPay","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"StandardOrder","ofType":null}},"args":[{"name":"input","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"confirmPayTm","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"StandardOrder","ofType":null}},"args":[{"name":"orderNo","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"confirmPayTmWithResultCode","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"StandardOrder","ofType":null}},"args":[{"name":"input","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"confirmRazorPay","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"ConfirmRazorPayPayload","ofType":null}},"args":[{"name":"input","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"confirmUpdatePhone","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"ConfirmUpdatePhonePayload","ofType":null}},"args":[{"name":"input","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"confirmUpi","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"StandardOrder","ofType":null}},"args":[{"name":"orderNo","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"confirmUpiWithResultCode","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"StandardOrder","ofType":null}},"args":[{"name":"input","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"confirmWallet","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"StandardOrder","ofType":null}},"args":[{"name":"orderNo","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"confirmWalletWithResultCode","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"StandardOrder","ofType":null}},"args":[{"name":"input","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"createCart","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"Cart","ofType":null}},"args":[]},{"name":"createContact","type":{"kind":"OBJECT","name":"NewsletterSubscription","ofType":null},"args":[{"name":"input","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"createReview","type":{"kind":"OBJECT","name":"Review","ofType":null},"args":[{"name":"input","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"createShopperContext","type":{"kind":"OBJECT","name":"ShopperContextPayload","ofType":null},"args":[{"name":"input","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"creditCard","type":{"kind":"NON_NULL","ofType":{"kind":"UNION","name":"CreditCardResult","ofType":null}},"args":[{"name":"input","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"deleteAccountRequest","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"deleteAddress","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"deleteAmbassadorCard","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"User","ofType":null}},"args":[{"name":"input","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"deleteCreditCard","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"User","ofType":null}},"args":[{"name":"input","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"giftCard","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"StandardOrder","ofType":null}},"args":[{"name":"input","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"gmoConfirmCreditCard","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"StandardOrder","ofType":null}},"args":[{"name":"input","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"googlePay","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"StandardOrder","ofType":null}},"args":[{"name":"input","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"guestLogon","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"TokenPayload","ofType":null}},"args":[]},{"name":"klarna","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"KlarnaResult","ofType":null}},"args":[{"name":"input","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"login","type":{"kind":"OBJECT","name":"AuthPayload","ofType":null},"args":[{"name":"input","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"loginWithEmailOTP","type":{"kind":"OBJECT","name":"SendEmailOtpResult","ofType":null},"args":[{"name":"input","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"loginWithOTP","type":{"kind":"SCALAR","name":"Any"},"args":[{"name":"input","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"loginWithPhone","type":{"kind":"OBJECT","name":"AuthPayload","ofType":null},"args":[{"name":"input","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"logout","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"manageCustomerLevelNotification","type":{"kind":"SCALAR","name":"Any"},"args":[{"name":"input","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"manageOrderLevelNotification","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[{"name":"input","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"onlineBanking","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"OnlineBankingResult","ofType":null}},"args":[{"name":"input","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"opluxFraudDetection","type":{"kind":"OBJECT","name":"OpluxFraudDetectionResult","ofType":null},"args":[{"name":"basketId","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}},{"name":"fraudbuster","type":{"kind":"SCALAR","name":"Any"}},{"name":"opluxEventId","type":{"kind":"SCALAR","name":"Any"}},{"name":"opluxFraudDetection","type":{"kind":"SCALAR","name":"Any"}},{"name":"opluxScreeningResult","type":{"kind":"SCALAR","name":"Any"}},{"name":"paymentMethodId","type":{"kind":"SCALAR","name":"Any"}}]},{"name":"payPal","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"PayPalResult","ofType":null}},"args":[{"name":"input","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"payPay","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"PayPayPayload","ofType":null}},"args":[{"name":"input","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"payTm","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"PayTmResult","ofType":null}},"args":[{"name":"basketId","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}},{"name":"feHost","type":{"kind":"SCALAR","name":"Any"}}]},{"name":"placeOrder","type":{"kind":"OBJECT","name":"PlaceOrderPayload","ofType":null},"args":[{"name":"input","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"profilingConsent","type":{"kind":"OBJECT","name":"ProfilingConsentResponse","ofType":null},"args":[{"name":"input","type":{"kind":"SCALAR","name":"Any"}}]},{"name":"refreshLogon","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"TokenPayload","ofType":null}},"args":[{"name":"input","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"refreshToken","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"register","type":{"kind":"OBJECT","name":"AuthPayload","ofType":null},"args":[{"name":"input","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"registerAmazonPayment","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"RegisterAmazonPaymentPayload","ofType":null}},"args":[{"name":"input","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"removeAmbassadorCardFromCart","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"Cart","ofType":null}},"args":[{"name":"input","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"removeCouponFromCart","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"Cart","ofType":null}},"args":[{"name":"input","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"removeGiftCard","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"Cart","ofType":null}},"args":[{"name":"input","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"removeGiftCardFromCart","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"Cart","ofType":null}},"args":[{"name":"input","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"removeItemFromCart","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"Cart","ofType":null}},"args":[{"name":"input","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"removeItemFromWishList","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[{"name":"input","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"removeStoreCredits","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"RemoveStoreCreditsPayload","ofType":null}},"args":[{"name":"input","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"resendOTP","type":{"kind":"SCALAR","name":"Any"},"args":[{"name":"input","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"resetPassword","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[{"name":"email","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"saveAmbassadorCard","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"User","ofType":null}},"args":[{"name":"input","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"saveCreditCard","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"User","ofType":null}},"args":[{"name":"input","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"saveNotificationPreferences","type":{"kind":"OBJECT","name":"NotificationsPayload","ofType":null},"args":[{"name":"input","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"signAmazonPayload","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"SignAmazonPayloadResponse","ofType":null}},"args":[{"name":"input","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"startAdyenPayment","type":{"kind":"OBJECT","name":"StartPaymentPayload","ofType":null},"args":[{"name":"input","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"startAmazonPayment","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"StartAmazonPaymentPayload","ofType":null}},"args":[{"name":"input","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"startAmazonProcessOrderPayment","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"StartAmazonProcessOrderPaymentPayload","ofType":null}},"args":[{"name":"input","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"startCreditCardPayment","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"StandardOrder","ofType":null}},"args":[{"name":"input","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"startKlarnaPayment","type":{"kind":"OBJECT","name":"StartKlarnaPaymentPayload","ofType":null},"args":[{"name":"input","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"startRazorPay","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"StartRazorPayPayload","ofType":null}},"args":[{"name":"input","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"trackGuestUser","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[{"name":"input","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"trackRegisteredUser","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[{"name":"input","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"trackUserEvent","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[{"name":"input","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"transferCart","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"Cart","ofType":null}},"args":[]},{"name":"updateAddress","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"Address","ofType":null}},"args":[{"name":"input","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"updateAmbassadorCards","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"User","ofType":null}},"args":[{"name":"input","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"updateBillingAddress","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"Cart","ofType":null}},"args":[{"name":"input","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"updateContact","type":{"kind":"OBJECT","name":"NewsletterSubscription","ofType":null},"args":[{"name":"input","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"updateItemInCart","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"Cart","ofType":null}},"args":[{"name":"input","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"updateItemInWishList","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"WishList","ofType":null}},"args":[{"name":"input","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"updateOpluxDataToBasket","type":{"kind":"OBJECT","name":"Cart","ofType":null},"args":[{"name":"basketId","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}},{"name":"isClearOpluxData","type":{"kind":"SCALAR","name":"Any"}},{"name":"opluxEventId","type":{"kind":"SCALAR","name":"Any"}},{"name":"opluxScreeningResult","type":{"kind":"SCALAR","name":"Any"}}]},{"name":"updatePassword","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[{"name":"input","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"updatePayPal","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"StandardOrder","ofType":null}},"args":[{"name":"input","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"updatePhone","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"UpdatePhonePayload","ofType":null}},"args":[{"name":"input","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"updateProfile","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"User","ofType":null}},"args":[{"name":"input","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"updateShipmentMethod","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"Cart","ofType":null}},"args":[{"name":"input","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"updateShippingAddress","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"Cart","ofType":null}},"args":[{"name":"input","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"upi","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"UPIResult","ofType":null}},"args":[{"name":"input","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"validateApplePayMerchant","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[{"name":"input","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"verifyLoginWithOTP","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"VerifyLoginWithOTPResult","ofType":null}},"args":[{"name":"input","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"verifyOtpProfile","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[{"name":"input","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"verifyUserAffiliations","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"VerifyUserAffiliationsPayload","ofType":null}},"args":[{"name":"input","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"wallet","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"WalletResult","ofType":null}},"args":[{"name":"input","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]}],"interfaces":[]},{"kind":"OBJECT","name":"MyCustomizerSettings","fields":[{"name":"enabled","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"iframeID","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"startPoint","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"NameTranslations","fields":[{"name":"en","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"es","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"fr","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"NestedOrder","fields":[{"name":"billingAddress","type":{"kind":"OBJECT","name":"OrderAddress","ofType":null},"args":[]},{"name":"createdAt","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"currency","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"customer","type":{"kind":"OBJECT","name":"CustomerInfo","ofType":null},"args":[]},{"name":"estimatedShippingCosts","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"estimatedTotal","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"exportStatus","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"isReturnable","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"orderAdjustments","type":{"kind":"NON_NULL","ofType":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"Adjustment","ofType":null}}}},"args":[]},{"name":"orderNo","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"orderStatus","type":{"kind":"OBJECT","name":"OrderStatus","ofType":null},"args":[]},{"name":"payPayAsyncResultNoticed","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"paymentInstruments","type":{"kind":"NON_NULL","ofType":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"UNION","name":"PaymentInstrument","ofType":null}}}},"args":[]},{"name":"shipment","type":{"kind":"OBJECT","name":"Shipment","ofType":null},"args":[]},{"name":"shippingAdjustments","type":{"kind":"NON_NULL","ofType":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"Adjustment","ofType":null}}}},"args":[]},{"name":"shippingCosts","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"shippingStatus","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"shippingSurcharge","type":{"kind":"OBJECT","name":"ShippingSurcharge","ofType":null},"args":[]},{"name":"status","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"subTotal","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"suborders","type":{"kind":"NON_NULL","ofType":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"Suborder","ofType":null}}}},"args":[]},{"name":"taxTotal","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"taxation","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"trackingNumber","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[{"kind":"INTERFACE","name":"BaseOrder"}]},{"kind":"OBJECT","name":"NewsletterSubscription","fields":[{"name":"dob","type":{"kind":"OBJECT","name":"DOB","ofType":null},"args":[]},{"name":"email","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"emailPreference","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"firstName","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"firstNamePronunciation","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"gender","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"iframeURL","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"isConfirmed","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"lastName","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"lastNamePronunciation","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"memberId","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"shoppingPreference","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"NotFound","fields":[{"name":"textSection","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"TextSection","ofType":null}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"NotFoundContentPage","fields":[{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]}],"interfaces":[{"kind":"INTERFACE","name":"Page"}]},{"kind":"OBJECT","name":"NotImplemented","fields":[{"name":"_id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"_type","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"NotificationsPayload","fields":[{"name":"customerSmsOptIn","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"marketingSmsOptIn","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"phoneNumber","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"OmsEntry","fields":[{"name":"customerId","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"status","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"trackingLink","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"OnlineBanking","fields":[{"name":"amount","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"authorizationStatus","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"type","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"OnlineBankingResult","fields":[{"name":"orderNo","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"url","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"OpluxFraudDetectionResult","fields":[{"name":"isOpluxNG","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"opluxEventId","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"opluxScreeningResult","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"UNION","name":"Order","possibleTypes":[{"kind":"OBJECT","name":"NestedOrder"},{"kind":"OBJECT","name":"StandardOrder"}]},{"kind":"OBJECT","name":"OrderAddress","fields":[{"name":"address1","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"address2","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"address3","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"city","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"companyName","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"countryCode","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"deliveryDate","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"deliveryTimeCode","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"deliveryTimeDisplayText","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"firstName","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"firstNamePronunciation","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"lastName","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"lastNamePronunciation","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"phone","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"postalCode","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"salutation","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"stateCode","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"streetNumber","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"OrderAnalytics","fields":[{"name":"netProratedDiscount","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"OrderEdge","fields":[{"name":"nodes","type":{"kind":"NON_NULL","ofType":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"StandardOrder","ofType":null}}}},"args":[]},{"name":"pageInfo","type":{"kind":"OBJECT","name":"PageInfo","ofType":null},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"OrderStatus","fields":[{"name":"code","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"label","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"INTERFACE","name":"Page","fields":[{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]}],"interfaces":[],"possibleTypes":[{"kind":"OBJECT","name":"CategoryPage"},{"kind":"OBJECT","name":"GlossaryPage"},{"kind":"OBJECT","name":"MarketingPage"},{"kind":"OBJECT","name":"NotFoundContentPage"},{"kind":"OBJECT","name":"SupportPage"}]},{"kind":"OBJECT","name":"PageInfo","fields":[{"name":"limit","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"nextOffset","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"offset","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"totalCount","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"PaginatedOutput","fields":[{"name":"chips","type":{"kind":"NON_NULL","ofType":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"Chip","ofType":null}}}},"args":[]},{"name":"filteringOptions","type":{"kind":"NON_NULL","ofType":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"FilterOption","ofType":null}}}},"args":[]},{"name":"hits","type":{"kind":"NON_NULL","ofType":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"SearchHitMeta","ofType":null}}}},"args":[]},{"name":"limit","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"nodes","type":{"kind":"NON_NULL","ofType":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"ProductSearchHit","ofType":null}}}},"args":[]},{"name":"offset","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"selectedSort","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"sortingOptions","type":{"kind":"NON_NULL","ofType":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"SortOption","ofType":null}}}},"args":[]},{"name":"summaries","type":{"kind":"NON_NULL","ofType":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"ProductSummary","ofType":null}}}},"args":[]},{"name":"totalCount","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"PayPal","fields":[{"name":"authorizationStatus","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"type","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"PayPalResult","fields":[{"name":"action","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"orderNo","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"token","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"url","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"PayPay","fields":[{"name":"authorizationStatus","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"type","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"PayPayContent","fields":[{"name":"body","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"name","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"PayPayPayload","fields":[{"name":"orderNo","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"url","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"PayTm","fields":[{"name":"amount","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"authorizationStatus","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"type","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"PayTmResult","fields":[{"name":"orderNo","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"url","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"PaymentCardSpec","fields":[{"name":"cardType","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"checksumVerificationEnabled","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"description","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"image","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"name","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"numberLengths","type":{"kind":"LIST","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"numberPrefixes","type":{"kind":"LIST","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]}],"interfaces":[]},{"kind":"UNION","name":"PaymentInstrument","possibleTypes":[{"kind":"OBJECT","name":"Adyen"},{"kind":"OBJECT","name":"AdyenKlarna"},{"kind":"OBJECT","name":"AdyenKlarnaAccount"},{"kind":"OBJECT","name":"AdyenPayPal"},{"kind":"OBJECT","name":"AfterPay"},{"kind":"OBJECT","name":"Alipay"},{"kind":"OBJECT","name":"AmazonPay"},{"kind":"OBJECT","name":"AmbassadorCard"},{"kind":"OBJECT","name":"ApplePay"},{"kind":"OBJECT","name":"CashOnDelivery"},{"kind":"OBJECT","name":"CreditCard"},{"kind":"OBJECT","name":"CreditCardConfirm"},{"kind":"OBJECT","name":"GiftCard"},{"kind":"OBJECT","name":"GooglePay"},{"kind":"OBJECT","name":"KlarnaPayments"},{"kind":"OBJECT","name":"OnlineBanking"},{"kind":"OBJECT","name":"PayPal"},{"kind":"OBJECT","name":"PayPay"},{"kind":"OBJECT","name":"PayTm"},{"kind":"OBJECT","name":"Razorpay"},{"kind":"OBJECT","name":"Scheme"},{"kind":"OBJECT","name":"StoreCreditInstrument"},{"kind":"OBJECT","name":"UPI"},{"kind":"OBJECT","name":"Wallet"},{"kind":"OBJECT","name":"WechatPay"},{"kind":"OBJECT","name":"ZipPay"}]},{"kind":"OBJECT","name":"PaymentMethod","fields":[{"name":"bank","type":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"Issuer","ofType":null}}},"args":[]},{"name":"c_additionalFee","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"cards","type":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"PaymentCardSpec","ofType":null}}},"args":[]},{"name":"description","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"name","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"paymentProcessorId","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"wallet","type":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"Issuer","ofType":null}}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"Pdp","fields":[{"name":"ProductStoryAdditionalContentSlot","type":{"kind":"LIST","ofType":{"kind":"OBJECT","name":"componentWithFilters","ofType":null}},"args":[{"name":"preview","type":{"kind":"SCALAR","name":"Any"}},{"name":"src","type":{"kind":"SCALAR","name":"Any"}}]},{"name":"aboveProductStory","type":{"kind":"LIST","ofType":{"kind":"OBJECT","name":"componentWithFilters","ofType":null}},"args":[{"name":"preview","type":{"kind":"SCALAR","name":"Any"}},{"name":"src","type":{"kind":"SCALAR","name":"Any"}}]},{"name":"belowProductGoogleShopping","type":{"kind":"LIST","ofType":{"kind":"OBJECT","name":"componentWithFilters","ofType":null}},"args":[{"name":"preview","type":{"kind":"SCALAR","name":"Any"}},{"name":"src","type":{"kind":"SCALAR","name":"Any"}}]},{"name":"belowProductStory","type":{"kind":"LIST","ofType":{"kind":"OBJECT","name":"componentWithFilters","ofType":null}},"args":[{"name":"preview","type":{"kind":"SCALAR","name":"Any"}},{"name":"src","type":{"kind":"SCALAR","name":"Any"}}]},{"name":"comingSoonSignUpForm","type":{"kind":"OBJECT","name":"SignUpForm","ofType":null},"args":[]},{"name":"ctaAboveSpecialMessage","type":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"CTA","ofType":null}}},"args":[]},{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"soldOutRecommender","type":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"UNION","name":"SoldOutRecommender","ofType":null}}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"PincodeServiceability","fields":[{"name":"city","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"expectedDate","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"stateCode","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"PixleeCdnPhotos","fields":[{"name":"attributedMediumUrl","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"largeUrl","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"mediumUrl","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"originalUrl","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"smallUrl","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"squareMediumUrl","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"PixleeConfig","fields":[{"name":"advancedFilters","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"enable","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"enablePDPGallery","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"numberPicturesGallery","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"socialMediaIcon","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"PixleeSimpleWidget","fields":[{"name":"_id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"widgetId","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"PlaceOrderPayload","fields":[{"name":"order","type":{"kind":"OBJECT","name":"StandardOrder","ofType":null},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"PortableText","fields":[{"name":"_key","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"_type","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"children","type":{"kind":"LIST","ofType":{"kind":"OBJECT","name":"Children","ofType":null}},"args":[]},{"name":"level","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"listItem","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"markDefs","type":{"kind":"LIST","ofType":{"kind":"OBJECT","name":"MarkDefs","ofType":null}},"args":[]},{"name":"style","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"UNION","name":"PortableTextContent","possibleTypes":[{"kind":"OBJECT","name":"CTA"},{"kind":"OBJECT","name":"PortableText"}]},{"kind":"OBJECT","name":"PortableTextWithList","fields":[{"name":"_type","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"children","type":{"kind":"LIST","ofType":{"kind":"OBJECT","name":"TextChildren","ofType":null}},"args":[]},{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"level","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"listItem","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"markDefs","type":{"kind":"LIST","ofType":{"kind":"OBJECT","name":"MarkDefs","ofType":null}},"args":[]},{"name":"style","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"PositionedTile","fields":[{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"position","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"tile","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"PromoTile","ofType":null}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"PriceInfo","fields":[{"name":"price","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"salePrice","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"PrizeSlot","fields":[{"name":"_id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"availableFrom","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"availableTo","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"odds","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"prize","type":{"kind":"OBJECT","name":"SanityPrize","ofType":null},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"Product","fields":[{"name":"altImageUrl","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"amountOfReviews","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"appOnlyDateTimeFrom","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"appOnlyDateTimeTo","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"articleType","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"averageRating","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"badge","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"badges","type":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"ProductBadge","ofType":null}}},"args":[]},{"name":"brand","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"category","type":{"kind":"OBJECT","name":"Category","ofType":null},"args":[]},{"name":"color","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"colorCount","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"colorName","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"colorValue","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"colors","type":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"ProductColor","ofType":null}}},"args":[]},{"name":"configureID","type":{"kind":"OBJECT","name":"ConfigureIDSettings","ofType":null},"args":[]},{"name":"content","type":{"kind":"OBJECT","name":"Pdp","ofType":null},"args":[{"name":"isDraft","type":{"kind":"SCALAR","name":"Any"}}]},{"name":"description","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"disableRatings","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"disableReviews","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"displayOutOfStock","type":{"kind":"OBJECT","name":"DisplayOutOfStock","ofType":null},"args":[]},{"name":"exploreMoreCTALabel","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"exploreMoreCTATargetCategoryID","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"fitOptions","type":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"FitOptions","ofType":null}}},"args":[]},{"name":"header","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"image","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"ProductImage","ofType":null}},"args":[]},{"name":"imageUrl","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"isAppExclusive","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"isMixedCartAllowed","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"isWebExclusive","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"look","type":{"kind":"LIST","ofType":{"kind":"OBJECT","name":"StyliticsLook","ofType":null}},"args":[{"name":"id","type":{"kind":"SCALAR","name":"Any"}}]},{"name":"masterId","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"myCustomizer","type":{"kind":"OBJECT","name":"MyCustomizerSettings","ofType":null},"args":[]},{"name":"name","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"offline","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"orderable","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"orderableColorCount","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"price","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"primaryCategoryId","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"productDivision","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"productMeasurements","type":{"kind":"OBJECT","name":"ProductMeasurements","ofType":null},"args":[]},{"name":"productNameTranslated","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"productStory","type":{"kind":"OBJECT","name":"ProductStory","ofType":null},"args":[]},{"name":"productVideos","type":{"kind":"LIST","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"promotion","type":{"kind":"OBJECT","name":"ProductPromotion","ofType":null},"args":[]},{"name":"promotionExclusion","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"promotions","type":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"ProductPromotion","ofType":null}}},"args":[{"name":"page","type":{"kind":"SCALAR","name":"Any"}}]},{"name":"recommendedWorkouts","type":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"MobileAppRecommendedWorkout","ofType":null}}},"args":[]},{"name":"salePrice","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"score","type":{"kind":"OBJECT","name":"Score","ofType":null},"args":[]},{"name":"shippingCallout","type":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"PortableText","ofType":null}}},"args":[]},{"name":"showExploreCollectionCTA","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"sizeChartId","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"slug","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"subHeader","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"userGeneratedContent","type":{"kind":"LIST","ofType":{"kind":"OBJECT","name":"UserGeneratedContent","ofType":null}},"args":[]},{"name":"userGeneratedContentForWeb","type":{"kind":"LIST","ofType":{"kind":"OBJECT","name":"UserGeneratedContent","ofType":null}},"args":[]},{"name":"variantMeta","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"variations","type":{"kind":"NON_NULL","ofType":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"Variant","ofType":null}}}},"args":[]},{"name":"verticalProductVideos","type":{"kind":"LIST","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"ProductBadge","fields":[{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"label","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"ProductCarousel","fields":[{"name":"_id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"availableFrom","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"availableTo","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"copy","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"header","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"products","type":{"kind":"NON_NULL","ofType":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"VariantProduct","ofType":null}}}},"args":[]},{"name":"puid","type":{"kind":"OBJECT","name":"BannerIdentifier","ofType":null},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"ProductCartItem","fields":[{"name":"adjustQuantityMessage","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"adjustments","type":{"kind":"NON_NULL","ofType":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"Adjustment","ofType":null}}}},"args":[]},{"name":"bonusItemId","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"cancelledQuantity","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"channelSkuCode","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"customizationCost","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"customizationName","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"customizationNumber","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"estimatedDeliveryDate","type":{"kind":"OBJECT","name":"EstimatedDeliveryDate","ofType":null},"args":[]},{"name":"hasStock","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"inCartPrice","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"isBonus","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"personalizationImageURL","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"personalizationLargeImageURL","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"personalizationName","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"personalizationNumber","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"personalizationPrice","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"personalizationRecipeID","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"personalizationSurcharge","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"popularityCount","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"product","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"VariantProduct","ofType":null}},"args":[]},{"name":"productReturn","type":{"kind":"OBJECT","name":"ReturnedProduct","ofType":null},"args":[]},{"name":"purchasedPrice","type":{"kind":"OBJECT","name":"ProductPrice","ofType":null},"args":[]},{"name":"quantity","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"quantityInCart","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"restricted","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"status","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"stockMessage","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"stockMessageCode","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"taxRate","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"ProductColor","fields":[{"name":"image","type":{"kind":"OBJECT","name":"ProductImage","ofType":null},"args":[]},{"name":"name","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"orderable","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"value","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"ProductComparison","fields":[{"name":"_id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"comparisonFields","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"header","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"products","type":{"kind":"NON_NULL","ofType":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"ComparisonProduct","ofType":null}}}},"args":[]},{"name":"variant","type":{"kind":"OBJECT","name":"VariantProduct","ofType":null},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"ProductFeature","fields":[{"name":"_id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"copy","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"header","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"horizontalAlignment","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"image","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"SanityImage","ofType":null}},"args":[]},{"name":"video","type":{"kind":"OBJECT","name":"SanityVideo","ofType":null},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"ProductGroupFeatures","fields":[{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"productFeatures","type":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"ProductFeature","ofType":null}}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"ProductImage","fields":[{"name":"alt","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"coverImageHref","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"href","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"proportionalImageHref","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"title","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"verticalImageHref","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"ProductListingPage","fields":[{"name":"appContent","type":{"kind":"LIST","ofType":{"kind":"OBJECT","name":"AppComponentWithFilters","ofType":null}},"args":[{"name":"preview","type":{"kind":"SCALAR","name":"Any"}},{"name":"src","type":{"kind":"SCALAR","name":"Any"}}]},{"name":"bottomContent","type":{"kind":"LIST","ofType":{"kind":"OBJECT","name":"componentWithFilters","ofType":null}},"args":[{"name":"preview","type":{"kind":"SCALAR","name":"Any"}},{"name":"src","type":{"kind":"SCALAR","name":"Any"}}]},{"name":"bottomSeoContent","type":{"kind":"LIST","ofType":{"kind":"OBJECT","name":"PortableText","ofType":null}},"args":[]},{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"mobileAppContent","type":{"kind":"OBJECT","name":"mobileAppContent","ofType":null},"args":[{"name":"preview","type":{"kind":"SCALAR","name":"Any"}},{"name":"src","type":{"kind":"SCALAR","name":"Any"}}]},{"name":"recommenderEnabled","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"recommenderId","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"tiles","type":{"kind":"LIST","ofType":{"kind":"OBJECT","name":"PositionedTile","ofType":null}},"args":[]},{"name":"topContent","type":{"kind":"LIST","ofType":{"kind":"OBJECT","name":"componentWithFilters","ofType":null}},"args":[{"name":"preview","type":{"kind":"SCALAR","name":"Any"}},{"name":"src","type":{"kind":"SCALAR","name":"Any"}}]}],"interfaces":[]},{"kind":"OBJECT","name":"ProductMeasurements","fields":[{"name":"imperial","type":{"kind":"NON_NULL","ofType":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}}}},"args":[]},{"name":"metric","type":{"kind":"NON_NULL","ofType":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}}}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"ProductNameTranslations","fields":[{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"name","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"NameTranslations","ofType":null}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"ProductPrice","fields":[{"name":"bestPrice","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"isSalePriceElapsed","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"price","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"promotionPrice","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"salePrice","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"salePriceInitializeDate","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"tax","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"taxRate","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"validFrom","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"validTo","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"ProductPromotion","fields":[{"name":"calloutMessage","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"gwpTitle","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"name","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"ProductRecommender","fields":[{"name":"_id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"copy","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"cta","type":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"CTA","ofType":null}}},"args":[]},{"name":"header","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"identifier","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"showAsGrid","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"type","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"ProductRef","fields":[{"name":"color","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"header","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"masterId","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"productId","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"productName","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"subHeader","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"visible","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"ProductSearchHit","fields":[{"name":"color","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"masterId","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"masterProduct","type":{"kind":"OBJECT","name":"Product","ofType":null},"args":[]},{"name":"variantProduct","type":{"kind":"OBJECT","name":"Variant","ofType":null},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"ProductStory","fields":[{"name":"additionalContentSections","type":{"kind":"LIST","ofType":{"kind":"OBJECT","name":"componentWithFilters","ofType":null}},"args":[]},{"name":"careInstructions","type":{"kind":"LIST","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"longDescription","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"manufacturerInfo","type":{"kind":"OBJECT","name":"ManufacturerInfo","ofType":null},"args":[]},{"name":"materialComposition","type":{"kind":"LIST","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"productKeywords","type":{"kind":"LIST","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"ProductSuggestion","fields":[{"name":"coords","type":{"kind":"OBJECT","name":"Coordinates","ofType":null},"args":[]},{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"image","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"ProductImage","ofType":null}},"args":[]},{"name":"name","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"orderable","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"price","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"promotionPrice","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"replacements","type":{"kind":"NON_NULL","ofType":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"ProductSuggestion","ofType":null}}}},"args":[]},{"name":"salePrice","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"slug","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"styleId","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"ProductSummary","fields":[{"name":"badge","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"badges","type":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"ProductBadge","ofType":null}}},"args":[]},{"name":"brand","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"colorName","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"colorValue","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"displayOutOfStock","type":{"kind":"OBJECT","name":"DisplayOutOfStock","ofType":null},"args":[]},{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"images","type":{"kind":"NON_NULL","ofType":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"ProductImage","ofType":null}}}},"args":[]},{"name":"masterId","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"name","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"orderable","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"price","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"promotion","type":{"kind":"OBJECT","name":"ProductPromotion","ofType":null},"args":[]},{"name":"promotions","type":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"ProductPromotion","ofType":null}}},"args":[]},{"name":"salePrice","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"score","type":{"kind":"OBJECT","name":"Score","ofType":null},"args":[]},{"name":"variations","type":{"kind":"NON_NULL","ofType":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"ProductVariationSummary","ofType":null}}}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"ProductTile","fields":[{"name":"_id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"availableFrom","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"availableTo","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"product","type":{"kind":"OBJECT","name":"VariantProduct","ofType":null},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"ProductVariationSummary","fields":[{"name":"colorName","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"colorValue","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"images","type":{"kind":"NON_NULL","ofType":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"ProductImage","ofType":null}}}},"args":[]},{"name":"swatch","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"ProductImage","ofType":null}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"ProductWithExclusion","fields":[{"name":"excludedColors","type":{"kind":"NON_NULL","ofType":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}},"args":[]},{"name":"product","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"Product","ofType":null}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"ProfilingConsentResponse","fields":[{"name":"citizenId","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"externalRef","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"token","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"PromoTile","fields":[{"name":"_id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"backgroundColor","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"backgroundImage","type":{"kind":"OBJECT","name":"SanityImage","ofType":null},"args":[]},{"name":"contentBelow","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"copy","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"cta","type":{"kind":"OBJECT","name":"CTA","ofType":null},"args":[]},{"name":"header","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"mobileBackgroundImage","type":{"kind":"OBJECT","name":"SanityImage","ofType":null},"args":[]},{"name":"puid","type":{"kind":"OBJECT","name":"BannerIdentifier","ofType":null},"args":[]},{"name":"textColor","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"verticalAlignment","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"video","type":{"kind":"OBJECT","name":"SanityVideo","ofType":null},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"PumatracLink","fields":[{"name":"id","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"type","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"QRCode","fields":[{"name":"_id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"identifier","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"name","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"qrCodeContent","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"qrCodeImage","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"SanityImage","ofType":null}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"Query","fields":[{"name":"activeCart","type":{"kind":"OBJECT","name":"Cart","ofType":null},"args":[]},{"name":"activeCartV2","type":{"kind":"OBJECT","name":"Cart","ofType":null},"args":[]},{"name":"address","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"Address","ofType":null}},"args":[{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"afterPayConfig","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"AfterPayConfig","ofType":null}},"args":[]},{"name":"allCustomerGroups","type":{"kind":"NON_NULL","ofType":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}},"args":[]},{"name":"allProductRecommenders","type":{"kind":"NON_NULL","ofType":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"Recommender","ofType":null}}}},"args":[]},{"name":"allProducts","type":{"kind":"NON_NULL","ofType":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"ProductRef","ofType":null}}}},"args":[{"name":"locale","type":{"kind":"SCALAR","name":"Any"}},{"name":"query","type":{"kind":"SCALAR","name":"Any"}}]},{"name":"allTranslations","type":{"kind":"NON_NULL","ofType":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"ResourceKey","ofType":null}}}},"args":[]},{"name":"amazonPayPaymentDescriptor","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"AmazonPayPaymentDescriptorPayload","ofType":null}},"args":[{"name":"input","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"appStories","type":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"MobileAppStory","ofType":null}}},"args":[{"name":"params","type":{"kind":"SCALAR","name":"Any"}}]},{"name":"calendar","type":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"AppDropItem","ofType":null}}},"args":[]},{"name":"campaignVariations","type":{"kind":"SCALAR","name":"Any"},"args":[{"name":"input","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"cart","type":{"kind":"OBJECT","name":"Cart","ofType":null},"args":[{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"cartPage","type":{"kind":"OBJECT","name":"CartPage","ofType":null},"args":[{"name":"isDraft","type":{"kind":"SCALAR","name":"Any"}}]},{"name":"categories","type":{"kind":"NON_NULL","ofType":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"Category","ofType":null}}}},"args":[]},{"name":"category","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"Category","ofType":null}},"args":[{"name":"id","type":{"kind":"SCALAR","name":"Any"}},{"name":"url","type":{"kind":"SCALAR","name":"Any"}}]},{"name":"categoryById","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"Category","ofType":null}},"args":[{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"categoryByUrl","type":{"kind":"OBJECT","name":"Category","ofType":null},"args":[{"name":"preview","type":{"kind":"SCALAR","name":"Any"}},{"name":"url","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"checkAmbassadorBalance","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[{"name":"cardNumber","type":{"kind":"SCALAR","name":"Any"}},{"name":"paymentInstrumentId","type":{"kind":"SCALAR","name":"Any"}},{"name":"pin","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"checkGiftCardBalance","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[{"name":"cardNumber","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}},{"name":"countryCode","type":{"kind":"SCALAR","name":"Any"}},{"name":"pin","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}},{"name":"rateLimit","type":{"kind":"SCALAR","name":"Any"}}]},{"name":"content","type":{"kind":"SCALAR","name":"Any"},"args":[{"name":"input","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"dropCalendarPage","type":{"kind":"OBJECT","name":"DropCalendarPage","ofType":null},"args":[]},{"name":"error404","type":{"kind":"OBJECT","name":"Error404","ofType":null},"args":[]},{"name":"frontendConfiguration","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"FrontendConfiguration","ofType":null}},"args":[]},{"name":"getAmazonPayAddress","type":{"kind":"OBJECT","name":"AmazonPayAddress","ofType":null},"args":[{"name":"addressConsentToken","type":{"kind":"SCALAR","name":"Any"}},{"name":"orderReferenceId","type":{"kind":"SCALAR","name":"Any"}}]},{"name":"getAmazonPayCustomerInfo","type":{"kind":"OBJECT","name":"AmazonPayCustomerInfoPayload","ofType":null},"args":[{"name":"amazonPayToken","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"getPayPayContent","type":{"kind":"OBJECT","name":"PayPayContent","ofType":null},"args":[{"name":"assetId","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"giftCard","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"GiftCardProduct","ofType":null}},"args":[]},{"name":"globalPromoBanner","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"GlobalPromoBanner","ofType":null}},"args":[{"name":"isDraft","type":{"kind":"SCALAR","name":"Any"}},{"name":"preview","type":{"kind":"SCALAR","name":"Any"}},{"name":"src","type":{"kind":"SCALAR","name":"Any"}}]},{"name":"glossaryPage","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"GlossaryPage","ofType":null}},"args":[{"name":"isDraft","type":{"kind":"SCALAR","name":"Any"}},{"name":"slug","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"highlights","type":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"Interest","ofType":null}}},"args":[{"name":"slugs","type":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}}]},{"name":"interests","type":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"Interest","ofType":null}}},"args":[]},{"name":"inventory","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"Inventory","ofType":null}},"args":[{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"look","type":{"kind":"OBJECT","name":"StyliticsLook","ofType":null},"args":[{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"mainFooter","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"MainFooter","ofType":null}},"args":[{"name":"isDraft","type":{"kind":"SCALAR","name":"Any"}}]},{"name":"mainNav","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"MainNav","ofType":null}},"args":[{"name":"isDraft","type":{"kind":"SCALAR","name":"Any"}},{"name":"preview","type":{"kind":"SCALAR","name":"Any"}}]},{"name":"me","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"User","ofType":null}},"args":[]},{"name":"mobileAppCartNotices","type":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"MobileAppCartNotice","ofType":null}}},"args":[]},{"name":"mobileAppHomePage","type":{"kind":"OBJECT","name":"AppContent","ofType":null},"args":[{"name":"preview","type":{"kind":"SCALAR","name":"Any"}}]},{"name":"mobileAppInbox","type":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"MobileAppInboxItem","ofType":null}}},"args":[{"name":"dateTime","type":{"kind":"SCALAR","name":"Any"}}]},{"name":"mobileAppNotificationBanners","type":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"MobileAppNotificationBanner","ofType":null}}},"args":[{"name":"dateTime","type":{"kind":"SCALAR","name":"Any"}}]},{"name":"mobileAppVersion","type":{"kind":"OBJECT","name":"AppVersion","ofType":null},"args":[]},{"name":"notFound","type":{"kind":"OBJECT","name":"NotFound","ofType":null},"args":[]},{"name":"notificationsPreferences","type":{"kind":"OBJECT","name":"NotificationsPayload","ofType":null},"args":[]},{"name":"order","type":{"kind":"UNION","name":"Order","ofType":null},"args":[{"name":"orderNo","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"orderSearch","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"StandardOrder","ofType":null}},"args":[{"name":"billingPostalCode","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}},{"name":"orderEmail","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}},{"name":"orderNo","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"outfits","type":{"kind":"NON_NULL","ofType":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"StyliticsLook","ofType":null}}}},"args":[{"name":"tags","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"page","type":{"kind":"INTERFACE","name":"Page","ofType":null},"args":[{"name":"isDraft","type":{"kind":"SCALAR","name":"Any"}},{"name":"preview","type":{"kind":"SCALAR","name":"Any"}},{"name":"slug","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"pdp","type":{"kind":"OBJECT","name":"Pdp","ofType":null},"args":[{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"pincode","type":{"kind":"OBJECT","name":"PincodeServiceability","ofType":null},"args":[{"name":"pincode","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"ping","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"pixleeConfig","type":{"kind":"OBJECT","name":"PixleeConfig","ofType":null},"args":[]},{"name":"product","type":{"kind":"OBJECT","name":"Product","ofType":null},"args":[{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}},{"name":"viewAt","type":{"kind":"SCALAR","name":"Any"}}]},{"name":"productScore","type":{"kind":"OBJECT","name":"Score","ofType":null},"args":[{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"recommendations","type":{"kind":"NON_NULL","ofType":{"kind":"LIST","ofType":{"kind":"OBJECT","name":"ProductSearchHit","ofType":null}}},"args":[{"name":"ids","type":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}},{"name":"pageType","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"recommendationsWithDetails","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"RecommendationsOutput","ofType":null}},"args":[{"name":"ids","type":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}},{"name":"pageType","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"search","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"PaginatedOutput","ofType":null}},"args":[{"name":"input","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"searchEmptyState","type":{"kind":"OBJECT","name":"SearchEmptyState","ofType":null},"args":[]},{"name":"searchFlyoutRecommendedProducts","type":{"kind":"NON_NULL","ofType":{"kind":"LIST","ofType":{"kind":"OBJECT","name":"ProductSearchHit","ofType":null}}},"args":[{"name":"input","type":{"kind":"SCALAR","name":"Any"}}]},{"name":"searchOrderByEmail","type":{"kind":"UNION","name":"Order","ofType":null},"args":[{"name":"email","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}},{"name":"orderNo","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"searchOrderByEmailPhone","type":{"kind":"UNION","name":"Order","ofType":null},"args":[{"name":"email","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}},{"name":"orderNo","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}},{"name":"phone","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"searchOrderByEmailPostcode","type":{"kind":"UNION","name":"Order","ofType":null},"args":[{"name":"email","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}},{"name":"orderNo","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}},{"name":"postcode","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"searchOrderByPhone","type":{"kind":"UNION","name":"Order","ofType":null},"args":[{"name":"orderNo","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}},{"name":"phone","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"secondGlobalBanner","type":{"kind":"OBJECT","name":"SecondGlobalBanner","ofType":null},"args":[{"name":"isDraft","type":{"kind":"SCALAR","name":"Any"}},{"name":"preview","type":{"kind":"SCALAR","name":"Any"}},{"name":"src","type":{"kind":"SCALAR","name":"Any"}}]},{"name":"siblingVariants","type":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"Variant","ofType":null}}},"args":[{"name":"input","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"signUpForm","type":{"kind":"OBJECT","name":"SignUpForm","ofType":null},"args":[]},{"name":"signUpFormById","type":{"kind":"OBJECT","name":"SignUpForm","ofType":null},"args":[{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"signUpForms","type":{"kind":"LIST","ofType":{"kind":"OBJECT","name":"SignUpForm","ofType":null}},"args":[]},{"name":"sizeCharts","type":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"SizeChart","ofType":null}}},"args":[{"name":"ids","type":{"kind":"NON_NULL","ofType":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}}}]},{"name":"spinTheWheelById","type":{"kind":"OBJECT","name":"SpinTheWheel","ofType":null},"args":[{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"spinTheWheelByIds","type":{"kind":"LIST","ofType":{"kind":"OBJECT","name":"SpinTheWheel","ofType":null}},"args":[{"name":"ids","type":{"kind":"NON_NULL","ofType":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}}}]},{"name":"stories","type":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"MobileAppStory","ofType":null}}},"args":[{"name":"params","type":{"kind":"SCALAR","name":"Any"}}]},{"name":"suggestions","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"SearchSuggestions","ofType":null}},"args":[{"name":"preview","type":{"kind":"SCALAR","name":"Any"}},{"name":"searchTerm","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"supportPage","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"SupportPage","ofType":null}},"args":[{"name":"isDraft","type":{"kind":"SCALAR","name":"Any"}},{"name":"preview","type":{"kind":"SCALAR","name":"Any"}},{"name":"slug","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"supportPages","type":{"kind":"NON_NULL","ofType":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"SupportPage","ofType":null}}}},"args":[{"name":"availableOn","type":{"kind":"SCALAR","name":"Any"}},{"name":"tags","type":{"kind":"NON_NULL","ofType":{"kind":"LIST","ofType":{"kind":"SCALAR","name":"Any"}}}}]},{"name":"termsAndConditionsConfigs","type":{"kind":"OBJECT","name":"TermsAndConditionsConfigs","ofType":null},"args":[{"name":"isDraft","type":{"kind":"SCALAR","name":"Any"}}]},{"name":"translate","type":{"kind":"NON_NULL","ofType":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"ResourceKey","ofType":null}}}},"args":[{"name":"keys","type":{"kind":"NON_NULL","ofType":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}}}]},{"name":"translationsByIds","type":{"kind":"NON_NULL","ofType":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"ProductNameTranslations","ofType":null}}}},"args":[{"name":"ids","type":{"kind":"NON_NULL","ofType":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}}}]},{"name":"trendingSearchTerms","type":{"kind":"NON_NULL","ofType":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"TrendingSearchTerm","ofType":null}}}},"args":[]},{"name":"urlRedirect","type":{"kind":"SCALAR","name":"Any"},"args":[{"name":"isDraft","type":{"kind":"SCALAR","name":"Any"}},{"name":"path","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"urlRedirectV2","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"UrlRedirect","ofType":null}},"args":[{"name":"path","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"userGeneratedContent","type":{"kind":"LIST","ofType":{"kind":"OBJECT","name":"UserGeneratedContent","ofType":null}},"args":[{"name":"productId","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"userGeneratedContentForWeb","type":{"kind":"LIST","ofType":{"kind":"OBJECT","name":"UserGeneratedContent","ofType":null}},"args":[{"name":"productId","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"variant","type":{"kind":"OBJECT","name":"VariantProduct","ofType":null},"args":[{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"variantInventory","type":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"Inventory","ofType":null}}},"args":[{"name":"styleNumber","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"variants","type":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"Variant","ofType":null}}},"args":[{"name":"input","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}]},{"name":"wishList","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"WishList","ofType":null}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"QuoteCallout","fields":[{"name":"_id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"copy","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"copyColor","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"ctas","type":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"CTA","ofType":null}}},"args":[]},{"name":"header","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"headerColor","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"quote","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"Razorpay","fields":[{"name":"amount","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"type","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"Recommendation","fields":[{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"image_url","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"product_name","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"product_url","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"RecommendationsOutput","fields":[{"name":"recommendations","type":{"kind":"NON_NULL","ofType":{"kind":"LIST","ofType":{"kind":"OBJECT","name":"ProductSearchHit","ofType":null}}},"args":[]},{"name":"recommenderId","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"recommenderName","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"Recommender","fields":[{"name":"description","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"name","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"recommenderType","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"RegisterAmazonPaymentPayload","fields":[{"name":"cart","type":{"kind":"OBJECT","name":"Cart","ofType":null},"args":[]},{"name":"shouldPromptForLogin","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"RemoveStoreCreditsPayload","fields":[{"name":"cart","type":{"kind":"OBJECT","name":"Cart","ofType":null},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"ResourceKey","fields":[{"name":"key","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"value","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"ReturnedProduct","fields":[{"name":"channelReturnOrderTime","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"forwardAwb","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"price","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"quantity","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"returnAwb","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"returnOrderCode","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"status","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"statuses","type":{"kind":"LIST","ofType":{"kind":"OBJECT","name":"TimelineStatus","ofType":null}},"args":[]},{"name":"transporter","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"type","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"Review","fields":[{"name":"aspects","type":{"kind":"OBJECT","name":"ReviewAspects","ofType":null},"args":[]},{"name":"cons","type":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}},"args":[]},{"name":"consInputted","type":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}},"args":[]},{"name":"date","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"email","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"helpfulVotes","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"isRecommended","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"location","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"nickname","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"notification","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"preview","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"pros","type":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}},"args":[]},{"name":"prosInputted","type":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}},"args":[]},{"name":"rating","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"secondaryRatings","type":{"kind":"LIST","ofType":{"kind":"OBJECT","name":"ReviewRating","ofType":null}},"args":[]},{"name":"terms","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"text","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"title","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"ReviewAspects","fields":[{"name":"comfort","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"size","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"width","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"ReviewEdge","fields":[{"name":"nodes","type":{"kind":"NON_NULL","ofType":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"Review","ofType":null}}}},"args":[]},{"name":"pageInfo","type":{"kind":"OBJECT","name":"PageInfo","ofType":null},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"ReviewRating","fields":[{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"label","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"rating","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"ReviewSummary","fields":[{"name":"aspects","type":{"kind":"OBJECT","name":"ReviewAspects","ofType":null},"args":[]},{"name":"recommendedCount","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"recommendedPercentage","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"totalCount","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"Rgba","fields":[{"name":"a","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"b","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"g","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"r","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"SDKData","fields":[{"name":"token","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"SEO","fields":[{"name":"pageDescription","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"pageTitle","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"SanityImage","fields":[{"name":"_key","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"alt","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"asset","type":{"kind":"OBJECT","name":"SanityImageAsset","ofType":null},"args":[]},{"name":"crop","type":{"kind":"OBJECT","name":"SanityImageCrop","ofType":null},"args":[]},{"name":"hotspot","type":{"kind":"OBJECT","name":"SanityImageHotspot","ofType":null},"args":[]},{"name":"overlay","type":{"kind":"OBJECT","name":"BackgroundOverlay","ofType":null},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"SanityImageAsset","fields":[{"name":"_id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"assetId","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"cloudinary","type":{"kind":"OBJECT","name":"CloudinaryConfig","ofType":null},"args":[]},{"name":"extension","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"label","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"metadata","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"SanityImageMetaData","ofType":null}},"args":[]},{"name":"path","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"url","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"SanityImageCrop","fields":[{"name":"_key","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"bottom","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"left","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"right","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"top","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"SanityImageHotspot","fields":[{"name":"_key","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"height","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"width","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"x","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"y","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"SanityImageMetaData","fields":[{"name":"_key","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"dimensions","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"SanityImageMetaDataDimensions","ofType":null}},"args":[]},{"name":"lqip","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"SanityImageMetaDataDimensions","fields":[{"name":"height","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"width","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"SanityPrize","fields":[{"name":"_id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"addToInbox","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"androidWallet","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"appContent","type":{"kind":"LIST","ofType":{"kind":"OBJECT","name":"AppComponentWithFilters","ofType":null}},"args":[{"name":"preview","type":{"kind":"SCALAR","name":"Any"}},{"name":"src","type":{"kind":"SCALAR","name":"Any"}}]},{"name":"appleWallet","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"backgroundImage","type":{"kind":"OBJECT","name":"SanityImage","ofType":null},"args":[]},{"name":"encodedPass","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"googleMapsUrl","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"identifier","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"latitude","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"longitude","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"maps","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"name","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"prizeHeader","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"prizeLogo","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"SanityImage","ofType":null}},"args":[]},{"name":"prizeSubHeader","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"prizeType","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"qrCode","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"QRCode","ofType":null}},"args":[]},{"name":"qrCodeContent","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"SanityProduct","fields":[{"name":"color","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"comparisonFields","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"masterId","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"productId","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"productName","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"SanityVideo","fields":[{"name":"autoplay","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"cloudinary","type":{"kind":"OBJECT","name":"CloudinaryConfig","ofType":null},"args":[]},{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"loop","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"mute","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"source","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"SavedAmbassadorCard","fields":[{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"maskedNumber","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"name","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"preferred","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"SavedCreditCard","fields":[{"name":"UUID","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"creditCardExpirationMonth","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"creditCardExpirationYear","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"creditCardNumber","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"creditCardSeq","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"creditCardType","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"creditHolderName","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"defaultFlag","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"maskedCreditCardNumber","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"ScheduledFreeShippingThreshold","fields":[{"name":"availableFrom","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"availableTo","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"threshold","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"Scheme","fields":[{"name":"amount","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"authorizationStatus","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"type","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"Score","fields":[{"name":"amount","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"rating","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"reviews","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"ReviewEdge","ofType":null}},"args":[{"name":"limit","type":{"kind":"SCALAR","name":"Any"}},{"name":"offset","type":{"kind":"SCALAR","name":"Any"}},{"name":"search","type":{"kind":"SCALAR","name":"Any"}},{"name":"sort","type":{"kind":"SCALAR","name":"Any"}}]},{"name":"summary","type":{"kind":"OBJECT","name":"ReviewSummary","ofType":null},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"SearchCategory","fields":[{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"name","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"url","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"SearchEmptyState","fields":[{"name":"productRecommender","type":{"kind":"OBJECT","name":"ProductRecommender","ofType":null},"args":[]},{"name":"seo","type":{"kind":"OBJECT","name":"SEO","ofType":null},"args":[]},{"name":"textSection","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"TextSection","ofType":null}},"args":[]},{"name":"withLiveChat","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"SearchHitMeta","fields":[{"name":"color","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"masterId","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"variantId","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"SearchSuggestions","fields":[{"name":"suggestedCategories","type":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"SearchCategory","ofType":null}}},"args":[]},{"name":"suggestedPhrases","type":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"SuggestedPhrase","ofType":null}}},"args":[]},{"name":"suggestedProducts","type":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"Variant","ofType":null}}},"args":[]},{"name":"suggestedProductsSummaries","type":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"SuggestedProduct","ofType":null}}},"args":[]},{"name":"suggestedRedirect","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"suggestedRedirectLink","type":{"kind":"OBJECT","name":"MobileAppLink","ofType":null},"args":[]},{"name":"suggestedTerms","type":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"SuggestedTerm","ofType":null}}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"SecondGlobalBanner","fields":[{"name":"banners","type":{"kind":"NON_NULL","ofType":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"infoBannerWithCategoryExclusion","ofType":null}}}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"SendEmailOtpResult","fields":[{"name":"otpExpiration","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"showResendButtonAfter","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"Shipment","fields":[{"name":"address","type":{"kind":"OBJECT","name":"OrderAddress","ofType":null},"args":[]},{"name":"authorityToLeave","type":{"kind":"OBJECT","name":"AuthorityToLeave","ofType":null},"args":[]},{"name":"deliveryDate","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"deliveryTimeCode","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"deliveryTimeDisplayText","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"shipmentMethod","type":{"kind":"OBJECT","name":"ShipmentMethod","ofType":null},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"ShipmentMethod","fields":[{"name":"address","type":{"kind":"OBJECT","name":"OrderAddress","ofType":null},"args":[]},{"name":"estimatedShippingDate","type":{"kind":"OBJECT","name":"EstimatedShippingDate","ofType":null},"args":[]},{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"name","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"price","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"ShipmentMethodInfo","fields":[{"name":"availableShipmentMethods","type":{"kind":"NON_NULL","ofType":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"ShipmentMethod","ofType":null}}}},"args":[]},{"name":"defaultShipmentMethodId","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"ShippingSurcharge","fields":[{"name":"amount","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"label","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"tooltip","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"ShopCollection","fields":[{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"ShopperContextPayload","fields":[{"name":"effectiveDateTime","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"sourceCode","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"SideBySide","fields":[{"name":"_id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"componentTiles","type":{"kind":"NON_NULL","ofType":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"UNION","name":"Tiles","ofType":null}}}},"args":[]},{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"tiles","type":{"kind":"NON_NULL","ofType":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"TrendingTile","ofType":null}}}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"SignAmazonPayloadResponse","fields":[{"name":"signedPayload","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"SignUpForm","fields":[{"name":"analyticsIdentifier","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"backgroundColor","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"backgroundImage","type":{"kind":"OBJECT","name":"SanityImage","ofType":null},"args":[]},{"name":"cartPageLaunchButtonLabel","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"contactSource","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"copy","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"ctas","type":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"CTA","ofType":null}}},"args":[]},{"name":"customText","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"disclaimer","type":{"kind":"LIST","ofType":{"kind":"OBJECT","name":"PortableText","ofType":null}},"args":[]},{"name":"disclaimerText","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"fields","type":{"kind":"NON_NULL","ofType":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}},"args":[]},{"name":"footnote","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"header","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"inverted","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"launchButtonLabel","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"launchLinkText","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"mobileBackgroundImage","type":{"kind":"OBJECT","name":"SanityImage","ofType":null},"args":[]},{"name":"optionalFields","type":{"kind":"LIST","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"portableDisclaimerText","type":{"kind":"LIST","ofType":{"kind":"OBJECT","name":"PortableText","ofType":null}},"args":[]},{"name":"sourceId","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"submitButtonColor","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"submitButtonText","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"submitButtonTextColor","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"successCopy","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"successCopyTextColor","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"successFootnote","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"successFootnoteTextColor","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"successHeader","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"successHeaderTextColor","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"successImage","type":{"kind":"OBJECT","name":"SanityImage","ofType":null},"args":[]},{"name":"textColor","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"SiteConfig","fields":[{"name":"currency","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"Currency","ofType":null}},"args":[]},{"name":"deliveryDateDays","type":{"kind":"OBJECT","name":"DeliveryDateDays","ofType":null},"args":[]},{"name":"enableEstimatedDeliverDatesByItem","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"freeShippingThreshold","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"maxDaysForReturn","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"scheduledFreeShippingThresholds","type":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"ScheduledFreeShippingThreshold","ofType":null}}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"Size","fields":[{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"label","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"maxOrderableQuantity","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"orderable","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"productId","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"value","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"SizeChart","fields":[{"name":"body","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"name","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"SizeGroup","fields":[{"name":"description","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"label","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"sizes","type":{"kind":"NON_NULL","ofType":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"Size","ofType":null}}}},"args":[]}],"interfaces":[]},{"kind":"UNION","name":"Slot","possibleTypes":[{"kind":"OBJECT","name":"AdditionalContentSection"},{"kind":"OBJECT","name":"BodyContent"},{"kind":"OBJECT","name":"BodyHeader"},{"kind":"OBJECT","name":"CountdownClock"},{"kind":"OBJECT","name":"FaqModule"},{"kind":"OBJECT","name":"FeatureHero"},{"kind":"OBJECT","name":"FeaturesGrid"},{"kind":"OBJECT","name":"FullBleedHero"},{"kind":"OBJECT","name":"HotspotHero"},{"kind":"OBJECT","name":"HowToWearIt"},{"kind":"OBJECT","name":"Iframe"},{"kind":"OBJECT","name":"InfoBanner"},{"kind":"OBJECT","name":"LaunchCalendar"},{"kind":"OBJECT","name":"LinkListing"},{"kind":"OBJECT","name":"NotImplemented"},{"kind":"OBJECT","name":"PixleeSimpleWidget"},{"kind":"OBJECT","name":"ProductCarousel"},{"kind":"OBJECT","name":"ProductComparison"},{"kind":"OBJECT","name":"ProductGroupFeatures"},{"kind":"OBJECT","name":"ProductRecommender"},{"kind":"OBJECT","name":"QuoteCallout"},{"kind":"OBJECT","name":"ShopCollection"},{"kind":"OBJECT","name":"SideBySide"},{"kind":"OBJECT","name":"SignUpForm"},{"kind":"OBJECT","name":"SpinTheWheel"},{"kind":"OBJECT","name":"SplitHero"},{"kind":"OBJECT","name":"StyliticsCarousel"},{"kind":"OBJECT","name":"TrendingInline"},{"kind":"OBJECT","name":"VideoHero"},{"kind":"OBJECT","name":"YouTubeVideoCarousel"}]},{"kind":"UNION","name":"SoldOutRecommender","possibleTypes":[{"kind":"OBJECT","name":"ProductCarousel"},{"kind":"OBJECT","name":"ProductRecommender"}]},{"kind":"OBJECT","name":"SortOption","fields":[{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"label","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"SpinTheWheel","fields":[{"name":"SpinTheWheelBackgroundImage","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"SanityImage","ofType":null}},"args":[]},{"name":"_id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"backgroundColor","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"backgroundImage","type":{"kind":"OBJECT","name":"SanityImage","ofType":null},"args":[]},{"name":"buttonText","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"identifier","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"logo","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"SanityImage","ofType":null}},"args":[]},{"name":"name","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"prizes","type":{"kind":"NON_NULL","ofType":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"PrizeSlot","ofType":null}}}},"args":[]},{"name":"subtitle","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"textColor","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"title","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"SplitHero","fields":[{"name":"availableFrom","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"availableTo","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"backgroundColor","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"backgroundImage","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"SanityImage","ofType":null}},"args":[]},{"name":"copy","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"countdownClock","type":{"kind":"OBJECT","name":"CountdownClock","ofType":null},"args":[]},{"name":"ctas","type":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"CTA","ofType":null}}},"args":[]},{"name":"footnote","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"header","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"horizontalAlignment","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"layout","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"logo","type":{"kind":"OBJECT","name":"SanityImage","ofType":null},"args":[]},{"name":"mobileBackgroundImage","type":{"kind":"OBJECT","name":"SanityImage","ofType":null},"args":[]},{"name":"puid","type":{"kind":"OBJECT","name":"BannerIdentifier","ofType":null},"args":[]},{"name":"showDayFieldInCountdownClock","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"textColor","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"StandardOrder","fields":[{"name":"billingAddress","type":{"kind":"OBJECT","name":"OrderAddress","ofType":null},"args":[]},{"name":"couponItems","type":{"kind":"LIST","ofType":{"kind":"OBJECT","name":"CouponItem","ofType":null}},"args":[]},{"name":"createdAt","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"currency","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"customer","type":{"kind":"OBJECT","name":"CustomerInfo","ofType":null},"args":[]},{"name":"customizationAdjustment","type":{"kind":"OBJECT","name":"Adjustment","ofType":null},"args":[]},{"name":"estimatedShippingCosts","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"estimatedTotal","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"exportStatus","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"gmoAccessID","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"gmoAccessPass","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"gmoChallengeUrl","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"gmoFlow","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"gmoRedirectUrl","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"hasFreeShipping","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"isMixedCartAllowed","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"isReturnable","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"netProratedDiscount","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"oms","type":{"kind":"OBJECT","name":"OmsEntry","ofType":null},"args":[]},{"name":"orderAdjustments","type":{"kind":"NON_NULL","ofType":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"Adjustment","ofType":null}}}},"args":[]},{"name":"orderNo","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"orderStatus","type":{"kind":"OBJECT","name":"OrderStatus","ofType":null},"args":[]},{"name":"orderToken","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"payPayAsyncResultNoticed","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"paymentInstruments","type":{"kind":"NON_NULL","ofType":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"UNION","name":"PaymentInstrument","ofType":null}}}},"args":[]},{"name":"pin","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"pinId","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"products","type":{"kind":"NON_NULL","ofType":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"UNION","name":"CartItem","ofType":null}}}},"args":[]},{"name":"promoDiscountValue","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"refundInformation","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"revenue","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"shipment","type":{"kind":"OBJECT","name":"Shipment","ofType":null},"args":[]},{"name":"shippingAdjustments","type":{"kind":"NON_NULL","ofType":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"Adjustment","ofType":null}}}},"args":[]},{"name":"shippingCosts","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"shippingStatus","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"shippingSurcharge","type":{"kind":"OBJECT","name":"ShippingSurcharge","ofType":null},"args":[]},{"name":"status","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"statuses","type":{"kind":"LIST","ofType":{"kind":"OBJECT","name":"TimelineStatus","ofType":null}},"args":[]},{"name":"subTotal","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"taxTotal","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"taxation","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"trackingNumber","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[{"kind":"INTERFACE","name":"BaseOrder"}]},{"kind":"OBJECT","name":"StartAmazonPaymentPayload","fields":[{"name":"order","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"StandardOrder","ofType":null}},"args":[]},{"name":"url","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"StartAmazonProcessOrderPaymentPayload","fields":[{"name":"order","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"StandardOrder","ofType":null}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"StartKlarnaPaymentPayload","fields":[{"name":"clientToken","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"orderNo","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"paymentMethodCategories","type":{"kind":"LIST","ofType":{"kind":"OBJECT","name":"KlarnaPaymentMethodCategories","ofType":null}},"args":[]},{"name":"sessionId","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"StartPaymentPayload","fields":[{"name":"action","type":{"kind":"UNION","name":"AdyenAction","ofType":null},"args":[]},{"name":"analytics","type":{"kind":"OBJECT","name":"OrderAnalytics","ofType":null},"args":[]},{"name":"orderNo","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"resultCode","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"simulatorUrl","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"StartRazorPayPayload","fields":[{"name":"order","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"StandardOrder","ofType":null}},"args":[]},{"name":"razorPayOrderId","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"StatelessSubmissionResponse","fields":[{"name":"externalRef","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"StoreCredit","fields":[{"name":"amount","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"currency","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"StoreCreditInstrument","fields":[{"name":"amount","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"type","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"Style","fields":[{"name":"background","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"border","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"rounded","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"shadow","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"StyliticsCarousel","fields":[{"name":"header","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"numberOfTiles","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"outfits","type":{"kind":"NON_NULL","ofType":{"kind":"LIST","ofType":{"kind":"OBJECT","name":"StyliticsLook","ofType":null}}},"args":[]},{"name":"tags","type":{"kind":"LIST","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"tileLayout","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"tiles","type":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"PositionedTile","ofType":null}}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"StyliticsLook","fields":[{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"image","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"ProductImage","ofType":null}},"args":[]},{"name":"products","type":{"kind":"NON_NULL","ofType":{"kind":"LIST","ofType":{"kind":"OBJECT","name":"ProductSuggestion","ofType":null}}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"Suborder","fields":[{"name":"awbNo","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"courierPartner","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"isReturnable","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"orderNo","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"products","type":{"kind":"NON_NULL","ofType":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"UNION","name":"CartItem","ofType":null}}}},"args":[]},{"name":"returnBy","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"returnUrl","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"status","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"statuses","type":{"kind":"LIST","ofType":{"kind":"OBJECT","name":"TimelineStatus","ofType":null}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"SuggestedPhrase","fields":[{"name":"suggestion","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"SuggestedProduct","fields":[{"name":"color","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"colorName","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"colorValue","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"header","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"images","type":{"kind":"NON_NULL","ofType":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"ProductImage","ofType":null}}}},"args":[]},{"name":"isSalePriceElapsed","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"masterId","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"name","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"preview","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"price","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"salePrice","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"slug","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"subHeader","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"SuggestedTerm","fields":[{"name":"original","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"suggestion","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"SupportPage","fields":[{"name":"content","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"integration","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"localeContent","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"localeTitle","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"title","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"url","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]}],"interfaces":[{"kind":"INTERFACE","name":"Page"}]},{"kind":"OBJECT","name":"TermsAndConditions","fields":[{"name":"_id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"content","type":{"kind":"LIST","ofType":{"kind":"OBJECT","name":"PortableText","ofType":null}},"args":[]},{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"TermsAndConditionsConfigs","fields":[{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"showAbove","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"tacOnCartPage","type":{"kind":"OBJECT","name":"TermsAndConditions","ofType":null},"args":[]},{"name":"tacOnCheckoutAddress","type":{"kind":"OBJECT","name":"TermsAndConditions","ofType":null},"args":[]},{"name":"tacOnCheckoutConfirmation","type":{"kind":"OBJECT","name":"TermsAndConditions","ofType":null},"args":[]},{"name":"tacOnCheckoutPayment","type":{"kind":"OBJECT","name":"TermsAndConditions","ofType":null},"args":[]},{"name":"tacOnCheckoutSignInArea","type":{"kind":"OBJECT","name":"TermsAndConditions","ofType":null},"args":[]},{"name":"tacOnCreateAccount","type":{"kind":"OBJECT","name":"TermsAndConditions","ofType":null},"args":[]},{"name":"tacOnItemAddedPopup","type":{"kind":"OBJECT","name":"TermsAndConditions","ofType":null},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"Text","fields":[{"name":"align","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"color","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"copy","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"footnote","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"header","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"TextChildren","fields":[{"name":"_type","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"marks","type":{"kind":"LIST","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"text","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"TextSection","fields":[{"name":"heading","type":{"kind":"LIST","ofType":{"kind":"OBJECT","name":"PortableText","ofType":null}},"args":[]},{"name":"label","type":{"kind":"LIST","ofType":{"kind":"OBJECT","name":"PortableText","ofType":null}},"args":[]},{"name":"text","type":{"kind":"LIST","ofType":{"kind":"UNION","name":"PortableTextContent","ofType":null}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"ThreeDSResponse","fields":[{"name":"data","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"method","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"orderNo","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"url","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"Tile","fields":[{"name":"alignment","type":{"kind":"OBJECT","name":"Alignment","ofType":null},"args":[]},{"name":"aspectRatio","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"ctas","type":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"CallToAction","ofType":null}}},"args":[]},{"name":"ctas2","type":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"CTA","ofType":null}}},"args":[]},{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"image","type":{"kind":"OBJECT","name":"Image","ofType":null},"args":[]},{"name":"link","type":{"kind":"OBJECT","name":"Link","ofType":null},"args":[]},{"name":"style","type":{"kind":"OBJECT","name":"Style","ofType":null},"args":[]},{"name":"text","type":{"kind":"OBJECT","name":"Text","ofType":null},"args":[]}],"interfaces":[]},{"kind":"UNION","name":"Tiles","possibleTypes":[{"kind":"OBJECT","name":"ProductRecommender"},{"kind":"OBJECT","name":"TrendingTile"}]},{"kind":"OBJECT","name":"TimelineStatus","fields":[{"name":"label","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"order","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"status","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"TokenPayload","fields":[{"name":"accessToken","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"customerContext","type":{"kind":"OBJECT","name":"CustomerContext","ofType":null},"args":[]},{"name":"customerEmail","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"customerGroup","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"customerId","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"refreshToken","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"uniqueShopperId","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"user","type":{"kind":"OBJECT","name":"User","ofType":null},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"TrendingInline","fields":[{"name":"availableFrom","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"availableTo","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"tiles","type":{"kind":"NON_NULL","ofType":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"TrendingTile","ofType":null}}}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"TrendingSearchTerm","fields":[{"name":"rank","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"searchTerm","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"TrendingTile","fields":[{"name":"_id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"availableFrom","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"availableTo","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"backgroundImage","type":{"kind":"OBJECT","name":"SanityImage","ofType":null},"args":[]},{"name":"backgroundOverlay","type":{"kind":"OBJECT","name":"BackgroundOverlay","ofType":null},"args":[]},{"name":"backgroundType","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"contentBelow","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"copy","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"countdownClock","type":{"kind":"OBJECT","name":"CountdownClock","ofType":null},"args":[]},{"name":"ctas","type":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"CTA","ofType":null}}},"args":[]},{"name":"einsteinRecommender","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"einsteinRecommenderAltText","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"header","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"overlay","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"puid","type":{"kind":"OBJECT","name":"BannerIdentifier","ofType":null},"args":[]},{"name":"textColor","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"UGCProduct","fields":[{"name":"id","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"imageThumb","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"sku","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"title","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"UPI","fields":[{"name":"amount","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"authorizationStatus","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"type","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"UPIResult","fields":[{"name":"orderNo","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"url","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"UpdatePhonePayload","fields":[{"name":"code","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"message","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"pinId","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"user","type":{"kind":"OBJECT","name":"User","ofType":null},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"UpdateProfilingConsentInput","fields":[{"name":"expiryDate","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"externalRef","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"token","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"UrlRedirect","fields":[{"name":"availableFrom","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"availableTo","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"redirectType","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"url","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"User","fields":[{"name":"addresses","type":{"kind":"NON_NULL","ofType":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"Address","ofType":null}}}},"args":[]},{"name":"ambassadorCards","type":{"kind":"NON_NULL","ofType":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"SavedAmbassadorCard","ofType":null}}}},"args":[]},{"name":"birthday","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"creationDate","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"customerNo","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"email","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"firstName","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"firstNamePronunciation","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"gender","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"groups","type":{"kind":"NON_NULL","ofType":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}}},"args":[]},{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"lastName","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"lastNamePronunciation","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"newsletterSubscription","type":{"kind":"OBJECT","name":"NewsletterSubscription","ofType":null},"args":[]},{"name":"orders","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"OrderEdge","ofType":null}},"args":[{"name":"from","type":{"kind":"SCALAR","name":"Any"}},{"name":"limit","type":{"kind":"SCALAR","name":"Any"}},{"name":"offset","type":{"kind":"SCALAR","name":"Any"}},{"name":"until","type":{"kind":"SCALAR","name":"Any"}}]},{"name":"phoneNumber","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"savedCards","type":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"SavedCreditCard","ofType":null}}},"args":[]},{"name":"smsContactNumber","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"storeCredit","type":{"kind":"OBJECT","name":"StoreCredit","ofType":null},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"UserGeneratedContent","fields":[{"name":"altText","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"avatarUrl","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"bigUrl","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"collectTerm","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"contentType","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"id","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"isInfluencer","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"likeCount","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"mediumUrl","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"mentions","type":{"kind":"LIST","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"photoTitle","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"pixleeCdnPhotos","type":{"kind":"OBJECT","name":"PixleeCdnPhotos","ofType":null},"args":[]},{"name":"platformLink","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"products","type":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"UGCProduct","ofType":null}}},"args":[]},{"name":"source","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"sourceUrl","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"thumbnailUrl","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"title","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"userName","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"width","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"Variant","fields":[{"name":"allowUnisexSize","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"appOnlyDateTimeFrom","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"appOnlyDateTimeTo","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"apparelLength","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"badge","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"badges","type":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"ProductBadge","ofType":null}}},"args":[]},{"name":"brand","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"characteristics","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"color","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"colorName","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"colorValue","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"configureID","type":{"kind":"OBJECT","name":"ConfigureIDSettings","ofType":null},"args":[]},{"name":"cupType","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"description","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"displayOutOfStock","type":{"kind":"OBJECT","name":"DisplayOutOfStock","ofType":null},"args":[]},{"name":"ean","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"fastener","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"fit","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"gender","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"header","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"heelToToeDrop","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"images","type":{"kind":"NON_NULL","ofType":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"ProductImage","ofType":null}}}},"args":[]},{"name":"isAppExclusive","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"isFinalSale","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"isWebExclusive","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"mainMaterial","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"manufacturerInfo","type":{"kind":"OBJECT","name":"ManufacturerInfo","ofType":null},"args":[]},{"name":"masterId","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"materialComposition","type":{"kind":"LIST","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"modelMeasurementText","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"myCustomizer","type":{"kind":"OBJECT","name":"MyCustomizerSettings","ofType":null},"args":[]},{"name":"name","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"offline","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"orderable","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"percentageDiscountBadge","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"playerLevel","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"pocketType","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"preview","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"price","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"primaryCategoryId","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"productPrice","type":{"kind":"OBJECT","name":"ProductPrice","ofType":null},"args":[]},{"name":"productStory","type":{"kind":"OBJECT","name":"ProductStory","ofType":null},"args":[]},{"name":"promotionExclusion","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"promotions","type":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"ProductPromotion","ofType":null}}},"args":[{"name":"page","type":{"kind":"SCALAR","name":"Any"}}]},{"name":"pronation","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"refinementCushioningLevel","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"returnRuleID","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"runTerrain","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"runnerType","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"salePrice","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"sizeGroups","type":{"kind":"NON_NULL","ofType":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"SizeGroup","ofType":null}}}},"args":[]},{"name":"sizes","type":{"kind":"NON_NULL","ofType":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"Size","ofType":null}}}},"args":[]},{"name":"slug","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"specialMessage","type":{"kind":"SCALAR","name":"Any"},"args":[{"name":"viewAt","type":{"kind":"SCALAR","name":"Any"}}]},{"name":"specialMessageFrom","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"specialMessageTo","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"studs","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"styleNumber","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"subHeader","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"supportLevelBra","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"taxDisplayMsg","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"technology","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"trouserRise","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"upc","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"validUntil","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"variantId","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"weight","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"VariantColor","fields":[{"name":"name","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"value","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"VariantProduct","fields":[{"name":"ageGroup","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"appOnlyDateTimeFrom","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"appOnlyDateTimeTo","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"apparelLength","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"articleGroup","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"articleType","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"assortmentAvailability","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"badge","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"badges","type":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"ProductBadge","ofType":null}}},"args":[]},{"name":"brand","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"businessSegment","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"businessSubSegment","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"businessUnit","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"characteristics","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"collectionMark","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"color","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"VariantColor","ofType":null}},"args":[]},{"name":"colorDescription","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"colorName","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"colorValue","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"configureID","type":{"kind":"OBJECT","name":"ConfigureIDSettings","ofType":null},"args":[]},{"name":"cupType","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"description","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"displayOutOfStock","type":{"kind":"OBJECT","name":"DisplayOutOfStock","ofType":null},"args":[]},{"name":"division","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"ean","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"fastener","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"fit","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"franchise","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"gender","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"header","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"heelToToeDrop","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"imageUrl","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"images","type":{"kind":"NON_NULL","ofType":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"ProductImage","ofType":null}}}},"args":[]},{"name":"inventory","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"isAppExclusive","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"isFinalSale","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"isWebExclusive","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"lineName","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"mainMaterial","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"masterId","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"masterProduct","type":{"kind":"OBJECT","name":"Product","ofType":null},"args":[]},{"name":"materialComposition","type":{"kind":"LIST","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"maxOrderableQuantity","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"myCustomizer","type":{"kind":"OBJECT","name":"MyCustomizerSettings","ofType":null},"args":[]},{"name":"name","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"offline","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"orderable","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"percentageDiscountBadge","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"playerLevel","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"pocketType","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"popularityCount","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"price","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"primaryCategoryId","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"productPrice","type":{"kind":"OBJECT","name":"ProductPrice","ofType":null},"args":[]},{"name":"promotionExclusion","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"promotions","type":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"ProductPromotion","ofType":null}}},"args":[]},{"name":"pronation","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"refinementCushioningLevel","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"returnRuleID","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"runTerrain","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"runnerType","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"salePrice","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"size","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"VariantSize","ofType":null}},"args":[]},{"name":"slug","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"specialMessage","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"sportName","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"studs","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"styleNumber","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"subHeader","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"supportLevelBra","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"taxDisplayMsg","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"technology","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"trouserRise","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"upc","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"validUntil","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"weight","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"VariantSize","fields":[{"name":"label","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"name","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"value","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"VerifyLoginWithOTPResult","fields":[{"name":"authPayload","type":{"kind":"OBJECT","name":"AuthPayload","ofType":null},"args":[]},{"name":"code","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"message","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"otpVerifyToken","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"VerifyUserAffiliationsPayload","fields":[{"name":"affiliations","type":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}},"args":[]},{"name":"verified","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"Version","fields":[{"name":"latest","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"mandatory","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"Video","fields":[{"name":"cloudinary","type":{"kind":"OBJECT","name":"CloudinaryConfig","ofType":null},"args":[]},{"name":"url","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"VideoHero","fields":[{"name":"autoplay","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"availableFrom","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"availableTo","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"backgroundVideo","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"backgroundVideoV2","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"Video","ofType":null}},"args":[]},{"name":"controls","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"copy","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"ctas","type":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"CTA","ofType":null}}},"args":[]},{"name":"footnote","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"header","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"horizontalAlignment","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"loop","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"minAspectRatio","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"mobileBackgroundVideo","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"mobileBackgroundVideoV2","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"Video","ofType":null}},"args":[]},{"name":"mute","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"overlayContent","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"textColor","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"verticalAlignment","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"videoPosterImage","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"Wallet","fields":[{"name":"amount","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"authorizationStatus","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"type","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"WalletResult","fields":[{"name":"orderNo","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"url","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"WechatPay","fields":[{"name":"amount","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"type","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"WishList","fields":[{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"items","type":{"kind":"NON_NULL","ofType":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"WishListItem","ofType":null}}}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"WishListItem","fields":[{"name":"creationDate","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"product","type":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"VariantProduct","ofType":null}},"args":[]},{"name":"quantity","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"YouTubeVideoCarousel","fields":[{"name":"autoplay","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"playlistId","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"showThumbnails","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"videoIds","type":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"ZipPay","fields":[{"name":"amount","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"type","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"componentWithFilters","fields":[{"name":"availableFrom","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"availableTo","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"campaign","type":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"Campaign","ofType":null}}},"args":[]},{"name":"component","type":{"kind":"UNION","name":"Slot","ofType":null},"args":[]},{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"online","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"targetDevices","type":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}}},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"infoBannerWithCategoryExclusion","fields":[{"name":"availableFrom","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"availableTo","type":{"kind":"SCALAR","name":"Any"},"args":[]},{"name":"banner","type":{"kind":"OBJECT","name":"InfoBanner","ofType":null},"args":[]},{"name":"campaign","type":{"kind":"LIST","ofType":{"kind":"OBJECT","name":"Campaign","ofType":null}},"args":[]},{"name":"exclusions","type":{"kind":"LIST","ofType":{"kind":"NON_NULL","ofType":{"kind":"OBJECT","name":"CategoryExclusion","ofType":null}}},"args":[]},{"name":"id","type":{"kind":"NON_NULL","ofType":{"kind":"SCALAR","name":"Any"}},"args":[]},{"name":"isSticky","type":{"kind":"SCALAR","name":"Any"},"args":[]}],"interfaces":[]},{"kind":"OBJECT","name":"mobileAppContent","fields":[{"name":"bottomContent","type":{"kind":"LIST","ofType":{"kind":"OBJECT","name":"AppComponentWithFilters","ofType":null}},"args":[]},{"name":"topContent","type":{"kind":"LIST","ofType":{"kind":"OBJECT","name":"AppComponentWithFilters","ofType":null}},"args":[]}],"interfaces":[]},{"kind":"SCALAR","name":"Any"}],"directives":[]}}');
;// CONCATENATED MODULE: ./gql/exchanges/cache.ts








var ROOT_QUERY_NAME = "Query";
var VARIANTS_FOR_MASTER_QUERY_NAME = "siblingVariants";
var invalidateCategoryPLPAndProduct = function(_, __, cache) {
    var key = "Query";
    cache.inspectFields(key).forEach(function(field) {
        if (field.fieldName === "categoryByUrl" || field.fieldName === "product") {
            cache.invalidate(key, field.fieldKey);
        }
    });
};
var invalidateCachesAfterPurchase = function(cache, result) {
    if (!result) return;
    cache.invalidate("Query", "wishList");
    // invalidate the "me" query so that the order history/most recent purchase
    // data will have to be refetched after the customer places a new order
    cache.invalidate("Query", "me");
    cacheCart(cache, null);
};
// Updates preffered address in cache,
// this dedupes the property from address list
var updatePreferredAddress = function(currentAddress, prevData) {
    // Only update if preffered address updated to current address
    if (!prevData || !prevData.me || !currentAddress.preferred) return null;
    prevData.me.addresses = prevData.me.addresses.map(function(cachedAddress) {
        if (currentAddress.id === cachedAddress.id) {
            return currentAddress;
        }
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, cachedAddress), {
            preferred: false
        });
    });
    return prevData;
};
var cacheCart = function(cache, cart) {
    var ref;
    var current = cache.readQuery({
        query: queries_cart/* CART_QUERY */.P
    });
    var ref1;
    // Only the `activeCart` query includes the availablePaymentMethods fields,
    // since that is subresolved and potentially expensive.  Other cart related
    // operations such as `addItemsToCart`, `cancelOrder` etc. will not return
    // this field, but we still want it in the cache.  Therefore, when updating
    // the value of the cached `CART_QUERY` data, we should retain the existing
    // cached `availablePaymentMethods` data if it is not present in the cart
    // data passed into this function
    var updated = cart ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, cart), {
        availablePaymentMethods: (ref1 = cart === null || cart === void 0 ? void 0 : cart.availablePaymentMethods) !== null && ref1 !== void 0 ? ref1 : current === null || current === void 0 ? void 0 : (ref = current.activeCart) === null || ref === void 0 ? void 0 : ref.availablePaymentMethods
    }) : null;
    cache.updateQuery({
        query: queries_cart/* CART_QUERY */.P
    }, function() {
        return {
            activeCart: updated
        };
    });
};
var getAllVariantsFromCache = function(cache, masterId) {
    var queryElements = cache.inspectFields(ROOT_QUERY_NAME);
    // attempt to find a cache entry which has the same master ID as supplied
    var cacheEntryWithSameMasterId = queryElements.find(function(queries) {
        var ref;
        if (queries.fieldName !== VARIANTS_FOR_MASTER_QUERY_NAME) return false;
        var ref1;
        var input = ((ref1 = queries === null || queries === void 0 ? void 0 : queries.arguments) !== null && ref1 !== void 0 ? ref1 : {}).input;
        return (input === null || input === void 0 ? void 0 : (ref = input.styleNumberId) === null || ref === void 0 ? void 0 : ref.split("_")[0]) === masterId;
    });
    // if we cannot find one, bail
    if (!cacheEntryWithSameMasterId) return;
    // get the style number for the cached entry
    var styleNumberIdForSameMaster = cacheEntryWithSameMasterId.arguments.input.styleNumberId;
    // return the cached data for that matching style number
    return cache.resolve(ROOT_QUERY_NAME, VARIANTS_FOR_MASTER_QUERY_NAME, {
        input: {
            styleNumberId: styleNumberIdForSameMaster
        }
    });
};
var _email, _orderNo, _orderNo1, _orderNo2, _couponItemId;
var cache_cacheExchange = cacheExchange({
    schema: graphql_urql_schema_namespaceObject,
    resolvers: {
        Product: {
            look: function(_, __, cache, info) {
                return cache.resolve(info.parentKey, "look", {
                    id: info.variables.variationId
                });
            },
            promotions: function(_, args, cache, info) {
                return cache.resolve(info.parentKey, "promotions", {
                    page: args.page
                });
            }
        },
        Query: {
            // This is the dedup logic for the variants query.
            siblingVariants: function(_, args, cache) {
                var styleNumberId = args.input.styleNumberId;
                var ref;
                // "id" is styleNumber like "311123_01".
                // Splitting on _ will give us the masterId.
                var masterId = (ref = styleNumberId === null || styleNumberId === void 0 ? void 0 : styleNumberId.split("_")[0]) !== null && ref !== void 0 ? ref : "";
                var result = getAllVariantsFromCache(cache, masterId);
                if (!Array.isArray(result) || !result.length) {
                    return;
                }
                return result;
            },
            // This is to resuse as much data from plp -> pdp transition.
            product: function(_, args, cache, info) {
                var fields = cache.inspectFields("Product:".concat(args.id));
                var resolvedProduct = fields.reduce(function(acc, param) {
                    var fieldName = param.fieldName;
                    acc[fieldName] = cache.resolve("Product:".concat(args.id), fieldName);
                    return acc;
                }, {});
                var masterId = resolvedProduct.id;
                if (masterId) {
                    var variantId = info.variables.variationId;
                    var isVariationsEmpty = Array.isArray(resolvedProduct.variations) && !resolvedProduct.variations.length;
                    var isVariationsNull = !resolvedProduct.variations;
                    if (isVariationsEmpty || isVariationsNull) {
                        var currentVariantFromCache = [
                            "Variant:".concat(variantId)
                        ];
                        var // cache, or default to the cached data for the current variant
                        ref;
                        var variations = resolvedProduct.orderableColorCount === 1 ? currentVariantFromCache : (ref = getAllVariantsFromCache(cache, masterId)) !== null && ref !== void 0 ? ref : currentVariantFromCache;
                        resolvedProduct.variations = variations;
                    }
                    return resolvedProduct;
                }
                // If there is no product in the cache then return undefined
                // and let the request result populate the cache
                return;
            }
        }
    },
    keys: {
        AuthorityToLeave: function() {
            return null;
        },
        Adyen: function() {
            return null;
        },
        AmazonPayPaymentDescriptorPayload: function() {
            return null;
        },
        OmsEntry: function() {
            return null;
        },
        EstimatedShippingDate: function() {
            return null;
        },
        FilterOptionValue: function() {
            return null;
        },
        ReviewAspects: function() {
            return null;
        },
        ReviewSummary: function() {
            return null;
        },
        BackgroundOverlay: function() {
            return null;
        },
        CTA: function() {
            return null;
        },
        ColorInput: function() {
            return null;
        },
        Rgba: function() {
            return null;
        },
        SanityImage: function() {
            return null;
        },
        SanityImageCrop: function() {
            return null;
        },
        SanityImageHotspot: function() {
            return null;
        },
        SanityImageMetaData: function() {
            return null;
        },
        ProductImage: function() {
            return null;
        },
        ProductColor: function() {
            return null;
        },
        Message: function() {
            return null;
        },
        Coordinates: function() {
            return null;
        },
        Information: function() {
            return null;
        },
        VariantSize: function() {
            return null;
        },
        Size: function() {
            return null;
        },
        SizeGroup: function() {
            return null;
        },
        VariantColor: function() {
            return null;
        },
        PaginatedOutput: function() {
            return null;
        },
        FilterOption: function() {
            return null;
        },
        Score: function() {
            return null;
        },
        SEO: function() {
            return null;
        },
        TimelineStatus: function() {
            return null;
        },
        TrendingSearchTerm: function() {
            return null;
        },
        ProductMeasurements: function() {
            return null;
        },
        NewsletterSubscription: function(entity) {
            return (_email = entity.email) !== null && _email !== void 0 ? _email : null;
        },
        ProductStory: function() {
            return null;
        },
        DisplayOutOfStock: function() {
            return null;
        },
        Shipment: function() {
            return null;
        },
        StandardOrder: function(order) {
            return (_orderNo = order.orderNo) !== null && _orderNo !== void 0 ? _orderNo : null;
        },
        NestedOrder: function(order) {
            return (_orderNo1 = order.orderNo) !== null && _orderNo1 !== void 0 ? _orderNo1 : null;
        },
        Suborder: function(suborder) {
            return (_orderNo2 = suborder.orderNo) !== null && _orderNo2 !== void 0 ? _orderNo2 : null;
        },
        CustomerInfo: function() {
            return null;
        },
        AfterPayConfig: function() {
            return null;
        },
        PaymentCardSpec: function() {
            return null;
        },
        OrderEdge: function() {
            return null;
        },
        DOB: function() {
            return null;
        },
        ShipmentMethodInfo: function() {
            return null;
        },
        Adjustment: function() {
            return null;
        },
        ProductWithExclusion: function() {
            return null;
        },
        ShippingSurcharge: function() {
            return null;
        },
        CallToAction: function() {
            return null;
        },
        Alignment: function() {
            return null;
        },
        Image: function() {
            return null;
        },
        Badge: function() {
            return null;
        },
        Text: function() {
            return null;
        },
        Link: function() {
            return null;
        },
        Style: function() {
            return null;
        },
        Tile: function() {
            return null;
        },
        Card: function() {
            return null;
        },
        SearchSuggestions: function() {
            return null;
        },
        SuggestedTerm: function() {
            return null;
        },
        SuggestedPhrase: function() {
            return null;
        },
        SanityImageMetaDataDimensions: function() {
            return null;
        },
        TextSection: function() {
            return null;
        },
        PortableText: function() {
            return null;
        },
        Children: function() {
            return null;
        },
        MarkDefs: function() {
            return null;
        },
        ManufacturerInfo: function() {
            return null;
        },
        Info: function() {
            return null;
        },
        UserGeneratedContent: function() {
            return null;
        },
        PixleeCdnPhotos: function() {
            return null;
        },
        Inventory: function() {
            return null;
        },
        FrontendConfiguration: function() {
            return null;
        },
        FeatureFlags: function() {
            return null;
        },
        SiteConfig: function() {
            return null;
        },
        DeliveryDateDays: function() {
            return null;
        },
        Environment: function() {
            return null;
        },
        PincodeServiceability: function() {
            return null;
        },
        CouponItem: function(couponItem) {
            return (_couponItemId = couponItem.couponItemId) !== null && _couponItemId !== void 0 ? _couponItemId : null;
        },
        SavedCreditCard: function() {
            return null;
        },
        ComparisonProduct: function() {
            return null;
        },
        ComparisonField: function() {
            return null;
        },
        ConfigureIDSettings: function() {
            return null;
        },
        NotFoundContentPage: function() {
            return null;
        },
        BannerIdentifier: function() {
            return null;
        },
        RecommendationsOutput: function(recommendations) {
            return recommendations.recommenderId;
        },
        Campaign: function() {
            return null;
        },
        ProductPrice: function() {
            return null;
        },
        OrderStatus: function() {
            return null;
        },
        GlossaryCategory: function(category) {
            return category.value;
        },
        GlossaryPage: function(page) {
            return page.id;
        },
        GlossaryTermFlattened: function(term) {
            return term.id;
        },
        ShopperContextPayload: function() {
            return null;
        },
        ScheduledFreeShippingThreshold: function() {
            return null;
        },
        UrlRedirect: function() {
            return null;
        }
    },
    updates: {
        Mutation: {
            addItemsToCart: function(result, args, cache) {
                var ref;
                if (typeof (result === null || result === void 0 ? void 0 : result.addItemsToCart) === "object" && !(args === null || args === void 0 ? void 0 : (ref = args.input) === null || ref === void 0 ? void 0 : ref.basketId)) {
                    cacheCart(cache, result.addItemsToCart);
                }
            },
            addGiftCardToCart: function(result, args, cache) {
                var ref;
                if (typeof (result === null || result === void 0 ? void 0 : result.addGiftCardToCart) === "object" && !(args === null || args === void 0 ? void 0 : (ref = args.input) === null || ref === void 0 ? void 0 : ref.basketId)) {
                    cacheCart(cache, result.addGiftCardToCart);
                }
            },
            ambassadorCard: function(result, _args, cache) {
                invalidateCachesAfterPurchase(cache, result.ambassadorCard);
            },
            removeCouponFromCart: invalidateCategoryPLPAndProduct,
            addCouponToCart: invalidateCategoryPLPAndProduct,
            giftCard: function(result, _args, cache) {
                invalidateCachesAfterPurchase(cache, result.giftCard);
            },
            googlePay: function(result, _args, cache) {
                invalidateCachesAfterPurchase(cache, result.googlePay);
            },
            creditCard: function(result, _args, cache) {
                invalidateCachesAfterPurchase(cache, result.creditCard);
            },
            confirmCreditCard: function(result, _args, cache) {
                invalidateCachesAfterPurchase(cache, result.confirmCreditCard);
            },
            confirmCashOnDelivery: function(result, _args, cache) {
                invalidateCachesAfterPurchase(cache, result.confirmCashOnDelivery);
            },
            confirmAfterPay: function(result, _args, cache) {
                invalidateCachesAfterPurchase(cache, result.confirmAfterPay);
            },
            confirmPayPay: function(result, _args, cache) {
                invalidateCachesAfterPurchase(cache, result.confirmPayPay);
            },
            confirmApplePay: function(result, _args, cache) {
                invalidateCachesAfterPurchase(cache, result.confirmApplePay);
            },
            confirmPayPal: function(result, _args, cache) {
                invalidateCachesAfterPurchase(cache, result.confirmPayPal);
            },
            confirmAmazonPay: function(result, _args, cache) {
                invalidateCachesAfterPurchase(cache, result.confirmAmazonPay);
            },
            completeAdyenPayment: function(result, _args, cache) {
                invalidateCachesAfterPurchase(cache, result.completeAdyenPayment);
            },
            completeAmazonPayment: function(result, _args, cache) {
                invalidateCachesAfterPurchase(cache, result.completeAmazonPayment);
            },
            startAdyenPayment: function(result, _args, cache) {
                var ref;
                var resultData = result;
                var resultCode = resultData === null || resultData === void 0 ? void 0 : (ref = resultData.startAdyenPayment) === null || ref === void 0 ? void 0 : ref.resultCode;
                // Only invalidate the cart when this mutation retuns 'Authorised'.
                // The mutation places the order in GQL already.
                if (resultCode === graphql/* AdyenResultCodeEnum.Authorised */.HuP.Authorised) {
                    invalidateCachesAfterPurchase(cache, result.startAdyenPayment);
                }
            },
            confirmRazorPay: function(result, _args, cache) {
                invalidateCachesAfterPurchase(cache, result.confirmRazorPay);
            },
            cancelGooglePay: function(result, _args, cache) {
                if (result.cancelGooglePay) {
                    cacheCart(cache, result.cancelGooglePay);
                }
            },
            cancelOrder: function(result, _args, cache) {
                var ref;
                cacheCart(cache, (ref = result.cancelOrder) === null || ref === void 0 ? void 0 : ref.cart);
            },
            cancelApplePay: function(result, _args, cache) {
                if (result === null || result === void 0 ? void 0 : result.cancelApplePay) {
                    cacheCart(cache, result.cancelApplePay);
                }
            },
            manageCustomerLevelNotification: function(result, _args, cache) {
                var res = result.manageCustomerLevelNotification;
                cache.updateQuery({
                    query: ME_QUERY
                }, function(prevData) {
                    if (!(prevData === null || prevData === void 0 ? void 0 : prevData.me)) return null;
                    var data = prevData;
                    data.me.smsContactNumber = res;
                    return data;
                });
            },
            updateAddress: function(result, _args, cache) {
                if (result.updateAddress) {
                    var resultData = result;
                    if (!resultData.updateAddress.preferred) {
                        return;
                    }
                    cache.updateQuery({
                        query: ME_QUERY,
                        variables: {
                            includeAddresses: true
                        }
                    }, function(prevData) {
                        // Updates preferred address in the cache list of addresses
                        return updatePreferredAddress(resultData.updateAddress, prevData);
                    });
                }
            },
            updateProfile: function(result, _args, cache) {
                if (result.updateProfile) {
                    cache.updateQuery({
                        query: ME_QUERY
                    }, function(prevData) {
                        if (!prevData || !prevData.me) return null;
                        prevData.me = result.updateProfile;
                        return prevData;
                    });
                }
            },
            addAddress: function(result, _args, cache) {
                if (result.addAddress) {
                    var resultData = result;
                    cache.updateQuery({
                        query: ME_QUERY,
                        variables: {
                            includeAddresses: true
                        }
                    }, function(prevData) {
                        if (!(prevData === null || prevData === void 0 ? void 0 : prevData.me)) return null;
                        var data = (0,_object_spread/* default */.Z)({}, prevData);
                        if (!data.me.addresses) {
                            data.me.addresses = [];
                        }
                        data.me.addresses.push(resultData.addAddress);
                        // Updates preferred address in the cache list of addresses
                        if (resultData.addAddress.preferred) {
                            return updatePreferredAddress(resultData.addAddress, prevData);
                        }
                        return data;
                    });
                }
            },
            deleteAddress: function(result, args, cache) {
                var variables = args;
                if (result.deleteAddress) {
                    cache.updateQuery({
                        query: ME_QUERY,
                        variables: {
                            includeAddresses: true
                        }
                    }, function(prevData) {
                        if (!prevData || !prevData.me) return null;
                        var data = prevData;
                        return {
                            me: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevData.me), {
                                addresses: data.me.addresses.filter(function(a) {
                                    return a.id !== variables.id;
                                })
                            })
                        };
                    });
                }
            },
            deleteCreditCard: function(result, _args, cache) {
                if (result.deleteCreditCard) {
                    cache.updateQuery({
                        query: ME_QUERY,
                        variables: {
                            includeSavedCards: true
                        }
                    }, function(prevData) {
                        if (!prevData || !prevData.me) return null;
                        var resultData = result;
                        return {
                            me: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevData.me), {
                                savedCards: resultData.deleteCreditCard.savedCards
                            })
                        };
                    });
                }
            },
            saveCreditCard: function(result, _args, cache) {
                if (result.saveCreditCard) {
                    cache.updateQuery({
                        query: ME_QUERY,
                        variables: {
                            includeSavedCards: true
                        }
                    }, function(prevData) {
                        if (!prevData || !prevData.me) return null;
                        var resultData = result;
                        return {
                            me: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevData.me), {
                                savedCards: resultData.saveCreditCard.savedCards
                            })
                        };
                    });
                }
            },
            removeItemFromWishList: function(result, args, cache) {
                var variables = args;
                if (result.removeItemFromWishList) {
                    cache.updateQuery({
                        query: wishList/* WISHLIST_QUERY */.z
                    }, function(prevData) {
                        if (!prevData || !prevData.wishList) return null;
                        var data = prevData;
                        return {
                            wishList: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data.wishList), {
                                items: data.wishList.items.filter(function(item) {
                                    return item.id !== variables.input.itemId;
                                })
                            })
                        };
                    });
                }
            }
        }
    },
    optimistic: {
        removeItemFromWishList: function() {
            return true;
        }
    }
});

;// CONCATENATED MODULE: ./gql/exchanges/error.ts


var gqlMocksEnabled = "false" === "true";
var ignoreError = function(error) {
    return error.message.match("requested page could not be found") || // when using mock service worker, we get a "socket hang up" error whenever
    // a query is aborted. This error does not cause any problems since the abort
    // was expected, but we ignore it to keep the dev tools console output clean
    (error.message.match("socket hang up") && gqlMocksEnabled);
};
var errorExchangeConfig = {
    onError: function(error, operation) {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
        if (ignoreError(error)) return;
        var queryDefinition = operation.query.definitions[0] || undefined;
        var queryName = queryDefinition && "name" in queryDefinition && ((ref = queryDefinition.name) === null || ref === void 0 ? void 0 : ref.value) || (queryDefinition === null || queryDefinition === void 0 ? void 0 : queryDefinition.kind) || "unknown";
        var errorCode = (ref1 = error === null || error === void 0 ? void 0 : error.graphQLErrors[0]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.extensions) === null || ref2 === void 0 ? void 0 : ref2.code;
        var errorMessage = typeof ((ref3 = error === null || error === void 0 ? void 0 : error.graphQLErrors[0]) === null || ref3 === void 0 ? void 0 : ref3.message) === "string" && ((ref4 = error === null || error === void 0 ? void 0 : error.graphQLErrors[0]) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.message) === null || ref5 === void 0 ? void 0 : ref5.toLowerCase());
        var apigwRequestId = error === null || error === void 0 ? void 0 : (ref6 = error.response) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.headers) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.get) === null || ref8 === void 0 ? void 0 : ref8.call(ref7, "apigw-requestid");
        clientLogger/* clientLogger.error */.u.error({
            queryName: queryName,
            errorCode: errorCode,
            errorMessage: errorMessage,
            apigwRequestId: apigwRequestId
        }, "GraphQL Error");
    }
};
var errorExchange = (0,urql_core/* mapExchange */.Lw)(errorExchangeConfig);

;// CONCATENATED MODULE: ../node_modules/@urql/exchange-retry/dist/urql-exchange-retry.mjs




var retryExchange = y => {
  var {retryIf: p, retryWith: s} = y;
  var d = y.initialDelayMs || 1e3;
  var m = y.maxDelayMs || 15e3;
  var v = y.maxNumberAttempts || 2;
  var c = null != y.randomDelay ? !!y.randomDelay : !0;
  return ({forward: y, dispatchDebug: l}) => f => {
    var {source: h, next: x} = (0,wonka/* makeSubject */.nN)();
    var D = (0,wonka/* mergeMap */.zg)((r => {
      var {key: e, context: i} = r;
      var y = (i.retryCount || 0) + 1;
      var p = i.retryDelay || d;
      var s = Math.random() + 1.5;
      if (c && p * s < m) {
        p *= s;
      }
      var h = (0,wonka/* filter */.hX)((r => ("query" === r.kind || "teardown" === r.kind) && r.key === e))(f);
       false && 0;
      return (0,wonka/* takeUntil */.Rs)(h)((0,wonka/* debounce */.Ds)((() => p))((0,wonka/* fromValue */._A)((0,urql_core/* makeOperation */.vx)(r.kind, r, {
        ...r.context,
        retryDelay: p,
        retryCount: y
      }))));
    }))(h);
    return (0,wonka/* filter */.hX)((r => {
      if (!(r.error && (p ? p(r.error, r.operation) : s || r.error.networkError))) {
        return !0;
      }
      if (!((r.operation.context.retryCount || 0) >= v - 1)) {
        var e = s ? s(r.error, r.operation) : r.operation;
        if (!e) {
          return !0;
        }
        x(e);
        return !1;
      }
       false && 0;
      return !0;
    }))(y((0,wonka/* merge */.TS)([ f, D ])));
  };
};


//# sourceMappingURL=urql-exchange-retry.mjs.map

;// CONCATENATED MODULE: ./gql/exchanges/retry.ts

var REQUEST_TIMEOUT_STATUS_CODE = 408;
var retryOperations = [];
var createRetryExchange = function() {
    return retryExchange({
        initialDelayMs: 1000,
        maxDelayMs: 15000,
        randomDelay: true,
        maxNumberAttempts: 5,
        retryIf: function(err, operation) {
            return Boolean(((err === null || err === void 0 ? void 0 : err.graphQLErrors) || []).find(function(graphQLError) {
                return graphQLError.extensions.code == REQUEST_TIMEOUT_STATUS_CODE;
            }) && operation.query.definitions.find(function(definition) {
                var ref, ref1;
                return definition.kind === "OperationDefinition" && ((ref = definition.name) === null || ref === void 0 ? void 0 : ref.value) && retryOperations.includes((ref1 = definition.name) === null || ref1 === void 0 ? void 0 : ref1.value);
            }));
        }
    });
};

;// CONCATENATED MODULE: ./gql/exchanges/filterNoLocale.ts


var filterNoLocale = function(param) {
    var forward = param.forward;
    var localesHash = Object.values(constants/* SUPPORTED_LOCALE */.xM).reduce(function(prevResult, locale) {
        prevResult[locale] = locale;
        return prevResult;
    }, {});
    return function(operations$) {
        return forward((0,wonka/* pipe */.zG)(operations$, (0,wonka/* filter */.hX)(function(op) {
            // FIXME: This will cause operations that don't match the filter to
            // just hang forever, as the operation will never be handled. Instead,
            // it would be better to return an error for such operations.
            // See the urql documentation: "How to Avoid Dropping Operations":
            // https://formidable.com/open-source/urql/docs/advanced/authoring-exchanges/#how-to-avoid-accidentally-dropping-operations
            if (op.kind === "mutation" || op.kind === "query") {
                var ref, ref1;
                var fetchOptions = typeof ((ref = op.context) === null || ref === void 0 ? void 0 : ref.fetchOptions) === "function" ? op.context.fetchOptions() : op.context.fetchOptions;
                var locale = fetchOptions === null || fetchOptions === void 0 ? void 0 : (ref1 = fetchOptions.headers) === null || ref1 === void 0 ? void 0 : ref1["locale"];
                return locale in localesHash;
            }
            return true;
        })));
    };
};

;// CONCATENATED MODULE: ./gql/client.ts
/* provided dependency */ var process = __webpack_require__(27061);












var getGraphQlUrl = function() {
    if (!constants/* isServer */.sk) {
        return window.location.origin + "/api/graphql";
    }
    var _GQL_ENDPOINT;
    var gqlEndpoint = (_GQL_ENDPOINT = process.env.GQL_ENDPOINT) !== null && _GQL_ENDPOINT !== void 0 ? _GQL_ENDPOINT : "";
    if (!gqlEndpoint) {
        throw new Error("GQL Endpoint must be provided in order for the web application to run!");
    }
    return gqlEndpoint;
};
var getFetchOptions = function(ctx) {
    var ref;
    var cookies = (0,dist.parseCookies)(ctx);
    var locale = constants/* isServer */.sk ? (0,utils_locale/* getLocaleFromRequest */.Sr)(ctx.req) : (0,utils_locale/* getLocaleFromUrl */.GB)((router_default()).query);
    var options = {
        headers: {
            locale: locale,
            accept: "application/graphql-response+json, application/graphql+json, application/json",
            "x-graphql-client-name": "nitro-fe",
            "x-graphql-client-version": "ee64fa18388a20d6b60fb833a576307ea0e58f8b" || 0
        }
    };
    var noCache = constants/* isServer */.sk ? ctx === null || ctx === void 0 ? void 0 : (ref = ctx.query) === null || ref === void 0 ? void 0 : ref.draft : window.location.search.match("draft=");
    // This header ensures that GQL requests don't get cached
    if (noCache) options.headers.preview = "true";
    var bloomReachId = cookies["_br_uid_2"];
    if (bloomReachId) options.headers["bloomreach-id"] = bloomReachId;
    var impersonation = (0,cookie/* getStoredAgentAuthData */.jH)(ctx);
    if (impersonation) {
        options.headers["impersonation-agent"] = impersonation.identifier;
    }
    return options;
};
var withUrql = withUrqlClient(function(ssr, ctx) {
    return {
        fetchOptions: function() {
            return getFetchOptions(ctx);
        },
        url: getGraphQlUrl(),
        preferGetMethod: false,
        exchanges: [
             false && 0,
            cache_cacheExchange,
            ssr,
            constants/* isServer */.sk ? createSSRAuthExchange(ctx) : createClientAuthExchange(),
            createRetryExchange(),
            filterNoLocale,
            errorExchange,
            urql_core/* fetchExchange */.Ek, 
        ].filter(Boolean)
    };
}, {
    ssr: true
});

// EXTERNAL MODULE: ./hooks/useCookieSettings.tsx + 1 modules
var useCookieSettings = __webpack_require__(34457);
// EXTERNAL MODULE: ./hooks/useEmarsysWebExtend.tsx + 2 modules
var useEmarsysWebExtend = __webpack_require__(78108);
// EXTERNAL MODULE: ./hooks/useForter.tsx + 1 modules
var useForter = __webpack_require__(42876);
// EXTERNAL MODULE: ./hooks/useGA4Events.tsx
var useGA4Events = __webpack_require__(89113);
// EXTERNAL MODULE: ./hooks/useToast.tsx
var useToast = __webpack_require__(14476);
// EXTERNAL MODULE: ./hooks/useAccountSettings.tsx
var useAccountSettings = __webpack_require__(35855);
;// CONCATENATED MODULE: ./utils/googleTagManager.tsx

var gtmScriptText = function(param) {
    var gtmId = param.gtmId;
    return '\n  (function (w, d, s, l, i) {\n    w[l] = w[l] || [];\n    w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });\n    window.pageData = {\n      navigation: {},\n      customer: {},\n    };\n    var f = d.getElementsByTagName(s)[0],\n      j = d.createElement(s),\n      dl = l != "dataLayer" ? "&l=" + l : "";\n    j.async = true;\n    j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;\n    f.parentNode.insertBefore(j, f);\n  })(window, document, "script", "dataLayer", "'.concat(gtmId, '");\n');
};
var GtmNoScript = function(param) {
    var gtmId = param.gtmId;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("noscript", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
            src: "https://www.googletagmanager.com/ns.html?id=".concat(gtmId),
            height: "0",
            width: "0",
            className: "display:none;visibility:hidden"
        })
    });
};

// EXTERNAL MODULE: ./utils/isCrawlerCheck.ts + 1 modules
var isCrawlerCheck = __webpack_require__(22198);
;// CONCATENATED MODULE: ./config/getLocalizedFlagsEnabled.ts
var getLocalizedFlagsEnabled = function(allLocalesFeatureFlags) {
    var result = {};
    for(var env in allLocalesFeatureFlags){
        var allLocales = allLocalesFeatureFlags[env];
        for(var locale in allLocales){
            var allFlags = allLocales[locale];
            for(var flag in allFlags){
                if (allFlags[flag]) {
                    if (!result[flag]) {
                        result[flag] = {};
                    }
                    if (!result[flag][env]) {
                        result[flag][env] = [];
                    }
                    result[flag][env].push(locale);
                }
            }
        }
    }
    return result;
};

// EXTERNAL MODULE: ../node_modules/deepmerge/dist/cjs.js
var cjs = __webpack_require__(21857);
var cjs_default = /*#__PURE__*/__webpack_require__.n(cjs);
;// CONCATENATED MODULE: ../node_modules/@global-ecom/nitro-uds/dist/theme/esm/index.js




const sanitizeInput = (input, theme) => {
    const result = theme('aspectRatio', `${input}`);
    if (input === 'none')
        return input;
    if (typeof result === 'number')
        return result;
    return parseFloat(`${result}`);
};
const aspectRatio$ = (ratio, { theme }) => {
    const value = sanitizeInput(ratio, theme);
    if (!value)
        return '';
    if (value === 'none') {
        return twind/* apply */.nn `static pb-0 children:(static h-auto w-auto inset-auto)`;
    }
    return {
        width: '100%',
        paddingTop: `${value * 100}%`,
        position: 'relative',
        '& > *': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            width: '100%',
            height: '100%',
            overflow: 'hidden',
        },
    };
};
const aspectRatio = ((parts) => {
    const input = Array.isArray(parts) ? parts[0] : parts;
    return (0,twind/* directive */.XM)(aspectRatio$, input);
});
/**
 * Function for Minimum Aspect Ratio
 * first sanitize the input value and either
 * return styles for 'none'
 * or an aspect ratio value
 */
const minAspectRatio$ = (ratio, { theme }) => {
    const value = sanitizeInput(ratio, theme);
    // if no value, don't return any styles
    if (!value)
        return '';
    // clear styles
    if (value === 'none') {
        return {
            width: 'auto',
            position: 'static',
            '&:before': {
                content: 'none',
                paddingBottom: 0,
                float: 'none',
            },
            '&:after': {
                content: 'none',
            },
        };
    }
    //
    return {
        width: '100%',
        position: 'relative',
        '&:before': {
            content: '""',
            paddingBottom: `${value * 100}%`,
            float: 'left',
        },
        '&:after': {
            display: 'table',
            content: '""',
            clear: 'both',
        },
    };
};
const minAspectRatio = ((parts) => {
    const input = Array.isArray(parts) ? parts[0] : parts;
    return (0,twind/* directive */.XM)(minAspectRatio$, input);
});

const heading$ = (size, { theme }) => {
    const fontSize = theme('headingSize')[size || 'base'];
    return typeof fontSize === 'string'
        ? { fontSize: fontSize }
        : { fontSize: fontSize[0], lineHeight: fontSize[1] };
};
const heading = ((size, context) => Array.isArray(size)
    ? heading$(size[0], context)
    : (0,twind/* directive */.XM)(heading$, `${size}`));

const spacing = {
    px: '1px',
    0: '0px',
    0.5: '0.125rem',
    1: '0.25rem',
    1.5: '0.375rem',
    2: '0.5rem',
    2.5: '0.625rem',
    3: '0.75rem',
    3.5: '0.875rem',
    4: '1rem',
    5: '1.25rem',
    6: '1.5rem',
    7: '1.75rem',
    8: '2rem',
    9: '2.25rem',
    10: '2.5rem',
    11: '2.75rem',
    12: '3rem',
    14: '3.5rem',
    16: '4rem',
    20: '5rem',
    24: '6rem',
    28: '7rem',
    32: '8rem',
    36: '9rem',
    40: '10rem',
    44: '11rem',
    48: '12rem',
    52: '13rem',
    56: '14rem',
    60: '15rem',
    64: '16rem',
    72: '18rem',
    80: '20rem',
    96: '24rem',
    112: '28rem',
    128: '32rem',
};
const textDecorationLineTypes = [
    'underline',
    'overline',
    'line-through',
    'none',
];

/**
 * TODO: focus-visible mismatch
 *
 *      body:not(.focus-visible) * {
 *        outline: none !important;
 *      }
 *
 *      .focus-visible :focus {
 *        outline: none !important;
 *        @apply ring-gray-500 ring-2 rounded-sm;
 *      }
 *
 *      .focus-visible input:focus + [data-type='check-btn'] {
 *        @apply ring-gray-500 ring-2 ring-opacity-90;
 *      }
 *
 *      .focus-visible input:focus + [data-type='radio-btn'] {
 *        @apply ring-gray-500 ring-2 ring-opacity-90;
 *      }
 *
 *      .focus-visible [data-test-id='dropdown-select'] {
 *        @apply focus-within:ring-2 ring-gray-500;
 *      }
 *
 *      .focus-visible input:focus,
 *      .focus-visible textarea:focus {
 *        outline: none !important;
 *        @apply ring-gray-500 ring-2 rounded-sm;
 *      }
 *
 */
const baseConfig = {
    mode: 'silent',
    preflight: `
    html,
    body {
      width: 100%;
    }

    body {
      min-height: 100vh;
      overflow-x: hidden;
      @apply font-display;
      font-kerning: normal;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      text-rendering: optimizeLegibility;
    }


    [data-live-announcer="true"] {
      @apply sr-only;
    }


    /* custom fonts JP */
    body.ja,
    body.ja .font-display {
      font-family: "Noto Sans JP", FFDINforPuma, sans-serif;
    }

    a,button {
      cursor: pointer;
    }

    /* global focus indicator */
    body button:focus-visible, body a:focus-visible {
      outline: 2px solid #8c9198;
      outline-offset: 2px;
    }

    body button:focus:not(:focus-visible), body a:focus:not(:focus-visible) {
      outline: none;
    }

    :not(button):not(a):not(input):not(textarea):not(select):focus-visible {
      outline: 2px solid #8c9198;
      outline-offset: -2px;
    }

    :not(button):not(a):not(input):not(textarea):not(select):focus-visible {
      outline: 2px solid #8c9198;
      outline-offset: -2px;
    }

    .overflow-y-scroll,
    .overflow-y-auto {
      -webkit-overflow-scrolling: touch;
    }

    body *:not([role='dialog']):not(#modal)::-webkit-scrollbar {
      -webkit-appearance: none;
      width: 6px;
      height: 6px;
    }

    body *:not([role='dialog']):not(#modal)::-webkit-scrollbar-track {
      background: #DFE0E1;
      border-radius: 6px;
    }

    body *:not(dialog)::-webkit-scrollbar-thumb {
      background-color: #50565E;
      border-radius: 6px;
    }

    /* input search decorators */
    input[type='search'] {
      -webkit-appearance: none;
    }

    /* Chrome, Safari */
    input[type='search']::-webkit-search-decoration,
    input[type='search']::-webkit-search-cancel-button,
    input[type='search']::-webkit-search-results-button,
    input[type='search']::-webkit-search-results-decoration {
      display: none;
    }

    /* IE, Edge */
    input[type='search']::-ms-clear {
      display: none;
      width: 0;
      height: 0;
    }
  `,
    theme: {
        screens: {
            _: '0px',
            '2xs': '375px',
            xs: '480px',
            sm: '640px',
            md: '768px',
            lg: '1024px',
            xl: '1280px',
            '2xl': '1440px',
            '3xl': '1600px',
            '4xl': '1920px',
            mobile: { raw: 'screen and (max-width: 539px)' },
            tablet: {
                raw: 'screen and (min-width: 540px) and (max-width: 1023px)',
            },
            desktop: { raw: 'screen and (min-width: 1024px)' },
        },
        colors: {
            transparent: 'transparent',
            current: 'currentColor',
            inherit: 'inherit',
            white: '#ffffff',
            black: '#191919',
            gray: {
                100: '#f3f4f6',
                200: '#e5e7eb',
                300: '#d1d5db',
                400: '#9ca3af',
                500: '#6b7280',
                600: '#4b5563',
            },
            red: {
                DEFAULT: '#ba2b20',
                500: '#ef4444',
                600: '#dc2626',
                700: '#b91c1c',
            },
            green: {
                DEFAULT: '#008626',
                500: '#10b981',
                600: '#059669',
            },
            blue: {
                700: '#1d4ed8',
            },
            neutral: {
                DEFAULT: '#191919',
                0: '#ffffff',
                10: '#F6F7F8',
                20: '#DFE0E1',
                30: '#BDC1C5',
                40: '#A1A8AF',
                50: '#8C9198',
                60: '#676D75',
                70: '#50565E',
                80: '#3B4047',
                90: '#262A30',
                100: '#191919',
            },
            outline: {
                DEFAULT: '#8C9198',
                invert: '#676D75',
            },
            brand: {
                DEFAULT: '#AC1E1E',
                0: '#FFF5F5',
                5: '#FCDEDE',
                10: '#F8C6C6',
                20: '#F19595',
                30: '#E66B6B',
                40: '#D84949',
                50: '#C43030',
                60: '#AC1E1E',
                70: '#920F0F',
                80: '#710808',
                90: '#4C0303',
                100: '#260000',
            },
            gold: {
                DEFAULT: '#6D5527',
                80: '#4C3B1B',
                60: '#6D5527',
                40: '#A78B55',
                light: '#A3885F',
            },
            info: {
                DEFAULT: '#0656B6',
                0: '#F5FAFF',
                5: '#DAEAFD',
                10: '#BFDAFB',
                20: '#8ABAF5',
                30: '#5B9CEC',
                40: '#3582DF',
                50: '#196ACD',
                60: '#0656B6',
                70: '#004599',
                80: '#003576',
                90: '#00234F',
                100: '#001126',
            },
            warning: {
                DEFAULT: '#CD9719',
                0: '#FFFBF5',
                5: '#FDF1DA',
                10: '#FBE6BF',
                20: '#F5D18A',
                30: '#ECBD5B',
                40: '#DFAA35',
                50: '#CD9719',
                60: '#B68206',
                70: '#996D00',
                80: '#765400',
                90: '#4F3800',
                100: '#261B00',
            },
            success: {
                DEFAULT: '#4D7D04',
                0: '##FFFFF5',
                5: '#F3F4D2',
                10: '#E4E9B1',
                20: '#C4D477',
                30: '#A1BE49',
                40: '#81A828',
                50: '#649312',
                60: '#4D7D04',
                70: '#3B6700',
                80: '#2D5200',
                90: '#203C00',
                100: '#142600',
            },
            error: {
                DEFAULT: '#B62906',
                0: '#FFF6F5',
                5: '#FDDDDA',
                10: '#FBC5BF',
                20: '#F5988A',
                30: '#EC715B',
                40: '#DF5335',
                50: '#CD3B19',
                60: '#B62906',
                70: '#991F00',
                80: '#761900',
                90: '#4F1100',
                100: '#260800',
            },
            promotion: {
                DEFAULT: '#732C7E',
                10: '#8F7EB4',
                100: '#732C7E',
            },
        },
        borderColor: theme => ({
            ...theme('colors'),
            DEFAULT: theme('colors.gray.200', 'currentColor'),
        }),
        ringColor: theme => ({
            DEFAULT: '#8C9198',
            invert: '#676D75',
            ...theme('colors'),
        }),
        ringOpacity: {
            DEFAULT: '1',
        },
        ringWidth: {
            DEFAULT: '3px',
            0: '0px',
            1: '1px',
            2: '2px',
            3: '3px',
        },
        fontFamily: {
            display: [
                'FFDINforPuma',
                'Inter',
                '-apple-system',
                'system-ui',
                'BlinkMacSystemFont',
                'Segoe UI',
                'Roboto',
                'Helvetica Neue',
                'Arial',
                'sans-serif',
            ],
        },
        headingSize: {
            xxxs: ['14px', '1.333'],
            xxs: ['16px', '1.333'],
            xs: ['18px', '1.333'],
            sm: ['20px', '1.2'],
            base: ['24px', '1.1666'],
            lg: ['28px', '1.142'],
            xl: ['32px', '1.125'],
            '2xl': ['40px', '1.1'],
            '3xl': ['48px', '1'],
            '4xl': ['60px', '1'],
            '5xl': ['72px', '1'],
            '6xl': ['96px', '1'],
            '7xl': ['112px', '1'],
            inherit: 'inherit',
        },
        fontSize: {
            xxs: ['10px', { lineHeight: '1.6', letterSpacing: '0.04' }],
            xs: ['12px', { lineHeight: '1.333', letterSpacing: '0.04' }],
            sm: ['14px', '1.428'],
            base: ['16px', '1.5'],
            lg: ['18px', '1.5555'],
            xl: ['20px', '1.4'],
            '2xl': ['24px', '1.333'],
            '3xl': ['28px', '1.142'],
            '4xl': ['32px', '1.125'],
            '5xl': ['40px', '1.1'],
            '6xl': ['48px', '1'],
            '7xl': ['60px', '1'],
            '8xl': ['72px', '1'],
            '9xl': ['96px', '1'],
            '10xl': ['112px', '1'],
            inherit: 'inherit',
        },
        fontWeight: {
            normal: '400',
            bold: '700',
            unset: 'unset',
        },
        lineHeight: {
            xxs: '1rem',
        },
        outline: {
            default: ['1px solid #8C9198', '2px'],
            invert: ['1px solid #676D75', '2px'],
            none: ['none', '0px'],
        },
        letterSpacing: {
            tightest: '-.06em',
            tighter: '-.04em',
            tight: '-.02em',
            normal: '0',
            wide: '.02em',
            wider: '.04em',
            widest: '.06em',
        },
        animation: {
            'fade-in': 'fadeIn 200ms',
            'fade-in-up': 'fadeInUp 200ms',
            'fall-from-top': 'fallFromTop 200ms',
            'slide-in-top': 'slideInTop 200ms',
            'slide-in-bottom': 'slideInBottom 200ms',
            none: 'none',
        },
        keyframes: {
            pulse: {
                '0%, 100%': { opacity: '0%' },
                '50%': { opacity: '20%' },
            },
            fadeIn: {
                '0%': { opacity: '0%' },
                '100%': { opacity: '100%' },
            },
            fadeInUp: {
                '0%': { opacity: '0%', transform: 'translateY(2%)' },
                '100%': { opacity: '100%', transform: 'translateY(0)' },
            },
            fallFromTop: {
                from: { opacity: 0, transform: 'translateY(-100%) rotate(-45deg)' },
                to: { opacity: 1, transform: 'translateY(0) rotate(0deg)' },
            },
            slideInTop: {
                from: { transform: 'translateY(-2%)' },
                to: { transform: 'translateY(0)' },
            },
            slideInBottom: {
                from: { transform: 'translateY(2%)' },
                to: { transform: 'translateY(0)' },
            },
        },
        extend: {
            gridAutoColumns: {
                '1': '100%',
                '2': '50%',
                '3': '33.3%',
                '4': '25%',
                '5': '20%',
                '6': '16.666%',
            },
            zIndex: {
                dialog: '1000',
                search: '999',
            },
            borderWidth: {
                1: '1px',
                2: '2px',
                3: '3px',
                4: '4px',
                5: '5px',
                6: '6px',
                8: '8px',
            },
            maxWidth: { ...spacing, min: 'min-content', max: 'max-content' },
            minWidth: { ...spacing, min: 'min-content', max: 'max-content' },
            minHeight: { ...spacing },
            maxHeight: { ...spacing },
            height: {
                max: 'max-content',
            },
            width: {
                112: '28rem',
                128: '32rem',
            },
            boxShadow: {
                'glow-base': '0px 0px 25px -5px rgba(25, 25, 25, 0.15)',
                'glow-success': '0px 0px 25px -5px rgba(32, 60, 0, 0.15)',
                'glow-error': '0px 0px 25px -5px rgba(118, 25, 0, 0.15)',
                'glow-warning': '0px 0px 25px -5px rgba(79, 56, 0, 0.15)',
                'glow-info': '0px 0px 25px -5px rgba(0, 53, 118, 0.15)',
                'glow-base-invert': '0px 0px 25px -5px rgba(223,224,225, 0.15)',
                'glow-success-invert': '0px 0px 25px -5px rgba(196,212,119, 0.15)',
                'glow-error-invert': '0px 0px 25px -5px rgba(251,197,191, 0.15)',
                'glow-warning-invert': '0px 0px 25px -5px rgba(245,209,138, 0.15)',
                'glow-info-invert': '0px 0px 25px -5px rgba(191,218,251, 0.15)',
            },
            transitionTimingFunction: {
                'in-expo': 'cubic-bezier(0.95, 0.05, 0.795, 0.035)',
                'out-expo': 'cubic-bezier(0.19, 1, 0.22, 1)',
            },
        },
    },
    plugins: {
        'font-stretch-normal': css/* css */.iv `
      font-stretch: normal;
    `,
        'font-stretch-condensed': css/* css */.iv `
      font-stretch: condensed;
    `,
        // heading typescale
        heading: heading,
        // Aspect ratio padding hack
        'aspect-ratio': aspectRatio,
        'min-aspect-ratio': minAspectRatio,
        // css aspect ratio
        aspect: (parts) => ({
            '@supports (aspect-ratio: 1 / 1)': {
                aspectRatio: `${parts[0]} / ${parts[1]}`,
            },
            '@supports not (aspect-ratio: 1 / 1)': {
                '&::before': {
                    content: '""',
                    float: 'left',
                    paddingTop: `calc(100% / (${parts[0] / parts[1]}))`,
                },
                '&::after': {
                    clear: 'left',
                    content: '""',
                    display: 'block',
                },
            },
        }),
        indent: parts => ({
            textIndent: parts[0],
        }),
        content: () => ({
            content: '""',
        }),
        // Text decoration extended types for line, thickeness and color
        decoration: (parts, { theme }) => {
            if (textDecorationLineTypes.includes(parts[0])) {
                return {
                    textDecorationLine: parts[0],
                };
            }
            if (Number(parts[0])) {
                return {
                    textDecorationThickness: theme('borderWidth', parts[0]),
                };
            }
            return {
                textDecorationColor: theme('colors', parts),
            };
        },
        // Text underline offset
        'underline-offset': (parts, { theme }) => ({
            textUnderlineOffset: theme('spacing', parts[0]),
        }),
        'flex-gap': (parts, { theme }) => {
            return {
                marginBottom: `-${theme('spacing', parts)} !important`,
                marginRight: `-${theme('spacing', parts)} !important`,
                '& > *': {
                    marginBottom: `${theme('spacing', parts)} !important`,
                    marginRight: `${theme('spacing', parts)} !important`,
                },
            };
        },
        'line-clamp': parts => {
            return {
                display: '-webkit-box',
                WebkitLineClamp: parts[0],
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden',
            };
        },
        'no-scrollbars': () => {
            return css/* css */.iv `
        &::-webkit-scrollbar {
          width: 0px;
          height: 0px;
        }
      `;
        },
    },
    variants: {
        ltr: '&[dir=ltr], [dir=ltr] &',
        rtl: '&[dir=rtl], [dir=rtl] &',
    },
};

const mergeThemeOptions = {
    isMergeableObject: n => {
        return !!n && typeof n === 'object';
    },
    arrayMerge: (target, source) => source,
};
const mergeConfig = (target, source, options) => {
    const { preflight: targetPreflight = ``, ...targetRest } = target;
    const { preflight: sourcePreflight = ``, ...sourceRest } = source;
    return cjs_default()({
        preflight: `${targetPreflight} ${sourcePreflight}`,
        ...targetRest,
    }, sourceRest, options || mergeThemeOptions);
};

const createConfig = (theme) => {
    const { preflight, ...rest } = mergeConfig(baseConfig, theme || {});
    const twindConfig = {
        preflight: twindPreflight => {
            return css/* css */.iv `
        ${twindPreflight}
        ${preflight}
      `;
        },
        ...rest,
    };
    return twindConfig;
};

const twindConfig = createConfig();


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ../node_modules/@twind/typography/typography.js
var typography_i=t=>t.toFixed(7).replace(/(\.\d+?)0+$/,"$1").replace(/\.0$/,""),typography_r=t=>`${typography_i(t/16)}rem`,typography_o=(t,n)=>`${typography_i(t/n)}em`,typography_h=({theme:t,tag:n})=>({DEFAULT:{css:[{color:t("colors",["gray","700"]),maxWidth:"65ch",[`[class~="${n("lead")}"]`]:{color:t("colors",["gray","600"])},a:{color:t("colors",["gray","900"]),textDecoration:"underline",fontWeight:"500"},strong:{color:t("colors",["gray","900"]),fontWeight:"600"},ol:{counterReset:"list-counter"},"ol > li":{position:"relative",counterIncrement:"list-counter"},"ol > li::before":{content:'counter(list-counter) "."',position:"absolute",fontWeight:"400",color:t("colors",["gray","500"])},"ul > li":{position:"relative"},"ul > li::before":{content:'""',position:"absolute",backgroundColor:t("colors",["gray","300"]),borderRadius:"50%"},hr:{borderColor:t("colors",["gray","200"]),borderTopWidth:"1"},blockquote:{fontWeight:"500",fontStyle:"italic",color:t("colors",["gray","900"]),borderLeftWidth:"0.25rem",borderLeftColor:t("colors",["gray","200"]),quotes:'"\\201C""\\201D""\\2018""\\2019"'},"blockquote p:first-of-type::before":{content:"open-quote"},"blockquote p:last-of-type::after":{content:"close-quote"},h1:{color:t("colors",["gray","900"]),fontWeight:"800"},h2:{color:t("colors",["gray","900"]),fontWeight:"700"},h3:{color:t("colors",["gray","900"]),fontWeight:"600"},h4:{color:t("colors",["gray","900"]),fontWeight:"600"},"figure figcaption":{color:t("colors",["gray","500"])},code:{color:t("colors",["gray","900"]),fontWeight:"600"},"code::before":{content:'"`"'},"code::after":{content:'"`"'},"a code":{color:t("colors",["gray","900"])},pre:{color:t("colors",["gray","200"]),backgroundColor:t("colors",["gray","800"]),overflowX:"auto"},"pre code":{backgroundColor:"transparent",borderWidth:"0",borderRadius:"0",padding:"0",fontWeight:"400",color:"inherit",fontSize:"inherit",fontFamily:"inherit",lineHeight:"inherit"},"pre code::before":{content:'""'},"pre code::after":{content:'""'},table:{width:"100%",tableLayout:"auto",textAlign:"left",marginTop:typography_o(32,16),marginBottom:typography_o(32,16)},thead:{color:t("colors",["gray","900"]),fontWeight:"600",borderBottomWidth:"1px",borderBottomColor:t("colors",["gray","300"])},"thead th":{verticalAlign:"bottom"},"tbody tr":{borderBottomWidth:"1px",borderBottomColor:t("colors",["gray","200"])},"tbody tr:last-child":{borderBottomWidth:"0"},"tbody td":{verticalAlign:"top"}},{fontSize:typography_r(16),lineHeight:typography_i(28/16),p:{marginTop:typography_o(20,16),marginBottom:typography_o(20,16)},[`[class~="${n("lead")}"]`]:{fontSize:typography_o(20,16),lineHeight:typography_i(32/20),marginTop:typography_o(24,20),marginBottom:typography_o(24,20)},blockquote:{marginTop:typography_o(32,20),marginBottom:typography_o(32,20),paddingLeft:typography_o(20,20)},h1:{fontSize:typography_o(36,16),marginTop:"0",marginBottom:typography_o(32,36),lineHeight:typography_i(40/36)},h2:{fontSize:typography_o(24,16),marginTop:typography_o(48,24),marginBottom:typography_o(24,24),lineHeight:typography_i(32/24)},h3:{fontSize:typography_o(20,16),marginTop:typography_o(32,20),marginBottom:typography_o(12,20),lineHeight:typography_i(32/20)},h4:{marginTop:typography_o(24,16),marginBottom:typography_o(8,16),lineHeight:typography_i(24/16)},img:{marginTop:typography_o(32,16),marginBottom:typography_o(32,16)},video:{marginTop:typography_o(32,16),marginBottom:typography_o(32,16)},figure:{marginTop:typography_o(32,16),marginBottom:typography_o(32,16)},"figure > *":{marginTop:"0",marginBottom:"0"},"figure figcaption":{fontSize:typography_o(14,16),lineHeight:typography_i(20/14),marginTop:typography_o(12,14)},code:{fontSize:typography_o(14,16)},"h2 code":{fontSize:typography_o(21,24)},"h3 code":{fontSize:typography_o(18,20)},pre:{fontSize:typography_o(14,16),lineHeight:typography_i(24/14),marginTop:typography_o(24,14),marginBottom:typography_o(24,14),borderRadius:typography_r(6),paddingTop:typography_o(12,14),paddingRight:typography_o(16,14),paddingBottom:typography_o(12,14),paddingLeft:typography_o(16,14)},ol:{marginTop:typography_o(20,16),marginBottom:typography_o(20,16)},ul:{marginTop:typography_o(20,16),marginBottom:typography_o(20,16)},li:{marginTop:typography_o(8,16),marginBottom:typography_o(8,16)},"ol > li":{paddingLeft:typography_o(28,16)},"ol > li::before":{left:"0"},"ul > li":{paddingLeft:typography_o(28,16)},"ul > li::before":{width:typography_o(6,16),height:typography_o(6,16),top:`calc(${typography_o(28/2,16)} - ${typography_o(3,16)})`,left:typography_o(4,16)},"> ul > li p":{marginTop:typography_o(12,16),marginBottom:typography_o(12,16)},"> ul > li > *:first-child":{marginTop:typography_o(20,16)},"> ul > li > *:last-child":{marginBottom:typography_o(20,16)},"> ol > li > *:first-child":{marginTop:typography_o(20,16)},"> ol > li > *:last-child":{marginBottom:typography_o(20,16)},"ul ul, ul ol, ol ul, ol ol":{marginTop:typography_o(12,16),marginBottom:typography_o(12,16)},hr:{marginTop:typography_o(48,16),marginBottom:typography_o(48,16)},"hr + *":{marginTop:"0"},"h2 + *":{marginTop:"0"},"h3 + *":{marginTop:"0"},"h4 + *":{marginTop:"0"},table:{fontSize:typography_o(14,16),lineHeight:typography_i(24/14)},"thead th":{paddingRight:typography_o(8,14),paddingBottom:typography_o(8,14),paddingLeft:typography_o(8,14)},"thead th:first-child":{paddingLeft:"0"},"thead th:last-child":{paddingRight:"0"},"tbody td":{paddingTop:typography_o(8,14),paddingRight:typography_o(8,14),paddingBottom:typography_o(8,14),paddingLeft:typography_o(8,14)},"tbody td:first-child":{paddingLeft:"0"},"tbody td:last-child":{paddingRight:"0"}},{"> :first-child":{marginTop:"0"},"> :last-child":{marginBottom:"0"}}]},sm:{css:[{fontSize:typography_r(14),lineHeight:typography_i(24/14),p:{marginTop:typography_o(16,14),marginBottom:typography_o(16,14)},[`[class~="${n("lead")}"]`]:{fontSize:typography_o(18,14),lineHeight:typography_i(28/18),marginTop:typography_o(16,18),marginBottom:typography_o(16,18)},blockquote:{marginTop:typography_o(24,18),marginBottom:typography_o(24,18),paddingLeft:typography_o(20,18)},h1:{fontSize:typography_o(30,14),marginTop:"0",marginBottom:typography_o(24,30),lineHeight:typography_i(36/30)},h2:{fontSize:typography_o(20,14),marginTop:typography_o(32,20),marginBottom:typography_o(16,20),lineHeight:typography_i(28/20)},h3:{fontSize:typography_o(18,14),marginTop:typography_o(28,18),marginBottom:typography_o(8,18),lineHeight:typography_i(28/18)},h4:{marginTop:typography_o(20,14),marginBottom:typography_o(8,14),lineHeight:typography_i(20/14)},img:{marginTop:typography_o(24,14),marginBottom:typography_o(24,14)},video:{marginTop:typography_o(24,14),marginBottom:typography_o(24,14)},figure:{marginTop:typography_o(24,14),marginBottom:typography_o(24,14)},"figure > *":{marginTop:"0",marginBottom:"0"},"figure figcaption":{fontSize:typography_o(12,14),lineHeight:typography_i(16/12),marginTop:typography_o(8,12)},code:{fontSize:typography_o(12,14)},"h2 code":{fontSize:typography_o(18,20)},"h3 code":{fontSize:typography_o(16,18)},pre:{fontSize:typography_o(12,14),lineHeight:typography_i(20/12),marginTop:typography_o(20,12),marginBottom:typography_o(20,12),borderRadius:typography_r(4),paddingTop:typography_o(8,12),paddingRight:typography_o(12,12),paddingBottom:typography_o(8,12),paddingLeft:typography_o(12,12)},ol:{marginTop:typography_o(16,14),marginBottom:typography_o(16,14)},ul:{marginTop:typography_o(16,14),marginBottom:typography_o(16,14)},li:{marginTop:typography_o(4,14),marginBottom:typography_o(4,14)},"ol > li":{paddingLeft:typography_o(22,14)},"ol > li::before":{left:"0"},"ul > li":{paddingLeft:typography_o(22,14)},"ul > li::before":{height:typography_o(5,14),width:typography_o(5,14),top:`calc(${typography_o(24/2,14)} - ${typography_o(2.5,14)})`,left:typography_o(3,14)},"> ul > li p":{marginTop:typography_o(8,14),marginBottom:typography_o(8,14)},"> ul > li > *:first-child":{marginTop:typography_o(16,14)},"> ul > li > *:last-child":{marginBottom:typography_o(16,14)},"> ol > li > *:first-child":{marginTop:typography_o(16,14)},"> ol > li > *:last-child":{marginBottom:typography_o(16,14)},"ul ul, ul ol, ol ul, ol ol":{marginTop:typography_o(8,14),marginBottom:typography_o(8,14)},hr:{marginTop:typography_o(40,14),marginBottom:typography_o(40,14)},"hr + *":{marginTop:"0"},"h2 + *":{marginTop:"0"},"h3 + *":{marginTop:"0"},"h4 + *":{marginTop:"0"},table:{fontSize:typography_o(12,14),lineHeight:typography_i(18/12)},"thead th":{paddingRight:typography_o(12,12),paddingBottom:typography_o(8,12),paddingLeft:typography_o(12,12)},"thead th:first-child":{paddingLeft:"0"},"thead th:last-child":{paddingRight:"0"},"tbody td":{paddingTop:typography_o(8,12),paddingRight:typography_o(12,12),paddingBottom:typography_o(8,12),paddingLeft:typography_o(12,12)},"tbody td:first-child":{paddingLeft:"0"},"tbody td:last-child":{paddingRight:"0"}},{"> :first-child":{marginTop:"0"},"> :last-child":{marginBottom:"0"}}]},lg:{css:[{fontSize:typography_r(18),lineHeight:typography_i(32/18),p:{marginTop:typography_o(24,18),marginBottom:typography_o(24,18)},[`[class~="${n("lead")}"]`]:{fontSize:typography_o(22,18),lineHeight:typography_i(32/22),marginTop:typography_o(24,22),marginBottom:typography_o(24,22)},blockquote:{marginTop:typography_o(40,24),marginBottom:typography_o(40,24),paddingLeft:typography_o(24,24)},h1:{fontSize:typography_o(48,18),marginTop:"0",marginBottom:typography_o(40,48),lineHeight:typography_i(48/48)},h2:{fontSize:typography_o(30,18),marginTop:typography_o(56,30),marginBottom:typography_o(32,30),lineHeight:typography_i(40/30)},h3:{fontSize:typography_o(24,18),marginTop:typography_o(40,24),marginBottom:typography_o(16,24),lineHeight:typography_i(36/24)},h4:{marginTop:typography_o(32,18),marginBottom:typography_o(8,18),lineHeight:typography_i(28/18)},img:{marginTop:typography_o(32,18),marginBottom:typography_o(32,18)},video:{marginTop:typography_o(32,18),marginBottom:typography_o(32,18)},figure:{marginTop:typography_o(32,18),marginBottom:typography_o(32,18)},"figure > *":{marginTop:"0",marginBottom:"0"},"figure figcaption":{fontSize:typography_o(16,18),lineHeight:typography_i(24/16),marginTop:typography_o(16,16)},code:{fontSize:typography_o(16,18)},"h2 code":{fontSize:typography_o(26,30)},"h3 code":{fontSize:typography_o(21,24)},pre:{fontSize:typography_o(16,18),lineHeight:typography_i(28/16),marginTop:typography_o(32,16),marginBottom:typography_o(32,16),borderRadius:typography_r(6),paddingTop:typography_o(16,16),paddingRight:typography_o(24,16),paddingBottom:typography_o(16,16),paddingLeft:typography_o(24,16)},ol:{marginTop:typography_o(24,18),marginBottom:typography_o(24,18)},ul:{marginTop:typography_o(24,18),marginBottom:typography_o(24,18)},li:{marginTop:typography_o(12,18),marginBottom:typography_o(12,18)},"ol > li":{paddingLeft:typography_o(30,18)},"ol > li::before":{left:"0"},"ul > li":{paddingLeft:typography_o(30,18)},"ul > li::before":{width:typography_o(6,18),height:typography_o(6,18),top:`calc(${typography_o(32/2,18)} - ${typography_o(3,18)})`,left:typography_o(4,18)},"> ul > li p":{marginTop:typography_o(16,18),marginBottom:typography_o(16,18)},"> ul > li > *:first-child":{marginTop:typography_o(24,18)},"> ul > li > *:last-child":{marginBottom:typography_o(24,18)},"> ol > li > *:first-child":{marginTop:typography_o(24,18)},"> ol > li > *:last-child":{marginBottom:typography_o(24,18)},"ul ul, ul ol, ol ul, ol ol":{marginTop:typography_o(16,18),marginBottom:typography_o(16,18)},hr:{marginTop:typography_o(56,18),marginBottom:typography_o(56,18)},"hr + *":{marginTop:"0"},"h2 + *":{marginTop:"0"},"h3 + *":{marginTop:"0"},"h4 + *":{marginTop:"0"},table:{fontSize:typography_o(16,18),lineHeight:typography_i(24/16)},"thead th":{paddingRight:typography_o(12,16),paddingBottom:typography_o(12,16),paddingLeft:typography_o(12,16)},"thead th:first-child":{paddingLeft:"0"},"thead th:last-child":{paddingRight:"0"},"tbody td":{paddingTop:typography_o(12,16),paddingRight:typography_o(12,16),paddingBottom:typography_o(12,16),paddingLeft:typography_o(12,16)},"tbody td:first-child":{paddingLeft:"0"},"tbody td:last-child":{paddingRight:"0"}},{"> :first-child":{marginTop:"0"},"> :last-child":{marginBottom:"0"}}]},xl:{css:[{fontSize:typography_r(20),lineHeight:typography_i(36/20),p:{marginTop:typography_o(24,20),marginBottom:typography_o(24,20)},[`[class~="${n("lead")}"]`]:{fontSize:typography_o(24,20),lineHeight:typography_i(36/24),marginTop:typography_o(24,24),marginBottom:typography_o(24,24)},blockquote:{marginTop:typography_o(48,30),marginBottom:typography_o(48,30),paddingLeft:typography_o(32,30)},h1:{fontSize:typography_o(56,20),marginTop:"0",marginBottom:typography_o(48,56),lineHeight:typography_i(56/56)},h2:{fontSize:typography_o(36,20),marginTop:typography_o(56,36),marginBottom:typography_o(32,36),lineHeight:typography_i(40/36)},h3:{fontSize:typography_o(30,20),marginTop:typography_o(48,30),marginBottom:typography_o(20,30),lineHeight:typography_i(40/30)},h4:{marginTop:typography_o(36,20),marginBottom:typography_o(12,20),lineHeight:typography_i(32/20)},img:{marginTop:typography_o(40,20),marginBottom:typography_o(40,20)},video:{marginTop:typography_o(40,20),marginBottom:typography_o(40,20)},figure:{marginTop:typography_o(40,20),marginBottom:typography_o(40,20)},"figure > *":{marginTop:"0",marginBottom:"0"},"figure figcaption":{fontSize:typography_o(18,20),lineHeight:typography_i(28/18),marginTop:typography_o(18,18)},code:{fontSize:typography_o(18,20)},"h2 code":{fontSize:typography_o(31,36)},"h3 code":{fontSize:typography_o(27,30)},pre:{fontSize:typography_o(18,20),lineHeight:typography_i(32/18),marginTop:typography_o(36,18),marginBottom:typography_o(36,18),borderRadius:typography_r(8),paddingTop:typography_o(20,18),paddingRight:typography_o(24,18),paddingBottom:typography_o(20,18),paddingLeft:typography_o(24,18)},ol:{marginTop:typography_o(24,20),marginBottom:typography_o(24,20)},ul:{marginTop:typography_o(24,20),marginBottom:typography_o(24,20)},li:{marginTop:typography_o(12,20),marginBottom:typography_o(12,20)},"ol > li":{paddingLeft:typography_o(36,20)},"ol > li::before":{left:"0"},"ul > li":{paddingLeft:typography_o(36,20)},"ul > li::before":{width:typography_o(7,20),height:typography_o(7,20),top:`calc(${typography_o(36/2,20)} - ${typography_o(3.5,20)})`,left:typography_o(5,20)},"> ul > li p":{marginTop:typography_o(16,20),marginBottom:typography_o(16,20)},"> ul > li > *:first-child":{marginTop:typography_o(24,20)},"> ul > li > *:last-child":{marginBottom:typography_o(24,20)},"> ol > li > *:first-child":{marginTop:typography_o(24,20)},"> ol > li > *:last-child":{marginBottom:typography_o(24,20)},"ul ul, ul ol, ol ul, ol ol":{marginTop:typography_o(16,20),marginBottom:typography_o(16,20)},hr:{marginTop:typography_o(56,20),marginBottom:typography_o(56,20)},"hr + *":{marginTop:"0"},"h2 + *":{marginTop:"0"},"h3 + *":{marginTop:"0"},"h4 + *":{marginTop:"0"},table:{fontSize:typography_o(18,20),lineHeight:typography_i(28/18)},"thead th":{paddingRight:typography_o(12,18),paddingBottom:typography_o(16,18),paddingLeft:typography_o(12,18)},"thead th:first-child":{paddingLeft:"0"},"thead th:last-child":{paddingRight:"0"},"tbody td":{paddingTop:typography_o(16,18),paddingRight:typography_o(12,18),paddingBottom:typography_o(16,18),paddingLeft:typography_o(12,18)},"tbody td:first-child":{paddingLeft:"0"},"tbody td:last-child":{paddingRight:"0"}},{"> :first-child":{marginTop:"0"},"> :last-child":{marginBottom:"0"}}]},"2xl":{css:[{fontSize:typography_r(24),lineHeight:typography_i(40/24),p:{marginTop:typography_o(32,24),marginBottom:typography_o(32,24)},[`[class~="${n("lead")}"]`]:{fontSize:typography_o(30,24),lineHeight:typography_i(44/30),marginTop:typography_o(32,30),marginBottom:typography_o(32,30)},blockquote:{marginTop:typography_o(64,36),marginBottom:typography_o(64,36),paddingLeft:typography_o(40,36)},h1:{fontSize:typography_o(64,24),marginTop:"0",marginBottom:typography_o(56,64),lineHeight:typography_i(64/64)},h2:{fontSize:typography_o(48,24),marginTop:typography_o(72,48),marginBottom:typography_o(40,48),lineHeight:typography_i(52/48)},h3:{fontSize:typography_o(36,24),marginTop:typography_o(56,36),marginBottom:typography_o(24,36),lineHeight:typography_i(44/36)},h4:{marginTop:typography_o(40,24),marginBottom:typography_o(16,24),lineHeight:typography_i(36/24)},img:{marginTop:typography_o(48,24),marginBottom:typography_o(48,24)},video:{marginTop:typography_o(48,24),marginBottom:typography_o(48,24)},figure:{marginTop:typography_o(48,24),marginBottom:typography_o(48,24)},"figure > *":{marginTop:"0",marginBottom:"0"},"figure figcaption":{fontSize:typography_o(20,24),lineHeight:typography_i(32/20),marginTop:typography_o(20,20)},code:{fontSize:typography_o(20,24)},"h2 code":{fontSize:typography_o(42,48)},"h3 code":{fontSize:typography_o(32,36)},pre:{fontSize:typography_o(20,24),lineHeight:typography_i(36/20),marginTop:typography_o(40,20),marginBottom:typography_o(40,20),borderRadius:typography_r(8),paddingTop:typography_o(24,20),paddingRight:typography_o(32,20),paddingBottom:typography_o(24,20),paddingLeft:typography_o(32,20)},ol:{marginTop:typography_o(32,24),marginBottom:typography_o(32,24)},ul:{marginTop:typography_o(32,24),marginBottom:typography_o(32,24)},li:{marginTop:typography_o(12,24),marginBottom:typography_o(12,24)},"ol > li":{paddingLeft:typography_o(40,24)},"ol > li::before":{left:"0"},"ul > li":{paddingLeft:typography_o(40,24)},"ul > li::before":{width:typography_o(8,24),height:typography_o(8,24),top:`calc(${typography_o(40/2,24)} - ${typography_o(4,24)})`,left:typography_o(6,24)},"> ul > li p":{marginTop:typography_o(20,24),marginBottom:typography_o(20,24)},"> ul > li > *:first-child":{marginTop:typography_o(32,24)},"> ul > li > *:last-child":{marginBottom:typography_o(32,24)},"> ol > li > *:first-child":{marginTop:typography_o(32,24)},"> ol > li > *:last-child":{marginBottom:typography_o(32,24)},"ul ul, ul ol, ol ul, ol ol":{marginTop:typography_o(16,24),marginBottom:typography_o(16,24)},hr:{marginTop:typography_o(72,24),marginBottom:typography_o(72,24)},"hr + *":{marginTop:"0"},"h2 + *":{marginTop:"0"},"h3 + *":{marginTop:"0"},"h4 + *":{marginTop:"0"},table:{fontSize:typography_o(20,24),lineHeight:typography_i(28/20)},"thead th":{paddingRight:typography_o(12,20),paddingBottom:typography_o(16,20),paddingLeft:typography_o(12,20)},"thead th:first-child":{paddingLeft:"0"},"thead th:last-child":{paddingRight:"0"},"tbody td":{paddingTop:typography_o(16,20),paddingRight:typography_o(12,20),paddingBottom:typography_o(16,20),paddingLeft:typography_o(12,20)},"tbody td:first-child":{paddingLeft:"0"},"tbody td:last-child":{paddingRight:"0"}},{"> :first-child":{marginTop:"0"},"> :last-child":{marginBottom:"0"}}]}});var typography_s=({className:t="prose"}={})=>({lead:(n,{tag:g})=>g("lead"),[t]:(n,g)=>{let e=g.theme("colors",[n[0],"600"],"");if(e)return{"& a":{color:e},"& a code":{color:e}};let f=typography_h(g),{css:m}=f[n[0]||"DEFAULT"]||{};if(m){let d={};return m.forEach(p=>Object.keys(p).forEach(l=>{let a=p[l],c=a!=null&&typeof a=="object"&&!Array.isArray(a)?`& ${l}`:l;d[c]=a})),d}}}),typography_T=typography_s;
//# sourceMappingURL=typography.js.map

;// CONCATENATED MODULE: ./ui/animations/button.ts
/**
 * An animation where the button appears from off the
 * left hand side of the screen, moving in with a slight
 * slant which straightens up at the end of the buttons
 * travel
 */ var attentionButtonAppearAnimation = function() {
    return "\n    @keyframes attention-button-appear {\n      0% { left: -100%; transform: skew(14deg); }\n      80% { left: 0; transform: skew(14deg); }\n      100% { left: 0; transform: skew(0deg); }\n    }\n\n    animation: attention-button-appear 0.65s;\n    animation-timing-function: ease-out;\n    animation-fill-mode: forwards;\n    transform-origin: bottom;\n    transition: transform 0.4s, left 0.4s;\n    will-change: transform;\n  ";
};
/**
 * Creates a border edge which will start off out of view
 * and slide in sequentially with the others, giving the
 * effect of drawing a thicker border around the button
 * starting top-right and drawing anti-clockwise, then
 * reversing, and repeating until the 6th time when the
 * thicker border remains
 *
 */ var attentionButtonBorderAnimation = function(borderSide, type) {
    var thickness = 2;
    var offset = 2;
    var direction = "";
    var width = "calc(100% + ".concat(thickness, "px)");
    var height = "calc(100% + ".concat(thickness, "px)");
    var frames = [];
    switch(borderSide){
        case "top":
            {
                direction = "left";
                height = "".concat(thickness, "px");
                frames = [
                    15,
                    20,
                    50,
                    55
                ];
                break;
            }
        case "right":
            {
                direction = "top";
                width = "".concat(thickness, "px");
                frames = [
                    0,
                    5,
                    65,
                    70
                ];
                break;
            }
        case "bottom":
            {
                direction = "right";
                height = "".concat(thickness, "px");
                frames = [
                    5,
                    10,
                    60,
                    65
                ];
                break;
            }
        case "left":
            {
                direction = "bottom";
                width = "".concat(thickness, "px");
                frames = [
                    10,
                    15,
                    55,
                    60
                ];
                break;
            }
    }
    var outOfView = "calc(calc(100% + ".concat(thickness * 2, "px) * -1)");
    var inView = "-".concat(offset, "px");
    return "\n    clip-path: polygon(-".concat(offset, "px -").concat(offset, "px, -").concat(offset, "px calc(100% + ").concat(offset, "px), calc(100% + ").concat(offset, "px) calc(100% + ").concat(offset, "px), calc(100% + ").concat(offset, "px) -").concat(offset, "px);\n    @keyframes attention-button-").concat(borderSide, "-border {\n      ").concat(frames[0], "% { ").concat(direction, ": ").concat(outOfView, "; }\n      ").concat(frames[1], "% { ").concat(direction, ": ").concat(inView, "; }\n      ").concat(frames[2], "% { ").concat(direction, ": ").concat(inView, "; }\n      ").concat(frames[3], "% { ").concat(direction, ": ").concat(outOfView, "; }\n    }\n    &::").concat(type, " {\n      content: '';\n      position: absolute;\n      ").concat(borderSide, ": ").concat(inView, ";\n      ").concat(direction, ": ").concat(outOfView, ";\n      width: ").concat(width, ";\n      height: ").concat(height, ";\n      background-color: black;\n      animation: attention-button-").concat(borderSide, "-border 10s infinite;\n      animation-fill-mode: forwards;\n      animation-iteration-count: 5.5;\n      animation-delay: 2s;\n    }\n  ");
};

;// CONCATENATED MODULE: ./twind.config.ts



function twind_config_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        > li a {\n          ",
        "\n        }\n        > li:hover a {\n          ",
        "\n        }\n      "
    ]);
    twind_config_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function twind_config_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        position: relative;\n        &::after {\n          content: '';\n          ",
        "\n        }\n      "
    ]);
    twind_config_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function twind_config_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        position: relative;\n        &::after {\n          content: '';\n          ",
        "\n        }\n      "
    ]);
    twind_config_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function twind_config_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        text-align: inherit;\n      "
    ]);
    twind_config_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function twind_config_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        ul li {\n          padding-left: 0;\n          list-style-type: disc;\n        }\n        ol li {\n          padding-left: 0;\n          list-style-type: decimal;\n        }\n        ul,\n        ol {\n          margin-left: 1rem;\n        }\n      "
    ]);
    twind_config_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function twind_config_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        a {\n          text-decoration: underline;\n        }\n      "
    ]);
    twind_config_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function twind_config_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        text-decoration: underline;\n        text-decoration-thickness: 2px;\n        text-underline-offset: 2px;\n      "
    ]);
    twind_config_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        ",
        "\n      "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        ",
        "\n        ",
        "\n      "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        ",
        "\n        ",
        "\n      "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      scroll-snap-type: ",
        " mandatory;\n      > * {\n        scroll-snap-align: ",
        ";\n      }\n    "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      column-count: ",
        ";\n    "
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}




var twind_config_twindConfig = createConfig({
    mode: "silent",
    preflight: "\n\n    main,\n    dialog {\n      @apply bg-white;\n    }\n\n    body {\n      @apply text-neutral-100 bg-white;\n    }\n\n    body:not(.focus-visible) * {\n      outline: none !important;\n    }\n\n    .focus-visible :focus {\n      outline: none !important;\n      @apply ring-gray-500 ring-2 rounded-sm;\n    }\n\n    .focus-visible input:focus + [data-type='check-btn'] {\n      @apply ring-gray-500 ring-2 ring-opacity-90;\n    }\n\n    .focus-visible input:focus + [data-type='radio-btn'] {\n      @apply ring-gray-500 ring-2 ring-opacity-90;\n    }\n\n    .focus-visible [data-test-id='dropdown-select'] {\n      @apply focus-within:ring-2 ring-gray-500;\n    }\n\n    .focus-visible input:focus,\n    .focus-visible textarea:focus {\n      outline: none !important;\n      @apply ring-gray-500 ring-2 rounded-sm;\n    }\n\n    .fc-confirm-order a {\n      text-decoration: underline;\n    }\n\n    #ada-button-frame {\n      display: none;\n   }\n\n   /* Branch.io iframe z-index control */\n   iframe[id^=\"branch-banner-iframe\"] {\n     z-index: 70 !important;\n   }\n\n   /* Chatbot widget z-index control */\n   #fc_frame,\n   #fc_frame.fc-widget-small {\n     z-index: 10 !important;\n   }\n   iframe#fc_widget {\n     z-index: 10 !important;\n   }\n\n   /* OneTrust cookie banner z-index control */\n   #onetrust-banner-sdk.otFlat {\n     z-index: 90 !important;\n   }\n\n   /* Qualtrics feedback widget z-index control */\n  .QSIFeedbackButton {\n   z-index: 30 !important;\n  }\n\n   /* Styles for hiding scrollbar */\n    .hide-scrollbar::-webkit-scrollbar {\n      display: none;\n    }\n    .hide-scrollbar {\n      -ms-overflow-style: none;  /* IE and Edge */\n      scrollbar-width: none;  /* Firefox */\n    }\n  ",
    theme: {
        extend: {
            spacing: {
                em: "1em",
                rem: "1rem",
                "128": "32rem"
            },
            colors: {
                puma: {
                    silver: "#999999",
                    gold: "#8A7350",
                    "gold-light": "#A3885F",
                    green: "#008626",
                    gray: {
                        DEFAULT: "#A1A8AF",
                        "20": "#F6F7F8",
                        "60": "#676D75"
                    },
                    "gray-light": "#BABABA",
                    red: "#ba2b20",
                    black: {
                        DEFAULT: "#181818",
                        "50": "#000000",
                        "100": "#181818",
                        "200": "#444444",
                        "300": "#6C6C6C",
                        "350": "#8c9198",
                        "400": "#999999",
                        "500": "#CCCCCC",
                        "600": "#E5E7EB",
                        "700": "#EEEEEE",
                        "800": "#FAFAFA",
                        "900": "#FFFFFF"
                    }
                },
                swatch: {
                    black: "#333",
                    gray: "#9CA3AF",
                    metallic: "#D1D5DB",
                    brown: "#795548",
                    blue: "#1976D2",
                    green: "#4CAF50",
                    orange: "#FB8C00",
                    tan: "#D2B48C",
                    beige: "#D2B48C",
                    yellow: "#FFEA00",
                    red: "#E53935",
                    white: "#FFF",
                    pink: "#F8BBD0",
                    purple: "#8E24AA",
                    silver: "#c0c0c0",
                    gold: "#cd9a01",
                    other: "#cccccc"
                }
            }
        }
    },
    plugins: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        "nav-fade-non-selected": function() {
            return (0,css/* css */.iv)(twind_config_templateObject(), (0,css/* apply */.nn)("opacity-50"), (0,css/* apply */.nn)("opacity-100"));
        },
        "nav-underline": function() {
            return (0,css/* css */.iv)(twind_config_templateObject1(), (0,css/* apply */.nn)("transition transform-gpu block absolute left-0 bottom-0 w-full h-0.5 bg-puma-gold", "opacity-0 translate-y-1"));
        },
        "nav-underline-selected": function() {
            return (0,css/* css */.iv)(twind_config_templateObject2(), (0,css/* apply */.nn)("opacity-100 -translate-y-0"));
        },
        "text-inherit": function() {
            return (0,css/* css */.iv)(twind_config_templateObject3());
        },
        "cms-list-styles": function() {
            return (0,css/* css */.iv)(twind_config_templateObject4());
        },
        "cms-link-styles": function() {
            return (0,css/* css */.iv)(twind_config_templateObject5());
        },
        "link-underline": function() {
            return (0,css/* css */.iv)(twind_config_templateObject6());
        },
        "signup-button-appear": function() {
            return (0,css/* css */.iv)(_templateObject7(), attentionButtonAppearAnimation());
        },
        "signup-button-outer": function() {
            return (0,css/* css */.iv)(_templateObject8(), attentionButtonBorderAnimation("top", "before"), attentionButtonBorderAnimation("bottom", "after"));
        },
        "signup-button-inner": function() {
            return (0,css/* css */.iv)(_templateObject9(), attentionButtonBorderAnimation("left", "before"), attentionButtonBorderAnimation("right", "after"));
        }
    }, typography_T({
        className: "prose"
    })), {
        aspect: function(parts) {
            return {
                "aspect-ratio": "".concat(parts[0], " / ").concat(parts[1])
            };
        },
        "scroll-snap": function(parts) {
            return (0,css/* css */.iv)(_templateObject10(), parts[0] || "x", parts[1] || "start");
        },
        "column-count": function(parts) {
            return (0,css/* css */.iv)(_templateObject11(), parts[0]);
        }
    })
});
/* harmony default export */ var twind_config = (twind_config_twindConfig);

;// CONCATENATED MODULE: ./utils/environment/isDevelopmentEnv/isDevelopmentEnv.ts
var isDevelopmentEnv = function(env) {
    return env.STAGE === "development";
};

;// CONCATENATED MODULE: ./utils/environment/isPerformanceEnv/isPerformanceEnv.ts
/**
 * Returns whether or not the current environment is the perf environment.
 * Extracted to a util to simplify testing but also to isolate for later
 * improvement as, honestly, checking the sanityDataset does not feel like
 * a super-robust solution. It was just all I could find.
 *
 */ var isPerformanceEnv = function(env) {
    return env.sanityDataset === "performance";
};

;// CONCATENATED MODULE: ./pages/_app.tsx
/* provided dependency */ var _app_process = __webpack_require__(27061);






























































var MinimalFooter = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6401).then(__webpack_require__.bind(__webpack_require__, 46401)).then(function(x) {
        return x.MinimalFooter;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(46401)
            ];
        }
    },
    ssr: false
});
var ContentManagementToolbox = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7246).then(__webpack_require__.bind(__webpack_require__, 27246));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(27246)
            ];
        }
    },
    ssr: false
});
var PickUpWhereYouLeftOff = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 8234).then(__webpack_require__.bind(__webpack_require__, 78234)).then(function(x) {
        return x.PickUpWhereYouLeftOff;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(78234)
            ];
        }
    },
    ssr: false
});
var CookieBanner = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9948).then(__webpack_require__.bind(__webpack_require__, 79948));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(79948)
            ];
        }
    },
    ssr: false
});
var LocationCheck = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1939).then(__webpack_require__.bind(__webpack_require__, 81939));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(81939)
            ];
        }
    },
    ssr: false
});
if (false) {}
function PumaApp(param) {
    var Component = param.Component, pageProps = param.pageProps, locale = param.locale, language = param.language, country = param.country, siteConfig = param.siteConfig, resources = param.resources, host = param.host, mainNavQuery = param.mainNavQuery, resetUrqlClient = param.resetUrqlClient, isCrawler = param.isCrawler;
    var ref, ref1;
    var router = (0,next_router.useRouter)();
    var _$isServer = (0,useIsServer/* useIsServer */.w)();
    var ref2 = (0,_sliced_to_array/* default */.Z)(router.asPath.split("?"), 2), pathname = ref2[0], queryString = ref2[1];
    var qs = new URLSearchParams(queryString);
    var requestSource = qs.get("requestSource");
    // --------------------------------------------------------------------
    // Application updates
    // --------------------------------------------------------------------
    // If the user leaves the site then comes back to the site using their
    // back button in the browser then clientside JS is not re-executed so we
    // need to force a page reload to bootstrap the app again
    (0,react.useEffect)(function() {
        var handler = function(event) {
            return event.persisted && window.location.reload();
        };
        window === null || window === void 0 ? void 0 : window.addEventListener("pageshow", handler);
        return function() {
            return window === null || window === void 0 ? void 0 : window.removeEventListener("pageshow", handler);
        };
    }, []);
    // Check to see if there are any new updates to be run on the client browser
    // This should be done as early as possible in case data needs to be altered
    // or updated in a way which the rest of the app expects
    (0,react.useEffect)(function() {
        var shouldReload = runUpdates();
        if (!_$isServer && shouldReload) window.location.reload();
    }, [
        _$isServer
    ]);
    // --------------------------------------------------------------------
    // Auth state & shopping cart
    // --------------------------------------------------------------------
    var ref3 = (0,react.useState)(function() {
        return (0,cookie/* getStoredAuthData */.ir)();
    }), auth = ref3[0], setAuth = ref3[1];
    useCancelCustomerOrder(auth.customerId);
    (0,react.useEffect)(function() {
        // Triggered after setting cookies in response to initial guestLogon, login, register or logout
        var onTokenChanged = function() {
            return setAuth((0,cookie/* getStoredAuthData */.ir)());
        };
        authEventEmitter/* authEventEmitter.on */.c.on("token-changed", onTokenChanged);
        return function() {
            return authEventEmitter/* authEventEmitter.off */.c.off("token-changed", onTokenChanged);
        };
    }, []);
    // Reset the urql client (and cache) if the customer ID changes
    // This occurs on login, register, logout
    var ref4 = (0,react.useState)(), prevCustomerId = ref4[0], setPrevCustomerId = ref4[1];
    (0,react.useEffect)(function() {
        if (prevCustomerId && auth.customerId && prevCustomerId !== auth.customerId && resetUrqlClient) {
            resetUrqlClient();
        }
        setPrevCustomerId(auth.customerId);
    // We only want to re-run this if the customerId changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        auth.customerId,
        resetUrqlClient
    ]);
    // --------------------------------------------------------------------
    // Site config
    // --------------------------------------------------------------------
    var ref5 = (0,react.useState)(function() {
        // Since "getInitialProps" only runs on the server once, siteConfig will be undefined
        // on subsequent client side transition. (See next js docs on how getInitialProps work).
        // We must capture the siteConfig in the first render in a state / closure.
        // That will be our single source of truth for the lifecycle of the app.
        // What implications does that have?
        // Never use siteConfig in _app directly. That siteConfig will be undefined on the next
        // client side routing. Use siteContext always.
        var selectFeatureFlagsEnabled = function(featureFlags) {
            return Object.entries(featureFlags).filter(function(param) {
                var _param = (0,_sliced_to_array/* default */.Z)(param, 2), _ = _param[0], enabled = _param[1];
                return Boolean(enabled);
            }).flatMap(function(flag) {
                return flag[0].replace(/Enabled/, "");
            });
        };
        var localizedUrl = (0,utils_locale/* getUrlFromLocale */.bH)(locale);
        if (!_$isServer) {
            window.sessionStorage.setItem("analyticsReleaseVersion", siteConfig === null || siteConfig === void 0 ? void 0 : siteConfig.analytics.releaseVersion);
        }
        var localizeUrlPath = function(originalPath, absolute) {
            var path = originalPath.replace(/^\//, ""); // Remove leading slash
            var localizedPath = path ? "".concat(localizedUrl, "/").concat(path) : localizedUrl;
            if (absolute) {
                var hostPrefix = host.startsWith("localhost") ? "http://" : "https://";
                var absoluteHost = "".concat(hostPrefix).concat(host);
                return "".concat(absoluteHost).concat(localizedPath);
            } else {
                return localizedPath;
            }
        };
        var isLocalizedFeatureFlagEnabledClient = function(flag) {
            var ref, ref1;
            var currentLocale = locale;
            var namespace = siteConfig.env.NAMESPACE ? "".concat(siteConfig.env.NAMESPACE, "-") : "";
            var currentEnv = namespace.includes("pr-") ? "PullRequestEnvironment" : "".concat(namespace).concat(siteConfig.env.STAGE);
            return Boolean((ref = featureFlags_namespaceObject[currentEnv]) === null || ref === void 0 ? void 0 : (ref1 = ref[currentLocale]) === null || ref1 === void 0 ? void 0 : ref1[flag]);
        };
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, siteConfig), {
            locale: locale,
            country: country,
            host: host,
            language: language,
            localizeUrlPath: localizeUrlPath,
            localizeDate: function(date) {
                return new Date(date).toLocaleDateString(locale);
            },
            selectFeatureFlagsEnabled: selectFeatureFlagsEnabled,
            isLocalizedFeatureFlagEnabled: isLocalizedFeatureFlagEnabledClient,
            localizedFeatureFlagsEnabled: getLocalizedFlagsEnabled(featureFlags_namespaceObject)
        });
    }), siteContext = ref5[0];
    // --------------------------------------------------------------------
    // Translations / text
    // --------------------------------------------------------------------
    // This callback is a curry of the getInitialTranslations function
    // which has an expensive but cacheable initial setup call
    // eslint-disable-next-line react-hooks/exhaustive-deps
    var t = (0,react.useCallback)((0,useTranslations/* getInitialTranslations */.Te)(resources), []);
    // --------------------------------------------------------------------
    // Nav links
    // --------------------------------------------------------------------
    var ref6 = (0,react.useState)(mainNavQuery), allNavLinks = ref6[0];
    var navLinks = allNavLinks === null || allNavLinks === void 0 ? void 0 : allNavLinks.mainNav;
    var mobileNavLinks = allNavLinks === null || allNavLinks === void 0 ? void 0 : allNavLinks.mobileOnly;
    // --------------------------------------------------------------------
    // Analytics
    // --------------------------------------------------------------------
    var didStartAnalytics = (0,react.useRef)(false);
    (0,react.useEffect)(function() {
        if (didStartAnalytics.current) return;
        didStartAnalytics.current = true;
        (0,analytics/* activateOptimize */.Du)();
    // We only want to re-run this effect when the site starts
    }, [
        auth
    ]);
    // --------------------------------------------------------------------
    // Shopper context / source code promotions
    // --------------------------------------------------------------------
    var ref7 = (0,react.useState)(false), sourceCodeSetInContext = ref7[0], setSourceCodeSetInContext = ref7[1];
    var ref8 = (0,_sliced_to_array/* default */.Z)((0,graphql/* useCreateShopperContextMutation */.m45)(), 2), createShopperContext = ref8[1];
    var sourceCode = qs.get("src");
    var hasSourceCodeInQuerystring = !!sourceCode;
    (0,react.useEffect)(function() {
        if (!hasSourceCodeInQuerystring || sourceCodeSetInContext) return;
        (0,_async_to_generator/* default */.Z)(function() {
            var _tmp;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _tmp = {};
                        return [
                            4,
                            createShopperContext((_tmp.input = {
                                sourceCode: sourceCode
                            }, _tmp))
                        ];
                    case 1:
                        _state.sent();
                        setSourceCodeSetInContext(true);
                        return [
                            2
                        ];
                }
            });
        })();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    // --------------------------------------------------------------------
    // Shopper context / ID.me Authentication
    // --------------------------------------------------------------------
    var idMeAuthenticationCode = qs.get("code");
    var ref9 = (0,react.useState)({}), toast = ref9[0], setToast = ref9[1];
    var ref10 = (0,_sliced_to_array/* default */.Z)((0,graphql/* useVerifyUserAffiliationsMutation */.Oa7)(), 2), verifyUserAffiliations = ref10[1];
    var idMeEnabled = !!((ref = siteContext.env) === null || ref === void 0 ? void 0 : ref.idMeClientId);
    // Verifies user's affiliations and updates shopper context accordingly
    (0,react.useEffect)(function() {
        if (!idMeEnabled || !idMeAuthenticationCode) return;
        else {
            (0,_async_to_generator/* default */.Z)(function() {
                var response, _tmp, ref, isSuccess, toastProps, _tmp1;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _tmp = {};
                            return [
                                4,
                                verifyUserAffiliations((_tmp.input = {
                                    authorizationCode: idMeAuthenticationCode
                                }, _tmp))
                            ];
                        case 1:
                            response = _state.sent();
                            _tmp1 = {};
                            if (response.data) {
                                ;
                                isSuccess = !!((ref = response.data.verifyUserAffiliations) === null || ref === void 0 ? void 0 : ref.verified);
                                toastProps = (_tmp1.title = isSuccess ? t("congratulations") : t("uhoh"), _tmp1.description = isSuccess ? t("idMeSuccess") : t("idMeFailure"), _tmp1.variant = isSuccess ? "success" : "error", _tmp1.dataTestId = "idMeToastMessage", _tmp1);
                                setToast(toastProps);
                            }
                            return [
                                2
                            ];
                    }
                });
            })();
        }
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    var _env = siteContext.env, abTestingScript = _env.abTestingScript, branchKey = _env.branchKey, googleTagManagerStringIdsFromDoppler = _env.googleTagManagerId, yottaaScriptUrl = _env.yottaaScriptUrl;
    var _staticFeatures = siteContext.staticFeatures, hidePickUpWhereYouLetOff = _staticFeatures.hidePickUpWhereYouLetOff, isSalesfloorEnabled = _staticFeatures.isSalesfloorEnabled;
    var path = (0,utils_locale/* removeLocalePrefix */.g5)(pathname, siteContext.locale);
    var showMinimalPageFurniture = path.includes("adyen") || path.startsWith("/live-chat") || path.startsWith("/help") && qs.has("minimal") || path.includes("/paypay") && requestSource && [
        "mobile-app-ios",
        "mobile-app-android"
    ].includes(requestSource);
    // NOTE: example of possible googleTagManagerStringIdsFromDoppler:
    // " GTM-XL6RHPD, GTM-XL6RHPD ,GTM-XL6RHPD "
    var gtmIds = (googleTagManagerStringIdsFromDoppler || "") //Provide default empty string as site will otherwise break if no Tag ID provided
    .split(",").map(function(str) {
        return str.trim();
    }).filter(function(str) {
        return str;
    });
    var SF_WIDGET_CLASS = "sf-widget-hide-all";
    var SF_WIDGET_RESTRICTED_PATHS = [
        "/cart",
        "/checkout"
    ];
    var isSfRestrictedInThisPage = SF_WIDGET_RESTRICTED_PATHS.some(function(restrictedUrl) {
        return pathname.includes(restrictedUrl);
    });
    (0,react.useEffect)(function() {
        if (!isSfRestrictedInThisPage || !isSalesfloorEnabled) return;
        document.body.classList.add(SF_WIDGET_CLASS);
        return function() {
            document.body.classList.remove(SF_WIDGET_CLASS);
        };
    }, [
        isSfRestrictedInThisPage,
        isSalesfloorEnabled
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        charSet: "utf-8"
                    }, "charSet"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "viewport",
                        content: "width=device-width, initial-scale=1, maximum-scale=2"
                    }),
                    !siteContext.searchEngineIndexableLanguages.includes(siteContext.language) && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "robots",
                        content: "noindex, nofollow"
                    }),
                    yottaaScriptUrl && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                                rel: "preconnect",
                                href: "https://qoerum.yottaa-prod.com"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                                type: "text/javascript",
                                src: yottaaScriptUrl
                            })
                        ]
                    }),
                    !isDevelopmentEnv(siteContext.env) && !isPerformanceEnv(siteContext.env) && siteContext.staticFeatures.shapeSecurity && /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                        src: "/_next/dynamic/chunks/mecrury-f937bd6abdfdd14e.js"
                    }),
                    abTestingScript && /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                        type: "text/javascript",
                        src: abTestingScript
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "apple-touch-icon-precomposed",
                        sizes: "57x57",
                        href: "/assets/apple-touch-icon-57x57.png"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "apple-touch-icon-precomposed",
                        sizes: "60x60",
                        href: "/assets/apple-touch-icon-60x60.png"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "apple-touch-icon-precomposed",
                        sizes: "72x72",
                        href: "/assets/apple-touch-icon-72x72.png"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "apple-touch-icon-precomposed",
                        sizes: "76x76",
                        href: "/assets/apple-touch-icon-76x76.png"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "apple-touch-icon-precomposed",
                        sizes: "114x114",
                        href: "/assets/apple-touch-icon-114x114.png"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "apple-touch-icon-precomposed",
                        sizes: "120x120",
                        href: "/assets/apple-touch-icon-120x120.png"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "apple-touch-icon-precomposed",
                        sizes: "144x144",
                        href: "/assets/apple-touch-icon-144x144.png"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "apple-touch-icon-precomposed",
                        sizes: "152x152",
                        href: "/assets/apple-touch-icon-152x152.png"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "icon",
                        type: "image/png",
                        href: "/assets/android-chrome-192x192.png",
                        sizes: "192x192"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "icon",
                        type: "image/png",
                        href: "/assets/android-chrome-512x512.png",
                        sizes: "512x512"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "icon",
                        type: "image/png",
                        href: "/assets/favicon-48x48.png",
                        sizes: "48x48"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "application-name",
                        content: "\xa0"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "msapplication-TileColor",
                        content: "#FFFFFF"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "msapplication-TileImage",
                        content: "/assets/mstile-144x144.png"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "msapplication-square70x70logo",
                        content: "/assets/mstile-70x70.png"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "msapplication-square150x150logo",
                        content: "/assets/mstile-150x150.png"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "msapplication-wide310x150logo",
                        content: "/assets/mstile-310x150.png"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "msapplication-square310x310logo",
                        content: "/assets/mstile-310x310.png"
                    }),
                    siteContext.countryCode.toUpperCase() === constants/* SUPPORTED_COUNTRY.JP */.bM.JP && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                                rel: "preconnect",
                                href: "https://fonts.googleapis.com"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                                rel: "preconnect",
                                href: "https://fonts.gstatic.com"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "google-site-verification",
                        content: "fuTkqTLherNJsYYYxW6VfBMV-OHAOuOMtUp8jwytNAY"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "msvalidate.01",
                        content: "2A9EAE6A41044CA61F6FCAD3454E70A6"
                    }),
                    gtmIds.map(function(gtmId, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            name: "googleTagManagerId".concat(index),
                            content: gtmId
                        }, "metaGoogleTagManagerId".concat(index));
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InjectedScript/* InjectedScript */.D, {
                        async: true,
                        script:  false ? 0 : gtmIds.map(function(gtmId) {
                            return gtmScriptText({
                                gtmId: gtmId
                            });
                        }).join("")
                    }),
                    siteContext.env.STAGE === "production" && branchKey && /*#__PURE__*/ (0,jsx_runtime.jsx)(InjectedScript/* InjectedScript */.D, {
                        script: '\n            (function(b,r,a,n,c,h,_,s,d,k){if(!b[n]||!b[n]._q){for(;s<_.length;)c(h,_[s++]);d=r.createElement(a);d.async=1;d.src="https://cdn.branch.io/branch-latest.min.js";k=r.getElementsByTagName(a)[0];k.parentNode.insertBefore(d,k);b[n]=h}})(window,document,"script","branch",function(b,r){b[r]=function(){b._q.push([r,arguments])}},{_q:[],_v:1},"addListener applyCode autoAppIndex banner closeBanner closeJourney creditHistory credits data deepview deepviewCta first getCode init link logout redeem referrals removeListener sendSMS setBranchViewData setIdentity track validateCode trackCommerceEvent logEvent disableTracking qrCode".split(" "), 0);\n            const params = navigator.userAgent.match(/((iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)|(PUMAMobileApp))/i) ? {\'no_journeys\': true} : undefined;\n            \n            /**\n             * Branch.io Banner Z-Index Control\n             * \n             * This code ensures the Branch.io banner appears at the correct z-index level.\n             * The outer iframe is controlled via CSS in twind.config.ts, while this code\n             * handles the inner banner element that can\'t be targeted with external CSS.\n             * \n             * The \'willShowJourney\' event fires before the banner is displayed, allowing us\n             * to modify its z-index before it becomes visible to the user.\n             */\n            branch.init(\''.concat(branchKey, "', params);\n            \n            branch.addListener('willShowJourney', function() {\n              try {\n                const iframe = document.getElementById('branch-banner-iframe');\n                if (iframe && iframe.contentDocument) {\n                  const bannerElement = iframe.contentDocument.getElementById('branch-banner');\n                  if (bannerElement) {\n                    bannerElement.style.zIndex = '70';\n                  }\n                }\n              } catch {\n                // Silent fail - cross-origin restrictions may prevent access\n              }\n            });\n            ")
                    }),
                    siteContext.emarsysMerchantId && /*#__PURE__*/ (0,jsx_runtime.jsx)(InjectedScript/* InjectedScript */.D, {
                        script: "\n              var ScarabQueue = ScarabQueue || [];\n              (function(id) {\n                if (document.getElementById(id)) return;\n                var js = document.createElement('script'); js.id = id;\n                js.src = '//cdn.scarabresearch.com/js/".concat(siteContext.emarsysMerchantId, "/scarab-v2.js';\n                var fs = document.getElementsByTagName('script')[0];\n                fs.parentNode.insertBefore(js, fs);\n              })('scarab-js-api');\n            ")
                    })
                ]
            }),
            gtmIds.map(function(gtmId, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(GtmNoScript, {
                    gtmId: gtmId
                }, "GtmNoScript".concat(index));
            }),
            siteContext.countryCode.toUpperCase() === constants/* SUPPORTED_COUNTRY.GB */.bM.GB && /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                id: "chatbot",
                strategy: "lazyOnload",
                src: "//eu.fw-cdn.com/12873622/840604.js"
            }),
            ((ref1 = siteContext.liveChat) === null || ref1 === void 0 ? void 0 : ref1.provider) === "zendesk" && /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                defer: true,
                id: "ze-snippet",
                strategy: "lazyOnload",
                src: siteContext.liveChat.script
            }),
            siteContext.insiderIntegration && /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                async: true,
                src: "//".concat(siteContext.insiderIntegration.partnerName, ".api.useinsider.com/ins.js?id=").concat(siteContext.insiderIntegration.partnerId)
            }),
            siteContext.env.STAGE === "production" && siteContext.env.CORALOGIX_RUM_KEY && /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                src: "https://cdn.rum-ingress-coralogix.com/coralogix/browser/latest/coralogix-browser-sdk.js",
                onReady: function() {
                    window.CoralogixRum.init({
                        public_key: siteContext.env.CORALOGIX_RUM_KEY,
                        application: "nitro".concat(siteContext.env.NAMESPACE === "pre" ? "-pre-prod" : "-prod"),
                        instrumentations: {
                            xhr: true,
                            fetch: true,
                            web_vitals: true,
                            interactions: true,
                            custom: true,
                            errors: true,
                            long_tasks: true,
                            resources: true
                        },
                        version: siteContext.env.SHA,
                        coralogixDomain: "EU1",
                        user_context: {},
                        labels: {},
                        sessionConfig: {
                            sessionSampleRate: isCrawler ? 100 : 5
                        }
                    });
                }
            }, "coralogix-script"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(useSiteConfig/* SiteConfigContext.Provider */.D.Provider, {
                value: siteContext,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(useTranslations/* TranslationsContext.Provider */.yJ.Provider, {
                    value: {
                        t: t
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UdsProviderWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(useAuth/* AuthProvider */.Ho, {
                            auth: auth,
                            setAuth: setAuth,
                            country: country,
                            language: language,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(useBrowsingHistory/* BrowsingHistoryProvider */.P, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(useLocation/* LocationContextProvider */.ri, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(usePreferences/* PreferencesProvider */.CE, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(useProductHistory/* ProductHistoryProvider */.zH, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(useDeviceInteraction/* DeviceInteractionProvider */.X, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(usePageEventsContext/* PageEventsProvider */.Uu, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(useMainNav/* MainNavProvider */.s3, {
                                                        navLinks: navLinks,
                                                        mobileNavLinks: mobileNavLinks,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(useGooglePay/* GooglePayProvider */.l, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(useMiniCart/* MiniCartProvider */.qP, {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(useAccountSettings/* AccountSettingsProvider */.nE, {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(useEmarsysWebExtend/* EmarsysWebExtendProvider */.S, {
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(useSticky/* StickyStackContextProvider */.Y, {
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(useCookieSettings/* CookieSettingsProvider */.o6, {
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(useGA4Events/* GA4Provider */.OM, {
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(useStickyButton/* StickyButtonProvider */.Gs, {
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* TooltipProvider */.pnl, {
                                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(useIsCrawler/* CrawlerProvider */.j, {
                                                                                                isCrawler: isCrawler,
                                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(useHeading/* HeadingProvider */.u, {
                                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(useCheckoutFormData/* CheckoutFormProvider */.LF, {
                                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* ToastProvider */.VWW, {
                                                                                                            duration: 7000,
                                                                                                            label: t("notifications"),
                                                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(useToast/* ToastProvider */.V, {
                                                                                                                children: [
                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ImpersonationBanner, {}),
                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(useForter/* ForterProvider */.v, {
                                                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                                                            className: "relative min-h-screen flex flex-col",
                                                                                                                            children: [
                                                                                                                                showMinimalPageFurniture ? /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                                                                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, (0,_object_spread/* default */.Z)({}, pageProps))
                                                                                                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                                                                                    children: [
                                                                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                                                                            href: "#puma-skip-here",
                                                                                                                                            className: "absolute left-0 top-0 px-4 py-3 text-base font-bold bg-puma-black-900 text-puma-black-900 transform -translate-y-[200%] focus:translate-y-0",
                                                                                                                                            children: t("skipToContent")
                                                                                                                                        }),
                                                                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {}),
                                                                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                                                                                                                                            id: "puma-skip-here",
                                                                                                                                            className: "flex-grow",
                                                                                                                                            children: [
                                                                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, (0,_object_spread/* default */.Z)({}, pageProps)),
                                                                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationCheck, {}),
                                                                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CookieBanner, {}),
                                                                                                                                                !hidePickUpWhereYouLetOff && /*#__PURE__*/ (0,jsx_runtime.jsx)(PickUpWhereYouLeftOff, {})
                                                                                                                                            ]
                                                                                                                                        }),
                                                                                                                                        router.asPath.includes("/checkout") || router.asPath.includes("showQuickRegister") ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MinimalFooter, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(MainFooter, {})
                                                                                                                                    ]
                                                                                                                                }),
                                                                                                                                toast.description && /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast, (0,_object_spread/* default */.Z)({}, toast))
                                                                                                                            ]
                                                                                                                        })
                                                                                                                    }),
                                                                                                                    siteContext.env.STAGE !== "production" && /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentManagementToolbox, {}),
                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* ToastViewport */._ih, {})
                                                                                                                ]
                                                                                                            })
                                                                                                        })
                                                                                                    })
                                                                                                })
                                                                                            })
                                                                                        })
                                                                                    })
                                                                                })
                                                                            })
                                                                        })
                                                                    })
                                                                })
                                                            })
                                                        })
                                                    })
                                                })
                                            })
                                        })
                                    })
                                })
                            })
                        })
                    })
                })
            })
        ]
    });
}
if (constants/* isServer */.sk) {
    PumaApp.getInitialProps = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(appContext) {
            var ref, ref1, context, client, req, res, fetchOptions, url, _headers, host, locale, namespace, isCrawler, _tmp, surrogateKey, ref2, country, language, frontendConfig, _tmp1, _tmp2, _tmp3, frontendConfigData, webInMaintenanceMode, _tmp4, mainNavQuery, _tmp5, _tmp6, ref3, staticSiteConfig, resources, appProps, processEnv, _tmp7, isLocalizedFeatureFlagEnabledServer, _tmp8, _tmp9;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        context = appContext.ctx;
                        client = context.urqlClient;
                        req = context.req;
                        res = context.res;
                        fetchOptions = getFetchOptions(context);
                        fetchOptions.headers["gcdn-force"] = "1";
                        url = req.url || "";
                        _headers = req.headers, host = _headers.host, locale = _headers.locale;
                        namespace = _app_process.env.NAMESPACE;
                        _tmp = {};
                        isCrawler = (0,isCrawlerCheck/* isCrawlerCheck */.c)((_tmp.host = host, _tmp.namespace = namespace, _tmp.req = req, _tmp));
                        surrogateKey = res.getHeader("surrogate-key");
                        res.setHeader("surrogate-key", [
                            surrogateKey,
                            "ssr"
                        ].flat().join(" "));
                        ref2 = (0,utils_locale/* parseRequestUrl */.VJ)(req), country = ref2.country, language = ref2.language;
                        _tmp1 = {};
                        _tmp2 = {};
                        return [
                            4,
                            client.query(graphql/* FrontendConfigurationDocument */.bTF, _tmp1, (_tmp2.fetchOptions = fetchOptions, _tmp2)).toPromise()
                        ];
                    case 1:
                        frontendConfig = _state.sent();
                        _tmp3 = {};
                        // If we don't get a frontend config back something is very wrong
                        // and we can't confidently proceed so we return 500 in order to make
                        // sure that fastly doesn't cache the SSR'd response.
                        if (frontendConfig.error || !frontendConfig.data) {
                            // eslint-disable-next-line no-console
                            console.error("Unable to load frontend config", (_tmp3.err = frontendConfig.error, _tmp3.url = url, _tmp3));
                            // @ts-expect-error
                            return [
                                2,
                                res.writeHead(500).end()
                            ];
                        }
                        frontendConfigData = (ref = frontendConfig.data) === null || ref === void 0 ? void 0 : ref.frontendConfiguration;
                        webInMaintenanceMode = frontendConfigData.environment.webInMaintenanceMode;
                        _tmp4 = {};
                        if ((webInMaintenanceMode === null || webInMaintenanceMode === void 0 ? void 0 : webInMaintenanceMode.toLowerCase()) === "true") {
                            // On the server, we'll use an HTTP response to
                            // redirect with the status code of our choice.
                            // 307 is for temporary redirects.
                            res.writeHead(307, (_tmp4.Location = "/maintenance/".concat(country, "/").concat(language), _tmp4));
                            res.end();
                        }
                        _tmp5 = {};
                        _tmp6 = {};
                        return [
                            4,
                            client.query((0,useGroqQuery/* CONTENT_QUERY */.lK)("MainNavChildren"), (_tmp5.input = {
                                query: MainNavQuery,
                                params: {
                                    url: "/"
                                },
                                src: context.query.src,
                                draft: context.query.draft,
                                preview: (0,useGroqQuery/* groqPreviewInput */.i8)(context.query)
                            }, _tmp5), (_tmp6.fetchOptions = fetchOptions, _tmp6)).toPromise()
                        ];
                    case 2:
                        mainNavQuery = _state.sent();
                        return [
                            4,
                            Promise.all([
                                __webpack_require__(97524)("./".concat(country, "/config")).then(function(mod) {
                                    return mod.config;
                                }),
                                __webpack_require__(30242)("./".concat(locale)).then(function(res) {
                                    return res.default;
                                })
                            ])
                        ];
                    case 3:
                        ref3 = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                            _state.sent(),
                            2
                        ]), staticSiteConfig = ref3[0], resources = ref3[1];
                        return [
                            4,
                            app["default"].getInitialProps(appContext)
                        ];
                    case 4:
                        appProps = _state.sent();
                        _tmp7 = {};
                        processEnv = (_tmp7.CORALOGIX_RUM_KEY = "cxtp_yHhCHWK0YD6ozlcDG6skWSzX7HaOLw", _tmp7.STAGE = "production", _tmp7.SHA = _app_process.env.SHA, _tmp7.NAMESPACE = namespace, _tmp7);
                        isLocalizedFeatureFlagEnabledServer = function(flag) {
                            var ref, ref1;
                            var currentLocale = locale;
                            var currentNamespace = namespace ? "".concat(namespace, "-") : "";
                            var currentEnv = currentNamespace.includes("pr-") ? "PullRequestEnvironment" : "".concat(currentNamespace).concat("production");
                            return Boolean((ref = featureFlags_namespaceObject[currentEnv]) === null || ref === void 0 ? void 0 : (ref1 = ref[currentLocale]) === null || ref1 === void 0 ? void 0 : ref1[flag]);
                        };
                        _tmp8 = {};
                        _tmp9 = {};
                        return [
                            2,
                            (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)(_tmp8, appProps), (_tmp9.mainNavQuery = mainNavQuery === null || mainNavQuery === void 0 ? void 0 : (ref1 = mainNavQuery.data) === null || ref1 === void 0 ? void 0 : ref1.content, _tmp9.locale = locale, _tmp9.language = language, _tmp9.country = country.toUpperCase(), _tmp9.isCrawler = isCrawler, _tmp9.resources = resources, _tmp9.// Current frontend setup: (siteConfig, staticConfig, frontendConfig, siteContext).
                            // "StaticConfig" is a json file that we dynamically import based on the country.
                            // This way we ensure that the rendering server only sends corresponding data to the client.
                            // In that json file we have data that are exposable, mostly config values:
                            // currency, flag ... .
                            // These values can be extracted later on to Sanity.
                            // The frontedConfig query returns the exposable "secrets" and the feature flags.
                            // Behind the scenes (see resolvers/frontendConfig) we reach out to Sanity to fetch the feature
                            // flags (they are highly dynamic and we'd like content creators to control them).
                            // As for the exposable secrets:
                            // the API is already aware all of the secrets. Therefore it just needs to filter out those that can be
                            // safely sent over.
                            // The "stage" variable is dependent on the CI/CD setup -> it is coming from the "process.env" var.
                            // All of these item make the "siteConfig" that we return as a prop to our _app component.
                            // Reminder: our _app getInitialProps only executed on the server opposed to a 'regular' "getInitialProps"
                            // which is executed on the server when that is the first paint, or on the client if a client-side route
                            // transition takes place. That will become important later. Next step: see the siteContext on line 344.
                            siteConfig = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, staticSiteConfig, frontendConfigData.siteConfig), {
                                features: frontendConfigData.featureFlags,
                                env: (0,_object_spread/* default */.Z)({}, frontendConfigData.environment, processEnv),
                                isLocalizedFeatureFlagEnabled: isLocalizedFeatureFlagEnabledServer,
                                localizedFeatureFlagsEnabled: getLocalizedFlagsEnabled(featureFlags_namespaceObject)
                            }), _tmp9.host = host, _tmp9))
                        ];
                }
            });
        });
        return function(appContext) {
            return _ref.apply(this, arguments);
        };
    }();
}
/**
 * Note that if we move this away we'll have to move the AuthContext.Provider as well, this could
 * be done through a HOC comparable to withAuth. This is needed because inside of a server-side render
 * we'll traverse the VDOM tree, if the Provider isn't part of this we won't be giving accurate results.
 */ // @ts-expect-error
/* harmony default export */ var _app = (withUrql(withTwindApp(twind_config, PumaApp)));


/***/ }),

/***/ 50384:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ commonFieldsProps; }
/* harmony export */ });
var commonFieldsProps = {
    email: {
        fieldType: "input",
        validations: [
            "email"
        ],
        maxLength: 200
    },
    orderEmail: {
        fieldType: "input",
        validations: [
            "email"
        ],
        maxLength: 200
    },
    firstName: {
        fieldType: "input",
        validations: [
            "name"
        ],
        maxLength: 50
    },
    lastName: {
        fieldType: "input",
        validations: [
            "name"
        ],
        maxLength: 50
    },
    password: {
        fieldType: "password",
        validations: [
            "password"
        ],
        minLength: 8,
        maxLength: 255
    },
    billingPostalCode: {
        fieldType: "input",
        validations: [
            "postalCode"
        ],
        maxLength: 50
    },
    backToMyAccount: {
        fieldType: "link",
        href: "/account/"
    },
    cancel: {
        fieldType: "link",
        variant: "primary",
        href: "/account"
    },
    phone: {
        fieldType: "input",
        validations: [
            "phoneNumber"
        ]
    },
    orderNo: {
        fieldType: "input",
        validations: [
            "safeInput",
            "orderNumberValidation"
        ]
    },
    returnOrderLookup: {
        variant: "primary"
    },
    returnsOrderExplainerModal: {
        name: "returnsOrderExplainerModal",
        fieldType: "text-to-modal",
        text: "returnWhereToFindOrder",
        modalTitle: "returnWhereToFindOrder",
        modalDescription: "returnWhereToFindOrderExplainer"
    },
    createAccountV2: {
        name: "createAccountV2",
        className: "-mt-3 mb-8",
        size: "base"
    }
};


/***/ }),

/***/ 75750:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ inStates; }
/* harmony export */ });
var inStates = [
    {
        name: "Andhra Pradesh",
        value: "AP"
    },
    {
        name: "Arunachal Pradesh",
        value: "AR"
    },
    {
        name: "Assam",
        value: "AS"
    },
    {
        name: "Bihar",
        value: "BR"
    },
    {
        name: "Chhattisgarh",
        value: "CG",
        isoCompliantValue: "CT"
    },
    {
        name: "Goa",
        value: "GA"
    },
    {
        name: "Gujarat",
        value: "GJ"
    },
    {
        name: "Haryana",
        value: "HR"
    },
    {
        name: "Himachal Pradesh",
        value: "HP"
    },
    {
        name: "Jammu and Kashmir",
        value: "JK"
    },
    {
        name: "Jharkhand",
        value: "JH"
    },
    {
        name: "Karnataka",
        value: "KA"
    },
    {
        name: "Kerala",
        value: "KL"
    },
    {
        name: "Madhya Pradesh",
        value: "MP"
    },
    {
        name: "Maharashtra",
        value: "MH"
    },
    {
        name: "Manipur",
        value: "MN"
    },
    {
        name: "Meghalaya",
        value: "ML"
    },
    {
        name: "Mizoram",
        value: "MZ"
    },
    {
        name: "Nagaland",
        value: "NL"
    },
    {
        name: "Odisha",
        value: "OD",
        isoCompliantValue: "OR"
    },
    {
        name: "Punjab",
        value: "PB"
    },
    {
        name: "Rajasthan",
        value: "RJ"
    },
    {
        name: "Sikkim",
        value: "SK"
    },
    {
        name: "Tamil Nadu",
        value: "TN"
    },
    {
        name: "Telangana",
        value: "TS",
        isoCompliantValue: "TG"
    },
    {
        name: "Tripura",
        value: "TR"
    },
    {
        name: "Uttar Pradesh",
        value: "UP"
    },
    {
        name: "Uttarakhand",
        value: "UK",
        isoCompliantValue: "UT"
    },
    {
        name: "West Bengal",
        value: "WB"
    },
    {
        name: "Andaman and Nicobar Islands",
        value: "AN"
    },
    {
        name: "Chandigarh",
        value: "CH"
    },
    {
        name: "Dadra and Nagar Haveli",
        value: "DN",
        isoCompliantValue: "DH"
    },
    {
        name: "Daman and Diu",
        value: "DD",
        isoCompliantValue: "DH"
    },
    {
        name: "Lakshadweep",
        value: "LD"
    },
    {
        name: "NCT Delhi",
        value: "DL"
    },
    {
        name: "Puducherry",
        value: "PY"
    }, 
];


/***/ }),

/***/ 3661:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ HOLDER_NAME_NOT_ALLOWED_CHARACTERS; },
/* harmony export */   "e": function() { return /* binding */ JPFieldProps; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85034);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70169);
/* harmony import */ var _common_fields__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50384);



var ALLOWED_CHARACTERS = "^([\0-/:-~\x80-ž’”]|[　-〿぀-ゟ゠-ヿ＀-￯一-龯])+$";
var ALLOWED_CITY_STREET = "^[\0-~\x80-ž’”　-〿぀-ゟ゠-ヿ＀-￯一-龯★-☆←-↕※]+$";
var HIRAGANA_ALL_CHARACTERS = "ぁ-ん";
var KANJI_ALL_CHARACTERS = "一-龯";
var KATAKANA_FULL_WIDTH_CHARACTERS = "ァ-ン";
var KATAKANA_HALF_WIDTH_CHARACTERS = "ｧ-ﾝﾞﾟ";
var LATIN_FULL_WIDTH_CHARACTERS = "Ａ-ｚ";
var NUMBERS_FULL_WIDTH_CHARACTERS = "０-９";
var NUMBERS_HALF_WIDTH_CHARACTERS = "0-9";
var ASCII_SYMBOLS_FULL_WIDTH_CHARACTERS = "！＂＃＄％＆＇（）＊＋，－．／：；＜＝＞？＠［＼］＾＿｀｛｜｝～";
var ASCII_SYMBOLS_HALF_WIDTH_CHARACTERS = "!\"#$%&'()*+,-./:;<=>?@[\\]^_`{|}~";
// put some of the not allowed characters in a separate variable
// so that when you enter these characters, display a separate message
// https://pumaglobal.atlassian.net/browse/CBC-7137?focusedCommentId=972373
var HOLDER_NAME_NOT_ALLOWED_CHARACTERS = HIRAGANA_ALL_CHARACTERS + KANJI_ALL_CHARACTERS + KATAKANA_FULL_WIDTH_CHARACTERS + KATAKANA_HALF_WIDTH_CHARACTERS + LATIN_FULL_WIDTH_CHARACTERS + NUMBERS_FULL_WIDTH_CHARACTERS + NUMBERS_HALF_WIDTH_CHARACTERS + ASCII_SYMBOLS_FULL_WIDTH_CHARACTERS + ASCII_SYMBOLS_HALF_WIDTH_CHARACTERS;
var HOLDER_NAME_ALLOWED_CHARACTERS = "a-zA-Z\\s";
var HOLDER_NAME_CHARACTERS_EXTENDED = "^[" + HOLDER_NAME_ALLOWED_CHARACTERS + HOLDER_NAME_NOT_ALLOWED_CHARACTERS + "]+$";
var STATE_CODE = "^[" + HIRAGANA_ALL_CHARACTERS + KANJI_ALL_CHARACTERS + KATAKANA_FULL_WIDTH_CHARACTERS + KATAKANA_HALF_WIDTH_CHARACTERS + "a-zA-Z0-9]+$";
var JPFieldProps = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, _common_fields__WEBPACK_IMPORTED_MODULE_0__/* .commonFieldsProps */ .I), {
    firstName: {
        fieldType: "input",
        pattern: ALLOWED_CHARACTERS,
        maxLength: 50,
        validations: [
            "name"
        ]
    },
    lastName: {
        fieldType: "input",
        pattern: ALLOWED_CHARACTERS,
        maxLength: 50,
        validations: [
            "name"
        ]
    },
    firstNamePronunciation: {
        fieldType: "input",
        pattern: ALLOWED_CHARACTERS,
        maxLength: 50,
        validations: [
            "name"
        ]
    },
    lastNamePronunciation: {
        fieldType: "input",
        pattern: ALLOWED_CHARACTERS,
        maxLength: 50,
        validations: [
            "name"
        ]
    },
    phone: {
        fieldType: "input",
        pattern: "^[\\+]?[\\d]{7,15}$",
        maxLength: 30
    },
    phoneNumber: {
        fieldType: "input",
        pattern: "^[\\+(/. 0-9 \\)-]+[ ]*((( |x|ext|ext.|extension|Ext|Ext.|Extension|#){1}[ ]?([0-9]){1,7}){0,1})$",
        maxLength: 30
    },
    password: {
        fieldType: "password",
        pattern: "^(?=.*[a-zA-Z])(?=.*[0-9]).{8,255}$",
        validations: [
            "safeInput"
        ],
        minLength: 8,
        maxLength: 255
    },
    email: {
        fieldType: "input",
        pattern: "^[\\w-\\.\\%\\+]+@(([\\w-]{1,})+\\.)+[\\w-]{2,6}$",
        maxLength: 50
    },
    postalCode: {
        fieldType: "yubinbango-address-look-up",
        pattern: "^([0-9]{3}-[0-9]{4})$|^([0-9]{7})$",
        maxLength: 8
    },
    stateCode: {
        fieldType: "input",
        pattern: STATE_CODE,
        maxLength: 50
    },
    city: {
        fieldType: "input",
        pattern: ALLOWED_CITY_STREET,
        maxLength: 50
    },
    address1: {
        fieldType: "input",
        pattern: ALLOWED_CITY_STREET,
        maxLength: 50
    },
    backCancel: {
        fieldType: "link",
        href: "/account",
        className: "w-full",
        size: "lg",
        variant: "secondary"
    },
    holderName: {
        fieldType: "input",
        maxLength: 40,
        pattern: HOLDER_NAME_CHARACTERS_EXTENDED,
        validations: [
            "holderNameExcludeCharacters"
        ]
    },
    holderNameAccount: {
        fieldType: "input",
        maxLength: 40,
        pattern: HOLDER_NAME_CHARACTERS_EXTENDED,
        validations: [
            "holderNameExcludeCharacters"
        ]
    },
    cardNumber: {
        fieldType: "card-number"
    },
    expirationDate: {
        fieldType: "expiration-date"
    },
    cvv: {
        fieldType: "cvv"
    },
    gender: {
        fieldType: "input-radio",
        values: [
            "male",
            "female"
        ]
    },
    cancel: {
        fieldType: "link",
        variant: "secondary",
        href: "/account",
        size: "lg",
        className: "flex-auto"
    },
    backToMyAccount: {
        fieldType: "link",
        href: "/account",
        class: "col-span-2"
    },
    currentPassword: {
        fieldType: "password",
        maxLength: 255,
        minLength: 8
    },
    newPassword: {
        fieldType: "password",
        pattern: "^(?=.*[a-zA-Z])(?=.*[0-9]).{8,255}$",
        validations: [
            "password"
        ],
        maxLength: 255,
        minLength: 8
    },
    newPasswordConfirmation: {
        fieldType: "password",
        maxLength: 255,
        minLength: 8
    },
    orderEmail: {
        fieldType: "input",
        pattern: "^[\\w-\\.\\%\\+]+@(([\\w-]{1,})+\\.)+[\\w-]{2,6}$",
        maxLength: 50
    }
});


/***/ }),

/***/ 57023:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "xm": function() { return /* reexport */ useFiredEventsStore; },
  "wQ": function() { return /* reexport */ useModalsOpenStore; },
  "Gd": function() { return /* reexport */ usePopupsOpenStore; },
  "nx": function() { return /* reexport */ useTempStateStore; },
  "fK": function() { return /* reexport */ useWidgetInstanceStore; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(3204);
// EXTERNAL MODULE: ../node_modules/zustand/esm/index.mjs + 1 modules
var esm = __webpack_require__(6805);
// EXTERNAL MODULE: ../node_modules/zustand/esm/react/shallow.mjs
var shallow = __webpack_require__(53248);
;// CONCATENATED MODULE: ./store/firedEvents.store.ts



var _useFiredEventsStore = (0,esm/* create */.Ue)(function(set) {
    return {
        firedEvents: [],
        setFiredEvents: function(value) {
            return set({
                firedEvents: value
            });
        }
    };
});
// https://github.com/pmndrs/zustand#selecting-multiple-state-slices
var useFiredEventsStore = function() {
    var ref = _useFiredEventsStore((0,shallow/* useShallow */.N)(function(state) {
        return {
            firedEvents: state.firedEvents,
            setFiredEvents: state.setFiredEvents
        };
    })), firedEvents = ref.firedEvents, setFiredEvents = ref.setFiredEvents;
    var setEventFired = function(eventName) {
        return setFiredEvents(Array.from(new Set((0,_to_consumable_array/* default */.Z)(firedEvents).concat([
            eventName
        ]))));
    };
    var eventHasFired = function(eventName) {
        return firedEvents.some(function(x) {
            return x === eventName;
        });
    };
    return {
        eventHasFired: eventHasFired,
        setEventFired: setEventFired
    };
};

;// CONCATENATED MODULE: ./store/widgetInstance.store.ts


var _useWidgetInstanceStore = (0,esm/* create */.Ue)(function(set) {
    return {
        widgetInstance: null,
        setWidgetInstance: function(value) {
            return set({
                widgetInstance: value
            });
        }
    };
});
// https://github.com/pmndrs/zustand#selecting-multiple-state-slices
var useWidgetInstanceStore = function() {
    var ref = _useWidgetInstanceStore((0,shallow/* useShallow */.N)(function(state) {
        return {
            widgetInstance: state.widgetInstance,
            setWidgetInstance: state.setWidgetInstance
        };
    })), widgetInstance = ref.widgetInstance, setWidgetInstance = ref.setWidgetInstance;
    return {
        widgetInstance: widgetInstance,
        setWidgetInstance: setWidgetInstance
    };
};

;// CONCATENATED MODULE: ./store/modalsOpen.store.ts



var _useModalsOpenStore = (0,esm/* create */.Ue)(function(set) {
    return {
        modalsOpen: [],
        setModalsOpen: function(value) {
            return set({
                modalsOpen: value
            });
        }
    };
});
// https://github.com/pmndrs/zustand#selecting-multiple-state-slices
var useModalsOpenStore = function() {
    var ref = _useModalsOpenStore((0,shallow/* useShallow */.N)(function(state) {
        return {
            modalsOpen: state.modalsOpen,
            setModalsOpen: state.setModalsOpen
        };
    })), modalsOpen = ref.modalsOpen, setModalsOpen = ref.setModalsOpen;
    var setModalOpen = function(modalName, open) {
        if (open) {
            setModalsOpen(modalsOpen.filter(function(e) {
                return e !== modalName;
            }).concat([
                modalName
            ]));
        } else setModalsOpen((0,_to_consumable_array/* default */.Z)(modalsOpen.filter(function(x) {
            return x !== modalName;
        })));
    };
    var isModalOpen = function(modalName) {
        return modalsOpen.some(function(x) {
            return x === modalName;
        });
    };
    return {
        isModalOpen: isModalOpen,
        setModalOpen: setModalOpen
    };
}; // ─── Usage ───────────────────────────────────────────────────────────────────
 //
 // const { isModalOpen, setModalOpen } = useModalsOpenStore();
 //
 // if (isModalOpen('foobar')) {
 //   setModalOpen('foobar', false);
 // }
 //
 // ─────────────────────────────────────────────────────────────────────────────

;// CONCATENATED MODULE: ./store/popupsOpen.store.ts



var _usePopupsOpenStore = (0,esm/* create */.Ue)(function(set) {
    return {
        popupsOpen: [],
        setPopupsOpen: function(value) {
            return set({
                popupsOpen: value
            });
        }
    };
});
// https://github.com/pmndrs/zustand#selecting-multiple-state-slices
var usePopupsOpenStore = function() {
    var ref = _usePopupsOpenStore((0,shallow/* useShallow */.N)(function(state) {
        return {
            popupsOpen: state.popupsOpen,
            setPopupsOpen: state.setPopupsOpen
        };
    })), popupsOpen = ref.popupsOpen, setPopupsOpen = ref.setPopupsOpen;
    var setPopupOpen = function(popupName, open) {
        if (open) {
            setPopupsOpen(popupsOpen.filter(function(e) {
                return e !== popupName;
            }).concat([
                popupName
            ]));
        } else setPopupsOpen((0,_to_consumable_array/* default */.Z)(popupsOpen.filter(function(x) {
            return x !== popupName;
        })));
    };
    var isPopupOpen = function(popupName) {
        return popupsOpen.some(function(x) {
            return x === popupName;
        });
    };
    return {
        isPopupOpen: isPopupOpen,
        setPopupOpen: setPopupOpen
    };
}; // ─── Usage ───────────────────────────────────────────────────────────────────
 //
 // const { isPopupOpen, setPopupOpen } = usePopupsOpenStore();
 //
 // if (isPopupOpen('foobar')) {
 //   setPopupOpen('foobar', false);
 // }
 //
 // ─────────────────────────────────────────────────────────────────────────────

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(17599);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(85034);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(70169);
;// CONCATENATED MODULE: ./store/tempState.store.ts





var initialTempState = {
    IdOfLastProductAddedToCart: ""
};
var _useTempStateStore = (0,esm/* create */.Ue)(function(set) {
    return {
        tempState: initialTempState,
        setTempState: function(value) {
            return set({
                tempState: value
            });
        }
    };
});
// https://github.com/pmndrs/zustand#selecting-multiple-state-slices
var useTempStateStore = function() {
    var ref = _useTempStateStore((0,shallow/* useShallow */.N)(function(state) {
        return {
            tempState: state.tempState,
            setTempState: state.setTempState
        };
    })), tempState = ref.tempState, _setTempState = ref.setTempState;
    var setTempState = function(tempStateName, value) {
        return _setTempState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, tempState), (0,_define_property/* default */.Z)({}, tempStateName, value)));
    };
    var getTempState = function(tempStateName) {
        return tempState[tempStateName];
    };
    return {
        getTempState: getTempState,
        setTempState: setTempState
    };
}; // ─── Usage ───────────────────────────────────────────────────────────────────
 //
 // const { getTempState, setTempState } = useTempStateStore();
 //
 // if (!getTempState('foobar')) {
 //   setTempState('foobar', 'asd123');
 // }
 //
 // ─────────────────────────────────────────────────────────────────────────────

;// CONCATENATED MODULE: ./store/index.ts







/***/ }),

/***/ 90099:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Db": function() { return /* binding */ Dimensions; },
/* harmony export */   "Ty": function() { return /* binding */ SignUpFormAnalyticsIdentifiers; },
/* harmony export */   "VF": function() { return /* binding */ EmailSignUpActions; },
/* harmony export */   "ew": function() { return /* binding */ SignUpActions; },
/* harmony export */   "fD": function() { return /* binding */ SignUpLocations; },
/* harmony export */   "n_": function() { return /* binding */ EmailSignUpLocations; },
/* harmony export */   "pR": function() { return /* binding */ ItemAvailabilitySchema; }
/* harmony export */ });
var Dimensions;
(function(Dimensions) {
    Dimensions["d14"] = "dimension14";
    Dimensions["d15"] = "dimension15";
    Dimensions["d16"] = "dimension16";
    Dimensions["d17"] = "dimension17";
    Dimensions["d18"] = "dimension18";
    Dimensions["d19"] = "dimension19";
    Dimensions["d20"] = "dimension20";
    Dimensions["d21"] = "dimension21";
    Dimensions["d22"] = "dimension22";
    Dimensions["d23"] = "dimension23";
    Dimensions["d24"] = "dimension24";
    Dimensions["d25"] = "dimension25";
    Dimensions["d27"] = "dimension27";
    Dimensions["d76"] = "dimension76";
    Dimensions["d79"] = "dimension79";
    Dimensions["d80"] = "dimension80";
    Dimensions["d81"] = "dimension81";
    Dimensions["d82"] = "dimension82";
    Dimensions["d88"] = "dimension88";
    Dimensions["d92"] = "dimension92";
    Dimensions["d94"] = "dimension94";
    Dimensions["d96"] = "dimension96";
    Dimensions["d97"] = "dimension97";
    Dimensions["d100"] = "dimension100";
})(Dimensions || (Dimensions = {}));
var ItemAvailabilitySchema;
(function(ItemAvailabilitySchema) {
    ItemAvailabilitySchema["instock"] = "InStock";
    ItemAvailabilitySchema["soldout"] = "SoldOut";
    ItemAvailabilitySchema["presale"] = "PreOrder";
    ItemAvailabilitySchema["backsoon"] = "OutOfStock";
})(ItemAvailabilitySchema || (ItemAvailabilitySchema = {}));
var SignUpFormAnalyticsIdentifiers;
(function(SignUpFormAnalyticsIdentifiers) {
    SignUpFormAnalyticsIdentifiers["EMAIL_SIGNUP"] = "EMAIL_SIGNUP";
    SignUpFormAnalyticsIdentifiers["SMS_OPT_IN"] = "SMS_OPT_IN";
})(SignUpFormAnalyticsIdentifiers || (SignUpFormAnalyticsIdentifiers = {}));
var SignUpActions;
(function(SignUpActions) {
    SignUpActions["Closed"] = "signup closed";
    SignUpActions["ButtonDismissed"] = "signup button dismissed";
    SignUpActions["Error"] = "signup error";
    SignUpActions["Impression"] = "signup impression";
    SignUpActions["ModalImpression"] = "signup modal impression";
    SignUpActions["Opened"] = "signup opened";
    SignUpActions["Submit"] = "signup submit";
    SignUpActions["ToggleOn"] = "signup toggled on";
    SignUpActions["ToggleOff"] = "signup toggled off";
})(SignUpActions || (SignUpActions = {}));
var SignUpLocations;
(function(SignUpLocations) {
    SignUpLocations["CartNewsletterSignUp"] = "cart newsletter sign up";
    SignUpLocations["OrderConfirmation"] = "order confirmation";
    SignUpLocations["SignUpFormHero"] = "sign up form hero";
    SignUpLocations["SignUpFormPDPComingSoon"] = "sign up form pdp coming soon";
    SignUpLocations["SiteFooter"] = "site footer";
    SignUpLocations["StickySignUpButton"] = "sticky sign up button";
    SignUpLocations["MyAccount"] = "my account";
})(SignUpLocations || (SignUpLocations = {}));
var EmailSignUpActions;
(function(EmailSignUpActions) {
    EmailSignUpActions["Closed"] = "email signup closed";
    EmailSignUpActions["ButtonDismissed"] = "email signup button dismissed";
    EmailSignUpActions["Error"] = "email signup error";
    EmailSignUpActions["Impression"] = "email signup impression";
    EmailSignUpActions["ModalImpression"] = "email signup modal impression";
    EmailSignUpActions["Opened"] = "email signup opened";
    EmailSignUpActions["Submit"] = "email signup submit";
})(EmailSignUpActions || (EmailSignUpActions = {}));
var EmailSignUpLocations;
(function(EmailSignUpLocations) {
    EmailSignUpLocations["CartNewsletterSignUp"] = "cart newsletter sign up";
    EmailSignUpLocations["OrderConfirmation"] = "order confirmation";
    EmailSignUpLocations["SignUpFormHero"] = "sign up form hero";
    EmailSignUpLocations["SignUpFormPDPComingSoon"] = "sign up form pdp coming soon";
    EmailSignUpLocations["SiteFooter"] = "site footer";
    EmailSignUpLocations["StickySignUpButton"] = "sticky sign up button";
    EmailSignUpLocations["MyAccount"] = "my account";
})(EmailSignUpLocations || (EmailSignUpLocations = {}));


/***/ }),

/***/ 77797:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ AcceptedPaymentMethods; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var hooks_useFeature__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53625);
/* harmony import */ var hooks_useSiteConfig__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20368);
/* harmony import */ var ui_forms_PaymentMethods_CardFrameIcon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20808);




var PARTNER_NAME_TO_LOGO = {
    afterPay: "payment-afterpay",
    amazonPay: "payment-amazon-pay",
    americanExpress: "payment-amex",
    applePay: "payment-apple-pay",
    diners: "payment-diners-club",
    discover: "payment-discover",
    googlePay: "payment-google-pay",
    JCB: "payment-jcb",
    klarna: "payment-klarna",
    maestro: "payment-maestro",
    master: "payment-mastercard",
    payPal: "payment-paypal",
    payPay: "payment-paypay",
    visa: "payment-visa",
    zip: "payment-zip",
    weChatPay: "payment-wechat-pay",
    alipay: "payment-alipay",
    UPI: "payment-upi",
    rupay: "payment-rupay"
};
var AcceptedPaymentMethods = function(param) {
    var className = param.className, dataTestId = param.dataTestId, ariaLabel = param.ariaLabel, filterFn = param.filterFn;
    var ref = (0,hooks_useSiteConfig__WEBPACK_IMPORTED_MODULE_2__/* .useSiteConfig */ .N)(), orderedPaymentPartners = ref.orderedPaymentPartners, isPNARegion = ref.staticFeatures.isPNARegion;
    var isKlarnaEnabled = (0,hooks_useFeature__WEBPACK_IMPORTED_MODULE_1__/* .useFeature */ .S)("KLARNA_ENABLED");
    var filteredPaymentPartners = orderedPaymentPartners;
    if (filterFn) {
        filteredPaymentPartners = orderedPaymentPartners.filter(filterFn);
    }
    if (isPNARegion && !isKlarnaEnabled && filteredPaymentPartners.includes("klarna")) filteredPaymentPartners.splice(filteredPaymentPartners.indexOf("klarna"), 1);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
        className: className,
        "data-test-id": dataTestId,
        "aria-label": ariaLabel,
        children: filteredPaymentPartners === null || filteredPaymentPartners === void 0 ? void 0 : filteredPaymentPartners.map(function(paymentPartner) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                className: "flex bg-white rounded-sm",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ui_forms_PaymentMethods_CardFrameIcon__WEBPACK_IMPORTED_MODULE_3__/* .CardFrameIcon */ .d, {
                    name: PARTNER_NAME_TO_LOGO[paymentPartner],
                    label: paymentPartner
                })
            }, paymentPartner);
        })
    });
};


/***/ }),

/***/ 39309:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ij": function() { return /* binding */ AddressLookup; }
/* harmony export */ });
/* unused harmony exports generateOptions, checkPlaceDetailsRoute */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(23842);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(85034);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(70169);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(31373);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(59312);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27378);
/* harmony import */ var _global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12601);
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79758);
/* harmony import */ var hooks_useFeature__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(53625);
/* harmony import */ var hooks_useGoogleServices__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(48548);
/* harmony import */ var utils_debounce__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(40572);
/* harmony import */ var utils_transformPlaces__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(19259);













var generateOptions = function(addresses) {
    return addresses.map(function(address, index) {
        var _place_id;
        return {
            id: (_place_id = address.place_id) !== null && _place_id !== void 0 ? _place_id : "".concat(address.description, "-").concat(index),
            value: address.description
        };
    });
};
var checkPlaceDetailsRoute = function(placeDetails) {
    var ref;
    // If API returns a 'route', pass through the street number from the original input
    if ((ref = placeDetails.types) === null || ref === void 0 ? void 0 : ref.find(function(type) {
        return type === "route";
    })) {
        var ref1;
        var newAddressComponent = {
            long_name: "",
            short_name: "",
            types: [
                "street_number"
            ]
        };
        (ref1 = placeDetails.address_components) === null || ref1 === void 0 ? void 0 : ref1.unshift(newAddressComponent);
    }
    return placeDetails;
};
var AddressLookupComp = function(_param, ref) {
    var onSelect = _param.onSelect, onChange = _param.onChange, onBlur = _param.onBlur, lookupConstraints = _param.lookupConstraints, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_param, [
        "onSelect",
        "onChange",
        "onBlur",
        "lookupConstraints"
    ]);
    var googleAutocompleteEnabled = (0,hooks_useFeature__WEBPACK_IMPORTED_MODULE_4__/* .useFeature */ .S)("GOOGLE_ADDRESS_LOOKUP");
    var _$ref = (0,hooks_useGoogleServices__WEBPACK_IMPORTED_MODULE_5__/* .useGoogleServices */ .o0)(), autoComplete = _$ref.autoComplete, getPlaceDetails = _$ref.getPlaceDetails;
    var onOptionSelect = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(function(address) {
            var placeDetails, _ref, address1, rest, _tmp, e;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            getPlaceDetails(address.id)
                        ];
                    case 1:
                        placeDetails = _state.sent();
                        placeDetails = checkPlaceDetailsRoute(placeDetails);
                        _ref = (0,utils_transformPlaces__WEBPACK_IMPORTED_MODULE_7__/* .transformPlaces */ .P)(placeDetails), address1 = _ref.address1, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_ref, [
                            "address1"
                        ]);
                        _tmp = {};
                        if (onSelect) {
                            onSelect((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((_tmp.address1 = address1, _tmp), rest));
                        }
                        return [
                            3,
                            3
                        ];
                    case 2:
                        e = _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function onOptionSelect(address) {
            return _ref.apply(this, arguments);
        };
    }();
    var filter = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(param) {
        var value = param.value, setOptions = param.setOptions;
        var shouldAutocomplete = !utils_constants__WEBPACK_IMPORTED_MODULE_3__/* .isServer */ .sk && googleAutocompleteEnabled && (value === null || value === void 0 ? void 0 : value.length) > 0;
        if (shouldAutocomplete) {
            autoComplete(value, lookupConstraints).then(function(addr) {
                return setOptions(generateOptions(addr));
            });
        }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        lookupConstraints
    ]);
    var debouncedFilter = (0,utils_debounce__WEBPACK_IMPORTED_MODULE_6__/* .debounce */ .D)(filter, 250);
    var handleBlur = function(e) {
        if (onBlur) {
            onBlur(e.target.value);
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_2__/* .InputCombobox */ .kec, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, rest), {
        typeahead: true,
        onOptionSelect: onOptionSelect,
        filter: debouncedFilter,
        onBlur: onBlur ? handleBlur : undefined,
        ref: ref
    }));
};
var AddressLookup = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(AddressLookupComp);


/***/ }),

/***/ 6485:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85034);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70169);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31373);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27378);
/* harmony import */ var _global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12601);
/* harmony import */ var hooks_useTranslations__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77480);







var CloseButton = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function CloseButton(props, ref) {
    var t = (0,hooks_useTranslations__WEBPACK_IMPORTED_MODULE_3__/* .useTranslate */ .qM)();
    var label = props.label, _dataTestId = props.dataTestId, dataTestId = _dataTestId === void 0 ? "close-btn" : _dataTestId, _size = props.size, size = _size === void 0 ? "base" : _size, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(props, [
        "label",
        "dataTestId",
        "size"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_2__/* .ButtonIcon */ .Eik, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        dataTestId: dataTestId,
        icon: "close",
        label: label !== null && label !== void 0 ? label : t("close"),
        mode: "icon",
        size: size,
        variant: "ghost"
    }, rest), {
        ref: ref
    }));
});
/* harmony default export */ __webpack_exports__["Z"] = (CloseButton);


/***/ }),

/***/ 43116:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ CvvModal; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27378);
/* harmony import */ var _global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12601);
/* harmony import */ var hooks_useTranslations__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77480);
/* harmony import */ var ui_components_Modal__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51377);
/* harmony import */ var _CloseButton__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6485);






var CvvModal = function(param) {
    var handleClose = param.handleClose;
    var t = (0,hooks_useTranslations__WEBPACK_IMPORTED_MODULE_3__/* .useTranslate */ .qM)();
    var fallbackHandleClose = function() {
        return null;
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(ui_components_Modal__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        variant: "dark",
        onClickOutside: handleClose,
        className: "w-full max-w-md px-8 pb-8 pt-9 relative",
        dataTestId: "cvv-hint-modal",
        containerClassName: "z-[1000]",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CloseButton__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                onClick: handleClose !== null && handleClose !== void 0 ? handleClose : fallbackHandleClose,
                className: "absolute top-8 right-5 !mt-0"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_2__/* .Stack */ .Kqy, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                        className: "text-xl font-bold uppercase w-11/12",
                        children: t("whereToFindCVV")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                        className: "block text-lg font-bold",
                        children: "Visa, MasterCard"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: "/assets/cvv_visa.png",
                        className: "w-full max-w-64",
                        width: "420",
                        height: "267"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        children: t("cvvVisaInstructions")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                        className: "block text-lg font-bold",
                        children: "American Express"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: "/assets/cvv_express.png",
                        className: "w-full max-w-64",
                        width: "420",
                        height: "267"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        children: t("cvvAmexInstructions")
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 46502:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ FooterLink; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85034);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31373);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var twind__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34209);
/* harmony import */ var ui_elements_Link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68302);





var FooterLink = function(_param) {
    var _linkStyle = _param.linkStyle, linkStyle = _linkStyle === void 0 ? "text-base" : _linkStyle, href = _param.href, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "linkStyle",
        "href"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ui_elements_Link__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .r, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        role: "menuitem",
        className: (0,twind__WEBPACK_IMPORTED_MODULE_4__.tw)("font-normal hover:text-white", linkStyle),
        href: href
    }, props));
};


/***/ }),

/***/ 34976:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ FooterLinks; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27378);
/* harmony import */ var utils_analytics__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83168);
/* harmony import */ var hooks_useLinkResolver__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(13022);
/* harmony import */ var _FooterLink__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(46502);





var FooterLinks = function(param) {
    var links = param.links, parentNavigationName = param.parentNavigationName, _listItemStyle = param.listItemStyle, listItemStyle = _listItemStyle === void 0 ? "flex" : _listItemStyle, _linkStyle = param.linkStyle, linkStyle = _linkStyle === void 0 ? "" : _linkStyle;
    var getLink = (0,hooks_useLinkResolver__WEBPACK_IMPORTED_MODULE_3__/* .useLinkResolver */ .u)().getLink;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: links === null || links === void 0 ? void 0 : links.map(function(link) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                role: "none",
                className: listItemStyle,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_FooterLink__WEBPACK_IMPORTED_MODULE_4__/* .FooterLink */ .S, {
                    role: "menuitem",
                    newtab: !!link.newtab,
                    linkStyle: linkStyle,
                    onClick: function() {
                        if (link.title) {
                            (0,utils_analytics__WEBPACK_IMPORTED_MODULE_2__/* .footerNavigationEvent */ .ZG)({
                                parentNavigation: "".concat(parentNavigationName, ":").concat(link.title),
                                linkClicked: link.title
                            });
                        }
                        (0,utils_analytics__WEBPACK_IMPORTED_MODULE_2__/* .footerNavigationClickEvent */ .i7)("".concat(parentNavigationName, ":").concat(link.title));
                    },
                    href: getLink(link),
                    children: link.title
                })
            }, link._key);
        })
    });
};


/***/ }),

/***/ 91622:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ LoadingSpinner; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var _global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12601);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27378);
/* harmony import */ var twind_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(49224);




var LoadingSpinner = function(param) {
    var className = param.className, _dataTestId = param.dataTestId, dataTestId = _dataTestId === void 0 ? "loading-spinner" : _dataTestId;
    var pulse = (0,twind_css__WEBPACK_IMPORTED_MODULE_3__/* .animation */ .oQ)("4s ease infinite .2s", {
        "0%, 100%": {
            opacity: "0%"
        },
        "40%": {
            opacity: "10%"
        }
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,twind_css__WEBPACK_IMPORTED_MODULE_3__.tw)("m-auto max-w-[40vw] opacity-0", (0,twind_css__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(pulse), className),
        "data-test-id": dataTestId,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_1__/* .Icon */ .JO$, {
            name: "puma-wordmark"
        })
    });
};


/***/ }),

/***/ 3629:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ ItemCountBadge; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85034);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31373);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var _global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12601);
/* harmony import */ var twind__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34209);





var ItemCountBadge = function(_param) {
    var count = _param.count, _float = _param.float, float = _float === void 0 ? false : _float, _className = _param.className, className = _className === void 0 ? "" : _className, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "count",
        "float",
        "className"
    ]);
    return count > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_1__/* .Badge */ .Cts, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        className: (0,twind__WEBPACK_IMPORTED_MODULE_4__.tw)("pointer-events-none", float && "absolute z-10 -top-1 -right-1", className),
        label: String(count),
        "aria-hidden": "true",
        color: "brand",
        size: "sm",
        round: true
    }, props)) : null;
};


/***/ }),

/***/ 72805:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ MainNavSkeleton; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var twind__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34209);
/* harmony import */ var _Skeleton__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98463);



var MainNavSkeleton = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "desktop:absolute grid grid-cols-1 desktop:grid-cols-4 gap-2 desktop:gap-8 w-full desktop:h-full justify-center desktop:px-8",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Skeleton__WEBPACK_IMPORTED_MODULE_1__/* .Skeleton */ .O, {
                className: (0,twind__WEBPACK_IMPORTED_MODULE_2__.tw)("w-full h-8")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Skeleton__WEBPACK_IMPORTED_MODULE_1__/* .Skeleton */ .O, {
                className: (0,twind__WEBPACK_IMPORTED_MODULE_2__.tw)("w-full h-8")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Skeleton__WEBPACK_IMPORTED_MODULE_1__/* .Skeleton */ .O, {
                className: (0,twind__WEBPACK_IMPORTED_MODULE_2__.tw)("w-full h-8")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Skeleton__WEBPACK_IMPORTED_MODULE_1__/* .Skeleton */ .O, {
                className: (0,twind__WEBPACK_IMPORTED_MODULE_2__.tw)("w-full h-8")
            })
        ]
    });
};


/***/ }),

/***/ 234:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ PopoverForm; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var twind_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49224);
/* harmony import */ var _global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12601);
/* harmony import */ var ui_forms_AuthenticateForm__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8165);
/* harmony import */ var ui_forms_OTPForm__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(83688);
/* harmony import */ var hooks_useFeature__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(53625);
/* harmony import */ var hooks_useMainNav__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(14425);







var AuthForm = function(param) {
    var isOTPAuthEnabled = param.isOTPAuthEnabled, onClose = param.onClose, action = param.action;
    return isOTPAuthEnabled ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ui_forms_OTPForm__WEBPACK_IMPORTED_MODULE_4__/* .OTPAuthenticateForm */ .Q, {
        isInPopover: true,
        onClose: onClose,
        action: action
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ui_forms_AuthenticateForm__WEBPACK_IMPORTED_MODULE_3__/* .AuthenticateForm */ .c, {
        isInPopover: true,
        onClose: onClose,
        action: action
    });
};
var PopoverForm = function(props) {
    var action = props.action, isOpen = props.isOpen, isMobile = props.isMobile, buttonText = props.buttonText, handleClick = props.handleClick, onClose = props.onClose;
    var isOTPAuthEnabled = (0,hooks_useFeature__WEBPACK_IMPORTED_MODULE_5__/* .useFeature */ .S)("OTP_LOGIN");
    var popoverLoginEnabledJP = (0,hooks_useFeature__WEBPACK_IMPORTED_MODULE_5__/* .useFeature */ .S)("POPOVER_LOGIN_ENABLED_JP");
    var isRegisterOpen = (0,hooks_useMainNav__WEBPACK_IMPORTED_MODULE_6__/* .useMainNavContext */ .QH)().isRegisterOpen;
    var isForgotPasswordFormOpen = (0,hooks_useMainNav__WEBPACK_IMPORTED_MODULE_6__/* .useMainNavContext */ .QH)().isForgotPasswordFormOpen;
    return isMobile ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (0,twind_css__WEBPACK_IMPORTED_MODULE_1__.tw)("absolute top-0 bg-white w-full transform transition-all duration-500 overflow-y-hidden", {
            "h-screen": !isRegisterOpen || !popoverLoginEnabledJP,
            "translate-x-full invisible": !isOpen,
            "translate-x-0": isOpen
        }),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "bg-puma-black-400 bg-opacity-10 p-4 flex justify-between text-xl capitalize",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        "data-test-id": "mobile-nav-prev-icon",
                        "data-link-name": "go-back",
                        "data-link-location": "mobile-nav",
                        onClick: handleClick,
                        type: "button",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "text-puma-black-200",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_2__/* .Icon */ .JO$, {
                                name: "chevron-left",
                                size: "2xl"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                        children: buttonText
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "w-8"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (0,twind_css__WEBPACK_IMPORTED_MODULE_1__.tw)("mx-auto max-w-screen-xs px-3 pt-8", {
                    "pb-16": popoverLoginEnabledJP
                }),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AuthForm, {
                    isOTPAuthEnabled: isOTPAuthEnabled,
                    onClose: onClose,
                    action: action
                })
            })
        ]
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (0,twind_css__WEBPACK_IMPORTED_MODULE_1__.tw)("overflow-y-auto max-h-[calc(100vh-150px)] p-4 fixed bg-white z-10 top-0 right-0 w-full", {
            "transform transition-all duration-300": !isForgotPasswordFormOpen,
            "opacity-0 invisible": !isOpen,
            "border 0px solid rgb(229) opacity-100": isOpen
        }),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "w-full flex justify-center pb-5",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_2__/* .ButtonIcon */ .Eik, {
                        label: "chevron",
                        icon: "chevron-left",
                        invert: true,
                        onClick: handleClick,
                        className: "m-4 absolute top-0 left-0"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xvT, {
                        className: "mt-1 text-xl",
                        children: [
                            " ",
                            buttonText
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "pt-5 pb-3",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AuthForm, {
                    isOTPAuthEnabled: isOTPAuthEnabled,
                    onClose: onClose,
                    action: action
                })
            })
        ]
    });
};


/***/ }),

/***/ 93512:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ ManagedHeading; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85034);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70169);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(31373);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3204);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86677);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var hooks_useHeading__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99592);







var renderHeading = function(tag, content, attributes, dataTestId) {
    var contentWithoutHTag = react__WEBPACK_IMPORTED_MODULE_0__.Children.map(content, function(child) {
        if (/*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.isValidElement(child) && [
            "h1",
            "h2",
            "h3",
            "h4"
        ].includes(child.type)) {
            return child.props.children;
        }
        return child;
    });
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(tag, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, attributes), {
        "data-test-id": dataTestId
    }), contentWithoutHTag);
};
var flatten = function(children) {
    var flat = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    var ref;
    flat = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(flat).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_0__.Children.toArray(children)));
    if ((children === null || children === void 0 ? void 0 : children.props) && (children === null || children === void 0 ? void 0 : (ref = children.props) === null || ref === void 0 ? void 0 : ref.children)) {
        var ref1;
        return flatten(children === null || children === void 0 ? void 0 : (ref1 = children.props) === null || ref1 === void 0 ? void 0 : ref1.children, flat);
    }
    return flat;
};
var simplify = function(children) {
    var flat = flatten(children);
    return flat.map(function(param) {
        var key = param.key, ref = param.ref, type = param.type, props = param.props;
        var childProps = props || {};
        return {
            key: key,
            ref: ref,
            type: type,
            props: childProps
        };
    });
};
var compareObjs = function(obj1, obj2) {
    return JSON.stringify(obj1) === JSON.stringify(obj2);
};
var ManagedHeading = function(_param) {
    var tag = _param.tag, mainHeading = _param.mainHeading, children = _param.children, dataTestId = _param.dataTestId, dangerouslySetInnerHTML = _param.dangerouslySetInnerHTML, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_param, [
        "tag",
        "mainHeading",
        "children",
        "dataTestId",
        "dangerouslySetInnerHTML"
    ]);
    var ref = (0,hooks_useHeading__WEBPACK_IMPORTED_MODULE_2__/* .useHeading */ .h)(), headingRef = ref.headingRef, isPLPref = ref.isPLPref;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var DEFAULT_HEADING_TAG = "h4";
    var headingTag = tag !== null && tag !== void 0 ? tag : DEFAULT_HEADING_TAG;
    var isPDP = (router === null || router === void 0 ? void 0 : router.route) === "/[country]/[language]/pd/[model]/[id]";
    var isPLP = isPLPref.current && (router === null || router === void 0 ? void 0 : router.route) === "/[country]/[language]/[...category]";
    var isPDPorPLP = isPDP || isPLP;
    var simpleChildren = typeof children === "string" ? children : simplify(children);
    if (headingTag === "h1") {
        if (!isPDPorPLP && (!headingRef.current || compareObjs(simpleChildren, headingRef.current)) || isPDPorPLP && mainHeading) {
            headingRef.current = simpleChildren;
            return renderHeading("h1", dangerouslySetInnerHTML ? null : children, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props), {
                dangerouslySetInnerHTML: dangerouslySetInnerHTML
            }), dataTestId);
        }
        return renderHeading("h2", dangerouslySetInnerHTML ? null : children, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props), {
            dangerouslySetInnerHTML: dangerouslySetInnerHTML
        }), dataTestId);
    }
    return renderHeading(headingTag, dangerouslySetInnerHTML ? null : children, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props), {
        dangerouslySetInnerHTML: dangerouslySetInnerHTML
    }), dataTestId);
};


/***/ }),

/***/ 51377:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27378);
/* harmony import */ var twind_style__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(79200);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31542);
/* harmony import */ var hooks_a11y__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(71129);
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(79758);
/* harmony import */ var hooks_useResizeObserver__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(13765);
/* harmony import */ var utils_media__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(39772);








var overlay = (0,twind_style__WEBPACK_IMPORTED_MODULE_2__/* .style */ .oB)({
    base: "flex fixed left-0 top-0 m-0 w-full h-screen z-50 overflow-y-auto font-display p-4 xs:p-8 overflow-y-scroll",
    variants: {
        variant: {
            light: "bg-white bg-opacity-50",
            dark: "bg-puma-black bg-opacity-50",
            darkOpacity: "bg-puma-black bg-opacity-10"
        },
        layout: {
            fullscreen: "xs:p-0 p-0",
            drawerLeft: "xs:p-0 p-0",
            drawerRight: "xs:p-0 p-0"
        }
    },
    defaults: {
        variant: "light"
    }
});
var modal = (0,twind_style__WEBPACK_IMPORTED_MODULE_2__/* .style */ .oB)({
    base: "relative bg-white m-auto shadow-xl rounded-md",
    variants: {
        variant: {
            light: "",
            dark: "",
            darkOpacity: ""
        },
        layout: {
            drawerLeft: "w-full max-w-md rounded-none ml-0 min-h-full",
            drawerRight: "w-full max-w-md rounded-none mr-0 min-h-full",
            fullscreen: "w-full rounded-none shadow-none min-h-full"
        }
    }
});
var Modal = function(props) {
    var ref = ((0,hooks_useResizeObserver__WEBPACK_IMPORTED_MODULE_6__/* .useResizeObserver */ .y)() || {}).ref;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(function() {
        var element = document.createElement("div");
        element.setAttribute("tabindex", "-1");
        return element;
    }), container = ref1[0];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useLayoutEffect)(function() {
        document.body.insertBefore(container, null);
        return function() {
            if (document.body.contains(container)) {
                document.body.removeChild(container);
            }
        };
    }, [
        container
    ]);
    var modalRef = react__WEBPACK_IMPORTED_MODULE_1__.useRef(null);
    (0,hooks_a11y__WEBPACK_IMPORTED_MODULE_4__/* .useDialogDismiss */ .sH)({
        ref: modalRef,
        handler: function(e) {
            var ref;
            // This prevents the Insider modal from interfering with the MiniCart modal's onClickOutside event
            // https://pumaglobal.atlassian.net/browse/CBC-7400
            if ((e === null || e === void 0 ? void 0 : e.target).closest(".ins-preview-wrapper")) return;
            return ((ref = props.onClickOutside) === null || ref === void 0 ? void 0 : ref.call(props)) || function() {
                return null;
            };
        }
    });
    (0,hooks_a11y__WEBPACK_IMPORTED_MODULE_4__/* .useFocusTrap */ .P5)({
        ref: modalRef,
        isActive: true,
        isFocused: props.isFocused
    });
    (0,hooks_a11y__WEBPACK_IMPORTED_MODULE_4__/* .useBodyScrollLock */ .yn)(true);
    if (utils_constants__WEBPACK_IMPORTED_MODULE_5__/* .isServer */ .sk) return null;
    var element = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        id: "modal",
        ref: ref,
        className: (0,twind_style__WEBPACK_IMPORTED_MODULE_2__.tw)(overlay({
            variant: props.variant,
            layout: props.layout
        }), props.containerClassName),
        "data-test-id": props.dataTestId,
        style: {
            margin: 0,
            border: 0,
            height: (0,utils_media__WEBPACK_IMPORTED_MODULE_7__/* .getIsMobile */ .W)() ? "100%" : window.innerHeight,
            top: 0,
            left: 0,
            pointerEvents: "auto"
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            role: "dialog",
            "aria-modal": "true",
            className: (0,twind_style__WEBPACK_IMPORTED_MODULE_2__.tw)(modal({
                variant: props.variant,
                layout: props.layout
            }), props.className, props.animateClassName),
            tabIndex: -1,
            ref: modalRef,
            "aria-labelledby": props["aria-labelledby"],
            children: props.children
        })
    });
    return /*#__PURE__*/ (0,react_dom__WEBPACK_IMPORTED_MODULE_3__.createPortal)(element, container);
};
/* harmony default export */ __webpack_exports__["Z"] = (Modal);


/***/ }),

/***/ 42413:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "hG": function() { return /* binding */ MINICART_PRICE_STRATEGY; },
  "iB": function() { return /* binding */ PDP_PRICE_STRATEGY; },
  "P8": function() { return /* binding */ PLP_PRICE_STRATEGY; },
  "jF": function() { return /* binding */ ProductPrice; },
  "Km": function() { return /* binding */ RECOMMENDATION_CAROUSEL_PRICE_STRATEGY; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(17599);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(85034);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(70169);
// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(24246);
// EXTERNAL MODULE: ../node_modules/next/router.js
var next_router = __webpack_require__(86677);
// EXTERNAL MODULE: ../node_modules/@global-ecom/nitro-uds/dist/elements/esm/index.js + 103 modules
var esm = __webpack_require__(12601);
// EXTERNAL MODULE: ./hooks/useFeature.ts
var useFeature = __webpack_require__(53625);
// EXTERNAL MODULE: ./hooks/usePriceFormatter.ts + 1 modules
var usePriceFormatter = __webpack_require__(23658);
// EXTERNAL MODULE: ./hooks/useTranslations.tsx
var useTranslations = __webpack_require__(77480);
// EXTERNAL MODULE: ./utils/getMinimalNumber.ts
var getMinimalNumber = __webpack_require__(23295);
// EXTERNAL MODULE: ./utils/isNumber.ts
var isNumber = __webpack_require__(95442);
// EXTERNAL MODULE: ./utils/calculateDiscountPercent.ts
var calculateDiscountPercent = __webpack_require__(883);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ../node_modules/twind/twind.js + 1 modules
var twind = __webpack_require__(34209);
;// CONCATENATED MODULE: ./ui/components/ProductPrice/types.ts
var PRICE_TYPE;
(function(PRICE_TYPE) {
    PRICE_TYPE["PROMOTION"] = "PROMOTION";
    PRICE_TYPE["SALE"] = "SALE";
    PRICE_TYPE["OLD_SALE"] = "OLD_SALE";
    PRICE_TYPE["OLD_REGULAR"] = "OLD_REGULAR";
    PRICE_TYPE["REGULAR"] = "REGULAR";
    PRICE_TYPE["PERSONALIZED"] = "PERSONALIZED";
    PRICE_TYPE["BEST_PRICE"] = "BEST_PRICE";
})(PRICE_TYPE || (PRICE_TYPE = {}));

;// CONCATENATED MODULE: ./ui/components/ProductPrice/PriceContent.tsx








var PriceContent = function(param) {
    var _compact = param.compact, compact = _compact === void 0 ? false : _compact, wrapText = param.wrapText, priceType = param.priceType, prices = param.prices, formattedPrice = param.formattedPrice, dataTestId = param.dataTestId, _className = param.className, className = _className === void 0 ? "" : _className, couponDiscount = param.couponDiscount, bestPriceDiscount = param.bestPriceDiscount, isSalePriceElapsed = param.isSalePriceElapsed, isPdp = param.isPdp;
    var t = (0,useTranslations/* useTranslate */.qM)();
    var showAllPricesAtOnce = (0,useFeature/* useFeature */.S)("SHOW_ALL_PRICES_AT_ONCE");
    var isGiftWithPurchaseNewDesign = (0,useFeature/* useFeature */.S)("GIFT_WITH_PURCHASE_NEW_DESIGN");
    var compactStyles = compact || showAllPricesAtOnce ? "text-base" : "text-sm 2xs:text-base sm:text-xl lg:text-lg xl:text-xl";
    var _sale;
    var percentDifference = (0,calculateDiscountPercent/* calculateDiscountPercent */.X)(prices.regular, (_sale = prices.sale) !== null && _sale !== void 0 ? _sale : prices.regular);
    var isFreeItem = prices.sale === 0;
    var getPriceContent = function(contentKey, contentVariables) {
        return t(contentKey, contentVariables);
    };
    var _obj;
    var priceOptions = (_obj = {}, (0,_define_property/* default */.Z)(_obj, PRICE_TYPE.REGULAR, {
        priceStyle: "font-bold",
        contentKey: "orderDetailAmount",
        variables: {
            amount: formattedPrice
        }
    }), (0,_define_property/* default */.Z)(_obj, PRICE_TYPE.OLD_REGULAR, {
        priceStyle: isPdp ? "line-through opacity-50" : "opacity-50",
        contentKey: "orderDetailSalePriceWithText",
        variables: {
            amount: formattedPrice,
            text: t("regularPrice")
        }
    }), (0,_define_property/* default */.Z)(_obj, PRICE_TYPE.PERSONALIZED, {
        priceStyle: "font-bold",
        contentKey: "orderDetailAmount",
        variables: {
            amount: formattedPrice
        }
    }), (0,_define_property/* default */.Z)(_obj, PRICE_TYPE.SALE, {
        priceStyle: "text-puma-red font-bold",
        contentKey: "orderDetailSalePriceWithPercentage",
        variables: {
            amount: formattedPrice,
            percentage: percentDifference
        }
    }), (0,_define_property/* default */.Z)(_obj, PRICE_TYPE.OLD_SALE, {
        priceStyle: "line-through opacity-50",
        contentKey: "orderDetailSalePriceWithPercentage",
        variables: {
            amount: formattedPrice,
            percentage: percentDifference
        }
    }), (0,_define_property/* default */.Z)(_obj, PRICE_TYPE.PROMOTION, {
        priceStyle: "".concat(isGiftWithPurchaseNewDesign && isFreeItem ? "text-success-60" : "text-puma-red", " font-bold"),
        contentKey: "orderDetailSalePriceWithPercentage",
        variables: {
            amount: formattedPrice,
            percentage: isSalePriceElapsed && couponDiscount ? couponDiscount : percentDifference
        }
    }), (0,_define_property/* default */.Z)(_obj, PRICE_TYPE.BEST_PRICE, {
        priceStyle: "line-through opacity-50",
        contentKey: "orderDetailSalePriceWithPercentage",
        variables: {
            amount: formattedPrice,
            percentage: bestPriceDiscount && bestPriceDiscount
        }
    }), _obj);
    var _priceType = priceOptions[priceType], contentKey = _priceType.contentKey, priceStyle = _priceType.priceStyle, variables = _priceType.variables;
    var priceContent = isGiftWithPurchaseNewDesign && isFreeItem ? t("free") : getPriceContent(contentKey, variables) || getPriceContent("orderDetailAmount", {
        amount: formattedPrice
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        className: (0,twind.tw)(!wrapText && "whitespace-nowrap", compactStyles, priceStyle, className ? "override:(".concat(className, ")") : ""),
        "data-test-id": dataTestId,
        children: (priceType === PRICE_TYPE.SALE || priceType === PRICE_TYPE.OLD_SALE) && isSalePriceElapsed ? formattedPrice : priceContent
    });
};

;// CONCATENATED MODULE: ./ui/components/ProductPrice/ProductPrice.tsx














var _obj, _obj1;
var PLP_PRICE_STRATEGY = {
    classNames: (_obj = {}, (0,_define_property/* default */.Z)(_obj, PRICE_TYPE.REGULAR, "opacity-100"), (0,_define_property/* default */.Z)(_obj, PRICE_TYPE.OLD_REGULAR, "text-puma-black-300 opacity-100"), _obj),
    dataTestIds: (_obj1 = {}, (0,_define_property/* default */.Z)(_obj1, PRICE_TYPE.REGULAR, "price"), (0,_define_property/* default */.Z)(_obj1, PRICE_TYPE.OLD_REGULAR, "price"), (0,_define_property/* default */.Z)(_obj1, PRICE_TYPE.SALE, "sale-price"), _obj1)
};
var _obj2, _obj3;
var PDP_PRICE_STRATEGY = {
    classNames: (_obj2 = {}, (0,_define_property/* default */.Z)(_obj2, PRICE_TYPE.REGULAR, "md:text-2xl opacity-100"), (0,_define_property/* default */.Z)(_obj2, PRICE_TYPE.OLD_REGULAR, "font-bold opacity-100"), (0,_define_property/* default */.Z)(_obj2, PRICE_TYPE.SALE, "text-xl md:text-2xl"), (0,_define_property/* default */.Z)(_obj2, PRICE_TYPE.BEST_PRICE, "text-sm opacity-100 line-through"), _obj2),
    dataTestIds: (_obj3 = {}, (0,_define_property/* default */.Z)(_obj3, PRICE_TYPE.REGULAR, "item-price-pdp"), (0,_define_property/* default */.Z)(_obj3, PRICE_TYPE.OLD_REGULAR, "item-price-pdp"), (0,_define_property/* default */.Z)(_obj3, PRICE_TYPE.SALE, "item-sale-price-pdp"), (0,_define_property/* default */.Z)(_obj3, PRICE_TYPE.BEST_PRICE, "item-best-price-pdp"), _obj3)
};
var _obj4;
var MINICART_PRICE_STRATEGY = {
    classNames: (_obj4 = {}, (0,_define_property/* default */.Z)(_obj4, PRICE_TYPE.REGULAR, "font-normal"), (0,_define_property/* default */.Z)(_obj4, PRICE_TYPE.OLD_REGULAR, "font-normal no-underline"), _obj4)
};
var _obj5;
var RECOMMENDATION_CAROUSEL_PRICE_STRATEGY = {
    classNames: (_obj5 = {}, (0,_define_property/* default */.Z)(_obj5, PRICE_TYPE.REGULAR, "xs:text-base text-sm"), (0,_define_property/* default */.Z)(_obj5, PRICE_TYPE.OLD_REGULAR, "xs:text-base text-sm font-normal"), (0,_define_property/* default */.Z)(_obj5, PRICE_TYPE.SALE, "xs:text-base text-sm"), (0,_define_property/* default */.Z)(_obj5, PRICE_TYPE.OLD_SALE, "xs:text-base text-sm font-normal"), (0,_define_property/* default */.Z)(_obj5, PRICE_TYPE.PROMOTION, "xs:text-base text-sm"), _obj5)
};
var ProductPrice = function(param) {
    var _compact = param.compact, compact = _compact === void 0 ? false : _compact, _wrapText = param.wrapText, wrapText = _wrapText === void 0 ? false : _wrapText, classNames = param.classNames, dataTestIds = param.dataTestIds, isFinalPrice = param.isFinalPrice, price = param.price, _isMinicart = param.isMinicart, isMinicart = _isMinicart === void 0 ? false : _isMinicart;
    var _amount = price.amount, amount = _amount === void 0 ? 0 : _amount, promotionPrice = price.promotionPrice, salePrice = price.salePrice, bestPrice = price.bestPrice, personalizationPrice = price.personalizationPrice, isSalePriceElapsed = price.isSalePriceElapsed;
    var showAllPricesAtOnce = (0,useFeature/* useFeature */.S)("SHOW_ALL_PRICES_AT_ONCE");
    var euCustomPriceFormating = (0,useFeature/* useFeature */.S)("EU_CUSTOM_PRICE_FORMATING");
    var is30DaysBestPrice = (0,useFeature/* useFeature */.S)("IS_30_DAYS_BEST_PRICE");
    var t = (0,useTranslations/* useTranslate */.qM)();
    var formatter = (0,usePriceFormatter/* usePriceFormatter */.o)();
    var router = (0,next_router.useRouter)();
    var isPdp = router.asPath.includes("pd");
    var normalizedRegularPrice = ((0,isNumber/* isNumber */.h)(amount) && amount !== 0 ? amount : salePrice || promotionPrice) || 0;
    var finalPrice = isFinalPrice ? (0,getMinimalNumber/* getMinimalNumber */.q)(amount, salePrice, promotionPrice) : undefined;
    var regularPrice = finalPrice !== null && finalPrice !== void 0 ? finalPrice : normalizedRegularPrice;
    var _amount1 = (0,isNumber/* isNumber */.h)(regularPrice) ? formatter(regularPrice) : "";
    var _salePrice = (0,isNumber/* isNumber */.h)(salePrice) ? formatter(salePrice) : "";
    var _bestPrice = (0,isNumber/* isNumber */.h)(bestPrice) ? formatter(bestPrice) : "";
    var _personalizedPrice = (0,isNumber/* isNumber */.h)(personalizationPrice) ? formatter(personalizationPrice) : "";
    var _promotionPrice = (0,isNumber/* isNumber */.h)(promotionPrice) ? formatter(promotionPrice) : "";
    var couponDiscount = salePrice && promotionPrice && (0,calculateDiscountPercent/* calculateDiscountPercent */.X)(salePrice, promotionPrice);
    var bestPriceDiscount = bestPrice && salePrice && (0,calculateDiscountPercent/* calculateDiscountPercent */.X)(salePrice, bestPrice);
    var oldRegularDiscount = salePrice && regularPrice && (0,calculateDiscountPercent/* calculateDiscountPercent */.X)(regularPrice, salePrice);
    var renderPriceContent = function(priceType) {
        var props = {
            priceType: priceType,
            compact: compact,
            couponDiscount: couponDiscount !== null && couponDiscount !== void 0 ? couponDiscount : undefined,
            bestPriceDiscount: bestPriceDiscount !== null && bestPriceDiscount !== void 0 ? bestPriceDiscount : undefined,
            isSalePriceElapsed: isSalePriceElapsed !== null && isSalePriceElapsed !== void 0 ? isSalePriceElapsed : undefined
        };
        var dataTestId = dataTestIds && dataTestIds[priceType];
        var className = classNames && classNames[priceType];
        switch(priceType){
            case PRICE_TYPE.PROMOTION:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceContent, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                    prices: {
                        regular: regularPrice,
                        sale: promotionPrice
                    },
                    formattedPrice: _promotionPrice,
                    dataTestId: dataTestId || "item-price",
                    className: className
                }), priceType);
            case PRICE_TYPE.SALE:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceContent, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                    prices: {
                        regular: regularPrice,
                        sale: salePrice
                    },
                    formattedPrice: _salePrice,
                    dataTestId: dataTestId || "item-price",
                    className: className
                }), priceType);
            case PRICE_TYPE.OLD_SALE:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceContent, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                    prices: {
                        regular: regularPrice,
                        sale: salePrice
                    },
                    formattedPrice: _salePrice,
                    className: className
                }), priceType);
            case PRICE_TYPE.REGULAR:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceContent, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                    prices: {
                        regular: regularPrice
                    },
                    formattedPrice: _amount1,
                    dataTestId: dataTestId || "item-price",
                    className: className
                }), priceType);
            case PRICE_TYPE.PERSONALIZED:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceContent, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                    prices: {
                        regular: personalizationPrice
                    },
                    formattedPrice: _personalizedPrice,
                    dataTestId: dataTestId || "item-price-personalized",
                    className: className
                }), priceType);
            case PRICE_TYPE.OLD_REGULAR:
                var content = euCustomPriceFormating ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Stack */.Kqy, {
                    direction: "row",
                    items: "center",
                    className: "w-100 flex-nowrap",
                    gap: {
                        _: "sm",
                        lg: "xs"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Text */.xvT, {
                            "data-test-id": "rrp-text",
                            size: "sm",
                            color: "muted",
                            weight: "normal",
                            children: [
                                t("rrp"),
                                ":"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceContent, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                            prices: {
                                regular: regularPrice
                            },
                            formattedPrice: _amount1,
                            dataTestId: dataTestId || "item-price-base-eu",
                            className: "".concat(className, " override:text-sm"),
                            wrapText: wrapText,
                            isPdp: isPdp
                        }), priceType),
                        !!oldRegularDiscount && oldRegularDiscount !== 0 && !isMinicart && isPdp && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Badge */.Cts, {
                            color: "error",
                            label: "-".concat(oldRegularDiscount, "%"),
                            outline: true,
                            round: true,
                            size: "base"
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceContent, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                    prices: {
                        regular: regularPrice
                    },
                    formattedPrice: _amount1,
                    dataTestId: dataTestId || "item-price-base",
                    className: className,
                    wrapText: wrapText
                }), priceType);
                return content;
            case PRICE_TYPE.BEST_PRICE:
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Stack */.Kqy, {
                    direction: "row",
                    items: "center",
                    className: "w-100",
                    gap: {
                        _: "sm",
                        lg: "xs"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Text */.xvT, {
                            "data-test-id": "rrp-text",
                            size: "sm",
                            color: "muted",
                            weight: "normal",
                            children: [
                                t("bestPrice"),
                                ":"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceContent, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                            prices: {
                                regular: regularPrice
                            },
                            formattedPrice: _bestPrice,
                            dataTestId: dataTestId || "item-best-price",
                            className: "".concat(className, " override:text-sm"),
                            wrapText: wrapText
                        }), priceType),
                        !!bestPriceDiscount && bestPriceDiscount !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Text */.xvT, {
                            "data-test-id": "best-price-discount",
                            size: "xs",
                            color: "muted",
                            children: [
                                bestPriceDiscount,
                                "%"
                            ]
                        })
                    ]
                });
            default:
                return null;
        }
    };
    var prices = [
        PRICE_TYPE.REGULAR
    ];
    if (isFinalPrice) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: prices.map(renderPriceContent)
        });
    }
    // For personalized products we always show the personalized price
    // There are upcoming changes to how this is handled in SF which will
    // be handled in https://pumaglobal.atlassian.net/browse/WEB-343
    if (personalizationPrice) {
        prices = [
            PRICE_TYPE.PERSONALIZED
        ];
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: prices.map(renderPriceContent)
        });
    }
    if ((0,isNumber/* isNumber */.h)(salePrice) && (0,isNumber/* isNumber */.h)(promotionPrice) && salePrice !== regularPrice && promotionPrice !== regularPrice && promotionPrice !== salePrice) {
        prices = showAllPricesAtOnce ? [
            PRICE_TYPE.PROMOTION,
            PRICE_TYPE.OLD_SALE,
            PRICE_TYPE.OLD_REGULAR
        ] : [
            PRICE_TYPE.PROMOTION,
            PRICE_TYPE.OLD_REGULAR
        ];
        if (isSalePriceElapsed) {
            prices = [
                PRICE_TYPE.PROMOTION,
                PRICE_TYPE.OLD_SALE
            ];
        }
        // Add best price if available
        if (is30DaysBestPrice && (0,isNumber/* isNumber */.h)(bestPrice)) {
            prices.push(PRICE_TYPE.BEST_PRICE);
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: prices.map(renderPriceContent)
        });
    }
    if ((0,isNumber/* isNumber */.h)(salePrice) && salePrice !== regularPrice) {
        prices = [
            PRICE_TYPE.SALE,
            PRICE_TYPE.OLD_REGULAR
        ];
        if (isSalePriceElapsed) {
            prices = [
                PRICE_TYPE.SALE
            ];
        }
        // Add best price if available
        if (is30DaysBestPrice && (0,isNumber/* isNumber */.h)(bestPrice)) {
            prices.push(PRICE_TYPE.BEST_PRICE);
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: prices.map(renderPriceContent)
        });
    }
    if ((0,isNumber/* isNumber */.h)(promotionPrice) && promotionPrice !== regularPrice) {
        prices = [
            PRICE_TYPE.PROMOTION,
            PRICE_TYPE.OLD_REGULAR
        ];
        // Add best price if available
        if (is30DaysBestPrice && (0,isNumber/* isNumber */.h)(bestPrice)) {
            prices.push(PRICE_TYPE.BEST_PRICE);
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: prices.map(renderPriceContent)
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: prices.map(renderPriceContent)
    });
};


/***/ }),

/***/ 86468:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ SanityImage; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(85034);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var twind_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49224);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27378);
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79758);
/* harmony import */ var utils_image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(75350);
/* harmony import */ var ui_elements_ImageOverlay__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26730);
/* harmony import */ var hooks_useGA4Events__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(89113);








var placeholderImage = "data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==";
var imageFormat = "q=80&auto=format";
var SanityImage = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12;
    var fireClickProductImage = (0,hooks_useGA4Events__WEBPACK_IMPORTED_MODULE_6__/* .useGA4Events */ .tL)().fireClickProductImage;
    var asset = (ref = props.source) === null || ref === void 0 ? void 0 : ref.asset;
    var mobileAsset = (ref1 = props.mobileSource) === null || ref1 === void 0 ? void 0 : ref1.asset;
    var mobileMediaCondition = (0,utils_image__WEBPACK_IMPORTED_MODULE_4__/* .getImageMediaCondition */ .uG)("mobile");
    var tabletMediaCondition = (0,utils_image__WEBPACK_IMPORTED_MODULE_4__/* .getImageMediaCondition */ .uG)("tablet");
    var desktopMediaCondition = (0,utils_image__WEBPACK_IMPORTED_MODULE_4__/* .getImageMediaCondition */ .uG)("desktop");
    var allSourcesNormalized = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
        var sourcesNormalized = ((ref = props.source) === null || ref === void 0 ? void 0 : (ref1 = ref.asset) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.cloudinary) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.transformations) === null || ref3 === void 0 ? void 0 : ref3.length) ? props.source.asset.cloudinary.transformations : [
            {
                _key: "sanity-cdn-image-1",
                url: "".concat(asset === null || asset === void 0 ? void 0 : asset.url, "?w=2160&").concat(imageFormat),
                width: 2160,
                media: desktopMediaCondition,
                platform: "desktop"
            },
            {
                _key: "sanity-cdn-image-2",
                url: "".concat(asset === null || asset === void 0 ? void 0 : asset.url, "?w=1440&").concat(imageFormat),
                width: 1440,
                media: tabletMediaCondition,
                platform: "desktop"
            }, 
        ];
        var mobileSourcesNormalized = ((ref4 = props.mobileSource) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.asset) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.cloudinary) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.transformations) === null || ref7 === void 0 ? void 0 : ref7.length) ? props.mobileSource.asset.cloudinary.transformations : sourcesNormalized.every(function(s) {
            return s.platform !== "all";
        }) ? [
            {
                _key: "sanity-cdn-image-3",
                url: "".concat((mobileAsset === null || mobileAsset === void 0 ? void 0 : mobileAsset.url) || (asset === null || asset === void 0 ? void 0 : asset.url), "?w=720&").concat(imageFormat),
                width: 720,
                media: mobileMediaCondition,
                platform: "mobile"
            }, 
        ] : null;
        return sourcesNormalized.concat(mobileSourcesNormalized || []);
    }, [
        (ref2 = props.source) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.asset) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.cloudinary) === null || ref4 === void 0 ? void 0 : ref4.transformations,
        (ref5 = props.mobileSource) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.asset) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.cloudinary) === null || ref7 === void 0 ? void 0 : ref7.transformations,
        asset === null || asset === void 0 ? void 0 : asset.url,
        mobileAsset === null || mobileAsset === void 0 ? void 0 : mobileAsset.url,
        desktopMediaCondition,
        tabletMediaCondition,
        mobileMediaCondition, 
    ]);
    var hasUrl = (asset === null || asset === void 0 ? void 0 : asset.url) || (mobileAsset === null || mobileAsset === void 0 ? void 0 : mobileAsset.url);
    if (!hasUrl) return null;
    var blur = (asset === null || asset === void 0 ? void 0 : asset.metadata.lqip) || (mobileAsset === null || mobileAsset === void 0 ? void 0 : mobileAsset.metadata.lqip);
    var alt = ((ref8 = props.source) === null || ref8 === void 0 ? void 0 : ref8.alt) || ((ref9 = props.mobileSource) === null || ref9 === void 0 ? void 0 : ref9.alt);
    var shouldRender = props.priority || !utils_constants__WEBPACK_IMPORTED_MODULE_3__/* .isServer */ .sk;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("picture", {
        "data-test-id": "sanity-image",
        className: (0,twind_css__WEBPACK_IMPORTED_MODULE_1__.tw)("flex bg-puma-black-800 pointer-events-none", props.preserveImageWidth ? "" : "w-full", props.relative ? "relative" : "absolute inset-0 h-full", props.className),
        style: shouldRender ? {
            backgroundImage: "url(".concat(blur, ")"),
            backgroundSize: "cover"
        } : undefined,
        children: [
            shouldRender && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: allSourcesNormalized.map(function(source) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("source", {
                        "data-test-id": "sanity-image-source",
                        srcSet: source.url,
                        width: props.preserveImageWidth ? source.width : undefined,
                        media: source.media || undefined,
                        onClick: function() {
                            return fireClickProductImage(source.url || "");
                        }
                    }, source._key);
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                "data-test-id": "sanity-image-element",
                srcSet: placeholderImage,
                className: "object-cover w-full h-full",
                alt: alt || props.defaultAlt || undefined,
                loading: props.priority ? "eager" : "lazy",
                decoding: "auto",
                fetchpriority: props.priority ? "high" : undefined
            }),
            ((ref10 = props.source) === null || ref10 === void 0 ? void 0 : ref10.overlay) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ui_elements_ImageOverlay__WEBPACK_IMPORTED_MODULE_5__/* .ImageOverlay */ .v, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
                className: "invisible tablet:visible desktop:visible"
            }, props.source.overlay)),
            ((ref11 = props.mobileSource) === null || ref11 === void 0 ? void 0 : ref11.overlay) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ui_elements_ImageOverlay__WEBPACK_IMPORTED_MODULE_5__/* .ImageOverlay */ .v, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
                className: "invisible mobile:visible"
            }, (ref12 = props.mobileSource) === null || ref12 === void 0 ? void 0 : ref12.overlay))
        ]
    });
};


/***/ }),

/***/ 98463:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ Skeleton; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27378);
/* harmony import */ var twind_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(49224);



var Skeleton = function(param) {
    var className = param.className, children = param.children, _animate = param.animate, animate = _animate === void 0 ? true : _animate, _delay = param.delay, delay = _delay === void 0 ? "0ms" : _delay;
    var pulse = (0,twind_css__WEBPACK_IMPORTED_MODULE_2__/* .animation */ .oQ)("4s ease infinite ".concat(delay), {
        "0%, 100%": {
            opacity: "5%"
        },
        "40%": {
            opacity: "20%"
        }
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        "data-test-id": "skeleton-loader",
        className: (0,twind_css__WEBPACK_IMPORTED_MODULE_2__.tw)("bg-puma-black-400 rounded-sm opacity-5 cursor-wait", animate ? (0,twind_css__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(pulse) : "opacity-20", className),
        "aria-hidden": "true",
        children: children
    });
};


/***/ }),

/***/ 99750:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ TermsAndConditions; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(5341);
// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(24246);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ../node_modules/urql/dist/urql.es.js
var urql_es = __webpack_require__(25380);
// EXTERNAL MODULE: ../node_modules/next/router.js
var next_router = __webpack_require__(86677);
// EXTERNAL MODULE: ../node_modules/@sanity/block-content-to-react/lib/BlockContent.js
var BlockContent = __webpack_require__(57178);
var BlockContent_default = /*#__PURE__*/__webpack_require__.n(BlockContent);
// EXTERNAL MODULE: ./utils/serializeBlockContent.tsx
var serializeBlockContent = __webpack_require__(88313);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(19989);
// EXTERNAL MODULE: ../node_modules/@urql/core/dist/urql-core.mjs
var urql_core = __webpack_require__(70463);
;// CONCATENATED MODULE: ./gql/fragments/portableBlock.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment portableTextFields on PortableText {\n    _type\n    _key\n    children {\n      _type\n      _key\n      text\n      marks\n    }\n    markDefs {\n      _type\n      _key\n      _ref\n      href\n      link\n      newtab\n    }\n    style\n    level\n    listItem\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var PORTABLE_BLOCK_FRAGMENT = (0,urql_core/* gql */.Ps)(_templateObject());

;// CONCATENATED MODULE: ./gql/fragments/termsAndConditions.ts

function termsAndConditions_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment termsAndConditionsFields on TermsAndConditions {\n    id\n    __typename\n    content {\n      ...portableTextFields\n    }\n  }\n  ",
        "\n"
    ]);
    termsAndConditions_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var TERMS_AND_CONDITIONS_FRAGMENT = (0,urql_core/* gql */.Ps)(termsAndConditions_templateObject(), PORTABLE_BLOCK_FRAGMENT);

;// CONCATENATED MODULE: ./gql/queries/termsAndConditions.ts

function queries_termsAndConditions_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query TermsAndConditionsConfigs($isDraft: String) {\n    termsAndConditionsConfigs(isDraft: $isDraft) {\n      id\n      tacOnCartPage {\n        ...termsAndConditionsFields\n      }\n      tacOnItemAddedPopup {\n        ...termsAndConditionsFields\n      }\n      tacOnCheckoutSignInArea {\n        ...termsAndConditionsFields\n      }\n      tacOnCheckoutConfirmation {\n        ...termsAndConditionsFields\n      }\n      tacOnCheckoutAddress {\n        ...termsAndConditionsFields\n      }\n      tacOnCreateAccount {\n        ...termsAndConditionsFields\n      }\n      tacOnCheckoutPayment {\n        ...termsAndConditionsFields\n      }\n      showAbove\n    }\n  }\n\n  ",
        "\n"
    ]);
    queries_termsAndConditions_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var TERMS_AND_CONDITIONS_QUERY = (0,urql_core/* gql */.Ps)(queries_termsAndConditions_templateObject(), TERMS_AND_CONDITIONS_FRAGMENT);

;// CONCATENATED MODULE: ./ui/components/TermsAndConditions.tsx








var TermsAndConditionsSection = function(param) {
    var showAbove = param.showAbove, children = param.children, className = param.className, blocks = param.blocks, portableText = param.portableText, serializers = param.serializers;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            !showAbove && children,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                "data-test-id": "terms-and-conditions",
                className: className ? className : "text-xs normal-case",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((BlockContent_default()), {
                    blocks: (blocks === null || blocks === void 0 ? void 0 : blocks.blocks) ? blocks.blocks : portableText,
                    serializers: serializers || serializeBlockContent/* serializeTocBlockContent */.lw
                })
            }),
            showAbove && children
        ]
    });
};
function TermsAndConditions(props) {
    var ref, ref1, ref2, ref3;
    var children = props.children, backupContent = props.backupContent, page = props.page, className = props.className, serializers = props.serializers, blocks = props.blocks;
    var router = (0,next_router.useRouter)();
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,urql_es/* useQuery */.aM)({
        query: TERMS_AND_CONDITIONS_QUERY,
        variables: {
            isDraft: router.query.draft
        }
    }), 1), config = ref4[0];
    var portableText = (config === null || config === void 0 ? void 0 : (ref = config.data) === null || ref === void 0 ? void 0 : ref.termsAndConditionsConfigs) && ((ref1 = config.data.termsAndConditionsConfigs[page]) === null || ref1 === void 0 ? void 0 : ref1.content);
    var showAbove = config === null || config === void 0 ? void 0 : (ref2 = config.data) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.termsAndConditionsConfigs) === null || ref3 === void 0 ? void 0 : ref3.showAbove;
    if (config.fetching) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: children
        });
    }
    if (config.error || !portableText) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                children,
                backupContent
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TermsAndConditionsSection, {
        showAbove: showAbove,
        children: children,
        className: className,
        blocks: blocks,
        portableText: portableText,
        serializers: serializers
    });
};


/***/ }),

/***/ 95459:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ TermsAndConditionsBackup; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var _global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12601);
/* harmony import */ var hooks_useSiteConfig__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20368);
/* harmony import */ var hooks_useTranslations__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77480);
/* harmony import */ var ui_elements_Link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68302);





var TermsLink = function(param) {
    var externalUrl = param.externalUrl, text = param.text;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ui_elements_Link__WEBPACK_IMPORTED_MODULE_4__/* .Link */ .r, {
        href: externalUrl !== null && externalUrl !== void 0 ? externalUrl : "/help/terms-and-conditions",
        rel: "noopener",
        className: "underline text-xs px-0.5",
        target: externalUrl ? "_blank" : undefined,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
            children: [
                text,
                externalUrl && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_1__/* .Icon */ .JO$, {
                    name: "external-link",
                    size: "xxs",
                    className: "inline"
                })
            ]
        })
    });
};
function TermsAndConditionsBackup(props) {
    var t = (0,hooks_useTranslations__WEBPACK_IMPORTED_MODULE_3__/* .useTranslate */ .qM)();
    var legal = (0,hooks_useSiteConfig__WEBPACK_IMPORTED_MODULE_2__/* .useSiteConfig */ .N)().legal;
    var prefixText = props.page === "tacOnCreateAccount" ? t("byLogging") : t("byContinuing");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
            className: "text-xs",
            children: [
                prefixText,
                " ",
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TermsLink, {
                    externalUrl: legal === null || legal === void 0 ? void 0 : legal.termsAndConditions,
                    text: t("termsAndConditions")
                }),
                t("andThe"),
                " ",
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TermsLink, {
                    externalUrl: legal === null || legal === void 0 ? void 0 : legal.privacyPolicy,
                    text: t("privacyPolicy")
                }),
                "."
            ]
        })
    });
};


/***/ }),

/***/ 85814:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "l": function() { return /* binding */ CallToActions; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(85034);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(70169);
// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(24246);
// EXTERNAL MODULE: ../node_modules/twind/twind.js + 1 modules
var twind = __webpack_require__(34209);
// EXTERNAL MODULE: ./ui/elements/Link.tsx
var Link = __webpack_require__(68302);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ./hooks/useSiteConfig.ts
var useSiteConfig = __webpack_require__(20368);
;// CONCATENATED MODULE: ./hooks/useSerializeLocaleString.ts


var useSerializeLocaleString = function() {
    var language = (0,useSiteConfig/* useSiteConfig */.N)().language;
    return (0,react.useCallback)(function(str) {
        if (language && str && str[language]) {
            return typeof str[language] === "string" ? str[language] : "";
        }
        return typeof str === "string" ? str : "";
    }, [
        language
    ]);
};
/* harmony default export */ var hooks_useSerializeLocaleString = (useSerializeLocaleString);

// EXTERNAL MODULE: ./hooks/useLinkResolver.ts
var useLinkResolver = __webpack_require__(13022);
;// CONCATENATED MODULE: ./ui/content/CallToActions.tsx







var CallToActions = function(props) {
    var ref, ref1;
    var ref2;
    var isAnchor = (ref2 = (ref = props.linkProps) === null || ref === void 0 ? void 0 : ref.isAnchor) !== null && ref2 !== void 0 ? ref2 : true;
    var serialize = hooks_useSerializeLocaleString();
    var getLink = (0,useLinkResolver/* useLinkResolver */.u)().getLink;
    if (!((ref1 = props.ctas) === null || ref1 === void 0 ? void 0 : ref1.length)) return null;
    var ref3, ref4;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: props.ctas.map(function(cta) {
            var ref, ref1;
            /*#__PURE__*/ return (0,jsx_runtime.jsx)(Link/* Link */.r, {
                dataTestId: "call-to-action",
                href: getLink(cta),
                as: "button",
                variant: (ref4 = (ref3 = (ref = props.linkProps) === null || ref === void 0 ? void 0 : ref.variant) !== null && ref3 !== void 0 ? ref3 : cta.variant) !== null && ref4 !== void 0 ? ref4 : "black",
                className: (0,twind.tw)("pointer-events-auto whitespace-normal", props.className),
                outlined: !!cta.outlined,
                newtab: !!cta.newtab,
                popup: !!cta.popup,
                query: cta.query,
                action: cta.action || undefined,
                underlined: (ref1 = props.linkProps) === null || ref1 === void 0 ? void 0 : ref1.underlined,
                gaBannerData: props.gaBannerData,
                ga4Data: props.ga4Data && (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props.ga4Data), {
                    link_url: getLink(cta),
                    cta_click: cta.title || ""
                }),
                isAnchor: isAnchor,
                children: serialize(cta.title)
            }, cta._key);
        })
    });
};


/***/ }),

/***/ 83949:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "w": function() { return /* binding */ ClampedInfoMessageText; }
});

// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(24246);
// EXTERNAL MODULE: ../node_modules/next/router.js
var next_router = __webpack_require__(86677);
// EXTERNAL MODULE: ../node_modules/clamp-js/clamp.js
var clamp = __webpack_require__(13512);
var clamp_default = /*#__PURE__*/__webpack_require__.n(clamp);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
;// CONCATENATED MODULE: ./hooks/useClampedText.ts


var TEXT_TO_CLAMP_GHOST_ELEMENT = "text-to-clamp-ghost-element";
var useClampedText = function(param) {
    var text = param.text, maxLines = param.maxLines, maxWidthInPx = param.maxWidthInPx, endHtml = param.endHtml;
    var ref = (0,react.useState)(""), clampedTextInnerHtml = ref[0], setClampedTextInnerHtml = ref[1];
    var setTheGhostElement = (0,react.useCallback)(function() {
        if (text) {
            var previousGhostTextToClampElement = document.getElementById(TEXT_TO_CLAMP_GHOST_ELEMENT);
            if (previousGhostTextToClampElement) previousGhostTextToClampElement.remove();
            var ghostElement = document.createElement("p");
            ghostElement.id = TEXT_TO_CLAMP_GHOST_ELEMENT;
            ghostElement.classList.add("absolute", "opacity-0", "-z-50");
            ghostElement.style.width = maxWidthInPx;
            ghostElement.style.padding = "8px 12px";
            ghostElement.style.fontSize = "14px";
            ghostElement.style.lineHeight = "1.428";
            ghostElement.innerHTML = text;
            document.body.appendChild(ghostElement);
        }
    }, [
        text,
        maxWidthInPx
    ]);
    var prepareClampedText = (0,react.useCallback)(function() {
        if (text) {
            var ghostTextToClampElement = document.getElementById(TEXT_TO_CLAMP_GHOST_ELEMENT);
            clamp_default()(ghostTextToClampElement, {
                clamp: maxLines,
                useNativeClamp: false,
                animate: false,
                truncationChar: "  ",
                truncationHTML: "...".concat(endHtml ? " " + endHtml : "")
            });
            if (ghostTextToClampElement) {
                setClampedTextInnerHtml(ghostTextToClampElement.innerHTML || "");
                ghostTextToClampElement.remove();
            }
        }
    }, [
        text,
        endHtml,
        maxLines
    ]);
    (0,react.useEffect)(function() {
        setTheGhostElement();
        prepareClampedText();
    }, [
        setTheGhostElement,
        prepareClampedText
    ]);
    return clampedTextInnerHtml;
};

// EXTERNAL MODULE: ./utils/constants.ts
var constants = __webpack_require__(79758);
// EXTERNAL MODULE: ./hooks/useWindowSize.ts
var useWindowSize = __webpack_require__(45746);
// EXTERNAL MODULE: ./utils/media.ts
var media = __webpack_require__(39772);
;// CONCATENATED MODULE: ./ui/content/ClampedInfoMessageText.tsx






var ClampedInfoMessageText = function(param) {
    var infoMessage = param.infoMessage, setShowInfoMessage = param.setShowInfoMessage, readMoreLink = param.readMoreLink;
    var isMobile = (0,media/* getIsMobile */.W)();
    var router = (0,next_router.useRouter)();
    var width = (0,useWindowSize/* useWindowSize */.i)().width;
    if (!constants/* isServer */.sk && !(window === null || window === void 0 ? void 0 : window.router)) {
        Object.defineProperty(window, "router", {
            value: router
        });
    }
    if (!constants/* isServer */.sk && !(window === null || window === void 0 ? void 0 : window.setShowInfoMessage)) {
        Object.defineProperty(window, "setShowInfoMessage", {
            value: setShowInfoMessage
        });
    }
    var clampedTextInnerHtml = useClampedText({
        maxLines: 6,
        maxWidthInPx: isMobile ? "".concat(String(width), "px") : "375px",
        text: infoMessage || "",
        endHtml: '<a href="'.concat(readMoreLink, '" onclick="((event) => {\n            event.preventDefault();\n            window.router.replace(event.target.href);\n            window.setShowInfoMessage(false)\n          })(event)" class="text-puma-black underline">Read more</a>')
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
        dangerouslySetInnerHTML: {
            __html: clampedTextInnerHtml
        }
    });
};


/***/ }),

/***/ 83057:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ ContentHeading; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27378);
/* harmony import */ var _global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12601);
/* harmony import */ var ui_components_ManagedHeading__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93512);
/* harmony import */ var ui_elements_Markdown__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41467);





var ContentHeading = function(param) {
    var header = param.header, className = param.className, headingTag = param.headingTag, dataTestId = param.dataTestId, children = param.children;
    var DEFAULT_HEAD_TAG = "h4";
    var HeadingTag = headingTag !== null && headingTag !== void 0 ? headingTag : DEFAULT_HEAD_TAG;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_2__/* .Heading */ .X6q, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(ui_components_ManagedHeading__WEBPACK_IMPORTED_MODULE_3__/* .ManagedHeading */ .P, {
            tag: HeadingTag,
            dataTestId: dataTestId,
            className: className,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ui_elements_Markdown__WEBPACK_IMPORTED_MODULE_4__/* .Markdown */ .U, {
                    content: header
                }),
                children
            ]
        })
    });
};


/***/ }),

/***/ 3099:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "h": function() { return /* binding */ CountdownClock; },
  "s": function() { return /* binding */ useIsCountdownAvailable; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(19989);
// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(24246);
// EXTERNAL MODULE: ../node_modules/twind/twind.js + 1 modules
var twind = __webpack_require__(34209);
// EXTERNAL MODULE: ../node_modules/next/router.js
var next_router = __webpack_require__(86677);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
;// CONCATENATED MODULE: ./hooks/useCountdown.ts

var MILLISECOND_IN_AN_HOUR = 3600000;
var MILLISECOND_IN_A_MINUTE = 60000;
var useCountdown = function(param) {
    var countdownEnd = param.countdownEnd;
    var ref = (0,react.useState)(function() {
        var target = new Date(countdownEnd).getTime();
        var remaining = target - Date.now();
        return calculateReturnValues(remaining);
    }), countdown = ref[0], setCountdown = ref[1];
    (0,react.useEffect)(function() {
        var target = new Date(countdownEnd).getTime();
        var t = setInterval(function() {
            var remaining = target - Date.now();
            setCountdown(calculateReturnValues(remaining));
            if (remaining <= 0) {
                clearInterval(t);
            }
        }, 1000);
        return function() {
            return clearInterval(t);
        };
    }, [
        countdownEnd
    ]);
    return countdown;
};
var calculateReturnValues = function(countdown) {
    // 1000 milliseconds in 1 second
    // 60 seconds in a minute
    // 60 mins in an hour
    // 24 hours in a day
    if (countdown < 1) {
        return {
            days: 0,
            hours: 0,
            minutes: 0,
            seconds: 0,
            lessThanAnHourRemaining: false,
            lessThanAMinuteRemaining: false
        };
    }
    // calculate time left
    var days = Math.floor(countdown / (MILLISECOND_IN_AN_HOUR * 24));
    var hours = Math.floor(countdown % (MILLISECOND_IN_AN_HOUR * 24) / MILLISECOND_IN_AN_HOUR);
    var minutes = Math.floor(countdown % MILLISECOND_IN_AN_HOUR / MILLISECOND_IN_A_MINUTE);
    var seconds = Math.floor(countdown % MILLISECOND_IN_A_MINUTE / 1000);
    var lessThanAnHourRemaining = countdown < MILLISECOND_IN_AN_HOUR;
    var lessThanAMinuteRemaining = countdown < MILLISECOND_IN_A_MINUTE;
    return {
        days: days,
        hours: hours,
        minutes: minutes,
        seconds: seconds,
        lessThanAnHourRemaining: lessThanAnHourRemaining,
        lessThanAMinuteRemaining: lessThanAMinuteRemaining
    };
};

// EXTERNAL MODULE: ./hooks/useTranslations.tsx
var useTranslations = __webpack_require__(77480);
// EXTERNAL MODULE: ./utils/media.ts
var media = __webpack_require__(39772);
// EXTERNAL MODULE: ./hooks/usePromotionView.ts
var usePromotionView = __webpack_require__(32736);
;// CONCATENATED MODULE: ./ui/content/CountdownClock.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "font-bold"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}








var DEFAULT_CONTAINER_CLASS_NAME = "text-base";
var DEFAULT_CONFIG = {
    containerClassName: DEFAULT_CONTAINER_CLASS_NAME,
    labelClassName: "",
    showLabels: false,
    timeUnitClassName: ""
};
var useIsCountdownAvailable = function(availableFrom, availableTo) {
    var router = (0,next_router.useRouter)();
    var _viewAt;
    var viewAt = (_viewAt = router.query.viewAt) !== null && _viewAt !== void 0 ? _viewAt : +new Date();
    var showClock = true;
    if (availableFrom && +new Date(availableFrom) > viewAt) showClock = false;
    if (availableTo && +new Date(availableTo) < viewAt) showClock = false;
    return showClock;
};
var CountdownClock = function(param) {
    var availableFrom = param.availableFrom, availableTo = param.availableTo, countdownEnd = param.countdownEnd, _config = param.config, config = _config === void 0 ? DEFAULT_CONFIG : _config, __typename = param.__typename, id = param.id;
    var isCountdownAvailable = useIsCountdownAvailable(availableFrom, availableTo);
    if (!isCountdownAvailable) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Clock, {
        config: config,
        countdownEnd: countdownEnd,
        id: id,
        typename: __typename
    });
};
var Clock = function(param) {
    var config = param.config, countdownEnd = param.countdownEnd, id = param.id, typename = param.typename;
    var translate = (0,useTranslations/* useTranslate */.qM)();
    var isDesktop = (0,media/* getIsDesktop */.w)();
    var _containerClassName = config.containerClassName, containerClassName = _containerClassName === void 0 ? DEFAULT_CONTAINER_CLASS_NAME : _containerClassName, labelClassName = config.labelClassName, showLabels = config.showLabels, timeUnitClassName = config.timeUnitClassName;
    var ref = useCountdown({
        countdownEnd: countdownEnd
    }), days = ref.days, hours = ref.hours, lessThanAMinuteRemaining = ref.lessThanAMinuteRemaining, lessThanAnHourRemaining = ref.lessThanAnHourRemaining, minutes = ref.minutes, seconds = ref.seconds;
    var sharedValueClassNames = (0,twind/* apply */.nn)("font-bold");
    var sharedSeparatorClassNames = (0,twind/* apply */.nn)([
        showLabels && "hidden"
    ]);
    var unboldDaysAndHours = lessThanAnHourRemaining || lessThanAMinuteRemaining;
    var countdownClockRef = (0,react.useRef)(null);
    var promotionId = id || "";
    var promotionName = "";
    var creativeName = typename || "CountdownClock";
    var gaTrackData = {
        id: promotionId,
        name: promotionName,
        creative: creativeName
    };
    (0,usePromotionView/* usePromotionView */.Y)(countdownClockRef, gaTrackData, true);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("time", {
        className: (0,twind.tw)("flex", containerClassName),
        role: "timer",
        dateTime: countdownEnd,
        ref: countdownClockRef,
        children: [
            days > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TimeUnit, {
                        value: days,
                        label: translate("days"),
                        showLabels: showLabels,
                        labelClassName: labelClassName,
                        timeUnitClassName: (0,twind.tw)([
                            sharedValueClassNames,
                            unboldDaysAndHours && "font-normal",
                            timeUnitClassName, 
                        ])
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TimeSeparator, {
                        className: (0,twind.tw)([
                            sharedSeparatorClassNames,
                            timeUnitClassName
                        ])
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TimeUnit, {
                value: hours,
                label: translate("hours"),
                showLabels: showLabels,
                labelClassName: labelClassName,
                timeUnitClassName: (0,twind.tw)([
                    sharedValueClassNames,
                    unboldDaysAndHours && "font-normal",
                    timeUnitClassName, 
                ])
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TimeSeparator, {
                className: (0,twind.tw)([
                    sharedSeparatorClassNames,
                    timeUnitClassName
                ])
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TimeUnit, {
                value: minutes,
                label: translate(isDesktop ? "minutes" : "minutesAbbreviation"),
                showLabels: showLabels,
                labelClassName: labelClassName,
                timeUnitClassName: (0,twind.tw)([
                    sharedValueClassNames,
                    lessThanAMinuteRemaining && "font-normal",
                    timeUnitClassName, 
                ])
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TimeSeparator, {
                className: (0,twind.tw)([
                    sharedSeparatorClassNames,
                    timeUnitClassName
                ])
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TimeUnit, {
                value: seconds,
                label: translate(isDesktop ? "seconds" : "secondsAbbreviation"),
                showLabels: showLabels,
                labelClassName: labelClassName,
                timeUnitClassName: (0,twind.tw)([
                    sharedValueClassNames,
                    timeUnitClassName
                ])
            })
        ]
    });
};
var TimeUnit = function(param) {
    var value = param.value, label = param.label, _showLabels = param.showLabels, showLabels = _showLabels === void 0 ? false : _showLabels, timeUnitClassName = param.timeUnitClassName, labelClassName = param.labelClassName;
    var showLeadingZero = value < 10;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col items-center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                className: timeUnitClassName,
                suppressHydrationWarning: true,
                children: [
                    showLeadingZero && "0",
                    value
                ]
            }),
            showLabels && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: labelClassName,
                suppressHydrationWarning: true,
                children: label
            })
        ]
    });
};
var TimeSeparator = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,twind.tw)([
            (0,twind/* apply */.nn)(_templateObject()),
            className
        ]),
        suppressHydrationWarning: true,
        children: ":"
    });
};


/***/ }),

/***/ 62079:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "S": function() { return /* binding */ FaqModule; }
});

// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(24246);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ../node_modules/@sanity/block-content-to-react/lib/BlockContent.js
var BlockContent = __webpack_require__(57178);
var BlockContent_default = /*#__PURE__*/__webpack_require__.n(BlockContent);
// EXTERNAL MODULE: ../node_modules/twind/css/css.js
var css = __webpack_require__(49224);
;// CONCATENATED MODULE: ./utils/portableTextToPlainText.ts
var defaults = {
    nonTextBehavior: "remove"
};
function portableBlocksToText(blocks) {
    var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var options = Object.assign({}, defaults, opts);
    return blocks.map(function(block) {
        if (block._type !== "block" || !block.children) {
            return options.nonTextBehavior === "remove" ? "" : "[".concat(block._type, " block]");
        }
        return block.children.map(function(child) {
            return child.text;
        }).join("");
    }).join("\n\n");
}

// EXTERNAL MODULE: ./ui/elements/InjectedScript.tsx
var InjectedScript = __webpack_require__(19735);
// EXTERNAL MODULE: ./ui/elements/Accordion.tsx
var Accordion = __webpack_require__(36998);
// EXTERNAL MODULE: ./utils/serializeBlockContent.tsx
var serializeBlockContent = __webpack_require__(88313);
// EXTERNAL MODULE: ./ui/content/ContentHeading.tsx
var ContentHeading = __webpack_require__(83057);
;// CONCATENATED MODULE: ./ui/content/FaqModule.tsx









var FaqModule = function(param) {
    var localeTitle = param.localeTitle, headingTag = param.headingTag, faqs = param.faqs, inPortableText = param.inPortableText;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,css.tw)("w-full flex flex-1 flex-col", !inPortableText && "px-6 pb-4"),
        children: [
            localeTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentHeading/* ContentHeading */.H, {
                header: localeTitle,
                className: (0,css.tw)("font-bold leading-tight", inPortableText ? "mt-0!" : "pb-4", "mobile:text-2xl tablet:text-3xl desktop:text-4xl xl:text-5xl"),
                headingTag: headingTag
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* AccordionRoot */.c2, {
                children: faqs === null || faqs === void 0 ? void 0 : faqs.map(function(item) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* AccordionTab */.US, {
                        title: item.question || "",
                        id: item._id,
                        expand: false,
                        bodyClassNameConfig: {
                            baseClassName: !inPortableText ? "py-4" : ""
                        },
                        headerClassNameConfig: {
                            baseClassName: "text-lg font-semibold pt-2 pb-4 capitalize"
                        },
                        headerWrapperClassNameConfig: {
                            baseClassName: inPortableText ? "mt-3! mb-2!" : ""
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((BlockContent_default()), {
                            blocks: item.answer,
                            serializers: serializeBlockContent/* serializeTocBlockContent */.lw
                        })
                    }, item._id);
                })
            }),
            (faqs === null || faqs === void 0 ? void 0 : faqs.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(InjectedScript/* InjectedScript */.D, {
                type: "application/ld+json",
                script: '{\n          "@context": "https://schema.org",\n          "@type": "FAQPage",\n          "mainEntity": [\n          '.concat(faqs === null || faqs === void 0 ? void 0 : faqs.map(function(item) {
                    return '{\n                "@type": "Question",\n                "name": "'.concat(item.question, '",\n                "acceptedAnswer": {\n                  "@type": "Answer",\n                  "text": "').concat(portableBlocksToText(item.answer), '"\n                }\n              }');
                }), "\n          ]\n        }")
            })
        ]
    });
};


/***/ }),

/***/ 86491:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ InfoBanner; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(85034);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(70169);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27378);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86677);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var twind__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(34209);
/* harmony import */ var _global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12601);
/* harmony import */ var ui_components_SanityImage__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86468);
/* harmony import */ var ui_elements_Link__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(68302);
/* harmony import */ var ui_elements_Markdown__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(41467);
/* harmony import */ var hooks_usePromotionView__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(32736);
/* harmony import */ var hooks_a11y__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(71129);
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(79758);
/* harmony import */ var utils_media__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(39772);
/* harmony import */ var hooks_useLinkResolver__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(13022);
/* harmony import */ var hooks_useSiteConfig__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(20368);
/* harmony import */ var utils_locale__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(79302);
/* harmony import */ var _CountdownClock__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(3099);
/* harmony import */ var _ClampedInfoMessageText__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(83949);



















var InfoBanner = function(props) {
    var ref, ref1, ref2, ref3, ref4;
    var asPath = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)().asPath;
    var getLink = (0,hooks_useLinkResolver__WEBPACK_IMPORTED_MODULE_11__/* .useLinkResolver */ .u)().getLink;
    var infoBannerRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isTooltipOpen = ref5[0], setTooltipOpen = ref5[1];
    var tooltipRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var buttonIconRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var tooltipContainerId = "tooltip-container-".concat(props._id);
    var isSafari = utils_constants__WEBPACK_IMPORTED_MODULE_9__/* .isServer */ .sk ? false : ((ref2 = (ref = window.navigator) === null || ref === void 0 ? void 0 : (ref1 = ref.userAgent) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase()) === null || ref2 === void 0 ? void 0 : ref2.indexOf("safari/")) > -1;
    (0,hooks_a11y__WEBPACK_IMPORTED_MODULE_8__/* .useDialogDismiss */ .sH)({
        ref: tooltipRef,
        external: tooltipRef,
        handler: function(e) {
            var firstTooltipContainer = document.getElementById(tooltipContainerId); // tooltipRef didn't work because the tooltip is rendered twice for some reason...
            if ((e === null || e === void 0 ? void 0 : e.target) && (firstTooltipContainer === e.target || (firstTooltipContainer === null || firstTooltipContainer === void 0 ? void 0 : firstTooltipContainer.contains(e.target)))) {
                return;
            }
            if (!(e === null || e === void 0 ? void 0 : e.target) || !buttonIconRef.current || !buttonIconRef.current.contains(e === null || e === void 0 ? void 0 : e.target)) {
                setTooltipOpen(!isTooltipOpen);
            }
        }
    });
    var promotion_name = props.header || "";
    var gaTrackData = {
        id: ((ref3 = props.puid) === null || ref3 === void 0 ? void 0 : ref3.current) || "",
        name: promotion_name,
        creative: "promo-banner",
        position: "0",
        campaign: props.campaignId || ""
    };
    var creative_name = props._type || "InfoBanner";
    var promotion_id = props._id;
    var ctasLinks = ((ref4 = props.ctas) === null || ref4 === void 0 ? void 0 : ref4.map(function(cta) {
        return getLink(cta);
    })) || [];
    var extendedGaTrackData = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)({}, gaTrackData), {
        promotion_id: promotion_id,
        creative_name: creative_name,
        cta_links: ctasLinks
    });
    var ga4PromotionTrackerPosition = (0,hooks_usePromotionView__WEBPACK_IMPORTED_MODULE_7__/* .usePromotionView */ .Y)(infoBannerRef, extendedGaTrackData).ga4PromotionTrackerPosition;
    var ga4Data = {
        creative_name: creative_name,
        creative_slot: ga4PromotionTrackerPosition,
        promotion_id: promotion_id,
        promotion_name: promotion_name,
        link_url: ctasLinks[0] || "",
        cta_click: undefined,
        fireEventFromPdp: asPath.includes("/pd/")
    };
    var isMobile = (0,utils_media__WEBPACK_IMPORTED_MODULE_10__/* .getIsMobile */ .W)();
    var tooltipStyles = {
        "--tooltip-max-width": "".concat(isMobile ? "460px" : "375px"),
        zIndex: "50"
    };
    var disclaimer = props.disclaimer;
    var infoMessage = disclaimer === null || disclaimer === void 0 ? void 0 : disclaimer.map(function(detail) {
        var ref;
        return detail === null || detail === void 0 ? void 0 : (ref = detail.children) === null || ref === void 0 ? void 0 : ref.map(function(el) {
            return el.text;
        }).join("");
    }).join("");
    var locale = (0,hooks_useSiteConfig__WEBPACK_IMPORTED_MODULE_12__/* .useSiteConfig */ .N)().locale;
    var localeUrl = (0,utils_locale__WEBPACK_IMPORTED_MODULE_13__/* .getUrlFromLocale */ .bH)(locale);
    var readMoreLink = "".concat(localeUrl, "/puma/sale-terms-and-conditions");
    var _backgroundColor, _textColor;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        "data-link-loc": "banner",
        "data-test-id": "banner",
        className: (0,twind__WEBPACK_IMPORTED_MODULE_18__.tw)("relative flex p-4 pb-5 overflow-hidden bg-[".concat((_backgroundColor = props.backgroundColor) !== null && _backgroundColor !== void 0 ? _backgroundColor : "#fafafa", "] my-0 mx-[calc(50%-50vw)]")),
        ref: infoBannerRef,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ui_components_SanityImage__WEBPACK_IMPORTED_MODULE_4__/* .SanityImage */ .d, {
                mobileSource: props.mobileBackgroundImage,
                source: props.optionalBackgroundImage,
                priority: props.priority && !props.deferred
            }),
            props.ctas && props.ctas[0] && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ui_elements_Link__WEBPACK_IMPORTED_MODULE_5__/* .Link */ .r, {
                query: props.ctas[0].query,
                newtab: !!props.ctas[0].newtab,
                href: ctasLinks[0] || "",
                className: "absolute inset-0 h-full w-full",
                "aria-hidden": true,
                tabIndex: -1,
                gaBannerData: gaTrackData,
                ga4Data: ga4Data
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (0,twind__WEBPACK_IMPORTED_MODULE_18__.tw)("relative m-auto flex flex-col items-center text-center text-[".concat((_textColor = props.textColor) !== null && _textColor !== void 0 ? _textColor : "#000", "]")),
                children: [
                    props.header && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "text-lg desktop:text-xl font-bold leading-tight mb-0",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ui_elements_Markdown__WEBPACK_IMPORTED_MODULE_6__/* .Markdown */ .U, {
                            content: props.header
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (0,twind__WEBPACK_IMPORTED_MODULE_18__.tw)([
                            "flex flex-col items-center",
                            props.showCountdownBeneathSubheading && "flex-col-reverse", 
                        ]),
                        children: [
                            props.countdownClock && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CountdownClock__WEBPACK_IMPORTED_MODULE_14__/* .CountdownClock */ .h, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)({}, props.countdownClock), {
                                config: {
                                    containerClassName: "text-xl space-x-1"
                                }
                            })),
                            props.copy && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "mobile:mt-1 text-sm desktop:text-base font-bold",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ui_elements_Markdown__WEBPACK_IMPORTED_MODULE_6__/* .Markdown */ .U, {
                                    content: props.copy
                                })
                            })
                        ]
                    }),
                    props.ctas && props.ctas.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex space-x-2 items-center",
                        children: [
                            props.ctas.map(function(cta) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ui_elements_Link__WEBPACK_IMPORTED_MODULE_5__/* .Link */ .r, {
                                    href: getLink(cta),
                                    query: cta.query,
                                    newtab: !!cta.newtab,
                                    popup: !!cta.popup,
                                    gaBannerData: gaTrackData,
                                    underlined: true,
                                    ga4Data: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)({}, ga4Data), {
                                        link_url: getLink(cta),
                                        cta_click: cta.title || ""
                                    }),
                                    children: cta.title
                                }, cta._key);
                            }),
                            !!infoMessage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_3__/* .TooltipRoot */ .wYI, {
                                side: "bottom",
                                align: "center",
                                open: isTooltipOpen,
                                invert: true,
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_3__/* .TooltipTrigger */ .aJU, {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_3__/* .ButtonIcon */ .Eik, {
                                            ref: buttonIconRef,
                                            label: "Disclaimer",
                                            icon: "info-outline",
                                            variant: "ghost",
                                            size: "base",
                                            invert: true,
                                            round: true,
                                            onClick: function() {
                                                return setTooltipOpen(!isTooltipOpen);
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_3__/* .TooltipContent */ ._vU, {
                                        style: tooltipStyles,
                                        className: "!bg-puma-gray-20 !text-black`",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: isSafari ? "h-20 overflow-hidden" : "line-clamp-4",
                                            id: tooltipContainerId,
                                            ref: tooltipRef,
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ClampedInfoMessageText__WEBPACK_IMPORTED_MODULE_15__/* .ClampedInfoMessageText */ .w, {
                                                infoMessage: infoMessage,
                                                setShowInfoMessage: setTooltipOpen,
                                                readMoreLink: readMoreLink
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    props.footnote && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                        className: "text-xs mt-1",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ui_elements_Markdown__WEBPACK_IMPORTED_MODULE_6__/* .Markdown */ .U, {
                            content: props.footnote
                        })
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 64236:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ Missing; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var hooks_useSiteConfig__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20368);
/* harmony import */ var ui_components_ManagedHeading__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93512);



var Missing = function(component) {
    var env = (0,hooks_useSiteConfig__WEBPACK_IMPORTED_MODULE_1__/* .useSiteConfig */ .N)().env;
    if (env.STAGE === "production") return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "bg-gray-100 py-24 text-center",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ui_components_ManagedHeading__WEBPACK_IMPORTED_MODULE_2__/* .ManagedHeading */ .P, {
                tag: "h1",
                className: "text-2xl font-bold",
                children: component.__typename || component._type
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "uppercase opacity-50",
                children: "Missing component for this type"
            })
        ]
    });
};


/***/ }),

/***/ 36998:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "US": function() { return /* binding */ AccordionTab; },
/* harmony export */   "c2": function() { return /* binding */ AccordionRoot; }
/* harmony export */ });
/* unused harmony export useAccordionTab */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85034);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70169);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31373);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var _global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12601);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27378);
/* harmony import */ var twind__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(34209);







var AccordionContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.createContext)({
    tabRefs: {},
    addTabRef: function(_ref, _id) {
        return null;
    },
    tabsOpen: {},
    toggleTabById: function(_id) {
        return null;
    },
    focusTabById: function(_id) {
        return null;
    },
    focusNextTabById: function(_id) {
        return null;
    },
    focusPreviousTabById: function(_id) {
        return null;
    },
    focusFirstTab: function() {
        return null;
    },
    focusLastTab: function() {
        return null;
    }
});
var AccordionRoot = function(param) {
    var children = param.children;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({}), tabRefs = ref[0], setTabRefs = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({}), tabsOpen = ref1[0], setTabsOpen = ref1[1];
    var getTabIndexById = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(id) {
        var tabKeys = Object.keys(tabRefs);
        var tabIndex = tabKeys.findIndex(function(v) {
            return v == id;
        });
        return tabIndex;
    }, [
        tabRefs
    ]);
    var focusTabById = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(id) {
        var ref;
        var tabRef = tabRefs[id];
        (ref = tabRef.current) === null || ref === void 0 ? void 0 : ref.focus();
    }, [
        tabRefs
    ]);
    var focusNextTabById = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(id) {
        var tabKeys = Object.keys(tabRefs);
        var keyIndex = getTabIndexById(id);
        var nextKeyIndex = keyIndex + 1 < tabKeys.length ? keyIndex + 1 : 0;
        focusTabById(tabKeys[nextKeyIndex]);
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        tabRefs,
        focusTabById
    ]);
    var focusPreviousTabById = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(id) {
        var tabKeys = Object.keys(tabRefs);
        var keyIndex = getTabIndexById(id);
        var nextKeyIndex = keyIndex - 1 >= 0 ? keyIndex - 1 : tabKeys.length - 1;
        focusTabById(tabKeys[nextKeyIndex]);
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        tabRefs,
        focusTabById
    ]);
    /** Focus First Tab */ var focusFirstTab = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function() {
        var tabKeys = Object.keys(tabRefs);
        focusTabById(tabKeys[0]);
    }, [
        tabRefs,
        focusTabById
    ]);
    var focusLastTab = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function() {
        var tabKeys = Object.keys(tabRefs);
        focusTabById(tabKeys[tabKeys.length - 1]);
    }, [
        tabRefs,
        focusTabById
    ]);
    var toggleTabById = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(id) {
        setTabsOpen(function(state) {
            var newState = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, state);
            newState[id] = !newState[id];
            return newState;
        });
    }, [
        setTabsOpen
    ]);
    var addTabRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(ref, id) {
        setTabRefs(function(state) {
            var newState = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, state);
            newState[id] = ref;
            return newState;
        });
        setTabsOpen(function(state) {
            var newState = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, state);
            newState[id] = false;
            return newState;
        });
    }, [
        setTabRefs,
        setTabsOpen
    ]);
    var providerValue = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        return {
            tabRefs: tabRefs,
            addTabRef: addTabRef,
            tabsOpen: tabsOpen,
            toggleTabById: toggleTabById,
            focusTabById: focusTabById,
            focusNextTabById: focusNextTabById,
            focusPreviousTabById: focusPreviousTabById,
            focusFirstTab: focusFirstTab,
            focusLastTab: focusLastTab
        };
    }, [
        tabRefs,
        addTabRef,
        tabsOpen,
        toggleTabById,
        focusTabById,
        focusNextTabById,
        focusPreviousTabById,
        focusFirstTab,
        focusLastTab, 
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AccordionContext.Provider, {
        value: providerValue,
        children: children
    });
};
var useAccordionTab = function(id) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(AccordionContext), addTabRef = ref.addTabRef, tabsOpen = ref.tabsOpen, toggleTabById = ref.toggleTabById, focusNextTabById = ref.focusNextTabById, focusPreviousTabById = ref.focusPreviousTabById, focusFirstTab = ref.focusFirstTab, focusLastTab = ref.focusLastTab;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        addTabRef(ref1, id);
    }, [
        addTabRef,
        ref1,
        id
    ]);
    var handleKeyDown = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(event) {
        var key = event.key;
        if (key !== "Tab" && key !== "Enter") {
            event.preventDefault();
        }
        switch(true){
            case key === "ArrowDown":
                focusNextTabById(id);
                break;
            case key === "ArrowUp":
                focusPreviousTabById(id);
                break;
            case key === "Home":
                focusFirstTab();
                break;
            case key === "End":
                focusLastTab();
                break;
        }
    }, [
        id,
        focusNextTabById,
        focusPreviousTabById,
        focusFirstTab,
        focusLastTab
    ]);
    var handleOnClick = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function() {
        toggleTabById(id);
    }, [
        toggleTabById,
        id
    ]);
    return {
        ref: ref1,
        expanded: tabsOpen[id],
        toggleTab: toggleTabById,
        onClick: handleOnClick,
        onKeyDown: handleKeyDown
    };
};
var AccordionTab = function(_param) {
    var id = _param.id, bodyClassNameConfig = _param.bodyClassNameConfig, children = _param.children, className = _param.className, _expand = _param.expand, expand = _expand === void 0 ? true : _expand, headerClassNameConfig = _param.headerClassNameConfig, headerWrapperClassNameConfig = _param.headerWrapperClassNameConfig, title = _param.title, dataTestId = _param.dataTestId, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "id",
        "bodyClassNameConfig",
        "children",
        "className",
        "expand",
        "headerClassNameConfig",
        "headerWrapperClassNameConfig",
        "title",
        "dataTestId"
    ]);
    var _ref = useAccordionTab(id), ref = _ref.ref, expanded = _ref.expanded, toggleTab = _ref.toggleTab, hookRest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_ref, [
        "ref",
        "expanded",
        "toggleTab"
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (expand) {
            toggleTab(id);
        }
    }, [
        expand,
        id,
        toggleTab
    ]);
    var ref1;
    var expandedClassName = (ref1 = headerClassNameConfig === null || headerClassNameConfig === void 0 ? void 0 : headerClassNameConfig.expanded) !== null && ref1 !== void 0 ? ref1 : "pb-0";
    var ref2;
    var closedClassName = (ref2 = headerClassNameConfig === null || headerClassNameConfig === void 0 ? void 0 : headerClassNameConfig.closed) !== null && ref2 !== void 0 ? ref2 : "pb-4";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        id: "accordion-".concat(id),
        "data-test-id": dataTestId,
        className: (0,twind__WEBPACK_IMPORTED_MODULE_5__.tw)("border-b"),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                id: "heading-".concat(id),
                className: (0,twind__WEBPACK_IMPORTED_MODULE_5__.tw)("flex", headerWrapperClassNameConfig === null || headerWrapperClassNameConfig === void 0 ? void 0 : headerWrapperClassNameConfig.baseClassName),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
                    "data-test-id": "".concat(dataTestId, "-btn"),
                    ref: ref,
                    "aria-expanded": expanded,
                    "aria-controls": "tabregion-".concat(id),
                    className: (0,twind__WEBPACK_IMPORTED_MODULE_5__.tw)([
                        "w-full flex justify-between relative text-left text-puma-black focus:outline-none h-[60px] items-center",
                        headerClassNameConfig === null || headerClassNameConfig === void 0 ? void 0 : headerClassNameConfig.baseClassName,
                        expanded ? expandedClassName : closedClassName, 
                    ]),
                    type: "button"
                }, rest, hookRest), {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            children: title
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: (0,twind__WEBPACK_IMPORTED_MODULE_5__.tw)(expanded && "transform rotate-180"),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_1__/* .Icon */ .JO$, {
                                name: "chevron-down",
                                size: "2xl"
                            })
                        })
                    ]
                }))
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                role: "region",
                id: "tabregion-".concat(id),
                "aria-labelledby": "heading-".concat(id),
                hidden: !expanded,
                className: (0,twind__WEBPACK_IMPORTED_MODULE_5__.tw)([
                    "w-full",
                    bodyClassNameConfig === null || bodyClassNameConfig === void 0 ? void 0 : bodyClassNameConfig.baseClassName
                ]),
                children: children
            })
        ]
    });
};


/***/ }),

/***/ 66224:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ AlertMessage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var _global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12601);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27378);
/* harmony import */ var twind_style__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79200);




var messageStyle = (0,twind_style__WEBPACK_IMPORTED_MODULE_3__/* .style */ .oB)({
    base: "flex-shrink flex items-center space-x-2 text-xs text-puma-black-300",
    variants: {
        type: {
            success: "text-puma-green",
            warning: "text-puma-red",
            plaininfo: "text-puma-black",
            info: "text-puma-black-300"
        }
    }
});
var AlertMessage = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (0,twind_style__WEBPACK_IMPORTED_MODULE_3__.tw)(messageStyle({
            type: props.type
        })),
        "data-test-id": props.dataTestId,
        role: "alert",
        children: [
            props.icon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_1__/* .Icon */ .JO$, {
                name: props.icon,
                size: "2xl"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "font-bold uppercase text-sm mb-0.5",
                children: props.children
            })
        ]
    });
};


/***/ }),

/***/ 70868:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "z": function() { return /* binding */ Button; }
});

// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(24246);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ../node_modules/twind/style/style.js
var style = __webpack_require__(79200);
// EXTERNAL MODULE: ./hooks/useTranslations.tsx
var useTranslations = __webpack_require__(77480);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(19989);
// EXTERNAL MODULE: ../node_modules/twind/css/css.js
var css = __webpack_require__(49224);
;// CONCATENATED MODULE: ./ui/elements/DotAnimation.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: 0.9em;\n  height: 0.9em;\n  border-radius: 50%;\n  background-color: currentColor;\n  transform: scale(0);\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  animation: dotPulse 1.3s infinite linear;\n  @keyframes dotPulse {\n    0% {\n      transform: scale(0);\n    }\n    30% {\n      transform: scale(1);\n    }\n    80%,\n    100% {\n      transform: scale(0);\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  animation-delay: 0s;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  animation-delay: 0.25s;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  animation-delay: 0.5s;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}



var dot = (0,css/* css */.iv)(_templateObject());
var dotPlaying = (0,css/* css */.iv)(_templateObject1());
var dotOne = (0,css/* css */.iv)(_templateObject2());
var dotTwo = (0,css/* css */.iv)(_templateObject3());
var dotThree = (0,css/* css */.iv)(_templateObject4());
var DotAnimation = function(param) {
    var className = param.className, on = param.on;
    var ref = (0,react.useState)(false), playing = ref[0], setPlaying = ref[1];
    var playingTimeoutRef = (0,react.useRef)();
    (0,react.useEffect)(function() {
        playingTimeoutRef.current && clearTimeout(playingTimeoutRef.current);
        playingTimeoutRef.current = setTimeout(function() {
            setPlaying(on);
        }, on ? 0 : 300);
        return function() {
            playingTimeoutRef.current && clearTimeout(playingTimeoutRef.current);
        };
    }, [
        on,
        setPlaying
    ]);
    return playing ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
        className: (0,css.tw)(className, "flex space-x-1.5 transition-opacity duration-300", on ? "opacity-100" : "opacity-0"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (0,css.tw)(dot, playing && dotPlaying, dotOne)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (0,css.tw)(dot, playing && dotPlaying, dotTwo)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (0,css.tw)(dot, playing && dotPlaying, dotThree)
            })
        ]
    }) : null;
};

;// CONCATENATED MODULE: ./ui/elements/Button.tsx





var Button_button = (0,style/* style */.oB)({
    base: "relative px-5 py-2 bg-puma-black text-base text-white uppercase font-bold border-1 border-puma-black flex items-center justify-center rounded-sm",
    variants: {
        variant: {
            primary: "bg-puma-gold border-puma-gold",
            secondary: "bg-puma-silver border-puma-silver",
            link: "px-0 py-0 bg-transparent text-puma-black border-0 border-b-1 border-current text-sm uppercase font-bold rounded-none h-auto",
            inline: "px-0 py-0 bg-transparent text-current border-0 h-auto text-underline inline-block text-normal-case font-unset text-inherit",
            black: "bg-puma-black border-puma-black text-white"
        },
        colorscheme: {
            green: "bg-puma-green text-puma-green bg-opacity-20 border-none"
        },
        height: {
            tall: "h-14"
        },
        outlined: {
            true: "bg-transparent"
        },
        disabled: {
            true: "opacity-40 cursor-not-allowed"
        }
    },
    matches: [
        {
            outlined: true,
            use: "text-puma-black"
        },
        {
            variant: "primary",
            outlined: true,
            use: "text-puma-gold"
        },
        {
            variant: "secondary",
            outlined: true,
            use: "text-puma-silver"
        },
        {
            variant: "black",
            outlined: true,
            use: "text-puma-black"
        }, 
    ]
});
var Button = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    var t = (0,useTranslations/* useTranslate */.qM)();
    var onClickButton = function(e) {
        if (props.loading) return;
        if (typeof props.onClick !== "function") return;
        props.onClick(e);
    };
    var _type;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
        ref: ref,
        id: props.id,
        className: (0,style.tw)(Button_button({
            variant: props.variant,
            height: props.height,
            disabled: props.loading || props.disabled,
            outlined: props.outlined,
            colorscheme: props.colorscheme
        }), props.className),
        disabled: props.disabled,
        "aria-disabled": props.loading || props.disabled,
        "aria-label": props.label,
        onClick: onClickButton,
        // eslint-disable-next-line react/button-has-type
        type: (_type = props.type) !== null && _type !== void 0 ? _type : "button",
        "data-test-id": props.dataTestId,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (0,style.tw)("flex items-center space-x-2 transition-opacity duration-300", props.loading ? "opacity-0" : "opacity-100", props.textStyle),
                children: props.children
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DotAnimation, {
                on: props.loading,
                className: "absolute left-1/2 top-1/2 transform -translate-1/2"
            }),
            props.loading && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "sr-only",
                children: t("loading")
            })
        ]
    });
});
Button.displayName = "Button";


/***/ }),

/***/ 26730:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ ImageOverlay; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);

var DIRECTION;
(function(DIRECTION) {
    DIRECTION[DIRECTION["right"] = 0] = "right";
    DIRECTION[DIRECTION["left"] = 1] = "left";
    DIRECTION[DIRECTION["top"] = 2] = "top";
    DIRECTION[DIRECTION["bottom"] = 3] = "bottom";
})(DIRECTION || (DIRECTION = {}));
var ImageOverlay = function(param) {
    var className = param.className, _direction = param.direction, direction = _direction === void 0 ? DIRECTION.left : _direction, overlayColorInput = param.overlayColorInput, overlayType = param.overlayType;
    if (!overlayColorInput) return null;
    var rgb = overlayColorInput.rgb;
    var rgba = "rgba(".concat(rgb.r, ", ").concat(rgb.g, ", ").concat(rgb.b, ", ").concat(rgb.a, ")");
    var backgroundImage = overlayType === "Linear" ? "linear-gradient(to ".concat(direction, ", ").concat(rgba, ", transparent 125%)") : "linear-gradient(".concat(rgba, ", ").concat(rgba, ")");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        "data-test-id": "image-overlay",
        className: className,
        style: {
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundImage: backgroundImage
        }
    });
};


/***/ }),

/***/ 19735:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ InjectedScript; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85034);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31373);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);



var InjectedScript = function(_param) {
    var script = _param.script, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "script"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        dangerouslySetInnerHTML: {
            __html: script
        }
    }, props));
};


/***/ }),

/***/ 68302:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ Link; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(85034);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(70169);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(31373);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79894);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var twind_style__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(79200);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27378);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86677);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var hooks_useIsCrawler__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(32239);
/* harmony import */ var utils_urls__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(90901);
/* harmony import */ var hooks_useSiteConfig__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(20368);
/* harmony import */ var utils_analytics__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(83168);
/* harmony import */ var hooks_useCookieSettings__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(34457);
/* harmony import */ var hooks_usePromotionSelect__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(36858);
/* harmony import */ var hooks_useGA4Events__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(89113);
/* harmony import */ var hooks_useLinkResolver__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(13022);
















var link = (0,twind_style__WEBPACK_IMPORTED_MODULE_2__/* .style */ .oB)({
    base: "bg-transparent text-current text-base no-underline",
    variants: {
        variant: {
            black: "text-puma-black",
            white: "text-white",
            primary: "text-puma-gold",
            secondary: "text-puma-silver"
        },
        underlined: {
            true: "bg-transparent border-b-1 border-current text-sm uppercase font-bold leading-tight"
        },
        size: {
            sm: "text-sm",
            md: "text-base",
            lg: "text-lg"
        },
        disabled: {
            true: "opacity-60 pointer-events-none"
        }
    }
});
var button = (0,twind_style__WEBPACK_IMPORTED_MODULE_2__/* .style */ .oB)({
    base: "block px-5 py-2 whitespace-nowrap border-1 uppercase font-bold tracking-wide text-center flex items-center justify-center",
    variants: {
        variant: {
            black: "bg-puma-black border-puma-black text-white hover:bg-opacity-80",
            white: "bg-white border-white text-puma-black hover:bg-neutral-20 hover:border-neutral-20",
            primary: "bg-puma-gold border-puma-gold text-white",
            secondary: "bg-puma-silver border-puma-silver text-white"
        },
        height: {
            tall: "h-14"
        },
        outlined: {
            true: "bg-transparent hover:bg-transparent"
        },
        underlined: {
            true: "px-0 py-px bg-transparent border-0 border-b-1 border-current text-sm uppercase font-bold rounded-none leading-tight"
        },
        disabled: {
            true: "opacity-40 pointer-events-none"
        }
    },
    matches: [
        {
            variant: "black",
            outlined: true,
            use: "text-puma-black"
        },
        {
            variant: "white",
            outlined: true,
            use: "text-white"
        },
        {
            variant: "primary",
            outlined: true,
            use: "text-puma-gold"
        },
        {
            variant: "secondary",
            outlined: true,
            use: "text-puma-silver"
        }, 
    ]
});
var TRIGGER_COOKIE_MANAGEMENT_BAR = "triggerCookieManagementBar";
var Link = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_3__.forwardRef)(function(props, ref) {
    var href = props.href, newtab = props.newtab, popup = props.popup, query = props.query, as = props.as, dataTestId = props.dataTestId, dataLinkLoc = props.dataLinkLoc, className = props.className, disabled = props.disabled, variant = props.variant, outlined = props.outlined, height = props.height, underlined = props.underlined, size = props.size, gaBannerData = props.gaBannerData, ga4Data = props.ga4Data, action = props.action, absoluteForCrawlers = props.absoluteForCrawlers, onClickCTA = props.onClickCTA, _isAnchor = props.isAnchor, isAnchor = _isAnchor === void 0 ? true : _isAnchor, restProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(props, [
        "href",
        "newtab",
        "popup",
        "query",
        "as",
        "dataTestId",
        "dataLinkLoc",
        "className",
        "disabled",
        "variant",
        "outlined",
        "height",
        "underlined",
        "size",
        "gaBannerData",
        "ga4Data",
        "action",
        "absoluteForCrawlers",
        "onClickCTA",
        "isAnchor"
    ]);
    var setShowCookieSettings = (0,hooks_useCookieSettings__WEBPACK_IMPORTED_MODULE_9__/* .useCookieSettings */ .eK)().setShowCookieSettings;
    var localizeUrlPath = (0,hooks_useSiteConfig__WEBPACK_IMPORTED_MODULE_7__/* .useSiteConfig */ .N)().localizeUrlPath;
    var newtabProps = newtab ? {
        target: "_blank",
        rel: "noopener noreferrer"
    } : {};
    var getLocalizedLink = (0,hooks_useLinkResolver__WEBPACK_IMPORTED_MODULE_12__/* .useLinkResolver */ .u)().getLocalizedLink;
    var isCrawler = (0,hooks_useIsCrawler__WEBPACK_IMPORTED_MODULE_5__/* .useIsCrawler */ .i)();
    var asPath = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)().asPath;
    var promotionSelectEvent = (0,hooks_usePromotionSelect__WEBPACK_IMPORTED_MODULE_10__/* .usePromotionSelect */ .y)().promotionSelectEvent;
    var linkHref = getLocalizedLink({
        href: href,
        query: query
    }, absoluteForCrawlers && isCrawler);
    var popupClickHandler = function(e) {
        e.stopPropagation();
        onClickCTA === null || onClickCTA === void 0 ? void 0 : onClickCTA();
        if (action === TRIGGER_COOKIE_MANAGEMENT_BAR) {
            e.preventDefault();
            setShowCookieSettings(true);
        }
        if (!href) return e.preventDefault();
        if (gaBannerData) {
            (0,utils_analytics__WEBPACK_IMPORTED_MODULE_8__/* .event */ .B)(utils_analytics__WEBPACK_IMPORTED_MODULE_8__/* .AnalyticsEvents.PROMOTION_CLICK */ ._q.PROMOTION_CLICK, {
                ecommerce: {
                    promoClick: {
                        promotions: [
                            (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({}, gaBannerData), {
                                "cta-click": !!props.children ? "Button: ".concat(props.children) : "Banner Clicked"
                            }), 
                        ]
                    }
                }
            });
        }
        if (ga4Data) {
            var link_page_type = ga4Data.link_url ? (0,utils_analytics__WEBPACK_IMPORTED_MODULE_8__/* .getPageType */ .C2)(localizeUrlPath(ga4Data.link_url)) : undefined;
            promotionSelectEvent((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({}, ga4Data), {
                link_page_type: link_page_type,
                cta_click: ga4Data.cta_click && "Button: ".concat(ga4Data.cta_click),
                fireEventFromPdp: asPath.includes("/pd/")
            }), link_page_type === "pdp" && ga4Data.link_url && {
                product: (0,hooks_useGA4Events__WEBPACK_IMPORTED_MODULE_11__/* .getProductFromLinkUrl */ .F9)(ga4Data.link_url)
            }, link_page_type === "plp" && {
                setPromotion: !newtab
            }));
        }
        if (popup) {
            e.preventDefault();
            return window.open(linkHref, "", "\n        scrollbars=yes,\n        menubar=no,\n        status=no,\n        location=no,\n        toolbar=no,\n        width=750,\n        height=780,\n        top=".concat((window.innerHeight - 780) / 2, ",\n        left=").concat((window.innerWidth - 750) / 2, "\n        ").replace(/\\n/g, "").trim());
        }
    };
    var linkProps = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({
        onClick: popupClickHandler,
        "aria-disabled": disabled || href === null,
        "data-test-id": dataTestId,
        "data-link-loc": dataLinkLoc,
        ref: ref,
        className: (0,twind_style__WEBPACK_IMPORTED_MODULE_2__.tw)((0,twind_style__WEBPACK_IMPORTED_MODULE_2__/* .apply */ .nn)(as === "button" ? button({
            variant: variant,
            outlined: outlined,
            underlined: underlined,
            disabled: disabled,
            height: height
        }) : link({
            variant: variant,
            underlined: underlined,
            size: size,
            disabled: disabled
        })), href ? "cursor-pointer" : "cursor-default", className)
    }, newtabProps, restProps);
    return (0,utils_urls__WEBPACK_IMPORTED_MODULE_6__/* .isAbsoluteUrl */ .sD)(href || "") ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({
        href: linkHref,
        onClick: popupClickHandler,
        "aria-disabled": disabled || href === null,
        "data-test-id": dataTestId,
        ref: ref,
        className: (0,twind_style__WEBPACK_IMPORTED_MODULE_2__.tw)((0,twind_style__WEBPACK_IMPORTED_MODULE_2__/* .apply */ .nn)(as === "button" ? button({
            variant: variant,
            outlined: outlined,
            underlined: underlined,
            disabled: disabled,
            height: height
        }) : link({
            variant: variant,
            underlined: underlined,
            size: size,
            disabled: disabled
        })), href ? "cursor-pointer" : "cursor-default", className)
    }, newtabProps, restProps)) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
        href: linkHref,
        prefetch: false,
        children: isAnchor ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({}, linkProps)) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({}, linkProps))
    });
});
Link.displayName = "Link";


/***/ }),

/***/ 41467:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "U": function() { return /* binding */ Markdown; }
});

// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(24246);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(3204);
;// CONCATENATED MODULE: ./utils/markdownParser.ts


var tags = {
    "*": "b",
    "~": "s",
    _: "i"
};
var replaceNewLines = function(str) {
    return str.split("\\n").flatMap(function(value, index, array) {
        if (index === array.length - 1) return [
            value
        ];
        var uniqueKey = "br" + Math.random().toString(36).slice(2);
        var newElement = (0,react.createElement)("br", {
            key: uniqueKey
        });
        return [
            value,
            newElement
        ];
    });
};
var markdown = function(str) {
    var _content;
    var tokenizer = /(__)(.*?)(__)|(\*\*)(.*?)(\*\*)|(~~)(.*?)(~~)/;
    var content = [];
    var token;
    // There are no special tokens in the content
    if (!str.match(tokenizer)) return replaceNewLines(str);
    // Loop until there are no more markdown tokens
    while(token = tokenizer.exec(str)){
        if (token.index > 0) {
            var // Add the plain text before the token
            _content1;
            (_content1 = content).push.apply(_content1, (0,_to_consumable_array/* default */.Z)(replaceNewLines(str.substring(0, token.index))));
        }
        var contentWithMarkdown = token[0];
        var htmlTag = tags[contentWithMarkdown.charAt(0)];
        var strippedContent = replaceNewLines(contentWithMarkdown.slice(2, -2));
        var newElement = (0,react.createElement)(htmlTag, {
            key: strippedContent.toString()
        }, strippedContent);
        content.push(newElement);
        str = str.substring(token.index + contentWithMarkdown.length);
    }
    // Append any remaining content
    if (str) (_content = content).push.apply(_content, (0,_to_consumable_array/* default */.Z)(replaceNewLines(str)));
    return content;
};

;// CONCATENATED MODULE: ./ui/elements/Markdown.tsx



var Markdown = /*#__PURE__*/ react.memo(function Markdown(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: markdown(props.content)
    });
});


/***/ }),

/***/ 31887:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ ForgotPasswordForm; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(23842);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(5341);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(59312);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27378);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93451);
/* harmony import */ var _global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12601);
/* harmony import */ var hooks_useTranslations__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(77480);
/* harmony import */ var hooks_useValidation__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70750);
/* harmony import */ var hooks_useFormData__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(56543);
/* harmony import */ var _generated_graphql__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(37678);
/* harmony import */ var hooks_useSiteConfig__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(20368);












var ForgotPasswordForm = function(props) {
    var ref, ref1, ref2;
    var isInPopover = props.isInPopover;
    var t = (0,hooks_useTranslations__WEBPACK_IMPORTED_MODULE_4__/* .useTranslate */ .qM)();
    var ref3 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,hooks_useValidation__WEBPACK_IMPORTED_MODULE_5__/* .useValidation */ .V)(), 1), validate = ref3[0];
    var data = (0,hooks_useFormData__WEBPACK_IMPORTED_MODULE_6__/* .useFormData */ .qW)().data;
    var ref4 = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_2__/* .useForm */ .cI)({
        mode: "onBlur",
        reValidateMode: "onChange",
        defaultValues: {
            email: data === null || data === void 0 ? void 0 : data.email
        }
    }), registerField = ref4.register, handleSubmit = ref4.handleSubmit, errors = ref4.errors, formState = ref4.formState, watch = ref4.watch;
    var ref5 = (0,hooks_useSiteConfig__WEBPACK_IMPORTED_MODULE_8__/* .useSiteConfig */ .N)(), showModifiedResetPassFormPopup = ref5.staticFeatures.showModifiedResetPassFormPopup;
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), afterForgotPassPopup = ref6[0], setAfterForgotPassPopup = ref6[1];
    var ref7 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_generated_graphql__WEBPACK_IMPORTED_MODULE_7__/* .useResetPasswordMutation */ .gL8)(), 2), resetPasswordResult = ref7[0], resetPassword = ref7[1];
    var onSubmit = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(function(data) {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!formState.isValid) return [
                            2
                        ];
                        return [
                            4,
                            resetPassword(data)
                        ];
                    case 1:
                        _state.sent();
                        setAfterForgotPassPopup(true);
                        return [
                            2
                        ];
                }
            });
        });
        return function onSubmit(data) {
            return _ref.apply(this, arguments);
        };
    }();
    var confirmPopupOpenJapan = afterForgotPassPopup && showModifiedResetPassFormPopup;
    var confirmPopupOpenOthers = afterForgotPassPopup && !showModifiedResetPassFormPopup;
    var email = watch("email");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("form", {
        className: "space-y-8 pt-2 pb-16 sm:pb-0",
        "data-test-id": "forgotten-password-form",
        onSubmit: handleSubmit(onSubmit),
        noValidate: true,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "".concat(isInPopover && "text-center", " space-y-2"),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                        "data-test-id": "forgotten-password-title",
                        className: "".concat(isInPopover ? "text-lg" : "text-xl text-center", " font-bold uppercase whitespace-pre-wrap"),
                        children: afterForgotPassPopup ? t("resetPasswordConfirm") : t("forgotPassword")
                    }),
                    confirmPopupOpenJapan && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "whitespace-pre-wrap space-y-2",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                role: "alert",
                                className: "text-puma-green -m-1",
                                "data-test-id": "password-reset-email-sent-success",
                                children: [
                                    t("emailSentMessage"),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                    email
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                children: t("checkEmailSuggestionsMessage")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                children: t("checkIfNoEmailMessage")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                className: "list-decimal pl-6",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                        children: t("checkYourEmailAfterMessage")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                        children: t("allowItToBeReceivedMessage")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                        children: t("reSendEmailMessage")
                                    })
                                ]
                            })
                        ]
                    }),
                    confirmPopupOpenOthers && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                role: "alert",
                                className: "text-puma-green",
                                "data-test-id": "password-reset-email-sent-success",
                                children: [
                                    t("emailSentMessage"),
                                    " ",
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                    " ",
                                    email,
                                    "."
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                children: t("checkEmailSuggestionsMessage")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                className: "list-disc pl-6",
                                "data-test-id": "email-reset-instructions-support-text",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                        children: t("waitAfewMinutesMessage")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                        children: t("checkSpamFolderMessage")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                        children: t("reSendEmailMessage")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                        children: t("sendMailToSupportMessage")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                        children: t("provideCorrectEmailMessage")
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "text-base whitespace-pre-wrap",
                        children: afterForgotPassPopup ? t("provideContactOfficialMessage") : t("provideAccountEmailMessage")
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_3__/* .LiveRegion */ .LE2, {
                type: "assertive",
                children: resetPasswordResult.error && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_3__/* .Alert */ .bZj, {
                    variant: "error",
                    dataTestId: "forgotten-password-error",
                    content: resetPasswordResult.error && (((ref = resetPasswordResult.error) === null || ref === void 0 ? void 0 : ref.graphQLErrors[0]) ? ((ref1 = resetPasswordResult.error) === null || ref1 === void 0 ? void 0 : ref1.graphQLErrors[0].message) || t("somethingWentWrong") : t("networkError"))
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_3__/* .Stack */ .Kqy, {
                gap: "lg",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_3__/* .InputText */ .oHY, {
                        ref: registerField({
                            required: t("requiredField"),
                            validate: validate.email,
                            maxLength: {
                                value: 50,
                                message: t("yourEmailCannotBeLong", {
                                    length: 50
                                })
                            }
                        }),
                        dataTestId: "email-input",
                        id: "email-input",
                        label: t("email"),
                        name: "email",
                        type: "email",
                        maxLength: 50,
                        errorText: (ref2 = errors.email) === null || ref2 === void 0 ? void 0 : ref2.message,
                        placeholder: t("email"),
                        required: true,
                        crossOrigin: undefined
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .zxk, {
                        size: "lg",
                        dataTestId: "submit-password-reset-btn",
                        label: confirmPopupOpenJapan ? t("resubmit") : t("submit"),
                        loading: resetPasswordResult.fetching,
                        disabled: resetPasswordResult.fetching,
                        type: "submit",
                        bleed: true
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 8165:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "g": function() { return /* binding */ AuthAction; },
  "c": function() { return /* binding */ AuthenticateForm; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(5341);
// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(24246);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ../node_modules/twind/twind.js + 1 modules
var twind = __webpack_require__(34209);
// EXTERNAL MODULE: ../node_modules/next/router.js
var next_router = __webpack_require__(86677);
var router_default = /*#__PURE__*/__webpack_require__.n(next_router);
// EXTERNAL MODULE: ../node_modules/@global-ecom/nitro-uds/dist/elements/esm/index.js + 103 modules
var esm = __webpack_require__(12601);
// EXTERNAL MODULE: ./hooks/useTranslations.tsx
var useTranslations = __webpack_require__(77480);
// EXTERNAL MODULE: ./ui/elements/Link.tsx
var Link = __webpack_require__(68302);
// EXTERNAL MODULE: ./ui/components/Modal.tsx
var Modal = __webpack_require__(51377);
// EXTERNAL MODULE: ./hooks/useFormData.tsx
var useFormData = __webpack_require__(56543);
// EXTERNAL MODULE: ./ui/components/CloseButton.tsx
var CloseButton = __webpack_require__(6485);
// EXTERNAL MODULE: ./hooks/usePageEventsContext.tsx
var usePageEventsContext = __webpack_require__(43308);
// EXTERNAL MODULE: ./hooks/useFeature.ts
var useFeature = __webpack_require__(53625);
// EXTERNAL MODULE: ./hooks/useMainNav.tsx + 1 modules
var useMainNav = __webpack_require__(14425);
// EXTERNAL MODULE: ./hooks/useSiteConfig.ts
var useSiteConfig = __webpack_require__(20368);
// EXTERNAL MODULE: ./ui/forms/LoginWithEmailAndPassword.tsx
var LoginWithEmailAndPassword = __webpack_require__(75139);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(23842);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(85034);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(70169);
// EXTERNAL MODULE: ../node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(59312);
// EXTERNAL MODULE: ../node_modules/react-hook-form/dist/index.esm.js
var index_esm = __webpack_require__(93451);
// EXTERNAL MODULE: ./hooks/useEmailNotification.ts
var useEmailNotification = __webpack_require__(47607);
// EXTERNAL MODULE: ./hooks/useLoginAndRegister.ts
var useLoginAndRegister = __webpack_require__(4402);
// EXTERNAL MODULE: ./ui/forms/custom/CustomForm.tsx + 20 modules
var CustomForm = __webpack_require__(80417);
// EXTERNAL MODULE: ./hooks/useAuth.tsx
var useAuth = __webpack_require__(72507);
// EXTERNAL MODULE: ./utils/analytics/index.ts + 6 modules
var analytics = __webpack_require__(83168);
// EXTERNAL MODULE: ./utils/analytics/hashEmail.ts
var hashEmail = __webpack_require__(91990);
;// CONCATENATED MODULE: ./ui/forms/AuthenticateRegisterForm.tsx



















var RegisterForm = function(param) {
    var onSuccess = param.onSuccess, pageviewEventHasFired = param.pageviewEventHasFired, _injectedHashEMail = param.injectedHashEMail, injectedHashEMail = _injectedHashEMail === void 0 ? hashEmail/* hashEmail */.g : _injectedHashEMail, isInPopover = param.isInPopover;
    var isRegisterOpen = (0,useMainNav/* useMainNavContext */.QH)().isRegisterOpen;
    var auth = (0,useAuth/* useAuth */.aC)();
    var ref = (0,useSiteConfig/* useSiteConfig */.N)(), _forms = ref.forms, registrationForm = _forms.registration, registrationV2 = _forms.registrationV2;
    var createSignupContact = (0,useEmailNotification/* useEmailNotification */.S)().createSignupContact;
    var ref1 = (0,useLoginAndRegister/* useLoginAndRegister */.$)(), _register = (0,_sliced_to_array/* default */.Z)(ref1.register, 2), registerResult = _register[0], register = _register[1];
    var popoverLoginEnabled = (0,useFeature/* useFeature */.S)("POPOVER_LOGIN_ENABLED");
    var hasSubmitted = react.useRef(false);
    (0,react.useEffect)(function() {
        return function() {
            if ((!isInPopover || isRegisterOpen) && !hasSubmitted.current && pageviewEventHasFired) {
                (0,analytics/* event */.B)(analytics/* AnalyticsEvents.GA4_CustomEvent */._q.GA4_CustomEvent, {
                    event_name: analytics/* AnalyticsEvents.SIGN_UP_FORM_CLOSE */._q.SIGN_UP_FORM_CLOSE,
                    event_params: {
                        method: (0,analytics/* getPageType */.C2)((router_default()).asPath)
                    }
                });
            }
        };
    }, [
        pageviewEventHasFired,
        isInPopover,
        isRegisterOpen
    ]);
    var onSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var ref, ref1, registerInput, _tmp, isDateDefined, triggerGA4Event, isPopover, result, _tmp1, dob, _tmp2, _firstNamePronunciation, _lastNamePronunciation, _smsOptIn, _phoneNumber, _tmp3, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        hasSubmitted.current = true;
                        _tmp = {};
                        registerInput = (_tmp.email = data.email, _tmp.firstName = data.firstName, _tmp.firstNamePronunciation = data.firstNamePronunciation, _tmp.lastName = data.lastName, _tmp.lastNamePronunciation = data.lastNamePronunciation, _tmp.password = data.password, _tmp);
                        isDateDefined = function(data) {
                            return data.year && data.month && data.day;
                        };
                        if (isDateDefined(data)) {
                            registerInput = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, registerInput), {
                                birthday: new Date(Date.UTC(Number(data.year), Number(data.month) - 1, Number(data.day))).toISOString().split("T")[0]
                            });
                        }
                        triggerGA4Event = function() {
                            (0,analytics/* event */.B)(analytics/* AnalyticsEvents.GA4_CustomEvent */._q.GA4_CustomEvent, {
                                event_name: analytics/* AnalyticsEvents.GA4EC_SignUp */._q.GA4EC_SignUp,
                                event_params: {
                                    method: (0,analytics/* getPageType */.C2)((router_default()).asPath),
                                    is_guest: "false",
                                    hashed_email: injectedHashEMail(data.email),
                                    custom_user_id: auth.customerId
                                }
                            });
                        };
                        isPopover = popoverLoginEnabled || !window.location.pathname.includes("/account");
                        return [
                            4,
                            register(registerInput)
                        ];
                    case 1:
                        result = _state.sent();
                        _tmp1 = {};
                        if (result.error) {
                            if (!isPopover) {
                                window.scrollTo((_tmp1.top = 0, _tmp1.behavior = "smooth", _tmp1));
                            }
                        }
                        if ((ref = result.data) === null || ref === void 0 ? void 0 : ref.register) {
                            if (isPopover) {
                                window.scrollTo(0, 0);
                            }
                        }
                        if (!(result === null || result === void 0 ? void 0 : (ref1 = result.data) === null || ref1 === void 0 ? void 0 : ref1.register)) return [
                            2
                        ];
                        if (!(data.emailList || data.smsOptIn)) return [
                            3,
                            5
                        ];
                        _tmp2 = {};
                        dob = isDateDefined(data) ? (_tmp2.day = Number(data.day), _tmp2.month = Number(data.month), _tmp2.year = Number(data.year), _tmp2) : undefined;
                        _state.label = 2;
                    case 2:
                        _state.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]);
                        _tmp3 = {};
                        return [
                            4,
                            createSignupContact((_tmp3.firstName = data.firstName, _tmp3.lastName = data.lastName, _tmp3.email = data.email, _tmp3.firstNamePronunciation = (_firstNamePronunciation = data.firstNamePronunciation) !== null && _firstNamePronunciation !== void 0 ? _firstNamePronunciation : null, _tmp3.lastNamePronunciation = (_lastNamePronunciation = data.lastNamePronunciation) !== null && _lastNamePronunciation !== void 0 ? _lastNamePronunciation : null, _tmp3.dob = dob !== null && dob !== void 0 ? dob : null, _tmp3.smsOptIn = (_smsOptIn = data.smsOptIn) !== null && _smsOptIn !== void 0 ? _smsOptIn : null, _tmp3.phoneNumber = (_phoneNumber = data.phoneNumber) !== null && _phoneNumber !== void 0 ? _phoneNumber : null, _tmp3))
                        ];
                    case 3:
                        _state.sent();
                        return [
                            3,
                            5
                        ];
                    case 4:
                        error = _state.sent();
                        // eslint-disable-next-line no-console
                        console.error("Error:", error);
                        return [
                            3,
                            5
                        ];
                    case 5:
                        if (pageviewEventHasFired) triggerGA4Event();
                        if (onSuccess) {
                            onSuccess();
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function onSubmit(data) {
            return _ref.apply(this, arguments);
        };
    }();
    var form = (0,index_esm/* useForm */.cI)({
        defaultValues: {
            emailList: true
        },
        mode: "onChange"
    });
    (0,react.useEffect)(function() {
        if ((!isInPopover || isRegisterOpen) && pageviewEventHasFired) {
            (0,analytics/* event */.B)(analytics/* AnalyticsEvents.GA4_CustomEvent */._q.GA4_CustomEvent, {
                event_name: analytics/* AnalyticsEvents.GA4EC_SignUpFormOpen */._q.GA4EC_SignUpFormOpen,
                event_params: {
                    method: (0,analytics/* getPageType */.C2)((router_default()).asPath)
                }
            });
        }
    }, [
        pageviewEventHasFired,
        isInPopover,
        isRegisterOpen
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomForm/* CustomForm */.y, {
        form: form,
        onSubmit: onSubmit,
        result: registerResult,
        config: popoverLoginEnabled && isInPopover ? registrationV2 : registrationForm,
        dataTestId: "registration-form",
        gapY: popoverLoginEnabled ? "sm" : "base"
    });
};

// EXTERNAL MODULE: ./ui/forms/AuthenticateForgotPasswordForm.tsx
var AuthenticateForgotPasswordForm = __webpack_require__(31887);
;// CONCATENATED MODULE: ./ui/forms/AuthenticateQuickRegisterForm.tsx
















var QuickRegisterForm = function(param) {
    var onSuccess = param.onSuccess;
    var t = (0,useTranslations/* useTranslate */.qM)();
    var ref = (0,useSiteConfig/* useSiteConfig */.N)(), _forms = ref.forms, quickRegistrationForm = _forms.quickRegistration;
    var createSignupContact = (0,useEmailNotification/* useEmailNotification */.S)().createSignupContact;
    var pageviewEventHasFired = (0,usePageEventsContext/* usePageEventsContext */.qN)().pageviewEventHasFired;
    var ref1 = (0,useLoginAndRegister/* useLoginAndRegister */.$)(), _register = (0,_sliced_to_array/* default */.Z)(ref1.register, 2), registerResult = _register[0], register = _register[1];
    var router = (0,next_router.useRouter)();
    var inflowCode = router.query.inflowCode;
    var form = (0,index_esm/* useForm */.cI)({
        defaultValues: {
            emailList: true
        },
        mode: "onChange"
    });
    var hasSubmitted = react.useRef(false);
    // we only want to run this when unmounth the component without submit.
    react.useEffect(function() {
        return function() {
            if (!hasSubmitted.current && pageviewEventHasFired) {
                (0,analytics/* event */.B)(analytics/* AnalyticsEvents.GA4_CustomEvent */._q.GA4_CustomEvent, {
                    event_name: analytics/* AnalyticsEvents.SIGN_UP_FORM_CLOSE */._q.SIGN_UP_FORM_CLOSE,
                    event_params: {
                        method: (0,analytics/* getPageType */.C2)(router.asPath)
                    }
                });
            }
        };
    }, [
        pageviewEventHasFired,
        router.asPath
    ]);
    var onSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var ref, registerValues, _tmp, inflowProperty, _tmp1, result, _firstNamePronunciation, _lastNamePronunciation, _tmp2;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        hasSubmitted.current = true;
                        _tmp = {};
                        registerValues = (_tmp.firstName = data.firstName, _tmp.lastName = data.lastName, _tmp.email = data.email, _tmp.password = data.password, _tmp);
                        _tmp1 = {};
                        if (inflowCode) {
                            inflowProperty = (_tmp1.inflowCode = inflowCode, _tmp1);
                            registerValues = (0,_object_spread/* default */.Z)({}, registerValues, inflowProperty);
                        }
                        return [
                            4,
                            register(registerValues)
                        ];
                    case 1:
                        result = _state.sent();
                        if (!(result === null || result === void 0 ? void 0 : (ref = result.data) === null || ref === void 0 ? void 0 : ref.register)) return [
                            2
                        ];
                        if (!data.emailList) return [
                            3,
                            3
                        ];
                        _tmp2 = {};
                        return [
                            4,
                            createSignupContact((_tmp2.firstName = data.firstName, _tmp2.lastName = data.lastName, _tmp2.email = data.email, _tmp2.firstNamePronunciation = (_firstNamePronunciation = data.firstNamePronunciation) !== null && _firstNamePronunciation !== void 0 ? _firstNamePronunciation : null, _tmp2.lastNamePronunciation = (_lastNamePronunciation = data.lastNamePronunciation) !== null && _lastNamePronunciation !== void 0 ? _lastNamePronunciation : null, _tmp2.dob = null, _tmp2.smsOptIn = null, _tmp2.phoneNumber = null, _tmp2))
                        ];
                    case 2:
                        _state.sent();
                        _state.label = 3;
                    case 3:
                        if (onSuccess) onSuccess();
                        return [
                            2
                        ];
                }
            });
        });
        return function onSubmit(data) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col",
        children: [
            quickRegistrationForm && /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomForm/* CustomForm */.y, {
                form: form,
                onSubmit: onSubmit,
                config: quickRegistrationForm,
                result: registerResult,
                dataTestId: "quick-registration-form"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: "text-xs mt-4",
                children: [
                    t("byContinuing"),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                        className: "underline text-xs",
                        href: "/help/terms-and-conditions",
                        rel: "noopener",
                        children: t("termsAndConditions")
                    }),
                    " ",
                    t("andThe"),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                        className: "underline text-xs",
                        href: "/help/privacy-policy",
                        rel: "noopener",
                        children: t("privacyPolicy")
                    }),
                    "."
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./ui/forms/AuthenticateForm.tsx



















var AuthAction;
(function(AuthAction) {
    AuthAction["register"] = "register";
    AuthAction["login"] = "login";
    AuthAction["reset_password"] = "reset_password";
})(AuthAction || (AuthAction = {}));
var tabStyle = "text-base md:text-xl whitespace-nowrap w-full flex justify-center items-center text-center cursor-pointer py-2 md:py-3 md:px-8 border-b-2 focus:ring-transparent focus:border-puma-gold";
var activeTabStyle = "font-bold border-puma-black";
var AuthenticateForm = function(param) {
    var from = param.from, _action = param.action, action = _action === void 0 ? AuthAction.login : _action, onSuccess = param.onSuccess, resetOnOverlay = param.resetOnOverlay, showQuickRegistration = param.showQuickRegistration, isInModal = param.isInModal, isInPopover = param.isInPopover, onClose = param.onClose;
    var t = (0,useTranslations/* useTranslate */.qM)();
    var router = (0,next_router.useRouter)();
    var localizeUrlPath = (0,useSiteConfig/* useSiteConfig */.N)().localizeUrlPath;
    var _query = router.query, wishlist = _query.wishlist, swatch = _query.swatch, size = _query.size;
    var pageviewEventHasFired = (0,usePageEventsContext/* usePageEventsContext */.qN)().pageviewEventHasFired;
    var popoverLoginEnabled = (0,useFeature/* useFeature */.S)("POPOVER_LOGIN_ENABLED");
    var setForgotPasswordFormOpen = (0,useMainNav/* useMainNavContext */.QH)().setForgotPasswordFormOpen;
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(action), 2), selectedAction = ref[0], setSelectedAction = ref[1];
    var fromSuffix = from ? "&from=".concat(from) : "";
    var swatchQuery = swatch ? "&swatch=".concat(swatch) : "";
    var sizeQuery = size ? "&size=".concat(size) : "";
    var wishlistQuery = wishlist ? "&wishlist=".concat(wishlist) : "";
    var handleActionChange = function(action) {
        return function(e) {
            e.preventDefault();
            if (!isInModal) {
                router.replace(localizeUrlPath("/account/login?action=" + action + fromSuffix + swatchQuery + sizeQuery + wishlistQuery));
            }
            setSelectedAction(action);
        };
    };
    var showReset = selectedAction === AuthAction.reset_password;
    var activeTab = selectedAction === AuthAction.register ? AuthAction.register : AuthAction.login;
    var showAuthForm = !showQuickRegistration && (resetOnOverlay || !showReset);
    var showResetForm = showReset && !resetOnOverlay;
    var showResetOverlay = showReset && resetOnOverlay;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(useFormData/* AuthFormContextProvider */.G$, {
        children: [
            showQuickRegistration && /*#__PURE__*/ (0,jsx_runtime.jsx)(QuickRegisterForm, {
                onSuccess: onSuccess
            }),
            showAuthForm && (!isInPopover ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "sr-only",
                        children: t("signIn")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Stack */.Kqy, {
                        items: "start",
                        gap: "lg",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Stack */.Kqy, {
                                direction: "row",
                                gap: "none",
                                justify: "stretch",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                                        dataTestId: "login-action-button",
                                        onClick: handleActionChange(AuthAction.login),
                                        href: "/account/login?action=login".concat(fromSuffix),
                                        className: (0,twind.tw)([
                                            tabStyle,
                                            activeTab === AuthAction.login && activeTabStyle, 
                                        ]),
                                        children: t("login")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                                        dataTestId: "register-action-button",
                                        onClick: handleActionChange(AuthAction.register),
                                        href: "/account/login?action=register".concat(fromSuffix),
                                        className: (0,twind.tw)([
                                            tabStyle,
                                            activeTab === AuthAction.register && activeTabStyle, 
                                        ]),
                                        children: popoverLoginEnabled ? t("joinUs") : t("createAccount")
                                    })
                                ]
                            }),
                            activeTab === AuthAction.register ? /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Stack */.Kqy, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RegisterForm, {
                                    onSuccess: onSuccess,
                                    pageviewEventHasFired: pageviewEventHasFired,
                                    isInPopover: isInPopover
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(LoginWithEmailAndPassword/* LoginWithEmailAndPasswordForm */.k, {
                                onSuccess: function() {
                                    onClose === null || onClose === void 0 ? void 0 : onClose();
                                    onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
                                },
                                onForgotPasswordClick: function() {
                                    setSelectedAction(AuthAction.reset_password);
                                    setForgotPasswordFormOpen(true);
                                }
                            })
                        ]
                    })
                ]
            }) : action === AuthAction.register ? /*#__PURE__*/ (0,jsx_runtime.jsx)(RegisterForm, {
                onSuccess: onClose,
                isInPopover: isInPopover,
                pageviewEventHasFired: pageviewEventHasFired
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(LoginWithEmailAndPassword/* LoginWithEmailAndPasswordForm */.k, {
                onSuccess: function() {
                    onClose === null || onClose === void 0 ? void 0 : onClose();
                    onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
                },
                onForgotPasswordClick: function() {
                    setForgotPasswordFormOpen(true);
                },
                isInPopover: isInPopover
            })),
            showResetForm && /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthenticateForgotPasswordForm/* ForgotPasswordForm */.L, {
                isInPopover: isInPopover
            }),
            showResetOverlay && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
                className: "w-full max-w-md px-8 pb-8 pt-9 relative",
                onClickOutside: function() {
                    setSelectedAction(AuthAction.login);
                    setForgotPasswordFormOpen(false);
                },
                variant: "dark",
                dataTestId: "forgot-password-overlay-modal",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseButton/* default */.Z, {
                        className: "absolute top-5 right-5 !mt-0",
                        onClick: function() {
                            setSelectedAction(AuthAction.login);
                            setForgotPasswordFormOpen(false);
                        },
                        dataTestId: "login-modal-close-btn"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthenticateForgotPasswordForm/* ForgotPasswordForm */.L, {
                        isInPopover: isInPopover
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 75139:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ LoginWithEmailAndPasswordForm; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(23842);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(85034);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(70169);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(5341);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(59312);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27378);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93451);
/* harmony import */ var _global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12601);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86677);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var twind__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(34209);
/* harmony import */ var _generated_graphql__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(37678);
/* harmony import */ var hooks_useTranslations__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(77480);
/* harmony import */ var hooks_useAuth__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(72507);
/* harmony import */ var hooks_useSiteConfig__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(20368);
/* harmony import */ var hooks_useValidation__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(70750);
/* harmony import */ var hooks_useFormData__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(56543);
/* harmony import */ var hooks_useLoginAndRegister__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(4402);
/* harmony import */ var hooks_useFeature__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(53625);
/* harmony import */ var hooks_useTranslationFieldOrDefault__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(19318);
/* harmony import */ var hooks_usePreferences__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(89915);
/* harmony import */ var ui_components_TermsAndConditions__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(99750);
/* harmony import */ var ui_components_TermsAndConditionsBackup__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(95459);
/* harmony import */ var utils_extractError__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(4360);
/* harmony import */ var utils_analytics__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(83168);
/* harmony import */ var hooks_usePageEventsContext__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(43308);
/* harmony import */ var hooks_useMainNav__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(14425);
/* harmony import */ var _OTPForm__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(83688);




























var LoginWithEmailAndPasswordForm = function(param) {
    var onSuccess = param.onSuccess, navigate = param.navigate, onForgotPasswordClick = param.onForgotPasswordClick, isInPopover = param.isInPopover;
    var ref, ref1, ref2, ref3;
    var popoverLoginEnabled = (0,hooks_useFeature__WEBPACK_IMPORTED_MODULE_12__/* .useFeature */ .S)("POPOVER_LOGIN_ENABLED");
    var t = (0,hooks_useTranslations__WEBPACK_IMPORTED_MODULE_6__/* .useTranslate */ .qM)();
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    var ref4 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)((0,hooks_useValidation__WEBPACK_IMPORTED_MODULE_9__/* .useValidation */ .V)(), 1), validate = ref4[0];
    var getErrorMessageOrDefault = (0,hooks_useTranslationFieldOrDefault__WEBPACK_IMPORTED_MODULE_13__/* .useTranslationFieldOrDefault */ .H)();
    var auth = (0,hooks_useAuth__WEBPACK_IMPORTED_MODULE_7__/* .useAuth */ .aC)();
    var ref5 = (0,hooks_useFormData__WEBPACK_IMPORTED_MODULE_10__/* .useFormData */ .qW)(), data = ref5.data, setValues = ref5.setValues;
    var ref6 = (0,hooks_usePreferences__WEBPACK_IMPORTED_MODULE_14__/* .usePreferences */ .Gn)(), preferences = ref6.preferences, setPreferences = ref6.setPreferences;
    var ref7 = (0,hooks_usePageEventsContext__WEBPACK_IMPORTED_MODULE_18__/* .usePageEventsContext */ .qN)(), pageviewEventHasFired = ref7.pageviewEventHasFired, setCartEventFired = ref7.setCartEventFired;
    var lastLoginEmail = preferences["last-login-email"];
    var rememberMeChecked = lastLoginEmail !== undefined;
    var ref8 = (0,hooks_useSiteConfig__WEBPACK_IMPORTED_MODULE_8__/* .useSiteConfig */ .N)(), _validation = ref8.validation, _phone = _validation.phone, prefix = _phone.prefix, max = _phone.length.max;
    var _phoneNo;
    var ref9 = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_2__/* .useForm */ .cI)({
        defaultValues: {
            email: data.email || lastLoginEmail,
            phoneNo: (_phoneNo = data.phoneNo) !== null && _phoneNo !== void 0 ? _phoneNo : prefix,
            rememberMe: rememberMeChecked
        },
        mode: "onChange"
    }), registerField = ref9.register, handleSubmit = ref9.handleSubmit, errors = ref9.errors, formState = ref9.formState, watch = ref9.watch;
    var ref10 = (0,hooks_useLoginAndRegister__WEBPACK_IMPORTED_MODULE_11__/* .useLoginAndRegister */ .$)(), _loginWithEmailAndPassword = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)(ref10.loginWithEmailAndPassword, 2), loginResult = _loginWithEmailAndPassword[0], login = _loginWithEmailAndPassword[1];
    var emailFieldValue = watch("email");
    var isOTPEnabled = (0,hooks_useFeature__WEBPACK_IMPORTED_MODULE_12__/* .useFeature */ .S)("OTP_LOGIN");
    var hideTermsAndConditions = (0,hooks_useFeature__WEBPACK_IMPORTED_MODULE_12__/* .useFeature */ .S)("HIDE_TERMS_AND_CONDITIONS_ON_LOGIN");
    var ref11 = (0,hooks_useMainNav__WEBPACK_IMPORTED_MODULE_19__/* .useMainNavContext */ .QH)(), isForgotPasswordFormOpen = ref11.isForgotPasswordFormOpen, mobileMenuOpen = ref11.mobileMenuOpen;
    var ref12 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)((0,_generated_graphql__WEBPACK_IMPORTED_MODULE_5__/* .useUpdateProfileMutation */ .TGI)(), 2), updateProfile = ref12[1];
    var hasExistingAccount = !!(data.email && data.phoneNo && data.phoneNo !== prefix);
    react__WEBPACK_IMPORTED_MODULE_1__.useEffect(function() {
        setValues && setValues({
            email: emailFieldValue
        });
    }, [
        emailFieldValue,
        setValues
    ]);
    var setLastLoginEmail = function(email) {
        setPreferences(function(curr) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)({}, curr), {
                "last-login-email": email
            });
        });
    };
    var onSubmit = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z)(function(loginData) {
            var ref, ref1, result, _tmp, _tmp1, _tmp2, ref2, ref3, email, _tmp3, customerId, _tmp4;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_25__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _tmp = {};
                        _tmp1 = {};
                        return [
                            4,
                            login((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)(_tmp, loginData), (_tmp1.email = data.email || loginData.email, _tmp1.uniqueShopperId = auth.uniqueShopperId, _tmp1)))
                        ];
                    case 1:
                        result = _state.sent();
                        if (!hasExistingAccount) return [
                            3,
                            3
                        ];
                        _tmp2 = {};
                        return [
                            4,
                            updateProfile((_tmp2.firstName = data.firstName, _tmp2.lastName = data.lastName, _tmp2.phoneNumber = data.phoneNo, _tmp2))
                        ];
                    case 2:
                        _state.sent();
                        _state.label = 3;
                    case 3:
                        if (!((ref = result.data) === null || ref === void 0 ? void 0 : ref.login)) return [
                            2
                        ];
                        if (!hasExistingAccount) {
                            if (loginData.rememberMe) {
                                setLastLoginEmail(loginData.email);
                            } else {
                                setLastLoginEmail(undefined);
                            }
                        }
                        _tmp3 = {};
                        _tmp4 = {};
                        if ((ref1 = result.data) === null || ref1 === void 0 ? void 0 : ref1.login) {
                            if (popoverLoginEnabled && !window.location.pathname.includes("/account")) {
                                window.scrollTo(0, 0);
                            }
                            if (pageviewEventHasFired) {
                                ;
                                setCartEventFired(false);
                                email = (((ref2 = result.data) === null || ref2 === void 0 ? void 0 : ref2.login.user) || _tmp3).email;
                                customerId = (((ref3 = result.data) === null || ref3 === void 0 ? void 0 : ref3.login) || _tmp4).customerId;
                                (0,utils_analytics__WEBPACK_IMPORTED_MODULE_17__/* .loginEvent */ .F2)(router.asPath, email, customerId);
                            }
                        }
                        if (onSuccess) onSuccess();
                        return [
                            2
                        ];
                }
            });
        });
        return function onSubmit(loginData) {
            return _ref.apply(this, arguments);
        };
    }();
    var loginError = undefined;
    if ((0,utils_extractError__WEBPACK_IMPORTED_MODULE_26__/* .extractCode */ .N)(loginResult) === "UNAUTHENTICATED") {
        loginError = t("invalidLoginPassword");
    } else if ((0,utils_extractError__WEBPACK_IMPORTED_MODULE_26__/* .extractError */ .d)(loginResult)) {
        loginError = (0,utils_extractError__WEBPACK_IMPORTED_MODULE_26__/* .extractError */ .d)(loginResult);
    } else if ((ref = loginResult.error) === null || ref === void 0 ? void 0 : ref.networkError) {
        loginError = t("networkError");
    }
    var _error;
    var error = (_error = data.error) !== null && _error !== void 0 ? _error : loginError;
    // Only show the email and password helper text if the user doesn't
    // have an account, and a translation for this text exists.
    var showEmailAndPasswordHelperText = Boolean(!hasExistingAccount && t("enterEmailAndPassword"));
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_3__/* .Stack */ .Kqy, {
        className: (0,twind__WEBPACK_IMPORTED_MODULE_27__.tw)(isForgotPasswordFormOpen && !mobileMenuOpen && "hidden"),
        asChild: true,
        dataTestId: "login-form",
        gapY: isInPopover ? "sm" : "base",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("form", {
            onSubmit: handleSubmit(onSubmit),
            noValidate: true,
            children: [
                showEmailAndPasswordHelperText && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    children: t("enterEmailAndPassword")
                }),
                error && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_3__/* .LiveRegion */ .LE2, {
                    type: "assertive",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_3__/* .Alert */ .bZj, {
                        variant: "error",
                        dataTestId: "login-form-error",
                        content: error
                    })
                }),
                hasExistingAccount && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_3__/* .InputText */ .oHY, {
                    id: "phoneNo",
                    label: t("phoneNumberLabel"),
                    dataTestId: "auth-field-phoneNo",
                    ref: registerField({
                        required: t("requiredField"),
                        validate: validate.phoneNumber,
                        maxLength: {
                            value: max,
                            message: t("genericFieldMaxLength", {
                                length: max
                            })
                        }
                    }),
                    maxLength: max,
                    name: "phoneNo",
                    disabled: true,
                    errorText: (ref1 = errors.phoneNo) === null || ref1 === void 0 ? void 0 : ref1.message,
                    placeholder: t("phonePlaceholder"),
                    type: "tel",
                    required: true,
                    crossOrigin: undefined
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_3__/* .InputText */ .oHY, {
                    id: "email",
                    label: t("emailPlaceholder"),
                    dataTestId: "auth-field-email",
                    ref: registerField({
                        required: getErrorMessageOrDefault("email", "requiredField"),
                        validate: validate.email
                    }),
                    name: "email",
                    type: "email",
                    disabled: hasExistingAccount,
                    errorText: (ref2 = errors.email) === null || ref2 === void 0 ? void 0 : ref2.message,
                    placeholder: t("email"),
                    required: true,
                    crossOrigin: undefined
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_3__/* .InputPassword */ .CMk, {
                    id: "password",
                    label: t("passwordLabel"),
                    dataTestId: "auth-field-password",
                    name: "password",
                    minLength: 8,
                    maxLength: 255,
                    placeholder: t("passwordPlaceholder"),
                    ref: registerField({
                        required: t("requiredFieldPassword")
                    }),
                    errorText: (ref3 = errors.password) === null || ref3 === void 0 ? void 0 : ref3.message,
                    showErrorIcon: true,
                    required: true,
                    crossOrigin: undefined
                }),
                !hasExistingAccount && !isInPopover && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_3__/* .InputCheckbox */ .o2J, {
                    id: "rememberMe",
                    name: "rememberMe",
                    ref: registerField(),
                    dataTestId: "auth-field-remember-me",
                    onChange: function(e) {
                        if (!e.target.checked) {
                            setLastLoginEmail(undefined);
                        }
                    },
                    children: t("rememberMe")
                }),
                hideTermsAndConditions || isInPopover ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .zxk, {
                    dataTestId: "auth-button-login",
                    label: hasExistingAccount ? t("linkPhone") : t("login"),
                    id: "login-submit",
                    loading: loginResult.fetching,
                    disabled: loginResult.fetching || !formState.isValid,
                    type: "submit",
                    dimmedReason: formState.isValid ? "" : t("pleaseCorrectInputErrors"),
                    size: !isInPopover ? "lg" : "base",
                    className: "mt-4"
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ui_components_TermsAndConditions__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                    page: "tacOnCreateAccount",
                    backupContent: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ui_components_TermsAndConditionsBackup__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                        page: "tacOnCreateAccount"
                    }),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .zxk, {
                        dataTestId: "auth-button-login",
                        label: hasExistingAccount ? t("linkPhone") : t("login"),
                        id: "login-submit",
                        loading: loginResult.fetching,
                        disabled: loginResult.fetching || !formState.isValid,
                        type: "submit",
                        dimmedReason: formState.isValid ? "" : t("pleaseCorrectInputErrors"),
                        size: "lg"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_3__/* .Stack */ .Kqy, {
                    direction: {
                        initial: "column"
                    },
                    items: "start",
                    className: "flex flex-wrap",
                    gapY: "none",
                    children: [
                        isOTPEnabled && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .zxk, {
                            dataTestId: "auth-button-otp-login",
                            variant: "underline",
                            onClick: function() {
                                return navigate === null || navigate === void 0 ? void 0 : navigate(_OTPForm__WEBPACK_IMPORTED_MODULE_20__/* .OTPAuthStage.login */ .h.login);
                            },
                            label: t("loginWithOTP")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .zxk, {
                            variant: "underline",
                            dataTestId: "forgotten-password-link",
                            onClick: onForgotPasswordClick,
                            label: t("forgotPassword"),
                            style: {
                                marginTop: isInPopover && !isOTPEnabled ? "-10px" : "0"
                            }
                        })
                    ]
                })
            ]
        })
    });
};


/***/ }),

/***/ 83688:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "h": function() { return /* binding */ OTPAuthStage; },
  "Q": function() { return /* binding */ OTPAuthenticateForm; }
});

// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(24246);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ../node_modules/next/router.js
var next_router = __webpack_require__(86677);
var router_default = /*#__PURE__*/__webpack_require__.n(next_router);
// EXTERNAL MODULE: ./ui/components/Modal.tsx
var Modal = __webpack_require__(51377);
// EXTERNAL MODULE: ./ui/components/CloseButton.tsx
var CloseButton = __webpack_require__(6485);
// EXTERNAL MODULE: ./hooks/useMainNav.tsx + 1 modules
var useMainNav = __webpack_require__(14425);
// EXTERNAL MODULE: ./hooks/useSiteConfig.ts
var useSiteConfig = __webpack_require__(20368);
// EXTERNAL MODULE: ./hooks/useTranslations.tsx
var useTranslations = __webpack_require__(77480);
// EXTERNAL MODULE: ./hooks/useFormData.tsx
var useFormData = __webpack_require__(56543);
// EXTERNAL MODULE: ./ui/forms/AuthenticateForgotPasswordForm.tsx
var AuthenticateForgotPasswordForm = __webpack_require__(31887);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(23842);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(85034);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(70169);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(5341);
// EXTERNAL MODULE: ../node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(59312);
// EXTERNAL MODULE: ../node_modules/react-hook-form/dist/index.esm.js
var index_esm = __webpack_require__(93451);
// EXTERNAL MODULE: ../node_modules/@global-ecom/nitro-uds/dist/elements/esm/index.js + 103 modules
var esm = __webpack_require__(12601);
// EXTERNAL MODULE: ./hooks/useValidation.ts + 1 modules
var useValidation = __webpack_require__(70750);
// EXTERNAL MODULE: ./hooks/useLoginAndRegister.ts
var useLoginAndRegister = __webpack_require__(4402);
// EXTERNAL MODULE: ./utils/extractError.ts
var extractError = __webpack_require__(4360);
// EXTERNAL MODULE: ./utils/analytics/index.ts + 6 modules
var analytics = __webpack_require__(83168);
// EXTERNAL MODULE: ./hooks/useAuth.tsx
var useAuth = __webpack_require__(72507);
// EXTERNAL MODULE: ./hooks/usePageEventsContext.tsx
var usePageEventsContext = __webpack_require__(43308);
// EXTERNAL MODULE: ./hooks/useIsServer.ts
var useIsServer = __webpack_require__(64724);
// EXTERNAL MODULE: ./hooks/useFeature.ts
var useFeature = __webpack_require__(53625);
// EXTERNAL MODULE: ./utils/analytics/hashEmail.ts
var hashEmail = __webpack_require__(91990);
;// CONCATENATED MODULE: ./ui/forms/SignupOTPForm.tsx
























var SignupOTPForm = function(param) {
    var onSuccess = param.onSuccess, navigate = param.navigate;
    var ref, ref1, ref2, ref3, ref4, ref5;
    var t = (0,useTranslations/* useTranslate */.qM)();
    var ref6 = (0,_sliced_to_array/* default */.Z)((0,useValidation/* useValidation */.V)(), 1), validate = ref6[0];
    var ref7 = (0,useFormData/* useFormData */.qW)(), data = ref7.data, setValues = ref7.setValues;
    var auth = (0,useAuth/* useAuth */.aC)();
    var pageviewEventHasFired = (0,usePageEventsContext/* usePageEventsContext */.qN)().pageviewEventHasFired;
    var ref8 = (0,useMainNav/* useMainNavContext */.QH)(), isRegisterOpen = ref8.isRegisterOpen, setLoginOpen = ref8.setLoginOpen, setRegisterOpen = ref8.setRegisterOpen;
    var isServer = (0,useIsServer/* useIsServer */.w)();
    var registerOTPVerificationEnabled = (0,useFeature/* useFeature */.S)("REGISTER_OTP_VERIFICATION_ENABLED");
    var ref9 = (0,index_esm/* useForm */.cI)({
        defaultValues: {
            emailList: true,
            phoneNo: data.phoneNo,
            terms: true
        },
        mode: "onChange"
    }), registerField = ref9.register, handleSubmit = ref9.handleSubmit, errors = ref9.errors, formState = ref9.formState;
    var ref10 = (0,useLoginAndRegister/* useLoginAndRegister */.$)(), _register = (0,_sliced_to_array/* default */.Z)(ref10.register, 2), registerResult = _register[0], register = _register[1];
    var hasSubmitted = react.useRef(false);
    var shouldShowVerifyPhoneModal = !data.phoneNo && !isServer && isRegisterOpen && registerOTPVerificationEnabled;
    (0,react.useEffect)(function() {
        if (pageviewEventHasFired) {
            (0,analytics/* event */.B)(analytics/* AnalyticsEvents.GA4_CustomEvent */._q.GA4_CustomEvent, {
                event_name: analytics/* AnalyticsEvents.GA4EC_SignUpFormOpen */._q.GA4EC_SignUpFormOpen,
                event_params: {
                    method: (0,analytics/* getPageType */.C2)((router_default()).asPath)
                }
            });
        }
    }, [
        pageviewEventHasFired
    ]);
    (0,react.useEffect)(function() {
        return function() {
            if (!hasSubmitted.current && pageviewEventHasFired) {
                (0,analytics/* event */.B)(analytics/* AnalyticsEvents.GA4_CustomEvent */._q.GA4_CustomEvent, {
                    event_name: analytics/* AnalyticsEvents.SIGN_UP_FORM_CLOSE */._q.SIGN_UP_FORM_CLOSE,
                    event_params: {
                        method: (0,analytics/* getPageType */.C2)((router_default()).asPath)
                    }
                });
            }
        };
    }, [
        pageviewEventHasFired
    ]);
    var onSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var ref, result, _tmp, _tmp1, triggerGA4Event, _tmp2;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        hasSubmitted.current = true;
                        _tmp = {};
                        _tmp1 = {};
                        return [
                            4,
                            register((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)(_tmp, data), (_tmp1.otpVerifyToken = window.localStorage.getItem("otpToken"), _tmp1)))
                        ];
                    case 1:
                        result = _state.sent();
                        triggerGA4Event = function() {
                            (0,analytics/* event */.B)(analytics/* AnalyticsEvents.GA4_CustomEvent */._q.GA4_CustomEvent, {
                                event_name: analytics/* AnalyticsEvents.GA4EC_SignUp */._q.GA4EC_SignUp,
                                event_params: {
                                    method: (0,analytics/* getPageType */.C2)((router_default()).asPath),
                                    is_guest: "false",
                                    hashed_email: (0,hashEmail/* hashEmail */.g)(data.email),
                                    custom_user_id: auth.customerId
                                }
                            });
                        };
                        _tmp2 = {};
                        if ((0,extractError/* extractCode */.N)(result) === "LOGIN_ALREADY_EXISTS") {
                            setValues((_tmp2.error = "This login is already in use. Please log in with your password.", _tmp2.firstName = data.firstName, _tmp2.lastName = data.lastName, _tmp2.email = data.email, _tmp2.phoneNumber = data.phoneNo, _tmp2));
                            navigate === null || navigate === void 0 ? void 0 : navigate(OTPAuthStage.login_with_email);
                        }
                        if (!((ref = result.data) === null || ref === void 0 ? void 0 : ref.register)) return [
                            2
                        ];
                        if (pageviewEventHasFired) triggerGA4Event();
                        if (onSuccess) onSuccess();
                        return [
                            2
                        ];
                }
            });
        });
        return function onSubmit(data) {
            return _ref.apply(this, arguments);
        };
    }();
    var error = (0,extractError/* extractError */.d)(registerResult) || data.error;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Stack */.Kqy, {
        asChild: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
            "data-test-id": "login-form",
            onSubmit: handleSubmit(onSubmit),
            noValidate: true,
            children: [
                error && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* LiveRegion */.LE2, {
                    type: "assertive",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Alert */.bZj, {
                        dataTestId: "register-otp-form-error",
                        content: error,
                        variant: "error"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* InputText */.oHY, {
                    id: "firstName",
                    label: t("firstNameLabel"),
                    dataTestId: "auth-field-firstName",
                    ref: registerField({
                        required: t("requiredField"),
                        validate: validate.name
                    }),
                    name: "firstName",
                    errorText: (ref = errors.firstName) === null || ref === void 0 ? void 0 : ref.message,
                    placeholder: t("firstNamePlaceholder"),
                    required: true,
                    crossOrigin: undefined
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* InputText */.oHY, {
                    id: "lastName",
                    label: t("lastNameLabel"),
                    dataTestId: "auth-field-lastName",
                    ref: registerField({
                        required: t("requiredField"),
                        validate: validate.name
                    }),
                    name: "lastName",
                    errorText: (ref1 = errors.lastName) === null || ref1 === void 0 ? void 0 : ref1.message,
                    placeholder: t("lastNamePlaceholder"),
                    required: true,
                    crossOrigin: undefined
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* InputText */.oHY, {
                    id: "phoneNo",
                    label: t("phoneLabel"),
                    dataTestId: "auth-field-phoneNo",
                    ref: registerField({
                        required: t("requiredField"),
                        validate: validate.phoneNumber
                    }),
                    name: "phoneNo",
                    errorText: (ref2 = errors.phoneNo) === null || ref2 === void 0 ? void 0 : ref2.message,
                    placeholder: t("phonePlaceholder"),
                    type: "tel",
                    required: true,
                    crossOrigin: undefined
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* InputText */.oHY, {
                    id: "email",
                    label: t("emailLabel"),
                    dataTestId: "auth-field-email",
                    ref: registerField({
                        required: t("requiredField"),
                        validate: validate.email
                    }),
                    name: "email",
                    errorText: (ref3 = errors.email) === null || ref3 === void 0 ? void 0 : ref3.message,
                    placeholder: t("emailPlaceholder"),
                    required: true,
                    crossOrigin: undefined
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* InputPassword */.CMk, {
                    id: "password",
                    label: t("passwordLabel"),
                    dataTestId: "auth-field-password",
                    ref: registerField({
                        required: t("requiredField"),
                        validate: validate.password
                    }),
                    name: "password",
                    errorText: (ref4 = errors.password) === null || ref4 === void 0 ? void 0 : ref4.message,
                    placeholder: t("passwordPlaceholder"),
                    required: true,
                    crossOrigin: undefined
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Button */.zxk, {
                    dataTestId: "auth-button-register",
                    label: t("continue"),
                    id: "register-submit",
                    loading: registerResult.fetching,
                    disabled: registerResult.fetching || !formState.isValid,
                    type: "submit",
                    dimmedReason: t("pleaseCorrectInputErrors")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* InputCheckbox */.o2J, {
                    dataTestId: "auth-field-emailList",
                    id: "emailList",
                    name: "emailList",
                    ref: registerField,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "font-bold",
                        children: t("emailListPlaceholder")
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* InputCheckbox */.o2J, {
                    id: "terms",
                    name: "terms",
                    dataTestId: "auth-field-toc",
                    ref: registerField({
                        validate: function(value) {
                            if (!value) {
                                return t("acceptTerms");
                            }
                        }
                    }),
                    children: t("reviewTerms")
                }),
                ((ref5 = errors.terms) === null || ref5 === void 0 ? void 0 : ref5.message) && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Text */.xvT, {
                    asChild: true,
                    dataTestId: "toc-message",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: errors.terms.message
                    })
                }),
                shouldShowVerifyPhoneModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
                    variant: "darkOpacity",
                    dataTestId: "verify-my-phone",
                    className: "max-w-xl p-6 border-none rounded-none origin-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col space-y-6 p-4 sm:p-6",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "text-base text-gray-600 leading-none",
                                    children: t("verifyPhoneNoMessage")
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* ButtonCta */.NlM, {
                                    id: "verify-my-phone-btn",
                                    onClick: function() {
                                        return setLoginOpen(true), setRegisterOpen(false);
                                    },
                                    label: t("verifyPhoneNoCta"),
                                    className: "w-full",
                                    type: "button",
                                    dataTestId: "verify-my-phone-btn"
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./__generated__/graphql.ts
var graphql = __webpack_require__(37678);
// EXTERNAL MODULE: ./ui/components/TermsAndConditions.tsx + 3 modules
var TermsAndConditions = __webpack_require__(99750);
// EXTERNAL MODULE: ./ui/components/TermsAndConditionsBackup.tsx
var TermsAndConditionsBackup = __webpack_require__(95459);
// EXTERNAL MODULE: ./utils/textMask.ts
var textMask = __webpack_require__(27058);
;// CONCATENATED MODULE: ./ui/forms/ConfirmOTP.tsx




















var GraphqlOTPErrorCodes = [
    graphql/* GraphQlError.OtpLoginDisabled */.lNJ.OtpLoginDisabled,
    graphql/* GraphQlError.WrongPin */.lNJ.WrongPin,
    graphql/* GraphQlError.InternalServerError */.lNJ.InternalServerError,
    graphql/* GraphQlError.TtlExpired */.lNJ.TtlExpired, 
];
// TODO: This is already a refactored version of the messages. Ideally we want to decouple these from the frontend and make it injectable from sanity.
var OTP_CLIENT_ERROR_MESSAGES = {
    MORE_THAN_ONE_CUSTOMER: "We couldn't log you in as your phone number is linked to more than one accounts. Please contact the customer support team.",
    ENCRYPTED_PASSWORD_EMPTY: "Please log in using your password in order to enable login via OTP for next time.",
    NO_MORE_PIN_ATTEMPTS: "You've exceeded the maximum number of attempts to enter correct OTP codes. Please try after some time or contact customer care"
};
var OTP_GQL_ERROR_MESSAGES = {
    OTP_LOGIN_DISABLED: "Kindly login with your phone number or email and password as the OTP option is currently unavailable",
    WRONG_PIN: "The OTP entered is incorrect. Please enter correct OTP or try regenerating the OTP",
    INTERNAL_SERVER_ERROR: "Something went wrong",
    TTL_EXPIRED: "The OTP entered has expired. Please regenerate a new OTP"
};
var ConfirmOTP = function(props) {
    var ref, ref1, ref2;
    var t = (0,useTranslations/* useTranslate */.qM)();
    var ref3 = (0,index_esm/* useForm */.cI)({
        mode: "onChange"
    }), registerField = ref3.register, handleSubmit = ref3.handleSubmit, errors = ref3.errors, formState = ref3.formState;
    var timerRef = react.useRef(null);
    var validation = (0,useSiteConfig/* useSiteConfig */.N)().validation;
    var ref4 = (0,useFormData/* useFormData */.qW)(), data = ref4.data, setValues = ref4.setValues;
    var pageviewEventHasFired = (0,usePageEventsContext/* usePageEventsContext */.qN)().pageviewEventHasFired;
    var ref5 = (0,useLoginAndRegister/* useLoginAndRegister */.$)(), _verifyLoginWithOTP = (0,_sliced_to_array/* default */.Z)(ref5.verifyLoginWithOTP, 2), verifyLoginWithOTPResult = _verifyLoginWithOTP[0], verifyLoginWithOTP = _verifyLoginWithOTP[1], _resendOTP = (0,_sliced_to_array/* default */.Z)(ref5.resendOTP, 2), resendOTPResult = _resendOTP[0], resendOTP = _resendOTP[1];
    var router = (0,next_router.useRouter)();
    var ref6 = (0,_sliced_to_array/* default */.Z)(react.useState(20), 2), timer = ref6[0], setTimer = ref6[1];
    var setUpTimer = react.useCallback(function() {
        setTimer(20);
        timerRef.current = setInterval(function() {
            return setTimer(function(prev) {
                return --prev;
            });
        }, 1000);
    }, []);
    var tearDownTimer = react.useCallback(function() {
        if (timerRef.current) clearInterval(timerRef.current);
    }, []);
    react.useEffect(function() {
        if (timerRef.current && timer <= 0) clearInterval(timerRef.current);
    }, [
        timer
    ]);
    react.useEffect(function() {
        setUpTimer();
        return function() {
            tearDownTimer();
        };
    }, [
        setUpTimer,
        tearDownTimer
    ]);
    var executeRedirect = function(error) {
        var isRegisterRedirectPath = error === "MORE_THAN_ONE_CUSTOMER";
        if (isRegisterRedirectPath) props.navigate(OTPAuthStage.register);
        var isLoginWithEmailPath = [
            "ENCRYPTED_PASSWORD_EMPTY",
            "OTP_LOGIN_DISABLED", 
        ].includes(error);
        if (isLoginWithEmailPath) props.navigate(OTPAuthStage.login_with_email);
    };
    var handleLoginRedirect = function() {
        setValues({
            error: ""
        }); // reset error when user goes back to login page
        props.navigate(OTPAuthStage.login);
    };
    var handleResendOTP = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(e) {
            var ref, result, _tmp, ref1, _tmp1;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        e.preventDefault();
                        tearDownTimer();
                        setUpTimer();
                        _tmp = {};
                        return [
                            4,
                            resendOTP((_tmp.pinId = data.pinId, _tmp))
                        ];
                    case 1:
                        result = _state.sent();
                        _tmp1 = {};
                        if ((ref = result.data) === null || ref === void 0 ? void 0 : ref.resendOTP) {
                            ;
                            setValues((_tmp1.pinId = (ref1 = result.data) === null || ref1 === void 0 ? void 0 : ref1.resendOTP, _tmp1));
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function handleResendOTP(e) {
            return _ref.apply(this, arguments);
        };
    }();
    var onSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(formDataValues) {
            var ref, _tmp, result, _tmp1, errorCode, ref1, code, _tmp2, ref2, ref3, user, customerId, _tmp3, _tmp4, _tmp5, e, _tmp6;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        _tmp = {};
                        setValues((_tmp.error = "", _tmp));
                        _tmp1 = {};
                        return [
                            4,
                            verifyLoginWithOTP((_tmp1.pin = formDataValues.otp, _tmp1.pinId = data.pinId, _tmp1.phoneNo = data.phoneNo, _tmp1))
                        ];
                    case 1:
                        result = _state.sent();
                        errorCode = (0,extractError/* extractCode */.N)(result); // used to extract GQL errors
                        _tmp2 = {};
                        code = ((ref1 = (ref = result.data) === null || ref === void 0 ? void 0 : ref.verifyLoginWithOTP) !== null && ref1 !== void 0 ? ref1 : _tmp2).code;
                        // exit early if there is no customer with number
                        if (code === "CUSTOMER_NOT_FOUND") props.navigate(OTPAuthStage.register);
                        _tmp3 = {};
                        if (code === "OK" && props.onSuccess) {
                            ;
                            ref3 = ((ref2 = result.data) === null || ref2 === void 0 ? void 0 : ref2.verifyLoginWithOTP.authPayload) || _tmp3, user = ref3.user, customerId = ref3.customerId;
                            if (pageviewEventHasFired) (0,analytics/* loginEvent */.F2)(router.asPath, user === null || user === void 0 ? void 0 : user.email, customerId);
                            props.onSuccess();
                        }
                        _tmp4 = {};
                        _tmp5 = {};
                        if (code) {
                            setValues((_tmp4.error = OTP_CLIENT_ERROR_MESSAGES[code], _tmp4));
                            executeRedirect(code);
                        } else if (errorCode) {
                            setValues((_tmp5.error = OTP_GQL_ERROR_MESSAGES[errorCode], _tmp5));
                            executeRedirect(errorCode);
                        }
                        return [
                            3,
                            3
                        ];
                    case 2:
                        e = _state.sent();
                        _tmp6 = {};
                        setValues((_tmp6.error = e === null || e === void 0 ? void 0 : e.message, _tmp6));
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function onSubmit(formDataValues) {
            return _ref.apply(this, arguments);
        };
    }();
    var _error;
    var error = (_error = data.error) !== null && _error !== void 0 ? _error : (0,extractError/* extractError */.d)(verifyLoginWithOTPResult);
    react.useEffect(function() {
        if (!data.phoneNo) props.navigate(OTPAuthStage.login);
    }, [
        data.phoneNo,
        props.navigate
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    var ref7;
    var maskedPhoneNumber = (0,textMask/* invertedTextMask */.M)(data.phoneNo, (ref7 = (ref = validation.phone.prefix) === null || ref === void 0 ? void 0 : ref.length) !== null && ref7 !== void 0 ? ref7 : 0, 3, "#");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
        className: "flex flex-col space-y-4",
        "data-test-id": "login-form",
        onSubmit: handleSubmit(onSubmit),
        noValidate: true,
        children: [
            error && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Alert */.bZj, {
                dataTestId: "confirm-form-error",
                variant: "error",
                content: error
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: t("enterOTP")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "font-bold",
                                children: maskedPhoneNumber
                            }),
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Button */.zxk, {
                                variant: "underline",
                                onClick: handleLoginRedirect,
                                label: t("change")
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* InputText */.oHY, {
                label: t("otpLabel"),
                id: "otp",
                dataTestId: "confirm-field-phone",
                ref: registerField({
                    required: t("requiredField"),
                    maxLength: 4
                }),
                name: "otp",
                error: !!((ref1 = errors.otp) === null || ref1 === void 0 ? void 0 : ref1.message),
                errorText: (ref2 = errors.otp) === null || ref2 === void 0 ? void 0 : ref2.message,
                maxLength: 4,
                placeholder: t("otpPlaceholder"),
                required: true,
                crossOrigin: undefined
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TermsAndConditions/* default */.Z, {
                page: "tacOnCreateAccount",
                backupContent: /*#__PURE__*/ (0,jsx_runtime.jsx)(TermsAndConditionsBackup/* default */.Z, {
                    page: "tacOnCreateAccount"
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Button */.zxk, {
                    dataTestId: "otp-confirm-btn",
                    label: t("login"),
                    id: "login-submit",
                    loading: verifyLoginWithOTPResult.fetching,
                    disabled: verifyLoginWithOTPResult.fetching || resendOTPResult.fetching || !formState.isValid,
                    type: "submit",
                    dimmedReason: t("pleaseCorrectInputErrors")
                })
            }),
            timer > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "mt-4",
                children: t("resendOTPTimer", {
                    timer: timer
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: "text-puma-black",
                children: [
                    t("didNotGetTheCode"),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Button */.zxk, {
                        dataTestId: "resend-otp",
                        variant: "underline",
                        onClick: handleResendOTP,
                        label: t("resend")
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./ui/forms/LoginWithEmailAndPassword.tsx
var LoginWithEmailAndPassword = __webpack_require__(75139);
;// CONCATENATED MODULE: ./ui/forms/LoginWithOTP.tsx














var LoginOTPForm = function(param) {
    var navigate = param.navigate;
    var ref;
    var t = (0,useTranslations/* useTranslate */.qM)();
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useValidation/* useValidation */.V)(), 1), validate = ref1[0];
    var ref2 = (0,useSiteConfig/* useSiteConfig */.N)(), _validation = ref2.validation, _phone = _validation.phone, prefix = _phone.prefix, max = _phone.length.max;
    var ref3 = (0,index_esm/* useForm */.cI)({
        mode: "onChange",
        defaultValues: {
            phoneNo: prefix
        }
    }), registerField = ref3.register, handleSubmit = ref3.handleSubmit, errors = ref3.errors, formState = ref3.formState, watch = ref3.watch;
    var ref4 = (0,useFormData/* useFormData */.qW)(), data = ref4.data, setValues = ref4.setValues;
    var phoneNoFieldValue = watch("phoneNo");
    react.useEffect(function() {
        setValues && setValues({
            phoneNo: phoneNoFieldValue
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        phoneNoFieldValue
    ]);
    var ref5 = (0,useLoginAndRegister/* useLoginAndRegister */.$)(), _loginWithOTP = (0,_sliced_to_array/* default */.Z)(ref5.loginWithOTP, 2), loginWithOTPResult = _loginWithOTP[0], loginWithOTP = _loginWithOTP[1];
    var onSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var ref, result, _tmp, _tmp1;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _tmp = {};
                        return [
                            4,
                            loginWithOTP((_tmp.phoneNo = data.phoneNo, _tmp))
                        ];
                    case 1:
                        result = _state.sent();
                        _tmp1 = {};
                        if ((ref = result.data) === null || ref === void 0 ? void 0 : ref.loginWithOTP) {
                            setValues((_tmp1.phoneNo = data.phoneNo, _tmp1.pinId = result.data.loginWithOTP, _tmp1));
                            navigate(OTPAuthStage.confirm_otp);
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function onSubmit(data) {
            return _ref.apply(this, arguments);
        };
    }();
    var ref6;
    var error = (ref6 = (0,extractError/* extractError */.d)(loginWithOTPResult)) !== null && ref6 !== void 0 ? ref6 : data === null || data === void 0 ? void 0 : data.error;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Stack */.Kqy, {
        asChild: true,
        dataTestId: "login-form",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
            onSubmit: handleSubmit(onSubmit),
            children: [
                error && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* LiveRegion */.LE2, {
                    type: "assertive",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Alert */.bZj, {
                        "data-test-id": "login-form-error",
                        variant: "error",
                        content: error
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* InputText */.oHY, {
                    label: t("phoneNumberLabel"),
                    id: "phoneNo",
                    dataTestId: "auth-field-phoneNo",
                    ref: registerField({
                        required: t("requiredField"),
                        validate: validate.phoneNumber,
                        maxLength: {
                            value: max,
                            message: t("genericFieldMaxLength", {
                                length: max
                            })
                        }
                    }),
                    maxLength: max,
                    name: "phoneNo",
                    errorText: (ref = errors.phoneNo) === null || ref === void 0 ? void 0 : ref.message,
                    placeholder: t("phonePlaceholder"),
                    type: "tel",
                    required: true,
                    crossOrigin: undefined
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Button */.zxk, {
                    dataTestId: "get-otp-btn",
                    id: "login-submit",
                    loading: loginWithOTPResult.fetching,
                    disabled: loginWithOTPResult.fetching || !formState.isValid,
                    type: "submit",
                    label: t("getOTP"),
                    dimmedReason: t("pleaseCorrectInputErrors")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: t("otpLoginHeader")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Stack */.Kqy, {
                    direction: {
                        initial: "row"
                    },
                    justify: "start",
                    gapY: "none",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Button */.zxk, {
                            variant: "underline",
                            dataTestId: "otp-login-with-email-password",
                            onClick: function() {
                                return navigate(OTPAuthStage.login_with_email);
                            },
                            label: t("loginWithEmailAndPassword")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Button */.zxk, {
                            variant: "underline",
                            dataTestId: "otp-login-with-phone-password",
                            onClick: function() {
                                return navigate(OTPAuthStage.login_with_phone_password);
                            },
                            label: t("loginWithPhoneAndPassword")
                        })
                    ]
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ../node_modules/twind/twind.js + 1 modules
var twind = __webpack_require__(34209);
;// CONCATENATED MODULE: ./ui/forms/LoginWithPhoneAndPassword.tsx






















var LoginWithPhoneAndPassword = function(param) {
    var onSuccess = param.onSuccess, navigate = param.navigate, onForgotPasswordClick = param.onForgotPasswordClick, isInPopover = param.isInPopover;
    var ref, ref1;
    var t = (0,useTranslations/* useTranslate */.qM)();
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useValidation/* useValidation */.V)(), 1), validate = ref2[0];
    var ref3 = (0,useSiteConfig/* useSiteConfig */.N)(), _validation = ref3.validation, prefix = _validation.phone.prefix;
    var ref4 = (0,index_esm/* useForm */.cI)({
        mode: "onChange",
        defaultValues: {
            phoneNo: prefix
        }
    }), registerField = ref4.register, handleSubmit = ref4.handleSubmit, errors = ref4.errors, formState = ref4.formState, watch = ref4.watch;
    var router = (0,next_router.useRouter)();
    var ref5 = (0,useFormData/* useFormData */.qW)(), data = ref5.data, setValues = ref5.setValues;
    var pageviewEventHasFired = (0,usePageEventsContext/* usePageEventsContext */.qN)().pageviewEventHasFired;
    var ref6 = (0,useMainNav/* useMainNavContext */.QH)(), isForgotPasswordFormOpen = ref6.isForgotPasswordFormOpen, mobileMenuOpen = ref6.mobileMenuOpen;
    var phoneFieldValue = watch("phoneNo");
    (0,react.useEffect)(function() {
        setValues && setValues({
            phoneNo: phoneFieldValue
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        phoneFieldValue
    ]);
    var ref7 = (0,useLoginAndRegister/* useLoginAndRegister */.$)(), _loginWithPhoneAndPassword = (0,_sliced_to_array/* default */.Z)(ref7.loginWithPhoneAndPassword, 2), loginResult = _loginWithPhoneAndPassword[0], login = _loginWithPhoneAndPassword[1];
    var onSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var ref, result, _tmp, ref1, ref2, email, _tmp1, customerId, _tmp2;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _tmp = {};
                        return [
                            4,
                            login((0,_object_spread/* default */.Z)(_tmp, data))
                        ];
                    case 1:
                        result = _state.sent();
                        _tmp1 = {};
                        _tmp2 = {};
                        if ((ref = result.data) === null || ref === void 0 ? void 0 : ref.loginWithPhone) {
                            ;
                            email = (((ref1 = result.data) === null || ref1 === void 0 ? void 0 : ref1.loginWithPhone.user) || _tmp1).email;
                            customerId = (((ref2 = result.data) === null || ref2 === void 0 ? void 0 : ref2.loginWithPhone) || _tmp2).customerId;
                            if (pageviewEventHasFired) (0,analytics/* loginEvent */.F2)(router.asPath, email, customerId);
                            onSuccess && onSuccess();
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function onSubmit(data) {
            return _ref.apply(this, arguments);
        };
    }();
    var ref8;
    var error = (0,extractError/* extractCode */.N)(loginResult) === "CUSTOMER_NOT_FOUND" ? "Customer with phone number provided wasn't found. Please check phone number or use another login option." : (ref8 = (0,extractError/* extractError */.d)(loginResult)) !== null && ref8 !== void 0 ? ref8 : data === null || data === void 0 ? void 0 : data.error;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Stack */.Kqy, {
        className: (0,twind.tw)(isForgotPasswordFormOpen && !mobileMenuOpen && "hidden"),
        asChild: true,
        dataTestId: "login-form",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
            onSubmit: handleSubmit(onSubmit),
            noValidate: true,
            children: [
                error && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* LiveRegion */.LE2, {
                    type: "assertive",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Alert */.bZj, {
                        dataTestId: "login-form-error",
                        content: error,
                        variant: "error"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: t("enterPhoneAndPassword")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* InputText */.oHY, {
                    id: "auth-field-phoneNo",
                    label: t("phoneNumberLabel"),
                    dataTestId: "auth-field-phoneNo",
                    ref: registerField({
                        required: t("requiredField"),
                        validate: validate.phoneNumber
                    }),
                    name: "phoneNo",
                    errorText: (ref = errors.phoneNo) === null || ref === void 0 ? void 0 : ref.message,
                    placeholder: t("phonePlaceholder"),
                    type: "tel",
                    required: true,
                    crossOrigin: undefined
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* InputPassword */.CMk, {
                    label: t("passwordLabel"),
                    id: "password",
                    dataTestId: "auth-field-password",
                    ref: registerField({
                        required: t("requiredField")
                    }),
                    name: "password",
                    errorText: (ref1 = errors.password) === null || ref1 === void 0 ? void 0 : ref1.message,
                    placeholder: t("passwordPlaceholder"),
                    required: true,
                    crossOrigin: undefined
                }),
                !isInPopover && /*#__PURE__*/ (0,jsx_runtime.jsx)(TermsAndConditions/* default */.Z, {
                    page: "tacOnCreateAccount",
                    backupContent: /*#__PURE__*/ (0,jsx_runtime.jsx)(TermsAndConditionsBackup/* default */.Z, {
                        page: "tacOnCreateAccount"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Button */.zxk, {
                    dataTestId: "auth-button-login",
                    label: t("login"),
                    id: "login-submit",
                    loading: loginResult.fetching,
                    disabled: loginResult.fetching || !formState.isValid,
                    type: "submit",
                    dimmedReason: t("pleaseCorrectInputErrors")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Stack */.Kqy, {
                    direction: {
                        initial: "column"
                    },
                    items: "start",
                    gapY: "none",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Button */.zxk, {
                            variant: "underline",
                            dataTestId: "auth-button-otp-login",
                            onClick: function() {
                                return navigate === null || navigate === void 0 ? void 0 : navigate(OTPAuthStage.login);
                            },
                            label: t("loginWithOTP")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Button */.zxk, {
                            variant: "underline",
                            dataTestId: "auth-button-forgot-password",
                            onClick: onForgotPasswordClick,
                            label: t("resetPassword")
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./ui/forms/OTPForm.tsx















var OTPAuthStage;
(function(OTPAuthStage) {
    OTPAuthStage["register"] = "register";
    OTPAuthStage["login"] = "login";
    OTPAuthStage["login_with_email"] = "login_with_email";
    OTPAuthStage["login_with_phone_password"] = "login_with_phone_password";
    OTPAuthStage["reset_password"] = "reset_password";
    OTPAuthStage["confirm_otp"] = "confirm_otp";
})(OTPAuthStage || (OTPAuthStage = {}));
var OTPFormElement = function(props) {
    var localizeUrlPath = (0,useSiteConfig/* useSiteConfig */.N)().localizeUrlPath;
    var router = (0,next_router.useRouter)();
    var setForgotPasswordFormOpen = (0,useMainNav/* useMainNavContext */.QH)().setForgotPasswordFormOpen;
    switch(props.selectedAction){
        case OTPAuthStage.register:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SignupOTPForm, {
                onSuccess: function() {
                    return router.replace(localizeUrlPath("/account"));
                },
                navigate: props.navigate
            });
        case OTPAuthStage.confirm_otp:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConfirmOTP, {
                navigate: props.navigate,
                onSuccess: props.onSuccess
            });
        case OTPAuthStage.login_with_email:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(LoginWithEmailAndPassword/* LoginWithEmailAndPasswordForm */.k, {
                onSuccess: function() {
                    var ref, ref1;
                    (ref = props.onClose) === null || ref === void 0 ? void 0 : ref.call(props);
                    (ref1 = props.onSuccess) === null || ref1 === void 0 ? void 0 : ref1.call(props);
                },
                navigate: props.navigate,
                onForgotPasswordClick: function() {
                    if (props.isInPopover) {
                        setForgotPasswordFormOpen(true);
                    } else {
                        props.onForgotPasswordClick();
                    }
                },
                isInPopover: props.isInPopover
            });
        case OTPAuthStage.login_with_phone_password:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(LoginWithPhoneAndPassword, {
                onSuccess: function() {
                    var ref, ref1;
                    (ref = props.onClose) === null || ref === void 0 ? void 0 : ref.call(props);
                    (ref1 = props.onSuccess) === null || ref1 === void 0 ? void 0 : ref1.call(props);
                },
                navigate: props.navigate,
                onForgotPasswordClick: function() {
                    if (props.isInPopover) {
                        setForgotPasswordFormOpen(true);
                    } else {
                        props.onForgotPasswordClick();
                    }
                },
                isInPopover: props.isInPopover
            });
        case OTPAuthStage.login:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(LoginOTPForm, {
                navigate: props.navigate
            });
        default:
            return null;
    }
};
var FormTitle = function(param) {
    var selectedAction = param.selectedAction;
    var t = (0,useTranslations/* useTranslate */.qM)();
    switch(selectedAction){
        case OTPAuthStage.register:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: t("register")
            });
        case OTPAuthStage.confirm_otp:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: t("enterOTPHeader")
            });
        case OTPAuthStage.login:
        case OTPAuthStage.login_with_email:
        case OTPAuthStage.login_with_phone_password:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: t("loginOrRegisterHeader")
            });
        default:
            return null;
    }
};
var OTPAuthenticateForm = function(param) {
    var from = param.from, _action = param.action, action = _action === void 0 ? OTPAuthStage.login : _action, onSuccess = param.onSuccess, resetOnOverlay = param.resetOnOverlay, showQuickRegistration = param.showQuickRegistration, isInModal = param.isInModal, isInPopover = param.isInPopover, onClose = param.onClose;
    var t = (0,useTranslations/* useTranslate */.qM)();
    var router = (0,next_router.useRouter)();
    var localizeUrlPath = (0,useSiteConfig/* useSiteConfig */.N)().localizeUrlPath;
    var _query = router.query, wishlist = _query.wishlist, swatch = _query.swatch, size = _query.size;
    var setForgotPasswordFormOpen = (0,useMainNav/* useMainNavContext */.QH)().setForgotPasswordFormOpen;
    var ref = (0,react.useState)(action), selectedAction = ref[0], setSelectedAction = ref[1];
    (0,react.useEffect)(function() {
        setSelectedAction(action);
    }, [
        action
    ]);
    var fromSuffix = from ? "&from=".concat(from) : "";
    var swatchQuery = swatch ? "&swatch=".concat(swatch) : "";
    var sizeQuery = size ? "&size=".concat(size) : "";
    var wishlistQuery = wishlist ? "&wishlist=".concat(wishlist) : "";
    var navigate = (0,react.useCallback)(function(action) {
        if (!isInModal && !isInPopover) {
            router.replace(localizeUrlPath("/account/login?action=" + action + fromSuffix + swatchQuery + sizeQuery + wishlistQuery));
        }
        setSelectedAction(action);
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        isInModal,
        router,
        localizeUrlPath
    ]);
    var showReset = selectedAction === OTPAuthStage.reset_password;
    var showResetForm = showReset && !resetOnOverlay;
    var showResetOverlay = showReset && resetOnOverlay;
    var showAuthForm = !showQuickRegistration && (resetOnOverlay || !showReset);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(useFormData/* AuthFormContextProvider */.G$, {
        children: [
            showAuthForm && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        className: "sr-only",
                        children: t("signIn")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        id: "login-container",
                        className: "space-y-5",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                !isInPopover && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-xl text-center font-bold w-full py-3 mb-8 border-b-2 border-puma-black",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormTitle, {
                                        selectedAction: selectedAction
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(OTPFormElement, {
                                    selectedAction: selectedAction,
                                    onForgotPasswordClick: function() {
                                        setSelectedAction(OTPAuthStage.reset_password);
                                    },
                                    onSuccess: onSuccess,
                                    navigate: navigate,
                                    isInPopover: isInPopover,
                                    onClose: onClose
                                })
                            ]
                        })
                    })
                ]
            }),
            showResetForm && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthenticateForgotPasswordForm/* ForgotPasswordForm */.L, {
                    isInPopover: isInPopover
                })
            }),
            showResetOverlay && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
                className: "w-full max-w-md px-8 pb-8 pt-9 relative",
                onClickOutside: function() {
                    setSelectedAction(OTPAuthStage.login);
                    setForgotPasswordFormOpen(false);
                },
                variant: "dark",
                dataTestId: "forgotten-password-modal",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseButton/* default */.Z, {
                        className: "absolute top-5 right-5 !mt-0",
                        onClick: function() {
                            setSelectedAction(OTPAuthStage.login);
                            setForgotPasswordFormOpen(false);
                        },
                        dataTestId: "close-forgotten-password-modal"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthenticateForgotPasswordForm/* ForgotPasswordForm */.L, {
                        isInPopover: isInPopover
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 20808:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ CardFrameIcon; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85034);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70169);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31373);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var _global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12601);
/* harmony import */ var twind__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34209);






var CardFrameIcon = function(_param) /*#__PURE__*/ {
    var borderless = _param.borderless, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "borderless"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        className: (0,twind__WEBPACK_IMPORTED_MODULE_3__.tw)("border-1 rounded-sm flex", borderless ? "border-transparent" : "border-puma-gray"),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_1__/* .Icon */ .JO$, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props), {
            size: "4xl",
            aspectRatio: 0.6
        }))
    });
};


/***/ }),

/***/ 89765:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ CreditCardLogo; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var _CardFrameIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20808);


var CreditCardLogo = function(param) {
    var type = param.type;
    switch(type){
        case "visa":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CardFrameIcon__WEBPACK_IMPORTED_MODULE_1__/* .CardFrameIcon */ .d, {
                name: "payment-visa",
                dataTestId: "card-icon-visa"
            });
        case "mastercard":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CardFrameIcon__WEBPACK_IMPORTED_MODULE_1__/* .CardFrameIcon */ .d, {
                name: "payment-mastercard",
                dataTestId: "card-icon-mastercard"
            });
        case "amex":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CardFrameIcon__WEBPACK_IMPORTED_MODULE_1__/* .CardFrameIcon */ .d, {
                name: "payment-amex",
                dataTestId: "card-icon-amex"
            });
        case "discover":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CardFrameIcon__WEBPACK_IMPORTED_MODULE_1__/* .CardFrameIcon */ .d, {
                name: "payment-discover",
                dataTestId: "card-icon-discover"
            });
        case "maestro":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CardFrameIcon__WEBPACK_IMPORTED_MODULE_1__/* .CardFrameIcon */ .d, {
                name: "payment-maestro",
                dataTestId: "card-icon-maestro"
            });
        case "jcb":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CardFrameIcon__WEBPACK_IMPORTED_MODULE_1__/* .CardFrameIcon */ .d, {
                name: "payment-jcb",
                dataTestId: "card-icon-jcb"
            });
        case "diners":
        case "diners_club_carte_blanche":
        case "diners_club_international":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CardFrameIcon__WEBPACK_IMPORTED_MODULE_1__/* .CardFrameIcon */ .d, {
                name: "payment-diners-club",
                dataTestId: "card-icon-diners-club"
            });
        default:
            return null;
    }
};


/***/ }),

/***/ 80417:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "y": function() { return /* binding */ CustomForm; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(19989);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(3204);
// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(24246);
// EXTERNAL MODULE: ../node_modules/@global-ecom/nitro-uds/dist/elements/esm/index.js + 103 modules
var esm = __webpack_require__(12601);
// EXTERNAL MODULE: ../node_modules/twind/style/style.js
var style = __webpack_require__(79200);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(85034);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(70169);
// EXTERNAL MODULE: ../node_modules/react-hook-form/dist/index.esm.js
var index_esm = __webpack_require__(93451);
;// CONCATENATED MODULE: ./ui/forms/custom/components/CustomFormWrapper.tsx






var CustomFormWrapper = function(props) {
    var isNested = props.isNested, children = props.children, onSubmit = props.onSubmit, form = props.form, dataTestId = props.dataTestId, gapY = props.gapY;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: isNested ? /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Stack */.Kqy, {
            dataTestId: dataTestId,
            children: children
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FormProvider */.RV, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, form), {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Stack */.Kqy, {
                asChild: true,
                dataTestId: dataTestId,
                gapY: gapY !== null && gapY !== void 0 ? gapY : "base",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
                    noValidate: true,
                    onSubmit: form.handleSubmit(onSubmit),
                    children: children
                })
            })
        }))
    });
};

// EXTERNAL MODULE: ./hooks/useSiteConfig.ts
var useSiteConfig = __webpack_require__(20368);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(23842);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(5341);
// EXTERNAL MODULE: ../node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(59312);
// EXTERNAL MODULE: ./hooks/useValidation.ts + 1 modules
var useValidation = __webpack_require__(70750);
// EXTERNAL MODULE: ./hooks/useTranslations.tsx
var useTranslations = __webpack_require__(77480);
// EXTERNAL MODULE: ./utils/object.ts
var object = __webpack_require__(7676);
// EXTERNAL MODULE: ./hooks/useTranslationFieldOrDefault.ts
var useTranslationFieldOrDefault = __webpack_require__(19318);
// EXTERNAL MODULE: ./hooks/useCheckoutFormData.tsx
var useCheckoutFormData = __webpack_require__(54973);
;// CONCATENATED MODULE: ./ui/forms/custom/hooks/useFormField.ts





/**
 * A safe wrapper around useCheckoutFormData that provides mock functionality
 * when the CheckoutFormProvider is not available (e.g., in Storybook).
 *
 * This hook catches the error thrown by useCheckoutFormData when used outside
 * of a CheckoutFormProvider and returns mock implementations of the functions.
 *
 * @template T The form values type
 * @param addressForm Optional form methods from react-hook-form
 * @returns The same interface as useCheckoutFormData
 */ var useSafeCheckoutFormData = function(addressForm) {
    try {
        // The original hook only uses the form methods, not the generic type parameter
        // This is type-safe because we're only passing the form methods object structure
        // Using unknown instead of any to maintain type safety
        return (0,useCheckoutFormData/* useCheckoutFormData */.rG)(addressForm);
    } catch (error) {
        // Return mock implementations if the hook throws
        return {
            getPersistedFormField: function(_fieldName) {
                return typeof _fieldName === "string" && _fieldName.includes("useAsBilling") ? false : "";
            },
            setPersistedFormField: function(_fieldName, _value) {
            // No-op implementation
            },
            clearPersistedFormField: function(_fieldName) {
            // No-op implementation
            },
            clearAddressFormFields: function(_addressType) {
            // No-op implementation
            },
            data: {}
        };
    }
};
var useFormField = function(field) {
    var errors = (0,index_esm/* useFormContext */.Gc)().errors;
    var getErrorMessageOrDefault = (0,useTranslationFieldOrDefault/* useTranslationFieldOrDefault */.H)();
    var resolveInputError = react.useCallback(function() {
        var ref;
        return (ref = (0,object/* resolveNode */.Ql)(field.name, errors)) === null || ref === void 0 ? void 0 : ref.message;
    }, [
        field,
        errors
    ]);
    return {
        getErrorMessageOrDefault: getErrorMessageOrDefault,
        resolveInputError: resolveInputError
    };
};

// EXTERNAL MODULE: ./ui/forms/custom/helpers/index.ts
var helpers = __webpack_require__(21541);
;// CONCATENATED MODULE: ./ui/forms/custom/components/CustomFormInput.tsx











var CustomFormInput = function(param) {
    var field = param.field, _required = param.required, required = _required === void 0 ? false : _required, prefix = param.prefix, submit = param.submit;
    var form = (0,index_esm/* useFormContext */.Gc)();
    var ref = (0,_sliced_to_array/* default */.Z)((0,useValidation/* useValidation */.V)(), 2), validate = ref[0], dynamicValidation = ref[1];
    var t = (0,useTranslations/* useTranslate */.qM)();
    var ref1 = useFormField(field), resolveInputError = ref1.resolveInputError, getErrorMessageOrDefault = ref1.getErrorMessageOrDefault;
    // Use a ref to track if the effect has run
    var initialLoadRef = (0,react.useRef)(false);
    // Use our safe version of the hook that works in both the app and Storybook
    var ref2 = useSafeCheckoutFormData(form), getPersistedFormField = ref2.getPersistedFormField, setPersistedFormField = ref2.setPersistedFormField;
    (0,react.useEffect)(function() {
        // Only run this effect once on mount
        if (!initialLoadRef.current) {
            // Check if the field name contains relevant address fields
            if (field.name.includes("firstName") || field.name.includes("lastName") || field.name.includes("lastNamePronunciation") || field.name.includes("firstNamePronunciation") || field.name.includes("address1") || field.name.includes("address2") || field.name.includes("city") || field.name.includes("postalCode") || field.name.includes("stateCode") || field.name.includes("phone") || field.name.includes("email")) {
                var persistedValue = getPersistedFormField(field.name);
                if (persistedValue) {
                    form.setValue(field.name, persistedValue);
                }
            }
            initialLoadRef.current = true;
        }
    }, [
        field.name,
        form,
        getPersistedFormField
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* InputText */.oHY, {
        name: field.name,
        id: field.id,
        dataTestId: field.dataTestId,
        required: required,
        placeholder: field.placeholder,
        label: field.label,
        maxLength: field.maxLength,
        minLength: field.minLength,
        errorText: resolveInputError(),
        autoCapitalize: field.autoCapitalize,
        ref: form.register({
            validate: function() {
                var _ref = (0,_async_to_generator/* default */.Z)(function(value) {
                    var errorMessage, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, v;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        if (value && field.pattern && required && !new RegExp(field.pattern).test(value.trim())) {
                            return [
                                2,
                                field.patternError || t("invalidInput")
                            ];
                        }
                        if (required && !value.trim()) {
                            return [
                                2,
                                t("invalidInput")
                            ];
                        }
                        if (value && field.pattern && !new RegExp(field.pattern).test(value)) {
                            return [
                                2,
                                field.patternError || t("invalidInput")
                            ];
                        }
                        if (field.validations) {
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            try {
                                for(_iterator = field.validations[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    v = _step.value;
                                    if (typeof v === "string") {
                                        errorMessage = validate[v](value, form.getValues());
                                    } else {
                                        errorMessage = dynamicValidation(value, form, v);
                                    }
                                    if (errorMessage) break;
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                        }
                        return [
                            2,
                            errorMessage
                        ];
                    });
                });
                return function(value) {
                    return _ref.apply(this, arguments);
                };
            }(),
            required: required && getErrorMessageOrDefault(field.name.substring(field.name.indexOf(".") + 1), "requiredField"),
            maxLength: field.maxLength && {
                value: field.maxLength,
                message: t("genericFieldMaxLength", {
                    length: field.maxLength
                })
            },
            minLength: field.minLength && {
                value: field.minLength,
                message: t("genericFieldMinLength", {
                    length: field.minLength
                })
            }
        }),
        type: field.inputType || field.type,
        onChange: function() {
            if (field.onChangeTrigger) {
                var helperFunc = helpers/* checkoutAddressHelpers */.dx[field.onChangeTrigger];
                if (helperFunc) helperFunc(form, prefix);
            }
            if (field.submitOnUpdate && submit) {
                form.trigger().then(function() {
                    submit();
                });
            }
        },
        onBlur: function(e) {
            if (field.name.includes("firstName") || field.name.includes("lastName") || field.name.includes("lastNamePronunciation") || field.name.includes("firstNamePronunciation") || field.name.includes("address1") || field.name.includes("address2") || field.name.includes("city") || field.name.includes("postalCode") || field.name.includes("stateCode") || field.name.includes("phone") || field.name.includes("email")) {
                setPersistedFormField(field.name, e.target.value);
            }
        },
        crossOrigin: undefined
    }, field.key);
};
/* harmony default export */ var components_CustomFormInput = (/*#__PURE__*/react.memo(CustomFormInput));

;// CONCATENATED MODULE: ./ui/forms/custom/components/CustomFormPassword.tsx










var CustomFormPassword = function(param) {
    var field = param.field;
    var form = (0,index_esm/* useFormContext */.Gc)();
    var ref = useFormField(field), resolveInputError = ref.resolveInputError, getErrorMessageOrDefault = ref.getErrorMessageOrDefault;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useValidation/* useValidation */.V)(), 2), validate = ref1[0], dynamicValidation = ref1[1];
    var t = (0,useTranslations/* useTranslate */.qM)();
    var register = form.register;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* InputPassword */.CMk, {
        label: field.label,
        dataTestId: field.dataTestId,
        placeholder: field.placeholder,
        id: field.id,
        name: field.name,
        ref: register({
            validate: function() {
                var _ref = (0,_async_to_generator/* default */.Z)(function(value) {
                    var errorMessage, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, v;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        if (field.pattern && !new RegExp(field.pattern).test(value)) {
                            return [
                                2,
                                field.patternError || t("invalidInput")
                            ];
                        }
                        if (field.validations) {
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            try {
                                for(_iterator = field.validations[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    v = _step.value;
                                    if (typeof v === "string") {
                                        errorMessage = validate[v](value);
                                    } else {
                                        errorMessage = dynamicValidation(value, form, v);
                                    }
                                    if (errorMessage) break;
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                        }
                        return [
                            2,
                            errorMessage
                        ];
                    });
                });
                return function(value) {
                    return _ref.apply(this, arguments);
                };
            }(),
            required: getErrorMessageOrDefault(field.name, "requiredField"),
            minLength: field.minLength && {
                value: field.minLength,
                message: t("passwordMinLength", {
                    length: field.minLength
                })
            },
            maxLength: field.maxLength && {
                value: field.maxLength,
                message: t("passwordMaxLength", {
                    length: field.maxLength
                })
            }
        }),
        minLength: field.minLength,
        maxLength: field.maxLength,
        errorText: resolveInputError(),
        required: true,
        crossOrigin: undefined
    }, field.key);
};
/* harmony default export */ var components_CustomFormPassword = (/*#__PURE__*/react.memo(CustomFormPassword));

;// CONCATENATED MODULE: ./ui/forms/custom/components/CustomFormCheckBox.tsx




var CustomFormCheckBox = function(param) {
    var field = param.field, _required = param.required, required = _required === void 0 ? false : _required;
    var register = (0,index_esm/* useFormContext */.Gc)().register;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* InputCheckbox */.o2J, {
        name: field.name,
        dataTestId: field.dataTestId,
        id: field.id,
        required: required,
        ref: register,
        children: field.label
    }, field.key);
};
/* harmony default export */ var components_CustomFormCheckBox = (/*#__PURE__*/react.memo(CustomFormCheckBox));

// EXTERNAL MODULE: ./hooks/useFeature.ts
var useFeature = __webpack_require__(53625);
;// CONCATENATED MODULE: ./ui/forms/custom/components/CustomFormBirthday.tsx








var SELECT_NAMES = {
    day: "day",
    month: "month",
    year: "year"
};
var hasValidValue = function(name) {
    return name !== "" && typeof name !== "undefined";
};
var CustomFormBirthday = function(param) {
    var field = param.field, _required = param.required, required = _required === void 0 ? false : _required;
    var ref, ref1, ref2, ref3, ref4, ref5;
    var t = (0,useTranslations/* useTranslate */.qM)();
    var form = (0,index_esm/* useFormContext */.Gc)();
    var popoverLoginEnabledJP = (0,useFeature/* useFeature */.S)("POPOVER_LOGIN_ENABLED_JP");
    var register = form.register, watch = form.watch, errors = form.errors;
    var currentItems = watch([
        SELECT_NAMES.day,
        SELECT_NAMES.month,
        SELECT_NAMES.year, 
    ]);
    var errorText = ((ref = errors[SELECT_NAMES.year]) === null || ref === void 0 ? void 0 : ref.message) || ((ref1 = errors[SELECT_NAMES.month]) === null || ref1 === void 0 ? void 0 : ref1.message) || ((ref2 = errors[SELECT_NAMES.day]) === null || ref2 === void 0 ? void 0 : ref2.message);
    var errorFields = {
        year: Boolean((ref3 = errors.year) === null || ref3 === void 0 ? void 0 : ref3.message),
        month: Boolean((ref4 = errors.month) === null || ref4 === void 0 ? void 0 : ref4.message),
        day: Boolean((ref5 = errors.day) === null || ref5 === void 0 ? void 0 : ref5.message)
    };
    var hasInitialValues = (0,react.useMemo)(function() {
        return hasValidValue(currentItems === null || currentItems === void 0 ? void 0 : currentItems.day) && hasValidValue(currentItems === null || currentItems === void 0 ? void 0 : currentItems.month) && hasValidValue(currentItems === null || currentItems === void 0 ? void 0 : currentItems.year);
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    return /*#__PURE__*/ (0,react.createElement)(esm/* InputDateSelect */.ksW, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, popoverLoginEnabledJP && {
        direction: "row"
    }), {
        key: field.key,
        name: field.name,
        id: field.id,
        label: t("labelInputBirthday"),
        required: required,
        currentItems: currentItems,
        selectNames: SELECT_NAMES,
        disabled: field.disabled || hasInitialValues,
        dataTestId: "birthday",
        errorText: errorText,
        error: errorFields,
        refs: {
            day: register({
                required: t("requiredFieldDay")
            }),
            month: register({
                required: t("requiredFieldMonth")
            }),
            year: register({
                required: t("requiredFieldYear")
            })
        },
        supportText: !field.hideSupportText ? t("birthdayInputSupportText") : undefined
    }));
};
/* harmony default export */ var components_CustomFormBirthday = (/*#__PURE__*/react.memo(CustomFormBirthday));

;// CONCATENATED MODULE: ./ui/forms/custom/components/CustomFormButton.tsx





var CustomFormButton = function(param) {
    var button = param.button, result = param.result;
    var formState = (0,index_esm/* useFormContext */.Gc)().formState;
    var t = (0,useTranslations/* useTranslate */.qM)();
    var _type;
    var type = (_type = button.type) !== null && _type !== void 0 ? _type : "submit";
    var isLoading = type === "submit" && (result === null || result === void 0 ? void 0 : result.fetching);
    var isDisabled = !formState.isValid;
    var _size;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Button */.zxk, {
        className: button.className,
        dataTestId: button.dataTestId,
        id: button.id,
        label: button.label,
        loading: isLoading,
        dimmed: isLoading || isDisabled,
        dimmedReason: isDisabled ? t("pleaseCorrectInputErrors") : "",
        disabled: isDisabled,
        type: type,
        size: (_size = button.size) !== null && _size !== void 0 ? _size : "lg",
        variant: button.variant
    }, button.key);
};
/* harmony default export */ var components_CustomFormButton = (/*#__PURE__*/react.memo(CustomFormButton));

// EXTERNAL MODULE: ../node_modules/twind/twind.js + 1 modules
var twind = __webpack_require__(34209);
;// CONCATENATED MODULE: ./ui/forms/custom/components/CustomFormLink.tsx




var CustomFormLink = function(param) {
    var field = param.field;
    var _href, _size;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,twind.tw)("flex items-center justify-center", field.class),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Link */.rUS, {
            href: (_href = field.href) !== null && _href !== void 0 ? _href : "",
            dataTestId: field.dataTestId,
            variant: field.variant || "underline",
            label: field.label,
            size: (_size = field.size) !== null && _size !== void 0 ? _size : undefined,
            className: field.className
        }, field.name)
    });
};
/* harmony default export */ var components_CustomFormLink = (/*#__PURE__*/react.memo(CustomFormLink));

;// CONCATENATED MODULE: ./ui/forms/custom/components/CustomFormRadio.tsx





var CustomFormRadio = function(param) {
    var field = param.field, _required = param.required, required = _required === void 0 ? false : _required;
    var register = (0,index_esm/* useFormContext */.Gc)().register;
    var ref = useFormField(field), getErrorMessageOrDefault = ref.getErrorMessageOrDefault, resolveInputError = ref.resolveInputError;
    var error = resolveInputError();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Stack */.Kqy, {
        gap: "sm",
        children: [
            field.values.map(function(value) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* InputRadio */.rWV, {
                    dataTestId: field.dataTestId,
                    name: field.name,
                    id: "".concat(field.name, "-").concat(value.value),
                    ref: register({
                        required: required && getErrorMessageOrDefault(field.name, "requiredField")
                    }),
                    className: "p-1",
                    value: value.value,
                    "aria-describedby": "".concat(field.name, "_error"),
                    children: value.label
                }, "".concat(field.name, "-").concat(value.value));
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* LiveRegion */.LE2, {
                type: "polite",
                id: "".concat(field.name, "_error"),
                children: error && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Alert */.bZj, {
                    variant: "error",
                    content: error
                })
            })
        ]
    });
};
/* harmony default export */ var components_CustomFormRadio = (/*#__PURE__*/react.memo(CustomFormRadio));

// EXTERNAL MODULE: ./utils/matchStateAndPostalCode.ts
var matchStateAndPostalCode = __webpack_require__(44321);
;// CONCATENATED MODULE: ./ui/forms/custom/components/CustomFormDropdown.tsx













var CustomFormDropdown = function(param) {
    var dropdownField = param.dropdownField, prefix = param.prefix, _required = param.required, required = _required === void 0 ? false : _required;
    var form = (0,index_esm/* useFormContext */.Gc)();
    var env = (0,useSiteConfig/* useSiteConfig */.N)().env;
    var t = (0,useTranslations/* useTranslate */.qM)();
    var resolveInputError = useFormField(dropdownField).resolveInputError;
    var ref = (0,_sliced_to_array/* default */.Z)((0,useValidation/* useValidation */.V)(), 2), validate = ref[0], dynamicValidation = ref[1];
    var options = dropdownField.translateLabels ? (0,helpers/* translateSelectOptions */.cE)(dropdownField.options, t) : dropdownField.options;
    var watch = form.watch, register = form.register;
    var value = watch(dropdownField.name);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* InputSelect */.JDu, {
        name: dropdownField.name,
        label: dropdownField.label,
        id: dropdownField.id,
        dataTestId: dropdownField.dataTestId,
        placeholder: dropdownField.placeholder,
        required: required,
        options: options,
        errorText: resolveInputError(),
        value: value,
        disabled: dropdownField.disabled,
        ref: register({
            validate: {
                requiredField: function(value) {
                    return required && !value ? t("requiredField") : undefined;
                },
                postalStateMatch: function() {
                    var _ref = (0,_async_to_generator/* default */.Z)(function(value) {
                        var stateFields, postalCode, watchedCountryCode, isValid, _tmp;
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    stateFields = new Set([
                                        "shippingAddress.stateCode",
                                        "billingAddress.stateCode"
                                    ]);
                                    if (!stateFields.has(dropdownField.name)) return [
                                        2,
                                        undefined
                                    ];
                                    postalCode = form.getValues(dropdownField.name.replace("stateCode", "postalCode"));
                                    // Will not error if postalcode is not defined yet
                                    if (!postalCode || form.formState.errors.postalCode) return [
                                        2,
                                        undefined
                                    ];
                                    watchedCountryCode = form.watch("shippingAddress.countryCode") || form.watch("billingAddress.countryCode");
                                    _tmp = {};
                                    return [
                                        4,
                                        (0,matchStateAndPostalCode/* matchStateAndPostalCode */.J)((_tmp.postalCode = postalCode, _tmp.stateCode = value ? value : null, _tmp.country = watchedCountryCode, _tmp.googleApiKey = env.googleApiKey, _tmp))
                                    ];
                                case 1:
                                    isValid = _state.sent().isValid;
                                    // State selected does not match postalCode provided
                                    if (!isValid) return [
                                        2,
                                        t("stateInvalidPostcode")
                                    ];
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function(value) {
                        return _ref.apply(this, arguments);
                    };
                }(),
                otherValidations: function() {
                    var _ref = (0,_async_to_generator/* default */.Z)(function(value) {
                        var errorMessage, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, v;
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            if (dropdownField.validations) {
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(_iterator = dropdownField.validations[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        v = _step.value;
                                        if (typeof v === "string") {
                                            errorMessage = validate[v](value);
                                        } else {
                                            errorMessage = dynamicValidation(value, form, v);
                                        }
                                        if (errorMessage) break;
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                            }
                            return [
                                2,
                                errorMessage
                            ];
                        });
                    });
                    return function(value) {
                        return _ref.apply(this, arguments);
                    };
                }()
            }
        }),
        onChange: function() {
            if (dropdownField.onChangeTrigger) {
                var helperFunc = helpers/* checkoutAddressHelpers */.dx[dropdownField.onChangeTrigger];
                if (helperFunc) helperFunc(form, prefix);
            }
        }
    }, dropdownField.key);
};
/* harmony default export */ var components_CustomFormDropdown = (/*#__PURE__*/react.memo(CustomFormDropdown));

// EXTERNAL MODULE: ./utils/constants.ts
var constants = __webpack_require__(79758);
// EXTERNAL MODULE: ./ui/components/AddressLookup.tsx
var AddressLookup = __webpack_require__(39309);
;// CONCATENATED MODULE: ./ui/forms/custom/components/CustomFormGoogleAddressLookUp.tsx












var CustomFormGoogleAddressLookUp = function(param) {
    var field = param.field, country = param.country, _required = param.required, required = _required === void 0 ? false : _required, prefix = param.prefix, submit = param.submit;
    var t = (0,useTranslations/* useTranslate */.qM)();
    var ref = (0,_sliced_to_array/* default */.Z)((0,useValidation/* useValidation */.V)(), 2), validate = ref[0], dynamicValidation = ref[1];
    var form = (0,index_esm/* useFormContext */.Gc)();
    var resolveInputError = useFormField(field).resolveInputError;
    // Use checkout form data hook with form parameter
    var setPersistedFormField = useSafeCheckoutFormData(form).setPersistedFormField;
    var onSelect = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(placeResults) {
            var ref, affectedFields;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!((ref = field.mapAddressLookupResultsToFormValues) === null || ref === void 0 ? void 0 : ref.length)) return [
                            3,
                            2
                        ];
                        affectedFields = [];
                        field.mapAddressLookupResultsToFormValues.forEach(function(param) {
                            var resultKey = param.resultKey, formKey = param.formKey;
                            var field = (0,helpers/* buildName */.VD)(formKey, prefix);
                            setValue(field, placeResults[resultKey]);
                            affectedFields.push(field);
                        });
                        return [
                            4,
                            trigger(affectedFields)
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        // Explicitly persist city, state, and postal code to context
                        try {
                            // Persist city if provided
                            if (placeResults.city) {
                                setPersistedFormField((0,helpers/* buildName */.VD)("city", prefix), placeResults.city);
                            }
                            // Persist stateCode if provided
                            if (placeResults.stateCode) {
                                setPersistedFormField((0,helpers/* buildName */.VD)("stateCode", prefix), placeResults.stateCode);
                            }
                            // Persist postalCode if provided
                            if (placeResults.postalCode) {
                                setPersistedFormField((0,helpers/* buildName */.VD)("postalCode", prefix), placeResults.postalCode);
                            }
                            // Persist address1 if provided
                            if (placeResults.address1) {
                                setPersistedFormField((0,helpers/* buildName */.VD)("address1", prefix), placeResults.address1);
                            }
                        } catch (e) {
                        // Silent error handling for context operations
                        }
                        if (!field.validateOnAddressLookupSelect) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            trigger()
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        if (field.submitOnUpdate && submit) {
                            trigger().then(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                                return (0,tslib_es6.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            return [
                                                4,
                                                submit()
                                            ];
                                        case 1:
                                            return [
                                                2,
                                                _state.sent()
                                            ];
                                    }
                                });
                            }));
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function onSelect(placeResults) {
            return _ref.apply(this, arguments);
        };
    }();
    var register = form.register, trigger = form.trigger, setValue = form.setValue, watch = form.watch;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AddressLookup/* AddressLookup */.Ij, {
        defaultValue: watch(field.name),
        lookupConstraints: constants/* SHIPPING_LOOKUP_CONSTRAINTS */.mV[country],
        onSelect: onSelect,
        name: field.name,
        label: field.label,
        id: field.id,
        dataTestId: field.dataTestId,
        placeholder: field.placeholder || "",
        maxLength: field.maxLength,
        required: required,
        ref: register({
            required: required && t("requiredField"),
            validate: function() {
                var _ref = (0,_async_to_generator/* default */.Z)(function(value) {
                    var errorMessage, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, v;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        if (field.validations) {
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            try {
                                for(_iterator = field.validations[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    v = _step.value;
                                    if (typeof v === "string") {
                                        errorMessage = validate[v](value);
                                    } else {
                                        errorMessage = dynamicValidation(value, form, v);
                                    }
                                    if (errorMessage) break;
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                        }
                        return [
                            2,
                            errorMessage
                        ];
                    });
                });
                return function(value) {
                    return _ref.apply(this, arguments);
                };
            }(),
            maxLength: field.maxLength && {
                value: field.maxLength,
                message: t("genericFieldMaxLength", {
                    length: field.maxLength
                })
            },
            minLength: field.minLength && {
                value: field.minLength,
                message: t("genericFieldMinLength", {
                    length: field.minLength
                })
            }
        }),
        errorText: resolveInputError()
    }, field.key);
};
/* harmony default export */ var components_CustomFormGoogleAddressLookUp = (/*#__PURE__*/react.memo(CustomFormGoogleAddressLookUp));

// EXTERNAL MODULE: ./ui/components/TermsAndConditions.tsx + 3 modules
var TermsAndConditions = __webpack_require__(99750);
;// CONCATENATED MODULE: ./ui/forms/custom/components/CustomFormTextOnly.tsx




var CustomFormText = function(param) {
    var field = param.field;
    var t = (0,useTranslations/* useTranslate */.qM)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Text */.xvT, {
        size: "xs",
        children: field.key ? t(field.key) : ""
    }, field.name);
};
/* harmony default export */ var CustomFormTextOnly = (/*#__PURE__*/react.memo(CustomFormText));

;// CONCATENATED MODULE: ./ui/forms/custom/components/CustomFormYubinbangoAddressLookUp.tsx












var EMPTY_ADDRESS_RESPONSE = {
    region_id: undefined,
    region: undefined,
    locality: undefined,
    street: undefined,
    extended: undefined
};
var CustomFormYubinbangoAddressLookUp = function(param) {
    var field = param.field, _required = param.required, required = _required === void 0 ? false : _required, prefix = param.prefix;
    var form = (0,index_esm/* useFormContext */.Gc)();
    var register = form.register, trigger = form.trigger, setValue = form.setValue, watch = form.watch;
    var setPersistedFormField = useSafeCheckoutFormData(form).setPersistedFormField;
    var defaultValue = (0,react.useRef)(watch(field.name));
    var t = (0,useTranslations/* useTranslate */.qM)();
    var resolveInputError = useFormField(field).resolveInputError;
    var getErrorMessageOrDefault = (0,useTranslationFieldOrDefault/* useTranslationFieldOrDefault */.H)();
    var getName = function(field) {
        return prefix ? "".concat(prefix, ".").concat(field) : field;
    };
    var url = "https://yubinbango.github.io/yubinbango-data/data/";
    var addressStates = (0,useSiteConfig/* useSiteConfig */.N)().addressStates;
    var onOptionSelect = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(address) {
            var _codeInfo, ref, regionId, locality, street, extended, addressRes, ref1, ref2, ref3;
            return (0,tslib_es6.__generator)(this, function(_state) {
                ref = (0,_sliced_to_array/* default */.Z)((_codeInfo = address.codeInfo) !== null && _codeInfo !== void 0 ? _codeInfo : [], 4), regionId = ref[0], locality = ref[1], street = ref[2], extended = ref[3];
                addressRes = EMPTY_ADDRESS_RESPONSE;
                if (regionId && locality) {
                    ;
                    addressRes = {
                        region_id: regionId !== null && regionId !== void 0 ? regionId : regionId,
                        region: addressStates["JP"] ? (ref1 = addressStates["JP"].find(function(state) {
                            return state.value === regionId;
                        })) === null || ref1 === void 0 ? void 0 : ref1.name : undefined,
                        locality: locality,
                        street: street !== null && street !== void 0 ? street : street,
                        extended: extended !== null && extended !== void 0 ? extended : street
                    };
                }
                setValue((0,helpers/* buildName */.VD)("postalCode", prefix), address.value ? "".concat(address.value.substring(0, 8)) : "");
                setPersistedFormField((0,helpers/* buildName */.VD)("postalCode", prefix), address.value ? "".concat(address.value.substring(0, 8)) : "");
                setValue((0,helpers/* buildName */.VD)("city", prefix), (addressRes === null || addressRes === void 0 ? void 0 : addressRes.locality) && (addressRes === null || addressRes === void 0 ? void 0 : addressRes.street) ? addressRes.locality + "" + addressRes.street : "");
                setPersistedFormField((0,helpers/* buildName */.VD)("city", prefix), (addressRes === null || addressRes === void 0 ? void 0 : addressRes.locality) && (addressRes === null || addressRes === void 0 ? void 0 : addressRes.street) ? addressRes.locality + "" + addressRes.street : "");
                setValue((0,helpers/* buildName */.VD)("stateCode", prefix), (ref2 = addressRes === null || addressRes === void 0 ? void 0 : addressRes.region) !== null && ref2 !== void 0 ? ref2 : "");
                setPersistedFormField((0,helpers/* buildName */.VD)("stateCode", prefix), (ref3 = addressRes === null || addressRes === void 0 ? void 0 : addressRes.region) !== null && ref3 !== void 0 ? ref3 : "");
                setValue((0,helpers/* buildName */.VD)("address1", prefix), "");
                setPersistedFormField((0,helpers/* buildName */.VD)("address1", prefix), "");
                trigger([
                    getName("stateCode"),
                    getName("city"),
                    getName("postalCode"),
                    getName("address1")
                ]);
                return [
                    2
                ];
            });
        });
        return function onOptionSelect(address) {
            return _ref.apply(this, arguments);
        };
    }();
    var filter = function(param) {
        var value = param.value, setOptions = param.setOptions;
        var ref, ref1;
        setValue((0,helpers/* buildName */.VD)("stateCode", prefix), "");
        setValue((0,helpers/* buildName */.VD)("city", prefix), "");
        setPersistedFormField((0,helpers/* buildName */.VD)("stateCode", prefix), "");
        setPersistedFormField((0,helpers/* buildName */.VD)("city", prefix), "");
        trigger([
            getName("stateCode"),
            getName("city")
        ]);
        var cleanedUpValue = (ref1 = (ref = value.replace(/[０-９]/g, function(s) {
            return String.fromCharCode(s.charCodeAt(0) - 65248);
        })) === null || ref === void 0 ? void 0 : ref.match(/\d/g)) === null || ref1 === void 0 ? void 0 : ref1.join("");
        if (cleanedUpValue && (cleanedUpValue === null || cleanedUpValue === void 0 ? void 0 : cleanedUpValue.length) > 2) {
            fetch(url + (cleanedUpValue === null || cleanedUpValue === void 0 ? void 0 : cleanedUpValue.substring(0, 3)) + ".js").then(function(response) {
                return response.text();
            }).then(function(result) {
                var matcher = result.match(/({".*"]})/);
                if (matcher) {
                    var json = JSON.parse(matcher[0]);
                    var arrayFilter = [];
                    Object.entries(json).forEach(function(param) {
                        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], value = _param[1];
                        if (key.startsWith(cleanedUpValue)) {
                            var codeInfo = value;
                            arrayFilter.push({
                                value: "".concat(key.slice(0, 3), "-").concat(key.slice(3), " ").concat(codeInfo[1]).concat(codeInfo[2]),
                                id: key,
                                codeInfo: codeInfo
                            });
                        }
                    });
                    if (arrayFilter.length === 1) onOptionSelect(arrayFilter[0]);
                    setOptions(arrayFilter);
                }
            }).catch(function(error) {
                // eslint-disable-next-line no-console
                console.error("Error while fetching yubinbango result for postalCode: ".concat(value), error);
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* InputCombobox */.kec, {
        defaultValue: defaultValue.current,
        name: field.name,
        label: field.label,
        id: field.id,
        dataTestId: field.dataTestId,
        placeholder: field.placeholder || "",
        maxLength: field.maxLength,
        required: required,
        ref: register({
            validate: function(value) {
                if (value && field.pattern && !new RegExp(field.pattern).test(value)) {
                    return field.patternError || t("invalidInput");
                }
            },
            required: required && getErrorMessageOrDefault(field.name.substring(field.name.indexOf(".") + 1), "requiredField")
        }),
        errorText: resolveInputError(),
        typeahead: true,
        onOptionSelect: onOptionSelect,
        filter: filter,
        crossOrigin: undefined
    }, field.key);
};
/* harmony default export */ var components_CustomFormYubinbangoAddressLookUp = (/*#__PURE__*/react.memo(CustomFormYubinbangoAddressLookUp));

// EXTERNAL MODULE: ./ui/components/CvvModal.tsx
var CvvModal = __webpack_require__(43116);
// EXTERNAL MODULE: ./utils/creditCardValidator.ts
var creditCardValidator = __webpack_require__(18047);
;// CONCATENATED MODULE: ./ui/forms/custom/components/CustomFormCvv.tsx









var MAX_CVV_LENGTH = 4;
var CustomFormCvv = function(param) {
    var field = param.field, _required = param.required, required = _required === void 0 ? false : _required, prefix = param.prefix, formResult = param.formResult;
    var ref = (0,react.useState)(false), showCVVModal = ref[0], setShowCVVModal = ref[1];
    var t = (0,useTranslations/* useTranslate */.qM)();
    var ref1 = (0,index_esm/* useFormContext */.Gc)(), watch = ref1.watch, register = ref1.register, setValue = ref1.setValue;
    var ref2 = useFormField(field), resolveInputError = ref2.resolveInputError, getErrorMessageOrDefault = ref2.getErrorMessageOrDefault;
    var cardNumber = watch("cardNumber");
    var cardNumberResult = (0,creditCardValidator/* validateCreditCard */.Y)(cardNumber !== null && cardNumber !== void 0 ? cardNumber : "");
    (0,react.useEffect)(function() {
        if (formResult === null || formResult === void 0 ? void 0 : formResult.error) {
            setValue((0,helpers/* buildName */.VD)("cvv", prefix), "");
        }
    }, [
        formResult === null || formResult === void 0 ? void 0 : formResult.error,
        prefix,
        setValue
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* InputText */.oHY, {
                id: field.id,
                label: field.label,
                dataTestId: field.dataTestId,
                name: field.name,
                placeholder: field.placeholder || "",
                errorText: resolveInputError(),
                required: required,
                autoComplete: "cc-csc",
                autoCorrect: "off",
                spellCheck: false,
                inputMode: "numeric",
                type: "tel",
                ref: register({
                    required: required && getErrorMessageOrDefault(field.name, "requiredField"),
                    pattern: {
                        message: getErrorMessageOrDefault(field.name, "validValue"),
                        value: new RegExp("^[0-9]{" + cardNumberResult.minCVV + "}$")
                    },
                    minLength: {
                        value: cardNumberResult.minCVV,
                        message: getErrorMessageOrDefault(field.name, "genericFieldMinLength", {
                            length: cardNumberResult.minCVV
                        })
                    },
                    maxLength: {
                        value: MAX_CVV_LENGTH,
                        message: t("genericFieldMaxLength", {
                            length: MAX_CVV_LENGTH
                        })
                    }
                }),
                minLength: cardNumberResult.minCVV,
                maxLength: MAX_CVV_LENGTH,
                inputSlot: function(param) {
                    var invert = param.invert, disabled = param.disabled;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Button */.zxk, {
                        label: t("whereToFindCVV"),
                        icon: "info",
                        mode: "icon",
                        variant: "ghost",
                        onClick: function() {
                            return setShowCVVModal(!showCVVModal);
                        },
                        role: "switch",
                        "aria-pressed": showCVVModal,
                        invert: invert,
                        dimmed: disabled
                    });
                },
                crossOrigin: undefined
            }, field.name),
            showCVVModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(CvvModal/* CvvModal */.X, {
                handleClose: function() {
                    return setShowCVVModal(false);
                }
            })
        ]
    });
};
/* harmony default export */ var components_CustomFormCvv = (/*#__PURE__*/(0,react.memo)(CustomFormCvv));

// EXTERNAL MODULE: ./utils/creditCardFormatter.ts
var creditCardFormatter = __webpack_require__(66641);
;// CONCATENATED MODULE: ./ui/forms/custom/components/CustomFormExpirationDate.tsx








var CustomFormExpirationDate = function(param) {
    var field = param.field, _required = param.required, required = _required === void 0 ? false : _required, prefix = param.prefix, formResult = param.formResult;
    var prevExpiryDate = (0,react.useRef)("");
    var ref = (0,index_esm/* useFormContext */.Gc)(), register = ref.register, watch = ref.watch, setValue = ref.setValue;
    var t = (0,useTranslations/* useTranslate */.qM)();
    var ref1 = useFormField(field), resolveInputError = ref1.resolveInputError, getErrorMessageOrDefault = ref1.getErrorMessageOrDefault;
    var expirationDate = watch("expirationDate");
    (0,react.useEffect)(function() {
        var dateTrimmed = "".concat(expirationDate).replace(/\D+/g, "").replace("/", "");
        if (!dateTrimmed || prevExpiryDate.current === expirationDate || prevExpiryDate.current.length > expirationDate.length) {
            prevExpiryDate.current = expirationDate;
            return;
        }
        var result = (0,creditCardFormatter/* formatExpirationDate */.N)(dateTrimmed);
        setValue("expirationDate", result);
        prevExpiryDate.current = result;
    }, [
        expirationDate,
        setValue
    ]);
    (0,react.useEffect)(function() {
        if (formResult === null || formResult === void 0 ? void 0 : formResult.error) {
            setValue((0,helpers/* buildName */.VD)("expirationDate", prefix), "");
        }
    }, [
        formResult === null || formResult === void 0 ? void 0 : formResult.error,
        prefix,
        setValue
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* InputText */.oHY, {
        id: "form-expiration-date",
        name: field.name,
        label: field.label,
        dataTestId: field.dataTestId,
        placeholder: field.placeholder || "",
        errorText: resolveInputError(),
        required: required,
        autoComplete: "cc-exp",
        autoCorrect: "off",
        spellCheck: false,
        inputMode: "numeric",
        maxLength: 5,
        type: "tel",
        ref: register({
            required: required && getErrorMessageOrDefault(field.name, "requiredField"),
            minLength: {
                value: 5,
                message: getErrorMessageOrDefault(field.name, "validDate")
            },
            pattern: {
                message: t("validDate"),
                value: /^((0[1-9])|(1[0-2]))\/(\d{2})$/
            },
            validate: function(value) {
                var month = Number.parseInt(value.split("/")[0]);
                var year = Number.parseInt(value.split("/")[1]);
                if (isNaN(month) || isNaN(year)) return t("validDate");
                var expiryTimeStamp = new Date(2000 + year, month, 0).getTime();
                return new Date().getTime() > expiryTimeStamp ? t("validDate") : undefined;
            }
        }),
        crossOrigin: undefined
    }, field.name);
};
/* harmony default export */ var components_CustomFormExpirationDate = (/*#__PURE__*/react.memo(CustomFormExpirationDate));

// EXTERNAL MODULE: ./ui/forms/PaymentMethods/CreditCard/CreditCardLogo.tsx
var CreditCardLogo = __webpack_require__(89765);
;// CONCATENATED MODULE: ./ui/forms/custom/components/CustomFormCardNumber.tsx









var CustomFormCardNumber = function(param) {
    var field = param.field, _required = param.required, required = _required === void 0 ? false : _required, prefix = param.prefix, formResult = param.formResult;
    var ref;
    var ref1 = (0,index_esm/* useFormContext */.Gc)(), watch = ref1.watch, register = ref1.register, setValue = ref1.setValue, trigger = ref1.trigger;
    var prevCardNumber = (0,react.useRef)("");
    var cardNumber = watch("cardNumber");
    var ref2 = useFormField(field), resolveInputError = ref2.resolveInputError, getErrorMessageOrDefault = ref2.getErrorMessageOrDefault;
    var cardNumberResult = (0,creditCardValidator/* validateCreditCard */.Y)(cardNumber !== null && cardNumber !== void 0 ? cardNumber : "");
    (0,react.useEffect)(function() {
        if (!cardNumber || prevCardNumber.current === cardNumber || prevCardNumber.current.length > cardNumber.length) {
            prevCardNumber.current = cardNumber;
            return;
        }
        setValue((0,helpers/* buildName */.VD)("cardNumber", prefix), (0,creditCardFormatter/* formatCreditCard */.y)(cardNumber, cardNumberResult.card_type));
        prevCardNumber.current = cardNumber;
    }, [
        cardNumber,
        cardNumberResult,
        prefix,
        setValue
    ]);
    (0,react.useEffect)(function() {
        if (formResult === null || formResult === void 0 ? void 0 : formResult.error) {
            setValue((0,helpers/* buildName */.VD)("cardNumber", prefix), "");
        }
    }, [
        formResult === null || formResult === void 0 ? void 0 : formResult.error,
        prefix,
        setValue
    ]);
    var creditCardType = typeof cardNumberResult.card_type === "string" ? cardNumberResult.card_type : cardNumberResult === null || cardNumberResult === void 0 ? void 0 : (ref = cardNumberResult.card_type) === null || ref === void 0 ? void 0 : ref.name;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* InputText */.oHY, {
        dataTestId: field.dataTestId,
        name: field.name,
        placeholder: field.placeholder || "",
        errorText: resolveInputError(),
        required: required,
        autoComplete: "cc-number",
        autoCorrect: "off",
        spellCheck: false,
        pattern: "\\d*",
        inputMode: "numeric",
        maxLength: 20,
        type: "tel",
        ref: register({
            required: required && getErrorMessageOrDefault(field.name, "requiredField"),
            validate: function(v) {
                var result = (0,creditCardValidator/* validateCreditCard */.Y)(v.replace(/ /g, ""));
                if (!result.valid) {
                    return getErrorMessageOrDefault(field.name, "validValue");
                }
                return true;
            }
        }),
        onChange: function() {
            trigger("cvv");
        },
        label: field.label,
        id: field.name,
        inputSlot: creditCardType ? function() {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CreditCardLogo/* CreditCardLogo */.x, {
                type: creditCardType
            });
        } : undefined,
        crossOrigin: undefined
    }, field.name);
};
/* harmony default export */ var components_CustomFormCardNumber = (/*#__PURE__*/react.memo(CustomFormCardNumber));

// EXTERNAL MODULE: ./ui/components/CloseButton.tsx
var CloseButton = __webpack_require__(6485);
// EXTERNAL MODULE: ./ui/components/Modal.tsx
var Modal = __webpack_require__(51377);
;// CONCATENATED MODULE: ./ui/forms/custom/components/CustomFormTextToModal.tsx





var CustomFormTextToModal = function(param) {
    var field = param.field;
    var t = (0,useTranslations/* useTranslate */.qM)();
    var ref = (0,react.useState)(false), openModal = ref[0], setOpenModal = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                onClick: function(e) {
                    e.preventDefault();
                    setOpenModal(true);
                },
                "data-test-id": "text-to-modal-link:".concat(field.name || ""),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "font-bold cursor-pointer",
                    children: t(field.text)
                })
            }),
            openModal && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
                variant: "dark",
                className: "w-full max-w-screen-lg",
                onClickOutside: function() {
                    setOpenModal(false);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseButton/* default */.Z, {
                        className: "absolute right-0 top-0 p-3",
                        onClick: function() {
                            return setOpenModal(false);
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: "border-b p-5 font-bold text-2xl mt-3 mb-2",
                        children: t(field.modalTitle)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "p-5",
                        children: t(field.modalDescription)
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_CustomFormTextToModal = (CustomFormTextToModal);

// EXTERNAL MODULE: ./utils/transformPlaces.ts
var transformPlaces = __webpack_require__(19259);
// EXTERNAL MODULE: ./ui/elements/AlertMessage.tsx
var AlertMessage = __webpack_require__(66224);
// EXTERNAL MODULE: ./hooks/useGoogleServices.tsx + 1 modules
var useGoogleServices = __webpack_require__(48548);
// EXTERNAL MODULE: ./utils/extractError.ts
var extractError = __webpack_require__(4360);
;// CONCATENATED MODULE: ./ui/forms/custom/components/CustomFormPincode.tsx

















var CustomFormPinCodeAddressLookUp = function(param) {
    var field = param.field, prefix = param.prefix, submit = param.submit;
    var ref, ref1, ref2;
    var t = (0,useTranslations/* useTranslate */.qM)();
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,useValidation/* useValidation */.V)(), 2), validate = ref3[0], dynamicValidation = ref3[1];
    var form = (0,index_esm/* useFormContext */.Gc)();
    var resolveInputError = useFormField(field).resolveInputError;
    // Use checkout form data hook for persistence
    var setPersistedFormField = useSafeCheckoutFormData(form).setPersistedFormField;
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,useValidation/* usePincodeValidation */.v)(), 2), pincodeQuery = ref4[0], validatePincode = ref4[1];
    var register = form.register, watch = form.watch;
    var isGoogleReversePostalCodeLookupEnabled = (0,useFeature/* useFeature */.S)("GOOGLE_REVERSE_POSTAL_CODE_LOOKUP");
    /** Sets the values for the fields given, then triggers validation on these
   * fields. Will not set or trigger on fields where the value is nullish.
   *
   * Note: Field order matters!
   */ var setValueAndTrigger = function(fields) {
        var affectedFields = [];
        Object.entries(fields).forEach(function(param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], value = _param[1];
            if (value) {
                form.setValue((0,helpers/* buildName */.VD)(key, prefix), value);
                affectedFields.push((0,helpers/* buildName */.VD)(key, prefix));
            }
        });
        form.trigger();
    };
    var errors = prefix && form.errors[prefix];
    var isPincodeEnabled = (0,useFeature/* useFeature */.S)("PINCODE_SERVICEABILITY");
    var expectedDeliveryDate = !(errors === null || errors === void 0 ? void 0 : (ref = errors.postalCode) === null || ref === void 0 ? void 0 : ref.message) && !pincodeQuery.fetching && ((ref1 = pincodeQuery.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.pincode) === null || ref2 === void 0 ? void 0 : ref2.expectedDate);
    var ref5 = (0,useSiteConfig/* useSiteConfig */.N)(), siteConfigCountryCode = ref5.countryCode;
    var ref6 = (0,useGoogleServices/* useGoogleServices */.o0)(), getPlaceDetails = ref6.getPlaceDetails, geocode = ref6.geocode;
    var currentCountryCode = siteConfigCountryCode.toUpperCase();
    var googleReversePostalCodeLookup = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(postalCode) {
            var address, placeDetails, ref, city, address1, stateCode, _tmp, e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            geocode(postalCode, currentCountryCode)
                        ];
                    case 1:
                        address = _state.sent();
                        return [
                            4,
                            getPlaceDetails(address.place_id)
                        ];
                    case 2:
                        placeDetails = _state.sent();
                        ref = (0,transformPlaces/* transformPlaces */.P)(placeDetails), city = ref.city, address1 = ref.address1, stateCode = ref.stateCode;
                        _tmp = {};
                        autofillCityAndState((_tmp.city = city, _tmp.address1 = address1, _tmp.stateCode = stateCode, _tmp));
                        return [
                            3,
                            4
                        ];
                    case 3:
                        e = _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function googleReversePostalCodeLookup(postalCode) {
            return _ref.apply(this, arguments);
        };
    }();
    var autofillAddressByPostalCode = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(postalCode) {
            var postalCodeError, ref, ref1, data, _tmp, _pincode, city, stateCode, _tmp1;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        postalCodeError = validate.postalCode(postalCode, currentCountryCode);
                        if (postalCodeError) return [
                            2
                        ];
                        if (!isPincodeEnabled) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            validatePincode(postalCode)
                        ];
                    case 1:
                        _tmp = {};
                        data = ((ref1 = _state.sent()) !== null && ref1 !== void 0 ? ref1 : _tmp).data;
                        _tmp1 = {};
                        if (data === null || data === void 0 ? void 0 : (ref = data.pincode) === null || ref === void 0 ? void 0 : ref.stateCode) {
                            _pincode = data.pincode, city = _pincode.city, stateCode = _pincode.stateCode;
                            autofillCityAndState((_tmp1.city = city, _tmp1.stateCode = stateCode, _tmp1));
                            return [
                                2
                            ];
                        }
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            googleReversePostalCodeLookup(postalCode)
                        ];
                    case 3:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function autofillAddressByPostalCode(postalCode) {
            return _ref.apply(this, arguments);
        };
    }();
    var autofillCityAndState = function(param) {
        var city = param.city, address1 = param.address1, stateCode = param.stateCode;
        // Set values in the form
        setValueAndTrigger({
            city: city,
            address1: address1,
            stateCode: stateCode
        });
        // Persist city if provided
        if (city) {
            setPersistedFormField((0,helpers/* buildName */.VD)("city", prefix), city);
        }
        // Persist address1 if provided
        if (address1) {
            setPersistedFormField((0,helpers/* buildName */.VD)("address1", prefix), address1);
        }
        // Persist stateCode if provided
        if (stateCode) {
            setPersistedFormField((0,helpers/* buildName */.VD)("stateCode", prefix), stateCode);
        }
    };
    var watchedStateCode = watch((0,helpers/* buildName */.VD)("stateCode", prefix));
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "space-y-2",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* InputText */.oHY, {
                defaultValue: watch(field.name),
                name: field.name,
                label: field.label,
                id: field.id,
                dataTestId: field.dataTestId,
                placeholder: field.placeholder || "",
                maxLength: field.maxLength,
                required: true,
                onChange: function() {
                    var _ref = (0,_async_to_generator/* default */.Z)(function(e) {
                        var currentPincode;
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    currentPincode = e.target.value;
                                    setPersistedFormField(field.name, currentPincode);
                                    if (!isGoogleReversePostalCodeLookupEnabled) return [
                                        3,
                                        2
                                    ];
                                    return [
                                        4,
                                        autofillAddressByPostalCode(currentPincode)
                                    ];
                                case 1:
                                    _state.sent();
                                    return [
                                        3,
                                        3
                                    ];
                                case 2:
                                    watchedStateCode && form.trigger((0,helpers/* buildName */.VD)("stateCode", prefix));
                                    _state.label = 3;
                                case 3:
                                    if (!(errors === null || errors === void 0 ? void 0 : errors.postalCode) && submit) {
                                        submit();
                                    }
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function(e) {
                        return _ref.apply(this, arguments);
                    };
                }(),
                ref: register({
                    required: t("requiredField"),
                    validate: function() {
                        var _ref = (0,_async_to_generator/* default */.Z)(function(value) {
                            var errorMessage, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, v, res, error;
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        if (field.validations) {
                                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                            try {
                                                for(_iterator = field.validations[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                                    v = _step.value;
                                                    if (typeof v === "string") {
                                                        errorMessage = validate[v](value);
                                                    } else {
                                                        errorMessage = dynamicValidation(value, form, v);
                                                    }
                                                    if (errorMessage) break;
                                                }
                                            } catch (err) {
                                                _didIteratorError = true;
                                                _iteratorError = err;
                                            } finally{
                                                try {
                                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                        _iterator.return();
                                                    }
                                                } finally{
                                                    if (_didIteratorError) {
                                                        throw _iteratorError;
                                                    }
                                                }
                                            }
                                        }
                                        if (errorMessage) return [
                                            2,
                                            errorMessage
                                        ];
                                        return [
                                            4,
                                            validatePincode(value)
                                        ];
                                    case 1:
                                        res = _state.sent();
                                        if (!res) return [
                                            2
                                        ];
                                        error = (0,extractError/* extractError */.d)(res);
                                        if (error) return [
                                            2,
                                            error
                                        ];
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                        return function(value) {
                            return _ref.apply(this, arguments);
                        };
                    }(),
                    maxLength: field.maxLength && {
                        value: field.maxLength,
                        message: t("genericFieldMaxLength", {
                            length: field.maxLength
                        })
                    },
                    minLength: field.minLength && {
                        value: field.minLength,
                        message: t("genericFieldMinLength", {
                            length: field.minLength
                        })
                    }
                }),
                errorText: resolveInputError(),
                crossOrigin: undefined
            }, field.key),
            prefix === "shippingAddress" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    pincodeQuery.fetching && /*#__PURE__*/ (0,jsx_runtime.jsx)(AlertMessage/* AlertMessage */.g, {
                        icon: "truck",
                        dataTestId: "pincode-query-fetching",
                        type: "info",
                        children: t("loadingDotDotDot")
                    }),
                    expectedDeliveryDate && /*#__PURE__*/ (0,jsx_runtime.jsx)(AlertMessage/* AlertMessage */.g, {
                        icon: "truck",
                        dataTestId: "expected-delivery-date",
                        type: "success",
                        children: expectedDeliveryDate
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var CustomFormPincode = (/*#__PURE__*/react.memo(CustomFormPinCodeAddressLookUp));

;// CONCATENATED MODULE: ./ui/forms/custom/components/CustomFormSmsOptIn.tsx







var SmsOptInTermsAndConditions = function(param) {
    var ctaLabel = param.ctaLabel;
    var t = (0,useTranslations/* useTranslate */.qM)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Text */.xvT, {
        size: "xs",
        children: t("smsOptInTermsAndConditions", {
            ctaLabel: ctaLabel ? t(ctaLabel) : t("submit")
        })
    });
};
var CustomFormSmsOptIn = function(param) {
    var field = param.field, _phoneNumberFieldName = param.phoneNumberFieldName, phoneNumberFieldName = _phoneNumberFieldName === void 0 ? "".concat(field.name, "PhoneNumber") : _phoneNumberFieldName, ctaLabel = param.ctaLabel;
    var ref;
    var t = (0,useTranslations/* useTranslate */.qM)();
    var ref1 = (0,index_esm/* useFormContext */.Gc)(), register = ref1.register, watch = ref1.watch, errors = ref1.errors;
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useValidation/* useValidation */.V)(), 1), validate = ref2[0];
    var smsOptInValue = watch("smsOptIn");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Stack */.Kqy, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* InputCheckbox */.o2J, {
                name: field.name,
                id: field.id,
                dataTestId: field.dataTestId,
                ref: register(),
                children: t("smsOptInLabel")
            }, "".concat(field.key, "_checkbox")),
            smsOptInValue && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* InputText */.oHY, {
                        type: "tel",
                        name: phoneNumberFieldName,
                        id: "".concat(field.id, "-phoneNumber"),
                        dataTestId: "".concat(field.dataTestId, "-phone-number"),
                        label: t("smsOptInPhoneNumberLabel"),
                        placeholder: t("smsOptInPhoneNumberPlaceholder"),
                        required: true,
                        errorText: (ref = errors[phoneNumberFieldName]) === null || ref === void 0 ? void 0 : ref.message,
                        ref: register({
                            required: true,
                            validate: validate.phoneNumber
                        }),
                        crossOrigin: undefined
                    }, "".concat(field.key, "_phoneNumber")),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SmsOptInTermsAndConditions, {
                        ctaLabel: ctaLabel
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_CustomFormSmsOptIn = (/*#__PURE__*/(0,react.memo)(CustomFormSmsOptIn));

;// CONCATENATED MODULE: ./ui/forms/custom/components/CustomFormField.tsx
























function useTriggerDependents(fieldPath, fieldConfig, prefix) {
    var ref = (0,index_esm/* useFormContext */.Gc)(), watch = ref.watch, trigger = ref.trigger;
    var fieldValue = watch(fieldPath);
    (0,react.useEffect)(function() {
        var ref;
        var fieldNames = (ref = fieldConfig.dependentFields) === null || ref === void 0 ? void 0 : ref.map(function(dependentField) {
            return (0,helpers/* buildName */.VD)(dependentField, prefix);
        });
        if (fieldNames) {
            trigger(fieldNames);
        }
    }, [
        fieldValue,
        fieldConfig.dependentFields,
        trigger,
        prefix
    ]);
}
var CustomFormField = function(param) {
    var fieldConfig = param.fieldConfig, result = param.result, prefix = param.prefix, submit = param.submit;
    var countryCode = (0,useSiteConfig/* useSiteConfig */.N)().countryCode;
    var fieldProps = (0,useSiteConfig/* useSiteConfig */.N)().fieldProps;
    var t = (0,useTranslations/* useTranslate */.qM)();
    var field = (0,react.useMemo)(function() {
        return (0,helpers/* resolveField */.z8)(fieldConfig, fieldProps, t, prefix);
    }, [
        fieldConfig,
        fieldProps,
        t,
        prefix
    ]);
    useTriggerDependents(field.name, fieldConfig, prefix);
    switch(field.fieldType){
        case "input":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CustomFormInput, {
                field: field,
                required: fieldConfig.required,
                submit: submit
            });
        case "password":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CustomFormPassword, {
                field: field
            });
        case "checkbox":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CustomFormCheckBox, {
                field: field,
                required: fieldConfig.required
            });
        case "birthday":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CustomFormBirthday, {
                field: field,
                required: fieldConfig.required
            });
        case "button":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CustomFormButton, {
                button: field,
                result: result
            });
        case "link":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CustomFormLink, {
                field: field
            });
        case "blank":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
        case "input-radio":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CustomFormRadio, {
                field: field
            });
        case "dropdown":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CustomFormDropdown, {
                dropdownField: field,
                required: fieldConfig.required,
                prefix: prefix
            });
        case "google-address-look-up":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CustomFormGoogleAddressLookUp, {
                field: field,
                country: countryCode,
                prefix: prefix,
                required: fieldConfig.required,
                submit: submit
            });
        case "terms-and-conditions":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(TermsAndConditions/* default */.Z, {
                page: field.page
            });
        case "text-only":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomFormTextOnly, {
                field: field
            });
        case "yubinbango-address-look-up":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CustomFormYubinbangoAddressLookUp, {
                field: field,
                prefix: prefix,
                required: fieldConfig.required
            });
        case "cvv":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CustomFormCvv, {
                field: field,
                prefix: prefix,
                required: fieldConfig.required,
                formResult: result
            });
        case "expiration-date":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CustomFormExpirationDate, {
                field: field,
                required: fieldConfig.required,
                formResult: result
            });
        case "card-number":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CustomFormCardNumber, {
                field: field,
                prefix: prefix,
                required: fieldConfig.required,
                formResult: result
            });
        case "pincode":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomFormPincode, {
                country: countryCode,
                field: field,
                prefix: prefix,
                submit: submit
            });
        case "text-to-modal":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CustomFormTextToModal, {
                field: field
            });
        case "sms-opt-in":
            var ref, ref1;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CustomFormSmsOptIn, {
                field: field,
                phoneNumberFieldName: (ref = fieldConfig.args) === null || ref === void 0 ? void 0 : ref.phoneNumberFieldName,
                ctaLabel: (ref1 = fieldConfig.args) === null || ref1 === void 0 ? void 0 : ref1.ctaLabel
            });
        default:
            // Should be unreachable
            // @ts-expect-error -- Make sure we aren't missing any 'case' statements:
            // eslint-disable-next-line no-console
            console.error("No form field found for ".concat(field.fieldType));
            return null;
    }
};
/* harmony default export */ var components_CustomFormField = (/*#__PURE__*/react.memo(CustomFormField));

;// CONCATENATED MODULE: ./ui/forms/custom/CustomForm.tsx


function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        & > *:nth-child(",
        ") {\n          @apply col-auto;\n        }\n      "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var layout = (0,style/* style */.oB)({
    base: "grid grid-cols-2 gap-4 children:(only-child:col-span-2 sm:col-auto col-span-2)",
    variants: {
        actionRow: {
            true: "pt-3"
        }
    }
});
var FormRowContainer = function(param) {
    var row = param.row, children = param.children;
    var isActionsRow = row.filter(function(field) {
        return ![
            "button",
            "link"
        ].includes(field.type);
    }).length === 0;
    var fieldCollapseOverrides = row.map(function(field, index) {
        return field.preventStack && (0,style/* css */.iv)(_templateObject(), index + 1);
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: style.tw.apply(void 0, [
            layout({
                actionRow: isActionsRow
            })
        ].concat((0,_to_consumable_array/* default */.Z)(fieldCollapseOverrides))),
        children: children
    });
};
var CustomForm = function(param) {
    var result = param.result, form = param.form, prefix = param.prefix, formFields = param.config, disableResultError = param.disableResultError, isNested = param.isNested, onSubmit = param.onSubmit, submit = param.submit, dataTestId = param.dataTestId, title = param.title, gapY = param.gapY, triggerValidation = param.triggerValidation;
    (0,react.useEffect)(function() {
        if (triggerValidation) form.trigger();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var errorMessage = result && (0,extractError/* extractError */.d)(result);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CustomFormWrapper, {
        dataTestId: dataTestId,
        isNested: isNested,
        onSubmit: onSubmit,
        form: form,
        gapY: gapY,
        children: [
            title && /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: "text-xl",
                children: title
            }),
            !disableResultError && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* LiveRegion */.LE2, {
                type: "assertive",
                children: errorMessage && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Alert */.bZj, {
                    variant: "error",
                    content: errorMessage,
                    dataTestId: "".concat(dataTestId, "-error")
                })
            }),
            formFields && formFields.map(function(row, i) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(FormRowContainer, {
                    row: row,
                    children: row.map(function(field) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CustomFormField, {
                            fieldConfig: field,
                            result: result,
                            prefix: prefix,
                            submit: submit
                        }, field.name);
                    })
                }, i);
            })
        ]
    });
};


/***/ }),

/***/ 21541:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$s": function() { return /* binding */ getSelectLabel; },
/* harmony export */   "SP": function() { return /* binding */ mandatoryFieldsNames; },
/* harmony export */   "VD": function() { return /* binding */ buildName; },
/* harmony export */   "VP": function() { return /* binding */ hasAllShippingFields; },
/* harmony export */   "cE": function() { return /* binding */ translateSelectOptions; },
/* harmony export */   "dx": function() { return /* binding */ checkoutAddressHelpers; },
/* harmony export */   "z8": function() { return /* binding */ resolveField; }
/* harmony export */ });
/* unused harmony exports translateInputRadioValues, buildPlaceholder, buildPatternError, buildLabel, buildId, buildDataTestId, setValuesOnStateCodeChange, validateStateCode, buildBaseInputProps, getFieldByType */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85034);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70169);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3204);
/* harmony import */ var randomstring__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9889);
/* harmony import */ var utils_toKebabCase__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36662);





var translateSelectOptions = function(options, t) {
    return options.map(function(option) {
        return {
            label: t(option.label) || option.label,
            value: option.value
        };
    });
};
var translateInputRadioValues = function(items, t) {
    return items.map(function(item) {
        return {
            value: item,
            label: t(item) || item
        };
    });
};
var getSelectLabel = function(id, options) {
    if (!options || !id) return "";
    var option = options.find(function(option) {
        return option.value === id;
    });
    return (option === null || option === void 0 ? void 0 : option.label) || "";
};
var buildName = function(name, prefix) {
    return prefix ? "".concat(prefix, ".").concat(name) : name;
};
var buildPlaceholder = function(name) {
    return "".concat(name, "Placeholder");
};
var buildPatternError = function(name) {
    return "".concat(name, "PatternError");
};
var buildLabel = function(name) {
    return "".concat(name, "Label");
};
var buildId = function(name, prefix) {
    var formattedName = (0,utils_toKebabCase__WEBPACK_IMPORTED_MODULE_1__/* .toKebabCase */ .m)(name);
    if (!prefix) {
        // Add an id prefix in order to avoid duplicate field ids
        return "".concat(randomstring__WEBPACK_IMPORTED_MODULE_0__.generate(8), "-").concat(name);
    } else {
        var formattedPrefix = (0,utils_toKebabCase__WEBPACK_IMPORTED_MODULE_1__/* .toKebabCase */ .m)(prefix);
        return "".concat(formattedPrefix, "-").concat(formattedName);
    }
};
var buildDataTestId = function(name) {
    return (0,utils_toKebabCase__WEBPACK_IMPORTED_MODULE_1__/* .toKebabCase */ .m)(name);
};
var setValuesOnStateCodeChange = function(addressForm, prefix) {
    if (!prefix) return;
    addressForm.setValue(buildName("stateCode", prefix), undefined);
    addressForm.clearErrors([
        buildName("stateCode", prefix)
    ]);
    addressForm.trigger(buildName("postalCode", prefix));
};
var validateStateCode = function(addressForm, prefix) {
    return addressForm.trigger(buildName("stateCode", prefix));
};
var checkoutAddressHelpers = {
    setValuesOnStateCodeChange: setValuesOnStateCodeChange,
    validateStateCode: validateStateCode
};
var buildBaseInputProps = function(name, prefix, t) {
    return {
        key: buildName(name, prefix),
        name: buildName(name, prefix),
        id: buildId(name, prefix),
        dataTestId: buildDataTestId(name),
        placeholder: t(buildPlaceholder(name)),
        label: t(buildLabel(name)),
        patternError: t(buildPatternError(name))
    };
};
var getFieldByType = function(config, t, prefix) {
    var sharedProps = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        fieldType: config.type
    }, buildBaseInputProps(config.name, prefix, t));
    switch(config.type){
        case "terms-and-conditions":
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, sharedProps), {
                page: config.name
            });
        case "button":
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, sharedProps), {
                type: config.buttonType
            });
        case "link":
            return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, sharedProps);
        case "input-radio":
            return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, sharedProps);
        case "checkbox":
            return sharedProps;
        case "dropdown":
            {
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, sharedProps), {
                    options: []
                });
            }
        case "birthday":
            {
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, sharedProps), {
                    hideSupportText: config.hideSupportText
                });
            }
        case "password":
        case "google-address-look-up":
        case "input":
        default:
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, sharedProps), {
                inputType: config.inputType,
                maxLength: 255
            });
    }
};
var resolveField = function(fieldConfig, fieldProps, t, prefix) {
    var field = getFieldByType(fieldConfig, t, prefix);
    var fieldProp = fieldProps[fieldConfig.name];
    if (fieldProp) {
        if (fieldConfig.type === "dropdown") {
            var options = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(translateSelectOptions(fieldProps[fieldConfig.name].options || [], t));
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, field, fieldProp), {
                options: options
            });
        }
        if (fieldConfig.type === "input-radio") {
            var values = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(translateInputRadioValues(fieldProps[fieldConfig.name].values || [], t));
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, field, fieldProp), {
                values: values
            });
        }
        return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, field, fieldProp);
    }
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, field);
};
var hasAllShippingFields = function(shippingAddress, mandatoryFields, fields) {
    var requiredFields = mandatoryFields && mandatoryFields.length ? mandatoryFields : [
        "firstName",
        "lastName",
        "address1",
        "postalCode",
        "stateCode",
        "countryCode",
        "phone", 
    ];
    return shippingAddress && requiredFields.every(function(field) {
        var fieldProp = fields === null || fields === void 0 ? void 0 : fields[field];
        var regExpValidation = fieldProp && "pattern" in fieldProp ? fieldProp.pattern : undefined;
        return shippingAddress[field] && (!regExpValidation || new RegExp(regExpValidation).test(shippingAddress[field]));
    });
};
var mandatoryFieldsNames = function(form) {
    var names = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = form[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var fields = _step.value;
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = fields[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var field = _step1.value;
                    if (field.name && field.required) {
                        names.push(field.name);
                    }
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return names;
};


/***/ }),

/***/ 74968:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ry": function() { return /* binding */ toAnalyticsCart; },
/* harmony export */   "cp": function() { return /* binding */ getCombinedProductsValue; },
/* harmony export */   "kA": function() { return /* binding */ transformCartProductToAnalyticsCartProduct; },
/* harmony export */   "kF": function() { return /* binding */ sessionCartTotalEvent; },
/* harmony export */   "xH": function() { return /* binding */ viewCartAnalyticsEvent; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85034);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70169);
/* harmony import */ var utils_isNotNullish__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50597);
/* harmony import */ var utils_products__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1032);
/* harmony import */ var utils_ga4Items__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(54093);
/* harmony import */ var _analytics_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67977);
/* harmony import */ var _analytics_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85680);
/* harmony import */ var _analytics_pdp__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46659);








var sessionCartTotalEvent = function(cartTotal) {
    return (0,_analytics_utils__WEBPACK_IMPORTED_MODULE_1__/* .event */ .B)(_analytics_types__WEBPACK_IMPORTED_MODULE_2__/* .AnalyticsEvents.GA4_SessionCartTotal */ ._q.GA4_SessionCartTotal, {
        event_name: _analytics_types__WEBPACK_IMPORTED_MODULE_2__/* .AnalyticsEvents.CART */ ._q.CART,
        cart: {
            cart_total: cartTotal || 0
        }
    });
};
var ref, ref1, ref2;
var toAnalyticsCart = function(data) {
    var ref3;
    return {
        total: (ref = data === null || data === void 0 ? void 0 : data.estimatedTotal) !== null && ref !== void 0 ? ref : 0,
        items: (ref1 = data === null || data === void 0 ? void 0 : (ref3 = data.products) === null || ref3 === void 0 ? void 0 : ref3.map(function(x) {
            return transformCartProductToAnalyticsCartProduct(x);
        }).filter(utils_isNotNullish__WEBPACK_IMPORTED_MODULE_4__/* .isNotNullish */ .l)) !== null && ref1 !== void 0 ? ref1 : [],
        items_qty: (ref2 = ((data === null || data === void 0 ? void 0 : data.products) || []).reduce(function(acc, item) {
            return acc + (item.__typename === "ProductCartItem" ? item.quantity : 1);
        }, 0)) !== null && ref2 !== void 0 ? ref2 : 0
    };
};
var transformCartProductToAnalyticsCartProduct = function(item) {
    var includeExtraAnalyticsDimensions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    if (item.__typename === "ProductCartItem") {
        var coupon = "";
        if (item.adjustments) {
            coupon = item.adjustments.map(function(a) {
                return "".concat(a.couponCode, "|").concat(a.promotionId);
            }).join(", ");
        }
        var _ean, _brand, _primaryCategoryId;
        var analyticsCartProduct = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
            coupon: coupon,
            id: item.product.styleNumber,
            variant: item.product.id,
            ean: (_ean = item.product.ean) !== null && _ean !== void 0 ? _ean : "",
            name: item.product.name,
            price: item.inCartPrice,
            brand: (_brand = item.product.brand) !== null && _brand !== void 0 ? _brand : "PUMA",
            category: (_primaryCategoryId = item.product.primaryCategoryId) !== null && _primaryCategoryId !== void 0 ? _primaryCategoryId : "",
            quantity: item.quantity,
            full_price: item.product.price,
            unitDiscount: item.product.salePrice ? parseFloat((item.product.price - item.product.salePrice).toFixed(2)) : undefined
        }, includeExtraAnalyticsDimensions && (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, (0,_analytics_utils__WEBPACK_IMPORTED_MODULE_1__/* .getAnalyticsDimensions */ .NM)(item.product))), {
            imageUrl: item.product.imageUrl
        });
        if ("taxRate" in item && (0,utils_isNotNullish__WEBPACK_IMPORTED_MODULE_4__/* .isNotNullish */ .l)(item.taxRate)) {
            analyticsCartProduct.taxRate = parseFloat(Number(item.taxRate).toFixed(2));
        }
        return analyticsCartProduct;
    }
    if (item.__typename === "GiftCardCartItem") {
        return {
            id: "000001_01",
            variant: "",
            ean: "",
            name: utils_products__WEBPACK_IMPORTED_MODULE_0__/* .DIGITAL_GIFT_CARD_NAME */ .Og,
            price: item.amount,
            brand: "PUMA",
            category: "",
            quantity: 1,
            recipient_email: item.recipientEmail,
            recipient_name: item.recipientName,
            imageUrl: item.imageUrl
        };
    }
};
var getCombinedProductsValue = function(products) {
    var _quantityInCart;
    return products.reduce(function(acc, product) {
        return acc + product.inCartPrice * ((_quantityInCart = product.quantityInCart) !== null && _quantityInCart !== void 0 ? _quantityInCart : product.quantity);
    }, 0);
};
var viewCartAnalyticsEvent = function(param) {
    var currency = param.currency, products = param.products, couponItems = param.couponItems;
    var value = getCombinedProductsValue(products);
    var items = products.map(function(p) {
        var ref, ref1, ref2, ref3;
        var ga4Item = (0,utils_ga4Items__WEBPACK_IMPORTED_MODULE_7__/* .getGa4Item */ .Vr)((ref = p.product) === null || ref === void 0 ? void 0 : ref.styleNumber);
        return (0,_analytics_pdp__WEBPACK_IMPORTED_MODULE_3__/* .transformListProductToAnalyticsItem */ .pD)({
            product: p.product,
            currency: currency,
            quantity: p.quantity,
            categories: {
                item_category: (ref1 = p.product) === null || ref1 === void 0 ? void 0 : ref1.primaryCategoryId
            },
            size: (ref2 = p.product) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.size) === null || ref3 === void 0 ? void 0 : ref3.value,
            adjustments: p.adjustments,
            itemListId: ga4Item === null || ga4Item === void 0 ? void 0 : ga4Item.lid,
            itemListName: ga4Item === null || ga4Item === void 0 ? void 0 : ga4Item.lname,
            index: ga4Item === null || ga4Item === void 0 ? void 0 : ga4Item.idx,
            creativeName: ga4Item === null || ga4Item === void 0 ? void 0 : ga4Item.cname,
            creativeSlot: ga4Item === null || ga4Item === void 0 ? void 0 : ga4Item.cslot,
            promotionId: ga4Item === null || ga4Item === void 0 ? void 0 : ga4Item.pid,
            promotionName: ga4Item === null || ga4Item === void 0 ? void 0 : ga4Item.pname
        });
    });
    (0,_analytics_utils__WEBPACK_IMPORTED_MODULE_1__/* .event */ .B)(_analytics_types__WEBPACK_IMPORTED_MODULE_2__/* .AnalyticsEvents.GA4EC_ViewCart */ ._q.GA4EC_ViewCart, {
        event_name: _analytics_types__WEBPACK_IMPORTED_MODULE_2__/* .AnalyticsEvents.VIEW_CART */ ._q.VIEW_CART,
        ecommerce: {
            currency: currency,
            value: Number(value.toFixed(2)),
            coupon: (couponItems === null || couponItems === void 0 ? void 0 : couponItems.length) ? couponItems.map(function(c) {
                return c.code;
            }).join("|") : undefined,
            items: items
        }
    });
};


/***/ }),

/***/ 31285:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cl": function() { return /* binding */ convertToGA4PaymentMethod; },
/* harmony export */   "UM": function() { return /* binding */ paymentClickEvent; },
/* harmony export */   "ds": function() { return /* binding */ addPaymentInfoAnalyticsEvent; },
/* harmony export */   "pd": function() { return /* binding */ formErrorEvent; },
/* harmony export */   "sm": function() { return /* binding */ addShippingInfoEvent; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(17599);
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79758);
/* harmony import */ var utils_ga4Items__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(54093);
/* harmony import */ var _analytics_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67977);
/* harmony import */ var _analytics_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85680);
/* harmony import */ var _analytics_cart__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74968);
/* harmony import */ var _analytics_pdp__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(46659);







var paymentClickEvent = function() {
    (0,_analytics_utils__WEBPACK_IMPORTED_MODULE_1__/* .event */ .B)(_analytics_types__WEBPACK_IMPORTED_MODULE_2__/* .AnalyticsEvents.GA4_CustomEvent */ ._q.GA4_CustomEvent, {
        event_name: _analytics_types__WEBPACK_IMPORTED_MODULE_2__/* .AnalyticsEvents.PAYMENT_CLICK */ ._q.PAYMENT_CLICK,
        event_params: {
            user_action: "3rd party payment"
        }
    });
};
var convertToGA4PaymentMethod = function(paymentMethod) {
    var _obj;
    var paymentMethodMapping = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .PaymentMethod.AFTERPAY */ .XL.AFTERPAY, utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .PaymentMethodsGA4Analytics.AFTERPAY */ .QJ.AFTERPAY), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .PaymentMethod.ALIPAY */ .XL.ALIPAY, utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .PaymentMethodsGA4Analytics.ALIPAY */ .QJ.ALIPAY), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .PaymentMethod.AMAZON_PAY */ .XL.AMAZON_PAY, utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .PaymentMethodsGA4Analytics.AMAZON_PAY */ .QJ.AMAZON_PAY), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .PaymentMethod.AMBASSADOR_CARD */ .XL.AMBASSADOR_CARD, utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .PaymentMethodsGA4Analytics.AMBASSADOR_CARD */ .QJ.AMBASSADOR_CARD), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .PaymentMethod.APPLE_PAY */ .XL.APPLE_PAY, utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .PaymentMethodsGA4Analytics.APPLE_PAY */ .QJ.APPLE_PAY), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .PaymentMethod.COD */ .XL.COD, utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .PaymentMethodsGA4Analytics.CASH_ON_DELIVERY */ .QJ.CASH_ON_DELIVERY), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .PaymentMethod.CREDIT_CARD */ .XL.CREDIT_CARD, utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .PaymentMethodsGA4Analytics.CREDIT_CARD */ .QJ.CREDIT_CARD), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .PaymentMethod.GIFT_CARD */ .XL.GIFT_CARD, utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .PaymentMethodsGA4Analytics.GIFT_CARD */ .QJ.GIFT_CARD), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .PaymentMethod.GOOGLE_PAY */ .XL.GOOGLE_PAY, utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .PaymentMethodsGA4Analytics.GOOGLE_PAY */ .QJ.GOOGLE_PAY), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .PaymentMethod.KLARNA */ .XL.KLARNA, utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .PaymentMethodsGA4Analytics.KLARNA */ .QJ.KLARNA), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .PaymentMethod.ONLINE_BANKING_IN */ .XL.ONLINE_BANKING_IN, utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .PaymentMethodsGA4Analytics.NET_BANKING */ .QJ.NET_BANKING), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .PaymentMethod.PAY_PAY */ .XL.PAY_PAY, utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .PaymentMethodsGA4Analytics.PAY_PAY */ .QJ.PAY_PAY), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .PaymentMethod.PAYPAL */ .XL.PAYPAL, utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .PaymentMethodsGA4Analytics.PAYPAL */ .QJ.PAYPAL), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .PaymentMethod.UPI */ .XL.UPI, utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .PaymentMethodsGA4Analytics.UPI */ .QJ.UPI), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .PaymentMethod.WALLET */ .XL.WALLET, utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .PaymentMethodsGA4Analytics.WALLETS */ .QJ.WALLETS), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .PaymentMethod.ZIP_PAY */ .XL.ZIP_PAY, utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .PaymentMethodsGA4Analytics.ZIP_PAY */ .QJ.ZIP_PAY), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .PaymentMethod.WECHAT_PAY */ .XL.WECHAT_PAY, utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .PaymentMethodsGA4Analytics.WECHAT_PAY */ .QJ.WECHAT_PAY), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .PaymentMethod.ADYEN_COMPONENT */ .XL.ADYEN_COMPONENT, utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .PaymentMethodsGA4Analytics.ADYEN_COMPONENT */ .QJ.ADYEN_COMPONENT), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .PaymentMethod.ADYEN_PAYPAL */ .XL.ADYEN_PAYPAL, utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .PaymentMethodsGA4Analytics.PAYPAL */ .QJ.PAYPAL), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .PaymentMethod.KLARNA_ACCOUNT */ .XL.KLARNA_ACCOUNT, utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .PaymentMethodsGA4Analytics.KLARNA_ACCOUNT */ .QJ.KLARNA_ACCOUNT), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .PaymentMethod.KLARNA_PAYMENTS */ .XL.KLARNA_PAYMENTS, utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .PaymentMethodsGA4Analytics.KLARNA_PAYMENTS */ .QJ.KLARNA_PAYMENTS), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .PaymentMethod.NET_BANKING_DEPRECATED */ .XL.NET_BANKING_DEPRECATED, utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .PaymentMethodsGA4Analytics.NET_BANKING */ .QJ.NET_BANKING), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .PaymentMethod.PAYTM */ .XL.PAYTM, utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .PaymentMethodsGA4Analytics.PAYTM */ .QJ.PAYTM), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .PaymentMethod.SCHEME */ .XL.SCHEME, utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .PaymentMethodsGA4Analytics.CREDIT_CARD */ .QJ.CREDIT_CARD), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .PaymentMethod.STORE_CREDIT */ .XL.STORE_CREDIT, utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .PaymentMethodsGA4Analytics.STORE_CREDIT */ .QJ.STORE_CREDIT), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .PaymentMethod.UPI_COLLECT */ .XL.UPI_COLLECT, utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .PaymentMethodsGA4Analytics.UPI_COLLECT */ .QJ.UPI_COLLECT), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .PaymentMethod.AFTERPAY_TOUCH */ .XL.AFTERPAY_TOUCH, utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .PaymentMethodsGA4Analytics.AFTERPAY_TOUCH */ .QJ.AFTERPAY_TOUCH), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .PaymentMethod.RAZORPAY */ .XL.RAZORPAY, utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .PaymentMethodsGA4Analytics.RAZORPAY */ .QJ.RAZORPAY), _obj);
    return paymentMethodMapping[paymentMethod] || paymentMethod && paymentMethod.split("_").join(" ").toLowerCase();
};
var addPaymentInfoAnalyticsEvent = function(param) {
    var currency = param.currency, products = param.products, couponItems = param.couponItems, paymentInstruments = param.paymentInstruments, paymentMethodGA4 = param.paymentMethodGA4;
    var value = (0,_analytics_cart__WEBPACK_IMPORTED_MODULE_3__/* .getCombinedProductsValue */ .cp)(products);
    var items = products.map(function(product) {
        var ref, ref1, ref2, ref3;
        var ga4Item = (0,utils_ga4Items__WEBPACK_IMPORTED_MODULE_6__/* .getGa4Item */ .Vr)((ref = product.product) === null || ref === void 0 ? void 0 : ref.styleNumber);
        return (0,_analytics_pdp__WEBPACK_IMPORTED_MODULE_4__/* .transformListProductToAnalyticsItem */ .pD)({
            product: product.product,
            currency: currency,
            quantity: product.quantity,
            categories: {
                item_category: (ref1 = product.product) === null || ref1 === void 0 ? void 0 : ref1.primaryCategoryId
            },
            size: (ref2 = product.product) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.size) === null || ref3 === void 0 ? void 0 : ref3.label,
            adjustments: product.adjustments,
            itemListId: ga4Item === null || ga4Item === void 0 ? void 0 : ga4Item.lid,
            itemListName: ga4Item === null || ga4Item === void 0 ? void 0 : ga4Item.lname,
            index: ga4Item === null || ga4Item === void 0 ? void 0 : ga4Item.idx,
            creativeName: ga4Item === null || ga4Item === void 0 ? void 0 : ga4Item.cname,
            creativeSlot: ga4Item === null || ga4Item === void 0 ? void 0 : ga4Item.cslot,
            promotionId: ga4Item === null || ga4Item === void 0 ? void 0 : ga4Item.pid,
            promotionName: ga4Item === null || ga4Item === void 0 ? void 0 : ga4Item.pname
        });
    });
    var paymentType = (paymentInstruments === null || paymentInstruments === void 0 ? void 0 : paymentInstruments.length) ? paymentInstruments.map(function(c) {
        return convertToGA4PaymentMethod(c.type);
    }).join("|") : paymentMethodGA4;
    (0,_analytics_utils__WEBPACK_IMPORTED_MODULE_1__/* .event */ .B)(_analytics_types__WEBPACK_IMPORTED_MODULE_2__/* .AnalyticsEvents.GA4EC_AddPaymentInfo */ ._q.GA4EC_AddPaymentInfo, {
        event_name: _analytics_types__WEBPACK_IMPORTED_MODULE_2__/* .AnalyticsEvents.ADD_PAYMENT_INFO */ ._q.ADD_PAYMENT_INFO,
        ecommerce: {
            currency: currency,
            value: Number(value.toFixed(2)),
            coupon: (couponItems === null || couponItems === void 0 ? void 0 : couponItems.length) > 0 && !couponItems.every(function(item) {
                return item.discountAmount === null;
            }) ? couponItems.map(function(c) {
                return c.code;
            }).join("|") : undefined,
            payment_type: paymentType,
            items: items
        }
    });
};
var addShippingInfoEvent = function(currency, shipmentMethod, couponItems, products) {
    var value = (0,_analytics_cart__WEBPACK_IMPORTED_MODULE_3__/* .getCombinedProductsValue */ .cp)(products);
    var items = products.map(function(param) {
        var product = param.product, quantityInCart = param.quantityInCart, adjustments = param.adjustments;
        var ref;
        var size = (product === null || product === void 0 ? void 0 : (ref = product.size) === null || ref === void 0 ? void 0 : ref.label) || "";
        var ga4Item = (0,utils_ga4Items__WEBPACK_IMPORTED_MODULE_6__/* .getGa4Item */ .Vr)(product === null || product === void 0 ? void 0 : product.styleNumber);
        return (0,_analytics_pdp__WEBPACK_IMPORTED_MODULE_4__/* .transformListProductToAnalyticsItem */ .pD)({
            product: product,
            currency: currency,
            quantity: quantityInCart,
            categories: {
                item_category: product === null || product === void 0 ? void 0 : product.primaryCategoryId
            },
            size: size,
            adjustments: adjustments,
            itemId: product === null || product === void 0 ? void 0 : product.styleNumber,
            itemListId: ga4Item === null || ga4Item === void 0 ? void 0 : ga4Item.lid,
            itemListName: ga4Item === null || ga4Item === void 0 ? void 0 : ga4Item.lname,
            index: ga4Item === null || ga4Item === void 0 ? void 0 : ga4Item.idx,
            creativeName: ga4Item === null || ga4Item === void 0 ? void 0 : ga4Item.cname,
            creativeSlot: ga4Item === null || ga4Item === void 0 ? void 0 : ga4Item.cslot,
            promotionId: ga4Item === null || ga4Item === void 0 ? void 0 : ga4Item.pid,
            promotionName: ga4Item === null || ga4Item === void 0 ? void 0 : ga4Item.pname
        });
    });
    var shippingTier = shipmentMethod.toLowerCase();
    (0,_analytics_utils__WEBPACK_IMPORTED_MODULE_1__/* .event */ .B)(_analytics_types__WEBPACK_IMPORTED_MODULE_2__/* .AnalyticsEvents.GA4EC_AddShippingInfo */ ._q.GA4EC_AddShippingInfo, {
        event_name: _analytics_types__WEBPACK_IMPORTED_MODULE_2__/* .AnalyticsEvents.ADD_SHIPPING_INFO */ ._q.ADD_SHIPPING_INFO,
        ecommerce: {
            currency: currency,
            value: Number(value.toFixed(2)),
            coupon: (couponItems === null || couponItems === void 0 ? void 0 : couponItems.length) ? couponItems.map(function(c) {
                return c.code;
            }).join("|") : undefined,
            shipping_tier: shippingTier,
            items: items
        }
    });
};
var formErrorEvent = function(formType, errors) {
    (0,_analytics_utils__WEBPACK_IMPORTED_MODULE_1__/* .event */ .B)(_analytics_types__WEBPACK_IMPORTED_MODULE_2__/* .AnalyticsEvents.GA4_CustomEvent */ ._q.GA4_CustomEvent, {
        event_name: _analytics_types__WEBPACK_IMPORTED_MODULE_2__/* .AnalyticsEvents.FORM_ERROR */ ._q.FORM_ERROR,
        event_params: {
            section: formType,
            fieldType: errors.join(" | "),
            field_type: errors.join(" | ")
        }
    });
};


/***/ }),

/***/ 46659:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "lL": function() { return /* binding */ addPrefixToAnalyticProp; },
  "Ub": function() { return /* binding */ getAnalyticsImage; },
  "bA": function() { return /* binding */ transformImageUrlToImageInteractionAnalyticsEvent; },
  "pD": function() { return /* binding */ transformListProductToAnalyticsItem; },
  "ve": function() { return /* binding */ transformListProductToAnalyticsProduct; },
  "vA": function() { return /* binding */ transformProductToAnalyticsProduct; },
  "Tp": function() { return /* binding */ transformVariantProductToAnalyticsProduct; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(85034);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(70169);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(5341);
// EXTERNAL MODULE: ./utils/getMinimalNumber.ts
var getMinimalNumber = __webpack_require__(23295);
;// CONCATENATED MODULE: ./utils/getProductPrice.ts
var getProductPrice = function(product) {
    return (product === null || product === void 0 ? void 0 : product.salePrice) || (product === null || product === void 0 ? void 0 : product.price) || 0;
};

// EXTERNAL MODULE: ./utils/isNumber.ts
var isNumber = __webpack_require__(95442);
// EXTERNAL MODULE: ./utils/products.ts
var products = __webpack_require__(1032);
// EXTERNAL MODULE: ./utils/analytics/analytics-utils.ts
var analytics_utils = __webpack_require__(67977);
;// CONCATENATED MODULE: ./utils/analytics/analytics-pdp.ts








var getVariantAvailability = function(sizes) {
    if (!sizes) return;
    var amountOrderable = sizes === null || sizes === void 0 ? void 0 : sizes.filter(function(size) {
        return size.orderable === true;
    });
    if (!amountOrderable.length) return "unavailable";
    if (amountOrderable.length === sizes.length) return "available";
    if (amountOrderable.length < sizes.length) return "partially available";
};
var transformListProductToAnalyticsProduct = function(product, i, list, categoryId) {
    if (!product.masterProduct) return null;
    var swatch = product.color;
    var selectedVariation = product.variantProduct;
    var ref, _brand;
    return {
        id: "".concat(product.masterId, "_").concat(swatch),
        variant: product.id,
        ean: (ref = selectedVariation === null || selectedVariation === void 0 ? void 0 : selectedVariation.ean) !== null && ref !== void 0 ? ref : "",
        name: product.masterProduct.name,
        price: getProductPrice(selectedVariation),
        brand: (_brand = product.masterProduct.brand) !== null && _brand !== void 0 ? _brand : "PUMA",
        position: (0,isNumber/* isNumber */.h)(i) ? i + 1 : undefined,
        list: list !== null && list !== void 0 ? list : "",
        category: categoryId !== null && categoryId !== void 0 ? categoryId : ""
    };
};
var getAnalyticsImage = function(image, defaultImage) {
    // TO DO: Define approach in GA4 when have image comes from fluidconfigure.
    // For now we use the original product image
    var isPersonalizedImage = !!image.includes("fluidconfigure");
    var analyticsImage = isPersonalizedImage ? transformImageUrlToImageInteractionAnalyticsEvent(defaultImage) : transformImageUrlToImageInteractionAnalyticsEvent(image);
    return analyticsImage;
};
var transformImageUrlToImageInteractionAnalyticsEvent = function(imageURL) {
    var ref;
    var ref1 = (0,_sliced_to_array/* default */.Z)((ref = imageURL.split("/global/")[1]) === null || ref === void 0 ? void 0 : ref.split("/"), 5), styleID = ref1[0], colorID = ref1[1], imageView = ref1[2], fndImageRegion = ref1[3], imageRegion = ref1[4];
    // Here we have to account for two types of URL
    // normal: images.puma.com/image/upload/f_auto,q_auto,b_rgb:fafafa,w_2000,h_2000/global/374915/01/mod03/fnd/PNA/fmt/png
    // fnd: images.puma.com/image/upload/f_auto,q_auto,b_rgb:fafafa,w_2000,h_2000/global/374915/01/fnd/PNA/fmt/png
    // The `fnd` type is one part shorter than the normal URLs so we have to
    // account for the shifting in position of some destructured variables
    var isFndView = imageView === "fnd";
    return {
        imageURL: imageURL,
        imageType: isFndView ? "fnd" : imageView.slice(0, -2),
        imageNumber: isFndView ? "unavailable" : imageView.slice(-2),
        imageRegion: isFndView ? fndImageRegion : imageRegion,
        productID: "".concat(styleID, "_").concat(colorID),
        styleID: styleID,
        colorID: colorID
    };
};
var transformProductToAnalyticsProduct = function(param) {
    var categoryId = param.categoryId, desiredSize = param.desiredSize, _includeExtraAnalyticsDimensions = param.includeExtraAnalyticsDimensions, includeExtraAnalyticsDimensions = _includeExtraAnalyticsDimensions === void 0 ? false : _includeExtraAnalyticsDimensions, product = param.product, variant = param.variant;
    var ref, ref1;
    var variantPrice = variant === null || variant === void 0 ? void 0 : (ref = variant.productPrice) === null || ref === void 0 ? void 0 : ref.price;
    var variantSalePrice = variant === null || variant === void 0 ? void 0 : (ref1 = variant.productPrice) === null || ref1 === void 0 ? void 0 : ref1.salePrice;
    var sizes = (0,products/* getSizesFromSizeGroups */.hJ)(variant.sizeGroups);
    var size = sizes.find(function(s) {
        return s.id === desiredSize;
    });
    var additionalDimensions = includeExtraAnalyticsDimensions ? (0,analytics_utils/* getAdditionalAnalyticsDimensions */.Zg)({
        sizeName: desiredSize ? size === null || size === void 0 ? void 0 : size.label : "",
        displayOutOfStock: product === null || product === void 0 ? void 0 : product.displayOutOfStock,
        assortmentAvailability: getVariantAvailability(sizes),
        isProductMarkedDown: !!(variantPrice && variantSalePrice && variantSalePrice < variantPrice),
        orderable: size ? size.orderable : variant.orderable,
        ean: variant.ean
    }) : {};
    var ref2, ref3, _ean;
    return (0,_object_spread/* default */.Z)({
        id: variant.id,
        variant: (ref3 = (ref2 = size === null || size === void 0 ? void 0 : size.productId) !== null && ref2 !== void 0 ? ref2 : variant.variantId) !== null && ref3 !== void 0 ? ref3 : "",
        ean: (_ean = variant.ean) !== null && _ean !== void 0 ? _ean : "",
        name: variant.name || (product === null || product === void 0 ? void 0 : product.name) || "",
        price: getProductPrice(variant),
        full_price: variantPrice,
        brand: (product === null || product === void 0 ? void 0 : product.brand) || "PUMA",
        category: categoryId || (product === null || product === void 0 ? void 0 : product.primaryCategoryId) || ""
    }, additionalDimensions);
};
var _ean, ref, ref1;
var transformVariantProductToAnalyticsProduct = function(variantProduct) {
    var includeExtraAnalyticsDimensions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return (0,_object_spread/* default */.Z)({
        id: variantProduct.styleNumber,
        variant: variantProduct.id,
        ean: (_ean = variantProduct.ean) !== null && _ean !== void 0 ? _ean : "",
        name: variantProduct === null || variantProduct === void 0 ? void 0 : variantProduct.name,
        price: getProductPrice(variantProduct),
        brand: (ref = variantProduct === null || variantProduct === void 0 ? void 0 : variantProduct.brand) !== null && ref !== void 0 ? ref : "PUMA",
        category: (ref1 = variantProduct === null || variantProduct === void 0 ? void 0 : variantProduct.primaryCategoryId) !== null && ref1 !== void 0 ? ref1 : "",
        full_price: variantProduct.price
    }, includeExtraAnalyticsDimensions && (0,_object_spread/* default */.Z)({}, (0,analytics_utils/* getAdditionalAnalyticsDimensions */.Zg)({
        sizeName: variantProduct.size.label,
        displayOutOfStock: variantProduct.displayOutOfStock,
        assortmentAvailability: variantProduct.assortmentAvailability,
        isProductMarkedDown: !!(variantProduct.salePrice && variantProduct.salePrice < variantProduct.price),
        orderable: variantProduct.orderable,
        ean: variantProduct.ean
    })));
};
var addPrefixToAnalyticProp = function(prop) {
    var prefix = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "a";
    if (prop) return (0,isNumber/* beginsWithNumber */.b)(prop) ? "".concat(prefix).concat(prop) : prop;
};
var isEmpty = function(value) {
    return(// null or undefined
    value == null || // has length and it's zero
    (value.hasOwnProperty("length") && value.length === 0) || // is an Object and has no keys
    (value.constructor === Object && Object.keys(value).length === 0));
};
var transformListProductToAnalyticsItem = function(param) {
    var product = param.product, currency = param.currency, quantity = param.quantity, categories = param.categories, itemListId = param.itemListId, itemListName = param.itemListName, size = param.size, adjustments = param.adjustments, index = param.index, creativeName = param.creativeName, creativeSlot = param.creativeSlot, promotionId = param.promotionId, promotionName = param.promotionName, discovery = param.discovery, assortmentAvailabilityItem = param.assortmentAvailabilityItem, itemId = param.itemId, itemName = param.itemName;
    var ref, ref1, ref2, ref3, ref4, ref5;
    var item_id = itemId !== null && itemId !== void 0 ? itemId : (product === null || product === void 0 ? void 0 : product.masterId) && (product.colorValue ? product.masterId + "_" + product.colorValue : product.masterId) || (product === null || product === void 0 ? void 0 : product.id);
    var productPrice = (product === null || product === void 0 ? void 0 : product.productPrice) ? product.productPrice : product === null || product === void 0 ? void 0 : (ref = product.variantProduct) === null || ref === void 0 ? void 0 : ref.productPrice;
    var _tax;
    var price = productPrice ? (0,getMinimalNumber/* getMinimalNumber */.q)(productPrice.price, productPrice.promotionPrice, productPrice.salePrice) - ((_tax = productPrice.tax) !== null && _tax !== void 0 ? _tax : 0) : undefined;
    var taxRate = (productPrice === null || productPrice === void 0 ? void 0 : productPrice.taxRate) || undefined;
    var coupon = (adjustments === null || adjustments === void 0 ? void 0 : adjustments.map(function(c) {
        return c.couponCode;
    }).join("|")) || undefined;
    var discount = productPrice ? coupon && (productPrice === null || productPrice === void 0 ? void 0 : productPrice.salePrice) && (productPrice === null || productPrice === void 0 ? void 0 : productPrice.promotionPrice) ? productPrice.salePrice - productPrice.promotionPrice : 0 : undefined;
    var saleDiscount = productPrice ? productPrice.price && productPrice.salePrice ? productPrice.price - productPrice.salePrice : 0 : undefined;
    var itemAvailability = (0,analytics_utils/* getItemAvailability */.jl)(product === null || product === void 0 ? void 0 : product.displayOutOfStock);
    var availability = [
        "InStock",
        "PreOrder"
    ].includes(itemAvailability) ? "true" : "false";
    var formattedSize = addPrefixToAnalyticProp(size);
    var sizes = (product === null || product === void 0 ? void 0 : product.sizeGroups) ? (0,products/* getSizesFromSizeGroups */.hJ)(product.sizeGroups) : [];
    var assortmentAvailability = (sizes === null || sizes === void 0 ? void 0 : sizes.length) ? getVariantAvailability(sizes) : undefined;
    var markedDown = productPrice && productPrice.price && productPrice.price ? "".concat(!!(productPrice.salePrice < productPrice.price)) : undefined;
    var discounted = productPrice && productPrice.promotionPrice && productPrice.price ? "".concat(!!(productPrice.promotionPrice < productPrice.price)) : undefined;
    var orderable = (product === null || product === void 0 ? void 0 : product.orderable) === true || (product === null || product === void 0 ? void 0 : (ref1 = product.variantProduct) === null || ref1 === void 0 ? void 0 : ref1.orderable) === true ? "true" : (product === null || product === void 0 ? void 0 : product.orderable) === false || (product === null || product === void 0 ? void 0 : (ref2 = product.variantProduct) === null || ref2 === void 0 ? void 0 : ref2.orderable) === false ? "false" : undefined;
    //To check
    var variantId = (product === null || product === void 0 ? void 0 : product.variantId) || (product === null || product === void 0 ? void 0 : product.productId) || (product === null || product === void 0 ? void 0 : (ref3 = product.variantProduct) === null || ref3 === void 0 ? void 0 : ref3.variantId) || undefined;
    var styleNumber = (product === null || product === void 0 ? void 0 : product.styleNumber) || undefined;
    var colorCodeFormatted = product && product.colorValue ? "a".concat(product.colorValue || product.colors && product.colors[0].value || product.color) : undefined;
    var full_price = (productPrice === null || productPrice === void 0 ? void 0 : productPrice.price) ? String(productPrice.price) : undefined;
    var sport = !isEmpty(product === null || product === void 0 ? void 0 : product.sportName) ? product.sportName : undefined;
    var gender = !isEmpty(product === null || product === void 0 ? void 0 : product.gender) ? product.gender : undefined;
    var ageGroup = !isEmpty(product === null || product === void 0 ? void 0 : product.ageGroup) ? product.ageGroup : undefined;
    var lineName = !isEmpty(product === null || product === void 0 ? void 0 : product.lineName) ? product.lineName : undefined;
    var collection = !isEmpty(product === null || product === void 0 ? void 0 : product.collectionMark) ? product.collectionMark : undefined;
    var division = !isEmpty(product === null || product === void 0 ? void 0 : product.division) ? product.division : undefined;
    var businessUnit = !isEmpty(product === null || product === void 0 ? void 0 : product.businessUnit) ? product.businessUnit : undefined;
    var businessSubSegment = !isEmpty(product === null || product === void 0 ? void 0 : product.businessSubSegment) ? product.businessSubSegment : undefined;
    var franchise = !isEmpty(product === null || product === void 0 ? void 0 : product.franchise) ? product.franchise : undefined;
    var item = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        item_id: item_id,
        item_name: itemName || (product === null || product === void 0 ? void 0 : product.name) || (product === null || product === void 0 ? void 0 : product.productName),
        affiliation: "PUMA",
        coupon: coupon,
        currency: currency,
        discount: discount ? Math.round(discount * 100) / 100 : undefined,
        index: index,
        item_brand: "PUMA"
    }, categories), {
        item_list_id: itemListId,
        item_list_name: itemListName,
        item_variant: variantId,
        price: price,
        tax_rate: taxRate,
        quantity: quantity,
        creative_name: creativeName,
        creative_slot: creativeSlot,
        promotion_id: promotionId,
        promotion_name: promotionName,
        full_price: full_price,
        sale_discount: saleDiscount !== undefined ? Number((saleDiscount * quantity).toFixed(2)) : undefined,
        size: formattedSize,
        availability: availability,
        assortment_availability: assortmentAvailability || assortmentAvailabilityItem,
        discounted: discounted,
        orderable: orderable,
        item_ean: (product === null || product === void 0 ? void 0 : product.ean) || (product === null || product === void 0 ? void 0 : (ref4 = product.variantProduct) === null || ref4 === void 0 ? void 0 : ref4.ean),
        color: (product === null || product === void 0 ? void 0 : product.colorName) || (product === null || product === void 0 ? void 0 : (ref5 = product.variantProduct) === null || ref5 === void 0 ? void 0 : ref5.colorName),
        style_number: styleNumber,
        marked_down: markedDown,
        discovery: discovery,
        sport: sport,
        gender: gender,
        age_group: ageGroup,
        line_name: lineName,
        collection: collection,
        division: division,
        color_code: colorCodeFormatted,
        business_unit: businessUnit,
        business_subsegment: businessSubSegment,
        franchise: franchise,
        department: undefined,
        class: undefined
    });
    return item;
};


/***/ }),

/***/ 67977:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ event; },
/* harmony export */   "C2": function() { return /* binding */ getPageType; },
/* harmony export */   "Cv": function() { return /* binding */ getPDPFitAnalyticsData; },
/* harmony export */   "Du": function() { return /* binding */ activateOptimize; },
/* harmony export */   "LV": function() { return /* binding */ pageview; },
/* harmony export */   "NM": function() { return /* binding */ getAnalyticsDimensions; },
/* harmony export */   "RW": function() { return /* binding */ getCommonFitAnalyticsData; },
/* harmony export */   "Zg": function() { return /* binding */ getAdditionalAnalyticsDimensions; },
/* harmony export */   "iK": function() { return /* binding */ removeNullUndefined; },
/* harmony export */   "jl": function() { return /* binding */ getItemAvailability; }
/* harmony export */ });
/* unused harmony exports getAddToCardReferrer, ga4GenericEvent, getG4aPath, getCustomerId */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(17599);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(85034);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(70169);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(5341);
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79758);
/* harmony import */ var types_analyticTypes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90099);
/* harmony import */ var utils_string__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(12874);
/* harmony import */ var utils_products__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1032);
/* harmony import */ var _analytics_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85680);
/* harmony import */ var _hashEmail__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(91990);










var getPageType = function(url) {
    var baseUrl = url.toLowerCase();
    switch(true){
        case baseUrl.includes("/checkout/confirmation"):
            return "order confirmation";
        case baseUrl.includes("/checkout/payment"):
            return "payment";
        case baseUrl.includes("/checkout"):
            return "checkout";
        case baseUrl.includes("/pd/"):
            return "pdp";
        case baseUrl.includes("/account"):
            return "account";
        case baseUrl.includes("/search"):
            return "search";
        case baseUrl.includes("/wishlist"):
        case baseUrl.includes("/returns"):
            return "other";
        case baseUrl.includes("/cart"):
            return "cart";
        case baseUrl.includes("/help"):
            return "content";
        case baseUrl.split("/").length === 3:
            return "home";
        default:
            return "plp";
    }
};
var activateOptimize = function() {
    window.dataLayer.push({
        event: "optimize.activate"
    });
};
var getAdditionalAnalyticsDimensions = function(param) {
    var sizeName = param.sizeName, displayOutOfStock = param.displayOutOfStock, assortmentAvailability = param.assortmentAvailability, isProductMarkedDown = param.isProductMarkedDown, orderable = param.orderable, ean = param.ean;
    var _obj;
    return _obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, types_analyticTypes__WEBPACK_IMPORTED_MODULE_1__/* .Dimensions.d88 */ .Db.d88, (0,utils_string__WEBPACK_IMPORTED_MODULE_6__/* .upperCaseOrBlank */ .Wq)(sizeName)), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, types_analyticTypes__WEBPACK_IMPORTED_MODULE_1__/* .Dimensions.d92 */ .Db.d92, getItemAvailability(displayOutOfStock || undefined)), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, types_analyticTypes__WEBPACK_IMPORTED_MODULE_1__/* .Dimensions.d94 */ .Db.d94, (0,utils_string__WEBPACK_IMPORTED_MODULE_6__/* .lowerCaseOrBlank */ .Ms)(assortmentAvailability)), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, types_analyticTypes__WEBPACK_IMPORTED_MODULE_1__/* .Dimensions.d96 */ .Db.d96, (0,utils_string__WEBPACK_IMPORTED_MODULE_6__/* .lowerCaseOrBlank */ .Ms)("".concat(isProductMarkedDown !== null && isProductMarkedDown !== void 0 ? isProductMarkedDown : ""))), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, types_analyticTypes__WEBPACK_IMPORTED_MODULE_1__/* .Dimensions.d97 */ .Db.d97, (0,utils_string__WEBPACK_IMPORTED_MODULE_6__/* .lowerCaseOrBlank */ .Ms)("".concat(orderable))), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, types_analyticTypes__WEBPACK_IMPORTED_MODULE_1__/* .Dimensions.d100 */ .Db.d100, getAddToCardReferrer(ean)), _obj;
};
var getAnalyticsDimensions = function(product) {
    var ref, ref1;
    var productPrice = product === null || product === void 0 ? void 0 : (ref = product.productPrice) === null || ref === void 0 ? void 0 : ref.price;
    var productSalePrice = product === null || product === void 0 ? void 0 : (ref1 = product.productPrice) === null || ref1 === void 0 ? void 0 : ref1.salePrice;
    var isProductMarkedDown = !!(productPrice && productSalePrice && productSalePrice < productPrice);
    var _obj;
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, types_analyticTypes__WEBPACK_IMPORTED_MODULE_1__/* .Dimensions.d14 */ .Db.d14, (0,utils_string__WEBPACK_IMPORTED_MODULE_6__/* .lowerCaseOrBlank */ .Ms)(product.name)), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, types_analyticTypes__WEBPACK_IMPORTED_MODULE_1__/* .Dimensions.d15 */ .Db.d15, (0,utils_string__WEBPACK_IMPORTED_MODULE_6__/* .lowerCaseOrBlank */ .Ms)(product.masterId)), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, types_analyticTypes__WEBPACK_IMPORTED_MODULE_1__/* .Dimensions.d16 */ .Db.d16, (0,utils_string__WEBPACK_IMPORTED_MODULE_6__/* .lowerCaseOrBlank */ .Ms)(product.sportName)), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, types_analyticTypes__WEBPACK_IMPORTED_MODULE_1__/* .Dimensions.d17 */ .Db.d17, (0,utils_string__WEBPACK_IMPORTED_MODULE_6__/* .lowerCaseOrBlank */ .Ms)(product.technology)), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, types_analyticTypes__WEBPACK_IMPORTED_MODULE_1__/* .Dimensions.d18 */ .Db.d18, (0,utils_string__WEBPACK_IMPORTED_MODULE_6__/* .lowerCaseOrBlank */ .Ms)(product.gender)), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, types_analyticTypes__WEBPACK_IMPORTED_MODULE_1__/* .Dimensions.d19 */ .Db.d19, (0,utils_string__WEBPACK_IMPORTED_MODULE_6__/* .lowerCaseOrBlank */ .Ms)(product.ageGroup)), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, types_analyticTypes__WEBPACK_IMPORTED_MODULE_1__/* .Dimensions.d20 */ .Db.d20, (0,utils_string__WEBPACK_IMPORTED_MODULE_6__/* .lowerCaseOrBlank */ .Ms)(product.lineName)), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, types_analyticTypes__WEBPACK_IMPORTED_MODULE_1__/* .Dimensions.d21 */ .Db.d21, (0,utils_string__WEBPACK_IMPORTED_MODULE_6__/* .lowerCaseOrBlank */ .Ms)(product.businessSegment)), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, types_analyticTypes__WEBPACK_IMPORTED_MODULE_1__/* .Dimensions.d22 */ .Db.d22, (0,utils_string__WEBPACK_IMPORTED_MODULE_6__/* .lowerCaseOrBlank */ .Ms)(product.division)), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, types_analyticTypes__WEBPACK_IMPORTED_MODULE_1__/* .Dimensions.d23 */ .Db.d23, (0,utils_string__WEBPACK_IMPORTED_MODULE_6__/* .lowerCaseOrBlank */ .Ms)(product.articleGroup)), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, types_analyticTypes__WEBPACK_IMPORTED_MODULE_1__/* .Dimensions.d24 */ .Db.d24, (0,utils_string__WEBPACK_IMPORTED_MODULE_6__/* .lowerCaseOrBlank */ .Ms)(product.articleType)), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, types_analyticTypes__WEBPACK_IMPORTED_MODULE_1__/* .Dimensions.d25 */ .Db.d25, (0,utils_string__WEBPACK_IMPORTED_MODULE_6__/* .lowerCaseOrBlank */ .Ms)(product.colorDescription)), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, types_analyticTypes__WEBPACK_IMPORTED_MODULE_1__/* .Dimensions.d76 */ .Db.d76, (0,utils_string__WEBPACK_IMPORTED_MODULE_6__/* .lowerCaseOrBlank */ .Ms)(product.colorName)), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, types_analyticTypes__WEBPACK_IMPORTED_MODULE_1__/* .Dimensions.d79 */ .Db.d79, (0,utils_string__WEBPACK_IMPORTED_MODULE_6__/* .lowerCaseOrBlank */ .Ms)(product.businessUnit)), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, types_analyticTypes__WEBPACK_IMPORTED_MODULE_1__/* .Dimensions.d80 */ .Db.d80, (0,utils_string__WEBPACK_IMPORTED_MODULE_6__/* .lowerCaseOrBlank */ .Ms)(product.businessSubSegment)), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, types_analyticTypes__WEBPACK_IMPORTED_MODULE_1__/* .Dimensions.d81 */ .Db.d81, (0,utils_string__WEBPACK_IMPORTED_MODULE_6__/* .lowerCaseOrBlank */ .Ms)(product.franchise)), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, types_analyticTypes__WEBPACK_IMPORTED_MODULE_1__/* .Dimensions.d82 */ .Db.d82, (0,utils_string__WEBPACK_IMPORTED_MODULE_6__/* .lowerCaseOrBlank */ .Ms)(product.collectionMark)), _obj), getAdditionalAnalyticsDimensions({
        sizeName: product.size.label,
        orderable: product.orderable,
        displayOutOfStock: product.displayOutOfStock,
        assortmentAvailability: product.assortmentAvailability,
        isProductMarkedDown: isProductMarkedDown,
        ean: product.ean
    }));
};
var getItemAvailability = function(val) {
    if (!val) return types_analyticTypes__WEBPACK_IMPORTED_MODULE_1__/* .ItemAvailabilitySchema.instock */ .pR.instock;
    var itemAvailabilityValue = Object.keys(val).filter(function(key) {
        return val[key];
    })[0];
    var _itemAvailabilityValue;
    return (_itemAvailabilityValue = types_analyticTypes__WEBPACK_IMPORTED_MODULE_1__/* .ItemAvailabilitySchema */ .pR[itemAvailabilityValue]) !== null && _itemAvailabilityValue !== void 0 ? _itemAvailabilityValue : "";
};
var getCommonFitAnalyticsData = function() {
    var shopLanguage = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", shopCountry = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", currency = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", userId = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "", sessionId = arguments.length > 4 ? arguments[4] : void 0;
    return {
        shopLanguage: shopLanguage,
        shopCountry: shopCountry,
        currency: currency,
        userId: userId,
        sessionId: sessionId || userId
    };
};
var _styleNumber, ref, _styleNumber1;
var getPDPFitAnalyticsData = function(masterProduct, variation, swatch) {
    var ref1;
    return {
        currentProductId: (_styleNumber = variation.styleNumber) !== null && _styleNumber !== void 0 ? _styleNumber : "",
        mainThumbnail: (ref = (ref1 = variation.images[0]) === null || ref1 === void 0 ? void 0 : ref1.href) !== null && ref !== void 0 ? ref : "",
        allProductIds: masterProduct === null || masterProduct === void 0 ? void 0 : masterProduct.variations.map(function(variation) {
            return (_styleNumber1 = variation.styleNumber) !== null && _styleNumber1 !== void 0 ? _styleNumber1 : "";
        }),
        sizes: masterProduct === null || masterProduct === void 0 ? void 0 : masterProduct.variations.filter(function(variation) {
            return variation.colorValue === swatch;
        }).map(function(variation) {
            var retypedVariation = variation;
            var sizes = (0,utils_products__WEBPACK_IMPORTED_MODULE_2__/* .getSizesFromSizeGroups */ .hJ)(retypedVariation === null || retypedVariation === void 0 ? void 0 : retypedVariation.sizeGroups);
            return {
                length: null,
                values: sizes.map(function(size) {
                    return size.label;
                }),
                availability: sizes.reduce(function(acc, curr) {
                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, acc), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, curr.label, curr.orderable));
                }, {})
            };
        })
    };
};
var getAddToCardReferrer = function(ean) {
    var ref;
    if (ean && (window === null || window === void 0 ? void 0 : (ref = window.dataLayer) === null || ref === void 0 ? void 0 : ref.length)) {
        var ref1;
        var listDataLayer = window.dataLayer.filter(function(e) {
            return e.event === _analytics_types__WEBPACK_IMPORTED_MODULE_3__/* .AnalyticsEvents.ADD_TO_CART */ ._q.ADD_TO_CART;
        });
        var vectorProductsEvent = listDataLayer.map(function(element) {
            var ref, ref1, ref2, ref3, ref4, ref5;
            var rObj = {
                ean: "",
                dimension100: ""
            };
            rObj["ean"] = (ref2 = element === null || element === void 0 ? void 0 : (ref = element.ecommerce) === null || ref === void 0 ? void 0 : (ref1 = ref.add) === null || ref1 === void 0 ? void 0 : ref1.products[0]) === null || ref2 === void 0 ? void 0 : ref2.ean;
            rObj["dimension100"] = (ref5 = element === null || element === void 0 ? void 0 : (ref3 = element.ecommerce) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.add) === null || ref4 === void 0 ? void 0 : ref4.products[0]) === null || ref5 === void 0 ? void 0 : ref5.dimension100;
            return rObj;
        });
        var result = vectorProductsEvent.filter(function(item) {
            return item.ean === ean;
        });
        return (ref1 = result[0]) === null || ref1 === void 0 ? void 0 : ref1.dimension100;
    } else {
        return "";
    }
};
var ga4GenericEvent = function(url, payload, pageType) {
    var isGuest = String(!payload.customerAuth);
    var query_string = getG4aPath(url, "query string");
    var ref;
    var referrerCategory = (ref = window.localStorage.getItem(utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .REFERRER_CATEGORY */ .qh)) !== null && ref !== void 0 ? ref : undefined;
    var ref1;
    var referrerType = (ref1 = window.localStorage.getItem(utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .REFERRER_TYPE */ .cj)) !== null && ref1 !== void 0 ? ref1 : undefined;
    window.dataLayer.push({
        event: _analytics_types__WEBPACK_IMPORTED_MODULE_3__/* .AnalyticsEvents.GA4_GENERIC */ ._q.GA4_GENERIC,
        attraqtSourceId: "1234",
        page_type: pageType,
        page_title: payload.pageTitle,
        page_path: getG4aPath(url, "page path"),
        page_location: payload.currentURL,
        query_string: query_string,
        local_language: payload.language,
        custom_user_id: getCustomerId(payload),
        store_view: "".concat(payload.language, "-").concat(payload.country.toUpperCase()),
        is_guest: isGuest,
        release_version: window.sessionStorage.getItem("analyticsReleaseVersion"),
        web_frontend: "cybercat",
        index_status: getIndexStatus(),
        gsm_code: getGsmCode(payload.country),
        hashed_email: (0,_hashEmail__WEBPACK_IMPORTED_MODULE_4__/* .hashEmail */ .g)(payload.customerEmail),
        referrer_category: referrerCategory,
        referrer_type: referrerType
    });
};
var getG4aPath = function(url, pathType) {
    var splittedUrl = url.split("?");
    if (pathType === "page path") return splittedUrl[0];
    else return splittedUrl[1];
};
var getCustomerId = function(payload) {
    var storedCustomerId = localStorage.getItem("customerID");
    if (!payload.customerAuth) {
        return storedCustomerId || "guest_".concat(payload.customerId);
    }
    if (!storedCustomerId || storedCustomerId !== payload.customerId) {
        localStorage.setItem("customerID", payload.customerId);
    }
    return localStorage.getItem("customerID") || "";
};
var pageview = function(url, payload, pageTypeOverride) {
    var pageType = pageTypeOverride !== null && pageTypeOverride !== void 0 ? pageTypeOverride : getPageType(url);
    ga4GenericEvent(url, payload, pageType);
    event(_analytics_types__WEBPACK_IMPORTED_MODULE_3__/* .AnalyticsEvents.GENERAL */ ._q.GENERAL, {
        pageType: pageType,
        pageTitle: payload.pageTitle,
        language: payload.language,
        customerID: payload.customerId,
        customerAuth: payload.customerAuth,
        customerEmail: payload.customerEmail,
        customerNo: payload.customerNo,
        storeView: payload.country,
        country: payload.country.toUpperCase() + " Shop",
        environment: "production",
        releaseVersion: window.sessionStorage.getItem("analyticsReleaseVersion"),
        frontend: "cybercat",
        breadcrumbs: payload.breadcrumbs,
        viewport: getViewport(),
        searchQuery: payload.searchQuery,
        cart: payload.cart,
        currentURL: payload.currentURL
    });
};
var gsmCodes = {
    ca: "CARE0003",
    us: "USRE0001",
    uk: "GBRE0006",
    jp: "JPRE0006",
    in: "INRE0001",
    au: "AURE0001",
    nz: "NZRE0002"
};
var getGsmCode = function(countryCode) {
    var country = countryCode.split("-")[0];
    return gsmCodes[country];
};
var getIndexStatus = function() {
    if (document) {
        var ref;
        var robots = (ref = document.getElementsByName("robots")[0]) === null || ref === void 0 ? void 0 : ref["content"];
        if (robots === "noindex, nofollow") {
            return "noindex";
        } else {
            return "index";
        }
    }
};
var event = function(type, payload) {
    var isGA4Event = type.startsWith("GA4EC_") || type === _analytics_types__WEBPACK_IMPORTED_MODULE_3__/* .AnalyticsEvents.GA4_CustomEvent */ ._q.GA4_CustomEvent;
    var eventData = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        event: type
    }, !isGA4Event && {
        environment: "production",
        release_version: window.sessionStorage.getItem("analyticsReleaseVersion"),
        viewport: getViewport()
    }, payload);
    if (!utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .isServer */ .sk) window.dataLayer.push(eventData);
};
var getViewport = function() {
    var minScreenSize = Math.min(window.screen.width, window.screen.height);
    if (minScreenSize < 480) {
        return "mobile";
    } else if (minScreenSize < 1024) {
        return "tablet";
    }
    return "desktop";
};
var removeNullUndefined = function(obj) {
    return Object.fromEntries(Object.entries(obj).filter(function(param) {
        var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(param, 2), _ = _param[0], v = _param[1];
        return v != null;
    }));
};


/***/ }),

/***/ 85680:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sc": function() { return /* binding */ SearchType; },
/* harmony export */   "Vw": function() { return /* binding */ UserAction; },
/* harmony export */   "_q": function() { return /* binding */ AnalyticsEvents; },
/* harmony export */   "dm": function() { return /* binding */ FormType; }
/* harmony export */ });
/* eslint sort-keys: ["error", "asc"] */ var AnalyticsEvents = {
    ACCOUNT: "account",
    ACCOUNT_AMBASSADOR: "my_account_ambassador",
    ACCOUNT_GENERAL: "my_account_general",
    ACCOUNT_LOYALTY_CARD: "my_account_loyalty_card",
    ACCOUNT_OVERVIEW: "my_account_overview",
    ACCOUNT_SETTINGS: "my_account_settings",
    ADD_ITEM_LIST_TO_CART: "add_to_cart",
    ADD_PAYMENT_INFO: "add_payment_info",
    ADD_SHIPPING_INFO: "add_shipping_info",
    ADD_TO_CART: "add to cart",
    ADD_TO_WISHLIST: "add_to_wishlist",
    BEGIN_CHECKOUT: "begin_checkout",
    CART: "cart",
    CHANGE_COLOR: "change_color",
    CHECKOUT: "checkout",
    CHOOSE_SIZE: "choose_size",
    ELEVATED_PDP_IMPRESSION: "elevated pdp impression",
    EMAIL_SIGNUP: "email signup",
    FOOTER_LINK_CLICKED: "footer link clicked",
    FORM_ERROR: "form_error",
    GA4EC_AddItemToCart: "GA4EC_AddItemToCart",
    GA4EC_AddItemToWishlist: "GA4EC_AddItemToWishlist",
    GA4EC_AddPaymentInfo: "GA4EC_AddPaymentInfo",
    GA4EC_AddShippingInfo: "GA4EC_AddShippingInfo",
    GA4EC_BeginCheckout: "GA4EC_BeginCheckout",
    GA4EC_ItemListClick: "GA4EC_ItemListClick",
    GA4EC_ItemListView: "GA4EC_ItemListView",
    GA4EC_ItemView: "GA4EC_ItemView",
    GA4EC_NewsletterImpression: "newsletter_impression",
    GA4EC_OrderConfirmation: "GA4EC_OrderConfirmation",
    GA4EC_PromotionSelect: "GA4EC_PromotionSelect",
    GA4EC_PromotionView: "GA4EC_PromotionView",
    GA4EC_Refinement: "refinement",
    GA4EC_RemoveItemFromCart: "GA4EC_RemoveItemFromCart",
    GA4EC_SignUp: "sign_up",
    GA4EC_SignUpFormOpen: "sign_up_form_open",
    GA4EC_Sizechart: "sizechart",
    GA4EC_Stylitics: "stylitics",
    GA4EC_ViewCart: "GA4EC_ViewCart",
    GA4_ADD_TO_CART: "add_to_cart",
    GA4_ADD_TO_WISHLIST: "add_to_wishlist",
    GA4_CustomEvent: "GA4customEvent",
    GA4_FORM_ERROR: "form_error",
    GA4_GENERIC: "GA4generic",
    GA4_IMAGE_OPENED: "image_opened",
    GA4_IMPRESSION: "impression",
    GA4_OVERLAY_VIEW: "overlay_view",
    GA4_PRODUCT_CLICK: "product_click",
    GA4_PROMO_CODE_SUBMITED: "promo_code_submitted",
    GA4_SELECT_PRODUCT_OVERLAY: "select_product_overlay",
    GA4_SessionCartTotal: "GA4sessionCartTotal",
    GENERAL: "general",
    HEADER_LINK_CLICKED: "header link clicked",
    IMAGE_VIEWED: "image_viewed",
    LANGUAGE_CHANGED: "language changed",
    LOGIN: "login",
    LOGOUT: "logout",
    MENU_OPEN: "menu_open",
    MINICART: "minicart",
    MORE_INFORMATION: "more_information",
    MY_ACCOUNT_CARD: "my_account_card",
    NAVIGATION_CLICK: "navigation_click",
    ORDER_CONFIRMATION: "order confirmation",
    ORDER_LOOKUP: "order lookup",
    PAYMENT: "payment",
    PAYMENT_CLICK: "payment_click",
    PAYMENT_TYPE_SELECTED: "payment type selected",
    PDP_INTERACTION: "pdp interaction",
    PIXLEE: "pixlee",
    PLP_RATING_IMPRESSION: "plp_rating_impression",
    PRODUCT_CLICKED: "product clicked",
    PRODUCT_DISCOVERY_CHANNEL: "product_discovery_channel",
    PRODUCT_LIST_LOADED: "product list loaded",
    PRODUCT_LIST_REFRESHED: "product list refreshed",
    PRODUCT_LIST_UPDATED: "product list updated",
    PRODUCT_RECOMMENDER_CLICKED: "product recommender click",
    PRODUCT_RECOMMENDER_VIEWED: "product recommender view",
    PRODUCT_VIEWED: "product viewed",
    PROMOTION_CLICK: "promotion click",
    PROMOTION_VIEW: "promotion view",
    PROMO_CODE_SUBMITTED: "promo code submitted",
    PURCHASE: "purchase",
    QUANTITY_CHANGE: "quantity_change",
    RATINGS_AND_REVIEWS: "ratings_and_reviews",
    REFINEMENT_SELECTED: "refinement selected",
    REMOVE_FROM_CART: "remove from cart",
    REMOVE_ITEM_FROM_CART: "remove_from_cart",
    SCROLL: "scroll",
    SEARCH: "search",
    SEARCH_MODAL_IMPRESSION: "search modal impression",
    SEARCH_OPEN: "search_open",
    SEARCH_RECENTLY_VIEWED_PRODUCT_CLICK: "recently viewed click",
    SEARCH_RECOMMENDED_PRODUCT_CLICK: "suggested product",
    SEARCH_SUGGESTED_PRODUCT_CLICK: "related product click",
    SEARCH_SUGGESTED_SEARCH_TERM_CLICK: "suggested search term",
    SEARCH_TRENDING_SEARCH_TERM_CLICK: "trending searches",
    SELECT_ITEM: "select_item",
    SELECT_LOCATION: "select_location",
    SELECT_PROMOTION: "select_promotion",
    SHOW_MORE_ALL: "show_more_all",
    SIGN_UP_FORM_CLOSE: "sign_up_form_close",
    SIGN_UP_FORM_ERROR: "sign_up_form_error",
    SMS_OPT_IN: "sms signup",
    SORT_SELECTED: "sort selected",
    STYLITICS_INTERACTION: "stylitics interaction",
    THUMBNAIL_ARROW: "thumbnail_arrow",
    VIDEO_COMPLETE: "video_complete",
    VIDEO_PROGRESS: "video_progress",
    VIDEO_START: "video_start",
    VIEW_CART: "view_cart",
    VIEW_ITEM: "view_item",
    VIEW_ITEM_LIST: "view_item_list",
    VIEW_PROMOTION: "view_promotion",
    WISHLIST_TRANSFER: "wishlist_transfer"
};
var SearchType;
(function(SearchType) {
    SearchType["regular"] = "regular search";
    SearchType["noResults"] = "no results search bar";
})(SearchType || (SearchType = {}));
var UserAction;
(function(UserAction) {
    UserAction["SHOW_BALANCE"] = "show balance";
    UserAction["NEW_AMBASSADOR_CARD"] = "new ambassador card";
})(UserAction || (UserAction = {}));
var FormType;
(function(FormType) {
    FormType["SHIPPING"] = "shipping_form";
    FormType["BILLING"] = "billing_form";
    FormType["CHECKOUT"] = "checkout_promo_form";
    FormType["CART_PROMO"] = "cart_promo_form";
    FormType["GIFT_CARD"] = "gift_card_form";
})(FormType || (FormType = {}));


/***/ }),

/***/ 91990:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ hashEmail; }
/* harmony export */ });
var hashEmail = function(email) {
    var crypto = __webpack_require__(34309);
    if (email) {
        var hash = crypto.createHash("sha256");
        hash.update(email);
        var hashedEmail = hash.digest("hex");
        return hashedEmail;
    }
};


/***/ }),

/***/ 83168:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "_q": function() { return /* reexport */ analytics_types/* AnalyticsEvents */._q; },
  "dm": function() { return /* reexport */ analytics_types/* FormType */.dm; },
  "Sc": function() { return /* reexport */ analytics_types/* SearchType */.Sc; },
  "Vw": function() { return /* reexport */ analytics_types/* UserAction */.Vw; },
  "Du": function() { return /* reexport */ analytics_utils/* activateOptimize */.Du; },
  "ds": function() { return /* reexport */ analytics_checkout/* addPaymentInfoAnalyticsEvent */.ds; },
  "lL": function() { return /* reexport */ analytics_pdp/* addPrefixToAnalyticProp */.lL; },
  "sm": function() { return /* reexport */ analytics_checkout/* addShippingInfoEvent */.sm; },
  "XO": function() { return /* reexport */ addToWishListEvent; },
  "z2": function() { return /* reexport */ categoryHeaderNavigationEvent; },
  "Cl": function() { return /* reexport */ analytics_checkout/* convertToGA4PaymentMethod */.Cl; },
  "QZ": function() { return /* reexport */ emailSignUpEvent; },
  "B": function() { return /* reexport */ analytics_utils/* event */.B; },
  "i7": function() { return /* reexport */ footerNavigationClickEvent; },
  "ZG": function() { return /* reexport */ footerNavigationEvent; },
  "pd": function() { return /* reexport */ analytics_checkout/* formErrorEvent */.pd; },
  "Ub": function() { return /* reexport */ analytics_pdp/* getAnalyticsImage */.Ub; },
  "RW": function() { return /* reexport */ analytics_utils/* getCommonFitAnalyticsData */.RW; },
  "y9": function() { return /* reexport */ getOrderConfirmationFitAnalyticsData; },
  "Cv": function() { return /* reexport */ analytics_utils/* getPDPFitAnalyticsData */.Cv; },
  "C2": function() { return /* reexport */ analytics_utils/* getPageType */.C2; },
  "zy": function() { return /* reexport */ getUserOrderInformation; },
  "eW": function() { return /* reexport */ handleIntersectionCarousel; },
  "RQ": function() { return /* reexport */ handleIntersectionPLP; },
  "Z8": function() { return /* reexport */ headerNavigationClickEvent; },
  "n4": function() { return /* reexport */ headerNavigationEvent; },
  "Hb": function() { return /* reexport */ iconHeaderNavigationClickEvent; },
  "_J": function() { return /* reexport */ iconHeaderNavigationEvent; },
  "F2": function() { return /* reexport */ loginEvent; },
  "br": function() { return /* reexport */ logoutEvent; },
  "W0": function() { return /* reexport */ mobileMenuOpenEvent; },
  "Ng": function() { return /* reexport */ myAccountAmbassadorEvent; },
  "Sk": function() { return /* reexport */ myAccountCardEvents; },
  "rx": function() { return /* reexport */ myAccountGeneralEvent; },
  "Bh": function() { return /* reexport */ myAccountLoyaltyCardEvent; },
  "My": function() { return /* reexport */ myAccountOverviewEvent; },
  "yV": function() { return /* reexport */ myAccountUserSettingsEvent; },
  "f": function() { return /* reexport */ navigationEvent; },
  "LV": function() { return /* reexport */ analytics_utils/* pageview */.LV; },
  "UM": function() { return /* reexport */ analytics_checkout/* paymentClickEvent */.UM; },
  "iK": function() { return /* reexport */ analytics_utils/* removeNullUndefined */.iK; },
  "dr": function() { return /* reexport */ searchAnalyticsEvent; },
  "kF": function() { return /* reexport */ analytics_cart/* sessionCartTotalEvent */.kF; },
  "Sh": function() { return /* reexport */ signUpFormAnalyticsEvent; },
  "Ry": function() { return /* reexport */ analytics_cart/* toAnalyticsCart */.Ry; },
  "kA": function() { return /* reexport */ analytics_cart/* transformCartProductToAnalyticsCartProduct */.kA; },
  "bA": function() { return /* reexport */ analytics_pdp/* transformImageUrlToImageInteractionAnalyticsEvent */.bA; },
  "pD": function() { return /* reexport */ analytics_pdp/* transformListProductToAnalyticsItem */.pD; },
  "ve": function() { return /* reexport */ analytics_pdp/* transformListProductToAnalyticsProduct */.ve; },
  "vA": function() { return /* reexport */ analytics_pdp/* transformProductToAnalyticsProduct */.vA; },
  "Tp": function() { return /* reexport */ analytics_pdp/* transformVariantProductToAnalyticsProduct */.Tp; },
  "xH": function() { return /* reexport */ analytics_cart/* viewCartAnalyticsEvent */.xH; }
});

// UNUSED EXPORTS: ga4GenericEvent, getAddToCardReferrer, getAdditionalAnalyticsDimensions, getAnalyticsDimensions, getCombinedProductsValue, getCustomerId, getG4aPath, getItemAvailability

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(3204);
// EXTERNAL MODULE: ./utils/capitalize.ts
var capitalize = __webpack_require__(59308);
// EXTERNAL MODULE: ./utils/analytics/analytics.types.ts
var analytics_types = __webpack_require__(85680);
;// CONCATENATED MODULE: ./utils/analytics/analytics-navigation.ts




var navigationEvent = function(param) {
    var event_name = param.event_name, user_action = param.user_action, nav_path = param.nav_path;
    (0,analytics_utils/* event */.B)(analytics_types/* AnalyticsEvents.GA4_CustomEvent */._q.GA4_CustomEvent, {
        event_name: event_name,
        event_params: (0,analytics_utils/* removeNullUndefined */.iK)({
            user_action: user_action,
            nav_path: nav_path
        })
    });
};
var footerNavigationEvent = function(param) {
    var parentNavigation = param.parentNavigation, _linkClicked = param.linkClicked, linkClicked = _linkClicked === void 0 ? "" : _linkClicked;
    (0,analytics_utils/* event */.B)(analytics_types/* AnalyticsEvents.FOOTER_LINK_CLICKED */._q.FOOTER_LINK_CLICKED, {
        parentNavigation: parentNavigation,
        linkClicked: linkClicked
    });
    navigationEvent({
        event_name: analytics_types/* AnalyticsEvents.NAVIGATION_CLICK */._q.NAVIGATION_CLICK,
        user_action: "footer",
        nav_path: parentNavigation.toLocaleLowerCase()
    });
};
var headerNavigationClickEvent = function(param) {
    var link = param.link;
    if (link === null || link === void 0 ? void 0 : link.href) {
        var parts = categoryUrlToParts(link.href);
        navigationEvent({
            event_name: analytics_types/* AnalyticsEvents.NAVIGATION_CLICK */._q.NAVIGATION_CLICK,
            user_action: "header",
            nav_path: categoryPartsToParentNavigationClick(parts).toLowerCase()
        });
    }
};
var iconHeaderNavigationClickEvent = function(icon) {
    return navigationEvent({
        event_name: analytics_types/* AnalyticsEvents.NAVIGATION_CLICK */._q.NAVIGATION_CLICK,
        user_action: "header",
        nav_path: "Icon:".concat(icon).toLowerCase()
    });
};
var footerNavigationClickEvent = function(nav_path) {
    navigationEvent({
        event_name: analytics_types/* AnalyticsEvents.NAVIGATION_CLICK */._q.NAVIGATION_CLICK,
        user_action: "footer",
        nav_path: nav_path.toLowerCase()
    });
};
/*
 *  header navigation
 */ var categoryUrlToParts = function(url) {
    return(// '/women/clothing/plus-size' => ['Women', 'Clothing', 'Plus Sizes']
    url.split("/").filter(Boolean) // remove any empty string parts (first one caused by leading slash)
    .map(function(x) {
        return (0,capitalize/* capitalize */.k)(x.replace(/-/g, " "));
    }));
}; // remove dashes from and capitalize words in each part
var categoryPartsToParentNavigation = function(parts) {
    // '/men' => 'Shop:Men' (level 1) or '/men/shoes/suede' => 'Shop:Men:Shoes' (level 2+)
    if (parts.length > 1) {
        parts = parts.slice(0, -1); // remove the last part for categories greater than level 1 for reporting purposes
    }
    var reportingPrefix = "Shop";
    return [
        reportingPrefix
    ].concat((0,_to_consumable_array/* default */.Z)(parts)).join(":");
};
var categoryPartsToParentNavigationClick = function(parts) {
    var reportingPrefix = "Shop";
    return [
        reportingPrefix
    ].concat((0,_to_consumable_array/* default */.Z)(parts)).join(":");
};
var headerNavigationEvent = function(param) {
    var parentNavigation = param.parentNavigation, _linkClicked = param.linkClicked, linkClicked = _linkClicked === void 0 ? "" : _linkClicked;
    (0,analytics_utils/* event */.B)(analytics_types/* AnalyticsEvents.HEADER_LINK_CLICKED */._q.HEADER_LINK_CLICKED, {
        parentNavigation: parentNavigation,
        linkClicked: linkClicked
    });
};
var categoryHeaderNavigationEvent = function(param) {
    var link = param.link;
    if (link === null || link === void 0 ? void 0 : link.href) {
        var parts = categoryUrlToParts(link.href);
        headerNavigationEvent({
            parentNavigation: categoryPartsToParentNavigation(parts),
            linkClicked: parts[parts.length - 1]
        });
    }
};
var iconHeaderNavigationEvent = function(icon) {
    return headerNavigationEvent({
        parentNavigation: "Icon:".concat(icon),
        linkClicked: icon
    });
};
var mobileMenuOpenEvent = function() {
    return (0,analytics_utils/* event */.B)(analytics_types/* AnalyticsEvents.GA4_CustomEvent */._q.GA4_CustomEvent, {
        event_name: analytics_types/* AnalyticsEvents.MENU_OPEN */._q.MENU_OPEN
    });
};

// EXTERNAL MODULE: ./utils/analytics/analytics-utils.ts
var analytics_utils = __webpack_require__(67977);
// EXTERNAL MODULE: ./utils/getMinimalNumber.ts
var getMinimalNumber = __webpack_require__(23295);
// EXTERNAL MODULE: ./utils/analytics/analytics-pdp.ts + 1 modules
var analytics_pdp = __webpack_require__(46659);
;// CONCATENATED MODULE: ./utils/analytics/analytics-myAccount.ts




var myAccountGeneralEvent = function(param) {
    var userAction = param.userAction;
    return (0,analytics_utils/* event */.B)(analytics_types/* AnalyticsEvents.GA4_CustomEvent */._q.GA4_CustomEvent, {
        event_name: analytics_types/* AnalyticsEvents.ACCOUNT_GENERAL */._q.ACCOUNT_GENERAL,
        event_params: {
            user_action: userAction
        }
    });
};
var myAccountCardEvents = function(params) {
    (0,analytics_utils/* event */.B)(analytics_types/* AnalyticsEvents.GA4_CustomEvent */._q.GA4_CustomEvent, {
        event_name: analytics_types/* AnalyticsEvents.MY_ACCOUNT_CARD */._q.MY_ACCOUNT_CARD,
        event_params: (0,analytics_utils/* removeNullUndefined */.iK)(params)
    });
};
var myAccountLoyaltyCardEvent = function() {
    return (0,analytics_utils/* event */.B)(analytics_types/* AnalyticsEvents.GA4_CustomEvent */._q.GA4_CustomEvent, {
        event_name: analytics_types/* AnalyticsEvents.ACCOUNT_LOYALTY_CARD */._q.ACCOUNT_LOYALTY_CARD,
        user_action: "click loyalty card"
    });
};
var addToWishListEvent = function(currency, wishListItem, quantity, imageType, imageNumber) {
    var ref, ref1;
    var productPrice = (ref = wishListItem.product) === null || ref === void 0 ? void 0 : ref.productPrice;
    var price = productPrice ? (0,getMinimalNumber/* getMinimalNumber */.q)(productPrice.price, productPrice.promotionPrice, productPrice.salePrice) : undefined;
    var value = (quantity !== null && quantity !== void 0 ? quantity : 0) * (price !== null && price !== void 0 ? price : 0);
    var product = wishListItem.product;
    var size = product === null || product === void 0 ? void 0 : (ref1 = product.size) === null || ref1 === void 0 ? void 0 : ref1.label;
    var item = (0,analytics_pdp/* transformListProductToAnalyticsItem */.pD)({
        product: product,
        currency: currency,
        quantity: quantity !== null && quantity !== void 0 ? quantity : 0,
        categories: {
            item_category: product === null || product === void 0 ? void 0 : product.primaryCategoryId
        },
        size: size,
        index: undefined,
        itemId: product.styleNumber
    });
    (0,analytics_utils/* event */.B)(analytics_types/* AnalyticsEvents.GA4EC_AddItemToWishlist */._q.GA4EC_AddItemToWishlist, {
        event_name: analytics_types/* AnalyticsEvents.ADD_TO_WISHLIST */._q.ADD_TO_WISHLIST,
        ecommerce: {
            currency: currency,
            value: Number(value.toFixed(2)),
            item_id_ep: product.styleNumber,
            item_name_ep: product.name,
            image_type: imageType,
            image_number: imageNumber,
            items: [
                item
            ]
        }
    });
    (0,analytics_utils/* event */.B)(analytics_types/* AnalyticsEvents.GA4_CustomEvent */._q.GA4_CustomEvent, {
        event_name: analytics_types/* AnalyticsEvents.GA4EC_Stylitics */._q.GA4EC_Stylitics,
        event_params: {
            user_action: analytics_types/* AnalyticsEvents.GA4_ADD_TO_WISHLIST */._q.GA4_ADD_TO_WISHLIST,
            item_id_ep: product.styleNumber,
            item_name_ep: product.name,
            stylitics_outfit_id: undefined,
            stylitics_product_id: product.styleNumber
        }
    });
};
var myAccountAmbassadorEvent = function(params) {
    return (0,analytics_utils/* event */.B)(analytics_types/* AnalyticsEvents.GA4_CustomEvent */._q.GA4_CustomEvent, {
        event_name: analytics_types/* AnalyticsEvents.ACCOUNT_AMBASSADOR */._q.ACCOUNT_AMBASSADOR,
        event_params: (0,analytics_utils/* removeNullUndefined */.iK)(params)
    });
};
var myAccountOverviewEvent = function(param) {
    var userAction = param.userAction;
    return (0,analytics_utils/* event */.B)(analytics_types/* AnalyticsEvents.GA4_CustomEvent */._q.GA4_CustomEvent, {
        event_name: analytics_types/* AnalyticsEvents.ACCOUNT_OVERVIEW */._q.ACCOUNT_OVERVIEW,
        event_params: {
            user_action: userAction
        }
    });
};
var myAccountUserSettingsEvent = function(param) {
    var userAction = param.userAction, section = param.section;
    return (0,analytics_utils/* event */.B)(analytics_types/* AnalyticsEvents.GA4_CustomEvent */._q.GA4_CustomEvent, {
        event_name: analytics_types/* AnalyticsEvents.ACCOUNT_SETTINGS */._q.ACCOUNT_SETTINGS,
        event_params: {
            user_action: userAction,
            section: section
        }
    });
};

// EXTERNAL MODULE: ./types/analyticTypes.ts
var analyticTypes = __webpack_require__(90099);
// EXTERNAL MODULE: ./utils/analytics/hashEmail.ts
var hashEmail = __webpack_require__(91990);
;// CONCATENATED MODULE: ./utils/analytics/analytics-login.ts




var emailSignUpEvent = function(action, location) {
    if (!location) return;
    (0,analytics_utils/* event */.B)(analytics_types/* AnalyticsEvents.EMAIL_SIGNUP */._q.EMAIL_SIGNUP, {
        emailAction: action,
        signUpLocation: analyticTypes/* EmailSignUpLocations */.n_[location]
    });
};
var signUpFormAnalyticsEvent = function(param) {
    var identifier = param.identifier, action = param.action, location = param.location;
    if (!location) return;
    var signUpLocation = analyticTypes/* SignUpLocations */.fD[location];
    switch(identifier || analyticTypes/* SignUpFormAnalyticsIdentifiers.EMAIL_SIGNUP */.Ty.EMAIL_SIGNUP){
        case analyticTypes/* SignUpFormAnalyticsIdentifiers.SMS_OPT_IN */.Ty.SMS_OPT_IN:
            {
                (0,analytics_utils/* event */.B)(analytics_types/* AnalyticsEvents.SMS_OPT_IN */._q.SMS_OPT_IN, {
                    smsAction: "sms ".concat(action),
                    signUpLocation: signUpLocation
                });
                break;
            }
        case analyticTypes/* SignUpFormAnalyticsIdentifiers.EMAIL_SIGNUP */.Ty.EMAIL_SIGNUP:
            {
                (0,analytics_utils/* event */.B)(analytics_types/* AnalyticsEvents.EMAIL_SIGNUP */._q.EMAIL_SIGNUP, {
                    emailAction: "email ".concat(action),
                    signUpLocation: signUpLocation
                });
                break;
            }
        default:
            // eslint-disable-next-line no-console
            console.warn("Unhandled Sign Up Form Identifier: ".concat(identifier));
    }
};
var logoutEvent = function(customerEmail, customerId, method) {
    (0,analytics_utils/* event */.B)(analytics_types/* AnalyticsEvents.GA4_CustomEvent */._q.GA4_CustomEvent, {
        event_name: analytics_types/* AnalyticsEvents.LOGOUT */._q.LOGOUT,
        event_params: {
            method: method,
            is_guest: "true",
            hashed_email: (0,hashEmail/* hashEmail */.g)(customerEmail),
            custom_user_id: customerId
        }
    });
};
var loginEvent = function(url, hashedEmail, customUserId) {
    (0,analytics_utils/* event */.B)(analytics_types/* AnalyticsEvents.GA4_CustomEvent */._q.GA4_CustomEvent, {
        event_name: analytics_types/* AnalyticsEvents.LOGIN */._q.LOGIN,
        event_params: {
            method: (0,analytics_utils/* getPageType */.C2)(url),
            is_guest: "false",
            hashed_email: (0,hashEmail/* hashEmail */.g)(hashedEmail),
            custom_user_id: customUserId
        }
    });
};

// EXTERNAL MODULE: ./utils/analytics/analytics-checkout.ts
var analytics_checkout = __webpack_require__(31285);
// EXTERNAL MODULE: ./utils/analytics/analytics-cart.ts
var analytics_cart = __webpack_require__(74968);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(85034);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(70169);
;// CONCATENATED MODULE: ./utils/analytics/analytics-plp.ts






var handleIntersectionPLP = function(param) {
    var productId = param.productId, intersectedProductsRef = param.intersectedProductsRef, intersectAllProductsRef = param.intersectAllProductsRef, listProducts = param.listProducts, screenSize = param.screenSize, currency = param.currency, offset = param.offset, pageviewEventHasFired = param.pageviewEventHasFired, currentCategory = param.currentCategory, searchTerm = param.searchTerm, promotion = param.promotion;
    var productFinder = intersectedProductsRef.current.some(function(obj) {
        var ref;
        return (obj === null || obj === void 0 ? void 0 : (ref = obj.variantProduct) === null || ref === void 0 ? void 0 : ref.id) === productId;
    });
    var productFinderAux = intersectAllProductsRef.current.some(function(obj) {
        var ref;
        return (obj === null || obj === void 0 ? void 0 : (ref = obj.variantProduct) === null || ref === void 0 ? void 0 : ref.id) === productId;
    });
    if (productFinder || productFinderAux) return;
    var idx = -1;
    var filterProductsById = listProducts === null || listProducts === void 0 ? void 0 : listProducts.find(function(p, i) {
        var ref;
        if (productId === (p === null || p === void 0 ? void 0 : (ref = p.variantProduct) === null || ref === void 0 ? void 0 : ref.id)) {
            idx = i;
            return true;
        }
        return false;
    });
    if (filterProductsById) {
        intersectedProductsRef.current = (0,_to_consumable_array/* default */.Z)(intersectedProductsRef.current).concat([
            (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, filterProductsById), {
                idx: idx
            }), 
        ]);
        intersectAllProductsRef.current = (0,_to_consumable_array/* default */.Z)(intersectAllProductsRef.current).concat([
            (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, filterProductsById), {
                idx: idx
            }), 
        ]);
    } else {
        if (productId === "positioned-promo-tile") {
            var objectPromoTile = {
                id: productId,
                variantProduct: {
                    id: productId
                }
            };
            intersectedProductsRef.current = (0,_to_consumable_array/* default */.Z)(intersectedProductsRef.current).concat([
                objectPromoTile, 
            ]);
            intersectAllProductsRef.current = (0,_to_consumable_array/* default */.Z)(intersectAllProductsRef.current).concat([
                objectPromoTile, 
            ]);
        }
    }
    if (intersectedProductsRef.current.length === screenSize || intersectedProductsRef.current.length === listProducts.length) {
        var ref;
        var filterIntersectedProductsRef = (ref = intersectedProductsRef.current) === null || ref === void 0 ? void 0 : ref.filter(function(product) {
            return product.id !== "positioned-promo-tile";
        });
        var listItemsGa4Emplifi = filterIntersectedProductsRef.map(function(p) {
            var ref, ref1, ref2, ref3;
            var product = p;
            var ref4;
            return {
                user_action: "rating_impression",
                item_id_ep: (ref = product.variantProduct) === null || ref === void 0 ? void 0 : ref.id,
                item_name_ep: (ref4 = (ref1 = product.variantProduct) === null || ref1 === void 0 ? void 0 : ref1.name) !== null && ref4 !== void 0 ? ref4 : "",
                review_count: (ref2 = product.masterProduct) === null || ref2 === void 0 ? void 0 : ref2.amountOfReviews,
                avg_rating: (ref3 = product.masterProduct) === null || ref3 === void 0 ? void 0 : ref3.averageRating
            };
        });
        var listItems = filterIntersectedProductsRef.map(function(product) {
            return (0,analytics_pdp/* transformListProductToAnalyticsItem */.pD)((0,_object_spread/* default */.Z)({
                product: product.variantProduct,
                currency: currency.code,
                quantity: 1,
                itemListId: searchTerm ? searchTerm : currentCategory === null || currentCategory === void 0 ? void 0 : currentCategory.id,
                itemListName: searchTerm ? searchTerm : currentCategory === null || currentCategory === void 0 ? void 0 : currentCategory.name,
                index: offset + product["idx"],
                categories: {
                    // NOTE: send `item_category` anyway but with undefined value
                    item_category: undefined
                }
            }, promotion && (0,_object_spread/* default */.Z)({}, promotion)));
        });
        if (pageviewEventHasFired) {
            (0,analytics_utils/* event */.B)(analytics_types/* AnalyticsEvents.GA4EC_ItemListView */._q.GA4EC_ItemListView, {
                event_name: analytics_types/* AnalyticsEvents.VIEW_ITEM_LIST */._q.VIEW_ITEM_LIST,
                ecommerce: {
                    item_list_id: searchTerm ? searchTerm : currentCategory === null || currentCategory === void 0 ? void 0 : currentCategory.id,
                    item_list_name: searchTerm ? searchTerm : currentCategory === null || currentCategory === void 0 ? void 0 : currentCategory.name,
                    // NOTE:  "item_id_ep" & "item_name_ep" send with data
                    //        only on PDP, in PLP send with "undefined" value
                    item_id_ep: undefined,
                    item_name_ep: undefined,
                    items: listItems
                }
            });
            (0,analytics_utils/* event */.B)(analytics_types/* AnalyticsEvents.GA4_CustomEvent */._q.GA4_CustomEvent, {
                event_name: analytics_types/* AnalyticsEvents.PLP_RATING_IMPRESSION */._q.PLP_RATING_IMPRESSION,
                ecommerce: {
                    item_list_id: searchTerm ? searchTerm : currentCategory === null || currentCategory === void 0 ? void 0 : currentCategory.id,
                    item_list_name: searchTerm ? searchTerm : currentCategory === null || currentCategory === void 0 ? void 0 : currentCategory.name,
                    // NOTE:  "item_id_ep" & "item_name_ep" send with data
                    //        only on PDP, in PLP send with "undefined" value
                    item_id_ep: undefined,
                    item_name_ep: undefined,
                    items: listItemsGa4Emplifi
                }
            });
        }
        intersectedProductsRef.current = [];
        listItemsGa4Emplifi = [];
    }
};

// EXTERNAL MODULE: ./utils/string.ts
var string = __webpack_require__(12874);
;// CONCATENATED MODULE: ./utils/analytics/analytics-order.ts

var getOrderConfirmationFitAnalyticsData = function(products) {
    return {
        products: products.filter(function(cartItem) {
            return cartItem.__typename === "ProductCartItem";
        }).map(function(cartItem) {
            var productCartItem;
            if (cartItem.__typename === "ProductCartItem" && cartItem.product.__typename) {
                productCartItem = cartItem.product;
            } else {
                return cartItem;
            }
            var _upc, _ean;
            return {
                purchasedSize: productCartItem.size.label,
                shopArticleCode: (_upc = productCartItem.upc) !== null && _upc !== void 0 ? _upc : "",
                productId: productCartItem.styleNumber,
                price: cartItem.inCartPrice,
                quantity: cartItem.quantity,
                ean: (_ean = productCartItem.ean) !== null && _ean !== void 0 ? _ean : ""
            };
        })
    };
};
var getUserOrderInformation = function(order) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16;
    return {
        order_email: (0,string/* lowerCaseOrBlank */.Ms)(order === null || order === void 0 ? void 0 : (ref = order.customer) === null || ref === void 0 ? void 0 : ref.email),
        phone_number: (0,string/* lowerCaseOrBlank */.Ms)(order === null || order === void 0 ? void 0 : (ref1 = order.shipment) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.address) === null || ref2 === void 0 ? void 0 : ref2.phone),
        address_fname: (0,string/* lowerCaseRemoveSpecialChars */.Df)(order === null || order === void 0 ? void 0 : (ref3 = order.shipment) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.address) === null || ref4 === void 0 ? void 0 : ref4.firstName),
        address_lname: (0,string/* lowerCaseRemoveSpecialChars */.Df)(order === null || order === void 0 ? void 0 : (ref5 = order.shipment) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.address) === null || ref6 === void 0 ? void 0 : ref6.lastName),
        address_street: (0,string/* lowerCaseRemoveSpecialChars */.Df)(order === null || order === void 0 ? void 0 : (ref7 = order.shipment) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.address) === null || ref8 === void 0 ? void 0 : ref8.address1),
        address_state: (0,string/* lowerCaseRemoveSpecialChars */.Df)(order === null || order === void 0 ? void 0 : (ref9 = order.shipment) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.address) === null || ref10 === void 0 ? void 0 : ref10.stateCode),
        address_postal: (0,string/* lowerCaseRemoveSpecialChars */.Df)(order === null || order === void 0 ? void 0 : (ref11 = order.shipment) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.address) === null || ref12 === void 0 ? void 0 : ref12.postalCode),
        address_city: (0,string/* lowerCaseRemoveSpecialChars */.Df)(order === null || order === void 0 ? void 0 : (ref13 = order.shipment) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.address) === null || ref14 === void 0 ? void 0 : ref14.city),
        address_country: order === null || order === void 0 ? void 0 : (ref15 = order.shipment) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.address) === null || ref16 === void 0 ? void 0 : ref16.countryCode
    };
};

;// CONCATENATED MODULE: ./utils/analytics/analytics-homePage.ts



var searchAnalyticsEvent = function(resultsNumber, isPDP) {
    var ref, ref1;
    var keys = [
        "search_type",
        "search_term",
        "suggested_section_click",
        "suggested_element_click",
        "user_action", 
    ];
    var sessionValues = keys.map(function(key) {
        return window.sessionStorage.getItem(key);
    });
    var ref2, ref3, ref4;
    var eventParams = {
        search_type: (ref2 = sessionValues[0]) !== null && ref2 !== void 0 ? ref2 : undefined,
        search_term: (ref3 = sessionValues[1]) !== null && ref3 !== void 0 ? ref3 : undefined,
        results_number: !isPDP ? resultsNumber : undefined,
        suggested_section_click: (ref = sessionValues[2]) === null || ref === void 0 ? void 0 : ref.toLowerCase(),
        suggested_element_click: (ref1 = sessionValues[3]) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase(),
        user_action: (ref4 = sessionValues[4]) !== null && ref4 !== void 0 ? ref4 : undefined
    };
    (0,analytics_utils/* event */.B)(analytics_types/* AnalyticsEvents.GA4_CustomEvent */._q.GA4_CustomEvent, {
        event_name: analytics_types/* AnalyticsEvents.SEARCH */._q.SEARCH,
        event_params: eventParams
    });
    keys.forEach(function(key) {
        return window.sessionStorage.removeItem(key);
    });
};
var handleIntersectionCarousel = function(param) {
    var productId = param.productId, intersectedProductsRef = param.intersectedProductsRef, intersectAllProductsRef = param.intersectAllProductsRef, screenSizeCarousel = param.screenSizeCarousel, itemListId = param.itemListId, itemListName = param.itemListName, itemEpId = param.itemEpId, itemEpName = param.itemEpName, listProducts = param.listProducts, pageviewEventHasFired = param.pageviewEventHasFired, countProductsTriggeredRef = param.countProductsTriggeredRef;
    var productFinder = intersectedProductsRef.current.some(function(obj) {
        return (obj === null || obj === void 0 ? void 0 : obj.item_id) === productId;
    });
    var productFinderAux = intersectAllProductsRef.current.some(function(obj) {
        return (obj === null || obj === void 0 ? void 0 : obj.item_id) === productId;
    });
    if (productFinder || productFinderAux || listProducts.length <= 0) return;
    var filterProductsById = listProducts === null || listProducts === void 0 ? void 0 : listProducts.find(function(product) {
        return productId === (product === null || product === void 0 ? void 0 : product.item_id);
    });
    if (filterProductsById) {
        intersectedProductsRef.current = (0,_to_consumable_array/* default */.Z)(intersectedProductsRef.current).concat([
            filterProductsById, 
        ]);
        intersectAllProductsRef.current = (0,_to_consumable_array/* default */.Z)(intersectAllProductsRef.current).concat([
            filterProductsById, 
        ]);
    }
    var itemsLeft = listProducts.length - countProductsTriggeredRef.current;
    var isLastBatch = intersectAllProductsRef.current.length === listProducts.length && itemsLeft < screenSizeCarousel;
    if (intersectedProductsRef.current.length === screenSizeCarousel || isLastBatch) {
        if (pageviewEventHasFired) {
            (0,analytics_utils/* event */.B)(analytics_types/* AnalyticsEvents.GA4EC_ItemListView */._q.GA4EC_ItemListView, {
                event_name: analytics_types/* AnalyticsEvents.VIEW_ITEM_LIST */._q.VIEW_ITEM_LIST,
                ecommerce: {
                    item_list_id: itemListId,
                    item_list_name: itemListName,
                    item_id_ep: itemEpId,
                    item_name_ep: itemEpName,
                    items: intersectedProductsRef.current
                }
            });
        }
        intersectedProductsRef.current = [];
        countProductsTriggeredRef.current += screenSizeCarousel;
        isLastBatch = false;
    }
};

;// CONCATENATED MODULE: ./utils/analytics/index.ts













/***/ }),

/***/ 54225:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ authEventEmitter; }
/* harmony export */ });
/* harmony import */ var mitt__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(76844);

var authEventEmitter = (0,mitt__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();


/***/ }),

/***/ 61060:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Nh": function() { return /* binding */ trackSuggestEventInBloomreach; },
/* harmony export */   "Xq": function() { return /* binding */ trackSearchEventInBloomreach; },
/* harmony export */   "_E": function() { return /* binding */ trackAddToCartInBloomreach; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17599);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85034);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79758);



var _obj;
var CATALOGS_BY_COUNTRY_CODE = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, _constants__WEBPACK_IMPORTED_MODULE_0__/* .SUPPORTED_COUNTRY.US */ .bM.US, [
    {
        name: "puma-master-na"
    },
    {
        name: "puma-catalog-autocat-na"
    }, 
]), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, _constants__WEBPACK_IMPORTED_MODULE_0__/* .SUPPORTED_COUNTRY.CA */ .bM.CA, [
    {
        name: "puma-master-na"
    },
    {
        name: "puma-catalog-autocat-ca"
    }, 
]), _obj);
var getCatalogsByCountryCode = function(countryCode) {
    return CATALOGS_BY_COUNTRY_CODE[countryCode.toUpperCase()] || [];
};
var segmentDataIfValid = function(visitorCountryCode) {
    return visitorCountryCode ? {
        segment: "customer_country:".concat(visitorCountryCode.toUpperCase())
    } : {};
};
var trackAddToCartInBloomreach = function(param) {
    var productId = param.productId, sku = param.sku, currency = param.currency;
    var regionCurrencyHandler = window.location.href;
    if (!window.BrTrk) return;
    if (regionCurrencyHandler.includes("/au/en") || regionCurrencyHandler.includes("/nz/en")) {
        window.BrTrk.getTracker().logEvent("cart", "click-add", {
            prod_id: productId,
            sku: sku,
            currency: currency
        });
    } else {
        window.BrTrk.getTracker().logEvent("cart", "click-add", {
            prod_id: productId,
            sku: sku
        });
    }
};
var trackSearchEventInBloomreach = function(param) {
    var query = param.query, siteCountryCode = param.siteCountryCode, visitorCountryCode = param.visitorCountryCode;
    if (!window.BrTrk) return;
    window.BrTrk.getTracker().logEvent("suggest", "submit", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        q: query,
        catalogs: JSON.stringify(getCatalogsByCountryCode(siteCountryCode))
    }, segmentDataIfValid(visitorCountryCode)), {}, true);
};
var trackSuggestEventInBloomreach = function(param) {
    var query = param.query, suggestion = param.suggestion, siteCountryCode = param.siteCountryCode, visitorCountryCode = param.visitorCountryCode;
    if (!window.BrTrk) return;
    window.BrTrk.getTracker().logEvent("suggest", "click", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        q: suggestion,
        aq: query,
        catalogs: JSON.stringify(getCatalogsByCountryCode(siteCountryCode))
    }, segmentDataIfValid(visitorCountryCode)), {}, true);
};


/***/ }),

/***/ 69377:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ buildProductUrl; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5341);
/* harmony import */ var _encodeProductNameForUri__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90192);


/**
 * This function builds a PDP url based on the given `masterId` and `productName`.
 * It also accepts an optional `params` object which will be converted to a query string.
 * Note: 'color' will be replaced with 'swatch' in the query string.
 *
 * @example
 * buildProductUrl('123456', 'My Product');
 * // returns '/pd/my-product/123456'
 * @example
 * buildProductUrl('123456', 'My Product', { swatch: '75', size: '0120' });
 * // returns '/pd/my-product/123456?swatch=75&size=0120'
 * @example
 * buildProductUrl('123456', 'My Product', { color: '75' });
 * // returns '/pd/my-product/123456?swatch=75'
 * @example
 * buildProductUrl('123456', 'My Product', { search: true });
 * // returns '/pd/my-product/123456?search=true'
 */ var buildProductUrl = function(masterId, productName, params) {
    var disableEncodingCharacters = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var url = "/pd/".concat((0,_encodeProductNameForUri__WEBPACK_IMPORTED_MODULE_0__/* .encodeProductNameForUri */ .o)(productName, disableEncodingCharacters), "/").concat(masterId);
    if (!params) return url;
    var queryString = Object.entries(params).filter(function(param) {
        var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(param, 2), _ = _param[0], value = _param[1];
        return value !== "";
    }).map(function(param) {
        var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(param, 2), key = _param[0], value = _param[1];
        if (key === "color") key = "swatch";
        return "".concat(key, "=").concat(encodeURIComponent(value));
    }).join("&");
    return queryString ? "".concat(url, "?").concat(queryString) : url;
};


/***/ }),

/***/ 883:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ calculateDiscountPercent; }
/* harmony export */ });
var calculateDiscountPercent = function(price, activePrice) {
    // Calculate percentage and convert to fixed point notation to avoid floating point errors
    var percentageString = ((1 - activePrice / price) * 100).toFixed(1);
    // Convert string back into number so we can floor it
    var percentageNumber = parseInt(percentageString, 10);
    // Floor the value to prevent any point percentages
    return Math.floor(percentageNumber);
};


/***/ }),

/***/ 59308:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ capitalize; }
/* harmony export */ });
var capitalize = function(string) {
    return typeof string === "string" ? string.split(" ").map(function(shard) {
        return shard.charAt(0).toUpperCase() + shard.slice(1);
    }).join(" ") : "";
};


/***/ }),

/***/ 50222:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ clientLogger; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23842);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31373);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59312);



/**
 * Client Side Logging Utilities
 * Client Side NextJS requires a logger based on
 * browser console to avoid importing pino to the browser bundle
 */ var clientLogger = {
    info: function info(data, message) {
        log("info", data, message);
    },
    warn: function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(data, message) {
            var Sentry, _tmp;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            __webpack_require__.e(/* import() */ 5151).then(__webpack_require__.bind(__webpack_require__, 35151))
                        ];
                    case 1:
                        Sentry = _state.sent();
                        log("warn", data, message);
                        _tmp = {};
                        Sentry.captureMessage(message, (_tmp.tags = data, _tmp));
                        return [
                            2
                        ];
                }
            });
        });
        return function(data, message) {
            return _ref.apply(this, arguments);
        };
    }(),
    error: function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(data, message) {
            var Sentry, _tmp, err, tags, _tmp1;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            __webpack_require__.e(/* import() */ 5151).then(__webpack_require__.bind(__webpack_require__, 35151))
                        ];
                    case 1:
                        Sentry = _state.sent();
                        log("error", data, message);
                        _tmp = {};
                        Sentry.addBreadcrumb((_tmp.message = message, _tmp));
                        _tmp1 = {};
                        if (data === null || data === void 0 ? void 0 : data.err) {
                            err = data.err, tags = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(data, [
                                "err"
                            ]);
                            Sentry.captureException(err, (_tmp1.tags = tags, _tmp1));
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function(data, message) {
            return _ref.apply(this, arguments);
        };
    }()
};
function log(level, data, message) {
    // eslint-disable-next-line no-console
    var logFn = console[level] || console.info;
    if (logFn) {
        logFn(message, data);
    }
}


/***/ }),

/***/ 79758:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BG": function() { return /* binding */ CART_ERROR; },
/* harmony export */   "Ei": function() { return /* binding */ REFERRER_TYPE_VAL; },
/* harmony export */   "F": function() { return /* binding */ SCROLL_GA4_EVENT_PERCENTAGE_STRING; },
/* harmony export */   "Ff": function() { return /* binding */ GUAM; },
/* harmony export */   "Gl": function() { return /* binding */ VIDEO_GA4_EVENT_PERCENTAGES; },
/* harmony export */   "N5": function() { return /* binding */ SUPPORTED_PAYMENT_TYPES; },
/* harmony export */   "Od": function() { return /* binding */ UNITED_STATES_TERRITORY; },
/* harmony export */   "QH": function() { return /* binding */ CRAWLERS; },
/* harmony export */   "QJ": function() { return /* binding */ PaymentMethodsGA4Analytics; },
/* harmony export */   "QU": function() { return /* binding */ CARD_TYPES; },
/* harmony export */   "Qn": function() { return /* binding */ ELEVATED_PDP_TYPES; },
/* harmony export */   "S7": function() { return /* binding */ FITANALYTICS_IS_LOADED_INDICATOR; },
/* harmony export */   "Su": function() { return /* binding */ ONE_TRUST_CONSENT_UPDATED; },
/* harmony export */   "Tp": function() { return /* binding */ PaymentMethodExtra; },
/* harmony export */   "X9": function() { return /* binding */ PAYMENT_METHOD_SESSION_STORAGE_ENTRY; },
/* harmony export */   "XL": function() { return /* binding */ PaymentMethod; },
/* harmony export */   "YC": function() { return /* binding */ FITANALYTICS_FIT_FINDER_PLACEMENT; },
/* harmony export */   "Zp": function() { return /* binding */ SCROLL_GA4_EVENT_PERCENTAGES; },
/* harmony export */   "au": function() { return /* binding */ VIDEO_GA4_EVENT_PERCENTAGE_STRING; },
/* harmony export */   "bM": function() { return /* binding */ SUPPORTED_COUNTRY; },
/* harmony export */   "cU": function() { return /* binding */ BASKET_STOCK_STATUS; },
/* harmony export */   "cj": function() { return /* binding */ REFERRER_TYPE; },
/* harmony export */   "dp": function() { return /* binding */ OpluxFraudDetectionMethod; },
/* harmony export */   "hG": function() { return /* binding */ noIndexParams; },
/* harmony export */   "ho": function() { return /* binding */ MaxAgeExpiration; },
/* harmony export */   "lF": function() { return /* binding */ SUPPORTED_LANGUAGE; },
/* harmony export */   "mV": function() { return /* binding */ SHIPPING_LOOKUP_CONSTRAINTS; },
/* harmony export */   "no": function() { return /* binding */ SLOT_LINK_TYPE; },
/* harmony export */   "o0": function() { return /* binding */ BILLING_LOOKUP_CONSTRAINTS; },
/* harmony export */   "p5": function() { return /* binding */ COOKIE_BANNER_ACKNOWLEDGED_EVENT_NAME; },
/* harmony export */   "qh": function() { return /* binding */ REFERRER_CATEGORY; },
/* harmony export */   "sk": function() { return /* binding */ isServer; },
/* harmony export */   "xM": function() { return /* binding */ SUPPORTED_LOCALE; },
/* harmony export */   "yN": function() { return /* binding */ UNITED_STATES_ARMED_FORCES; }
/* harmony export */ });
/* unused harmony exports noop, EU_SHIPPING_COUNTRIES_OPTIONS, MAX_DAYS_FOR_RETURN, WORD_COUNT_FOR_TEXT_CUT, ConstantsSessionStorage */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17599);

var PaymentMethod;
(function(PaymentMethod) {
    PaymentMethod["ADYEN_COMPONENT"] = "AdyenComponent";
    PaymentMethod["ADYEN_PAYPAL"] = "paypal";
    PaymentMethod["AFTERPAY"] = "AFTERPAY_PBI";
    PaymentMethod["AMAZON_PAY"] = "AMAZON_PAY";
    PaymentMethod["AMAZON_PAY_V2"] = "AMAZON_PAY_V2";
    PaymentMethod["AMBASSADOR_CARD"] = "AMBCARD";
    PaymentMethod["APPLE_PAY"] = "DW_APPLE_PAY";
    PaymentMethod["COD"] = "COD";
    PaymentMethod["CREDIT_CARD"] = "CREDIT_CARD";
    PaymentMethod["GIFT_CARD"] = "GIFT_CARD";
    PaymentMethod["GOOGLE_PAY"] = "DW_GOOGLE_PAY";
    PaymentMethod["KLARNA"] = "klarna";
    PaymentMethod["KLARNA_ACCOUNT"] = "klarna_account";
    PaymentMethod["KLARNA_PAYMENTS"] = "KLARNA_PAYMENTS";
    PaymentMethod["NET_BANKING_DEPRECATED"] = "billdesk_online";
    PaymentMethod["ONLINE_BANKING_IN"] = "onlinebanking_IN";
    PaymentMethod["PAY_PAY"] = "PAY_PAY";
    PaymentMethod["PAYPAL"] = "PayPal";
    PaymentMethod["PAYTM"] = "paytm";
    PaymentMethod["SCHEME"] = "scheme";
    PaymentMethod["STORE_CREDIT"] = "GIFT_CERTIFICATE";
    PaymentMethod["UPI"] = "billdesk_upi";
    PaymentMethod["UPI_COLLECT"] = "upi_collect";
    PaymentMethod["WALLET"] = "billdesk_wallet";
    PaymentMethod["ZIP_PAY"] = "zip";
    PaymentMethod["WECHAT_PAY"] = "wechatpayWeb";
    PaymentMethod["AFTERPAY_TOUCH"] = "afterpaytouch";
    PaymentMethod["ALIPAY"] = "alipay";
    PaymentMethod["RAZORPAY"] = "RAZORPAY";
})(PaymentMethod || (PaymentMethod = {}));
var PaymentMethodExtra;
(function(PaymentMethodExtra) {
    PaymentMethodExtra["GIFT_CARD"] = "GIFT_CARD";
    PaymentMethodExtra["GMO"] = "GMO";
})(PaymentMethodExtra || (PaymentMethodExtra = {}));
var isServer = "object" === "undefined";
// eslint-disable-next-line @typescript-eslint/no-empty-function
var noop = function() {};
var SUPPORTED_LOCALE;
(function(SUPPORTED_LOCALE) {
    SUPPORTED_LOCALE["EN_AU"] = "en-AU";
    SUPPORTED_LOCALE["EN_CA"] = "en-CA";
    SUPPORTED_LOCALE["EN_GB"] = "en-GB";
    SUPPORTED_LOCALE["EN_IN"] = "en-IN";
    SUPPORTED_LOCALE["EN_US"] = "en-US";
    SUPPORTED_LOCALE["ES_US"] = "es-US";
    SUPPORTED_LOCALE["FR_CA"] = "fr-CA";
    SUPPORTED_LOCALE["JA_JP"] = "ja-JP";
    SUPPORTED_LOCALE[// eu migration
    "EN_BG"] = "en-BG";
    SUPPORTED_LOCALE["EN_LT"] = "en-LT";
})(SUPPORTED_LOCALE || (SUPPORTED_LOCALE = {}));
var SUPPORTED_LANGUAGE;
(function(SUPPORTED_LANGUAGE) {
    SUPPORTED_LANGUAGE["DE"] = "de";
    SUPPORTED_LANGUAGE["EN"] = "en";
    SUPPORTED_LANGUAGE["ES"] = "es";
    SUPPORTED_LANGUAGE["FR"] = "fr";
    SUPPORTED_LANGUAGE["JA"] = "ja";
})(SUPPORTED_LANGUAGE || (SUPPORTED_LANGUAGE = {}));
var SUPPORTED_COUNTRY;
(function(SUPPORTED_COUNTRY) {
    SUPPORTED_COUNTRY["AU"] = "AU";
    SUPPORTED_COUNTRY["CA"] = "CA";
    SUPPORTED_COUNTRY["GB"] = "GB";
    SUPPORTED_COUNTRY["IN"] = "IN";
    SUPPORTED_COUNTRY["JP"] = "JP";
    SUPPORTED_COUNTRY["US"] = "US";
    SUPPORTED_COUNTRY[// eu migration
    "BG"] = "BG";
    SUPPORTED_COUNTRY["LT"] = "LT";
})(SUPPORTED_COUNTRY || (SUPPORTED_COUNTRY = {}));
var UNITED_STATES_ARMED_FORCES;
(function(UNITED_STATES_ARMED_FORCES) {
    UNITED_STATES_ARMED_FORCES["AF"] = "AF";
    UNITED_STATES_ARMED_FORCES["AA"] = "AA";
    UNITED_STATES_ARMED_FORCES["AC"] = "AC";
    UNITED_STATES_ARMED_FORCES["AE"] = "AE";
    UNITED_STATES_ARMED_FORCES["AM"] = "AM";
    UNITED_STATES_ARMED_FORCES["AP"] = "AP";
})(UNITED_STATES_ARMED_FORCES || (UNITED_STATES_ARMED_FORCES = {}));
var UNITED_STATES_TERRITORY;
(function(UNITED_STATES_TERRITORY) {
    UNITED_STATES_TERRITORY["PR"] = "PR";
    UNITED_STATES_TERRITORY["GU"] = "GU";
    UNITED_STATES_TERRITORY["VI"] = "VI";
    UNITED_STATES_TERRITORY["MP"] = "MP";
    UNITED_STATES_TERRITORY["AS"] = "AS";
})(UNITED_STATES_TERRITORY || (UNITED_STATES_TERRITORY = {}));
var SUPPORTED_PAYMENT_TYPES;
(function(SUPPORTED_PAYMENT_TYPES) {
    SUPPORTED_PAYMENT_TYPES["AdyenKlarna"] = "Adyen Klarna";
    SUPPORTED_PAYMENT_TYPES["Afterpay"] = "Afterpay";
    SUPPORTED_PAYMENT_TYPES["AmazonPay"] = "Amazon Pay";
    SUPPORTED_PAYMENT_TYPES["AmbassadorCard"] = "Ambassador Card";
    SUPPORTED_PAYMENT_TYPES["CashOnDelivery"] = "Cash on Delivery";
    SUPPORTED_PAYMENT_TYPES["CreditCard"] = "Credit Card";
    SUPPORTED_PAYMENT_TYPES["GiftCard"] = "Gift Card";
    SUPPORTED_PAYMENT_TYPES["Klarna"] = "Klarna";
    SUPPORTED_PAYMENT_TYPES["OnlineBanking"] = "NetBanking";
    SUPPORTED_PAYMENT_TYPES["PayPal"] = "PayPal";
    SUPPORTED_PAYMENT_TYPES["PayPay"] = "PayPay";
    SUPPORTED_PAYMENT_TYPES["PayTM"] = "PayTM";
    SUPPORTED_PAYMENT_TYPES["UPI"] = "UPI";
    SUPPORTED_PAYMENT_TYPES["Wallet"] = "Wallet";
})(SUPPORTED_PAYMENT_TYPES || (SUPPORTED_PAYMENT_TYPES = {}));
var GUAM = "GU";
var EU_SHIPPING_COUNTRIES_OPTIONS = [
    {
        label: "Austria",
        value: "AT"
    },
    {
        label: "Belgium",
        value: "BE"
    },
    {
        label: "Bulgaria",
        value: "BG"
    },
    {
        label: "Croatia",
        value: "HR"
    },
    {
        label: "Czech Republic",
        value: "CZ"
    },
    {
        label: "Denmark",
        value: "DK"
    },
    {
        label: "Estonia",
        value: "EE"
    },
    {
        label: "Finland",
        value: "FI"
    },
    {
        label: "France",
        value: "FR"
    },
    {
        label: "Germany",
        value: "DE"
    },
    {
        label: "Greece",
        value: "GR"
    },
    {
        label: "Hungary",
        value: "HU"
    },
    {
        label: "Ireland",
        value: "IE"
    },
    {
        label: "Italy",
        value: "IT"
    },
    {
        label: "Latvia",
        value: "LV"
    },
    {
        label: "Luxembourg",
        value: "LU"
    },
    {
        label: "Lithuania",
        value: "LT"
    },
    {
        label: "Netherlands",
        value: "NL"
    },
    {
        label: "Norway",
        value: "NO"
    },
    {
        label: "Poland",
        value: "PL"
    },
    {
        label: "Portugal",
        value: "PT"
    },
    {
        label: "Romania",
        value: "RO"
    },
    {
        label: "Slovakia",
        value: "SK"
    },
    {
        label: "Slovenia",
        value: "SI"
    },
    {
        label: "Spain",
        value: "ES"
    },
    {
        label: "Sweden",
        value: "SE"
    },
    {
        label: "Switzerland",
        value: "CH"
    }, 
];
var SHIPPING_LOOKUP_CONSTRAINTS = {
    au: [
        SUPPORTED_COUNTRY.AU
    ],
    ca: [
        SUPPORTED_COUNTRY.CA
    ],
    gb: [
        SUPPORTED_COUNTRY.GB
    ],
    in: [
        SUPPORTED_COUNTRY.IN
    ],
    jp: [
        SUPPORTED_COUNTRY.JP
    ],
    us: [
        SUPPORTED_COUNTRY.US,
        GUAM
    ],
    bg: [
        SUPPORTED_COUNTRY.BG
    ],
    lt: [
        SUPPORTED_COUNTRY.LT
    ]
};
var BILLING_LOOKUP_CONSTRAINTS = {
    au: [
        SUPPORTED_COUNTRY.AU
    ],
    ca: [
        SUPPORTED_COUNTRY.US,
        SUPPORTED_COUNTRY.CA,
        GUAM
    ],
    gb: [
        SUPPORTED_COUNTRY.GB
    ],
    in: [
        SUPPORTED_COUNTRY.IN
    ],
    jp: [
        SUPPORTED_COUNTRY.JP
    ],
    us: [
        SUPPORTED_COUNTRY.US,
        SUPPORTED_COUNTRY.CA,
        GUAM
    ],
    bg: [
        SUPPORTED_COUNTRY.BG
    ],
    lt: [
        SUPPORTED_COUNTRY.LT
    ]
};
// According to current policy for returns
var MAX_DAYS_FOR_RETURN = 45;
// Existing app uses a 55-word limit to cut the text
var WORD_COUNT_FOR_TEXT_CUT = 55;
var BASKET_STOCK_STATUS;
(function(BASKET_STOCK_STATUS) {
    BASKET_STOCK_STATUS["PREORDER"] = "PREORDER";
    BASKET_STOCK_STATUS["MIXED"] = "MIXED";
    BASKET_STOCK_STATUS["INSTOCK"] = "INSTOCK";
})(BASKET_STOCK_STATUS || (BASKET_STOCK_STATUS = {}));
var CARD_TYPES = {
    "american express": "americanExpress",
    "master card": "master",
    "diners club": "diners",
    jcb: "JCB"
};
var PAYMENT_METHOD_SESSION_STORAGE_ENTRY;
(function(PAYMENT_METHOD_SESSION_STORAGE_ENTRY) {
    PAYMENT_METHOD_SESSION_STORAGE_ENTRY["PayPal"] = "paypal-order-number";
    PAYMENT_METHOD_SESSION_STORAGE_ENTRY["Afterpay"] = "afterpay-order-number";
    PAYMENT_METHOD_SESSION_STORAGE_ENTRY["CreditCard"] = "credit-card-order-number";
    PAYMENT_METHOD_SESSION_STORAGE_ENTRY["AdyenKlarna"] = "klarna-order-number";
    PAYMENT_METHOD_SESSION_STORAGE_ENTRY["UPI"] = "upi-order-number";
    PAYMENT_METHOD_SESSION_STORAGE_ENTRY["Wallet"] = "wallet-order-number";
    PAYMENT_METHOD_SESSION_STORAGE_ENTRY["OnlineBanking"] = "onlineBanking-order-number";
    PAYMENT_METHOD_SESSION_STORAGE_ENTRY["PayTM"] = "paytm-order-number";
    PAYMENT_METHOD_SESSION_STORAGE_ENTRY["UpiCollect"] = "adyen-upi-collect-order-number";
    PAYMENT_METHOD_SESSION_STORAGE_ENTRY["PayPay"] = "paypay-order-number";
    PAYMENT_METHOD_SESSION_STORAGE_ENTRY["COD"] = "cod-order-number";
    PAYMENT_METHOD_SESSION_STORAGE_ENTRY["Amazon"] = "amazon-order-number";
    PAYMENT_METHOD_SESSION_STORAGE_ENTRY["ApplePay"] = "apple-pay-order-number";
    PAYMENT_METHOD_SESSION_STORAGE_ENTRY["GooglePay"] = "google-pay-order-number";
    PAYMENT_METHOD_SESSION_STORAGE_ENTRY["WechatPay"] = "wechat-pay-order-number";
    PAYMENT_METHOD_SESSION_STORAGE_ENTRY["ZipPay"] = "zip-pay-order-number";
    PAYMENT_METHOD_SESSION_STORAGE_ENTRY["Alipay"] = "alipay-order-number";
    PAYMENT_METHOD_SESSION_STORAGE_ENTRY["Razorpay"] = "razorpay-order-number";
    PAYMENT_METHOD_SESSION_STORAGE_ENTRY["Klarna"] = "klarna-payments-order-number";
})(PAYMENT_METHOD_SESSION_STORAGE_ENTRY || (PAYMENT_METHOD_SESSION_STORAGE_ENTRY = {}));
var OpluxFraudDetectionMethod;
(function(OpluxFraudDetectionMethod) {
    OpluxFraudDetectionMethod["DETECT"] = "Detect";
    OpluxFraudDetectionMethod["UPDATE"] = "Update";
})(OpluxFraudDetectionMethod || (OpluxFraudDetectionMethod = {}));
var REFERRER_CATEGORY = "referrer-category";
var REFERRER_TYPE = "referrer-type";
var REFERRER_TYPE_VAL;
(function(REFERRER_TYPE_VAL) {
    REFERRER_TYPE_VAL["AutomatedComparison"] = "automatedComparison";
    REFERRER_TYPE_VAL["Carousel"] = "carousel";
    REFERRER_TYPE_VAL["Comparison"] = "comparison";
    REFERRER_TYPE_VAL["Stylitics"] = "stylitics";
})(REFERRER_TYPE_VAL || (REFERRER_TYPE_VAL = {}));
var COOKIE_BANNER_ACKNOWLEDGED_EVENT_NAME = "accept-cookies";
// FitAnalytics Fit Finder tool is place in the DOM directly before the element
// with this attribute.  See docs/third-party-integrations/fit-analytics.md.
var FITANALYTICS_FIT_FINDER_PLACEMENT = (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, "data-test-id", "size-guide-btn");
// FitAnalytics uses the element with this attribute to determine if the page
// has loaded and the category. See docs/third-party-integrations/fit-analytics.md
var FITANALYTICS_IS_LOADED_INDICATOR = {
    id: "breadcrumb"
};
var MaxAgeExpiration;
(function(MaxAgeExpiration) {
    MaxAgeExpiration[MaxAgeExpiration["DAILY"] = 86400] = "DAILY";
    MaxAgeExpiration[MaxAgeExpiration["WEEKLY"] = 604800] = "WEEKLY";
    MaxAgeExpiration[MaxAgeExpiration["MONTHLY"] = 2592000] = "MONTHLY";
})(MaxAgeExpiration || (MaxAgeExpiration = {}));
var CART_ERROR = {
    LONG_TERM_PAYMENT_ERROR: "LONG_TERM_PAYMENT_ERROR",
    LONG_TERM_PAYMENT_EMPTY: "LONG_TERM_PAYMENT_EMPTY"
};
var PaymentMethodsGA4Analytics;
(function(PaymentMethodsGA4Analytics) {
    PaymentMethodsGA4Analytics["AFTERPAY"] = "afterpay";
    PaymentMethodsGA4Analytics["ALIPAY"] = "alipay";
    PaymentMethodsGA4Analytics["AMAZON_PAY"] = "amazon pay";
    PaymentMethodsGA4Analytics["AMBASSADOR_CARD"] = "ambassador card";
    PaymentMethodsGA4Analytics["APPLE_PAY"] = "apple pay";
    PaymentMethodsGA4Analytics["CASH_ON_DELIVERY"] = "cash on delivery";
    PaymentMethodsGA4Analytics["CREDIT_CARD"] = "credit card";
    PaymentMethodsGA4Analytics["GIFT_CARD"] = "gift card";
    PaymentMethodsGA4Analytics["GOOGLE_PAY"] = "google pay";
    PaymentMethodsGA4Analytics["KLARNA"] = "klarna";
    PaymentMethodsGA4Analytics["NET_BANKING"] = "netbanking";
    PaymentMethodsGA4Analytics["PAY_PAY"] = "paypay";
    PaymentMethodsGA4Analytics["PAYPAL"] = "paypal";
    PaymentMethodsGA4Analytics["UPI"] = "upi";
    PaymentMethodsGA4Analytics["WALLETS"] = "wallets";
    PaymentMethodsGA4Analytics["ZIP_PAY"] = "zip";
    PaymentMethodsGA4Analytics["WECHAT_PAY"] = "wechat";
    PaymentMethodsGA4Analytics["ADYEN_COMPONENT"] = "adyen component";
    PaymentMethodsGA4Analytics["PAYTM"] = "paytm";
    PaymentMethodsGA4Analytics["SCHEME"] = "scheme";
    PaymentMethodsGA4Analytics["STORE_CREDIT"] = "store credit";
    PaymentMethodsGA4Analytics["UPI_COLLECT"] = "upi collect";
    PaymentMethodsGA4Analytics["AFTERPAY_TOUCH"] = "afterpay touch";
    PaymentMethodsGA4Analytics["RAZORPAY"] = "razorpay";
    PaymentMethodsGA4Analytics["KLARNA_ACCOUNT"] = "klarna account";
    PaymentMethodsGA4Analytics["KLARNA_PAYMENTS"] = "klarna payments";
})(PaymentMethodsGA4Analytics || (PaymentMethodsGA4Analytics = {}));
var SLOT_LINK_TYPE = {
    CTA: "ctas",
    LINK: "link"
};
// ─────────────────────────────────────────────────────────────────────────────
var SCROLL_GA4_EVENT_PERCENTAGES = [
    "25",
    "50",
    "75",
    "100"
];
// create a record with the percentage strings to be used in context to keep a record of the events that have been fired
var SCROLL_GA4_EVENT_PERCENTAGE_STRING = {
    "25": "SCROLL_EVENT_25_PERCENT",
    "50": "SCROLL_EVENT_50_PERCENT",
    "75": "SCROLL_EVENT_75_PERCENT",
    "100": "SCROLL_EVENT_100_PERCENT"
};
var ConstantsSessionStorage;
(function(ConstantsSessionStorage) {
    ConstantsSessionStorage["LIST_PRODUCT_KLARNA"] = "list-product-klarna";
})(ConstantsSessionStorage || (ConstantsSessionStorage = {}));
var ONE_TRUST_CONSENT_UPDATED = "OneTrustGroupsUpdated";
// ─────────────────────────────────────────────────────────────────────────────
var VIDEO_GA4_EVENT_PERCENTAGES = [
    "0",
    "10",
    "25",
    "50",
    "75",
    "100", 
];
// create a record with the percentage strings to be used in context to keep a record of the events that have been fired
var VIDEO_GA4_EVENT_PERCENTAGE_STRING = {
    "0": "VIDEO_EVENT_0_PERCENT",
    "10": "VIDEO_EVENT_10_PERCENT",
    "25": "VIDEO_EVENT_25_PERCENT",
    "50": "VIDEO_EVENT_50_PERCENT",
    "75": "VIDEO_EVENT_75_PERCENT",
    "100": "VIDEO_EVENT_100_PERCENT"
};
// ─────────────────────────────────────────────────────────────────────────────
var CRAWLERS = [
    "google",
    "googlebot",
    "bingbot",
    "facebookexternalhit",
    "mediapartners-Google",
    "ahrefsbot",
    "googlebot-image",
    "ia_archiver",
    "linkedinbot",
    "msnbot",
    "semrushbot",
    "slurp",
    "googlebot-news",
    "yandex",
    "applebot",
    "rogerbot",
    "twitterbot",
    "adidxbot",
    "duckduckbot",
    "facebot",
    "googlebot-mobile",
    "pinterestbot",
    "yandexbot",
    "360spider",
    "heritrix",
    "teoma",
    "yeti",
    "googlebot-video",
    "googleother",
    "msnbot-media",
    "coccocbot-web",
    "haosouspider",
    "yisouspider",
    "archive.org_bot",
    "buzzbot",
    "fast enterprise crawler",
    "fast-webcrawler",
    "fluffy",
    "google favicon",
    "msrbot",
    "seokicks-robot",
    "sistrix crawler",
    "slackbot",
    "w3c_validator",
    "wbsearchbot",
    "web-archive-net.com.bot",
    "whatsapp",
    "qwantify",
    "semanticscholarbot",
    "yacybot",
    "screaming frog seo spider",
    "duckduckgo-favicons-bot",
    "feedfetcher-google",
    "yahoo! slurp",
    "yandeximages",
    "yandexrenderresourcesbot",
    "alexandriaorgbot",
    "atom feed robot",
    "daum",
    "mojeekbot",
    "tineye",
    "tineye-bot",
    "zumbot",
    "headlesschrome",
    "quora-bot",
    "scandibot", 
];
var ELEVATED_PDP_TYPES = [
    "FeaturesGrid",
    "FullBleedHero",
    "VideoHero",
    "SplitHero",
    "TrendingInline",
    "ProductComparison",
    "ProductGroupFeatures", 
];
var noIndexParams = [
    "sc_lid",
    "sc_src",
    "smtrctid",
    "fdid",
    "mktID",
    "mktid",
    "sc_eh",
    "_branch_match_id",
    "pmpt",
    "endpoint",
    "from",
    "%243p",
    "$3p",
    "%24deep_link",
    "$deep_link",
    "utm_medium",
    "originalpagetype",
    "utm_aud",
    "locale",
    "action",
    "pref_gender",
    "pref_productdivName",
    "pref_size",
    "pref_sportCode",
    "pref_style",
    "prefn1",
    "utm_source",
    "start",
    "from",
    "sort",
    "src",
    "q",
    "SUBPUID",
    "j",
    "imktID",
    "_pxhc", 
];


/***/ }),

/***/ 66641:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ formatExpirationDate; },
/* harmony export */   "y": function() { return /* binding */ formatCreditCard; }
/* harmony export */ });
//https://baymard.com/checkout-usability/credit-card-patterns
// http://support.worldpay.com/support/kb/bg/testandgolive/tgl5103.html
var getCardFormat = function(value, type) {
    // if we don't have card formatting, return a default 4-4-4-4-4
    if (typeof type === "string") return [
        4,
        4,
        4,
        4,
        4
    ];
    // if the format is a single array, return it as is
    if (Array.isArray(type.format)) return type.format;
    // else there are multiple formats for this card type
    // get the length of our current input
    // and use the valid_length array, to find
    // the first length that's longer than our string and
    // return the format for that string length
    var nextPossibleLength = type.valid_length.find(function(v) {
        return v >= value.length;
    }) || type.valid_length[type.valid_length.length - 1];
    return type.format[nextPossibleLength];
};
function formatExpirationDate(dateTrimmed) {
    var lastIndex = 0;
    var shards = [
        2,
        2
    ].reduce(function(res, cur) {
        // short circuit
        if (dateTrimmed.length < lastIndex) return res;
        // create slice and add to shards
        var slice = dateTrimmed.slice(lastIndex, lastIndex + cur);
        res.push(slice);
        // update controls
        lastIndex += cur;
        return res;
    }, []);
    return shards.join("/").trim();
}
function formatCreditCard(value, type) {
    var card = value.replace(/\D+/g, "");
    // get format for this card type
    var format = getCardFormat(card, type);
    // use the format array to create slices of the card input
    var lastIndex = 0;
    var shardsCombinedLength = 0;
    var shards = format.reduce(function(res, cur) {
        // short cirquit
        if (card.length < lastIndex) return res;
        // create slice and add to shards
        var slice = card.slice(lastIndex, lastIndex + cur);
        res.push(slice);
        // update controls
        lastIndex += cur;
        shardsCombinedLength += slice.length;
        return res;
    }, []);
    // if the input is loner than the expected format,
    // add the remaining to an extra shard
    if (card.length > shardsCombinedLength) shards.push(card.slice(shardsCombinedLength));
    // join with spaces and trim the whitespace
    return shards.join(" ").replace(/ +(?= )/g, "").trim();
}


/***/ }),

/***/ 18047:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ validateCreditCard; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24364);

var card_types = [
    {
        name: "amex",
        range: "34,37",
        valid_length: [
            15
        ],
        format: [
            4,
            6,
            5
        ]
    },
    {
        name: "diners_club_carte_blanche",
        range: "300-305",
        valid_length: [
            14
        ],
        format: [
            4,
            6,
            4
        ]
    },
    {
        name: "diners_club_international",
        range: "36",
        valid_length: [
            14
        ],
        format: [
            4,
            6,
            4
        ]
    },
    {
        name: "jcb",
        range: "3528-3589",
        valid_length: [
            16
        ],
        format: [
            4,
            4,
            4,
            4
        ]
    },
    {
        name: "laser",
        range: "6304, 6706, 6709, 6771",
        valid_length: [
            16,
            17,
            18,
            19
        ],
        format: {
            16: [
                4,
                4,
                4,
                4
            ],
            17: [
                4,
                4,
                4,
                5
            ],
            18: [
                4,
                4,
                4,
                4,
                2
            ],
            19: [
                4,
                4,
                4,
                4,
                3
            ]
        }
    },
    {
        name: "visa_electron",
        range: "4026, 417500, 4508, 4844, 4913, 4917",
        valid_length: [
            16
        ],
        format: [
            4,
            4,
            4,
            4
        ]
    },
    {
        name: "visa",
        range: "4",
        valid_length: [
            13,
            14,
            15,
            16,
            17,
            18,
            19
        ],
        format: {
            13: [
                4,
                4,
                5
            ],
            14: [
                4,
                4,
                4,
                2
            ],
            15: [
                4,
                4,
                4,
                3
            ],
            16: [
                4,
                4,
                4,
                4
            ],
            17: [
                4,
                4,
                4,
                5
            ],
            18: [
                4,
                4,
                4,
                4,
                2
            ],
            19: [
                4,
                4,
                4,
                4,
                3
            ]
        }
    },
    {
        name: "mastercard",
        range: "51-55, 232100-272099, 22",
        valid_length: [
            16
        ],
        format: [
            4,
            4,
            4,
            4
        ]
    },
    {
        name: "discover",
        range: "6011, 622126-622925, 644-649, 65",
        valid_length: [
            16
        ],
        format: [
            4,
            4,
            4,
            4
        ]
    },
    {
        name: "dankort",
        range: "5019",
        valid_length: [
            16
        ],
        format: [
            4,
            4,
            4,
            4
        ]
    },
    {
        name: "maestro",
        range: "50, 56-59, 61-63, 66-69, 600-606, 609, 640-643, 7744, 700600, 706980, 707145, 708252, 709900, 724365, 800003, 822951, 849686, 927001, 990015",
        valid_length: [
            12,
            13,
            14,
            15,
            16,
            17,
            18,
            19
        ],
        format: {
            12: [
                4,
                4,
                4
            ],
            13: [
                4,
                4,
                5
            ],
            14: [
                4,
                6,
                4
            ],
            15: [
                4,
                6,
                5
            ],
            16: [
                4,
                4,
                4,
                4
            ],
            17: [
                4,
                4,
                4,
                5
            ],
            18: [
                4,
                4,
                4,
                6
            ],
            19: [
                4,
                4,
                4,
                4,
                3
            ]
        }
    },
    {
        name: "uatp",
        range: "1",
        valid_length: [
            15
        ],
        format: [
            4,
            5,
            6
        ]
    }, 
];
var Trie = /*#__PURE__*/ function() {
    "use strict";
    function Trie() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, Trie);
        this.trie = {};
    }
    var _proto = Trie.prototype;
    _proto.push = function push(value) {
        var char, i, j, len, obj;
        value = value.toString();
        obj = this.trie;
        var ref = value.split("");
        var results = [];
        for(i = j = 0, len = ref.length; j < len; i = ++j){
            char = ref[i];
            if (obj[char] == null) {
                if (i === value.length - 1) {
                    obj[char] = null;
                } else {
                    obj[char] = {};
                }
            }
            // @ts-expect-error
            results.push(obj = obj[char]);
        }
        return results;
    };
    _proto.find = function find(value) {
        var char, i, j, len, obj;
        value = value.toString();
        obj = this.trie;
        var ref = value.split("");
        for(i = j = 0, len = ref.length; j < len; i = ++j){
            char = ref[i];
            if (obj.hasOwnProperty(char)) {
                if (obj[char] === null) {
                    return true;
                }
            } else {
                return false;
            }
            obj = obj[char];
        }
    };
    return Trie;
}();
var Range = /*#__PURE__*/ function() {
    "use strict";
    function Range(trie) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, Range);
        this.trie = trie;
    }
    var _proto = Range.prototype;
    _proto.rangeWithString = function rangeWithString(ranges) {
        var j, k, len, n, r, range, ref, ref1;
        if (typeof ranges !== "string") {
            throw Error("rangeWithString requires a string parameter");
        }
        ranges = ranges.replace(/ /g, "");
        ranges = ranges.split(",");
        var trie = new Trie();
        for(j = 0, len = ranges.length; j < len; j++){
            range = ranges[j];
            if (r = range.match(/^(\d+)-(\d+)$/)) {
                for(n = k = ref = r[1], ref1 = r[2]; ref <= ref1 ? k <= ref1 : k >= ref1; n = ref <= ref1 ? ++k : --k){
                    trie.push(n);
                }
            } else if (range.match(/^\d+$/)) {
                trie.push(range);
            } else {
                throw Error("Invalid range '" + r + "'");
            }
        }
        return new Range(trie);
    };
    _proto.match = function match(number) {
        return this.trie.find(number);
    };
    return Range;
}();
function validateCreditCard(v) {
    var indexOf = [].indexOf;
    var card, card_type;
    var range = new Range(new Trie());
    var ref = card_types.map(function(x) {
        return typeof x !== "string" ? x.name : x;
    });
    for(var j = 0, len = ref.length; j < len; j++){
        card_type = ref[j];
        var t = function() {
            var k, len1;
            var results = [];
            for(k = 0, len1 = card_types.length; k < len1; k++){
                card = card_types[k];
                results.push(card.name);
            }
            return results;
        }();
        if (t.indexOf(card_type) < 0) {
            return {
                card_type: "INVALID_CARD",
                valid: false,
                minCVV: 0
            };
        }
    }
    var get_card_type = function get_card_type(number) {
        var k, len1, r;
        var ref1 = function() {
            var l, len1, ref1;
            var results = [];
            for(l = 0, len1 = card_types.length; l < len1; l++){
                card = card_types[l];
                // @ts-expect-error
                if (ref1 = card.name, indexOf.call(ref, ref1) >= 0) {
                    results.push(card);
                }
            }
            return results;
        }();
        for(k = 0, len1 = ref1.length; k < len1; k++){
            card_type = ref1[k];
            //@ts-expect-error
            r = range.rangeWithString(card_type.range);
            if (r.match(number)) {
                return card_type;
            }
        }
        return null;
    };
    var is_valid_luhn = function is_valid_luhn(number) {
        var digit, k, len1, n, sum;
        sum = 0;
        var ref1 = number.split("").reverse();
        for(n = k = 0, len1 = ref1.length; k < len1; n = ++k){
            digit = ref1[n];
            digit = +digit;
            if (n % 2) {
                digit *= 2;
                if (digit < 10) {
                    sum += digit;
                } else {
                    sum += digit - 9;
                }
            } else {
                sum += digit;
            }
        }
        return sum % 10 === 0;
    };
    var normalize = function normalize(number) {
        return number.replace(/[ -]/g, "");
    };
    var is_valid_length = function is_valid_length(number, card_type) {
        var ref1;
        return(// @ts-expect-error
        (ref1 = number.length), indexOf.call(card_type.valid_length, ref1) >= 0);
    };
    var validate_number = function validate_number(number) {
        var length_valid, luhn_valid;
        //@ts-expect-error
        card_type = get_card_type(number);
        luhn_valid = false;
        length_valid = false;
        if (card_type != null) {
            luhn_valid = is_valid_luhn(number);
            length_valid = is_valid_length(number, card_type);
        }
        return {
            card_type: card_type || "",
            minCVV: card_type && (typeof card_type === "string" ? card_type : card_type.name) === "amex" ? 4 : 3,
            valid: luhn_valid && length_valid,
            luhn_valid: luhn_valid,
            length_valid: length_valid
        };
    };
    return validate_number(normalize(v));
}


/***/ }),

/***/ 35525:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cy": function() { return /* binding */ IsDateAfter; },
/* harmony export */   "H1": function() { return /* binding */ isOpenNow; },
/* harmony export */   "ZR": function() { return /* binding */ longDateFormat; },
/* harmony export */   "ci": function() { return /* binding */ timezoneDateFormat; },
/* harmony export */   "hF": function() { return /* binding */ isDateBefore; },
/* harmony export */   "zx": function() { return /* binding */ isDateBetween; }
/* harmony export */ });
/* unused harmony export standardDateFormat */
var longDateFormat = function(date, locale) {
    return new Intl.DateTimeFormat(locale).format(new Date(date));
};
var standardDateFormat = function(date) {
    var d = new Date(date);
    var day = d.getDate();
    var month = d.getMonth() + 1;
    var year = d.getFullYear();
    return "".concat(month, " ").concat(day, ", ").concat(year);
};
/**
 * Formats the given date string to display the date, month, and hour in the
 * user's timezone, along with the timezone name if `showTimeZoneName` is true.
 *
 * @param date - The date string to format (e.g. '2023-04-10T12:00:00Z').
 * @param locale - The locale identifier to format the date in (e.g. 'en-US').
 * @param showTimeZoneName - Whether to show the timezone name (e.g. 'PDT'), defaults to `false`.
 * @return string - The formatted date string (e.g. '4/10, 12 PM PDT').
 *
 * @example
 * // Returns '4/10, 12 PM PDT'
 * timezoneDateFormat('2023-04-10T12:00:00Z', 'en-US', true, 'America/Los_Angeles');
 *
 * @example
 * // Returns '4/10, 12 PM'
 * timezoneDateFormat('2023-04-10T12:00:00Z', 'en-US', false, 'America/Los_Angeles');
 */ var timezoneDateFormat = function(date, locale) {
    var showTimeZoneName = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, timeZone = arguments.length > 3 ? arguments[3] : void 0;
    return new Intl.DateTimeFormat(locale, {
        timeZoneName: showTimeZoneName ? "short" : undefined,
        day: "numeric",
        month: "numeric",
        hour: "numeric",
        minute: locale === "en-IN" ? "numeric" : undefined,
        hourCycle: locale === "en-GB" || locale === "ja-JP" ? "h12" : undefined,
        timeZone: timeZone
    }).format(new Date(date)).toUpperCase();
};
/**
 * Checks if the current day and hour are within the specified opening hours.
 *
 * @param openingHours The opening hours for the live chat, typed in `sites/types.ts`.
 * @returns {boolean} `true` if currently open, `false` otherwise (or no hours given).
 */ var isOpenNow = function(openingHours) {
    if (!openingHours) return false;
    var now = new Date();
    var currentDay = now.getDay();
    var currentHour = now.getHours();
    return openingHours.days.includes(currentDay) && openingHours.hours.includes(currentHour);
};
/**
 * Checks if a given date is between two other dates
 *
 * @param {Object} dates - The object containing the three dates
 * @param {Date} dates.startDate - The start date of the interval
 * @param {Date} dates.endDate - The end date of the interval
 * @param {Date} dates.dateToCheck - The date which will be checked
 * @returns {boolean} `true` if the date to check is between the start and the
 * end date, `false` otherwise
 */ var isDateBetween = function(param) {
    var startDate = param.startDate, endDate = param.endDate, dateToCheck = param.dateToCheck;
    return startDate.getTime() <= dateToCheck.getTime() && endDate.getTime() >= dateToCheck.getTime();
};
/**
 * Checks if a given date is between two other dates
 *
 * @param {Object} dates - The object containing the two dates
 * @param {Date} dates.dateToCheck - The date which will be checked
 * @param {Date} dates.startDate - The start date of the interval
 * @returns {boolean} `true` if the date to check is after the start date,
 * `false` otherwise
 */ var IsDateAfter = function(param) {
    var dateToCheck = param.dateToCheck, startDate = param.startDate;
    return startDate.getTime() <= dateToCheck.getTime();
};
/**
 * Checks if a given date is between two other dates
 *
 * @param {Object} dates - The object containing the two dates
 * @param {Date} dates.dateToCheck - The date which will be checked
 * @param {Date} dates.endDate - The end date of the interval
 * @returns {boolean} `true` if the date to check is before the end date,
 * `false` otherwise
 */ var isDateBefore = function(param) {
    var dateToCheck = param.dateToCheck, endDate = param.endDate;
    return endDate.getTime() >= dateToCheck.getTime();
};


/***/ }),

/***/ 40572:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ debounce; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3204);

var timeouts = new Map();
// picked off the internet: a very tiny hashing function called funHash
var hash = function(s) {
    var i, h;
    for(i = 0, h = 0xdeadbeef; i < s.length; i++)h = Math.imul(h ^ s.charCodeAt(i), 2654435761);
    return (h ^ h >>> 16) >>> 0;
};
var debounce = function(fn, ms) {
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var id = hash(fn.toString());
        var existingTimeout = timeouts.get(id);
        if (existingTimeout) clearTimeout(existingTimeout);
        var timeout = setTimeout(function() {
            fn.apply(void 0, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(args));
            timeouts.delete(id);
        }, ms);
        timeouts.set(id, timeout);
        return timeout;
    };
};


/***/ }),

/***/ 90192:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ encodeProductNameForUri; }
/* harmony export */ });
var excludedCharacters = [
    "'",
    ",",
    "™",
    "\xae",
    "”",
    "(",
    ")",
    "`",
    "!",
    "#",
    "%",
    "&",
    "*",
    "_",
    "+",
    ":",
    ";",
    "=",
    "?",
    "@",
    "[",
    "\\",
    "]",
    "{",
    "}",
    '"',
    "\\\\",
    "|",
    "~",
    "^",
    "<",
    ">",
    "\xa0",
    "’",
    "\xb0",
    "\xba",
    "\xa3",
    "\xee",
    "​"
];
var replaceCharactersList = {
    á: "a",
    é: "e",
    è: "e",
    í: "i",
    ó: "o",
    ú: "u",
    ñ: "n",
    ä: "ae",
    ë: "e",
    ï: "i",
    ö: "oe",
    ü: "ue",
    ÿ: "y",
    $: "S",
    æ: "ae",
    ç: "c",
    ē: "e",
    à: "a",
    ì: "i",
    ò: "o",
    ê: "e",
    ô: "o",
    œ: "oe",
    ù: "u",
    "⁰": "0",
    "\xb9": "1",
    "\xb2": "2",
    "\xb3": "3",
    "⁴": "4",
    "⁵": "5",
    "⁶": "6",
    "⁷": "7",
    "⁸": "8",
    "⁹": "9"
};
var replaceCharacters = function(productName) {
    return productName.split("").map(function(char) {
        return replaceCharactersList[char] || char;
    }).join("");
};
var encodeProductNameForUri = function(productName) {
    var disableEncodingCharacters = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var regex = new RegExp("[".concat(excludedCharacters.join(""), "]"), "g");
    var strippedProductName = (productName !== null && productName !== void 0 ? productName : "product-name").toLowerCase().replace(regex, "");
    return disableEncodingCharacters ? replaceCharacters(strippedProductName).replace(/\ /g, "-") // Space
    .replace(/\//g, "-") // Forward slash
    .replace(/\./g, "-") // Period
     : encodeURIComponent(replaceCharacters(strippedProductName)).replace(/%20/g, "-") // Space
    .replace(/%2F/g, "-") // Forward slash
    .replace(/\./g, "-");
};


/***/ }),

/***/ 4360:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ extractCode; },
/* harmony export */   "d": function() { return /* binding */ extractError; }
/* harmony export */ });
/** Gets the first error message from a GraphQL request */ var extractError = function() {
    for(var _len = arguments.length, states = new Array(_len), _key = 0; _key < _len; _key++){
        states[_key] = arguments[_key];
    }
    var ref;
    var error = getError(states);
    if (!error) return;
    var ref1;
    return (ref1 = (ref = error.graphQLErrors[0]) === null || ref === void 0 ? void 0 : ref.message) !== null && ref1 !== void 0 ? ref1 : "A network error occurred";
};
/** Gets the first error code from a GraphQL request */ var extractCode = function() {
    for(var _len = arguments.length, states = new Array(_len), _key = 0; _key < _len; _key++){
        states[_key] = arguments[_key];
    }
    var ref, ref1;
    var error = getError(states);
    if (!error) return;
    var ref2;
    return (ref2 = (ref = error.graphQLErrors[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.extensions) === null || ref1 === void 0 ? void 0 : ref1.code) !== null && ref2 !== void 0 ? ref2 : "A network error occurred";
};
var getError = function(states) {
    var ref;
    return (ref = states.find(function(state) {
        return state.error;
    })) === null || ref === void 0 ? void 0 : ref.error;
};


/***/ }),

/***/ 71926:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ extractProductVariants; }
/* harmony export */ });
var extractProductVariants = function(products) {
    if (!products) return [];
    return products.map(function(product) {
        switch(product === null || product === void 0 ? void 0 : product.__typename){
            case "Variant":
            case "VariantProduct":
                return product;
            case "ProductSearchHit":
                return product.variantProduct;
            default:
                return null;
        }
    }).filter(Boolean);
};


/***/ }),

/***/ 63179:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ek": function() { return /* binding */ FORTER_WEBID_STORAGE_KEY; },
/* harmony export */   "Gl": function() { return /* binding */ formatForterWebId; },
/* harmony export */   "JK": function() { return /* binding */ validateForterWebId; },
/* harmony export */   "Kn": function() { return /* binding */ FORTER_TOKEN_STORAGE_KEY; },
/* harmony export */   "Ze": function() { return /* binding */ getForterToken; },
/* harmony export */   "Zn": function() { return /* binding */ retrieveWebId; },
/* harmony export */   "at": function() { return /* binding */ retrieveCustomerWebId; },
/* harmony export */   "os": function() { return /* binding */ storeCustomerWebId; }
/* harmony export */ });
/* unused harmony export FORTER_CUSTOMER_WEBID_STORAGE_KEY */
/* harmony import */ var nookies__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(15798);
/* harmony import */ var nookies__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(nookies__WEBPACK_IMPORTED_MODULE_0__);

var FORTER_TOKEN_STORAGE_KEY = "forterToken";
var FORTER_WEBID_STORAGE_KEY = "forterWebId";
var FORTER_CUSTOMER_WEBID_STORAGE_KEY = "forterCustomerWebId";
var formatForterWebId = function(webId) {
    if (!webId) return "";
    var result = "";
    for(var i = 1; i <= webId.length; i += 1){
        result += webId[i - 1];
        if (i % 3 === 0) result += " ";
    }
    return result.trim();
};
var validateForterWebId = function(webId) {
    if (!webId) return false;
    // web ID must be a valid luhn number. implementing validation
    // here to avoid typos having forter reject the payment
    var webIdNoSpaces = webId.replaceAll(" ", "");
    var sum = 0;
    var mul = 1;
    var len = webIdNoSpaces.length;
    while(len--){
        var ca = parseInt(webIdNoSpaces.charAt(len), 10) * mul;
        sum += ca - (ca > 9 ? 1 : 0) * 9;
        mul = 3 - mul;
    }
    return sum % 10 === 0 && sum > 0;
};
var getForterToken = function() {
    var ref;
    return (ref = (0,nookies__WEBPACK_IMPORTED_MODULE_0__.parseCookies)()["forterToken"]) !== null && ref !== void 0 ? ref : "";
};
var retrieveWebId = function() {
    return localStorage.getItem(FORTER_WEBID_STORAGE_KEY);
};
var retrieveCustomerWebId = function() {
    var ref;
    return (ref = window.sessionStorage.getItem(FORTER_CUSTOMER_WEBID_STORAGE_KEY)) !== null && ref !== void 0 ? ref : null;
};
var storeCustomerWebId = function(value) {
    if (value) {
        window.sessionStorage.setItem(FORTER_CUSTOMER_WEBID_STORAGE_KEY, value);
    } else {
        window.sessionStorage.removeItem(FORTER_CUSTOMER_WEBID_STORAGE_KEY);
    }
};


/***/ }),

/***/ 54093:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EI": function() { return /* binding */ removeGa4ItemFromMap; },
/* harmony export */   "HH": function() { return /* binding */ setGa4ItemInMap; },
/* harmony export */   "Vr": function() { return /* binding */ getGa4Item; },
/* harmony export */   "nL": function() { return /* binding */ getLastRelativeEntry; },
/* harmony export */   "uC": function() { return /* binding */ removeGa4ItemsMap; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85034);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70169);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5341);



var GA4_ITEMS_MAP = "Ga4ItemsMap";
var MAX_ENTRIES = 50;
var getGa4ItemsMap = function() {
    if (false) {}
    var localStorageMap = localStorage.getItem(GA4_ITEMS_MAP);
    // If there's no data in localStorage, return an empty Map
    if (!localStorageMap) {
        return new Map();
    }
    try {
        // Parse the JSON and cast it into a Map with the correct types
        return new Map(JSON.parse(localStorageMap));
    } catch (error) {
        return new Map();
    }
};
var getLastRelativeEntry = function(masterId) {
    var itemsMap = getGa4ItemsMap();
    if (itemsMap) {
        return Array.from(itemsMap.entries()).filter(function(e) {
            return e[0].startsWith(masterId);
        }).pop();
    }
    return itemsMap;
};
var getGa4Item = function(id) {
    var ref;
    return id ? (ref = getGa4ItemsMap()) === null || ref === void 0 ? void 0 : ref.get(id) : undefined;
};
var setGa4ItemInMap = function(id, item, preserveCartValue) {
    var itemsMap = getGa4ItemsMap();
    if (itemsMap) {
        var existingItem = itemsMap.get(id);
        if (existingItem) {
            itemsMap.delete(id);
            if (preserveCartValue) {
                itemsMap.set(id, item);
            } else {
                itemsMap.set(id, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, item), {
                    cart: existingItem.cart
                }));
            }
        } else {
            if (itemsMap.size == MAX_ENTRIES) {
                var filteredMap = new Map();
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = itemsMap[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _value = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_step.value, 2), key = _value[0], value = _value[1];
                        if (value.cart !== "1") {
                            filteredMap.set(key, value);
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                if (filteredMap.size > 0) {
                    var victimId = Array.from(filteredMap.keys()).shift();
                    itemsMap.delete(victimId);
                    itemsMap.set(id, item);
                }
            } else {
                itemsMap.set(id, item);
            }
        }
        localStorage.setItem(GA4_ITEMS_MAP, JSON.stringify(Array.from(itemsMap.entries())));
    }
    return itemsMap;
};
var removeGa4ItemFromMap = function(id) {
    var itemsMap = getGa4ItemsMap();
    if (itemsMap) {
        itemsMap.delete(id);
        localStorage.setItem(GA4_ITEMS_MAP, JSON.stringify(Array.from(itemsMap.entries())));
    }
};
var removeGa4ItemsMap = function() {
    if (true) localStorage.removeItem(GA4_ITEMS_MAP);
};


/***/ }),

/***/ 23295:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ getMinimalNumber; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3204);
/* harmony import */ var _isNumber__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95442);


var getMinimalNumber = function() {
    for(var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++){
        values[_key] = arguments[_key];
    }
    var _Math;
    var numbers = values.filter(_isNumber__WEBPACK_IMPORTED_MODULE_0__/* .isNumber */ .h);
    return (_Math = Math).min.apply(_Math, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(numbers));
};


/***/ }),

/***/ 21867:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ getUrlByCategory; }
/* harmony export */ });
// Generates a URL based on the provided category.
var getUrlByCategory = function(category, fallback) {
    return category ? Array.isArray(category) ? "/".concat(category.join("/")) : "/".concat(category) : fallback !== null && fallback !== void 0 ? fallback : "";
};


/***/ }),

/***/ 75350:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QW": function() { return /* binding */ resizeProductImage; },
/* harmony export */   "lv": function() { return /* binding */ getResponsiveImageSizes; },
/* harmony export */   "n9": function() { return /* binding */ addWidthTransform; },
/* harmony export */   "oO": function() { return /* binding */ getResponsiveImageSrcSet; },
/* harmony export */   "uG": function() { return /* binding */ getImageMediaCondition; }
/* harmony export */ });
/* unused harmony export resizeStyliticsImage */
/* harmony import */ var twind_css__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49224);

var getImageMediaCondition = function(screen) {
    return twind_css__WEBPACK_IMPORTED_MODULE_0__.tw.theme("screens.".concat(screen)).raw.replace("screen and ", "");
};
var getResponsiveImageSizes = function(sizes) {
    var mobileMediaCondition = getImageMediaCondition("mobile");
    var tabletMediaCondition = getImageMediaCondition("tablet");
    var desktopMediaCondition = getImageMediaCondition("desktop");
    return "".concat(mobileMediaCondition, " ").concat(sizes.mobile, ", ").concat(tabletMediaCondition, " ").concat(sizes.tablet, ", ").concat(desktopMediaCondition, " ").concat(sizes.desktop);
};
/**
 * Resizes the product image by changing the width value in the image's URL.
 * The `originalImageWidth` parameter is used to identify the width to replace, which defaults to `'2000'`.
 * If the `originalImageWidth` is not found in the src URL, it returns the original src URL.
 *
 * Works for the following URL format:
 * - https://images.puma.com/image/upload/f_auto,q_auto,b_rgb:fafafa,w_2000,h_2000/global/374915/01/sv01/fnd/PNA/fmt/png
 */ var resizeProductImage = function(src, newWidth) {
    var originalImageWidth = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "2000";
    if (!src) return "";
    // Captures the width or height value in the image URL, e.g. 'w_2000', 'h_2000'
    var widthHeightRegex = new RegExp("([wh])_".concat(originalImageWidth), "g");
    if (!src.match(widthHeightRegex)) return src;
    return src.replace(widthHeightRegex, "$1_".concat(newWidth.toString()));
};
/**
 * Resizes the product image by changing the width value in the image's URL.
 * The `originalImageWidth` parameter is used to identify the width to replace, which defaults to `'1200'`.
 * If the `originalImageWidth` is not found in the src URL, it returns the original src URL.
 *
 * Works for the following URL format:
 * - https://images.puma.net/images/534038/74/fnd/PNA/w/1200/h/1200/
 */ var resizeStyliticsImage = function(src, newWidth) {
    var originalImageWidth = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "1200";
    if (!src) return "";
    // Captures the width or height value in the image URL, e.g. 'w/1200', 'h/1200'.
    var widthHeightRegex = new RegExp("([wh])/".concat(originalImageWidth), "g");
    if (!src.match(widthHeightRegex)) return src;
    return src.replace(widthHeightRegex, "$1/".concat(newWidth.toString()));
};
/**
 * Creates a string for a responsive image srcset. It replaces the original width in the src URL with each
 * of the specified widths, creating a separate URL for each.
 *
 * @param {string} src - The URL of the original image, where the width is specified as 'w_[originalImageWidth]', e.g. 'w_900'.
 * @param {number[]} widths - The list of widths to be applied. Each width generates a new URL.
 * @param {string} originalImageWidth - The width value to be replaced in the original image URL, e.g. '900'.
 * @returns {string} The generated srcset string, with each URL-width pair separated by a comma.
 */ var getResponsiveImageSrcSet = function(src, widths, originalImageWidth) {
    var srcSetArray = widths.map(function(width) {
        var newSrc = resizeProductImage(src, width, originalImageWidth);
        return "".concat(newSrc, " ").concat(width, "w");
    });
    return srcSetArray.join(",");
};
/**
 * Adds a width transform to Cloudinary images.
 * Needed as product images using a named transform do not have an explicit width transform in the URL.
 * Adds w_2000, as this matches the default transform used for square images
 *
 * Works for the following URL format:
 * - https://images.puma.com/image/upload/t_vertical_model/global/193923/02/mod03/fnd/PNA/
 */ var addWidthTransform = function(src) {
    return src.replace(/\/upload\/[^/]+/, function(match) {
        return "".concat(match, ",w_2000");
    });
};


/***/ }),

/***/ 89996:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ isContentOnline; }
/* harmony export */ });
var isContentOnline = function(doc, preview) {
    var isDev = !!preview;
    var viewAt = isDev && (preview === null || preview === void 0 ? void 0 : preview.viewAt) ? +preview.viewAt : Date.now();
    if ((doc === null || doc === void 0 ? void 0 : doc.online) === false) return false;
    if ((doc === null || doc === void 0 ? void 0 : doc.onlineFrom) && +new Date(doc.onlineFrom) > viewAt) return false;
    if ((doc === null || doc === void 0 ? void 0 : doc.onlineTo) && +new Date(doc.onlineTo) < viewAt) return false;
    return true;
};


/***/ }),

/***/ 22198:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "c": function() { return /* binding */ isCrawlerCheck; }
});

// EXTERNAL MODULE: ./utils/constants.ts
var constants = __webpack_require__(79758);
;// CONCATENATED MODULE: ./utils/crawlerCheck.ts

function crawlerCheck(userAgent) {
    if (userAgent) {
        return constants/* CRAWLERS.some */.QH.some(function(crawler) {
            return userAgent.toLowerCase().includes(crawler);
        });
    }
    return false;
}

;// CONCATENATED MODULE: ./utils/isCrawlerCheck.ts

function isCrawlerCheck(param) {
    var namespace = param.namespace, host = param.host, req = param.req;
    var ref, ref1, ref2, ref3;
    var isCrawler = (namespace === null || namespace === void 0 ? void 0 : namespace.includes("pr-")) || (host === null || host === void 0 ? void 0 : host.startsWith("localhost")) ? crawlerCheck(req === null || req === void 0 ? void 0 : (ref = req.headers) === null || ref === void 0 ? void 0 : ref["user-agent"]) : (req === null || req === void 0 ? void 0 : (ref1 = req.headers) === null || ref1 === void 0 ? void 0 : ref1["x-user-agent"]) === "bot" || (req === null || req === void 0 ? void 0 : (ref2 = req.headers) === null || ref2 === void 0 ? void 0 : (ref3 = ref2["user-agent"]) === null || ref3 === void 0 ? void 0 : ref3.includes("botify"));
    return isCrawler;
}


/***/ }),

/***/ 64191:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ isInitialClientRender; }
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79758);

function isInitialClientRender(router) {
    var ref, ref1;
    if (_constants__WEBPACK_IMPORTED_MODULE_0__/* .isServer */ .sk) return false;
    // The `components` field is only defined on the base Router type:
    var routeInfo = (ref = router) === null || ref === void 0 ? void 0 : (ref1 = ref.components) === null || ref1 === void 0 ? void 0 : ref1[router.pathname];
    var r = routeInfo;
    return !!r.initial;
}


/***/ }),

/***/ 50597:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ isNotNullish; }
/* harmony export */ });
/**
 * Ensures a value is neither null nor undefined.
 * This type guard facilitates safe usage in contexts that don't handle `null` or `undefined`.
 *
 * @param value The value to check against `null` and `undefined`.
 * @returns {boolean} Returns `true` if the value is not `null` or `undefined`, otherwise returns `false`.
 *
 * @example
 * isNotNullish(null);        // Expected output: false
 * isNotNullish(undefined);   // Expected output: false
 * isNotNullish(0);           // Expected output: true
 * isNotNullish('abc');       // Expected output: true
 */ var isNotNullish = function(value) {
    return value !== null && value !== undefined;
};


/***/ }),

/***/ 95442:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ beginsWithNumber; },
/* harmony export */   "h": function() { return /* binding */ isNumber; }
/* harmony export */ });
var isNumber = function(input) {
    return typeof input === "number" && Number.isFinite(input);
};
var beginsWithNumber = function(input) {
    return /^[0-9]/.test(input);
};


/***/ }),

/***/ 41332:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ isTouchScreenDevice; }
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79758);

var isTouchScreenOperationSystem = function(userAgent) {
    return /\b(BlackBerry|webOS|iPhone|IEMobile)\b/i.test(userAgent) || /\b(Android|Windows Phone|iPad|iPod)\b/i.test(userAgent);
};
var isTouchScreenDevice = function() {
    if (_constants__WEBPACK_IMPORTED_MODULE_0__/* .isServer */ .sk) {
        return false;
    }
    var UA = navigator.userAgent;
    var hasTouchScreen = false;
    if ("maxTouchPoints" in navigator) {
        if (window.screen.width >= 1024) {
            hasTouchScreen = isTouchScreenOperationSystem(UA);
        } else {
            hasTouchScreen = navigator.maxTouchPoints > 0;
        }
    } else {
        var mQ = typeof window.matchMedia === "function" && matchMedia("(pointer:coarse)");
        if (mQ && mQ.media === "(pointer:coarse)") {
            hasTouchScreen = !!mQ.matches;
        } else if ("orientation" in window) {
            hasTouchScreen = true; // deprecated, but good fallback
        } else {
            // Only as a last resort, fall back to user agent sniffing
            hasTouchScreen = isTouchScreenOperationSystem(UA);
        }
    }
    return hasTouchScreen;
};


/***/ }),

/***/ 79302:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Sr": function() { return /* binding */ getLocaleFromRequest; },
  "GB": function() { return /* binding */ getLocaleFromUrl; },
  "p5": function() { return /* binding */ getMappedCountryCode; },
  "bH": function() { return /* binding */ getUrlFromLocale; },
  "VJ": function() { return /* binding */ parseRequestUrl; },
  "Ns": function() { return /* binding */ parseUrlData; },
  "g5": function() { return /* binding */ removeLocalePrefix; }
});

// UNUSED EXPORTS: getCountryLanguageFromLocale

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_sliced_to_array.mjs
var src_sliced_to_array = __webpack_require__(5341);
;// CONCATENATED MODULE: ./i18n.json
var i18n_namespaceObject = JSON.parse('{"locales":["de-DE","en-AU","en-CA","en-DE","en-GB","en-IN","en-NZ","en-US","es-US","fr-CA","ja-JP","en-BG","en-LT"],"defaultLocale":"en-CA","domains":[{"domain":"au.puma.com","defaultLocale":"en-AU","locales":["en-AU"]},{"domain":"ca.puma.com","defaultLocale":"en-CA","locales":["fr-CA","en-CA"]},{"domain":"eu.puma.com","defaultLocale":"en-DE","locales":["en-DE","de-DE","en-BG","en-LT"]},{"domain":"in.puma.com","defaultLocale":"en-IN","locales":["en-IN"]},{"domain":"jp.puma.com","defaultLocale":"ja-JP","locales":["ja-JP"]},{"domain":"nz.puma.com","defaultLocale":"en-NZ","locales":["en-NZ"]},{"domain":"uk.puma.com","defaultLocale":"en-GB","locales":["en-GB"]},{"domain":"us.puma.com","defaultLocale":"en-US","locales":["es-US","en-US"]}],"urlCountryCodeMap":{"UK":"GB"}}');
;// CONCATENATED MODULE: ./utils/locale.ts


/**
 * Returns the remapped country code for countries that use
 * alternate ISO country codes such as UK
 * @param countryCode The ISO country code
 */ var getMappedCountryCode = function(countryCode) {
    var ref;
    var mapping = Object.keys(i18n_namespaceObject.urlCountryCodeMap).reduce(function(result, key) {
        result[i18n_namespaceObject.urlCountryCodeMap[key]] = key;
        return result;
    }, {});
    return (ref = mapping[countryCode.toUpperCase()]) === null || ref === void 0 ? void 0 : ref.toLowerCase();
};
/**
 * Gets a URL path prefix for the current locale
 * @param locale The locale
 */ var getUrlFromLocale = function(locale) {
    if (!locale) {
        locale = i18n_namespaceObject.defaultLocale;
    }
    var ref = (0,src_sliced_to_array/* default */.Z)(locale.split("-"), 2), language = ref[0], country = ref[1];
    var urlCountry = getMappedCountryCode(country) || country.toLowerCase();
    return "/".concat(urlCountry, "/").concat(language);
};
/**
 * Gets a locale string from the NextJS Router query parameters
 * Should only be used in client side code.
 * For SSR, use `getLocaleFromRequest` method
 * @param query Incoming Nextjs Router query
 */ var getLocaleFromUrl = function(query) {
    var requestInfo = parseUrlData(query);
    return getLocaleString(requestInfo);
};
/**
 * Gets the locale information from the NextJS Router query parameters
 * Should only be used in client side code.
 * For SSR, use `parseRequestUrl` method
 * @param query Incoming Nextjs Router query
 */ var parseUrlData = function(query) {
    var ref, ref1;
    var language = query.language, country = query.country;
    var ucCountry = (ref = country) === null || ref === void 0 ? void 0 : ref.toUpperCase();
    return {
        language: language,
        country: ((ref1 = i18n_namespaceObject.urlCountryCodeMap[ucCountry]) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase()) || country
    };
};
/**
 * Gets a locale string from the NextJS Request
 * Should only be used in SSR code.
 * For client side, use `getLocaleFromUrl` method
 * @param request Incoming Nextjs request
 */ var getLocaleFromRequest = function(request) {
    var requestInfo = parseRequestUrl(request);
    return getLocaleString(requestInfo);
};
/**
 * Gets the locale information from the NextJS Request
 * Should only be used in SSR code.
 * For client side, use `parseUrlData` method
 * @param request Incoming Nextjs request
 */ var parseRequestUrl = function(request) {
    var ref;
    var url = request.url || "";
    var host = request.headers.host;
    // The requested URL that we can extract country and language
    // to create the locale that the user requested
    var ref1 = (0,src_sliced_to_array/* default */.Z)(url.split("?"), 1), pathname = ref1[0];
    var ref2 = (0,src_sliced_to_array/* default */.Z)(pathname.split("/").slice(1), 2), country = ref2[0], language = ref2[1];
    // all requests at this stage MUST have a language and country in the URL
    if (!(language && country)) {
        var ref3;
        // We are rendering a page outside of the
        // `pages/[country]/[language]/*` directory and we must
        // provide a default locale for the domain in order
        // for special pages like _error and 404 to prerender
        var domain = ((ref3 = i18n_namespaceObject.domains) === null || ref3 === void 0 ? void 0 : ref3.find(function(param) {
            var domain = param.domain;
            return domain === host;
        })) || i18n_namespaceObject;
        var ref4 = (0,src_sliced_to_array/* default */.Z)(domain.defaultLocale.split("-"), 2), defaultLanguage = ref4[0], defaultCountry = ref4[1];
        language = defaultLanguage.toLowerCase();
        country = defaultCountry.toLowerCase();
    }
    return {
        language: language,
        // country codes can be remapped for vanity (uk => gb)
        country: ((ref = i18n_namespaceObject.urlCountryCodeMap[country.toUpperCase()]) === null || ref === void 0 ? void 0 : ref.toLowerCase()) || country
    };
};
/**
 * Returns the url path without the locale prefix
 * @param path The NextJS Router url path
 * @param locale The locale
 */ var removeLocalePrefix = function(path, locale) {
    var prefix = getUrlFromLocale(locale);
    return path.replace(prefix, "");
};
// create an ISO locale string from locale information
function getLocaleString(requestInfo) {
    if (requestInfo.country && requestInfo.language) {
        return "".concat(requestInfo.language.toLowerCase(), "-").concat(requestInfo.country.toUpperCase());
    }
    return "";
}
function getCountryLanguageFromLocale(locale) {
    var ref = _sliced_to_array(locale.split("-"), 2), language = ref[0], country = ref[1];
    return {
        language: language,
        country: country
    };
}


/***/ }),

/***/ 44321:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ matchStateAndPostalCode; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23842);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59312);
/* harmony import */ var sites_in_states__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75750);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79758);




// Below method uses google Geocoding API to check for valid postalCode
// in addition to whether the postalCode is from the state selected
// https://developers.google.com/maps/documentation/geocoding/overview
var matchStateAndPostalCode = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(param) {
        var postalCode, googleApiKey, stateCode, country, isUs, isUsArmedForces, isUsTerritory, _tmp, geocodeResult, filteredForCountry, _tmp1, filteredForState, getCorrectedStateCode, _tmp2, _tmp3, _tmp4;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    postalCode = param.postalCode, googleApiKey = param.googleApiKey, stateCode = param.stateCode, country = param.country;
                    country = country.toUpperCase();
                    isUs = country === _constants__WEBPACK_IMPORTED_MODULE_1__/* .SUPPORTED_COUNTRY.US */ .bM.US;
                    isUsArmedForces = isUs && stateCode && Object.keys(_constants__WEBPACK_IMPORTED_MODULE_1__/* .UNITED_STATES_ARMED_FORCES */ .yN).includes(stateCode);
                    isUsTerritory = isUs && stateCode && Object.keys(_constants__WEBPACK_IMPORTED_MODULE_1__/* .UNITED_STATES_TERRITORY */ .Od).includes(stateCode);
                    _tmp = {};
                    if (isUsArmedForces) {
                        return [
                            2,
                            (_tmp.isValid = true, _tmp.isMatch = true, _tmp.geoStateCode = stateCode, _tmp)
                        ];
                    }
                    if (isUsTerritory) {
                        country = stateCode;
                    }
                    return [
                        4,
                        fetch("https://maps.googleapis.com/maps/api/geocode/json?address=".concat(postalCode === null || postalCode === void 0 ? void 0 : postalCode.toUpperCase(), "&components=country:").concat(country, "&key=").concat(googleApiKey)).then(function(data) {
                            return data.json();
                        }).catch(function(error) {
                            // eslint-disable-next-line no-console
                            console.error("Error while fetching geocode result for postalCode: ".concat(postalCode), error);
                            return {
                                isValid: false,
                                isMatch: false,
                                geoStateCode: null
                            };
                        })
                    ];
                case 1:
                    geocodeResult = _state.sent();
                    _tmp1 = {};
                    _tmp2 = {};
                    _tmp3 = {};
                    _tmp4 = {};
                    if (geocodeResult.status === "OK" && geocodeResult.results.length > 0) {
                        filteredForCountry = geocodeResult.results[0].address_components.find(function(address) {
                            return address.types.includes("country");
                        });
                        if ((filteredForCountry === null || filteredForCountry === void 0 ? void 0 : filteredForCountry.short_name) && (filteredForCountry === null || filteredForCountry === void 0 ? void 0 : filteredForCountry.short_name.toUpperCase()) !== country) {
                            return [
                                2,
                                (_tmp1.isValid = false, _tmp1.isMatch = false, _tmp1.geoStateCode = null, _tmp1)
                            ];
                        }
                        filteredForState = geocodeResult.results[0].address_components.find(function(address) {
                            if (isUsTerritory) {
                                return geocodeResult.results[0].types.includes("postal_code") && address.types.includes("country");
                            }
                            return address.types.includes("administrative_area_level_1");
                        });
                        getCorrectedStateCode = function(stateCode) {
                            if (!stateCode) return;
                            if (country === _constants__WEBPACK_IMPORTED_MODULE_1__/* .SUPPORTED_COUNTRY.IN */ .bM.IN) {
                                return getIndiaISOStateCode(stateCode);
                            }
                            return stateCode;
                        };
                        if ((filteredForState === null || filteredForState === void 0 ? void 0 : filteredForState.short_name) === getCorrectedStateCode(stateCode)) {
                            return [
                                2,
                                (_tmp2.isValid = true, _tmp2.isMatch = true, _tmp2.geoStateCode = stateCode, _tmp2)
                            ];
                        }
                        return [
                            2,
                            (_tmp3.isValid = true, _tmp3.isMatch = false, _tmp3.geoStateCode = filteredForState === null || filteredForState === void 0 ? void 0 : filteredForState.short_name, _tmp3)
                        ];
                    } else {
                        // postalCode not found
                        return [
                            2,
                            (_tmp4.isValid = false, _tmp4.isMatch = false, _tmp4.geoStateCode = null, _tmp4)
                        ];
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return function matchStateAndPostalCode(_) {
        return _ref.apply(this, arguments);
    };
}();
/** Salesforce uses non-standard state codes for India. This takes the
 * Salesforce state code and returns the `ISO 3166-2:IN` state code. */ var getIndiaISOStateCode = function(stateCode) {
    var mappedState = sites_in_states__WEBPACK_IMPORTED_MODULE_0__/* .inStates.find */ .k.find(function(state) {
        return stateCode === state.value;
    });
    var ref;
    return (ref = mappedState === null || mappedState === void 0 ? void 0 : mappedState.isoCompliantValue) !== null && ref !== void 0 ? ref : stateCode;
};


/***/ }),

/***/ 39772:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ getIsMobile; },
/* harmony export */   "w": function() { return /* binding */ getIsDesktop; }
/* harmony export */ });
/* harmony import */ var twind_css__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49224);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79758);


var getIsMobile = function() {
    return !_constants__WEBPACK_IMPORTED_MODULE_1__/* .isServer */ .sk && matchMedia(twind_css__WEBPACK_IMPORTED_MODULE_0__.tw.theme("screens.mobile").raw).matches;
};
var getIsDesktop = function() {
    return !_constants__WEBPACK_IMPORTED_MODULE_1__/* .isServer */ .sk && matchMedia(twind_css__WEBPACK_IMPORTED_MODULE_0__.tw.theme("screens.desktop").raw).matches;
};


/***/ }),

/***/ 57000:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ merge; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(15963);

var mergeInternal = function(target, source) {
    if (!source || !(0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(source, Object)) {
        return source;
    }
    var realTarget = target ? target : Array.isArray(source) ? [] : {};
    Object.keys(source).map(function(key) {
        realTarget[key] = mergeInternal(realTarget[key], source[key]);
    });
    return realTarget;
};
var merge = function(target, source) {
    if (!source || !(0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(source, Object)) {
        // @ts-expect-error
        return target;
    }
    var clonedTarget = JSON.parse(JSON.stringify(target));
    Object.keys(source).map(function(key) {
        clonedTarget[key] = mergeInternal(clonedTarget[key], source[key]);
    });
    return clonedTarget;
};


/***/ }),

/***/ 7676:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "PO": function() { return /* binding */ isPlainObject; },
/* harmony export */   "Ql": function() { return /* binding */ resolveNode; },
/* harmony export */   "_h": function() { return /* binding */ avoidEmptyProperties; }
/* harmony export */ });
/**
 * Resolves node in `obj` by `path`
 * @param path - path in the object string or string[]
 * @param obj - object
 * @param separator - separator used in the path
 * @return object | object[] | undefined
 */ var resolveNode = function(path, obj) {
    var separator = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ".";
    if (Array.isArray(path) && !path.length) return undefined;
    var properties = Array.isArray(path) ? path : path.split(separator);
    return (properties || []).reduce(function(prev, curr) {
        return prev && prev[curr];
    }, obj);
};
var avoidEmptyProperties = function(object) {
    var objectModified = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.keys(object)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var propertyName = _step.value;
            if (typeof object[propertyName] !== "undefined") {
                objectModified[propertyName] = object[propertyName];
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return objectModified;
};
var isPlainObject = function(maybeObject) {
    return !!maybeObject && typeof maybeObject === "object" && // @ts-expect-error -- __proto__ is what we check for, can be null.
    (maybeObject.__proto__ === null || // @ts-expect-error -- __proto__ is what we check for, can be null.
    maybeObject.__proto__ === Object.prototype);
};


/***/ }),

/***/ 49341:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "IU": function() { return /* binding */ encodeFilters; },
/* harmony export */   "RF": function() { return /* binding */ isValidFilter; },
/* harmony export */   "id": function() { return /* binding */ decodeFilters; },
/* harmony export */   "lq": function() { return /* binding */ encodeFilterName; }
/* harmony export */ });
/* unused harmony export decodeFilterName */
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5341);

var prefix = "pref_";
var encodeFilters = function(filters) {
    var encoded = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.entries(filters)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _value = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_step.value, 2), k = _value[0], v = _value[1];
            if (v) encoded[encodeFilterName(k)] = v;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return encoded;
};
var decodeFilters = function(filters) {
    var decoded = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.entries(filters)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _value = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_step.value, 2), k = _value[0], v = _value[1];
            var decodedKey = decodeFilterName(k);
            if (decodedKey !== null && v) decoded[decodedKey] = v;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return decoded;
};
var isValidFilter = function(filterName) {
    return filterName.startsWith(prefix);
};
var encodeFilterName = function(filterName) {
    return "".concat(prefix).concat(filterName);
};
var decodeFilterName = function(filterName) {
    if (!isValidFilter(filterName)) return null;
    return filterName.replace(prefix, "");
};


/***/ }),

/***/ 1032:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "NN": function() { return /* binding */ getMaxQuantity; },
/* harmony export */   "Og": function() { return /* binding */ DIGITAL_GIFT_CARD_NAME; },
/* harmony export */   "g0": function() { return /* binding */ wellKnownFilterIds; },
/* harmony export */   "hJ": function() { return /* binding */ getSizesFromSizeGroups; },
/* harmony export */   "tN": function() { return /* binding */ createListVariables; },
/* harmony export */   "ur": function() { return /* binding */ MAX_PRODUCT_PAGE_SIZE; }
/* harmony export */ });
/* unused harmony export getFinalProductPrice */
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31373);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5341);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3204);
/* harmony import */ var _productFilters__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49341);




// These filters have specific UI.
var wellKnownFilterIds = {
    color: "color",
    size: "size",
    price: "price",
    minMaxPriceRange: "minMaxPriceRange"
};
var DIGITAL_GIFT_CARD_NAME = "Digital Gift Card";
var MAX_PRODUCT_PAGE_SIZE = 24;
var createListVariables = function(_param) {
    var q = _param.q, limit = _param.limit, offset = _param.offset, sort = _param.sort, restQuery = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_param, [
        "q",
        "limit",
        "offset",
        "sort"
    ]);
    var filters = [];
    var validFilters = (0,_productFilters__WEBPACK_IMPORTED_MODULE_1__/* .decodeFilters */ .id)(restQuery);
    var minPrice = validFilters.minPrice, maxPrice = validFilters.maxPrice, remainingValidFilters = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(validFilters, [
        "minPrice",
        "maxPrice"
    ]);
    Object.entries(remainingValidFilters).forEach(function(param) {
        var _$_param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(param, 2), k = _$_param[0], v = _$_param[1];
        if (v && typeof v === "string") {
            filters.push({
                id: k,
                values: v.split(",")
            });
        }
    });
    if (minPrice && maxPrice) {
        filters.push({
            id: wellKnownFilterIds.price,
            values: [
                minPrice,
                maxPrice
            ]
        });
    }
    return {
        q: q,
        offset: Number(offset) || 0,
        limit: Number(limit) || MAX_PRODUCT_PAGE_SIZE,
        sort: sort,
        filters: filters,
        isDraft: "false"
    };
};
var getMaxQuantity = function(param) {
    var _maxOrderableQuantity = param.maxOrderableQuantity, maxOrderableQuantity = _maxOrderableQuantity === void 0 ? 1 : _maxOrderableQuantity, _inventoryQuantity = param.inventoryQuantity, inventoryQuantity = _inventoryQuantity === void 0 ? 0 : _inventoryQuantity;
    return inventoryQuantity && inventoryQuantity < maxOrderableQuantity ? inventoryQuantity : maxOrderableQuantity;
};
var getSizesFromSizeGroups = function(sizeGroups) {
    var allSizes = sizeGroups === null || sizeGroups === void 0 ? void 0 : sizeGroups.flatMap(function(x) {
        return x.sizes;
    });
    var uniqueSizes = new Map();
    if (allSizes) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = allSizes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var size = _step.value;
                if (!uniqueSizes.has(size.value)) uniqueSizes.set(size.value, size);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(uniqueSizes.values());
    }
    return [];
};
var getFinalProductPrice = function(product) {
    if (product) {
        var ref, ref1, ref2;
        var ref3, ref4, ref5, ref6;
        var finalPrice = (ref6 = (ref5 = (ref4 = (ref3 = (ref = product.productPrice) === null || ref === void 0 ? void 0 : ref.promotionPrice) !== null && ref3 !== void 0 ? ref3 : (ref1 = product.productPrice) === null || ref1 === void 0 ? void 0 : ref1.salePrice) !== null && ref4 !== void 0 ? ref4 : (ref2 = product.productPrice) === null || ref2 === void 0 ? void 0 : ref2.price) !== null && ref5 !== void 0 ? ref5 : product.salePrice) !== null && ref6 !== void 0 ? ref6 : product.price;
        return finalPrice;
    }
};


/***/ }),

/***/ 78474:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ NotificationQueryParams; },
/* harmony export */   "v": function() { return /* binding */ NewsletterQueryParams; }
/* harmony export */ });
var NewsletterQueryParams;
(function(NewsletterQueryParams) {
    NewsletterQueryParams["EmailList"] = "emailList";
})(NewsletterQueryParams || (NewsletterQueryParams = {}));
var NotificationQueryParams;
(function(NotificationQueryParams) {
    NotificationQueryParams["SmsUpdate"] = "smsUpdate";
})(NotificationQueryParams || (NotificationQueryParams = {}));


/***/ }),

/***/ 88313:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A5": function() { return /* binding */ serializeHeaderToList; },
/* harmony export */   "H6": function() { return /* binding */ serializeBlockContent; },
/* harmony export */   "Mr": function() { return /* binding */ Prose; },
/* harmony export */   "Yi": function() { return /* binding */ BlockContentLink; },
/* harmony export */   "lw": function() { return /* binding */ serializeTocBlockContent; }
/* harmony export */ });
/* unused harmony export BlockContentLinkTarget */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(85034);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(70169);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19989);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27378);
/* harmony import */ var _sanity_block_content_to_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(57178);
/* harmony import */ var _sanity_block_content_to_react__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_sanity_block_content_to_react__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var twind_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(49224);
/* harmony import */ var ui_components_SanityImage__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(86468);
/* harmony import */ var ui_content_CallToActions__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85814);
/* harmony import */ var ui_elements_Link__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(68302);
/* harmony import */ var ui_content_FaqModule__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(62079);
/* harmony import */ var ui_content_Missing__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(64236);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n        * {\n          @apply break-words;\n        }\n        a {\n          text-decoration: none;\n        }\n        ul {\n          list-style-type: disc !important;\n          list-style-position: inside !important;\n        }\n        ul ul {\n          list-style-type: circle !important;\n        }\n        ul ul ul {\n          list-style-type: square !important;\n        }\n        ol {\n          list-style-type: decimal !important;\n          list-style-position: inside !important;\n        }\n        ol ol {\n          list-style-type: lower-alpha !important;\n        }\n        ol ol ol {\n          list-style-type: lower-roman !important;\n        }\n      "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}









var BlockContentLink = function(props, sCustomStyles, onClick) {
    var className = (0,twind_css__WEBPACK_IMPORTED_MODULE_4__.tw)("border-b-2 border-puma-black-500 hover:border-puma-gold-light text-base", sCustomStyles);
    if (props.mark._type === "mailLink") return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
        className: className,
        href: props.mark.link || props.mark.href,
        rel: "noreferrer",
        target: "_blank",
        onClick: onClick,
        children: props.children
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: props.mark.link || props.mark.href ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ui_elements_Link__WEBPACK_IMPORTED_MODULE_7__/* .Link */ .r, {
            href: props.mark.link || props.mark.href,
            className: className,
            newtab: props.mark.newtab,
            onClick: onClick,
            children: props.children
        }) : null
    });
};
/** Add an `id` attribute to an element so it can be a "link target" (e.g. "#element-id"). */ var BlockContentLinkTarget = function(param) {
    var _type = param._type, children = param.children, mark = param.mark;
    var Tag = _type;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                className: "invisible -top-24 relative inline-block",
                id: mark.id
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Tag, {
                children: children
            })
        ]
    });
};
var getHeadingBlock = function(id, children) {
    var className = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
        className: "".concat(className, " font-bold font-display leading-tight mb-2"),
        id: id,
        children: children
    });
};
var serializeBlockContent = {
    types: {
        cta: function Cta(props) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "mt-2",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ui_content_CallToActions__WEBPACK_IMPORTED_MODULE_6__/* .CallToActions */ .l, {
                    ctas: [
                        props.node
                    ],
                    className: "inline-flex"
                })
            });
        },
        block: function(props) {
            var _node = props.node, style = _node.style, _key = _node._key, children = props.children;
            switch(style){
                case "h1":
                    return getHeadingBlock(_key, children, "text-3xl md:text-4xl");
                case "h2":
                    return getHeadingBlock(_key, children, "text-2xl md:text-3xl");
                case "h3":
                    return getHeadingBlock(_key, children, "text-xl md:text-2xl");
                case "h4":
                    return getHeadingBlock(_key, children, "text-lg md:text-xl");
                case "h5":
                    return getHeadingBlock(_key, children, "text md:text-lg");
                case "h6":
                    return getHeadingBlock(_key, children);
                case "blockquote":
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("blockquote", {
                        className: "p-2 my-2 bg-gray-50 border-l-4 border-gray-300 dark:border-gray-500 dark:bg-gray-800",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("p", {
                            className: "italic font-medium leading-relaxed text-gray-900",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                    children: '"'
                                }),
                                children,
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                    children: '"'
                                })
                            ]
                        })
                    });
                case "normal":
                    return children.length === 1 && children[0] === "" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br", {}) : _sanity_block_content_to_react__WEBPACK_IMPORTED_MODULE_3___default().defaultSerializers.types.block(props);
                default:
                    return _sanity_block_content_to_react__WEBPACK_IMPORTED_MODULE_3___default().defaultSerializers.types.block(props);
            }
        },
        image: function(param) {
            var node = param.node;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ui_components_SanityImage__WEBPACK_IMPORTED_MODULE_5__/* .SanityImage */ .d, {
                source: node,
                relative: true,
                className: "bg-transparent"
            });
        },
        table: function(param) {
            var node = param.node;
            var ref;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("table", {
                className: "table-auto border-collapse border border-gray-300 w-full mt-2 mb-2",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("tbody", {
                    children: (ref = node.rows) === null || ref === void 0 ? void 0 : ref.map(function(row) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("tr", {
                            className: "border-t",
                            children: row.cells.map(function(cell, index) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("td", {
                                    className: "border px-4 py-2",
                                    children: cell
                                }, index);
                            })
                        }, row._key);
                    })
                })
            });
        },
        FaqModule: function(param) {
            var node = param.node;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ui_content_FaqModule__WEBPACK_IMPORTED_MODULE_8__/* .FaqModule */ .S, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, node), {
                inPortableText: true
            }));
        },
        Widget: function(param) {
            var node = param.node;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ui_content_Missing__WEBPACK_IMPORTED_MODULE_9__/* .Missing */ .J, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, node)); //TODO Add the correct Widget component when it is implemented.
        }
    },
    list: function(param) {
        var type = param.type, children = param.children;
        switch(type){
            case "bullet":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("ul", {
                    className: "list-disc list-inside ml-4",
                    children: children
                });
            case "number":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("ol", {
                    className: "list-decimal list-inside ml-4",
                    children: children
                });
            default:
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("ul", {
                    children: children
                });
        }
    },
    listItem: function(param) {
        var children = param.children;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("li", {
            className: "mb-2 text-left",
            children: children
        });
    },
    marks: {
        absoluteLink: BlockContentLink,
        internalLink: BlockContentLink,
        linkTarget: BlockContentLinkTarget,
        mailLink: BlockContentLink,
        sub: function(param) {
            var children = param.children;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("sub", {
                children: children
            });
        },
        sup: function(param) {
            var children = param.children;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("sup", {
                children: children
            });
        },
        code: function(param) {
            var children = param.children;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("code", {
                children: children
            });
        },
        highlight: function(param) {
            var children = param.children;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                className: "bg-puma-red text-white",
                children: children
            });
        }
    }
};
var serializeHeaderToList = {
    types: {
        block: function(props) {
            if (/^h\d/.test(props.node.style)) {
                return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.createElement("li", {}, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.createElement("a", {
                    href: "#".concat(props.node._key),
                    className: "text-sm underline"
                }, props.children));
            }
            return _sanity_block_content_to_react__WEBPACK_IMPORTED_MODULE_3___default().defaultSerializers.types.block(props);
        }
    }
};
var TocBlockContentLink = function(props) {
    return BlockContentLink(props, "text-xs");
};
var serializeTocBlockContent = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, serializeBlockContent), {
    marks: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, serializeBlockContent.marks), {
        internalLink: TocBlockContentLink,
        absoluteLink: TocBlockContentLink
    })
});
var Prose = function(param) {
    var content = param.content;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((_sanity_block_content_to_react__WEBPACK_IMPORTED_MODULE_3___default()), {
        className: (0,twind_css__WEBPACK_IMPORTED_MODULE_4__.tw)("prose md:prose-m max-w-full", (0,twind_css__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject())),
        renderContainerOnSingleChild: true,
        blocks: content,
        serializers: serializeBlockContent
    });
};


/***/ }),

/***/ 12874:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Df": function() { return /* binding */ lowerCaseRemoveSpecialChars; },
/* harmony export */   "Ms": function() { return /* binding */ lowerCaseOrBlank; },
/* harmony export */   "Om": function() { return /* binding */ normalizeDiacriticalCharacters; },
/* harmony export */   "Wq": function() { return /* binding */ upperCaseOrBlank; },
/* harmony export */   "zW": function() { return /* binding */ toCamelCase; }
/* harmony export */ });
/* unused harmony export withTrailingSpaceOrEmpty */
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3204);

var withTrailingSpaceOrEmpty = function(v) {
    return v ? "".concat(v, " ") : "";
};
var ref;
var lowerCaseOrBlank = function(val) {
    return (ref = val === null || val === void 0 ? void 0 : val.toLowerCase()) !== null && ref !== void 0 ? ref : "";
};
var ref1;
var upperCaseOrBlank = function(val) {
    return (ref1 = val === null || val === void 0 ? void 0 : val.toUpperCase()) !== null && ref1 !== void 0 ? ref1 : "";
};
var ref2;
var lowerCaseRemoveSpecialChars = function(val) {
    return (ref2 = val === null || val === void 0 ? void 0 : val.replace(/[^a-zA-Z0-9- ]/g, "").toLowerCase()) !== null && ref2 !== void 0 ? ref2 : "";
};
var normalizeDiacriticalCharacters = function(val) {
    return val.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
};
var toCamelCase = function(val) {
    if (!val) return "";
    var punctuation = /[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]/g;
    var splittedString = val && val.replaceAll(punctuation, " ").split(" ");
    var camelCasedWord = splittedString.reduce(function(acc, curr, idx) {
        if (idx === 0) return [
            curr.toLowerCase()
        ];
        if (!curr.length) return acc;
        var capitalizedWord = curr.charAt(0).toUpperCase() + curr.slice(1).toLowerCase();
        return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(acc).concat([
            capitalizedWord
        ]);
    }, []).join("");
    return camelCasedWord;
};


/***/ }),

/***/ 27058:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ invertedTextMask; }
/* harmony export */ });
/* unused harmony export textMask */
/**
 * This function masks the start and end of the
 * input text according to the parameters given.
 * @param {string} input - The input string to be masked
 * @param {number} leftPadding - The number of characters to mask from the left (default: `0`)
 * @param {number} rightPadding - The number of characters to mask from the right (default: `0`)
 * @param {string} maskCharacter - The character to use as a mask (default: `*`)
 */ var textMask = function(input) {
    var leftPadding = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, rightPadding = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, maskCharacter = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "*";
    input !== null && input !== void 0 ? input : input = ""; // coalesce to empty string if undefined
    // Normalise padding to zero if negative numbers are provided
    leftPadding = Math.max(leftPadding, 0);
    rightPadding = Math.max(rightPadding, 0);
    var lengthOfLeftString = Math.max(input.length - rightPadding, 0);
    return "".concat(input).slice(leftPadding, lengthOfLeftString).padStart(lengthOfLeftString, maskCharacter).padEnd(input.length, maskCharacter);
};
/**
 * This function masks the middle of the
 * input text according to the parameters given.
 * @param {string} input - The input string to be masked
 * @param {number} leftCharsToShow - The number of characters to show on the left (default: `0`)
 * @param {number} rightCharsToShow - The number of characters to show on the right (default: `0`)
 * @param {string} maskCharacter - The character to use as a mask (default: `*`)
 */ var invertedTextMask = function(input) {
    var leftCharsToShow = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, rightCharsToShow = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, maskCharacter = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "*";
    input !== null && input !== void 0 ? input : input = ""; // coalesce to empty string if undefined
    // Return the original string if charsToShow are >= the input string
    if (leftCharsToShow >= input.length || rightCharsToShow >= input.length) return input;
    // Normalise padding to zero if negative numbers are provided
    leftCharsToShow = Math.min(Math.max(leftCharsToShow, 0), input.length);
    rightCharsToShow = Math.min(Math.max(rightCharsToShow, 0), input.length);
    var left = "".concat(input).slice(0, leftCharsToShow);
    var right = "".concat(input).slice(input.length - rightCharsToShow);
    var middle = "".padStart(input.length - leftCharsToShow - rightCharsToShow, maskCharacter);
    return "".concat(left).concat(middle).concat(right);
};


/***/ }),

/***/ 36662:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ toKebabCase; }
/* harmony export */ });
/**
 * converts string to kebab case
 * @param str - alphanumeric characters only
 */ var toKebabCase = function(string) {
    return string.replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[\s_]+/g, "-").toLowerCase();
};


/***/ }),

/***/ 19259:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ transformPlaces; }
/* harmony export */ });
/* harmony import */ var sites_in_states__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75750);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79758);


var getCity = function(address) {
    var city;
    // * The desired value for 'city' can sit in any of these three types
    [
        "postal_town",
        "locality",
        "sublocality_level_1"
    ].forEach(function(specificity) {
        if (!city) {
            city = getComponent(address, specificity);
        }
    });
    return city;
};
var getComponent = function(address, component) {
    return address.find(function(comp) {
        return comp.types.includes(component);
    });
};
var transformPlaces = function(googlePlaceResult) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    var address = googlePlaceResult.address_components;
    if (!address) return {};
    // * Google Maps API does not return 'postal_code' for addresses in Guam
    var postalCode = (ref = getComponent(address, "postal_code")) === null || ref === void 0 ? void 0 : ref.long_name;
    var street = (ref1 = getComponent(address, "route")) === null || ref1 === void 0 ? void 0 : ref1.long_name;
    var streetNumber = (ref2 = getComponent(address, "street_number")) === null || ref2 === void 0 ? void 0 : ref2.long_name;
    var premise = (ref3 = getComponent(address, "premise")) === null || ref3 === void 0 ? void 0 : ref3.long_name;
    var countryCode = (ref4 = getComponent(address, "country")) === null || ref4 === void 0 ? void 0 : ref4.short_name;
    var subpremise = (ref5 = getComponent(address, "subpremise")) === null || ref5 === void 0 ? void 0 : ref5.long_name;
    var companyName;
    if (countryCode === _constants__WEBPACK_IMPORTED_MODULE_1__/* .SUPPORTED_COUNTRY.GB */ .bM.GB) companyName = (googlePlaceResult === null || googlePlaceResult === void 0 ? void 0 : googlePlaceResult.name) || ((ref6 = getComponent(address, "subpremise")) === null || ref6 === void 0 ? void 0 : ref6.long_name) || premise;
    else companyName = subpremise;
    var locality = (ref7 = getComponent(address, "sublocality_level_1")) === null || ref7 === void 0 ? void 0 : ref7.long_name;
    var city = (ref8 = getCity(address)) === null || ref8 === void 0 ? void 0 : ref8.long_name;
    var stateCode = (ref9 = getComponent(address, "administrative_area_level_1")) === null || ref9 === void 0 ? void 0 : ref9.short_name;
    var address1 = function() {
        if (streetNumber && street) return "".concat(streetNumber, " ").concat(street);
        // there are no street details for some India locations
        // so adding these as fallback
        // if there's really nothing usable, return the place name
        if (premise && locality) return "".concat(premise, " ").concat(locality);
        // when postcode lookup is enabled, place name will default to the postcode
        // In that case we don't want to return an address1
        if (googlePlaceResult.name && googlePlaceResult.name !== postalCode) return googlePlaceResult.name;
    };
    var getCorrectedStateCode = function() {
        if (!stateCode) return;
        if (countryCode === _constants__WEBPACK_IMPORTED_MODULE_1__/* .GUAM */ .Ff) return _constants__WEBPACK_IMPORTED_MODULE_1__/* .GUAM */ .Ff;
        if (countryCode === _constants__WEBPACK_IMPORTED_MODULE_1__/* .SUPPORTED_COUNTRY.IN */ .bM.IN) {
            return getIndiaSalesforceStateCode(stateCode);
        }
        return stateCode;
    };
    var getCorrectedCountryCode = function() {
        if (countryCode === _constants__WEBPACK_IMPORTED_MODULE_1__/* .GUAM */ .Ff) return _constants__WEBPACK_IMPORTED_MODULE_1__/* .SUPPORTED_COUNTRY.US */ .bM.US;
        return countryCode;
    };
    return {
        address1: address1(),
        address2: companyName,
        city: city,
        postalCode: postalCode,
        stateCode: getCorrectedStateCode(),
        countryCode: getCorrectedCountryCode(),
        streetNumber: streetNumber,
        street: street,
        companyName: companyName
    };
};
/** Salesforce uses non-standard state codes for India. This takes the
 * `ISO 3166-2:IN` state code and returns the Salesforce state code. */ var getIndiaSalesforceStateCode = function(stateCode) {
    var mappedState = sites_in_states__WEBPACK_IMPORTED_MODULE_0__/* .inStates.find */ .k.find(function(state) {
        return stateCode === state.isoCompliantValue;
    });
    var ref;
    return (ref = mappedState === null || mappedState === void 0 ? void 0 : mappedState.value) !== null && ref !== void 0 ? ref : stateCode;
};


/***/ }),

/***/ 90901:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "RF": function() { return /* binding */ slotLink; },
/* harmony export */   "SL": function() { return /* binding */ getAccountRedirectLink; },
/* harmony export */   "sD": function() { return /* binding */ isAbsoluteUrl; },
/* harmony export */   "xy": function() { return /* binding */ isUrlSegment; }
/* harmony export */ });
/* unused harmony export buildUrl */
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79758);

// Used to check if the user is currently navigated to a path that the given link relates to.
// Will return a match if the current route is more specific than the link, but still begins with the same path.
// IE: link `/en/us/kids/boys` will return true for the url `/en/us/kids/boys/shoes`
// Used to highlight the link to show the user is currently viewing this category.
var isUrlSegment = function(link, category) {
    if (!(link === null || link === void 0 ? void 0 : link.href) || !Array.isArray(category)) return false;
    return category.join("/").startsWith(link.href.substring(1));
};
/**
 * Builds a URL with the given params.
 * @param url - The base URL to build from.
 * @param params - The params to append to the URL.
 * @example
 * buildUrl('/foo', { bar: 'baz' }) // => '/foo?bar=baz'
 */ var buildUrl = function(url, params) {
    var urlWithParams = new URL(url);
    Object.keys(params).forEach(function(key) {
        return urlWithParams.searchParams.append(key, params[key]);
    });
    return urlWithParams.href;
};
var getAccountRedirectLink = function(asPath) {
    if (asPath.includes("account")) {
        return {
            searchParams: "",
            asPathWithoutLocaleAndSearchParams: ""
        };
    }
    /**
   * Returns searchParams from the asPath while prefixing it with "&".
   * i.e. /in/en/something?foo=bar -> &foo=bar
   */ var searchParams = asPath.includes("?") ? "&".concat(asPath.split("?")[1]) : "";
    /**
   * Returns asPath without the locale
   * i.e. /in/en/something?foo=bar -> something?foo=bar
   */ var asPathWithoutLocale = asPath.split("/").splice(3).join("/");
    /**
   * Returns url without the searchParams.
   * i.e. /in/en/something?foo=bar -> in/en/something
   * and /in/en -> in/en
   */ var rootPath = asPathWithoutLocale.split("?")[0];
    var asPathWithoutLocaleAndSearchParams = rootPath && "&from=".concat(rootPath);
    return {
        searchParams: searchParams,
        asPathWithoutLocaleAndSearchParams: asPathWithoutLocaleAndSearchParams
    };
};
// Returns the correct link for the constent slot banner, depending on whether it's a cta or a clickeable banner.
var slotLink = function(linkType, ctas, link) {
    if (linkType === _constants__WEBPACK_IMPORTED_MODULE_0__/* .SLOT_LINK_TYPE.CTA */ .no.CTA && ctas && ctas[0]) return ctas[0];
    else return link;
};
/**
 * Checks if the given URL is an absolute URL.
 * @param href - The URL to check.
 * @returns True if the URL is absolute, false otherwise.
 */ var isAbsoluteUrl = function(href) {
    try {
        new URL(href);
        return true;
    } catch (e) {
        return false;
    }
};


/***/ }),

/***/ 34309:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __dirname = "/";
/* provided dependency */ var Buffer = __webpack_require__(30816)["Buffer"];
/* provided dependency */ var process = __webpack_require__(27061);
(function(){var e={7160:function(e,t,r){var i=t;i.bignum=r(711);i.define=r(495).define;i.base=r(853);i.constants=r(7335);i.decoders=r(6701);i.encoders=r(3418)},495:function(e,t,r){var i=r(7160);var n=r(3782);var a=t;a.define=function define(e,t){return new Entity(e,t)};function Entity(e,t){this.name=e;this.body=t;this.decoders={};this.encoders={}}Entity.prototype._createNamed=function createNamed(e){var t;try{t=r(6144).runInThisContext("(function "+this.name+"(entity) {\n"+"  this._initNamed(entity);\n"+"})")}catch(e){t=function(e){this._initNamed(e)}}n(t,e);t.prototype._initNamed=function initnamed(t){e.call(this,t)};return new t(this)};Entity.prototype._getDecoder=function _getDecoder(e){e=e||"der";if(!this.decoders.hasOwnProperty(e))this.decoders[e]=this._createNamed(i.decoders[e]);return this.decoders[e]};Entity.prototype.decode=function decode(e,t,r){return this._getDecoder(t).decode(e,r)};Entity.prototype._getEncoder=function _getEncoder(e){e=e||"der";if(!this.encoders.hasOwnProperty(e))this.encoders[e]=this._createNamed(i.encoders[e]);return this.encoders[e]};Entity.prototype.encode=function encode(e,t,r){return this._getEncoder(t).encode(e,r)}},6483:function(e,t,r){var i=r(3782);var n=r(853).Reporter;var a=r(4300).Buffer;function DecoderBuffer(e,t){n.call(this,t);if(!a.isBuffer(e)){this.error("Input not Buffer");return}this.base=e;this.offset=0;this.length=e.length}i(DecoderBuffer,n);t.C=DecoderBuffer;DecoderBuffer.prototype.save=function save(){return{offset:this.offset,reporter:n.prototype.save.call(this)}};DecoderBuffer.prototype.restore=function restore(e){var t=new DecoderBuffer(this.base);t.offset=e.offset;t.length=this.offset;this.offset=e.offset;n.prototype.restore.call(this,e.reporter);return t};DecoderBuffer.prototype.isEmpty=function isEmpty(){return this.offset===this.length};DecoderBuffer.prototype.readUInt8=function readUInt8(e){if(this.offset+1<=this.length)return this.base.readUInt8(this.offset++,true);else return this.error(e||"DecoderBuffer overrun")};DecoderBuffer.prototype.skip=function skip(e,t){if(!(this.offset+e<=this.length))return this.error(t||"DecoderBuffer overrun");var r=new DecoderBuffer(this.base);r._reporterState=this._reporterState;r.offset=this.offset;r.length=this.offset+e;this.offset+=e;return r};DecoderBuffer.prototype.raw=function raw(e){return this.base.slice(e?e.offset:this.offset,this.length)};function EncoderBuffer(e,t){if(Array.isArray(e)){this.length=0;this.value=e.map((function(e){if(!(e instanceof EncoderBuffer))e=new EncoderBuffer(e,t);this.length+=e.length;return e}),this)}else if(typeof e==="number"){if(!(0<=e&&e<=255))return t.error("non-byte EncoderBuffer value");this.value=e;this.length=1}else if(typeof e==="string"){this.value=e;this.length=a.byteLength(e)}else if(a.isBuffer(e)){this.value=e;this.length=e.length}else{return t.error("Unsupported type: "+typeof e)}}t.R=EncoderBuffer;EncoderBuffer.prototype.join=function join(e,t){if(!e)e=new a(this.length);if(!t)t=0;if(this.length===0)return e;if(Array.isArray(this.value)){this.value.forEach((function(r){r.join(e,t);t+=r.length}))}else{if(typeof this.value==="number")e[t]=this.value;else if(typeof this.value==="string")e.write(this.value,t);else if(a.isBuffer(this.value))this.value.copy(e,t);t+=this.length}return e}},853:function(e,t,r){var i=t;i.Reporter=r(1293).b;i.DecoderBuffer=r(6483).C;i.EncoderBuffer=r(6483).R;i.Node=r(9374)},9374:function(e,t,r){var i=r(853).Reporter;var n=r(853).EncoderBuffer;var a=r(853).DecoderBuffer;var s=r(3523);var o=["seq","seqof","set","setof","objid","bool","gentime","utctime","null_","enum","int","objDesc","bitstr","bmpstr","charstr","genstr","graphstr","ia5str","iso646str","numstr","octstr","printstr","t61str","unistr","utf8str","videostr"];var h=["key","obj","use","optional","explicit","implicit","def","choice","any","contains"].concat(o);var u=["_peekTag","_decodeTag","_use","_decodeStr","_decodeObjid","_decodeTime","_decodeNull","_decodeInt","_decodeBool","_decodeList","_encodeComposite","_encodeStr","_encodeObjid","_encodeTime","_encodeNull","_encodeInt","_encodeBool"];function Node(e,t){var r={};this._baseState=r;r.enc=e;r.parent=t||null;r.children=null;r.tag=null;r.args=null;r.reverseArgs=null;r.choice=null;r.optional=false;r.any=false;r.obj=false;r.use=null;r.useDecoder=null;r.key=null;r["default"]=null;r.explicit=null;r.implicit=null;r.contains=null;if(!r.parent){r.children=[];this._wrap()}}e.exports=Node;var d=["enc","parent","children","tag","args","reverseArgs","choice","optional","any","obj","use","alteredUse","key","default","explicit","implicit","contains"];Node.prototype.clone=function clone(){var e=this._baseState;var t={};d.forEach((function(r){t[r]=e[r]}));var r=new this.constructor(t.parent);r._baseState=t;return r};Node.prototype._wrap=function wrap(){var e=this._baseState;h.forEach((function(t){this[t]=function _wrappedMethod(){var r=new this.constructor(this);e.children.push(r);return r[t].apply(r,arguments)}}),this)};Node.prototype._init=function init(e){var t=this._baseState;s(t.parent===null);e.call(this);t.children=t.children.filter((function(e){return e._baseState.parent===this}),this);s.equal(t.children.length,1,"Root node can have only one child")};Node.prototype._useArgs=function useArgs(e){var t=this._baseState;var r=e.filter((function(e){return e instanceof this.constructor}),this);e=e.filter((function(e){return!(e instanceof this.constructor)}),this);if(r.length!==0){s(t.children===null);t.children=r;r.forEach((function(e){e._baseState.parent=this}),this)}if(e.length!==0){s(t.args===null);t.args=e;t.reverseArgs=e.map((function(e){if(typeof e!=="object"||e.constructor!==Object)return e;var t={};Object.keys(e).forEach((function(r){if(r==(r|0))r|=0;var i=e[r];t[i]=r}));return t}))}};u.forEach((function(e){Node.prototype[e]=function _overrided(){var t=this._baseState;throw new Error(e+" not implemented for encoding: "+t.enc)}}));o.forEach((function(e){Node.prototype[e]=function _tagMethod(){var t=this._baseState;var r=Array.prototype.slice.call(arguments);s(t.tag===null);t.tag=e;this._useArgs(r);return this}}));Node.prototype.use=function use(e){s(e);var t=this._baseState;s(t.use===null);t.use=e;return this};Node.prototype.optional=function optional(){var e=this._baseState;e.optional=true;return this};Node.prototype.def=function def(e){var t=this._baseState;s(t["default"]===null);t["default"]=e;t.optional=true;return this};Node.prototype.explicit=function explicit(e){var t=this._baseState;s(t.explicit===null&&t.implicit===null);t.explicit=e;return this};Node.prototype.implicit=function implicit(e){var t=this._baseState;s(t.explicit===null&&t.implicit===null);t.implicit=e;return this};Node.prototype.obj=function obj(){var e=this._baseState;var t=Array.prototype.slice.call(arguments);e.obj=true;if(t.length!==0)this._useArgs(t);return this};Node.prototype.key=function key(e){var t=this._baseState;s(t.key===null);t.key=e;return this};Node.prototype.any=function any(){var e=this._baseState;e.any=true;return this};Node.prototype.choice=function choice(e){var t=this._baseState;s(t.choice===null);t.choice=e;this._useArgs(Object.keys(e).map((function(t){return e[t]})));return this};Node.prototype.contains=function contains(e){var t=this._baseState;s(t.use===null);t.contains=e;return this};Node.prototype._decode=function decode(e,t){var r=this._baseState;if(r.parent===null)return e.wrapResult(r.children[0]._decode(e,t));var i=r["default"];var n=true;var s=null;if(r.key!==null)s=e.enterKey(r.key);if(r.optional){var o=null;if(r.explicit!==null)o=r.explicit;else if(r.implicit!==null)o=r.implicit;else if(r.tag!==null)o=r.tag;if(o===null&&!r.any){var h=e.save();try{if(r.choice===null)this._decodeGeneric(r.tag,e,t);else this._decodeChoice(e,t);n=true}catch(e){n=false}e.restore(h)}else{n=this._peekTag(e,o,r.any);if(e.isError(n))return n}}var u;if(r.obj&&n)u=e.enterObject();if(n){if(r.explicit!==null){var d=this._decodeTag(e,r.explicit);if(e.isError(d))return d;e=d}var c=e.offset;if(r.use===null&&r.choice===null){if(r.any)var h=e.save();var l=this._decodeTag(e,r.implicit!==null?r.implicit:r.tag,r.any);if(e.isError(l))return l;if(r.any)i=e.raw(h);else e=l}if(t&&t.track&&r.tag!==null)t.track(e.path(),c,e.length,"tagged");if(t&&t.track&&r.tag!==null)t.track(e.path(),e.offset,e.length,"content");if(r.any)i=i;else if(r.choice===null)i=this._decodeGeneric(r.tag,e,t);else i=this._decodeChoice(e,t);if(e.isError(i))return i;if(!r.any&&r.choice===null&&r.children!==null){r.children.forEach((function decodeChildren(r){r._decode(e,t)}))}if(r.contains&&(r.tag==="octstr"||r.tag==="bitstr")){var p=new a(i);i=this._getUse(r.contains,e._reporterState.obj)._decode(p,t)}}if(r.obj&&n)i=e.leaveObject(u);if(r.key!==null&&(i!==null||n===true))e.leaveKey(s,r.key,i);else if(s!==null)e.exitKey(s);return i};Node.prototype._decodeGeneric=function decodeGeneric(e,t,r){var i=this._baseState;if(e==="seq"||e==="set")return null;if(e==="seqof"||e==="setof")return this._decodeList(t,e,i.args[0],r);else if(/str$/.test(e))return this._decodeStr(t,e,r);else if(e==="objid"&&i.args)return this._decodeObjid(t,i.args[0],i.args[1],r);else if(e==="objid")return this._decodeObjid(t,null,null,r);else if(e==="gentime"||e==="utctime")return this._decodeTime(t,e,r);else if(e==="null_")return this._decodeNull(t,r);else if(e==="bool")return this._decodeBool(t,r);else if(e==="objDesc")return this._decodeStr(t,e,r);else if(e==="int"||e==="enum")return this._decodeInt(t,i.args&&i.args[0],r);if(i.use!==null){return this._getUse(i.use,t._reporterState.obj)._decode(t,r)}else{return t.error("unknown tag: "+e)}};Node.prototype._getUse=function _getUse(e,t){var r=this._baseState;r.useDecoder=this._use(e,t);s(r.useDecoder._baseState.parent===null);r.useDecoder=r.useDecoder._baseState.children[0];if(r.implicit!==r.useDecoder._baseState.implicit){r.useDecoder=r.useDecoder.clone();r.useDecoder._baseState.implicit=r.implicit}return r.useDecoder};Node.prototype._decodeChoice=function decodeChoice(e,t){var r=this._baseState;var i=null;var n=false;Object.keys(r.choice).some((function(a){var s=e.save();var o=r.choice[a];try{var h=o._decode(e,t);if(e.isError(h))return false;i={type:a,value:h};n=true}catch(t){e.restore(s);return false}return true}),this);if(!n)return e.error("Choice not matched");return i};Node.prototype._createEncoderBuffer=function createEncoderBuffer(e){return new n(e,this.reporter)};Node.prototype._encode=function encode(e,t,r){var i=this._baseState;if(i["default"]!==null&&i["default"]===e)return;var n=this._encodeValue(e,t,r);if(n===undefined)return;if(this._skipDefault(n,t,r))return;return n};Node.prototype._encodeValue=function encode(e,t,r){var n=this._baseState;if(n.parent===null)return n.children[0]._encode(e,t||new i);var a=null;this.reporter=t;if(n.optional&&e===undefined){if(n["default"]!==null)e=n["default"];else return}var s=null;var o=false;if(n.any){a=this._createEncoderBuffer(e)}else if(n.choice){a=this._encodeChoice(e,t)}else if(n.contains){s=this._getUse(n.contains,r)._encode(e,t);o=true}else if(n.children){s=n.children.map((function(r){if(r._baseState.tag==="null_")return r._encode(null,t,e);if(r._baseState.key===null)return t.error("Child should have a key");var i=t.enterKey(r._baseState.key);if(typeof e!=="object")return t.error("Child expected, but input is not object");var n=r._encode(e[r._baseState.key],t,e);t.leaveKey(i);return n}),this).filter((function(e){return e}));s=this._createEncoderBuffer(s)}else{if(n.tag==="seqof"||n.tag==="setof"){if(!(n.args&&n.args.length===1))return t.error("Too many args for : "+n.tag);if(!Array.isArray(e))return t.error("seqof/setof, but data is not Array");var h=this.clone();h._baseState.implicit=null;s=this._createEncoderBuffer(e.map((function(r){var i=this._baseState;return this._getUse(i.args[0],e)._encode(r,t)}),h))}else if(n.use!==null){a=this._getUse(n.use,r)._encode(e,t)}else{s=this._encodePrimitive(n.tag,e);o=true}}var a;if(!n.any&&n.choice===null){var u=n.implicit!==null?n.implicit:n.tag;var d=n.implicit===null?"universal":"context";if(u===null){if(n.use===null)t.error("Tag could be omitted only for .use()")}else{if(n.use===null)a=this._encodeComposite(u,o,d,s)}}if(n.explicit!==null)a=this._encodeComposite(n.explicit,false,"context",a);return a};Node.prototype._encodeChoice=function encodeChoice(e,t){var r=this._baseState;var i=r.choice[e.type];if(!i){s(false,e.type+" not found in "+JSON.stringify(Object.keys(r.choice)))}return i._encode(e.value,t)};Node.prototype._encodePrimitive=function encodePrimitive(e,t){var r=this._baseState;if(/str$/.test(e))return this._encodeStr(t,e);else if(e==="objid"&&r.args)return this._encodeObjid(t,r.reverseArgs[0],r.args[1]);else if(e==="objid")return this._encodeObjid(t,null,null);else if(e==="gentime"||e==="utctime")return this._encodeTime(t,e);else if(e==="null_")return this._encodeNull();else if(e==="int"||e==="enum")return this._encodeInt(t,r.args&&r.reverseArgs[0]);else if(e==="bool")return this._encodeBool(t);else if(e==="objDesc")return this._encodeStr(t,e);else throw new Error("Unsupported tag: "+e)};Node.prototype._isNumstr=function isNumstr(e){return/^[0-9 ]*$/.test(e)};Node.prototype._isPrintstr=function isPrintstr(e){return/^[A-Za-z0-9 '\(\)\+,\-\.\/:=\?]*$/.test(e)}},1293:function(e,t,r){var i=r(3782);function Reporter(e){this._reporterState={obj:null,path:[],options:e||{},errors:[]}}t.b=Reporter;Reporter.prototype.isError=function isError(e){return e instanceof ReporterError};Reporter.prototype.save=function save(){var e=this._reporterState;return{obj:e.obj,pathLen:e.path.length}};Reporter.prototype.restore=function restore(e){var t=this._reporterState;t.obj=e.obj;t.path=t.path.slice(0,e.pathLen)};Reporter.prototype.enterKey=function enterKey(e){return this._reporterState.path.push(e)};Reporter.prototype.exitKey=function exitKey(e){var t=this._reporterState;t.path=t.path.slice(0,e-1)};Reporter.prototype.leaveKey=function leaveKey(e,t,r){var i=this._reporterState;this.exitKey(e);if(i.obj!==null)i.obj[t]=r};Reporter.prototype.path=function path(){return this._reporterState.path.join("/")};Reporter.prototype.enterObject=function enterObject(){var e=this._reporterState;var t=e.obj;e.obj={};return t};Reporter.prototype.leaveObject=function leaveObject(e){var t=this._reporterState;var r=t.obj;t.obj=e;return r};Reporter.prototype.error=function error(e){var t;var r=this._reporterState;var i=e instanceof ReporterError;if(i){t=e}else{t=new ReporterError(r.path.map((function(e){return"["+JSON.stringify(e)+"]"})).join(""),e.message||e,e.stack)}if(!r.options.partial)throw t;if(!i)r.errors.push(t);return t};Reporter.prototype.wrapResult=function wrapResult(e){var t=this._reporterState;if(!t.options.partial)return e;return{result:this.isError(e)?null:e,errors:t.errors}};function ReporterError(e,t){this.path=e;this.rethrow(t)}i(ReporterError,Error);ReporterError.prototype.rethrow=function rethrow(e){this.message=e+" at: "+(this.path||"(shallow)");if(Error.captureStackTrace)Error.captureStackTrace(this,ReporterError);if(!this.stack){try{throw new Error(this.message)}catch(e){this.stack=e.stack}}return this}},9791:function(e,t,r){var i=r(7335);t.tagClass={0:"universal",1:"application",2:"context",3:"private"};t.tagClassByName=i._reverse(t.tagClass);t.tag={0:"end",1:"bool",2:"int",3:"bitstr",4:"octstr",5:"null_",6:"objid",7:"objDesc",8:"external",9:"real",10:"enum",11:"embed",12:"utf8str",13:"relativeOid",16:"seq",17:"set",18:"numstr",19:"printstr",20:"t61str",21:"videostr",22:"ia5str",23:"utctime",24:"gentime",25:"graphstr",26:"iso646str",27:"genstr",28:"unistr",29:"charstr",30:"bmpstr"};t.tagByName=i._reverse(t.tag)},7335:function(e,t,r){var i=t;i._reverse=function reverse(e){var t={};Object.keys(e).forEach((function(r){if((r|0)==r)r=r|0;var i=e[r];t[i]=r}));return t};i.der=r(9791)},2259:function(e,t,r){var i=r(3782);var n=r(7160);var a=n.base;var s=n.bignum;var o=n.constants.der;function DERDecoder(e){this.enc="der";this.name=e.name;this.entity=e;this.tree=new DERNode;this.tree._init(e.body)}e.exports=DERDecoder;DERDecoder.prototype.decode=function decode(e,t){if(!(e instanceof a.DecoderBuffer))e=new a.DecoderBuffer(e,t);return this.tree._decode(e,t)};function DERNode(e){a.Node.call(this,"der",e)}i(DERNode,a.Node);DERNode.prototype._peekTag=function peekTag(e,t,r){if(e.isEmpty())return false;var i=e.save();var n=derDecodeTag(e,'Failed to peek tag: "'+t+'"');if(e.isError(n))return n;e.restore(i);return n.tag===t||n.tagStr===t||n.tagStr+"of"===t||r};DERNode.prototype._decodeTag=function decodeTag(e,t,r){var i=derDecodeTag(e,'Failed to decode tag of "'+t+'"');if(e.isError(i))return i;var n=derDecodeLen(e,i.primitive,'Failed to get length of "'+t+'"');if(e.isError(n))return n;if(!r&&i.tag!==t&&i.tagStr!==t&&i.tagStr+"of"!==t){return e.error('Failed to match tag: "'+t+'"')}if(i.primitive||n!==null)return e.skip(n,'Failed to match body of: "'+t+'"');var a=e.save();var s=this._skipUntilEnd(e,'Failed to skip indefinite length body: "'+this.tag+'"');if(e.isError(s))return s;n=e.offset-a.offset;e.restore(a);return e.skip(n,'Failed to match body of: "'+t+'"')};DERNode.prototype._skipUntilEnd=function skipUntilEnd(e,t){while(true){var r=derDecodeTag(e,t);if(e.isError(r))return r;var i=derDecodeLen(e,r.primitive,t);if(e.isError(i))return i;var n;if(r.primitive||i!==null)n=e.skip(i);else n=this._skipUntilEnd(e,t);if(e.isError(n))return n;if(r.tagStr==="end")break}};DERNode.prototype._decodeList=function decodeList(e,t,r,i){var n=[];while(!e.isEmpty()){var a=this._peekTag(e,"end");if(e.isError(a))return a;var s=r.decode(e,"der",i);if(e.isError(s)&&a)break;n.push(s)}return n};DERNode.prototype._decodeStr=function decodeStr(e,t){if(t==="bitstr"){var r=e.readUInt8();if(e.isError(r))return r;return{unused:r,data:e.raw()}}else if(t==="bmpstr"){var i=e.raw();if(i.length%2===1)return e.error("Decoding of string type: bmpstr length mismatch");var n="";for(var a=0;a<i.length/2;a++){n+=String.fromCharCode(i.readUInt16BE(a*2))}return n}else if(t==="numstr"){var s=e.raw().toString("ascii");if(!this._isNumstr(s)){return e.error("Decoding of string type: "+"numstr unsupported characters")}return s}else if(t==="octstr"){return e.raw()}else if(t==="objDesc"){return e.raw()}else if(t==="printstr"){var o=e.raw().toString("ascii");if(!this._isPrintstr(o)){return e.error("Decoding of string type: "+"printstr unsupported characters")}return o}else if(/str$/.test(t)){return e.raw().toString()}else{return e.error("Decoding of string type: "+t+" unsupported")}};DERNode.prototype._decodeObjid=function decodeObjid(e,t,r){var i;var n=[];var a=0;while(!e.isEmpty()){var s=e.readUInt8();a<<=7;a|=s&127;if((s&128)===0){n.push(a);a=0}}if(s&128)n.push(a);var o=n[0]/40|0;var h=n[0]%40;if(r)i=n;else i=[o,h].concat(n.slice(1));if(t){var u=t[i.join(" ")];if(u===undefined)u=t[i.join(".")];if(u!==undefined)i=u}return i};DERNode.prototype._decodeTime=function decodeTime(e,t){var r=e.raw().toString();if(t==="gentime"){var i=r.slice(0,4)|0;var n=r.slice(4,6)|0;var a=r.slice(6,8)|0;var s=r.slice(8,10)|0;var o=r.slice(10,12)|0;var h=r.slice(12,14)|0}else if(t==="utctime"){var i=r.slice(0,2)|0;var n=r.slice(2,4)|0;var a=r.slice(4,6)|0;var s=r.slice(6,8)|0;var o=r.slice(8,10)|0;var h=r.slice(10,12)|0;if(i<70)i=2e3+i;else i=1900+i}else{return e.error("Decoding "+t+" time is not supported yet")}return Date.UTC(i,n-1,a,s,o,h,0)};DERNode.prototype._decodeNull=function decodeNull(e){return null};DERNode.prototype._decodeBool=function decodeBool(e){var t=e.readUInt8();if(e.isError(t))return t;else return t!==0};DERNode.prototype._decodeInt=function decodeInt(e,t){var r=e.raw();var i=new s(r);if(t)i=t[i.toString(10)]||i;return i};DERNode.prototype._use=function use(e,t){if(typeof e==="function")e=e(t);return e._getDecoder("der").tree};function derDecodeTag(e,t){var r=e.readUInt8(t);if(e.isError(r))return r;var i=o.tagClass[r>>6];var n=(r&32)===0;if((r&31)===31){var a=r;r=0;while((a&128)===128){a=e.readUInt8(t);if(e.isError(a))return a;r<<=7;r|=a&127}}else{r&=31}var s=o.tag[r];return{cls:i,primitive:n,tag:r,tagStr:s}}function derDecodeLen(e,t,r){var i=e.readUInt8(r);if(e.isError(i))return i;if(!t&&i===128)return null;if((i&128)===0){return i}var n=i&127;if(n>4)return e.error("length octect is too long");i=0;for(var a=0;a<n;a++){i<<=8;var s=e.readUInt8(r);if(e.isError(s))return s;i|=s}return i}},6701:function(e,t,r){var i=t;i.der=r(2259);i.pem=r(8527)},8527:function(e,t,r){var i=r(3782);var n=r(4300).Buffer;var a=r(2259);function PEMDecoder(e){a.call(this,e);this.enc="pem"}i(PEMDecoder,a);e.exports=PEMDecoder;PEMDecoder.prototype.decode=function decode(e,t){var r=e.toString().split(/[\r\n]+/g);var i=t.label.toUpperCase();var s=/^-----(BEGIN|END) ([^-]+)-----$/;var o=-1;var h=-1;for(var u=0;u<r.length;u++){var d=r[u].match(s);if(d===null)continue;if(d[2]!==i)continue;if(o===-1){if(d[1]!=="BEGIN")break;o=u}else{if(d[1]!=="END")break;h=u;break}}if(o===-1||h===-1)throw new Error("PEM section not found for: "+i);var c=r.slice(o+1,h).join("");c.replace(/[^a-z0-9\+\/=]+/gi,"");var l=new n(c,"base64");return a.prototype.decode.call(this,l,t)}},7804:function(e,t,r){var i=r(3782);var n=r(4300).Buffer;var a=r(7160);var s=a.base;var o=a.constants.der;function DEREncoder(e){this.enc="der";this.name=e.name;this.entity=e;this.tree=new DERNode;this.tree._init(e.body)}e.exports=DEREncoder;DEREncoder.prototype.encode=function encode(e,t){return this.tree._encode(e,t).join()};function DERNode(e){s.Node.call(this,"der",e)}i(DERNode,s.Node);DERNode.prototype._encodeComposite=function encodeComposite(e,t,r,i){var a=encodeTag(e,t,r,this.reporter);if(i.length<128){var s=new n(2);s[0]=a;s[1]=i.length;return this._createEncoderBuffer([s,i])}var o=1;for(var h=i.length;h>=256;h>>=8)o++;var s=new n(1+1+o);s[0]=a;s[1]=128|o;for(var h=1+o,u=i.length;u>0;h--,u>>=8)s[h]=u&255;return this._createEncoderBuffer([s,i])};DERNode.prototype._encodeStr=function encodeStr(e,t){if(t==="bitstr"){return this._createEncoderBuffer([e.unused|0,e.data])}else if(t==="bmpstr"){var r=new n(e.length*2);for(var i=0;i<e.length;i++){r.writeUInt16BE(e.charCodeAt(i),i*2)}return this._createEncoderBuffer(r)}else if(t==="numstr"){if(!this._isNumstr(e)){return this.reporter.error("Encoding of string type: numstr supports "+"only digits and space")}return this._createEncoderBuffer(e)}else if(t==="printstr"){if(!this._isPrintstr(e)){return this.reporter.error("Encoding of string type: printstr supports "+"only latin upper and lower case letters, "+"digits, space, apostrophe, left and rigth "+"parenthesis, plus sign, comma, hyphen, "+"dot, slash, colon, equal sign, "+"question mark")}return this._createEncoderBuffer(e)}else if(/str$/.test(t)){return this._createEncoderBuffer(e)}else if(t==="objDesc"){return this._createEncoderBuffer(e)}else{return this.reporter.error("Encoding of string type: "+t+" unsupported")}};DERNode.prototype._encodeObjid=function encodeObjid(e,t,r){if(typeof e==="string"){if(!t)return this.reporter.error("string objid given, but no values map found");if(!t.hasOwnProperty(e))return this.reporter.error("objid not found in values map");e=t[e].split(/[\s\.]+/g);for(var i=0;i<e.length;i++)e[i]|=0}else if(Array.isArray(e)){e=e.slice();for(var i=0;i<e.length;i++)e[i]|=0}if(!Array.isArray(e)){return this.reporter.error("objid() should be either array or string, "+"got: "+JSON.stringify(e))}if(!r){if(e[1]>=40)return this.reporter.error("Second objid identifier OOB");e.splice(0,2,e[0]*40+e[1])}var a=0;for(var i=0;i<e.length;i++){var s=e[i];for(a++;s>=128;s>>=7)a++}var o=new n(a);var h=o.length-1;for(var i=e.length-1;i>=0;i--){var s=e[i];o[h--]=s&127;while((s>>=7)>0)o[h--]=128|s&127}return this._createEncoderBuffer(o)};function two(e){if(e<10)return"0"+e;else return e}DERNode.prototype._encodeTime=function encodeTime(e,t){var r;var i=new Date(e);if(t==="gentime"){r=[two(i.getFullYear()),two(i.getUTCMonth()+1),two(i.getUTCDate()),two(i.getUTCHours()),two(i.getUTCMinutes()),two(i.getUTCSeconds()),"Z"].join("")}else if(t==="utctime"){r=[two(i.getFullYear()%100),two(i.getUTCMonth()+1),two(i.getUTCDate()),two(i.getUTCHours()),two(i.getUTCMinutes()),two(i.getUTCSeconds()),"Z"].join("")}else{this.reporter.error("Encoding "+t+" time is not supported yet")}return this._encodeStr(r,"octstr")};DERNode.prototype._encodeNull=function encodeNull(){return this._createEncoderBuffer("")};DERNode.prototype._encodeInt=function encodeInt(e,t){if(typeof e==="string"){if(!t)return this.reporter.error("String int or enum given, but no values map");if(!t.hasOwnProperty(e)){return this.reporter.error("Values map doesn't contain: "+JSON.stringify(e))}e=t[e]}if(typeof e!=="number"&&!n.isBuffer(e)){var r=e.toArray();if(!e.sign&&r[0]&128){r.unshift(0)}e=new n(r)}if(n.isBuffer(e)){var i=e.length;if(e.length===0)i++;var a=new n(i);e.copy(a);if(e.length===0)a[0]=0;return this._createEncoderBuffer(a)}if(e<128)return this._createEncoderBuffer(e);if(e<256)return this._createEncoderBuffer([0,e]);var i=1;for(var s=e;s>=256;s>>=8)i++;var a=new Array(i);for(var s=a.length-1;s>=0;s--){a[s]=e&255;e>>=8}if(a[0]&128){a.unshift(0)}return this._createEncoderBuffer(new n(a))};DERNode.prototype._encodeBool=function encodeBool(e){return this._createEncoderBuffer(e?255:0)};DERNode.prototype._use=function use(e,t){if(typeof e==="function")e=e(t);return e._getEncoder("der").tree};DERNode.prototype._skipDefault=function skipDefault(e,t,r){var i=this._baseState;var n;if(i["default"]===null)return false;var a=e.join();if(i.defaultBuffer===undefined)i.defaultBuffer=this._encodeValue(i["default"],t,r).join();if(a.length!==i.defaultBuffer.length)return false;for(n=0;n<a.length;n++)if(a[n]!==i.defaultBuffer[n])return false;return true};function encodeTag(e,t,r,i){var n;if(e==="seqof")e="seq";else if(e==="setof")e="set";if(o.tagByName.hasOwnProperty(e))n=o.tagByName[e];else if(typeof e==="number"&&(e|0)===e)n=e;else return i.error("Unknown tag: "+e);if(n>=31)return i.error("Multi-octet tag encoding unsupported");if(!t)n|=32;n|=o.tagClassByName[r||"universal"]<<6;return n}},3418:function(e,t,r){var i=t;i.der=r(7804);i.pem=r(1564)},1564:function(e,t,r){var i=r(3782);var n=r(7804);function PEMEncoder(e){n.call(this,e);this.enc="pem"}i(PEMEncoder,n);e.exports=PEMEncoder;PEMEncoder.prototype.encode=function encode(e,t){var r=n.prototype.encode.call(this,e);var i=r.toString("base64");var a=["-----BEGIN "+t.label+"-----"];for(var s=0;s<i.length;s+=64)a.push(i.slice(s,s+64));a.push("-----END "+t.label+"-----");return a.join("\n")}},711:function(e,t,r){e=r.nmd(e);(function(e,t){"use strict";function assert(e,t){if(!e)throw new Error(t||"Assertion failed")}function inherits(e,t){e.super_=t;var TempCtor=function(){};TempCtor.prototype=t.prototype;e.prototype=new TempCtor;e.prototype.constructor=e}function BN(e,t,r){if(BN.isBN(e)){return e}this.negative=0;this.words=null;this.length=0;this.red=null;if(e!==null){if(t==="le"||t==="be"){r=t;t=10}this._init(e||0,t||10,r||"be")}}if(typeof e==="object"){e.exports=BN}else{t.BN=BN}BN.BN=BN;BN.wordSize=26;var i;try{i=r(4300).Buffer}catch(e){}BN.isBN=function isBN(e){if(e instanceof BN){return true}return e!==null&&typeof e==="object"&&e.constructor.wordSize===BN.wordSize&&Array.isArray(e.words)};BN.max=function max(e,t){if(e.cmp(t)>0)return e;return t};BN.min=function min(e,t){if(e.cmp(t)<0)return e;return t};BN.prototype._init=function init(e,t,r){if(typeof e==="number"){return this._initNumber(e,t,r)}if(typeof e==="object"){return this._initArray(e,t,r)}if(t==="hex"){t=16}assert(t===(t|0)&&t>=2&&t<=36);e=e.toString().replace(/\s+/g,"");var i=0;if(e[0]==="-"){i++}if(t===16){this._parseHex(e,i)}else{this._parseBase(e,t,i)}if(e[0]==="-"){this.negative=1}this.strip();if(r!=="le")return;this._initArray(this.toArray(),t,r)};BN.prototype._initNumber=function _initNumber(e,t,r){if(e<0){this.negative=1;e=-e}if(e<67108864){this.words=[e&67108863];this.length=1}else if(e<4503599627370496){this.words=[e&67108863,e/67108864&67108863];this.length=2}else{assert(e<9007199254740992);this.words=[e&67108863,e/67108864&67108863,1];this.length=3}if(r!=="le")return;this._initArray(this.toArray(),t,r)};BN.prototype._initArray=function _initArray(e,t,r){assert(typeof e.length==="number");if(e.length<=0){this.words=[0];this.length=1;return this}this.length=Math.ceil(e.length/3);this.words=new Array(this.length);for(var i=0;i<this.length;i++){this.words[i]=0}var n,a;var s=0;if(r==="be"){for(i=e.length-1,n=0;i>=0;i-=3){a=e[i]|e[i-1]<<8|e[i-2]<<16;this.words[n]|=a<<s&67108863;this.words[n+1]=a>>>26-s&67108863;s+=24;if(s>=26){s-=26;n++}}}else if(r==="le"){for(i=0,n=0;i<e.length;i+=3){a=e[i]|e[i+1]<<8|e[i+2]<<16;this.words[n]|=a<<s&67108863;this.words[n+1]=a>>>26-s&67108863;s+=24;if(s>=26){s-=26;n++}}}return this.strip()};function parseHex(e,t,r){var i=0;var n=Math.min(e.length,r);for(var a=t;a<n;a++){var s=e.charCodeAt(a)-48;i<<=4;if(s>=49&&s<=54){i|=s-49+10}else if(s>=17&&s<=22){i|=s-17+10}else{i|=s&15}}return i}BN.prototype._parseHex=function _parseHex(e,t){this.length=Math.ceil((e.length-t)/6);this.words=new Array(this.length);for(var r=0;r<this.length;r++){this.words[r]=0}var i,n;var a=0;for(r=e.length-6,i=0;r>=t;r-=6){n=parseHex(e,r,r+6);this.words[i]|=n<<a&67108863;this.words[i+1]|=n>>>26-a&4194303;a+=24;if(a>=26){a-=26;i++}}if(r+6!==t){n=parseHex(e,t,r+6);this.words[i]|=n<<a&67108863;this.words[i+1]|=n>>>26-a&4194303}this.strip()};function parseBase(e,t,r,i){var n=0;var a=Math.min(e.length,r);for(var s=t;s<a;s++){var o=e.charCodeAt(s)-48;n*=i;if(o>=49){n+=o-49+10}else if(o>=17){n+=o-17+10}else{n+=o}}return n}BN.prototype._parseBase=function _parseBase(e,t,r){this.words=[0];this.length=1;for(var i=0,n=1;n<=67108863;n*=t){i++}i--;n=n/t|0;var a=e.length-r;var s=a%i;var o=Math.min(a,a-s)+r;var h=0;for(var u=r;u<o;u+=i){h=parseBase(e,u,u+i,t);this.imuln(n);if(this.words[0]+h<67108864){this.words[0]+=h}else{this._iaddn(h)}}if(s!==0){var d=1;h=parseBase(e,u,e.length,t);for(u=0;u<s;u++){d*=t}this.imuln(d);if(this.words[0]+h<67108864){this.words[0]+=h}else{this._iaddn(h)}}};BN.prototype.copy=function copy(e){e.words=new Array(this.length);for(var t=0;t<this.length;t++){e.words[t]=this.words[t]}e.length=this.length;e.negative=this.negative;e.red=this.red};BN.prototype.clone=function clone(){var e=new BN(null);this.copy(e);return e};BN.prototype._expand=function _expand(e){while(this.length<e){this.words[this.length++]=0}return this};BN.prototype.strip=function strip(){while(this.length>1&&this.words[this.length-1]===0){this.length--}return this._normSign()};BN.prototype._normSign=function _normSign(){if(this.length===1&&this.words[0]===0){this.negative=0}return this};BN.prototype.inspect=function inspect(){return(this.red?"<BN-R: ":"<BN: ")+this.toString(16)+">"};var n=["","0","00","000","0000","00000","000000","0000000","00000000","000000000","0000000000","00000000000","000000000000","0000000000000","00000000000000","000000000000000","0000000000000000","00000000000000000","000000000000000000","0000000000000000000","00000000000000000000","000000000000000000000","0000000000000000000000","00000000000000000000000","000000000000000000000000","0000000000000000000000000"];var a=[0,0,25,16,12,11,10,9,8,8,7,7,7,7,6,6,6,6,6,6,6,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5];var s=[0,0,33554432,43046721,16777216,48828125,60466176,40353607,16777216,43046721,1e7,19487171,35831808,62748517,7529536,11390625,16777216,24137569,34012224,47045881,64e6,4084101,5153632,6436343,7962624,9765625,11881376,14348907,17210368,20511149,243e5,28629151,33554432,39135393,45435424,52521875,60466176];BN.prototype.toString=function toString(e,t){e=e||10;t=t|0||1;var r;if(e===16||e==="hex"){r="";var i=0;var o=0;for(var h=0;h<this.length;h++){var u=this.words[h];var d=((u<<i|o)&16777215).toString(16);o=u>>>24-i&16777215;if(o!==0||h!==this.length-1){r=n[6-d.length]+d+r}else{r=d+r}i+=2;if(i>=26){i-=26;h--}}if(o!==0){r=o.toString(16)+r}while(r.length%t!==0){r="0"+r}if(this.negative!==0){r="-"+r}return r}if(e===(e|0)&&e>=2&&e<=36){var c=a[e];var l=s[e];r="";var p=this.clone();p.negative=0;while(!p.isZero()){var v=p.modn(l).toString(e);p=p.idivn(l);if(!p.isZero()){r=n[c-v.length]+v+r}else{r=v+r}}if(this.isZero()){r="0"+r}while(r.length%t!==0){r="0"+r}if(this.negative!==0){r="-"+r}return r}assert(false,"Base should be between 2 and 36")};BN.prototype.toNumber=function toNumber(){var e=this.words[0];if(this.length===2){e+=this.words[1]*67108864}else if(this.length===3&&this.words[2]===1){e+=4503599627370496+this.words[1]*67108864}else if(this.length>2){assert(false,"Number can only safely store up to 53 bits")}return this.negative!==0?-e:e};BN.prototype.toJSON=function toJSON(){return this.toString(16)};BN.prototype.toBuffer=function toBuffer(e,t){assert(typeof i!=="undefined");return this.toArrayLike(i,e,t)};BN.prototype.toArray=function toArray(e,t){return this.toArrayLike(Array,e,t)};BN.prototype.toArrayLike=function toArrayLike(e,t,r){var i=this.byteLength();var n=r||Math.max(1,i);assert(i<=n,"byte array longer than desired length");assert(n>0,"Requested array length <= 0");this.strip();var a=t==="le";var s=new e(n);var o,h;var u=this.clone();if(!a){for(h=0;h<n-i;h++){s[h]=0}for(h=0;!u.isZero();h++){o=u.andln(255);u.iushrn(8);s[n-h-1]=o}}else{for(h=0;!u.isZero();h++){o=u.andln(255);u.iushrn(8);s[h]=o}for(;h<n;h++){s[h]=0}}return s};if(Math.clz32){BN.prototype._countBits=function _countBits(e){return 32-Math.clz32(e)}}else{BN.prototype._countBits=function _countBits(e){var t=e;var r=0;if(t>=4096){r+=13;t>>>=13}if(t>=64){r+=7;t>>>=7}if(t>=8){r+=4;t>>>=4}if(t>=2){r+=2;t>>>=2}return r+t}}BN.prototype._zeroBits=function _zeroBits(e){if(e===0)return 26;var t=e;var r=0;if((t&8191)===0){r+=13;t>>>=13}if((t&127)===0){r+=7;t>>>=7}if((t&15)===0){r+=4;t>>>=4}if((t&3)===0){r+=2;t>>>=2}if((t&1)===0){r++}return r};BN.prototype.bitLength=function bitLength(){var e=this.words[this.length-1];var t=this._countBits(e);return(this.length-1)*26+t};function toBitArray(e){var t=new Array(e.bitLength());for(var r=0;r<t.length;r++){var i=r/26|0;var n=r%26;t[r]=(e.words[i]&1<<n)>>>n}return t}BN.prototype.zeroBits=function zeroBits(){if(this.isZero())return 0;var e=0;for(var t=0;t<this.length;t++){var r=this._zeroBits(this.words[t]);e+=r;if(r!==26)break}return e};BN.prototype.byteLength=function byteLength(){return Math.ceil(this.bitLength()/8)};BN.prototype.toTwos=function toTwos(e){if(this.negative!==0){return this.abs().inotn(e).iaddn(1)}return this.clone()};BN.prototype.fromTwos=function fromTwos(e){if(this.testn(e-1)){return this.notn(e).iaddn(1).ineg()}return this.clone()};BN.prototype.isNeg=function isNeg(){return this.negative!==0};BN.prototype.neg=function neg(){return this.clone().ineg()};BN.prototype.ineg=function ineg(){if(!this.isZero()){this.negative^=1}return this};BN.prototype.iuor=function iuor(e){while(this.length<e.length){this.words[this.length++]=0}for(var t=0;t<e.length;t++){this.words[t]=this.words[t]|e.words[t]}return this.strip()};BN.prototype.ior=function ior(e){assert((this.negative|e.negative)===0);return this.iuor(e)};BN.prototype.or=function or(e){if(this.length>e.length)return this.clone().ior(e);return e.clone().ior(this)};BN.prototype.uor=function uor(e){if(this.length>e.length)return this.clone().iuor(e);return e.clone().iuor(this)};BN.prototype.iuand=function iuand(e){var t;if(this.length>e.length){t=e}else{t=this}for(var r=0;r<t.length;r++){this.words[r]=this.words[r]&e.words[r]}this.length=t.length;return this.strip()};BN.prototype.iand=function iand(e){assert((this.negative|e.negative)===0);return this.iuand(e)};BN.prototype.and=function and(e){if(this.length>e.length)return this.clone().iand(e);return e.clone().iand(this)};BN.prototype.uand=function uand(e){if(this.length>e.length)return this.clone().iuand(e);return e.clone().iuand(this)};BN.prototype.iuxor=function iuxor(e){var t;var r;if(this.length>e.length){t=this;r=e}else{t=e;r=this}for(var i=0;i<r.length;i++){this.words[i]=t.words[i]^r.words[i]}if(this!==t){for(;i<t.length;i++){this.words[i]=t.words[i]}}this.length=t.length;return this.strip()};BN.prototype.ixor=function ixor(e){assert((this.negative|e.negative)===0);return this.iuxor(e)};BN.prototype.xor=function xor(e){if(this.length>e.length)return this.clone().ixor(e);return e.clone().ixor(this)};BN.prototype.uxor=function uxor(e){if(this.length>e.length)return this.clone().iuxor(e);return e.clone().iuxor(this)};BN.prototype.inotn=function inotn(e){assert(typeof e==="number"&&e>=0);var t=Math.ceil(e/26)|0;var r=e%26;this._expand(t);if(r>0){t--}for(var i=0;i<t;i++){this.words[i]=~this.words[i]&67108863}if(r>0){this.words[i]=~this.words[i]&67108863>>26-r}return this.strip()};BN.prototype.notn=function notn(e){return this.clone().inotn(e)};BN.prototype.setn=function setn(e,t){assert(typeof e==="number"&&e>=0);var r=e/26|0;var i=e%26;this._expand(r+1);if(t){this.words[r]=this.words[r]|1<<i}else{this.words[r]=this.words[r]&~(1<<i)}return this.strip()};BN.prototype.iadd=function iadd(e){var t;if(this.negative!==0&&e.negative===0){this.negative=0;t=this.isub(e);this.negative^=1;return this._normSign()}else if(this.negative===0&&e.negative!==0){e.negative=0;t=this.isub(e);e.negative=1;return t._normSign()}var r,i;if(this.length>e.length){r=this;i=e}else{r=e;i=this}var n=0;for(var a=0;a<i.length;a++){t=(r.words[a]|0)+(i.words[a]|0)+n;this.words[a]=t&67108863;n=t>>>26}for(;n!==0&&a<r.length;a++){t=(r.words[a]|0)+n;this.words[a]=t&67108863;n=t>>>26}this.length=r.length;if(n!==0){this.words[this.length]=n;this.length++}else if(r!==this){for(;a<r.length;a++){this.words[a]=r.words[a]}}return this};BN.prototype.add=function add(e){var t;if(e.negative!==0&&this.negative===0){e.negative=0;t=this.sub(e);e.negative^=1;return t}else if(e.negative===0&&this.negative!==0){this.negative=0;t=e.sub(this);this.negative=1;return t}if(this.length>e.length)return this.clone().iadd(e);return e.clone().iadd(this)};BN.prototype.isub=function isub(e){if(e.negative!==0){e.negative=0;var t=this.iadd(e);e.negative=1;return t._normSign()}else if(this.negative!==0){this.negative=0;this.iadd(e);this.negative=1;return this._normSign()}var r=this.cmp(e);if(r===0){this.negative=0;this.length=1;this.words[0]=0;return this}var i,n;if(r>0){i=this;n=e}else{i=e;n=this}var a=0;for(var s=0;s<n.length;s++){t=(i.words[s]|0)-(n.words[s]|0)+a;a=t>>26;this.words[s]=t&67108863}for(;a!==0&&s<i.length;s++){t=(i.words[s]|0)+a;a=t>>26;this.words[s]=t&67108863}if(a===0&&s<i.length&&i!==this){for(;s<i.length;s++){this.words[s]=i.words[s]}}this.length=Math.max(this.length,s);if(i!==this){this.negative=1}return this.strip()};BN.prototype.sub=function sub(e){return this.clone().isub(e)};function smallMulTo(e,t,r){r.negative=t.negative^e.negative;var i=e.length+t.length|0;r.length=i;i=i-1|0;var n=e.words[0]|0;var a=t.words[0]|0;var s=n*a;var o=s&67108863;var h=s/67108864|0;r.words[0]=o;for(var u=1;u<i;u++){var d=h>>>26;var c=h&67108863;var l=Math.min(u,t.length-1);for(var p=Math.max(0,u-e.length+1);p<=l;p++){var v=u-p|0;n=e.words[v]|0;a=t.words[p]|0;s=n*a+c;d+=s/67108864|0;c=s&67108863}r.words[u]=c|0;h=d|0}if(h!==0){r.words[u]=h|0}else{r.length--}return r.strip()}var o=function comb10MulTo(e,t,r){var i=e.words;var n=t.words;var a=r.words;var s=0;var o;var h;var u;var d=i[0]|0;var c=d&8191;var l=d>>>13;var p=i[1]|0;var v=p&8191;var b=p>>>13;var m=i[2]|0;var y=m&8191;var g=m>>>13;var _=i[3]|0;var w=_&8191;var M=_>>>13;var B=i[4]|0;var E=B&8191;var k=B>>>13;var A=i[5]|0;var N=A&8191;var P=A>>>13;var x=i[6]|0;var I=x&8191;var C=x>>>13;var D=i[7]|0;var T=D&8191;var j=D>>>13;var q=i[8]|0;var O=q&8191;var H=q>>>13;var L=i[9]|0;var z=L&8191;var F=L>>>13;var U=n[0]|0;var W=U&8191;var V=U>>>13;var G=n[1]|0;var J=G&8191;var Z=G>>>13;var X=n[2]|0;var Y=X&8191;var $=X>>>13;var Q=n[3]|0;var ee=Q&8191;var te=Q>>>13;var re=n[4]|0;var ie=re&8191;var ne=re>>>13;var ae=n[5]|0;var fe=ae&8191;var se=ae>>>13;var oe=n[6]|0;var he=oe&8191;var ue=oe>>>13;var de=n[7]|0;var ce=de&8191;var le=de>>>13;var pe=n[8]|0;var ve=pe&8191;var be=pe>>>13;var me=n[9]|0;var ye=me&8191;var ge=me>>>13;r.negative=e.negative^t.negative;r.length=19;o=Math.imul(c,W);h=Math.imul(c,V);h=h+Math.imul(l,W)|0;u=Math.imul(l,V);var _e=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(_e>>>26)|0;_e&=67108863;o=Math.imul(v,W);h=Math.imul(v,V);h=h+Math.imul(b,W)|0;u=Math.imul(b,V);o=o+Math.imul(c,J)|0;h=h+Math.imul(c,Z)|0;h=h+Math.imul(l,J)|0;u=u+Math.imul(l,Z)|0;var we=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(we>>>26)|0;we&=67108863;o=Math.imul(y,W);h=Math.imul(y,V);h=h+Math.imul(g,W)|0;u=Math.imul(g,V);o=o+Math.imul(v,J)|0;h=h+Math.imul(v,Z)|0;h=h+Math.imul(b,J)|0;u=u+Math.imul(b,Z)|0;o=o+Math.imul(c,Y)|0;h=h+Math.imul(c,$)|0;h=h+Math.imul(l,Y)|0;u=u+Math.imul(l,$)|0;var Me=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Me>>>26)|0;Me&=67108863;o=Math.imul(w,W);h=Math.imul(w,V);h=h+Math.imul(M,W)|0;u=Math.imul(M,V);o=o+Math.imul(y,J)|0;h=h+Math.imul(y,Z)|0;h=h+Math.imul(g,J)|0;u=u+Math.imul(g,Z)|0;o=o+Math.imul(v,Y)|0;h=h+Math.imul(v,$)|0;h=h+Math.imul(b,Y)|0;u=u+Math.imul(b,$)|0;o=o+Math.imul(c,ee)|0;h=h+Math.imul(c,te)|0;h=h+Math.imul(l,ee)|0;u=u+Math.imul(l,te)|0;var Se=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Se>>>26)|0;Se&=67108863;o=Math.imul(E,W);h=Math.imul(E,V);h=h+Math.imul(k,W)|0;u=Math.imul(k,V);o=o+Math.imul(w,J)|0;h=h+Math.imul(w,Z)|0;h=h+Math.imul(M,J)|0;u=u+Math.imul(M,Z)|0;o=o+Math.imul(y,Y)|0;h=h+Math.imul(y,$)|0;h=h+Math.imul(g,Y)|0;u=u+Math.imul(g,$)|0;o=o+Math.imul(v,ee)|0;h=h+Math.imul(v,te)|0;h=h+Math.imul(b,ee)|0;u=u+Math.imul(b,te)|0;o=o+Math.imul(c,ie)|0;h=h+Math.imul(c,ne)|0;h=h+Math.imul(l,ie)|0;u=u+Math.imul(l,ne)|0;var Be=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Be>>>26)|0;Be&=67108863;o=Math.imul(N,W);h=Math.imul(N,V);h=h+Math.imul(P,W)|0;u=Math.imul(P,V);o=o+Math.imul(E,J)|0;h=h+Math.imul(E,Z)|0;h=h+Math.imul(k,J)|0;u=u+Math.imul(k,Z)|0;o=o+Math.imul(w,Y)|0;h=h+Math.imul(w,$)|0;h=h+Math.imul(M,Y)|0;u=u+Math.imul(M,$)|0;o=o+Math.imul(y,ee)|0;h=h+Math.imul(y,te)|0;h=h+Math.imul(g,ee)|0;u=u+Math.imul(g,te)|0;o=o+Math.imul(v,ie)|0;h=h+Math.imul(v,ne)|0;h=h+Math.imul(b,ie)|0;u=u+Math.imul(b,ne)|0;o=o+Math.imul(c,fe)|0;h=h+Math.imul(c,se)|0;h=h+Math.imul(l,fe)|0;u=u+Math.imul(l,se)|0;var Ee=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Ee>>>26)|0;Ee&=67108863;o=Math.imul(I,W);h=Math.imul(I,V);h=h+Math.imul(C,W)|0;u=Math.imul(C,V);o=o+Math.imul(N,J)|0;h=h+Math.imul(N,Z)|0;h=h+Math.imul(P,J)|0;u=u+Math.imul(P,Z)|0;o=o+Math.imul(E,Y)|0;h=h+Math.imul(E,$)|0;h=h+Math.imul(k,Y)|0;u=u+Math.imul(k,$)|0;o=o+Math.imul(w,ee)|0;h=h+Math.imul(w,te)|0;h=h+Math.imul(M,ee)|0;u=u+Math.imul(M,te)|0;o=o+Math.imul(y,ie)|0;h=h+Math.imul(y,ne)|0;h=h+Math.imul(g,ie)|0;u=u+Math.imul(g,ne)|0;o=o+Math.imul(v,fe)|0;h=h+Math.imul(v,se)|0;h=h+Math.imul(b,fe)|0;u=u+Math.imul(b,se)|0;o=o+Math.imul(c,he)|0;h=h+Math.imul(c,ue)|0;h=h+Math.imul(l,he)|0;u=u+Math.imul(l,ue)|0;var ke=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(ke>>>26)|0;ke&=67108863;o=Math.imul(T,W);h=Math.imul(T,V);h=h+Math.imul(j,W)|0;u=Math.imul(j,V);o=o+Math.imul(I,J)|0;h=h+Math.imul(I,Z)|0;h=h+Math.imul(C,J)|0;u=u+Math.imul(C,Z)|0;o=o+Math.imul(N,Y)|0;h=h+Math.imul(N,$)|0;h=h+Math.imul(P,Y)|0;u=u+Math.imul(P,$)|0;o=o+Math.imul(E,ee)|0;h=h+Math.imul(E,te)|0;h=h+Math.imul(k,ee)|0;u=u+Math.imul(k,te)|0;o=o+Math.imul(w,ie)|0;h=h+Math.imul(w,ne)|0;h=h+Math.imul(M,ie)|0;u=u+Math.imul(M,ne)|0;o=o+Math.imul(y,fe)|0;h=h+Math.imul(y,se)|0;h=h+Math.imul(g,fe)|0;u=u+Math.imul(g,se)|0;o=o+Math.imul(v,he)|0;h=h+Math.imul(v,ue)|0;h=h+Math.imul(b,he)|0;u=u+Math.imul(b,ue)|0;o=o+Math.imul(c,ce)|0;h=h+Math.imul(c,le)|0;h=h+Math.imul(l,ce)|0;u=u+Math.imul(l,le)|0;var Ae=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Ae>>>26)|0;Ae&=67108863;o=Math.imul(O,W);h=Math.imul(O,V);h=h+Math.imul(H,W)|0;u=Math.imul(H,V);o=o+Math.imul(T,J)|0;h=h+Math.imul(T,Z)|0;h=h+Math.imul(j,J)|0;u=u+Math.imul(j,Z)|0;o=o+Math.imul(I,Y)|0;h=h+Math.imul(I,$)|0;h=h+Math.imul(C,Y)|0;u=u+Math.imul(C,$)|0;o=o+Math.imul(N,ee)|0;h=h+Math.imul(N,te)|0;h=h+Math.imul(P,ee)|0;u=u+Math.imul(P,te)|0;o=o+Math.imul(E,ie)|0;h=h+Math.imul(E,ne)|0;h=h+Math.imul(k,ie)|0;u=u+Math.imul(k,ne)|0;o=o+Math.imul(w,fe)|0;h=h+Math.imul(w,se)|0;h=h+Math.imul(M,fe)|0;u=u+Math.imul(M,se)|0;o=o+Math.imul(y,he)|0;h=h+Math.imul(y,ue)|0;h=h+Math.imul(g,he)|0;u=u+Math.imul(g,ue)|0;o=o+Math.imul(v,ce)|0;h=h+Math.imul(v,le)|0;h=h+Math.imul(b,ce)|0;u=u+Math.imul(b,le)|0;o=o+Math.imul(c,ve)|0;h=h+Math.imul(c,be)|0;h=h+Math.imul(l,ve)|0;u=u+Math.imul(l,be)|0;var Ne=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Ne>>>26)|0;Ne&=67108863;o=Math.imul(z,W);h=Math.imul(z,V);h=h+Math.imul(F,W)|0;u=Math.imul(F,V);o=o+Math.imul(O,J)|0;h=h+Math.imul(O,Z)|0;h=h+Math.imul(H,J)|0;u=u+Math.imul(H,Z)|0;o=o+Math.imul(T,Y)|0;h=h+Math.imul(T,$)|0;h=h+Math.imul(j,Y)|0;u=u+Math.imul(j,$)|0;o=o+Math.imul(I,ee)|0;h=h+Math.imul(I,te)|0;h=h+Math.imul(C,ee)|0;u=u+Math.imul(C,te)|0;o=o+Math.imul(N,ie)|0;h=h+Math.imul(N,ne)|0;h=h+Math.imul(P,ie)|0;u=u+Math.imul(P,ne)|0;o=o+Math.imul(E,fe)|0;h=h+Math.imul(E,se)|0;h=h+Math.imul(k,fe)|0;u=u+Math.imul(k,se)|0;o=o+Math.imul(w,he)|0;h=h+Math.imul(w,ue)|0;h=h+Math.imul(M,he)|0;u=u+Math.imul(M,ue)|0;o=o+Math.imul(y,ce)|0;h=h+Math.imul(y,le)|0;h=h+Math.imul(g,ce)|0;u=u+Math.imul(g,le)|0;o=o+Math.imul(v,ve)|0;h=h+Math.imul(v,be)|0;h=h+Math.imul(b,ve)|0;u=u+Math.imul(b,be)|0;o=o+Math.imul(c,ye)|0;h=h+Math.imul(c,ge)|0;h=h+Math.imul(l,ye)|0;u=u+Math.imul(l,ge)|0;var Re=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Re>>>26)|0;Re&=67108863;o=Math.imul(z,J);h=Math.imul(z,Z);h=h+Math.imul(F,J)|0;u=Math.imul(F,Z);o=o+Math.imul(O,Y)|0;h=h+Math.imul(O,$)|0;h=h+Math.imul(H,Y)|0;u=u+Math.imul(H,$)|0;o=o+Math.imul(T,ee)|0;h=h+Math.imul(T,te)|0;h=h+Math.imul(j,ee)|0;u=u+Math.imul(j,te)|0;o=o+Math.imul(I,ie)|0;h=h+Math.imul(I,ne)|0;h=h+Math.imul(C,ie)|0;u=u+Math.imul(C,ne)|0;o=o+Math.imul(N,fe)|0;h=h+Math.imul(N,se)|0;h=h+Math.imul(P,fe)|0;u=u+Math.imul(P,se)|0;o=o+Math.imul(E,he)|0;h=h+Math.imul(E,ue)|0;h=h+Math.imul(k,he)|0;u=u+Math.imul(k,ue)|0;o=o+Math.imul(w,ce)|0;h=h+Math.imul(w,le)|0;h=h+Math.imul(M,ce)|0;u=u+Math.imul(M,le)|0;o=o+Math.imul(y,ve)|0;h=h+Math.imul(y,be)|0;h=h+Math.imul(g,ve)|0;u=u+Math.imul(g,be)|0;o=o+Math.imul(v,ye)|0;h=h+Math.imul(v,ge)|0;h=h+Math.imul(b,ye)|0;u=u+Math.imul(b,ge)|0;var Pe=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Pe>>>26)|0;Pe&=67108863;o=Math.imul(z,Y);h=Math.imul(z,$);h=h+Math.imul(F,Y)|0;u=Math.imul(F,$);o=o+Math.imul(O,ee)|0;h=h+Math.imul(O,te)|0;h=h+Math.imul(H,ee)|0;u=u+Math.imul(H,te)|0;o=o+Math.imul(T,ie)|0;h=h+Math.imul(T,ne)|0;h=h+Math.imul(j,ie)|0;u=u+Math.imul(j,ne)|0;o=o+Math.imul(I,fe)|0;h=h+Math.imul(I,se)|0;h=h+Math.imul(C,fe)|0;u=u+Math.imul(C,se)|0;o=o+Math.imul(N,he)|0;h=h+Math.imul(N,ue)|0;h=h+Math.imul(P,he)|0;u=u+Math.imul(P,ue)|0;o=o+Math.imul(E,ce)|0;h=h+Math.imul(E,le)|0;h=h+Math.imul(k,ce)|0;u=u+Math.imul(k,le)|0;o=o+Math.imul(w,ve)|0;h=h+Math.imul(w,be)|0;h=h+Math.imul(M,ve)|0;u=u+Math.imul(M,be)|0;o=o+Math.imul(y,ye)|0;h=h+Math.imul(y,ge)|0;h=h+Math.imul(g,ye)|0;u=u+Math.imul(g,ge)|0;var xe=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(xe>>>26)|0;xe&=67108863;o=Math.imul(z,ee);h=Math.imul(z,te);h=h+Math.imul(F,ee)|0;u=Math.imul(F,te);o=o+Math.imul(O,ie)|0;h=h+Math.imul(O,ne)|0;h=h+Math.imul(H,ie)|0;u=u+Math.imul(H,ne)|0;o=o+Math.imul(T,fe)|0;h=h+Math.imul(T,se)|0;h=h+Math.imul(j,fe)|0;u=u+Math.imul(j,se)|0;o=o+Math.imul(I,he)|0;h=h+Math.imul(I,ue)|0;h=h+Math.imul(C,he)|0;u=u+Math.imul(C,ue)|0;o=o+Math.imul(N,ce)|0;h=h+Math.imul(N,le)|0;h=h+Math.imul(P,ce)|0;u=u+Math.imul(P,le)|0;o=o+Math.imul(E,ve)|0;h=h+Math.imul(E,be)|0;h=h+Math.imul(k,ve)|0;u=u+Math.imul(k,be)|0;o=o+Math.imul(w,ye)|0;h=h+Math.imul(w,ge)|0;h=h+Math.imul(M,ye)|0;u=u+Math.imul(M,ge)|0;var Ie=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Ie>>>26)|0;Ie&=67108863;o=Math.imul(z,ie);h=Math.imul(z,ne);h=h+Math.imul(F,ie)|0;u=Math.imul(F,ne);o=o+Math.imul(O,fe)|0;h=h+Math.imul(O,se)|0;h=h+Math.imul(H,fe)|0;u=u+Math.imul(H,se)|0;o=o+Math.imul(T,he)|0;h=h+Math.imul(T,ue)|0;h=h+Math.imul(j,he)|0;u=u+Math.imul(j,ue)|0;o=o+Math.imul(I,ce)|0;h=h+Math.imul(I,le)|0;h=h+Math.imul(C,ce)|0;u=u+Math.imul(C,le)|0;o=o+Math.imul(N,ve)|0;h=h+Math.imul(N,be)|0;h=h+Math.imul(P,ve)|0;u=u+Math.imul(P,be)|0;o=o+Math.imul(E,ye)|0;h=h+Math.imul(E,ge)|0;h=h+Math.imul(k,ye)|0;u=u+Math.imul(k,ge)|0;var Ce=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Ce>>>26)|0;Ce&=67108863;o=Math.imul(z,fe);h=Math.imul(z,se);h=h+Math.imul(F,fe)|0;u=Math.imul(F,se);o=o+Math.imul(O,he)|0;h=h+Math.imul(O,ue)|0;h=h+Math.imul(H,he)|0;u=u+Math.imul(H,ue)|0;o=o+Math.imul(T,ce)|0;h=h+Math.imul(T,le)|0;h=h+Math.imul(j,ce)|0;u=u+Math.imul(j,le)|0;o=o+Math.imul(I,ve)|0;h=h+Math.imul(I,be)|0;h=h+Math.imul(C,ve)|0;u=u+Math.imul(C,be)|0;o=o+Math.imul(N,ye)|0;h=h+Math.imul(N,ge)|0;h=h+Math.imul(P,ye)|0;u=u+Math.imul(P,ge)|0;var De=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(De>>>26)|0;De&=67108863;o=Math.imul(z,he);h=Math.imul(z,ue);h=h+Math.imul(F,he)|0;u=Math.imul(F,ue);o=o+Math.imul(O,ce)|0;h=h+Math.imul(O,le)|0;h=h+Math.imul(H,ce)|0;u=u+Math.imul(H,le)|0;o=o+Math.imul(T,ve)|0;h=h+Math.imul(T,be)|0;h=h+Math.imul(j,ve)|0;u=u+Math.imul(j,be)|0;o=o+Math.imul(I,ye)|0;h=h+Math.imul(I,ge)|0;h=h+Math.imul(C,ye)|0;u=u+Math.imul(C,ge)|0;var Te=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Te>>>26)|0;Te&=67108863;o=Math.imul(z,ce);h=Math.imul(z,le);h=h+Math.imul(F,ce)|0;u=Math.imul(F,le);o=o+Math.imul(O,ve)|0;h=h+Math.imul(O,be)|0;h=h+Math.imul(H,ve)|0;u=u+Math.imul(H,be)|0;o=o+Math.imul(T,ye)|0;h=h+Math.imul(T,ge)|0;h=h+Math.imul(j,ye)|0;u=u+Math.imul(j,ge)|0;var je=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(je>>>26)|0;je&=67108863;o=Math.imul(z,ve);h=Math.imul(z,be);h=h+Math.imul(F,ve)|0;u=Math.imul(F,be);o=o+Math.imul(O,ye)|0;h=h+Math.imul(O,ge)|0;h=h+Math.imul(H,ye)|0;u=u+Math.imul(H,ge)|0;var qe=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(qe>>>26)|0;qe&=67108863;o=Math.imul(z,ye);h=Math.imul(z,ge);h=h+Math.imul(F,ye)|0;u=Math.imul(F,ge);var Oe=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Oe>>>26)|0;Oe&=67108863;a[0]=_e;a[1]=we;a[2]=Me;a[3]=Se;a[4]=Be;a[5]=Ee;a[6]=ke;a[7]=Ae;a[8]=Ne;a[9]=Re;a[10]=Pe;a[11]=xe;a[12]=Ie;a[13]=Ce;a[14]=De;a[15]=Te;a[16]=je;a[17]=qe;a[18]=Oe;if(s!==0){a[19]=s;r.length++}return r};if(!Math.imul){o=smallMulTo}function bigMulTo(e,t,r){r.negative=t.negative^e.negative;r.length=e.length+t.length;var i=0;var n=0;for(var a=0;a<r.length-1;a++){var s=n;n=0;var o=i&67108863;var h=Math.min(a,t.length-1);for(var u=Math.max(0,a-e.length+1);u<=h;u++){var d=a-u;var c=e.words[d]|0;var l=t.words[u]|0;var p=c*l;var v=p&67108863;s=s+(p/67108864|0)|0;v=v+o|0;o=v&67108863;s=s+(v>>>26)|0;n+=s>>>26;s&=67108863}r.words[a]=o;i=s;s=n}if(i!==0){r.words[a]=i}else{r.length--}return r.strip()}function jumboMulTo(e,t,r){var i=new FFTM;return i.mulp(e,t,r)}BN.prototype.mulTo=function mulTo(e,t){var r;var i=this.length+e.length;if(this.length===10&&e.length===10){r=o(this,e,t)}else if(i<63){r=smallMulTo(this,e,t)}else if(i<1024){r=bigMulTo(this,e,t)}else{r=jumboMulTo(this,e,t)}return r};function FFTM(e,t){this.x=e;this.y=t}FFTM.prototype.makeRBT=function makeRBT(e){var t=new Array(e);var r=BN.prototype._countBits(e)-1;for(var i=0;i<e;i++){t[i]=this.revBin(i,r,e)}return t};FFTM.prototype.revBin=function revBin(e,t,r){if(e===0||e===r-1)return e;var i=0;for(var n=0;n<t;n++){i|=(e&1)<<t-n-1;e>>=1}return i};FFTM.prototype.permute=function permute(e,t,r,i,n,a){for(var s=0;s<a;s++){i[s]=t[e[s]];n[s]=r[e[s]]}};FFTM.prototype.transform=function transform(e,t,r,i,n,a){this.permute(a,e,t,r,i,n);for(var s=1;s<n;s<<=1){var o=s<<1;var h=Math.cos(2*Math.PI/o);var u=Math.sin(2*Math.PI/o);for(var d=0;d<n;d+=o){var c=h;var l=u;for(var p=0;p<s;p++){var v=r[d+p];var b=i[d+p];var m=r[d+p+s];var y=i[d+p+s];var g=c*m-l*y;y=c*y+l*m;m=g;r[d+p]=v+m;i[d+p]=b+y;r[d+p+s]=v-m;i[d+p+s]=b-y;if(p!==o){g=h*c-u*l;l=h*l+u*c;c=g}}}}};FFTM.prototype.guessLen13b=function guessLen13b(e,t){var r=Math.max(t,e)|1;var i=r&1;var n=0;for(r=r/2|0;r;r=r>>>1){n++}return 1<<n+1+i};FFTM.prototype.conjugate=function conjugate(e,t,r){if(r<=1)return;for(var i=0;i<r/2;i++){var n=e[i];e[i]=e[r-i-1];e[r-i-1]=n;n=t[i];t[i]=-t[r-i-1];t[r-i-1]=-n}};FFTM.prototype.normalize13b=function normalize13b(e,t){var r=0;for(var i=0;i<t/2;i++){var n=Math.round(e[2*i+1]/t)*8192+Math.round(e[2*i]/t)+r;e[i]=n&67108863;if(n<67108864){r=0}else{r=n/67108864|0}}return e};FFTM.prototype.convert13b=function convert13b(e,t,r,i){var n=0;for(var a=0;a<t;a++){n=n+(e[a]|0);r[2*a]=n&8191;n=n>>>13;r[2*a+1]=n&8191;n=n>>>13}for(a=2*t;a<i;++a){r[a]=0}assert(n===0);assert((n&~8191)===0)};FFTM.prototype.stub=function stub(e){var t=new Array(e);for(var r=0;r<e;r++){t[r]=0}return t};FFTM.prototype.mulp=function mulp(e,t,r){var i=2*this.guessLen13b(e.length,t.length);var n=this.makeRBT(i);var a=this.stub(i);var s=new Array(i);var o=new Array(i);var h=new Array(i);var u=new Array(i);var d=new Array(i);var c=new Array(i);var l=r.words;l.length=i;this.convert13b(e.words,e.length,s,i);this.convert13b(t.words,t.length,u,i);this.transform(s,a,o,h,i,n);this.transform(u,a,d,c,i,n);for(var p=0;p<i;p++){var v=o[p]*d[p]-h[p]*c[p];h[p]=o[p]*c[p]+h[p]*d[p];o[p]=v}this.conjugate(o,h,i);this.transform(o,h,l,a,i,n);this.conjugate(l,a,i);this.normalize13b(l,i);r.negative=e.negative^t.negative;r.length=e.length+t.length;return r.strip()};BN.prototype.mul=function mul(e){var t=new BN(null);t.words=new Array(this.length+e.length);return this.mulTo(e,t)};BN.prototype.mulf=function mulf(e){var t=new BN(null);t.words=new Array(this.length+e.length);return jumboMulTo(this,e,t)};BN.prototype.imul=function imul(e){return this.clone().mulTo(e,this)};BN.prototype.imuln=function imuln(e){assert(typeof e==="number");assert(e<67108864);var t=0;for(var r=0;r<this.length;r++){var i=(this.words[r]|0)*e;var n=(i&67108863)+(t&67108863);t>>=26;t+=i/67108864|0;t+=n>>>26;this.words[r]=n&67108863}if(t!==0){this.words[r]=t;this.length++}return this};BN.prototype.muln=function muln(e){return this.clone().imuln(e)};BN.prototype.sqr=function sqr(){return this.mul(this)};BN.prototype.isqr=function isqr(){return this.imul(this.clone())};BN.prototype.pow=function pow(e){var t=toBitArray(e);if(t.length===0)return new BN(1);var r=this;for(var i=0;i<t.length;i++,r=r.sqr()){if(t[i]!==0)break}if(++i<t.length){for(var n=r.sqr();i<t.length;i++,n=n.sqr()){if(t[i]===0)continue;r=r.mul(n)}}return r};BN.prototype.iushln=function iushln(e){assert(typeof e==="number"&&e>=0);var t=e%26;var r=(e-t)/26;var i=67108863>>>26-t<<26-t;var n;if(t!==0){var a=0;for(n=0;n<this.length;n++){var s=this.words[n]&i;var o=(this.words[n]|0)-s<<t;this.words[n]=o|a;a=s>>>26-t}if(a){this.words[n]=a;this.length++}}if(r!==0){for(n=this.length-1;n>=0;n--){this.words[n+r]=this.words[n]}for(n=0;n<r;n++){this.words[n]=0}this.length+=r}return this.strip()};BN.prototype.ishln=function ishln(e){assert(this.negative===0);return this.iushln(e)};BN.prototype.iushrn=function iushrn(e,t,r){assert(typeof e==="number"&&e>=0);var i;if(t){i=(t-t%26)/26}else{i=0}var n=e%26;var a=Math.min((e-n)/26,this.length);var s=67108863^67108863>>>n<<n;var o=r;i-=a;i=Math.max(0,i);if(o){for(var h=0;h<a;h++){o.words[h]=this.words[h]}o.length=a}if(a===0){}else if(this.length>a){this.length-=a;for(h=0;h<this.length;h++){this.words[h]=this.words[h+a]}}else{this.words[0]=0;this.length=1}var u=0;for(h=this.length-1;h>=0&&(u!==0||h>=i);h--){var d=this.words[h]|0;this.words[h]=u<<26-n|d>>>n;u=d&s}if(o&&u!==0){o.words[o.length++]=u}if(this.length===0){this.words[0]=0;this.length=1}return this.strip()};BN.prototype.ishrn=function ishrn(e,t,r){assert(this.negative===0);return this.iushrn(e,t,r)};BN.prototype.shln=function shln(e){return this.clone().ishln(e)};BN.prototype.ushln=function ushln(e){return this.clone().iushln(e)};BN.prototype.shrn=function shrn(e){return this.clone().ishrn(e)};BN.prototype.ushrn=function ushrn(e){return this.clone().iushrn(e)};BN.prototype.testn=function testn(e){assert(typeof e==="number"&&e>=0);var t=e%26;var r=(e-t)/26;var i=1<<t;if(this.length<=r)return false;var n=this.words[r];return!!(n&i)};BN.prototype.imaskn=function imaskn(e){assert(typeof e==="number"&&e>=0);var t=e%26;var r=(e-t)/26;assert(this.negative===0,"imaskn works only with positive numbers");if(this.length<=r){return this}if(t!==0){r++}this.length=Math.min(r,this.length);if(t!==0){var i=67108863^67108863>>>t<<t;this.words[this.length-1]&=i}return this.strip()};BN.prototype.maskn=function maskn(e){return this.clone().imaskn(e)};BN.prototype.iaddn=function iaddn(e){assert(typeof e==="number");assert(e<67108864);if(e<0)return this.isubn(-e);if(this.negative!==0){if(this.length===1&&(this.words[0]|0)<e){this.words[0]=e-(this.words[0]|0);this.negative=0;return this}this.negative=0;this.isubn(e);this.negative=1;return this}return this._iaddn(e)};BN.prototype._iaddn=function _iaddn(e){this.words[0]+=e;for(var t=0;t<this.length&&this.words[t]>=67108864;t++){this.words[t]-=67108864;if(t===this.length-1){this.words[t+1]=1}else{this.words[t+1]++}}this.length=Math.max(this.length,t+1);return this};BN.prototype.isubn=function isubn(e){assert(typeof e==="number");assert(e<67108864);if(e<0)return this.iaddn(-e);if(this.negative!==0){this.negative=0;this.iaddn(e);this.negative=1;return this}this.words[0]-=e;if(this.length===1&&this.words[0]<0){this.words[0]=-this.words[0];this.negative=1}else{for(var t=0;t<this.length&&this.words[t]<0;t++){this.words[t]+=67108864;this.words[t+1]-=1}}return this.strip()};BN.prototype.addn=function addn(e){return this.clone().iaddn(e)};BN.prototype.subn=function subn(e){return this.clone().isubn(e)};BN.prototype.iabs=function iabs(){this.negative=0;return this};BN.prototype.abs=function abs(){return this.clone().iabs()};BN.prototype._ishlnsubmul=function _ishlnsubmul(e,t,r){var i=e.length+r;var n;this._expand(i);var a;var s=0;for(n=0;n<e.length;n++){a=(this.words[n+r]|0)+s;var o=(e.words[n]|0)*t;a-=o&67108863;s=(a>>26)-(o/67108864|0);this.words[n+r]=a&67108863}for(;n<this.length-r;n++){a=(this.words[n+r]|0)+s;s=a>>26;this.words[n+r]=a&67108863}if(s===0)return this.strip();assert(s===-1);s=0;for(n=0;n<this.length;n++){a=-(this.words[n]|0)+s;s=a>>26;this.words[n]=a&67108863}this.negative=1;return this.strip()};BN.prototype._wordDiv=function _wordDiv(e,t){var r=this.length-e.length;var i=this.clone();var n=e;var a=n.words[n.length-1]|0;var s=this._countBits(a);r=26-s;if(r!==0){n=n.ushln(r);i.iushln(r);a=n.words[n.length-1]|0}var o=i.length-n.length;var h;if(t!=="mod"){h=new BN(null);h.length=o+1;h.words=new Array(h.length);for(var u=0;u<h.length;u++){h.words[u]=0}}var d=i.clone()._ishlnsubmul(n,1,o);if(d.negative===0){i=d;if(h){h.words[o]=1}}for(var c=o-1;c>=0;c--){var l=(i.words[n.length+c]|0)*67108864+(i.words[n.length+c-1]|0);l=Math.min(l/a|0,67108863);i._ishlnsubmul(n,l,c);while(i.negative!==0){l--;i.negative=0;i._ishlnsubmul(n,1,c);if(!i.isZero()){i.negative^=1}}if(h){h.words[c]=l}}if(h){h.strip()}i.strip();if(t!=="div"&&r!==0){i.iushrn(r)}return{div:h||null,mod:i}};BN.prototype.divmod=function divmod(e,t,r){assert(!e.isZero());if(this.isZero()){return{div:new BN(0),mod:new BN(0)}}var i,n,a;if(this.negative!==0&&e.negative===0){a=this.neg().divmod(e,t);if(t!=="mod"){i=a.div.neg()}if(t!=="div"){n=a.mod.neg();if(r&&n.negative!==0){n.iadd(e)}}return{div:i,mod:n}}if(this.negative===0&&e.negative!==0){a=this.divmod(e.neg(),t);if(t!=="mod"){i=a.div.neg()}return{div:i,mod:a.mod}}if((this.negative&e.negative)!==0){a=this.neg().divmod(e.neg(),t);if(t!=="div"){n=a.mod.neg();if(r&&n.negative!==0){n.isub(e)}}return{div:a.div,mod:n}}if(e.length>this.length||this.cmp(e)<0){return{div:new BN(0),mod:this}}if(e.length===1){if(t==="div"){return{div:this.divn(e.words[0]),mod:null}}if(t==="mod"){return{div:null,mod:new BN(this.modn(e.words[0]))}}return{div:this.divn(e.words[0]),mod:new BN(this.modn(e.words[0]))}}return this._wordDiv(e,t)};BN.prototype.div=function div(e){return this.divmod(e,"div",false).div};BN.prototype.mod=function mod(e){return this.divmod(e,"mod",false).mod};BN.prototype.umod=function umod(e){return this.divmod(e,"mod",true).mod};BN.prototype.divRound=function divRound(e){var t=this.divmod(e);if(t.mod.isZero())return t.div;var r=t.div.negative!==0?t.mod.isub(e):t.mod;var i=e.ushrn(1);var n=e.andln(1);var a=r.cmp(i);if(a<0||n===1&&a===0)return t.div;return t.div.negative!==0?t.div.isubn(1):t.div.iaddn(1)};BN.prototype.modn=function modn(e){assert(e<=67108863);var t=(1<<26)%e;var r=0;for(var i=this.length-1;i>=0;i--){r=(t*r+(this.words[i]|0))%e}return r};BN.prototype.idivn=function idivn(e){assert(e<=67108863);var t=0;for(var r=this.length-1;r>=0;r--){var i=(this.words[r]|0)+t*67108864;this.words[r]=i/e|0;t=i%e}return this.strip()};BN.prototype.divn=function divn(e){return this.clone().idivn(e)};BN.prototype.egcd=function egcd(e){assert(e.negative===0);assert(!e.isZero());var t=this;var r=e.clone();if(t.negative!==0){t=t.umod(e)}else{t=t.clone()}var i=new BN(1);var n=new BN(0);var a=new BN(0);var s=new BN(1);var o=0;while(t.isEven()&&r.isEven()){t.iushrn(1);r.iushrn(1);++o}var h=r.clone();var u=t.clone();while(!t.isZero()){for(var d=0,c=1;(t.words[0]&c)===0&&d<26;++d,c<<=1);if(d>0){t.iushrn(d);while(d-- >0){if(i.isOdd()||n.isOdd()){i.iadd(h);n.isub(u)}i.iushrn(1);n.iushrn(1)}}for(var l=0,p=1;(r.words[0]&p)===0&&l<26;++l,p<<=1);if(l>0){r.iushrn(l);while(l-- >0){if(a.isOdd()||s.isOdd()){a.iadd(h);s.isub(u)}a.iushrn(1);s.iushrn(1)}}if(t.cmp(r)>=0){t.isub(r);i.isub(a);n.isub(s)}else{r.isub(t);a.isub(i);s.isub(n)}}return{a:a,b:s,gcd:r.iushln(o)}};BN.prototype._invmp=function _invmp(e){assert(e.negative===0);assert(!e.isZero());var t=this;var r=e.clone();if(t.negative!==0){t=t.umod(e)}else{t=t.clone()}var i=new BN(1);var n=new BN(0);var a=r.clone();while(t.cmpn(1)>0&&r.cmpn(1)>0){for(var s=0,o=1;(t.words[0]&o)===0&&s<26;++s,o<<=1);if(s>0){t.iushrn(s);while(s-- >0){if(i.isOdd()){i.iadd(a)}i.iushrn(1)}}for(var h=0,u=1;(r.words[0]&u)===0&&h<26;++h,u<<=1);if(h>0){r.iushrn(h);while(h-- >0){if(n.isOdd()){n.iadd(a)}n.iushrn(1)}}if(t.cmp(r)>=0){t.isub(r);i.isub(n)}else{r.isub(t);n.isub(i)}}var d;if(t.cmpn(1)===0){d=i}else{d=n}if(d.cmpn(0)<0){d.iadd(e)}return d};BN.prototype.gcd=function gcd(e){if(this.isZero())return e.abs();if(e.isZero())return this.abs();var t=this.clone();var r=e.clone();t.negative=0;r.negative=0;for(var i=0;t.isEven()&&r.isEven();i++){t.iushrn(1);r.iushrn(1)}do{while(t.isEven()){t.iushrn(1)}while(r.isEven()){r.iushrn(1)}var n=t.cmp(r);if(n<0){var a=t;t=r;r=a}else if(n===0||r.cmpn(1)===0){break}t.isub(r)}while(true);return r.iushln(i)};BN.prototype.invm=function invm(e){return this.egcd(e).a.umod(e)};BN.prototype.isEven=function isEven(){return(this.words[0]&1)===0};BN.prototype.isOdd=function isOdd(){return(this.words[0]&1)===1};BN.prototype.andln=function andln(e){return this.words[0]&e};BN.prototype.bincn=function bincn(e){assert(typeof e==="number");var t=e%26;var r=(e-t)/26;var i=1<<t;if(this.length<=r){this._expand(r+1);this.words[r]|=i;return this}var n=i;for(var a=r;n!==0&&a<this.length;a++){var s=this.words[a]|0;s+=n;n=s>>>26;s&=67108863;this.words[a]=s}if(n!==0){this.words[a]=n;this.length++}return this};BN.prototype.isZero=function isZero(){return this.length===1&&this.words[0]===0};BN.prototype.cmpn=function cmpn(e){var t=e<0;if(this.negative!==0&&!t)return-1;if(this.negative===0&&t)return 1;this.strip();var r;if(this.length>1){r=1}else{if(t){e=-e}assert(e<=67108863,"Number is too big");var i=this.words[0]|0;r=i===e?0:i<e?-1:1}if(this.negative!==0)return-r|0;return r};BN.prototype.cmp=function cmp(e){if(this.negative!==0&&e.negative===0)return-1;if(this.negative===0&&e.negative!==0)return 1;var t=this.ucmp(e);if(this.negative!==0)return-t|0;return t};BN.prototype.ucmp=function ucmp(e){if(this.length>e.length)return 1;if(this.length<e.length)return-1;var t=0;for(var r=this.length-1;r>=0;r--){var i=this.words[r]|0;var n=e.words[r]|0;if(i===n)continue;if(i<n){t=-1}else if(i>n){t=1}break}return t};BN.prototype.gtn=function gtn(e){return this.cmpn(e)===1};BN.prototype.gt=function gt(e){return this.cmp(e)===1};BN.prototype.gten=function gten(e){return this.cmpn(e)>=0};BN.prototype.gte=function gte(e){return this.cmp(e)>=0};BN.prototype.ltn=function ltn(e){return this.cmpn(e)===-1};BN.prototype.lt=function lt(e){return this.cmp(e)===-1};BN.prototype.lten=function lten(e){return this.cmpn(e)<=0};BN.prototype.lte=function lte(e){return this.cmp(e)<=0};BN.prototype.eqn=function eqn(e){return this.cmpn(e)===0};BN.prototype.eq=function eq(e){return this.cmp(e)===0};BN.red=function red(e){return new Red(e)};BN.prototype.toRed=function toRed(e){assert(!this.red,"Already a number in reduction context");assert(this.negative===0,"red works only with positives");return e.convertTo(this)._forceRed(e)};BN.prototype.fromRed=function fromRed(){assert(this.red,"fromRed works only with numbers in reduction context");return this.red.convertFrom(this)};BN.prototype._forceRed=function _forceRed(e){this.red=e;return this};BN.prototype.forceRed=function forceRed(e){assert(!this.red,"Already a number in reduction context");return this._forceRed(e)};BN.prototype.redAdd=function redAdd(e){assert(this.red,"redAdd works only with red numbers");return this.red.add(this,e)};BN.prototype.redIAdd=function redIAdd(e){assert(this.red,"redIAdd works only with red numbers");return this.red.iadd(this,e)};BN.prototype.redSub=function redSub(e){assert(this.red,"redSub works only with red numbers");return this.red.sub(this,e)};BN.prototype.redISub=function redISub(e){assert(this.red,"redISub works only with red numbers");return this.red.isub(this,e)};BN.prototype.redShl=function redShl(e){assert(this.red,"redShl works only with red numbers");return this.red.shl(this,e)};BN.prototype.redMul=function redMul(e){assert(this.red,"redMul works only with red numbers");this.red._verify2(this,e);return this.red.mul(this,e)};BN.prototype.redIMul=function redIMul(e){assert(this.red,"redMul works only with red numbers");this.red._verify2(this,e);return this.red.imul(this,e)};BN.prototype.redSqr=function redSqr(){assert(this.red,"redSqr works only with red numbers");this.red._verify1(this);return this.red.sqr(this)};BN.prototype.redISqr=function redISqr(){assert(this.red,"redISqr works only with red numbers");this.red._verify1(this);return this.red.isqr(this)};BN.prototype.redSqrt=function redSqrt(){assert(this.red,"redSqrt works only with red numbers");this.red._verify1(this);return this.red.sqrt(this)};BN.prototype.redInvm=function redInvm(){assert(this.red,"redInvm works only with red numbers");this.red._verify1(this);return this.red.invm(this)};BN.prototype.redNeg=function redNeg(){assert(this.red,"redNeg works only with red numbers");this.red._verify1(this);return this.red.neg(this)};BN.prototype.redPow=function redPow(e){assert(this.red&&!e.red,"redPow(normalNum)");this.red._verify1(this);return this.red.pow(this,e)};var h={k256:null,p224:null,p192:null,p25519:null};function MPrime(e,t){this.name=e;this.p=new BN(t,16);this.n=this.p.bitLength();this.k=new BN(1).iushln(this.n).isub(this.p);this.tmp=this._tmp()}MPrime.prototype._tmp=function _tmp(){var e=new BN(null);e.words=new Array(Math.ceil(this.n/13));return e};MPrime.prototype.ireduce=function ireduce(e){var t=e;var r;do{this.split(t,this.tmp);t=this.imulK(t);t=t.iadd(this.tmp);r=t.bitLength()}while(r>this.n);var i=r<this.n?-1:t.ucmp(this.p);if(i===0){t.words[0]=0;t.length=1}else if(i>0){t.isub(this.p)}else{if(t.strip!==undefined){t.strip()}else{t._strip()}}return t};MPrime.prototype.split=function split(e,t){e.iushrn(this.n,0,t)};MPrime.prototype.imulK=function imulK(e){return e.imul(this.k)};function K256(){MPrime.call(this,"k256","ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f")}inherits(K256,MPrime);K256.prototype.split=function split(e,t){var r=4194303;var i=Math.min(e.length,9);for(var n=0;n<i;n++){t.words[n]=e.words[n]}t.length=i;if(e.length<=9){e.words[0]=0;e.length=1;return}var a=e.words[9];t.words[t.length++]=a&r;for(n=10;n<e.length;n++){var s=e.words[n]|0;e.words[n-10]=(s&r)<<4|a>>>22;a=s}a>>>=22;e.words[n-10]=a;if(a===0&&e.length>10){e.length-=10}else{e.length-=9}};K256.prototype.imulK=function imulK(e){e.words[e.length]=0;e.words[e.length+1]=0;e.length+=2;var t=0;for(var r=0;r<e.length;r++){var i=e.words[r]|0;t+=i*977;e.words[r]=t&67108863;t=i*64+(t/67108864|0)}if(e.words[e.length-1]===0){e.length--;if(e.words[e.length-1]===0){e.length--}}return e};function P224(){MPrime.call(this,"p224","ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001")}inherits(P224,MPrime);function P192(){MPrime.call(this,"p192","ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff")}inherits(P192,MPrime);function P25519(){MPrime.call(this,"25519","7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed")}inherits(P25519,MPrime);P25519.prototype.imulK=function imulK(e){var t=0;for(var r=0;r<e.length;r++){var i=(e.words[r]|0)*19+t;var n=i&67108863;i>>>=26;e.words[r]=n;t=i}if(t!==0){e.words[e.length++]=t}return e};BN._prime=function prime(e){if(h[e])return h[e];var prime;if(e==="k256"){prime=new K256}else if(e==="p224"){prime=new P224}else if(e==="p192"){prime=new P192}else if(e==="p25519"){prime=new P25519}else{throw new Error("Unknown prime "+e)}h[e]=prime;return prime};function Red(e){if(typeof e==="string"){var t=BN._prime(e);this.m=t.p;this.prime=t}else{assert(e.gtn(1),"modulus must be greater than 1");this.m=e;this.prime=null}}Red.prototype._verify1=function _verify1(e){assert(e.negative===0,"red works only with positives");assert(e.red,"red works only with red numbers")};Red.prototype._verify2=function _verify2(e,t){assert((e.negative|t.negative)===0,"red works only with positives");assert(e.red&&e.red===t.red,"red works only with red numbers")};Red.prototype.imod=function imod(e){if(this.prime)return this.prime.ireduce(e)._forceRed(this);return e.umod(this.m)._forceRed(this)};Red.prototype.neg=function neg(e){if(e.isZero()){return e.clone()}return this.m.sub(e)._forceRed(this)};Red.prototype.add=function add(e,t){this._verify2(e,t);var r=e.add(t);if(r.cmp(this.m)>=0){r.isub(this.m)}return r._forceRed(this)};Red.prototype.iadd=function iadd(e,t){this._verify2(e,t);var r=e.iadd(t);if(r.cmp(this.m)>=0){r.isub(this.m)}return r};Red.prototype.sub=function sub(e,t){this._verify2(e,t);var r=e.sub(t);if(r.cmpn(0)<0){r.iadd(this.m)}return r._forceRed(this)};Red.prototype.isub=function isub(e,t){this._verify2(e,t);var r=e.isub(t);if(r.cmpn(0)<0){r.iadd(this.m)}return r};Red.prototype.shl=function shl(e,t){this._verify1(e);return this.imod(e.ushln(t))};Red.prototype.imul=function imul(e,t){this._verify2(e,t);return this.imod(e.imul(t))};Red.prototype.mul=function mul(e,t){this._verify2(e,t);return this.imod(e.mul(t))};Red.prototype.isqr=function isqr(e){return this.imul(e,e.clone())};Red.prototype.sqr=function sqr(e){return this.mul(e,e)};Red.prototype.sqrt=function sqrt(e){if(e.isZero())return e.clone();var t=this.m.andln(3);assert(t%2===1);if(t===3){var r=this.m.add(new BN(1)).iushrn(2);return this.pow(e,r)}var i=this.m.subn(1);var n=0;while(!i.isZero()&&i.andln(1)===0){n++;i.iushrn(1)}assert(!i.isZero());var a=new BN(1).toRed(this);var s=a.redNeg();var o=this.m.subn(1).iushrn(1);var h=this.m.bitLength();h=new BN(2*h*h).toRed(this);while(this.pow(h,o).cmp(s)!==0){h.redIAdd(s)}var u=this.pow(h,i);var d=this.pow(e,i.addn(1).iushrn(1));var c=this.pow(e,i);var l=n;while(c.cmp(a)!==0){var p=c;for(var v=0;p.cmp(a)!==0;v++){p=p.redSqr()}assert(v<l);var b=this.pow(u,new BN(1).iushln(l-v-1));d=d.redMul(b);u=b.redSqr();c=c.redMul(u);l=v}return d};Red.prototype.invm=function invm(e){var t=e._invmp(this.m);if(t.negative!==0){t.negative=0;return this.imod(t).redNeg()}else{return this.imod(t)}};Red.prototype.pow=function pow(e,t){if(t.isZero())return new BN(1).toRed(this);if(t.cmpn(1)===0)return e.clone();var r=4;var i=new Array(1<<r);i[0]=new BN(1).toRed(this);i[1]=e;for(var n=2;n<i.length;n++){i[n]=this.mul(i[n-1],e)}var a=i[0];var s=0;var o=0;var h=t.bitLength()%26;if(h===0){h=26}for(n=t.length-1;n>=0;n--){var u=t.words[n];for(var d=h-1;d>=0;d--){var c=u>>d&1;if(a!==i[0]){a=this.sqr(a)}if(c===0&&s===0){o=0;continue}s<<=1;s|=c;o++;if(o!==r&&(n!==0||d!==0))continue;a=this.mul(a,i[s]);o=0;s=0}h=26}return a};Red.prototype.convertTo=function convertTo(e){var t=e.umod(this.m);return t===e?t.clone():t};Red.prototype.convertFrom=function convertFrom(e){var t=e.clone();t.red=null;return t};BN.mont=function mont(e){return new Mont(e)};function Mont(e){Red.call(this,e);this.shift=this.m.bitLength();if(this.shift%26!==0){this.shift+=26-this.shift%26}this.r=new BN(1).iushln(this.shift);this.r2=this.imod(this.r.sqr());this.rinv=this.r._invmp(this.m);this.minv=this.rinv.mul(this.r).isubn(1).div(this.m);this.minv=this.minv.umod(this.r);this.minv=this.r.sub(this.minv)}inherits(Mont,Red);Mont.prototype.convertTo=function convertTo(e){return this.imod(e.ushln(this.shift))};Mont.prototype.convertFrom=function convertFrom(e){var t=this.imod(e.mul(this.rinv));t.red=null;return t};Mont.prototype.imul=function imul(e,t){if(e.isZero()||t.isZero()){e.words[0]=0;e.length=1;return e}var r=e.imul(t);var i=r.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);var n=r.isub(i).iushrn(this.shift);var a=n;if(n.cmp(this.m)>=0){a=n.isub(this.m)}else if(n.cmpn(0)<0){a=n.iadd(this.m)}return a._forceRed(this)};Mont.prototype.mul=function mul(e,t){if(e.isZero()||t.isZero())return new BN(0)._forceRed(this);var r=e.mul(t);var i=r.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);var n=r.isub(i).iushrn(this.shift);var a=n;if(n.cmp(this.m)>=0){a=n.isub(this.m)}else if(n.cmpn(0)<0){a=n.iadd(this.m)}return a._forceRed(this)};Mont.prototype.invm=function invm(e){var t=this.imod(e._invmp(this.m).mul(this.r2));return t._forceRed(this)}})( false||e,this)},1670:function(e,t,r){e=r.nmd(e);(function(e,t){"use strict";function assert(e,t){if(!e)throw new Error(t||"Assertion failed")}function inherits(e,t){e.super_=t;var TempCtor=function(){};TempCtor.prototype=t.prototype;e.prototype=new TempCtor;e.prototype.constructor=e}function BN(e,t,r){if(BN.isBN(e)){return e}this.negative=0;this.words=null;this.length=0;this.red=null;if(e!==null){if(t==="le"||t==="be"){r=t;t=10}this._init(e||0,t||10,r||"be")}}if(typeof e==="object"){e.exports=BN}else{t.BN=BN}BN.BN=BN;BN.wordSize=26;var i;try{i=r(4300).Buffer}catch(e){}BN.isBN=function isBN(e){if(e instanceof BN){return true}return e!==null&&typeof e==="object"&&e.constructor.wordSize===BN.wordSize&&Array.isArray(e.words)};BN.max=function max(e,t){if(e.cmp(t)>0)return e;return t};BN.min=function min(e,t){if(e.cmp(t)<0)return e;return t};BN.prototype._init=function init(e,t,r){if(typeof e==="number"){return this._initNumber(e,t,r)}if(typeof e==="object"){return this._initArray(e,t,r)}if(t==="hex"){t=16}assert(t===(t|0)&&t>=2&&t<=36);e=e.toString().replace(/\s+/g,"");var i=0;if(e[0]==="-"){i++}if(t===16){this._parseHex(e,i)}else{this._parseBase(e,t,i)}if(e[0]==="-"){this.negative=1}this._strip();if(r!=="le")return;this._initArray(this.toArray(),t,r)};BN.prototype._initNumber=function _initNumber(e,t,r){if(e<0){this.negative=1;e=-e}if(e<67108864){this.words=[e&67108863];this.length=1}else if(e<4503599627370496){this.words=[e&67108863,e/67108864&67108863];this.length=2}else{assert(e<9007199254740992);this.words=[e&67108863,e/67108864&67108863,1];this.length=3}if(r!=="le")return;this._initArray(this.toArray(),t,r)};BN.prototype._initArray=function _initArray(e,t,r){assert(typeof e.length==="number");if(e.length<=0){this.words=[0];this.length=1;return this}this.length=Math.ceil(e.length/3);this.words=new Array(this.length);for(var i=0;i<this.length;i++){this.words[i]=0}var n,a;var s=0;if(r==="be"){for(i=e.length-1,n=0;i>=0;i-=3){a=e[i]|e[i-1]<<8|e[i-2]<<16;this.words[n]|=a<<s&67108863;this.words[n+1]=a>>>26-s&67108863;s+=24;if(s>=26){s-=26;n++}}}else if(r==="le"){for(i=0,n=0;i<e.length;i+=3){a=e[i]|e[i+1]<<8|e[i+2]<<16;this.words[n]|=a<<s&67108863;this.words[n+1]=a>>>26-s&67108863;s+=24;if(s>=26){s-=26;n++}}}return this._strip()};function parseHex(e,t,r){var i=0;var n=Math.min(e.length,r);var a=0;for(var s=t;s<n;s++){var o=e.charCodeAt(s)-48;i<<=4;var h;if(o>=49&&o<=54){h=o-49+10}else if(o>=17&&o<=22){h=o-17+10}else{h=o}i|=h;a|=h}assert(!(a&240),"Invalid character in "+e);return i}BN.prototype._parseHex=function _parseHex(e,t){this.length=Math.ceil((e.length-t)/6);this.words=new Array(this.length);for(var r=0;r<this.length;r++){this.words[r]=0}var i,n;var a=0;for(r=e.length-6,i=0;r>=t;r-=6){n=parseHex(e,r,r+6);this.words[i]|=n<<a&67108863;this.words[i+1]|=n>>>26-a&4194303;a+=24;if(a>=26){a-=26;i++}}if(r+6!==t){n=parseHex(e,t,r+6);this.words[i]|=n<<a&67108863;this.words[i+1]|=n>>>26-a&4194303}this._strip()};function parseBase(e,t,r,i){var n=0;var a=0;var s=Math.min(e.length,r);for(var o=t;o<s;o++){var h=e.charCodeAt(o)-48;n*=i;if(h>=49){a=h-49+10}else if(h>=17){a=h-17+10}else{a=h}assert(h>=0&&a<i,"Invalid character");n+=a}return n}BN.prototype._parseBase=function _parseBase(e,t,r){this.words=[0];this.length=1;for(var i=0,n=1;n<=67108863;n*=t){i++}i--;n=n/t|0;var a=e.length-r;var s=a%i;var o=Math.min(a,a-s)+r;var h=0;for(var u=r;u<o;u+=i){h=parseBase(e,u,u+i,t);this.imuln(n);if(this.words[0]+h<67108864){this.words[0]+=h}else{this._iaddn(h)}}if(s!==0){var d=1;h=parseBase(e,u,e.length,t);for(u=0;u<s;u++){d*=t}this.imuln(d);if(this.words[0]+h<67108864){this.words[0]+=h}else{this._iaddn(h)}}};BN.prototype.copy=function copy(e){e.words=new Array(this.length);for(var t=0;t<this.length;t++){e.words[t]=this.words[t]}e.length=this.length;e.negative=this.negative;e.red=this.red};function move(e,t){e.words=t.words;e.length=t.length;e.negative=t.negative;e.red=t.red}BN.prototype._move=function _move(e){move(e,this)};BN.prototype.clone=function clone(){var e=new BN(null);this.copy(e);return e};BN.prototype._expand=function _expand(e){while(this.length<e){this.words[this.length++]=0}return this};BN.prototype._strip=function strip(){while(this.length>1&&this.words[this.length-1]===0){this.length--}return this._normSign()};BN.prototype._normSign=function _normSign(){if(this.length===1&&this.words[0]===0){this.negative=0}return this};if(typeof Symbol!=="undefined"&&typeof Symbol.for==="function"){BN.prototype[Symbol.for("nodejs.util.inspect.custom")]=inspect}else{BN.prototype.inspect=inspect}function inspect(){return(this.red?"<BN-R: ":"<BN: ")+this.toString(16)+">"}var n=["","0","00","000","0000","00000","000000","0000000","00000000","000000000","0000000000","00000000000","000000000000","0000000000000","00000000000000","000000000000000","0000000000000000","00000000000000000","000000000000000000","0000000000000000000","00000000000000000000","000000000000000000000","0000000000000000000000","00000000000000000000000","000000000000000000000000","0000000000000000000000000"];var a=[0,0,25,16,12,11,10,9,8,8,7,7,7,7,6,6,6,6,6,6,6,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5];var s=[0,0,33554432,43046721,16777216,48828125,60466176,40353607,16777216,43046721,1e7,19487171,35831808,62748517,7529536,11390625,16777216,24137569,34012224,47045881,64e6,4084101,5153632,6436343,7962624,9765625,11881376,14348907,17210368,20511149,243e5,28629151,33554432,39135393,45435424,52521875,60466176];BN.prototype.toString=function toString(e,t){e=e||10;t=t|0||1;var r;if(e===16||e==="hex"){r="";var i=0;var o=0;for(var h=0;h<this.length;h++){var u=this.words[h];var d=((u<<i|o)&16777215).toString(16);o=u>>>24-i&16777215;if(o!==0||h!==this.length-1){r=n[6-d.length]+d+r}else{r=d+r}i+=2;if(i>=26){i-=26;h--}}if(o!==0){r=o.toString(16)+r}while(r.length%t!==0){r="0"+r}if(this.negative!==0){r="-"+r}return r}if(e===(e|0)&&e>=2&&e<=36){var c=a[e];var l=s[e];r="";var p=this.clone();p.negative=0;while(!p.isZero()){var v=p.modrn(l).toString(e);p=p.idivn(l);if(!p.isZero()){r=n[c-v.length]+v+r}else{r=v+r}}if(this.isZero()){r="0"+r}while(r.length%t!==0){r="0"+r}if(this.negative!==0){r="-"+r}return r}assert(false,"Base should be between 2 and 36")};BN.prototype.toNumber=function toNumber(){var e=this.words[0];if(this.length===2){e+=this.words[1]*67108864}else if(this.length===3&&this.words[2]===1){e+=4503599627370496+this.words[1]*67108864}else if(this.length>2){assert(false,"Number can only safely store up to 53 bits")}return this.negative!==0?-e:e};BN.prototype.toJSON=function toJSON(){return this.toString(16,2)};if(i){BN.prototype.toBuffer=function toBuffer(e,t){return this.toArrayLike(i,e,t)}}BN.prototype.toArray=function toArray(e,t){return this.toArrayLike(Array,e,t)};var o=function allocate(e,t){if(e.allocUnsafe){return e.allocUnsafe(t)}return new e(t)};BN.prototype.toArrayLike=function toArrayLike(e,t,r){this._strip();var i=this.byteLength();var n=r||Math.max(1,i);assert(i<=n,"byte array longer than desired length");assert(n>0,"Requested array length <= 0");var a=o(e,n);var s=t==="le"?"LE":"BE";this["_toArrayLike"+s](a,i);return a};BN.prototype._toArrayLikeLE=function _toArrayLikeLE(e,t){var r=0;var i=0;for(var n=0,a=0;n<this.length;n++){var s=this.words[n]<<a|i;e[r++]=s&255;if(r<e.length){e[r++]=s>>8&255}if(r<e.length){e[r++]=s>>16&255}if(a===6){if(r<e.length){e[r++]=s>>24&255}i=0;a=0}else{i=s>>>24;a+=2}}if(r<e.length){e[r++]=i;while(r<e.length){e[r++]=0}}};BN.prototype._toArrayLikeBE=function _toArrayLikeBE(e,t){var r=e.length-1;var i=0;for(var n=0,a=0;n<this.length;n++){var s=this.words[n]<<a|i;e[r--]=s&255;if(r>=0){e[r--]=s>>8&255}if(r>=0){e[r--]=s>>16&255}if(a===6){if(r>=0){e[r--]=s>>24&255}i=0;a=0}else{i=s>>>24;a+=2}}if(r>=0){e[r--]=i;while(r>=0){e[r--]=0}}};if(Math.clz32){BN.prototype._countBits=function _countBits(e){return 32-Math.clz32(e)}}else{BN.prototype._countBits=function _countBits(e){var t=e;var r=0;if(t>=4096){r+=13;t>>>=13}if(t>=64){r+=7;t>>>=7}if(t>=8){r+=4;t>>>=4}if(t>=2){r+=2;t>>>=2}return r+t}}BN.prototype._zeroBits=function _zeroBits(e){if(e===0)return 26;var t=e;var r=0;if((t&8191)===0){r+=13;t>>>=13}if((t&127)===0){r+=7;t>>>=7}if((t&15)===0){r+=4;t>>>=4}if((t&3)===0){r+=2;t>>>=2}if((t&1)===0){r++}return r};BN.prototype.bitLength=function bitLength(){var e=this.words[this.length-1];var t=this._countBits(e);return(this.length-1)*26+t};function toBitArray(e){var t=new Array(e.bitLength());for(var r=0;r<t.length;r++){var i=r/26|0;var n=r%26;t[r]=e.words[i]>>>n&1}return t}BN.prototype.zeroBits=function zeroBits(){if(this.isZero())return 0;var e=0;for(var t=0;t<this.length;t++){var r=this._zeroBits(this.words[t]);e+=r;if(r!==26)break}return e};BN.prototype.byteLength=function byteLength(){return Math.ceil(this.bitLength()/8)};BN.prototype.toTwos=function toTwos(e){if(this.negative!==0){return this.abs().inotn(e).iaddn(1)}return this.clone()};BN.prototype.fromTwos=function fromTwos(e){if(this.testn(e-1)){return this.notn(e).iaddn(1).ineg()}return this.clone()};BN.prototype.isNeg=function isNeg(){return this.negative!==0};BN.prototype.neg=function neg(){return this.clone().ineg()};BN.prototype.ineg=function ineg(){if(!this.isZero()){this.negative^=1}return this};BN.prototype.iuor=function iuor(e){while(this.length<e.length){this.words[this.length++]=0}for(var t=0;t<e.length;t++){this.words[t]=this.words[t]|e.words[t]}return this._strip()};BN.prototype.ior=function ior(e){assert((this.negative|e.negative)===0);return this.iuor(e)};BN.prototype.or=function or(e){if(this.length>e.length)return this.clone().ior(e);return e.clone().ior(this)};BN.prototype.uor=function uor(e){if(this.length>e.length)return this.clone().iuor(e);return e.clone().iuor(this)};BN.prototype.iuand=function iuand(e){var t;if(this.length>e.length){t=e}else{t=this}for(var r=0;r<t.length;r++){this.words[r]=this.words[r]&e.words[r]}this.length=t.length;return this._strip()};BN.prototype.iand=function iand(e){assert((this.negative|e.negative)===0);return this.iuand(e)};BN.prototype.and=function and(e){if(this.length>e.length)return this.clone().iand(e);return e.clone().iand(this)};BN.prototype.uand=function uand(e){if(this.length>e.length)return this.clone().iuand(e);return e.clone().iuand(this)};BN.prototype.iuxor=function iuxor(e){var t;var r;if(this.length>e.length){t=this;r=e}else{t=e;r=this}for(var i=0;i<r.length;i++){this.words[i]=t.words[i]^r.words[i]}if(this!==t){for(;i<t.length;i++){this.words[i]=t.words[i]}}this.length=t.length;return this._strip()};BN.prototype.ixor=function ixor(e){assert((this.negative|e.negative)===0);return this.iuxor(e)};BN.prototype.xor=function xor(e){if(this.length>e.length)return this.clone().ixor(e);return e.clone().ixor(this)};BN.prototype.uxor=function uxor(e){if(this.length>e.length)return this.clone().iuxor(e);return e.clone().iuxor(this)};BN.prototype.inotn=function inotn(e){assert(typeof e==="number"&&e>=0);var t=Math.ceil(e/26)|0;var r=e%26;this._expand(t);if(r>0){t--}for(var i=0;i<t;i++){this.words[i]=~this.words[i]&67108863}if(r>0){this.words[i]=~this.words[i]&67108863>>26-r}return this._strip()};BN.prototype.notn=function notn(e){return this.clone().inotn(e)};BN.prototype.setn=function setn(e,t){assert(typeof e==="number"&&e>=0);var r=e/26|0;var i=e%26;this._expand(r+1);if(t){this.words[r]=this.words[r]|1<<i}else{this.words[r]=this.words[r]&~(1<<i)}return this._strip()};BN.prototype.iadd=function iadd(e){var t;if(this.negative!==0&&e.negative===0){this.negative=0;t=this.isub(e);this.negative^=1;return this._normSign()}else if(this.negative===0&&e.negative!==0){e.negative=0;t=this.isub(e);e.negative=1;return t._normSign()}var r,i;if(this.length>e.length){r=this;i=e}else{r=e;i=this}var n=0;for(var a=0;a<i.length;a++){t=(r.words[a]|0)+(i.words[a]|0)+n;this.words[a]=t&67108863;n=t>>>26}for(;n!==0&&a<r.length;a++){t=(r.words[a]|0)+n;this.words[a]=t&67108863;n=t>>>26}this.length=r.length;if(n!==0){this.words[this.length]=n;this.length++}else if(r!==this){for(;a<r.length;a++){this.words[a]=r.words[a]}}return this};BN.prototype.add=function add(e){var t;if(e.negative!==0&&this.negative===0){e.negative=0;t=this.sub(e);e.negative^=1;return t}else if(e.negative===0&&this.negative!==0){this.negative=0;t=e.sub(this);this.negative=1;return t}if(this.length>e.length)return this.clone().iadd(e);return e.clone().iadd(this)};BN.prototype.isub=function isub(e){if(e.negative!==0){e.negative=0;var t=this.iadd(e);e.negative=1;return t._normSign()}else if(this.negative!==0){this.negative=0;this.iadd(e);this.negative=1;return this._normSign()}var r=this.cmp(e);if(r===0){this.negative=0;this.length=1;this.words[0]=0;return this}var i,n;if(r>0){i=this;n=e}else{i=e;n=this}var a=0;for(var s=0;s<n.length;s++){t=(i.words[s]|0)-(n.words[s]|0)+a;a=t>>26;this.words[s]=t&67108863}for(;a!==0&&s<i.length;s++){t=(i.words[s]|0)+a;a=t>>26;this.words[s]=t&67108863}if(a===0&&s<i.length&&i!==this){for(;s<i.length;s++){this.words[s]=i.words[s]}}this.length=Math.max(this.length,s);if(i!==this){this.negative=1}return this._strip()};BN.prototype.sub=function sub(e){return this.clone().isub(e)};function smallMulTo(e,t,r){r.negative=t.negative^e.negative;var i=e.length+t.length|0;r.length=i;i=i-1|0;var n=e.words[0]|0;var a=t.words[0]|0;var s=n*a;var o=s&67108863;var h=s/67108864|0;r.words[0]=o;for(var u=1;u<i;u++){var d=h>>>26;var c=h&67108863;var l=Math.min(u,t.length-1);for(var p=Math.max(0,u-e.length+1);p<=l;p++){var v=u-p|0;n=e.words[v]|0;a=t.words[p]|0;s=n*a+c;d+=s/67108864|0;c=s&67108863}r.words[u]=c|0;h=d|0}if(h!==0){r.words[u]=h|0}else{r.length--}return r._strip()}var h=function comb10MulTo(e,t,r){var i=e.words;var n=t.words;var a=r.words;var s=0;var o;var h;var u;var d=i[0]|0;var c=d&8191;var l=d>>>13;var p=i[1]|0;var v=p&8191;var b=p>>>13;var m=i[2]|0;var y=m&8191;var g=m>>>13;var _=i[3]|0;var w=_&8191;var M=_>>>13;var B=i[4]|0;var E=B&8191;var k=B>>>13;var A=i[5]|0;var N=A&8191;var P=A>>>13;var x=i[6]|0;var I=x&8191;var C=x>>>13;var D=i[7]|0;var T=D&8191;var j=D>>>13;var q=i[8]|0;var O=q&8191;var H=q>>>13;var L=i[9]|0;var z=L&8191;var F=L>>>13;var U=n[0]|0;var W=U&8191;var V=U>>>13;var G=n[1]|0;var J=G&8191;var Z=G>>>13;var X=n[2]|0;var Y=X&8191;var $=X>>>13;var Q=n[3]|0;var ee=Q&8191;var te=Q>>>13;var re=n[4]|0;var ie=re&8191;var ne=re>>>13;var ae=n[5]|0;var fe=ae&8191;var se=ae>>>13;var oe=n[6]|0;var he=oe&8191;var ue=oe>>>13;var de=n[7]|0;var ce=de&8191;var le=de>>>13;var pe=n[8]|0;var ve=pe&8191;var be=pe>>>13;var me=n[9]|0;var ye=me&8191;var ge=me>>>13;r.negative=e.negative^t.negative;r.length=19;o=Math.imul(c,W);h=Math.imul(c,V);h=h+Math.imul(l,W)|0;u=Math.imul(l,V);var _e=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(_e>>>26)|0;_e&=67108863;o=Math.imul(v,W);h=Math.imul(v,V);h=h+Math.imul(b,W)|0;u=Math.imul(b,V);o=o+Math.imul(c,J)|0;h=h+Math.imul(c,Z)|0;h=h+Math.imul(l,J)|0;u=u+Math.imul(l,Z)|0;var we=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(we>>>26)|0;we&=67108863;o=Math.imul(y,W);h=Math.imul(y,V);h=h+Math.imul(g,W)|0;u=Math.imul(g,V);o=o+Math.imul(v,J)|0;h=h+Math.imul(v,Z)|0;h=h+Math.imul(b,J)|0;u=u+Math.imul(b,Z)|0;o=o+Math.imul(c,Y)|0;h=h+Math.imul(c,$)|0;h=h+Math.imul(l,Y)|0;u=u+Math.imul(l,$)|0;var Me=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Me>>>26)|0;Me&=67108863;o=Math.imul(w,W);h=Math.imul(w,V);h=h+Math.imul(M,W)|0;u=Math.imul(M,V);o=o+Math.imul(y,J)|0;h=h+Math.imul(y,Z)|0;h=h+Math.imul(g,J)|0;u=u+Math.imul(g,Z)|0;o=o+Math.imul(v,Y)|0;h=h+Math.imul(v,$)|0;h=h+Math.imul(b,Y)|0;u=u+Math.imul(b,$)|0;o=o+Math.imul(c,ee)|0;h=h+Math.imul(c,te)|0;h=h+Math.imul(l,ee)|0;u=u+Math.imul(l,te)|0;var Se=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Se>>>26)|0;Se&=67108863;o=Math.imul(E,W);h=Math.imul(E,V);h=h+Math.imul(k,W)|0;u=Math.imul(k,V);o=o+Math.imul(w,J)|0;h=h+Math.imul(w,Z)|0;h=h+Math.imul(M,J)|0;u=u+Math.imul(M,Z)|0;o=o+Math.imul(y,Y)|0;h=h+Math.imul(y,$)|0;h=h+Math.imul(g,Y)|0;u=u+Math.imul(g,$)|0;o=o+Math.imul(v,ee)|0;h=h+Math.imul(v,te)|0;h=h+Math.imul(b,ee)|0;u=u+Math.imul(b,te)|0;o=o+Math.imul(c,ie)|0;h=h+Math.imul(c,ne)|0;h=h+Math.imul(l,ie)|0;u=u+Math.imul(l,ne)|0;var Be=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Be>>>26)|0;Be&=67108863;o=Math.imul(N,W);h=Math.imul(N,V);h=h+Math.imul(P,W)|0;u=Math.imul(P,V);o=o+Math.imul(E,J)|0;h=h+Math.imul(E,Z)|0;h=h+Math.imul(k,J)|0;u=u+Math.imul(k,Z)|0;o=o+Math.imul(w,Y)|0;h=h+Math.imul(w,$)|0;h=h+Math.imul(M,Y)|0;u=u+Math.imul(M,$)|0;o=o+Math.imul(y,ee)|0;h=h+Math.imul(y,te)|0;h=h+Math.imul(g,ee)|0;u=u+Math.imul(g,te)|0;o=o+Math.imul(v,ie)|0;h=h+Math.imul(v,ne)|0;h=h+Math.imul(b,ie)|0;u=u+Math.imul(b,ne)|0;o=o+Math.imul(c,fe)|0;h=h+Math.imul(c,se)|0;h=h+Math.imul(l,fe)|0;u=u+Math.imul(l,se)|0;var Ee=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Ee>>>26)|0;Ee&=67108863;o=Math.imul(I,W);h=Math.imul(I,V);h=h+Math.imul(C,W)|0;u=Math.imul(C,V);o=o+Math.imul(N,J)|0;h=h+Math.imul(N,Z)|0;h=h+Math.imul(P,J)|0;u=u+Math.imul(P,Z)|0;o=o+Math.imul(E,Y)|0;h=h+Math.imul(E,$)|0;h=h+Math.imul(k,Y)|0;u=u+Math.imul(k,$)|0;o=o+Math.imul(w,ee)|0;h=h+Math.imul(w,te)|0;h=h+Math.imul(M,ee)|0;u=u+Math.imul(M,te)|0;o=o+Math.imul(y,ie)|0;h=h+Math.imul(y,ne)|0;h=h+Math.imul(g,ie)|0;u=u+Math.imul(g,ne)|0;o=o+Math.imul(v,fe)|0;h=h+Math.imul(v,se)|0;h=h+Math.imul(b,fe)|0;u=u+Math.imul(b,se)|0;o=o+Math.imul(c,he)|0;h=h+Math.imul(c,ue)|0;h=h+Math.imul(l,he)|0;u=u+Math.imul(l,ue)|0;var ke=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(ke>>>26)|0;ke&=67108863;o=Math.imul(T,W);h=Math.imul(T,V);h=h+Math.imul(j,W)|0;u=Math.imul(j,V);o=o+Math.imul(I,J)|0;h=h+Math.imul(I,Z)|0;h=h+Math.imul(C,J)|0;u=u+Math.imul(C,Z)|0;o=o+Math.imul(N,Y)|0;h=h+Math.imul(N,$)|0;h=h+Math.imul(P,Y)|0;u=u+Math.imul(P,$)|0;o=o+Math.imul(E,ee)|0;h=h+Math.imul(E,te)|0;h=h+Math.imul(k,ee)|0;u=u+Math.imul(k,te)|0;o=o+Math.imul(w,ie)|0;h=h+Math.imul(w,ne)|0;h=h+Math.imul(M,ie)|0;u=u+Math.imul(M,ne)|0;o=o+Math.imul(y,fe)|0;h=h+Math.imul(y,se)|0;h=h+Math.imul(g,fe)|0;u=u+Math.imul(g,se)|0;o=o+Math.imul(v,he)|0;h=h+Math.imul(v,ue)|0;h=h+Math.imul(b,he)|0;u=u+Math.imul(b,ue)|0;o=o+Math.imul(c,ce)|0;h=h+Math.imul(c,le)|0;h=h+Math.imul(l,ce)|0;u=u+Math.imul(l,le)|0;var Ae=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Ae>>>26)|0;Ae&=67108863;o=Math.imul(O,W);h=Math.imul(O,V);h=h+Math.imul(H,W)|0;u=Math.imul(H,V);o=o+Math.imul(T,J)|0;h=h+Math.imul(T,Z)|0;h=h+Math.imul(j,J)|0;u=u+Math.imul(j,Z)|0;o=o+Math.imul(I,Y)|0;h=h+Math.imul(I,$)|0;h=h+Math.imul(C,Y)|0;u=u+Math.imul(C,$)|0;o=o+Math.imul(N,ee)|0;h=h+Math.imul(N,te)|0;h=h+Math.imul(P,ee)|0;u=u+Math.imul(P,te)|0;o=o+Math.imul(E,ie)|0;h=h+Math.imul(E,ne)|0;h=h+Math.imul(k,ie)|0;u=u+Math.imul(k,ne)|0;o=o+Math.imul(w,fe)|0;h=h+Math.imul(w,se)|0;h=h+Math.imul(M,fe)|0;u=u+Math.imul(M,se)|0;o=o+Math.imul(y,he)|0;h=h+Math.imul(y,ue)|0;h=h+Math.imul(g,he)|0;u=u+Math.imul(g,ue)|0;o=o+Math.imul(v,ce)|0;h=h+Math.imul(v,le)|0;h=h+Math.imul(b,ce)|0;u=u+Math.imul(b,le)|0;o=o+Math.imul(c,ve)|0;h=h+Math.imul(c,be)|0;h=h+Math.imul(l,ve)|0;u=u+Math.imul(l,be)|0;var Ne=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Ne>>>26)|0;Ne&=67108863;o=Math.imul(z,W);h=Math.imul(z,V);h=h+Math.imul(F,W)|0;u=Math.imul(F,V);o=o+Math.imul(O,J)|0;h=h+Math.imul(O,Z)|0;h=h+Math.imul(H,J)|0;u=u+Math.imul(H,Z)|0;o=o+Math.imul(T,Y)|0;h=h+Math.imul(T,$)|0;h=h+Math.imul(j,Y)|0;u=u+Math.imul(j,$)|0;o=o+Math.imul(I,ee)|0;h=h+Math.imul(I,te)|0;h=h+Math.imul(C,ee)|0;u=u+Math.imul(C,te)|0;o=o+Math.imul(N,ie)|0;h=h+Math.imul(N,ne)|0;h=h+Math.imul(P,ie)|0;u=u+Math.imul(P,ne)|0;o=o+Math.imul(E,fe)|0;h=h+Math.imul(E,se)|0;h=h+Math.imul(k,fe)|0;u=u+Math.imul(k,se)|0;o=o+Math.imul(w,he)|0;h=h+Math.imul(w,ue)|0;h=h+Math.imul(M,he)|0;u=u+Math.imul(M,ue)|0;o=o+Math.imul(y,ce)|0;h=h+Math.imul(y,le)|0;h=h+Math.imul(g,ce)|0;u=u+Math.imul(g,le)|0;o=o+Math.imul(v,ve)|0;h=h+Math.imul(v,be)|0;h=h+Math.imul(b,ve)|0;u=u+Math.imul(b,be)|0;o=o+Math.imul(c,ye)|0;h=h+Math.imul(c,ge)|0;h=h+Math.imul(l,ye)|0;u=u+Math.imul(l,ge)|0;var Re=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Re>>>26)|0;Re&=67108863;o=Math.imul(z,J);h=Math.imul(z,Z);h=h+Math.imul(F,J)|0;u=Math.imul(F,Z);o=o+Math.imul(O,Y)|0;h=h+Math.imul(O,$)|0;h=h+Math.imul(H,Y)|0;u=u+Math.imul(H,$)|0;o=o+Math.imul(T,ee)|0;h=h+Math.imul(T,te)|0;h=h+Math.imul(j,ee)|0;u=u+Math.imul(j,te)|0;o=o+Math.imul(I,ie)|0;h=h+Math.imul(I,ne)|0;h=h+Math.imul(C,ie)|0;u=u+Math.imul(C,ne)|0;o=o+Math.imul(N,fe)|0;h=h+Math.imul(N,se)|0;h=h+Math.imul(P,fe)|0;u=u+Math.imul(P,se)|0;o=o+Math.imul(E,he)|0;h=h+Math.imul(E,ue)|0;h=h+Math.imul(k,he)|0;u=u+Math.imul(k,ue)|0;o=o+Math.imul(w,ce)|0;h=h+Math.imul(w,le)|0;h=h+Math.imul(M,ce)|0;u=u+Math.imul(M,le)|0;o=o+Math.imul(y,ve)|0;h=h+Math.imul(y,be)|0;h=h+Math.imul(g,ve)|0;u=u+Math.imul(g,be)|0;o=o+Math.imul(v,ye)|0;h=h+Math.imul(v,ge)|0;h=h+Math.imul(b,ye)|0;u=u+Math.imul(b,ge)|0;var Pe=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Pe>>>26)|0;Pe&=67108863;o=Math.imul(z,Y);h=Math.imul(z,$);h=h+Math.imul(F,Y)|0;u=Math.imul(F,$);o=o+Math.imul(O,ee)|0;h=h+Math.imul(O,te)|0;h=h+Math.imul(H,ee)|0;u=u+Math.imul(H,te)|0;o=o+Math.imul(T,ie)|0;h=h+Math.imul(T,ne)|0;h=h+Math.imul(j,ie)|0;u=u+Math.imul(j,ne)|0;o=o+Math.imul(I,fe)|0;h=h+Math.imul(I,se)|0;h=h+Math.imul(C,fe)|0;u=u+Math.imul(C,se)|0;o=o+Math.imul(N,he)|0;h=h+Math.imul(N,ue)|0;h=h+Math.imul(P,he)|0;u=u+Math.imul(P,ue)|0;o=o+Math.imul(E,ce)|0;h=h+Math.imul(E,le)|0;h=h+Math.imul(k,ce)|0;u=u+Math.imul(k,le)|0;o=o+Math.imul(w,ve)|0;h=h+Math.imul(w,be)|0;h=h+Math.imul(M,ve)|0;u=u+Math.imul(M,be)|0;o=o+Math.imul(y,ye)|0;h=h+Math.imul(y,ge)|0;h=h+Math.imul(g,ye)|0;u=u+Math.imul(g,ge)|0;var xe=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(xe>>>26)|0;xe&=67108863;o=Math.imul(z,ee);h=Math.imul(z,te);h=h+Math.imul(F,ee)|0;u=Math.imul(F,te);o=o+Math.imul(O,ie)|0;h=h+Math.imul(O,ne)|0;h=h+Math.imul(H,ie)|0;u=u+Math.imul(H,ne)|0;o=o+Math.imul(T,fe)|0;h=h+Math.imul(T,se)|0;h=h+Math.imul(j,fe)|0;u=u+Math.imul(j,se)|0;o=o+Math.imul(I,he)|0;h=h+Math.imul(I,ue)|0;h=h+Math.imul(C,he)|0;u=u+Math.imul(C,ue)|0;o=o+Math.imul(N,ce)|0;h=h+Math.imul(N,le)|0;h=h+Math.imul(P,ce)|0;u=u+Math.imul(P,le)|0;o=o+Math.imul(E,ve)|0;h=h+Math.imul(E,be)|0;h=h+Math.imul(k,ve)|0;u=u+Math.imul(k,be)|0;o=o+Math.imul(w,ye)|0;h=h+Math.imul(w,ge)|0;h=h+Math.imul(M,ye)|0;u=u+Math.imul(M,ge)|0;var Ie=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Ie>>>26)|0;Ie&=67108863;o=Math.imul(z,ie);h=Math.imul(z,ne);h=h+Math.imul(F,ie)|0;u=Math.imul(F,ne);o=o+Math.imul(O,fe)|0;h=h+Math.imul(O,se)|0;h=h+Math.imul(H,fe)|0;u=u+Math.imul(H,se)|0;o=o+Math.imul(T,he)|0;h=h+Math.imul(T,ue)|0;h=h+Math.imul(j,he)|0;u=u+Math.imul(j,ue)|0;o=o+Math.imul(I,ce)|0;h=h+Math.imul(I,le)|0;h=h+Math.imul(C,ce)|0;u=u+Math.imul(C,le)|0;o=o+Math.imul(N,ve)|0;h=h+Math.imul(N,be)|0;h=h+Math.imul(P,ve)|0;u=u+Math.imul(P,be)|0;o=o+Math.imul(E,ye)|0;h=h+Math.imul(E,ge)|0;h=h+Math.imul(k,ye)|0;u=u+Math.imul(k,ge)|0;var Ce=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Ce>>>26)|0;Ce&=67108863;o=Math.imul(z,fe);h=Math.imul(z,se);h=h+Math.imul(F,fe)|0;u=Math.imul(F,se);o=o+Math.imul(O,he)|0;h=h+Math.imul(O,ue)|0;h=h+Math.imul(H,he)|0;u=u+Math.imul(H,ue)|0;o=o+Math.imul(T,ce)|0;h=h+Math.imul(T,le)|0;h=h+Math.imul(j,ce)|0;u=u+Math.imul(j,le)|0;o=o+Math.imul(I,ve)|0;h=h+Math.imul(I,be)|0;h=h+Math.imul(C,ve)|0;u=u+Math.imul(C,be)|0;o=o+Math.imul(N,ye)|0;h=h+Math.imul(N,ge)|0;h=h+Math.imul(P,ye)|0;u=u+Math.imul(P,ge)|0;var De=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(De>>>26)|0;De&=67108863;o=Math.imul(z,he);h=Math.imul(z,ue);h=h+Math.imul(F,he)|0;u=Math.imul(F,ue);o=o+Math.imul(O,ce)|0;h=h+Math.imul(O,le)|0;h=h+Math.imul(H,ce)|0;u=u+Math.imul(H,le)|0;o=o+Math.imul(T,ve)|0;h=h+Math.imul(T,be)|0;h=h+Math.imul(j,ve)|0;u=u+Math.imul(j,be)|0;o=o+Math.imul(I,ye)|0;h=h+Math.imul(I,ge)|0;h=h+Math.imul(C,ye)|0;u=u+Math.imul(C,ge)|0;var Te=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Te>>>26)|0;Te&=67108863;o=Math.imul(z,ce);h=Math.imul(z,le);h=h+Math.imul(F,ce)|0;u=Math.imul(F,le);o=o+Math.imul(O,ve)|0;h=h+Math.imul(O,be)|0;h=h+Math.imul(H,ve)|0;u=u+Math.imul(H,be)|0;o=o+Math.imul(T,ye)|0;h=h+Math.imul(T,ge)|0;h=h+Math.imul(j,ye)|0;u=u+Math.imul(j,ge)|0;var je=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(je>>>26)|0;je&=67108863;o=Math.imul(z,ve);h=Math.imul(z,be);h=h+Math.imul(F,ve)|0;u=Math.imul(F,be);o=o+Math.imul(O,ye)|0;h=h+Math.imul(O,ge)|0;h=h+Math.imul(H,ye)|0;u=u+Math.imul(H,ge)|0;var qe=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(qe>>>26)|0;qe&=67108863;o=Math.imul(z,ye);h=Math.imul(z,ge);h=h+Math.imul(F,ye)|0;u=Math.imul(F,ge);var Oe=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Oe>>>26)|0;Oe&=67108863;a[0]=_e;a[1]=we;a[2]=Me;a[3]=Se;a[4]=Be;a[5]=Ee;a[6]=ke;a[7]=Ae;a[8]=Ne;a[9]=Re;a[10]=Pe;a[11]=xe;a[12]=Ie;a[13]=Ce;a[14]=De;a[15]=Te;a[16]=je;a[17]=qe;a[18]=Oe;if(s!==0){a[19]=s;r.length++}return r};if(!Math.imul){h=smallMulTo}function bigMulTo(e,t,r){r.negative=t.negative^e.negative;r.length=e.length+t.length;var i=0;var n=0;for(var a=0;a<r.length-1;a++){var s=n;n=0;var o=i&67108863;var h=Math.min(a,t.length-1);for(var u=Math.max(0,a-e.length+1);u<=h;u++){var d=a-u;var c=e.words[d]|0;var l=t.words[u]|0;var p=c*l;var v=p&67108863;s=s+(p/67108864|0)|0;v=v+o|0;o=v&67108863;s=s+(v>>>26)|0;n+=s>>>26;s&=67108863}r.words[a]=o;i=s;s=n}if(i!==0){r.words[a]=i}else{r.length--}return r._strip()}function jumboMulTo(e,t,r){return bigMulTo(e,t,r)}BN.prototype.mulTo=function mulTo(e,t){var r;var i=this.length+e.length;if(this.length===10&&e.length===10){r=h(this,e,t)}else if(i<63){r=smallMulTo(this,e,t)}else if(i<1024){r=bigMulTo(this,e,t)}else{r=jumboMulTo(this,e,t)}return r};function FFTM(e,t){this.x=e;this.y=t}FFTM.prototype.makeRBT=function makeRBT(e){var t=new Array(e);var r=BN.prototype._countBits(e)-1;for(var i=0;i<e;i++){t[i]=this.revBin(i,r,e)}return t};FFTM.prototype.revBin=function revBin(e,t,r){if(e===0||e===r-1)return e;var i=0;for(var n=0;n<t;n++){i|=(e&1)<<t-n-1;e>>=1}return i};FFTM.prototype.permute=function permute(e,t,r,i,n,a){for(var s=0;s<a;s++){i[s]=t[e[s]];n[s]=r[e[s]]}};FFTM.prototype.transform=function transform(e,t,r,i,n,a){this.permute(a,e,t,r,i,n);for(var s=1;s<n;s<<=1){var o=s<<1;var h=Math.cos(2*Math.PI/o);var u=Math.sin(2*Math.PI/o);for(var d=0;d<n;d+=o){var c=h;var l=u;for(var p=0;p<s;p++){var v=r[d+p];var b=i[d+p];var m=r[d+p+s];var y=i[d+p+s];var g=c*m-l*y;y=c*y+l*m;m=g;r[d+p]=v+m;i[d+p]=b+y;r[d+p+s]=v-m;i[d+p+s]=b-y;if(p!==o){g=h*c-u*l;l=h*l+u*c;c=g}}}}};FFTM.prototype.guessLen13b=function guessLen13b(e,t){var r=Math.max(t,e)|1;var i=r&1;var n=0;for(r=r/2|0;r;r=r>>>1){n++}return 1<<n+1+i};FFTM.prototype.conjugate=function conjugate(e,t,r){if(r<=1)return;for(var i=0;i<r/2;i++){var n=e[i];e[i]=e[r-i-1];e[r-i-1]=n;n=t[i];t[i]=-t[r-i-1];t[r-i-1]=-n}};FFTM.prototype.normalize13b=function normalize13b(e,t){var r=0;for(var i=0;i<t/2;i++){var n=Math.round(e[2*i+1]/t)*8192+Math.round(e[2*i]/t)+r;e[i]=n&67108863;if(n<67108864){r=0}else{r=n/67108864|0}}return e};FFTM.prototype.convert13b=function convert13b(e,t,r,i){var n=0;for(var a=0;a<t;a++){n=n+(e[a]|0);r[2*a]=n&8191;n=n>>>13;r[2*a+1]=n&8191;n=n>>>13}for(a=2*t;a<i;++a){r[a]=0}assert(n===0);assert((n&~8191)===0)};FFTM.prototype.stub=function stub(e){var t=new Array(e);for(var r=0;r<e;r++){t[r]=0}return t};FFTM.prototype.mulp=function mulp(e,t,r){var i=2*this.guessLen13b(e.length,t.length);var n=this.makeRBT(i);var a=this.stub(i);var s=new Array(i);var o=new Array(i);var h=new Array(i);var u=new Array(i);var d=new Array(i);var c=new Array(i);var l=r.words;l.length=i;this.convert13b(e.words,e.length,s,i);this.convert13b(t.words,t.length,u,i);this.transform(s,a,o,h,i,n);this.transform(u,a,d,c,i,n);for(var p=0;p<i;p++){var v=o[p]*d[p]-h[p]*c[p];h[p]=o[p]*c[p]+h[p]*d[p];o[p]=v}this.conjugate(o,h,i);this.transform(o,h,l,a,i,n);this.conjugate(l,a,i);this.normalize13b(l,i);r.negative=e.negative^t.negative;r.length=e.length+t.length;return r._strip()};BN.prototype.mul=function mul(e){var t=new BN(null);t.words=new Array(this.length+e.length);return this.mulTo(e,t)};BN.prototype.mulf=function mulf(e){var t=new BN(null);t.words=new Array(this.length+e.length);return jumboMulTo(this,e,t)};BN.prototype.imul=function imul(e){return this.clone().mulTo(e,this)};BN.prototype.imuln=function imuln(e){var t=e<0;if(t)e=-e;assert(typeof e==="number");assert(e<67108864);var r=0;for(var i=0;i<this.length;i++){var n=(this.words[i]|0)*e;var a=(n&67108863)+(r&67108863);r>>=26;r+=n/67108864|0;r+=a>>>26;this.words[i]=a&67108863}if(r!==0){this.words[i]=r;this.length++}return t?this.ineg():this};BN.prototype.muln=function muln(e){return this.clone().imuln(e)};BN.prototype.sqr=function sqr(){return this.mul(this)};BN.prototype.isqr=function isqr(){return this.imul(this.clone())};BN.prototype.pow=function pow(e){var t=toBitArray(e);if(t.length===0)return new BN(1);var r=this;for(var i=0;i<t.length;i++,r=r.sqr()){if(t[i]!==0)break}if(++i<t.length){for(var n=r.sqr();i<t.length;i++,n=n.sqr()){if(t[i]===0)continue;r=r.mul(n)}}return r};BN.prototype.iushln=function iushln(e){assert(typeof e==="number"&&e>=0);var t=e%26;var r=(e-t)/26;var i=67108863>>>26-t<<26-t;var n;if(t!==0){var a=0;for(n=0;n<this.length;n++){var s=this.words[n]&i;var o=(this.words[n]|0)-s<<t;this.words[n]=o|a;a=s>>>26-t}if(a){this.words[n]=a;this.length++}}if(r!==0){for(n=this.length-1;n>=0;n--){this.words[n+r]=this.words[n]}for(n=0;n<r;n++){this.words[n]=0}this.length+=r}return this._strip()};BN.prototype.ishln=function ishln(e){assert(this.negative===0);return this.iushln(e)};BN.prototype.iushrn=function iushrn(e,t,r){assert(typeof e==="number"&&e>=0);var i;if(t){i=(t-t%26)/26}else{i=0}var n=e%26;var a=Math.min((e-n)/26,this.length);var s=67108863^67108863>>>n<<n;var o=r;i-=a;i=Math.max(0,i);if(o){for(var h=0;h<a;h++){o.words[h]=this.words[h]}o.length=a}if(a===0){}else if(this.length>a){this.length-=a;for(h=0;h<this.length;h++){this.words[h]=this.words[h+a]}}else{this.words[0]=0;this.length=1}var u=0;for(h=this.length-1;h>=0&&(u!==0||h>=i);h--){var d=this.words[h]|0;this.words[h]=u<<26-n|d>>>n;u=d&s}if(o&&u!==0){o.words[o.length++]=u}if(this.length===0){this.words[0]=0;this.length=1}return this._strip()};BN.prototype.ishrn=function ishrn(e,t,r){assert(this.negative===0);return this.iushrn(e,t,r)};BN.prototype.shln=function shln(e){return this.clone().ishln(e)};BN.prototype.ushln=function ushln(e){return this.clone().iushln(e)};BN.prototype.shrn=function shrn(e){return this.clone().ishrn(e)};BN.prototype.ushrn=function ushrn(e){return this.clone().iushrn(e)};BN.prototype.testn=function testn(e){assert(typeof e==="number"&&e>=0);var t=e%26;var r=(e-t)/26;var i=1<<t;if(this.length<=r)return false;var n=this.words[r];return!!(n&i)};BN.prototype.imaskn=function imaskn(e){assert(typeof e==="number"&&e>=0);var t=e%26;var r=(e-t)/26;assert(this.negative===0,"imaskn works only with positive numbers");if(this.length<=r){return this}if(t!==0){r++}this.length=Math.min(r,this.length);if(t!==0){var i=67108863^67108863>>>t<<t;this.words[this.length-1]&=i}return this._strip()};BN.prototype.maskn=function maskn(e){return this.clone().imaskn(e)};BN.prototype.iaddn=function iaddn(e){assert(typeof e==="number");assert(e<67108864);if(e<0)return this.isubn(-e);if(this.negative!==0){if(this.length===1&&(this.words[0]|0)<=e){this.words[0]=e-(this.words[0]|0);this.negative=0;return this}this.negative=0;this.isubn(e);this.negative=1;return this}return this._iaddn(e)};BN.prototype._iaddn=function _iaddn(e){this.words[0]+=e;for(var t=0;t<this.length&&this.words[t]>=67108864;t++){this.words[t]-=67108864;if(t===this.length-1){this.words[t+1]=1}else{this.words[t+1]++}}this.length=Math.max(this.length,t+1);return this};BN.prototype.isubn=function isubn(e){assert(typeof e==="number");assert(e<67108864);if(e<0)return this.iaddn(-e);if(this.negative!==0){this.negative=0;this.iaddn(e);this.negative=1;return this}this.words[0]-=e;if(this.length===1&&this.words[0]<0){this.words[0]=-this.words[0];this.negative=1}else{for(var t=0;t<this.length&&this.words[t]<0;t++){this.words[t]+=67108864;this.words[t+1]-=1}}return this._strip()};BN.prototype.addn=function addn(e){return this.clone().iaddn(e)};BN.prototype.subn=function subn(e){return this.clone().isubn(e)};BN.prototype.iabs=function iabs(){this.negative=0;return this};BN.prototype.abs=function abs(){return this.clone().iabs()};BN.prototype._ishlnsubmul=function _ishlnsubmul(e,t,r){var i=e.length+r;var n;this._expand(i);var a;var s=0;for(n=0;n<e.length;n++){a=(this.words[n+r]|0)+s;var o=(e.words[n]|0)*t;a-=o&67108863;s=(a>>26)-(o/67108864|0);this.words[n+r]=a&67108863}for(;n<this.length-r;n++){a=(this.words[n+r]|0)+s;s=a>>26;this.words[n+r]=a&67108863}if(s===0)return this._strip();assert(s===-1);s=0;for(n=0;n<this.length;n++){a=-(this.words[n]|0)+s;s=a>>26;this.words[n]=a&67108863}this.negative=1;return this._strip()};BN.prototype._wordDiv=function _wordDiv(e,t){var r=this.length-e.length;var i=this.clone();var n=e;var a=n.words[n.length-1]|0;var s=this._countBits(a);r=26-s;if(r!==0){n=n.ushln(r);i.iushln(r);a=n.words[n.length-1]|0}var o=i.length-n.length;var h;if(t!=="mod"){h=new BN(null);h.length=o+1;h.words=new Array(h.length);for(var u=0;u<h.length;u++){h.words[u]=0}}var d=i.clone()._ishlnsubmul(n,1,o);if(d.negative===0){i=d;if(h){h.words[o]=1}}for(var c=o-1;c>=0;c--){var l=(i.words[n.length+c]|0)*67108864+(i.words[n.length+c-1]|0);l=Math.min(l/a|0,67108863);i._ishlnsubmul(n,l,c);while(i.negative!==0){l--;i.negative=0;i._ishlnsubmul(n,1,c);if(!i.isZero()){i.negative^=1}}if(h){h.words[c]=l}}if(h){h._strip()}i._strip();if(t!=="div"&&r!==0){i.iushrn(r)}return{div:h||null,mod:i}};BN.prototype.divmod=function divmod(e,t,r){assert(!e.isZero());if(this.isZero()){return{div:new BN(0),mod:new BN(0)}}var i,n,a;if(this.negative!==0&&e.negative===0){a=this.neg().divmod(e,t);if(t!=="mod"){i=a.div.neg()}if(t!=="div"){n=a.mod.neg();if(r&&n.negative!==0){n.iadd(e)}}return{div:i,mod:n}}if(this.negative===0&&e.negative!==0){a=this.divmod(e.neg(),t);if(t!=="mod"){i=a.div.neg()}return{div:i,mod:a.mod}}if((this.negative&e.negative)!==0){a=this.neg().divmod(e.neg(),t);if(t!=="div"){n=a.mod.neg();if(r&&n.negative!==0){n.isub(e)}}return{div:a.div,mod:n}}if(e.length>this.length||this.cmp(e)<0){return{div:new BN(0),mod:this}}if(e.length===1){if(t==="div"){return{div:this.divn(e.words[0]),mod:null}}if(t==="mod"){return{div:null,mod:new BN(this.modrn(e.words[0]))}}return{div:this.divn(e.words[0]),mod:new BN(this.modrn(e.words[0]))}}return this._wordDiv(e,t)};BN.prototype.div=function div(e){return this.divmod(e,"div",false).div};BN.prototype.mod=function mod(e){return this.divmod(e,"mod",false).mod};BN.prototype.umod=function umod(e){return this.divmod(e,"mod",true).mod};BN.prototype.divRound=function divRound(e){var t=this.divmod(e);if(t.mod.isZero())return t.div;var r=t.div.negative!==0?t.mod.isub(e):t.mod;var i=e.ushrn(1);var n=e.andln(1);var a=r.cmp(i);if(a<0||n===1&&a===0)return t.div;return t.div.negative!==0?t.div.isubn(1):t.div.iaddn(1)};BN.prototype.modrn=function modrn(e){var t=e<0;if(t)e=-e;assert(e<=67108863);var r=(1<<26)%e;var i=0;for(var n=this.length-1;n>=0;n--){i=(r*i+(this.words[n]|0))%e}return t?-i:i};BN.prototype.modn=function modn(e){return this.modrn(e)};BN.prototype.idivn=function idivn(e){var t=e<0;if(t)e=-e;assert(e<=67108863);var r=0;for(var i=this.length-1;i>=0;i--){var n=(this.words[i]|0)+r*67108864;this.words[i]=n/e|0;r=n%e}this._strip();return t?this.ineg():this};BN.prototype.divn=function divn(e){return this.clone().idivn(e)};BN.prototype.egcd=function egcd(e){assert(e.negative===0);assert(!e.isZero());var t=this;var r=e.clone();if(t.negative!==0){t=t.umod(e)}else{t=t.clone()}var i=new BN(1);var n=new BN(0);var a=new BN(0);var s=new BN(1);var o=0;while(t.isEven()&&r.isEven()){t.iushrn(1);r.iushrn(1);++o}var h=r.clone();var u=t.clone();while(!t.isZero()){for(var d=0,c=1;(t.words[0]&c)===0&&d<26;++d,c<<=1);if(d>0){t.iushrn(d);while(d-- >0){if(i.isOdd()||n.isOdd()){i.iadd(h);n.isub(u)}i.iushrn(1);n.iushrn(1)}}for(var l=0,p=1;(r.words[0]&p)===0&&l<26;++l,p<<=1);if(l>0){r.iushrn(l);while(l-- >0){if(a.isOdd()||s.isOdd()){a.iadd(h);s.isub(u)}a.iushrn(1);s.iushrn(1)}}if(t.cmp(r)>=0){t.isub(r);i.isub(a);n.isub(s)}else{r.isub(t);a.isub(i);s.isub(n)}}return{a:a,b:s,gcd:r.iushln(o)}};BN.prototype._invmp=function _invmp(e){assert(e.negative===0);assert(!e.isZero());var t=this;var r=e.clone();if(t.negative!==0){t=t.umod(e)}else{t=t.clone()}var i=new BN(1);var n=new BN(0);var a=r.clone();while(t.cmpn(1)>0&&r.cmpn(1)>0){for(var s=0,o=1;(t.words[0]&o)===0&&s<26;++s,o<<=1);if(s>0){t.iushrn(s);while(s-- >0){if(i.isOdd()){i.iadd(a)}i.iushrn(1)}}for(var h=0,u=1;(r.words[0]&u)===0&&h<26;++h,u<<=1);if(h>0){r.iushrn(h);while(h-- >0){if(n.isOdd()){n.iadd(a)}n.iushrn(1)}}if(t.cmp(r)>=0){t.isub(r);i.isub(n)}else{r.isub(t);n.isub(i)}}var d;if(t.cmpn(1)===0){d=i}else{d=n}if(d.cmpn(0)<0){d.iadd(e)}return d};BN.prototype.gcd=function gcd(e){if(this.isZero())return e.abs();if(e.isZero())return this.abs();var t=this.clone();var r=e.clone();t.negative=0;r.negative=0;for(var i=0;t.isEven()&&r.isEven();i++){t.iushrn(1);r.iushrn(1)}do{while(t.isEven()){t.iushrn(1)}while(r.isEven()){r.iushrn(1)}var n=t.cmp(r);if(n<0){var a=t;t=r;r=a}else if(n===0||r.cmpn(1)===0){break}t.isub(r)}while(true);return r.iushln(i)};BN.prototype.invm=function invm(e){return this.egcd(e).a.umod(e)};BN.prototype.isEven=function isEven(){return(this.words[0]&1)===0};BN.prototype.isOdd=function isOdd(){return(this.words[0]&1)===1};BN.prototype.andln=function andln(e){return this.words[0]&e};BN.prototype.bincn=function bincn(e){assert(typeof e==="number");var t=e%26;var r=(e-t)/26;var i=1<<t;if(this.length<=r){this._expand(r+1);this.words[r]|=i;return this}var n=i;for(var a=r;n!==0&&a<this.length;a++){var s=this.words[a]|0;s+=n;n=s>>>26;s&=67108863;this.words[a]=s}if(n!==0){this.words[a]=n;this.length++}return this};BN.prototype.isZero=function isZero(){return this.length===1&&this.words[0]===0};BN.prototype.cmpn=function cmpn(e){var t=e<0;if(this.negative!==0&&!t)return-1;if(this.negative===0&&t)return 1;this._strip();var r;if(this.length>1){r=1}else{if(t){e=-e}assert(e<=67108863,"Number is too big");var i=this.words[0]|0;r=i===e?0:i<e?-1:1}if(this.negative!==0)return-r|0;return r};BN.prototype.cmp=function cmp(e){if(this.negative!==0&&e.negative===0)return-1;if(this.negative===0&&e.negative!==0)return 1;var t=this.ucmp(e);if(this.negative!==0)return-t|0;return t};BN.prototype.ucmp=function ucmp(e){if(this.length>e.length)return 1;if(this.length<e.length)return-1;var t=0;for(var r=this.length-1;r>=0;r--){var i=this.words[r]|0;var n=e.words[r]|0;if(i===n)continue;if(i<n){t=-1}else if(i>n){t=1}break}return t};BN.prototype.gtn=function gtn(e){return this.cmpn(e)===1};BN.prototype.gt=function gt(e){return this.cmp(e)===1};BN.prototype.gten=function gten(e){return this.cmpn(e)>=0};BN.prototype.gte=function gte(e){return this.cmp(e)>=0};BN.prototype.ltn=function ltn(e){return this.cmpn(e)===-1};BN.prototype.lt=function lt(e){return this.cmp(e)===-1};BN.prototype.lten=function lten(e){return this.cmpn(e)<=0};BN.prototype.lte=function lte(e){return this.cmp(e)<=0};BN.prototype.eqn=function eqn(e){return this.cmpn(e)===0};BN.prototype.eq=function eq(e){return this.cmp(e)===0};BN.red=function red(e){return new Red(e)};BN.prototype.toRed=function toRed(e){assert(!this.red,"Already a number in reduction context");assert(this.negative===0,"red works only with positives");return e.convertTo(this)._forceRed(e)};BN.prototype.fromRed=function fromRed(){assert(this.red,"fromRed works only with numbers in reduction context");return this.red.convertFrom(this)};BN.prototype._forceRed=function _forceRed(e){this.red=e;return this};BN.prototype.forceRed=function forceRed(e){assert(!this.red,"Already a number in reduction context");return this._forceRed(e)};BN.prototype.redAdd=function redAdd(e){assert(this.red,"redAdd works only with red numbers");return this.red.add(this,e)};BN.prototype.redIAdd=function redIAdd(e){assert(this.red,"redIAdd works only with red numbers");return this.red.iadd(this,e)};BN.prototype.redSub=function redSub(e){assert(this.red,"redSub works only with red numbers");return this.red.sub(this,e)};BN.prototype.redISub=function redISub(e){assert(this.red,"redISub works only with red numbers");return this.red.isub(this,e)};BN.prototype.redShl=function redShl(e){assert(this.red,"redShl works only with red numbers");return this.red.shl(this,e)};BN.prototype.redMul=function redMul(e){assert(this.red,"redMul works only with red numbers");this.red._verify2(this,e);return this.red.mul(this,e)};BN.prototype.redIMul=function redIMul(e){assert(this.red,"redMul works only with red numbers");this.red._verify2(this,e);return this.red.imul(this,e)};BN.prototype.redSqr=function redSqr(){assert(this.red,"redSqr works only with red numbers");this.red._verify1(this);return this.red.sqr(this)};BN.prototype.redISqr=function redISqr(){assert(this.red,"redISqr works only with red numbers");this.red._verify1(this);return this.red.isqr(this)};BN.prototype.redSqrt=function redSqrt(){assert(this.red,"redSqrt works only with red numbers");this.red._verify1(this);return this.red.sqrt(this)};BN.prototype.redInvm=function redInvm(){assert(this.red,"redInvm works only with red numbers");this.red._verify1(this);return this.red.invm(this)};BN.prototype.redNeg=function redNeg(){assert(this.red,"redNeg works only with red numbers");this.red._verify1(this);return this.red.neg(this)};BN.prototype.redPow=function redPow(e){assert(this.red&&!e.red,"redPow(normalNum)");this.red._verify1(this);return this.red.pow(this,e)};var u={k256:null,p224:null,p192:null,p25519:null};function MPrime(e,t){this.name=e;this.p=new BN(t,16);this.n=this.p.bitLength();this.k=new BN(1).iushln(this.n).isub(this.p);this.tmp=this._tmp()}MPrime.prototype._tmp=function _tmp(){var e=new BN(null);e.words=new Array(Math.ceil(this.n/13));return e};MPrime.prototype.ireduce=function ireduce(e){var t=e;var r;do{this.split(t,this.tmp);t=this.imulK(t);t=t.iadd(this.tmp);r=t.bitLength()}while(r>this.n);var i=r<this.n?-1:t.ucmp(this.p);if(i===0){t.words[0]=0;t.length=1}else if(i>0){t.isub(this.p)}else{if(t.strip!==undefined){t.strip()}else{t._strip()}}return t};MPrime.prototype.split=function split(e,t){e.iushrn(this.n,0,t)};MPrime.prototype.imulK=function imulK(e){return e.imul(this.k)};function K256(){MPrime.call(this,"k256","ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f")}inherits(K256,MPrime);K256.prototype.split=function split(e,t){var r=4194303;var i=Math.min(e.length,9);for(var n=0;n<i;n++){t.words[n]=e.words[n]}t.length=i;if(e.length<=9){e.words[0]=0;e.length=1;return}var a=e.words[9];t.words[t.length++]=a&r;for(n=10;n<e.length;n++){var s=e.words[n]|0;e.words[n-10]=(s&r)<<4|a>>>22;a=s}a>>>=22;e.words[n-10]=a;if(a===0&&e.length>10){e.length-=10}else{e.length-=9}};K256.prototype.imulK=function imulK(e){e.words[e.length]=0;e.words[e.length+1]=0;e.length+=2;var t=0;for(var r=0;r<e.length;r++){var i=e.words[r]|0;t+=i*977;e.words[r]=t&67108863;t=i*64+(t/67108864|0)}if(e.words[e.length-1]===0){e.length--;if(e.words[e.length-1]===0){e.length--}}return e};function P224(){MPrime.call(this,"p224","ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001")}inherits(P224,MPrime);function P192(){MPrime.call(this,"p192","ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff")}inherits(P192,MPrime);function P25519(){MPrime.call(this,"25519","7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed")}inherits(P25519,MPrime);P25519.prototype.imulK=function imulK(e){var t=0;for(var r=0;r<e.length;r++){var i=(e.words[r]|0)*19+t;var n=i&67108863;i>>>=26;e.words[r]=n;t=i}if(t!==0){e.words[e.length++]=t}return e};BN._prime=function prime(e){if(u[e])return u[e];var prime;if(e==="k256"){prime=new K256}else if(e==="p224"){prime=new P224}else if(e==="p192"){prime=new P192}else if(e==="p25519"){prime=new P25519}else{throw new Error("Unknown prime "+e)}u[e]=prime;return prime};function Red(e){if(typeof e==="string"){var t=BN._prime(e);this.m=t.p;this.prime=t}else{assert(e.gtn(1),"modulus must be greater than 1");this.m=e;this.prime=null}}Red.prototype._verify1=function _verify1(e){assert(e.negative===0,"red works only with positives");assert(e.red,"red works only with red numbers")};Red.prototype._verify2=function _verify2(e,t){assert((e.negative|t.negative)===0,"red works only with positives");assert(e.red&&e.red===t.red,"red works only with red numbers")};Red.prototype.imod=function imod(e){if(this.prime)return this.prime.ireduce(e)._forceRed(this);move(e,e.umod(this.m)._forceRed(this));return e};Red.prototype.neg=function neg(e){if(e.isZero()){return e.clone()}return this.m.sub(e)._forceRed(this)};Red.prototype.add=function add(e,t){this._verify2(e,t);var r=e.add(t);if(r.cmp(this.m)>=0){r.isub(this.m)}return r._forceRed(this)};Red.prototype.iadd=function iadd(e,t){this._verify2(e,t);var r=e.iadd(t);if(r.cmp(this.m)>=0){r.isub(this.m)}return r};Red.prototype.sub=function sub(e,t){this._verify2(e,t);var r=e.sub(t);if(r.cmpn(0)<0){r.iadd(this.m)}return r._forceRed(this)};Red.prototype.isub=function isub(e,t){this._verify2(e,t);var r=e.isub(t);if(r.cmpn(0)<0){r.iadd(this.m)}return r};Red.prototype.shl=function shl(e,t){this._verify1(e);return this.imod(e.ushln(t))};Red.prototype.imul=function imul(e,t){this._verify2(e,t);return this.imod(e.imul(t))};Red.prototype.mul=function mul(e,t){this._verify2(e,t);return this.imod(e.mul(t))};Red.prototype.isqr=function isqr(e){return this.imul(e,e.clone())};Red.prototype.sqr=function sqr(e){return this.mul(e,e)};Red.prototype.sqrt=function sqrt(e){if(e.isZero())return e.clone();var t=this.m.andln(3);assert(t%2===1);if(t===3){var r=this.m.add(new BN(1)).iushrn(2);return this.pow(e,r)}var i=this.m.subn(1);var n=0;while(!i.isZero()&&i.andln(1)===0){n++;i.iushrn(1)}assert(!i.isZero());var a=new BN(1).toRed(this);var s=a.redNeg();var o=this.m.subn(1).iushrn(1);var h=this.m.bitLength();h=new BN(2*h*h).toRed(this);while(this.pow(h,o).cmp(s)!==0){h.redIAdd(s)}var u=this.pow(h,i);var d=this.pow(e,i.addn(1).iushrn(1));var c=this.pow(e,i);var l=n;while(c.cmp(a)!==0){var p=c;for(var v=0;p.cmp(a)!==0;v++){p=p.redSqr()}assert(v<l);var b=this.pow(u,new BN(1).iushln(l-v-1));d=d.redMul(b);u=b.redSqr();c=c.redMul(u);l=v}return d};Red.prototype.invm=function invm(e){var t=e._invmp(this.m);if(t.negative!==0){t.negative=0;return this.imod(t).redNeg()}else{return this.imod(t)}};Red.prototype.pow=function pow(e,t){if(t.isZero())return new BN(1).toRed(this);if(t.cmpn(1)===0)return e.clone();var r=4;var i=new Array(1<<r);i[0]=new BN(1).toRed(this);i[1]=e;for(var n=2;n<i.length;n++){i[n]=this.mul(i[n-1],e)}var a=i[0];var s=0;var o=0;var h=t.bitLength()%26;if(h===0){h=26}for(n=t.length-1;n>=0;n--){var u=t.words[n];for(var d=h-1;d>=0;d--){var c=u>>d&1;if(a!==i[0]){a=this.sqr(a)}if(c===0&&s===0){o=0;continue}s<<=1;s|=c;o++;if(o!==r&&(n!==0||d!==0))continue;a=this.mul(a,i[s]);o=0;s=0}h=26}return a};Red.prototype.convertTo=function convertTo(e){var t=e.umod(this.m);return t===e?t.clone():t};Red.prototype.convertFrom=function convertFrom(e){var t=e.clone();t.red=null;return t};BN.mont=function mont(e){return new Mont(e)};function Mont(e){Red.call(this,e);this.shift=this.m.bitLength();if(this.shift%26!==0){this.shift+=26-this.shift%26}this.r=new BN(1).iushln(this.shift);this.r2=this.imod(this.r.sqr());this.rinv=this.r._invmp(this.m);this.minv=this.rinv.mul(this.r).isubn(1).div(this.m);this.minv=this.minv.umod(this.r);this.minv=this.r.sub(this.minv)}inherits(Mont,Red);Mont.prototype.convertTo=function convertTo(e){return this.imod(e.ushln(this.shift))};Mont.prototype.convertFrom=function convertFrom(e){var t=this.imod(e.mul(this.rinv));t.red=null;return t};Mont.prototype.imul=function imul(e,t){if(e.isZero()||t.isZero()){e.words[0]=0;e.length=1;return e}var r=e.imul(t);var i=r.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);var n=r.isub(i).iushrn(this.shift);var a=n;if(n.cmp(this.m)>=0){a=n.isub(this.m)}else if(n.cmpn(0)<0){a=n.iadd(this.m)}return a._forceRed(this)};Mont.prototype.mul=function mul(e,t){if(e.isZero()||t.isZero())return new BN(0)._forceRed(this);var r=e.mul(t);var i=r.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);var n=r.isub(i).iushrn(this.shift);var a=n;if(n.cmp(this.m)>=0){a=n.isub(this.m)}else if(n.cmpn(0)<0){a=n.iadd(this.m)}return a._forceRed(this)};Mont.prototype.invm=function invm(e){var t=this.imod(e._invmp(this.m).mul(this.r2));return t._forceRed(this)}})( false||e,this)},3500:function(e,t,r){var i;e.exports=function rand(e){if(!i)i=new Rand(null);return i.generate(e)};function Rand(e){this.rand=e}e.exports.Rand=Rand;Rand.prototype.generate=function generate(e){return this._rand(e)};Rand.prototype._rand=function _rand(e){if(this.rand.getBytes)return this.rand.getBytes(e);var t=new Uint8Array(e);for(var r=0;r<t.length;r++)t[r]=this.rand.getByte();return t};if(typeof self==="object"){if(self.crypto&&self.crypto.getRandomValues){Rand.prototype._rand=function _rand(e){var t=new Uint8Array(e);self.crypto.getRandomValues(t);return t}}else if(self.msCrypto&&self.msCrypto.getRandomValues){Rand.prototype._rand=function _rand(e){var t=new Uint8Array(e);self.msCrypto.getRandomValues(t);return t}}else if(typeof window==="object"){Rand.prototype._rand=function(){throw new Error("Not implemented yet")}}}else{try{var n=r(6113);if(typeof n.randomBytes!=="function")throw new Error("Not supported");Rand.prototype._rand=function _rand(e){return n.randomBytes(e)}}catch(e){}}},1387:function(e,t,r){var i=r(5055).Buffer;function asUInt32Array(e){if(!i.isBuffer(e))e=i.from(e);var t=e.length/4|0;var r=new Array(t);for(var n=0;n<t;n++){r[n]=e.readUInt32BE(n*4)}return r}function scrubVec(e){for(var t=0;t<e.length;e++){e[t]=0}}function cryptBlock(e,t,r,i,n){var a=r[0];var s=r[1];var o=r[2];var h=r[3];var u=e[0]^t[0];var d=e[1]^t[1];var c=e[2]^t[2];var l=e[3]^t[3];var p,v,b,m;var y=4;for(var g=1;g<n;g++){p=a[u>>>24]^s[d>>>16&255]^o[c>>>8&255]^h[l&255]^t[y++];v=a[d>>>24]^s[c>>>16&255]^o[l>>>8&255]^h[u&255]^t[y++];b=a[c>>>24]^s[l>>>16&255]^o[u>>>8&255]^h[d&255]^t[y++];m=a[l>>>24]^s[u>>>16&255]^o[d>>>8&255]^h[c&255]^t[y++];u=p;d=v;c=b;l=m}p=(i[u>>>24]<<24|i[d>>>16&255]<<16|i[c>>>8&255]<<8|i[l&255])^t[y++];v=(i[d>>>24]<<24|i[c>>>16&255]<<16|i[l>>>8&255]<<8|i[u&255])^t[y++];b=(i[c>>>24]<<24|i[l>>>16&255]<<16|i[u>>>8&255]<<8|i[d&255])^t[y++];m=(i[l>>>24]<<24|i[u>>>16&255]<<16|i[d>>>8&255]<<8|i[c&255])^t[y++];p=p>>>0;v=v>>>0;b=b>>>0;m=m>>>0;return[p,v,b,m]}var n=[0,1,2,4,8,16,32,64,128,27,54];var a=function(){var e=new Array(256);for(var t=0;t<256;t++){if(t<128){e[t]=t<<1}else{e[t]=t<<1^283}}var r=[];var i=[];var n=[[],[],[],[]];var a=[[],[],[],[]];var s=0;var o=0;for(var h=0;h<256;++h){var u=o^o<<1^o<<2^o<<3^o<<4;u=u>>>8^u&255^99;r[s]=u;i[u]=s;var d=e[s];var c=e[d];var l=e[c];var p=e[u]*257^u*16843008;n[0][s]=p<<24|p>>>8;n[1][s]=p<<16|p>>>16;n[2][s]=p<<8|p>>>24;n[3][s]=p;p=l*16843009^c*65537^d*257^s*16843008;a[0][u]=p<<24|p>>>8;a[1][u]=p<<16|p>>>16;a[2][u]=p<<8|p>>>24;a[3][u]=p;if(s===0){s=o=1}else{s=d^e[e[e[l^d]]];o^=e[e[o]]}}return{SBOX:r,INV_SBOX:i,SUB_MIX:n,INV_SUB_MIX:a}}();function AES(e){this._key=asUInt32Array(e);this._reset()}AES.blockSize=4*4;AES.keySize=256/8;AES.prototype.blockSize=AES.blockSize;AES.prototype.keySize=AES.keySize;AES.prototype._reset=function(){var e=this._key;var t=e.length;var r=t+6;var i=(r+1)*4;var s=[];for(var o=0;o<t;o++){s[o]=e[o]}for(o=t;o<i;o++){var h=s[o-1];if(o%t===0){h=h<<8|h>>>24;h=a.SBOX[h>>>24]<<24|a.SBOX[h>>>16&255]<<16|a.SBOX[h>>>8&255]<<8|a.SBOX[h&255];h^=n[o/t|0]<<24}else if(t>6&&o%t===4){h=a.SBOX[h>>>24]<<24|a.SBOX[h>>>16&255]<<16|a.SBOX[h>>>8&255]<<8|a.SBOX[h&255]}s[o]=s[o-t]^h}var u=[];for(var d=0;d<i;d++){var c=i-d;var l=s[c-(d%4?0:4)];if(d<4||c<=4){u[d]=l}else{u[d]=a.INV_SUB_MIX[0][a.SBOX[l>>>24]]^a.INV_SUB_MIX[1][a.SBOX[l>>>16&255]]^a.INV_SUB_MIX[2][a.SBOX[l>>>8&255]]^a.INV_SUB_MIX[3][a.SBOX[l&255]]}}this._nRounds=r;this._keySchedule=s;this._invKeySchedule=u};AES.prototype.encryptBlockRaw=function(e){e=asUInt32Array(e);return cryptBlock(e,this._keySchedule,a.SUB_MIX,a.SBOX,this._nRounds)};AES.prototype.encryptBlock=function(e){var t=this.encryptBlockRaw(e);var r=i.allocUnsafe(16);r.writeUInt32BE(t[0],0);r.writeUInt32BE(t[1],4);r.writeUInt32BE(t[2],8);r.writeUInt32BE(t[3],12);return r};AES.prototype.decryptBlock=function(e){e=asUInt32Array(e);var t=e[1];e[1]=e[3];e[3]=t;var r=cryptBlock(e,this._invKeySchedule,a.INV_SUB_MIX,a.INV_SBOX,this._nRounds);var n=i.allocUnsafe(16);n.writeUInt32BE(r[0],0);n.writeUInt32BE(r[3],4);n.writeUInt32BE(r[2],8);n.writeUInt32BE(r[1],12);return n};AES.prototype.scrub=function(){scrubVec(this._keySchedule);scrubVec(this._invKeySchedule);scrubVec(this._key)};e.exports.AES=AES},6624:function(e,t,r){var i=r(1387);var n=r(5055).Buffer;var a=r(1043);var s=r(3782);var o=r(7225);var h=r(4734);var u=r(598);function xorTest(e,t){var r=0;if(e.length!==t.length)r++;var i=Math.min(e.length,t.length);for(var n=0;n<i;++n){r+=e[n]^t[n]}return r}function calcIv(e,t,r){if(t.length===12){e._finID=n.concat([t,n.from([0,0,0,1])]);return n.concat([t,n.from([0,0,0,2])])}var i=new o(r);var a=t.length;var s=a%16;i.update(t);if(s){s=16-s;i.update(n.alloc(s,0))}i.update(n.alloc(8,0));var h=a*8;var d=n.alloc(8);d.writeUIntBE(h,0,8);i.update(d);e._finID=i.state;var c=n.from(e._finID);u(c);return c}function StreamCipher(e,t,r,s){a.call(this);var h=n.alloc(4,0);this._cipher=new i.AES(t);var u=this._cipher.encryptBlock(h);this._ghash=new o(u);r=calcIv(this,r,u);this._prev=n.from(r);this._cache=n.allocUnsafe(0);this._secCache=n.allocUnsafe(0);this._decrypt=s;this._alen=0;this._len=0;this._mode=e;this._authTag=null;this._called=false}s(StreamCipher,a);StreamCipher.prototype._update=function(e){if(!this._called&&this._alen){var t=16-this._alen%16;if(t<16){t=n.alloc(t,0);this._ghash.update(t)}}this._called=true;var r=this._mode.encrypt(this,e);if(this._decrypt){this._ghash.update(e)}else{this._ghash.update(r)}this._len+=e.length;return r};StreamCipher.prototype._final=function(){if(this._decrypt&&!this._authTag)throw new Error("Unsupported state or unable to authenticate data");var e=h(this._ghash.final(this._alen*8,this._len*8),this._cipher.encryptBlock(this._finID));if(this._decrypt&&xorTest(e,this._authTag))throw new Error("Unsupported state or unable to authenticate data");this._authTag=e;this._cipher.scrub()};StreamCipher.prototype.getAuthTag=function getAuthTag(){if(this._decrypt||!n.isBuffer(this._authTag))throw new Error("Attempting to get auth tag in unsupported state");return this._authTag};StreamCipher.prototype.setAuthTag=function setAuthTag(e){if(!this._decrypt)throw new Error("Attempting to set auth tag in unsupported state");this._authTag=e};StreamCipher.prototype.setAAD=function setAAD(e){if(this._called)throw new Error("Attempting to set AAD in unsupported state");this._ghash.update(e);this._alen+=e.length};e.exports=StreamCipher},6594:function(e,t,r){var i=r(2);var n=r(2598);var a=r(5866);function getCiphers(){return Object.keys(a)}t.createCipher=t.Cipher=i.createCipher;t.createCipheriv=t.Cipheriv=i.createCipheriv;t.createDecipher=t.Decipher=n.createDecipher;t.createDecipheriv=t.Decipheriv=n.createDecipheriv;t.listCiphers=t.getCiphers=getCiphers},2598:function(e,t,r){var i=r(6624);var n=r(5055).Buffer;var a=r(6370);var s=r(126);var o=r(1043);var h=r(1387);var u=r(8368);var d=r(3782);function Decipher(e,t,r){o.call(this);this._cache=new Splitter;this._last=void 0;this._cipher=new h.AES(t);this._prev=n.from(r);this._mode=e;this._autopadding=true}d(Decipher,o);Decipher.prototype._update=function(e){this._cache.add(e);var t;var r;var i=[];while(t=this._cache.get(this._autopadding)){r=this._mode.decrypt(this,t);i.push(r)}return n.concat(i)};Decipher.prototype._final=function(){var e=this._cache.flush();if(this._autopadding){return unpad(this._mode.decrypt(this,e))}else if(e){throw new Error("data not multiple of block length")}};Decipher.prototype.setAutoPadding=function(e){this._autopadding=!!e;return this};function Splitter(){this.cache=n.allocUnsafe(0)}Splitter.prototype.add=function(e){this.cache=n.concat([this.cache,e])};Splitter.prototype.get=function(e){var t;if(e){if(this.cache.length>16){t=this.cache.slice(0,16);this.cache=this.cache.slice(16);return t}}else{if(this.cache.length>=16){t=this.cache.slice(0,16);this.cache=this.cache.slice(16);return t}}return null};Splitter.prototype.flush=function(){if(this.cache.length)return this.cache};function unpad(e){var t=e[15];if(t<1||t>16){throw new Error("unable to decrypt data")}var r=-1;while(++r<t){if(e[r+(16-t)]!==t){throw new Error("unable to decrypt data")}}if(t===16)return;return e.slice(0,16-t)}function createDecipheriv(e,t,r){var o=a[e.toLowerCase()];if(!o)throw new TypeError("invalid suite type");if(typeof r==="string")r=n.from(r);if(o.mode!=="GCM"&&r.length!==o.iv)throw new TypeError("invalid iv length "+r.length);if(typeof t==="string")t=n.from(t);if(t.length!==o.key/8)throw new TypeError("invalid key length "+t.length);if(o.type==="stream"){return new s(o.module,t,r,true)}else if(o.type==="auth"){return new i(o.module,t,r,true)}return new Decipher(o.module,t,r)}function createDecipher(e,t){var r=a[e.toLowerCase()];if(!r)throw new TypeError("invalid suite type");var i=u(t,false,r.key,r.iv);return createDecipheriv(e,i.key,i.iv)}t.createDecipher=createDecipher;t.createDecipheriv=createDecipheriv},2:function(e,t,r){var i=r(6370);var n=r(6624);var a=r(5055).Buffer;var s=r(126);var o=r(1043);var h=r(1387);var u=r(8368);var d=r(3782);function Cipher(e,t,r){o.call(this);this._cache=new Splitter;this._cipher=new h.AES(t);this._prev=a.from(r);this._mode=e;this._autopadding=true}d(Cipher,o);Cipher.prototype._update=function(e){this._cache.add(e);var t;var r;var i=[];while(t=this._cache.get()){r=this._mode.encrypt(this,t);i.push(r)}return a.concat(i)};var c=a.alloc(16,16);Cipher.prototype._final=function(){var e=this._cache.flush();if(this._autopadding){e=this._mode.encrypt(this,e);this._cipher.scrub();return e}if(!e.equals(c)){this._cipher.scrub();throw new Error("data not multiple of block length")}};Cipher.prototype.setAutoPadding=function(e){this._autopadding=!!e;return this};function Splitter(){this.cache=a.allocUnsafe(0)}Splitter.prototype.add=function(e){this.cache=a.concat([this.cache,e])};Splitter.prototype.get=function(){if(this.cache.length>15){var e=this.cache.slice(0,16);this.cache=this.cache.slice(16);return e}return null};Splitter.prototype.flush=function(){var e=16-this.cache.length;var t=a.allocUnsafe(e);var r=-1;while(++r<e){t.writeUInt8(e,r)}return a.concat([this.cache,t])};function createCipheriv(e,t,r){var o=i[e.toLowerCase()];if(!o)throw new TypeError("invalid suite type");if(typeof t==="string")t=a.from(t);if(t.length!==o.key/8)throw new TypeError("invalid key length "+t.length);if(typeof r==="string")r=a.from(r);if(o.mode!=="GCM"&&r.length!==o.iv)throw new TypeError("invalid iv length "+r.length);if(o.type==="stream"){return new s(o.module,t,r)}else if(o.type==="auth"){return new n(o.module,t,r)}return new Cipher(o.module,t,r)}function createCipher(e,t){var r=i[e.toLowerCase()];if(!r)throw new TypeError("invalid suite type");var n=u(t,false,r.key,r.iv);return createCipheriv(e,n.key,n.iv)}t.createCipheriv=createCipheriv;t.createCipher=createCipher},7225:function(e,t,r){var i=r(5055).Buffer;var n=i.alloc(16,0);function toArray(e){return[e.readUInt32BE(0),e.readUInt32BE(4),e.readUInt32BE(8),e.readUInt32BE(12)]}function fromArray(e){var t=i.allocUnsafe(16);t.writeUInt32BE(e[0]>>>0,0);t.writeUInt32BE(e[1]>>>0,4);t.writeUInt32BE(e[2]>>>0,8);t.writeUInt32BE(e[3]>>>0,12);return t}function GHASH(e){this.h=e;this.state=i.alloc(16,0);this.cache=i.allocUnsafe(0)}GHASH.prototype.ghash=function(e){var t=-1;while(++t<e.length){this.state[t]^=e[t]}this._multiply()};GHASH.prototype._multiply=function(){var e=toArray(this.h);var t=[0,0,0,0];var r,i,n;var a=-1;while(++a<128){i=(this.state[~~(a/8)]&1<<7-a%8)!==0;if(i){t[0]^=e[0];t[1]^=e[1];t[2]^=e[2];t[3]^=e[3]}n=(e[3]&1)!==0;for(r=3;r>0;r--){e[r]=e[r]>>>1|(e[r-1]&1)<<31}e[0]=e[0]>>>1;if(n){e[0]=e[0]^225<<24}}this.state=fromArray(t)};GHASH.prototype.update=function(e){this.cache=i.concat([this.cache,e]);var t;while(this.cache.length>=16){t=this.cache.slice(0,16);this.cache=this.cache.slice(16);this.ghash(t)}};GHASH.prototype.final=function(e,t){if(this.cache.length){this.ghash(i.concat([this.cache,n],16))}this.ghash(fromArray([0,e,0,t]));return this.state};e.exports=GHASH},598:function(e){function incr32(e){var t=e.length;var r;while(t--){r=e.readUInt8(t);if(r===255){e.writeUInt8(0,t)}else{r++;e.writeUInt8(r,t);break}}}e.exports=incr32},9825:function(e,t,r){var i=r(4734);t.encrypt=function(e,t){var r=i(t,e._prev);e._prev=e._cipher.encryptBlock(r);return e._prev};t.decrypt=function(e,t){var r=e._prev;e._prev=t;var n=e._cipher.decryptBlock(t);return i(n,r)}},321:function(e,t,r){var i=r(5055).Buffer;var n=r(4734);function encryptStart(e,t,r){var a=t.length;var s=n(t,e._cache);e._cache=e._cache.slice(a);e._prev=i.concat([e._prev,r?t:s]);return s}t.encrypt=function(e,t,r){var n=i.allocUnsafe(0);var a;while(t.length){if(e._cache.length===0){e._cache=e._cipher.encryptBlock(e._prev);e._prev=i.allocUnsafe(0)}if(e._cache.length<=t.length){a=e._cache.length;n=i.concat([n,encryptStart(e,t.slice(0,a),r)]);t=t.slice(a)}else{n=i.concat([n,encryptStart(e,t,r)]);break}}return n}},3147:function(e,t,r){var i=r(5055).Buffer;function encryptByte(e,t,r){var i;var n=-1;var a=8;var s=0;var o,h;while(++n<a){i=e._cipher.encryptBlock(e._prev);o=t&1<<7-n?128:0;h=i[0]^o;s+=(h&128)>>n%8;e._prev=shiftIn(e._prev,r?o:h)}return s}function shiftIn(e,t){var r=e.length;var n=-1;var a=i.allocUnsafe(e.length);e=i.concat([e,i.from([t])]);while(++n<r){a[n]=e[n]<<1|e[n+1]>>7}return a}t.encrypt=function(e,t,r){var n=t.length;var a=i.allocUnsafe(n);var s=-1;while(++s<n){a[s]=encryptByte(e,t[s],r)}return a}},2430:function(e,t,r){var i=r(5055).Buffer;function encryptByte(e,t,r){var n=e._cipher.encryptBlock(e._prev);var a=n[0]^t;e._prev=i.concat([e._prev.slice(1),i.from([r?t:a])]);return a}t.encrypt=function(e,t,r){var n=t.length;var a=i.allocUnsafe(n);var s=-1;while(++s<n){a[s]=encryptByte(e,t[s],r)}return a}},3361:function(e,t,r){var i=r(4734);var n=r(5055).Buffer;var a=r(598);function getBlock(e){var t=e._cipher.encryptBlockRaw(e._prev);a(e._prev);return t}var s=16;t.encrypt=function(e,t){var r=Math.ceil(t.length/s);var a=e._cache.length;e._cache=n.concat([e._cache,n.allocUnsafe(r*s)]);for(var o=0;o<r;o++){var h=getBlock(e);var u=a+o*s;e._cache.writeUInt32BE(h[0],u+0);e._cache.writeUInt32BE(h[1],u+4);e._cache.writeUInt32BE(h[2],u+8);e._cache.writeUInt32BE(h[3],u+12)}var d=e._cache.slice(0,t.length);e._cache=e._cache.slice(t.length);return i(t,d)}},1590:function(e,t){t.encrypt=function(e,t){return e._cipher.encryptBlock(t)};t.decrypt=function(e,t){return e._cipher.decryptBlock(t)}},6370:function(e,t,r){var i={ECB:r(1590),CBC:r(9825),CFB:r(321),CFB8:r(2430),CFB1:r(3147),OFB:r(3412),CTR:r(3361),GCM:r(3361)};var n=r(5866);for(var a in n){n[a].module=i[n[a].mode]}e.exports=n},3412:function(e,t,r){var i=r(4734);function getBlock(e){e._prev=e._cipher.encryptBlock(e._prev);return e._prev}t.encrypt=function(e,t){while(e._cache.length<t.length){e._cache=Buffer.concat([e._cache,getBlock(e)])}var r=e._cache.slice(0,t.length);e._cache=e._cache.slice(t.length);return i(t,r)}},126:function(e,t,r){var i=r(1387);var n=r(5055).Buffer;var a=r(1043);var s=r(3782);function StreamCipher(e,t,r,s){a.call(this);this._cipher=new i.AES(t);this._prev=n.from(r);this._cache=n.allocUnsafe(0);this._secCache=n.allocUnsafe(0);this._decrypt=s;this._mode=e}s(StreamCipher,a);StreamCipher.prototype._update=function(e){return this._mode.encrypt(this,e,this._decrypt)};StreamCipher.prototype._final=function(){this._cipher.scrub()};e.exports=StreamCipher},8996:function(e,t,r){var i=r(5238);var n=r(6594);var a=r(6370);var s=r(6280);var o=r(8368);function createCipher(e,t){e=e.toLowerCase();var r,i;if(a[e]){r=a[e].key;i=a[e].iv}else if(s[e]){r=s[e].key*8;i=s[e].iv}else{throw new TypeError("invalid suite type")}var n=o(t,false,r,i);return createCipheriv(e,n.key,n.iv)}function createDecipher(e,t){e=e.toLowerCase();var r,i;if(a[e]){r=a[e].key;i=a[e].iv}else if(s[e]){r=s[e].key*8;i=s[e].iv}else{throw new TypeError("invalid suite type")}var n=o(t,false,r,i);return createDecipheriv(e,n.key,n.iv)}function createCipheriv(e,t,r){e=e.toLowerCase();if(a[e])return n.createCipheriv(e,t,r);if(s[e])return new i({key:t,iv:r,mode:e});throw new TypeError("invalid suite type")}function createDecipheriv(e,t,r){e=e.toLowerCase();if(a[e])return n.createDecipheriv(e,t,r);if(s[e])return new i({key:t,iv:r,mode:e,decrypt:true});throw new TypeError("invalid suite type")}function getCiphers(){return Object.keys(s).concat(n.getCiphers())}t.createCipher=t.Cipher=createCipher;t.createCipheriv=t.Cipheriv=createCipheriv;t.createDecipher=t.Decipher=createDecipher;t.createDecipheriv=t.Decipheriv=createDecipheriv;t.listCiphers=t.getCiphers=getCiphers},5238:function(e,t,r){var i=r(1043);var n=r(9536);var a=r(3782);var s=r(5055).Buffer;var o={"des-ede3-cbc":n.CBC.instantiate(n.EDE),"des-ede3":n.EDE,"des-ede-cbc":n.CBC.instantiate(n.EDE),"des-ede":n.EDE,"des-cbc":n.CBC.instantiate(n.DES),"des-ecb":n.DES};o.des=o["des-cbc"];o.des3=o["des-ede3-cbc"];e.exports=DES;a(DES,i);function DES(e){i.call(this);var t=e.mode.toLowerCase();var r=o[t];var n;if(e.decrypt){n="decrypt"}else{n="encrypt"}var a=e.key;if(!s.isBuffer(a)){a=s.from(a)}if(t==="des-ede"||t==="des-ede-cbc"){a=s.concat([a,a.slice(0,8)])}var h=e.iv;if(!s.isBuffer(h)){h=s.from(h)}this._des=r.create({key:a,iv:h,type:n})}DES.prototype._update=function(e){return s.from(this._des.update(e))};DES.prototype._final=function(){return s.from(this._des.final())}},6280:function(e,t){t["des-ecb"]={key:8,iv:0};t["des-cbc"]=t.des={key:8,iv:8};t["des-ede3-cbc"]=t.des3={key:24,iv:8};t["des-ede3"]={key:24,iv:0};t["des-ede-cbc"]={key:16,iv:8};t["des-ede"]={key:16,iv:0}},7166:function(e,t,r){var i=r(711);var n=r(7223);e.exports=crt;function blind(e){var t=getr(e);var r=t.toRed(i.mont(e.modulus)).redPow(new i(e.publicExponent)).fromRed();return{blinder:r,unblinder:t.invm(e.modulus)}}function crt(e,t){var r=blind(t);var n=t.modulus.byteLength();var a=i.mont(t.modulus);var s=new i(e).mul(r.blinder).umod(t.modulus);var o=s.toRed(i.mont(t.prime1));var h=s.toRed(i.mont(t.prime2));var u=t.coefficient;var d=t.prime1;var c=t.prime2;var l=o.redPow(t.exponent1);var p=h.redPow(t.exponent2);l=l.fromRed();p=p.fromRed();var v=l.isub(p).imul(u).umod(d);v.imul(c);p.iadd(v);return new Buffer(p.imul(r.unblinder).umod(t.modulus).toArray(false,n))}crt.getr=getr;function getr(e){var t=e.modulus.byteLength();var r=new i(n(t));while(r.cmp(e.modulus)>=0||!r.umod(e.prime1)||!r.umod(e.prime2)){r=new i(n(t))}return r}},9276:function(e,t,r){e.exports=r(2908)},4078:function(e,t,r){var i=r(5055).Buffer;var n=r(9739);var a=r(3726);var s=r(3782);var o=r(9807);var h=r(4013);var u=r(2908);Object.keys(u).forEach((function(e){u[e].id=i.from(u[e].id,"hex");u[e.toLowerCase()]=u[e]}));function Sign(e){a.Writable.call(this);var t=u[e];if(!t)throw new Error("Unknown message digest");this._hashType=t.hash;this._hash=n(t.hash);this._tag=t.id;this._signType=t.sign}s(Sign,a.Writable);Sign.prototype._write=function _write(e,t,r){this._hash.update(e);r()};Sign.prototype.update=function update(e,t){if(typeof e==="string")e=i.from(e,t);this._hash.update(e);return this};Sign.prototype.sign=function signMethod(e,t){this.end();var r=this._hash.digest();var i=o(r,e,this._hashType,this._signType,this._tag);return t?i.toString(t):i};function Verify(e){a.Writable.call(this);var t=u[e];if(!t)throw new Error("Unknown message digest");this._hash=n(t.hash);this._tag=t.id;this._signType=t.sign}s(Verify,a.Writable);Verify.prototype._write=function _write(e,t,r){this._hash.update(e);r()};Verify.prototype.update=function update(e,t){if(typeof e==="string")e=i.from(e,t);this._hash.update(e);return this};Verify.prototype.verify=function verifyMethod(e,t,r){if(typeof t==="string")t=i.from(t,r);this.end();var n=this._hash.digest();return h(t,n,e,this._signType,this._tag)};function createSign(e){return new Sign(e)}function createVerify(e){return new Verify(e)}e.exports={Sign:createSign,Verify:createVerify,createSign:createSign,createVerify:createVerify}},9807:function(e,t,r){var i=r(5055).Buffer;var n=r(4873);var a=r(7166);var s=r(949).ec;var o=r(1670);var h=r(9902);var u=r(9267);function sign(e,t,r,n,s){var o=h(t);if(o.curve){if(n!=="ecdsa"&&n!=="ecdsa/rsa")throw new Error("wrong private key type");return ecSign(e,o)}else if(o.type==="dsa"){if(n!=="dsa")throw new Error("wrong private key type");return dsaSign(e,o,r)}else{if(n!=="rsa"&&n!=="ecdsa/rsa")throw new Error("wrong private key type")}e=i.concat([s,e]);var u=o.modulus.byteLength();var d=[0,1];while(e.length+d.length+1<u)d.push(255);d.push(0);var c=-1;while(++c<e.length)d.push(e[c]);var l=a(d,o);return l}function ecSign(e,t){var r=u[t.curve.join(".")];if(!r)throw new Error("unknown curve "+t.curve.join("."));var n=new s(r);var a=n.keyFromPrivate(t.privateKey);var o=a.sign(e);return i.from(o.toDER())}function dsaSign(e,t,r){var i=t.params.priv_key;var n=t.params.p;var a=t.params.q;var s=t.params.g;var h=new o(0);var u;var d=bits2int(e,a).mod(a);var c=false;var l=getKey(i,a,e,r);while(c===false){u=makeKey(a,l,r);h=makeR(s,u,n,a);c=u.invm(a).imul(d.add(i.mul(h))).mod(a);if(c.cmpn(0)===0){c=false;h=new o(0)}}return toDER(h,c)}function toDER(e,t){e=e.toArray();t=t.toArray();if(e[0]&128)e=[0].concat(e);if(t[0]&128)t=[0].concat(t);var r=e.length+t.length+4;var n=[48,r,2,e.length];n=n.concat(e,[2,t.length],t);return i.from(n)}function getKey(e,t,r,a){e=i.from(e.toArray());if(e.length<t.byteLength()){var s=i.alloc(t.byteLength()-e.length);e=i.concat([s,e])}var o=r.length;var h=bits2octets(r,t);var u=i.alloc(o);u.fill(1);var d=i.alloc(o);d=n(a,d).update(u).update(i.from([0])).update(e).update(h).digest();u=n(a,d).update(u).digest();d=n(a,d).update(u).update(i.from([1])).update(e).update(h).digest();u=n(a,d).update(u).digest();return{k:d,v:u}}function bits2int(e,t){var r=new o(e);var i=(e.length<<3)-t.bitLength();if(i>0)r.ishrn(i);return r}function bits2octets(e,t){e=bits2int(e,t);e=e.mod(t);var r=i.from(e.toArray());if(r.length<t.byteLength()){var n=i.alloc(t.byteLength()-r.length);r=i.concat([n,r])}return r}function makeKey(e,t,r){var a;var s;do{a=i.alloc(0);while(a.length*8<e.bitLength()){t.v=n(r,t.k).update(t.v).digest();a=i.concat([a,t.v])}s=bits2int(a,e);t.k=n(r,t.k).update(t.v).update(i.from([0])).digest();t.v=n(r,t.k).update(t.v).digest()}while(s.cmp(e)!==-1);return s}function makeR(e,t,r,i){return e.toRed(o.mont(r)).redPow(t).fromRed().mod(i)}e.exports=sign;e.exports.getKey=getKey;e.exports.makeKey=makeKey},4013:function(e,t,r){var i=r(5055).Buffer;var n=r(1670);var a=r(949).ec;var s=r(9902);var o=r(9267);function verify(e,t,r,a,o){var h=s(r);if(h.type==="ec"){if(a!=="ecdsa"&&a!=="ecdsa/rsa")throw new Error("wrong public key type");return ecVerify(e,t,h)}else if(h.type==="dsa"){if(a!=="dsa")throw new Error("wrong public key type");return dsaVerify(e,t,h)}else{if(a!=="rsa"&&a!=="ecdsa/rsa")throw new Error("wrong public key type")}t=i.concat([o,t]);var u=h.modulus.byteLength();var d=[1];var c=0;while(t.length+d.length+2<u){d.push(255);c++}d.push(0);var l=-1;while(++l<t.length){d.push(t[l])}d=i.from(d);var p=n.mont(h.modulus);e=new n(e).toRed(p);e=e.redPow(new n(h.publicExponent));e=i.from(e.fromRed().toArray());var v=c<8?1:0;u=Math.min(e.length,d.length);if(e.length!==d.length)v=1;l=-1;while(++l<u)v|=e[l]^d[l];return v===0}function ecVerify(e,t,r){var i=o[r.data.algorithm.curve.join(".")];if(!i)throw new Error("unknown curve "+r.data.algorithm.curve.join("."));var n=new a(i);var s=r.data.subjectPrivateKey.data;return n.verify(t,e,s)}function dsaVerify(e,t,r){var i=r.data.p;var a=r.data.q;var o=r.data.g;var h=r.data.pub_key;var u=s.signature.decode(e,"der");var d=u.s;var c=u.r;checkValue(d,a);checkValue(c,a);var l=n.mont(i);var p=d.invm(a);var v=o.toRed(l).redPow(new n(t).mul(p).mod(a)).fromRed().mul(h.toRed(l).redPow(c.mul(p).mod(a)).fromRed()).mod(i).mod(a);return v.cmp(c)===0}function checkValue(e,t){if(e.cmpn(0)<=0)throw new Error("invalid sig");if(e.cmp(t)>=t)throw new Error("invalid sig")}e.exports=verify},4734:function(e){e.exports=function xor(e,t){var r=Math.min(e.length,t.length);var i=new Buffer(r);for(var n=0;n<r;++n){i[n]=e[n]^t[n]}return i}},1043:function(e,t,r){var i=r(5055).Buffer;var n=r(2781).Transform;var a=r(1576).StringDecoder;var s=r(3782);function CipherBase(e){n.call(this);this.hashMode=typeof e==="string";if(this.hashMode){this[e]=this._finalOrDigest}else{this.final=this._finalOrDigest}if(this._final){this.__final=this._final;this._final=null}this._decoder=null;this._encoding=null}s(CipherBase,n);CipherBase.prototype.update=function(e,t,r){if(typeof e==="string"){e=i.from(e,t)}var n=this._update(e);if(this.hashMode)return this;if(r){n=this._toString(n,r)}return n};CipherBase.prototype.setAutoPadding=function(){};CipherBase.prototype.getAuthTag=function(){throw new Error("trying to get auth tag in unsupported state")};CipherBase.prototype.setAuthTag=function(){throw new Error("trying to set auth tag in unsupported state")};CipherBase.prototype.setAAD=function(){throw new Error("trying to set aad in unsupported state")};CipherBase.prototype._transform=function(e,t,r){var i;try{if(this.hashMode){this._update(e)}else{this.push(this._update(e))}}catch(e){i=e}finally{r(i)}};CipherBase.prototype._flush=function(e){var t;try{this.push(this.__final())}catch(e){t=e}e(t)};CipherBase.prototype._finalOrDigest=function(e){var t=this.__final()||i.alloc(0);if(e){t=this._toString(t,e,true)}return t};CipherBase.prototype._toString=function(e,t,r){if(!this._decoder){this._decoder=new a(t);this._encoding=t}if(this._encoding!==t)throw new Error("can't switch encodings");var i=this._decoder.write(e);if(r){i+=this._decoder.end()}return i};e.exports=CipherBase},9942:function(e,t,r){var i=r(949);var n=r(711);e.exports=function createECDH(e){return new ECDH(e)};var a={secp256k1:{name:"secp256k1",byteLength:32},secp224r1:{name:"p224",byteLength:28},prime256v1:{name:"p256",byteLength:32},prime192v1:{name:"p192",byteLength:24},ed25519:{name:"ed25519",byteLength:32},secp384r1:{name:"p384",byteLength:48},secp521r1:{name:"p521",byteLength:66}};a.p224=a.secp224r1;a.p256=a.secp256r1=a.prime256v1;a.p192=a.secp192r1=a.prime192v1;a.p384=a.secp384r1;a.p521=a.secp521r1;function ECDH(e){this.curveType=a[e];if(!this.curveType){this.curveType={name:e}}this.curve=new i.ec(this.curveType.name);this.keys=void 0}ECDH.prototype.generateKeys=function(e,t){this.keys=this.curve.genKeyPair();return this.getPublicKey(e,t)};ECDH.prototype.computeSecret=function(e,t,r){t=t||"utf8";if(!Buffer.isBuffer(e)){e=new Buffer(e,t)}var i=this.curve.keyFromPublic(e).getPublic();var n=i.mul(this.keys.getPrivate()).getX();return formatReturnValue(n,r,this.curveType.byteLength)};ECDH.prototype.getPublicKey=function(e,t){var r=this.keys.getPublic(t==="compressed",true);if(t==="hybrid"){if(r[r.length-1]%2){r[0]=7}else{r[0]=6}}return formatReturnValue(r,e)};ECDH.prototype.getPrivateKey=function(e){return formatReturnValue(this.keys.getPrivate(),e)};ECDH.prototype.setPublicKey=function(e,t){t=t||"utf8";if(!Buffer.isBuffer(e)){e=new Buffer(e,t)}this.keys._importPublic(e);return this};ECDH.prototype.setPrivateKey=function(e,t){t=t||"utf8";if(!Buffer.isBuffer(e)){e=new Buffer(e,t)}var r=new n(e);r=r.toString(16);this.keys=this.curve.genKeyPair();this.keys._importPrivate(r);return this};function formatReturnValue(e,t,r){if(!Array.isArray(e)){e=e.toArray()}var i=new Buffer(e);if(r&&i.length<r){var n=new Buffer(r-i.length);n.fill(0);i=Buffer.concat([n,i])}if(!t){return i}else{return i.toString(t)}}},9739:function(e,t,r){"use strict";var i=r(3782);var n=r(3533);var a=r(3225);var s=r(4371);var o=r(1043);function Hash(e){o.call(this,"digest");this._hash=e}i(Hash,o);Hash.prototype._update=function(e){this._hash.update(e)};Hash.prototype._final=function(){return this._hash.digest()};e.exports=function createHash(e){e=e.toLowerCase();if(e==="md5")return new n;if(e==="rmd160"||e==="ripemd160")return new a;return new Hash(s(e))}},450:function(e,t,r){var i=r(3533);e.exports=function(e){return(new i).update(e).digest()}},4873:function(e,t,r){"use strict";var i=r(3782);var n=r(8119);var a=r(1043);var s=r(5055).Buffer;var o=r(450);var h=r(3225);var u=r(4371);var d=s.alloc(128);function Hmac(e,t){a.call(this,"digest");if(typeof t==="string"){t=s.from(t)}var r=e==="sha512"||e==="sha384"?128:64;this._alg=e;this._key=t;if(t.length>r){var i=e==="rmd160"?new h:u(e);t=i.update(t).digest()}else if(t.length<r){t=s.concat([t,d],r)}var n=this._ipad=s.allocUnsafe(r);var o=this._opad=s.allocUnsafe(r);for(var c=0;c<r;c++){n[c]=t[c]^54;o[c]=t[c]^92}this._hash=e==="rmd160"?new h:u(e);this._hash.update(n)}i(Hmac,a);Hmac.prototype._update=function(e){this._hash.update(e)};Hmac.prototype._final=function(){var e=this._hash.digest();var t=this._alg==="rmd160"?new h:u(this._alg);return t.update(this._opad).update(e).digest()};e.exports=function createHmac(e,t){e=e.toLowerCase();if(e==="rmd160"||e==="ripemd160"){return new Hmac("rmd160",t)}if(e==="md5"){return new n(o,t)}return new Hmac(e,t)}},8119:function(e,t,r){"use strict";var i=r(3782);var n=r(5055).Buffer;var a=r(1043);var s=n.alloc(128);var o=64;function Hmac(e,t){a.call(this,"digest");if(typeof t==="string"){t=n.from(t)}this._alg=e;this._key=t;if(t.length>o){t=e(t)}else if(t.length<o){t=n.concat([t,s],o)}var r=this._ipad=n.allocUnsafe(o);var i=this._opad=n.allocUnsafe(o);for(var h=0;h<o;h++){r[h]=t[h]^54;i[h]=t[h]^92}this._hash=[r]}i(Hmac,a);Hmac.prototype._update=function(e){this._hash.push(e)};Hmac.prototype._final=function(){var e=this._alg(n.concat(this._hash));return this._alg(n.concat([this._opad,e]))};e.exports=Hmac},9536:function(e,t,r){"use strict";t.utils=r(5334);t.Cipher=r(9876);t.DES=r(1016);t.CBC=r(8641);t.EDE=r(6159)},8641:function(e,t,r){"use strict";var i=r(3523);var n=r(3782);var a={};function CBCState(e){i.equal(e.length,8,"Invalid IV length");this.iv=new Array(8);for(var t=0;t<this.iv.length;t++)this.iv[t]=e[t]}function instantiate(e){function CBC(t){e.call(this,t);this._cbcInit()}n(CBC,e);var t=Object.keys(a);for(var r=0;r<t.length;r++){var i=t[r];CBC.prototype[i]=a[i]}CBC.create=function create(e){return new CBC(e)};return CBC}t.instantiate=instantiate;a._cbcInit=function _cbcInit(){var e=new CBCState(this.options.iv);this._cbcState=e};a._update=function _update(e,t,r,i){var n=this._cbcState;var a=this.constructor.super_.prototype;var s=n.iv;if(this.type==="encrypt"){for(var o=0;o<this.blockSize;o++)s[o]^=e[t+o];a._update.call(this,s,0,r,i);for(var o=0;o<this.blockSize;o++)s[o]=r[i+o]}else{a._update.call(this,e,t,r,i);for(var o=0;o<this.blockSize;o++)r[i+o]^=s[o];for(var o=0;o<this.blockSize;o++)s[o]=e[t+o]}}},9876:function(e,t,r){"use strict";var i=r(3523);function Cipher(e){this.options=e;this.type=this.options.type;this.blockSize=8;this._init();this.buffer=new Array(this.blockSize);this.bufferOff=0}e.exports=Cipher;Cipher.prototype._init=function _init(){};Cipher.prototype.update=function update(e){if(e.length===0)return[];if(this.type==="decrypt")return this._updateDecrypt(e);else return this._updateEncrypt(e)};Cipher.prototype._buffer=function _buffer(e,t){var r=Math.min(this.buffer.length-this.bufferOff,e.length-t);for(var i=0;i<r;i++)this.buffer[this.bufferOff+i]=e[t+i];this.bufferOff+=r;return r};Cipher.prototype._flushBuffer=function _flushBuffer(e,t){this._update(this.buffer,0,e,t);this.bufferOff=0;return this.blockSize};Cipher.prototype._updateEncrypt=function _updateEncrypt(e){var t=0;var r=0;var i=(this.bufferOff+e.length)/this.blockSize|0;var n=new Array(i*this.blockSize);if(this.bufferOff!==0){t+=this._buffer(e,t);if(this.bufferOff===this.buffer.length)r+=this._flushBuffer(n,r)}var a=e.length-(e.length-t)%this.blockSize;for(;t<a;t+=this.blockSize){this._update(e,t,n,r);r+=this.blockSize}for(;t<e.length;t++,this.bufferOff++)this.buffer[this.bufferOff]=e[t];return n};Cipher.prototype._updateDecrypt=function _updateDecrypt(e){var t=0;var r=0;var i=Math.ceil((this.bufferOff+e.length)/this.blockSize)-1;var n=new Array(i*this.blockSize);for(;i>0;i--){t+=this._buffer(e,t);r+=this._flushBuffer(n,r)}t+=this._buffer(e,t);return n};Cipher.prototype.final=function final(e){var t;if(e)t=this.update(e);var r;if(this.type==="encrypt")r=this._finalEncrypt();else r=this._finalDecrypt();if(t)return t.concat(r);else return r};Cipher.prototype._pad=function _pad(e,t){if(t===0)return false;while(t<e.length)e[t++]=0;return true};Cipher.prototype._finalEncrypt=function _finalEncrypt(){if(!this._pad(this.buffer,this.bufferOff))return[];var e=new Array(this.blockSize);this._update(this.buffer,0,e,0);return e};Cipher.prototype._unpad=function _unpad(e){return e};Cipher.prototype._finalDecrypt=function _finalDecrypt(){i.equal(this.bufferOff,this.blockSize,"Not enough data to decrypt");var e=new Array(this.blockSize);this._flushBuffer(e,0);return this._unpad(e)}},1016:function(e,t,r){"use strict";var i=r(3523);var n=r(3782);var a=r(5334);var s=r(9876);function DESState(){this.tmp=new Array(2);this.keys=null}function DES(e){s.call(this,e);var t=new DESState;this._desState=t;this.deriveKeys(t,e.key)}n(DES,s);e.exports=DES;DES.create=function create(e){return new DES(e)};var o=[1,1,2,2,2,2,2,2,1,2,2,2,2,2,2,1];DES.prototype.deriveKeys=function deriveKeys(e,t){e.keys=new Array(16*2);i.equal(t.length,this.blockSize,"Invalid key length");var r=a.readUInt32BE(t,0);var n=a.readUInt32BE(t,4);a.pc1(r,n,e.tmp,0);r=e.tmp[0];n=e.tmp[1];for(var s=0;s<e.keys.length;s+=2){var h=o[s>>>1];r=a.r28shl(r,h);n=a.r28shl(n,h);a.pc2(r,n,e.keys,s)}};DES.prototype._update=function _update(e,t,r,i){var n=this._desState;var s=a.readUInt32BE(e,t);var o=a.readUInt32BE(e,t+4);a.ip(s,o,n.tmp,0);s=n.tmp[0];o=n.tmp[1];if(this.type==="encrypt")this._encrypt(n,s,o,n.tmp,0);else this._decrypt(n,s,o,n.tmp,0);s=n.tmp[0];o=n.tmp[1];a.writeUInt32BE(r,s,i);a.writeUInt32BE(r,o,i+4)};DES.prototype._pad=function _pad(e,t){var r=e.length-t;for(var i=t;i<e.length;i++)e[i]=r;return true};DES.prototype._unpad=function _unpad(e){var t=e[e.length-1];for(var r=e.length-t;r<e.length;r++)i.equal(e[r],t);return e.slice(0,e.length-t)};DES.prototype._encrypt=function _encrypt(e,t,r,i,n){var s=t;var o=r;for(var h=0;h<e.keys.length;h+=2){var u=e.keys[h];var d=e.keys[h+1];a.expand(o,e.tmp,0);u^=e.tmp[0];d^=e.tmp[1];var c=a.substitute(u,d);var l=a.permute(c);var p=o;o=(s^l)>>>0;s=p}a.rip(o,s,i,n)};DES.prototype._decrypt=function _decrypt(e,t,r,i,n){var s=r;var o=t;for(var h=e.keys.length-2;h>=0;h-=2){var u=e.keys[h];var d=e.keys[h+1];a.expand(s,e.tmp,0);u^=e.tmp[0];d^=e.tmp[1];var c=a.substitute(u,d);var l=a.permute(c);var p=s;s=(o^l)>>>0;o=p}a.rip(s,o,i,n)}},6159:function(e,t,r){"use strict";var i=r(3523);var n=r(3782);var a=r(9876);var s=r(1016);function EDEState(e,t){i.equal(t.length,24,"Invalid key length");var r=t.slice(0,8);var n=t.slice(8,16);var a=t.slice(16,24);if(e==="encrypt"){this.ciphers=[s.create({type:"encrypt",key:r}),s.create({type:"decrypt",key:n}),s.create({type:"encrypt",key:a})]}else{this.ciphers=[s.create({type:"decrypt",key:a}),s.create({type:"encrypt",key:n}),s.create({type:"decrypt",key:r})]}}function EDE(e){a.call(this,e);var t=new EDEState(this.type,this.options.key);this._edeState=t}n(EDE,a);e.exports=EDE;EDE.create=function create(e){return new EDE(e)};EDE.prototype._update=function _update(e,t,r,i){var n=this._edeState;n.ciphers[0]._update(e,t,r,i);n.ciphers[1]._update(r,i,r,i);n.ciphers[2]._update(r,i,r,i)};EDE.prototype._pad=s.prototype._pad;EDE.prototype._unpad=s.prototype._unpad},5334:function(e,t){"use strict";t.readUInt32BE=function readUInt32BE(e,t){var r=e[0+t]<<24|e[1+t]<<16|e[2+t]<<8|e[3+t];return r>>>0};t.writeUInt32BE=function writeUInt32BE(e,t,r){e[0+r]=t>>>24;e[1+r]=t>>>16&255;e[2+r]=t>>>8&255;e[3+r]=t&255};t.ip=function ip(e,t,r,i){var n=0;var a=0;for(var s=6;s>=0;s-=2){for(var o=0;o<=24;o+=8){n<<=1;n|=t>>>o+s&1}for(var o=0;o<=24;o+=8){n<<=1;n|=e>>>o+s&1}}for(var s=6;s>=0;s-=2){for(var o=1;o<=25;o+=8){a<<=1;a|=t>>>o+s&1}for(var o=1;o<=25;o+=8){a<<=1;a|=e>>>o+s&1}}r[i+0]=n>>>0;r[i+1]=a>>>0};t.rip=function rip(e,t,r,i){var n=0;var a=0;for(var s=0;s<4;s++){for(var o=24;o>=0;o-=8){n<<=1;n|=t>>>o+s&1;n<<=1;n|=e>>>o+s&1}}for(var s=4;s<8;s++){for(var o=24;o>=0;o-=8){a<<=1;a|=t>>>o+s&1;a<<=1;a|=e>>>o+s&1}}r[i+0]=n>>>0;r[i+1]=a>>>0};t.pc1=function pc1(e,t,r,i){var n=0;var a=0;for(var s=7;s>=5;s--){for(var o=0;o<=24;o+=8){n<<=1;n|=t>>o+s&1}for(var o=0;o<=24;o+=8){n<<=1;n|=e>>o+s&1}}for(var o=0;o<=24;o+=8){n<<=1;n|=t>>o+s&1}for(var s=1;s<=3;s++){for(var o=0;o<=24;o+=8){a<<=1;a|=t>>o+s&1}for(var o=0;o<=24;o+=8){a<<=1;a|=e>>o+s&1}}for(var o=0;o<=24;o+=8){a<<=1;a|=e>>o+s&1}r[i+0]=n>>>0;r[i+1]=a>>>0};t.r28shl=function r28shl(e,t){return e<<t&268435455|e>>>28-t};var r=[14,11,17,4,27,23,25,0,13,22,7,18,5,9,16,24,2,20,12,21,1,8,15,26,15,4,25,19,9,1,26,16,5,11,23,8,12,7,17,0,22,3,10,14,6,20,27,24];t.pc2=function pc2(e,t,i,n){var a=0;var s=0;var o=r.length>>>1;for(var h=0;h<o;h++){a<<=1;a|=e>>>r[h]&1}for(var h=o;h<r.length;h++){s<<=1;s|=t>>>r[h]&1}i[n+0]=a>>>0;i[n+1]=s>>>0};t.expand=function expand(e,t,r){var i=0;var n=0;i=(e&1)<<5|e>>>27;for(var a=23;a>=15;a-=4){i<<=6;i|=e>>>a&63}for(var a=11;a>=3;a-=4){n|=e>>>a&63;n<<=6}n|=(e&31)<<1|e>>>31;t[r+0]=i>>>0;t[r+1]=n>>>0};var i=[14,0,4,15,13,7,1,4,2,14,15,2,11,13,8,1,3,10,10,6,6,12,12,11,5,9,9,5,0,3,7,8,4,15,1,12,14,8,8,2,13,4,6,9,2,1,11,7,15,5,12,11,9,3,7,14,3,10,10,0,5,6,0,13,15,3,1,13,8,4,14,7,6,15,11,2,3,8,4,14,9,12,7,0,2,1,13,10,12,6,0,9,5,11,10,5,0,13,14,8,7,10,11,1,10,3,4,15,13,4,1,2,5,11,8,6,12,7,6,12,9,0,3,5,2,14,15,9,10,13,0,7,9,0,14,9,6,3,3,4,15,6,5,10,1,2,13,8,12,5,7,14,11,12,4,11,2,15,8,1,13,1,6,10,4,13,9,0,8,6,15,9,3,8,0,7,11,4,1,15,2,14,12,3,5,11,10,5,14,2,7,12,7,13,13,8,14,11,3,5,0,6,6,15,9,0,10,3,1,4,2,7,8,2,5,12,11,1,12,10,4,14,15,9,10,3,6,15,9,0,0,6,12,10,11,1,7,13,13,8,15,9,1,4,3,5,14,11,5,12,2,7,8,2,4,14,2,14,12,11,4,2,1,12,7,4,10,7,11,13,6,1,8,5,5,0,3,15,15,10,13,3,0,9,14,8,9,6,4,11,2,8,1,12,11,7,10,1,13,14,7,2,8,13,15,6,9,15,12,0,5,9,6,10,3,4,0,5,14,3,12,10,1,15,10,4,15,2,9,7,2,12,6,9,8,5,0,6,13,1,3,13,4,14,14,0,7,11,5,3,11,8,9,4,14,3,15,2,5,12,2,9,8,5,12,15,3,10,7,11,0,14,4,1,10,7,1,6,13,0,11,8,6,13,4,13,11,0,2,11,14,7,15,4,0,9,8,1,13,10,3,14,12,3,9,5,7,12,5,2,10,15,6,8,1,6,1,6,4,11,11,13,13,8,12,1,3,4,7,10,14,7,10,9,15,5,6,0,8,15,0,14,5,2,9,3,2,12,13,1,2,15,8,13,4,8,6,10,15,3,11,7,1,4,10,12,9,5,3,6,14,11,5,0,0,14,12,9,7,2,7,2,11,1,4,14,1,7,9,4,12,10,14,8,2,13,0,15,6,12,10,9,13,0,15,3,3,5,5,6,8,11];t.substitute=function substitute(e,t){var r=0;for(var n=0;n<4;n++){var a=e>>>18-n*6&63;var s=i[n*64+a];r<<=4;r|=s}for(var n=0;n<4;n++){var a=t>>>18-n*6&63;var s=i[4*64+n*64+a];r<<=4;r|=s}return r>>>0};var n=[16,25,12,11,3,20,4,15,31,17,9,6,27,14,1,22,30,24,8,18,0,5,29,23,13,19,2,26,10,21,28,7];t.permute=function permute(e){var t=0;for(var r=0;r<n.length;r++){t<<=1;t|=e>>>n[r]&1}return t>>>0};t.padSplit=function padSplit(e,t,r){var i=e.toString(2);while(i.length<t)i="0"+i;var n=[];for(var a=0;a<t;a+=r)n.push(i.slice(a,a+r));return n.join(" ")}},6587:function(e,t,r){var i=r(296);var n=r(7992);var a=r(373);function getDiffieHellman(e){var t=new Buffer(n[e].prime,"hex");var r=new Buffer(n[e].gen,"hex");return new a(t,r)}var s={binary:true,hex:true,base64:true};function createDiffieHellman(e,t,r,n){if(Buffer.isBuffer(t)||s[t]===undefined){return createDiffieHellman(e,"binary",t,r)}t=t||"binary";n=n||"binary";r=r||new Buffer([2]);if(!Buffer.isBuffer(r)){r=new Buffer(r,n)}if(typeof e==="number"){return new a(i(e,r),r,true)}if(!Buffer.isBuffer(e)){e=new Buffer(e,t)}return new a(e,r,true)}t.DiffieHellmanGroup=t.createDiffieHellmanGroup=t.getDiffieHellman=getDiffieHellman;t.createDiffieHellman=t.DiffieHellman=createDiffieHellman},373:function(e,t,r){var i=r(711);var n=r(1354);var a=new n;var s=new i(24);var o=new i(11);var h=new i(10);var u=new i(3);var d=new i(7);var c=r(296);var l=r(7223);e.exports=DH;function setPublicKey(e,t){t=t||"utf8";if(!Buffer.isBuffer(e)){e=new Buffer(e,t)}this._pub=new i(e);return this}function setPrivateKey(e,t){t=t||"utf8";if(!Buffer.isBuffer(e)){e=new Buffer(e,t)}this._priv=new i(e);return this}var p={};function checkPrime(e,t){var r=t.toString("hex");var i=[r,e.toString(16)].join("_");if(i in p){return p[i]}var n=0;if(e.isEven()||!c.simpleSieve||!c.fermatTest(e)||!a.test(e)){n+=1;if(r==="02"||r==="05"){n+=8}else{n+=4}p[i]=n;return n}if(!a.test(e.shrn(1))){n+=2}var l;switch(r){case"02":if(e.mod(s).cmp(o)){n+=8}break;case"05":l=e.mod(h);if(l.cmp(u)&&l.cmp(d)){n+=8}break;default:n+=4}p[i]=n;return n}function DH(e,t,r){this.setGenerator(t);this.__prime=new i(e);this._prime=i.mont(this.__prime);this._primeLen=e.length;this._pub=undefined;this._priv=undefined;this._primeCode=undefined;if(r){this.setPublicKey=setPublicKey;this.setPrivateKey=setPrivateKey}else{this._primeCode=8}}Object.defineProperty(DH.prototype,"verifyError",{enumerable:true,get:function(){if(typeof this._primeCode!=="number"){this._primeCode=checkPrime(this.__prime,this.__gen)}return this._primeCode}});DH.prototype.generateKeys=function(){if(!this._priv){this._priv=new i(l(this._primeLen))}this._pub=this._gen.toRed(this._prime).redPow(this._priv).fromRed();return this.getPublicKey()};DH.prototype.computeSecret=function(e){e=new i(e);e=e.toRed(this._prime);var t=e.redPow(this._priv).fromRed();var r=new Buffer(t.toArray());var n=this.getPrime();if(r.length<n.length){var a=new Buffer(n.length-r.length);a.fill(0);r=Buffer.concat([a,r])}return r};DH.prototype.getPublicKey=function getPublicKey(e){return formatReturnValue(this._pub,e)};DH.prototype.getPrivateKey=function getPrivateKey(e){return formatReturnValue(this._priv,e)};DH.prototype.getPrime=function(e){return formatReturnValue(this.__prime,e)};DH.prototype.getGenerator=function(e){return formatReturnValue(this._gen,e)};DH.prototype.setGenerator=function(e,t){t=t||"utf8";if(!Buffer.isBuffer(e)){e=new Buffer(e,t)}this.__gen=e;this._gen=new i(e);return this};function formatReturnValue(e,t){var r=new Buffer(e.toArray());if(!t){return r}else{return r.toString(t)}}},296:function(e,t,r){var i=r(7223);e.exports=findPrime;findPrime.simpleSieve=simpleSieve;findPrime.fermatTest=fermatTest;var n=r(711);var a=new n(24);var s=r(1354);var o=new s;var h=new n(1);var u=new n(2);var d=new n(5);var c=new n(16);var l=new n(8);var p=new n(10);var v=new n(3);var b=new n(7);var m=new n(11);var y=new n(4);var g=new n(12);var _=null;function _getPrimes(){if(_!==null)return _;var e=1048576;var t=[];t[0]=2;for(var r=1,i=3;i<e;i+=2){var n=Math.ceil(Math.sqrt(i));for(var a=0;a<r&&t[a]<=n;a++)if(i%t[a]===0)break;if(r!==a&&t[a]<=n)continue;t[r++]=i}_=t;return t}function simpleSieve(e){var t=_getPrimes();for(var r=0;r<t.length;r++)if(e.modn(t[r])===0){if(e.cmpn(t[r])===0){return true}else{return false}}return true}function fermatTest(e){var t=n.mont(e);return u.toRed(t).redPow(e.subn(1)).fromRed().cmpn(1)===0}function findPrime(e,t){if(e<16){if(t===2||t===5){return new n([140,123])}else{return new n([140,39])}}t=new n(t);var r,s;while(true){r=new n(i(Math.ceil(e/8)));while(r.bitLength()>e){r.ishrn(1)}if(r.isEven()){r.iadd(h)}if(!r.testn(1)){r.iadd(u)}if(!t.cmp(u)){while(r.mod(a).cmp(m)){r.iadd(y)}}else if(!t.cmp(d)){while(r.mod(p).cmp(v)){r.iadd(y)}}s=r.shrn(1);if(simpleSieve(s)&&simpleSieve(r)&&fermatTest(s)&&fermatTest(r)&&o.test(s)&&o.test(r)){return r}}}},949:function(e,t,r){"use strict";var i=t;i.version=r(2531).i8;i.utils=r(4401);i.rand=r(3500);i.curve=r(9359);i.curves=r(6226);i.ec=r(4088);i.eddsa=r(8511)},2727:function(e,t,r){"use strict";var i=r(711);var n=r(4401);var a=n.getNAF;var s=n.getJSF;var o=n.assert;function BaseCurve(e,t){this.type=e;this.p=new i(t.p,16);this.red=t.prime?i.red(t.prime):i.mont(this.p);this.zero=new i(0).toRed(this.red);this.one=new i(1).toRed(this.red);this.two=new i(2).toRed(this.red);this.n=t.n&&new i(t.n,16);this.g=t.g&&this.pointFromJSON(t.g,t.gRed);this._wnafT1=new Array(4);this._wnafT2=new Array(4);this._wnafT3=new Array(4);this._wnafT4=new Array(4);this._bitLength=this.n?this.n.bitLength():0;var r=this.n&&this.p.div(this.n);if(!r||r.cmpn(100)>0){this.redN=null}else{this._maxwellTrick=true;this.redN=this.n.toRed(this.red)}}e.exports=BaseCurve;BaseCurve.prototype.point=function point(){throw new Error("Not implemented")};BaseCurve.prototype.validate=function validate(){throw new Error("Not implemented")};BaseCurve.prototype._fixedNafMul=function _fixedNafMul(e,t){o(e.precomputed);var r=e._getDoubles();var i=a(t,1,this._bitLength);var n=(1<<r.step+1)-(r.step%2===0?2:1);n/=3;var s=[];for(var h=0;h<i.length;h+=r.step){var u=0;for(var t=h+r.step-1;t>=h;t--)u=(u<<1)+i[t];s.push(u)}var d=this.jpoint(null,null,null);var c=this.jpoint(null,null,null);for(var l=n;l>0;l--){for(var h=0;h<s.length;h++){var u=s[h];if(u===l)c=c.mixedAdd(r.points[h]);else if(u===-l)c=c.mixedAdd(r.points[h].neg())}d=d.add(c)}return d.toP()};BaseCurve.prototype._wnafMul=function _wnafMul(e,t){var r=4;var i=e._getNAFPoints(r);r=i.wnd;var n=i.points;var s=a(t,r,this._bitLength);var h=this.jpoint(null,null,null);for(var u=s.length-1;u>=0;u--){for(var t=0;u>=0&&s[u]===0;u--)t++;if(u>=0)t++;h=h.dblp(t);if(u<0)break;var d=s[u];o(d!==0);if(e.type==="affine"){if(d>0)h=h.mixedAdd(n[d-1>>1]);else h=h.mixedAdd(n[-d-1>>1].neg())}else{if(d>0)h=h.add(n[d-1>>1]);else h=h.add(n[-d-1>>1].neg())}}return e.type==="affine"?h.toP():h};BaseCurve.prototype._wnafMulAdd=function _wnafMulAdd(e,t,r,i,n){var o=this._wnafT1;var h=this._wnafT2;var u=this._wnafT3;var d=0;for(var c=0;c<i;c++){var l=t[c];var p=l._getNAFPoints(e);o[c]=p.wnd;h[c]=p.points}for(var c=i-1;c>=1;c-=2){var v=c-1;var b=c;if(o[v]!==1||o[b]!==1){u[v]=a(r[v],o[v],this._bitLength);u[b]=a(r[b],o[b],this._bitLength);d=Math.max(u[v].length,d);d=Math.max(u[b].length,d);continue}var m=[t[v],null,null,t[b]];if(t[v].y.cmp(t[b].y)===0){m[1]=t[v].add(t[b]);m[2]=t[v].toJ().mixedAdd(t[b].neg())}else if(t[v].y.cmp(t[b].y.redNeg())===0){m[1]=t[v].toJ().mixedAdd(t[b]);m[2]=t[v].add(t[b].neg())}else{m[1]=t[v].toJ().mixedAdd(t[b]);m[2]=t[v].toJ().mixedAdd(t[b].neg())}var y=[-3,-1,-5,-7,0,7,5,1,3];var g=s(r[v],r[b]);d=Math.max(g[0].length,d);u[v]=new Array(d);u[b]=new Array(d);for(var _=0;_<d;_++){var w=g[0][_]|0;var M=g[1][_]|0;u[v][_]=y[(w+1)*3+(M+1)];u[b][_]=0;h[v]=m}}var B=this.jpoint(null,null,null);var E=this._wnafT4;for(var c=d;c>=0;c--){var k=0;while(c>=0){var A=true;for(var _=0;_<i;_++){E[_]=u[_][c]|0;if(E[_]!==0)A=false}if(!A)break;k++;c--}if(c>=0)k++;B=B.dblp(k);if(c<0)break;for(var _=0;_<i;_++){var N=E[_];var l;if(N===0)continue;else if(N>0)l=h[_][N-1>>1];else if(N<0)l=h[_][-N-1>>1].neg();if(l.type==="affine")B=B.mixedAdd(l);else B=B.add(l)}}for(var c=0;c<i;c++)h[c]=null;if(n)return B;else return B.toP()};function BasePoint(e,t){this.curve=e;this.type=t;this.precomputed=null}BaseCurve.BasePoint=BasePoint;BasePoint.prototype.eq=function eq(){throw new Error("Not implemented")};BasePoint.prototype.validate=function validate(){return this.curve.validate(this)};BaseCurve.prototype.decodePoint=function decodePoint(e,t){e=n.toArray(e,t);var r=this.p.byteLength();if((e[0]===4||e[0]===6||e[0]===7)&&e.length-1===2*r){if(e[0]===6)o(e[e.length-1]%2===0);else if(e[0]===7)o(e[e.length-1]%2===1);var i=this.point(e.slice(1,1+r),e.slice(1+r,1+2*r));return i}else if((e[0]===2||e[0]===3)&&e.length-1===r){return this.pointFromX(e.slice(1,1+r),e[0]===3)}throw new Error("Unknown point format")};BasePoint.prototype.encodeCompressed=function encodeCompressed(e){return this.encode(e,true)};BasePoint.prototype._encode=function _encode(e){var t=this.curve.p.byteLength();var r=this.getX().toArray("be",t);if(e)return[this.getY().isEven()?2:3].concat(r);return[4].concat(r,this.getY().toArray("be",t))};BasePoint.prototype.encode=function encode(e,t){return n.encode(this._encode(t),e)};BasePoint.prototype.precompute=function precompute(e){if(this.precomputed)return this;var t={doubles:null,naf:null,beta:null};t.naf=this._getNAFPoints(8);t.doubles=this._getDoubles(4,e);t.beta=this._getBeta();this.precomputed=t;return this};BasePoint.prototype._hasDoubles=function _hasDoubles(e){if(!this.precomputed)return false;var t=this.precomputed.doubles;if(!t)return false;return t.points.length>=Math.ceil((e.bitLength()+1)/t.step)};BasePoint.prototype._getDoubles=function _getDoubles(e,t){if(this.precomputed&&this.precomputed.doubles)return this.precomputed.doubles;var r=[this];var i=this;for(var n=0;n<t;n+=e){for(var a=0;a<e;a++)i=i.dbl();r.push(i)}return{step:e,points:r}};BasePoint.prototype._getNAFPoints=function _getNAFPoints(e){if(this.precomputed&&this.precomputed.naf)return this.precomputed.naf;var t=[this];var r=(1<<e)-1;var i=r===1?null:this.dbl();for(var n=1;n<r;n++)t[n]=t[n-1].add(i);return{wnd:e,points:t}};BasePoint.prototype._getBeta=function _getBeta(){return null};BasePoint.prototype.dblp=function dblp(e){var t=this;for(var r=0;r<e;r++)t=t.dbl();return t}},2705:function(e,t,r){"use strict";var i=r(4401);var n=r(711);var a=r(3782);var s=r(2727);var o=i.assert;function EdwardsCurve(e){this.twisted=(e.a|0)!==1;this.mOneA=this.twisted&&(e.a|0)===-1;this.extended=this.mOneA;s.call(this,"edwards",e);this.a=new n(e.a,16).umod(this.red.m);this.a=this.a.toRed(this.red);this.c=new n(e.c,16).toRed(this.red);this.c2=this.c.redSqr();this.d=new n(e.d,16).toRed(this.red);this.dd=this.d.redAdd(this.d);o(!this.twisted||this.c.fromRed().cmpn(1)===0);this.oneC=(e.c|0)===1}a(EdwardsCurve,s);e.exports=EdwardsCurve;EdwardsCurve.prototype._mulA=function _mulA(e){if(this.mOneA)return e.redNeg();else return this.a.redMul(e)};EdwardsCurve.prototype._mulC=function _mulC(e){if(this.oneC)return e;else return this.c.redMul(e)};EdwardsCurve.prototype.jpoint=function jpoint(e,t,r,i){return this.point(e,t,r,i)};EdwardsCurve.prototype.pointFromX=function pointFromX(e,t){e=new n(e,16);if(!e.red)e=e.toRed(this.red);var r=e.redSqr();var i=this.c2.redSub(this.a.redMul(r));var a=this.one.redSub(this.c2.redMul(this.d).redMul(r));var s=i.redMul(a.redInvm());var o=s.redSqrt();if(o.redSqr().redSub(s).cmp(this.zero)!==0)throw new Error("invalid point");var h=o.fromRed().isOdd();if(t&&!h||!t&&h)o=o.redNeg();return this.point(e,o)};EdwardsCurve.prototype.pointFromY=function pointFromY(e,t){e=new n(e,16);if(!e.red)e=e.toRed(this.red);var r=e.redSqr();var i=r.redSub(this.c2);var a=r.redMul(this.d).redMul(this.c2).redSub(this.a);var s=i.redMul(a.redInvm());if(s.cmp(this.zero)===0){if(t)throw new Error("invalid point");else return this.point(this.zero,e)}var o=s.redSqrt();if(o.redSqr().redSub(s).cmp(this.zero)!==0)throw new Error("invalid point");if(o.fromRed().isOdd()!==t)o=o.redNeg();return this.point(o,e)};EdwardsCurve.prototype.validate=function validate(e){if(e.isInfinity())return true;e.normalize();var t=e.x.redSqr();var r=e.y.redSqr();var i=t.redMul(this.a).redAdd(r);var n=this.c2.redMul(this.one.redAdd(this.d.redMul(t).redMul(r)));return i.cmp(n)===0};function Point(e,t,r,i,a){s.BasePoint.call(this,e,"projective");if(t===null&&r===null&&i===null){this.x=this.curve.zero;this.y=this.curve.one;this.z=this.curve.one;this.t=this.curve.zero;this.zOne=true}else{this.x=new n(t,16);this.y=new n(r,16);this.z=i?new n(i,16):this.curve.one;this.t=a&&new n(a,16);if(!this.x.red)this.x=this.x.toRed(this.curve.red);if(!this.y.red)this.y=this.y.toRed(this.curve.red);if(!this.z.red)this.z=this.z.toRed(this.curve.red);if(this.t&&!this.t.red)this.t=this.t.toRed(this.curve.red);this.zOne=this.z===this.curve.one;if(this.curve.extended&&!this.t){this.t=this.x.redMul(this.y);if(!this.zOne)this.t=this.t.redMul(this.z.redInvm())}}}a(Point,s.BasePoint);EdwardsCurve.prototype.pointFromJSON=function pointFromJSON(e){return Point.fromJSON(this,e)};EdwardsCurve.prototype.point=function point(e,t,r,i){return new Point(this,e,t,r,i)};Point.fromJSON=function fromJSON(e,t){return new Point(e,t[0],t[1],t[2])};Point.prototype.inspect=function inspect(){if(this.isInfinity())return"<EC Point Infinity>";return"<EC Point x: "+this.x.fromRed().toString(16,2)+" y: "+this.y.fromRed().toString(16,2)+" z: "+this.z.fromRed().toString(16,2)+">"};Point.prototype.isInfinity=function isInfinity(){return this.x.cmpn(0)===0&&(this.y.cmp(this.z)===0||this.zOne&&this.y.cmp(this.curve.c)===0)};Point.prototype._extDbl=function _extDbl(){var e=this.x.redSqr();var t=this.y.redSqr();var r=this.z.redSqr();r=r.redIAdd(r);var i=this.curve._mulA(e);var n=this.x.redAdd(this.y).redSqr().redISub(e).redISub(t);var a=i.redAdd(t);var s=a.redSub(r);var o=i.redSub(t);var h=n.redMul(s);var u=a.redMul(o);var d=n.redMul(o);var c=s.redMul(a);return this.curve.point(h,u,c,d)};Point.prototype._projDbl=function _projDbl(){var e=this.x.redAdd(this.y).redSqr();var t=this.x.redSqr();var r=this.y.redSqr();var i;var n;var a;if(this.curve.twisted){var s=this.curve._mulA(t);var o=s.redAdd(r);if(this.zOne){i=e.redSub(t).redSub(r).redMul(o.redSub(this.curve.two));n=o.redMul(s.redSub(r));a=o.redSqr().redSub(o).redSub(o)}else{var h=this.z.redSqr();var u=o.redSub(h).redISub(h);i=e.redSub(t).redISub(r).redMul(u);n=o.redMul(s.redSub(r));a=o.redMul(u)}}else{var s=t.redAdd(r);var h=this.curve._mulC(this.z).redSqr();var u=s.redSub(h).redSub(h);i=this.curve._mulC(e.redISub(s)).redMul(u);n=this.curve._mulC(s).redMul(t.redISub(r));a=s.redMul(u)}return this.curve.point(i,n,a)};Point.prototype.dbl=function dbl(){if(this.isInfinity())return this;if(this.curve.extended)return this._extDbl();else return this._projDbl()};Point.prototype._extAdd=function _extAdd(e){var t=this.y.redSub(this.x).redMul(e.y.redSub(e.x));var r=this.y.redAdd(this.x).redMul(e.y.redAdd(e.x));var i=this.t.redMul(this.curve.dd).redMul(e.t);var n=this.z.redMul(e.z.redAdd(e.z));var a=r.redSub(t);var s=n.redSub(i);var o=n.redAdd(i);var h=r.redAdd(t);var u=a.redMul(s);var d=o.redMul(h);var c=a.redMul(h);var l=s.redMul(o);return this.curve.point(u,d,l,c)};Point.prototype._projAdd=function _projAdd(e){var t=this.z.redMul(e.z);var r=t.redSqr();var i=this.x.redMul(e.x);var n=this.y.redMul(e.y);var a=this.curve.d.redMul(i).redMul(n);var s=r.redSub(a);var o=r.redAdd(a);var h=this.x.redAdd(this.y).redMul(e.x.redAdd(e.y)).redISub(i).redISub(n);var u=t.redMul(s).redMul(h);var d;var c;if(this.curve.twisted){d=t.redMul(o).redMul(n.redSub(this.curve._mulA(i)));c=s.redMul(o)}else{d=t.redMul(o).redMul(n.redSub(i));c=this.curve._mulC(s).redMul(o)}return this.curve.point(u,d,c)};Point.prototype.add=function add(e){if(this.isInfinity())return e;if(e.isInfinity())return this;if(this.curve.extended)return this._extAdd(e);else return this._projAdd(e)};Point.prototype.mul=function mul(e){if(this._hasDoubles(e))return this.curve._fixedNafMul(this,e);else return this.curve._wnafMul(this,e)};Point.prototype.mulAdd=function mulAdd(e,t,r){return this.curve._wnafMulAdd(1,[this,t],[e,r],2,false)};Point.prototype.jmulAdd=function jmulAdd(e,t,r){return this.curve._wnafMulAdd(1,[this,t],[e,r],2,true)};Point.prototype.normalize=function normalize(){if(this.zOne)return this;var e=this.z.redInvm();this.x=this.x.redMul(e);this.y=this.y.redMul(e);if(this.t)this.t=this.t.redMul(e);this.z=this.curve.one;this.zOne=true;return this};Point.prototype.neg=function neg(){return this.curve.point(this.x.redNeg(),this.y,this.z,this.t&&this.t.redNeg())};Point.prototype.getX=function getX(){this.normalize();return this.x.fromRed()};Point.prototype.getY=function getY(){this.normalize();return this.y.fromRed()};Point.prototype.eq=function eq(e){return this===e||this.getX().cmp(e.getX())===0&&this.getY().cmp(e.getY())===0};Point.prototype.eqXToP=function eqXToP(e){var t=e.toRed(this.curve.red).redMul(this.z);if(this.x.cmp(t)===0)return true;var r=e.clone();var i=this.curve.redN.redMul(this.z);for(;;){r.iadd(this.curve.n);if(r.cmp(this.curve.p)>=0)return false;t.redIAdd(i);if(this.x.cmp(t)===0)return true}};Point.prototype.toP=Point.prototype.normalize;Point.prototype.mixedAdd=Point.prototype.add},9359:function(e,t,r){"use strict";var i=t;i.base=r(2727);i.short=r(4720);i.mont=r(6653);i.edwards=r(2705)},6653:function(e,t,r){"use strict";var i=r(711);var n=r(3782);var a=r(2727);var s=r(4401);function MontCurve(e){a.call(this,"mont",e);this.a=new i(e.a,16).toRed(this.red);this.b=new i(e.b,16).toRed(this.red);this.i4=new i(4).toRed(this.red).redInvm();this.two=new i(2).toRed(this.red);this.a24=this.i4.redMul(this.a.redAdd(this.two))}n(MontCurve,a);e.exports=MontCurve;MontCurve.prototype.validate=function validate(e){var t=e.normalize().x;var r=t.redSqr();var i=r.redMul(t).redAdd(r.redMul(this.a)).redAdd(t);var n=i.redSqrt();return n.redSqr().cmp(i)===0};function Point(e,t,r){a.BasePoint.call(this,e,"projective");if(t===null&&r===null){this.x=this.curve.one;this.z=this.curve.zero}else{this.x=new i(t,16);this.z=new i(r,16);if(!this.x.red)this.x=this.x.toRed(this.curve.red);if(!this.z.red)this.z=this.z.toRed(this.curve.red)}}n(Point,a.BasePoint);MontCurve.prototype.decodePoint=function decodePoint(e,t){return this.point(s.toArray(e,t),1)};MontCurve.prototype.point=function point(e,t){return new Point(this,e,t)};MontCurve.prototype.pointFromJSON=function pointFromJSON(e){return Point.fromJSON(this,e)};Point.prototype.precompute=function precompute(){};Point.prototype._encode=function _encode(){return this.getX().toArray("be",this.curve.p.byteLength())};Point.fromJSON=function fromJSON(e,t){return new Point(e,t[0],t[1]||e.one)};Point.prototype.inspect=function inspect(){if(this.isInfinity())return"<EC Point Infinity>";return"<EC Point x: "+this.x.fromRed().toString(16,2)+" z: "+this.z.fromRed().toString(16,2)+">"};Point.prototype.isInfinity=function isInfinity(){return this.z.cmpn(0)===0};Point.prototype.dbl=function dbl(){var e=this.x.redAdd(this.z);var t=e.redSqr();var r=this.x.redSub(this.z);var i=r.redSqr();var n=t.redSub(i);var a=t.redMul(i);var s=n.redMul(i.redAdd(this.curve.a24.redMul(n)));return this.curve.point(a,s)};Point.prototype.add=function add(){throw new Error("Not supported on Montgomery curve")};Point.prototype.diffAdd=function diffAdd(e,t){var r=this.x.redAdd(this.z);var i=this.x.redSub(this.z);var n=e.x.redAdd(e.z);var a=e.x.redSub(e.z);var s=a.redMul(r);var o=n.redMul(i);var h=t.z.redMul(s.redAdd(o).redSqr());var u=t.x.redMul(s.redISub(o).redSqr());return this.curve.point(h,u)};Point.prototype.mul=function mul(e){var t=e.clone();var r=this;var i=this.curve.point(null,null);var n=this;for(var a=[];t.cmpn(0)!==0;t.iushrn(1))a.push(t.andln(1));for(var s=a.length-1;s>=0;s--){if(a[s]===0){r=r.diffAdd(i,n);i=i.dbl()}else{i=r.diffAdd(i,n);r=r.dbl()}}return i};Point.prototype.mulAdd=function mulAdd(){throw new Error("Not supported on Montgomery curve")};Point.prototype.jumlAdd=function jumlAdd(){throw new Error("Not supported on Montgomery curve")};Point.prototype.eq=function eq(e){return this.getX().cmp(e.getX())===0};Point.prototype.normalize=function normalize(){this.x=this.x.redMul(this.z.redInvm());this.z=this.curve.one;return this};Point.prototype.getX=function getX(){this.normalize();return this.x.fromRed()}},4720:function(e,t,r){"use strict";var i=r(4401);var n=r(711);var a=r(3782);var s=r(2727);var o=i.assert;function ShortCurve(e){s.call(this,"short",e);this.a=new n(e.a,16).toRed(this.red);this.b=new n(e.b,16).toRed(this.red);this.tinv=this.two.redInvm();this.zeroA=this.a.fromRed().cmpn(0)===0;this.threeA=this.a.fromRed().sub(this.p).cmpn(-3)===0;this.endo=this._getEndomorphism(e);this._endoWnafT1=new Array(4);this._endoWnafT2=new Array(4)}a(ShortCurve,s);e.exports=ShortCurve;ShortCurve.prototype._getEndomorphism=function _getEndomorphism(e){if(!this.zeroA||!this.g||!this.n||this.p.modn(3)!==1)return;var t;var r;if(e.beta){t=new n(e.beta,16).toRed(this.red)}else{var i=this._getEndoRoots(this.p);t=i[0].cmp(i[1])<0?i[0]:i[1];t=t.toRed(this.red)}if(e.lambda){r=new n(e.lambda,16)}else{var a=this._getEndoRoots(this.n);if(this.g.mul(a[0]).x.cmp(this.g.x.redMul(t))===0){r=a[0]}else{r=a[1];o(this.g.mul(r).x.cmp(this.g.x.redMul(t))===0)}}var s;if(e.basis){s=e.basis.map((function(e){return{a:new n(e.a,16),b:new n(e.b,16)}}))}else{s=this._getEndoBasis(r)}return{beta:t,lambda:r,basis:s}};ShortCurve.prototype._getEndoRoots=function _getEndoRoots(e){var t=e===this.p?this.red:n.mont(e);var r=new n(2).toRed(t).redInvm();var i=r.redNeg();var a=new n(3).toRed(t).redNeg().redSqrt().redMul(r);var s=i.redAdd(a).fromRed();var o=i.redSub(a).fromRed();return[s,o]};ShortCurve.prototype._getEndoBasis=function _getEndoBasis(e){var t=this.n.ushrn(Math.floor(this.n.bitLength()/2));var r=e;var i=this.n.clone();var a=new n(1);var s=new n(0);var o=new n(0);var h=new n(1);var u;var d;var c;var l;var p;var v;var b;var m=0;var y;var g;while(r.cmpn(0)!==0){var _=i.div(r);y=i.sub(_.mul(r));g=o.sub(_.mul(a));var w=h.sub(_.mul(s));if(!c&&y.cmp(t)<0){u=b.neg();d=a;c=y.neg();l=g}else if(c&&++m===2){break}b=y;i=r;r=y;o=a;a=g;h=s;s=w}p=y.neg();v=g;var M=c.sqr().add(l.sqr());var B=p.sqr().add(v.sqr());if(B.cmp(M)>=0){p=u;v=d}if(c.negative){c=c.neg();l=l.neg()}if(p.negative){p=p.neg();v=v.neg()}return[{a:c,b:l},{a:p,b:v}]};ShortCurve.prototype._endoSplit=function _endoSplit(e){var t=this.endo.basis;var r=t[0];var i=t[1];var n=i.b.mul(e).divRound(this.n);var a=r.b.neg().mul(e).divRound(this.n);var s=n.mul(r.a);var o=a.mul(i.a);var h=n.mul(r.b);var u=a.mul(i.b);var d=e.sub(s).sub(o);var c=h.add(u).neg();return{k1:d,k2:c}};ShortCurve.prototype.pointFromX=function pointFromX(e,t){e=new n(e,16);if(!e.red)e=e.toRed(this.red);var r=e.redSqr().redMul(e).redIAdd(e.redMul(this.a)).redIAdd(this.b);var i=r.redSqrt();if(i.redSqr().redSub(r).cmp(this.zero)!==0)throw new Error("invalid point");var a=i.fromRed().isOdd();if(t&&!a||!t&&a)i=i.redNeg();return this.point(e,i)};ShortCurve.prototype.validate=function validate(e){if(e.inf)return true;var t=e.x;var r=e.y;var i=this.a.redMul(t);var n=t.redSqr().redMul(t).redIAdd(i).redIAdd(this.b);return r.redSqr().redISub(n).cmpn(0)===0};ShortCurve.prototype._endoWnafMulAdd=function _endoWnafMulAdd(e,t,r){var i=this._endoWnafT1;var n=this._endoWnafT2;for(var a=0;a<e.length;a++){var s=this._endoSplit(t[a]);var o=e[a];var h=o._getBeta();if(s.k1.negative){s.k1.ineg();o=o.neg(true)}if(s.k2.negative){s.k2.ineg();h=h.neg(true)}i[a*2]=o;i[a*2+1]=h;n[a*2]=s.k1;n[a*2+1]=s.k2}var u=this._wnafMulAdd(1,i,n,a*2,r);for(var d=0;d<a*2;d++){i[d]=null;n[d]=null}return u};function Point(e,t,r,i){s.BasePoint.call(this,e,"affine");if(t===null&&r===null){this.x=null;this.y=null;this.inf=true}else{this.x=new n(t,16);this.y=new n(r,16);if(i){this.x.forceRed(this.curve.red);this.y.forceRed(this.curve.red)}if(!this.x.red)this.x=this.x.toRed(this.curve.red);if(!this.y.red)this.y=this.y.toRed(this.curve.red);this.inf=false}}a(Point,s.BasePoint);ShortCurve.prototype.point=function point(e,t,r){return new Point(this,e,t,r)};ShortCurve.prototype.pointFromJSON=function pointFromJSON(e,t){return Point.fromJSON(this,e,t)};Point.prototype._getBeta=function _getBeta(){if(!this.curve.endo)return;var e=this.precomputed;if(e&&e.beta)return e.beta;var t=this.curve.point(this.x.redMul(this.curve.endo.beta),this.y);if(e){var r=this.curve;var endoMul=function(e){return r.point(e.x.redMul(r.endo.beta),e.y)};e.beta=t;t.precomputed={beta:null,naf:e.naf&&{wnd:e.naf.wnd,points:e.naf.points.map(endoMul)},doubles:e.doubles&&{step:e.doubles.step,points:e.doubles.points.map(endoMul)}}}return t};Point.prototype.toJSON=function toJSON(){if(!this.precomputed)return[this.x,this.y];return[this.x,this.y,this.precomputed&&{doubles:this.precomputed.doubles&&{step:this.precomputed.doubles.step,points:this.precomputed.doubles.points.slice(1)},naf:this.precomputed.naf&&{wnd:this.precomputed.naf.wnd,points:this.precomputed.naf.points.slice(1)}}]};Point.fromJSON=function fromJSON(e,t,r){if(typeof t==="string")t=JSON.parse(t);var i=e.point(t[0],t[1],r);if(!t[2])return i;function obj2point(t){return e.point(t[0],t[1],r)}var n=t[2];i.precomputed={beta:null,doubles:n.doubles&&{step:n.doubles.step,points:[i].concat(n.doubles.points.map(obj2point))},naf:n.naf&&{wnd:n.naf.wnd,points:[i].concat(n.naf.points.map(obj2point))}};return i};Point.prototype.inspect=function inspect(){if(this.isInfinity())return"<EC Point Infinity>";return"<EC Point x: "+this.x.fromRed().toString(16,2)+" y: "+this.y.fromRed().toString(16,2)+">"};Point.prototype.isInfinity=function isInfinity(){return this.inf};Point.prototype.add=function add(e){if(this.inf)return e;if(e.inf)return this;if(this.eq(e))return this.dbl();if(this.neg().eq(e))return this.curve.point(null,null);if(this.x.cmp(e.x)===0)return this.curve.point(null,null);var t=this.y.redSub(e.y);if(t.cmpn(0)!==0)t=t.redMul(this.x.redSub(e.x).redInvm());var r=t.redSqr().redISub(this.x).redISub(e.x);var i=t.redMul(this.x.redSub(r)).redISub(this.y);return this.curve.point(r,i)};Point.prototype.dbl=function dbl(){if(this.inf)return this;var e=this.y.redAdd(this.y);if(e.cmpn(0)===0)return this.curve.point(null,null);var t=this.curve.a;var r=this.x.redSqr();var i=e.redInvm();var n=r.redAdd(r).redIAdd(r).redIAdd(t).redMul(i);var a=n.redSqr().redISub(this.x.redAdd(this.x));var s=n.redMul(this.x.redSub(a)).redISub(this.y);return this.curve.point(a,s)};Point.prototype.getX=function getX(){return this.x.fromRed()};Point.prototype.getY=function getY(){return this.y.fromRed()};Point.prototype.mul=function mul(e){e=new n(e,16);if(this.isInfinity())return this;else if(this._hasDoubles(e))return this.curve._fixedNafMul(this,e);else if(this.curve.endo)return this.curve._endoWnafMulAdd([this],[e]);else return this.curve._wnafMul(this,e)};Point.prototype.mulAdd=function mulAdd(e,t,r){var i=[this,t];var n=[e,r];if(this.curve.endo)return this.curve._endoWnafMulAdd(i,n);else return this.curve._wnafMulAdd(1,i,n,2)};Point.prototype.jmulAdd=function jmulAdd(e,t,r){var i=[this,t];var n=[e,r];if(this.curve.endo)return this.curve._endoWnafMulAdd(i,n,true);else return this.curve._wnafMulAdd(1,i,n,2,true)};Point.prototype.eq=function eq(e){return this===e||this.inf===e.inf&&(this.inf||this.x.cmp(e.x)===0&&this.y.cmp(e.y)===0)};Point.prototype.neg=function neg(e){if(this.inf)return this;var t=this.curve.point(this.x,this.y.redNeg());if(e&&this.precomputed){var r=this.precomputed;var negate=function(e){return e.neg()};t.precomputed={naf:r.naf&&{wnd:r.naf.wnd,points:r.naf.points.map(negate)},doubles:r.doubles&&{step:r.doubles.step,points:r.doubles.points.map(negate)}}}return t};Point.prototype.toJ=function toJ(){if(this.inf)return this.curve.jpoint(null,null,null);var e=this.curve.jpoint(this.x,this.y,this.curve.one);return e};function JPoint(e,t,r,i){s.BasePoint.call(this,e,"jacobian");if(t===null&&r===null&&i===null){this.x=this.curve.one;this.y=this.curve.one;this.z=new n(0)}else{this.x=new n(t,16);this.y=new n(r,16);this.z=new n(i,16)}if(!this.x.red)this.x=this.x.toRed(this.curve.red);if(!this.y.red)this.y=this.y.toRed(this.curve.red);if(!this.z.red)this.z=this.z.toRed(this.curve.red);this.zOne=this.z===this.curve.one}a(JPoint,s.BasePoint);ShortCurve.prototype.jpoint=function jpoint(e,t,r){return new JPoint(this,e,t,r)};JPoint.prototype.toP=function toP(){if(this.isInfinity())return this.curve.point(null,null);var e=this.z.redInvm();var t=e.redSqr();var r=this.x.redMul(t);var i=this.y.redMul(t).redMul(e);return this.curve.point(r,i)};JPoint.prototype.neg=function neg(){return this.curve.jpoint(this.x,this.y.redNeg(),this.z)};JPoint.prototype.add=function add(e){if(this.isInfinity())return e;if(e.isInfinity())return this;var t=e.z.redSqr();var r=this.z.redSqr();var i=this.x.redMul(t);var n=e.x.redMul(r);var a=this.y.redMul(t.redMul(e.z));var s=e.y.redMul(r.redMul(this.z));var o=i.redSub(n);var h=a.redSub(s);if(o.cmpn(0)===0){if(h.cmpn(0)!==0)return this.curve.jpoint(null,null,null);else return this.dbl()}var u=o.redSqr();var d=u.redMul(o);var c=i.redMul(u);var l=h.redSqr().redIAdd(d).redISub(c).redISub(c);var p=h.redMul(c.redISub(l)).redISub(a.redMul(d));var v=this.z.redMul(e.z).redMul(o);return this.curve.jpoint(l,p,v)};JPoint.prototype.mixedAdd=function mixedAdd(e){if(this.isInfinity())return e.toJ();if(e.isInfinity())return this;var t=this.z.redSqr();var r=this.x;var i=e.x.redMul(t);var n=this.y;var a=e.y.redMul(t).redMul(this.z);var s=r.redSub(i);var o=n.redSub(a);if(s.cmpn(0)===0){if(o.cmpn(0)!==0)return this.curve.jpoint(null,null,null);else return this.dbl()}var h=s.redSqr();var u=h.redMul(s);var d=r.redMul(h);var c=o.redSqr().redIAdd(u).redISub(d).redISub(d);var l=o.redMul(d.redISub(c)).redISub(n.redMul(u));var p=this.z.redMul(s);return this.curve.jpoint(c,l,p)};JPoint.prototype.dblp=function dblp(e){if(e===0)return this;if(this.isInfinity())return this;if(!e)return this.dbl();if(this.curve.zeroA||this.curve.threeA){var t=this;for(var r=0;r<e;r++)t=t.dbl();return t}var i=this.curve.a;var n=this.curve.tinv;var a=this.x;var s=this.y;var o=this.z;var h=o.redSqr().redSqr();var u=s.redAdd(s);for(var r=0;r<e;r++){var d=a.redSqr();var c=u.redSqr();var l=c.redSqr();var p=d.redAdd(d).redIAdd(d).redIAdd(i.redMul(h));var v=a.redMul(c);var b=p.redSqr().redISub(v.redAdd(v));var m=v.redISub(b);var y=p.redMul(m);y=y.redIAdd(y).redISub(l);var g=u.redMul(o);if(r+1<e)h=h.redMul(l);a=b;o=g;u=y}return this.curve.jpoint(a,u.redMul(n),o)};JPoint.prototype.dbl=function dbl(){if(this.isInfinity())return this;if(this.curve.zeroA)return this._zeroDbl();else if(this.curve.threeA)return this._threeDbl();else return this._dbl()};JPoint.prototype._zeroDbl=function _zeroDbl(){var e;var t;var r;if(this.zOne){var i=this.x.redSqr();var n=this.y.redSqr();var a=n.redSqr();var s=this.x.redAdd(n).redSqr().redISub(i).redISub(a);s=s.redIAdd(s);var o=i.redAdd(i).redIAdd(i);var h=o.redSqr().redISub(s).redISub(s);var u=a.redIAdd(a);u=u.redIAdd(u);u=u.redIAdd(u);e=h;t=o.redMul(s.redISub(h)).redISub(u);r=this.y.redAdd(this.y)}else{var d=this.x.redSqr();var c=this.y.redSqr();var l=c.redSqr();var p=this.x.redAdd(c).redSqr().redISub(d).redISub(l);p=p.redIAdd(p);var v=d.redAdd(d).redIAdd(d);var b=v.redSqr();var m=l.redIAdd(l);m=m.redIAdd(m);m=m.redIAdd(m);e=b.redISub(p).redISub(p);t=v.redMul(p.redISub(e)).redISub(m);r=this.y.redMul(this.z);r=r.redIAdd(r)}return this.curve.jpoint(e,t,r)};JPoint.prototype._threeDbl=function _threeDbl(){var e;var t;var r;if(this.zOne){var i=this.x.redSqr();var n=this.y.redSqr();var a=n.redSqr();var s=this.x.redAdd(n).redSqr().redISub(i).redISub(a);s=s.redIAdd(s);var o=i.redAdd(i).redIAdd(i).redIAdd(this.curve.a);var h=o.redSqr().redISub(s).redISub(s);e=h;var u=a.redIAdd(a);u=u.redIAdd(u);u=u.redIAdd(u);t=o.redMul(s.redISub(h)).redISub(u);r=this.y.redAdd(this.y)}else{var d=this.z.redSqr();var c=this.y.redSqr();var l=this.x.redMul(c);var p=this.x.redSub(d).redMul(this.x.redAdd(d));p=p.redAdd(p).redIAdd(p);var v=l.redIAdd(l);v=v.redIAdd(v);var b=v.redAdd(v);e=p.redSqr().redISub(b);r=this.y.redAdd(this.z).redSqr().redISub(c).redISub(d);var m=c.redSqr();m=m.redIAdd(m);m=m.redIAdd(m);m=m.redIAdd(m);t=p.redMul(v.redISub(e)).redISub(m)}return this.curve.jpoint(e,t,r)};JPoint.prototype._dbl=function _dbl(){var e=this.curve.a;var t=this.x;var r=this.y;var i=this.z;var n=i.redSqr().redSqr();var a=t.redSqr();var s=r.redSqr();var o=a.redAdd(a).redIAdd(a).redIAdd(e.redMul(n));var h=t.redAdd(t);h=h.redIAdd(h);var u=h.redMul(s);var d=o.redSqr().redISub(u.redAdd(u));var c=u.redISub(d);var l=s.redSqr();l=l.redIAdd(l);l=l.redIAdd(l);l=l.redIAdd(l);var p=o.redMul(c).redISub(l);var v=r.redAdd(r).redMul(i);return this.curve.jpoint(d,p,v)};JPoint.prototype.trpl=function trpl(){if(!this.curve.zeroA)return this.dbl().add(this);var e=this.x.redSqr();var t=this.y.redSqr();var r=this.z.redSqr();var i=t.redSqr();var n=e.redAdd(e).redIAdd(e);var a=n.redSqr();var s=this.x.redAdd(t).redSqr().redISub(e).redISub(i);s=s.redIAdd(s);s=s.redAdd(s).redIAdd(s);s=s.redISub(a);var o=s.redSqr();var h=i.redIAdd(i);h=h.redIAdd(h);h=h.redIAdd(h);h=h.redIAdd(h);var u=n.redIAdd(s).redSqr().redISub(a).redISub(o).redISub(h);var d=t.redMul(u);d=d.redIAdd(d);d=d.redIAdd(d);var c=this.x.redMul(o).redISub(d);c=c.redIAdd(c);c=c.redIAdd(c);var l=this.y.redMul(u.redMul(h.redISub(u)).redISub(s.redMul(o)));l=l.redIAdd(l);l=l.redIAdd(l);l=l.redIAdd(l);var p=this.z.redAdd(s).redSqr().redISub(r).redISub(o);return this.curve.jpoint(c,l,p)};JPoint.prototype.mul=function mul(e,t){e=new n(e,t);return this.curve._wnafMul(this,e)};JPoint.prototype.eq=function eq(e){if(e.type==="affine")return this.eq(e.toJ());if(this===e)return true;var t=this.z.redSqr();var r=e.z.redSqr();if(this.x.redMul(r).redISub(e.x.redMul(t)).cmpn(0)!==0)return false;var i=t.redMul(this.z);var n=r.redMul(e.z);return this.y.redMul(n).redISub(e.y.redMul(i)).cmpn(0)===0};JPoint.prototype.eqXToP=function eqXToP(e){var t=this.z.redSqr();var r=e.toRed(this.curve.red).redMul(t);if(this.x.cmp(r)===0)return true;var i=e.clone();var n=this.curve.redN.redMul(t);for(;;){i.iadd(this.curve.n);if(i.cmp(this.curve.p)>=0)return false;r.redIAdd(n);if(this.x.cmp(r)===0)return true}};JPoint.prototype.inspect=function inspect(){if(this.isInfinity())return"<EC JPoint Infinity>";return"<EC JPoint x: "+this.x.toString(16,2)+" y: "+this.y.toString(16,2)+" z: "+this.z.toString(16,2)+">"};JPoint.prototype.isInfinity=function isInfinity(){return this.z.cmpn(0)===0}},6226:function(e,t,r){"use strict";var i=t;var n=r(7028);var a=r(9359);var s=r(4401);var o=s.assert;function PresetCurve(e){if(e.type==="short")this.curve=new a.short(e);else if(e.type==="edwards")this.curve=new a.edwards(e);else this.curve=new a.mont(e);this.g=this.curve.g;this.n=this.curve.n;this.hash=e.hash;o(this.g.validate(),"Invalid curve");o(this.g.mul(this.n).isInfinity(),"Invalid curve, G*N != O")}i.PresetCurve=PresetCurve;function defineCurve(e,t){Object.defineProperty(i,e,{configurable:true,enumerable:true,get:function(){var r=new PresetCurve(t);Object.defineProperty(i,e,{configurable:true,enumerable:true,value:r});return r}})}defineCurve("p192",{type:"short",prime:"p192",p:"ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff",a:"ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc",b:"64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1",n:"ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831",hash:n.sha256,gRed:false,g:["188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012","07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811"]});defineCurve("p224",{type:"short",prime:"p224",p:"ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001",a:"ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe",b:"b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4",n:"ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d",hash:n.sha256,gRed:false,g:["b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21","bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34"]});defineCurve("p256",{type:"short",prime:null,p:"ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff",a:"ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc",b:"5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b",n:"ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551",hash:n.sha256,gRed:false,g:["6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296","4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5"]});defineCurve("p384",{type:"short",prime:null,p:"ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff "+"fffffffe ffffffff 00000000 00000000 ffffffff",a:"ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff "+"fffffffe ffffffff 00000000 00000000 fffffffc",b:"b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f "+"5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",n:"ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 "+"f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",hash:n.sha384,gRed:false,g:["aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 "+"5502f25d bf55296c 3a545e38 72760ab7","3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 "+"0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"]});defineCurve("p521",{type:"short",prime:null,p:"000001ff ffffffff ffffffff ffffffff ffffffff ffffffff "+"ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff "+"ffffffff ffffffff ffffffff ffffffff ffffffff",a:"000001ff ffffffff ffffffff ffffffff ffffffff ffffffff "+"ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff "+"ffffffff ffffffff ffffffff ffffffff fffffffc",b:"00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b "+"99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd "+"3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",n:"000001ff ffffffff ffffffff ffffffff ffffffff ffffffff "+"ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 "+"f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",hash:n.sha512,gRed:false,g:["000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 "+"053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 "+"a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66","00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 "+"579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 "+"3fad0761 353c7086 a272c240 88be9476 9fd16650"]});defineCurve("curve25519",{type:"mont",prime:"p25519",p:"7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",a:"76d06",b:"1",n:"1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",hash:n.sha256,gRed:false,g:["9"]});defineCurve("ed25519",{type:"edwards",prime:"p25519",p:"7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",a:"-1",c:"1",d:"52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3",n:"1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",hash:n.sha256,gRed:false,g:["216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a","6666666666666666666666666666666666666666666666666666666666666658"]});var h;try{h=r(9702)}catch(e){h=undefined}defineCurve("secp256k1",{type:"short",prime:"k256",p:"ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f",a:"0",b:"7",n:"ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141",h:"1",hash:n.sha256,beta:"7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee",lambda:"5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72",basis:[{a:"3086d221a7d46bcde86c90e49284eb15",b:"-e4437ed6010e88286f547fa90abfe4c3"},{a:"114ca50f7a8e2f3f657c1108d9d44cfd8",b:"3086d221a7d46bcde86c90e49284eb15"}],gRed:false,g:["79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798","483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8",h]})},4088:function(e,t,r){"use strict";var i=r(711);var n=r(4910);var a=r(4401);var s=r(6226);var o=r(3500);var h=a.assert;var u=r(4724);var d=r(7526);function EC(e){if(!(this instanceof EC))return new EC(e);if(typeof e==="string"){h(s.hasOwnProperty(e),"Unknown curve "+e);e=s[e]}if(e instanceof s.PresetCurve)e={curve:e};this.curve=e.curve.curve;this.n=this.curve.n;this.nh=this.n.ushrn(1);this.g=this.curve.g;this.g=e.curve.g;this.g.precompute(e.curve.n.bitLength()+1);this.hash=e.hash||e.curve.hash}e.exports=EC;EC.prototype.keyPair=function keyPair(e){return new u(this,e)};EC.prototype.keyFromPrivate=function keyFromPrivate(e,t){return u.fromPrivate(this,e,t)};EC.prototype.keyFromPublic=function keyFromPublic(e,t){return u.fromPublic(this,e,t)};EC.prototype.genKeyPair=function genKeyPair(e){if(!e)e={};var t=new n({hash:this.hash,pers:e.pers,persEnc:e.persEnc||"utf8",entropy:e.entropy||o(this.hash.hmacStrength),entropyEnc:e.entropy&&e.entropyEnc||"utf8",nonce:this.n.toArray()});var r=this.n.byteLength();var a=this.n.sub(new i(2));do{var s=new i(t.generate(r));if(s.cmp(a)>0)continue;s.iaddn(1);return this.keyFromPrivate(s)}while(true)};EC.prototype._truncateToN=function truncateToN(e,t){var r=e.byteLength()*8-this.n.bitLength();if(r>0)e=e.ushrn(r);if(!t&&e.cmp(this.n)>=0)return e.sub(this.n);else return e};EC.prototype.sign=function sign(e,t,r,a){if(typeof r==="object"){a=r;r=null}if(!a)a={};t=this.keyFromPrivate(t,r);e=this._truncateToN(new i(e,16));var s=this.n.byteLength();var o=t.getPrivate().toArray("be",s);var h=e.toArray("be",s);var u=new n({hash:this.hash,entropy:o,nonce:h,pers:a.pers,persEnc:a.persEnc||"utf8"});var c=this.n.sub(new i(1));for(var l=0;true;l++){var p=a.k?a.k(l):new i(u.generate(this.n.byteLength()));p=this._truncateToN(p,true);if(p.cmpn(1)<=0||p.cmp(c)>=0)continue;var v=this.g.mul(p);if(v.isInfinity())continue;var b=v.getX();var m=b.umod(this.n);if(m.cmpn(0)===0)continue;var y=p.invm(this.n).mul(m.mul(t.getPrivate()).iadd(e));y=y.umod(this.n);if(y.cmpn(0)===0)continue;var g=(v.getY().isOdd()?1:0)|(b.cmp(m)!==0?2:0);if(a.canonical&&y.cmp(this.nh)>0){y=this.n.sub(y);g^=1}return new d({r:m,s:y,recoveryParam:g})}};EC.prototype.verify=function verify(e,t,r,n){e=this._truncateToN(new i(e,16));r=this.keyFromPublic(r,n);t=new d(t,"hex");var a=t.r;var s=t.s;if(a.cmpn(1)<0||a.cmp(this.n)>=0)return false;if(s.cmpn(1)<0||s.cmp(this.n)>=0)return false;var o=s.invm(this.n);var h=o.mul(e).umod(this.n);var u=o.mul(a).umod(this.n);if(!this.curve._maxwellTrick){var c=this.g.mulAdd(h,r.getPublic(),u);if(c.isInfinity())return false;return c.getX().umod(this.n).cmp(a)===0}var c=this.g.jmulAdd(h,r.getPublic(),u);if(c.isInfinity())return false;return c.eqXToP(a)};EC.prototype.recoverPubKey=function(e,t,r,n){h((3&r)===r,"The recovery param is more than two bits");t=new d(t,n);var a=this.n;var s=new i(e);var o=t.r;var u=t.s;var c=r&1;var l=r>>1;if(o.cmp(this.curve.p.umod(this.curve.n))>=0&&l)throw new Error("Unable to find sencond key candinate");if(l)o=this.curve.pointFromX(o.add(this.curve.n),c);else o=this.curve.pointFromX(o,c);var p=t.r.invm(a);var v=a.sub(s).mul(p).umod(a);var b=u.mul(p).umod(a);return this.g.mulAdd(v,o,b)};EC.prototype.getKeyRecoveryParam=function(e,t,r,i){t=new d(t,i);if(t.recoveryParam!==null)return t.recoveryParam;for(var n=0;n<4;n++){var a;try{a=this.recoverPubKey(e,t,n)}catch(e){continue}if(a.eq(r))return n}throw new Error("Unable to find valid recovery factor")}},4724:function(e,t,r){"use strict";var i=r(711);var n=r(4401);var a=n.assert;function KeyPair(e,t){this.ec=e;this.priv=null;this.pub=null;if(t.priv)this._importPrivate(t.priv,t.privEnc);if(t.pub)this._importPublic(t.pub,t.pubEnc)}e.exports=KeyPair;KeyPair.fromPublic=function fromPublic(e,t,r){if(t instanceof KeyPair)return t;return new KeyPair(e,{pub:t,pubEnc:r})};KeyPair.fromPrivate=function fromPrivate(e,t,r){if(t instanceof KeyPair)return t;return new KeyPair(e,{priv:t,privEnc:r})};KeyPair.prototype.validate=function validate(){var e=this.getPublic();if(e.isInfinity())return{result:false,reason:"Invalid public key"};if(!e.validate())return{result:false,reason:"Public key is not a point"};if(!e.mul(this.ec.curve.n).isInfinity())return{result:false,reason:"Public key * N != O"};return{result:true,reason:null}};KeyPair.prototype.getPublic=function getPublic(e,t){if(typeof e==="string"){t=e;e=null}if(!this.pub)this.pub=this.ec.g.mul(this.priv);if(!t)return this.pub;return this.pub.encode(t,e)};KeyPair.prototype.getPrivate=function getPrivate(e){if(e==="hex")return this.priv.toString(16,2);else return this.priv};KeyPair.prototype._importPrivate=function _importPrivate(e,t){this.priv=new i(e,t||16);this.priv=this.priv.umod(this.ec.curve.n)};KeyPair.prototype._importPublic=function _importPublic(e,t){if(e.x||e.y){if(this.ec.curve.type==="mont"){a(e.x,"Need x coordinate")}else if(this.ec.curve.type==="short"||this.ec.curve.type==="edwards"){a(e.x&&e.y,"Need both x and y coordinate")}this.pub=this.ec.curve.point(e.x,e.y);return}this.pub=this.ec.curve.decodePoint(e,t)};KeyPair.prototype.derive=function derive(e){return e.mul(this.priv).getX()};KeyPair.prototype.sign=function sign(e,t,r){return this.ec.sign(e,this,t,r)};KeyPair.prototype.verify=function verify(e,t){return this.ec.verify(e,t,this)};KeyPair.prototype.inspect=function inspect(){return"<Key priv: "+(this.priv&&this.priv.toString(16,2))+" pub: "+(this.pub&&this.pub.inspect())+" >"}},7526:function(e,t,r){"use strict";var i=r(711);var n=r(4401);var a=n.assert;function Signature(e,t){if(e instanceof Signature)return e;if(this._importDER(e,t))return;a(e.r&&e.s,"Signature without r or s");this.r=new i(e.r,16);this.s=new i(e.s,16);if(e.recoveryParam===undefined)this.recoveryParam=null;else this.recoveryParam=e.recoveryParam}e.exports=Signature;function Position(){this.place=0}function getLength(e,t){var r=e[t.place++];if(!(r&128)){return r}var i=r&15;if(i===0||i>4){return false}var n=0;for(var a=0,s=t.place;a<i;a++,s++){n<<=8;n|=e[s];n>>>=0}if(n<=127){return false}t.place=s;return n}function rmPadding(e){var t=0;var r=e.length-1;while(!e[t]&&!(e[t+1]&128)&&t<r){t++}if(t===0){return e}return e.slice(t)}Signature.prototype._importDER=function _importDER(e,t){e=n.toArray(e,t);var r=new Position;if(e[r.place++]!==48){return false}var a=getLength(e,r);if(a===false){return false}if(a+r.place!==e.length){return false}if(e[r.place++]!==2){return false}var s=getLength(e,r);if(s===false){return false}var o=e.slice(r.place,s+r.place);r.place+=s;if(e[r.place++]!==2){return false}var h=getLength(e,r);if(h===false){return false}if(e.length!==h+r.place){return false}var u=e.slice(r.place,h+r.place);if(o[0]===0){if(o[1]&128){o=o.slice(1)}else{return false}}if(u[0]===0){if(u[1]&128){u=u.slice(1)}else{return false}}this.r=new i(o);this.s=new i(u);this.recoveryParam=null;return true};function constructLength(e,t){if(t<128){e.push(t);return}var r=1+(Math.log(t)/Math.LN2>>>3);e.push(r|128);while(--r){e.push(t>>>(r<<3)&255)}e.push(t)}Signature.prototype.toDER=function toDER(e){var t=this.r.toArray();var r=this.s.toArray();if(t[0]&128)t=[0].concat(t);if(r[0]&128)r=[0].concat(r);t=rmPadding(t);r=rmPadding(r);while(!r[0]&&!(r[1]&128)){r=r.slice(1)}var i=[2];constructLength(i,t.length);i=i.concat(t);i.push(2);constructLength(i,r.length);var a=i.concat(r);var s=[48];constructLength(s,a.length);s=s.concat(a);return n.encode(s,e)}},8511:function(e,t,r){"use strict";var i=r(7028);var n=r(6226);var a=r(4401);var s=a.assert;var o=a.parseBytes;var h=r(9917);var u=r(9314);function EDDSA(e){s(e==="ed25519","only tested with ed25519 so far");if(!(this instanceof EDDSA))return new EDDSA(e);var e=n[e].curve;this.curve=e;this.g=e.g;this.g.precompute(e.n.bitLength()+1);this.pointClass=e.point().constructor;this.encodingLength=Math.ceil(e.n.bitLength()/8);this.hash=i.sha512}e.exports=EDDSA;EDDSA.prototype.sign=function sign(e,t){e=o(e);var r=this.keyFromSecret(t);var i=this.hashInt(r.messagePrefix(),e);var n=this.g.mul(i);var a=this.encodePoint(n);var s=this.hashInt(a,r.pubBytes(),e).mul(r.priv());var h=i.add(s).umod(this.curve.n);return this.makeSignature({R:n,S:h,Rencoded:a})};EDDSA.prototype.verify=function verify(e,t,r){e=o(e);t=this.makeSignature(t);var i=this.keyFromPublic(r);var n=this.hashInt(t.Rencoded(),i.pubBytes(),e);var a=this.g.mul(t.S());var s=t.R().add(i.pub().mul(n));return s.eq(a)};EDDSA.prototype.hashInt=function hashInt(){var e=this.hash();for(var t=0;t<arguments.length;t++)e.update(arguments[t]);return a.intFromLE(e.digest()).umod(this.curve.n)};EDDSA.prototype.keyFromPublic=function keyFromPublic(e){return h.fromPublic(this,e)};EDDSA.prototype.keyFromSecret=function keyFromSecret(e){return h.fromSecret(this,e)};EDDSA.prototype.makeSignature=function makeSignature(e){if(e instanceof u)return e;return new u(this,e)};EDDSA.prototype.encodePoint=function encodePoint(e){var t=e.getY().toArray("le",this.encodingLength);t[this.encodingLength-1]|=e.getX().isOdd()?128:0;return t};EDDSA.prototype.decodePoint=function decodePoint(e){e=a.parseBytes(e);var t=e.length-1;var r=e.slice(0,t).concat(e[t]&~128);var i=(e[t]&128)!==0;var n=a.intFromLE(r);return this.curve.pointFromY(n,i)};EDDSA.prototype.encodeInt=function encodeInt(e){return e.toArray("le",this.encodingLength)};EDDSA.prototype.decodeInt=function decodeInt(e){return a.intFromLE(e)};EDDSA.prototype.isPoint=function isPoint(e){return e instanceof this.pointClass}},9917:function(e,t,r){"use strict";var i=r(4401);var n=i.assert;var a=i.parseBytes;var s=i.cachedProperty;function KeyPair(e,t){this.eddsa=e;this._secret=a(t.secret);if(e.isPoint(t.pub))this._pub=t.pub;else this._pubBytes=a(t.pub)}KeyPair.fromPublic=function fromPublic(e,t){if(t instanceof KeyPair)return t;return new KeyPair(e,{pub:t})};KeyPair.fromSecret=function fromSecret(e,t){if(t instanceof KeyPair)return t;return new KeyPair(e,{secret:t})};KeyPair.prototype.secret=function secret(){return this._secret};s(KeyPair,"pubBytes",(function pubBytes(){return this.eddsa.encodePoint(this.pub())}));s(KeyPair,"pub",(function pub(){if(this._pubBytes)return this.eddsa.decodePoint(this._pubBytes);return this.eddsa.g.mul(this.priv())}));s(KeyPair,"privBytes",(function privBytes(){var e=this.eddsa;var t=this.hash();var r=e.encodingLength-1;var i=t.slice(0,e.encodingLength);i[0]&=248;i[r]&=127;i[r]|=64;return i}));s(KeyPair,"priv",(function priv(){return this.eddsa.decodeInt(this.privBytes())}));s(KeyPair,"hash",(function hash(){return this.eddsa.hash().update(this.secret()).digest()}));s(KeyPair,"messagePrefix",(function messagePrefix(){return this.hash().slice(this.eddsa.encodingLength)}));KeyPair.prototype.sign=function sign(e){n(this._secret,"KeyPair can only verify");return this.eddsa.sign(e,this)};KeyPair.prototype.verify=function verify(e,t){return this.eddsa.verify(e,t,this)};KeyPair.prototype.getSecret=function getSecret(e){n(this._secret,"KeyPair is public only");return i.encode(this.secret(),e)};KeyPair.prototype.getPublic=function getPublic(e){return i.encode(this.pubBytes(),e)};e.exports=KeyPair},9314:function(e,t,r){"use strict";var i=r(711);var n=r(4401);var a=n.assert;var s=n.cachedProperty;var o=n.parseBytes;function Signature(e,t){this.eddsa=e;if(typeof t!=="object")t=o(t);if(Array.isArray(t)){t={R:t.slice(0,e.encodingLength),S:t.slice(e.encodingLength)}}a(t.R&&t.S,"Signature without R or S");if(e.isPoint(t.R))this._R=t.R;if(t.S instanceof i)this._S=t.S;this._Rencoded=Array.isArray(t.R)?t.R:t.Rencoded;this._Sencoded=Array.isArray(t.S)?t.S:t.Sencoded}s(Signature,"S",(function S(){return this.eddsa.decodeInt(this.Sencoded())}));s(Signature,"R",(function R(){return this.eddsa.decodePoint(this.Rencoded())}));s(Signature,"Rencoded",(function Rencoded(){return this.eddsa.encodePoint(this.R())}));s(Signature,"Sencoded",(function Sencoded(){return this.eddsa.encodeInt(this.S())}));Signature.prototype.toBytes=function toBytes(){return this.Rencoded().concat(this.Sencoded())};Signature.prototype.toHex=function toHex(){return n.encode(this.toBytes(),"hex").toUpperCase()};e.exports=Signature},9702:function(e){e.exports={doubles:{step:4,points:[["e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a","f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821"],["8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508","11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf"],["175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739","d3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695"],["363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640","4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9"],["8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c","4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36"],["723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda","96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f"],["eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa","5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999"],["100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0","cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09"],["e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d","9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d"],["feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d","e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088"],["da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1","9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d"],["53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0","5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8"],["8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047","10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a"],["385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862","283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453"],["6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7","7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160"],["3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd","56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0"],["85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83","7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6"],["948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a","53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589"],["6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8","bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17"],["e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d","4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda"],["e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725","7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd"],["213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754","4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2"],["4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c","17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6"],["fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6","6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f"],["76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39","c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01"],["c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891","893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3"],["d895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b","febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f"],["b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03","2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7"],["e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d","eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78"],["a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070","7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1"],["90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4","e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150"],["8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da","662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82"],["e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11","1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc"],["8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e","efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b"],["e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41","2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51"],["b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef","67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45"],["d68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8","db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120"],["324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d","648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84"],["4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96","35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d"],["9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd","ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d"],["6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5","9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8"],["a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266","40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8"],["7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71","34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac"],["928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac","c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f"],["85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751","1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962"],["ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e","493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907"],["827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241","c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec"],["eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3","be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d"],["e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f","4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414"],["1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19","aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd"],["146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be","b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0"],["fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9","6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811"],["da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2","8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1"],["a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13","7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c"],["174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c","ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73"],["959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba","2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd"],["d2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151","e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405"],["64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073","d99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589"],["8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458","38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e"],["13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b","69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27"],["bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366","d3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1"],["8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa","40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482"],["8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0","620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945"],["dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787","7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573"],["f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e","ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82"]]},naf:{wnd:7,points:[["f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9","388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672"],["2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4","d8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6"],["5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc","6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da"],["acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe","cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37"],["774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb","d984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b"],["f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8","ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81"],["d7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e","581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58"],["defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34","4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77"],["2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c","85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a"],["352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5","321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c"],["2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f","2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67"],["9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714","73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402"],["daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729","a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55"],["c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db","2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482"],["6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4","e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82"],["1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5","b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396"],["605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479","2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49"],["62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d","80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf"],["80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f","1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a"],["7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb","d0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7"],["d528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9","eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933"],["49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963","758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a"],["77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74","958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6"],["f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530","e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37"],["463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b","5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e"],["f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247","cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6"],["caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1","cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476"],["2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120","4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40"],["7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435","91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61"],["754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18","673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683"],["e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8","59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5"],["186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb","3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b"],["df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f","55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417"],["5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143","efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868"],["290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba","e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a"],["af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45","f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6"],["766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a","744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996"],["59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e","c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e"],["f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8","e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d"],["7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c","30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2"],["948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519","e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e"],["7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab","100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437"],["3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca","ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311"],["d3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf","8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4"],["1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610","68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575"],["733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4","f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d"],["15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c","d56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d"],["a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940","edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629"],["e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980","a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06"],["311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3","66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374"],["34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf","9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee"],["f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63","4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1"],["d7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448","fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b"],["32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf","5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661"],["7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5","8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6"],["ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6","8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e"],["16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5","5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d"],["eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99","f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc"],["78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51","f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4"],["494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5","42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c"],["a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5","204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b"],["c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997","4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913"],["841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881","73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154"],["5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5","39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865"],["36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66","d2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc"],["336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726","ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224"],["8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede","6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e"],["1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94","60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6"],["85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31","3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511"],["29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51","b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b"],["a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252","ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2"],["4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5","cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c"],["d24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b","6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3"],["ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4","322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d"],["af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f","6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700"],["e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889","2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4"],["591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246","b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196"],["11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984","998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4"],["3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a","b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257"],["cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030","bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13"],["c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197","6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096"],["c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593","c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38"],["a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef","21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f"],["347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38","60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448"],["da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a","49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a"],["c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111","5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4"],["4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502","7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437"],["3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea","be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7"],["cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26","8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d"],["b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986","39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a"],["d4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e","62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54"],["48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4","25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77"],["dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda","ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517"],["6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859","cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10"],["e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f","f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125"],["eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c","6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e"],["13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942","fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1"],["ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a","1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2"],["b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80","5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423"],["ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d","438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8"],["8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1","cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758"],["52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63","c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375"],["e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352","6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d"],["7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193","ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec"],["5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00","9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0"],["32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58","ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c"],["e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7","d3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4"],["8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8","c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f"],["4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e","67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649"],["3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d","cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826"],["674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b","299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5"],["d32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f","f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87"],["30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6","462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b"],["be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297","62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc"],["93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a","7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c"],["b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c","ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f"],["d5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52","4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a"],["d3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb","bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46"],["463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065","bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f"],["7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917","603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03"],["74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9","cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08"],["30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3","553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8"],["9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57","712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373"],["176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66","ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3"],["75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8","9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8"],["809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721","9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1"],["1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180","4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9"]]}}},4401:function(e,t,r){"use strict";var i=t;var n=r(711);var a=r(3523);var s=r(6545);i.assert=a;i.toArray=s.toArray;i.zero2=s.zero2;i.toHex=s.toHex;i.encode=s.encode;function getNAF(e,t,r){var i=new Array(Math.max(e.bitLength(),r)+1);i.fill(0);var n=1<<t+1;var a=e.clone();for(var s=0;s<i.length;s++){var o;var h=a.andln(n-1);if(a.isOdd()){if(h>(n>>1)-1)o=(n>>1)-h;else o=h;a.isubn(o)}else{o=0}i[s]=o;a.iushrn(1)}return i}i.getNAF=getNAF;function getJSF(e,t){var r=[[],[]];e=e.clone();t=t.clone();var i=0;var n=0;while(e.cmpn(-i)>0||t.cmpn(-n)>0){var a=e.andln(3)+i&3;var s=t.andln(3)+n&3;if(a===3)a=-1;if(s===3)s=-1;var o;if((a&1)===0){o=0}else{var h=e.andln(7)+i&7;if((h===3||h===5)&&s===2)o=-a;else o=a}r[0].push(o);var u;if((s&1)===0){u=0}else{var h=t.andln(7)+n&7;if((h===3||h===5)&&a===2)u=-s;else u=s}r[1].push(u);if(2*i===o+1)i=1-i;if(2*n===u+1)n=1-n;e.iushrn(1);t.iushrn(1)}return r}i.getJSF=getJSF;function cachedProperty(e,t,r){var i="_"+t;e.prototype[t]=function cachedProperty(){return this[i]!==undefined?this[i]:this[i]=r.call(this)}}i.cachedProperty=cachedProperty;function parseBytes(e){return typeof e==="string"?i.toArray(e,"hex"):e}i.parseBytes=parseBytes;function intFromLE(e){return new n(e,"hex","le")}i.intFromLE=intFromLE},8368:function(e,t,r){var i=r(5055).Buffer;var n=r(3533);function EVP_BytesToKey(e,t,r,a){if(!i.isBuffer(e))e=i.from(e,"binary");if(t){if(!i.isBuffer(t))t=i.from(t,"binary");if(t.length!==8)throw new RangeError("salt should be Buffer with 8 byte length")}var s=r/8;var o=i.alloc(s);var h=i.alloc(a||0);var u=i.alloc(0);while(s>0||a>0){var d=new n;d.update(u);d.update(e);if(t)d.update(t);u=d.digest();var c=0;if(s>0){var l=o.length-s;c=Math.min(s,u.length);u.copy(o,l,0,c);s-=c}if(c<u.length&&a>0){var p=h.length-a;var v=Math.min(a,u.length-c);u.copy(h,p,c,c+v);a-=v}}u.fill(0);return{key:o,iv:h}}e.exports=EVP_BytesToKey},9029:function(e,t,r){"use strict";var i=r(5055).Buffer;var n=r(3726).Transform;var a=r(3782);function throwIfNotStringOrBuffer(e,t){if(!i.isBuffer(e)&&typeof e!=="string"){throw new TypeError(t+" must be a string or a buffer")}}function HashBase(e){n.call(this);this._block=i.allocUnsafe(e);this._blockSize=e;this._blockOffset=0;this._length=[0,0,0,0];this._finalized=false}a(HashBase,n);HashBase.prototype._transform=function(e,t,r){var i=null;try{this.update(e,t)}catch(e){i=e}r(i)};HashBase.prototype._flush=function(e){var t=null;try{this.push(this.digest())}catch(e){t=e}e(t)};HashBase.prototype.update=function(e,t){throwIfNotStringOrBuffer(e,"Data");if(this._finalized)throw new Error("Digest already called");if(!i.isBuffer(e))e=i.from(e,t);var r=this._block;var n=0;while(this._blockOffset+e.length-n>=this._blockSize){for(var a=this._blockOffset;a<this._blockSize;)r[a++]=e[n++];this._update();this._blockOffset=0}while(n<e.length)r[this._blockOffset++]=e[n++];for(var s=0,o=e.length*8;o>0;++s){this._length[s]+=o;o=this._length[s]/4294967296|0;if(o>0)this._length[s]-=4294967296*o}return this};HashBase.prototype._update=function(){throw new Error("_update is not implemented")};HashBase.prototype.digest=function(e){if(this._finalized)throw new Error("Digest already called");this._finalized=true;var t=this._digest();if(e!==undefined)t=t.toString(e);this._block.fill(0);this._blockOffset=0;for(var r=0;r<4;++r)this._length[r]=0;return t};HashBase.prototype._digest=function(){throw new Error("_digest is not implemented")};e.exports=HashBase},7028:function(e,t,r){var i=t;i.utils=r(263);i.common=r(1330);i.sha=r(301);i.ripemd=r(3079);i.hmac=r(3092);i.sha1=i.sha.sha1;i.sha256=i.sha.sha256;i.sha224=i.sha.sha224;i.sha384=i.sha.sha384;i.sha512=i.sha.sha512;i.ripemd160=i.ripemd.ripemd160},1330:function(e,t,r){"use strict";var i=r(263);var n=r(3523);function BlockHash(){this.pending=null;this.pendingTotal=0;this.blockSize=this.constructor.blockSize;this.outSize=this.constructor.outSize;this.hmacStrength=this.constructor.hmacStrength;this.padLength=this.constructor.padLength/8;this.endian="big";this._delta8=this.blockSize/8;this._delta32=this.blockSize/32}t.BlockHash=BlockHash;BlockHash.prototype.update=function update(e,t){e=i.toArray(e,t);if(!this.pending)this.pending=e;else this.pending=this.pending.concat(e);this.pendingTotal+=e.length;if(this.pending.length>=this._delta8){e=this.pending;var r=e.length%this._delta8;this.pending=e.slice(e.length-r,e.length);if(this.pending.length===0)this.pending=null;e=i.join32(e,0,e.length-r,this.endian);for(var n=0;n<e.length;n+=this._delta32)this._update(e,n,n+this._delta32)}return this};BlockHash.prototype.digest=function digest(e){this.update(this._pad());n(this.pending===null);return this._digest(e)};BlockHash.prototype._pad=function pad(){var e=this.pendingTotal;var t=this._delta8;var r=t-(e+this.padLength)%t;var i=new Array(r+this.padLength);i[0]=128;for(var n=1;n<r;n++)i[n]=0;e<<=3;if(this.endian==="big"){for(var a=8;a<this.padLength;a++)i[n++]=0;i[n++]=0;i[n++]=0;i[n++]=0;i[n++]=0;i[n++]=e>>>24&255;i[n++]=e>>>16&255;i[n++]=e>>>8&255;i[n++]=e&255}else{i[n++]=e&255;i[n++]=e>>>8&255;i[n++]=e>>>16&255;i[n++]=e>>>24&255;i[n++]=0;i[n++]=0;i[n++]=0;i[n++]=0;for(a=8;a<this.padLength;a++)i[n++]=0}return i}},3092:function(e,t,r){"use strict";var i=r(263);var n=r(3523);function Hmac(e,t,r){if(!(this instanceof Hmac))return new Hmac(e,t,r);this.Hash=e;this.blockSize=e.blockSize/8;this.outSize=e.outSize/8;this.inner=null;this.outer=null;this._init(i.toArray(t,r))}e.exports=Hmac;Hmac.prototype._init=function init(e){if(e.length>this.blockSize)e=(new this.Hash).update(e).digest();n(e.length<=this.blockSize);for(var t=e.length;t<this.blockSize;t++)e.push(0);for(t=0;t<e.length;t++)e[t]^=54;this.inner=(new this.Hash).update(e);for(t=0;t<e.length;t++)e[t]^=106;this.outer=(new this.Hash).update(e)};Hmac.prototype.update=function update(e,t){this.inner.update(e,t);return this};Hmac.prototype.digest=function digest(e){this.outer.update(this.inner.digest());return this.outer.digest(e)}},3079:function(e,t,r){"use strict";var i=r(263);var n=r(1330);var a=i.rotl32;var s=i.sum32;var o=i.sum32_3;var h=i.sum32_4;var u=n.BlockHash;function RIPEMD160(){if(!(this instanceof RIPEMD160))return new RIPEMD160;u.call(this);this.h=[1732584193,4023233417,2562383102,271733878,3285377520];this.endian="little"}i.inherits(RIPEMD160,u);t.ripemd160=RIPEMD160;RIPEMD160.blockSize=512;RIPEMD160.outSize=160;RIPEMD160.hmacStrength=192;RIPEMD160.padLength=64;RIPEMD160.prototype._update=function update(e,t){var r=this.h[0];var i=this.h[1];var n=this.h[2];var u=this.h[3];var v=this.h[4];var b=r;var m=i;var y=n;var g=u;var _=v;for(var w=0;w<80;w++){var M=s(a(h(r,f(w,i,n,u),e[d[w]+t],K(w)),l[w]),v);r=v;v=u;u=a(n,10);n=i;i=M;M=s(a(h(b,f(79-w,m,y,g),e[c[w]+t],Kh(w)),p[w]),_);b=_;_=g;g=a(y,10);y=m;m=M}M=o(this.h[1],n,g);this.h[1]=o(this.h[2],u,_);this.h[2]=o(this.h[3],v,b);this.h[3]=o(this.h[4],r,m);this.h[4]=o(this.h[0],i,y);this.h[0]=M};RIPEMD160.prototype._digest=function digest(e){if(e==="hex")return i.toHex32(this.h,"little");else return i.split32(this.h,"little")};function f(e,t,r,i){if(e<=15)return t^r^i;else if(e<=31)return t&r|~t&i;else if(e<=47)return(t|~r)^i;else if(e<=63)return t&i|r&~i;else return t^(r|~i)}function K(e){if(e<=15)return 0;else if(e<=31)return 1518500249;else if(e<=47)return 1859775393;else if(e<=63)return 2400959708;else return 2840853838}function Kh(e){if(e<=15)return 1352829926;else if(e<=31)return 1548603684;else if(e<=47)return 1836072691;else if(e<=63)return 2053994217;else return 0}var d=[0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,7,4,13,1,10,6,15,3,12,0,9,5,2,14,11,8,3,10,14,4,9,15,8,1,2,7,0,6,13,11,5,12,1,9,11,10,0,8,12,4,13,3,7,15,14,5,6,2,4,0,5,9,7,12,2,10,14,1,3,8,11,6,15,13];var c=[5,14,7,0,9,2,11,4,13,6,15,8,1,10,3,12,6,11,3,7,0,13,5,10,14,15,8,12,4,9,1,2,15,5,1,3,7,14,6,9,11,8,12,2,10,0,4,13,8,6,4,1,3,11,15,0,5,12,2,13,9,7,10,14,12,15,10,4,1,5,8,7,6,2,13,14,0,3,9,11];var l=[11,14,15,12,5,8,7,9,11,13,14,15,6,7,9,8,7,6,8,13,11,9,7,15,7,12,15,9,11,7,13,12,11,13,6,7,14,9,13,15,14,8,13,6,5,12,7,5,11,12,14,15,14,15,9,8,9,14,5,6,8,6,5,12,9,15,5,11,6,8,13,12,5,12,13,14,11,8,5,6];var p=[8,9,9,11,13,15,15,5,7,7,8,11,14,14,12,6,9,13,15,7,12,8,9,11,7,7,12,7,6,15,13,11,9,7,15,11,8,6,6,14,12,13,5,14,13,13,7,5,15,5,8,11,14,14,6,14,6,9,12,9,12,5,15,8,8,5,12,9,12,5,14,6,8,13,6,5,15,13,11,11]},301:function(e,t,r){"use strict";t.sha1=r(2742);t.sha224=r(7105);t.sha256=r(1525);t.sha384=r(9948);t.sha512=r(1319)},2742:function(e,t,r){"use strict";var i=r(263);var n=r(1330);var a=r(2975);var s=i.rotl32;var o=i.sum32;var h=i.sum32_5;var u=a.ft_1;var d=n.BlockHash;var c=[1518500249,1859775393,2400959708,3395469782];function SHA1(){if(!(this instanceof SHA1))return new SHA1;d.call(this);this.h=[1732584193,4023233417,2562383102,271733878,3285377520];this.W=new Array(80)}i.inherits(SHA1,d);e.exports=SHA1;SHA1.blockSize=512;SHA1.outSize=160;SHA1.hmacStrength=80;SHA1.padLength=64;SHA1.prototype._update=function _update(e,t){var r=this.W;for(var i=0;i<16;i++)r[i]=e[t+i];for(;i<r.length;i++)r[i]=s(r[i-3]^r[i-8]^r[i-14]^r[i-16],1);var n=this.h[0];var a=this.h[1];var d=this.h[2];var l=this.h[3];var p=this.h[4];for(i=0;i<r.length;i++){var v=~~(i/20);var b=h(s(n,5),u(v,a,d,l),p,r[i],c[v]);p=l;l=d;d=s(a,30);a=n;n=b}this.h[0]=o(this.h[0],n);this.h[1]=o(this.h[1],a);this.h[2]=o(this.h[2],d);this.h[3]=o(this.h[3],l);this.h[4]=o(this.h[4],p)};SHA1.prototype._digest=function digest(e){if(e==="hex")return i.toHex32(this.h,"big");else return i.split32(this.h,"big")}},7105:function(e,t,r){"use strict";var i=r(263);var n=r(1525);function SHA224(){if(!(this instanceof SHA224))return new SHA224;n.call(this);this.h=[3238371032,914150663,812702999,4144912697,4290775857,1750603025,1694076839,3204075428]}i.inherits(SHA224,n);e.exports=SHA224;SHA224.blockSize=512;SHA224.outSize=224;SHA224.hmacStrength=192;SHA224.padLength=64;SHA224.prototype._digest=function digest(e){if(e==="hex")return i.toHex32(this.h.slice(0,7),"big");else return i.split32(this.h.slice(0,7),"big")}},1525:function(e,t,r){"use strict";var i=r(263);var n=r(1330);var a=r(2975);var s=r(3523);var o=i.sum32;var h=i.sum32_4;var u=i.sum32_5;var d=a.ch32;var c=a.maj32;var l=a.s0_256;var p=a.s1_256;var v=a.g0_256;var b=a.g1_256;var m=n.BlockHash;var y=[1116352408,1899447441,3049323471,3921009573,961987163,1508970993,2453635748,2870763221,3624381080,310598401,607225278,1426881987,1925078388,2162078206,2614888103,3248222580,3835390401,4022224774,264347078,604807628,770255983,1249150122,1555081692,1996064986,2554220882,2821834349,2952996808,3210313671,3336571891,3584528711,113926993,338241895,666307205,773529912,1294757372,1396182291,1695183700,1986661051,2177026350,2456956037,2730485921,2820302411,3259730800,3345764771,3516065817,3600352804,4094571909,275423344,430227734,506948616,659060556,883997877,958139571,1322822218,1537002063,1747873779,1955562222,2024104815,2227730452,2361852424,2428436474,2756734187,3204031479,3329325298];function SHA256(){if(!(this instanceof SHA256))return new SHA256;m.call(this);this.h=[1779033703,3144134277,1013904242,2773480762,1359893119,2600822924,528734635,1541459225];this.k=y;this.W=new Array(64)}i.inherits(SHA256,m);e.exports=SHA256;SHA256.blockSize=512;SHA256.outSize=256;SHA256.hmacStrength=192;SHA256.padLength=64;SHA256.prototype._update=function _update(e,t){var r=this.W;for(var i=0;i<16;i++)r[i]=e[t+i];for(;i<r.length;i++)r[i]=h(b(r[i-2]),r[i-7],v(r[i-15]),r[i-16]);var n=this.h[0];var a=this.h[1];var m=this.h[2];var y=this.h[3];var g=this.h[4];var _=this.h[5];var w=this.h[6];var M=this.h[7];s(this.k.length===r.length);for(i=0;i<r.length;i++){var B=u(M,p(g),d(g,_,w),this.k[i],r[i]);var E=o(l(n),c(n,a,m));M=w;w=_;_=g;g=o(y,B);y=m;m=a;a=n;n=o(B,E)}this.h[0]=o(this.h[0],n);this.h[1]=o(this.h[1],a);this.h[2]=o(this.h[2],m);this.h[3]=o(this.h[3],y);this.h[4]=o(this.h[4],g);this.h[5]=o(this.h[5],_);this.h[6]=o(this.h[6],w);this.h[7]=o(this.h[7],M)};SHA256.prototype._digest=function digest(e){if(e==="hex")return i.toHex32(this.h,"big");else return i.split32(this.h,"big")}},9948:function(e,t,r){"use strict";var i=r(263);var n=r(1319);function SHA384(){if(!(this instanceof SHA384))return new SHA384;n.call(this);this.h=[3418070365,3238371032,1654270250,914150663,2438529370,812702999,355462360,4144912697,1731405415,4290775857,2394180231,1750603025,3675008525,1694076839,1203062813,3204075428]}i.inherits(SHA384,n);e.exports=SHA384;SHA384.blockSize=1024;SHA384.outSize=384;SHA384.hmacStrength=192;SHA384.padLength=128;SHA384.prototype._digest=function digest(e){if(e==="hex")return i.toHex32(this.h.slice(0,12),"big");else return i.split32(this.h.slice(0,12),"big")}},1319:function(e,t,r){"use strict";var i=r(263);var n=r(1330);var a=r(3523);var s=i.rotr64_hi;var o=i.rotr64_lo;var h=i.shr64_hi;var u=i.shr64_lo;var d=i.sum64;var c=i.sum64_hi;var l=i.sum64_lo;var p=i.sum64_4_hi;var v=i.sum64_4_lo;var b=i.sum64_5_hi;var m=i.sum64_5_lo;var y=n.BlockHash;var g=[1116352408,3609767458,1899447441,602891725,3049323471,3964484399,3921009573,2173295548,961987163,4081628472,1508970993,3053834265,2453635748,2937671579,2870763221,3664609560,3624381080,2734883394,310598401,1164996542,607225278,1323610764,1426881987,3590304994,1925078388,4068182383,2162078206,991336113,2614888103,633803317,3248222580,3479774868,3835390401,2666613458,4022224774,944711139,264347078,2341262773,604807628,2007800933,770255983,1495990901,1249150122,1856431235,1555081692,3175218132,1996064986,2198950837,2554220882,3999719339,2821834349,766784016,2952996808,2566594879,3210313671,3203337956,3336571891,1034457026,3584528711,2466948901,113926993,3758326383,338241895,168717936,666307205,1188179964,773529912,1546045734,1294757372,1522805485,1396182291,2643833823,1695183700,2343527390,1986661051,1014477480,2177026350,1206759142,2456956037,344077627,2730485921,1290863460,2820302411,3158454273,3259730800,3505952657,3345764771,106217008,3516065817,3606008344,3600352804,1432725776,4094571909,1467031594,275423344,851169720,430227734,3100823752,506948616,1363258195,659060556,3750685593,883997877,3785050280,958139571,3318307427,1322822218,3812723403,1537002063,2003034995,1747873779,3602036899,1955562222,1575990012,2024104815,1125592928,2227730452,2716904306,2361852424,442776044,2428436474,593698344,2756734187,3733110249,3204031479,2999351573,3329325298,3815920427,3391569614,3928383900,3515267271,566280711,3940187606,3454069534,4118630271,4000239992,116418474,1914138554,174292421,2731055270,289380356,3203993006,460393269,320620315,685471733,587496836,852142971,1086792851,1017036298,365543100,1126000580,2618297676,1288033470,3409855158,1501505948,4234509866,1607167915,987167468,1816402316,1246189591];function SHA512(){if(!(this instanceof SHA512))return new SHA512;y.call(this);this.h=[1779033703,4089235720,3144134277,2227873595,1013904242,4271175723,2773480762,1595750129,1359893119,2917565137,2600822924,725511199,528734635,4215389547,1541459225,327033209];this.k=g;this.W=new Array(160)}i.inherits(SHA512,y);e.exports=SHA512;SHA512.blockSize=1024;SHA512.outSize=512;SHA512.hmacStrength=192;SHA512.padLength=128;SHA512.prototype._prepareBlock=function _prepareBlock(e,t){var r=this.W;for(var i=0;i<32;i++)r[i]=e[t+i];for(;i<r.length;i+=2){var n=g1_512_hi(r[i-4],r[i-3]);var a=g1_512_lo(r[i-4],r[i-3]);var s=r[i-14];var o=r[i-13];var h=g0_512_hi(r[i-30],r[i-29]);var u=g0_512_lo(r[i-30],r[i-29]);var d=r[i-32];var c=r[i-31];r[i]=p(n,a,s,o,h,u,d,c);r[i+1]=v(n,a,s,o,h,u,d,c)}};SHA512.prototype._update=function _update(e,t){this._prepareBlock(e,t);var r=this.W;var i=this.h[0];var n=this.h[1];var s=this.h[2];var o=this.h[3];var h=this.h[4];var u=this.h[5];var p=this.h[6];var v=this.h[7];var y=this.h[8];var g=this.h[9];var _=this.h[10];var w=this.h[11];var M=this.h[12];var B=this.h[13];var E=this.h[14];var k=this.h[15];a(this.k.length===r.length);for(var A=0;A<r.length;A+=2){var N=E;var P=k;var x=s1_512_hi(y,g);var I=s1_512_lo(y,g);var C=ch64_hi(y,g,_,w,M,B);var D=ch64_lo(y,g,_,w,M,B);var T=this.k[A];var j=this.k[A+1];var q=r[A];var O=r[A+1];var H=b(N,P,x,I,C,D,T,j,q,O);var L=m(N,P,x,I,C,D,T,j,q,O);N=s0_512_hi(i,n);P=s0_512_lo(i,n);x=maj64_hi(i,n,s,o,h,u);I=maj64_lo(i,n,s,o,h,u);var z=c(N,P,x,I);var F=l(N,P,x,I);E=M;k=B;M=_;B=w;_=y;w=g;y=c(p,v,H,L);g=l(v,v,H,L);p=h;v=u;h=s;u=o;s=i;o=n;i=c(H,L,z,F);n=l(H,L,z,F)}d(this.h,0,i,n);d(this.h,2,s,o);d(this.h,4,h,u);d(this.h,6,p,v);d(this.h,8,y,g);d(this.h,10,_,w);d(this.h,12,M,B);d(this.h,14,E,k)};SHA512.prototype._digest=function digest(e){if(e==="hex")return i.toHex32(this.h,"big");else return i.split32(this.h,"big")};function ch64_hi(e,t,r,i,n){var a=e&r^~e&n;if(a<0)a+=4294967296;return a}function ch64_lo(e,t,r,i,n,a){var s=t&i^~t&a;if(s<0)s+=4294967296;return s}function maj64_hi(e,t,r,i,n){var a=e&r^e&n^r&n;if(a<0)a+=4294967296;return a}function maj64_lo(e,t,r,i,n,a){var s=t&i^t&a^i&a;if(s<0)s+=4294967296;return s}function s0_512_hi(e,t){var r=s(e,t,28);var i=s(t,e,2);var n=s(t,e,7);var a=r^i^n;if(a<0)a+=4294967296;return a}function s0_512_lo(e,t){var r=o(e,t,28);var i=o(t,e,2);var n=o(t,e,7);var a=r^i^n;if(a<0)a+=4294967296;return a}function s1_512_hi(e,t){var r=s(e,t,14);var i=s(e,t,18);var n=s(t,e,9);var a=r^i^n;if(a<0)a+=4294967296;return a}function s1_512_lo(e,t){var r=o(e,t,14);var i=o(e,t,18);var n=o(t,e,9);var a=r^i^n;if(a<0)a+=4294967296;return a}function g0_512_hi(e,t){var r=s(e,t,1);var i=s(e,t,8);var n=h(e,t,7);var a=r^i^n;if(a<0)a+=4294967296;return a}function g0_512_lo(e,t){var r=o(e,t,1);var i=o(e,t,8);var n=u(e,t,7);var a=r^i^n;if(a<0)a+=4294967296;return a}function g1_512_hi(e,t){var r=s(e,t,19);var i=s(t,e,29);var n=h(e,t,6);var a=r^i^n;if(a<0)a+=4294967296;return a}function g1_512_lo(e,t){var r=o(e,t,19);var i=o(t,e,29);var n=u(e,t,6);var a=r^i^n;if(a<0)a+=4294967296;return a}},2975:function(e,t,r){"use strict";var i=r(263);var n=i.rotr32;function ft_1(e,t,r,i){if(e===0)return ch32(t,r,i);if(e===1||e===3)return p32(t,r,i);if(e===2)return maj32(t,r,i)}t.ft_1=ft_1;function ch32(e,t,r){return e&t^~e&r}t.ch32=ch32;function maj32(e,t,r){return e&t^e&r^t&r}t.maj32=maj32;function p32(e,t,r){return e^t^r}t.p32=p32;function s0_256(e){return n(e,2)^n(e,13)^n(e,22)}t.s0_256=s0_256;function s1_256(e){return n(e,6)^n(e,11)^n(e,25)}t.s1_256=s1_256;function g0_256(e){return n(e,7)^n(e,18)^e>>>3}t.g0_256=g0_256;function g1_256(e){return n(e,17)^n(e,19)^e>>>10}t.g1_256=g1_256},263:function(e,t,r){"use strict";var i=r(3523);var n=r(3782);t.inherits=n;function isSurrogatePair(e,t){if((e.charCodeAt(t)&64512)!==55296){return false}if(t<0||t+1>=e.length){return false}return(e.charCodeAt(t+1)&64512)===56320}function toArray(e,t){if(Array.isArray(e))return e.slice();if(!e)return[];var r=[];if(typeof e==="string"){if(!t){var i=0;for(var n=0;n<e.length;n++){var a=e.charCodeAt(n);if(a<128){r[i++]=a}else if(a<2048){r[i++]=a>>6|192;r[i++]=a&63|128}else if(isSurrogatePair(e,n)){a=65536+((a&1023)<<10)+(e.charCodeAt(++n)&1023);r[i++]=a>>18|240;r[i++]=a>>12&63|128;r[i++]=a>>6&63|128;r[i++]=a&63|128}else{r[i++]=a>>12|224;r[i++]=a>>6&63|128;r[i++]=a&63|128}}}else if(t==="hex"){e=e.replace(/[^a-z0-9]+/gi,"");if(e.length%2!==0)e="0"+e;for(n=0;n<e.length;n+=2)r.push(parseInt(e[n]+e[n+1],16))}}else{for(n=0;n<e.length;n++)r[n]=e[n]|0}return r}t.toArray=toArray;function toHex(e){var t="";for(var r=0;r<e.length;r++)t+=zero2(e[r].toString(16));return t}t.toHex=toHex;function htonl(e){var t=e>>>24|e>>>8&65280|e<<8&16711680|(e&255)<<24;return t>>>0}t.htonl=htonl;function toHex32(e,t){var r="";for(var i=0;i<e.length;i++){var n=e[i];if(t==="little")n=htonl(n);r+=zero8(n.toString(16))}return r}t.toHex32=toHex32;function zero2(e){if(e.length===1)return"0"+e;else return e}t.zero2=zero2;function zero8(e){if(e.length===7)return"0"+e;else if(e.length===6)return"00"+e;else if(e.length===5)return"000"+e;else if(e.length===4)return"0000"+e;else if(e.length===3)return"00000"+e;else if(e.length===2)return"000000"+e;else if(e.length===1)return"0000000"+e;else return e}t.zero8=zero8;function join32(e,t,r,n){var a=r-t;i(a%4===0);var s=new Array(a/4);for(var o=0,h=t;o<s.length;o++,h+=4){var u;if(n==="big")u=e[h]<<24|e[h+1]<<16|e[h+2]<<8|e[h+3];else u=e[h+3]<<24|e[h+2]<<16|e[h+1]<<8|e[h];s[o]=u>>>0}return s}t.join32=join32;function split32(e,t){var r=new Array(e.length*4);for(var i=0,n=0;i<e.length;i++,n+=4){var a=e[i];if(t==="big"){r[n]=a>>>24;r[n+1]=a>>>16&255;r[n+2]=a>>>8&255;r[n+3]=a&255}else{r[n+3]=a>>>24;r[n+2]=a>>>16&255;r[n+1]=a>>>8&255;r[n]=a&255}}return r}t.split32=split32;function rotr32(e,t){return e>>>t|e<<32-t}t.rotr32=rotr32;function rotl32(e,t){return e<<t|e>>>32-t}t.rotl32=rotl32;function sum32(e,t){return e+t>>>0}t.sum32=sum32;function sum32_3(e,t,r){return e+t+r>>>0}t.sum32_3=sum32_3;function sum32_4(e,t,r,i){return e+t+r+i>>>0}t.sum32_4=sum32_4;function sum32_5(e,t,r,i,n){return e+t+r+i+n>>>0}t.sum32_5=sum32_5;function sum64(e,t,r,i){var n=e[t];var a=e[t+1];var s=i+a>>>0;var o=(s<i?1:0)+r+n;e[t]=o>>>0;e[t+1]=s}t.sum64=sum64;function sum64_hi(e,t,r,i){var n=t+i>>>0;var a=(n<t?1:0)+e+r;return a>>>0}t.sum64_hi=sum64_hi;function sum64_lo(e,t,r,i){var n=t+i;return n>>>0}t.sum64_lo=sum64_lo;function sum64_4_hi(e,t,r,i,n,a,s,o){var h=0;var u=t;u=u+i>>>0;h+=u<t?1:0;u=u+a>>>0;h+=u<a?1:0;u=u+o>>>0;h+=u<o?1:0;var d=e+r+n+s+h;return d>>>0}t.sum64_4_hi=sum64_4_hi;function sum64_4_lo(e,t,r,i,n,a,s,o){var h=t+i+a+o;return h>>>0}t.sum64_4_lo=sum64_4_lo;function sum64_5_hi(e,t,r,i,n,a,s,o,h,u){var d=0;var c=t;c=c+i>>>0;d+=c<t?1:0;c=c+a>>>0;d+=c<a?1:0;c=c+o>>>0;d+=c<o?1:0;c=c+u>>>0;d+=c<u?1:0;var l=e+r+n+s+h+d;return l>>>0}t.sum64_5_hi=sum64_5_hi;function sum64_5_lo(e,t,r,i,n,a,s,o,h,u){var d=t+i+a+o+u;return d>>>0}t.sum64_5_lo=sum64_5_lo;function rotr64_hi(e,t,r){var i=t<<32-r|e>>>r;return i>>>0}t.rotr64_hi=rotr64_hi;function rotr64_lo(e,t,r){var i=e<<32-r|t>>>r;return i>>>0}t.rotr64_lo=rotr64_lo;function shr64_hi(e,t,r){return e>>>r}t.shr64_hi=shr64_hi;function shr64_lo(e,t,r){var i=e<<32-r|t>>>r;return i>>>0}t.shr64_lo=shr64_lo},4910:function(e,t,r){"use strict";var i=r(7028);var n=r(6545);var a=r(3523);function HmacDRBG(e){if(!(this instanceof HmacDRBG))return new HmacDRBG(e);this.hash=e.hash;this.predResist=!!e.predResist;this.outLen=this.hash.outSize;this.minEntropy=e.minEntropy||this.hash.hmacStrength;this._reseed=null;this.reseedInterval=null;this.K=null;this.V=null;var t=n.toArray(e.entropy,e.entropyEnc||"hex");var r=n.toArray(e.nonce,e.nonceEnc||"hex");var i=n.toArray(e.pers,e.persEnc||"hex");a(t.length>=this.minEntropy/8,"Not enough entropy. Minimum is: "+this.minEntropy+" bits");this._init(t,r,i)}e.exports=HmacDRBG;HmacDRBG.prototype._init=function init(e,t,r){var i=e.concat(t).concat(r);this.K=new Array(this.outLen/8);this.V=new Array(this.outLen/8);for(var n=0;n<this.V.length;n++){this.K[n]=0;this.V[n]=1}this._update(i);this._reseed=1;this.reseedInterval=281474976710656};HmacDRBG.prototype._hmac=function hmac(){return new i.hmac(this.hash,this.K)};HmacDRBG.prototype._update=function update(e){var t=this._hmac().update(this.V).update([0]);if(e)t=t.update(e);this.K=t.digest();this.V=this._hmac().update(this.V).digest();if(!e)return;this.K=this._hmac().update(this.V).update([1]).update(e).digest();this.V=this._hmac().update(this.V).digest()};HmacDRBG.prototype.reseed=function reseed(e,t,r,i){if(typeof t!=="string"){i=r;r=t;t=null}e=n.toArray(e,t);r=n.toArray(r,i);a(e.length>=this.minEntropy/8,"Not enough entropy. Minimum is: "+this.minEntropy+" bits");this._update(e.concat(r||[]));this._reseed=1};HmacDRBG.prototype.generate=function generate(e,t,r,i){if(this._reseed>this.reseedInterval)throw new Error("Reseed is required");if(typeof t!=="string"){i=r;r=t;t=null}if(r){r=n.toArray(r,i||"hex");this._update(r)}var a=[];while(a.length<e){this.V=this._hmac().update(this.V).digest();a=a.concat(this.V)}var s=a.slice(0,e);this._update(r);this._reseed++;return n.encode(s,t)}},3782:function(e){if(typeof Object.create==="function"){e.exports=function inherits(e,t){if(t){e.super_=t;e.prototype=Object.create(t.prototype,{constructor:{value:e,enumerable:false,writable:true,configurable:true}})}}}else{e.exports=function inherits(e,t){if(t){e.super_=t;var TempCtor=function(){};TempCtor.prototype=t.prototype;e.prototype=new TempCtor;e.prototype.constructor=e}}}},3533:function(e,t,r){"use strict";var i=r(3782);var n=r(9029);var a=r(5055).Buffer;var s=new Array(16);function MD5(){n.call(this,64);this._a=1732584193;this._b=4023233417;this._c=2562383102;this._d=271733878}i(MD5,n);MD5.prototype._update=function(){var e=s;for(var t=0;t<16;++t)e[t]=this._block.readInt32LE(t*4);var r=this._a;var i=this._b;var n=this._c;var a=this._d;r=fnF(r,i,n,a,e[0],3614090360,7);a=fnF(a,r,i,n,e[1],3905402710,12);n=fnF(n,a,r,i,e[2],606105819,17);i=fnF(i,n,a,r,e[3],3250441966,22);r=fnF(r,i,n,a,e[4],4118548399,7);a=fnF(a,r,i,n,e[5],1200080426,12);n=fnF(n,a,r,i,e[6],2821735955,17);i=fnF(i,n,a,r,e[7],4249261313,22);r=fnF(r,i,n,a,e[8],1770035416,7);a=fnF(a,r,i,n,e[9],2336552879,12);n=fnF(n,a,r,i,e[10],4294925233,17);i=fnF(i,n,a,r,e[11],2304563134,22);r=fnF(r,i,n,a,e[12],1804603682,7);a=fnF(a,r,i,n,e[13],4254626195,12);n=fnF(n,a,r,i,e[14],2792965006,17);i=fnF(i,n,a,r,e[15],1236535329,22);r=fnG(r,i,n,a,e[1],4129170786,5);a=fnG(a,r,i,n,e[6],3225465664,9);n=fnG(n,a,r,i,e[11],643717713,14);i=fnG(i,n,a,r,e[0],3921069994,20);r=fnG(r,i,n,a,e[5],3593408605,5);a=fnG(a,r,i,n,e[10],38016083,9);n=fnG(n,a,r,i,e[15],3634488961,14);i=fnG(i,n,a,r,e[4],3889429448,20);r=fnG(r,i,n,a,e[9],568446438,5);a=fnG(a,r,i,n,e[14],3275163606,9);n=fnG(n,a,r,i,e[3],4107603335,14);i=fnG(i,n,a,r,e[8],1163531501,20);r=fnG(r,i,n,a,e[13],2850285829,5);a=fnG(a,r,i,n,e[2],4243563512,9);n=fnG(n,a,r,i,e[7],1735328473,14);i=fnG(i,n,a,r,e[12],2368359562,20);r=fnH(r,i,n,a,e[5],4294588738,4);a=fnH(a,r,i,n,e[8],2272392833,11);n=fnH(n,a,r,i,e[11],1839030562,16);i=fnH(i,n,a,r,e[14],4259657740,23);r=fnH(r,i,n,a,e[1],2763975236,4);a=fnH(a,r,i,n,e[4],1272893353,11);n=fnH(n,a,r,i,e[7],4139469664,16);i=fnH(i,n,a,r,e[10],3200236656,23);r=fnH(r,i,n,a,e[13],681279174,4);a=fnH(a,r,i,n,e[0],3936430074,11);n=fnH(n,a,r,i,e[3],3572445317,16);i=fnH(i,n,a,r,e[6],76029189,23);r=fnH(r,i,n,a,e[9],3654602809,4);a=fnH(a,r,i,n,e[12],3873151461,11);n=fnH(n,a,r,i,e[15],530742520,16);i=fnH(i,n,a,r,e[2],3299628645,23);r=fnI(r,i,n,a,e[0],4096336452,6);a=fnI(a,r,i,n,e[7],1126891415,10);n=fnI(n,a,r,i,e[14],2878612391,15);i=fnI(i,n,a,r,e[5],4237533241,21);r=fnI(r,i,n,a,e[12],1700485571,6);a=fnI(a,r,i,n,e[3],2399980690,10);n=fnI(n,a,r,i,e[10],4293915773,15);i=fnI(i,n,a,r,e[1],2240044497,21);r=fnI(r,i,n,a,e[8],1873313359,6);a=fnI(a,r,i,n,e[15],4264355552,10);n=fnI(n,a,r,i,e[6],2734768916,15);i=fnI(i,n,a,r,e[13],1309151649,21);r=fnI(r,i,n,a,e[4],4149444226,6);a=fnI(a,r,i,n,e[11],3174756917,10);n=fnI(n,a,r,i,e[2],718787259,15);i=fnI(i,n,a,r,e[9],3951481745,21);this._a=this._a+r|0;this._b=this._b+i|0;this._c=this._c+n|0;this._d=this._d+a|0};MD5.prototype._digest=function(){this._block[this._blockOffset++]=128;if(this._blockOffset>56){this._block.fill(0,this._blockOffset,64);this._update();this._blockOffset=0}this._block.fill(0,this._blockOffset,56);this._block.writeUInt32LE(this._length[0],56);this._block.writeUInt32LE(this._length[1],60);this._update();var e=a.allocUnsafe(16);e.writeInt32LE(this._a,0);e.writeInt32LE(this._b,4);e.writeInt32LE(this._c,8);e.writeInt32LE(this._d,12);return e};function rotl(e,t){return e<<t|e>>>32-t}function fnF(e,t,r,i,n,a,s){return rotl(e+(t&r|~t&i)+n+a|0,s)+t|0}function fnG(e,t,r,i,n,a,s){return rotl(e+(t&i|r&~i)+n+a|0,s)+t|0}function fnH(e,t,r,i,n,a,s){return rotl(e+(t^r^i)+n+a|0,s)+t|0}function fnI(e,t,r,i,n,a,s){return rotl(e+(r^(t|~i))+n+a|0,s)+t|0}e.exports=MD5},1354:function(e,t,r){var i=r(711);var n=r(3500);function MillerRabin(e){this.rand=e||new n.Rand}e.exports=MillerRabin;MillerRabin.create=function create(e){return new MillerRabin(e)};MillerRabin.prototype._randbelow=function _randbelow(e){var t=e.bitLength();var r=Math.ceil(t/8);do{var n=new i(this.rand.generate(r))}while(n.cmp(e)>=0);return n};MillerRabin.prototype._randrange=function _randrange(e,t){var r=t.sub(e);return e.add(this._randbelow(r))};MillerRabin.prototype.test=function test(e,t,r){var n=e.bitLength();var a=i.mont(e);var s=new i(1).toRed(a);if(!t)t=Math.max(1,n/48|0);var o=e.subn(1);for(var h=0;!o.testn(h);h++){}var u=e.shrn(h);var d=o.toRed(a);var c=true;for(;t>0;t--){var l=this._randrange(new i(2),o);if(r)r(l);var p=l.toRed(a).redPow(u);if(p.cmp(s)===0||p.cmp(d)===0)continue;for(var v=1;v<h;v++){p=p.redSqr();if(p.cmp(s)===0)return false;if(p.cmp(d)===0)break}if(v===h)return false}return c};MillerRabin.prototype.getDivisor=function getDivisor(e,t){var r=e.bitLength();var n=i.mont(e);var a=new i(1).toRed(n);if(!t)t=Math.max(1,r/48|0);var s=e.subn(1);for(var o=0;!s.testn(o);o++){}var h=e.shrn(o);var u=s.toRed(n);for(;t>0;t--){var d=this._randrange(new i(2),s);var c=e.gcd(d);if(c.cmpn(1)!==0)return c;var l=d.toRed(n).redPow(h);if(l.cmp(a)===0||l.cmp(u)===0)continue;for(var p=1;p<o;p++){l=l.redSqr();if(l.cmp(a)===0)return l.fromRed().subn(1).gcd(e);if(l.cmp(u)===0)break}if(p===o){l=l.redSqr();return l.fromRed().subn(1).gcd(e)}}return false}},3523:function(e){e.exports=assert;function assert(e,t){if(!e)throw new Error(t||"Assertion failed")}assert.equal=function assertEqual(e,t,r){if(e!=t)throw new Error(r||"Assertion failed: "+e+" != "+t)}},6545:function(e,t){"use strict";var r=t;function toArray(e,t){if(Array.isArray(e))return e.slice();if(!e)return[];var r=[];if(typeof e!=="string"){for(var i=0;i<e.length;i++)r[i]=e[i]|0;return r}if(t==="hex"){e=e.replace(/[^a-z0-9]+/gi,"");if(e.length%2!==0)e="0"+e;for(var i=0;i<e.length;i+=2)r.push(parseInt(e[i]+e[i+1],16))}else{for(var i=0;i<e.length;i++){var n=e.charCodeAt(i);var a=n>>8;var s=n&255;if(a)r.push(a,s);else r.push(s)}}return r}r.toArray=toArray;function zero2(e){if(e.length===1)return"0"+e;else return e}r.zero2=zero2;function toHex(e){var t="";for(var r=0;r<e.length;r++)t+=zero2(e[r].toString(16));return t}r.toHex=toHex;r.encode=function encode(e,t){if(t==="hex")return toHex(e);else return e}},8687:function(e,t,r){"use strict";var i=r(7160);t.certificate=r(8782);var n=i.define("RSAPrivateKey",(function(){this.seq().obj(this.key("version").int(),this.key("modulus").int(),this.key("publicExponent").int(),this.key("privateExponent").int(),this.key("prime1").int(),this.key("prime2").int(),this.key("exponent1").int(),this.key("exponent2").int(),this.key("coefficient").int())}));t.RSAPrivateKey=n;var a=i.define("RSAPublicKey",(function(){this.seq().obj(this.key("modulus").int(),this.key("publicExponent").int())}));t.RSAPublicKey=a;var s=i.define("SubjectPublicKeyInfo",(function(){this.seq().obj(this.key("algorithm").use(o),this.key("subjectPublicKey").bitstr())}));t.PublicKey=s;var o=i.define("AlgorithmIdentifier",(function(){this.seq().obj(this.key("algorithm").objid(),this.key("none").null_().optional(),this.key("curve").objid().optional(),this.key("params").seq().obj(this.key("p").int(),this.key("q").int(),this.key("g").int()).optional())}));var h=i.define("PrivateKeyInfo",(function(){this.seq().obj(this.key("version").int(),this.key("algorithm").use(o),this.key("subjectPrivateKey").octstr())}));t.PrivateKey=h;var u=i.define("EncryptedPrivateKeyInfo",(function(){this.seq().obj(this.key("algorithm").seq().obj(this.key("id").objid(),this.key("decrypt").seq().obj(this.key("kde").seq().obj(this.key("id").objid(),this.key("kdeparams").seq().obj(this.key("salt").octstr(),this.key("iters").int())),this.key("cipher").seq().obj(this.key("algo").objid(),this.key("iv").octstr()))),this.key("subjectPrivateKey").octstr())}));t.EncryptedPrivateKey=u;var d=i.define("DSAPrivateKey",(function(){this.seq().obj(this.key("version").int(),this.key("p").int(),this.key("q").int(),this.key("g").int(),this.key("pub_key").int(),this.key("priv_key").int())}));t.DSAPrivateKey=d;t.DSAparam=i.define("DSAparam",(function(){this.int()}));var c=i.define("ECPrivateKey",(function(){this.seq().obj(this.key("version").int(),this.key("privateKey").octstr(),this.key("parameters").optional().explicit(0).use(l),this.key("publicKey").optional().explicit(1).bitstr())}));t.ECPrivateKey=c;var l=i.define("ECParameters",(function(){this.choice({namedCurve:this.objid()})}));t.signature=i.define("signature",(function(){this.seq().obj(this.key("r").int(),this.key("s").int())}))},8782:function(e,t,r){"use strict";var i=r(7160);var n=i.define("Time",(function(){this.choice({utcTime:this.utctime(),generalTime:this.gentime()})}));var a=i.define("AttributeTypeValue",(function(){this.seq().obj(this.key("type").objid(),this.key("value").any())}));var s=i.define("AlgorithmIdentifier",(function(){this.seq().obj(this.key("algorithm").objid(),this.key("parameters").optional(),this.key("curve").objid().optional())}));var o=i.define("SubjectPublicKeyInfo",(function(){this.seq().obj(this.key("algorithm").use(s),this.key("subjectPublicKey").bitstr())}));var h=i.define("RelativeDistinguishedName",(function(){this.setof(a)}));var u=i.define("RDNSequence",(function(){this.seqof(h)}));var d=i.define("Name",(function(){this.choice({rdnSequence:this.use(u)})}));var c=i.define("Validity",(function(){this.seq().obj(this.key("notBefore").use(n),this.key("notAfter").use(n))}));var l=i.define("Extension",(function(){this.seq().obj(this.key("extnID").objid(),this.key("critical").bool().def(false),this.key("extnValue").octstr())}));var p=i.define("TBSCertificate",(function(){this.seq().obj(this.key("version").explicit(0).int().optional(),this.key("serialNumber").int(),this.key("signature").use(s),this.key("issuer").use(d),this.key("validity").use(c),this.key("subject").use(d),this.key("subjectPublicKeyInfo").use(o),this.key("issuerUniqueID").implicit(1).bitstr().optional(),this.key("subjectUniqueID").implicit(2).bitstr().optional(),this.key("extensions").explicit(3).seqof(l).optional())}));var v=i.define("X509Certificate",(function(){this.seq().obj(this.key("tbsCertificate").use(p),this.key("signatureAlgorithm").use(s),this.key("signatureValue").bitstr())}));e.exports=v},6501:function(e,t,r){var i=/Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r\+\/\=]+)[\n\r]+/m;var n=/^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----/m;var a=/^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----([0-9A-z\n\r\+\/\=]+)-----END \1-----$/m;var s=r(8368);var o=r(6594);var h=r(5055).Buffer;e.exports=function(e,t){var r=e.toString();var u=r.match(i);var d;if(!u){var c=r.match(a);d=new h(c[2].replace(/[\r\n]/g,""),"base64")}else{var l="aes"+u[1];var p=h.from(u[2],"hex");var v=h.from(u[3].replace(/[\r\n]/g,""),"base64");var b=s(t,p.slice(0,8),parseInt(u[1],10)).key;var m=[];var y=o.createDecipheriv(l,b,p);m.push(y.update(v));m.push(y.final());d=h.concat(m)}var g=r.match(n)[1];return{tag:g,data:d}}},9902:function(e,t,r){var i=r(8687);var n=r(2510);var a=r(6501);var s=r(6594);var o=r(4978);var h=r(5055).Buffer;e.exports=parseKeys;function parseKeys(e){var t;if(typeof e==="object"&&!h.isBuffer(e)){t=e.passphrase;e=e.key}if(typeof e==="string"){e=h.from(e)}var r=a(e,t);var n=r.tag;var s=r.data;var o,u;switch(n){case"CERTIFICATE":u=i.certificate.decode(s,"der").tbsCertificate.subjectPublicKeyInfo;case"PUBLIC KEY":if(!u){u=i.PublicKey.decode(s,"der")}o=u.algorithm.algorithm.join(".");switch(o){case"1.2.840.113549.1.1.1":return i.RSAPublicKey.decode(u.subjectPublicKey.data,"der");case"1.2.840.10045.2.1":u.subjectPrivateKey=u.subjectPublicKey;return{type:"ec",data:u};case"1.2.840.10040.4.1":u.algorithm.params.pub_key=i.DSAparam.decode(u.subjectPublicKey.data,"der");return{type:"dsa",data:u.algorithm.params};default:throw new Error("unknown key id "+o)}throw new Error("unknown key type "+n);case"ENCRYPTED PRIVATE KEY":s=i.EncryptedPrivateKey.decode(s,"der");s=decrypt(s,t);case"PRIVATE KEY":u=i.PrivateKey.decode(s,"der");o=u.algorithm.algorithm.join(".");switch(o){case"1.2.840.113549.1.1.1":return i.RSAPrivateKey.decode(u.subjectPrivateKey,"der");case"1.2.840.10045.2.1":return{curve:u.algorithm.curve,privateKey:i.ECPrivateKey.decode(u.subjectPrivateKey,"der").privateKey};case"1.2.840.10040.4.1":u.algorithm.params.priv_key=i.DSAparam.decode(u.subjectPrivateKey,"der");return{type:"dsa",params:u.algorithm.params};default:throw new Error("unknown key id "+o)}throw new Error("unknown key type "+n);case"RSA PUBLIC KEY":return i.RSAPublicKey.decode(s,"der");case"RSA PRIVATE KEY":return i.RSAPrivateKey.decode(s,"der");case"DSA PRIVATE KEY":return{type:"dsa",params:i.DSAPrivateKey.decode(s,"der")};case"EC PRIVATE KEY":s=i.ECPrivateKey.decode(s,"der");return{curve:s.parameters.value,privateKey:s.privateKey};default:throw new Error("unknown key type "+n)}}parseKeys.signature=i.signature;function decrypt(e,t){var r=e.algorithm.decrypt.kde.kdeparams.salt;var i=parseInt(e.algorithm.decrypt.kde.kdeparams.iters.toString(),10);var a=n[e.algorithm.decrypt.cipher.algo.join(".")];var u=e.algorithm.decrypt.cipher.iv;var d=e.subjectPrivateKey;var c=parseInt(a.split("-")[1],10)/8;var l=o.pbkdf2Sync(t,r,i,c,"sha1");var p=s.createDecipheriv(a,l,u);var v=[];v.push(p.update(d));v.push(p.final());return h.concat(v)}},4978:function(e,t,r){var i=r(6113);var n=r(5349);var a=r(7007);var s=r(5407);function nativePBKDF2(e,t,r,o,h,u){n(r,o);e=s(e,a,"Password");t=s(t,a,"Salt");if(typeof h==="function"){u=h;h="sha1"}if(typeof u!=="function")throw new Error("No callback provided to pbkdf2");return i.pbkdf2(e,t,r,o,h,u)}function nativePBKDF2Sync(e,t,r,o,h){n(r,o);e=s(e,a,"Password");t=s(t,a,"Salt");h=h||"sha1";return i.pbkdf2Sync(e,t,r,o,h)}if(!i.pbkdf2Sync||i.pbkdf2Sync.toString().indexOf("keylen, digest")===-1){t.pbkdf2Sync=r(2127);t.pbkdf2=r(9601)}else{t.pbkdf2Sync=nativePBKDF2Sync;t.pbkdf2=nativePBKDF2}},9601:function(e,t,r){var i=r(5055).Buffer;var n=r(5349);var a=r(7007);var s=r(2127);var o=r(5407);var h;var u=__webpack_require__.g.crypto&&__webpack_require__.g.crypto.subtle;var d={sha:"SHA-1","sha-1":"SHA-1",sha1:"SHA-1",sha256:"SHA-256","sha-256":"SHA-256",sha384:"SHA-384","sha-384":"SHA-384","sha-512":"SHA-512",sha512:"SHA-512"};var c=[];function checkNative(e){if(__webpack_require__.g.process&&!__webpack_require__.g.process.browser){return Promise.resolve(false)}if(!u||!u.importKey||!u.deriveBits){return Promise.resolve(false)}if(c[e]!==undefined){return c[e]}h=h||i.alloc(8);var t=browserPbkdf2(h,h,10,128,e).then((function(){return true})).catch((function(){return false}));c[e]=t;return t}function browserPbkdf2(e,t,r,n,a){return u.importKey("raw",e,{name:"PBKDF2"},false,["deriveBits"]).then((function(e){return u.deriveBits({name:"PBKDF2",salt:t,iterations:r,hash:{name:a}},e,n<<3)})).then((function(e){return i.from(e)}))}function resolvePromise(e,t){e.then((function(e){process.nextTick((function(){t(null,e)}))}),(function(e){process.nextTick((function(){t(e)}))}))}e.exports=function(e,t,r,i,h,u){if(typeof h==="function"){u=h;h=undefined}h=h||"sha1";var c=d[h.toLowerCase()];if(!c||typeof __webpack_require__.g.Promise!=="function"){return process.nextTick((function(){var n;try{n=s(e,t,r,i,h)}catch(e){return u(e)}u(null,n)}))}n(r,i);e=o(e,a,"Password");t=o(t,a,"Salt");if(typeof u!=="function")throw new Error("No callback provided to pbkdf2");resolvePromise(checkNative(c).then((function(n){if(n)return browserPbkdf2(e,t,r,i,c);return s(e,t,r,i,h)})),u)}},7007:function(e){var t;if(true){t="utf-8"}else { var r; }e.exports=t},5349:function(e){var t=Math.pow(2,30)-1;e.exports=function(e,r){if(typeof e!=="number"){throw new TypeError("Iterations not a number")}if(e<0){throw new TypeError("Bad iterations")}if(typeof r!=="number"){throw new TypeError("Key length not a number")}if(r<0||r>t||r!==r){throw new TypeError("Bad key length")}}},2127:function(e,t,r){var i={md5:16,sha1:20,sha224:28,sha256:32,sha384:48,sha512:64,rmd160:20,ripemd160:20};var n=r(4873);var a=r(5055).Buffer;var s=r(5349);var o=r(7007);var h=r(5407);function pbkdf2(e,t,r,u,d){s(r,u);e=h(e,o,"Password");t=h(t,o,"Salt");d=d||"sha1";var c=a.allocUnsafe(u);var l=a.allocUnsafe(t.length+4);t.copy(l,0,0,t.length);var p=0;var v=i[d];var b=Math.ceil(u/v);for(var m=1;m<=b;m++){l.writeUInt32BE(m,t.length);var y=n(d,e).update(l).digest();var g=y;for(var _=1;_<r;_++){g=n(d,e).update(g).digest();for(var w=0;w<v;w++)y[w]^=g[w]}y.copy(c,p);p+=v}return c}e.exports=pbkdf2},5407:function(e,t,r){var i=r(5055).Buffer;e.exports=function(e,t,r){if(i.isBuffer(e)){return e}else if(typeof e==="string"){return i.from(e,t)}else if(ArrayBuffer.isView(e)){return i.from(e.buffer)}else{throw new TypeError(r+" must be a string, a Buffer, a typed array or a DataView")}}},9783:function(e,t,r){t.publicEncrypt=r(3995);t.privateDecrypt=r(4366);t.privateEncrypt=function privateEncrypt(e,r){return t.publicEncrypt(e,r,true)};t.publicDecrypt=function publicDecrypt(e,r){return t.privateDecrypt(e,r,true)}},5520:function(e,t,r){var i=r(9739);var n=r(5055).Buffer;e.exports=function(e,t){var r=n.alloc(0);var a=0;var s;while(r.length<t){s=i2ops(a++);r=n.concat([r,i("sha1").update(e).update(s).digest()])}return r.slice(0,t)};function i2ops(e){var t=n.allocUnsafe(4);t.writeUInt32BE(e,0);return t}},4366:function(e,t,r){var i=r(9902);var n=r(5520);var a=r(6386);var s=r(711);var o=r(7166);var h=r(9739);var u=r(1607);var d=r(5055).Buffer;e.exports=function privateDecrypt(e,t,r){var n;if(e.padding){n=e.padding}else if(r){n=1}else{n=4}var a=i(e);var h=a.modulus.byteLength();if(t.length>h||new s(t).cmp(a.modulus)>=0){throw new Error("decryption error")}var c;if(r){c=u(new s(t),a)}else{c=o(t,a)}var l=d.alloc(h-c.length);c=d.concat([l,c],h);if(n===4){return oaep(a,c)}else if(n===1){return pkcs1(a,c,r)}else if(n===3){return c}else{throw new Error("unknown padding")}};function oaep(e,t){var r=e.modulus.byteLength();var i=h("sha1").update(d.alloc(0)).digest();var s=i.length;if(t[0]!==0){throw new Error("decryption error")}var o=t.slice(1,s+1);var u=t.slice(s+1);var c=a(o,n(u,s));var l=a(u,n(c,r-s-1));if(compare(i,l.slice(0,s))){throw new Error("decryption error")}var p=s;while(l[p]===0){p++}if(l[p++]!==1){throw new Error("decryption error")}return l.slice(p)}function pkcs1(e,t,r){var i=t.slice(0,2);var n=2;var a=0;while(t[n++]!==0){if(n>=t.length){a++;break}}var s=t.slice(2,n-1);if(i.toString("hex")!=="0002"&&!r||i.toString("hex")!=="0001"&&r){a++}if(s.length<8){a++}if(a){throw new Error("decryption error")}return t.slice(n)}function compare(e,t){e=d.from(e);t=d.from(t);var r=0;var i=e.length;if(e.length!==t.length){r++;i=Math.min(e.length,t.length)}var n=-1;while(++n<i){r+=e[n]^t[n]}return r}},3995:function(e,t,r){var i=r(9902);var n=r(7223);var a=r(9739);var s=r(5520);var o=r(6386);var h=r(711);var u=r(1607);var d=r(7166);var c=r(5055).Buffer;e.exports=function publicEncrypt(e,t,r){var n;if(e.padding){n=e.padding}else if(r){n=1}else{n=4}var a=i(e);var s;if(n===4){s=oaep(a,t)}else if(n===1){s=pkcs1(a,t,r)}else if(n===3){s=new h(t);if(s.cmp(a.modulus)>=0){throw new Error("data too long for modulus")}}else{throw new Error("unknown padding")}if(r){return d(s,a)}else{return u(s,a)}};function oaep(e,t){var r=e.modulus.byteLength();var i=t.length;var u=a("sha1").update(c.alloc(0)).digest();var d=u.length;var l=2*d;if(i>r-l-2){throw new Error("message too long")}var p=c.alloc(r-i-l-2);var v=r-d-1;var b=n(d);var m=o(c.concat([u,p,c.alloc(1,1),t],v),s(b,v));var y=o(b,s(m,d));return new h(c.concat([c.alloc(1),y,m],r))}function pkcs1(e,t,r){var i=t.length;var n=e.modulus.byteLength();if(i>n-11){throw new Error("message too long")}var a;if(r){a=c.alloc(n-i-3,255)}else{a=nonZero(n-i-3)}return new h(c.concat([c.from([0,r?1:2]),a,c.alloc(1),t],n))}function nonZero(e){var t=c.allocUnsafe(e);var r=0;var i=n(e*2);var a=0;var s;while(r<e){if(a===i.length){i=n(e*2);a=0}s=i[a++];if(s){t[r++]=s}}return t}},1607:function(e,t,r){var i=r(711);var n=r(5055).Buffer;function withPublic(e,t){return n.from(e.toRed(i.mont(t.modulus)).redPow(new i(t.publicExponent)).fromRed().toArray())}e.exports=withPublic},6386:function(e){e.exports=function xor(e,t){var r=e.length;var i=-1;while(++i<r){e[i]^=t[i]}return e}},7223:function(e,t,r){"use strict";var i=65536;var n=4294967295;function oldBrowser(){throw new Error("Secure random number generation is not supported by this browser.\nUse Chrome, Firefox or Internet Explorer 11")}var a=r(5055).Buffer;var s=__webpack_require__.g.crypto||__webpack_require__.g.msCrypto;if(s&&s.getRandomValues){e.exports=randomBytes}else{e.exports=oldBrowser}function randomBytes(e,t){if(e>n)throw new RangeError("requested too many random bytes");var r=a.allocUnsafe(e);if(e>0){if(e>i){for(var o=0;o<e;o+=i){s.getRandomValues(r.slice(o,o+i))}}else{s.getRandomValues(r)}}if(typeof t==="function"){return process.nextTick((function(){t(null,r)}))}return r}},6445:function(e,t,r){"use strict";function oldBrowser(){throw new Error("secure random number generation not supported by this browser\nuse chrome, FireFox or Internet Explorer 11")}var i=r(5055);var n=r(7223);var a=i.Buffer;var s=i.kMaxLength;var o=__webpack_require__.g.crypto||__webpack_require__.g.msCrypto;var h=Math.pow(2,32)-1;function assertOffset(e,t){if(typeof e!=="number"||e!==e){throw new TypeError("offset must be a number")}if(e>h||e<0){throw new TypeError("offset must be a uint32")}if(e>s||e>t){throw new RangeError("offset out of range")}}function assertSize(e,t,r){if(typeof e!=="number"||e!==e){throw new TypeError("size must be a number")}if(e>h||e<0){throw new TypeError("size must be a uint32")}if(e+t>r||e>s){throw new RangeError("buffer too small")}}if(o&&o.getRandomValues||!true){t.randomFill=randomFill;t.randomFillSync=randomFillSync}else{t.randomFill=oldBrowser;t.randomFillSync=oldBrowser}function randomFill(e,t,r,i){if(!a.isBuffer(e)&&!(e instanceof __webpack_require__.g.Uint8Array)){throw new TypeError('"buf" argument must be a Buffer or Uint8Array')}if(typeof t==="function"){i=t;t=0;r=e.length}else if(typeof r==="function"){i=r;r=e.length-t}else if(typeof i!=="function"){throw new TypeError('"cb" argument must be a function')}assertOffset(t,e.length);assertSize(r,t,e.length);return actualFill(e,t,r,i)}function actualFill(e,t,r,i){if(true){var a=e.buffer;var s=new Uint8Array(a,t,r);o.getRandomValues(s);if(i){process.nextTick((function(){i(null,e)}));return}return e}if(i){n(r,(function(r,n){if(r){return i(r)}n.copy(e,t);i(null,e)}));return}var h=n(r);h.copy(e,t);return e}function randomFillSync(e,t,r){if(typeof t==="undefined"){t=0}if(!a.isBuffer(e)&&!(e instanceof __webpack_require__.g.Uint8Array)){throw new TypeError('"buf" argument must be a Buffer or Uint8Array')}assertOffset(t,e.length);if(r===undefined)r=e.length-t;assertSize(r,t,e.length);return actualFill(e,t,r)}},4646:function(e){"use strict";const t={};function createErrorType(e,r,i){if(!i){i=Error}function getMessage(e,t,i){if(typeof r==="string"){return r}else{return r(e,t,i)}}class NodeError extends i{constructor(e,t,r){super(getMessage(e,t,r))}}NodeError.prototype.name=i.name;NodeError.prototype.code=e;t[e]=NodeError}function oneOf(e,t){if(Array.isArray(e)){const r=e.length;e=e.map((e=>String(e)));if(r>2){return`one of ${t} ${e.slice(0,r-1).join(", ")}, or `+e[r-1]}else if(r===2){return`one of ${t} ${e[0]} or ${e[1]}`}else{return`of ${t} ${e[0]}`}}else{return`of ${t} ${String(e)}`}}function startsWith(e,t,r){return e.substr(!r||r<0?0:+r,t.length)===t}function endsWith(e,t,r){if(r===undefined||r>e.length){r=e.length}return e.substring(r-t.length,r)===t}function includes(e,t,r){if(typeof r!=="number"){r=0}if(r+t.length>e.length){return false}else{return e.indexOf(t,r)!==-1}}createErrorType("ERR_INVALID_OPT_VALUE",(function(e,t){return'The value "'+t+'" is invalid for option "'+e+'"'}),TypeError);createErrorType("ERR_INVALID_ARG_TYPE",(function(e,t,r){let i;if(typeof t==="string"&&startsWith(t,"not ")){i="must not be";t=t.replace(/^not /,"")}else{i="must be"}let n;if(endsWith(e," argument")){n=`The ${e} ${i} ${oneOf(t,"type")}`}else{const r=includes(e,".")?"property":"argument";n=`The "${e}" ${r} ${i} ${oneOf(t,"type")}`}n+=`. Received type ${typeof r}`;return n}),TypeError);createErrorType("ERR_STREAM_PUSH_AFTER_EOF","stream.push() after EOF");createErrorType("ERR_METHOD_NOT_IMPLEMENTED",(function(e){return"The "+e+" method is not implemented"}));createErrorType("ERR_STREAM_PREMATURE_CLOSE","Premature close");createErrorType("ERR_STREAM_DESTROYED",(function(e){return"Cannot call "+e+" after a stream was destroyed"}));createErrorType("ERR_MULTIPLE_CALLBACK","Callback called multiple times");createErrorType("ERR_STREAM_CANNOT_PIPE","Cannot pipe, not readable");createErrorType("ERR_STREAM_WRITE_AFTER_END","write after end");createErrorType("ERR_STREAM_NULL_VALUES","May not write null values to stream",TypeError);createErrorType("ERR_UNKNOWN_ENCODING",(function(e){return"Unknown encoding: "+e}),TypeError);createErrorType("ERR_STREAM_UNSHIFT_AFTER_END_EVENT","stream.unshift() after end event");e.exports.q=t},2403:function(e,t,r){"use strict";var i=Object.keys||function(e){var t=[];for(var r in e){t.push(r)}return t};e.exports=Duplex;var n=r(1709);var a=r(7337);r(3782)(Duplex,n);{var s=i(a.prototype);for(var o=0;o<s.length;o++){var h=s[o];if(!Duplex.prototype[h])Duplex.prototype[h]=a.prototype[h]}}function Duplex(e){if(!(this instanceof Duplex))return new Duplex(e);n.call(this,e);a.call(this,e);this.allowHalfOpen=true;if(e){if(e.readable===false)this.readable=false;if(e.writable===false)this.writable=false;if(e.allowHalfOpen===false){this.allowHalfOpen=false;this.once("end",onend)}}}Object.defineProperty(Duplex.prototype,"writableHighWaterMark",{enumerable:false,get:function get(){return this._writableState.highWaterMark}});Object.defineProperty(Duplex.prototype,"writableBuffer",{enumerable:false,get:function get(){return this._writableState&&this._writableState.getBuffer()}});Object.defineProperty(Duplex.prototype,"writableLength",{enumerable:false,get:function get(){return this._writableState.length}});function onend(){if(this._writableState.ended)return;process.nextTick(onEndNT,this)}function onEndNT(e){e.end()}Object.defineProperty(Duplex.prototype,"destroyed",{enumerable:false,get:function get(){if(this._readableState===undefined||this._writableState===undefined){return false}return this._readableState.destroyed&&this._writableState.destroyed},set:function set(e){if(this._readableState===undefined||this._writableState===undefined){return}this._readableState.destroyed=e;this._writableState.destroyed=e}})},7889:function(e,t,r){"use strict";e.exports=PassThrough;var i=r(1170);r(3782)(PassThrough,i);function PassThrough(e){if(!(this instanceof PassThrough))return new PassThrough(e);i.call(this,e)}PassThrough.prototype._transform=function(e,t,r){r(null,e)}},1709:function(e,t,r){"use strict";e.exports=Readable;var i;Readable.ReadableState=ReadableState;var n=r(2361).EventEmitter;var a=function EElistenerCount(e,t){return e.listeners(t).length};var s=r(4678);var o=r(4300).Buffer;var h=__webpack_require__.g.Uint8Array||function(){};function _uint8ArrayToBuffer(e){return o.from(e)}function _isUint8Array(e){return o.isBuffer(e)||e instanceof h}var u=r(3837);var d;if(u&&u.debuglog){d=u.debuglog("stream")}else{d=function debug(){}}var c=r(4379);var l=r(7025);var p=r(6776),v=p.getHighWaterMark;var b=r(4646).q,m=b.ERR_INVALID_ARG_TYPE,y=b.ERR_STREAM_PUSH_AFTER_EOF,g=b.ERR_METHOD_NOT_IMPLEMENTED,_=b.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;var w;var M;var B;r(3782)(Readable,s);var E=l.errorOrDestroy;var k=["error","close","destroy","pause","resume"];function prependListener(e,t,r){if(typeof e.prependListener==="function")return e.prependListener(t,r);if(!e._events||!e._events[t])e.on(t,r);else if(Array.isArray(e._events[t]))e._events[t].unshift(r);else e._events[t]=[r,e._events[t]]}function ReadableState(e,t,n){i=i||r(2403);e=e||{};if(typeof n!=="boolean")n=t instanceof i;this.objectMode=!!e.objectMode;if(n)this.objectMode=this.objectMode||!!e.readableObjectMode;this.highWaterMark=v(this,e,"readableHighWaterMark",n);this.buffer=new c;this.length=0;this.pipes=null;this.pipesCount=0;this.flowing=null;this.ended=false;this.endEmitted=false;this.reading=false;this.sync=true;this.needReadable=false;this.emittedReadable=false;this.readableListening=false;this.resumeScheduled=false;this.paused=true;this.emitClose=e.emitClose!==false;this.autoDestroy=!!e.autoDestroy;this.destroyed=false;this.defaultEncoding=e.defaultEncoding||"utf8";this.awaitDrain=0;this.readingMore=false;this.decoder=null;this.encoding=null;if(e.encoding){if(!w)w=r(3704).s;this.decoder=new w(e.encoding);this.encoding=e.encoding}}function Readable(e){i=i||r(2403);if(!(this instanceof Readable))return new Readable(e);var t=this instanceof i;this._readableState=new ReadableState(e,this,t);this.readable=true;if(e){if(typeof e.read==="function")this._read=e.read;if(typeof e.destroy==="function")this._destroy=e.destroy}s.call(this)}Object.defineProperty(Readable.prototype,"destroyed",{enumerable:false,get:function get(){if(this._readableState===undefined){return false}return this._readableState.destroyed},set:function set(e){if(!this._readableState){return}this._readableState.destroyed=e}});Readable.prototype.destroy=l.destroy;Readable.prototype._undestroy=l.undestroy;Readable.prototype._destroy=function(e,t){t(e)};Readable.prototype.push=function(e,t){var r=this._readableState;var i;if(!r.objectMode){if(typeof e==="string"){t=t||r.defaultEncoding;if(t!==r.encoding){e=o.from(e,t);t=""}i=true}}else{i=true}return readableAddChunk(this,e,t,false,i)};Readable.prototype.unshift=function(e){return readableAddChunk(this,e,null,true,false)};function readableAddChunk(e,t,r,i,n){d("readableAddChunk",t);var a=e._readableState;if(t===null){a.reading=false;onEofChunk(e,a)}else{var s;if(!n)s=chunkInvalid(a,t);if(s){E(e,s)}else if(a.objectMode||t&&t.length>0){if(typeof t!=="string"&&!a.objectMode&&Object.getPrototypeOf(t)!==o.prototype){t=_uint8ArrayToBuffer(t)}if(i){if(a.endEmitted)E(e,new _);else addChunk(e,a,t,true)}else if(a.ended){E(e,new y)}else if(a.destroyed){return false}else{a.reading=false;if(a.decoder&&!r){t=a.decoder.write(t);if(a.objectMode||t.length!==0)addChunk(e,a,t,false);else maybeReadMore(e,a)}else{addChunk(e,a,t,false)}}}else if(!i){a.reading=false;maybeReadMore(e,a)}}return!a.ended&&(a.length<a.highWaterMark||a.length===0)}function addChunk(e,t,r,i){if(t.flowing&&t.length===0&&!t.sync){t.awaitDrain=0;e.emit("data",r)}else{t.length+=t.objectMode?1:r.length;if(i)t.buffer.unshift(r);else t.buffer.push(r);if(t.needReadable)emitReadable(e)}maybeReadMore(e,t)}function chunkInvalid(e,t){var r;if(!_isUint8Array(t)&&typeof t!=="string"&&t!==undefined&&!e.objectMode){r=new m("chunk",["string","Buffer","Uint8Array"],t)}return r}Readable.prototype.isPaused=function(){return this._readableState.flowing===false};Readable.prototype.setEncoding=function(e){if(!w)w=r(3704).s;var t=new w(e);this._readableState.decoder=t;this._readableState.encoding=this._readableState.decoder.encoding;var i=this._readableState.buffer.head;var n="";while(i!==null){n+=t.write(i.data);i=i.next}this._readableState.buffer.clear();if(n!=="")this._readableState.buffer.push(n);this._readableState.length=n.length;return this};var A=1073741824;function computeNewHighWaterMark(e){if(e>=A){e=A}else{e--;e|=e>>>1;e|=e>>>2;e|=e>>>4;e|=e>>>8;e|=e>>>16;e++}return e}function howMuchToRead(e,t){if(e<=0||t.length===0&&t.ended)return 0;if(t.objectMode)return 1;if(e!==e){if(t.flowing&&t.length)return t.buffer.head.data.length;else return t.length}if(e>t.highWaterMark)t.highWaterMark=computeNewHighWaterMark(e);if(e<=t.length)return e;if(!t.ended){t.needReadable=true;return 0}return t.length}Readable.prototype.read=function(e){d("read",e);e=parseInt(e,10);var t=this._readableState;var r=e;if(e!==0)t.emittedReadable=false;if(e===0&&t.needReadable&&((t.highWaterMark!==0?t.length>=t.highWaterMark:t.length>0)||t.ended)){d("read: emitReadable",t.length,t.ended);if(t.length===0&&t.ended)endReadable(this);else emitReadable(this);return null}e=howMuchToRead(e,t);if(e===0&&t.ended){if(t.length===0)endReadable(this);return null}var i=t.needReadable;d("need readable",i);if(t.length===0||t.length-e<t.highWaterMark){i=true;d("length less than watermark",i)}if(t.ended||t.reading){i=false;d("reading or ended",i)}else if(i){d("do read");t.reading=true;t.sync=true;if(t.length===0)t.needReadable=true;this._read(t.highWaterMark);t.sync=false;if(!t.reading)e=howMuchToRead(r,t)}var n;if(e>0)n=fromList(e,t);else n=null;if(n===null){t.needReadable=t.length<=t.highWaterMark;e=0}else{t.length-=e;t.awaitDrain=0}if(t.length===0){if(!t.ended)t.needReadable=true;if(r!==e&&t.ended)endReadable(this)}if(n!==null)this.emit("data",n);return n};function onEofChunk(e,t){d("onEofChunk");if(t.ended)return;if(t.decoder){var r=t.decoder.end();if(r&&r.length){t.buffer.push(r);t.length+=t.objectMode?1:r.length}}t.ended=true;if(t.sync){emitReadable(e)}else{t.needReadable=false;if(!t.emittedReadable){t.emittedReadable=true;emitReadable_(e)}}}function emitReadable(e){var t=e._readableState;d("emitReadable",t.needReadable,t.emittedReadable);t.needReadable=false;if(!t.emittedReadable){d("emitReadable",t.flowing);t.emittedReadable=true;process.nextTick(emitReadable_,e)}}function emitReadable_(e){var t=e._readableState;d("emitReadable_",t.destroyed,t.length,t.ended);if(!t.destroyed&&(t.length||t.ended)){e.emit("readable");t.emittedReadable=false}t.needReadable=!t.flowing&&!t.ended&&t.length<=t.highWaterMark;flow(e)}function maybeReadMore(e,t){if(!t.readingMore){t.readingMore=true;process.nextTick(maybeReadMore_,e,t)}}function maybeReadMore_(e,t){while(!t.reading&&!t.ended&&(t.length<t.highWaterMark||t.flowing&&t.length===0)){var r=t.length;d("maybeReadMore read 0");e.read(0);if(r===t.length)break}t.readingMore=false}Readable.prototype._read=function(e){E(this,new g("_read()"))};Readable.prototype.pipe=function(e,t){var r=this;var i=this._readableState;switch(i.pipesCount){case 0:i.pipes=e;break;case 1:i.pipes=[i.pipes,e];break;default:i.pipes.push(e);break}i.pipesCount+=1;d("pipe count=%d opts=%j",i.pipesCount,t);var n=(!t||t.end!==false)&&e!==process.stdout&&e!==process.stderr;var s=n?onend:unpipe;if(i.endEmitted)process.nextTick(s);else r.once("end",s);e.on("unpipe",onunpipe);function onunpipe(e,t){d("onunpipe");if(e===r){if(t&&t.hasUnpiped===false){t.hasUnpiped=true;cleanup()}}}function onend(){d("onend");e.end()}var o=pipeOnDrain(r);e.on("drain",o);var h=false;function cleanup(){d("cleanup");e.removeListener("close",onclose);e.removeListener("finish",onfinish);e.removeListener("drain",o);e.removeListener("error",onerror);e.removeListener("unpipe",onunpipe);r.removeListener("end",onend);r.removeListener("end",unpipe);r.removeListener("data",ondata);h=true;if(i.awaitDrain&&(!e._writableState||e._writableState.needDrain))o()}r.on("data",ondata);function ondata(t){d("ondata");var n=e.write(t);d("dest.write",n);if(n===false){if((i.pipesCount===1&&i.pipes===e||i.pipesCount>1&&indexOf(i.pipes,e)!==-1)&&!h){d("false write response, pause",i.awaitDrain);i.awaitDrain++}r.pause()}}function onerror(t){d("onerror",t);unpipe();e.removeListener("error",onerror);if(a(e,"error")===0)E(e,t)}prependListener(e,"error",onerror);function onclose(){e.removeListener("finish",onfinish);unpipe()}e.once("close",onclose);function onfinish(){d("onfinish");e.removeListener("close",onclose);unpipe()}e.once("finish",onfinish);function unpipe(){d("unpipe");r.unpipe(e)}e.emit("pipe",r);if(!i.flowing){d("pipe resume");r.resume()}return e};function pipeOnDrain(e){return function pipeOnDrainFunctionResult(){var t=e._readableState;d("pipeOnDrain",t.awaitDrain);if(t.awaitDrain)t.awaitDrain--;if(t.awaitDrain===0&&a(e,"data")){t.flowing=true;flow(e)}}}Readable.prototype.unpipe=function(e){var t=this._readableState;var r={hasUnpiped:false};if(t.pipesCount===0)return this;if(t.pipesCount===1){if(e&&e!==t.pipes)return this;if(!e)e=t.pipes;t.pipes=null;t.pipesCount=0;t.flowing=false;if(e)e.emit("unpipe",this,r);return this}if(!e){var i=t.pipes;var n=t.pipesCount;t.pipes=null;t.pipesCount=0;t.flowing=false;for(var a=0;a<n;a++){i[a].emit("unpipe",this,{hasUnpiped:false})}return this}var s=indexOf(t.pipes,e);if(s===-1)return this;t.pipes.splice(s,1);t.pipesCount-=1;if(t.pipesCount===1)t.pipes=t.pipes[0];e.emit("unpipe",this,r);return this};Readable.prototype.on=function(e,t){var r=s.prototype.on.call(this,e,t);var i=this._readableState;if(e==="data"){i.readableListening=this.listenerCount("readable")>0;if(i.flowing!==false)this.resume()}else if(e==="readable"){if(!i.endEmitted&&!i.readableListening){i.readableListening=i.needReadable=true;i.flowing=false;i.emittedReadable=false;d("on readable",i.length,i.reading);if(i.length){emitReadable(this)}else if(!i.reading){process.nextTick(nReadingNextTick,this)}}}return r};Readable.prototype.addListener=Readable.prototype.on;Readable.prototype.removeListener=function(e,t){var r=s.prototype.removeListener.call(this,e,t);if(e==="readable"){process.nextTick(updateReadableListening,this)}return r};Readable.prototype.removeAllListeners=function(e){var t=s.prototype.removeAllListeners.apply(this,arguments);if(e==="readable"||e===undefined){process.nextTick(updateReadableListening,this)}return t};function updateReadableListening(e){var t=e._readableState;t.readableListening=e.listenerCount("readable")>0;if(t.resumeScheduled&&!t.paused){t.flowing=true}else if(e.listenerCount("data")>0){e.resume()}}function nReadingNextTick(e){d("readable nexttick read 0");e.read(0)}Readable.prototype.resume=function(){var e=this._readableState;if(!e.flowing){d("resume");e.flowing=!e.readableListening;resume(this,e)}e.paused=false;return this};function resume(e,t){if(!t.resumeScheduled){t.resumeScheduled=true;process.nextTick(resume_,e,t)}}function resume_(e,t){d("resume",t.reading);if(!t.reading){e.read(0)}t.resumeScheduled=false;e.emit("resume");flow(e);if(t.flowing&&!t.reading)e.read(0)}Readable.prototype.pause=function(){d("call pause flowing=%j",this._readableState.flowing);if(this._readableState.flowing!==false){d("pause");this._readableState.flowing=false;this.emit("pause")}this._readableState.paused=true;return this};function flow(e){var t=e._readableState;d("flow",t.flowing);while(t.flowing&&e.read()!==null){}}Readable.prototype.wrap=function(e){var t=this;var r=this._readableState;var i=false;e.on("end",(function(){d("wrapped end");if(r.decoder&&!r.ended){var e=r.decoder.end();if(e&&e.length)t.push(e)}t.push(null)}));e.on("data",(function(n){d("wrapped data");if(r.decoder)n=r.decoder.write(n);if(r.objectMode&&(n===null||n===undefined))return;else if(!r.objectMode&&(!n||!n.length))return;var a=t.push(n);if(!a){i=true;e.pause()}}));for(var n in e){if(this[n]===undefined&&typeof e[n]==="function"){this[n]=function methodWrap(t){return function methodWrapReturnFunction(){return e[t].apply(e,arguments)}}(n)}}for(var a=0;a<k.length;a++){e.on(k[a],this.emit.bind(this,k[a]))}this._read=function(t){d("wrapped _read",t);if(i){i=false;e.resume()}};return this};if(typeof Symbol==="function"){Readable.prototype[Symbol.asyncIterator]=function(){if(M===undefined){M=r(6871)}return M(this)}}Object.defineProperty(Readable.prototype,"readableHighWaterMark",{enumerable:false,get:function get(){return this._readableState.highWaterMark}});Object.defineProperty(Readable.prototype,"readableBuffer",{enumerable:false,get:function get(){return this._readableState&&this._readableState.buffer}});Object.defineProperty(Readable.prototype,"readableFlowing",{enumerable:false,get:function get(){return this._readableState.flowing},set:function set(e){if(this._readableState){this._readableState.flowing=e}}});Readable._fromList=fromList;Object.defineProperty(Readable.prototype,"readableLength",{enumerable:false,get:function get(){return this._readableState.length}});function fromList(e,t){if(t.length===0)return null;var r;if(t.objectMode)r=t.buffer.shift();else if(!e||e>=t.length){if(t.decoder)r=t.buffer.join("");else if(t.buffer.length===1)r=t.buffer.first();else r=t.buffer.concat(t.length);t.buffer.clear()}else{r=t.buffer.consume(e,t.decoder)}return r}function endReadable(e){var t=e._readableState;d("endReadable",t.endEmitted);if(!t.endEmitted){t.ended=true;process.nextTick(endReadableNT,t,e)}}function endReadableNT(e,t){d("endReadableNT",e.endEmitted,e.length);if(!e.endEmitted&&e.length===0){e.endEmitted=true;t.readable=false;t.emit("end");if(e.autoDestroy){var r=t._writableState;if(!r||r.autoDestroy&&r.finished){t.destroy()}}}}if(typeof Symbol==="function"){Readable.from=function(e,t){if(B===undefined){B=r(9727)}return B(Readable,e,t)}}function indexOf(e,t){for(var r=0,i=e.length;r<i;r++){if(e[r]===t)return r}return-1}},1170:function(e,t,r){"use strict";e.exports=Transform;var i=r(4646).q,n=i.ERR_METHOD_NOT_IMPLEMENTED,a=i.ERR_MULTIPLE_CALLBACK,s=i.ERR_TRANSFORM_ALREADY_TRANSFORMING,o=i.ERR_TRANSFORM_WITH_LENGTH_0;var h=r(2403);r(3782)(Transform,h);function afterTransform(e,t){var r=this._transformState;r.transforming=false;var i=r.writecb;if(i===null){return this.emit("error",new a)}r.writechunk=null;r.writecb=null;if(t!=null)this.push(t);i(e);var n=this._readableState;n.reading=false;if(n.needReadable||n.length<n.highWaterMark){this._read(n.highWaterMark)}}function Transform(e){if(!(this instanceof Transform))return new Transform(e);h.call(this,e);this._transformState={afterTransform:afterTransform.bind(this),needTransform:false,transforming:false,writecb:null,writechunk:null,writeencoding:null};this._readableState.needReadable=true;this._readableState.sync=false;if(e){if(typeof e.transform==="function")this._transform=e.transform;if(typeof e.flush==="function")this._flush=e.flush}this.on("prefinish",prefinish)}function prefinish(){var e=this;if(typeof this._flush==="function"&&!this._readableState.destroyed){this._flush((function(t,r){done(e,t,r)}))}else{done(this,null,null)}}Transform.prototype.push=function(e,t){this._transformState.needTransform=false;return h.prototype.push.call(this,e,t)};Transform.prototype._transform=function(e,t,r){r(new n("_transform()"))};Transform.prototype._write=function(e,t,r){var i=this._transformState;i.writecb=r;i.writechunk=e;i.writeencoding=t;if(!i.transforming){var n=this._readableState;if(i.needTransform||n.needReadable||n.length<n.highWaterMark)this._read(n.highWaterMark)}};Transform.prototype._read=function(e){var t=this._transformState;if(t.writechunk!==null&&!t.transforming){t.transforming=true;this._transform(t.writechunk,t.writeencoding,t.afterTransform)}else{t.needTransform=true}};Transform.prototype._destroy=function(e,t){h.prototype._destroy.call(this,e,(function(e){t(e)}))};function done(e,t,r){if(t)return e.emit("error",t);if(r!=null)e.push(r);if(e._writableState.length)throw new o;if(e._transformState.transforming)throw new s;return e.push(null)}},7337:function(e,t,r){"use strict";e.exports=Writable;function WriteReq(e,t,r){this.chunk=e;this.encoding=t;this.callback=r;this.next=null}function CorkedRequest(e){var t=this;this.next=null;this.entry=null;this.finish=function(){onCorkedFinish(t,e)}}var i;Writable.WritableState=WritableState;var n={deprecate:r(6769)};var a=r(4678);var s=r(4300).Buffer;var o=__webpack_require__.g.Uint8Array||function(){};function _uint8ArrayToBuffer(e){return s.from(e)}function _isUint8Array(e){return s.isBuffer(e)||e instanceof o}var h=r(7025);var u=r(6776),d=u.getHighWaterMark;var c=r(4646).q,l=c.ERR_INVALID_ARG_TYPE,p=c.ERR_METHOD_NOT_IMPLEMENTED,v=c.ERR_MULTIPLE_CALLBACK,b=c.ERR_STREAM_CANNOT_PIPE,m=c.ERR_STREAM_DESTROYED,y=c.ERR_STREAM_NULL_VALUES,g=c.ERR_STREAM_WRITE_AFTER_END,_=c.ERR_UNKNOWN_ENCODING;var w=h.errorOrDestroy;r(3782)(Writable,a);function nop(){}function WritableState(e,t,n){i=i||r(2403);e=e||{};if(typeof n!=="boolean")n=t instanceof i;this.objectMode=!!e.objectMode;if(n)this.objectMode=this.objectMode||!!e.writableObjectMode;this.highWaterMark=d(this,e,"writableHighWaterMark",n);this.finalCalled=false;this.needDrain=false;this.ending=false;this.ended=false;this.finished=false;this.destroyed=false;var a=e.decodeStrings===false;this.decodeStrings=!a;this.defaultEncoding=e.defaultEncoding||"utf8";this.length=0;this.writing=false;this.corked=0;this.sync=true;this.bufferProcessing=false;this.onwrite=function(e){onwrite(t,e)};this.writecb=null;this.writelen=0;this.bufferedRequest=null;this.lastBufferedRequest=null;this.pendingcb=0;this.prefinished=false;this.errorEmitted=false;this.emitClose=e.emitClose!==false;this.autoDestroy=!!e.autoDestroy;this.bufferedRequestCount=0;this.corkedRequestsFree=new CorkedRequest(this)}WritableState.prototype.getBuffer=function getBuffer(){var e=this.bufferedRequest;var t=[];while(e){t.push(e);e=e.next}return t};(function(){try{Object.defineProperty(WritableState.prototype,"buffer",{get:n.deprecate((function writableStateBufferGetter(){return this.getBuffer()}),"_writableState.buffer is deprecated. Use _writableState.getBuffer "+"instead.","DEP0003")})}catch(e){}})();var M;if(typeof Symbol==="function"&&Symbol.hasInstance&&typeof Function.prototype[Symbol.hasInstance]==="function"){M=Function.prototype[Symbol.hasInstance];Object.defineProperty(Writable,Symbol.hasInstance,{value:function value(e){if(M.call(this,e))return true;if(this!==Writable)return false;return e&&e._writableState instanceof WritableState}})}else{M=function realHasInstance(e){return e instanceof this}}function Writable(e){i=i||r(2403);var t=this instanceof i;if(!t&&!M.call(Writable,this))return new Writable(e);this._writableState=new WritableState(e,this,t);this.writable=true;if(e){if(typeof e.write==="function")this._write=e.write;if(typeof e.writev==="function")this._writev=e.writev;if(typeof e.destroy==="function")this._destroy=e.destroy;if(typeof e.final==="function")this._final=e.final}a.call(this)}Writable.prototype.pipe=function(){w(this,new b)};function writeAfterEnd(e,t){var r=new g;w(e,r);process.nextTick(t,r)}function validChunk(e,t,r,i){var n;if(r===null){n=new y}else if(typeof r!=="string"&&!t.objectMode){n=new l("chunk",["string","Buffer"],r)}if(n){w(e,n);process.nextTick(i,n);return false}return true}Writable.prototype.write=function(e,t,r){var i=this._writableState;var n=false;var a=!i.objectMode&&_isUint8Array(e);if(a&&!s.isBuffer(e)){e=_uint8ArrayToBuffer(e)}if(typeof t==="function"){r=t;t=null}if(a)t="buffer";else if(!t)t=i.defaultEncoding;if(typeof r!=="function")r=nop;if(i.ending)writeAfterEnd(this,r);else if(a||validChunk(this,i,e,r)){i.pendingcb++;n=writeOrBuffer(this,i,a,e,t,r)}return n};Writable.prototype.cork=function(){this._writableState.corked++};Writable.prototype.uncork=function(){var e=this._writableState;if(e.corked){e.corked--;if(!e.writing&&!e.corked&&!e.bufferProcessing&&e.bufferedRequest)clearBuffer(this,e)}};Writable.prototype.setDefaultEncoding=function setDefaultEncoding(e){if(typeof e==="string")e=e.toLowerCase();if(!(["hex","utf8","utf-8","ascii","binary","base64","ucs2","ucs-2","utf16le","utf-16le","raw"].indexOf((e+"").toLowerCase())>-1))throw new _(e);this._writableState.defaultEncoding=e;return this};Object.defineProperty(Writable.prototype,"writableBuffer",{enumerable:false,get:function get(){return this._writableState&&this._writableState.getBuffer()}});function decodeChunk(e,t,r){if(!e.objectMode&&e.decodeStrings!==false&&typeof t==="string"){t=s.from(t,r)}return t}Object.defineProperty(Writable.prototype,"writableHighWaterMark",{enumerable:false,get:function get(){return this._writableState.highWaterMark}});function writeOrBuffer(e,t,r,i,n,a){if(!r){var s=decodeChunk(t,i,n);if(i!==s){r=true;n="buffer";i=s}}var o=t.objectMode?1:i.length;t.length+=o;var h=t.length<t.highWaterMark;if(!h)t.needDrain=true;if(t.writing||t.corked){var u=t.lastBufferedRequest;t.lastBufferedRequest={chunk:i,encoding:n,isBuf:r,callback:a,next:null};if(u){u.next=t.lastBufferedRequest}else{t.bufferedRequest=t.lastBufferedRequest}t.bufferedRequestCount+=1}else{doWrite(e,t,false,o,i,n,a)}return h}function doWrite(e,t,r,i,n,a,s){t.writelen=i;t.writecb=s;t.writing=true;t.sync=true;if(t.destroyed)t.onwrite(new m("write"));else if(r)e._writev(n,t.onwrite);else e._write(n,a,t.onwrite);t.sync=false}function onwriteError(e,t,r,i,n){--t.pendingcb;if(r){process.nextTick(n,i);process.nextTick(finishMaybe,e,t);e._writableState.errorEmitted=true;w(e,i)}else{n(i);e._writableState.errorEmitted=true;w(e,i);finishMaybe(e,t)}}function onwriteStateUpdate(e){e.writing=false;e.writecb=null;e.length-=e.writelen;e.writelen=0}function onwrite(e,t){var r=e._writableState;var i=r.sync;var n=r.writecb;if(typeof n!=="function")throw new v;onwriteStateUpdate(r);if(t)onwriteError(e,r,i,t,n);else{var a=needFinish(r)||e.destroyed;if(!a&&!r.corked&&!r.bufferProcessing&&r.bufferedRequest){clearBuffer(e,r)}if(i){process.nextTick(afterWrite,e,r,a,n)}else{afterWrite(e,r,a,n)}}}function afterWrite(e,t,r,i){if(!r)onwriteDrain(e,t);t.pendingcb--;i();finishMaybe(e,t)}function onwriteDrain(e,t){if(t.length===0&&t.needDrain){t.needDrain=false;e.emit("drain")}}function clearBuffer(e,t){t.bufferProcessing=true;var r=t.bufferedRequest;if(e._writev&&r&&r.next){var i=t.bufferedRequestCount;var n=new Array(i);var a=t.corkedRequestsFree;a.entry=r;var s=0;var o=true;while(r){n[s]=r;if(!r.isBuf)o=false;r=r.next;s+=1}n.allBuffers=o;doWrite(e,t,true,t.length,n,"",a.finish);t.pendingcb++;t.lastBufferedRequest=null;if(a.next){t.corkedRequestsFree=a.next;a.next=null}else{t.corkedRequestsFree=new CorkedRequest(t)}t.bufferedRequestCount=0}else{while(r){var h=r.chunk;var u=r.encoding;var d=r.callback;var c=t.objectMode?1:h.length;doWrite(e,t,false,c,h,u,d);r=r.next;t.bufferedRequestCount--;if(t.writing){break}}if(r===null)t.lastBufferedRequest=null}t.bufferedRequest=r;t.bufferProcessing=false}Writable.prototype._write=function(e,t,r){r(new p("_write()"))};Writable.prototype._writev=null;Writable.prototype.end=function(e,t,r){var i=this._writableState;if(typeof e==="function"){r=e;e=null;t=null}else if(typeof t==="function"){r=t;t=null}if(e!==null&&e!==undefined)this.write(e,t);if(i.corked){i.corked=1;this.uncork()}if(!i.ending)endWritable(this,i,r);return this};Object.defineProperty(Writable.prototype,"writableLength",{enumerable:false,get:function get(){return this._writableState.length}});function needFinish(e){return e.ending&&e.length===0&&e.bufferedRequest===null&&!e.finished&&!e.writing}function callFinal(e,t){e._final((function(r){t.pendingcb--;if(r){w(e,r)}t.prefinished=true;e.emit("prefinish");finishMaybe(e,t)}))}function prefinish(e,t){if(!t.prefinished&&!t.finalCalled){if(typeof e._final==="function"&&!t.destroyed){t.pendingcb++;t.finalCalled=true;process.nextTick(callFinal,e,t)}else{t.prefinished=true;e.emit("prefinish")}}}function finishMaybe(e,t){var r=needFinish(t);if(r){prefinish(e,t);if(t.pendingcb===0){t.finished=true;e.emit("finish");if(t.autoDestroy){var i=e._readableState;if(!i||i.autoDestroy&&i.endEmitted){e.destroy()}}}}return r}function endWritable(e,t,r){t.ending=true;finishMaybe(e,t);if(r){if(t.finished)process.nextTick(r);else e.once("finish",r)}t.ended=true;e.writable=false}function onCorkedFinish(e,t,r){var i=e.entry;e.entry=null;while(i){var n=i.callback;t.pendingcb--;n(r);i=i.next}t.corkedRequestsFree.next=e}Object.defineProperty(Writable.prototype,"destroyed",{enumerable:false,get:function get(){if(this._writableState===undefined){return false}return this._writableState.destroyed},set:function set(e){if(!this._writableState){return}this._writableState.destroyed=e}});Writable.prototype.destroy=h.destroy;Writable.prototype._undestroy=h.undestroy;Writable.prototype._destroy=function(e,t){t(e)}},6871:function(e,t,r){"use strict";var i;function _defineProperty(e,t,r){if(t in e){Object.defineProperty(e,t,{value:r,enumerable:true,configurable:true,writable:true})}else{e[t]=r}return e}var n=r(9698);var a=Symbol("lastResolve");var s=Symbol("lastReject");var o=Symbol("error");var h=Symbol("ended");var u=Symbol("lastPromise");var d=Symbol("handlePromise");var c=Symbol("stream");function createIterResult(e,t){return{value:e,done:t}}function readAndResolve(e){var t=e[a];if(t!==null){var r=e[c].read();if(r!==null){e[u]=null;e[a]=null;e[s]=null;t(createIterResult(r,false))}}}function onReadable(e){process.nextTick(readAndResolve,e)}function wrapForNext(e,t){return function(r,i){e.then((function(){if(t[h]){r(createIterResult(undefined,true));return}t[d](r,i)}),i)}}var l=Object.getPrototypeOf((function(){}));var p=Object.setPrototypeOf((i={get stream(){return this[c]},next:function next(){var e=this;var t=this[o];if(t!==null){return Promise.reject(t)}if(this[h]){return Promise.resolve(createIterResult(undefined,true))}if(this[c].destroyed){return new Promise((function(t,r){process.nextTick((function(){if(e[o]){r(e[o])}else{t(createIterResult(undefined,true))}}))}))}var r=this[u];var i;if(r){i=new Promise(wrapForNext(r,this))}else{var n=this[c].read();if(n!==null){return Promise.resolve(createIterResult(n,false))}i=new Promise(this[d])}this[u]=i;return i}},_defineProperty(i,Symbol.asyncIterator,(function(){return this})),_defineProperty(i,"return",(function _return(){var e=this;return new Promise((function(t,r){e[c].destroy(null,(function(e){if(e){r(e);return}t(createIterResult(undefined,true))}))}))})),i),l);var v=function createReadableStreamAsyncIterator(e){var t;var r=Object.create(p,(t={},_defineProperty(t,c,{value:e,writable:true}),_defineProperty(t,a,{value:null,writable:true}),_defineProperty(t,s,{value:null,writable:true}),_defineProperty(t,o,{value:null,writable:true}),_defineProperty(t,h,{value:e._readableState.endEmitted,writable:true}),_defineProperty(t,d,{value:function value(e,t){var i=r[c].read();if(i){r[u]=null;r[a]=null;r[s]=null;e(createIterResult(i,false))}else{r[a]=e;r[s]=t}},writable:true}),t));r[u]=null;n(e,(function(e){if(e&&e.code!=="ERR_STREAM_PREMATURE_CLOSE"){var t=r[s];if(t!==null){r[u]=null;r[a]=null;r[s]=null;t(e)}r[o]=e;return}var i=r[a];if(i!==null){r[u]=null;r[a]=null;r[s]=null;i(createIterResult(undefined,true))}r[h]=true}));e.on("readable",onReadable.bind(null,r));return r};e.exports=v},4379:function(e,t,r){"use strict";function ownKeys(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);if(t)i=i.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}));r.push.apply(r,i)}return r}function _objectSpread(e){for(var t=1;t<arguments.length;t++){var r=arguments[t]!=null?arguments[t]:{};if(t%2){ownKeys(Object(r),true).forEach((function(t){_defineProperty(e,t,r[t])}))}else if(Object.getOwnPropertyDescriptors){Object.defineProperties(e,Object.getOwnPropertyDescriptors(r))}else{ownKeys(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))}))}}return e}function _defineProperty(e,t,r){if(t in e){Object.defineProperty(e,t,{value:r,enumerable:true,configurable:true,writable:true})}else{e[t]=r}return e}function _classCallCheck(e,t){if(!(e instanceof t)){throw new TypeError("Cannot call a class as a function")}}function _defineProperties(e,t){for(var r=0;r<t.length;r++){var i=t[r];i.enumerable=i.enumerable||false;i.configurable=true;if("value"in i)i.writable=true;Object.defineProperty(e,i.key,i)}}function _createClass(e,t,r){if(t)_defineProperties(e.prototype,t);if(r)_defineProperties(e,r);return e}var i=r(4300),n=i.Buffer;var a=r(3837),s=a.inspect;var o=s&&s.custom||"inspect";function copyBuffer(e,t,r){n.prototype.copy.call(e,t,r)}e.exports=function(){function BufferList(){_classCallCheck(this,BufferList);this.head=null;this.tail=null;this.length=0}_createClass(BufferList,[{key:"push",value:function push(e){var t={data:e,next:null};if(this.length>0)this.tail.next=t;else this.head=t;this.tail=t;++this.length}},{key:"unshift",value:function unshift(e){var t={data:e,next:this.head};if(this.length===0)this.tail=t;this.head=t;++this.length}},{key:"shift",value:function shift(){if(this.length===0)return;var e=this.head.data;if(this.length===1)this.head=this.tail=null;else this.head=this.head.next;--this.length;return e}},{key:"clear",value:function clear(){this.head=this.tail=null;this.length=0}},{key:"join",value:function join(e){if(this.length===0)return"";var t=this.head;var r=""+t.data;while(t=t.next){r+=e+t.data}return r}},{key:"concat",value:function concat(e){if(this.length===0)return n.alloc(0);var t=n.allocUnsafe(e>>>0);var r=this.head;var i=0;while(r){copyBuffer(r.data,t,i);i+=r.data.length;r=r.next}return t}},{key:"consume",value:function consume(e,t){var r;if(e<this.head.data.length){r=this.head.data.slice(0,e);this.head.data=this.head.data.slice(e)}else if(e===this.head.data.length){r=this.shift()}else{r=t?this._getString(e):this._getBuffer(e)}return r}},{key:"first",value:function first(){return this.head.data}},{key:"_getString",value:function _getString(e){var t=this.head;var r=1;var i=t.data;e-=i.length;while(t=t.next){var n=t.data;var a=e>n.length?n.length:e;if(a===n.length)i+=n;else i+=n.slice(0,e);e-=a;if(e===0){if(a===n.length){++r;if(t.next)this.head=t.next;else this.head=this.tail=null}else{this.head=t;t.data=n.slice(a)}break}++r}this.length-=r;return i}},{key:"_getBuffer",value:function _getBuffer(e){var t=n.allocUnsafe(e);var r=this.head;var i=1;r.data.copy(t);e-=r.data.length;while(r=r.next){var a=r.data;var s=e>a.length?a.length:e;a.copy(t,t.length-e,0,s);e-=s;if(e===0){if(s===a.length){++i;if(r.next)this.head=r.next;else this.head=this.tail=null}else{this.head=r;r.data=a.slice(s)}break}++i}this.length-=i;return t}},{key:o,value:function value(e,t){return s(this,_objectSpread({},t,{depth:0,customInspect:false}))}}]);return BufferList}()},7025:function(e){"use strict";function destroy(e,t){var r=this;var i=this._readableState&&this._readableState.destroyed;var n=this._writableState&&this._writableState.destroyed;if(i||n){if(t){t(e)}else if(e){if(!this._writableState){process.nextTick(emitErrorNT,this,e)}else if(!this._writableState.errorEmitted){this._writableState.errorEmitted=true;process.nextTick(emitErrorNT,this,e)}}return this}if(this._readableState){this._readableState.destroyed=true}if(this._writableState){this._writableState.destroyed=true}this._destroy(e||null,(function(e){if(!t&&e){if(!r._writableState){process.nextTick(emitErrorAndCloseNT,r,e)}else if(!r._writableState.errorEmitted){r._writableState.errorEmitted=true;process.nextTick(emitErrorAndCloseNT,r,e)}else{process.nextTick(emitCloseNT,r)}}else if(t){process.nextTick(emitCloseNT,r);t(e)}else{process.nextTick(emitCloseNT,r)}}));return this}function emitErrorAndCloseNT(e,t){emitErrorNT(e,t);emitCloseNT(e)}function emitCloseNT(e){if(e._writableState&&!e._writableState.emitClose)return;if(e._readableState&&!e._readableState.emitClose)return;e.emit("close")}function undestroy(){if(this._readableState){this._readableState.destroyed=false;this._readableState.reading=false;this._readableState.ended=false;this._readableState.endEmitted=false}if(this._writableState){this._writableState.destroyed=false;this._writableState.ended=false;this._writableState.ending=false;this._writableState.finalCalled=false;this._writableState.prefinished=false;this._writableState.finished=false;this._writableState.errorEmitted=false}}function emitErrorNT(e,t){e.emit("error",t)}function errorOrDestroy(e,t){var r=e._readableState;var i=e._writableState;if(r&&r.autoDestroy||i&&i.autoDestroy)e.destroy(t);else e.emit("error",t)}e.exports={destroy:destroy,undestroy:undestroy,errorOrDestroy:errorOrDestroy}},9698:function(e,t,r){"use strict";var i=r(4646).q.ERR_STREAM_PREMATURE_CLOSE;function once(e){var t=false;return function(){if(t)return;t=true;for(var r=arguments.length,i=new Array(r),n=0;n<r;n++){i[n]=arguments[n]}e.apply(this,i)}}function noop(){}function isRequest(e){return e.setHeader&&typeof e.abort==="function"}function eos(e,t,r){if(typeof t==="function")return eos(e,null,t);if(!t)t={};r=once(r||noop);var n=t.readable||t.readable!==false&&e.readable;var a=t.writable||t.writable!==false&&e.writable;var s=function onlegacyfinish(){if(!e.writable)h()};var o=e._writableState&&e._writableState.finished;var h=function onfinish(){a=false;o=true;if(!n)r.call(e)};var u=e._readableState&&e._readableState.endEmitted;var d=function onend(){n=false;u=true;if(!a)r.call(e)};var c=function onerror(t){r.call(e,t)};var l=function onclose(){var t;if(n&&!u){if(!e._readableState||!e._readableState.ended)t=new i;return r.call(e,t)}if(a&&!o){if(!e._writableState||!e._writableState.ended)t=new i;return r.call(e,t)}};var p=function onrequest(){e.req.on("finish",h)};if(isRequest(e)){e.on("complete",h);e.on("abort",l);if(e.req)p();else e.on("request",p)}else if(a&&!e._writableState){e.on("end",s);e.on("close",s)}e.on("end",d);e.on("finish",h);if(t.error!==false)e.on("error",c);e.on("close",l);return function(){e.removeListener("complete",h);e.removeListener("abort",l);e.removeListener("request",p);if(e.req)e.req.removeListener("finish",h);e.removeListener("end",s);e.removeListener("close",s);e.removeListener("finish",h);e.removeListener("end",d);e.removeListener("error",c);e.removeListener("close",l)}}e.exports=eos},9727:function(e,t,r){"use strict";function asyncGeneratorStep(e,t,r,i,n,a,s){try{var o=e[a](s);var h=o.value}catch(e){r(e);return}if(o.done){t(h)}else{Promise.resolve(h).then(i,n)}}function _asyncToGenerator(e){return function(){var t=this,r=arguments;return new Promise((function(i,n){var a=e.apply(t,r);function _next(e){asyncGeneratorStep(a,i,n,_next,_throw,"next",e)}function _throw(e){asyncGeneratorStep(a,i,n,_next,_throw,"throw",e)}_next(undefined)}))}}function ownKeys(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);if(t)i=i.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}));r.push.apply(r,i)}return r}function _objectSpread(e){for(var t=1;t<arguments.length;t++){var r=arguments[t]!=null?arguments[t]:{};if(t%2){ownKeys(Object(r),true).forEach((function(t){_defineProperty(e,t,r[t])}))}else if(Object.getOwnPropertyDescriptors){Object.defineProperties(e,Object.getOwnPropertyDescriptors(r))}else{ownKeys(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))}))}}return e}function _defineProperty(e,t,r){if(t in e){Object.defineProperty(e,t,{value:r,enumerable:true,configurable:true,writable:true})}else{e[t]=r}return e}var i=r(4646).q.ERR_INVALID_ARG_TYPE;function from(e,t,r){var n;if(t&&typeof t.next==="function"){n=t}else if(t&&t[Symbol.asyncIterator])n=t[Symbol.asyncIterator]();else if(t&&t[Symbol.iterator])n=t[Symbol.iterator]();else throw new i("iterable",["Iterable"],t);var a=new e(_objectSpread({objectMode:true},r));var s=false;a._read=function(){if(!s){s=true;next()}};function next(){return _next2.apply(this,arguments)}function _next2(){_next2=_asyncToGenerator((function*(){try{var e=yield n.next(),t=e.value,r=e.done;if(r){a.push(null)}else if(a.push(yield t)){next()}else{s=false}}catch(e){a.destroy(e)}}));return _next2.apply(this,arguments)}return a}e.exports=from},8442:function(e,t,r){"use strict";var i;function once(e){var t=false;return function(){if(t)return;t=true;e.apply(void 0,arguments)}}var n=r(4646).q,a=n.ERR_MISSING_ARGS,s=n.ERR_STREAM_DESTROYED;function noop(e){if(e)throw e}function isRequest(e){return e.setHeader&&typeof e.abort==="function"}function destroyer(e,t,n,a){a=once(a);var o=false;e.on("close",(function(){o=true}));if(i===undefined)i=r(9698);i(e,{readable:t,writable:n},(function(e){if(e)return a(e);o=true;a()}));var h=false;return function(t){if(o)return;if(h)return;h=true;if(isRequest(e))return e.abort();if(typeof e.destroy==="function")return e.destroy();a(t||new s("pipe"))}}function call(e){e()}function pipe(e,t){return e.pipe(t)}function popCallback(e){if(!e.length)return noop;if(typeof e[e.length-1]!=="function")return noop;return e.pop()}function pipeline(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++){t[r]=arguments[r]}var i=popCallback(t);if(Array.isArray(t[0]))t=t[0];if(t.length<2){throw new a("streams")}var n;var s=t.map((function(e,r){var a=r<t.length-1;var o=r>0;return destroyer(e,a,o,(function(e){if(!n)n=e;if(e)s.forEach(call);if(a)return;s.forEach(call);i(n)}))}));return t.reduce(pipe)}e.exports=pipeline},6776:function(e,t,r){"use strict";var i=r(4646).q.ERR_INVALID_OPT_VALUE;function highWaterMarkFrom(e,t,r){return e.highWaterMark!=null?e.highWaterMark:t?e[r]:null}function getHighWaterMark(e,t,r,n){var a=highWaterMarkFrom(t,n,r);if(a!=null){if(!(isFinite(a)&&Math.floor(a)===a)||a<0){var s=n?r:"highWaterMark";throw new i(s,a)}return Math.floor(a)}return e.objectMode?16:16*1024}e.exports={getHighWaterMark:getHighWaterMark}},4678:function(e,t,r){e.exports=r(2781)},3726:function(e,t,r){var i=r(2781);if(process.env.READABLE_STREAM==="disable"&&i){e.exports=i.Readable;Object.assign(e.exports,i);e.exports.Stream=i}else{t=e.exports=r(1709);t.Stream=i||t;t.Readable=t;t.Writable=r(7337);t.Duplex=r(2403);t.Transform=r(1170);t.PassThrough=r(7889);t.finished=r(9698);t.pipeline=r(8442)}},3225:function(e,t,r){"use strict";var i=r(4300).Buffer;var n=r(3782);var a=r(9029);var s=new Array(16);var o=[0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,7,4,13,1,10,6,15,3,12,0,9,5,2,14,11,8,3,10,14,4,9,15,8,1,2,7,0,6,13,11,5,12,1,9,11,10,0,8,12,4,13,3,7,15,14,5,6,2,4,0,5,9,7,12,2,10,14,1,3,8,11,6,15,13];var h=[5,14,7,0,9,2,11,4,13,6,15,8,1,10,3,12,6,11,3,7,0,13,5,10,14,15,8,12,4,9,1,2,15,5,1,3,7,14,6,9,11,8,12,2,10,0,4,13,8,6,4,1,3,11,15,0,5,12,2,13,9,7,10,14,12,15,10,4,1,5,8,7,6,2,13,14,0,3,9,11];var u=[11,14,15,12,5,8,7,9,11,13,14,15,6,7,9,8,7,6,8,13,11,9,7,15,7,12,15,9,11,7,13,12,11,13,6,7,14,9,13,15,14,8,13,6,5,12,7,5,11,12,14,15,14,15,9,8,9,14,5,6,8,6,5,12,9,15,5,11,6,8,13,12,5,12,13,14,11,8,5,6];var d=[8,9,9,11,13,15,15,5,7,7,8,11,14,14,12,6,9,13,15,7,12,8,9,11,7,7,12,7,6,15,13,11,9,7,15,11,8,6,6,14,12,13,5,14,13,13,7,5,15,5,8,11,14,14,6,14,6,9,12,9,12,5,15,8,8,5,12,9,12,5,14,6,8,13,6,5,15,13,11,11];var c=[0,1518500249,1859775393,2400959708,2840853838];var l=[1352829926,1548603684,1836072691,2053994217,0];function RIPEMD160(){a.call(this,64);this._a=1732584193;this._b=4023233417;this._c=2562383102;this._d=271733878;this._e=3285377520}n(RIPEMD160,a);RIPEMD160.prototype._update=function(){var e=s;for(var t=0;t<16;++t)e[t]=this._block.readInt32LE(t*4);var r=this._a|0;var i=this._b|0;var n=this._c|0;var a=this._d|0;var p=this._e|0;var v=this._a|0;var b=this._b|0;var m=this._c|0;var y=this._d|0;var g=this._e|0;for(var _=0;_<80;_+=1){var w;var M;if(_<16){w=fn1(r,i,n,a,p,e[o[_]],c[0],u[_]);M=fn5(v,b,m,y,g,e[h[_]],l[0],d[_])}else if(_<32){w=fn2(r,i,n,a,p,e[o[_]],c[1],u[_]);M=fn4(v,b,m,y,g,e[h[_]],l[1],d[_])}else if(_<48){w=fn3(r,i,n,a,p,e[o[_]],c[2],u[_]);M=fn3(v,b,m,y,g,e[h[_]],l[2],d[_])}else if(_<64){w=fn4(r,i,n,a,p,e[o[_]],c[3],u[_]);M=fn2(v,b,m,y,g,e[h[_]],l[3],d[_])}else{w=fn5(r,i,n,a,p,e[o[_]],c[4],u[_]);M=fn1(v,b,m,y,g,e[h[_]],l[4],d[_])}r=p;p=a;a=rotl(n,10);n=i;i=w;v=g;g=y;y=rotl(m,10);m=b;b=M}var B=this._b+n+y|0;this._b=this._c+a+g|0;this._c=this._d+p+v|0;this._d=this._e+r+b|0;this._e=this._a+i+m|0;this._a=B};RIPEMD160.prototype._digest=function(){this._block[this._blockOffset++]=128;if(this._blockOffset>56){this._block.fill(0,this._blockOffset,64);this._update();this._blockOffset=0}this._block.fill(0,this._blockOffset,56);this._block.writeUInt32LE(this._length[0],56);this._block.writeUInt32LE(this._length[1],60);this._update();var e=i.alloc?i.alloc(20):new i(20);e.writeInt32LE(this._a,0);e.writeInt32LE(this._b,4);e.writeInt32LE(this._c,8);e.writeInt32LE(this._d,12);e.writeInt32LE(this._e,16);return e};function rotl(e,t){return e<<t|e>>>32-t}function fn1(e,t,r,i,n,a,s,o){return rotl(e+(t^r^i)+a+s|0,o)+n|0}function fn2(e,t,r,i,n,a,s,o){return rotl(e+(t&r|~t&i)+a+s|0,o)+n|0}function fn3(e,t,r,i,n,a,s,o){return rotl(e+((t|~r)^i)+a+s|0,o)+n|0}function fn4(e,t,r,i,n,a,s,o){return rotl(e+(t&i|r&~i)+a+s|0,o)+n|0}function fn5(e,t,r,i,n,a,s,o){return rotl(e+(t^(r|~i))+a+s|0,o)+n|0}e.exports=RIPEMD160},5055:function(e,t,r){var i=r(4300);var n=i.Buffer;function copyProps(e,t){for(var r in e){t[r]=e[r]}}if(n.from&&n.alloc&&n.allocUnsafe&&n.allocUnsafeSlow){e.exports=i}else{copyProps(i,t);t.Buffer=SafeBuffer}function SafeBuffer(e,t,r){return n(e,t,r)}SafeBuffer.prototype=Object.create(n.prototype);copyProps(n,SafeBuffer);SafeBuffer.from=function(e,t,r){if(typeof e==="number"){throw new TypeError("Argument must not be a number")}return n(e,t,r)};SafeBuffer.alloc=function(e,t,r){if(typeof e!=="number"){throw new TypeError("Argument must be a number")}var i=n(e);if(t!==undefined){if(typeof r==="string"){i.fill(t,r)}else{i.fill(t)}}else{i.fill(0)}return i};SafeBuffer.allocUnsafe=function(e){if(typeof e!=="number"){throw new TypeError("Argument must be a number")}return n(e)};SafeBuffer.allocUnsafeSlow=function(e){if(typeof e!=="number"){throw new TypeError("Argument must be a number")}return i.SlowBuffer(e)}},2858:function(e,t,r){var i=r(5055).Buffer;function Hash(e,t){this._block=i.alloc(e);this._finalSize=t;this._blockSize=e;this._len=0}Hash.prototype.update=function(e,t){if(typeof e==="string"){t=t||"utf8";e=i.from(e,t)}var r=this._block;var n=this._blockSize;var a=e.length;var s=this._len;for(var o=0;o<a;){var h=s%n;var u=Math.min(a-o,n-h);for(var d=0;d<u;d++){r[h+d]=e[o+d]}s+=u;o+=u;if(s%n===0){this._update(r)}}this._len+=a;return this};Hash.prototype.digest=function(e){var t=this._len%this._blockSize;this._block[t]=128;this._block.fill(0,t+1);if(t>=this._finalSize){this._update(this._block);this._block.fill(0)}var r=this._len*8;if(r<=4294967295){this._block.writeUInt32BE(r,this._blockSize-4)}else{var i=(r&4294967295)>>>0;var n=(r-i)/4294967296;this._block.writeUInt32BE(n,this._blockSize-8);this._block.writeUInt32BE(i,this._blockSize-4)}this._update(this._block);var a=this._hash();return e?a.toString(e):a};Hash.prototype._update=function(){throw new Error("_update must be implemented by subclass")};e.exports=Hash},4371:function(e,t,r){var i=e.exports=function SHA(e){e=e.toLowerCase();var t=i[e];if(!t)throw new Error(e+" is not supported (we accept pull requests)");return new t};i.sha=r(4018);i.sha1=r(4179);i.sha224=r(532);i.sha256=r(1843);i.sha384=r(7455);i.sha512=r(9934)},4018:function(e,t,r){var i=r(3782);var n=r(2858);var a=r(5055).Buffer;var s=[1518500249,1859775393,2400959708|0,3395469782|0];var o=new Array(80);function Sha(){this.init();this._w=o;n.call(this,64,56)}i(Sha,n);Sha.prototype.init=function(){this._a=1732584193;this._b=4023233417;this._c=2562383102;this._d=271733878;this._e=3285377520;return this};function rotl5(e){return e<<5|e>>>27}function rotl30(e){return e<<30|e>>>2}function ft(e,t,r,i){if(e===0)return t&r|~t&i;if(e===2)return t&r|t&i|r&i;return t^r^i}Sha.prototype._update=function(e){var t=this._w;var r=this._a|0;var i=this._b|0;var n=this._c|0;var a=this._d|0;var o=this._e|0;for(var h=0;h<16;++h)t[h]=e.readInt32BE(h*4);for(;h<80;++h)t[h]=t[h-3]^t[h-8]^t[h-14]^t[h-16];for(var u=0;u<80;++u){var d=~~(u/20);var c=rotl5(r)+ft(d,i,n,a)+o+t[u]+s[d]|0;o=a;a=n;n=rotl30(i);i=r;r=c}this._a=r+this._a|0;this._b=i+this._b|0;this._c=n+this._c|0;this._d=a+this._d|0;this._e=o+this._e|0};Sha.prototype._hash=function(){var e=a.allocUnsafe(20);e.writeInt32BE(this._a|0,0);e.writeInt32BE(this._b|0,4);e.writeInt32BE(this._c|0,8);e.writeInt32BE(this._d|0,12);e.writeInt32BE(this._e|0,16);return e};e.exports=Sha},4179:function(e,t,r){var i=r(3782);var n=r(2858);var a=r(5055).Buffer;var s=[1518500249,1859775393,2400959708|0,3395469782|0];var o=new Array(80);function Sha1(){this.init();this._w=o;n.call(this,64,56)}i(Sha1,n);Sha1.prototype.init=function(){this._a=1732584193;this._b=4023233417;this._c=2562383102;this._d=271733878;this._e=3285377520;return this};function rotl1(e){return e<<1|e>>>31}function rotl5(e){return e<<5|e>>>27}function rotl30(e){return e<<30|e>>>2}function ft(e,t,r,i){if(e===0)return t&r|~t&i;if(e===2)return t&r|t&i|r&i;return t^r^i}Sha1.prototype._update=function(e){var t=this._w;var r=this._a|0;var i=this._b|0;var n=this._c|0;var a=this._d|0;var o=this._e|0;for(var h=0;h<16;++h)t[h]=e.readInt32BE(h*4);for(;h<80;++h)t[h]=rotl1(t[h-3]^t[h-8]^t[h-14]^t[h-16]);for(var u=0;u<80;++u){var d=~~(u/20);var c=rotl5(r)+ft(d,i,n,a)+o+t[u]+s[d]|0;o=a;a=n;n=rotl30(i);i=r;r=c}this._a=r+this._a|0;this._b=i+this._b|0;this._c=n+this._c|0;this._d=a+this._d|0;this._e=o+this._e|0};Sha1.prototype._hash=function(){var e=a.allocUnsafe(20);e.writeInt32BE(this._a|0,0);e.writeInt32BE(this._b|0,4);e.writeInt32BE(this._c|0,8);e.writeInt32BE(this._d|0,12);e.writeInt32BE(this._e|0,16);return e};e.exports=Sha1},532:function(e,t,r){var i=r(3782);var n=r(1843);var a=r(2858);var s=r(5055).Buffer;var o=new Array(64);function Sha224(){this.init();this._w=o;a.call(this,64,56)}i(Sha224,n);Sha224.prototype.init=function(){this._a=3238371032;this._b=914150663;this._c=812702999;this._d=4144912697;this._e=4290775857;this._f=1750603025;this._g=1694076839;this._h=3204075428;return this};Sha224.prototype._hash=function(){var e=s.allocUnsafe(28);e.writeInt32BE(this._a,0);e.writeInt32BE(this._b,4);e.writeInt32BE(this._c,8);e.writeInt32BE(this._d,12);e.writeInt32BE(this._e,16);e.writeInt32BE(this._f,20);e.writeInt32BE(this._g,24);return e};e.exports=Sha224},1843:function(e,t,r){var i=r(3782);var n=r(2858);var a=r(5055).Buffer;var s=[1116352408,1899447441,3049323471,3921009573,961987163,1508970993,2453635748,2870763221,3624381080,310598401,607225278,1426881987,1925078388,2162078206,2614888103,3248222580,3835390401,4022224774,264347078,604807628,770255983,1249150122,1555081692,1996064986,2554220882,2821834349,2952996808,3210313671,3336571891,3584528711,113926993,338241895,666307205,773529912,1294757372,1396182291,1695183700,1986661051,2177026350,2456956037,2730485921,2820302411,3259730800,3345764771,3516065817,3600352804,4094571909,275423344,430227734,506948616,659060556,883997877,958139571,1322822218,1537002063,1747873779,1955562222,2024104815,2227730452,2361852424,2428436474,2756734187,3204031479,3329325298];var o=new Array(64);function Sha256(){this.init();this._w=o;n.call(this,64,56)}i(Sha256,n);Sha256.prototype.init=function(){this._a=1779033703;this._b=3144134277;this._c=1013904242;this._d=2773480762;this._e=1359893119;this._f=2600822924;this._g=528734635;this._h=1541459225;return this};function ch(e,t,r){return r^e&(t^r)}function maj(e,t,r){return e&t|r&(e|t)}function sigma0(e){return(e>>>2|e<<30)^(e>>>13|e<<19)^(e>>>22|e<<10)}function sigma1(e){return(e>>>6|e<<26)^(e>>>11|e<<21)^(e>>>25|e<<7)}function gamma0(e){return(e>>>7|e<<25)^(e>>>18|e<<14)^e>>>3}function gamma1(e){return(e>>>17|e<<15)^(e>>>19|e<<13)^e>>>10}Sha256.prototype._update=function(e){var t=this._w;var r=this._a|0;var i=this._b|0;var n=this._c|0;var a=this._d|0;var o=this._e|0;var h=this._f|0;var u=this._g|0;var d=this._h|0;for(var c=0;c<16;++c)t[c]=e.readInt32BE(c*4);for(;c<64;++c)t[c]=gamma1(t[c-2])+t[c-7]+gamma0(t[c-15])+t[c-16]|0;for(var l=0;l<64;++l){var p=d+sigma1(o)+ch(o,h,u)+s[l]+t[l]|0;var v=sigma0(r)+maj(r,i,n)|0;d=u;u=h;h=o;o=a+p|0;a=n;n=i;i=r;r=p+v|0}this._a=r+this._a|0;this._b=i+this._b|0;this._c=n+this._c|0;this._d=a+this._d|0;this._e=o+this._e|0;this._f=h+this._f|0;this._g=u+this._g|0;this._h=d+this._h|0};Sha256.prototype._hash=function(){var e=a.allocUnsafe(32);e.writeInt32BE(this._a,0);e.writeInt32BE(this._b,4);e.writeInt32BE(this._c,8);e.writeInt32BE(this._d,12);e.writeInt32BE(this._e,16);e.writeInt32BE(this._f,20);e.writeInt32BE(this._g,24);e.writeInt32BE(this._h,28);return e};e.exports=Sha256},7455:function(e,t,r){var i=r(3782);var n=r(9934);var a=r(2858);var s=r(5055).Buffer;var o=new Array(160);function Sha384(){this.init();this._w=o;a.call(this,128,112)}i(Sha384,n);Sha384.prototype.init=function(){this._ah=3418070365;this._bh=1654270250;this._ch=2438529370;this._dh=355462360;this._eh=1731405415;this._fh=2394180231;this._gh=3675008525;this._hh=1203062813;this._al=3238371032;this._bl=914150663;this._cl=812702999;this._dl=4144912697;this._el=4290775857;this._fl=1750603025;this._gl=1694076839;this._hl=3204075428;return this};Sha384.prototype._hash=function(){var e=s.allocUnsafe(48);function writeInt64BE(t,r,i){e.writeInt32BE(t,i);e.writeInt32BE(r,i+4)}writeInt64BE(this._ah,this._al,0);writeInt64BE(this._bh,this._bl,8);writeInt64BE(this._ch,this._cl,16);writeInt64BE(this._dh,this._dl,24);writeInt64BE(this._eh,this._el,32);writeInt64BE(this._fh,this._fl,40);return e};e.exports=Sha384},9934:function(e,t,r){var i=r(3782);var n=r(2858);var a=r(5055).Buffer;var s=[1116352408,3609767458,1899447441,602891725,3049323471,3964484399,3921009573,2173295548,961987163,4081628472,1508970993,3053834265,2453635748,2937671579,2870763221,3664609560,3624381080,2734883394,310598401,1164996542,607225278,1323610764,1426881987,3590304994,1925078388,4068182383,2162078206,991336113,2614888103,633803317,3248222580,3479774868,3835390401,2666613458,4022224774,944711139,264347078,2341262773,604807628,2007800933,770255983,1495990901,1249150122,1856431235,1555081692,3175218132,1996064986,2198950837,2554220882,3999719339,2821834349,766784016,2952996808,2566594879,3210313671,3203337956,3336571891,1034457026,3584528711,2466948901,113926993,3758326383,338241895,168717936,666307205,1188179964,773529912,1546045734,1294757372,1522805485,1396182291,2643833823,1695183700,2343527390,1986661051,1014477480,2177026350,1206759142,2456956037,344077627,2730485921,1290863460,2820302411,3158454273,3259730800,3505952657,3345764771,106217008,3516065817,3606008344,3600352804,1432725776,4094571909,1467031594,275423344,851169720,430227734,3100823752,506948616,1363258195,659060556,3750685593,883997877,3785050280,958139571,3318307427,1322822218,3812723403,1537002063,2003034995,1747873779,3602036899,1955562222,1575990012,2024104815,1125592928,2227730452,2716904306,2361852424,442776044,2428436474,593698344,2756734187,3733110249,3204031479,2999351573,3329325298,3815920427,3391569614,3928383900,3515267271,566280711,3940187606,3454069534,4118630271,4000239992,116418474,1914138554,174292421,2731055270,289380356,3203993006,460393269,320620315,685471733,587496836,852142971,1086792851,1017036298,365543100,1126000580,2618297676,1288033470,3409855158,1501505948,4234509866,1607167915,987167468,1816402316,1246189591];var o=new Array(160);function Sha512(){this.init();this._w=o;n.call(this,128,112)}i(Sha512,n);Sha512.prototype.init=function(){this._ah=1779033703;this._bh=3144134277;this._ch=1013904242;this._dh=2773480762;this._eh=1359893119;this._fh=2600822924;this._gh=528734635;this._hh=1541459225;this._al=4089235720;this._bl=2227873595;this._cl=4271175723;this._dl=1595750129;this._el=2917565137;this._fl=725511199;this._gl=4215389547;this._hl=327033209;return this};function Ch(e,t,r){return r^e&(t^r)}function maj(e,t,r){return e&t|r&(e|t)}function sigma0(e,t){return(e>>>28|t<<4)^(t>>>2|e<<30)^(t>>>7|e<<25)}function sigma1(e,t){return(e>>>14|t<<18)^(e>>>18|t<<14)^(t>>>9|e<<23)}function Gamma0(e,t){return(e>>>1|t<<31)^(e>>>8|t<<24)^e>>>7}function Gamma0l(e,t){return(e>>>1|t<<31)^(e>>>8|t<<24)^(e>>>7|t<<25)}function Gamma1(e,t){return(e>>>19|t<<13)^(t>>>29|e<<3)^e>>>6}function Gamma1l(e,t){return(e>>>19|t<<13)^(t>>>29|e<<3)^(e>>>6|t<<26)}function getCarry(e,t){return e>>>0<t>>>0?1:0}Sha512.prototype._update=function(e){var t=this._w;var r=this._ah|0;var i=this._bh|0;var n=this._ch|0;var a=this._dh|0;var o=this._eh|0;var h=this._fh|0;var u=this._gh|0;var d=this._hh|0;var c=this._al|0;var l=this._bl|0;var p=this._cl|0;var v=this._dl|0;var b=this._el|0;var m=this._fl|0;var y=this._gl|0;var g=this._hl|0;for(var _=0;_<32;_+=2){t[_]=e.readInt32BE(_*4);t[_+1]=e.readInt32BE(_*4+4)}for(;_<160;_+=2){var w=t[_-15*2];var M=t[_-15*2+1];var B=Gamma0(w,M);var E=Gamma0l(M,w);w=t[_-2*2];M=t[_-2*2+1];var k=Gamma1(w,M);var A=Gamma1l(M,w);var N=t[_-7*2];var P=t[_-7*2+1];var x=t[_-16*2];var I=t[_-16*2+1];var C=E+P|0;var D=B+N+getCarry(C,E)|0;C=C+A|0;D=D+k+getCarry(C,A)|0;C=C+I|0;D=D+x+getCarry(C,I)|0;t[_]=D;t[_+1]=C}for(var T=0;T<160;T+=2){D=t[T];C=t[T+1];var j=maj(r,i,n);var q=maj(c,l,p);var O=sigma0(r,c);var H=sigma0(c,r);var L=sigma1(o,b);var z=sigma1(b,o);var F=s[T];var U=s[T+1];var W=Ch(o,h,u);var V=Ch(b,m,y);var G=g+z|0;var J=d+L+getCarry(G,g)|0;G=G+V|0;J=J+W+getCarry(G,V)|0;G=G+U|0;J=J+F+getCarry(G,U)|0;G=G+C|0;J=J+D+getCarry(G,C)|0;var Z=H+q|0;var X=O+j+getCarry(Z,H)|0;d=u;g=y;u=h;y=m;h=o;m=b;b=v+G|0;o=a+J+getCarry(b,v)|0;a=n;v=p;n=i;p=l;i=r;l=c;c=G+Z|0;r=J+X+getCarry(c,G)|0}this._al=this._al+c|0;this._bl=this._bl+l|0;this._cl=this._cl+p|0;this._dl=this._dl+v|0;this._el=this._el+b|0;this._fl=this._fl+m|0;this._gl=this._gl+y|0;this._hl=this._hl+g|0;this._ah=this._ah+r+getCarry(this._al,c)|0;this._bh=this._bh+i+getCarry(this._bl,l)|0;this._ch=this._ch+n+getCarry(this._cl,p)|0;this._dh=this._dh+a+getCarry(this._dl,v)|0;this._eh=this._eh+o+getCarry(this._el,b)|0;this._fh=this._fh+h+getCarry(this._fl,m)|0;this._gh=this._gh+u+getCarry(this._gl,y)|0;this._hh=this._hh+d+getCarry(this._hl,g)|0};Sha512.prototype._hash=function(){var e=a.allocUnsafe(64);function writeInt64BE(t,r,i){e.writeInt32BE(t,i);e.writeInt32BE(r,i+4)}writeInt64BE(this._ah,this._al,0);writeInt64BE(this._bh,this._bl,8);writeInt64BE(this._ch,this._cl,16);writeInt64BE(this._dh,this._dl,24);writeInt64BE(this._eh,this._el,32);writeInt64BE(this._fh,this._fl,40);writeInt64BE(this._gh,this._gl,48);writeInt64BE(this._hh,this._hl,56);return e};e.exports=Sha512},3704:function(e,t,r){"use strict";var i=r(5055).Buffer;var n=i.isEncoding||function(e){e=""+e;switch(e&&e.toLowerCase()){case"hex":case"utf8":case"utf-8":case"ascii":case"binary":case"base64":case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":case"raw":return true;default:return false}};function _normalizeEncoding(e){if(!e)return"utf8";var t;while(true){switch(e){case"utf8":case"utf-8":return"utf8";case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return"utf16le";case"latin1":case"binary":return"latin1";case"base64":case"ascii":case"hex":return e;default:if(t)return;e=(""+e).toLowerCase();t=true}}}function normalizeEncoding(e){var t=_normalizeEncoding(e);if(typeof t!=="string"&&(i.isEncoding===n||!n(e)))throw new Error("Unknown encoding: "+e);return t||e}t.s=StringDecoder;function StringDecoder(e){this.encoding=normalizeEncoding(e);var t;switch(this.encoding){case"utf16le":this.text=utf16Text;this.end=utf16End;t=4;break;case"utf8":this.fillLast=utf8FillLast;t=4;break;case"base64":this.text=base64Text;this.end=base64End;t=3;break;default:this.write=simpleWrite;this.end=simpleEnd;return}this.lastNeed=0;this.lastTotal=0;this.lastChar=i.allocUnsafe(t)}StringDecoder.prototype.write=function(e){if(e.length===0)return"";var t;var r;if(this.lastNeed){t=this.fillLast(e);if(t===undefined)return"";r=this.lastNeed;this.lastNeed=0}else{r=0}if(r<e.length)return t?t+this.text(e,r):this.text(e,r);return t||""};StringDecoder.prototype.end=utf8End;StringDecoder.prototype.text=utf8Text;StringDecoder.prototype.fillLast=function(e){if(this.lastNeed<=e.length){e.copy(this.lastChar,this.lastTotal-this.lastNeed,0,this.lastNeed);return this.lastChar.toString(this.encoding,0,this.lastTotal)}e.copy(this.lastChar,this.lastTotal-this.lastNeed,0,e.length);this.lastNeed-=e.length};function utf8CheckByte(e){if(e<=127)return 0;else if(e>>5===6)return 2;else if(e>>4===14)return 3;else if(e>>3===30)return 4;return e>>6===2?-1:-2}function utf8CheckIncomplete(e,t,r){var i=t.length-1;if(i<r)return 0;var n=utf8CheckByte(t[i]);if(n>=0){if(n>0)e.lastNeed=n-1;return n}if(--i<r||n===-2)return 0;n=utf8CheckByte(t[i]);if(n>=0){if(n>0)e.lastNeed=n-2;return n}if(--i<r||n===-2)return 0;n=utf8CheckByte(t[i]);if(n>=0){if(n>0){if(n===2)n=0;else e.lastNeed=n-3}return n}return 0}function utf8CheckExtraBytes(e,t,r){if((t[0]&192)!==128){e.lastNeed=0;return"�"}if(e.lastNeed>1&&t.length>1){if((t[1]&192)!==128){e.lastNeed=1;return"�"}if(e.lastNeed>2&&t.length>2){if((t[2]&192)!==128){e.lastNeed=2;return"�"}}}}function utf8FillLast(e){var t=this.lastTotal-this.lastNeed;var r=utf8CheckExtraBytes(this,e,t);if(r!==undefined)return r;if(this.lastNeed<=e.length){e.copy(this.lastChar,t,0,this.lastNeed);return this.lastChar.toString(this.encoding,0,this.lastTotal)}e.copy(this.lastChar,t,0,e.length);this.lastNeed-=e.length}function utf8Text(e,t){var r=utf8CheckIncomplete(this,e,t);if(!this.lastNeed)return e.toString("utf8",t);this.lastTotal=r;var i=e.length-(r-this.lastNeed);e.copy(this.lastChar,0,i);return e.toString("utf8",t,i)}function utf8End(e){var t=e&&e.length?this.write(e):"";if(this.lastNeed)return t+"�";return t}function utf16Text(e,t){if((e.length-t)%2===0){var r=e.toString("utf16le",t);if(r){var i=r.charCodeAt(r.length-1);if(i>=55296&&i<=56319){this.lastNeed=2;this.lastTotal=4;this.lastChar[0]=e[e.length-2];this.lastChar[1]=e[e.length-1];return r.slice(0,-1)}}return r}this.lastNeed=1;this.lastTotal=2;this.lastChar[0]=e[e.length-1];return e.toString("utf16le",t,e.length-1)}function utf16End(e){var t=e&&e.length?this.write(e):"";if(this.lastNeed){var r=this.lastTotal-this.lastNeed;return t+this.lastChar.toString("utf16le",0,r)}return t}function base64Text(e,t){var r=(e.length-t)%3;if(r===0)return e.toString("base64",t);this.lastNeed=3-r;this.lastTotal=3;if(r===1){this.lastChar[0]=e[e.length-1]}else{this.lastChar[0]=e[e.length-2];this.lastChar[1]=e[e.length-1]}return e.toString("base64",t,e.length-r)}function base64End(e){var t=e&&e.length?this.write(e):"";if(this.lastNeed)return t+this.lastChar.toString("base64",0,3-this.lastNeed);return t}function simpleWrite(e){return e.toString(this.encoding)}function simpleEnd(e){return e&&e.length?this.write(e):""}},6769:function(e){e.exports=deprecate;function deprecate(e,t){if(config("noDeprecation")){return e}var r=false;function deprecated(){if(!r){if(config("throwDeprecation")){throw new Error(t)}else if(config("traceDeprecation")){console.trace(t)}else{console.warn(t)}r=true}return e.apply(this,arguments)}return deprecated}function config(e){try{if(!__webpack_require__.g.localStorage)return false}catch(e){return false}var t=__webpack_require__.g.localStorage[e];if(null==t)return false;return String(t).toLowerCase()==="true"}},4300:function(e){"use strict";e.exports=__webpack_require__(30816)},6113:function(e){"use strict";e.exports=__webpack_require__(34309)},2361:function(e){"use strict";e.exports=__webpack_require__(50343)},2781:function(e){"use strict";e.exports=__webpack_require__(4957)},1576:function(e){"use strict";e.exports=__webpack_require__(34361)},3837:function(e){"use strict";e.exports=__webpack_require__(71323)},6144:function(e){"use strict";e.exports=__webpack_require__(69410)},5866:function(e){"use strict";e.exports=JSON.parse('{"aes-128-ecb":{"cipher":"AES","key":128,"iv":0,"mode":"ECB","type":"block"},"aes-192-ecb":{"cipher":"AES","key":192,"iv":0,"mode":"ECB","type":"block"},"aes-256-ecb":{"cipher":"AES","key":256,"iv":0,"mode":"ECB","type":"block"},"aes-128-cbc":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes-192-cbc":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes-256-cbc":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes128":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes192":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes256":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes-128-cfb":{"cipher":"AES","key":128,"iv":16,"mode":"CFB","type":"stream"},"aes-192-cfb":{"cipher":"AES","key":192,"iv":16,"mode":"CFB","type":"stream"},"aes-256-cfb":{"cipher":"AES","key":256,"iv":16,"mode":"CFB","type":"stream"},"aes-128-cfb8":{"cipher":"AES","key":128,"iv":16,"mode":"CFB8","type":"stream"},"aes-192-cfb8":{"cipher":"AES","key":192,"iv":16,"mode":"CFB8","type":"stream"},"aes-256-cfb8":{"cipher":"AES","key":256,"iv":16,"mode":"CFB8","type":"stream"},"aes-128-cfb1":{"cipher":"AES","key":128,"iv":16,"mode":"CFB1","type":"stream"},"aes-192-cfb1":{"cipher":"AES","key":192,"iv":16,"mode":"CFB1","type":"stream"},"aes-256-cfb1":{"cipher":"AES","key":256,"iv":16,"mode":"CFB1","type":"stream"},"aes-128-ofb":{"cipher":"AES","key":128,"iv":16,"mode":"OFB","type":"stream"},"aes-192-ofb":{"cipher":"AES","key":192,"iv":16,"mode":"OFB","type":"stream"},"aes-256-ofb":{"cipher":"AES","key":256,"iv":16,"mode":"OFB","type":"stream"},"aes-128-ctr":{"cipher":"AES","key":128,"iv":16,"mode":"CTR","type":"stream"},"aes-192-ctr":{"cipher":"AES","key":192,"iv":16,"mode":"CTR","type":"stream"},"aes-256-ctr":{"cipher":"AES","key":256,"iv":16,"mode":"CTR","type":"stream"},"aes-128-gcm":{"cipher":"AES","key":128,"iv":12,"mode":"GCM","type":"auth"},"aes-192-gcm":{"cipher":"AES","key":192,"iv":12,"mode":"GCM","type":"auth"},"aes-256-gcm":{"cipher":"AES","key":256,"iv":12,"mode":"GCM","type":"auth"}}')},2908:function(e){"use strict";e.exports=JSON.parse('{"sha224WithRSAEncryption":{"sign":"rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"RSA-SHA224":{"sign":"ecdsa/rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"sha256WithRSAEncryption":{"sign":"rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"RSA-SHA256":{"sign":"ecdsa/rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"sha384WithRSAEncryption":{"sign":"rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"RSA-SHA384":{"sign":"ecdsa/rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"sha512WithRSAEncryption":{"sign":"rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA512":{"sign":"ecdsa/rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA1":{"sign":"rsa","hash":"sha1","id":"3021300906052b0e03021a05000414"},"ecdsa-with-SHA1":{"sign":"ecdsa","hash":"sha1","id":""},"sha256":{"sign":"ecdsa","hash":"sha256","id":""},"sha224":{"sign":"ecdsa","hash":"sha224","id":""},"sha384":{"sign":"ecdsa","hash":"sha384","id":""},"sha512":{"sign":"ecdsa","hash":"sha512","id":""},"DSA-SHA":{"sign":"dsa","hash":"sha1","id":""},"DSA-SHA1":{"sign":"dsa","hash":"sha1","id":""},"DSA":{"sign":"dsa","hash":"sha1","id":""},"DSA-WITH-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-WITH-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-WITH-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-WITH-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-RIPEMD160":{"sign":"dsa","hash":"rmd160","id":""},"ripemd160WithRSA":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"RSA-RIPEMD160":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"md5WithRSAEncryption":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"},"RSA-MD5":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"}}')},9267:function(e){"use strict";e.exports=JSON.parse('{"1.3.132.0.10":"secp256k1","1.3.132.0.33":"p224","1.2.840.10045.3.1.1":"p192","1.2.840.10045.3.1.7":"p256","1.3.132.0.34":"p384","1.3.132.0.35":"p521"}')},7992:function(e){"use strict";e.exports=JSON.parse('{"modp1":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"},"modp2":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"},"modp5":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"},"modp14":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"},"modp15":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"},"modp16":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"},"modp17":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"},"modp18":{"gen":"02","prime":"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"}}')},2531:function(e){"use strict";e.exports={i8:"6.5.3"}},2510:function(e){"use strict";e.exports=JSON.parse('{"2.16.840.1.101.3.4.1.1":"aes-128-ecb","2.16.840.1.101.3.4.1.2":"aes-128-cbc","2.16.840.1.101.3.4.1.3":"aes-128-ofb","2.16.840.1.101.3.4.1.4":"aes-128-cfb","2.16.840.1.101.3.4.1.21":"aes-192-ecb","2.16.840.1.101.3.4.1.22":"aes-192-cbc","2.16.840.1.101.3.4.1.23":"aes-192-ofb","2.16.840.1.101.3.4.1.24":"aes-192-cfb","2.16.840.1.101.3.4.1.41":"aes-256-ecb","2.16.840.1.101.3.4.1.42":"aes-256-cbc","2.16.840.1.101.3.4.1.43":"aes-256-ofb","2.16.840.1.101.3.4.1.44":"aes-256-cfb"}')}};var t={};function __nccwpck_require__(r){var i=t[r];if(i!==undefined){return i.exports}var n=t[r]={id:r,loaded:false,exports:{}};var a=true;try{e[r].call(n.exports,n,n.exports,__nccwpck_require__);a=false}finally{if(a)delete t[r]}n.loaded=true;return n.exports}!function(){__nccwpck_require__.nmd=function(e){e.paths=[];if(!e.children)e.children=[];return e}}();if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var r={};!function(){"use strict";var e=r;e.randomBytes=e.rng=e.pseudoRandomBytes=e.prng=__nccwpck_require__(7223);e.createHash=e.Hash=__nccwpck_require__(9739);e.createHmac=e.Hmac=__nccwpck_require__(4873);var t=__nccwpck_require__(9276);var i=Object.keys(t);var n=["sha1","sha224","sha256","sha384","sha512","md5","rmd160"].concat(i);e.getHashes=function(){return n};var a=__nccwpck_require__(4978);e.pbkdf2=a.pbkdf2;e.pbkdf2Sync=a.pbkdf2Sync;var s=__nccwpck_require__(8996);e.Cipher=s.Cipher;e.createCipher=s.createCipher;e.Cipheriv=s.Cipheriv;e.createCipheriv=s.createCipheriv;e.Decipher=s.Decipher;e.createDecipher=s.createDecipher;e.Decipheriv=s.Decipheriv;e.createDecipheriv=s.createDecipheriv;e.getCiphers=s.getCiphers;e.listCiphers=s.listCiphers;var o=__nccwpck_require__(6587);e.DiffieHellmanGroup=o.DiffieHellmanGroup;e.createDiffieHellmanGroup=o.createDiffieHellmanGroup;e.getDiffieHellman=o.getDiffieHellman;e.createDiffieHellman=o.createDiffieHellman;e.DiffieHellman=o.DiffieHellman;var h=__nccwpck_require__(4078);e.createSign=h.createSign;e.Sign=h.Sign;e.createVerify=h.createVerify;e.Verify=h.Verify;e.createECDH=__nccwpck_require__(9942);var u=__nccwpck_require__(9783);e.publicEncrypt=u.publicEncrypt;e.privateEncrypt=u.privateEncrypt;e.publicDecrypt=u.publicDecrypt;e.privateDecrypt=u.privateDecrypt;var d=__nccwpck_require__(6445);e.randomFill=d.randomFill;e.randomFillSync=d.randomFillSync;e.createCredentials=function(){throw new Error(["sorry, createCredentials is not implemented yet","we accept pull requests","https://github.com/crypto-browserify/crypto-browserify"].join("\n"))};e.constants={DH_CHECK_P_NOT_SAFE_PRIME:2,DH_CHECK_P_NOT_PRIME:1,DH_UNABLE_TO_CHECK_GENERATOR:4,DH_NOT_SUITABLE_GENERATOR:8,NPN_ENABLED:1,ALPN_ENABLED:1,RSA_PKCS1_PADDING:1,RSA_SSLV23_PADDING:2,RSA_NO_PADDING:3,RSA_PKCS1_OAEP_PADDING:4,RSA_X931_PADDING:5,RSA_PKCS1_PSS_PADDING:6,POINT_CONVERSION_COMPRESSED:2,POINT_CONVERSION_UNCOMPRESSED:4,POINT_CONVERSION_HYBRID:6}}();module.exports=r})();

/***/ }),

/***/ 1859:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 4957:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __dirname = "/";
/* provided dependency */ var process = __webpack_require__(27061);
(function(){var e={782:function(e){if(typeof Object.create==="function"){e.exports=function inherits(e,t){if(t){e.super_=t;e.prototype=Object.create(t.prototype,{constructor:{value:e,enumerable:false,writable:true,configurable:true}})}}}else{e.exports=function inherits(e,t){if(t){e.super_=t;var TempCtor=function(){};TempCtor.prototype=t.prototype;e.prototype=new TempCtor;e.prototype.constructor=e}}}},646:function(e){"use strict";const t={};function createErrorType(e,r,n){if(!n){n=Error}function getMessage(e,t,n){if(typeof r==="string"){return r}else{return r(e,t,n)}}class NodeError extends n{constructor(e,t,r){super(getMessage(e,t,r))}}NodeError.prototype.name=n.name;NodeError.prototype.code=e;t[e]=NodeError}function oneOf(e,t){if(Array.isArray(e)){const r=e.length;e=e.map((e=>String(e)));if(r>2){return`one of ${t} ${e.slice(0,r-1).join(", ")}, or `+e[r-1]}else if(r===2){return`one of ${t} ${e[0]} or ${e[1]}`}else{return`of ${t} ${e[0]}`}}else{return`of ${t} ${String(e)}`}}function startsWith(e,t,r){return e.substr(!r||r<0?0:+r,t.length)===t}function endsWith(e,t,r){if(r===undefined||r>e.length){r=e.length}return e.substring(r-t.length,r)===t}function includes(e,t,r){if(typeof r!=="number"){r=0}if(r+t.length>e.length){return false}else{return e.indexOf(t,r)!==-1}}createErrorType("ERR_INVALID_OPT_VALUE",(function(e,t){return'The value "'+t+'" is invalid for option "'+e+'"'}),TypeError);createErrorType("ERR_INVALID_ARG_TYPE",(function(e,t,r){let n;if(typeof t==="string"&&startsWith(t,"not ")){n="must not be";t=t.replace(/^not /,"")}else{n="must be"}let i;if(endsWith(e," argument")){i=`The ${e} ${n} ${oneOf(t,"type")}`}else{const r=includes(e,".")?"property":"argument";i=`The "${e}" ${r} ${n} ${oneOf(t,"type")}`}i+=`. Received type ${typeof r}`;return i}),TypeError);createErrorType("ERR_STREAM_PUSH_AFTER_EOF","stream.push() after EOF");createErrorType("ERR_METHOD_NOT_IMPLEMENTED",(function(e){return"The "+e+" method is not implemented"}));createErrorType("ERR_STREAM_PREMATURE_CLOSE","Premature close");createErrorType("ERR_STREAM_DESTROYED",(function(e){return"Cannot call "+e+" after a stream was destroyed"}));createErrorType("ERR_MULTIPLE_CALLBACK","Callback called multiple times");createErrorType("ERR_STREAM_CANNOT_PIPE","Cannot pipe, not readable");createErrorType("ERR_STREAM_WRITE_AFTER_END","write after end");createErrorType("ERR_STREAM_NULL_VALUES","May not write null values to stream",TypeError);createErrorType("ERR_UNKNOWN_ENCODING",(function(e){return"Unknown encoding: "+e}),TypeError);createErrorType("ERR_STREAM_UNSHIFT_AFTER_END_EVENT","stream.unshift() after end event");e.exports.q=t},403:function(e,t,r){"use strict";var n=Object.keys||function(e){var t=[];for(var r in e){t.push(r)}return t};e.exports=Duplex;var i=r(709);var a=r(337);r(782)(Duplex,i);{var o=n(a.prototype);for(var s=0;s<o.length;s++){var f=o[s];if(!Duplex.prototype[f])Duplex.prototype[f]=a.prototype[f]}}function Duplex(e){if(!(this instanceof Duplex))return new Duplex(e);i.call(this,e);a.call(this,e);this.allowHalfOpen=true;if(e){if(e.readable===false)this.readable=false;if(e.writable===false)this.writable=false;if(e.allowHalfOpen===false){this.allowHalfOpen=false;this.once("end",onend)}}}Object.defineProperty(Duplex.prototype,"writableHighWaterMark",{enumerable:false,get:function get(){return this._writableState.highWaterMark}});Object.defineProperty(Duplex.prototype,"writableBuffer",{enumerable:false,get:function get(){return this._writableState&&this._writableState.getBuffer()}});Object.defineProperty(Duplex.prototype,"writableLength",{enumerable:false,get:function get(){return this._writableState.length}});function onend(){if(this._writableState.ended)return;process.nextTick(onEndNT,this)}function onEndNT(e){e.end()}Object.defineProperty(Duplex.prototype,"destroyed",{enumerable:false,get:function get(){if(this._readableState===undefined||this._writableState===undefined){return false}return this._readableState.destroyed&&this._writableState.destroyed},set:function set(e){if(this._readableState===undefined||this._writableState===undefined){return}this._readableState.destroyed=e;this._writableState.destroyed=e}})},889:function(e,t,r){"use strict";e.exports=PassThrough;var n=r(170);r(782)(PassThrough,n);function PassThrough(e){if(!(this instanceof PassThrough))return new PassThrough(e);n.call(this,e)}PassThrough.prototype._transform=function(e,t,r){r(null,e)}},709:function(e,t,r){"use strict";e.exports=Readable;var n;Readable.ReadableState=ReadableState;var i=r(361).EventEmitter;var a=function EElistenerCount(e,t){return e.listeners(t).length};var o=r(678);var s=r(300).Buffer;var f=__webpack_require__.g.Uint8Array||function(){};function _uint8ArrayToBuffer(e){return s.from(e)}function _isUint8Array(e){return s.isBuffer(e)||e instanceof f}var l=r(837);var u;if(l&&l.debuglog){u=l.debuglog("stream")}else{u=function debug(){}}var d=r(379);var c=r(25);var h=r(776),p=h.getHighWaterMark;var b=r(646).q,g=b.ERR_INVALID_ARG_TYPE,y=b.ERR_STREAM_PUSH_AFTER_EOF,_=b.ERR_METHOD_NOT_IMPLEMENTED,v=b.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;var w;var m;var S;r(782)(Readable,o);var R=c.errorOrDestroy;var E=["error","close","destroy","pause","resume"];function prependListener(e,t,r){if(typeof e.prependListener==="function")return e.prependListener(t,r);if(!e._events||!e._events[t])e.on(t,r);else if(Array.isArray(e._events[t]))e._events[t].unshift(r);else e._events[t]=[r,e._events[t]]}function ReadableState(e,t,i){n=n||r(403);e=e||{};if(typeof i!=="boolean")i=t instanceof n;this.objectMode=!!e.objectMode;if(i)this.objectMode=this.objectMode||!!e.readableObjectMode;this.highWaterMark=p(this,e,"readableHighWaterMark",i);this.buffer=new d;this.length=0;this.pipes=null;this.pipesCount=0;this.flowing=null;this.ended=false;this.endEmitted=false;this.reading=false;this.sync=true;this.needReadable=false;this.emittedReadable=false;this.readableListening=false;this.resumeScheduled=false;this.paused=true;this.emitClose=e.emitClose!==false;this.autoDestroy=!!e.autoDestroy;this.destroyed=false;this.defaultEncoding=e.defaultEncoding||"utf8";this.awaitDrain=0;this.readingMore=false;this.decoder=null;this.encoding=null;if(e.encoding){if(!w)w=r(704).s;this.decoder=new w(e.encoding);this.encoding=e.encoding}}function Readable(e){n=n||r(403);if(!(this instanceof Readable))return new Readable(e);var t=this instanceof n;this._readableState=new ReadableState(e,this,t);this.readable=true;if(e){if(typeof e.read==="function")this._read=e.read;if(typeof e.destroy==="function")this._destroy=e.destroy}o.call(this)}Object.defineProperty(Readable.prototype,"destroyed",{enumerable:false,get:function get(){if(this._readableState===undefined){return false}return this._readableState.destroyed},set:function set(e){if(!this._readableState){return}this._readableState.destroyed=e}});Readable.prototype.destroy=c.destroy;Readable.prototype._undestroy=c.undestroy;Readable.prototype._destroy=function(e,t){t(e)};Readable.prototype.push=function(e,t){var r=this._readableState;var n;if(!r.objectMode){if(typeof e==="string"){t=t||r.defaultEncoding;if(t!==r.encoding){e=s.from(e,t);t=""}n=true}}else{n=true}return readableAddChunk(this,e,t,false,n)};Readable.prototype.unshift=function(e){return readableAddChunk(this,e,null,true,false)};function readableAddChunk(e,t,r,n,i){u("readableAddChunk",t);var a=e._readableState;if(t===null){a.reading=false;onEofChunk(e,a)}else{var o;if(!i)o=chunkInvalid(a,t);if(o){R(e,o)}else if(a.objectMode||t&&t.length>0){if(typeof t!=="string"&&!a.objectMode&&Object.getPrototypeOf(t)!==s.prototype){t=_uint8ArrayToBuffer(t)}if(n){if(a.endEmitted)R(e,new v);else addChunk(e,a,t,true)}else if(a.ended){R(e,new y)}else if(a.destroyed){return false}else{a.reading=false;if(a.decoder&&!r){t=a.decoder.write(t);if(a.objectMode||t.length!==0)addChunk(e,a,t,false);else maybeReadMore(e,a)}else{addChunk(e,a,t,false)}}}else if(!n){a.reading=false;maybeReadMore(e,a)}}return!a.ended&&(a.length<a.highWaterMark||a.length===0)}function addChunk(e,t,r,n){if(t.flowing&&t.length===0&&!t.sync){t.awaitDrain=0;e.emit("data",r)}else{t.length+=t.objectMode?1:r.length;if(n)t.buffer.unshift(r);else t.buffer.push(r);if(t.needReadable)emitReadable(e)}maybeReadMore(e,t)}function chunkInvalid(e,t){var r;if(!_isUint8Array(t)&&typeof t!=="string"&&t!==undefined&&!e.objectMode){r=new g("chunk",["string","Buffer","Uint8Array"],t)}return r}Readable.prototype.isPaused=function(){return this._readableState.flowing===false};Readable.prototype.setEncoding=function(e){if(!w)w=r(704).s;var t=new w(e);this._readableState.decoder=t;this._readableState.encoding=this._readableState.decoder.encoding;var n=this._readableState.buffer.head;var i="";while(n!==null){i+=t.write(n.data);n=n.next}this._readableState.buffer.clear();if(i!=="")this._readableState.buffer.push(i);this._readableState.length=i.length;return this};var T=1073741824;function computeNewHighWaterMark(e){if(e>=T){e=T}else{e--;e|=e>>>1;e|=e>>>2;e|=e>>>4;e|=e>>>8;e|=e>>>16;e++}return e}function howMuchToRead(e,t){if(e<=0||t.length===0&&t.ended)return 0;if(t.objectMode)return 1;if(e!==e){if(t.flowing&&t.length)return t.buffer.head.data.length;else return t.length}if(e>t.highWaterMark)t.highWaterMark=computeNewHighWaterMark(e);if(e<=t.length)return e;if(!t.ended){t.needReadable=true;return 0}return t.length}Readable.prototype.read=function(e){u("read",e);e=parseInt(e,10);var t=this._readableState;var r=e;if(e!==0)t.emittedReadable=false;if(e===0&&t.needReadable&&((t.highWaterMark!==0?t.length>=t.highWaterMark:t.length>0)||t.ended)){u("read: emitReadable",t.length,t.ended);if(t.length===0&&t.ended)endReadable(this);else emitReadable(this);return null}e=howMuchToRead(e,t);if(e===0&&t.ended){if(t.length===0)endReadable(this);return null}var n=t.needReadable;u("need readable",n);if(t.length===0||t.length-e<t.highWaterMark){n=true;u("length less than watermark",n)}if(t.ended||t.reading){n=false;u("reading or ended",n)}else if(n){u("do read");t.reading=true;t.sync=true;if(t.length===0)t.needReadable=true;this._read(t.highWaterMark);t.sync=false;if(!t.reading)e=howMuchToRead(r,t)}var i;if(e>0)i=fromList(e,t);else i=null;if(i===null){t.needReadable=t.length<=t.highWaterMark;e=0}else{t.length-=e;t.awaitDrain=0}if(t.length===0){if(!t.ended)t.needReadable=true;if(r!==e&&t.ended)endReadable(this)}if(i!==null)this.emit("data",i);return i};function onEofChunk(e,t){u("onEofChunk");if(t.ended)return;if(t.decoder){var r=t.decoder.end();if(r&&r.length){t.buffer.push(r);t.length+=t.objectMode?1:r.length}}t.ended=true;if(t.sync){emitReadable(e)}else{t.needReadable=false;if(!t.emittedReadable){t.emittedReadable=true;emitReadable_(e)}}}function emitReadable(e){var t=e._readableState;u("emitReadable",t.needReadable,t.emittedReadable);t.needReadable=false;if(!t.emittedReadable){u("emitReadable",t.flowing);t.emittedReadable=true;process.nextTick(emitReadable_,e)}}function emitReadable_(e){var t=e._readableState;u("emitReadable_",t.destroyed,t.length,t.ended);if(!t.destroyed&&(t.length||t.ended)){e.emit("readable");t.emittedReadable=false}t.needReadable=!t.flowing&&!t.ended&&t.length<=t.highWaterMark;flow(e)}function maybeReadMore(e,t){if(!t.readingMore){t.readingMore=true;process.nextTick(maybeReadMore_,e,t)}}function maybeReadMore_(e,t){while(!t.reading&&!t.ended&&(t.length<t.highWaterMark||t.flowing&&t.length===0)){var r=t.length;u("maybeReadMore read 0");e.read(0);if(r===t.length)break}t.readingMore=false}Readable.prototype._read=function(e){R(this,new _("_read()"))};Readable.prototype.pipe=function(e,t){var r=this;var n=this._readableState;switch(n.pipesCount){case 0:n.pipes=e;break;case 1:n.pipes=[n.pipes,e];break;default:n.pipes.push(e);break}n.pipesCount+=1;u("pipe count=%d opts=%j",n.pipesCount,t);var i=(!t||t.end!==false)&&e!==process.stdout&&e!==process.stderr;var o=i?onend:unpipe;if(n.endEmitted)process.nextTick(o);else r.once("end",o);e.on("unpipe",onunpipe);function onunpipe(e,t){u("onunpipe");if(e===r){if(t&&t.hasUnpiped===false){t.hasUnpiped=true;cleanup()}}}function onend(){u("onend");e.end()}var s=pipeOnDrain(r);e.on("drain",s);var f=false;function cleanup(){u("cleanup");e.removeListener("close",onclose);e.removeListener("finish",onfinish);e.removeListener("drain",s);e.removeListener("error",onerror);e.removeListener("unpipe",onunpipe);r.removeListener("end",onend);r.removeListener("end",unpipe);r.removeListener("data",ondata);f=true;if(n.awaitDrain&&(!e._writableState||e._writableState.needDrain))s()}r.on("data",ondata);function ondata(t){u("ondata");var i=e.write(t);u("dest.write",i);if(i===false){if((n.pipesCount===1&&n.pipes===e||n.pipesCount>1&&indexOf(n.pipes,e)!==-1)&&!f){u("false write response, pause",n.awaitDrain);n.awaitDrain++}r.pause()}}function onerror(t){u("onerror",t);unpipe();e.removeListener("error",onerror);if(a(e,"error")===0)R(e,t)}prependListener(e,"error",onerror);function onclose(){e.removeListener("finish",onfinish);unpipe()}e.once("close",onclose);function onfinish(){u("onfinish");e.removeListener("close",onclose);unpipe()}e.once("finish",onfinish);function unpipe(){u("unpipe");r.unpipe(e)}e.emit("pipe",r);if(!n.flowing){u("pipe resume");r.resume()}return e};function pipeOnDrain(e){return function pipeOnDrainFunctionResult(){var t=e._readableState;u("pipeOnDrain",t.awaitDrain);if(t.awaitDrain)t.awaitDrain--;if(t.awaitDrain===0&&a(e,"data")){t.flowing=true;flow(e)}}}Readable.prototype.unpipe=function(e){var t=this._readableState;var r={hasUnpiped:false};if(t.pipesCount===0)return this;if(t.pipesCount===1){if(e&&e!==t.pipes)return this;if(!e)e=t.pipes;t.pipes=null;t.pipesCount=0;t.flowing=false;if(e)e.emit("unpipe",this,r);return this}if(!e){var n=t.pipes;var i=t.pipesCount;t.pipes=null;t.pipesCount=0;t.flowing=false;for(var a=0;a<i;a++){n[a].emit("unpipe",this,{hasUnpiped:false})}return this}var o=indexOf(t.pipes,e);if(o===-1)return this;t.pipes.splice(o,1);t.pipesCount-=1;if(t.pipesCount===1)t.pipes=t.pipes[0];e.emit("unpipe",this,r);return this};Readable.prototype.on=function(e,t){var r=o.prototype.on.call(this,e,t);var n=this._readableState;if(e==="data"){n.readableListening=this.listenerCount("readable")>0;if(n.flowing!==false)this.resume()}else if(e==="readable"){if(!n.endEmitted&&!n.readableListening){n.readableListening=n.needReadable=true;n.flowing=false;n.emittedReadable=false;u("on readable",n.length,n.reading);if(n.length){emitReadable(this)}else if(!n.reading){process.nextTick(nReadingNextTick,this)}}}return r};Readable.prototype.addListener=Readable.prototype.on;Readable.prototype.removeListener=function(e,t){var r=o.prototype.removeListener.call(this,e,t);if(e==="readable"){process.nextTick(updateReadableListening,this)}return r};Readable.prototype.removeAllListeners=function(e){var t=o.prototype.removeAllListeners.apply(this,arguments);if(e==="readable"||e===undefined){process.nextTick(updateReadableListening,this)}return t};function updateReadableListening(e){var t=e._readableState;t.readableListening=e.listenerCount("readable")>0;if(t.resumeScheduled&&!t.paused){t.flowing=true}else if(e.listenerCount("data")>0){e.resume()}}function nReadingNextTick(e){u("readable nexttick read 0");e.read(0)}Readable.prototype.resume=function(){var e=this._readableState;if(!e.flowing){u("resume");e.flowing=!e.readableListening;resume(this,e)}e.paused=false;return this};function resume(e,t){if(!t.resumeScheduled){t.resumeScheduled=true;process.nextTick(resume_,e,t)}}function resume_(e,t){u("resume",t.reading);if(!t.reading){e.read(0)}t.resumeScheduled=false;e.emit("resume");flow(e);if(t.flowing&&!t.reading)e.read(0)}Readable.prototype.pause=function(){u("call pause flowing=%j",this._readableState.flowing);if(this._readableState.flowing!==false){u("pause");this._readableState.flowing=false;this.emit("pause")}this._readableState.paused=true;return this};function flow(e){var t=e._readableState;u("flow",t.flowing);while(t.flowing&&e.read()!==null){}}Readable.prototype.wrap=function(e){var t=this;var r=this._readableState;var n=false;e.on("end",(function(){u("wrapped end");if(r.decoder&&!r.ended){var e=r.decoder.end();if(e&&e.length)t.push(e)}t.push(null)}));e.on("data",(function(i){u("wrapped data");if(r.decoder)i=r.decoder.write(i);if(r.objectMode&&(i===null||i===undefined))return;else if(!r.objectMode&&(!i||!i.length))return;var a=t.push(i);if(!a){n=true;e.pause()}}));for(var i in e){if(this[i]===undefined&&typeof e[i]==="function"){this[i]=function methodWrap(t){return function methodWrapReturnFunction(){return e[t].apply(e,arguments)}}(i)}}for(var a=0;a<E.length;a++){e.on(E[a],this.emit.bind(this,E[a]))}this._read=function(t){u("wrapped _read",t);if(n){n=false;e.resume()}};return this};if(typeof Symbol==="function"){Readable.prototype[Symbol.asyncIterator]=function(){if(m===undefined){m=r(871)}return m(this)}}Object.defineProperty(Readable.prototype,"readableHighWaterMark",{enumerable:false,get:function get(){return this._readableState.highWaterMark}});Object.defineProperty(Readable.prototype,"readableBuffer",{enumerable:false,get:function get(){return this._readableState&&this._readableState.buffer}});Object.defineProperty(Readable.prototype,"readableFlowing",{enumerable:false,get:function get(){return this._readableState.flowing},set:function set(e){if(this._readableState){this._readableState.flowing=e}}});Readable._fromList=fromList;Object.defineProperty(Readable.prototype,"readableLength",{enumerable:false,get:function get(){return this._readableState.length}});function fromList(e,t){if(t.length===0)return null;var r;if(t.objectMode)r=t.buffer.shift();else if(!e||e>=t.length){if(t.decoder)r=t.buffer.join("");else if(t.buffer.length===1)r=t.buffer.first();else r=t.buffer.concat(t.length);t.buffer.clear()}else{r=t.buffer.consume(e,t.decoder)}return r}function endReadable(e){var t=e._readableState;u("endReadable",t.endEmitted);if(!t.endEmitted){t.ended=true;process.nextTick(endReadableNT,t,e)}}function endReadableNT(e,t){u("endReadableNT",e.endEmitted,e.length);if(!e.endEmitted&&e.length===0){e.endEmitted=true;t.readable=false;t.emit("end");if(e.autoDestroy){var r=t._writableState;if(!r||r.autoDestroy&&r.finished){t.destroy()}}}}if(typeof Symbol==="function"){Readable.from=function(e,t){if(S===undefined){S=r(727)}return S(Readable,e,t)}}function indexOf(e,t){for(var r=0,n=e.length;r<n;r++){if(e[r]===t)return r}return-1}},170:function(e,t,r){"use strict";e.exports=Transform;var n=r(646).q,i=n.ERR_METHOD_NOT_IMPLEMENTED,a=n.ERR_MULTIPLE_CALLBACK,o=n.ERR_TRANSFORM_ALREADY_TRANSFORMING,s=n.ERR_TRANSFORM_WITH_LENGTH_0;var f=r(403);r(782)(Transform,f);function afterTransform(e,t){var r=this._transformState;r.transforming=false;var n=r.writecb;if(n===null){return this.emit("error",new a)}r.writechunk=null;r.writecb=null;if(t!=null)this.push(t);n(e);var i=this._readableState;i.reading=false;if(i.needReadable||i.length<i.highWaterMark){this._read(i.highWaterMark)}}function Transform(e){if(!(this instanceof Transform))return new Transform(e);f.call(this,e);this._transformState={afterTransform:afterTransform.bind(this),needTransform:false,transforming:false,writecb:null,writechunk:null,writeencoding:null};this._readableState.needReadable=true;this._readableState.sync=false;if(e){if(typeof e.transform==="function")this._transform=e.transform;if(typeof e.flush==="function")this._flush=e.flush}this.on("prefinish",prefinish)}function prefinish(){var e=this;if(typeof this._flush==="function"&&!this._readableState.destroyed){this._flush((function(t,r){done(e,t,r)}))}else{done(this,null,null)}}Transform.prototype.push=function(e,t){this._transformState.needTransform=false;return f.prototype.push.call(this,e,t)};Transform.prototype._transform=function(e,t,r){r(new i("_transform()"))};Transform.prototype._write=function(e,t,r){var n=this._transformState;n.writecb=r;n.writechunk=e;n.writeencoding=t;if(!n.transforming){var i=this._readableState;if(n.needTransform||i.needReadable||i.length<i.highWaterMark)this._read(i.highWaterMark)}};Transform.prototype._read=function(e){var t=this._transformState;if(t.writechunk!==null&&!t.transforming){t.transforming=true;this._transform(t.writechunk,t.writeencoding,t.afterTransform)}else{t.needTransform=true}};Transform.prototype._destroy=function(e,t){f.prototype._destroy.call(this,e,(function(e){t(e)}))};function done(e,t,r){if(t)return e.emit("error",t);if(r!=null)e.push(r);if(e._writableState.length)throw new s;if(e._transformState.transforming)throw new o;return e.push(null)}},337:function(e,t,r){"use strict";e.exports=Writable;function WriteReq(e,t,r){this.chunk=e;this.encoding=t;this.callback=r;this.next=null}function CorkedRequest(e){var t=this;this.next=null;this.entry=null;this.finish=function(){onCorkedFinish(t,e)}}var n;Writable.WritableState=WritableState;var i={deprecate:r(769)};var a=r(678);var o=r(300).Buffer;var s=__webpack_require__.g.Uint8Array||function(){};function _uint8ArrayToBuffer(e){return o.from(e)}function _isUint8Array(e){return o.isBuffer(e)||e instanceof s}var f=r(25);var l=r(776),u=l.getHighWaterMark;var d=r(646).q,c=d.ERR_INVALID_ARG_TYPE,h=d.ERR_METHOD_NOT_IMPLEMENTED,p=d.ERR_MULTIPLE_CALLBACK,b=d.ERR_STREAM_CANNOT_PIPE,g=d.ERR_STREAM_DESTROYED,y=d.ERR_STREAM_NULL_VALUES,_=d.ERR_STREAM_WRITE_AFTER_END,v=d.ERR_UNKNOWN_ENCODING;var w=f.errorOrDestroy;r(782)(Writable,a);function nop(){}function WritableState(e,t,i){n=n||r(403);e=e||{};if(typeof i!=="boolean")i=t instanceof n;this.objectMode=!!e.objectMode;if(i)this.objectMode=this.objectMode||!!e.writableObjectMode;this.highWaterMark=u(this,e,"writableHighWaterMark",i);this.finalCalled=false;this.needDrain=false;this.ending=false;this.ended=false;this.finished=false;this.destroyed=false;var a=e.decodeStrings===false;this.decodeStrings=!a;this.defaultEncoding=e.defaultEncoding||"utf8";this.length=0;this.writing=false;this.corked=0;this.sync=true;this.bufferProcessing=false;this.onwrite=function(e){onwrite(t,e)};this.writecb=null;this.writelen=0;this.bufferedRequest=null;this.lastBufferedRequest=null;this.pendingcb=0;this.prefinished=false;this.errorEmitted=false;this.emitClose=e.emitClose!==false;this.autoDestroy=!!e.autoDestroy;this.bufferedRequestCount=0;this.corkedRequestsFree=new CorkedRequest(this)}WritableState.prototype.getBuffer=function getBuffer(){var e=this.bufferedRequest;var t=[];while(e){t.push(e);e=e.next}return t};(function(){try{Object.defineProperty(WritableState.prototype,"buffer",{get:i.deprecate((function writableStateBufferGetter(){return this.getBuffer()}),"_writableState.buffer is deprecated. Use _writableState.getBuffer "+"instead.","DEP0003")})}catch(e){}})();var m;if(typeof Symbol==="function"&&Symbol.hasInstance&&typeof Function.prototype[Symbol.hasInstance]==="function"){m=Function.prototype[Symbol.hasInstance];Object.defineProperty(Writable,Symbol.hasInstance,{value:function value(e){if(m.call(this,e))return true;if(this!==Writable)return false;return e&&e._writableState instanceof WritableState}})}else{m=function realHasInstance(e){return e instanceof this}}function Writable(e){n=n||r(403);var t=this instanceof n;if(!t&&!m.call(Writable,this))return new Writable(e);this._writableState=new WritableState(e,this,t);this.writable=true;if(e){if(typeof e.write==="function")this._write=e.write;if(typeof e.writev==="function")this._writev=e.writev;if(typeof e.destroy==="function")this._destroy=e.destroy;if(typeof e.final==="function")this._final=e.final}a.call(this)}Writable.prototype.pipe=function(){w(this,new b)};function writeAfterEnd(e,t){var r=new _;w(e,r);process.nextTick(t,r)}function validChunk(e,t,r,n){var i;if(r===null){i=new y}else if(typeof r!=="string"&&!t.objectMode){i=new c("chunk",["string","Buffer"],r)}if(i){w(e,i);process.nextTick(n,i);return false}return true}Writable.prototype.write=function(e,t,r){var n=this._writableState;var i=false;var a=!n.objectMode&&_isUint8Array(e);if(a&&!o.isBuffer(e)){e=_uint8ArrayToBuffer(e)}if(typeof t==="function"){r=t;t=null}if(a)t="buffer";else if(!t)t=n.defaultEncoding;if(typeof r!=="function")r=nop;if(n.ending)writeAfterEnd(this,r);else if(a||validChunk(this,n,e,r)){n.pendingcb++;i=writeOrBuffer(this,n,a,e,t,r)}return i};Writable.prototype.cork=function(){this._writableState.corked++};Writable.prototype.uncork=function(){var e=this._writableState;if(e.corked){e.corked--;if(!e.writing&&!e.corked&&!e.bufferProcessing&&e.bufferedRequest)clearBuffer(this,e)}};Writable.prototype.setDefaultEncoding=function setDefaultEncoding(e){if(typeof e==="string")e=e.toLowerCase();if(!(["hex","utf8","utf-8","ascii","binary","base64","ucs2","ucs-2","utf16le","utf-16le","raw"].indexOf((e+"").toLowerCase())>-1))throw new v(e);this._writableState.defaultEncoding=e;return this};Object.defineProperty(Writable.prototype,"writableBuffer",{enumerable:false,get:function get(){return this._writableState&&this._writableState.getBuffer()}});function decodeChunk(e,t,r){if(!e.objectMode&&e.decodeStrings!==false&&typeof t==="string"){t=o.from(t,r)}return t}Object.defineProperty(Writable.prototype,"writableHighWaterMark",{enumerable:false,get:function get(){return this._writableState.highWaterMark}});function writeOrBuffer(e,t,r,n,i,a){if(!r){var o=decodeChunk(t,n,i);if(n!==o){r=true;i="buffer";n=o}}var s=t.objectMode?1:n.length;t.length+=s;var f=t.length<t.highWaterMark;if(!f)t.needDrain=true;if(t.writing||t.corked){var l=t.lastBufferedRequest;t.lastBufferedRequest={chunk:n,encoding:i,isBuf:r,callback:a,next:null};if(l){l.next=t.lastBufferedRequest}else{t.bufferedRequest=t.lastBufferedRequest}t.bufferedRequestCount+=1}else{doWrite(e,t,false,s,n,i,a)}return f}function doWrite(e,t,r,n,i,a,o){t.writelen=n;t.writecb=o;t.writing=true;t.sync=true;if(t.destroyed)t.onwrite(new g("write"));else if(r)e._writev(i,t.onwrite);else e._write(i,a,t.onwrite);t.sync=false}function onwriteError(e,t,r,n,i){--t.pendingcb;if(r){process.nextTick(i,n);process.nextTick(finishMaybe,e,t);e._writableState.errorEmitted=true;w(e,n)}else{i(n);e._writableState.errorEmitted=true;w(e,n);finishMaybe(e,t)}}function onwriteStateUpdate(e){e.writing=false;e.writecb=null;e.length-=e.writelen;e.writelen=0}function onwrite(e,t){var r=e._writableState;var n=r.sync;var i=r.writecb;if(typeof i!=="function")throw new p;onwriteStateUpdate(r);if(t)onwriteError(e,r,n,t,i);else{var a=needFinish(r)||e.destroyed;if(!a&&!r.corked&&!r.bufferProcessing&&r.bufferedRequest){clearBuffer(e,r)}if(n){process.nextTick(afterWrite,e,r,a,i)}else{afterWrite(e,r,a,i)}}}function afterWrite(e,t,r,n){if(!r)onwriteDrain(e,t);t.pendingcb--;n();finishMaybe(e,t)}function onwriteDrain(e,t){if(t.length===0&&t.needDrain){t.needDrain=false;e.emit("drain")}}function clearBuffer(e,t){t.bufferProcessing=true;var r=t.bufferedRequest;if(e._writev&&r&&r.next){var n=t.bufferedRequestCount;var i=new Array(n);var a=t.corkedRequestsFree;a.entry=r;var o=0;var s=true;while(r){i[o]=r;if(!r.isBuf)s=false;r=r.next;o+=1}i.allBuffers=s;doWrite(e,t,true,t.length,i,"",a.finish);t.pendingcb++;t.lastBufferedRequest=null;if(a.next){t.corkedRequestsFree=a.next;a.next=null}else{t.corkedRequestsFree=new CorkedRequest(t)}t.bufferedRequestCount=0}else{while(r){var f=r.chunk;var l=r.encoding;var u=r.callback;var d=t.objectMode?1:f.length;doWrite(e,t,false,d,f,l,u);r=r.next;t.bufferedRequestCount--;if(t.writing){break}}if(r===null)t.lastBufferedRequest=null}t.bufferedRequest=r;t.bufferProcessing=false}Writable.prototype._write=function(e,t,r){r(new h("_write()"))};Writable.prototype._writev=null;Writable.prototype.end=function(e,t,r){var n=this._writableState;if(typeof e==="function"){r=e;e=null;t=null}else if(typeof t==="function"){r=t;t=null}if(e!==null&&e!==undefined)this.write(e,t);if(n.corked){n.corked=1;this.uncork()}if(!n.ending)endWritable(this,n,r);return this};Object.defineProperty(Writable.prototype,"writableLength",{enumerable:false,get:function get(){return this._writableState.length}});function needFinish(e){return e.ending&&e.length===0&&e.bufferedRequest===null&&!e.finished&&!e.writing}function callFinal(e,t){e._final((function(r){t.pendingcb--;if(r){w(e,r)}t.prefinished=true;e.emit("prefinish");finishMaybe(e,t)}))}function prefinish(e,t){if(!t.prefinished&&!t.finalCalled){if(typeof e._final==="function"&&!t.destroyed){t.pendingcb++;t.finalCalled=true;process.nextTick(callFinal,e,t)}else{t.prefinished=true;e.emit("prefinish")}}}function finishMaybe(e,t){var r=needFinish(t);if(r){prefinish(e,t);if(t.pendingcb===0){t.finished=true;e.emit("finish");if(t.autoDestroy){var n=e._readableState;if(!n||n.autoDestroy&&n.endEmitted){e.destroy()}}}}return r}function endWritable(e,t,r){t.ending=true;finishMaybe(e,t);if(r){if(t.finished)process.nextTick(r);else e.once("finish",r)}t.ended=true;e.writable=false}function onCorkedFinish(e,t,r){var n=e.entry;e.entry=null;while(n){var i=n.callback;t.pendingcb--;i(r);n=n.next}t.corkedRequestsFree.next=e}Object.defineProperty(Writable.prototype,"destroyed",{enumerable:false,get:function get(){if(this._writableState===undefined){return false}return this._writableState.destroyed},set:function set(e){if(!this._writableState){return}this._writableState.destroyed=e}});Writable.prototype.destroy=f.destroy;Writable.prototype._undestroy=f.undestroy;Writable.prototype._destroy=function(e,t){t(e)}},871:function(e,t,r){"use strict";var n;function _defineProperty(e,t,r){if(t in e){Object.defineProperty(e,t,{value:r,enumerable:true,configurable:true,writable:true})}else{e[t]=r}return e}var i=r(698);var a=Symbol("lastResolve");var o=Symbol("lastReject");var s=Symbol("error");var f=Symbol("ended");var l=Symbol("lastPromise");var u=Symbol("handlePromise");var d=Symbol("stream");function createIterResult(e,t){return{value:e,done:t}}function readAndResolve(e){var t=e[a];if(t!==null){var r=e[d].read();if(r!==null){e[l]=null;e[a]=null;e[o]=null;t(createIterResult(r,false))}}}function onReadable(e){process.nextTick(readAndResolve,e)}function wrapForNext(e,t){return function(r,n){e.then((function(){if(t[f]){r(createIterResult(undefined,true));return}t[u](r,n)}),n)}}var c=Object.getPrototypeOf((function(){}));var h=Object.setPrototypeOf((n={get stream(){return this[d]},next:function next(){var e=this;var t=this[s];if(t!==null){return Promise.reject(t)}if(this[f]){return Promise.resolve(createIterResult(undefined,true))}if(this[d].destroyed){return new Promise((function(t,r){process.nextTick((function(){if(e[s]){r(e[s])}else{t(createIterResult(undefined,true))}}))}))}var r=this[l];var n;if(r){n=new Promise(wrapForNext(r,this))}else{var i=this[d].read();if(i!==null){return Promise.resolve(createIterResult(i,false))}n=new Promise(this[u])}this[l]=n;return n}},_defineProperty(n,Symbol.asyncIterator,(function(){return this})),_defineProperty(n,"return",(function _return(){var e=this;return new Promise((function(t,r){e[d].destroy(null,(function(e){if(e){r(e);return}t(createIterResult(undefined,true))}))}))})),n),c);var p=function createReadableStreamAsyncIterator(e){var t;var r=Object.create(h,(t={},_defineProperty(t,d,{value:e,writable:true}),_defineProperty(t,a,{value:null,writable:true}),_defineProperty(t,o,{value:null,writable:true}),_defineProperty(t,s,{value:null,writable:true}),_defineProperty(t,f,{value:e._readableState.endEmitted,writable:true}),_defineProperty(t,u,{value:function value(e,t){var n=r[d].read();if(n){r[l]=null;r[a]=null;r[o]=null;e(createIterResult(n,false))}else{r[a]=e;r[o]=t}},writable:true}),t));r[l]=null;i(e,(function(e){if(e&&e.code!=="ERR_STREAM_PREMATURE_CLOSE"){var t=r[o];if(t!==null){r[l]=null;r[a]=null;r[o]=null;t(e)}r[s]=e;return}var n=r[a];if(n!==null){r[l]=null;r[a]=null;r[o]=null;n(createIterResult(undefined,true))}r[f]=true}));e.on("readable",onReadable.bind(null,r));return r};e.exports=p},379:function(e,t,r){"use strict";function ownKeys(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(e);if(t)n=n.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}));r.push.apply(r,n)}return r}function _objectSpread(e){for(var t=1;t<arguments.length;t++){var r=arguments[t]!=null?arguments[t]:{};if(t%2){ownKeys(Object(r),true).forEach((function(t){_defineProperty(e,t,r[t])}))}else if(Object.getOwnPropertyDescriptors){Object.defineProperties(e,Object.getOwnPropertyDescriptors(r))}else{ownKeys(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))}))}}return e}function _defineProperty(e,t,r){if(t in e){Object.defineProperty(e,t,{value:r,enumerable:true,configurable:true,writable:true})}else{e[t]=r}return e}function _classCallCheck(e,t){if(!(e instanceof t)){throw new TypeError("Cannot call a class as a function")}}function _defineProperties(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||false;n.configurable=true;if("value"in n)n.writable=true;Object.defineProperty(e,n.key,n)}}function _createClass(e,t,r){if(t)_defineProperties(e.prototype,t);if(r)_defineProperties(e,r);return e}var n=r(300),i=n.Buffer;var a=r(837),o=a.inspect;var s=o&&o.custom||"inspect";function copyBuffer(e,t,r){i.prototype.copy.call(e,t,r)}e.exports=function(){function BufferList(){_classCallCheck(this,BufferList);this.head=null;this.tail=null;this.length=0}_createClass(BufferList,[{key:"push",value:function push(e){var t={data:e,next:null};if(this.length>0)this.tail.next=t;else this.head=t;this.tail=t;++this.length}},{key:"unshift",value:function unshift(e){var t={data:e,next:this.head};if(this.length===0)this.tail=t;this.head=t;++this.length}},{key:"shift",value:function shift(){if(this.length===0)return;var e=this.head.data;if(this.length===1)this.head=this.tail=null;else this.head=this.head.next;--this.length;return e}},{key:"clear",value:function clear(){this.head=this.tail=null;this.length=0}},{key:"join",value:function join(e){if(this.length===0)return"";var t=this.head;var r=""+t.data;while(t=t.next){r+=e+t.data}return r}},{key:"concat",value:function concat(e){if(this.length===0)return i.alloc(0);var t=i.allocUnsafe(e>>>0);var r=this.head;var n=0;while(r){copyBuffer(r.data,t,n);n+=r.data.length;r=r.next}return t}},{key:"consume",value:function consume(e,t){var r;if(e<this.head.data.length){r=this.head.data.slice(0,e);this.head.data=this.head.data.slice(e)}else if(e===this.head.data.length){r=this.shift()}else{r=t?this._getString(e):this._getBuffer(e)}return r}},{key:"first",value:function first(){return this.head.data}},{key:"_getString",value:function _getString(e){var t=this.head;var r=1;var n=t.data;e-=n.length;while(t=t.next){var i=t.data;var a=e>i.length?i.length:e;if(a===i.length)n+=i;else n+=i.slice(0,e);e-=a;if(e===0){if(a===i.length){++r;if(t.next)this.head=t.next;else this.head=this.tail=null}else{this.head=t;t.data=i.slice(a)}break}++r}this.length-=r;return n}},{key:"_getBuffer",value:function _getBuffer(e){var t=i.allocUnsafe(e);var r=this.head;var n=1;r.data.copy(t);e-=r.data.length;while(r=r.next){var a=r.data;var o=e>a.length?a.length:e;a.copy(t,t.length-e,0,o);e-=o;if(e===0){if(o===a.length){++n;if(r.next)this.head=r.next;else this.head=this.tail=null}else{this.head=r;r.data=a.slice(o)}break}++n}this.length-=n;return t}},{key:s,value:function value(e,t){return o(this,_objectSpread({},t,{depth:0,customInspect:false}))}}]);return BufferList}()},25:function(e){"use strict";function destroy(e,t){var r=this;var n=this._readableState&&this._readableState.destroyed;var i=this._writableState&&this._writableState.destroyed;if(n||i){if(t){t(e)}else if(e){if(!this._writableState){process.nextTick(emitErrorNT,this,e)}else if(!this._writableState.errorEmitted){this._writableState.errorEmitted=true;process.nextTick(emitErrorNT,this,e)}}return this}if(this._readableState){this._readableState.destroyed=true}if(this._writableState){this._writableState.destroyed=true}this._destroy(e||null,(function(e){if(!t&&e){if(!r._writableState){process.nextTick(emitErrorAndCloseNT,r,e)}else if(!r._writableState.errorEmitted){r._writableState.errorEmitted=true;process.nextTick(emitErrorAndCloseNT,r,e)}else{process.nextTick(emitCloseNT,r)}}else if(t){process.nextTick(emitCloseNT,r);t(e)}else{process.nextTick(emitCloseNT,r)}}));return this}function emitErrorAndCloseNT(e,t){emitErrorNT(e,t);emitCloseNT(e)}function emitCloseNT(e){if(e._writableState&&!e._writableState.emitClose)return;if(e._readableState&&!e._readableState.emitClose)return;e.emit("close")}function undestroy(){if(this._readableState){this._readableState.destroyed=false;this._readableState.reading=false;this._readableState.ended=false;this._readableState.endEmitted=false}if(this._writableState){this._writableState.destroyed=false;this._writableState.ended=false;this._writableState.ending=false;this._writableState.finalCalled=false;this._writableState.prefinished=false;this._writableState.finished=false;this._writableState.errorEmitted=false}}function emitErrorNT(e,t){e.emit("error",t)}function errorOrDestroy(e,t){var r=e._readableState;var n=e._writableState;if(r&&r.autoDestroy||n&&n.autoDestroy)e.destroy(t);else e.emit("error",t)}e.exports={destroy:destroy,undestroy:undestroy,errorOrDestroy:errorOrDestroy}},698:function(e,t,r){"use strict";var n=r(646).q.ERR_STREAM_PREMATURE_CLOSE;function once(e){var t=false;return function(){if(t)return;t=true;for(var r=arguments.length,n=new Array(r),i=0;i<r;i++){n[i]=arguments[i]}e.apply(this,n)}}function noop(){}function isRequest(e){return e.setHeader&&typeof e.abort==="function"}function eos(e,t,r){if(typeof t==="function")return eos(e,null,t);if(!t)t={};r=once(r||noop);var i=t.readable||t.readable!==false&&e.readable;var a=t.writable||t.writable!==false&&e.writable;var o=function onlegacyfinish(){if(!e.writable)f()};var s=e._writableState&&e._writableState.finished;var f=function onfinish(){a=false;s=true;if(!i)r.call(e)};var l=e._readableState&&e._readableState.endEmitted;var u=function onend(){i=false;l=true;if(!a)r.call(e)};var d=function onerror(t){r.call(e,t)};var c=function onclose(){var t;if(i&&!l){if(!e._readableState||!e._readableState.ended)t=new n;return r.call(e,t)}if(a&&!s){if(!e._writableState||!e._writableState.ended)t=new n;return r.call(e,t)}};var h=function onrequest(){e.req.on("finish",f)};if(isRequest(e)){e.on("complete",f);e.on("abort",c);if(e.req)h();else e.on("request",h)}else if(a&&!e._writableState){e.on("end",o);e.on("close",o)}e.on("end",u);e.on("finish",f);if(t.error!==false)e.on("error",d);e.on("close",c);return function(){e.removeListener("complete",f);e.removeListener("abort",c);e.removeListener("request",h);if(e.req)e.req.removeListener("finish",f);e.removeListener("end",o);e.removeListener("close",o);e.removeListener("finish",f);e.removeListener("end",u);e.removeListener("error",d);e.removeListener("close",c)}}e.exports=eos},727:function(e,t,r){"use strict";function asyncGeneratorStep(e,t,r,n,i,a,o){try{var s=e[a](o);var f=s.value}catch(e){r(e);return}if(s.done){t(f)}else{Promise.resolve(f).then(n,i)}}function _asyncToGenerator(e){return function(){var t=this,r=arguments;return new Promise((function(n,i){var a=e.apply(t,r);function _next(e){asyncGeneratorStep(a,n,i,_next,_throw,"next",e)}function _throw(e){asyncGeneratorStep(a,n,i,_next,_throw,"throw",e)}_next(undefined)}))}}function ownKeys(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(e);if(t)n=n.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}));r.push.apply(r,n)}return r}function _objectSpread(e){for(var t=1;t<arguments.length;t++){var r=arguments[t]!=null?arguments[t]:{};if(t%2){ownKeys(Object(r),true).forEach((function(t){_defineProperty(e,t,r[t])}))}else if(Object.getOwnPropertyDescriptors){Object.defineProperties(e,Object.getOwnPropertyDescriptors(r))}else{ownKeys(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))}))}}return e}function _defineProperty(e,t,r){if(t in e){Object.defineProperty(e,t,{value:r,enumerable:true,configurable:true,writable:true})}else{e[t]=r}return e}var n=r(646).q.ERR_INVALID_ARG_TYPE;function from(e,t,r){var i;if(t&&typeof t.next==="function"){i=t}else if(t&&t[Symbol.asyncIterator])i=t[Symbol.asyncIterator]();else if(t&&t[Symbol.iterator])i=t[Symbol.iterator]();else throw new n("iterable",["Iterable"],t);var a=new e(_objectSpread({objectMode:true},r));var o=false;a._read=function(){if(!o){o=true;next()}};function next(){return _next2.apply(this,arguments)}function _next2(){_next2=_asyncToGenerator((function*(){try{var e=yield i.next(),t=e.value,r=e.done;if(r){a.push(null)}else if(a.push(yield t)){next()}else{o=false}}catch(e){a.destroy(e)}}));return _next2.apply(this,arguments)}return a}e.exports=from},442:function(e,t,r){"use strict";var n;function once(e){var t=false;return function(){if(t)return;t=true;e.apply(void 0,arguments)}}var i=r(646).q,a=i.ERR_MISSING_ARGS,o=i.ERR_STREAM_DESTROYED;function noop(e){if(e)throw e}function isRequest(e){return e.setHeader&&typeof e.abort==="function"}function destroyer(e,t,i,a){a=once(a);var s=false;e.on("close",(function(){s=true}));if(n===undefined)n=r(698);n(e,{readable:t,writable:i},(function(e){if(e)return a(e);s=true;a()}));var f=false;return function(t){if(s)return;if(f)return;f=true;if(isRequest(e))return e.abort();if(typeof e.destroy==="function")return e.destroy();a(t||new o("pipe"))}}function call(e){e()}function pipe(e,t){return e.pipe(t)}function popCallback(e){if(!e.length)return noop;if(typeof e[e.length-1]!=="function")return noop;return e.pop()}function pipeline(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++){t[r]=arguments[r]}var n=popCallback(t);if(Array.isArray(t[0]))t=t[0];if(t.length<2){throw new a("streams")}var i;var o=t.map((function(e,r){var a=r<t.length-1;var s=r>0;return destroyer(e,a,s,(function(e){if(!i)i=e;if(e)o.forEach(call);if(a)return;o.forEach(call);n(i)}))}));return t.reduce(pipe)}e.exports=pipeline},776:function(e,t,r){"use strict";var n=r(646).q.ERR_INVALID_OPT_VALUE;function highWaterMarkFrom(e,t,r){return e.highWaterMark!=null?e.highWaterMark:t?e[r]:null}function getHighWaterMark(e,t,r,i){var a=highWaterMarkFrom(t,i,r);if(a!=null){if(!(isFinite(a)&&Math.floor(a)===a)||a<0){var o=i?r:"highWaterMark";throw new n(o,a)}return Math.floor(a)}return e.objectMode?16:16*1024}e.exports={getHighWaterMark:getHighWaterMark}},678:function(e,t,r){e.exports=r(781)},55:function(e,t,r){var n=r(300);var i=n.Buffer;function copyProps(e,t){for(var r in e){t[r]=e[r]}}if(i.from&&i.alloc&&i.allocUnsafe&&i.allocUnsafeSlow){e.exports=n}else{copyProps(n,t);t.Buffer=SafeBuffer}function SafeBuffer(e,t,r){return i(e,t,r)}SafeBuffer.prototype=Object.create(i.prototype);copyProps(i,SafeBuffer);SafeBuffer.from=function(e,t,r){if(typeof e==="number"){throw new TypeError("Argument must not be a number")}return i(e,t,r)};SafeBuffer.alloc=function(e,t,r){if(typeof e!=="number"){throw new TypeError("Argument must be a number")}var n=i(e);if(t!==undefined){if(typeof r==="string"){n.fill(t,r)}else{n.fill(t)}}else{n.fill(0)}return n};SafeBuffer.allocUnsafe=function(e){if(typeof e!=="number"){throw new TypeError("Argument must be a number")}return i(e)};SafeBuffer.allocUnsafeSlow=function(e){if(typeof e!=="number"){throw new TypeError("Argument must be a number")}return n.SlowBuffer(e)}},173:function(e,t,r){e.exports=Stream;var n=r(361).EventEmitter;var i=r(782);i(Stream,n);Stream.Readable=r(709);Stream.Writable=r(337);Stream.Duplex=r(403);Stream.Transform=r(170);Stream.PassThrough=r(889);Stream.finished=r(698);Stream.pipeline=r(442);Stream.Stream=Stream;function Stream(){n.call(this)}Stream.prototype.pipe=function(e,t){var r=this;function ondata(t){if(e.writable){if(false===e.write(t)&&r.pause){r.pause()}}}r.on("data",ondata);function ondrain(){if(r.readable&&r.resume){r.resume()}}e.on("drain",ondrain);if(!e._isStdio&&(!t||t.end!==false)){r.on("end",onend);r.on("close",onclose)}var i=false;function onend(){if(i)return;i=true;e.end()}function onclose(){if(i)return;i=true;if(typeof e.destroy==="function")e.destroy()}function onerror(e){cleanup();if(n.listenerCount(this,"error")===0){throw e}}r.on("error",onerror);e.on("error",onerror);function cleanup(){r.removeListener("data",ondata);e.removeListener("drain",ondrain);r.removeListener("end",onend);r.removeListener("close",onclose);r.removeListener("error",onerror);e.removeListener("error",onerror);r.removeListener("end",cleanup);r.removeListener("close",cleanup);e.removeListener("close",cleanup)}r.on("end",cleanup);r.on("close",cleanup);e.on("close",cleanup);e.emit("pipe",r);return e}},704:function(e,t,r){"use strict";var n=r(55).Buffer;var i=n.isEncoding||function(e){e=""+e;switch(e&&e.toLowerCase()){case"hex":case"utf8":case"utf-8":case"ascii":case"binary":case"base64":case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":case"raw":return true;default:return false}};function _normalizeEncoding(e){if(!e)return"utf8";var t;while(true){switch(e){case"utf8":case"utf-8":return"utf8";case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return"utf16le";case"latin1":case"binary":return"latin1";case"base64":case"ascii":case"hex":return e;default:if(t)return;e=(""+e).toLowerCase();t=true}}}function normalizeEncoding(e){var t=_normalizeEncoding(e);if(typeof t!=="string"&&(n.isEncoding===i||!i(e)))throw new Error("Unknown encoding: "+e);return t||e}t.s=StringDecoder;function StringDecoder(e){this.encoding=normalizeEncoding(e);var t;switch(this.encoding){case"utf16le":this.text=utf16Text;this.end=utf16End;t=4;break;case"utf8":this.fillLast=utf8FillLast;t=4;break;case"base64":this.text=base64Text;this.end=base64End;t=3;break;default:this.write=simpleWrite;this.end=simpleEnd;return}this.lastNeed=0;this.lastTotal=0;this.lastChar=n.allocUnsafe(t)}StringDecoder.prototype.write=function(e){if(e.length===0)return"";var t;var r;if(this.lastNeed){t=this.fillLast(e);if(t===undefined)return"";r=this.lastNeed;this.lastNeed=0}else{r=0}if(r<e.length)return t?t+this.text(e,r):this.text(e,r);return t||""};StringDecoder.prototype.end=utf8End;StringDecoder.prototype.text=utf8Text;StringDecoder.prototype.fillLast=function(e){if(this.lastNeed<=e.length){e.copy(this.lastChar,this.lastTotal-this.lastNeed,0,this.lastNeed);return this.lastChar.toString(this.encoding,0,this.lastTotal)}e.copy(this.lastChar,this.lastTotal-this.lastNeed,0,e.length);this.lastNeed-=e.length};function utf8CheckByte(e){if(e<=127)return 0;else if(e>>5===6)return 2;else if(e>>4===14)return 3;else if(e>>3===30)return 4;return e>>6===2?-1:-2}function utf8CheckIncomplete(e,t,r){var n=t.length-1;if(n<r)return 0;var i=utf8CheckByte(t[n]);if(i>=0){if(i>0)e.lastNeed=i-1;return i}if(--n<r||i===-2)return 0;i=utf8CheckByte(t[n]);if(i>=0){if(i>0)e.lastNeed=i-2;return i}if(--n<r||i===-2)return 0;i=utf8CheckByte(t[n]);if(i>=0){if(i>0){if(i===2)i=0;else e.lastNeed=i-3}return i}return 0}function utf8CheckExtraBytes(e,t,r){if((t[0]&192)!==128){e.lastNeed=0;return"�"}if(e.lastNeed>1&&t.length>1){if((t[1]&192)!==128){e.lastNeed=1;return"�"}if(e.lastNeed>2&&t.length>2){if((t[2]&192)!==128){e.lastNeed=2;return"�"}}}}function utf8FillLast(e){var t=this.lastTotal-this.lastNeed;var r=utf8CheckExtraBytes(this,e,t);if(r!==undefined)return r;if(this.lastNeed<=e.length){e.copy(this.lastChar,t,0,this.lastNeed);return this.lastChar.toString(this.encoding,0,this.lastTotal)}e.copy(this.lastChar,t,0,e.length);this.lastNeed-=e.length}function utf8Text(e,t){var r=utf8CheckIncomplete(this,e,t);if(!this.lastNeed)return e.toString("utf8",t);this.lastTotal=r;var n=e.length-(r-this.lastNeed);e.copy(this.lastChar,0,n);return e.toString("utf8",t,n)}function utf8End(e){var t=e&&e.length?this.write(e):"";if(this.lastNeed)return t+"�";return t}function utf16Text(e,t){if((e.length-t)%2===0){var r=e.toString("utf16le",t);if(r){var n=r.charCodeAt(r.length-1);if(n>=55296&&n<=56319){this.lastNeed=2;this.lastTotal=4;this.lastChar[0]=e[e.length-2];this.lastChar[1]=e[e.length-1];return r.slice(0,-1)}}return r}this.lastNeed=1;this.lastTotal=2;this.lastChar[0]=e[e.length-1];return e.toString("utf16le",t,e.length-1)}function utf16End(e){var t=e&&e.length?this.write(e):"";if(this.lastNeed){var r=this.lastTotal-this.lastNeed;return t+this.lastChar.toString("utf16le",0,r)}return t}function base64Text(e,t){var r=(e.length-t)%3;if(r===0)return e.toString("base64",t);this.lastNeed=3-r;this.lastTotal=3;if(r===1){this.lastChar[0]=e[e.length-1]}else{this.lastChar[0]=e[e.length-2];this.lastChar[1]=e[e.length-1]}return e.toString("base64",t,e.length-r)}function base64End(e){var t=e&&e.length?this.write(e):"";if(this.lastNeed)return t+this.lastChar.toString("base64",0,3-this.lastNeed);return t}function simpleWrite(e){return e.toString(this.encoding)}function simpleEnd(e){return e&&e.length?this.write(e):""}},769:function(e){e.exports=deprecate;function deprecate(e,t){if(config("noDeprecation")){return e}var r=false;function deprecated(){if(!r){if(config("throwDeprecation")){throw new Error(t)}else if(config("traceDeprecation")){console.trace(t)}else{console.warn(t)}r=true}return e.apply(this,arguments)}return deprecated}function config(e){try{if(!__webpack_require__.g.localStorage)return false}catch(e){return false}var t=__webpack_require__.g.localStorage[e];if(null==t)return false;return String(t).toLowerCase()==="true"}},300:function(e){"use strict";e.exports=__webpack_require__(30816)},361:function(e){"use strict";e.exports=__webpack_require__(50343)},781:function(e){"use strict";e.exports=(__webpack_require__(50343).EventEmitter)},837:function(e){"use strict";e.exports=__webpack_require__(71323)}};var t={};function __nccwpck_require__(r){var n=t[r];if(n!==undefined){return n.exports}var i=t[r]={exports:{}};var a=true;try{e[r](i,i.exports,__nccwpck_require__);a=false}finally{if(a)delete t[r]}return i.exports}if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var r=__nccwpck_require__(173);module.exports=r})();

/***/ }),

/***/ 69410:
/***/ (function(module) {

var __dirname = "/";
(function(){var __webpack_modules__={950:function(__unused_webpack_module,exports){var indexOf=function(e,t){if(e.indexOf)return e.indexOf(t);else for(var r=0;r<e.length;r++){if(e[r]===t)return r}return-1};var Object_keys=function(e){if(Object.keys)return Object.keys(e);else{var t=[];for(var r in e)t.push(r);return t}};var forEach=function(e,t){if(e.forEach)return e.forEach(t);else for(var r=0;r<e.length;r++){t(e[r],r,e)}};var defineProp=function(){try{Object.defineProperty({},"_",{});return function(e,t,r){Object.defineProperty(e,t,{writable:true,enumerable:false,configurable:true,value:r})}}catch(e){return function(e,t,r){e[t]=r}}}();var globals=["Array","Boolean","Date","Error","EvalError","Function","Infinity","JSON","Math","NaN","Number","Object","RangeError","ReferenceError","RegExp","String","SyntaxError","TypeError","URIError","decodeURI","decodeURIComponent","encodeURI","encodeURIComponent","escape","eval","isFinite","isNaN","parseFloat","parseInt","undefined","unescape"];function Context(){}Context.prototype={};var Script=exports.Script=function NodeScript(e){if(!(this instanceof Script))return new Script(e);this.code=e};Script.prototype.runInContext=function(e){if(!(e instanceof Context)){throw new TypeError("needs a 'context' argument.")}var t=document.createElement("iframe");if(!t.style)t.style={};t.style.display="none";document.body.appendChild(t);var r=t.contentWindow;var n=r.eval,o=r.execScript;if(!n&&o){o.call(r,"null");n=r.eval}forEach(Object_keys(e),(function(t){r[t]=e[t]}));forEach(globals,(function(t){if(e[t]){r[t]=e[t]}}));var c=Object_keys(r);var i=n.call(r,this.code);forEach(Object_keys(r),(function(t){if(t in e||indexOf(c,t)===-1){e[t]=r[t]}}));forEach(globals,(function(t){if(!(t in e)){defineProp(e,t,r[t])}}));document.body.removeChild(t);return i};Script.prototype.runInThisContext=function(){return eval(this.code)};Script.prototype.runInNewContext=function(e){var t=Script.createContext(e);var r=this.runInContext(t);if(e){forEach(Object_keys(t),(function(r){e[r]=t[r]}))}return r};forEach(Object_keys(Script.prototype),(function(e){exports[e]=Script[e]=function(t){var r=Script(t);return r[e].apply(r,[].slice.call(arguments,1))}}));exports.isContext=function(e){return e instanceof Context};exports.createScript=function(e){return exports.Script(e)};exports.createContext=Script.createContext=function(e){var t=new Context;if(typeof e==="object"){forEach(Object_keys(e),(function(r){t[r]=e[r]}))}return t}}};if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var __webpack_exports__={};__webpack_modules__[950](0,__webpack_exports__);module.exports=__webpack_exports__})();

/***/ }),

/***/ 65218:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(29906)


/***/ }),

/***/ 88038:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(80555)


/***/ }),

/***/ 79894:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(11453)


/***/ }),

/***/ 86677:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(15817)


/***/ }),

/***/ 43218:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(17162)


/***/ }),

/***/ 15798:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.destroyCookie = exports.setCookie = exports.parseCookies = void 0;
var cookie = __webpack_require__(34882);
var setCookieParser = __webpack_require__(88319);
var utils_1 = __webpack_require__(84480);
/**
 * Parses cookies.
 *
 * @param ctx NextJS page or API context, express context, null or undefined.
 * @param options Options that we pass down to `cookie` library.
 */
function parseCookies(ctx, options) {
    var _a, _b;
    if ((_b = (_a = ctx === null || ctx === void 0 ? void 0 : ctx.req) === null || _a === void 0 ? void 0 : _a.headers) === null || _b === void 0 ? void 0 : _b.cookie) {
        return cookie.parse(ctx.req.headers.cookie, options);
    }
    if (utils_1.isBrowser()) {
        return cookie.parse(document.cookie, options);
    }
    return {};
}
exports.parseCookies = parseCookies;
/**
 * Sets a cookie.
 *
 * @param ctx NextJS page or API context, express context, null or undefined.
 * @param name The name of your cookie.
 * @param value The value of your cookie.
 * @param options Options that we pass down to `cookie` library.
 */
function setCookie(ctx, name, value, options) {
    var _a, _b;
    if (options === void 0) { options = {}; }
    // SSR
    if (((_a = ctx === null || ctx === void 0 ? void 0 : ctx.res) === null || _a === void 0 ? void 0 : _a.getHeader) && ctx.res.setHeader) {
        // Check if response has finished and warn about it.
        if ((_b = ctx === null || ctx === void 0 ? void 0 : ctx.res) === null || _b === void 0 ? void 0 : _b.finished) {
            console.warn("Not setting \"" + name + "\" cookie. Response has finished.");
            console.warn("You should set cookie before res.send()");
            return {};
        }
        /**
         * Load existing cookies from the header and parse them.
         */
        var cookies = ctx.res.getHeader('Set-Cookie') || [];
        if (typeof cookies === 'string')
            cookies = [cookies];
        if (typeof cookies === 'number')
            cookies = [];
        /**
         * Parse cookies but ignore values - we've already encoded
         * them in the previous call.
         */
        var parsedCookies = setCookieParser.parse(cookies, {
            decodeValues: false,
        });
        /**
         * We create the new cookie and make sure that none of
         * the existing cookies match it.
         */
        var newCookie_1 = utils_1.createCookie(name, value, options);
        var cookiesToSet_1 = [];
        parsedCookies.forEach(function (parsedCookie) {
            if (!utils_1.areCookiesEqual(parsedCookie, newCookie_1)) {
                /**
                 * We serialize the cookie back to the original format
                 * if it isn't the same as the new one.
                 */
                var serializedCookie = cookie.serialize(parsedCookie.name, parsedCookie.value, __assign({ 
                    // we prevent reencoding by default, but you might override it
                    encode: function (val) { return val; } }, parsedCookie));
                cookiesToSet_1.push(serializedCookie);
            }
        });
        cookiesToSet_1.push(cookie.serialize(name, value, options));
        // Update the header.
        ctx.res.setHeader('Set-Cookie', cookiesToSet_1);
    }
    // Browser
    if (utils_1.isBrowser()) {
        if (options && options.httpOnly) {
            throw new Error('Can not set a httpOnly cookie in the browser.');
        }
        document.cookie = cookie.serialize(name, value, options);
    }
    return {};
}
exports.setCookie = setCookie;
/**
 * Destroys a cookie with a particular name.
 *
 * @param ctx NextJS page or API context, express context, null or undefined.
 * @param name Cookie name.
 * @param options Options that we pass down to `cookie` library.
 */
function destroyCookie(ctx, name, options) {
    /**
     * We forward the request destroy to setCookie function
     * as it is the same function with modified maxAge value.
     */
    return setCookie(ctx, name, '', __assign(__assign({}, (options || {})), { maxAge: -1 }));
}
exports.destroyCookie = destroyCookie;
/* Utility Exports */
exports["default"] = {
    set: setCookie,
    get: parseCookies,
    destroy: destroyCookie,
};
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 84480:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.areCookiesEqual = exports.hasSameProperties = exports.createCookie = exports.isBrowser = void 0;
/**
 * Tells whether we are in a browser or server.
 */
function isBrowser() {
    return typeof window !== 'undefined';
}
exports.isBrowser = isBrowser;
/**
 * Create an instance of the Cookie interface
 */
function createCookie(name, value, options) {
    var sameSite = options.sameSite;
    if (sameSite === true) {
        sameSite = 'strict';
    }
    if (sameSite === undefined || sameSite === false) {
        sameSite = 'lax';
    }
    var cookieToSet = __assign(__assign({}, options), { sameSite: sameSite });
    delete cookieToSet.encode;
    return __assign({ name: name, value: value }, cookieToSet);
}
exports.createCookie = createCookie;
/**
 * Tells whether given objects have the same properties.
 */
function hasSameProperties(a, b) {
    var aProps = Object.getOwnPropertyNames(a);
    var bProps = Object.getOwnPropertyNames(b);
    if (aProps.length !== bProps.length) {
        return false;
    }
    for (var i = 0; i < aProps.length; i++) {
        var propName = aProps[i];
        if (a[propName] !== b[propName]) {
            return false;
        }
    }
    return true;
}
exports.hasSameProperties = hasSameProperties;
/**
 * Compare the cookie and return true if the cookies have equivalent
 * options and the cookies would be overwritten in the browser storage.
 *
 * @param a first Cookie for comparison
 * @param b second Cookie for comparison
 */
function areCookiesEqual(a, b) {
    var sameSiteSame = a.sameSite === b.sameSite;
    if (typeof a.sameSite === 'string' && typeof b.sameSite === 'string') {
        sameSiteSame = a.sameSite.toLowerCase() === b.sameSite.toLowerCase();
    }
    return (hasSameProperties(__assign(__assign({}, a), { sameSite: undefined }), __assign(__assign({}, b), { sameSite: undefined })) && sameSiteSame);
}
exports.areCookiesEqual = areCookiesEqual;
/* Functions */
//# sourceMappingURL=utils.js.map

/***/ }),

/***/ 27061:
/***/ (function(module) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),

/***/ 58772:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(90331);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ 23615:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) { var throwOnDirectAccess, ReactIs; } else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(58772)();
}


/***/ }),

/***/ 90331:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),

/***/ 9889:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(576);

/***/ }),

/***/ 60720:
/***/ (function(module, exports, __webpack_require__) {

var arrayUniq = __webpack_require__(9686);

function Charset() {
  this.chars = '';
}

Charset.prototype.setType = function(type) {
  var chars;

  var numbers     = '0123456789';
  var charsLower  = 'abcdefghijklmnopqrstuvwxyz';
  var charsUpper  = charsLower.toUpperCase();
  var hexChars    = 'abcdef';
  var binaryChars = '01';
  var octalChars  = '01234567';

  if (type === 'alphanumeric') {
    chars = numbers + charsLower + charsUpper;
  }
  else if (type === 'numeric') {
    chars = numbers;
  }
  else if (type === 'alphabetic') {
    chars = charsLower + charsUpper;
  }
  else if (type === 'hex') {
    chars = numbers + hexChars;
  }
  else if (type === 'binary') {
    chars = binaryChars;
  }
  else if (type === 'octal') {
    chars = octalChars;
  }
  else {
    chars = type;
  }

  this.chars = chars;
}

Charset.prototype.removeUnreadable = function() {
  var unreadableChars = /[0OIl]/g;
  this.chars = this.chars.replace(unreadableChars, '');
}

Charset.prototype.setcapitalization = function(capitalization) {
  if (capitalization === 'uppercase') {
    this.chars = this.chars.toUpperCase();
  }
  else if (capitalization === 'lowercase') {
    this.chars = this.chars.toLowerCase();
  }
}

Charset.prototype.removeDuplicates = function() {
  var charMap = this.chars.split('');
  charMap = arrayUniq(charMap);
  this.chars = charMap.join('');
}

module.exports = exports = Charset;


/***/ }),

/***/ 576:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var randomBytes = __webpack_require__(40917);
var Charset = __webpack_require__(60720);


function unsafeRandomBytes(length) {
  var stack = [];
  for (var i = 0; i < length; i++) {
    stack.push(Math.floor(Math.random() * 255));
  }

  return {
    length,
    readUInt8: function (index) {
      return stack[index];
    }
  };
}

function safeRandomBytes(length) {
  try {
    return randomBytes(length);
  } catch (e) {
    /* React/React Native Fix + Eternal loop removed */
    return unsafeRandomBytes(length);
  }
}

function processString(buf, initialString, chars, reqLen, maxByte) {
  var string = initialString;
  for (var i = 0; i < buf.length && string.length < reqLen; i++) {
    var randomByte = buf.readUInt8(i);
    if (randomByte < maxByte) {
      string += chars.charAt(randomByte % chars.length);
    }
  }
  return string;
}

function getAsyncString(string, chars, length, maxByte, cb) {
  randomBytes(length, function(err, buf) {
    if (err) {
      // Since it is waiting for entropy, errors are legit and we shouldn't just keep retrying
      cb(err);
    }
    var generatedString = processString(buf, string, chars, length, maxByte);
    if (generatedString.length < length) {
      getAsyncString(generatedString, chars, length, maxByte, cb);
    } else {
      cb(null, generatedString);
    }
  })
}

exports.generate = function(options, cb) {
  var charset = new Charset();

  var length, chars, capitalization, string = '';

  // Handle options
  if (typeof options === 'object') {
    length = typeof options.length === 'number' ? options.length : 32;

    if (options.charset) {
      charset.setType(options.charset);
    }
    else {
      charset.setType('alphanumeric');
    }

    if (options.capitalization) {
      charset.setcapitalization(options.capitalization);
    }

    if (options.readable) {
      charset.removeUnreadable();
    }

    charset.removeDuplicates();
  }
  else if (typeof options === 'number') {
    length = options;
    charset.setType('alphanumeric');
  }
  else {
    length = 32;
    charset.setType('alphanumeric');
  }

  // Generate the string
  var charsLen = charset.chars.length;
  var maxByte = 256 - (256 % charsLen);

  if (!cb) {
    while (string.length < length) {
      var buf = safeRandomBytes(Math.ceil(length * 256 / maxByte));
      string = processString(buf, string, charset.chars, length, maxByte);
    }

    return string;
  }

  getAsyncString(string, charset.chars, length, maxByte, cb);

};


/***/ }),

/***/ 40917:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* provided dependency */ var Buffer = __webpack_require__(30816)["Buffer"];
/* provided dependency */ var process = __webpack_require__(27061);


function oldBrowser () {
  throw new Error('secure random number generation not supported by this browser\nuse chrome, FireFox or Internet Explorer 11')
}

var crypto = __webpack_require__.g.crypto || __webpack_require__.g.msCrypto

if (crypto && crypto.getRandomValues) {
  module.exports = randomBytes
} else {
  module.exports = oldBrowser
}

function randomBytes (size, cb) {
  // phantomjs needs to throw
  if (size > 65536) throw new Error('requested too many random bytes')
  // in case browserify  isn't using the Uint8Array version
  var rawBytes = new __webpack_require__.g.Uint8Array(size)

  // This will not work in older browsers.
  // See https://developer.mozilla.org/en-US/docs/Web/API/window.crypto.getRandomValues
  if (size > 0) {  // getRandomValues fails on IE if size == 0
    crypto.getRandomValues(rawBytes)
  }
  // phantomjs doesn't like a buffer being passed here
  var bytes = new Buffer(rawBytes.buffer)

  if (typeof cb === 'function') {
    return process.nextTick(function () {
      cb(null, bytes)
    })
  }

  return bytes
}


/***/ }),

/***/ 93451:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gc": function() { return /* binding */ useFormContext; },
/* harmony export */   "RV": function() { return /* binding */ FormProvider; },
/* harmony export */   "cI": function() { return /* binding */ useForm; }
/* harmony export */ });
/* unused harmony exports Controller, appendErrors, get, transformToNestObject, useController, useFieldArray, useWatch */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);


var isHTMLElement = (value) => value instanceof HTMLElement;

const EVENTS = {
    BLUR: 'blur',
    CHANGE: 'change',
    INPUT: 'input',
};
const VALIDATION_MODE = {
    onBlur: 'onBlur',
    onChange: 'onChange',
    onSubmit: 'onSubmit',
    onTouched: 'onTouched',
    all: 'all',
};
const SELECT = 'select';
const UNDEFINED = 'undefined';
const INPUT_VALIDATION_RULES = {
    max: 'max',
    min: 'min',
    maxLength: 'maxLength',
    minLength: 'minLength',
    pattern: 'pattern',
    required: 'required',
    validate: 'validate',
};

function attachEventListeners({ ref }, shouldAttachChangeEvent, handleChange) {
    if (isHTMLElement(ref) && handleChange) {
        ref.addEventListener(shouldAttachChangeEvent ? EVENTS.CHANGE : EVENTS.INPUT, handleChange);
        ref.addEventListener(EVENTS.BLUR, handleChange);
    }
}

var isNullOrUndefined = (value) => value == null;

const isObjectType = (value) => typeof value === 'object';
var isObject = (value) => !isNullOrUndefined(value) &&
    !Array.isArray(value) &&
    isObjectType(value) &&
    !(value instanceof Date);

var isKey = (value) => /^\w*$/.test(value);

var compact = (value) => value.filter(Boolean);

var stringToPath = (input) => compact(input
    .replace(/["|']/g, '')
    .replace(/\[/g, '.')
    .replace(/\]/g, '')
    .split('.'));

function set(object, path, value) {
    let index = -1;
    const tempPath = isKey(path) ? [path] : stringToPath(path);
    const length = tempPath.length;
    const lastIndex = length - 1;
    while (++index < length) {
        const key = tempPath[index];
        let newValue = value;
        if (index !== lastIndex) {
            const objValue = object[key];
            newValue =
                isObject(objValue) || Array.isArray(objValue)
                    ? objValue
                    : !isNaN(+tempPath[index + 1])
                        ? []
                        : {};
        }
        object[key] = newValue;
        object = object[key];
    }
    return object;
}

var transformToNestObject = (data, value = {}) => {
    for (const key in data) {
        !isKey(key) ? set(value, key, data[key]) : (value[key] = data[key]);
    }
    return value;
};

var isUndefined = (val) => val === undefined;

var get = (obj = {}, path, defaultValue) => {
    const result = compact(path.split(/[,[\].]+?/)).reduce((result, key) => (isNullOrUndefined(result) ? result : result[key]), obj);
    return isUndefined(result) || result === obj
        ? isUndefined(obj[path])
            ? defaultValue
            : obj[path]
        : result;
};

var focusOnErrorField = (fields, fieldErrors) => {
    for (const key in fields) {
        if (get(fieldErrors, key)) {
            const field = fields[key];
            if (field) {
                if (field.ref.focus && isUndefined(field.ref.focus())) {
                    break;
                }
                else if (field.options) {
                    field.options[0].ref.focus();
                    break;
                }
            }
        }
    }
};

var removeAllEventListeners = (ref, validateWithStateUpdate) => {
    if (isHTMLElement(ref) && ref.removeEventListener) {
        ref.removeEventListener(EVENTS.INPUT, validateWithStateUpdate);
        ref.removeEventListener(EVENTS.CHANGE, validateWithStateUpdate);
        ref.removeEventListener(EVENTS.BLUR, validateWithStateUpdate);
    }
};

const defaultReturn = {
    isValid: false,
    value: null,
};
var getRadioValue = (options) => Array.isArray(options)
    ? options.reduce((previous, option) => option && option.ref.checked
        ? {
            isValid: true,
            value: option.ref.value,
        }
        : previous, defaultReturn)
    : defaultReturn;

var getMultipleSelectValue = (options) => [...options]
    .filter(({ selected }) => selected)
    .map(({ value }) => value);

var isRadioInput = (element) => element.type === 'radio';

var isFileInput = (element) => element.type === 'file';

var isCheckBoxInput = (element) => element.type === 'checkbox';

var isMultipleSelect = (element) => element.type === `${SELECT}-multiple`;

const defaultResult = {
    value: false,
    isValid: false,
};
const validResult = { value: true, isValid: true };
var getCheckboxValue = (options) => {
    if (Array.isArray(options)) {
        if (options.length > 1) {
            const values = options
                .filter((option) => option && option.ref.checked)
                .map(({ ref: { value } }) => value);
            return { value: values, isValid: !!values.length };
        }
        const { checked, value, attributes } = options[0].ref;
        return checked
            ? attributes && !isUndefined(attributes.value)
                ? isUndefined(value) || value === ''
                    ? validResult
                    : { value: value, isValid: true }
                : validResult
            : defaultResult;
    }
    return defaultResult;
};

function getFieldValue(fieldsRef, name, shallowFieldsStateRef, excludeDisabled, shouldKeepRawValue) {
    const field = fieldsRef.current[name];
    if (field) {
        const { ref: { value, disabled }, ref, valueAsNumber, valueAsDate, setValueAs, } = field;
        if (disabled && excludeDisabled) {
            return;
        }
        if (isFileInput(ref)) {
            return ref.files;
        }
        if (isRadioInput(ref)) {
            return getRadioValue(field.options).value;
        }
        if (isMultipleSelect(ref)) {
            return getMultipleSelectValue(ref.options);
        }
        if (isCheckBoxInput(ref)) {
            return getCheckboxValue(field.options).value;
        }
        return shouldKeepRawValue
            ? value
            : valueAsNumber
                ? value === ''
                    ? NaN
                    : +value
                : valueAsDate
                    ? ref.valueAsDate
                    : setValueAs
                        ? setValueAs(value)
                        : value;
    }
    if (shallowFieldsStateRef) {
        return get(shallowFieldsStateRef.current, name);
    }
}

function isDetached(element) {
    if (!element) {
        return true;
    }
    if (!(element instanceof HTMLElement) ||
        element.nodeType === Node.DOCUMENT_NODE) {
        return false;
    }
    return isDetached(element.parentNode);
}

var isEmptyObject = (value) => isObject(value) && !Object.keys(value).length;

var isBoolean = (value) => typeof value === 'boolean';

function baseGet(object, updatePath) {
    const length = updatePath.slice(0, -1).length;
    let index = 0;
    while (index < length) {
        object = isUndefined(object) ? index++ : object[updatePath[index++]];
    }
    return object;
}
function unset(object, path) {
    const updatePath = isKey(path) ? [path] : stringToPath(path);
    const childObject = updatePath.length == 1 ? object : baseGet(object, updatePath);
    const key = updatePath[updatePath.length - 1];
    let previousObjRef;
    if (childObject) {
        delete childObject[key];
    }
    for (let k = 0; k < updatePath.slice(0, -1).length; k++) {
        let index = -1;
        let objectRef;
        const currentPaths = updatePath.slice(0, -(k + 1));
        const currentPathsLength = currentPaths.length - 1;
        if (k > 0) {
            previousObjRef = object;
        }
        while (++index < currentPaths.length) {
            const item = currentPaths[index];
            objectRef = objectRef ? objectRef[item] : object[item];
            if (currentPathsLength === index &&
                ((isObject(objectRef) && isEmptyObject(objectRef)) ||
                    (Array.isArray(objectRef) &&
                        !objectRef.filter((data) => (isObject(data) && !isEmptyObject(data)) || isBoolean(data)).length))) {
                previousObjRef ? delete previousObjRef[item] : delete object[item];
            }
            previousObjRef = objectRef;
        }
    }
    return object;
}

const isSameRef = (fieldValue, ref) => fieldValue && fieldValue.ref === ref;
function findRemovedFieldAndRemoveListener(fieldsRef, handleChange, field, shallowFieldsStateRef, shouldUnregister, forceDelete) {
    const { ref, ref: { name }, } = field;
    const fieldRef = fieldsRef.current[name];
    if (!shouldUnregister) {
        const value = getFieldValue(fieldsRef, name, shallowFieldsStateRef);
        !isUndefined(value) && set(shallowFieldsStateRef.current, name, value);
    }
    if (!ref.type || !fieldRef) {
        delete fieldsRef.current[name];
        return;
    }
    if (isRadioInput(ref) || isCheckBoxInput(ref)) {
        if (Array.isArray(fieldRef.options) && fieldRef.options.length) {
            compact(fieldRef.options).forEach((option = {}, index) => {
                if ((isDetached(option.ref) && isSameRef(option, option.ref)) ||
                    forceDelete) {
                    removeAllEventListeners(option.ref, handleChange);
                    unset(fieldRef.options, `[${index}]`);
                }
            });
            if (fieldRef.options && !compact(fieldRef.options).length) {
                delete fieldsRef.current[name];
            }
        }
        else {
            delete fieldsRef.current[name];
        }
    }
    else if ((isDetached(ref) && isSameRef(fieldRef, ref)) || forceDelete) {
        removeAllEventListeners(ref, handleChange);
        delete fieldsRef.current[name];
    }
}

var isPrimitive = (value) => isNullOrUndefined(value) || !isObjectType(value);

function deepMerge(target, source) {
    if (isPrimitive(target) || isPrimitive(source)) {
        return source;
    }
    for (const key in source) {
        const targetValue = target[key];
        const sourceValue = source[key];
        try {
            target[key] =
                (isObject(targetValue) && isObject(sourceValue)) ||
                    (Array.isArray(targetValue) && Array.isArray(sourceValue))
                    ? deepMerge(targetValue, sourceValue)
                    : sourceValue;
        }
        catch (_a) { }
    }
    return target;
}

function deepEqual(object1, object2, isErrorObject) {
    if (isPrimitive(object1) ||
        isPrimitive(object2) ||
        object1 instanceof Date ||
        object2 instanceof Date) {
        return object1 === object2;
    }
    if (!(0,react__WEBPACK_IMPORTED_MODULE_0__.isValidElement)(object1)) {
        const keys1 = Object.keys(object1);
        const keys2 = Object.keys(object2);
        if (keys1.length !== keys2.length) {
            return false;
        }
        for (const key of keys1) {
            const val1 = object1[key];
            if (!(isErrorObject && key === 'ref')) {
                const val2 = object2[key];
                if ((isObject(val1) || Array.isArray(val1)) &&
                    (isObject(val2) || Array.isArray(val2))
                    ? !deepEqual(val1, val2, isErrorObject)
                    : val1 !== val2) {
                    return false;
                }
            }
        }
    }
    return true;
}

function setDirtyFields(values, defaultValues, dirtyFields, parentNode, parentName) {
    let index = -1;
    while (++index < values.length) {
        for (const key in values[index]) {
            if (Array.isArray(values[index][key])) {
                !dirtyFields[index] && (dirtyFields[index] = {});
                dirtyFields[index][key] = [];
                setDirtyFields(values[index][key], get(defaultValues[index] || {}, key, []), dirtyFields[index][key], dirtyFields[index], key);
            }
            else {
                deepEqual(get(defaultValues[index] || {}, key), values[index][key])
                    ? set(dirtyFields[index] || {}, key)
                    : (dirtyFields[index] = Object.assign(Object.assign({}, dirtyFields[index]), { [key]: true }));
            }
        }
        parentNode &&
            !dirtyFields.length &&
            delete parentNode[parentName];
    }
    return dirtyFields;
}
var setFieldArrayDirtyFields = (values, defaultValues, dirtyFields) => deepMerge(setDirtyFields(values, defaultValues, dirtyFields.slice(0, values.length)), setDirtyFields(defaultValues, values, dirtyFields.slice(0, values.length)));

var isString = (value) => typeof value === 'string';

var getFieldsValues = (fieldsRef, shallowFieldsState, shouldUnregister, excludeDisabled, search) => {
    const output = {};
    for (const name in fieldsRef.current) {
        if (isUndefined(search) ||
            (isString(search)
                ? name.startsWith(search)
                : Array.isArray(search) && search.find((data) => name.startsWith(data)))) {
            output[name] = getFieldValue(fieldsRef, name, undefined, excludeDisabled);
        }
    }
    return shouldUnregister
        ? transformToNestObject(output)
        : deepMerge(shallowFieldsState, transformToNestObject(output));
};

var isErrorStateChanged = ({ errors, name, error, validFields, fieldsWithValidation, }) => {
    const isValid = isUndefined(error);
    const previousError = get(errors, name);
    return ((isValid && !!previousError) ||
        (!isValid && !deepEqual(previousError, error, true)) ||
        (isValid && get(fieldsWithValidation, name) && !get(validFields, name)));
};

var isRegex = (value) => value instanceof RegExp;

var getValueAndMessage = (validationData) => isObject(validationData) && !isRegex(validationData)
    ? validationData
    : {
        value: validationData,
        message: '',
    };

var isFunction = (value) => typeof value === 'function';

var isMessage = (value) => isString(value) || (0,react__WEBPACK_IMPORTED_MODULE_0__.isValidElement)(value);

function getValidateError(result, ref, type = 'validate') {
    if (isMessage(result) || (isBoolean(result) && !result)) {
        return {
            type,
            message: isMessage(result) ? result : '',
            ref,
        };
    }
}

var appendErrors = (name, validateAllFieldCriteria, errors, type, message) => validateAllFieldCriteria
    ? Object.assign(Object.assign({}, errors[name]), { types: Object.assign(Object.assign({}, (errors[name] && errors[name].types ? errors[name].types : {})), { [type]: message || true }) }) : {};

var validateField = async (fieldsRef, validateAllFieldCriteria, { ref, ref: { value }, options, required, maxLength, minLength, min, max, pattern, validate, }, shallowFieldsStateRef) => {
    const name = ref.name;
    const error = {};
    const isRadio = isRadioInput(ref);
    const isCheckBox = isCheckBoxInput(ref);
    const isRadioOrCheckbox = isRadio || isCheckBox;
    const isEmpty = value === '';
    const appendErrorsCurry = appendErrors.bind(null, name, validateAllFieldCriteria, error);
    const getMinMaxMessage = (exceedMax, maxLengthMessage, minLengthMessage, maxType = INPUT_VALIDATION_RULES.maxLength, minType = INPUT_VALIDATION_RULES.minLength) => {
        const message = exceedMax ? maxLengthMessage : minLengthMessage;
        error[name] = Object.assign({ type: exceedMax ? maxType : minType, message,
            ref }, (exceedMax
            ? appendErrorsCurry(maxType, message)
            : appendErrorsCurry(minType, message)));
    };
    if (required &&
        ((!isRadio && !isCheckBox && (isEmpty || isNullOrUndefined(value))) ||
            (isBoolean(value) && !value) ||
            (isCheckBox && !getCheckboxValue(options).isValid) ||
            (isRadio && !getRadioValue(options).isValid))) {
        const { value, message } = isMessage(required)
            ? { value: !!required, message: required }
            : getValueAndMessage(required);
        if (value) {
            error[name] = Object.assign({ type: INPUT_VALIDATION_RULES.required, message, ref: isRadioOrCheckbox
                    ? ((fieldsRef.current[name].options || [])[0] || {}).ref
                    : ref }, appendErrorsCurry(INPUT_VALIDATION_RULES.required, message));
            if (!validateAllFieldCriteria) {
                return error;
            }
        }
    }
    if ((!isNullOrUndefined(min) || !isNullOrUndefined(max)) && value !== '') {
        let exceedMax;
        let exceedMin;
        const maxOutput = getValueAndMessage(max);
        const minOutput = getValueAndMessage(min);
        if (!isNaN(value)) {
            const valueNumber = ref.valueAsNumber || parseFloat(value);
            if (!isNullOrUndefined(maxOutput.value)) {
                exceedMax = valueNumber > maxOutput.value;
            }
            if (!isNullOrUndefined(minOutput.value)) {
                exceedMin = valueNumber < minOutput.value;
            }
        }
        else {
            const valueDate = ref.valueAsDate || new Date(value);
            if (isString(maxOutput.value)) {
                exceedMax = valueDate > new Date(maxOutput.value);
            }
            if (isString(minOutput.value)) {
                exceedMin = valueDate < new Date(minOutput.value);
            }
        }
        if (exceedMax || exceedMin) {
            getMinMaxMessage(!!exceedMax, maxOutput.message, minOutput.message, INPUT_VALIDATION_RULES.max, INPUT_VALIDATION_RULES.min);
            if (!validateAllFieldCriteria) {
                return error;
            }
        }
    }
    if (isString(value) && !isEmpty && (maxLength || minLength)) {
        const maxLengthOutput = getValueAndMessage(maxLength);
        const minLengthOutput = getValueAndMessage(minLength);
        const exceedMax = !isNullOrUndefined(maxLengthOutput.value) &&
            value.length > maxLengthOutput.value;
        const exceedMin = !isNullOrUndefined(minLengthOutput.value) &&
            value.length < minLengthOutput.value;
        if (exceedMax || exceedMin) {
            getMinMaxMessage(exceedMax, maxLengthOutput.message, minLengthOutput.message);
            if (!validateAllFieldCriteria) {
                return error;
            }
        }
    }
    if (isString(value) && pattern && !isEmpty) {
        const { value: patternValue, message } = getValueAndMessage(pattern);
        if (isRegex(patternValue) && !patternValue.test(value)) {
            error[name] = Object.assign({ type: INPUT_VALIDATION_RULES.pattern, message,
                ref }, appendErrorsCurry(INPUT_VALIDATION_RULES.pattern, message));
            if (!validateAllFieldCriteria) {
                return error;
            }
        }
    }
    if (validate) {
        const fieldValue = getFieldValue(fieldsRef, name, shallowFieldsStateRef, false, true);
        const validateRef = isRadioOrCheckbox && options ? options[0].ref : ref;
        if (isFunction(validate)) {
            const result = await validate(fieldValue);
            const validateError = getValidateError(result, validateRef);
            if (validateError) {
                error[name] = Object.assign(Object.assign({}, validateError), appendErrorsCurry(INPUT_VALIDATION_RULES.validate, validateError.message));
                if (!validateAllFieldCriteria) {
                    return error;
                }
            }
        }
        else if (isObject(validate)) {
            let validationResult = {};
            for (const [key, validateFunction] of Object.entries(validate)) {
                if (!isEmptyObject(validationResult) && !validateAllFieldCriteria) {
                    break;
                }
                const validateResult = await validateFunction(fieldValue);
                const validateError = getValidateError(validateResult, validateRef, key);
                if (validateError) {
                    validationResult = Object.assign(Object.assign({}, validateError), appendErrorsCurry(key, validateError.message));
                    if (validateAllFieldCriteria) {
                        error[name] = validationResult;
                    }
                }
            }
            if (!isEmptyObject(validationResult)) {
                error[name] = Object.assign({ ref: validateRef }, validationResult);
                if (!validateAllFieldCriteria) {
                    return error;
                }
            }
        }
    }
    return error;
};

const getPath = (rootPath, values, paths = []) => {
    for (const property in values) {
        const rootName = (rootPath +
            (isObject(values)
                ? `.${property}`
                : `[${property}]`));
        isPrimitive(values[property])
            ? paths.push(rootName)
            : getPath(rootName, values[property], paths);
    }
    return paths;
};

var assignWatchFields = (fieldValues, fieldName, watchFields, inputValue, isSingleField) => {
    let value = undefined;
    watchFields.add(fieldName);
    if (!isEmptyObject(fieldValues)) {
        value = get(fieldValues, fieldName);
        if (isObject(value) || Array.isArray(value)) {
            getPath(fieldName, value).forEach((name) => watchFields.add(name));
        }
    }
    return isUndefined(value)
        ? isSingleField
            ? inputValue
            : get(inputValue, fieldName)
        : value;
};

var skipValidation = ({ isOnBlur, isOnChange, isOnTouch, isTouched, isReValidateOnBlur, isReValidateOnChange, isBlurEvent, isSubmitted, isOnAll, }) => {
    if (isOnAll) {
        return false;
    }
    else if (!isSubmitted && isOnTouch) {
        return !(isTouched || isBlurEvent);
    }
    else if (isSubmitted ? isReValidateOnBlur : isOnBlur) {
        return !isBlurEvent;
    }
    else if (isSubmitted ? isReValidateOnChange : isOnChange) {
        return isBlurEvent;
    }
    return true;
};

var getFieldArrayParentName = (name) => name.substring(0, name.indexOf('['));

const isMatchFieldArrayName = (name, searchName) => RegExp(`^${searchName}([|.)\\d+`.replace(/\[/g, '\\[').replace(/\]/g, '\\]')).test(name);
var isNameInFieldArray = (names, name) => [...names].some((current) => isMatchFieldArrayName(name, current));

var isSelectInput = (element) => element.type === `${SELECT}-one`;

function onDomRemove(fieldsRef, removeFieldEventListenerAndRef) {
    const observer = new MutationObserver(() => {
        for (const field of Object.values(fieldsRef.current)) {
            if (field && field.options) {
                for (const option of field.options) {
                    if (option && option.ref && isDetached(option.ref)) {
                        removeFieldEventListenerAndRef(field);
                    }
                }
            }
            else if (field && isDetached(field.ref)) {
                removeFieldEventListenerAndRef(field);
            }
        }
    });
    observer.observe(window.document, {
        childList: true,
        subtree: true,
    });
    return observer;
}

var isWeb = typeof window !== UNDEFINED && typeof document !== UNDEFINED;

function cloneObject(data) {
    var _a;
    let copy;
    if (isPrimitive(data) ||
        (isWeb && (data instanceof File || isHTMLElement(data)))) {
        return data;
    }
    if (!['Set', 'Map', 'Object', 'Date', 'Array'].includes((_a = data.constructor) === null || _a === void 0 ? void 0 : _a.name)) {
        return data;
    }
    if (data instanceof Date) {
        copy = new Date(data.getTime());
        return copy;
    }
    if (data instanceof Set) {
        copy = new Set();
        for (const item of data) {
            copy.add(item);
        }
        return copy;
    }
    if (data instanceof Map) {
        copy = new Map();
        for (const key of data.keys()) {
            copy.set(key, cloneObject(data.get(key)));
        }
        return copy;
    }
    copy = Array.isArray(data) ? [] : {};
    for (const key in data) {
        copy[key] = cloneObject(data[key]);
    }
    return copy;
}

var modeChecker = (mode) => ({
    isOnSubmit: !mode || mode === VALIDATION_MODE.onSubmit,
    isOnBlur: mode === VALIDATION_MODE.onBlur,
    isOnChange: mode === VALIDATION_MODE.onChange,
    isOnAll: mode === VALIDATION_MODE.all,
    isOnTouch: mode === VALIDATION_MODE.onTouched,
});

var isRadioOrCheckboxFunction = (ref) => isRadioInput(ref) || isCheckBoxInput(ref);

const isWindowUndefined = typeof window === UNDEFINED;
const isProxyEnabled = isWeb ? 'Proxy' in window : typeof Proxy !== UNDEFINED;
function useForm({ mode = VALIDATION_MODE.onSubmit, reValidateMode = VALIDATION_MODE.onChange, resolver, context, defaultValues = {}, shouldFocusError = true, shouldUnregister = true, criteriaMode, } = {}) {
    const fieldsRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)({});
    const fieldArrayDefaultValuesRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)({});
    const fieldArrayValuesRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)({});
    const watchFieldsRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(new Set());
    const useWatchFieldsRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)({});
    const useWatchRenderFunctionsRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)({});
    const fieldsWithValidationRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)({});
    const validFieldsRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)({});
    const defaultValuesRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(defaultValues);
    const isUnMount = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
    const isWatchAllRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
    const handleChangeRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
    const shallowFieldsStateRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)({});
    const resetFieldArrayFunctionRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)({});
    const contextRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(context);
    const resolverRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(resolver);
    const fieldArrayNamesRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(new Set());
    const modeRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(modeChecker(mode));
    const { isOnSubmit, isOnTouch } = modeRef.current;
    const isValidateAllFieldCriteria = criteriaMode === VALIDATION_MODE.all;
    const [formState, setFormState] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
        isDirty: false,
        isValidating: false,
        dirtyFields: {},
        isSubmitted: false,
        submitCount: 0,
        touched: {},
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: !isOnSubmit,
        errors: {},
    });
    const readFormStateRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)({
        isDirty: !isProxyEnabled,
        dirtyFields: !isProxyEnabled,
        touched: !isProxyEnabled || isOnTouch,
        isValidating: !isProxyEnabled,
        isSubmitting: !isProxyEnabled,
        isValid: !isProxyEnabled,
    });
    const formStateRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(formState);
    const observerRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
    const { isOnBlur: isReValidateOnBlur, isOnChange: isReValidateOnChange, } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(modeChecker(reValidateMode)).current;
    contextRef.current = context;
    resolverRef.current = resolver;
    formStateRef.current = formState;
    shallowFieldsStateRef.current = shouldUnregister
        ? {}
        : isEmptyObject(shallowFieldsStateRef.current)
            ? cloneObject(defaultValues)
            : shallowFieldsStateRef.current;
    const updateFormState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((state = {}) => {
        if (!isUnMount.current) {
            formStateRef.current = Object.assign(Object.assign({}, formStateRef.current), state);
            setFormState(formStateRef.current);
        }
    }, []);
    const updateIsValidating = () => readFormStateRef.current.isValidating &&
        updateFormState({
            isValidating: true,
        });
    const shouldRenderBaseOnError = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((name, error, shouldRender = false, state = {}, isValid) => {
        let shouldReRender = shouldRender ||
            isErrorStateChanged({
                errors: formStateRef.current.errors,
                error,
                name,
                validFields: validFieldsRef.current,
                fieldsWithValidation: fieldsWithValidationRef.current,
            });
        const previousError = get(formStateRef.current.errors, name);
        if (error) {
            unset(validFieldsRef.current, name);
            shouldReRender =
                shouldReRender ||
                    !previousError ||
                    !deepEqual(previousError, error, true);
            set(formStateRef.current.errors, name, error);
        }
        else {
            if (get(fieldsWithValidationRef.current, name) || resolverRef.current) {
                set(validFieldsRef.current, name, true);
                shouldReRender = shouldReRender || previousError;
            }
            unset(formStateRef.current.errors, name);
        }
        if ((shouldReRender && !isNullOrUndefined(shouldRender)) ||
            !isEmptyObject(state) ||
            readFormStateRef.current.isValidating) {
            updateFormState(Object.assign(Object.assign(Object.assign({}, state), (resolverRef.current ? { isValid: !!isValid } : {})), { isValidating: false }));
        }
    }, []);
    const setFieldValue = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((name, rawValue) => {
        const { ref, options } = fieldsRef.current[name];
        const value = isWeb && isHTMLElement(ref) && isNullOrUndefined(rawValue)
            ? ''
            : rawValue;
        if (isRadioInput(ref)) {
            (options || []).forEach(({ ref: radioRef }) => (radioRef.checked = radioRef.value === value));
        }
        else if (isFileInput(ref) && !isString(value)) {
            ref.files = value;
        }
        else if (isMultipleSelect(ref)) {
            [...ref.options].forEach((selectRef) => (selectRef.selected = value.includes(selectRef.value)));
        }
        else if (isCheckBoxInput(ref) && options) {
            options.length > 1
                ? options.forEach(({ ref: checkboxRef }) => (checkboxRef.checked = Array.isArray(value)
                    ? !!value.find((data) => data === checkboxRef.value)
                    : value === checkboxRef.value))
                : (options[0].ref.checked = !!value);
        }
        else {
            ref.value = value;
        }
    }, []);
    const isFormDirty = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((name, data) => {
        if (readFormStateRef.current.isDirty) {
            const formValues = getValues();
            name && data && set(formValues, name, data);
            return !deepEqual(formValues, defaultValuesRef.current);
        }
        return false;
    }, []);
    const updateAndGetDirtyState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((name, shouldRender = true) => {
        if (readFormStateRef.current.isDirty ||
            readFormStateRef.current.dirtyFields) {
            const isFieldDirty = !deepEqual(get(defaultValuesRef.current, name), getFieldValue(fieldsRef, name, shallowFieldsStateRef));
            const isDirtyFieldExist = get(formStateRef.current.dirtyFields, name);
            const previousIsDirty = formStateRef.current.isDirty;
            isFieldDirty
                ? set(formStateRef.current.dirtyFields, name, true)
                : unset(formStateRef.current.dirtyFields, name);
            const state = {
                isDirty: isFormDirty(),
                dirtyFields: formStateRef.current.dirtyFields,
            };
            const isChanged = (readFormStateRef.current.isDirty &&
                previousIsDirty !== state.isDirty) ||
                (readFormStateRef.current.dirtyFields &&
                    isDirtyFieldExist !== get(formStateRef.current.dirtyFields, name));
            isChanged && shouldRender && updateFormState(state);
            return isChanged ? state : {};
        }
        return {};
    }, []);
    const executeValidation = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(async (name, skipReRender) => {
        if (false) {}
        const error = (await validateField(fieldsRef, isValidateAllFieldCriteria, fieldsRef.current[name], shallowFieldsStateRef))[name];
        shouldRenderBaseOnError(name, error, skipReRender);
        return isUndefined(error);
    }, [shouldRenderBaseOnError, isValidateAllFieldCriteria]);
    const executeSchemaOrResolverValidation = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(async (names) => {
        const { errors } = await resolverRef.current(getValues(), contextRef.current, isValidateAllFieldCriteria);
        const previousFormIsValid = formStateRef.current.isValid;
        if (Array.isArray(names)) {
            const isInputsValid = names
                .map((name) => {
                const error = get(errors, name);
                error
                    ? set(formStateRef.current.errors, name, error)
                    : unset(formStateRef.current.errors, name);
                return !error;
            })
                .every(Boolean);
            updateFormState({
                isValid: isEmptyObject(errors),
                isValidating: false,
            });
            return isInputsValid;
        }
        else {
            const error = get(errors, names);
            shouldRenderBaseOnError(names, error, previousFormIsValid !== isEmptyObject(errors), {}, isEmptyObject(errors));
            return !error;
        }
    }, [shouldRenderBaseOnError, isValidateAllFieldCriteria]);
    const trigger = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(async (name) => {
        const fields = name || Object.keys(fieldsRef.current);
        updateIsValidating();
        if (resolverRef.current) {
            return executeSchemaOrResolverValidation(fields);
        }
        if (Array.isArray(fields)) {
            !name && (formStateRef.current.errors = {});
            const result = await Promise.all(fields.map(async (data) => await executeValidation(data, null)));
            updateFormState({
                isValidating: false,
            });
            return result.every(Boolean);
        }
        return await executeValidation(fields);
    }, [executeSchemaOrResolverValidation, executeValidation]);
    const setInternalValues = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((name, value, { shouldDirty, shouldValidate }) => {
        const data = {};
        set(data, name, value);
        for (const fieldName of getPath(name, value)) {
            if (fieldsRef.current[fieldName]) {
                setFieldValue(fieldName, get(data, fieldName));
                shouldDirty && updateAndGetDirtyState(fieldName);
                shouldValidate && trigger(fieldName);
            }
        }
    }, [trigger, setFieldValue, updateAndGetDirtyState]);
    const setInternalValue = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((name, value, config) => {
        !shouldUnregister &&
            !isPrimitive(value) &&
            set(shallowFieldsStateRef.current, name, Array.isArray(value) ? [...value] : Object.assign({}, value));
        if (fieldsRef.current[name]) {
            setFieldValue(name, value);
            config.shouldDirty && updateAndGetDirtyState(name);
            config.shouldValidate && trigger(name);
        }
        else if (!isPrimitive(value)) {
            setInternalValues(name, value, config);
            if (fieldArrayNamesRef.current.has(name)) {
                const parentName = getFieldArrayParentName(name) || name;
                set(fieldArrayDefaultValuesRef.current, name, value);
                resetFieldArrayFunctionRef.current[parentName]({
                    [parentName]: get(fieldArrayDefaultValuesRef.current, parentName),
                });
                if ((readFormStateRef.current.isDirty ||
                    readFormStateRef.current.dirtyFields) &&
                    config.shouldDirty) {
                    set(formStateRef.current.dirtyFields, name, setFieldArrayDirtyFields(value, get(defaultValuesRef.current, name, []), get(formStateRef.current.dirtyFields, name, [])));
                    updateFormState({
                        isDirty: !deepEqual(Object.assign(Object.assign({}, getValues()), { [name]: value }), defaultValuesRef.current),
                    });
                }
            }
        }
        !shouldUnregister && set(shallowFieldsStateRef.current, name, value);
    }, [updateAndGetDirtyState, setFieldValue, setInternalValues]);
    const isFieldWatched = (name) => isWatchAllRef.current ||
        watchFieldsRef.current.has(name) ||
        watchFieldsRef.current.has((name.match(/\w+/) || [])[0]);
    const renderWatchedInputs = (name) => {
        let found = true;
        if (!isEmptyObject(useWatchFieldsRef.current)) {
            for (const key in useWatchFieldsRef.current) {
                if (!name ||
                    !useWatchFieldsRef.current[key].size ||
                    useWatchFieldsRef.current[key].has(name) ||
                    useWatchFieldsRef.current[key].has(getFieldArrayParentName(name))) {
                    useWatchRenderFunctionsRef.current[key]();
                    found = false;
                }
            }
        }
        return found;
    };
    function setValue(name, value, config) {
        setInternalValue(name, value, config || {});
        isFieldWatched(name) && updateFormState();
        renderWatchedInputs(name);
    }
    handleChangeRef.current = handleChangeRef.current
        ? handleChangeRef.current
        : async ({ type, target }) => {
            let name = target.name;
            const field = fieldsRef.current[name];
            let error;
            let isValid;
            if (field) {
                const isBlurEvent = type === EVENTS.BLUR;
                const shouldSkipValidation = skipValidation(Object.assign({ isBlurEvent,
                    isReValidateOnChange,
                    isReValidateOnBlur, isTouched: !!get(formStateRef.current.touched, name), isSubmitted: formStateRef.current.isSubmitted }, modeRef.current));
                let state = updateAndGetDirtyState(name, false);
                let shouldRender = !isEmptyObject(state) ||
                    (!isBlurEvent && isFieldWatched(name));
                if (isBlurEvent &&
                    !get(formStateRef.current.touched, name) &&
                    readFormStateRef.current.touched) {
                    set(formStateRef.current.touched, name, true);
                    state = Object.assign(Object.assign({}, state), { touched: formStateRef.current.touched });
                }
                if (!shouldUnregister && isCheckBoxInput(target)) {
                    set(shallowFieldsStateRef.current, name, getFieldValue(fieldsRef, name));
                }
                if (shouldSkipValidation) {
                    !isBlurEvent && renderWatchedInputs(name);
                    return ((!isEmptyObject(state) ||
                        (shouldRender && isEmptyObject(state))) &&
                        updateFormState(state));
                }
                updateIsValidating();
                if (resolverRef.current) {
                    const { errors } = await resolverRef.current(getValues(), contextRef.current, isValidateAllFieldCriteria);
                    const previousFormIsValid = formStateRef.current.isValid;
                    error = get(errors, name);
                    if (isCheckBoxInput(target) &&
                        !error &&
                        resolverRef.current) {
                        const parentNodeName = getFieldArrayParentName(name);
                        const currentError = get(errors, parentNodeName, {});
                        currentError.type &&
                            currentError.message &&
                            (error = currentError);
                        if (parentNodeName &&
                            (currentError ||
                                get(formStateRef.current.errors, parentNodeName))) {
                            name = parentNodeName;
                        }
                    }
                    isValid = isEmptyObject(errors);
                    previousFormIsValid !== isValid && (shouldRender = true);
                }
                else {
                    error = (await validateField(fieldsRef, isValidateAllFieldCriteria, field, shallowFieldsStateRef))[name];
                }
                !isBlurEvent && renderWatchedInputs(name);
                shouldRenderBaseOnError(name, error, shouldRender, state, isValid);
            }
        };
    function setFieldArrayDefaultValues(data) {
        if (!shouldUnregister) {
            let copy = cloneObject(data);
            for (const value of fieldArrayNamesRef.current) {
                if (isKey(value) && !copy[value]) {
                    copy = Object.assign(Object.assign({}, copy), { [value]: [] });
                }
            }
            return copy;
        }
        return data;
    }
    function getValues(payload) {
        if (isString(payload)) {
            return getFieldValue(fieldsRef, payload, shallowFieldsStateRef);
        }
        if (Array.isArray(payload)) {
            const data = {};
            for (const name of payload) {
                set(data, name, getFieldValue(fieldsRef, name, shallowFieldsStateRef));
            }
            return data;
        }
        return setFieldArrayDefaultValues(getFieldsValues(fieldsRef, cloneObject(shallowFieldsStateRef.current), shouldUnregister));
    }
    const validateResolver = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(async (values = {}) => {
        const newDefaultValues = isEmptyObject(fieldsRef.current)
            ? defaultValuesRef.current
            : {};
        const { errors } = (await resolverRef.current(Object.assign(Object.assign(Object.assign({}, newDefaultValues), getValues()), values), contextRef.current, isValidateAllFieldCriteria)) || {};
        const isValid = isEmptyObject(errors);
        formStateRef.current.isValid !== isValid &&
            updateFormState({
                isValid,
            });
    }, [isValidateAllFieldCriteria]);
    const removeFieldEventListener = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((field, forceDelete) => {
        findRemovedFieldAndRemoveListener(fieldsRef, handleChangeRef.current, field, shallowFieldsStateRef, shouldUnregister, forceDelete);
        if (shouldUnregister) {
            unset(validFieldsRef.current, field.ref.name);
            unset(fieldsWithValidationRef.current, field.ref.name);
        }
    }, [shouldUnregister]);
    const updateWatchedValue = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((name) => {
        if (isWatchAllRef.current) {
            updateFormState();
        }
        else {
            for (const watchField of watchFieldsRef.current) {
                if (watchField.startsWith(name)) {
                    updateFormState();
                    break;
                }
            }
            renderWatchedInputs(name);
        }
    }, []);
    const removeFieldEventListenerAndRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((field, forceDelete) => {
        if (field) {
            removeFieldEventListener(field, forceDelete);
            if (shouldUnregister && !compact(field.options || []).length) {
                unset(formStateRef.current.errors, field.ref.name);
                set(formStateRef.current.dirtyFields, field.ref.name, true);
                updateFormState({
                    isDirty: isFormDirty(),
                });
                readFormStateRef.current.isValid &&
                    resolverRef.current &&
                    validateResolver();
                updateWatchedValue(field.ref.name);
            }
        }
    }, [validateResolver, removeFieldEventListener]);
    function clearErrors(name) {
        name &&
            (Array.isArray(name) ? name : [name]).forEach((inputName) => fieldsRef.current[inputName] && isKey(inputName)
                ? delete formStateRef.current.errors[inputName]
                : unset(formStateRef.current.errors, inputName));
        updateFormState({
            errors: name ? formStateRef.current.errors : {},
        });
    }
    function setError(name, error) {
        const ref = (fieldsRef.current[name] || {}).ref;
        set(formStateRef.current.errors, name, Object.assign(Object.assign({}, error), { ref }));
        updateFormState({
            isValid: false,
        });
        error.shouldFocus && ref && ref.focus && ref.focus();
    }
    const watchInternal = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((fieldNames, defaultValue, watchId) => {
        const watchFields = watchId
            ? useWatchFieldsRef.current[watchId]
            : watchFieldsRef.current;
        let fieldValues = getFieldsValues(fieldsRef, cloneObject(shallowFieldsStateRef.current), shouldUnregister, false, fieldNames);
        if (isString(fieldNames)) {
            const parentNodeName = getFieldArrayParentName(fieldNames) || fieldNames;
            if (fieldArrayNamesRef.current.has(parentNodeName)) {
                fieldValues = Object.assign(Object.assign({}, fieldArrayValuesRef.current), fieldValues);
            }
            return assignWatchFields(fieldValues, fieldNames, watchFields, isUndefined(get(defaultValuesRef.current, fieldNames))
                ? defaultValue
                : get(defaultValuesRef.current, fieldNames), true);
        }
        const combinedDefaultValues = isUndefined(defaultValue)
            ? defaultValuesRef.current
            : defaultValue;
        if (Array.isArray(fieldNames)) {
            return fieldNames.reduce((previous, name) => (Object.assign(Object.assign({}, previous), { [name]: assignWatchFields(fieldValues, name, watchFields, combinedDefaultValues) })), {});
        }
        isWatchAllRef.current = isUndefined(watchId);
        return transformToNestObject((!isEmptyObject(fieldValues) && fieldValues) ||
            combinedDefaultValues);
    }, []);
    function watch(fieldNames, defaultValue) {
        return watchInternal(fieldNames, defaultValue);
    }
    function unregister(name) {
        for (const fieldName of Array.isArray(name) ? name : [name]) {
            removeFieldEventListenerAndRef(fieldsRef.current[fieldName], true);
        }
    }
    function registerFieldRef(ref, options = {}) {
        if (false) {}
        const { name, type, value } = ref;
        const fieldRefAndValidationOptions = Object.assign({ ref }, options);
        const fields = fieldsRef.current;
        const isRadioOrCheckbox = isRadioOrCheckboxFunction(ref);
        const isFieldArray = isNameInFieldArray(fieldArrayNamesRef.current, name);
        const compareRef = (currentRef) => isWeb && (!isHTMLElement(ref) || currentRef === ref);
        let field = fields[name];
        let isEmptyDefaultValue = true;
        let defaultValue;
        if (field &&
            (isRadioOrCheckbox
                ? Array.isArray(field.options) &&
                    compact(field.options).find((option) => {
                        return value === option.ref.value && compareRef(option.ref);
                    })
                : compareRef(field.ref))) {
            fields[name] = Object.assign(Object.assign({}, field), options);
            return;
        }
        if (type) {
            field = isRadioOrCheckbox
                ? Object.assign({ options: [
                        ...compact((field && field.options) || []),
                        {
                            ref,
                        },
                    ], ref: { type, name } }, options) : Object.assign({}, fieldRefAndValidationOptions);
        }
        else {
            field = fieldRefAndValidationOptions;
        }
        fields[name] = field;
        const isEmptyUnmountFields = isUndefined(get(shallowFieldsStateRef.current, name));
        if (!isEmptyObject(defaultValuesRef.current) || !isEmptyUnmountFields) {
            defaultValue = get(isEmptyUnmountFields
                ? defaultValuesRef.current
                : shallowFieldsStateRef.current, name);
            isEmptyDefaultValue = isUndefined(defaultValue);
            if (!isEmptyDefaultValue && !isFieldArray) {
                setFieldValue(name, defaultValue);
            }
        }
        if (!isEmptyObject(options)) {
            set(fieldsWithValidationRef.current, name, true);
            if (!isOnSubmit && readFormStateRef.current.isValid) {
                validateField(fieldsRef, isValidateAllFieldCriteria, field, shallowFieldsStateRef).then((error) => {
                    const previousFormIsValid = formStateRef.current.isValid;
                    isEmptyObject(error)
                        ? set(validFieldsRef.current, name, true)
                        : unset(validFieldsRef.current, name);
                    previousFormIsValid !== isEmptyObject(error) && updateFormState();
                });
            }
        }
        if (shouldUnregister && !(isFieldArray && isEmptyDefaultValue)) {
            !isFieldArray && unset(formStateRef.current.dirtyFields, name);
        }
        if (type) {
            attachEventListeners(isRadioOrCheckbox && field.options
                ? field.options[field.options.length - 1]
                : field, isRadioOrCheckbox || isSelectInput(ref), handleChangeRef.current);
        }
    }
    function register(refOrRegisterOptions, options) {
        if (!isWindowUndefined) {
            if (isString(refOrRegisterOptions)) {
                registerFieldRef({ name: refOrRegisterOptions }, options);
            }
            else if (isObject(refOrRegisterOptions) &&
                'name' in refOrRegisterOptions) {
                registerFieldRef(refOrRegisterOptions, options);
            }
            else {
                return (ref) => ref && registerFieldRef(ref, refOrRegisterOptions);
            }
        }
    }
    const handleSubmit = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((onValid, onInvalid) => async (e) => {
        if (e && e.preventDefault) {
            e.preventDefault();
            e.persist();
        }
        let fieldErrors = {};
        let fieldValues = setFieldArrayDefaultValues(getFieldsValues(fieldsRef, cloneObject(shallowFieldsStateRef.current), shouldUnregister, true));
        readFormStateRef.current.isSubmitting &&
            updateFormState({
                isSubmitting: true,
            });
        try {
            if (resolverRef.current) {
                const { errors, values } = await resolverRef.current(fieldValues, contextRef.current, isValidateAllFieldCriteria);
                formStateRef.current.errors = fieldErrors = errors;
                fieldValues = values;
            }
            else {
                for (const field of Object.values(fieldsRef.current)) {
                    if (field) {
                        const { name } = field.ref;
                        const fieldError = await validateField(fieldsRef, isValidateAllFieldCriteria, field, shallowFieldsStateRef);
                        if (fieldError[name]) {
                            set(fieldErrors, name, fieldError[name]);
                            unset(validFieldsRef.current, name);
                        }
                        else if (get(fieldsWithValidationRef.current, name)) {
                            unset(formStateRef.current.errors, name);
                            set(validFieldsRef.current, name, true);
                        }
                    }
                }
            }
            if (isEmptyObject(fieldErrors) &&
                Object.keys(formStateRef.current.errors).every((name) => name in fieldsRef.current)) {
                updateFormState({
                    errors: {},
                    isSubmitting: true,
                });
                await onValid(fieldValues, e);
            }
            else {
                formStateRef.current.errors = Object.assign(Object.assign({}, formStateRef.current.errors), fieldErrors);
                onInvalid && (await onInvalid(formStateRef.current.errors, e));
                shouldFocusError &&
                    focusOnErrorField(fieldsRef.current, formStateRef.current.errors);
            }
        }
        finally {
            formStateRef.current.isSubmitting = false;
            updateFormState({
                isSubmitted: true,
                isSubmitting: false,
                isSubmitSuccessful: isEmptyObject(formStateRef.current.errors),
                submitCount: formStateRef.current.submitCount + 1,
            });
        }
    }, [shouldFocusError, isValidateAllFieldCriteria]);
    const resetRefs = ({ errors, isDirty, isSubmitted, touched, isValid, submitCount, dirtyFields, }) => {
        if (!isValid) {
            validFieldsRef.current = {};
            fieldsWithValidationRef.current = {};
        }
        fieldArrayDefaultValuesRef.current = {};
        watchFieldsRef.current = new Set();
        isWatchAllRef.current = false;
        updateFormState({
            submitCount: submitCount ? formStateRef.current.submitCount : 0,
            isDirty: isDirty ? formStateRef.current.isDirty : false,
            isSubmitted: isSubmitted ? formStateRef.current.isSubmitted : false,
            isValid: isValid ? formStateRef.current.isValid : false,
            dirtyFields: dirtyFields ? formStateRef.current.dirtyFields : {},
            touched: touched ? formStateRef.current.touched : {},
            errors: errors ? formStateRef.current.errors : {},
            isSubmitting: false,
            isSubmitSuccessful: false,
        });
    };
    const reset = (values, omitResetState = {}) => {
        if (isWeb) {
            for (const field of Object.values(fieldsRef.current)) {
                if (field) {
                    const { ref, options } = field;
                    const inputRef = isRadioOrCheckboxFunction(ref) && Array.isArray(options)
                        ? options[0].ref
                        : ref;
                    if (isHTMLElement(inputRef)) {
                        try {
                            inputRef.closest('form').reset();
                            break;
                        }
                        catch (_a) { }
                    }
                }
            }
        }
        fieldsRef.current = {};
        defaultValuesRef.current = Object.assign({}, (values || defaultValuesRef.current));
        values && renderWatchedInputs('');
        Object.values(resetFieldArrayFunctionRef.current).forEach((resetFieldArray) => isFunction(resetFieldArray) && resetFieldArray());
        shallowFieldsStateRef.current = shouldUnregister
            ? {}
            : cloneObject(values || defaultValuesRef.current);
        resetRefs(omitResetState);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
        resolver && readFormStateRef.current.isValid && validateResolver();
        observerRef.current =
            observerRef.current || !isWeb
                ? observerRef.current
                : onDomRemove(fieldsRef, removeFieldEventListenerAndRef);
    }, [removeFieldEventListenerAndRef, defaultValuesRef.current]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => () => {
        observerRef.current && observerRef.current.disconnect();
        isUnMount.current = true;
        if (false) {}
        Object.values(fieldsRef.current).forEach((field) => removeFieldEventListenerAndRef(field, true));
    }, []);
    if (!resolver && readFormStateRef.current.isValid) {
        formState.isValid =
            deepEqual(validFieldsRef.current, fieldsWithValidationRef.current) &&
                isEmptyObject(formStateRef.current.errors);
    }
    const commonProps = {
        trigger,
        setValue: (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(setValue, [setInternalValue, trigger]),
        getValues: (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(getValues, []),
        register: (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(register, [defaultValuesRef.current]),
        unregister: (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(unregister, []),
        formState: isProxyEnabled
            ? new Proxy(formState, {
                get: (obj, prop) => {
                    if (false) {}
                    if (prop in obj) {
                        readFormStateRef.current[prop] = true;
                        return obj[prop];
                    }
                    return undefined;
                },
            })
            : formState,
    };
    const control = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => (Object.assign({ isFormDirty,
        updateWatchedValue,
        shouldUnregister,
        updateFormState,
        removeFieldEventListener,
        watchInternal, mode: modeRef.current, reValidateMode: {
            isReValidateOnBlur,
            isReValidateOnChange,
        }, validateResolver: resolver ? validateResolver : undefined, fieldsRef,
        resetFieldArrayFunctionRef,
        useWatchFieldsRef,
        useWatchRenderFunctionsRef,
        fieldArrayDefaultValuesRef,
        validFieldsRef,
        fieldsWithValidationRef,
        fieldArrayNamesRef,
        readFormStateRef,
        formStateRef,
        defaultValuesRef,
        shallowFieldsStateRef,
        fieldArrayValuesRef }, commonProps)), [
        defaultValuesRef.current,
        updateWatchedValue,
        shouldUnregister,
        removeFieldEventListener,
        watchInternal,
    ]);
    return Object.assign({ watch,
        control,
        handleSubmit, reset: (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(reset, []), clearErrors: (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(clearErrors, []), setError: (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(setError, []), errors: formState.errors }, commonProps);
}

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

const FormContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);
FormContext.displayName = 'RHFContext';
const useFormContext = () => (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(FormContext);
const FormProvider = (_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return ((0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(FormContext.Provider, { value: Object.assign({}, props) }, children));
};

var generateId = () => {
    const d = typeof performance === UNDEFINED ? Date.now() : performance.now() * 1000;
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        const r = (Math.random() * 16 + d) % 16 | 0;
        return (c == 'x' ? r : (r & 0x3) | 0x8).toString(16);
    });
};

function removeAtIndexes(data, indexes) {
    let i = 0;
    const temp = [...data];
    for (const index of indexes) {
        temp.splice(index - i, 1);
        i++;
    }
    return compact(temp).length ? temp : [];
}
var removeArrayAt = (data, index) => isUndefined(index)
    ? []
    : removeAtIndexes(data, (Array.isArray(index) ? index : [index]).sort((a, b) => a - b));

var moveArrayAt = (data, from, to) => {
    if (Array.isArray(data)) {
        if (isUndefined(data[to])) {
            data[to] = undefined;
        }
        data.splice(to, 0, data.splice(from, 1)[0]);
        return data;
    }
    return [];
};

var swapArrayAt = (data, indexA, indexB) => {
    const temp = [data[indexB], data[indexA]];
    data[indexA] = temp[0];
    data[indexB] = temp[1];
};

function prepend(data, value) {
    return [...(Array.isArray(value) ? value : [value || undefined]), ...data];
}

function insert(data, index, value) {
    return [
        ...data.slice(0, index),
        ...(Array.isArray(value) ? value : [value || undefined]),
        ...data.slice(index),
    ];
}

var fillEmptyArray = (value) => Array.isArray(value) ? Array(value.length).fill(undefined) : undefined;

var fillBooleanArray = (value) => (Array.isArray(value) ? value : [value]).map((data) => {
    if (isObject(data)) {
        const object = {};
        for (const key in data) {
            object[key] = true;
        }
        return object;
    }
    return true;
});

const mapIds = (values = [], keyName, skipWarn) => {
    if (false) {}
    return values.map((value) => (Object.assign({ [keyName]: value[keyName] || generateId() }, value)));
};
const useFieldArray = ({ control, name, keyName = 'id', }) => {
    const methods = useFormContext();
    if (false) {}
    const focusIndexRef = useRef(-1);
    const isUnMount = useRef(false);
    const { isFormDirty, updateWatchedValue, resetFieldArrayFunctionRef, fieldArrayNamesRef, fieldsRef, defaultValuesRef, removeFieldEventListener, formStateRef, shallowFieldsStateRef, updateFormState, readFormStateRef, validFieldsRef, fieldsWithValidationRef, fieldArrayDefaultValuesRef, validateResolver, getValues, shouldUnregister, fieldArrayValuesRef, } = control || methods.control;
    const getDefaultValues = (values) => get(shouldUnregister ? values : shallowFieldsStateRef.current, name, []);
    const fieldArrayParentName = getFieldArrayParentName(name);
    const memoizedDefaultValues = useRef([
        ...(get(fieldArrayDefaultValuesRef.current, fieldArrayParentName)
            ? getDefaultValues(fieldArrayDefaultValuesRef.current)
            : getDefaultValues(defaultValuesRef.current)),
    ]);
    const [fields, setFields] = useState(mapIds(memoizedDefaultValues.current, keyName));
    set(fieldArrayValuesRef.current, name, compact(fields));
    const omitKey = (fields) => fields.map((_a = {}) => {
        var _b = keyName, omitted = _a[_b], rest = __rest(_a, [typeof _b === "symbol" ? _b : _b + ""]);
        return rest;
    });
    fieldArrayNamesRef.current.add(name);
    const getFieldArrayValue = useCallback(() => get(fieldArrayValuesRef.current, name, []), [name]);
    const getCurrentFieldsValues = () => mapIds(get(getValues(), name, getFieldArrayValue()).map((item, index) => (Object.assign(Object.assign({}, getFieldArrayValue()[index]), item))), keyName, true);
    fieldArrayNamesRef.current.add(name);
    if (fieldArrayParentName &&
        !get(fieldArrayDefaultValuesRef.current, fieldArrayParentName)) {
        set(fieldArrayDefaultValuesRef.current, fieldArrayParentName, cloneObject(get(defaultValuesRef.current, fieldArrayParentName)));
    }
    const setFieldAndValidState = (fieldsValues) => {
        setFields(fieldsValues);
        set(fieldArrayValuesRef.current, name, fieldsValues);
        if (readFormStateRef.current.isValid && validateResolver) {
            const values = getValues();
            set(values, name, fieldsValues);
            validateResolver(values);
        }
    };
    const resetFields = () => {
        for (const key in fieldsRef.current) {
            if (isMatchFieldArrayName(key, name)) {
                removeFieldEventListener(fieldsRef.current[key], true);
                delete fieldsRef.current[key];
            }
        }
    };
    const cleanup = (ref) => !compact(get(ref, name, [])).length && unset(ref, name);
    const updateDirtyFieldsWithDefaultValues = (updatedFieldArrayValues) => {
        if (updatedFieldArrayValues) {
            set(formStateRef.current.dirtyFields, name, setFieldArrayDirtyFields(omitKey(updatedFieldArrayValues), get(defaultValuesRef.current, name, []), get(formStateRef.current.dirtyFields, name, [])));
        }
    };
    const batchStateUpdate = (method, args, updatedFieldValues, updatedFormValues = [], shouldSet = true, shouldUpdateValid = false) => {
        if (get(shallowFieldsStateRef.current, name)) {
            const output = method(get(shallowFieldsStateRef.current, name), args.argA, args.argB);
            shouldSet && set(shallowFieldsStateRef.current, name, output);
        }
        if (get(fieldArrayDefaultValuesRef.current, name)) {
            const output = method(get(fieldArrayDefaultValuesRef.current, name), args.argA, args.argB);
            shouldSet && set(fieldArrayDefaultValuesRef.current, name, output);
        }
        if (Array.isArray(get(formStateRef.current.errors, name))) {
            const output = method(get(formStateRef.current.errors, name), args.argA, args.argB);
            shouldSet && set(formStateRef.current.errors, name, output);
            cleanup(formStateRef.current.errors);
        }
        if (readFormStateRef.current.touched &&
            get(formStateRef.current.touched, name)) {
            const output = method(get(formStateRef.current.touched, name), args.argA, args.argB);
            shouldSet && set(formStateRef.current.touched, name, output);
            cleanup(formStateRef.current.touched);
        }
        if (readFormStateRef.current.dirtyFields ||
            readFormStateRef.current.isDirty) {
            set(formStateRef.current.dirtyFields, name, setFieldArrayDirtyFields(omitKey(updatedFormValues), get(defaultValuesRef.current, name, []), get(formStateRef.current.dirtyFields, name, [])));
            updateDirtyFieldsWithDefaultValues(updatedFieldValues);
            cleanup(formStateRef.current.dirtyFields);
        }
        if (shouldUpdateValid &&
            readFormStateRef.current.isValid &&
            !validateResolver) {
            set(validFieldsRef.current, name, method(get(validFieldsRef.current, name, []), args.argA));
            cleanup(validFieldsRef.current);
            set(fieldsWithValidationRef.current, name, method(get(fieldsWithValidationRef.current, name, []), args.argA));
            cleanup(fieldsWithValidationRef.current);
        }
        if (!isUnMount.current && readFormStateRef.current.isDirty) {
            updateFormState({
                isDirty: isFormDirty(name, omitKey(updatedFormValues)),
            });
        }
    };
    const append = (value, shouldFocus = true) => {
        const appendValue = Array.isArray(value) ? value : [value];
        const updateFormValues = [
            ...getCurrentFieldsValues(),
            ...mapIds(appendValue, keyName),
        ];
        setFieldAndValidState(updateFormValues);
        if (readFormStateRef.current.dirtyFields ||
            readFormStateRef.current.isDirty) {
            updateDirtyFieldsWithDefaultValues(updateFormValues);
            updateFormState({
                isDirty: true,
                dirtyFields: formStateRef.current.dirtyFields,
            });
        }
        !shouldUnregister &&
            set(shallowFieldsStateRef.current, name, [
                ...(get(shallowFieldsStateRef.current, name) || []),
                ...cloneObject(appendValue),
            ]);
        focusIndexRef.current = shouldFocus
            ? get(fieldArrayValuesRef.current, name).length - 1
            : -1;
    };
    const prepend$1 = (value, shouldFocus = true) => {
        const emptyArray = fillEmptyArray(value);
        const updatedFieldArrayValues = prepend(getCurrentFieldsValues(), mapIds(Array.isArray(value) ? value : [value], keyName));
        setFieldAndValidState(updatedFieldArrayValues);
        resetFields();
        batchStateUpdate(prepend, {
            argA: emptyArray,
            argC: fillBooleanArray(value),
        }, updatedFieldArrayValues);
        focusIndexRef.current = shouldFocus ? 0 : -1;
    };
    const remove = (index) => {
        const fieldValues = getCurrentFieldsValues();
        const updatedFieldValues = removeArrayAt(fieldValues, index);
        setFieldAndValidState(updatedFieldValues);
        resetFields();
        batchStateUpdate(removeArrayAt, {
            argA: index,
            argC: index,
        }, updatedFieldValues, removeArrayAt(fieldValues, index), true, true);
    };
    const insert$1 = (index, value, shouldFocus = true) => {
        const emptyArray = fillEmptyArray(value);
        const fieldValues = getCurrentFieldsValues();
        const updatedFieldArrayValues = insert(fieldValues, index, mapIds(Array.isArray(value) ? value : [value], keyName));
        setFieldAndValidState(updatedFieldArrayValues);
        resetFields();
        batchStateUpdate(insert, {
            argA: index,
            argB: emptyArray,
            argC: index,
            argD: fillBooleanArray(value),
        }, updatedFieldArrayValues, insert(fieldValues, index));
        focusIndexRef.current = shouldFocus ? index : -1;
    };
    const swap = (indexA, indexB) => {
        const fieldValues = getCurrentFieldsValues();
        swapArrayAt(fieldValues, indexA, indexB);
        resetFields();
        setFieldAndValidState([...fieldValues]);
        batchStateUpdate(swapArrayAt, {
            argA: indexA,
            argB: indexB,
            argC: indexA,
            argD: indexB,
        }, undefined, fieldValues, false);
    };
    const move = (from, to) => {
        const fieldValues = getCurrentFieldsValues();
        moveArrayAt(fieldValues, from, to);
        resetFields();
        setFieldAndValidState([...fieldValues]);
        batchStateUpdate(moveArrayAt, {
            argA: from,
            argB: to,
            argC: from,
            argD: to,
        }, undefined, fieldValues, false);
    };
    useEffect(() => {
        if (false) {}
        const defaultValues = get(fieldArrayDefaultValuesRef.current, name);
        if (defaultValues && fields.length < defaultValues.length) {
            set(fieldArrayDefaultValuesRef.current, name, defaultValues.slice(1));
        }
        updateWatchedValue(name);
        if (focusIndexRef.current > -1) {
            for (const key in fieldsRef.current) {
                const field = fieldsRef.current[key];
                if (key.startsWith(`${name}[${focusIndexRef.current}]`) &&
                    field.ref.focus) {
                    field.ref.focus();
                    break;
                }
            }
        }
        focusIndexRef.current = -1;
    }, [fields, name]);
    useEffect(() => {
        const resetFunctions = resetFieldArrayFunctionRef.current;
        const fieldArrayNames = fieldArrayNamesRef.current;
        if (!getFieldArrayParentName(name)) {
            resetFunctions[name] = (data) => {
                resetFields();
                !data && unset(fieldArrayDefaultValuesRef.current, name);
                unset(shallowFieldsStateRef.current, name);
                memoizedDefaultValues.current = get(data || defaultValuesRef.current, name);
                if (!isUnMount.current) {
                    setFields(mapIds(memoizedDefaultValues.current, keyName));
                }
            };
        }
        return () => {
            isUnMount.current = true;
            shouldUnregister && remove();
            resetFields();
            delete resetFunctions[name];
            unset(fieldArrayValuesRef.current, name);
            fieldArrayNames.delete(name);
        };
    }, []);
    return {
        swap: useCallback(swap, [name]),
        move: useCallback(move, [name]),
        prepend: useCallback(prepend$1, [name]),
        append: useCallback(append, [name]),
        remove: useCallback(remove, [name]),
        insert: useCallback(insert$1, [name]),
        fields: compact(fields),
    };
};

var getInputValue = (event) => isPrimitive(event) ||
    !isObject(event.target) ||
    (isObject(event.target) && !event.type)
    ? event
    : isUndefined(event.target.value)
        ? event.target.checked
        : event.target.value;

function useController({ name, rules, defaultValue, control, onFocus, }) {
    const methods = useFormContext();
    if (false) {}
    const { defaultValuesRef, setValue, register, unregister, trigger, mode, reValidateMode: { isReValidateOnBlur, isReValidateOnChange }, formState, formStateRef: { current: { isSubmitted, touched, errors }, }, updateFormState, readFormStateRef, fieldsRef, fieldArrayNamesRef, shallowFieldsStateRef, } = control || methods.control;
    const isNotFieldArray = !isNameInFieldArray(fieldArrayNamesRef.current, name);
    const getInitialValue = () => !isUndefined(get(shallowFieldsStateRef.current, name)) && isNotFieldArray
        ? get(shallowFieldsStateRef.current, name)
        : isUndefined(defaultValue)
            ? get(defaultValuesRef.current, name)
            : defaultValue;
    const [value, setInputStateValue] = useState(getInitialValue());
    const valueRef = useRef(value);
    const ref = useRef({
        focus: () => null,
    });
    const onFocusRef = useRef(onFocus ||
        (() => {
            if (isFunction(ref.current.focus)) {
                ref.current.focus();
            }
            if (false) {}
        }));
    const shouldValidate = useCallback((isBlurEvent) => !skipValidation(Object.assign({ isBlurEvent,
        isReValidateOnBlur,
        isReValidateOnChange,
        isSubmitted, isTouched: !!get(touched, name) }, mode)), [
        isReValidateOnBlur,
        isReValidateOnChange,
        isSubmitted,
        touched,
        name,
        mode,
    ]);
    const commonTask = useCallback(([event]) => {
        const data = getInputValue(event);
        setInputStateValue(data);
        valueRef.current = data;
        return data;
    }, []);
    const registerField = useCallback((shouldUpdateValue) => {
        if (false) {}
        if (fieldsRef.current[name]) {
            fieldsRef.current[name] = Object.assign({ ref: fieldsRef.current[name].ref }, rules);
        }
        else {
            register(Object.defineProperties({
                name,
                focus: onFocusRef.current,
            }, {
                value: {
                    set(data) {
                        setInputStateValue(data);
                        valueRef.current = data;
                    },
                    get() {
                        return valueRef.current;
                    },
                },
            }), rules);
            shouldUpdateValue = isUndefined(get(defaultValuesRef.current, name));
        }
        shouldUpdateValue &&
            isNotFieldArray &&
            setInputStateValue(getInitialValue());
    }, [rules, name, register]);
    useEffect(() => () => unregister(name), [name]);
    useEffect(() => {
        if (false) {}
        registerField();
    }, [registerField]);
    useEffect(() => {
        !fieldsRef.current[name] && registerField(true);
    });
    const onBlur = useCallback(() => {
        if (readFormStateRef.current.touched && !get(touched, name)) {
            set(touched, name, true);
            updateFormState({
                touched,
            });
        }
        shouldValidate(true) && trigger(name);
    }, [name, updateFormState, shouldValidate, trigger, readFormStateRef]);
    const onChange = useCallback((...event) => setValue(name, commonTask(event), {
        shouldValidate: shouldValidate(),
        shouldDirty: true,
    }), [setValue, name, shouldValidate]);
    return {
        field: {
            onChange,
            onBlur,
            name,
            value,
            ref,
        },
        meta: Object.defineProperties({
            invalid: !!get(errors, name),
        }, {
            isDirty: {
                get() {
                    return !!get(formState.dirtyFields, name);
                },
            },
            isTouched: {
                get() {
                    return !!get(formState.touched, name);
                },
            },
        }),
    };
}

function useWatch({ control, name, defaultValue, }) {
    const methods = useFormContext();
    if (false) {}
    const { useWatchFieldsRef, useWatchRenderFunctionsRef, watchInternal, defaultValuesRef, } = control || methods.control;
    const updateValue = useState()[1];
    const idRef = useRef();
    const defaultValueRef = useRef(defaultValue);
    useEffect(() => {
        if (false) {}
        const id = (idRef.current = generateId());
        const watchFieldsHookRender = useWatchRenderFunctionsRef.current;
        const watchFieldsHook = useWatchFieldsRef.current;
        watchFieldsHook[id] = new Set();
        watchFieldsHookRender[id] = () => updateValue({});
        watchInternal(name, defaultValueRef.current, id);
        return () => {
            delete watchFieldsHook[id];
            delete watchFieldsHookRender[id];
        };
    }, [
        name,
        useWatchRenderFunctionsRef,
        useWatchFieldsRef,
        watchInternal,
        defaultValueRef,
    ]);
    return idRef.current
        ? watchInternal(name, defaultValueRef.current, idRef.current)
        : isUndefined(defaultValue)
            ? isString(name)
                ? get(defaultValuesRef.current, name)
                : Array.isArray(name)
                    ? name.reduce((previous, inputName) => (Object.assign(Object.assign({}, previous), { [inputName]: get(defaultValuesRef.current, inputName) })), {})
                    : defaultValuesRef.current
            : defaultValue;
}

const Controller = (props) => {
    const { rules, as, render, defaultValue, control, onFocus } = props, rest = __rest(props, ["rules", "as", "render", "defaultValue", "control", "onFocus"]);
    const { field, meta } = useController(props);
    const componentProps = Object.assign(Object.assign({}, rest), field);
    return as
        ? isValidElement(as)
            ? cloneElement(as, componentProps)
            : createElement(as, componentProps)
        : render
            ? render(field, meta)
            : null;
};


//# sourceMappingURL=index.esm.js.map


/***/ }),

/***/ 27172:
/***/ (function(module, exports, __webpack_require__) {

/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */
/* eslint-disable node/no-deprecated-api */
var buffer = __webpack_require__(30816)
var Buffer = buffer.Buffer

// alternative to using Object.keys for old browsers
function copyProps (src, dst) {
  for (var key in src) {
    dst[key] = src[key]
  }
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
  module.exports = buffer
} else {
  // Copy properties from require('buffer')
  copyProps(buffer, exports)
  exports.Buffer = SafeBuffer
}

function SafeBuffer (arg, encodingOrOffset, length) {
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.prototype = Object.create(Buffer.prototype)

// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer)

SafeBuffer.from = function (arg, encodingOrOffset, length) {
  if (typeof arg === 'number') {
    throw new TypeError('Argument must not be a number')
  }
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.alloc = function (size, fill, encoding) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  var buf = Buffer(size)
  if (fill !== undefined) {
    if (typeof encoding === 'string') {
      buf.fill(fill, encoding)
    } else {
      buf.fill(fill)
    }
  } else {
    buf.fill(0)
  }
  return buf
}

SafeBuffer.allocUnsafe = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return Buffer(size)
}

SafeBuffer.allocUnsafeSlow = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return buffer.SlowBuffer(size)
}


/***/ }),

/***/ 88319:
/***/ (function(module) {

"use strict";


var defaultParseOptions = {
  decodeValues: true,
  map: false,
  silent: false,
};

function isNonEmptyString(str) {
  return typeof str === "string" && !!str.trim();
}

function parseString(setCookieValue, options) {
  var parts = setCookieValue.split(";").filter(isNonEmptyString);
  var nameValue = parts.shift().split("=");
  var name = nameValue.shift();
  var value = nameValue.join("="); // everything after the first =, joined by a "=" if there was more than one part

  options = options
    ? Object.assign({}, defaultParseOptions, options)
    : defaultParseOptions;

  try {
    value = options.decodeValues ? decodeURIComponent(value) : value; // decode cookie value
  } catch (e) {
    console.error(
      "set-cookie-parser encountered an error while decoding a cookie with value '" +
        value +
        "'. Set options.decodeValues to false to disable this feature.",
      e
    );
  }

  var cookie = {
    name: name, // grab everything before the first =
    value: value,
  };

  parts.forEach(function (part) {
    var sides = part.split("=");
    var key = sides.shift().trimLeft().toLowerCase();
    var value = sides.join("=");
    if (key === "expires") {
      cookie.expires = new Date(value);
    } else if (key === "max-age") {
      cookie.maxAge = parseInt(value, 10);
    } else if (key === "secure") {
      cookie.secure = true;
    } else if (key === "httponly") {
      cookie.httpOnly = true;
    } else if (key === "samesite") {
      cookie.sameSite = value;
    } else {
      cookie[key] = value;
    }
  });

  return cookie;
}

function parse(input, options) {
  options = options
    ? Object.assign({}, defaultParseOptions, options)
    : defaultParseOptions;

  if (!input) {
    if (!options.map) {
      return [];
    } else {
      return {};
    }
  }

  if (input.headers && input.headers["set-cookie"]) {
    // fast-path for node.js (which automatically normalizes header names to lower-case
    input = input.headers["set-cookie"];
  } else if (input.headers) {
    // slow-path for other environments - see #25
    var sch =
      input.headers[
        Object.keys(input.headers).find(function (key) {
          return key.toLowerCase() === "set-cookie";
        })
      ];
    // warn if called on a request-like object with a cookie header rather than a set-cookie header - see #34, 36
    if (!sch && input.headers.cookie && !options.silent) {
      console.warn(
        "Warning: set-cookie-parser appears to have been called on a request object. It is designed to parse Set-Cookie headers from responses, not Cookie headers from requests. Set the option {silent: true} to suppress this warning."
      );
    }
    input = sch;
  }
  if (!Array.isArray(input)) {
    input = [input];
  }

  options = options
    ? Object.assign({}, defaultParseOptions, options)
    : defaultParseOptions;

  if (!options.map) {
    return input.filter(isNonEmptyString).map(function (str) {
      return parseString(str, options);
    });
  } else {
    var cookies = {};
    return input.filter(isNonEmptyString).reduce(function (cookies, str) {
      var cookie = parseString(str, options);
      cookies[cookie.name] = cookie;
      return cookies;
    }, cookies);
  }
}

/*
  Set-Cookie header field-values are sometimes comma joined in one string. This splits them without choking on commas
  that are within a single set-cookie field-value, such as in the Expires portion.

  This is uncommon, but explicitly allowed - see https://tools.ietf.org/html/rfc2616#section-4.2
  Node.js does this for every header *except* set-cookie - see https://github.com/nodejs/node/blob/d5e363b77ebaf1caf67cd7528224b651c86815c1/lib/_http_incoming.js#L128
  React Native's fetch does this for *every* header, including set-cookie.

  Based on: https://github.com/google/j2objc/commit/16820fdbc8f76ca0c33472810ce0cb03d20efe25
  Credits to: https://github.com/tomball for original and https://github.com/chrusart for JavaScript implementation
*/
function splitCookiesString(cookiesString) {
  if (Array.isArray(cookiesString)) {
    return cookiesString;
  }
  if (typeof cookiesString !== "string") {
    return [];
  }

  var cookiesStrings = [];
  var pos = 0;
  var start;
  var ch;
  var lastComma;
  var nextStart;
  var cookiesSeparatorFound;

  function skipWhitespace() {
    while (pos < cookiesString.length && /\s/.test(cookiesString.charAt(pos))) {
      pos += 1;
    }
    return pos < cookiesString.length;
  }

  function notSpecialChar() {
    ch = cookiesString.charAt(pos);

    return ch !== "=" && ch !== ";" && ch !== ",";
  }

  while (pos < cookiesString.length) {
    start = pos;
    cookiesSeparatorFound = false;

    while (skipWhitespace()) {
      ch = cookiesString.charAt(pos);
      if (ch === ",") {
        // ',' is a cookie separator if we have later first '=', not ';' or ','
        lastComma = pos;
        pos += 1;

        skipWhitespace();
        nextStart = pos;

        while (pos < cookiesString.length && notSpecialChar()) {
          pos += 1;
        }

        // currently special character
        if (pos < cookiesString.length && cookiesString.charAt(pos) === "=") {
          // we found cookies separator
          cookiesSeparatorFound = true;
          // pos is inside the next cookie, so back up and return it.
          pos = nextStart;
          cookiesStrings.push(cookiesString.substring(start, lastComma));
          start = pos;
        } else {
          // in param ',' or param separator ';',
          // we continue from that comma
          pos = lastComma + 1;
        }
      } else {
        pos += 1;
      }
    }

    if (!cookiesSeparatorFound || pos >= cookiesString.length) {
      cookiesStrings.push(cookiesString.substring(start, cookiesString.length));
    }
  }

  return cookiesStrings;
}

module.exports = parse;
module.exports.parse = parse;
module.exports.parseString = parseString;
module.exports.splitCookiesString = splitCookiesString;


/***/ }),

/***/ 34361:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



/*<replacement>*/

var Buffer = (__webpack_require__(27172).Buffer);
/*</replacement>*/

var isEncoding = Buffer.isEncoding || function (encoding) {
  encoding = '' + encoding;
  switch (encoding && encoding.toLowerCase()) {
    case 'hex':case 'utf8':case 'utf-8':case 'ascii':case 'binary':case 'base64':case 'ucs2':case 'ucs-2':case 'utf16le':case 'utf-16le':case 'raw':
      return true;
    default:
      return false;
  }
};

function _normalizeEncoding(enc) {
  if (!enc) return 'utf8';
  var retried;
  while (true) {
    switch (enc) {
      case 'utf8':
      case 'utf-8':
        return 'utf8';
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return 'utf16le';
      case 'latin1':
      case 'binary':
        return 'latin1';
      case 'base64':
      case 'ascii':
      case 'hex':
        return enc;
      default:
        if (retried) return; // undefined
        enc = ('' + enc).toLowerCase();
        retried = true;
    }
  }
};

// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function normalizeEncoding(enc) {
  var nenc = _normalizeEncoding(enc);
  if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
  return nenc || enc;
}

// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
exports.StringDecoder = StringDecoder;
function StringDecoder(encoding) {
  this.encoding = normalizeEncoding(encoding);
  var nb;
  switch (this.encoding) {
    case 'utf16le':
      this.text = utf16Text;
      this.end = utf16End;
      nb = 4;
      break;
    case 'utf8':
      this.fillLast = utf8FillLast;
      nb = 4;
      break;
    case 'base64':
      this.text = base64Text;
      this.end = base64End;
      nb = 3;
      break;
    default:
      this.write = simpleWrite;
      this.end = simpleEnd;
      return;
  }
  this.lastNeed = 0;
  this.lastTotal = 0;
  this.lastChar = Buffer.allocUnsafe(nb);
}

StringDecoder.prototype.write = function (buf) {
  if (buf.length === 0) return '';
  var r;
  var i;
  if (this.lastNeed) {
    r = this.fillLast(buf);
    if (r === undefined) return '';
    i = this.lastNeed;
    this.lastNeed = 0;
  } else {
    i = 0;
  }
  if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
  return r || '';
};

StringDecoder.prototype.end = utf8End;

// Returns only complete characters in a Buffer
StringDecoder.prototype.text = utf8Text;

// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
StringDecoder.prototype.fillLast = function (buf) {
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
  this.lastNeed -= buf.length;
};

// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function utf8CheckByte(byte) {
  if (byte <= 0x7F) return 0;else if (byte >> 5 === 0x06) return 2;else if (byte >> 4 === 0x0E) return 3;else if (byte >> 3 === 0x1E) return 4;
  return byte >> 6 === 0x02 ? -1 : -2;
}

// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function utf8CheckIncomplete(self, buf, i) {
  var j = buf.length - 1;
  if (j < i) return 0;
  var nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 1;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 2;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) {
      if (nb === 2) nb = 0;else self.lastNeed = nb - 3;
    }
    return nb;
  }
  return 0;
}

// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function utf8CheckExtraBytes(self, buf, p) {
  if ((buf[0] & 0xC0) !== 0x80) {
    self.lastNeed = 0;
    return '\ufffd';
  }
  if (self.lastNeed > 1 && buf.length > 1) {
    if ((buf[1] & 0xC0) !== 0x80) {
      self.lastNeed = 1;
      return '\ufffd';
    }
    if (self.lastNeed > 2 && buf.length > 2) {
      if ((buf[2] & 0xC0) !== 0x80) {
        self.lastNeed = 2;
        return '\ufffd';
      }
    }
  }
}

// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function utf8FillLast(buf) {
  var p = this.lastTotal - this.lastNeed;
  var r = utf8CheckExtraBytes(this, buf, p);
  if (r !== undefined) return r;
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, p, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, p, 0, buf.length);
  this.lastNeed -= buf.length;
}

// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function utf8Text(buf, i) {
  var total = utf8CheckIncomplete(this, buf, i);
  if (!this.lastNeed) return buf.toString('utf8', i);
  this.lastTotal = total;
  var end = buf.length - (total - this.lastNeed);
  buf.copy(this.lastChar, 0, end);
  return buf.toString('utf8', i, end);
}

// For UTF-8, a replacement character is added when ending on a partial
// character.
function utf8End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + '\ufffd';
  return r;
}

// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function utf16Text(buf, i) {
  if ((buf.length - i) % 2 === 0) {
    var r = buf.toString('utf16le', i);
    if (r) {
      var c = r.charCodeAt(r.length - 1);
      if (c >= 0xD800 && c <= 0xDBFF) {
        this.lastNeed = 2;
        this.lastTotal = 4;
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
        return r.slice(0, -1);
      }
    }
    return r;
  }
  this.lastNeed = 1;
  this.lastTotal = 2;
  this.lastChar[0] = buf[buf.length - 1];
  return buf.toString('utf16le', i, buf.length - 1);
}

// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function utf16End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) {
    var end = this.lastTotal - this.lastNeed;
    return r + this.lastChar.toString('utf16le', 0, end);
  }
  return r;
}

function base64Text(buf, i) {
  var n = (buf.length - i) % 3;
  if (n === 0) return buf.toString('base64', i);
  this.lastNeed = 3 - n;
  this.lastTotal = 3;
  if (n === 1) {
    this.lastChar[0] = buf[buf.length - 1];
  } else {
    this.lastChar[0] = buf[buf.length - 2];
    this.lastChar[1] = buf[buf.length - 1];
  }
  return buf.toString('base64', i, buf.length - n);
}

function base64End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
  return r;
}

// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function simpleWrite(buf) {
  return buf.toString(this.encoding);
}

function simpleEnd(buf) {
  return buf && buf.length ? this.write(buf) : '';
}

/***/ }),

/***/ 49224:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F4": function() { return /* binding */ keyframes; },
/* harmony export */   "iv": function() { return /* binding */ css; },
/* harmony export */   "nn": function() { return /* reexport safe */ twind__WEBPACK_IMPORTED_MODULE_0__.nn; },
/* harmony export */   "oQ": function() { return /* binding */ animation; },
/* harmony export */   "tw": function() { return /* reexport safe */ twind__WEBPACK_IMPORTED_MODULE_0__.tw; }
/* harmony export */ });
/* unused harmony export screen */
/* harmony import */ var twind__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34209);
// src/css/index.ts


// src/internal/util.ts
var includes = (value, search) => !!~value.indexOf(search);
var join = (parts, separator = "-") => parts.join(separator);
var hyphenate = (value) => value.replace(/[A-Z]/g, "-$&").toLowerCase();
var evalThunk = (value, context) => {
  while (typeof value == "function") {
    value = value(context);
  }
  return value;
};
var isCSSProperty = (key, value) => !includes("@:&", key[0]) && (includes("rg", (typeof value)[5]) || Array.isArray(value));
var merge = (target, source, context) => source ? Object.keys(source).reduce((target2, key) => {
  const value = evalThunk(source[key], context);
  if (isCSSProperty(key, value)) {
    target2[hyphenate(key)] = value;
  } else {
    target2[key] = key[0] == "@" && includes("figa", key[1]) ? (target2[key] || []).concat(value) : merge(target2[key] || {}, value, context);
  }
  return target2;
}, target) : target;
var escape = typeof CSS !== "undefined" && CSS.escape || ((className) => className.replace(/[!"'`*+.,;:\\/<=>?@#$%&^|~()[\]{}]/g, "\\$&").replace(/^\d/, "\\3$& "));
var buildMediaQuery = (screen2) => {
  if (!Array.isArray(screen2)) {
    screen2 = [screen2];
  }
  return "@media " + join(screen2.map((screen3) => {
    if (typeof screen3 == "string") {
      screen3 = {min: screen3};
    }
    return screen3.raw || join(Object.keys(screen3).map((feature) => `(${feature}-width:${screen3[feature]})`), " and ");
  }), ",");
};

// src/css/index.ts

var translate = (tokens, context) => {
  const collect = (target, token) => Array.isArray(token) ? token.reduce(collect, target) : merge(target, evalThunk(token, context), context);
  return tokens.reduce(collect, {});
};
var newRule = /\s*(?:([\w-%@]+)\s*:?\s*([^{;]+?)\s*(?:;|$|})|([^;}{]*?)\s*{)|(})/gi;
var ruleClean = /\/\*[\s\S]*?\*\/|\s+|\n/gm;
var decorate = (selectors, currentBlock) => selectors.reduceRight((rules, selector) => ({[selector]: rules}), currentBlock);
var saveBlock = (rules, selectors, currentBlock) => {
  if (currentBlock) {
    rules.push(decorate(selectors, currentBlock));
  }
};
var interleave = (strings, interpolations, context) => {
  let buffer = strings[0];
  const result = [];
  for (let index = 0; index < interpolations.length; ) {
    const interpolation = evalThunk(interpolations[index], context);
    if (interpolation && typeof interpolation == "object") {
      result.push(buffer, interpolation);
      buffer = strings[++index];
    } else {
      buffer += (interpolation || "") + strings[++index];
    }
  }
  result.push(buffer);
  return result;
};
var astish = (values, context) => {
  const selectors = [];
  const rules = [];
  let currentBlock;
  let match;
  for (let index = 0; index < values.length; index++) {
    const value = values[index];
    if (typeof value == "string") {
      while (match = newRule.exec(value.replace(ruleClean, " "))) {
        if (!match[0])
          continue;
        if (match[4]) {
          currentBlock = saveBlock(rules, selectors, currentBlock);
          selectors.pop();
        }
        if (match[3]) {
          currentBlock = saveBlock(rules, selectors, currentBlock);
          selectors.push(match[3]);
        } else if (!match[4]) {
          if (!currentBlock)
            currentBlock = {};
          const value2 = match[2] && /\S/.test(match[2]) ? match[2] : values[++index];
          if (value2) {
            if (match[1] == "@apply") {
              merge(currentBlock, evalThunk((0,twind__WEBPACK_IMPORTED_MODULE_0__/* .apply */ .nn)(value2), context), context);
            } else {
              currentBlock[match[1]] = value2;
            }
          }
        }
      }
    } else {
      currentBlock = saveBlock(rules, selectors, currentBlock);
      rules.push(decorate(selectors, value));
    }
  }
  saveBlock(rules, selectors, currentBlock);
  return rules;
};
var cssFactory = (tokens, context) => translate(Array.isArray(tokens[0]) && Array.isArray(tokens[0].raw) ? astish(interleave(tokens[0], tokens.slice(1), context), context) : tokens, context);
var css = (...tokens) => (0,twind__WEBPACK_IMPORTED_MODULE_0__/* .directive */ .XM)(cssFactory, tokens);
var keyframesFactory = (tokens, context) => {
  const waypoints = cssFactory(tokens, context);
  const id = (0,twind__WEBPACK_IMPORTED_MODULE_0__/* .hash */ .vp)(JSON.stringify(waypoints));
  context.tw(() => ({[`@keyframes ${id}`]: waypoints}));
  return id;
};
var keyframes = (...tokens) => (0,twind__WEBPACK_IMPORTED_MODULE_0__/* .directive */ .XM)(keyframesFactory, tokens);
var animation = (value, waypoints) => waypoints === void 0 ? (...args) => animation(value, keyframes(...args)) : css({
  ...value && typeof value == "object" ? value : {animation: value},
  animationName: typeof waypoints == "function" ? waypoints : keyframes(waypoints)
});
var screenFactory = ({size, rules}, context) => {
  const media = buildMediaQuery(context.theme("screens", size));
  return rules === void 0 ? media : {
    [media]: typeof rules == "function" ? evalThunk(rules, context) : cssFactory([rules], context)
  };
};
var screen = (size, rules) => directive(screenFactory, {size, rules});

//# sourceMappingURL=css.js.map


/***/ }),

/***/ 1281:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N7": function() { return /* binding */ observe; },
/* harmony export */   "cY": function() { return /* reexport safe */ twind__WEBPACK_IMPORTED_MODULE_0__.cY; },
/* harmony export */   "zo": function() { return /* binding */ createObserver; }
/* harmony export */ });
/* harmony import */ var twind__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34209);
// src/observe/index.ts


// src/internal/util.ts
var ensureMaxSize = (map, max) => {
  if (map.size > max) {
    map.delete(map.keys().next().value);
  }
};
var escape = typeof CSS !== "undefined" && CSS.escape || ((className) => className.replace(/[!"'`*+.,;:\\/<=>?@#$%&^|~()[\]{}]/g, "\\$&").replace(/^\d/, "\\3$& "));

// src/observe/index.ts

var caches = new WeakMap();
var getCache = (tw) => {
  let rulesToClassCache = caches.get(tw);
  if (!rulesToClassCache) {
    rulesToClassCache = new Map();
    caches.set(tw, rulesToClassCache);
  }
  return rulesToClassCache;
};
var uniq = (value, index, values) => values.indexOf(value) == index;
var createObserver = ({tw = twind__WEBPACK_IMPORTED_MODULE_0__.tw} = {}) => {
  if (typeof MutationObserver == "function") {
    const rulesToClassCache = getCache(tw);
    const handleMutation = ({target, addedNodes}) => {
      var _a;
      const rules = (_a = target.getAttribute) == null ? void 0 : _a.call(target, "class");
      if (rules) {
        let className = rulesToClassCache.get(rules);
        if (!className) {
          className = tw(rules).split(/ +/g).filter(uniq).join(" ");
          rulesToClassCache.set(rules, className);
          rulesToClassCache.set(className, className);
          ensureMaxSize(rulesToClassCache, 3e4);
        }
        if (rules !== className) {
          ;
          target.setAttribute("class", className);
        }
      }
      for (let index = addedNodes.length; index--; ) {
        const node = addedNodes[index];
        handleMutations([
          {
            target: node,
            addedNodes: node.children || []
          }
        ]);
      }
    };
    const handleMutations = (mutations) => {
      mutations.forEach(handleMutation);
      mutations = observer.takeRecords();
      if (mutations)
        mutations.forEach(handleMutation);
    };
    const observer = new MutationObserver(handleMutations);
    return {
      observe(target) {
        handleMutations([{target, addedNodes: [target]}]);
        observer.observe(target, {
          attributes: true,
          attributeFilter: ["class"],
          subtree: true,
          childList: true
        });
        return this;
      },
      disconnect() {
        observer.disconnect();
        return this;
      }
    };
  }
  return {
    observe() {
      return this;
    },
    disconnect() {
      return this;
    }
  };
};
function observe(target, config = typeof this == "function" ? void 0 : this) {
  return createObserver(config).observe(target);
}

//# sourceMappingURL=observe.js.map


/***/ }),

/***/ 79200:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F4": function() { return /* reexport safe */ twind_css__WEBPACK_IMPORTED_MODULE_0__.F4; },
/* harmony export */   "iv": function() { return /* reexport safe */ twind_css__WEBPACK_IMPORTED_MODULE_0__.iv; },
/* harmony export */   "nn": function() { return /* reexport safe */ twind_css__WEBPACK_IMPORTED_MODULE_0__.nn; },
/* harmony export */   "oB": function() { return /* binding */ style; },
/* harmony export */   "oQ": function() { return /* reexport safe */ twind_css__WEBPACK_IMPORTED_MODULE_0__.oQ; },
/* harmony export */   "tw": function() { return /* reexport safe */ twind_css__WEBPACK_IMPORTED_MODULE_0__.tw; }
/* harmony export */ });
/* harmony import */ var twind__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34209);
/* harmony import */ var twind_css__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49224);
// src/style/index.ts


// src/internal/util.ts
var includes = (value, search) => !!~value.indexOf(search);
var hyphenate = (value) => value.replace(/[A-Z]/g, "-$&").toLowerCase();
var evalThunk = (value, context) => {
  while (typeof value == "function") {
    value = value(context);
  }
  return value;
};
var isCSSProperty = (key, value) => !includes("@:&", key[0]) && (includes("rg", (typeof value)[5]) || Array.isArray(value));
var merge = (target, source, context) => source ? Object.keys(source).reduce((target2, key) => {
  const value = evalThunk(source[key], context);
  if (isCSSProperty(key, value)) {
    target2[hyphenate(key)] = value;
  } else {
    target2[key] = key[0] == "@" && includes("figa", key[1]) ? (target2[key] || []).concat(value) : merge(target2[key] || {}, value, context);
  }
  return target2;
}, target) : target;
var escape = typeof CSS !== "undefined" && CSS.escape || ((className) => className.replace(/[!"'`*+.,;:\\/<=>?@#$%&^|~()[\]{}]/g, "\\$&").replace(/^\d/, "\\3$& "));

// src/style/index.ts

var styled$ = (rules, context) => rules.reduce((result, rule) => {
  if (typeof rule == "string") {
    rule = (0,twind__WEBPACK_IMPORTED_MODULE_1__/* .apply */ .nn)(rule);
  }
  if (typeof rule == "function") {
    return merge(result, evalThunk(rule, context), context);
  }
  if (rule) {
    return merge(result, rule, context);
  }
  return result;
}, {});
var buildMediaRule = (key, value) => ({
  [key[0] == "@" ? key : `@screen ${key}`]: typeof value == "string" ? (0,twind__WEBPACK_IMPORTED_MODULE_1__/* .apply */ .nn)(value) : value
});
var createStyle = (config = {}, base) => {
  const {base: baseStyle, variants = {}, defaults, matches = []} = config;
  const id = (0,twind__WEBPACK_IMPORTED_MODULE_1__/* .hash */ .vp)(JSON.stringify([base == null ? void 0 : base.className, baseStyle, variants, defaults, matches]));
  const className = (base ? base.className + " " : "") + id;
  const selector = (base || "") + "." + id;
  return Object.defineProperties((allProps) => {
    const {tw, css, class: localClass, className: localClassName, ...props} = {
      ...defaults,
      ...allProps
    };
    const rules = [
      base && base(props),
      {
        _: className + (localClassName ? " " + localClassName : "") + (localClass ? " " + localClass : "")
      },
      baseStyle
    ];
    Object.keys(variants).forEach((variantKey) => {
      const variant = variants[variantKey];
      const propsValue = props[variantKey];
      if (propsValue === Object(propsValue)) {
        Object.keys(propsValue).forEach((key) => {
          const value = variant[propsValue[key]];
          rules.push(key == "initial" ? value : buildMediaRule(key, value));
        });
      } else {
        rules.push(variant[propsValue]);
      }
    });
    matches.forEach((matcher) => {
      const ruleIndex = rules.push(matcher.use) - 1;
      if (!Object.keys(matcher).every((variantKey) => {
        const propsValue = props[variantKey];
        const compoundValue = String(matcher[variantKey]);
        if (propsValue === Object(propsValue)) {
          Object.keys(propsValue).forEach((key) => {
            if (key != "initial" && compoundValue == String(propsValue[key])) {
              rules.push(buildMediaRule(key, rules[ruleIndex]));
            }
          });
          return true;
        }
        return variantKey == "use" || compoundValue == String(propsValue);
      })) {
        rules.length = ruleIndex;
      }
    });
    rules.push((0,twind__WEBPACK_IMPORTED_MODULE_1__/* .apply */ .nn)(tw), css);
    return (0,twind__WEBPACK_IMPORTED_MODULE_1__/* .directive */ .XM)(styled$, rules);
  }, {
    toString: {
      value: () => selector
    },
    className: {
      value: className
    },
    selector: {
      value: selector
    }
  });
};
var style = (base, config) => typeof base == "function" ? createStyle(config, base) : createStyle(base);

//# sourceMappingURL=style.js.map


/***/ }),

/***/ 34209:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "nn": function() { return /* binding */ apply; },
  "XM": function() { return /* binding */ directive; },
  "vp": function() { return /* binding */ cyrb32; },
  "cY": function() { return /* binding */ setup; },
  "tw": function() { return /* binding */ tw; }
});

// UNUSED EXPORTS: autoprefix, create, cssomSheet, expandGroups, mode, noprefix, silent, strict, theme, voidSheet, warn

;// CONCATENATED MODULE: ../node_modules/style-vendorizer/dist/esm/bundle.min.mjs
var i=new Map([["align-self","-ms-grid-row-align"],["color-adjust","-webkit-print-color-adjust"],["column-gap","grid-column-gap"],["forced-color-adjust","-ms-high-contrast-adjust"],["gap","grid-gap"],["grid-template-columns","-ms-grid-columns"],["grid-template-rows","-ms-grid-rows"],["justify-self","-ms-grid-column-align"],["margin-inline-end","-webkit-margin-end"],["margin-inline-start","-webkit-margin-start"],["mask-border","-webkit-mask-box-image"],["mask-border-outset","-webkit-mask-box-image-outset"],["mask-border-slice","-webkit-mask-box-image-slice"],["mask-border-source","-webkit-mask-box-image-source"],["mask-border-repeat","-webkit-mask-box-image-repeat"],["mask-border-width","-webkit-mask-box-image-width"],["overflow-wrap","word-wrap"],["padding-inline-end","-webkit-padding-end"],["padding-inline-start","-webkit-padding-start"],["print-color-adjust","color-adjust"],["row-gap","grid-row-gap"],["scroll-margin-bottom","scroll-snap-margin-bottom"],["scroll-margin-left","scroll-snap-margin-left"],["scroll-margin-right","scroll-snap-margin-right"],["scroll-margin-top","scroll-snap-margin-top"],["scroll-margin","scroll-snap-margin"],["text-combine-upright","-ms-text-combine-horizontal"]]);function r(r){return i.get(r)}function a(i){var r=/^(?:(text-(?:decoration$|e|or|si)|back(?:ground-cl|d|f)|box-d|mask(?:$|-[ispro]|-cl)|pr|hyphena|flex-d)|(tab-|column(?!-s)|text-align-l)|(ap)|u|hy)/i.exec(i);return r?r[1]?1:r[2]?2:r[3]?3:5:0}function t(i,r){var a=/^(?:(pos)|(cli)|(background-i)|(flex(?:$|-b)|(?:max-|min-)?(?:block-s|inl|he|widt))|dis)/i.exec(i);return a?a[1]?/^sti/i.test(r)?1:0:a[2]?/^pat/i.test(r)?1:0:a[3]?/^image-/i.test(r)?1:0:a[4]?"-"===r[3]?2:0:/^(?:inline-)?grid$/i.test(r)?4:0:0}
//# sourceMappingURL=bundle.min.mjs.map

;// CONCATENATED MODULE: ../node_modules/twind/twind.js
// src/internal/util.ts
var includes = (value, search) => !!~value.indexOf(search);
var join = (parts, separator = "-") => parts.join(separator);
var joinTruthy = (parts, separator) => join(parts.filter(Boolean), separator);
var tail = (array, startIndex = 1) => array.slice(startIndex);
var identity = (value) => value;
var noop = () => {
};
var capitalize = (value) => value[0].toUpperCase() + tail(value);
var hyphenate = (value) => value.replace(/[A-Z]/g, "-$&").toLowerCase();
var evalThunk = (value, context) => {
  while (typeof value == "function") {
    value = value(context);
  }
  return value;
};
var ensureMaxSize = (map, max) => {
  if (map.size > max) {
    map.delete(map.keys().next().value);
  }
};
var isCSSProperty = (key, value) => !includes("@:&", key[0]) && (includes("rg", (typeof value)[5]) || Array.isArray(value));
var merge = (target, source, context) => source ? Object.keys(source).reduce((target2, key) => {
  const value = evalThunk(source[key], context);
  if (isCSSProperty(key, value)) {
    target2[hyphenate(key)] = value;
  } else {
    target2[key] = key[0] == "@" && includes("figa", key[1]) ? (target2[key] || []).concat(value) : merge(target2[key] || {}, value, context);
  }
  return target2;
}, target) : target;
var twind_escape = typeof CSS !== "undefined" && CSS.escape || ((className) => className.replace(/[!"'`*+.,;:\\/<=>?@#$%&^|~()[\]{}]/g, "\\$&").replace(/^\d/, "\\3$& "));
var buildMediaQuery = (screen) => {
  if (!Array.isArray(screen)) {
    screen = [screen];
  }
  return "@media " + join(screen.map((screen2) => {
    if (typeof screen2 == "string") {
      screen2 = {min: screen2};
    }
    return screen2.raw || join(Object.keys(screen2).map((feature) => `(${feature}-width:${screen2[feature]})`), " and ");
  }), ",");
};
var cyrb32 = (value) => {
  for (var h = 9, index = value.length; index--; ) {
    h = Math.imul(h ^ value.charCodeAt(index), 1597334677);
  }
  return "tw-" + ((h ^ h >>> 9) >>> 0).toString(36);
};
var sortedInsertionIndex = (array, element) => {
  for (var low = 0, high = array.length; low < high; ) {
    const pivot = high + low >> 1;
    if (array[pivot] <= element) {
      low = pivot + 1;
    } else {
      high = pivot;
    }
  }
  return high;
};

// src/twind/parse.ts
var groupings;
var rules;
var startGrouping = (value = "") => {
  groupings.push(value);
  return "";
};
var endGrouping = (isWhitespace) => {
  groupings.length = Math.max(groupings.lastIndexOf("") + ~~isWhitespace, 0);
};
var onlyPrefixes = (s) => s && !includes("!:", s[0]);
var onlyVariants = (s) => s[0] == ":";
var addRule = (directive2, negate) => {
  rules.push({
    v: groupings.filter(onlyVariants),
    d: directive2,
    n: negate,
    i: includes(groupings, "!"),
    $: ""
  });
};
var saveRule = (buffer) => {
  const negate = buffer[0] == "-";
  if (negate) {
    buffer = tail(buffer);
  }
  const prefix = join(groupings.filter(onlyPrefixes));
  addRule(buffer == "&" ? prefix : (prefix && prefix + "-") + buffer, negate);
  return "";
};
var parseString = (token, isVariant) => {
  let buffer = "";
  for (let char, dynamic = false, position2 = 0; char = token[position2++]; ) {
    if (dynamic || char == "[") {
      buffer += char;
      dynamic = char != "]";
      continue;
    }
    switch (char) {
      case ":":
        buffer = buffer && startGrouping(":" + (token[position2] == char ? token[position2++] : "") + buffer);
        break;
      case "(":
        buffer = buffer && startGrouping(buffer);
        startGrouping();
        break;
      case "!":
        startGrouping(char);
        break;
      case ")":
      case " ":
      case "	":
      case "\n":
      case "\r":
        buffer = buffer && saveRule(buffer);
        endGrouping(char !== ")");
        break;
      default:
        buffer += char;
    }
  }
  if (buffer) {
    if (isVariant) {
      startGrouping(":" + buffer);
    } else if (buffer.slice(-1) == "-") {
      startGrouping(buffer.slice(0, -1));
    } else {
      saveRule(buffer);
    }
  }
};
var parseGroupedToken = (token) => {
  startGrouping();
  parseToken(token);
  endGrouping();
};
var parseGroup = (key, token) => {
  if (token) {
    startGrouping();
    const isVariant = includes("tbu", (typeof token)[1]);
    parseString(key, isVariant);
    if (isVariant) {
      parseGroupedToken(token);
    }
    endGrouping();
  }
};
var parseToken = (token) => {
  switch (typeof token) {
    case "string":
      parseString(token);
      break;
    case "function":
      addRule(token);
      break;
    case "object":
      if (Array.isArray(token)) {
        token.forEach(parseGroupedToken);
      } else if (token) {
        Object.keys(token).forEach((key) => {
          parseGroup(key, token[key]);
        });
      }
  }
};
var staticsCaches = new WeakMap();
var buildStatics = (strings) => {
  let statics = staticsCaches.get(strings);
  if (!statics) {
    let slowModeIndex = NaN;
    let buffer = "";
    statics = strings.map((token, index) => {
      if (slowModeIndex !== slowModeIndex && (token.slice(-1) == "[" || includes(":-(", (strings[index + 1] || "")[0]))) {
        slowModeIndex = index;
      }
      if (index >= slowModeIndex) {
        return (interpolation) => {
          if (index == slowModeIndex) {
            buffer = "";
          }
          buffer += token;
          if (includes("rg", (typeof interpolation)[5])) {
            buffer += interpolation;
          } else if (interpolation) {
            parseString(buffer);
            buffer = "";
            parseToken(interpolation);
          }
          if (index == strings.length - 1) {
            parseString(buffer);
          }
        };
      }
      const staticRules = rules = [];
      parseString(token);
      const activeGroupings = [...groupings];
      rules = [];
      return (interpolation) => {
        rules.push(...staticRules);
        groupings = [...activeGroupings];
        if (interpolation) {
          parseToken(interpolation);
        }
      };
    });
    staticsCaches.set(strings, statics);
  }
  return statics;
};
var parse = (tokens) => {
  groupings = [];
  rules = [];
  if (Array.isArray(tokens[0]) && Array.isArray(tokens[0].raw)) {
    buildStatics(tokens[0]).forEach((apply2, index) => apply2(tokens[index + 1]));
  } else {
    parseToken(tokens);
  }
  return rules;
};

// src/twind/directive.ts
var isFunctionFree;
var detectFunction = (key, value) => {
  if (typeof value == "function") {
    isFunctionFree = false;
  }
  return value;
};
var stringify = (data) => {
  isFunctionFree = true;
  const key = JSON.stringify(data, detectFunction);
  return isFunctionFree && key;
};
var cacheByFactory = new WeakMap();
var directive = (factory, data) => {
  const key = stringify(data);
  let directive2;
  if (key) {
    var cache = cacheByFactory.get(factory);
    if (!cache) {
      cacheByFactory.set(factory, cache = new Map());
    }
    directive2 = cache.get(key);
  }
  if (!directive2) {
    directive2 = Object.defineProperty((params, context) => {
      context = Array.isArray(params) ? context : params;
      return evalThunk(factory(data, context), context);
    }, "toJSON", {
      value: () => key || data
    });
    if (cache) {
      cache.set(key, directive2);
      ensureMaxSize(cache, 1e4);
    }
  }
  return directive2;
};

// src/twind/apply.ts
var applyFactory = (tokens, {css}) => css(parse(tokens));
var apply = (...tokens) => directive(applyFactory, tokens);

// src/twind/helpers.ts
var positions = (resolve) => (value, position2, prefix, suffix) => {
  if (value) {
    const properties = position2 && resolve(position2);
    if (properties && properties.length > 0) {
      return properties.reduce((declarations, property2) => {
        declarations[joinTruthy([prefix, property2, suffix])] = value;
        return declarations;
      }, {});
    }
  }
};
var corners = /* @__PURE__ */ positions((key) => ({
  t: ["top-left", "top-right"],
  r: ["top-right", "bottom-right"],
  b: ["bottom-left", "bottom-right"],
  l: ["bottom-left", "top-left"],
  tl: ["top-left"],
  tr: ["top-right"],
  bl: ["bottom-left"],
  br: ["bottom-right"]
})[key]);
var expandEdges = (key) => {
  const parts = ({x: "lr", y: "tb"}[key] || key || "").split("").sort();
  for (let index = parts.length; index--; ) {
    if (!(parts[index] = {
      t: "top",
      r: "right",
      b: "bottom",
      l: "left"
    }[parts[index]]))
      return;
  }
  if (parts.length)
    return parts;
};
var edges = /* @__PURE__ */ positions(expandEdges);
var stringifyVariant = (selector, variant) => selector + (variant[1] == ":" ? tail(variant, 2) + ":" : tail(variant)) + ":";
var stringifyRule = (rule, directive2 = rule.d) => typeof directive2 == "function" ? "" : rule.v.reduce(stringifyVariant, "") + (rule.i ? "!" : "") + (rule.n ? "-" : "") + directive2;

// src/twind/plugins.ts
var _;
var __;
var $;
var toColumnsOrRows = (x) => x == "cols" ? "columns" : "rows";
var property = (property2) => (params, context, id) => ({
  [property2]: id + ((_ = join(params)) && "-" + _)
});
var propertyValue = (property2, separator) => (params, context, id) => (_ = join(params, separator)) && {
  [property2 || id]: _
};
var themeProperty = (section) => (params, {theme: theme2}, id) => (_ = theme2(section || id, params)) && {
  [section || id]: _
};
var themePropertyFallback = (section, separator) => (params, {theme: theme2}, id) => (_ = theme2(section || id, params, join(params, separator))) && {
  [section || id]: _
};
var alias = (handler, name) => (params, context) => handler(params, context, name);
var display = property("display");
var position = property("position");
var textTransform = property("textTransform");
var textDecoration = property("textDecoration");
var fontStyle = property("fontStyle");
var fontVariantNumeric = (key) => (params, context, id) => ({
  ["--tw-" + key]: id,
  fontVariantNumeric: "var(--tw-ordinal,/*!*/ /*!*/) var(--tw-slashed-zero,/*!*/ /*!*/) var(--tw-numeric-figure,/*!*/ /*!*/) var(--tw-numeric-spacing,/*!*/ /*!*/) var(--tw-numeric-fraction,/*!*/ /*!*/)"
});
var inset = (params, {theme: theme2}, id) => (_ = theme2("inset", params)) && {[id]: _};
var opacityProperty = (params, theme2, id, section = id) => (_ = theme2(section + "Opacity", tail(params))) && {
  [`--tw-${id}-opacity`]: _
};
var parseColorComponent = (chars, factor) => Math.round(parseInt(chars, 16) * factor);
var asRGBA = (color, opacityProperty2, opacityDefault) => {
  if (color && color[0] == "#" && (_ = (color.length - 1) / 3) && ($ = [17, 1, 0.062272][_ - 1])) {
    return `rgba(${parseColorComponent(color.substr(1, _), $)},${parseColorComponent(color.substr(1 + _, _), $)},${parseColorComponent(color.substr(1 + 2 * _, _), $)},${opacityProperty2 ? `var(--tw-${opacityProperty2}${opacityDefault ? "," + opacityDefault : ""})` : opacityDefault || 1})`;
  }
  return color;
};
var withOpacityFallback = (property2, kind, color) => color && typeof color == "string" ? (_ = asRGBA(color, kind + "-opacity")) && _ !== color ? {
  [`--tw-${kind}-opacity`]: "1",
  [property2]: [color, _]
} : {[property2]: color} : void 0;
var transparentTo = (color) => ($ = asRGBA(color, "", "0")) == _ ? "transparent" : $;
var reversableEdge = (params, {theme: theme2}, id, section, prefix, suffix) => (_ = {x: ["right", "left"], y: ["bottom", "top"]}[params[0]]) && ($ = `--tw-${id}-${params[0]}-reverse`) ? params[1] == "reverse" ? {
  [$]: "1"
} : {
  [$]: "0",
  [joinTruthy([prefix, _[0], suffix])]: (__ = theme2(section, tail(params))) && `calc(${__} * var(${$}))`,
  [joinTruthy([prefix, _[1], suffix])]: __ && [__, `calc(${__} * calc(1 - var(${$})))`]
} : void 0;
var placeHelper = (property2, params) => params[0] && {
  [property2]: (includes("wun", (params[0] || "")[3]) ? "space-" : "") + params[0]
};
var contentPluginFor = (property2) => (params) => includes(["start", "end"], params[0]) ? {[property2]: "flex-" + params[0]} : placeHelper(property2, params);
var gridPlugin = (kind) => (params, {theme: theme2}) => {
  if (_ = theme2("grid" + capitalize(kind), params, "")) {
    return {["grid-" + kind]: _};
  }
  switch (params[0]) {
    case "span":
      return params[1] && {
        ["grid-" + kind]: `span ${params[1]} / span ${params[1]}`
      };
    case "start":
    case "end":
      return (_ = theme2("grid" + capitalize(kind) + capitalize(params[0]), tail(params), join(tail(params)))) && {
        [`grid-${kind}-${params[0]}`]: _
      };
  }
};
var border = (params, {theme: theme2}, id) => {
  switch (params[0]) {
    case "solid":
    case "dashed":
    case "dotted":
    case "double":
    case "none":
      return propertyValue("borderStyle")(params);
    case "collapse":
    case "separate":
      return propertyValue("borderCollapse")(params);
    case "opacity":
      return opacityProperty(params, theme2, id);
  }
  return (_ = theme2(id + "Width", params, "")) ? {borderWidth: _} : withOpacityFallback("borderColor", id, theme2(id + "Color", params));
};
var transform = (gpu) => (gpu ? "translate3d(var(--tw-translate-x,0),var(--tw-translate-y,0),0)" : "translateX(var(--tw-translate-x,0)) translateY(var(--tw-translate-y,0))") + " rotate(var(--tw-rotate,0)) skewX(var(--tw-skew-x,0)) skewY(var(--tw-skew-y,0)) scaleX(var(--tw-scale-x,1)) scaleY(var(--tw-scale-y,1))";
var transformXYFunction = (params, context, id) => params[0] && (_ = context.theme(id, params[1] || params[0])) && {
  [`--tw-${id}-x`]: params[0] !== "y" && _,
  [`--tw-${id}-y`]: params[0] !== "x" && _,
  transform: [`${id}${params[1] ? params[0].toUpperCase() : ""}(${_})`, transform()]
};
var edgesPluginFor = (key) => (params, context, id) => id[1] ? edges(context.theme(key, params), id[1], key) : themeProperty(key)(params, context, id);
var padding = edgesPluginFor("padding");
var margin = edgesPluginFor("margin");
var minMax = (params, {theme: theme2}, id) => (_ = {w: "width", h: "height"}[params[0]]) && {
  [_ = `${id}${capitalize(_)}`]: theme2(_, tail(params))
};
var filter = (params, {theme: theme2}, id) => {
  const parts = id.split("-");
  const prefix = parts[0] == "backdrop" ? parts[0] + "-" : "";
  if (!prefix) {
    params.unshift(...parts);
  }
  if (params[0] == "filter") {
    const filters = [
      "blur",
      "brightness",
      "contrast",
      "grayscale",
      "hue-rotate",
      "invert",
      prefix && "opacity",
      "saturate",
      "sepia",
      !prefix && "drop-shadow"
    ].filter(Boolean);
    return params[1] == "none" ? {[prefix + "filter"]: "none"} : filters.reduce((css, key) => {
      css["--tw-" + prefix + key] = "var(--tw-empty,/*!*/ /*!*/)";
      return css;
    }, {
      [prefix + "filter"]: filters.map((key) => `var(--tw-${prefix}${key})`).join(" ")
    });
  }
  $ = params.shift();
  if (includes(["hue", "drop"], $))
    $ += capitalize(params.shift());
  return (_ = theme2(prefix ? "backdrop" + capitalize($) : $, params)) && {
    ["--tw-" + prefix + $]: (Array.isArray(_) ? _ : [_]).map((_4) => `${hyphenate($)}(${_4})`).join(" ")
  };
};
var corePlugins = {
  group: (params, {tag}, id) => tag(join([id, ...params])),
  hidden: alias(display, "none"),
  inline: display,
  block: display,
  contents: display,
  flow: display,
  table: (params, context, id) => includes(["auto", "fixed"], params[0]) ? {tableLayout: params[0]} : display(params, context, id),
  flex(params, context, id) {
    switch (params[0]) {
      case "row":
      case "col":
        return {
          flexDirection: join(params[0] == "col" ? ["column", ...tail(params)] : params)
        };
      case "nowrap":
      case "wrap":
        return {flexWrap: join(params)};
      case "grow":
      case "shrink":
        _ = context.theme("flex" + capitalize(params[0]), tail(params), params[1] || 1);
        return _ != null && {
          ["flex-" + params[0]]: "" + _
        };
    }
    return (_ = context.theme("flex", params, "")) ? {flex: _} : display(params, context, id);
  },
  grid(params, context, id) {
    switch (params[0]) {
      case "cols":
      case "rows":
        return (_ = context.theme("gridTemplate" + capitalize(toColumnsOrRows(params[0])), tail(params), params.length == 2 && Number(params[1]) ? `repeat(${params[1]},minmax(0,1fr))` : join(tail(params)))) && {
          ["gridTemplate-" + toColumnsOrRows(params[0])]: _
        };
      case "flow":
        return params.length > 1 && {
          gridAutoFlow: join(params[1] == "col" ? ["column", ...tail(params, 2)] : tail(params), " ")
        };
    }
    return display(params, context, id);
  },
  auto: (params, {theme: theme2}) => includes(["cols", "rows"], params[0]) && (_ = theme2("gridAuto" + capitalize(toColumnsOrRows(params[0])), tail(params), join(tail(params)))) && {
    ["gridAuto-" + toColumnsOrRows(params[0])]: _
  },
  static: position,
  fixed: position,
  absolute: position,
  relative: position,
  sticky: position,
  visible: {visibility: "visible"},
  invisible: {visibility: "hidden"},
  antialiased: {
    WebkitFontSmoothing: "antialiased",
    MozOsxFontSmoothing: "grayscale"
  },
  "subpixel-antialiased": {
    WebkitFontSmoothing: "auto",
    MozOsxFontSmoothing: "auto"
  },
  truncate: {
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis"
  },
  "sr-only": {
    position: "absolute",
    width: "1px",
    height: "1px",
    padding: "0",
    margin: "-1px",
    overflow: "hidden",
    whiteSpace: "nowrap",
    clip: "rect(0,0,0,0)",
    borderWidth: "0"
  },
  "not-sr-only": {
    position: "static",
    width: "auto",
    height: "auto",
    padding: "0",
    margin: "0",
    overflow: "visible",
    whiteSpace: "normal",
    clip: "auto"
  },
  resize: (params) => ({
    resize: {x: "horizontal", y: "vertical"}[params[0]] || params[0] || "both"
  }),
  box: (params) => params[0] && {boxSizing: params[0] + "-box"},
  appearance: propertyValue(),
  cursor: themePropertyFallback(),
  float: propertyValue(),
  clear: propertyValue(),
  decoration: propertyValue("boxDecorationBreak"),
  isolate: {isolation: "isolate"},
  isolation: propertyValue(),
  "mix-blend": propertyValue("mixBlendMode"),
  top: inset,
  right: inset,
  bottom: inset,
  left: inset,
  inset: (params, {theme: theme2}) => (_ = expandEdges(params[0])) ? edges(theme2("inset", tail(params)), params[0]) : (_ = theme2("inset", params)) && {
    top: _,
    right: _,
    bottom: _,
    left: _
  },
  underline: textDecoration,
  "line-through": textDecoration,
  "no-underline": alias(textDecoration, "none"),
  "text-underline": alias(textDecoration, "underline"),
  "text-no-underline": alias(textDecoration, "none"),
  "text-line-through": alias(textDecoration, "line-through"),
  uppercase: textTransform,
  lowercase: textTransform,
  capitalize: textTransform,
  "normal-case": alias(textTransform, "none"),
  "text-normal-case": alias(textTransform, "none"),
  italic: fontStyle,
  "not-italic": alias(fontStyle, "normal"),
  "font-italic": alias(fontStyle, "italic"),
  "font-not-italic": alias(fontStyle, "normal"),
  font: (params, context, id) => (_ = context.theme("fontFamily", params, "")) ? {fontFamily: _} : themeProperty("fontWeight")(params, context, id),
  items: (params) => params[0] && {
    alignItems: includes(["start", "end"], params[0]) ? "flex-" + params[0] : join(params)
  },
  "justify-self": propertyValue(),
  "justify-items": propertyValue(),
  justify: contentPluginFor("justifyContent"),
  content: contentPluginFor("alignContent"),
  self: contentPluginFor("alignSelf"),
  place: (params) => params[0] && placeHelper("place-" + params[0], tail(params)),
  overscroll: (params) => params[0] && {
    ["overscrollBehavior" + (params[1] ? "-" + params[0] : "")]: params[1] || params[0]
  },
  col: gridPlugin("column"),
  row: gridPlugin("row"),
  duration: themeProperty("transitionDuration"),
  delay: themeProperty("transitionDelay"),
  tracking: themeProperty("letterSpacing"),
  leading: themeProperty("lineHeight"),
  z: themeProperty("zIndex"),
  opacity: themeProperty(),
  ease: themeProperty("transitionTimingFunction"),
  p: padding,
  py: padding,
  px: padding,
  pt: padding,
  pr: padding,
  pb: padding,
  pl: padding,
  m: margin,
  my: margin,
  mx: margin,
  mt: margin,
  mr: margin,
  mb: margin,
  ml: margin,
  w: themeProperty("width"),
  h: themeProperty("height"),
  min: minMax,
  max: minMax,
  fill: themeProperty(),
  order: themeProperty(),
  origin: themePropertyFallback("transformOrigin", " "),
  select: propertyValue("userSelect"),
  "pointer-events": propertyValue(),
  align: propertyValue("verticalAlign"),
  whitespace: propertyValue("whiteSpace"),
  "normal-nums": {fontVariantNumeric: "normal"},
  ordinal: fontVariantNumeric("ordinal"),
  "slashed-zero": fontVariantNumeric("slashed-zero"),
  "lining-nums": fontVariantNumeric("numeric-figure"),
  "oldstyle-nums": fontVariantNumeric("numeric-figure"),
  "proportional-nums": fontVariantNumeric("numeric-spacing"),
  "tabular-nums": fontVariantNumeric("numeric-spacing"),
  "diagonal-fractions": fontVariantNumeric("numeric-fraction"),
  "stacked-fractions": fontVariantNumeric("numeric-fraction"),
  overflow: (params, context, id) => includes(["ellipsis", "clip"], params[0]) ? propertyValue("textOverflow")(params) : params[1] ? {["overflow-" + params[0]]: params[1]} : propertyValue()(params, context, id),
  transform: (params) => params[0] == "none" ? {transform: "none"} : {
    "--tw-translate-x": "0",
    "--tw-translate-y": "0",
    "--tw-rotate": "0",
    "--tw-skew-x": "0",
    "--tw-skew-y": "0",
    "--tw-scale-x": "1",
    "--tw-scale-y": "1",
    transform: transform(params[0] == "gpu")
  },
  rotate: (params, {theme: theme2}) => (_ = theme2("rotate", params)) && {
    "--tw-rotate": _,
    transform: [`rotate(${_})`, transform()]
  },
  scale: transformXYFunction,
  translate: transformXYFunction,
  skew: transformXYFunction,
  gap: (params, context, id) => (_ = {x: "column", y: "row"}[params[0]]) ? {[_ + "Gap"]: context.theme("gap", tail(params))} : themeProperty("gap")(params, context, id),
  stroke: (params, context, id) => (_ = context.theme("stroke", params, "")) ? {stroke: _} : themeProperty("strokeWidth")(params, context, id),
  outline: (params, {theme: theme2}) => (_ = theme2("outline", params)) && {
    outline: _[0],
    outlineOffset: _[1]
  },
  "break-normal": {
    wordBreak: "normal",
    overflowWrap: "normal"
  },
  "break-words": {overflowWrap: "break-word"},
  "break-all": {wordBreak: "break-all"},
  text(params, {theme: theme2}, id) {
    switch (params[0]) {
      case "left":
      case "center":
      case "right":
      case "justify":
        return {textAlign: params[0]};
      case "uppercase":
      case "lowercase":
      case "capitalize":
        return textTransform([], _, params[0]);
      case "opacity":
        return opacityProperty(params, theme2, id);
    }
    const fontSize = theme2("fontSize", params, "");
    if (fontSize) {
      return typeof fontSize == "string" ? {fontSize} : {
        fontSize: fontSize[0],
        ...typeof fontSize[1] == "string" ? {lineHeight: fontSize[1]} : fontSize[1]
      };
    }
    return withOpacityFallback("color", "text", theme2("textColor", params));
  },
  bg(params, {theme: theme2}, id) {
    switch (params[0]) {
      case "fixed":
      case "local":
      case "scroll":
        return propertyValue("backgroundAttachment", ",")(params);
      case "bottom":
      case "center":
      case "left":
      case "right":
      case "top":
        return propertyValue("backgroundPosition", " ")(params);
      case "no":
        return params[1] == "repeat" && propertyValue("backgroundRepeat")(params);
      case "repeat":
        return includes("xy", params[1]) ? propertyValue("backgroundRepeat")(params) : {backgroundRepeat: params[1] || params[0]};
      case "opacity":
        return opacityProperty(params, theme2, id, "background");
      case "clip":
      case "origin":
        return params[1] && {
          ["background-" + params[0]]: params[1] + (params[1] == "text" ? "" : "-box")
        };
      case "blend":
        return propertyValue("background-blend-mode")(tail(params));
      case "gradient":
        if (params[1] == "to" && (_ = expandEdges(params[2]))) {
          return {
            backgroundImage: `linear-gradient(to ${join(_, " ")},var(--tw-gradient-stops))`
          };
        }
    }
    return (_ = theme2("backgroundPosition", params, "")) ? {backgroundPosition: _} : (_ = theme2("backgroundSize", params, "")) ? {backgroundSize: _} : (_ = theme2("backgroundImage", params, "")) ? {backgroundImage: _} : withOpacityFallback("backgroundColor", "bg", theme2("backgroundColor", params));
  },
  from: (params, {theme: theme2}) => (_ = theme2("gradientColorStops", params)) && {
    "--tw-gradient-from": _,
    "--tw-gradient-stops": `var(--tw-gradient-from),var(--tw-gradient-to,${transparentTo(_)})`
  },
  via: (params, {theme: theme2}) => (_ = theme2("gradientColorStops", params)) && {
    "--tw-gradient-stops": `var(--tw-gradient-from),${_},var(--tw-gradient-to,${transparentTo(_)})`
  },
  to: (params, {theme: theme2}) => (_ = theme2("gradientColorStops", params)) && {
    "--tw-gradient-to": _
  },
  border: (params, context, id) => expandEdges(params[0]) ? edges(context.theme("borderWidth", tail(params)), params[0], "border", "width") : border(params, context, id),
  divide: (params, context, id) => (_ = reversableEdge(params, context, id, "divideWidth", "border", "width") || border(params, context, id)) && {
    "&>:not([hidden])~:not([hidden])": _
  },
  space: (params, context, id) => (_ = reversableEdge(params, context, id, "space", "margin")) && {
    "&>:not([hidden])~:not([hidden])": _
  },
  placeholder: (params, {theme: theme2}, id) => (_ = params[0] == "opacity" ? opacityProperty(params, theme2, id) : withOpacityFallback("color", "placeholder", theme2("placeholderColor", params))) && {
    "&::placeholder": _
  },
  shadow: (params, {theme: theme2}) => (_ = theme2("boxShadow", params)) && {
    ":global": {
      "*": {
        "--tw-shadow": "0 0 transparent"
      }
    },
    "--tw-shadow": _ == "none" ? "0 0 transparent" : _,
    boxShadow: [
      _,
      `var(--tw-ring-offset-shadow,0 0 transparent),var(--tw-ring-shadow,0 0 transparent),var(--tw-shadow)`
    ]
  },
  animate: (params, {theme: theme2, tag}) => {
    if ($ = theme2("animation", params)) {
      const parts = $.split(" ");
      if ((_ = theme2("keyframes", parts[0], __ = {})) !== __) {
        return ($ = tag(parts[0])) && {
          animation: $ + " " + join(tail(parts), " "),
          ["@keyframes " + $]: _
        };
      }
      return {animation: $};
    }
  },
  ring(params, {theme: theme2}, id) {
    switch (params[0]) {
      case "inset":
        return {"--tw-ring-inset": "inset"};
      case "opacity":
        return opacityProperty(params, theme2, id);
      case "offset":
        return (_ = theme2("ringOffsetWidth", tail(params), "")) ? {
          "--tw-ring-offset-width": _
        } : {
          "--tw-ring-offset-color": theme2("ringOffsetColor", tail(params))
        };
    }
    return (_ = theme2("ringWidth", params, "")) ? {
      "--tw-ring-offset-shadow": `var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color)`,
      "--tw-ring-shadow": `var(--tw-ring-inset) 0 0 0 calc(${_} + var(--tw-ring-offset-width)) var(--tw-ring-color)`,
      boxShadow: `var(--tw-ring-offset-shadow),var(--tw-ring-shadow),var(--tw-shadow,0 0 transparent)`,
      ":global": {
        "*": {
          "--tw-ring-inset": "var(--tw-empty,/*!*/ /*!*/)",
          "--tw-ring-offset-width": theme2("ringOffsetWidth", "", "0px"),
          "--tw-ring-offset-color": theme2("ringOffsetColor", "", "#fff"),
          "--tw-ring-color": asRGBA(theme2("ringColor", "", "#93c5fd"), "ring-opacity", theme2("ringOpacity", "", "0.5")),
          "--tw-ring-offset-shadow": "0 0 transparent",
          "--tw-ring-shadow": "0 0 transparent"
        }
      }
    } : {
      "--tw-ring-opacity": "1",
      "--tw-ring-color": asRGBA(theme2("ringColor", params), "ring-opacity")
    };
  },
  object: (params, context, id) => includes(["contain", "cover", "fill", "none", "scale-down"], join(params)) ? {objectFit: join(params)} : themePropertyFallback("objectPosition", " ")(params, context, id),
  list: (params, context, id) => join(params) == "item" ? display(params, context, id) : includes(["inside", "outside"], join(params)) ? {listStylePosition: params[0]} : themePropertyFallback("listStyleType")(params, context, id),
  rounded: (params, context, id) => corners(context.theme("borderRadius", tail(params), ""), params[0], "border", "radius") || themeProperty("borderRadius")(params, context, id),
  "transition-none": {transitionProperty: "none"},
  transition: (params, {theme: theme2}) => ({
    transitionProperty: theme2("transitionProperty", params),
    transitionTimingFunction: theme2("transitionTimingFunction", ""),
    transitionDuration: theme2("transitionDuration", "")
  }),
  container: (params, {theme: theme2}) => {
    const {screens = theme2("screens"), center, padding: padding2} = theme2("container");
    const paddingFor = (screen) => (_ = padding2 && (typeof padding2 == "string" ? padding2 : padding2[screen] || padding2.DEFAULT)) ? {
      paddingRight: _,
      paddingLeft: _
    } : {};
    return Object.keys(screens).reduce((rules2, screen) => {
      if (($ = screens[screen]) && typeof $ == "string") {
        rules2[buildMediaQuery($)] = {
          "&": {
            "max-width": $,
            ...paddingFor(screen)
          }
        };
      }
      return rules2;
    }, {
      width: "100%",
      ...center ? {marginRight: "auto", marginLeft: "auto"} : {},
      ...paddingFor("xs")
    });
  },
  filter,
  blur: filter,
  brightness: filter,
  contrast: filter,
  grayscale: filter,
  "hue-rotate": filter,
  invert: filter,
  saturate: filter,
  sepia: filter,
  "drop-shadow": filter,
  backdrop: filter
};

// src/twind/preflight.ts
var createPreflight = (theme2) => ({
  ":root": {tabSize: 4},
  "body,blockquote,dl,dd,h1,h2,h3,h4,h5,h6,hr,figure,p,pre,fieldset,ol,ul": {margin: "0"},
  button: {backgroundColor: "transparent", backgroundImage: "none"},
  'button,[type="button"],[type="reset"],[type="submit"]': {WebkitAppearance: "button"},
  "button:focus": {outline: ["1px dotted", "5px auto -webkit-focus-ring-color"]},
  "fieldset,ol,ul,legend": {padding: "0"},
  "ol,ul": {listStyle: "none"},
  html: {
    lineHeight: "1.5",
    WebkitTextSizeAdjust: "100%",
    fontFamily: theme2("fontFamily.sans", "ui-sans-serif,system-ui,sans-serif")
  },
  body: {fontFamily: "inherit", lineHeight: "inherit"},
  "*,::before,::after": {
    boxSizing: "border-box",
    border: `0 solid ${theme2("borderColor.DEFAULT", "currentColor")}`
  },
  hr: {height: "0", color: "inherit", borderTopWidth: "1px"},
  img: {borderStyle: "solid"},
  textarea: {resize: "vertical"},
  "input::placeholder,textarea::placeholder": {
    opacity: "1",
    color: theme2("placeholderColor.DEFAULT", theme2("colors.gray.400", "#a1a1aa"))
  },
  'button,[role="button"]': {cursor: "pointer"},
  table: {textIndent: "0", borderColor: "inherit", borderCollapse: "collapse"},
  "h1,h2,h3,h4,h5,h6": {fontSize: "inherit", fontWeight: "inherit"},
  a: {color: "inherit", textDecoration: "inherit"},
  "button,input,optgroup,select,textarea": {
    fontFamily: "inherit",
    fontSize: "100%",
    margin: "0",
    padding: "0",
    lineHeight: "inherit",
    color: "inherit"
  },
  "button,select": {textTransform: "none"},
  "::-moz-focus-inner": {borderStyle: "none", padding: "0"},
  ":-moz-focusring": {outline: "1px dotted ButtonText"},
  ":-moz-ui-invalid": {boxShadow: "none"},
  progress: {verticalAlign: "baseline"},
  "::-webkit-inner-spin-button,::-webkit-outer-spin-button": {height: "auto"},
  '[type="search"]': {WebkitAppearance: "textfield", outlineOffset: "-2px"},
  "::-webkit-search-decoration": {WebkitAppearance: "none"},
  "::-webkit-file-upload-button": {WebkitAppearance: "button", font: "inherit"},
  summary: {display: "list-item"},
  "abbr[title]": {textDecoration: "underline dotted"},
  "b,strong": {fontWeight: "bolder"},
  "pre,code,kbd,samp": {
    fontFamily: theme2("fontFamily", "mono", "ui-monospace,monospace"),
    fontSize: "1em"
  },
  "sub,sup": {fontSize: "75%", lineHeight: "0", position: "relative", verticalAlign: "baseline"},
  sub: {bottom: "-0.25em"},
  sup: {top: "-0.5em"},
  "img,svg,video,canvas,audio,iframe,embed,object": {display: "block", verticalAlign: "middle"},
  "img,video": {maxWidth: "100%", height: "auto"}
});

// src/twind/variants.ts
var coreVariants = {
  dark: "@media (prefers-color-scheme:dark)",
  sticky: "@supports ((position: -webkit-sticky) or (position:sticky))",
  "motion-reduce": "@media (prefers-reduced-motion:reduce)",
  "motion-safe": "@media (prefers-reduced-motion:no-preference)",
  first: "&:first-child",
  last: "&:last-child",
  even: "&:nth-child(2n)",
  odd: "&:nth-child(odd)",
  children: "&>*",
  siblings: "&~*",
  sibling: "&+*",
  override: "&&"
};

// src/internal/dom.ts
var STYLE_ELEMENT_ID = "__twind";
var getStyleElement = (nonce) => {
  let element = self[STYLE_ELEMENT_ID];
  if (!element) {
    element = document.head.appendChild(document.createElement("style"));
    element.id = STYLE_ELEMENT_ID;
    nonce && (element.nonce = nonce);
    element.appendChild(document.createTextNode(""));
  }
  return element;
};

// src/twind/sheets.ts
var cssomSheet = ({
  nonce,
  target = getStyleElement(nonce).sheet
} = {}) => {
  const offset = target.cssRules.length;
  return {
    target,
    insert: (rule, index) => target.insertRule(rule, offset + index)
  };
};
var voidSheet = () => ({
  target: null,
  insert: noop
});

// src/twind/modes.ts
var mode = (report) => ({
  unknown(section, key = [], optional, context) {
    if (!optional) {
      this.report({id: "UNKNOWN_THEME_VALUE", key: section + "." + join(key)}, context);
    }
  },
  report({id, ...info}) {
    return report(`[${id}] ${JSON.stringify(info)}`);
  }
});
var warn = /* @__PURE__ */ mode((message) => console.warn(message));
var strict = /* @__PURE__ */ mode((message) => {
  throw new Error(message);
});
var silent = /* @__PURE__ */ mode(noop);

// src/twind/prefix.ts

var noprefix = (property2, value, important) => `${property2}:${value}${important ? " !important" : ""}`;
var autoprefix = (property2, value, important) => {
  let cssText = "";
  const propertyAlias = r(property2);
  if (propertyAlias)
    cssText += `${noprefix(propertyAlias, value, important)};`;
  let flags = a(property2);
  if (flags & 1)
    cssText += `-webkit-${noprefix(property2, value, important)};`;
  if (flags & 2)
    cssText += `-moz-${noprefix(property2, value, important)};`;
  if (flags & 4)
    cssText += `-ms-${noprefix(property2, value, important)};`;
  flags = t(property2, value);
  if (flags & 1)
    cssText += `${noprefix(property2, `-webkit-${value}`, important)};`;
  if (flags & 2)
    cssText += `${noprefix(property2, `-moz-${value}`, important)};`;
  if (flags & 4)
    cssText += `${noprefix(property2, `-ms-${value}`, important)};`;
  cssText += noprefix(property2, value, important);
  return cssText;
};

// src/twind/theme.ts
var ratios = (start, end) => {
  const result = {};
  do {
    for (let dividend = 1; dividend < start; dividend++) {
      result[`${dividend}/${start}`] = Number((dividend / start * 100).toFixed(6)) + "%";
    }
  } while (++start <= end);
  return result;
};
var exponential = (stop, unit, start = 0) => {
  const result = {};
  for (; start <= stop; start = start * 2 || 1) {
    result[start] = start + unit;
  }
  return result;
};
var linear = (stop, unit = "", divideBy = 1, start = 0, step = 1, result = {}) => {
  for (; start <= stop; start += step) {
    result[start] = start / divideBy + unit;
  }
  return result;
};
var alias2 = (section) => (theme2) => theme2(section);
var themeFactory = (args, {theme: theme2}) => theme2(...args);
var theme = (...args) => directive(themeFactory, args);
var defaultTheme = {
  screens: {
    sm: "640px",
    md: "768px",
    lg: "1024px",
    xl: "1280px",
    "2xl": "1536px"
  },
  colors: {
    transparent: "transparent",
    current: "currentColor",
    black: "#000",
    white: "#fff",
    gray: {
      50: "#f9fafb",
      100: "#f3f4f6",
      200: "#e5e7eb",
      300: "#d1d5db",
      400: "#9ca3af",
      500: "#6b7280",
      600: "#4b5563",
      700: "#374151",
      800: "#1f2937",
      900: "#111827"
    },
    red: {
      50: "#fef2f2",
      100: "#fee2e2",
      200: "#fecaca",
      300: "#fca5a5",
      400: "#f87171",
      500: "#ef4444",
      600: "#dc2626",
      700: "#b91c1c",
      800: "#991b1b",
      900: "#7f1d1d"
    },
    yellow: {
      50: "#fffbeb",
      100: "#fef3c7",
      200: "#fde68a",
      300: "#fcd34d",
      400: "#fbbf24",
      500: "#f59e0b",
      600: "#d97706",
      700: "#b45309",
      800: "#92400e",
      900: "#78350f"
    },
    green: {
      50: "#ecfdf5",
      100: "#d1fae5",
      200: "#a7f3d0",
      300: "#6ee7b7",
      400: "#34d399",
      500: "#10b981",
      600: "#059669",
      700: "#047857",
      800: "#065f46",
      900: "#064e3b"
    },
    blue: {
      50: "#eff6ff",
      100: "#dbeafe",
      200: "#bfdbfe",
      300: "#93c5fd",
      400: "#60a5fa",
      500: "#3b82f6",
      600: "#2563eb",
      700: "#1d4ed8",
      800: "#1e40af",
      900: "#1e3a8a"
    },
    indigo: {
      50: "#eef2ff",
      100: "#e0e7ff",
      200: "#c7d2fe",
      300: "#a5b4fc",
      400: "#818cf8",
      500: "#6366f1",
      600: "#4f46e5",
      700: "#4338ca",
      800: "#3730a3",
      900: "#312e81"
    },
    purple: {
      50: "#f5f3ff",
      100: "#ede9fe",
      200: "#ddd6fe",
      300: "#c4b5fd",
      400: "#a78bfa",
      500: "#8b5cf6",
      600: "#7c3aed",
      700: "#6d28d9",
      800: "#5b21b6",
      900: "#4c1d95"
    },
    pink: {
      50: "#fdf2f8",
      100: "#fce7f3",
      200: "#fbcfe8",
      300: "#f9a8d4",
      400: "#f472b6",
      500: "#ec4899",
      600: "#db2777",
      700: "#be185d",
      800: "#9d174d",
      900: "#831843"
    }
  },
  spacing: {
    px: "1px",
    0: "0px",
    .../* @__PURE__ */ linear(4, "rem", 4, 0.5, 0.5),
    .../* @__PURE__ */ linear(12, "rem", 4, 5),
    14: "3.5rem",
    .../* @__PURE__ */ linear(64, "rem", 4, 16, 4),
    72: "18rem",
    80: "20rem",
    96: "24rem"
  },
  durations: {
    75: "75ms",
    100: "100ms",
    150: "150ms",
    200: "200ms",
    300: "300ms",
    500: "500ms",
    700: "700ms",
    1e3: "1000ms"
  },
  animation: {
    none: "none",
    spin: "spin 1s linear infinite",
    ping: "ping 1s cubic-bezier(0, 0, 0.2, 1) infinite",
    pulse: "pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite",
    bounce: "bounce 1s infinite"
  },
  backdropBlur: /* @__PURE__ */ alias2("blur"),
  backdropBrightness: /* @__PURE__ */ alias2("brightness"),
  backdropContrast: /* @__PURE__ */ alias2("contrast"),
  backdropGrayscale: /* @__PURE__ */ alias2("grayscale"),
  backdropHueRotate: /* @__PURE__ */ alias2("hueRotate"),
  backdropInvert: /* @__PURE__ */ alias2("invert"),
  backdropOpacity: /* @__PURE__ */ alias2("opacity"),
  backdropSaturate: /* @__PURE__ */ alias2("saturate"),
  backdropSepia: /* @__PURE__ */ alias2("sepia"),
  backgroundColor: /* @__PURE__ */ alias2("colors"),
  backgroundImage: {
    none: "none"
  },
  backgroundOpacity: /* @__PURE__ */ alias2("opacity"),
  backgroundSize: {
    auto: "auto",
    cover: "cover",
    contain: "contain"
  },
  blur: {
    0: "0",
    sm: "4px",
    DEFAULT: "8px",
    md: "12px",
    lg: "16px",
    xl: "24px",
    "2xl": "40px",
    "3xl": "64px"
  },
  brightness: {
    .../* @__PURE__ */ linear(200, "", 100, 0, 50),
    .../* @__PURE__ */ linear(110, "", 100, 90, 5),
    75: "0.75",
    125: "1.25"
  },
  borderColor: (theme2) => ({
    ...theme2("colors"),
    DEFAULT: theme2("colors.gray.200", "currentColor")
  }),
  borderOpacity: /* @__PURE__ */ alias2("opacity"),
  borderRadius: {
    none: "0px",
    sm: "0.125rem",
    DEFAULT: "0.25rem",
    md: "0.375rem",
    lg: "0.5rem",
    xl: "0.75rem",
    "2xl": "1rem",
    "3xl": "1.5rem",
    "1/2": "50%",
    full: "9999px"
  },
  borderWidth: {
    DEFAULT: "1px",
    .../* @__PURE__ */ exponential(8, "px")
  },
  boxShadow: {
    sm: "0 1px 2px 0 rgba(0,0,0,0.05)",
    DEFAULT: "0 1px 3px 0 rgba(0,0,0,0.1), 0 1px 2px 0 rgba(0,0,0,0.06)",
    md: "0 4px 6px -1px rgba(0,0,0,0.1), 0 2px 4px -1px rgba(0,0,0,0.06)",
    lg: "0 10px 15px -3px rgba(0,0,0,0.1), 0 4px 6px -2px rgba(0,0,0,0.05)",
    xl: "0 20px 25px -5px rgba(0,0,0,0.1), 0 10px 10px -5px rgba(0,0,0,0.04)",
    "2xl": "0 25px 50px -12px rgba(0,0,0,0.25)",
    inner: "inset 0 2px 4px 0 rgba(0,0,0,0.06)",
    none: "none"
  },
  contrast: {
    .../* @__PURE__ */ linear(200, "", 100, 0, 50),
    75: "0.75",
    125: "1.25"
  },
  divideColor: /* @__PURE__ */ alias2("borderColor"),
  divideOpacity: /* @__PURE__ */ alias2("borderOpacity"),
  divideWidth: /* @__PURE__ */ alias2("borderWidth"),
  dropShadow: {
    sm: "0 1px 1px rgba(0,0,0,0.05)",
    DEFAULT: ["0 1px 2px rgba(0,0,0,0.1)", "0 1px 1px rgba(0,0,0,0.06)"],
    md: ["0 4px 3px rgba(0,0,0,0.07)", "0 2px 2px rgba(0,0,0,0.06)"],
    lg: ["0 10px 8px rgba(0,0,0,0.04)", "0 4px 3px rgba(0,0,0,0.1)"],
    xl: ["0 20px 13px rgba(0,0,0,0.03)", "0 8px 5px rgba(0,0,0,0.08)"],
    "2xl": "0 25px 25px rgba(0,0,0,0.15)",
    none: "0 0 #0000"
  },
  fill: {current: "currentColor"},
  grayscale: {
    0: "0",
    DEFAULT: "100%"
  },
  hueRotate: {
    0: "0deg",
    15: "15deg",
    30: "30deg",
    60: "60deg",
    90: "90deg",
    180: "180deg"
  },
  invert: {
    0: "0",
    DEFAULT: "100%"
  },
  flex: {
    1: "1 1 0%",
    auto: "1 1 auto",
    initial: "0 1 auto",
    none: "none"
  },
  fontFamily: {
    sans: 'ui-sans-serif,system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji"'.split(","),
    serif: 'ui-serif,Georgia,Cambria,"Times New Roman",Times,serif'.split(","),
    mono: 'ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,"Liberation Mono","Courier New",monospace'.split(",")
  },
  fontSize: {
    xs: ["0.75rem", "1rem"],
    sm: ["0.875rem", "1.25rem"],
    base: ["1rem", "1.5rem"],
    lg: ["1.125rem", "1.75rem"],
    xl: ["1.25rem", "1.75rem"],
    "2xl": ["1.5rem", "2rem"],
    "3xl": ["1.875rem", "2.25rem"],
    "4xl": ["2.25rem", "2.5rem"],
    "5xl": ["3rem", "1"],
    "6xl": ["3.75rem", "1"],
    "7xl": ["4.5rem", "1"],
    "8xl": ["6rem", "1"],
    "9xl": ["8rem", "1"]
  },
  fontWeight: {
    thin: "100",
    extralight: "200",
    light: "300",
    normal: "400",
    medium: "500",
    semibold: "600",
    bold: "700",
    extrabold: "800",
    black: "900"
  },
  gridTemplateColumns: {},
  gridTemplateRows: {},
  gridAutoColumns: {
    min: "min-content",
    max: "max-content",
    fr: "minmax(0,1fr)"
  },
  gridAutoRows: {
    min: "min-content",
    max: "max-content",
    fr: "minmax(0,1fr)"
  },
  gridColumn: {
    auto: "auto",
    "span-full": "1 / -1"
  },
  gridRow: {
    auto: "auto",
    "span-full": "1 / -1"
  },
  gap: /* @__PURE__ */ alias2("spacing"),
  gradientColorStops: /* @__PURE__ */ alias2("colors"),
  height: (theme2) => ({
    auto: "auto",
    ...theme2("spacing"),
    ...ratios(2, 6),
    full: "100%",
    screen: "100vh"
  }),
  inset: (theme2) => ({
    auto: "auto",
    ...theme2("spacing"),
    ...ratios(2, 4),
    full: "100%"
  }),
  keyframes: {
    spin: {
      from: {
        transform: "rotate(0deg)"
      },
      to: {
        transform: "rotate(360deg)"
      }
    },
    ping: {
      "0%": {
        transform: "scale(1)",
        opacity: "1"
      },
      "75%,100%": {
        transform: "scale(2)",
        opacity: "0"
      }
    },
    pulse: {
      "0%,100%": {
        opacity: "1"
      },
      "50%": {
        opacity: ".5"
      }
    },
    bounce: {
      "0%, 100%": {
        transform: "translateY(-25%)",
        animationTimingFunction: "cubic-bezier(0.8,0,1,1)"
      },
      "50%": {
        transform: "none",
        animationTimingFunction: "cubic-bezier(0,0,0.2,1)"
      }
    }
  },
  letterSpacing: {
    tighter: "-0.05em",
    tight: "-0.025em",
    normal: "0em",
    wide: "0.025em",
    wider: "0.05em",
    widest: "0.1em"
  },
  lineHeight: {
    none: "1",
    tight: "1.25",
    snug: "1.375",
    normal: "1.5",
    relaxed: "1.625",
    loose: "2",
    .../* @__PURE__ */ linear(10, "rem", 4, 3)
  },
  margin: (theme2) => ({
    auto: "auto",
    ...theme2("spacing")
  }),
  maxHeight: (theme2) => ({
    ...theme2("spacing"),
    full: "100%",
    screen: "100vh"
  }),
  maxWidth: (theme2, {breakpoints}) => ({
    none: "none",
    0: "0rem",
    xs: "20rem",
    sm: "24rem",
    md: "28rem",
    lg: "32rem",
    xl: "36rem",
    "2xl": "42rem",
    "3xl": "48rem",
    "4xl": "56rem",
    "5xl": "64rem",
    "6xl": "72rem",
    "7xl": "80rem",
    full: "100%",
    min: "min-content",
    max: "max-content",
    prose: "65ch",
    ...breakpoints(theme2("screens"))
  }),
  minHeight: {
    0: "0px",
    full: "100%",
    screen: "100vh"
  },
  minWidth: {
    0: "0px",
    full: "100%",
    min: "min-content",
    max: "max-content"
  },
  opacity: {
    .../* @__PURE__ */ linear(100, "", 100, 0, 10),
    5: "0.05",
    25: "0.25",
    75: "0.75",
    95: "0.95"
  },
  order: {
    first: "-9999",
    last: "9999",
    none: "0",
    .../* @__PURE__ */ linear(12, "", 1, 1)
  },
  outline: {
    none: ["2px solid transparent", "2px"],
    white: ["2px dotted white", "2px"],
    black: ["2px dotted black", "2px"]
  },
  padding: /* @__PURE__ */ alias2("spacing"),
  placeholderColor: /* @__PURE__ */ alias2("colors"),
  placeholderOpacity: /* @__PURE__ */ alias2("opacity"),
  ringColor: (theme2) => ({
    DEFAULT: theme2("colors.blue.500", "#3b82f6"),
    ...theme2("colors")
  }),
  ringOffsetColor: /* @__PURE__ */ alias2("colors"),
  ringOffsetWidth: /* @__PURE__ */ exponential(8, "px"),
  ringOpacity: (theme2) => ({
    DEFAULT: "0.5",
    ...theme2("opacity")
  }),
  ringWidth: {
    DEFAULT: "3px",
    .../* @__PURE__ */ exponential(8, "px")
  },
  rotate: {
    .../* @__PURE__ */ exponential(2, "deg"),
    .../* @__PURE__ */ exponential(12, "deg", 3),
    .../* @__PURE__ */ exponential(180, "deg", 45)
  },
  saturate: /* @__PURE__ */ linear(200, "", 100, 0, 50),
  scale: {
    .../* @__PURE__ */ linear(150, "", 100, 0, 50),
    .../* @__PURE__ */ linear(110, "", 100, 90, 5),
    75: "0.75",
    125: "1.25"
  },
  sepia: {
    0: "0",
    DEFAULT: "100%"
  },
  skew: {
    .../* @__PURE__ */ exponential(2, "deg"),
    .../* @__PURE__ */ exponential(12, "deg", 3)
  },
  space: /* @__PURE__ */ alias2("spacing"),
  stroke: {
    current: "currentColor"
  },
  strokeWidth: /* @__PURE__ */ linear(2),
  textColor: /* @__PURE__ */ alias2("colors"),
  textOpacity: /* @__PURE__ */ alias2("opacity"),
  transitionDuration: (theme2) => ({
    DEFAULT: "150ms",
    ...theme2("durations")
  }),
  transitionDelay: /* @__PURE__ */ alias2("durations"),
  transitionProperty: {
    none: "none",
    all: "all",
    DEFAULT: "background-color,border-color,color,fill,stroke,opacity,box-shadow,transform,filter,backdrop-filter",
    colors: "background-color,border-color,color,fill,stroke",
    opacity: "opacity",
    shadow: "box-shadow",
    transform: "transform"
  },
  transitionTimingFunction: {
    DEFAULT: "cubic-bezier(0.4,0,0.2,1)",
    linear: "linear",
    in: "cubic-bezier(0.4,0,1,1)",
    out: "cubic-bezier(0,0,0.2,1)",
    "in-out": "cubic-bezier(0.4,0,0.2,1)"
  },
  translate: (theme2) => ({
    ...theme2("spacing"),
    ...ratios(2, 4),
    full: "100%"
  }),
  width: (theme2) => ({
    auto: "auto",
    ...theme2("spacing"),
    ...ratios(2, 6),
    ...ratios(12, 12),
    screen: "100vw",
    full: "100%",
    min: "min-content",
    max: "max-content"
  }),
  zIndex: {
    auto: "auto",
    .../* @__PURE__ */ linear(50, "", 1, 0, 10)
  }
};
var flattenColorPalette = (colors, target = {}, prefix = []) => {
  Object.keys(colors).forEach((property2) => {
    const value = colors[property2];
    if (property2 == "DEFAULT") {
      target[join(prefix)] = value;
      target[join(prefix, ".")] = value;
    }
    const key = [...prefix, property2];
    target[join(key)] = value;
    target[join(key, ".")] = value;
    if (value && typeof value == "object") {
      flattenColorPalette(value, target, key);
    }
  }, target);
  return target;
};
var resolveContext = {
  negative: () => ({}),
  breakpoints: (screens) => Object.keys(screens).filter((key) => typeof screens[key] == "string").reduce((target, key) => {
    target["screen-" + key] = screens[key];
    return target;
  }, {})
};
var handleArbitraryValues = (section, key) => (key = key[0] == "[" && key.slice(-1) == "]" && key.slice(1, -1)) && includes(section, "olor") == /^(#|(hsl|rgb)a?\(|[a-z]+$)/.test(key) && (includes(key, "calc(") ? key.replace(/(-?\d*\.?\d(?!\b-.+[,)](?![^+\-/*])\D)(?:%|[a-z]+)?|\))([+\-/*])/g, "$1 $2 ") : key);
var makeThemeResolver = (config) => {
  const cache = new Map();
  const theme2 = {...defaultTheme, ...config};
  const deref = (theme3, section) => {
    const base = theme3 && theme3[section];
    const value = typeof base == "function" ? base(resolve, resolveContext) : base;
    return value && section == "colors" ? flattenColorPalette(value) : value;
  };
  const resolve = (section, key, defaultValue) => {
    const keypath = section.split(".");
    section = keypath[0];
    if (keypath.length > 1) {
      defaultValue = key;
      key = join(tail(keypath), ".");
    }
    let base = cache.get(section);
    if (!base) {
      cache.set(section, base = {...deref(theme2, section)});
      Object.assign(base, deref(theme2.extend, section));
    }
    if (key != null) {
      key = (Array.isArray(key) ? join(key) : key) || "DEFAULT";
      const value = handleArbitraryValues(section, key) || base[key];
      return value == null ? defaultValue : Array.isArray(value) && !includes(["fontSize", "outline", "dropShadow"], section) ? join(value, ",") : value;
    }
    return base;
  };
  return resolve;
};

// src/twind/translate.ts
var translate = (plugins, context) => (rule, isTranslating) => {
  if (typeof rule.d == "function") {
    return rule.d(context);
  }
  const parameters = rule.d.split(/-(?![^[]*])/g);
  if (!isTranslating && parameters[0] == "tw" && rule.$ == rule.d) {
    return rule.$;
  }
  for (let index = parameters.length; index; index--) {
    const id = join(parameters.slice(0, index));
    if (Object.prototype.hasOwnProperty.call(plugins, id)) {
      const plugin = plugins[id];
      return typeof plugin == "function" ? plugin(tail(parameters, index), context, id) : typeof plugin == "string" ? context[isTranslating ? "css" : "tw"](plugin) : plugin;
    }
  }
};

// src/twind/decorate.ts
var _2;
var GROUP_RE = /^:(group(?:(?!-focus).+?)*)-(.+)$/;
var NOT_PREFIX_RE = /^(:not)-(.+)/;
var prepareVariantSelector = (variant) => variant[1] == "[" ? tail(variant) : variant;
var decorate = (darkMode, variants, {theme: theme2, tag}) => {
  const applyVariant = (translation, variant) => {
    if (_2 = theme2("screens", tail(variant), "")) {
      return {[buildMediaQuery(_2)]: translation};
    }
    if (variant == ":dark" && darkMode == "class") {
      return {".dark &": translation};
    }
    if (_2 = GROUP_RE.exec(variant)) {
      return {[`.${twind_escape(tag(_2[1]))}:${_2[2]} &`]: translation};
    }
    return {
      [variants[tail(variant)] || "&" + variant.replace(NOT_PREFIX_RE, (_4, not, variant2) => not + "(" + prepareVariantSelector(":" + variant2) + ")")]: translation
    };
  };
  return (translation, rule) => rule.v.reduceRight(applyVariant, translation);
};

// src/twind/presedence.ts
var _3;
var responsivePrecedence = (css) => (((_3 = /(?:^|min-width: *)(\d+(?:.\d+)?)(p)?/.exec(css)) ? +_3[1] / (_3[2] ? 15 : 1) / 10 : 0) & 31) << 22;
var seperatorPrecedence = (string) => {
  _3 = 0;
  for (let index = string.length; index--; ) {
    _3 += includes("-:,", string[index]);
  }
  return _3;
};
var atRulePresedence = (css) => (seperatorPrecedence(css) & 15) << 18;
var PRECEDENCES_BY_PSEUDO_CLASS = [
  "rst",
  "st",
  "en",
  "d",
  "nk",
  "sited",
  "pty",
  "ecked",
  "cus-w",
  "ver",
  "cus",
  "cus-v",
  "tive",
  "sable",
  "ad-on",
  "tiona",
  "quire"
];
var pseudoPrecedence = (pseudoClass) => 1 << (~(_3 = PRECEDENCES_BY_PSEUDO_CLASS.indexOf(pseudoClass.replace(GROUP_RE, ":$2").slice(3, 8))) ? _3 : 17);
var makeVariantPresedenceCalculator = (theme2, variants) => (presedence, variant) => presedence | ((_3 = theme2("screens", tail(variant), "")) ? 1 << 27 | responsivePrecedence(buildMediaQuery(_3)) : variant == ":dark" ? 1 << 30 : (_3 = variants[variant] || variant.replace(NOT_PREFIX_RE, ":$2"))[0] == "@" ? atRulePresedence(_3) : pseudoPrecedence(variant));
var declarationPropertyPrecedence = (property2) => property2[0] == "-" ? 0 : seperatorPrecedence(property2) + ((_3 = /^(?:(border-(?!w|c|sty)|[tlbr].{2,4}m?$|c.{7}$)|([fl].{5}l|g.{8}$|pl))/.exec(property2)) ? +!!_3[1] || -!!_3[2] : 0) + 1;

// src/twind/serialize.ts
var stringifyBlock = (body, selector) => selector + "{" + body + "}";
var serialize = (prefix, variants, context) => {
  const {theme: theme2, tag} = context;
  const tagVar = (_4, property2) => "--" + tag(property2);
  const tagVars = (value) => `${value}`.replace(/--(tw-[\w-]+)\b/g, tagVar);
  const stringifyDeclaration = (property2, value, important) => {
    property2 = tagVars(property2);
    return Array.isArray(value) ? join(value.filter(Boolean).map((value2) => prefix(property2, tagVars(value2), important)), ";") : prefix(property2, tagVars(value), important);
  };
  let rules2;
  const stringify2 = (atRules, selector, presedence, css, important) => {
    if (Array.isArray(css)) {
      css.forEach((css2) => css2 && stringify2(atRules, selector, presedence, css2, important));
      return;
    }
    let declarations = "";
    let maxPropertyPresedence = 0;
    let numberOfDeclarations = 0;
    if (css["@apply"]) {
      css = merge(evalThunk(apply(css["@apply"]), context), {...css, "@apply": void 0}, context);
    }
    Object.keys(css).forEach((key) => {
      const value = evalThunk(css[key], context);
      if (isCSSProperty(key, value)) {
        if (value !== "" && key.length > 1) {
          const property2 = hyphenate(key);
          numberOfDeclarations += 1;
          maxPropertyPresedence = Math.max(maxPropertyPresedence, declarationPropertyPrecedence(property2));
          declarations = (declarations && declarations + ";") + stringifyDeclaration(property2, value, important);
        }
      } else if (value) {
        if (key == ":global") {
          key = "@global";
        }
        if (key[0] == "@") {
          if (key[1] == "g") {
            stringify2([], "", 0, value, important);
          } else if (key[1] == "f") {
            stringify2([], key, 0, value, important);
          } else if (key[1] == "k") {
            const currentSize = rules2.length;
            stringify2([], "", 0, value, important);
            const waypoints = rules2.splice(currentSize, rules2.length - currentSize);
            rules2.push({
              r: stringifyBlock(join(waypoints.map((p) => p.r), ""), key),
              p: waypoints.reduce((sum, p) => sum + p.p, 0)
            });
          } else if (key[1] == "i") {
            ;
            (Array.isArray(value) ? value : [value]).forEach((value2) => value2 && rules2.push({p: 0, r: `${key} ${value2};`}));
          } else {
            if (key[2] == "c") {
              key = buildMediaQuery(context.theme("screens", tail(key, 8).trim()));
            }
            stringify2([...atRules, key], selector, presedence | responsivePrecedence(key) | atRulePresedence(key), value, important);
          }
        } else {
          stringify2(atRules, selector ? selector.replace(/ *((?:\(.+?\)|\[.+?\]|[^,])+) *(,|$)/g, (_4, selectorPart, comma) => key.replace(/ *((?:\(.+?\)|\[.+?\]|[^,])+) *(,|$)/g, (_5, keyPart, comma2) => (includes(keyPart, "&") ? keyPart.replace(/&/g, selectorPart) : (selectorPart && selectorPart + " ") + keyPart) + comma2) + comma) : key, presedence, value, important);
        }
      }
    });
    if (numberOfDeclarations) {
      rules2.push({
        r: atRules.reduceRight(stringifyBlock, stringifyBlock(declarations, selector)),
        p: presedence * (1 << 8) + ((Math.max(0, 15 - numberOfDeclarations) & 15) << 4 | (maxPropertyPresedence || 15) & 15)
      });
    }
  };
  const variantPresedence = makeVariantPresedenceCalculator(theme2, variants);
  return (css, className, rule, layer = 0) => {
    layer <<= 28;
    rules2 = [];
    stringify2([], className ? "." + twind_escape(className) : "", rule ? rule.v.reduceRight(variantPresedence, layer) : layer, css, rule && rule.i);
    return rules2;
  };
};

// src/twind/inject.ts
var inject = (sheet, mode2, init, context) => {
  let sortedPrecedences;
  init((value = []) => sortedPrecedences = value);
  let insertedRules;
  init((value = new Set()) => insertedRules = value);
  return ({r: css, p: presedence}) => {
    if (!insertedRules.has(css)) {
      insertedRules.add(css);
      const index = sortedInsertionIndex(sortedPrecedences, presedence);
      try {
        sheet.insert(css, index);
        sortedPrecedences.splice(index, 0, presedence);
      } catch (error) {
        if (!/:-[mwo]/.test(css)) {
          mode2.report({id: "INJECT_CSS_ERROR", css, error}, context);
        }
      }
    }
  };
};

// src/twind/configure.ts
var sanitize = (value, defaultValue, disabled, enabled = defaultValue) => value === false ? disabled : value === true ? enabled : value || defaultValue;
var loadMode = (mode2) => (typeof mode2 == "string" ? {t: strict, a: warn, i: silent}[mode2[1]] : mode2) || warn;
var COMPONENT_PROPS = {_: {value: "", writable: true}};
var configure = (config = {}) => {
  const theme2 = makeThemeResolver(config.theme);
  const mode2 = loadMode(config.mode);
  const hash = sanitize(config.hash, false, false, cyrb32);
  const important = config.important;
  let activeRule = {v: []};
  let translateDepth = 0;
  const lastTranslations = [];
  const context = {
    tw: (...tokens) => process(tokens),
    theme: (section, key, defaultValue) => {
      var _a;
      const value = (_a = theme2(section, key, defaultValue)) != null ? _a : mode2.unknown(section, key == null || Array.isArray(key) ? key : key.split("."), defaultValue != null, context);
      return activeRule.n && value && includes("rg", (typeof value)[5]) ? `calc(${value} * -1)` : value;
    },
    tag: (value) => hash ? hash(value) : value,
    css: (rules2) => {
      translateDepth++;
      const lastTranslationsIndex = lastTranslations.length;
      try {
        ;
        (typeof rules2 == "string" ? parse([rules2]) : rules2).forEach(convert);
        const css = Object.create(null, COMPONENT_PROPS);
        for (let index = lastTranslationsIndex; index < lastTranslations.length; index++) {
          const translation = lastTranslations[index];
          if (translation) {
            switch (typeof translation) {
              case "object":
                merge(css, translation, context);
                break;
              case "string":
                css._ += (css._ && " ") + translation;
            }
          }
        }
        return css;
      } finally {
        lastTranslations.length = lastTranslationsIndex;
        translateDepth--;
      }
    }
  };
  const translate2 = translate({...corePlugins, ...config.plugins}, context);
  const doTranslate = (rule) => {
    const parentRule = activeRule;
    activeRule = rule;
    try {
      return evalThunk(translate2(rule), context);
    } finally {
      activeRule = parentRule;
    }
  };
  const variants = {...coreVariants, ...config.variants};
  const decorate2 = decorate(config.darkMode || "media", variants, context);
  const serialize2 = serialize(sanitize(config.prefix, autoprefix, noprefix), variants, context);
  const sheet = config.sheet || (typeof window == "undefined" ? voidSheet() : cssomSheet(config));
  const {init = (callback) => callback()} = sheet;
  const inject2 = inject(sheet, mode2, init, context);
  let idToClassName;
  init((value = new Map()) => idToClassName = value);
  const inlineDirectiveName = new WeakMap();
  const evaluateFunctions = (key, value) => key == "_" ? void 0 : typeof value == "function" ? JSON.stringify(evalThunk(value, context), evaluateFunctions) : value;
  const convert = (rule) => {
    if (!translateDepth && activeRule.v.length) {
      rule = {...rule, v: [...activeRule.v, ...rule.v], $: ""};
    }
    if (!rule.$) {
      rule.$ = stringifyRule(rule, inlineDirectiveName.get(rule.d));
    }
    let className = translateDepth ? null : idToClassName.get(rule.$);
    if (className == null) {
      let translation = doTranslate(rule);
      if (!rule.$) {
        rule.$ = cyrb32(JSON.stringify(translation, evaluateFunctions));
        inlineDirectiveName.set(rule.d, rule.$);
        rule.$ = stringifyRule(rule, rule.$);
      }
      if (translation && typeof translation == "object") {
        rule.v = rule.v.map(prepareVariantSelector);
        if (important)
          rule.i = important;
        translation = decorate2(translation, rule);
        if (translateDepth) {
          lastTranslations.push(translation);
        } else {
          const layer = typeof rule.d == "function" ? typeof translation._ == "string" ? 1 : 3 : 2;
          className = hash || typeof rule.d == "function" ? (hash || cyrb32)(layer + rule.$) : rule.$;
          serialize2(translation, className, rule, layer).forEach(inject2);
          if (translation._) {
            className += " " + translation._;
          }
        }
      } else {
        if (typeof translation == "string") {
          className = translation;
        } else {
          className = rule.$;
          mode2.report({id: "UNKNOWN_DIRECTIVE", rule: className}, context);
        }
        if (translateDepth && typeof rule.d !== "function") {
          lastTranslations.push(className);
        }
      }
      if (!translateDepth) {
        idToClassName.set(rule.$, className);
        ensureMaxSize(idToClassName, 3e4);
      }
    }
    return className;
  };
  const process = (tokens) => join(parse(tokens).map(convert).filter(Boolean), " ");
  const preflight = sanitize(config.preflight, identity, false);
  if (preflight) {
    const css = createPreflight(theme2);
    const styles = serialize2(typeof preflight == "function" ? evalThunk(preflight(css, context), context) || css : {...css, ...preflight});
    init((injected = (styles.forEach(inject2), true)) => injected);
  }
  return {
    init: () => mode2.report({id: "LATE_SETUP_CALL"}, context),
    process
  };
};

// src/twind/instance.ts
var create = (config) => {
  let process = (tokens) => {
    init();
    return process(tokens);
  };
  let init = (config2) => {
    ;
    ({process, init} = configure(config2));
  };
  if (config)
    init(config);
  let context;
  const fromContext = (key) => () => {
    if (!context) {
      process([
        (_4) => {
          context = _4;
          return "";
        }
      ]);
    }
    return context[key];
  };
  return {
    tw: Object.defineProperties((...tokens) => process(tokens), {
      theme: {
        get: fromContext("theme")
      }
    }),
    setup: (config2) => init(config2)
  };
};

// src/twind/default.ts
var {tw, setup} = /* @__PURE__ */ create();

// src/twind/expand.ts
var expandGroups = (classNames) => parse(classNames).map((rule) => stringifyRule(rule)).join(" ");

//# sourceMappingURL=twind.js.map


/***/ }),

/***/ 25380:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Db": function() { return /* binding */ useMutation; },
/* harmony export */   "aM": function() { return /* binding */ useQuery; },
/* harmony export */   "m8": function() { return /* binding */ useClient; },
/* harmony export */   "zt": function() { return /* binding */ b; }
/* harmony export */ });
/* unused harmony exports Consumer, Context, Mutation, Query, Subscription, useSubscription */
/* harmony import */ var _urql_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88423);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var wonka__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51044);










var y = {};

var x = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(y);

var b = x.Provider;

var g = x.Consumer;

x.displayName = "UrqlContext";

var useClient = () => {
  var e = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(x);
  if (e === y && "production" !== "production") { var r; }
  return e;
};

var q = {
  fetching: !1,
  stale: !1,
  error: void 0,
  data: void 0,
  extensions: void 0,
  operation: void 0
};

var computeNextState = (e, r) => {
  var t = {
    ...e,
    ...r,
    data: void 0 !== r.data || r.error ? r.data : e.data,
    fetching: !!r.fetching,
    stale: !!r.stale
  };
  return ((e, r) => {
    if ("object" != typeof e || "object" != typeof r) {
      return e !== r;
    }
    for (var t in e) {
      if (!(t in r)) {
        return !0;
      }
    }
    for (var n in r) {
      if (e[n] !== r[n]) {
        return !0;
      }
    }
    return !1;
  })(e, t) ? t : e;
};

var hasDepsChanged = (e, r) => {
  for (var t = 0, n = r.length; t < n; t++) {
    if (e[t] !== r[t]) {
      return !0;
    }
  }
  return !1;
};

var _ = react__WEBPACK_IMPORTED_MODULE_0__.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;

function deferDispatch(e, r) {
  if (false) {} else {
    e(r);
  }
}

function useMutation(r) {
  var t = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(!0);
  var n = useClient();
  var [s, l] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(q);
  var p = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(((a, u) => {
    deferDispatch(l, {
      ...q,
      fetching: !0
    });
    return (0,wonka__WEBPACK_IMPORTED_MODULE_1__/* .toPromise */ .Vi)((0,wonka__WEBPACK_IMPORTED_MODULE_1__/* .take */ .qn)(1)((0,wonka__WEBPACK_IMPORTED_MODULE_1__/* .filter */ .hX)((e => !e.hasNext))((0,wonka__WEBPACK_IMPORTED_MODULE_1__/* .onPush */ .Mq)((e => {
      if (t.current) {
        deferDispatch(l, {
          fetching: !1,
          stale: e.stale,
          data: e.data,
          error: e.error,
          extensions: e.extensions,
          operation: e.operation
        });
      }
    }))(n.executeMutation((0,_urql_core__WEBPACK_IMPORTED_MODULE_2__.h)(r, a), u || {})))));
  }), [ n, r, l ]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)((() => {
    t.current = !0;
    return () => {
      t.current = !1;
    };
  }), []);
  return [ s, p ];
}

function useRequest(r, t) {
  var n = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(void 0);
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)((() => {
    var a = (0,_urql_core__WEBPACK_IMPORTED_MODULE_2__.h)(r, t);
    if (void 0 !== n.current && n.current.key === a.key) {
      return n.current;
    } else {
      n.current = a;
      return a;
    }
  }), [ r, t ]);
}

var getCacheForClient = e => {
  if (!e._react) {
    var r = new Set;
    var t = new Map;
    if (e.operations$) {
      (0,wonka__WEBPACK_IMPORTED_MODULE_1__/* .subscribe */ .Ld)((e => {
        if ("teardown" === e.kind && r.has(e.key)) {
          r.delete(e.key);
          t.delete(e.key);
        }
      }))(e.operations$);
    }
    e._react = {
      get: e => t.get(e),
      set(e, n) {
        r.delete(e);
        t.set(e, n);
      },
      dispose(e) {
        r.add(e);
      }
    };
  }
  return e._react;
};

var isSuspense = (e, r) => e.suspense && (!r || !1 !== r.suspense);

function useQuery(e) {
  var r = useClient();
  var t = getCacheForClient(r);
  var n = isSuspense(r, e.context);
  var a = useRequest(e.query, e.variables);
  var c = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)((() => {
    if (e.pause) {
      return null;
    }
    var u = r.executeQuery(a, {
      requestPolicy: e.requestPolicy,
      ...e.context
    });
    return n ? (0,wonka__WEBPACK_IMPORTED_MODULE_1__/* .onPush */ .Mq)((e => {
      t.set(a.key, e);
    }))(u) : u;
  }), [ t, r, a, n, e.pause, e.requestPolicy, e.context ]);
  var v = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(((e, r) => {
    if (!e) {
      return {
        fetching: !1
      };
    }
    var n = t.get(a.key);
    if (!n) {
      var u;
      var i = (0,wonka__WEBPACK_IMPORTED_MODULE_1__/* .subscribe */ .Ld)((e => {
        n = e;
        if (u) {
          u(n);
        }
      }))((0,wonka__WEBPACK_IMPORTED_MODULE_1__/* .takeWhile */ .oE)((() => r && !u || !n))(e));
      if (null == n && r) {
        var o = new Promise((e => {
          u = e;
        }));
        t.set(a.key, o);
        throw o;
      } else {
        i.unsubscribe();
      }
    } else if (r && null != n && "then" in n) {
      throw n;
    }
    return n || {
      fetching: !0
    };
  }), [ t, a ]);
  var f = [ r, a, e.requestPolicy, e.context, e.pause ];
  var [y, x] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)((() => [ c, computeNextState(q, v(c, n)), f ]));
  var b = y[1];
  if (c !== y[0] && hasDepsChanged(y[2], f)) {
    x([ c, b = computeNextState(y[1], v(c, n)), f ]);
  }
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)((() => {
    var e = y[0];
    var r = y[2][1];
    var n = !1;
    var updateResult = e => {
      n = !0;
      deferDispatch(x, (r => {
        var t = computeNextState(r[1], e);
        return r[1] !== t ? [ r[0], t, r[2] ] : r;
      }));
    };
    if (e) {
      var a = (0,wonka__WEBPACK_IMPORTED_MODULE_1__/* .subscribe */ .Ld)(updateResult)((0,wonka__WEBPACK_IMPORTED_MODULE_1__/* .onEnd */ .ok)((() => {
        updateResult({
          fetching: !1
        });
      }))(e));
      if (!n) {
        updateResult({
          fetching: !0
        });
      }
      return () => {
        t.dispose(r.key);
        a.unsubscribe();
      };
    } else {
      updateResult({
        fetching: !1
      });
    }
  }), [ t, y[0], y[2][1] ]);
  var g = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((u => {
    var i = {
      requestPolicy: e.requestPolicy,
      ...e.context,
      ...u
    };
    deferDispatch(x, (e => [ n ? (0,wonka__WEBPACK_IMPORTED_MODULE_1__/* .onPush */ .Mq)((e => {
      t.set(a.key, e);
    }))(r.executeQuery(a, i)) : r.executeQuery(a, i), e[1], f ]));
  }), [ r, t, a, n, v, e.requestPolicy, e.context ]);
  return [ b, g ];
}

function useSubscription(e, r) {
  var t = useClient();
  var n = useRequest(e.query, e.variables);
  var c = a(r);
  c.current = r;
  var v = s((() => !e.pause ? t.executeSubscription(n, e.context) : null), [ t, n, e.pause, e.context ]);
  var f = [ t, n, e.context, e.pause ];
  var [d, p] = u((() => [ v, {
    ...q,
    fetching: !!v
  }, f ]));
  var y = d[1];
  if (v !== d[0] && hasDepsChanged(d[2], f)) {
    p([ v, y = computeNextState(d[1], {
      fetching: !!v
    }), f ]);
  }
  o((() => {
    var updateResult = e => {
      deferDispatch(p, (r => {
        var t = computeNextState(r[1], e);
        if (r[1] === t) {
          return r;
        }
        if (c.current && r[1].data !== t.data) {
          t.data = c.current(r[1].data, t.data);
        }
        return [ r[0], t, r[2] ];
      }));
    };
    if (d[0]) {
      return l(updateResult)(h((() => {
        updateResult({
          fetching: !!v
        });
      }))(d[0])).unsubscribe;
    } else {
      updateResult({
        fetching: !1
      });
    }
  }), [ d[0] ]);
  var x = i((r => {
    var a = t.executeSubscription(n, {
      ...e.context,
      ...r
    });
    deferDispatch(p, (e => [ a, e[1], f ]));
  }), [ t, e.context, n ]);
  return [ y, x ];
}

function Mutation(e) {
  var r = useMutation(e.query);
  return e.children({
    ...r[0],
    executeMutation: r[1]
  });
}

function Query(e) {
  var r = useQuery(e);
  return e.children({
    ...r[0],
    executeQuery: r[1]
  });
}

function Subscription(e) {
  var r = useSubscription(e, e.handler);
  return e.children({
    ...r[0],
    executeSubscription: r[1]
  });
}


//# sourceMappingURL=urql.es.js.map


/***/ }),

/***/ 94047:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var e=__webpack_require__(27378);function h(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var k="function"===typeof Object.is?Object.is:h,l=e.useState,m=e.useEffect,n=e.useLayoutEffect,p=e.useDebugValue;function q(a,b){var d=b(),f=l({inst:{value:d,getSnapshot:b}}),c=f[0].inst,g=f[1];n(function(){c.value=d;c.getSnapshot=b;r(c)&&g({inst:c})},[a,d,b]);m(function(){r(c)&&g({inst:c});return a(function(){r(c)&&g({inst:c})})},[a]);p(d);return d}
function r(a){var b=a.getSnapshot;a=a.value;try{var d=b();return!k(a,d)}catch(f){return!0}}function t(a,b){return b()}var u="undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement?t:q;exports.useSyncExternalStore=void 0!==e.useSyncExternalStore?e.useSyncExternalStore:u;


/***/ }),

/***/ 92693:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var h=__webpack_require__(27378),n=__webpack_require__(70644);function p(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var q="function"===typeof Object.is?Object.is:p,r=n.useSyncExternalStore,t=h.useRef,u=h.useEffect,v=h.useMemo,w=h.useDebugValue;
exports.useSyncExternalStoreWithSelector=function(a,b,e,l,g){var c=t(null);if(null===c.current){var f={hasValue:!1,value:null};c.current=f}else f=c.current;c=v(function(){function a(a){if(!c){c=!0;d=a;a=l(a);if(void 0!==g&&f.hasValue){var b=f.value;if(g(b,a))return k=b}return k=a}b=k;if(q(d,a))return b;var e=l(a);if(void 0!==g&&g(b,e))return b;d=a;return k=e}var c=!1,d,k,m=void 0===e?null:e;return[function(){return a(b())},null===m?void 0:function(){return a(m())}]},[b,e,l,g]);var d=r(a,c[0],c[1]);
u(function(){f.hasValue=!0;f.value=d},[d]);w(d);return d};


/***/ }),

/***/ 70644:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(94047);
} else {}


/***/ }),

/***/ 60626:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(92693);
} else {}


/***/ }),

/***/ 35141:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var undefined;

var $SyntaxError = SyntaxError;
var $Function = Function;
var $TypeError = TypeError;

// eslint-disable-next-line consistent-return
var getEvalledConstructor = function (expressionSyntax) {
	try {
		return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
	} catch (e) {}
};

var $gOPD = Object.getOwnPropertyDescriptor;
if ($gOPD) {
	try {
		$gOPD({}, '');
	} catch (e) {
		$gOPD = null; // this is IE 8, which has a broken gOPD
	}
}

var throwTypeError = function () {
	throw new $TypeError();
};
var ThrowTypeError = $gOPD
	? (function () {
		try {
			// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
			arguments.callee; // IE 8 does not throw here
			return throwTypeError;
		} catch (calleeThrows) {
			try {
				// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
				return $gOPD(arguments, 'callee').get;
			} catch (gOPDthrows) {
				return throwTypeError;
			}
		}
	}())
	: throwTypeError;

var hasSymbols = __webpack_require__(40679)();

var getProto = Object.getPrototypeOf || function (x) { return x.__proto__; }; // eslint-disable-line no-proto

var needsEval = {};

var TypedArray = typeof Uint8Array === 'undefined' ? undefined : getProto(Uint8Array);

var INTRINSICS = {
	'%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
	'%Array%': Array,
	'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
	'%ArrayIteratorPrototype%': hasSymbols ? getProto([][Symbol.iterator]()) : undefined,
	'%AsyncFromSyncIteratorPrototype%': undefined,
	'%AsyncFunction%': needsEval,
	'%AsyncGenerator%': needsEval,
	'%AsyncGeneratorFunction%': needsEval,
	'%AsyncIteratorPrototype%': needsEval,
	'%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
	'%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
	'%Boolean%': Boolean,
	'%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
	'%Date%': Date,
	'%decodeURI%': decodeURI,
	'%decodeURIComponent%': decodeURIComponent,
	'%encodeURI%': encodeURI,
	'%encodeURIComponent%': encodeURIComponent,
	'%Error%': Error,
	'%eval%': eval, // eslint-disable-line no-eval
	'%EvalError%': EvalError,
	'%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
	'%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
	'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
	'%Function%': $Function,
	'%GeneratorFunction%': needsEval,
	'%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
	'%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
	'%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
	'%isFinite%': isFinite,
	'%isNaN%': isNaN,
	'%IteratorPrototype%': hasSymbols ? getProto(getProto([][Symbol.iterator]())) : undefined,
	'%JSON%': typeof JSON === 'object' ? JSON : undefined,
	'%Map%': typeof Map === 'undefined' ? undefined : Map,
	'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols ? undefined : getProto(new Map()[Symbol.iterator]()),
	'%Math%': Math,
	'%Number%': Number,
	'%Object%': Object,
	'%parseFloat%': parseFloat,
	'%parseInt%': parseInt,
	'%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
	'%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
	'%RangeError%': RangeError,
	'%ReferenceError%': ReferenceError,
	'%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
	'%RegExp%': RegExp,
	'%Set%': typeof Set === 'undefined' ? undefined : Set,
	'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols ? undefined : getProto(new Set()[Symbol.iterator]()),
	'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
	'%String%': String,
	'%StringIteratorPrototype%': hasSymbols ? getProto(''[Symbol.iterator]()) : undefined,
	'%Symbol%': hasSymbols ? Symbol : undefined,
	'%SyntaxError%': $SyntaxError,
	'%ThrowTypeError%': ThrowTypeError,
	'%TypedArray%': TypedArray,
	'%TypeError%': $TypeError,
	'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
	'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
	'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
	'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
	'%URIError%': URIError,
	'%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
	'%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
	'%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet
};

var doEval = function doEval(name) {
	var value;
	if (name === '%AsyncFunction%') {
		value = getEvalledConstructor('async function () {}');
	} else if (name === '%GeneratorFunction%') {
		value = getEvalledConstructor('function* () {}');
	} else if (name === '%AsyncGeneratorFunction%') {
		value = getEvalledConstructor('async function* () {}');
	} else if (name === '%AsyncGenerator%') {
		var fn = doEval('%AsyncGeneratorFunction%');
		if (fn) {
			value = fn.prototype;
		}
	} else if (name === '%AsyncIteratorPrototype%') {
		var gen = doEval('%AsyncGenerator%');
		if (gen) {
			value = getProto(gen.prototype);
		}
	}

	INTRINSICS[name] = value;

	return value;
};

var LEGACY_ALIASES = {
	'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
	'%ArrayPrototype%': ['Array', 'prototype'],
	'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
	'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
	'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
	'%ArrayProto_values%': ['Array', 'prototype', 'values'],
	'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
	'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
	'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
	'%BooleanPrototype%': ['Boolean', 'prototype'],
	'%DataViewPrototype%': ['DataView', 'prototype'],
	'%DatePrototype%': ['Date', 'prototype'],
	'%ErrorPrototype%': ['Error', 'prototype'],
	'%EvalErrorPrototype%': ['EvalError', 'prototype'],
	'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
	'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
	'%FunctionPrototype%': ['Function', 'prototype'],
	'%Generator%': ['GeneratorFunction', 'prototype'],
	'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
	'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
	'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
	'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
	'%JSONParse%': ['JSON', 'parse'],
	'%JSONStringify%': ['JSON', 'stringify'],
	'%MapPrototype%': ['Map', 'prototype'],
	'%NumberPrototype%': ['Number', 'prototype'],
	'%ObjectPrototype%': ['Object', 'prototype'],
	'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
	'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
	'%PromisePrototype%': ['Promise', 'prototype'],
	'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
	'%Promise_all%': ['Promise', 'all'],
	'%Promise_reject%': ['Promise', 'reject'],
	'%Promise_resolve%': ['Promise', 'resolve'],
	'%RangeErrorPrototype%': ['RangeError', 'prototype'],
	'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
	'%RegExpPrototype%': ['RegExp', 'prototype'],
	'%SetPrototype%': ['Set', 'prototype'],
	'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
	'%StringPrototype%': ['String', 'prototype'],
	'%SymbolPrototype%': ['Symbol', 'prototype'],
	'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
	'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
	'%TypeErrorPrototype%': ['TypeError', 'prototype'],
	'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
	'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
	'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
	'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
	'%URIErrorPrototype%': ['URIError', 'prototype'],
	'%WeakMapPrototype%': ['WeakMap', 'prototype'],
	'%WeakSetPrototype%': ['WeakSet', 'prototype']
};

var bind = __webpack_require__(20132);
var hasOwn = __webpack_require__(77492);
var $concat = bind.call(Function.call, Array.prototype.concat);
var $spliceApply = bind.call(Function.apply, Array.prototype.splice);
var $replace = bind.call(Function.call, String.prototype.replace);
var $strSlice = bind.call(Function.call, String.prototype.slice);
var $exec = bind.call(Function.call, RegExp.prototype.exec);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath = function stringToPath(string) {
	var first = $strSlice(string, 0, 1);
	var last = $strSlice(string, -1);
	if (first === '%' && last !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
	} else if (last === '%' && first !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
	}
	var result = [];
	$replace(string, rePropName, function (match, number, quote, subString) {
		result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
	});
	return result;
};
/* end adaptation */

var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
	var intrinsicName = name;
	var alias;
	if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
		alias = LEGACY_ALIASES[intrinsicName];
		intrinsicName = '%' + alias[0] + '%';
	}

	if (hasOwn(INTRINSICS, intrinsicName)) {
		var value = INTRINSICS[intrinsicName];
		if (value === needsEval) {
			value = doEval(intrinsicName);
		}
		if (typeof value === 'undefined' && !allowMissing) {
			throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
		}

		return {
			alias: alias,
			name: intrinsicName,
			value: value
		};
	}

	throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
};

module.exports = function GetIntrinsic(name, allowMissing) {
	if (typeof name !== 'string' || name.length === 0) {
		throw new $TypeError('intrinsic name must be a non-empty string');
	}
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new $TypeError('"allowMissing" argument must be a boolean');
	}

	if ($exec(/^%?[^%]*%?$/g, name) === null) {
		throw new $SyntaxError('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
	}
	var parts = stringToPath(name);
	var intrinsicBaseName = parts.length > 0 ? parts[0] : '';

	var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
	var intrinsicRealName = intrinsic.name;
	var value = intrinsic.value;
	var skipFurtherCaching = false;

	var alias = intrinsic.alias;
	if (alias) {
		intrinsicBaseName = alias[0];
		$spliceApply(parts, $concat([0, 1], alias));
	}

	for (var i = 1, isOwn = true; i < parts.length; i += 1) {
		var part = parts[i];
		var first = $strSlice(part, 0, 1);
		var last = $strSlice(part, -1);
		if (
			(
				(first === '"' || first === "'" || first === '`')
				|| (last === '"' || last === "'" || last === '`')
			)
			&& first !== last
		) {
			throw new $SyntaxError('property names with quotes must have matching quotes');
		}
		if (part === 'constructor' || !isOwn) {
			skipFurtherCaching = true;
		}

		intrinsicBaseName += '.' + part;
		intrinsicRealName = '%' + intrinsicBaseName + '%';

		if (hasOwn(INTRINSICS, intrinsicRealName)) {
			value = INTRINSICS[intrinsicRealName];
		} else if (value != null) {
			if (!(part in value)) {
				if (!allowMissing) {
					throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
				}
				return void undefined;
			}
			if ($gOPD && (i + 1) >= parts.length) {
				var desc = $gOPD(value, part);
				isOwn = !!desc;

				// By convention, when a data property is converted to an accessor
				// property to emulate a data property that does not suffer from
				// the override mistake, that accessor's getter is marked with
				// an `originalValue` property. Here, when we detect this, we
				// uphold the illusion by pretending to see that original data
				// property, i.e., returning the value rather than the getter
				// itself.
				if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
					value = desc.get;
				} else {
					value = value[part];
				}
			} else {
				isOwn = hasOwn(value, part);
				value = value[part];
			}

			if (isOwn && !skipFurtherCaching) {
				INTRINSICS[intrinsicRealName] = value;
			}
		}
	}
	return value;
};


/***/ }),

/***/ 23452:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var forEach = __webpack_require__(55278);
var availableTypedArrays = __webpack_require__(40973);
var callBound = __webpack_require__(12737);

var $toString = callBound('Object.prototype.toString');
var hasToStringTag = __webpack_require__(10698)();

var g = typeof globalThis === 'undefined' ? __webpack_require__.g : globalThis;
var typedArrays = availableTypedArrays();

var $indexOf = callBound('Array.prototype.indexOf', true) || function indexOf(array, value) {
	for (var i = 0; i < array.length; i += 1) {
		if (array[i] === value) {
			return i;
		}
	}
	return -1;
};
var $slice = callBound('String.prototype.slice');
var toStrTags = {};
var gOPD = __webpack_require__(69425);
var getPrototypeOf = Object.getPrototypeOf; // require('getprototypeof');
if (hasToStringTag && gOPD && getPrototypeOf) {
	forEach(typedArrays, function (typedArray) {
		var arr = new g[typedArray]();
		if (Symbol.toStringTag in arr) {
			var proto = getPrototypeOf(arr);
			var descriptor = gOPD(proto, Symbol.toStringTag);
			if (!descriptor) {
				var superProto = getPrototypeOf(proto);
				descriptor = gOPD(superProto, Symbol.toStringTag);
			}
			toStrTags[typedArray] = descriptor.get;
		}
	});
}

var tryTypedArrays = function tryAllTypedArrays(value) {
	var anyTrue = false;
	forEach(toStrTags, function (getter, typedArray) {
		if (!anyTrue) {
			try {
				anyTrue = getter.call(value) === typedArray;
			} catch (e) { /**/ }
		}
	});
	return anyTrue;
};

module.exports = function isTypedArray(value) {
	if (!value || typeof value !== 'object') { return false; }
	if (!hasToStringTag || !(Symbol.toStringTag in value)) {
		var tag = $slice($toString(value), 8, -1);
		return $indexOf(typedArrays, tag) > -1;
	}
	if (!gOPD) { return false; }
	return tryTypedArrays(value);
};


/***/ }),

/***/ 44634:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var forEach = __webpack_require__(55278);
var availableTypedArrays = __webpack_require__(40973);
var callBound = __webpack_require__(12737);

var $toString = callBound('Object.prototype.toString');
var hasToStringTag = __webpack_require__(10698)();

var g = typeof globalThis === 'undefined' ? __webpack_require__.g : globalThis;
var typedArrays = availableTypedArrays();

var $slice = callBound('String.prototype.slice');
var toStrTags = {};
var gOPD = __webpack_require__(69425);
var getPrototypeOf = Object.getPrototypeOf; // require('getprototypeof');
if (hasToStringTag && gOPD && getPrototypeOf) {
	forEach(typedArrays, function (typedArray) {
		if (typeof g[typedArray] === 'function') {
			var arr = new g[typedArray]();
			if (Symbol.toStringTag in arr) {
				var proto = getPrototypeOf(arr);
				var descriptor = gOPD(proto, Symbol.toStringTag);
				if (!descriptor) {
					var superProto = getPrototypeOf(proto);
					descriptor = gOPD(superProto, Symbol.toStringTag);
				}
				toStrTags[typedArray] = descriptor.get;
			}
		}
	});
}

var tryTypedArrays = function tryAllTypedArrays(value) {
	var foundName = false;
	forEach(toStrTags, function (getter, typedArray) {
		if (!foundName) {
			try {
				var name = getter.call(value);
				if (name === typedArray) {
					foundName = name;
				}
			} catch (e) {}
		}
	});
	return foundName;
};

var isTypedArray = __webpack_require__(23452);

module.exports = function whichTypedArray(value) {
	if (!isTypedArray(value)) { return false; }
	if (!hasToStringTag || !(Symbol.toStringTag in value)) { return $slice($toString(value), 8, -1); }
	return tryTypedArrays(value);
};


/***/ }),

/***/ 56579:
/***/ (function(module) {

module.exports = function isBuffer(arg) {
  return arg && typeof arg === 'object'
    && typeof arg.copy === 'function'
    && typeof arg.fill === 'function'
    && typeof arg.readUInt8 === 'function';
}

/***/ }),

/***/ 7673:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
// Currently in sync with Node.js lib/internal/util/types.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9



var isArgumentsObject = __webpack_require__(47740);
var isGeneratorFunction = __webpack_require__(18265);
var whichTypedArray = __webpack_require__(44634);
var isTypedArray = __webpack_require__(23452);

function uncurryThis(f) {
  return f.call.bind(f);
}

var BigIntSupported = typeof BigInt !== 'undefined';
var SymbolSupported = typeof Symbol !== 'undefined';

var ObjectToString = uncurryThis(Object.prototype.toString);

var numberValue = uncurryThis(Number.prototype.valueOf);
var stringValue = uncurryThis(String.prototype.valueOf);
var booleanValue = uncurryThis(Boolean.prototype.valueOf);

if (BigIntSupported) {
  var bigIntValue = uncurryThis(BigInt.prototype.valueOf);
}

if (SymbolSupported) {
  var symbolValue = uncurryThis(Symbol.prototype.valueOf);
}

function checkBoxedPrimitive(value, prototypeValueOf) {
  if (typeof value !== 'object') {
    return false;
  }
  try {
    prototypeValueOf(value);
    return true;
  } catch(e) {
    return false;
  }
}

exports.isArgumentsObject = isArgumentsObject;
exports.isGeneratorFunction = isGeneratorFunction;
exports.isTypedArray = isTypedArray;

// Taken from here and modified for better browser support
// https://github.com/sindresorhus/p-is-promise/blob/cda35a513bda03f977ad5cde3a079d237e82d7ef/index.js
function isPromise(input) {
	return (
		(
			typeof Promise !== 'undefined' &&
			input instanceof Promise
		) ||
		(
			input !== null &&
			typeof input === 'object' &&
			typeof input.then === 'function' &&
			typeof input.catch === 'function'
		)
	);
}
exports.isPromise = isPromise;

function isArrayBufferView(value) {
  if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) {
    return ArrayBuffer.isView(value);
  }

  return (
    isTypedArray(value) ||
    isDataView(value)
  );
}
exports.isArrayBufferView = isArrayBufferView;


function isUint8Array(value) {
  return whichTypedArray(value) === 'Uint8Array';
}
exports.isUint8Array = isUint8Array;

function isUint8ClampedArray(value) {
  return whichTypedArray(value) === 'Uint8ClampedArray';
}
exports.isUint8ClampedArray = isUint8ClampedArray;

function isUint16Array(value) {
  return whichTypedArray(value) === 'Uint16Array';
}
exports.isUint16Array = isUint16Array;

function isUint32Array(value) {
  return whichTypedArray(value) === 'Uint32Array';
}
exports.isUint32Array = isUint32Array;

function isInt8Array(value) {
  return whichTypedArray(value) === 'Int8Array';
}
exports.isInt8Array = isInt8Array;

function isInt16Array(value) {
  return whichTypedArray(value) === 'Int16Array';
}
exports.isInt16Array = isInt16Array;

function isInt32Array(value) {
  return whichTypedArray(value) === 'Int32Array';
}
exports.isInt32Array = isInt32Array;

function isFloat32Array(value) {
  return whichTypedArray(value) === 'Float32Array';
}
exports.isFloat32Array = isFloat32Array;

function isFloat64Array(value) {
  return whichTypedArray(value) === 'Float64Array';
}
exports.isFloat64Array = isFloat64Array;

function isBigInt64Array(value) {
  return whichTypedArray(value) === 'BigInt64Array';
}
exports.isBigInt64Array = isBigInt64Array;

function isBigUint64Array(value) {
  return whichTypedArray(value) === 'BigUint64Array';
}
exports.isBigUint64Array = isBigUint64Array;

function isMapToString(value) {
  return ObjectToString(value) === '[object Map]';
}
isMapToString.working = (
  typeof Map !== 'undefined' &&
  isMapToString(new Map())
);

function isMap(value) {
  if (typeof Map === 'undefined') {
    return false;
  }

  return isMapToString.working
    ? isMapToString(value)
    : value instanceof Map;
}
exports.isMap = isMap;

function isSetToString(value) {
  return ObjectToString(value) === '[object Set]';
}
isSetToString.working = (
  typeof Set !== 'undefined' &&
  isSetToString(new Set())
);
function isSet(value) {
  if (typeof Set === 'undefined') {
    return false;
  }

  return isSetToString.working
    ? isSetToString(value)
    : value instanceof Set;
}
exports.isSet = isSet;

function isWeakMapToString(value) {
  return ObjectToString(value) === '[object WeakMap]';
}
isWeakMapToString.working = (
  typeof WeakMap !== 'undefined' &&
  isWeakMapToString(new WeakMap())
);
function isWeakMap(value) {
  if (typeof WeakMap === 'undefined') {
    return false;
  }

  return isWeakMapToString.working
    ? isWeakMapToString(value)
    : value instanceof WeakMap;
}
exports.isWeakMap = isWeakMap;

function isWeakSetToString(value) {
  return ObjectToString(value) === '[object WeakSet]';
}
isWeakSetToString.working = (
  typeof WeakSet !== 'undefined' &&
  isWeakSetToString(new WeakSet())
);
function isWeakSet(value) {
  return isWeakSetToString(value);
}
exports.isWeakSet = isWeakSet;

function isArrayBufferToString(value) {
  return ObjectToString(value) === '[object ArrayBuffer]';
}
isArrayBufferToString.working = (
  typeof ArrayBuffer !== 'undefined' &&
  isArrayBufferToString(new ArrayBuffer())
);
function isArrayBuffer(value) {
  if (typeof ArrayBuffer === 'undefined') {
    return false;
  }

  return isArrayBufferToString.working
    ? isArrayBufferToString(value)
    : value instanceof ArrayBuffer;
}
exports.isArrayBuffer = isArrayBuffer;

function isDataViewToString(value) {
  return ObjectToString(value) === '[object DataView]';
}
isDataViewToString.working = (
  typeof ArrayBuffer !== 'undefined' &&
  typeof DataView !== 'undefined' &&
  isDataViewToString(new DataView(new ArrayBuffer(1), 0, 1))
);
function isDataView(value) {
  if (typeof DataView === 'undefined') {
    return false;
  }

  return isDataViewToString.working
    ? isDataViewToString(value)
    : value instanceof DataView;
}
exports.isDataView = isDataView;

// Store a copy of SharedArrayBuffer in case it's deleted elsewhere
var SharedArrayBufferCopy = typeof SharedArrayBuffer !== 'undefined' ? SharedArrayBuffer : undefined;
function isSharedArrayBufferToString(value) {
  return ObjectToString(value) === '[object SharedArrayBuffer]';
}
function isSharedArrayBuffer(value) {
  if (typeof SharedArrayBufferCopy === 'undefined') {
    return false;
  }

  if (typeof isSharedArrayBufferToString.working === 'undefined') {
    isSharedArrayBufferToString.working = isSharedArrayBufferToString(new SharedArrayBufferCopy());
  }

  return isSharedArrayBufferToString.working
    ? isSharedArrayBufferToString(value)
    : value instanceof SharedArrayBufferCopy;
}
exports.isSharedArrayBuffer = isSharedArrayBuffer;

function isAsyncFunction(value) {
  return ObjectToString(value) === '[object AsyncFunction]';
}
exports.isAsyncFunction = isAsyncFunction;

function isMapIterator(value) {
  return ObjectToString(value) === '[object Map Iterator]';
}
exports.isMapIterator = isMapIterator;

function isSetIterator(value) {
  return ObjectToString(value) === '[object Set Iterator]';
}
exports.isSetIterator = isSetIterator;

function isGeneratorObject(value) {
  return ObjectToString(value) === '[object Generator]';
}
exports.isGeneratorObject = isGeneratorObject;

function isWebAssemblyCompiledModule(value) {
  return ObjectToString(value) === '[object WebAssembly.Module]';
}
exports.isWebAssemblyCompiledModule = isWebAssemblyCompiledModule;

function isNumberObject(value) {
  return checkBoxedPrimitive(value, numberValue);
}
exports.isNumberObject = isNumberObject;

function isStringObject(value) {
  return checkBoxedPrimitive(value, stringValue);
}
exports.isStringObject = isStringObject;

function isBooleanObject(value) {
  return checkBoxedPrimitive(value, booleanValue);
}
exports.isBooleanObject = isBooleanObject;

function isBigIntObject(value) {
  return BigIntSupported && checkBoxedPrimitive(value, bigIntValue);
}
exports.isBigIntObject = isBigIntObject;

function isSymbolObject(value) {
  return SymbolSupported && checkBoxedPrimitive(value, symbolValue);
}
exports.isSymbolObject = isSymbolObject;

function isBoxedPrimitive(value) {
  return (
    isNumberObject(value) ||
    isStringObject(value) ||
    isBooleanObject(value) ||
    isBigIntObject(value) ||
    isSymbolObject(value)
  );
}
exports.isBoxedPrimitive = isBoxedPrimitive;

function isAnyArrayBuffer(value) {
  return typeof Uint8Array !== 'undefined' && (
    isArrayBuffer(value) ||
    isSharedArrayBuffer(value)
  );
}
exports.isAnyArrayBuffer = isAnyArrayBuffer;

['isProxy', 'isExternal', 'isModuleNamespaceObject'].forEach(function(method) {
  Object.defineProperty(exports, method, {
    enumerable: false,
    value: function() {
      throw new Error(method + ' is not supported in userland');
    }
  });
});


/***/ }),

/***/ 71323:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

/* provided dependency */ var process = __webpack_require__(27061);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors ||
  function getOwnPropertyDescriptors(obj) {
    var keys = Object.keys(obj);
    var descriptors = {};
    for (var i = 0; i < keys.length; i++) {
      descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
    }
    return descriptors;
  };

var formatRegExp = /%[sdj%]/g;
exports.format = function(f) {
  if (!isString(f)) {
    var objects = [];
    for (var i = 0; i < arguments.length; i++) {
      objects.push(inspect(arguments[i]));
    }
    return objects.join(' ');
  }

  var i = 1;
  var args = arguments;
  var len = args.length;
  var str = String(f).replace(formatRegExp, function(x) {
    if (x === '%%') return '%';
    if (i >= len) return x;
    switch (x) {
      case '%s': return String(args[i++]);
      case '%d': return Number(args[i++]);
      case '%j':
        try {
          return JSON.stringify(args[i++]);
        } catch (_) {
          return '[Circular]';
        }
      default:
        return x;
    }
  });
  for (var x = args[i]; i < len; x = args[++i]) {
    if (isNull(x) || !isObject(x)) {
      str += ' ' + x;
    } else {
      str += ' ' + inspect(x);
    }
  }
  return str;
};


// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
exports.deprecate = function(fn, msg) {
  if (typeof process !== 'undefined' && process.noDeprecation === true) {
    return fn;
  }

  // Allow for deprecating things in the process of starting up.
  if (typeof process === 'undefined') {
    return function() {
      return exports.deprecate(fn, msg).apply(this, arguments);
    };
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (process.throwDeprecation) {
        throw new Error(msg);
      } else if (process.traceDeprecation) {
        console.trace(msg);
      } else {
        console.error(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
};


var debugs = {};
var debugEnvRegex = /^$/;

if (process.env.NODE_DEBUG) {
  var debugEnv = process.env.NODE_DEBUG;
  debugEnv = debugEnv.replace(/[|\\{}()[\]^$+?.]/g, '\\$&')
    .replace(/\*/g, '.*')
    .replace(/,/g, '$|^')
    .toUpperCase();
  debugEnvRegex = new RegExp('^' + debugEnv + '$', 'i');
}
exports.debuglog = function(set) {
  set = set.toUpperCase();
  if (!debugs[set]) {
    if (debugEnvRegex.test(set)) {
      var pid = process.pid;
      debugs[set] = function() {
        var msg = exports.format.apply(exports, arguments);
        console.error('%s %d: %s', set, pid, msg);
      };
    } else {
      debugs[set] = function() {};
    }
  }
  return debugs[set];
};


/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */
/* legacy: obj, showHidden, depth, colors*/
function inspect(obj, opts) {
  // default options
  var ctx = {
    seen: [],
    stylize: stylizeNoColor
  };
  // legacy...
  if (arguments.length >= 3) ctx.depth = arguments[2];
  if (arguments.length >= 4) ctx.colors = arguments[3];
  if (isBoolean(opts)) {
    // legacy...
    ctx.showHidden = opts;
  } else if (opts) {
    // got an "options" object
    exports._extend(ctx, opts);
  }
  // set default options
  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
  if (isUndefined(ctx.depth)) ctx.depth = 2;
  if (isUndefined(ctx.colors)) ctx.colors = false;
  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
  if (ctx.colors) ctx.stylize = stylizeWithColor;
  return formatValue(ctx, obj, ctx.depth);
}
exports.inspect = inspect;


// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
inspect.colors = {
  'bold' : [1, 22],
  'italic' : [3, 23],
  'underline' : [4, 24],
  'inverse' : [7, 27],
  'white' : [37, 39],
  'grey' : [90, 39],
  'black' : [30, 39],
  'blue' : [34, 39],
  'cyan' : [36, 39],
  'green' : [32, 39],
  'magenta' : [35, 39],
  'red' : [31, 39],
  'yellow' : [33, 39]
};

// Don't use 'blue' not visible on cmd.exe
inspect.styles = {
  'special': 'cyan',
  'number': 'yellow',
  'boolean': 'yellow',
  'undefined': 'grey',
  'null': 'bold',
  'string': 'green',
  'date': 'magenta',
  // "name": intentionally not styling
  'regexp': 'red'
};


function stylizeWithColor(str, styleType) {
  var style = inspect.styles[styleType];

  if (style) {
    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
           '\u001b[' + inspect.colors[style][1] + 'm';
  } else {
    return str;
  }
}


function stylizeNoColor(str, styleType) {
  return str;
}


function arrayToHash(array) {
  var hash = {};

  array.forEach(function(val, idx) {
    hash[val] = true;
  });

  return hash;
}


function formatValue(ctx, value, recurseTimes) {
  // Provide a hook for user-specified inspect functions.
  // Check that value is an object with an inspect function on it
  if (ctx.customInspect &&
      value &&
      isFunction(value.inspect) &&
      // Filter out the util module, it's inspect function is special
      value.inspect !== exports.inspect &&
      // Also filter out any prototype objects using the circular check.
      !(value.constructor && value.constructor.prototype === value)) {
    var ret = value.inspect(recurseTimes, ctx);
    if (!isString(ret)) {
      ret = formatValue(ctx, ret, recurseTimes);
    }
    return ret;
  }

  // Primitive types cannot have properties
  var primitive = formatPrimitive(ctx, value);
  if (primitive) {
    return primitive;
  }

  // Look up the keys of the object.
  var keys = Object.keys(value);
  var visibleKeys = arrayToHash(keys);

  if (ctx.showHidden) {
    keys = Object.getOwnPropertyNames(value);
  }

  // IE doesn't make error fields non-enumerable
  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
  if (isError(value)
      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
    return formatError(value);
  }

  // Some type of object without properties can be shortcutted.
  if (keys.length === 0) {
    if (isFunction(value)) {
      var name = value.name ? ': ' + value.name : '';
      return ctx.stylize('[Function' + name + ']', 'special');
    }
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    }
    if (isDate(value)) {
      return ctx.stylize(Date.prototype.toString.call(value), 'date');
    }
    if (isError(value)) {
      return formatError(value);
    }
  }

  var base = '', array = false, braces = ['{', '}'];

  // Make Array say that they are Array
  if (isArray(value)) {
    array = true;
    braces = ['[', ']'];
  }

  // Make functions say that they are functions
  if (isFunction(value)) {
    var n = value.name ? ': ' + value.name : '';
    base = ' [Function' + n + ']';
  }

  // Make RegExps say that they are RegExps
  if (isRegExp(value)) {
    base = ' ' + RegExp.prototype.toString.call(value);
  }

  // Make dates with properties first say the date
  if (isDate(value)) {
    base = ' ' + Date.prototype.toUTCString.call(value);
  }

  // Make error with message first say the error
  if (isError(value)) {
    base = ' ' + formatError(value);
  }

  if (keys.length === 0 && (!array || value.length == 0)) {
    return braces[0] + base + braces[1];
  }

  if (recurseTimes < 0) {
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    } else {
      return ctx.stylize('[Object]', 'special');
    }
  }

  ctx.seen.push(value);

  var output;
  if (array) {
    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
  } else {
    output = keys.map(function(key) {
      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
  }

  ctx.seen.pop();

  return reduceToSingleString(output, base, braces);
}


function formatPrimitive(ctx, value) {
  if (isUndefined(value))
    return ctx.stylize('undefined', 'undefined');
  if (isString(value)) {
    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
                                             .replace(/'/g, "\\'")
                                             .replace(/\\"/g, '"') + '\'';
    return ctx.stylize(simple, 'string');
  }
  if (isNumber(value))
    return ctx.stylize('' + value, 'number');
  if (isBoolean(value))
    return ctx.stylize('' + value, 'boolean');
  // For some reason typeof null is "object", so special case here.
  if (isNull(value))
    return ctx.stylize('null', 'null');
}


function formatError(value) {
  return '[' + Error.prototype.toString.call(value) + ']';
}


function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
  var output = [];
  for (var i = 0, l = value.length; i < l; ++i) {
    if (hasOwnProperty(value, String(i))) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          String(i), true));
    } else {
      output.push('');
    }
  }
  keys.forEach(function(key) {
    if (!key.match(/^\d+$/)) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          key, true));
    }
  });
  return output;
}


function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
  var name, str, desc;
  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
  if (desc.get) {
    if (desc.set) {
      str = ctx.stylize('[Getter/Setter]', 'special');
    } else {
      str = ctx.stylize('[Getter]', 'special');
    }
  } else {
    if (desc.set) {
      str = ctx.stylize('[Setter]', 'special');
    }
  }
  if (!hasOwnProperty(visibleKeys, key)) {
    name = '[' + key + ']';
  }
  if (!str) {
    if (ctx.seen.indexOf(desc.value) < 0) {
      if (isNull(recurseTimes)) {
        str = formatValue(ctx, desc.value, null);
      } else {
        str = formatValue(ctx, desc.value, recurseTimes - 1);
      }
      if (str.indexOf('\n') > -1) {
        if (array) {
          str = str.split('\n').map(function(line) {
            return '  ' + line;
          }).join('\n').slice(2);
        } else {
          str = '\n' + str.split('\n').map(function(line) {
            return '   ' + line;
          }).join('\n');
        }
      }
    } else {
      str = ctx.stylize('[Circular]', 'special');
    }
  }
  if (isUndefined(name)) {
    if (array && key.match(/^\d+$/)) {
      return str;
    }
    name = JSON.stringify('' + key);
    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
      name = name.slice(1, -1);
      name = ctx.stylize(name, 'name');
    } else {
      name = name.replace(/'/g, "\\'")
                 .replace(/\\"/g, '"')
                 .replace(/(^"|"$)/g, "'");
      name = ctx.stylize(name, 'string');
    }
  }

  return name + ': ' + str;
}


function reduceToSingleString(output, base, braces) {
  var numLinesEst = 0;
  var length = output.reduce(function(prev, cur) {
    numLinesEst++;
    if (cur.indexOf('\n') >= 0) numLinesEst++;
    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
  }, 0);

  if (length > 60) {
    return braces[0] +
           (base === '' ? '' : base + '\n ') +
           ' ' +
           output.join(',\n  ') +
           ' ' +
           braces[1];
  }

  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}


// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
exports.types = __webpack_require__(7673);

function isArray(ar) {
  return Array.isArray(ar);
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return isObject(re) && objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;
exports.types.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return isObject(d) && objectToString(d) === '[object Date]';
}
exports.isDate = isDate;
exports.types.isDate = isDate;

function isError(e) {
  return isObject(e) &&
      (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;
exports.types.isNativeError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = __webpack_require__(56579);

function objectToString(o) {
  return Object.prototype.toString.call(o);
}


function pad(n) {
  return n < 10 ? '0' + n.toString(10) : n.toString(10);
}


var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
              'Oct', 'Nov', 'Dec'];

// 26 Feb 16:19:34
function timestamp() {
  var d = new Date();
  var time = [pad(d.getHours()),
              pad(d.getMinutes()),
              pad(d.getSeconds())].join(':');
  return [d.getDate(), months[d.getMonth()], time].join(' ');
}


// log is just a thin wrapper to console.log that prepends a timestamp
exports.log = function() {
  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
};


/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */
exports.inherits = __webpack_require__(70087);

exports._extend = function(origin, add) {
  // Don't do anything if add isn't an object
  if (!add || !isObject(add)) return origin;

  var keys = Object.keys(add);
  var i = keys.length;
  while (i--) {
    origin[keys[i]] = add[keys[i]];
  }
  return origin;
};

function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

var kCustomPromisifiedSymbol = typeof Symbol !== 'undefined' ? Symbol('util.promisify.custom') : undefined;

exports.promisify = function promisify(original) {
  if (typeof original !== 'function')
    throw new TypeError('The "original" argument must be of type Function');

  if (kCustomPromisifiedSymbol && original[kCustomPromisifiedSymbol]) {
    var fn = original[kCustomPromisifiedSymbol];
    if (typeof fn !== 'function') {
      throw new TypeError('The "util.promisify.custom" argument must be of type Function');
    }
    Object.defineProperty(fn, kCustomPromisifiedSymbol, {
      value: fn, enumerable: false, writable: false, configurable: true
    });
    return fn;
  }

  function fn() {
    var promiseResolve, promiseReject;
    var promise = new Promise(function (resolve, reject) {
      promiseResolve = resolve;
      promiseReject = reject;
    });

    var args = [];
    for (var i = 0; i < arguments.length; i++) {
      args.push(arguments[i]);
    }
    args.push(function (err, value) {
      if (err) {
        promiseReject(err);
      } else {
        promiseResolve(value);
      }
    });

    try {
      original.apply(this, args);
    } catch (err) {
      promiseReject(err);
    }

    return promise;
  }

  Object.setPrototypeOf(fn, Object.getPrototypeOf(original));

  if (kCustomPromisifiedSymbol) Object.defineProperty(fn, kCustomPromisifiedSymbol, {
    value: fn, enumerable: false, writable: false, configurable: true
  });
  return Object.defineProperties(
    fn,
    getOwnPropertyDescriptors(original)
  );
}

exports.promisify.custom = kCustomPromisifiedSymbol

function callbackifyOnRejected(reason, cb) {
  // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
  // Because `null` is a special error value in callbacks which means "no error
  // occurred", we error-wrap so the callback consumer can distinguish between
  // "the promise rejected with null" or "the promise fulfilled with undefined".
  if (!reason) {
    var newReason = new Error('Promise was rejected with a falsy value');
    newReason.reason = reason;
    reason = newReason;
  }
  return cb(reason);
}

function callbackify(original) {
  if (typeof original !== 'function') {
    throw new TypeError('The "original" argument must be of type Function');
  }

  // We DO NOT return the promise as it gives the user a false sense that
  // the promise is actually somehow related to the callback's execution
  // and that the callback throwing will reject the promise.
  function callbackified() {
    var args = [];
    for (var i = 0; i < arguments.length; i++) {
      args.push(arguments[i]);
    }

    var maybeCb = args.pop();
    if (typeof maybeCb !== 'function') {
      throw new TypeError('The last argument must be of type Function');
    }
    var self = this;
    var cb = function() {
      return maybeCb.apply(self, arguments);
    };
    // In true node style we process the callback on `nextTick` with all the
    // implications (stack, `uncaughtException`, `async_hooks`)
    original.apply(this, args)
      .then(function(ret) { process.nextTick(cb.bind(null, null, ret)) },
            function(rej) { process.nextTick(callbackifyOnRejected.bind(null, rej, cb)) });
  }

  Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
  Object.defineProperties(callbackified,
                          getOwnPropertyDescriptors(original));
  return callbackified;
}
exports.callbackify = callbackify;


/***/ }),

/***/ 30242:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var map = {
	"./": [
		48465,
		9,
		9771,
		6950,
		6971,
		5598,
		8465
	],
	"./countries": [
		25384,
		3,
		5384
	],
	"./countries.json": [
		25384,
		3,
		5384
	],
	"./de": [
		7758,
		9,
		7758
	],
	"./de.ts": [
		7758,
		9,
		7758
	],
	"./en": [
		39771,
		9,
		9771
	],
	"./en-AU": [
		10890,
		9,
		9771,
		890
	],
	"./en-AU.ts": [
		10890,
		9,
		9771,
		890
	],
	"./en-BG": [
		52307,
		9,
		9771,
		2307
	],
	"./en-BG.ts": [
		52307,
		9,
		9771,
		2307
	],
	"./en-CA": [
		19756,
		9,
		9771,
		9756
	],
	"./en-CA.ts": [
		19756,
		9,
		9771,
		9756
	],
	"./en-GB": [
		58075,
		9,
		9771,
		8075
	],
	"./en-GB.ts": [
		58075,
		9,
		9771,
		8075
	],
	"./en-IN": [
		2361,
		9,
		9771,
		2361
	],
	"./en-IN.ts": [
		2361,
		9,
		9771,
		2361
	],
	"./en-LT": [
		48040,
		9,
		9771,
		8040
	],
	"./en-LT.ts": [
		48040,
		9,
		9771,
		8040
	],
	"./en-US": [
		54923,
		9,
		9771,
		4923
	],
	"./en-US.ts": [
		54923,
		9,
		9771,
		4923
	],
	"./en-common-EU": [
		18349,
		9,
		9771,
		8349
	],
	"./en-common-EU.ts": [
		18349,
		9,
		9771,
		8349
	],
	"./en.ts": [
		39771,
		9,
		9771
	],
	"./es-US": [
		75598,
		9,
		5598
	],
	"./es-US.ts": [
		75598,
		9,
		5598
	],
	"./fr-CA": [
		36971,
		9,
		6971
	],
	"./fr-CA.ts": [
		36971,
		9,
		6971
	],
	"./index": [
		48465,
		9,
		9771,
		6950,
		6971,
		5598,
		8465
	],
	"./index.ts": [
		48465,
		9,
		9771,
		6950,
		6971,
		5598,
		8465
	],
	"./ja-JP": [
		66950,
		9,
		6950
	],
	"./ja-JP.ts": [
		66950,
		9,
		6950
	],
	"./localeType": [
		87706,
		9,
		7706
	],
	"./localeType.ts": [
		87706,
		9,
		7706
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 30242;
module.exports = webpackAsyncContext;

/***/ }),

/***/ 97524:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var map = {
	"./au/config": [
		9129,
		9129
	],
	"./bg/config": [
		58468,
		8468
	],
	"./ca/config": [
		48030,
		8030
	],
	"./common/config": [
		35333,
		5333
	],
	"./gb/config": [
		11924,
		1924,
		3108
	],
	"./in/config": [
		26345,
		6345
	],
	"./jp/config": [
		24878,
		4878,
		1526
	],
	"./lt/config": [
		42081,
		2081
	],
	"./us/config": [
		76801,
		6801
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 97524;
module.exports = webpackAsyncContext;

/***/ }),

/***/ 40973:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var possibleNames = [
	'BigInt64Array',
	'BigUint64Array',
	'Float32Array',
	'Float64Array',
	'Int16Array',
	'Int32Array',
	'Int8Array',
	'Uint16Array',
	'Uint32Array',
	'Uint8Array',
	'Uint8ClampedArray'
];

var g = typeof globalThis === 'undefined' ? __webpack_require__.g : globalThis;

module.exports = function availableTypedArrays() {
	var out = [];
	for (var i = 0; i < possibleNames.length; i++) {
		if (typeof g[possibleNames[i]] === 'function') {
			out[out.length] = possibleNames[i];
		}
	}
	return out;
};


/***/ }),

/***/ 69425:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(35141);

var $gOPD = GetIntrinsic('%Object.getOwnPropertyDescriptor%', true);
if ($gOPD) {
	try {
		$gOPD([], 'length');
	} catch (e) {
		// IE 8 has a broken gOPD
		$gOPD = null;
	}
}

module.exports = $gOPD;


/***/ }),

/***/ 7846:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Mq": function() { return /* binding */ valueFromASTUntyped; },
/* harmony export */   "Qc": function() { return /* binding */ parse; },
/* harmony export */   "S0": function() { return /* binding */ print; },
/* harmony export */   "__": function() { return /* binding */ GraphQLError; },
/* harmony export */   "hY": function() { return /* binding */ e; }
/* harmony export */ });
/* unused harmony exports BREAK, OperationTypeNode, parseType, parseValue, printBlockString, printString, valueFromTypeNode, visit */
var e = {
  NAME: "Name",
  DOCUMENT: "Document",
  OPERATION_DEFINITION: "OperationDefinition",
  VARIABLE_DEFINITION: "VariableDefinition",
  SELECTION_SET: "SelectionSet",
  FIELD: "Field",
  ARGUMENT: "Argument",
  FRAGMENT_SPREAD: "FragmentSpread",
  INLINE_FRAGMENT: "InlineFragment",
  FRAGMENT_DEFINITION: "FragmentDefinition",
  VARIABLE: "Variable",
  INT: "IntValue",
  FLOAT: "FloatValue",
  STRING: "StringValue",
  BOOLEAN: "BooleanValue",
  NULL: "NullValue",
  ENUM: "EnumValue",
  LIST: "ListValue",
  OBJECT: "ObjectValue",
  OBJECT_FIELD: "ObjectField",
  DIRECTIVE: "Directive",
  NAMED_TYPE: "NamedType",
  LIST_TYPE: "ListType",
  NON_NULL_TYPE: "NonNullType"
};

var r = {
  QUERY: "query",
  MUTATION: "mutation",
  SUBSCRIPTION: "subscription"
};

class GraphQLError extends Error {
  constructor(e, r, i, n, a, t, o) {
    super(e);
    this.name = "GraphQLError";
    this.message = e;
    if (a) {
      this.path = a;
    }
    if (r) {
      this.nodes = Array.isArray(r) ? r : [ r ];
    }
    if (i) {
      this.source = i;
    }
    if (n) {
      this.positions = n;
    }
    if (t) {
      this.originalError = t;
    }
    var l = o;
    if (!l && t) {
      var u = t.extensions;
      if (u && "object" == typeof u) {
        l = u;
      }
    }
    this.extensions = l || {};
  }
  toJSON() {
    return {
      ...this,
      message: this.message
    };
  }
  toString() {
    return this.message;
  }
  get [Symbol.toStringTag]() {
    return "GraphQLError";
  }
}

var i;

var n;

function error(e) {
  return new GraphQLError(`Syntax Error: Unexpected token at ${n} in ${e}`);
}

function advance(e) {
  e.lastIndex = n;
  if (e.test(i)) {
    return i.slice(n, n = e.lastIndex);
  }
}

var a = / +(?=[^\s])/y;

function blockString(e) {
  var r = e.split("\n");
  var i = "";
  var n = 0;
  var t = 0;
  var o = r.length - 1;
  for (var l = 0; l < r.length; l++) {
    a.lastIndex = 0;
    if (a.test(r[l])) {
      if (l && (!n || a.lastIndex < n)) {
        n = a.lastIndex;
      }
      t = t || l;
      o = l;
    }
  }
  for (var u = t; u <= o; u++) {
    if (u !== t) {
      i += "\n";
    }
    i += r[u].slice(n).replace(/\\"""/g, '"""');
  }
  return i;
}

function ignored() {
  for (var e = 0 | i.charCodeAt(n++); 9 === e || 10 === e || 13 === e || 32 === e || 35 === e || 44 === e || 65279 === e; e = 0 | i.charCodeAt(n++)) {
    if (35 === e) {
      while (10 !== (e = i.charCodeAt(n++)) && 13 !== e) {}
    }
  }
  n--;
}

var t = /[_\w][_\d\w]*/y;

function name() {
  var e;
  if (e = advance(t)) {
    return {
      kind: "Name",
      value: e
    };
  }
}

var o = /null|true|false/y;

var l = /\$[_\w][_\d\w]*/y;

var u = /-?\d+/y;

var v = /(?:\.\d+)?(?:[eE][+-]?\d+)?/y;

var d = /\\/g;

var s = /"""(?:[\s\S]+(?="""))?"""/y;

var c = /"(?:[^"\r\n]+)?"/y;

function value(e) {
  var r;
  var a;
  if (a = advance(o)) {
    r = "null" === a ? {
      kind: "NullValue"
    } : {
      kind: "BooleanValue",
      value: "true" === a
    };
  } else if (!e && (a = advance(l))) {
    r = {
      kind: "Variable",
      name: {
        kind: "Name",
        value: a.slice(1)
      }
    };
  } else if (a = advance(u)) {
    var f = a;
    if (a = advance(v)) {
      r = {
        kind: "FloatValue",
        value: f + a
      };
    } else {
      r = {
        kind: "IntValue",
        value: f
      };
    }
  } else if (a = advance(t)) {
    r = {
      kind: "EnumValue",
      value: a
    };
  } else if (a = advance(s)) {
    r = {
      kind: "StringValue",
      value: blockString(a.slice(3, -3)),
      block: !0
    };
  } else if (a = advance(c)) {
    r = {
      kind: "StringValue",
      value: d.test(a) ? JSON.parse(a) : a.slice(1, -1),
      block: !1
    };
  } else if (r = function list(e) {
    var r;
    if (91 === i.charCodeAt(n)) {
      n++;
      ignored();
      var a = [];
      while (r = value(e)) {
        a.push(r);
      }
      if (93 !== i.charCodeAt(n++)) {
        throw error("ListValue");
      }
      ignored();
      return {
        kind: "ListValue",
        values: a
      };
    }
  }(e) || function object(e) {
    if (123 === i.charCodeAt(n)) {
      n++;
      ignored();
      var r = [];
      var a;
      while (a = name()) {
        ignored();
        if (58 !== i.charCodeAt(n++)) {
          throw error("ObjectField");
        }
        ignored();
        var t = value(e);
        if (!t) {
          throw error("ObjectField");
        }
        r.push({
          kind: "ObjectField",
          name: a,
          value: t
        });
      }
      if (125 !== i.charCodeAt(n++)) {
        throw error("ObjectValue");
      }
      ignored();
      return {
        kind: "ObjectValue",
        fields: r
      };
    }
  }(e)) {
    return r;
  }
  ignored();
  return r;
}

function arguments_(e) {
  var r = [];
  ignored();
  if (40 === i.charCodeAt(n)) {
    n++;
    ignored();
    var a;
    while (a = name()) {
      ignored();
      if (58 !== i.charCodeAt(n++)) {
        throw error("Argument");
      }
      ignored();
      var t = value(e);
      if (!t) {
        throw error("Argument");
      }
      r.push({
        kind: "Argument",
        name: a,
        value: t
      });
    }
    if (!r.length || 41 !== i.charCodeAt(n++)) {
      throw error("Argument");
    }
    ignored();
  }
  return r;
}

function directives(e) {
  var r = [];
  ignored();
  while (64 === i.charCodeAt(n)) {
    n++;
    var a = name();
    if (!a) {
      throw error("Directive");
    }
    ignored();
    r.push({
      kind: "Directive",
      name: a,
      arguments: arguments_(e)
    });
  }
  return r;
}

function field() {
  var e = name();
  if (e) {
    ignored();
    var r;
    if (58 === i.charCodeAt(n)) {
      n++;
      ignored();
      r = e;
      if (!(e = name())) {
        throw error("Field");
      }
      ignored();
    }
    return {
      kind: "Field",
      alias: r,
      name: e,
      arguments: arguments_(!1),
      directives: directives(!1),
      selectionSet: selectionSet()
    };
  }
}

function type() {
  var e;
  ignored();
  if (91 === i.charCodeAt(n)) {
    n++;
    ignored();
    var r = type();
    if (!r || 93 !== i.charCodeAt(n++)) {
      throw error("ListType");
    }
    e = {
      kind: "ListType",
      type: r
    };
  } else if (e = name()) {
    e = {
      kind: "NamedType",
      name: e
    };
  } else {
    throw error("NamedType");
  }
  ignored();
  if (33 === i.charCodeAt(n)) {
    n++;
    ignored();
    return {
      kind: "NonNullType",
      type: e
    };
  } else {
    return e;
  }
}

var f = /on/y;

function typeCondition() {
  if (advance(f)) {
    ignored();
    var e = name();
    if (!e) {
      throw error("NamedType");
    }
    ignored();
    return {
      kind: "NamedType",
      name: e
    };
  }
}

var p = /\.\.\./y;

function fragmentSpread() {
  if (advance(p)) {
    ignored();
    var e = n;
    var r;
    if ((r = name()) && "on" !== r.value) {
      return {
        kind: "FragmentSpread",
        name: r,
        directives: directives(!1)
      };
    } else {
      n = e;
      var i = typeCondition();
      var a = directives(!1);
      var t = selectionSet();
      if (!t) {
        throw error("InlineFragment");
      }
      return {
        kind: "InlineFragment",
        typeCondition: i,
        directives: a,
        selectionSet: t
      };
    }
  }
}

function selectionSet() {
  var e;
  ignored();
  if (123 === i.charCodeAt(n)) {
    n++;
    ignored();
    var r = [];
    while (e = fragmentSpread() || field()) {
      r.push(e);
    }
    if (!r.length || 125 !== i.charCodeAt(n++)) {
      throw error("SelectionSet");
    }
    ignored();
    return {
      kind: "SelectionSet",
      selections: r
    };
  }
}

var m = /fragment/y;

function fragmentDefinition() {
  if (advance(m)) {
    ignored();
    var e = name();
    if (!e) {
      throw error("FragmentDefinition");
    }
    ignored();
    var r = typeCondition();
    if (!r) {
      throw error("FragmentDefinition");
    }
    var i = directives(!1);
    var n = selectionSet();
    if (!n) {
      throw error("FragmentDefinition");
    }
    return {
      kind: "FragmentDefinition",
      name: e,
      typeCondition: r,
      directives: i,
      selectionSet: n
    };
  }
}

var g = /query|mutation|subscription/y;

function operationDefinition() {
  var e;
  var r;
  var a = [];
  var t = [];
  if (e = advance(g)) {
    ignored();
    r = name();
    a = function variableDefinitions() {
      var e;
      var r = [];
      ignored();
      if (40 === i.charCodeAt(n)) {
        n++;
        ignored();
        while (e = advance(l)) {
          ignored();
          if (58 !== i.charCodeAt(n++)) {
            throw error("VariableDefinition");
          }
          var a = type();
          var t = void 0;
          if (61 === i.charCodeAt(n)) {
            n++;
            ignored();
            if (!(t = value(!0))) {
              throw error("VariableDefinition");
            }
          }
          ignored();
          r.push({
            kind: "VariableDefinition",
            variable: {
              kind: "Variable",
              name: {
                kind: "Name",
                value: e.slice(1)
              }
            },
            type: a,
            defaultValue: t,
            directives: directives(!0)
          });
        }
        if (41 !== i.charCodeAt(n++)) {
          throw error("VariableDefinition");
        }
        ignored();
      }
      return r;
    }();
    t = directives(!1);
  }
  var o = selectionSet();
  if (o) {
    return {
      kind: "OperationDefinition",
      operation: e || "query",
      name: r,
      variableDefinitions: a,
      directives: t,
      selectionSet: o
    };
  }
}

function parse(e, r) {
  i = "string" == typeof e.body ? e.body : e;
  n = 0;
  return function document() {
    var e;
    ignored();
    var r = [];
    while (e = fragmentDefinition() || operationDefinition()) {
      r.push(e);
    }
    return {
      kind: "Document",
      definitions: r
    };
  }();
}

function parseValue(e, r) {
  i = "string" == typeof e.body ? e.body : e;
  n = 0;
  ignored();
  var a = value(!1);
  if (!a) {
    throw error("ValueNode");
  }
  return a;
}

function parseType(e, r) {
  i = "string" == typeof e.body ? e.body : e;
  n = 0;
  return type();
}

var h = {};

function visit(e, r) {
  var i = [];
  var n = [];
  try {
    var a = function traverse(e, a, t) {
      var o = !1;
      var l = r[e.kind] && r[e.kind].enter || r[e.kind] || r.enter;
      var u = l && l.call(r, e, a, t, n, i);
      if (!1 === u) {
        return e;
      } else if (null === u) {
        return null;
      } else if (u === h) {
        throw h;
      } else if (u && "string" == typeof u.kind) {
        o = u !== e;
        e = u;
      }
      if (t) {
        i.push(t);
      }
      var v;
      var d = {
        ...e
      };
      for (var s in e) {
        n.push(s);
        var c = e[s];
        if (Array.isArray(c)) {
          var f = [];
          for (var p = 0; p < c.length; p++) {
            if (null != c[p] && "string" == typeof c[p].kind) {
              i.push(e);
              n.push(p);
              v = traverse(c[p], p, c);
              n.pop();
              i.pop();
              if (null == v) {
                o = !0;
              } else {
                o = o || v !== c[p];
                f.push(v);
              }
            }
          }
          c = f;
        } else if (null != c && "string" == typeof c.kind) {
          if (void 0 !== (v = traverse(c, s, e))) {
            o = o || c !== v;
            c = v;
          }
        }
        n.pop();
        if (o) {
          d[s] = c;
        }
      }
      if (t) {
        i.pop();
      }
      var m = r[e.kind] && r[e.kind].leave || r.leave;
      var g = m && m.call(r, e, a, t, n, i);
      if (g === h) {
        throw h;
      } else if (void 0 !== g) {
        return g;
      } else if (void 0 !== u) {
        return o ? d : u;
      } else {
        return o ? d : e;
      }
    }(e);
    return void 0 !== a && !1 !== a ? a : e;
  } catch (r) {
    if (r !== h) {
      throw r;
    }
    return e;
  }
}

function printString(e) {
  return JSON.stringify(e);
}

function printBlockString(e) {
  return '"""\n' + e.replace(/"""/g, '\\"""') + '\n"""';
}

var hasItems = e => !(!e || !e.length);

var y = {
  OperationDefinition(e) {
    if ("query" === e.operation && !e.name && !hasItems(e.variableDefinitions) && !hasItems(e.directives)) {
      return y.SelectionSet(e.selectionSet);
    }
    var r = e.operation;
    if (e.name) {
      r += " " + e.name.value;
    }
    if (hasItems(e.variableDefinitions)) {
      if (!e.name) {
        r += " ";
      }
      r += "(" + e.variableDefinitions.map(y.VariableDefinition).join(", ") + ")";
    }
    if (hasItems(e.directives)) {
      r += " " + e.directives.map(y.Directive).join(" ");
    }
    return r + " " + y.SelectionSet(e.selectionSet);
  },
  VariableDefinition(e) {
    var r = y.Variable(e.variable) + ": " + print(e.type);
    if (e.defaultValue) {
      r += " = " + print(e.defaultValue);
    }
    if (hasItems(e.directives)) {
      r += " " + e.directives.map(y.Directive).join(" ");
    }
    return r;
  },
  Field(e) {
    var r = (e.alias ? e.alias.value + ": " : "") + e.name.value;
    if (hasItems(e.arguments)) {
      var i = e.arguments.map(y.Argument);
      var n = r + "(" + i.join(", ") + ")";
      r = n.length > 80 ? r + "(\n  " + i.join("\n").replace(/\n/g, "\n  ") + "\n)" : n;
    }
    if (hasItems(e.directives)) {
      r += " " + e.directives.map(y.Directive).join(" ");
    }
    return e.selectionSet ? r + " " + y.SelectionSet(e.selectionSet) : r;
  },
  StringValue: e => e.block ? printBlockString(e.value) : printString(e.value),
  BooleanValue: e => "" + e.value,
  NullValue: e => "null",
  IntValue: e => e.value,
  FloatValue: e => e.value,
  EnumValue: e => e.value,
  Name: e => e.value,
  Variable: e => "$" + e.name.value,
  ListValue: e => "[" + e.values.map(print).join(", ") + "]",
  ObjectValue: e => "{" + e.fields.map(y.ObjectField).join(", ") + "}",
  ObjectField: e => e.name.value + ": " + print(e.value),
  Document: e => hasItems(e.definitions) ? e.definitions.map(print).join("\n\n") : "",
  SelectionSet: e => "{\n  " + e.selections.map(print).join("\n").replace(/\n/g, "\n  ") + "\n}",
  Argument: e => e.name.value + ": " + print(e.value),
  FragmentSpread(e) {
    var r = "..." + e.name.value;
    if (hasItems(e.directives)) {
      r += " " + e.directives.map(y.Directive).join(" ");
    }
    return r;
  },
  InlineFragment(e) {
    var r = "...";
    if (e.typeCondition) {
      r += " on " + e.typeCondition.name.value;
    }
    if (hasItems(e.directives)) {
      r += " " + e.directives.map(y.Directive).join(" ");
    }
    return r + " " + print(e.selectionSet);
  },
  FragmentDefinition(e) {
    var r = "fragment " + e.name.value;
    r += " on " + e.typeCondition.name.value;
    if (hasItems(e.directives)) {
      r += " " + e.directives.map(y.Directive).join(" ");
    }
    return r + " " + print(e.selectionSet);
  },
  Directive(e) {
    var r = "@" + e.name.value;
    if (hasItems(e.arguments)) {
      r += "(" + e.arguments.map(y.Argument).join(", ") + ")";
    }
    return r;
  },
  NamedType: e => e.name.value,
  ListType: e => "[" + print(e.type) + "]",
  NonNullType: e => print(e.type) + "!"
};

function print(e) {
  return y[e.kind] ? y[e.kind](e) : "";
}

function valueFromASTUntyped(e, r) {
  switch (e.kind) {
   case "NullValue":
    return null;

   case "IntValue":
    return parseInt(e.value, 10);

   case "FloatValue":
    return parseFloat(e.value);

   case "StringValue":
   case "EnumValue":
   case "BooleanValue":
    return e.value;

   case "ListValue":
    var i = [];
    for (var n = 0, a = e.values; n < a.length; n += 1) {
      i.push(valueFromASTUntyped(a[n], r));
    }
    return i;

   case "ObjectValue":
    var t = Object.create(null);
    for (var o = 0, l = e.fields; o < l.length; o += 1) {
      var u = l[o];
      t[u.name.value] = valueFromASTUntyped(u.value, r);
    }
    return t;

   case "Variable":
    return r && r[e.name.value];
  }
}

function valueFromTypeNode(e, r, i) {
  if ("Variable" === e.kind) {
    return i ? valueFromTypeNode(i[e.name.value], r, i) : void 0;
  } else if ("NonNullType" === r.kind) {
    return "NullValue" !== e.kind ? valueFromTypeNode(e, r, i) : void 0;
  } else if ("NullValue" === e.kind) {
    return null;
  } else if ("ListType" === r.kind) {
    if ("ListValue" === e.kind) {
      var n = [];
      for (var a = 0, t = e.values; a < t.length; a += 1) {
        var o = valueFromTypeNode(t[a], r.type, i);
        if (void 0 === o) {
          return;
        } else {
          n.push(o);
        }
      }
      return n;
    }
  } else if ("NamedType" === r.kind) {
    switch (r.name.value) {
     case "Int":
     case "Float":
     case "String":
     case "Bool":
      return r.name.value + "Value" === e.kind ? valueFromASTUntyped(e, i) : void 0;

     default:
      return valueFromASTUntyped(e, i);
    }
  }
}


//# sourceMappingURL=graphql.web.mjs.map


/***/ }),

/***/ 25773:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _extends; }
/* harmony export */ });
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}


/***/ }),

/***/ 76949:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ $e42e1063c40fb3ef$export$b9ecd428b558ff10; }
/* harmony export */ });
function $e42e1063c40fb3ef$export$b9ecd428b558ff10(originalEventHandler, ourEventHandler, { checkForDefaultPrevented: checkForDefaultPrevented = true  } = {}) {
    return function handleEvent(event) {
        originalEventHandler === null || originalEventHandler === void 0 || originalEventHandler(event);
        if (checkForDefaultPrevented === false || !event.defaultPrevented) return ourEventHandler === null || ourEventHandler === void 0 ? void 0 : ourEventHandler(event);
    };
}





//# sourceMappingURL=index.mjs.map


/***/ }),

/***/ 84878:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "B": function() { return /* binding */ $e02a7d9cb1dc128c$export$c74125a8e3af6bb2; }
});

// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ../node_modules/@radix-ui/react-context/dist/index.mjs
var dist = __webpack_require__(13958);
// EXTERNAL MODULE: ../node_modules/@radix-ui/react-compose-refs/dist/index.mjs
var react_compose_refs_dist = __webpack_require__(62921);
// EXTERNAL MODULE: ../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(25773);
;// CONCATENATED MODULE: ../node_modules/@radix-ui/react-collection/node_modules/@radix-ui/react-slot/dist/index.mjs







/* -------------------------------------------------------------------------------------------------
 * Slot
 * -----------------------------------------------------------------------------------------------*/ const $5e63c961fc1ce211$export$8c6ed5c666ac1360 = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { children: children , ...slotProps } = props;
    const childrenArray = react.Children.toArray(children);
    const slottable = childrenArray.find($5e63c961fc1ce211$var$isSlottable);
    if (slottable) {
        // the new element to render is the one passed as a child of `Slottable`
        const newElement = slottable.props.children;
        const newChildren = childrenArray.map((child)=>{
            if (child === slottable) {
                // because the new element will be the one rendered, we are only interested
                // in grabbing its children (`newElement.props.children`)
                if (react.Children.count(newElement) > 1) return react.Children.only(null);
                return /*#__PURE__*/ (0,react.isValidElement)(newElement) ? newElement.props.children : null;
            } else return child;
        });
        return /*#__PURE__*/ (0,react.createElement)($5e63c961fc1ce211$var$SlotClone, (0,esm_extends/* default */.Z)({}, slotProps, {
            ref: forwardedRef
        }), /*#__PURE__*/ (0,react.isValidElement)(newElement) ? /*#__PURE__*/ (0,react.cloneElement)(newElement, undefined, newChildren) : null);
    }
    return /*#__PURE__*/ (0,react.createElement)($5e63c961fc1ce211$var$SlotClone, (0,esm_extends/* default */.Z)({}, slotProps, {
        ref: forwardedRef
    }), children);
});
$5e63c961fc1ce211$export$8c6ed5c666ac1360.displayName = 'Slot';
/* -------------------------------------------------------------------------------------------------
 * SlotClone
 * -----------------------------------------------------------------------------------------------*/ const $5e63c961fc1ce211$var$SlotClone = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { children: children , ...slotProps } = props;
    if (/*#__PURE__*/ (0,react.isValidElement)(children)) return /*#__PURE__*/ (0,react.cloneElement)(children, {
        ...$5e63c961fc1ce211$var$mergeProps(slotProps, children.props),
        ref: forwardedRef ? (0,react_compose_refs_dist/* composeRefs */.F)(forwardedRef, children.ref) : children.ref
    });
    return react.Children.count(children) > 1 ? react.Children.only(null) : null;
});
$5e63c961fc1ce211$var$SlotClone.displayName = 'SlotClone';
/* -------------------------------------------------------------------------------------------------
 * Slottable
 * -----------------------------------------------------------------------------------------------*/ const $5e63c961fc1ce211$export$d9f1ccf0bdb05d45 = ({ children: children  })=>{
    return /*#__PURE__*/ (0,react.createElement)(react.Fragment, null, children);
};
/* ---------------------------------------------------------------------------------------------- */ function $5e63c961fc1ce211$var$isSlottable(child) {
    return /*#__PURE__*/ (0,react.isValidElement)(child) && child.type === $5e63c961fc1ce211$export$d9f1ccf0bdb05d45;
}
function $5e63c961fc1ce211$var$mergeProps(slotProps, childProps) {
    // all child props should override
    const overrideProps = {
        ...childProps
    };
    for(const propName in childProps){
        const slotPropValue = slotProps[propName];
        const childPropValue = childProps[propName];
        const isHandler = /^on[A-Z]/.test(propName);
        if (isHandler) {
            // if the handler exists on both, we compose them
            if (slotPropValue && childPropValue) overrideProps[propName] = (...args)=>{
                childPropValue(...args);
                slotPropValue(...args);
            };
            else if (slotPropValue) overrideProps[propName] = slotPropValue;
        } else if (propName === 'style') overrideProps[propName] = {
            ...slotPropValue,
            ...childPropValue
        };
        else if (propName === 'className') overrideProps[propName] = [
            slotPropValue,
            childPropValue
        ].filter(Boolean).join(' ');
    }
    return {
        ...slotProps,
        ...overrideProps
    };
}
const $5e63c961fc1ce211$export$be92b6f5f03c0fe9 = (/* unused pure expression or super */ null && ($5e63c961fc1ce211$export$8c6ed5c666ac1360));





//# sourceMappingURL=index.mjs.map

;// CONCATENATED MODULE: ../node_modules/@radix-ui/react-collection/dist/index.mjs









// We have resorted to returning slots directly rather than exposing primitives that can then
// be slotted like `<CollectionItem as={Slot}>…</CollectionItem>`.
// This is because we encountered issues with generic types that cannot be statically analysed
// due to creating them dynamically via createCollection.
function $e02a7d9cb1dc128c$export$c74125a8e3af6bb2(name) {
    /* -----------------------------------------------------------------------------------------------
   * CollectionProvider
   * ---------------------------------------------------------------------------------------------*/ const PROVIDER_NAME = name + 'CollectionProvider';
    const [createCollectionContext, createCollectionScope] = (0,dist/* createContextScope */.b)(PROVIDER_NAME);
    const [CollectionProviderImpl, useCollectionContext] = createCollectionContext(PROVIDER_NAME, {
        collectionRef: {
            current: null
        },
        itemMap: new Map()
    });
    const CollectionProvider = (props)=>{
        const { scope: scope , children: children  } = props;
        const ref = react.useRef(null);
        const itemMap = react.useRef(new Map()).current;
        return /*#__PURE__*/ react.createElement(CollectionProviderImpl, {
            scope: scope,
            itemMap: itemMap,
            collectionRef: ref
        }, children);
    };
    /*#__PURE__*/ Object.assign(CollectionProvider, {
        displayName: PROVIDER_NAME
    });
    /* -----------------------------------------------------------------------------------------------
   * CollectionSlot
   * ---------------------------------------------------------------------------------------------*/ const COLLECTION_SLOT_NAME = name + 'CollectionSlot';
    const CollectionSlot = /*#__PURE__*/ react.forwardRef((props, forwardedRef)=>{
        const { scope: scope , children: children  } = props;
        const context = useCollectionContext(COLLECTION_SLOT_NAME, scope);
        const composedRefs = (0,react_compose_refs_dist/* useComposedRefs */.e)(forwardedRef, context.collectionRef);
        return /*#__PURE__*/ react.createElement($5e63c961fc1ce211$export$8c6ed5c666ac1360, {
            ref: composedRefs
        }, children);
    });
    /*#__PURE__*/ Object.assign(CollectionSlot, {
        displayName: COLLECTION_SLOT_NAME
    });
    /* -----------------------------------------------------------------------------------------------
   * CollectionItem
   * ---------------------------------------------------------------------------------------------*/ const ITEM_SLOT_NAME = name + 'CollectionItemSlot';
    const ITEM_DATA_ATTR = 'data-radix-collection-item';
    const CollectionItemSlot = /*#__PURE__*/ react.forwardRef((props, forwardedRef)=>{
        const { scope: scope , children: children , ...itemData } = props;
        const ref = react.useRef(null);
        const composedRefs = (0,react_compose_refs_dist/* useComposedRefs */.e)(forwardedRef, ref);
        const context = useCollectionContext(ITEM_SLOT_NAME, scope);
        react.useEffect(()=>{
            context.itemMap.set(ref, {
                ref: ref,
                ...itemData
            });
            return ()=>void context.itemMap.delete(ref)
            ;
        });
        return /*#__PURE__*/ react.createElement($5e63c961fc1ce211$export$8c6ed5c666ac1360, {
            [ITEM_DATA_ATTR]: '',
            ref: composedRefs
        }, children);
    });
    /*#__PURE__*/ Object.assign(CollectionItemSlot, {
        displayName: ITEM_SLOT_NAME
    });
    /* -----------------------------------------------------------------------------------------------
   * useCollection
   * ---------------------------------------------------------------------------------------------*/ function useCollection(scope) {
        const context = useCollectionContext(name + 'CollectionConsumer', scope);
        const getItems = react.useCallback(()=>{
            const collectionNode = context.collectionRef.current;
            if (!collectionNode) return [];
            const orderedNodes = Array.from(collectionNode.querySelectorAll(`[${ITEM_DATA_ATTR}]`));
            const items = Array.from(context.itemMap.values());
            const orderedItems = items.sort((a, b)=>orderedNodes.indexOf(a.ref.current) - orderedNodes.indexOf(b.ref.current)
            );
            return orderedItems;
        }, [
            context.collectionRef,
            context.itemMap
        ]);
        return getItems;
    }
    return [
        {
            Provider: CollectionProvider,
            Slot: CollectionSlot,
            ItemSlot: CollectionItemSlot
        },
        useCollection,
        createCollectionScope
    ];
}





//# sourceMappingURL=index.mjs.map


/***/ }),

/***/ 62921:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ $6ed0406888f73fc4$export$43e446d32b3d21af; },
/* harmony export */   "e": function() { return /* binding */ $6ed0406888f73fc4$export$c7b2cbe3552a0d05; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);



/**
 * Set a given ref to a given value
 * This utility takes care of different types of refs: callback refs and RefObject(s)
 */ function $6ed0406888f73fc4$var$setRef(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref !== null && ref !== undefined) ref.current = value;
}
/**
 * A utility to compose multiple refs together
 * Accepts callback refs and RefObject(s)
 */ function $6ed0406888f73fc4$export$43e446d32b3d21af(...refs) {
    return (node)=>refs.forEach((ref)=>$6ed0406888f73fc4$var$setRef(ref, node)
        )
    ;
}
/**
 * A custom hook that composes multiple refs
 * Accepts callback refs and RefObject(s)
 */ function $6ed0406888f73fc4$export$c7b2cbe3552a0d05(...refs) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)($6ed0406888f73fc4$export$43e446d32b3d21af(...refs), refs);
}





//# sourceMappingURL=index.mjs.map


/***/ }),

/***/ 13958:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ $c512c27ab02ef895$export$50c7b4e9d9f19c1; }
/* harmony export */ });
/* unused harmony export createContext */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);



function $c512c27ab02ef895$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
    const Context = /*#__PURE__*/ $3bkAK$createContext(defaultContext);
    function Provider(props) {
        const { children: children , ...context } = props; // Only re-memoize when prop values change
        // eslint-disable-next-line react-hooks/exhaustive-deps
        const value = $3bkAK$useMemo(()=>context
        , Object.values(context));
        return /*#__PURE__*/ $3bkAK$createElement(Context.Provider, {
            value: value
        }, children);
    }
    function useContext(consumerName) {
        const context = $3bkAK$useContext(Context);
        if (context) return context;
        if (defaultContext !== undefined) return defaultContext; // if a defaultContext wasn't specified, it's a required context.
        throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
    }
    Provider.displayName = rootComponentName + 'Provider';
    return [
        Provider,
        useContext
    ];
}
/* -------------------------------------------------------------------------------------------------
 * createContextScope
 * -----------------------------------------------------------------------------------------------*/ function $c512c27ab02ef895$export$50c7b4e9d9f19c1(scopeName, createContextScopeDeps = []) {
    let defaultContexts = [];
    /* -----------------------------------------------------------------------------------------------
   * createContext
   * ---------------------------------------------------------------------------------------------*/ function $c512c27ab02ef895$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
        const BaseContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(defaultContext);
        const index = defaultContexts.length;
        defaultContexts = [
            ...defaultContexts,
            defaultContext
        ];
        function Provider(props) {
            const { scope: scope , children: children , ...context } = props;
            const Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index]) || BaseContext; // Only re-memoize when prop values change
            // eslint-disable-next-line react-hooks/exhaustive-deps
            const value = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>context
            , Object.values(context));
            return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(Context.Provider, {
                value: value
            }, children);
        }
        function useContext(consumerName, scope) {
            const Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index]) || BaseContext;
            const context = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(Context);
            if (context) return context;
            if (defaultContext !== undefined) return defaultContext; // if a defaultContext wasn't specified, it's a required context.
            throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
        }
        Provider.displayName = rootComponentName + 'Provider';
        return [
            Provider,
            useContext
        ];
    }
    /* -----------------------------------------------------------------------------------------------
   * createScope
   * ---------------------------------------------------------------------------------------------*/ const createScope = ()=>{
        const scopeContexts = defaultContexts.map((defaultContext)=>{
            return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(defaultContext);
        });
        return function useScope(scope) {
            const contexts = (scope === null || scope === void 0 ? void 0 : scope[scopeName]) || scopeContexts;
            return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>({
                    [`__scope${scopeName}`]: {
                        ...scope,
                        [scopeName]: contexts
                    }
                })
            , [
                scope,
                contexts
            ]);
        };
    };
    createScope.scopeName = scopeName;
    return [
        $c512c27ab02ef895$export$fd42f52fd3ae1109,
        $c512c27ab02ef895$var$composeContextScopes(createScope, ...createContextScopeDeps)
    ];
}
/* -------------------------------------------------------------------------------------------------
 * composeContextScopes
 * -----------------------------------------------------------------------------------------------*/ function $c512c27ab02ef895$var$composeContextScopes(...scopes) {
    const baseScope = scopes[0];
    if (scopes.length === 1) return baseScope;
    const createScope1 = ()=>{
        const scopeHooks = scopes.map((createScope)=>({
                useScope: createScope(),
                scopeName: createScope.scopeName
            })
        );
        return function useComposedScopes(overrideScopes) {
            const nextScopes1 = scopeHooks.reduce((nextScopes, { useScope: useScope , scopeName: scopeName  })=>{
                // We are calling a hook inside a callback which React warns against to avoid inconsistent
                // renders, however, scoping doesn't have render side effects so we ignore the rule.
                // eslint-disable-next-line react-hooks/rules-of-hooks
                const scopeProps = useScope(overrideScopes);
                const currentScope = scopeProps[`__scope${scopeName}`];
                return {
                    ...nextScopes,
                    ...currentScope
                };
            }, {});
            return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>({
                    [`__scope${baseScope.scopeName}`]: nextScopes1
                })
            , [
                nextScopes1
            ]);
        };
    };
    createScope1.scopeName = baseScope.scopeName;
    return createScope1;
}





//# sourceMappingURL=index.mjs.map


/***/ }),

/***/ 73814:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "gm": function() { return /* binding */ $f631663db3294ace$export$b39126d51d94e6f3; }
/* harmony export */ });
/* unused harmony exports Provider, DirectionProvider */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);



const $f631663db3294ace$var$DirectionContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(undefined);
/* -------------------------------------------------------------------------------------------------
 * Direction
 * -----------------------------------------------------------------------------------------------*/ const $f631663db3294ace$export$c760c09fdd558351 = (props)=>{
    const { dir: dir , children: children  } = props;
    return /*#__PURE__*/ $7Gjcd$createElement($f631663db3294ace$var$DirectionContext.Provider, {
        value: dir
    }, children);
};
/* -----------------------------------------------------------------------------------------------*/ function $f631663db3294ace$export$b39126d51d94e6f3(localDir) {
    const globalDir = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)($f631663db3294ace$var$DirectionContext);
    return localDir || globalDir || 'ltr';
}
const $f631663db3294ace$export$2881499e37b75b9a = (/* unused pure expression or super */ null && ($f631663db3294ace$export$c760c09fdd558351));





//# sourceMappingURL=index.mjs.map


/***/ }),

/***/ 14181:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "WV": function() { return /* binding */ $8927f6f2acc4f386$export$250ffa63cdc0d034; },
  "jH": function() { return /* binding */ $8927f6f2acc4f386$export$6d1a0317bde7de7f; }
});

// UNUSED EXPORTS: Root

// EXTERNAL MODULE: ../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(25773);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ../node_modules/react-dom/index.js
var react_dom = __webpack_require__(31542);
// EXTERNAL MODULE: ../node_modules/@radix-ui/react-compose-refs/dist/index.mjs
var dist = __webpack_require__(62921);
;// CONCATENATED MODULE: ../node_modules/@radix-ui/react-primitive/node_modules/@radix-ui/react-slot/dist/index.mjs







/* -------------------------------------------------------------------------------------------------
 * Slot
 * -----------------------------------------------------------------------------------------------*/ const $5e63c961fc1ce211$export$8c6ed5c666ac1360 = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { children: children , ...slotProps } = props;
    const childrenArray = react.Children.toArray(children);
    const slottable = childrenArray.find($5e63c961fc1ce211$var$isSlottable);
    if (slottable) {
        // the new element to render is the one passed as a child of `Slottable`
        const newElement = slottable.props.children;
        const newChildren = childrenArray.map((child)=>{
            if (child === slottable) {
                // because the new element will be the one rendered, we are only interested
                // in grabbing its children (`newElement.props.children`)
                if (react.Children.count(newElement) > 1) return react.Children.only(null);
                return /*#__PURE__*/ (0,react.isValidElement)(newElement) ? newElement.props.children : null;
            } else return child;
        });
        return /*#__PURE__*/ (0,react.createElement)($5e63c961fc1ce211$var$SlotClone, (0,esm_extends/* default */.Z)({}, slotProps, {
            ref: forwardedRef
        }), /*#__PURE__*/ (0,react.isValidElement)(newElement) ? /*#__PURE__*/ (0,react.cloneElement)(newElement, undefined, newChildren) : null);
    }
    return /*#__PURE__*/ (0,react.createElement)($5e63c961fc1ce211$var$SlotClone, (0,esm_extends/* default */.Z)({}, slotProps, {
        ref: forwardedRef
    }), children);
});
$5e63c961fc1ce211$export$8c6ed5c666ac1360.displayName = 'Slot';
/* -------------------------------------------------------------------------------------------------
 * SlotClone
 * -----------------------------------------------------------------------------------------------*/ const $5e63c961fc1ce211$var$SlotClone = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { children: children , ...slotProps } = props;
    if (/*#__PURE__*/ (0,react.isValidElement)(children)) return /*#__PURE__*/ (0,react.cloneElement)(children, {
        ...$5e63c961fc1ce211$var$mergeProps(slotProps, children.props),
        ref: forwardedRef ? (0,dist/* composeRefs */.F)(forwardedRef, children.ref) : children.ref
    });
    return react.Children.count(children) > 1 ? react.Children.only(null) : null;
});
$5e63c961fc1ce211$var$SlotClone.displayName = 'SlotClone';
/* -------------------------------------------------------------------------------------------------
 * Slottable
 * -----------------------------------------------------------------------------------------------*/ const $5e63c961fc1ce211$export$d9f1ccf0bdb05d45 = ({ children: children  })=>{
    return /*#__PURE__*/ (0,react.createElement)(react.Fragment, null, children);
};
/* ---------------------------------------------------------------------------------------------- */ function $5e63c961fc1ce211$var$isSlottable(child) {
    return /*#__PURE__*/ (0,react.isValidElement)(child) && child.type === $5e63c961fc1ce211$export$d9f1ccf0bdb05d45;
}
function $5e63c961fc1ce211$var$mergeProps(slotProps, childProps) {
    // all child props should override
    const overrideProps = {
        ...childProps
    };
    for(const propName in childProps){
        const slotPropValue = slotProps[propName];
        const childPropValue = childProps[propName];
        const isHandler = /^on[A-Z]/.test(propName);
        if (isHandler) {
            // if the handler exists on both, we compose them
            if (slotPropValue && childPropValue) overrideProps[propName] = (...args)=>{
                childPropValue(...args);
                slotPropValue(...args);
            };
            else if (slotPropValue) overrideProps[propName] = slotPropValue;
        } else if (propName === 'style') overrideProps[propName] = {
            ...slotPropValue,
            ...childPropValue
        };
        else if (propName === 'className') overrideProps[propName] = [
            slotPropValue,
            childPropValue
        ].filter(Boolean).join(' ');
    }
    return {
        ...slotProps,
        ...overrideProps
    };
}
const $5e63c961fc1ce211$export$be92b6f5f03c0fe9 = (/* unused pure expression or super */ null && ($5e63c961fc1ce211$export$8c6ed5c666ac1360));





//# sourceMappingURL=index.mjs.map

;// CONCATENATED MODULE: ../node_modules/@radix-ui/react-primitive/dist/index.mjs









const $8927f6f2acc4f386$var$NODES = [
    'a',
    'button',
    'div',
    'form',
    'h2',
    'h3',
    'img',
    'input',
    'label',
    'li',
    'nav',
    'ol',
    'p',
    'span',
    'svg',
    'ul'
]; // Temporary while we await merge of this fix:
// https://github.com/DefinitelyTyped/DefinitelyTyped/pull/55396
// prettier-ignore
/* -------------------------------------------------------------------------------------------------
 * Primitive
 * -----------------------------------------------------------------------------------------------*/ const $8927f6f2acc4f386$export$250ffa63cdc0d034 = $8927f6f2acc4f386$var$NODES.reduce((primitive, node)=>{
    const Node = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
        const { asChild: asChild , ...primitiveProps } = props;
        const Comp = asChild ? $5e63c961fc1ce211$export$8c6ed5c666ac1360 : node;
        (0,react.useEffect)(()=>{
            window[Symbol.for('radix-ui')] = true;
        }, []);
        return /*#__PURE__*/ (0,react.createElement)(Comp, (0,esm_extends/* default */.Z)({}, primitiveProps, {
            ref: forwardedRef
        }));
    });
    Node.displayName = `Primitive.${node}`;
    return {
        ...primitive,
        [node]: Node
    };
}, {});
/* -------------------------------------------------------------------------------------------------
 * Utils
 * -----------------------------------------------------------------------------------------------*/ /**
 * Flush custom event dispatch
 * https://github.com/radix-ui/primitives/pull/1378
 *
 * React batches *all* event handlers since version 18, this introduces certain considerations when using custom event types.
 *
 * Internally, React prioritises events in the following order:
 *  - discrete
 *  - continuous
 *  - default
 *
 * https://github.com/facebook/react/blob/a8a4742f1c54493df00da648a3f9d26e3db9c8b5/packages/react-dom/src/events/ReactDOMEventListener.js#L294-L350
 *
 * `discrete` is an  important distinction as updates within these events are applied immediately.
 * React however, is not able to infer the priority of custom event types due to how they are detected internally.
 * Because of this, it's possible for updates from custom events to be unexpectedly batched when
 * dispatched by another `discrete` event.
 *
 * In order to ensure that updates from custom events are applied predictably, we need to manually flush the batch.
 * This utility should be used when dispatching a custom event from within another `discrete` event, this utility
 * is not nessesary when dispatching known event types, or if dispatching a custom type inside a non-discrete event.
 * For example:
 *
 * dispatching a known click 👎
 * target.dispatchEvent(new Event(‘click’))
 *
 * dispatching a custom type within a non-discrete event 👎
 * onScroll={(event) => event.target.dispatchEvent(new CustomEvent(‘customType’))}
 *
 * dispatching a custom type within a `discrete` event 👍
 * onPointerDown={(event) => dispatchDiscreteCustomEvent(event.target, new CustomEvent(‘customType’))}
 *
 * Note: though React classifies `focus`, `focusin` and `focusout` events as `discrete`, it's  not recommended to use
 * this utility with them. This is because it's possible for those handlers to be called implicitly during render
 * e.g. when focus is within a component as it is unmounted, or when managing focus on mount.
 */ function $8927f6f2acc4f386$export$6d1a0317bde7de7f(target, event) {
    if (target) (0,react_dom.flushSync)(()=>target.dispatchEvent(event)
    );
}
/* -----------------------------------------------------------------------------------------------*/ const $8927f6f2acc4f386$export$be92b6f5f03c0fe9 = (/* unused pure expression or super */ null && ($8927f6f2acc4f386$export$250ffa63cdc0d034));





//# sourceMappingURL=index.mjs.map


/***/ }),

/***/ 60938:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ $b1b2314f5f9a1d84$export$25bec8c6f54ee79a; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);



/**
 * A custom hook that converts a callback to a ref to avoid triggering re-renders when passed as a
 * prop or avoid re-executing effects when passed as a dependency
 */ function $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(callback) {
    const callbackRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(callback);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        callbackRef.current = callback;
    }); // https://github.com/facebook/react/issues/19240
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>(...args)=>{
            var _callbackRef$current;
            return (_callbackRef$current = callbackRef.current) === null || _callbackRef$current === void 0 ? void 0 : _callbackRef$current.call(callbackRef, ...args);
        }
    , []);
}





//# sourceMappingURL=index.mjs.map


/***/ }),

/***/ 37517:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ $71cd76cc60e0454e$export$6f32135080cb4c3; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var _radix_ui_react_use_callback_ref__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60938);





function $71cd76cc60e0454e$export$6f32135080cb4c3({ prop: prop , defaultProp: defaultProp , onChange: onChange = ()=>{}  }) {
    const [uncontrolledProp, setUncontrolledProp] = $71cd76cc60e0454e$var$useUncontrolledState({
        defaultProp: defaultProp,
        onChange: onChange
    });
    const isControlled = prop !== undefined;
    const value1 = isControlled ? prop : uncontrolledProp;
    const handleChange = (0,_radix_ui_react_use_callback_ref__WEBPACK_IMPORTED_MODULE_1__/* .useCallbackRef */ .W)(onChange);
    const setValue = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((nextValue)=>{
        if (isControlled) {
            const setter = nextValue;
            const value = typeof nextValue === 'function' ? setter(prop) : nextValue;
            if (value !== prop) handleChange(value);
        } else setUncontrolledProp(nextValue);
    }, [
        isControlled,
        prop,
        setUncontrolledProp,
        handleChange
    ]);
    return [
        value1,
        setValue
    ];
}
function $71cd76cc60e0454e$var$useUncontrolledState({ defaultProp: defaultProp , onChange: onChange  }) {
    const uncontrolledState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(defaultProp);
    const [value] = uncontrolledState;
    const prevValueRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(value);
    const handleChange = (0,_radix_ui_react_use_callback_ref__WEBPACK_IMPORTED_MODULE_1__/* .useCallbackRef */ .W)(onChange);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (prevValueRef.current !== value) {
            handleChange(value);
            prevValueRef.current = value;
        }
    }, [
        value,
        prevValueRef,
        handleChange
    ]);
    return uncontrolledState;
}





//# sourceMappingURL=index.mjs.map


/***/ }),

/***/ 39447:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ $9f79659886946c16$export$e5c5a5f917a5871c; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);



/**
 * On the server, React emits a warning when calling `useLayoutEffect`.
 * This is because neither `useLayoutEffect` nor `useEffect` run on the server.
 * We use this safe version which suppresses the warning by replacing it with a noop on the server.
 *
 * See: https://reactjs.org/docs/hooks-reference.html#uselayouteffect
 */ const $9f79659886946c16$export$e5c5a5f917a5871c = Boolean(globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) ? react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect : ()=>{};





//# sourceMappingURL=index.mjs.map


/***/ }),

/***/ 40261:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ $db6c3485150b8e66$export$1ab7ae714698c4b8; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var _radix_ui_react_use_layout_effect__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39447);





function $db6c3485150b8e66$export$1ab7ae714698c4b8(element) {
    const [size, setSize] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(undefined);
    (0,_radix_ui_react_use_layout_effect__WEBPACK_IMPORTED_MODULE_1__/* .useLayoutEffect */ .b)(()=>{
        if (element) {
            // provide size as early as possible
            setSize({
                width: element.offsetWidth,
                height: element.offsetHeight
            });
            const resizeObserver = new ResizeObserver((entries)=>{
                if (!Array.isArray(entries)) return;
                 // Since we only observe the one element, we don't need to loop over the
                // array
                if (!entries.length) return;
                const entry = entries[0];
                let width;
                let height;
                if ('borderBoxSize' in entry) {
                    const borderSizeEntry = entry['borderBoxSize']; // iron out differences between browsers
                    const borderSize = Array.isArray(borderSizeEntry) ? borderSizeEntry[0] : borderSizeEntry;
                    width = borderSize['inlineSize'];
                    height = borderSize['blockSize'];
                } else {
                    // for browsers that don't support `borderBoxSize`
                    // we calculate it ourselves to get the correct border box.
                    width = element.offsetWidth;
                    height = element.offsetHeight;
                }
                setSize({
                    width: width,
                    height: height
                });
            });
            resizeObserver.observe(element, {
                box: 'border-box'
            });
            return ()=>resizeObserver.unobserve(element)
            ;
        } else // We only want to reset to `undefined` when the element becomes `null`,
        // not if it changes to another element.
        setSize(undefined);
    }, [
        element
    ]);
    return size;
}





//# sourceMappingURL=index.mjs.map


/***/ }),

/***/ 10719:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayLikeToArray; }
/* harmony export */ });
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}


/***/ }),

/***/ 19695:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayWithHoles; }
/* harmony export */ });
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}


/***/ }),

/***/ 23842:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _asyncToGenerator; }
/* harmony export */ });
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}


/***/ }),

/***/ 24364:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _classCallCheck; }
/* harmony export */ });
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),

/***/ 17599:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _defineProperty; }
/* harmony export */ });
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}


/***/ }),

/***/ 15963:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _instanceof; }
/* harmony export */ });
function _instanceof(left, right) {
  if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
    return !!right[Symbol.hasInstance](left);
  } else {
    return left instanceof right;
  }
}

/***/ }),

/***/ 82126:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _iterableToArray; }
/* harmony export */ });
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


/***/ }),

/***/ 30539:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _nonIterableRest; }
/* harmony export */ });
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


/***/ }),

/***/ 85034:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectSpread; }
/* harmony export */ });
/* harmony import */ var _define_property_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17599);


function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      (0,_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    });
  }

  return target;
}

/***/ }),

/***/ 70169:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectSpreadProps; }
/* harmony export */ });
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}

function _objectSpreadProps(target, source) {
  source = source != null ? source : {}
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(
        target,
        key,
        Object.getOwnPropertyDescriptor(source, key)
      );
    });
  }

  return target;
}

/***/ }),

/***/ 31373:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _objectWithoutProperties; }
});

;// CONCATENATED MODULE: ../node_modules/@swc/helpers/src/_object_without_properties_loose.mjs
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

;// CONCATENATED MODULE: ../node_modules/@swc/helpers/src/_object_without_properties.mjs


function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/***/ }),

/***/ 5341:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _slicedToArray; }
/* harmony export */ });
/* harmony import */ var _array_with_holes_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19695);
/* harmony import */ var _iterable_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82126);
/* harmony import */ var _non_iterable_rest_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30539);
/* harmony import */ var _unsupported_iterable_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12164);





function _slicedToArray(arr, i) {
  return (0,_array_with_holes_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(arr) || (0,_iterable_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(arr, i) || (0,_unsupported_iterable_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(arr, i) || (0,_non_iterable_rest_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
}


/***/ }),

/***/ 19989:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _taggedTemplateLiteral; }
/* harmony export */ });
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}


/***/ }),

/***/ 3204:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _toConsumableArray; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_array_like_to_array.mjs
var _array_like_to_array = __webpack_require__(10719);
;// CONCATENATED MODULE: ../node_modules/@swc/helpers/src/_array_without_holes.mjs


function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return (0,_array_like_to_array/* default */.Z)(arr);
}

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(82126);
;// CONCATENATED MODULE: ../node_modules/@swc/helpers/src/_non_iterable_spread.mjs
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(12164);
;// CONCATENATED MODULE: ../node_modules/@swc/helpers/src/_to_consumable_array.mjs





function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || (0,_iterable_to_array/* default */.Z)(arr) || (0,_unsupported_iterable_to_array/* default */.Z)(arr) || _nonIterableSpread();
}


/***/ }),

/***/ 12164:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _unsupportedIterableToArray; }
/* harmony export */ });
/* harmony import */ var _array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10719);


function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
}


/***/ }),

/***/ 88423:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ CombinedError; },
/* harmony export */   "d": function() { return /* binding */ makeFetchURL; },
/* harmony export */   "e": function() { return /* binding */ makeFetchOptions; },
/* harmony export */   "f": function() { return /* binding */ makeFetchSource; },
/* harmony export */   "h": function() { return /* binding */ createRequest; },
/* harmony export */   "i": function() { return /* binding */ stringifyVariables; },
/* harmony export */   "k": function() { return /* binding */ keyDocument; },
/* harmony export */   "m": function() { return /* binding */ makeFetchBody; },
/* harmony export */   "s": function() { return /* binding */ stringifyDocument; }
/* harmony export */ });
/* unused harmony exports a, b, c, g */
/* harmony import */ var _0no_co_graphql_web__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7846);
/* harmony import */ var wonka__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51044);




var rehydrateGraphQlError = e => {
  if (e && e.message && (e.extensions || "GraphQLError" === e.name)) {
    return e;
  } else if ("object" == typeof e && e.message) {
    return new _0no_co_graphql_web__WEBPACK_IMPORTED_MODULE_0__/* .GraphQLError */ .__(e.message, e.nodes, e.source, e.positions, e.path, e, e.extensions || {});
  } else {
    return new _0no_co_graphql_web__WEBPACK_IMPORTED_MODULE_0__/* .GraphQLError */ .__(e);
  }
};

class CombinedError extends Error {
  constructor(r) {
    var e = (r.graphQLErrors || []).map(rehydrateGraphQlError);
    var t = ((r, e) => {
      var t = "";
      if (r) {
        return `[Network] ${r.message}`;
      }
      if (e) {
        for (var a of e) {
          if (t) {
            t += "\n";
          }
          t += `[GraphQL] ${a.message}`;
        }
      }
      return t;
    })(r.networkError, e);
    super(t);
    this.name = "CombinedError";
    this.message = t;
    this.graphQLErrors = e;
    this.networkError = r.networkError;
    this.response = r.response;
  }
  toString() {
    return this.message;
  }
}

var phash = (r, e) => {
  var t = 0 | (e || 5381);
  for (var a = 0, o = 0 | r.length; a < o; a++) {
    t = (t << 5) + t + r.charCodeAt(a);
  }
  return t;
};

var s = new Set;

var i = new WeakMap;

var stringify = r => {
  if (null === r || s.has(r)) {
    return "null";
  } else if ("object" != typeof r) {
    return JSON.stringify(r) || "";
  } else if (r.toJSON) {
    return stringify(r.toJSON());
  } else if (Array.isArray(r)) {
    var e = "[";
    for (var t of r) {
      if (e.length > 1) {
        e += ",";
      }
      e += stringify(t) || "null";
    }
    return e += "]";
  }
  var a = Object.keys(r).sort();
  if (!a.length && r.constructor && r.constructor !== Object) {
    var o = i.get(r) || Math.random().toString(36).slice(2);
    i.set(r, o);
    return stringify({
      __key: o
    });
  }
  s.add(r);
  var n = "{";
  for (var f of a) {
    var v = stringify(r[f]);
    if (v) {
      if (n.length > 1) {
        n += ",";
      }
      n += stringify(f) + ":" + v;
    }
  }
  s.delete(r);
  return n += "}";
};

var extract = (r, e, t) => {
  if (null == t || "object" != typeof t || t.toJSON || s.has(t)) {} else if (Array.isArray(t)) {
    for (var a = 0, o = t.length; a < o; a++) {
      extract(r, `${e}.${a}`, t[a]);
    }
  } else if (t instanceof f || t instanceof v) {
    r.set(e, t);
  } else {
    s.add(t);
    for (var n of Object.keys(t)) {
      extract(r, `${e}.${n}`, t[n]);
    }
  }
};

var stringifyVariables = r => {
  s.clear();
  return stringify(r);
};

class NoopConstructor {}

var f = "undefined" != typeof File ? File : NoopConstructor;

var v = "undefined" != typeof Blob ? Blob : NoopConstructor;

var l = /("{3}[\s\S]*"{3}|"(?:\\.|[^"])*")/g;

var c = /(?:#[^\n\r]+)?(?:[\r\n]+|$)/g;

var replaceOutsideStrings = (r, e) => e % 2 == 0 ? r.replace(c, "\n") : r;

var sanitizeDocument = r => r.split(l).map(replaceOutsideStrings).join("").trim();

var d = new Map;

var p = new Map;

var stringifyDocument = r => {
  var t;
  if ("string" == typeof r) {
    t = sanitizeDocument(r);
  } else if (r.loc && p.get(r.__key) === r) {
    t = r.loc.source.body;
  } else {
    t = d.get(r) || sanitizeDocument((0,_0no_co_graphql_web__WEBPACK_IMPORTED_MODULE_0__/* .print */ .S0)(r));
    d.set(r, t);
  }
  if ("string" != typeof r && !r.loc) {
    r.loc = {
      start: 0,
      end: t.length,
      source: {
        body: t,
        name: "gql",
        locationOffset: {
          line: 1,
          column: 1
        }
      }
    };
  }
  return t;
};

var hashDocument = r => {
  var e = phash(stringifyDocument(r));
  if (r.definitions) {
    var t = getOperationName(r);
    if (t) {
      e = phash(`\n# ${t}`, e);
    }
  }
  return e;
};

var keyDocument = r => {
  var e;
  var a;
  if ("string" == typeof r) {
    e = hashDocument(r);
    a = p.get(e) || (0,_0no_co_graphql_web__WEBPACK_IMPORTED_MODULE_0__/* .parse */ .Qc)(r, {
      noLocation: !0
    });
  } else {
    e = r.__key || hashDocument(r);
    a = p.get(e) || r;
  }
  if (!a.loc) {
    stringifyDocument(a);
  }
  a.__key = e;
  p.set(e, a);
  return a;
};

var createRequest = (r, e, t) => {
  var a = e || {};
  var o = keyDocument(r);
  var n = stringifyVariables(a);
  var s = o.__key;
  if ("{}" !== n) {
    s = phash(n, s);
  }
  return {
    key: s,
    query: o,
    variables: a,
    extensions: t
  };
};

var getOperationName = r => {
  for (var e of r.definitions) {
    if (e.kind === _0no_co_graphql_web__WEBPACK_IMPORTED_MODULE_0__/* .Kind.OPERATION_DEFINITION */ .hY.OPERATION_DEFINITION) {
      return e.name ? e.name.value : void 0;
    }
  }
};

var getOperationType = r => {
  for (var e of r.definitions) {
    if (e.kind === a.OPERATION_DEFINITION) {
      return e.operation;
    }
  }
};

var makeResult = (r, e, t) => {
  if (!("data" in e) && !("errors" in e)) {
    throw new Error("No Content");
  }
  var a = "subscription" === r.kind;
  return {
    operation: r,
    data: e.data,
    error: Array.isArray(e.errors) ? new CombinedError({
      graphQLErrors: e.errors,
      response: t
    }) : void 0,
    extensions: e.extensions ? {
      ...e.extensions
    } : void 0,
    hasNext: null == e.hasNext ? a : e.hasNext,
    stale: !1
  };
};

var deepMerge = (r, e) => {
  if ("object" == typeof r && null != r) {
    if (!r.constructor || r.constructor === Object || Array.isArray(r)) {
      r = Array.isArray(r) ? [ ...r ] : {
        ...r
      };
      for (var t of Object.keys(e)) {
        r[t] = deepMerge(r[t], e[t]);
      }
      return r;
    }
  }
  return e;
};

var mergeResultPatch = (r, e, t) => {
  var a = r.error ? r.error.graphQLErrors : [];
  var o = !!r.extensions || !!e.extensions;
  var n = {
    ...r.extensions,
    ...e.extensions
  };
  var s = e.incremental;
  if ("path" in e) {
    s = [ e ];
  }
  var i = {
    data: r.data
  };
  if (s) {
    for (var f of s) {
      if (Array.isArray(f.errors)) {
        a.push(...f.errors);
      }
      if (f.extensions) {
        Object.assign(n, f.extensions);
        o = !0;
      }
      var v = "data";
      var l = i;
      for (var c = 0, d = f.path.length; c < d; v = f.path[c++]) {
        l = l[v] = Array.isArray(l[v]) ? [ ...l[v] ] : {
          ...l[v]
        };
      }
      if (f.items) {
        var p = +v >= 0 ? v : 0;
        for (var u = 0, y = f.items.length; u < y; u++) {
          l[p + u] = deepMerge(l[p + u], f.items[u]);
        }
      } else if (void 0 !== f.data) {
        l[v] = deepMerge(l[v], f.data);
      }
    }
  } else {
    i.data = e.data || r.data;
    a = e.errors || a;
  }
  return {
    operation: r.operation,
    data: i.data,
    error: a.length ? new CombinedError({
      graphQLErrors: a,
      response: t
    }) : void 0,
    extensions: o ? n : void 0,
    hasNext: null != e.hasNext ? e.hasNext : r.hasNext,
    stale: !1
  };
};

var makeErrorResult = (r, e, t) => ({
  operation: r,
  data: void 0,
  error: new CombinedError({
    networkError: e,
    response: t
  }),
  extensions: void 0,
  hasNext: !1,
  stale: !1
});

function makeFetchBody(r) {
  return {
    query: r.extensions && r.extensions.persistedQuery && !r.extensions.persistedQuery.miss ? void 0 : stringifyDocument(r.query),
    operationName: getOperationName(r.query),
    variables: r.variables || void 0,
    extensions: r.extensions
  };
}

var makeFetchURL = (r, e) => {
  var t = "query" === r.kind && r.context.preferGetMethod;
  if (!t || !e) {
    return r.context.url;
  }
  var a = new URL(r.context.url);
  for (var o in e) {
    var n = e[o];
    if (n) {
      a.searchParams.set(o, "object" == typeof n ? stringifyVariables(n) : n);
    }
  }
  var s = a.toString();
  if (s.length > 2047 && "force" !== t) {
    r.context.preferGetMethod = !1;
    return r.context.url;
  }
  return s;
};

var serializeBody = (r, e) => {
  if (e && !("query" === r.kind && !!r.context.preferGetMethod)) {
    var t = stringifyVariables(e);
    var a = (r => {
      var e = new Map;
      if (f !== NoopConstructor || v !== NoopConstructor) {
        s.clear();
        extract(e, "variables", r);
      }
      return e;
    })(e.variables);
    if (a.size) {
      var o = new FormData;
      o.append("operations", t);
      o.append("map", stringifyVariables({
        ...[ ...a.keys() ].map((r => [ r ]))
      }));
      var n = 0;
      for (var i of a.values()) {
        o.append("" + n++, i);
      }
      return o;
    }
    return t;
  }
};

var makeFetchOptions = (r, e) => {
  var t = {
    accept: "subscription" === r.kind ? "text/event-stream, multipart/mixed" : "application/graphql-response+json, application/graphql+json, application/json, text/event-stream, multipart/mixed"
  };
  var a = ("function" == typeof r.context.fetchOptions ? r.context.fetchOptions() : r.context.fetchOptions) || {};
  if (a.headers) {
    for (var o in a.headers) {
      t[o.toLowerCase()] = a.headers[o];
    }
  }
  var n = serializeBody(r, e);
  if ("string" == typeof n && !t["content-type"]) {
    t["content-type"] = "application/json";
  }
  return {
    ...a,
    method: n ? "POST" : "GET",
    body: n,
    headers: t
  };
};

var u = "undefined" != typeof TextDecoder ? new TextDecoder : null;

var y = /boundary="?([^=";]+)"?/i;

var h = /data: ?([^\n]+)/;

var toString = r => "Buffer" === r.constructor.name ? r.toString() : u.decode(r);

async function* streamBody(r) {
  if (r.body[Symbol.asyncIterator]) {
    for await (var e of r.body) {
      yield toString(e);
    }
  } else {
    var t = r.body.getReader();
    var a;
    try {
      while (!(a = await t.read()).done) {
        yield toString(a.value);
      }
    } finally {
      t.cancel();
    }
  }
}

async function* split(r, e) {
  var t = "";
  var a;
  for await (var o of r) {
    t += o;
    while ((a = t.indexOf(e)) > -1) {
      yield t.slice(0, a);
      t = t.slice(a + e.length);
    }
  }
}

async function* fetchOperation(r, e, t) {
  var a = !0;
  var o;
  var n = null;
  var s;
  try {
    if ("undefined" != typeof AbortController) {
      t.signal = (o = new AbortController).signal;
    }
    yield await Promise.resolve();
    var i = (s = await (r.context.fetch || fetch)(e, t)).headers.get("Content-Type") || "";
    var f;
    if (/multipart\/mixed/i.test(i)) {
      f = async function* parseMultipartMixed(r, e) {
        var t = r.match(y);
        var a = "--" + (t ? t[1] : "-");
        var o = !0;
        var n;
        for await (var s of split(streamBody(e), a)) {
          if (o) {
            o = !1;
          } else {
            try {
              yield n = JSON.parse(s.slice(s.indexOf("\r\n\r\n") + 4));
            } catch (r) {
              if (!n) {
                throw r;
              }
            }
          }
          if (n && !n.hasNext) {
            break;
          }
        }
        if (n && n.hasNext) {
          yield {
            hasNext: !1
          };
        }
      }(i, s);
    } else if (/text\/event-stream/i.test(i)) {
      f = async function* parseEventStream(r) {
        var e;
        for await (var t of split(streamBody(r), "\n\n")) {
          var a = t.match(h);
          if (a) {
            var o = a[1];
            try {
              yield e = JSON.parse(o);
            } catch (r) {
              if (!e) {
                throw r;
              }
            }
            if (e && !e.hasNext) {
              break;
            }
          }
        }
        if (e && e.hasNext) {
          yield {
            hasNext: !1
          };
        }
      }(s);
    } else if (!/text\//i.test(i)) {
      f = async function* parseJSON(r) {
        yield JSON.parse(await r.text());
      }(s);
    } else {
      throw new Error(await s.text());
    }
    for await (var v of f) {
      n = n ? mergeResultPatch(n, v, s) : makeResult(r, v, s);
      a = !1;
      yield n;
      a = !0;
    }
    if (!n) {
      yield n = makeResult(r, {}, s);
    }
  } catch (e) {
    if (!a) {
      throw e;
    }
    yield makeErrorResult(r, s && (s.status < 200 || s.status >= 300) && s.statusText ? new Error(s.statusText) : e, s);
  } finally {
    if (o) {
      o.abort();
    }
  }
}

function makeFetchSource(r, e, t) {
  return (0,wonka__WEBPACK_IMPORTED_MODULE_1__/* .filter */ .hX)((r => !!r))((0,wonka__WEBPACK_IMPORTED_MODULE_1__/* .fromAsyncIterable */ .fY)(fetchOperation(r, e, t)));
}


//# sourceMappingURL=urql-core-chunk.mjs.map


/***/ }),

/***/ 70463:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$Y": function() { return /* binding */ ssrExchange; },
/* harmony export */   "Ek": function() { return /* binding */ fetchExchange; },
/* harmony export */   "HG": function() { return /* binding */ cacheExchange; },
/* harmony export */   "Lw": function() { return /* binding */ mapExchange; },
/* harmony export */   "Ps": function() { return /* binding */ gql; },
/* harmony export */   "eI": function() { return /* binding */ j; },
/* harmony export */   "nZ": function() { return /* binding */ formatDocument; },
/* harmony export */   "vx": function() { return /* binding */ makeOperation; }
/* harmony export */ });
/* unused harmony exports Client, composeExchanges, debugExchange, dedupExchange, errorExchange, maskTypename, subscriptionExchange */
/* harmony import */ var _0no_co_graphql_web__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7846);
/* harmony import */ var _urql_core_chunk_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88423);
/* harmony import */ var wonka__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51044);








var collectTypes = (e, r) => {
  if (Array.isArray(e)) {
    for (var t of e) {
      collectTypes(t, r);
    }
  } else if ("object" == typeof e && null !== e) {
    for (var n in e) {
      if ("__typename" === n && "string" == typeof e[n]) {
        r.add(e[n]);
      } else {
        collectTypes(e[n], r);
      }
    }
  }
  return r;
};

var formatNode = r => {
  var t = !1;
  if ("definitions" in r) {
    var n = [];
    for (var a of r.definitions) {
      var o = formatNode(a);
      t = t || o !== a;
      n.push(o);
    }
    if (t) {
      return {
        ...r,
        definitions: n
      };
    }
  } else if ("selectionSet" in r) {
    var i = [];
    var s = r.kind === _0no_co_graphql_web__WEBPACK_IMPORTED_MODULE_0__/* .Kind.OPERATION_DEFINITION */ .hY.OPERATION_DEFINITION;
    if (r.selectionSet) {
      for (var c of r.selectionSet.selections || []) {
        s = s || c.kind === _0no_co_graphql_web__WEBPACK_IMPORTED_MODULE_0__/* .Kind.FIELD */ .hY.FIELD && "__typename" === c.name.value && !c.alias;
        var u = formatNode(c);
        t = t || u !== c;
        i.push(u);
      }
      if (!s) {
        t = !0;
        i.push({
          kind: _0no_co_graphql_web__WEBPACK_IMPORTED_MODULE_0__/* .Kind.FIELD */ .hY.FIELD,
          name: {
            kind: _0no_co_graphql_web__WEBPACK_IMPORTED_MODULE_0__/* .Kind.NAME */ .hY.NAME,
            value: "__typename"
          }
        });
      }
      if (t) {
        return {
          ...r,
          selectionSet: {
            ...r.selectionSet,
            selections: i
          }
        };
      }
    }
  }
  return r;
};

var I = new Map;

var formatDocument = e => {
  var t = (0,_urql_core_chunk_mjs__WEBPACK_IMPORTED_MODULE_1__.k)(e);
  var n = I.get(t.__key);
  if (!n) {
    I.set(t.__key, n = formatNode(t));
    Object.defineProperty(n, "__key", {
      value: t.__key,
      enumerable: !1
    });
  }
  return n;
};

var maskTypename = (e, r) => {
  if (!e || "object" != typeof e) {
    return e;
  } else if (Array.isArray(e)) {
    return e.map((e => maskTypename(e)));
  } else if (e && "object" == typeof e && (r || "__typename" in e)) {
    var t = {};
    for (var n in e) {
      if ("__typename" === n) {
        Object.defineProperty(t, "__typename", {
          enumerable: !1,
          value: e.__typename
        });
      } else {
        t[n] = maskTypename(e[n]);
      }
    }
    return t;
  } else {
    return e;
  }
};

function withPromise(e) {
  var source$ = r => e(r);
  source$.toPromise = () => (0,wonka__WEBPACK_IMPORTED_MODULE_2__/* .toPromise */ .Vi)((0,wonka__WEBPACK_IMPORTED_MODULE_2__/* .take */ .qn)(1)((0,wonka__WEBPACK_IMPORTED_MODULE_2__/* .filter */ .hX)((e => !e.stale && !e.hasNext))(source$)));
  source$.then = (e, r) => source$.toPromise().then(e, r);
  source$.subscribe = e => (0,wonka__WEBPACK_IMPORTED_MODULE_2__/* .subscribe */ .Ld)(e)(source$);
  return source$;
}

function makeOperation(e, r, t) {
  return {
    ...r,
    kind: e,
    context: r.context ? {
      ...r.context,
      ...t
    } : t || r.context
  };
}

var addMetadata = (e, r) => makeOperation(e.kind, e, {
  meta: {
    ...e.context.meta,
    ...r
  }
});

var noop = () => {};

function gql(n) {
  var a = new Map;
  var o = [];
  var i = [];
  var s = Array.isArray(n) ? n[0] : n || "";
  for (var c = 1; c < arguments.length; c++) {
    var u = arguments[c];
    if (u && u.definitions) {
      i.push(u);
    } else {
      s += u;
    }
    s += arguments[0][c];
  }
  i.unshift((0,_urql_core_chunk_mjs__WEBPACK_IMPORTED_MODULE_1__.k)(s));
  for (var p of i) {
    for (var v of p.definitions) {
      if (v.kind === _0no_co_graphql_web__WEBPACK_IMPORTED_MODULE_0__/* .Kind.FRAGMENT_DEFINITION */ .hY.FRAGMENT_DEFINITION) {
        var d = v.name.value;
        var f = (0,_urql_core_chunk_mjs__WEBPACK_IMPORTED_MODULE_1__.s)(v);
        if (!a.has(d)) {
          a.set(d, f);
          o.push(v);
        } else if (false) {}
      } else {
        o.push(v);
      }
    }
  }
  return (0,_urql_core_chunk_mjs__WEBPACK_IMPORTED_MODULE_1__.k)({
    kind: _0no_co_graphql_web__WEBPACK_IMPORTED_MODULE_0__/* .Kind.DOCUMENT */ .hY.DOCUMENT,
    definitions: o
  });
}

var shouldSkip = ({kind: e}) => "mutation" !== e && "query" !== e;

var cacheExchange = ({forward: e, client: r, dispatchDebug: t}) => {
  var n = new Map;
  var a = new Map;
  var mapTypeNames = e => {
    var r = makeOperation(e.kind, e);
    r.query = formatDocument(e.query);
    return r;
  };
  var isOperationCached = e => "query" === e.kind && "network-only" !== e.context.requestPolicy && ("cache-only" === e.context.requestPolicy || n.has(e.key));
  return o => {
    var i = (0,wonka__WEBPACK_IMPORTED_MODULE_2__/* .map */ .UI)((e => {
      var a = n.get(e.key);
       false && 0;
      var o = a;
      if (false) {}
      if ("cache-and-network" === e.context.requestPolicy) {
        o.stale = !0;
        reexecuteOperation(r, e);
      }
      return o;
    }))((0,wonka__WEBPACK_IMPORTED_MODULE_2__/* .filter */ .hX)((e => !shouldSkip(e) && isOperationCached(e)))(o));
    var s = (0,wonka__WEBPACK_IMPORTED_MODULE_2__/* .tap */ .bw)((e => {
      var {operation: o} = e;
      if (!o) {
        return;
      }
      var i = (e => [ ...collectTypes(e, new Set) ])(e.data).concat(o.context.additionalTypenames || []);
      if ("mutation" === e.operation.kind) {
        var s = new Set;
         false && 0;
        for (var c = 0; c < i.length; c++) {
          var u = i[c];
          var p = a.get(u);
          if (!p) {
            a.set(u, p = new Set);
          }
          for (var v of p.values()) {
            s.add(v);
          }
          p.clear();
        }
        for (var d of s.values()) {
          if (n.has(d)) {
            o = n.get(d).operation;
            n.delete(d);
            reexecuteOperation(r, o);
          }
        }
      } else if ("query" === o.kind && e.data) {
        n.set(o.key, e);
        for (var f = 0; f < i.length; f++) {
          var l = i[f];
          var h = a.get(l);
          if (!h) {
            a.set(l, h = new Set);
          }
          h.add(o.key);
        }
      }
    }))(e((0,wonka__WEBPACK_IMPORTED_MODULE_2__/* .filter */ .hX)((e => "query" !== e.kind || "cache-only" !== e.context.requestPolicy))((0,wonka__WEBPACK_IMPORTED_MODULE_2__/* .map */ .UI)((e =>  false ? 0 : e))((0,wonka__WEBPACK_IMPORTED_MODULE_2__/* .merge */ .TS)([ (0,wonka__WEBPACK_IMPORTED_MODULE_2__/* .map */ .UI)(mapTypeNames)((0,wonka__WEBPACK_IMPORTED_MODULE_2__/* .filter */ .hX)((e => !shouldSkip(e) && !isOperationCached(e)))(o)), (0,wonka__WEBPACK_IMPORTED_MODULE_2__/* .filter */ .hX)((e => shouldSkip(e)))(o) ])))));
    return (0,wonka__WEBPACK_IMPORTED_MODULE_2__/* .merge */ .TS)([ i, s ]);
  };
};

var reexecuteOperation = (e, r) => e.reexecuteOperation(makeOperation(r.kind, r, {
  requestPolicy: "network-only"
}));

var T = new Set;

var ssrExchange = (e = {}) => {
  var r = !!e.staleWhileRevalidate;
  var t = !!e.includeExtensions;
  var a = {};
  var o = [];
  var invalidate = e => {
    o.push(e.operation.key);
    if (1 === o.length) {
      Promise.resolve().then((() => {
        var e;
        while (e = o.shift()) {
          a[e] = null;
        }
      }));
    }
  };
  var ssr = ({client: o, forward: i}) => s => {
    var c = e && "boolean" == typeof e.isClient ? !!e.isClient : !o.suspense;
    var u = i((0,wonka__WEBPACK_IMPORTED_MODULE_2__/* .filter */ .hX)((e => !a[e.key] || !!a[e.key].hasNext || "network-only" === e.context.requestPolicy))(s));
    var p = (0,wonka__WEBPACK_IMPORTED_MODULE_2__/* .map */ .UI)((e => {
      var i = ((e, r, t) => ({
        operation: e,
        data: r.data ? JSON.parse(r.data) : void 0,
        extensions: t && r.extensions ? JSON.parse(r.extensions) : void 0,
        error: r.error ? new _urql_core_chunk_mjs__WEBPACK_IMPORTED_MODULE_1__.C({
          networkError: r.error.networkError ? new Error(r.error.networkError) : void 0,
          graphQLErrors: r.error.graphQLErrors
        }) : void 0,
        stale: !1,
        hasNext: !!r.hasNext
      }))(e, a[e.key], t);
      if (r && !T.has(e.key)) {
        i.stale = !0;
        T.add(e.key);
        reexecuteOperation(o, e);
      }
      return {
        ...i,
        operation:  false ? 0 : e
      };
    }))((0,wonka__WEBPACK_IMPORTED_MODULE_2__/* .filter */ .hX)((e => !!a[e.key] && "network-only" !== e.context.requestPolicy))(s));
    if (!c) {
      u = (0,wonka__WEBPACK_IMPORTED_MODULE_2__/* .tap */ .bw)((e => {
        var {operation: r} = e;
        if ("mutation" !== r.kind) {
          var n = ((e, r) => {
            var t = {
              data: JSON.stringify(e.data),
              hasNext: e.hasNext
            };
            if (void 0 !== e.data) {
              t.data = JSON.stringify(e.data);
            }
            if (r && void 0 !== e.extensions) {
              t.extensions = JSON.stringify(e.extensions);
            }
            if (e.error) {
              t.error = {
                graphQLErrors: e.error.graphQLErrors.map((e => {
                  if (!e.path && !e.extensions) {
                    return e.message;
                  }
                  return {
                    message: e.message,
                    path: e.path,
                    extensions: e.extensions
                  };
                }))
              };
              if (e.error.networkError) {
                t.error.networkError = "" + e.error.networkError;
              }
            }
            return t;
          })(e, t);
          a[r.key] = n;
        }
      }))(u);
    } else {
      p = (0,wonka__WEBPACK_IMPORTED_MODULE_2__/* .tap */ .bw)(invalidate)(p);
    }
    return (0,wonka__WEBPACK_IMPORTED_MODULE_2__/* .merge */ .TS)([ u, p ]);
  };
  ssr.restoreData = e => {
    for (var r in e) {
      if (null !== a[r]) {
        a[r] = e[r];
      }
    }
  };
  ssr.extractData = () => {
    var e = {};
    for (var r in a) {
      if (null != a[r]) {
        e[r] = a[r];
      }
    }
    return e;
  };
  if (e && e.initialState) {
    ssr.restoreData(e.initialState);
  }
  return ssr;
};

var subscriptionExchange = ({forwardSubscription: e, enableAllOperations: r, isSubscriptionOperation: t}) => ({client: n, forward: i}) => {
  var u = t || (e => {
    var {kind: t} = e;
    return "subscription" === t || !!r && ("query" === t || "mutation" === t);
  });
  return r => {
    var t = g((t => {
      var {key: i} = t;
      var u = y((e => "teardown" === e.kind && e.key === i))(r);
      return O(u)((r => {
        var t = e(a(r), r);
        return w((({next: e, complete: a}) => {
          var i = !1;
          var u;
          var p;
          Promise.resolve().then((() => {
            if (i) {
              return;
            }
            u = t.subscribe({
              next(t) {
                e(p = p ? o(p, t) : s(r, t));
              },
              error(t) {
                e(c(r, t));
              },
              complete() {
                if (!i) {
                  i = !0;
                  if ("subscription" === r.kind) {
                    n.reexecuteOperation(makeOperation("teardown", r, r.context));
                  }
                  if (p && p.hasNext) {
                    e(o(p, {
                      hasNext: !1
                    }));
                  }
                  a();
                }
              }
            });
          }));
          return () => {
            i = !0;
            if (u) {
              u.unsubscribe();
            }
          };
        }));
      })(t));
    }))(y(u)(r));
    var p = i(y((e => !u(e)))(r));
    return E([ t, p ]);
  };
};

var debugExchange = ({forward: e}) => {
  if (true) {
    return r => e(r);
  } else {}
};

var dedupExchange = ({forward: e}) => r => e(r);

var fetchExchange = ({forward: e, dispatchDebug: r}) => t => {
  var n = (0,wonka__WEBPACK_IMPORTED_MODULE_2__/* .mergeMap */ .zg)((e => {
    var n = (0,_urql_core_chunk_mjs__WEBPACK_IMPORTED_MODULE_1__.m)(e);
    var o = (0,_urql_core_chunk_mjs__WEBPACK_IMPORTED_MODULE_1__.d)(e, n);
    var i = (0,_urql_core_chunk_mjs__WEBPACK_IMPORTED_MODULE_1__.e)(e, n);
     false && 0;
    var s = (0,wonka__WEBPACK_IMPORTED_MODULE_2__/* .takeUntil */ .Rs)((0,wonka__WEBPACK_IMPORTED_MODULE_2__/* .filter */ .hX)((r => "teardown" === r.kind && r.key === e.key))(t))((0,_urql_core_chunk_mjs__WEBPACK_IMPORTED_MODULE_1__.f)(e, o, i));
    if (false) {}
    return s;
  }))((0,wonka__WEBPACK_IMPORTED_MODULE_2__/* .filter */ .hX)((e => "teardown" !== e.kind && ("subscription" !== e.kind || !!e.context.fetchSubscriptions)))(t));
  var o = e((0,wonka__WEBPACK_IMPORTED_MODULE_2__/* .filter */ .hX)((e => "teardown" === e.kind || "subscription" === e.kind && !e.context.fetchSubscriptions))(t));
  return (0,wonka__WEBPACK_IMPORTED_MODULE_2__/* .merge */ .TS)([ n, o ]);
};

var composeExchanges = e => ({client: r, forward: t, dispatchDebug: n}) => e.reduceRight(((e, t) => {
  var a = !1;
  return t({
    client: r,
    forward(r) {
      if (false) {}
      return (0,wonka__WEBPACK_IMPORTED_MODULE_2__/* .share */ .BN)(e((0,wonka__WEBPACK_IMPORTED_MODULE_2__/* .share */ .BN)(r)));
    },
    dispatchDebug(e) {
       false && 0;
    }
  });
}), t);

var mapExchange = ({onOperation: e, onResult: r, onError: t}) => ({forward: n}) => a => (0,wonka__WEBPACK_IMPORTED_MODULE_2__/* .mergeMap */ .zg)((e => {
  if (t && e.error) {
    t(e.error, e.operation);
  }
  var n = r && r(e) || e;
  return "then" in n ? (0,wonka__WEBPACK_IMPORTED_MODULE_2__/* .fromPromise */ .p4)(n) : (0,wonka__WEBPACK_IMPORTED_MODULE_2__/* .fromValue */ ._A)(n);
}))(n((0,wonka__WEBPACK_IMPORTED_MODULE_2__/* .mergeMap */ .zg)((r => {
  var t = e && e(r) || r;
  return "then" in t ? (0,wonka__WEBPACK_IMPORTED_MODULE_2__/* .fromPromise */ .p4)(t) : (0,wonka__WEBPACK_IMPORTED_MODULE_2__/* .fromValue */ ._A)(t);
}))(a)));

var fallbackExchange = ({dispatchDebug: e}) => r => {
  if (false) {}
  return (0,wonka__WEBPACK_IMPORTED_MODULE_2__/* .filter */ .hX)((e => !1))(r);
};

var C = function Client(e) {
  if (false) {}
  var r = 0;
  var t = new Map;
  var n = new Map;
  var a = new Set;
  var o = [];
  var i = {
    url: e.url,
    fetchOptions: e.fetchOptions,
    fetch: e.fetch,
    preferGetMethod: !!e.preferGetMethod,
    requestPolicy: e.requestPolicy || "cache-first"
  };
  var s = (0,wonka__WEBPACK_IMPORTED_MODULE_2__/* .makeSubject */ .nN)();
  function nextOperation(e) {
    var r = t.get(e.key);
    if ("mutation" === e.kind || "teardown" === e.kind || (r ? !r.hasNext : !a.has(e.key))) {
      if ("teardown" === e.kind) {
        a.delete(e.key);
      } else if ("mutation" !== e.kind) {
        a.add(e.key);
      }
      s.next(e);
    }
  }
  var c = !1;
  function dispatchOperation(e) {
    if (e) {
      nextOperation(e);
    }
    if (!c) {
      c = !0;
      while (c && (e = o.shift())) {
        nextOperation(e);
      }
      c = !1;
    }
  }
  var makeResultSource = r => {
    var i = (0,wonka__WEBPACK_IMPORTED_MODULE_2__/* .takeUntil */ .Rs)((0,wonka__WEBPACK_IMPORTED_MODULE_2__/* .filter */ .hX)((e => "teardown" === e.kind && e.key === r.key))(s.source))((0,wonka__WEBPACK_IMPORTED_MODULE_2__/* .filter */ .hX)((e => e.operation.kind === r.kind && e.operation.key === r.key && (!e.operation.context._instance || e.operation.context._instance === r.context._instance)))(w));
    if ("query" !== r.kind) {
      i = (0,wonka__WEBPACK_IMPORTED_MODULE_2__/* .takeWhile */ .oE)((e => !!e.hasNext), !0)(i);
    } else {
      i = (0,wonka__WEBPACK_IMPORTED_MODULE_2__/* .switchMap */ .wt)((e => {
        var t = (0,wonka__WEBPACK_IMPORTED_MODULE_2__/* .fromValue */ ._A)(e);
        return e.stale || e.hasNext ? t : (0,wonka__WEBPACK_IMPORTED_MODULE_2__/* .merge */ .TS)([ t, (0,wonka__WEBPACK_IMPORTED_MODULE_2__/* .map */ .UI)((() => {
          e.stale = !0;
          return e;
        }))((0,wonka__WEBPACK_IMPORTED_MODULE_2__/* .take */ .qn)(1)((0,wonka__WEBPACK_IMPORTED_MODULE_2__/* .filter */ .hX)((e => e.key === r.key))(s.source))) ]);
      }))(i);
    }
    if ("mutation" !== r.kind) {
      i = (0,wonka__WEBPACK_IMPORTED_MODULE_2__/* .onEnd */ .ok)((() => {
        a.delete(r.key);
        t.delete(r.key);
        n.delete(r.key);
        c = !1;
        for (var e = o.length - 1; e >= 0; e--) {
          if (o[e].key === r.key) {
            o.splice(e, 1);
          }
        }
        nextOperation(makeOperation("teardown", r, r.context));
      }))((0,wonka__WEBPACK_IMPORTED_MODULE_2__/* .onPush */ .Mq)((e => {
        a.delete(r.key);
        t.set(r.key, e);
      }))(i));
    } else {
      i = (0,wonka__WEBPACK_IMPORTED_MODULE_2__/* .onStart */ .Hr)((() => {
        nextOperation(r);
      }))(i);
    }
    if (e.maskTypename) {
      i = (0,wonka__WEBPACK_IMPORTED_MODULE_2__/* .map */ .UI)((e => ({
        ...e,
        data: maskTypename(e.data, !0)
      })))(i);
    }
    return (0,wonka__WEBPACK_IMPORTED_MODULE_2__/* .share */ .BN)(i);
  };
  var u = this instanceof Client ? this : Object.create(Client.prototype);
  var p = Object.assign(u, {
    suspense: !!e.suspense,
    operations$: s.source,
    reexecuteOperation(e) {
      if ("mutation" === e.kind || n.has(e.key)) {
        o.push(e);
        Promise.resolve().then(dispatchOperation);
      }
    },
    createRequestOperation(e, t, n) {
      if (!n) {
        n = {};
      }
      var a;
      if (false) {}
      return makeOperation(e, t, {
        _instance: "mutation" === e ? r = r + 1 | 0 : void 0,
        ...i,
        ...n,
        requestPolicy: n.requestPolicy || i.requestPolicy,
        suspense: n.suspense || !1 !== n.suspense && p.suspense
      });
    },
    executeRequestOperation(e) {
      if ("mutation" === e.kind) {
        return withPromise(makeResultSource(e));
      }
      return withPromise((0,wonka__WEBPACK_IMPORTED_MODULE_2__/* .lazy */ .Vo)((() => {
        var r = n.get(e.key);
        if (!r) {
          n.set(e.key, r = makeResultSource(e));
        }
        r = (0,wonka__WEBPACK_IMPORTED_MODULE_2__/* .onStart */ .Hr)((() => {
          dispatchOperation(e);
        }))(r);
        var a = t.get(e.key);
        if ("query" === e.kind && a && (a.stale || a.hasNext)) {
          return (0,wonka__WEBPACK_IMPORTED_MODULE_2__/* .switchMap */ .wt)(wonka__WEBPACK_IMPORTED_MODULE_2__/* .fromValue */ ._A)((0,wonka__WEBPACK_IMPORTED_MODULE_2__/* .merge */ .TS)([ r, (0,wonka__WEBPACK_IMPORTED_MODULE_2__/* .filter */ .hX)((r => r === t.get(e.key)))((0,wonka__WEBPACK_IMPORTED_MODULE_2__/* .fromValue */ ._A)(a)) ]));
        } else {
          return r;
        }
      })));
    },
    executeQuery(e, r) {
      var t = p.createRequestOperation("query", e, r);
      return p.executeRequestOperation(t);
    },
    executeSubscription(e, r) {
      var t = p.createRequestOperation("subscription", e, r);
      return p.executeRequestOperation(t);
    },
    executeMutation(e, r) {
      var t = p.createRequestOperation("mutation", e, r);
      return p.executeRequestOperation(t);
    },
    readQuery(e, r, t) {
      var n = null;
      (0,wonka__WEBPACK_IMPORTED_MODULE_2__/* .subscribe */ .Ld)((e => {
        n = e;
      }))(p.query(e, r, t)).unsubscribe();
      return n;
    },
    query: (e, r, t) => p.executeQuery((0,_urql_core_chunk_mjs__WEBPACK_IMPORTED_MODULE_1__.h)(e, r), t),
    subscription: (e, r, t) => p.executeSubscription((0,_urql_core_chunk_mjs__WEBPACK_IMPORTED_MODULE_1__.h)(e, r), t),
    mutation: (e, r, t) => p.executeMutation((0,_urql_core_chunk_mjs__WEBPACK_IMPORTED_MODULE_1__.h)(e, r), t)
  });
  var v = noop;
  if (false) { var x, l; }
  var g = composeExchanges(e.exchanges);
  var w = (0,wonka__WEBPACK_IMPORTED_MODULE_2__/* .share */ .BN)(g({
    client: p,
    dispatchDebug: v,
    forward: fallbackExchange({
      dispatchDebug: v
    })
  })(s.source));
  (0,wonka__WEBPACK_IMPORTED_MODULE_2__/* .publish */ .nY)(w);
  return p;
};

var j = C;


//# sourceMappingURL=urql-core.mjs.map


/***/ }),

/***/ 51044:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BN": function() { return /* binding */ share; },
/* harmony export */   "Ds": function() { return /* binding */ debounce; },
/* harmony export */   "Hr": function() { return /* binding */ onStart; },
/* harmony export */   "Ld": function() { return /* binding */ subscribe; },
/* harmony export */   "Mq": function() { return /* binding */ onPush; },
/* harmony export */   "Rs": function() { return /* binding */ takeUntil; },
/* harmony export */   "TS": function() { return /* binding */ merge; },
/* harmony export */   "UI": function() { return /* binding */ map; },
/* harmony export */   "Vi": function() { return /* binding */ toPromise; },
/* harmony export */   "Vo": function() { return /* binding */ lazy; },
/* harmony export */   "_A": function() { return /* binding */ fromValue; },
/* harmony export */   "bw": function() { return /* binding */ onPush; },
/* harmony export */   "cS": function() { return /* binding */ empty; },
/* harmony export */   "fY": function() { return /* binding */ fromAsyncIterable; },
/* harmony export */   "hX": function() { return /* binding */ filter; },
/* harmony export */   "nI": function() { return /* binding */ r; },
/* harmony export */   "nN": function() { return /* binding */ makeSubject; },
/* harmony export */   "nY": function() { return /* binding */ publish; },
/* harmony export */   "oE": function() { return /* binding */ takeWhile; },
/* harmony export */   "ok": function() { return /* binding */ onEnd; },
/* harmony export */   "p4": function() { return /* binding */ fromPromise; },
/* harmony export */   "qn": function() { return /* binding */ take; },
/* harmony export */   "wt": function() { return /* binding */ switchMap; },
/* harmony export */   "zG": function() { return /* binding */ pipe; },
/* harmony export */   "zg": function() { return /* binding */ mergeMap; }
/* harmony export */ });
/* unused harmony exports buffer, combine, concat, concatAll, concatMap, delay, flatten, forEach, fromCallbag, fromDomEvent, fromIterable, fromObservable, interval, make, mergeAll, never, sample, scan, skip, skipUntil, skipWhile, switchAll, takeLast, throttle, toArray, toAsyncIterable, toCallbag, toObservable, zip */
var teardownPlaceholder = () => {};

var e = teardownPlaceholder;

function start(e) {
  return {
    tag: 0,
    0: e
  };
}

function push(e) {
  return {
    tag: 1,
    0: e
  };
}

var identity = e => e;

function buffer(r) {
  return t => i => {
    var a = [];
    var f = e;
    var n = e;
    var s = !1;
    var l = !1;
    t((e => {
      if (l) {} else if (0 === e) {
        l = !0;
        n(1);
        if (a.length) {
          i(push(a));
        }
        i(0);
      } else if (0 === e.tag) {
        f = e[0];
        r((e => {
          if (l) {} else if (0 === e) {
            l = !0;
            f(1);
            if (a.length) {
              i(push(a));
            }
            i(0);
          } else if (0 === e.tag) {
            n = e[0];
          } else if (a.length) {
            var r = push(a);
            a = [];
            i(r);
          }
        }));
      } else {
        a.push(e[0]);
        if (!s) {
          s = !0;
          f(0);
          n(0);
        } else {
          s = !1;
        }
      }
    }));
    i(start((e => {
      if (1 === e && !l) {
        l = !0;
        f(1);
        n(1);
      } else if (!l && !s) {
        s = !0;
        f(0);
        n(0);
      }
    })));
  };
}

function concatMap(r) {
  return t => i => {
    var a = [];
    var f = e;
    var n = e;
    var s = !1;
    var l = !1;
    var u = !1;
    var o = !1;
    function applyInnerSource(e) {
      u = !0;
      e((e => {
        if (0 === e) {
          if (u) {
            u = !1;
            if (a.length) {
              applyInnerSource(r(a.shift()));
            } else if (o) {
              i(0);
            } else if (!s) {
              s = !0;
              f(0);
            }
          }
        } else if (0 === e.tag) {
          l = !1;
          (n = e[0])(0);
        } else if (u) {
          i(e);
          if (l) {
            l = !1;
          } else {
            n(0);
          }
        }
      }));
    }
    t((e => {
      if (o) {} else if (0 === e) {
        o = !0;
        if (!u && !a.length) {
          i(0);
        }
      } else if (0 === e.tag) {
        f = e[0];
      } else {
        s = !1;
        if (u) {
          a.push(e[0]);
        } else {
          applyInnerSource(r(e[0]));
        }
      }
    }));
    i(start((e => {
      if (1 === e) {
        if (!o) {
          o = !0;
          f(1);
        }
        if (u) {
          u = !1;
          n(1);
        }
      } else {
        if (!o && !s) {
          s = !0;
          f(0);
        }
        if (u && !l) {
          l = !0;
          n(0);
        }
      }
    })));
  };
}

function concatAll(e) {
  return concatMap(identity)(e);
}

function concat(e) {
  return concatAll(r(e));
}

function filter(r) {
  return t => i => {
    var a = e;
    t((e => {
      if (0 === e) {
        i(0);
      } else if (0 === e.tag) {
        a = e[0];
        i(e);
      } else if (!r(e[0])) {
        a(0);
      } else {
        i(e);
      }
    }));
  };
}

function map(e) {
  return r => t => r((r => {
    if (0 === r || 0 === r.tag) {
      t(r);
    } else {
      t(push(e(r[0])));
    }
  }));
}

function mergeMap(r) {
  return t => i => {
    var a = [];
    var f = e;
    var n = !1;
    var s = !1;
    t((t => {
      if (s) {} else if (0 === t) {
        s = !0;
        if (!a.length) {
          i(0);
        }
      } else if (0 === t.tag) {
        f = t[0];
      } else {
        n = !1;
        !function applyInnerSource(r) {
          var t = e;
          r((e => {
            if (0 === e) {
              if (a.length) {
                var r = a.indexOf(t);
                if (r > -1) {
                  (a = a.slice()).splice(r, 1);
                }
                if (!a.length) {
                  if (s) {
                    i(0);
                  } else if (!n) {
                    n = !0;
                    f(0);
                  }
                }
              }
            } else if (0 === e.tag) {
              a.push(t = e[0]);
              t(0);
            } else if (a.length) {
              i(e);
              t(0);
            }
          }));
        }(r(t[0]));
        if (!n) {
          n = !0;
          f(0);
        }
      }
    }));
    i(start((e => {
      if (1 === e) {
        if (!s) {
          s = !0;
          f(1);
        }
        for (var r = 0, t = a, i = a.length; r < i; r++) {
          t[r](1);
        }
        a.length = 0;
      } else {
        if (!s && !n) {
          n = !0;
          f(0);
        } else {
          n = !1;
        }
        for (var l = 0, u = a, o = a.length; l < o; l++) {
          u[l](0);
        }
      }
    })));
  };
}

function mergeAll(e) {
  return mergeMap(identity)(e);
}

function merge(e) {
  return mergeAll(r(e));
}

function onEnd(e) {
  return r => t => {
    var i = !1;
    r((r => {
      if (i) {} else if (0 === r) {
        i = !0;
        t(0);
        e();
      } else if (0 === r.tag) {
        var a = r[0];
        t(start((r => {
          if (1 === r) {
            i = !0;
            a(1);
            e();
          } else {
            a(r);
          }
        })));
      } else {
        t(r);
      }
    }));
  };
}

function onPush(e) {
  return r => t => {
    var i = !1;
    r((r => {
      if (i) {} else if (0 === r) {
        i = !0;
        t(0);
      } else if (0 === r.tag) {
        var a = r[0];
        t(start((e => {
          if (1 === e) {
            i = !0;
          }
          a(e);
        })));
      } else {
        e(r[0]);
        t(r);
      }
    }));
  };
}

function onStart(e) {
  return r => t => r((r => {
    if (0 === r) {
      t(0);
    } else if (0 === r.tag) {
      t(r);
      e();
    } else {
      t(r);
    }
  }));
}

function sample(r) {
  return t => i => {
    var a = e;
    var f = e;
    var n;
    var s = !1;
    var l = !1;
    t((e => {
      if (l) {} else if (0 === e) {
        l = !0;
        f(1);
        i(0);
      } else if (0 === e.tag) {
        a = e[0];
      } else {
        n = e[0];
        if (!s) {
          s = !0;
          f(0);
          a(0);
        } else {
          s = !1;
        }
      }
    }));
    r((e => {
      if (l) {} else if (0 === e) {
        l = !0;
        a(1);
        i(0);
      } else if (0 === e.tag) {
        f = e[0];
      } else if (void 0 !== n) {
        var r = push(n);
        n = void 0;
        i(r);
      }
    }));
    i(start((e => {
      if (1 === e && !l) {
        l = !0;
        a(1);
        f(1);
      } else if (!l && !s) {
        s = !0;
        a(0);
        f(0);
      }
    })));
  };
}

function scan(e, r) {
  return t => i => {
    var a = r;
    t((r => {
      if (0 === r) {
        i(0);
      } else if (0 === r.tag) {
        i(r);
      } else {
        i(push(a = e(a, r[0])));
      }
    }));
  };
}

function share(r) {
  var t = [];
  var i = e;
  var a = !1;
  return e => {
    t.push(e);
    if (1 === t.length) {
      r((e => {
        if (0 === e) {
          for (var r = 0, f = t, n = t.length; r < n; r++) {
            f[r](0);
          }
          t.length = 0;
        } else if (0 === e.tag) {
          i = e[0];
        } else {
          a = !1;
          for (var s = 0, l = t, u = t.length; s < u; s++) {
            l[s](e);
          }
        }
      }));
    }
    e(start((r => {
      if (1 === r) {
        var f = t.indexOf(e);
        if (f > -1) {
          (t = t.slice()).splice(f, 1);
        }
        if (!t.length) {
          i(1);
        }
      } else if (!a) {
        a = !0;
        i(0);
      }
    })));
  };
}

function skip(r) {
  return t => i => {
    var a = e;
    var f = r;
    t((e => {
      if (0 === e) {
        i(0);
      } else if (0 === e.tag) {
        a = e[0];
        i(e);
      } else if (f-- > 0) {
        a(0);
      } else {
        i(e);
      }
    }));
  };
}

function skipUntil(r) {
  return t => i => {
    var a = e;
    var f = e;
    var n = !0;
    var s = !1;
    var l = !1;
    t((e => {
      if (l) {} else if (0 === e) {
        l = !0;
        if (n) {
          f(1);
        }
        i(0);
      } else if (0 === e.tag) {
        a = e[0];
        r((e => {
          if (0 === e) {
            if (n) {
              l = !0;
              a(1);
            }
          } else if (0 === e.tag) {
            (f = e[0])(0);
          } else {
            n = !1;
            f(1);
          }
        }));
      } else if (!n) {
        s = !1;
        i(e);
      } else if (!s) {
        s = !0;
        a(0);
        f(0);
      } else {
        s = !1;
      }
    }));
    i(start((e => {
      if (1 === e && !l) {
        l = !0;
        a(1);
        if (n) {
          f(1);
        }
      } else if (!l && !s) {
        s = !0;
        if (n) {
          f(0);
        }
        a(0);
      }
    })));
  };
}

function skipWhile(r) {
  return t => i => {
    var a = e;
    var f = !0;
    t((e => {
      if (0 === e) {
        i(0);
      } else if (0 === e.tag) {
        a = e[0];
        i(e);
      } else if (f) {
        if (r(e[0])) {
          a(0);
        } else {
          f = !1;
          i(e);
        }
      } else {
        i(e);
      }
    }));
  };
}

function switchMap(r) {
  return t => i => {
    var a = e;
    var f = e;
    var n = !1;
    var s = !1;
    var l = !1;
    var u = !1;
    t((t => {
      if (u) {} else if (0 === t) {
        u = !0;
        if (!l) {
          i(0);
        }
      } else if (0 === t.tag) {
        a = t[0];
      } else {
        if (l) {
          f(1);
          f = e;
        }
        if (!n) {
          n = !0;
          a(0);
        } else {
          n = !1;
        }
        !function applyInnerSource(e) {
          l = !0;
          e((e => {
            if (!l) {} else if (0 === e) {
              l = !1;
              if (u) {
                i(0);
              } else if (!n) {
                n = !0;
                a(0);
              }
            } else if (0 === e.tag) {
              s = !1;
              (f = e[0])(0);
            } else {
              i(e);
              if (!s) {
                f(0);
              } else {
                s = !1;
              }
            }
          }));
        }(r(t[0]));
      }
    }));
    i(start((e => {
      if (1 === e) {
        if (!u) {
          u = !0;
          a(1);
        }
        if (l) {
          l = !1;
          f(1);
        }
      } else {
        if (!u && !n) {
          n = !0;
          a(0);
        }
        if (l && !s) {
          s = !0;
          f(0);
        }
      }
    })));
  };
}

function switchAll(e) {
  return switchMap(identity)(e);
}

function take(r) {
  return t => i => {
    var a = e;
    var f = !1;
    var n = 0;
    t((e => {
      if (f) {} else if (0 === e) {
        f = !0;
        i(0);
      } else if (0 === e.tag) {
        if (r <= 0) {
          f = !0;
          i(0);
          e[0](1);
        } else {
          a = e[0];
        }
      } else if (n++ < r) {
        i(e);
        if (!f && n >= r) {
          f = !0;
          i(0);
          a(1);
        }
      } else {
        i(e);
      }
    }));
    i(start((e => {
      if (1 === e && !f) {
        f = !0;
        a(1);
      } else if (0 === e && !f && n < r) {
        a(0);
      }
    })));
  };
}

function takeLast(t) {
  return i => a => {
    var f = [];
    var n = e;
    i((e => {
      if (0 === e) {
        r(f)(a);
      } else if (0 === e.tag) {
        if (t <= 0) {
          e[0](1);
          r(f)(a);
        } else {
          (n = e[0])(0);
        }
      } else {
        if (f.length >= t && t) {
          f.shift();
        }
        f.push(e[0]);
        n(0);
      }
    }));
  };
}

function takeUntil(r) {
  return t => i => {
    var a = e;
    var f = e;
    var n = !1;
    t((e => {
      if (n) {} else if (0 === e) {
        n = !0;
        f(1);
        i(0);
      } else if (0 === e.tag) {
        a = e[0];
        r((e => {
          if (0 === e) {} else if (0 === e.tag) {
            (f = e[0])(0);
          } else {
            n = !0;
            f(1);
            a(1);
            i(0);
          }
        }));
      } else {
        i(e);
      }
    }));
    i(start((e => {
      if (1 === e && !n) {
        n = !0;
        a(1);
        f(1);
      } else if (!n) {
        a(0);
      }
    })));
  };
}

function takeWhile(r, t) {
  return i => a => {
    var f = e;
    var n = !1;
    i((e => {
      if (n) {} else if (0 === e) {
        n = !0;
        a(0);
      } else if (0 === e.tag) {
        f = e[0];
        a(e);
      } else if (!r(e[0])) {
        n = !0;
        if (t) {
          a(e);
        }
        a(0);
        f(1);
      } else {
        a(e);
      }
    }));
  };
}

function debounce(e) {
  return r => t => {
    var i;
    var a = !1;
    var f = !1;
    r((r => {
      if (f) {} else if (0 === r) {
        f = !0;
        if (i) {
          a = !0;
        } else {
          t(0);
        }
      } else if (0 === r.tag) {
        var n = r[0];
        t(start((e => {
          if (1 === e && !f) {
            f = !0;
            a = !1;
            if (i) {
              clearTimeout(i);
            }
            n(1);
          } else if (!f) {
            n(0);
          }
        })));
      } else {
        if (i) {
          clearTimeout(i);
        }
        i = setTimeout((() => {
          i = void 0;
          t(r);
          if (a) {
            t(0);
          }
        }), e(r[0]));
      }
    }));
  };
}

function delay(e) {
  return r => t => {
    var i = 0;
    r((r => {
      if (0 !== r && 0 === r.tag) {
        t(r);
      } else {
        i++;
        setTimeout((() => {
          if (i) {
            i--;
            t(r);
          }
        }), e);
      }
    }));
  };
}

function throttle(e) {
  return r => t => {
    var i = !1;
    var a;
    r((r => {
      if (0 === r) {
        if (a) {
          clearTimeout(a);
        }
        t(0);
      } else if (0 === r.tag) {
        var f = r[0];
        t(start((e => {
          if (1 === e) {
            if (a) {
              clearTimeout(a);
            }
            f(1);
          } else {
            f(0);
          }
        })));
      } else if (!i) {
        i = !0;
        if (a) {
          clearTimeout(a);
        }
        a = setTimeout((() => {
          a = void 0;
          i = !1;
        }), e(r[0]));
        t(r);
      }
    }));
  };
}

function lazy(e) {
  return r => e()(r);
}

function fromAsyncIterable(e) {
  return r => {
    var t = e[Symbol.asyncIterator]();
    var i = !1;
    var a = !1;
    var f = !1;
    var n;
    r(start((async e => {
      if (1 === e) {
        i = !0;
        if (t.return) {
          t.return();
        }
      } else if (a) {
        f = !0;
      } else {
        for (f = a = !0; f && !i; ) {
          if ((n = await t.next()).done) {
            i = !0;
            if (t.return) {
              await t.return();
            }
            r(0);
          } else {
            try {
              f = !1;
              r(push(n.value));
            } catch (e) {
              if (t.throw) {
                if (i = !!(await t.throw(e)).done) {
                  r(0);
                }
              } else {
                throw e;
              }
            }
          }
        }
        a = !1;
      }
    })));
  };
}

function fromIterable(e) {
  if (e[Symbol.asyncIterator]) {
    return fromAsyncIterable(e);
  }
  return r => {
    var t = e[Symbol.iterator]();
    var i = !1;
    var a = !1;
    var f = !1;
    var n;
    r(start((e => {
      if (1 === e) {
        i = !0;
        if (t.return) {
          t.return();
        }
      } else if (a) {
        f = !0;
      } else {
        for (f = a = !0; f && !i; ) {
          if ((n = t.next()).done) {
            i = !0;
            if (t.return) {
              t.return();
            }
            r(0);
          } else {
            try {
              f = !1;
              r(push(n.value));
            } catch (e) {
              if (t.throw) {
                if (i = !!t.throw(e).done) {
                  r(0);
                }
              } else {
                throw e;
              }
            }
          }
        }
        a = !1;
      }
    })));
  };
}

var r = fromIterable;

function fromValue(e) {
  return r => {
    var t = !1;
    r(start((i => {
      if (1 === i) {
        t = !0;
      } else if (!t) {
        t = !0;
        r(push(e));
        r(0);
      }
    })));
  };
}

function make(e) {
  return r => {
    var t = !1;
    var i = e({
      next(e) {
        if (!t) {
          r(push(e));
        }
      },
      complete() {
        if (!t) {
          t = !0;
          r(0);
        }
      }
    });
    r(start((e => {
      if (1 === e && !t) {
        t = !0;
        i();
      }
    })));
  };
}

function makeSubject() {
  var e;
  var r;
  return {
    source: share(make((t => {
      e = t.next;
      r = t.complete;
      return teardownPlaceholder;
    }))),
    next(r) {
      if (e) {
        e(r);
      }
    },
    complete() {
      if (r) {
        r();
      }
    }
  };
}

var empty = e => {
  var r = !1;
  e(start((t => {
    if (1 === t) {
      r = !0;
    } else if (!r) {
      r = !0;
      e(0);
    }
  })));
};

var never = r => {
  r(start(e));
};

function interval(e) {
  return make((r => {
    var t = 0;
    var i = setInterval((() => r.next(t++)), e);
    return () => clearInterval(i);
  }));
}

function fromDomEvent(e, r) {
  return make((t => {
    e.addEventListener(r, t.next);
    return () => e.removeEventListener(r, t.next);
  }));
}

function fromPromise(e) {
  return make((r => {
    e.then((e => {
      Promise.resolve(e).then((() => {
        r.next(e);
        r.complete();
      }));
    }));
    return teardownPlaceholder;
  }));
}

function subscribe(r) {
  return t => {
    var i = e;
    var a = !1;
    t((e => {
      if (0 === e) {
        a = !0;
      } else if (0 === e.tag) {
        (i = e[0])(0);
      } else if (!a) {
        r(e[0]);
        i(0);
      }
    }));
    return {
      unsubscribe() {
        if (!a) {
          a = !0;
          i(1);
        }
      }
    };
  };
}

function forEach(e) {
  return r => {
    subscribe(e)(r);
  };
}

function publish(e) {
  subscribe((e => {}))(e);
}

var t = {
  done: !0
};

var toAsyncIterable = r => ({
  [Symbol.asyncIterator]() {
    var i = [];
    var a = !1;
    var f = e;
    var n;
    r((e => {
      if (a) {} else if (0 === e) {
        if (n) {
          n = n(t);
        }
        a = !0;
      } else if (0 === e.tag) {
        (f = e[0])(0);
      } else if (n) {
        n = n({
          value: e[0],
          done: !1
        });
      } else {
        i.push(e[0]);
      }
    }));
    return {
      async next() {
        if (a && !i.length) {
          return t;
        } else if (!a && i.length <= 1) {
          f(0);
        }
        return i.length ? {
          value: i.shift(),
          done: !1
        } : new Promise((e => n = e));
      },
      async return() {
        if (!a) {
          n = f(1);
        }
        a = !0;
        return t;
      }
    };
  }
});

function toArray(r) {
  var t = [];
  var i = e;
  var a = !1;
  r((e => {
    if (0 === e) {
      a = !0;
    } else if (0 === e.tag) {
      (i = e[0])(0);
    } else {
      t.push(e[0]);
      i(0);
    }
  }));
  if (!a) {
    i(1);
  }
  return t;
}

function toPromise(r) {
  return new Promise((t => {
    var i = e;
    var a;
    r((e => {
      if (0 === e) {
        Promise.resolve(a).then(t);
      } else if (0 === e.tag) {
        (i = e[0])(0);
      } else {
        a = e[0];
        i(0);
      }
    }));
  }));
}

function zip(r) {
  var t = Object.keys(r).length;
  return i => {
    var a = new Set;
    var f = Array.isArray(r) ? new Array(t).fill(e) : {};
    var n = Array.isArray(r) ? new Array(t) : {};
    var s = !1;
    var l = !1;
    var u = !1;
    var o = 0;
    var loop = function(v) {
      r[v]((c => {
        if (0 === c) {
          if (o >= t - 1) {
            u = !0;
            i(0);
          } else {
            o++;
          }
        } else if (0 === c.tag) {
          f[v] = c[0];
        } else if (!u) {
          n[v] = c[0];
          a.add(v);
          if (!s && a.size < t) {
            if (!l) {
              for (var h in r) {
                if (!a.has(h)) {
                  (f[h] || e)(0);
                }
              }
            } else {
              l = !1;
            }
          } else {
            s = !0;
            l = !1;
            i(push(Array.isArray(n) ? n.slice() : {
              ...n
            }));
          }
        }
      }));
    };
    for (var v in r) {
      loop(v);
    }
    i(start((e => {
      if (u) {} else if (1 === e) {
        u = !0;
        for (var r in f) {
          f[r](1);
        }
      } else if (!l) {
        l = !0;
        for (var t in f) {
          f[t](0);
        }
      }
    })));
  };
}

function combine(...e) {
  return zip(e);
}

var observableSymbol = () => Symbol.observable || "@@observable";

function fromObservable(e) {
  return r => {
    var t = (e[observableSymbol()] ? e[observableSymbol()]() : e).subscribe({
      next(e) {
        r(push(e));
      },
      complete() {
        r(0);
      },
      error(e) {
        throw e;
      }
    });
    r(start((e => {
      if (1 === e) {
        t.unsubscribe();
      }
    })));
  };
}

function toObservable(r) {
  return {
    subscribe(t, i, a) {
      var f = "object" == typeof t ? t : {
        next: t,
        error: i,
        complete: a
      };
      var n = e;
      var s = !1;
      r((e => {
        if (s) {} else if (0 === e) {
          s = !0;
          if (f.complete) {
            f.complete();
          }
        } else if (0 === e.tag) {
          (n = e[0])(0);
        } else {
          f.next(e[0]);
          n(0);
        }
      }));
      var l = {
        closed: !1,
        unsubscribe() {
          l.closed = !0;
          s = !0;
          n(1);
        }
      };
      return l;
    },
    [observableSymbol()]() {
      return this;
    }
  };
}

function fromCallbag(e) {
  return r => {
    e(0, ((e, t) => {
      if (0 === e) {
        r(start((e => {
          t(e + 1);
        })));
      } else if (1 === e) {
        r(push(t));
      } else {
        r(0);
      }
    }));
  };
}

function toCallbag(e) {
  return (r, t) => {
    if (0 === r) {
      e((e => {
        if (0 === e) {
          t(2);
        } else if (0 === e.tag) {
          t(0, (r => {
            if (r < 3) {
              e[0](r - 1);
            }
          }));
        } else {
          t(1, e[0]);
        }
      }));
    }
  };
}

var pipe = (...e) => {
  var r = e[0];
  for (var t = 1, i = e.length; t < i; t++) {
    r = e[t](r);
  }
  return r;
};


//# sourceMappingURL=wonka.mjs.map


/***/ }),

/***/ 6805:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Ue": function() { return /* binding */ create; }
});

// UNUSED EXPORTS: createStore, default, useStore

;// CONCATENATED MODULE: ../node_modules/zustand/esm/vanilla.mjs
const createStoreImpl = (createState) => {
  let state;
  const listeners = /* @__PURE__ */ new Set();
  const setState = (partial, replace) => {
    const nextState = typeof partial === "function" ? partial(state) : partial;
    if (!Object.is(nextState, state)) {
      const previousState = state;
      state = (replace != null ? replace : typeof nextState !== "object" || nextState === null) ? nextState : Object.assign({}, state, nextState);
      listeners.forEach((listener) => listener(state, previousState));
    }
  };
  const getState = () => state;
  const getInitialState = () => initialState;
  const subscribe = (listener) => {
    listeners.add(listener);
    return () => listeners.delete(listener);
  };
  const destroy = () => {
    if (( false ? 0 : void 0) !== "production") {
      console.warn(
        "[DEPRECATED] The `destroy` method will be unsupported in a future version. Instead use unsubscribe function returned by subscribe. Everything will be garbage-collected if store is garbage-collected."
      );
    }
    listeners.clear();
  };
  const api = { setState, getState, getInitialState, subscribe, destroy };
  const initialState = state = createState(setState, getState, api);
  return api;
};
const createStore = (createState) => createState ? createStoreImpl(createState) : createStoreImpl;
var vanilla = (createState) => {
  if (( false ? 0 : void 0) !== "production") {
    console.warn(
      "[DEPRECATED] Default export is deprecated. Instead use import { createStore } from 'zustand/vanilla'."
    );
  }
  return createStore(createState);
};



// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ../node_modules/use-sync-external-store/shim/with-selector.js
var with_selector = __webpack_require__(60626);
;// CONCATENATED MODULE: ../node_modules/zustand/esm/index.mjs





const { useDebugValue } = react;
const { useSyncExternalStoreWithSelector } = with_selector;
let didWarnAboutEqualityFn = false;
const identity = (arg) => arg;
function useStore(api, selector = identity, equalityFn) {
  if (( false ? 0 : void 0) !== "production" && equalityFn && !didWarnAboutEqualityFn) {
    console.warn(
      "[DEPRECATED] Use `createWithEqualityFn` instead of `create` or use `useStoreWithEqualityFn` instead of `useStore`. They can be imported from 'zustand/traditional'. https://github.com/pmndrs/zustand/discussions/1937"
    );
    didWarnAboutEqualityFn = true;
  }
  const slice = useSyncExternalStoreWithSelector(
    api.subscribe,
    api.getState,
    api.getServerState || api.getInitialState,
    selector,
    equalityFn
  );
  useDebugValue(slice);
  return slice;
}
const createImpl = (createState) => {
  if (( false ? 0 : void 0) !== "production" && typeof createState !== "function") {
    console.warn(
      "[DEPRECATED] Passing a vanilla store will be unsupported in a future version. Instead use `import { useStore } from 'zustand'`."
    );
  }
  const api = typeof createState === "function" ? createStore(createState) : createState;
  const useBoundStore = (selector, equalityFn) => useStore(api, selector, equalityFn);
  Object.assign(useBoundStore, api);
  return useBoundStore;
};
const create = (createState) => createState ? createImpl(createState) : createImpl;
var esm_react = (createState) => {
  if (( false ? 0 : void 0) !== "production") {
    console.warn(
      "[DEPRECATED] Default export is deprecated. Instead use `import { create } from 'zustand'`."
    );
  }
  return create(createState);
};




/***/ }),

/***/ 53248:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ useShallow; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);


function shallow(objA, objB) {
  if (Object.is(objA, objB)) {
    return true;
  }
  if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) {
    return false;
  }
  if (objA instanceof Map && objB instanceof Map) {
    if (objA.size !== objB.size)
      return false;
    for (const [key, value] of objA) {
      if (!Object.is(value, objB.get(key))) {
        return false;
      }
    }
    return true;
  }
  if (objA instanceof Set && objB instanceof Set) {
    if (objA.size !== objB.size)
      return false;
    for (const value of objA) {
      if (!objB.has(value)) {
        return false;
      }
    }
    return true;
  }
  const keysA = Object.keys(objA);
  if (keysA.length !== Object.keys(objB).length) {
    return false;
  }
  for (const keyA of keysA) {
    if (!Object.prototype.hasOwnProperty.call(objB, keyA) || !Object.is(objA[keyA], objB[keyA])) {
      return false;
    }
  }
  return true;
}

const { useRef } = react__WEBPACK_IMPORTED_MODULE_0__;
function useShallow(selector) {
  const prev = useRef();
  return (state) => {
    const next = selector(state);
    return shallow(prev.current, next) ? prev.current : prev.current = next;
  };
}




/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,179], function() { return __webpack_exec__(90729), __webpack_exec__(36321), __webpack_exec__(15817); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);